
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire06a3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire06a3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ifLAN", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d49e8b922d581d6f$export$ffb0004e005737fa; }, function (v) { return $d49e8b922d581d6f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d49e8b922d581d6f$export$34b9dba7ce09269b; }, function (v) { return $d49e8b922d581d6f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d49e8b922d581d6f$export$25062201e9e25d76; }, function (v) { return $d49e8b922d581d6f$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d49e8b922d581d6f$export$ffb0004e005737fa;
var $d49e8b922d581d6f$export$34b9dba7ce09269b;
var $d49e8b922d581d6f$export$25062201e9e25d76;
'use strict';
parcelRequire("leYiG");

var $70fFQ = parcelRequire("70fFQ");
var $d49e8b922d581d6f$var$g = 60103;
$d49e8b922d581d6f$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $d49e8b922d581d6f$var$h = Symbol.for;
    $d49e8b922d581d6f$var$g = $d49e8b922d581d6f$var$h("react.element");
    $d49e8b922d581d6f$export$ffb0004e005737fa = $d49e8b922d581d6f$var$h("react.fragment");
}
var $d49e8b922d581d6f$var$m = $70fFQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d49e8b922d581d6f$var$n = Object.prototype.hasOwnProperty, $d49e8b922d581d6f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d49e8b922d581d6f$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$d49e8b922d581d6f$var$n.call(a, b) && !$d49e8b922d581d6f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d49e8b922d581d6f$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $d49e8b922d581d6f$var$m.current
    };
}
$d49e8b922d581d6f$export$34b9dba7ce09269b = $d49e8b922d581d6f$var$q;
$d49e8b922d581d6f$export$25062201e9e25d76 = $d49e8b922d581d6f$var$q;

});
parcelRegister("leYiG", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $f769ae2b8c6d4c07$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f769ae2b8c6d4c07$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f769ae2b8c6d4c07$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $f769ae2b8c6d4c07$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $f769ae2b8c6d4c07$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $f769ae2b8c6d4c07$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $f769ae2b8c6d4c07$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($f769ae2b8c6d4c07$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($f769ae2b8c6d4c07$var$getOwnPropertySymbols) {
            symbols = $f769ae2b8c6d4c07$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($f769ae2b8c6d4c07$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("70fFQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hjxY2"));

});
parcelRegister("hjxY2", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c9ae8f3ccfa82d2b$export$ffb0004e005737fa; }, function (v) { return $c9ae8f3ccfa82d2b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c9ae8f3ccfa82d2b$export$5f8d39834fd61797; }, function (v) { return $c9ae8f3ccfa82d2b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $c9ae8f3ccfa82d2b$export$e2c29f18771995cb; }, function (v) { return $c9ae8f3ccfa82d2b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5; }, function (v) { return $c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $c9ae8f3ccfa82d2b$export$dca3b0875bd9a954; }, function (v) { return $c9ae8f3ccfa82d2b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c9ae8f3ccfa82d2b$export$16fa2f45be04daa8; }, function (v) { return $c9ae8f3ccfa82d2b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd; }, function (v) { return $c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c9ae8f3ccfa82d2b$export$ae55be85d98224ed; }, function (v) { return $c9ae8f3ccfa82d2b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c9ae8f3ccfa82d2b$export$e530037191fcd5d7; }, function (v) { return $c9ae8f3ccfa82d2b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109; }, function (v) { return $c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d; }, function (v) { return $c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9; }, function (v) { return $c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43; }, function (v) { return $c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c9ae8f3ccfa82d2b$export$257a8862b851cb5b; }, function (v) { return $c9ae8f3ccfa82d2b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c9ae8f3ccfa82d2b$export$a8257692ac88316c; }, function (v) { return $c9ae8f3ccfa82d2b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c9ae8f3ccfa82d2b$export$488013bae63b21da; }, function (v) { return $c9ae8f3ccfa82d2b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c9ae8f3ccfa82d2b$export$7c73462e0d25e514; }, function (v) { return $c9ae8f3ccfa82d2b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c9ae8f3ccfa82d2b$export$35808ee640e87ca7; }, function (v) { return $c9ae8f3ccfa82d2b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c9ae8f3ccfa82d2b$export$fae74005e78b1a27; }, function (v) { return $c9ae8f3ccfa82d2b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e; }, function (v) { return $c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $c9ae8f3ccfa82d2b$export$6d9c69b0de29b591; }, function (v) { return $c9ae8f3ccfa82d2b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c9ae8f3ccfa82d2b$export$d5a552a76deda3c2; }, function (v) { return $c9ae8f3ccfa82d2b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c; }, function (v) { return $c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c9ae8f3ccfa82d2b$export$1538c33de8887b59; }, function (v) { return $c9ae8f3ccfa82d2b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c9ae8f3ccfa82d2b$export$13e3392192263954; }, function (v) { return $c9ae8f3ccfa82d2b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca; }, function (v) { return $c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c9ae8f3ccfa82d2b$export$60241385465d0a34; }, function (v) { return $c9ae8f3ccfa82d2b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $c9ae8f3ccfa82d2b$export$83d89fbfd8236492; }, function (v) { return $c9ae8f3ccfa82d2b$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9ae8f3ccfa82d2b$export$ffb0004e005737fa;
var $c9ae8f3ccfa82d2b$export$5f8d39834fd61797;
var $c9ae8f3ccfa82d2b$export$e2c29f18771995cb;
var $c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5;
var $c9ae8f3ccfa82d2b$export$dca3b0875bd9a954;
var $c9ae8f3ccfa82d2b$export$16fa2f45be04daa8;
var $c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd;
var $c9ae8f3ccfa82d2b$export$ae55be85d98224ed;
var $c9ae8f3ccfa82d2b$export$e530037191fcd5d7;
var $c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109;
var $c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d;
var $c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9;
var $c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43;
var $c9ae8f3ccfa82d2b$export$257a8862b851cb5b;
var $c9ae8f3ccfa82d2b$export$a8257692ac88316c;
var $c9ae8f3ccfa82d2b$export$488013bae63b21da;
var $c9ae8f3ccfa82d2b$export$7c73462e0d25e514;
var $c9ae8f3ccfa82d2b$export$35808ee640e87ca7;
var $c9ae8f3ccfa82d2b$export$fae74005e78b1a27;
var $c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e;
var $c9ae8f3ccfa82d2b$export$6d9c69b0de29b591;
var $c9ae8f3ccfa82d2b$export$d5a552a76deda3c2;
var $c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c;
var $c9ae8f3ccfa82d2b$export$1538c33de8887b59;
var $c9ae8f3ccfa82d2b$export$13e3392192263954;
var $c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca;
var $c9ae8f3ccfa82d2b$export$60241385465d0a34;
var $c9ae8f3ccfa82d2b$export$83d89fbfd8236492;
'use strict';

var $leYiG = parcelRequire("leYiG");
var $c9ae8f3ccfa82d2b$var$n = 60103, $c9ae8f3ccfa82d2b$var$p = 60106;
$c9ae8f3ccfa82d2b$export$ffb0004e005737fa = 60107;
$c9ae8f3ccfa82d2b$export$5f8d39834fd61797 = 60108;
$c9ae8f3ccfa82d2b$export$e2c29f18771995cb = 60114;
var $c9ae8f3ccfa82d2b$var$q = 60109, $c9ae8f3ccfa82d2b$var$r = 60110, $c9ae8f3ccfa82d2b$var$t = 60112;
$c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5 = 60113;
var $c9ae8f3ccfa82d2b$var$u = 60115, $c9ae8f3ccfa82d2b$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $c9ae8f3ccfa82d2b$var$w = Symbol.for;
    $c9ae8f3ccfa82d2b$var$n = $c9ae8f3ccfa82d2b$var$w("react.element");
    $c9ae8f3ccfa82d2b$var$p = $c9ae8f3ccfa82d2b$var$w("react.portal");
    $c9ae8f3ccfa82d2b$export$ffb0004e005737fa = $c9ae8f3ccfa82d2b$var$w("react.fragment");
    $c9ae8f3ccfa82d2b$export$5f8d39834fd61797 = $c9ae8f3ccfa82d2b$var$w("react.strict_mode");
    $c9ae8f3ccfa82d2b$export$e2c29f18771995cb = $c9ae8f3ccfa82d2b$var$w("react.profiler");
    $c9ae8f3ccfa82d2b$var$q = $c9ae8f3ccfa82d2b$var$w("react.provider");
    $c9ae8f3ccfa82d2b$var$r = $c9ae8f3ccfa82d2b$var$w("react.context");
    $c9ae8f3ccfa82d2b$var$t = $c9ae8f3ccfa82d2b$var$w("react.forward_ref");
    $c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5 = $c9ae8f3ccfa82d2b$var$w("react.suspense");
    $c9ae8f3ccfa82d2b$var$u = $c9ae8f3ccfa82d2b$var$w("react.memo");
    $c9ae8f3ccfa82d2b$var$v = $c9ae8f3ccfa82d2b$var$w("react.lazy");
}
var $c9ae8f3ccfa82d2b$var$x = "function" === typeof Symbol && Symbol.iterator;
function $c9ae8f3ccfa82d2b$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c9ae8f3ccfa82d2b$var$x && a[$c9ae8f3ccfa82d2b$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $c9ae8f3ccfa82d2b$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c9ae8f3ccfa82d2b$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c9ae8f3ccfa82d2b$var$B = {};
function $c9ae8f3ccfa82d2b$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $c9ae8f3ccfa82d2b$var$B;
    this.updater = c || $c9ae8f3ccfa82d2b$var$A;
}
$c9ae8f3ccfa82d2b$var$C.prototype.isReactComponent = {};
$c9ae8f3ccfa82d2b$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($c9ae8f3ccfa82d2b$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c9ae8f3ccfa82d2b$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c9ae8f3ccfa82d2b$var$D() {}
$c9ae8f3ccfa82d2b$var$D.prototype = $c9ae8f3ccfa82d2b$var$C.prototype;
function $c9ae8f3ccfa82d2b$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $c9ae8f3ccfa82d2b$var$B;
    this.updater = c || $c9ae8f3ccfa82d2b$var$A;
}
var $c9ae8f3ccfa82d2b$var$F = $c9ae8f3ccfa82d2b$var$E.prototype = new $c9ae8f3ccfa82d2b$var$D;
$c9ae8f3ccfa82d2b$var$F.constructor = $c9ae8f3ccfa82d2b$var$E;
$leYiG($c9ae8f3ccfa82d2b$var$F, $c9ae8f3ccfa82d2b$var$C.prototype);
$c9ae8f3ccfa82d2b$var$F.isPureReactComponent = !0;
var $c9ae8f3ccfa82d2b$var$G = {
    current: null
}, $c9ae8f3ccfa82d2b$var$H = Object.prototype.hasOwnProperty, $c9ae8f3ccfa82d2b$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c9ae8f3ccfa82d2b$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c9ae8f3ccfa82d2b$var$H.call(b, e) && !$c9ae8f3ccfa82d2b$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $c9ae8f3ccfa82d2b$var$G.current
    };
}
function $c9ae8f3ccfa82d2b$var$K(a, b) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c9ae8f3ccfa82d2b$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c9ae8f3ccfa82d2b$var$n;
}
function $c9ae8f3ccfa82d2b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c9ae8f3ccfa82d2b$var$M = /\/+/g;
function $c9ae8f3ccfa82d2b$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c9ae8f3ccfa82d2b$var$escape("" + a.key) : b.toString(36);
}
function $c9ae8f3ccfa82d2b$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c9ae8f3ccfa82d2b$var$n:
                case $c9ae8f3ccfa82d2b$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $c9ae8f3ccfa82d2b$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($c9ae8f3ccfa82d2b$var$M, "$&/") + "/"), $c9ae8f3ccfa82d2b$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($c9ae8f3ccfa82d2b$var$L(d) && (d = $c9ae8f3ccfa82d2b$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($c9ae8f3ccfa82d2b$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $c9ae8f3ccfa82d2b$var$N(k, g);
        h += $c9ae8f3ccfa82d2b$var$O(k, b, c, f, d);
    }
    else if (f = $c9ae8f3ccfa82d2b$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $c9ae8f3ccfa82d2b$var$N(k, g++), h += $c9ae8f3ccfa82d2b$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($c9ae8f3ccfa82d2b$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $c9ae8f3ccfa82d2b$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $c9ae8f3ccfa82d2b$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $c9ae8f3ccfa82d2b$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $c9ae8f3ccfa82d2b$var$R = {
    current: null
};
function $c9ae8f3ccfa82d2b$var$S() {
    var a = $c9ae8f3ccfa82d2b$var$R.current;
    if (null === a) throw Error($c9ae8f3ccfa82d2b$var$z(321));
    return a;
}
var $c9ae8f3ccfa82d2b$var$T = {
    ReactCurrentDispatcher: $c9ae8f3ccfa82d2b$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $c9ae8f3ccfa82d2b$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $leYiG
};
$c9ae8f3ccfa82d2b$export$dca3b0875bd9a954 = {
    map: $c9ae8f3ccfa82d2b$var$P,
    forEach: function(a, b, c) {
        $c9ae8f3ccfa82d2b$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $c9ae8f3ccfa82d2b$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c9ae8f3ccfa82d2b$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c9ae8f3ccfa82d2b$var$L(a)) throw Error($c9ae8f3ccfa82d2b$var$z(143));
        return a;
    }
};
$c9ae8f3ccfa82d2b$export$16fa2f45be04daa8 = $c9ae8f3ccfa82d2b$var$C;
$c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd = $c9ae8f3ccfa82d2b$var$E;
$c9ae8f3ccfa82d2b$export$ae55be85d98224ed = $c9ae8f3ccfa82d2b$var$T;
$c9ae8f3ccfa82d2b$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($c9ae8f3ccfa82d2b$var$z(267, a));
    var e = $leYiG({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c9ae8f3ccfa82d2b$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c9ae8f3ccfa82d2b$var$H.call(b, f) && !$c9ae8f3ccfa82d2b$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $c9ae8f3ccfa82d2b$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $c9ae8f3ccfa82d2b$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d = $c9ae8f3ccfa82d2b$var$J;
$c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9 = function(a) {
    var b = $c9ae8f3ccfa82d2b$var$J.bind(null, a);
    b.type = a;
    return b;
};
$c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c9ae8f3ccfa82d2b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$t,
        render: a
    };
};
$c9ae8f3ccfa82d2b$export$a8257692ac88316c = $c9ae8f3ccfa82d2b$var$L;
$c9ae8f3ccfa82d2b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c9ae8f3ccfa82d2b$var$Q
    };
};
$c9ae8f3ccfa82d2b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c9ae8f3ccfa82d2b$export$35808ee640e87ca7 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$S().useCallback(a, b);
};
$c9ae8f3ccfa82d2b$export$fae74005e78b1a27 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$S().useContext(a, b);
};
$c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e = function() {};
$c9ae8f3ccfa82d2b$export$6d9c69b0de29b591 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$S().useEffect(a, b);
};
$c9ae8f3ccfa82d2b$export$d5a552a76deda3c2 = function(a, b, c) {
    return $c9ae8f3ccfa82d2b$var$S().useImperativeHandle(a, b, c);
};
$c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$S().useLayoutEffect(a, b);
};
$c9ae8f3ccfa82d2b$export$1538c33de8887b59 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$S().useMemo(a, b);
};
$c9ae8f3ccfa82d2b$export$13e3392192263954 = function(a, b, c) {
    return $c9ae8f3ccfa82d2b$var$S().useReducer(a, b, c);
};
$c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca = function(a) {
    return $c9ae8f3ccfa82d2b$var$S().useRef(a);
};
$c9ae8f3ccfa82d2b$export$60241385465d0a34 = function(a) {
    return $c9ae8f3ccfa82d2b$var$S().useState(a);
};
$c9ae8f3ccfa82d2b$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("3glZ1", function(module, exports) {
'use strict';
function $2603eb25b0423f2c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2603eb25b0423f2c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2603eb25b0423f2c$var$checkDCE();

module.exports = (parcelRequire("ldfzr"));

});
parcelRegister("ldfzr", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $70fFQ = parcelRequire("70fFQ");

var $leYiG = parcelRequire("leYiG");

var $c2cCr = parcelRequire("c2cCr");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$70fFQ) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $70fFQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $leYiG({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $70fFQ.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $leYiG({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $leYiG({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $leYiG({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $c2cCr.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $c2cCr.unstable_scheduleCallback($c2cCr.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $c2cCr.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $c2cCr.unstable_UserBlockingPriority, ed = $c2cCr.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $leYiG(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $leYiG({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $leYiG({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $leYiG({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $leYiG({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $leYiG({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $leYiG({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $leYiG({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $leYiG({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $leYiG({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $leYiG({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $leYiG({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $leYiG({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $leYiG({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $c2cCr.unstable_runWithPriority, Of = $c2cCr.unstable_scheduleCallback, Pf = $c2cCr.unstable_cancelCallback, Qf = $c2cCr.unstable_shouldYield, Rf = $c2cCr.unstable_requestPaint, Sf = $c2cCr.unstable_now, Tf = $c2cCr.unstable_getCurrentPriorityLevel, Uf = $c2cCr.unstable_ImmediatePriority, Vf = $c2cCr.unstable_UserBlockingPriority, Wf = $c2cCr.unstable_NormalPriority, Xf = $c2cCr.unstable_LowPriority, Yf = $c2cCr.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $leYiG({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $leYiG({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $70fFQ.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $leYiG({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $leYiG({}, e, {
                    value: void 0
                });
                d = $leYiG({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $leYiG({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("c2cCr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jA2H2"));

});
parcelRegister("jA2H2", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e41377ef566186ed$export$c4744153514ff05d; }, function (v) { return $e41377ef566186ed$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e41377ef566186ed$export$b5836b71941fa3ed; }, function (v) { return $e41377ef566186ed$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e41377ef566186ed$export$d66a1c1c77bd778b; }, function (v) { return $e41377ef566186ed$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e41377ef566186ed$export$3e506c1ccc9cc1a7; }, function (v) { return $e41377ef566186ed$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e41377ef566186ed$export$e26fe2ed2fa76875; }, function (v) { return $e41377ef566186ed$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e41377ef566186ed$export$502329bbf4b505b1; }, function (v) { return $e41377ef566186ed$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e41377ef566186ed$export$6e3807111c4874c4; }, function (v) { return $e41377ef566186ed$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e41377ef566186ed$export$c27134553091fb3a; }, function (v) { return $e41377ef566186ed$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e41377ef566186ed$export$33ee1acdc04fd2a2; }, function (v) { return $e41377ef566186ed$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e41377ef566186ed$export$b00a404bbd5edef2; }, function (v) { return $e41377ef566186ed$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e41377ef566186ed$export$8352ce38b91d0c62; }, function (v) { return $e41377ef566186ed$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e41377ef566186ed$export$d3dfb8e4810cb555; }, function (v) { return $e41377ef566186ed$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e41377ef566186ed$export$839f9183b0465a69; }, function (v) { return $e41377ef566186ed$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e41377ef566186ed$export$72fdf0e06517287b; }, function (v) { return $e41377ef566186ed$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e41377ef566186ed$export$4b844e58a3e414b4; }, function (v) { return $e41377ef566186ed$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e41377ef566186ed$export$816d2913ae6b83b1; }, function (v) { return $e41377ef566186ed$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e41377ef566186ed$export$61bcfe829111a1d0; }, function (v) { return $e41377ef566186ed$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e41377ef566186ed$export$7ee8c9beb337bc3f; }, function (v) { return $e41377ef566186ed$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e41377ef566186ed$export$cf845f2c119da08a; }, function (v) { return $e41377ef566186ed$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e41377ef566186ed$export$c4744153514ff05d;
var $e41377ef566186ed$export$b5836b71941fa3ed;
var $e41377ef566186ed$export$d66a1c1c77bd778b;
var $e41377ef566186ed$export$3e506c1ccc9cc1a7;
var $e41377ef566186ed$export$e26fe2ed2fa76875;
var $e41377ef566186ed$export$502329bbf4b505b1;
var $e41377ef566186ed$export$6e3807111c4874c4;
var $e41377ef566186ed$export$c27134553091fb3a;
var $e41377ef566186ed$export$33ee1acdc04fd2a2;
var $e41377ef566186ed$export$b00a404bbd5edef2;
var $e41377ef566186ed$export$8352ce38b91d0c62;
var $e41377ef566186ed$export$d3dfb8e4810cb555;
var $e41377ef566186ed$export$839f9183b0465a69;
var $e41377ef566186ed$export$72fdf0e06517287b;
var $e41377ef566186ed$export$4b844e58a3e414b4;
var $e41377ef566186ed$export$816d2913ae6b83b1;
var $e41377ef566186ed$export$61bcfe829111a1d0;
var $e41377ef566186ed$export$7ee8c9beb337bc3f;
var $e41377ef566186ed$export$cf845f2c119da08a;
'use strict';
var $e41377ef566186ed$var$f, $e41377ef566186ed$var$g, $e41377ef566186ed$var$h, $e41377ef566186ed$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e41377ef566186ed$var$l = performance;
    $e41377ef566186ed$export$c4744153514ff05d = function() {
        return $e41377ef566186ed$var$l.now();
    };
} else {
    var $e41377ef566186ed$var$p = Date, $e41377ef566186ed$var$q = $e41377ef566186ed$var$p.now();
    $e41377ef566186ed$export$c4744153514ff05d = function() {
        return $e41377ef566186ed$var$p.now() - $e41377ef566186ed$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $e41377ef566186ed$var$t = null, $e41377ef566186ed$var$u = null, $e41377ef566186ed$var$w = function() {
        if (null !== $e41377ef566186ed$var$t) try {
            var a = $e41377ef566186ed$export$c4744153514ff05d();
            $e41377ef566186ed$var$t(!0, a);
            $e41377ef566186ed$var$t = null;
        } catch (b) {
            throw setTimeout($e41377ef566186ed$var$w, 0), b;
        }
    };
    $e41377ef566186ed$var$f = function(a) {
        null !== $e41377ef566186ed$var$t ? setTimeout($e41377ef566186ed$var$f, 0, a) : ($e41377ef566186ed$var$t = a, setTimeout($e41377ef566186ed$var$w, 0));
    };
    $e41377ef566186ed$var$g = function(a, b) {
        $e41377ef566186ed$var$u = setTimeout(a, b);
    };
    $e41377ef566186ed$var$h = function() {
        clearTimeout($e41377ef566186ed$var$u);
    };
    $e41377ef566186ed$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $e41377ef566186ed$var$k = $e41377ef566186ed$export$d66a1c1c77bd778b = function() {};
} else {
    var $e41377ef566186ed$var$x = window.setTimeout, $e41377ef566186ed$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $e41377ef566186ed$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $e41377ef566186ed$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $e41377ef566186ed$var$A = !1, $e41377ef566186ed$var$B = null, $e41377ef566186ed$var$C = -1, $e41377ef566186ed$var$D = 5, $e41377ef566186ed$var$E = 0;
    $e41377ef566186ed$export$b5836b71941fa3ed = function() {
        return $e41377ef566186ed$export$c4744153514ff05d() >= $e41377ef566186ed$var$E;
    };
    $e41377ef566186ed$var$k = function() {};
    $e41377ef566186ed$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e41377ef566186ed$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $e41377ef566186ed$var$F = new MessageChannel, $e41377ef566186ed$var$G = $e41377ef566186ed$var$F.port2;
    $e41377ef566186ed$var$F.port1.onmessage = function() {
        if (null !== $e41377ef566186ed$var$B) {
            var a = $e41377ef566186ed$export$c4744153514ff05d();
            $e41377ef566186ed$var$E = a + $e41377ef566186ed$var$D;
            try {
                $e41377ef566186ed$var$B(!0, a) ? $e41377ef566186ed$var$G.postMessage(null) : ($e41377ef566186ed$var$A = !1, $e41377ef566186ed$var$B = null);
            } catch (b) {
                throw $e41377ef566186ed$var$G.postMessage(null), b;
            }
        } else $e41377ef566186ed$var$A = !1;
    };
    $e41377ef566186ed$var$f = function(a) {
        $e41377ef566186ed$var$B = a;
        $e41377ef566186ed$var$A || ($e41377ef566186ed$var$A = !0, $e41377ef566186ed$var$G.postMessage(null));
    };
    $e41377ef566186ed$var$g = function(a, b) {
        $e41377ef566186ed$var$C = $e41377ef566186ed$var$x(function() {
            a($e41377ef566186ed$export$c4744153514ff05d());
        }, b);
    };
    $e41377ef566186ed$var$h = function() {
        $e41377ef566186ed$var$y($e41377ef566186ed$var$C);
        $e41377ef566186ed$var$C = -1;
    };
}
function $e41377ef566186ed$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $e41377ef566186ed$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e41377ef566186ed$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $e41377ef566186ed$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $e41377ef566186ed$var$I(n, c)) void 0 !== r && 0 > $e41377ef566186ed$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $e41377ef566186ed$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $e41377ef566186ed$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $e41377ef566186ed$var$L = [], $e41377ef566186ed$var$M = [], $e41377ef566186ed$var$N = 1, $e41377ef566186ed$var$O = null, $e41377ef566186ed$var$P = 3, $e41377ef566186ed$var$Q = !1, $e41377ef566186ed$var$R = !1, $e41377ef566186ed$var$S = !1;
function $e41377ef566186ed$var$T(a) {
    for(var b = $e41377ef566186ed$var$J($e41377ef566186ed$var$M); null !== b;){
        if (null === b.callback) $e41377ef566186ed$var$K($e41377ef566186ed$var$M);
        else if (b.startTime <= a) $e41377ef566186ed$var$K($e41377ef566186ed$var$M), b.sortIndex = b.expirationTime, $e41377ef566186ed$var$H($e41377ef566186ed$var$L, b);
        else break;
        b = $e41377ef566186ed$var$J($e41377ef566186ed$var$M);
    }
}
function $e41377ef566186ed$var$U(a) {
    $e41377ef566186ed$var$S = !1;
    $e41377ef566186ed$var$T(a);
    if (!$e41377ef566186ed$var$R) {
        if (null !== $e41377ef566186ed$var$J($e41377ef566186ed$var$L)) $e41377ef566186ed$var$R = !0, $e41377ef566186ed$var$f($e41377ef566186ed$var$V);
        else {
            var b = $e41377ef566186ed$var$J($e41377ef566186ed$var$M);
            null !== b && $e41377ef566186ed$var$g($e41377ef566186ed$var$U, b.startTime - a);
        }
    }
}
function $e41377ef566186ed$var$V(a, b) {
    $e41377ef566186ed$var$R = !1;
    $e41377ef566186ed$var$S && ($e41377ef566186ed$var$S = !1, $e41377ef566186ed$var$h());
    $e41377ef566186ed$var$Q = !0;
    var c = $e41377ef566186ed$var$P;
    try {
        $e41377ef566186ed$var$T(b);
        for($e41377ef566186ed$var$O = $e41377ef566186ed$var$J($e41377ef566186ed$var$L); null !== $e41377ef566186ed$var$O && (!($e41377ef566186ed$var$O.expirationTime > b) || a && !$e41377ef566186ed$export$b5836b71941fa3ed());){
            var d = $e41377ef566186ed$var$O.callback;
            if ("function" === typeof d) {
                $e41377ef566186ed$var$O.callback = null;
                $e41377ef566186ed$var$P = $e41377ef566186ed$var$O.priorityLevel;
                var e = d($e41377ef566186ed$var$O.expirationTime <= b);
                b = $e41377ef566186ed$export$c4744153514ff05d();
                "function" === typeof e ? $e41377ef566186ed$var$O.callback = e : $e41377ef566186ed$var$O === $e41377ef566186ed$var$J($e41377ef566186ed$var$L) && $e41377ef566186ed$var$K($e41377ef566186ed$var$L);
                $e41377ef566186ed$var$T(b);
            } else $e41377ef566186ed$var$K($e41377ef566186ed$var$L);
            $e41377ef566186ed$var$O = $e41377ef566186ed$var$J($e41377ef566186ed$var$L);
        }
        if (null !== $e41377ef566186ed$var$O) var m = !0;
        else {
            var n = $e41377ef566186ed$var$J($e41377ef566186ed$var$M);
            null !== n && $e41377ef566186ed$var$g($e41377ef566186ed$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $e41377ef566186ed$var$O = null, $e41377ef566186ed$var$P = c, $e41377ef566186ed$var$Q = !1;
    }
}
var $e41377ef566186ed$var$W = $e41377ef566186ed$var$k;
$e41377ef566186ed$export$3e506c1ccc9cc1a7 = 5;
$e41377ef566186ed$export$e26fe2ed2fa76875 = 1;
$e41377ef566186ed$export$502329bbf4b505b1 = 4;
$e41377ef566186ed$export$6e3807111c4874c4 = 3;
$e41377ef566186ed$export$c27134553091fb3a = null;
$e41377ef566186ed$export$33ee1acdc04fd2a2 = 2;
$e41377ef566186ed$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e41377ef566186ed$export$8352ce38b91d0c62 = function() {
    $e41377ef566186ed$var$R || $e41377ef566186ed$var$Q || ($e41377ef566186ed$var$R = !0, $e41377ef566186ed$var$f($e41377ef566186ed$var$V));
};
$e41377ef566186ed$export$d3dfb8e4810cb555 = function() {
    return $e41377ef566186ed$var$P;
};
$e41377ef566186ed$export$839f9183b0465a69 = function() {
    return $e41377ef566186ed$var$J($e41377ef566186ed$var$L);
};
$e41377ef566186ed$export$72fdf0e06517287b = function(a) {
    switch($e41377ef566186ed$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e41377ef566186ed$var$P;
    }
    var c = $e41377ef566186ed$var$P;
    $e41377ef566186ed$var$P = b;
    try {
        return a();
    } finally{
        $e41377ef566186ed$var$P = c;
    }
};
$e41377ef566186ed$export$4b844e58a3e414b4 = function() {};
$e41377ef566186ed$export$816d2913ae6b83b1 = $e41377ef566186ed$var$W;
$e41377ef566186ed$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e41377ef566186ed$var$P;
    $e41377ef566186ed$var$P = a;
    try {
        return b();
    } finally{
        $e41377ef566186ed$var$P = c;
    }
};
$e41377ef566186ed$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e41377ef566186ed$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e41377ef566186ed$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e41377ef566186ed$var$H($e41377ef566186ed$var$M, a), null === $e41377ef566186ed$var$J($e41377ef566186ed$var$L) && a === $e41377ef566186ed$var$J($e41377ef566186ed$var$M) && ($e41377ef566186ed$var$S ? $e41377ef566186ed$var$h() : $e41377ef566186ed$var$S = !0, $e41377ef566186ed$var$g($e41377ef566186ed$var$U, c - d))) : (a.sortIndex = e, $e41377ef566186ed$var$H($e41377ef566186ed$var$L, a), $e41377ef566186ed$var$R || $e41377ef566186ed$var$Q || ($e41377ef566186ed$var$R = !0, $e41377ef566186ed$var$f($e41377ef566186ed$var$V)));
    return a;
};
$e41377ef566186ed$export$cf845f2c119da08a = function(a) {
    var b = $e41377ef566186ed$var$P;
    return function() {
        var c = $e41377ef566186ed$var$P;
        $e41377ef566186ed$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e41377ef566186ed$var$P = c;
        }
    };
};

});




parcelRegister("4GSL4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $36a58f7b27f0109b$export$a7c73072b1a182ae; }, function (v) { return $36a58f7b27f0109b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $36a58f7b27f0109b$export$9f27bc3417b4524d; }, function (v) { return $36a58f7b27f0109b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $36a58f7b27f0109b$export$db77ccec0bb4ccac; }, function (v) { return $36a58f7b27f0109b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $36a58f7b27f0109b$export$8392c0c9d3dcbd35; }, function (v) { return $36a58f7b27f0109b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $36a58f7b27f0109b$export$ffb0004e005737fa; }, function (v) { return $36a58f7b27f0109b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $36a58f7b27f0109b$export$b624eff549462981; }, function (v) { return $36a58f7b27f0109b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $36a58f7b27f0109b$export$7897aa7841a5380c; }, function (v) { return $36a58f7b27f0109b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $36a58f7b27f0109b$export$602eac185826482c; }, function (v) { return $36a58f7b27f0109b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $36a58f7b27f0109b$export$e2c29f18771995cb; }, function (v) { return $36a58f7b27f0109b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $36a58f7b27f0109b$export$5f8d39834fd61797; }, function (v) { return $36a58f7b27f0109b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $36a58f7b27f0109b$export$74bf444e3cd11ea5; }, function (v) { return $36a58f7b27f0109b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $36a58f7b27f0109b$export$998bcd577473dd93; }, function (v) { return $36a58f7b27f0109b$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $36a58f7b27f0109b$export$92387174baf9b227; }, function (v) { return $36a58f7b27f0109b$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $36a58f7b27f0109b$export$ec112efeb987d9c6; }, function (v) { return $36a58f7b27f0109b$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $36a58f7b27f0109b$export$b706b080d889d2c9; }, function (v) { return $36a58f7b27f0109b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $36a58f7b27f0109b$export$5be5a87408f70ddc; }, function (v) { return $36a58f7b27f0109b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $36a58f7b27f0109b$export$45a5e7f76e0caa8d; }, function (v) { return $36a58f7b27f0109b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $36a58f7b27f0109b$export$455c2e768291efa6; }, function (v) { return $36a58f7b27f0109b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $36a58f7b27f0109b$export$9522e17588c12572; }, function (v) { return $36a58f7b27f0109b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $36a58f7b27f0109b$export$2110ac352bb060b9; }, function (v) { return $36a58f7b27f0109b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $36a58f7b27f0109b$export$56885ab8b9c456ab; }, function (v) { return $36a58f7b27f0109b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $36a58f7b27f0109b$export$d927fcb6adf8f9de; }, function (v) { return $36a58f7b27f0109b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $36a58f7b27f0109b$export$b82d16f27459e05a; }, function (v) { return $36a58f7b27f0109b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $36a58f7b27f0109b$export$522c17b4f5e123e8; }, function (v) { return $36a58f7b27f0109b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $36a58f7b27f0109b$export$1aabd8a0274ecfd6; }, function (v) { return $36a58f7b27f0109b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $36a58f7b27f0109b$export$3d6c20d97e46b957; }, function (v) { return $36a58f7b27f0109b$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $36a58f7b27f0109b$export$9b621391a187a31a; }, function (v) { return $36a58f7b27f0109b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $36a58f7b27f0109b$export$f5bbd400c2f4426f; }, function (v) { return $36a58f7b27f0109b$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $36a58f7b27f0109b$export$a7c73072b1a182ae;
var $36a58f7b27f0109b$export$9f27bc3417b4524d;
var $36a58f7b27f0109b$export$db77ccec0bb4ccac;
var $36a58f7b27f0109b$export$8392c0c9d3dcbd35;
var $36a58f7b27f0109b$export$ffb0004e005737fa;
var $36a58f7b27f0109b$export$b624eff549462981;
var $36a58f7b27f0109b$export$7897aa7841a5380c;
var $36a58f7b27f0109b$export$602eac185826482c;
var $36a58f7b27f0109b$export$e2c29f18771995cb;
var $36a58f7b27f0109b$export$5f8d39834fd61797;
var $36a58f7b27f0109b$export$74bf444e3cd11ea5;
var $36a58f7b27f0109b$export$998bcd577473dd93;
var $36a58f7b27f0109b$export$92387174baf9b227;
var $36a58f7b27f0109b$export$ec112efeb987d9c6;
var $36a58f7b27f0109b$export$b706b080d889d2c9;
var $36a58f7b27f0109b$export$5be5a87408f70ddc;
var $36a58f7b27f0109b$export$45a5e7f76e0caa8d;
var $36a58f7b27f0109b$export$455c2e768291efa6;
var $36a58f7b27f0109b$export$9522e17588c12572;
var $36a58f7b27f0109b$export$2110ac352bb060b9;
var $36a58f7b27f0109b$export$56885ab8b9c456ab;
var $36a58f7b27f0109b$export$d927fcb6adf8f9de;
var $36a58f7b27f0109b$export$b82d16f27459e05a;
var $36a58f7b27f0109b$export$522c17b4f5e123e8;
var $36a58f7b27f0109b$export$1aabd8a0274ecfd6;
var $36a58f7b27f0109b$export$3d6c20d97e46b957;
var $36a58f7b27f0109b$export$9b621391a187a31a;
var $36a58f7b27f0109b$export$f5bbd400c2f4426f;
'use strict';
var $36a58f7b27f0109b$var$b = Symbol.for("react.element"), $36a58f7b27f0109b$var$c = Symbol.for("react.portal"), $36a58f7b27f0109b$var$d = Symbol.for("react.fragment"), $36a58f7b27f0109b$var$e = Symbol.for("react.strict_mode"), $36a58f7b27f0109b$var$f = Symbol.for("react.profiler"), $36a58f7b27f0109b$var$g = Symbol.for("react.provider"), $36a58f7b27f0109b$var$h = Symbol.for("react.context"), $36a58f7b27f0109b$var$k = Symbol.for("react.server_context"), $36a58f7b27f0109b$var$l = Symbol.for("react.forward_ref"), $36a58f7b27f0109b$var$m = Symbol.for("react.suspense"), $36a58f7b27f0109b$var$n = Symbol.for("react.suspense_list"), $36a58f7b27f0109b$var$p = Symbol.for("react.memo"), $36a58f7b27f0109b$var$q = Symbol.for("react.lazy"), $36a58f7b27f0109b$var$t = Symbol.for("react.offscreen"), $36a58f7b27f0109b$var$u;
$36a58f7b27f0109b$var$u = Symbol.for("react.module.reference");
function $36a58f7b27f0109b$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $36a58f7b27f0109b$var$b:
                switch(a = a.type, a){
                    case $36a58f7b27f0109b$var$d:
                    case $36a58f7b27f0109b$var$f:
                    case $36a58f7b27f0109b$var$e:
                    case $36a58f7b27f0109b$var$m:
                    case $36a58f7b27f0109b$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $36a58f7b27f0109b$var$k:
                            case $36a58f7b27f0109b$var$h:
                            case $36a58f7b27f0109b$var$l:
                            case $36a58f7b27f0109b$var$q:
                            case $36a58f7b27f0109b$var$p:
                            case $36a58f7b27f0109b$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $36a58f7b27f0109b$var$c:
                return r;
        }
    }
}
$36a58f7b27f0109b$export$a7c73072b1a182ae = $36a58f7b27f0109b$var$h;
$36a58f7b27f0109b$export$9f27bc3417b4524d = $36a58f7b27f0109b$var$g;
$36a58f7b27f0109b$export$db77ccec0bb4ccac = $36a58f7b27f0109b$var$b;
$36a58f7b27f0109b$export$8392c0c9d3dcbd35 = $36a58f7b27f0109b$var$l;
$36a58f7b27f0109b$export$ffb0004e005737fa = $36a58f7b27f0109b$var$d;
$36a58f7b27f0109b$export$b624eff549462981 = $36a58f7b27f0109b$var$q;
$36a58f7b27f0109b$export$7897aa7841a5380c = $36a58f7b27f0109b$var$p;
$36a58f7b27f0109b$export$602eac185826482c = $36a58f7b27f0109b$var$c;
$36a58f7b27f0109b$export$e2c29f18771995cb = $36a58f7b27f0109b$var$f;
$36a58f7b27f0109b$export$5f8d39834fd61797 = $36a58f7b27f0109b$var$e;
$36a58f7b27f0109b$export$74bf444e3cd11ea5 = $36a58f7b27f0109b$var$m;
$36a58f7b27f0109b$export$998bcd577473dd93 = $36a58f7b27f0109b$var$n;
$36a58f7b27f0109b$export$92387174baf9b227 = function() {
    return !1;
};
$36a58f7b27f0109b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$36a58f7b27f0109b$export$b706b080d889d2c9 = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$h;
};
$36a58f7b27f0109b$export$5be5a87408f70ddc = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$g;
};
$36a58f7b27f0109b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $36a58f7b27f0109b$var$b;
};
$36a58f7b27f0109b$export$455c2e768291efa6 = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$l;
};
$36a58f7b27f0109b$export$9522e17588c12572 = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$d;
};
$36a58f7b27f0109b$export$2110ac352bb060b9 = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$q;
};
$36a58f7b27f0109b$export$56885ab8b9c456ab = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$p;
};
$36a58f7b27f0109b$export$d927fcb6adf8f9de = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$c;
};
$36a58f7b27f0109b$export$b82d16f27459e05a = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$f;
};
$36a58f7b27f0109b$export$522c17b4f5e123e8 = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$e;
};
$36a58f7b27f0109b$export$1aabd8a0274ecfd6 = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$m;
};
$36a58f7b27f0109b$export$3d6c20d97e46b957 = function(a) {
    return $36a58f7b27f0109b$var$v(a) === $36a58f7b27f0109b$var$n;
};
$36a58f7b27f0109b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $36a58f7b27f0109b$var$d || a === $36a58f7b27f0109b$var$f || a === $36a58f7b27f0109b$var$e || a === $36a58f7b27f0109b$var$m || a === $36a58f7b27f0109b$var$n || a === $36a58f7b27f0109b$var$t || "object" === typeof a && null !== a && (a.$$typeof === $36a58f7b27f0109b$var$q || a.$$typeof === $36a58f7b27f0109b$var$p || a.$$typeof === $36a58f7b27f0109b$var$g || a.$$typeof === $36a58f7b27f0109b$var$h || a.$$typeof === $36a58f7b27f0109b$var$l || a.$$typeof === $36a58f7b27f0109b$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$36a58f7b27f0109b$export$f5bbd400c2f4426f = $36a58f7b27f0109b$var$v;

});

parcelRegister("2vcBV", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $1d28423d4cc8bbec$export$2b8d127b894957b9; }, function (v) { return $1d28423d4cc8bbec$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $1d28423d4cc8bbec$export$cea3a54a6425200c; }, function (v) { return $1d28423d4cc8bbec$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $1d28423d4cc8bbec$export$a7c73072b1a182ae; }, function (v) { return $1d28423d4cc8bbec$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $1d28423d4cc8bbec$export$9f27bc3417b4524d; }, function (v) { return $1d28423d4cc8bbec$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $1d28423d4cc8bbec$export$db77ccec0bb4ccac; }, function (v) { return $1d28423d4cc8bbec$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $1d28423d4cc8bbec$export$8392c0c9d3dcbd35; }, function (v) { return $1d28423d4cc8bbec$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1d28423d4cc8bbec$export$ffb0004e005737fa; }, function (v) { return $1d28423d4cc8bbec$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $1d28423d4cc8bbec$export$b624eff549462981; }, function (v) { return $1d28423d4cc8bbec$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $1d28423d4cc8bbec$export$7897aa7841a5380c; }, function (v) { return $1d28423d4cc8bbec$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $1d28423d4cc8bbec$export$602eac185826482c; }, function (v) { return $1d28423d4cc8bbec$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $1d28423d4cc8bbec$export$e2c29f18771995cb; }, function (v) { return $1d28423d4cc8bbec$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1d28423d4cc8bbec$export$5f8d39834fd61797; }, function (v) { return $1d28423d4cc8bbec$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1d28423d4cc8bbec$export$74bf444e3cd11ea5; }, function (v) { return $1d28423d4cc8bbec$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $1d28423d4cc8bbec$export$92387174baf9b227; }, function (v) { return $1d28423d4cc8bbec$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $1d28423d4cc8bbec$export$ec112efeb987d9c6; }, function (v) { return $1d28423d4cc8bbec$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $1d28423d4cc8bbec$export$b706b080d889d2c9; }, function (v) { return $1d28423d4cc8bbec$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $1d28423d4cc8bbec$export$5be5a87408f70ddc; }, function (v) { return $1d28423d4cc8bbec$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $1d28423d4cc8bbec$export$45a5e7f76e0caa8d; }, function (v) { return $1d28423d4cc8bbec$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $1d28423d4cc8bbec$export$455c2e768291efa6; }, function (v) { return $1d28423d4cc8bbec$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $1d28423d4cc8bbec$export$9522e17588c12572; }, function (v) { return $1d28423d4cc8bbec$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $1d28423d4cc8bbec$export$2110ac352bb060b9; }, function (v) { return $1d28423d4cc8bbec$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $1d28423d4cc8bbec$export$56885ab8b9c456ab; }, function (v) { return $1d28423d4cc8bbec$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $1d28423d4cc8bbec$export$d927fcb6adf8f9de; }, function (v) { return $1d28423d4cc8bbec$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $1d28423d4cc8bbec$export$b82d16f27459e05a; }, function (v) { return $1d28423d4cc8bbec$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $1d28423d4cc8bbec$export$522c17b4f5e123e8; }, function (v) { return $1d28423d4cc8bbec$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $1d28423d4cc8bbec$export$1aabd8a0274ecfd6; }, function (v) { return $1d28423d4cc8bbec$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $1d28423d4cc8bbec$export$9b621391a187a31a; }, function (v) { return $1d28423d4cc8bbec$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $1d28423d4cc8bbec$export$f5bbd400c2f4426f; }, function (v) { return $1d28423d4cc8bbec$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1d28423d4cc8bbec$export$2b8d127b894957b9;
var $1d28423d4cc8bbec$export$cea3a54a6425200c;
var $1d28423d4cc8bbec$export$a7c73072b1a182ae;
var $1d28423d4cc8bbec$export$9f27bc3417b4524d;
var $1d28423d4cc8bbec$export$db77ccec0bb4ccac;
var $1d28423d4cc8bbec$export$8392c0c9d3dcbd35;
var $1d28423d4cc8bbec$export$ffb0004e005737fa;
var $1d28423d4cc8bbec$export$b624eff549462981;
var $1d28423d4cc8bbec$export$7897aa7841a5380c;
var $1d28423d4cc8bbec$export$602eac185826482c;
var $1d28423d4cc8bbec$export$e2c29f18771995cb;
var $1d28423d4cc8bbec$export$5f8d39834fd61797;
var $1d28423d4cc8bbec$export$74bf444e3cd11ea5;
var $1d28423d4cc8bbec$export$92387174baf9b227;
var $1d28423d4cc8bbec$export$ec112efeb987d9c6;
var $1d28423d4cc8bbec$export$b706b080d889d2c9;
var $1d28423d4cc8bbec$export$5be5a87408f70ddc;
var $1d28423d4cc8bbec$export$45a5e7f76e0caa8d;
var $1d28423d4cc8bbec$export$455c2e768291efa6;
var $1d28423d4cc8bbec$export$9522e17588c12572;
var $1d28423d4cc8bbec$export$2110ac352bb060b9;
var $1d28423d4cc8bbec$export$56885ab8b9c456ab;
var $1d28423d4cc8bbec$export$d927fcb6adf8f9de;
var $1d28423d4cc8bbec$export$b82d16f27459e05a;
var $1d28423d4cc8bbec$export$522c17b4f5e123e8;
var $1d28423d4cc8bbec$export$1aabd8a0274ecfd6;
var $1d28423d4cc8bbec$export$9b621391a187a31a;
var $1d28423d4cc8bbec$export$f5bbd400c2f4426f;
'use strict';
var $1d28423d4cc8bbec$var$b = "function" === typeof Symbol && Symbol.for, $1d28423d4cc8bbec$var$c = $1d28423d4cc8bbec$var$b ? Symbol.for("react.element") : 60103, $1d28423d4cc8bbec$var$d = $1d28423d4cc8bbec$var$b ? Symbol.for("react.portal") : 60106, $1d28423d4cc8bbec$var$e = $1d28423d4cc8bbec$var$b ? Symbol.for("react.fragment") : 60107, $1d28423d4cc8bbec$var$f = $1d28423d4cc8bbec$var$b ? Symbol.for("react.strict_mode") : 60108, $1d28423d4cc8bbec$var$g = $1d28423d4cc8bbec$var$b ? Symbol.for("react.profiler") : 60114, $1d28423d4cc8bbec$var$h = $1d28423d4cc8bbec$var$b ? Symbol.for("react.provider") : 60109, $1d28423d4cc8bbec$var$k = $1d28423d4cc8bbec$var$b ? Symbol.for("react.context") : 60110, $1d28423d4cc8bbec$var$l = $1d28423d4cc8bbec$var$b ? Symbol.for("react.async_mode") : 60111, $1d28423d4cc8bbec$var$m = $1d28423d4cc8bbec$var$b ? Symbol.for("react.concurrent_mode") : 60111, $1d28423d4cc8bbec$var$n = $1d28423d4cc8bbec$var$b ? Symbol.for("react.forward_ref") : 60112, $1d28423d4cc8bbec$var$p = $1d28423d4cc8bbec$var$b ? Symbol.for("react.suspense") : 60113, $1d28423d4cc8bbec$var$q = $1d28423d4cc8bbec$var$b ? Symbol.for("react.suspense_list") : 60120, $1d28423d4cc8bbec$var$r = $1d28423d4cc8bbec$var$b ? Symbol.for("react.memo") : 60115, $1d28423d4cc8bbec$var$t = $1d28423d4cc8bbec$var$b ? Symbol.for("react.lazy") : 60116, $1d28423d4cc8bbec$var$v = $1d28423d4cc8bbec$var$b ? Symbol.for("react.block") : 60121, $1d28423d4cc8bbec$var$w = $1d28423d4cc8bbec$var$b ? Symbol.for("react.fundamental") : 60117, $1d28423d4cc8bbec$var$x = $1d28423d4cc8bbec$var$b ? Symbol.for("react.responder") : 60118, $1d28423d4cc8bbec$var$y = $1d28423d4cc8bbec$var$b ? Symbol.for("react.scope") : 60119;
function $1d28423d4cc8bbec$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $1d28423d4cc8bbec$var$c:
                switch(a = a.type, a){
                    case $1d28423d4cc8bbec$var$l:
                    case $1d28423d4cc8bbec$var$m:
                    case $1d28423d4cc8bbec$var$e:
                    case $1d28423d4cc8bbec$var$g:
                    case $1d28423d4cc8bbec$var$f:
                    case $1d28423d4cc8bbec$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1d28423d4cc8bbec$var$k:
                            case $1d28423d4cc8bbec$var$n:
                            case $1d28423d4cc8bbec$var$t:
                            case $1d28423d4cc8bbec$var$r:
                            case $1d28423d4cc8bbec$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $1d28423d4cc8bbec$var$d:
                return u;
        }
    }
}
function $1d28423d4cc8bbec$var$A(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$m;
}
$1d28423d4cc8bbec$export$2b8d127b894957b9 = $1d28423d4cc8bbec$var$l;
$1d28423d4cc8bbec$export$cea3a54a6425200c = $1d28423d4cc8bbec$var$m;
$1d28423d4cc8bbec$export$a7c73072b1a182ae = $1d28423d4cc8bbec$var$k;
$1d28423d4cc8bbec$export$9f27bc3417b4524d = $1d28423d4cc8bbec$var$h;
$1d28423d4cc8bbec$export$db77ccec0bb4ccac = $1d28423d4cc8bbec$var$c;
$1d28423d4cc8bbec$export$8392c0c9d3dcbd35 = $1d28423d4cc8bbec$var$n;
$1d28423d4cc8bbec$export$ffb0004e005737fa = $1d28423d4cc8bbec$var$e;
$1d28423d4cc8bbec$export$b624eff549462981 = $1d28423d4cc8bbec$var$t;
$1d28423d4cc8bbec$export$7897aa7841a5380c = $1d28423d4cc8bbec$var$r;
$1d28423d4cc8bbec$export$602eac185826482c = $1d28423d4cc8bbec$var$d;
$1d28423d4cc8bbec$export$e2c29f18771995cb = $1d28423d4cc8bbec$var$g;
$1d28423d4cc8bbec$export$5f8d39834fd61797 = $1d28423d4cc8bbec$var$f;
$1d28423d4cc8bbec$export$74bf444e3cd11ea5 = $1d28423d4cc8bbec$var$p;
$1d28423d4cc8bbec$export$92387174baf9b227 = function(a) {
    return $1d28423d4cc8bbec$var$A(a) || $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$l;
};
$1d28423d4cc8bbec$export$ec112efeb987d9c6 = $1d28423d4cc8bbec$var$A;
$1d28423d4cc8bbec$export$b706b080d889d2c9 = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$k;
};
$1d28423d4cc8bbec$export$5be5a87408f70ddc = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$h;
};
$1d28423d4cc8bbec$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1d28423d4cc8bbec$var$c;
};
$1d28423d4cc8bbec$export$455c2e768291efa6 = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$n;
};
$1d28423d4cc8bbec$export$9522e17588c12572 = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$e;
};
$1d28423d4cc8bbec$export$2110ac352bb060b9 = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$t;
};
$1d28423d4cc8bbec$export$56885ab8b9c456ab = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$r;
};
$1d28423d4cc8bbec$export$d927fcb6adf8f9de = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$d;
};
$1d28423d4cc8bbec$export$b82d16f27459e05a = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$g;
};
$1d28423d4cc8bbec$export$522c17b4f5e123e8 = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$f;
};
$1d28423d4cc8bbec$export$1aabd8a0274ecfd6 = function(a) {
    return $1d28423d4cc8bbec$var$z(a) === $1d28423d4cc8bbec$var$p;
};
$1d28423d4cc8bbec$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1d28423d4cc8bbec$var$e || a === $1d28423d4cc8bbec$var$m || a === $1d28423d4cc8bbec$var$g || a === $1d28423d4cc8bbec$var$f || a === $1d28423d4cc8bbec$var$p || a === $1d28423d4cc8bbec$var$q || "object" === typeof a && null !== a && (a.$$typeof === $1d28423d4cc8bbec$var$t || a.$$typeof === $1d28423d4cc8bbec$var$r || a.$$typeof === $1d28423d4cc8bbec$var$h || a.$$typeof === $1d28423d4cc8bbec$var$k || a.$$typeof === $1d28423d4cc8bbec$var$n || a.$$typeof === $1d28423d4cc8bbec$var$w || a.$$typeof === $1d28423d4cc8bbec$var$x || a.$$typeof === $1d28423d4cc8bbec$var$y || a.$$typeof === $1d28423d4cc8bbec$var$v);
};
$1d28423d4cc8bbec$export$f5bbd400c2f4426f = $1d28423d4cc8bbec$var$z;

});

parcelRegister("cd0Jr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e37444847af19e8$var$ReactIs, $8e37444847af19e8$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("eSKCJ"))();

});
parcelRegister("eSKCJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kGFiO = parcelRequire("kGFiO");
function $ad5a4654dfeb0e94$var$emptyFunction() {}
function $ad5a4654dfeb0e94$var$emptyFunctionWithReset() {}
$ad5a4654dfeb0e94$var$emptyFunctionWithReset.resetWarningCache = $ad5a4654dfeb0e94$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kGFiO) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ad5a4654dfeb0e94$var$emptyFunctionWithReset,
        resetWarningCache: $ad5a4654dfeb0e94$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kGFiO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f0f7c4b0d0b6e510$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f0f7c4b0d0b6e510$var$ReactPropTypesSecret;

});



parcelRegister("hI4Hx", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("axMmP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $7c66174f9669f3c3$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $7c66174f9669f3c3$export$2e2bcd8739ae039; });
function $7c66174f9669f3c3$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $7c66174f9669f3c3$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $7c66174f9669f3c3$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $7c66174f9669f3c3$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7c66174f9669f3c3$export$2e2bcd8739ae039 = $7c66174f9669f3c3$export$4f5d2d50c9deca37;

});

parcelRegister("bht2X", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $8367d0522f7f4c6c$export$871608497c498473; }, function (v) { return $8367d0522f7f4c6c$export$871608497c498473 = v; });
var $8367d0522f7f4c6c$export$871608497c498473;
"use strict";
$8367d0522f7f4c6c$export$871608497c498473 = $8367d0522f7f4c6c$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $8367d0522f7f4c6c$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});

parcelRegister("4pFgQ", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $336982b3a2983d84$export$1ea939691cdc45b8; }, function (v) { return $336982b3a2983d84$export$1ea939691cdc45b8 = v; });
var $336982b3a2983d84$export$1ea939691cdc45b8;
"use strict";
$336982b3a2983d84$export$1ea939691cdc45b8 = $336982b3a2983d84$var$isValid;

var $bht2X = parcelRequire("bht2X");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $336982b3a2983d84$var$isValid(date) {
    if (!(0, $bht2X.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $7NYl1.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("7NYl1", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $5aebe9dd36102734$export$e67a095c620b86fe; }, function (v) { return $5aebe9dd36102734$export$e67a095c620b86fe = v; });
var $5aebe9dd36102734$export$e67a095c620b86fe;
"use strict";
$5aebe9dd36102734$export$e67a095c620b86fe = $5aebe9dd36102734$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $5aebe9dd36102734$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});


parcelRegister("9IzSo", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $71340d64f8f6be55$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $f25bz.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $3jJeP.longFormatters;
    }
});

var $s26wx = parcelRequire("s26wx");

var $f8DjC = parcelRequire("f8DjC");

var $f25bz = parcelRequire("f25bz");

var $3jJeP = parcelRequire("3jJeP");

var $abYtk = parcelRequire("abYtk");

var $4pFgQ = parcelRequire("4pFgQ");

var $7NYl1 = parcelRequire("7NYl1");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $71340d64f8f6be55$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $71340d64f8f6be55$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $71340d64f8f6be55$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $71340d64f8f6be55$var$doubleQuoteRegExp = /''/g;
const $71340d64f8f6be55$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $71340d64f8f6be55$var$format(date, formatStr, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $s26wx.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $7NYl1.toDate)(date);
    if (!(0, $4pFgQ.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($71340d64f8f6be55$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $3jJeP.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($71340d64f8f6be55$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $71340d64f8f6be55$var$cleanEscapedString(substring)
        };
        if ($f25bz.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($71340d64f8f6be55$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $abYtk.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $abYtk.isProtectedDayOfYearToken)(token)) (0, $abYtk.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $f25bz.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $71340d64f8f6be55$var$cleanEscapedString(input) {
    const matched = input.match($71340d64f8f6be55$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($71340d64f8f6be55$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("s26wx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $bvUmQ.enUS;
    }
});

var $bvUmQ = parcelRequire("bvUmQ");

});
parcelRegister("bvUmQ", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $861e505fa363222c$export$137380d9ce54f7f; }, function (v) { return $861e505fa363222c$export$137380d9ce54f7f = v; });
var $861e505fa363222c$export$137380d9ce54f7f;
"use strict";
$861e505fa363222c$export$137380d9ce54f7f = void 0;

var $cUzFK = parcelRequire("cUzFK");

var $lI9Wk = parcelRequire("lI9Wk");

var $4UiyE = parcelRequire("4UiyE");

var $cu6hA = parcelRequire("cu6hA");

var $aXO6d = parcelRequire("aXO6d");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $861e505fa363222c$var$enUS = $861e505fa363222c$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $cUzFK.formatDistance,
    formatLong: $lI9Wk.formatLong,
    formatRelative: $4UiyE.formatRelative,
    localize: $cu6hA.localize,
    match: $aXO6d.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("cUzFK", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $966662c3ed7c3187$export$2c14ff85d6318973; }, function (v) { return $966662c3ed7c3187$export$2c14ff85d6318973 = v; });
var $966662c3ed7c3187$export$2c14ff85d6318973;
"use strict";
$966662c3ed7c3187$export$2c14ff85d6318973 = void 0;
const $966662c3ed7c3187$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $966662c3ed7c3187$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $966662c3ed7c3187$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$966662c3ed7c3187$export$2c14ff85d6318973 = $966662c3ed7c3187$var$formatDistance;

});

parcelRegister("lI9Wk", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $fce56ae45bfa6c43$export$cbf60ecb96cbb82f; }, function (v) { return $fce56ae45bfa6c43$export$cbf60ecb96cbb82f = v; });
var $fce56ae45bfa6c43$export$cbf60ecb96cbb82f;
"use strict";
$fce56ae45bfa6c43$export$cbf60ecb96cbb82f = void 0;

var $3OHDL = parcelRequire("3OHDL");
const $fce56ae45bfa6c43$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $fce56ae45bfa6c43$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $fce56ae45bfa6c43$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fce56ae45bfa6c43$var$formatLong = $fce56ae45bfa6c43$export$cbf60ecb96cbb82f = {
    date: (0, $3OHDL.buildFormatLongFn)({
        formats: $fce56ae45bfa6c43$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $3OHDL.buildFormatLongFn)({
        formats: $fce56ae45bfa6c43$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $3OHDL.buildFormatLongFn)({
        formats: $fce56ae45bfa6c43$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("3OHDL", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $2c77e4ab1dfdc956$export$38e44e97ce4dbb7d; }, function (v) { return $2c77e4ab1dfdc956$export$38e44e97ce4dbb7d = v; });
var $2c77e4ab1dfdc956$export$38e44e97ce4dbb7d;
"use strict";
$2c77e4ab1dfdc956$export$38e44e97ce4dbb7d = $2c77e4ab1dfdc956$var$buildFormatLongFn;
function $2c77e4ab1dfdc956$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("4UiyE", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $392ac99a488d6449$export$8fbbfd65594f46a0; }, function (v) { return $392ac99a488d6449$export$8fbbfd65594f46a0 = v; });
var $392ac99a488d6449$export$8fbbfd65594f46a0;
"use strict";
$392ac99a488d6449$export$8fbbfd65594f46a0 = void 0;
const $392ac99a488d6449$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $392ac99a488d6449$var$formatRelative = (token, _date, _baseDate, _options)=>$392ac99a488d6449$var$formatRelativeLocale[token];
$392ac99a488d6449$export$8fbbfd65594f46a0 = $392ac99a488d6449$var$formatRelative;

});

parcelRegister("cu6hA", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $916d2901ec17aa32$export$b3bd0bc58e36cd63; }, function (v) { return $916d2901ec17aa32$export$b3bd0bc58e36cd63 = v; });
var $916d2901ec17aa32$export$b3bd0bc58e36cd63;
"use strict";
$916d2901ec17aa32$export$b3bd0bc58e36cd63 = void 0;

var $l0e5y = parcelRequire("l0e5y");
const $916d2901ec17aa32$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $916d2901ec17aa32$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $916d2901ec17aa32$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $916d2901ec17aa32$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $916d2901ec17aa32$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $916d2901ec17aa32$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $916d2901ec17aa32$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $916d2901ec17aa32$var$localize = $916d2901ec17aa32$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $916d2901ec17aa32$var$ordinalNumber,
    era: (0, $l0e5y.buildLocalizeFn)({
        values: $916d2901ec17aa32$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $l0e5y.buildLocalizeFn)({
        values: $916d2901ec17aa32$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $l0e5y.buildLocalizeFn)({
        values: $916d2901ec17aa32$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $l0e5y.buildLocalizeFn)({
        values: $916d2901ec17aa32$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $l0e5y.buildLocalizeFn)({
        values: $916d2901ec17aa32$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $916d2901ec17aa32$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("l0e5y", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $f4a486bc99131197$export$63596d6ee8878b25; }, function (v) { return $f4a486bc99131197$export$63596d6ee8878b25 = v; });
var $f4a486bc99131197$export$63596d6ee8878b25;
"use strict";
$f4a486bc99131197$export$63596d6ee8878b25 = $f4a486bc99131197$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $f4a486bc99131197$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("aXO6d", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $7fb646bb1d0f1a47$export$4659b591c19bdf3d; }, function (v) { return $7fb646bb1d0f1a47$export$4659b591c19bdf3d = v; });
var $7fb646bb1d0f1a47$export$4659b591c19bdf3d;
"use strict";
$7fb646bb1d0f1a47$export$4659b591c19bdf3d = void 0;

var $jVNaS = parcelRequire("jVNaS");

var $fet3y = parcelRequire("fet3y");
const $7fb646bb1d0f1a47$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $7fb646bb1d0f1a47$var$parseOrdinalNumberPattern = /\d+/i;
const $7fb646bb1d0f1a47$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $7fb646bb1d0f1a47$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $7fb646bb1d0f1a47$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $7fb646bb1d0f1a47$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7fb646bb1d0f1a47$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $7fb646bb1d0f1a47$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $7fb646bb1d0f1a47$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $7fb646bb1d0f1a47$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $7fb646bb1d0f1a47$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $7fb646bb1d0f1a47$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $7fb646bb1d0f1a47$var$match = $7fb646bb1d0f1a47$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $fet3y.buildMatchPatternFn)({
        matchPattern: $7fb646bb1d0f1a47$var$matchOrdinalNumberPattern,
        parsePattern: $7fb646bb1d0f1a47$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $jVNaS.buildMatchFn)({
        matchPatterns: $7fb646bb1d0f1a47$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb646bb1d0f1a47$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jVNaS.buildMatchFn)({
        matchPatterns: $7fb646bb1d0f1a47$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb646bb1d0f1a47$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $jVNaS.buildMatchFn)({
        matchPatterns: $7fb646bb1d0f1a47$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb646bb1d0f1a47$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jVNaS.buildMatchFn)({
        matchPatterns: $7fb646bb1d0f1a47$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb646bb1d0f1a47$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jVNaS.buildMatchFn)({
        matchPatterns: $7fb646bb1d0f1a47$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7fb646bb1d0f1a47$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("jVNaS", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $e8297c30af616eab$export$1430a0f35710914d; }, function (v) { return $e8297c30af616eab$export$1430a0f35710914d = v; });
var $e8297c30af616eab$export$1430a0f35710914d;
"use strict";
$e8297c30af616eab$export$1430a0f35710914d = $e8297c30af616eab$var$buildMatchFn;
function $e8297c30af616eab$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e8297c30af616eab$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e8297c30af616eab$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e8297c30af616eab$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e8297c30af616eab$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("fet3y", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $b16eb3ca5d215e32$export$fdaf2fd6d7edde95; }, function (v) { return $b16eb3ca5d215e32$export$fdaf2fd6d7edde95 = v; });
var $b16eb3ca5d215e32$export$fdaf2fd6d7edde95;
"use strict";
$b16eb3ca5d215e32$export$fdaf2fd6d7edde95 = $b16eb3ca5d215e32$var$buildMatchPatternFn;
function $b16eb3ca5d215e32$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("f8DjC", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $b056199c3b3654d8$export$430a3269e24b912e; }, function (v) { return $b056199c3b3654d8$export$430a3269e24b912e = v; });
$parcel$export(module.exports, "setDefaultOptions", function () { return $b056199c3b3654d8$export$95365be1b0704abc; }, function (v) { return $b056199c3b3654d8$export$95365be1b0704abc = v; });
var $b056199c3b3654d8$export$430a3269e24b912e;
var $b056199c3b3654d8$export$95365be1b0704abc;
"use strict";
$b056199c3b3654d8$export$430a3269e24b912e = $b056199c3b3654d8$var$getDefaultOptions;
$b056199c3b3654d8$export$95365be1b0704abc = $b056199c3b3654d8$var$setDefaultOptions;
let $b056199c3b3654d8$var$defaultOptions = {};
function $b056199c3b3654d8$var$getDefaultOptions() {
    return $b056199c3b3654d8$var$defaultOptions;
}
function $b056199c3b3654d8$var$setDefaultOptions(newOptions) {
    $b056199c3b3654d8$var$defaultOptions = newOptions;
}

});

parcelRegister("f25bz", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $af1b10aebd63b488$export$fe98a034cfb96d55; }, function (v) { return $af1b10aebd63b488$export$fe98a034cfb96d55 = v; });
var $af1b10aebd63b488$export$fe98a034cfb96d55;
"use strict";
$af1b10aebd63b488$export$fe98a034cfb96d55 = void 0;

var $2TuPF = parcelRequire("2TuPF");

var $5MJAb = parcelRequire("5MJAb");

var $VphlE = parcelRequire("VphlE");

var $ZnAKU = parcelRequire("ZnAKU");

var $7Fdrm = parcelRequire("7Fdrm");

var $fx1dE = parcelRequire("fx1dE");

var $lP0sG = parcelRequire("lP0sG");
const $af1b10aebd63b488$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $af1b10aebd63b488$var$formatters = $af1b10aebd63b488$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $lP0sG.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $7Fdrm.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $fx1dE.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $fx1dE.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $VphlE.getISOWeekYear)(date);
        // Padding
        return (0, $fx1dE.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $fx1dE.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $fx1dE.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $fx1dE.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $lP0sG.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $fx1dE.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $ZnAKU.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $fx1dE.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $5MJAb.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $fx1dE.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $lP0sG.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $2TuPF.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $fx1dE.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $fx1dE.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $fx1dE.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $fx1dE.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $af1b10aebd63b488$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $af1b10aebd63b488$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $af1b10aebd63b488$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $af1b10aebd63b488$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $af1b10aebd63b488$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $af1b10aebd63b488$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $lP0sG.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $lP0sG.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $fx1dE.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $fx1dE.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $lP0sG.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $lP0sG.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $lP0sG.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $af1b10aebd63b488$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $af1b10aebd63b488$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $af1b10aebd63b488$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $af1b10aebd63b488$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $af1b10aebd63b488$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $af1b10aebd63b488$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $af1b10aebd63b488$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $af1b10aebd63b488$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $af1b10aebd63b488$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $af1b10aebd63b488$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $fx1dE.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $fx1dE.addLeadingZeros)(timestamp, token.length);
    }
};
function $af1b10aebd63b488$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $fx1dE.addLeadingZeros)(minutes, 2);
}
function $af1b10aebd63b488$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $fx1dE.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $af1b10aebd63b488$var$formatTimezone(offset, delimiter);
}
function $af1b10aebd63b488$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $fx1dE.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $fx1dE.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("2TuPF", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", function () { return $21b8a278a1aa6359$export$d3b42cd8452deec; }, function (v) { return $21b8a278a1aa6359$export$d3b42cd8452deec = v; });
var $21b8a278a1aa6359$export$d3b42cd8452deec;
"use strict";
$21b8a278a1aa6359$export$d3b42cd8452deec = $21b8a278a1aa6359$var$getDayOfYear;

var $jaIwE = parcelRequire("jaIwE");

var $2pG9s = parcelRequire("2pG9s");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $21b8a278a1aa6359$var$getDayOfYear(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const diff = (0, $jaIwE.differenceInCalendarDays)(_date, (0, $2pG9s.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});
parcelRegister("jaIwE", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", function () { return $df517d59651c10e2$export$4a02e9c37dab4871; }, function (v) { return $df517d59651c10e2$export$4a02e9c37dab4871 = v; });
var $df517d59651c10e2$export$4a02e9c37dab4871;
"use strict";
$df517d59651c10e2$export$4a02e9c37dab4871 = $df517d59651c10e2$var$differenceInCalendarDays;

var $kMovx = parcelRequire("kMovx");

var $ePNEc = parcelRequire("ePNEc");

var $eBj5w = parcelRequire("eBj5w");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $df517d59651c10e2$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $ePNEc.startOfDay)(dateLeft);
    const startOfDayRight = (0, $ePNEc.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $kMovx.millisecondsInDay);
}

});
parcelRegister("kMovx", function(module, exports) {

$parcel$export(module.exports, "secondsInYear", function () { return $03e76877ee554d15$export$7271e9e3478110d1; }, function (v) { return $03e76877ee554d15$export$7271e9e3478110d1 = v; });
$parcel$export(module.exports, "secondsInWeek", function () { return $03e76877ee554d15$export$34804a017b31e2fe; }, function (v) { return $03e76877ee554d15$export$34804a017b31e2fe = v; });
$parcel$export(module.exports, "secondsInQuarter", function () { return $03e76877ee554d15$export$be1dccf2de902d31; }, function (v) { return $03e76877ee554d15$export$be1dccf2de902d31 = v; });
$parcel$export(module.exports, "secondsInMonth", function () { return $03e76877ee554d15$export$8e6600bbdee7dabb; }, function (v) { return $03e76877ee554d15$export$8e6600bbdee7dabb = v; });
$parcel$export(module.exports, "secondsInMinute", function () { return $03e76877ee554d15$export$a77c1a7ebebe2a5a; }, function (v) { return $03e76877ee554d15$export$a77c1a7ebebe2a5a = v; });
$parcel$export(module.exports, "secondsInHour", function () { return $03e76877ee554d15$export$698aec755e92c695; }, function (v) { return $03e76877ee554d15$export$698aec755e92c695 = v; });
$parcel$export(module.exports, "secondsInDay", function () { return $03e76877ee554d15$export$815a9362476d2fe3; }, function (v) { return $03e76877ee554d15$export$815a9362476d2fe3 = v; });
$parcel$export(module.exports, "quartersInYear", function () { return $03e76877ee554d15$export$4db7641526e3241f; }, function (v) { return $03e76877ee554d15$export$4db7641526e3241f = v; });
$parcel$export(module.exports, "monthsInYear", function () { return $03e76877ee554d15$export$80d7e435f744f319; }, function (v) { return $03e76877ee554d15$export$80d7e435f744f319 = v; });
$parcel$export(module.exports, "monthsInQuarter", function () { return $03e76877ee554d15$export$3c58128db900d44e; }, function (v) { return $03e76877ee554d15$export$3c58128db900d44e = v; });
$parcel$export(module.exports, "minutesInYear", function () { return $03e76877ee554d15$export$3633035e63cee86a; }, function (v) { return $03e76877ee554d15$export$3633035e63cee86a = v; });
$parcel$export(module.exports, "minutesInMonth", function () { return $03e76877ee554d15$export$ab7da2ccd1075c38; }, function (v) { return $03e76877ee554d15$export$ab7da2ccd1075c38 = v; });
$parcel$export(module.exports, "minutesInHour", function () { return $03e76877ee554d15$export$f2f5ae5a8e2d8f9f; }, function (v) { return $03e76877ee554d15$export$f2f5ae5a8e2d8f9f = v; });
$parcel$export(module.exports, "minutesInDay", function () { return $03e76877ee554d15$export$2423174df8cd3cd2; }, function (v) { return $03e76877ee554d15$export$2423174df8cd3cd2 = v; });
$parcel$export(module.exports, "millisecondsInWeek", function () { return $03e76877ee554d15$export$4fad13613e88edc8; }, function (v) { return $03e76877ee554d15$export$4fad13613e88edc8 = v; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $03e76877ee554d15$export$397c2d5776aa9055; }, function (v) { return $03e76877ee554d15$export$397c2d5776aa9055 = v; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $03e76877ee554d15$export$91246f0b9bd9beff; }, function (v) { return $03e76877ee554d15$export$91246f0b9bd9beff = v; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $03e76877ee554d15$export$7f72910d6dfd237a; }, function (v) { return $03e76877ee554d15$export$7f72910d6dfd237a = v; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $03e76877ee554d15$export$b76b1809a2898f9a; }, function (v) { return $03e76877ee554d15$export$b76b1809a2898f9a = v; });
$parcel$export(module.exports, "daysInYear", function () { return $03e76877ee554d15$export$3913210603d8e9ae; }, function (v) { return $03e76877ee554d15$export$3913210603d8e9ae = v; });
$parcel$export(module.exports, "daysInWeek", function () { return $03e76877ee554d15$export$dfd9b671c89acc8e; }, function (v) { return $03e76877ee554d15$export$dfd9b671c89acc8e = v; });
var $03e76877ee554d15$export$7271e9e3478110d1;
var $03e76877ee554d15$export$34804a017b31e2fe;
var $03e76877ee554d15$export$be1dccf2de902d31;
var $03e76877ee554d15$export$8e6600bbdee7dabb;
var $03e76877ee554d15$export$a77c1a7ebebe2a5a;
var $03e76877ee554d15$export$698aec755e92c695;
var $03e76877ee554d15$export$815a9362476d2fe3;
var $03e76877ee554d15$export$4db7641526e3241f;
var $03e76877ee554d15$export$80d7e435f744f319;
var $03e76877ee554d15$export$3c58128db900d44e;
var $03e76877ee554d15$export$3633035e63cee86a;
var $03e76877ee554d15$export$ab7da2ccd1075c38;
var $03e76877ee554d15$export$f2f5ae5a8e2d8f9f;
var $03e76877ee554d15$export$2423174df8cd3cd2;
var $03e76877ee554d15$export$4dec998e48f9c246;
var $03e76877ee554d15$export$4fad13613e88edc8;
var $03e76877ee554d15$export$397c2d5776aa9055;
var $03e76877ee554d15$export$91246f0b9bd9beff;
var $03e76877ee554d15$export$7f72910d6dfd237a;
var $03e76877ee554d15$export$b76b1809a2898f9a;
var $03e76877ee554d15$export$81caae6e1cc7a622;
var $03e76877ee554d15$export$3913210603d8e9ae;
var $03e76877ee554d15$export$dfd9b671c89acc8e;
"use strict";
$03e76877ee554d15$export$7271e9e3478110d1 = $03e76877ee554d15$export$34804a017b31e2fe = $03e76877ee554d15$export$be1dccf2de902d31 = $03e76877ee554d15$export$8e6600bbdee7dabb = $03e76877ee554d15$export$a77c1a7ebebe2a5a = $03e76877ee554d15$export$698aec755e92c695 = $03e76877ee554d15$export$815a9362476d2fe3 = $03e76877ee554d15$export$4db7641526e3241f = $03e76877ee554d15$export$80d7e435f744f319 = $03e76877ee554d15$export$3c58128db900d44e = $03e76877ee554d15$export$3633035e63cee86a = $03e76877ee554d15$export$ab7da2ccd1075c38 = $03e76877ee554d15$export$f2f5ae5a8e2d8f9f = $03e76877ee554d15$export$2423174df8cd3cd2 = $03e76877ee554d15$export$4dec998e48f9c246 = $03e76877ee554d15$export$4fad13613e88edc8 = $03e76877ee554d15$export$397c2d5776aa9055 = $03e76877ee554d15$export$91246f0b9bd9beff = $03e76877ee554d15$export$7f72910d6dfd237a = $03e76877ee554d15$export$b76b1809a2898f9a = $03e76877ee554d15$export$81caae6e1cc7a622 = $03e76877ee554d15$export$3913210603d8e9ae = $03e76877ee554d15$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $03e76877ee554d15$var$daysInWeek = $03e76877ee554d15$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $03e76877ee554d15$var$daysInYear = $03e76877ee554d15$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $03e76877ee554d15$var$maxTime = $03e76877ee554d15$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $03e76877ee554d15$var$minTime = $03e76877ee554d15$export$4dec998e48f9c246 = -$03e76877ee554d15$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $03e76877ee554d15$var$millisecondsInWeek = $03e76877ee554d15$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $03e76877ee554d15$var$millisecondsInDay = $03e76877ee554d15$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $03e76877ee554d15$var$millisecondsInMinute = $03e76877ee554d15$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $03e76877ee554d15$var$millisecondsInHour = $03e76877ee554d15$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $03e76877ee554d15$var$millisecondsInSecond = $03e76877ee554d15$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $03e76877ee554d15$var$minutesInYear = $03e76877ee554d15$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $03e76877ee554d15$var$minutesInMonth = $03e76877ee554d15$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $03e76877ee554d15$var$minutesInDay = $03e76877ee554d15$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $03e76877ee554d15$var$minutesInHour = $03e76877ee554d15$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $03e76877ee554d15$var$monthsInQuarter = $03e76877ee554d15$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $03e76877ee554d15$var$monthsInYear = $03e76877ee554d15$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $03e76877ee554d15$var$quartersInYear = $03e76877ee554d15$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $03e76877ee554d15$var$secondsInHour = $03e76877ee554d15$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $03e76877ee554d15$var$secondsInMinute = $03e76877ee554d15$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $03e76877ee554d15$var$secondsInDay = $03e76877ee554d15$export$815a9362476d2fe3 = $03e76877ee554d15$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $03e76877ee554d15$var$secondsInWeek = $03e76877ee554d15$export$34804a017b31e2fe = $03e76877ee554d15$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $03e76877ee554d15$var$secondsInYear = $03e76877ee554d15$export$7271e9e3478110d1 = $03e76877ee554d15$var$secondsInDay * $03e76877ee554d15$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $03e76877ee554d15$var$secondsInMonth = $03e76877ee554d15$export$8e6600bbdee7dabb = $03e76877ee554d15$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $03e76877ee554d15$var$secondsInQuarter = $03e76877ee554d15$export$be1dccf2de902d31 = $03e76877ee554d15$var$secondsInMonth * 3;

});

parcelRegister("ePNEc", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $accc570bb37f7ca5$export$63fa379ae8a9ba2; }, function (v) { return $accc570bb37f7ca5$export$63fa379ae8a9ba2 = v; });
var $accc570bb37f7ca5$export$63fa379ae8a9ba2;
"use strict";
$accc570bb37f7ca5$export$63fa379ae8a9ba2 = $accc570bb37f7ca5$var$startOfDay;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $accc570bb37f7ca5$var$startOfDay(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("eBj5w", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $aa1353de0f86a63c$export$113002b5eff6e430; }, function (v) { return $aa1353de0f86a63c$export$113002b5eff6e430 = v; });
var $aa1353de0f86a63c$export$113002b5eff6e430;
"use strict";
$aa1353de0f86a63c$export$113002b5eff6e430 = $aa1353de0f86a63c$var$getTimezoneOffsetInMilliseconds;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $aa1353de0f86a63c$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("2pG9s", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $1c1e9cf715b012af$export$f91e89d3d0406102; }, function (v) { return $1c1e9cf715b012af$export$f91e89d3d0406102 = v; });
var $1c1e9cf715b012af$export$f91e89d3d0406102;
"use strict";
$1c1e9cf715b012af$export$f91e89d3d0406102 = $1c1e9cf715b012af$var$startOfYear;

var $7NYl1 = parcelRequire("7NYl1");

var $5viJK = parcelRequire("5viJK");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $1c1e9cf715b012af$var$startOfYear(date) {
    const cleanDate = (0, $7NYl1.toDate)(date);
    const _date = (0, $5viJK.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});
parcelRegister("5viJK", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $401e61bb2f6e2f1d$export$ead8a1812b171991; }, function (v) { return $401e61bb2f6e2f1d$export$ead8a1812b171991 = v; });
var $401e61bb2f6e2f1d$export$ead8a1812b171991;
"use strict";
$401e61bb2f6e2f1d$export$ead8a1812b171991 = $401e61bb2f6e2f1d$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $401e61bb2f6e2f1d$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});



parcelRegister("5MJAb", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $4364cb2fd16413b9$export$7cabdc5698b63e2f; }, function (v) { return $4364cb2fd16413b9$export$7cabdc5698b63e2f = v; });
var $4364cb2fd16413b9$export$7cabdc5698b63e2f;
"use strict";
$4364cb2fd16413b9$export$7cabdc5698b63e2f = $4364cb2fd16413b9$var$getISOWeek;

var $kMovx = parcelRequire("kMovx");

var $56Gig = parcelRequire("56Gig");

var $9tNR4 = parcelRequire("9tNR4");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $4364cb2fd16413b9$var$getISOWeek(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const diff = +(0, $56Gig.startOfISOWeek)(_date) - +(0, $9tNR4.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $kMovx.millisecondsInWeek) + 1;
}

});
parcelRegister("56Gig", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $3b7e51ed42f11d46$export$6173213f95a4431e; }, function (v) { return $3b7e51ed42f11d46$export$6173213f95a4431e = v; });
var $3b7e51ed42f11d46$export$6173213f95a4431e;
"use strict";
$3b7e51ed42f11d46$export$6173213f95a4431e = $3b7e51ed42f11d46$var$startOfISOWeek;

var $dembC = parcelRequire("dembC");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $3b7e51ed42f11d46$var$startOfISOWeek(date) {
    return (0, $dembC.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("dembC", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $9a1dcae6f2015743$export$42c81a444fbfb5d4; }, function (v) { return $9a1dcae6f2015743$export$42c81a444fbfb5d4 = v; });
var $9a1dcae6f2015743$export$42c81a444fbfb5d4;
"use strict";
$9a1dcae6f2015743$export$42c81a444fbfb5d4 = $9a1dcae6f2015743$var$startOfWeek;

var $7NYl1 = parcelRequire("7NYl1");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $9a1dcae6f2015743$var$startOfWeek(date, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7NYl1.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("9tNR4", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $6e6d7ea1aef675c9$export$236bdfa374eb69a9; }, function (v) { return $6e6d7ea1aef675c9$export$236bdfa374eb69a9 = v; });
var $6e6d7ea1aef675c9$export$236bdfa374eb69a9;
"use strict";
$6e6d7ea1aef675c9$export$236bdfa374eb69a9 = $6e6d7ea1aef675c9$var$startOfISOWeekYear;

var $VphlE = parcelRequire("VphlE");

var $56Gig = parcelRequire("56Gig");

var $5viJK = parcelRequire("5viJK");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $6e6d7ea1aef675c9$var$startOfISOWeekYear(date) {
    const year = (0, $VphlE.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $5viJK.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $56Gig.startOfISOWeek)(fourthOfJanuary);
}

});
parcelRegister("VphlE", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $0ac8eed4b4721b10$export$3dbc52535f6f8fcc; }, function (v) { return $0ac8eed4b4721b10$export$3dbc52535f6f8fcc = v; });
var $0ac8eed4b4721b10$export$3dbc52535f6f8fcc;
"use strict";
$0ac8eed4b4721b10$export$3dbc52535f6f8fcc = $0ac8eed4b4721b10$var$getISOWeekYear;

var $5viJK = parcelRequire("5viJK");

var $56Gig = parcelRequire("56Gig");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $0ac8eed4b4721b10$var$getISOWeekYear(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $5viJK.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $56Gig.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $5viJK.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $56Gig.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("ZnAKU", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $0b87ff774e916008$export$efe19b760242b2fc; }, function (v) { return $0b87ff774e916008$export$efe19b760242b2fc = v; });
var $0b87ff774e916008$export$efe19b760242b2fc;
"use strict";
$0b87ff774e916008$export$efe19b760242b2fc = $0b87ff774e916008$var$getWeek;

var $kMovx = parcelRequire("kMovx");

var $dembC = parcelRequire("dembC");

var $bz05S = parcelRequire("bz05S");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $0b87ff774e916008$var$getWeek(date, options) {
    const _date = (0, $7NYl1.toDate)(date);
    const diff = +(0, $dembC.startOfWeek)(_date, options) - +(0, $bz05S.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $kMovx.millisecondsInWeek) + 1;
}

});
parcelRegister("bz05S", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $86b309354f1e9a7f$export$bb7b45bb8e74da0f; }, function (v) { return $86b309354f1e9a7f$export$bb7b45bb8e74da0f = v; });
var $86b309354f1e9a7f$export$bb7b45bb8e74da0f;
"use strict";
$86b309354f1e9a7f$export$bb7b45bb8e74da0f = $86b309354f1e9a7f$var$startOfWeekYear;

var $5viJK = parcelRequire("5viJK");

var $7Fdrm = parcelRequire("7Fdrm");

var $dembC = parcelRequire("dembC");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $86b309354f1e9a7f$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $7Fdrm.getWeekYear)(date, options);
    const firstWeek = (0, $5viJK.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $dembC.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("7Fdrm", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $5946c9b104b217dc$export$12d572480ceb6e58; }, function (v) { return $5946c9b104b217dc$export$12d572480ceb6e58 = v; });
var $5946c9b104b217dc$export$12d572480ceb6e58;
"use strict";
$5946c9b104b217dc$export$12d572480ceb6e58 = $5946c9b104b217dc$var$getWeekYear;

var $5viJK = parcelRequire("5viJK");

var $dembC = parcelRequire("dembC");

var $7NYl1 = parcelRequire("7NYl1");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $5946c9b104b217dc$var$getWeekYear(date, options) {
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $5viJK.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $dembC.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $5viJK.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $dembC.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("fx1dE", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", function () { return $b4eae2318c87ac5a$export$c8306e720e213c0f; }, function (v) { return $b4eae2318c87ac5a$export$c8306e720e213c0f = v; });
var $b4eae2318c87ac5a$export$c8306e720e213c0f;
"use strict";
$b4eae2318c87ac5a$export$c8306e720e213c0f = $b4eae2318c87ac5a$var$addLeadingZeros;
function $b4eae2318c87ac5a$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("lP0sG", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", function () { return $fe2eb81366a02ea7$export$b0d4b338e1516f13; }, function (v) { return $fe2eb81366a02ea7$export$b0d4b338e1516f13 = v; });
var $fe2eb81366a02ea7$export$b0d4b338e1516f13;
"use strict";
$fe2eb81366a02ea7$export$b0d4b338e1516f13 = void 0;

var $fx1dE = parcelRequire("fx1dE");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $fe2eb81366a02ea7$var$lightFormatters = $fe2eb81366a02ea7$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $fx1dE.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $fx1dE.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $fx1dE.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $fx1dE.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $fx1dE.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $fx1dE.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $fx1dE.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $fx1dE.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("3jJeP", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $26a63cca1e1ae834$export$70cc8fd02856fd58; }, function (v) { return $26a63cca1e1ae834$export$70cc8fd02856fd58 = v; });
var $26a63cca1e1ae834$export$70cc8fd02856fd58;
"use strict";
$26a63cca1e1ae834$export$70cc8fd02856fd58 = void 0;
const $26a63cca1e1ae834$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $26a63cca1e1ae834$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $26a63cca1e1ae834$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $26a63cca1e1ae834$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $26a63cca1e1ae834$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $26a63cca1e1ae834$var$timeLongFormatter(timePattern, formatLong));
};
const $26a63cca1e1ae834$var$longFormatters = $26a63cca1e1ae834$export$70cc8fd02856fd58 = {
    p: $26a63cca1e1ae834$var$timeLongFormatter,
    P: $26a63cca1e1ae834$var$dateTimeLongFormatter
};

});

parcelRegister("abYtk", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $76b9d6ef07205d19$export$c6cc36aa33304772; }, function (v) { return $76b9d6ef07205d19$export$c6cc36aa33304772 = v; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $76b9d6ef07205d19$export$c6b49d6dceb604a1; }, function (v) { return $76b9d6ef07205d19$export$c6b49d6dceb604a1 = v; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $76b9d6ef07205d19$export$f5f38f90ecaaf879; }, function (v) { return $76b9d6ef07205d19$export$f5f38f90ecaaf879 = v; });
var $76b9d6ef07205d19$export$c6cc36aa33304772;
var $76b9d6ef07205d19$export$c6b49d6dceb604a1;
var $76b9d6ef07205d19$export$f5f38f90ecaaf879;
"use strict";
$76b9d6ef07205d19$export$c6cc36aa33304772 = $76b9d6ef07205d19$var$isProtectedDayOfYearToken;
$76b9d6ef07205d19$export$c6b49d6dceb604a1 = $76b9d6ef07205d19$var$isProtectedWeekYearToken;
$76b9d6ef07205d19$export$f5f38f90ecaaf879 = $76b9d6ef07205d19$var$warnOrThrowProtectedError;
const $76b9d6ef07205d19$var$dayOfYearTokenRE = /^D+$/;
const $76b9d6ef07205d19$var$weekYearTokenRE = /^Y+$/;
const $76b9d6ef07205d19$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $76b9d6ef07205d19$var$isProtectedDayOfYearToken(token) {
    return $76b9d6ef07205d19$var$dayOfYearTokenRE.test(token);
}
function $76b9d6ef07205d19$var$isProtectedWeekYearToken(token) {
    return $76b9d6ef07205d19$var$weekYearTokenRE.test(token);
}
function $76b9d6ef07205d19$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $76b9d6ef07205d19$var$message(token, format, input);
    console.warn(_message);
    if ($76b9d6ef07205d19$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $76b9d6ef07205d19$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});


parcelRegister("9VdIH", function(module, exports) {

$parcel$export(module.exports, "addMinutes", function () { return $7394146ace375635$export$2287e3d29250119e; }, function (v) { return $7394146ace375635$export$2287e3d29250119e = v; });
var $7394146ace375635$export$2287e3d29250119e;
"use strict";
$7394146ace375635$export$2287e3d29250119e = $7394146ace375635$var$addMinutes;

var $32aF3 = parcelRequire("32aF3");

var $kMovx = parcelRequire("kMovx");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $7394146ace375635$var$addMinutes(date, amount) {
    return (0, $32aF3.addMilliseconds)(date, amount * $kMovx.millisecondsInMinute);
}

});
parcelRegister("32aF3", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", function () { return $2359d41992888751$export$baf757aaf0c95c94; }, function (v) { return $2359d41992888751$export$baf757aaf0c95c94 = v; });
var $2359d41992888751$export$baf757aaf0c95c94;
"use strict";
$2359d41992888751$export$baf757aaf0c95c94 = $2359d41992888751$var$addMilliseconds;

var $7NYl1 = parcelRequire("7NYl1");

var $5viJK = parcelRequire("5viJK");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $2359d41992888751$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $7NYl1.toDate)(date);
    return (0, $5viJK.constructFrom)(date, timestamp + amount);
}

});


parcelRegister("lk4ac", function(module, exports) {

$parcel$export(module.exports, "addHours", function () { return $f85eb206556bd0b2$export$4a4306ad4fa0e5e6; }, function (v) { return $f85eb206556bd0b2$export$4a4306ad4fa0e5e6 = v; });
var $f85eb206556bd0b2$export$4a4306ad4fa0e5e6;
"use strict";
$f85eb206556bd0b2$export$4a4306ad4fa0e5e6 = $f85eb206556bd0b2$var$addHours;

var $32aF3 = parcelRequire("32aF3");

var $kMovx = parcelRequire("kMovx");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $f85eb206556bd0b2$var$addHours(date, amount) {
    return (0, $32aF3.addMilliseconds)(date, amount * $kMovx.millisecondsInHour);
}

});

parcelRegister("2vrAW", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $1d33e1c847aedd23$export$dd412b56f1e4d8aa; }, function (v) { return $1d33e1c847aedd23$export$dd412b56f1e4d8aa = v; });
var $1d33e1c847aedd23$export$dd412b56f1e4d8aa;
"use strict";
$1d33e1c847aedd23$export$dd412b56f1e4d8aa = $1d33e1c847aedd23$var$addDays;

var $7NYl1 = parcelRequire("7NYl1");

var $5viJK = parcelRequire("5viJK");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $1d33e1c847aedd23$var$addDays(date, amount) {
    const _date = (0, $7NYl1.toDate)(date);
    if (isNaN(amount)) return (0, $5viJK.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});

parcelRegister("1hExc", function(module, exports) {

$parcel$export(module.exports, "addWeeks", function () { return $0ef6d244185abae7$export$ef501a2bb4f3ee6b; }, function (v) { return $0ef6d244185abae7$export$ef501a2bb4f3ee6b = v; });
var $0ef6d244185abae7$export$ef501a2bb4f3ee6b;
"use strict";
$0ef6d244185abae7$export$ef501a2bb4f3ee6b = $0ef6d244185abae7$var$addWeeks;

var $2vrAW = parcelRequire("2vrAW");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $0ef6d244185abae7$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $2vrAW.addDays)(date, days);
}

});

parcelRegister("1uoU9", function(module, exports) {

$parcel$export(module.exports, "addMonths", function () { return $115be958d85233d5$export$17c93e242b2d3a22; }, function (v) { return $115be958d85233d5$export$17c93e242b2d3a22 = v; });
var $115be958d85233d5$export$17c93e242b2d3a22;
"use strict";
$115be958d85233d5$export$17c93e242b2d3a22 = $115be958d85233d5$var$addMonths;

var $7NYl1 = parcelRequire("7NYl1");

var $5viJK = parcelRequire("5viJK");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $115be958d85233d5$var$addMonths(date, amount) {
    const _date = (0, $7NYl1.toDate)(date);
    if (isNaN(amount)) return (0, $5viJK.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $5viJK.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});

parcelRegister("ejkpp", function(module, exports) {

$parcel$export(module.exports, "addQuarters", function () { return $a6b2abc92271d4fe$export$c252a41d0fbed2ce; }, function (v) { return $a6b2abc92271d4fe$export$c252a41d0fbed2ce = v; });
var $a6b2abc92271d4fe$export$c252a41d0fbed2ce;
"use strict";
$a6b2abc92271d4fe$export$c252a41d0fbed2ce = $a6b2abc92271d4fe$var$addQuarters;

var $1uoU9 = parcelRequire("1uoU9");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $a6b2abc92271d4fe$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $1uoU9.addMonths)(date, months);
}

});

parcelRegister("bvEuC", function(module, exports) {

$parcel$export(module.exports, "addYears", function () { return $86120002810a4419$export$3d83eec43f4ea476; }, function (v) { return $86120002810a4419$export$3d83eec43f4ea476 = v; });
var $86120002810a4419$export$3d83eec43f4ea476;
"use strict";
$86120002810a4419$export$3d83eec43f4ea476 = $86120002810a4419$var$addYears;

var $1uoU9 = parcelRequire("1uoU9");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $86120002810a4419$var$addYears(date, amount) {
    return (0, $1uoU9.addMonths)(date, amount * 12);
}

});

parcelRegister("5BZWP", function(module, exports) {

$parcel$export(module.exports, "subDays", function () { return $41607602d20f7794$export$70823084e2deb1ea; }, function (v) { return $41607602d20f7794$export$70823084e2deb1ea = v; });
var $41607602d20f7794$export$70823084e2deb1ea;
"use strict";
$41607602d20f7794$export$70823084e2deb1ea = $41607602d20f7794$var$subDays;

var $2vrAW = parcelRequire("2vrAW");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $41607602d20f7794$var$subDays(date, amount) {
    return (0, $2vrAW.addDays)(date, -amount);
}

});

parcelRegister("4YyMs", function(module, exports) {

$parcel$export(module.exports, "subWeeks", function () { return $39f7beb214135767$export$b4d8ae6376193efb; }, function (v) { return $39f7beb214135767$export$b4d8ae6376193efb = v; });
var $39f7beb214135767$export$b4d8ae6376193efb;
"use strict";
$39f7beb214135767$export$b4d8ae6376193efb = $39f7beb214135767$var$subWeeks;

var $1hExc = parcelRequire("1hExc");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $39f7beb214135767$var$subWeeks(date, amount) {
    return (0, $1hExc.addWeeks)(date, -amount);
}

});

parcelRegister("baGWJ", function(module, exports) {

$parcel$export(module.exports, "subMonths", function () { return $8221f120961da5e2$export$73d1c15a21f9fae5; }, function (v) { return $8221f120961da5e2$export$73d1c15a21f9fae5 = v; });
var $8221f120961da5e2$export$73d1c15a21f9fae5;
"use strict";
$8221f120961da5e2$export$73d1c15a21f9fae5 = $8221f120961da5e2$var$subMonths;

var $1uoU9 = parcelRequire("1uoU9");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $8221f120961da5e2$var$subMonths(date, amount) {
    return (0, $1uoU9.addMonths)(date, -amount);
}

});

parcelRegister("ba81a", function(module, exports) {

$parcel$export(module.exports, "subQuarters", function () { return $8206d909777a3a10$export$a31bfeeeee80cce6; }, function (v) { return $8206d909777a3a10$export$a31bfeeeee80cce6 = v; });
var $8206d909777a3a10$export$a31bfeeeee80cce6;
"use strict";
$8206d909777a3a10$export$a31bfeeeee80cce6 = $8206d909777a3a10$var$subQuarters;

var $ejkpp = parcelRequire("ejkpp");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $8206d909777a3a10$var$subQuarters(date, amount) {
    return (0, $ejkpp.addQuarters)(date, -amount);
}

});

parcelRegister("aZjqa", function(module, exports) {

$parcel$export(module.exports, "subYears", function () { return $7ffeaa842c09154a$export$14867687ff6c92e2; }, function (v) { return $7ffeaa842c09154a$export$14867687ff6c92e2 = v; });
var $7ffeaa842c09154a$export$14867687ff6c92e2;
"use strict";
$7ffeaa842c09154a$export$14867687ff6c92e2 = $7ffeaa842c09154a$var$subYears;

var $bvEuC = parcelRequire("bvEuC");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $7ffeaa842c09154a$var$subYears(date, amount) {
    return (0, $bvEuC.addYears)(date, -amount);
}

});

parcelRegister("cDEq1", function(module, exports) {

$parcel$export(module.exports, "getSeconds", function () { return $93387ae472314a49$export$5e9417507ff28427; }, function (v) { return $93387ae472314a49$export$5e9417507ff28427 = v; });
var $93387ae472314a49$export$5e9417507ff28427;
"use strict";
$93387ae472314a49$export$5e9417507ff28427 = $93387ae472314a49$var$getSeconds;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $93387ae472314a49$var$getSeconds(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("lvYCh", function(module, exports) {

$parcel$export(module.exports, "getMinutes", function () { return $fa9b83681233f475$export$b7f1bc3ea3ac4145; }, function (v) { return $fa9b83681233f475$export$b7f1bc3ea3ac4145 = v; });
var $fa9b83681233f475$export$b7f1bc3ea3ac4145;
"use strict";
$fa9b83681233f475$export$b7f1bc3ea3ac4145 = $fa9b83681233f475$var$getMinutes;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $fa9b83681233f475$var$getMinutes(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("lk486", function(module, exports) {

$parcel$export(module.exports, "getHours", function () { return $f85eab4aa3e7b107$export$257b40f71c07d58f; }, function (v) { return $f85eab4aa3e7b107$export$257b40f71c07d58f = v; });
var $f85eab4aa3e7b107$export$257b40f71c07d58f;
"use strict";
$f85eab4aa3e7b107$export$257b40f71c07d58f = $f85eab4aa3e7b107$var$getHours;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $f85eab4aa3e7b107$var$getHours(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("7Vb0N", function(module, exports) {

$parcel$export(module.exports, "getDay", function () { return $5c46660169889714$export$1b64bc9c5306ed54; }, function (v) { return $5c46660169889714$export$1b64bc9c5306ed54 = v; });
var $5c46660169889714$export$1b64bc9c5306ed54;
"use strict";
$5c46660169889714$export$1b64bc9c5306ed54 = $5c46660169889714$var$getDay;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $5c46660169889714$var$getDay(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRegister("4sou0", function(module, exports) {

$parcel$export(module.exports, "getDate", function () { return $33ecc4c33da95376$export$aa350b96d91cd94; }, function (v) { return $33ecc4c33da95376$export$aa350b96d91cd94 = v; });
var $33ecc4c33da95376$export$aa350b96d91cd94;
"use strict";
$33ecc4c33da95376$export$aa350b96d91cd94 = $33ecc4c33da95376$var$getDate;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $33ecc4c33da95376$var$getDate(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("7ivcB", function(module, exports) {

$parcel$export(module.exports, "getMonth", function () { return $55026af32f78bc19$export$6ce1b5acc29cb53b; }, function (v) { return $55026af32f78bc19$export$6ce1b5acc29cb53b = v; });
var $55026af32f78bc19$export$6ce1b5acc29cb53b;
"use strict";
$55026af32f78bc19$export$6ce1b5acc29cb53b = $55026af32f78bc19$var$getMonth;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $55026af32f78bc19$var$getMonth(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("gTkms", function(module, exports) {

$parcel$export(module.exports, "getQuarter", function () { return $c4c193af2d76bb71$export$de90a4bb31c25221; }, function (v) { return $c4c193af2d76bb71$export$de90a4bb31c25221 = v; });
var $c4c193af2d76bb71$export$de90a4bb31c25221;
"use strict";
$c4c193af2d76bb71$export$de90a4bb31c25221 = $c4c193af2d76bb71$var$getQuarter;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $c4c193af2d76bb71$var$getQuarter(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("d8MXz", function(module, exports) {

$parcel$export(module.exports, "getYear", function () { return $991200200ccc3510$export$5846dc2d57a5c860; }, function (v) { return $991200200ccc3510$export$5846dc2d57a5c860 = v; });
var $991200200ccc3510$export$5846dc2d57a5c860;
"use strict";
$991200200ccc3510$export$5846dc2d57a5c860 = $991200200ccc3510$var$getYear;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $991200200ccc3510$var$getYear(date) {
    return (0, $7NYl1.toDate)(date).getFullYear();
}

});

parcelRegister("bUKY3", function(module, exports) {

$parcel$export(module.exports, "getTime", function () { return $8ac95b772c6a54a1$export$1428f42a7de81803; }, function (v) { return $8ac95b772c6a54a1$export$1428f42a7de81803 = v; });
var $8ac95b772c6a54a1$export$1428f42a7de81803;
"use strict";
$8ac95b772c6a54a1$export$1428f42a7de81803 = $8ac95b772c6a54a1$var$getTime;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $8ac95b772c6a54a1$var$getTime(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRegister("6dtTI", function(module, exports) {

$parcel$export(module.exports, "setSeconds", function () { return $486b260aec704b0a$export$aec44746644cbf43; }, function (v) { return $486b260aec704b0a$export$aec44746644cbf43 = v; });
var $486b260aec704b0a$export$aec44746644cbf43;
"use strict";
$486b260aec704b0a$export$aec44746644cbf43 = $486b260aec704b0a$var$setSeconds;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $486b260aec704b0a$var$setSeconds(date, seconds) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("kMcoB", function(module, exports) {

$parcel$export(module.exports, "setMinutes", function () { return $f201e7ea6d4722fc$export$ad569bf1c79ea89d; }, function (v) { return $f201e7ea6d4722fc$export$ad569bf1c79ea89d = v; });
var $f201e7ea6d4722fc$export$ad569bf1c79ea89d;
"use strict";
$f201e7ea6d4722fc$export$ad569bf1c79ea89d = $f201e7ea6d4722fc$var$setMinutes;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $f201e7ea6d4722fc$var$setMinutes(date, minutes) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("uw6ye", function(module, exports) {

$parcel$export(module.exports, "setHours", function () { return $05bbb4c6382d0d7f$export$f86b797a4659b781; }, function (v) { return $05bbb4c6382d0d7f$export$f86b797a4659b781 = v; });
var $05bbb4c6382d0d7f$export$f86b797a4659b781;
"use strict";
$05bbb4c6382d0d7f$export$f86b797a4659b781 = $05bbb4c6382d0d7f$var$setHours;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $05bbb4c6382d0d7f$var$setHours(date, hours) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("lf7yb", function(module, exports) {

$parcel$export(module.exports, "setMonth", function () { return $f770db0bc8416fd8$export$63264690f8e36790; }, function (v) { return $f770db0bc8416fd8$export$63264690f8e36790 = v; });
var $f770db0bc8416fd8$export$63264690f8e36790;
"use strict";
$f770db0bc8416fd8$export$63264690f8e36790 = $f770db0bc8416fd8$var$setMonth;

var $5viJK = parcelRequire("5viJK");

var $3GcQZ = parcelRequire("3GcQZ");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $f770db0bc8416fd8$var$setMonth(date, month) {
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $5viJK.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $3GcQZ.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});
parcelRegister("3GcQZ", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", function () { return $2adf43d0191e9805$export$f645ddd439eb259d; }, function (v) { return $2adf43d0191e9805$export$f645ddd439eb259d = v; });
var $2adf43d0191e9805$export$f645ddd439eb259d;
"use strict";
$2adf43d0191e9805$export$f645ddd439eb259d = $2adf43d0191e9805$var$getDaysInMonth;

var $7NYl1 = parcelRequire("7NYl1");

var $5viJK = parcelRequire("5viJK");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $2adf43d0191e9805$var$getDaysInMonth(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $5viJK.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("g5M5t", function(module, exports) {

$parcel$export(module.exports, "setQuarter", function () { return $bb726a1b48e0ba29$export$8924d1de7efe1755; }, function (v) { return $bb726a1b48e0ba29$export$8924d1de7efe1755 = v; });
var $bb726a1b48e0ba29$export$8924d1de7efe1755;
"use strict";
$bb726a1b48e0ba29$export$8924d1de7efe1755 = $bb726a1b48e0ba29$var$setQuarter;

var $lf7yb = parcelRequire("lf7yb");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $bb726a1b48e0ba29$var$setQuarter(date, quarter) {
    const _date = (0, $7NYl1.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $lf7yb.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRegister("fgH89", function(module, exports) {

$parcel$export(module.exports, "setYear", function () { return $b1d9ce77e9bf6088$export$a8408b6c5639cab7; }, function (v) { return $b1d9ce77e9bf6088$export$a8408b6c5639cab7 = v; });
var $b1d9ce77e9bf6088$export$a8408b6c5639cab7;
"use strict";
$b1d9ce77e9bf6088$export$a8408b6c5639cab7 = $b1d9ce77e9bf6088$var$setYear;

var $5viJK = parcelRequire("5viJK");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $b1d9ce77e9bf6088$var$setYear(date, year) {
    const _date = (0, $7NYl1.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $5viJK.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("dczK0", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $99c81ecb18c85bfd$export$96ec731ed4dcb222; }, function (v) { return $99c81ecb18c85bfd$export$96ec731ed4dcb222 = v; });
var $99c81ecb18c85bfd$export$96ec731ed4dcb222;
"use strict";
$99c81ecb18c85bfd$export$96ec731ed4dcb222 = $99c81ecb18c85bfd$var$min;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $99c81ecb18c85bfd$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $7NYl1.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});

parcelRegister("7nRuI", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $56042d40cd6e8719$export$8960430cfd85939f; }, function (v) { return $56042d40cd6e8719$export$8960430cfd85939f = v; });
var $56042d40cd6e8719$export$8960430cfd85939f;
"use strict";
$56042d40cd6e8719$export$8960430cfd85939f = $56042d40cd6e8719$var$max;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $56042d40cd6e8719$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $7NYl1.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("8pkT1", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", function () { return $61f0dc2a6d722ea8$export$489984ac7c996389; }, function (v) { return $61f0dc2a6d722ea8$export$489984ac7c996389 = v; });
var $61f0dc2a6d722ea8$export$489984ac7c996389;
"use strict";
$61f0dc2a6d722ea8$export$489984ac7c996389 = $61f0dc2a6d722ea8$var$differenceInCalendarMonths;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $61f0dc2a6d722ea8$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("8EzaS", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", function () { return $64cd581628a03a53$export$c06dce8b38891685; }, function (v) { return $64cd581628a03a53$export$c06dce8b38891685 = v; });
var $64cd581628a03a53$export$c06dce8b38891685;
"use strict";
$64cd581628a03a53$export$c06dce8b38891685 = $64cd581628a03a53$var$differenceInCalendarYears;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $64cd581628a03a53$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRegister("lesSB", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", function () { return $f7514eaff42425af$export$f62ae9fb13958c7a; }, function (v) { return $f7514eaff42425af$export$f62ae9fb13958c7a = v; });
var $f7514eaff42425af$export$f62ae9fb13958c7a;
"use strict";
$f7514eaff42425af$export$f62ae9fb13958c7a = $f7514eaff42425af$var$differenceInCalendarQuarters;

var $gTkms = parcelRequire("gTkms");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $f7514eaff42425af$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $gTkms.getQuarter)(_dateLeft) - (0, $gTkms.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});

parcelRegister("fNVra", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", function () { return $b817fc75bd2156d6$export$a5a3b454ada2268e; }, function (v) { return $b817fc75bd2156d6$export$a5a3b454ada2268e = v; });
var $b817fc75bd2156d6$export$a5a3b454ada2268e;
"use strict";
$b817fc75bd2156d6$export$a5a3b454ada2268e = $b817fc75bd2156d6$var$startOfMonth;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $b817fc75bd2156d6$var$startOfMonth(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("5tBn0", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", function () { return $3fcca615fe962cc4$export$69be7267a042ecb3; }, function (v) { return $3fcca615fe962cc4$export$69be7267a042ecb3 = v; });
var $3fcca615fe962cc4$export$69be7267a042ecb3;
"use strict";
$3fcca615fe962cc4$export$69be7267a042ecb3 = $3fcca615fe962cc4$var$startOfQuarter;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $3fcca615fe962cc4$var$startOfQuarter(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("exWqC", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $a97178661cb08bd0$export$eb9a03f0e9aa6cea; }, function (v) { return $a97178661cb08bd0$export$eb9a03f0e9aa6cea = v; });
var $a97178661cb08bd0$export$eb9a03f0e9aa6cea;
"use strict";
$a97178661cb08bd0$export$eb9a03f0e9aa6cea = $a97178661cb08bd0$var$endOfDay;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $a97178661cb08bd0$var$endOfDay(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("8mcDi", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", function () { return $615a2d6cdac04b50$export$ef8b6d9133084f4e; }, function (v) { return $615a2d6cdac04b50$export$ef8b6d9133084f4e = v; });
var $615a2d6cdac04b50$export$ef8b6d9133084f4e;
"use strict";
$615a2d6cdac04b50$export$ef8b6d9133084f4e = $615a2d6cdac04b50$var$endOfWeek;

var $7NYl1 = parcelRequire("7NYl1");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $615a2d6cdac04b50$var$endOfWeek(date, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7NYl1.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("lVNbV", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $ff751439564d5796$export$a2258d9c4118825c; }, function (v) { return $ff751439564d5796$export$a2258d9c4118825c = v; });
var $ff751439564d5796$export$a2258d9c4118825c;
"use strict";
$ff751439564d5796$export$a2258d9c4118825c = $ff751439564d5796$var$endOfMonth;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $ff751439564d5796$var$endOfMonth(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("72tdj", function(module, exports) {

$parcel$export(module.exports, "endOfYear", function () { return $51ff618a37fbb6c3$export$8b7aa55c66d5569e; }, function (v) { return $51ff618a37fbb6c3$export$8b7aa55c66d5569e = v; });
var $51ff618a37fbb6c3$export$8b7aa55c66d5569e;
"use strict";
$51ff618a37fbb6c3$export$8b7aa55c66d5569e = $51ff618a37fbb6c3$var$endOfYear;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $51ff618a37fbb6c3$var$endOfYear(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("ky24C", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $ef58975b1cae8412$export$248d38f6296296c5; }, function (v) { return $ef58975b1cae8412$export$248d38f6296296c5 = v; });
var $ef58975b1cae8412$export$248d38f6296296c5;
"use strict";
$ef58975b1cae8412$export$248d38f6296296c5 = $ef58975b1cae8412$var$isEqual;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $ef58975b1cae8412$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $7NYl1.toDate)(leftDate);
    const _dateRight = (0, $7NYl1.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("73v8c", function(module, exports) {

$parcel$export(module.exports, "isSameDay", function () { return $5230f63fe19c9dff$export$ea39ec197993aef0; }, function (v) { return $5230f63fe19c9dff$export$ea39ec197993aef0 = v; });
var $5230f63fe19c9dff$export$ea39ec197993aef0;
"use strict";
$5230f63fe19c9dff$export$ea39ec197993aef0 = $5230f63fe19c9dff$var$isSameDay;

var $ePNEc = parcelRequire("ePNEc");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $5230f63fe19c9dff$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $ePNEc.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $ePNEc.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("9qPPc", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", function () { return $6ddebe15d9b20ac9$export$a18c89cbd24170ff; }, function (v) { return $6ddebe15d9b20ac9$export$a18c89cbd24170ff = v; });
var $6ddebe15d9b20ac9$export$a18c89cbd24170ff;
"use strict";
$6ddebe15d9b20ac9$export$a18c89cbd24170ff = $6ddebe15d9b20ac9$var$isSameMonth;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $6ddebe15d9b20ac9$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("82gj4", function(module, exports) {

$parcel$export(module.exports, "isSameYear", function () { return $5d9b28cc1eee24e1$export$5841f9eb9773f25f; }, function (v) { return $5d9b28cc1eee24e1$export$5841f9eb9773f25f = v; });
var $5d9b28cc1eee24e1$export$5841f9eb9773f25f;
"use strict";
$5d9b28cc1eee24e1$export$5841f9eb9773f25f = $5d9b28cc1eee24e1$var$isSameYear;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $5d9b28cc1eee24e1$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("g5oPq", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", function () { return $bb605f6734502faa$export$5c60e4190867161c; }, function (v) { return $bb605f6734502faa$export$5c60e4190867161c = v; });
var $bb605f6734502faa$export$5c60e4190867161c;
"use strict";
$bb605f6734502faa$export$5c60e4190867161c = $bb605f6734502faa$var$isSameQuarter;

var $5tBn0 = parcelRequire("5tBn0");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $bb605f6734502faa$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $5tBn0.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $5tBn0.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});

parcelRegister("7s5Ss", function(module, exports) {

$parcel$export(module.exports, "isAfter", function () { return $56cfb5124d08cd46$export$e4de839670987035; }, function (v) { return $56cfb5124d08cd46$export$e4de839670987035 = v; });
var $56cfb5124d08cd46$export$e4de839670987035;
"use strict";
$56cfb5124d08cd46$export$e4de839670987035 = $56cfb5124d08cd46$var$isAfter;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $56cfb5124d08cd46$var$isAfter(date, dateToCompare) {
    const _date = (0, $7NYl1.toDate)(date);
    const _dateToCompare = (0, $7NYl1.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("fLOXb", function(module, exports) {

$parcel$export(module.exports, "isBefore", function () { return $b7b2c519b4b5b2de$export$5c007e10c6929c95; }, function (v) { return $b7b2c519b4b5b2de$export$5c007e10c6929c95 = v; });
var $b7b2c519b4b5b2de$export$5c007e10c6929c95;
"use strict";
$b7b2c519b4b5b2de$export$5c007e10c6929c95 = $b7b2c519b4b5b2de$var$isBefore;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $b7b2c519b4b5b2de$var$isBefore(date, dateToCompare) {
    const _date = (0, $7NYl1.toDate)(date);
    const _dateToCompare = (0, $7NYl1.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("flwHs", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", function () { return $b2c22eb65b693686$export$d7deef7a3738e19d; }, function (v) { return $b2c22eb65b693686$export$d7deef7a3738e19d = v; });
var $b2c22eb65b693686$export$d7deef7a3738e19d;
"use strict";
$b2c22eb65b693686$export$d7deef7a3738e19d = $b2c22eb65b693686$var$isWithinInterval;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $b2c22eb65b693686$var$isWithinInterval(date, interval) {
    const time = +(0, $7NYl1.toDate)(date);
    const [startTime, endTime] = [
        +(0, $7NYl1.toDate)(interval.start),
        +(0, $7NYl1.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("l1Ixk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $3jJeP.longFormatters;
    }
});
module.exports.parse = $f4ec3d0195ab8103$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $aX84T.parsers;
    }
});

var $5viJK = parcelRequire("5viJK");

var $5Ew7Y = parcelRequire("5Ew7Y");

var $s26wx = parcelRequire("s26wx");

var $7NYl1 = parcelRequire("7NYl1");

var $3jJeP = parcelRequire("3jJeP");

var $abYtk = parcelRequire("abYtk");

var $aX84T = parcelRequire("aX84T");

var $kYGOe = parcelRequire("kYGOe");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $f4ec3d0195ab8103$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $f4ec3d0195ab8103$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $f4ec3d0195ab8103$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $f4ec3d0195ab8103$var$doubleQuoteRegExp = /''/g;
const $f4ec3d0195ab8103$var$notWhitespaceRegExp = /\S/;
const $f4ec3d0195ab8103$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $f4ec3d0195ab8103$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $5Ew7Y.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $s26wx.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $7NYl1.toDate)(referenceDate);
        else return (0, $5viJK.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $kYGOe.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($f4ec3d0195ab8103$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $3jJeP.longFormatters) {
            const longFormatter = $3jJeP.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($f4ec3d0195ab8103$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $abYtk.isProtectedWeekYearToken)(token)) (0, $abYtk.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $abYtk.isProtectedDayOfYearToken)(token)) (0, $abYtk.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $aX84T.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $5viJK.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($f4ec3d0195ab8103$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $f4ec3d0195ab8103$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $5viJK.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $f4ec3d0195ab8103$var$notWhitespaceRegExp.test(dateStr)) return (0, $5viJK.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $7NYl1.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $5viJK.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $5viJK.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $5viJK.constructFrom)(referenceDate, date);
}
function $f4ec3d0195ab8103$var$cleanEscapedString(input) {
    return input.match($f4ec3d0195ab8103$var$escapedStringRegExp)[1].replace($f4ec3d0195ab8103$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("5Ew7Y", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $41d99c1010b4fd16$export$430a3269e24b912e; }, function (v) { return $41d99c1010b4fd16$export$430a3269e24b912e = v; });
var $41d99c1010b4fd16$export$430a3269e24b912e;
"use strict";
$41d99c1010b4fd16$export$430a3269e24b912e = $41d99c1010b4fd16$var$getDefaultOptions;

var $f8DjC = parcelRequire("f8DjC");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $41d99c1010b4fd16$var$getDefaultOptions() {
    return Object.assign({}, (0, $f8DjC.getDefaultOptions)());
}

});

parcelRegister("aX84T", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $7f95ae2c4f0cf936$export$19131010e7fd8373; }, function (v) { return $7f95ae2c4f0cf936$export$19131010e7fd8373 = v; });
var $7f95ae2c4f0cf936$export$19131010e7fd8373;
"use strict";
$7f95ae2c4f0cf936$export$19131010e7fd8373 = void 0;

var $8ZAWj = parcelRequire("8ZAWj");

var $jHQPs = parcelRequire("jHQPs");

var $6Xr5L = parcelRequire("6Xr5L");

var $5kaJe = parcelRequire("5kaJe");

var $1js2g = parcelRequire("1js2g");

var $3KoRW = parcelRequire("3KoRW");

var $aELFk = parcelRequire("aELFk");

var $98PWb = parcelRequire("98PWb");

var $dGEpI = parcelRequire("dGEpI");

var $86sQA = parcelRequire("86sQA");

var $87CWo = parcelRequire("87CWo");

var $jxl9D = parcelRequire("jxl9D");

var $eFXnS = parcelRequire("eFXnS");

var $8DmyD = parcelRequire("8DmyD");

var $58AMJ = parcelRequire("58AMJ");

var $9bWOj = parcelRequire("9bWOj");

var $izc6U = parcelRequire("izc6U");

var $lgE3E = parcelRequire("lgE3E");

var $3qYlp = parcelRequire("3qYlp");

var $eVXsF = parcelRequire("eVXsF");

var $iZWkC = parcelRequire("iZWkC");

var $cXcxC = parcelRequire("cXcxC");

var $3oHES = parcelRequire("3oHES");

var $aQ4fD = parcelRequire("aQ4fD");

var $48ebK = parcelRequire("48ebK");

var $83hfR = parcelRequire("83hfR");

var $eeFkR = parcelRequire("eeFkR");

var $7VFNK = parcelRequire("7VFNK");

var $kFulo = parcelRequire("kFulo");

var $56zUZ = parcelRequire("56zUZ");

var $dcenz = parcelRequire("dcenz");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $7f95ae2c4f0cf936$var$parsers = $7f95ae2c4f0cf936$export$19131010e7fd8373 = {
    G: new $8ZAWj.EraParser(),
    y: new $jHQPs.YearParser(),
    Y: new $6Xr5L.LocalWeekYearParser(),
    R: new $5kaJe.ISOWeekYearParser(),
    u: new $1js2g.ExtendedYearParser(),
    Q: new $3KoRW.QuarterParser(),
    q: new $aELFk.StandAloneQuarterParser(),
    M: new $98PWb.MonthParser(),
    L: new $dGEpI.StandAloneMonthParser(),
    w: new $86sQA.LocalWeekParser(),
    I: new $87CWo.ISOWeekParser(),
    d: new $jxl9D.DateParser(),
    D: new $eFXnS.DayOfYearParser(),
    E: new $8DmyD.DayParser(),
    e: new $58AMJ.LocalDayParser(),
    c: new $9bWOj.StandAloneLocalDayParser(),
    i: new $izc6U.ISODayParser(),
    a: new $lgE3E.AMPMParser(),
    b: new $3qYlp.AMPMMidnightParser(),
    B: new $eVXsF.DayPeriodParser(),
    h: new $iZWkC.Hour1to12Parser(),
    H: new $cXcxC.Hour0to23Parser(),
    K: new $3oHES.Hour0To11Parser(),
    k: new $aQ4fD.Hour1To24Parser(),
    m: new $48ebK.MinuteParser(),
    s: new $83hfR.SecondParser(),
    S: new $eeFkR.FractionOfSecondParser(),
    X: new $7VFNK.ISOTimezoneWithZParser(),
    x: new $kFulo.ISOTimezoneParser(),
    t: new $56zUZ.TimestampSecondsParser(),
    T: new $dcenz.TimestampMillisecondsParser()
};

});
parcelRegister("8ZAWj", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $68c0aca5b3264a50$export$8e5a1d3f85a9688; }, function (v) { return $68c0aca5b3264a50$export$8e5a1d3f85a9688 = v; });
var $68c0aca5b3264a50$export$8e5a1d3f85a9688;
"use strict";
$68c0aca5b3264a50$export$8e5a1d3f85a9688 = void 0;

var $fNjoe = parcelRequire("fNjoe");
class $68c0aca5b3264a50$var$EraParser extends $fNjoe.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$68c0aca5b3264a50$export$8e5a1d3f85a9688 = $68c0aca5b3264a50$var$EraParser;

});
parcelRegister("fNjoe", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $b7fa790f7c116745$export$7acfa6ed01010e37; }, function (v) { return $b7fa790f7c116745$export$7acfa6ed01010e37 = v; });
var $b7fa790f7c116745$export$7acfa6ed01010e37;
"use strict";
$b7fa790f7c116745$export$7acfa6ed01010e37 = void 0;

var $kYGOe = parcelRequire("kYGOe");
class $b7fa790f7c116745$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $kYGOe.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$b7fa790f7c116745$export$7acfa6ed01010e37 = $b7fa790f7c116745$var$Parser;

});
parcelRegister("kYGOe", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $f45a9e41dd6960a4$export$9a09e32dd4990fd5; }, function (v) { return $f45a9e41dd6960a4$export$9a09e32dd4990fd5 = v; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $f45a9e41dd6960a4$export$5aaf7ff7f09ea4ee; }, function (v) { return $f45a9e41dd6960a4$export$5aaf7ff7f09ea4ee = v; });
var $f45a9e41dd6960a4$export$9a09e32dd4990fd5;
var $f45a9e41dd6960a4$export$81d53e3678089a6;
var $f45a9e41dd6960a4$export$5aaf7ff7f09ea4ee;
"use strict";
$f45a9e41dd6960a4$export$9a09e32dd4990fd5 = $f45a9e41dd6960a4$export$81d53e3678089a6 = $f45a9e41dd6960a4$export$5aaf7ff7f09ea4ee = void 0;

var $krF3E = parcelRequire("krF3E");

var $5viJK = parcelRequire("5viJK");
const $f45a9e41dd6960a4$var$TIMEZONE_UNIT_PRIORITY = 10;
class $f45a9e41dd6960a4$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$f45a9e41dd6960a4$export$81d53e3678089a6 = $f45a9e41dd6960a4$var$Setter;
class $f45a9e41dd6960a4$var$ValueSetter extends $f45a9e41dd6960a4$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$f45a9e41dd6960a4$export$9a09e32dd4990fd5 = $f45a9e41dd6960a4$var$ValueSetter;
class $f45a9e41dd6960a4$var$DateToSystemTimezoneSetter extends $f45a9e41dd6960a4$var$Setter {
    priority = $f45a9e41dd6960a4$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $5viJK.constructFrom)(date, (0, $krF3E.transpose)(date, Date));
    }
}
$f45a9e41dd6960a4$export$5aaf7ff7f09ea4ee = $f45a9e41dd6960a4$var$DateToSystemTimezoneSetter;

});
parcelRegister("krF3E", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $ee262d7e27e69151$export$9cb09a71b7d66923; }, function (v) { return $ee262d7e27e69151$export$9cb09a71b7d66923 = v; });
var $ee262d7e27e69151$export$9cb09a71b7d66923;
"use strict";
$ee262d7e27e69151$export$9cb09a71b7d66923 = $ee262d7e27e69151$var$transpose;

var $5viJK = parcelRequire("5viJK");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $ee262d7e27e69151$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $5viJK.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("jHQPs", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $e58b0334e7052334$export$48d352de7cd4a988; }, function (v) { return $e58b0334e7052334$export$48d352de7cd4a988 = v; });
var $e58b0334e7052334$export$48d352de7cd4a988;
"use strict";
$e58b0334e7052334$export$48d352de7cd4a988 = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $e58b0334e7052334$var$YearParser extends $fNjoe.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $kgNIv.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $kgNIv.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$e58b0334e7052334$export$48d352de7cd4a988 = $e58b0334e7052334$var$YearParser;

});
parcelRegister("kgNIv", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $ec1bddf9bdcde6bc$export$fb506d2676e7f207; }, function (v) { return $ec1bddf9bdcde6bc$export$fb506d2676e7f207 = v; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $ec1bddf9bdcde6bc$export$3d50627710b84d75; }, function (v) { return $ec1bddf9bdcde6bc$export$3d50627710b84d75 = v; });
$parcel$export(module.exports, "mapValue", function () { return $ec1bddf9bdcde6bc$export$4f84e3a82c7b538; }, function (v) { return $ec1bddf9bdcde6bc$export$4f84e3a82c7b538 = v; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $ec1bddf9bdcde6bc$export$29126f735cbf69f7; }, function (v) { return $ec1bddf9bdcde6bc$export$29126f735cbf69f7 = v; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $ec1bddf9bdcde6bc$export$d931c43c4608a164; }, function (v) { return $ec1bddf9bdcde6bc$export$d931c43c4608a164 = v; });
$parcel$export(module.exports, "parseNDigits", function () { return $ec1bddf9bdcde6bc$export$513bb01536146ab6; }, function (v) { return $ec1bddf9bdcde6bc$export$513bb01536146ab6 = v; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $ec1bddf9bdcde6bc$export$2c9307b2e29c533c; }, function (v) { return $ec1bddf9bdcde6bc$export$2c9307b2e29c533c = v; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $ec1bddf9bdcde6bc$export$cc7cc9e2a3ff9388; }, function (v) { return $ec1bddf9bdcde6bc$export$cc7cc9e2a3ff9388 = v; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $ec1bddf9bdcde6bc$export$6497f4c0ecdfba8e; }, function (v) { return $ec1bddf9bdcde6bc$export$6497f4c0ecdfba8e = v; });
var $ec1bddf9bdcde6bc$export$fb506d2676e7f207;
var $ec1bddf9bdcde6bc$export$3d50627710b84d75;
var $ec1bddf9bdcde6bc$export$4f84e3a82c7b538;
var $ec1bddf9bdcde6bc$export$29126f735cbf69f7;
var $ec1bddf9bdcde6bc$export$d931c43c4608a164;
var $ec1bddf9bdcde6bc$export$513bb01536146ab6;
var $ec1bddf9bdcde6bc$export$2c9307b2e29c533c;
var $ec1bddf9bdcde6bc$export$cc7cc9e2a3ff9388;
var $ec1bddf9bdcde6bc$export$6497f4c0ecdfba8e;
"use strict";
$ec1bddf9bdcde6bc$export$fb506d2676e7f207 = $ec1bddf9bdcde6bc$var$dayPeriodEnumToHours;
$ec1bddf9bdcde6bc$export$3d50627710b84d75 = $ec1bddf9bdcde6bc$var$isLeapYearIndex;
$ec1bddf9bdcde6bc$export$4f84e3a82c7b538 = $ec1bddf9bdcde6bc$var$mapValue;
$ec1bddf9bdcde6bc$export$29126f735cbf69f7 = $ec1bddf9bdcde6bc$var$normalizeTwoDigitYear;
$ec1bddf9bdcde6bc$export$d931c43c4608a164 = $ec1bddf9bdcde6bc$var$parseAnyDigitsSigned;
$ec1bddf9bdcde6bc$export$513bb01536146ab6 = $ec1bddf9bdcde6bc$var$parseNDigits;
$ec1bddf9bdcde6bc$export$2c9307b2e29c533c = $ec1bddf9bdcde6bc$var$parseNDigitsSigned;
$ec1bddf9bdcde6bc$export$cc7cc9e2a3ff9388 = $ec1bddf9bdcde6bc$var$parseNumericPattern;
$ec1bddf9bdcde6bc$export$6497f4c0ecdfba8e = $ec1bddf9bdcde6bc$var$parseTimezonePattern;

var $kMovx = parcelRequire("kMovx");

var $eht9h = parcelRequire("eht9h");
function $ec1bddf9bdcde6bc$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $ec1bddf9bdcde6bc$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $ec1bddf9bdcde6bc$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $kMovx.millisecondsInHour + minutes * $kMovx.millisecondsInMinute + seconds * $kMovx.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $ec1bddf9bdcde6bc$var$parseAnyDigitsSigned(dateString) {
    return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.anyDigitsSigned, dateString);
}
function $ec1bddf9bdcde6bc$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.singleDigit, dateString);
        case 2:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.twoDigits, dateString);
        case 3:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.threeDigits, dateString);
        case 4:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.fourDigits, dateString);
        default:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $ec1bddf9bdcde6bc$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern($eht9h.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $ec1bddf9bdcde6bc$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $ec1bddf9bdcde6bc$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $ec1bddf9bdcde6bc$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $ec1bddf9bdcde6bc$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("eht9h", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", function () { return $a65943847d80cb87$export$a7ee192b982af9c1; }, function (v) { return $a65943847d80cb87$export$a7ee192b982af9c1 = v; });
$parcel$export(module.exports, "numericPatterns", function () { return $a65943847d80cb87$export$c123ee06d9da8480; }, function (v) { return $a65943847d80cb87$export$c123ee06d9da8480 = v; });
var $a65943847d80cb87$export$a7ee192b982af9c1;
var $a65943847d80cb87$export$c123ee06d9da8480;
"use strict";
$a65943847d80cb87$export$a7ee192b982af9c1 = $a65943847d80cb87$export$c123ee06d9da8480 = void 0;
const $a65943847d80cb87$var$numericPatterns = $a65943847d80cb87$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $a65943847d80cb87$var$timezonePatterns = $a65943847d80cb87$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("6Xr5L", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $510d44ac783f95b7$export$b8ef38dfcf05d5db; }, function (v) { return $510d44ac783f95b7$export$b8ef38dfcf05d5db = v; });
var $510d44ac783f95b7$export$b8ef38dfcf05d5db;
"use strict";
$510d44ac783f95b7$export$b8ef38dfcf05d5db = void 0;

var $7Fdrm = parcelRequire("7Fdrm");

var $dembC = parcelRequire("dembC");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// Local week-numbering year
class $510d44ac783f95b7$var$LocalWeekYearParser extends $fNjoe.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $kgNIv.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $7Fdrm.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $kgNIv.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $dembC.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $dembC.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$510d44ac783f95b7$export$b8ef38dfcf05d5db = $510d44ac783f95b7$var$LocalWeekYearParser;

});

parcelRegister("5kaJe", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $3e0724787f547dc5$export$951d1df011fde06f; }, function (v) { return $3e0724787f547dc5$export$951d1df011fde06f = v; });
var $3e0724787f547dc5$export$951d1df011fde06f;
"use strict";
$3e0724787f547dc5$export$951d1df011fde06f = void 0;

var $56Gig = parcelRequire("56Gig");

var $5viJK = parcelRequire("5viJK");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// ISO week-numbering year
class $3e0724787f547dc5$var$ISOWeekYearParser extends $fNjoe.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $kgNIv.parseNDigitsSigned)(4, dateString);
        return (0, $kgNIv.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $5viJK.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $56Gig.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$3e0724787f547dc5$export$951d1df011fde06f = $3e0724787f547dc5$var$ISOWeekYearParser;

});

parcelRegister("1js2g", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $0f4d50098a87b2f2$export$bad9d2ea38e8f1a; }, function (v) { return $0f4d50098a87b2f2$export$bad9d2ea38e8f1a = v; });
var $0f4d50098a87b2f2$export$bad9d2ea38e8f1a;
"use strict";
$0f4d50098a87b2f2$export$bad9d2ea38e8f1a = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $0f4d50098a87b2f2$var$ExtendedYearParser extends $fNjoe.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $kgNIv.parseNDigitsSigned)(4, dateString);
        return (0, $kgNIv.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$0f4d50098a87b2f2$export$bad9d2ea38e8f1a = $0f4d50098a87b2f2$var$ExtendedYearParser;

});

parcelRegister("3KoRW", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $2ba8f56b6d9e6c63$export$5cb0f701186dde1d; }, function (v) { return $2ba8f56b6d9e6c63$export$5cb0f701186dde1d = v; });
var $2ba8f56b6d9e6c63$export$5cb0f701186dde1d;
"use strict";
$2ba8f56b6d9e6c63$export$5cb0f701186dde1d = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $2ba8f56b6d9e6c63$var$QuarterParser extends $fNjoe.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$2ba8f56b6d9e6c63$export$5cb0f701186dde1d = $2ba8f56b6d9e6c63$var$QuarterParser;

});

parcelRegister("aELFk", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $7c229d35eed1fecd$export$300c0c2990e20e6d; }, function (v) { return $7c229d35eed1fecd$export$300c0c2990e20e6d = v; });
var $7c229d35eed1fecd$export$300c0c2990e20e6d;
"use strict";
$7c229d35eed1fecd$export$300c0c2990e20e6d = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $7c229d35eed1fecd$var$StandAloneQuarterParser extends $fNjoe.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$7c229d35eed1fecd$export$300c0c2990e20e6d = $7c229d35eed1fecd$var$StandAloneQuarterParser;

});

parcelRegister("98PWb", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $6a7d261a613f6e81$export$400dd8b40ef138a3; }, function (v) { return $6a7d261a613f6e81$export$400dd8b40ef138a3 = v; });
var $6a7d261a613f6e81$export$400dd8b40ef138a3;
"use strict";
$6a7d261a613f6e81$export$400dd8b40ef138a3 = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $6a7d261a613f6e81$var$MonthParser extends $fNjoe.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $kgNIv.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$6a7d261a613f6e81$export$400dd8b40ef138a3 = $6a7d261a613f6e81$var$MonthParser;

});

parcelRegister("dGEpI", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $9f6e8bf08ce2b803$export$1d7eaa53eaa5deba; }, function (v) { return $9f6e8bf08ce2b803$export$1d7eaa53eaa5deba = v; });
var $9f6e8bf08ce2b803$export$1d7eaa53eaa5deba;
"use strict";
$9f6e8bf08ce2b803$export$1d7eaa53eaa5deba = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $9f6e8bf08ce2b803$var$StandAloneMonthParser extends $fNjoe.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $kgNIv.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9f6e8bf08ce2b803$export$1d7eaa53eaa5deba = $9f6e8bf08ce2b803$var$StandAloneMonthParser;

});

parcelRegister("86sQA", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $5e6542b74888ea7d$export$c4005ffc174e07c0; }, function (v) { return $5e6542b74888ea7d$export$c4005ffc174e07c0 = v; });
var $5e6542b74888ea7d$export$c4005ffc174e07c0;
"use strict";
$5e6542b74888ea7d$export$c4005ffc174e07c0 = void 0;

var $kBQeH = parcelRequire("kBQeH");

var $dembC = parcelRequire("dembC");

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// Local week of year
class $5e6542b74888ea7d$var$LocalWeekParser extends $fNjoe.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $dembC.startOfWeek)((0, $kBQeH.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$5e6542b74888ea7d$export$c4005ffc174e07c0 = $5e6542b74888ea7d$var$LocalWeekParser;

});
parcelRegister("kBQeH", function(module, exports) {

$parcel$export(module.exports, "setWeek", function () { return $f00fc856da5245b1$export$4b3066ce4afafd88; }, function (v) { return $f00fc856da5245b1$export$4b3066ce4afafd88 = v; });
var $f00fc856da5245b1$export$4b3066ce4afafd88;
"use strict";
$f00fc856da5245b1$export$4b3066ce4afafd88 = $f00fc856da5245b1$var$setWeek;

var $ZnAKU = parcelRequire("ZnAKU");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $f00fc856da5245b1$var$setWeek(date, week, options) {
    const _date = (0, $7NYl1.toDate)(date);
    const diff = (0, $ZnAKU.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("87CWo", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $5e9d2f09af0ca1b3$export$6fc8dbedd560a6af; }, function (v) { return $5e9d2f09af0ca1b3$export$6fc8dbedd560a6af = v; });
var $5e9d2f09af0ca1b3$export$6fc8dbedd560a6af;
"use strict";
$5e9d2f09af0ca1b3$export$6fc8dbedd560a6af = void 0;

var $ljPWF = parcelRequire("ljPWF");

var $56Gig = parcelRequire("56Gig");

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// ISO week of year
class $5e9d2f09af0ca1b3$var$ISOWeekParser extends $fNjoe.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $56Gig.startOfISOWeek)((0, $ljPWF.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$5e9d2f09af0ca1b3$export$6fc8dbedd560a6af = $5e9d2f09af0ca1b3$var$ISOWeekParser;

});
parcelRegister("ljPWF", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", function () { return $f853aa97659b1eb6$export$6542bebf6be94082; }, function (v) { return $f853aa97659b1eb6$export$6542bebf6be94082 = v; });
var $f853aa97659b1eb6$export$6542bebf6be94082;
"use strict";
$f853aa97659b1eb6$export$6542bebf6be94082 = $f853aa97659b1eb6$var$setISOWeek;

var $5MJAb = parcelRequire("5MJAb");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $f853aa97659b1eb6$var$setISOWeek(date, week) {
    const _date = (0, $7NYl1.toDate)(date);
    const diff = (0, $5MJAb.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("jxl9D", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $e39182392eadc3c0$export$e8d4b28a20981dd2; }, function (v) { return $e39182392eadc3c0$export$e8d4b28a20981dd2 = v; });
var $e39182392eadc3c0$export$e8d4b28a20981dd2;
"use strict";
$e39182392eadc3c0$export$e8d4b28a20981dd2 = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
const $e39182392eadc3c0$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e39182392eadc3c0$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $e39182392eadc3c0$var$DateParser extends $fNjoe.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $kgNIv.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e39182392eadc3c0$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e39182392eadc3c0$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e39182392eadc3c0$export$e8d4b28a20981dd2 = $e39182392eadc3c0$var$DateParser;

});

parcelRegister("eFXnS", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $aaf2f574aaa2d90b$export$6cfe0d613455f615; }, function (v) { return $aaf2f574aaa2d90b$export$6cfe0d613455f615 = v; });
var $aaf2f574aaa2d90b$export$6cfe0d613455f615;
"use strict";
$aaf2f574aaa2d90b$export$6cfe0d613455f615 = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $aaf2f574aaa2d90b$var$DayOfYearParser extends $fNjoe.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $kgNIv.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$aaf2f574aaa2d90b$export$6cfe0d613455f615 = $aaf2f574aaa2d90b$var$DayOfYearParser;

});

parcelRegister("8DmyD", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $649376ba72260814$export$1b03c8b76262f7bd; }, function (v) { return $649376ba72260814$export$1b03c8b76262f7bd = v; });
var $649376ba72260814$export$1b03c8b76262f7bd;
"use strict";
$649376ba72260814$export$1b03c8b76262f7bd = void 0;

var $hdXd9 = parcelRequire("hdXd9");

var $fNjoe = parcelRequire("fNjoe");
// Day of week
class $649376ba72260814$var$DayParser extends $fNjoe.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $hdXd9.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$649376ba72260814$export$1b03c8b76262f7bd = $649376ba72260814$var$DayParser;

});
parcelRegister("hdXd9", function(module, exports) {

$parcel$export(module.exports, "setDay", function () { return $c8a194a491fa2477$export$b04fdcda82decc6c; }, function (v) { return $c8a194a491fa2477$export$b04fdcda82decc6c = v; });
var $c8a194a491fa2477$export$b04fdcda82decc6c;
"use strict";
$c8a194a491fa2477$export$b04fdcda82decc6c = $c8a194a491fa2477$var$setDay;

var $2vrAW = parcelRequire("2vrAW");

var $7NYl1 = parcelRequire("7NYl1");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $c8a194a491fa2477$var$setDay(date, day, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7NYl1.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $2vrAW.addDays)(_date, diff);
}

});


parcelRegister("58AMJ", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $3bda3bd9d4ea7c78$export$44d1c127ab42c480; }, function (v) { return $3bda3bd9d4ea7c78$export$44d1c127ab42c480 = v; });
var $3bda3bd9d4ea7c78$export$44d1c127ab42c480;
"use strict";
$3bda3bd9d4ea7c78$export$44d1c127ab42c480 = void 0;

var $hdXd9 = parcelRequire("hdXd9");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// Local day of week
class $3bda3bd9d4ea7c78$var$LocalDayParser extends $fNjoe.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $kgNIv.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $hdXd9.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$3bda3bd9d4ea7c78$export$44d1c127ab42c480 = $3bda3bd9d4ea7c78$var$LocalDayParser;

});

parcelRegister("9bWOj", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $6b12c2acfa686f53$export$e447a647caaaec1d; }, function (v) { return $6b12c2acfa686f53$export$e447a647caaaec1d = v; });
var $6b12c2acfa686f53$export$e447a647caaaec1d;
"use strict";
$6b12c2acfa686f53$export$e447a647caaaec1d = void 0;

var $hdXd9 = parcelRequire("hdXd9");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// Stand-alone local day of week
class $6b12c2acfa686f53$var$StandAloneLocalDayParser extends $fNjoe.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $kgNIv.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $hdXd9.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$6b12c2acfa686f53$export$e447a647caaaec1d = $6b12c2acfa686f53$var$StandAloneLocalDayParser;

});

parcelRegister("izc6U", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $d844e3c7b3d0f899$export$693fb1e525095b2a; }, function (v) { return $d844e3c7b3d0f899$export$693fb1e525095b2a = v; });
var $d844e3c7b3d0f899$export$693fb1e525095b2a;
"use strict";
$d844e3c7b3d0f899$export$693fb1e525095b2a = void 0;

var $5abwi = parcelRequire("5abwi");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// ISO day of week
class $d844e3c7b3d0f899$var$ISODayParser extends $fNjoe.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $kgNIv.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $kgNIv.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $kgNIv.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $kgNIv.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $5abwi.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$d844e3c7b3d0f899$export$693fb1e525095b2a = $d844e3c7b3d0f899$var$ISODayParser;

});
parcelRegister("5abwi", function(module, exports) {

$parcel$export(module.exports, "setISODay", function () { return $3c26d28794d4c5be$export$1fd9df65adb0d1aa; }, function (v) { return $3c26d28794d4c5be$export$1fd9df65adb0d1aa = v; });
var $3c26d28794d4c5be$export$1fd9df65adb0d1aa;
"use strict";
$3c26d28794d4c5be$export$1fd9df65adb0d1aa = $3c26d28794d4c5be$var$setISODay;

var $2vrAW = parcelRequire("2vrAW");

var $4GKw4 = parcelRequire("4GKw4");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $3c26d28794d4c5be$var$setISODay(date, day) {
    const _date = (0, $7NYl1.toDate)(date);
    const currentDay = (0, $4GKw4.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $2vrAW.addDays)(_date, diff);
}

});
parcelRegister("4GKw4", function(module, exports) {

$parcel$export(module.exports, "getISODay", function () { return $369f2ad027ed176d$export$c514f4c1a8ed5e9e; }, function (v) { return $369f2ad027ed176d$export$c514f4c1a8ed5e9e = v; });
var $369f2ad027ed176d$export$c514f4c1a8ed5e9e;
"use strict";
$369f2ad027ed176d$export$c514f4c1a8ed5e9e = $369f2ad027ed176d$var$getISODay;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $369f2ad027ed176d$var$getISODay(date) {
    const _date = (0, $7NYl1.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});



parcelRegister("lgE3E", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $f7ba2a40113f5ce0$export$8d1e08492351df91; }, function (v) { return $f7ba2a40113f5ce0$export$8d1e08492351df91 = v; });
var $f7ba2a40113f5ce0$export$8d1e08492351df91;
"use strict";
$f7ba2a40113f5ce0$export$8d1e08492351df91 = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $f7ba2a40113f5ce0$var$AMPMParser extends $fNjoe.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $kgNIv.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$f7ba2a40113f5ce0$export$8d1e08492351df91 = $f7ba2a40113f5ce0$var$AMPMParser;

});

parcelRegister("3qYlp", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $28029bf389a10bf6$export$73ca2bd0a17d273; }, function (v) { return $28029bf389a10bf6$export$73ca2bd0a17d273 = v; });
var $28029bf389a10bf6$export$73ca2bd0a17d273;
"use strict";
$28029bf389a10bf6$export$73ca2bd0a17d273 = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $28029bf389a10bf6$var$AMPMMidnightParser extends $fNjoe.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $kgNIv.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$28029bf389a10bf6$export$73ca2bd0a17d273 = $28029bf389a10bf6$var$AMPMMidnightParser;

});

parcelRegister("eVXsF", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $adf4835d42e662d0$export$bb9212adf05373db; }, function (v) { return $adf4835d42e662d0$export$bb9212adf05373db = v; });
var $adf4835d42e662d0$export$bb9212adf05373db;
"use strict";
$adf4835d42e662d0$export$bb9212adf05373db = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// in the morning, in the afternoon, in the evening, at night
class $adf4835d42e662d0$var$DayPeriodParser extends $fNjoe.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $kgNIv.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$adf4835d42e662d0$export$bb9212adf05373db = $adf4835d42e662d0$var$DayPeriodParser;

});

parcelRegister("iZWkC", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $dd4b2becb61e2199$export$8a04050a727a1756; }, function (v) { return $dd4b2becb61e2199$export$8a04050a727a1756 = v; });
var $dd4b2becb61e2199$export$8a04050a727a1756;
"use strict";
$dd4b2becb61e2199$export$8a04050a727a1756 = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $dd4b2becb61e2199$var$Hour1to12Parser extends $fNjoe.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$dd4b2becb61e2199$export$8a04050a727a1756 = $dd4b2becb61e2199$var$Hour1to12Parser;

});

parcelRegister("cXcxC", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $96e4b92db3ab66ff$export$e56f4dea2c3e56dd; }, function (v) { return $96e4b92db3ab66ff$export$e56f4dea2c3e56dd = v; });
var $96e4b92db3ab66ff$export$e56f4dea2c3e56dd;
"use strict";
$96e4b92db3ab66ff$export$e56f4dea2c3e56dd = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $96e4b92db3ab66ff$var$Hour0to23Parser extends $fNjoe.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$96e4b92db3ab66ff$export$e56f4dea2c3e56dd = $96e4b92db3ab66ff$var$Hour0to23Parser;

});

parcelRegister("3oHES", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $27957aa36c35ade7$export$cbbe855312f87d77; }, function (v) { return $27957aa36c35ade7$export$cbbe855312f87d77 = v; });
var $27957aa36c35ade7$export$cbbe855312f87d77;
"use strict";
$27957aa36c35ade7$export$cbbe855312f87d77 = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $27957aa36c35ade7$var$Hour0To11Parser extends $fNjoe.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$27957aa36c35ade7$export$cbbe855312f87d77 = $27957aa36c35ade7$var$Hour0To11Parser;

});

parcelRegister("aQ4fD", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $7e420ee7f006f82e$export$6008046d2b34b6a5; }, function (v) { return $7e420ee7f006f82e$export$6008046d2b34b6a5 = v; });
var $7e420ee7f006f82e$export$6008046d2b34b6a5;
"use strict";
$7e420ee7f006f82e$export$6008046d2b34b6a5 = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $7e420ee7f006f82e$var$Hour1To24Parser extends $fNjoe.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$7e420ee7f006f82e$export$6008046d2b34b6a5 = $7e420ee7f006f82e$var$Hour1To24Parser;

});

parcelRegister("48ebK", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $3022ea4f25e1f7d7$export$2b52670d9e2be53; }, function (v) { return $3022ea4f25e1f7d7$export$2b52670d9e2be53 = v; });
var $3022ea4f25e1f7d7$export$2b52670d9e2be53;
"use strict";
$3022ea4f25e1f7d7$export$2b52670d9e2be53 = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $3022ea4f25e1f7d7$var$MinuteParser extends $fNjoe.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$3022ea4f25e1f7d7$export$2b52670d9e2be53 = $3022ea4f25e1f7d7$var$MinuteParser;

});

parcelRegister("83hfR", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $5dcbfd01c8a0527b$export$94d46d540cf1366a; }, function (v) { return $5dcbfd01c8a0527b$export$94d46d540cf1366a = v; });
var $5dcbfd01c8a0527b$export$94d46d540cf1366a;
"use strict";
$5dcbfd01c8a0527b$export$94d46d540cf1366a = void 0;

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $5dcbfd01c8a0527b$var$SecondParser extends $fNjoe.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $kgNIv.parseNumericPattern)($eht9h.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $kgNIv.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$5dcbfd01c8a0527b$export$94d46d540cf1366a = $5dcbfd01c8a0527b$var$SecondParser;

});

parcelRegister("eeFkR", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $a5d26fdb017603e2$export$b8e6f8b2d70893b1; }, function (v) { return $a5d26fdb017603e2$export$b8e6f8b2d70893b1 = v; });
var $a5d26fdb017603e2$export$b8e6f8b2d70893b1;
"use strict";
$a5d26fdb017603e2$export$b8e6f8b2d70893b1 = void 0;

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $a5d26fdb017603e2$var$FractionOfSecondParser extends $fNjoe.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $kgNIv.mapValue)((0, $kgNIv.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$a5d26fdb017603e2$export$b8e6f8b2d70893b1 = $a5d26fdb017603e2$var$FractionOfSecondParser;

});

parcelRegister("7VFNK", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $5c5e482e40de2aba$export$104d901d49fea29b; }, function (v) { return $5c5e482e40de2aba$export$104d901d49fea29b = v; });
var $5c5e482e40de2aba$export$104d901d49fea29b;
"use strict";
$5c5e482e40de2aba$export$104d901d49fea29b = void 0;

var $5viJK = parcelRequire("5viJK");

var $eBj5w = parcelRequire("eBj5w");

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $5c5e482e40de2aba$var$ISOTimezoneWithZParser extends $fNjoe.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $5viJK.constructFrom)(date, date.getTime() - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$5c5e482e40de2aba$export$104d901d49fea29b = $5c5e482e40de2aba$var$ISOTimezoneWithZParser;

});

parcelRegister("kFulo", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $f0bf2cb3cfff7721$export$12910e5204b52b9; }, function (v) { return $f0bf2cb3cfff7721$export$12910e5204b52b9 = v; });
var $f0bf2cb3cfff7721$export$12910e5204b52b9;
"use strict";
$f0bf2cb3cfff7721$export$12910e5204b52b9 = void 0;

var $5viJK = parcelRequire("5viJK");

var $eBj5w = parcelRequire("eBj5w");

var $eht9h = parcelRequire("eht9h");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
// Timezone (ISO-8601)
class $f0bf2cb3cfff7721$var$ISOTimezoneParser extends $fNjoe.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $kgNIv.parseTimezonePattern)($eht9h.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $5viJK.constructFrom)(date, date.getTime() - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$f0bf2cb3cfff7721$export$12910e5204b52b9 = $f0bf2cb3cfff7721$var$ISOTimezoneParser;

});

parcelRegister("56zUZ", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $3b795fe1ced2a488$export$2cd8bf877a05e96; }, function (v) { return $3b795fe1ced2a488$export$2cd8bf877a05e96 = v; });
var $3b795fe1ced2a488$export$2cd8bf877a05e96;
"use strict";
$3b795fe1ced2a488$export$2cd8bf877a05e96 = void 0;

var $5viJK = parcelRequire("5viJK");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $3b795fe1ced2a488$var$TimestampSecondsParser extends $fNjoe.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $kgNIv.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $5viJK.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$3b795fe1ced2a488$export$2cd8bf877a05e96 = $3b795fe1ced2a488$var$TimestampSecondsParser;

});

parcelRegister("dcenz", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $99b78cbf7a5338b4$export$6d8f69c6906d6368; }, function (v) { return $99b78cbf7a5338b4$export$6d8f69c6906d6368 = v; });
var $99b78cbf7a5338b4$export$6d8f69c6906d6368;
"use strict";
$99b78cbf7a5338b4$export$6d8f69c6906d6368 = void 0;

var $5viJK = parcelRequire("5viJK");

var $fNjoe = parcelRequire("fNjoe");

var $kgNIv = parcelRequire("kgNIv");
class $99b78cbf7a5338b4$var$TimestampMillisecondsParser extends $fNjoe.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $kgNIv.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $5viJK.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$99b78cbf7a5338b4$export$6d8f69c6906d6368 = $99b78cbf7a5338b4$var$TimestampMillisecondsParser;

});



parcelRegister("5WWIe", function(module, exports) {

$parcel$export(module.exports, "parseISO", function () { return $454fe9972aa8ac87$export$4393d2ccbbedb219; }, function (v) { return $454fe9972aa8ac87$export$4393d2ccbbedb219 = v; });
var $454fe9972aa8ac87$export$4393d2ccbbedb219;
"use strict";
$454fe9972aa8ac87$export$4393d2ccbbedb219 = $454fe9972aa8ac87$var$parseISO;

var $kMovx = parcelRequire("kMovx");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $454fe9972aa8ac87$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $454fe9972aa8ac87$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $454fe9972aa8ac87$var$parseYear(dateStrings.date, additionalDigits);
        date = $454fe9972aa8ac87$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $454fe9972aa8ac87$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $454fe9972aa8ac87$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $454fe9972aa8ac87$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $454fe9972aa8ac87$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $454fe9972aa8ac87$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $454fe9972aa8ac87$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $454fe9972aa8ac87$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($454fe9972aa8ac87$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($454fe9972aa8ac87$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($454fe9972aa8ac87$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $454fe9972aa8ac87$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $454fe9972aa8ac87$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $454fe9972aa8ac87$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($454fe9972aa8ac87$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $454fe9972aa8ac87$var$parseDateUnit(captures[1]);
    const month = $454fe9972aa8ac87$var$parseDateUnit(captures[2]) - 1;
    const day = $454fe9972aa8ac87$var$parseDateUnit(captures[3]);
    const week = $454fe9972aa8ac87$var$parseDateUnit(captures[4]);
    const dayOfWeek = $454fe9972aa8ac87$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$454fe9972aa8ac87$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $454fe9972aa8ac87$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$454fe9972aa8ac87$var$validateDate(year, month, day) || !$454fe9972aa8ac87$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $454fe9972aa8ac87$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $454fe9972aa8ac87$var$parseTime(timeString) {
    const captures = timeString.match($454fe9972aa8ac87$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $454fe9972aa8ac87$var$parseTimeUnit(captures[1]);
    const minutes = $454fe9972aa8ac87$var$parseTimeUnit(captures[2]);
    const seconds = $454fe9972aa8ac87$var$parseTimeUnit(captures[3]);
    if (!$454fe9972aa8ac87$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $kMovx.millisecondsInHour + minutes * $kMovx.millisecondsInMinute + seconds * 1000;
}
function $454fe9972aa8ac87$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $454fe9972aa8ac87$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($454fe9972aa8ac87$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$454fe9972aa8ac87$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $kMovx.millisecondsInHour + minutes * $kMovx.millisecondsInMinute);
}
function $454fe9972aa8ac87$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $454fe9972aa8ac87$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $454fe9972aa8ac87$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $454fe9972aa8ac87$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($454fe9972aa8ac87$var$daysInMonths[month] || ($454fe9972aa8ac87$var$isLeapYearIndex(year) ? 29 : 28));
}
function $454fe9972aa8ac87$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($454fe9972aa8ac87$var$isLeapYearIndex(year) ? 366 : 365);
}
function $454fe9972aa8ac87$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $454fe9972aa8ac87$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $454fe9972aa8ac87$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("aECmM", function(module, exports) {
"use strict";

var $gEhyf = parcelRequire("gEhyf");
Object.keys($gEhyf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gEhyf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gEhyf[key];
        }
    });
});

var $esSds = parcelRequire("esSds");
Object.keys($esSds).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $esSds[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $esSds[key];
        }
    });
});

var $2vrAW = parcelRequire("2vrAW");
Object.keys($2vrAW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2vrAW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2vrAW[key];
        }
    });
});

var $lk4ac = parcelRequire("lk4ac");
Object.keys($lk4ac).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lk4ac[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lk4ac[key];
        }
    });
});

var $2AWhK = parcelRequire("2AWhK");
Object.keys($2AWhK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2AWhK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2AWhK[key];
        }
    });
});

var $32aF3 = parcelRequire("32aF3");
Object.keys($32aF3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $32aF3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $32aF3[key];
        }
    });
});

var $9VdIH = parcelRequire("9VdIH");
Object.keys($9VdIH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9VdIH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9VdIH[key];
        }
    });
});

var $1uoU9 = parcelRequire("1uoU9");
Object.keys($1uoU9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1uoU9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1uoU9[key];
        }
    });
});

var $ejkpp = parcelRequire("ejkpp");
Object.keys($ejkpp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ejkpp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ejkpp[key];
        }
    });
});

var $42N2s = parcelRequire("42N2s");
Object.keys($42N2s).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $42N2s[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $42N2s[key];
        }
    });
});

var $1hExc = parcelRequire("1hExc");
Object.keys($1hExc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1hExc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1hExc[key];
        }
    });
});

var $bvEuC = parcelRequire("bvEuC");
Object.keys($bvEuC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bvEuC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bvEuC[key];
        }
    });
});

var $6OkTI = parcelRequire("6OkTI");
Object.keys($6OkTI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6OkTI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6OkTI[key];
        }
    });
});

var $8BQdJ = parcelRequire("8BQdJ");
Object.keys($8BQdJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8BQdJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8BQdJ[key];
        }
    });
});

var $g42hP = parcelRequire("g42hP");
Object.keys($g42hP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g42hP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g42hP[key];
        }
    });
});

var $6c4Hu = parcelRequire("6c4Hu");
Object.keys($6c4Hu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6c4Hu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6c4Hu[key];
        }
    });
});

var $du4Y6 = parcelRequire("du4Y6");
Object.keys($du4Y6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $du4Y6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $du4Y6[key];
        }
    });
});

var $aKGxR = parcelRequire("aKGxR");
Object.keys($aKGxR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aKGxR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aKGxR[key];
        }
    });
});

var $5viJK = parcelRequire("5viJK");
Object.keys($5viJK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5viJK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5viJK[key];
        }
    });
});

var $lcXac = parcelRequire("lcXac");
Object.keys($lcXac).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lcXac[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lcXac[key];
        }
    });
});

var $2hvBi = parcelRequire("2hvBi");
Object.keys($2hvBi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2hvBi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2hvBi[key];
        }
    });
});

var $26XKE = parcelRequire("26XKE");
Object.keys($26XKE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $26XKE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $26XKE[key];
        }
    });
});

var $jaIwE = parcelRequire("jaIwE");
Object.keys($jaIwE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jaIwE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jaIwE[key];
        }
    });
});

var $9NFa1 = parcelRequire("9NFa1");
Object.keys($9NFa1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9NFa1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9NFa1[key];
        }
    });
});

var $2ll1D = parcelRequire("2ll1D");
Object.keys($2ll1D).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2ll1D[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ll1D[key];
        }
    });
});

var $8pkT1 = parcelRequire("8pkT1");
Object.keys($8pkT1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8pkT1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8pkT1[key];
        }
    });
});

var $lesSB = parcelRequire("lesSB");
Object.keys($lesSB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lesSB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lesSB[key];
        }
    });
});

var $jq8bc = parcelRequire("jq8bc");
Object.keys($jq8bc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jq8bc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jq8bc[key];
        }
    });
});

var $8EzaS = parcelRequire("8EzaS");
Object.keys($8EzaS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8EzaS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8EzaS[key];
        }
    });
});

var $b22mw = parcelRequire("b22mw");
Object.keys($b22mw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b22mw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b22mw[key];
        }
    });
});

var $3B2eR = parcelRequire("3B2eR");
Object.keys($3B2eR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3B2eR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3B2eR[key];
        }
    });
});

var $jYsuj = parcelRequire("jYsuj");
Object.keys($jYsuj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jYsuj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jYsuj[key];
        }
    });
});

var $bNAOX = parcelRequire("bNAOX");
Object.keys($bNAOX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bNAOX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bNAOX[key];
        }
    });
});

var $6aND4 = parcelRequire("6aND4");
Object.keys($6aND4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6aND4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6aND4[key];
        }
    });
});

var $ltGKA = parcelRequire("ltGKA");
Object.keys($ltGKA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ltGKA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ltGKA[key];
        }
    });
});

var $eOWeV = parcelRequire("eOWeV");
Object.keys($eOWeV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eOWeV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eOWeV[key];
        }
    });
});

var $2o9YY = parcelRequire("2o9YY");
Object.keys($2o9YY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2o9YY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2o9YY[key];
        }
    });
});

var $hyJk4 = parcelRequire("hyJk4");
Object.keys($hyJk4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hyJk4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hyJk4[key];
        }
    });
});

var $hZM1i = parcelRequire("hZM1i");
Object.keys($hZM1i).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hZM1i[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hZM1i[key];
        }
    });
});

var $1Ywvk = parcelRequire("1Ywvk");
Object.keys($1Ywvk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1Ywvk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1Ywvk[key];
        }
    });
});

var $2hnEA = parcelRequire("2hnEA");
Object.keys($2hnEA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2hnEA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2hnEA[key];
        }
    });
});

var $awqIG = parcelRequire("awqIG");
Object.keys($awqIG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $awqIG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $awqIG[key];
        }
    });
});

var $cBY1o = parcelRequire("cBY1o");
Object.keys($cBY1o).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cBY1o[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cBY1o[key];
        }
    });
});

var $20n6r = parcelRequire("20n6r");
Object.keys($20n6r).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $20n6r[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $20n6r[key];
        }
    });
});

var $4h9Lx = parcelRequire("4h9Lx");
Object.keys($4h9Lx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4h9Lx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4h9Lx[key];
        }
    });
});

var $4uJYT = parcelRequire("4uJYT");
Object.keys($4uJYT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4uJYT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4uJYT[key];
        }
    });
});

var $1T9ve = parcelRequire("1T9ve");
Object.keys($1T9ve).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1T9ve[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1T9ve[key];
        }
    });
});

var $kYXKC = parcelRequire("kYXKC");
Object.keys($kYXKC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kYXKC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kYXKC[key];
        }
    });
});

var $6sgoi = parcelRequire("6sgoi");
Object.keys($6sgoi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6sgoi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6sgoi[key];
        }
    });
});

var $exWqC = parcelRequire("exWqC");
Object.keys($exWqC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $exWqC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $exWqC[key];
        }
    });
});

var $7kD58 = parcelRequire("7kD58");
Object.keys($7kD58).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7kD58[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7kD58[key];
        }
    });
});

var $aCong = parcelRequire("aCong");
Object.keys($aCong).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aCong[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aCong[key];
        }
    });
});

var $alaze = parcelRequire("alaze");
Object.keys($alaze).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $alaze[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $alaze[key];
        }
    });
});

var $cfw9z = parcelRequire("cfw9z");
Object.keys($cfw9z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cfw9z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cfw9z[key];
        }
    });
});

var $lH32C = parcelRequire("lH32C");
Object.keys($lH32C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lH32C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lH32C[key];
        }
    });
});

var $lVNbV = parcelRequire("lVNbV");
Object.keys($lVNbV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lVNbV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lVNbV[key];
        }
    });
});

var $8Qg9u = parcelRequire("8Qg9u");
Object.keys($8Qg9u).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8Qg9u[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8Qg9u[key];
        }
    });
});

var $jizcV = parcelRequire("jizcV");
Object.keys($jizcV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jizcV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jizcV[key];
        }
    });
});

var $9dVqn = parcelRequire("9dVqn");
Object.keys($9dVqn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9dVqn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9dVqn[key];
        }
    });
});

var $7CgVw = parcelRequire("7CgVw");
Object.keys($7CgVw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7CgVw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7CgVw[key];
        }
    });
});

var $8mcDi = parcelRequire("8mcDi");
Object.keys($8mcDi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8mcDi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8mcDi[key];
        }
    });
});

var $72tdj = parcelRequire("72tdj");
Object.keys($72tdj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $72tdj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $72tdj[key];
        }
    });
});

var $7Uazv = parcelRequire("7Uazv");
Object.keys($7Uazv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Uazv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Uazv[key];
        }
    });
});

var $9IzSo = parcelRequire("9IzSo");
Object.keys($9IzSo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9IzSo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9IzSo[key];
        }
    });
});

var $iKYfi = parcelRequire("iKYfi");
Object.keys($iKYfi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iKYfi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iKYfi[key];
        }
    });
});

var $3V3VQ = parcelRequire("3V3VQ");
Object.keys($3V3VQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3V3VQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3V3VQ[key];
        }
    });
});

var $joimB = parcelRequire("joimB");
Object.keys($joimB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $joimB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $joimB[key];
        }
    });
});

var $lDYot = parcelRequire("lDYot");
Object.keys($lDYot).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lDYot[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lDYot[key];
        }
    });
});

var $37W9Q = parcelRequire("37W9Q");
Object.keys($37W9Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $37W9Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $37W9Q[key];
        }
    });
});

var $6hucJ = parcelRequire("6hucJ");
Object.keys($6hucJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6hucJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6hucJ[key];
        }
    });
});

var $7Z3RP = parcelRequire("7Z3RP");
Object.keys($7Z3RP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Z3RP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Z3RP[key];
        }
    });
});

var $aDwZh = parcelRequire("aDwZh");
Object.keys($aDwZh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aDwZh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aDwZh[key];
        }
    });
});

var $kBG3L = parcelRequire("kBG3L");
Object.keys($kBG3L).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kBG3L[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kBG3L[key];
        }
    });
});

var $89M7d = parcelRequire("89M7d");
Object.keys($89M7d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $89M7d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $89M7d[key];
        }
    });
});

var $lfcGS = parcelRequire("lfcGS");
Object.keys($lfcGS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lfcGS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lfcGS[key];
        }
    });
});

var $72LQN = parcelRequire("72LQN");
Object.keys($72LQN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $72LQN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $72LQN[key];
        }
    });
});

var $4sou0 = parcelRequire("4sou0");
Object.keys($4sou0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4sou0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4sou0[key];
        }
    });
});

var $7Vb0N = parcelRequire("7Vb0N");
Object.keys($7Vb0N).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Vb0N[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Vb0N[key];
        }
    });
});

var $2TuPF = parcelRequire("2TuPF");
Object.keys($2TuPF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2TuPF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2TuPF[key];
        }
    });
});

var $3GcQZ = parcelRequire("3GcQZ");
Object.keys($3GcQZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3GcQZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3GcQZ[key];
        }
    });
});

var $4vqPW = parcelRequire("4vqPW");
Object.keys($4vqPW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4vqPW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4vqPW[key];
        }
    });
});

var $kgz3L = parcelRequire("kgz3L");
Object.keys($kgz3L).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kgz3L[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kgz3L[key];
        }
    });
});

var $5Ew7Y = parcelRequire("5Ew7Y");
Object.keys($5Ew7Y).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Ew7Y[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Ew7Y[key];
        }
    });
});

var $lk486 = parcelRequire("lk486");
Object.keys($lk486).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lk486[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lk486[key];
        }
    });
});

var $4GKw4 = parcelRequire("4GKw4");
Object.keys($4GKw4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4GKw4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4GKw4[key];
        }
    });
});

var $5MJAb = parcelRequire("5MJAb");
Object.keys($5MJAb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5MJAb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5MJAb[key];
        }
    });
});

var $VphlE = parcelRequire("VphlE");
Object.keys($VphlE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $VphlE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $VphlE[key];
        }
    });
});

var $83vBF = parcelRequire("83vBF");
Object.keys($83vBF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $83vBF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $83vBF[key];
        }
    });
});

var $3JYJz = parcelRequire("3JYJz");
Object.keys($3JYJz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3JYJz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3JYJz[key];
        }
    });
});

var $lvYCh = parcelRequire("lvYCh");
Object.keys($lvYCh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lvYCh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lvYCh[key];
        }
    });
});

var $7ivcB = parcelRequire("7ivcB");
Object.keys($7ivcB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7ivcB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7ivcB[key];
        }
    });
});

var $9uEO5 = parcelRequire("9uEO5");
Object.keys($9uEO5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9uEO5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9uEO5[key];
        }
    });
});

var $gTkms = parcelRequire("gTkms");
Object.keys($gTkms).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gTkms[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gTkms[key];
        }
    });
});

var $cDEq1 = parcelRequire("cDEq1");
Object.keys($cDEq1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cDEq1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cDEq1[key];
        }
    });
});

var $bUKY3 = parcelRequire("bUKY3");
Object.keys($bUKY3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bUKY3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bUKY3[key];
        }
    });
});

var $7N1mJ = parcelRequire("7N1mJ");
Object.keys($7N1mJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7N1mJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7N1mJ[key];
        }
    });
});

var $ZnAKU = parcelRequire("ZnAKU");
Object.keys($ZnAKU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ZnAKU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ZnAKU[key];
        }
    });
});

var $jh645 = parcelRequire("jh645");
Object.keys($jh645).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jh645[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jh645[key];
        }
    });
});

var $7Fdrm = parcelRequire("7Fdrm");
Object.keys($7Fdrm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Fdrm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Fdrm[key];
        }
    });
});

var $gd1pn = parcelRequire("gd1pn");
Object.keys($gd1pn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gd1pn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gd1pn[key];
        }
    });
});

var $d8MXz = parcelRequire("d8MXz");
Object.keys($d8MXz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d8MXz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d8MXz[key];
        }
    });
});

var $8ieyg = parcelRequire("8ieyg");
Object.keys($8ieyg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8ieyg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ieyg[key];
        }
    });
});

var $bTsKH = parcelRequire("bTsKH");
Object.keys($bTsKH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bTsKH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bTsKH[key];
        }
    });
});

var $6s9yy = parcelRequire("6s9yy");
Object.keys($6s9yy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6s9yy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6s9yy[key];
        }
    });
});

var $dORoq = parcelRequire("dORoq");
Object.keys($dORoq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dORoq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dORoq[key];
        }
    });
});

var $cLZbZ = parcelRequire("cLZbZ");
Object.keys($cLZbZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cLZbZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cLZbZ[key];
        }
    });
});

var $fbMXk = parcelRequire("fbMXk");
Object.keys($fbMXk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fbMXk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fbMXk[key];
        }
    });
});

var $btRbY = parcelRequire("btRbY");
Object.keys($btRbY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $btRbY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $btRbY[key];
        }
    });
});

var $7s5Ss = parcelRequire("7s5Ss");
Object.keys($7s5Ss).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7s5Ss[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7s5Ss[key];
        }
    });
});

var $fLOXb = parcelRequire("fLOXb");
Object.keys($fLOXb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fLOXb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fLOXb[key];
        }
    });
});

var $bht2X = parcelRequire("bht2X");
Object.keys($bht2X).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bht2X[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bht2X[key];
        }
    });
});

var $ky24C = parcelRequire("ky24C");
Object.keys($ky24C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ky24C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ky24C[key];
        }
    });
});

var $3hqWf = parcelRequire("3hqWf");
Object.keys($3hqWf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3hqWf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3hqWf[key];
        }
    });
});

var $4jIPU = parcelRequire("4jIPU");
Object.keys($4jIPU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4jIPU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4jIPU[key];
        }
    });
});

var $dMmHn = parcelRequire("dMmHn");
Object.keys($dMmHn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dMmHn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dMmHn[key];
        }
    });
});

var $jwfj8 = parcelRequire("jwfj8");
Object.keys($jwfj8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jwfj8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jwfj8[key];
        }
    });
});

var $2AGyL = parcelRequire("2AGyL");
Object.keys($2AGyL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2AGyL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2AGyL[key];
        }
    });
});

var $2VN4v = parcelRequire("2VN4v");
Object.keys($2VN4v).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2VN4v[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2VN4v[key];
        }
    });
});

var $gHo0W = parcelRequire("gHo0W");
Object.keys($gHo0W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gHo0W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gHo0W[key];
        }
    });
});

var $gX9mk = parcelRequire("gX9mk");
Object.keys($gX9mk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gX9mk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gX9mk[key];
        }
    });
});

var $iZCBT = parcelRequire("iZCBT");
Object.keys($iZCBT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iZCBT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iZCBT[key];
        }
    });
});

var $73v8c = parcelRequire("73v8c");
Object.keys($73v8c).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $73v8c[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $73v8c[key];
        }
    });
});

var $7fw9p = parcelRequire("7fw9p");
Object.keys($7fw9p).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7fw9p[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7fw9p[key];
        }
    });
});

var $fpN6P = parcelRequire("fpN6P");
Object.keys($fpN6P).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fpN6P[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fpN6P[key];
        }
    });
});

var $kLUir = parcelRequire("kLUir");
Object.keys($kLUir).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kLUir[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kLUir[key];
        }
    });
});

var $sYhzN = parcelRequire("sYhzN");
Object.keys($sYhzN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $sYhzN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $sYhzN[key];
        }
    });
});

var $9qPPc = parcelRequire("9qPPc");
Object.keys($9qPPc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9qPPc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9qPPc[key];
        }
    });
});

var $g5oPq = parcelRequire("g5oPq");
Object.keys($g5oPq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g5oPq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g5oPq[key];
        }
    });
});

var $fQKG7 = parcelRequire("fQKG7");
Object.keys($fQKG7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fQKG7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fQKG7[key];
        }
    });
});

var $7E3R5 = parcelRequire("7E3R5");
Object.keys($7E3R5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7E3R5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7E3R5[key];
        }
    });
});

var $82gj4 = parcelRequire("82gj4");
Object.keys($82gj4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $82gj4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $82gj4[key];
        }
    });
});

var $1jL69 = parcelRequire("1jL69");
Object.keys($1jL69).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1jL69[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1jL69[key];
        }
    });
});

var $fW9OG = parcelRequire("fW9OG");
Object.keys($fW9OG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fW9OG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fW9OG[key];
        }
    });
});

var $bpm6C = parcelRequire("bpm6C");
Object.keys($bpm6C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bpm6C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bpm6C[key];
        }
    });
});

var $6zZTc = parcelRequire("6zZTc");
Object.keys($6zZTc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6zZTc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6zZTc[key];
        }
    });
});

var $2jLKP = parcelRequire("2jLKP");
Object.keys($2jLKP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2jLKP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2jLKP[key];
        }
    });
});

var $ayh6X = parcelRequire("ayh6X");
Object.keys($ayh6X).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ayh6X[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ayh6X[key];
        }
    });
});

var $hnniR = parcelRequire("hnniR");
Object.keys($hnniR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hnniR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hnniR[key];
        }
    });
});

var $b7MYT = parcelRequire("b7MYT");
Object.keys($b7MYT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b7MYT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b7MYT[key];
        }
    });
});

var $jVXe7 = parcelRequire("jVXe7");
Object.keys($jVXe7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jVXe7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jVXe7[key];
        }
    });
});

var $k8VaZ = parcelRequire("k8VaZ");
Object.keys($k8VaZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k8VaZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k8VaZ[key];
        }
    });
});

var $jai8J = parcelRequire("jai8J");
Object.keys($jai8J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jai8J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jai8J[key];
        }
    });
});

var $c6Vcq = parcelRequire("c6Vcq");
Object.keys($c6Vcq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c6Vcq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c6Vcq[key];
        }
    });
});

var $lvv1w = parcelRequire("lvv1w");
Object.keys($lvv1w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lvv1w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lvv1w[key];
        }
    });
});

var $guT22 = parcelRequire("guT22");
Object.keys($guT22).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $guT22[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $guT22[key];
        }
    });
});

var $4pFgQ = parcelRequire("4pFgQ");
Object.keys($4pFgQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4pFgQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4pFgQ[key];
        }
    });
});

var $lTthR = parcelRequire("lTthR");
Object.keys($lTthR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lTthR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lTthR[key];
        }
    });
});

var $fpiN0 = parcelRequire("fpiN0");
Object.keys($fpiN0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fpiN0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fpiN0[key];
        }
    });
});

var $flwHs = parcelRequire("flwHs");
Object.keys($flwHs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $flwHs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $flwHs[key];
        }
    });
});

var $22R1s = parcelRequire("22R1s");
Object.keys($22R1s).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $22R1s[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $22R1s[key];
        }
    });
});

var $b2fu7 = parcelRequire("b2fu7");
Object.keys($b2fu7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b2fu7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b2fu7[key];
        }
    });
});

var $dndVE = parcelRequire("dndVE");
Object.keys($dndVE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dndVE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dndVE[key];
        }
    });
});

var $4G8MV = parcelRequire("4G8MV");
Object.keys($4G8MV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4G8MV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4G8MV[key];
        }
    });
});

var $i6KAU = parcelRequire("i6KAU");
Object.keys($i6KAU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i6KAU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i6KAU[key];
        }
    });
});

var $h1phI = parcelRequire("h1phI");
Object.keys($h1phI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h1phI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h1phI[key];
        }
    });
});

var $kQ7hG = parcelRequire("kQ7hG");
Object.keys($kQ7hG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kQ7hG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kQ7hG[key];
        }
    });
});

var $76Dnj = parcelRequire("76Dnj");
Object.keys($76Dnj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $76Dnj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $76Dnj[key];
        }
    });
});

var $gM2TP = parcelRequire("gM2TP");
Object.keys($gM2TP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gM2TP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gM2TP[key];
        }
    });
});

var $7nRuI = parcelRequire("7nRuI");
Object.keys($7nRuI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7nRuI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7nRuI[key];
        }
    });
});

var $8cbK9 = parcelRequire("8cbK9");
Object.keys($8cbK9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8cbK9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8cbK9[key];
        }
    });
});

var $kOg5P = parcelRequire("kOg5P");
Object.keys($kOg5P).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kOg5P[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kOg5P[key];
        }
    });
});

var $jrOc8 = parcelRequire("jrOc8");
Object.keys($jrOc8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jrOc8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jrOc8[key];
        }
    });
});

var $1K1po = parcelRequire("1K1po");
Object.keys($1K1po).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1K1po[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1K1po[key];
        }
    });
});

var $dczK0 = parcelRequire("dczK0");
Object.keys($dczK0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dczK0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dczK0[key];
        }
    });
});

var $yUvqg = parcelRequire("yUvqg");
Object.keys($yUvqg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $yUvqg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $yUvqg[key];
        }
    });
});

var $aVG2I = parcelRequire("aVG2I");
Object.keys($aVG2I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aVG2I[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aVG2I[key];
        }
    });
});

var $l6lCN = parcelRequire("l6lCN");
Object.keys($l6lCN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l6lCN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l6lCN[key];
        }
    });
});

var $hJaAX = parcelRequire("hJaAX");
Object.keys($hJaAX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hJaAX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hJaAX[key];
        }
    });
});

var $41GzP = parcelRequire("41GzP");
Object.keys($41GzP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $41GzP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $41GzP[key];
        }
    });
});

var $74dx3 = parcelRequire("74dx3");
Object.keys($74dx3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $74dx3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $74dx3[key];
        }
    });
});

var $3TYro = parcelRequire("3TYro");
Object.keys($3TYro).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3TYro[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3TYro[key];
        }
    });
});

var $hlkYe = parcelRequire("hlkYe");
Object.keys($hlkYe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hlkYe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hlkYe[key];
        }
    });
});

var $5Wbnw = parcelRequire("5Wbnw");
Object.keys($5Wbnw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Wbnw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Wbnw[key];
        }
    });
});

var $9Q62z = parcelRequire("9Q62z");
Object.keys($9Q62z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9Q62z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9Q62z[key];
        }
    });
});

var $8YzuS = parcelRequire("8YzuS");
Object.keys($8YzuS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8YzuS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8YzuS[key];
        }
    });
});

var $hhPe8 = parcelRequire("hhPe8");
Object.keys($hhPe8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hhPe8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hhPe8[key];
        }
    });
});

var $4UfuH = parcelRequire("4UfuH");
Object.keys($4UfuH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4UfuH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4UfuH[key];
        }
    });
});

var $l1Ixk = parcelRequire("l1Ixk");
Object.keys($l1Ixk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l1Ixk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l1Ixk[key];
        }
    });
});

var $5WWIe = parcelRequire("5WWIe");
Object.keys($5WWIe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5WWIe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5WWIe[key];
        }
    });
});

var $lJMKo = parcelRequire("lJMKo");
Object.keys($lJMKo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lJMKo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lJMKo[key];
        }
    });
});

var $bPkc1 = parcelRequire("bPkc1");
Object.keys($bPkc1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bPkc1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bPkc1[key];
        }
    });
});

var $lDPqg = parcelRequire("lDPqg");
Object.keys($lDPqg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lDPqg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lDPqg[key];
        }
    });
});

var $kbygx = parcelRequire("kbygx");
Object.keys($kbygx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kbygx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kbygx[key];
        }
    });
});

var $8mExm = parcelRequire("8mExm");
Object.keys($8mExm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8mExm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8mExm[key];
        }
    });
});

var $3md94 = parcelRequire("3md94");
Object.keys($3md94).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3md94[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3md94[key];
        }
    });
});

var $l55Kk = parcelRequire("l55Kk");
Object.keys($l55Kk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l55Kk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l55Kk[key];
        }
    });
});

var $4bKCH = parcelRequire("4bKCH");
Object.keys($4bKCH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4bKCH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4bKCH[key];
        }
    });
});

var $fQ1E0 = parcelRequire("fQ1E0");
Object.keys($fQ1E0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fQ1E0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fQ1E0[key];
        }
    });
});

var $8o5Na = parcelRequire("8o5Na");
Object.keys($8o5Na).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8o5Na[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8o5Na[key];
        }
    });
});

var $9yMjm = parcelRequire("9yMjm");
Object.keys($9yMjm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9yMjm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9yMjm[key];
        }
    });
});

var $f32BC = parcelRequire("f32BC");
Object.keys($f32BC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f32BC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f32BC[key];
        }
    });
});

var $jymNW = parcelRequire("jymNW");
Object.keys($jymNW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jymNW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jymNW[key];
        }
    });
});

var $kfEGt = parcelRequire("kfEGt");
Object.keys($kfEGt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kfEGt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kfEGt[key];
        }
    });
});

var $bQMlt = parcelRequire("bQMlt");
Object.keys($bQMlt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bQMlt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bQMlt[key];
        }
    });
});

var $cw6ua = parcelRequire("cw6ua");
Object.keys($cw6ua).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cw6ua[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cw6ua[key];
        }
    });
});

var $4znFA = parcelRequire("4znFA");
Object.keys($4znFA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4znFA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4znFA[key];
        }
    });
});

var $edv5c = parcelRequire("edv5c");
Object.keys($edv5c).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $edv5c[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $edv5c[key];
        }
    });
});

var $hdXd9 = parcelRequire("hdXd9");
Object.keys($hdXd9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hdXd9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hdXd9[key];
        }
    });
});

var $c0jYB = parcelRequire("c0jYB");
Object.keys($c0jYB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c0jYB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c0jYB[key];
        }
    });
});

var $gvMSR = parcelRequire("gvMSR");
Object.keys($gvMSR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gvMSR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gvMSR[key];
        }
    });
});

var $uw6ye = parcelRequire("uw6ye");
Object.keys($uw6ye).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $uw6ye[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $uw6ye[key];
        }
    });
});

var $5abwi = parcelRequire("5abwi");
Object.keys($5abwi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5abwi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5abwi[key];
        }
    });
});

var $ljPWF = parcelRequire("ljPWF");
Object.keys($ljPWF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ljPWF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ljPWF[key];
        }
    });
});

var $7syUZ = parcelRequire("7syUZ");
Object.keys($7syUZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7syUZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7syUZ[key];
        }
    });
});

var $87ptp = parcelRequire("87ptp");
Object.keys($87ptp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $87ptp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $87ptp[key];
        }
    });
});

var $kMcoB = parcelRequire("kMcoB");
Object.keys($kMcoB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kMcoB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kMcoB[key];
        }
    });
});

var $lf7yb = parcelRequire("lf7yb");
Object.keys($lf7yb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lf7yb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lf7yb[key];
        }
    });
});

var $g5M5t = parcelRequire("g5M5t");
Object.keys($g5M5t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g5M5t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g5M5t[key];
        }
    });
});

var $6dtTI = parcelRequire("6dtTI");
Object.keys($6dtTI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6dtTI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6dtTI[key];
        }
    });
});

var $kBQeH = parcelRequire("kBQeH");
Object.keys($kBQeH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kBQeH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kBQeH[key];
        }
    });
});

var $hMPMV = parcelRequire("hMPMV");
Object.keys($hMPMV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hMPMV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hMPMV[key];
        }
    });
});

var $fgH89 = parcelRequire("fgH89");
Object.keys($fgH89).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fgH89[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fgH89[key];
        }
    });
});

var $ePNEc = parcelRequire("ePNEc");
Object.keys($ePNEc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ePNEc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ePNEc[key];
        }
    });
});

var $m5fJR = parcelRequire("m5fJR");
Object.keys($m5fJR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $m5fJR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $m5fJR[key];
        }
    });
});

var $5G3Lh = parcelRequire("5G3Lh");
Object.keys($5G3Lh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5G3Lh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5G3Lh[key];
        }
    });
});

var $56Gig = parcelRequire("56Gig");
Object.keys($56Gig).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $56Gig[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $56Gig[key];
        }
    });
});

var $9tNR4 = parcelRequire("9tNR4");
Object.keys($9tNR4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9tNR4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9tNR4[key];
        }
    });
});

var $8rSI2 = parcelRequire("8rSI2");
Object.keys($8rSI2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8rSI2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8rSI2[key];
        }
    });
});

var $fNVra = parcelRequire("fNVra");
Object.keys($fNVra).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fNVra[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fNVra[key];
        }
    });
});

var $5tBn0 = parcelRequire("5tBn0");
Object.keys($5tBn0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5tBn0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5tBn0[key];
        }
    });
});

var $5uitn = parcelRequire("5uitn");
Object.keys($5uitn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5uitn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5uitn[key];
        }
    });
});

var $9OXOc = parcelRequire("9OXOc");
Object.keys($9OXOc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9OXOc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9OXOc[key];
        }
    });
});

var $boABr = parcelRequire("boABr");
Object.keys($boABr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $boABr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $boABr[key];
        }
    });
});

var $dembC = parcelRequire("dembC");
Object.keys($dembC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dembC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dembC[key];
        }
    });
});

var $bz05S = parcelRequire("bz05S");
Object.keys($bz05S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bz05S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bz05S[key];
        }
    });
});

var $2pG9s = parcelRequire("2pG9s");
Object.keys($2pG9s).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2pG9s[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2pG9s[key];
        }
    });
});

var $iUgWT = parcelRequire("iUgWT");
Object.keys($iUgWT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iUgWT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iUgWT[key];
        }
    });
});

var $gugfV = parcelRequire("gugfV");
Object.keys($gugfV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gugfV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gugfV[key];
        }
    });
});

var $nB2ui = parcelRequire("nB2ui");
Object.keys($nB2ui).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $nB2ui[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $nB2ui[key];
        }
    });
});

var $5BZWP = parcelRequire("5BZWP");
Object.keys($5BZWP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5BZWP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5BZWP[key];
        }
    });
});

var $jQtXi = parcelRequire("jQtXi");
Object.keys($jQtXi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jQtXi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jQtXi[key];
        }
    });
});

var $bxI0B = parcelRequire("bxI0B");
Object.keys($bxI0B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bxI0B[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bxI0B[key];
        }
    });
});

var $dmC9V = parcelRequire("dmC9V");
Object.keys($dmC9V).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dmC9V[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dmC9V[key];
        }
    });
});

var $3biK9 = parcelRequire("3biK9");
Object.keys($3biK9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3biK9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3biK9[key];
        }
    });
});

var $baGWJ = parcelRequire("baGWJ");
Object.keys($baGWJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $baGWJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $baGWJ[key];
        }
    });
});

var $ba81a = parcelRequire("ba81a");
Object.keys($ba81a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ba81a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ba81a[key];
        }
    });
});

var $irhDk = parcelRequire("irhDk");
Object.keys($irhDk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $irhDk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $irhDk[key];
        }
    });
});

var $4YyMs = parcelRequire("4YyMs");
Object.keys($4YyMs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4YyMs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4YyMs[key];
        }
    });
});

var $aZjqa = parcelRequire("aZjqa");
Object.keys($aZjqa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aZjqa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aZjqa[key];
        }
    });
});

var $7NYl1 = parcelRequire("7NYl1");
Object.keys($7NYl1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7NYl1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7NYl1[key];
        }
    });
});

var $krF3E = parcelRequire("krF3E");
Object.keys($krF3E).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $krF3E[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $krF3E[key];
        }
    });
});

var $euuF0 = parcelRequire("euuF0");
Object.keys($euuF0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $euuF0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $euuF0[key];
        }
    });
});

var $hHueA = parcelRequire("hHueA");
Object.keys($hHueA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hHueA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hHueA[key];
        }
    });
});

var $35GDA = parcelRequire("35GDA");
Object.keys($35GDA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $35GDA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $35GDA[key];
        }
    });
});

var $bo82R = parcelRequire("bo82R");
Object.keys($bo82R).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bo82R[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bo82R[key];
        }
    });
});

});
parcelRegister("gEhyf", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $c1edff16ac3fded6$export$e16d8520af44a096; }, function (v) { return $c1edff16ac3fded6$export$e16d8520af44a096 = v; });
var $c1edff16ac3fded6$export$e16d8520af44a096;
"use strict";
$c1edff16ac3fded6$export$e16d8520af44a096 = $c1edff16ac3fded6$var$add;

var $2vrAW = parcelRequire("2vrAW");

var $1uoU9 = parcelRequire("1uoU9");

var $5viJK = parcelRequire("5viJK");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $c1edff16ac3fded6$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $7NYl1.toDate)(date);
    const dateWithMonths = months || years ? (0, $1uoU9.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $2vrAW.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $5viJK.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});

parcelRegister("esSds", function(module, exports) {

$parcel$export(module.exports, "addBusinessDays", function () { return $a87dbc6643d10af6$export$f087b9ada3136ae9; }, function (v) { return $a87dbc6643d10af6$export$f087b9ada3136ae9 = v; });
var $a87dbc6643d10af6$export$f087b9ada3136ae9;
"use strict";
$a87dbc6643d10af6$export$f087b9ada3136ae9 = $a87dbc6643d10af6$var$addBusinessDays;

var $5viJK = parcelRequire("5viJK");

var $1jL69 = parcelRequire("1jL69");

var $fW9OG = parcelRequire("fW9OG");

var $fpiN0 = parcelRequire("fpiN0");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $a87dbc6643d10af6$var$addBusinessDays(date, amount) {
    const _date = (0, $7NYl1.toDate)(date);
    const startedOnWeekend = (0, $fpiN0.isWeekend)(_date);
    if (isNaN(amount)) return (0, $5viJK.constructFrom)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $fpiN0.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $fpiN0.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $1jL69.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $fW9OG.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}

});
parcelRegister("1jL69", function(module, exports) {

$parcel$export(module.exports, "isSaturday", function () { return $0f5c1980bc915dc8$export$def9f260655b3a76; }, function (v) { return $0f5c1980bc915dc8$export$def9f260655b3a76 = v; });
var $0f5c1980bc915dc8$export$def9f260655b3a76;
"use strict";
$0f5c1980bc915dc8$export$def9f260655b3a76 = $0f5c1980bc915dc8$var$isSaturday;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $0f5c1980bc915dc8$var$isSaturday(date) {
    return (0, $7NYl1.toDate)(date).getDay() === 6;
}

});

parcelRegister("fW9OG", function(module, exports) {

$parcel$export(module.exports, "isSunday", function () { return $b9a3e3288d91ec88$export$70f720dfc6028987; }, function (v) { return $b9a3e3288d91ec88$export$70f720dfc6028987 = v; });
var $b9a3e3288d91ec88$export$70f720dfc6028987;
"use strict";
$b9a3e3288d91ec88$export$70f720dfc6028987 = $b9a3e3288d91ec88$var$isSunday;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $b9a3e3288d91ec88$var$isSunday(date) {
    return (0, $7NYl1.toDate)(date).getDay() === 0;
}

});

parcelRegister("fpiN0", function(module, exports) {

$parcel$export(module.exports, "isWeekend", function () { return $b377c3fc12e14341$export$618d60ea299da42; }, function (v) { return $b377c3fc12e14341$export$618d60ea299da42 = v; });
var $b377c3fc12e14341$export$618d60ea299da42;
"use strict";
$b377c3fc12e14341$export$618d60ea299da42 = $b377c3fc12e14341$var$isWeekend;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $b377c3fc12e14341$var$isWeekend(date) {
    const day = (0, $7NYl1.toDate)(date).getDay();
    return day === 0 || day === 6;
}

});


parcelRegister("2AWhK", function(module, exports) {

$parcel$export(module.exports, "addISOWeekYears", function () { return $1e3c27ccf2c979b3$export$c8240694da10d5f; }, function (v) { return $1e3c27ccf2c979b3$export$c8240694da10d5f = v; });
var $1e3c27ccf2c979b3$export$c8240694da10d5f;
"use strict";
$1e3c27ccf2c979b3$export$c8240694da10d5f = $1e3c27ccf2c979b3$var$addISOWeekYears;

var $VphlE = parcelRequire("VphlE");

var $7syUZ = parcelRequire("7syUZ");
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $1e3c27ccf2c979b3$var$addISOWeekYears(date, amount) {
    return (0, $7syUZ.setISOWeekYear)(date, (0, $VphlE.getISOWeekYear)(date) + amount);
}

});
parcelRegister("7syUZ", function(module, exports) {

$parcel$export(module.exports, "setISOWeekYear", function () { return $56e63bf4c6a29173$export$814397aabf10ab77; }, function (v) { return $56e63bf4c6a29173$export$814397aabf10ab77 = v; });
var $56e63bf4c6a29173$export$814397aabf10ab77;
"use strict";
$56e63bf4c6a29173$export$814397aabf10ab77 = $56e63bf4c6a29173$var$setISOWeekYear;

var $5viJK = parcelRequire("5viJK");

var $jaIwE = parcelRequire("jaIwE");

var $9tNR4 = parcelRequire("9tNR4");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $56e63bf4c6a29173$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $7NYl1.toDate)(date);
    const diff = (0, $jaIwE.differenceInCalendarDays)(_date, (0, $9tNR4.startOfISOWeekYear)(_date));
    const fourthOfJanuary = (0, $5viJK.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $9tNR4.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("42N2s", function(module, exports) {

$parcel$export(module.exports, "addSeconds", function () { return $2f1d636430cfe7d1$export$3cb31b0df13be68; }, function (v) { return $2f1d636430cfe7d1$export$3cb31b0df13be68 = v; });
var $2f1d636430cfe7d1$export$3cb31b0df13be68;
"use strict";
$2f1d636430cfe7d1$export$3cb31b0df13be68 = $2f1d636430cfe7d1$var$addSeconds;

var $32aF3 = parcelRequire("32aF3");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $2f1d636430cfe7d1$var$addSeconds(date, amount) {
    return (0, $32aF3.addMilliseconds)(date, amount * 1000);
}

});

parcelRegister("6OkTI", function(module, exports) {

$parcel$export(module.exports, "areIntervalsOverlapping", function () { return $4f579f72de12eba7$export$2bf3385645436101; }, function (v) { return $4f579f72de12eba7$export$2bf3385645436101 = v; });
var $4f579f72de12eba7$export$2bf3385645436101;
"use strict";
$4f579f72de12eba7$export$2bf3385645436101 = $4f579f72de12eba7$var$areIntervalsOverlapping;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $4f579f72de12eba7$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $7NYl1.toDate)(intervalLeft.start),
        +(0, $7NYl1.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $7NYl1.toDate)(intervalRight.start),
        +(0, $7NYl1.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

});

parcelRegister("8BQdJ", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $644a4955f7467685$export$7d15b64cf5a3a4c4; }, function (v) { return $644a4955f7467685$export$7d15b64cf5a3a4c4 = v; });
var $644a4955f7467685$export$7d15b64cf5a3a4c4;
"use strict";
$644a4955f7467685$export$7d15b64cf5a3a4c4 = $644a4955f7467685$var$clamp;

var $7nRuI = parcelRequire("7nRuI");

var $dczK0 = parcelRequire("dczK0");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $644a4955f7467685$var$clamp(date, interval) {
    return (0, $dczK0.min)([
        (0, $7nRuI.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}

});

parcelRegister("g42hP", function(module, exports) {

$parcel$export(module.exports, "closestIndexTo", function () { return $bb1ecb219770177a$export$42127b72a9d091c7; }, function (v) { return $bb1ecb219770177a$export$42127b72a9d091c7 = v; });
var $bb1ecb219770177a$export$42127b72a9d091c7;
"use strict";
$bb1ecb219770177a$export$42127b72a9d091c7 = $bb1ecb219770177a$var$closestIndexTo;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $bb1ecb219770177a$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $7NYl1.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $7NYl1.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("6c4Hu", function(module, exports) {

$parcel$export(module.exports, "closestTo", function () { return $4827827e2752ecb2$export$73858b464497125a; }, function (v) { return $4827827e2752ecb2$export$73858b464497125a = v; });
var $4827827e2752ecb2$export$73858b464497125a;
"use strict";
$4827827e2752ecb2$export$73858b464497125a = $4827827e2752ecb2$var$closestTo;

var $5viJK = parcelRequire("5viJK");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $4827827e2752ecb2$var$closestTo(dateToCompare, dates) {
    const date = (0, $7NYl1.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, $5viJK.constructFrom)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $7NYl1.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $5viJK.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("du4Y6", function(module, exports) {

$parcel$export(module.exports, "compareAsc", function () { return $9d11ee5010fd7fd2$export$fe114145ae75d197; }, function (v) { return $9d11ee5010fd7fd2$export$fe114145ae75d197 = v; });
var $9d11ee5010fd7fd2$export$fe114145ae75d197;
"use strict";
$9d11ee5010fd7fd2$export$fe114145ae75d197 = $9d11ee5010fd7fd2$var$compareAsc;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $9d11ee5010fd7fd2$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("aKGxR", function(module, exports) {

$parcel$export(module.exports, "compareDesc", function () { return $7d3f33dbb26e8c5d$export$ed84005ac9356f7a; }, function (v) { return $7d3f33dbb26e8c5d$export$ed84005ac9356f7a = v; });
var $7d3f33dbb26e8c5d$export$ed84005ac9356f7a;
"use strict";
$7d3f33dbb26e8c5d$export$ed84005ac9356f7a = $7d3f33dbb26e8c5d$var$compareDesc;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $7d3f33dbb26e8c5d$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

});

parcelRegister("lcXac", function(module, exports) {

$parcel$export(module.exports, "constructNow", function () { return $f7089c97c6a0534f$export$18c3c6510fb97afc; }, function (v) { return $f7089c97c6a0534f$export$18c3c6510fb97afc = v; });
var $f7089c97c6a0534f$export$18c3c6510fb97afc;
"use strict";
$f7089c97c6a0534f$export$18c3c6510fb97afc = $f7089c97c6a0534f$var$constructNow;

var $5viJK = parcelRequire("5viJK");
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $f7089c97c6a0534f$var$constructNow(date) {
    return (0, $5viJK.constructFrom)(date, Date.now());
}

});

parcelRegister("2hvBi", function(module, exports) {

$parcel$export(module.exports, "daysToWeeks", function () { return $1a95ae7d3193f007$export$66d8b66cbb6006a8; }, function (v) { return $1a95ae7d3193f007$export$66d8b66cbb6006a8 = v; });
var $1a95ae7d3193f007$export$66d8b66cbb6006a8;
"use strict";
$1a95ae7d3193f007$export$66d8b66cbb6006a8 = $1a95ae7d3193f007$var$daysToWeeks;

var $kMovx = parcelRequire("kMovx");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $1a95ae7d3193f007$var$daysToWeeks(days) {
    const weeks = days / $kMovx.daysInWeek;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("26XKE", function(module, exports) {

$parcel$export(module.exports, "differenceInBusinessDays", function () { return $189a7dad1a495dc1$export$f30d3269a6c53cb9; }, function (v) { return $189a7dad1a495dc1$export$f30d3269a6c53cb9 = v; });
var $189a7dad1a495dc1$export$f30d3269a6c53cb9;
"use strict";
$189a7dad1a495dc1$export$f30d3269a6c53cb9 = $189a7dad1a495dc1$var$differenceInBusinessDays;

var $2vrAW = parcelRequire("2vrAW");

var $jaIwE = parcelRequire("jaIwE");

var $73v8c = parcelRequire("73v8c");

var $4pFgQ = parcelRequire("4pFgQ");

var $fpiN0 = parcelRequire("fpiN0");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $189a7dad1a495dc1$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    let _dateRight = (0, $7NYl1.toDate)(dateRight);
    if (!(0, $4pFgQ.isValid)(_dateLeft) || !(0, $4pFgQ.isValid)(_dateRight)) return NaN;
    const calendarDifference = (0, $jaIwE.differenceInCalendarDays)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $2vrAW.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $73v8c.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $fpiN0.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, $2vrAW.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("9NFa1", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeekYears", function () { return $72289e480704177a$export$7f8a73dc2e50a070; }, function (v) { return $72289e480704177a$export$7f8a73dc2e50a070 = v; });
var $72289e480704177a$export$7f8a73dc2e50a070;
"use strict";
$72289e480704177a$export$7f8a73dc2e50a070 = $72289e480704177a$var$differenceInCalendarISOWeekYears;

var $VphlE = parcelRequire("VphlE");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $72289e480704177a$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $VphlE.getISOWeekYear)(dateLeft) - (0, $VphlE.getISOWeekYear)(dateRight);
}

});

parcelRegister("2ll1D", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeeks", function () { return $1b4dda21587bec3b$export$28df1cb58b17e450; }, function (v) { return $1b4dda21587bec3b$export$28df1cb58b17e450 = v; });
var $1b4dda21587bec3b$export$28df1cb58b17e450;
"use strict";
$1b4dda21587bec3b$export$28df1cb58b17e450 = $1b4dda21587bec3b$var$differenceInCalendarISOWeeks;

var $kMovx = parcelRequire("kMovx");

var $56Gig = parcelRequire("56Gig");

var $eBj5w = parcelRequire("eBj5w");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $1b4dda21587bec3b$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $56Gig.startOfISOWeek)(dateLeft);
    const startOfISOWeekRight = (0, $56Gig.startOfISOWeek)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $kMovx.millisecondsInWeek);
}

});

parcelRegister("jq8bc", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarWeeks", function () { return $e236ca50ed207452$export$6ed034ce62348e4; }, function (v) { return $e236ca50ed207452$export$6ed034ce62348e4 = v; });
var $e236ca50ed207452$export$6ed034ce62348e4;
"use strict";
$e236ca50ed207452$export$6ed034ce62348e4 = $e236ca50ed207452$var$differenceInCalendarWeeks;

var $kMovx = parcelRequire("kMovx");

var $dembC = parcelRequire("dembC");

var $eBj5w = parcelRequire("eBj5w");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $e236ca50ed207452$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $dembC.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, $dembC.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $kMovx.millisecondsInWeek);
}

});

parcelRegister("b22mw", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", function () { return $8081b6ba28ba7bbd$export$86415ebf4eb36b8c; }, function (v) { return $8081b6ba28ba7bbd$export$86415ebf4eb36b8c = v; });
var $8081b6ba28ba7bbd$export$86415ebf4eb36b8c;
"use strict";
$8081b6ba28ba7bbd$export$86415ebf4eb36b8c = $8081b6ba28ba7bbd$var$differenceInDays;

var $jaIwE = parcelRequire("jaIwE");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $8081b6ba28ba7bbd$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const sign = $8081b6ba28ba7bbd$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $jaIwE.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($8081b6ba28ba7bbd$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $8081b6ba28ba7bbd$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("3B2eR", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", function () { return $29e69057fb17f854$export$5436ca250d4d6872; }, function (v) { return $29e69057fb17f854$export$5436ca250d4d6872 = v; });
var $29e69057fb17f854$export$5436ca250d4d6872;
"use strict";
$29e69057fb17f854$export$5436ca250d4d6872 = $29e69057fb17f854$var$differenceInHours;

var $l5U4C = parcelRequire("l5U4C");

var $kMovx = parcelRequire("kMovx");

var $bNAOX = parcelRequire("bNAOX");
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $29e69057fb17f854$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $bNAOX.differenceInMilliseconds)(dateLeft, dateRight) / $kMovx.millisecondsInHour;
    return (0, $l5U4C.getRoundingMethod)(options?.roundingMethod)(diff);
}

});
parcelRegister("l5U4C", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $f5b58fa739c63567$export$b6474a47258c1211; }, function (v) { return $f5b58fa739c63567$export$b6474a47258c1211 = v; });
var $f5b58fa739c63567$export$b6474a47258c1211;
"use strict";
$f5b58fa739c63567$export$b6474a47258c1211 = $f5b58fa739c63567$var$getRoundingMethod;
function $f5b58fa739c63567$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("bNAOX", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", function () { return $8970d5309760eae3$export$7be94d13716b4bf6; }, function (v) { return $8970d5309760eae3$export$7be94d13716b4bf6 = v; });
var $8970d5309760eae3$export$7be94d13716b4bf6;
"use strict";
$8970d5309760eae3$export$7be94d13716b4bf6 = $8970d5309760eae3$var$differenceInMilliseconds;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $8970d5309760eae3$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $7NYl1.toDate)(dateLeft) - +(0, $7NYl1.toDate)(dateRight);
}

});


parcelRegister("jYsuj", function(module, exports) {

$parcel$export(module.exports, "differenceInISOWeekYears", function () { return $e8a9b80768d16b5d$export$bf7bde0b3bf8913a; }, function (v) { return $e8a9b80768d16b5d$export$bf7bde0b3bf8913a = v; });
var $e8a9b80768d16b5d$export$bf7bde0b3bf8913a;
"use strict";
$e8a9b80768d16b5d$export$bf7bde0b3bf8913a = $e8a9b80768d16b5d$var$differenceInISOWeekYears;

var $du4Y6 = parcelRequire("du4Y6");

var $9NFa1 = parcelRequire("9NFa1");

var $bxI0B = parcelRequire("bxI0B");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $e8a9b80768d16b5d$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const sign = (0, $du4Y6.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $9NFa1.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, $bxI0B.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $du4Y6.compareAsc)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("bxI0B", function(module, exports) {

$parcel$export(module.exports, "subISOWeekYears", function () { return $8674e9fc93c8cddc$export$4f7d47b952f4a0aa; }, function (v) { return $8674e9fc93c8cddc$export$4f7d47b952f4a0aa = v; });
var $8674e9fc93c8cddc$export$4f7d47b952f4a0aa;
"use strict";
$8674e9fc93c8cddc$export$4f7d47b952f4a0aa = $8674e9fc93c8cddc$var$subISOWeekYears;

var $2AWhK = parcelRequire("2AWhK");
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $8674e9fc93c8cddc$var$subISOWeekYears(date, amount) {
    return (0, $2AWhK.addISOWeekYears)(date, -amount);
}

});


parcelRegister("6aND4", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", function () { return $47ea2c970fbeb74b$export$d904251335be481a; }, function (v) { return $47ea2c970fbeb74b$export$d904251335be481a = v; });
var $47ea2c970fbeb74b$export$d904251335be481a;
"use strict";
$47ea2c970fbeb74b$export$d904251335be481a = $47ea2c970fbeb74b$var$differenceInMinutes;

var $l5U4C = parcelRequire("l5U4C");

var $kMovx = parcelRequire("kMovx");

var $bNAOX = parcelRequire("bNAOX");
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $47ea2c970fbeb74b$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $bNAOX.differenceInMilliseconds)(dateLeft, dateRight) / $kMovx.millisecondsInMinute;
    return (0, $l5U4C.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("ltGKA", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", function () { return $fa2d77c3ee883dd9$export$fc1ed482c2861792; }, function (v) { return $fa2d77c3ee883dd9$export$fc1ed482c2861792 = v; });
var $fa2d77c3ee883dd9$export$fc1ed482c2861792;
"use strict";
$fa2d77c3ee883dd9$export$fc1ed482c2861792 = $fa2d77c3ee883dd9$var$differenceInMonths;

var $du4Y6 = parcelRequire("du4Y6");

var $8pkT1 = parcelRequire("8pkT1");

var $2AGyL = parcelRequire("2AGyL");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $fa2d77c3ee883dd9$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const sign = (0, $du4Y6.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $8pkT1.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $du4Y6.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2AGyL.isLastDayOfMonth)((0, $7NYl1.toDate)(dateLeft)) && difference === 1 && (0, $du4Y6.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("2AGyL", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", function () { return $1e2ff503507bab1d$export$c817d0312007ea5e; }, function (v) { return $1e2ff503507bab1d$export$c817d0312007ea5e = v; });
var $1e2ff503507bab1d$export$c817d0312007ea5e;
"use strict";
$1e2ff503507bab1d$export$c817d0312007ea5e = $1e2ff503507bab1d$var$isLastDayOfMonth;

var $exWqC = parcelRequire("exWqC");

var $lVNbV = parcelRequire("lVNbV");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $1e2ff503507bab1d$var$isLastDayOfMonth(date) {
    const _date = (0, $7NYl1.toDate)(date);
    return +(0, $exWqC.endOfDay)(_date) === +(0, $lVNbV.endOfMonth)(_date);
}

});


parcelRegister("eOWeV", function(module, exports) {

$parcel$export(module.exports, "differenceInQuarters", function () { return $aca2e960c8a0b4da$export$74b5c4055a405552; }, function (v) { return $aca2e960c8a0b4da$export$74b5c4055a405552 = v; });
var $aca2e960c8a0b4da$export$74b5c4055a405552;
"use strict";
$aca2e960c8a0b4da$export$74b5c4055a405552 = $aca2e960c8a0b4da$var$differenceInQuarters;

var $l5U4C = parcelRequire("l5U4C");

var $ltGKA = parcelRequire("ltGKA");
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $aca2e960c8a0b4da$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $ltGKA.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, $l5U4C.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("2o9YY", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", function () { return $1bd590fa69efb146$export$c1889aec51783710; }, function (v) { return $1bd590fa69efb146$export$c1889aec51783710 = v; });
var $1bd590fa69efb146$export$c1889aec51783710;
"use strict";
$1bd590fa69efb146$export$c1889aec51783710 = $1bd590fa69efb146$var$differenceInSeconds;

var $l5U4C = parcelRequire("l5U4C");

var $bNAOX = parcelRequire("bNAOX");
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $1bd590fa69efb146$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $bNAOX.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, $l5U4C.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("hyJk4", function(module, exports) {

$parcel$export(module.exports, "differenceInWeeks", function () { return $cc88c4c6deae4872$export$b5147a91dc40ddb7; }, function (v) { return $cc88c4c6deae4872$export$b5147a91dc40ddb7 = v; });
var $cc88c4c6deae4872$export$b5147a91dc40ddb7;
"use strict";
$cc88c4c6deae4872$export$b5147a91dc40ddb7 = $cc88c4c6deae4872$var$differenceInWeeks;

var $l5U4C = parcelRequire("l5U4C");

var $b22mw = parcelRequire("b22mw");
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $cc88c4c6deae4872$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $b22mw.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, $l5U4C.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("hZM1i", function(module, exports) {

$parcel$export(module.exports, "differenceInYears", function () { return $d19d61f13e9e1863$export$ed6bf486f68899ca; }, function (v) { return $d19d61f13e9e1863$export$ed6bf486f68899ca = v; });
var $d19d61f13e9e1863$export$ed6bf486f68899ca;
"use strict";
$d19d61f13e9e1863$export$ed6bf486f68899ca = $d19d61f13e9e1863$var$differenceInYears;

var $du4Y6 = parcelRequire("du4Y6");

var $8EzaS = parcelRequire("8EzaS");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $d19d61f13e9e1863$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $7NYl1.toDate)(dateLeft);
    const _dateRight = (0, $7NYl1.toDate)(dateRight);
    const sign = (0, $du4Y6.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $8EzaS.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $du4Y6.compareAsc)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("1Ywvk", function(module, exports) {

$parcel$export(module.exports, "eachDayOfInterval", function () { return $17049bb7de423d0c$export$7a337e5923c7ceb5; }, function (v) { return $17049bb7de423d0c$export$7a337e5923c7ceb5 = v; });
var $17049bb7de423d0c$export$7a337e5923c7ceb5;
"use strict";
$17049bb7de423d0c$export$7a337e5923c7ceb5 = $17049bb7de423d0c$var$eachDayOfInterval;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $17049bb7de423d0c$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $7NYl1.toDate)(interval.start);
    const endDate = (0, $7NYl1.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $7NYl1.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("2hnEA", function(module, exports) {

$parcel$export(module.exports, "eachHourOfInterval", function () { return $1a8f84694ac1cf27$export$bb4f48fee90ea86e; }, function (v) { return $1a8f84694ac1cf27$export$bb4f48fee90ea86e = v; });
var $1a8f84694ac1cf27$export$bb4f48fee90ea86e;
"use strict";
$1a8f84694ac1cf27$export$bb4f48fee90ea86e = $1a8f84694ac1cf27$var$eachHourOfInterval;

var $lk4ac = parcelRequire("lk4ac");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $1a8f84694ac1cf27$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $7NYl1.toDate)(interval.start);
    const endDate = (0, $7NYl1.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $7NYl1.toDate)(currentDate));
        currentDate = (0, $lk4ac.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("awqIG", function(module, exports) {

$parcel$export(module.exports, "eachMinuteOfInterval", function () { return $7a919e89db66b907$export$82e17d693ce9eb6c; }, function (v) { return $7a919e89db66b907$export$82e17d693ce9eb6c = v; });
var $7a919e89db66b907$export$82e17d693ce9eb6c;
"use strict";
$7a919e89db66b907$export$82e17d693ce9eb6c = $7a919e89db66b907$var$eachMinuteOfInterval;

var $9VdIH = parcelRequire("9VdIH");

var $8rSI2 = parcelRequire("8rSI2");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $7a919e89db66b907$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $8rSI2.startOfMinute)((0, $7NYl1.toDate)(interval.start));
    const endDate = (0, $7NYl1.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $7NYl1.toDate)(currentDate));
        currentDate = (0, $9VdIH.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("8rSI2", function(module, exports) {

$parcel$export(module.exports, "startOfMinute", function () { return $626b487ca2d26c27$export$c66440458c6aa793; }, function (v) { return $626b487ca2d26c27$export$c66440458c6aa793 = v; });
var $626b487ca2d26c27$export$c66440458c6aa793;
"use strict";
$626b487ca2d26c27$export$c66440458c6aa793 = $626b487ca2d26c27$var$startOfMinute;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $626b487ca2d26c27$var$startOfMinute(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}

});


parcelRegister("cBY1o", function(module, exports) {

$parcel$export(module.exports, "eachMonthOfInterval", function () { return $92e77fbd156c6384$export$1c9322f2d2a5eed3; }, function (v) { return $92e77fbd156c6384$export$1c9322f2d2a5eed3 = v; });
var $92e77fbd156c6384$export$1c9322f2d2a5eed3;
"use strict";
$92e77fbd156c6384$export$1c9322f2d2a5eed3 = $92e77fbd156c6384$var$eachMonthOfInterval;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $92e77fbd156c6384$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $7NYl1.toDate)(interval.start);
    const endDate = (0, $7NYl1.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $7NYl1.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("20n6r", function(module, exports) {

$parcel$export(module.exports, "eachQuarterOfInterval", function () { return $175d809bb3f034bd$export$96790a0abfab0078; }, function (v) { return $175d809bb3f034bd$export$96790a0abfab0078 = v; });
var $175d809bb3f034bd$export$96790a0abfab0078;
"use strict";
$175d809bb3f034bd$export$96790a0abfab0078 = $175d809bb3f034bd$var$eachQuarterOfInterval;

var $ejkpp = parcelRequire("ejkpp");

var $5tBn0 = parcelRequire("5tBn0");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $175d809bb3f034bd$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $7NYl1.toDate)(interval.start);
    const endDate = (0, $7NYl1.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $5tBn0.startOfQuarter)(startDate) : +(0, $5tBn0.startOfQuarter)(endDate);
    let currentDate = reversed ? (0, $5tBn0.startOfQuarter)(endDate) : (0, $5tBn0.startOfQuarter)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $7NYl1.toDate)(currentDate));
        currentDate = (0, $ejkpp.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("4h9Lx", function(module, exports) {

$parcel$export(module.exports, "eachWeekOfInterval", function () { return $31d0533a70a8c4e6$export$d31a8caec75fa456; }, function (v) { return $31d0533a70a8c4e6$export$d31a8caec75fa456 = v; });
var $31d0533a70a8c4e6$export$d31a8caec75fa456;
"use strict";
$31d0533a70a8c4e6$export$d31a8caec75fa456 = $31d0533a70a8c4e6$var$eachWeekOfInterval;

var $1hExc = parcelRequire("1hExc");

var $dembC = parcelRequire("dembC");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $31d0533a70a8c4e6$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $7NYl1.toDate)(interval.start);
    const endDate = (0, $7NYl1.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $dembC.startOfWeek)(endDate, options) : (0, $dembC.startOfWeek)(startDate, options);
    const endDateWeek = reversed ? (0, $dembC.startOfWeek)(startDate, options) : (0, $dembC.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $7NYl1.toDate)(currentDate));
        currentDate = (0, $1hExc.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("4uJYT", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfInterval", function () { return $345da1a78529cf98$export$a2ae85dd849354a8; }, function (v) { return $345da1a78529cf98$export$a2ae85dd849354a8 = v; });
var $345da1a78529cf98$export$a2ae85dd849354a8;
"use strict";
$345da1a78529cf98$export$a2ae85dd849354a8 = $345da1a78529cf98$var$eachWeekendOfInterval;

var $1Ywvk = parcelRequire("1Ywvk");

var $fpiN0 = parcelRequire("fpiN0");
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $345da1a78529cf98$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $1Ywvk.eachDayOfInterval)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $fpiN0.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}

});

parcelRegister("1T9ve", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfMonth", function () { return $16024c897a3a8a1a$export$f9a185d0ad232d17; }, function (v) { return $16024c897a3a8a1a$export$f9a185d0ad232d17 = v; });
var $16024c897a3a8a1a$export$f9a185d0ad232d17;
"use strict";
$16024c897a3a8a1a$export$f9a185d0ad232d17 = $16024c897a3a8a1a$var$eachWeekendOfMonth;

var $4uJYT = parcelRequire("4uJYT");

var $lVNbV = parcelRequire("lVNbV");

var $fNVra = parcelRequire("fNVra");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $16024c897a3a8a1a$var$eachWeekendOfMonth(date) {
    const start = (0, $fNVra.startOfMonth)(date);
    const end = (0, $lVNbV.endOfMonth)(date);
    return (0, $4uJYT.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});

parcelRegister("kYXKC", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfYear", function () { return $03f1284c6e740f54$export$d4a9e5efc1ddceb9; }, function (v) { return $03f1284c6e740f54$export$d4a9e5efc1ddceb9 = v; });
var $03f1284c6e740f54$export$d4a9e5efc1ddceb9;
"use strict";
$03f1284c6e740f54$export$d4a9e5efc1ddceb9 = $03f1284c6e740f54$var$eachWeekendOfYear;

var $4uJYT = parcelRequire("4uJYT");

var $72tdj = parcelRequire("72tdj");

var $2pG9s = parcelRequire("2pG9s");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $03f1284c6e740f54$var$eachWeekendOfYear(date) {
    const start = (0, $2pG9s.startOfYear)(date);
    const end = (0, $72tdj.endOfYear)(date);
    return (0, $4uJYT.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});

parcelRegister("6sgoi", function(module, exports) {

$parcel$export(module.exports, "eachYearOfInterval", function () { return $4b3212801f3051d2$export$9b7f165f0a71d2a5; }, function (v) { return $4b3212801f3051d2$export$9b7f165f0a71d2a5 = v; });
var $4b3212801f3051d2$export$9b7f165f0a71d2a5;
"use strict";
$4b3212801f3051d2$export$9b7f165f0a71d2a5 = $4b3212801f3051d2$var$eachYearOfInterval;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $4b3212801f3051d2$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $7NYl1.toDate)(interval.start);
    const endDate = (0, $7NYl1.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $7NYl1.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("7kD58", function(module, exports) {

$parcel$export(module.exports, "endOfDecade", function () { return $5568b77c501af272$export$b922ac31d5bbe7a6; }, function (v) { return $5568b77c501af272$export$b922ac31d5bbe7a6 = v; });
var $5568b77c501af272$export$b922ac31d5bbe7a6;
"use strict";
$5568b77c501af272$export$b922ac31d5bbe7a6 = $5568b77c501af272$var$endOfDecade;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $5568b77c501af272$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("aCong", function(module, exports) {

$parcel$export(module.exports, "endOfHour", function () { return $7bb05c2ee70ab9e9$export$95ae95d2176c5f0; }, function (v) { return $7bb05c2ee70ab9e9$export$95ae95d2176c5f0 = v; });
var $7bb05c2ee70ab9e9$export$95ae95d2176c5f0;
"use strict";
$7bb05c2ee70ab9e9$export$95ae95d2176c5f0 = $7bb05c2ee70ab9e9$var$endOfHour;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $7bb05c2ee70ab9e9$var$endOfHour(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}

});

parcelRegister("alaze", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeek", function () { return $78740ff9de330f5d$export$186cd934f32084be; }, function (v) { return $78740ff9de330f5d$export$186cd934f32084be = v; });
var $78740ff9de330f5d$export$186cd934f32084be;
"use strict";
$78740ff9de330f5d$export$186cd934f32084be = $78740ff9de330f5d$var$endOfISOWeek;

var $8mcDi = parcelRequire("8mcDi");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $78740ff9de330f5d$var$endOfISOWeek(date) {
    return (0, $8mcDi.endOfWeek)(date, {
        weekStartsOn: 1
    });
}

});

parcelRegister("cfw9z", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeekYear", function () { return $8eafd3bd79411015$export$73068f3824c9c1d; }, function (v) { return $8eafd3bd79411015$export$73068f3824c9c1d = v; });
var $8eafd3bd79411015$export$73068f3824c9c1d;
"use strict";
$8eafd3bd79411015$export$73068f3824c9c1d = $8eafd3bd79411015$var$endOfISOWeekYear;

var $VphlE = parcelRequire("VphlE");

var $56Gig = parcelRequire("56Gig");

var $5viJK = parcelRequire("5viJK");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $8eafd3bd79411015$var$endOfISOWeekYear(date) {
    const year = (0, $VphlE.getISOWeekYear)(date);
    const fourthOfJanuaryOfNextYear = (0, $5viJK.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $56Gig.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}

});

parcelRegister("lH32C", function(module, exports) {

$parcel$export(module.exports, "endOfMinute", function () { return $fcaff91049525df7$export$a06a772fc63bff07; }, function (v) { return $fcaff91049525df7$export$a06a772fc63bff07 = v; });
var $fcaff91049525df7$export$a06a772fc63bff07;
"use strict";
$fcaff91049525df7$export$a06a772fc63bff07 = $fcaff91049525df7$var$endOfMinute;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $fcaff91049525df7$var$endOfMinute(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}

});

parcelRegister("8Qg9u", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", function () { return $66ffb58b887e8be1$export$5f53493861eef879; }, function (v) { return $66ffb58b887e8be1$export$5f53493861eef879 = v; });
var $66ffb58b887e8be1$export$5f53493861eef879;
"use strict";
$66ffb58b887e8be1$export$5f53493861eef879 = $66ffb58b887e8be1$var$endOfQuarter;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $66ffb58b887e8be1$var$endOfQuarter(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("jizcV", function(module, exports) {

$parcel$export(module.exports, "endOfSecond", function () { return $e0cb0236f23d24e4$export$ef560ab2fa7b52a2; }, function (v) { return $e0cb0236f23d24e4$export$ef560ab2fa7b52a2 = v; });
var $e0cb0236f23d24e4$export$ef560ab2fa7b52a2;
"use strict";
$e0cb0236f23d24e4$export$ef560ab2fa7b52a2 = $e0cb0236f23d24e4$var$endOfSecond;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $e0cb0236f23d24e4$var$endOfSecond(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}

});

parcelRegister("9dVqn", function(module, exports) {

$parcel$export(module.exports, "endOfToday", function () { return $6b71df41cf90fc1f$export$1b7031a80bd92a6e; }, function (v) { return $6b71df41cf90fc1f$export$1b7031a80bd92a6e = v; });
var $6b71df41cf90fc1f$export$1b7031a80bd92a6e;
"use strict";
$6b71df41cf90fc1f$export$1b7031a80bd92a6e = $6b71df41cf90fc1f$var$endOfToday;

var $exWqC = parcelRequire("exWqC");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $6b71df41cf90fc1f$var$endOfToday() {
    return (0, $exWqC.endOfDay)(Date.now());
}

});

parcelRegister("7CgVw", function(module, exports) {

$parcel$export(module.exports, "endOfTomorrow", function () { return $58b9364c4e2b45e7$export$d788ac27ae2a54ea; }, function (v) { return $58b9364c4e2b45e7$export$d788ac27ae2a54ea = v; });
var $58b9364c4e2b45e7$export$d788ac27ae2a54ea;
"use strict";
$58b9364c4e2b45e7$export$d788ac27ae2a54ea = $58b9364c4e2b45e7$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $58b9364c4e2b45e7$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("7Uazv", function(module, exports) {

$parcel$export(module.exports, "endOfYesterday", function () { return $5c15f6b1ecf6347a$export$45190faf1024f97a; }, function (v) { return $5c15f6b1ecf6347a$export$45190faf1024f97a = v; });
var $5c15f6b1ecf6347a$export$45190faf1024f97a;
"use strict";
$5c15f6b1ecf6347a$export$45190faf1024f97a = $5c15f6b1ecf6347a$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $5c15f6b1ecf6347a$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("iKYfi", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $da7b416403869855$export$2c14ff85d6318973; }, function (v) { return $da7b416403869855$export$2c14ff85d6318973 = v; });
var $da7b416403869855$export$2c14ff85d6318973;
"use strict";
$da7b416403869855$export$2c14ff85d6318973 = $da7b416403869855$var$formatDistance;

var $du4Y6 = parcelRequire("du4Y6");

var $kMovx = parcelRequire("kMovx");

var $ltGKA = parcelRequire("ltGKA");

var $2o9YY = parcelRequire("2o9YY");

var $7NYl1 = parcelRequire("7NYl1");

var $s26wx = parcelRequire("s26wx");

var $f8DjC = parcelRequire("f8DjC");

var $eBj5w = parcelRequire("eBj5w");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $da7b416403869855$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $s26wx.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $du4Y6.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $7NYl1.toDate)(baseDate);
        dateRight = (0, $7NYl1.toDate)(date);
    } else {
        dateLeft = (0, $7NYl1.toDate)(date);
        dateRight = (0, $7NYl1.toDate)(baseDate);
    }
    const seconds = (0, $2o9YY.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $eBj5w.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $kMovx.minutesInDay) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $kMovx.minutesInMonth) {
        const days = Math.round(minutes / $kMovx.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $kMovx.minutesInMonth * 2) {
        months = Math.round(minutes / $kMovx.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $ltGKA.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $kMovx.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

});

parcelRegister("3V3VQ", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", function () { return $2da9becc27b3a9ac$export$e4be225b8ee0a759; }, function (v) { return $2da9becc27b3a9ac$export$e4be225b8ee0a759 = v; });
var $2da9becc27b3a9ac$export$e4be225b8ee0a759;
"use strict";
$2da9becc27b3a9ac$export$e4be225b8ee0a759 = $2da9becc27b3a9ac$var$formatDistanceStrict;

var $s26wx = parcelRequire("s26wx");

var $f8DjC = parcelRequire("f8DjC");

var $l5U4C = parcelRequire("l5U4C");

var $eBj5w = parcelRequire("eBj5w");

var $du4Y6 = parcelRequire("du4Y6");

var $kMovx = parcelRequire("kMovx");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $2da9becc27b3a9ac$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $s26wx.defaultLocale;
    const comparison = (0, $du4Y6.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $7NYl1.toDate)(baseDate);
        dateRight = (0, $7NYl1.toDate)(date);
    } else {
        dateLeft = (0, $7NYl1.toDate)(date);
        dateRight = (0, $7NYl1.toDate)(baseDate);
    }
    const roundingMethod = (0, $l5U4C.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $kMovx.millisecondsInMinute;
    const timezoneOffset = (0, $eBj5w.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $kMovx.millisecondsInMinute;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $kMovx.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < $kMovx.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < $kMovx.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $kMovx.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $kMovx.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $kMovx.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}

});

parcelRegister("joimB", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", function () { return $e1de80daae801d4b$export$d130c20a256f8817; }, function (v) { return $e1de80daae801d4b$export$d130c20a256f8817 = v; });
var $e1de80daae801d4b$export$d130c20a256f8817;
"use strict";
$e1de80daae801d4b$export$d130c20a256f8817 = $e1de80daae801d4b$var$formatDistanceToNow;

var $lcXac = parcelRequire("lcXac");

var $iKYfi = parcelRequire("iKYfi");
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $e1de80daae801d4b$var$formatDistanceToNow(date, options) {
    return (0, $iKYfi.formatDistance)(date, (0, $lcXac.constructNow)(date), options);
}

});

parcelRegister("lDYot", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNowStrict", function () { return $fc1c1667e898a2af$export$d0e02d4eb1ad1e32; }, function (v) { return $fc1c1667e898a2af$export$d0e02d4eb1ad1e32 = v; });
var $fc1c1667e898a2af$export$d0e02d4eb1ad1e32;
"use strict";
$fc1c1667e898a2af$export$d0e02d4eb1ad1e32 = $fc1c1667e898a2af$var$formatDistanceToNowStrict;

var $3V3VQ = parcelRequire("3V3VQ");

var $lcXac = parcelRequire("lcXac");
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $fc1c1667e898a2af$var$formatDistanceToNowStrict(date, options) {
    return (0, $3V3VQ.formatDistanceStrict)(date, (0, $lcXac.constructNow)(date), options);
}

});

parcelRegister("37W9Q", function(module, exports) {

$parcel$export(module.exports, "formatDuration", function () { return $246f2378efe3269c$export$bc733b0c5cbb3e8a; }, function (v) { return $246f2378efe3269c$export$bc733b0c5cbb3e8a = v; });
var $246f2378efe3269c$export$bc733b0c5cbb3e8a;
"use strict";
$246f2378efe3269c$export$bc733b0c5cbb3e8a = $246f2378efe3269c$var$formatDuration;

var $s26wx = parcelRequire("s26wx");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link formatDuration} function options.
 */ const $246f2378efe3269c$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $246f2378efe3269c$var$formatDuration(duration, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $s26wx.defaultLocale;
    const format = options?.format ?? $246f2378efe3269c$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

});

parcelRegister("6hucJ", function(module, exports) {

$parcel$export(module.exports, "formatISO", function () { return $492bc293da7c50d3$export$3c826ac3ab9da76c; }, function (v) { return $492bc293da7c50d3$export$3c826ac3ab9da76c = v; });
var $492bc293da7c50d3$export$3c826ac3ab9da76c;
"use strict";
$492bc293da7c50d3$export$3c826ac3ab9da76c = $492bc293da7c50d3$var$formatISO;

var $7NYl1 = parcelRequire("7NYl1");

var $fx1dE = parcelRequire("fx1dE");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $492bc293da7c50d3$var$formatISO(date, options) {
    const _date = (0, $7NYl1.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $fx1dE.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $fx1dE.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $fx1dE.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $fx1dE.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $fx1dE.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $fx1dE.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $fx1dE.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $fx1dE.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}

});

parcelRegister("7Z3RP", function(module, exports) {

$parcel$export(module.exports, "formatISO9075", function () { return $5d013ada75f8387c$export$a673944250043fa4; }, function (v) { return $5d013ada75f8387c$export$a673944250043fa4 = v; });
var $5d013ada75f8387c$export$a673944250043fa4;
"use strict";
$5d013ada75f8387c$export$a673944250043fa4 = $5d013ada75f8387c$var$formatISO9075;

var $4pFgQ = parcelRequire("4pFgQ");

var $7NYl1 = parcelRequire("7NYl1");

var $fx1dE = parcelRequire("fx1dE");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $5d013ada75f8387c$var$formatISO9075(date, options) {
    const _date = (0, $7NYl1.toDate)(date);
    if (!(0, $4pFgQ.isValid)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $fx1dE.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $fx1dE.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $fx1dE.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $fx1dE.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $fx1dE.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $fx1dE.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}

});

parcelRegister("aDwZh", function(module, exports) {

$parcel$export(module.exports, "formatISODuration", function () { return $7be722873e22a908$export$437c31ab743f6b26; }, function (v) { return $7be722873e22a908$export$437c31ab743f6b26 = v; });
var $7be722873e22a908$export$437c31ab743f6b26;
"use strict";
$7be722873e22a908$export$437c31ab743f6b26 = $7be722873e22a908$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $7be722873e22a908$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

});

parcelRegister("kBG3L", function(module, exports) {

$parcel$export(module.exports, "formatRFC3339", function () { return $f007e3836b15f833$export$6d441bffeec6bd6c; }, function (v) { return $f007e3836b15f833$export$6d441bffeec6bd6c = v; });
var $f007e3836b15f833$export$6d441bffeec6bd6c;
"use strict";
$f007e3836b15f833$export$6d441bffeec6bd6c = $f007e3836b15f833$var$formatRFC3339;

var $4pFgQ = parcelRequire("4pFgQ");

var $7NYl1 = parcelRequire("7NYl1");

var $fx1dE = parcelRequire("fx1dE");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $f007e3836b15f833$var$formatRFC3339(date, options) {
    const _date = (0, $7NYl1.toDate)(date);
    if (!(0, $4pFgQ.isValid)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $fx1dE.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, $fx1dE.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $fx1dE.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, $fx1dE.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, $fx1dE.addLeadingZeros)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $fx1dE.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $fx1dE.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $fx1dE.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

});

parcelRegister("89M7d", function(module, exports) {

$parcel$export(module.exports, "formatRFC7231", function () { return $5f047cb1deec7738$export$7add2e4539ce658a; }, function (v) { return $5f047cb1deec7738$export$7add2e4539ce658a = v; });
var $5f047cb1deec7738$export$7add2e4539ce658a;
"use strict";
$5f047cb1deec7738$export$7add2e4539ce658a = $5f047cb1deec7738$var$formatRFC7231;

var $4pFgQ = parcelRequire("4pFgQ");

var $7NYl1 = parcelRequire("7NYl1");

var $fx1dE = parcelRequire("fx1dE");
const $5f047cb1deec7738$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $5f047cb1deec7738$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $5f047cb1deec7738$var$formatRFC7231(date) {
    const _date = (0, $7NYl1.toDate)(date);
    if (!(0, $4pFgQ.isValid)(_date)) throw new RangeError("Invalid time value");
    const dayName = $5f047cb1deec7738$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $fx1dE.addLeadingZeros)(_date.getUTCDate(), 2);
    const monthName = $5f047cb1deec7738$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $fx1dE.addLeadingZeros)(_date.getUTCHours(), 2);
    const minute = (0, $fx1dE.addLeadingZeros)(_date.getUTCMinutes(), 2);
    const second = (0, $fx1dE.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

});

parcelRegister("lfcGS", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f774d7c30e4c9dc3$export$8fbbfd65594f46a0; }, function (v) { return $f774d7c30e4c9dc3$export$8fbbfd65594f46a0 = v; });
var $f774d7c30e4c9dc3$export$8fbbfd65594f46a0;
"use strict";
$f774d7c30e4c9dc3$export$8fbbfd65594f46a0 = $f774d7c30e4c9dc3$var$formatRelative;

var $jaIwE = parcelRequire("jaIwE");

var $9IzSo = parcelRequire("9IzSo");

var $7NYl1 = parcelRequire("7NYl1");

var $s26wx = parcelRequire("s26wx");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $f774d7c30e4c9dc3$var$formatRelative(date, baseDate, options) {
    const _date = (0, $7NYl1.toDate)(date);
    const _baseDate = (0, $7NYl1.toDate)(baseDate);
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $s26wx.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $jaIwE.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $9IzSo.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

});

parcelRegister("72LQN", function(module, exports) {

$parcel$export(module.exports, "fromUnixTime", function () { return $520dd66a4d1d0d7f$export$3664df8597731ed4; }, function (v) { return $520dd66a4d1d0d7f$export$3664df8597731ed4 = v; });
var $520dd66a4d1d0d7f$export$3664df8597731ed4;
"use strict";
$520dd66a4d1d0d7f$export$3664df8597731ed4 = $520dd66a4d1d0d7f$var$fromUnixTime;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $520dd66a4d1d0d7f$var$fromUnixTime(unixTime) {
    return (0, $7NYl1.toDate)(unixTime * 1000);
}

});

parcelRegister("4vqPW", function(module, exports) {

$parcel$export(module.exports, "getDaysInYear", function () { return $347edfe1700ad524$export$63a4a9fc49e3550e; }, function (v) { return $347edfe1700ad524$export$63a4a9fc49e3550e = v; });
var $347edfe1700ad524$export$63a4a9fc49e3550e;
"use strict";
$347edfe1700ad524$export$63a4a9fc49e3550e = $347edfe1700ad524$var$getDaysInYear;

var $2VN4v = parcelRequire("2VN4v");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $347edfe1700ad524$var$getDaysInYear(date) {
    const _date = (0, $7NYl1.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $2VN4v.isLeapYear)(_date) ? 366 : 365;
}

});
parcelRegister("2VN4v", function(module, exports) {

$parcel$export(module.exports, "isLeapYear", function () { return $2226f840a0478afb$export$553d7fa8e3805fc0; }, function (v) { return $2226f840a0478afb$export$553d7fa8e3805fc0 = v; });
var $2226f840a0478afb$export$553d7fa8e3805fc0;
"use strict";
$2226f840a0478afb$export$553d7fa8e3805fc0 = $2226f840a0478afb$var$isLeapYear;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $2226f840a0478afb$var$isLeapYear(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});


parcelRegister("kgz3L", function(module, exports) {

$parcel$export(module.exports, "getDecade", function () { return $ec107f64df60bd07$export$5bc0f4decfc52b64; }, function (v) { return $ec107f64df60bd07$export$5bc0f4decfc52b64 = v; });
var $ec107f64df60bd07$export$5bc0f4decfc52b64;
"use strict";
$ec107f64df60bd07$export$5bc0f4decfc52b64 = $ec107f64df60bd07$var$getDecade;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $ec107f64df60bd07$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}

});

parcelRegister("83vBF", function(module, exports) {

$parcel$export(module.exports, "getISOWeeksInYear", function () { return $5dd71ef1dc200681$export$822983242a16750f; }, function (v) { return $5dd71ef1dc200681$export$822983242a16750f = v; });
var $5dd71ef1dc200681$export$822983242a16750f;
"use strict";
$5dd71ef1dc200681$export$822983242a16750f = $5dd71ef1dc200681$var$getISOWeeksInYear;

var $1hExc = parcelRequire("1hExc");

var $kMovx = parcelRequire("kMovx");

var $9tNR4 = parcelRequire("9tNR4");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $5dd71ef1dc200681$var$getISOWeeksInYear(date) {
    const thisYear = (0, $9tNR4.startOfISOWeekYear)(date);
    const nextYear = (0, $9tNR4.startOfISOWeekYear)((0, $1hExc.addWeeks)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $kMovx.millisecondsInWeek);
}

});

parcelRegister("3JYJz", function(module, exports) {

$parcel$export(module.exports, "getMilliseconds", function () { return $2b94af8cfdc92aec$export$b8e4380f312797af; }, function (v) { return $2b94af8cfdc92aec$export$b8e4380f312797af = v; });
var $2b94af8cfdc92aec$export$b8e4380f312797af;
"use strict";
$2b94af8cfdc92aec$export$b8e4380f312797af = $2b94af8cfdc92aec$var$getMilliseconds;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $2b94af8cfdc92aec$var$getMilliseconds(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

});

parcelRegister("9uEO5", function(module, exports) {

$parcel$export(module.exports, "getOverlappingDaysInIntervals", function () { return $6e9691cd9e1736c1$export$baae148532bd1d46; }, function (v) { return $6e9691cd9e1736c1$export$baae148532bd1d46 = v; });
var $6e9691cd9e1736c1$export$baae148532bd1d46;
"use strict";
$6e9691cd9e1736c1$export$baae148532bd1d46 = $6e9691cd9e1736c1$var$getOverlappingDaysInIntervals;

var $eBj5w = parcelRequire("eBj5w");

var $kMovx = parcelRequire("kMovx");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $6e9691cd9e1736c1$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $7NYl1.toDate)(intervalLeft.start),
        +(0, $7NYl1.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $7NYl1.toDate)(intervalRight.start),
        +(0, $7NYl1.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $eBj5w.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $kMovx.millisecondsInDay);
}

});

parcelRegister("7N1mJ", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", function () { return $5abe2b2fa13cc5a5$export$1f77c0008d16313; }, function (v) { return $5abe2b2fa13cc5a5$export$1f77c0008d16313 = v; });
var $5abe2b2fa13cc5a5$export$1f77c0008d16313;
"use strict";
$5abe2b2fa13cc5a5$export$1f77c0008d16313 = $5abe2b2fa13cc5a5$var$getUnixTime;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $5abe2b2fa13cc5a5$var$getUnixTime(date) {
    return Math.trunc(+(0, $7NYl1.toDate)(date) / 1000);
}

});

parcelRegister("jh645", function(module, exports) {

$parcel$export(module.exports, "getWeekOfMonth", function () { return $e0844f3bce699f11$export$59fb9b85a4d8d027; }, function (v) { return $e0844f3bce699f11$export$59fb9b85a4d8d027 = v; });
var $e0844f3bce699f11$export$59fb9b85a4d8d027;
"use strict";
$e0844f3bce699f11$export$59fb9b85a4d8d027 = $e0844f3bce699f11$var$getWeekOfMonth;

var $4sou0 = parcelRequire("4sou0");

var $7Vb0N = parcelRequire("7Vb0N");

var $fNVra = parcelRequire("fNVra");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $e0844f3bce699f11$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $4sou0.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $7Vb0N.getDay)((0, $fNVra.startOfMonth)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

});

parcelRegister("gd1pn", function(module, exports) {

$parcel$export(module.exports, "getWeeksInMonth", function () { return $bccef3e4d97f8ca9$export$ccc1b2479e7dd654; }, function (v) { return $bccef3e4d97f8ca9$export$ccc1b2479e7dd654 = v; });
var $bccef3e4d97f8ca9$export$ccc1b2479e7dd654;
"use strict";
$bccef3e4d97f8ca9$export$ccc1b2479e7dd654 = $bccef3e4d97f8ca9$var$getWeeksInMonth;

var $jq8bc = parcelRequire("jq8bc");

var $i6KAU = parcelRequire("i6KAU");

var $fNVra = parcelRequire("fNVra");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $bccef3e4d97f8ca9$var$getWeeksInMonth(date, options) {
    return (0, $jq8bc.differenceInCalendarWeeks)((0, $i6KAU.lastDayOfMonth)(date), (0, $fNVra.startOfMonth)(date), options) + 1;
}

});
parcelRegister("i6KAU", function(module, exports) {

$parcel$export(module.exports, "lastDayOfMonth", function () { return $d2ecee34ba5f5cda$export$36818250d6c87922; }, function (v) { return $d2ecee34ba5f5cda$export$36818250d6c87922 = v; });
var $d2ecee34ba5f5cda$export$36818250d6c87922;
"use strict";
$d2ecee34ba5f5cda$export$36818250d6c87922 = $d2ecee34ba5f5cda$var$lastDayOfMonth;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $d2ecee34ba5f5cda$var$lastDayOfMonth(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("8ieyg", function(module, exports) {

$parcel$export(module.exports, "hoursToMilliseconds", function () { return $609b4ad57ba824e1$export$5b42ab7a22898b69; }, function (v) { return $609b4ad57ba824e1$export$5b42ab7a22898b69 = v; });
var $609b4ad57ba824e1$export$5b42ab7a22898b69;
"use strict";
$609b4ad57ba824e1$export$5b42ab7a22898b69 = $609b4ad57ba824e1$var$hoursToMilliseconds;

var $kMovx = parcelRequire("kMovx");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $609b4ad57ba824e1$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $kMovx.millisecondsInHour);
}

});

parcelRegister("bTsKH", function(module, exports) {

$parcel$export(module.exports, "hoursToMinutes", function () { return $8a8b2257bda63441$export$83bfc73cdf89a4d8; }, function (v) { return $8a8b2257bda63441$export$83bfc73cdf89a4d8 = v; });
var $8a8b2257bda63441$export$83bfc73cdf89a4d8;
"use strict";
$8a8b2257bda63441$export$83bfc73cdf89a4d8 = $8a8b2257bda63441$var$hoursToMinutes;

var $kMovx = parcelRequire("kMovx");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $8a8b2257bda63441$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $kMovx.minutesInHour);
}

});

parcelRegister("6s9yy", function(module, exports) {

$parcel$export(module.exports, "hoursToSeconds", function () { return $4b2cc55053635e1d$export$59b1396ccbd5a4e1; }, function (v) { return $4b2cc55053635e1d$export$59b1396ccbd5a4e1 = v; });
var $4b2cc55053635e1d$export$59b1396ccbd5a4e1;
"use strict";
$4b2cc55053635e1d$export$59b1396ccbd5a4e1 = $4b2cc55053635e1d$var$hoursToSeconds;

var $kMovx = parcelRequire("kMovx");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $4b2cc55053635e1d$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $kMovx.secondsInHour);
}

});

parcelRegister("dORoq", function(module, exports) {

$parcel$export(module.exports, "interval", function () { return $a0f95c94f33c6d84$export$3174cdbf0a0cbc84; }, function (v) { return $a0f95c94f33c6d84$export$3174cdbf0a0cbc84 = v; });
var $a0f95c94f33c6d84$export$3174cdbf0a0cbc84;
"use strict";
$a0f95c94f33c6d84$export$3174cdbf0a0cbc84 = $a0f95c94f33c6d84$var$interval;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $a0f95c94f33c6d84$var$interval(start, end, options) {
    const _start = (0, $7NYl1.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $7NYl1.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}

});

parcelRegister("cLZbZ", function(module, exports) {

$parcel$export(module.exports, "intervalToDuration", function () { return $94c9575893f29b6d$export$7b6c9a626316863; }, function (v) { return $94c9575893f29b6d$export$7b6c9a626316863 = v; });
var $94c9575893f29b6d$export$7b6c9a626316863;
"use strict";
$94c9575893f29b6d$export$7b6c9a626316863 = $94c9575893f29b6d$var$intervalToDuration;

var $gEhyf = parcelRequire("gEhyf");

var $b22mw = parcelRequire("b22mw");

var $3B2eR = parcelRequire("3B2eR");

var $6aND4 = parcelRequire("6aND4");

var $ltGKA = parcelRequire("ltGKA");

var $2o9YY = parcelRequire("2o9YY");

var $hZM1i = parcelRequire("hZM1i");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $94c9575893f29b6d$var$intervalToDuration(interval) {
    const start = (0, $7NYl1.toDate)(interval.start);
    const end = (0, $7NYl1.toDate)(interval.end);
    const duration = {};
    const years = (0, $hZM1i.differenceInYears)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $gEhyf.add)(start, {
        years: duration.years
    });
    const months = (0, $ltGKA.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $gEhyf.add)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $b22mw.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $gEhyf.add)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $3B2eR.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $gEhyf.add)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $6aND4.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $gEhyf.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $2o9YY.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}

});

parcelRegister("fbMXk", function(module, exports) {

$parcel$export(module.exports, "intlFormat", function () { return $b0eddbb4f9afd7f8$export$f58f1234eed71f82; }, function (v) { return $b0eddbb4f9afd7f8$export$f58f1234eed71f82 = v; });
var $b0eddbb4f9afd7f8$export$f58f1234eed71f82;
"use strict";
$b0eddbb4f9afd7f8$export$f58f1234eed71f82 = $b0eddbb4f9afd7f8$var$intlFormat;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $b0eddbb4f9afd7f8$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($b0eddbb4f9afd7f8$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $7NYl1.toDate)(date));
}
function $b0eddbb4f9afd7f8$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}

});

parcelRegister("btRbY", function(module, exports) {

$parcel$export(module.exports, "intlFormatDistance", function () { return $85bba9fdcce659f4$export$a110a4020280fd5; }, function (v) { return $85bba9fdcce659f4$export$a110a4020280fd5 = v; });
var $85bba9fdcce659f4$export$a110a4020280fd5;
"use strict";
$85bba9fdcce659f4$export$a110a4020280fd5 = $85bba9fdcce659f4$var$intlFormatDistance;

var $kMovx = parcelRequire("kMovx");

var $jaIwE = parcelRequire("jaIwE");

var $8pkT1 = parcelRequire("8pkT1");

var $lesSB = parcelRequire("lesSB");

var $jq8bc = parcelRequire("jq8bc");

var $8EzaS = parcelRequire("8EzaS");

var $3B2eR = parcelRequire("3B2eR");

var $6aND4 = parcelRequire("6aND4");

var $2o9YY = parcelRequire("2o9YY");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $85bba9fdcce659f4$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $7NYl1.toDate)(date);
    const dateRight = (0, $7NYl1.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $2o9YY.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $kMovx.secondsInMinute) {
            value = (0, $2o9YY.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $kMovx.secondsInHour) {
            value = (0, $6aND4.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $kMovx.secondsInDay && Math.abs((0, $jaIwE.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, $3B2eR.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $kMovx.secondsInWeek && (value = (0, $jaIwE.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $kMovx.secondsInMonth) {
            value = (0, $jq8bc.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $kMovx.secondsInQuarter) {
            value = (0, $8pkT1.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $kMovx.secondsInYear) {
            if ((0, $lesSB.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $lesSB.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $8EzaS.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $8EzaS.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $2o9YY.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $6aND4.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $3B2eR.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $jaIwE.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $jq8bc.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $8pkT1.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $lesSB.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $8EzaS.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}

});

parcelRegister("3hqWf", function(module, exports) {

$parcel$export(module.exports, "isExists", function () { return $2637db0cc7612393$export$127519e0edcdc58b; }, function (v) { return $2637db0cc7612393$export$127519e0edcdc58b = v; });
var $2637db0cc7612393$export$127519e0edcdc58b;
"use strict";
$2637db0cc7612393$export$127519e0edcdc58b = $2637db0cc7612393$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $2637db0cc7612393$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

});

parcelRegister("4jIPU", function(module, exports) {

$parcel$export(module.exports, "isFirstDayOfMonth", function () { return $324bb7558db2b961$export$2716a425049f51dd; }, function (v) { return $324bb7558db2b961$export$2716a425049f51dd = v; });
var $324bb7558db2b961$export$2716a425049f51dd;
"use strict";
$324bb7558db2b961$export$2716a425049f51dd = $324bb7558db2b961$var$isFirstDayOfMonth;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $324bb7558db2b961$var$isFirstDayOfMonth(date) {
    return (0, $7NYl1.toDate)(date).getDate() === 1;
}

});

parcelRegister("dMmHn", function(module, exports) {

$parcel$export(module.exports, "isFriday", function () { return $a0815d88d07bb256$export$3b7d89f127884993; }, function (v) { return $a0815d88d07bb256$export$3b7d89f127884993 = v; });
var $a0815d88d07bb256$export$3b7d89f127884993;
"use strict";
$a0815d88d07bb256$export$3b7d89f127884993 = $a0815d88d07bb256$var$isFriday;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $a0815d88d07bb256$var$isFriday(date) {
    return (0, $7NYl1.toDate)(date).getDay() === 5;
}

});

parcelRegister("jwfj8", function(module, exports) {

$parcel$export(module.exports, "isFuture", function () { return $e35ce13d2cf656ae$export$2baac2df6018cd7; }, function (v) { return $e35ce13d2cf656ae$export$2baac2df6018cd7 = v; });
var $e35ce13d2cf656ae$export$2baac2df6018cd7;
"use strict";
$e35ce13d2cf656ae$export$2baac2df6018cd7 = $e35ce13d2cf656ae$var$isFuture;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $e35ce13d2cf656ae$var$isFuture(date) {
    return +(0, $7NYl1.toDate)(date) > Date.now();
}

});

parcelRegister("gHo0W", function(module, exports) {

$parcel$export(module.exports, "isMatch", function () { return $c2834a3c09dab656$export$b74c33566721f70f; }, function (v) { return $c2834a3c09dab656$export$b74c33566721f70f = v; });
var $c2834a3c09dab656$export$b74c33566721f70f;
"use strict";
$c2834a3c09dab656$export$b74c33566721f70f = $c2834a3c09dab656$var$isMatch;

var $4pFgQ = parcelRequire("4pFgQ");

var $l1Ixk = parcelRequire("l1Ixk");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $c2834a3c09dab656$var$isMatch(dateStr, formatStr, options) {
    return (0, $4pFgQ.isValid)((0, $l1Ixk.parse)(dateStr, formatStr, new Date(), options));
}

});

parcelRegister("gX9mk", function(module, exports) {

$parcel$export(module.exports, "isMonday", function () { return $c5796a949e343ac4$export$9573fe9b7c9ac3f5; }, function (v) { return $c5796a949e343ac4$export$9573fe9b7c9ac3f5 = v; });
var $c5796a949e343ac4$export$9573fe9b7c9ac3f5;
"use strict";
$c5796a949e343ac4$export$9573fe9b7c9ac3f5 = $c5796a949e343ac4$var$isMonday;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $c5796a949e343ac4$var$isMonday(date) {
    return (0, $7NYl1.toDate)(date).getDay() === 1;
}

});

parcelRegister("iZCBT", function(module, exports) {

$parcel$export(module.exports, "isPast", function () { return $dd3bdfacb4d8f45a$export$fc5014aa3db48558; }, function (v) { return $dd3bdfacb4d8f45a$export$fc5014aa3db48558 = v; });
var $dd3bdfacb4d8f45a$export$fc5014aa3db48558;
"use strict";
$dd3bdfacb4d8f45a$export$fc5014aa3db48558 = $dd3bdfacb4d8f45a$var$isPast;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $dd3bdfacb4d8f45a$var$isPast(date) {
    return +(0, $7NYl1.toDate)(date) < Date.now();
}

});

parcelRegister("7fw9p", function(module, exports) {

$parcel$export(module.exports, "isSameHour", function () { return $5472df94464ed1c3$export$f9f3a94a0371013; }, function (v) { return $5472df94464ed1c3$export$f9f3a94a0371013 = v; });
var $5472df94464ed1c3$export$f9f3a94a0371013;
"use strict";
$5472df94464ed1c3$export$f9f3a94a0371013 = $5472df94464ed1c3$var$isSameHour;

var $5G3Lh = parcelRequire("5G3Lh");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $5472df94464ed1c3$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $5G3Lh.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, $5G3Lh.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

});
parcelRegister("5G3Lh", function(module, exports) {

$parcel$export(module.exports, "startOfHour", function () { return $4223caf45afe2f59$export$24f91f68e7c9d9d5; }, function (v) { return $4223caf45afe2f59$export$24f91f68e7c9d9d5 = v; });
var $4223caf45afe2f59$export$24f91f68e7c9d9d5;
"use strict";
$4223caf45afe2f59$export$24f91f68e7c9d9d5 = $4223caf45afe2f59$var$startOfHour;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $4223caf45afe2f59$var$startOfHour(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

});


parcelRegister("fpN6P", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeek", function () { return $b38f48e077d7fed9$export$1c6e74e3c7b27764; }, function (v) { return $b38f48e077d7fed9$export$1c6e74e3c7b27764 = v; });
var $b38f48e077d7fed9$export$1c6e74e3c7b27764;
"use strict";
$b38f48e077d7fed9$export$1c6e74e3c7b27764 = $b38f48e077d7fed9$var$isSameISOWeek;

var $7E3R5 = parcelRequire("7E3R5");
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $b38f48e077d7fed9$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $7E3R5.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}

});
parcelRegister("7E3R5", function(module, exports) {

$parcel$export(module.exports, "isSameWeek", function () { return $590f42610ba43a6d$export$6ea683876c36b8d2; }, function (v) { return $590f42610ba43a6d$export$6ea683876c36b8d2 = v; });
var $590f42610ba43a6d$export$6ea683876c36b8d2;
"use strict";
$590f42610ba43a6d$export$6ea683876c36b8d2 = $590f42610ba43a6d$var$isSameWeek;

var $dembC = parcelRequire("dembC");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $590f42610ba43a6d$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $dembC.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $dembC.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

});


parcelRegister("kLUir", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeekYear", function () { return $f1f3ddb5996aefc7$export$5f55dbf38a1aee81; }, function (v) { return $f1f3ddb5996aefc7$export$5f55dbf38a1aee81 = v; });
var $f1f3ddb5996aefc7$export$5f55dbf38a1aee81;
"use strict";
$f1f3ddb5996aefc7$export$5f55dbf38a1aee81 = $f1f3ddb5996aefc7$var$isSameISOWeekYear;

var $9tNR4 = parcelRequire("9tNR4");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $f1f3ddb5996aefc7$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $9tNR4.startOfISOWeekYear)(dateLeft);
    const dateRightStartOfYear = (0, $9tNR4.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}

});

parcelRegister("sYhzN", function(module, exports) {

$parcel$export(module.exports, "isSameMinute", function () { return $0571607c79308887$export$5d274bf63c8705cb; }, function (v) { return $0571607c79308887$export$5d274bf63c8705cb = v; });
var $0571607c79308887$export$5d274bf63c8705cb;
"use strict";
$0571607c79308887$export$5d274bf63c8705cb = $0571607c79308887$var$isSameMinute;

var $8rSI2 = parcelRequire("8rSI2");
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $0571607c79308887$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $8rSI2.startOfMinute)(dateLeft);
    const dateRightStartOfMinute = (0, $8rSI2.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

});

parcelRegister("fQKG7", function(module, exports) {

$parcel$export(module.exports, "isSameSecond", function () { return $b89febab23a2baf9$export$b88fbcfe038f3498; }, function (v) { return $b89febab23a2baf9$export$b88fbcfe038f3498 = v; });
var $b89febab23a2baf9$export$b88fbcfe038f3498;
"use strict";
$b89febab23a2baf9$export$b88fbcfe038f3498 = $b89febab23a2baf9$var$isSameSecond;

var $5uitn = parcelRequire("5uitn");
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $b89febab23a2baf9$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $5uitn.startOfSecond)(dateLeft);
    const dateRightStartOfSecond = (0, $5uitn.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

});
parcelRegister("5uitn", function(module, exports) {

$parcel$export(module.exports, "startOfSecond", function () { return $3fee1569e60323ee$export$66c51f9715fdbff5; }, function (v) { return $3fee1569e60323ee$export$66c51f9715fdbff5 = v; });
var $3fee1569e60323ee$export$66c51f9715fdbff5;
"use strict";
$3fee1569e60323ee$export$66c51f9715fdbff5 = $3fee1569e60323ee$var$startOfSecond;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $3fee1569e60323ee$var$startOfSecond(date) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}

});


parcelRegister("bpm6C", function(module, exports) {

$parcel$export(module.exports, "isThisHour", function () { return $84e32d3be31341a2$export$5d41bdc7172839b9; }, function (v) { return $84e32d3be31341a2$export$5d41bdc7172839b9 = v; });
var $84e32d3be31341a2$export$5d41bdc7172839b9;
"use strict";
$84e32d3be31341a2$export$5d41bdc7172839b9 = $84e32d3be31341a2$var$isThisHour;

var $lcXac = parcelRequire("lcXac");

var $7fw9p = parcelRequire("7fw9p");
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $84e32d3be31341a2$var$isThisHour(date) {
    return (0, $7fw9p.isSameHour)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("6zZTc", function(module, exports) {

$parcel$export(module.exports, "isThisISOWeek", function () { return $4ca604e376ac76d1$export$4e987896c721f753; }, function (v) { return $4ca604e376ac76d1$export$4e987896c721f753 = v; });
var $4ca604e376ac76d1$export$4e987896c721f753;
"use strict";
$4ca604e376ac76d1$export$4e987896c721f753 = $4ca604e376ac76d1$var$isThisISOWeek;

var $lcXac = parcelRequire("lcXac");

var $fpN6P = parcelRequire("fpN6P");
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $4ca604e376ac76d1$var$isThisISOWeek(date) {
    return (0, $fpN6P.isSameISOWeek)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("2jLKP", function(module, exports) {

$parcel$export(module.exports, "isThisMinute", function () { return $1b02661b1201b5b1$export$fa55b7d29d8d957a; }, function (v) { return $1b02661b1201b5b1$export$fa55b7d29d8d957a = v; });
var $1b02661b1201b5b1$export$fa55b7d29d8d957a;
"use strict";
$1b02661b1201b5b1$export$fa55b7d29d8d957a = $1b02661b1201b5b1$var$isThisMinute;

var $lcXac = parcelRequire("lcXac");

var $sYhzN = parcelRequire("sYhzN");
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $1b02661b1201b5b1$var$isThisMinute(date) {
    return (0, $sYhzN.isSameMinute)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("ayh6X", function(module, exports) {

$parcel$export(module.exports, "isThisMonth", function () { return $7aea5a47b86ba84c$export$173f1e1d92847276; }, function (v) { return $7aea5a47b86ba84c$export$173f1e1d92847276 = v; });
var $7aea5a47b86ba84c$export$173f1e1d92847276;
"use strict";
$7aea5a47b86ba84c$export$173f1e1d92847276 = $7aea5a47b86ba84c$var$isThisMonth;

var $lcXac = parcelRequire("lcXac");

var $9qPPc = parcelRequire("9qPPc");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $7aea5a47b86ba84c$var$isThisMonth(date) {
    return (0, $9qPPc.isSameMonth)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("hnniR", function(module, exports) {

$parcel$export(module.exports, "isThisQuarter", function () { return $ca66a92ca7ec52d6$export$3d88fd18ab599ccc; }, function (v) { return $ca66a92ca7ec52d6$export$3d88fd18ab599ccc = v; });
var $ca66a92ca7ec52d6$export$3d88fd18ab599ccc;
"use strict";
$ca66a92ca7ec52d6$export$3d88fd18ab599ccc = $ca66a92ca7ec52d6$var$isThisQuarter;

var $lcXac = parcelRequire("lcXac");

var $g5oPq = parcelRequire("g5oPq");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $ca66a92ca7ec52d6$var$isThisQuarter(date) {
    return (0, $g5oPq.isSameQuarter)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("b7MYT", function(module, exports) {

$parcel$export(module.exports, "isThisSecond", function () { return $819657d0e50f37c3$export$8d7059b5bca087e6; }, function (v) { return $819657d0e50f37c3$export$8d7059b5bca087e6 = v; });
var $819657d0e50f37c3$export$8d7059b5bca087e6;
"use strict";
$819657d0e50f37c3$export$8d7059b5bca087e6 = $819657d0e50f37c3$var$isThisSecond;

var $lcXac = parcelRequire("lcXac");

var $fQKG7 = parcelRequire("fQKG7");
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $819657d0e50f37c3$var$isThisSecond(date) {
    return (0, $fQKG7.isSameSecond)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("jVXe7", function(module, exports) {

$parcel$export(module.exports, "isThisWeek", function () { return $e83148633414c81b$export$cfe4b66a69cdd8a; }, function (v) { return $e83148633414c81b$export$cfe4b66a69cdd8a = v; });
var $e83148633414c81b$export$cfe4b66a69cdd8a;
"use strict";
$e83148633414c81b$export$cfe4b66a69cdd8a = $e83148633414c81b$var$isThisWeek;

var $lcXac = parcelRequire("lcXac");

var $7E3R5 = parcelRequire("7E3R5");
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $e83148633414c81b$var$isThisWeek(date, options) {
    return (0, $7E3R5.isSameWeek)(date, (0, $lcXac.constructNow)(date), options);
}

});

parcelRegister("k8VaZ", function(module, exports) {

$parcel$export(module.exports, "isThisYear", function () { return $eaa0e7ffbf821b69$export$a28c94941893a5ac; }, function (v) { return $eaa0e7ffbf821b69$export$a28c94941893a5ac = v; });
var $eaa0e7ffbf821b69$export$a28c94941893a5ac;
"use strict";
$eaa0e7ffbf821b69$export$a28c94941893a5ac = $eaa0e7ffbf821b69$var$isThisYear;

var $lcXac = parcelRequire("lcXac");

var $82gj4 = parcelRequire("82gj4");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $eaa0e7ffbf821b69$var$isThisYear(date) {
    return (0, $82gj4.isSameYear)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("jai8J", function(module, exports) {

$parcel$export(module.exports, "isThursday", function () { return $df3d05afc6b7a3ae$export$c8e7c906983ea347; }, function (v) { return $df3d05afc6b7a3ae$export$c8e7c906983ea347 = v; });
var $df3d05afc6b7a3ae$export$c8e7c906983ea347;
"use strict";
$df3d05afc6b7a3ae$export$c8e7c906983ea347 = $df3d05afc6b7a3ae$var$isThursday;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $df3d05afc6b7a3ae$var$isThursday(date) {
    return (0, $7NYl1.toDate)(date).getDay() === 4;
}

});

parcelRegister("c6Vcq", function(module, exports) {

$parcel$export(module.exports, "isToday", function () { return $8d126a2ec4f95258$export$629b0a497aa65267; }, function (v) { return $8d126a2ec4f95258$export$629b0a497aa65267 = v; });
var $8d126a2ec4f95258$export$629b0a497aa65267;
"use strict";
$8d126a2ec4f95258$export$629b0a497aa65267 = $8d126a2ec4f95258$var$isToday;

var $lcXac = parcelRequire("lcXac");

var $73v8c = parcelRequire("73v8c");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $8d126a2ec4f95258$var$isToday(date) {
    return (0, $73v8c.isSameDay)(date, (0, $lcXac.constructNow)(date));
}

});

parcelRegister("lvv1w", function(module, exports) {

$parcel$export(module.exports, "isTomorrow", function () { return $fa848ed8438282e9$export$d6365ba92f0647f1; }, function (v) { return $fa848ed8438282e9$export$d6365ba92f0647f1 = v; });
var $fa848ed8438282e9$export$d6365ba92f0647f1;
"use strict";
$fa848ed8438282e9$export$d6365ba92f0647f1 = $fa848ed8438282e9$var$isTomorrow;

var $2vrAW = parcelRequire("2vrAW");

var $lcXac = parcelRequire("lcXac");

var $73v8c = parcelRequire("73v8c");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $fa848ed8438282e9$var$isTomorrow(date) {
    return (0, $73v8c.isSameDay)(date, (0, $2vrAW.addDays)((0, $lcXac.constructNow)(date), 1));
}

});

parcelRegister("guT22", function(module, exports) {

$parcel$export(module.exports, "isTuesday", function () { return $c02a22e0f8a0f74f$export$90d50b8f209f5ac3; }, function (v) { return $c02a22e0f8a0f74f$export$90d50b8f209f5ac3 = v; });
var $c02a22e0f8a0f74f$export$90d50b8f209f5ac3;
"use strict";
$c02a22e0f8a0f74f$export$90d50b8f209f5ac3 = $c02a22e0f8a0f74f$var$isTuesday;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $c02a22e0f8a0f74f$var$isTuesday(date) {
    return (0, $7NYl1.toDate)(date).getDay() === 2;
}

});

parcelRegister("lTthR", function(module, exports) {

$parcel$export(module.exports, "isWednesday", function () { return $ff0573d2d5496c7a$export$ec9de642cdd62944; }, function (v) { return $ff0573d2d5496c7a$export$ec9de642cdd62944 = v; });
var $ff0573d2d5496c7a$export$ec9de642cdd62944;
"use strict";
$ff0573d2d5496c7a$export$ec9de642cdd62944 = $ff0573d2d5496c7a$var$isWednesday;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $ff0573d2d5496c7a$var$isWednesday(date) {
    return (0, $7NYl1.toDate)(date).getDay() === 3;
}

});

parcelRegister("22R1s", function(module, exports) {

$parcel$export(module.exports, "isYesterday", function () { return $17d4e5d8091c3cc1$export$221990270ebfe867; }, function (v) { return $17d4e5d8091c3cc1$export$221990270ebfe867 = v; });
var $17d4e5d8091c3cc1$export$221990270ebfe867;
"use strict";
$17d4e5d8091c3cc1$export$221990270ebfe867 = $17d4e5d8091c3cc1$var$isYesterday;

var $lcXac = parcelRequire("lcXac");

var $73v8c = parcelRequire("73v8c");

var $5BZWP = parcelRequire("5BZWP");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $17d4e5d8091c3cc1$var$isYesterday(date) {
    return (0, $73v8c.isSameDay)(date, (0, $5BZWP.subDays)((0, $lcXac.constructNow)(date), 1));
}

});

parcelRegister("b2fu7", function(module, exports) {

$parcel$export(module.exports, "lastDayOfDecade", function () { return $808be48fbaaec529$export$2aaf6241f57dd605; }, function (v) { return $808be48fbaaec529$export$2aaf6241f57dd605 = v; });
var $808be48fbaaec529$export$2aaf6241f57dd605;
"use strict";
$808be48fbaaec529$export$2aaf6241f57dd605 = $808be48fbaaec529$var$lastDayOfDecade;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $808be48fbaaec529$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("dndVE", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeek", function () { return $9bc83a599468cba3$export$b08a8fc26ae6d94b; }, function (v) { return $9bc83a599468cba3$export$b08a8fc26ae6d94b = v; });
var $9bc83a599468cba3$export$b08a8fc26ae6d94b;
"use strict";
$9bc83a599468cba3$export$b08a8fc26ae6d94b = $9bc83a599468cba3$var$lastDayOfISOWeek;

var $kQ7hG = parcelRequire("kQ7hG");
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $9bc83a599468cba3$var$lastDayOfISOWeek(date) {
    return (0, $kQ7hG.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("kQ7hG", function(module, exports) {

$parcel$export(module.exports, "lastDayOfWeek", function () { return $f2be5077f4372a50$export$b73502c35a293b0a; }, function (v) { return $f2be5077f4372a50$export$b73502c35a293b0a = v; });
var $f2be5077f4372a50$export$b73502c35a293b0a;
"use strict";
$f2be5077f4372a50$export$b73502c35a293b0a = $f2be5077f4372a50$var$lastDayOfWeek;

var $7NYl1 = parcelRequire("7NYl1");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $f2be5077f4372a50$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7NYl1.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("4G8MV", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeekYear", function () { return $3681e6cbfdd2c7a3$export$1810bada8cd02ee1; }, function (v) { return $3681e6cbfdd2c7a3$export$1810bada8cd02ee1 = v; });
var $3681e6cbfdd2c7a3$export$1810bada8cd02ee1;
"use strict";
$3681e6cbfdd2c7a3$export$1810bada8cd02ee1 = $3681e6cbfdd2c7a3$var$lastDayOfISOWeekYear;

var $VphlE = parcelRequire("VphlE");

var $56Gig = parcelRequire("56Gig");

var $5viJK = parcelRequire("5viJK");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $3681e6cbfdd2c7a3$var$lastDayOfISOWeekYear(date) {
    const year = (0, $VphlE.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $5viJK.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $56Gig.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}

});

parcelRegister("h1phI", function(module, exports) {

$parcel$export(module.exports, "lastDayOfQuarter", function () { return $c64624af7fa5844a$export$8693c04228304c7; }, function (v) { return $c64624af7fa5844a$export$8693c04228304c7 = v; });
var $c64624af7fa5844a$export$8693c04228304c7;
"use strict";
$c64624af7fa5844a$export$8693c04228304c7 = $c64624af7fa5844a$var$lastDayOfQuarter;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $c64624af7fa5844a$var$lastDayOfQuarter(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("76Dnj", function(module, exports) {

$parcel$export(module.exports, "lastDayOfYear", function () { return $52c7a300c08e4c92$export$323f7bc07b828bed; }, function (v) { return $52c7a300c08e4c92$export$323f7bc07b828bed = v; });
var $52c7a300c08e4c92$export$323f7bc07b828bed;
"use strict";
$52c7a300c08e4c92$export$323f7bc07b828bed = $52c7a300c08e4c92$var$lastDayOfYear;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $52c7a300c08e4c92$var$lastDayOfYear(date) {
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("gM2TP", function(module, exports) {
"use strict";
module.exports.lightFormat = $c36360c8fc9f50cd$var$lightFormat;
Object.defineProperty(module.exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $lP0sG.lightFormatters;
    }
});

var $4pFgQ = parcelRequire("4pFgQ");

var $7NYl1 = parcelRequire("7NYl1");

var $lP0sG = parcelRequire("lP0sG");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $c36360c8fc9f50cd$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $c36360c8fc9f50cd$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $c36360c8fc9f50cd$var$doubleQuoteRegExp = /''/g;
const $c36360c8fc9f50cd$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $c36360c8fc9f50cd$var$lightFormat(date, formatStr) {
    const _date = (0, $7NYl1.toDate)(date);
    if (!(0, $4pFgQ.isValid)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($c36360c8fc9f50cd$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $c36360c8fc9f50cd$var$cleanEscapedString(substring);
        const formatter = $lP0sG.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($c36360c8fc9f50cd$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $c36360c8fc9f50cd$var$cleanEscapedString(input) {
    const matches = input.match($c36360c8fc9f50cd$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($c36360c8fc9f50cd$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("8cbK9", function(module, exports) {

$parcel$export(module.exports, "milliseconds", function () { return $5f788db095a352d4$export$9a27fac83d67afd3; }, function (v) { return $5f788db095a352d4$export$9a27fac83d67afd3 = v; });
var $5f788db095a352d4$export$9a27fac83d67afd3;
"use strict";
$5f788db095a352d4$export$9a27fac83d67afd3 = $5f788db095a352d4$var$milliseconds;

var $kMovx = parcelRequire("kMovx");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $5f788db095a352d4$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $kMovx.daysInYear;
    if (months) totalDays += months * ($kMovx.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}

});

parcelRegister("kOg5P", function(module, exports) {

$parcel$export(module.exports, "millisecondsToHours", function () { return $f264f5deb9f6ca92$export$689a412b29fa9ed5; }, function (v) { return $f264f5deb9f6ca92$export$689a412b29fa9ed5 = v; });
var $f264f5deb9f6ca92$export$689a412b29fa9ed5;
"use strict";
$f264f5deb9f6ca92$export$689a412b29fa9ed5 = $f264f5deb9f6ca92$var$millisecondsToHours;

var $kMovx = parcelRequire("kMovx");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $f264f5deb9f6ca92$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $kMovx.millisecondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("jrOc8", function(module, exports) {

$parcel$export(module.exports, "millisecondsToMinutes", function () { return $e287798b04b12ce3$export$a5f974e81e48cfc0; }, function (v) { return $e287798b04b12ce3$export$a5f974e81e48cfc0 = v; });
var $e287798b04b12ce3$export$a5f974e81e48cfc0;
"use strict";
$e287798b04b12ce3$export$a5f974e81e48cfc0 = $e287798b04b12ce3$var$millisecondsToMinutes;

var $kMovx = parcelRequire("kMovx");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $e287798b04b12ce3$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $kMovx.millisecondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("1K1po", function(module, exports) {

$parcel$export(module.exports, "millisecondsToSeconds", function () { return $144b2e0675ab24a1$export$f64c3bfbc58eec0f; }, function (v) { return $144b2e0675ab24a1$export$f64c3bfbc58eec0f = v; });
var $144b2e0675ab24a1$export$f64c3bfbc58eec0f;
"use strict";
$144b2e0675ab24a1$export$f64c3bfbc58eec0f = $144b2e0675ab24a1$var$millisecondsToSeconds;

var $kMovx = parcelRequire("kMovx");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $144b2e0675ab24a1$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $kMovx.millisecondsInSecond;
    return Math.trunc(seconds);
}

});

parcelRegister("yUvqg", function(module, exports) {

$parcel$export(module.exports, "minutesToHours", function () { return $068f01f7f3073335$export$815164eb42530ae7; }, function (v) { return $068f01f7f3073335$export$815164eb42530ae7 = v; });
var $068f01f7f3073335$export$815164eb42530ae7;
"use strict";
$068f01f7f3073335$export$815164eb42530ae7 = $068f01f7f3073335$var$minutesToHours;

var $kMovx = parcelRequire("kMovx");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $068f01f7f3073335$var$minutesToHours(minutes) {
    const hours = minutes / $kMovx.minutesInHour;
    return Math.trunc(hours);
}

});

parcelRegister("aVG2I", function(module, exports) {

$parcel$export(module.exports, "minutesToMilliseconds", function () { return $7f4fd716fd608a06$export$f6b9795ef9056e3d; }, function (v) { return $7f4fd716fd608a06$export$f6b9795ef9056e3d = v; });
var $7f4fd716fd608a06$export$f6b9795ef9056e3d;
"use strict";
$7f4fd716fd608a06$export$f6b9795ef9056e3d = $7f4fd716fd608a06$var$minutesToMilliseconds;

var $kMovx = parcelRequire("kMovx");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $7f4fd716fd608a06$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $kMovx.millisecondsInMinute);
}

});

parcelRegister("l6lCN", function(module, exports) {

$parcel$export(module.exports, "minutesToSeconds", function () { return $f5caeec205035033$export$81ded4628c655103; }, function (v) { return $f5caeec205035033$export$81ded4628c655103 = v; });
var $f5caeec205035033$export$81ded4628c655103;
"use strict";
$f5caeec205035033$export$81ded4628c655103 = $f5caeec205035033$var$minutesToSeconds;

var $kMovx = parcelRequire("kMovx");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $f5caeec205035033$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $kMovx.secondsInMinute);
}

});

parcelRegister("hJaAX", function(module, exports) {

$parcel$export(module.exports, "monthsToQuarters", function () { return $ce7edb9ecaed56dc$export$1932fa2a2068c849; }, function (v) { return $ce7edb9ecaed56dc$export$1932fa2a2068c849 = v; });
var $ce7edb9ecaed56dc$export$1932fa2a2068c849;
"use strict";
$ce7edb9ecaed56dc$export$1932fa2a2068c849 = $ce7edb9ecaed56dc$var$monthsToQuarters;

var $kMovx = parcelRequire("kMovx");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $ce7edb9ecaed56dc$var$monthsToQuarters(months) {
    const quarters = months / $kMovx.monthsInQuarter;
    return Math.trunc(quarters);
}

});

parcelRegister("41GzP", function(module, exports) {

$parcel$export(module.exports, "monthsToYears", function () { return $2ee84851361e68e8$export$7489026ed27fc925; }, function (v) { return $2ee84851361e68e8$export$7489026ed27fc925 = v; });
var $2ee84851361e68e8$export$7489026ed27fc925;
"use strict";
$2ee84851361e68e8$export$7489026ed27fc925 = $2ee84851361e68e8$var$monthsToYears;

var $kMovx = parcelRequire("kMovx");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $2ee84851361e68e8$var$monthsToYears(months) {
    const years = months / $kMovx.monthsInYear;
    return Math.trunc(years);
}

});

parcelRegister("74dx3", function(module, exports) {

$parcel$export(module.exports, "nextDay", function () { return $52536758b14b7685$export$992728922317ffc8; }, function (v) { return $52536758b14b7685$export$992728922317ffc8 = v; });
var $52536758b14b7685$export$992728922317ffc8;
"use strict";
$52536758b14b7685$export$992728922317ffc8 = $52536758b14b7685$var$nextDay;

var $2vrAW = parcelRequire("2vrAW");

var $7Vb0N = parcelRequire("7Vb0N");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $52536758b14b7685$var$nextDay(date, day) {
    let delta = day - (0, $7Vb0N.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, $2vrAW.addDays)(date, delta);
}

});

parcelRegister("3TYro", function(module, exports) {

$parcel$export(module.exports, "nextFriday", function () { return $2d75646efebb3fb7$export$21d76934fce76327; }, function (v) { return $2d75646efebb3fb7$export$21d76934fce76327 = v; });
var $2d75646efebb3fb7$export$21d76934fce76327;
"use strict";
$2d75646efebb3fb7$export$21d76934fce76327 = $2d75646efebb3fb7$var$nextFriday;

var $74dx3 = parcelRequire("74dx3");
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $2d75646efebb3fb7$var$nextFriday(date) {
    return (0, $74dx3.nextDay)(date, 5);
}

});

parcelRegister("hlkYe", function(module, exports) {

$parcel$export(module.exports, "nextMonday", function () { return $ca04aa24283beccf$export$a20373bb0df6efdd; }, function (v) { return $ca04aa24283beccf$export$a20373bb0df6efdd = v; });
var $ca04aa24283beccf$export$a20373bb0df6efdd;
"use strict";
$ca04aa24283beccf$export$a20373bb0df6efdd = $ca04aa24283beccf$var$nextMonday;

var $74dx3 = parcelRequire("74dx3");
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $ca04aa24283beccf$var$nextMonday(date) {
    return (0, $74dx3.nextDay)(date, 1);
}

});

parcelRegister("5Wbnw", function(module, exports) {

$parcel$export(module.exports, "nextSaturday", function () { return $452b320ede6df614$export$c52f069246f7b032; }, function (v) { return $452b320ede6df614$export$c52f069246f7b032 = v; });
var $452b320ede6df614$export$c52f069246f7b032;
"use strict";
$452b320ede6df614$export$c52f069246f7b032 = $452b320ede6df614$var$nextSaturday;

var $74dx3 = parcelRequire("74dx3");
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $452b320ede6df614$var$nextSaturday(date) {
    return (0, $74dx3.nextDay)(date, 6);
}

});

parcelRegister("9Q62z", function(module, exports) {

$parcel$export(module.exports, "nextSunday", function () { return $729da7e7de8f49e0$export$a30adaa3ef47f854; }, function (v) { return $729da7e7de8f49e0$export$a30adaa3ef47f854 = v; });
var $729da7e7de8f49e0$export$a30adaa3ef47f854;
"use strict";
$729da7e7de8f49e0$export$a30adaa3ef47f854 = $729da7e7de8f49e0$var$nextSunday;

var $74dx3 = parcelRequire("74dx3");
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $729da7e7de8f49e0$var$nextSunday(date) {
    return (0, $74dx3.nextDay)(date, 0);
}

});

parcelRegister("8YzuS", function(module, exports) {

$parcel$export(module.exports, "nextThursday", function () { return $688f7650b15d71f7$export$36d9a8523a98d5a4; }, function (v) { return $688f7650b15d71f7$export$36d9a8523a98d5a4 = v; });
var $688f7650b15d71f7$export$36d9a8523a98d5a4;
"use strict";
$688f7650b15d71f7$export$36d9a8523a98d5a4 = $688f7650b15d71f7$var$nextThursday;

var $74dx3 = parcelRequire("74dx3");
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $688f7650b15d71f7$var$nextThursday(date) {
    return (0, $74dx3.nextDay)(date, 4);
}

});

parcelRegister("hhPe8", function(module, exports) {

$parcel$export(module.exports, "nextTuesday", function () { return $c95bc2d230f398af$export$391d63ff7dc2f668; }, function (v) { return $c95bc2d230f398af$export$391d63ff7dc2f668 = v; });
var $c95bc2d230f398af$export$391d63ff7dc2f668;
"use strict";
$c95bc2d230f398af$export$391d63ff7dc2f668 = $c95bc2d230f398af$var$nextTuesday;

var $74dx3 = parcelRequire("74dx3");
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $c95bc2d230f398af$var$nextTuesday(date) {
    return (0, $74dx3.nextDay)(date, 2);
}

});

parcelRegister("4UfuH", function(module, exports) {

$parcel$export(module.exports, "nextWednesday", function () { return $3928692e64f02a44$export$7a895c1ff204304e; }, function (v) { return $3928692e64f02a44$export$7a895c1ff204304e = v; });
var $3928692e64f02a44$export$7a895c1ff204304e;
"use strict";
$3928692e64f02a44$export$7a895c1ff204304e = $3928692e64f02a44$var$nextWednesday;

var $74dx3 = parcelRequire("74dx3");
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $3928692e64f02a44$var$nextWednesday(date) {
    return (0, $74dx3.nextDay)(date, 3);
}

});

parcelRegister("lJMKo", function(module, exports) {

$parcel$export(module.exports, "parseJSON", function () { return $fd339d2394a18163$export$27924e57e9afff7f; }, function (v) { return $fd339d2394a18163$export$27924e57e9afff7f = v; });
var $fd339d2394a18163$export$27924e57e9afff7f;
"use strict";
$fd339d2394a18163$export$27924e57e9afff7f = $fd339d2394a18163$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $fd339d2394a18163$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}

});

parcelRegister("bPkc1", function(module, exports) {

$parcel$export(module.exports, "previousDay", function () { return $89c41f0827ca10a7$export$4caccb62df4eacc0; }, function (v) { return $89c41f0827ca10a7$export$4caccb62df4eacc0 = v; });
var $89c41f0827ca10a7$export$4caccb62df4eacc0;
"use strict";
$89c41f0827ca10a7$export$4caccb62df4eacc0 = $89c41f0827ca10a7$var$previousDay;

var $7Vb0N = parcelRequire("7Vb0N");

var $5BZWP = parcelRequire("5BZWP");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $89c41f0827ca10a7$var$previousDay(date, day) {
    let delta = (0, $7Vb0N.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $5BZWP.subDays)(date, delta);
}

});

parcelRegister("lDPqg", function(module, exports) {

$parcel$export(module.exports, "previousFriday", function () { return $fc1520f961d01d7d$export$32d52646c338c11d; }, function (v) { return $fc1520f961d01d7d$export$32d52646c338c11d = v; });
var $fc1520f961d01d7d$export$32d52646c338c11d;
"use strict";
$fc1520f961d01d7d$export$32d52646c338c11d = $fc1520f961d01d7d$var$previousFriday;

var $bPkc1 = parcelRequire("bPkc1");
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $fc1520f961d01d7d$var$previousFriday(date) {
    return (0, $bPkc1.previousDay)(date, 5);
}

});

parcelRegister("kbygx", function(module, exports) {

$parcel$export(module.exports, "previousMonday", function () { return $eb1f6a353a43f5cb$export$398437ab6f45c582; }, function (v) { return $eb1f6a353a43f5cb$export$398437ab6f45c582 = v; });
var $eb1f6a353a43f5cb$export$398437ab6f45c582;
"use strict";
$eb1f6a353a43f5cb$export$398437ab6f45c582 = $eb1f6a353a43f5cb$var$previousMonday;

var $bPkc1 = parcelRequire("bPkc1");
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $eb1f6a353a43f5cb$var$previousMonday(date) {
    return (0, $bPkc1.previousDay)(date, 1);
}

});

parcelRegister("8mExm", function(module, exports) {

$parcel$export(module.exports, "previousSaturday", function () { return $616fd29eea92e93b$export$36767a7e6101ecb0; }, function (v) { return $616fd29eea92e93b$export$36767a7e6101ecb0 = v; });
var $616fd29eea92e93b$export$36767a7e6101ecb0;
"use strict";
$616fd29eea92e93b$export$36767a7e6101ecb0 = $616fd29eea92e93b$var$previousSaturday;

var $bPkc1 = parcelRequire("bPkc1");
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $616fd29eea92e93b$var$previousSaturday(date) {
    return (0, $bPkc1.previousDay)(date, 6);
}

});

parcelRegister("3md94", function(module, exports) {

$parcel$export(module.exports, "previousSunday", function () { return $271d9f8951bedf3e$export$7d3d7d8fc5e81fd4; }, function (v) { return $271d9f8951bedf3e$export$7d3d7d8fc5e81fd4 = v; });
var $271d9f8951bedf3e$export$7d3d7d8fc5e81fd4;
"use strict";
$271d9f8951bedf3e$export$7d3d7d8fc5e81fd4 = $271d9f8951bedf3e$var$previousSunday;

var $bPkc1 = parcelRequire("bPkc1");
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $271d9f8951bedf3e$var$previousSunday(date) {
    return (0, $bPkc1.previousDay)(date, 0);
}

});

parcelRegister("l55Kk", function(module, exports) {

$parcel$export(module.exports, "previousThursday", function () { return $f58e85a96b6fd4b7$export$1975b5b1f6b0e34e; }, function (v) { return $f58e85a96b6fd4b7$export$1975b5b1f6b0e34e = v; });
var $f58e85a96b6fd4b7$export$1975b5b1f6b0e34e;
"use strict";
$f58e85a96b6fd4b7$export$1975b5b1f6b0e34e = $f58e85a96b6fd4b7$var$previousThursday;

var $bPkc1 = parcelRequire("bPkc1");
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $f58e85a96b6fd4b7$var$previousThursday(date) {
    return (0, $bPkc1.previousDay)(date, 4);
}

});

parcelRegister("4bKCH", function(module, exports) {

$parcel$export(module.exports, "previousTuesday", function () { return $30cc5ae0c67eec6c$export$a034a75f093bcfaf; }, function (v) { return $30cc5ae0c67eec6c$export$a034a75f093bcfaf = v; });
var $30cc5ae0c67eec6c$export$a034a75f093bcfaf;
"use strict";
$30cc5ae0c67eec6c$export$a034a75f093bcfaf = $30cc5ae0c67eec6c$var$previousTuesday;

var $bPkc1 = parcelRequire("bPkc1");
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $30cc5ae0c67eec6c$var$previousTuesday(date) {
    return (0, $bPkc1.previousDay)(date, 2);
}

});

parcelRegister("fQ1E0", function(module, exports) {

$parcel$export(module.exports, "previousWednesday", function () { return $b87cfcd841ef685b$export$26334f591e4ce672; }, function (v) { return $b87cfcd841ef685b$export$26334f591e4ce672 = v; });
var $b87cfcd841ef685b$export$26334f591e4ce672;
"use strict";
$b87cfcd841ef685b$export$26334f591e4ce672 = $b87cfcd841ef685b$var$previousWednesday;

var $bPkc1 = parcelRequire("bPkc1");
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $b87cfcd841ef685b$var$previousWednesday(date) {
    return (0, $bPkc1.previousDay)(date, 3);
}

});

parcelRegister("8o5Na", function(module, exports) {

$parcel$export(module.exports, "quartersToMonths", function () { return $61b50ec50b80f313$export$a29d19ce21d74c57; }, function (v) { return $61b50ec50b80f313$export$a29d19ce21d74c57 = v; });
var $61b50ec50b80f313$export$a29d19ce21d74c57;
"use strict";
$61b50ec50b80f313$export$a29d19ce21d74c57 = $61b50ec50b80f313$var$quartersToMonths;

var $kMovx = parcelRequire("kMovx");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $61b50ec50b80f313$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $kMovx.monthsInQuarter);
}

});

parcelRegister("9yMjm", function(module, exports) {

$parcel$export(module.exports, "quartersToYears", function () { return $6f5cc3a9a787c898$export$c309fa8f184b4648; }, function (v) { return $6f5cc3a9a787c898$export$c309fa8f184b4648 = v; });
var $6f5cc3a9a787c898$export$c309fa8f184b4648;
"use strict";
$6f5cc3a9a787c898$export$c309fa8f184b4648 = $6f5cc3a9a787c898$var$quartersToYears;

var $kMovx = parcelRequire("kMovx");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $6f5cc3a9a787c898$var$quartersToYears(quarters) {
    const years = quarters / $kMovx.quartersInYear;
    return Math.trunc(years);
}

});

parcelRegister("f32BC", function(module, exports) {

$parcel$export(module.exports, "roundToNearestHours", function () { return $af4928462a480554$export$a8b87649ebc0e3c2; }, function (v) { return $af4928462a480554$export$a8b87649ebc0e3c2 = v; });
var $af4928462a480554$export$a8b87649ebc0e3c2;
"use strict";
$af4928462a480554$export$a8b87649ebc0e3c2 = $af4928462a480554$var$roundToNearestHours;

var $l5U4C = parcelRequire("l5U4C");

var $5viJK = parcelRequire("5viJK");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $af4928462a480554$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $5viJK.constructFrom)(date, NaN);
    const _date = (0, $7NYl1.toDate)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $l5U4C.getRoundingMethod)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $5viJK.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}

});

parcelRegister("jymNW", function(module, exports) {

$parcel$export(module.exports, "roundToNearestMinutes", function () { return $e3c2e1cb2e9f3962$export$d97410bb8cd0dff; }, function (v) { return $e3c2e1cb2e9f3962$export$d97410bb8cd0dff = v; });
var $e3c2e1cb2e9f3962$export$d97410bb8cd0dff;
"use strict";
$e3c2e1cb2e9f3962$export$d97410bb8cd0dff = $e3c2e1cb2e9f3962$var$roundToNearestMinutes;

var $l5U4C = parcelRequire("l5U4C");

var $5viJK = parcelRequire("5viJK");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $e3c2e1cb2e9f3962$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $5viJK.constructFrom)(date, NaN);
    const _date = (0, $7NYl1.toDate)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $l5U4C.getRoundingMethod)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $5viJK.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}

});

parcelRegister("kfEGt", function(module, exports) {

$parcel$export(module.exports, "secondsToHours", function () { return $ebe4c46082b9df27$export$47d555ff5354096f; }, function (v) { return $ebe4c46082b9df27$export$47d555ff5354096f = v; });
var $ebe4c46082b9df27$export$47d555ff5354096f;
"use strict";
$ebe4c46082b9df27$export$47d555ff5354096f = $ebe4c46082b9df27$var$secondsToHours;

var $kMovx = parcelRequire("kMovx");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $ebe4c46082b9df27$var$secondsToHours(seconds) {
    const hours = seconds / $kMovx.secondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("bQMlt", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $8a0a0d6b40c976b2$export$fc3e7e8557f8c8c7; }, function (v) { return $8a0a0d6b40c976b2$export$fc3e7e8557f8c8c7 = v; });
var $8a0a0d6b40c976b2$export$fc3e7e8557f8c8c7;
"use strict";
$8a0a0d6b40c976b2$export$fc3e7e8557f8c8c7 = $8a0a0d6b40c976b2$var$secondsToMilliseconds;

var $kMovx = parcelRequire("kMovx");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $8a0a0d6b40c976b2$var$secondsToMilliseconds(seconds) {
    return seconds * $kMovx.millisecondsInSecond;
}

});

parcelRegister("cw6ua", function(module, exports) {

$parcel$export(module.exports, "secondsToMinutes", function () { return $91cd811e48e063a7$export$ed657adb62398e99; }, function (v) { return $91cd811e48e063a7$export$ed657adb62398e99 = v; });
var $91cd811e48e063a7$export$ed657adb62398e99;
"use strict";
$91cd811e48e063a7$export$ed657adb62398e99 = $91cd811e48e063a7$var$secondsToMinutes;

var $kMovx = parcelRequire("kMovx");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $91cd811e48e063a7$var$secondsToMinutes(seconds) {
    const minutes = seconds / $kMovx.secondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("4znFA", function(module, exports) {

$parcel$export(module.exports, "set", function () { return $353ccaa2f2d9ef03$export$adaa4cf7ef1b65be; }, function (v) { return $353ccaa2f2d9ef03$export$adaa4cf7ef1b65be = v; });
var $353ccaa2f2d9ef03$export$adaa4cf7ef1b65be;
"use strict";
$353ccaa2f2d9ef03$export$adaa4cf7ef1b65be = $353ccaa2f2d9ef03$var$set;

var $5viJK = parcelRequire("5viJK");

var $lf7yb = parcelRequire("lf7yb");

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $353ccaa2f2d9ef03$var$set(date, values) {
    let _date = (0, $7NYl1.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $5viJK.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $lf7yb.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});

parcelRegister("edv5c", function(module, exports) {

$parcel$export(module.exports, "setDate", function () { return $a59a64011ff14f20$export$566174fa40823587; }, function (v) { return $a59a64011ff14f20$export$566174fa40823587 = v; });
var $a59a64011ff14f20$export$566174fa40823587;
"use strict";
$a59a64011ff14f20$export$566174fa40823587 = $a59a64011ff14f20$var$setDate;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $a59a64011ff14f20$var$setDate(date, dayOfMonth) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

});

parcelRegister("c0jYB", function(module, exports) {

$parcel$export(module.exports, "setDayOfYear", function () { return $8bd4fb08606c462b$export$2af590ffc7e7d7c5; }, function (v) { return $8bd4fb08606c462b$export$2af590ffc7e7d7c5 = v; });
var $8bd4fb08606c462b$export$2af590ffc7e7d7c5;
"use strict";
$8bd4fb08606c462b$export$2af590ffc7e7d7c5 = $8bd4fb08606c462b$var$setDayOfYear;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $8bd4fb08606c462b$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}

});

parcelRegister("gvMSR", function(module, exports) {

$parcel$export(module.exports, "setDefaultOptions", function () { return $c05575e8f5c133a3$export$95365be1b0704abc; }, function (v) { return $c05575e8f5c133a3$export$95365be1b0704abc = v; });
var $c05575e8f5c133a3$export$95365be1b0704abc;
"use strict";
$c05575e8f5c133a3$export$95365be1b0704abc = $c05575e8f5c133a3$var$setDefaultOptions;

var $f8DjC = parcelRequire("f8DjC");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $c05575e8f5c133a3$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $f8DjC.setDefaultOptions)(result);
}

});

parcelRegister("87ptp", function(module, exports) {

$parcel$export(module.exports, "setMilliseconds", function () { return $5e92bca5d368932b$export$de5664029b35e06d; }, function (v) { return $5e92bca5d368932b$export$de5664029b35e06d = v; });
var $5e92bca5d368932b$export$de5664029b35e06d;
"use strict";
$5e92bca5d368932b$export$de5664029b35e06d = $5e92bca5d368932b$var$setMilliseconds;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $5e92bca5d368932b$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $7NYl1.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

});

parcelRegister("hMPMV", function(module, exports) {

$parcel$export(module.exports, "setWeekYear", function () { return $cf2f1761143e6071$export$4340968d5939835e; }, function (v) { return $cf2f1761143e6071$export$4340968d5939835e = v; });
var $cf2f1761143e6071$export$4340968d5939835e;
"use strict";
$cf2f1761143e6071$export$4340968d5939835e = $cf2f1761143e6071$var$setWeekYear;

var $5viJK = parcelRequire("5viJK");

var $jaIwE = parcelRequire("jaIwE");

var $bz05S = parcelRequire("bz05S");

var $7NYl1 = parcelRequire("7NYl1");

var $f8DjC = parcelRequire("f8DjC");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $cf2f1761143e6071$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $f8DjC.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $7NYl1.toDate)(date);
    const diff = (0, $jaIwE.differenceInCalendarDays)(_date, (0, $bz05S.startOfWeekYear)(_date, options));
    const firstWeek = (0, $5viJK.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $bz05S.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});

parcelRegister("m5fJR", function(module, exports) {

$parcel$export(module.exports, "startOfDecade", function () { return $0426214baa39734b$export$730492981c634308; }, function (v) { return $0426214baa39734b$export$730492981c634308 = v; });
var $0426214baa39734b$export$730492981c634308;
"use strict";
$0426214baa39734b$export$730492981c634308 = $0426214baa39734b$var$startOfDecade;

var $7NYl1 = parcelRequire("7NYl1");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $0426214baa39734b$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $7NYl1.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("9OXOc", function(module, exports) {

$parcel$export(module.exports, "startOfToday", function () { return $72672d503e066363$export$444d742fd5a45a57; }, function (v) { return $72672d503e066363$export$444d742fd5a45a57 = v; });
var $72672d503e066363$export$444d742fd5a45a57;
"use strict";
$72672d503e066363$export$444d742fd5a45a57 = $72672d503e066363$var$startOfToday;

var $ePNEc = parcelRequire("ePNEc");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $72672d503e066363$var$startOfToday() {
    return (0, $ePNEc.startOfDay)(Date.now());
}

});

parcelRegister("boABr", function(module, exports) {

$parcel$export(module.exports, "startOfTomorrow", function () { return $84be5432ba1f5f12$export$7e8566c79d5bee07; }, function (v) { return $84be5432ba1f5f12$export$7e8566c79d5bee07 = v; });
var $84be5432ba1f5f12$export$7e8566c79d5bee07;
"use strict";
$84be5432ba1f5f12$export$7e8566c79d5bee07 = $84be5432ba1f5f12$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $84be5432ba1f5f12$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("iUgWT", function(module, exports) {

$parcel$export(module.exports, "startOfYesterday", function () { return $dc3a9aa958ebd1fe$export$23a16f3c6d143ce9; }, function (v) { return $dc3a9aa958ebd1fe$export$23a16f3c6d143ce9 = v; });
var $dc3a9aa958ebd1fe$export$23a16f3c6d143ce9;
"use strict";
$dc3a9aa958ebd1fe$export$23a16f3c6d143ce9 = $dc3a9aa958ebd1fe$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $dc3a9aa958ebd1fe$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gugfV", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $c00c0ec0b3f3da39$export$f93b5905241a7cca; }, function (v) { return $c00c0ec0b3f3da39$export$f93b5905241a7cca = v; });
var $c00c0ec0b3f3da39$export$f93b5905241a7cca;
"use strict";
$c00c0ec0b3f3da39$export$f93b5905241a7cca = $c00c0ec0b3f3da39$var$sub;

var $5BZWP = parcelRequire("5BZWP");

var $baGWJ = parcelRequire("baGWJ");

var $5viJK = parcelRequire("5viJK");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $c00c0ec0b3f3da39$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $baGWJ.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $5BZWP.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $5viJK.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});

parcelRegister("nB2ui", function(module, exports) {

$parcel$export(module.exports, "subBusinessDays", function () { return $046ee14ba4e48120$export$e5cc51ae28664a93; }, function (v) { return $046ee14ba4e48120$export$e5cc51ae28664a93 = v; });
var $046ee14ba4e48120$export$e5cc51ae28664a93;
"use strict";
$046ee14ba4e48120$export$e5cc51ae28664a93 = $046ee14ba4e48120$var$subBusinessDays;

var $esSds = parcelRequire("esSds");
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $046ee14ba4e48120$var$subBusinessDays(date, amount) {
    return (0, $esSds.addBusinessDays)(date, -amount);
}

});

parcelRegister("jQtXi", function(module, exports) {

$parcel$export(module.exports, "subHours", function () { return $e72a1c2eff42f074$export$5e9fa51cd5bb1e71; }, function (v) { return $e72a1c2eff42f074$export$5e9fa51cd5bb1e71 = v; });
var $e72a1c2eff42f074$export$5e9fa51cd5bb1e71;
"use strict";
$e72a1c2eff42f074$export$5e9fa51cd5bb1e71 = $e72a1c2eff42f074$var$subHours;

var $lk4ac = parcelRequire("lk4ac");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $e72a1c2eff42f074$var$subHours(date, amount) {
    return (0, $lk4ac.addHours)(date, -amount);
}

});

parcelRegister("dmC9V", function(module, exports) {

$parcel$export(module.exports, "subMilliseconds", function () { return $9baaee07a5f8cbec$export$5abaf57ab8e91640; }, function (v) { return $9baaee07a5f8cbec$export$5abaf57ab8e91640 = v; });
var $9baaee07a5f8cbec$export$5abaf57ab8e91640;
"use strict";
$9baaee07a5f8cbec$export$5abaf57ab8e91640 = $9baaee07a5f8cbec$var$subMilliseconds;

var $32aF3 = parcelRequire("32aF3");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $9baaee07a5f8cbec$var$subMilliseconds(date, amount) {
    return (0, $32aF3.addMilliseconds)(date, -amount);
}

});

parcelRegister("3biK9", function(module, exports) {

$parcel$export(module.exports, "subMinutes", function () { return $2510f03d669e94d2$export$e12a970efb73fce5; }, function (v) { return $2510f03d669e94d2$export$e12a970efb73fce5 = v; });
var $2510f03d669e94d2$export$e12a970efb73fce5;
"use strict";
$2510f03d669e94d2$export$e12a970efb73fce5 = $2510f03d669e94d2$var$subMinutes;

var $9VdIH = parcelRequire("9VdIH");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $2510f03d669e94d2$var$subMinutes(date, amount) {
    return (0, $9VdIH.addMinutes)(date, -amount);
}

});

parcelRegister("irhDk", function(module, exports) {

$parcel$export(module.exports, "subSeconds", function () { return $d6c86d3b689ed97a$export$e95d8ad9981db689; }, function (v) { return $d6c86d3b689ed97a$export$e95d8ad9981db689 = v; });
var $d6c86d3b689ed97a$export$e95d8ad9981db689;
"use strict";
$d6c86d3b689ed97a$export$e95d8ad9981db689 = $d6c86d3b689ed97a$var$subSeconds;

var $42N2s = parcelRequire("42N2s");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $d6c86d3b689ed97a$var$subSeconds(date, amount) {
    return (0, $42N2s.addSeconds)(date, -amount);
}

});

parcelRegister("euuF0", function(module, exports) {

$parcel$export(module.exports, "weeksToDays", function () { return $a8cba68ca735fe38$export$b696b6eeb89501ad; }, function (v) { return $a8cba68ca735fe38$export$b696b6eeb89501ad = v; });
var $a8cba68ca735fe38$export$b696b6eeb89501ad;
"use strict";
$a8cba68ca735fe38$export$b696b6eeb89501ad = $a8cba68ca735fe38$var$weeksToDays;

var $kMovx = parcelRequire("kMovx");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $a8cba68ca735fe38$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $kMovx.daysInWeek);
}

});

parcelRegister("hHueA", function(module, exports) {

$parcel$export(module.exports, "yearsToDays", function () { return $ce2de7b4f93e94c9$export$862cb7b6e45c3b17; }, function (v) { return $ce2de7b4f93e94c9$export$862cb7b6e45c3b17 = v; });
var $ce2de7b4f93e94c9$export$862cb7b6e45c3b17;
"use strict";
$ce2de7b4f93e94c9$export$862cb7b6e45c3b17 = $ce2de7b4f93e94c9$var$yearsToDays;

var $kMovx = parcelRequire("kMovx");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $ce2de7b4f93e94c9$var$yearsToDays(years) {
    return Math.trunc(years * $kMovx.daysInYear);
}

});

parcelRegister("35GDA", function(module, exports) {

$parcel$export(module.exports, "yearsToMonths", function () { return $2402e9a4404d1f00$export$894abb0747b9a00; }, function (v) { return $2402e9a4404d1f00$export$894abb0747b9a00 = v; });
var $2402e9a4404d1f00$export$894abb0747b9a00;
"use strict";
$2402e9a4404d1f00$export$894abb0747b9a00 = $2402e9a4404d1f00$var$yearsToMonths;

var $kMovx = parcelRequire("kMovx");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $2402e9a4404d1f00$var$yearsToMonths(years) {
    return Math.trunc(years * $kMovx.monthsInYear);
}

});

parcelRegister("bo82R", function(module, exports) {

$parcel$export(module.exports, "yearsToQuarters", function () { return $84a82d34d850bf72$export$ab26576e5e7379d7; }, function (v) { return $84a82d34d850bf72$export$ab26576e5e7379d7 = v; });
var $84a82d34d850bf72$export$ab26576e5e7379d7;
"use strict";
$84a82d34d850bf72$export$ab26576e5e7379d7 = $84a82d34d850bf72$var$yearsToQuarters;

var $kMovx = parcelRequire("kMovx");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $84a82d34d850bf72$var$yearsToQuarters(years) {
    return Math.trunc(years * $kMovx.quartersInYear);
}

});


parcelRegister("aRv2D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", function () { return $7e86eecca38c8d6b$export$e2911fc69bd3195e; });
$parcel$export(module.exports, "default", function () { return $7e86eecca38c8d6b$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");
function $7e86eecca38c8d6b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $7e86eecca38c8d6b$var$_setPrototypeOf(subClass, superClass);
}
function $7e86eecca38c8d6b$var$_setPrototypeOf(o, p) {
    $7e86eecca38c8d6b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7e86eecca38c8d6b$var$_setPrototypeOf(o, p);
}
function $7e86eecca38c8d6b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7e86eecca38c8d6b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $7e86eecca38c8d6b$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $7e86eecca38c8d6b$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $7e86eecca38c8d6b$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $7e86eecca38c8d6b$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $7e86eecca38c8d6b$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $7e86eecca38c8d6b$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $7e86eecca38c8d6b$var$uid = $7e86eecca38c8d6b$var$autoInc();
var $7e86eecca38c8d6b$var$passiveEventSupport;
var $7e86eecca38c8d6b$var$handlersMap = {};
var $7e86eecca38c8d6b$var$enabledInstances = {};
var $7e86eecca38c8d6b$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $7e86eecca38c8d6b$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $7e86eecca38c8d6b$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = $7e86eecca38c8d6b$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $7e86eecca38c8d6b$var$passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $7e86eecca38c8d6b$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $7e86eecca38c8d6b$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $3glZ1.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $7e86eecca38c8d6b$var$enabledInstances[_this._uid]) return;
                if (typeof $7e86eecca38c8d6b$var$passiveEventSupport === 'undefined') $7e86eecca38c8d6b$var$passiveEventSupport = $7e86eecca38c8d6b$var$testPassiveEventSupport();
                $7e86eecca38c8d6b$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $7e86eecca38c8d6b$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $7e86eecca38c8d6b$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($7e86eecca38c8d6b$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $7e86eecca38c8d6b$var$handlersMap[_this._uid], $7e86eecca38c8d6b$var$getEventHandlerOptions($7e86eecca38c8d6b$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $7e86eecca38c8d6b$var$enabledInstances[_this._uid];
                var fn = $7e86eecca38c8d6b$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $7e86eecca38c8d6b$var$getEventHandlerOptions($7e86eecca38c8d6b$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $7e86eecca38c8d6b$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $7e86eecca38c8d6b$var$uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        };
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $7e86eecca38c8d6b$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $70fFQ.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $70fFQ.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $7e86eecca38c8d6b$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $7e86eecca38c8d6b$export$2e2bcd8739ae039 = $7e86eecca38c8d6b$var$onClickOutsideHOC;

});

parcelRegister("hQ3sB", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $cfc9fa2b1616a41e$export$74665b213cb5c4cf; });
$parcel$export(module.exports, "FloatingList", function () { return $cfc9fa2b1616a41e$export$ffe15b0e64951704; });
$parcel$export(module.exports, "useListItem", function () { return $cfc9fa2b1616a41e$export$dcdc7ff5149f7d1a; });
$parcel$export(module.exports, "Composite", function () { return $cfc9fa2b1616a41e$export$43586241d9db0c6d; });
$parcel$export(module.exports, "CompositeItem", function () { return $cfc9fa2b1616a41e$export$ef1ef7a3a43ace8e; });
$parcel$export(module.exports, "useId", function () { return $cfc9fa2b1616a41e$export$f680877a34711e37; });
$parcel$export(module.exports, "FloatingArrow", function () { return $cfc9fa2b1616a41e$export$33511391554732bc; });
$parcel$export(module.exports, "useFloatingParentNodeId", function () { return $cfc9fa2b1616a41e$export$165209eae06d3488; });
$parcel$export(module.exports, "useFloatingTree", function () { return $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69; });
$parcel$export(module.exports, "useFloatingNodeId", function () { return $cfc9fa2b1616a41e$export$9b136e0e758a42f4; });
$parcel$export(module.exports, "FloatingNode", function () { return $cfc9fa2b1616a41e$export$ca00a83b5b253862; });
$parcel$export(module.exports, "FloatingTree", function () { return $cfc9fa2b1616a41e$export$587b60129641c4c8; });
$parcel$export(module.exports, "useHover", function () { return $cfc9fa2b1616a41e$export$ae780daf29e6d456; });
$parcel$export(module.exports, "useDelayGroupContext", function () { return $cfc9fa2b1616a41e$export$e2411914b150383d; });
$parcel$export(module.exports, "FloatingDelayGroup", function () { return $cfc9fa2b1616a41e$export$718279509ff1e241; });
$parcel$export(module.exports, "useDelayGroup", function () { return $cfc9fa2b1616a41e$export$560fc8be89c8b4a8; });
$parcel$export(module.exports, "useFloatingPortalNode", function () { return $cfc9fa2b1616a41e$export$ac107512f3c5cca6; });
$parcel$export(module.exports, "FloatingPortal", function () { return $cfc9fa2b1616a41e$export$31fa5d718fa2ac09; });
$parcel$export(module.exports, "FloatingFocusManager", function () { return $cfc9fa2b1616a41e$export$8aeee49171ded61a; });
$parcel$export(module.exports, "FloatingOverlay", function () { return $cfc9fa2b1616a41e$export$a35954495955337b; });
$parcel$export(module.exports, "useClick", function () { return $cfc9fa2b1616a41e$export$98524f11226063fc; });
$parcel$export(module.exports, "useClientPoint", function () { return $cfc9fa2b1616a41e$export$7fe170a73a621816; });
$parcel$export(module.exports, "useDismiss", function () { return $cfc9fa2b1616a41e$export$fcdf1ba5fafc089b; });
$parcel$export(module.exports, "useFloatingRootContext", function () { return $cfc9fa2b1616a41e$export$1df81146f8ad8e4c; });
$parcel$export(module.exports, "useFloating", function () { return $cfc9fa2b1616a41e$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "useFocus", function () { return $cfc9fa2b1616a41e$export$f8168d8dd8fd66e6; });
$parcel$export(module.exports, "useInteractions", function () { return $cfc9fa2b1616a41e$export$a519f7794e446ddd; });
$parcel$export(module.exports, "useListNavigation", function () { return $cfc9fa2b1616a41e$export$b5d22cac4ad33f40; });
$parcel$export(module.exports, "useRole", function () { return $cfc9fa2b1616a41e$export$f66572793fa256a1; });
$parcel$export(module.exports, "useTransitionStatus", function () { return $cfc9fa2b1616a41e$export$b2ef21706733f7e5; });
$parcel$export(module.exports, "useTransitionStyles", function () { return $cfc9fa2b1616a41e$export$769fba13884bc2f4; });
$parcel$export(module.exports, "useTypeahead", function () { return $cfc9fa2b1616a41e$export$d8d674d50b73ba93; });
$parcel$export(module.exports, "inner", function () { return $cfc9fa2b1616a41e$export$4ae363f1d88fb658; });
$parcel$export(module.exports, "useInnerOffset", function () { return $cfc9fa2b1616a41e$export$3d74b0dda7cc82ff; });
$parcel$export(module.exports, "safePolygon", function () { return $cfc9fa2b1616a41e$export$7484214ab62358d2; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("dgS8r")).arrow; });
$parcel$export(module.exports, "autoPlacement", function () { return (parcelRequire("dgS8r")).autoPlacement; });
$parcel$export(module.exports, "autoUpdate", function () { return (parcelRequire("ia7Xl")).autoUpdate; });
$parcel$export(module.exports, "computePosition", function () { return (parcelRequire("ia7Xl")).computePosition; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("ia7Xl")).detectOverflow; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("dgS8r")).flip; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return (parcelRequire("kQHwI")).getOverflowAncestors; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("dgS8r")).hide; });
$parcel$export(module.exports, "inline", function () { return (parcelRequire("dgS8r")).inline; });
$parcel$export(module.exports, "limitShift", function () { return (parcelRequire("dgS8r")).limitShift; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("dgS8r")).offset; });
$parcel$export(module.exports, "platform", function () { return (parcelRequire("ia7Xl")).platform; });
$parcel$export(module.exports, "shift", function () { return (parcelRequire("dgS8r")).shift; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("dgS8r")).size; });

var $70fFQ = parcelRequire("70fFQ");

var $3a9cH = parcelRequire("3a9cH");

var $dGBOw = parcelRequire("dGBOw");

var $kQHwI = parcelRequire("kQHwI");

var $6LPnk = parcelRequire("6LPnk");

var $3glZ1 = parcelRequire("3glZ1");

var $dgS8r = parcelRequire("dgS8r");
var $ia7Xl = parcelRequire("ia7Xl");
var $ia7Xl = parcelRequire("ia7Xl");
var $kQHwI = parcelRequire("kQHwI");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $cfc9fa2b1616a41e$export$74665b213cb5c4cf(refs) {
    return $70fFQ.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $cfc9fa2b1616a41e$var$SafeReact = {
    ...$70fFQ
};
const $cfc9fa2b1616a41e$var$useInsertionEffect = $cfc9fa2b1616a41e$var$SafeReact.useInsertionEffect;
const $cfc9fa2b1616a41e$var$useSafeInsertionEffect = $cfc9fa2b1616a41e$var$useInsertionEffect || ((fn)=>fn());
function $cfc9fa2b1616a41e$var$useEffectEvent(callback) {
    const ref = $70fFQ.useRef(()=>{});
    $cfc9fa2b1616a41e$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $70fFQ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $cfc9fa2b1616a41e$var$ARROW_UP = 'ArrowUp';
const $cfc9fa2b1616a41e$var$ARROW_DOWN = 'ArrowDown';
const $cfc9fa2b1616a41e$var$ARROW_LEFT = 'ArrowLeft';
const $cfc9fa2b1616a41e$var$ARROW_RIGHT = 'ArrowRight';
function $cfc9fa2b1616a41e$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $cfc9fa2b1616a41e$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $cfc9fa2b1616a41e$var$getMinIndex(listRef, disabledIndices) {
    return $cfc9fa2b1616a41e$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $cfc9fa2b1616a41e$var$getMaxIndex(listRef, disabledIndices) {
    return $cfc9fa2b1616a41e$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $cfc9fa2b1616a41e$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $cfc9fa2b1616a41e$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $cfc9fa2b1616a41e$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $cfc9fa2b1616a41e$var$ARROW_UP) {
        stop && (0, $3a9cH.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($cfc9fa2b1616a41e$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $cfc9fa2b1616a41e$var$ARROW_DOWN) {
        stop && (0, $3a9cH.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($cfc9fa2b1616a41e$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $dGBOw.floor)(prevIndex / cols);
        if (event.key === (rtl ? $cfc9fa2b1616a41e$var$ARROW_LEFT : $cfc9fa2b1616a41e$var$ARROW_RIGHT)) {
            stop && (0, $3a9cH.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $cfc9fa2b1616a41e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($cfc9fa2b1616a41e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $cfc9fa2b1616a41e$var$ARROW_RIGHT : $cfc9fa2b1616a41e$var$ARROW_LEFT)) {
            stop && (0, $3a9cH.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $cfc9fa2b1616a41e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($cfc9fa2b1616a41e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $dGBOw.floor)(maxIndex / cols) === prevRow;
        if ($cfc9fa2b1616a41e$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $cfc9fa2b1616a41e$var$ARROW_RIGHT : $cfc9fa2b1616a41e$var$ARROW_LEFT) ? maxIndex : $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $cfc9fa2b1616a41e$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $cfc9fa2b1616a41e$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $cfc9fa2b1616a41e$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $cfc9fa2b1616a41e$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var $cfc9fa2b1616a41e$var$index = typeof document !== 'undefined' ? (0, $70fFQ.useLayoutEffect) : (0, $70fFQ.useEffect);
function $cfc9fa2b1616a41e$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $cfc9fa2b1616a41e$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $cfc9fa2b1616a41e$var$FloatingListContext = /*#__PURE__*/ $70fFQ.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $cfc9fa2b1616a41e$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $70fFQ.useState(()=>new Map());
    const register = $70fFQ.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $70fFQ.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $cfc9fa2b1616a41e$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($cfc9fa2b1616a41e$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$cfc9fa2b1616a41e$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FloatingListContext.Provider, {
        value: $70fFQ.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $cfc9fa2b1616a41e$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $70fFQ.useContext($cfc9fa2b1616a41e$var$FloatingListContext);
    const [index$1, setIndex] = $70fFQ.useState(null);
    const componentRef = $70fFQ.useRef(null);
    const ref = $70fFQ.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $70fFQ.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $cfc9fa2b1616a41e$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $70fFQ.cloneElement(render, computedProps);
    return /*#__PURE__*/ $70fFQ.createElement("div", computedProps);
}
const $cfc9fa2b1616a41e$var$CompositeContext = /*#__PURE__*/ $70fFQ.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $cfc9fa2b1616a41e$var$horizontalKeys = [
    $cfc9fa2b1616a41e$var$ARROW_LEFT,
    $cfc9fa2b1616a41e$var$ARROW_RIGHT
];
const $cfc9fa2b1616a41e$var$verticalKeys = [
    $cfc9fa2b1616a41e$var$ARROW_UP,
    $cfc9fa2b1616a41e$var$ARROW_DOWN
];
const $cfc9fa2b1616a41e$var$allKeys = [
    ...$cfc9fa2b1616a41e$var$horizontalKeys,
    ...$cfc9fa2b1616a41e$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $cfc9fa2b1616a41e$export$43586241d9db0c6d = /*#__PURE__*/ $70fFQ.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $70fFQ.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $cfc9fa2b1616a41e$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $70fFQ.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $70fFQ.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$cfc9fa2b1616a41e$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $cfc9fa2b1616a41e$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $cfc9fa2b1616a41e$var$getMaxIndex(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $cfc9fa2b1616a41e$var$ARROW_LEFT : $cfc9fa2b1616a41e$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $cfc9fa2b1616a41e$var$ARROW_RIGHT : $cfc9fa2b1616a41e$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $cfc9fa2b1616a41e$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$cfc9fa2b1616a41e$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$cfc9fa2b1616a41e$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$cfc9fa2b1616a41e$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $cfc9fa2b1616a41e$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$cfc9fa2b1616a41e$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $cfc9fa2b1616a41e$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $cfc9fa2b1616a41e$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $cfc9fa2b1616a41e$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $cfc9fa2b1616a41e$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $cfc9fa2b1616a41e$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $cfc9fa2b1616a41e$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $cfc9fa2b1616a41e$var$allKeys : ({
            horizontal: $cfc9fa2b1616a41e$var$horizontalKeys,
            vertical: $cfc9fa2b1616a41e$var$verticalKeys,
            both: $cfc9fa2b1616a41e$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $cfc9fa2b1616a41e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$cfc9fa2b1616a41e$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $cfc9fa2b1616a41e$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $cfc9fa2b1616a41e$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $70fFQ.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $70fFQ.useContext($cfc9fa2b1616a41e$var$CompositeContext);
    const { ref: ref, index: index } = $cfc9fa2b1616a41e$export$dcdc7ff5149f7d1a();
    const mergedRef = $cfc9fa2b1616a41e$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $cfc9fa2b1616a41e$var$renderJsx(render, computedProps);
});
function $cfc9fa2b1616a41e$var$_extends() {
    $cfc9fa2b1616a41e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cfc9fa2b1616a41e$var$_extends.apply(this, arguments);
}
let $cfc9fa2b1616a41e$var$serverHandoffComplete = false;
let $cfc9fa2b1616a41e$var$count = 0;
const $cfc9fa2b1616a41e$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $cfc9fa2b1616a41e$var$count++;
function $cfc9fa2b1616a41e$var$useFloatingId() {
    const [id, setId] = $70fFQ.useState(()=>$cfc9fa2b1616a41e$var$serverHandoffComplete ? $cfc9fa2b1616a41e$var$genId() : undefined);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (id == null) setId($cfc9fa2b1616a41e$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $70fFQ.useEffect(()=>{
        $cfc9fa2b1616a41e$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $cfc9fa2b1616a41e$var$useReactId = $cfc9fa2b1616a41e$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $cfc9fa2b1616a41e$export$f680877a34711e37 = $cfc9fa2b1616a41e$var$useReactId || $cfc9fa2b1616a41e$var$useFloatingId;
let $cfc9fa2b1616a41e$var$devMessageSet;
function $cfc9fa2b1616a41e$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $cfc9fa2b1616a41e$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $cfc9fa2b1616a41e$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $cfc9fa2b1616a41e$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $cfc9fa2b1616a41e$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $cfc9fa2b1616a41e$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $cfc9fa2b1616a41e$export$33511391554732bc = /*#__PURE__*/ $70fFQ.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $cfc9fa2b1616a41e$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $70fFQ.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $kQHwI.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $70fFQ.createElement("svg", $cfc9fa2b1616a41e$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $70fFQ.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $70fFQ.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $70fFQ.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $70fFQ.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $cfc9fa2b1616a41e$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $cfc9fa2b1616a41e$var$FloatingNodeContext = /*#__PURE__*/ $70fFQ.createContext(null);
const $cfc9fa2b1616a41e$var$FloatingTreeContext = /*#__PURE__*/ $70fFQ.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $cfc9fa2b1616a41e$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $70fFQ.useContext($cfc9fa2b1616a41e$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69 = ()=>$70fFQ.useContext($cfc9fa2b1616a41e$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $cfc9fa2b1616a41e$export$9b136e0e758a42f4(customParentId) {
    const id = $cfc9fa2b1616a41e$export$f680877a34711e37();
    const tree = $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69();
    const reactParentId = $cfc9fa2b1616a41e$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $cfc9fa2b1616a41e$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $cfc9fa2b1616a41e$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $cfc9fa2b1616a41e$export$165209eae06d3488();
    return /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FloatingNodeContext.Provider, {
        value: $70fFQ.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $cfc9fa2b1616a41e$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $70fFQ.useRef([]);
    const addNode = $70fFQ.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $70fFQ.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $70fFQ.useState(()=>$cfc9fa2b1616a41e$var$createPubSub())[0];
    return /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FloatingTreeContext.Provider, {
        value: $70fFQ.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $cfc9fa2b1616a41e$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $cfc9fa2b1616a41e$var$useLatestRef(value) {
    const ref = (0, $70fFQ.useRef)(value);
    $cfc9fa2b1616a41e$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $cfc9fa2b1616a41e$var$safePolygonIdentifier = /*#__PURE__*/ $cfc9fa2b1616a41e$var$createAttribute('safe-polygon');
function $cfc9fa2b1616a41e$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $3a9cH.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $cfc9fa2b1616a41e$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69();
    const parentId = $cfc9fa2b1616a41e$export$165209eae06d3488();
    const handleCloseRef = $cfc9fa2b1616a41e$var$useLatestRef(handleClose);
    const delayRef = $cfc9fa2b1616a41e$var$useLatestRef(delay);
    const openRef = $cfc9fa2b1616a41e$var$useLatestRef(open);
    const pointerTypeRef = $70fFQ.useRef();
    const timeoutRef = $70fFQ.useRef(-1);
    const handlerRef = $70fFQ.useRef();
    const restTimeoutRef = $70fFQ.useRef(-1);
    const blockMouseMoveRef = $70fFQ.useRef(true);
    const performedPointerEventsMutationRef = $70fFQ.useRef(false);
    const unbindMouseMoveRef = $70fFQ.useRef(()=>{});
    const restTimeoutPendingRef = $70fFQ.useRef(false);
    const isHoverOpen = $70fFQ.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $70fFQ.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $70fFQ.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $3a9cH.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $70fFQ.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $cfc9fa2b1616a41e$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $cfc9fa2b1616a41e$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $cfc9fa2b1616a41e$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $3a9cH.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($cfc9fa2b1616a41e$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = $cfc9fa2b1616a41e$var$useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $70fFQ.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $3a9cH.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$cfc9fa2b1616a41e$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $cfc9fa2b1616a41e$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $3a9cH.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $3a9cH.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $kQHwI.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $cfc9fa2b1616a41e$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $kQHwI.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $3a9cH.getDocument)(elements.floating).body;
                body.setAttribute($cfc9fa2b1616a41e$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $70fFQ.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $70fFQ.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $3a9cH.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $70fFQ.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $cfc9fa2b1616a41e$var$NOOP = ()=>{};
const $cfc9fa2b1616a41e$var$FloatingDelayGroupContext = /*#__PURE__*/ $70fFQ.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $cfc9fa2b1616a41e$var$NOOP,
    setState: $cfc9fa2b1616a41e$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $cfc9fa2b1616a41e$export$e2411914b150383d = ()=>$70fFQ.useContext($cfc9fa2b1616a41e$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $cfc9fa2b1616a41e$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $70fFQ.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $70fFQ.useRef(null);
    const setCurrentId = $70fFQ.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FloatingDelayGroupContext.Provider, {
        value: $70fFQ.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $cfc9fa2b1616a41e$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $cfc9fa2b1616a41e$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $cfc9fa2b1616a41e$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $cfc9fa2b1616a41e$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
let $cfc9fa2b1616a41e$var$rafId = 0;
function $cfc9fa2b1616a41e$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($cfc9fa2b1616a41e$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $cfc9fa2b1616a41e$var$rafId = requestAnimationFrame(exec);
}
function $cfc9fa2b1616a41e$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $cfc9fa2b1616a41e$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $cfc9fa2b1616a41e$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $cfc9fa2b1616a41e$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $cfc9fa2b1616a41e$var$counterMap = /*#__PURE__*/ new WeakMap();
let $cfc9fa2b1616a41e$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $cfc9fa2b1616a41e$var$markerMap = {};
let $cfc9fa2b1616a41e$var$lockCount$1 = 0;
const $cfc9fa2b1616a41e$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $cfc9fa2b1616a41e$var$unwrapHost = (node)=>node && (node.host || $cfc9fa2b1616a41e$var$unwrapHost(node.parentNode));
const $cfc9fa2b1616a41e$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $cfc9fa2b1616a41e$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $cfc9fa2b1616a41e$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $cfc9fa2b1616a41e$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$cfc9fa2b1616a41e$var$markerMap[markerName]) $cfc9fa2b1616a41e$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $cfc9fa2b1616a41e$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $kQHwI.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($cfc9fa2b1616a41e$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $cfc9fa2b1616a41e$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $cfc9fa2b1616a41e$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $cfc9fa2b1616a41e$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($cfc9fa2b1616a41e$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $cfc9fa2b1616a41e$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$cfc9fa2b1616a41e$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $cfc9fa2b1616a41e$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $cfc9fa2b1616a41e$var$lockCount$1--;
        if (!$cfc9fa2b1616a41e$var$lockCount$1) {
            $cfc9fa2b1616a41e$var$counterMap = new WeakMap();
            $cfc9fa2b1616a41e$var$counterMap = new WeakMap();
            $cfc9fa2b1616a41e$var$uncontrolledElementsSet = new WeakSet();
            $cfc9fa2b1616a41e$var$markerMap = {};
        }
    };
}
function $cfc9fa2b1616a41e$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $3a9cH.getDocument)(avoidElements[0]).body;
    return $cfc9fa2b1616a41e$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $cfc9fa2b1616a41e$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $cfc9fa2b1616a41e$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $6LPnk.tabbable)(container, $cfc9fa2b1616a41e$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $3a9cH.activeElement)((0, $3a9cH.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $cfc9fa2b1616a41e$var$getNextTabbable() {
    return $cfc9fa2b1616a41e$var$getTabbableIn(document.body, 'next');
}
function $cfc9fa2b1616a41e$var$getPreviousTabbable() {
    return $cfc9fa2b1616a41e$var$getTabbableIn(document.body, 'prev');
}
function $cfc9fa2b1616a41e$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $3a9cH.contains)(containerElement, relatedTarget);
}
function $cfc9fa2b1616a41e$var$disableFocusInside(container) {
    const tabbableElements = (0, $6LPnk.tabbable)(container, $cfc9fa2b1616a41e$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $cfc9fa2b1616a41e$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $cfc9fa2b1616a41e$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $cfc9fa2b1616a41e$var$timeoutId;
function $cfc9fa2b1616a41e$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($cfc9fa2b1616a41e$var$timeoutId);
    }
}
const $cfc9fa2b1616a41e$var$FocusGuard = /*#__PURE__*/ $70fFQ.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $70fFQ.useState();
    $cfc9fa2b1616a41e$var$index(()=>{
        if ((0, $3a9cH.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $cfc9fa2b1616a41e$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $cfc9fa2b1616a41e$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$cfc9fa2b1616a41e$var$createAttribute('focus-guard')]: '',
        style: $cfc9fa2b1616a41e$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $70fFQ.createElement("span", $cfc9fa2b1616a41e$var$_extends({}, props, restProps));
});
const $cfc9fa2b1616a41e$var$PortalContext = /*#__PURE__*/ $70fFQ.createContext(null);
const $cfc9fa2b1616a41e$var$attr = /*#__PURE__*/ $cfc9fa2b1616a41e$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $cfc9fa2b1616a41e$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $cfc9fa2b1616a41e$export$f680877a34711e37();
    const portalContext = $cfc9fa2b1616a41e$var$usePortalContext();
    const [portalNode, setPortalNode] = $70fFQ.useState(null);
    const portalNodeRef = $70fFQ.useRef(null);
    $cfc9fa2b1616a41e$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($cfc9fa2b1616a41e$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $kQHwI.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($cfc9fa2b1616a41e$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $cfc9fa2b1616a41e$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $cfc9fa2b1616a41e$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $70fFQ.useState(null);
    const beforeOutsideRef = $70fFQ.useRef(null);
    const afterOutsideRef = $70fFQ.useRef(null);
    const beforeInsideRef = $70fFQ.useRef(null);
    const afterInsideRef = $70fFQ.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $70fFQ.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $cfc9fa2b1616a41e$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $cfc9fa2b1616a41e$var$enableFocusInside : $cfc9fa2b1616a41e$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $70fFQ.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $cfc9fa2b1616a41e$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$PortalContext.Provider, {
        value: $70fFQ.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($cfc9fa2b1616a41e$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $cfc9fa2b1616a41e$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $70fFQ.createElement("span", {
        "aria-owns": portalNode.id,
        style: $cfc9fa2b1616a41e$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $3glZ1.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($cfc9fa2b1616a41e$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $cfc9fa2b1616a41e$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $cfc9fa2b1616a41e$var$usePortalContext = ()=>$70fFQ.useContext($cfc9fa2b1616a41e$var$PortalContext);
const $cfc9fa2b1616a41e$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $cfc9fa2b1616a41e$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($cfc9fa2b1616a41e$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $cfc9fa2b1616a41e$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $cfc9fa2b1616a41e$var$LIST_LIMIT = 20;
let $cfc9fa2b1616a41e$var$previouslyFocusedElements = [];
function $cfc9fa2b1616a41e$var$addPreviouslyFocusedElement(element) {
    $cfc9fa2b1616a41e$var$previouslyFocusedElements = $cfc9fa2b1616a41e$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $kQHwI.getNodeName)(tabbableEl) === 'body') return;
    if (!(0, $6LPnk.isTabbable)(tabbableEl, $cfc9fa2b1616a41e$var$getTabbableOptions())) {
        const tabbableChild = (0, $6LPnk.tabbable)(tabbableEl, $cfc9fa2b1616a41e$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $cfc9fa2b1616a41e$var$previouslyFocusedElements.push(tabbableEl);
    if ($cfc9fa2b1616a41e$var$previouslyFocusedElements.length > $cfc9fa2b1616a41e$var$LIST_LIMIT) $cfc9fa2b1616a41e$var$previouslyFocusedElements = $cfc9fa2b1616a41e$var$previouslyFocusedElements.slice(-$cfc9fa2b1616a41e$var$LIST_LIMIT);
}
function $cfc9fa2b1616a41e$var$getPreviouslyFocusedElement() {
    return $cfc9fa2b1616a41e$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $cfc9fa2b1616a41e$var$VisuallyHiddenDismiss = /*#__PURE__*/ $70fFQ.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $70fFQ.createElement("button", $cfc9fa2b1616a41e$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $cfc9fa2b1616a41e$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $cfc9fa2b1616a41e$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $3a9cH.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $cfc9fa2b1616a41e$var$supportsInert() ? _guards : true;
    const orderRef = $cfc9fa2b1616a41e$var$useLatestRef(order);
    const initialFocusRef = $cfc9fa2b1616a41e$var$useLatestRef(initialFocus);
    const returnFocusRef = $cfc9fa2b1616a41e$var$useLatestRef(returnFocus);
    const tree = $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69();
    const portalContext = $cfc9fa2b1616a41e$var$usePortalContext();
    const startDismissButtonRef = $70fFQ.useRef(null);
    const endDismissButtonRef = $70fFQ.useRef(null);
    const preventReturnFocusRef = $70fFQ.useRef(false);
    const isPointerDownRef = $70fFQ.useRef(false);
    const tabbableIndexRef = $70fFQ.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $cfc9fa2b1616a41e$var$getFloatingFocusElement(floating);
    const getTabbableContent = $cfc9fa2b1616a41e$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $6LPnk.tabbable)(container, $cfc9fa2b1616a41e$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $cfc9fa2b1616a41e$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $70fFQ.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $3a9cH.contains)(floatingFocusElement, (0, $3a9cH.activeElement)((0, $3a9cH.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $3a9cH.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $3a9cH.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $3a9cH.stopEvent)(event);
                    if (event.shiftKey) $cfc9fa2b1616a41e$var$enqueueFocus(els[els.length - 1]);
                    else $cfc9fa2b1616a41e$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $3a9cH.stopEvent)(event);
                    $cfc9fa2b1616a41e$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $3a9cH.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $70fFQ.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $3a9cH.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $70fFQ.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $3a9cH.contains)(domReference, relatedTarget) || (0, $3a9cH.contains)(floating, relatedTarget) || (0, $3a9cH.contains)(relatedTarget, floating) || (0, $3a9cH.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($cfc9fa2b1616a41e$var$createAttribute('focus-guard')) || tree && ($cfc9fa2b1616a41e$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $3a9cH.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $3a9cH.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $cfc9fa2b1616a41e$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $3a9cH.activeElement)((0, $3a9cH.getDocument)(floatingFocusElement)) === (0, $3a9cH.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $kQHwI.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $kQHwI.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $cfc9fa2b1616a41e$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $kQHwI.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $70fFQ.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $cfc9fa2b1616a41e$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $cfc9fa2b1616a41e$var$markOthers(insideElements, guards, !guards) : $cfc9fa2b1616a41e$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (disabled || !(0, $kQHwI.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $3a9cH.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $3a9cH.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $3a9cH.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $cfc9fa2b1616a41e$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $3a9cH.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $3a9cH.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $cfc9fa2b1616a41e$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $cfc9fa2b1616a41e$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $3a9cH.isVirtualClick)(event) || (0, $3a9cH.isVirtualPointerEvent)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $cfc9fa2b1616a41e$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') return $cfc9fa2b1616a41e$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $3a9cH.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $3a9cH.contains)(floating, activeEl) || tree && $cfc9fa2b1616a41e$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $3a9cH.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $cfc9fa2b1616a41e$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $kQHwI.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    $70fFQ.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $cfc9fa2b1616a41e$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $3a9cH.activeElement)((0, $3a9cH.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $70fFQ.createElement($70fFQ.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $cfc9fa2b1616a41e$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($cfc9fa2b1616a41e$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $cfc9fa2b1616a41e$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $70fFQ.createElement($cfc9fa2b1616a41e$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $cfc9fa2b1616a41e$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($cfc9fa2b1616a41e$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $cfc9fa2b1616a41e$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $cfc9fa2b1616a41e$var$lockCount = 0;
function $cfc9fa2b1616a41e$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $3a9cH.getPlatform)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $cfc9fa2b1616a41e$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $cfc9fa2b1616a41e$export$a35954495955337b = /*#__PURE__*/ $70fFQ.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!lockScroll) return;
        $cfc9fa2b1616a41e$var$lockCount++;
        if ($cfc9fa2b1616a41e$var$lockCount === 1) $cfc9fa2b1616a41e$var$cleanup = $cfc9fa2b1616a41e$var$enableScrollLock();
        return ()=>{
            $cfc9fa2b1616a41e$var$lockCount--;
            if ($cfc9fa2b1616a41e$var$lockCount === 0) $cfc9fa2b1616a41e$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $70fFQ.createElement("div", $cfc9fa2b1616a41e$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $cfc9fa2b1616a41e$var$isButtonTarget(event) {
    return (0, $kQHwI.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function $cfc9fa2b1616a41e$var$isSpaceIgnored(element) {
    return (0, $3a9cH.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $cfc9fa2b1616a41e$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $70fFQ.useRef();
    const didKeyDownRef = $70fFQ.useRef(false);
    const reference = $70fFQ.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $3a9cH.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $3a9cH.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $cfc9fa2b1616a41e$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$cfc9fa2b1616a41e$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $cfc9fa2b1616a41e$var$isButtonTarget(event) || $cfc9fa2b1616a41e$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $cfc9fa2b1616a41e$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $cfc9fa2b1616a41e$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $cfc9fa2b1616a41e$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $70fFQ.useRef(false);
    const cleanupListenerRef = $70fFQ.useRef(null);
    const [pointerType, setPointerType] = $70fFQ.useState();
    const [reactive, setReactive] = $70fFQ.useState([]);
    const setReference = $cfc9fa2b1616a41e$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$cfc9fa2b1616a41e$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($cfc9fa2b1616a41e$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $cfc9fa2b1616a41e$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $3a9cH.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $70fFQ.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $kQHwI.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $3a9cH.getTarget)(event);
            if (!(0, $3a9cH.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $cfc9fa2b1616a41e$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $70fFQ.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $70fFQ.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $70fFQ.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $70fFQ.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $cfc9fa2b1616a41e$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $cfc9fa2b1616a41e$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $cfc9fa2b1616a41e$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $cfc9fa2b1616a41e$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $cfc9fa2b1616a41e$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $70fFQ.useRef(false);
    const endedOrStartedInsideRef = $70fFQ.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $cfc9fa2b1616a41e$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $cfc9fa2b1616a41e$var$normalizeProp(capture);
    const isComposingRef = $70fFQ.useRef(false);
    const closeOnEscapeKeyDown = $cfc9fa2b1616a41e$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $cfc9fa2b1616a41e$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $3a9cH.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $cfc9fa2b1616a41e$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $3a9cH.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $3a9cH.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $cfc9fa2b1616a41e$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $3a9cH.getTarget)(event);
        const inertSelector = "[" + $cfc9fa2b1616a41e$var$createAttribute('inert') + "]";
        const markers = (0, $3a9cH.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $kQHwI.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $kQHwI.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $kQHwI.getParentNode)(targetRootAncestor);
            if ((0, $kQHwI.isLastTraversableNode)(nextParent) || !(0, $kQHwI.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $kQHwI.isElement)(target) && !(0, $3a9cH.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $3a9cH.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $3a9cH.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $kQHwI.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $kQHwI.getComputedStyle)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $cfc9fa2b1616a41e$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $3a9cH.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $3a9cH.isEventTargetWithin)(event, elements.floating) || (0, $3a9cH.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $cfc9fa2b1616a41e$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $cfc9fa2b1616a41e$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $3a9cH.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $3a9cH.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $70fFQ.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $kQHwI.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $3a9cH.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $kQHwI.isElement)(elements.domReference)) ancestors = (0, $kQHwI.getOverflowAncestors)(elements.domReference);
            if ((0, $kQHwI.isElement)(elements.floating)) ancestors = ancestors.concat((0, $kQHwI.getOverflowAncestors)(elements.floating));
            if (!(0, $kQHwI.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $kQHwI.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $70fFQ.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $70fFQ.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$cfc9fa2b1616a41e$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $70fFQ.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$cfc9fa2b1616a41e$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $cfc9fa2b1616a41e$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $cfc9fa2b1616a41e$export$f680877a34711e37();
    const dataRef = $70fFQ.useRef({});
    const [events] = $70fFQ.useState(()=>$cfc9fa2b1616a41e$var$createPubSub());
    const nested = $cfc9fa2b1616a41e$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $70fFQ.useState(elementsProp.reference);
    const onOpenChange = $cfc9fa2b1616a41e$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $70fFQ.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $70fFQ.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $70fFQ.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $cfc9fa2b1616a41e$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $cfc9fa2b1616a41e$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $70fFQ.useState(null);
    const [positionReference, _setPositionReference] = $70fFQ.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $70fFQ.useRef(null);
    const tree = $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69();
    $cfc9fa2b1616a41e$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $dgS8r.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $70fFQ.useCallback((node)=>{
        const computedPositionReference = (0, $kQHwI.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $70fFQ.useCallback((node)=>{
        if ((0, $kQHwI.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $kQHwI.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $kQHwI.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $70fFQ.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $70fFQ.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $70fFQ.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $70fFQ.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $cfc9fa2b1616a41e$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $70fFQ.useRef(false);
    const timeoutRef = $70fFQ.useRef();
    const keyboardModalityRef = $70fFQ.useRef(true);
    $70fFQ.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $kQHwI.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $kQHwI.isHTMLElement)(elements.domReference) && elements.domReference === (0, $3a9cH.activeElement)((0, $3a9cH.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $70fFQ.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $70fFQ.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $70fFQ.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $3a9cH.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $3a9cH.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $kQHwI.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $3a9cH.isSafari)() && (0, $3a9cH.isMac)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $3a9cH.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $kQHwI.isElement)(relatedTarget) && relatedTarget.hasAttribute($cfc9fa2b1616a41e$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $3a9cH.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $3a9cH.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $3a9cH.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $cfc9fa2b1616a41e$var$ACTIVE_KEY = 'active';
const $cfc9fa2b1616a41e$var$SELECTED_KEY = 'selected';
function $cfc9fa2b1616a41e$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$cfc9fa2b1616a41e$var$ACTIVE_KEY]: _, [$cfc9fa2b1616a41e$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$cfc9fa2b1616a41e$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $cfc9fa2b1616a41e$var$ACTIVE_KEY,
                    $cfc9fa2b1616a41e$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $cfc9fa2b1616a41e$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $70fFQ.useCallback((userProps)=>$cfc9fa2b1616a41e$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $70fFQ.useCallback((userProps)=>$cfc9fa2b1616a41e$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $70fFQ.useCallback((userProps)=>$cfc9fa2b1616a41e$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $70fFQ.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $cfc9fa2b1616a41e$var$isPreventScrollSupported = false;
function $cfc9fa2b1616a41e$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $cfc9fa2b1616a41e$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $cfc9fa2b1616a41e$var$ARROW_UP || key === $cfc9fa2b1616a41e$var$ARROW_DOWN;
    const horizontal = key === $cfc9fa2b1616a41e$var$ARROW_LEFT || key === $cfc9fa2b1616a41e$var$ARROW_RIGHT;
    return $cfc9fa2b1616a41e$var$doSwitch(orientation, vertical, horizontal);
}
function $cfc9fa2b1616a41e$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $cfc9fa2b1616a41e$var$ARROW_DOWN;
    const horizontal = rtl ? key === $cfc9fa2b1616a41e$var$ARROW_LEFT : key === $cfc9fa2b1616a41e$var$ARROW_RIGHT;
    return $cfc9fa2b1616a41e$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $cfc9fa2b1616a41e$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $cfc9fa2b1616a41e$var$ARROW_LEFT : key === $cfc9fa2b1616a41e$var$ARROW_RIGHT;
    const horizontal = key === $cfc9fa2b1616a41e$var$ARROW_DOWN;
    return $cfc9fa2b1616a41e$var$doSwitch(orientation, vertical, horizontal);
}
function $cfc9fa2b1616a41e$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $cfc9fa2b1616a41e$var$ARROW_RIGHT : key === $cfc9fa2b1616a41e$var$ARROW_LEFT;
    const horizontal = key === $cfc9fa2b1616a41e$var$ARROW_UP;
    return $cfc9fa2b1616a41e$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $cfc9fa2b1616a41e$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $cfc9fa2b1616a41e$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $cfc9fa2b1616a41e$var$useLatestRef(floatingFocusElement);
    const parentId = $cfc9fa2b1616a41e$export$165209eae06d3488();
    const tree = $cfc9fa2b1616a41e$export$db0c2a7c7a2a4f69();
    const onNavigate = $cfc9fa2b1616a41e$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $3a9cH.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $70fFQ.useRef(focusItemOnOpen);
    const indexRef = $70fFQ.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $70fFQ.useRef(null);
    const isPointerModalityRef = $70fFQ.useRef(true);
    const previousOnNavigateRef = $70fFQ.useRef(onNavigate);
    const previousMountedRef = $70fFQ.useRef(!!elements.floating);
    const previousOpenRef = $70fFQ.useRef(open);
    const forceSyncFocus = $70fFQ.useRef(false);
    const forceScrollIntoViewRef = $70fFQ.useRef(false);
    const disabledIndicesRef = $cfc9fa2b1616a41e$var$useLatestRef(disabledIndices);
    const latestOpenRef = $cfc9fa2b1616a41e$var$useLatestRef(open);
    const scrollItemIntoViewRef = $cfc9fa2b1616a41e$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $cfc9fa2b1616a41e$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $70fFQ.useState();
    const [virtualId, setVirtualId] = $70fFQ.useState();
    const focusItem = $cfc9fa2b1616a41e$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $cfc9fa2b1616a41e$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $3a9cH.isMac)() && (0, $3a9cH.isSafari)() ? $cfc9fa2b1616a41e$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $cfc9fa2b1616a41e$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $cfc9fa2b1616a41e$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $cfc9fa2b1616a41e$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $cfc9fa2b1616a41e$var$getMinIndex(listRef, disabledIndicesRef.current) : $cfc9fa2b1616a41e$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$cfc9fa2b1616a41e$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $cfc9fa2b1616a41e$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $3a9cH.activeElement)((0, $3a9cH.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $3a9cH.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $70fFQ.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $cfc9fa2b1616a41e$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $cfc9fa2b1616a41e$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $cfc9fa2b1616a41e$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $3a9cH.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $kQHwI.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $cfc9fa2b1616a41e$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $cfc9fa2b1616a41e$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $3a9cH.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $3a9cH.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $cfc9fa2b1616a41e$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$cfc9fa2b1616a41e$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$cfc9fa2b1616a41e$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$cfc9fa2b1616a41e$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $cfc9fa2b1616a41e$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$cfc9fa2b1616a41e$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $cfc9fa2b1616a41e$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $cfc9fa2b1616a41e$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $cfc9fa2b1616a41e$var$ARROW_LEFT : $cfc9fa2b1616a41e$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($cfc9fa2b1616a41e$var$isMainOrientationKey(event.key, orientation)) {
            (0, $3a9cH.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $3a9cH.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $cfc9fa2b1616a41e$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($cfc9fa2b1616a41e$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $cfc9fa2b1616a41e$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $cfc9fa2b1616a41e$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $cfc9fa2b1616a41e$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $cfc9fa2b1616a41e$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($cfc9fa2b1616a41e$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $70fFQ.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $70fFQ.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $3a9cH.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $70fFQ.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $3a9cH.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $3a9cH.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $cfc9fa2b1616a41e$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $cfc9fa2b1616a41e$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $cfc9fa2b1616a41e$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $cfc9fa2b1616a41e$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $3a9cH.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $3a9cH.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $3a9cH.stopEvent)(event);
                        if (open) {
                            indexRef.current = $cfc9fa2b1616a41e$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $3a9cH.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $cfc9fa2b1616a41e$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $cfc9fa2b1616a41e$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $cfc9fa2b1616a41e$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $cfc9fa2b1616a41e$export$f680877a34711e37();
    const parentId = $cfc9fa2b1616a41e$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $70fFQ.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $70fFQ.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $70fFQ.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $cfc9fa2b1616a41e$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $cfc9fa2b1616a41e$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $cfc9fa2b1616a41e$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $70fFQ.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $70fFQ.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $cfc9fa2b1616a41e$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $70fFQ.useState('unmounted');
    const isMounted = $cfc9fa2b1616a41e$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $cfc9fa2b1616a41e$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $cfc9fa2b1616a41e$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $70fFQ.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $70fFQ.useState(()=>({
            ...$cfc9fa2b1616a41e$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$cfc9fa2b1616a41e$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $cfc9fa2b1616a41e$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $cfc9fa2b1616a41e$var$useLatestRef(unstable_initial);
    const openRef = $cfc9fa2b1616a41e$var$useLatestRef(unstable_open);
    const closeRef = $cfc9fa2b1616a41e$var$useLatestRef(unstable_close);
    const commonRef = $cfc9fa2b1616a41e$var$useLatestRef(unstable_common);
    $cfc9fa2b1616a41e$var$index(()=>{
        const initialStyles = $cfc9fa2b1616a41e$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $cfc9fa2b1616a41e$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $cfc9fa2b1616a41e$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $cfc9fa2b1616a41e$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($cfc9fa2b1616a41e$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($cfc9fa2b1616a41e$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $cfc9fa2b1616a41e$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $70fFQ.useRef();
    const stringRef = $70fFQ.useRef('');
    const prevIndexRef = $70fFQ.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $70fFQ.useRef(null);
    const onMatch = $cfc9fa2b1616a41e$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $cfc9fa2b1616a41e$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $cfc9fa2b1616a41e$var$useLatestRef(findMatch);
    const ignoreKeysRef = $cfc9fa2b1616a41e$var$useLatestRef(ignoreKeys);
    $cfc9fa2b1616a41e$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $cfc9fa2b1616a41e$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $cfc9fa2b1616a41e$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $cfc9fa2b1616a41e$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $3a9cH.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $3a9cH.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $70fFQ.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $70fFQ.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $cfc9fa2b1616a41e$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $cfc9fa2b1616a41e$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $dGBOw.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $dgS8r.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $ia7Xl.detectOverflow)($cfc9fa2b1616a41e$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $ia7Xl.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $dGBOw.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $dGBOw.round);
            const maxHeight = rounder((0, $dGBOw.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $dGBOw.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $dGBOw.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $3glZ1.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $ia7Xl.detectOverflow)($cfc9fa2b1616a41e$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $cfc9fa2b1616a41e$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $cfc9fa2b1616a41e$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $70fFQ.useRef(false);
    const prevScrollTopRef = $70fFQ.useRef(null);
    const initialOverflowRef = $70fFQ.useRef(null);
    $70fFQ.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $3glZ1.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $3a9cH.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $70fFQ.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $3glZ1.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $70fFQ.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $cfc9fa2b1616a41e$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $cfc9fa2b1616a41e$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $cfc9fa2b1616a41e$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $3a9cH.getTarget)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $3a9cH.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $3a9cH.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $cfc9fa2b1616a41e$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $kQHwI.isElement)(event.relatedTarget) && (0, $3a9cH.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $cfc9fa2b1616a41e$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($cfc9fa2b1616a41e$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$cfc9fa2b1616a41e$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("3a9cH", function(module, exports) {

$parcel$export(module.exports, "activeElement", function () { return $24d971f1e6c3e824$export$da980962bd2147a4; });
$parcel$export(module.exports, "contains", function () { return $24d971f1e6c3e824$export$2344b14b097df817; });
$parcel$export(module.exports, "getPlatform", function () { return $24d971f1e6c3e824$export$867a782338812cb4; });
$parcel$export(module.exports, "getUserAgent", function () { return $24d971f1e6c3e824$export$7935961ef7719cb0; });
$parcel$export(module.exports, "isVirtualClick", function () { return $24d971f1e6c3e824$export$60278871457622de; });
$parcel$export(module.exports, "isVirtualPointerEvent", function () { return $24d971f1e6c3e824$export$29bf1b5f2c56cf63; });
$parcel$export(module.exports, "isSafari", function () { return $24d971f1e6c3e824$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isMac", function () { return $24d971f1e6c3e824$export$9ac100e40613ea10; });
$parcel$export(module.exports, "isMouseLikePointerType", function () { return $24d971f1e6c3e824$export$81cf264172d31e51; });
$parcel$export(module.exports, "isReactEvent", function () { return $24d971f1e6c3e824$export$94781ce41a161222; });
$parcel$export(module.exports, "isRootElement", function () { return $24d971f1e6c3e824$export$7b296c28e0fa3aed; });
$parcel$export(module.exports, "getDocument", function () { return $24d971f1e6c3e824$export$f65ca476c09acec0; });
$parcel$export(module.exports, "isEventTargetWithin", function () { return $24d971f1e6c3e824$export$43c3154d5bf2c6c2; });
$parcel$export(module.exports, "getTarget", function () { return $24d971f1e6c3e824$export$c22522a4dfa48e9c; });
$parcel$export(module.exports, "isTypeableElement", function () { return $24d971f1e6c3e824$export$42ad131c32f0fb8d; });
$parcel$export(module.exports, "stopEvent", function () { return $24d971f1e6c3e824$export$7ae4cd3a66c1e050; });
$parcel$export(module.exports, "isTypeableCombobox", function () { return $24d971f1e6c3e824$export$259ba5ae38188551; });

var $kQHwI = parcelRequire("kQHwI");
function $24d971f1e6c3e824$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $24d971f1e6c3e824$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $kQHwI.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $24d971f1e6c3e824$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $24d971f1e6c3e824$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $24d971f1e6c3e824$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($24d971f1e6c3e824$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $24d971f1e6c3e824$export$29bf1b5f2c56cf63(event) {
    if ($24d971f1e6c3e824$export$c8f880a2d81914c4()) return false;
    return !$24d971f1e6c3e824$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $24d971f1e6c3e824$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $24d971f1e6c3e824$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $24d971f1e6c3e824$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($24d971f1e6c3e824$export$867a782338812cb4()) || re.test($24d971f1e6c3e824$export$7935961ef7719cb0());
}
function $24d971f1e6c3e824$export$9ac100e40613ea10() {
    return $24d971f1e6c3e824$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $24d971f1e6c3e824$export$c8f880a2d81914c4() {
    return $24d971f1e6c3e824$export$7935961ef7719cb0().includes('jsdom/');
}
function $24d971f1e6c3e824$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $24d971f1e6c3e824$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $24d971f1e6c3e824$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $24d971f1e6c3e824$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $24d971f1e6c3e824$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $24d971f1e6c3e824$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $24d971f1e6c3e824$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $24d971f1e6c3e824$export$42ad131c32f0fb8d(element) {
    return (0, $kQHwI.isHTMLElement)(element) && element.matches($24d971f1e6c3e824$export$78b3d091ff376bc);
}
function $24d971f1e6c3e824$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $24d971f1e6c3e824$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $24d971f1e6c3e824$export$42ad131c32f0fb8d(element);
}

});
parcelRegister("kQHwI", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $f2da6d7a764f7e1e$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $f2da6d7a764f7e1e$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $f2da6d7a764f7e1e$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $f2da6d7a764f7e1e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $f2da6d7a764f7e1e$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $f2da6d7a764f7e1e$export$af51f0f06c0f328a; });
$parcel$export(module.exports, "isOverflowElement", function () { return $f2da6d7a764f7e1e$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $f2da6d7a764f7e1e$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $f2da6d7a764f7e1e$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $f2da6d7a764f7e1e$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $f2da6d7a764f7e1e$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $f2da6d7a764f7e1e$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $f2da6d7a764f7e1e$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $f2da6d7a764f7e1e$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $f2da6d7a764f7e1e$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $f2da6d7a764f7e1e$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $f2da6d7a764f7e1e$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $f2da6d7a764f7e1e$export$7bf1f8740e3e34af; });
function $f2da6d7a764f7e1e$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $f2da6d7a764f7e1e$export$651544f548703224(node) {
    if ($f2da6d7a764f7e1e$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $f2da6d7a764f7e1e$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $f2da6d7a764f7e1e$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($f2da6d7a764f7e1e$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $f2da6d7a764f7e1e$export$8ee0fc9ee280b4ee(value) {
    if (!$f2da6d7a764f7e1e$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $f2da6d7a764f7e1e$export$38b2d434cce3ea22(value).Node;
}
function $f2da6d7a764f7e1e$export$45a5e7f76e0caa8d(value) {
    if (!$f2da6d7a764f7e1e$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $f2da6d7a764f7e1e$export$38b2d434cce3ea22(value).Element;
}
function $f2da6d7a764f7e1e$export$1b3bfaa9684536aa(value) {
    if (!$f2da6d7a764f7e1e$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $f2da6d7a764f7e1e$export$38b2d434cce3ea22(value).HTMLElement;
}
function $f2da6d7a764f7e1e$export$af51f0f06c0f328a(value) {
    if (!$f2da6d7a764f7e1e$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $f2da6d7a764f7e1e$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $f2da6d7a764f7e1e$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $f2da6d7a764f7e1e$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $f2da6d7a764f7e1e$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($f2da6d7a764f7e1e$export$651544f548703224(element));
}
function $f2da6d7a764f7e1e$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $f2da6d7a764f7e1e$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $f2da6d7a764f7e1e$var$containRe = /paint|layout|strict|content/;
const $f2da6d7a764f7e1e$var$isNotNone = (value)=>!!value && value !== 'none';
let $f2da6d7a764f7e1e$var$isWebKitValue;
function $f2da6d7a764f7e1e$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $f2da6d7a764f7e1e$export$45a5e7f76e0caa8d(elementOrCss) ? $f2da6d7a764f7e1e$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $f2da6d7a764f7e1e$var$isNotNone(css.transform) || $f2da6d7a764f7e1e$var$isNotNone(css.translate) || $f2da6d7a764f7e1e$var$isNotNone(css.scale) || $f2da6d7a764f7e1e$var$isNotNone(css.rotate) || $f2da6d7a764f7e1e$var$isNotNone(css.perspective) || !$f2da6d7a764f7e1e$export$78551043582a6a98() && ($f2da6d7a764f7e1e$var$isNotNone(css.backdropFilter) || $f2da6d7a764f7e1e$var$isNotNone(css.filter)) || $f2da6d7a764f7e1e$var$willChangeRe.test(css.willChange || '') || $f2da6d7a764f7e1e$var$containRe.test(css.contain || '');
}
function $f2da6d7a764f7e1e$export$940d8225183e1404(element) {
    let currentNode = $f2da6d7a764f7e1e$export$4e12058fc4d51d56(element);
    while($f2da6d7a764f7e1e$export$1b3bfaa9684536aa(currentNode) && !$f2da6d7a764f7e1e$export$d1162fb0b6d4cd51(currentNode)){
        if ($f2da6d7a764f7e1e$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($f2da6d7a764f7e1e$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $f2da6d7a764f7e1e$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $f2da6d7a764f7e1e$export$78551043582a6a98() {
    if ($f2da6d7a764f7e1e$var$isWebKitValue == null) $f2da6d7a764f7e1e$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $f2da6d7a764f7e1e$var$isWebKitValue;
}
function $f2da6d7a764f7e1e$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($f2da6d7a764f7e1e$export$651544f548703224(node));
}
function $f2da6d7a764f7e1e$export$3735103072e4a80(element) {
    return $f2da6d7a764f7e1e$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $f2da6d7a764f7e1e$export$dc8fc79fa2800137(element) {
    if ($f2da6d7a764f7e1e$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $f2da6d7a764f7e1e$export$4e12058fc4d51d56(node) {
    if ($f2da6d7a764f7e1e$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $f2da6d7a764f7e1e$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $f2da6d7a764f7e1e$export$e495491855dc5418(node);
    return $f2da6d7a764f7e1e$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $f2da6d7a764f7e1e$export$7cd01a57c8ca906c(node) {
    const parentNode = $f2da6d7a764f7e1e$export$4e12058fc4d51d56(node);
    if ($f2da6d7a764f7e1e$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($f2da6d7a764f7e1e$export$1b3bfaa9684536aa(parentNode) && $f2da6d7a764f7e1e$export$989e911fa9af580a(parentNode)) return parentNode;
    return $f2da6d7a764f7e1e$export$7cd01a57c8ca906c(parentNode);
}
function $f2da6d7a764f7e1e$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $f2da6d7a764f7e1e$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $f2da6d7a764f7e1e$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $f2da6d7a764f7e1e$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $f2da6d7a764f7e1e$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $f2da6d7a764f7e1e$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $f2da6d7a764f7e1e$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $f2da6d7a764f7e1e$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("dGBOw", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $9f6c87a1d12fe04d$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $9f6c87a1d12fe04d$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $9f6c87a1d12fe04d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $9f6c87a1d12fe04d$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $9f6c87a1d12fe04d$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $9f6c87a1d12fe04d$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $9f6c87a1d12fe04d$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $9f6c87a1d12fe04d$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $9f6c87a1d12fe04d$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $9f6c87a1d12fe04d$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $9f6c87a1d12fe04d$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $9f6c87a1d12fe04d$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $9f6c87a1d12fe04d$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $9f6c87a1d12fe04d$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $9f6c87a1d12fe04d$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $9f6c87a1d12fe04d$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $9f6c87a1d12fe04d$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $9f6c87a1d12fe04d$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $9f6c87a1d12fe04d$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $9f6c87a1d12fe04d$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $9f6c87a1d12fe04d$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $9f6c87a1d12fe04d$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $9f6c87a1d12fe04d$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $9f6c87a1d12fe04d$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $9f6c87a1d12fe04d$export$803cd8101b6c182b = /*#__PURE__*/ $9f6c87a1d12fe04d$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $9f6c87a1d12fe04d$export$27b07d8a310ed8b5[0], side + "-" + $9f6c87a1d12fe04d$export$27b07d8a310ed8b5[1]), []);
const $9f6c87a1d12fe04d$export$96ec731ed4dcb222 = Math.min;
const $9f6c87a1d12fe04d$export$8960430cfd85939f = Math.max;
const $9f6c87a1d12fe04d$export$2077e0241d6afd3c = Math.round;
const $9f6c87a1d12fe04d$export$a3fe094919f356fd = Math.floor;
const $9f6c87a1d12fe04d$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $9f6c87a1d12fe04d$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $9f6c87a1d12fe04d$export$7d15b64cf5a3a4c4(start, value, end) {
    return $9f6c87a1d12fe04d$export$8960430cfd85939f(start, $9f6c87a1d12fe04d$export$96ec731ed4dcb222(value, end));
}
function $9f6c87a1d12fe04d$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $9f6c87a1d12fe04d$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $9f6c87a1d12fe04d$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $9f6c87a1d12fe04d$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $9f6c87a1d12fe04d$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $9f6c87a1d12fe04d$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $9f6c87a1d12fe04d$export$2b57e0052a6d6d4c(placement) {
    return $9f6c87a1d12fe04d$export$8a000a963141ac32($9f6c87a1d12fe04d$export$f28e8f882010718a(placement));
}
function $9f6c87a1d12fe04d$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $9f6c87a1d12fe04d$export$f0989780f32bfcda(placement);
    const alignmentAxis = $9f6c87a1d12fe04d$export$2b57e0052a6d6d4c(placement);
    const length = $9f6c87a1d12fe04d$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $9f6c87a1d12fe04d$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $9f6c87a1d12fe04d$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $9f6c87a1d12fe04d$export$496432a3699e50b1(placement) {
    const oppositePlacement = $9f6c87a1d12fe04d$export$9c5e28bad23365fa(placement);
    return [
        $9f6c87a1d12fe04d$export$2b182c584985588b(placement),
        oppositePlacement,
        $9f6c87a1d12fe04d$export$2b182c584985588b(oppositePlacement)
    ];
}
function $9f6c87a1d12fe04d$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $9f6c87a1d12fe04d$var$lrPlacement = [
    'left',
    'right'
];
const $9f6c87a1d12fe04d$var$rlPlacement = [
    'right',
    'left'
];
const $9f6c87a1d12fe04d$var$tbPlacement = [
    'top',
    'bottom'
];
const $9f6c87a1d12fe04d$var$btPlacement = [
    'bottom',
    'top'
];
function $9f6c87a1d12fe04d$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $9f6c87a1d12fe04d$var$rlPlacement : $9f6c87a1d12fe04d$var$lrPlacement;
            return isStart ? $9f6c87a1d12fe04d$var$lrPlacement : $9f6c87a1d12fe04d$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $9f6c87a1d12fe04d$var$tbPlacement : $9f6c87a1d12fe04d$var$btPlacement;
        default:
            return [];
    }
}
function $9f6c87a1d12fe04d$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $9f6c87a1d12fe04d$export$f0989780f32bfcda(placement);
    let list = $9f6c87a1d12fe04d$var$getSideList($9f6c87a1d12fe04d$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($9f6c87a1d12fe04d$export$2b182c584985588b));
    }
    return list;
}
function $9f6c87a1d12fe04d$export$9c5e28bad23365fa(placement) {
    const side = $9f6c87a1d12fe04d$export$3c915306cb7fc97a(placement);
    return $9f6c87a1d12fe04d$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $9f6c87a1d12fe04d$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $9f6c87a1d12fe04d$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $9f6c87a1d12fe04d$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $9f6c87a1d12fe04d$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});

parcelRegister("6LPnk", function(module, exports) {

$parcel$export(module.exports, "tabbable", function () { return $4edefbe6d4f11bfa$export$17100aea90429aa7; });
$parcel$export(module.exports, "isTabbable", function () { return $4edefbe6d4f11bfa$export$bebd5a1431fec25d; });
/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $4edefbe6d4f11bfa$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $4edefbe6d4f11bfa$var$candidateSelector = /* #__PURE__ */ $4edefbe6d4f11bfa$var$candidateSelectors.join(',');
var $4edefbe6d4f11bfa$var$NoElement = typeof Element === 'undefined';
var $4edefbe6d4f11bfa$var$matches = $4edefbe6d4f11bfa$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $4edefbe6d4f11bfa$var$getRootNode = !$4edefbe6d4f11bfa$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $4edefbe6d4f11bfa$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $4edefbe6d4f11bfa$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $4edefbe6d4f11bfa$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $4edefbe6d4f11bfa$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($4edefbe6d4f11bfa$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($4edefbe6d4f11bfa$var$candidateSelector));
    if (includeContainer && $4edefbe6d4f11bfa$var$matches.call(el, $4edefbe6d4f11bfa$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $4edefbe6d4f11bfa$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($4edefbe6d4f11bfa$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $4edefbe6d4f11bfa$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $4edefbe6d4f11bfa$var$matches.call(element, $4edefbe6d4f11bfa$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$4edefbe6d4f11bfa$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $4edefbe6d4f11bfa$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $4edefbe6d4f11bfa$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $4edefbe6d4f11bfa$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $4edefbe6d4f11bfa$var$isContentEditable(node)) && !$4edefbe6d4f11bfa$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $4edefbe6d4f11bfa$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $4edefbe6d4f11bfa$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$4edefbe6d4f11bfa$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $4edefbe6d4f11bfa$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $4edefbe6d4f11bfa$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $4edefbe6d4f11bfa$var$isHiddenInput = function isHiddenInput(node) {
    return $4edefbe6d4f11bfa$var$isInput(node) && node.type === 'hidden';
};
var $4edefbe6d4f11bfa$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $4edefbe6d4f11bfa$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $4edefbe6d4f11bfa$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $4edefbe6d4f11bfa$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $4edefbe6d4f11bfa$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $4edefbe6d4f11bfa$var$isRadio = function isRadio(node) {
    return $4edefbe6d4f11bfa$var$isInput(node) && node.type === 'radio';
};
var $4edefbe6d4f11bfa$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $4edefbe6d4f11bfa$var$isRadio(node) && !$4edefbe6d4f11bfa$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $4edefbe6d4f11bfa$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $4edefbe6d4f11bfa$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $4edefbe6d4f11bfa$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $4edefbe6d4f11bfa$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $4edefbe6d4f11bfa$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $4edefbe6d4f11bfa$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($4edefbe6d4f11bfa$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $4edefbe6d4f11bfa$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $4edefbe6d4f11bfa$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($4edefbe6d4f11bfa$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $4edefbe6d4f11bfa$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $4edefbe6d4f11bfa$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $4edefbe6d4f11bfa$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $4edefbe6d4f11bfa$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $4edefbe6d4f11bfa$var$isHiddenInput(node) || $4edefbe6d4f11bfa$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $4edefbe6d4f11bfa$var$isDetailsWithSummary(node) || $4edefbe6d4f11bfa$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $4edefbe6d4f11bfa$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($4edefbe6d4f11bfa$var$isNonTabbableRadio(node) || $4edefbe6d4f11bfa$export$a4672efddb4181b8(node) < 0 || !$4edefbe6d4f11bfa$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $4edefbe6d4f11bfa$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $4edefbe6d4f11bfa$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $4edefbe6d4f11bfa$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $4edefbe6d4f11bfa$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($4edefbe6d4f11bfa$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $4edefbe6d4f11bfa$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $4edefbe6d4f11bfa$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $4edefbe6d4f11bfa$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $4edefbe6d4f11bfa$var$isShadowRootTabbable
    });
    else candidates = $4edefbe6d4f11bfa$var$getCandidates(container, options.includeContainer, $4edefbe6d4f11bfa$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $4edefbe6d4f11bfa$var$_sortByOrder(candidates);
};
var $4edefbe6d4f11bfa$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $4edefbe6d4f11bfa$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $4edefbe6d4f11bfa$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $4edefbe6d4f11bfa$var$getCandidates(container, options.includeContainer, $4edefbe6d4f11bfa$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $4edefbe6d4f11bfa$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($4edefbe6d4f11bfa$var$matches.call(node, $4edefbe6d4f11bfa$var$candidateSelector) === false) return false;
    return $4edefbe6d4f11bfa$var$isNodeMatchingSelectorTabbable(options, node);
};
var $4edefbe6d4f11bfa$var$focusableCandidateSelector = /* #__PURE__ */ $4edefbe6d4f11bfa$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $4edefbe6d4f11bfa$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($4edefbe6d4f11bfa$var$matches.call(node, $4edefbe6d4f11bfa$var$focusableCandidateSelector) === false) return false;
    return $4edefbe6d4f11bfa$var$isNodeMatchingSelectorFocusable(options, node);
};

});

parcelRegister("dgS8r", function(module, exports) {

$parcel$export(module.exports, "useFloating", function () { return $9a96c31309cb85d8$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "offset", function () { return $9a96c31309cb85d8$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $9a96c31309cb85d8$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $9a96c31309cb85d8$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "flip", function () { return $9a96c31309cb85d8$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $9a96c31309cb85d8$export$346677f925de839c; });
$parcel$export(module.exports, "autoPlacement", function () { return $9a96c31309cb85d8$export$91fb6ecbd551914; });
$parcel$export(module.exports, "hide", function () { return $9a96c31309cb85d8$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $9a96c31309cb85d8$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "arrow", function () { return $9a96c31309cb85d8$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "computePosition", function () { return (parcelRequire("ia7Xl")).computePosition; });

var $ia7Xl = parcelRequire("ia7Xl");
var $kQHwI = parcelRequire("kQHwI");

var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");
var $9a96c31309cb85d8$var$isClient = typeof document !== 'undefined';
var $9a96c31309cb85d8$var$noop = function noop() {};
var $9a96c31309cb85d8$var$index = $9a96c31309cb85d8$var$isClient ? (0, $70fFQ.useLayoutEffect) : $9a96c31309cb85d8$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $9a96c31309cb85d8$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$9a96c31309cb85d8$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$9a96c31309cb85d8$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $9a96c31309cb85d8$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $9a96c31309cb85d8$var$roundByDPR(element, value) {
    const dpr = $9a96c31309cb85d8$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $9a96c31309cb85d8$var$useLatestRef(value) {
    const ref = $70fFQ.useRef(value);
    $9a96c31309cb85d8$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $9a96c31309cb85d8$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $70fFQ.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $70fFQ.useState(middleware);
    if (!$9a96c31309cb85d8$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $70fFQ.useState(null);
    const [_floating, _setFloating] = $70fFQ.useState(null);
    const setReference = $70fFQ.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $70fFQ.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $70fFQ.useRef(null);
    const floatingRef = $70fFQ.useRef(null);
    const dataRef = $70fFQ.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $9a96c31309cb85d8$var$useLatestRef(whileElementsMounted);
    const platformRef = $9a96c31309cb85d8$var$useLatestRef(platform);
    const openRef = $9a96c31309cb85d8$var$useLatestRef(open);
    const update = $70fFQ.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $ia7Xl.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$9a96c31309cb85d8$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $3glZ1.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $9a96c31309cb85d8$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $70fFQ.useRef(false);
    $9a96c31309cb85d8$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $9a96c31309cb85d8$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $70fFQ.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $70fFQ.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $70fFQ.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $9a96c31309cb85d8$var$roundByDPR(elements.floating, data.x);
        const y = $9a96c31309cb85d8$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$9a96c31309cb85d8$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $70fFQ.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9a96c31309cb85d8$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $ia7Xl.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $ia7Xl.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9a96c31309cb85d8$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $ia7Xl.offset)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9a96c31309cb85d8$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $ia7Xl.shift)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9a96c31309cb85d8$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $ia7Xl.limitShift)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9a96c31309cb85d8$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $ia7Xl.flip)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9a96c31309cb85d8$export$346677f925de839c = (options, deps)=>{
    const result = (0, $ia7Xl.size)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9a96c31309cb85d8$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $ia7Xl.autoPlacement)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9a96c31309cb85d8$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $ia7Xl.hide)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9a96c31309cb85d8$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $ia7Xl.inline)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9a96c31309cb85d8$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $9a96c31309cb85d8$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};

});
parcelRegister("ia7Xl", function(module, exports) {

$parcel$export(module.exports, "platform", function () { return $d38f55185cb61f30$export$722a64dea1b767dc; });
$parcel$export(module.exports, "autoUpdate", function () { return $d38f55185cb61f30$export$deee3a793edee05f; });
$parcel$export(module.exports, "detectOverflow", function () { return $d38f55185cb61f30$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "offset", function () { return $d38f55185cb61f30$export$cc800923e997bb8; });
$parcel$export(module.exports, "autoPlacement", function () { return $d38f55185cb61f30$export$91fb6ecbd551914; });
$parcel$export(module.exports, "shift", function () { return $d38f55185cb61f30$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $d38f55185cb61f30$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $d38f55185cb61f30$export$346677f925de839c; });
$parcel$export(module.exports, "hide", function () { return $d38f55185cb61f30$export$fe8985bb6374093c; });
$parcel$export(module.exports, "arrow", function () { return $d38f55185cb61f30$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "inline", function () { return $d38f55185cb61f30$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "limitShift", function () { return $d38f55185cb61f30$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "computePosition", function () { return $d38f55185cb61f30$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return (parcelRequire("kQHwI")).getOverflowAncestors; });

var $frOgp = parcelRequire("frOgp");
var $dGBOw = parcelRequire("dGBOw");

var $dGBOw = parcelRequire("dGBOw");

var $kQHwI = parcelRequire("kQHwI");
function $d38f55185cb61f30$var$getCssDimensions(element) {
    const css = (0, $kQHwI.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $kQHwI.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $dGBOw.round)(width) !== offsetWidth || (0, $dGBOw.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $d38f55185cb61f30$var$unwrapElement(element) {
    return !(0, $kQHwI.isElement)(element) ? element.contextElement : element;
}
function $d38f55185cb61f30$var$getScale(element) {
    const domElement = $d38f55185cb61f30$var$unwrapElement(element);
    if (!(0, $kQHwI.isHTMLElement)(domElement)) return (0, $dGBOw.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $d38f55185cb61f30$var$getCssDimensions(domElement);
    let x = ($ ? (0, $dGBOw.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $dGBOw.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $d38f55185cb61f30$var$noOffsets = /*#__PURE__*/ (0, $dGBOw.createCoords)(0);
function $d38f55185cb61f30$var$getVisualOffsets(element) {
    const win = (0, $kQHwI.getWindow)(element);
    if (!(0, $kQHwI.isWebKit)() || !win.visualViewport) return $d38f55185cb61f30$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $d38f55185cb61f30$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $kQHwI.getWindow)(element)) return false;
    return isFixed;
}
function $d38f55185cb61f30$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $d38f55185cb61f30$var$unwrapElement(element);
    let scale = (0, $dGBOw.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $kQHwI.isElement)(offsetParent)) scale = $d38f55185cb61f30$var$getScale(offsetParent);
        } else scale = $d38f55185cb61f30$var$getScale(element);
    }
    const visualOffsets = $d38f55185cb61f30$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $d38f55185cb61f30$var$getVisualOffsets(domElement) : (0, $dGBOw.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $kQHwI.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $kQHwI.isElement)(offsetParent) ? (0, $kQHwI.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $kQHwI.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $d38f55185cb61f30$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $kQHwI.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $kQHwI.getWindow)(currentIFrame);
            currentIFrame = (0, $kQHwI.getFrameElement)(currentWin);
        }
    }
    return (0, $dGBOw.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $d38f55185cb61f30$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $kQHwI.getNodeScroll)(element).scrollLeft;
    if (!rect) return $d38f55185cb61f30$var$getBoundingClientRect((0, $kQHwI.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $d38f55185cb61f30$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $d38f55185cb61f30$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $d38f55185cb61f30$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $kQHwI.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $kQHwI.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $dGBOw.createCoords)(1);
    const offsets = (0, $dGBOw.createCoords)(0);
    const isOffsetParentAnElement = (0, $kQHwI.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $kQHwI.getNodeName)(offsetParent) !== 'body' || (0, $kQHwI.isOverflowElement)(documentElement)) scroll = (0, $kQHwI.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $d38f55185cb61f30$var$getBoundingClientRect(offsetParent);
            scale = $d38f55185cb61f30$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $d38f55185cb61f30$var$getHTMLOffset(documentElement, scroll) : (0, $dGBOw.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $d38f55185cb61f30$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $d38f55185cb61f30$var$getDocumentRect(element) {
    const html = (0, $kQHwI.getDocumentElement)(element);
    const scroll = (0, $kQHwI.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $dGBOw.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $dGBOw.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $d38f55185cb61f30$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $kQHwI.getComputedStyle)(body).direction === 'rtl') x += (0, $dGBOw.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $d38f55185cb61f30$var$SCROLLBAR_MAX = 25;
function $d38f55185cb61f30$var$getViewportRect(element, strategy) {
    const win = (0, $kQHwI.getWindow)(element);
    const html = (0, $kQHwI.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $kQHwI.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $d38f55185cb61f30$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $d38f55185cb61f30$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $d38f55185cb61f30$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $d38f55185cb61f30$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $d38f55185cb61f30$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $kQHwI.isHTMLElement)(element) ? $d38f55185cb61f30$var$getScale(element) : (0, $dGBOw.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $d38f55185cb61f30$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $d38f55185cb61f30$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $d38f55185cb61f30$var$getDocumentRect((0, $kQHwI.getDocumentElement)(element));
    else if ((0, $kQHwI.isElement)(clippingAncestor)) rect = $d38f55185cb61f30$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $d38f55185cb61f30$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $dGBOw.rectToClientRect)(rect);
}
function $d38f55185cb61f30$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $kQHwI.getParentNode)(element);
    if (parentNode === stopNode || !(0, $kQHwI.isElement)(parentNode) || (0, $kQHwI.isLastTraversableNode)(parentNode)) return false;
    return (0, $kQHwI.getComputedStyle)(parentNode).position === 'fixed' || $d38f55185cb61f30$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $d38f55185cb61f30$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $kQHwI.getOverflowAncestors)(element, [], false).filter((el)=>(0, $kQHwI.isElement)(el) && (0, $kQHwI.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $kQHwI.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $kQHwI.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $kQHwI.isElement)(currentNode) && !(0, $kQHwI.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $kQHwI.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $kQHwI.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $kQHwI.isOverflowElement)(currentNode) && !currentNodeIsContaining && $d38f55185cb61f30$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $kQHwI.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $d38f55185cb61f30$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $kQHwI.isTopLayer)(element) ? [] : $d38f55185cb61f30$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $d38f55185cb61f30$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $d38f55185cb61f30$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $dGBOw.max)(rect.top, top);
        right = (0, $dGBOw.min)(rect.right, right);
        bottom = (0, $dGBOw.min)(rect.bottom, bottom);
        left = (0, $dGBOw.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $d38f55185cb61f30$var$getDimensions(element) {
    const { width: width, height: height } = $d38f55185cb61f30$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $d38f55185cb61f30$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $kQHwI.isHTMLElement)(offsetParent);
    const documentElement = (0, $kQHwI.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $d38f55185cb61f30$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $dGBOw.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $d38f55185cb61f30$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $kQHwI.getNodeName)(offsetParent) !== 'body' || (0, $kQHwI.isOverflowElement)(documentElement)) scroll = (0, $kQHwI.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $d38f55185cb61f30$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $d38f55185cb61f30$var$getHTMLOffset(documentElement, scroll) : (0, $dGBOw.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $d38f55185cb61f30$var$isStaticPositioned(element) {
    return (0, $kQHwI.getComputedStyle)(element).position === 'static';
}
function $d38f55185cb61f30$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $kQHwI.isHTMLElement)(element) || (0, $kQHwI.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $kQHwI.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $d38f55185cb61f30$var$getOffsetParent(element, polyfill) {
    const win = (0, $kQHwI.getWindow)(element);
    if ((0, $kQHwI.isTopLayer)(element)) return win;
    if (!(0, $kQHwI.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $kQHwI.getParentNode)(element);
        while(svgOffsetParent && !(0, $kQHwI.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $kQHwI.isElement)(svgOffsetParent) && !$d38f55185cb61f30$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $kQHwI.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $d38f55185cb61f30$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $kQHwI.isTableElement)(offsetParent) && $d38f55185cb61f30$var$isStaticPositioned(offsetParent))offsetParent = $d38f55185cb61f30$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $kQHwI.isLastTraversableNode)(offsetParent) && $d38f55185cb61f30$var$isStaticPositioned(offsetParent) && !(0, $kQHwI.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $kQHwI.getContainingBlock)(element) || win;
}
const $d38f55185cb61f30$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $d38f55185cb61f30$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $d38f55185cb61f30$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $d38f55185cb61f30$var$isRTL(element) {
    return (0, $kQHwI.getComputedStyle)(element).direction === 'rtl';
}
const $d38f55185cb61f30$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $d38f55185cb61f30$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $kQHwI.getDocumentElement,
    getClippingRect: $d38f55185cb61f30$var$getClippingRect,
    getOffsetParent: $d38f55185cb61f30$var$getOffsetParent,
    getElementRects: $d38f55185cb61f30$var$getElementRects,
    getClientRects: $d38f55185cb61f30$var$getClientRects,
    getDimensions: $d38f55185cb61f30$var$getDimensions,
    getScale: $d38f55185cb61f30$var$getScale,
    isElement: $kQHwI.isElement,
    isRTL: $d38f55185cb61f30$var$isRTL
};
function $d38f55185cb61f30$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $d38f55185cb61f30$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $kQHwI.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $dGBOw.floor)(top);
        const insetRight = (0, $dGBOw.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $dGBOw.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $dGBOw.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $dGBOw.max)(0, (0, $dGBOw.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$d38f55185cb61f30$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $d38f55185cb61f30$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $d38f55185cb61f30$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $kQHwI.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $kQHwI.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $d38f55185cb61f30$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $d38f55185cb61f30$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $d38f55185cb61f30$var$getBoundingClientRect(reference);
        if (prevRefRect && !$d38f55185cb61f30$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $d38f55185cb61f30$export$37b6bde19b108ecc = (0, $frOgp.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $d38f55185cb61f30$export$cc800923e997bb8 = (0, $frOgp.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $d38f55185cb61f30$export$91fb6ecbd551914 = (0, $frOgp.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $d38f55185cb61f30$export$fba63a578e423eb = (0, $frOgp.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $d38f55185cb61f30$export$8a83211c878a3f1f = (0, $frOgp.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $d38f55185cb61f30$export$346677f925de839c = (0, $frOgp.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $d38f55185cb61f30$export$fe8985bb6374093c = (0, $frOgp.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $d38f55185cb61f30$export$f2120bbfa5450bd2 = (0, $frOgp.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $d38f55185cb61f30$export$18c8ad048e32c7d5 = (0, $frOgp.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $d38f55185cb61f30$export$7bf07e38f3dc4b69 = (0, $frOgp.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $d38f55185cb61f30$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $d38f55185cb61f30$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $frOgp.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("frOgp", function(module, exports) {

$parcel$export(module.exports, "detectOverflow", function () { return $b3f05df9267e5d02$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "computePosition", function () { return $b3f05df9267e5d02$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "arrow", function () { return $b3f05df9267e5d02$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $b3f05df9267e5d02$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $b3f05df9267e5d02$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $b3f05df9267e5d02$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $b3f05df9267e5d02$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $b3f05df9267e5d02$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $b3f05df9267e5d02$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $b3f05df9267e5d02$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $b3f05df9267e5d02$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("dGBOw")).rectToClientRect; });

var $dGBOw = parcelRequire("dGBOw");
function $b3f05df9267e5d02$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $dGBOw.getSideAxis)(placement);
    const alignmentAxis = (0, $dGBOw.getAlignmentAxis)(placement);
    const alignLength = (0, $dGBOw.getAxisLength)(alignmentAxis);
    const side = (0, $dGBOw.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $dGBOw.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $b3f05df9267e5d02$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $dGBOw.evaluate)(options, state);
    const paddingObject = (0, $dGBOw.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $dGBOw.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $dGBOw.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $b3f05df9267e5d02$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $b3f05df9267e5d02$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $b3f05df9267e5d02$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $b3f05df9267e5d02$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $b3f05df9267e5d02$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $b3f05df9267e5d02$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b3f05df9267e5d02$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $dGBOw.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $dGBOw.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $dGBOw.getAlignmentAxis)(placement);
            const length = (0, $dGBOw.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $dGBOw.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $dGBOw.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $dGBOw.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $dGBOw.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $b3f05df9267e5d02$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $dGBOw.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $dGBOw.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $dGBOw.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $dGBOw.getAlignment)(placement) === alignment || (autoAlignment ? (0, $dGBOw.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b3f05df9267e5d02$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $dGBOw.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $dGBOw.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $dGBOw.placements) ? $b3f05df9267e5d02$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $dGBOw.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $dGBOw.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $dGBOw.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $dGBOw.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b3f05df9267e5d02$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $dGBOw.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $dGBOw.getSide)(placement);
            const initialSideAxis = (0, $dGBOw.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $dGBOw.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $dGBOw.getOppositePlacement)(initialPlacement)
            ] : (0, $dGBOw.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $dGBOw.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $dGBOw.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $dGBOw.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $dGBOw.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $dGBOw.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $b3f05df9267e5d02$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $b3f05df9267e5d02$var$isAnySideFullyClipped(overflow) {
    return (0, $dGBOw.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b3f05df9267e5d02$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $dGBOw.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $b3f05df9267e5d02$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $b3f05df9267e5d02$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $b3f05df9267e5d02$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $b3f05df9267e5d02$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $b3f05df9267e5d02$var$getBoundingRect(rects) {
    const minX = (0, $dGBOw.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $dGBOw.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $dGBOw.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $dGBOw.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $b3f05df9267e5d02$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $dGBOw.rectToClientRect)($b3f05df9267e5d02$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b3f05df9267e5d02$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $dGBOw.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $b3f05df9267e5d02$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $dGBOw.rectToClientRect)($b3f05df9267e5d02$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $dGBOw.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $dGBOw.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $dGBOw.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $dGBOw.getSide)(placement) === 'left';
                    const maxRight = (0, $dGBOw.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $dGBOw.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $b3f05df9267e5d02$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $b3f05df9267e5d02$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $dGBOw.getSide)(placement);
    const alignment = (0, $dGBOw.getAlignment)(placement);
    const isVertical = (0, $dGBOw.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $b3f05df9267e5d02$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $dGBOw.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b3f05df9267e5d02$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $b3f05df9267e5d02$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b3f05df9267e5d02$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $dGBOw.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $dGBOw.getSideAxis)((0, $dGBOw.getSide)(placement));
            const mainAxis = (0, $dGBOw.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $dGBOw.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $dGBOw.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b3f05df9267e5d02$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $dGBOw.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $dGBOw.getSideAxis)(placement);
            const mainAxis = (0, $dGBOw.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $dGBOw.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $b3f05df9267e5d02$var$originSides.has((0, $dGBOw.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b3f05df9267e5d02$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $dGBOw.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $dGBOw.getSide)(placement);
            const alignment = (0, $dGBOw.getAlignment)(placement);
            const isYAxis = (0, $dGBOw.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $dGBOw.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $dGBOw.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $dGBOw.max)(overflow.left, 0);
                const xMax = (0, $dGBOw.max)(overflow.right, 0);
                const yMin = (0, $dGBOw.max)(overflow.top, 0);
                const yMax = (0, $dGBOw.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $dGBOw.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $dGBOw.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});




parcelRegister("jYkpI", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $e8a374a80c99de8e$var$DATE_MAX_YEAR, $e8a374a80c99de8e$var$DATE_MIN_YEAR, $e8a374a80c99de8e$var$DATE_SPLITS, $e8a374a80c99de8e$var$GRAPHS, $e8a374a80c99de8e$var$L33T_TABLE, $e8a374a80c99de8e$var$RANKED_DICTIONARIES, $e8a374a80c99de8e$var$REGEXEN, $e8a374a80c99de8e$var$adjacency_graphs, $e8a374a80c99de8e$var$build_ranked_dict, $e8a374a80c99de8e$var$frequency_lists, $e8a374a80c99de8e$var$lst, $e8a374a80c99de8e$var$matching, $e8a374a80c99de8e$var$name, $e8a374a80c99de8e$var$scoring;

$e8a374a80c99de8e$var$frequency_lists = (parcelRequire("5il0r"));

$e8a374a80c99de8e$var$adjacency_graphs = (parcelRequire("271js"));

$e8a374a80c99de8e$var$scoring = (parcelRequire("fWMoF"));
$e8a374a80c99de8e$var$build_ranked_dict = function(ordered_list) {
    var i, len1, o, result, word;
    result = {};
    i = 1;
    for(o = 0, len1 = ordered_list.length; o < len1; o++){
        word = ordered_list[o];
        result[word] = i;
        i += 1;
    }
    return result;
};
$e8a374a80c99de8e$var$RANKED_DICTIONARIES = {};
for($e8a374a80c99de8e$var$name in $e8a374a80c99de8e$var$frequency_lists){
    $e8a374a80c99de8e$var$lst = $e8a374a80c99de8e$var$frequency_lists[$e8a374a80c99de8e$var$name];
    $e8a374a80c99de8e$var$RANKED_DICTIONARIES[$e8a374a80c99de8e$var$name] = $e8a374a80c99de8e$var$build_ranked_dict($e8a374a80c99de8e$var$lst);
}
$e8a374a80c99de8e$var$GRAPHS = {
    qwerty: $e8a374a80c99de8e$var$adjacency_graphs.qwerty,
    dvorak: $e8a374a80c99de8e$var$adjacency_graphs.dvorak,
    keypad: $e8a374a80c99de8e$var$adjacency_graphs.keypad,
    mac_keypad: $e8a374a80c99de8e$var$adjacency_graphs.mac_keypad
};
$e8a374a80c99de8e$var$L33T_TABLE = {
    a: [
        '4',
        '@'
    ],
    b: [
        '8'
    ],
    c: [
        '(',
        '{',
        '[',
        '<'
    ],
    e: [
        '3'
    ],
    g: [
        '6',
        '9'
    ],
    i: [
        '1',
        '!',
        '|'
    ],
    l: [
        '1',
        '|',
        '7'
    ],
    o: [
        '0'
    ],
    s: [
        '$',
        '5'
    ],
    t: [
        '+',
        '7'
    ],
    x: [
        '%'
    ],
    z: [
        '2'
    ]
};
$e8a374a80c99de8e$var$REGEXEN = {
    recent_year: /19\d\d|200\d|201\d/g
};
$e8a374a80c99de8e$var$DATE_MAX_YEAR = 2050;
$e8a374a80c99de8e$var$DATE_MIN_YEAR = 1000;
$e8a374a80c99de8e$var$DATE_SPLITS = {
    4: [
        [
            1,
            2
        ],
        [
            2,
            3
        ]
    ],
    5: [
        [
            1,
            3
        ],
        [
            2,
            3
        ]
    ],
    6: [
        [
            1,
            2
        ],
        [
            2,
            4
        ],
        [
            4,
            5
        ]
    ],
    7: [
        [
            1,
            3
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            4,
            6
        ]
    ],
    8: [
        [
            2,
            4
        ],
        [
            4,
            6
        ]
    ]
};
$e8a374a80c99de8e$var$matching = {
    empty: function(obj) {
        var k;
        return function() {
            var results;
            results = [];
            for(k in obj)results.push(k);
            return results;
        }().length === 0;
    },
    extend: function(lst, lst2) {
        return lst.push.apply(lst, lst2);
    },
    translate: function(string, chr_map) {
        var chr;
        return (function() {
            var len1, o, ref, results;
            ref = string.split('');
            results = [];
            for(o = 0, len1 = ref.length; o < len1; o++){
                chr = ref[o];
                results.push(chr_map[chr] || chr);
            }
            return results;
        })().join('');
    },
    mod: function(n, m) {
        return (n % m + m) % m;
    },
    sorted: function(matches) {
        return matches.sort(function(m1, m2) {
            return m1.i - m2.i || m1.j - m2.j;
        });
    },
    omnimatch: function(password) {
        var len1, matcher, matchers, matches, o;
        matches = [];
        matchers = [
            this.dictionary_match,
            this.reverse_dictionary_match,
            this.l33t_match,
            this.spatial_match,
            this.repeat_match,
            this.sequence_match,
            this.regex_match,
            this.date_match
        ];
        for(o = 0, len1 = matchers.length; o < len1; o++){
            matcher = matchers[o];
            this.extend(matches, matcher.call(this, password));
        }
        return this.sorted(matches);
    },
    dictionary_match: function(password, _ranked_dictionaries) {
        var dictionary_name, i, j, len, matches, o, p, password_lower, rank, ranked_dict, ref, ref1, ref2, word;
        if (_ranked_dictionaries == null) _ranked_dictionaries = $e8a374a80c99de8e$var$RANKED_DICTIONARIES;
        matches = [];
        len = password.length;
        password_lower = password.toLowerCase();
        for(dictionary_name in _ranked_dictionaries){
            ranked_dict = _ranked_dictionaries[dictionary_name];
            for(i = o = 0, ref = len; 0 <= ref ? o < ref : o > ref; i = 0 <= ref ? ++o : --o){
                for(j = p = ref1 = i, ref2 = len; ref1 <= ref2 ? p < ref2 : p > ref2; j = ref1 <= ref2 ? ++p : --p)if (password_lower.slice(i, +j + 1 || 9e9) in ranked_dict) {
                    word = password_lower.slice(i, +j + 1 || 9e9);
                    rank = ranked_dict[word];
                    matches.push({
                        pattern: 'dictionary',
                        i: i,
                        j: j,
                        token: password.slice(i, +j + 1 || 9e9),
                        matched_word: word,
                        rank: rank,
                        dictionary_name: dictionary_name,
                        reversed: false,
                        l33t: false
                    });
                }
            }
        }
        return this.sorted(matches);
    },
    reverse_dictionary_match: function(password, _ranked_dictionaries) {
        var len1, match, matches, o, ref, reversed_password;
        if (_ranked_dictionaries == null) _ranked_dictionaries = $e8a374a80c99de8e$var$RANKED_DICTIONARIES;
        reversed_password = password.split('').reverse().join('');
        matches = this.dictionary_match(reversed_password, _ranked_dictionaries);
        for(o = 0, len1 = matches.length; o < len1; o++){
            match = matches[o];
            match.token = match.token.split('').reverse().join('');
            match.reversed = true;
            ref = [
                password.length - 1 - match.j,
                password.length - 1 - match.i
            ], match.i = ref[0], match.j = ref[1];
        }
        return this.sorted(matches);
    },
    set_user_input_dictionary: function(ordered_list) {
        return $e8a374a80c99de8e$var$RANKED_DICTIONARIES['user_inputs'] = $e8a374a80c99de8e$var$build_ranked_dict(ordered_list.slice());
    },
    relevant_l33t_subtable: function(password, table) {
        var chr, len1, letter, o, password_chars, ref, relevant_subs, sub, subs, subtable;
        password_chars = {};
        ref = password.split('');
        for(o = 0, len1 = ref.length; o < len1; o++){
            chr = ref[o];
            password_chars[chr] = true;
        }
        subtable = {};
        for(letter in table){
            subs = table[letter];
            relevant_subs = function() {
                var len2, p, results;
                results = [];
                for(p = 0, len2 = subs.length; p < len2; p++){
                    sub = subs[p];
                    if (sub in password_chars) results.push(sub);
                }
                return results;
            }();
            if (relevant_subs.length > 0) subtable[letter] = relevant_subs;
        }
        return subtable;
    },
    enumerate_l33t_subs: function(table) {
        var chr, dedup, helper, k, keys, l33t_chr, len1, len2, o, p, ref, sub, sub_dict, sub_dicts, subs;
        keys = function() {
            var results;
            results = [];
            for(k in table)results.push(k);
            return results;
        }();
        subs = [
            []
        ];
        dedup = function(subs) {
            var assoc, deduped, label, len1, members, o, sub, v;
            deduped = [];
            members = {};
            for(o = 0, len1 = subs.length; o < len1; o++){
                sub = subs[o];
                assoc = function() {
                    var len2, p, results;
                    results = [];
                    for(v = p = 0, len2 = sub.length; p < len2; v = ++p){
                        k = sub[v];
                        results.push([
                            k,
                            v
                        ]);
                    }
                    return results;
                }();
                assoc.sort();
                label = (function() {
                    var len2, p, results;
                    results = [];
                    for(v = p = 0, len2 = assoc.length; p < len2; v = ++p){
                        k = assoc[v];
                        results.push(k + ',' + v);
                    }
                    return results;
                })().join('-');
                if (!(label in members)) {
                    members[label] = true;
                    deduped.push(sub);
                }
            }
            return deduped;
        };
        helper = function(keys) {
            var dup_l33t_index, first_key, i, l33t_chr, len1, len2, next_subs, o, p, q, ref, ref1, rest_keys, sub, sub_alternative, sub_extension;
            if (!keys.length) return;
            first_key = keys[0];
            rest_keys = keys.slice(1);
            next_subs = [];
            ref = table[first_key];
            for(o = 0, len1 = ref.length; o < len1; o++){
                l33t_chr = ref[o];
                for(p = 0, len2 = subs.length; p < len2; p++){
                    sub = subs[p];
                    dup_l33t_index = -1;
                    for(i = q = 0, ref1 = sub.length; 0 <= ref1 ? q < ref1 : q > ref1; i = 0 <= ref1 ? ++q : --q)if (sub[i][0] === l33t_chr) {
                        dup_l33t_index = i;
                        break;
                    }
                    if (dup_l33t_index === -1) {
                        sub_extension = sub.concat([
                            [
                                l33t_chr,
                                first_key
                            ]
                        ]);
                        next_subs.push(sub_extension);
                    } else {
                        sub_alternative = sub.slice(0);
                        sub_alternative.splice(dup_l33t_index, 1);
                        sub_alternative.push([
                            l33t_chr,
                            first_key
                        ]);
                        next_subs.push(sub);
                        next_subs.push(sub_alternative);
                    }
                }
            }
            subs = dedup(next_subs);
            return helper(rest_keys);
        };
        helper(keys);
        sub_dicts = [];
        for(o = 0, len1 = subs.length; o < len1; o++){
            sub = subs[o];
            sub_dict = {};
            for(p = 0, len2 = sub.length; p < len2; p++){
                ref = sub[p], l33t_chr = ref[0], chr = ref[1];
                sub_dict[l33t_chr] = chr;
            }
            sub_dicts.push(sub_dict);
        }
        return sub_dicts;
    },
    l33t_match: function(password, _ranked_dictionaries, _l33t_table) {
        var chr, k, len1, len2, match, match_sub, matches, o, p, ref, ref1, sub, subbed_chr, subbed_password, token, v;
        if (_ranked_dictionaries == null) _ranked_dictionaries = $e8a374a80c99de8e$var$RANKED_DICTIONARIES;
        if (_l33t_table == null) _l33t_table = $e8a374a80c99de8e$var$L33T_TABLE;
        matches = [];
        ref = this.enumerate_l33t_subs(this.relevant_l33t_subtable(password, _l33t_table));
        for(o = 0, len1 = ref.length; o < len1; o++){
            sub = ref[o];
            if (this.empty(sub)) break;
            subbed_password = this.translate(password, sub);
            ref1 = this.dictionary_match(subbed_password, _ranked_dictionaries);
            for(p = 0, len2 = ref1.length; p < len2; p++){
                match = ref1[p];
                token = password.slice(match.i, +match.j + 1 || 9e9);
                if (token.toLowerCase() === match.matched_word) continue;
                match_sub = {};
                for(subbed_chr in sub){
                    chr = sub[subbed_chr];
                    if (token.indexOf(subbed_chr) !== -1) match_sub[subbed_chr] = chr;
                }
                match.l33t = true;
                match.token = token;
                match.sub = match_sub;
                match.sub_display = (function() {
                    var results;
                    results = [];
                    for(k in match_sub){
                        v = match_sub[k];
                        results.push(k + " -> " + v);
                    }
                    return results;
                })().join(', ');
                matches.push(match);
            }
        }
        return this.sorted(matches.filter(function(match) {
            return match.token.length > 1;
        }));
    },
    spatial_match: function(password, _graphs) {
        var graph, graph_name, matches;
        if (_graphs == null) _graphs = $e8a374a80c99de8e$var$GRAPHS;
        matches = [];
        for(graph_name in _graphs){
            graph = _graphs[graph_name];
            this.extend(matches, this.spatial_match_helper(password, graph, graph_name));
        }
        return this.sorted(matches);
    },
    SHIFTED_RX: /[~!@#$%^&*()_+QWERTYUIOP{}|ASDFGHJKL:"ZXCVBNM<>?]/,
    spatial_match_helper: function(password, graph, graph_name) {
        var adj, adjacents, cur_char, cur_direction, found, found_direction, i, j, last_direction, len1, matches, o, prev_char, shifted_count, turns;
        matches = [];
        i = 0;
        while(i < password.length - 1){
            j = i + 1;
            last_direction = null;
            turns = 0;
            if ((graph_name === 'qwerty' || graph_name === 'dvorak') && this.SHIFTED_RX.exec(password.charAt(i))) shifted_count = 1;
            else shifted_count = 0;
            while(true){
                prev_char = password.charAt(j - 1);
                found = false;
                found_direction = -1;
                cur_direction = -1;
                adjacents = graph[prev_char] || [];
                if (j < password.length) {
                    cur_char = password.charAt(j);
                    for(o = 0, len1 = adjacents.length; o < len1; o++){
                        adj = adjacents[o];
                        cur_direction += 1;
                        if (adj && adj.indexOf(cur_char) !== -1) {
                            found = true;
                            found_direction = cur_direction;
                            if (adj.indexOf(cur_char) === 1) shifted_count += 1;
                            if (last_direction !== found_direction) {
                                turns += 1;
                                last_direction = found_direction;
                            }
                            break;
                        }
                    }
                }
                if (found) j += 1;
                else {
                    if (j - i > 2) matches.push({
                        pattern: 'spatial',
                        i: i,
                        j: j - 1,
                        token: password.slice(i, j),
                        graph: graph_name,
                        turns: turns,
                        shifted_count: shifted_count
                    });
                    i = j;
                    break;
                }
            }
        }
        return matches;
    },
    repeat_match: function(password) {
        var base_analysis, base_guesses, base_matches, base_token, greedy, greedy_match, i, j, lastIndex, lazy, lazy_anchored, lazy_match, match, matches, ref;
        matches = [];
        greedy = /(.+)\1+/g;
        lazy = /(.+?)\1+/g;
        lazy_anchored = /^(.+?)\1+$/;
        lastIndex = 0;
        while(lastIndex < password.length){
            greedy.lastIndex = lazy.lastIndex = lastIndex;
            greedy_match = greedy.exec(password);
            lazy_match = lazy.exec(password);
            if (greedy_match == null) break;
            if (greedy_match[0].length > lazy_match[0].length) {
                match = greedy_match;
                base_token = lazy_anchored.exec(match[0])[1];
            } else {
                match = lazy_match;
                base_token = match[1];
            }
            ref = [
                match.index,
                match.index + match[0].length - 1
            ], i = ref[0], j = ref[1];
            base_analysis = $e8a374a80c99de8e$var$scoring.most_guessable_match_sequence(base_token, this.omnimatch(base_token));
            base_matches = base_analysis.sequence;
            base_guesses = base_analysis.guesses;
            matches.push({
                pattern: 'repeat',
                i: i,
                j: j,
                token: match[0],
                base_token: base_token,
                base_guesses: base_guesses,
                base_matches: base_matches,
                repeat_count: match[0].length / base_token.length
            });
            lastIndex = j + 1;
        }
        return matches;
    },
    MAX_DELTA: 5,
    sequence_match: function(password) {
        var delta, i, j, k, last_delta, o, ref, result, update;
        if (password.length === 1) return [];
        update = function(_this) {
            return function(i, j, delta) {
                var ref, sequence_name, sequence_space, token;
                if (j - i > 1 || Math.abs(delta) === 1) {
                    if (0 < (ref = Math.abs(delta)) && ref <= _this.MAX_DELTA) {
                        token = password.slice(i, +j + 1 || 9e9);
                        if (/^[a-z]+$/.test(token)) {
                            sequence_name = 'lower';
                            sequence_space = 26;
                        } else if (/^[A-Z]+$/.test(token)) {
                            sequence_name = 'upper';
                            sequence_space = 26;
                        } else if (/^\d+$/.test(token)) {
                            sequence_name = 'digits';
                            sequence_space = 10;
                        } else {
                            sequence_name = 'unicode';
                            sequence_space = 26;
                        }
                        return result.push({
                            pattern: 'sequence',
                            i: i,
                            j: j,
                            token: password.slice(i, +j + 1 || 9e9),
                            sequence_name: sequence_name,
                            sequence_space: sequence_space,
                            ascending: delta > 0
                        });
                    }
                }
            };
        }(this);
        result = [];
        i = 0;
        last_delta = null;
        for(k = o = 1, ref = password.length; 1 <= ref ? o < ref : o > ref; k = 1 <= ref ? ++o : --o){
            delta = password.charCodeAt(k) - password.charCodeAt(k - 1);
            if (last_delta == null) last_delta = delta;
            if (delta === last_delta) continue;
            j = k - 1;
            update(i, j, last_delta);
            i = j;
            last_delta = delta;
        }
        update(i, password.length - 1, last_delta);
        return result;
    },
    regex_match: function(password, _regexen) {
        var matches, regex, rx_match, token;
        if (_regexen == null) _regexen = $e8a374a80c99de8e$var$REGEXEN;
        matches = [];
        for($e8a374a80c99de8e$var$name in _regexen){
            regex = _regexen[$e8a374a80c99de8e$var$name];
            regex.lastIndex = 0;
            while(rx_match = regex.exec(password)){
                token = rx_match[0];
                matches.push({
                    pattern: 'regex',
                    token: token,
                    i: rx_match.index,
                    j: rx_match.index + rx_match[0].length - 1,
                    regex_name: $e8a374a80c99de8e$var$name,
                    regex_match: rx_match
                });
            }
        }
        return this.sorted(matches);
    },
    date_match: function(password) {
        var best_candidate, candidate, candidates, distance, dmy, i, j, k, l, len1, len2, matches, maybe_date_no_separator, maybe_date_with_separator, metric, min_distance, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, rx_match, s, t, token;
        matches = [];
        maybe_date_no_separator = /^\d{4,8}$/;
        maybe_date_with_separator = /^(\d{1,4})([\s\/\\_.-])(\d{1,2})\2(\d{1,4})$/;
        for(i = o = 0, ref = password.length - 4; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o)for(j = p = ref1 = i + 3, ref2 = i + 7; ref1 <= ref2 ? p <= ref2 : p >= ref2; j = ref1 <= ref2 ? ++p : --p){
            if (j >= password.length) break;
            token = password.slice(i, +j + 1 || 9e9);
            if (!maybe_date_no_separator.exec(token)) continue;
            candidates = [];
            ref3 = $e8a374a80c99de8e$var$DATE_SPLITS[token.length];
            for(q = 0, len1 = ref3.length; q < len1; q++){
                ref4 = ref3[q], k = ref4[0], l = ref4[1];
                dmy = this.map_ints_to_dmy([
                    parseInt(token.slice(0, k)),
                    parseInt(token.slice(k, l)),
                    parseInt(token.slice(l))
                ]);
                if (dmy != null) candidates.push(dmy);
            }
            if (!(candidates.length > 0)) continue;
            best_candidate = candidates[0];
            metric = function(candidate) {
                return Math.abs(candidate.year - $e8a374a80c99de8e$var$scoring.REFERENCE_YEAR);
            };
            min_distance = metric(candidates[0]);
            ref5 = candidates.slice(1);
            for(r = 0, len2 = ref5.length; r < len2; r++){
                candidate = ref5[r];
                distance = metric(candidate);
                if (distance < min_distance) ref6 = [
                    candidate,
                    distance
                ], best_candidate = ref6[0], min_distance = ref6[1];
            }
            matches.push({
                pattern: 'date',
                token: token,
                i: i,
                j: j,
                separator: '',
                year: best_candidate.year,
                month: best_candidate.month,
                day: best_candidate.day
            });
        }
        for(i = s = 0, ref7 = password.length - 6; 0 <= ref7 ? s <= ref7 : s >= ref7; i = 0 <= ref7 ? ++s : --s)for(j = t = ref8 = i + 5, ref9 = i + 9; ref8 <= ref9 ? t <= ref9 : t >= ref9; j = ref8 <= ref9 ? ++t : --t){
            if (j >= password.length) break;
            token = password.slice(i, +j + 1 || 9e9);
            rx_match = maybe_date_with_separator.exec(token);
            if (rx_match == null) continue;
            dmy = this.map_ints_to_dmy([
                parseInt(rx_match[1]),
                parseInt(rx_match[3]),
                parseInt(rx_match[4])
            ]);
            if (dmy == null) continue;
            matches.push({
                pattern: 'date',
                token: token,
                i: i,
                j: j,
                separator: rx_match[2],
                year: dmy.year,
                month: dmy.month,
                day: dmy.day
            });
        }
        return this.sorted(matches.filter(function(match) {
            var is_submatch, len3, other_match, u;
            is_submatch = false;
            for(u = 0, len3 = matches.length; u < len3; u++){
                other_match = matches[u];
                if (match === other_match) continue;
                if (other_match.i <= match.i && other_match.j >= match.j) {
                    is_submatch = true;
                    break;
                }
            }
            return !is_submatch;
        }));
    },
    map_ints_to_dmy: function(ints) {
        var dm, int, len1, len2, len3, o, over_12, over_31, p, possible_year_splits, q, ref, ref1, rest, under_1, y;
        if (ints[1] > 31 || ints[1] <= 0) return;
        over_12 = 0;
        over_31 = 0;
        under_1 = 0;
        for(o = 0, len1 = ints.length; o < len1; o++){
            int = ints[o];
            if (99 < int && int < $e8a374a80c99de8e$var$DATE_MIN_YEAR || int > $e8a374a80c99de8e$var$DATE_MAX_YEAR) return;
            if (int > 31) over_31 += 1;
            if (int > 12) over_12 += 1;
            if (int <= 0) under_1 += 1;
        }
        if (over_31 >= 2 || over_12 === 3 || under_1 >= 2) return;
        possible_year_splits = [
            [
                ints[2],
                ints.slice(0, 2)
            ],
            [
                ints[0],
                ints.slice(1, 3)
            ]
        ];
        for(p = 0, len2 = possible_year_splits.length; p < len2; p++){
            ref = possible_year_splits[p], y = ref[0], rest = ref[1];
            if ($e8a374a80c99de8e$var$DATE_MIN_YEAR <= y && y <= $e8a374a80c99de8e$var$DATE_MAX_YEAR) {
                dm = this.map_ints_to_dm(rest);
                if (dm != null) return {
                    year: y,
                    month: dm.month,
                    day: dm.day
                };
                else return;
            }
        }
        for(q = 0, len3 = possible_year_splits.length; q < len3; q++){
            ref1 = possible_year_splits[q], y = ref1[0], rest = ref1[1];
            dm = this.map_ints_to_dm(rest);
            if (dm != null) {
                y = this.two_to_four_digit_year(y);
                return {
                    year: y,
                    month: dm.month,
                    day: dm.day
                };
            }
        }
    },
    map_ints_to_dm: function(ints) {
        var d, len1, m, o, ref, ref1;
        ref = [
            ints,
            ints.slice().reverse()
        ];
        for(o = 0, len1 = ref.length; o < len1; o++){
            ref1 = ref[o], d = ref1[0], m = ref1[1];
            if (1 <= d && d <= 31 && 1 <= m && m <= 12) return {
                day: d,
                month: m
            };
        }
    },
    two_to_four_digit_year: function(year) {
        if (year > 99) return year;
        else if (year > 50) return year + 1900;
        else return year + 2000;
    }
};
module.exports = $e8a374a80c99de8e$var$matching;

});
parcelRegister("5il0r", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $3daeed971962dd76$var$frequency_lists;
$3daeed971962dd76$var$frequency_lists = {
    passwords: "123456,password,12345678,qwerty,123456789,12345,1234,111111,1234567,dragon,123123,baseball,abc123,football,monkey,letmein,shadow,master,696969,mustang,666666,qwertyuiop,123321,1234567890,pussy,superman,654321,1qaz2wsx,7777777,fuckyou,qazwsx,jordan,123qwe,000000,killer,trustno1,hunter,harley,zxcvbnm,asdfgh,buster,batman,soccer,tigger,charlie,sunshine,iloveyou,fuckme,ranger,hockey,computer,starwars,asshole,pepper,klaster,112233,zxcvbn,freedom,princess,maggie,pass,ginger,11111111,131313,fuck,love,cheese,159753,summer,chelsea,dallas,biteme,matrix,yankees,6969,corvette,austin,access,thunder,merlin,secret,diamond,hello,hammer,fucker,1234qwer,silver,gfhjkm,internet,samantha,golfer,scooter,test,orange,cookie,q1w2e3r4t5,maverick,sparky,phoenix,mickey,bigdog,snoopy,guitar,whatever,chicken,camaro,mercedes,peanut,ferrari,falcon,cowboy,welcome,sexy,samsung,steelers,smokey,dakota,arsenal,boomer,eagles,tigers,marina,nascar,booboo,gateway,yellow,porsche,monster,spider,diablo,hannah,bulldog,junior,london,purple,compaq,lakers,iceman,qwer1234,hardcore,cowboys,money,banana,ncc1701,boston,tennis,q1w2e3r4,coffee,scooby,123654,nikita,yamaha,mother,barney,brandy,chester,fuckoff,oliver,player,forever,rangers,midnight,chicago,bigdaddy,redsox,angel,badboy,fender,jasper,slayer,rabbit,natasha,marine,bigdick,wizard,marlboro,raiders,prince,casper,fishing,flower,jasmine,iwantu,panties,adidas,winter,winner,gandalf,password1,enter,ghbdtn,1q2w3e4r,golden,cocacola,jordan23,winston,madison,angels,panther,blowme,sexsex,bigtits,spanky,bitch,sophie,asdfasdf,horny,thx1138,toyota,tiger,dick,canada,12344321,blowjob,8675309,muffin,liverpoo,apples,qwerty123,passw0rd,abcd1234,pokemon,123abc,slipknot,qazxsw,123456a,scorpion,qwaszx,butter,startrek,rainbow,asdfghjkl,razz,newyork,redskins,gemini,cameron,qazwsxedc,florida,liverpool,turtle,sierra,viking,booger,butthead,doctor,rocket,159357,dolphins,captain,bandit,jaguar,packers,pookie,peaches,789456,asdf,dolphin,helpme,blue,theman,maxwell,qwertyui,shithead,lovers,maddog,giants,nirvana,metallic,hotdog,rosebud,mountain,warrior,stupid,elephant,suckit,success,bond007,jackass,alexis,porn,lucky,scorpio,samson,q1w2e3,azerty,rush2112,driver,freddy,1q2w3e4r5t,sydney,gators,dexter,red123,123456q,12345a,bubba,creative,voodoo,golf,trouble,america,nissan,gunner,garfield,bullshit,asdfghjk,5150,fucking,apollo,1qazxsw2,2112,eminem,legend,airborne,bear,beavis,apple,brooklyn,godzilla,skippy,4815162342,buddy,qwert,kitten,magic,shelby,beaver,phantom,asdasd,xavier,braves,darkness,blink182,copper,platinum,qweqwe,tomcat,01012011,girls,bigboy,102030,animal,police,online,11223344,voyager,lifehack,12qwaszx,fish,sniper,315475,trinity,blazer,heaven,lover,snowball,playboy,loveme,bubbles,hooters,cricket,willow,donkey,topgun,nintendo,saturn,destiny,pakistan,pumpkin,digital,sergey,redwings,explorer,tits,private,runner,therock,guinness,lasvegas,beatles,789456123,fire,cassie,christin,qwerty1,celtic,asdf1234,andrey,broncos,007007,babygirl,eclipse,fluffy,cartman,michigan,carolina,testing,alexande,birdie,pantera,cherry,vampire,mexico,dickhead,buffalo,genius,montana,beer,minecraft,maximus,flyers,lovely,stalker,metallica,doggie,snickers,speedy,bronco,lol123,paradise,yankee,horses,magnum,dreams,147258369,lacrosse,ou812,goober,enigma,qwertyu,scotty,pimpin,bollocks,surfer,cock,poohbear,genesis,star,asd123,qweasdzxc,racing,hello1,hawaii,eagle1,viper,poopoo,einstein,boobies,12345q,bitches,drowssap,simple,badger,alaska,action,jester,drummer,111222,spitfire,forest,maryjane,champion,diesel,svetlana,friday,hotrod,147258,chevy,lucky1,westside,security,google,badass,tester,shorty,thumper,hitman,mozart,zaq12wsx,boobs,reddog,010203,lizard,a123456,123456789a,ruslan,eagle,1232323q,scarface,qwerty12,147852,a12345,buddha,porno,420420,spirit,money1,stargate,qwe123,naruto,mercury,liberty,12345qwert,semperfi,suzuki,popcorn,spooky,marley,scotland,kitty,cherokee,vikings,simpsons,rascal,qweasd,hummer,loveyou,michael1,patches,russia,jupiter,penguin,passion,cumshot,vfhbyf,honda,vladimir,sandman,passport,raider,bastard,123789,infinity,assman,bulldogs,fantasy,sucker,1234554321,horney,domino,budlight,disney,ironman,usuckballz1,softball,brutus,redrum,bigred,mnbvcxz,fktrcfylh,karina,marines,digger,kawasaki,cougar,fireman,oksana,monday,cunt,justice,nigger,super,wildcats,tinker,logitech,dancer,swordfis,avalon,everton,alexandr,motorola,patriots,hentai,madonna,pussy1,ducati,colorado,connor,juventus,galore,smooth,freeuser,warcraft,boogie,titanic,wolverin,elizabet,arizona,valentin,saints,asdfg,accord,test123,password123,christ,yfnfif,stinky,slut,spiderma,naughty,chopper,hello123,ncc1701d,extreme,skyline,poop,zombie,pearljam,123qweasd,froggy,awesome,vision,pirate,fylhtq,dreamer,bullet,predator,empire,123123a,kirill,charlie1,panthers,penis,skipper,nemesis,rasdzv3,peekaboo,rolltide,cardinal,psycho,danger,mookie,happy1,wanker,chevelle,manutd,goblue,9379992,hobbes,vegeta,fyfcnfcbz,852456,picard,159951,windows,loverboy,victory,vfrcbv,bambam,serega,123654789,turkey,tweety,galina,hiphop,rooster,changeme,berlin,taurus,suckme,polina,electric,avatar,134679,maksim,raptor,alpha1,hendrix,newport,bigcock,brazil,spring,a1b2c3,madmax,alpha,britney,sublime,darkside,bigman,wolfpack,classic,hercules,ronaldo,letmein1,1q2w3e,741852963,spiderman,blizzard,123456789q,cheyenne,cjkysirj,tiger1,wombat,bubba1,pandora,zxc123,holiday,wildcat,devils,horse,alabama,147852369,caesar,12312,buddy1,bondage,pussycat,pickle,shaggy,catch22,leather,chronic,a1b2c3d4,admin,qqq111,qaz123,airplane,kodiak,freepass,billybob,sunset,katana,phpbb,chocolat,snowman,angel1,stingray,firebird,wolves,zeppelin,detroit,pontiac,gundam,panzer,vagina,outlaw,redhead,tarheels,greenday,nastya,01011980,hardon,engineer,dragon1,hellfire,serenity,cobra,fireball,lickme,darkstar,1029384756,01011,mustang1,flash,124578,strike,beauty,pavilion,01012000,bobafett,dbrnjhbz,bigmac,bowling,chris1,ytrewq,natali,pyramid,rulez,welcome1,dodgers,apache,swimming,whynot,teens,trooper,fuckit,defender,precious,135790,packard,weasel,popeye,lucifer,cancer,icecream,142536,raven,swordfish,presario,viktor,rockstar,blonde,james1,wutang,spike,pimp,atlanta,airforce,thailand,casino,lennon,mouse,741852,hacker,bluebird,hawkeye,456123,theone,catfish,sailor,goldfish,nfnmzyf,tattoo,pervert,barbie,maxima,nipples,machine,trucks,wrangler,rocks,tornado,lights,cadillac,bubble,pegasus,madman,longhorn,browns,target,666999,eatme,qazwsx123,microsoft,dilbert,christia,baller,lesbian,shooter,xfiles,seattle,qazqaz,cthutq,amateur,prelude,corona,freaky,malibu,123qweasdzxc,assassin,246810,atlantis,integra,pussies,iloveu,lonewolf,dragons,monkey1,unicorn,software,bobcat,stealth,peewee,openup,753951,srinivas,zaqwsx,valentina,shotgun,trigger,veronika,bruins,coyote,babydoll,joker,dollar,lestat,rocky1,hottie,random,butterfly,wordpass,smiley,sweety,snake,chipper,woody,samurai,devildog,gizmo,maddie,soso123aljg,mistress,freedom1,flipper,express,hjvfirf,moose,cessna,piglet,polaris,teacher,montreal,cookies,wolfgang,scully,fatboy,wicked,balls,tickle,bunny,dfvgbh,foobar,transam,pepsi,fetish,oicu812,basketba,toshiba,hotstuff,sunday,booty,gambit,31415926,impala,stephani,jessica1,hooker,lancer,knicks,shamrock,fuckyou2,stinger,314159,redneck,deftones,squirt,siemens,blaster,trucker,subaru,renegade,ibanez,manson,swinger,reaper,blondie,mylove,galaxy,blahblah,enterpri,travel,1234abcd,babylon5,indiana,skeeter,master1,sugar,ficken,smoke,bigone,sweetpea,fucked,trfnthbyf,marino,escort,smitty,bigfoot,babes,larisa,trumpet,spartan,valera,babylon,asdfghj,yankees1,bigboobs,stormy,mister,hamlet,aardvark,butterfl,marathon,paladin,cavalier,manchester,skater,indigo,hornet,buckeyes,01011990,indians,karate,hesoyam,toronto,diamonds,chiefs,buckeye,1qaz2wsx3edc,highland,hotsex,charger,redman,passwor,maiden,drpepper,storm,pornstar,garden,12345678910,pencil,sherlock,timber,thuglife,insane,pizza,jungle,jesus1,aragorn,1a2b3c,hamster,david1,triumph,techno,lollol,pioneer,catdog,321654,fktrctq,morpheus,141627,pascal,shadow1,hobbit,wetpussy,erotic,consumer,blabla,justme,stones,chrissy,spartak,goforit,burger,pitbull,adgjmptw,italia,barcelona,hunting,colors,kissme,virgin,overlord,pebbles,sundance,emerald,doggy,racecar,irina,element,1478963,zipper,alpine,basket,goddess,poison,nipple,sakura,chichi,huskers,13579,pussys,q12345,ultimate,ncc1701e,blackie,nicola,rommel,matthew1,caserta,omega,geronimo,sammy1,trojan,123qwe123,philips,nugget,tarzan,chicks,aleksandr,bassman,trixie,portugal,anakin,dodger,bomber,superfly,madness,q1w2e3r4t5y6,loser,123asd,fatcat,ybrbnf,soldier,warlock,wrinkle1,desire,sexual,babe,seminole,alejandr,951753,11235813,westham,andrei,concrete,access14,weed,letmein2,ladybug,naked,christop,trombone,tintin,bluesky,rhbcnbyf,qazxswedc,onelove,cdtnkfyf,whore,vfvjxrf,titans,stallion,truck,hansolo,blue22,smiles,beagle,panama,kingkong,flatron,inferno,mongoose,connect,poiuyt,snatch,qawsed,juice,blessed,rocker,snakes,turbo,bluemoon,sex4me,finger,jamaica,a1234567,mulder,beetle,fuckyou1,passat,immortal,plastic,123454321,anthony1,whiskey,dietcoke,suck,spunky,magic1,monitor,cactus,exigen,planet,ripper,teen,spyder,apple1,nolimit,hollywoo,sluts,sticky,trunks,1234321,14789632,pickles,sailing,bonehead,ghbdtnbr,delta,charlott,rubber,911911,112358,molly1,yomama,hongkong,jumper,william1,ilovesex,faster,unreal,cumming,memphis,1123581321,nylons,legion,sebastia,shalom,pentium,geheim,werewolf,funtime,ferret,orion,curious,555666,niners,cantona,sprite,philly,pirates,abgrtyu,lollipop,eternity,boeing,super123,sweets,cooldude,tottenha,green1,jackoff,stocking,7895123,moomoo,martini,biscuit,drizzt,colt45,fossil,makaveli,snapper,satan666,maniac,salmon,patriot,verbatim,nasty,shasta,asdzxc,shaved,blackcat,raistlin,qwerty12345,punkrock,cjkywt,01012010,4128,waterloo,crimson,twister,oxford,musicman,seinfeld,biggie,condor,ravens,megadeth,wolfman,cosmos,sharks,banshee,keeper,foxtrot,gn56gn56,skywalke,velvet,black1,sesame,dogs,squirrel,privet,sunrise,wolverine,sucks,legolas,grendel,ghost,cats,carrot,frosty,lvbnhbq,blades,stardust,frog,qazwsxed,121314,coolio,brownie,groovy,twilight,daytona,vanhalen,pikachu,peanuts,licker,hershey,jericho,intrepid,ninja,1234567a,zaq123,lobster,goblin,punisher,strider,shogun,kansas,amadeus,seven7,jason1,neptune,showtime,muscle,oldman,ekaterina,rfrfirf,getsome,showme,111222333,obiwan,skittles,danni,tanker,maestro,tarheel,anubis,hannibal,anal,newlife,gothic,shark,fighter,blue123,blues,123456z,princes,slick,chaos,thunder1,sabine,1q2w3e4r5t6y,python,test1,mirage,devil,clover,tequila,chelsea1,surfing,delete,potato,chubby,panasonic,sandiego,portland,baggins,fusion,sooners,blackdog,buttons,californ,moscow,playtime,mature,1a2b3c4d,dagger,dima,stimpy,asdf123,gangster,warriors,iverson,chargers,byteme,swallow,liquid,lucky7,dingdong,nymets,cracker,mushroom,456852,crusader,bigguy,miami,dkflbvbh,bugger,nimrod,tazman,stranger,newpass,doodle,powder,gotcha,guardian,dublin,slapshot,septembe,147896325,pepsi1,milano,grizzly,woody1,knights,photos,2468,nookie,charly,rammstein,brasil,123321123,scruffy,munchkin,poopie,123098,kittycat,latino,walnut,1701,thegame,viper1,1passwor,kolobok,picasso,robert1,barcelon,bananas,trance,auburn,coltrane,eatshit,goodluck,starcraft,wheels,parrot,postal,blade,wisdom,pink,gorilla,katerina,pass123,andrew1,shaney14,dumbass,osiris,fuck_inside,oakland,discover,ranger1,spanking,lonestar,bingo,meridian,ping,heather1,dookie,stonecol,megaman,192837465,rjntyjr,ledzep,lowrider,25802580,richard1,firefly,griffey,racerx,paradox,ghjcnj,gangsta,zaq1xsw2,tacobell,weezer,sirius,halflife,buffett,shiloh,123698745,vertigo,sergei,aliens,sobaka,keyboard,kangaroo,sinner,soccer1,0.0.000,bonjour,socrates,chucky,hotboy,sprint,0007,sarah1,scarlet,celica,shazam,formula1,sommer,trebor,qwerasdf,jeep,mailcreated5240,bollox,asshole1,fuckface,honda1,rebels,vacation,lexmark,penguins,12369874,ragnarok,formula,258456,tempest,vfhecz,tacoma,qwertz,colombia,flames,rockon,duck,prodigy,wookie,dodgeram,mustangs,123qaz,sithlord,smoker,server,bang,incubus,scoobydo,oblivion,molson,kitkat,titleist,rescue,zxcv1234,carpet,1122,bigballs,tardis,jimbob,xanadu,blueeyes,shaman,mersedes,pooper,pussy69,golfing,hearts,mallard,12312312,kenwood,patrick1,dogg,cowboys1,oracle,123zxc,nuttertools,102938,topper,1122334455,shemale,sleepy,gremlin,yourmom,123987,gateway1,printer,monkeys,peterpan,mikey,kingston,cooler,analsex,jimbo,pa55word,asterix,freckles,birdman,frank1,defiant,aussie,stud,blondes,tatyana,445566,aspirine,mariners,jackal,deadhead,katrin,anime,rootbeer,frogger,polo,scooter1,hallo,noodles,thomas1,parola,shaolin,celine,11112222,plymouth,creampie,justdoit,ohyeah,fatass,assfuck,amazon,1234567q,kisses,magnus,camel,nopass,bosco,987456,6751520,harley1,putter,champs,massive,spidey,lightnin,camelot,letsgo,gizmodo,aezakmi,bones,caliente,12121,goodtime,thankyou,raiders1,brucelee,redalert,aquarius,456654,catherin,smokin,pooh,mypass,astros,roller,porkchop,sapphire,qwert123,kevin1,a1s2d3f4,beckham,atomic,rusty1,vanilla,qazwsxedcrfv,hunter1,kaktus,cxfcnmt,blacky,753159,elvis1,aggies,blackjac,bangkok,scream,123321q,iforgot,power1,kasper,abc12,buster1,slappy,shitty,veritas,chevrole,amber1,01012001,vader,amsterdam,jammer,primus,spectrum,eduard,granny,horny1,sasha1,clancy,usa123,satan,diamond1,hitler,avenger,1221,spankme,123456qwerty,simba,smudge,scrappy,labrador,john316,syracuse,front242,falcons,husker,candyman,commando,gator,pacman,delta1,pancho,krishna,fatman,clitoris,pineappl,lesbians,8j4ye3uz,barkley,vulcan,punkin,boner,celtics,monopoly,flyboy,romashka,hamburg,123456aa,lick,gangbang,223344,area51,spartans,aaa111,tricky,snuggles,drago,homerun,vectra,homer1,hermes,topcat,cuddles,infiniti,1234567890q,cosworth,goose,phoenix1,killer1,ivanov,bossman,qawsedrf,peugeot,exigent,doberman,durango,brandon1,plumber,telefon,horndog,laguna,rbhbkk,dawg,webmaster,breeze,beast,porsche9,beefcake,leopard,redbull,oscar1,topdog,godsmack,theking,pics,omega1,speaker,viktoria,fuckers,bowler,starbuck,gjkbyf,valhalla,anarchy,blacks,herbie,kingpin,starfish,nokia,loveit,achilles,906090,labtec,ncc1701a,fitness,jordan1,brando,arsenal1,bull,kicker,napass,desert,sailboat,bohica,tractor,hidden,muppet,jackson1,jimmy1,terminator,phillies,pa55w0rd,terror,farside,swingers,legacy,frontier,butthole,doughboy,jrcfyf,tuesday,sabbath,daniel1,nebraska,homers,qwertyuio,azamat,fallen,agent007,striker,camels,iguana,looker,pinkfloy,moloko,qwerty123456,dannyboy,luckydog,789654,pistol,whocares,charmed,skiing,select,franky,puppy,daniil,vladik,vette,vfrcbvrf,ihateyou,nevada,moneys,vkontakte,mandingo,puppies,666777,mystic,zidane,kotenok,dilligaf,budman,bunghole,zvezda,123457,triton,golfball,technics,trojans,panda,laptop,rookie,01011991,15426378,aberdeen,gustav,jethro,enterprise,igor,stripper,filter,hurrican,rfnthbyf,lespaul,gizmo1,butch,132435,dthjybrf,1366613,excalibu,963852,nofear,momoney,possum,cutter,oilers,moocow,cupcake,gbpltw,batman1,splash,svetik,super1,soleil,bogdan,melissa1,vipers,babyboy,tdutybq,lancelot,ccbill,keystone,passwort,flamingo,firefox,dogman,vortex,rebel,noodle,raven1,zaphod,killme,pokemon1,coolman,danila,designer,skinny,kamikaze,deadman,gopher,doobie,warhammer,deeznuts,freaks,engage,chevy1,steve1,apollo13,poncho,hammers,azsxdc,dracula,000007,sassy,bitch1,boots,deskjet,12332,macdaddy,mighty,rangers1,manchest,sterlin,casey1,meatball,mailman,sinatra,cthulhu,summer1,bubbas,cartoon,bicycle,eatpussy,truelove,sentinel,tolkien,breast,capone,lickit,summit,123456k,peter1,daisy1,kitty1,123456789z,crazy1,jamesbon,texas1,sexygirl,362436,sonic,billyboy,redhot,microsof,microlab,daddy1,rockets,iloveyo,fernand,gordon24,danie,cutlass,polska,star69,titties,pantyhos,01011985,thekid,aikido,gofish,mayday,1234qwe,coke,anfield,sony,lansing,smut,scotch,sexx,catman,73501505,hustler,saun,dfkthbz,passwor1,jenny1,azsxdcfv,cheers,irish1,gabrie,tinman,orioles,1225,charlton,fortuna,01011970,airbus,rustam,xtreme,bigmoney,zxcasd,retard,grumpy,huskies,boxing,4runner,kelly1,ultima,warlord,fordf150,oranges,rotten,asdfjkl,superstar,denali,sultan,bikini,saratoga,thor,figaro,sixers,wildfire,vladislav,128500,sparta,mayhem,greenbay,chewie,music1,number1,cancun,fabie,mellon,poiuytrewq,cloud9,crunch,bigtime,chicken1,piccolo,bigbird,321654987,billy1,mojo,01011981,maradona,sandro,chester1,bizkit,rjirfrgbde,789123,rightnow,jasmine1,hyperion,treasure,meatloaf,armani,rovers,jarhead,01011986,cruise,coconut,dragoon,utopia,davids,cosmo,rfhbyf,reebok,1066,charli,giorgi,sticks,sayang,pass1234,exodus,anaconda,zaqxsw,illini,woofwoof,emily1,sandy1,packer,poontang,govols,jedi,tomato,beaner,cooter,creamy,lionking,happy123,albatros,poodle,kenworth,dinosaur,greens,goku,happyday,eeyore,tsunami,cabbage,holyshit,turkey50,memorex,chaser,bogart,orgasm,tommy1,volley,whisper,knopka,ericsson,walleye,321123,pepper1,katie1,chickens,tyler1,corrado,twisted,100000,zorro,clemson,zxcasdqwe,tootsie,milana,zenith,fktrcfylhf,shania,frisco,polniypizdec0211,crazybab,junebug,fugazi,rereirf,vfvekz,1001,sausage,vfczyz,koshka,clapton,justin1,anhyeuem,condom,fubar,hardrock,skywalker,tundra,cocks,gringo,150781,canon,vitalik,aspire,stocks,samsung1,applepie,abc12345,arjay,gandalf1,boob,pillow,sparkle,gmoney,rockhard,lucky13,samiam,everest,hellyeah,bigsexy,skorpion,rfrnec,hedgehog,australi,candle,slacker,dicks,voyeur,jazzman,america1,bobby1,br0d3r,wolfie,vfksirf,1qa2ws3ed,13243546,fright,yosemite,temp,karolina,fart,barsik,surf,cheetah,baddog,deniska,starship,bootie,milena,hithere,kume,greatone,dildo,50cent,0.0.0.000,albion,amanda1,midget,lion,maxell,football1,cyclone,freeporn,nikola,bonsai,kenshin,slider,balloon,roadkill,killbill,222333,jerkoff,78945612,dinamo,tekken,rambler,goliath,cinnamon,malaka,backdoor,fiesta,packers1,rastaman,fletch,sojdlg123aljg,stefano,artemis,calico,nyjets,damnit,robotech,duchess,rctybz,hooter,keywest,18436572,hal9000,mechanic,pingpong,operator,presto,sword,rasputin,spank,bristol,faggot,shado,963852741,amsterda,321456,wibble,carrera,alibaba,majestic,ramses,duster,route66,trident,clipper,steeler,wrestlin,divine,kipper,gotohell,kingfish,snake1,passwords,buttman,pompey,viagra,zxcvbnm1,spurs,332211,slutty,lineage2,oleg,macross,pooter,brian1,qwert1,charles1,slave,jokers,yzerman,swimmer,ne1469,nwo4life,solnce,seamus,lolipop,pupsik,moose1,ivanova,secret1,matador,love69,420247,ktyjxrf,subway,cinder,vermont,pussie,chico,florian,magick,guiness,allsop,ghetto,flash1,a123456789,typhoon,dfkthf,depeche,skydive,dammit,seeker,fuckthis,crysis,kcj9wx5n,umbrella,r2d2c3po,123123q,snoopdog,critter,theboss,ding,162534,splinter,kinky,cyclops,jayhawk,456321,caramel,qwer123,underdog,caveman,onlyme,grapes,feather,hotshot,fuckher,renault,george1,sex123,pippen,000001,789987,floppy,cunts,megapass,1000,pornos,usmc,kickass,great1,quattro,135246,wassup,helloo,p0015123,nicole1,chivas,shannon1,bullseye,java,fishes,blackhaw,jamesbond,tunafish,juggalo,dkflbckfd,123789456,dallas1,translator,122333,beanie,alucard,gfhjkm123,supersta,magicman,ashley1,cohiba,xbox360,caligula,12131415,facial,7753191,dfktynbyf,cobra1,cigars,fang,klingon,bob123,safari,looser,10203,deepthroat,malina,200000,tazmania,gonzo,goalie,jacob1,monaco,cruiser,misfit,vh5150,tommyboy,marino13,yousuck,sharky,vfhufhbnf,horizon,absolut,brighton,123456r,death1,kungfu,maxx,forfun,mamapapa,enter1,budweise,banker,getmoney,kostya,qazwsx12,bigbear,vector,fallout,nudist,gunners,royals,chainsaw,scania,trader,blueboy,walrus,eastside,kahuna,qwerty1234,love123,steph,01011989,cypress,champ,undertaker,ybrjkfq,europa,snowboar,sabres,moneyman,chrisbln,minime,nipper,groucho,whitey,viewsonic,penthous,wolf359,fabric,flounder,coolguy,whitesox,passme,smegma,skidoo,thanatos,fucku2,snapple,dalejr,mondeo,thesims,mybaby,panasoni,sinbad,thecat,topher,frodo,sneakers,q123456,z1x2c3,alfa,chicago1,taylor1,ghjcnjnfr,cat123,olivier,cyber,titanium,0420,madison1,jabroni,dang,hambone,intruder,holly1,gargoyle,sadie1,static,poseidon,studly,newcastl,sexxxx,poppy,johannes,danzig,beastie,musica,buckshot,sunnyday,adonis,bluedog,bonkers,2128506,chrono,compute,spawn,01011988,turbo1,smelly,wapbbs,goldstar,ferrari1,778899,quantum,pisces,boomboom,gunnar,1024,test1234,florida1,nike,superman1,multiplelo,custom,motherlode,1qwerty,westwood,usnavy,apple123,daewoo,korn,stereo,sasuke,sunflowe,watcher,dharma,555777,mouse1,assholes,babyblue,123qwerty,marius,walmart,snoop,starfire,tigger1,paintbal,knickers,aaliyah,lokomotiv,theend,winston1,sapper,rover,erotica,scanner,racer,zeus,sexy69,doogie,bayern,joshua1,newbie,scott1,losers,droopy,outkast,martin1,dodge1,wasser,ufkbyf,rjycnfynby,thirteen,12345z,112211,hotred,deejay,hotpussy,192837,jessic,philippe,scout,panther1,cubbies,havefun,magpie,fghtkm,avalanch,newyork1,pudding,leonid,harry1,cbr600,audia4,bimmer,fucku,01011984,idontknow,vfvfgfgf,1357,aleksey,builder,01011987,zerocool,godfather,mylife,donuts,allmine,redfish,777888,sascha,nitram,bounce,333666,smokes,1x2zkg8w,rodman,stunner,zxasqw12,hoosier,hairy,beretta,insert,123456s,rtyuehe,francesc,tights,cheese1,micron,quartz,hockey1,gegcbr,searay,jewels,bogey,paintball,celeron,padres,bing,syncmaster,ziggy,simon1,beaches,prissy,diehard,orange1,mittens,aleksandra,queens,02071986,biggles,thongs,southpark,artur,twinkle,gretzky,rabota,cambiami,monalisa,gollum,chuckles,spike1,gladiator,whisky,spongebob,sexy1,03082006,mazafaka,meathead,4121,ou8122,barefoot,12345678q,cfitymrf,bigass,a1s2d3,kosmos,blessing,titty,clevelan,terrapin,ginger1,johnboy,maggot,clarinet,deeznutz,336699,stumpy,stoney,footbal,traveler,volvo,bucket,snapon,pianoman,hawkeyes,futbol,casanova,tango,goodboy,scuba,honey1,sexyman,warthog,mustard,abc1234,nickel,10203040,meowmeow,1012,boricua,prophet,sauron,12qwas,reefer,andromeda,crystal1,joker1,90210,goofy,loco,lovesex,triangle,whatsup,mellow,bengals,monster1,maste,01011910,lover1,love1,123aaa,sunshin,smeghead,hokies,sting,welder,rambo,cerberus,bunny1,rockford,monke,1q2w3e4r5,goldwing,gabriell,buzzard,crjhgbjy,james007,rainman,groove,tiberius,purdue,nokia6300,hayabusa,shou,jagger,diver,zigzag,poochie,usarmy,phish,redwood,redwing,12345679,salamander,silver1,abcd123,sputnik,boobie,ripple,eternal,12qw34er,thegreat,allstar,slinky,gesperrt,mishka,whiskers,pinhead,overkill,sweet1,rhfcjnrf,montgom240,sersolution,jamie1,starman,proxy,swords,nikolay,bacardi,rasta,badgirl,rebecca1,wildman,penny1,spaceman,1007,10101,logan1,hacked,bulldog1,helmet,windsor,buffy1,runescape,trapper,123451,banane,dbrnjh,ripken,12345qwe,frisky,shun,fester,oasis,lightning,ib6ub9,cicero,kool,pony,thedog,784512,01011992,megatron,illusion,edward1,napster,11223,squash,roadking,woohoo,19411945,hoosiers,01091989,tracker,bagira,midway,leavemealone,br549,14725836,235689,menace,rachel1,feng,laser,stoned,realmadrid,787898,balloons,tinkerbell,5551212,maria1,pobeda,heineken,sonics,moonlight,optimus,comet,orchid,02071982,jaybird,kashmir,12345678a,chuang,chunky,peach,mortgage,rulezzz,saleen,chuckie,zippy,fishing1,gsxr750,doghouse,maxim,reader,shai,buddah,benfica,chou,salomon,meister,eraser,blackbir,bigmike,starter,pissing,angus,deluxe,eagles1,hardcock,135792468,mian,seahawks,godfathe,bookworm,gregor,intel,talisman,blackjack,babyface,hawaiian,dogfood,zhong,01011975,sancho,ludmila,medusa,mortimer,123456654321,roadrunn,just4me,stalin,01011993,handyman,alphabet,pizzas,calgary,clouds,password2,cgfhnfr,f**k,cubswin,gong,lexus,max123,xxx123,digital1,gfhjkm1,7779311,missy1,michae,beautifu,gator1,1005,pacers,buddie,chinook,heckfy,dutchess,sally1,breasts,beowulf,darkman,jenn,tiffany1,zhei,quan,qazwsx1,satana,shang,idontkno,smiths,puddin,nasty1,teddybea,valkyrie,passwd,chao,boxster,killers,yoda,cheater,inuyasha,beast1,wareagle,foryou,dragonball,mermaid,bhbirf,teddy1,dolphin1,misty1,delphi,gromit,sponge,qazzaq,fytxrf,gameover,diao,sergi,beamer,beemer,kittykat,rancid,manowar,adam12,diggler,assword,austin1,wishbone,gonavy,sparky1,fisting,thedude,sinister,1213,venera,novell,salsero,jayden,fuckoff1,linda1,vedder,02021987,1pussy,redline,lust,jktymrf,02011985,dfcbkbq,dragon12,chrome,gamecube,titten,cong,bella1,leng,02081988,eureka,bitchass,147369,banner,lakota,123321a,mustafa,preacher,hotbox,02041986,z1x2c3v4,playstation,01011977,claymore,electra,checkers,zheng,qing,armagedon,02051986,wrestle,svoboda,bulls,nimbus,alenka,madina,newpass6,onetime,aa123456,bartman,02091987,silverad,electron,12345t,devil666,oliver1,skylar,rhtdtlrj,gobucks,johann,12011987,milkman,02101985,camper,thunderb,bigbutt,jammin,davide,cheeks,goaway,lighter,claudi,thumbs,pissoff,ghostrider,cocaine,teng,squall,lotus,hootie,blackout,doitnow,subzero,02031986,marine1,02021988,pothead,123456qw,skate,1369,peng,antoni,neng,miao,bcfields,1492,marika,794613,musashi,tulips,nong,piao,chai,ruan,southpar,02061985,nude,mandarin,654123,ninjas,cannabis,jetski,xerxes,zhuang,kleopatra,dickie,bilbo,pinky,morgan1,1020,1017,dieter,baseball1,tottenham,quest,yfnfkmz,dirtbike,1234567890a,mango,jackson5,ipswich,iamgod,02011987,tdutybz,modena,qiao,slippery,qweasd123,bluefish,samtron,toon,111333,iscool,02091986,petrov,fuzzy,zhou,1357924680,mollydog,deng,02021986,1236987,pheonix,zhun,ghblehjr,othello,starcraf,000111,sanfran,a11111,cameltoe,badman,vasilisa,jiang,1qaz2ws,luan,sveta,12qw12,akira,chuai,369963,cheech,beatle,pickup,paloma,01011983,caravan,elizaveta,gawker,banzai,pussey,mullet,seng,bingo1,bearcat,flexible,farscape,borussia,zhuai,templar,guitar1,toolman,yfcntymrf,chloe1,xiang,slave1,guai,nuggets,02081984,mantis,slim,scorpio1,fyutkbyf,thedoors,02081987,02061986,123qq123,zappa,fergie,7ugd5hip2j,huai,asdfzxcv,sunflower,pussyman,deadpool,bigtit,01011982,love12,lassie,skyler,gatorade,carpedie,jockey,mancity,spectre,02021984,cameron1,artemka,reng,02031984,iomega,jing,moritz,spice,rhino,spinner,heater,zhai,hover,talon,grease,qiong,corleone,ltybcrf,tian,cowboy1,hippie,chimera,ting,alex123,02021985,mickey1,corsair,sonoma,aaron1,xxxpass,bacchus,webmaste,chuo,xyz123,chrysler,spurs1,artem,shei,cosmic,01020304,deutsch,gabriel1,123455,oceans,987456321,binladen,latinas,a12345678,speedo,buttercu,02081989,21031988,merlot,millwall,ceng,kotaku,jiong,dragonba,2580,stonecold,snuffy,01011999,02011986,hellos,blaze,maggie1,slapper,istanbul,bonjovi,babylove,mazda,bullfrog,phoeni,meng,porsche1,nomore,02061989,bobdylan,capslock,orion1,zaraza,teddybear,ntktajy,myname,rong,wraith,mets,niao,02041984,smokie,chevrolet,dialog,gfhjkmgfhjkm,dotcom,vadim,monarch,athlon,mikey1,hamish,pian,liang,coolness,chui,thoma,ramones,ciccio,chippy,eddie1,house1,ning,marker,cougars,jackpot,barbados,reds,pdtplf,knockers,cobalt,amateurs,dipshit,napoli,kilroy,pulsar,jayhawks,daemon,alexey,weng,shuang,9293709b13,shiner,eldorado,soulmate,mclaren,golfer1,andromed,duan,50spanks,sexyboy,dogshit,02021983,shuo,kakashka,syzygy,111111a,yeahbaby,qiang,netscape,fulham,120676,gooner,zhui,rainbow6,laurent,dog123,halifax,freeway,carlitos,147963,eastwood,microphone,monkey12,1123,persik,coldbeer,geng,nuan,danny1,fgtkmcby,entropy,gadget,just4fun,sophi,baggio,carlito,1234567891,02021989,02041983,specialk,piramida,suan,bigblue,salasana,hopeful,mephisto,bailey1,hack,annie1,generic,violetta,spencer1,arcadia,02051983,hondas,9562876,trainer,jones1,smashing,liao,159632,iceberg,rebel1,snooker,temp123,zang,matteo,fastball,q2w3e4r5,bamboo,fuckyo,shutup,astro,buddyboy,nikitos,redbird,maxxxx,shitface,02031987,kuai,kissmyass,sahara,radiohea,1234asdf,wildcard,maxwell1,patric,plasma,heynow,bruno1,shao,bigfish,misfits,sassy1,sheng,02011988,02081986,testpass,nanook,cygnus,licking,slavik,pringles,xing,1022,ninja1,submit,dundee,tiburon,pinkfloyd,yummy,shuai,guang,chopin,obelix,insomnia,stroker,1a2s3d4f,1223,playboy1,lazarus,jorda,spider1,homerj,sleeper,02041982,darklord,cang,02041988,02041987,tripod,magician,jelly,telephon,15975,vsjasnel12,pasword,iverson3,pavlov,homeboy,gamecock,amigo,brodie,budapest,yjdsqgfhjkm,reckless,02011980,pang,tiger123,2469,mason1,orient,01011979,zong,cdtnbr,maksimka,1011,bushido,taxman,giorgio,sphinx,kazantip,02101984,concorde,verizon,lovebug,georg,sam123,seadoo,qazwsxedc123,jiao,jezebel,pharmacy,abnormal,jellybea,maxime,puffy,islander,bunnies,jiggaman,drakon,010180,pluto,zhjckfd,12365,classics,crusher,mordor,hooligan,strawberry,02081985,scrabble,hawaii50,1224,wg8e3wjf,cthtuf,premium,arrow,123456qwe,mazda626,ramrod,tootie,rhjrjlbk,ghost1,1211,bounty,niang,02071984,goat,killer12,sweetnes,porno1,masamune,426hemi,corolla,mariposa,hjccbz,doomsday,bummer,blue12,zhao,bird33,excalibur,samsun,kirsty,buttfuck,kfhbcf,zhuo,marcello,ozzy,02021982,dynamite,655321,master12,123465,lollypop,stepan,1qa2ws,spiker,goirish,callum,michael2,moonbeam,attila,henry1,lindros,andrea1,sporty,lantern,12365478,nextel,violin,volcom,998877,water1,imation,inspiron,dynamo,citadel,placebo,clowns,tiao,02061988,tripper,dabears,haggis,merlin1,02031985,anthrax,amerika,iloveme,vsegda,burrito,bombers,snowboard,forsaken,katarina,a1a2a3,woofer,tigger2,fullmoon,tiger2,spock,hannah1,snoopy1,sexxxy,sausages,stanislav,cobain,robotics,exotic,green123,mobydick,senators,pumpkins,fergus,asddsa,147741,258852,windsurf,reddevil,vfitymrf,nevermind,nang,woodland,4417,mick,shui,q1q2q3,wingman,69696,superb,zuan,ganesh,pecker,zephyr,anastasiya,icu812,larry1,02081982,broker,zalupa,mihail,vfibyf,dogger,7007,paddle,varvara,schalke,1z2x3c,presiden,yankees2,tuning,poopy,02051982,concord,vanguard,stiffy,rjhjktdf,felix1,wrench,firewall,boxer,bubba69,popper,02011984,temppass,gobears,cuan,tipper,fuckme1,kamila,thong,puss,bigcat,drummer1,02031982,sowhat,digimon,tigers1,rang,jingle,bian,uranus,soprano,mandy1,dusty1,fandango,aloha,pumpkin1,postman,02061980,dogcat,bombay,pussy123,onetwo,highheel,pippo,julie1,laura1,pepito,beng,smokey1,stylus,stratus,reload,duckie,karen1,jimbo1,225588,369258,krusty,snappy,asdf12,electro,111qqq,kuang,fishin,clit,abstr,christma,qqqqq1,1234560,carnage,guyver,boxers,kittens,zeng,1000000,qwerty11,toaster,cramps,yugioh,02061987,icehouse,zxcvbnm123,pineapple,namaste,harrypotter,mygirl,falcon1,earnhard,fender1,spikes,nutmeg,01081989,dogboy,02091983,369852,softail,mypassword,prowler,bigboss,1112,harvest,heng,jubilee,killjoy,basset,keng,zaqxswcde,redsox1,biao,titan,misfit99,robot,wifey,kidrock,02101987,gameboy,enrico,1z2x3c4v,broncos1,arrows,havana,banger,cookie1,chriss,123qw,platypus,cindy1,lumber,pinball,foxy,london1,1023,05051987,02041985,password12,superma,longbow,radiohead,nigga,12051988,spongebo,qwert12345,abrakadabra,dodgers1,02101989,chillin,niceguy,pistons,hookup,santafe,bigben,jets,1013,vikings1,mankind,viktoriya,beardog,hammer1,02071980,reddwarf,magelan,longjohn,jennife,gilles,carmex2,02071987,stasik,bumper,doofus,slamdunk,pixies,garion,steffi,alessandro,beerman,niceass,warrior1,honolulu,134679852,visa,johndeer,mother1,windmill,boozer,oatmeal,aptiva,busty,delight,tasty,slick1,bergkamp,badgers,guitars,puffin,02091981,nikki1,irishman,miller1,zildjian,123000,airwolf,magnet,anai,install,02041981,02061983,astra,romans,megan1,mudvayne,freebird,muscles,dogbert,02091980,02091984,snowflak,01011900,mang,joseph1,nygiants,playstat,junior1,vjcrdf,qwer12,webhompas,giraffe,pelican,jefferso,comanche,bruiser,monkeybo,kjkszpj,123456l,micro,albany,02051987,angel123,epsilon,aladin,death666,hounddog,josephin,altima,chilly,02071988,78945,ultra,02041979,gasman,thisisit,pavel,idunno,kimmie,05051985,paulie,ballin,medion,moondog,manolo,pallmall,climber,fishbone,genesis1,153624,toffee,tbone,clippers,krypton,jerry1,picturs,compass,111111q,02051988,1121,02081977,sairam,getout,333777,cobras,22041987,bigblock,severin,booster,norwich,whiteout,ctrhtn,123456m,02061984,hewlett,shocker,fuckinside,02031981,chase1,white1,versace,123456789s,basebal,iloveyou2,bluebell,08031986,anthon,stubby,foreve,undertak,werder,saiyan,mama123,medic,chipmunk,mike123,mazdarx7,qwe123qwe,bowwow,kjrjvjnbd,celeb,choochoo,demo,lovelife,02051984,colnago,lithium,02051989,15051981,zzzxxx,welcom,anastasi,fidelio,franc,26061987,roadster,stone55,drifter,hookem,hellboy,1234qw,cbr900rr,sinned,good123654,storm1,gypsy,zebra,zachary1,toejam,buceta,02021979,testing1,redfox,lineage,mike1,highbury,koroleva,nathan1,washingt,02061982,02091985,vintage,redbaron,dalshe,mykids,11051987,macbeth,julien,james123,krasotka,111000,10011986,987123,pipeline,tatarin,sensei,codered,komodo,frogman,7894561230,nascar24,juicy,01031988,redrose,mydick,pigeon,tkbpfdtnf,smirnoff,1215,spam,winner1,flyfish,moskva,81fukkc,21031987,olesya,starligh,summer99,13041988,fishhead,freesex,super12,06061986,azazel,scoobydoo,02021981,cabron,yogibear,sheba1,konstantin,tranny,chilli,terminat,ghbywtccf,slowhand,soccer12,cricket1,fuckhead,1002,seagull,achtung,blam,bigbob,bdsm,nostromo,survivor,cnfybckfd,lemonade,boomer1,rainbow1,rober,irinka,cocksuck,peaches1,itsme,sugar1,zodiac,upyours,dinara,135791,sunny1,chiara,johnson1,02041989,solitude,habibi,sushi,markiz,smoke1,rockies,catwoman,johnny1,qwerty7,bearcats,username,01011978,wanderer,ohshit,02101986,sigma,stephen1,paradigm,02011989,flanker,sanity,jsbach,spotty,bologna,fantasia,chevys,borabora,cocker,74108520,123ewq,12021988,01061990,gtnhjdbx,02071981,01011960,sundevil,3000gt,mustang6,gagging,maggi,armstron,yfnfkb,13041987,revolver,02021976,trouble1,madcat,jeremy1,jackass1,volkswag,30051985,corndog,pool6123,marines1,03041991,pizza1,piggy,sissy,02031979,sunfire,angelus,undead,24061986,14061991,wildbill,shinobi,45m2do5bs,123qwer,21011989,cleopatr,lasvega,hornets,amorcit,11081989,coventry,nirvana1,destin,sidekick,20061988,02081983,gbhfvblf,sneaky,bmw325,22021989,nfytxrf,sekret,kalina,zanzibar,hotone,qazws,wasabi,heidi1,highlander,blues1,hitachi,paolo,23041987,slayer1,simba1,02011981,tinkerbe,kieran,01121986,172839,boiler,1125,bluesman,waffle,asdfgh01,threesom,conan,1102,reflex,18011987,nautilus,everlast,fatty,vader1,01071986,cyborg,ghbdtn123,birddog,rubble,02071983,suckers,02021973,skyhawk,12qw12qw,dakota1,joebob,nokia6233,woodie,longdong,lamer,troll,ghjcnjgfhjkm,420000,boating,nitro,armada,messiah,1031,penguin1,02091989,americ,02071989,redeye,asdqwe123,07071987,monty1,goten,spikey,sonata,635241,tokiohotel,sonyericsson,citroen,compaq1,1812,umpire,belmont,jonny,pantera1,nudes,palmtree,14111986,fenway,bighead,razor,gryphon,andyod22,aaaaa1,taco,10031988,enterme,malachi,dogface,reptile,01041985,dindom,handball,marseille,candy1,19101987,torino,tigge,matthias,viewsoni,13031987,stinker,evangelion,24011985,123456123,rampage,sandrine,02081980,thecrow,astral,28041987,sprinter,private1,seabee,shibby,02101988,25081988,fearless,junkie,01091987,aramis,antelope,draven,fuck1,mazda6,eggman,02021990,barselona,buddy123,19061987,fyfnjkbq,nancy1,12121990,10071987,sluggo,kille,hotties,irishka,zxcasdqwe123,shamus,fairlane,honeybee,soccer10,13061986,fantomas,17051988,10051987,20111986,gladiato,karachi,gambler,gordo,01011995,biatch,matthe,25800852,papito,excite,buffalo1,bobdole,cheshire,player1,28021992,thewho,10101986,pinky1,mentor,tomahawk,brown1,03041986,bismillah,bigpoppa,ijrjkfl,01121988,runaway,08121986,skibum,studman,helper,squeak,holycow,manfred,harlem,glock,gideon,987321,14021985,yellow1,wizard1,margarit,success1,medved,sf49ers,lambda,pasadena,johngalt,quasar,1776,02031980,coldplay,amand,playa,bigpimp,04041991,capricorn,elefant,sweetness,bruce1,luca,dominik,10011990,biker,09051945,datsun,elcamino,trinitro,malice,audi,voyager1,02101983,joe123,carpente,spartan1,mario1,glamour,diaper,12121985,22011988,winter1,asimov,callisto,nikolai,pebble,02101981,vendetta,david123,boytoy,11061985,02031989,iloveyou1,stupid1,cayman,casper1,zippo,yamahar1,wildwood,foxylady,calibra,02041980,27061988,dungeon,leedsutd,30041986,11051990,bestbuy,antares,dominion,24680,01061986,skillet,enforcer,derparol,01041988,196969,29071983,f00tball,purple1,mingus,25031987,21031990,remingto,giggles,klaste,3x7pxr,01011994,coolcat,29051989,megane,20031987,02051980,04041988,synergy,0000007,macman,iforget,adgjmp,vjqgfhjkm,28011987,rfvfcenhf,16051989,25121987,16051987,rogue,mamamia,08051990,20091991,1210,carnival,bolitas,paris1,dmitriy,dimas,05051989,papillon,knuckles,29011985,hola,tophat,28021990,100500,cutiepie,devo,415263,ducks,ghjuhfvvf,asdqwe,22021986,freefall,parol,02011983,zarina,buste,vitamin,warez,bigones,17061988,baritone,jamess,twiggy,mischief,bitchy,hetfield,1003,dontknow,grinch,sasha_007,18061990,12031985,12031987,calimero,224466,letmei,15011987,acmilan,alexandre,02031977,08081988,whiteboy,21051991,barney1,02071978,money123,18091985,bigdawg,02031988,cygnusx1,zoloto,31011987,firefigh,blowfish,screamer,lfybbk,20051988,chelse,11121986,01031989,harddick,sexylady,30031988,02041974,auditt,pizdec,kojak,kfgjxrf,20091988,123456ru,wp2003wp,1204,15051990,slugger,kordell1,03031986,swinging,01011974,02071979,rockie,dimples,1234123,1dragon,trucking,rusty2,roger1,marijuana,kerouac,02051978,08031985,paco,thecure,keepout,kernel,noname123,13121985,francisc,bozo,02011982,22071986,02101979,obsidian,12345qw,spud,tabasco,02051985,jaguars,dfktynby,kokomo,popova,notused,sevens,4200,magneto,02051976,roswell,15101986,21101986,lakeside,bigbang,aspen,little1,14021986,loki,suckmydick,strawber,carlos1,nokian73,dirty1,joshu,25091987,16121987,02041975,advent,17011987,slimshady,whistler,10101990,stryker,22031984,15021985,01031985,blueball,26031988,ksusha,bahamut,robocop,w_pass,chris123,impreza,prozac,bookie,bricks,13021990,alice1,cassandr,11111q,john123,4ever,korova,02051973,142857,25041988,paramedi,eclipse1,salope,07091990,1124,darkangel,23021986,999666,nomad,02051981,smackdow,01021990,yoyoma,argentin,moonligh,57chevy,bootys,hardone,capricor,galant,spanker,dkflbr,24111989,magpies,krolik,21051988,cevthrb,cheddar,22041988,bigbooty,scuba1,qwedsa,duffman,bukkake,acura,johncena,sexxy,p@ssw0rd,258369,cherries,12345s,asgard,leopold,fuck123,mopar,lalakers,dogpound,matrix1,crusty,spanner,kestrel,fenris,universa,peachy,assasin,lemmein,eggplant,hejsan,canucks,wendy1,doggy1,aikman,tupac,turnip,godlike,fussball,golden1,19283746,april1,django,petrova,captain1,vincent1,ratman,taekwondo,chocha,serpent,perfect1,capetown,vampir,amore,gymnast,timeout,nbvjatq,blue32,ksenia,k.lvbkf,nazgul,budweiser,clutch,mariya,sylveste,02051972,beaker,cartman1,q11111,sexxx,forever1,loser1,marseill,magellan,vehpbr,sexgod,jktxrf,hallo123,132456,liverpool1,southpaw,seneca,camden,357159,camero,tenchi,johndoe,145236,roofer,741963,vlad,02041978,fktyrf,zxcv123,wingnut,wolfpac,notebook,pufunga7782,brandy1,biteme1,goodgirl,redhat,02031978,challeng,millenium,hoops,maveric,noname,angus1,gaell,onion,olympus,sabrina1,ricard,sixpack,gratis,gagged,camaross,hotgirls,flasher,02051977,bubba123,goldfing,moonshin,gerrard,volkov,sonyfuck,mandrake,258963,tracer,lakers1,asians,susan1,money12,helmut,boater,diablo2,1234zxcv,dogwood,bubbles1,happy2,randy1,aries,beach1,marcius2,navigator,goodie,hellokitty,fkbyjxrf,earthlink,lookout,jumbo,opendoor,stanley1,marie1,12345m,07071977,ashle,wormix,murzik,02081976,lakewood,bluejays,loveya,commande,gateway2,peppe,01011976,7896321,goth,oreo,slammer,rasmus,faith1,knight1,stone1,redskin,ironmaiden,gotmilk,destiny1,dejavu,1master,midnite,timosha,espresso,delfin,toriamos,oberon,ceasar,markie,1a2s3d,ghhh47hj7649,vjkjrj,daddyo,dougie,disco,auggie,lekker,therock1,ou8123,start1,noway,p4ssw0rd,shadow12,333444,saigon,2fast4u,capecod,23skidoo,qazxcv,beater,bremen,aaasss,roadrunner,peace1,12345qwer,02071975,platon,bordeaux,vbkfirf,135798642,test12,supernov,beatles1,qwert40,optimist,vanessa1,prince1,ilovegod,nightwish,natasha1,alchemy,bimbo,blue99,patches1,gsxr1000,richar,hattrick,hott,solaris,proton,nevets,enternow,beavis1,amigos,159357a,ambers,lenochka,147896,suckdick,shag,intercourse,blue1234,spiral,02061977,tosser,ilove,02031975,cowgirl,canuck,q2w3e4,munch,spoons,waterboy,123567,evgeniy,savior,zasada,redcar,mamacita,terefon,globus,doggies,htubcnhfwbz,1008,cuervo,suslik,azertyui,limewire,houston1,stratfor,steaua,coors,tennis1,12345qwerty,stigmata,derf,klondike,patrici,marijuan,hardball,odyssey,nineinch,boston1,pass1,beezer,sandr,charon,power123,a1234,vauxhall,875421,awesome1,reggae,boulder,funstuff,iriska,krokodil,rfntymrf,sterva,champ1,bball,peeper,m123456,toolbox,cabernet,sheepdog,magic32,pigpen,02041977,holein1,lhfrjy,banan,dabomb,natalie1,jennaj,montana1,joecool,funky,steven1,ringo,junio,sammy123,qqqwww,baltimor,footjob,geezer,357951,mash4077,cashmone,pancake,monic,grandam,bongo,yessir,gocubs,nastia,vancouve,barley,dragon69,watford,ilikepie,02071976,laddie,123456789m,hairball,toonarmy,pimpdadd,cvthnm,hunte,davinci,lback,sophie1,firenze,q1234567,admin1,bonanza,elway7,daman,strap,azert,wxcvbn,afrika,theforce,123456t,idefix,wolfen,houdini,scheisse,default,beech,maserati,02061976,sigmachi,dylan1,bigdicks,eskimo,mizzou,02101976,riccardo,egghead,111777,kronos,ghbrjk,chaos1,jomama,rfhnjirf,rodeo,dolemite,cafc91,nittany,pathfind,mikael,password9,vqsablpzla,purpl,gabber,modelsne,myxworld,hellsing,punker,rocknrol,fishon,fuck69,02041976,lolol,twinkie,tripleh,cirrus,redbone,killer123,biggun,allegro,gthcbr,smith1,wanking,bootsy,barry1,mohawk,koolaid,5329,futurama,samoht,klizma,996633,lobo,honeys,peanut1,556677,zxasqw,joemama,javelin,samm,223322,sandra1,flicks,montag,nataly,3006,tasha1,1235789,dogbone,poker1,p0o9i8u7,goodday,smoothie,toocool,max333,metroid,archange,vagabond,billabon,22061941,tyson1,02031973,darkange,skateboard,evolutio,morrowind,wizards,frodo1,rockin,cumslut,plastics,zaqwsxcde,5201314,doit,outback,bumble,dominiqu,persona,nevermore,alinka,02021971,forgetit,sexo,all4one,c2h5oh,petunia,sheeba,kenny1,elisabet,aolsucks,woodstoc,pumper,02011975,fabio,granada,scrapper,123459,minimoni,q123456789,breaker,1004,02091976,ncc74656,slimshad,friendster,austin31,wiseguy,donner,dilbert1,132465,blackbird,buffet,jellybean,barfly,behappy,01011971,carebear,fireblad,02051975,boxcar,cheeky,kiteboy,hello12,panda1,elvisp,opennow,doktor,alex12,02101977,pornking,flamengo,02091975,snowbird,lonesome,robin1,11111a,weed420,baracuda,bleach,12345abc,nokia1,metall,singapor,mariner,herewego,dingo,tycoon,cubs,blunts,proview,123456789d,kamasutra,lagnaf,vipergts,navyseal,starwar,masterbate,wildone,peterbil,cucumber,butkus,123qwert,climax,deniro,gotribe,cement,scooby1,summer69,harrier,shodan,newyear,02091977,starwars1,romeo1,sedona,harald,doubled,sasha123,bigguns,salami,awnyce,kiwi,homemade,pimping,azzer,bradley1,warhamme,linkin,dudeman,qwe321,pinnacle,maxdog,flipflop,lfitymrf,fucker1,acidburn,esquire,sperma,fellatio,jeepster,thedon,sexybitch,pookey,spliff,widget,vfntvfnbrf,trinity1,mutant,samuel1,meliss,gohome,1q2q3q,mercede,comein,grin,cartoons,paragon,henrik,rainyday,pacino,senna,bigdog1,alleycat,12345qaz,narnia,mustang2,tanya1,gianni,apollo11,wetter,clovis,escalade,rainbows,freddy1,smart1,daisydog,s123456,cocksucker,pushkin,lefty,sambo,fyutkjxtr,hiziad,boyz,whiplash,orchard,newark,adrenalin,1598753,bootsie,chelle,trustme,chewy,golfgti,tuscl,ambrosia,5wr2i7h8,penetration,shonuf,jughead,payday,stickman,gotham,kolokol,johnny5,kolbasa,stang,puppydog,charisma,gators1,mone,jakarta,draco,nightmar,01011973,inlove,laetitia,02091973,tarpon,nautica,meadow,0192837465,luckyone,14881488,chessie,goldeney,tarakan,69camaro,bungle,wordup,interne,fuckme2,515000,dragonfl,sprout,02081974,gerbil,bandit1,02071971,melanie1,phialpha,camber,kathy1,adriano,gonzo1,10293847,bigjohn,bismarck,7777777a,scamper,12348765,rabbits,222777,bynthytn,dima123,alexander1,mallorca,dragster,favorite6,beethove,burner,cooper1,fosters,hello2,normandy,777999,sebring,1michael,lauren1,blake1,killa,02091971,nounours,trumpet1,thumper1,playball,xantia,rugby1,rocknroll,guillaum,angela1,strelok,prosper,buttercup,masterp,dbnfkbr,cambridg,venom,treefrog,lumina,1234566,supra,sexybabe,freee,shen,frogs,driller,pavement,grace1,dicky,checker,smackdown,pandas,cannibal,asdffdsa,blue42,zyjxrf,nthvbyfnjh,melrose,neon,jabber,gamma,369258147,aprilia,atticus,benessere,catcher,skipper1,azertyuiop,sixty9,thierry,treetop,jello,melons,123456789qwe,tantra,buzzer,catnip,bouncer,computer1,sexyone,ananas,young1,olenka,sexman,mooses,kittys,sephiroth,contra,hallowee,skylark,sparkles,777333,1qazxsw23edc,lucas1,q1w2e3r,gofast,hannes,amethyst,ploppy,flower2,hotass,amatory,volleyba,dixie1,bettyboo,ticklish,02061974,frenchy,phish1,murphy1,trustno,02061972,leinad,mynameis,spooge,jupiter1,hyundai,frosch,junkmail,abacab,marbles,32167,casio,sunshine1,wayne1,longhair,caster,snicker,02101973,gannibal,skinhead,hansol,gatsby,segblue2,montecar,plato,gumby,kaboom,matty,bosco1,888999,jazzy,panter,jesus123,charlie2,giulia,candyass,sex69,travis1,farmboy,special1,02041973,letsdoit,password01,allison1,abcdefg1,notredam,ilikeit,789654123,liberty1,rugger,uptown,alcatraz,123456w,airman,007bond,navajo,kenobi,terrier,stayout,grisha,frankie1,fluff,1qazzaq1,1234561,virginie,1234568,tango1,werdna,octopus,fitter,dfcbkbcf,blacklab,115599,montrose,allen1,supernova,frederik,ilovepussy,justice1,radeon,playboy2,blubber,sliver,swoosh,motocros,lockdown,pearls,thebear,istheman,pinetree,biit,1234rewq,rustydog,tampabay,titts,babycake,jehovah,vampire1,streaming,collie,camil,fidelity,calvin1,stitch,gatit,restart,puppy1,budgie,grunt,capitals,hiking,dreamcas,zorro1,321678,riffraff,makaka,playmate,napalm,rollin,amstel,zxcvb123,samanth,rumble,fuckme69,jimmys,951357,pizzaman,1234567899,tralala,delpiero,alexi,yamato,itisme,1million,vfndtq,kahlua,londo,wonderboy,carrots,tazz,ratboy,rfgecnf,02081973,nico,fujitsu,tujhrf,sergbest,blobby,02051970,sonic1,1357911,smirnov,video1,panhead,bucky,02031974,44332211,duffer,cashmoney,left4dead,bagpuss,salman,01011972,titfuck,66613666,england1,malish,dresden,lemans,darina,zapper,123456as,123456qqq,met2002,02041972,redstar,blue23,1234509876,pajero,booyah,please1,tetsuo,semper,finder,hanuman,sunlight,123456n,02061971,treble,cupoi,password99,dimitri,3ip76k2,popcorn1,lol12345,stellar,nympho,shark1,keith1,saskia,bigtruck,revoluti,rambo1,asd222,feelgood,phat,gogators,bismark,cola,puck,furball,burnout,slonik,bowtie,mommy1,icecube,fabienn,mouser,papamama,rolex,giants1,blue11,trooper1,momdad,iklo,morten,rhubarb,gareth,123456d,blitz,canada1,r2d2,brest,tigercat,usmarine,lilbit,benny1,azrael,lebowski,12345r,madagaskar,begemot,loverman,dragonballz,italiano,mazda3,naughty1,onions,diver1,cyrano,capcom,asdfg123,forlife,fisherman,weare138,requiem,mufasa,alpha123,piercing,hellas,abracadabra,duckman,caracas,macintos,02011971,jordan2,crescent,fduecn,hogtied,eatmenow,ramjet,18121812,kicksass,whatthe,discus,rfhfvtkmrf,rufus1,sqdwfe,mantle,vegitto,trek,dan123,paladin1,rudeboy,liliya,lunchbox,riversid,acapulco,libero,dnsadm,maison,toomuch,boobear,hemlock,sextoy,pugsley,misiek,athome,migue,altoids,marcin,123450,rhfcfdbwf,jeter2,rhinos,rjhjkm,mercury1,ronaldinho,shampoo,makayla,kamilla,masterbating,tennesse,holger,john1,matchbox,hores,poptart,parlament,goodyear,asdfgh1,02081970,hardwood,alain,erection,hfytnrb,highlife,implants,benjami,dipper,jeeper,bendover,supersonic,babybear,laserjet,gotenks,bama,natedogg,aol123,pokemo,rabbit1,raduga,sopranos,cashflow,menthol,pharao,hacking,334455,ghjcnbnenrf,lizzy,muffin1,pooky,penis1,flyer,gramma,dipset,becca,ireland1,diana1,donjuan,pong,ziggy1,alterego,simple1,cbr900,logger,111555,claudia1,cantona7,matisse,ljxtymrf,victori,harle,mamas,encore,mangos,iceman1,diamon,alexxx,tiamat,5000,desktop,mafia,smurf,princesa,shojou,blueberr,welkom,maximka,123890,123q123,tammy1,bobmarley,clips,demon666,ismail,termite,laser1,missie,altair,donna1,bauhaus,trinitron,mogwai,flyers88,juniper,nokia5800,boroda,jingles,qwerasdfzxcv,shakur,777666,legos,mallrats,1qazxsw,goldeneye,tamerlan,julia1,backbone,spleen,49ers,shady,darkone,medic1,justi,giggle,cloudy,aisan,douche,parkour,bluejay,huskers1,redwine,1qw23er4,satchmo,1231234,nineball,stewart1,ballsack,probes,kappa,amiga,flipper1,dortmund,963258,trigun,1237895,homepage,blinky,screwy,gizzmo,belkin,chemist,coolhand,chachi,braves1,thebest,greedisgood,pro100,banana1,101091m,123456g,wonderfu,barefeet,8inches,1111qqqq,kcchiefs,qweasdzxc123,metal1,jennifer1,xian,asdasd123,pollux,cheerleaers,fruity,mustang5,turbos,shopper,photon,espana,hillbill,oyster,macaroni,gigabyte,jesper,motown,tuxedo,buster12,triplex,cyclones,estrell,mortis,holla,456987,fiddle,sapphic,jurassic,thebeast,ghjcnjq,baura,spock1,metallica1,karaoke,nemrac58,love1234,02031970,flvbybcnhfnjh,frisbee,diva,ajax,feathers,flower1,soccer11,allday,mierda,pearl1,amature,marauder,333555,redheads,womans,egorka,godbless,159263,nimitz,aaaa1111,sashka,madcow,socce,greywolf,baboon,pimpdaddy,123456789r,reloaded,lancia,rfhfylfi,dicker,placid,grimace,22446688,olemiss,whores,culinary,wannabe,maxi,1234567aa,amelie,riley1,trample,phantom1,baberuth,bramble,asdfqwer,vides,4you,abc123456,taichi,aztnm,smother,outsider,hakr,blackhawk,bigblack,girlie,spook,valeriya,gianluca,freedo,1q2q3q4q,handbag,lavalamp,cumm,pertinant,whatup,nokia123,redlight,patrik,111aaa,poppy1,dfytxrf,aviator,sweeps,kristin1,cypher,elway,yinyang,access1,poophead,tucson,noles1,monterey,waterfal,dank,dougal,918273,suede,minnesot,legman,bukowski,ganja,mammoth,riverrat,asswipe,daredevi,lian,arizona1,kamikadze,alex1234,smile1,angel2,55bgates,bellagio,0001,wanrltw,stiletto,lipton,arsena,biohazard,bbking,chappy,tetris,as123456,darthvad,lilwayne,nopassword,7412369,123456789987654321,natchez,glitter,14785236,mytime,rubicon,moto,pyon,wazzup,tbird,shane1,nightowl,getoff,beckham7,trueblue,hotgirl,nevermin,deathnote,13131,taffy,bigal,copenhag,apricot,gallaries,dtkjcbgtl,totoro,onlyone,civicsi,jesse1,baby123,sierra1,festus,abacus,sickboy,fishtank,fungus,charle,golfpro,teensex,mario66,seaside,aleksei,rosewood,blackberry,1020304050,bedlam,schumi,deerhunt,contour,darkelf,surveyor,deltas,pitchers,741258963,dipstick,funny1,lizzard,112233445566,jupiter2,softtail,titman,greenman,z1x2c3v4b5,smartass,12345677,notnow,myworld,nascar1,chewbacc,nosferatu,downhill,dallas22,kuan,blazers,whales,soldat,craving,powerman,yfcntyf,hotrats,cfvceyu,qweasdzx,princess1,feline,qqwwee,chitown,1234qaz,mastermind,114477,dingbat,care1839,standby,kismet,atreides,dogmeat,icarus,monkeyboy,alex1,mouses,nicetits,sealteam,chopper1,crispy,winter99,rrpass1,myporn,myspace1,corazo,topolino,ass123,lawman,muffy,orgy,1love,passord,hooyah,ekmzyf,pretzel,amonra,nestle,01011950,jimbeam,happyman,z12345,stonewal,helios,manunited,harcore,dick1,gaymen,2hot4u,light1,qwerty13,kakashi,pjkjnj,alcatel,taylo,allah,buddydog,ltkmaby,mongo,blonds,start123,audia6,123456v,civilwar,bellaco,turtles,mustan,deadspin,aaa123,fynjirf,lucky123,tortoise,amor,summe,waterski,zulu,drag0n,dtxyjcnm,gizmos,strife,interacial,pusyy,goose1,bear1,equinox,matri,jaguar1,tobydog,sammys,nachos,traktor,bryan1,morgoth,444555,dasani,miami1,mashka,xxxxxx1,ownage,nightwin,hotlips,passmast,cool123,skolko,eldiablo,manu,1357908642,screwyou,badabing,foreplay,hydro,kubrick,seductive,demon1,comeon,galileo,aladdin,metoo,happines,902100,mizuno,caddy,bizzare,girls1,redone,ohmygod,sable,bonovox,girlies,hamper,opus,gizmodo1,aaabbb,pizzahut,999888,rocky2,anton1,kikimora,peavey,ocelot,a1a2a3a4,2wsx3edc,jackie1,solace,sprocket,galary,chuck1,volvo1,shurik,poop123,locutus,virago,wdtnjxtr,tequier,bisexual,doodles,makeitso,fishy,789632145,nothing1,fishcake,sentry,libertad,oaktree,fivestar,adidas1,vegitta,mississi,spiffy,carme,neutron,vantage,agassi,boners,123456789v,hilltop,taipan,barrage,kenneth1,fister,martian,willem,lfybkf,bluestar,moonman,ntktdbpjh,paperino,bikers,daffy,benji,quake,dragonfly,suckcock,danilka,lapochka,belinea,calypso,asshol,camero1,abraxas,mike1234,womam,q1q2q3q4q5,youknow,maxpower,pic\'s,audi80,sonora,raymond1,tickler,tadpole,belair,crazyman,finalfantasy,999000,jonatha,paisley,kissmyas,morgana,monste,mantra,spunk,magic123,jonesy,mark1,alessand,741258,baddest,ghbdtnrfrltkf,zxccxz,tictac,augustin,racers,7grout,foxfire,99762000,openit,nathanie,1z2x3c4v5b,seadog,gangbanged,lovehate,hondacbr,harpoon,mamochka,fisherma,bismilla,locust,wally1,spiderman1,saffron,utjhubq,123456987,20spanks,safeway,pisser,bdfyjd,kristen1,bigdick1,magenta,vfhujif,anfisa,friday13,qaz123wsx,0987654321q,tyrant,guan,meggie,kontol,nurlan,ayanami,rocket1,yaroslav,websol76,mutley,hugoboss,websolutions,elpaso,gagarin,badboys,sephirot,918273645,newuser,qian,edcrfv,booger1,852258,lockout,timoxa94,mazda323,firedog,sokolova,skydiver,jesus777,1234567890z,soulfly,canary,malinka,guillerm,hookers,dogfart,surfer1,osprey,india123,rhjkbr,stoppedby,nokia5530,123456789o,blue1,werter,divers,3000,123456f,alpina,cali,whoknows,godspeed,986532,foreskin,fuzzy1,heyyou,didier,slapnuts,fresno,rosebud1,sandman1,bears1,blade1,honeybun,queen1,baronn,pakista,philipp,9111961,topsecret,sniper1,214365,slipper,letsfuck,pippen33,godawgs,mousey,qw123456,scrotum,loveis,lighthou,bp2002,nancy123,jeffrey1,susieq,buddy2,ralphie,trout1,willi,antonov,sluttey,rehbwf,marty1,darian,losangeles,letme1n,12345d,pusssy,godiva,ender,golfnut,leonidas,a1b2c3d4e5,puffer,general1,wizzard,lehjxrf,racer1,bigbucks,cool12,buddys,zinger,esprit,vbienrf,josep,tickling,froggie,987654321a,895623,daddys,crumbs,gucci,mikkel,opiate,tracy1,christophe,came11,777555,petrovich,humbug,dirtydog,allstate,horatio,wachtwoord,creepers,squirts,rotary,bigd,georgia1,fujifilm,2sweet,dasha,yorkie,slimjim,wiccan,kenzie,system1,skunk,b12345,getit,pommes,daredevil,sugars,bucker,piston,lionheart,1bitch,515051,catfight,recon,icecold,fantom,vodafone,kontakt,boris1,vfcnth,canine,01011961,valleywa,faraon,chickenwing101,qq123456,livewire,livelife,roosters,jeepers,ilya1234,coochie,pavlik,dewalt,dfhdfhf,architec,blackops,1qaz2wsx3edc4rfv,rhfcjnf,wsxedc,teaser,sebora,25252,rhino1,ankara,swifty,decimal,redleg,shanno,nermal,candies,smirnova,dragon01,photo1,ranetki,a1s2d3f4g5,axio,wertzu,maurizio,6uldv8,zxcvasdf,punkass,flowe,graywolf,peddler,3rjs1la7qe,mpegs,seawolf,ladyboy,pianos,piggies,vixen,alexus,orpheus,gdtrfb,z123456,macgyver,hugetits,ralph1,flathead,maurici,mailru,goofball,nissan1,nikon,stopit,odin,big1,smooch,reboot,famil,bullit,anthony7,gerhard,methos,124038,morena,eagle2,jessica2,zebras,getlost,gfynthf,123581321,sarajevo,indon,comets,tatjana,rfgbnjirf,joystick,batman12,123456c,sabre,beerme,victory1,kitties,1475369,badboy1,booboo1,comcast,slava,squid,saxophon,lionhear,qaywsx,bustle,nastena,roadway,loader,hillside,starlight,24681012,niggers,access99,bazooka,molly123,blackice,bandi,cocacol,nfhfrfy,timur,muschi,horse1,quant4307s,squerting,oscars,mygirls,flashman,tangerin,goofy1,p0o9i8,housewifes,newness,monkey69,escorpio,password11,hippo,warcraft3,qazxsw123,qpalzm,ribbit,ghbdtndctv,bogota,star123,258000,lincoln1,bigjim,lacoste,firestorm,legenda,indain,ludacris,milamber,1009,evangeli,letmesee,a111111,hooters1,bigred1,shaker,husky,a4tech,cnfkrth,argyle,rjhjdf,nataha,0o9i8u7y,gibson1,sooners1,glendale,archery,hoochie,stooge,aaaaaa1,scorpions,school1,vegas1,rapier,mike23,bassoon,groupd2013,macaco,baker1,labia,freewill,santiag,silverado,butch1,vflfufcrfh,monica1,rugrat,cornhole,aerosmit,bionicle,gfgfvfvf,daniel12,virgo,fmale,favorite2,detroit1,pokey,shredder,baggies,wednesda,cosmo1,mimosa,sparhawk,firehawk,romario,911turbo,funtimes,fhntvrf,nexus6,159753456,timothy1,bajingan,terry1,frenchie,raiden,1mustang,babemagnet,74123698,nadejda,truffles,rapture,douglas1,lamborghini,motocross,rjcvjc,748596,skeeter1,dante1,angel666,telecom,carsten,pietro,bmw318,astro1,carpediem,samir,orang,helium,scirocco,fuzzball,rushmore,rebelz,hotspur,lacrimosa,chevys10,madonna1,domenico,yfnfirf,jachin,shelby1,bloke,dawgs,dunhill,atlanta1,service1,mikado,devilman,angelit,reznor,euphoria,lesbain,checkmat,browndog,phreak,blaze1,crash1,farida,mutter,luckyme,horsemen,vgirl,jediknig,asdas,cesare,allnight,rockey,starlite,truck1,passfan,close-up,samue,cazzo,wrinkles,homely,eatme1,sexpot,snapshot,dima1995,asthma,thetruth,ducky,blender,priyanka,gaucho,dutchman,sizzle,kakarot,651550,passcode,justinbieber,666333,elodie,sanjay,110442,alex01,lotus1,2300mj,lakshmi,zoomer,quake3,12349876,teapot,12345687,ramada,pennywis,striper,pilot1,chingon,optima,nudity,ethan1,euclid,beeline,loyola,biguns,zaq12345,bravo1,disney1,buffa,assmunch,vivid,6661313,wellingt,aqwzsx,madala11,9874123,sigmar,pictere,tiptop,bettyboop,dinero,tahiti,gregory1,bionic,speed1,fubar1,lexus1,denis1,hawthorn,saxman,suntzu,bernhard,dominika,camaro1,hunter12,balboa,bmw2002,seville,diablo1,vfhbyjxrf,1234abc,carling,lockerroom,punani,darth,baron1,vaness,1password,libido,picher,232425,karamba,futyn007,daydream,11001001,dragon123,friends1,bopper,rocky123,chooch,asslover,shimmer,riddler,openme,tugboat,sexy123,midori,gulnara,christo,swatch,laker,offroad,puddles,hackers,mannheim,manager1,horseman,roman1,dancer1,komputer,pictuers,nokia5130,ejaculation,lioness,123456y,evilone,nastenka,pushok,javie,lilman,3141592,mjolnir,toulouse,pussy2,bigworm,smoke420,fullback,extensa,dreamcast,belize,delboy,willie1,casablanca,csyjxtr,ricky1,bonghit,salvator,basher,pussylover,rosie1,963258741,vivitron,cobra427,meonly,armageddon,myfriend,zardoz,qwedsazxc,kraken,fzappa,starfox,333999,illmatic,capoeira,weenie,ramzes,freedom2,toasty,pupkin,shinigami,fhvfutljy,nocturne,churchil,thumbnils,tailgate,neworder,sexymama,goarmy,cerebus,michelle1,vbifyz,surfsup,earthlin,dabulls,basketbal,aligator,mojojojo,saibaba,welcome2,wifes,wdtnjr,12345w,slasher,papabear,terran,footman,hocke,153759,texans,tom123,sfgiants,billabong,aassdd,monolith,xxx777,l3tm31n,ticktock,newone,hellno,japanees,contortionist,admin123,scout1,alabama1,divx1,rochard,privat,radar1,bigdad,fhctybq,tortuga,citrus,avanti,fantasy1,woodstock,s12345,fireman1,embalmer,woodwork,bonzai,konyor,newstart,jigga,panorama,goats,smithy,rugrats,hotmama,daedalus,nonstop,fruitbat,lisenok,quaker,violator,12345123,my3sons,cajun,fraggle,gayboy,oldfart,vulva,knickerless,orgasms,undertow,binky,litle,kfcnjxrf,masturbation,bunnie,alexis1,planner,transexual,sparty,leeloo,monies,fozzie,stinger1,landrove,anakonda,scoobie,yamaha1,henti,star12,rfhlbyfk,beyonce,catfood,cjytxrf,zealots,strat,fordtruc,archangel,silvi,sativa,boogers,miles1,bigjoe,tulip,petite,greentea,shitter,jonboy,voltron,morticia,evanescence,3edc4rfv,longshot,windows1,serge,aabbcc,starbucks,sinful,drywall,prelude1,www123,camel1,homebrew,marlins,123412,letmeinn,domini,swampy,plokij,fordf350,webcam,michele1,bolivi,27731828,wingzero,qawsedrftg,shinji,sverige,jasper1,piper1,cummer,iiyama,gocats,amour,alfarome,jumanji,mike69,fantasti,1monkey,w00t88,shawn1,lorien,1a2s3d4f5g,koleso,murph,natascha,sunkist,kennwort,emine,grinder,m12345,q1q2q3q4,cheeba,money2,qazwsxedc1,diamante,prosto,pdiddy,stinky1,gabby1,luckys,franci,pornographic,moochie,gfhjdjp,samdog,empire1,comicbookdb,emili,motdepasse,iphone,braveheart,reeses,nebula,sanjose,bubba2,kickflip,arcangel,superbow,porsche911,xyzzy,nigger1,dagobert,devil1,alatam,monkey2,barbara1,12345v,vfpfafrf,alessio,babemagn,aceman,arrakis,kavkaz,987789,jasons,berserk,sublime1,rogue1,myspace,buckwhea,csyekz,pussy4me,vette1,boots1,boingo,arnaud,budlite,redstorm,paramore,becky1,imtheman,chango,marley1,milkyway,666555,giveme,mahalo,lux2000,lucian,paddy,praxis,shimano,bigpenis,creeper,newproject2004,rammstei,j3qq4h7h2v,hfljcnm,lambchop,anthony2,bugman,gfhjkm12,dreamer1,stooges,cybersex,diamant,cowboyup,maximus1,sentra,615243,goethe,manhatta,fastcar,selmer,1213141516,yfnfitymrf,denni,chewey,yankee1,elektra,123456789p,trousers,fishface,topspin,orwell,vorona,sodapop,motherfu,ibilltes,forall,kookie,ronald1,balrog,maximilian,mypasswo,sonny1,zzxxcc,tkfkdg,magoo,mdogg,heeled,gitara,lesbos,marajade,tippy,morozova,enter123,lesbean,pounded,asd456,fialka,scarab,sharpie,spanky1,gstring,sachin,12345asd,princeto,hellohel,ursitesux,billows,1234kekc,kombat,cashew,duracell,kseniya,sevenof9,kostik,arthur1,corvet07,rdfhnbhf,songoku,tiberian,needforspeed,1qwert,dropkick,kevin123,panache,libra,a123456a,kjiflm,vfhnsirf,cntgfy,iamcool,narut,buffer,sk8ordie,urlaub,fireblade,blanked,marishka,gemini1,altec,gorillaz,chief1,revival47,ironman1,space1,ramstein,doorknob,devilmaycry,nemesis1,sosiska,pennstat,monday1,pioner,shevchenko,detectiv,evildead,blessed1,aggie,coffees,tical,scotts,bullwink,marsel,krypto,adrock,rjitxrf,asmodeus,rapunzel,theboys,hotdogs,deepthro,maxpayne,veronic,fyyeirf,otter,cheste,abbey1,thanos,bedrock,bartok,google1,xxxzzz,rodent,montecarlo,hernande,mikayla,123456789l,bravehea,12locked,ltymub,pegasus1,ameteur,saltydog,faisal,milfnew,momsuck,everques,ytngfhjkz,m0nkey,businessbabe,cooki,custard,123456ab,lbvjxrf,outlaws,753357,qwerty78,udacha,insider,chees,fuckmehard,shotokan,katya,seahorse,vtldtlm,turtle1,mike12,beebop,heathe,everton1,darknes,barnie,rbcekz,alisher,toohot,theduke,555222,reddog1,breezy,bulldawg,monkeyman,baylee,losangel,mastermi,apollo1,aurelie,zxcvb12345,cayenne,bastet,wsxzaq,geibcnbr,yello,fucmy69,redwall,ladybird,bitchs,cccccc1,rktjgfnhf,ghjdthrf,quest1,oedipus,linus,impalass,fartman,12345k,fokker,159753a,optiplex,bbbbbb1,realtor,slipkno,santacru,rowdy,jelena,smeller,3984240,ddddd1,sexyme,janet1,3698741,eatme69,cazzone,today1,poobear,ignatius,master123,newpass1,heather2,snoopdogg,blondinka,pass12,honeydew,fuckthat,890098890,lovem,goldrush,gecko,biker1,llama,pendejo,avalanche,fremont,snowman1,gandolf,chowder,1a2b3c4d5e,flyguy,magadan,1fuck,pingvin,nokia5230,ab1234,lothar,lasers,bignuts,renee1,royboy,skynet,12340987,1122334,dragrace,lovely1,22334455,booter,12345612,corvett,123456qq,capital1,videoes,funtik,wyvern,flange,sammydog,hulkster,13245768,not4you,vorlon,omegared,l58jkdjp!,filippo,123mudar,samadams,petrus,chris12,charlie123,123456789123,icetea,sunderla,adrian1,123qweas,kazanova,aslan,monkey123,fktyeirf,goodsex,123ab,lbtest,banaan,bluenose,837519,asd12345,waffenss,whateve,1a2a3a4a,trailers,vfhbirf,bhbcrf,klaatu,turk182,monsoon,beachbum,sunbeam,succes,clyde1,viking1,rawhide,bubblegum,princ,mackenzi,hershey1,222555,dima55,niggaz,manatee,aquila,anechka,pamel,bugsbunn,lovel,sestra,newport1,althor,hornyman,wakeup,zzz111,phishy,cerber,torrent,thething,solnishko,babel,buckeye1,peanu,ethernet,uncencored,baraka,665544,chris2,rb26dett,willy1,choppers,texaco,biggirl,123456b,anna2614,sukebe,caralho,callofduty,rt6ytere,jesus7,angel12,1money,timelord,allblack,pavlova,romanov,tequiero,yitbos,lookup,bulls23,snowflake,dickweed,barks,lever,irisha,firestar,fred1234,ghjnjnbg,danman,gatito,betty1,milhouse,kbctyjr,masterbaiting,delsol,papit,doggys,123698741,bdfyjdf,invictus,bloods,kayla1,yourmama,apple2,angelok,bigboy1,pontiac1,verygood,yeshua,twins2,porn4me,141516,rasta69,james2,bosshog,candys,adventur,stripe,djkjlz,dokken,austin316,skins,hogwarts,vbhevbh,navigato,desperado,xxx666,cneltyn,vasiliy,hazmat,daytek,eightbal,fred1,four20,74227422,fabia,aerosmith,manue,wingchun,boohoo,hombre,sanity72,goatboy,fuckm,partizan,avrora,utahjazz,submarin,pussyeat,heinlein,control1,costaric,smarty,chuan,triplets,snowy,snafu,teacher1,vangogh,vandal,evergree,cochise,qwerty99,pyramid1,saab900,sniffer,qaz741,lebron23,mark123,wolvie,blackbelt,yoshi,feeder,janeway,nutella,fuking,asscock,deepak,poppie,bigshow,housewife,grils,tonto,cynthia1,temptress,irakli,belle1,russell1,manders,frank123,seabass,gforce,songbird,zippy1,naught,brenda1,chewy1,hotshit,topaz,43046721,girfriend,marinka,jakester,thatsme,planeta,falstaff,patrizia,reborn,riptide,cherry1,shuan,nogard,chino,oasis1,qwaszx12,goodlife,davis1,1911a1,harrys,shitfuck,12345678900,russian7,007700,bulls1,porshe,danil,dolphi,river1,sabaka,gobigred,deborah1,volkswagen,miamo,alkaline,muffdive,1letmein,fkbyrf,goodguy,hallo1,nirvan,ozzie,cannonda,cvbhyjdf,marmite,germany1,joeblow,radio1,love11,raindrop,159852,jacko,newday,fathead,elvis123,caspe,citibank,sports1,deuce,boxter,fakepass,golfman,snowdog,birthday4,nonmembe,niklas,parsifal,krasota,theshit,1235813,maganda,nikita1,omicron,cassie1,columbo,buick,sigma1,thistle,bassin,rickster,apteka,sienna,skulls,miamor,coolgirl,gravis,1qazxc,virgini,hunter2,akasha,batma,motorcyc,bambino,tenerife,fordf250,zhuan,iloveporn,markiza,hotbabes,becool,fynjybyf,wapapapa,forme,mamont,pizda,dragonz,sharon1,scrooge,mrbill,pfloyd,leeroy,natedog,ishmael,777111,tecumseh,carajo,nfy.irf,0000000000o,blackcock,fedorov,antigone,feanor,novikova,bobert,peregrin,spartan117,pumkin,rayman,manuals,tooltime,555333,bonethug,marina1,bonnie1,tonyhawk,laracroft,mahalkita,18273645,terriers,gamer,hoser,littlema,molotok,glennwei,lemon1,caboose,tater,12345654321,brians,fritz1,mistral,jigsaw,fuckshit,hornyguy,southside,edthom,antonio1,bobmarle,pitures,ilikesex,crafty,nexus,boarder,fulcrum,astonvil,yanks1,yngwie,account1,zooropa,hotlegs,sammi,gumbo,rover1,perkele,maurolarastefy,lampard,357753,barracud,dmband,abcxyz,pathfinder,335577,yuliya,micky,jayman,asdfg12345,1596321,halcyon,rerfhtre,feniks,zaxscd,gotyoass,jaycee,samson1,jamesb,vibrate,grandpri,camino,colossus,davidb,mamo4ka,nicky1,homer123,pinguin,watermelon,shadow01,lasttime,glider,823762,helen1,pyramids,tulane,osama,rostov,john12,scoote,bhbyrf,gohan,galeries,joyful,bigpussy,tonka,mowgli,astalavista,zzz123,leafs,dalejr8,unicorn1,777000,primal,bigmama,okmijn,killzone,qaz12345,snookie,zxcvvcxz,davidc,epson,rockman,ceaser,beanbag,katten,3151020,duckhunt,segreto,matros,ragnar,699669,sexsexse,123123z,fuckyeah,bigbutts,gbcmrf,element1,marketin,saratov,elbereth,blaster1,yamahar6,grime,masha,juneau,1230123,pappy,lindsay1,mooner,seattle1,katzen,lucent,polly1,lagwagon,pixie,misiaczek,666666a,smokedog,lakers24,eyeball,ironhors,ametuer,volkodav,vepsrf,kimmy,gumby1,poi098,ovation,1q2w3,drinker,penetrating,summertime,1dallas,prima,modles,takamine,hardwork,macintosh,tahoe,passthie,chiks,sundown,flowers1,boromir,music123,phaedrus,albert1,joung,malakas,gulliver,parker1,balder,sonne,jessie1,domainlock2005,express1,vfkbyf,youandme,raketa,koala,dhjnvytyjub,nhfrnjh,testibil,ybrbnjc,987654321q,axeman,pintail,pokemon123,dogggg,shandy,thesaint,11122233,x72jhhu3z,theclash,raptors,zappa1,djdjxrf,hell666,friday1,vivaldi,pluto1,lance1,guesswho,jeadmi,corgan,skillz,skippy1,mango1,gymnastic,satori,362514,theedge,cxfcnkbdfz,sparkey,deicide,bagels,lololol,lemmings,r4e3w2q1,silve,staind,schnuffi,dazzle,basebal1,leroy1,bilbo1,luckie,qwerty2,goodfell,hermione,peaceout,davidoff,yesterda,killah,flippy,chrisb,zelda1,headless,muttley,fuckof,tittys,catdaddy,photog,beeker,reaver,ram1500,yorktown,bolero,tryagain,arman,chicco,learjet,alexei,jenna1,go2hell,12s3t4p55,momsanaladventure,mustang9,protoss,rooter,ginola,dingo1,mojave,erica1,1qazse4,marvin1,redwolf,sunbird,dangerou,maciek,girsl,hawks1,packard1,excellen,dashka,soleda,toonces,acetate,nacked,jbond007,alligator,debbie1,wellhung,monkeyma,supers,rigger,larsson,vaseline,rjnzhf,maripos,123456asd,cbr600rr,doggydog,cronic,jason123,trekker,flipmode,druid,sonyvaio,dodges,mayfair,mystuff,fun4me,samanta,sofiya,magics,1ranger,arcane,sixtynin,222444,omerta,luscious,gbyudby,bobcats,envision,chance1,seaweed,holdem,tomate,mensch,slicer,acura1,goochi,qweewq,punter,repoman,tomboy,never1,cortina,gomets,147896321,369852147,dogma,bhjxrf,loglatin,eragon,strato,gazelle,growler,885522,klaudia,payton34,fuckem,butchie,scorpi,lugano,123456789k,nichola,chipper1,spide,uhbujhbq,rsalinas,vfylfhby,longhorns,bugatti,everquest,!qaz2wsx,blackass,999111,snakeman,p455w0rd,fanatic,family1,pfqxbr,777vlad,mysecret,marat,phoenix2,october1,genghis,panties1,cooker,citron,ace123,1234569,gramps,blackcoc,kodiak1,hickory,ivanhoe,blackboy,escher,sincity,beaks,meandyou,spaniel,canon1,timmy1,lancaste,polaroid,edinburg,fuckedup,hotman,cueball,golfclub,gopack,bookcase,worldcup,dkflbvbhjdbx,twostep,17171717aa,letsplay,zolushka,stella1,pfkegf,kingtut,67camaro,barracuda,wiggles,gjhjkm,prancer,patata,kjifhf,theman1,romanova,sexyass,copper1,dobber,sokolov,pomidor,algernon,cadman,amoremio,william2,silly1,bobbys,hercule,hd764nw5d7e1vb1,defcon,deutschland,robinhood,alfalfa,machoman,lesbens,pandora1,easypay,tomservo,nadezhda,goonies,saab9000,jordyn,f15eagle,dbrecz,12qwerty,greatsex,thrawn,blunted,baywatch,doggystyle,loloxx,chevy2,january1,kodak,bushel,78963214,ub6ib9,zz8807zpl,briefs,hawker,224488,first1,bonzo,brent1,erasure,69213124,sidewind,soccer13,622521,mentos,kolibri,onepiece,united1,ponyboy,keksa12,wayer,mypussy,andrej,mischa,mille,bruno123,garter,bigpun,talgat,familia,jazzy1,mustang8,newjob,747400,bobber,blackbel,hatteras,ginge,asdfjkl;,camelot1,blue44,rebbyt34,ebony1,vegas123,myboys,aleksander,ijrjkflrf,lopata,pilsner,lotus123,m0nk3y,andreev,freiheit,balls1,drjynfrnt,mazda1,waterpolo,shibumi,852963,123bbb,cezer121,blondie1,volkova,rattler,kleenex,ben123,sanane,happydog,satellit,qazplm,qazwsxedcrfvtgb,meowmix,badguy,facefuck,spice1,blondy,major1,25000,anna123,654321a,sober1,deathrow,patterso,china1,naruto1,hawkeye1,waldo1,butchy,crayon,5tgb6yhn,klopik,crocodil,mothra,imhorny,pookie1,splatter,slippy,lizard1,router,buratino,yahweh,123698,dragon11,123qwe456,peepers,trucker1,ganjaman,1hxboqg2,cheyanne,storys,sebastie,zztop,maddison,4rfv3edc,darthvader,jeffro,iloveit,victor1,hotty,delphin,lifeisgood,gooseman,shifty,insertions,dude123,abrupt,123masha,boogaloo,chronos,stamford,pimpster,kthjxrf,getmein,amidala,flubber,fettish,grapeape,dantes,oralsex,jack1,foxcg33,winchest,francis1,getin,archon,cliffy,blueman,1basebal,sport1,emmitt22,porn123,bignasty,morga,123hfjdk147,ferrar,juanito,fabiol,caseydog,steveo,peternorth,paroll,kimchi,bootleg,gaijin,secre,acacia,eatme2,amarillo,monkey11,rfhfgep,tylers,a1a2a3a4a5,sweetass,blower,rodina,babushka,camilo,cimbom,tiffan,vfnbkmlf,ohbaby,gotigers,lindsey1,dragon13,romulus,qazxsw12,zxcvbn1,dropdead,hitman47,snuggle,eleven11,bloopers,357mag,avangard,bmw320,ginscoot,dshade,masterkey,voodoo1,rootedit,caramba,leahcim,hannover,8phrowz622,tim123,cassius,000000a,angelito,zzzzz1,badkarma,star1,malaga,glenwood,footlove,golf1,summer12,helpme1,fastcars,titan1,police1,polinka,k.jdm,marusya,augusto,shiraz,pantyhose,donald1,blaise,arabella,brigada,c3por2d2,peter01,marco1,hellow,dillweed,uzumymw,geraldin,loveyou2,toyota1,088011,gophers,indy500,slainte,5hsu75kpot,teejay,renat,racoon,sabrin,angie1,shiznit,harpua,sexyred,latex,tucker1,alexandru,wahoo,teamwork,deepblue,goodison,rundmc,r2d2c3p0,puppys,samba,ayrton,boobed,999777,topsecre,blowme1,123321z,loudog,random1,pantie,drevil,mandolin,121212q,hottub,brother1,failsafe,spade1,matvey,open1234,carmen1,priscill,schatzi,kajak,gooddog,trojans1,gordon1,kayak,calamity,argent,ufhvjybz,seviyi,penfold,assface,dildos,hawkwind,crowbar,yanks,ruffles,rastus,luv2epus,open123,aquafina,dawns,jared1,teufel,12345c,vwgolf,pepsi123,amores,passwerd,01478520,boliva,smutty,headshot,password3,davidd,zydfhm,gbgbcmrf,pornpass,insertion,ceckbr,test2,car123,checkit,dbnfkbq,niggas,nyyankee,muskrat,nbuhtyjr,gunner1,ocean1,fabienne,chrissy1,wendys,loveme89,batgirl,cerveza,igorek,steel1,ragman,boris123,novifarm,sexy12,qwerty777,mike01,giveitup,123456abc,fuckall,crevice,hackerz,gspot,eight8,assassins,texass,swallows,123458,baldur,moonshine,labatt,modem,sydney1,voland,dbnfkz,hotchick,jacker,princessa,dawgs1,holiday1,booper,reliant,miranda1,jamaica1,andre1,badnaamhere,barnaby,tiger7,david12,margaux,corsica,085tzzqi,universi,thewall,nevermor,martin6,qwerty77,cipher,apples1,0102030405,seraphim,black123,imzadi,gandon,ducati99,1shadow,dkflbvbhjdyf,44magnum,bigbad,feedme,samantha1,ultraman,redneck1,jackdog,usmc0311,fresh1,monique1,tigre,alphaman,cool1,greyhoun,indycar,crunchy,55chevy,carefree,willow1,063dyjuy,xrated,assclown,federica,hilfiger,trivia,bronco1,mamita,100200300,simcity,lexingky,akatsuki,retsam,johndeere,abudfv,raster,elgato,businka,satanas,mattingl,redwing1,shamil,patate,mannn,moonstar,evil666,b123456,bowl300,tanechka,34523452,carthage,babygir,santino,bondarenko,jesuss,chico1,numlock,shyguy,sound1,kirby1,needit,mostwanted,427900,funky1,steve123,passions,anduril,kermit1,prospero,lusty,barakuda,dream1,broodwar,porky,christy1,mahal,yyyyyy1,allan1,1sexy,flintsto,capri,cumeater,heretic,robert2,hippos,blindax,marykay,collecti,kasumi,1qaz!qaz,112233q,123258,chemistr,coolboy,0o9i8u,kabuki,righton,tigress,nessie,sergej,andrew12,yfafyz,ytrhjvfyn,angel7,victo,mobbdeep,lemming,transfor,1725782,myhouse,aeynbr,muskie,leno4ka,westham1,cvbhyjd,daffodil,pussylicker,pamela1,stuffer,warehous,tinker1,2w3e4r,pluton,louise1,polarbea,253634,prime1,anatoliy,januar,wysiwyg,cobraya,ralphy,whaler,xterra,cableguy,112233a,porn69,jamesd,aqualung,jimmy123,lumpy,luckyman,kingsize,golfing1,alpha7,leeds1,marigold,lol1234,teabag,alex11,10sne1,saopaulo,shanny,roland1,basser,3216732167,carol1,year2005,morozov,saturn1,joseluis,bushed,redrock,memnoch,lalaland,indiana1,lovegod,gulnaz,buffalos,loveyou1,anteater,pattaya,jaydee,redshift,bartek,summerti,coffee1,ricochet,incest,schastie,rakkaus,h2opolo,suikoden,perro,dance1,loveme1,whoopass,vladvlad,boober,flyers1,alessia,gfcgjhn,pipers,papaya,gunsling,coolone,blackie1,gonads,gfhjkzytn,foxhound,qwert12,gangrel,ghjvtntq,bluedevi,mywife,summer01,hangman,licorice,patter,vfr750,thorsten,515253,ninguna,dakine,strange1,mexic,vergeten,12345432,8phrowz624,stampede,floyd1,sailfish,raziel,ananda,giacomo,freeme,crfprf,74185296,allstars,master01,solrac,gfnhbjn,bayliner,bmw525,3465xxx,catter,single1,michael3,pentium4,nitrox,mapet123456,halibut,killroy,xxxxx1,phillip1,poopsie,arsenalfc,buffys,kosova,all4me,32165498,arslan,opensesame,brutis,charles2,pochta,nadegda,backspac,mustang0,invis,gogeta,654321q,adam25,niceday,truckin,gfdkbr,biceps,sceptre,bigdave,lauras,user345,sandys,shabba,ratdog,cristiano,natha,march13,gumball,getsdown,wasdwasd,redhead1,dddddd1,longlegs,13572468,starsky,ducksoup,bunnys,omsairam,whoami,fred123,danmark,flapper,swanky,lakings,yfhenj,asterios,rainier,searcher,dapper,ltdjxrf,horsey,seahawk,shroom,tkfkdgo,aquaman,tashkent,number9,messi10,1asshole,milenium,illumina,vegita,jodeci,buster01,bareback,goldfinger,fire1,33rjhjds,sabian,thinkpad,smooth1,sully,bonghits,sushi1,magnavox,colombi,voiture,limpone,oldone,aruba,rooster1,zhenya,nomar5,touchdow,limpbizkit,rhfcfdxbr,baphomet,afrodita,bball1,madiso,ladles,lovefeet,matthew2,theworld,thunderbird,dolly1,123rrr,forklift,alfons,berkut,speedy1,saphire,oilman,creatine,pussylov,bastard1,456258,wicked1,filimon,skyline1,fucing,yfnfkbz,hot123,abdulla,nippon,nolimits,billiard,booty1,buttplug,westlife,coolbean,aloha1,lopas,asasin,1212121,october2,whodat,good4u,d12345,kostas,ilya1992,regal,pioneer1,volodya,focus1,bastos,nbvjif,fenix,anita1,vadimka,nickle,jesusc,123321456,teste,christ1,essendon,evgenii,celticfc,adam1,forumwp,lovesme,26exkp,chillout,burly,thelast1,marcus1,metalgear,test11,ronaldo7,socrate,world1,franki,mommie,vicecity,postov1000,charlie3,oldschool,333221,legoland,antoshka,counterstrike,buggy,mustang3,123454,qwertzui,toons,chesty,bigtoe,tigger12,limpopo,rerehepf,diddle,nokia3250,solidsnake,conan1,rockroll,963369,titanic1,qwezxc,cloggy,prashant,katharin,maxfli,takashi,cumonme,michael9,mymother,pennstate,khalid,48151623,fightclub,showboat,mateusz,elrond,teenie,arrow1,mammamia,dustydog,dominator,erasmus,zxcvb1,1a2a3a,bones1,dennis1,galaxie,pleaseme,whatever1,junkyard,galadriel,charlies,2wsxzaq1,crimson1,behemoth,teres,master11,fairway,shady1,pass99,1batman,joshua12,baraban,apelsin,mousepad,melon,twodogs,123321qwe,metalica,ryjgrf,pipiska,rerfhfxf,lugnut,cretin,iloveu2,powerade,aaaaaaa1,omanko,kovalenko,isabe,chobits,151nxjmt,shadow11,zcxfcnkbdf,gy3yt2rgls,vfhbyrf,159753123,bladerunner,goodone,wonton,doodie,333666999,fuckyou123,kitty123,chisox,orlando1,skateboa,red12345,destroye,snoogans,satan1,juancarlo,goheels,jetson,scottt,fuckup,aleksa,gfhfljrc,passfind,oscar123,derrick1,hateme,viper123,pieman,audi100,tuffy,andover,shooter1,10000,makarov,grant1,nighthaw,13576479,browneye,batigol,nfvfhf,chocolate1,7hrdnw23,petter,bantam,morlii,jediknight,brenden,argonaut,goodstuf,wisconsi,315920,abigail1,dirtbag,splurge,k123456,lucky777,valdepen,gsxr600,322223,ghjnjrjk,zaq1xsw2cde3,schwanz,walter1,letmein22,nomads,124356,codeblue,nokian70,fucke,footbal1,agyvorc,aztecs,passw0r,smuggles,femmes,ballgag,krasnodar,tamuna,schule,sixtynine,empires,erfolg,dvader,ladygaga,elite1,venezuel,nitrous,kochamcie,olivia1,trustn01,arioch,sting1,131415,tristar,555000,maroon,135799,marsik,555556,fomoco,natalka,cwoui,tartan,davecole,nosferat,hotsauce,dmitry,horus,dimasik,skazka,boss302,bluebear,vesper,ultras,tarantul,asd123asd,azteca,theflash,8ball,1footbal,titlover,lucas123,number6,sampson1,789852,party1,dragon99,adonai,carwash,metropol,psychnau,vthctltc,hounds,firework,blink18,145632,wildcat1,satchel,rice80,ghtktcnm,sailor1,cubano,anderso,rocks1,mike11,famili,dfghjc,besiktas,roygbiv,nikko,bethan,minotaur,rakesh,orange12,hfleuf,jackel,myangel,favorite7,1478520,asssss,agnieszka,haley1,raisin,htubyf,1buster,cfiekz,derevo,1a2a3a4a5a,baltika,raffles,scruffy1,clitlick,louis1,buddha1,fy.nrf,walker1,makoto,shadow2,redbeard,vfvfvskfhfve,mycock,sandydog,lineman,network1,favorite8,longdick,mustangg,mavericks,indica,1killer,cisco1,angelofwar,blue69,brianna1,bubbaa,slayer666,level42,baldrick,brutus1,lowdown,haribo,lovesexy,500000,thissuck,picker,stephy,1fuckme,characte,telecast,1bigdog,repytwjdf,thematrix,hammerhe,chucha,ganesha,gunsmoke,georgi,sheltie,1harley,knulla,sallas,westie,dragon7,conker,crappie,margosha,lisboa,3e2w1q,shrike,grifter,ghjcnjghjcnj,asdfg1,mnbvcxz1,myszka,posture,boggie,rocketman,flhtyfkby,twiztid,vostok,pi314159,force1,televizor,gtkmvtym,samhain,imcool,jadzia,dreamers,strannik,k2trix,steelhea,nikitin,commodor,brian123,chocobo,whopper,ibilljpf,megafon,ararat,thomas12,ghbrjkbcn,q1234567890,hibernia,kings1,jim123,redfive,68camaro,iawgk2,xavier1,1234567u,d123456,ndirish,airborn,halfmoon,fluffy1,ranchero,sneaker,soccer2,passion1,cowman,birthday1,johnn,razzle,glock17,wsxqaz,nubian,lucky2,jelly1,henderso,eric1,123123e,boscoe01,fuck0ff,simpson1,sassie,rjyjgkz,nascar3,watashi,loredana,janus,wilso,conman,david2,mothe,iloveher,snikers,davidj,fkmnthyfnbdf,mettss,ratfink,123456h,lostsoul,sweet16,brabus,wobble,petra1,fuckfest,otters,sable1,svetka,spartacu,bigstick,milashka,1lover,pasport,champagn,papichul,hrvatska,hondacivic,kevins,tacit,moneybag,gohogs,rasta1,246813579,ytyfdbcnm,gubber,darkmoon,vitaliy,233223,playboys,tristan1,joyce1,oriflame,mugwump,access2,autocad,thematri,qweqwe123,lolwut,ibill01,multisyn,1233211,pelikan,rob123,chacal,1234432,griffon,pooch,dagestan,geisha,satriani,anjali,rocketma,gixxer,pendrago,vincen,hellokit,killyou,ruger,doodah,bumblebe,badlands,galactic,emachines,foghorn,jackso,jerem,avgust,frontera,123369,daisymae,hornyboy,welcome123,tigger01,diabl,angel13,interex,iwantsex,rockydog,kukolka,sawdust,online1,3234412,bigpapa,jewboy,3263827,dave123,riches,333222,tony1,toggle,farter,124816,tities,balle,brasilia,southsid,micke,ghbdtn12,patit,ctdfcnjgjkm,olds442,zzzzzz1,nelso,gremlins,gypsy1,carter1,slut69,farcry,7415963,michael8,birdie1,charl,123456789abc,100001,aztec,sinjin,bigpimpi,closeup,atlas1,nvidia,doggone,classic1,manana,malcolm1,rfkbyf,hotbabe,rajesh,dimebag,ganjubas,rodion,jagr68,seren,syrinx,funnyman,karapuz,123456789n,bloomin,admin18533362,biggdogg,ocarina,poopy1,hellome,internet1,booties,blowjobs,matt1,donkey1,swede,1jennife,evgeniya,lfhbyf,coach1,444777,green12,patryk,pinewood,justin12,271828,89600506779,notredame,tuborg,lemond,sk8ter,million1,wowser,pablo1,st0n3,jeeves,funhouse,hiroshi,gobucs,angeleye,bereza,winter12,catalin,qazedc,andros,ramazan,vampyre,sweethea,imperium,murat,jamest,flossy,sandeep,morgen,salamandra,bigdogg,stroller,njdevils,nutsack,vittorio,%%passwo,playful,rjyatnrf,tookie,ubnfhf,michi,777444,shadow13,devils1,radiance,toshiba1,beluga,amormi,dandfa,trust1,killemall,smallville,polgara,billyb,landscap,steves,exploite,zamboni,damage11,dzxtckfd,trader12,pokey1,kobe08,damager,egorov,dragon88,ckfdbr,lisa69,blade2,audis4,nelson1,nibbles,23176djivanfros,mutabor,artofwar,matvei,metal666,hrfzlz,schwinn,poohbea,seven77,thinker,123456789qwerty,sobriety,jakers,karamelka,vbkfyf,volodin,iddqd,dale03,roberto1,lizaveta,qqqqqq1,cathy1,08154711,davidm,quixote,bluenote,tazdevil,katrina1,bigfoot1,bublik,marma,olechka,fatpussy,marduk,arina,nonrev67,qqqq1111,camill,wtpfhm,truffle,fairview,mashina,voltaire,qazxswedcvfr,dickface,grassy,lapdance,bosstone,crazy8,yackwin,mobil,danielit,mounta1n,player69,bluegill,mewtwo,reverb,cnthdf,pablito,a123321,elena1,warcraft1,orland,ilovemyself,rfntyjr,joyride,schoo,dthjxrf,thetachi,goodtimes,blacksun,humpty,chewbacca,guyute,123xyz,lexicon,blue45,qwe789,galatasaray,centrino,hendrix1,deimos,saturn5,craig1,vlad1996,sarah123,tupelo,ljrnjh,hotwife,bingos,1231231,nicholas1,flamer,pusher,1233210,heart1,hun999,jiggy,giddyup,oktober,123456zxc,budda,galahad,glamur,samwise,oneton,bugsbunny,dominic1,scooby2,freetime,internat,159753852,sc00ter,wantit,mazinger,inflames,laracrof,greedo,014789,godofwar,repytwjd,water123,fishnet,venus1,wallace1,tenpin,paula1,1475963,mania,novikov,qwertyasdfgh,goldmine,homies,777888999,8balls,holeinon,paper1,samael,013579,mansur,nikit,ak1234,blueline,polska1,hotcock,laredo,windstar,vbkbwbz,raider1,newworld,lfybkrf,catfish1,shorty1,piranha,treacle,royale,2234562,smurfs,minion,cadence,flapjack,123456p,sydne,135531,robinhoo,nasdaq,decatur,cyberonline,newage,gemstone,jabba,touchme,hooch,pigdog,indahous,fonzie,zebra1,juggle,patrick2,nihongo,hitomi,oldnavy,qwerfdsa,ukraina,shakti,allure,kingrich,diane1,canad,piramide,hottie1,clarion,college1,5641110,connect1,therion,clubber,velcro,dave1,astra1,13579-,astroboy,skittle,isgreat,photoes,cvzefh1gkc,001100,2cool4u,7555545,ginger12,2wsxcde3,camaro69,invader,domenow,asd1234,colgate,qwertasdfg,jack123,pass01,maxman,bronte,whkzyc,peter123,bogie,yecgaa,abc321,1qay2wsx,enfield,camaroz2,trashman,bonefish,system32,azsxdcfvgb,peterose,iwantyou,dick69,temp1234,blastoff,capa200,connie1,blazin,12233445,sexybaby,123456j,brentfor,pheasant,hommer,jerryg,thunders,august1,lager,kapusta,boobs1,nokia5300,rocco1,xytfu7,stars1,tugger,123sas,blingbling,1bubba,0wnsyo0,1george,baile,richard2,habana,1diamond,sensatio,1golfer,maverick1,1chris,clinton1,michael7,dragons1,sunrise1,pissant,fatim,mopar1,levani,rostik,pizzapie,987412365,oceans11,748159263,cum4me,palmetto,4r3e2w1q,paige1,muncher,arsehole,kratos,gaffer,banderas,billys,prakash,crabby,bungie,silver12,caddis,spawn1,xboxlive,sylvania,littlebi,524645,futura,valdemar,isacs155,prettygirl,big123,555444,slimer,chicke,newstyle,skypilot,sailormoon,fatluvr69,jetaime,sitruc,jesuschrist,sameer,bear12,hellion,yendor,country1,etnies,conejo,jedimast,darkknight,toobad,yxcvbn,snooks,porn4life,calvary,alfaromeo,ghostman,yannick,fnkfynblf,vatoloco,homebase,5550666,barret,1111111111zz,odysseus,edwardss,favre4,jerrys,crybaby,xsw21qaz,firestor,spanks,indians1,squish,kingair,babycakes,haters,sarahs,212223,teddyb,xfactor,cumload,rhapsody,death123,three3,raccoon,thomas2,slayer66,1q2q3q4q5q,thebes,mysterio,thirdeye,orkiox.,nodoubt,bugsy,schweiz,dima1996,angels1,darkwing,jeronimo,moonpie,ronaldo9,peaches2,mack10,manish,denise1,fellowes,carioca,taylor12,epaulson,makemoney,oc247ngucz,kochanie,3edcvfr4,vulture,1qw23e,1234567z,munchie,picard1,xthtgfirf,sportste,psycho1,tahoe1,creativ,perils,slurred,hermit,scoob,diesel1,cards1,wipeout,weeble,integra1,out3xf,powerpc,chrism,kalle,ariadne,kailua,phatty,dexter1,fordman,bungalow,paul123,compa,train1,thejoker,jys6wz,pussyeater,eatmee,sludge,dominus,denisa,tagheuer,yxcvbnm,bill1,ghfdlf,300zx,nikita123,carcass,semaj,ramone,muenchen,animal1,greeny,annemari,dbrf134,jeepcj7,mollys,garten,sashok,ironmaid,coyotes,astoria,george12,westcoast,primetim,123456o,panchito,rafae,japan1,framer,auralo,tooshort,egorova,qwerty22,callme,medicina,warhawk,w1w2w3w4,cristia,merli,alex22,kawaii,chatte,wargames,utvols,muaddib,trinket,andreas1,jjjjj1,cleric,scooters,cuntlick,gggggg1,slipknot1,235711,handcuff,stussy,guess1,leiceste,ppppp1,passe,lovegun,chevyman,hugecock,driver1,buttsex,psychnaut1,cyber1,black2,alpha12,melbourn,man123,metalman,yjdsqujl,blondi,bungee,freak1,stomper,caitlin1,nikitina,flyaway,prikol,begood,desperad,aurelius,john1234,whosyourdaddy,slimed123,bretagne,den123,hotwheel,king123,roodypoo,izzicam,save13tx,warpten,nokia3310,samolet,ready1,coopers,scott123,bonito,1aaaaa,yomomma,dawg1,rache,itworks,asecret,fencer,451236,polka,olivetti,sysadmin,zepplin,sanjuan,479373,lickem,hondacrx,pulamea,future1,naked1,sexyguy,w4g8at,lollol1,declan,runner1,rumple,daddy123,4snz9g,grandprix,calcio,whatthefuck,nagrom,asslick,pennst,negrit,squiggy,1223334444,police22,giovann,toronto1,tweet,yardbird,seagate,truckers,554455,scimitar,pescator,slydog,gaysex,dogfish,fuck777,12332112,qazxswed,morkovka,daniela1,imback,horny69,789123456,123456789w,jimmy2,bagger,ilove69,nikolaus,atdhfkm,rebirth,1111aaaa,pervasive,gjgeufq,dte4uw,gfhnbpfy,skeletor,whitney1,walkman,delorean,disco1,555888,as1234,ishikawa,fuck12,reaper1,dmitrii,bigshot,morrisse,purgen,qwer4321,itachi,willys,123123qwe,kisska,roma123,trafford,sk84life,326159487,pedros,idiom,plover,bebop,159875321,jailbird,arrowhea,qwaszx123,zaxscdvf,catlover,bakers,13579246,bones69,vermont1,helloyou,simeon,chevyz71,funguy,stargaze,parolparol,steph1,bubby,apathy,poppet,laxman,kelly123,goodnews,741236,boner1,gaetano,astonvilla,virtua,luckyboy,rocheste,hello2u,elohim,trigger1,cstrike,pepsicola,miroslav,96385274,fistfuck,cheval,magyar,svetlanka,lbfyjxrf,mamedov,123123123q,ronaldo1,scotty1,1nicole,pittbull,fredd,bbbbb1,dagwood,gfhkfvtyn,ghblehrb,logan5,1jordan,sexbomb,omega2,montauk,258741,dtythf,gibbon,winamp,thebomb,millerli,852654,gemin,baldy,halflife2,dragon22,mulberry,morrigan,hotel6,zorglub,surfin,951159,excell,arhangel,emachine,moses1,968574,reklama,bulldog2,cuties,barca,twingo,saber,elite11,redtruck,casablan,ashish,moneyy,pepper12,cnhtktw,rjcnbr,arschloch,phenix,cachorro,sunita,madoka,joselui,adams1,mymoney,hemicuda,fyutkjr,jake12,chicas,eeeee1,sonnyboy,smarties,birdy,kitten1,cnfcbr,island1,kurosaki,taekwond,konfetka,bennett1,omega3,jackson2,fresca,minako,octavian,kban667,feyenoord,muaythai,jakedog,fktrcfylhjdyf,1357911q,phuket,sexslave,fktrcfylhjdbx,asdfjk,89015173454,qwerty00,kindbud,eltoro,sex6969,nyknicks,12344321q,caballo,evenflow,hoddle,love22,metro1,mahalko,lawdog,tightass,manitou,buckie,whiskey1,anton123,335533,password4,primo,ramair,timbo,brayden,stewie,pedro1,yorkshir,ganster,hellothe,tippy1,direwolf,genesi,rodrig,enkeli,vaz21099,sorcerer,winky,oneshot,boggle,serebro,badger1,japanes,comicbook,kamehame,alcat,denis123,echo45,sexboy,gr8ful,hondo,voetbal,blue33,2112rush,geneviev,danni1,moosey,polkmn,matthew7,ironhead,hot2trot,ashley12,sweeper,imogen,blue21,retep,stealth1,guitarra,bernard1,tatian,frankfur,vfnhbwf,slacking,haha123,963741,asdasdas,katenok,airforce1,123456789qaz,shotgun1,12qwasz,reggie1,sharo,976431,pacifica,dhip6a,neptun,kardon,spooky1,beaut,555555a,toosweet,tiedup,11121314,startac,lover69,rediska,pirata,vfhrbp,1234qwerty,energize,hansolo1,playbo,larry123,oemdlg,cnjvfnjkju,a123123,alexan,gohawks,antonius,fcbayern,mambo,yummy1,kremlin,ellen1,tremere,vfiekz,bellevue,charlie9,izabella,malishka,fermat,rotterda,dawggy,becket,chasey,kramer1,21125150,lolit,cabrio,schlong,arisha,verity,3some,favorit,maricon,travelle,hotpants,red1234,garrett1,home123,knarf,seven777,figment,asdewq,canseco,good2go,warhol,thomas01,pionee,al9agd,panacea,chevy454,brazzers,oriole,azerty123,finalfan,patricio,northsta,rebelde,bulldo,stallone,boogie1,7uftyx,cfhfnjd,compusa,cornholi,config,deere,hoopster,sepultura,grasshop,babygurl,lesbo,diceman,proverbs,reddragon,nurbek,tigerwoo,superdup,buzzsaw,kakaroto,golgo13,edwar,123qaz123,butter1,sssss1,texas2,respekt,ou812ic,123456qaz,55555a,doctor1,mcgwire,maria123,aol999,cinders,aa1234,joness,ghbrjkmyj,makemone,sammyboy,567765,380zliki,theraven,testme,mylene,elvira26,indiglo,tiramisu,shannara,baby1,123666,gfhreh,papercut,johnmish,orange8,bogey1,mustang7,bagpipes,dimarik,vsijyjr,4637324,ravage,cogito,seven11,natashka,warzone,hr3ytm,4free,bigdee,000006,243462536,bigboi,123333,trouts,sandy123,szevasz,monica2,guderian,newlife1,ratchet,r12345,razorbac,12345i,piazza31,oddjob,beauty1,fffff1,anklet,nodrog,pepit,olivi,puravida,robert12,transam1,portman,bubbadog,steelers1,wilson1,eightball,mexico1,superboy,4rfv5tgb,mzepab,samurai1,fuckslut,colleen1,girdle,vfrcbvec,q1w2e3r4t,soldier1,19844891,alyssa1,a12345a,fidelis,skelter,nolove,mickeymouse,frehley,password69,watermel,aliska,soccer15,12345e,ladybug1,abulafia,adagio,tigerlil,takehana,hecate,bootneck,junfan,arigato,wonkette,bobby123,trustnoone,phantasm,132465798,brianjo,w12345,t34vfrc1991,deadeye,1robert,1daddy,adida,check1,grimlock,muffi,airwalk,prizrak,onclick,longbeac,ernie1,eadgbe,moore1,geniu,shadow123,bugaga,jonathan1,cjrjkjdf,orlova,buldog,talon1,westport,aenima,541233432442,barsuk,chicago2,kellys,hellbent,toughguy,iskander,skoal,whatisit,jake123,scooter2,fgjrfkbgcbc,ghandi,love13,adelphia,vjhrjdrf,adrenali,niunia,jemoeder,rainbo,all4u8,anime1,freedom7,seraph,789321,tommys,antman,firetruc,neogeo,natas,bmwm3,froggy1,paul1,mamit,bayview,gateways,kusanagi,ihateu,frederi,rock1,centurion,grizli,biggin,fish1,stalker1,3girls,ilovepor,klootzak,lollo,redsox04,kirill123,jake1,pampers,vasya,hammers1,teacup,towing,celtic1,ishtar,yingyang,4904s677075,dahc1,patriot1,patrick9,redbirds,doremi,rebecc,yoohoo,makarova,epiphone,rfgbnfy,milesd,blister,chelseafc,katana1,blackrose,1james,primrose,shock5,hard1,scooby12,c6h12o6,dustoff,boing,chisel,kamil,1william,defiant1,tyvugq,mp8o6d,aaa340,nafets,sonnet,flyhigh,242526,crewcom,love23,strike1,stairway,katusha,salamand,cupcake1,password0,007james,sunnie,multisync,harley01,tequila1,fred12,driver8,q8zo8wzq,hunter01,mozzer,temporar,eatmeraw,mrbrownxx,kailey,sycamore,flogger,tincup,rahasia,ganymede,bandera,slinger,1111122222,vander,woodys,1cowboy,khaled,jamies,london12,babyboo,tzpvaw,diogenes,budice,mavrick,135797531,cheeta,macros,squonk,blackber,topfuel,apache1,falcon16,darkjedi,cheeze,vfhvtkfl,sparco,change1,gfhfif,freestyl,kukuruza,loveme2,12345f,kozlov,sherpa,marbella,44445555,bocephus,1winner,alvar,hollydog,gonefish,iwantin,barman,godislove,amanda18,rfpfynbg,eugen,abcdef1,redhawk,thelema,spoonman,baller1,harry123,475869,tigerman,cdtnjxrf,marillio,scribble,elnino,carguy,hardhead,l2g7k3,troopers,selen,dragon76,antigua,ewtosi,ulysse,astana,paroli,cristo,carmex,marjan,bassfish,letitbe,kasparov,jay123,19933991,blue13,eyecandy,scribe,mylord,ukflbjkec,ellie1,beaver1,destro,neuken,halfpint,ameli,lilly1,satanic,xngwoj,12345trewq,asdf1,bulldogg,asakura,jesucrist,flipside,packers4,biggy,kadett,biteme69,bobdog,silverfo,saint1,bobbo,packman,knowledg,foolio,fussbal,12345g,kozerog,westcoas,minidisc,nbvcxw,martini1,alastair,rasengan,superbee,memento,porker,lena123,florenc,kakadu,bmw123,getalife,bigsky,monkee,people1,schlampe,red321,memyself,0147896325,12345678900987654321,soccer14,realdeal,gfgjxrf,bella123,juggs,doritos,celtics1,peterbilt,ghbdtnbrb,gnusmas,xcountry,ghbdtn1,batman99,deusex,gtnhjdf,blablabl,juster,marimba,love2,rerjkrf,alhambra,micros,siemens1,assmaste,moonie,dashadasha,atybrc,eeeeee1,wildrose,blue55,davidl,xrp23q,skyblue,leo123,ggggg1,bestfriend,franny,1234rmvb,fun123,rules1,sebastien,chester2,hakeem,winston2,fartripper,atlant,07831505,iluvsex,q1a2z3,larrys,009900,ghjkju,capitan,rider1,qazxsw21,belochka,andy123,hellya,chicca,maximal,juergen,password1234,howard1,quetzal,daniel123,qpwoeiruty,123555,bharat,ferrari3,numbnuts,savant,ladydog,phipsi,lovepussy,etoile,power2,mitten,britneys,chilidog,08522580,2fchbg,kinky1,bluerose,loulo,ricardo1,doqvq3,kswbdu,013cpfza,timoha,ghbdtnghbdtn,3stooges,gearhead,browns1,g00ber,super7,greenbud,kitty2,pootie,toolshed,gamers,coffe,ibill123,freelove,anasazi,sister1,jigger,natash,stacy1,weronika,luzern,soccer7,hoopla,dmoney,valerie1,canes,razdvatri,washere,greenwoo,rfhjkbyf,anselm,pkxe62,maribe,daniel2,maxim1,faceoff,carbine,xtkjdtr,buddy12,stratos,jumpman,buttocks,aqswdefr,pepsis,sonechka,steeler1,lanman,nietzsch,ballz,biscuit1,wrxsti,goodfood,juventu,federic,mattman,vika123,strelec,jledfyxbr,sideshow,4life,fredderf,bigwilly,12347890,12345671,sharik,bmw325i,fylhtqrf,dannon4,marky,mrhappy,drdoom,maddog1,pompier,cerbera,goobers,howler,jenny69,evely,letitrid,cthuttdyf,felip,shizzle,golf12,t123456,yamah,bluearmy,squishy,roxan,10inches,dollface,babygirl1,blacksta,kaneda,lexingto,canadien,222888,kukushka,sistema,224422,shadow69,ppspankp,mellons,barbie1,free4all,alfa156,lostone,2w3e4r5t,painkiller,robbie1,binger,8dihc6,jaspe,rellik,quark,sogood,hoopstar,number2,snowy1,dad2ownu,cresta,qwe123asd,hjvfyjdf,gibsonsg,qbg26i,dockers,grunge,duckling,lfiekz,cuntsoup,kasia1,1tigger,woaini,reksio,tmoney,firefighter,neuron,audia3,woogie,powerboo,powermac,fatcock,12345666,upnfmc,lustful,porn1,gotlove,amylee,kbytqrf,11924704,25251325,sarasota,sexme,ozzie1,berliner,nigga1,guatemal,seagulls,iloveyou!,chicken2,qwerty21,010203040506,1pillow,libby1,vodoley,backlash,piglets,teiubesc,019283,vonnegut,perico,thunde,buckey,gtxtymrf,manunite,iiiii1,lost4815162342,madonn,270873_,britney1,kevlar,piano1,boondock,colt1911,salamat,doma77ns,anuradha,cnhjqrf,rottweil,newmoon,topgun1,mauser,fightclu,birthday21,reviewpa,herons,aassddff,lakers32,melissa2,vredina,jiujitsu,mgoblue,shakey,moss84,12345zxcvb,funsex,benji1,garci,113322,chipie,windex,nokia5310,pwxd5x,bluemax,cosita,chalupa,trotsky,new123,g3ujwg,newguy,canabis,gnaget,happydays,felixx,1patrick,cumface,sparkie,kozlova,123234,newports,broncos7,golf18,recycle,hahah,harrypot,cachondo,open4me,miria,guessit,pepsione,knocker,usmc1775,countach,playe,wiking,landrover,cracksevi,drumline,a7777777,smile123,manzana,panty,liberta,pimp69,dolfan,quality1,schnee,superson,elaine22,webhompass,mrbrownx,deepsea,4wheel,mamasita,rockport,rollie,myhome,jordan12,kfvgjxrf,hockey12,seagrave,ford1,chelsea2,samsara,marissa1,lamesa,mobil1,piotrek,tommygun,yyyyy1,wesley1,billy123,homersim,julies,amanda12,shaka,maldini,suzenet,springst,iiiiii1,yakuza,111111aa,westwind,helpdesk,annamari,bringit,hopefull,hhhhhhh1,saywhat,mazdarx8,bulova,jennife1,baikal,gfhjkmxbr,victoria1,gizmo123,alex99,defjam,2girls,sandrock,positivo,shingo,syncmast,opensesa,silicone,fuckina,senna1,karlos,duffbeer,montagne,gehrig,thetick,pepino,hamburge,paramedic,scamp,smokeweed,fabregas,phantoms,venom121293,2583458,badone,porno69,manwhore,vfvf123,notagain,vbktyf,rfnthbyrf,wildblue,kelly001,dragon66,camell,curtis1,frolova,1212123,dothedew,tyler123,reddrago,planetx,promethe,gigolo,1001001,thisone,eugeni,blackshe,cruzazul,incognito,puller,joonas,quick1,spirit1,gazza,zealot,gordito,hotrod1,mitch1,pollito,hellcat,mythos,duluth,383pdjvl,easy123,hermos,binkie,its420,lovecraf,darien,romina,doraemon,19877891,syclone,hadoken,transpor,ichiro,intell,gargamel,dragon2,wavpzt,557744,rjw7x4,jennys,kickit,rjynfrn,likeit,555111,corvus,nec3520,133113,mookie1,bochum,samsung2,locoman0,154ugeiu,vfvfbgfgf,135792,[start],tenni,20001,vestax,hufmqw,neveragain,wizkid,kjgfnf,nokia6303,tristen,saltanat,louie1,gandalf2,sinfonia,alpha3,tolstoy,ford150,f00bar,1hello,alici,lol12,riker1,hellou,333888,1hunter,qw1234,vibrator,mets86,43211234,gonzale,cookies1,sissy1,john11,bubber,blue01,cup2006,gtkmvtyb,nazareth,heybaby,suresh,teddie,mozilla,rodeo1,madhouse,gamera,123123321,naresh,dominos,foxtrot1,taras,powerup,kipling,jasonb,fidget,galena,meatman,alpacino,bookmark,farting,humper,titsnass,gorgon,castaway,dianka,anutka,gecko1,fucklove,connery,wings1,erika1,peoria,moneymaker,ichabod,heaven1,paperboy,phaser,breakers,nurse1,westbrom,alex13,brendan1,123asd123,almera,grubber,clarkie,thisisme,welkom01,51051051051,crypto,freenet,pflybwf,black12,testme2,changeit,autobahn,attica,chaoss,denver1,tercel,gnasher23,master2,vasilii,sherman1,gomer,bigbuck,derek1,qwerzxcv,jumble,dragon23,art131313,numark,beasty,cxfcnmttcnm,updown,starion,glist,sxhq65,ranger99,monkey7,shifter,wolves1,4r5t6y,phone1,favorite5,skytommy,abracada,1martin,102030405060,gatech,giulio,blacktop,cheer1,africa1,grizzly1,inkjet,shemales,durango1,booner,11223344q,supergirl,vanyarespekt,dickless,srilanka,weaponx,6string,nashvill,spicey,boxer1,fabien,2sexy2ho,bowhunt,jerrylee,acrobat,tawnee,ulisse,nolimit8,l8g3bkde,pershing,gordo1,allover,gobrowns,123432,123444,321456987,spoon1,hhhhh1,sailing1,gardenia,teache,sexmachine,tratata,pirate1,niceone,jimbos,314159265,qsdfgh,bobbyy,ccccc1,carla1,vjkjltw,savana,biotech,frigid,123456789g,dragon10,yesiam,alpha06,oakwood,tooter,winsto,radioman,vavilon,asnaeb,google123,nariman,kellyb,dthyjcnm,password6,parol1,golf72,skate1,lthtdj,1234567890s,kennet,rossia,lindas,nataliya,perfecto,eminem1,kitana,aragorn1,rexona,arsenalf,planot,coope,testing123,timex,blackbox,bullhead,barbarian,dreamon,polaris1,cfvjktn,frdfhbev,gametime,slipknot666,nomad1,hfgcjlbz,happy69,fiddler,brazil1,joeboy,indianali,113355,obelisk,telemark,ghostrid,preston1,anonim,wellcome,verizon1,sayangku,censor,timeport,dummies,adult1,nbnfybr,donger,thales,iamgay,sexy1234,deadlift,pidaras,doroga,123qwe321,portuga,asdfgh12,happys,cadr14nu,pi3141,maksik,dribble,cortland,darken,stepanova,bommel,tropic,sochi2014,bluegras,shahid,merhaba,nacho,2580456,orange44,kongen,3cudjz,78girl,my3kids,marcopol,deadmeat,gabbie,saruman,jeepman,freddie1,katie123,master99,ronal,ballbag,centauri,killer7,xqgann,pinecone,jdeere,geirby,aceshigh,55832811,pepsimax,rayden,razor1,tallyho,ewelina,coldfire,florid,glotest,999333,sevenup,bluefin,limaperu,apostol,bobbins,charmed1,michelin,sundin,centaur,alphaone,christof,trial1,lions1,45645,just4you,starflee,vicki1,cougar1,green2,jellyfis,batman69,games1,hihje863,crazyzil,w0rm1,oklick,dogbite,yssup,sunstar,paprika,postov10,124578963,x24ik3,kanada,buckster,iloveamy,bear123,smiler,nx74205,ohiostat,spacey,bigbill,doudo,nikolaeva,hcleeb,sex666,mindy1,buster11,deacons,boness,njkcnsq,candy2,cracker1,turkey1,qwertyu1,gogreen,tazzzz,edgewise,ranger01,qwerty6,blazer1,arian,letmeinnow,cigar1,jjjjjj1,grigio,frien,tenchu,f9lmwd,imissyou,filipp,heathers,coolie,salem1,woodduck,scubadiv,123kat,raffaele,nikolaev,dapzu455,skooter,9inches,lthgfhjkm,gr8one,ffffff1,zujlrf,amanda69,gldmeo,m5wkqf,rfrltkf,televisi,bonjou,paleale,stuff1,cumalot,fuckmenow,climb7,mark1234,t26gn4,oneeye,george2,utyyflbq,hunting1,tracy71,ready2go,hotguy,accessno,charger1,rudedog,kmfdm,goober1,sweetie1,wtpmjgda,dimensio,ollie1,pickles1,hellraiser,mustdie,123zzz,99887766,stepanov,verdun,tokenbad,anatol,bartende,cidkid86,onkelz,timmie,mooseman,patch1,12345678c,marta1,dummy1,bethany1,myfamily,history1,178500,lsutiger,phydeaux,moren,dbrnjhjdbx,gnbxrf,uniden,drummers,abpbrf,godboy,daisy123,hogan1,ratpack,irland,tangerine,greddy,flore,sqrunch,billyjoe,q55555,clemson1,98745632,marios,ishot,angelin,access12,naruto12,lolly,scxakv,austin12,sallad,cool99,rockit,mongo1,mark22,ghbynth,ariadna,senha,docto,tyler2,mobius,hammarby,192168,anna12,claire1,pxx3eftp,secreto,greeneye,stjabn,baguvix,satana666,rhbcnbyjxrf,dallastx,garfiel,michaelj,1summer,montan,1234ab,filbert,squids,fastback,lyudmila,chucho,eagleone,kimberle,ar3yuk3,jake01,nokids,soccer22,1066ad,ballon,cheeto,review69,madeira,taylor2,sunny123,chubbs,lakeland,striker1,porche,qwertyu8,digiview,go1234,ferari,lovetits,aditya,minnow,green3,matman,cellphon,fortytwo,minni,pucara,69a20a,roman123,fuente,12e3e456,paul12,jacky,demian,littleman,jadakiss,vlad1997,franca,282860,midian,nunzio,xaccess2,colibri,jessica0,revilo,654456,harvey1,wolf1,macarena,corey1,husky1,arsen,milleniu,852147,crowes,redcat,combat123654,hugger,psalms,quixtar,ilovemom,toyot,ballss,ilovekim,serdar,james23,avenger1,serendip,malamute,nalgas,teflon,shagger,letmein6,vyjujnjxbt,assa1234,student1,dixiedog,gznybwf13,fuckass,aq1sw2de3,robroy,hosehead,sosa21,123345,ias100,teddy123,poppin,dgl70460,zanoza,farhan,quicksilver,1701d,tajmahal,depechemode,paulchen,angler,tommy2,recoil,megamanx,scarecro,nicole2,152535,rfvtgb,skunky,fatty1,saturno,wormwood,milwauke,udbwsk,sexlover,stefa,7bgiqk,gfnhbr,omar10,bratan,lbyfvj,slyfox,forest1,jambo,william3,tempus,solitari,lucydog,murzilka,qweasdzxc1,vehpbkrf,12312345,fixit,woobie,andre123,123456789x,lifter,zinaida,soccer17,andone,foxbat,torsten,apple12,teleport,123456i,leglover,bigcocks,vologda,dodger1,martyn,d6o8pm,naciona,eagleeye,maria6,rimshot,bentley1,octagon,barbos,masaki,gremio,siemen,s1107d,mujeres,bigtits1,cherr,saints1,mrpink,simran,ghzybr,ferrari2,secret12,tornado1,kocham,picolo,deneme,onelove1,rolan,fenster,1fuckyou,cabbie,pegaso,nastyboy,password5,aidana,mine2306,mike13,wetone,tigger69,ytreza,bondage1,myass,golova,tolik,happyboy,poilkj,nimda2k,rammer,rubies,hardcore1,jetset,hoops1,jlaudio,misskitt,1charlie,google12,theone1,phred,porsch,aalborg,luft4,charlie5,password7,gnosis,djgabbab,1daniel,vinny,borris,cumulus,member1,trogdor,darthmau,andrew2,ktjybl,relisys,kriste,rasta220,chgobndg,weener,qwerty66,fritter,followme,freeman1,ballen,blood1,peache,mariso,trevor1,biotch,gtfullam,chamonix,friendste,alligato,misha1,1soccer,18821221,venkat,superd,molotov,bongos,mpower,acun3t1x,dfcmrf,h4x3d,rfhfufylf,tigran,booyaa,plastic1,monstr,rfnhby,lookatme,anabolic,tiesto,simon123,soulman,canes1,skyking,tomcat1,madona,bassline,dasha123,tarheel1,dutch1,xsw23edc,qwerty123456789,imperator,slaveboy,bateau,paypal,house123,pentax,wolf666,drgonzo,perros,digger1,juninho,hellomoto,bladerun,zzzzzzz1,keebler,take8422,fffffff1,ginuwine,israe,caesar1,crack1,precious1,garand,magda1,zigazaga,321ewq,johnpaul,mama1234,iceman69,sanjeev,treeman,elric,rebell,1thunder,cochon,deamon,zoltan,straycat,uhbyuj,luvfur,mugsy,primer,wonder1,teetime,candycan,pfchfytw,fromage,gitler,salvatio,piggy1,23049307,zafira,chicky,sergeev,katze,bangers,andriy,jailbait,vaz2107,ghbhjlf,dbjktnnf,aqswde,zaratustra,asroma,1pepper,alyss,kkkkk1,ryan1,radish,cozumel,waterpol,pentium1,rosebowl,farmall,steinway,dbrekz,baranov,jkmuf,another1,chinacat,qqqqqqq1,hadrian,devilmaycry4,ratbag,teddy2,love21,pullings,packrat,robyn1,boobo,qw12er34,tribe1,rosey,celestia,nikkie,fortune12,olga123,danthema,gameon,vfrfhjys,dilshod,henry14,jenova,redblue,chimaera,pennywise,sokrates,danimal,qqaazz,fuaqz4,killer2,198200,tbone1,kolyan,wabbit,lewis1,maxtor,egoist,asdfas,spyglass,omegas,jack12,nikitka,esperanz,doozer,matematika,wwwww1,ssssss1,poiu0987,suchka,courtney1,gungho,alpha2,fktyjxrf,summer06,bud420,devildriver,heavyd,saracen,foucault,choclate,rjdfktyrj,goblue1,monaro,jmoney,dcpugh,efbcapa201,qqh92r,pepsicol,bbb747,ch5nmk,honeyb,beszoptad,tweeter,intheass,iseedeadpeople,123dan,89231243658s,farside1,findme,smiley1,55556666,sartre,ytcnjh,kacper,costarica,134679258,mikeys,nolimit9,vova123,withyou,5rxypn,love143,freebie,rescue1,203040,michael6,12monkey,redgreen,steff,itstime,naveen,good12345,acidrain,1dawg,miramar,playas,daddio,orion2,852741,studmuff,kobe24,senha123,stephe,mehmet,allalone,scarface1,helloworld,smith123,blueyes,vitali,memphis1,mybitch,colin1,159874,1dick,podaria,d6wnro,brahms,f3gh65,dfcbkmtd,xxxman,corran,ugejvp,qcfmtz,marusia,totem,arachnid,matrix2,antonell,fgntrf,zemfira,christos,surfing1,naruto123,plato1,56qhxs,madzia,vanille,043aaa,asq321,mutton,ohiostate,golde,cdznjckfd,rhfcysq,green5,elephan,superdog,jacqueli,bollock,lolitas,nick12,1orange,maplelea,july23,argento,waldorf,wolfer,pokemon12,zxcvbnmm,flicka,drexel,outlawz,harrie,atrain,juice2,falcons1,charlie6,19391945,tower1,dragon21,hotdamn,dirtyboy,love4ever,1ginger,thunder2,virgo1,alien1,bubblegu,4wwvte,123456789qqq,realtime,studio54,passss,vasilek,awsome,giorgia,bigbass,2002tii,sunghile,mosdef,simbas,count0,uwrl7c,summer05,lhepmz,ranger21,sugarbea,principe,5550123,tatanka,9638v,cheerios,majere,nomercy,jamesbond007,bh90210,7550055,jobber,karaganda,pongo,trickle,defamer,6chid8,1q2a3z,tuscan,nick123,.adgjm,loveyo,hobbes1,note1234,shootme,171819,loveporn,9788960,monty123,fabrice,macduff,monkey13,shadowfa,tweeker,hanna1,madball,telnet,loveu2,qwedcxzas,thatsit,vfhcbr,ptfe3xxp,gblfhfcs,ddddddd1,hakkinen,liverune,deathsta,misty123,suka123,recon1,inferno1,232629,polecat,sanibel,grouch,hitech,hamradio,rkfdbfnehf,vandam,nadin,fastlane,shlong,iddqdidkfa,ledzeppelin,sexyfeet,098123,stacey1,negras,roofing,lucifer1,ikarus,tgbyhn,melnik,barbaria,montego,twisted1,bigal1,jiggle,darkwolf,acerview,silvio,treetops,bishop1,iwanna,pornsite,happyme,gfccdjhl,114411,veritech,batterse,casey123,yhntgb,mailto,milli,guster,q12345678,coronet,sleuth,fuckmeha,armadill,kroshka,geordie,lastochka,pynchon,killall,tommy123,sasha1996,godslove,hikaru,clticic,cornbrea,vfkmdbyf,passmaster,123123123a,souris,nailer,diabolo,skipjack,martin12,hinata,mof6681,brookie,dogfight,johnso,karpov,326598,rfvbrflpt,travesti,caballer,galaxy1,wotan,antoha,art123,xakep1234,ricflair,pervert1,p00kie,ambulanc,santosh,berserker,larry33,bitch123,a987654321,dogstar,angel22,cjcbcrf,redhouse,toodles,gold123,hotspot,kennedy1,glock21,chosen1,schneide,mainman,taffy1,3ki42x,4zqauf,ranger2,4meonly,year2000,121212a,kfylsi,netzwerk,diese,picasso1,rerecz,225522,dastan,swimmer1,brooke1,blackbea,oneway,ruslana,dont4get,phidelt,chrisp,gjyxbr,xwing,kickme,shimmy,kimmy1,4815162342lost,qwerty5,fcporto,jazzbo,mierd,252627,basses,sr20det,00133,florin,howdy1,kryten,goshen,koufax,cichlid,imhotep,andyman,wrest666,saveme,dutchy,anonymou,semprini,siempre,mocha1,forest11,wildroid,aspen1,sesam,kfgekz,cbhbec,a55555,sigmanu,slash1,giggs11,vatech,marias,candy123,jericho1,kingme,123a123,drakula,cdjkjxm,mercur,oneman,hoseman,plumper,ilovehim,lancers,sergey1,takeshi,goodtogo,cranberr,ghjcnj123,harvick,qazxs,1972chev,horsesho,freedom3,letmein7,saitek,anguss,vfvfgfgfz,300000,elektro,toonporn,999111999q,mamuka,q9umoz,edelweis,subwoofer,bayside,disturbe,volition,lucky3,12345678z,3mpz4r,march1,atlantida,strekoza,seagrams,090909t,yy5rbfsc,jack1234,sammy12,sampras,mark12,eintrach,chaucer,lllll1,nochance,whitepower,197000,lbvekz,passer,torana,12345as,pallas,koolio,12qw34,nokia8800,findout,1thomas,mmmmm1,654987,mihaela,chinaman,superduper,donnas,ringo1,jeroen,gfdkjdf,professo,cdtnrf,tranmere,tanstaaf,himera,ukflbfnjh,667788,alex32,joschi,w123456,okidoki,flatline,papercli,super8,doris1,2good4u,4z34l0ts,pedigree,freeride,gsxr1100,wulfgar,benjie,ferdinan,king1,charlie7,djdxbr,fhntvbq,ripcurl,2wsx1qaz,kingsx,desade,sn00py,loveboat,rottie,evgesha,4money,dolittle,adgjmpt,buzzers,brett1,makita,123123qweqwe,rusalka,sluts1,123456e,jameson1,bigbaby,1z2z3z,ckjybr,love4u,fucker69,erhfbyf,jeanluc,farhad,fishfood,merkin,giant1,golf69,rfnfcnhjaf,camera1,stromb,smoothy,774411,nylon,juice1,rfn.irf,newyor,123456789t,marmot,star11,jennyff,jester1,hisashi,kumquat,alex777,helicopt,merkur,dehpye,cummin,zsmj2v,kristjan,april12,englan,honeypot,badgirls,uzumaki,keines,p12345,guita,quake1,duncan1,juicer,milkbone,hurtme,123456789b,qq123456789,schwein,p3wqaw,54132442,qwertyytrewq,andreeva,ruffryde,punkie,abfkrf,kristinka,anna1987,ooooo1,335533aa,umberto,amber123,456123789,456789123,beelch,manta,peeker,1112131415,3141592654,gipper,wrinkle5,katies,asd123456,james11,78n3s5af,michael0,daboss,jimmyb,hotdog1,david69,852123,blazed,sickan,eljefe,2n6wvq,gobills,rfhfcm,squeaker,cabowabo,luebri,karups,test01,melkor,angel777,smallvil,modano,olorin,4rkpkt,leslie1,koffie,shadows1,littleon,amiga1,topeka,summer20,asterix1,pitstop,aloysius,k12345,magazin,joker69,panocha,pass1word,1233214,ironpony,368ejhih,88keys,pizza123,sonali,57np39,quake2,1234567890qw,1020304,sword1,fynjif,abcde123,dfktyjr,rockys,grendel1,harley12,kokakola,super2,azathoth,lisa123,shelley1,girlss,ibragim,seven1,jeff24,1bigdick,dragan,autobot,t4nvp7,omega123,900000,hecnfv,889988,nitro1,doggie1,fatjoe,811pahc,tommyt,savage1,pallino,smitty1,jg3h4hfn,jamielee,1qazwsx,zx123456,machine1,asdfgh123,guinnes,789520,sharkman,jochen,legend1,sonic2,extreme1,dima12,photoman,123459876,nokian95,775533,vaz2109,april10,becks,repmvf,pooker,qwer12345,themaster,nabeel,monkey10,gogetit,hockey99,bbbbbbb1,zinedine,dolphin2,anelka,1superma,winter01,muggsy,horny2,669966,kuleshov,jesusis,calavera,bullet1,87t5hdf,sleepers,winkie,vespa,lightsab,carine,magister,1spider,shitbird,salavat,becca1,wc18c2,shirak,galactus,zaskar,barkley1,reshma,dogbreat,fullsail,asasa,boeder,12345ta,zxcvbnm12,lepton,elfquest,tony123,vkaxcs,savatage,sevilia1,badkitty,munkey,pebbles1,diciembr,qapmoc,gabriel2,1qa2ws3e,cbcmrb,welldone,nfyufh,kaizen,jack11,manisha,grommit,g12345,maverik,chessman,heythere,mixail,jjjjjjj1,sylvia1,fairmont,harve,skully,global1,youwish,pikachu1,badcat,zombie1,49527843,ultra1,redrider,offsprin,lovebird,153426,stymie,aq1sw2,sorrento,0000001,r3ady41t,webster1,95175,adam123,coonass,159487,slut1,gerasim,monkey99,slutwife,159963,1pass1page,hobiecat,bigtymer,all4you,maggie2,olamide,comcast1,infinit,bailee,vasileva,.ktxrf,asdfghjkl1,12345678912,setter,fuckyou7,nnagqx,lifesuck,draken,austi,feb2000,cable1,1234qwerasdf,hax0red,zxcv12,vlad7788,nosaj,lenovo,underpar,huskies1,lovegirl,feynman,suerte,babaloo,alskdjfhg,oldsmobi,bomber1,redrover,pupuce,methodman,phenom,cutegirl,countyli,gretsch,godisgood,bysunsu,hardhat,mironova,123qwe456rty,rusty123,salut,187211,555666777,11111z,mahesh,rjntyjxtr,br00klyn,dunce1,timebomb,bovine,makelove,littlee,shaven,rizwan,patrick7,42042042,bobbijo,rustem,buttmunc,dongle,tiger69,bluecat,blackhol,shirin,peaces,cherub,cubase,longwood,lotus7,gwju3g,bruin,pzaiu8,green11,uyxnyd,seventee,dragon5,tinkerbel,bluess,bomba,fedorova,joshua2,bodyshop,peluche,gbpacker,shelly1,d1i2m3a4,ghtpbltyn,talons,sergeevna,misato,chrisc,sexmeup,brend,olddog,davros,hazelnut,bridget1,hzze929b,readme,brethart,wild1,ghbdtnbr1,nortel,kinger,royal1,bucky1,allah1,drakkar,emyeuanh,gallaghe,hardtime,jocker,tanman,flavio,abcdef123,leviatha,squid1,skeet,sexse,123456x,mom4u4mm,lilred,djljktq,ocean11,cadaver,baxter1,808state,fighton,primavera,1andrew,moogle,limabean,goddess1,vitalya,blue56,258025,bullride,cicci,1234567d,connor1,gsxr11,oliveoil,leonard1,legsex,gavrik,rjnjgtc,mexicano,2bad4u,goodfellas,ornw6d,mancheste,hawkmoon,zlzfrh,schorsch,g9zns4,bashful,rossi46,stephie,rfhfntkm,sellout,123fuck,stewar1,solnze,00007,thor5200,compaq12,didit,bigdeal,hjlbyf,zebulon,wpf8eu,kamran,emanuele,197500,carvin,ozlq6qwm,3syqo15hil,pennys,epvjb6,asdfghjkl123,198000,nfbcbz,jazzer,asfnhg66,zoloft,albundy,aeiou,getlaid,planet1,gjkbyjxrf,alex2000,brianb,moveon,maggie11,eieio,vcradq,shaggy1,novartis,cocoloco,dunamis,554uzpad,sundrop,1qwertyu,alfie,feliks,briand,123www,red456,addams,fhntv1998,goodhead,theway,javaman,angel01,stratoca,lonsdale,15987532,bigpimpin,skater1,issue43,muffie,yasmina,slowride,crm114,sanity729,himmel,carolcox,bustanut,parabola,masterlo,computador,crackhea,dynastar,rockbott,doggysty,wantsome,bigten,gaelle,juicy1,alaska1,etower,sixnine,suntan,froggies,nokia7610,hunter11,njnets,alicante,buttons1,diosesamo,elizabeth1,chiron,trustnoo,amatuers,tinytim,mechta,sammy2,cthulu,trs8f7,poonam,m6cjy69u35,cookie12,blue25,jordans,santa1,kalinka,mikey123,lebedeva,12345689,kissss,queenbee,vjybnjh,ghostdog,cuckold,bearshare,rjcntyrj,alinochka,ghjcnjrdfibyj,aggie1,teens1,3qvqod,dauren,tonino,hpk2qc,iqzzt580,bears85,nascar88,theboy,njqcw4,masyanya,pn5jvw,intranet,lollone,shadow99,00096462,techie,cvtifhbrb,redeemed,gocanes,62717315,topman,intj3a,cobrajet,antivirus,whyme,berserke,ikilz083,airedale,brandon2,hopkig,johanna1,danil8098,gojira,arthu,vision1,pendragon,milen,chrissie,vampiro,mudder,chris22,blowme69,omega7,surfers,goterps,italy1,baseba11,diego1,gnatsum,birdies,semenov,joker123,zenit2011,wojtek,cab4ma99,watchmen,damia,forgotte,fdm7ed,strummer,freelanc,cingular,orange77,mcdonalds,vjhjpjdf,kariya,tombston,starlet,hawaii1,dantheman,megabyte,nbvjirf,anjing,ybrjkftdbx,hotmom,kazbek,pacific1,sashimi,asd12,coorslig,yvtte545,kitte,elysium,klimenko,cobblers,kamehameha,only4me,redriver,triforce,sidorov,vittoria,fredi,dank420,m1234567,fallout2,989244342a,crazy123,crapola,servus,volvos,1scooter,griffin1,autopass,ownzyou,deviant,george01,2kgwai,boeing74,simhrq,hermosa,hardcor,griffy,rolex1,hackme,cuddles1,master3,bujhtr,aaron123,popolo,blader,1sexyred,gerry1,cronos,ffvdj474,yeehaw,bob1234,carlos2,mike77,buckwheat,ramesh,acls2h,monster2,montess,11qq22ww,lazer,zx123456789,chimpy,masterch,sargon,lochness,archana,1234qwert,hbxfhl,sarahb,altoid,zxcvbn12,dakot,caterham,dolomite,chazz,r29hqq,longone,pericles,grand1,sherbert,eagle3,pudge,irontree,synapse,boome,nogood,summer2,pooki,gangsta1,mahalkit,elenka,lbhtrnjh,dukedog,19922991,hopkins1,evgenia,domino1,x123456,manny1,tabbycat,drake1,jerico,drahcir,kelly2,708090a,facesit,11c645df,mac123,boodog,kalani,hiphop1,critters,hellothere,tbirds,valerka,551scasi,love777,paloalto,mrbrown,duke3d,killa1,arcturus,spider12,dizzy1,smudger,goddog,75395,spammy,1357997531,78678,datalife,zxcvbn123,1122112211,london22,23dp4x,rxmtkp,biggirls,ownsu,lzbs2twz,sharps,geryfe,237081a,golakers,nemesi,sasha1995,pretty1,mittens1,d1lakiss,speedrac,gfhjkmm,sabbat,hellrais,159753258,qwertyuiop123,playgirl,crippler,salma,strat1,celest,hello5,omega5,cheese12,ndeyl5,edward12,soccer3,cheerio,davido,vfrcbr,gjhjctyjr,boscoe,inessa,shithole,ibill,qwepoi,201jedlz,asdlkj,davidk,spawn2,ariel1,michael4,jamie123,romantik,micro1,pittsbur,canibus,katja,muhtar,thomas123,studboy,masahiro,rebrov,patrick8,hotboys,sarge1,1hammer,nnnnn1,eistee,datalore,jackdani,sasha2010,mwq6qlzo,cmfnpu,klausi,cnhjbntkm,andrzej,ilovejen,lindaa,hunter123,vvvvv1,novembe,hamster1,x35v8l,lacey1,1silver,iluvporn,valter,herson,alexsandr,cojones,backhoe,womens,777angel,beatit,klingon1,ta8g4w,luisito,benedikt,maxwel,inspecto,zaq12ws,wladimir,bobbyd,peterj,asdfg12,hellspawn,bitch69,nick1234,golfer23,sony123,jello1,killie,chubby1,kodaira52,yanochka,buckfast,morris1,roaddogg,snakeeye,sex1234,mike22,mmouse,fucker11,dantist,brittan,vfrfhjdf,doc123,plokijuh,emerald1,batman01,serafim,elementa,soccer9,footlong,cthuttdbx,hapkido,eagle123,getsmart,getiton,batman2,masons,mastiff,098890,cfvfhf,james7,azalea,sherif,saun24865709,123red,cnhtrjpf,martina1,pupper,michael5,alan12,shakir,devin1,ha8fyp,palom,mamulya,trippy,deerhunter,happyone,monkey77,3mta3,123456789f,crownvic,teodor,natusik,0137485,vovchik,strutter,triumph1,cvetok,moremone,sonnen,screwbal,akira1,sexnow,pernille,independ,poopies,samapi,kbcbxrf,master22,swetlana,urchin,viper2,magica,slurpee,postit,gilgames,kissarmy,clubpenguin,limpbizk,timber1,celin,lilkim,fuckhard,lonely1,mom123,goodwood,extasy,sdsadee23,foxglove,malibog,clark1,casey2,shell1,odense,balefire,dcunited,cubbie,pierr,solei,161718,bowling1,areyukesc,batboy,r123456,1pionee,marmelad,maynard1,cn42qj,cfvehfq,heathrow,qazxcvbn,connecti,secret123,newfie,xzsawq21,tubitzen,nikusha,enigma1,yfcnz123,1austin,michaelc,splunge,wanger,phantom2,jason2,pain4me,primetime21,babes1,liberte,sugarray,undergro,zonker,labatts,djhjyf,watch1,eagle5,madison2,cntgfirf,sasha2,masterca,fiction7,slick50,bruins1,sagitari,12481632,peniss,insuranc,2b8riedt,12346789,mrclean,ssptx452,tissot,q1w2e3r4t5y6u7,avatar1,comet1,spacer,vbrjkf,pass11,wanker1,14vbqk9p,noshit,money4me,sayana,fish1234,seaways,pipper,romeo123,karens,wardog,ab123456,gorilla1,andrey123,lifesucks,jamesr,4wcqjn,bearman,glock22,matt11,dflbvrf,barbi,maine1,dima1997,sunnyboy,6bjvpe,bangkok1,666666q,rafiki,letmein0,0raziel0,dalla,london99,wildthin,patrycja,skydog,qcactw,tmjxn151,yqlgr667,jimmyd,stripclub,deadwood,863abgsg,horses1,qn632o,scatman,sonia1,subrosa,woland,kolya,charlie4,moleman,j12345,summer11,angel11,blasen,sandal,mynewpas,retlaw,cambria,mustang4,nohack04,kimber45,fatdog,maiden1,bigload,necron,dupont24,ghost123,turbo2,.ktymrf,radagast,balzac,vsevolod,pankaj,argentum,2bigtits,mamabear,bumblebee,mercury7,maddie1,chomper,jq24nc,snooky,pussylic,1lovers,taltos,warchild,diablo66,jojo12,sumerki,aventura,gagger,annelies,drumset,cumshots,azimut,123580,clambake,bmw540,birthday54,psswrd,paganini,wildwest,filibert,teaseme,1test,scampi,thunder5,antosha,purple12,supersex,hhhhhh1,brujah,111222333a,13579a,bvgthfnjh,4506802a,killians,choco,qqqwwweee,raygun,1grand,koetsu13,sharp1,mimi92139,fastfood,idontcare,bluered,chochoz,4z3al0ts,target1,sheffiel,labrat,stalingrad,147123,cubfan,corvett1,holden1,snapper1,4071505,amadeo,pollo,desperados,lovestory,marcopolo,mumbles,familyguy,kimchee,marcio,support1,tekila,shygirl1,trekkie,submissi,ilaria,salam,loveu,wildstar,master69,sales1,netware,homer2,arseniy,gerrity1,raspberr,atreyu,stick1,aldric,tennis12,matahari,alohomora,dicanio,michae1,michaeld,666111,luvbug,boyscout,esmerald,mjordan,admiral1,steamboa,616913,ybhdfyf,557711,555999,sunray,apokalipsis,theroc,bmw330,buzzy,chicos,lenusik,shadowma,eagles05,444222,peartree,qqq123,sandmann,spring1,430799,phatass,andi03,binky1,arsch,bamba,kenny123,fabolous,loser123,poop12,maman,phobos,tecate,myxworld4,metros,cocorico,nokia6120,johnny69,hater,spanked,313233,markos,love2011,mozart1,viktoriy,reccos,331234,hornyone,vitesse,1um83z,55555q,proline,v12345,skaven,alizee,bimini,fenerbahce,543216,zaqqaz,poi123,stabilo,brownie1,1qwerty1,dinesh,baggins1,1234567t,davidkin,friend1,lietuva,octopuss,spooks,12345qq,myshit,buttface,paradoxx,pop123,golfin,sweet69,rfghbp,sambuca,kayak1,bogus1,girlz,dallas12,millers,123456zx,operatio,pravda,eternal1,chase123,moroni,proust,blueduck,harris1,redbarch,996699,1010101,mouche,millenni,1123456,score1,1234565,1234576,eae21157,dave12,pussyy,gfif1991,1598741,hoppy,darrian,snoogins,fartface,ichbins,vfkbyrf,rusrap,2741001,fyfrjylf,aprils,favre,thisis,bannana,serval,wiggum,satsuma,matt123,ivan123,gulmira,123zxc123,oscar2,acces,annie2,dragon0,emiliano,allthat,pajaro,amandine,rawiswar,sinead,tassie,karma1,piggys,nokias,orions,origami,type40,mondo,ferrets,monker,biteme2,gauntlet,arkham,ascona,ingram01,klem1,quicksil,bingo123,blue66,plazma,onfire,shortie,spjfet,123963,thered,fire777,lobito,vball,1chicken,moosehea,elefante,babe23,jesus12,parallax,elfstone,number5,shrooms,freya,hacker1,roxette,snoops,number7,fellini,dtlmvf,chigger,mission1,mitsubis,kannan,whitedog,james01,ghjgecr,rfnfgekmnf,everythi,getnaked,prettybo,sylvan,chiller,carrera4,cowbo,biochem,azbuka,qwertyuiop1,midnight1,informat,audio1,alfred1,0range,sucker1,scott2,russland,1eagle,torben,djkrjlfd,rocky6,maddy1,bonobo,portos,chrissi,xjznq5,dexte,vdlxuc,teardrop,pktmxr,iamtheone,danijela,eyphed,suzuki1,etvww4,redtail,ranger11,mowerman,asshole2,coolkid,adriana1,bootcamp,longcut,evets,npyxr5,bighurt,bassman1,stryder,giblet,nastja,blackadd,topflite,wizar,cumnow,technolo,bassboat,bullitt,kugm7b,maksimus,wankers,mine12,sunfish,pimpin1,shearer9,user1,vjzgjxnf,tycobb,80070633pc,stanly,vitaly,shirley1,cinzia,carolyn1,angeliqu,teamo,qdarcv,aa123321,ragdoll,bonit,ladyluck,wiggly,vitara,jetbalance,12345600,ozzman,dima12345,mybuddy,shilo,satan66,erebus,warrio,090808qwe,stupi,bigdan,paul1234,chiapet,brooks1,philly1,dually,gowest,farmer1,1qa2ws3ed4rf,alberto1,beachboy,barne,aa12345,aliyah,radman,benson1,dfkthbq,highball,bonou2,i81u812,workit,darter,redhook,csfbr5yy,buttlove,episode1,ewyuza,porthos,lalal,abcd12,papero,toosexy,keeper1,silver7,jujitsu,corset,pilot123,simonsay,pinggolf,katerinka,kender,drunk1,fylhjvtlf,rashmi,nighthawk,maggy,juggernaut,larryb,cabibble,fyabcf,247365,gangstar,jaybee,verycool,123456789qw,forbidde,prufrock,12345zxc,malaika,blackbur,docker,filipe,koshechka,gemma1,djamaal,dfcbkmtdf,gangst,9988aa,ducks1,pthrfkj,puertorico,muppets,griffins,whippet,sauber,timofey,larinso,123456789zxc,quicken,qsefth,liteon,headcase,bigdadd,zxc321,maniak,jamesc,bassmast,bigdogs,1girls,123xxx,trajan,lerochka,noggin,mtndew,04975756,domin,wer123,fumanchu,lambada,thankgod,june22,kayaking,patchy,summer10,timepass,poiu1234,kondor,kakka,lament,zidane10,686xqxfg,l8v53x,caveman1,nfvthkfy,holymoly,pepita,alex1996,mifune,fighter1,asslicker,jack22,abc123abc,zaxxon,midnigh,winni,psalm23,punky,monkey22,password13,mymusic,justyna,annushka,lucky5,briann,495rus19,withlove,almaz,supergir,miata,bingbong,bradpitt,kamasutr,yfgjktjy,vanman,pegleg,amsterdam1,123a321,letmein9,shivan,korona,bmw520,annette1,scotsman,gandal,welcome12,sc00by,qpwoei,fred69,m1sf1t,hamburg1,1access,dfkmrbhbz,excalibe,boobies1,fuckhole,karamel,starfuck,star99,breakfas,georgiy,ywvxpz,smasher,fatcat1,allanon,12345n,coondog,whacko,avalon1,scythe,saab93,timon,khorne,atlast,nemisis,brady12,blenheim,52678677,mick7278,9skw5g,fleetwoo,ruger1,kissass,pussy7,scruff,12345l,bigfun,vpmfsz,yxkck878,evgeny,55667788,lickher,foothill,alesis,poppies,77777778,californi,mannie,bartjek,qhxbij,thehulk,xirt2k,angelo4ek,rfkmrekznjh,tinhorse,1david,sparky12,night1,luojianhua,bobble,nederland,rosemari,travi,minou,ciscokid,beehive,565hlgqo,alpine1,samsung123,trainman,xpress,logistic,vw198m2n,hanter,zaqwsx123,qwasz,mariachi,paska,kmg365,kaulitz,sasha12,north1,polarbear,mighty1,makeksa11,123456781,one4all,gladston,notoriou,polniypizdec110211,gosia,grandad,xholes,timofei,invalidp,speaker1,zaharov,maggiema,loislane,gonoles,br5499,discgolf,kaskad,snooper,newman1,belial,demigod,vicky1,pridurok,alex1990,tardis1,cruzer,hornie,sacramen,babycat,burunduk,mark69,oakland1,me1234,gmctruck,extacy,sexdog,putang,poppen,billyd,1qaz2w,loveable,gimlet,azwebitalia,ragtop,198500,qweas,mirela,rock123,11bravo,sprewell,tigrenok,jaredleto,vfhbif,blue2,rimjob,catwalk,sigsauer,loqse,doromich,jack01,lasombra,jonny5,newpassword,profesor,garcia1,123as123,croucher,demeter,4_life,rfhfvtkm,superman2,rogues,assword1,russia1,jeff1,mydream,z123456789,rascal1,darre,kimberl,pickle1,ztmfcq,ponchik,lovesporn,hikari,gsgba368,pornoman,chbjun,choppy,diggity,nightwolf,viktori,camar,vfhecmrf,alisa1,minstrel,wishmaster,mulder1,aleks,gogirl,gracelan,8womys,highwind,solstice,dbrnjhjdyf,nightman,pimmel,beertje,ms6nud,wwfwcw,fx3tuo,poopface,asshat,dirtyd,jiminy,luv2fuck,ptybnxtvgbjy,dragnet,pornogra,10inch,scarlet1,guido1,raintree,v123456,1aaaaaaa,maxim1935,hotwater,gadzooks,playaz,harri,brando1,defcon1,ivanna,123654a,arsenal2,candela,nt5d27,jaime1,duke1,burton1,allstar1,dragos,newpoint,albacore,1236987z,verygoodbot,1wildcat,fishy1,ptktysq,chris11,puschel,itdxtyrj,7kbe9d,serpico,jazzie,1zzzzz,kindbuds,wenef45313,1compute,tatung,sardor,gfyfcjybr,test99,toucan,meteora,lysander,asscrack,jowgnx,hevnm4,suckthis,masha123,karinka,marit,oqglh565,dragon00,vvvbbb,cheburashka,vfrfrf,downlow,unforgiven,p3e85tr,kim123,sillyboy,gold1,golfvr6,quicksan,irochka,froglegs,shortsto,caleb1,tishka,bigtitts,smurfy,bosto,dropzone,nocode,jazzbass,digdug,green7,saltlake,therat,dmitriev,lunita,deaddog,summer0,1212qq,bobbyg,mty3rh,isaac1,gusher,helloman,sugarbear,corvair,extrem,teatime,tujazopi,titanik,efyreg,jo9k2jw2,counchac,tivoli,utjvtnhbz,bebit,jacob6,clayton1,incubus1,flash123,squirter,dima2010,cock1,rawks,komatsu,forty2,98741236,cajun1,madelein,mudhoney,magomed,q111111,qaswed,consense,12345b,bakayaro,silencer,zoinks,bigdic,werwolf,pinkpuss,96321478,alfie1,ali123,sarit,minette,musics,chato,iaapptfcor,cobaka,strumpf,datnigga,sonic123,yfnecbr,vjzctvmz,pasta1,tribbles,crasher,htlbcrf,1tiger,shock123,bearshar,syphon,a654321,cubbies1,jlhanes,eyespy,fucktheworld,carrie1,bmw325is,suzuk,mander,dorina,mithril,hondo1,vfhnbyb,sachem,newton1,12345x,7777755102q,230857z,xxxsex,scubapro,hayastan,spankit,delasoul,searock6,fallout3,nilrem,24681357,pashka,voluntee,pharoh,willo,india1,badboy69,roflmao,gunslinger,lovergir,mama12,melange,640xwfkv,chaton,darkknig,bigman1,aabbccdd,harleyd,birdhouse,giggsy,hiawatha,tiberium,joker7,hello1234,sloopy,tm371855,greendog,solar1,bignose,djohn11,espanol,oswego,iridium,kavitha,pavell,mirjam,cyjdsvujljv,alpha5,deluge,hamme,luntik,turismo,stasya,kjkbnf,caeser,schnecke,tweety1,tralfaz,lambrett,prodigy1,trstno1,pimpshit,werty1,karman,bigboob,pastel,blackmen,matthew8,moomin,q1w2e,gilly,primaver,jimmyg,house2,elviss,15975321,1jessica,monaliza,salt55,vfylfhbyrf,harley11,tickleme,murder1,nurgle,kickass1,theresa1,fordtruck,pargolf,managua,inkognito,sherry1,gotit,friedric,metro2033,slk230,freeport,cigarett,492529,vfhctkm,thebeach,twocats,bakugan,yzerman1,charlieb,motoko,skiman,1234567w,pussy3,love77,asenna,buffie,260zntpc,kinkos,access20,mallard1,fuckyou69,monami,rrrrr1,bigdog69,mikola,1boomer,godzila,ginger2,dima2000,skorpion39,dima1234,hawkdog79,warrior2,ltleirf,supra1,jerusale,monkey01,333z333,666888,kelsey1,w8gkz2x1,fdfnfh,msnxbi,qwe123rty,mach1,monkey3,123456789qq,c123456,nezabudka,barclays,nisse,dasha1,12345678987654321,dima1993,oldspice,frank2,rabbitt,prettyboy,ov3ajy,iamthema,kawasak,banjo1,gtivr6,collants,gondor,hibees,cowboys2,codfish,buster2,purzel,rubyred,kayaker,bikerboy,qguvyt,masher,sseexx,kenshiro,moonglow,semenova,rosari,eduard1,deltaforce,grouper,bongo1,tempgod,1taylor,goldsink,qazxsw1,1jesus,m69fg2w,maximili,marysia,husker1,kokanee,sideout,googl,south1,plumber1,trillian,00001,1357900,farkle,1xxxxx,pascha,emanuela,bagheera,hound1,mylov,newjersey,swampfox,sakic19,torey,geforce,wu4etd,conrail,pigman,martin2,ber02,nascar2,angel69,barty,kitsune,cornet,yes90125,goomba,daking,anthea,sivart,weather1,ndaswf,scoubidou,masterchief,rectum,3364068,oranges1,copter,1samanth,eddies,mimoza,ahfywbz,celtic88,86mets,applemac,amanda11,taliesin,1angel,imhere,london11,bandit12,killer666,beer1,06225930,psylocke,james69,schumach,24pnz6kc,endymion,wookie1,poiu123,birdland,smoochie,lastone,rclaki,olive1,pirat,thunder7,chris69,rocko,151617,djg4bb4b,lapper,ajcuivd289,colole57,shadow7,dallas21,ajtdmw,executiv,dickies,omegaman,jason12,newhaven,aaaaaas,pmdmscts,s456123789,beatri,applesauce,levelone,strapon,benladen,creaven,ttttt1,saab95,f123456,pitbul,54321a,sex12345,robert3,atilla,mevefalkcakk,1johnny,veedub,lilleke,nitsuj,5t6y7u8i,teddys,bluefox,nascar20,vwjetta,buffy123,playstation3,loverr,qweasd12,lover2,telekom,benjamin1,alemania,neutrino,rockz,valjean,testicle,trinity3,realty,firestarter,794613852,ardvark,guadalup,philmont,arnold1,holas,zw6syj,birthday299,dover1,sexxy1,gojets,741236985,cance,blue77,xzibit,qwerty88,komarova,qweszxc,footer,rainger,silverst,ghjcnb,catmando,tatooine,31217221027711,amalgam,69dude,qwerty321,roscoe1,74185,cubby,alfa147,perry1,darock,katmandu,darknight,knicks1,freestuff,45454,kidman,4tlved,axlrose,cutie1,quantum1,joseph10,ichigo,pentium3,rfhectkm,rowdy1,woodsink,justforfun,sveta123,pornografia,mrbean,bigpig,tujheirf,delta9,portsmou,hotbod,kartal,10111213,fkbyf001,pavel1,pistons1,necromancer,verga,c7lrwu,doober,thegame1,hatesyou,sexisfun,1melissa,tuczno18,bowhunte,gobama,scorch,campeon,bruce2,fudge1,herpderp,bacon1,redsky,blackeye,19966991,19992000,ripken8,masturba,34524815,primax,paulina1,vp6y38,427cobra,4dwvjj,dracon,fkg7h4f3v6,longview,arakis,panama1,honda2,lkjhgfdsaz,razors,steels,fqkw5m,dionysus,mariajos,soroka,enriqu,nissa,barolo,king1234,hshfd4n279,holland1,flyer1,tbones,343104ky,modems,tk421,ybrbnrf,pikapp,sureshot,wooddoor,florida2,mrbungle,vecmrf,catsdogs,axolotl,nowayout,francoi,chris21,toenail,hartland,asdjkl,nikkii,onlyyou,buckskin,fnord,flutie,holen1,rincewind,lefty1,ducky1,199000,fvthbrf,redskin1,ryno23,lostlove,19mtpgam19,abercrom,benhur,jordan11,roflcopter,ranma,phillesh,avondale,igromania,p4ssword,jenny123,tttttt1,spycams,cardigan,2112yyz,sleepy1,paris123,mopars,lakers34,hustler1,james99,matrix3,popimp,12pack,eggbert,medvedev,testit,performa,logitec,marija,sexybeast,supermanboy,iwantit,rjktcj,jeffer,svarog,halo123,whdbtp,nokia3230,heyjoe,marilyn1,speeder,ibxnsm,prostock,bennyboy,charmin,codydog,parol999,ford9402,jimmer,crayola,159357258,alex77,joey1,cayuga,phish420,poligon,specops,tarasova,caramelo,draconis,dimon,cyzkhw,june29,getbent,1guitar,jimjam,dictiona,shammy,flotsam,0okm9ijn,crapper,technic,fwsadn,rhfdxtyrj,zaq11qaz,anfield1,159753q,curious1,hip-hop,1iiiii,gfhjkm2,cocteau,liveevil,friskie,crackhead,b1afra,elektrik,lancer1,b0ll0cks,jasond,z1234567,tempest1,alakazam,asdfasd,duffy1,oneday,dinkle,qazedctgb,kasimir,happy7,salama,hondaciv,nadezda,andretti,cannondale,sparticu,znbvjd,blueice,money01,finster,eldar,moosie,pappa,delta123,neruda,bmw330ci,jeanpaul,malibu1,alevtina,sobeit,travolta,fullmetal,enamorad,mausi,boston12,greggy,smurf1,ratrace,ichiban,ilovepus,davidg,wolf69,villa1,cocopuff,football12,starfury,zxc12345,forfree,fairfiel,dreams1,tayson,mike2,dogday,hej123,oldtimer,sanpedro,clicker,mollycat,roadstar,golfe,lvbnhbq1,topdevice,a1b2c,sevastopol,calli,milosc,fire911,pink123,team3x,nolimit5,snickers1,annies,09877890,jewel1,steve69,justin11,autechre,killerbe,browncow,slava1,christer,fantomen,redcloud,elenberg,beautiful1,passw0rd1,nazira,advantag,cockring,chaka,rjpzdrf,99941,az123456,biohazar,energie,bubble1,bmw323,tellme,printer1,glavine,1starwar,coolbeans,april17,carly1,quagmire,admin2,djkujuhfl,pontoon,texmex,carlos12,thermo,vaz2106,nougat,bob666,1hockey,1john,cricke,qwerty10,twinz,totalwar,underwoo,tijger,lildevil,123q321,germania,freddd,1scott,beefy,5t4r3e2w1q,fishbait,nobby,hogger,dnstuff,jimmyc,redknapp,flame1,tinfloor,balla,nfnfhby,yukon1,vixens,batata,danny123,1zxcvbnm,gaetan,homewood,greats,tester1,green99,1fucker,sc0tland,starss,glori,arnhem,goatman,1234asd,supertra,bill123,elguapo,sexylegs,jackryan,usmc69,innow,roaddog,alukard,winter11,crawler,gogiants,rvd420,alessandr,homegrow,gobbler,esteba,valeriy,happy12,1joshua,hawking,sicnarf,waynes,iamhappy,bayadera,august2,sashas,gotti,dragonfire,pencil1,halogen,borisov,bassingw,15975346,zachar,sweetp,soccer99,sky123,flipyou,spots3,xakepy,cyclops1,dragon77,rattolo58,motorhea,piligrim,helloween,dmb2010,supermen,shad0w,eatcum,sandokan,pinga,ufkfrnbrf,roksana,amista,pusser,sony1234,azerty1,1qasw2,ghbdt,q1w2e3r4t5y6u7i8,ktutylf,brehznev,zaebali,shitass,creosote,gjrtvjy,14938685,naughtyboy,pedro123,21crack,maurice1,joesakic,nicolas1,matthew9,lbyfhf,elocin,hfcgbplzq,pepper123,tiktak,mycroft,ryan11,firefly1,arriva,cyecvevhbr,loreal,peedee,jessica8,lisa01,anamari,pionex,ipanema,airbag,frfltvbz,123456789aa,epwr49,casper12,sweethear,sanandreas,wuschel,cocodog,france1,119911,redroses,erevan,xtvgbjy,bigfella,geneve,volvo850,evermore,amy123,moxie,celebs,geeman,underwor,haslo1,joy123,hallow,chelsea0,12435687,abarth,12332145,tazman1,roshan,yummie,genius1,chrisd,ilovelife,seventy7,qaz1wsx2,rocket88,gaurav,bobbyboy,tauchen,roberts1,locksmit,masterof,www111,d9ungl,volvos40,asdasd1,golfers,jillian1,7xm5rq,arwpls4u,gbhcf2,elloco,football2,muerte,bob101,sabbath1,strider1,killer66,notyou,lawnboy,de7mdf,johnnyb,voodoo2,sashaa,homedepo,bravos,nihao123,braindea,weedhead,rajeev,artem1,camille1,rockss,bobbyb,aniston,frnhbcf,oakridge,biscayne,cxfcnm,dressage,jesus3,kellyann,king69,juillet,holliste,h00ters,ripoff,123645,1999ar,eric12,123777,tommi,dick12,bilder,chris99,rulezz,getpaid,chicubs,ender1,byajhvfnbrf,milkshak,sk8board,freakshow,antonella,monolit,shelb,hannah01,masters1,pitbull1,1matthew,luvpussy,agbdlcid,panther2,alphas,euskadi,8318131,ronnie1,7558795,sweetgirl,cookie59,sequoia,5552555,ktyxbr,4500455,money7,severus,shinobu,dbityrf,phisig,rogue2,fractal,redfred,sebastian1,nelli,b00mer,cyberman,zqjphsyf6ctifgu,oldsmobile,redeemer,pimpi,lovehurts,1slayer,black13,rtynfdh,airmax,g00gle,1panther,artemon,nopasswo,fuck1234,luke1,trinit,666000,ziadma,oscardog,davex,hazel1,isgood,demond,james5,construc,555551,january2,m1911a1,flameboy,merda,nathan12,nicklaus,dukester,hello99,scorpio7,leviathan,dfcbktr,pourquoi,vfrcbv123,shlomo,rfcgth,rocky3,ignatz,ajhneyf,roger123,squeek,4815162342a,biskit,mossimo,soccer21,gridlock,lunker,popstar,ghhh47hj764,chutney,nitehawk,vortec,gamma1,codeman,dragula,kappasig,rainbow2,milehigh,blueballs,ou8124me,rulesyou,collingw,mystere,aster,astrovan,firetruck,fische,crawfish,hornydog,morebeer,tigerpaw,radost,144000,1chance,1234567890qwe,gracie1,myopia,oxnard,seminoles,evgeni,edvard,partytim,domani,tuffy1,jaimatadi,blackmag,kzueirf,peternor,mathew1,maggie12,henrys,k1234567,fasted,pozitiv,cfdtkbq,jessica7,goleafs,bandito,girl78,sharingan,skyhigh,bigrob,zorros,poopers,oldschoo,pentium2,gripper,norcal,kimba,artiller,moneymak,00197400,272829,shadow1212,thebull,handbags,all4u2c,bigman2,civics,godisgoo,section8,bandaid,suzanne1,zorba,159123,racecars,i62gbq,rambo123,ironroad,johnson2,knobby,twinboys,sausage1,kelly69,enter2,rhjirf,yessss,james12,anguilla,boutit,iggypop,vovochka,06060,budwiser,romuald,meditate,good1,sandrin,herkules,lakers8,honeybea,11111111a,miche,rangers9,lobster1,seiko,belova,midcon,mackdadd,bigdaddy1,daddie,sepultur,freddy12,damon1,stormy1,hockey2,bailey12,hedimaptfcor,dcowboys,sadiedog,thuggin,horny123,josie1,nikki2,beaver69,peewee1,mateus,viktorija,barrys,cubswin1,matt1234,timoxa,rileydog,sicilia,luckycat,candybar,julian1,abc456,pussylip,phase1,acadia,catty,246800,evertonf,bojangle,qzwxec,nikolaj,fabrizi,kagome,noncapa0,marle,popol,hahaha1,cossie,carla10,diggers,spankey,sangeeta,cucciolo,breezer,starwar1,cornholio,rastafari,spring99,yyyyyyy1,webstar,72d5tn,sasha1234,inhouse,gobuffs,civic1,redstone,234523,minnie1,rivaldo,angel5,sti2000,xenocide,11qq11,1phoenix,herman1,holly123,tallguy,sharks1,madri,superbad,ronin,jalal123,hardbody,1234567r,assman1,vivahate,buddylee,38972091,bonds25,40028922,qrhmis,wp2005,ceejay,pepper01,51842543,redrum1,renton,varadero,tvxtjk7r,vetteman,djhvbrc,curly1,fruitcak,jessicas,maduro,popmart,acuari,dirkpitt,buick1,bergerac,golfcart,pdtpljxrf,hooch1,dudelove,d9ebk7,123452000,afdjhbn,greener,123455432,parachut,mookie12,123456780,jeepcj5,potatoe,sanya,qwerty2010,waqw3p,gotika,freaky1,chihuahu,buccanee,ecstacy,crazyboy,slickric,blue88,fktdnbyf,2004rj,delta4,333222111,calient,ptbdhw,1bailey,blitz1,sheila1,master23,hoagie,pyf8ah,orbita,daveyboy,prono1,delta2,heman,1horny,tyrik123,ostrov,md2020,herve,rockfish,el546218,rfhbyjxrf,chessmaster,redmoon,lenny1,215487,tomat,guppy,amekpass,amoeba,my3girls,nottingh,kavita,natalia1,puccini,fabiana,8letters,romeos,netgear,casper2,taters,gowings,iforgot1,pokesmot,pollit,lawrun,petey1,rosebuds,007jr,gthtcnhjqrf,k9dls02a,neener,azertyu,duke11,manyak,tiger01,petros,supermar,mangas,twisty,spotter,takagi,dlanod,qcmfd454,tusymo,zz123456,chach,navyblue,gilbert1,2kash6zq,avemaria,1hxboqg2s,viviane,lhbjkjubz2957704,nowwowtg,1a2b3c4,m0rn3,kqigb7,superpuper,juehtw,gethigh,theclown,makeme,pradeep,sergik,deion21,nurik,devo2706,nbvibt,roman222,kalima,nevaeh,martin7,anathema,florian1,tamwsn3sja,dinmamma,133159,123654q,slicks,pnp0c08,yojimbo,skipp,kiran,pussyfuck,teengirl,apples12,myballs,angeli,1234a,125678,opelastra,blind1,armagedd,fish123,pitufo,chelseaf,thedevil,nugget1,cunt69,beetle1,carter15,apolon,collant,password00,fishboy,djkrjdf,deftone,celti,three11,cyrus1,lefthand,skoal1,ferndale,aries1,fred01,roberta1,chucks,cornbread,lloyd1,icecrea,cisco123,newjerse,vfhrbpf,passio,volcom1,rikimaru,yeah11,djembe,facile,a1l2e3x4,batman7,nurbol,lorenzo1,monica69,blowjob1,998899,spank1,233391,n123456,1bear,bellsout,999998,celtic67,sabre1,putas,y9enkj,alfabeta,heatwave,honey123,hard4u,insane1,xthysq,magnum1,lightsaber,123qweqwe,fisher1,pixie1,precios,benfic,thegirls,bootsman,4321rewq,nabokov,hightime,djghjc,1chelsea,junglist,august16,t3fkvkmj,1232123,lsdlsd12,chuckie1,pescado,granit,toogood,cathouse,natedawg,bmw530,123kid,hajime,198400,engine1,wessonnn,kingdom1,novembre,1rocks,kingfisher,qwerty89,jordan22,zasranec,megat,sucess,installutil,fetish01,yanshi1982,1313666,1314520,clemence,wargod,time1,newzealand,snaker,13324124,cfrehf,hepcat,mazahaka,bigjay,denisov,eastwest,1yellow,mistydog,cheetos,1596357,ginger11,mavrik,bubby1,bhbyf,pyramide,giusepp,luthien,honda250,andrewjackie,kentavr,lampoon,zaq123wsx,sonicx,davidh,1ccccc,gorodok,windsong,programm,blunt420,vlad1995,zxcvfdsa,tarasov,mrskin,sachas,mercedes1,koteczek,rawdog,honeybear,stuart1,kaktys,richard7,55555n,azalia,hockey10,scouter,francy,1xxxxxx,julie456,tequilla,penis123,schmoe,tigerwoods,1ferrari,popov,snowdrop,matthieu,smolensk,cornflak,jordan01,love2000,23wesdxc,kswiss,anna2000,geniusnet,baby2000,33ds5x,waverly,onlyone4,networkingpe,raven123,blesse,gocards,wow123,pjflkork,juicey,poorboy,freeee,billybo,shaheen,zxcvbnm.,berlit,truth1,gepard,ludovic,gunther1,bobby2,bob12345,sunmoon,septembr,bigmac1,bcnjhbz,seaking,all4u,12qw34er56ty,bassie,nokia5228,7355608,sylwia,charvel,billgate,davion,chablis,catsmeow,kjiflrf,amylynn,rfvbkkf,mizredhe,handjob,jasper12,erbol,solara,bagpipe,biffer,notime,erlan,8543852,sugaree,oshkosh,fedora,bangbus,5lyedn,longball,teresa1,bootyman,aleksand,qazwsxedc12,nujbhc,tifosi,zpxvwy,lights1,slowpoke,tiger12,kstate,password10,alex69,collins1,9632147,doglover,baseball2,security1,grunts,orange2,godloves,213qwe879,julieb,1qazxsw23edcvfr4,noidea,8uiazp,betsy1,junior2,parol123,123456zz,piehonkii,kanker,bunky,hingis,reese1,qaz123456,sidewinder,tonedup,footsie,blackpoo,jalapeno,mummy1,always1,josh1,rockyboy,plucky,chicag,nadroj,blarney,blood123,wheaties,packer1,ravens1,mrjones,gfhjkm007,anna2010,awatar,guitar12,hashish,scale1,tomwaits,amrita,fantasma,rfpfym,pass2,tigris,bigair,slicker,sylvi,shilpa,cindylou,archie1,bitches1,poppys,ontime,horney1,camaroz28,alladin,bujhm,cq2kph,alina1,wvj5np,1211123a,tetons,scorelan,concordi,morgan2,awacs,shanty,tomcat14,andrew123,bear69,vitae,fred99,chingy,octane,belgario,fatdaddy,rhodan,password23,sexxes,boomtown,joshua01,war3demo,my2kids,buck1,hot4you,monamour,12345aa,yumiko,parool,carlton1,neverland,rose12,right1,sociald,grouse,brandon0,cat222,alex00,civicex,bintang,malkav,arschloc,dodgeviper,qwerty666,goduke,dante123,boss1,ontheroc,corpsman,love14,uiegu451,hardtail,irondoor,ghjrehfnehf,36460341,konijn,h2slca,kondom25,123456ss,cfytxrf,btnjey,nando,freemail,comander,natas666,siouxsie,hummer1,biomed,dimsum,yankees0,diablo666,lesbian1,pot420,jasonm,glock23,jennyb,itsmine,lena2010,whattheh,beandip,abaddon,kishore,signup,apogee,biteme12,suzieq,vgfun4,iseeyou,rifleman,qwerta,4pussy,hawkman,guest1,june17,dicksuck,bootay,cash12,bassale,ktybyuhfl,leetch,nescafe,7ovtgimc,clapton1,auror,boonie,tracker1,john69,bellas,cabinboy,yonkers,silky1,ladyffesta,drache,kamil1,davidp,bad123,snoopy12,sanche,werthvfy,achille,nefertiti,gerald1,slage33,warszawa,macsan26,mason123,kotopes,welcome8,nascar99,kiril,77778888,hairy1,monito,comicsans,81726354,killabee,arclight,yuo67,feelme,86753099,nnssnn,monday12,88351132,88889999,websters,subito,asdf12345,vaz2108,zvbxrpl,159753456852,rezeda,multimed,noaccess,henrique,tascam,captiva,zadrot,hateyou,sophie12,123123456,snoop1,charlie8,birmingh,hardline,libert,azsxdcf,89172735872,rjpthju,bondar,philips1,olegnaruto,myword,yakman,stardog,banana12,1234567890w,farout,annick,duke01,rfj422,billard,glock19,shaolin1,master10,cinderel,deltaone,manning1,biggreen,sidney1,patty1,goforit1,766rglqy,sevendus,aristotl,armagedo,blumen,gfhfyjz,kazakov,lekbyxxx,accord1,idiota,soccer16,texas123,victoire,ololo,chris01,bobbbb,299792458,eeeeeee1,confiden,07070,clarks,techno1,kayley,stang1,wwwwww1,uuuuu1,neverdie,jasonr,cavscout,481516234,mylove1,shaitan,1qazxcvb,barbaros,123456782000,123wer,thissucks,7seven,227722,faerie,hayduke,dbacks,snorkel,zmxncbv,tiger99,unknown1,melmac,polo1234,sssssss1,1fire,369147,bandung,bluejean,nivram,stanle,ctcnhf,soccer20,blingbli,dirtball,alex2112,183461,skylin,boobman,geronto,brittany1,yyz2112,gizmo69,ktrcec,dakota12,chiken,sexy11,vg08k714,bernadet,1bulldog,beachs,hollyb,maryjoy,margo1,danielle1,chakra,alexand,hullcity,matrix12,sarenna,pablos,antler,supercar,chomsky,german1,airjordan,545ettvy,camaron,flight1,netvideo,tootall,valheru,481516,1234as,skimmer,redcross,inuyash,uthvfy,1012nw,edoardo,bjhgfi,golf11,9379992a,lagarto,socball,boopie,krazy,.adgjmptw,gaydar,kovalev,geddylee,firstone,turbodog,loveee,135711,badbo,trapdoor,opopop11,danny2,max2000,526452,kerry1,leapfrog,daisy2,134kzbip,1andrea,playa1,peekab00,heskey,pirrello,gsewfmck,dimon4ik,puppie,chelios,554433,hypnodanny,fantik,yhwnqc,ghbdtngjrf,anchorag,buffett1,fanta,sappho,024680,vialli,chiva,lucylu,hashem,exbntkm,thema,23jordan,jake11,wildside,smartie,emerica,2wj2k9oj,ventrue,timoth,lamers,baerchen,suspende,boobis,denman85,1adam12,otello,king12,dzakuni,qsawbbs,isgay,porno123,jam123,daytona1,tazzie,bunny123,amaterasu,jeffre,crocus,mastercard,bitchedup,chicago7,aynrand,intel1,tamila,alianza,mulch,merlin12,rose123,alcapone,mircea,loveher,joseph12,chelsea6,dorothy1,wolfgar,unlimite,arturik,qwerty3,paddy1,piramid,linda123,cooool,millie1,warlock1,forgotit,tort02,ilikeyou,avensis,loveislife,dumbass1,clint1,2110se,drlove,olesia,kalinina,sergey123,123423,alicia1,markova,tri5a3,media1,willia1,xxxxxxx1,beercan,smk7366,jesusislord,motherfuck,smacker,birthday5,jbaby,harley2,hyper1,a9387670a,honey2,corvet,gjmptw,rjhjkmbien,apollon,madhuri,3a5irt,cessna17,saluki,digweed,tamia1,yja3vo,cfvlehfr,1111111q,martyna,stimpy1,anjana,yankeemp,jupiler,idkfa,1blue,fromv,afric,3xbobobo,liverp00l,nikon1,amadeus1,acer123,napoleo,david7,vbhjckfdf,mojo69,percy1,pirates1,grunt1,alenushka,finbar,zsxdcf,mandy123,1fred,timewarp,747bbb,druids,julia123,123321qq,spacebar,dreads,fcbarcelona,angela12,anima,christopher1,stargazer,123123s,hockey11,brewski,marlbor,blinker,motorhead,damngood,werthrf,letmein3,moremoney,killer99,anneke,eatit,pilatus,andrew01,fiona1,maitai,blucher,zxgdqn,e5pftu,nagual,panic1,andron,openwide,alphabeta,alison1,chelsea8,fende,mmm666,1shot2,a19l1980,123456@,1black,m1chael,vagner,realgood,maxxx,vekmnbr,stifler,2509mmh,tarkan,sherzod,1234567b,gunners1,artem2010,shooby,sammie1,p123456,piggie,abcde12345,nokia6230,moldir,piter,1qaz3edc,frequenc,acuransx,1star,nikeair,alex21,dapimp,ranjan,ilovegirls,anastasiy,berbatov,manso,21436587,leafs1,106666,angelochek,ingodwetrust,123456aaa,deano,korsar,pipetka,thunder9,minka,himura,installdevic,1qqqqq,digitalprodu,suckmeoff,plonker,headers,vlasov,ktr1996,windsor1,mishanya,garfield1,korvin,littlebit,azaz09,vandamme,scripto,s4114d,passward,britt1,r1chard,ferrari5,running1,7xswzaq,falcon2,pepper76,trademan,ea53g5,graham1,volvos80,reanimator,micasa,1234554321q,kairat,escorpion,sanek94,karolina1,kolovrat,karen2,1qaz@wsx,racing1,splooge,sarah2,deadman1,creed1,nooner,minicoop,oceane,room112,charme,12345ab,summer00,wetcunt,drewman,nastyman,redfire,appels,merlin69,dolfin,bornfree,diskette,ohwell,12345678qwe,jasont,madcap,cobra2,dolemit1,whatthehell,juanit,voldemar,rocke,bianc,elendil,vtufgjkbc,hotwheels,spanis,sukram,pokerface,k1ller,freakout,dontae,realmadri,drumss,gorams,258789,snakey,jasonn,whitewolf,befree,johnny99,pooka,theghost,kennys,vfvektxrf,toby1,jumpman23,deadlock,barbwire,stellina,alexa1,dalamar,mustanggt,northwes,tesoro,chameleo,sigtau,satoshi,george11,hotcum,cornell1,golfer12,geek01d,trololo,kellym,megapolis,pepsi2,hea666,monkfish,blue52,sarajane,bowler1,skeets,ddgirls,hfccbz,bailey01,isabella1,dreday,moose123,baobab,crushme,000009,veryhot,roadie,meanone,mike18,henriett,dohcvtec,moulin,gulnur,adastra,angel9,western1,natura,sweetpe,dtnfkm,marsbar,daisys,frogger1,virus1,redwood1,streetball,fridolin,d78unhxq,midas,michelob,cantik,sk2000,kikker,macanudo,rambone,fizzle,20000,peanuts1,cowpie,stone32,astaroth,dakota01,redso,mustard1,sexylove,giantess,teaparty,bobbin,beerbong,monet1,charles3,anniedog,anna1988,cameleon,longbeach,tamere,qpful542,mesquite,waldemar,12345zx,iamhere,lowboy,canard,granp,daisymay,love33,moosejaw,nivek,ninjaman,shrike01,aaa777,88002000600,vodolei,bambush,falcor,harley69,alphaomega,severine,grappler,bosox,twogirls,gatorman,vettes,buttmunch,chyna,excelsio,crayfish,birillo,megumi,lsia9dnb9y,littlebo,stevek,hiroyuki,firehous,master5,briley2,gangste,chrisk,camaleon,bulle,troyboy,froinlaven,mybutt,sandhya,rapala,jagged,crazycat,lucky12,jetman,wavmanuk,1heather,beegee,negril,mario123,funtime1,conehead,abigai,mhorgan,patagoni,travel1,backspace,frenchfr,mudcat,dashenka,baseball3,rustys,741852kk,dickme,baller23,griffey1,suckmycock,fuhrfzgc,jenny2,spuds,berlin1,justfun,icewind,bumerang,pavlusha,minecraft123,shasta1,ranger12,123400,twisters,buthead,miked,finance1,dignity7,hello9,lvjdp383,jgthfnjh,dalmatio,paparoach,miller31,2bornot2b,fathe,monterre,theblues,satans,schaap,jasmine2,sibelius,manon,heslo,jcnhjd,shane123,natasha2,pierrot,bluecar,iloveass,harriso,red12,london20,job314,beholder,reddawg,fuckyou!,pussylick,bologna1,austintx,ole4ka,blotto,onering,jearly,balbes,lightbul,bighorn,crossfir,lee123,prapor,1ashley,gfhjkm22,wwe123,09090,sexsite,marina123,jagua,witch1,schmoo,parkview,dragon3,chilango,ultimo,abramova,nautique,2bornot2,duende,1arthur,nightwing,surfboar,quant4307,15s9pu03,karina1,shitball,walleye1,wildman1,whytesha,1morgan,my2girls,polic,baranova,berezuckiy,kkkkkk1,forzima,fornow,qwerty02,gokart,suckit69,davidlee,whatnow,edgard,tits1,bayshore,36987412,ghbphfr,daddyy,explore1,zoidberg,5qnzjx,morgane,danilov,blacksex,mickey12,balsam,83y6pv,sarahc,slaye,all4u2,slayer69,nadia1,rlzwp503,4cranker,kaylie,numberon,teremok,wolf12,deeppurple,goodbeer,aaa555,66669999,whatif,harmony1,ue8fpw,3tmnej,254xtpss,dusty197,wcksdypk,zerkalo,dfnheirf,motorol,digita,whoareyou,darksoul,manics,rounders,killer11,d2000lb,cegthgfhjkm,catdog1,beograd,pepsico,julius1,123654987,softbal,killer23,weasel1,lifeson,q123456q,444555666,bunches,andy1,darby1,service01,bear11,jordan123,amega,duncan21,yensid,lerxst,rassvet,bronco2,fortis,pornlove,paiste,198900,asdflkjh,1236547890,futur,eugene1,winnipeg261,fk8bhydb,seanjohn,brimston,matthe1,bitchedu,crisco,302731,roxydog,woodlawn,volgograd,ace1210,boy4u2ownnyc,laura123,pronger,parker12,z123456z,andrew13,longlife,sarang,drogba,gobruins,soccer4,holida,espace,almira,murmansk,green22,safina,wm00022,1chevy,schlumpf,doroth,ulises,golf99,hellyes,detlef,mydog,erkina,bastardo,mashenka,sucram,wehttam,generic1,195000,spaceboy,lopas123,scammer,skynyrd,daddy2,titani,ficker,cr250r,kbnthfnehf,takedown,sticky1,davidruiz,desant,nremtp,painter1,bogies,agamemno,kansas1,smallfry,archi,2b4dnvsx,1player,saddie,peapod,6458zn7a,qvw6n2,gfxqx686,twice2,sh4d0w3d,mayfly,375125,phitau,yqmbevgk,89211375759,kumar1,pfhfpf,toyboy,way2go,7pvn4t,pass69,chipster,spoony,buddycat,diamond3,rincewin,hobie,david01,billbo,hxp4life,matild,pokemon2,dimochka,clown1,148888,jenmt3,cuxldv,cqnwhy,cde34rfv,simone1,verynice,toobig,pasha123,mike00,maria2,lolpop,firewire,dragon9,martesana,a1234567890,birthday3,providen,kiska,pitbulls,556655,misawa,damned69,martin11,goldorak,gunship,glory1,winxclub,sixgun,splodge,agent1,splitter,dome69,ifghjb,eliza1,snaiper,wutang36,phoenix7,666425,arshavin,paulaner,namron,m69fg1w,qwert1234,terrys,zesyrmvu,joeman,scoots,dwml9f,625vrobg,sally123,gostoso,symow8,pelota,c43qpul5rz,majinbuu,lithium1,bigstuff,horndog1,kipelov,kringle,1beavis,loshara,octobe,jmzacf,12342000,qw12qw,runescape1,chargers1,krokus,piknik,jessy,778811,gjvbljh,474jdvff,pleaser,misskitty,breaker1,7f4df451,dayan,twinky,yakumo,chippers,matia,tanith,len2ski1,manni,nichol1,f00b4r,nokia3110,standart,123456789i,shami,steffie,larrywn,chucker,john99,chamois,jjjkkk,penmouse,ktnj2010,gooners,hemmelig,rodney1,merlin01,bearcat1,1yyyyy,159753z,1fffff,1ddddd,thomas11,gjkbyrf,ivanka,f1f2f3,petrovna,phunky,conair,brian2,creative1,klipsch,vbitymrf,freek,breitlin,cecili,westwing,gohabsgo,tippmann,1steve,quattro6,fatbob,sp00ky,rastas,1123581,redsea,rfnmrf,jerky1,1aaaaaa,spk666,simba123,qwert54321,123abcd,beavis69,fyfyfc,starr1,1236547,peanutbutter,sintra,12345abcde,1357246,abcde1,climbon,755dfx,mermaids,monte1,serkan,geilesau,777win,jasonc,parkside,imagine1,rockhead,producti,playhard,principa,spammer,gagher,escada,tsv1860,dbyjuhfl,cruiser1,kennyg,montgome,2481632,pompano,cum123,angel6,sooty,bear01,april6,bodyhamm,pugsly,getrich,mikes,pelusa,fosgate,jasonp,rostislav,kimberly1,128mo,dallas11,gooner1,manuel1,cocacola1,imesh,5782790,password8,daboys,1jones,intheend,e3w2q1,whisper1,madone,pjcgujrat,1p2o3i,jamesp,felicida,nemrac,phikap,firecat,jrcfyjxrf,matt12,bigfan,doedel,005500,jasonx,1234567k,badfish,goosey,utjuhfabz,wilco,artem123,igor123,spike123,jor23dan,dga9la,v2jmsz,morgan12,avery1,dogstyle,natasa,221195ws,twopac,oktober7,karthik,poop1,mightymo,davidr,zermatt,jehova,aezakmi1,dimwit,monkey5,serega123,qwerty111,blabl,casey22,boy123,1clutch,asdfjkl1,hariom,bruce10,jeep95,1smith,sm9934,karishma,bazzzz,aristo,669e53e1,nesterov,kill666,fihdfv,1abc2,anna1,silver11,mojoman,telefono,goeagles,sd3lpgdr,rfhfynby,melinda1,llcoolj,idteul,bigchief,rocky13,timberwo,ballers,gatekeep,kashif,hardass,anastasija,max777,vfuyjkbz,riesling,agent99,kappas,dalglish,tincan,orange3,turtoise,abkbvjy,mike24,hugedick,alabala,geolog,aziza,devilboy,habanero,waheguru,funboy,freedom5,natwest,seashore,impaler,qwaszx1,pastas,bmw535,tecktonik,mika00,jobsearc,pinche,puntang,aw96b6,1corvett,skorpio,foundati,zzr1100,gembird,vfnhjcrby,soccer18,vaz2110,peterp,archer1,cross1,samedi,dima1992,hunter99,lipper,hotbody,zhjckfdf,ducati1,trailer1,04325956,cheryl1,benetton,kononenko,sloneczko,rfgtkmrf,nashua,balalaika,ampere,eliston,dorsai,digge,flyrod,oxymoron,minolta,ironmike,majortom,karimov,fortun,putaria,an83546921an13,blade123,franchis,mxaigtg5,dynxyu,devlt4,brasi,terces,wqmfuh,nqdgxz,dale88,minchia,seeyou,housepen,1apple,1buddy,mariusz,bighouse,tango2,flimflam,nicola1,qwertyasd,tomek1,shumaher,kartoshka,bassss,canaries,redman1,123456789as,preciosa,allblacks,navidad,tommaso,beaudog,forrest1,green23,ryjgjxrf,go4it,ironman2,badnews,butterba,1grizzly,isaeva,rembrand,toront,1richard,bigjon,yfltymrf,1kitty,4ng62t,littlejo,wolfdog,ctvtyjd,spain1,megryan,tatertot,raven69,4809594q,tapout,stuntman,a131313,lagers,hotstuf,lfdbl11,stanley2,advokat,boloto,7894561,dooker,adxel187,cleodog,4play,0p9o8i,masterb,bimota,charlee,toystory,6820055,6666667,crevette,6031769,corsa,bingoo,dima1990,tennis11,samuri,avocado,melissa6,unicor,habari,metart,needsex,cockman,hernan,3891576,3334444,amigo1,gobuffs2,mike21,allianz,2835493,179355,midgard,joey123,oneluv,ellis1,towncar,shonuff,scouse,tool69,thomas19,chorizo,jblaze,lisa1,dima1999,sophia1,anna1989,vfvekbxrf,krasavica,redlegs,jason25,tbontb,katrine,eumesmo,vfhufhbnrf,1654321,asdfghj1,motdepas,booga,doogle,1453145,byron1,158272,kardinal,tanne,fallen1,abcd12345,ufyljy,n12345,kucing,burberry,bodger,1234578,februar,1234512,nekkid,prober,harrison1,idlewild,rfnz90,foiegras,pussy21,bigstud,denzel,tiffany2,bigwill,1234567890zzz,hello69,compute1,viper9,hellspaw,trythis,gococks,dogballs,delfi,lupine,millenia,newdelhi,charlest,basspro,1mike,joeblack,975310,1rosebud,batman11,misterio,fucknut,charlie0,august11,juancho,ilonka,jigei743ks,adam1234,889900,goonie,alicat,ggggggg1,1zzzzzzz,sexywife,northstar,chris23,888111,containe,trojan1,jason5,graikos,1ggggg,1eeeee,tigers01,indigo1,hotmale,jacob123,mishima,richard3,cjxb2014,coco123,meagain,thaman,wallst,edgewood,bundas,1power,matilda1,maradon,hookedup,jemima,r3vi3wpass,2004-10-,mudman,taz123,xswzaq,emerson1,anna21,warlord1,toering,pelle,tgwdvu,masterb8,wallstre,moppel,priora,ghjcnjrdfif,yoland,12332100,1j9e7f6f,jazzzz,yesman,brianm,42qwerty42,12345698,darkmanx,nirmal,john31,bb123456,neuspeed,billgates,moguls,fj1200,hbhlair,shaun1,ghbdfn,305pwzlr,nbu3cd,susanb,pimpdad,mangust6403,joedog,dawidek,gigante,708090,703751,700007,ikalcr,tbivbn,697769,marvi,iyaayas,karen123,jimmyboy,dozer1,e6z8jh,bigtime1,getdown,kevin12,brookly,zjduc3,nolan1,cobber,yr8wdxcq,liebe,m1garand,blah123,616879,action1,600000,sumitomo,albcaz,asian1,557799,dave69,556699,sasa123,streaker,michel1,karate1,buddy7,daulet,koks888,roadtrip,wapiti,oldguy,illini1,1234qq,mrspock,kwiatek,buterfly,august31,jibxhq,jackin,taxicab,tristram,talisker,446655,444666,chrisa,freespace,vfhbfyyf,chevell,444333,notyours,442244,christian1,seemore,sniper12,marlin1,joker666,multik,devilish,crf450,cdfoli,eastern1,asshead,duhast,voyager2,cyberia,1wizard,cybernet,iloveme1,veterok,karandash,392781,looksee,diddy,diabolic,foofight,missey,herbert1,bmw318i,premier1,zsfmpv,eric1234,dun6sm,fuck11,345543,spudman,lurker,bitem,lizzy1,ironsink,minami,339311,s7fhs127,sterne,332233,plankton,galax,azuywe,changepa,august25,mouse123,sikici,killer69,xswqaz,quovadis,gnomik,033028pw,777777a,barrakuda,spawn666,goodgod,slurp,morbius,yelnats,cujo31,norman1,fastone,earwig,aureli,wordlife,bnfkbz,yasmi,austin123,timberla,missy2,legalize,netcom,liljon,takeit,georgin,987654321z,warbird,vitalina,all4u3,mmmmmm1,bichon,ellobo,wahoos,fcazmj,aksarben,lodoss,satnam,vasili,197800,maarten,sam138989,0u812,ankita,walte,prince12,anvils,bestia,hoschi,198300,univer,jack10,ktyecbr,gr00vy,hokie,wolfman1,fuckwit,geyser,emmanue,ybrjkftd,qwerty33,karat,dblock,avocat,bobbym,womersle,1please,nostra,dayana,billyray,alternat,iloveu1,qwerty69,rammstein1,mystikal,winne,drawde,executor,craxxxs,ghjcnjnf,999888777,welshman,access123,963214785,951753852,babe69,fvcnthlfv,****me,666999666,testing2,199200,nintendo64,oscarr,guido8,zhanna,gumshoe,jbird,159357456,pasca,123452345,satan6,mithrand,fhbirf,aa1111aa,viggen,ficktjuv,radial9,davids1,rainbow7,futuro,hipho,platin,poppy123,rhenjq,fulle,rosit,chicano,scrumpy,lumpy1,seifer,uvmrysez,autumn1,xenon,susie1,7u8i9o0p,gamer1,sirene,muffy1,monkeys1,kalinin,olcrackmaster,hotmove,uconn,gshock,merson,lthtdyz,pizzaboy,peggy1,pistache,pinto1,fishka,ladydi,pandor,baileys,hungwell,redboy,rookie1,amanda01,passwrd,clean1,matty1,tarkus,jabba1,bobster,beer30,solomon1,moneymon,sesamo,fred11,sunnysid,jasmine5,thebears,putamadre,workhard,flashbac,counter1,liefde,magnat,corky1,green6,abramov,lordik,univers,shortys,david3,vip123,gnarly,1234567s,billy2,honkey,deathstar,grimmy,govinda,direktor,12345678s,linus1,shoppin,rekbrjdf,santeria,prett,berty75,mohican,daftpunk,uekmyfhf,chupa,strats,ironbird,giants56,salisbur,koldun,summer04,pondscum,jimmyj,miata1,george3,redshoes,weezie,bartman1,0p9o8i7u,s1lver,dorkus,125478,omega9,sexisgood,mancow,patric1,jetta1,074401,ghjuhtcc,gfhjk,bibble,terry2,123213,medicin,rebel2,hen3ry,4freedom,aldrin,lovesyou,browny,renwod,winnie1,belladon,1house,tyghbn,blessme,rfhfrfnbwf,haylee,deepdive,booya,phantasy,gansta,cock69,4mnveh,gazza1,redapple,structur,anakin1,manolito,steve01,poolman,chloe123,vlad1998,qazwsxe,pushit,random123,ontherocks,o236nq,brain1,dimedrol,agape,rovnogod,1balls,knigh,alliso,love01,wolf01,flintstone,beernuts,tuffguy,isengard,highfive,alex23,casper99,rubina,getreal,chinita,italian1,airsoft,qwerty23,muffdiver,willi1,grace123,orioles1,redbull1,chino1,ziggy123,breadman,estefan,ljcneg,gotoit,logan123,wideglid,mancity1,treess,qwe123456,kazumi,qweasdqwe,oddworld,naveed,protos,towson,a801016,godislov,at_asp,bambam1,soccer5,dark123,67vette,carlos123,hoser1,scouser,wesdxc,pelus,dragon25,pflhjn,abdula,1freedom,policema,tarkin,eduardo1,mackdad,gfhjkm11,lfplhfgthvf,adilet,zzzzxxxx,childre,samarkand,cegthgegth,shama,fresher,silvestr,greaser,allout,plmokn,sexdrive,nintendo1,fantasy7,oleander,fe126fd,crumpet,pingzing,dionis,hipster,yfcnz,requin,calliope,jerome1,housecat,abc123456789,doghot,snake123,augus,brillig,chronic1,gfhjkbot,expediti,noisette,master7,caliban,whitetai,favorite3,lisamari,educatio,ghjhjr,saber1,zcegth,1958proman,vtkrbq,milkdud,imajica,thehip,bailey10,hockey19,dkflbdjcnjr,j123456,bernar,aeiouy,gamlet,deltachi,endzone,conni,bcgfybz,brandi1,auckland2010,7653ajl1,mardigra,testuser,bunko18,camaro67,36936,greenie,454dfmcq,6xe8j2z4,mrgreen,ranger5,headhunt,banshee1,moonunit,zyltrc,hello3,pussyboy,stoopid,tigger11,yellow12,drums1,blue02,kils123,junkman,banyan,jimmyjam,tbbucs,sportster,badass1,joshie,braves10,lajolla,1amanda,antani,78787,antero,19216801,chich,rhett32,sarahm,beloit,sucker69,corkey,nicosnn,rccola,caracol,daffyduc,bunny2,mantas,monkies,hedonist,cacapipi,ashton1,sid123,19899891,patche,greekgod,cbr1000,leader1,19977991,ettore,chongo,113311,picass,cfif123,rhtfnbd,frances1,andy12,minnette,bigboy12,green69,alices,babcia,partyboy,javabean,freehand,qawsed123,xxx111,harold1,passwo,jonny1,kappa1,w2dlww3v5p,1merlin,222999,tomjones,jakeman,franken,markhegarty,john01,carole1,daveman,caseys,apeman,mookey,moon123,claret,titans1,residentevil,campari,curitiba,dovetail,aerostar,jackdaniels,basenji,zaq12w,glencoe,biglove,goober12,ncc170,far7766,monkey21,eclipse9,1234567v,vanechka,aristote,grumble,belgorod,abhishek,neworleans,pazzword,dummie,sashadog,diablo11,mst3000,koala1,maureen1,jake99,isaiah1,funkster,gillian1,ekaterina20,chibears,astra123,4me2no,winte,skippe,necro,windows9,vinograd,demolay,vika2010,quiksilver,19371ayj,dollar1,shecky,qzwxecrv,butterfly1,merrill1,scoreland,1crazy,megastar,mandragora,track1,dedhed,jacob2,newhope,qawsedrftgyh,shack1,samvel,gatita,shyster,clara1,telstar,office1,crickett,truls,nirmala,joselito,chrisl,lesnik,aaaabbbb,austin01,leto2010,bubbie,aaa12345,widder,234432,salinger,mrsmith,qazsedcft,newshoes,skunks,yt1300,bmw316,arbeit,smoove,123321qweewq,123qazwsx,22221111,seesaw,0987654321a,peach1,1029384756q,sereda,gerrard8,shit123,batcave,energy1,peterb,mytruck,peter12,alesya,tomato1,spirou,laputaxx,magoo1,omgkremidia,knight12,norton1,vladislava,shaddy,austin11,jlbyjxrf,kbdthgekm,punheta,fetish69,exploiter,roger2,manstein,gtnhjd,32615948worms,dogbreath,ujkjdjkjvrf,vodka1,ripcord,fatrat,kotek1,tiziana,larrybir,thunder3,nbvfnb,9kyq6fge,remembe,likemike,gavin1,shinigam,yfcnfcmz,13245678,jabbar,vampyr,ane4ka,lollipo,ashwin,scuderia,limpdick,deagle,3247562,vishenka,fdhjhf,alex02,volvov70,mandys,bioshock,caraca,tombraider,matrix69,jeff123,13579135,parazit,black3,noway1,diablos,hitmen,garden1,aminor,decembe,august12,b00ger,006900,452073t,schach,hitman1,mariner1,vbnmrf,paint1,742617000027,bitchboy,pfqxjyjr,5681392,marryher,sinnet,malik1,muffin12,aninha,piolin,lady12,traffic1,cbvjyf,6345789,june21,ivan2010,ryan123,honda99,gunny,coorslight,asd321,hunter69,7224763,sonofgod,dolphins1,1dolphin,pavlenko,woodwind,lovelov,pinkpant,gblfhfcbyf,hotel1,justinbiebe,vinter,jeff1234,mydogs,1pizza,boats1,parrothe,shawshan,brooklyn1,cbrown,1rocky,hemi426,dragon64,redwings1,porsches,ghostly,hubbahub,buttnut,b929ezzh,sorokina,flashg,fritos,b7mguk,metatron,treehous,vorpal,8902792,marcu,free123,labamba,chiefs1,zxc123zxc,keli_14,hotti,1steeler,money4,rakker,foxwoods,free1,ahjkjd,sidorova,snowwhit,neptune1,mrlover,trader1,nudelamb,baloo,power7,deltasig,bills1,trevo,7gorwell,nokia6630,nokia5320,madhatte,1cowboys,manga1,namtab,sanjar,fanny1,birdman1,adv12775,carlo1,dude1998,babyhuey,nicole11,madmike,ubvyfpbz,qawsedr,lifetec,skyhook,stalker123,toolong,robertso,ripazha,zippy123,1111111a,manol,dirtyman,analslut,jason3,dutches,minhasenha,cerise,fenrir,jayjay1,flatbush,franka,bhbyjxrf,26429vadim,lawntrax,198700,fritzy,nikhil,ripper1,harami,truckman,nemvxyheqdd5oqxyxyzi,gkfytnf,bugaboo,cableman,hairpie,xplorer,movado,hotsex69,mordred,ohyeah1,patrick3,frolov,katieh,4311111q,mochaj,presari,bigdo,753951852,freedom4,kapitan,tomas1,135795,sweet123,pokers,shagme,tane4ka,sentinal,ufgyndmv,jonnyb,skate123,123456798,123456788,very1,gerrit,damocles,dollarbi,caroline1,lloyds,pizdets,flatland,92702689,dave13,meoff,ajnjuhfabz,achmed,madison9,744744z,amonte,avrillavigne,elaine1,norma1,asseater,everlong,buddy23,cmgang1,trash1,mitsu,flyman,ulugbek,june27,magistr,fittan,sebora64,dingos,sleipnir,caterpil,cindys,212121qaz,partys,dialer,gjytltkmybr,qweqaz,janvier,rocawear,lostboy,aileron,sweety1,everest1,pornman,boombox,potter1,blackdic,44448888,eric123,112233aa,2502557i,novass,nanotech,yourname,x12345,indian1,15975300,1234567l,carla51,chicago0,coleta,cxzdsaewq,qqwweerr,marwan,deltic,hollys,qwerasd,pon32029,rainmake,nathan0,matveeva,legioner,kevink,riven,tombraid,blitzen,a54321,jackyl,chinese1,shalimar,oleg1995,beaches1,tommylee,eknock,berli,monkey23,badbob,pugwash,likewhoa,jesus2,yujyd360,belmar,shadow22,utfp5e,angelo1,minimax,pooder,cocoa1,moresex,tortue,lesbia,panthe,snoopy2,drumnbass,alway,gmcz71,6jhwmqku,leppard,dinsdale,blair1,boriqua,money111,virtuagirl,267605,rattlesn,1sunshin,monica12,veritas1,newmexic,millertime,turandot,rfvxfnrf,jaydog,kakawka,bowhunter,booboo12,deerpark,erreway,taylorma,rfkbybyf,wooglin,weegee,rexdog,iamhorny,cazzo1,vhou812,bacardi1,dctktyyfz,godpasi,peanut12,bertha1,fuckyoubitch,ghosty,altavista,jertoot,smokeit,ghjcnbvtyz,fhnehxbr,rolsen,qazxcdews,maddmaxx,redrocke,qazokm,spencer2,thekiller,asdf11,123sex,tupac1,p1234567,dbrown,1biteme,tgo4466,316769,sunghi,shakespe,frosty1,gucci1,arcana,bandit01,lyubov,poochy,dartmout,magpies1,sunnyd,mouseman,summer07,chester7,shalini,danbury,pigboy,dave99,deniss,harryb,ashley11,pppppp1,01081988m,balloon1,tkachenko,bucks1,master77,pussyca,tricky1,zzxxccvv,zoulou,doomer,mukesh,iluv69,supermax,todays,thefox,don123,dontask,diplom,piglett,shiney,fahbrf,qaz12wsx,temitope,reggin,project1,buffy2,inside1,lbpfqyth,vanilla1,lovecock,u4slpwra,fylh.irf,123211,7ertu3ds,necroman,chalky,artist1,simpso,4x7wjr,chaos666,lazyacres,harley99,ch33s3,marusa,eagle7,dilligas,computadora,lucky69,denwer,nissan350z,unforgiv,oddball,schalke0,aztec1,borisova,branden1,parkave,marie123,germa,lafayett,878kckxy,405060,cheeseca,bigwave,fred22,andreea,poulet,mercutio,psycholo,andrew88,o4izdmxu,sanctuar,newhome,milion,suckmydi,rjvgm.nth,warior,goodgame,1qwertyuiop,6339cndh,scorpio2,macker,southbay,crabcake,toadie,paperclip,fatkid,maddo,cliff1,rastafar,maries,twins1,geujdrf,anjela,wc4fun,dolina,mpetroff,rollout,zydeco,shadow3,pumpki,steeda,volvo240,terras,blowjo,blue2000,incognit,badmojo,gambit1,zhukov,station1,aaronb,graci,duke123,clipper1,qazxsw2,ledzeppe,kukareku,sexkitte,cinco,007008,lakers12,a1234b,acmilan1,afhfjy,starrr,slutty3,phoneman,kostyan,bonzo1,sintesi07,ersatz,cloud1,nephilim,nascar03,rey619,kairos,123456789e,hardon1,boeing1,juliya,hfccdtn,vgfun8,polizei,456838,keithb,minouche,ariston,savag,213141,clarkken,microwav,london2,santacla,campeo,qr5mx7,464811,mynuts,bombo,1mickey,lucky8,danger1,ironside,carter12,wyatt1,borntorun,iloveyou123,jose1,pancake1,tadmichaels,monsta,jugger,hunnie,triste,heat7777,ilovejesus,queeny,luckycharm,lieben,gordolee85,jtkirk,forever21,jetlag,skylane,taucher,neworlea,holera,000005,anhnhoem,melissa7,mumdad,massimiliano,dima1994,nigel1,madison3,slicky,shokolad,serenit,jmh1978,soccer123,chris3,drwho,rfpzdrf,1qasw23ed,free4me,wonka,sasquatc,sanan,maytag,verochka,bankone,molly12,monopoli,xfqybr,lamborgini,gondolin,candycane,needsome,jb007,scottie1,brigit,0147258369,kalamazo,lololyo123,bill1234,ilovejes,lol123123,popkorn,april13,567rntvm,downunde,charle1,angelbab,guildwars,homeworld,qazxcvbnm,superma1,dupa123,kryptoni,happyy,artyom,stormie,cool11,calvin69,saphir,konovalov,jansport,october8,liebling,druuna,susans,megans,tujhjdf,wmegrfux,jumbo1,ljb4dt7n,012345678910,kolesnik,speculum,at4gftlw,kurgan,93pn75,cahek0980,dallas01,godswill,fhifdby,chelsea4,jump23,barsoom,catinhat,urlacher,angel99,vidadi1,678910,lickme69,topaz1,westend,loveone,c12345,gold12,alex1959,mamon,barney12,1maggie,alex12345,lp2568cskt,s1234567,gjikbdctyf,anthony0,browns99,chips1,sunking,widespre,lalala1,tdutif,fucklife,master00,alino4ka,stakan,blonde1,phoebus,tenore,bvgthbz,brunos,suzjv8,uvdwgt,revenant,1banana,veroniqu,sexfun,sp1der,4g3izhox,isakov,shiva1,scooba,bluefire,wizard12,dimitris,funbags,perseus,hoodoo,keving,malboro,157953,a32tv8ls,latics,animate,mossad,yejntb,karting,qmpq39zr,busdrive,jtuac3my,jkne9y,sr20dett,4gxrzemq,keylargo,741147,rfktylfhm,toast1,skins1,xcalibur,gattone,seether,kameron,glock9mm,julio1,delenn,gameday,tommyd,str8edge,bulls123,66699,carlsberg,woodbird,adnama,45auto,codyman,truck2,1w2w3w4w,pvjegu,method1,luetdi,41d8cd98f00b,bankai,5432112345,94rwpe,reneee,chrisx,melvins,775577,sam2000,scrappy1,rachid,grizzley,margare,morgan01,winstons,gevorg,gonzal,crawdad,gfhfdjp,babilon,noneya,pussy11,barbell,easyride,c00li0,777771,311music,karla1,golions,19866891,peejay,leadfoot,hfvbkm,kr9z40sy,cobra123,isotwe,grizz,sallys,****you,aaa123a,dembel,foxs14,hillcres,webman,mudshark,alfredo1,weeded,lester1,hovepark,ratface,000777fffa,huskie,wildthing,elbarto,waikiki,masami,call911,goose2,regin,dovajb,agricola,cjytxrj,andy11,penny123,family01,a121212,1braves,upupa68,happy100,824655,cjlove,firsttim,kalel,redhair,dfhtymt,sliders,bananna,loverbo,fifa2008,crouton,chevy350,panties2,kolya1,alyona,hagrid,spagetti,q2w3e4r,867530,narkoman,nhfdvfnjkju123,1ccccccc,napolean,0072563,allay,w8sted,wigwam,jamesk,state1,parovoz,beach69,kevinb,rossella,logitech1,celula,gnocca,canucks1,loginova,marlboro1,aaaa1,kalleanka,mester,mishutka,milenko,alibek,jersey1,peterc,1mouse,nedved,blackone,ghfplybr,682regkh,beejay,newburgh,ruffian,clarets,noreaga,xenophon,hummerh2,tenshi,smeagol,soloyo,vfhnby,ereiamjh,ewq321,goomie,sportin,cellphone,sonnie,jetblack,saudan,gblfhfc,matheus,uhfvjnf,alicja,jayman1,devon1,hexagon,bailey2,vtufajy,yankees7,salty1,908070,killemal,gammas,eurocard,sydney12,tuesday1,antietam,wayfarer,beast666,19952009sa,aq12ws,eveli,hockey21,haloreach,dontcare,xxxx1,andrea11,karlmarx,jelszo,tylerb,protools,timberwolf,ruffneck,pololo,1bbbbb,waleed,sasami,twinss,fairlady,illuminati,alex007,sucks1,homerjay,scooter7,tarbaby,barmaley,amistad,vanes,randers,tigers12,dreamer2,goleafsg,googie,bernie1,as12345,godeep,james3,phanto,gwbush,cumlover,2196dc,studioworks,995511,golf56,titova,kaleka,itali,socks1,kurwamac,daisuke,hevonen,woody123,daisie,wouter,henry123,gostosa,guppie,porpoise,iamsexy,276115,paula123,1020315,38gjgeuftd,rjrfrjkf,knotty,idiot1,sasha12345,matrix13,securit,radical1,ag764ks,jsmith,coolguy1,secretar,juanas,sasha1988,itout,00000001,tiger11,1butthea,putain,cavalo,basia1,kobebryant,1232323,12345asdfg,sunsh1ne,cyfqgth,tomkat,dorota,dashit,pelmen,5t6y7u,whipit,smokeone,helloall,bonjour1,snowshoe,nilknarf,x1x2x3,lammas,1234599,lol123456,atombomb,ironchef,noclue,alekseev,gwbush1,silver2,12345678m,yesican,fahjlbnf,chapstic,alex95,open1,tiger200,lisichka,pogiako,cbr929,searchin,tanya123,alex1973,phil413,alex1991,dominati,geckos,freddi,silenthill,egroeg,vorobey,antoxa,dark666,shkola,apple22,rebellio,shamanking,7f8srt,cumsucker,partagas,bill99,22223333,arnster55,fucknuts,proxima,silversi,goblues,parcells,vfrcbvjdf,piloto,avocet,emily2,1597530,miniskir,himitsu,pepper2,juiceman,venom1,bogdana,jujube,quatro,botafogo,mama2010,junior12,derrickh,asdfrewq,miller2,chitarra,silverfox,napol,prestigio,devil123,mm111qm,ara123,max33484,sex2000,primo1,sephan,anyuta,alena2010,viborg,verysexy,hibiscus,terps,josefin,oxcart,spooker,speciali,raffaello,partyon,vfhvtkflrf,strela,a123456z,worksuck,glasss,lomonosov,dusty123,dukeblue,1winter,sergeeva,lala123,john22,cmc09,sobolev,bettylou,dannyb,gjkrjdybr,hagakure,iecnhbr,awsedr,pmdmsctsk,costco,alekseeva,fktrcttd,bazuka,flyingv,garuda,buffy16,gutierre,beer12,stomatolog,ernies,palmeiras,golf123,love269,n.kmgfy,gjkysqgbpltw,youare,joeboo,baksik,lifeguar,111a111,nascar8,mindgame,dude1,neopets,frdfkfyu,june24,phoenix8,penelopa,merlin99,mercenar,badluck,mishel,bookert,deadsexy,power9,chinchil,1234567m,alex10,skunk1,rfhkcjy,sammycat,wright1,randy2,marakesh,temppassword,elmer251,mooki,patrick0,bonoedge,1tits,chiar,kylie1,graffix,milkman1,cornel,mrkitty,nicole12,ticketmaster,beatles4,number20,ffff1,terps1,superfre,yfdbufnjh,jake1234,flblfc,1111qq,zanuda,jmol01,wpoolejr,polopol,nicolett,omega13,cannonba,123456789.,sandy69,ribeye,bo243ns,marilena,bogdan123,milla,redskins1,19733791,alias1,movie1,ducat,marzena,shadowru,56565,coolman1,pornlover,teepee,spiff,nafanya,gateway3,fuckyou0,hasher,34778,booboo69,staticx,hang10,qq12345,garnier,bosco123,1234567qw,carson1,samso,1xrg4kcq,cbr929rr,allan123,motorbik,andrew22,pussy101,miroslava,cytujdbr,camp0017,cobweb,snusmumrik,salmon1,cindy2,aliya,serendipity,co437at,tincouch,timmy123,hunter22,st1100,vvvvvv1,blanka,krondor,sweeti,nenit,kuzmich,gustavo1,bmw320i,alex2010,trees1,kyliem,essayons,april26,kumari,sprin,fajita,appletre,fghbjhb,1green,katieb,steven2,corrado1,satelite,1michell,123456789c,cfkfvfylhf,acurarsx,slut543,inhere,bob2000,pouncer,k123456789,fishie,aliso,audia8,bluetick,soccer69,jordan99,fromhell,mammoth1,fighting54,mike25,pepper11,extra1,worldwid,chaise,vfr800,sordfish,almat,nofate,listopad,hellgate,dctvghbdf,jeremia,qantas,lokiju,honker,sprint1,maral,triniti,compaq3,sixsix6,married1,loveman,juggalo1,repvtyrj,zxcasdqw,123445,whore1,123678,monkey6,west123,warcraf,pwnage,mystery1,creamyou,ant123,rehjgfnrf,corona1,coleman1,steve121,alderaan,barnaul,celeste1,junebug1,bombshel,gretzky9,tankist,targa,cachou,vaz2101,playgolf,boneyard,strateg,romawka,iforgotit,pullup,garbage1,irock,archmage,shaft1,oceano,sadies,alvin1,135135ab,psalm69,lmfao,ranger02,zaharova,33334444,perkman,realman,salguod,cmoney,astonmartin,glock1,greyfox,viper99,helpm,blackdick,46775575,family5,shazbot,dewey1,qwertyas,shivani,black22,mailman1,greenday1,57392632,red007,stanky,sanchez1,tysons,daruma,altosax,krayzie,85852008,1forever,98798798,irock.,123456654,142536789,ford22,brick1,michela,preciou,crazy4u,01telemike01,nolife,concac,safety1,annie123,brunswic,destini,123456qwer,madison0,snowball1,137946,1133557799,jarule,scout2,songohan,thedead,00009999,murphy01,spycam,hirsute,aurinko,associat,1miller,baklan,hermes1,2183rm,martie,kangoo,shweta,yvonne1,westsid,jackpot1,rotciv,maratik,fabrika,claude1,nursultan,noentry,ytnhjufnm,electra1,ghjcnjnfr1,puneet,smokey01,integrit,bugeye,trouble2,14071789,paul01,omgwtf,dmh415,ekilpool,yourmom1,moimeme,sparky11,boludo,ruslan123,kissme1,demetrio,appelsin,asshole3,raiders2,bunns,fynjybj,billygoa,p030710p$e4o,macdonal,248ujnfk,acorns,schmidt1,sparrow1,vinbylrj,weasle,jerom,ycwvrxxh,skywalk,gerlinde,solidus,postal1,poochie1,1charles,rhianna,terorist,rehnrf,omgwtfbbq,assfucke,deadend,zidan,jimboy,vengence,maroon5,7452tr,dalejr88,sombra,anatole,elodi,amazonas,147789,q12345q,gawker1,juanma,kassidy,greek1,bruces,bilbob,mike44,0o9i8u7y6t,kaligula,agentx,familie,anders1,pimpjuice,0128um,birthday10,lawncare,hownow,grandorgue,juggerna,scarfac,kensai,swatteam,123four,motorbike,repytxbr,other1,celicagt,pleomax,gen0303,godisgreat,icepick,lucifer666,heavy1,tea4two,forsure,02020,shortdog,webhead,chris13,palenque,3techsrl,knights1,orenburg,prong,nomarg,wutang1,80637852730,laika,iamfree,12345670,pillow1,12343412,bigears,peterg,stunna,rocky5,12123434,damir,feuerwehr,7418529630,danone,yanina,valenci,andy69,111222q,silvia1,1jjjjj,loveforever,passwo1,stratocaster,8928190a,motorolla,lateralu,ujujkm,chubba,ujkjdf,signon,123456789zx,serdce,stevo,wifey200,ololo123,popeye1,1pass,central1,melena,luxor,nemezida,poker123,ilovemusic,qaz1234,noodles1,lakeshow,amarill,ginseng,billiam,trento,321cba,fatback,soccer33,master13,marie2,newcar,bigtop,dark1,camron,nosgoth,155555,biglou,redbud,jordan7,159789,diversio,actros,dazed,drizzit,hjcnjd,wiktoria,justic,gooses,luzifer,darren1,chynna,tanuki,11335577,icculus,boobss,biggi,firstson,ceisi123,gatewa,hrothgar,jarhead1,happyjoy,felipe1,bebop1,medman,athena1,boneman,keiths,djljgfl,dicklick,russ120,mylady,zxcdsa,rock12,bluesea,kayaks,provista,luckies,smile4me,bootycal,enduro,123123f,heartbre,ern3sto,apple13,bigpappa,fy.njxrf,bigtom,cool69,perrito,quiet1,puszek,cious,cruella,temp1,david26,alemap,aa123123,teddies,tricolor,smokey12,kikiriki,mickey01,robert01,super5,ranman,stevenso,deliciou,money777,degauss,mozar,susanne1,asdasd12,shitbag,mommy123,wrestle1,imfree,fuckyou12,barbaris,florent,ujhijr,f8yruxoj,tefjps,anemone,toltec,2gether,left4dead2,ximen,gfkmvf,dunca,emilys,diana123,16473a,mark01,bigbro,annarbor,nikita2000,11aa11,tigres,llllll1,loser2,fbi11213,jupite,qwaszxqw,macabre,123ert,rev2000,mooooo,klapaucius,bagel1,chiquit,iyaoyas,bear101,irocz28,vfktymrfz,smokey2,love99,rfhnbyf,dracul,keith123,slicko,peacock1,orgasmic,thesnake,solder,wetass,doofer,david5,rhfcyjlfh,swanny,tammys,turkiye,tubaman,estefani,firehose,funnyguy,servo,grace17,pippa1,arbiter,jimmy69,nfymrf,asdf67nm,rjcnzy,demon123,thicknes,sexysex,kristall,michail,encarta,banderos,minty,marchenko,de1987ma,mo5kva,aircav,naomi1,bonni,tatoo,cronaldo,49ers1,mama1963,1truck,telecaster,punksnotdead,erotik,1eagles,1fender,luv269,acdeehan,tanner1,freema,1q3e5t7u,linksys,tiger6,megaman1,neophyte,australia1,mydaddy,1jeffrey,fgdfgdfg,gfgekz,1986irachka,keyman,m0b1l3,dfcz123,mikeyg,playstation2,abc125,slacker1,110491g,lordsoth,bhavani,ssecca,dctvghbdtn,niblick,hondacar,baby01,worldcom,4034407,51094didi,3657549,3630000,3578951,sweetpussy,majick,supercoo,robert11,abacabb,panda123,gfhjkm13,ford4x4,zippo1,lapin,1726354,lovesong,dude11,moebius,paravoz,1357642,matkhau,solnyshko,daniel4,multiplelog,starik,martusia,iamtheman,greentre,jetblue,motorrad,vfrcbvev,redoak,dogma1,gnorman,komlos,tonka1,1010220,666satan,losenord,lateralus,absinthe,command1,jigga1,iiiiiii1,pants1,jungfrau,926337,ufhhbgjnnth,yamakasi,888555,sunny7,gemini69,alone1,zxcvbnmz,cabezon,skyblues,zxc1234,456123a,zero00,caseih,azzurra,legolas1,menudo,murcielago,785612,779977,benidorm,viperman,dima1985,piglet1,hemligt,hotfeet,7elephants,hardup,gamess,a000000,267ksyjf,kaitlynn,sharkie,sisyphus,yellow22,667766,redvette,666420,mets69,ac2zxdty,hxxrvwcy,cdavis,alan1,noddy,579300,druss,eatshit1,555123,appleseed,simpleplan,kazak,526282,fynfyfyfhbde,birthday6,dragon6,1pookie,bluedevils,omg123,hj8z6e,x5dxwp,455445,batman23,termin,chrisbrown,animals1,lucky9,443322,kzktxrf,takayuki,fermer,assembler,zomu9q,sissyboy,sergant,felina,nokia6230i,eminem12,croco,hunt4red,festina,darknigh,cptnz062,ndshnx4s,twizzler,wnmaz7sd,aamaax,gfhfcjkmrf,alabama123,barrynov,happy5,punt0it,durandal,8xuuobe4,cmu9ggzh,bruno12,316497,crazyfrog,vfvfktyf,apple3,kasey1,mackdaddy,anthon1,sunnys,angel3,cribbage,moon1,donal,bryce1,pandabear,mwss474,whitesta,freaker,197100,bitche,p2ssw0rd,turnb,tiktonik,moonlite,ferret1,jackas,ferrum,bearclaw,liberty2,1diablo,caribe,snakeeyes,janbam,azonic,rainmaker,vetalik,bigeasy,baby1234,sureno13,blink1,kluivert,calbears,lavanda,198600,dhtlbyf,medvedeva,fox123,whirling,bonscott,freedom9,october3,manoman,segredo,cerulean,robinso,bsmith,flatus,dannon,password21,rrrrrr1,callista,romai,rainman1,trantor,mickeymo,bulldog7,g123456,pavlin,pass22,snowie,hookah,7ofnine,bubba22,cabible,nicerack,moomoo1,summer98,yoyo123,milan1,lieve27,mustang69,jackster,exocet,nadege,qaz12,bahama,watson1,libras,eclipse2,bahram,bapezm,up9x8rww,ghjcnjz,themaste,deflep27,ghost16,gattaca,fotograf,junior123,gilber,gbjyth,8vjzus,rosco1,begonia,aldebara,flower12,novastar,buzzman,manchild,lopez1,mama11,william7,yfcnz1,blackstar,spurs123,moom4242,1amber,iownyou,tightend,07931505,paquito,1johnson,smokepot,pi31415,snowmass,ayacdc,jessicam,giuliana,5tgbnhy6,harlee,giuli,bigwig,tentacle,scoubidou2,benelli,vasilina,nimda,284655,jaihind,lero4ka,1tommy,reggi,ididit,jlbyjxtcndj,mike26,qbert,wweraw,lukasz,loosee123,palantir,flint1,mapper,baldie,saturne,virgin1,meeeee,elkcit,iloveme2,blue15,themoon,radmir,number3,shyanne,missle,hannelor,jasmina,karin1,lewie622,ghjcnjqgfhjkm,blasters,oiseau,sheela,grinders,panget,rapido,positiv,twink,fltkbyf,kzsfj874,daniel01,enjoyit,nofags,doodad,rustler,squealer,fortunat,peace123,khushi,devils2,7inches,candlebo,topdawg,armen,soundman,zxcqweasd,april7,gazeta,netman,hoppers,bear99,ghbjhbntn,mantle7,bigbo,harpo,jgordon,bullshi,vinny1,krishn,star22,thunderc,galinka,phish123,tintable,nightcrawler,tigerboy,rbhgbx,messi,basilisk,masha1998,nina123,yomamma,kayla123,geemoney,0000000000d,motoman,a3jtni,ser123,owen10,italien,vintelok,12345rewq,nightime,jeepin,ch1tt1ck,mxyzptlk,bandido,ohboy,doctorj,hussar,superted,parfilev,grundle,1jack,livestrong,chrisj,matthew3,access22,moikka,fatone,miguelit,trivium,glenn1,smooches,heiko,dezember,spaghett,stason,molokai,bossdog,guitarma,waderh,boriska,photosho,path13,hfrtnf,audre,junior24,monkey24,silke,vaz21093,bigblue1,trident1,candide,arcanum,klinker,orange99,bengals1,rosebu,mjujuj,nallepuh,mtwapa1a,ranger69,level1,bissjop,leica,1tiffany,rutabega,elvis77,kellie1,sameas,barada,karabas,frank12,queenb,toutoune,surfcity,samanth1,monitor1,littledo,kazakova,fodase,mistral1,april22,carlit,shakal,batman123,fuckoff2,alpha01,5544332211,buddy3,towtruck,kenwood1,vfiekmrf,jkl123,pypsik,ranger75,sitges,toyman,bartek1,ladygirl,booman,boeing77,installsqlst,222666,gosling,bigmack,223311,bogos,kevin2,gomez1,xohzi3g4,kfnju842,klubnika,cubalibr,123456789101,kenpo,0147852369,raptor1,tallulah,boobys,jjones,1q2s3c,moogie,vid2600,almas,wombat1,extra300,xfiles1,green77,sexsex1,heyjude,sammyy,missy123,maiyeuem,nccpl25282,thicluv,sissie,raven3,fldjrfn,buster22,broncos2,laurab,letmein4,harrydog,solovey,fishlips,asdf4321,ford123,superjet,norwegen,movieman,psw333333,intoit,postbank,deepwate,ola123,geolog323,murphys,eshort,a3eilm2s2y,kimota,belous,saurus,123321qaz,i81b4u,aaa12,monkey20,buckwild,byabybnb,mapleleafs,yfcnzyfcnz,baby69,summer03,twista,246890,246824,ltcnhjth,z1z2z3,monika1,sad123,uto29321,bathory,villan,funkey,poptarts,spam967888,705499fh,sebast,porn1234,earn381,1porsche,whatthef,123456789y,polo12,brillo,soreilly,waters1,eudora,allochka,is_a_bot,winter00,bassplay,531879fiz,onemore,bjarne,red911,kot123,artur1,qazxdr,c0rvette,diamond7,matematica,klesko,beaver12,2enter,seashell,panam,chaching,edward2,browni,xenogear,cornfed,aniram,chicco22,darwin1,ancella2,sophie2,vika1998,anneli,shawn41,babie,resolute,pandora2,william8,twoone,coors1,jesusis1,teh012,cheerlea,renfield,tessa1,anna1986,madness1,bkmlfh,19719870,liebherr,ck6znp42,gary123,123654z,alsscan,eyedoc,matrix7,metalgea,chinito,4iter,falcon11,7jokx7b9du,bigfeet,tassadar,retnuh,muscle1,klimova,darion,batistuta,bigsur,1herbier,noonie,ghjrehjh,karimova,faustus,snowwhite,1manager,dasboot,michael12,analfuck,inbed,dwdrums,jaysoncj,maranell,bsheep75,164379,rolodex,166666,rrrrrrr1,almaz666,167943,russel1,negrito,alianz,goodpussy,veronik,1w2q3r4e,efremov,emb377,sdpass,william6,alanfahy,nastya1995,panther5,automag,123qwe12,vfvf2011,fishe,1peanut,speedie,qazwsx1234,pass999,171204j,ketamine,sheena1,energizer,usethis1,123abc123,buster21,thechamp,flvbhfk,frank69,chane,hopeful1,claybird,pander,anusha,bigmaxxx,faktor,housebed,dimidrol,bigball,shashi,derby1,fredy,dervish,bootycall,80988218126,killerb,cheese2,pariss,mymail,dell123,catbert,christa1,chevytru,gjgjdf,00998877,overdriv,ratten,golf01,nyyanks,dinamite,bloembol,gismo,magnus1,march2,twinkles,ryan22,duckey,118a105b,kitcat,brielle,poussin,lanzarot,youngone,ssvegeta,hero63,battle1,kiler,fktrcfylh1,newera,vika1996,dynomite,oooppp,beer4me,foodie,ljhjuf,sonshine,godess,doug1,constanc,thinkbig,steve2,damnyou,autogod,www333,kyle1,ranger7,roller1,harry2,dustin1,hopalong,tkachuk,b00bies,bill2,deep111,stuffit,fire69,redfish1,andrei123,graphix,1fishing,kimbo1,mlesp31,ifufkbyf,gurkan,44556,emily123,busman,and123,8546404,paladine,1world,bulgakov,4294967296,bball23,1wwwww,mycats,elain,delta6,36363,emilyb,color1,6060842,cdtnkfyrf,hedonism,gfgfrfhkj,5551298,scubad,gostate,sillyme,hdbiker,beardown,fishers,sektor,00000007,newbaby,rapid1,braves95,gator2,nigge,anthony3,sammmy,oou812,heffer,phishin,roxanne1,yourass,hornet1,albator,2521659,underwat,tanusha,dianas,3f3fpht7op,dragon20,bilbobag,cheroke,radiatio,dwarf1,majik,33st33,dochka,garibald,robinh,sham69,temp01,wakeboar,violet1,1w2w3w,registr,tonite,maranello,1593570,parolamea,galatasara,loranthos,1472583,asmodean,1362840,scylla,doneit,jokerr,porkypig,kungen,mercator,koolhaas,come2me,debbie69,calbear,liverpoolfc,yankees4,12344321a,kennyb,madma,85200258,dustin23,thomas13,tooling,mikasa,mistic,crfnbyf,112233445,sofia1,heinz57,colts1,price1,snowey,joakim,mark11,963147,cnhfcnm,kzinti,1bbbbbbb,rubberdu,donthate,rupert1,sasha1992,regis1,nbuhbwf,fanboy,sundial,sooner1,wayout,vjnjhjkf,deskpro,arkangel,willie12,mikeyb,celtic1888,luis1,buddy01,duane1,grandma1,aolcom,weeman,172839456,basshead,hornball,magnu,pagedown,molly2,131517,rfvtgbyhn,astonmar,mistery,madalina,cash1,1happy,shenlong,matrix01,nazarova,369874125,800500,webguy,rse2540,ashley2,briank,789551,786110,chunli,j0nathan,greshnik,courtne,suckmyco,mjollnir,789632147,asdfg1234,754321,odelay,ranma12,zebedee,artem777,bmw318is,butt1,rambler1,yankees9,alabam,5w76rnqp,rosies,mafioso,studio1,babyruth,tranzit,magical123,gfhjkm135,12345$,soboleva,709394,ubique,drizzt1,elmers,teamster,pokemons,1472583690,1597532486,shockers,merckx,melanie2,ttocs,clarisse,earth1,dennys,slobber,flagman,farfalla,troika,4fa82hyx,hakan,x4ww5qdr,cumsuck,leather1,forum1,july20,barbel,zodiak,samuel12,ford01,rushfan,bugsy1,invest1,tumadre,screwme,a666666,money5,henry8,tiddles,sailaway,starburs,100years,killer01,comando,hiromi,ranetka,thordog,blackhole,palmeira,verboten,solidsna,q1w1e1,humme,kevinc,gbrfxe,gevaudan,hannah11,peter2,vangar,sharky7,talktome,jesse123,chuchi,pammy,!qazxsw2,siesta,twenty1,wetwilly,477041,natural1,sun123,daniel3,intersta,shithead1,hellyea,bonethugs,solitair,bubbles2,father1,nick01,444000,adidas12,dripik,cameron2,442200,a7nz8546,respublika,fkojn6gb,428054,snoppy,rulez1,haslo,rachael1,purple01,zldej102,ab12cd34,cytuehjxrf,madhu,astroman,preteen,handsoff,mrblonde,biggio,testin,vfdhif,twolves,unclesam,asmara,kpydskcw,lg2wmgvr,grolsch,biarritz,feather1,williamm,s62i93,bone1,penske,337733,336633,taurus1,334433,billet,diamondd,333000,nukem,fishhook,godogs,thehun,lena1982,blue00,smelly1,unb4g9ty,65pjv22,applegat,mikehunt,giancarlo,krillin,felix123,december1,soapy,46doris,nicole23,bigsexy1,justin10,pingu,bambou,falcon12,dgthtl,1surfer,qwerty01,estrellit,nfqcjy,easygo,konica,qazqwe,1234567890m,stingers,nonrev,3e4r5t,champio,bbbbbb99,196400,allen123,seppel,simba2,rockme,zebra3,tekken3,endgame,sandy2,197300,fitte,monkey00,eldritch,littleone,rfyfgkz,1member,66chevy,oohrah,cormac,hpmrbm41,197600,grayfox,elvis69,celebrit,maxwell7,rodders,krist,1camaro,broken1,kendall1,silkcut,katenka,angrick,maruni,17071994a,tktyf,kruemel,snuffles,iro4ka,baby12,alexis01,marryme,vlad1994,forward1,culero,badaboom,malvin,hardtoon,hatelove,molley,knopo4ka,duchess1,mensuck,cba321,kickbutt,zastava,wayner,fuckyou6,eddie123,cjkysir,john33,dragonfi,cody1,jabell,cjhjrf,badseed,sweden1,marihuana,brownlov,elland,nike1234,kwiettie,jonnyboy,togepi,billyk,robert123,bb334,florenci,ssgoku,198910,bristol1,bob007,allister,yjdujhjl,gauloise,198920,bellaboo,9lives,aguilas,wltfg4ta,foxyroxy,rocket69,fifty50,babalu,master21,malinois,kaluga,gogosox,obsessio,yeahrigh,panthers1,capstan,liza2000,leigh1,paintball1,blueskie,cbr600f3,bagdad,jose98,mandreki,shark01,wonderbo,muledeer,xsvnd4b2,hangten,200001,grenden,anaell,apa195,model1,245lufpq,zip100,ghjcgtrn,wert1234,misty2,charro,juanjose,fkbcrf,frostbit,badminto,buddyy,1doctor,vanya,archibal,parviz,spunky1,footboy,dm6tzsgp,legola,samadhi,poopee,ytdxz2ca,hallowboy,dposton,gautie,theworm,guilherme,dopehead,iluvtits,bobbob1,ranger6,worldwar,lowkey,chewbaca,oooooo99,ducttape,dedalus,celular,8i9o0p,borisenko,taylor01,111111z,arlingto,p3nnywiz,rdgpl3ds,boobless,kcmfwesg,blacksab,mother2,markus1,leachim,secret2,s123456789,1derful,espero,russell2,tazzer,marykate,freakme,mollyb,lindros8,james00,gofaster,stokrotka,kilbosik,aquamann,pawel1,shedevil,mousie,slot2009,october6,146969,mm259up,brewcrew,choucho,uliana,sexfiend,fktirf,pantss,vladimi,starz,sheeps,12341234q,bigun,tiggers,crjhjcnm,libtech,pudge1,home12,zircon,klaus1,jerry2,pink1,lingus,monkey66,dumass,polopolo09,feuerweh,rjyatnf,chessy,beefer,shamen,poohbear1,4jjcho,bennevis,fatgirls,ujnbrf,cdexswzaq,9noize9,rich123,nomoney,racecar1,hacke,clahay,acuario,getsum,hondacrv,william0,cheyenn,techdeck,atljhjdf,wtcacq,suger,fallenangel,bammer,tranquil,carla123,relayer,lespaul1,portvale,idontno,bycnbnen,trooper2,gennadiy,pompon,billbob,amazonka,akitas,chinatow,atkbrc,busters,fitness1,cateye,selfok2013,1murphy,fullhous,mucker,bajskorv,nectarin,littlebitch,love24,feyenoor,bigal37,lambo1,pussybitch,icecube1,biged,kyocera,ltybcjdf,boodle,theking1,gotrice,sunset1,abm1224,fromme,sexsells,inheat,kenya1,swinger1,aphrodit,kurtcobain,rhind101,poidog,poiulkjh,kuzmina,beantown,tony88,stuttgar,drumer,joaqui,messenge,motorman,amber2,nicegirl,rachel69,andreia,faith123,studmuffin,jaiden,red111,vtkmybr,gamecocks,gumper,bosshogg,4me2know,tokyo1,kleaner,roadhog,fuckmeno,phoenix3,seeme,buttnutt,boner69,andreyka,myheart,katerin,rugburn,jvtuepip,dc3ubn,chile1,ashley69,happy99,swissair,balls2,fylhttdf,jimboo,55555d,mickey11,voronin,m7hsqstm,stufff,merete,weihnachte,dowjones,baloo1,freeones,bears34,auburn1,beverl,timberland,1elvis,guinness1,bombadil,flatron1,logging7,telefoon,merl1n,masha1,andrei1,cowabung,yousuck1,1matrix,peopl,asd123qwe,sweett,mirror1,torrente,joker12,diamond6,jackaroo,00000a,millerlite,ironhorse,2twins,stryke,gggg1,zzzxxxccc,roosevel,8363eddy,angel21,depeche1,d0ct0r,blue14,areyou,veloce,grendal,frederiksberg,cbcntvf,cb207sl,sasha2000,was.here,fritzz,rosedale,spinoza,cokeisit,gandalf3,skidmark,ashley01,12345j,1234567890qaz,sexxxxxx,beagles,lennart,12345789,pass10,politic,max007,gcheckou,12345611,tiffy,lightman,mushin,velosiped,brucewayne,gauthie,elena123,greenegg,h2oski,clocker,nitemare,123321s,megiddo,cassidy1,david13,boywonde,flori,peggy12,pgszt6md,batterie,redlands,scooter6,bckhere,trueno,bailey11,maxwell2,bandana,timoth1,startnow,ducati74,tiern,maxine1,blackmetal,suzyq,balla007,phatfarm,kirsten1,titmouse,benhogan,culito,forbin,chess1,warren1,panman,mickey7,24lover,dascha,speed2,redlion,andrew10,johnwayn,nike23,chacha1,bendog,bullyboy,goldtree,spookie,tigger99,1cookie,poutine,cyclone1,woodpony,camaleun,bluesky1,dfadan,eagles20,lovergirl,peepshow,mine1,dima1989,rjdfkmxer,11111aaaaa,machina,august17,1hhhhh,0773417k,1monster,freaksho,jazzmin,davidw,kurupt,chumly,huggies,sashenka,ccccccc1,bridge1,giggalo,cincinna,pistol1,hello22,david77,lightfoo,lucky6,jimmy12,261397,lisa12,tabaluga,mysite,belo4ka,greenn,eagle99,punkrawk,salvado,slick123,wichsen,knight99,dummys,fefolico,contrera,kalle1,anna1984,delray,robert99,garena,pretende,racefan,alons,serenada,ludmilla,cnhtkjr,l0swf9gx,hankster,dfktynbyrf,sheep1,john23,cv141ab,kalyani,944turbo,crystal2,blackfly,zrjdktdf,eus1sue1,mario5,riverplate,harddriv,melissa3,elliott1,sexybitc,cnhfyybr,jimdavis,bollix,beta1,amberlee,skywalk1,natala,1blood,brattax,shitty1,gb15kv99,ronjon,rothmans,thedoc,joey21,hotboi,firedawg,bimbo38,jibber,aftermat,nomar,01478963,phishing,domodo,anna13,materia,martha1,budman1,gunblade,exclusiv,sasha1997,anastas,rebecca2,fackyou,kallisti,fuckmyass,norseman,ipswich1,151500,1edward,intelinside,darcy1,bcrich,yjdjcnbf,failte,buzzzz,cream1,tatiana1,7eleven,green8,153351,1a2s3d4f5g6h,154263,milano1,bambi1,bruins77,rugby2,jamal1,bolita,sundaypunch,bubba12,realmadr,vfyxtcnth,iwojima,notlob,black666,valkiria,nexus1,millerti,birthday100,swiss1,appollo,gefest,greeneyes,celebrat,tigerr,slava123,izumrud,bubbabub,legoman,joesmith,katya123,sweetdream,john44,wwwwwww1,oooooo1,socal,lovespor,s5r8ed67s,258147,heidis,cowboy22,wachovia,michaelb,qwe1234567,i12345,255225,goldie1,alfa155,45colt,safeu851,antonova,longtong,1sparky,gfvznm,busen,hjlbjy,whateva,rocky4,cokeman,joshua3,kekskek1,sirocco,jagman,123456qwert,phinupi,thomas10,loller,sakur,vika2011,fullred,mariska,azucar,ncstate,glenn74,halima,aleshka,ilovemylife,verlaat,baggie,scoubidou6,phatboy,jbruton,scoop1,barney11,blindman,def456,maximus2,master55,nestea,11223355,diego123,sexpistols,sniffy,philip1,f12345,prisonbreak,nokia2700,ajnjuhfa,yankees3,colfax,ak470000,mtnman,bdfyeirf,fotball,ichbin,trebla,ilusha,riobravo,beaner1,thoradin,polkaudi,kurosawa,honda123,ladybu,valerik,poltava,saviola,fuckyouguys,754740g0,anallove,microlab1,juris01,ncc1864,garfild,shania1,qagsud,makarenko,cindy69,lebedev,andrew11,johnnybo,groovy1,booster1,sanders1,tommyb,johnson4,kd189nlcih,hondaman,vlasova,chick1,sokada,sevisgur,bear2327,chacho,sexmania,roma1993,hjcnbckfd,valley1,howdie,tuppence,jimandanne,strike3,y4kuz4,nhfnfnf,tsubasa,19955991,scabby,quincunx,dima1998,uuuuuu1,logica,skinner1,pinguino,lisa1234,xpressmusic,getfucked,qqqq1,bbbb1,matulino,ulyana,upsman,johnsmith,123579,co2000,spanner1,todiefor,mangoes,isabel1,123852,negra,snowdon,nikki123,bronx1,booom,ram2500,chuck123,fireboy,creek1,batman13,princesse,az12345,maksat,1knight,28infern,241455,r7112s,muselman,mets1986,katydid,vlad777,playme,kmfdm1,asssex,1prince,iop890,bigbroth,mollymoo,waitron,lizottes,125412,juggler,quinta,0sister0,zanardi,nata123,heckfyxbr,22q04w90e,engine2,nikita95,zamira,hammer22,lutscher,carolina1,zz6319,sanman,vfuflfy,buster99,rossco,kourniko,aggarwal,tattoo1,janice1,finger1,125521,19911992,shdwlnds,rudenko,vfvfgfgf123,galatea,monkeybu,juhani,premiumcash,classact,devilmay,helpme2,knuddel,hardpack,ramil,perrit,basil1,zombie13,stockcar,tos8217,honeypie,nowayman,alphadog,melon1,talula,125689,tiribon12,tornike,haribol,telefone,tiger22,sucka,lfytxrf,chicken123,muggins,a23456,b1234567,lytdybr,otter1,pippa,vasilisk,cooking1,helter,78978,bestboy,viper7,ahmed1,whitewol,mommys,apple5,shazam1,chelsea7,kumiko,masterma,rallye,bushmast,jkz123,entrar,andrew6,nathan01,alaric,tavasz,heimdall,gravy1,jimmy99,cthlwt,powerr,gthtrhtcnjr,canesfan,sasha11,ybrbnf_25,august9,brucie,artichok,arnie1,superdude,tarelka,mickey22,dooper,luners,holeshot,good123,gettysbu,bicho,hammer99,divine5,1zxcvbn,stronzo,q22222,disne,bmw750il,godhead,hallodu,aerith,nastik,differen,cestmoi,amber69,5string,pornosta,dirtygirl,ginger123,formel1,scott12,honda200,hotspurs,johnatha,firstone123,lexmark1,msconfig,karlmasc,l123456,123qweasdzx,baldman,sungod,furka,retsub,9811020,ryder1,tcglyued,astron,lbvfcbr,minddoc,dirt49,baseball12,tbear,simpl,schuey,artimus,bikman,plat1num,quantex,gotyou,hailey1,justin01,ellada,8481068,000002,manimal,dthjybxrf,buck123,dick123,6969696,nospam,strong1,kodeord,bama12,123321w,superman123,gladiolus,nintend,5792076,dreamgirl,spankme1,gautam,arianna1,titti,tetas,cool1234,belladog,importan,4206969,87e5nclizry,teufelo7,doller,yfl.irf,quaresma,3440172,melis,bradle,nnmaster,fast1,iverso,blargh,lucas12,chrisg,iamsam,123321az,tomjerry,kawika,2597174,standrew,billyg,muskan,gizmodo2,rz93qpmq,870621345,sathya,qmezrxg4,januari,marthe,moom4261,cum2me,hkger286,lou1988,suckit1,croaker,klaudia1,753951456,aidan1,fsunoles,romanenko,abbydog,isthebes,akshay,corgi,fuck666,walkman555,ranger98,scorpian,hardwareid,bluedragon,fastman,2305822q,iddqdiddqd,1597532,gopokes,zvfrfcb,w1234567,sputnik1,tr1993,pa$$w0rd,2i5fdruv,havvoc,1357913,1313131,bnm123,cowd00d,flexscan,thesims2,boogiema,bigsexxy,powerstr,ngc4565,joshman,babyboy1,123jlb,funfunfu,qwe456,honor1,puttana,bobbyj,daniel21,pussy12,shmuck,1232580,123578951,maxthedo,hithere1,bond0007,gehenna,nomames,blueone,r1234567,bwana,gatinho,1011111,torrents,cinta,123451234,tiger25,money69,edibey,pointman,mmcm19,wales1,caffreys,phaedra,bloodlus,321ret32,rufuss,tarbit,joanna1,102030405,stickboy,lotrfotr34,jamshid,mclarenf1,ataman,99ford,yarrak,logan2,ironlung,pushistik,dragoon1,unclebob,tigereye,pinokio,tylerj,mermaid1,stevie1,jaylen,888777,ramana,roman777,brandon7,17711771s,thiago,luigi1,edgar1,brucey,videogam,classi,birder,faramir,twiddle,cubalibre,grizzy,fucky,jjvwd4,august15,idinahui,ranita,nikita1998,123342,w1w2w3,78621323,4cancel,789963,(null,vassago,jaydog472,123452,timt42,canada99,123589,rebenok,htyfnf,785001,osipov,maks123,neverwinter,love2010,777222,67390436,eleanor1,bykemo,aquemini,frogg,roboto,thorny,shipmate,logcabin,66005918,nokian,gonzos,louisian,1abcdefg,triathlo,ilovemar,couger,letmeino,supera,runvs,fibonacci,muttly,58565254,5thgbqi,vfnehsv,electr,jose12,artemis1,newlove,thd1shr,hawkey,grigoryan,saisha,tosca,redder,lifesux,temple1,bunnyman,thekids,sabbeth,tarzan1,182838,158uefas,dell50,1super,666222,47ds8x,jackhamm,mineonly,rfnfhbyf,048ro,665259,kristina1,bombero,52545856,secure1,bigloser,peterk,alex2,51525354,anarchy1,superx,teenslut,money23,sigmapi,sanfrancisco,acme34,private5,eclips,qwerttrewq,axelle,kokain,hardguy,peter69,jesuschr,dyanna,dude69,sarah69,toyota91,amberr,45645645,bugmenot,bigted,44556677,556644,wwr8x9pu,alphaome,harley13,kolia123,wejrpfpu,revelati,nairda,sodoff,cityboy,pinkpussy,dkalis,miami305,wow12345,triplet,tannenbau,asdfasdf1,darkhors,527952,retired1,soxfan,nfyz123,37583867,goddes,515069,gxlmxbewym,1warrior,36925814,dmb2011,topten,karpova,89876065093rax,naturals,gateway9,cepseoun,turbot,493949,cock22,italia1,sasafras,gopnik,stalke,1qazxdr5,wm2006,ace1062,alieva,blue28,aracel,sandia,motoguzz,terri1,emmajane,conej,recoba,alex1995,jerkyboy,cowboy12,arenrone,precisio,31415927,scsa316,panzer1,studly1,powerhou,bensam,mashoutq,billee,eeyore1,reape,thebeatl,rul3z,montesa,doodle1,cvzefh1gk,424365,a159753,zimmerma,gumdrop,ashaman,grimreap,icandoit,borodina,branca,dima2009,keywest1,vaders,bubluk,diavolo,assss,goleta,eatass,napster1,382436,369741,5411pimo,lenchik,pikach,gilgamesh,kalimera,singer1,gordon2,rjycnbnewbz,maulwurf,joker13,2much4u,bond00,alice123,robotec,fuckgirl,zgjybz,redhorse,margaret1,brady1,pumpkin2,chinky,fourplay,1booger,roisin,1brandon,sandan,blackheart,cheez,blackfin,cntgfyjdf,mymoney1,09080706,goodboss,sebring1,rose1,kensingt,bigboner,marcus12,ym3cautj,struppi,thestone,lovebugs,stater,silver99,forest99,qazwsx12345,vasile,longboar,mkonji,huligan,rhfcbdfz,airmail,porn11,1ooooo,sofun,snake2,msouthwa,dougla,1iceman,shahrukh,sharona,dragon666,france98,196800,196820,ps253535,zjses9evpa,sniper01,design1,konfeta,jack99,drum66,good4you,station2,brucew,regedit,school12,mvtnr765,pub113,fantas,tiburon1,king99,ghjcnjgbpltw,checkito,308win,1ladybug,corneliu,svetasveta,197430,icicle,imaccess,ou81269,jjjdsl,brandon6,bimbo1,smokee,piccolo1,3611jcmg,children2,cookie2,conor1,darth1,margera,aoi856,paully,ou812345,sklave,eklhigcz,30624700,amazing1,wahooo,seau55,1beer,apples2,chulo,dolphin9,heather6,198206,198207,hergood,miracle1,njhyflj,4real,milka,silverfi,fabfive,spring12,ermine,mammy,jumpjet,adilbek,toscana,caustic,hotlove,sammy69,lolita1,byoung,whipme,barney01,mistys,tree1,buster3,kaylin,gfccgjhn,132333,aishiteru,pangaea,fathead1,smurph,198701,ryslan,gasto,xexeylhf,anisimov,chevyss,saskatoo,brandy12,tweaker,irish123,music2,denny1,palpatin,outlaw1,lovesuck,woman1,mrpibb,diadora,hfnfneq,poulette,harlock,mclaren1,cooper12,newpass3,bobby12,rfgecnfcerf,alskdjfh,mini14,dukers,raffael,199103,cleo123,1234567qwertyu,mossberg,scoopy,dctulf,starline,hjvjxrf,misfits1,rangers2,bilbos,blackhea,pappnase,atwork,purple2,daywalker,summoner,1jjjjjjj,swansong,chris10,laluna,12345qqq,charly1,lionsden,money99,silver33,hoghead,bdaddy,199430,saisg002,nosaints,tirpitz,1gggggg,jason13,kingss,ernest1,0cdh0v99ue,pkunzip,arowana,spiri,deskjet1,armine,lances,magic2,thetaxi,14159265,cacique,14142135,orange10,richard0,backdraf,255ooo,humtum,kohsamui,c43dae874d,wrestling1,cbhtym,sorento,megha,pepsiman,qweqwe12,bliss7,mario64,korolev,balls123,schlange,gordit,optiquest,fatdick,fish99,richy,nottoday,dianne1,armyof1,1234qwerasdfzxcv,bbonds,aekara,lidiya,baddog1,yellow5,funkie,ryan01,greentree,gcheckout,marshal1,liliput,000000z,rfhbyrf,gtogto43,rumpole,tarado,marcelit,aqwzsxedc,kenshin1,sassydog,system12,belly1,zilla,kissfan,tools1,desember,donsdad,nick11,scorpio6,poopoo1,toto99,steph123,dogfuck,rocket21,thx113,dude12,sanek,sommar,smacky,pimpsta,letmego,k1200rs,lytghjgtnhjdcr,abigale,buddog,deles,baseball9,roofus,carlsbad,hamzah,hereiam,genial,schoolgirlie,yfz450,breads,piesek,washear,chimay,apocalyp,nicole18,gfgf1234,gobulls,dnevnik,wonderwall,beer1234,1moose,beer69,maryann1,adpass,mike34,birdcage,hottuna,gigant,penquin,praveen,donna123,123lol123,thesame,fregat,adidas11,selrahc,pandoras,test3,chasmo,111222333000,pecos,daniel11,ingersol,shana1,mama12345,cessna15,myhero,1simpson,nazarenko,cognit,seattle2,irina1,azfpc310,rfycthdf,hardy1,jazmyn,sl1200,hotlanta,jason22,kumar123,sujatha,fsd9shtyu,highjump,changer,entertai,kolding,mrbig,sayuri,eagle21,qwertzu,jorge1,0101dd,bigdong,ou812a,sinatra1,htcnjhfy,oleg123,videoman,pbyfblf,tv612se,bigbird1,kenaidog,gunite,silverma,ardmore,123123qq,hotbot,cascada,cbr600f4,harakiri,chico123,boscos,aaron12,glasgow1,kmn5hc,lanfear,1light,liveoak,fizika,ybrjkftdyf,surfside,intermilan,multipas,redcard,72chevy,balata,coolio1,schroede,kanat,testerer,camion,kierra,hejmeddig,antonio2,tornados,isidor,pinkey,n8skfswa,ginny1,houndog,1bill,chris25,hastur,1marine,greatdan,french1,hatman,123qqq,z1z2z3z4,kicker1,katiedog,usopen,smith22,mrmagoo,1234512i,assa123,7seven7,monster7,june12,bpvtyf,149521,guenter,alex1985,voronina,mbkugegs,zaqwsxcderfv,rusty5,mystic1,master0,abcdef12,jndfkb,r4zpm3,cheesey,skripka,blackwhite,sharon69,dro8smwq,lektor,techman,boognish,deidara,heckfyf,quietkey,authcode,monkey4,jayboy,pinkerto,merengue,chulita,bushwick,turambar,kittykit,joseph2,dad123,kristo,pepote,scheiss,hambone1,bigballa,restaura,tequil,111luzer,euro2000,motox,denhaag,chelsi,flaco1,preeti,lillo,1001sin,passw,august24,beatoff,555555d,willis1,kissthis,qwertyz,rvgmw2gl,iloveboobies,timati,kimbo,msinfo,dewdrop,sdbaker,fcc5nky2,messiah1,catboy,small1,chode,beastie1,star77,hvidovre,short1,xavie,dagobah,alex1987,papageno,dakota2,toonami,fuerte,jesus33,lawina,souppp,dirtybir,chrish,naturist,channel1,peyote,flibble,gutentag,lactate,killem,zucchero,robinho,ditka,grumpy1,avr7000,boxxer,topcop,berry1,mypass1,beverly1,deuce1,9638527410,cthuttdf,kzkmrf,lovethem,band1t,cantona1,purple11,apples123,wonderwo,123a456,fuzzie,lucky99,dancer2,hoddling,rockcity,winner12,spooty,mansfiel,aimee1,287hf71h,rudiger,culebra,god123,agent86,daniel0,bunky1,notmine,9ball,goofus,puffy1,xyh28af4,kulikov,bankshot,vurdf5i2,kevinm,ercole,sexygirls,razvan,october7,goater,lollie,raissa,thefrog,mdmaiwa3,mascha,jesussaves,union1,anthony9,crossroa,brother2,areyuke,rodman91,toonsex,dopeman,gericom,vaz2115,cockgobbler,12356789,12345699,signatur,alexandra1,coolwhip,erwin1,awdrgyjilp,pens66,ghjrjgtyrj,linkinpark,emergenc,psych0,blood666,bootmort,wetworks,piroca,johnd,iamthe1,supermario,homer69,flameon,image1,bebert,fylhtq1,annapoli,apple11,hockey22,10048,indahouse,mykiss,1penguin,markp,misha123,foghat,march11,hank1,santorin,defcon4,tampico,vbnhjafy,robert22,bunkie,athlon64,sex777,nextdoor,koskesh,lolnoob,seemnemaailm,black23,march15,yeehaa,chiqui,teagan,siegheil,monday2,cornhusk,mamusia,chilis,sthgrtst,feldspar,scottm,pugdog,rfghjy,micmac,gtnhjdyf,terminato,1jackson,kakosja,bogomol,123321aa,rkbvtyrj,tresor,tigertig,fuckitall,vbkkbjy,caramon,zxc12,balin,dildo1,soccer09,avata,abby123,cheetah1,marquise,jennyc,hondavfr,tinti,anna1985,dennis2,jorel,mayflowe,icema,hal2000,nikkis,bigmouth,greenery,nurjan,leonov,liberty7,fafnir,larionov,sat321321,byteme1,nausicaa,hjvfynbrf,everto,zebra123,sergio1,titone,wisdom1,kahala,104328q,marcin1,salima,pcitra,1nnnnn,nalini,galvesto,neeraj,rick1,squeeky,agnes1,jitterbu,agshar,maria12,0112358,traxxas,stivone,prophet1,bananza,sommer1,canoneos,hotfun,redsox11,1bigmac,dctdjkjl,legion1,everclea,valenok,black9,danny001,roxie1,1theman,mudslide,july16,lechef,chula,glamis,emilka,canbeef,ioanna,cactus1,rockshox,im2cool,ninja9,thvfrjdf,june28,milo17,missyou,micky1,nbibyf,nokiaa,goldi,mattias,fuckthem,asdzxc123,ironfist,junior01,nesta,crazzy,killswit,hygge,zantac,kazama,melvin1,allston,maandag,hiccup,prototyp,specboot,dwl610,hello6,159456,baldhead,redwhite,calpoly,whitetail,agile1,cousteau,matt01,aust1n,malcolmx,gjlfhjr,semperf1,ferarri,a1b2c3d,vangelis,mkvdari,bettis36,andzia,comand,tazzman,morgaine,pepluv,anna1990,inandout,anetka,anna1997,wallpape,moonrake,huntress,hogtie,cameron7,sammy7,singe11,clownboy,newzeala,wilmar,safrane,rebeld,poopi,granat,hammertime,nermin,11251422,xyzzy1,bogeys,jkmxbr,fktrcfyl,11223311,nfyrbcn,11223300,powerpla,zoedog,ybrbnbyf,zaphod42,tarawa,jxfhjdfirf,dude1234,g5wks9,goobe,czekolada,blackros,amaranth,medical1,thereds,julija,nhecsyfujkjdt,promopas,buddy4,marmalad,weihnachten,tronic,letici,passthief,67mustan,ds7zamnw,morri,w8woord,cheops,pinarell,sonofsam,av473dv,sf161pn,5c92v5h6,purple13,tango123,plant1,1baby,xufrgemw,fitta,1rangers,spawns,kenned,taratata,19944991,11111118,coronas,4ebouux8,roadrash,corvette1,dfyjdf846,marley12,qwaszxerdfcv,68stang,67stang,racin,ellehcim,sofiko,nicetry,seabass1,jazzman1,zaqwsx1,laz2937,uuuuuuu1,vlad123,rafale,j1234567,223366,nnnnnn1,226622,junkfood,asilas,cer980,daddymac,persepho,neelam,00700,shithappens,255555,qwertyy,xbox36,19755791,qweasd1,bearcub,jerryb,a1b1c1,polkaudio,basketball1,456rty,1loveyou,marcus2,mama1961,palace1,transcend,shuriken,sudhakar,teenlove,anabelle,matrix99,pogoda,notme,bartend,jordana,nihaoma,ataris,littlegi,ferraris,redarmy,giallo,fastdraw,accountbloc,peludo,pornostar,pinoyako,cindee,glassjaw,dameon,johnnyd,finnland,saudade,losbravo,slonko,toplay,smalltit,nicksfun,stockhol,penpal,caraj,divedeep,cannibus,poppydog,pass88,viktory,walhalla,arisia,lucozade,goldenbo,tigers11,caball,ownage123,tonna,handy1,johny,capital5,faith2,stillher,brandan,pooky1,antananarivu,hotdick,1justin,lacrimos,goathead,bobrik,cgtwbfkbcn,maywood,kamilek,gbplf123,gulnar,beanhead,vfvjyn,shash,viper69,ttttttt1,hondacr,kanako,muffer,dukies,justin123,agapov58,mushka,bad11bad,muleman,jojo123,andreika,makeit,vanill,boomers,bigals,merlin11,quacker,aurelien,spartak1922,ligeti,diana2,lawnmowe,fortune1,awesom,rockyy,anna1994,oinker,love88,eastbay,ab55484,poker0,ozzy666,papasmurf,antihero,photogra,ktm250,painkill,jegr2d2,p3orion,canman,dextur,qwest123,samboy,yomismo,sierra01,herber,vfrcbvvfrcbv,gloria1,llama1,pie123,bobbyjoe,buzzkill,skidrow,grabber,phili,javier1,9379992q,geroin,oleg1994,sovereig,rollover,zaq12qaz,battery1,killer13,alina123,groucho1,mario12,peter22,butterbean,elise1,lucycat,neo123,ferdi,golfer01,randie,gfhfyjbr,ventura1,chelsea3,pinoy,mtgox,yrrim7,shoeman,mirko,ffggyyo,65mustan,ufdibyjd,john55,suckfuck,greatgoo,fvfnjhb,mmmnnn,love20,1bullshi,sucesso,easy1234,robin123,rockets1,diamondb,wolfee,nothing0,joker777,glasnost,richar1,guille,sayan,koresh,goshawk,alexx,batman21,a123456b,hball,243122,rockandr,coolfool,isaia,mary1,yjdbrjdf,lolopc,cleocat,cimbo,lovehina,8vfhnf,passking,bonapart,diamond2,bigboys,kreator,ctvtyjdf,sassy123,shellac,table54781,nedkelly,philbert,sux2bu,nomis,sparky99,python1,littlebear,numpty,silmaril,sweeet,jamesw,cbufhtnf,peggysue,wodahs,luvsex,wizardry,venom123,love4you,bama1,samat,reviewpass,ned467,cjkjdtq,mamula,gijoe,amersham,devochka,redhill,gisel,preggo,polock,cando,rewster,greenlantern,panasonik,dave1234,mikeee,1carlos,miledi,darkness1,p0o9i8u7y6,kathryn1,happyguy,dcp500,assmaster,sambuka,sailormo,antonio3,logans,18254288,nokiax2,qwertzuiop,zavilov,totti,xenon1,edward11,targa1,something1,tony_t,q1w2e3r4t5y6u7i8o9p0,02551670,vladimir1,monkeybutt,greenda,neel21,craiger,saveliy,dei008,honda450,fylhtq95,spike2,fjnq8915,passwordstandard,vova12345,talonesi,richi,gigemags,pierre1,westin,trevoga,dorothee,bastogne,25563o,brandon3,truegrit,krimml,iamgreat,servis,a112233,paulinka,azimuth,corperfmonsy,358hkyp,homerun1,dogbert1,eatmyass,cottage1,savina,baseball7,bigtex,gimmesum,asdcxz,lennon1,a159357,1bastard,413276191q,pngfilt,pchealth,netsnip,bodiroga,1matt,webtvs,ravers,adapters,siddis,mashamasha,coffee2,myhoney,anna1982,marcia1,fairchil,maniek,iloveluc,batmonh,wildon,bowie1,netnwlnk,fancy1,tom204,olga1976,vfif123,queens1,ajax01,lovess,mockba,icam4usb,triada,odinthor,rstlne,exciter,sundog,anchorat,girls69,nfnmzyrf,soloma,gti16v,shadowman,ottom,rataros,tonchin,vishal,chicken0,pornlo,christiaan,volante,likesit,mariupol,runfast,gbpltw123,missys,villevalo,kbpjxrf,ghibli,calla,cessna172,kinglear,dell11,swift1,walera,1cricket,pussy5,turbo911,tucke,maprchem56458,rosehill,thekiwi1,ygfxbkgt,mandarinka,98xa29,magnit,cjfrf,paswoord,grandam1,shenmue,leedsuni,hatrick,zagadka,angeldog,michaell,dance123,koichi,bballs,29palms,xanth,228822,ppppppp1,1kkkkk,1lllll,mynewbots,spurss,madmax1,224455,city1,mmmmmmm1,nnnnnnn1,biedronka,thebeatles,elessar,f14tomcat,jordan18,bobo123,ayi000,tedbear,86chevyx,user123,bobolink,maktub,elmer1,flyfishi,franco1,gandalf0,traxdata,david21,enlighte,dmitrij,beckys,1giants,flippe,12345678w,jossie,rugbyman,snowcat,rapeme,peanut11,gemeni,udders,techn9ne,armani1,chappie,war123,vakantie,maddawg,sewanee,jake5253,tautt1,anthony5,letterma,jimbo2,kmdtyjr,hextall,jessica6,amiga500,hotcunt,phoenix9,veronda,saqartvelo,scubas,sixer3,williamj,nightfal,shihan,melnikova,kosssss,handily,killer77,jhrl0821,march17,rushman,6gcf636i,metoyou,irina123,mine11,primus1,formatters,matthew5,infotech,gangster1,jordan45,moose69,kompas,motoxxx,greatwhi,cobra12,kirpich,weezer1,hello23,montse,tracy123,connecte,cjymrf,hemingwa,azreal,gundam00,mobila,boxman,slayers1,ravshan,june26,fktrcfylhjd,bermuda1,tylerd,maersk,qazwsx11,eybdthcbntn,ash123,camelo,kat123,backd00r,cheyenne1,1king,jerkin,tnt123,trabant,warhammer40k,rambos,punto,home77,pedrito,1frank,brille,guitarman,george13,rakas,tgbxtcrbq,flute1,bananas1,lovezp1314,thespot,postie,buster69,sexytime,twistys,zacharia,sportage,toccata,denver7,terry123,bogdanova,devil69,higgins1,whatluck,pele10,kkk666,jeffery1,1qayxsw2,riptide1,chevy11,munchy,lazer1,hooker1,ghfgjh,vergesse,playgrou,4077mash,gusev,humpin,oneputt,hydepark,monster9,tiger8,tangsoo,guy123,hesoyam1,uhtqneyu,thanku,lomond,ortezza,kronik,geetha,rabbit66,killas,qazxswe,alabaste,1234567890qwerty,capone1,andrea12,geral,beatbox,slutfuck,booyaka,jasmine7,ostsee,maestro1,beatme,tracey1,buster123,donaldduck,ironfish,happy6,konnichi,gintonic,momoney1,dugan1,today2,enkidu,destiny2,trim7gun,katuha,fractals,morganstanley,polkadot,gotime,prince11,204060,fifa2010,bobbyt,seemee,amanda10,airbrush,bigtitty,heidie,layla1,cotton1,5speed,fyfnjkmtdyf,flynavy,joxury8f,meeko,akuma,dudley1,flyboy1,moondog1,trotters,mariami,signin,chinna,legs11,pussy4,1s1h1e1f1,felici,optimus1,iluvu,marlins1,gavaec,balance1,glock40,london01,kokot,southwes,comfort1,sammy11,rockbottom,brianc,litebeer,homero,chopsuey,greenlan,charit,freecell,hampster,smalldog,viper12,blofeld,1234567890987654321,realsex,romann,cartman2,cjdthitycndj,nelly1,bmw528,zwezda,masterba,jeep99,turtl,america2,sunburst,sanyco,auntjudy,125wm,blue10,qwsazx,cartma,toby12,robbob,red222,ilovecock,losfix16,1explore,helge,vaz2114,whynotme,baba123,mugen,1qazwsxedc,albertjr,0101198,sextime,supras,nicolas2,wantsex,pussy6,checkm8,winam,24gordon,misterme,curlew,gbljhfcs,medtech,franzi,butthea,voivod,blackhat,egoiste,pjkeirf,maddog69,pakalolo,hockey4,igor1234,rouges,snowhite,homefree,sexfreak,acer12,dsmith,blessyou,199410,vfrcbvjd,falco02,belinda1,yaglasph,april21,groundho,jasmin1,nevergiveup,elvir,gborv526,c00kie,emma01,awesome2,larina,mike12345,maximu,anupam,bltynbabrfwbz,tanushka,sukkel,raptor22,josh12,schalke04,cosmodog,fuckyou8,busybee,198800,bijoux,frame1,blackmor,giveit,issmall,bear13,123-123,bladez,littlegirl,ultra123,fletch1,flashnet,loploprock,rkelly,12step,lukas1,littlewhore,cuntfinger,stinkyfinger,laurenc,198020,n7td4bjl,jackie69,camel123,ben1234,1gateway,adelheid,fatmike,thuglove,zzaaqq,chivas1,4815162342q,mamadou,nadano,james22,benwin,andrea99,rjirf,michou,abkbgg,d50gnn,aaazzz,a123654,blankman,booboo11,medicus,bigbone,197200,justine1,bendix,morphius,njhvjp,44mag,zsecyus56,goodbye1,nokiadermo,a333444,waratsea,4rzp8ab7,fevral,brillian,kirbys,minim,erathia,grazia,zxcvb1234,dukey,snaggle,poppi,hymen,1video,dune2000,jpthjdf,cvbn123,zcxfcnkbdfz,astonv,ginnie,316271,engine3,pr1ncess,64chevy,glass1,laotzu,hollyy,comicbooks,assasins,nuaddn9561,scottsda,hfcnfvfy,accobra,7777777z,werty123,metalhead,romanson,redsand,365214,shalo,arsenii,1989cc,sissi,duramax,382563,petera,414243,mamapap,jollymon,field1,fatgirl,janets,trompete,matchbox20,rambo2,nepenthe,441232,qwertyuiop10,bozo123,phezc419hv,romantika,lifestyl,pengui,decembre,demon6,panther6,444888,scanman,ghjcnjabkz,pachanga,buzzword,indianer,spiderman3,tony12,startre,frog1,fyutk,483422,tupacshakur,albert12,1drummer,bmw328i,green17,aerdna,invisibl,summer13,calimer,mustaine,lgnu9d,morefun,hesoyam123,escort1,scrapland,stargat,barabbas,dead13,545645,mexicali,sierr,gfhfpbn,gonchar,moonstafa,searock,counte,foster1,jayhawk1,floren,maremma,nastya2010,softball1,adaptec,halloo,barrabas,zxcasd123,hunny,mariana1,kafedra,freedom0,green420,vlad1234,method7,665566,tooting,hallo12,davinchi,conducto,medias,666444,invernes,madhatter,456asd,12345678i,687887,le33px,spring00,help123,bellybut,billy5,vitalik1,river123,gorila,bendis,power666,747200,footslav,acehigh,qazxswedc123,q1a1z1,richard9,peterburg,tabletop,gavrilov,123qwe1,kolosov,fredrau,run4fun,789056,jkbvgbflf,chitra,87654321q,steve22,wideopen,access88,surfe,tdfyutkbjy,impossib,kevin69,880888,cantina,887766,wxcvb,dontforg,qwer1209,asslicke,mamma123,indig,arkasha,scrapp,morelia,vehxbr,jones2,scratch1,cody11,cassie12,gerbera,dontgotm,underhil,maks2010,hollywood1,hanibal,elena2010,jason11,1010321,stewar,elaman,fireplug,goodby,sacrific,babyphat,bobcat12,bruce123,1233215,tony45,tiburo,love15,bmw750,wallstreet,2h0t4me,1346795,lamerz,munkee,134679q,granvill,1512198,armastus,aiden1,pipeutvj,g1234567,angeleyes,usmc1,102030q,putangina,brandnew,shadowfax,eagles12,1falcon,brianw,lokomoti,2022958,scooper,pegas,jabroni1,2121212,buffal,siffredi,wewiz,twotone,rosebudd,nightwis,carpet1,mickey2,2525252,sleddog,red333,jamesm,2797349,jeff12,onizuka,felixxxx,rf6666,fine1,ohlala,forplay,chicago5,muncho,scooby11,ptichka,johnnn,19851985p,dogphil3650,totenkopf,monitor2,macross7,3816778,dudder,semaj1,bounder,racerx1,5556633,7085506,ofclr278,brody1,7506751,nantucke,hedj2n4q,drew1,aessedai,trekbike,pussykat,samatron,imani,9124852,wiley1,dukenukem,iampurehaha2,9556035,obvious1,mccool24,apache64,kravchenko,justforf,basura,jamese,s0ccer,safado,darksta,surfer69,damian1,gjpbnbd,gunny1,wolley,sananton,zxcvbn123456,odt4p6sv8,sergei1,modem1,mansikka,zzzz1,rifraf,dima777,mary69,looking4,donttell,red100,ninjutsu,uaeuaeman,bigbri,brasco,queenas8151,demetri,angel007,bubbl,kolort,conny,antonia1,avtoritet,kaka22,kailayu,sassy2,wrongway,chevy3,1nascar,patriots1,chrisrey,mike99,sexy22,chkdsk,sd3utre7,padawan,a6pihd,doming,mesohorny,tamada,donatello,emma22,eather,susan69,pinky123,stud69,fatbitch,pilsbury,thc420,lovepuss,1creativ,golf1234,hurryup,1honda,huskerdu,marino1,gowron,girl1,fucktoy,gtnhjpfdjlcr,dkjfghdk,pinkfl,loreli,7777777s,donkeykong,rockytop,staples1,sone4ka,xxxjay,flywheel,toppdogg,bigbubba,aaa123456,2letmein,shavkat,paule,dlanor,adamas,0147852,aassaa,dixon1,bmw328,mother12,ilikepussy,holly2,tsmith,excaliber,fhutynbyf,nicole3,tulipan,emanue,flyvholm,currahee,godsgift,antonioj,torito,dinky1,sanna,yfcnzvjz,june14,anime123,123321456654,hanswurst,bandman,hello101,xxxyyy,chevy69,technica,tagada,arnol,v00d00,lilone,filles,drumandbass,dinamit,a1234a,eatmeat,elway07,inout,james6,dawid1,thewolf,diapason,yodaddy,qscwdv,fuckit1,liljoe,sloeber,simbacat,sascha1,qwe1234,1badger,prisca,angel17,gravedig,jakeyboy,longboard,truskawka,golfer11,pyramid7,highspee,pistola,theriver,hammer69,1packers,dannyd,alfonse,qwertgfdsa,11119999,basket1,ghjtrn,saralee,12inches,paolo1,zse4xdr5,taproot,sophieh6,grizzlie,hockey69,danang,biggums,hotbitch,5alive,beloved1,bluewave,dimon95,koketka,multiscan,littleb,leghorn,poker2,delite,skyfir,bigjake,persona1,amberdog,hannah12,derren,ziffle,1sarah,1assword,sparky01,seymur,tomtom1,123321qw,goskins,soccer19,luvbekki,bumhole,2balls,1muffin,borodin,monkey9,yfeiybrb,1alex,betmen,freder,nigger123,azizbek,gjkzrjdf,lilmike,1bigdadd,1rock,taganrog,snappy1,andrey1,kolonka,bunyan,gomango,vivia,clarkkent,satur,gaudeamus,mantaray,1month,whitehea,fargus,andrew99,ray123,redhawks,liza2009,qw12345,den12345,vfhnsyjdf,147258369a,mazepa,newyorke,1arsenal,hondas2000,demona,fordgt,steve12,birthday2,12457896,dickster,edcwsxqaz,sahalin,pantyman,skinny1,hubertus,cumshot1,chiro,kappaman,mark3434,canada12,lichking,bonkers1,ivan1985,sybase,valmet,doors1,deedlit,kyjelly,bdfysx,ford11,throatfuck,backwood,fylhsq,lalit,boss429,kotova,bricky,steveh,joshua19,kissa,imladris,star1234,lubimka,partyman,crazyd,tobias1,ilike69,imhome,whome,fourstar,scanner1,ujhjl312,anatoli,85bears,jimbo69,5678ytr,potapova,nokia7070,sunday1,kalleank,1996gta,refinnej,july1,molodec,nothanks,enigm,12play,sugardog,nhfkbdfkb,larousse,cannon1,144444,qazxcdew,stimorol,jhereg,spawn7,143000,fearme,hambur,merlin21,dobie,is3yeusc,partner1,dekal,varsha,478jfszk,flavi,hippo1,9hmlpyjd,july21,7imjfstw,lexxus,truelov,nokia5200,carlos6,anais,mudbone,anahit,taylorc,tashas,larkspur,animal2000,nibiru,jan123,miyvarxar,deflep,dolore,communit,ifoptfcor,laura2,anadrol,mamaliga,mitzi1,blue92,april15,matveev,kajlas,wowlook1,1flowers,shadow14,alucard1,1golf,bantha,scotlan,singapur,mark13,manchester1,telus01,superdav,jackoff1,madnes,bullnuts,world123,clitty,palmer1,david10,spider10,sargsyan,rattlers,david4,windows2,sony12,visigoth,qqqaaa,penfloor,cabledog,camilla1,natasha123,eagleman,softcore,bobrov,dietmar,divad,sss123,d1234567,tlbyjhju,1q1q1q1,paraiso,dav123,lfiekmrf,drachen,lzhan16889,tplate,gfghbrf,casio1,123boots1,123test,sys64738,heavymetal,andiamo,meduza,soarer,coco12,negrita,amigas,heavymet,bespin,1asdfghj,wharfrat,wetsex,tight1,janus1,sword123,ladeda,dragon98,austin2,atep1,jungle1,12345abcd,lexus300,pheonix1,alex1974,123qw123,137955,bigtim,shadow88,igor1994,goodjob,arzen,champ123,121ebay,changeme1,brooksie,frogman1,buldozer,morrowin,achim,trish1,lasse,festiva,bubbaman,scottb,kramit,august22,tyson123,passsword,oompah,al123456,fucking1,green45,noodle1,looking1,ashlynn,al1716,stang50,coco11,greese,bob111,brennan1,jasonj,1cherry,1q2345,1xxxxxxx,fifa2011,brondby,zachar1,satyam,easy1,magic7,1rainbow,cheezit,1eeeeeee,ashley123,assass1,amanda123,jerbear,1bbbbbb,azerty12,15975391,654321z,twinturb,onlyone1,denis1988,6846kg3r,jumbos,pennydog,dandelion,haileris,epervier,snoopy69,afrodite,oldpussy,green55,poopypan,verymuch,katyusha,recon7,mine69,tangos,contro,blowme2,jade1,skydive1,fiveiron,dimo4ka,bokser,stargirl,fordfocus,tigers2,platina,baseball11,raque,pimper,jawbreak,buster88,walter34,chucko,penchair,horizon1,thecure1,scc1975,adrianna1,kareta,duke12,krille,dumbfuck,cunt1,aldebaran,laverda,harumi,knopfler,pongo1,pfhbyf,dogman1,rossigno,1hardon,scarlets,nuggets1,ibelieve,akinfeev,xfhkbr,athene,falcon69,happie,billly,nitsua,fiocco,qwerty09,gizmo2,slava2,125690,doggy123,craigs,vader123,silkeborg,124365,peterm,123978,krakatoa,123699,123592,kgvebmqy,pensacol,d1d2d3,snowstor,goldenboy,gfg65h7,ev700,church1,orange11,g0dz1ll4,chester3,acheron,cynthi,hotshot1,jesuschris,motdepass,zymurgy,one2one,fietsbel,harryp,wisper,pookster,nn527hp,dolla,milkmaid,rustyboy,terrell1,epsilon1,lillian1,dale3,crhbgrf,maxsim,selecta,mamada,fatman1,ufkjxrf,shinchan,fuckuall,women1,000008,bossss,greta1,rbhjxrf,mamasboy,purple69,felicidade,sexy21,cathay,hunglow,splatt,kahless,shopping1,1gandalf,themis,delta7,moon69,blue24,parliame,mamma1,miyuki,2500hd,jackmeof,razer,rocker1,juvis123,noremac,boing747,9z5ve9rrcz,icewater,titania,alley1,moparman,christo1,oliver2,vinicius,tigerfan,chevyy,joshua99,doda99,matrixx,ekbnrf,jackfrost,viper01,kasia,cnfhsq,triton1,ssbt8ae2,rugby8,ramman,1lucky,barabash,ghtlfntkm,junaid,apeshit,enfant,kenpo1,shit12,007000,marge1,shadow10,qwerty789,richard8,vbitkm,lostboys,jesus4me,richard4,hifive,kolawole,damilola,prisma,paranoya,prince2,lisaann,happyness,cardss,methodma,supercop,a8kd47v5,gamgee,polly123,irene1,number8,hoyasaxa,1digital,matthew0,dclxvi,lisica,roy123,2468013579,sparda,queball,vaffanculo,pass1wor,repmvbx,999666333,freedom8,botanik,777555333,marcos1,lubimaya,flash2,einstei,08080,123456789j,159951159,159357123,carrot1,alina1995,sanjos,dilara,mustang67,wisteria,jhnjgtl12,98766789,darksun,arxangel,87062134,creativ1,malyshka,fuckthemall,barsic,rocksta,2big4u,5nizza,genesis2,romance1,ofcourse,1horse,latenite,cubana,sactown,789456123a,milliona,61808861,57699434,imperia,bubba11,yellow3,change12,55495746,flappy,jimbo123,19372846,19380018,cutlass1,craig123,klepto,beagle1,solus,51502112,pasha1,19822891,46466452,19855891,petshop,nikolaevna,119966,nokia6131,evenpar,hoosier1,contrasena,jawa350,gonzo123,mouse2,115511,eetfuk,gfhfvgfvgfv,1crystal,sofaking,coyote1,kwiatuszek,fhrflbq,valeria1,anthro,0123654789,alltheway,zoltar,maasikas,wildchil,fredonia,earlgrey,gtnhjczy,matrix123,solid1,slavko,12monkeys,fjdksl,inter1,nokia6500,59382113kevinp,spuddy,cachero,coorslit,password!,kiba1z,karizma,vova1994,chicony,english1,bondra12,1rocket,hunden,jimbob1,zpflhjn1,th0mas,deuce22,meatwad,fatfree,congas,sambora,cooper2,janne,clancy1,stonie,busta,kamaz,speedy2,jasmine3,fahayek,arsenal0,beerss,trixie1,boobs69,luansantana,toadman,control2,ewing33,maxcat,mama1964,diamond4,tabaco,joshua0,piper2,music101,guybrush,reynald,pincher,katiebug,starrs,pimphard,frontosa,alex97,cootie,clockwor,belluno,skyeseth,booty69,chaparra,boochie,green4,bobcat1,havok,saraann,pipeman,aekdb,jumpshot,wintermu,chaika,1chester,rjnjatq,emokid,reset1,regal1,j0shua,134679a,asmodey,sarahh,zapidoo,ciccione,sosexy,beckham23,hornets1,alex1971,delerium,manageme,connor11,1rabbit,sane4ek,caseyboy,cbljhjdf,redsox20,tttttt99,haustool,ander,pantera6,passwd1,journey1,9988776655,blue135,writerspace,xiaoyua123,justice2,niagra,cassis,scorpius,bpgjldsgjldthnf,gamemaster,bloody1,retrac,stabbin,toybox,fight1,ytpyf.,glasha,va2001,taylor11,shameles,ladylove,10078,karmann,rodeos,eintritt,lanesra,tobasco,jnrhjqcz,navyman,pablit,leshka,jessica3,123vika,alena1,platinu,ilford,storm7,undernet,sasha777,1legend,anna2002,kanmax1994,porkpie,thunder0,gundog,pallina,easypass,duck1,supermom,roach1,twincam,14028,tiziano,qwerty32,123654789a,evropa,shampoo1,yfxfkmybr,cubby1,tsunami1,fktrcttdf,yasacrac,17098,happyhap,bullrun,rodder,oaktown,holde,isbest,taylor9,reeper,hammer11,julias,rolltide1,compaq123,fourx4,subzero1,hockey9,7mary3,busines,ybrbnjcbr,wagoneer,danniash,portishead,digitex,alex1981,david11,infidel,1snoopy,free30,jaden,tonto1,redcar27,footie,moskwa,thomas21,hammer12,burzum,cosmo123,50000,burltree,54343,54354,vwpassat,jack5225,cougars1,burlpony,blackhorse,alegna,petert,katemoss,ram123,nels0n,ferrina,angel77,cstock,1christi,dave55,abc123a,alex1975,av626ss,flipoff,folgore,max1998,science1,si711ne,yams7,wifey1,sveiks,cabin1,volodia,ox3ford,cartagen,platini,picture1,sparkle1,tiedomi,service321,wooody,christi1,gnasher,brunob,hammie,iraffert,bot2010,dtcyeirf,1234567890p,cooper11,alcoholi,savchenko,adam01,chelsea5,niewiem,icebear,lllooottt,ilovedick,sweetpus,money8,cookie13,rfnthbyf1988,booboo2,angus123,blockbus,david9,chica1,nazaret,samsung9,smile4u,daystar,skinnass,john10,thegirl,sexybeas,wasdwasd1,sigge1,1qa2ws3ed4rf5tg,czarny,ripley1,chris5,ashley19,anitha,pokerman,prevert,trfnthby,tony69,georgia2,stoppedb,qwertyuiop12345,miniclip,franky1,durdom,cabbages,1234567890o,delta5,liudmila,nhfycajhvths,court1,josiew,abcd1,doghead,diman,masiania,songline,boogle,triston,deepika,sexy4me,grapple,spacebal,ebonee,winter0,smokewee,nargiza,dragonla,sassys,andy2000,menards,yoshio,massive1,suckmy1k,passat99,sexybo,nastya1996,isdead,stratcat,hokuto,infix,pidoras,daffyduck,cumhard,baldeagl,kerberos,yardman,shibainu,guitare,cqub6553,tommyy,bk.irf,bigfoo,hecto,july27,james4,biggus,esbjerg,isgod,1irish,phenmarr,jamaic,roma1990,diamond0,yjdbrjd,girls4me,tampa1,kabuto,vaduz,hanse,spieng,dianochka,csm101,lorna1,ogoshi,plhy6hql,2wsx4rfv,cameron0,adebayo,oleg1996,sharipov,bouboule,hollister1,frogss,yeababy,kablam,adelante,memem,howies,thering,cecilia1,onetwo12,ojp123456,jordan9,msorcloledbr,neveraga,evh5150,redwin,1august,canno,1mercede,moody1,mudbug,chessmas,tiikeri,stickdaddy77,alex15,kvartira,7654321a,lollol123,qwaszxedc,algore,solana,vfhbyfvfhbyf,blue72,misha1111,smoke20,junior13,mogli,threee,shannon2,fuckmylife,kevinh,saransk,karenw,isolde,sekirarr,orion123,thomas0,debra1,laketaho,alondra,curiva,jazz1234,1tigers,jambos,lickme2,suomi,gandalf7,028526,zygote,brett123,br1ttany,supafly,159000,kingrat,luton1,cool-ca,bocman,thomasd,skiller,katter,mama777,chanc,tomass,1rachel,oldno7,rfpfyjdf,bigkev,yelrah,primas,osito,kipper1,msvcr71,bigboy11,thesun,noskcaj,chicc,sonja1,lozinka,mobile1,1vader,ummagumma,waves1,punter12,tubgtn,server1,irina1991,magic69,dak001,pandemonium,dead1,berlingo,cherrypi,1montana,lohotron,chicklet,asdfgh123456,stepside,ikmvw103,icebaby,trillium,1sucks,ukrnet,glock9,ab12345,thepower,robert8,thugstools,hockey13,buffon,livefree,sexpics,dessar,ja0000,rosenrot,james10,1fish,svoloch,mykitty,muffin11,evbukb,shwing,artem1992,andrey1992,sheldon1,passpage,nikita99,fubar123,vannasx,eight888,marial,max2010,express2,violentj,2ykn5ccf,spartan11,brenda69,jackiech,abagail,robin2,grass1,andy76,bell1,taison,superme,vika1995,xtr451,fred20,89032073168,denis1984,2000jeep,weetabix,199020,daxter,tevion,panther8,h9iymxmc,bigrig,kalambur,tsalagi,12213443,racecar02,jeffrey4,nataxa,bigsam,purgator,acuracl,troutbum,potsmoke,jimmyz,manutd1,nytimes,pureevil,bearss,cool22,dragonage,nodnarb,dbrbyu,4seasons,freude,elric1,werule,hockey14,12758698,corkie,yeahright,blademan,tafkap,clave,liziko,hofner,jeffhardy,nurich,runne,stanisla,lucy1,monk3y,forzaroma,eric99,bonaire,blackwoo,fengshui,1qaz0okm,newmoney,pimpin69,07078,anonymer,laptop1,cherry12,ace111,salsa1,wilbur1,doom12,diablo23,jgtxzbhr,under1,honda01,breadfan,megan2,juancarlos,stratus1,ackbar,love5683,happytim,lambert1,cbljhtyrj,komarov,spam69,nfhtkrf,brownn,sarmat,ifiksr,spike69,hoangen,angelz,economia,tanzen,avogadro,1vampire,spanners,mazdarx,queequeg,oriana,hershil,sulaco,joseph11,8seconds,aquariu,cumberla,heather9,anthony8,burton12,crystal0,maria3,qazwsxc,snow123,notgood,198520,raindog,heehaw,consulta,dasein,miller01,cthulhu1,dukenuke,iubire,baytown,hatebree,198505,sistem,lena12,welcome01,maraca,middleto,sindhu,mitsou,phoenix5,vovan,donaldo,dylandog,domovoy,lauren12,byrjuybnj,123llll,stillers,sanchin,tulpan,smallvill,1mmmmm,patti1,folgers,mike31,colts18,123456rrr,njkmrjz,phoenix0,biene,ironcity,kasperok,password22,fitnes,matthew6,spotligh,bujhm123,tommycat,hazel5,guitar11,145678,vfcmrf,compass1,willee,1barney,jack2000,littleminge,shemp,derrek,xxx12345,littlefuck,spuds1,karolinka,camneely,qwertyu123,142500,brandon00,munson15,falcon3,passssap,z3cn2erv,goahead,baggio10,141592,denali1,37kazoo,copernic,123456789asd,orange88,bravada,rush211,197700,pablo123,uptheass,samsam1,demoman,mattylad10,heydude,mister2,werken,13467985,marantz,a22222,f1f2f3f4,fm12mn12,gerasimova,burrito1,sony1,glenny,baldeagle,rmfidd,fenomen,verbati,forgetme,5element,wer138,chanel1,ooicu812,10293847qp,minicooper,chispa,myturn,deisel,vthrehbq,boredboi4u,filatova,anabe,poiuyt1,barmalei,yyyy1,fourkids,naumenko,bangbros,pornclub,okaykk,euclid90,warrior3,kornet,palevo,patatina,gocart,antanta,jed1054,clock1,111111w,dewars,mankind1,peugeot406,liten,tahira,howlin,naumov,rmracing,corone,cunthole,passit,rock69,jaguarxj,bumsen,197101,sweet2,197010,whitecat,sawadee,money100,yfhrjnbrb,andyboy,9085603566,trace1,fagget,robot1,angel20,6yhn7ujm,specialinsta,kareena,newblood,chingada,boobies2,bugger1,squad51,133andre,call06,ashes1,ilovelucy,success2,kotton,cavalla,philou,deebee,theband,nine09,artefact,196100,kkkkkkk1,nikolay9,onelov,basia,emilyann,sadman,fkrjujkbr,teamomuch,david777,padrino,money21,firdaus,orion3,chevy01,albatro,erdfcv,2legit,sarah7,torock,kevinn,holio,soloy,enron714,starfleet,qwer11,neverman,doctorwh,lucy11,dino12,trinity7,seatleon,o123456,pimpman,1asdfgh,snakebit,chancho,prorok,bleacher,ramire,darkseed,warhorse,michael123,1spanky,1hotdog,34erdfcv,n0th1ng,dimanche,repmvbyf,michaeljackson,login1,icequeen,toshiro,sperme,racer2,veget,birthday26,daniel9,lbvekmrf,charlus,bryan123,wspanic,schreibe,1andonly,dgoins,kewell,apollo12,egypt1,fernie,tiger21,aa123456789,blowj,spandau,bisquit,12345678d,deadmau5,fredie,311420,happyface,samant,gruppa,filmstar,andrew17,bakesale,sexy01,justlook,cbarkley,paul11,bloodred,rideme,birdbath,nfkbcvfy,jaxson,sirius1,kristof,virgos,nimrod1,hardc0re,killerbee,1abcdef,pitcher1,justonce,vlada,dakota99,vespucci,wpass,outside1,puertori,rfvbkf,teamlosi,vgfun2,porol777,empire11,20091989q,jasong,webuivalidat,escrima,lakers08,trigger2,addpass,342500,mongini,dfhtybr,horndogg,palermo1,136900,babyblu,alla98,dasha2010,jkelly,kernow,yfnecz,rockhopper,toeman,tlaloc,silver77,dave01,kevinr,1234567887654321,135642,me2you,8096468644q,remmus,spider7,jamesa,jilly,samba1,drongo,770129ji,supercat,juntas,tema1234,esthe,1234567892000,drew11,qazqaz123,beegees,blome,rattrace,howhigh,tallboy,rufus2,sunny2,sou812,miller12,indiana7,irnbru,patch123,letmeon,welcome5,nabisco,9hotpoin,hpvteb,lovinit,stormin,assmonke,trill,atlanti,money1234,cubsfan,mello1,stars2,ueptkm,agate,dannym88,lover123,wordz,worldnet,julemand,chaser1,s12345678,pissword,cinemax,woodchuc,point1,hotchkis,packers2,bananana,kalender,420666,penguin8,awo8rx3wa8t,hoppie,metlife,ilovemyfamily,weihnachtsbau,pudding1,luckystr,scully1,fatboy1,amizade,dedham,jahbless,blaat,surrende,****er,1panties,bigasses,ghjuhfvbcn,asshole123,dfktyrb,likeme,nickers,plastik,hektor,deeman,muchacha,cerebro,santana5,testdrive,dracula1,canalc,l1750sq,savannah1,murena,1inside,pokemon00,1iiiiiii,jordan20,sexual1,mailliw,calipso,014702580369,1zzzzzz,1jjjjjj,break1,15253545,yomama1,katinka,kevin11,1ffffff,martijn,sslazio,daniel5,porno2,nosmas,leolion,jscript,15975312,pundai,kelli1,kkkddd,obafgkm,marmaris,lilmama,london123,rfhfnt,elgordo,talk87,daniel7,thesims3,444111,bishkek,afrika2002,toby22,1speedy,daishi,2children,afroman,qqqqwwww,oldskool,hawai,v55555,syndicat,pukimak,fanatik,tiger5,parker01,bri5kev6,timexx,wartburg,love55,ecosse,yelena03,madinina,highway1,uhfdbwfgf,karuna,buhjvfybz,wallie,46and2,khalif,europ,qaz123wsx456,bobbybob,wolfone,falloutboy,manning18,scuba10,schnuff,ihateyou1,lindam,sara123,popcor,fallengun,divine1,montblanc,qwerty8,rooney10,roadrage,bertie1,latinus,lexusis,rhfvfnjhcr,opelgt,hitme,agatka,1yamaha,dmfxhkju,imaloser,michell1,sb211st,silver22,lockedup,andrew9,monica01,sassycat,dsobwick,tinroof,ctrhtnyj,bultaco,rhfcyjzhcr,aaaassss,14ss88,joanne1,momanddad,ahjkjdf,yelhsa,zipdrive,telescop,500600,1sexsex,facial1,motaro,511647,stoner1,temujin,elephant1,greatman,honey69,kociak,ukqmwhj6,altezza,cumquat,zippos,kontiki,123max,altec1,bibigon,tontos,qazsew,nopasaran,militar,supratt,oglala,kobayash,agathe,yawetag,dogs1,cfiekmrf,megan123,jamesdea,porosenok,tiger23,berger1,hello11,seemann,stunner1,walker2,imissu,jabari,minfd,lollol12,hjvfy,1-oct,stjohns,2278124q,123456789qwer,alex1983,glowworm,chicho,mallards,bluedevil,explorer1,543211,casita,1time,lachesis,alex1982,airborn1,dubesor,changa,lizzie1,captaink,socool,bidule,march23,1861brr,k.ljxrf,watchout,fotze,1brian,keksa2,aaaa1122,matrim,providian,privado,dreame,merry1,aregdone,davidt,nounour,twenty2,play2win,artcast2,zontik,552255,shit1,sluggy,552861,dr8350,brooze,alpha69,thunder6,kamelia2011,caleb123,mmxxmm,jamesh,lfybkjd,125267,125000,124536,bliss1,dddsss,indonesi,bob69,123888,tgkbxfgy,gerar,themack,hijodeputa,good4now,ddd123,clk430,kalash,tolkien1,132forever,blackb,whatis,s1s2s3s4,lolkin09,yamahar,48n25rcc,djtiesto,111222333444555,bigbull,blade55,coolbree,kelse,ichwill,yamaha12,sakic,bebeto,katoom,donke,sahar,wahine,645202,god666,berni,starwood,june15,sonoio,time123,llbean,deadsoul,lazarev,cdtnf,ksyusha,madarchod,technik,jamesy,4speed,tenorsax,legshow,yoshi1,chrisbl,44e3ebda,trafalga,heather7,serafima,favorite4,havefun1,wolve,55555r,james13,nosredna,bodean,jlettier,borracho,mickael,marinus,brutu,sweet666,kiborg,rollrock,jackson6,macross1,ousooner,9085084232,takeme,123qwaszx,firedept,vfrfhjd,jackfros,123456789000,briane,cookie11,baby22,bobby18,gromova,systemofadown,martin01,silver01,pimaou,darthmaul,hijinx,commo,chech,skyman,sunse,2vrd6,vladimirovna,uthvfybz,nicole01,kreker,bobo1,v123456789,erxtgb,meetoo,drakcap,vfvf12,misiek1,butane,network2,flyers99,riogrand,jennyk,e12345,spinne,avalon11,lovejone,studen,maint,porsche2,qwerty100,chamberl,bluedog1,sungam,just4u,andrew23,summer22,ludic,musiclover,aguil,beardog1,libertin,pippo1,joselit,patito,bigberth,digler,sydnee,jockstra,poopo,jas4an,nastya123,profil,fuesse,default1,titan2,mendoz,kpcofgs,anamika,brillo021,bomberman,guitar69,latching,69pussy,blues2,phelge,ninja123,m7n56xo,qwertasd,alex1976,cunningh,estrela,gladbach,marillion,mike2000,258046,bypop,muffinman,kd5396b,zeratul,djkxbwf,john77,sigma2,1linda,selur,reppep,quartz1,teen1,freeclus,spook1,kudos4ever,clitring,sexiness,blumpkin,macbook,tileman,centra,escaflowne,pentable,shant,grappa,zverev,1albert,lommerse,coffee11,777123,polkilo,muppet1,alex74,lkjhgfdsazx,olesica,april14,ba25547,souths,jasmi,arashi,smile2,2401pedro,mybabe,alex111,quintain,pimp1,tdeir8b2,makenna,122333444455555,%e2%82%ac,tootsie1,pass111,zaqxsw123,gkfdfybt,cnfnbcnbrf,usermane,iloveyou12,hard69,osasuna,firegod,arvind,babochka,kiss123,cookie123,julie123,kamakazi,dylan2,223355,tanguy,nbhtqa,tigger13,tubby1,makavel,asdflkj,sambo1,mononoke,mickeys,gayguy,win123,green33,wcrfxtvgbjy,bigsmall,1newlife,clove,babyfac,bigwaves,mama1970,shockwav,1friday,bassey,yarddog,codered1,victory7,bigrick,kracker,gulfstre,chris200,sunbanna,bertuzzi,begemotik,kuolema,pondus,destinee,123456789zz,abiodun,flopsy,amadeusptfcor,geronim,yggdrasi,contex,daniel6,suck1,adonis1,moorea,el345612,f22raptor,moviebuf,raunchy,6043dkf,zxcvbnm123456789,eric11,deadmoin,ratiug,nosliw,fannies,danno,888889,blank1,mikey2,gullit,thor99,mamiya,ollieb,thoth,dagger1,websolutionssu,bonker,prive,1346798520,03038,q1234q,mommy2,contax,zhipo,gwendoli,gothic1,1234562000,lovedick,gibso,digital2,space199,b26354,987654123,golive,serious1,pivkoo,better1,824358553,794613258,nata1980,logout,fishpond,buttss,squidly,good4me,redsox19,jhonny,zse45rdx,matrixxx,honey12,ramina,213546879,motzart,fall99,newspape,killit,gimpy,photowiz,olesja,thebus,marco123,147852963,bedbug,147369258,hellbound,gjgjxrf,123987456,lovehurt,five55,hammer01,1234554321a,alina2011,peppino,ang238,questor,112358132,alina1994,alina1998,money77,bobjones,aigerim,cressida,madalena,420smoke,tinchair,raven13,mooser,mauric,lovebu,adidas69,krypton1,1111112,loveline,divin,voshod,michaelm,cocotte,gbkbuhbv,76689295,kellyj,rhonda1,sweetu70,steamforums,geeque,nothere,124c41,quixotic,steam181,1169900,rfcgthcrbq,rfvbkm,sexstuff,1231230,djctvm,rockstar1,fulhamfc,bhecbr,rfntyf,quiksilv,56836803,jedimaster,pangit,gfhjkm777,tocool,1237654,stella12,55378008,19216811,potte,fender12,mortalkombat,ball1,nudegirl,palace22,rattrap,debeers,lickpussy,jimmy6,not4u2c,wert12,bigjuggs,sadomaso,1357924,312mas,laser123,arminia,branford,coastie,mrmojo,19801982,scott11,banaan123,ingres,300zxtt,hooters6,sweeties,19821983,19831985,19833891,sinnfein,welcome4,winner69,killerman,tachyon,tigre1,nymets1,kangol,martinet,sooty1,19921993,789qwe,harsingh,1597535,thecount,phantom3,36985214,lukas123,117711,pakistan1,madmax11,willow01,19932916,fucker12,flhrci,opelagila,theword,ashley24,tigger3,crazyj,rapide,deadfish,allana,31359092,sasha1993,sanders2,discman,zaq!2wsx,boilerma,mickey69,jamesg,babybo,jackson9,orion7,alina2010,indien,breeze1,atease,warspite,bazongaz,1celtic,asguard,mygal,fitzgera,1secret,duke33,cyklone,dipascuc,potapov,1escobar2,c0l0rad0,kki177hk,1little,macondo,victoriya,peter7,red666,winston6,kl?benhavn,muneca,jackme,jennan,happylife,am4h39d8nh,bodybuil,201980,dutchie,biggame,lapo4ka,rauchen,black10,flaquit,water12,31021364,command2,lainth88,mazdamx5,typhon,colin123,rcfhlfc,qwaszx11,g0away,ramir,diesirae,hacked1,cessna1,woodfish,enigma2,pqnr67w5,odgez8j3,grisou,hiheels,5gtgiaxm,2580258,ohotnik,transits,quackers,serjik,makenzie,mdmgatew,bryana,superman12,melly,lokit,thegod,slickone,fun4all,netpass,penhorse,1cooper,nsync,asdasd22,otherside,honeydog,herbie1,chiphi,proghouse,l0nd0n,shagg,select1,frost1996,casper123,countr,magichat,greatzyo,jyothi,3bears,thefly,nikkita,fgjcnjk,nitros,hornys,san123,lightspe,maslova,kimber1,newyork2,spammm,mikejone,pumpk1n,bruiser1,bacons,prelude9,boodie,dragon4,kenneth2,love98,power5,yodude,pumba,thinline,blue30,sexxybj,2dumb2live,matt21,forsale,1carolin,innova,ilikeporn,rbgtkjd,a1s2d3f,wu9942,ruffus,blackboo,qwerty999,draco1,marcelin,hideki,gendalf,trevon,saraha,cartmen,yjhbkmcr,time2go,fanclub,ladder1,chinni,6942987,united99,lindac,quadra,paolit,mainstre,beano002,lincoln7,bellend,anomie,8520456,bangalor,goodstuff,chernov,stepashka,gulla,mike007,frasse,harley03,omnislash,8538622,maryjan,sasha2011,gineok,8807031,hornier,gopinath,princesit,bdr529,godown,bosslady,hakaone,1qwe2,madman1,joshua11,lovegame,bayamon,jedi01,stupid12,sport123,aaa666,tony44,collect1,charliem,chimaira,cx18ka,trrim777,chuckd,thedream,redsox99,goodmorning,delta88,iloveyou11,newlife2,figvam,chicago3,jasonk,12qwer,9875321,lestat1,satcom,conditio,capri50,sayaka,9933162,trunks1,chinga,snooch,alexand1,findus,poekie,cfdbyf,kevind,mike1969,fire13,leftie,bigtuna,chinnu,silence1,celos1,blackdra,alex24,gfgfif,2boobs,happy8,enolagay,sataniv1993,turner1,dylans,peugeo,sasha1994,hoppel,conno,moonshot,santa234,meister1,008800,hanako,tree123,qweras,gfitymrf,reggie31,august29,supert,joshua10,akademia,gbljhfc,zorro123,nathalia,redsox12,hfpdjl,mishmash,nokiae51,nyyankees,tu190022,strongbo,none1,not4u2no,katie2,popart,harlequi,santan,michal1,1therock,screwu,csyekmrf,olemiss1,tyrese,hoople,sunshin1,cucina,starbase,topshelf,fostex,california1,castle1,symantec,pippolo,babare,turntabl,1angela,moo123,ipvteb,gogolf,alex88,cycle1,maxie1,phase2,selhurst,furnitur,samfox,fromvermine,shaq34,gators96,captain2,delonge,tomatoe,bisous,zxcvbnma,glacius,pineapple1,cannelle,ganibal,mko09ijn,paraklast1974,hobbes12,petty43,artema,junior8,mylover,1234567890d,fatal1ty,prostreet,peruan,10020,nadya,caution1,marocas,chanel5,summer08,metal123,111lox,scrapy,thatguy,eddie666,washingto,yannis,minnesota_hp,lucky4,playboy6,naumova,azzurro,patat,dale33,pa55wd,speedster,zemanova,saraht,newto,tony22,qscesz,arkady,1oliver,death6,vkfwx046,antiflag,stangs,jzf7qf2e,brianp,fozzy,cody123,startrek1,yoda123,murciela,trabajo,lvbnhbtdf,canario,fliper,adroit,henry5,goducks,papirus,alskdj,soccer6,88mike,gogetter,tanelorn,donking,marky1,leedsu,badmofo,al1916,wetdog,akmaral,pallet,april24,killer00,nesterova,rugby123,coffee12,browseui,ralliart,paigow,calgary1,armyman,vtldtltd,frodo2,frxtgb,iambigal,benno,jaytee,2hot4you,askar,bigtee,brentwoo,palladin,eddie2,al1916w,horosho,entrada,ilovetits,venture1,dragon19,jayde,chuvak,jamesl,fzr600,brandon8,vjqvbh,snowbal,snatch1,bg6njokf,pudder,karolin,candoo,pfuflrf,satchel1,manteca,khongbiet,critter1,partridg,skyclad,bigdon,ginger69,brave1,anthony4,spinnake,chinadol,passout,cochino,nipples1,15058,lopesk,sixflags,lloo999,parkhead,breakdance,cia123,fidodido,yuitre12,fooey,artem1995,gayathri,medin,nondriversig,l12345,bravo7,happy13,kazuya,camster,alex1998,luckyy,zipcode,dizzle,boating1,opusone,newpassw,movies23,kamikazi,zapato,bart316,cowboys0,corsair1,kingshit,hotdog12,rolyat,h200svrm,qwerty4,boofer,rhtyltkm,chris999,vaz21074,simferopol,pitboss,love3,britania,tanyshka,brause,123qwerty123,abeille,moscow1,ilkaev,manut,process1,inetcfg,dragon05,fortknox,castill,rynner,mrmike,koalas,jeebus,stockpor,longman,juanpabl,caiman,roleplay,jeremi,26058,prodojo,002200,magical1,black5,bvlgari,doogie1,cbhtqa,mahina,a1s2d3f4g5h6,jblpro,usmc01,bismilah,guitar01,april9,santana1,1234aa,monkey14,sorokin,evan1,doohan,animalsex,pfqxtyjr,dimitry,catchme,chello,silverch,glock45,dogleg,litespee,nirvana9,peyton18,alydar,warhamer,iluvme,sig229,minotavr,lobzik,jack23,bushwack,onlin,football123,joshua5,federov,winter2,bigmax,fufnfrhbcnb,hfpldfnhb,1dakota,f56307,chipmonk,4nick8,praline,vbhjh123,king11,22tango,gemini12,street1,77879,doodlebu,homyak,165432,chuluthu,trixi,karlito,salom,reisen,cdtnkzxjr,pookie11,tremendo,shazaam,welcome0,00000ty,peewee51,pizzle,gilead,bydand,sarvar,upskirt,legends1,freeway1,teenfuck,ranger9,darkfire,dfymrf,hunt0802,justme1,buffy1ma,1harry,671fsa75yt,burrfoot,budster,pa437tu,jimmyp,alina2006,malacon,charlize,elway1,free12,summer02,gadina,manara,gomer1,1cassie,sanja,kisulya,money3,pujols,ford50,midiland,turga,orange6,demetriu,freakboy,orosie1,radio123,open12,vfufpby,mustek,chris33,animes,meiling,nthtvjr,jasmine9,gfdkjd,oligarh,marimar,chicago9,.kzirf,bugssgub,samuraix,jackie01,pimpjuic,macdad,cagiva,vernost,willyboy,fynjyjdf,tabby1,privet123,torres9,retype,blueroom,raven11,q12we3,alex1989,bringiton,ridered,kareltje,ow8jtcs8t,ciccia,goniners,countryb,24688642,covingto,24861793,beyblade,vikin,badboyz,wlafiga,walstib,mirand,needajob,chloes,balaton,kbpfdtnf,freyja,bond9007,gabriel12,stormbri,hollage,love4eve,fenomeno,darknite,dragstar,kyle123,milfhunter,ma123123123,samia,ghislain,enrique1,ferien12,xjy6721,natalie2,reglisse,wilson2,wesker,rosebud7,amazon1,robertr,roykeane,xtcnth,mamatata,crazyc,mikie,savanah,blowjob69,jackie2,forty1,1coffee,fhbyjxrf,bubbah,goteam,hackedit,risky1,logoff,h397pnvr,buck13,robert23,bronc,st123st,godflesh,pornog,iamking,cisco69,septiembr,dale38,zhongguo,tibbar,panther9,buffa1,bigjohn1,mypuppy,vehvfycr,april16,shippo,fire1234,green15,q123123,gungadin,steveg,olivier1,chinaski,magnoli,faithy,storm12,toadfrog,paul99,78791,august20,automati,squirtle,cheezy,positano,burbon,nunya,llebpmac,kimmi,turtle2,alan123,prokuror,violin1,durex,pussygal,visionar,trick1,chicken6,29024,plowboy,rfybreks,imbue,sasha13,wagner1,vitalogy,cfymrf,thepro,26028,gorbunov,dvdcom,letmein5,duder,fastfun,pronin,libra1,conner1,harley20,stinker1,20068,20038,amitech,syoung,dugway,18068,welcome7,jimmypag,anastaci,kafka1,pfhfnecnhf,catsss,campus100,shamal,nacho1,fire12,vikings2,brasil1,rangerover,mohamma,peresvet,14058,cocomo,aliona,14038,qwaser,vikes,cbkmdf,skyblue1,ou81234,goodlove,dfkmltvfh,108888,roamer,pinky2,static1,zxcv4321,barmen,rock22,shelby2,morgans,1junior,pasword1,logjam,fifty5,nhfrnjhbcn,chaddy,philli,nemesis2,ingenier,djkrjd,ranger3,aikman8,knothead,daddy69,love007,vsythb,ford350,tiger00,renrut,owen11,energy12,march14,alena123,robert19,carisma,orange22,murphy11,podarok,prozak,kfgeirf,wolf13,lydia1,shazza,parasha,akimov,tobbie,pilote,heather4,baster,leones,gznfxjr,megama,987654321g,bullgod,boxster1,minkey,wombats,vergil,colegiata,lincol,smoothe,pride1,carwash1,latrell,bowling3,fylhtq123,pickwick,eider,bubblebox,bunnies1,loquit,slipper1,nutsac,purina,xtutdfhf,plokiju,1qazxs,uhjpysq,zxcvbasdfg,enjoy1,1pumpkin,phantom7,mama22,swordsma,wonderbr,dogdays,milker,u23456,silvan,dfkthbr,slagelse,yeahman,twothree,boston11,wolf100,dannyg,troll1,fynjy123,ghbcnfd,bftest,ballsdeep,bobbyorr,alphasig,cccdemo,fire123,norwest,claire2,august10,lth1108,problemas,sapito,alex06,1rusty,maccom,goirish1,ohyes,bxdumb,nabila,boobear1,rabbit69,princip,alexsander,travail,chantal1,dogggy,greenpea,diablo69,alex2009,bergen09,petticoa,classe,ceilidh,vlad2011,kamakiri,lucidity,qaz321,chileno,cexfhf,99ranger,mcitra,estoppel,volvos60,carter80,webpass,temp12,touareg,fcgbhby,bubba8,sunitha,200190ru,bitch2,shadow23,iluvit,nicole0,ruben1,nikki69,butttt,shocker1,souschef,lopotok01,kantot,corsano,cfnfyf,riverat,makalu,swapna,all4u9,cdtnkfy,ntktgepbr,ronaldo99,thomasj,bmw540i,chrisw,boomba,open321,z1x2c3v4b5n6m7,gaviota,iceman44,frosya,chris100,chris24,cosette,clearwat,micael,boogyman,pussy9,camus1,chumpy,heccrbq,konoplya,chester8,scooter5,ghjgfufylf,giotto,koolkat,zero000,bonita1,ckflrbq,j1964,mandog,18n28n24a,renob,head1,shergar,ringo123,tanita,sex4free,johnny12,halberd,reddevils,biolog,dillinge,fatb0y,c00per,hyperlit,wallace2,spears1,vitamine,buheirf,sloboda,alkash,mooman,marion1,arsenal7,sunder,nokia5610,edifier,pippone,fyfnjkmtdbx,fujimo,pepsi12,kulikova,bolat,duetto,daimon,maddog01,timoshka,ezmoney,desdemon,chesters,aiden,hugues,patrick5,aikman08,robert4,roenick,nyranger,writer1,36169544,foxmulder,118801,kutter,shashank,jamjar,118811,119955,aspirina,dinkus,1sailor,nalgene,19891959,snarf,allie1,cracky,resipsa,45678912,kemerovo,19841989,netware1,alhimik,19801984,nicole123,19761977,51501984,malaka1,montella,peachfuz,jethro1,cypress1,henkie,holdon,esmith,55443322,1friend,quique,bandicoot,statistika,great123,death13,ucht36,master4,67899876,bobsmith,nikko1,jr1234,hillary1,78978978,rsturbo,lzlzdfcz,bloodlust,shadow00,skagen,bambina,yummies,88887777,91328378,matthew4,itdoes,98256518,102938475,alina2002,123123789,fubared,dannys,123456321,nikifor,suck69,newmexico,scubaman,rhbcnb,fifnfy,puffdadd,159357852,dtheyxbr,theman22,212009164,prohor,shirle,nji90okm,newmedia,goose5,roma1995,letssee,iceman11,aksana,wirenut,pimpdady,1212312121,tamplier,pelican1,domodedovo,1928374655,fiction6,duckpond,ybrecz,thwack,onetwo34,gunsmith,murphydo,fallout1,spectre1,jabberwo,jgjesq,turbo6,bobo12,redryder,blackpus,elena1971,danilova,antoin,bobo1234,bobob,bobbobbo,dean1,222222a,jesusgod,matt23,musical1,darkmage,loppol,werrew,josepha,rebel12,toshka,gadfly,hawkwood,alina12,dnomyar,sexaddict,dangit,cool23,yocrack,archimed,farouk,nhfkzkz,lindalou,111zzzzz,ghjatccjh,wethepeople,m123456789,wowsers,kbkbxrf,bulldog5,m_roesel,sissinit,yamoon6,123ewqasd,dangel,miruvor79,kaytee,falcon7,bandit11,dotnet,dannii,arsenal9,miatamx5,1trouble,strip4me,dogpile,sexyred1,rjdfktdf,google10,shortman,crystal7,awesome123,cowdog,haruka,birthday28,jitter,diabolik,boomer12,dknight,bluewate,hockey123,crm0624,blueboys,willy123,jumpup,google2,cobra777,llabesab,vicelord,hopper1,gerryber,remmah,j10e5d4,qqqqqqw,agusti,fre_ak8yj,nahlik,redrobin,scott3,epson1,dumpy,bundao,aniolek,hola123,jergens,itsasecret,maxsam,bluelight,mountai1,bongwater,1london,pepper14,freeuse,dereks,qweqw,fordgt40,rfhfdfy,raider12,hunnybun,compac,splicer,megamon,tuffgong,gymnast1,butter11,modaddy,wapbbs_1,dandelio,soccer77,ghjnbdjcnjzybt,123xyi2,fishead,x002tp00,whodaman,555aaa,oussama,brunodog,technici,pmtgjnbl,qcxdw8ry,schweden,redsox3,throbber,collecto,japan10,dbm123dm,hellhoun,tech1,deadzone,kahlan,wolf123,dethklok,xzsawq,bigguy1,cybrthc,chandle,buck01,qq123123,secreta,williams1,c32649135,delta12,flash33,123joker,spacejam,polopo,holycrap,daman1,tummybed,financia,nusrat,euroline,magicone,jimkirk,ameritec,daniel26,sevenn,topazz,kingpins,dima1991,macdog,spencer5,oi812,geoffre,music11,baffle,123569,usagi,cassiope,polla,lilcrowe,thecakeisalie,vbhjndjhtw,vthokies,oldmans,sophie01,ghoster,penny2,129834,locutus1,meesha,magik,jerry69,daddysgirl,irondesk,andrey12,jasmine123,vepsrfyn,likesdick,1accord,jetboat,grafix,tomuch,showit,protozoa,mosias98,taburetka,blaze420,esenin,anal69,zhv84kv,puissant,charles0,aishwarya,babylon6,bitter1,lenina,raleigh1,lechat,access01,kamilka,fynjy,sparkplu,daisy3112,choppe,zootsuit,1234567j,rubyrose,gorilla9,nightshade,alternativa,cghfdjxybr,snuggles1,10121v,vova1992,leonardo1,dave2,matthewd,vfhfnbr,1986mets,nobull,bacall,mexican1,juanjo,mafia1,boomer22,soylent,edwards1,jordan10,blackwid,alex86,gemini13,lunar2,dctvcjcfnm,malaki,plugger,eagles11,snafu2,1shelly,cintaku,hannah22,tbird1,maks5843,irish88,homer22,amarok,fktrcfylhjdf,lincoln2,acess,gre69kik,need4speed,hightech,core2duo,blunt1,ublhjgjybrf,dragon33,1autopas,autopas1,wwww1,15935746,daniel20,2500aa,massim,1ggggggg,96ford,hardcor1,cobra5,blackdragon,vovan_lt,orochimaru,hjlbntkb,qwertyuiop12,tallen,paradoks,frozenfish,ghjuhfvvbcn,gerri1,nuggett,camilit,doright,trans1,serena1,catch2,bkmyeh,fireston,afhvfwtdn,purple3,figure8,fuckya,scamp1,laranja,ontheoutside,louis123,yellow7,moonwalk,mercury2,tolkein,raide,amenra,a13579,dranreb,5150vh,harish,tracksta,sexking,ozzmosis,katiee,alomar,matrix19,headroom,jahlove,ringding,apollo8,132546,132613,12345672000,saretta,135798,136666,thomas7,136913,onetwothree,hockey33,calida,nefertit,bitwise,tailhook,boop4,kfgecbr,bujhmbujhm,metal69,thedark,meteoro,felicia1,house12,tinuviel,istina,vaz2105,pimp13,toolfan,nina1,tuesday2,maxmotives,lgkp500,locksley,treech,darling1,kurama,aminka,ramin,redhed,dazzler,jager1,stpiliot,cardman,rfvtym,cheeser,14314314,paramoun,samcat,plumpy,stiffie,vsajyjr,panatha,qqq777,car12345,098poi,asdzx,keegan1,furelise,kalifornia,vbhjckfd,beast123,zcfvfzkexifz,harry5,1birdie,96328i,escola,extra330,henry12,gfhfyjqz,14u2nv,max1234,templar1,1dave,02588520,catrin,pangolin,marhaba,latin1,amorcito,dave22,escape1,advance1,yasuhiro,grepw,meetme,orange01,ernes,erdna,zsergn,nautica1,justinb,soundwav,miasma,greg78,nadine1,sexmad,lovebaby,promo1,excel1,babys,dragonma,camry1,sonnenschein,farooq,wazzkaprivet,magal,katinas,elvis99,redsox24,rooney1,chiefy,peggys,aliev,pilsung,mudhen,dontdoit,dennis12,supercal,energia,ballsout,funone,claudiu,brown2,amoco,dabl1125,philos,gjdtkbntkm,servette,13571113,whizzer,nollie,13467982,upiter,12string,bluejay1,silkie,william4,kosta1,143333,connor12,sustanon,06068,corporat,ssnake,laurita,king10,tahoes,arsenal123,sapato,charless,jeanmarc,levent,algerie,marine21,jettas,winsome,dctvgbplf,1701ab,xxxp455w0rd5,lllllll1,ooooooo1,monalis,koufax32,anastasya,debugger,sarita2,jason69,ufkxjyjr,gjlcnfdf,1jerry,daniel10,balinor,sexkitten,death2,qwertasdfgzxcvb,s9te949f,vegeta1,sysman,maxxam,dimabilan,mooose,ilovetit,june23,illest,doesit,mamou,abby12,longjump,transalp,moderato,littleguy,magritte,dilnoza,hawaiiguy,winbig,nemiroff,kokaine,admira,myemail,dream2,browneyes,destiny7,dragonss,suckme1,asa123,andranik,suckem,fleshbot,dandie,timmys,scitra,timdog,hasbeen,guesss,smellyfe,arachne,deutschl,harley88,birthday27,nobody1,papasmur,home1,jonass,bunia3,epatb1,embalm,vfvekmrf,apacer,12345656,estreet,weihnachtsbaum,mrwhite,admin12,kristie1,kelebek,yoda69,socken,tima123,bayern1,fktrcfylth,tamiya,99strenght,andy01,denis2011,19delta,stokecit,aotearoa,stalker2,nicnac,conrad1,popey,agusta,bowl36,1bigfish,mossyoak,1stunner,getinnow,jessejames,gkfnjy,drako,1nissan,egor123,hotness,1hawaii,zxc123456,cantstop,1peaches,madlen,west1234,jeter1,markis,judit,attack1,artemi,silver69,153246,crazy2,green9,yoshimi,1vette,chief123,jasper2,1sierra,twentyon,drstrang,aspirant,yannic,jenna123,bongtoke,slurpy,1sugar,civic97,rusty21,shineon,james19,anna12345,wonderwoman,1kevin,karol1,kanabis,wert21,fktif6115,evil1,kakaha,54gv768,826248s,tyrone1,1winston,sugar2,falcon01,adelya,mopar440,zasxcd,leecher,kinkysex,mercede1,travka,11234567,rebon,geekboy".split(","),
    english_wikipedia: "the,of,and,in,was,is,for,as,on,with,by,he,at,from,his,an,were,are,which,doc,https,also,or,has,had,first,one,their,its,after,new,who,they,two,her,she,been,other,when,time,during,there,into,school,more,may,years,over,only,year,most,would,world,city,some,where,between,later,three,state,such,then,national,used,made,known,under,many,university,united,while,part,season,team,these,american,than,film,second,born,south,became,states,war,through,being,including,both,before,north,high,however,people,family,early,history,album,area,them,series,against,until,since,district,county,name,work,life,group,music,following,number,company,several,four,called,played,released,career,league,game,government,house,each,based,day,same,won,use,station,club,international,town,located,population,general,college,east,found,age,march,end,september,began,home,public,church,line,june,river,member,system,place,century,band,july,york,january,october,song,august,best,former,british,party,named,held,village,show,local,november,took,service,december,built,another,major,within,along,members,five,single,due,although,small,old,left,final,large,include,building,served,president,received,games,death,february,main,third,set,children,own,order,species,park,law,air,published,road,died,book,men,women,army,often,according,education,central,country,division,english,top,included,development,french,community,among,water,play,side,list,times,near,late,form,original,different,center,power,led,students,german,moved,court,six,land,council,island,u.s.,record,million,research,art,established,award,street,military,television,given,region,support,western,production,non,political,point,cup,period,business,title,started,various,election,using,england,role,produced,become,program,works,field,total,office,class,written,association,radio,union,level,championship,director,few,force,created,department,founded,services,married,though,per,n't,site,open,act,short,society,version,royal,present,northern,worked,professional,full,returned,joined,story,france,european,currently,language,social,california,india,days,design,st.,further,round,australia,wrote,san,project,control,southern,railway,board,popular,continued,free,battle,considered,video,common,position,living,half,playing,recorded,red,post,described,average,records,special,modern,appeared,announced,areas,rock,release,elected,others,example,term,opened,similar,formed,route,census,current,schools,originally,lake,developed,race,himself,forces,addition,information,upon,province,match,event,songs,result,events,win,eastern,track,lead,teams,science,human,construction,minister,germany,awards,available,throughout,training,style,body,museum,australian,health,seven,signed,chief,eventually,appointed,sea,centre,debut,tour,points,media,light,range,character,across,features,families,largest,indian,network,less,performance,players,refer,europe,sold,festival,usually,taken,despite,designed,committee,process,return,official,episode,institute,stage,followed,performed,japanese,personal,thus,arts,space,low,months,includes,china,study,middle,magazine,leading,japan,groups,aircraft,featured,federal,civil,rights,model,coach,canadian,books,remained,eight,type,independent,completed,capital,academy,instead,kingdom,organization,countries,studies,competition,sports,size,above,section,finished,gold,involved,reported,management,systems,industry,directed,market,fourth,movement,technology,bank,ground,campaign,base,lower,sent,rather,added,provided,coast,grand,historic,valley,conference,bridge,winning,approximately,films,chinese,awarded,degree,russian,shows,native,female,replaced,municipality,square,studio,medical,data,african,successful,mid,bay,attack,previous,operations,spanish,theatre,student,republic,beginning,provide,ship,primary,owned,writing,tournament,culture,introduced,texas,related,natural,parts,governor,reached,ireland,units,senior,decided,italian,whose,higher,africa,standard,income,professor,placed,regional,los,buildings,championships,active,novel,energy,generally,interest,via,economic,previously,stated,itself,channel,below,operation,leader,traditional,trade,structure,limited,runs,prior,regular,famous,saint,navy,foreign,listed,artist,catholic,airport,results,parliament,collection,unit,officer,goal,attended,command,staff,commission,lived,location,plays,commercial,places,foundation,significant,older,medal,self,scored,companies,highway,activities,programs,wide,musical,notable,library,numerous,paris,towards,individual,allowed,plant,property,annual,contract,whom,highest,initially,required,earlier,assembly,artists,rural,seat,practice,defeated,ended,soviet,length,spent,manager,press,associated,author,issues,additional,characters,lord,zealand,policy,engine,township,noted,historical,complete,financial,religious,mission,contains,nine,recent,represented,pennsylvania,administration,opening,secretary,lines,report,executive,youth,closed,theory,writer,italy,angeles,appearance,feature,queen,launched,legal,terms,entered,issue,edition,singer,greek,majority,background,source,anti,cultural,complex,changes,recording,stadium,islands,operated,particularly,basketball,month,uses,port,castle,mostly,names,fort,selected,increased,status,earth,subsequently,pacific,cover,variety,certain,goals,remains,upper,congress,becoming,studied,irish,nature,particular,loss,caused,chart,dr.,forced,create,era,retired,material,review,rate,singles,referred,larger,individuals,shown,provides,products,speed,democratic,poland,parish,olympics,cities,themselves,temple,wing,genus,households,serving,cost,wales,stations,passed,supported,view,cases,forms,actor,male,matches,males,stars,tracks,females,administrative,median,effect,biography,train,engineering,camp,offered,chairman,houses,mainly,19th,surface,therefore,nearly,score,ancient,subject,prime,seasons,claimed,experience,specific,jewish,failed,overall,believed,plot,troops,greater,spain,consists,broadcast,heavy,increase,raised,separate,campus,1980s,appears,presented,lies,composed,recently,influence,fifth,nations,creek,references,elections,britain,double,cast,meaning,earned,carried,producer,latter,housing,brothers,attempt,article,response,border,remaining,nearby,direct,ships,value,workers,politician,academic,label,1970s,commander,rule,fellow,residents,authority,editor,transport,dutch,projects,responsible,covered,territory,flight,races,defense,tower,emperor,albums,facilities,daily,stories,assistant,managed,primarily,quality,function,proposed,distribution,conditions,prize,journal,code,vice,newspaper,corps,highly,constructed,mayor,critical,secondary,corporation,rugby,regiment,ohio,appearances,serve,allow,nation,multiple,discovered,directly,scene,levels,growth,elements,acquired,1990s,officers,physical,20th,latin,host,jersey,graduated,arrived,issued,literature,metal,estate,vote,immediately,quickly,asian,competed,extended,produce,urban,1960s,promoted,contemporary,global,formerly,appear,industrial,types,opera,ministry,soldiers,commonly,mass,formation,smaller,typically,drama,shortly,density,senate,effects,iran,polish,prominent,naval,settlement,divided,basis,republican,languages,distance,treatment,continue,product,mile,sources,footballer,format,clubs,leadership,initial,offers,operating,avenue,officially,columbia,grade,squadron,fleet,percent,farm,leaders,agreement,likely,equipment,website,mount,grew,method,transferred,intended,renamed,iron,asia,reserve,capacity,politics,widely,activity,advanced,relations,scottish,dedicated,crew,founder,episodes,lack,amount,build,efforts,concept,follows,ordered,leaves,positive,economy,entertainment,affairs,memorial,ability,illinois,communities,color,text,railroad,scientific,focus,comedy,serves,exchange,environment,cars,direction,organized,firm,description,agency,analysis,purpose,destroyed,reception,planned,revealed,infantry,architecture,growing,featuring,household,candidate,removed,situated,models,knowledge,solo,technical,organizations,assigned,conducted,participated,largely,purchased,register,gained,combined,headquarters,adopted,potential,protection,scale,approach,spread,independence,mountains,titled,geography,applied,safety,mixed,accepted,continues,captured,rail,defeat,principal,recognized,lieutenant,mentioned,semi,owner,joint,liberal,actress,traffic,creation,basic,notes,unique,supreme,declared,simply,plants,sales,massachusetts,designated,parties,jazz,compared,becomes,resources,titles,concert,learning,remain,teaching,versions,content,alongside,revolution,sons,block,premier,impact,champions,districts,generation,estimated,volume,image,sites,account,roles,sport,quarter,providing,zone,yard,scoring,classes,presence,performances,representatives,hosted,split,taught,origin,olympic,claims,critics,facility,occurred,suffered,municipal,damage,defined,resulted,respectively,expanded,platform,draft,opposition,expected,educational,ontario,climate,reports,atlantic,surrounding,performing,reduced,ranked,allows,birth,nominated,younger,newly,kong,positions,theater,philadelphia,heritage,finals,disease,sixth,laws,reviews,constitution,tradition,swedish,theme,fiction,rome,medicine,trains,resulting,existing,deputy,environmental,labour,classical,develop,fans,granted,receive,alternative,begins,nuclear,fame,buried,connected,identified,palace,falls,letters,combat,sciences,effort,villages,inspired,regions,towns,conservative,chosen,animals,labor,attacks,materials,yards,steel,representative,orchestra,peak,entitled,officials,returning,reference,northwest,imperial,convention,examples,ocean,publication,painting,subsequent,frequently,religion,brigade,fully,sides,acts,cemetery,relatively,oldest,suggested,succeeded,achieved,application,programme,cells,votes,promotion,graduate,armed,supply,flying,communist,figures,literary,netherlands,korea,worldwide,citizens,1950s,faculty,draw,stock,seats,occupied,methods,unknown,articles,claim,holds,authorities,audience,sweden,interview,obtained,covers,settled,transfer,marked,allowing,funding,challenge,southeast,unlike,crown,rise,portion,transportation,sector,phase,properties,edge,tropical,standards,institutions,philosophy,legislative,hills,brand,fund,conflict,unable,founding,refused,attempts,metres,permanent,starring,applications,creating,effective,aired,extensive,employed,enemy,expansion,billboard,rank,battalion,multi,vehicle,fought,alliance,category,perform,federation,poetry,bronze,bands,entry,vehicles,bureau,maximum,billion,trees,intelligence,greatest,screen,refers,commissioned,gallery,injury,confirmed,setting,treaty,adult,americans,broadcasting,supporting,pilot,mobile,writers,programming,existence,squad,minnesota,copies,korean,provincial,sets,defence,offices,agricultural,internal,core,northeast,retirement,factory,actions,prevent,communications,ending,weekly,containing,functions,attempted,interior,weight,bowl,recognition,incorporated,increasing,ultimately,documentary,derived,attacked,lyrics,mexican,external,churches,centuries,metropolitan,selling,opposed,personnel,mill,visited,presidential,roads,pieces,norwegian,controlled,18th,rear,influenced,wrestling,weapons,launch,composer,locations,developing,circuit,specifically,studios,shared,canal,wisconsin,publishing,approved,domestic,consisted,determined,comic,establishment,exhibition,southwest,fuel,electronic,cape,converted,educated,melbourne,hits,wins,producing,norway,slightly,occur,surname,identity,represent,constituency,funds,proved,links,structures,athletic,birds,contest,users,poet,institution,display,receiving,rare,contained,guns,motion,piano,temperature,publications,passenger,contributed,toward,cathedral,inhabitants,architect,exist,athletics,muslim,courses,abandoned,signal,successfully,disambiguation,tennessee,dynasty,heavily,maryland,jews,representing,budget,weather,missouri,introduction,faced,pair,chapel,reform,height,vietnam,occurs,motor,cambridge,lands,focused,sought,patients,shape,invasion,chemical,importance,communication,selection,regarding,homes,voivodeship,maintained,borough,failure,aged,passing,agriculture,oregon,teachers,flow,philippines,trail,seventh,portuguese,resistance,reaching,negative,fashion,scheduled,downtown,universities,trained,skills,scenes,views,notably,typical,incident,candidates,engines,decades,composition,commune,chain,inc.,austria,sale,values,employees,chamber,regarded,winners,registered,task,investment,colonial,swiss,user,entirely,flag,stores,closely,entrance,laid,journalist,coal,equal,causes,turkish,quebec,techniques,promote,junction,easily,dates,kentucky,singapore,residence,violence,advance,survey,humans,expressed,passes,streets,distinguished,qualified,folk,establish,egypt,artillery,visual,improved,actual,finishing,medium,protein,switzerland,productions,operate,poverty,neighborhood,organisation,consisting,consecutive,sections,partnership,extension,reaction,factor,costs,bodies,device,ethnic,racial,flat,objects,chapter,improve,musicians,courts,controversy,membership,merged,wars,expedition,interests,arab,comics,gain,describes,mining,bachelor,crisis,joining,decade,1930s,distributed,habitat,routes,arena,cycle,divisions,briefly,vocals,directors,degrees,object,recordings,installed,adjacent,demand,voted,causing,businesses,ruled,grounds,starred,drawn,opposite,stands,formal,operates,persons,counties,compete,wave,israeli,ncaa,resigned,brief,greece,combination,demographics,historian,contain,commonwealth,musician,collected,argued,louisiana,session,cabinet,parliamentary,electoral,loan,profit,regularly,conservation,islamic,purchase,17th,charts,residential,earliest,designs,paintings,survived,moth,items,goods,grey,anniversary,criticism,images,discovery,observed,underground,progress,additionally,participate,thousands,reduce,elementary,owners,stating,iraq,resolution,capture,tank,rooms,hollywood,finance,queensland,reign,maintain,iowa,landing,broad,outstanding,circle,path,manufacturing,assistance,sequence,gmina,crossing,leads,universal,shaped,kings,attached,medieval,ages,metro,colony,affected,scholars,oklahoma,coastal,soundtrack,painted,attend,definition,meanwhile,purposes,trophy,require,marketing,popularity,cable,mathematics,mississippi,represents,scheme,appeal,distinct,factors,acid,subjects,roughly,terminal,economics,senator,diocese,prix,contrast,argentina,czech,wings,relief,stages,duties,16th,novels,accused,whilst,equivalent,charged,measure,documents,couples,request,danish,defensive,guide,devices,statistics,credited,tries,passengers,allied,frame,puerto,peninsula,concluded,instruments,wounded,differences,associate,forests,afterwards,replace,requirements,aviation,solution,offensive,ownership,inner,legislation,hungarian,contributions,actors,translated,denmark,steam,depending,aspects,assumed,injured,severe,admitted,determine,shore,technique,arrival,measures,translation,debuted,delivered,returns,rejected,separated,visitors,damaged,storage,accompanied,markets,industries,losses,gulf,charter,strategy,corporate,socialist,somewhat,significantly,physics,mounted,satellite,experienced,constant,relative,pattern,restored,belgium,connecticut,partners,harvard,retained,networks,protected,mode,artistic,parallel,collaboration,debate,involving,journey,linked,salt,authors,components,context,occupation,requires,occasionally,policies,tamil,ottoman,revolutionary,hungary,poem,versus,gardens,amongst,audio,makeup,frequency,meters,orthodox,continuing,suggests,legislature,coalition,guitarist,eighth,classification,practices,soil,tokyo,instance,limit,coverage,considerable,ranking,colleges,cavalry,centers,daughters,twin,equipped,broadway,narrow,hosts,rates,domain,boundary,arranged,12th,whereas,brazilian,forming,rating,strategic,competitions,trading,covering,baltimore,commissioner,infrastructure,origins,replacement,praised,disc,collections,expression,ukraine,driven,edited,austrian,solar,ensure,premiered,successor,wooden,operational,hispanic,concerns,rapid,prisoners,childhood,meets,influential,tunnel,employment,tribe,qualifying,adapted,temporary,celebrated,appearing,increasingly,depression,adults,cinema,entering,laboratory,script,flows,romania,accounts,fictional,pittsburgh,achieve,monastery,franchise,formally,tools,newspapers,revival,sponsored,processes,vienna,springs,missions,classified,13th,annually,branches,lakes,gender,manner,advertising,normally,maintenance,adding,characteristics,integrated,decline,modified,strongly,critic,victims,malaysia,arkansas,nazi,restoration,powered,monument,hundreds,depth,15th,controversial,admiral,criticized,brick,honorary,initiative,output,visiting,birmingham,progressive,existed,carbon,1920s,credits,colour,rising,hence,defeating,superior,filmed,listing,column,surrounded,orleans,principles,territories,struck,participation,indonesia,movements,index,commerce,conduct,constitutional,spiritual,ambassador,vocal,completion,edinburgh,residing,tourism,finland,bears,medals,resident,themes,visible,indigenous,involvement,basin,electrical,ukrainian,concerts,boats,styles,processing,rival,drawing,vessels,experimental,declined,touring,supporters,compilation,coaching,cited,dated,roots,string,explained,transit,traditionally,poems,minimum,representation,14th,releases,effectively,architectural,triple,indicated,greatly,elevation,clinical,printed,10th,proposal,peaked,producers,romanized,rapidly,stream,innings,meetings,counter,householder,honour,lasted,agencies,document,exists,surviving,experiences,honors,landscape,hurricane,harbor,panel,competing,profile,vessel,farmers,lists,revenue,exception,customers,11th,participants,wildlife,utah,bible,gradually,preserved,replacing,symphony,begun,longest,siege,provinces,mechanical,genre,transmission,agents,executed,videos,benefits,funded,rated,instrumental,ninth,similarly,dominated,destruction,passage,technologies,thereafter,outer,facing,affiliated,opportunities,instrument,governments,scholar,evolution,channels,shares,sessions,widespread,occasions,engineers,scientists,signing,battery,competitive,alleged,eliminated,supplies,judges,hampshire,regime,portrayed,penalty,taiwan,denied,submarine,scholarship,substantial,transition,victorian,http,nevertheless,filed,supports,continental,tribes,ratio,doubles,useful,honours,blocks,principle,retail,departure,ranks,patrol,yorkshire,vancouver,inter,extent,afghanistan,strip,railways,component,organ,symbol,categories,encouraged,abroad,civilian,periods,traveled,writes,struggle,immediate,recommended,adaptation,egyptian,graduating,assault,drums,nomination,historically,voting,allies,detailed,achievement,percentage,arabic,assist,frequent,toured,apply,and/or,intersection,maine,touchdown,throne,produces,contribution,emerged,obtain,archbishop,seek,researchers,remainder,populations,clan,finnish,overseas,fifa,licensed,chemistry,festivals,mediterranean,injuries,animated,seeking,publisher,volumes,limits,venue,jerusalem,generated,trials,islam,youngest,ruling,glasgow,germans,songwriter,persian,municipalities,donated,viewed,belgian,cooperation,posted,tech,dual,volunteer,settlers,commanded,claiming,approval,delhi,usage,terminus,partly,electricity,locally,editions,premiere,absence,belief,traditions,statue,indicate,manor,stable,attributed,possession,managing,viewers,chile,overview,seed,regulations,essential,minority,cargo,segment,endemic,forum,deaths,monthly,playoffs,erected,practical,machines,suburb,relation,mrs.,descent,indoor,continuous,characterized,solutions,caribbean,rebuilt,serbian,summary,contested,psychology,pitch,attending,muhammad,tenure,drivers,diameter,assets,venture,punk,airlines,concentration,athletes,volunteers,pages,mines,influences,sculpture,protest,ferry,behalf,drafted,apparent,furthermore,ranging,romanian,democracy,lanka,significance,linear,d.c.,certified,voters,recovered,tours,demolished,boundaries,assisted,identify,grades,elsewhere,mechanism,1940s,reportedly,aimed,conversion,suspended,photography,departments,beijing,locomotives,publicly,dispute,magazines,resort,conventional,platforms,internationally,capita,settlements,dramatic,derby,establishing,involves,statistical,implementation,immigrants,exposed,diverse,layer,vast,ceased,connections,belonged,interstate,uefa,organised,abuse,deployed,cattle,partially,filming,mainstream,reduction,automatic,rarely,subsidiary,decides,merger,comprehensive,displayed,amendment,guinea,exclusively,manhattan,concerning,commons,radical,serbia,baptist,buses,initiated,portrait,harbour,choir,citizen,sole,unsuccessful,manufactured,enforcement,connecting,increases,patterns,sacred,muslims,clothing,hindu,unincorporated,sentenced,advisory,tanks,campaigns,fled,repeated,remote,rebellion,implemented,texts,fitted,tribute,writings,sufficient,ministers,21st,devoted,jurisdiction,coaches,interpretation,pole,businessman,peru,sporting,prices,cuba,relocated,opponent,arrangement,elite,manufacturer,responded,suitable,distinction,calendar,dominant,tourist,earning,prefecture,ties,preparation,anglo,pursue,worship,archaeological,chancellor,bangladesh,scores,traded,lowest,horror,outdoor,biology,commented,specialized,loop,arriving,farming,housed,historians,'the,patent,pupils,christianity,opponents,athens,northwestern,maps,promoting,reveals,flights,exclusive,lions,norfolk,hebrew,extensively,eldest,shops,acquisition,virtual,renowned,margin,ongoing,essentially,iranian,alternate,sailed,reporting,conclusion,originated,temperatures,exposure,secured,landed,rifle,framework,identical,martial,focuses,topics,ballet,fighters,belonging,wealthy,negotiations,evolved,bases,oriented,acres,democrat,heights,restricted,vary,graduation,aftermath,chess,illness,participating,vertical,collective,immigration,demonstrated,leaf,completing,organic,missile,leeds,eligible,grammar,confederate,improvement,congressional,wealth,cincinnati,spaces,indicates,corresponding,reaches,repair,isolated,taxes,congregation,ratings,leagues,diplomatic,submitted,winds,awareness,photographs,maritime,nigeria,accessible,animation,restaurants,philippine,inaugural,dismissed,armenian,illustrated,reservoir,speakers,programmes,resource,genetic,interviews,camps,regulation,computers,preferred,travelled,comparison,distinctive,recreation,requested,southeastern,dependent,brisbane,breeding,playoff,expand,bonus,gauge,departed,qualification,inspiration,shipping,slaves,variations,shield,theories,munich,recognised,emphasis,favour,variable,seeds,undergraduate,territorial,intellectual,qualify,mini,banned,pointed,democrats,assessment,judicial,examination,attempting,objective,partial,characteristic,hardware,pradesh,execution,ottawa,metre,drum,exhibitions,withdrew,attendance,phrase,journalism,logo,measured,error,christians,trio,protestant,theology,respective,atmosphere,buddhist,substitute,curriculum,fundamental,outbreak,rabbi,intermediate,designation,globe,liberation,simultaneously,diseases,experiments,locomotive,difficulties,mainland,nepal,relegated,contributing,database,developments,veteran,carries,ranges,instruction,lodge,protests,obama,newcastle,experiment,physician,describing,challenges,corruption,delaware,adventures,ensemble,succession,renaissance,tenth,altitude,receives,approached,crosses,syria,croatia,warsaw,professionals,improvements,worn,airline,compound,permitted,preservation,reducing,printing,scientist,activist,comprises,sized,societies,enters,ruler,gospel,earthquake,extend,autonomous,croatian,serial,decorated,relevant,ideal,grows,grass,tier,towers,wider,welfare,columns,alumni,descendants,interface,reserves,banking,colonies,manufacturers,magnetic,closure,pitched,vocalist,preserve,enrolled,cancelled,equation,2000s,nickname,bulgaria,heroes,exile,mathematical,demands,input,structural,tube,stem,approaches,argentine,axis,manuscript,inherited,depicted,targets,visits,veterans,regard,removal,efficiency,organisations,concepts,lebanon,manga,petersburg,rally,supplied,amounts,yale,tournaments,broadcasts,signals,pilots,azerbaijan,architects,enzyme,literacy,declaration,placing,batting,incumbent,bulgarian,consistent,poll,defended,landmark,southwestern,raid,resignation,travels,casualties,prestigious,namely,aims,recipient,warfare,readers,collapse,coached,controls,volleyball,coup,lesser,verse,pairs,exhibited,proteins,molecular,abilities,integration,consist,aspect,advocate,administered,governing,hospitals,commenced,coins,lords,variation,resumed,canton,artificial,elevated,palm,difficulty,civic,efficient,northeastern,inducted,radiation,affiliate,boards,stakes,byzantine,consumption,freight,interaction,oblast,numbered,seminary,contracts,extinct,predecessor,bearing,cultures,functional,neighboring,revised,cylinder,grants,narrative,reforms,athlete,tales,reflect,presidency,compositions,specialist,cricketer,founders,sequel,widow,disbanded,associations,backed,thereby,pitcher,commanding,boulevard,singers,crops,militia,reviewed,centres,waves,consequently,fortress,tributary,portions,bombing,excellence,nest,payment,mars,plaza,unity,victories,scotia,farms,nominations,variant,attacking,suspension,installation,graphics,estates,comments,acoustic,destination,venues,surrender,retreat,libraries,quarterback,customs,berkeley,collaborated,gathered,syndrome,dialogue,recruited,shanghai,neighbouring,psychological,saudi,moderate,exhibit,innovation,depot,binding,brunswick,situations,certificate,actively,shakespeare,editorial,presentation,ports,relay,nationalist,methodist,archives,experts,maintains,collegiate,bishops,maintaining,temporarily,embassy,essex,wellington,connects,reformed,bengal,recalled,inches,doctrine,deemed,legendary,reconstruction,statements,palestinian,meter,achievements,riders,interchange,spots,auto,accurate,chorus,dissolved,missionary,thai,operators,e.g.,generations,failing,delayed,cork,nashville,perceived,venezuela,cult,emerging,tomb,abolished,documented,gaining,canyon,episcopal,stored,assists,compiled,kerala,kilometers,mosque,grammy,theorem,unions,segments,glacier,arrives,theatrical,circulation,conferences,chapters,displays,circular,authored,conductor,fewer,dimensional,nationwide,liga,yugoslavia,peer,vietnamese,fellowship,armies,regardless,relating,dynamic,politicians,mixture,serie,somerset,imprisoned,posts,beliefs,beta,layout,independently,electronics,provisions,fastest,logic,headquartered,creates,challenged,beaten,appeals,plains,protocol,graphic,accommodate,iraqi,midfielder,span,commentary,freestyle,reflected,palestine,lighting,burial,virtually,backing,prague,tribal,heir,identification,prototype,criteria,dame,arch,tissue,footage,extending,procedures,predominantly,updated,rhythm,preliminary,cafe,disorder,prevented,suburbs,discontinued,retiring,oral,followers,extends,massacre,journalists,conquest,larvae,pronounced,behaviour,diversity,sustained,addressed,geographic,restrictions,voiced,milwaukee,dialect,quoted,grid,nationally,nearest,roster,twentieth,separation,indies,manages,citing,intervention,guidance,severely,migration,artwork,focusing,rivals,trustees,varied,enabled,committees,centered,skating,slavery,cardinals,forcing,tasks,auckland,youtube,argues,colored,advisor,mumbai,requiring,theological,registration,refugees,nineteenth,survivors,runners,colleagues,priests,contribute,variants,workshop,concentrated,creator,lectures,temples,exploration,requirement,interactive,navigation,companion,perth,allegedly,releasing,citizenship,observation,stationed,ph.d.,sheep,breed,discovers,encourage,kilometres,journals,performers,isle,saskatchewan,hybrid,hotels,lancashire,dubbed,airfield,anchor,suburban,theoretical,sussex,anglican,stockholm,permanently,upcoming,privately,receiver,optical,highways,congo,colours,aggregate,authorized,repeatedly,varies,fluid,innovative,transformed,praise,convoy,demanded,discography,attraction,export,audiences,ordained,enlisted,occasional,westminster,syrian,heavyweight,bosnia,consultant,eventual,improving,aires,wickets,epic,reactions,scandal,i.e.,discrimination,buenos,patron,investors,conjunction,testament,construct,encountered,celebrity,expanding,georgian,brands,retain,underwent,algorithm,foods,provision,orbit,transformation,associates,tactical,compact,varieties,stability,refuge,gathering,moreover,manila,configuration,gameplay,discipline,entity,comprising,composers,skill,monitoring,ruins,museums,sustainable,aerial,altered,codes,voyage,friedrich,conflicts,storyline,travelling,conducting,merit,indicating,referendum,currency,encounter,particles,automobile,workshops,acclaimed,inhabited,doctorate,cuban,phenomenon,dome,enrollment,tobacco,governance,trend,equally,manufacture,hydrogen,grande,compensation,download,pianist,grain,shifted,neutral,evaluation,define,cycling,seized,array,relatives,motors,firms,varying,automatically,restore,nicknamed,findings,governed,investigate,manitoba,administrator,vital,integral,indonesian,confusion,publishers,enable,geographical,inland,naming,civilians,reconnaissance,indianapolis,lecturer,deer,tourists,exterior,rhode,bassist,symbols,scope,ammunition,yuan,poets,punjab,nursing,cent,developers,estimates,presbyterian,nasa,holdings,generate,renewed,computing,cyprus,arabia,duration,compounds,gastropod,permit,valid,touchdowns,facade,interactions,mineral,practiced,allegations,consequence,goalkeeper,baronet,copyright,uprising,carved,targeted,competitors,mentions,sanctuary,fees,pursued,tampa,chronicle,capabilities,specified,specimens,toll,accounting,limestone,staged,upgraded,philosophical,streams,guild,revolt,rainfall,supporter,princeton,terrain,hometown,probability,assembled,paulo,surrey,voltage,developer,destroyer,floors,lineup,curve,prevention,potentially,onwards,trips,imposed,hosting,striking,strict,admission,apartments,solely,utility,proceeded,observations,euro,incidents,vinyl,profession,haven,distant,expelled,rivalry,runway,torpedo,zones,shrine,dimensions,investigations,lithuania,idaho,pursuit,copenhagen,considerably,locality,wireless,decrease,genes,thermal,deposits,hindi,habitats,withdrawn,biblical,monuments,casting,plateau,thesis,managers,flooding,assassination,acknowledged,interim,inscription,guided,pastor,finale,insects,transported,activists,marshal,intensity,airing,cardiff,proposals,lifestyle,prey,herald,capitol,aboriginal,measuring,lasting,interpreted,occurring,desired,drawings,healthcare,panels,elimination,oslo,ghana,blog,sabha,intent,superintendent,governors,bankruptcy,p.m.,equity,disk,layers,slovenia,prussia,quartet,mechanics,graduates,politically,monks,screenplay,nato,absorbed,topped,petition,bold,morocco,exhibits,canterbury,publish,rankings,crater,dominican,enhanced,planes,lutheran,governmental,joins,collecting,brussels,unified,streak,strategies,flagship,surfaces,oval,archive,etymology,imprisonment,instructor,noting,remix,opposing,servant,rotation,width,trans,maker,synthesis,excess,tactics,snail,ltd.,lighthouse,sequences,cornwall,plantation,mythology,performs,foundations,populated,horizontal,speedway,activated,performer,diving,conceived,edmonton,subtropical,environments,prompted,semifinals,caps,bulk,treasury,recreational,telegraph,continent,portraits,relegation,catholics,graph,velocity,rulers,endangered,secular,observer,learns,inquiry,idol,dictionary,certification,estimate,cluster,armenia,observatory,revived,nadu,consumers,hypothesis,manuscripts,contents,arguments,editing,trails,arctic,essays,belfast,acquire,promotional,undertaken,corridor,proceedings,antarctic,millennium,labels,delegates,vegetation,acclaim,directing,substance,outcome,diploma,philosopher,malta,albanian,vicinity,degc,legends,regiments,consent,terrorist,scattered,presidents,gravity,orientation,deployment,duchy,refuses,estonia,crowned,separately,renovation,rises,wilderness,objectives,agreements,empress,slopes,inclusion,equality,decree,ballot,criticised,rochester,recurring,struggled,disabled,henri,poles,prussian,convert,bacteria,poorly,sudan,geological,wyoming,consistently,minimal,withdrawal,interviewed,proximity,repairs,initiatives,pakistani,republicans,propaganda,viii,abstract,commercially,availability,mechanisms,naples,discussions,underlying,lens,proclaimed,advised,spelling,auxiliary,attract,lithuanian,editors,o'brien,accordance,measurement,novelist,ussr,formats,councils,contestants,indie,facebook,parishes,barrier,battalions,sponsor,consulting,terrorism,implement,uganda,crucial,unclear,notion,distinguish,collector,attractions,filipino,ecology,investments,capability,renovated,iceland,albania,accredited,scouts,armor,sculptor,cognitive,errors,gaming,condemned,successive,consolidated,baroque,entries,regulatory,reserved,treasurer,variables,arose,technological,rounded,provider,rhine,agrees,accuracy,genera,decreased,frankfurt,ecuador,edges,particle,rendered,calculated,careers,faction,rifles,americas,gaelic,portsmouth,resides,merchants,fiscal,premises,coin,draws,presenter,acceptance,ceremonies,pollution,consensus,membrane,brigadier,nonetheless,genres,supervision,predicted,magnitude,finite,differ,ancestry,vale,delegation,removing,proceeds,placement,emigrated,siblings,molecules,payments,considers,demonstration,proportion,newer,valve,achieving,confederation,continuously,luxury,notre,introducing,coordinates,charitable,squadrons,disorders,geometry,winnipeg,ulster,loans,longtime,receptor,preceding,belgrade,mandate,wrestler,neighbourhood,factories,buddhism,imported,sectors,protagonist,steep,elaborate,prohibited,artifacts,prizes,pupil,cooperative,sovereign,subspecies,carriers,allmusic,nationals,settings,autobiography,neighborhoods,analog,facilitate,voluntary,jointly,newfoundland,organizing,raids,exercises,nobel,machinery,baltic,crop,granite,dense,websites,mandatory,seeks,surrendered,anthology,comedian,bombs,slot,synopsis,critically,arcade,marking,equations,halls,indo,inaugurated,embarked,speeds,clause,invention,premiership,likewise,presenting,demonstrate,designers,organize,examined,km/h,bavaria,troop,referee,detection,zurich,prairie,rapper,wingspan,eurovision,luxembourg,slovakia,inception,disputed,mammals,entrepreneur,makers,evangelical,yield,clergy,trademark,defunct,allocated,depicting,volcanic,batted,conquered,sculptures,providers,reflects,armoured,locals,walt,herzegovina,contracted,entities,sponsorship,prominence,flowing,ethiopia,marketed,corporations,withdraw,carnegie,induced,investigated,portfolio,flowering,opinions,viewing,classroom,donations,bounded,perception,leicester,fruits,charleston,academics,statute,complaints,smallest,deceased,petroleum,resolved,commanders,algebra,southampton,modes,cultivation,transmitter,spelled,obtaining,sizes,acre,pageant,bats,abbreviated,correspondence,barracks,feast,tackles,raja,derives,geology,disputes,translations,counted,constantinople,seating,macedonia,preventing,accommodation,homeland,explored,invaded,provisional,transform,sphere,unsuccessfully,missionaries,conservatives,highlights,traces,organisms,openly,dancers,fossils,absent,monarchy,combining,lanes,stint,dynamics,chains,missiles,screening,module,tribune,generating,miners,nottingham,seoul,unofficial,owing,linking,rehabilitation,citation,louisville,mollusk,depicts,differential,zimbabwe,kosovo,recommendations,responses,pottery,scorer,aided,exceptions,dialects,telecommunications,defines,elderly,lunar,coupled,flown,25th,espn,formula_1,bordered,fragments,guidelines,gymnasium,valued,complexity,papal,presumably,maternal,challenging,reunited,advancing,comprised,uncertain,favorable,twelfth,correspondent,nobility,livestock,expressway,chilean,tide,researcher,emissions,profits,lengths,accompanying,witnessed,itunes,drainage,slope,reinforced,feminist,sanskrit,develops,physicians,outlets,isbn,coordinator,averaged,termed,occupy,diagnosed,yearly,humanitarian,prospect,spacecraft,stems,enacted,linux,ancestors,karnataka,constitute,immigrant,thriller,ecclesiastical,generals,celebrations,enhance,heating,advocated,evident,advances,bombardment,watershed,shuttle,wicket,twitter,adds,branded,teaches,schemes,pension,advocacy,conservatory,cairo,varsity,freshwater,providence,seemingly,shells,cuisine,specially,peaks,intensive,publishes,trilogy,skilled,nacional,unemployment,destinations,parameters,verses,trafficking,determination,infinite,savings,alignment,linguistic,countryside,dissolution,measurements,advantages,licence,subfamily,highlands,modest,regent,algeria,crest,teachings,knockout,brewery,combine,conventions,descended,chassis,primitive,fiji,explicitly,cumberland,uruguay,laboratories,bypass,elect,informal,preceded,holocaust,tackle,minneapolis,quantity,securities,console,doctoral,religions,commissioners,expertise,unveiled,precise,diplomat,standings,infant,disciplines,sicily,endorsed,systematic,charted,armored,mild,lateral,townships,hurling,prolific,invested,wartime,compatible,galleries,moist,battlefield,decoration,convent,tubes,terrestrial,nominee,requests,delegate,leased,dubai,polar,applying,addresses,munster,sings,commercials,teamed,dances,eleventh,midland,cedar,flee,sandstone,snails,inspection,divide,asset,themed,comparable,paramount,dairy,archaeology,intact,institutes,rectangular,instances,phases,reflecting,substantially,applies,vacant,lacked,copa,coloured,encounters,sponsors,encoded,possess,revenues,ucla,chaired,a.m.,enabling,playwright,stoke,sociology,tibetan,frames,motto,financing,illustrations,gibraltar,chateau,bolivia,transmitted,enclosed,persuaded,urged,folded,suffolk,regulated,bros.,submarines,myth,oriental,malaysian,effectiveness,narrowly,acute,sunk,replied,utilized,tasmania,consortium,quantities,gains,parkway,enlarged,sided,employers,adequate,accordingly,assumption,ballad,mascot,distances,peaking,saxony,projected,affiliation,limitations,metals,guatemala,scots,theaters,kindergarten,verb,employer,differs,discharge,controller,seasonal,marching,guru,campuses,avoided,vatican,maori,excessive,chartered,modifications,caves,monetary,sacramento,mixing,institutional,celebrities,irrigation,shapes,broadcaster,anthem,attributes,demolition,offshore,specification,surveys,yugoslav,contributor,auditorium,lebanese,capturing,airports,classrooms,chennai,paths,tendency,determining,lacking,upgrade,sailors,detected,kingdoms,sovereignty,freely,decorative,momentum,scholarly,georges,gandhi,speculation,transactions,undertook,interact,similarities,cove,teammate,constituted,painters,tends,madagascar,partnerships,afghan,personalities,attained,rebounds,masses,synagogue,reopened,asylum,embedded,imaging,catalogue,defenders,taxonomy,fiber,afterward,appealed,communists,lisbon,rica,judaism,adviser,batsman,ecological,commands,lgbt,cooling,accessed,wards,shiva,employs,thirds,scenic,worcester,tallest,contestant,humanities,economist,textile,constituencies,motorway,tram,percussion,cloth,leisure,1880s,baden,flags,resemble,riots,coined,sitcom,composite,implies,daytime,tanzania,penalties,optional,competitor,excluded,steering,reversed,autonomy,reviewer,breakthrough,professionally,damages,pomeranian,deputies,valleys,ventures,highlighted,electorate,mapping,shortened,executives,tertiary,specimen,launching,bibliography,sank,pursuing,binary,descendant,marched,natives,ideology,turks,adolf,archdiocese,tribunal,exceptional,nigerian,preference,fails,loading,comeback,vacuum,favored,alter,remnants,consecrated,spectators,trends,patriarch,feedback,paved,sentences,councillor,astronomy,advocates,broader,commentator,commissions,identifying,revealing,theatres,incomplete,enables,constituent,reformation,tract,haiti,atmospheric,screened,explosive,czechoslovakia,acids,symbolic,subdivision,liberals,incorporate,challenger,erie,filmmaker,laps,kazakhstan,organizational,evolutionary,chemicals,dedication,riverside,fauna,moths,maharashtra,annexed,gen.,resembles,underwater,garnered,timeline,remake,suited,educator,hectares,automotive,feared,latvia,finalist,narrator,portable,airways,plaque,designing,villagers,licensing,flank,statues,struggles,deutsche,migrated,cellular,jacksonville,wimbledon,defining,highlight,preparatory,planets,cologne,employ,frequencies,detachment,readily,libya,resign,halt,helicopters,reef,landmarks,collaborative,irregular,retaining,helsinki,folklore,weakened,viscount,interred,professors,memorable,mega,repertoire,rowing,dorsal,albeit,progressed,operative,coronation,liner,telugu,domains,philharmonic,detect,bengali,synthetic,tensions,atlas,dramatically,paralympics,xbox,shire,kiev,lengthy,sued,notorious,seas,screenwriter,transfers,aquatic,pioneers,unesco,radius,abundant,tunnels,syndicated,inventor,accreditation,janeiro,exeter,ceremonial,omaha,cadet,predators,resided,prose,slavic,precision,abbot,deity,engaging,cambodia,estonian,compliance,demonstrations,protesters,reactor,commodore,successes,chronicles,mare,extant,listings,minerals,tonnes,parody,cultivated,traders,pioneering,supplement,slovak,preparations,collision,partnered,vocational,atoms,malayalam,welcomed,documentation,curved,functioning,presently,formations,incorporates,nazis,botanical,nucleus,ethical,greeks,metric,automated,whereby,stance,europeans,duet,disability,purchasing,email,telescope,displaced,sodium,comparative,processor,inning,precipitation,aesthetic,import,coordination,feud,alternatively,mobility,tibet,regained,succeeding,hierarchy,apostolic,catalog,reproduction,inscriptions,vicar,clusters,posthumously,rican,loosely,additions,photographic,nowadays,selective,derivative,keyboards,guides,collectively,affecting,combines,operas,networking,decisive,terminated,continuity,finishes,ancestor,consul,heated,simulation,leipzig,incorporating,georgetown,formula_2,circa,forestry,portrayal,councillors,advancement,complained,forewings,confined,transaction,definitions,reduces,televised,1890s,rapids,phenomena,belarus,alps,landscapes,quarterly,specifications,commemorate,continuation,isolation,antenna,downstream,patents,ensuing,tended,saga,lifelong,columnist,labeled,gymnastics,papua,anticipated,demise,encompasses,madras,antarctica,interval,icon,rams,midlands,ingredients,priory,strengthen,rouge,explicit,gaza,aging,securing,anthropology,listeners,adaptations,underway,vista,malay,fortified,lightweight,violations,concerto,financed,jesuit,observers,trustee,descriptions,nordic,resistant,opted,accepts,prohibition,andhra,inflation,negro,wholly,imagery,spur,instructed,gloucester,cycles,middlesex,destroyers,statewide,evacuated,hyderabad,peasants,mice,shipyard,coordinate,pitching,colombian,exploring,numbering,compression,countess,hiatus,exceed,raced,archipelago,traits,soils,o'connor,vowel,android,facto,angola,amino,holders,logistics,circuits,emergence,kuwait,partition,emeritus,outcomes,submission,promotes,barack,negotiated,loaned,stripped,50th,excavations,treatments,fierce,participant,exports,decommissioned,cameo,remarked,residences,fuselage,mound,undergo,quarry,node,midwest,specializing,occupies,etc.,showcase,molecule,offs,modules,salon,exposition,revision,peers,positioned,hunters,competes,algorithms,reside,zagreb,calcium,uranium,silicon,airs,counterpart,outlet,collectors,sufficiently,canberra,inmates,anatomy,ensuring,curves,aviv,firearms,basque,volcano,thrust,sheikh,extensions,installations,aluminum,darker,sacked,emphasized,aligned,asserted,pseudonym,spanning,decorations,eighteenth,orbital,spatial,subdivided,notation,decay,macedonian,amended,declining,cyclist,feat,unusually,commuter,birthplace,latitude,activation,overhead,30th,finalists,whites,encyclopedia,tenor,qatar,survives,complement,concentrations,uncommon,astronomical,bangalore,pius,genome,memoir,recruit,prosecutor,modification,paired,container,basilica,arlington,displacement,germanic,mongolia,proportional,debates,matched,calcutta,rows,tehran,aerospace,prevalent,arise,lowland,24th,spokesman,supervised,advertisements,clash,tunes,revelation,wanderers,quarterfinals,fisheries,steadily,memoirs,pastoral,renewable,confluence,acquiring,strips,slogan,upstream,scouting,analyst,practitioners,turbine,strengthened,heavier,prehistoric,plural,excluding,isles,persecution,turin,rotating,villain,hemisphere,unaware,arabs,corpus,relied,singular,unanimous,schooling,passive,angles,dominance,instituted,aria,outskirts,balanced,beginnings,financially,structured,parachute,viewer,attitudes,subjected,escapes,derbyshire,erosion,addressing,styled,declaring,originating,colts,adjusted,stained,occurrence,fortifications,baghdad,nitrogen,localities,yemen,galway,debris,lodz,victorious,pharmaceutical,substances,unnamed,dwelling,atop,developmental,activism,voter,refugee,forested,relates,overlooking,genocide,kannada,insufficient,oversaw,partisan,dioxide,recipients,factions,mortality,capped,expeditions,receptors,reorganized,prominently,atom,flooded,flute,orchestral,scripts,mathematician,airplay,detached,rebuilding,dwarf,brotherhood,salvation,expressions,arabian,cameroon,poetic,recruiting,bundesliga,inserted,scrapped,disabilities,evacuation,pasha,undefeated,crafts,rituals,aluminium,norm,pools,submerged,occupying,pathway,exams,prosperity,wrestlers,promotions,basal,permits,nationalism,trim,merge,gazette,tributaries,transcription,caste,porto,emerge,modeled,adjoining,counterparts,paraguay,redevelopment,renewal,unreleased,equilibrium,similarity,minorities,soviets,comprise,nodes,tasked,unrelated,expired,johan,precursor,examinations,electrons,socialism,exiled,admiralty,floods,wigan,nonprofit,lacks,brigades,screens,repaired,hanover,fascist,labs,osaka,delays,judged,statutory,colt,col.,offspring,solving,bred,assisting,retains,somalia,grouped,corresponds,tunisia,chaplain,eminent,chord,22nd,spans,viral,innovations,possessions,mikhail,kolkata,icelandic,implications,introduces,racism,workforce,alto,compulsory,admits,censorship,onset,reluctant,inferior,iconic,progression,liability,turnout,satellites,behavioral,coordinated,exploitation,posterior,averaging,fringe,krakow,mountainous,greenwich,para,plantations,reinforcements,offerings,famed,intervals,constraints,individually,nutrition,1870s,taxation,threshold,tomatoes,fungi,contractor,ethiopian,apprentice,diabetes,wool,gujarat,honduras,norse,bucharest,23rd,arguably,accompany,prone,teammates,perennial,vacancy,polytechnic,deficit,okinawa,functionality,reminiscent,tolerance,transferring,myanmar,concludes,neighbours,hydraulic,economically,slower,plots,charities,synod,investor,catholicism,identifies,bronx,interpretations,adverse,judiciary,hereditary,nominal,sensor,symmetry,cubic,triangular,tenants,divisional,outreach,representations,passages,undergoing,cartridge,testified,exceeded,impacts,limiting,railroads,defeats,regain,rendering,humid,retreated,reliability,governorate,antwerp,infamous,implied,packaging,lahore,trades,billed,extinction,ecole,rejoined,recognizes,projection,qualifications,stripes,forts,socially,lexington,accurately,sexuality,westward,wikipedia,pilgrimage,abolition,choral,stuttgart,nests,expressing,strikeouts,assessed,monasteries,reconstructed,humorous,marxist,fertile,consort,urdu,patronage,peruvian,devised,lyric,baba,nassau,communism,extraction,popularly,markings,inability,litigation,accounted,processed,emirates,tempo,cadets,eponymous,contests,broadly,oxide,courtyard,frigate,directory,apex,outline,regency,chiefly,patrols,secretariat,cliffs,residency,privy,armament,australians,dorset,geometric,genetics,scholarships,fundraising,flats,demographic,multimedia,captained,documentaries,updates,canvas,blockade,guerrilla,songwriting,administrators,intake,drought,implementing,fraction,cannes,refusal,inscribed,meditation,announcing,exported,ballots,formula_3,curator,basel,arches,flour,subordinate,confrontation,gravel,simplified,berkshire,patriotic,tuition,employing,servers,castile,posting,combinations,discharged,miniature,mutations,constellation,incarnation,ideals,necessity,granting,ancestral,crowds,pioneered,mormon,methodology,rama,indirect,complexes,bavarian,patrons,uttar,skeleton,bollywood,flemish,viable,bloc,breeds,triggered,sustainability,tailed,referenced,comply,takeover,latvian,homestead,platoon,communal,nationality,excavated,targeting,sundays,posed,physicist,turret,endowment,marginal,dispatched,commentators,renovations,attachment,collaborations,ridges,barriers,obligations,shareholders,prof.,defenses,presided,rite,backgrounds,arbitrary,affordable,gloucestershire,thirteenth,inlet,miniseries,possesses,detained,pressures,subscription,realism,solidarity,proto,postgraduate,noun,burmese,abundance,homage,reasoning,anterior,robust,fencing,shifting,vowels,garde,profitable,loch,anchored,coastline,samoa,terminology,prostitution,magistrate,venezuelan,speculated,regulate,fixture,colonists,digit,induction,manned,expeditionary,computational,centennial,principally,vein,preserving,engineered,numerical,cancellation,conferred,continually,borne,seeded,advertisement,unanimously,treaties,infections,ions,sensors,lowered,amphibious,lava,fourteenth,bahrain,niagara,nicaragua,squares,congregations,26th,periodic,proprietary,1860s,contributors,seller,overs,emission,procession,presumed,illustrator,zinc,gases,tens,applicable,stretches,reproductive,sixteenth,apparatus,accomplishments,canoe,guam,oppose,recruitment,accumulated,limerick,namibia,staging,remixes,ordnance,uncertainty,pedestrian,temperate,treason,deposited,registry,cerambycidae,attracting,lankan,reprinted,shipbuilding,homosexuality,neurons,eliminating,1900s,resume,ministries,beneficial,blackpool,surplus,northampton,licenses,constructing,announcer,standardized,alternatives,taipei,inadequate,failures,yields,medalist,titular,obsolete,torah,burlington,predecessors,lublin,retailers,castles,depiction,issuing,gubernatorial,propulsion,tiles,damascus,discs,alternating,pomerania,peasant,tavern,redesignated,27th,illustration,focal,mans,codex,specialists,productivity,antiquity,controversies,promoter,pits,companions,behaviors,lyrical,prestige,creativity,swansea,dramas,approximate,feudal,tissues,crude,campaigned,unprecedented,chancel,amendments,surroundings,allegiance,exchanges,align,firmly,optimal,commenting,reigning,landings,obscure,1850s,contemporaries,paternal,devi,endurance,communes,incorporation,denominations,exchanged,routing,resorts,amnesty,slender,explores,suppression,heats,pronunciation,centred,coupe,stirling,freelance,treatise,linguistics,laos,informs,discovering,pillars,encourages,halted,robots,definitive,maturity,tuberculosis,venetian,silesian,unchanged,originates,mali,lincolnshire,quotes,seniors,premise,contingent,distribute,danube,gorge,logging,dams,curling,seventeenth,specializes,wetlands,deities,assess,thickness,rigid,culminated,utilities,substrate,insignia,nile,assam,shri,currents,suffrage,canadians,mortar,asteroid,bosnian,discoveries,enzymes,sanctioned,replica,hymn,investigators,tidal,dominate,derivatives,converting,leinster,verbs,honoured,criticisms,dismissal,discrete,masculine,reorganization,unlimited,wurttemberg,sacks,allocation,bahn,jurisdictions,participates,lagoon,famine,communion,culminating,surveyed,shortage,cables,intersects,cassette,foremost,adopting,solicitor,outright,bihar,reissued,farmland,dissertation,turnpike,baton,photographed,christchurch,kyoto,finances,rails,histories,linebacker,kilkenny,accelerated,dispersed,handicap,absorption,rancho,ceramic,captivity,cites,font,weighed,mater,utilize,bravery,extract,validity,slovenian,seminars,discourse,ranged,duel,ironically,warships,sega,temporal,surpassed,prolonged,recruits,northumberland,greenland,contributes,patented,eligibility,unification,discusses,reply,translates,beirut,relies,torque,northward,reviewers,monastic,accession,neural,tramway,heirs,sikh,subscribers,amenities,taliban,audit,rotterdam,wagons,kurdish,favoured,combustion,meanings,persia,browser,diagnostic,niger,formula_4,denomination,dividing,parameter,branding,badminton,leningrad,sparked,hurricanes,beetles,propeller,mozambique,refined,diagram,exhaust,vacated,readings,markers,reconciliation,determines,concurrent,imprint,primera,organism,demonstrating,filmmakers,vanderbilt,affiliates,traction,evaluated,defendants,megachile,investigative,zambia,assassinated,rewarded,probable,staffordshire,foreigners,directorate,nominees,consolidation,commandant,reddish,differing,unrest,drilling,bohemia,resembling,instrumentation,considerations,haute,promptly,variously,dwellings,clans,tablet,enforced,cockpit,semifinal,hussein,prisons,ceylon,emblem,monumental,phrases,correspond,crossover,outlined,characterised,acceleration,caucus,crusade,protested,composing,rajasthan,habsburg,rhythmic,interception,inherent,cooled,ponds,spokesperson,gradual,consultation,kuala,globally,suppressed,builders,avengers,suffix,integer,enforce,fibers,unionist,proclamation,uncovered,infrared,adapt,eisenhower,utilizing,captains,stretched,observing,assumes,prevents,analyses,saxophone,caucasus,notices,villains,dartmouth,mongol,hostilities,stretching,veterinary,lenses,texture,prompting,overthrow,excavation,islanders,masovian,battleship,biographer,replay,degradation,departing,luftwaffe,fleeing,oversight,immigrated,serbs,fishermen,strengthening,respiratory,italians,denotes,radial,escorted,motif,wiltshire,expresses,accessories,reverted,establishments,inequality,protocols,charting,famously,satirical,entirety,trench,friction,atletico,sampling,subset,weekday,upheld,sharply,correlation,incorrect,mughal,travelers,hasan,earnings,offset,evaluate,specialised,recognizing,flexibility,nagar,postseason,algebraic,capitalism,crystals,melodies,polynomial,racecourse,defences,austro,wembley,attracts,anarchist,resurrection,reviewing,decreasing,prefix,ratified,mutation,displaying,separating,restoring,assemblies,ordinance,priesthood,cruisers,appoint,moldova,imports,directive,epidemic,militant,senegal,signaling,restriction,critique,retrospective,nationalists,undertake,sioux,canals,algerian,redesigned,philanthropist,depict,conceptual,turbines,intellectuals,eastward,applicants,contractors,vendors,undergone,namesake,ensured,tones,substituted,hindwings,arrests,tombs,transitional,principality,reelection,taiwanese,cavity,manifesto,broadcasters,spawned,thoroughbred,identities,generators,proposes,hydroelectric,johannesburg,cortex,scandinavian,killings,aggression,boycott,catalyst,physiology,fifteenth,waterfront,chromosome,organist,costly,calculation,cemeteries,flourished,recognise,juniors,merging,disciples,ashore,workplace,enlightenment,diminished,debated,hailed,podium,educate,mandated,distributor,litre,electromagnetic,flotilla,estuary,peterborough,staircase,selections,melodic,confronts,wholesale,integrate,intercepted,catalonia,unite,immense,palatinate,switches,earthquakes,occupational,successors,praising,concluding,faculties,firstly,overhaul,empirical,metacritic,inauguration,evergreen,laden,winged,philosophers,amalgamated,geoff,centimeters,napoleonic,upright,planting,brewing,fined,sensory,migrants,wherein,inactive,headmaster,warwickshire,siberia,terminals,denounced,academia,divinity,bilateral,clive,omitted,peerage,relics,apartheid,syndicate,fearing,fixtures,desirable,dismantled,ethnicity,valves,biodiversity,aquarium,ideological,visibility,creators,analyzed,tenant,balkan,postwar,supplier,smithsonian,risen,morphology,digits,bohemian,wilmington,vishnu,demonstrates,aforementioned,biographical,mapped,khorasan,phosphate,presentations,ecosystem,processors,calculations,mosaic,clashes,penned,recalls,coding,angular,lattice,macau,accountability,extracted,pollen,therapeutic,overlap,violinist,deposed,candidacy,infants,covenant,bacterial,restructuring,dungeons,ordination,conducts,builds,invasive,customary,concurrently,relocation,cello,statutes,borneo,entrepreneurs,sanctions,packet,rockefeller,piedmont,comparisons,waterfall,receptions,glacial,surge,signatures,alterations,advertised,enduring,somali,botanist,100th,canonical,motifs,longitude,circulated,alloy,indirectly,margins,preserves,internally,besieged,shale,peripheral,drained,baseman,reassigned,tobago,soloist,socio,grazing,contexts,roofs,portraying,ottomans,shrewsbury,noteworthy,lamps,supplying,beams,qualifier,portray,greenhouse,stronghold,hitter,rites,cretaceous,urging,derive,nautical,aiming,fortunes,verde,donors,reliance,exceeding,exclusion,exercised,simultaneous,continents,guiding,pillar,gradient,poznan,eruption,clinics,moroccan,indicator,trams,piers,parallels,fragment,teatro,potassium,satire,compressed,businessmen,influx,seine,perspectives,shelters,decreases,mounting,formula_5,confederacy,equestrian,expulsion,mayors,liberia,resisted,affinity,shrub,unexpectedly,stimulus,amtrak,deported,perpendicular,statesman,wharf,storylines,romanesque,weights,surfaced,interceptions,dhaka,crambidae,orchestras,rwanda,conclude,constitutes,subsidiaries,admissions,prospective,shear,bilingual,campaigning,presiding,domination,commemorative,trailing,confiscated,petrol,acquisitions,polymer,onlyinclude,chloride,elevations,resolutions,hurdles,pledged,likelihood,objected,erect,encoding,databases,aristotle,hindus,marshes,bowled,ministerial,grange,acronym,annexation,squads,ambient,pilgrims,botany,sofla,astronomer,planetary,descending,bestowed,ceramics,diplomacy,metabolism,colonization,potomac,africans,engraved,recycling,commitments,resonance,disciplinary,jamaican,narrated,spectral,tipperary,waterford,stationary,arbitration,transparency,threatens,crossroads,slalom,oversee,centenary,incidence,economies,livery,moisture,newsletter,autobiographical,bhutan,propelled,dependence,moderately,adobe,barrels,subdivisions,outlook,labelled,stratford,arising,diaspora,barony,automobiles,ornamental,slated,norms,primetime,generalized,analysts,vectors,libyan,yielded,certificates,rooted,vernacular,belarusian,marketplace,prediction,fairfax,malawi,viruses,wooded,demos,mauritius,prosperous,coincided,liberties,huddersfield,ascent,warnings,hinduism,glucose,pulitzer,unused,filters,illegitimate,acquitted,protestants,canopy,staple,psychedelic,winding,abbas,pathways,cheltenham,lagos,niche,invaders,proponents,barred,conversely,doncaster,recession,embraced,rematch,concession,emigration,upgrades,bowls,tablets,remixed,loops,kensington,shootout,monarchs,organizers,harmful,punjabi,broadband,exempt,neolithic,profiles,portrays,parma,cyrillic,quasi,attested,regimental,revive,torpedoes,heidelberg,rhythms,spherical,denote,hymns,icons,theologian,qaeda,exceptionally,reinstated,comune,playhouse,lobbying,grossing,viceroy,delivers,visually,armistice,utrecht,syllable,vertices,analogous,annex,refurbished,entrants,knighted,disciple,rhetoric,detailing,inactivated,ballads,algae,intensified,favourable,sanitation,receivers,pornography,commemorated,cannons,entrusted,manifold,photographers,pueblo,textiles,steamer,myths,marquess,onward,liturgical,romney,uzbekistan,consistency,denoted,hertfordshire,convex,hearings,sulfur,universidad,podcast,selecting,emperors,arises,justices,1840s,mongolian,exploited,termination,digitally,infectious,sedan,symmetric,penal,illustrate,formulation,attribute,problematic,modular,inverse,berth,searches,rutgers,leicestershire,enthusiasts,lockheed,upwards,transverse,accolades,backward,archaeologists,crusaders,nuremberg,defects,ferries,vogue,containers,openings,transporting,separates,lumpur,purchases,attain,wichita,topology,woodlands,deleted,periodically,syntax,overturned,musicals,corp.,strasbourg,instability,nationale,prevailing,cache,marathi,versailles,unmarried,grains,straits,antagonist,segregation,assistants,d'etat,contention,dictatorship,unpopular,motorcycles,criterion,analytical,salzburg,militants,hanged,worcestershire,emphasize,paralympic,erupted,convinces,offences,oxidation,nouns,populace,atari,spanned,hazardous,educators,playable,births,baha'i,preseason,generates,invites,meteorological,handbook,foothills,enclosure,diffusion,mirza,convergence,geelong,coefficient,connector,formula_6,cylindrical,disasters,pleaded,knoxville,contamination,compose,libertarian,arrondissement,franciscan,intercontinental,susceptible,initiation,malaria,unbeaten,consonants,waived,saloon,popularized,estadio,pseudo,interdisciplinary,transports,transformers,carriages,bombings,revolves,ceded,collaborator,celestial,exemption,colchester,maltese,oceanic,ligue,crete,shareholder,routed,depictions,ridden,advisors,calculate,lending,guangzhou,simplicity,newscast,scheduling,snout,eliot,undertaking,armenians,nottinghamshire,whitish,consulted,deficiency,salle,cinemas,superseded,rigorous,kerman,convened,landowners,modernization,evenings,pitches,conditional,scandinavia,differed,formulated,cyclists,swami,guyana,dunes,electrified,appalachian,abdomen,scenarios,prototypes,sindh,consonant,adaptive,boroughs,wolverhampton,modelling,cylinders,amounted,minimize,ambassadors,lenin,settler,coincide,approximation,grouping,murals,bullying,registers,rumours,engagements,energetic,vertex,annals,bordering,geologic,yellowish,runoff,converts,allegheny,facilitated,saturdays,colliery,monitored,rainforest,interfaces,geographically,impaired,prevalence,joachim,paperback,slowed,shankar,distinguishing,seminal,categorized,authorised,auspices,bandwidth,asserts,rebranded,balkans,supplemented,seldom,weaving,capsule,apostles,populous,monmouth,payload,symphonic,densely,shoreline,managerial,masonry,antioch,averages,textbooks,royalist,coliseum,tandem,brewers,diocesan,posthumous,walled,incorrectly,distributions,ensued,reasonably,graffiti,propagation,automation,harmonic,augmented,middleweight,limbs,elongated,landfall,comparatively,literal,grossed,koppen,wavelength,1830s,cerebral,boasts,congestion,physiological,practitioner,coasts,cartoonist,undisclosed,frontal,launches,burgundy,qualifiers,imposing,stade,flanked,assyrian,raided,multiplayer,montane,chesapeake,pathology,drains,vineyards,intercollegiate,semiconductor,grassland,convey,citations,predominant,rejects,benefited,yahoo,graphs,busiest,encompassing,hamlets,explorers,suppress,minors,graphical,calculus,sediment,intends,diverted,mainline,unopposed,cottages,initiate,alumnus,towed,autism,forums,darlington,modernist,oxfordshire,lectured,capitalist,suppliers,panchayat,actresses,foundry,southbound,commodity,wesleyan,divides,palestinians,luton,caretaker,nobleman,mutiny,organizer,preferences,nomenclature,splits,unwilling,offenders,timor,relying,halftime,semitic,arithmetic,milestone,jesuits,arctiidae,retrieved,consuming,contender,edged,plagued,inclusive,transforming,khmer,federally,insurgents,distributing,amherst,rendition,prosecutors,viaduct,disqualified,kabul,liturgy,prevailed,reelected,instructors,swimmers,aperture,churchyard,interventions,totals,darts,metropolis,fuels,fluent,northbound,correctional,inflicted,barrister,realms,culturally,aristocratic,collaborating,emphasizes,choreographer,inputs,ensembles,humboldt,practised,endowed,strains,infringement,archaeologist,congregational,magna,relativity,efficiently,proliferation,mixtape,abruptly,regeneration,commissioning,yukon,archaic,reluctantly,retailer,northamptonshire,universally,crossings,boilers,nickelodeon,revue,abbreviation,retaliation,scripture,routinely,medicinal,benedictine,kenyan,retention,deteriorated,glaciers,apprenticeship,coupling,researched,topography,entrances,anaheim,pivotal,compensate,arched,modify,reinforce,dusseldorf,journeys,motorsport,conceded,sumatra,spaniards,quantitative,loire,cinematography,discarded,botswana,morale,engined,zionist,philanthropy,sainte,fatalities,cypriot,motorsports,indicators,pricing,institut,bethlehem,implicated,gravitational,differentiation,rotor,thriving,precedent,ambiguous,concessions,forecast,conserved,fremantle,asphalt,landslide,middlesbrough,formula_7,humidity,overseeing,chronological,diaries,multinational,crimean,turnover,improvised,youths,declares,tasmanian,canadiens,fumble,refinery,weekdays,unconstitutional,upward,guardians,brownish,imminent,hamas,endorsement,naturalist,martyrs,caledonia,chords,yeshiva,reptiles,severity,mitsubishi,fairs,installment,substitution,repertory,keyboardist,interpreter,silesia,noticeable,rhineland,transmit,inconsistent,booklet,academies,epithet,pertaining,progressively,aquatics,scrutiny,prefect,toxicity,rugged,consume,o'donnell,evolve,uniquely,cabaret,mediated,landowner,transgender,palazzo,compilations,albuquerque,induce,sinai,remastered,efficacy,underside,analogue,specify,possessing,advocating,compatibility,liberated,greenville,mecklenburg,header,memorials,sewage,rhodesia,1800s,salaries,atoll,coordinating,partisans,repealed,amidst,subjective,optimization,nectar,evolving,exploits,madhya,styling,accumulation,raion,postage,responds,buccaneers,frontman,brunei,choreography,coated,kinetic,sampled,inflammatory,complementary,eclectic,norte,vijay,a.k.a,mainz,casualty,connectivity,laureate,franchises,yiddish,reputed,unpublished,economical,periodicals,vertically,bicycles,brethren,capacities,unitary,archeological,tehsil,domesday,wehrmacht,justification,angered,mysore,fielded,abuses,nutrients,ambitions,taluk,battleships,symbolism,superiority,neglect,attendees,commentaries,collaborators,predictions,yorker,breeders,investing,libretto,informally,coefficients,memorandum,pounder,collingwood,tightly,envisioned,arbor,mistakenly,captures,nesting,conflicting,enhancing,streetcar,manufactures,buckinghamshire,rewards,commemorating,stony,expenditure,tornadoes,semantic,relocate,weimar,iberian,sighted,intending,ensign,beverages,expectation,differentiate,centro,utilizes,saxophonist,catchment,transylvania,ecosystems,shortest,sediments,socialists,ineffective,kapoor,formidable,heroine,guantanamo,prepares,scattering,pamphlet,verified,elector,barons,totaling,shrubs,pyrenees,amalgamation,mutually,longitudinal,comte,negatively,masonic,envoy,sexes,akbar,mythical,tonga,bishopric,assessments,malaya,warns,interiors,reefs,reflections,neutrality,musically,nomadic,waterways,provence,collaborate,scaled,adulthood,emerges,euros,optics,incentives,overland,periodical,liege,awarding,realization,slang,affirmed,schooner,hokkaido,czechoslovak,protectorate,undrafted,disagreed,commencement,electors,spruce,swindon,fueled,equatorial,inventions,suites,slovene,backdrop,adjunct,energies,remnant,inhabit,alliances,simulcast,reactors,mosques,travellers,outfielder,plumage,migratory,benin,experimented,fibre,projecting,drafting,laude,evidenced,northernmost,indicted,directional,replication,croydon,comedies,jailed,organizes,devotees,reservoirs,turrets,originate,economists,songwriters,junta,trenches,mounds,proportions,comedic,apostle,azerbaijani,farmhouse,resembled,disrupted,playback,mixes,diagonal,relevance,govern,programmer,gdansk,maize,soundtracks,tendencies,mastered,impacted,believers,kilometre,intervene,chairperson,aerodrome,sails,subsidies,ensures,aesthetics,congresses,ratios,sardinia,southernmost,functioned,controllers,downward,randomly,distortion,regents,palatine,disruption,spirituality,vidhan,tracts,compiler,ventilation,anchorage,symposium,assert,pistols,excelled,avenues,convoys,moniker,constructions,proponent,phased,spines,organising,schleswig,policing,campeonato,mined,hourly,croix,lucrative,authenticity,haitian,stimulation,burkina,espionage,midfield,manually,staffed,awakening,metabolic,biographies,entrepreneurship,conspicuous,guangdong,preface,subgroup,mythological,adjutant,feminism,vilnius,oversees,honourable,tripoli,stylized,kinase,societe,notoriety,altitudes,configurations,outward,transmissions,announces,auditor,ethanol,clube,nanjing,mecca,haifa,blogs,postmaster,paramilitary,depart,positioning,potent,recognizable,spire,brackets,remembrance,overlapping,turkic,articulated,scientology,operatic,deploy,readiness,biotechnology,restrict,cinematographer,inverted,synonymous,administratively,westphalia,commodities,replaces,downloads,centralized,munitions,preached,sichuan,fashionable,implementations,matrices,hiv/aids,loyalist,luzon,celebrates,hazards,heiress,mercenaries,synonym,creole,ljubljana,technician,auditioned,technicians,viewpoint,wetland,mongols,princely,sharif,coating,dynasties,southward,doubling,formula_8,mayoral,harvesting,conjecture,goaltender,oceania,spokane,welterweight,bracket,gatherings,weighted,newscasts,mussolini,affiliations,disadvantage,vibrant,spheres,sultanate,distributors,disliked,establishes,marches,drastically,yielding,jewellery,yokohama,vascular,airlift,canons,subcommittee,repression,strengths,graded,outspoken,fused,pembroke,filmography,redundant,fatigue,repeal,threads,reissue,pennant,edible,vapor,corrections,stimuli,commemoration,dictator,anand,secession,amassed,orchards,pontifical,experimentation,greeted,bangor,forwards,decomposition,quran,trolley,chesterfield,traverse,sermons,burials,skier,climbs,consultants,petitioned,reproduce,parted,illuminated,kurdistan,reigned,occupants,packaged,geometridae,woven,regulating,protagonists,crafted,affluent,clergyman,consoles,migrant,supremacy,attackers,caliph,defect,convection,rallies,huron,resin,segunda,quota,warship,overseen,criticizing,shrines,glamorgan,lowering,beaux,hampered,invasions,conductors,collects,bluegrass,surrounds,substrates,perpetual,chronology,pulmonary,executions,crimea,compiling,noctuidae,battled,tumors,minsk,novgorod,serviced,yeast,computation,swamps,theodor,baronetcy,salford,uruguayan,shortages,odisha,siberian,novelty,cinematic,invitational,decks,dowager,oppression,bandits,appellate,state-of-the-art,clade,palaces,signalling,galaxies,industrialist,tensor,learnt,incurred,magistrates,binds,orbits,ciudad,willingness,peninsular,basins,biomedical,shafts,marlborough,bournemouth,withstand,fitzroy,dunedin,variance,steamship,integrating,muscular,fines,akron,bulbophyllum,malmo,disclosed,cornerstone,runways,medicines,twenty20,gettysburg,progresses,frigates,bodied,transformations,transforms,helens,modelled,versatile,regulator,pursuits,legitimacy,amplifier,scriptures,voyages,examines,presenters,octagonal,poultry,formula_9,anatolia,computed,migrate,directorial,hybrids,localized,preferring,guggenheim,persisted,grassroots,inflammation,fishery,otago,vigorous,professions,instructional,inexpensive,insurgency,legislators,sequels,surnames,agrarian,stainless,nairobi,minas,forerunner,aristocracy,transitions,sicilian,showcased,doses,hiroshima,summarized,gearbox,emancipation,limitation,nuclei,seismic,abandonment,dominating,appropriations,occupations,electrification,hilly,contracting,exaggerated,entertainer,kazan,oricon,cartridges,characterization,parcel,maharaja,exceeds,aspiring,obituary,flattened,contrasted,narration,replies,oblique,outpost,fronts,arranger,talmud,keynes,doctrines,endured,confesses,fortification,supervisors,kilometer,academie,jammu,bathurst,piracy,prostitutes,navarre,cumulative,cruises,lifeboat,twinned,radicals,interacting,expenditures,wexford,libre,futsal,curated,clockwise,colloquially,procurement,immaculate,lyricist,enhancement,porcelain,alzheimer,highlighting,judah,disagreements,storytelling,sheltered,wroclaw,vaudeville,contrasts,neoclassical,compares,contrasting,deciduous,francaise,descriptive,cyclic,reactive,antiquities,meiji,repeats,creditors,forcibly,newmarket,picturesque,impending,uneven,bison,raceway,solvent,ecumenical,optic,professorship,harvested,waterway,banjo,pharaoh,geologist,scanning,dissent,recycled,unmanned,retreating,gospels,aqueduct,branched,tallinn,groundbreaking,syllables,hangar,designations,procedural,craters,cabins,encryption,anthropologist,montevideo,outgoing,inverness,chattanooga,fascism,calais,chapels,groundwater,downfall,misleading,robotic,tortricidae,pixel,handel,prohibit,crewe,renaming,reprised,kickoff,leftist,spaced,integers,causeway,pines,authorship,organise,ptolemy,accessibility,virtues,lesions,iroquois,qur'an,atheist,synthesized,biennial,confederates,dietary,skaters,stresses,tariff,koreans,intercity,republics,quintet,baroness,naive,amplitude,insistence,tbilisi,residues,grammatical,diversified,egyptians,accompaniment,vibration,repository,mandal,topological,distinctions,coherent,invariant,batters,nuevo,internationals,implements,follower,bahia,widened,independents,cantonese,totaled,guadalajara,wolverines,befriended,muzzle,surveying,hungarians,medici,deportation,rayon,approx,recounts,attends,clerical,hellenic,furnished,alleging,soluble,systemic,gallantry,bolshevik,intervened,hostel,gunpowder,specialising,stimulate,leiden,removes,thematic,floral,bafta,printers,conglomerate,eroded,analytic,successively,lehigh,thessaloniki,kilda,clauses,ascended,nehru,scripted,tokugawa,competence,diplomats,exclude,consecration,freedoms,assaults,revisions,blacksmith,textual,sparse,concacaf,slain,uploaded,enraged,whaling,guise,stadiums,debuting,dormitory,cardiovascular,yunnan,dioceses,consultancy,notions,lordship,archdeacon,collided,medial,airfields,garment,wrestled,adriatic,reversal,refueling,verification,jakob,horseshoe,intricate,veracruz,sarawak,syndication,synthesizer,anthologies,stature,feasibility,guillaume,narratives,publicized,antrim,intermittent,constituents,grimsby,filmmaking,doping,unlawful,nominally,transmitting,documenting,seater,internationale,ejected,steamboat,alsace,boise,ineligible,geared,vassal,mustered,ville,inline,pairing,eurasian,kyrgyzstan,barnsley,reprise,stereotypes,rushes,conform,firefighters,deportivo,revolutionaries,rabbis,concurrency,charters,sustaining,aspirations,algiers,chichester,falkland,morphological,systematically,volcanoes,designate,artworks,reclaimed,jurist,anglia,resurrected,chaotic,feasible,circulating,simulated,environmentally,confinement,adventist,harrisburg,laborers,ostensibly,universiade,pensions,influenza,bratislava,octave,refurbishment,gothenburg,putin,barangay,annapolis,breaststroke,illustrates,distorted,choreographed,promo,emphasizing,stakeholders,descends,exhibiting,intrinsic,invertebrates,evenly,roundabout,salts,formula_10,strata,inhibition,branching,stylistic,rumored,realises,mitochondrial,commuted,adherents,logos,bloomberg,telenovela,guineas,charcoal,engages,winery,reflective,siena,cambridgeshire,ventral,flashback,installing,engraving,grasses,traveller,rotated,proprietor,nationalities,precedence,sourced,trainers,cambodian,reductions,depleted,saharan,classifications,biochemistry,plaintiffs,arboretum,humanist,fictitious,aleppo,climates,bazaar,his/her,homogeneous,multiplication,moines,indexed,linguist,skeletal,foliage,societal,differentiated,informing,mammal,infancy,archival,cafes,malls,graeme,musee,schizophrenia,fargo,pronouns,derivation,descend,ascending,terminating,deviation,recaptured,confessions,weakening,tajikistan,bahadur,pasture,b/hip,donegal,supervising,sikhs,thinkers,euclidean,reinforcement,friars,portage,fuscous,lucknow,synchronized,assertion,choirs,privatization,corrosion,multitude,skyscraper,royalties,ligament,usable,spores,directs,clashed,stockport,fronted,dependency,contiguous,biologist,backstroke,powerhouse,frescoes,phylogenetic,welding,kildare,gabon,conveyed,augsburg,severn,continuum,sahib,lille,injuring,passeriformesfamily,succeeds,translating,unitarian,startup,turbulent,outlying,philanthropic,stanislaw,idols,claremont,conical,haryana,armagh,blended,implicit,conditioned,modulation,rochdale,labourers,coinage,shortstop,potsdam,gears,obesity,bestseller,advisers,bouts,comedians,jozef,lausanne,taxonomic,correlated,columbian,marne,indications,psychologists,libel,edict,beaufort,disadvantages,renal,finalized,racehorse,unconventional,disturbances,falsely,zoology,adorned,redesign,executing,narrower,commended,appliances,stalls,resurgence,saskatoon,miscellaneous,permitting,epoch,formula_11,cumbria,forefront,vedic,eastenders,disposed,supermarkets,rower,inhibitor,magnesium,colourful,yusuf,harrow,formulas,centrally,balancing,ionic,nocturnal,consolidate,ornate,raiding,charismatic,accelerate,nominate,residual,dhabi,commemorates,attribution,uninhabited,mindanao,atrocities,genealogical,romani,applicant,enactment,abstraction,trough,pulpit,minuscule,misconduct,grenades,timely,supplements,messaging,curvature,ceasefire,telangana,susquehanna,braking,redistribution,shreveport,neighbourhoods,gregorian,widowed,khuzestan,empowerment,scholastic,evangelist,peptide,topical,theorist,historia,thence,sudanese,museo,jurisprudence,masurian,frankish,headlined,recounted,netball,petitions,tolerant,hectare,truncated,southend,methane,captives,reigns,massif,subunit,acidic,weightlifting,footballers,sabah,britannia,tunisian,segregated,sawmill,withdrawing,unpaid,weaponry,somme,perceptions,unicode,alcoholism,durban,wrought,waterfalls,jihad,auschwitz,upland,eastbound,adjective,anhalt,evaluating,regimes,guildford,reproduced,pamphlets,hierarchical,maneuvers,hanoi,fabricated,repetition,enriched,arterial,replacements,tides,globalization,adequately,westbound,satisfactory,fleets,phosphorus,lastly,neuroscience,anchors,xinjiang,membranes,improvisation,shipments,orthodoxy,submissions,bolivian,mahmud,ramps,leyte,pastures,outlines,flees,transmitters,fares,sequential,stimulated,novice,alternately,symmetrical,breakaway,layered,baronets,lizards,blackish,edouard,horsepower,penang,principals,mercantile,maldives,overwhelmingly,hawke,rallied,prostate,conscription,juveniles,maccabi,carvings,strikers,sudbury,spurred,improves,lombardy,macquarie,parisian,elastic,distillery,shetland,humane,brentford,wrexham,warehouses,routines,encompassed,introductory,isfahan,instituto,palais,revolutions,sporadic,impoverished,portico,fellowships,speculative,enroll,dormant,adhere,fundamentally,sculpted,meritorious,template,upgrading,reformer,rectory,uncredited,indicative,creeks,galveston,radically,hezbollah,firearm,educating,prohibits,trondheim,locus,refit,headwaters,screenings,lowlands,wasps,coarse,attaining,sedimentary,perished,pitchfork,interned,cerro,stagecoach,aeronautical,liter,transitioned,haydn,inaccurate,legislatures,bromwich,knesset,spectroscopy,butte,asiatic,degraded,concordia,catastrophic,lobes,wellness,pensacola,periphery,hapoel,theta,horizontally,freiburg,liberalism,pleas,durable,warmian,offenses,mesopotamia,shandong,unsuitable,hospitalized,appropriately,phonetic,encompass,conversions,observes,illnesses,breakout,assigns,crowns,inhibitors,nightly,manifestation,fountains,maximize,alphabetical,sloop,expands,newtown,widening,gaddafi,commencing,camouflage,footprint,tyrol,barangays,universite,highlanders,budgets,query,lobbied,westchester,equator,stipulated,pointe,distinguishes,allotted,embankment,advises,storing,loyalists,fourier,rehearsals,starvation,gland,rihanna,tubular,expressive,baccalaureate,intersections,revered,carbonate,eritrea,craftsmen,cosmopolitan,sequencing,corridors,shortlisted,bangladeshi,persians,mimic,parades,repetitive,recommends,flanks,promoters,incompatible,teaming,ammonia,greyhound,solos,improper,legislator,newsweek,recurrent,vitro,cavendish,eireann,crises,prophets,mandir,strategically,guerrillas,formula_12,ghent,contenders,equivalence,drone,sociological,hamid,castes,statehood,aland,clinched,relaunched,tariffs,simulations,williamsburg,rotate,mediation,smallpox,harmonica,lodges,lavish,restrictive,o'sullivan,detainees,polynomials,echoes,intersecting,learners,elects,charlemagne,defiance,epsom,liszt,facilitating,absorbing,revelations,padua,pieter,pious,penultimate,mammalian,montenegrin,supplementary,widows,aromatic,croats,roanoke,trieste,legions,subdistrict,babylonian,grasslands,volga,violently,sparsely,oldies,telecommunication,respondents,quarries,downloadable,commandos,taxpayer,catalytic,malabar,afforded,copying,declines,nawab,junctions,assessing,filtering,classed,disused,compliant,christoph,gottingen,civilizations,hermitage,caledonian,whereupon,ethnically,springsteen,mobilization,terraces,indus,excel,zoological,enrichment,simulate,guitarists,registrar,cappella,invoked,reused,manchu,configured,uppsala,genealogy,mergers,casts,curricular,rebelled,subcontinent,horticultural,parramatta,orchestrated,dockyard,claudius,decca,prohibiting,turkmenistan,brahmin,clandestine,obligatory,elaborated,parasitic,helix,constraint,spearheaded,rotherham,eviction,adapting,albans,rescues,sociologist,guiana,convicts,occurrences,kamen,antennas,asturias,wheeled,sanitary,deterioration,trier,theorists,baseline,announcements,valea,planners,factual,serialized,serials,bilbao,demoted,fission,jamestown,cholera,alleviate,alteration,indefinite,sulfate,paced,climatic,valuation,artisans,proficiency,aegean,regulators,fledgling,sealing,influencing,servicemen,frequented,cancers,tambon,narayan,bankers,clarified,embodied,engraver,reorganisation,dissatisfied,dictated,supplemental,temperance,ratification,puget,nutrient,pretoria,papyrus,uniting,ascribed,cores,coptic,schoolhouse,barrio,1910s,armory,defected,transatlantic,regulates,ported,artefacts,specifies,boasted,scorers,mollusks,emitted,navigable,quakers,projective,dialogues,reunification,exponential,vastly,banners,unsigned,dissipated,halves,coincidentally,leasing,purported,escorting,estimation,foxes,lifespan,inflorescence,assimilation,showdown,staunch,prologue,ligand,superliga,telescopes,northwards,keynote,heaviest,taunton,redeveloped,vocalists,podlaskie,soyuz,rodents,azores,moravian,outset,parentheses,apparel,domestically,authoritative,polymers,monterrey,inhibit,launcher,jordanian,folds,taxis,mandates,singled,liechtenstein,subsistence,marxism,ousted,governorship,servicing,offseason,modernism,prism,devout,translators,islamist,chromosomes,pitted,bedfordshire,fabrication,authoritarian,javanese,leaflets,transient,substantive,predatory,sigismund,assassinate,diagrams,arrays,rediscovered,reclamation,spawning,fjord,peacekeeping,strands,fabrics,highs,regulars,tirana,ultraviolet,athenian,filly,barnet,naacp,nueva,favourites,terminates,showcases,clones,inherently,interpreting,bjorn,finely,lauded,unspecified,chola,pleistocene,insulation,antilles,donetsk,funnel,nutritional,biennale,reactivated,southport,primate,cavaliers,austrians,interspersed,restarted,suriname,amplifiers,wladyslaw,blockbuster,sportsman,minogue,brightness,benches,bridgeport,initiating,israelis,orbiting,newcomers,externally,scaling,transcribed,impairment,luxurious,longevity,impetus,temperament,ceilings,tchaikovsky,spreads,pantheon,bureaucracy,1820s,heraldic,villas,formula_13,galician,meath,avoidance,corresponded,headlining,connacht,seekers,rappers,solids,monograph,scoreless,opole,isotopes,himalayas,parodies,garments,microscopic,republished,havilland,orkney,demonstrators,pathogen,saturated,hellenistic,facilitates,aerodynamic,relocating,indochina,laval,astronomers,bequeathed,administrations,extracts,nagoya,torquay,demography,medicare,ambiguity,renumbered,pursuant,concave,syriac,electrode,dispersal,henan,bialystok,walsall,crystalline,puebla,janata,illumination,tianjin,enslaved,coloration,championed,defamation,grille,johor,rejoin,caspian,fatally,planck,workings,appointing,institutionalized,wessex,modernized,exemplified,regatta,jacobite,parochial,programmers,blending,eruptions,insurrection,regression,indices,sited,dentistry,mobilized,furnishings,levant,primaries,ardent,nagasaki,conqueror,dorchester,opined,heartland,amman,mortally,wellesley,bowlers,outputs,coveted,orthography,immersion,disrepair,disadvantaged,curate,childless,condensed,codice_1,remodeled,resultant,bolsheviks,superfamily,saxons,2010s,contractual,rivalries,malacca,oaxaca,magnate,vertebrae,quezon,olympiad,yucatan,tyres,macro,specialization,commendation,caliphate,gunnery,exiles,excerpts,fraudulent,adjustable,aramaic,interceptor,drumming,standardization,reciprocal,adolescents,federalist,aeronautics,favorably,enforcing,reintroduced,zhejiang,refining,biplane,banknotes,accordion,intersect,illustrating,summits,classmate,militias,biomass,massacres,epidemiology,reworked,wrestlemania,nantes,auditory,taxon,elliptical,chemotherapy,asserting,avoids,proficient,airmen,yellowstone,multicultural,alloys,utilization,seniority,kuyavian,huntsville,orthogonal,bloomington,cultivars,casimir,internment,repulsed,impedance,revolving,fermentation,parana,shutout,partnering,empowered,islamabad,polled,classify,amphibians,greyish,obedience,4x100,projectile,khyber,halfback,relational,d'ivoire,synonyms,endeavour,padma,customized,mastery,defenceman,berber,purge,interestingly,covent,promulgated,restricting,condemnation,hillsborough,walkers,privateer,intra,captaincy,naturalized,huffington,detecting,hinted,migrating,bayou,counterattack,anatomical,foraging,unsafe,swiftly,outdated,paraguayan,attire,masjid,endeavors,jerseys,triassic,quechua,growers,axial,accumulate,wastewater,cognition,fungal,animator,pagoda,kochi,uniformly,antibody,yerevan,hypotheses,combatants,italianate,draining,fragmentation,snowfall,formative,inversion,kitchener,identifier,additive,lucha,selects,ashland,cambrian,racetrack,trapping,congenital,primates,wavelengths,expansions,yeomanry,harcourt,wealthiest,awaited,punta,intervening,aggressively,vichy,piloted,midtown,tailored,heyday,metadata,guadalcanal,inorganic,hadith,pulses,francais,tangent,scandals,erroneously,tractors,pigment,constabulary,jiangsu,landfill,merton,basalt,astor,forbade,debuts,collisions,exchequer,stadion,roofed,flavour,sculptors,conservancy,dissemination,electrically,undeveloped,existent,surpassing,pentecostal,manifested,amend,formula_14,superhuman,barges,tunis,analytics,argyll,liquids,mechanized,domes,mansions,himalayan,indexing,reuters,nonlinear,purification,exiting,timbers,triangles,decommissioning,departmental,causal,fonts,americana,sept.,seasonally,incomes,razavi,sheds,memorabilia,rotational,terre,sutra,protege,yarmouth,grandmaster,annum,looted,imperialism,variability,liquidation,baptised,isotope,showcasing,milling,rationale,hammersmith,austen,streamlined,acknowledging,contentious,qaleh,breadth,turing,referees,feral,toulon,unofficially,identifiable,standout,labeling,dissatisfaction,jurgen,angrily,featherweight,cantons,constrained,dominates,standalone,relinquished,theologians,markedly,italics,downed,nitrate,likened,gules,craftsman,singaporean,pixels,mandela,moray,parity,departement,antigen,academically,burgh,brahma,arranges,wounding,triathlon,nouveau,vanuatu,banded,acknowledges,unearthed,stemming,authentication,byzantines,converge,nepali,commonplace,deteriorating,recalling,palette,mathematicians,greenish,pictorial,ahmedabad,rouen,validation,u.s.a.,'best,malvern,archers,converter,undergoes,fluorescent,logistical,notification,transvaal,illicit,symphonies,stabilization,worsened,fukuoka,decrees,enthusiast,seychelles,blogger,louvre,dignitaries,burundi,wreckage,signage,pinyin,bursts,federer,polarization,urbana,lazio,schism,nietzsche,venerable,administers,seton,kilograms,invariably,kathmandu,farmed,disqualification,earldom,appropriated,fluctuations,kermanshah,deployments,deformation,wheelbase,maratha,psalm,bytes,methyl,engravings,skirmish,fayette,vaccines,ideally,astrology,breweries,botanic,opposes,harmonies,irregularities,contended,gaulle,prowess,constants,aground,filipinos,fresco,ochreous,jaipur,willamette,quercus,eastwards,mortars,champaign,braille,reforming,horned,hunan,spacious,agitation,draught,specialties,flourishing,greensboro,necessitated,swedes,elemental,whorls,hugely,structurally,plurality,synthesizers,embassies,assad,contradictory,inference,discontent,recreated,inspectors,unicef,commuters,embryo,modifying,stints,numerals,communicated,boosted,trumpeter,brightly,adherence,remade,leases,restrained,eucalyptus,dwellers,planar,grooves,gainesville,daimler,anzac,szczecin,cornerback,prized,peking,mauritania,khalifa,motorized,lodging,instrumentalist,fortresses,cervical,formula_15,passerine,sectarian,researches,apprenticed,reliefs,disclose,gliding,repairing,queue,kyushu,literate,canoeing,sacrament,separatist,calabria,parkland,flowed,investigates,statistically,visionary,commits,dragoons,scrolls,premieres,revisited,subdued,censored,patterned,elective,outlawed,orphaned,leyland,richly,fujian,miniatures,heresy,plaques,countered,nonfiction,exponent,moravia,dispersion,marylebone,midwestern,enclave,ithaca,federated,electronically,handheld,microscopy,tolls,arrivals,climbers,continual,cossacks,moselle,deserts,ubiquitous,gables,forecasts,deforestation,vertebrates,flanking,drilled,superstructure,inspected,consultative,bypassed,ballast,subsidy,socioeconomic,relic,grenada,journalistic,administering,accommodated,collapses,appropriation,reclassified,foreword,porte,assimilated,observance,fragmented,arundel,thuringia,gonzaga,shenzhen,shipyards,sectional,ayrshire,sloping,dependencies,promenade,ecuadorian,mangrove,constructs,goalscorer,heroism,iteration,transistor,omnibus,hampstead,cochin,overshadowed,chieftain,scalar,finishers,ghanaian,abnormalities,monoplane,encyclopaedia,characterize,travancore,baronetage,bearers,biking,distributes,paving,christened,inspections,banco,humber,corinth,quadratic,albanians,lineages,majored,roadside,inaccessible,inclination,darmstadt,fianna,epilepsy,propellers,papacy,montagu,bhutto,sugarcane,optimized,pilasters,contend,batsmen,brabant,housemates,sligo,ascot,aquinas,supervisory,accorded,gerais,echoed,nunavut,conservatoire,carniola,quartermaster,gminas,impeachment,aquitaine,reformers,quarterfinal,karlsruhe,accelerator,coeducational,archduke,gelechiidae,seaplane,dissident,frenchman,palau,depots,hardcover,aachen,darreh,denominational,groningen,parcels,reluctance,drafts,elliptic,counters,decreed,airship,devotional,contradiction,formula_16,undergraduates,qualitative,guatemalan,slavs,southland,blackhawks,detrimental,abolish,chechen,manifestations,arthritis,perch,fated,hebei,peshawar,palin,immensely,havre,totalling,rampant,ferns,concourse,triples,elites,olympian,larva,herds,lipid,karabakh,distal,monotypic,vojvodina,batavia,multiplied,spacing,spellings,pedestrians,parchment,glossy,industrialization,dehydrogenase,patriotism,abolitionist,mentoring,elizabethan,figurative,dysfunction,abyss,constantin,middletown,stigma,mondays,gambia,gaius,israelites,renounced,nepalese,overcoming,buren,sulphur,divergence,predation,looting,iberia,futuristic,shelved,anthropological,innsbruck,escalated,clermont,entrepreneurial,benchmark,mechanically,detachments,populist,apocalyptic,exited,embryonic,stanza,readership,chiba,landlords,expansive,boniface,therapies,perpetrators,whitehall,kassel,masts,carriageway,clinch,pathogens,mazandaran,undesirable,teutonic,miocene,nagpur,juris,cantata,compile,diffuse,dynastic,reopening,comptroller,o'neal,flourish,electing,scientifically,departs,welded,modal,cosmology,fukushima,libertadores,chang'an,asean,generalization,localization,afrikaans,cricketers,accompanies,emigrants,esoteric,southwards,shutdown,prequel,fittings,innate,wrongly,equitable,dictionaries,senatorial,bipolar,flashbacks,semitism,walkway,lyrically,legality,sorbonne,vigorously,durga,samoan,karel,interchanges,patna,decider,registering,electrodes,anarchists,excursion,overthrown,gilan,recited,michelangelo,advertiser,kinship,taboo,cessation,formula_17,premiers,traversed,madurai,poorest,torneo,exerted,replicate,spelt,sporadically,horde,landscaping,razed,hindered,esperanto,manchuria,propellant,jalan,baha'is,sikkim,linguists,pandit,racially,ligands,dowry,francophone,escarpment,behest,magdeburg,mainstay,villiers,yangtze,grupo,conspirators,martyrdom,noticeably,lexical,kazakh,unrestricted,utilised,sired,inhabits,proofs,joseon,pliny,minted,buddhists,cultivate,interconnected,reuse,viability,australasian,derelict,resolving,overlooks,menon,stewardship,playwrights,thwarted,filmfare,disarmament,protections,bundles,sidelined,hypothesized,singer/songwriter,forage,netted,chancery,townshend,restructured,quotation,hyperbolic,succumbed,parliaments,shenandoah,apical,kibbutz,storeys,pastors,lettering,ukrainians,hardships,chihuahua,avail,aisles,taluka,antisemitism,assent,ventured,banksia,seamen,hospice,faroe,fearful,woreda,outfield,chlorine,transformer,tatar,panoramic,pendulum,haarlem,styria,cornice,importing,catalyzes,subunits,enamel,bakersfield,realignment,sorties,subordinates,deanery,townland,gunmen,tutelage,evaluations,allahabad,thrace,veneto,mennonite,sharia,subgenus,satisfies,puritan,unequal,gastrointestinal,ordinances,bacterium,horticulture,argonauts,adjectives,arable,duets,visualization,woolwich,revamped,euroleague,thorax,completes,originality,vasco,freighter,sardar,oratory,sects,extremes,signatories,exporting,arisen,exacerbated,departures,saipan,furlongs,d'italia,goring,dakar,conquests,docked,offshoot,okrug,referencing,disperse,netting,summed,rewritten,articulation,humanoid,spindle,competitiveness,preventive,facades,westinghouse,wycombe,synthase,emulate,fostering,abdel,hexagonal,myriad,caters,arjun,dismay,axiom,psychotherapy,colloquial,complemented,martinique,fractures,culmination,erstwhile,atrium,electronica,anarchism,nadal,montpellier,algebras,submitting,adopts,stemmed,overcame,internacional,asymmetric,gallipoli,gliders,flushing,extermination,hartlepool,tesla,interwar,patriarchal,hitherto,ganges,combatant,marred,philology,glastonbury,reversible,isthmus,undermined,southwark,gateshead,andalusia,remedies,hastily,optimum,smartphone,evade,patrolled,beheaded,dopamine,waivers,ugandan,gujarati,densities,predicting,intestinal,tentative,interstellar,kolonia,soloists,penetrated,rebellions,qeshlaq,prospered,colegio,deficits,konigsberg,deficient,accessing,relays,kurds,politburo,codified,incarnations,occupancy,cossack,metaphysical,deprivation,chopra,piccadilly,formula_18,makeshift,protestantism,alaskan,frontiers,faiths,tendon,dunkirk,durability,autobots,bonuses,coinciding,emails,gunboat,stucco,magma,neutrons,vizier,subscriptions,visuals,envisaged,carpets,smoky,schema,parliamentarian,immersed,domesticated,parishioners,flinders,diminutive,mahabharata,ballarat,falmouth,vacancies,gilded,twigs,mastering,clerics,dalmatia,islington,slogans,compressor,iconography,congolese,sanction,blends,bulgarians,moderator,outflow,textures,safeguard,trafalgar,tramways,skopje,colonialism,chimneys,jazeera,organisers,denoting,motivations,ganga,longstanding,deficiencies,gwynedd,palladium,holistic,fascia,preachers,embargo,sidings,busan,ignited,artificially,clearwater,cemented,northerly,salim,equivalents,crustaceans,oberliga,quadrangle,historiography,romanians,vaults,fiercely,incidental,peacetime,tonal,bhopal,oskar,radha,pesticides,timeslot,westerly,cathedrals,roadways,aldershot,connectors,brahmins,paler,aqueous,gustave,chromatic,linkage,lothian,specialises,aggregation,tributes,insurgent,enact,hampden,ghulam,federations,instigated,lyceum,fredrik,chairmanship,floated,consequent,antagonists,intimidation,patriarchate,warbler,heraldry,entrenched,expectancy,habitation,partitions,widest,launchers,nascent,ethos,wurzburg,lycee,chittagong,mahatma,merseyside,asteroids,yokosuka,cooperatives,quorum,redistricting,bureaucratic,yachts,deploying,rustic,phonology,chorale,cellist,stochastic,crucifixion,surmounted,confucian,portfolios,geothermal,crested,calibre,tropics,deferred,nasir,iqbal,persistence,essayist,chengdu,aborigines,fayetteville,bastion,interchangeable,burlesque,kilmarnock,specificity,tankers,colonels,fijian,quotations,enquiry,quito,palmerston,delle,multidisciplinary,polynesian,iodine,antennae,emphasised,manganese,baptists,galilee,jutland,latent,excursions,skepticism,tectonic,precursors,negligible,musique,misuse,vitoria,expressly,veneration,sulawesi,footed,mubarak,chongqing,chemically,midday,ravaged,facets,varma,yeovil,ethnographic,discounted,physicists,attache,disbanding,essen,shogunate,cooperated,waikato,realising,motherwell,pharmacology,sulfide,inward,expatriate,devoid,cultivar,monde,andean,groupings,goran,unaffected,moldovan,postdoctoral,coleophora,delegated,pronoun,conductivity,coleridge,disapproval,reappeared,microbial,campground,olsztyn,fostered,vaccination,rabbinical,champlain,milestones,viewership,caterpillar,effected,eupithecia,financier,inferred,uzbek,bundled,bandar,balochistan,mysticism,biosphere,holotype,symbolizes,lovecraft,photons,abkhazia,swaziland,subgroups,measurable,falkirk,valparaiso,ashok,discriminatory,rarity,tabernacle,flyweight,jalisco,westernmost,antiquarian,extracellular,margrave,colspan=9,midsummer,digestive,reversing,burgeoning,substitutes,medallist,khrushchev,guerre,folio,detonated,partido,plentiful,aggregator,medallion,infiltration,shaded,santander,fared,auctioned,permian,ramakrishna,andorra,mentors,diffraction,bukit,potentials,translucent,feminists,tiers,protracted,coburg,wreath,guelph,adventurer,he/she,vertebrate,pipelines,celsius,outbreaks,australasia,deccan,garibaldi,unionists,buildup,biochemical,reconstruct,boulders,stringent,barbed,wording,furnaces,pests,befriends,organises,popes,rizal,tentacles,cadre,tallahassee,punishments,occidental,formatted,mitigation,rulings,rubens,cascades,inducing,choctaw,volta,synagogues,movable,altarpiece,mitigate,practise,intermittently,encountering,memberships,earns,signify,retractable,amounting,pragmatic,wilfrid,dissenting,divergent,kanji,reconstituted,devonian,constitutions,levied,hendrik,starch,costal,honduran,ditches,polygon,eindhoven,superstars,salient,argus,punitive,purana,alluvial,flaps,inefficient,retracted,advantageous,quang,andersson,danville,binghamton,symbolize,conclave,shaanxi,silica,interpersonal,adept,frans,pavilions,lubbock,equip,sunken,limburg,activates,prosecutions,corinthian,venerated,shootings,retreats,parapet,orissa,riviere,animations,parodied,offline,metaphysics,bluffs,plume,piety,fruition,subsidized,steeplechase,shanxi,eurasia,angled,forecasting,suffragan,ashram,larval,labyrinth,chronicler,summaries,trailed,merges,thunderstorms,filtered,formula_19,advertisers,alpes,informatics,parti,constituting,undisputed,certifications,javascript,molten,sclerosis,rumoured,boulogne,hmong,lewes,breslau,notts,bantu,ducal,messengers,radars,nightclubs,bantamweight,carnatic,kaunas,fraternal,triggering,controversially,londonderry,visas,scarcity,offaly,uprisings,repelled,corinthians,pretext,kuomintang,kielce,empties,matriculated,pneumatic,expos,agile,treatises,midpoint,prehistory,oncology,subsets,hydra,hypertension,axioms,wabash,reiterated,swapped,achieves,premio,ageing,overture,curricula,challengers,subic,selangor,liners,frontline,shutter,validated,normalized,entertainers,molluscs,maharaj,allegation,youngstown,synth,thoroughfare,regionally,pillai,transcontinental,pedagogical,riemann,colonia,easternmost,tentatively,profiled,herefordshire,nativity,meuse,nucleotide,inhibits,huntingdon,throughput,recorders,conceding,domed,homeowners,centric,gabled,canoes,fringes,breeder,subtitled,fluoride,haplogroup,zionism,izmir,phylogeny,kharkiv,romanticism,adhesion,usaaf,delegations,lorestan,whalers,biathlon,vaulted,mathematically,pesos,skirmishes,heisman,kalamazoo,gesellschaft,launceston,interacts,quadruple,kowloon,psychoanalysis,toothed,ideologies,navigational,valence,induces,lesotho,frieze,rigging,undercarriage,explorations,spoof,eucharist,profitability,virtuoso,recitals,subterranean,sizeable,herodotus,subscriber,huxley,pivot,forewing,warring,boleslaw,bharatiya,suffixes,trois,percussionist,downturn,garrisons,philosophies,chants,mersin,mentored,dramatist,guilds,frameworks,thermodynamic,venomous,mehmed,assembling,rabbinic,hegemony,replicas,enlargement,claimant,retitled,utica,dumfries,metis,deter,assortment,tubing,afflicted,weavers,rupture,ornamentation,transept,salvaged,upkeep,callsign,rajput,stevenage,trimmed,intracellular,synchronization,consular,unfavorable,royalists,goldwyn,fasting,hussars,doppler,obscurity,currencies,amiens,acorn,tagore,townsville,gaussian,migrations,porta,anjou,graphite,seaport,monographs,gladiators,metrics,calligraphy,sculptural,swietokrzyskie,tolombeh,eredivisie,shoals,queries,carts,exempted,fiberglass,mirrored,bazar,progeny,formalized,mukherjee,professed,amazon.com,cathode,moreton,removable,mountaineers,nagano,transplantation,augustinian,steeply,epilogue,adapter,decisively,accelerating,mediaeval,substituting,tasman,devonshire,litres,enhancements,himmler,nephews,bypassing,imperfect,argentinian,reims,integrates,sochi,ascii,licences,niches,surgeries,fables,versatility,indra,footpath,afonso,crore,evaporation,encodes,shelling,conformity,simplify,updating,quotient,overt,firmware,umpires,architectures,eocene,conservatism,secretion,embroidery,f.c..,tuvalu,mosaics,shipwreck,prefectural,cohort,grievances,garnering,centerpiece,apoptosis,djibouti,bethesda,formula_20,shonen,richland,justinian,dormitories,meteorite,reliably,obtains,pedagogy,hardness,cupola,manifolds,amplification,steamers,familial,dumbarton,jerzy,genital,maidstone,salinity,grumman,signifies,presbytery,meteorology,procured,aegis,streamed,deletion,nuestra,mountaineering,accords,neuronal,khanate,grenoble,axles,dispatches,tokens,turku,auctions,propositions,planters,proclaiming,recommissioned,stravinsky,obverse,bombarded,waged,saviour,massacred,reformist,purportedly,resettlement,ravenna,embroiled,minden,revitalization,hikers,bridging,torpedoed,depletion,nizam,affectionately,latitudes,lubeck,spore,polymerase,aarhus,nazism,101st,buyout,galerie,diets,overflow,motivational,renown,brevet,deriving,melee,goddesses,demolish,amplified,tamworth,retake,brokerage,beneficiaries,henceforth,reorganised,silhouette,browsers,pollutants,peron,lichfield,encircled,defends,bulge,dubbing,flamenco,coimbatore,refinement,enshrined,grizzlies,capacitor,usefulness,evansville,interscholastic,rhodesian,bulletins,diamondbacks,rockers,platted,medalists,formosa,transporter,slabs,guadeloupe,disparate,concertos,violins,regaining,mandible,untitled,agnostic,issuance,hamiltonian,brampton,srpska,homology,downgraded,florentine,epitaph,kanye,rallying,analysed,grandstand,infinitely,antitrust,plundered,modernity,colspan=3|total,amphitheatre,doric,motorists,yemeni,carnivorous,probabilities,prelate,struts,scrapping,bydgoszcz,pancreatic,signings,predicts,compendium,ombudsman,apertura,appoints,rebbe,stereotypical,valladolid,clustered,touted,plywood,inertial,kettering,curving,d'honneur,housewives,grenadier,vandals,barbarossa,necked,waltham,reputedly,jharkhand,cistercian,pursues,viscosity,organiser,cloister,islet,stardom,moorish,himachal,strives,scripps,staggered,blasts,westwards,millimeters,angolan,hubei,agility,admirals,mordellistena,coincides,platte,vehicular,cordillera,riffs,schoolteacher,canaan,acoustics,tinged,reinforcing,concentrates,daleks,monza,selectively,musik,polynesia,exporter,reviving,macclesfield,bunkers,ballets,manors,caudal,microbiology,primes,unbroken,outcry,flocks,pakhtunkhwa,abelian,toowoomba,luminous,mould,appraisal,leuven,experimentally,interoperability,hideout,perak,specifying,knighthood,vasily,excerpt,computerized,niels,networked,byzantium,reaffirmed,geographer,obscured,fraternities,mixtures,allusion,accra,lengthened,inquest,panhandle,pigments,revolts,bluetooth,conjugate,overtaken,foray,coils,breech,streaks,impressionist,mendelssohn,intermediary,panned,suggestive,nevis,upazila,rotunda,mersey,linnaeus,anecdotes,gorbachev,viennese,exhaustive,moldavia,arcades,irrespective,orator,diminishing,predictive,cohesion,polarized,montage,avian,alienation,conus,jaffna,urbanization,seawater,extremity,editorials,scrolling,dreyfus,traverses,topographic,gunboats,extratropical,normans,correspondents,recognises,millennia,filtration,ammonium,voicing,complied,prefixes,diplomas,figurines,weakly,gated,oscillator,lucerne,embroidered,outpatient,airframe,fractional,disobedience,quarterbacks,formula_21,shinto,chiapas,epistle,leakage,pacifist,avignon,penrith,renders,mantua,screenplays,gustaf,tesco,alphabetically,rations,discharges,headland,tapestry,manipur,boolean,mediator,ebenezer,subchannel,fable,bestselling,ateneo,trademarks,recurrence,dwarfs,britannica,signifying,vikram,mediate,condensation,censuses,verbandsgemeinde,cartesian,sprang,surat,britons,chelmsford,courtenay,statistic,retina,abortions,liabilities,closures,mississauga,skyscrapers,saginaw,compounded,aristocrat,msnbc,stavanger,septa,interpretive,hinder,visibly,seeding,shutouts,irregularly,quebecois,footbridge,hydroxide,implicitly,lieutenants,simplex,persuades,midshipman,heterogeneous,officiated,crackdown,lends,tartu,altars,fractions,dissidents,tapered,modernisation,scripting,blazon,aquaculture,thermodynamics,sistan,hasidic,bellator,pavia,propagated,theorized,bedouin,transnational,mekong,chronicled,declarations,kickstarter,quotas,runtime,duquesne,broadened,clarendon,brownsville,saturation,tatars,electorates,malayan,replicated,observable,amphitheater,endorsements,referral,allentown,mormons,pantomime,eliminates,typeface,allegorical,varna,conduction,evoke,interviewer,subordinated,uyghur,landscaped,conventionally,ascend,edifice,postulated,hanja,whitewater,embarking,musicologist,tagalog,frontage,paratroopers,hydrocarbons,transliterated,nicolae,viewpoints,surrealist,asheville,falklands,hacienda,glide,opting,zimbabwean,discal,mortgages,nicaraguan,yadav,ghosh,abstracted,castilian,compositional,cartilage,intergovernmental,forfeited,importation,rapping,artes,republika,narayana,condominium,frisian,bradman,duality,marche,extremist,phosphorylation,genomes,allusions,valencian,habeas,ironworks,multiplex,harpsichord,emigrate,alternated,breda,waffen,smartphones,familiarity,regionalliga,herbaceous,piping,dilapidated,carboniferous,xviii,critiques,carcinoma,sagar,chippewa,postmodern,neapolitan,excludes,notoriously,distillation,tungsten,richness,installments,monoxide,chand,privatisation,molded,maths,projectiles,luoyang,epirus,lemma,concentric,incline,erroneous,sideline,gazetted,leopards,fibres,renovate,corrugated,unilateral,repatriation,orchestration,saeed,rockingham,loughborough,formula_22,bandleader,appellation,openness,nanotechnology,massively,tonnage,dunfermline,exposes,moored,ridership,motte,eurobasket,majoring,feats,silla,laterally,playlist,downwards,methodologies,eastbourne,daimyo,cellulose,leyton,norwalk,oblong,hibernian,opaque,insular,allegory,camogie,inactivation,favoring,masterpieces,rinpoche,serotonin,portrayals,waverley,airliner,longford,minimalist,outsourcing,excise,meyrick,qasim,organisational,synaptic,farmington,gorges,scunthorpe,zoned,tohoku,librarians,davao,decor,theatrically,brentwood,pomona,acquires,planter,capacitors,synchronous,skateboarding,coatings,turbocharged,ephraim,capitulation,scoreboard,hebrides,ensues,cereals,ailing,counterpoint,duplication,antisemitic,clique,aichi,oppressive,transcendental,incursions,rename,renumbering,powys,vestry,bitterly,neurology,supplanted,affine,susceptibility,orbiter,activating,overlaps,ecoregion,raman,canoer,darfur,microorganisms,precipitated,protruding,torun,anthropologists,rennes,kangaroos,parliamentarians,edits,littoral,archived,begum,rensselaer,microphones,ypres,empower,etruscan,wisden,montfort,calibration,isomorphic,rioting,kingship,verbally,smyrna,cohesive,canyons,fredericksburg,rahul,relativistic,micropolitan,maroons,industrialized,henchmen,uplift,earthworks,mahdi,disparity,cultured,transliteration,spiny,fragmentary,extinguished,atypical,inventors,biosynthesis,heralded,curacao,anomalies,aeroplane,surya,mangalore,maastricht,ashkenazi,fusiliers,hangzhou,emitting,monmouthshire,schwarzenegger,ramayana,peptides,thiruvananthapuram,alkali,coimbra,budding,reasoned,epithelial,harbors,rudimentary,classically,parque,ealing,crusades,rotations,riparian,pygmy,inertia,revolted,microprocessor,calendars,solvents,kriegsmarine,accademia,cheshmeh,yoruba,ardabil,mitra,genomic,notables,propagate,narrates,univision,outposts,polio,birkenhead,urinary,crocodiles,pectoral,barrymore,deadliest,rupees,chaim,protons,comical,astrophysics,unifying,formula_23,vassals,cortical,audubon,pedals,tenders,resorted,geophysical,lenders,recognising,tackling,lanarkshire,doctrinal,annan,combating,guangxi,estimating,selectors,tribunals,chambered,inhabiting,exemptions,curtailed,abbasid,kandahar,boron,bissau,150th,codenamed,wearer,whorl,adhered,subversive,famer,smelting,inserting,mogadishu,zoologist,mosul,stumps,almanac,olympiacos,stamens,participatory,cults,honeycomb,geologists,dividend,recursive,skiers,reprint,pandemic,liber,percentages,adversely,stoppage,chieftains,tubingen,southerly,overcrowding,unorganized,hangars,fulfil,hails,cantilever,woodbridge,pinus,wiesbaden,fertilization,fluorescence,enhances,plenary,troublesome,episodic,thrissur,kickboxing,allele,staffing,garda,televisions,philatelic,spacetime,bullpen,oxides,leninist,enrolling,inventive,truro,compatriot,ruskin,normative,assay,gotha,murad,illawarra,gendarmerie,strasse,mazraeh,rebounded,fanfare,liaoning,rembrandt,iranians,emirate,governs,latency,waterfowl,chairmen,katowice,aristocrats,eclipsed,sentient,sonatas,interplay,sacking,decepticons,dynamical,arbitrarily,resonant,petar,velocities,alludes,wastes,prefectures,belleville,sensibility,salvadoran,consolidating,medicaid,trainees,vivekananda,molar,porous,upload,youngster,infused,doctorates,wuhan,annihilation,enthusiastically,gamespot,kanpur,accumulating,monorail,operetta,tiling,sapporo,finns,calvinist,hydrocarbon,sparrows,orienteering,cornelis,minster,vuelta,plebiscite,embraces,panchayats,focussed,remediation,brahman,olfactory,reestablished,uniqueness,northumbria,rwandan,predominately,abode,ghats,balances,californian,uptake,bruges,inert,westerns,reprints,cairn,yarra,resurfaced,audible,rossini,regensburg,italiana,fleshy,irrigated,alerts,yahya,varanasi,marginalized,expatriates,cantonment,normandie,sahitya,directives,rounder,hulls,fictionalized,constables,inserts,hipped,potosi,navies,biologists,canteen,husbandry,augment,fortnight,assamese,kampala,o'keefe,paleolithic,bluish,promontory,consecutively,striving,niall,reuniting,dipole,friendlies,disapproved,thrived,netflix,liberian,dielectric,medway,strategist,sankt,pickups,hitters,encode,rerouted,claimants,anglesey,partitioned,cavan,flutes,reared,repainted,armaments,bowed,thoracic,balliol,piero,chaplains,dehestan,sender,junkers,sindhi,sickle,dividends,metallurgy,honorific,berths,namco,springboard,resettled,gansu,copyrighted,criticizes,utopian,bendigo,ovarian,binomial,spaceflight,oratorio,proprietors,supergroup,duplicated,foreground,strongholds,revolved,optimize,layouts,westland,hurler,anthropomorphic,excelsior,merchandising,reeds,vetoed,cryptography,hollyoaks,monash,flooring,ionian,resilience,johnstown,resolves,lawmakers,alegre,wildcards,intolerance,subculture,selector,slums,formulate,bayonet,istvan,restitution,interchangeably,awakens,rostock,serpentine,oscillation,reichstag,phenotype,recessed,piotr,annotated,preparedness,consultations,clausura,preferential,euthanasia,genoese,outcrops,freemasonry,geometrical,genesee,islets,prometheus,panamanian,thunderbolt,terraced,stara,shipwrecks,futebol,faroese,sharqi,aldermen,zeitung,unify,formula_24,humanism,syntactic,earthen,blyth,taxed,rescinded,suleiman,cymru,dwindled,vitality,superieure,resupply,adolphe,ardennes,rajiv,profiling,olympique,gestation,interfaith,milosevic,tagline,funerary,druze,silvery,plough,shrubland,relaunch,disband,nunatak,minimizing,excessively,waned,attaching,luminosity,bugle,encampment,electrostatic,minesweeper,dubrovnik,rufous,greenock,hochschule,assyrians,extracting,malnutrition,priya,attainment,anhui,connotations,predicate,seabirds,deduced,pseudonyms,gopal,plovdiv,refineries,imitated,kwazulu,terracotta,tenets,discourses,brandeis,whigs,dominions,pulmonate,landslides,tutors,determinant,richelieu,farmstead,tubercles,technicolor,hegel,redundancy,greenpeace,shortening,mules,distilled,xxiii,fundamentalist,acrylic,outbuildings,lighted,corals,signaled,transistors,cavite,austerity,76ers,exposures,dionysius,outlining,commutative,permissible,knowledgeable,howrah,assemblage,inhibited,crewmen,mbit/s,pyramidal,aberdeenshire,bering,rotates,atheism,howitzer,saone,lancet,fermented,contradicted,materiel,ofsted,numeric,uniformity,josephus,nazarene,kuwaiti,noblemen,pediment,emergent,campaigner,akademi,murcia,perugia,gallen,allsvenskan,finned,cavities,matriculation,rosters,twickenham,signatory,propel,readable,contends,artisan,flamboyant,reggio,italo,fumbles,widescreen,rectangle,centimetres,collaborates,envoys,rijeka,phonological,thinly,refractive,civilisation,reductase,cognate,dalhousie,monticello,lighthouses,jitsu,luneburg,socialite,fermi,collectible,optioned,marquee,jokingly,architecturally,kabir,concubine,nationalisation,watercolor,wicklow,acharya,pooja,leibniz,rajendra,nationalized,stalemate,bloggers,glutamate,uplands,shivaji,carolingian,bucuresti,dasht,reappears,muscat,functionally,formulations,hinged,hainan,catechism,autosomal,incremental,asahi,coeur,diversification,multilateral,fewest,recombination,finisher,harrogate,hangul,feasts,photovoltaic,paget,liquidity,alluded,incubation,applauded,choruses,malagasy,hispanics,bequest,underparts,cassava,kazimierz,gastric,eradication,mowtowr,tyrosine,archbishopric,e9e9e9,unproductive,uxbridge,hydrolysis,harbours,officio,deterministic,devonport,kanagawa,breaches,freetown,rhinoceros,chandigarh,janos,sanatorium,liberator,inequalities,agonist,hydrophobic,constructors,nagorno,snowboarding,welcomes,subscribed,iloilo,resuming,catalysts,stallions,jawaharlal,harriers,definitively,roughriders,hertford,inhibiting,elgar,randomized,incumbents,episcopate,rainforests,yangon,improperly,kemal,interpreters,diverged,uttarakhand,umayyad,phnom,panathinaikos,shabbat,diode,jiangxi,forbidding,nozzle,artistry,licensee,processions,staffs,decimated,expressionism,shingle,palsy,ontology,mahayana,maribor,sunil,hostels,edwardian,jetty,freehold,overthrew,eukaryotic,schuylkill,rawalpindi,sheath,recessive,ferenc,mandibles,berlusconi,confessor,convergent,ababa,slugging,rentals,sephardic,equivalently,collagen,markov,dynamically,hailing,depressions,sprawling,fairgrounds,indistinguishable,plutarch,pressurized,banff,coldest,braunschweig,mackintosh,sociedad,wittgenstein,tromso,airbase,lecturers,subtitle,attaches,purified,contemplated,dreamworks,telephony,prophetic,rockland,aylesbury,biscay,coherence,aleksandar,judoka,pageants,theses,homelessness,luthor,sitcoms,hinterland,fifths,derwent,privateers,enigmatic,nationalistic,instructs,superimposed,conformation,tricycle,dusan,attributable,unbeknownst,laptops,etching,archbishops,ayatollah,cranial,gharbi,interprets,lackawanna,abingdon,saltwater,tories,lender,minaj,ancillary,ranching,pembrokeshire,topographical,plagiarism,murong,marque,chameleon,assertions,infiltrated,guildhall,reverence,schenectady,formula_25,kollam,notary,mexicana,initiates,abdication,basra,theorems,ionization,dismantling,eared,censors,budgetary,numeral,verlag,excommunicated,distinguishable,quarried,cagliari,hindustan,symbolizing,watertown,descartes,relayed,enclosures,militarily,sault,devolved,dalian,djokovic,filaments,staunton,tumour,curia,villainous,decentralized,galapagos,moncton,quartets,onscreen,necropolis,brasileiro,multipurpose,alamos,comarca,jorgen,concise,mercia,saitama,billiards,entomologist,montserrat,lindbergh,commuting,lethbridge,phoenician,deviations,anaerobic,denouncing,redoubt,fachhochschule,principalities,negros,announcers,seconded,parrots,konami,revivals,approving,devotee,riyadh,overtook,morecambe,lichen,expressionist,waterline,silverstone,geffen,sternites,aspiration,behavioural,grenville,tripura,mediums,genders,pyotr,charlottesville,sacraments,programmable,ps100,shackleton,garonne,sumerian,surpass,authorizing,interlocking,lagoons,voiceless,advert,steeple,boycotted,alouettes,yosef,oxidative,sassanid,benefiting,sayyid,nauru,predetermined,idealism,maxillary,polymerization,semesters,munchen,conor,outfitted,clapham,progenitor,gheorghe,observational,recognitions,numerically,colonized,hazrat,indore,contaminants,fatality,eradicate,assyria,convocation,cameos,skillful,skoda,corfu,confucius,overtly,ramadan,wollongong,placements,d.c..,permutation,contemporaneous,voltages,elegans,universitat,samar,plunder,dwindling,neuter,antonin,sinhala,campania,solidified,stanzas,fibrous,marburg,modernize,sorcery,deutscher,florets,thakur,disruptive,infielder,disintegration,internazionale,vicariate,effigy,tripartite,corrective,klamath,environs,leavenworth,sandhurst,workmen,compagnie,hoseynabad,strabo,palisades,ordovician,sigurd,grandsons,defection,viacom,sinhalese,innovator,uncontrolled,slavonic,indexes,refrigeration,aircrew,superbike,resumption,neustadt,confrontations,arras,hindenburg,ripon,embedding,isomorphism,dwarves,matchup,unison,lofty,argos,louth,constitutionally,transitive,newington,facelift,degeneration,perceptual,aviators,enclosing,igneous,symbolically,academician,constitutionality,iso/iec,sacrificial,maturation,apprentices,enzymology,naturalistic,hajji,arthropods,abbess,vistula,scuttled,gradients,pentathlon,etudes,freedmen,melaleuca,thrice,conductive,sackville,franciscans,stricter,golds,kites,worshiped,monsignor,trios,orally,tiered,primacy,bodywork,castleford,epidemics,alveolar,chapelle,chemists,hillsboro,soulful,warlords,ngati,huguenot,diurnal,remarking,luger,motorways,gauss,jahan,cutoff,proximal,bandai,catchphrase,jonubi,ossetia,codename,codice_2,throated,itinerant,chechnya,riverfront,leela,evoked,entailed,zamboanga,rejoining,circuitry,haymarket,khartoum,feuds,braced,miyazaki,mirren,lubusz,caricature,buttresses,attrition,characterizes,widnes,evanston,materialism,contradictions,marist,midrash,gainsborough,ulithi,turkmen,vidya,escuela,patrician,inspirations,reagent,premierships,humanistic,euphrates,transitioning,belfry,zedong,adaption,kaliningrad,lobos,epics,waiver,coniferous,polydor,inductee,refitted,moraine,unsatisfactory,worsening,polygamy,rajya,nested,subgenre,broadside,stampeders,lingua,incheon,pretender,peloton,persuading,excitation,multan,predates,tonne,brackish,autoimmune,insulated,podcasts,iraqis,bodybuilding,condominiums,midlothian,delft,debtor,asymmetrical,lycaenidae,forcefully,pathogenic,tamaulipas,andaman,intravenous,advancements,senegalese,chronologically,realigned,inquirer,eusebius,dekalb,additives,shortlist,goldwater,hindustani,auditing,caterpillars,pesticide,nakhon,ingestion,lansdowne,traditionalist,northland,thunderbirds,josip,nominating,locale,ventricular,animators,verandah,epistles,surveyors,anthems,dredd,upheaval,passaic,anatolian,svalbard,associative,floodplain,taranaki,estuaries,irreducible,beginners,hammerstein,allocate,coursework,secreted,counteract,handwritten,foundational,passover,discoverer,decoding,wares,bourgeoisie,playgrounds,nazionale,abbreviations,seanad,golan,mishra,godavari,rebranding,attendances,backstory,interrupts,lettered,hasbro,ultralight,hormozgan,armee,moderne,subdue,disuse,improvisational,enrolment,persists,moderated,carinthia,hatchback,inhibitory,capitalized,anatoly,abstracts,albemarle,bergamo,insolvency,sentai,cellars,walloon,joked,kashmiri,dirac,materialized,renomination,homologous,gusts,eighteens,centrifugal,storied,baluchestan,formula_26,poincare,vettel,infuriated,gauges,streetcars,vedanta,stately,liquidated,goguryeo,swifts,accountancy,levee,acadian,hydropower,eustace,comintern,allotment,designating,torsion,molding,irritation,aerobic,halen,concerted,plantings,garrisoned,gramophone,cytoplasm,onslaught,requisitioned,relieving,genitive,centrist,jeong,espanola,dissolving,chatterjee,sparking,connaught,varese,arjuna,carpathian,empowering,meteorologist,decathlon,opioid,hohenzollern,fenced,ibiza,avionics,footscray,scrum,discounts,filament,directories,a.f.c,stiffness,quaternary,adventurers,transmits,harmonious,taizong,radiating,germantown,ejection,projectors,gaseous,nahuatl,vidyalaya,nightlife,redefined,refuted,destitute,arista,potters,disseminated,distanced,jamboree,kaohsiung,tilted,lakeshore,grained,inflicting,kreis,novelists,descendents,mezzanine,recast,fatah,deregulation,ac/dc,australis,kohgiluyeh,boreal,goths,authoring,intoxicated,nonpartisan,theodosius,pyongyang,shree,boyhood,sanfl,plenipotentiary,photosynthesis,presidium,sinaloa,honshu,texan,avenida,transmembrane,malays,acropolis,catalunya,vases,inconsistencies,methodists,quell,suisse,banat,simcoe,cercle,zealanders,discredited,equine,sages,parthian,fascists,interpolation,classifying,spinoff,yehuda,cruised,gypsum,foaled,wallachia,saraswati,imperialist,seabed,footnotes,nakajima,locales,schoolmaster,drosophila,bridgehead,immanuel,courtier,bookseller,niccolo,stylistically,portmanteau,superleague,konkani,millimetres,arboreal,thanjavur,emulation,sounders,decompression,commoners,infusion,methodological,osage,rococo,anchoring,bayreuth,formula_27,abstracting,symbolized,bayonne,electrolyte,rowed,corvettes,traversing,editorship,sampler,presidio,curzon,adirondack,swahili,rearing,bladed,lemur,pashtun,behaviours,bottling,zaire,recognisable,systematics,leeward,formulae,subdistricts,smithfield,vijaya,buoyancy,boosting,cantonal,rishi,airflow,kamakura,adana,emblems,aquifer,clustering,husayn,woolly,wineries,montessori,turntable,exponentially,caverns,espoused,pianists,vorpommern,vicenza,latterly,o'rourke,williamstown,generale,kosice,duisburg,poirot,marshy,mismanagement,mandalay,dagenham,universes,chiral,radiated,stewards,vegan,crankshaft,kyrgyz,amphibian,cymbals,infrequently,offenbach,environmentalist,repatriated,permutations,midshipmen,loudoun,refereed,bamberg,ornamented,nitric,selim,translational,dorsum,annunciation,gippsland,reflector,informational,regia,reactionary,ahmet,weathering,erlewine,legalized,berne,occupant,divas,manifests,analyzes,disproportionate,mitochondria,totalitarian,paulista,interscope,anarcho,correlate,brookfield,elongate,brunel,ordinal,precincts,volatility,equaliser,hittite,somaliland,ticketing,monochrome,ubuntu,chhattisgarh,titleholder,ranches,referendums,blooms,accommodates,merthyr,religiously,ryukyu,tumultuous,checkpoints,anode,mi'kmaq,cannonball,punctuation,remodelled,assassinations,criminology,alternates,yonge,pixar,namibian,piraeus,trondelag,hautes,lifeboats,shoal,atelier,vehemently,sadat,postcode,jainism,lycoming,undisturbed,lutherans,genomics,popmatters,tabriz,isthmian,notched,autistic,horsham,mites,conseil,bloomsbury,seung,cybertron,idris,overhauled,disbandment,idealized,goldfields,worshippers,lobbyist,ailments,paganism,herbarium,athenians,messerschmitt,faraday,entangled,'olya,untreated,criticising,howitzers,parvati,lobed,debussy,atonement,tadeusz,permeability,mueang,sepals,degli,optionally,fuelled,follies,asterisk,pristina,lewiston,congested,overpass,affixed,pleads,telecasts,stanislaus,cryptographic,friesland,hamstring,selkirk,antisubmarine,inundated,overlay,aggregates,fleur,trolleybus,sagan,ibsen,inductees,beltway,tiled,ladders,cadbury,laplace,ascetic,micronesia,conveying,bellingham,cleft,batches,usaid,conjugation,macedon,assisi,reappointed,brine,jinnah,prairies,screenwriting,oxidized,despatches,linearly,fertilizers,brazilians,absorbs,wagga,modernised,scorsese,ashraf,charlestown,esque,habitable,nizhny,lettres,tuscaloosa,esplanade,coalitions,carbohydrates,legate,vermilion,standardised,galleria,psychoanalytic,rearrangement,substation,competency,nationalised,reshuffle,reconstructions,mehdi,bougainville,receivership,contraception,enlistment,conducive,aberystwyth,solicitors,dismisses,fibrosis,montclair,homeowner,surrealism,s.h.i.e.l.d,peregrine,compilers,1790s,parentage,palmas,rzeszow,worldview,eased,svenska,housemate,bundestag,originator,enlisting,outwards,reciprocity,formula_28,carbohydrate,democratically,firefighting,romagna,acknowledgement,khomeini,carbide,quests,vedas,characteristically,guwahati,brixton,unintended,brothels,parietal,namur,sherbrooke,moldavian,baruch,milieu,undulating,laurier,entre,dijon,ethylene,abilene,heracles,paralleling,ceres,dundalk,falun,auspicious,chisinau,polarity,foreclosure,templates,ojibwe,punic,eriksson,biden,bachchan,glaciation,spitfires,norsk,nonviolent,heidegger,algonquin,capacitance,cassettes,balconies,alleles,airdate,conveys,replays,classifies,infrequent,amine,cuttings,rarer,woking,olomouc,amritsar,rockabilly,illyrian,maoist,poignant,tempore,stalinist,segmented,bandmate,mollusc,muhammed,totalled,byrds,tendered,endogenous,kottayam,aisne,oxidase,overhears,illustrators,verve,commercialization,purplish,directv,moulded,lyttelton,baptismal,captors,saracens,georgios,shorten,polity,grids,fitzwilliam,sculls,impurities,confederations,akhtar,intangible,oscillations,parabolic,harlequin,maulana,ovate,tanzanian,singularity,confiscation,qazvin,speyer,phonemes,overgrown,vicarage,gurion,undocumented,niigata,thrones,preamble,stave,interment,liiga,ataturk,aphrodite,groupe,indentured,habsburgs,caption,utilitarian,ozark,slovenes,reproductions,plasticity,serbo,dulwich,castel,barbuda,salons,feuding,lenape,wikileaks,swamy,breuning,shedding,afield,superficially,operationally,lamented,okanagan,hamadan,accolade,furthering,adolphus,fyodor,abridged,cartoonists,pinkish,suharto,cytochrome,methylation,debit,colspan=9|,refine,taoist,signalled,herding,leaved,bayan,fatherland,rampart,sequenced,negation,storyteller,occupiers,barnabas,pelicans,nadir,conscripted,railcars,prerequisite,furthered,columba,carolinas,markup,gwalior,franche,chaco,eglinton,ramparts,rangoon,metabolites,pollination,croat,televisa,holyoke,testimonial,setlist,safavid,sendai,georgians,shakespearean,galleys,regenerative,krzysztof,overtones,estado,barbary,cherbourg,obispo,sayings,composites,sainsbury,deliberation,cosmological,mahalleh,embellished,ascap,biala,pancras,calumet,grands,canvases,antigens,marianas,defenseman,approximated,seedlings,soren,stele,nuncio,immunology,testimonies,glossary,recollections,suitability,tampere,venous,cohomology,methanol,echoing,ivanovich,warmly,sterilization,imran,multiplying,whitechapel,undersea,xuanzong,tacitus,bayesian,roundhouse,correlations,rioters,molds,fiorentina,bandmates,mezzo,thani,guerilla,200th,premiums,tamils,deepwater,chimpanzees,tribesmen,selwyn,globo,turnovers,punctuated,erode,nouvelle,banbury,exponents,abolishing,helical,maimonides,endothelial,goteborg,infield,encroachment,cottonwood,mazowiecki,parable,saarbrucken,reliever,epistemology,artistes,enrich,rationing,formula_29,palmyra,subfamilies,kauai,zoran,fieldwork,arousal,creditor,friuli,celts,comoros,equated,escalation,negev,tallied,inductive,anion,netanyahu,mesoamerican,lepidoptera,aspirated,remit,westmorland,italic,crosse,vaclav,fuego,owain,balmain,venetians,ethnicities,deflected,ticino,apulia,austere,flycatcher,reprising,repressive,hauptbahnhof,subtype,ophthalmology,summarizes,eniwetok,colonisation,subspace,nymphalidae,earmarked,tempe,burnet,crests,abbots,norwegians,enlarge,ashoka,frankfort,livorno,malware,renters,singly,iliad,moresby,rookies,gustavus,affirming,alleges,legume,chekhov,studded,abdicated,suzhou,isidore,townsite,repayment,quintus,yankovic,amorphous,constructor,narrowing,industrialists,tanganyika,capitalization,connective,mughals,rarities,aerodynamics,worthing,antalya,diagnostics,shaftesbury,thracian,obstetrics,benghazi,multiplier,orbitals,livonia,roscommon,intensify,ravel,oaths,overseer,locomotion,necessities,chickasaw,strathclyde,treviso,erfurt,aortic,contemplation,accrington,markazi,predeceased,hippocampus,whitecaps,assemblyman,incursion,ethnography,extraliga,reproducing,directorship,benzene,byway,stupa,taxable,scottsdale,onondaga,favourably,countermeasures,lithuanians,thatched,deflection,tarsus,consuls,annuity,paralleled,contextual,anglian,klang,hoisted,multilingual,enacting,samaj,taoiseach,carthaginian,apologised,hydrology,entrant,seamless,inflorescences,mugabe,westerners,seminaries,wintering,penzance,mitre,sergeants,unoccupied,delimitation,discriminate,upriver,abortive,nihon,bessarabia,calcareous,buffaloes,patil,daegu,streamline,berks,chaparral,laity,conceptions,typified,kiribati,threaded,mattel,eccentricity,signified,patagonia,slavonia,certifying,adnan,astley,sedition,minimally,enumerated,nikos,goalless,walid,narendra,causa,missoula,coolant,dalek,outcrop,hybridization,schoolchildren,peasantry,afghans,confucianism,shahr,gallic,tajik,kierkegaard,sauvignon,commissar,patriarchs,tuskegee,prussians,laois,ricans,talmudic,officiating,aesthetically,baloch,antiochus,separatists,suzerainty,arafat,shading,u.s.c,chancellors,inc..,toolkit,nepenthes,erebidae,solicited,pratap,kabbalah,alchemist,caltech,darjeeling,biopic,spillway,kaiserslautern,nijmegen,bolstered,neath,pahlavi,eugenics,bureaus,retook,northfield,instantaneous,deerfield,humankind,selectivity,putative,boarders,cornhuskers,marathas,raikkonen,aliabad,mangroves,garages,gulch,karzai,poitiers,chernobyl,thane,alexios,belgrano,scion,solubility,urbanized,executable,guizhou,nucleic,tripled,equalled,harare,houseguests,potency,ghazi,repeater,overarching,regrouped,broward,ragtime,d'art,nandi,regalia,campsites,mamluk,plating,wirral,presumption,zenit,archivist,emmerdale,decepticon,carabidae,kagoshima,franconia,guarani,formalism,diagonally,submarginal,denys,walkways,punts,metrolink,hydrographic,droplets,upperside,martyred,hummingbird,antebellum,curiously,mufti,friary,chabad,czechs,shaykh,reactivity,berklee,turbonilla,tongan,sultans,woodville,unlicensed,enmity,dominicans,operculum,quarrying,watercolour,catalyzed,gatwick,'what,mesozoic,auditors,shizuoka,footballing,haldane,telemundo,appended,deducted,disseminate,o'shea,pskov,abrasive,entente,gauteng,calicut,lemurs,elasticity,suffused,scopula,staining,upholding,excesses,shostakovich,loanwords,naidu,championnat,chromatography,boasting,goaltenders,engulfed,salah,kilogram,morristown,shingles,shi'a,labourer,renditions,frantisek,jekyll,zonal,nanda,sheriffs,eigenvalues,divisione,endorsing,ushered,auvergne,cadres,repentance,freemasons,utilising,laureates,diocletian,semiconductors,o'grady,vladivostok,sarkozy,trackage,masculinity,hydroxyl,mervyn,muskets,speculations,gridiron,opportunistic,mascots,aleutian,fillies,sewerage,excommunication,borrowers,capillary,trending,sydenham,synthpop,rajah,cagayan,deportes,kedah,faure,extremism,michoacan,levski,culminates,occitan,bioinformatics,unknowingly,inciting,emulated,footpaths,piacenza,dreadnought,viceroyalty,oceanographic,scouted,combinatorial,ornithologist,cannibalism,mujahideen,independiente,cilicia,hindwing,minimized,odeon,gyorgy,rubles,purchaser,collieries,kickers,interurban,coiled,lynchburg,respondent,plzen,detractors,etchings,centering,intensification,tomography,ranjit,warblers,retelling,reinstatement,cauchy,modulus,redirected,evaluates,beginner,kalateh,perforated,manoeuvre,scrimmage,internships,megawatts,mottled,haakon,tunbridge,kalyan,summarised,sukarno,quetta,canonized,henryk,agglomeration,coahuila,diluted,chiropractic,yogyakarta,talladega,sheik,cation,halting,reprisals,sulfuric,musharraf,sympathizers,publicised,arles,lectionary,fracturing,startups,sangha,latrobe,rideau,ligaments,blockading,cremona,lichens,fabaceae,modulated,evocative,embodies,battersea,indistinct,altai,subsystem,acidity,somatic,formula_30,tariq,rationality,sortie,ashlar,pokal,cytoplasmic,valour,bangla,displacing,hijacking,spectrometry,westmeath,weill,charing,goias,revolvers,individualized,tenured,nawaz,piquet,chanted,discard,bernd,phalanx,reworking,unilaterally,subclass,yitzhak,piloting,circumvent,disregarded,semicircular,viscous,tibetans,endeavours,retaliated,cretan,vienne,workhouse,sufficiency,aurangzeb,legalization,lipids,expanse,eintracht,sanjak,megas,125th,bahraini,yakima,eukaryotes,thwart,affirmation,peloponnese,retailing,carbonyl,chairwoman,macedonians,dentate,rockaway,correctness,wealthier,metamorphic,aragonese,fermanagh,pituitary,schrodinger,evokes,spoiler,chariots,akita,genitalia,combe,confectionery,desegregation,experiential,commodores,persepolis,viejo,restorations,virtualization,hispania,printmaking,stipend,yisrael,theravada,expended,radium,tweeted,polygonal,lippe,charente,leveraged,cutaneous,fallacy,fragrant,bypasses,elaborately,rigidity,majid,majorca,kongo,plasmodium,skits,audiovisual,eerste,staircases,prompts,coulthard,northwestward,riverdale,beatrix,copyrights,prudential,communicates,mated,obscenity,asynchronous,analyse,hansa,searchlight,farnborough,patras,asquith,qarah,contours,fumbled,pasteur,redistributed,almeria,sanctuaries,jewry,israelite,clinicians,koblenz,bookshop,affective,goulburn,panelist,sikorsky,cobham,mimics,ringed,portraiture,probabilistic,girolamo,intelligible,andalusian,jalal,athenaeum,eritrean,auxiliaries,pittsburg,devolution,sangam,isolating,anglers,cronulla,annihilated,kidderminster,synthesize,popularised,theophilus,bandstand,innumerable,chagrin,retroactively,weser,multiples,birdlife,goryeo,pawnee,grosser,grappling,tactile,ahmadinejad,turboprop,erdogan,matchday,proletarian,adhering,complements,austronesian,adverts,luminaries,archeology,impressionism,conifer,sodomy,interracial,platoons,lessen,postings,pejorative,registrations,cookery,persecutions,microbes,audits,idiosyncratic,subsp,suspensions,restricts,colouring,ratify,instrumentals,nucleotides,sulla,posits,bibliotheque,diameters,oceanography,instigation,subsumed,submachine,acceptor,legation,borrows,sedge,discriminated,loaves,insurers,highgate,detectable,abandons,kilns,sportscaster,harwich,iterations,preakness,arduous,tensile,prabhu,shortwave,philologist,shareholding,vegetative,complexities,councilors,distinctively,revitalize,automaton,amassing,montreux,khanh,surabaya,nurnberg,pernambuco,cuisines,charterhouse,firsts,tercera,inhabitant,homophobia,naturalism,einar,powerplant,coruna,entertainments,whedon,rajputs,raton,democracies,arunachal,oeuvre,wallonia,jeddah,trolleybuses,evangelism,vosges,kiowa,minimise,encirclement,undertakes,emigrant,beacons,deepened,grammars,publius,preeminent,seyyed,repechage,crafting,headingley,osteopathic,lithography,hotly,bligh,inshore,betrothed,olympians,formula_31,dissociation,trivandrum,arran,petrovic,stettin,disembarked,simplification,bronzes,philo,acrobatic,jonsson,conjectured,supercharged,kanto,detects,cheeses,correlates,harmonics,lifecycle,sudamericana,reservists,decayed,elitserien,parametric,113th,dusky,hogarth,modulo,symbiotic,monopolies,discontinuation,converges,southerners,tucuman,eclipses,enclaves,emits,famicom,caricatures,artistically,levelled,mussels,erecting,mouthparts,cunard,octaves,crucible,guardia,unusable,lagrangian,droughts,ephemeral,pashto,canis,tapering,sasebo,silurian,metallurgical,outscored,evolves,reissues,sedentary,homotopy,greyhawk,reagents,inheriting,onshore,tilting,rebuffed,reusable,naturalists,basingstoke,insofar,offensives,dravidian,curators,planks,rajan,isoforms,flagstaff,preside,globular,egalitarian,linkages,biographers,goalscorers,molybdenum,centralised,nordland,jurists,ellesmere,rosberg,hideyoshi,restructure,biases,borrower,scathing,redress,tunnelling,workflow,magnates,mahendra,dissenters,plethora,transcriptions,handicrafts,keyword,xi'an,petrograd,unser,prokofiev,90deg,madan,bataan,maronite,kearny,carmarthen,termini,consulates,disallowed,rockville,bowery,fanzine,docklands,bests,prohibitions,yeltsin,selassie,naturalization,realisation,dispensary,tribeca,abdulaziz,pocahontas,stagnation,pamplona,cuneiform,propagating,subsurface,christgau,epithelium,schwerin,lynching,routledge,hanseatic,upanishad,glebe,yugoslavian,complicity,endowments,girona,mynetworktv,entomology,plinth,ba'ath,supercup,torus,akkadian,salted,englewood,commandery,belgaum,prefixed,colorless,dartford,enthroned,caesarea,nominative,sandown,safeguards,hulled,formula_32,leamington,dieppe,spearhead,generalizations,demarcation,llanelli,masque,brickwork,recounting,sufism,strikingly,petrochemical,onslow,monologues,emigrating,anderlecht,sturt,hossein,sakhalin,subduction,novices,deptford,zanjan,airstrikes,coalfield,reintroduction,timbaland,hornby,messianic,stinging,universalist,situational,radiocarbon,strongman,rowling,saloons,traffickers,overran,fribourg,cambrai,gravesend,discretionary,finitely,archetype,assessor,pilipinas,exhumed,invocation,interacted,digitized,timisoara,smelter,teton,sexism,precepts,srinagar,pilsudski,carmelite,hanau,scoreline,hernando,trekking,blogging,fanbase,wielded,vesicles,nationalization,banja,rafts,motoring,luang,takeda,girder,stimulates,histone,sunda,nanoparticles,attains,jumpers,catalogued,alluding,pontus,ancients,examiners,shinkansen,ribbentrop,reimbursement,pharmacological,ramat,stringed,imposes,cheaply,transplanted,taiping,mizoram,looms,wallabies,sideman,kootenay,encased,sportsnet,revolutionized,tangier,benthic,runic,pakistanis,heatseekers,shyam,mishnah,presbyterians,stadt,sutras,straddles,zoroastrian,infer,fueling,gymnasts,ofcom,gunfight,journeyman,tracklist,oshawa,ps500,pa'in,mackinac,xiongnu,mississippian,breckinridge,freemason,bight,autoroute,liberalization,distantly,thrillers,solomons,presumptive,romanization,anecdotal,bohemians,unpaved,milder,concurred,spinners,alphabets,strenuous,rivieres,kerrang,mistreatment,dismounted,intensively,carlist,dancehall,shunting,pluralism,trafficked,brokered,bonaventure,bromide,neckar,designates,malian,reverses,sotheby,sorghum,serine,environmentalists,languedoc,consulship,metering,bankstown,handlers,militiamen,conforming,regularity,pondicherry,armin,capsized,consejo,capitalists,drogheda,granular,purged,acadians,endocrine,intramural,elicit,terns,orientations,miklos,omitting,apocryphal,slapstick,brecon,pliocene,affords,typography,emigre,tsarist,tomasz,beset,nishi,necessitating,encyclical,roleplaying,journeyed,inflow,sprints,progressives,novosibirsk,cameroonian,ephesus,speckled,kinshasa,freiherr,burnaby,dalmatian,torrential,rigor,renegades,bhakti,nurburgring,cosimo,convincingly,reverting,visayas,lewisham,charlottetown,charadriiformesfamily,transferable,jodhpur,converters,deepening,camshaft,underdeveloped,protease,polonia,uterine,quantify,tobruk,dealerships,narasimha,fortran,inactivity,1780s,victors,categorised,naxos,workstation,skink,sardinian,chalice,precede,dammed,sondheim,phineas,tutored,sourcing,uncompromising,placer,tyneside,courtiers,proclaims,pharmacies,hyogo,booksellers,sengoku,kursk,spectrometer,countywide,wielkopolski,bobsleigh,shetty,llywelyn,consistory,heretics,guinean,cliches,individualism,monolithic,imams,usability,bursa,deliberations,railings,torchwood,inconsistency,balearic,stabilizer,demonstrator,facet,radioactivity,outboard,educates,d'oyly,heretical,handover,jurisdictional,shockwave,hispaniola,conceptually,routers,unaffiliated,trentino,formula_33,cypriots,intervenes,neuchatel,formulating,maggiore,delisted,alcohols,thessaly,potable,estimator,suborder,fluency,mimicry,clergymen,infrastructures,rivals.com,baroda,subplot,majlis,plano,clinching,connotation,carinae,savile,intercultural,transcriptional,sandstones,ailerons,annotations,impresario,heinkel,scriptural,intermodal,astrological,ribbed,northeastward,posited,boers,utilise,kalmar,phylum,breakwater,skype,textured,guideline,azeri,rimini,massed,subsidence,anomalous,wolfsburg,polyphonic,accrediting,vodacom,kirov,captaining,kelantan,logie,fervent,eamon,taper,bundeswehr,disproportionately,divination,slobodan,pundits,hispano,kinetics,reunites,makati,ceasing,statistician,amending,chiltern,eparchy,riverine,melanoma,narragansett,pagans,raged,toppled,breaching,zadar,holby,dacian,ochre,velodrome,disparities,amphoe,sedans,webpage,williamsport,lachlan,groton,baring,swastika,heliport,unwillingness,razorbacks,exhibitors,foodstuffs,impacting,tithe,appendages,dermot,subtypes,nurseries,balinese,simulating,stary,remakes,mundi,chautauqua,geologically,stockade,hakka,dilute,kalimantan,pahang,overlapped,fredericton,baha'u'llah,jahangir,damping,benefactors,shomali,triumphal,cieszyn,paradigms,shielded,reggaeton,maharishi,zambian,shearing,golestan,mirroring,partitioning,flyover,songbook,incandescent,merrimack,huguenots,sangeet,vulnerabilities,trademarked,drydock,tantric,honoris,queenstown,labelling,iterative,enlists,statesmen,anglicans,herge,qinghai,burgundian,islami,delineated,zhuge,aggregated,banknote,qatari,suitably,tapestries,asymptotic,charleroi,majorities,pyramidellidae,leanings,climactic,tahir,ramsar,suppressor,revisionist,trawler,ernakulam,penicillium,categorization,slits,entitlement,collegium,earths,benefice,pinochet,puritans,loudspeaker,stockhausen,eurocup,roskilde,alois,jaroslav,rhondda,boutiques,vigor,neurotransmitter,ansar,malden,ferdinando,sported,relented,intercession,camberwell,wettest,thunderbolts,positional,oriel,cloverleaf,penalized,shoshone,rajkumar,completeness,sharjah,chromosomal,belgians,woolen,ultrasonic,sequentially,boleyn,mordella,microsystems,initiator,elachista,mineralogy,rhododendron,integrals,compostela,hamza,sawmills,stadio,berlioz,maidens,stonework,yachting,tappeh,myocardial,laborer,workstations,costumed,nicaea,lanark,roundtable,mashhad,nablus,algonquian,stuyvesant,sarkar,heroines,diwan,laments,intonation,intrigues,almaty,feuded,grandes,algarve,rehabilitate,macrophages,cruciate,dismayed,heuristic,eliezer,kozhikode,covalent,finalised,dimorphism,yaroslavl,overtaking,leverkusen,middlebury,feeders,brookings,speculates,insoluble,lodgings,jozsef,cysteine,shenyang,habilitation,spurious,brainchild,mtdna,comique,albedo,recife,partick,broadening,shahi,orientated,himalaya,swabia,palme,mennonites,spokeswoman,conscripts,sepulchre,chartres,eurozone,scaffold,invertebrate,parishad,bagan,heian,watercolors,basse,supercomputer,commences,tarragona,plainfield,arthurian,functor,identically,murex,chronicling,pressings,burrowing,histoire,guayaquil,goalkeeping,differentiable,warburg,machining,aeneas,kanawha,holocene,ramesses,reprisal,qingdao,avatars,turkestan,cantatas,besieging,repudiated,teamsters,equipping,hydride,ahmadiyya,euston,bottleneck,computations,terengganu,kalinga,stela,rediscovery,'this,azhar,stylised,karelia,polyethylene,kansai,motorised,lounges,normalization,calculators,1700s,goalkeepers,unfolded,commissary,cubism,vignettes,multiverse,heaters,briton,sparingly,childcare,thorium,plock,riksdag,eunuchs,catalysis,limassol,perce,uncensored,whitlam,ulmus,unites,mesopotamian,refraction,biodiesel,forza,fulda,unseated,mountbatten,shahrak,selenium,osijek,mimicking,antimicrobial,axons,simulcasting,donizetti,swabian,sportsmen,hafiz,neared,heraclius,locates,evaded,subcarpathian,bhubaneswar,negeri,jagannath,thaksin,aydin,oromo,lateran,goldsmiths,multiculturalism,cilia,mihai,evangelists,lorient,qajar,polygons,vinod,mechanised,anglophone,prefabricated,mosses,supervillain,airliners,biofuels,iodide,innovators,valais,wilberforce,logarithm,intelligentsia,dissipation,sanctioning,duchies,aymara,porches,simulators,mostar,telepathic,coaxial,caithness,burghs,fourths,stratification,joaquim,scribes,meteorites,monarchist,germination,vries,desiring,replenishment,istria,winemaking,tammany,troupes,hetman,lanceolate,pelagic,triptych,primeira,scant,outbound,hyphae,denser,bentham,basie,normale,executes,ladislaus,kontinental,herat,cruiserweight,activision,customization,manoeuvres,inglewood,northwood,waveform,investiture,inpatient,alignments,kiryat,rabat,archimedes,ustad,monsanto,archetypal,kirkby,sikhism,correspondingly,catskill,overlaid,petrels,widowers,unicameral,federalists,metalcore,gamerankings,mussel,formula_34,lymphocytes,cystic,southgate,vestiges,immortals,kalam,strove,amazons,pocono,sociologists,sopwith,adheres,laurens,caregivers,inspecting,transylvanian,rebroadcast,rhenish,miserables,pyrams,blois,newtonian,carapace,redshirt,gotland,nazir,unilever,distortions,linebackers,federalism,mombasa,lumen,bernoulli,favouring,aligarh,denounce,steamboats,dnieper,stratigraphic,synths,bernese,umass,icebreaker,guanajuato,heisenberg,boldly,diodes,ladakh,dogmatic,scriptwriter,maritimes,battlestar,symposia,adaptable,toluca,bhavan,nanking,ieyasu,picardy,soybean,adalbert,brompton,deutsches,brezhnev,glandular,laotian,hispanicized,ibadan,personification,dalit,yamuna,regio,dispensed,yamagata,zweibrucken,revising,fandom,stances,participle,flavours,khitan,vertebral,crores,mayaguez,dispensation,guntur,undefined,harpercollins,unionism,meena,leveling,philippa,refractory,telstra,judea,attenuation,pylons,elaboration,elegy,edging,gracillariidae,residencies,absentia,reflexive,deportations,dichotomy,stoves,sanremo,shimon,menachem,corneal,conifers,mordellidae,facsimile,diagnoses,cowper,citta,viticulture,divisive,riverview,foals,mystics,polyhedron,plazas,airspeed,redgrave,motherland,impede,multiplicity,barrichello,airships,pharmacists,harvester,clays,payloads,differentiating,popularize,caesars,tunneling,stagnant,circadian,indemnity,sensibilities,musicology,prefects,serfs,metra,lillehammer,carmarthenshire,kiosks,welland,barbican,alkyl,tillandsia,gatherers,asociacion,showings,bharati,brandywine,subversion,scalable,pfizer,dawla,barium,dardanelles,nsdap,konig,ayutthaya,hodgkin,sedimentation,completions,purchasers,sponsorships,maximizing,banked,taoism,minot,enrolls,fructose,aspired,capuchin,outages,artois,carrollton,totality,osceola,pawtucket,fontainebleau,converged,queretaro,competencies,botha,allotments,sheaf,shastri,obliquely,banding,catharines,outwardly,monchengladbach,driest,contemplative,cassini,ranga,pundit,kenilworth,tiananmen,disulfide,formula_35,townlands,codice_3,looping,caravans,rachmaninoff,segmentation,fluorine,anglicised,gnostic,dessau,discern,reconfigured,altrincham,rebounding,battlecruiser,ramblers,1770s,convective,triomphe,miyagi,mourners,instagram,aloft,breastfeeding,courtyards,folkestone,changsha,kumamoto,saarland,grayish,provisionally,appomattox,uncial,classicism,mahindra,elapsed,supremes,monophyletic,cautioned,formula_36,noblewoman,kernels,sucre,swaps,bengaluru,grenfell,epicenter,rockhampton,worshipful,licentiate,metaphorical,malankara,amputated,wattle,palawan,tankobon,nobunaga,polyhedra,transduction,jilin,syrians,affinities,fluently,emanating,anglicized,sportscar,botanists,altona,dravida,chorley,allocations,kunming,luanda,premiering,outlived,mesoamerica,lingual,dissipating,impairments,attenborough,balustrade,emulator,bakhsh,cladding,increments,ascents,workington,qal'eh,winless,categorical,petrel,emphasise,dormer,toros,hijackers,telescopic,solidly,jankovic,cession,gurus,madoff,newry,subsystems,northside,talib,englishmen,farnese,holographic,electives,argonne,scrivener,predated,brugge,nauvoo,catalyses,soared,siddeley,graphically,powerlifting,funicular,sungai,coercive,fusing,uncertainties,locos,acetic,diverge,wedgwood,dressings,tiebreaker,didactic,vyacheslav,acreage,interplanetary,battlecruisers,sunbury,alkaloids,hairpin,automata,wielkie,interdiction,plugins,monkees,nudibranch,esporte,approximations,disabling,powering,characterisation,ecologically,martinsville,termen,perpetuated,lufthansa,ascendancy,motherboard,bolshoi,athanasius,prunus,dilution,invests,nonzero,mendocino,charan,banque,shaheed,counterculture,unita,voivode,hospitalization,vapour,supermarine,resistor,steppes,osnabruck,intermediates,benzodiazepines,sunnyside,privatized,geopolitical,ponta,beersheba,kievan,embody,theoretic,sangh,cartographer,blige,rotors,thruway,battlefields,discernible,demobilized,broodmare,colouration,sagas,policymakers,serialization,augmentation,hoare,frankfurter,transnistria,kinases,detachable,generational,converging,antiaircraft,khaki,bimonthly,coadjutor,arkhangelsk,kannur,buffers,livonian,northwich,enveloped,cysts,yokozuna,herne,beeching,enron,virginian,woollen,excepting,competitively,outtakes,recombinant,hillcrest,clearances,pathe,cumbersome,brasov,u.s.a,likud,christiania,cruciform,hierarchies,wandsworth,lupin,resins,voiceover,sitar,electrochemical,mediacorp,typhus,grenadiers,hepatic,pompeii,weightlifter,bosniak,oxidoreductase,undersecretary,rescuers,ranji,seleucid,analysing,exegesis,tenancy,toure,kristiansand,110th,carillon,minesweepers,poitou,acceded,palladian,redevelop,naismith,rifled,proletariat,shojo,hackensack,harvests,endpoint,kuban,rosenborg,stonehenge,authorisation,jacobean,revocation,compatriots,colliding,undetermined,okayama,acknowledgment,angelou,fresnel,chahar,ethereal,mg/kg,emmet,mobilised,unfavourable,cultura,characterizing,parsonage,skeptics,expressways,rabaul,medea,guardsmen,visakhapatnam,caddo,homophobic,elmwood,encircling,coexistence,contending,seljuk,mycologist,infertility,moliere,insolvent,covenants,underpass,holme,landesliga,workplaces,delinquency,methamphetamine,contrived,tableau,tithes,overlying,usurped,contingents,spares,oligocene,molde,beatification,mordechai,balloting,pampanga,navigators,flowered,debutant,codec,orogeny,newsletters,solon,ambivalent,ubisoft,archdeaconry,harpers,kirkus,jabal,castings,kazhagam,sylhet,yuwen,barnstaple,amidships,causative,isuzu,watchtower,granules,canaveral,remuneration,insurer,payout,horizonte,integrative,attributing,kiwis,skanderbeg,asymmetry,gannett,urbanism,disassembled,unaltered,precluded,melodifestivalen,ascends,plugin,gurkha,bisons,stakeholder,industrialisation,abbotsford,sextet,bustling,uptempo,slavia,choreographers,midwives,haram,javed,gazetteer,subsection,natively,weighting,lysine,meera,redbridge,muchmusic,abruzzo,adjoins,unsustainable,foresters,kbit/s,cosmopterigidae,secularism,poetics,causality,phonograph,estudiantes,ceausescu,universitario,adjoint,applicability,gastropods,nagaland,kentish,mechelen,atalanta,woodpeckers,lombards,gatineau,romansh,avraham,acetylcholine,perturbation,galois,wenceslaus,fuzhou,meandering,dendritic,sacristy,accented,katha,therapeutics,perceives,unskilled,greenhouses,analogues,chaldean,timbre,sloped,volodymyr,sadiq,maghreb,monogram,rearguard,caucuses,mures,metabolite,uyezd,determinism,theosophical,corbet,gaels,disruptions,bicameral,ribosomal,wolseley,clarksville,watersheds,tarsi,radon,milanese,discontinuous,aristotelian,whistleblower,representational,hashim,modestly,localised,atrial,hazara,ravana,troyes,appointees,rubus,morningside,amity,aberdare,ganglia,wests,zbigniew,aerobatic,depopulated,corsican,introspective,twinning,hardtop,shallower,cataract,mesolithic,emblematic,graced,lubrication,republicanism,voronezh,bastions,meissen,irkutsk,oboes,hokkien,sprites,tenet,individualist,capitulated,oakville,dysentery,orientalist,hillsides,keywords,elicited,incised,lagging,apoel,lengthening,attractiveness,marauders,sportswriter,decentralization,boltzmann,contradicts,draftsman,precipitate,solihull,norske,consorts,hauptmann,riflemen,adventists,syndromes,demolishing,customize,continuo,peripherals,seamlessly,linguistically,bhushan,orphanages,paraul,lessened,devanagari,quarto,responders,patronymic,riemannian,altoona,canonization,honouring,geodetic,exemplifies,republica,enzymatic,porters,fairmount,pampa,sufferers,kamchatka,conjugated,coachella,uthman,repositories,copious,headteacher,awami,phoneme,homomorphism,franconian,moorland,davos,quantified,kamloops,quarks,mayoralty,weald,peacekeepers,valerian,particulate,insiders,perthshire,caches,guimaraes,piped,grenadines,kosciuszko,trombonist,artemisia,covariance,intertidal,soybeans,beatified,ellipse,fruiting,deafness,dnipropetrovsk,accrued,zealous,mandala,causation,junius,kilowatt,bakeries,montpelier,airdrie,rectified,bungalows,toleration,debian,pylon,trotskyist,posteriorly,two-and-a-half,herbivorous,islamists,poetical,donne,wodehouse,frome,allium,assimilate,phonemic,minaret,unprofitable,darpa,untenable,leaflet,bitcoin,zahir,thresholds,argentino,jacopo,bespoke,stratified,wellbeing,shiite,basaltic,timberwolves,secrete,taunts,marathons,isomers,carre,consecrators,penobscot,pitcairn,sakha,crosstown,inclusions,impassable,fenders,indre,uscgc,jordi,retinue,logarithmic,pilgrimages,railcar,cashel,blackrock,macroscopic,aligning,tabla,trestle,certify,ronson,palps,dissolves,thickened,silicate,taman,walsingham,hausa,lowestoft,rondo,oleksandr,cuyahoga,retardation,countering,cricketing,holborn,identifiers,hells,geophysics,infighting,sculpting,balaji,webbed,irradiation,runestone,trusses,oriya,sojourn,forfeiture,colonize,exclaimed,eucharistic,lackluster,glazing,northridge,gutenberg,stipulates,macroeconomic,priori,outermost,annular,udinese,insulating,headliner,godel,polytope,megalithic,salix,sharapova,derided,muskegon,braintree,plateaus,confers,autocratic,isomer,interstitial,stamping,omits,kirtland,hatchery,evidences,intifada,111th,podgorica,capua,motivating,nuneaton,jakub,korsakov,amitabh,mundial,monrovia,gluten,predictor,marshalling,d'orleans,levers,touchscreen,brantford,fricative,banishment,descendent,antagonism,ludovico,loudspeakers,formula_37,livelihoods,manassas,steamships,dewsbury,uppermost,humayun,lures,pinnacles,dependents,lecce,clumps,observatories,paleozoic,dedicating,samiti,draughtsman,gauls,incite,infringing,nepean,pythagorean,convents,triumvirate,seigneur,gaiman,vagrant,fossa,byproduct,serrated,renfrewshire,sheltering,achaemenid,dukedom,catchers,sampdoria,platelet,bielefeld,fluctuating,phenomenology,strikeout,ethnology,prospectors,woodworking,tatra,wildfires,meditations,agrippa,fortescue,qureshi,wojciech,methyltransferase,accusative,saatchi,amerindian,volcanism,zeeland,toyama,vladimirovich,allege,polygram,redox,budgeted,advisories,nematode,chipset,starscream,tonbridge,hardening,shales,accompanist,paraded,phonographic,whitefish,sportive,audiobook,kalisz,hibernation,latif,duels,ps200,coxeter,nayak,safeguarding,cantabria,minesweeping,zeiss,dunams,catholicos,sawtooth,ontological,nicobar,bridgend,unclassified,intrinsically,hanoverian,rabbitohs,kenseth,alcalde,northumbrian,raritan,septuagint,presse,sevres,origen,dandenong,peachtree,intersected,impeded,usages,hippodrome,novara,trajectories,customarily,yardage,inflected,yanow,kalan,taverns,liguria,librettist,intermarriage,1760s,courant,gambier,infanta,ptolemaic,ukulele,haganah,sceptical,manchukuo,plexus,implantation,hilal,intersex,efficiencies,arbroath,hagerstown,adelphi,diario,marais,matti,lifes,coining,modalities,divya,bletchley,conserving,ivorian,mithridates,generative,strikeforce,laymen,toponymy,pogrom,satya,meticulously,agios,dufferin,yaakov,fortnightly,cargoes,deterrence,prefrontal,przemysl,mitterrand,commemorations,chatsworth,gurdwara,abuja,chakraborty,badajoz,geometries,artiste,diatonic,ganglion,presides,marymount,nanak,cytokines,feudalism,storks,rowers,widens,politico,evangelicals,assailants,pittsfield,allowable,bijapur,telenovelas,dichomeris,glenelg,herbivores,keita,inked,radom,fundraisers,constantius,boheme,portability,komnenos,crystallography,derrida,moderates,tavistock,fateh,spacex,disjoint,bristles,commercialized,interwoven,empirically,regius,bulacan,newsday,showa,radicalism,yarrow,pleura,sayed,structuring,cotes,reminiscences,acetyl,edicts,escalators,aomori,encapsulated,legacies,bunbury,placings,fearsome,postscript,powerfully,keighley,hildesheim,amicus,crevices,deserters,benelux,aurangabad,freeware,ioannis,carpathians,chirac,seceded,prepaid,landlocked,naturalised,yanukovych,soundscan,blotch,phenotypic,determinants,twente,dictatorial,giessen,composes,recherche,pathophysiology,inventories,ayurveda,elevating,gravestone,degeneres,vilayet,popularizing,spartanburg,bloemfontein,previewed,renunciation,genotype,ogilvy,tracery,blacklisted,emissaries,diploid,disclosures,tupolev,shinjuku,antecedents,pennine,braganza,bhattacharya,countable,spectroscopic,ingolstadt,theseus,corroborated,compounding,thrombosis,extremadura,medallions,hasanabad,lambton,perpetuity,glycol,besancon,palaiologos,pandey,caicos,antecedent,stratum,laserdisc,novitiate,crowdfunding,palatal,sorceress,dassault,toughness,celle,cezanne,vientiane,tioga,hander,crossbar,gisborne,cursor,inspectorate,serif,praia,sphingidae,nameplate,psalter,ivanovic,sitka,equalised,mutineers,sergius,outgrowth,creationism,haredi,rhizomes,predominate,undertakings,vulgate,hydrothermal,abbeville,geodesic,kampung,physiotherapy,unauthorised,asteraceae,conservationist,minoan,supersport,mohammadabad,cranbrook,mentorship,legitimately,marshland,datuk,louvain,potawatomi,carnivores,levies,lyell,hymnal,regionals,tinto,shikoku,conformal,wanganui,beira,lleida,standstill,deloitte,formula_40,corbusier,chancellery,mixtapes,airtime,muhlenberg,formula_39,bracts,thrashers,prodigious,gironde,chickamauga,uyghurs,substitutions,pescara,batangas,gregarious,gijon,paleo,mathura,pumas,proportionally,hawkesbury,yucca,kristiania,funimation,fluted,eloquence,mohun,aftermarket,chroniclers,futurist,nonconformist,branko,mannerisms,lesnar,opengl,altos,retainers,ashfield,shelbourne,sulaiman,divisie,gwent,locarno,lieder,minkowski,bivalve,redeployed,cartography,seaway,bookings,decays,ostend,antiquaries,pathogenesis,formula_38,chrysalis,esperance,valli,motogp,homelands,bridged,bloor,ghazal,vulgaris,baekje,prospector,calculates,debtors,hesperiidae,titian,returner,landgrave,frontenac,kelowna,pregame,castelo,caius,canoeist,watercolours,winterthur,superintendents,dissonance,dubstep,adorn,matic,salih,hillel,swordsman,flavoured,emitter,assays,monongahela,deeded,brazzaville,sufferings,babylonia,fecal,umbria,astrologer,gentrification,frescos,phasing,zielona,ecozone,candido,manoj,quadrilateral,gyula,falsetto,prewar,puntland,infinitive,contraceptive,bakhtiari,ohrid,socialization,tailplane,evoking,havelock,macapagal,plundering,104th,keynesian,templars,phrasing,morphologically,czestochowa,humorously,catawba,burgas,chiswick,ellipsoid,kodansha,inwards,gautama,katanga,orthopaedic,heilongjiang,sieges,outsourced,subterminal,vijayawada,hares,oration,leitrim,ravines,manawatu,cryogenic,tracklisting,about.com,ambedkar,degenerated,hastened,venturing,lobbyists,shekhar,typefaces,northcote,rugen,'good,ornithology,asexual,hemispheres,unsupported,glyphs,spoleto,epigenetic,musicianship,donington,diogo,kangxi,bisected,polymorphism,megawatt,salta,embossed,cheetahs,cruzeiro,unhcr,aristide,rayleigh,maturing,indonesians,noire,llano,ffffff,camus,purges,annales,convair,apostasy,algol,phage,apaches,marketers,aldehyde,pompidou,kharkov,forgeries,praetorian,divested,retrospectively,gornji,scutellum,bitumen,pausanias,magnification,imitations,nyasaland,geographers,floodlights,athlone,hippolyte,expositions,clarinetist,razak,neutrinos,rotax,sheykh,plush,interconnect,andalus,cladogram,rudyard,resonator,granby,blackfriars,placido,windscreen,sahel,minamoto,haida,cations,emden,blackheath,thematically,blacklist,pawel,disseminating,academical,undamaged,raytheon,harsher,powhatan,ramachandran,saddles,paderborn,capping,zahra,prospecting,glycine,chromatin,profane,banska,helmand,okinawan,dislocation,oscillators,insectivorous,foyle,gilgit,autonomic,tuareg,sluice,pollinated,multiplexed,granary,narcissus,ranchi,staines,nitra,goalscoring,midwifery,pensioners,algorithmic,meetinghouse,biblioteca,besar,narva,angkor,predate,lohan,cyclical,detainee,occipital,eventing,faisalabad,dartmoor,kublai,courtly,resigns,radii,megachilidae,cartels,shortfall,xhosa,unregistered,benchmarks,dystopian,bulkhead,ponsonby,jovanovic,accumulates,papuan,bhutanese,intuitively,gotaland,headliners,recursion,dejan,novellas,diphthongs,imbued,withstood,analgesic,amplify,powertrain,programing,maidan,alstom,affirms,eradicated,summerslam,videogame,molla,severing,foundered,gallium,atmospheres,desalination,shmuel,howmeh,catolica,bossier,reconstructing,isolates,lyase,tweets,unconnected,tidewater,divisible,cohorts,orebro,presov,furnishing,folklorist,simplifying,centrale,notations,factorization,monarchies,deepen,macomb,facilitation,hennepin,declassified,redrawn,microprocessors,preliminaries,enlarging,timeframe,deutschen,shipbuilders,patiala,ferrous,aquariums,genealogies,vieux,unrecognized,bridgwater,tetrahedral,thule,resignations,gondwana,registries,agder,dataset,felled,parva,analyzer,worsen,coleraine,columella,blockaded,polytechnique,reassembled,reentry,narvik,greys,nigra,knockouts,bofors,gniezno,slotted,hamasaki,ferrers,conferring,thirdly,domestication,photojournalist,universality,preclude,ponting,halved,thereupon,photosynthetic,ostrava,mismatch,pangasinan,intermediaries,abolitionists,transited,headings,ustase,radiological,interconnection,dabrowa,invariants,honorius,preferentially,chantilly,marysville,dialectical,antioquia,abstained,gogol,dirichlet,muricidae,symmetries,reproduces,brazos,fatwa,bacillus,ketone,paribas,chowk,multiplicative,dermatitis,mamluks,devotes,adenosine,newbery,meditative,minefields,inflection,oxfam,conwy,bystrica,imprints,pandavas,infinitesimal,conurbation,amphetamine,reestablish,furth,edessa,injustices,frankston,serjeant,4x200,khazar,sihanouk,longchamp,stags,pogroms,coups,upperparts,endpoints,infringed,nuanced,summing,humorist,pacification,ciaran,jamaat,anteriorly,roddick,springboks,faceted,hypoxia,rigorously,cleves,fatimid,ayurvedic,tabled,ratna,senhora,maricopa,seibu,gauguin,holomorphic,campgrounds,amboy,coordinators,ponderosa,casemates,ouachita,nanaimo,mindoro,zealander,rimsky,cluny,tomaszow,meghalaya,caetano,tilak,roussillon,landtag,gravitation,dystrophy,cephalopods,trombones,glens,killarney,denominated,anthropogenic,pssas,roubaix,carcasses,montmorency,neotropical,communicative,rabindranath,ordinated,separable,overriding,surged,sagebrush,conciliation,codice_4,durrani,phosphatase,qadir,votive,revitalized,taiyuan,tyrannosaurus,graze,slovaks,nematodes,environmentalism,blockhouse,illiteracy,schengen,ecotourism,alternation,conic,wields,hounslow,blackfoot,kwame,ambulatory,volhynia,hordaland,croton,piedras,rohit,drava,conceptualized,birla,illustrative,gurgaon,barisal,tutsi,dezong,nasional,polje,chanson,clarinets,krasnoyarsk,aleksandrovich,cosmonaut,d'este,palliative,midseason,silencing,wardens,durer,girders,salamanders,torrington,supersonics,lauda,farid,circumnavigation,embankments,funnels,bajnoksag,lorries,cappadocia,jains,warringah,retirees,burgesses,equalization,cusco,ganesan,algal,amazonian,lineups,allocating,conquerors,usurper,mnemonic,predating,brahmaputra,ahmadabad,maidenhead,numismatic,subregion,encamped,reciprocating,freebsd,irgun,tortoises,governorates,zionists,airfoil,collated,ajmer,fiennes,etymological,polemic,chadian,clerestory,nordiques,fluctuated,calvados,oxidizing,trailhead,massena,quarrels,dordogne,tirunelveli,pyruvate,pulsed,athabasca,sylar,appointee,serer,japonica,andronikos,conferencing,nicolaus,chemin,ascertained,incited,woodbine,helices,hospitalised,emplacements,to/from,orchestre,tyrannical,pannonia,methodism,pop/rock,shibuya,berbers,despot,seaward,westpac,separator,perpignan,alamein,judeo,publicize,quantization,ethniki,gracilis,menlo,offside,oscillating,unregulated,succumbing,finnmark,metrical,suleyman,raith,sovereigns,bundesstrasse,kartli,fiduciary,darshan,foramen,curler,concubines,calvinism,larouche,bukhara,sophomores,mohanlal,lutheranism,monomer,eamonn,'black,uncontested,immersive,tutorials,beachhead,bindings,permeable,postulates,comite,transformative,indiscriminate,hofstra,associacao,amarna,dermatology,lapland,aosta,babur,unambiguous,formatting,schoolboys,gwangju,superconducting,replayed,adherent,aureus,compressors,forcible,spitsbergen,boulevards,budgeting,nossa,annandale,perumal,interregnum,sassoon,kwajalein,greenbrier,caldas,triangulation,flavius,increment,shakhtar,nullified,pinfall,nomen,microfinance,depreciation,cubist,steeper,splendour,gruppe,everyman,chasers,campaigners,bridle,modality,percussive,darkly,capes,velar,picton,triennial,factional,padang,toponym,betterment,norepinephrine,112th,estuarine,diemen,warehousing,morphism,ideologically,pairings,immunization,crassus,exporters,sefer,flocked,bulbous,deseret,booms,calcite,bohol,elven,groot,pulau,citigroup,wyeth,modernizing,layering,pastiche,complies,printmaker,condenser,theropod,cassino,oxyrhynchus,akademie,trainings,lowercase,coxae,parte,chetniks,pentagonal,keselowski,monocoque,morsi,reticulum,meiosis,clapboard,recoveries,tinge,an/fps,revista,sidon,livre,epidermis,conglomerates,kampong,congruent,harlequins,tergum,simplifies,epidemiological,underwriting,tcp/ip,exclusivity,multidimensional,mysql,columbine,ecologist,hayat,sicilies,levees,handset,aesop,usenet,pacquiao,archiving,alexandrian,compensatory,broadsheet,annotation,bahamian,d'affaires,interludes,phraya,shamans,marmara,customizable,immortalized,ambushes,chlorophyll,diesels,emulsion,rheumatoid,voluminous,screenwriters,tailoring,sedis,runcorn,democratization,bushehr,anacostia,constanta,antiquary,sixtus,radiate,advaita,antimony,acumen,barristers,reichsbahn,ronstadt,symbolist,pasig,cursive,secessionist,afrikaner,munnetra,inversely,adsorption,syllabic,moltke,idioms,midline,olimpico,diphosphate,cautions,radziwill,mobilisation,copelatus,trawlers,unicron,bhaskar,financiers,minimalism,derailment,marxists,oireachtas,abdicate,eigenvalue,zafar,vytautas,ganguly,chelyabinsk,telluride,subordination,ferried,dived,vendee,pictish,dimitrov,expiry,carnation,cayley,magnitudes,lismore,gretna,sandwiched,unmasked,sandomierz,swarthmore,tetra,nanyang,pevsner,dehradun,mormonism,rashi,complying,seaplanes,ningbo,cooperates,strathcona,mornington,mestizo,yulia,edgbaston,palisade,ethno,polytopes,espirito,tymoshenko,pronunciations,paradoxical,taichung,chipmunks,erhard,maximise,accretion,kanda,`abdu'l,narrowest,umpiring,mycenaean,divisor,geneticist,ceredigion,barque,hobbyists,equates,auxerre,spinose,cheil,sweetwater,guano,carboxylic,archiv,tannery,cormorant,agonists,fundacion,anbar,tunku,hindrance,meerut,concordat,secunderabad,kachin,achievable,murfreesboro,comprehensively,forges,broadest,synchronised,speciation,scapa,aliyev,conmebol,tirelessly,subjugated,pillaged,udaipur,defensively,lakhs,stateless,haasan,headlamps,patterning,podiums,polyphony,mcmurdo,mujer,vocally,storeyed,mucosa,multivariate,scopus,minimizes,formalised,certiorari,bourges,populate,overhanging,gaiety,unreserved,borromeo,woolworths,isotopic,bashar,purify,vertebra,medan,juxtaposition,earthwork,elongation,chaudhary,schematic,piast,steeped,nanotubes,fouls,achaea,legionnaires,abdur,qmjhl,embraer,hardback,centerville,ilocos,slovan,whitehorse,mauritian,moulding,mapuche,donned,provisioning,gazprom,jonesboro,audley,lightest,calyx,coldwater,trigonometric,petroglyphs,psychoanalyst,congregate,zambezi,fissure,supervises,bexley,etobicoke,wairarapa,tectonics,emphasises,formula_41,debugging,linfield,spatially,ionizing,ungulates,orinoco,clades,erlangen,news/talk,vols.,ceara,yakovlev,finsbury,entanglement,fieldhouse,graphene,intensifying,grigory,keyong,zacatecas,ninian,allgemeine,keswick,societa,snorri,femininity,najib,monoclonal,guyanese,postulate,huntly,abbeys,machinist,yunus,emphasising,ishaq,urmia,bremerton,pretenders,lumiere,thoroughfares,chikara,dramatized,metathorax,taiko,transcendence,wycliffe,retrieves,umpired,steuben,racehorses,taylors,kuznetsov,montezuma,precambrian,canopies,gaozong,propodeum,disestablished,retroactive,shoreham,rhizome,doubleheader,clinician,diwali,quartzite,shabaab,agassiz,despatched,stormwater,luxemburg,callao,universidade,courland,skane,glyph,dormers,witwatersrand,curacy,qualcomm,nansen,entablature,lauper,hausdorff,lusaka,ruthenian,360deg,cityscape,douai,vaishnava,spars,vaulting,rationalist,gygax,sequestration,typology,pollinates,accelerators,leben,colonials,cenotaph,imparted,carthaginians,equaled,rostrum,gobind,bodhisattva,oberst,bicycling,arabi,sangre,biophysics,hainaut,vernal,lunenburg,apportioned,finches,lajos,nenad,repackaged,zayed,nikephoros,r.e.m,swaminarayan,gestalt,unplaced,crags,grohl,sialkot,unsaturated,gwinnett,linemen,forays,palakkad,writs,instrumentalists,aircrews,badged,terrapins,180deg,oneness,commissariat,changi,pupation,circumscribed,contador,isotropic,administrated,fiefs,nimes,intrusions,minoru,geschichte,nadph,tainan,changchun,carbondale,frisia,swapo,evesham,hawai'i,encyclopedic,transporters,dysplasia,formula_42,onsite,jindal,guetta,judgements,narbonne,permissions,paleogene,rationalism,vilna,isometric,subtracted,chattahoochee,lamina,missa,greville,pervez,lattices,persistently,crystallization,timbered,hawaiians,fouling,interrelated,masood,ripening,stasi,gamal,visigothic,warlike,cybernetics,tanjung,forfar,cybernetic,karelian,brooklands,belfort,greifswald,campeche,inexplicably,refereeing,understory,uninterested,prius,collegiately,sefid,sarsfield,categorize,biannual,elsevier,eisteddfod,declension,autonoma,procuring,misrepresentation,novelization,bibliographic,shamanism,vestments,potash,eastleigh,ionized,turan,lavishly,scilly,balanchine,importers,parlance,'that,kanyakumari,synods,mieszko,crossovers,serfdom,conformational,legislated,exclave,heathland,sadar,differentiates,propositional,konstantinos,photoshop,manche,vellore,appalachia,orestes,taiga,exchanger,grozny,invalidated,baffin,spezia,staunchly,eisenach,robustness,virtuosity,ciphers,inlets,bolagh,understandings,bosniaks,parser,typhoons,sinan,luzerne,webcomic,subtraction,jhelum,businessweek,ceske,refrained,firebox,mitigated,helmholtz,dilip,eslamabad,metalwork,lucan,apportionment,provident,gdynia,schooners,casement,danse,hajjiabad,benazir,buttress,anthracite,newsreel,wollaston,dispatching,cadastral,riverboat,provincetown,nantwich,missal,irreverent,juxtaposed,darya,ennobled,electropop,stereoscopic,maneuverability,laban,luhansk,udine,collectibles,haulage,holyrood,materially,supercharger,gorizia,shkoder,townhouses,pilate,layoffs,folkloric,dialectic,exuberant,matures,malla,ceuta,citizenry,crewed,couplet,stopover,transposition,tradesmen,antioxidant,amines,utterance,grahame,landless,isere,diction,appellant,satirist,urbino,intertoto,subiaco,antonescu,nehemiah,ubiquitin,emcee,stourbridge,fencers,103rd,wranglers,monteverdi,watertight,expounded,xiamen,manmohan,pirie,threefold,antidepressant,sheboygan,grieg,cancerous,diverging,bernini,polychrome,fundamentalism,bihari,critiqued,cholas,villers,tendulkar,dafydd,vastra,fringed,evangelization,episcopalian,maliki,sana'a,ashburton,trianon,allegany,heptathlon,insufficiently,panelists,pharrell,hexham,amharic,fertilized,plumes,cistern,stratigraphy,akershus,catalans,karoo,rupee,minuteman,quantification,wigmore,leutnant,metanotum,weeknights,iridescent,extrasolar,brechin,deuterium,kuching,lyricism,astrakhan,brookhaven,euphorbia,hradec,bhagat,vardar,aylmer,positron,amygdala,speculators,unaccompanied,debrecen,slurry,windhoek,disaffected,rapporteur,mellitus,blockers,fronds,yatra,sportsperson,precession,physiologist,weeknight,pidgin,pharma,condemns,standardize,zetian,tibor,glycoprotein,emporia,cormorants,amalie,accesses,leonhard,denbighshire,roald,116th,will.i.am,symbiosis,privatised,meanders,chemnitz,jabalpur,shing,secede,ludvig,krajina,homegrown,snippets,sasanian,euripides,peder,cimarron,streaked,graubunden,kilimanjaro,mbeki,middleware,flensburg,bukovina,lindwall,marsalis,profited,abkhaz,polis,camouflaged,amyloid,morgantown,ovoid,bodleian,morte,quashed,gamelan,juventud,natchitoches,storyboard,freeview,enumeration,cielo,preludes,bulawayo,1600s,olympiads,multicast,faunal,asura,reinforces,puranas,ziegfeld,handicraft,seamount,kheil,noche,hallmarks,dermal,colorectal,encircle,hessen,umbilicus,sunnis,leste,unwin,disclosing,superfund,montmartre,refuelling,subprime,kolhapur,etiology,bismuth,laissez,vibrational,mazar,alcoa,rumsfeld,recurve,ticonderoga,lionsgate,onlookers,homesteads,filesystem,barometric,kingswood,biofuel,belleza,moshav,occidentalis,asymptomatic,northeasterly,leveson,huygens,numan,kingsway,primogeniture,toyotomi,yazoo,limpets,greenbelt,booed,concurrence,dihedral,ventrites,raipur,sibiu,plotters,kitab,109th,trackbed,skilful,berthed,effendi,fairing,sephardi,mikhailovich,lockyer,wadham,invertible,paperbacks,alphabetic,deuteronomy,constitutive,leathery,greyhounds,estoril,beechcraft,poblacion,cossidae,excreted,flamingos,singha,olmec,neurotransmitters,ascoli,nkrumah,forerunners,dualism,disenchanted,benefitted,centrum,undesignated,noida,o'donoghue,collages,egrets,egmont,wuppertal,cleave,montgomerie,pseudomonas,srinivasa,lymphatic,stadia,resold,minima,evacuees,consumerism,ronde,biochemist,automorphism,hollows,smuts,improvisations,vespasian,bream,pimlico,eglin,colne,melancholic,berhad,ousting,saale,notaulices,ouest,hunslet,tiberias,abdomina,ramsgate,stanislas,donbass,pontefract,sucrose,halts,drammen,chelm,l'arc,taming,trolleys,konin,incertae,licensees,scythian,giorgos,dative,tanglewood,farmlands,o'keeffe,caesium,romsdal,amstrad,corte,oglethorpe,huntingdonshire,magnetization,adapts,zamosc,shooto,cuttack,centrepiece,storehouse,winehouse,morbidity,woodcuts,ryazan,buddleja,buoyant,bodmin,estero,austral,verifiable,periyar,christendom,curtail,shura,kaifeng,cotswold,invariance,seafaring,gorica,androgen,usman,seabird,forecourt,pekka,juridical,audacious,yasser,cacti,qianlong,polemical,d'amore,espanyol,distrito,cartographers,pacifism,serpents,backa,nucleophilic,overturning,duplicates,marksman,oriente,vuitton,oberleutnant,gielgud,gesta,swinburne,transfiguration,1750s,retaken,celje,fredrikstad,asuka,cropping,mansard,donates,blacksmiths,vijayanagara,anuradhapura,germinate,betis,foreshore,jalandhar,bayonets,devaluation,frazione,ablaze,abidjan,approvals,homeostasis,corollary,auden,superfast,redcliffe,luxembourgish,datum,geraldton,printings,ludhiana,honoree,synchrotron,invercargill,hurriedly,108th,three-and-a-half,colonist,bexar,limousin,bessemer,ossetian,nunataks,buddhas,rebuked,thais,tilburg,verdicts,interleukin,unproven,dordrecht,solent,acclamation,muammar,dahomey,operettas,4x400,arrears,negotiators,whitehaven,apparitions,armoury,psychoactive,worshipers,sculptured,elphinstone,airshow,kjell,o'callaghan,shrank,professorships,predominance,subhash,coulomb,sekolah,retrofitted,samos,overthrowing,vibrato,resistors,palearctic,datasets,doordarshan,subcutaneous,compiles,immorality,patchwork,trinidadian,glycogen,pronged,zohar,visigoths,freres,akram,justo,agora,intakes,craiova,playwriting,bukhari,militarism,iwate,petitioners,harun,wisla,inefficiency,vendome,ledges,schopenhauer,kashi,entombed,assesses,tenn.,noumea,baguio,carex,o'donovan,filings,hillsdale,conjectures,blotches,annuals,lindisfarne,negated,vivek,angouleme,trincomalee,cofactor,verkhovna,backfield,twofold,automaker,rudra,freighters,darul,gharana,busway,formula_43,plattsburgh,portuguesa,showrunner,roadmap,valenciennes,erdos,biafra,spiritualism,transactional,modifies,carne,107th,cocos,gcses,tiverton,radiotherapy,meadowlands,gunma,srebrenica,foxtel,authenticated,enslavement,classicist,klaipeda,minstrels,searchable,infantrymen,incitement,shiga,nadp+,urals,guilders,banquets,exteriors,counterattacks,visualized,diacritics,patrimony,svensson,transepts,prizren,telegraphy,najaf,emblazoned,coupes,effluent,ragam,omani,greensburg,taino,flintshire,cd/dvd,lobbies,narrating,cacao,seafarers,bicolor,collaboratively,suraj,floodlit,sacral,puppetry,tlingit,malwa,login,motionless,thien,overseers,vihar,golem,specializations,bathhouse,priming,overdubs,winningest,archetypes,uniao,acland,creamery,slovakian,lithographs,maryborough,confidently,excavating,stillborn,ramallah,audiencia,alava,ternary,hermits,rostam,bauxite,gawain,lothair,captions,gulfstream,timelines,receded,mediating,petain,bastia,rudbar,bidders,disclaimer,shrews,tailings,trilobites,yuriy,jamil,demotion,gynecology,rajinikanth,madrigals,ghazni,flycatchers,vitebsk,bizet,computationally,kashgar,refinements,frankford,heralds,europe/africa,levante,disordered,sandringham,queues,ransacked,trebizond,verdes,comedie,primitives,figurine,organists,culminate,gosport,coagulation,ferrying,hoyas,polyurethane,prohibitive,midfielders,ligase,progesterone,defectors,sweetened,backcountry,diodorus,waterside,nieuport,khwaja,jurong,decried,gorkha,ismaili,300th,octahedral,kindergartens,paseo,codification,notifications,disregarding,risque,reconquista,shortland,atolls,texarkana,perceval,d'etudes,kanal,herbicides,tikva,nuova,gatherer,dissented,soweto,dexterity,enver,bacharach,placekicker,carnivals,automate,maynooth,symplectic,chetnik,militaire,upanishads,distributive,strafing,championing,moiety,miliband,blackadder,enforceable,maung,dimer,stadtbahn,diverges,obstructions,coleophoridae,disposals,shamrocks,aural,banca,bahru,coxed,grierson,vanadium,watermill,radiative,ecoregions,berets,hariri,bicarbonate,evacuations,mallee,nairn,rushden,loggia,slupsk,satisfactorily,milliseconds,cariboo,reine,cyclo,pigmentation,postmodernism,aqueducts,vasari,bourgogne,dilemmas,liquefied,fluminense,alloa,ibaraki,tenements,kumasi,humerus,raghu,labours,putsch,soundcloud,bodybuilder,rakyat,domitian,pesaro,translocation,sembilan,homeric,enforcers,tombstones,lectureship,rotorua,salamis,nikolaos,inferences,superfortress,lithgow,surmised,undercard,tarnow,barisan,stingrays,federacion,coldstream,haverford,ornithological,heerenveen,eleazar,jyoti,murali,bamako,riverbed,subsidised,theban,conspicuously,vistas,conservatorium,madrasa,kingfishers,arnulf,credential,syndicalist,sheathed,discontinuity,prisms,tsushima,coastlines,escapees,vitis,optimizing,megapixel,overground,embattled,halide,sprinters,buoys,mpumalanga,peculiarities,106th,roamed,menezes,macao,prelates,papyri,freemen,dissertations,irishmen,pooled,sverre,reconquest,conveyance,subjectivity,asturian,circassian,formula_45,comdr,thickets,unstressed,monro,passively,harmonium,moveable,dinar,carlsson,elysees,chairing,b'nai,confusingly,kaoru,convolution,godolphin,facilitator,saxophones,eelam,jebel,copulation,anions,livres,licensure,pontypridd,arakan,controllable,alessandria,propelling,stellenbosch,tiber,wolka,liberators,yarns,d'azur,tsinghua,semnan,amhara,ablation,melies,tonality,historique,beeston,kahne,intricately,sonoran,robespierre,gyrus,boycotts,defaulted,infill,maranhao,emigres,framingham,paraiba,wilhelmshaven,tritium,skyway,labial,supplementation,possessor,underserved,motets,maldivian,marrakech,quays,wikimedia,turbojet,demobilization,petrarch,encroaching,sloops,masted,karbala,corvallis,agribusiness,seaford,stenosis,hieronymus,irani,superdraft,baronies,cortisol,notability,veena,pontic,cyclin,archeologists,newham,culled,concurring,aeolian,manorial,shouldered,fords,philanthropists,105th,siddharth,gotthard,halim,rajshahi,jurchen,detritus,practicable,earthenware,discarding,travelogue,neuromuscular,elkhart,raeder,zygmunt,metastasis,internees,102nd,vigour,upmarket,summarizing,subjunctive,offsets,elizabethtown,udupi,pardubice,repeaters,instituting,archaea,substandard,technische,linga,anatomist,flourishes,velika,tenochtitlan,evangelistic,fitchburg,springbok,cascading,hydrostatic,avars,occasioned,filipina,perceiving,shimbun,africanus,consternation,tsing,optically,beitar,45deg,abutments,roseville,monomers,huelva,lotteries,hypothalamus,internationalist,electromechanical,hummingbirds,fibreglass,salaried,dramatists,uncovers,invokes,earners,excretion,gelding,ancien,aeronautica,haverhill,stour,ittihad,abramoff,yakov,ayodhya,accelerates,industrially,aeroplanes,deleterious,dwelt,belvoir,harpalus,atpase,maluku,alasdair,proportionality,taran,epistemological,interferometer,polypeptide,adjudged,villager,metastatic,marshalls,madhavan,archduchess,weizmann,kalgoorlie,balan,predefined,sessile,sagaing,brevity,insecticide,psychosocial,africana,steelworks,aether,aquifers,belem,mineiro,almagro,radiators,cenozoic,solute,turbocharger,invicta,guested,buccaneer,idolatry,unmatched,paducah,sinestro,dispossessed,conforms,responsiveness,cyanobacteria,flautist,procurator,complementing,semifinalist,rechargeable,permafrost,cytokine,refuges,boomed,gelderland,franchised,jinan,burnie,doubtless,randomness,colspan=12,angra,ginebra,famers,nuestro,declarative,roughness,lauenburg,motile,rekha,issuer,piney,interceptors,napoca,gipsy,formulaic,formula_44,viswanathan,ebrahim,thessalonica,galeria,muskogee,unsold,html5,taito,mobutu,icann,carnarvon,fairtrade,morphisms,upsilon,nozzles,fabius,meander,murugan,strontium,episcopacy,sandinista,parasol,attenuated,bhima,primeval,panay,ordinator,negara,osteoporosis,glossop,ebook,paradoxically,grevillea,modoc,equating,phonetically,legumes,covariant,dorje,quatre,bruxelles,pyroclastic,shipbuilder,zhaozong,obscuring,sveriges,tremolo,extensible,barrack,multnomah,hakon,chaharmahal,parsing,volumetric,astrophysical,glottal,combinatorics,freestanding,encoder,paralysed,cavalrymen,taboos,heilbronn,orientalis,lockport,marvels,ozawa,dispositions,waders,incurring,saltire,modulate,papilio,phenol,intermedia,rappahannock,plasmid,fortify,phenotypes,transiting,correspondences,leaguer,larnaca,incompatibility,mcenroe,deeming,endeavoured,aboriginals,helmed,salar,arginine,werke,ferrand,expropriated,delimited,couplets,phoenicians,petioles,ouster,anschluss,protectionist,plessis,urchins,orquesta,castleton,juniata,bittorrent,fulani,donji,mykola,rosemont,chandos,scepticism,signer,chalukya,wicketkeeper,coquitlam,programmatic,o'brian,carteret,urology,steelhead,paleocene,konkan,bettered,venkatesh,surfacing,longitudinally,centurions,popularization,yazid,douro,widths,premios,leonards,gristmill,fallujah,arezzo,leftists,ecliptic,glycerol,inaction,disenfranchised,acrimonious,depositing,parashah,cockatoo,marechal,bolzano,chios,cablevision,impartiality,pouches,thickly,equities,bentinck,emotive,boson,ashdown,conquistadors,parsi,conservationists,reductive,newlands,centerline,ornithologists,waveguide,nicene,philological,hemel,setanta,masala,aphids,convening,casco,matrilineal,chalcedon,orthographic,hythe,replete,damming,bolivarian,admixture,embarks,borderlands,conformed,nagarjuna,blenny,chaitanya,suwon,shigeru,tatarstan,lingayen,rejoins,grodno,merovingian,hardwicke,puducherry,prototyping,laxmi,upheavals,headquarter,pollinators,bromine,transom,plantagenet,arbuthnot,chidambaram,woburn,osamu,panelling,coauthored,zhongshu,hyaline,omissions,aspergillus,offensively,electrolytic,woodcut,sodom,intensities,clydebank,piotrkow,supplementing,quipped,focke,harbinger,positivism,parklands,wolfenbuttel,cauca,tryptophan,taunus,curragh,tsonga,remand,obscura,ashikaga,eltham,forelimbs,analogs,trnava,observances,kailash,antithesis,ayumi,abyssinia,dorsally,tralee,pursuers,misadventures,padova,perot,mahadev,tarim,granth,licenced,compania,patuxent,baronial,korda,cochabamba,codices,karna,memorialized,semaphore,playlists,mandibular,halal,sivaji,scherzinger,stralsund,foundries,ribosome,mindfulness,nikolayevich,paraphyletic,newsreader,catalyze,ioannina,thalamus,gbit/s,paymaster,sarab,500th,replenished,gamepro,cracow,formula_46,gascony,reburied,lessing,easement,transposed,meurthe,satires,proviso,balthasar,unbound,cuckoos,durbar,louisbourg,cowes,wholesalers,manet,narita,xiaoping,mohamad,illusory,cathal,reuptake,alkaloid,tahrir,mmorpg,underlies,anglicanism,repton,aharon,exogenous,buchenwald,indigent,odostomia,milled,santorum,toungoo,nevsky,steyr,urbanisation,darkseid,subsonic,canaanite,akiva,eglise,dentition,mediators,cirencester,peloponnesian,malmesbury,durres,oerlikon,tabulated,saens,canaria,ischemic,esterhazy,ringling,centralization,walthamstow,nalanda,lignite,takht,leninism,expiring,circe,phytoplankton,promulgation,integrable,breeches,aalto,menominee,borgo,scythians,skrull,galleon,reinvestment,raglan,reachable,liberec,airframes,electrolysis,geospatial,rubiaceae,interdependence,symmetrically,simulcasts,keenly,mauna,adipose,zaidi,fairport,vestibular,actuators,monochromatic,literatures,congestive,sacramental,atholl,skytrain,tycho,tunings,jamia,catharina,modifier,methuen,tapings,infiltrating,colima,grafting,tauranga,halides,pontificate,phonetics,koper,hafez,grooved,kintetsu,extrajudicial,linkoping,cyberpunk,repetitions,laurentian,parnu,bretton,darko,sverdlovsk,foreshadowed,akhenaten,rehnquist,gosford,coverts,pragmatism,broadleaf,ethiopians,instated,mediates,sodra,opulent,descriptor,enugu,shimla,leesburg,officership,giffard,refectory,lusitania,cybermen,fiume,corus,tydfil,lawrenceville,ocala,leviticus,burghers,ataxia,richthofen,amicably,acoustical,watling,inquired,tiempo,multiracial,parallelism,trenchard,tokyopop,germanium,usisl,philharmonia,shapur,jacobites,latinized,sophocles,remittances,o'farrell,adder,dimitrios,peshwa,dimitar,orlov,outstretched,musume,satish,dimensionless,serialised,baptisms,pagasa,antiviral,1740s,quine,arapaho,bombardments,stratosphere,ophthalmic,injunctions,carbonated,nonviolence,asante,creoles,sybra,boilermakers,abington,bipartite,permissive,cardinality,anheuser,carcinogenic,hohenlohe,surinam,szeged,infanticide,generically,floorball,'white,automakers,cerebellar,homozygous,remoteness,effortlessly,allude,'great,headmasters,minting,manchurian,kinabalu,wemyss,seditious,widgets,marbled,almshouses,bards,subgenres,tetsuya,faulting,kickboxer,gaulish,hoseyn,malton,fluvial,questionnaires,mondale,downplayed,traditionalists,vercelli,sumatran,landfills,gamesradar,exerts,franciszek,unlawfully,huesca,diderot,libertarians,professorial,laane,piecemeal,conidae,taiji,curatorial,perturbations,abstractions,szlachta,watercraft,mullah,zoroastrianism,segmental,khabarovsk,rectors,affordability,scuola,diffused,stena,cyclonic,workpiece,romford,'little,jhansi,stalag,zhongshan,skipton,maracaibo,bernadotte,thanet,groening,waterville,encloses,sahrawi,nuffield,moorings,chantry,annenberg,islay,marchers,tenses,wahid,siegen,furstenberg,basques,resuscitation,seminarians,tympanum,gentiles,vegetarianism,tufted,venkata,fantastical,pterophoridae,machined,superposition,glabrous,kaveri,chicane,executors,phyllonorycter,bidirectional,jasta,undertones,touristic,majapahit,navratilova,unpopularity,barbadian,tinian,webcast,hurdler,rigidly,jarrah,staphylococcus,igniting,irrawaddy,stabilised,airstrike,ragas,wakayama,energetically,ekstraklasa,minibus,largemouth,cultivators,leveraging,waitangi,carnaval,weaves,turntables,heydrich,sextus,excavate,govind,ignaz,pedagogue,uriah,borrowings,gemstones,infractions,mycobacterium,batavian,massing,praetor,subalpine,massoud,passers,geostationary,jalil,trainsets,barbus,impair,budejovice,denbigh,pertain,historicity,fortaleza,nederlandse,lamenting,masterchef,doubs,gemara,conductance,ploiesti,cetaceans,courthouses,bhagavad,mihailovic,occlusion,bremerhaven,bulwark,morava,kaine,drapery,maputo,conquistador,kaduna,famagusta,first-past-the-post,erudite,galton,undated,tangential,filho,dismembered,dashes,criterium,darwen,metabolized,blurring,everard,randwick,mohave,impurity,acuity,ansbach,chievo,surcharge,plantain,algoma,porosity,zirconium,selva,sevenoaks,venizelos,gwynne,golgi,imparting,separatism,courtesan,idiopathic,gravestones,hydroelectricity,babar,orford,purposeful,acutely,shard,ridgewood,viterbo,manohar,expropriation,placenames,brevis,cosine,unranked,richfield,newnham,recoverable,flightless,dispersing,clearfield,abu'l,stranraer,kempe,streamlining,goswami,epidermal,pieta,conciliatory,distilleries,electrophoresis,bonne,tiago,curiosities,candidature,picnicking,perihelion,lintel,povoa,gullies,configure,excision,facies,signers,1730s,insufficiency,semiotics,streatham,deactivation,entomological,skippers,albacete,parodying,escherichia,honorees,singaporeans,counterterrorism,tiruchirappalli,omnivorous,metropole,globalisation,athol,unbounded,codice_5,landforms,classifier,farmhouses,reaffirming,reparation,yomiuri,technologists,mitte,medica,viewable,steampunk,konya,kshatriya,repelling,edgewater,lamiinae,devas,potteries,llandaff,engendered,submits,virulence,uplifted,educationist,metropolitans,frontrunner,dunstable,forecastle,frets,methodius,exmouth,linnean,bouchet,repulsion,computable,equalling,liceo,tephritidae,agave,hydrological,azarenka,fairground,l'homme,enforces,xinhua,cinematographers,cooperstown,sa'id,paiute,christianization,tempos,chippenham,insulator,kotor,stereotyped,dello,cours,hisham,d'souza,eliminations,supercars,passau,rebrand,natures,coote,persephone,rededicated,cleaved,plenum,blistering,indiscriminately,cleese,safed,recursively,compacted,revues,hydration,shillong,echelons,garhwal,pedimented,grower,zwolle,wildflower,annexing,methionine,petah,valens,famitsu,petiole,specialities,nestorian,shahin,tokaido,shearwater,barberini,kinsmen,experimenter,alumnae,cloisters,alumina,pritzker,hardiness,soundgarden,julich,ps300,watercourse,cementing,wordplay,olivet,demesne,chasseurs,amide,zapotec,gaozu,porphyry,absorbers,indium,analogies,devotions,engravers,limestones,catapulted,surry,brickworks,gotra,rodham,landline,paleontologists,shankara,islip,raucous,trollope,arpad,embarkation,morphemes,recites,picardie,nakhchivan,tolerances,formula_47,khorramabad,nichiren,adrianople,kirkuk,assemblages,collider,bikaner,bushfires,roofline,coverings,reredos,bibliotheca,mantras,accentuated,commedia,rashtriya,fluctuation,serhiy,referential,fittipaldi,vesicle,geeta,iraklis,immediacy,chulalongkorn,hunsruck,bingen,dreadnoughts,stonemason,meenakshi,lebesgue,undergrowth,baltistan,paradoxes,parlement,articled,tiflis,dixieland,meriden,tejano,underdogs,barnstable,exemplify,venter,tropes,wielka,kankakee,iskandar,zilina,pharyngeal,spotify,materialised,picts,atlantique,theodoric,prepositions,paramilitaries,pinellas,attlee,actuated,piedmontese,grayling,thucydides,multifaceted,unedited,autonomously,universelle,utricularia,mooted,preto,incubated,underlie,brasenose,nootka,bushland,sensu,benzodiazepine,esteghlal,seagoing,amenhotep,azusa,sappers,culpeper,smokeless,thoroughbreds,dargah,gorda,alumna,mankato,zdroj,deleting,culvert,formula_49,punting,wushu,hindering,immunoglobulin,standardisation,birger,oilfield,quadrangular,ulama,recruiters,netanya,1630s,communaute,istituto,maciej,pathan,meher,vikas,characterizations,playmaker,interagency,intercepts,assembles,horthy,introspection,narada,matra,testes,radnicki,estonians,csiro,instar,mitford,adrenergic,crewmembers,haaretz,wasatch,lisburn,rangefinder,ordre,condensate,reforestation,corregidor,spvgg,modulator,mannerist,faulted,aspires,maktoum,squarepants,aethelred,piezoelectric,mulatto,dacre,progressions,jagiellonian,norge,samaria,sukhoi,effingham,coxless,hermetic,humanists,centrality,litters,stirlingshire,beaconsfield,sundanese,geometrically,caretakers,habitually,bandra,pashtuns,bradenton,arequipa,laminar,brickyard,hitchin,sustains,shipboard,ploughing,trechus,wheelers,bracketed,ilyushin,subotica,d'hondt,reappearance,bridgestone,intermarried,fulfilment,aphasia,birkbeck,transformational,strathmore,hornbill,millstone,lacan,voids,solothurn,gymnasiums,laconia,viaducts,peduncle,teachta,edgware,shinty,supernovae,wilfried,exclaim,parthia,mithun,flashpoint,moksha,cumbia,metternich,avalanches,militancy,motorist,rivadavia,chancellorsville,federals,gendered,bounding,footy,gauri,caliphs,lingam,watchmaker,unrecorded,riverina,unmodified,seafloor,droit,pfalz,chrysostom,gigabit,overlordship,besiege,espn2,oswestry,anachronistic,ballymena,reactivation,duchovny,ghani,abacetus,duller,legio,watercourses,nord-pas-de-calais,leiber,optometry,swarms,installer,sancti,adverbs,iheartmedia,meiningen,zeljko,kakheti,notional,circuses,patrilineal,acrobatics,infrastructural,sheva,oregonian,adjudication,aamir,wloclawek,overfishing,obstructive,subtracting,aurobindo,archeologist,newgate,'cause,secularization,tehsils,abscess,fingal,janacek,elkhorn,trims,kraftwerk,mandating,irregulars,faintly,congregationalist,sveti,kasai,mishaps,kennebec,provincially,durkheim,scotties,aicte,rapperswil,imphal,surrenders,morphs,nineveh,hoxha,cotabato,thuringian,metalworking,retold,shogakukan,anthers,proteasome,tippeligaen,disengagement,mockumentary,palatial,erupts,flume,corrientes,masthead,jaroslaw,rereleased,bharti,labors,distilling,tusks,varzim,refounded,enniskillen,melkite,semifinalists,vadodara,bermudian,capstone,grasse,origination,populus,alesi,arrondissements,semigroup,verein,opossum,messrs.,portadown,bulbul,tirupati,mulhouse,tetrahedron,roethlisberger,nonverbal,connexion,warangal,deprecated,gneiss,octet,vukovar,hesketh,chambre,despatch,claes,kargil,hideo,gravelly,tyndale,aquileia,tuners,defensible,tutte,theotokos,constructivist,ouvrage,dukla,polisario,monasticism,proscribed,commutation,testers,nipissing,codon,mesto,olivine,concomitant,exoskeleton,purports,coromandel,eyalet,dissension,hippocrates,purebred,yaounde,composting,oecophoridae,procopius,o'day,angiogenesis,sheerness,intelligencer,articular,felixstowe,aegon,endocrinology,trabzon,licinius,pagodas,zooplankton,hooghly,satie,drifters,sarthe,mercian,neuilly,tumours,canal+,scheldt,inclinations,counteroffensive,roadrunners,tuzla,shoreditch,surigao,predicates,carnot,algeciras,militaries,generalize,bulkheads,gawler,pollutant,celta,rundgren,microrna,gewog,olimpija,placental,lubelski,roxburgh,discerned,verano,kikuchi,musicale,l'enfant,ferocity,dimorphic,antigonus,erzurum,prebendary,recitative,discworld,cyrenaica,stigmella,totnes,sutta,pachuca,ulsan,downton,landshut,castellan,pleural,siedlce,siecle,catamaran,cottbus,utilises,trophic,freeholders,holyhead,u.s.s,chansons,responder,waziristan,suzuka,birding,shogi,asker,acetone,beautification,cytotoxic,dixit,hunterdon,cobblestone,formula_48,kossuth,devizes,sokoto,interlaced,shuttered,kilowatts,assiniboine,isaak,salto,alderney,sugarloaf,franchising,aggressiveness,toponyms,plaintext,antimatter,henin,equidistant,salivary,bilingualism,mountings,obligate,extirpated,irenaeus,misused,pastoralists,aftab,immigrating,warping,tyrolean,seaforth,teesside,soundwave,oligarchy,stelae,pairwise,iupac,tezuka,posht,orchestrations,landmass,ironstone,gallia,hjalmar,carmelites,strafford,elmhurst,palladio,fragility,teleplay,gruffudd,karoly,yerba,potok,espoo,inductance,macaque,nonprofits,pareto,rock'n'roll,spiritualist,shadowed,skateboarder,utterances,generality,congruence,prostrate,deterred,yellowknife,albarn,maldon,battlements,mohsen,insecticides,khulna,avellino,menstruation,glutathione,springdale,parlophone,confraternity,korps,countrywide,bosphorus,preexisting,damodar,astride,alexandrovich,sprinting,crystallized,botev,leaching,interstates,veers,angevin,undaunted,yevgeni,nishapur,northerners,alkmaar,bethnal,grocers,sepia,tornus,exemplar,trobe,charcot,gyeonggi,larne,tournai,lorain,voided,genji,enactments,maxilla,adiabatic,eifel,nazim,transducer,thelonious,pyrite,deportiva,dialectal,bengt,rosettes,labem,sergeyevich,synoptic,conservator,statuette,biweekly,adhesives,bifurcation,rajapaksa,mammootty,republique,yusef,waseda,marshfield,yekaterinburg,minnelli,fundy,fenian,matchups,dungannon,supremacist,panelled,drenthe,iyengar,fibula,narmada,homeport,oceanside,precept,antibacterial,altarpieces,swath,ospreys,lillooet,legnica,lossless,formula_50,galvatron,iorga,stormont,rsfsr,loggers,kutno,phenomenological,medallists,cuatro,soissons,homeopathy,bituminous,injures,syndicates,typesetting,displacements,dethroned,makassar,lucchese,abergavenny,targu,alborz,akb48,boldface,gastronomy,sacra,amenity,accumulator,myrtaceae,cornices,mourinho,denunciation,oxbow,diddley,aargau,arbitrage,bedchamber,gruffydd,zamindar,klagenfurt,caernarfon,slowdown,stansted,abrasion,tamaki,suetonius,dukakis,individualistic,ventrally,hotham,perestroika,ketones,fertilisation,sobriquet,couplings,renderings,misidentified,rundfunk,sarcastically,braniff,concours,dismissals,elegantly,modifiers,crediting,combos,crucially,seafront,lieut,ischemia,manchus,derivations,proteases,aristophanes,adenauer,porting,hezekiah,sante,trulli,hornblower,foreshadowing,ypsilanti,dharwad,khani,hohenstaufen,distillers,cosmodrome,intracranial,turki,salesian,gorzow,jihlava,yushchenko,leichhardt,venables,cassia,eurogamer,airtel,curative,bestsellers,timeform,sortied,grandview,massillon,ceding,pilbara,chillicothe,heredity,elblag,rogaland,ronne,millennial,batley,overuse,bharata,fille,campbelltown,abeyance,counterclockwise,250cc,neurodegenerative,consigned,electromagnetism,sunnah,saheb,exons,coxswain,gleaned,bassoons,worksop,prismatic,immigrate,pickets,takeo,bobsledder,stosur,fujimori,merchantmen,stiftung,forli,endorses,taskforce,thermally,atman,gurps,floodplains,enthalpy,extrinsic,setubal,kennesaw,grandis,scalability,durations,showrooms,prithvi,outro,overruns,andalucia,amanita,abitur,hipper,mozambican,sustainment,arsene,chesham,palaeolithic,reportage,criminality,knowsley,haploid,atacama,shueisha,ridgefield,astern,getafe,lineal,timorese,restyled,hollies,agincourt,unter,justly,tannins,mataram,industrialised,tarnovo,mumtaz,mustapha,stretton,synthetase,condita,allround,putra,stjepan,troughs,aechmea,specialisation,wearable,kadokawa,uralic,aeros,messiaen,existentialism,jeweller,effigies,gametes,fjordane,cochlear,interdependent,demonstrative,unstructured,emplacement,famines,spindles,amplitudes,actuator,tantalum,psilocybe,apnea,monogatari,expulsions,seleucus,tsuen,hospitaller,kronstadt,eclipsing,olympiakos,clann,canadensis,inverter,helio,egyptologist,squamous,resonate,munir,histology,torbay,khans,jcpenney,veterinarians,aintree,microscopes,colonised,reflectors,phosphorylated,pristimantis,tulare,corvinus,multiplexing,midweek,demosthenes,transjordan,ecija,tengku,vlachs,anamorphic,counterweight,radnor,trinitarian,armidale,maugham,njsiaa,futurism,stairways,avicenna,montebello,bridgetown,wenatchee,lyonnais,amass,surinamese,streptococcus,m*a*s*h,hydrogenation,frazioni,proscenium,kalat,pennsylvanian,huracan,tallying,kralove,nucleolar,phrygian,seaports,hyacinthe,ignace,donning,instalment,regnal,fonds,prawn,carell,folktales,goaltending,bracknell,vmware,patriarchy,mitsui,kragujevac,pythagoras,soult,thapa,disproved,suwalki,secures,somoza,l'ecole,divizia,chroma,herders,technologist,deduces,maasai,rampur,paraphrase,raimi,imaged,magsaysay,ivano,turmeric,formula_51,subcommittees,axillary,ionosphere,organically,indented,refurbishing,pequot,violinists,bearn,colle,contralto,silverton,mechanization,etruscans,wittelsbach,pasir,redshirted,marrakesh,scarp,plein,wafers,qareh,teotihuacan,frobenius,sinensis,rehoboth,bundaberg,newbridge,hydrodynamic,traore,abubakar,adjusts,storytellers,dynamos,verbandsliga,concertmaster,exxonmobil,appreciable,sieradz,marchioness,chaplaincy,rechristened,cunxu,overpopulation,apolitical,sequencer,beaked,nemanja,binaries,intendant,absorber,filamentous,indebtedness,nusra,nashik,reprises,psychedelia,abwehr,ligurian,isoform,resistive,pillaging,mahathir,reformatory,lusatia,allerton,ajaccio,tepals,maturin,njcaa,abyssinian,objector,fissures,sinuous,ecclesiastic,dalits,caching,deckers,phosphates,wurlitzer,navigated,trofeo,berea,purefoods,solway,unlockable,grammys,kostroma,vocalizations,basilan,rebuke,abbasi,douala,helsingborg,ambon,bakar,runestones,cenel,tomislav,pigmented,northgate,excised,seconda,kirke,determinations,dedicates,vilas,pueblos,reversion,unexploded,overprinted,ekiti,deauville,masato,anaesthesia,endoplasmic,transponders,aguascalientes,hindley,celluloid,affording,bayeux,piaget,rickshaws,eishockey,camarines,zamalek,undersides,hardwoods,hermitian,mutinied,monotone,blackmails,affixes,jpmorgan,habermas,mitrovica,paleontological,polystyrene,thana,manas,conformist,turbofan,decomposes,logano,castration,metamorphoses,patroness,herbicide,mikolaj,rapprochement,macroeconomics,barranquilla,matsudaira,lintels,femina,hijab,spotsylvania,morpheme,bitola,baluchistan,kurukshetra,otway,extrusion,waukesha,menswear,helder,trung,bingley,protester,boars,overhang,differentials,exarchate,hejaz,kumara,unjustified,timings,sharpness,nuovo,taisho,sundar,etc..,jehan,unquestionably,muscovy,daltrey,canute,paneled,amedeo,metroplex,elaborates,telus,tetrapods,dragonflies,epithets,saffir,parthenon,lucrezia,refitting,pentateuch,hanshin,montparnasse,lumberjacks,sanhedrin,erectile,odors,greenstone,resurgent,leszek,amory,substituents,prototypical,viewfinder,monck,universiteit,joffre,revives,chatillon,seedling,scherzo,manukau,ashdod,gympie,homolog,stalwarts,ruinous,weibo,tochigi,wallenberg,gayatri,munda,satyagraha,storefronts,heterogeneity,tollway,sportswriters,binocular,gendarmes,ladysmith,tikal,ortsgemeinde,ja'far,osmotic,linlithgow,bramley,telecoms,pugin,repose,rupaul,sieur,meniscus,garmisch,reintroduce,400th,shoten,poniatowski,drome,kazakhstani,changeover,astronautics,husserl,herzl,hypertext,katakana,polybius,antananarivo,seong,breguet,reliquary,utada,aggregating,liangshan,sivan,tonawanda,audiobooks,shankill,coulee,phenolic,brockton,bookmakers,handsets,boaters,wylde,commonality,mappings,silhouettes,pennines,maurya,pratchett,singularities,eschewed,pretensions,vitreous,ibero,totalitarianism,poulenc,lingered,directx,seasoning,deputation,interdict,illyria,feedstock,counterbalance,muzik,buganda,parachuted,violist,homogeneity,comix,fjords,corsairs,punted,verandahs,equilateral,laoghaire,magyars,117th,alesund,televoting,mayotte,eateries,refurbish,nswrl,yukio,caragiale,zetas,dispel,codecs,inoperable,outperformed,rejuvenation,elstree,modernise,contributory,pictou,tewkesbury,chechens,ashina,psionic,refutation,medico,overdubbed,nebulae,sandefjord,personages,eccellenza,businessperson,placename,abenaki,perryville,threshing,reshaped,arecibo,burslem,colspan=3|turnout,rebadged,lumia,erinsborough,interactivity,bitmap,indefatigable,theosophy,excitatory,gleizes,edsel,bermondsey,korce,saarinen,wazir,diyarbakir,cofounder,liberalisation,onsen,nighthawks,siting,retirements,semyon,d'histoire,114th,redditch,venetia,praha,'round,valdosta,hieroglyphic,postmedial,edirne,miscellany,savona,cockpits,minimization,coupler,jacksonian,appeasement,argentines,saurashtra,arkwright,hesiod,folios,fitzalan,publica,rivaled,civitas,beermen,constructivism,ribeira,zeitschrift,solanum,todos,deformities,chilliwack,verdean,meagre,bishoprics,gujrat,yangzhou,reentered,inboard,mythologies,virtus,unsurprisingly,rusticated,museu,symbolise,proportionate,thesaban,symbian,aeneid,mitotic,veliki,compressive,cisterns,abies,winemaker,massenet,bertolt,ahmednagar,triplemania,armorial,administracion,tenures,smokehouse,hashtag,fuerza,regattas,gennady,kanazawa,mahmudabad,crustal,asaph,valentinian,ilaiyaraaja,honeyeater,trapezoidal,cooperatively,unambiguously,mastodon,inhospitable,harnesses,riverton,renewables,djurgardens,haitians,airings,humanoids,boatswain,shijiazhuang,faints,veera,punjabis,steepest,narain,karlovy,serre,sulcus,collectives,1500m,arion,subarctic,liberally,apollonius,ostia,droplet,headstones,norra,robusta,maquis,veronese,imola,primers,luminance,escadrille,mizuki,irreconcilable,stalybridge,temur,paraffin,stuccoed,parthians,counsels,fundamentalists,vivendi,polymath,sugababes,mikko,yonne,fermions,vestfold,pastoralist,kigali,unseeded,glarus,cusps,amasya,northwesterly,minorca,astragalus,verney,trevelyan,antipathy,wollstonecraft,bivalves,boulez,royle,divisao,quranic,bareilly,coronal,deviates,lulea,erectus,petronas,chandan,proxies,aeroflot,postsynaptic,memoriam,moyne,gounod,kuznetsova,pallava,ordinating,reigate,'first,lewisburg,exploitative,danby,academica,bailiwick,brahe,injective,stipulations,aeschylus,computes,gulden,hydroxylase,liveries,somalis,underpinnings,muscovite,kongsberg,domus,overlain,shareware,variegated,jalalabad,agence,ciphertext,insectivores,dengeki,menuhin,cladistic,baerum,betrothal,tokushima,wavelet,expansionist,pottsville,siyuan,prerequisites,carpi,nemzeti,nazar,trialled,eliminator,irrorated,homeward,redwoods,undeterred,strayed,lutyens,multicellular,aurelian,notated,lordships,alsatian,idents,foggia,garros,chalukyas,lillestrom,podlaski,pessimism,hsien,demilitarized,whitewashed,willesden,kirkcaldy,sanctorum,lamia,relaying,escondido,paediatric,contemplates,demarcated,bluestone,betula,penarol,capitalise,kreuznach,kenora,115th,hold'em,reichswehr,vaucluse,m.i.a,windings,boys/girls,cajon,hisar,predictably,flemington,ysgol,mimicked,clivina,grahamstown,ionia,glyndebourne,patrese,aquaria,sleaford,dayal,sportscenter,malappuram,m.b.a.,manoa,carbines,solvable,designator,ramanujan,linearity,academicians,sayid,lancastrian,factorial,strindberg,vashem,delos,comyn,condensing,superdome,merited,kabaddi,intransitive,bideford,neuroimaging,duopoly,scorecards,ziggler,heriot,boyars,virology,marblehead,microtubules,westphalian,anticipates,hingham,searchers,harpist,rapides,morricone,convalescent,mises,nitride,metrorail,matterhorn,bicol,drivetrain,marketer,snippet,winemakers,muban,scavengers,halberstadt,herkimer,peten,laborious,stora,montgomeryshire,booklist,shamir,herault,eurostar,anhydrous,spacewalk,ecclesia,calliostoma,highschool,d'oro,suffusion,imparts,overlords,tagus,rectifier,counterinsurgency,ministered,eilean,milecastle,contre,micromollusk,okhotsk,bartoli,matroid,hasidim,thirunal,terme,tarlac,lashkar,presque,thameslink,flyby,troopship,renouncing,fatih,messrs,vexillum,bagration,magnetite,bornholm,androgynous,vehement,tourette,philosophic,gianfranco,tuileries,codice_6,radially,flexion,hants,reprocessing,setae,burne,palaeographically,infantryman,shorebirds,tamarind,moderna,threading,militaristic,crohn,norrkoping,125cc,stadtholder,troms,klezmer,alphanumeric,brome,emmanuelle,tiwari,alchemical,formula_52,onassis,bleriot,bipedal,colourless,hermeneutics,hosni,precipitating,turnstiles,hallucinogenic,panhellenic,wyandotte,elucidated,chita,ehime,generalised,hydrophilic,biota,niobium,rnzaf,gandhara,longueuil,logics,sheeting,bielsko,cuvier,kagyu,trefoil,docent,pancrase,stalinism,postures,encephalopathy,monckton,imbalances,epochs,leaguers,anzio,diminishes,pataki,nitrite,amuro,nabil,maybach,l'aquila,babbler,bacolod,thutmose,evora,gaudi,breakage,recur,preservative,60deg,mendip,functionaries,columnar,maccabiah,chert,verden,bromsgrove,clijsters,dengue,pastorate,phuoc,principia,viareggio,kharagpur,scharnhorst,anyang,bosons,l'art,criticises,ennio,semarang,brownian,mirabilis,asperger,calibers,typographical,cartooning,minos,disembark,supranational,undescribed,etymologically,alappuzha,vilhelm,lanao,pakenham,bhagavata,rakoczi,clearings,astrologers,manitowoc,bunuel,acetylene,scheduler,defamatory,trabzonspor,leaded,scioto,pentathlete,abrahamic,minigames,aldehydes,peerages,legionary,1640s,masterworks,loudness,bryansk,likeable,genocidal,vegetated,towpath,declination,pyrrhus,divinely,vocations,rosebery,associazione,loaders,biswas,oeste,tilings,xianzong,bhojpuri,annuities,relatedness,idolator,psers,constriction,chuvash,choristers,hanafi,fielders,grammarian,orpheum,asylums,millbrook,gyatso,geldof,stabilise,tableaux,diarist,kalahari,panini,cowdenbeath,melanin,4x100m,resonances,pinar,atherosclerosis,sheringham,castlereagh,aoyama,larks,pantograph,protrude,natak,gustafsson,moribund,cerevisiae,cleanly,polymeric,holkar,cosmonauts,underpinning,lithosphere,firuzabad,languished,mingled,citrate,spadina,lavas,daejeon,fibrillation,porgy,pineville,ps1000,cobbled,emamzadeh,mukhtar,dampers,indelible,salonika,nanoscale,treblinka,eilat,purporting,fluctuate,mesic,hagiography,cutscenes,fondation,barrens,comically,accrue,ibrox,makerere,defections,'there,hollandia,skene,grosseto,reddit,objectors,inoculation,rowdies,playfair,calligrapher,namor,sibenik,abbottabad,propellants,hydraulically,chloroplasts,tablelands,tecnico,schist,klasse,shirvan,bashkortostan,bullfighting,north/south,polski,hanns,woodblock,kilmore,ejecta,ignacy,nanchang,danubian,commendations,snohomish,samaritans,argumentation,vasconcelos,hedgehogs,vajrayana,barents,kulkarni,kumbakonam,identifications,hillingdon,weirs,nayanar,beauvoir,messe,divisors,atlantiques,broods,affluence,tegucigalpa,unsuited,autodesk,akash,princeps,culprits,kingstown,unassuming,goole,visayan,asceticism,blagojevich,irises,paphos,unsound,maurier,pontchartrain,desertification,sinfonietta,latins,especial,limpet,valerenga,glial,brainstem,mitral,parables,sauropod,judean,iskcon,sarcoma,venlo,justifications,zhuhai,blavatsky,alleviated,usafe,steppenwolf,inversions,janko,chagall,secretory,basildon,saguenay,pergamon,hemispherical,harmonized,reloading,franjo,domaine,extravagance,relativism,metamorphosed,labuan,baloncesto,gmail,byproducts,calvinists,counterattacked,vitus,bubonic,120th,strachey,ritually,brookwood,selectable,savinja,incontinence,meltwater,jinja,1720s,brahmi,morgenthau,sheaves,sleeved,stratovolcano,wielki,utilisation,avoca,fluxus,panzergrenadier,philately,deflation,podlaska,prerogatives,kuroda,theophile,zhongzong,gascoyne,magus,takao,arundell,fylde,merdeka,prithviraj,venkateswara,liepaja,daigo,dreamland,reflux,sunnyvale,coalfields,seacrest,soldering,flexor,structuralism,alnwick,outweighed,unaired,mangeshkar,batons,glaad,banshees,irradiated,organelles,biathlete,cabling,chairlift,lollapalooza,newsnight,capacitive,succumbs,flatly,miramichi,burwood,comedienne,charteris,biotic,workspace,aficionados,sokolka,chatelet,o'shaughnessy,prosthesis,neoliberal,refloated,oppland,hatchlings,econometrics,loess,thieu,androids,appalachians,jenin,pterostichinae,downsized,foils,chipsets,stencil,danza,narrate,maginot,yemenite,bisects,crustacean,prescriptive,melodious,alleviation,empowers,hansson,autodromo,obasanjo,osmosis,daugava,rheumatism,moraes,leucine,etymologies,chepstow,delaunay,bramall,bajaj,flavoring,approximates,marsupials,incisive,microcomputer,tactically,waals,wilno,fisichella,ursus,hindmarsh,mazarin,lomza,xenophobia,lawlessness,annecy,wingers,gornja,gnaeus,superieur,tlaxcala,clasps,symbolises,slats,rightist,effector,blighted,permanence,divan,progenitors,kunsthalle,anointing,excelling,coenzyme,indoctrination,dnipro,landholdings,adriaan,liturgies,cartan,ethmia,attributions,sanctus,trichy,chronicon,tancred,affinis,kampuchea,gantry,pontypool,membered,distrusted,fissile,dairies,hyposmocoma,craigie,adarsh,martinsburg,taxiway,30deg,geraint,vellum,bencher,khatami,formula_53,zemun,teruel,endeavored,palmares,pavements,u.s..,internationalization,satirized,carers,attainable,wraparound,muang,parkersburg,extinctions,birkenfeld,wildstorm,payers,cohabitation,unitas,culloden,capitalizing,clwyd,daoist,campinas,emmylou,orchidaceae,halakha,orientales,fealty,domnall,chiefdom,nigerians,ladislav,dniester,avowed,ergonomics,newsmagazine,kitsch,cantilevered,benchmarking,remarriage,alekhine,coldfield,taupo,almirante,substations,apprenticeships,seljuq,levelling,eponym,symbolising,salyut,opioids,underscore,ethnologue,mohegan,marikina,libro,bassano,parse,semantically,disjointed,dugdale,padraig,tulsi,modulating,xfinity,headlands,mstislav,earthworms,bourchier,lgbtq,embellishments,pennants,rowntree,betel,motet,mulla,catenary,washoe,mordaunt,dorking,colmar,girardeau,glentoran,grammatically,samad,recreations,technion,staccato,mikoyan,spoilers,lyndhurst,victimization,chertsey,belafonte,tondo,tonsberg,narrators,subcultures,malformations,edina,augmenting,attests,euphemia,cabriolet,disguising,1650s,navarrese,demoralized,cardiomyopathy,welwyn,wallachian,smoothness,planktonic,voles,issuers,sardasht,survivability,cuauhtemoc,thetis,extruded,signet,raghavan,lombok,eliyahu,crankcase,dissonant,stolberg,trencin,desktops,bursary,collectivization,charlottenburg,triathlete,curvilinear,involuntarily,mired,wausau,invades,sundaram,deletions,bootstrap,abellio,axiomatic,noguchi,setups,malawian,visalia,materialist,kartuzy,wenzong,plotline,yeshivas,parganas,tunica,citric,conspecific,idlib,superlative,reoccupied,blagoevgrad,masterton,immunological,hatta,courbet,vortices,swallowtail,delves,haridwar,diptera,boneh,bahawalpur,angering,mardin,equipments,deployable,guanine,normality,rimmed,artisanal,boxset,chandrasekhar,jools,chenar,tanakh,carcassonne,belatedly,millville,anorthosis,reintegration,velde,surfactant,kanaan,busoni,glyphipterix,personas,fullness,rheims,tisza,stabilizers,bharathi,joost,spinola,mouldings,perching,esztergom,afzal,apostate,lustre,s.league,motorboat,monotheistic,armature,barat,asistencia,bloomsburg,hippocampal,fictionalised,defaults,broch,hexadecimal,lusignan,ryanair,boccaccio,breisgau,southbank,bskyb,adjoined,neurobiology,aforesaid,sadhu,langue,headship,wozniacki,hangings,regulus,prioritized,dynamism,allier,hannity,shimin,antoninus,gymnopilus,caledon,preponderance,melayu,electrodynamics,syncopated,ibises,krosno,mechanistic,morpeth,harbored,albini,monotheism,'real,hyperactivity,haveli,writer/director,minato,nimoy,caerphilly,chitral,amirabad,fanshawe,l'oreal,lorde,mukti,authoritarianism,valuing,spyware,hanbury,restarting,stato,embed,suiza,empiricism,stabilisation,stari,castlemaine,orbis,manufactory,mauritanian,shoji,taoyuan,prokaryotes,oromia,ambiguities,embodying,slims,frente,innovate,ojibwa,powdery,gaeltacht,argentinos,quatermass,detergents,fijians,adaptor,tokai,chileans,bulgars,oxidoreductases,bezirksliga,conceicao,myosin,nellore,500cc,supercomputers,approximating,glyndwr,polypropylene,haugesund,cockerell,tudman,ashbourne,hindemith,bloodlines,rigveda,etruria,romanos,steyn,oradea,deceleration,manhunter,laryngeal,fraudulently,janez,wendover,haplotype,janaki,naoki,belizean,mellencamp,cartographic,sadhana,tricolour,pseudoscience,satara,bytow,s.p.a.,jagdgeschwader,arcot,omagh,sverdrup,masterplan,surtees,apocrypha,ahvaz,d'amato,socratic,leumit,unnumbered,nandini,witold,marsupial,coalesced,interpolated,gimnasia,karadzic,keratin,mamoru,aldeburgh,speculator,escapement,irfan,kashyap,satyajit,haddington,solver,rothko,ashkelon,kickapoo,yeomen,superbly,bloodiest,greenlandic,lithic,autofocus,yardbirds,poona,keble,javan,sufis,expandable,tumblr,ursuline,swimwear,winwood,counsellors,aberrations,marginalised,befriending,workouts,predestination,varietal,siddhartha,dunkeld,judaic,esquimalt,shabab,ajith,telefonica,stargard,hoysala,radhakrishnan,sinusoidal,strada,hiragana,cebuano,monoid,independencia,floodwaters,mildura,mudflats,ottokar,translit,radix,wigner,philosophically,tephritid,synthesizing,castletown,installs,stirner,resettle,bushfire,choirmaster,kabbalistic,shirazi,lightship,rebus,colonizers,centrifuge,leonean,kristofferson,thymus,clackamas,ratnam,rothesay,municipally,centralia,thurrock,gulfport,bilinear,desirability,merite,psoriasis,macaw,erigeron,consignment,mudstone,distorting,karlheinz,ramen,tailwheel,vitor,reinsurance,edifices,superannuation,dormancy,contagion,cobden,rendezvoused,prokaryotic,deliberative,patricians,feigned,degrades,starlings,sopot,viticultural,beaverton,overflowed,convener,garlands,michiel,ternopil,naturelle,biplanes,bagot,gamespy,ventspils,disembodied,flattening,profesional,londoners,arusha,scapular,forestall,pyridine,ulema,eurodance,aruna,callus,periodontal,coetzee,immobilized,o'meara,maharani,katipunan,reactants,zainab,microgravity,saintes,britpop,carrefour,constrain,adversarial,firebirds,brahmo,kashima,simca,surety,surpluses,superconductivity,gipuzkoa,cumans,tocantins,obtainable,humberside,roosting,'king,formula_54,minelayer,bessel,sulayman,cycled,biomarkers,annealing,shusha,barda,cassation,djing,polemics,tuple,directorates,indomitable,obsolescence,wilhelmine,pembina,bojan,tambo,dioecious,pensioner,magnificat,1660s,estrellas,southeasterly,immunodeficiency,railhead,surreptitiously,codeine,encores,religiosity,tempera,camberley,efendi,boardings,malleable,hagia,input/output,lucasfilm,ujjain,polymorphisms,creationist,berners,mickiewicz,irvington,linkedin,endures,kinect,munition,apologetics,fairlie,predicated,reprinting,ethnographer,variances,levantine,mariinsky,jadid,jarrow,asia/oceania,trinamool,waveforms,bisexuality,preselection,pupae,buckethead,hieroglyph,lyricists,marionette,dunbartonshire,restorer,monarchical,pazar,kickoffs,cabildo,savannas,gliese,dench,spoonbills,novelette,diliman,hypersensitivity,authorising,montefiore,mladen,qu'appelle,theistic,maruti,laterite,conestoga,saare,californica,proboscis,carrickfergus,imprecise,hadassah,baghdadi,jolgeh,deshmukh,amusements,heliopolis,berle,adaptability,partenkirchen,separations,baikonur,cardamom,southeastward,southfield,muzaffar,adequacy,metropolitana,rajkot,kiyoshi,metrobus,evictions,reconciles,librarianship,upsurge,knightley,badakhshan,proliferated,spirituals,burghley,electroacoustic,professing,featurette,reformists,skylab,descriptors,oddity,greyfriars,injects,salmond,lanzhou,dauntless,subgenera,underpowered,transpose,mahinda,gatos,aerobatics,seaworld,blocs,waratahs,joris,giggs,perfusion,koszalin,mieczyslaw,ayyubid,ecologists,modernists,sant'angelo,quicktime,him/her,staves,sanyo,melaka,acrocercops,qigong,iterated,generalizes,recuperation,vihara,circassians,psychical,chavo,memoires,infiltrates,notaries,pelecaniformesfamily,strident,chivalric,pierrepont,alleviating,broadsides,centipede,b.tech,reinterpreted,sudetenland,hussite,covenanters,radhika,ironclads,gainsbourg,testis,penarth,plantar,azadegan,beano,espn.com,leominster,autobiographies,nbcuniversal,eliade,khamenei,montferrat,undistinguished,ethnological,wenlock,fricatives,polymorphic,biome,joule,sheaths,astrophysicist,salve,neoclassicism,lovat,downwind,belisarius,forma,usurpation,freie,depopulation,backbench,ascenso,'high,aagpbl,gdanski,zalman,mouvement,encapsulation,bolshevism,statny,voyageurs,hywel,vizcaya,mazra'eh,narthex,azerbaijanis,cerebrospinal,mauretania,fantail,clearinghouse,bolingbroke,pequeno,ansett,remixing,microtubule,wrens,jawahar,palembang,gambian,hillsong,fingerboard,repurposed,sundry,incipient,veolia,theologically,ulaanbaatar,atsushi,foundling,resistivity,myeloma,factbook,mazowiecka,diacritic,urumqi,clontarf,provokes,intelsat,professes,materialise,portobello,benedictines,panionios,introverted,reacquired,bridport,mammary,kripke,oratorios,vlore,stoning,woredas,unreported,antti,togolese,fanzines,heuristics,conservatories,carburetors,clitheroe,cofounded,formula_57,erupting,quinnipiac,bootle,ghostface,sittings,aspinall,sealift,transferase,boldklub,siskiyou,predominated,francophonie,ferruginous,castrum,neogene,sakya,madama,precipitous,'love,posix,bithynia,uttara,avestan,thrushes,seiji,memorably,septimius,libri,cibernetico,hyperinflation,dissuaded,cuddalore,peculiarity,vaslui,grojec,albumin,thurles,casks,fasteners,fluidity,buble,casals,terek,gnosticism,cognates,ulnar,radwanska,babylonians,majuro,oxidizer,excavators,rhythmically,liffey,gorakhpur,eurydice,underscored,arborea,lumumba,tuber,catholique,grama,galilei,scrope,centreville,jacobin,bequests,ardeche,polygamous,montauban,terai,weatherboard,readability,attainder,acraea,transversely,rivets,winterbottom,reassures,bacteriology,vriesea,chera,andesite,dedications,homogenous,reconquered,bandon,forrestal,ukiyo,gurdjieff,tethys,sparc,muscogee,grebes,belchatow,mansa,blantyre,palliser,sokolow,fibroblasts,exmoor,misaki,soundscapes,housatonic,middelburg,convenor,leyla,antipope,histidine,okeechobee,alkenes,sombre,alkene,rubik,macaques,calabar,trophee,pinchot,'free,frusciante,chemins,falaise,vasteras,gripped,schwarzenberg,cumann,kanchipuram,acoustically,silverbacks,fangio,inset,plympton,kuril,vaccinations,recep,theropods,axils,stavropol,encroached,apoptotic,papandreou,wailers,moonstone,assizes,micrometers,hornchurch,truncation,annapurna,egyptologists,rheumatic,promiscuity,satiric,fleche,caloptilia,anisotropy,quaternions,gruppo,viscounts,awardees,aftershocks,sigint,concordance,oblasts,gaumont,stent,commissars,kesteven,hydroxy,vijayanagar,belorussian,fabricius,watermark,tearfully,mamet,leukaemia,sorkh,milepost,tattooing,vosta,abbasids,uncompleted,hedong,woodwinds,extinguishing,malus,multiplexes,francoist,pathet,responsa,bassists,'most,postsecondary,ossory,grampian,saakashvili,alito,strasberg,impressionistic,volador,gelatinous,vignette,underwing,campanian,abbasabad,albertville,hopefuls,nieuwe,taxiways,reconvened,recumbent,pathologists,unionized,faversham,asymptotically,romulo,culling,donja,constricted,annesley,duomo,enschede,lovech,sharpshooter,lansky,dhamma,papillae,alanine,mowat,delius,wrest,mcluhan,podkarpackie,imitators,bilaspur,stunting,pommel,casemate,handicaps,nagas,testaments,hemings,necessitate,rearward,locative,cilla,klitschko,lindau,merion,consequential,antic,soong,copula,berthing,chevrons,rostral,sympathizer,budokan,ranulf,beria,stilt,replying,conflated,alcibiades,painstaking,yamanashi,calif.,arvid,ctesiphon,xizong,rajas,caxton,downbeat,resurfacing,rudders,miscegenation,deathmatch,foregoing,arthropod,attestation,karts,reapportionment,harnessing,eastlake,schola,dosing,postcolonial,imtiaz,formula_55,insulators,gunung,accumulations,pampas,llewelyn,bahnhof,cytosol,grosjean,teaneck,briarcliff,arsenio,canara,elaborating,passchendaele,searchlights,holywell,mohandas,preventable,gehry,mestizos,ustinov,cliched,'national,heidfeld,tertullian,jihadist,tourer,miletus,semicircle,outclassed,bouillon,cardinalate,clarifies,dakshina,bilayer,pandyan,unrwa,chandragupta,formula_56,portola,sukumaran,lactation,islamia,heikki,couplers,misappropriation,catshark,montt,ploughs,carib,stator,leaderboard,kenrick,dendrites,scape,tillamook,molesworth,mussorgsky,melanesia,restated,troon,glycoside,truckee,headwater,mashup,sectoral,gangwon,docudrama,skirting,psychopathology,dramatised,ostroleka,infestations,thabo,depolarization,wideroe,eisenbahn,thomond,kumaon,upendra,foreland,acronyms,yaqui,retaking,raphaelite,specie,dupage,villars,lucasarts,chloroplast,werribee,balsa,ascribe,havant,flava,khawaja,tyumen,subtract,interrogators,reshaping,buzzcocks,eesti,campanile,potemkin,apertures,snowboarder,registrars,handbooks,boyar,contaminant,depositors,proximate,jeunesse,zagora,pronouncements,mists,nihilism,deified,margraviate,pietersen,moderators,amalfi,adjectival,copepods,magnetosphere,pallets,clemenceau,castra,perforation,granitic,troilus,grzegorz,luthier,dockyards,antofagasta,ffestiniog,subroutine,afterword,waterwheel,druce,nitin,undifferentiated,emacs,readmitted,barneveld,tapers,hittites,infomercials,infirm,braathens,heligoland,carpark,geomagnetic,musculoskeletal,nigerien,machinima,harmonize,repealing,indecency,muskoka,verite,steubenville,suffixed,cytoskeleton,surpasses,harmonia,imereti,ventricles,heterozygous,envisions,otsego,ecoles,warrnambool,burgenland,seria,rawat,capistrano,welby,kirin,enrollments,caricom,dragonlance,schaffhausen,expanses,photojournalism,brienne,etude,referent,jamtland,schemas,xianbei,cleburne,bicester,maritima,shorelines,diagonals,bjelke,nonpublic,aliasing,m.f.a,ovals,maitreya,skirmishing,grothendieck,sukhothai,angiotensin,bridlington,durgapur,contras,gakuen,skagit,rabbinate,tsunamis,haphazard,tyldesley,microcontroller,discourages,hialeah,compressing,septimus,larvik,condoleezza,psilocybin,protectionism,songbirds,clandestinely,selectmen,wargame,cinemascope,khazars,agronomy,melzer,latifah,cherokees,recesses,assemblymen,basescu,banaras,bioavailability,subchannels,adenine,o'kelly,prabhakar,leonese,dimethyl,testimonials,geoffroy,oxidant,universiti,gheorghiu,bohdan,reversals,zamorin,herbivore,jarre,sebastiao,infanterie,dolmen,teddington,radomsko,spaceships,cuzco,recapitulation,mahoning,bainimarama,myelin,aykroyd,decals,tokelau,nalgonda,rajasthani,121st,quelled,tambov,illyrians,homilies,illuminations,hypertrophy,grodzisk,inundation,incapacity,equilibria,combats,elihu,steinitz,berengar,gowda,canwest,khosrau,maculata,houten,kandinsky,onside,leatherhead,heritable,belvidere,federative,chukchi,serling,eruptive,patan,entitlements,suffragette,evolutions,migrates,demobilisation,athleticism,trope,sarpsborg,kensal,translink,squamish,concertgebouw,energon,timestamp,competences,zalgiris,serviceman,codice_7,spoofing,assange,mahadevan,skien,suceava,augustan,revisionism,unconvincing,hollande,drina,gottlob,lippi,broglie,darkening,tilapia,eagerness,nacht,kolmogorov,photometric,leeuwarden,jrotc,haemorrhage,almanack,cavalli,repudiation,galactose,zwickau,cetinje,houbraken,heavyweights,gabonese,ordinals,noticias,museveni,steric,charaxes,amjad,resection,joinville,leczyca,anastasius,purbeck,subtribe,dalles,leadoff,monoamine,jettisoned,kaori,anthologized,alfreton,indic,bayezid,tottori,colonizing,assassinating,unchanging,eusebian,d'estaing,tsingtao,toshio,transferases,peronist,metrology,equus,mirpur,libertarianism,kovil,indole,'green,abstention,quantitatively,icebreakers,tribals,mainstays,dryandra,eyewear,nilgiri,chrysanthemum,inositol,frenetic,merchantman,hesar,physiotherapist,transceiver,dancefloor,rankine,neisse,marginalization,lengthen,unaided,rework,pageantry,savio,striated,funen,witton,illuminates,frass,hydrolases,akali,bistrita,copywriter,firings,handballer,tachinidae,dmytro,coalesce,neretva,menem,moraines,coatbridge,crossrail,spoofed,drosera,ripen,protour,kikuyu,boleslav,edwardes,troubadours,haplogroups,wrasse,educationalist,sroda,khaneh,dagbladet,apennines,neuroscientist,deplored,terje,maccabees,daventry,spaceport,lessening,ducats,singer/guitarist,chambersburg,yeong,configurable,ceremonially,unrelenting,caffe,graaf,denizens,kingsport,ingush,panhard,synthesised,tumulus,homeschooled,bozorg,idiomatic,thanhouser,queensway,radek,hippolytus,inking,banovina,peacocks,piaui,handsworth,pantomimes,abalone,thera,kurzweil,bandura,augustinians,bocelli,ferrol,jiroft,quadrature,contravention,saussure,rectification,agrippina,angelis,matanzas,nidaros,palestrina,latium,coriolis,clostridium,ordain,uttering,lanchester,proteolytic,ayacucho,merseburg,holbein,sambalpur,algebraically,inchon,ostfold,savoia,calatrava,lahiri,judgeship,ammonite,masaryk,meyerbeer,hemorrhagic,superspeedway,ningxia,panicles,encircles,khmelnytsky,profusion,esher,babol,inflationary,anhydride,gaspe,mossy,periodicity,nacion,meteorologists,mahjong,interventional,sarin,moult,enderby,modell,palgrave,warners,montcalm,siddha,functionalism,rilke,politicized,broadmoor,kunste,orden,brasileira,araneta,eroticism,colquhoun,mamba,blacktown,tubercle,seagrass,manoel,camphor,neoregelia,llandudno,annexe,enplanements,kamien,plovers,statisticians,iturbide,madrasah,nontrivial,publican,landholders,manama,uninhabitable,revivalist,trunkline,friendliness,gurudwara,rocketry,unido,tripos,besant,braque,evolutionarily,abkhazian,staffel,ratzinger,brockville,bohemond,intercut,djurgarden,utilitarianism,deploys,sastri,absolutism,subhas,asghar,fictions,sepinwall,proportionately,titleholders,thereon,foursquare,machinegun,knightsbridge,siauliai,aqaba,gearboxes,castaways,weakens,phallic,strzelce,buoyed,ruthenia,pharynx,intractable,neptunes,koine,leakey,netherlandish,preempted,vinay,terracing,instigating,alluvium,prosthetics,vorarlberg,politiques,joinery,reduplication,nebuchadnezzar,lenticular,banka,seaborne,pattinson,helpline,aleph,beckenham,californians,namgyal,franziska,aphid,branagh,transcribe,appropriateness,surakarta,takings,propagates,juraj,b0d3fb,brera,arrayed,tailback,falsehood,hazleton,prosody,egyptology,pinnate,tableware,ratan,camperdown,ethnologist,tabari,classifiers,biogas,126th,kabila,arbitron,apuestas,membranous,kincardine,oceana,glories,natick,populism,synonymy,ghalib,mobiles,motherboards,stationers,germinal,patronised,formula_58,gaborone,torts,jeezy,interleague,novaya,batticaloa,offshoots,wilbraham,filename,nswrfl,'well,trilobite,pythons,optimally,scientologists,rhesus,pilsen,backdrops,batang,unionville,hermanos,shrikes,fareham,outlawing,discontinuing,boisterous,shamokin,scanty,southwestward,exchangers,unexpired,mewar,h.m.s,saldanha,pawan,condorcet,turbidity,donau,indulgences,coincident,cliques,weeklies,bardhaman,violators,kenai,caspase,xperia,kunal,fistula,epistemic,cammell,nephi,disestablishment,rotator,germaniawerft,pyaar,chequered,jigme,perlis,anisotropic,popstars,kapil,appendices,berat,defecting,shacks,wrangel,panchayath,gorna,suckling,aerosols,sponheim,talal,borehole,encodings,enlai,subduing,agong,nadar,kitsap,syrmia,majumdar,pichilemu,charleville,embryology,booting,literati,abutting,basalts,jussi,repubblica,hertogenbosch,digitization,relents,hillfort,wiesenthal,kirche,bhagwan,bactrian,oases,phyla,neutralizing,helsing,ebooks,spearheading,margarine,'golden,phosphor,picea,stimulants,outliers,timescale,gynaecology,integrator,skyrocketed,bridgnorth,senecio,ramachandra,suffragist,arrowheads,aswan,inadvertent,microelectronics,118th,sofer,kubica,melanesian,tuanku,balkh,vyborg,crystallographic,initiators,metamorphism,ginzburg,looters,unimproved,finistere,newburyport,norges,immunities,franchisees,asterism,kortrijk,camorra,komsomol,fleurs,draughts,patagonian,voracious,artin,collaborationist,revolucion,revitalizing,xaver,purifying,antipsychotic,disjunct,pompeius,dreamwave,juvenal,beinn,adiyaman,antitank,allama,boletus,melanogaster,dumitru,caproni,aligns,athabaskan,stobart,phallus,veikkausliiga,hornsey,buffering,bourbons,dobruja,marga,borax,electrics,gangnam,motorcyclist,whidbey,draconian,lodger,galilean,sanctification,imitates,boldness,underboss,wheatland,cantabrian,terceira,maumee,redefining,uppercase,ostroda,characterise,universalism,equalized,syndicalism,haringey,masovia,deleuze,funkadelic,conceals,thuan,minsky,pluralistic,ludendorff,beekeeping,bonfires,endoscopic,abuts,prebend,jonkoping,amami,tribunes,yup'ik,awadh,gasification,pforzheim,reforma,antiwar,vaishnavism,maryville,inextricably,margrethe,empresa,neutrophils,sanctified,ponca,elachistidae,curiae,quartier,mannar,hyperplasia,wimax,busing,neologism,florins,underrepresented,digitised,nieuw,cooch,howards,frege,hughie,plied,swale,kapellmeister,vajpayee,quadrupled,aeronautique,dushanbe,custos,saltillo,kisan,tigray,manaus,epigrams,shamanic,peppered,frosts,promotion/relegation,concedes,zwingli,charentes,whangarei,hyung,spring/summer,sobre,eretz,initialization,sawai,ephemera,grandfathered,arnaldo,customised,permeated,parapets,growths,visegrad,estudios,altamont,provincia,apologises,stoppard,carburettor,rifts,kinematic,zhengzhou,eschatology,prakrit,folate,yvelines,scapula,stupas,rishon,reconfiguration,flutist,1680s,apostolate,proudhon,lakshman,articulating,stortford,faithfull,bitterns,upwelling,qur'anic,lidar,interferometry,waterlogged,koirala,ditton,wavefunction,fazal,babbage,antioxidants,lemberg,deadlocked,tolled,ramapo,mathematica,leiria,topologies,khali,photonic,balti,1080p,corrects,recommenced,polyglot,friezes,tiebreak,copacabana,cholmondeley,armband,abolishment,sheamus,buttes,glycolysis,cataloged,warrenton,sassari,kishan,foodservice,cryptanalysis,holmenkollen,cosplay,machi,yousuf,mangal,allying,fertiliser,otomi,charlevoix,metallurg,parisians,bottlenose,oakleigh,debug,cidade,accede,ligation,madhava,pillboxes,gatefold,aveyron,sorin,thirsk,immemorial,menelik,mehra,domingos,underpinned,fleshed,harshness,diphthong,crestwood,miskolc,dupri,pyrausta,muskingum,tuoba,prodi,incidences,waynesboro,marquesas,heydar,artesian,calinescu,nucleation,funders,covalently,compaction,derbies,seaters,sodor,tabular,amadou,peckinpah,o'halloran,zechariah,libyans,kartik,daihatsu,chandran,erzhu,heresies,superheated,yarder,dorde,tanjore,abusers,xuanwu,juniperus,moesia,trusteeship,birdwatching,beatz,moorcock,harbhajan,sanga,choreographic,photonics,boylston,amalgamate,prawns,electrifying,sarath,inaccurately,exclaims,powerpoint,chaining,cpusa,adulterous,saccharomyces,glogow,vfl/afl,syncretic,simla,persisting,functors,allosteric,euphorbiaceae,juryo,mlada,moana,gabala,thornycroft,kumanovo,ostrovsky,sitio,tutankhamun,sauropods,kardzhali,reinterpretation,sulpice,rosyth,originators,halesowen,delineation,asesoria,abatement,gardai,elytra,taillights,overlays,monsoons,sandpipers,ingmar,henrico,inaccuracy,irwell,arenabowl,elche,pressburg,signalman,interviewees,sinkhole,pendle,ecommerce,cellos,nebria,organometallic,surrealistic,propagandist,interlaken,canandaigua,aerials,coutinho,pascagoula,tonopah,letterkenny,gropius,carbons,hammocks,childe,polities,hosiery,donitz,suppresses,diaghilev,stroudsburg,bagram,pistoia,regenerating,unitarians,takeaway,offstage,vidin,glorification,bakunin,yavapai,lutzow,sabercats,witney,abrogated,gorlitz,validating,dodecahedron,stubbornly,telenor,glaxosmithkline,solapur,undesired,jellicoe,dramatization,four-and-a-half,seawall,waterpark,artaxerxes,vocalization,typographic,byung,sachsenhausen,shepparton,kissimmee,konnan,belsen,dhawan,khurd,mutagenesis,vejle,perrot,estradiol,formula_60,saros,chiloe,misiones,lamprey,terrains,speke,miasto,eigenvectors,haydock,reservist,corticosteroids,savitri,shinawatra,developmentally,yehudi,berates,janissaries,recapturing,rancheria,subplots,gresley,nikkatsu,oryol,cosmas,boavista,formula_59,playfully,subsections,commentated,kathakali,dorid,vilaine,seepage,hylidae,keiji,kazakhs,triphosphate,1620s,supersede,monarchists,falla,miyako,notching,bhumibol,polarizing,secularized,shingled,bronislaw,lockerbie,soleyman,bundesbahn,latakia,redoubts,boult,inwardly,invents,ondrej,minangkabau,newquay,permanente,alhaji,madhav,malini,ellice,bookmaker,mankiewicz,etihad,o'dea,interrogative,mikawa,wallsend,canisius,bluesy,vitruvius,noord,ratifying,mixtec,gujranwala,subprefecture,keelung,goiania,nyssa,shi'ite,semitone,ch'uan,computerised,pertuan,catapults,nepomuk,shruti,millstones,buskerud,acolytes,tredegar,sarum,armia,dell'arte,devises,custodians,upturned,gallaudet,disembarking,thrashed,sagrada,myeon,undeclared,qumran,gaiden,tepco,janesville,showground,condense,chalon,unstaffed,pasay,undemocratic,hauts,viridis,uninjured,escutcheon,gymkhana,petaling,hammam,dislocations,tallaght,rerum,shias,indios,guaranty,simplicial,benares,benediction,tajiri,prolifically,huawei,onerous,grantee,ferencvaros,otranto,carbonates,conceit,digipak,qadri,masterclasses,swamiji,cradock,plunket,helmsman,119th,salutes,tippecanoe,murshidabad,intelligibility,mittal,diversifying,bidar,asansol,crowdsourcing,rovere,karakoram,grindcore,skylights,tulagi,furrows,ligne,stuka,sumer,subgraph,amata,regionalist,bulkeley,teletext,glorify,readied,lexicographer,sabadell,predictability,quilmes,phenylalanine,bandaranaike,pyrmont,marksmen,quisling,viscountess,sociopolitical,afoul,pediments,swazi,martyrology,nullify,panagiotis,superconductors,veldenz,jujuy,l'isle,hematopoietic,shafi,subsea,hattiesburg,jyvaskyla,kebir,myeloid,landmine,derecho,amerindians,birkenau,scriabin,milhaud,mucosal,nikaya,freikorps,theoretician,proconsul,o'hanlon,clerked,bactria,houma,macular,topologically,shrubby,aryeh,ghazali,afferent,magalhaes,moduli,ashtabula,vidarbha,securitate,ludwigsburg,adoor,varun,shuja,khatun,chengde,bushels,lascelles,professionnelle,elfman,rangpur,unpowered,citytv,chojnice,quaternion,stokowski,aschaffenburg,commutes,subramaniam,methylene,satrap,gharb,namesakes,rathore,helier,gestational,heraklion,colliers,giannis,pastureland,evocation,krefeld,mahadeva,churchmen,egret,yilmaz,galeazzo,pudukkottai,artigas,generalitat,mudslides,frescoed,enfeoffed,aphorisms,melilla,montaigne,gauliga,parkdale,mauboy,linings,prema,sapir,xylophone,kushan,rockne,sequoyah,vasyl,rectilinear,vidyasagar,microcosm,san'a,carcinogen,thicknesses,aleut,farcical,moderating,detested,hegemonic,instalments,vauban,verwaltungsgemeinschaft,picayune,razorback,magellanic,moluccas,pankhurst,exportation,waldegrave,sufferer,bayswater,1up.com,rearmament,orangutans,varazdin,b.o.b,elucidate,harlingen,erudition,brankovic,lapis,slipway,urraca,shinde,unwell,elwes,euboea,colwyn,srivijaya,grandstands,hortons,generalleutnant,fluxes,peterhead,gandhian,reals,alauddin,maximized,fairhaven,endow,ciechanow,perforations,darters,panellist,manmade,litigants,exhibitor,tirol,caracalla,conformance,hotelier,stabaek,hearths,borac,frisians,ident,veliko,emulators,schoharie,uzbeks,samarra,prestwick,wadia,universita,tanah,bucculatrix,predominates,genotypes,denounces,roadsides,ganassi,keokuk,philatelist,tomic,ingots,conduits,samplers,abdus,johar,allegories,timaru,wolfpacks,secunda,smeaton,sportivo,inverting,contraindications,whisperer,moradabad,calamities,bakufu,soundscape,smallholders,nadeem,crossroad,xenophobic,zakir,nationalliga,glazes,retroflex,schwyz,moroder,rubra,quraysh,theodoros,endemol,infidels,km/hr,repositioned,portraitist,lluis,answerable,arges,mindedness,coarser,eyewall,teleported,scolds,uppland,vibraphone,ricoh,isenburg,bricklayer,cuttlefish,abstentions,communicable,cephalopod,stockyards,balto,kinston,armbar,bandini,elphaba,maxims,bedouins,sachsen,friedkin,tractate,pamir,ivanovo,mohini,kovalainen,nambiar,melvyn,orthonormal,matsuyama,cuernavaca,veloso,overstated,streamer,dravid,informers,analyte,sympathized,streetscape,gosta,thomasville,grigore,futuna,depleting,whelks,kiedis,armadale,earner,wynyard,dothan,animating,tridentine,sabri,immovable,rivoli,ariege,parley,clinker,circulates,junagadh,fraunhofer,congregants,180th,buducnost,formula_62,olmert,dedekind,karnak,bayernliga,mazes,sandpiper,ecclestone,yuvan,smallmouth,decolonization,lemmy,adjudicated,retiro,legia,benue,posit,acidification,wahab,taconic,floatplane,perchlorate,atria,wisbech,divestment,dallara,phrygia,palustris,cybersecurity,rebates,facie,mineralogical,substituent,proteges,fowey,mayenne,smoothbore,cherwell,schwarzschild,junin,murrumbidgee,smalltalk,d'orsay,emirati,calaveras,titusville,theremin,vikramaditya,wampanoag,burra,plaines,onegin,emboldened,whampoa,langa,soderbergh,arnaz,sowerby,arendal,godunov,pathanamthitta,damselfly,bestowing,eurosport,iconoclasm,outfitters,acquiesced,badawi,hypotension,ebbsfleet,annulus,sohrab,thenceforth,chagatai,necessitates,aulus,oddities,toynbee,uniontown,innervation,populaire,indivisible,rossellini,minuet,cyrene,gyeongju,chania,cichlids,harrods,1690s,plunges,abdullahi,gurkhas,homebuilt,sortable,bangui,rediff,incrementally,demetrios,medaille,sportif,svend,guttenberg,tubules,carthusian,pleiades,torii,hoppus,phenyl,hanno,conyngham,teschen,cronenberg,wordless,melatonin,distinctiveness,autos,freising,xuanzang,dunwich,satanism,sweyn,predrag,contractually,pavlovic,malaysians,micrometres,expertly,pannonian,abstaining,capensis,southwesterly,catchphrases,commercialize,frankivsk,normanton,hibernate,verso,deportees,dubliners,codice_8,condors,zagros,glosses,leadville,conscript,morrisons,usury,ossian,oulton,vaccinium,civet,ayman,codrington,hadron,nanometers,geochemistry,extractor,grigori,tyrrhenian,neocollyris,drooping,falsification,werft,courtauld,brigantine,orhan,chapultepec,supercopa,federalized,praga,havering,encampments,infallibility,sardis,pawar,undirected,reconstructionist,ardrossan,varuna,pastimes,archdiocesan,fledging,shenhua,molise,secondarily,stagnated,replicates,ciencias,duryodhana,marauding,ruislip,ilyich,intermixed,ravenswood,shimazu,mycorrhizal,icosahedral,consents,dunblane,follicular,pekin,suffield,muromachi,kinsale,gauche,businesspeople,thereto,watauga,exaltation,chelmno,gorse,proliferate,drainages,burdwan,kangra,transducers,inductor,duvalier,maguindanao,moslem,uncaf,givenchy,plantarum,liturgics,telegraphs,lukashenko,chenango,andante,novae,ironwood,faubourg,torme,chinensis,ambala,pietermaritzburg,virginians,landform,bottlenecks,o'driscoll,darbhanga,baptistery,ameer,needlework,naperville,auditoriums,mullingar,starrer,animatronic,topsoil,madura,cannock,vernet,santurce,catocala,ozeki,pontevedra,multichannel,sundsvall,strategists,medio,135th,halil,afridi,trelawny,caloric,ghraib,allendale,hameed,ludwigshafen,spurned,pavlo,palmar,strafed,catamarca,aveiro,harmonization,surah,predictors,solvay,mande,omnipresent,parenthesis,echolocation,equaling,experimenters,acyclic,lithographic,sepoys,katarzyna,sridevi,impoundment,khosrow,caesarean,nacogdoches,rockdale,lawmaker,caucasians,bahman,miyan,rubric,exuberance,bombastic,ductile,snowdonia,inlays,pinyon,anemones,hurries,hospitallers,tayyip,pulleys,treme,photovoltaics,testbed,polonium,ryszard,osgoode,profiting,ironwork,unsurpassed,nepticulidae,makai,lumbini,preclassic,clarksburg,egremont,videography,rehabilitating,ponty,sardonic,geotechnical,khurasan,solzhenitsyn,henna,phoenicia,rhyolite,chateaux,retorted,tomar,deflections,repressions,harborough,renan,brumbies,vandross,storia,vodou,clerkenwell,decking,universo,salon.com,imprisoning,sudwest,ghaziabad,subscribing,pisgah,sukhumi,econometric,clearest,pindar,yildirim,iulia,atlases,cements,remaster,dugouts,collapsible,resurrecting,batik,unreliability,thiers,conjunctions,colophon,marcher,placeholder,flagella,wolds,kibaki,viviparous,twelver,screenshots,aroostook,khadr,iconographic,itasca,jaume,basti,propounded,varro,be'er,jeevan,exacted,shrublands,creditable,brocade,boras,bittern,oneonta,attentional,herzliya,comprehensible,lakeville,discards,caxias,frankland,camerata,satoru,matlab,commutator,interprovincial,yorkville,benefices,nizami,edwardsville,amigaos,cannabinoid,indianola,amateurliga,pernicious,ubiquity,anarchic,novelties,precondition,zardari,symington,sargodha,headphone,thermopylae,mashonaland,zindagi,thalberg,loewe,surfactants,dobro,crocodilians,samhita,diatoms,haileybury,berwickshire,supercritical,sofie,snorna,slatina,intramolecular,agung,osteoarthritis,obstetric,teochew,vakhtang,connemara,deformations,diadem,ferruccio,mainichi,qualitatively,refrigerant,rerecorded,methylated,karmapa,krasinski,restatement,rouvas,cubitt,seacoast,schwarzkopf,homonymous,shipowner,thiamine,approachable,xiahou,160th,ecumenism,polistes,internazionali,fouad,berar,biogeography,texting,inadequately,'when,4kids,hymenoptera,emplaced,cognomen,bellefonte,supplant,michaelmas,uriel,tafsir,morazan,schweinfurt,chorister,ps400,nscaa,petipa,resolutely,ouagadougou,mascarene,supercell,konstanz,bagrat,harmonix,bergson,shrimps,resonators,veneta,camas,mynydd,rumford,generalmajor,khayyam,web.com,pappus,halfdan,tanana,suomen,yutaka,bibliographical,traian,silat,noailles,contrapuntal,agaricus,'special,minibuses,1670s,obadiah,deepa,rorschach,malolos,lymington,valuations,imperials,caballeros,ambroise,judicature,elegiac,sedaka,shewa,checksum,gosforth,legionaries,corneille,microregion,friedrichshafen,antonis,surnamed,mycelium,cantus,educations,topmost,outfitting,ivica,nankai,gouda,anthemic,iosif,supercontinent,antifungal,belarusians,mudaliar,mohawks,caversham,glaciated,basemen,stevan,clonmel,loughton,deventer,positivist,manipuri,tensors,panipat,changeup,impermeable,dubbo,elfsborg,maritimo,regimens,bikram,bromeliad,substratum,norodom,gaultier,queanbeyan,pompeo,redacted,eurocopter,mothballed,centaurs,borno,copra,bemidji,'home,sopron,neuquen,passo,cineplex,alexandrov,wysokie,mammoths,yossi,sarcophagi,congreve,petkovic,extraneous,waterbirds,slurs,indias,phaeton,discontented,prefaced,abhay,prescot,interoperable,nordisk,bicyclists,validly,sejong,litovsk,zanesville,kapitanleutnant,kerch,changeable,mcclatchy,celebi,attesting,maccoll,sepahan,wayans,veined,gaudens,markt,dansk,soane,quantized,petersham,forebears,nayarit,frenzied,queuing,bygone,viggo,ludwik,tanka,hanssen,brythonic,cornhill,primorsky,stockpiles,conceptualization,lampeter,hinsdale,mesoderm,bielsk,rosenheim,ultron,joffrey,stanwyck,khagan,tiraspol,pavelic,ascendant,empoli,metatarsal,descentralizado,masada,ligier,huseyin,ramadi,waratah,tampines,ruthenium,statoil,mladost,liger,grecian,multiparty,digraph,maglev,reconsideration,radiography,cartilaginous,taizu,wintered,anabaptist,peterhouse,shoghi,assessors,numerator,paulet,painstakingly,halakhic,rocroi,motorcycling,gimel,kryptonian,emmeline,cheeked,drawdown,lelouch,dacians,brahmana,reminiscence,disinfection,optimizations,golders,extensor,tsugaru,tolling,liman,gulzar,unconvinced,crataegus,oppositional,dvina,pyrolysis,mandan,alexius,prion,stressors,loomed,moated,dhivehi,recyclable,relict,nestlings,sarandon,kosovar,solvers,czeslaw,kenta,maneuverable,middens,berkhamsted,comilla,folkways,loxton,beziers,batumi,petrochemicals,optimised,sirjan,rabindra,musicality,rationalisation,drillers,subspaces,'live,bbwaa,outfielders,tsung,danske,vandalised,norristown,striae,kanata,gastroenterology,steadfastly,equalising,bootlegging,mannerheim,notodontidae,lagoa,commentating,peninsulas,chishti,seismology,modigliani,preceptor,canonically,awardee,boyaca,hsinchu,stiffened,nacelle,bogor,dryness,unobstructed,yaqub,scindia,peeters,irritant,ammonites,ferromagnetic,speechwriter,oxygenated,walesa,millais,canarian,faience,calvinistic,discriminant,rasht,inker,annexes,howth,allocates,conditionally,roused,regionalism,regionalbahn,functionary,nitrates,bicentenary,recreates,saboteurs,koshi,plasmids,thinned,124th,plainview,kardashian,neuville,victorians,radiates,127th,vieques,schoolmates,petru,tokusatsu,keying,sunaina,flamethrower,'bout,demersal,hosokawa,corelli,omniscient,o'doherty,niksic,reflectivity,transdev,cavour,metronome,temporally,gabba,nsaids,geert,mayport,hematite,boeotia,vaudreuil,torshavn,sailplane,mineralogist,eskisehir,practises,gallifrey,takumi,unease,slipstream,hedmark,paulinus,ailsa,wielkopolska,filmworks,adamantly,vinaya,facelifted,franchisee,augustana,toppling,velvety,crispa,stonington,histological,genealogist,tactician,tebow,betjeman,nyingma,overwinter,oberoi,rampal,overwinters,petaluma,lactarius,stanmore,balikpapan,vasant,inclines,laminate,munshi,sociedade,rabbah,septal,boyband,ingrained,faltering,inhumans,nhtsa,affix,l'ordre,kazuki,rossendale,mysims,latvians,slaveholders,basilicata,neuburg,assize,manzanillo,scrobipalpa,formula_61,belgique,pterosaurs,privateering,vaasa,veria,northport,pressurised,hobbyist,austerlitz,sahih,bhadra,siliguri,bistrica,bursaries,wynton,corot,lepidus,lully,libor,libera,olusegun,choline,mannerism,lymphocyte,chagos,duxbury,parasitism,ecowas,morotai,cancion,coniston,aggrieved,sputnikmusic,parle,ammonian,civilisations,malformation,cattaraugus,skyhawks,d'arc,demerara,bronfman,midwinter,piscataway,jogaila,threonine,matins,kohlberg,hubli,pentatonic,camillus,nigam,potro,unchained,chauvel,orangeville,cistercians,redeployment,xanthi,manju,carabinieri,pakeha,nikolaevich,kantakouzenos,sesquicentennial,gunships,symbolised,teramo,ballo,crusading,l'oeil,bharatpur,lazier,gabrovo,hysteresis,rothbard,chaumont,roundel,ma'mun,sudhir,queried,newts,shimane,presynaptic,playfield,taxonomists,sensitivities,freleng,burkinabe,orfeo,autovia,proselytizing,bhangra,pasok,jujutsu,heung,pivoting,hominid,commending,formula_64,epworth,christianized,oresund,hantuchova,rajputana,hilversum,masoretic,dayak,bakri,assen,magog,macromolecules,waheed,qaida,spassky,rumped,protrudes,preminger,misogyny,glencairn,salafi,lacunae,grilles,racemes,areva,alighieri,inari,epitomized,photoshoot,one-of-a-kind,tring,muralist,tincture,backwaters,weaned,yeasts,analytically,smaland,caltrans,vysocina,jamuna,mauthausen,175th,nouvelles,censoring,reggina,christology,gilad,amplifying,mehmood,johnsons,redirects,eastgate,sacrum,meteoric,riverbanks,guidebooks,ascribes,scoparia,iconoclastic,telegraphic,chine,merah,mistico,lectern,sheung,aethelstan,capablanca,anant,uspto,albatrosses,mymensingh,antiretroviral,clonal,coorg,vaillant,liquidator,gigas,yokai,eradicating,motorcyclists,waitakere,tandon,nears,montenegrins,250th,tatsuya,yassin,atheistic,syncretism,nahum,berisha,transcended,owensboro,lakshmana,abteilung,unadorned,nyack,overflows,harrisonburg,complainant,uematsu,frictional,worsens,sangguniang,abutment,bulwer,sarma,apollinaire,shippers,lycia,alentejo,porpoises,optus,trawling,augustow,blackwall,workbench,westmount,leaped,sikandar,conveniences,stornoway,culverts,zoroastrians,hristo,ansgar,assistive,reassert,fanned,compasses,delgada,maisons,arima,plonsk,verlaine,starstruck,rakhine,befell,spirally,wyclef,expend,colloquium,formula_63,albertus,bellarmine,handedness,holon,introns,movimiento,profitably,lohengrin,discoverers,awash,erste,pharisees,dwarka,oghuz,hashing,heterodox,uloom,vladikavkaz,linesman,rehired,nucleophile,germanicus,gulshan,songz,bayerische,paralympian,crumlin,enjoined,khanum,prahran,penitent,amersfoort,saranac,semisimple,vagrants,compositing,tualatin,oxalate,lavra,ironi,ilkeston,umpqua,calum,stretford,zakat,guelders,hydrazine,birkin,spurring,modularity,aspartate,sodermanland,hopital,bellary,legazpi,clasico,cadfael,hypersonic,volleys,pharmacokinetics,carotene,orientale,pausini,bataille,lunga,retailed,m.phil,mazowieckie,vijayan,rawal,sublimation,promissory,estimators,ploughed,conflagration,penda,segregationist,otley,amputee,coauthor,sopra,pellew,wreckers,tollywood,circumscription,permittivity,strabane,landward,articulates,beaverbrook,rutherglen,coterminous,whistleblowers,colloidal,surbiton,atlante,oswiecim,bhasa,lampooned,chanter,saarc,landkreis,tribulation,tolerates,daiichi,hatun,cowries,dyschirius,abercromby,attock,aldwych,inflows,absolutist,l'histoire,committeeman,vanbrugh,headstock,westbourne,appenzell,hoxton,oculus,westfalen,roundabouts,nickelback,trovatore,quenching,summarises,conservators,transmutation,talleyrand,barzani,unwillingly,axonal,'blue,opining,enveloping,fidesz,rafah,colborne,flickr,lozenge,dulcimer,ndebele,swaraj,oxidize,gonville,resonated,gilani,superiore,endeared,janakpur,shepperton,solidifying,memoranda,sochaux,kurnool,rewari,emirs,kooning,bruford,unavailability,kayseri,judicious,negating,pterosaur,cytosolic,chernihiv,variational,sabretooth,seawolves,devalued,nanded,adverb,volunteerism,sealers,nemours,smederevo,kashubian,bartin,animax,vicomte,polotsk,polder,archiepiscopal,acceptability,quidditch,tussock,seminaire,immolation,belge,coves,wellingborough,khaganate,mckellen,nayaka,brega,kabhi,pontoons,bascule,newsreels,injectors,cobol,weblog,diplo,biggar,wheatbelt,erythrocytes,pedra,showgrounds,bogdanovich,eclecticism,toluene,elegies,formalize,andromedae,airworthiness,springville,mainframes,overexpression,magadha,bijelo,emlyn,glutamine,accenture,uhuru,metairie,arabidopsis,patanjali,peruvians,berezovsky,accion,astrolabe,jayanti,earnestly,sausalito,recurved,1500s,ramla,incineration,galleons,laplacian,shiki,smethwick,isomerase,dordevic,janow,jeffersonville,internationalism,penciled,styrene,ashur,nucleoside,peristome,horsemanship,sedges,bachata,medes,kristallnacht,schneerson,reflectance,invalided,strutt,draupadi,destino,partridges,tejas,quadrennial,aurel,halych,ethnomusicology,autonomist,radyo,rifting,shi'ar,crvena,telefilm,zawahiri,plana,sultanates,theodorus,subcontractors,pavle,seneschal,teleports,chernivtsi,buccal,brattleboro,stankovic,safar,dunhuang,electrocution,chastised,ergonomic,midsomer,130th,zomba,nongovernmental,escapist,localize,xuzhou,kyrie,carinthian,karlovac,nisan,kramnik,pilipino,digitisation,khasi,andronicus,highwayman,maior,misspelling,sebastopol,socon,rhaetian,archimandrite,partway,positivity,otaku,dingoes,tarski,geopolitics,disciplinarian,zulfikar,kenzo,globose,electrophilic,modele,storekeeper,pohang,wheldon,washers,interconnecting,digraphs,intrastate,campy,helvetic,frontispiece,ferrocarril,anambra,petraeus,midrib,endometrial,dwarfism,mauryan,endocytosis,brigs,percussionists,furtherance,synergistic,apocynaceae,krona,berthier,circumvented,casal,siltstone,precast,ethnikos,realists,geodesy,zarzuela,greenback,tripathi,persevered,interments,neutralization,olbermann,departements,supercomputing,demobilised,cassavetes,dunder,ministering,veszprem,barbarism,'world,pieve,apologist,frentzen,sulfides,firewalls,pronotum,staatsoper,hachette,makhachkala,oberland,phonon,yoshihiro,instars,purnima,winslet,mutsu,ergative,sajid,nizamuddin,paraphrased,ardeidae,kodagu,monooxygenase,skirmishers,sportiva,o'byrne,mykolaiv,ophir,prieta,gyllenhaal,kantian,leche,copan,herero,ps250,gelsenkirchen,shalit,sammarinese,chetwynd,wftda,travertine,warta,sigmaringen,concerti,namespace,ostergotland,biomarker,universals,collegio,embarcadero,wimborne,fiddlers,likening,ransomed,stifled,unabated,kalakaua,khanty,gongs,goodrem,countermeasure,publicizing,geomorphology,swedenborg,undefended,catastrophes,diverts,storyboards,amesbury,contactless,placentia,festivity,authorise,terrane,thallium,stradivarius,antonine,consortia,estimations,consecrate,supergiant,belichick,pendants,butyl,groza,univac,afire,kavala,studi,teletoon,paucity,gonbad,koninklijke,128th,stoichiometric,multimodal,facundo,anatomic,melamine,creuse,altan,brigands,mcguinty,blomfield,tsvangirai,protrusion,lurgan,warminster,tenzin,russellville,discursive,definable,scotrail,lignin,reincorporated,o'dell,outperform,redland,multicolored,evaporates,dimitrie,limbic,patapsco,interlingua,surrogacy,cutty,potrero,masud,cahiers,jintao,ardashir,centaurus,plagiarized,minehead,musings,statuettes,logarithms,seaview,prohibitively,downforce,rivington,tomorrowland,microbiologist,ferric,morag,capsid,kucinich,clairvaux,demotic,seamanship,cicada,painterly,cromarty,carbonic,tupou,oconee,tehuantepec,typecast,anstruther,internalized,underwriters,tetrahedra,flagrant,quakes,pathologies,ulrik,nahal,tarquini,dongguan,parnassus,ryoko,senussi,seleucia,airasia,einer,sashes,d'amico,matriculating,arabesque,honved,biophysical,hardinge,kherson,mommsen,diels,icbms,reshape,brasiliensis,palmach,netaji,oblate,functionalities,grigor,blacksburg,recoilless,melanchthon,reales,astrodome,handcrafted,memes,theorizes,isma'il,aarti,pirin,maatschappij,stabilizes,honiara,ashbury,copts,rootes,defensed,queiroz,mantegna,galesburg,coraciiformesfamily,cabrillo,tokio,antipsychotics,kanon,173rd,apollonia,finial,lydian,hadamard,rangi,dowlatabad,monolingual,platformer,subclasses,chiranjeevi,mirabeau,newsgroup,idmanyurdu,kambojas,walkover,zamoyski,generalist,khedive,flanges,knowle,bande,157th,alleyn,reaffirm,pininfarina,zuckerberg,hakodate,131st,aditi,bellinzona,vaulter,planking,boscombe,colombians,lysis,toppers,metered,nahyan,queensryche,minho,nagercoil,firebrand,foundress,bycatch,mendota,freeform,antena,capitalisation,martinus,overijssel,purists,interventionist,zgierz,burgundians,hippolyta,trompe,umatilla,moroccans,dictionnaire,hydrography,changers,chota,rimouski,aniline,bylaw,grandnephew,neamt,lemnos,connoisseurs,tractive,rearrangements,fetishism,finnic,apalachicola,landowning,calligraphic,circumpolar,mansfeld,legible,orientalism,tannhauser,blamey,maximization,noinclude,blackbirds,angara,ostersund,pancreatitis,glabra,acleris,juried,jungian,triumphantly,singlet,plasmas,synesthesia,yellowhead,unleashes,choiseul,quanzhong,brookville,kaskaskia,igcse,skatepark,jatin,jewellers,scaritinae,techcrunch,tellurium,lachaise,azuma,codeshare,dimensionality,unidirectional,scolaire,macdill,camshafts,unassisted,verband,kahlo,eliya,prelature,chiefdoms,saddleback,sockers,iommi,coloratura,llangollen,biosciences,harshest,maithili,k'iche,plical,multifunctional,andreu,tuskers,confounding,sambre,quarterdeck,ascetics,berdych,transversal,tuolumne,sagami,petrobras,brecker,menxia,instilling,stipulating,korra,oscillate,deadpan,v/line,pyrotechnic,stoneware,prelims,intracoastal,retraining,ilija,berwyn,encrypt,achievers,zulfiqar,glycoproteins,khatib,farmsteads,occultist,saman,fionn,derulo,khilji,obrenovic,argosy,toowong,dementieva,sociocultural,iconostasis,craigslist,festschrift,taifa,intercalated,tanjong,penticton,sharad,marxian,extrapolation,guises,wettin,prabang,exclaiming,kosta,famas,conakry,wanderings,'aliabad,macleay,exoplanet,bancorp,besiegers,surmounting,checkerboard,rajab,vliet,tarek,operable,wargaming,haldimand,fukuyama,uesugi,aggregations,erbil,brachiopods,tokyu,anglais,unfavorably,ujpest,escorial,armagnac,nagara,funafuti,ridgeline,cocking,o'gorman,compactness,retardant,krajowa,barua,coking,bestows,thampi,chicagoland,variably,o'loughlin,minnows,schwa,shaukat,polycarbonate,chlorinated,godalming,gramercy,delved,banqueting,enlil,sarada,prasanna,domhnall,decadal,regressive,lipoprotein,collectable,surendra,zaporizhia,cycliste,suchet,offsetting,formula_65,pudong,d'arte,blyton,quonset,osmania,tientsin,manorama,proteomics,bille,jalpaiguri,pertwee,barnegat,inventiveness,gollancz,euthanized,henricus,shortfalls,wuxia,chlorides,cerrado,polyvinyl,folktale,straddled,bioengineering,eschewing,greendale,recharged,olave,ceylonese,autocephalous,peacebuilding,wrights,guyed,rosamund,abitibi,bannockburn,gerontology,scutari,souness,seagram,codice_9,'open,xhtml,taguig,purposed,darbar,orthopedics,unpopulated,kisumu,tarrytown,feodor,polyhedral,monadnock,gottorp,priam,redesigning,gasworks,elfin,urquiza,homologation,filipovic,bohun,manningham,gornik,soundness,shorea,lanus,gelder,darke,sandgate,criticality,paranaense,153rd,vieja,lithograph,trapezoid,tiebreakers,convalescence,yan'an,actuaries,balad,altimeter,thermoelectric,trailblazer,previn,tenryu,ancaster,endoscopy,nicolet,discloses,fracking,plaine,salado,americanism,placards,absurdist,propylene,breccia,jirga,documenta,ismailis,161st,brentano,dallas/fort,embellishment,calipers,subscribes,mahavidyalaya,wednesbury,barnstormers,miwok,schembechler,minigame,unterberger,dopaminergic,inacio,nizamabad,overridden,monotype,cavernous,stichting,sassafras,sotho,argentinean,myrrh,rapidity,flatts,gowrie,dejected,kasaragod,cyprinidae,interlinked,arcseconds,degeneracy,infamously,incubate,substructure,trigeminal,sectarianism,marshlands,hooliganism,hurlers,isolationist,urania,burrard,switchover,lecco,wilts,interrogator,strived,ballooning,volterra,raciborz,relegating,gilding,cybele,dolomites,parachutist,lochaber,orators,raeburn,backend,benaud,rallycross,facings,banga,nuclides,defencemen,futurity,emitters,yadkin,eudonia,zambales,manasseh,sirte,meshes,peculiarly,mcminnville,roundly,boban,decrypt,icelanders,sanam,chelan,jovian,grudgingly,penalised,subscript,gambrinus,poaceae,infringements,maleficent,runciman,148th,supersymmetry,granites,liskeard,eliciting,involution,hallstatt,kitzbuhel,shankly,sandhills,inefficiencies,yishuv,psychotropic,nightjars,wavell,sangamon,vaikundar,choshu,retrospectives,pitesti,gigantea,hashemi,bosna,gakuin,siochana,arrangers,baronetcies,narayani,temecula,creston,koscierzyna,autochthonous,wyandot,anniston,igreja,mobilise,buzau,dunster,musselburgh,wenzhou,khattak,detoxification,decarboxylase,manlius,campbells,coleoptera,copyist,sympathisers,suisun,eminescu,defensor,transshipment,thurgau,somerton,fluctuates,ambika,weierstrass,lukow,giambattista,volcanics,romanticized,innovated,matabeleland,scotiabank,garwolin,purine,d'auvergne,borderland,maozhen,pricewaterhousecoopers,testator,pallium,scout.com,mv/pi,nazca,curacies,upjohn,sarasvati,monegasque,ketrzyn,malory,spikelets,biomechanics,haciendas,rapped,dwarfed,stews,nijinsky,subjection,matsu,perceptible,schwarzburg,midsection,entertains,circuitous,epiphytic,wonsan,alpini,bluefield,sloths,transportable,braunfels,dictum,szczecinek,jukka,wielun,wejherowo,hucknall,grameen,duodenum,ribose,deshpande,shahar,nexstar,injurious,dereham,lithographer,dhoni,structuralist,progreso,deschutes,christus,pulteney,quoins,yitzchak,gyeongsang,breviary,makkah,chiyoda,jutting,vineland,angiosperms,necrotic,novelisation,redistribute,tirumala,140th,featureless,mafic,rivaling,toyline,2/1st,martius,saalfeld,monthan,texian,kathak,melodramas,mithila,regierungsbezirk,509th,fermenting,schoolmate,virtuosic,briain,kokoda,heliocentric,handpicked,kilwinning,sonically,dinars,kasim,parkways,bogdanov,luxembourgian,halland,avesta,bardic,daugavpils,excavator,qwest,frustrate,physiographic,majoris,'ndrangheta,unrestrained,firmness,montalban,abundances,preservationists,adare,executioners,guardsman,bonnaroo,neglects,nazrul,pro12,hoorn,abercorn,refuting,kabud,cationic,parapsychology,troposphere,venezuelans,malignancy,khoja,unhindered,accordionist,medak,visby,ejercito,laparoscopic,dinas,umayyads,valmiki,o'dowd,saplings,stranding,incisions,illusionist,avocets,buccleuch,amazonia,fourfold,turboprops,roosts,priscus,turnstile,areal,certifies,pocklington,spoofs,viseu,commonalities,dabrowka,annam,homesteaders,daredevils,mondrian,negotiates,fiestas,perennials,maximizes,lubavitch,ravindra,scrapers,finials,kintyre,violas,snoqualmie,wilders,openbsd,mlawa,peritoneal,devarajan,congke,leszno,mercurial,fakir,joannes,bognor,overloading,unbuilt,gurung,scuttle,temperaments,bautzen,jardim,tradesman,visitations,barbet,sagamore,graaff,forecasters,wilsons,assis,l'air,shariah,sochaczew,russa,dirge,biliary,neuve,heartbreakers,strathearn,jacobian,overgrazing,edrich,anticline,parathyroid,petula,lepanto,decius,channelled,parvathi,puppeteers,communicators,francorchamps,kahane,longus,panjang,intron,traite,xxvii,matsuri,amrit,katyn,disheartened,cacak,omonia,alexandrine,partaking,wrangling,adjuvant,haskovo,tendrils,greensand,lammermoor,otherworld,volusia,stabling,one-and-a-half,bresson,zapatista,eotvos,ps150,webisodes,stepchildren,microarray,braganca,quanta,dolne,superoxide,bellona,delineate,ratha,lindenwood,bruhl,cingulate,tallies,bickerton,helgi,bevin,takoma,tsukuba,statuses,changeling,alister,bytom,dibrugarh,magnesia,duplicating,outlier,abated,goncalo,strelitz,shikai,mardan,musculature,ascomycota,springhill,tumuli,gabaa,odenwald,reformatted,autocracy,theresienstadt,suplex,chattopadhyay,mencken,congratulatory,weatherfield,systema,solemnity,projekt,quanzhou,kreuzberg,postbellum,nobuo,mediaworks,finisterre,matchplay,bangladeshis,kothen,oocyte,hovered,aromas,afshar,browed,teases,chorlton,arshad,cesaro,backbencher,iquique,vulcans,padmini,unabridged,cyclase,despotic,kirilenko,achaean,queensberry,debre,octahedron,iphigenia,curbing,karimnagar,sagarmatha,smelters,surrealists,sanada,shrestha,turridae,leasehold,jiedushi,eurythmics,appropriating,correze,thimphu,amery,musicomh,cyborgs,sandwell,pushcart,retorts,ameliorate,deteriorates,stojanovic,spline,entrenchments,bourse,chancellorship,pasolini,lendl,personage,reformulated,pubescens,loiret,metalurh,reinvention,nonhuman,eilema,tarsal,complutense,magne,broadview,metrodome,outtake,stouffville,seinen,bataillon,phosphoric,ostensible,opatow,aristides,beefheart,glorifying,banten,romsey,seamounts,fushimi,prophylaxis,sibylla,ranjith,goslar,balustrades,georgiev,caird,lafitte,peano,canso,bankura,halfpenny,segregate,caisson,bizerte,jamshedpur,euromaidan,philosophie,ridged,cheerfully,reclassification,aemilius,visionaries,samoans,wokingham,chemung,wolof,unbranched,cinerea,bhosle,ourense,immortalised,cornerstones,sourcebook,khufu,archimedean,universitatea,intermolecular,fiscally,suffices,metacomet,adjudicator,stablemate,specks,glace,inowroclaw,patristic,muharram,agitating,ashot,neurologic,didcot,gamla,ilves,putouts,siraj,laski,coaling,diarmuid,ratnagiri,rotulorum,liquefaction,morbihan,harel,aftershock,gruiformesfamily,bonnier,falconiformesfamily,adorns,wikis,maastrichtian,stauffenberg,bishopsgate,fakhr,sevenfold,ponders,quantifying,castiel,opacity,depredations,lenten,gravitated,o'mahony,modulates,inuktitut,paston,kayfabe,vagus,legalised,balked,arianism,tendering,sivas,birthdate,awlaki,khvajeh,shahab,samtgemeinde,bridgeton,amalgamations,biogenesis,recharging,tsukasa,mythbusters,chamfered,enthronement,freelancers,maharana,constantia,sutil,messines,monkton,okanogan,reinvigorated,apoplexy,tanahashi,neues,valiants,harappan,russes,carding,volkoff,funchal,statehouse,imitative,intrepidity,mellotron,samaras,turkana,besting,longitudes,exarch,diarrhoea,transcending,zvonareva,darna,ramblin,disconnection,137th,refocused,diarmait,agricole,ba'athist,turenne,contrabass,communis,daviess,fatimids,frosinone,fittingly,polyphyletic,qanat,theocratic,preclinical,abacha,toorak,marketplaces,conidia,seiya,contraindicated,retford,bundesautobahn,rebuilds,climatology,seaworthy,starfighter,qamar,categoria,malai,hellinsia,newstead,airworthy,catenin,avonmouth,arrhythmias,ayyavazhi,downgrade,ashburnham,ejector,kinematics,petworth,rspca,filmation,accipitridae,chhatrapati,g/mol,bacau,agama,ringtone,yudhoyono,orchestrator,arbitrators,138th,powerplants,cumbernauld,alderley,misamis,hawai`i,cuando,meistriliiga,jermyn,alans,pedigrees,ottavio,approbation,omnium,purulia,prioress,rheinland,lymphoid,lutsk,oscilloscope,ballina,iliac,motorbikes,modernising,uffizi,phylloxera,kalevala,bengalis,amravati,syntheses,interviewers,inflectional,outflank,maryhill,unhurt,profiler,nacelles,heseltine,personalised,guarda,herpetologist,airpark,pigot,margaretha,dinos,peleliu,breakbeat,kastamonu,shaivism,delamere,kingsville,epigram,khlong,phospholipids,journeying,lietuvos,congregated,deviance,celebes,subsoil,stroma,kvitova,lubricating,layoff,alagoas,olafur,doron,interuniversity,raycom,agonopterix,uzice,nanna,springvale,raimundo,wrested,pupal,talat,skinheads,vestige,unpainted,handan,odawara,ammar,attendee,lapped,myotis,gusty,ciconiiformesfamily,traversal,subfield,vitaphone,prensa,hasidism,inwood,carstairs,kropotkin,turgenev,dobra,remittance,purim,tannin,adige,tabulation,lethality,pacha,micronesian,dhruva,defensemen,tibeto,siculus,radioisotope,sodertalje,phitsanulok,euphonium,oxytocin,overhangs,skinks,fabrica,reinterred,emulates,bioscience,paragliding,raekwon,perigee,plausibility,frolunda,erroll,aznar,vyasa,albinus,trevally,confederacion,terse,sixtieth,1530s,kendriya,skateboarders,frontieres,muawiyah,easements,shehu,conservatively,keystones,kasem,brutalist,peekskill,cowry,orcas,syllabary,paltz,elisabetta,denticles,hampering,dolni,eidos,aarau,lermontov,yankton,shahbaz,barrages,kongsvinger,reestablishment,acetyltransferase,zulia,mrnas,slingsby,eucalypt,efficacious,weybridge,gradation,cinematheque,malthus,bampton,coexisted,cisse,hamdi,cupertino,saumarez,chionodes,libertine,formers,sakharov,pseudonymous,vol.1,mcduck,gopalakrishnan,amberley,jorhat,grandmasters,rudiments,dwindle,param,bukidnon,menander,americanus,multipliers,pulawy,homoerotic,pillbox,cd+dvd,epigraph,aleksandrow,extrapolated,horseshoes,contemporain,angiography,hasselt,shawinigan,memorization,legitimized,cyclades,outsold,rodolphe,kelis,powerball,dijkstra,analyzers,incompressible,sambar,orangeburg,osten,reauthorization,adamawa,sphagnum,hypermarket,millipedes,zoroaster,madea,ossuary,murrayfield,pronominal,gautham,resellers,ethers,quarrelled,dolna,stragglers,asami,tangut,passos,educacion,sharaf,texel,berio,bethpage,bezalel,marfa,noronha,36ers,genteel,avram,shilton,compensates,sweetener,reinstalled,disables,noether,1590s,balakrishnan,kotaro,northallerton,cataclysm,gholam,cancellara,schiphol,commends,longinus,albinism,gemayel,hamamatsu,volos,islamism,sidereal,pecuniary,diggings,townsquare,neosho,lushan,chittoor,akhil,disputation,desiccation,cambodians,thwarting,deliberated,ellipsis,bahini,susumu,separators,kohneh,plebeians,kultur,ogaden,pissarro,trypeta,latur,liaodong,vetting,datong,sohail,alchemists,lengthwise,unevenly,masterly,microcontrollers,occupier,deviating,farringdon,baccalaureat,theocracy,chebyshev,archivists,jayaram,ineffectiveness,scandinavians,jacobins,encomienda,nambu,g/cm3,catesby,paavo,heeded,rhodium,idealised,10deg,infective,mecyclothorax,halevy,sheared,minbari,audax,lusatian,rebuffs,hitfix,fastener,subjugate,tarun,binet,compuserve,synthesiser,keisuke,amalric,ligatures,tadashi,ignazio,abramovich,groundnut,otomo,maeve,mortlake,ostrogoths,antillean,todor,recto,millimetre,espousing,inaugurate,paracetamol,galvanic,harpalinae,jedrzejow,reassessment,langlands,civita,mikan,stikine,bijar,imamate,istana,kaiserliche,erastus,federale,cytosine,expansionism,hommes,norrland,smriti,snapdragon,gulab,taleb,lossy,khattab,urbanised,sesto,rekord,diffuser,desam,morganatic,silting,pacts,extender,beauharnais,purley,bouches,halfpipe,discontinuities,houthi,farmville,animism,horni,saadi,interpretative,blockades,symeon,biogeographic,transcaucasian,jetties,landrieu,astrocytes,conjunto,stumpings,weevils,geysers,redux,arching,romanus,tazeh,marcellinus,casein,opava,misrata,anare,sattar,declarer,dreux,oporto,venta,vallis,icosahedron,cortona,lachine,mohammedan,sandnes,zynga,clarin,diomedes,tsuyoshi,pribram,gulbarga,chartist,superettan,boscawen,altus,subang,gating,epistolary,vizianagaram,ogdensburg,panna,thyssen,tarkovsky,dzogchen,biograph,seremban,unscientific,nightjar,legco,deism,n.w.a,sudha,siskel,sassou,flintlock,jovial,montbeliard,pallida,formula_66,tranquillity,nisei,adornment,'people,yamhill,hockeyallsvenskan,adopters,appian,lowicz,haplotypes,succinctly,starogard,presidencies,kheyrabad,sobibor,kinesiology,cowichan,militum,cromwellian,leiningen,ps1.5,concourses,dalarna,goldfield,brzeg,faeces,aquarii,matchless,harvesters,181st,numismatics,korfball,sectioned,transpires,facultative,brandishing,kieron,forages,menai,glutinous,debarge,heathfield,1580s,malang,photoelectric,froome,semiotic,alwar,grammophon,chiaroscuro,mentalist,maramures,flacco,liquors,aleutians,marvell,sutlej,patnaik,qassam,flintoff,bayfield,haeckel,sueno,avicii,exoplanets,hoshi,annibale,vojislav,honeycombs,celebrant,rendsburg,veblen,quails,141st,carronades,savar,narrations,jeeva,ontologies,hedonistic,marinette,godot,munna,bessarabian,outrigger,thame,gravels,hoshino,falsifying,stereochemistry,nacionalista,medially,radula,ejecting,conservatorio,odile,ceiba,jaina,essonne,isometry,allophones,recidivism,iveco,ganda,grammarians,jagan,signposted,uncompressed,facilitators,constancy,ditko,propulsive,impaling,interbank,botolph,amlaib,intergroup,sorbus,cheka,debye,praca,adorning,presbyteries,dormition,strategos,qarase,pentecostals,beehives,hashemite,goldust,euronext,egress,arpanet,soames,jurchens,slovenska,copse,kazim,appraisals,marischal,mineola,sharada,caricaturist,sturluson,galba,faizabad,overwintering,grete,uyezds,didsbury,libreville,ablett,microstructure,anadolu,belenenses,elocution,cloaks,timeslots,halden,rashidun,displaces,sympatric,germanus,tuples,ceska,equalize,disassembly,krautrock,babangida,memel,deild,gopala,hematology,underclass,sangli,wawrinka,assur,toshack,refrains,nicotinic,bhagalpur,badami,racetracks,pocatello,walgreens,nazarbayev,occultation,spinnaker,geneon,josias,hydrolyzed,dzong,corregimiento,waistcoat,thermoplastic,soldered,anticancer,lactobacillus,shafi'i,carabus,adjournment,schlumberger,triceratops,despotate,mendicant,krishnamurti,bahasa,earthworm,lavoisier,noetherian,kalki,fervently,bhawan,saanich,coquille,gannet,motagua,kennels,mineralization,fitzherbert,svein,bifurcated,hairdressing,felis,abounded,dimers,fervour,hebdo,bluffton,aetna,corydon,clevedon,carneiro,subjectively,deutz,gastropoda,overshot,concatenation,varman,carolla,maharshi,mujib,inelastic,riverhead,initialized,safavids,rohini,caguas,bulges,fotbollforbund,hefei,spithead,westville,maronites,lytham,americo,gediminas,stephanus,chalcolithic,hijra,gnu/linux,predilection,rulership,sterility,haidar,scarlatti,saprissa,sviatoslav,pointedly,sunroof,guarantor,thevar,airstrips,pultusk,sture,129th,divinities,daizong,dolichoderus,cobourg,maoists,swordsmanship,uprated,bohme,tashi,largs,chandi,bluebeard,householders,richardsonian,drepanidae,antigonish,elbasan,occultism,marca,hypergeometric,oirat,stiglitz,ignites,dzungar,miquelon,pritam,d'automne,ulidiid,niamey,vallecano,fondo,billiton,incumbencies,raceme,chambery,cadell,barenaked,kagame,summerside,haussmann,hatshepsut,apothecaries,criollo,feint,nasals,timurid,feltham,plotinus,oxygenation,marginata,officinalis,salat,participations,ising,downe,izumo,unguided,pretence,coursed,haruna,viscountcy,mainstage,justicia,powiat,takara,capitoline,implacable,farben,stopford,cosmopterix,tuberous,kronecker,galatians,kweli,dogmas,exhorted,trebinje,skanda,newlyn,ablative,basidia,bhiwani,encroachments,stranglers,regrouping,tubal,shoestring,wawel,anionic,mesenchymal,creationists,pyrophosphate,moshi,despotism,powerbook,fatehpur,rupiah,segre,ternate,jessore,b.i.g,shevardnadze,abounds,gliwice,densest,memoria,suborbital,vietcong,ratepayers,karunanidhi,toolbar,descents,rhymney,exhortation,zahedan,carcinomas,hyperbaric,botvinnik,billets,neuropsychological,tigranes,hoards,chater,biennially,thistles,scotus,wataru,flotillas,hungama,monopolistic,payouts,vetch,generalissimo,caries,naumburg,piran,blizzards,escalates,reactant,shinya,theorize,rizzoli,transitway,ecclesiae,streptomyces,cantal,nisibis,superconductor,unworkable,thallus,roehampton,scheckter,viceroys,makuuchi,ilkley,superseding,takuya,klodzko,borbon,raspberries,operand,w.a.k.o,sarabande,factionalism,egalitarianism,temasek,torbat,unscripted,jorma,westerner,perfective,vrije,underlain,goldfrapp,blaenau,jomon,barthes,drivetime,bassa,bannock,umaga,fengxiang,zulus,sreenivasan,farces,codice_10,freeholder,poddebice,imperialists,deregulated,wingtip,o'hagan,pillared,overtone,hofstadter,149th,kitano,saybrook,standardizing,aldgate,staveley,o'flaherty,hundredths,steerable,soltan,empted,cruyff,intramuros,taluks,cotonou,marae,karur,figueres,barwon,lucullus,niobe,zemlya,lathes,homeported,chaux,amyotrophic,opines,exemplars,bhamo,homomorphisms,gauleiter,ladin,mafiosi,airdrieonians,b/soul,decal,transcaucasia,solti,defecation,deaconess,numidia,sampradaya,normalised,wingless,schwaben,alnus,cinerama,yakutsk,ketchikan,orvieto,unearned,monferrato,rotem,aacsb,loong,decoders,skerries,cardiothoracic,repositioning,pimpernel,yohannan,tenebrionoidea,nargis,nouvel,costliest,interdenominational,noize,redirecting,zither,morcha,radiometric,frequenting,irtysh,gbagbo,chakri,litvinenko,infotainment,ravensbruck,harith,corbels,maegashira,jousting,natan,novus,falcao,minis,railed,decile,rauma,ramaswamy,cavitation,paranaque,berchtesgaden,reanimated,schomberg,polysaccharides,exclusionary,cleon,anurag,ravaging,dhanush,mitchells,granule,contemptuous,keisei,rolleston,atlantean,yorkist,daraa,wapping,micrometer,keeneland,comparably,baranja,oranje,schlafli,yogic,dinajpur,unimpressive,masashi,recreativo,alemannic,petersfield,naoko,vasudeva,autosport,rajat,marella,busko,wethersfield,ssris,soulcalibur,kobani,wildland,rookery,hoffenheim,kauri,aliphatic,balaclava,ferrite,publicise,victorias,theism,quimper,chapbook,functionalist,roadbed,ulyanovsk,cupen,purpurea,calthorpe,teofilo,mousavi,cochlea,linotype,detmold,ellerslie,gakkai,telkom,southsea,subcontractor,inguinal,philatelists,zeebrugge,piave,trochidae,dempo,spoilt,saharanpur,mihrab,parasympathetic,barbarous,chartering,antiqua,katsina,bugis,categorizes,altstadt,kandyan,pambansa,overpasses,miters,assimilating,finlandia,uneconomic,am/fm,harpsichordist,dresdner,luminescence,authentically,overpowers,magmatic,cliftonville,oilfields,skirted,berthe,cuman,oakham,frelimo,glockenspiel,confection,saxophonists,piaseczno,multilevel,antipater,levying,maltreatment,velho,opoczno,harburg,pedophilia,unfunded,palettes,plasterwork,breve,dharmendra,auchinleck,nonesuch,blackmun,libretti,rabbani,145th,hasselbeck,kinnock,malate,vanden,cloverdale,ashgabat,nares,radians,steelworkers,sabor,possums,catterick,hemispheric,ostra,outpaced,dungeness,almshouse,penryn,texians,1000m,franchitti,incumbency,texcoco,newar,tramcars,toroidal,meitetsu,spellbound,agronomist,vinifera,riata,bunko,pinas,ba'al,github,vasilyevich,obsolescent,geodesics,ancestries,tujue,capitalised,unassigned,throng,unpaired,psychometric,skegness,exothermic,buffered,kristiansund,tongued,berenger,basho,alitalia,prolongation,archaeologically,fractionation,cyprinid,echinoderms,agriculturally,justiciar,sonam,ilium,baits,danceable,grazer,ardahan,grassed,preemption,glassworks,hasina,ugric,umbra,wahhabi,vannes,tinnitus,capitaine,tikrit,lisieux,scree,hormuz,despenser,jagiellon,maisonneuve,gandaki,santarem,basilicas,lancing,landskrona,weilburg,fireside,elysian,isleworth,krishnamurthy,filton,cynon,tecmo,subcostal,scalars,triglycerides,hyperplane,farmingdale,unione,meydan,pilings,mercosur,reactivate,akiba,fecundity,jatra,natsume,zarqawi,preta,masao,presbyter,oakenfold,rhodri,ferran,ruizong,cloyne,nelvana,epiphanius,borde,scutes,strictures,troughton,whitestone,sholom,toyah,shingon,kutuzov,abelard,passant,lipno,cafeterias,residuals,anabaptists,paratransit,criollos,pleven,radiata,destabilizing,hadiths,bazaars,mannose,taiyo,crookes,welbeck,baoding,archelaus,nguesso,alberni,wingtips,herts,viasat,lankans,evreux,wigram,fassbinder,ryuichi,storting,reducible,olesnica,znojmo,hyannis,theophanes,flatiron,mustering,rajahmundry,kadir,wayang,prome,lethargy,zubin,illegality,conall,dramedy,beerbohm,hipparchus,ziarat,ryuji,shugo,glenorchy,microarchitecture,morne,lewinsky,cauvery,battenberg,hyksos,wayanad,hamilcar,buhari,brazo,bratianu,solms,aksaray,elamite,chilcotin,bloodstock,sagara,dolny,reunified,umlaut,proteaceae,camborne,calabrian,dhanbad,vaxjo,cookware,potez,rediffusion,semitones,lamentations,allgau,guernica,suntory,pleated,stationing,urgell,gannets,bertelsmann,entryway,raphitomidae,acetaldehyde,nephrology,categorizing,beiyang,permeate,tourney,geosciences,khana,masayuki,crucis,universitaria,slaskie,khaimah,finno,advani,astonishingly,tubulin,vampiric,jeolla,sociale,cleethorpes,badri,muridae,suzong,debater,decimation,kenyans,mutualism,pontifex,middlemen,insee,halevi,lamentation,psychopathy,brassey,wenders,kavya,parabellum,prolactin,inescapable,apses,malignancies,rinzai,stigmatized,menahem,comox,ateliers,welshpool,setif,centimetre,truthfulness,downfield,drusus,woden,glycosylation,emanated,agulhas,dalkeith,jazira,nucky,unifil,jobim,operon,oryzomys,heroically,seances,supernumerary,backhouse,hashanah,tatler,imago,invert,hayato,clockmaker,kingsmill,swiecie,analogously,golconda,poste,tacitly,decentralised,ge'ez,diplomatically,fossiliferous,linseed,mahavira,pedestals,archpriest,byelection,domiciled,jeffersonian,bombus,winegrowing,waukegan,uncultivated,haverfordwest,saumur,communally,disbursed,cleeve,zeljeznicar,speciosa,vacationers,sigur,vaishali,zlatko,iftikhar,cropland,transkei,incompleteness,bohra,subantarctic,slieve,physiologic,similis,klerk,replanted,'right,chafee,reproducible,bayburt,regicide,muzaffarpur,plurals,hanyu,orthologs,diouf,assailed,kamui,tarik,dodecanese,gorne,on/off,179th,shimoga,granaries,carlists,valar,tripolitania,sherds,simmern,dissociated,isambard,polytechnical,yuvraj,brabazon,antisense,pubmed,glans,minutely,masaaki,raghavendra,savoury,podcasting,tachi,bienville,gongsun,ridgely,deform,yuichi,binders,canna,carcetti,llobregat,implored,berri,njegos,intermingled,offload,athenry,motherhouse,corpora,kakinada,dannebrog,imperio,prefaces,musicologists,aerospatiale,shirai,nagapattinam,servius,cristoforo,pomfret,reviled,entebbe,stane,east/west,thermometers,matriarchal,siglo,bodil,legionnaire,ze'ev,theorizing,sangeetha,horticulturist,uncountable,lookalike,anoxic,ionospheric,genealogists,chicopee,imprinting,popish,crematoria,diamondback,cyathea,hanzhong,cameramen,halogaland,naklo,waclaw,storehouses,flexed,comuni,frits,glauca,nilgiris,compresses,nainital,continuations,albay,hypoxic,samajwadi,dunkerque,nanticoke,sarwar,interchanged,jubal,corba,jalgaon,derleth,deathstroke,magny,vinnytsia,hyphenated,rimfire,sawan,boehner,disrepute,normalize,aromanian,dualistic,approximant,chama,karimabad,barnacles,sanok,stipends,dyfed,rijksmuseum,reverberation,suncorp,fungicides,reverie,spectrograph,stereophonic,niazi,ordos,alcan,karaite,lautrec,tableland,lamellar,rieti,langmuir,russula,webern,tweaks,hawick,southerner,morphy,naturalisation,enantiomer,michinoku,barbettes,relieves,carburettors,redruth,oblates,vocabularies,mogilev,bagmati,galium,reasserted,extolled,symon,eurosceptic,inflections,tirtha,recompense,oruro,roping,gouverneur,pared,yayoi,watermills,retooled,leukocytes,jubilant,mazhar,nicolau,manheim,touraine,bedser,hambledon,kohat,powerhouses,tlemcen,reuven,sympathetically,afrikaners,interes,handcrafts,etcher,baddeley,wodonga,amaury,155th,vulgarity,pompadour,automorphisms,1540s,oppositions,prekmurje,deryni,fortifying,arcuate,mahila,bocage,uther,nozze,slashes,atlantica,hadid,rhizomatous,azeris,'with,osmena,lewisville,innervated,bandmaster,outcropping,parallelogram,dominicana,twang,ingushetia,extensional,ladino,sastry,zinoviev,relatable,nobilis,cbeebies,hitless,eulima,sporangia,synge,longlisted,criminalized,penitential,weyden,tubule,volyn,priestesses,glenbrook,kibbutzim,windshaft,canadair,falange,zsolt,bonheur,meine,archangels,safeguarded,jamaicans,malarial,teasers,badging,merseyrail,operands,pulsars,gauchos,biotin,bambara,necaxa,egmond,tillage,coppi,anxiolytic,preah,mausoleums,plautus,feroz,debunked,187th,belediyespor,mujibur,wantage,carboxyl,chettiar,murnau,vagueness,racemic,backstretch,courtland,municipio,palpatine,dezful,hyperbola,sreekumar,chalons,altay,arapahoe,tudors,sapieha,quilon,burdensome,kanya,xxviii,recension,generis,siphuncle,repressor,bitrate,mandals,midhurst,dioxin,democratique,upholds,rodez,cinematographic,epoque,jinping,rabelais,zhytomyr,glenview,rebooted,khalidi,reticulata,122nd,monnaie,passersby,ghazals,europaea,lippmann,earthbound,tadic,andorran,artvin,angelicum,banksy,epicentre,resemblances,shuttled,rathaus,bernt,stonemasons,balochi,siang,tynemouth,cygni,biosynthetic,precipitates,sharecroppers,d'annunzio,softbank,shiji,apeldoorn,polycyclic,wenceslas,wuchang,samnites,tamarack,silmarillion,madinah,palaeontology,kirchberg,sculpin,rohtak,aquabats,oviparous,thynne,caney,blimps,minimalistic,whatcom,palatalization,bardstown,direct3d,paramagnetic,kamboja,khash,globemaster,lengua,matej,chernigov,swanage,arsenals,cascadia,cundinamarca,tusculum,leavers,organics,warplanes,'three,exertions,arminius,gandharva,inquires,comercio,kuopio,chabahar,plotlines,mersenne,anquetil,paralytic,buckminster,ambit,acrolophus,quantifiers,clacton,ciliary,ansaldo,fergana,egoism,thracians,chicoutimi,northbrook,analgesia,brotherhoods,hunza,adriaen,fluoridation,snowfalls,soundboard,fangoria,cannibalistic,orthogonius,chukotka,dindigul,manzoni,chainz,macromedia,beltline,muruga,schistura,provable,litex,initio,pneumoniae,infosys,cerium,boonton,cannonballs,d'une,solvency,mandurah,houthis,dolmens,apologists,radioisotopes,blaxploitation,poroshenko,stawell,coosa,maximilien,tempelhof,espouse,declaratory,hambro,xalapa,outmoded,mihiel,benefitting,desirous,archeparchy,repopulated,telescoping,captor,mackaye,disparaged,ramanathan,crowne,tumbled,technetium,silted,chedi,nievre,hyeon,cartoonish,interlock,infocom,rediff.com,dioramas,timekeeping,concertina,kutaisi,cesky,lubomirski,unapologetic,epigraphic,stalactites,sneha,biofilm,falconry,miraflores,catena,'outstanding,prospekt,apotheosis,o'odham,pacemakers,arabica,gandhinagar,reminisces,iroquoian,ornette,tilling,neoliberalism,chameleons,pandava,prefontaine,haiyan,gneisenau,utama,bando,reconstitution,azaria,canola,paratroops,ayckbourn,manistee,stourton,manifestos,lympne,denouement,tractatus,rakim,bellflower,nanometer,sassanids,turlough,presbyterianism,varmland,20deg,phool,nyerere,almohad,manipal,vlaanderen,quickness,removals,makow,circumflex,eatery,morane,fondazione,alkylation,unenforceable,galliano,silkworm,junior/senior,abducts,phlox,konskie,lofoten,buuren,glyphosate,faired,naturae,cobbles,taher,skrulls,dostoevsky,walkout,wagnerian,orbited,methodically,denzil,sarat,extraterritorial,kohima,d'armor,brinsley,rostropovich,fengtian,comitatus,aravind,moche,wrangell,giscard,vantaa,viljandi,hakoah,seabees,muscatine,ballade,camanachd,sothern,mullioned,durad,margraves,maven,arete,chandni,garifuna,142nd,reading/literature,thickest,intensifies,trygve,khaldun,perinatal,asana,powerline,acetylation,nureyev,omiya,montesquieu,riverwalk,marly,correlating,intermountain,bulgar,hammerheads,underscores,wiretapping,quatrain,ruisseau,newsagent,tuticorin,polygyny,hemsworth,partisanship,banna,istrian,evaporator".split(","),
    female_names: "mary,patricia,linda,barbara,elizabeth,jennifer,maria,susan,margaret,dorothy,lisa,nancy,karen,betty,helen,sandra,donna,carol,ruth,sharon,michelle,laura,sarah,kimberly,deborah,jessica,shirley,cynthia,angela,melissa,brenda,amy,anna,rebecca,virginia,kathleen,pamela,martha,debra,amanda,stephanie,carolyn,christine,marie,janet,catherine,frances,ann,joyce,diane,alice,julie,heather,teresa,doris,gloria,evelyn,jean,cheryl,mildred,katherine,joan,ashley,judith,rose,janice,kelly,nicole,judy,christina,kathy,theresa,beverly,denise,tammy,irene,jane,lori,rachel,marilyn,andrea,kathryn,louise,sara,anne,jacqueline,wanda,bonnie,julia,ruby,lois,tina,phyllis,norma,paula,diana,annie,lillian,emily,robin,peggy,crystal,gladys,rita,dawn,connie,florence,tracy,edna,tiffany,carmen,rosa,cindy,grace,wendy,victoria,edith,kim,sherry,sylvia,josephine,thelma,shannon,sheila,ethel,ellen,elaine,marjorie,carrie,charlotte,monica,esther,pauline,emma,juanita,anita,rhonda,hazel,amber,eva,debbie,april,leslie,clara,lucille,jamie,joanne,eleanor,valerie,danielle,megan,alicia,suzanne,michele,gail,bertha,darlene,veronica,jill,erin,geraldine,lauren,cathy,joann,lorraine,lynn,sally,regina,erica,beatrice,dolores,bernice,audrey,yvonne,annette,marion,dana,stacy,ana,renee,ida,vivian,roberta,holly,brittany,melanie,loretta,yolanda,jeanette,laurie,katie,kristen,vanessa,alma,sue,elsie,beth,jeanne,vicki,carla,tara,rosemary,eileen,terri,gertrude,lucy,tonya,ella,stacey,wilma,gina,kristin,jessie,natalie,agnes,vera,charlene,bessie,delores,melinda,pearl,arlene,maureen,colleen,allison,tamara,joy,georgia,constance,lillie,claudia,jackie,marcia,tanya,nellie,minnie,marlene,heidi,glenda,lydia,viola,courtney,marian,stella,caroline,dora,vickie,mattie,maxine,irma,mabel,marsha,myrtle,lena,christy,deanna,patsy,hilda,gwendolyn,jennie,nora,margie,nina,cassandra,leah,penny,kay,priscilla,naomi,carole,olga,billie,dianne,tracey,leona,jenny,felicia,sonia,miriam,velma,becky,bobbie,violet,kristina,toni,misty,mae,shelly,daisy,ramona,sherri,erika,katrina,claire,lindsey,lindsay,geneva,guadalupe,belinda,margarita,sheryl,cora,faye,ada,sabrina,isabel,marguerite,hattie,harriet,molly,cecilia,kristi,brandi,blanche,sandy,rosie,joanna,iris,eunice,angie,inez,lynda,madeline,amelia,alberta,genevieve,monique,jodi,janie,kayla,sonya,jan,kristine,candace,fannie,maryann,opal,alison,yvette,melody,luz,susie,olivia,flora,shelley,kristy,mamie,lula,lola,verna,beulah,antoinette,candice,juana,jeannette,pam,kelli,whitney,bridget,karla,celia,latoya,patty,shelia,gayle,della,vicky,lynne,sheri,marianne,kara,jacquelyn,erma,blanca,myra,leticia,pat,krista,roxanne,angelica,robyn,adrienne,rosalie,alexandra,brooke,bethany,sadie,bernadette,traci,jody,kendra,nichole,rachael,mable,ernestine,muriel,marcella,elena,krystal,angelina,nadine,kari,estelle,dianna,paulette,lora,mona,doreen,rosemarie,desiree,antonia,janis,betsy,christie,freda,meredith,lynette,teri,cristina,eula,leigh,meghan,sophia,eloise,rochelle,gretchen,cecelia,raquel,henrietta,alyssa,jana,gwen,jenna,tricia,laverne,olive,tasha,silvia,elvira,delia,kate,patti,lorena,kellie,sonja,lila,lana,darla,mindy,essie,mandy,lorene,elsa,josefina,jeannie,miranda,dixie,lucia,marta,faith,lela,johanna,shari,camille,tami,shawna,elisa,ebony,melba,ora,nettie,tabitha,ollie,winifred,kristie,alisha,aimee,rena,myrna,marla,tammie,latasha,bonita,patrice,ronda,sherrie,addie,francine,deloris,stacie,adriana,cheri,abigail,celeste,jewel,cara,adele,rebekah,lucinda,dorthy,effie,trina,reba,sallie,aurora,lenora,etta,lottie,kerri,trisha,nikki,estella,francisca,josie,tracie,marissa,karin,brittney,janelle,lourdes,laurel,helene,fern,elva,corinne,kelsey,ina,bettie,elisabeth,aida,caitlin,ingrid,iva,eugenia,christa,goldie,maude,jenifer,therese,dena,lorna,janette,latonya,candy,consuelo,tamika,rosetta,debora,cherie,polly,dina,jewell,fay,jillian,dorothea,nell,trudy,esperanza,patrica,kimberley,shanna,helena,cleo,stefanie,rosario,ola,janine,mollie,lupe,alisa,lou,maribel,susanne,bette,susana,elise,cecile,isabelle,lesley,jocelyn,paige,joni,rachelle,leola,daphne,alta,ester,petra,graciela,imogene,jolene,keisha,lacey,glenna,gabriela,keri,ursula,lizzie,kirsten,shana,adeline,mayra,jayne,jaclyn,gracie,sondra,carmela,marisa,rosalind,charity,tonia,beatriz,marisol,clarice,jeanine,sheena,angeline,frieda,lily,shauna,millie,claudette,cathleen,angelia,gabrielle,autumn,katharine,jodie,staci,lea,christi,justine,elma,luella,margret,dominique,socorro,martina,margo,mavis,callie,bobbi,maritza,lucile,leanne,jeannine,deana,aileen,lorie,ladonna,willa,manuela,gale,selma,dolly,sybil,abby,ivy,dee,winnie,marcy,luisa,jeri,magdalena,ofelia,meagan,audra,matilda,leila,cornelia,bianca,simone,bettye,randi,virgie,latisha,barbra,georgina,eliza,leann,bridgette,rhoda,haley,adela,nola,bernadine,flossie,ila,greta,ruthie,nelda,minerva,lilly,terrie,letha,hilary,estela,valarie,brianna,rosalyn,earline,catalina,ava,mia,clarissa,lidia,corrine,alexandria,concepcion,tia,sharron,rae,dona,ericka,jami,elnora,chandra,lenore,neva,marylou,melisa,tabatha,serena,avis,allie,sofia,jeanie,odessa,nannie,harriett,loraine,penelope,milagros,emilia,benita,allyson,ashlee,tania,esmeralda,eve,pearlie,zelma,malinda,noreen,tameka,saundra,hillary,amie,althea,rosalinda,lilia,alana,clare,alejandra,elinor,lorrie,jerri,darcy,earnestine,carmella,noemi,marcie,liza,annabelle,louisa,earlene,mallory,carlene,nita,selena,tanisha,katy,julianne,lakisha,edwina,maricela,margery,kenya,dollie,roxie,roslyn,kathrine,nanette,charmaine,lavonne,ilene,tammi,suzette,corine,kaye,chrystal,lina,deanne,lilian,juliana,aline,luann,kasey,maryanne,evangeline,colette,melva,lawanda,yesenia,nadia,madge,kathie,ophelia,valeria,nona,mitzi,mari,georgette,claudine,fran,alissa,roseann,lakeisha,susanna,reva,deidre,chasity,sheree,elvia,alyce,deirdre,gena,briana,araceli,katelyn,rosanne,wendi,tessa,berta,marva,imelda,marietta,marci,leonor,arline,sasha,madelyn,janna,juliette,deena,aurelia,josefa,augusta,liliana,lessie,amalia,savannah,anastasia,vilma,natalia,rosella,lynnette,corina,alfreda,leanna,amparo,coleen,tamra,aisha,wilda,karyn,maura,mai,evangelina,rosanna,hallie,erna,enid,mariana,lacy,juliet,jacklyn,freida,madeleine,mara,cathryn,lelia,casandra,bridgett,angelita,jannie,dionne,annmarie,katina,beryl,millicent,katheryn,diann,carissa,maryellen,liz,lauri,helga,gilda,rhea,marquita,hollie,tisha,tamera,angelique,francesca,kaitlin,lolita,florine,rowena,reyna,twila,fanny,janell,ines,concetta,bertie,alba,brigitte,alyson,vonda,pansy,elba,noelle,letitia,deann,brandie,louella,leta,felecia,sharlene,lesa,beverley,isabella,herminia,terra,celina,tori,octavia,jade,denice,germaine,michell,cortney,nelly,doretha,deidra,monika,lashonda,judi,chelsey,antionette,margot,adelaide,leeann,elisha,dessie,libby,kathi,gayla,latanya,mina,mellisa,kimberlee,jasmin,renae,zelda,elda,justina,gussie,emilie,camilla,abbie,rocio,kaitlyn,edythe,ashleigh,selina,lakesha,geri,allene,pamala,michaela,dayna,caryn,rosalia,jacquline,rebeca,marybeth,krystle,iola,dottie,belle,griselda,ernestina,elida,adrianne,demetria,delma,jaqueline,arleen,virgina,retha,fatima,tillie,eleanore,cari,treva,wilhelmina,rosalee,maurine,latrice,jena,taryn,elia,debby,maudie,jeanna,delilah,catrina,shonda,hortencia,theodora,teresita,robbin,danette,delphine,brianne,nilda,danna,cindi,bess,iona,winona,vida,rosita,marianna,racheal,guillermina,eloisa,celestine,caren,malissa,lona,chantel,shellie,marisela,leora,agatha,soledad,migdalia,ivette,christen,athena,janel,veda,pattie,tessie,tera,marilynn,lucretia,karrie,dinah,daniela,alecia,adelina,vernice,shiela,portia,merry,lashawn,dara,tawana,verda,alene,zella,sandi,rafaela,maya,kira,candida,alvina,suzan,shayla,lettie,samatha,oralia,matilde,larissa,vesta,renita,delois,shanda,phillis,lorri,erlinda,cathrine,barb,isabell,ione,gisela,roxanna,mayme,kisha,ellie,mellissa,dorris,dalia,bella,annetta,zoila,reta,reina,lauretta,kylie,christal,pilar,charla,elissa,tiffani,tana,paulina,leota,breanna,jayme,carmel,vernell,tomasa,mandi,dominga,santa,melodie,lura,alexa,tamela,mirna,kerrie,venus,felicita,cristy,carmelita,berniece,annemarie,tiara,roseanne,missy,cori,roxana,pricilla,kristal,jung,elyse,haydee,aletha,bettina,marge,gillian,filomena,zenaida,harriette,caridad,vada,aretha,pearline,marjory,marcela,flor,evette,elouise,alina,damaris,catharine,belva,nakia,marlena,luanne,lorine,karon,dorene,danita,brenna,tatiana,louann,julianna,andria,philomena,lucila,leonora,dovie,romona,mimi,jacquelin,gaye,tonja,misti,chastity,stacia,roxann,micaela,velda,marlys,johnna,aura,ivonne,hayley,nicki,majorie,herlinda,yadira,perla,gregoria,antonette,shelli,mozelle,mariah,joelle,cordelia,josette,chiquita,trista,laquita,georgiana,candi,shanon,hildegard,stephany,magda,karol,gabriella,tiana,roma,richelle,oleta,jacque,idella,alaina,suzanna,jovita,tosha,nereida,marlyn,kyla,delfina,tena,stephenie,sabina,nathalie,marcelle,gertie,darleen,thea,sharonda,shantel,belen,venessa,rosalina,genoveva,clementine,rosalba,renate,renata,georgianna,floy,dorcas,ariana,tyra,theda,mariam,juli,jesica,vikki,verla,roselyn,melvina,jannette,ginny,debrah,corrie,violeta,myrtis,latricia,collette,charleen,anissa,viviana,twyla,nedra,latonia,hellen,fabiola,annamarie,adell,sharyn,chantal,niki,maud,lizette,lindy,kesha,jeana,danelle,charline,chanel,valorie,dortha,cristal,sunny,leone,leilani,gerri,debi,andra,keshia,eulalia,easter,dulce,natividad,linnie,kami,georgie,catina,brook,alda,winnifred,sharla,ruthann,meaghan,magdalene,lissette,adelaida,venita,trena,shirlene,shameka,elizebeth,dian,shanta,latosha,carlotta,windy,rosina,mariann,leisa,jonnie,dawna,cathie,astrid,laureen,janeen,holli,fawn,vickey,teressa,shante,rubye,marcelina,chanda,terese,scarlett,marnie,lulu,lisette,jeniffer,elenor,dorinda,donita,carman,bernita,altagracia,aleta,adrianna,zoraida,lyndsey,janina,starla,phylis,phuong,kyra,charisse,blanch,sanjuanita,rona,nanci,marilee,maranda,brigette,sanjuana,marita,kassandra,joycelyn,felipa,chelsie,bonny,mireya,lorenza,kyong,ileana,candelaria,sherie,lucie,leatrice,lakeshia,gerda,edie,bambi,marylin,lavon,hortense,garnet,evie,tressa,shayna,lavina,kyung,jeanetta,sherrill,shara,phyliss,mittie,anabel,alesia,thuy,tawanda,joanie,tiffanie,lashanda,karissa,enriqueta,daria,daniella,corinna,alanna,abbey,roxane,roseanna,magnolia,lida,joellen,coral,carleen,tresa,peggie,novella,nila,maybelle,jenelle,carina,nova,melina,marquerite,margarette,josephina,evonne,cinthia,albina,toya,tawnya,sherita,myriam,lizabeth,lise,keely,jenni,giselle,cheryle,ardith,ardis,alesha,adriane,shaina,linnea,karolyn,felisha,dori,darci,artie,armida,zola,xiomara,vergie,shamika,nena,nannette,maxie,lovie,jeane,jaimie,inge,farrah,elaina,caitlyn,felicitas,cherly,caryl,yolonda,yasmin,teena,prudence,pennie,nydia,mackenzie,orpha,marvel,lizbeth,laurette,jerrie,hermelinda,carolee,tierra,mirian,meta,melony,kori,jennette,jamila,yoshiko,susannah,salina,rhiannon,joleen,cristine,ashton,aracely,tomeka,shalonda,marti,lacie,kala,jada,ilse,hailey,brittani,zona,syble,sherryl,nidia,marlo,kandice,kandi,alycia,ronna,norene,mercy,ingeborg,giovanna,gemma,christel,audry,zora,vita,trish,stephaine,shirlee,shanika,melonie,mazie,jazmin,inga,hettie,geralyn,fonda,estrella,adella,sarita,rina,milissa,maribeth,golda,evon,ethelyn,enedina,cherise,chana,velva,tawanna,sade,mirta,karie,jacinta,elna,davina,cierra,ashlie,albertha,tanesha,nelle,mindi,lorinda,larue,florene,demetra,dedra,ciara,chantelle,ashly,suzy,rosalva,noelia,lyda,leatha,krystyna,kristan,karri,darline,darcie,cinda,cherrie,awilda,almeda,rolanda,lanette,jerilyn,gisele,evalyn,cyndi,cleta,carin,zina,zena,velia,tanika,charissa,talia,margarete,lavonda,kaylee,kathlene,jonna,irena,ilona,idalia,candis,candance,brandee,anitra,alida,sigrid,nicolette,maryjo,linette,hedwig,christiana,alexia,tressie,modesta,lupita,lita,gladis,evelia,davida,cherri,cecily,ashely,annabel,agustina,wanita,shirly,rosaura,hulda,yetta,verona,thomasina,sibyl,shannan,mechelle,leandra,lani,kylee,kandy,jolynn,ferne,eboni,corene,alysia,zula,nada,moira,lyndsay,lorretta,jammie,hortensia,gaynell,adria,vina,vicenta,tangela,stephine,norine,nella,liana,leslee,kimberely,iliana,glory,felica,emogene,elfriede,eden,eartha,carma,ocie,lennie,kiara,jacalyn,carlota,arielle,otilia,kirstin,kacey,johnetta,joetta,jeraldine,jaunita,elana,dorthea,cami,amada,adelia,vernita,tamar,siobhan,renea,rashida,ouida,nilsa,meryl,kristyn,julieta,danica,breanne,aurea,anglea,sherron,odette,malia,lorelei,leesa,kenna,kathlyn,fiona,charlette,suzie,shantell,sabra,racquel,myong,mira,martine,lucienne,lavada,juliann,elvera,delphia,christiane,charolette,carri,asha,angella,paola,ninfa,leda,stefani,shanell,palma,machelle,lissa,kecia,kathryne,karlene,julissa,jettie,jenniffer,corrina,carolann,alena,rosaria,myrtice,marylee,liane,kenyatta,judie,janey,elmira,eldora,denna,cristi,cathi,zaida,vonnie,viva,vernie,rosaline,mariela,luciana,lesli,karan,felice,deneen,adina,wynona,tarsha,sheron,shanita,shani,shandra,randa,pinkie,nelida,marilou,lyla,laurene,laci,janene,dorotha,daniele,dani,carolynn,carlyn,berenice,ayesha,anneliese,alethea,thersa,tamiko,rufina,oliva,mozell,marylyn,kristian,kathyrn,kasandra,kandace,janae,domenica,debbra,dannielle,chun,arcelia,zenobia,sharen,sharee,lavinia,kacie,jackeline,huong,felisa,emelia,eleanora,cythia,cristin,claribel,anastacia,zulma,zandra,yoko,tenisha,susann,sherilyn,shay,shawanda,romana,mathilda,linsey,keiko,joana,isela,gretta,georgetta,eugenie,desirae,delora,corazon,antonina,anika,willene,tracee,tamatha,nichelle,mickie,maegan,luana,lanita,kelsie,edelmira,bree,afton,teodora,tamie,shena,linh,keli,kaci,danyelle,arlette,albertine,adelle,tiffiny,simona,nicolasa,nichol,nakisha,maira,loreen,kizzy,fallon,christene,bobbye,ying,vincenza,tanja,rubie,roni,queenie,margarett,kimberli,irmgard,idell,hilma,evelina,esta,emilee,dennise,dania,carie,risa,rikki,particia,masako,luvenia,loree,loni,lien,gigi,florencia,denita,billye,tomika,sharita,rana,nikole,neoma,margarite,madalyn,lucina,laila,kali,jenette,gabriele,evelyne,elenora,clementina,alejandrina,zulema,violette,vannessa,thresa,retta,patience,noella,nickie,jonell,chaya,camelia,bethel,anya,suzann,mila,lilla,laverna,keesha,kattie,georgene,eveline,estell,elizbeth,vivienne,vallie,trudie,stephane,magaly,madie,kenyetta,karren,janetta,hermine,drucilla,debbi,celestina,candie,britni,beckie,amina,zita,yolande,vivien,vernetta,trudi,pearle,patrina,ossie,nicolle,loyce,letty,katharina,joselyn,jonelle,jenell,iesha,heide,florinda,florentina,elodia,dorine,brunilda,brigid,ashli,ardella,twana,tarah,shavon,serina,rayna,ramonita,margurite,lucrecia,kourtney,kati,jesenia,crista,ayana,alica,alia,vinnie,suellen,romelia,rachell,olympia,michiko,kathaleen,jolie,jessi,janessa,hana,elease,carletta,britany,shona,salome,rosamond,regena,raina,ngoc,nelia,louvenia,lesia,latrina,laticia,larhonda,jina,jacki,emmy,deeann,coretta,arnetta,thalia,shanice,neta,mikki,micki,lonna,leana,lashunda,kiley,joye,jacqulyn,ignacia,hyun,hiroko,henriette,elayne,delinda,dahlia,coreen,consuela,conchita,babette,ayanna,anette,albertina,shawnee,shaneka,quiana,pamelia,merri,merlene,margit,kiesha,kiera,kaylene,jodee,jenise,erlene,emmie,dalila,daisey,casie,belia,babara,versie,vanesa,shelba,shawnda,nikia,naoma,marna,margeret,madaline,lawana,kindra,jutta,jazmine,janett,hannelore,glendora,gertrud,garnett,freeda,frederica,florance,flavia,carline,beverlee,anjanette,valda,tamala,shonna,sarina,oneida,merilyn,marleen,lurline,lenna,katherin,jeni,gracia,glady,farah,enola,dominque,devona,delana,cecila,caprice,alysha,alethia,vena,theresia,tawny,shakira,samara,sachiko,rachele,pamella,marni,mariel,maren,malisa,ligia,lera,latoria,larae,kimber,kathern,karey,jennefer,janeth,halina,fredia,delisa,debroah,ciera,angelika,andree,altha,vivan,terresa,tanna,sudie,signe,salena,ronni,rebbecca,myrtie,malika,maida,leonarda,kayleigh,ethyl,ellyn,dayle,cammie,brittni,birgit,avelina,asuncion,arianna,akiko,venice,tyesha,tonie,tiesha,takisha,steffanie,sindy,meghann,manda,macie,kellye,kellee,joslyn,inger,indira,glinda,glennis,fernanda,faustina,eneida,elicia,digna,dell,arletta,willia,tammara,tabetha,sherrell,sari,rebbeca,pauletta,natosha,nakita,mammie,kenisha,kazuko,kassie,earlean,daphine,corliss,clotilde,carolyne,bernetta,augustina,audrea,annis,annabell,tennille,tamica,selene,rosana,regenia,qiana,markita,macy,leeanne,laurine,jessenia,janita,georgine,genie,emiko,elvie,deandra,dagmar,corie,collen,cherish,romaine,porsha,pearlene,micheline,merna,margorie,margaretta,lore,jenine,hermina,fredericka,elke,drusilla,dorathy,dione,celena,brigida,allegra,tamekia,synthia,sook,slyvia,rosann,reatha,raye,marquetta,margart,ling,layla,kymberly,kiana,kayleen,katlyn,karmen,joella,emelda,eleni,detra,clemmie,cheryll,chantell,cathey,arnita,arla,angle,angelic,alyse,zofia,thomasine,tennie,sherly,sherley,sharyl,remedios,petrina,nickole,myung,myrle,mozella,louanne,lisha,latia,krysta,julienne,jeanene,jacqualine,isaura,gwenda,earleen,cleopatra,carlie,audie,antonietta,alise,verdell,tomoko,thao,talisha,shemika,savanna,santina,rosia,raeann,odilia,nana,minna,magan,lynelle,karma,joeann,ivana,inell,ilana,gudrun,dreama,crissy,chante,carmelina,arvilla,annamae,alvera,aleida,yanira,vanda,tianna,stefania,shira,nicol,nancie,monserrate,melynda,melany,lovella,laure,kacy,jacquelynn,hyon,gertha,eliana,christena,christeen,charise,caterina,carley,candyce,arlena,ammie,willette,vanita,tuyet,syreeta,penney,nyla,maryam,marya,magen,ludie,loma,livia,lanell,kimberlie,julee,donetta,diedra,denisha,deane,dawne,clarine,cherryl,bronwyn,alla,valery,tonda,sueann,soraya,shoshana,shela,sharleen,shanelle,nerissa,meridith,mellie,maye,maple,magaret,lili,leonila,leonie,leeanna,lavonia,lavera,kristel,kathey,kathe,jann,ilda,hildred,hildegarde,genia,fumiko,evelin,ermelinda,elly,dung,doloris,dionna,danae,berneice,annice,alix,verena,verdie,shawnna,shawana,shaunna,rozella,randee,ranae,milagro,lynell,luise,loida,lisbeth,karleen,junita,jona,isis,hyacinth,hedy,gwenn,ethelene,erline,donya,domonique,delicia,dannette,cicely,branda,blythe,bethann,ashlyn,annalee,alline,yuko,vella,trang,towanda,tesha,sherlyn,narcisa,miguelina,meri,maybell,marlana,marguerita,madlyn,lory,loriann,leonore,leighann,laurice,latesha,laronda,katrice,kasie,kaley,jadwiga,glennie,gearldine,francina,epifania,dyan,dorie,diedre,denese,demetrice,delena,cristie,cleora,catarina,carisa,barbera,almeta,trula,tereasa,solange,sheilah,shavonne,sanora,rochell,mathilde,margareta,maia,lynsey,lawanna,launa,kena,keena,katia,glynda,gaylene,elvina,elanor,danuta,danika,cristen,cordie,coletta,clarita,carmon,brynn,azucena,aundrea,angele,verlie,verlene,tamesha,silvana,sebrina,samira,reda,raylene,penni,norah,noma,mireille,melissia,maryalice,laraine,kimbery,karyl,karine,jolanda,johana,jesusa,jaleesa,jacquelyne,iluminada,hilaria,hanh,gennie,francie,floretta,exie,edda,drema,delpha,barbar,assunta,ardell,annalisa,alisia,yukiko,yolando,wonda,waltraud,veta,temeka,tameika,shirleen,shenita,piedad,ozella,mirtha,marilu,kimiko,juliane,jenice,janay,jacquiline,hilde,elois,echo,devorah,chau,brinda,betsey,arminda,aracelis,apryl,annett,alishia,veola,usha,toshiko,theola,tashia,talitha,shery,renetta,reiko,rasheeda,obdulia,mika,melaine,meggan,marlen,marget,marceline,mana,magdalen,librada,lezlie,latashia,lasandra,kelle,isidra,inocencia,gwyn,francoise,erminia,erinn,dimple,devora,criselda,armanda,arie,ariane,angelena,aliza,adriene,adaline,xochitl,twanna,tomiko,tamisha,taisha,susy,rutha,rhona,noriko,natashia,merrie,marinda,mariko,margert,loris,lizzette,leisha,kaila,joannie,jerrica,jene,jannet,janee,jacinda,herta,elenore,doretta,delaine,daniell,claudie,britta,apolonia,amberly,alease,yuri,waneta,tomi,sharri,sandie,roselle,reynalda,raguel,phylicia,patria,olimpia,odelia,mitzie,minda,mignon,mica,mendy,marivel,maile,lynetta,lavette,lauryn,latrisha,lakiesha,kiersten,kary,josphine,jolyn,jetta,janise,jacquie,ivelisse,glynis,gianna,gaynelle,danyell,danille,dacia,coralee,cher,ceola,arianne,aleshia,yung,williemae,trinh,thora,sherika,shemeka,shaunda,roseline,ricki,melda,mallie,lavonna,latina,laquanda,lala,lachelle,klara,kandis,johna,jeanmarie,jaye,grayce,gertude,emerita,ebonie,clorinda,ching,chery,carola,breann,blossom,bernardine,becki,arletha,argelia,alita,yulanda,yessenia,tobi,tasia,sylvie,shirl,shirely,shella,shantelle,sacha,rebecka,providencia,paulene,misha,miki,marline,marica,lorita,latoyia,lasonya,kerstin,kenda,keitha,kathrin,jaymie,gricelda,ginette,eryn,elina,elfrieda,danyel,cheree,chanelle,barrie,aurore,annamaria,alleen,ailene,aide,yasmine,vashti,treasa,tiffaney,sheryll,sharie,shanae,raisa,neda,mitsuko,mirella,milda,maryanna,maragret,mabelle,luetta,lorina,letisha,latarsha,lanelle,lajuana,krissy,karly,karena,jessika,jerica,jeanelle,jalisa,jacelyn,izola,euna,etha,domitila,dominica,daina,creola,carli,camie,brittny,ashanti,anisha,aleen,adah,yasuko,valrie,tona,tinisha,terisa,taneka,simonne,shalanda,serita,ressie,refugia,olene,margherita,mandie,maire,lyndia,luci,lorriane,loreta,leonia,lavona,lashawnda,lakia,kyoko,krystina,krysten,kenia,kelsi,jeanice,isobel,georgiann,genny,felicidad,eilene,deloise,deedee,conception,clora,cherilyn,calandra,armandina,anisa,tiera,theressa,stephania,sima,shyla,shonta,shera,shaquita,shala,rossana,nohemi,nery,moriah,melita,melida,melani,marylynn,marisha,mariette,malorie,madelene,ludivina,loria,lorette,loralee,lianne,lavenia,laurinda,lashon,kimi,keila,katelynn,jone,joane,jayna,janella,hertha,francene,elinore,despina,delsie,deedra,clemencia,carolin,bulah,brittanie,blondell,bibi,beaulah,beata,annita,agripina,virgen,valene,twanda,tommye,tarra,tari,tammera,shakia,sadye,ruthanne,rochel,rivka,pura,nenita,natisha,ming,merrilee,melodee,marvis,lucilla,leena,laveta,larita,lanie,keren,ileen,georgeann,genna,frida,eufemia,emely,edyth,deonna,deadra,darlena,chanell,cathern,cassondra,cassaundra,bernarda,berna,arlinda,anamaria,vertie,valeri,torri,stasia,sherise,sherill,sanda,ruthe,rosy,robbi,ranee,quyen,pearly,palmira,onita,nisha,niesha,nida,merlyn,mayola,marylouise,marth,margene,madelaine,londa,leontine,leoma,leia,lauralee,lanora,lakita,kiyoko,keturah,katelin,kareen,jonie,johnette,jenee,jeanett,izetta,hiedi,heike,hassie,giuseppina,georgann,fidela,fernande,elwanda,ellamae,eliz,dusti,dotty,cyndy,coralie,celesta,alverta,xenia,wava,vanetta,torrie,tashina,tandy,tambra,tama,stepanie,shila,shaunta,sharan,shaniqua,shae,setsuko,serafina,sandee,rosamaria,priscila,olinda,nadene,muoi,michelina,mercedez,maryrose,marcene,magali,mafalda,lannie,kayce,karoline,kamilah,kamala,justa,joline,jennine,jacquetta,iraida,georgeanna,franchesca,emeline,elane,ehtel,earlie,dulcie,dalene,classie,chere,charis,caroyln,carmina,carita,bethanie,ayako,arica,alysa,alessandra,akilah,adrien,zetta,youlanda,yelena,yahaira,xuan,wendolyn,tijuana,terina,teresia,suzi,sherell,shavonda,shaunte,sharda,shakita,sena,ryann,rubi,riva,reginia,rachal,parthenia,pamula,monnie,monet,michaele,melia,malka,maisha,lisandra,lekisha,lean,lakendra,krystin,kortney,kizzie,kittie,kera,kendal,kemberly,kanisha,julene,jule,johanne,jamee,halley,gidget,fredricka,fleta,fatimah,eusebia,elza,eleonore,dorthey,doria,donella,dinorah,delorse,claretha,christinia,charlyn,bong,belkis,azzie,andera,aiko,adena,yajaira,vania,ulrike,toshia,tifany,stefany,shizue,shenika,shawanna,sharolyn,sharilyn,shaquana,shantay,rozanne,roselee,remona,reanna,raelene,phung,petronila,natacha,nancey,myrl,miyoko,miesha,merideth,marvella,marquitta,marhta,marchelle,lizeth,libbie,lahoma,ladawn,kina,katheleen,katharyn,karisa,kaleigh,junie,julieann,johnsie,janean,jaimee,jackqueline,hisako,herma,helaine,gwyneth,gita,eustolia,emelina,elin,edris,donnette,donnetta,dierdre,denae,darcel,clarisa,cinderella,chia,charlesetta,charita,celsa,cassy,cassi,carlee,bruna,brittaney,brande,billi,antonetta,angla,angelyn,analisa,alane,wenona,wendie,veronique,vannesa,tobie,tempie,sumiko,sulema,somer,sheba,sharice,shanel,shalon,rosio,roselia,renay,rema,reena,ozie,oretha,oralee,ngan,nakesha,milly,marybelle,margrett,maragaret,manie,lurlene,lillia,lieselotte,lavelle,lashaunda,lakeesha,kaycee,kalyn,joya,joette,jenae,janiece,illa,grisel,glayds,genevie,gala,fredda,eleonor,debera,deandrea,corrinne,cordia,contessa,colene,cleotilde,chantay,cecille,beatris,azalee,arlean,ardath,anjelica,anja,alfredia,aleisha,zada,yuonne,xiao,willodean,vennie,vanna,tyisha,tova,torie,tonisha,tilda,tien,sirena,sherril,shanti,shan,senaida,samella,robbyn,renda,reita,phebe,paulita,nobuko,nguyet,neomi,mikaela,melania,maximina,marg,maisie,lynna,lilli,lashaun,lakenya,lael,kirstie,kathline,kasha,karlyn,karima,jovan,josefine,jennell,jacqui,jackelyn,hien,grazyna,florrie,floria,eleonora,dwana,dorla,delmy,deja,dede,dann,crysta,clelia,claris,chieko,cherlyn,cherelle,charmain,chara,cammy,arnette,ardelle,annika,amiee,amee,allena,yvone,yuki,yoshie,yevette,yael,willetta,voncile,venetta,tula,tonette,timika,temika,telma,teisha,taren,stacee,shawnta,saturnina,ricarda,pasty,onie,nubia,marielle,mariella,marianela,mardell,luanna,loise,lisabeth,lindsy,lilliana,lilliam,lelah,leigha,leanora,kristeen,khalilah,keeley,kandra,junko,joaquina,jerlene,jani,jamika,hsiu,hermila,genevive,evia,eugena,emmaline,elfreda,elene,donette,delcie,deeanna,darcey,clarinda,cira,chae,celinda,catheryn,casimira,carmelia,camellia,breana,bobette,bernardina,bebe,basilia,arlyne,amal,alayna,zonia,zenia,yuriko,yaeko,wynell,willena,vernia,tora,terrilyn,terica,tenesha,tawna,tajuana,taina,stephnie,sona,sina,shondra,shizuko,sherlene,sherice,sharika,rossie,rosena,rima,rheba,renna,natalya,nancee,melodi,meda,matha,marketta,maricruz,marcelene,malvina,luba,louetta,leida,lecia,lauran,lashawna,laine,khadijah,katerine,kasi,kallie,julietta,jesusita,jestine,jessia,jeffie,janyce,isadora,georgianne,fidelia,evita,eura,eulah,estefana,elsy,eladia,dodie,denisse,deloras,delila,daysi,crystle,concha,claretta,charlsie,charlena,carylon,bettyann,asley,ashlea,amira,agueda,agnus,yuette,vinita,victorina,tynisha,treena,toccara,tish,thomasena,tegan,soila,shenna,sharmaine,shantae,shandi,saran,sarai,sana,rosette,rolande,regine,otelia,olevia,nicholle,necole,naida,myrta,myesha,mitsue,minta,mertie,margy,mahalia,madalene,loura,lorean,lesha,leonida,lenita,lavone,lashell,lashandra,lamonica,kimbra,katherina,karry,kanesha,jong,jeneva,jaquelyn,gilma,ghislaine,gertrudis,fransisca,fermina,ettie,etsuko,ellan,elidia,edra,dorethea,doreatha,denyse,deetta,daine,cyrstal,corrin,cayla,carlita,camila,burma,bula,buena,barabara,avril,alaine,zana,wilhemina,wanetta,verline,vasiliki,tonita,tisa,teofila,tayna,taunya,tandra,takako,sunni,suanne,sixta,sharell,seema,rosenda,robena,raymonde,pamila,ozell,neida,mistie,micha,merissa,maurita,maryln,maryetta,marcell,malena,makeda,lovetta,lourie,lorrine,lorilee,laurena,lashay,larraine,laree,lacresha,kristle,keva,keira,karole,joie,jinny,jeannetta,jama,heidy,gilberte,gema,faviola,evelynn,enda,elli,ellena,divina,dagny,collene,codi,cindie,chassidy,chasidy,catrice,catherina,cassey,caroll,carlena,candra,calista,bryanna,britteny,beula,bari,audrie,audria,ardelia,annelle,angila,alona,allyn".split(","),
    surnames: "smith,johnson,williams,jones,brown,davis,miller,wilson,moore,taylor,anderson,jackson,white,harris,martin,thompson,garcia,martinez,robinson,clark,rodriguez,lewis,lee,walker,hall,allen,young,hernandez,king,wright,lopez,hill,green,adams,baker,gonzalez,nelson,carter,mitchell,perez,roberts,turner,phillips,campbell,parker,evans,edwards,collins,stewart,sanchez,morris,rogers,reed,cook,morgan,bell,murphy,bailey,rivera,cooper,richardson,cox,howard,ward,torres,peterson,gray,ramirez,watson,brooks,sanders,price,bennett,wood,barnes,ross,henderson,coleman,jenkins,perry,powell,long,patterson,hughes,flores,washington,butler,simmons,foster,gonzales,bryant,alexander,griffin,diaz,hayes,myers,ford,hamilton,graham,sullivan,wallace,woods,cole,west,owens,reynolds,fisher,ellis,harrison,gibson,mcdonald,cruz,marshall,ortiz,gomez,murray,freeman,wells,webb,simpson,stevens,tucker,porter,hicks,crawford,boyd,mason,morales,kennedy,warren,dixon,ramos,reyes,burns,gordon,shaw,holmes,rice,robertson,hunt,black,daniels,palmer,mills,nichols,grant,knight,ferguson,stone,hawkins,dunn,perkins,hudson,spencer,gardner,stephens,payne,pierce,berry,matthews,arnold,wagner,willis,watkins,olson,carroll,duncan,snyder,hart,cunningham,lane,andrews,ruiz,harper,fox,riley,armstrong,carpenter,weaver,greene,elliott,chavez,sims,peters,kelley,franklin,lawson,fields,gutierrez,schmidt,carr,vasquez,castillo,wheeler,chapman,montgomery,richards,williamson,johnston,banks,meyer,bishop,mccoy,howell,alvarez,morrison,hansen,fernandez,garza,harvey,burton,nguyen,jacobs,reid,fuller,lynch,garrett,romero,welch,larson,frazier,burke,hanson,mendoza,moreno,bowman,medina,fowler,brewer,hoffman,carlson,silva,pearson,holland,fleming,jensen,vargas,byrd,davidson,hopkins,herrera,wade,soto,walters,neal,caldwell,lowe,jennings,barnett,graves,jimenez,horton,shelton,barrett,obrien,castro,sutton,mckinney,lucas,miles,rodriquez,chambers,holt,lambert,fletcher,watts,bates,hale,rhodes,pena,beck,newman,haynes,mcdaniel,mendez,bush,vaughn,parks,dawson,santiago,norris,hardy,steele,curry,powers,schultz,barker,guzman,page,munoz,ball,keller,chandler,weber,walsh,lyons,ramsey,wolfe,schneider,mullins,benson,sharp,bowen,barber,cummings,hines,baldwin,griffith,valdez,hubbard,salazar,reeves,warner,stevenson,burgess,santos,tate,cross,garner,mann,mack,moss,thornton,mcgee,farmer,delgado,aguilar,vega,glover,manning,cohen,harmon,rodgers,robbins,newton,blair,higgins,ingram,reese,cannon,strickland,townsend,potter,goodwin,walton,rowe,hampton,ortega,patton,swanson,goodman,maldonado,yates,becker,erickson,hodges,rios,conner,adkins,webster,malone,hammond,flowers,cobb,moody,quinn,pope,osborne,mccarthy,guerrero,estrada,sandoval,gibbs,gross,fitzgerald,stokes,doyle,saunders,wise,colon,gill,alvarado,greer,padilla,waters,nunez,ballard,schwartz,mcbride,houston,christensen,klein,pratt,briggs,parsons,mclaughlin,zimmerman,buchanan,moran,copeland,pittman,brady,mccormick,holloway,brock,poole,logan,bass,marsh,drake,wong,jefferson,morton,abbott,sparks,norton,huff,massey,figueroa,carson,bowers,roberson,barton,tran,lamb,harrington,boone,cortez,clarke,mathis,singleton,wilkins,cain,underwood,hogan,mckenzie,collier,luna,phelps,mcguire,bridges,wilkerson,nash,summers,atkins,wilcox,pitts,conley,marquez,burnett,cochran,chase,davenport,hood,gates,ayala,sawyer,vazquez,dickerson,hodge,acosta,flynn,espinoza,nicholson,monroe,wolf,morrow,whitaker,oconnor,skinner,ware,molina,kirby,huffman,gilmore,dominguez,oneal,lang,combs,kramer,hancock,gallagher,gaines,shaffer,wiggins,mathews,mcclain,fischer,wall,melton,hensley,bond,dyer,grimes,contreras,wyatt,baxter,snow,mosley,shepherd,larsen,hoover,beasley,petersen,whitehead,meyers,garrison,shields,horn,savage,olsen,schroeder,hartman,woodard,mueller,kemp,deleon,booth,patel,calhoun,wiley,eaton,cline,navarro,harrell,humphrey,parrish,duran,hutchinson,hess,dorsey,bullock,robles,beard,dalton,avila,rich,blackwell,johns,blankenship,trevino,salinas,campos,pruitt,callahan,montoya,hardin,guerra,mcdowell,stafford,gallegos,henson,wilkinson,booker,merritt,atkinson,orr,decker,hobbs,tanner,knox,pacheco,stephenson,glass,rojas,serrano,marks,hickman,sweeney,strong,mcclure,conway,roth,maynard,farrell,lowery,hurst,nixon,weiss,trujillo,ellison,sloan,juarez,winters,mclean,boyer,villarreal,mccall,gentry,carrillo,ayers,lara,sexton,pace,hull,leblanc,browning,velasquez,leach,chang,sellers,herring,noble,foley,bartlett,mercado,landry,durham,walls,barr,mckee,bauer,rivers,bradshaw,pugh,velez,rush,estes,dodson,morse,sheppard,weeks,camacho,bean,barron,livingston,middleton,spears,branch,blevins,chen,kerr,mcconnell,hatfield,harding,solis,frost,giles,blackburn,pennington,woodward,finley,mcintosh,koch,mccullough,blanchard,rivas,brennan,mejia,kane,benton,buckley,valentine,maddox,russo,mcknight,buck,moon,mcmillan,crosby,berg,dotson,mays,roach,chan,richmond,meadows,faulkner,oneill,knapp,kline,ochoa,jacobson,gay,hendricks,horne,shepard,hebert,cardenas,mcintyre,waller,holman,donaldson,cantu,morin,gillespie,fuentes,tillman,bentley,peck,key,salas,rollins,gamble,dickson,santana,cabrera,cervantes,howe,hinton,hurley,spence,zamora,yang,mcneil,suarez,petty,gould,mcfarland,sampson,carver,bray,macdonald,stout,hester,melendez,dillon,farley,hopper,galloway,potts,joyner,stein,aguirre,osborn,mercer,bender,franco,rowland,sykes,pickett,sears,mayo,dunlap,hayden,wilder,mckay,coffey,mccarty,ewing,cooley,vaughan,bonner,cotton,holder,stark,ferrell,cantrell,fulton,lott,calderon,pollard,hooper,burch,mullen,fry,riddle,levy,duke,odonnell,britt,daugherty,berger,dillard,alston,frye,riggs,chaney,odom,duffy,fitzpatrick,valenzuela,mayer,alford,mcpherson,acevedo,barrera,cote,reilly,compton,mooney,mcgowan,craft,clemons,wynn,nielsen,baird,stanton,snider,rosales,bright,witt,hays,holden,rutledge,kinney,clements,castaneda,slater,hahn,burks,delaney,pate,lancaster,sharpe,whitfield,talley,macias,burris,ratliff,mccray,madden,kaufman,beach,goff,cash,bolton,mcfadden,levine,byers,kirkland,kidd,workman,carney,mcleod,holcomb,finch,sosa,haney,franks,sargent,nieves,downs,rasmussen,bird,hewitt,foreman,valencia,oneil,delacruz,vinson,dejesus,hyde,forbes,gilliam,guthrie,wooten,huber,barlow,boyle,mcmahon,buckner,rocha,puckett,langley,knowles,cooke,velazquez,whitley,vang,shea,rouse,hartley,mayfield,elder,rankin,hanna,cowan,lucero,arroyo,slaughter,haas,oconnell,minor,boucher,archer,boggs,dougherty,andersen,newell,crowe,wang,friedman,bland,swain,holley,pearce,childs,yarbrough,galvan,proctor,meeks,lozano,mora,rangel,bacon,villanueva,schaefer,rosado,helms,boyce,goss,stinson,ibarra,hutchins,covington,crowley,hatcher,mackey,bunch,womack,polk,dodd,childress,childers,villa,springer,mahoney,dailey,belcher,lockhart,griggs,costa,brandt,walden,moser,tatum,mccann,akers,lutz,pryor,orozco,mcallister,lugo,davies,shoemaker,rutherford,newsome,magee,chamberlain,blanton,simms,godfrey,flanagan,crum,cordova,escobar,downing,sinclair,donahue,krueger,mcginnis,gore,farris,webber,corbett,andrade,starr,lyon,yoder,hastings,mcgrath,spivey,krause,harden,crabtree,kirkpatrick,arrington,ritter,mcghee,bolden,maloney,gagnon,dunbar,ponce,pike,mayes,beatty,mobley,kimball,butts,montes,eldridge,braun,hamm,gibbons,moyer,manley,herron,plummer,elmore,cramer,rucker,pierson,fontenot,rubio,goldstein,elkins,wills,novak,hickey,worley,gorman,katz,dickinson,broussard,woodruff,crow,britton,nance,lehman,bingham,zuniga,whaley,shafer,coffman,steward,delarosa,neely,mata,davila,mccabe,kessler,hinkle,welsh,pagan,goldberg,goins,crouch,cuevas,quinones,mcdermott,hendrickson,samuels,denton,bergeron,ivey,locke,haines,snell,hoskins,byrne,arias,corbin,beltran,chappell,downey,dooley,tuttle,couch,payton,mcelroy,crockett,groves,cartwright,dickey,mcgill,dubois,muniz,tolbert,dempsey,cisneros,sewell,latham,vigil,tapia,rainey,norwood,stroud,meade,tipton,kuhn,hilliard,bonilla,teague,gunn,greenwood,correa,reece,pineda,phipps,frey,kaiser,ames,gunter,schmitt,milligan,espinosa,bowden,vickers,lowry,pritchard,costello,piper,mcclellan,lovell,sheehan,hatch,dobson,singh,jeffries,hollingsworth,sorensen,meza,fink,donnelly,burrell,tomlinson,colbert,billings,ritchie,helton,sutherland,peoples,mcqueen,thomason,givens,crocker,vogel,robison,dunham,coker,swartz,keys,ladner,richter,hargrove,edmonds,brantley,albright,murdock,boswell,muller,quintero,padgett,kenney,daly,connolly,inman,quintana,lund,barnard,villegas,simons,huggins,tidwell,sanderson,bullard,mcclendon,duarte,draper,marrero,dwyer,abrams,stover,goode,fraser,crews,bernal,godwin,conklin,mcneal,baca,esparza,crowder,bower,brewster,mcneill,rodrigues,leal,coates,raines,mccain,mccord,miner,holbrook,swift,dukes,carlisle,aldridge,ackerman,starks,ricks,holliday,ferris,hairston,sheffield,lange,fountain,doss,betts,kaplan,carmichael,bloom,ruffin,penn,kern,bowles,sizemore,larkin,dupree,seals,metcalf,hutchison,henley,farr,mccauley,hankins,gustafson,curran,waddell,ramey,cates,pollock,cummins,messer,heller,funk,cornett,palacios,galindo,cano,hathaway,pham,enriquez,salgado,pelletier,painter,wiseman,blount,feliciano,houser,doherty,mead,mcgraw,swan,capps,blanco,blackmon,thomson,mcmanus,burkett,gleason,dickens,cormier,voss,rushing,rosenberg,hurd,dumas,benitez,arellano,marin,caudill,bragg,jaramillo,huerta,gipson,colvin,biggs,vela,platt,cassidy,tompkins,mccollum,dolan,daley,crump,sneed,kilgore,grove,grimm,davison,brunson,prater,marcum,devine,dodge,stratton,rosas,choi,tripp,ledbetter,hightower,feldman,epps,yeager,posey,scruggs,cope,stubbs,richey,overton,trotter,sprague,cordero,butcher,stiles,burgos,woodson,horner,bassett,purcell,haskins,akins,ziegler,spaulding,hadley,grubbs,sumner,murillo,zavala,shook,lockwood,driscoll,dahl,thorpe,redmond,putnam,mcwilliams,mcrae,romano,joiner,sadler,hedrick,hager,hagen,fitch,coulter,thacker,mansfield,langston,guidry,ferreira,corley,conn,rossi,lackey,baez,saenz,mcnamara,mcmullen,mckenna,mcdonough,link,engel,browne,roper,peacock,eubanks,drummond,stringer,pritchett,parham,mims,landers,grayson,schafer,egan,timmons,ohara,keen,hamlin,finn,cortes,mcnair,nadeau,moseley,michaud,rosen,oakes,kurtz,jeffers,calloway,beal,bautista,winn,suggs,stern,stapleton,lyles,laird,montano,dawkins,hagan,goldman,bryson,barajas,lovett,segura,metz,lockett,langford,hinson,eastman,hooks,smallwood,shapiro,crowell,whalen,triplett,chatman,aldrich,cahill,youngblood,ybarra,stallings,sheets,reeder,connelly,bateman,abernathy,winkler,wilkes,masters,hackett,granger,gillis,schmitz,sapp,napier,souza,lanier,gomes,weir,otero,ledford,burroughs,babcock,ventura,siegel,dugan,bledsoe,atwood,wray,varner,spangler,anaya,staley,kraft,fournier,belanger,wolff,thorne,bynum,burnette,boykin,swenson,purvis,pina,khan,duvall,darby,xiong,kauffman,healy,engle,benoit,valle,steiner,spicer,shaver,randle,lundy,chin,calvert,staton,neff,kearney,darden,oakley,medeiros,mccracken,crenshaw,perdue,dill,whittaker,tobin,washburn,hogue,goodrich,easley,bravo,dennison,shipley,kerns,jorgensen,crain,villalobos,maurer,longoria,keene,coon,witherspoon,staples,pettit,kincaid,eason,madrid,echols,lusk,stahl,currie,thayer,shultz,mcnally,seay,maher,gagne,barrow,nava,moreland,honeycutt,hearn,diggs,caron,whitten,westbrook,stovall,ragland,munson,meier,looney,kimble,jolly,hobson,goddard,culver,burr,presley,negron,connell,tovar,huddleston,ashby,salter,root,pendleton,oleary,nickerson,myrick,judd,jacobsen,bain,adair,starnes,matos,busby,herndon,hanley,bellamy,doty,bartley,yazzie,rowell,parson,gifford,cullen,christiansen,benavides,barnhart,talbot,mock,crandall,connors,bonds,whitt,gage,bergman,arredondo,addison,lujan,dowdy,jernigan,huynh,bouchard,dutton,rhoades,ouellette,kiser,herrington,hare,blackman,babb,allred,rudd,paulson,ogden,koenig,geiger,begay,parra,lassiter,hawk,esposito,waldron,ransom,prather,chacon,vick,sands,roark,parr,mayberry,greenberg,coley,bruner,whitman,skaggs,shipman,leary,hutton,romo,medrano,ladd,kruse,askew,schulz,alfaro,tabor,mohr,gallo,bermudez,pereira,bliss,reaves,flint,comer,woodall,naquin,guevara,delong,carrier,pickens,tilley,schaffer,knutson,fenton,doran,vogt,vann,prescott,mclain,landis,corcoran,zapata,hyatt,hemphill,faulk,dove,boudreaux,aragon,whitlock,trejo,tackett,shearer,saldana,hanks,mckinnon,koehler,bourgeois,keyes,goodson,foote,lunsford,goldsmith,flood,winslow,sams,reagan,mccloud,hough,esquivel,naylor,loomis,coronado,ludwig,braswell,bearden,huang,fagan,ezell,edmondson,cronin,nunn,lemon,guillory,grier,dubose,traylor,ryder,dobbins,coyle,aponte,whitmore,smalls,rowan,malloy,cardona,braxton,borden,humphries,carrasco,ruff,metzger,huntley,hinojosa,finney,madsen,ernst,dozier,burkhart,bowser,peralta,daigle,whittington,sorenson,saucedo,roche,redding,fugate,avalos,waite,lind,huston,hawthorne,hamby,boyles,boles,regan,faust,crook,beam,barger,hinds,gallardo,willoughby,willingham,eckert,busch,zepeda,worthington,tinsley,hoff,hawley,carmona,varela,rector,newcomb,kinsey,dube,whatley,ragsdale,bernstein,becerra,yost,mattson,felder,cheek,handy,grossman,gauthier,escobedo,braden,beckman,mott,hillman,flaherty,dykes,stockton,stearns,lofton,coats,cavazos,beavers,barrios,tang,mosher,cardwell,coles,burnham,weller,lemons,beebe,aguilera,parnell,harman,couture,alley,schumacher,redd,dobbs,blum,blalock,merchant,ennis,denson,cottrell,brannon,bagley,aviles,watt,sousa,rosenthal,rooney,dietz,blank,paquette,mcclelland,duff,velasco,lentz,grubb,burrows,barbour,ulrich,shockley,rader,beyer,mixon,layton,altman,weathers,stoner,squires,shipp,priest,lipscomb,cutler,caballero,zimmer,willett,thurston,storey,medley,epperson,shah,mcmillian,baggett,torrez,hirsch,dent,poirier,peachey,farrar,creech,barth,trimble,dupre,albrecht,sample,lawler,crisp,conroy,wetzel,nesbitt,murry,jameson,wilhelm,patten,minton,matson,kimbrough,guinn,croft,toth,pulliam,nugent,newby,littlejohn,dias,canales,bernier,baron,singletary,renteria,pruett,mchugh,mabry,landrum,brower,stoddard,cagle,stjohn,scales,kohler,kellogg,hopson,gant,tharp,gann,zeigler,pringle,hammons,fairchild,deaton,chavis,carnes,rowley,matlock,kearns,irizarry,carrington,starkey,lopes,jarrell,craven,baum,littlefield,linn,humphreys,etheridge,cuellar,chastain,bundy,speer,skelton,quiroz,pyle,portillo,ponder,moulton,machado,killian,hutson,hitchcock,dowling,cloud,burdick,spann,pedersen,levin,leggett,hayward,dietrich,beaulieu,barksdale,wakefield,snowden,briscoe,bowie,berman,ogle,mcgregor,laughlin,helm,burden,wheatley,schreiber,pressley,parris,alaniz,agee,swann,snodgrass,schuster,radford,monk,mattingly,harp,girard,cheney,yancey,wagoner,ridley,lombardo,hudgins,gaskins,duckworth,coburn,willey,prado,newberry,magana,hammonds,elam,whipple,slade,serna,ojeda,liles,dorman,diehl,upton,reardon,michaels,goetz,eller,bauman,baer,layne,hummel,brenner,amaya,adamson,ornelas,dowell,cloutier,castellanos,wellman,saylor,orourke,moya,montalvo,kilpatrick,durbin,shell,oldham,kang,garvin,foss,branham,bartholomew,templeton,maguire,holton,rider,monahan,mccormack,beaty,anders,streeter,nieto,nielson,moffett,lankford,keating,heck,gatlin,delatorre,callaway,adcock,worrell,unger,robinette,nowak,jeter,brunner,steen,parrott,overstreet,nobles,montanez,clevenger,brinkley,trahan,quarles,pickering,pederson,jansen,grantham,gilchrist,crespo,aiken,schell,schaeffer,lorenz,leyva,harms,dyson,wallis,pease,leavitt,cheng,cavanaugh,batts,warden,seaman,rockwell,quezada,paxton,linder,houck,fontaine,durant,caruso,adler,pimentel,mize,lytle,cleary,cason,acker,switzer,isaacs,higginbotham,waterman,vandyke,stamper,sisk,shuler,riddick,mcmahan,levesque,hatton,bronson,bollinger,arnett,okeefe,gerber,gannon,farnsworth,baughman,silverman,satterfield,mccrary,kowalski,grigsby,greco,cabral,trout,rinehart,mahon,linton,gooden,curley,baugh,wyman,weiner,schwab,schuler,morrissey,mahan,bunn,thrasher,spear,waggoner,qualls,purdy,mcwhorter,mauldin,gilman,perryman,newsom,menard,martino,graf,billingsley,artis,simpkins,salisbury,quintanilla,gilliland,fraley,foust,crouse,scarborough,grissom,fultz,marlow,markham,madrigal,lawton,barfield,whiting,varney,schwarz,gooch,arce,wheat,truong,poulin,hurtado,selby,gaither,fortner,culpepper,coughlin,brinson,boudreau,bales,stepp,holm,schilling,morrell,kahn,heaton,gamez,causey,turpin,shanks,schrader,meek,isom,hardison,carranza,yanez,scroggins,schofield,runyon,ratcliff,murrell,moeller,irby,currier,butterfield,ralston,pullen,pinson,estep,carbone,hawks,ellington,casillas,spurlock,sikes,motley,mccartney,kruger,isbell,houle,burk,tomlin,quigley,neumann,lovelace,fennell,cheatham,bustamante,skidmore,hidalgo,forman,culp,bowens,betancourt,aquino,robb,milner,martel,gresham,wiles,ricketts,dowd,collazo,bostic,blakely,sherrod,kenyon,gandy,ebert,deloach,allard,sauer,robins,olivares,gillette,chestnut,bourque,paine,hite,hauser,devore,crawley,chapa,talbert,poindexter,meador,mcduffie,mattox,kraus,harkins,choate,wren,sledge,sanborn,kinder,geary,cornwell,barclay,abney,seward,rhoads,howland,fortier,benner,vines,tubbs,troutman,rapp,mccurdy,deluca,westmoreland,havens,guajardo,clary,seal,meehan,herzog,guillen,ashcraft,waugh,renner,milam,elrod,churchill,breaux,bolin,asher,windham,tirado,pemberton,nolen,noland,knott,emmons,cornish,christenson,brownlee,barbee,waldrop,pitt,olvera,lombardi,gruber,gaffney,eggleston,banda,archuleta,slone,prewitt,pfeiffer,nettles,mena,mcadams,henning,gardiner,cromwell,chisholm,burleson,vest,oglesby,mccarter,lumpkin,wofford,vanhorn,thorn,teel,swafford,stclair,stanfield,ocampo,herrmann,hannon,arsenault,roush,mcalister,hiatt,gunderson,forsythe,duggan,delvalle,cintron,wilks,weinstein,uribe,rizzo,noyes,mclendon,gurley,bethea,winstead,maples,guyton,giordano,alderman,valdes,polanco,pappas,lively,grogan,griffiths,bobo,arevalo,whitson,sowell,rendon,fernandes,farrow,benavidez,ayres,alicea,stump,smalley,seitz,schulte,gilley,gallant,canfield,wolford,omalley,mcnutt,mcnulty,mcgovern,hardman,harbin,cowart,chavarria,brink,beckett,bagwell,armstead,anglin,abreu,reynoso,krebs,jett,hoffmann,greenfield,forte,burney,broome,sisson,trammell,partridge,mace,lomax,lemieux,gossett,frantz,fogle,cooney,broughton,pence,paulsen,muncy,mcarthur,hollins,beauchamp,withers,osorio,mulligan,hoyle,dockery,cockrell,begley,amador,roby,rains,lindquist,gentile,everhart,bohannon,wylie,sommers,purnell,fortin,dunning,breeden,vail,phelan,phan,marx,cosby,colburn,boling,biddle,ledesma,gaddis,denney,chow,bueno,berrios,wicker,tolliver,thibodeaux,nagle,lavoie,fisk,crist,barbosa,reedy,locklear,kolb,himes,behrens,beckwith,weems,wahl,shorter,shackelford,rees,muse,cerda,valadez,thibodeau,saavedra,ridgeway,reiter,mchenry,majors,lachance,keaton,ferrara,clemens,blocker,applegate,needham,mojica,kuykendall,hamel,escamilla,doughty,burchett,ainsworth,vidal,upchurch,thigpen,strauss,spruill,sowers,riggins,ricker,mccombs,harlow,buffington,sotelo,olivas,negrete,morey,macon,logsdon,lapointe,bigelow,bello,westfall,stubblefield,lindley,hein,hawes,farrington,breen,birch,wilde,steed,sepulveda,reinhardt,proffitt,minter,messina,mcnabb,maier,keeler,gamboa,donohue,basham,shinn,crooks,cota,borders,bills,bachman,tisdale,tavares,schmid,pickard,gulley,fonseca,delossantos,condon,batista,wicks,wadsworth,martell,littleton,ison,haag,folsom,brumfield,broyles,brito,mireles,mcdonnell,leclair,hamblin,gough,fanning,binder,winfield,whitworth,soriano,palumbo,newkirk,mangum,hutcherson,comstock,carlin,beall,bair,wendt,watters,walling,putman,otoole,morley,mares,lemus,keener,hundley,dial,damico,billups,strother,mcfarlane,lamm,eaves,crutcher,caraballo,canty,atwell,taft,siler,rust,rawls,rawlings,prieto,mcneely,mcafee,hulsey,hackney,galvez,escalante,delagarza,crider,bandy,wilbanks,stowe,steinberg,renfro,masterson,massie,lanham,haskell,hamrick,dehart,burdette,branson,bourne,babin,aleman,worthy,tibbs,smoot,slack,paradis,mull,luce,houghton,gantt,furman,danner,christianson,burge,ashford,arndt,almeida,stallworth,shade,searcy,sager,noonan,mclemore,mcintire,maxey,lavigne,jobe,ferrer,falk,coffin,byrnes,aranda,apodaca,stamps,rounds,peek,olmstead,lewandowski,kaminski,dunaway,bruns,brackett,amato,reich,mcclung,lacroix,koontz,herrick,hardesty,flanders,cousins,cato,cade,vickery,shank,nagel,dupuis,croteau,cotter,stuckey,stine,porterfield,pauley,moffitt,knudsen,hardwick,goforth,dupont,blunt,barrows,barnhill,shull,rash,loftis,lemay,kitchens,horvath,grenier,fuchs,fairbanks,culbertson,calkins,burnside,beattie,ashworth,albertson,wertz,vaught,vallejo,turk,tuck,tijerina,sage,peterman,marroquin,marr,lantz,hoang,demarco,cone,berube,barnette,wharton,stinnett,slocum,scanlon,sander,pinto,mancuso,lima,headley,epstein,counts,clarkson,carnahan,boren,arteaga,adame,zook,whittle,whitehurst,wenzel,saxton,reddick,puente,handley,haggerty,earley,devlin,chaffin,cady,acuna,solano,sigler,pollack,pendergrass,ostrander,janes,francois,crutchfield,chamberlin,brubaker,baptiste,willson,reis,neeley,mullin,mercier,lira,layman,keeling,higdon,espinal,chapin,warfield,toledo,pulido,peebles,nagy,montague,mello,lear,jaeger,hogg,graff,furr,soliz,poore,mendenhall,mclaurin,maestas,gable,barraza,tillery,snead,pond,neill,mcculloch,mccorkle,lightfoot,hutchings,holloman,harness,dorn,bock,zielinski,turley,treadwell,stpierre,starling,somers,oswald,merrick,easterling,bivens,truitt,poston,parry,ontiveros,olivarez,moreau,medlin,lenz,knowlton,fairley,cobbs,chisolm,bannister,woodworth,toler,ocasio,noriega,neuman,moye,milburn,mcclanahan,lilley,hanes,flannery,dellinger,danielson,conti,blodgett,beers,weatherford,strain,karr,hitt,denham,custer,coble,clough,casteel,bolduc,batchelor,ammons,whitlow,tierney,staten,sibley,seifert,schubert,salcedo,mattison,laney,haggard,grooms,dees,cromer,cooks,colson,caswell,zarate,swisher,shin,ragan,pridgen,mcvey,matheny,lafleur,franz,ferraro,dugger,whiteside,rigsby,mcmurray,lehmann,jacoby,hildebrand,hendrick,headrick,goad,fincher,drury,borges,archibald,albers,woodcock,trapp,soares,seaton,monson,luckett,lindberg,kopp,keeton,healey,garvey,gaddy,fain,burchfield,wentworth,strand,stack,spooner,saucier,ricci,plunkett,pannell,ness,leger,freitas,fong,elizondo,duval,beaudoin,urbina,rickard,partin,mcgrew,mcclintock,ledoux,forsyth,faison,devries,bertrand,wasson,tilton,scarbrough,leung,irvine,garber,denning,corral,colley,castleberry,bowlin,bogan,beale,baines,trice,rayburn,parkinson,nunes,mcmillen,leahy,kimmel,higgs,fulmer,carden,bedford,taggart,spearman,prichard,morrill,koonce,heinz,hedges,guenther,grice,findley,dover,creighton,boothe,bayer,arreola,vitale,valles,raney,osgood,hanlon,burley,bounds,worden,weatherly,vetter,tanaka,stiltner,nevarez,mosby,montero,melancon,harter,hamer,goble,gladden,gist,ginn,akin,zaragoza,tarver,sammons,royster,oreilly,muir,morehead,luster,kingsley,kelso,grisham,glynn,baumann,alves,yount,tamayo,paterson,oates,menendez,longo,hargis,gillen,desantis,conover,breedlove,sumpter,scherer,rupp,reichert,heredia,creel,cohn,clemmons,casas,bickford,belton,bach,williford,whitcomb,tennant,sutter,stull,mccallum,langlois,keel,keegan,dangelo,dancy,damron,clapp,clanton,bankston,oliveira,mintz,mcinnis,martens,mabe,laster,jolley,hildreth,hefner,glaser,duckett,demers,brockman,blais,alcorn,agnew,toliver,tice,seeley,najera,musser,mcfall,laplante,galvin,fajardo,doan,coyne,copley,clawson,cheung,barone,wynne,woodley,tremblay,stoll,sparrow,sparkman,schweitzer,sasser,samples,roney,legg,heim,farias,colwell,christman,bratcher,winchester,upshaw,southerland,sorrell,sells,mccloskey,martindale,luttrell,loveless,lovejoy,linares,latimer,embry,coombs,bratton,bostick,venable,tuggle,toro,staggs,sandlin,jefferies,heckman,griffis,crayton,clem,browder,thorton,sturgill,sprouse,royer,rousseau,ridenour,pogue,perales,peeples,metzler,mesa,mccutcheon,mcbee,hornsby,heffner,corrigan,armijo,plante,peyton,paredes,macklin,hussey,hodgson,granados,frias,becnel,batten,almanza,turney,teal,sturgeon,meeker,mcdaniels,limon,keeney,hutto,holguin,gorham,fishman,fierro,blanchette,rodrigue,reddy,osburn,oden,lerma,kirkwood,keefer,haugen,hammett,chalmers,brinkman,baumgartner,zhang,valerio,tellez,steffen,shumate,sauls,ripley,kemper,guffey,evers,craddock,carvalho,blaylock,banuelos,balderas,wheaton,turnbull,shuman,pointer,mosier,mccue,ligon,kozlowski,johansen,ingle,herr,briones,snipes,rickman,pipkin,pantoja,orosco,moniz,lawless,kunkel,hibbard,galarza,enos,bussey,schott,salcido,perreault,mcdougal,mccool,haight,garris,easton,conyers,atherton,wimberly,utley,spellman,smithson,slagle,ritchey,rand,petit,osullivan,oaks,nutt,mcvay,mccreary,mayhew,knoll,jewett,harwood,cardoza,ashe,arriaga,zeller,wirth,whitmire,stauffer,rountree,redden,mccaffrey,martz,larose,langdon,humes,gaskin,faber,devito,cass,almond,wingfield,wingate,villareal,tyner,smothers,severson,reno,pennell,maupin,leighton,janssen,hassell,hallman,halcomb,folse,fitzsimmons,fahey,cranford,bolen,battles,battaglia,wooldridge,trask,rosser,regalado,mcewen,keefe,fuqua,echevarria,caro,boynton,andrus,viera,vanmeter,taber,spradlin,seibert,provost,prentice,oliphant,laporte,hwang,hatchett,hass,greiner,freedman,covert,chilton,byars,wiese,venegas,swank,shrader,roberge,mullis,mortensen,mccune,marlowe,kirchner,keck,isaacson,hostetler,halverson,gunther,griswold,fenner,durden,blackwood,ahrens,sawyers,savoy,nabors,mcswain,mackay,lavender,lash,labbe,jessup,fullerton,cruse,crittenden,correia,centeno,caudle,canady,callender,alarcon,ahern,winfrey,tribble,salley,roden,musgrove,minnick,fortenberry,carrion,bunting,batiste,whited,underhill,stillwell,rauch,pippin,perrin,messenger,mancini,lister,kinard,hartmann,fleck,wilt,treadway,thornhill,spalding,rafferty,pitre,patino,ordonez,linkous,kelleher,homan,galbraith,feeney,curtin,coward,camarillo,buss,bunnell,bolt,beeler,autry,alcala,witte,wentz,stidham,shively,nunley,meacham,martins,lemke,lefebvre,hynes,horowitz,hoppe,holcombe,dunne,derr,cochrane,brittain,bedard,beauregard,torrence,strunk,soria,simonson,shumaker,scoggins,oconner,moriarty,kuntz,ives,hutcheson,horan,hales,garmon,fitts,bohn,atchison,wisniewski,vanwinkle,sturm,sallee,prosser,moen,lundberg,kunz,kohl,keane,jorgenson,jaynes,funderburk,freed,durr,creamer,cosgrove,batson,vanhoose,thomsen,teeter,smyth,redmon,orellana,maness,heflin,goulet,frick,forney,bunker,asbury,aguiar,talbott,southard,mowery,mears,lemmon,krieger,hickson,elston,duong,delgadillo,dayton,dasilva,conaway,catron,bruton,bradbury,bordelon,bivins,bittner,bergstrom,beals,abell,whelan,tejada,pulley,pino,norfleet,nealy,maes,loper,gatewood,frierson,freund,finnegan,cupp,covey,catalano,boehm,bader,yoon,walston,tenney,sipes,rawlins,medlock,mccaskill,mccallister,marcotte,maclean,hughey,henke,harwell,gladney,gilson,chism,caskey,brandenburg,baylor,villasenor,veal,thatcher,stegall,petrie,nowlin,navarrete,lombard,loftin,lemaster,kroll,kovach,kimbrell,kidwell,hershberger,fulcher,cantwell,bustos,boland,bobbitt,binkley,wester,weis,verdin,tong,tiller,sisco,sharkey,seymore,rosenbaum,rohr,quinonez,pinkston,malley,logue,lessard,lerner,lebron,krauss,klinger,halstead,haller,getz,burrow,alger,shores,pfeifer,perron,nelms,munn,mcmaster,mckenney,manns,knudson,hutchens,huskey,goebel,flagg,cushman,click,castellano,carder,bumgarner,wampler,spinks,robson,neel,mcreynolds,mathias,maas,loera,jenson,florez,coons,buckingham,brogan,berryman,wilmoth,wilhite,thrash,shephard,seidel,schulze,roldan,pettis,obryan,maki,mackie,hatley,frazer,fiore,chesser,bottoms,bisson,benefield,allman,wilke,trudeau,timm,shifflett,mundy,milliken,mayers,leake,kohn,huntington,horsley,hermann,guerin,fryer,frizzell,foret,flemming,fife,criswell,carbajal,bozeman,boisvert,angulo,wallen,tapp,silvers,ramsay,oshea,orta,moll,mckeever,mcgehee,linville,kiefer,ketchum,howerton,groce,gass,fusco,corbitt,betz,bartels,amaral,aiello,weddle,sperry,seiler,runyan,raley,overby,osteen,olds,mckeown,matney,lauer,lattimore,hindman,hartwell,fredrickson,fredericks,espino,clegg,carswell,cambell,burkholder,woodbury,welker,totten,thornburg,theriault,stitt,stamm,stackhouse,scholl,saxon,rife,razo,quinlan,pinkerton,olivo,nesmith,nall,mattos,lafferty,justus,giron,geer,fielder,drayton,dortch,conners,conger,boatwright,billiot,barden,armenta,tibbetts,steadman,slattery,rinaldi,raynor,pinckney,pettigrew,milne,matteson,halsey,gonsalves,fellows,durand,desimone,cowley,cowles,brill,barham,barela,barba,ashmore,withrow,valenti,tejeda,spriggs,sayre,salerno,peltier,peel,merriman,matheson,lowman,lindstrom,hyland,giroux,earls,dugas,dabney,collado,briseno,baxley,whyte,wenger,vanover,vanburen,thiel,schindler,schiller,rigby,pomeroy,passmore,marble,manzo,mahaffey,lindgren,laflamme,greathouse,fite,calabrese,bayne,yamamoto,wick,townes,thames,reinhart,peeler,naranjo,montez,mcdade,mast,markley,marchand,leeper,kellum,hudgens,hennessey,hadden,gainey,coppola,borrego,bolling,beane,ault,slaton,pape,null,mulkey,lightner,langer,hillard,ethridge,enright,derosa,baskin,weinberg,turman,somerville,pardo,noll,lashley,ingraham,hiller,hendon,glaze,cothran,cooksey,conte,carrico,abner,wooley,swope,summerlin,sturgis,sturdivant,stott,spurgeon,spillman,speight,roussel,popp,nutter,mckeon,mazza,magnuson,lanning,kozak,jankowski,heyward,forster,corwin,callaghan,bays,wortham,usher,theriot,sayers,sabo,poling,loya,lieberman,laroche,labelle,howes,harr,garay,fogarty,everson,durkin,dominquez,chaves,chambliss,witcher,vieira,vandiver,terrill,stoker,schreiner,moorman,liddell,lawhorn,krug,irons,hylton,hollenbeck,herrin,hembree,goolsby,goodin,gilmer,foltz,dinkins,daughtry,caban,brim,briley,bilodeau,wyant,vergara,tallent,swearingen,stroup,scribner,quillen,pitman,mccants,maxfield,martinson,holtz,flournoy,brookins,brody,baumgardner,straub,sills,roybal,roundtree,oswalt,mcgriff,mcdougall,mccleary,maggard,gragg,gooding,godinez,doolittle,donato,cowell,cassell,bracken,appel,zambrano,reuter,perea,nakamura,monaghan,mickens,mcclinton,mcclary,marler,kish,judkins,gilbreath,freese,flanigan,felts,erdmann,dodds,chew,brownell,boatright,barreto,slayton,sandberg,saldivar,pettway,odum,narvaez,moultrie,montemayor,merrell,lees,keyser,hoke,hardaway,hannan,gilbertson,fogg,dumont,deberry,coggins,buxton,bucher,broadnax,beeson,araujo,appleton,amundson,aguayo,ackley,yocum,worsham,shivers,sanches,sacco,robey,rhoden,pender,ochs,mccurry,madera,luong,knotts,jackman,heinrich,hargrave,gault,comeaux,chitwood,caraway,boettcher,bernhardt,barrientos,zink,wickham,whiteman,thorp,stillman,settles,schoonover,roque,riddell,pilcher,phifer,novotny,macleod,hardee,haase,grider,doucette,clausen,bevins,beamon,badillo,tolley,tindall,soule,snook,seale,pinkney,pellegrino,nowell,nemeth,mondragon,mclane,lundgren,ingalls,hudspeth,hixson,gearhart,furlong,downes,dibble,deyoung,cornejo,camara,brookshire,boyette,wolcott,surratt,sellars,segal,salyer,reeve,rausch,labonte,haro,gower,freeland,fawcett,eads,driggers,donley,collett,bromley,boatman,ballinger,baldridge,volz,trombley,stonge,shanahan,rivard,rhyne,pedroza,matias,jamieson,hedgepeth,hartnett,estevez,eskridge,denman,chiu,chinn,catlett,carmack,buie,bechtel,beardsley,bard,ballou,ulmer,skeen,robledo,rincon,reitz,piazza,munger,moten,mcmichael,loftus,ledet,kersey,groff,fowlkes,crumpton,clouse,bettis,villagomez,timmerman,strom,santoro,roddy,penrod,musselman,macpherson,leboeuf,harless,haddad,guido,golding,fulkerson,fannin,dulaney,dowdell,cottle,ceja,cate,bosley,benge,albritton,voigt,trowbridge,soileau,seely,rohde,pearsall,paulk,orth,nason,mota,mcmullin,marquardt,madigan,hoag,gillum,gabbard,fenwick,danforth,cushing,cress,creed,cazares,bettencourt,barringer,baber,stansberry,schramm,rutter,rivero,oquendo,necaise,mouton,montenegro,miley,mcgough,marra,macmillan,lamontagne,jasso,horst,hetrick,heilman,gaytan,gall,fortney,dingle,desjardins,dabbs,burbank,brigham,breland,beaman,arriola,yarborough,wallin,toscano,stowers,reiss,pichardo,orton,michels,mcnamee,mccrory,leatherman,kell,keister,horning,hargett,guay,ferro,deboer,dagostino,carper,blanks,beaudry,towle,tafoya,stricklin,strader,soper,sonnier,sigmon,schenk,saddler,pedigo,mendes,lunn,lohr,lahr,kingsbury,jarman,hume,holliman,hofmann,haworth,harrelson,hambrick,flick,edmunds,dacosta,crossman,colston,chaplin,carrell,budd,weiler,waits,valentino,trantham,tarr,solorio,roebuck,powe,plank,pettus,pagano,mink,luker,leathers,joslin,hartzell,gambrell,cepeda,carty,caputo,brewington,bedell,ballew,applewhite,warnock,walz,urena,tudor,reel,pigg,parton,mickelson,meagher,mclellan,mcculley,mandel,leech,lavallee,kraemer,kling,kipp,kehoe,hochstetler,harriman,gregoire,grabowski,gosselin,gammon,fancher,edens,desai,brannan,armendariz,woolsey,whitehouse,whetstone,ussery,towne,testa,tallman,studer,strait,steinmetz,sorrells,sauceda,rolfe,paddock,mitchem,mcginn,mccrea,lovato,hazen,gilpin,gaynor,fike,devoe,delrio,curiel,burkhardt,bode,backus,zinn,watanabe,wachter,vanpelt,turnage,shaner,schroder,sato,riordan,quimby,portis,natale,mckoy,mccown,kilmer,hotchkiss,hesse,halbert,gwinn,godsey,delisle,chrisman,canter,arbogast,angell,acree,yancy,woolley,wesson,weatherspoon,trainor,stockman,spiller,sipe,rooks,reavis,propst,porras,neilson,mullens,loucks,llewellyn,kumar,koester,klingensmith,kirsch,kester,honaker,hodson,hennessy,helmick,garrity,garibay,drain,casarez,callis,botello,aycock,avant,wingard,wayman,tully,theisen,szymanski,stansbury,segovia,rainwater,preece,pirtle,padron,mincey,mckelvey,mathes,larrabee,kornegay,klug,ingersoll,hecht,germain,eggers,dykstra,deering,decoteau,deason,dearing,cofield,carrigan,bonham,bahr,aucoin,appleby,almonte,yager,womble,wimmer,weimer,vanderpool,stancil,sprinkle,romine,remington,pfaff,peckham,olivera,meraz,maze,lathrop,koehn,hazelton,halvorson,hallock,haddock,ducharme,dehaven,caruthers,brehm,bosworth,bost,bias,beeman,basile,bane,aikens,wold,walther,tabb,suber,strawn,stocker,shirey,schlosser,riedel,rembert,reimer,pyles,peele,merriweather,letourneau,latta,kidder,hixon,hillis,hight,herbst,henriquez,haygood,hamill,gabel,fritts,eubank,dawes,correll,bushey,buchholz,brotherton,botts,barnwell,auger,atchley,westphal,veilleux,ulloa,stutzman,shriver,ryals,pilkington,moyers,marrs,mangrum,maddux,lockard,laing,kuhl,harney,hammock,hamlett,felker,doerr,depriest,carrasquillo,carothers,bogle,bischoff,bergen,albanese,wyckoff,vermillion,vansickle,thibault,tetreault,stickney,shoemake,ruggiero,rawson,racine,philpot,paschal,mcelhaney,mathison,legrand,lapierre,kwan,kremer,jiles,hilbert,geyer,faircloth,ehlers,egbert,desrosiers,dalrymple,cotten,cashman,cadena,boardman,alcaraz,wyrick,therrien,tankersley,strickler,puryear,plourde,pattison,pardue,mcginty,mcevoy,landreth,kuhns,koon,hewett,giddens,emerick,eades,deangelis,cosme,ceballos,birdsong,benham,bemis,armour,anguiano,welborn,tsosie,storms,shoup,sessoms,samaniego,rood,rojo,rhinehart,raby,northcutt,myer,munguia,morehouse,mcdevitt,mallett,lozada,lemoine,kuehn,hallett,grim,gillard,gaylor,garman,gallaher,feaster,faris,darrow,dardar,coney,carreon,braithwaite,boylan,boyett,bixler,bigham,benford,barragan,barnum,zuber,wyche,westcott,vining,stoltzfus,simonds,shupe,sabin,ruble,rittenhouse,richman,perrone,mulholland,millan,lomeli,kite,jemison,hulett,holler,hickerson,herold,hazelwood,griffen,gause,forde,eisenberg,dilworth,charron,chaisson,bristow,breunig,brace,boutwell,bentz,belk,bayless,batchelder,baran,baeza,zimmermann,weathersby,volk,toole,theis,tedesco,searle,schenck,satterwhite,ruelas,rankins,partida,nesbit,morel,menchaca,levasseur,kaylor,johnstone,hulse,hollar,hersey,harrigan,harbison,guyer,gish,giese,gerlach,geller,geisler,falcone,elwell,doucet,deese,darr,corder,chafin,byler,bussell,burdett,brasher,bowe,bellinger,bastian,barner,alleyne,wilborn,weil,wegner,tatro,spitzer,smithers,schoen,resendez,parisi,overman,obrian,mudd,mahler,maggio,lindner,lalonde,lacasse,laboy,killion,kahl,jessen,jamerson,houk,henshaw,gustin,graber,durst,duenas,davey,cundiff,conlon,colunga,coakley,chiles,capers,buell,bricker,bissonnette,bartz,bagby,zayas,volpe,treece,toombs,thom,terrazas,swinney,skiles,silveira,shouse,senn,ramage,moua,langham,kyles,holston,hoagland,herd,feller,denison,carraway,burford,bickel,ambriz,abercrombie,yamada,weidner,waddle,verduzco,thurmond,swindle,schrock,sanabria,rosenberger,probst,peabody,olinger,nazario,mccafferty,mcbroom,mcabee,mazur,matherne,mapes,leverett,killingsworth,heisler,griego,gosnell,frankel,franke,ferrante,fenn,ehrlich,christopherso,chasse,caton,brunelle,bloomfield,babbitt,azevedo,abramson,ables,abeyta,youmans,wozniak,wainwright,stowell,smitherman,samuelson,runge,rothman,rosenfeld,peake,owings,olmos,munro,moreira,leatherwood,larkins,krantz,kovacs,kizer,kindred,karnes,jaffe,hubbell,hosey,hauck,goodell,erdman,dvorak,doane,cureton,cofer,buehler,bierman,berndt,banta,abdullah,warwick,waltz,turcotte,torrey,stith,seger,sachs,quesada,pinder,peppers,pascual,paschall,parkhurst,ozuna,oster,nicholls,lheureux,lavalley,kimura,jablonski,haun,gourley,gilligan,croy,cotto,cargill,burwell,burgett,buckman,booher,adorno,wrenn,whittemore,urias,szabo,sayles,saiz,rutland,rael,pharr,pelkey,ogrady,nickell,musick,moats,mather,massa,kirschner,kieffer,kellar,hendershot,gott,godoy,gadson,furtado,fiedler,erskine,dutcher,dever,daggett,chevalier,brake,ballesteros,amerson,wingo,waldon,trott,silvey,showers,schlegel,ritz,pepin,pelayo,parsley,palermo,moorehead,mchale,lett,kocher,kilburn,iglesias,humble,hulbert,huckaby,hartford,hardiman,gurney,grigg,grasso,goings,fillmore,farber,depew,dandrea,cowen,covarrubias,burrus,bracy,ardoin,thompkins,standley,radcliffe,pohl,persaud,parenteau,pabon,newson,newhouse,napolitano,mulcahy,malave,keim,hooten,hernandes,heffernan,hearne,greenleaf,glick,fuhrman,fetter,faria,dishman,dickenson,crites,criss,clapper,chenault,castor,casto,bugg,bove,bonney,anderton,allgood,alderson,woodman,warrick,toomey,tooley,tarrant,summerville,stebbins,sokol,searles,schutz,schumann,scheer,remillard,raper,proulx,palmore,monroy,messier,melo,melanson,mashburn,manzano,lussier,jenks,huneycutt,hartwig,grimsley,fulk,fielding,fidler,engstrom,eldred,dantzler,crandell,calder,brumley,breton,brann,bramlett,boykins,bianco,bancroft,almaraz,alcantar,whitmer,whitener,welton,vineyard,rahn,paquin,mizell,mcmillin,mckean,marston,maciel,lundquist,liggins,lampkin,kranz,koski,kirkham,jiminez,hazzard,harrod,graziano,grammer,gendron,garrido,fordham,englert,dryden,demoss,deluna,crabb,comeau,brummett,blume,benally,wessel,vanbuskirk,thorson,stumpf,stockwell,reams,radtke,rackley,pelton,niemi,newland,nelsen,morrissette,miramontes,mcginley,mccluskey,marchant,luevano,lampe,lail,jeffcoat,infante,hinman,gaona,eady,desmarais,decosta,dansby,cisco,choe,breckenridge,bostwick,borg,bianchi,alberts,wilkie,whorton,vargo,tait,soucy,schuman,ousley,mumford,lippert,leath,lavergne,laliberte,kirksey,kenner,johnsen,izzo,hiles,gullett,greenwell,gaspar,galbreath,gaitan,ericson,delapaz,croom,cottingham,clift,bushnell,bice,beason,arrowood,waring,voorhees,truax,shreve,shockey,schatz,sandifer,rubino,rozier,roseberry,pieper,peden,nester,nave,murphey,malinowski,macgregor,lafrance,kunkle,kirkman,hipp,hasty,haddix,gervais,gerdes,gamache,fouts,fitzwater,dillingham,deming,deanda,cedeno,cannady,burson,bouldin,arceneaux,woodhouse,whitford,wescott,welty,weigel,torgerson,toms,surber,sunderland,sterner,setzer,riojas,pumphrey,puga,metts,mcgarry,mccandless,magill,lupo,loveland,llamas,leclerc,koons,kahler,huss,holbert,heintz,haupt,grimmett,gaskill,ellingson,dorr,dingess,deweese,desilva,crossley,cordeiro,converse,conde,caldera,cairns,burmeister,burkhalter,brawner,bott,youngs,vierra,valladares,shrum,shropshire,sevilla,rusk,rodarte,pedraza,nino,merino,mcminn,markle,mapp,lajoie,koerner,kittrell,kato,hyder,hollifield,heiser,hazlett,greenwald,fant,eldredge,dreher,delafuente,cravens,claypool,beecher,aronson,alanis,worthen,wojcik,winger,whitacre,valverde,valdivia,troupe,thrower,swindell,suttles,stroman,spires,slate,shealy,sarver,sartin,sadowski,rondeau,rolon,rascon,priddy,paulino,nolte,munroe,molloy,mciver,lykins,loggins,lenoir,klotz,kempf,hupp,hollowell,hollander,haynie,harkness,harker,gottlieb,frith,eddins,driskell,doggett,densmore,charette,cassady,byrum,burcham,buggs,benn,whitted,warrington,vandusen,vaillancourt,steger,siebert,scofield,quirk,purser,plumb,orcutt,nordstrom,mosely,michalski,mcphail,mcdavid,mccraw,marchese,mannino,lefevre,largent,lanza,kress,isham,hunsaker,hoch,hildebrandt,guarino,grijalva,graybill,fick,ewell,ewald,cusick,crumley,coston,cathcart,carruthers,bullington,bowes,blain,blackford,barboza,yingling,wert,weiland,varga,silverstein,sievers,shuster,shumway,runnels,rumsey,renfroe,provencher,polley,mohler,middlebrooks,kutz,koster,groth,glidden,fazio,deen,chipman,chenoweth,champlin,cedillo,carrero,carmody,buckles,brien,boutin,bosch,berkowitz,altamirano,wilfong,wiegand,waites,truesdale,toussaint,tobey,tedder,steelman,sirois,schnell,robichaud,richburg,plumley,pizarro,piercy,ortego,oberg,neace,mertz,mcnew,matta,lapp,lair,kibler,howlett,hollister,hofer,hatten,hagler,falgoust,engelhardt,eberle,dombrowski,dinsmore,daye,casares,braud,balch,autrey,wendel,tyndall,strobel,stoltz,spinelli,serrato,reber,rathbone,palomino,nickels,mayle,mathers,mach,loeffler,littrell,levinson,leong,lemire,lejeune,lazo,lasley,koller,kennard,hoelscher,hintz,hagerman,greaves,fore,eudy,engler,corrales,cordes,brunet,bidwell,bennet,tyrrell,tharpe,swinton,stribling,southworth,sisneros,savoie,samons,ruvalcaba,ries,ramer,omara,mosqueda,millar,mcpeak,macomber,luckey,litton,lehr,lavin,hubbs,hoard,hibbs,hagans,futrell,exum,evenson,culler,carbaugh,callen,brashear,bloomer,blakeney,bigler,addington,woodford,unruh,tolentino,sumrall,stgermain,smock,sherer,rayner,pooler,oquinn,nero,mcglothlin,linden,kowal,kerrigan,ibrahim,harvell,hanrahan,goodall,geist,fussell,fung,ferebee,eley,eggert,dorsett,dingman,destefano,colucci,clemmer,burnell,brumbaugh,boddie,berryhill,avelar,alcantara,winder,winchell,vandenberg,trotman,thurber,thibeault,stlouis,stilwell,sperling,shattuck,sarmiento,ruppert,rumph,renaud,randazzo,rademacher,quiles,pearman,palomo,mercurio,lowrey,lindeman,lawlor,larosa,lander,labrecque,hovis,holifield,henninger,hawkes,hartfield,hann,hague,genovese,garrick,fudge,frink,eddings,dinh,cribbs,calvillo,bunton,brodeur,bolding,blanding,agosto,zahn,wiener,trussell,tello,teixeira,speck,sharma,shanklin,sealy,scanlan,santamaria,roundy,robichaux,ringer,rigney,prevost,polson,nord,moxley,medford,mccaslin,mcardle,macarthur,lewin,lasher,ketcham,keiser,heine,hackworth,grose,grizzle,gillman,gartner,frazee,fleury,edson,edmonson,derry,cronk,conant,burress,burgin,broom,brockington,bolick,boger,birchfield,billington,baily,bahena,armbruster,anson,yoho,wilcher,tinney,timberlake,thielen,sutphin,stultz,sikora,serra,schulman,scheffler,santillan,rego,preciado,pinkham,mickle,lomas,lizotte,lent,kellerman,keil,johanson,hernadez,hartsfield,haber,gorski,farkas,eberhardt,duquette,delano,cropper,cozart,cockerham,chamblee,cartagena,cahoon,buzzell,brister,brewton,blackshear,benfield,aston,ashburn,arruda,wetmore,weise,vaccaro,tucci,sudduth,stromberg,stoops,showalter,shears,runion,rowden,rosenblum,riffle,renfrow,peres,obryant,leftwich,lark,landeros,kistler,killough,kerley,kastner,hoggard,hartung,guertin,govan,gatling,gailey,fullmer,fulford,flatt,esquibel,endicott,edmiston,edelstein,dufresne,dressler,dickman,chee,busse,bonnett,berard,yoshida,velarde,veach,vanhouten,vachon,tolson,tolman,tennyson,stites,soler,shutt,ruggles,rhone,pegues,neese,muro,moncrief,mefford,mcphee,mcmorris,mceachern,mcclurg,mansour,mader,leija,lecompte,lafountain,labrie,jaquez,heald,hash,hartle,gainer,frisby,farina,eidson,edgerton,dyke,durrett,duhon,cuomo,cobos,cervantez,bybee,brockway,borowski,binion,beery,arguello,amaro,acton,yuen,winton,wigfall,weekley,vidrine,vannoy,tardiff,shoop,shilling,schick,safford,prendergast,pilgrim,pellerin,osuna,nissen,nalley,moller,messner,messick,merrifield,mcguinness,matherly,marcano,mahone,lemos,lebrun,jara,hoffer,herren,hecker,haws,haug,gwin,gober,gilliard,fredette,favela,echeverria,downer,donofrio,desrochers,crozier,corson,bechtold,argueta,aparicio,zamudio,westover,westerman,utter,troyer,thies,tapley,slavin,shirk,sandler,roop,rimmer,raymer,radcliff,otten,moorer,millet,mckibben,mccutchen,mcavoy,mcadoo,mayorga,mastin,martineau,marek,madore,leflore,kroeger,kennon,jimerson,hostetter,hornback,hendley,hance,guardado,granado,gowen,goodale,flinn,fleetwood,fitz,durkee,duprey,dipietro,dilley,clyburn,brawley,beckley,arana,weatherby,vollmer,vestal,tunnell,trigg,tingle,takahashi,sweatt,storer,snapp,shiver,rooker,rathbun,poisson,perrine,perri,parmer,parke,pare,papa,palmieri,midkiff,mecham,mccomas,mcalpine,lovelady,lillard,lally,knopp,kile,kiger,haile,gupta,goldsberry,gilreath,fulks,friesen,franzen,flack,findlay,ferland,dreyer,dore,dennard,deckard,debose,crim,coulombe,chancey,cantor,branton,bissell,barns,woolard,witham,wasserman,spiegel,shoffner,scholz,ruch,rossman,petry,palacio,paez,neary,mortenson,millsap,miele,menke,mckim,mcanally,martines,lemley,larochelle,klaus,klatt,kaufmann,kapp,helmer,hedge,halloran,glisson,frechette,fontana,eagan,distefano,danley,creekmore,chartier,chaffee,carillo,burg,bolinger,berkley,benz,basso,bash,zelaya,woodring,witkowski,wilmot,wilkens,wieland,verdugo,urquhart,tsai,timms,swiger,swaim,sussman,pires,molnar,mcatee,lowder,loos,linker,landes,kingery,hufford,higa,hendren,hammack,hamann,gillam,gerhardt,edelman,delk,deans,curl,constantine,cleaver,claar,casiano,carruth,carlyle,brophy,bolanos,bibbs,bessette,beggs,baugher,bartel,averill,andresen,amin,adames,valente,turnbow,swink,sublett,stroh,stringfellow,ridgway,pugliese,poteat,ohare,neubauer,murchison,mingo,lemmons,kwon,kellam,kean,jarmon,hyden,hudak,hollinger,henkel,hemingway,hasson,hansel,halter,haire,ginsberg,gillispie,fogel,flory,etter,elledge,eckman,deas,currin,crafton,coomer,colter,claxton,bulter,braddock,bowyer,binns,bellows,baskerville,barros,ansley,woolf,wight,waldman,wadley,tull,trull,tesch,stouffer,stadler,slay,shubert,sedillo,santacruz,reinke,poynter,neri,neale,mowry,moralez,monger,mitchum,merryman,manion,macdougall,litchfield,levitt,lepage,lasalle,khoury,kavanagh,karns,ivie,huebner,hodgkins,halpin,garica,eversole,dutra,dunagan,duffey,dillman,dillion,deville,dearborn,damato,courson,coulson,burdine,bousquet,bonin,bish,atencio,westbrooks,wages,vaca,toner,tillis,swett,struble,stanfill,solorzano,slusher,sipple,silvas,shults,schexnayder,saez,rodas,rager,pulver,penton,paniagua,meneses,mcfarlin,mcauley,matz,maloy,magruder,lohman,landa,lacombe,jaimes,holzer,holst,heil,hackler,grundy,gilkey,farnham,durfee,dunton,dunston,duda,dews,craver,corriveau,conwell,colella,chambless,bremer,boutte,bourassa,blaisdell,backman,babineaux,audette,alleman,towner,taveras,tarango,sullins,suiter,stallard,solberg,schlueter,poulos,pimental,owsley,okelley,moffatt,metcalfe,meekins,medellin,mcglynn,mccowan,marriott,marable,lennox,lamoureux,koss,kerby,karp,isenberg,howze,hockenberry,highsmith,hallmark,gusman,greeley,giddings,gaudet,gallup,fleenor,eicher,edington,dimaggio,dement,demello,decastro,bushman,brundage,brooker,bourg,blackstock,bergmann,beaton,banister,argo,appling,wortman,watterson,villalpando,tillotson,tighe,sundberg,sternberg,stamey,shipe,seeger,scarberry,sattler,sain,rothstein,poteet,plowman,pettiford,penland,partain,pankey,oyler,ogletree,ogburn,moton,merkel,lucier,lakey,kratz,kinser,kershaw,josephson,imhoff,hendry,hammon,frisbie,frawley,fraga,forester,eskew,emmert,drennan,doyon,dandridge,cawley,carvajal,bracey,belisle,batey,ahner,wysocki,weiser,veliz,tincher,sansone,sankey,sandstrom,rohrer,risner,pridemore,pfeffer,persinger,peery,oubre,nowicki,musgrave,murdoch,mullinax,mccary,mathieu,livengood,kyser,klink,kimes,kellner,kavanaugh,kasten,imes,hoey,hinshaw,hake,gurule,grube,grillo,geter,gatto,garver,garretson,farwell,eiland,dunford,decarlo,corso,colman,collard,cleghorn,chasteen,cavender,carlile,calvo,byerly,brogdon,broadwater,breault,bono,bergin,behr,ballenger,amick,tamez,stiffler,steinke,simmon,shankle,schaller,salmons,sackett,saad,rideout,ratcliffe,ranson,plascencia,petterson,olszewski,olney,olguin,nilsson,nevels,morelli,montiel,monge,michaelson,mertens,mcchesney,mcalpin,mathewson,loudermilk,lineberry,liggett,kinlaw,kight,jost,hereford,hardeman,halpern,halliday,hafer,gaul,friel,freitag,forsberg,evangelista,doering,dicarlo,dendy,delp,deguzman,dameron,curtiss,cosper,cauthen,bradberry,bouton,bonnell,bixby,bieber,beveridge,bedwell,barhorst,bannon,baltazar,baier,ayotte,attaway,arenas,abrego,turgeon,tunstall,thaxton,tenorio,stotts,sthilaire,shedd,seabolt,scalf,salyers,ruhl,rowlett,robinett,pfister,perlman,pepe,parkman,nunnally,norvell,napper,modlin,mckellar,mcclean,mascarenas,leibowitz,ledezma,kuhlman,kobayashi,hunley,holmquist,hinkley,hazard,hartsell,gribble,gravely,fifield,eliason,doak,crossland,carleton,bridgeman,bojorquez,boggess,auten,woosley,whiteley,wexler,twomey,tullis,townley,standridge,santoyo,rueda,riendeau,revell,pless,ottinger,nigro,nickles,mulvey,menefee,mcshane,mcloughlin,mckinzie,markey,lockridge,lipsey,knisley,knepper,kitts,kiel,jinks,hathcock,godin,gallego,fikes,fecteau,estabrook,ellinger,dunlop,dudek,countryman,chauvin,chatham,bullins,brownfield,boughton,bloodworth,bibb,baucom,barbieri,aubin,armitage,alessi,absher,abbate,zito,woolery,wiggs,wacker,tynes,tolle,telles,tarter,swarey,strode,stockdale,stalnaker,spina,schiff,saari,risley,rameriz,rakes,pettaway,penner,paulus,palladino,omeara,montelongo,melnick,mehta,mcgary,mccourt,mccollough,marchetti,manzanares,lowther,leiva,lauderdale,lafontaine,kowalczyk,knighton,joubert,jaworski,huth,hurdle,housley,hackman,gulick,gordy,gilstrap,gehrke,gebhart,gaudette,foxworth,endres,dunkle,cimino,caddell,brauer,braley,bodine,blackmore,belden,backer,ayer,andress,wisner,vuong,valliere,twigg,tavarez,strahan,steib,staub,sowder,seiber,schutt,scharf,schade,rodriques,risinger,renshaw,rahman,presnell,piatt,nieman,nevins,mcilwain,mcgaha,mccully,mccomb,massengale,macedo,lesher,kearse,jauregui,husted,hudnall,holmberg,hertel,hardie,glidewell,frausto,fassett,dalessandro,dahlgren,corum,constantino,conlin,colquitt,colombo,claycomb,cardin,buller,boney,bocanegra,biggers,benedetto,araiza,andino,albin,zorn,werth,weisman,walley,vanegas,ulibarri,towe,tedford,teasley,suttle,steffens,stcyr,squire,singley,sifuentes,shuck,schram,sass,rieger,ridenhour,rickert,richerson,rayborn,rabe,raab,pendley,pastore,ordway,moynihan,mellott,mckissick,mcgann,mccready,mauney,marrufo,lenhart,lazar,lafave,keele,kautz,jardine,jahnke,jacobo,hord,hardcastle,hageman,giglio,gehring,fortson,duque,duplessis,dicken,derosier,deitz,dalessio,cram,castleman,candelario,callison,caceres,bozarth,biles,bejarano,bashaw,avina,armentrout,alverez,acord,waterhouse,vereen,vanlandingham,strawser,shotwell,severance,seltzer,schoonmaker,schock,schaub,schaffner,roeder,rodrigez,riffe,rasberry,rancourt,railey,quade,pursley,prouty,perdomo,oxley,osterman,nickens,murphree,mounts,merida,maus,mattern,masse,martinelli,mangan,lutes,ludwick,loney,laureano,lasater,knighten,kissinger,kimsey,kessinger,honea,hollingshead,hockett,heyer,heron,gurrola,gove,glasscock,gillett,galan,featherstone,eckhardt,duron,dunson,dasher,culbreth,cowden,cowans,claypoole,churchwell,chabot,caviness,cater,caston,callan,byington,burkey,boden,beckford,atwater,archambault,alvey,alsup,whisenant,weese,voyles,verret,tsang,tessier,sweitzer,sherwin,shaughnessy,revis,remy,prine,philpott,peavy,paynter,parmenter,ovalle,offutt,nightingale,newlin,nakano,myatt,muth,mohan,mcmillon,mccarley,mccaleb,maxson,marinelli,maley,liston,letendre,kain,huntsman,hirst,hagerty,gulledge,greenway,grajeda,gorton,goines,gittens,frederickson,fanelli,embree,eichelberger,dunkin,dixson,dillow,defelice,chumley,burleigh,borkowski,binette,biggerstaff,berglund,beller,audet,arbuckle,allain,alfano,youngman,wittman,weintraub,vanzant,vaden,twitty,stollings,standifer,sines,shope,scalise,saville,posada,pisano,otte,nolasco,mier,merkle,mendiola,melcher,mejias,mcmurry,mccalla,markowitz,manis,mallette,macfarlane,lough,looper,landin,kittle,kinsella,kinnard,hobart,helman,hellman,hartsock,halford,hage,gordan,glasser,gayton,gattis,gastelum,gaspard,frisch,fitzhugh,eckstein,eberly,dowden,despain,crumpler,crotty,cornelison,chouinard,chamness,catlin,cann,bumgardner,budde,branum,bradfield,braddy,borst,birdwell,bazan,banas,bade,arango,ahearn,addis,zumwalt,wurth,wilk,widener,wagstaff,urrutia,terwilliger,tart,steinman,staats,sloat,rives,riggle,revels,reichard,prickett,poff,pitzer,petro,pell,northrup,nicks,moline,mielke,maynor,mallon,magness,lingle,lindell,lieb,lesko,lebeau,lammers,lafond,kiernan,ketron,jurado,holmgren,hilburn,hayashi,hashimoto,harbaugh,guillot,gard,froehlich,feinberg,falco,dufour,drees,doney,diep,delao,daves,dail,crowson,coss,congdon,carner,camarena,butterworth,burlingame,bouffard,bloch,bilyeu,barta,bakke,baillargeon,avent,aquilar,zeringue,yarber,wolfson,vogler,voelker,truss,troxell,thrift,strouse,spielman,sistrunk,sevigny,schuller,schaaf,ruffner,routh,roseman,ricciardi,peraza,pegram,overturf,olander,odaniel,millner,melchor,maroney,machuca,macaluso,livesay,layfield,laskowski,kwiatkowski,kilby,hovey,heywood,hayman,havard,harville,haigh,hagood,grieco,glassman,gebhardt,fleischer,fann,elson,eccles,cunha,crumb,blakley,bardwell,abshire,woodham,wines,welter,wargo,varnado,tutt,traynor,swaney,stricker,stoffel,stambaugh,sickler,shackleford,selman,seaver,sansom,sanmiguel,royston,rourke,rockett,rioux,puleo,pitchford,nardi,mulvaney,middaugh,malek,leos,lathan,kujawa,kimbro,killebrew,houlihan,hinckley,herod,hepler,hamner,hammel,hallowell,gonsalez,gingerich,gambill,funkhouser,fricke,fewell,falkner,endsley,dulin,drennen,deaver,dambrosio,chadwell,castanon,burkes,brune,brisco,brinker,bowker,boldt,berner,beaumont,beaird,bazemore,barrick,albano,younts,wunderlich,weidman,vanness,toland,theobald,stickler,steiger,stanger,spies,spector,sollars,smedley,seibel,scoville,saito,rummel,rowles,rouleau,roos,rogan,roemer,ream,raya,purkey,priester,perreira,penick,paulin,parkins,overcash,oleson,neves,muldrow,minard,midgett,michalak,melgar,mcentire,mcauliffe,marte,lydon,lindholm,leyba,langevin,lagasse,lafayette,kesler,kelton,kaminsky,jaggers,humbert,huck,howarth,hinrichs,higley,gupton,guimond,gravois,giguere,fretwell,fontes,feeley,faucher,eichhorn,ecker,earp,dole,dinger,derryberry,demars,deel,copenhaver,collinsworth,colangelo,cloyd,claiborne,caulfield,carlsen,calzada,caffey,broadus,brenneman,bouie,bodnar,blaney,blanc,beltz,behling,barahona,yockey,winkle,windom,wimer,villatoro,trexler,teran,taliaferro,sydnor,swinson,snelling,smtih,simonton,simoneaux,simoneau,sherrer,seavey,scheel,rushton,rupe,ruano,rippy,reiner,reiff,rabinowitz,quach,penley,odle,nock,minnich,mckown,mccarver,mcandrew,longley,laux,lamothe,lafreniere,kropp,krick,kates,jepson,huie,howse,howie,henriques,haydon,haught,hatter,hartzog,harkey,grimaldo,goshorn,gormley,gluck,gilroy,gillenwater,giffin,fluker,feder,eyre,eshelman,eakins,detwiler,delrosario,davisson,catalan,canning,calton,brammer,botelho,blakney,bartell,averett,askins,aker,witmer,winkelman,widmer,whittier,weitzel,wardell,wagers,ullman,tupper,tingley,tilghman,talton,simard,seda,scheller,sala,rundell,rost,ribeiro,rabideau,primm,pinon,peart,ostrom,ober,nystrom,nussbaum,naughton,murr,moorhead,monti,monteiro,melson,meissner,mclin,mcgruder,marotta,makowski,majewski,madewell,lunt,lukens,leininger,lebel,lakin,kepler,jaques,hunnicutt,hungerford,hoopes,hertz,heins,halliburton,grosso,gravitt,glasper,gallman,gallaway,funke,fulbright,falgout,eakin,dostie,dorado,dewberry,derose,cutshall,crampton,costanzo,colletti,cloninger,claytor,chiang,campagna,burd,brokaw,broaddus,bretz,brainard,binford,bilbrey,alpert,aitken,ahlers,zajac,woolfolk,witten,windle,wayland,tramel,tittle,talavera,suter,straley,specht,sommerville,soloman,skeens,sigman,sibert,shavers,schuck,schmit,sartain,sabol,rosenblatt,rollo,rashid,rabb,polston,nyberg,northrop,navarra,muldoon,mikesell,mcdougald,mcburney,mariscal,lozier,lingerfelt,legere,latour,lagunas,lacour,kurth,killen,kiely,kayser,kahle,isley,huertas,hower,hinz,haugh,gumm,galicia,fortunato,flake,dunleavy,duggins,doby,digiovanni,devaney,deltoro,cribb,corpuz,coronel,coen,charbonneau,caine,burchette,blakey,blakemore,bergquist,beene,beaudette,bayles,ballance,bakker,bailes,asberry,arwood,zucker,willman,whitesell,wald,walcott,vancleave,trump,strasser,simas,shick,schleicher,schaal,saleh,rotz,resnick,rainer,partee,ollis,oller,oday,noles,munday,mong,millican,merwin,mazzola,mansell,magallanes,llanes,lewellen,lepore,kisner,keesee,jeanlouis,ingham,hornbeck,hawn,hartz,harber,haffner,gutshall,guth,grays,gowan,finlay,finkelstein,eyler,enloe,dungan,diez,dearman,cull,crosson,chronister,cassity,campion,callihan,butz,breazeale,blumenthal,berkey,batty,batton,arvizu,alderete,aldana,albaugh,abernethy,wolter,wille,tweed,tollefson,thomasson,teter,testerman,sproul,spates,southwick,soukup,skelly,senter,sealey,sawicki,sargeant,rossiter,rosemond,repp,pifer,ormsby,nickelson,naumann,morabito,monzon,millsaps,millen,mcelrath,marcoux,mantooth,madson,macneil,mackinnon,louque,leister,lampley,kushner,krouse,kirwan,jessee,janson,jahn,jacquez,islas,hutt,holladay,hillyer,hepburn,hensel,harrold,gingrich,geis,gales,fults,finnell,ferri,featherston,epley,ebersole,eames,dunigan,drye,dismuke,devaughn,delorenzo,damiano,confer,collum,clower,clow,claussen,clack,caylor,cawthon,casias,carreno,bluhm,bingaman,bewley,belew,beckner,auld,amey,wolfenbarger,wilkey,wicklund,waltman,villalba,valero,valdovinos,ullrich,tyus,twyman,trost,tardif,tanguay,stripling,steinbach,shumpert,sasaki,sappington,sandusky,reinhold,reinert,quijano,placencia,pinkard,phinney,perrotta,pernell,parrett,oxendine,owensby,orman,nuno,mori,mcroberts,mcneese,mckamey,mccullum,markel,mardis,maines,lueck,lubin,lefler,leffler,larios,labarbera,kershner,josey,jeanbaptiste,izaguirre,hermosillo,haviland,hartshorn,hafner,ginter,getty,franck,fiske,dufrene,doody,davie,dangerfield,dahlberg,cuthbertson,crone,coffelt,chidester,chesson,cauley,caudell,cantara,campo,caines,bullis,bucci,brochu,bogard,bickerstaff,benning,arzola,antonelli,adkinson,zellers,wulf,worsley,woolridge,whitton,westerfield,walczak,vassar,truett,trueblood,trawick,townsley,topping,tobar,telford,steverson,stagg,sitton,sill,sergent,schoenfeld,sarabia,rutkowski,rubenstein,rigdon,prentiss,pomerleau,plumlee,philbrick,patnode,oloughlin,obregon,nuss,morell,mikell,mele,mcinerney,mcguigan,mcbrayer,lollar,kuehl,kinzer,kamp,joplin,jacobi,howells,holstein,hedden,hassler,harty,halle,greig,gouge,goodrum,gerhart,geier,geddes,gast,forehand,ferree,fendley,feltner,esqueda,encarnacion,eichler,egger,edmundson,eatmon,doud,donohoe,donelson,dilorenzo,digiacomo,diggins,delozier,dejong,danford,crippen,coppage,cogswell,clardy,cioffi,cabe,brunette,bresnahan,blomquist,blackstone,biller,bevis,bevan,bethune,benbow,baty,basinger,balcom,andes,aman,aguero,adkisson,yandell,wilds,whisenhunt,weigand,weeden,voight,villar,trottier,tillett,suazo,setser,scurry,schuh,schreck,schauer,samora,roane,rinker,reimers,ratchford,popovich,parkin,natal,melville,mcbryde,magdaleno,loehr,lockman,lingo,leduc,larocca,lamere,laclair,krall,korte,koger,jalbert,hughs,higbee,henton,heaney,haith,gump,greeson,goodloe,gholston,gasper,gagliardi,fregoso,farthing,fabrizio,ensor,elswick,elgin,eklund,eaddy,drouin,dorton,dizon,derouen,deherrera,davy,dampier,cullum,culley,cowgill,cardoso,cardinale,brodsky,broadbent,brimmer,briceno,branscum,bolyard,boley,bennington,beadle,baur,ballentine,azure,aultman,arciniega,aguila,aceves,yepez,woodrum,wethington,weissman,veloz,trusty,troup,trammel,tarpley,stivers,steck,sprayberry,spraggins,spitler,spiers,sohn,seagraves,schiffman,rudnick,rizo,riccio,rennie,quackenbush,puma,plott,pearcy,parada,paiz,munford,moskowitz,mease,mcnary,mccusker,lozoya,longmire,loesch,lasky,kuhlmann,krieg,koziol,kowalewski,konrad,kindle,jowers,jolin,jaco,horgan,hine,hileman,hepner,heise,heady,hawkinson,hannigan,haberman,guilford,grimaldi,garton,gagliano,fruge,follett,fiscus,ferretti,ebner,easterday,eanes,dirks,dimarco,depalma,deforest,cruce,craighead,christner,candler,cadwell,burchell,buettner,brinton,brazier,brannen,brame,bova,bomar,blakeslee,belknap,bangs,balzer,athey,armes,alvis,alverson,alvardo,yeung,wheelock,westlund,wessels,volkman,threadgill,thelen,tague,symons,swinford,sturtevant,straka,stier,stagner,segarra,seawright,rutan,roux,ringler,riker,ramsdell,quattlebaum,purifoy,poulson,permenter,peloquin,pasley,pagel,osman,obannon,nygaard,newcomer,munos,motta,meadors,mcquiston,mcniel,mcmann,mccrae,mayne,matte,legault,lechner,kucera,krohn,kratzer,koopman,jeske,horrocks,hock,hibbler,hesson,hersh,harvin,halvorsen,griner,grindle,gladstone,garofalo,frampton,forbis,eddington,diorio,dingus,dewar,desalvo,curcio,creasy,cortese,cordoba,connally,cluff,cascio,capuano,canaday,calabro,bussard,brayton,borja,bigley,arnone,arguelles,acuff,zamarripa,wooton,widner,wideman,threatt,thiele,templin,teeters,synder,swint,swick,sturges,stogner,stedman,spratt,siegfried,shetler,scull,savino,sather,rothwell,rook,rone,rhee,quevedo,privett,pouliot,poche,pickel,petrillo,pellegrini,peaslee,partlow,otey,nunnery,morelock,morello,meunier,messinger,mckie,mccubbin,mccarron,lerch,lavine,laverty,lariviere,lamkin,kugler,krol,kissel,keeter,hubble,hickox,hetzel,hayner,hagy,hadlock,groh,gottschalk,goodsell,gassaway,garrard,galligan,firth,fenderson,feinstein,etienne,engleman,emrick,ellender,drews,doiron,degraw,deegan,dart,crissman,corr,cookson,coil,cleaves,charest,chapple,chaparro,castano,carpio,byer,bufford,bridgewater,bridgers,brandes,borrero,bonanno,aube,ancheta,abarca,abad,wooster,wimbush,willhite,willams,wigley,weisberg,wardlaw,vigue,vanhook,unknow,torre,tasker,tarbox,strachan,slover,shamblin,semple,schuyler,schrimsher,sayer,salzman,rubalcava,riles,reneau,reichel,rayfield,rabon,pyatt,prindle,poss,polito,plemmons,pesce,perrault,pereyra,ostrowski,nilsen,niemeyer,munsey,mundell,moncada,miceli,meader,mcmasters,mckeehan,matsumoto,marron,marden,lizarraga,lingenfelter,lewallen,langan,lamanna,kovac,kinsler,kephart,keown,kass,kammerer,jeffreys,hysell,hosmer,hardnett,hanner,guyette,greening,glazer,ginder,fromm,fluellen,finkle,fessler,essary,eisele,duren,dittmer,crochet,cosentino,cogan,coelho,cavin,carrizales,campuzano,brough,bopp,bookman,bobb,blouin,beesley,battista,bascom,bakken,badgett,arneson,anselmo,albino,ahumada,woodyard,wolters,wireman,willison,warman,waldrup,vowell,vantassel,twombly,toomer,tennison,teets,tedeschi,swanner,stutz,stelly,sheehy,schermerhorn,scala,sandidge,salters,salo,saechao,roseboro,rolle,ressler,renz,renn,redford,raposa,rainbolt,pelfrey,orndorff,oney,nolin,nimmons,nardone,myhre,morman,menjivar,mcglone,mccammon,maxon,marciano,manus,lowrance,lorenzen,lonergan,lollis,littles,lindahl,lamas,lach,kuster,krawczyk,knuth,knecht,kirkendall,keitt,keever,kantor,jarboe,hoye,houchens,holter,holsinger,hickok,helwig,helgeson,hassett,harner,hamman,hames,hadfield,goree,goldfarb,gaughan,gaudreau,gantz,gallion,frady,foti,flesher,ferrin,faught,engram,donegan,desouza,degroot,cutright,crowl,criner,coan,clinkscales,chewning,chavira,catchings,carlock,bulger,buenrostro,bramblett,brack,boulware,bookout,bitner,birt,baranowski,baisden,allmon,acklin,yoakum,wilbourn,whisler,weinberger,washer,vasques,vanzandt,vanatta,troxler,tomes,tindle,tims,throckmorton,thach,stpeter,stlaurent,stenson,spry,spitz,songer,snavely,shroyer,shortridge,shenk,sevier,seabrook,scrivner,saltzman,rosenberry,rockwood,robeson,roan,reiser,ramires,raber,posner,popham,piotrowski,pinard,peterkin,pelham,peiffer,peay,nadler,musso,millett,mestas,mcgowen,marques,marasco,manriquez,manos,mair,lipps,leiker,krumm,knorr,kinslow,kessel,kendricks,kelm,irick,ickes,hurlburt,horta,hoekstra,heuer,helmuth,heatherly,hampson,hagar,haga,greenlaw,grau,godbey,gingras,gillies,gibb,gayden,gauvin,garrow,fontanez,florio,finke,fasano,ezzell,ewers,eveland,eckenrode,duclos,drumm,dimmick,delancey,defazio,dashiell,cusack,crowther,crigger,cray,coolidge,coldiron,cleland,chalfant,cassel,camire,cabrales,broomfield,brittingham,brisson,brickey,braziel,brazell,bragdon,boulanger,boman,bohannan,beem,barre,azar,ashbaugh,armistead,almazan,adamski,zendejas,winburn,willaims,wilhoit,westberry,wentzel,wendling,visser,vanscoy,vankirk,vallee,tweedy,thornberry,sweeny,spradling,spano,smelser,shim,sechrist,schall,scaife,rugg,rothrock,roesler,riehl,ridings,render,ransdell,radke,pinero,petree,pendergast,peluso,pecoraro,pascoe,panek,oshiro,navarrette,murguia,moores,moberg,michaelis,mcwhirter,mcsweeney,mcquade,mccay,mauk,mariani,marceau,mandeville,maeda,lunde,ludlow,loeb,lindo,linderman,leveille,leith,larock,lambrecht,kulp,kinsley,kimberlin,kesterson,hoyos,helfrich,hanke,grisby,goyette,gouveia,glazier,gile,gerena,gelinas,gasaway,funches,fujimoto,flynt,fenske,fellers,fehr,eslinger,escalera,enciso,duley,dittman,dineen,diller,devault,collings,clymer,clowers,chavers,charland,castorena,castello,camargo,bunce,bullen,boyes,borchers,borchardt,birnbaum,birdsall,billman,benites,bankhead,ange,ammerman,adkison,winegar,wickman,warr,warnke,villeneuve,veasey,vassallo,vannatta,vadnais,twilley,towery,tomblin,tippett,theiss,talkington,talamantes,swart,swanger,streit,stines,stabler,spurling,sobel,sine,simmers,shippy,shiflett,shearin,sauter,sanderlin,rusch,runkle,ruckman,rorie,roesch,richert,rehm,randel,ragin,quesenberry,puentes,plyler,plotkin,paugh,oshaughnessy,ohalloran,norsworthy,niemann,nader,moorefield,mooneyham,modica,miyamoto,mickel,mebane,mckinnie,mazurek,mancilla,lukas,lovins,loughlin,lotz,lindsley,liddle,levan,lederman,leclaire,lasseter,lapoint,lamoreaux,lafollette,kubiak,kirtley,keffer,kaczmarek,housman,hiers,hibbert,herrod,hegarty,hathorn,greenhaw,grafton,govea,futch,furst,franko,forcier,foran,flickinger,fairfield,eure,emrich,embrey,edgington,ecklund,eckard,durante,deyo,delvecchio,dade,currey,creswell,cottrill,casavant,cartier,cargile,capel,cammack,calfee,burse,burruss,brust,brousseau,bridwell,braaten,borkholder,bloomquist,bjork,bartelt,amburgey,yeary,whitefield,vinyard,vanvalkenburg,twitchell,timmins,tapper,stringham,starcher,spotts,slaugh,simonsen,sheffer,sequeira,rosati,rhymes,quint,pollak,peirce,patillo,parkerson,paiva,nilson,nevin,narcisse,mitton,merriam,merced,meiners,mckain,mcelveen,mcbeth,marsden,marez,manke,mahurin,mabrey,luper,krull,hunsicker,hornbuckle,holtzclaw,hinnant,heston,hering,hemenway,hegwood,hearns,halterman,guiterrez,grote,granillo,grainger,glasco,gilder,garren,garlock,garey,fryar,fredricks,fraizer,foshee,ferrel,felty,everitt,evens,esser,elkin,eberhart,durso,duguay,driskill,doster,dewall,deveau,demps,demaio,delreal,deleo,darrah,cumberbatch,culberson,cranmer,cordle,colgan,chesley,cavallo,castellon,castelli,carreras,carnell,carlucci,bontrager,blumberg,blasingame,becton,artrip,andujar,alkire,alder,zukowski,zuckerman,wroblewski,wrigley,woodside,wigginton,westman,westgate,werts,washam,wardlow,walser,waiters,tadlock,stringfield,stimpson,stickley,standish,spurlin,spindler,speller,spaeth,sotomayor,sluder,shryock,shepardson,shatley,scannell,santistevan,rosner,resto,reinhard,rathburn,prisco,poulsen,pinney,phares,pennock,pastrana,oviedo,ostler,nauman,mulford,moise,moberly,mirabal,metoyer,metheny,mentzer,meldrum,mcinturff,mcelyea,mcdougle,massaro,lumpkins,loveday,lofgren,lirette,lesperance,lefkowitz,ledger,lauzon,lachapelle,klassen,keough,kempton,kaelin,jeffords,hsieh,hoyer,horwitz,hoeft,hennig,haskin,gourdine,golightly,girouard,fulgham,fritsch,freer,frasher,foulk,firestone,fiorentino,fedor,ensley,englehart,eells,dunphy,donahoe,dileo,dibenedetto,dabrowski,crick,coonrod,conder,coddington,chunn,chaput,cerna,carreiro,calahan,braggs,bourdon,bollman,bittle,bauder,barreras,aubuchon,anzalone,adamo,zerbe,willcox,westberg,weikel,waymire,vroman,vinci,vallejos,truesdell,troutt,trotta,tollison,toles,tichenor,symonds,surles,strayer,stgeorge,sroka,sorrentino,solares,snelson,silvestri,sikorski,shawver,schumaker,schorr,schooley,scates,satterlee,satchell,rymer,roselli,robitaille,riegel,regis,reames,provenzano,priestley,plaisance,pettey,palomares,nowakowski,monette,minyard,mclamb,mchone,mccarroll,masson,magoon,maddy,lundin,licata,leonhardt,landwehr,kircher,kinch,karpinski,johannsen,hussain,houghtaling,hoskinson,hollaway,holeman,hobgood,hiebert,goggin,geissler,gadbois,gabaldon,fleshman,flannigan,fairman,eilers,dycus,dunmire,duffield,dowler,deloatch,dehaan,deemer,clayborn,christofferso,chilson,chesney,chatfield,carron,canale,brigman,branstetter,bosse,borton,bonar,biron,barroso,arispe,zacharias,zabel,yaeger,woolford,whetzel,weakley,veatch,vandeusen,tufts,troxel,troche,traver,townsel,talarico,swilley,sterrett,stenger,speakman,sowards,sours,souders,souder,soles,sobers,snoddy,smither,shute,shoaf,shahan,schuetz,scaggs,santini,rosson,rolen,robidoux,rentas,recio,pixley,pawlowski,pawlak,paull,overbey,orear,oliveri,oldenburg,nutting,naugle,mossman,misner,milazzo,michelson,mcentee,mccullar,mccree,mcaleer,mazzone,mandell,manahan,malott,maisonet,mailloux,lumley,lowrie,louviere,lipinski,lindemann,leppert,leasure,labarge,kubik,knisely,knepp,kenworthy,kennelly,kelch,kanter,houchin,hosley,hosler,hollon,holleman,heitman,haggins,gwaltney,goulding,gorden,geraci,gathers,frison,feagin,falconer,espada,erving,erikson,eisenhauer,ebeling,durgin,dowdle,dinwiddie,delcastillo,dedrick,crimmins,covell,cournoyer,coria,cohan,cataldo,carpentier,canas,campa,brode,brashears,blaser,bicknell,bednar,barwick,ascencio,althoff,almodovar,alamo,zirkle,zabala,wolverton,winebrenner,wetherell,westlake,wegener,weddington,tuten,trosclair,tressler,theroux,teske,swinehart,swensen,sundquist,southall,socha,sizer,silverberg,shortt,shimizu,sherrard,shaeffer,scheid,scheetz,saravia,sanner,rubinstein,rozell,romer,rheaume,reisinger,randles,pullum,petrella,payan,nordin,norcross,nicoletti,nicholes,newbold,nakagawa,monteith,milstead,milliner,mellen,mccardle,liptak,leitch,latimore,larrison,landau,laborde,koval,izquierdo,hymel,hoskin,holte,hoefer,hayworth,hausman,harrill,harrel,hardt,gully,groover,grinnell,greenspan,graver,grandberry,gorrell,goldenberg,goguen,gilleland,fuson,feldmann,everly,dyess,dunnigan,downie,dolby,deatherage,cosey,cheever,celaya,caver,cashion,caplinger,cansler,byrge,bruder,breuer,breslin,brazelton,botkin,bonneau,bondurant,bohanan,bogue,bodner,boatner,blatt,bickley,belliveau,beiler,beier,beckstead,bachmann,atkin,altizer,alloway,allaire,albro,abron,zellmer,yetter,yelverton,wiens,whidden,viramontes,vanwormer,tarantino,tanksley,sumlin,strauch,strang,stice,spahn,sosebee,sigala,shrout,seamon,schrum,schneck,schantz,ruddy,romig,roehl,renninger,reding,polak,pohlman,pasillas,oldfield,oldaker,ohanlon,ogilvie,norberg,nolette,neufeld,nellis,mummert,mulvihill,mullaney,monteleone,mendonca,meisner,mcmullan,mccluney,mattis,massengill,manfredi,luedtke,lounsbury,liberatore,lamphere,laforge,jourdan,iorio,iniguez,ikeda,hubler,hodgdon,hocking,heacock,haslam,haralson,hanshaw,hannum,hallam,haden,garnes,garces,gammage,gambino,finkel,faucett,ehrhardt,eggen,dusek,durrant,dubay,dones,depasquale,delucia,degraff,decamp,davalos,cullins,conard,clouser,clontz,cifuentes,chappel,chaffins,celis,carwile,byram,bruggeman,bressler,brathwaite,brasfield,bradburn,boose,bodie,blosser,bertsch,bernardi,bernabe,bengtson,barrette,astorga,alday,albee,abrahamson,yarnell,wiltse,wiebe,waguespack,vasser,upham,turek,traxler,torain,tomaszewski,tinnin,tiner,tindell,styron,stahlman,staab,skiba,sheperd,seidl,secor,schutte,sanfilippo,ruder,rondon,rearick,procter,prochaska,pettengill,pauly,neilsen,nally,mullenax,morano,meads,mcnaughton,mcmurtry,mcmath,mckinsey,matthes,massenburg,marlar,margolis,malin,magallon,mackin,lovette,loughran,loring,longstreet,loiselle,lenihan,kunze,koepke,kerwin,kalinowski,kagan,innis,innes,holtzman,heinemann,harshman,haider,haack,grondin,grissett,greenawalt,goudy,goodlett,goldston,gokey,gardea,galaviz,gafford,gabrielson,furlow,fritch,fordyce,folger,elizalde,ehlert,eckhoff,eccleston,ealey,dubin,diemer,deschamps,delapena,decicco,debolt,cullinan,crittendon,crase,cossey,coppock,coots,colyer,cluck,chamberland,burkhead,bumpus,buchan,borman,birkholz,berardi,benda,behnke,barter,amezquita,wotring,wirtz,wingert,wiesner,whitesides,weyant,wainscott,venezia,varnell,tussey,thurlow,tabares,stiver,stell,starke,stanhope,stanek,sisler,sinnott,siciliano,shehan,selph,seager,scurlock,scranton,santucci,santangelo,saltsman,rogge,rettig,renwick,reidy,reider,redfield,premo,parente,paolucci,palmquist,ohler,netherton,mutchler,morita,mistretta,minnis,middendorf,menzel,mendosa,mendelson,meaux,mcspadden,mcquaid,mcnatt,manigault,maney,mager,lukes,lopresti,liriano,letson,lechuga,lazenby,lauria,larimore,krupp,krupa,kopec,kinchen,kifer,kerney,kerner,kennison,kegley,karcher,justis,johson,jellison,janke,huskins,holzman,hinojos,hefley,hatmaker,harte,halloway,hallenbeck,goodwyn,glaspie,geise,fullwood,fryman,frakes,fraire,farrer,enlow,engen,ellzey,eckles,earles,dunkley,drinkard,dreiling,draeger,dinardo,dills,desroches,desantiago,curlee,crumbley,critchlow,coury,courtright,coffield,cleek,charpentier,cardone,caples,cantin,buntin,bugbee,brinkerhoff,brackin,bourland,blassingame,beacham,banning,auguste,andreasen,amann,almon,alejo,adelman,abston,yerger,wymer,woodberry,windley,whiteaker,westfield,weibel,wanner,waldrep,villani,vanarsdale,utterback,updike,triggs,topete,tolar,tigner,thoms,tauber,tarvin,tally,swiney,sweatman,studebaker,stennett,starrett,stannard,stalvey,sonnenberg,smithey,sieber,sickles,shinault,segars,sanger,salmeron,rothe,rizzi,restrepo,ralls,ragusa,quiroga,papenfuss,oropeza,okane,mudge,mozingo,molinaro,mcvicker,mcgarvey,mcfalls,mccraney,matus,magers,llanos,livermore,linehan,leitner,laymon,lawing,lacourse,kwong,kollar,kneeland,kennett,kellett,kangas,janzen,hutter,huling,hofmeister,hewes,harjo,habib,guice,grullon,greggs,grayer,granier,grable,gowdy,giannini,getchell,gartman,garnica,ganey,gallimore,fetters,fergerson,farlow,fagundes,exley,esteves,enders,edenfield,easterwood,drakeford,dipasquale,desousa,deshields,deeter,dedmon,debord,daughtery,cutts,courtemanche,coursey,copple,coomes,collis,cogburn,clopton,choquette,chaidez,castrejon,calhoon,burbach,bulloch,buchman,bruhn,bohon,blough,baynes,barstow,zeman,zackery,yardley,yamashita,wulff,wilken,wiliams,wickersham,wible,whipkey,wedgeworth,walmsley,walkup,vreeland,verrill,umana,traub,swingle,summey,stroupe,stockstill,steffey,stefanski,statler,stapp,speights,solari,soderberg,shunk,shorey,shewmaker,sheilds,schiffer,schank,schaff,sagers,rochon,riser,rickett,reale,raglin,polen,plata,pitcock,percival,palen,orona,oberle,nocera,navas,nault,mullings,montejano,monreal,minick,middlebrook,meece,mcmillion,mccullen,mauck,marshburn,maillet,mahaney,magner,maclin,lucey,litteral,lippincott,leite,leaks,lamarre,jurgens,jerkins,jager,hurwitz,hughley,hotaling,horstman,hohman,hocker,hively,hipps,hessler,hermanson,hepworth,helland,hedlund,harkless,haigler,gutierez,grindstaff,glantz,giardina,gerken,gadsden,finnerty,farnum,encinas,drakes,dennie,cutlip,curtsinger,couto,cortinas,corby,chiasson,carle,carballo,brindle,borum,bober,blagg,berthiaume,beahm,batres,basnight,backes,axtell,atterberry,alvares,alegria,woodell,wojciechowski,winfree,winbush,wiest,wesner,wamsley,wakeman,verner,truex,trafton,toman,thorsen,theus,tellier,tallant,szeto,strope,stills,simkins,shuey,shaul,servin,serio,serafin,salguero,ryerson,rudder,ruark,rother,rohrbaugh,rohrbach,rohan,rogerson,risher,reeser,pryce,prokop,prins,priebe,prejean,pinheiro,petrone,petri,penson,pearlman,parikh,natoli,murakami,mullikin,mullane,motes,morningstar,mcveigh,mcgrady,mcgaughey,mccurley,marchan,manske,lusby,linde,likens,licon,leroux,lemaire,legette,laskey,laprade,laplant,kolar,kittredge,kinley,kerber,kanagy,jetton,janik,ippolito,inouye,hunsinger,howley,howery,horrell,holthaus,hiner,hilson,hilderbrand,hartzler,harnish,harada,hansford,halligan,hagedorn,gwynn,gudino,greenstein,greear,gracey,goudeau,goodner,ginsburg,gerth,gerner,fujii,frier,frenette,folmar,fleisher,fleischmann,fetzer,eisenman,earhart,dupuy,dunkelberger,drexler,dillinger,dilbeck,dewald,demby,deford,craine,chesnut,casady,carstens,carrick,carino,carignan,canchola,bushong,burman,buono,brownlow,broach,britten,brickhouse,boyden,boulton,borland,bohrer,blubaugh,bever,berggren,benevides,arocho,arends,amezcua,almendarez,zalewski,witzel,winkfield,wilhoite,vangundy,vanfleet,vanetten,vandergriff,urbanski,troiano,thibodaux,straus,stoneking,stjean,stillings,stange,speicher,speegle,smeltzer,slawson,simmonds,shuttleworth,serpa,senger,seidman,schweiger,schloss,schimmel,schechter,sayler,sabatini,ronan,rodiguez,riggleman,richins,reamer,prunty,porath,plunk,piland,philbrook,pettitt,perna,peralez,pascale,padula,oboyle,nivens,nickols,mundt,munden,montijo,mcmanis,mcgrane,mccrimmon,manzi,mangold,malick,mahar,maddock,losey,litten,leedy,leavell,ladue,krahn,kluge,junker,iversen,imler,hurtt,huizar,hubbert,howington,hollomon,holdren,hoisington,heiden,hauge,hartigan,gutirrez,griffie,greenhill,gratton,granata,gottfried,gertz,gautreaux,furry,furey,funderburg,flippen,fitzgibbon,drucker,donoghue,dildy,devers,detweiler,despres,denby,degeorge,cueto,cranston,courville,clukey,cirillo,chivers,caudillo,butera,bulluck,buckmaster,braunstein,bracamonte,bourdeau,bonnette".split(","),
    us_tv_and_film: "you,i,to,that,it,me,what,this,know,i'm,no,have,my,don't,just,not,do,be,your,we,it's,so,but,all,well,oh,about,right,you're,get,here,out,going,like,yeah,if,can,up,want,think,that's,now,go,him,how,got,did,why,see,come,good,really,look,will,okay,back,can't,mean,tell,i'll,hey,he's,could,didn't,yes,something,because,say,take,way,little,make,need,gonna,never,we're,too,she's,i've,sure,our,sorry,what's,let,thing,maybe,down,man,very,there's,should,anything,said,much,any,even,off,please,doing,thank,give,thought,help,talk,god,still,wait,find,nothing,again,things,let's,doesn't,call,told,great,better,ever,night,away,believe,feel,everything,you've,fine,last,keep,does,put,around,stop,they're,i'd,guy,isn't,always,listen,wanted,guys,huh,those,big,lot,happened,thanks,won't,trying,kind,wrong,talking,guess,care,bad,mom,remember,getting,we'll,together,dad,leave,understand,wouldn't,actually,hear,baby,nice,father,else,stay,done,wasn't,course,might,mind,every,enough,try,hell,came,someone,you'll,whole,yourself,idea,ask,must,coming,looking,woman,room,knew,tonight,real,son,hope,went,hmm,happy,pretty,saw,girl,sir,friend,already,saying,next,job,problem,minute,thinking,haven't,heard,honey,matter,myself,couldn't,exactly,having,probably,happen,we've,hurt,boy,dead,gotta,alone,excuse,start,kill,hard,you'd,today,car,ready,without,wants,hold,wanna,yet,seen,deal,once,gone,morning,supposed,friends,head,stuff,worry,live,truth,face,forget,true,cause,soon,knows,telling,wife,who's,chance,run,move,anyone,person,bye,somebody,heart,miss,making,meet,anyway,phone,reason,damn,lost,looks,bring,case,turn,wish,tomorrow,kids,trust,check,change,anymore,least,aren't,working,makes,taking,means,brother,hate,ago,says,beautiful,gave,fact,crazy,sit,afraid,important,rest,fun,kid,word,watch,glad,everyone,sister,minutes,everybody,bit,couple,whoa,either,mrs,feeling,daughter,wow,gets,asked,break,promise,door,close,hand,easy,question,tried,far,walk,needs,mine,killed,hospital,anybody,alright,wedding,shut,able,die,perfect,stand,comes,hit,waiting,dinner,funny,husband,almost,pay,answer,cool,eyes,news,child,shouldn't,yours,moment,sleep,read,where's,sounds,sonny,pick,sometimes,bed,date,plan,hours,lose,hands,serious,shit,behind,inside,ahead,week,wonderful,fight,past,cut,quite,he'll,sick,it'll,eat,nobody,goes,save,seems,finally,lives,worried,upset,carly,met,brought,seem,sort,safe,weren't,leaving,front,shot,loved,asking,running,clear,figure,hot,felt,parents,drink,absolutely,how's,daddy,sweet,alive,sense,meant,happens,bet,blood,ain't,kidding,lie,meeting,dear,seeing,sound,fault,ten,buy,hour,speak,lady,jen,thinks,christmas,outside,hang,possible,worse,mistake,ooh,handle,spend,totally,giving,here's,marriage,realize,unless,sex,send,needed,scared,picture,talked,ass,hundred,changed,completely,explain,certainly,sign,boys,relationship,loves,hair,lying,choice,anywhere,future,weird,luck,she'll,turned,touch,kiss,crane,questions,obviously,wonder,pain,calling,somewhere,throw,straight,cold,fast,words,food,none,drive,feelings,they'll,marry,drop,cannot,dream,protect,twenty,surprise,sweetheart,poor,looked,mad,except,gun,y'know,dance,takes,appreciate,especially,situation,besides,pull,hasn't,worth,sheridan,amazing,expect,swear,piece,busy,happening,movie,we'd,catch,perhaps,step,fall,watching,kept,darling,dog,honor,moving,till,admit,problems,murder,he'd,evil,definitely,feels,honest,eye,broke,missed,longer,dollars,tired,evening,starting,entire,trip,niles,suppose,calm,imagine,fair,caught,blame,sitting,favor,apartment,terrible,clean,learn,frasier,relax,accident,wake,prove,smart,message,missing,forgot,interested,table,nbsp,mouth,pregnant,ring,careful,shall,dude,ride,figured,wear,shoot,stick,follow,angry,write,stopped,ran,standing,forgive,jail,wearing,ladies,kinda,lunch,cristian,greenlee,gotten,hoping,phoebe,thousand,ridge,paper,tough,tape,count,boyfriend,proud,agree,birthday,they've,share,offer,hurry,feet,wondering,decision,ones,finish,voice,herself,would've,mess,deserve,evidence,cute,dress,interesting,hotel,enjoy,quiet,concerned,staying,beat,sweetie,mention,clothes,fell,neither,mmm,fix,respect,prison,attention,holding,calls,surprised,bar,keeping,gift,hadn't,putting,dark,owe,ice,helping,normal,aunt,lawyer,apart,plans,jax,girlfriend,floor,whether,everything's,box,judge,upstairs,sake,mommy,possibly,worst,acting,accept,blow,strange,saved,conversation,plane,mama,yesterday,lied,quick,lately,stuck,difference,store,she'd,bought,doubt,listening,walking,cops,deep,dangerous,buffy,sleeping,chloe,rafe,join,card,crime,gentlemen,willing,window,walked,guilty,likes,fighting,difficult,soul,joke,favorite,uncle,promised,bother,seriously,cell,knowing,broken,advice,somehow,paid,losing,push,helped,killing,boss,liked,innocent,rules,learned,thirty,risk,letting,speaking,ridiculous,afternoon,apologize,nervous,charge,patient,boat,how'd,hide,detective,planning,huge,breakfast,horrible,awful,pleasure,driving,hanging,picked,sell,quit,apparently,dying,notice,congratulations,visit,could've,c'mon,letter,decide,forward,fool,showed,smell,seemed,spell,memory,pictures,slow,seconds,hungry,hearing,kitchen,ma'am,should've,realized,kick,grab,discuss,fifty,reading,idiot,suddenly,agent,destroy,bucks,shoes,peace,arms,demon,livvie,consider,papers,incredible,witch,drunk,attorney,tells,knock,ways,gives,nose,skye,turns,keeps,jealous,drug,sooner,cares,plenty,extra,outta,weekend,matters,gosh,opportunity,impossible,waste,pretend,jump,eating,proof,slept,arrest,breathe,perfectly,warm,pulled,twice,easier,goin,dating,suit,romantic,drugs,comfortable,finds,checked,divorce,begin,ourselves,closer,ruin,smile,laugh,treat,fear,what'd,otherwise,excited,mail,hiding,stole,pacey,noticed,fired,excellent,bringing,bottom,note,sudden,bathroom,honestly,sing,foot,remind,charges,witness,finding,tree,dare,hardly,that'll,steal,silly,contact,teach,shop,plus,colonel,fresh,trial,invited,roll,reach,dirty,choose,emergency,dropped,butt,credit,obvious,locked,loving,nuts,agreed,prue,goodbye,condition,guard,fuckin,grow,cake,mood,crap,crying,belong,partner,trick,pressure,dressed,taste,neck,nurse,raise,lots,carry,whoever,drinking,they'd,breaking,file,lock,wine,spot,paying,assume,asleep,turning,viki,bedroom,shower,nikolas,camera,fill,reasons,forty,bigger,nope,breath,doctors,pants,freak,movies,folks,cream,wild,truly,desk,convince,client,threw,hurts,spending,answers,shirt,chair,rough,doin,sees,ought,empty,wind,aware,dealing,pack,tight,hurting,guest,arrested,salem,confused,surgery,expecting,deacon,unfortunately,goddamn,bottle,beyond,whenever,pool,opinion,starts,jerk,secrets,falling,necessary,barely,dancing,tests,copy,cousin,ahem,twelve,tess,skin,fifteen,speech,orders,complicated,nowhere,escape,biggest,restaurant,grateful,usual,burn,address,someplace,screw,everywhere,regret,goodness,mistakes,details,responsibility,suspect,corner,hero,dumb,terrific,whoo,hole,memories,o'clock,teeth,ruined,bite,stenbeck,liar,showing,cards,desperate,search,pathetic,spoke,scare,marah,afford,settle,stayed,checking,hired,heads,concern,blew,alcazar,champagne,connection,tickets,happiness,saving,kissing,hated,personally,suggest,prepared,onto,downstairs,ticket,it'd,loose,holy,duty,convinced,throwing,kissed,legs,loud,saturday,babies,where'd,warning,miracle,carrying,blind,ugly,shopping,hates,sight,bride,coat,clearly,celebrate,brilliant,wanting,forrester,lips,custody,screwed,buying,toast,thoughts,reality,lexie,attitude,advantage,grandfather,sami,grandma,someday,roof,marrying,powerful,grown,grandmother,fake,must've,ideas,exciting,familiar,bomb,bout,harmony,schedule,capable,practically,correct,clue,forgotten,appointment,deserves,threat,bloody,lonely,shame,jacket,hook,scary,investigation,invite,shooting,lesson,criminal,victim,funeral,considering,burning,strength,harder,sisters,pushed,shock,pushing,heat,chocolate,miserable,corinthos,nightmare,brings,zander,crash,chances,sending,recognize,healthy,boring,feed,engaged,headed,treated,knife,drag,badly,hire,paint,pardon,behavior,closet,warn,gorgeous,milk,survive,ends,dump,rent,remembered,thanksgiving,rain,revenge,prefer,spare,pray,disappeared,aside,statement,sometime,meat,fantastic,breathing,laughing,stood,affair,ours,depends,protecting,jury,brave,fingers,murdered,explanation,picking,blah,stronger,handsome,unbelievable,anytime,shake,oakdale,wherever,pulling,facts,waited,lousy,circumstances,disappointed,weak,trusted,license,nothin,trash,understanding,slip,sounded,awake,friendship,stomach,weapon,threatened,mystery,vegas,understood,basically,switch,frankly,cheap,lifetime,deny,clock,garbage,why'd,tear,ears,indeed,changing,singing,tiny,decent,avoid,messed,filled,touched,disappear,exact,pills,kicked,harm,fortune,pretending,insurance,fancy,drove,cared,belongs,nights,lorelai,lift,timing,guarantee,chest,woke,burned,watched,heading,selfish,drinks,doll,committed,elevator,freeze,noise,wasting,ceremony,uncomfortable,staring,files,bike,stress,permission,thrown,possibility,borrow,fabulous,doors,screaming,bone,xander,what're,meal,apology,anger,honeymoon,bail,parking,fixed,wash,stolen,sensitive,stealing,photo,chose,lets,comfort,worrying,pocket,mateo,bleeding,shoulder,ignore,talent,tied,garage,dies,demons,dumped,witches,rude,crack,bothering,radar,soft,meantime,gimme,kinds,fate,concentrate,throat,prom,messages,intend,ashamed,somethin,manage,guilt,interrupt,guts,tongue,shoe,basement,sentence,purse,glasses,cabin,universe,repeat,mirror,wound,travers,tall,engagement,therapy,emotional,jeez,decisions,soup,thrilled,stake,chef,moves,extremely,moments,expensive,counting,shots,kidnapped,cleaning,shift,plate,impressed,smells,trapped,aidan,knocked,charming,attractive,argue,puts,whip,embarrassed,package,hitting,bust,stairs,alarm,pure,nail,nerve,incredibly,walks,dirt,stamp,terribly,friendly,damned,jobs,suffering,disgusting,stopping,deliver,riding,helps,disaster,bars,crossed,trap,talks,eggs,chick,threatening,spoken,introduce,confession,embarrassing,bags,impression,gate,reputation,presents,chat,suffer,argument,talkin,crowd,homework,coincidence,cancel,pride,solve,hopefully,pounds,pine,mate,illegal,generous,outfit,maid,bath,punch,freaked,begging,recall,enjoying,prepare,wheel,defend,signs,painful,yourselves,maris,that'd,suspicious,cooking,button,warned,sixty,pity,yelling,awhile,confidence,offering,pleased,panic,hers,gettin,refuse,grandpa,testify,choices,cruel,mental,gentleman,coma,cutting,proteus,guests,expert,benefit,faces,jumped,toilet,sneak,halloween,privacy,smoking,reminds,twins,swing,solid,options,commitment,crush,ambulance,wallet,gang,eleven,option,laundry,assure,stays,skip,fail,discussion,clinic,betrayed,sticking,bored,mansion,soda,sheriff,suite,handled,busted,load,happier,studying,romance,procedure,commit,assignment,suicide,minds,swim,yell,llanview,chasing,proper,believes,humor,hopes,lawyers,giant,latest,escaped,parent,tricks,insist,dropping,cheer,medication,flesh,routine,sandwich,handed,false,beating,warrant,awfully,odds,treating,thin,suggesting,fever,sweat,silent,clever,sweater,mall,sharing,assuming,judgment,goodnight,divorced,surely,steps,confess,math,listened,comin,answered,vulnerable,bless,dreaming,chip,zero,pissed,nate,kills,tears,knees,chill,brains,unusual,packed,dreamed,cure,lookin,grave,cheating,breaks,locker,gifts,awkward,thursday,joking,reasonable,dozen,curse,quartermaine,millions,dessert,rolling,detail,alien,delicious,closing,vampires,wore,tail,secure,salad,murderer,spit,offense,dust,conscience,bread,answering,lame,invitation,grief,smiling,pregnancy,prisoner,delivery,guards,virus,shrink,freezing,wreck,massimo,wire,technically,blown,anxious,cave,holidays,cleared,wishes,caring,candles,bound,charm,pulse,jumping,jokes,boom,occasion,silence,nonsense,frightened,slipped,dimera,blowing,relationships,kidnapping,spin,tool,roxy,packing,blaming,wrap,obsessed,fruit,torture,personality,there'll,fairy,necessarily,seventy,print,motel,underwear,grams,exhausted,believing,freaking,carefully,trace,touching,messing,recovery,intention,consequences,belt,sacrifice,courage,enjoyed,attracted,remove,testimony,intense,heal,defending,unfair,relieved,loyal,slowly,buzz,alcohol,surprises,psychiatrist,plain,attic,who'd,uniform,terrified,cleaned,zach,threaten,fella,enemies,satisfied,imagination,hooked,headache,forgetting,counselor,andie,acted,badge,naturally,frozen,sakes,appropriate,trunk,dunno,costume,sixteen,impressive,kicking,junk,grabbed,understands,describe,clients,owns,affect,witnesses,starving,instincts,happily,discussing,deserved,strangers,surveillance,admire,questioning,dragged,barn,deeply,wrapped,wasted,tense,hoped,fellas,roommate,mortal,fascinating,stops,arrangements,agenda,literally,propose,honesty,underneath,sauce,promises,lecture,eighty,torn,shocked,backup,differently,ninety,deck,biological,pheebs,ease,creep,waitress,telephone,ripped,raising,scratch,rings,prints,thee,arguing,ephram,asks,oops,diner,annoying,taggert,sergeant,blast,towel,clown,habit,creature,bermuda,snap,react,paranoid,handling,eaten,therapist,comment,sink,reporter,nurses,beats,priority,interrupting,warehouse,loyalty,inspector,pleasant,excuses,threats,guessing,tend,praying,motive,unconscious,mysterious,unhappy,tone,switched,rappaport,sookie,neighbor,loaded,swore,piss,balance,toss,misery,thief,squeeze,lobby,goa'uld,geez,exercise,forth,booked,sandburg,poker,eighteen,d'you,bury,everyday,digging,creepy,wondered,liver,hmmm,magical,fits,discussed,moral,helpful,searching,flew,depressed,aisle,cris,amen,vows,neighbors,darn,cents,arrange,annulment,useless,adventure,resist,fourteen,celebrating,inch,debt,violent,sand,teal'c,celebration,reminded,phones,paperwork,emotions,stubborn,pound,tension,stroke,steady,overnight,chips,beef,suits,boxes,cassadine,collect,tragedy,spoil,realm,wipe,surgeon,stretch,stepped,nephew,neat,limo,confident,perspective,climb,punishment,finest,springfield,hint,furniture,blanket,twist,proceed,fries,worries,niece,gloves,soap,signature,disappoint,crawl,convicted,flip,counsel,doubts,crimes,accusing,shaking,remembering,hallway,halfway,bothered,madam,gather,cameras,blackmail,symptoms,rope,ordinary,imagined,cigarette,supportive,explosion,trauma,ouch,furious,cheat,avoiding,whew,thick,oooh,boarding,approve,urgent,shhh,misunderstanding,drawer,phony,interfere,catching,bargain,tragic,respond,punish,penthouse,thou,rach,ohhh,insult,bugs,beside,begged,absolute,strictly,socks,senses,sneaking,reward,polite,checks,tale,physically,instructions,fooled,blows,tabby,bitter,adorable,y'all,tested,suggestion,jewelry,alike,jacks,distracted,shelter,lessons,constable,circus,audition,tune,shoulders,mask,helpless,feeding,explains,sucked,robbery,objection,behave,valuable,shadows,courtroom,confusing,talented,smarter,mistaken,customer,bizarre,scaring,motherfucker,alert,vecchio,reverend,foolish,compliment,bastards,worker,wheelchair,protective,gentle,reverse,picnic,knee,cage,wives,wednesday,voices,toes,stink,scares,pour,cheated,slide,ruining,filling,exit,cottage,upside,proves,parked,diary,complaining,confessed,pipe,merely,massage,chop,spill,prayer,betray,waiter,scam,rats,fraud,brush,tables,sympathy,pill,filthy,seventeen,employee,bracelet,pays,fairly,deeper,arrive,tracking,spite,shed,recommend,oughta,nanny,menu,diet,corn,roses,patch,dime,devastated,subtle,bullets,beans,pile,confirm,strings,parade,borrowed,toys,straighten,steak,premonition,planted,honored,exam,convenient,traveling,laying,insisted,dish,aitoro,kindly,grandson,donor,temper,teenager,proven,mothers,denial,backwards,tent,swell,noon,happiest,drives,thinkin,spirits,potion,holes,fence,whatsoever,rehearsal,overheard,lemme,hostage,bench,tryin,taxi,shove,moron,impress,needle,intelligent,instant,disagree,stinks,rianna,recover,groom,gesture,constantly,bartender,suspects,sealed,legally,hears,dresses,sheet,psychic,teenage,knocking,judging,accidentally,waking,rumor,manners,homeless,hollow,desperately,tapes,referring,item,genoa,gear,majesty,cried,tons,spells,instinct,quote,motorcycle,convincing,fashioned,aids,accomplished,grip,bump,upsetting,needing,invisible,forgiveness,feds,compare,bothers,tooth,inviting,earn,compromise,cocktail,tramp,jabot,intimate,dignity,dealt,souls,informed,gods,dressing,cigarettes,alistair,leak,fond,corky,seduce,liquor,fingerprints,enchantment,butters,stuffed,stavros,emotionally,transplant,tips,oxygen,nicely,lunatic,drill,complain,announcement,unfortunate,slap,prayers,plug,opens,oath,o'neill,mutual,yacht,remembers,fried,extraordinary,bait,warton,sworn,stare,safely,reunion,burst,might've,dive,aboard,expose,buddies,trusting,booze,sweep,sore,scudder,properly,parole,ditch,canceled,speaks,glow,wears,thirsty,skull,ringing,dorm,dining,bend,unexpected,pancakes,harsh,flattered,ahhh,troubles,fights,favourite,eats,rage,undercover,spoiled,sloane,shine,destroying,deliberately,conspiracy,thoughtful,sandwiches,plates,nails,miracles,fridge,drank,contrary,beloved,allergic,washed,stalking,solved,sack,misses,forgiven,bent,maciver,involve,dragging,cooked,pointing,foul,dull,beneath,heels,faking,deaf,stunt,jealousy,hopeless,fears,cuts,scenario,necklace,crashed,accuse,restraining,homicide,helicopter,firing,safer,auction,videotape,tore,reservations,pops,appetite,wounds,vanquish,ironic,fathers,excitement,anyhow,tearing,sends,rape,laughed,belly,dealer,cooperate,accomplish,wakes,spotted,sorts,reservation,ashes,tastes,supposedly,loft,intentions,integrity,wished,towels,suspected,investigating,inappropriate,lipstick,lawn,compassion,cafeteria,scarf,precisely,obsession,loses,lighten,infection,granddaughter,explode,balcony,this'll,spying,publicity,depend,cracked,conscious,ally,absurd,vicious,invented,forbid,directions,defendant,bare,announce,screwing,salesman,robbed,leap,lakeview,insanity,reveal,possibilities,kidnap,gown,chairs,wishing,setup,punished,criminals,regrets,raped,quarters,lamp,dentist,anyways,anonymous,semester,risks,owes,lungs,explaining,delicate,tricked,eager,doomed,adoption,stab,sickness,scum,floating,envelope,vault,sorel,pretended,potatoes,plea,photograph,payback,misunderstood,kiddo,healing,cascade,capeside,stabbed,remarkable,brat,privilege,passionate,nerves,lawsuit,kidney,disturbed,cozy,tire,shirts,oven,ordering,delay,risky,monsters,honorable,grounded,closest,breakdown,bald,abandon,scar,collar,worthless,sucking,enormous,disturbing,disturb,distract,deals,conclusions,vodka,dishes,crawling,briefcase,wiped,whistle,sits,roast,rented,pigs,flirting,deposit,bottles,topic,riot,overreacting,logical,hostile,embarrass,casual,beacon,amusing,altar,claus,survival,skirt,shave,porch,ghosts,favors,drops,dizzy,chili,advise,strikes,rehab,photographer,peaceful,leery,heavens,fortunately,fooling,expectations,cigar,weakness,ranch,practicing,examine,cranes,bribe,sail,prescription,hush,fragile,forensics,expense,drugged,cows,bells,visitor,suitcase,sorta,scan,manticore,insecure,imagining,hardest,clerk,wrist,what'll,starters,silk,pump,pale,nicer,haul,flies,boot,thumb,there'd,how're,elders,quietly,pulls,idiots,erase,denying,ankle,amnesia,accepting,heartbeat,devane,confront,minus,legitimate,fixing,arrogant,tuna,supper,slightest,sins,sayin,recipe,pier,paternity,humiliating,genuine,snack,rational,minded,guessed,weddings,tumor,humiliated,aspirin,spray,picks,eyed,drowning,contacts,ritual,perfume,hiring,hating,docks,creatures,visions,thanking,thankful,sock,nineteen,fork,throws,teenagers,stressed,slice,rolls,plead,ladder,kicks,detectives,assured,tellin,shallow,responsibilities,repay,howdy,girlfriends,deadly,comforting,ceiling,verdict,insensitive,spilled,respected,messy,interrupted,halliwell,blond,bleed,wardrobe,takin,murders,backs,underestimate,justify,harmless,frustrated,fold,enzo,communicate,bugging,arson,whack,salary,rumors,obligation,liking,dearest,congratulate,vengeance,rack,puzzle,fires,courtesy,caller,blamed,tops,quiz,prep,curiosity,circles,barbecue,sunnydale,spinning,psychotic,cough,accusations,resent,laughs,freshman,envy,drown,bartlet,asses,sofa,poster,highness,dock,apologies,theirs,stat,stall,realizes,psych,mmmm,fools,understandable,treats,succeed,stir,relaxed,makin,gratitude,faithful,accent,witter,wandering,locate,inevitable,gretel,deed,crushed,controlling,smelled,robe,gossip,gambling,cosmetics,accidents,surprising,stiff,sincere,rushed,refrigerator,preparing,nightmares,mijo,ignoring,hunch,fireworks,drowned,brass,whispering,sophisticated,luggage,hike,explore,emotion,crashing,contacted,complications,shining,rolled,righteous,reconsider,goody,geek,frightening,ethics,creeps,courthouse,camping,affection,smythe,haircut,essay,baked,apologized,vibe,respects,receipt,mami,hats,destructive,adore,adopt,tracked,shorts,reminding,dough,creations,cabot,barrel,snuck,slight,reporters,pressing,magnificent,madame,lazy,glorious,fiancee,bits,visitation,sane,kindness,shoulda,rescued,mattress,lounge,lifted,importantly,glove,enterprises,disappointment,condo,beings,admitting,yelled,waving,spoon,screech,satisfaction,reads,nailed,worm,tick,resting,marvelous,fuss,cortlandt,chased,pockets,luckily,lilith,filing,conversations,consideration,consciousness,worlds,innocence,forehead,aggressive,trailer,slam,quitting,inform,delighted,daylight,danced,confidential,aunts,washing,tossed,spectra,marrow,lined,implying,hatred,grill,corpse,clues,sober,offended,morgue,infected,humanity,distraction,cart,wired,violation,promising,harassment,glue,d'angelo,cursed,brutal,warlocks,wagon,unpleasant,proving,priorities,mustn't,lease,flame,disappearance,depressing,thrill,sitter,ribs,flush,earrings,deadline,corporal,collapsed,update,snapped,smack,melt,figuring,delusional,coulda,burnt,tender,sperm,realise,pork,popped,interrogation,esteem,choosing,undo,pres,prayed,plague,manipulate,insulting,detention,delightful,coffeehouse,betrayal,apologizing,adjust,wrecked,wont,whipped,rides,reminder,monsieur,faint,bake,distress,correctly,complaint,blocked,tortured,risking,pointless,handing,dumping,cups,alibi,struggling,shiny,risked,mummy,mint,hose,hobby,fortunate,fleischman,fitting,curtain,counseling,rode,puppet,modeling,memo,irresponsible,humiliation,hiya,freakin,felony,choke,blackmailing,appreciated,tabloid,suspicion,recovering,pledge,panicked,nursery,louder,jeans,investigator,homecoming,frustrating,buys,busting,buff,sleeve,irony,dope,declare,autopsy,workin,torch,prick,limb,hysterical,goddamnit,fetch,dimension,crowded,clip,climbing,bonding,woah,trusts,negotiate,lethal,iced,fantasies,deeds,bore,babysitter,questioned,outrageous,kiriakis,insulted,grudge,driveway,deserted,definite,beep,wires,suggestions,searched,owed,lend,drunken,demanding,costanza,conviction,bumped,weigh,touches,tempted,shout,resolve,relate,poisoned,meals,invitations,haunted,bogus,autograph,affects,tolerate,stepping,spontaneous,sleeps,probation,manny,fist,spectacular,hostages,heroin,havin,habits,encouraging,consult,burgers,boyfriends,bailed,baggage,watches,troubled,torturing,teasing,sweetest,qualities,postpone,overwhelmed,malkovich,impulse,classy,charging,amazed,policeman,hypocrite,humiliate,hideous,d'ya,costumes,bluffing,betting,bein,bedtime,alcoholic,vegetable,tray,suspicions,spreading,splendid,shrimp,shouting,pressed,nooo,grieving,gladly,fling,eliminate,cereal,aaah,sonofabitch,paralyzed,lotta,locks,guaranteed,dummy,despise,dental,briefing,bluff,batteries,whatta,sounding,servants,presume,handwriting,fainted,dried,allright,acknowledge,whacked,toxic,reliable,quicker,overwhelming,lining,harassing,fatal,endless,dolls,convict,whatcha,unlikely,shutting,positively,overcome,goddam,essence,dose,diagnosis,cured,bully,ahold,yearbook,tempting,shelf,prosecution,pouring,possessed,greedy,wonders,thorough,spine,rath,psychiatric,meaningless,latte,jammed,ignored,fiance,evidently,contempt,compromised,cans,weekends,urge,theft,suing,shipment,scissors,responding,proposition,noises,matching,hormones,hail,grandchildren,gently,smashed,sexually,sentimental,nicest,manipulated,intern,handcuffs,framed,errands,entertaining,crib,carriage,barge,spends,slipping,seated,rubbing,rely,reject,recommendation,reckon,headaches,float,embrace,corners,whining,sweating,skipped,mountie,motives,listens,cristobel,cleaner,cheerleader,balsom,unnecessary,stunning,scent,quartermaines,pose,montega,loosen,info,hottest,haunt,gracious,forgiving,errand,cakes,blames,abortion,sketch,shifts,plotting,perimeter,pals,mere,mattered,lonigan,interference,eyewitness,enthusiasm,diapers,strongest,shaken,punched,portal,catches,backyard,terrorists,sabotage,organs,needy,cuff,civilization,woof,who'll,prank,obnoxious,mates,hereby,gabby,faked,cellar,whitelighter,void,strangle,sour,muffins,interfering,demonic,clearing,boutique,barrington,terrace,smoked,righty,quack,petey,pact,knot,ketchup,disappearing,cordy,uptight,ticking,terrifying,tease,swamp,secretly,rejection,reflection,realizing,rays,mentally,marone,doubted,deception,congressman,cheesy,toto,stalling,scoop,ribbon,immune,expects,destined,bets,bathing,appreciation,accomplice,wander,shoved,sewer,scroll,retire,lasts,fugitive,freezer,discount,cranky,crank,clearance,bodyguard,anxiety,accountant,whoops,volunteered,talents,stinking,remotely,garlic,decency,cord,beds,altogether,uniforms,tremendous,popping,outa,observe,lung,hangs,feelin,dudes,donation,disguise,curb,bites,antique,toothbrush,realistic,predict,landlord,hourglass,hesitate,consolation,babbling,tipped,stranded,smartest,repeating,puke,psst,paycheck,overreacted,macho,juvenile,grocery,freshen,disposal,cuffs,caffeine,vanished,unfinished,ripping,pinch,flattering,expenses,dinners,colleague,ciao,belthazor,attorneys,woulda,whereabouts,waitin,truce,tripped,tasted,steer,poisoning,manipulative,immature,husbands,heel,granddad,delivering,condoms,addict,trashed,raining,pasta,needles,leaning,detector,coolest,batch,appointments,almighty,vegetables,spark,perfection,pains,momma,mole,meow,hairs,getaway,cracking,compliments,behold,verge,tougher,timer,tapped,taped,specialty,snooping,shoots,rendezvous,pentagon,leverage,jeopardize,janitor,grandparents,forbidden,clueless,bidding,ungrateful,unacceptable,tutor,serum,scuse,pajamas,mouths,lure,irrational,doom,cries,beautifully,arresting,approaching,traitor,sympathetic,smug,smash,rental,prostitute,premonitions,jumps,inventory,darlin,committing,banging,asap,worms,violated,vent,traumatic,traced,sweaty,shaft,overboard,insight,healed,grasp,experiencing,crappy,crab,chunk,awww,stain,shack,reacted,pronounce,poured,moms,marriages,jabez,handful,flipped,fireplace,embarrassment,disappears,concussion,bruises,brakes,twisting,swept,summon,splitting,sloppy,settling,reschedule,notch,hooray,grabbing,exquisite,disrespect,thornhart,straw,slapped,shipped,shattered,ruthless,refill,payroll,numb,mourning,manly,hunk,entertain,drift,dreadful,doorstep,confirmation,chops,appreciates,vague,tires,stressful,stashed,stash,sensed,preoccupied,predictable,noticing,madly,gunshot,dozens,dork,confuse,cleaners,charade,chalk,cappuccino,bouquet,amulet,addiction,who've,warming,unlock,satisfy,sacrificed,relaxing,lone,blocking,blend,blankets,addicted,yuck,hunger,hamburger,greeting,greet,gravy,gram,dreamt,dice,caution,backpack,agreeing,whale,taller,supervisor,sacrifices,phew,ounce,irrelevant,gran,felon,favorites,farther,fade,erased,easiest,convenience,compassionate,cane,backstage,agony,adores,veins,tweek,thieves,surgical,strangely,stetson,recital,proposing,productive,meaningful,immunity,hassle,goddamned,frighten,dearly,cease,ambition,wage,unstable,salvage,richer,refusing,raging,pumping,pressuring,mortals,lowlife,intimidated,intentionally,inspire,forgave,devotion,despicable,deciding,dash,comfy,breach,bark,aaaah,switching,swallowed,stove,screamed,scars,russians,pounding,poof,pipes,pawn,legit,invest,farewell,curtains,civilized,caviar,boost,token,superstition,supernatural,sadness,recorder,psyched,motivated,microwave,hallelujah,fraternity,dryer,cocoa,chewing,acceptable,unbelievably,smiled,smelling,simpler,respectable,remarks,khasinau,indication,gutter,grabs,fulfill,flashlight,ellenor,blooded,blink,blessings,beware,uhhh,turf,swings,slips,shovel,shocking,puff,mirrors,locking,heartless,fras,childish,cardiac,utterly,tuscany,ticked,stunned,statesville,sadly,purely,kiddin,jerks,hitch,flirt,fare,equals,dismiss,christening,casket,c'mere,breakup,biting,antibiotics,accusation,abducted,witchcraft,thread,runnin,punching,paramedics,newest,murdering,masks,lawndale,initials,grampa,choking,charms,careless,bushes,buns,bummed,shred,saves,saddle,rethink,regards,precinct,persuade,meds,manipulating,llanfair,leash,hearted,guarantees,fucks,disgrace,deposition,bookstore,boil,vitals,veil,trespassing,sidewalk,sensible,punishing,overtime,optimistic,obsessing,notify,mornin,jeopardy,jaffa,injection,hilarious,desires,confide,cautious,yada,where're,vindictive,vial,teeny,stroll,sittin,scrub,rebuild,posters,ordeal,nuns,intimacy,inheritance,exploded,donate,distracting,despair,crackers,wildwind,virtue,thoroughly,tails,spicy,sketches,sights,sheer,shaving,seize,scarecrow,refreshing,prosecute,platter,napkin,misplaced,merchandise,loony,jinx,heroic,frankenstein,ambitious,syrup,solitary,resemblance,reacting,premature,lavery,flashes,cheque,awright,acquainted,wrapping,untie,salute,realised,priceless,partying,lightly,lifting,kasnoff,insisting,glowing,generator,explosives,cutie,confronted,buts,blouse,ballistic,antidote,analyze,allowance,adjourned,unto,understatement,tucked,touchy,subconscious,screws,sarge,roommates,rambaldi,offend,nerd,knives,irresistible,incapable,hostility,goddammit,fuse,frat,curfew,blackmailed,walkin,starve,sleigh,sarcastic,recess,rebound,pinned,parlor,outfits,livin,heartache,haired,fundraiser,doorman,discreet,dilucca,cracks,considerate,climbed,catering,apophis,zoey,urine,strung,stitches,sordid,sark,protector,phoned,pets,hostess,flaw,flavor,deveraux,consumed,confidentiality,bourbon,straightened,specials,spaghetti,prettier,powerless,playin,playground,paranoia,instantly,havoc,exaggerating,eavesdropping,doughnuts,diversion,deepest,cutest,comb,bela,behaving,anyplace,accessory,workout,translate,stuffing,speeding,slime,royalty,polls,marital,lurking,lottery,imaginary,greetings,fairwinds,elegant,elbow,credibility,credentials,claws,chopped,bridal,bedside,babysitting,witty,unforgivable,underworld,tempt,tabs,sophomore,selfless,secrecy,restless,okey,movin,metaphor,messes,meltdown,lecter,incoming,gasoline,diefenbaker,buckle,admired,adjustment,warmth,throats,seduced,queer,parenting,noses,luckiest,graveyard,gifted,footsteps,dimeras,cynical,wedded,verbal,unpredictable,tuned,stoop,slides,sinking,rigged,plumbing,lingerie,hankey,greed,everwood,elope,dresser,chauffeur,bulletin,bugged,bouncing,temptation,strangest,slammed,sarcasm,pending,packages,orderly,obsessive,murderers,meteor,inconvenience,glimpse,froze,execute,courageous,consulate,closes,bosses,bees,amends,wuss,wolfram,wacky,unemployed,testifying,syringe,stew,startled,sorrow,sleazy,shaky,screams,rsquo,remark,poke,nutty,mentioning,mend,inspiring,impulsive,housekeeper,foam,fingernails,conditioning,baking,whine,thug,starved,sniffing,sedative,programmed,picket,paged,hound,homosexual,homo,hips,forgets,flipping,flea,flatter,dwell,dumpster,choo,assignments,ants,vile,unreasonable,tossing,thanked,steals,souvenir,scratched,psychopath,outs,obstruction,obey,lump,insists,harass,gloat,filth,edgy,didn,coroner,confessing,bruise,betraying,bailing,appealing,adebisi,wrath,wandered,waist,vain,traps,stepfather,poking,obligated,heavenly,dilemma,crazed,contagious,coaster,cheering,bundle,vomit,thingy,speeches,robbing,raft,pumped,pillows,peep,packs,neglected,m'kay,loneliness,intrude,helluva,gardener,forresters,drooling,betcha,vase,supermarket,squat,spitting,rhyme,relieve,receipts,racket,pictured,pause,overdue,motivation,morgendorffer,kidnapper,insect,horns,feminine,eyeballs,dumps,disappointing,crock,convertible,claw,clamp,canned,cambias,bathtub,avanya,artery,weep,warmer,suspense,summoned,spiders,reiber,raving,pushy,postponed,ohhhh,noooo,mold,laughter,incompetent,hugging,groceries,drip,communicating,auntie,adios,wraps,wiser,willingly,weirdest,timmih,thinner,swelling,swat,steroids,sensitivity,scrape,rehearse,prophecy,ledge,justified,insults,hateful,handles,doorway,chatting,buyer,buckaroo,bedrooms,askin,ammo,tutoring,subpoena,scratching,privileges,pager,mart,intriguing,idiotic,grape,enlighten,corrupt,brunch,bridesmaid,barking,applause,acquaintance,wretched,superficial,soak,smoothly,sensing,restraint,posing,pleading,payoff,oprah,nemo,morals,loaf,jumpy,ignorant,herbal,hangin,germs,generosity,flashing,doughnut,clumsy,chocolates,captive,behaved,apologise,vanity,stumbled,preview,poisonous,perjury,parental,onboard,mugged,minding,linen,knots,interviewing,humour,grind,greasy,goons,drastic,coop,comparing,cocky,clearer,bruised,brag,bind,worthwhile,whoop,vanquishing,tabloids,sprung,spotlight,sentencing,racist,provoke,pining,overly,locket,imply,impatient,hovering,hotter,fest,endure,dots,doren,debts,crawled,chained,brit,breaths,weirdo,warmed,wand,troubling,tok'ra,strapped,soaked,skipping,scrambled,rattle,profound,musta,mocking,misunderstand,limousine,kacl,hustle,forensic,enthusiastic,duct,drawers,devastating,conquer,clarify,chores,cheerleaders,cheaper,callin,blushing,barging,abused,yoga,wrecking,wits,waffles,virginity,vibes,uninvited,unfaithful,teller,strangled,scheming,ropes,rescuing,rave,postcard,o'reily,morphine,lotion,lads,kidneys,judgement,itch,indefinitely,grenade,glamorous,genetically,freud,discretion,delusions,crate,competent,bakery,argh,ahhhh,wedge,wager,unfit,tripping,torment,superhero,stirring,spinal,sorority,seminar,scenery,rabble,pneumonia,perks,override,ooooh,mija,manslaughter,mailed,lime,lettuce,intimidate,guarded,grieve,grad,frustration,doorbell,chinatown,authentic,arraignment,annulled,allergies,wanta,verify,vegetarian,tighter,telegram,stalk,spared,shoo,satisfying,saddam,requesting,pens,overprotective,obstacles,notified,nasedo,grandchild,genuinely,flushed,fluids,floss,escaping,ditched,cramp,corny,bunk,bitten,billions,bankrupt,yikes,wrists,ultrasound,ultimatum,thirst,sniff,shakes,salsa,retrieve,reassuring,pumps,neurotic,negotiating,needn't,monitors,millionaire,lydecker,limp,incriminating,hatchet,gracias,gordie,fills,feeds,doubting,decaf,biopsy,whiz,voluntarily,ventilator,unpack,unload,toad,spooked,snitch,schillinger,reassure,persuasive,mystical,mysteries,matrimony,mails,jock,headline,explanations,dispatch,curly,cupid,condolences,comrade,cassadines,bulb,bragging,awaits,assaulted,ambush,adolescent,abort,yank,whit,vaguely,undermine,tying,swamped,stabbing,slippers,slash,sincerely,sigh,setback,secondly,rotting,precaution,pcpd,melting,liaison,hots,hooking,headlines,haha,ganz,fury,felicity,fangs,encouragement,earring,dreidel,dory,donut,dictate,decorating,cocktails,bumps,blueberry,believable,backfired,backfire,apron,adjusting,vous,vouch,vitamins,ummm,tattoos,slimy,sibling,shhhh,renting,peculiar,parasite,paddington,marries,mailbox,magically,lovebirds,knocks,informant,exits,drazen,distractions,disconnected,dinosaurs,dashwood,crooked,conveniently,wink,warped,underestimated,tacky,shoving,seizure,reset,pushes,opener,mornings,mash,invent,indulge,horribly,hallucinating,festive,eyebrows,enjoys,desperation,dealers,darkest,daph,boragora,belts,bagel,authorization,auditions,agitated,wishful,wimp,vanish,unbearable,tonic,suffice,suction,slaying,safest,rocking,relive,puttin,prettiest,noisy,newlyweds,nauseous,misguided,mildly,midst,liable,judgmental,indy,hunted,givin,fascinated,elephants,dislike,deluded,decorate,crummy,contractions,carve,bottled,bonded,bahamas,unavailable,twenties,trustworthy,surgeons,stupidity,skies,remorse,preferably,pies,nausea,napkins,mule,mourn,melted,mashed,inherit,greatness,golly,excused,dumbo,drifting,delirious,damaging,cubicle,compelled,comm,chooses,checkup,boredom,bandages,alarms,windshield,who're,whaddya,transparent,surprisingly,sunglasses,slit,roar,reade,prognosis,probe,pitiful,persistent,peas,nosy,nagging,morons,masterpiece,martinis,limbo,liars,irritating,inclined,hump,hoynes,fiasco,eatin,cubans,concentrating,colorful,clam,cider,brochure,barto,bargaining,wiggle,welcoming,weighing,vanquished,stains,sooo,snacks,smear,sire,resentment,psychologist,pint,overhear,morality,landingham,kisser,hoot,holling,handshake,grilled,formality,elevators,depths,confirms,boathouse,accidental,westbridge,wacko,ulterior,thugs,thighs,tangled,stirred,snag,sling,sleaze,rumour,ripe,remarried,puddle,pins,perceptive,miraculous,longing,lockup,librarian,impressions,immoral,hypothetically,guarding,gourmet,gabe,faxed,extortion,downright,digest,cranberry,bygones,buzzing,burying,bikes,weary,taping,takeout,sweeping,stepmother,stale,senor,seaborn,pros,pepperoni,newborn,ludicrous,injected,geeks,forged,faults,drue,dire,dief,desi,deceiving,caterer,calmed,budge,ankles,vending,typing,tribbiani,there're,squared,snowing,shades,sexist,rewrite,regretted,raises,picky,orphan,mural,misjudged,miscarriage,memorize,leaking,jitters,invade,interruption,illegally,handicapped,glitch,gittes,finer,distraught,dispose,dishonest,digs,dads,cruelty,circling,canceling,butterflies,belongings,barbrady,amusement,alias,zombies,where've,unborn,swearing,stables,squeezed,sensational,resisting,radioactive,questionable,privileged,portofino,owning,overlook,orson,oddly,interrogate,imperative,impeccable,hurtful,hors,heap,graders,glance,disgust,devious,destruct,crazier,countdown,chump,cheeseburger,burglar,berries,ballroom,assumptions,annoyed,allergy,admirer,admirable,activate,underpants,twit,tack,strokes,stool,sham,scrap,retarded,resourceful,remarkably,refresh,pressured,precautions,pointy,nightclub,mustache,maui,lace,hunh,hubby,flare,dont,dokey,dangerously,crushing,clinging,choked,chem,cheerleading,checkbook,cashmere,calmly,blush,believer,amazingly,alas,what've,toilets,tacos,stairwell,spirited,sewing,rubbed,punches,protects,nuisance,motherfuckers,mingle,kynaston,knack,kinkle,impose,gullible,godmother,funniest,friggin,folding,fashions,eater,dysfunctional,drool,dripping,ditto,cruising,criticize,conceive,clone,cedars,caliber,brighter,blinded,birthdays,banquet,anticipate,annoy,whim,whichever,volatile,veto,vested,shroud,rests,reindeer,quarantine,pleases,painless,orphans,orphanage,offence,obliged,negotiation,narcotics,mistletoe,meddling,manifest,lookit,lilah,intrigued,injustice,homicidal,gigantic,exposing,elves,disturbance,disastrous,depended,demented,correction,cooped,cheerful,buyers,brownies,beverage,basics,arvin,weighs,upsets,unethical,swollen,sweaters,stupidest,sensation,scalpel,props,prescribed,pompous,objections,mushrooms,mulwray,manipulation,lured,internship,insignificant,inmate,incentive,fulfilled,disagreement,crypt,cornered,copied,brightest,beethoven,attendant,amaze,yogurt,wyndemere,vocabulary,tulsa,tactic,stuffy,respirator,pretends,polygraph,pennies,ordinarily,olives,necks,morally,martyr,leftovers,joints,hopping,homey,hints,heartbroken,forge,florist,firsthand,fiend,dandy,crippled,corrected,conniving,conditioner,clears,chemo,bubbly,bladder,beeper,baptism,wiring,wench,weaknesses,volunteering,violating,unlocked,tummy,surrogate,subid,stray,startle,specifics,slowing,scoot,robbers,rightful,richest,qfxmjrie,puffs,pierced,pencils,paralysis,makeover,luncheon,linksynergy,jerky,jacuzzi,hitched,hangover,fracture,flock,firemen,disgusted,darned,clams,borrowing,banged,wildest,weirder,unauthorized,stunts,sleeves,sixties,shush,shalt,retro,quits,pegged,painfully,paging,omelet,memorized,lawfully,jackets,intercept,ingredient,grownup,glued,fulfilling,enchanted,delusion,daring,compelling,carton,bridesmaids,bribed,boiling,bathrooms,bandage,awaiting,assign,arrogance,antiques,ainsley,turkeys,trashing,stockings,stalked,stabilized,skates,sedated,robes,respecting,psyche,presumptuous,prejudice,paragraph,mocha,mints,mating,mantan,lorne,loads,listener,itinerary,hepatitis,heave,guesses,fading,examining,dumbest,dishwasher,deceive,cunning,cripple,convictions,confided,compulsive,compromising,burglary,bumpy,brainwashed,benes,arnie,affirmative,adrenaline,adamant,watchin,waitresses,transgenic,toughest,tainted,surround,stormed,spree,spilling,spectacle,soaking,shreds,sewers,severed,scarce,scamming,scalp,rewind,rehearsing,pretentious,potions,overrated,obstacle,nerds,meems,mcmurphy,maternity,maneuver,loathe,fertility,eloping,ecstatic,ecstasy,divorcing,dignan,costing,clubhouse,clocks,candid,bursting,breather,braces,bending,arsonist,adored,absorb,valiant,uphold,unarmed,topolsky,thrilling,thigh,terminate,sustain,spaceship,snore,sneeze,smuggling,salty,quaint,patronize,patio,morbid,mamma,kettle,joyous,invincible,interpret,insecurities,impulses,illusions,holed,exploit,drivin,defenseless,dedicate,cradle,coupon,countless,conjure,cardboard,booking,backseat,accomplishment,wordsworth,wisely,valet,vaccine,urges,unnatural,unlucky,truths,traumatized,tasting,swears,strawberries,steaks,stats,skank,seducing,secretive,scumbag,screwdriver,schedules,rooting,rightfully,rattled,qualifies,puppets,prospects,pronto,posse,polling,pedestal,palms,muddy,morty,microscope,merci,lecturing,inject,incriminate,hygiene,grapefruit,gazebo,funnier,cuter,bossy,booby,aides,zende,winthrop,warrants,valentines,undressed,underage,truthfully,tampered,suffers,speechless,sparkling,sidelines,shrek,railing,puberty,pesky,outrage,outdoors,motions,moods,lunches,litter,kidnappers,itching,intuition,imitation,humility,hassling,gallons,drugstore,dosage,disrupt,dipping,deranged,debating,cuckoo,cremated,craziness,cooperating,circumstantial,chimney,blinking,biscuits,admiring,weeping,triad,trashy,soothing,slumber,slayers,skirts,siren,shindig,sentiment,rosco,riddance,quaid,purity,proceeding,pretzels,panicking,mckechnie,lovin,leaked,intruding,impersonating,ignorance,hamburgers,footprints,fluke,fleas,festivities,fences,feisty,evacuate,emergencies,deceived,creeping,craziest,corpses,conned,coincidences,bounced,bodyguards,blasted,bitterness,baloney,ashtray,apocalypse,zillion,watergate,wallpaper,telesave,sympathize,sweeter,startin,spades,sodas,snowed,sleepover,signor,seein,retainer,restroom,rested,repercussions,reliving,reconcile,prevail,preaching,overreact,o'neil,noose,moustache,manicure,maids,landlady,hypothetical,hopped,homesick,hives,hesitation,herbs,hectic,heartbreak,haunting,gangs,frown,fingerprint,exhausting,everytime,disregard,cling,chevron,chaperone,blinding,bitty,beads,battling,badgering,anticipation,upstanding,unprofessional,unhealthy,turmoil,truthful,toothpaste,tippin,thoughtless,tagataya,shooters,senseless,rewarding,propane,preposterous,pigeons,pastry,overhearing,obscene,negotiable,loner,jogging,itchy,insinuating,insides,hospitality,hormone,hearst,forthcoming,fists,fifties,etiquette,endings,destroys,despises,deprived,cuddy,crust,cloak,circumstance,chewed,casserole,bidder,bearer,artoo,applaud,appalling,vowed,virgins,vigilante,undone,throttle,testosterone,tailor,symptom,swoop,suitcases,stomp,sticker,stakeout,spoiling,snatched,smoochy,smitten,shameless,restraints,researching,renew,refund,reclaim,raoul,puzzles,purposely,punks,prosecuted,plaid,picturing,pickin,parasites,mysteriously,multiply,mascara,jukebox,interruptions,gunfire,furnace,elbows,duplicate,drapes,deliberate,decoy,cryptic,coupla,condemn,complicate,colossal,clerks,clarity,brushed,banished,argon,alarmed,worships,versa,uncanny,technicality,sundae,stumble,stripping,shuts,schmuck,satin,saliva,robber,relentless,reconnect,recipes,rearrange,rainy,psychiatrists,policemen,plunge,plugged,patched,overload,o'malley,mindless,menus,lullaby,lotte,leavin,killin,karinsky,invalid,hides,grownups,griff,flaws,flashy,flaming,fettes,evicted,dread,degrassi,dealings,dangers,cushion,bowel,barged,abide,abandoning,wonderfully,wait'll,violate,suicidal,stayin,sorted,slamming,sketchy,shoplifting,raiser,quizmaster,prefers,needless,motherhood,momentarily,migraine,lifts,leukemia,leftover,keepin,hinks,hellhole,gowns,goodies,gallon,futures,entertained,eighties,conspiring,cheery,benign,apiece,adjustments,abusive,abduction,wiping,whipping,welles,unspeakable,unidentified,trivial,transcripts,textbook,supervise,superstitious,stricken,stimulating,spielberg,slices,shelves,scratches,sabotaged,retrieval,repressed,rejecting,quickie,ponies,peeking,outraged,o'connell,moping,moaning,mausoleum,licked,kovich,klutz,interrogating,interfered,insulin,infested,incompetence,hyper,horrified,handedly,gekko,fraid,fractured,examiner,eloped,disoriented,dashing,crashdown,courier,cockroach,chipped,brushing,bombed,bolts,baths,baptized,astronaut,assurance,anemia,abuela,abiding,withholding,weave,wearin,weaker,suffocating,straws,straightforward,stench,steamed,starboard,sideways,shrinks,shortcut,scram,roasted,roaming,riviera,respectfully,repulsive,psychiatry,provoked,penitentiary,painkillers,ninotchka,mitzvah,milligrams,midge,marshmallows,looky,lapse,kubelik,intellect,improvise,implant,goa'ulds,giddy,geniuses,fruitcake,footing,fightin,drinkin,doork,detour,cuddle,crashes,combo,colonnade,cheats,cetera,bailiff,auditioning,assed,amused,alienate,aiding,aching,unwanted,topless,tongues,tiniest,superiors,soften,sheldrake,rawley,raisins,presses,plaster,nessa,narrowed,minions,merciful,lawsuits,intimidating,infirmary,inconvenient,imposter,hugged,honoring,holdin,hades,godforsaken,fumes,forgery,foolproof,folder,flattery,fingertips,exterminator,explodes,eccentric,dodging,disguised,crave,constructive,concealed,compartment,chute,chinpokomon,bodily,astronauts,alimony,accustomed,abdominal,wrinkle,wallow,valium,untrue,uncover,trembling,treasures,torched,toenails,timed,termites,telly,taunting,taransky,talker,succubus,smarts,sliding,sighting,semen,seizures,scarred,savvy,sauna,saddest,sacrificing,rubbish,riled,ratted,rationally,provenance,phonse,perky,pedal,overdose,nasal,nanites,mushy,movers,missus,midterm,merits,melodramatic,manure,knitting,invading,interpol,incapacitated,hotline,hauling,gunpoint,grail,ganza,framing,flannel,faded,eavesdrop,desserts,calories,breathtaking,bleak,blacked,batter,aggravated,yanked,wigand,whoah,unwind,undoubtedly,unattractive,twitch,trimester,torrance,timetable,taxpayers,strained,stared,slapping,sincerity,siding,shenanigans,shacking,sappy,samaritan,poorer,politely,paste,oysters,overruled,nightcap,mosquito,millimeter,merrier,manhood,lucked,kilos,ignition,hauled,harmed,goodwill,freshmen,fenmore,fasten,farce,exploding,erratic,drunks,ditching,d'artagnan,cramped,contacting,closets,clientele,chimp,bargained,arranging,anesthesia,amuse,altering,afternoons,accountable,abetting,wolek,waved,uneasy,toddy,tattooed,spauldings,sliced,sirens,schibetta,scatter,rinse,remedy,redemption,pleasures,optimism,oblige,mmmmm,masked,malicious,mailing,kosher,kiddies,judas,isolate,insecurity,incidentally,heals,headlights,growl,grilling,glazed,flunk,floats,fiery,fairness,exercising,excellency,disclosure,cupboard,counterfeit,condescending,conclusive,clicked,cleans,cholesterol,cashed,broccoli,brats,blueprints,blindfold,billing,attach,appalled,alrighty,wynant,unsolved,unreliable,toots,tighten,sweatshirt,steinbrenner,steamy,spouse,sonogram,slots,sleepless,shines,retaliate,rephrase,redeem,rambling,quilt,quarrel,prying,proverbial,priced,prescribe,prepped,pranks,possessive,plaintiff,pediatrics,overlooked,outcast,nightgown,mumbo,mediocre,mademoiselle,lunchtime,lifesaver,leaned,lambs,interns,hounding,hellmouth,hahaha,goner,ghoul,gardening,frenzy,foyer,extras,exaggerate,everlasting,enlightened,dialed,devote,deceitful,d'oeuvres,cosmetic,contaminated,conspired,conning,cavern,carving,butting,boiled,blurry,babysit,ascension,aaaaah,wildly,whoopee,whiny,weiskopf,walkie,vultures,vacations,upfront,unresolved,tampering,stockholders,snaps,sleepwalking,shrunk,sermon,seduction,scams,revolve,phenomenal,patrolling,paranormal,ounces,omigod,nightfall,lashing,innocents,infierno,incision,humming,haunts,gloss,gloating,frannie,fetal,feeny,entrapment,discomfort,detonator,dependable,concede,complication,commotion,commence,chulak,caucasian,casually,brainer,bolie,ballpark,anwar,analyzing,accommodations,youse,wring,wallowing,transgenics,thrive,tedious,stylish,strippers,sterile,squeezing,squeaky,sprained,solemn,snoring,shattering,shabby,seams,scrawny,revoked,residue,reeks,recite,ranting,quoting,predicament,plugs,pinpoint,petrified,pathological,passports,oughtta,nighter,navigate,kippie,intrigue,intentional,insufferable,hunky,how've,horrifying,hearty,hamptons,grazie,funerals,forks,fetched,excruciating,enjoyable,endanger,dumber,drying,diabolical,crossword,corry,comprehend,clipped,classmates,candlelight,brutally,brutality,boarded,bathrobe,authorize,assemble,aerobics,wholesome,whiff,vermin,trophies,trait,tragically,toying,testy,tasteful,stocked,spinach,sipping,sidetracked,scrubbing,scraping,sanctity,robberies,ridin,retribution,refrain,realities,radiant,protesting,projector,plutonium,payin,parting,o'reilly,nooooo,motherfucking,measly,manic,lalita,juggling,jerking,intro,inevitably,hypnosis,huddle,horrendous,hobbies,heartfelt,harlin,hairdresser,gonorrhea,fussing,furtwangler,fleeting,flawless,flashed,fetus,eulogy,distinctly,disrespectful,denies,crossbow,cregg,crabs,cowardly,contraction,contingency,confirming,condone,coffins,cleansing,cheesecake,certainty,cages,c'est,briefed,bravest,bosom,boils,binoculars,bachelorette,appetizer,ambushed,alerted,woozy,withhold,vulgar,utmost,unleashed,unholy,unhappiness,unconditional,typewriter,typed,twists,supermodel,subpoenaed,stringing,skeptical,schoolgirl,romantically,rocked,revoir,reopen,puncture,preach,polished,planetarium,penicillin,peacefully,nurturing,more'n,mmhmm,midgets,marklar,lodged,lifeline,jellyfish,infiltrate,hutch,horseback,heist,gents,frickin,freezes,forfeit,flakes,flair,fathered,eternally,epiphany,disgruntled,discouraged,delinquent,decipher,danvers,cubes,credible,coping,chills,cherished,catastrophe,bombshell,birthright,billionaire,ample,affections,admiration,abbotts,whatnot,watering,vinegar,unthinkable,unseen,unprepared,unorthodox,underhanded,uncool,timeless,thump,thermometer,theoretically,tapping,tagged,swung,stares,spiked,solves,smuggle,scarier,saucer,quitter,prudent,powdered,poked,pointers,peril,penetrate,penance,opium,nudge,nostrils,neurological,mockery,mobster,medically,loudly,insights,implicate,hypocritical,humanly,holiness,healthier,hammered,haldeman,gunman,gloom,freshly,francs,flunked,flawed,emptiness,drugging,dozer,derevko,deprive,deodorant,cryin,crocodile,coloring,colder,cognac,clocked,clippings,charades,chanting,certifiable,caterers,brute,brochures,botched,blinders,bitchin,banter,woken,ulcer,tread,thankfully,swine,swimsuit,swans,stressing,steaming,stamped,stabilize,squirm,snooze,shuffle,shredded,seafood,scratchy,savor,sadistic,rhetorical,revlon,realist,prosecuting,prophecies,polyester,petals,persuasion,paddles,o'leary,nuthin,neighbour,negroes,muster,meningitis,matron,lockers,letterman,legged,indictment,hypnotized,housekeeping,hopelessly,hallucinations,grader,goldilocks,girly,flask,envelopes,downside,doves,dissolve,discourage,disapprove,diabetic,deliveries,decorator,crossfire,criminally,containment,comrades,complimentary,chatter,catchy,cashier,cartel,caribou,cardiologist,brawl,booted,barbershop,aryan,angst,administer,zellie,wreak,whistles,vandalism,vamps,uterus,upstate,unstoppable,understudy,tristin,transcript,tranquilizer,toxins,tonsils,stempel,spotting,spectator,spatula,softer,snotty,slinging,showered,sexiest,sensual,sadder,rimbaud,restrain,resilient,remission,reinstate,rehash,recollection,rabies,popsicle,plausible,pediatric,patronizing,ostrich,ortolani,oooooh,omelette,mistrial,marseilles,loophole,laughin,kevvy,irritated,infidelity,hypothermia,horrific,groupie,grinding,graceful,goodspeed,gestures,frantic,extradition,echelon,disks,dawnie,dared,damsel,curled,collateral,collage,chant,calculating,bumping,bribes,boardwalk,blinds,blindly,bleeds,bickering,beasts,backside,avenge,apprehended,anguish,abusing,youthful,yells,yanking,whomever,when'd,vomiting,vengeful,unpacking,unfamiliar,undying,tumble,trolls,treacherous,tipping,tantrum,tanked,summons,straps,stomped,stinkin,stings,staked,squirrels,sprinkles,speculate,sorting,skinned,sicko,sicker,shootin,shatter,seeya,schnapps,s'posed,ronee,respectful,regroup,regretting,reeling,reckoned,ramifications,puddy,projections,preschool,plissken,platonic,permalash,outdone,outburst,mutants,mugging,misfortune,miserably,miraculously,medications,margaritas,manpower,lovemaking,logically,leeches,latrine,kneel,inflict,impostor,hypocrisy,hippies,heterosexual,heightened,hecuba,healer,gunned,grooming,groin,gooey,gloomy,frying,friendships,fredo,firepower,fathom,exhaustion,evils,endeavor,eggnog,dreaded,d'arcy,crotch,coughing,coronary,cookin,consummate,congrats,companionship,caved,caspar,bulletproof,brilliance,breakin,brash,blasting,aloud,airtight,advising,advertise,adultery,aches,wronged,upbeat,trillion,thingies,tending,tarts,surreal,specs,specialize,spade,shrew,shaping,selves,schoolwork,roomie,recuperating,rabid,quart,provocative,proudly,pretenses,prenatal,pharmaceuticals,pacing,overworked,originals,nicotine,murderous,mileage,mayonnaise,massages,losin,interrogated,injunction,impartial,homing,heartbreaker,hacks,glands,giver,fraizh,flips,flaunt,englishman,electrocuted,dusting,ducking,drifted,donating,cylon,crutches,crates,cowards,comfortably,chummy,chitchat,childbirth,businesswoman,brood,blatant,bethy,barring,bagged,awakened,asbestos,airplanes,worshipped,winnings,why're,visualize,unprotected,unleash,trays,thicker,therapists,takeoff,streisand,storeroom,stethoscope,stacked,spiteful,sneaks,snapping,slaughtered,slashed,simplest,silverware,shits,secluded,scruples,scrubs,scraps,ruptured,roaring,receptionist,recap,raditch,radiator,pushover,plastered,pharmacist,perverse,perpetrator,ornament,ointment,nineties,napping,nannies,mousse,moors,momentary,misunderstandings,manipulator,malfunction,laced,kivar,kickin,infuriating,impressionable,holdup,hires,hesitated,headphones,hammering,groundwork,grotesque,graces,gauze,gangsters,frivolous,freeing,fours,forwarding,ferrars,faulty,fantasizing,extracurricular,empathy,divorces,detonate,depraved,demeaning,deadlines,dalai,cursing,cufflink,crows,coupons,comforted,claustrophobic,casinos,camped,busboy,bluth,bennetts,baskets,attacker,aplastic,angrier,affectionate,zapped,wormhole,weaken,unrealistic,unravel,unimportant,unforgettable,twain,suspend,superbowl,stutter,stewardess,stepson,standin,spandex,souvenirs,sociopath,skeletons,shivering,sexier,selfishness,scrapbook,ritalin,ribbons,reunite,remarry,relaxation,rattling,rapist,psychosis,prepping,poses,pleasing,pisses,piling,persecuted,padded,operatives,negotiator,natty,menopause,mennihan,martimmys,loyalties,laynie,lando,justifies,intimately,inexperienced,impotent,immortality,horrors,hooky,hinges,heartbreaking,handcuffed,gypsies,guacamole,grovel,graziella,goggles,gestapo,fussy,ferragamo,feeble,eyesight,explosions,experimenting,enchanting,doubtful,dizziness,dismantle,detectors,deserving,defective,dangling,dancin,crumble,creamed,cramping,conceal,clockwork,chrissakes,chrissake,chopping,cabinets,brooding,bonfire,blurt,bloated,blackmailer,beforehand,bathed,bathe,barcode,banish,badges,babble,await,attentive,aroused,antibodies,animosity,ya'll,wrinkled,wonderland,willed,whisk,waltzing,waitressing,vigilant,upbringing,unselfish,uncles,trendy,trajectory,striped,stamina,stalled,staking,stacks,spoils,snuff,snooty,snide,shrinking,senora,secretaries,scoundrel,saline,salads,rundown,riddles,relapse,recommending,raspberry,plight,pecan,pantry,overslept,ornaments,niner,negligent,negligence,nailing,mucho,mouthed,monstrous,malpractice,lowly,loitering,logged,lingering,lettin,lattes,kamal,juror,jillefsky,jacked,irritate,intrusion,insatiable,infect,impromptu,icing,hmmmm,hefty,gasket,frightens,flapping,firstborn,faucet,estranged,envious,dopey,doesn,disposition,disposable,disappointments,dipped,dignified,deceit,dealership,deadbeat,curses,coven,counselors,concierge,clutches,casbah,callous,cahoots,brotherly,britches,brides,bethie,beige,autographed,attendants,attaboy,astonishing,appreciative,antibiotic,aneurysm,afterlife,affidavit,zoning,whats,whaddaya,vasectomy,unsuspecting,toula,topanga,tonio,toasted,tiring,terrorized,tenderness,tailing,sweats,suffocated,sucky,subconsciously,starvin,sprouts,spineless,sorrows,snowstorm,smirk,slicery,sledding,slander,simmer,signora,sigmund,seventies,sedate,scented,sandals,rollers,retraction,resigning,recuperate,receptive,racketeering,queasy,provoking,priors,prerogative,premed,pinched,pendant,outsiders,orbing,opportunist,olanov,neurologist,nanobot,mommies,molested,misread,mannered,laundromat,intercom,inspect,insanely,infatuation,indulgent,indiscretion,inconsiderate,hurrah,howling,herpes,hasta,harassed,hanukkah,groveling,groosalug,gander,galactica,futile,fridays,flier,fixes,exploiting,exorcism,evasive,endorse,emptied,dreary,dreamy,downloaded,dodged,doctored,disobeyed,disneyland,disable,dehydrated,contemplating,coconuts,cockroaches,clogged,chilling,chaperon,cameraman,bulbs,bucklands,bribing,brava,bracelets,bowels,bluepoint,appetizers,appendix,antics,anointed,analogy,almonds,yammering,winch,weirdness,wangler,vibrations,vendor,unmarked,unannounced,twerp,trespass,travesty,transfusion,trainee,towelie,tiresome,straightening,staggering,sonar,socializing,sinus,sinners,shambles,serene,scraped,scones,scepter,sarris,saberhagen,ridiculously,ridicule,rents,reconciled,radios,publicist,pubes,prune,prude,precrime,postponing,pluck,perish,peppermint,peeled,overdo,nutshell,nostalgic,mulan,mouthing,mistook,meddle,maybourne,martimmy,lobotomy,livelihood,lippman,likeness,kindest,kaffee,jocks,jerked,jeopardizing,jazzed,insured,inquisition,inhale,ingenious,holier,helmets,heirloom,heinous,haste,harmsway,hardship,hanky,gutters,gruesome,groping,goofing,godson,glare,finesse,figuratively,ferrie,endangerment,dreading,dozed,dorky,dmitri,divert,discredit,dialing,cufflinks,crutch,craps,corrupted,cocoon,cleavage,cannery,bystander,brushes,bruising,bribery,brainstorm,bolted,binge,ballistics,astute,arroway,adventurous,adoptive,addicts,addictive,yadda,whitelighters,wematanye,weeds,wedlock,wallets,vulnerability,vroom,vents,upped,unsettling,unharmed,trippin,trifle,tracing,tormenting,thats,syphilis,subtext,stickin,spices,sores,smacked,slumming,sinks,signore,shitting,shameful,shacked,septic,seedy,righteousness,relish,rectify,ravishing,quickest,phoebs,perverted,peeing,pedicure,pastrami,passionately,ozone,outnumbered,oregano,offender,nukes,nosed,nighty,nifty,mounties,motivate,moons,misinterpreted,mercenary,mentality,marsellus,lupus,lumbar,lovesick,lobsters,leaky,laundering,latch,jafar,instinctively,inspires,indoors,incarcerated,hundredth,handkerchief,gynecologist,guittierez,groundhog,grinning,goodbyes,geese,fullest,eyelashes,eyelash,enquirer,endlessly,elusive,disarm,detest,deluding,dangle,cotillion,corsage,conjugal,confessional,cones,commandment,coded,coals,chuckle,christmastime,cheeseburgers,chardonnay,celery,campfire,calming,burritos,brundle,broflovski,brighten,borderline,blinked,bling,beauties,bauers,battered,articulate,alienated,ahhhhh,agamemnon,accountants,y'see,wrongful,wrapper,workaholic,winnebago,whispered,warts,vacate,unworthy,unanswered,tonane,tolerated,throwin,throbbing,thrills,thorns,thereof,there've,tarot,sunscreen,stretcher,stereotype,soggy,sobbing,sizable,sightings,shucks,shrapnel,sever,senile,seaboard,scorned,saver,rebellious,rained,putty,prenup,pores,pinching,pertinent,peeping,paints,ovulating,opposites,occult,nutcracker,nutcase,newsstand,newfound,mocked,midterms,marshmallow,marbury,maclaren,leans,krudski,knowingly,keycard,junkies,juilliard,jolinar,irritable,invaluable,inuit,intoxicating,instruct,insolent,inexcusable,incubator,illustrious,hunsecker,houseguest,homosexuals,homeroom,hernia,harming,handgun,hallways,hallucination,gunshots,groupies,groggy,goiter,gingerbread,giggling,frigging,fledged,fedex,fairies,exchanging,exaggeration,esteemed,enlist,drags,dispense,disloyal,disconnect,desks,dentists,delacroix,degenerate,daydreaming,cushions,cuddly,corroborate,complexion,compensated,cobbler,closeness,chilled,checkmate,channing,carousel,calms,bylaws,benefactor,ballgame,baiting,backstabbing,artifact,airspace,adversary,actin,accuses,accelerant,abundantly,abstinence,zissou,zandt,yapping,witchy,willows,whadaya,vilandra,veiled,undress,undivided,underestimating,ultimatums,twirl,truckload,tremble,toasting,tingling,tents,tempered,sulking,stunk,sponges,spills,softly,snipers,scourge,rooftop,riana,revolting,revisit,refreshments,redecorating,recapture,raysy,pretense,prejudiced,precogs,pouting,poofs,pimple,piles,pediatrician,padre,packets,paces,orvelle,oblivious,objectivity,nighttime,nervosa,mexicans,meurice,melts,matchmaker,maeby,lugosi,lipnik,leprechaun,kissy,kafka,introductions,intestines,inspirational,insightful,inseparable,injections,inadvertently,hussy,huckabees,hittin,hemorrhaging,headin,haystack,hallowed,grudges,granilith,grandkids,grading,gracefully,godsend,gobbles,fragrance,fliers,finchley,farts,eyewitnesses,expendable,existential,dorms,delaying,degrading,deduction,darlings,danes,cylons,counsellor,contraire,consciously,conjuring,congratulating,cokes,buffay,brooch,bitching,bistro,bijou,bewitched,benevolent,bends,bearings,barren,aptitude,amish,amazes,abomination,worldly,whispers,whadda,wayward,wailing,vanishing,upscale,untouchable,unspoken,uncontrollable,unavoidable,unattended,trite,transvestite,toupee,timid,timers,terrorizing,swana,stumped,strolling,storybook,storming,stomachs,stoked,stationery,springtime,spontaneity,spits,spins,soaps,sentiments,scramble,scone,rooftops,retract,reflexes,rawdon,ragged,quirky,quantico,psychologically,prodigal,pounce,potty,pleasantries,pints,petting,perceive,onstage,notwithstanding,nibble,newmans,neutralize,mutilated,millionaires,mayflower,masquerade,mangy,macreedy,lunatics,lovable,locating,limping,lasagna,kwang,keepers,juvie,jaded,ironing,intuitive,intensely,insure,incantation,hysteria,hypnotize,humping,happenin,griet,grasping,glorified,ganging,g'night,focker,flunking,flimsy,flaunting,fixated,fitzwallace,fainting,eyebrow,exonerated,ether,electrician,egotistical,earthly,dusted,dignify,detonation,debrief,dazzling,dan'l,damnedest,daisies,crushes,crucify,contraband,confronting,collapsing,cocked,clicks,cliche,circled,chandelier,carburetor,callers,broads,breathes,bloodshed,blindsided,blabbing,bialystock,bashing,ballerina,aviva,arteries,anomaly,airstrip,agonizing,adjourn,aaaaa,yearning,wrecker,witnessing,whence,warhead,unsure,unheard,unfreeze,unfold,unbalanced,ugliest,troublemaker,toddler,tiptoe,threesome,thirties,thermostat,swipe,surgically,subtlety,stung,stumbling,stubs,stride,strangling,sprayed,socket,smuggled,showering,shhhhh,sabotaging,rumson,rounding,risotto,repairman,rehearsed,ratty,ragging,radiology,racquetball,racking,quieter,quicksand,prowl,prompt,premeditated,prematurely,prancing,porcupine,plated,pinocchio,peeked,peddle,panting,overweight,overrun,outing,outgrown,obsess,nursed,nodding,negativity,negatives,musketeers,mugger,motorcade,merrily,matured,masquerading,marvellous,maniacs,lovey,louse,linger,lilies,lawful,kudos,knuckle,juices,judgments,itches,intolerable,intermission,inept,incarceration,implication,imaginative,huckleberry,holster,heartburn,gunna,groomed,graciously,fulfillment,fugitives,forsaking,forgives,foreseeable,flavors,flares,fixation,fickle,fantasize,famished,fades,expiration,exclamation,erasing,eiffel,eerie,earful,duped,dulles,dissing,dissect,dispenser,dilated,detergent,desdemona,debriefing,damper,curing,crispina,crackpot,courting,cordial,conflicted,comprehension,commie,cleanup,chiropractor,charmer,chariot,cauldron,catatonic,bullied,buckets,brilliantly,breathed,booths,boardroom,blowout,blindness,blazing,biologically,bibles,biased,beseech,barbaric,balraj,audacity,anticipating,alcoholics,airhead,agendas,admittedly,absolution,youre,yippee,wittlesey,withheld,willful,whammy,weakest,washes,virtuous,videotapes,vials,unplugged,unpacked,unfairly,turbulence,tumbling,tricking,tremendously,traitors,torches,tinga,thyroid,teased,tawdry,taker,sympathies,swiped,sundaes,suave,strut,stepdad,spewing,spasm,socialize,slither,simulator,shutters,shrewd,shocks,semantics,schizophrenic,scans,savages,rya'c,runny,ruckus,royally,roadblocks,rewriting,revoke,repent,redecorate,recovers,recourse,ratched,ramali,racquet,quince,quiche,puppeteer,puking,puffed,problemo,praises,pouch,postcards,pooped,poised,piled,phoney,phobia,patching,parenthood,pardner,oozing,ohhhhh,numbing,nostril,nosey,neatly,nappa,nameless,mortuary,moronic,modesty,midwife,mcclane,matuka,maitre,lumps,lucid,loosened,loins,lawnmower,lamotta,kroehner,jinxy,jessep,jamming,jailhouse,jacking,intruders,inhuman,infatuated,indigestion,implore,implanted,hormonal,hoboken,hillbilly,heartwarming,headway,hatched,hartmans,harping,grapevine,gnome,forties,flyin,flirted,fingernail,exhilarating,enjoyment,embark,dumper,dubious,drell,docking,disillusioned,dishonor,disbarred,dicey,custodial,counterproductive,corned,cords,contemplate,concur,conceivable,cobblepot,chickened,checkout,carpe,cap'n,campers,buyin,bullies,braid,boxed,bouncy,blueberries,blubbering,bloodstream,bigamy,beeped,bearable,autographs,alarming,wretch,wimps,widower,whirlwind,whirl,warms,vandelay,unveiling,undoing,unbecoming,turnaround,touche,togetherness,tickles,ticker,teensy,taunt,sweethearts,stitched,standpoint,staffers,spotless,soothe,smothered,sickening,shouted,shepherds,shawl,seriousness,schooled,schoolboy,s'mores,roped,reminders,raggedy,preemptive,plucked,pheromones,particulars,pardoned,overpriced,overbearing,outrun,ohmigod,nosing,nicked,neanderthal,mosquitoes,mortified,milky,messin,mecha,markinson,marivellas,mannequin,manderley,madder,macready,lookie,locusts,lifetimes,lanna,lakhi,kholi,impersonate,hyperdrive,horrid,hopin,hogging,hearsay,harpy,harboring,hairdo,hafta,grasshopper,gobble,gatehouse,foosball,floozy,fished,firewood,finalize,felons,euphemism,entourage,elitist,elegance,drokken,drier,dredge,dossier,diseased,diarrhea,diagnose,despised,defuse,d'amour,contesting,conserve,conscientious,conjured,collars,clogs,chenille,chatty,chamomile,casing,calculator,brittle,breached,blurted,birthing,bikinis,astounding,assaulting,aroma,appliance,antsy,amnio,alienating,aliases,adolescence,xerox,wrongs,workload,willona,whistling,werewolves,wallaby,unwelcome,unseemly,unplug,undermining,ugliness,tyranny,tuesdays,trumpets,transference,ticks,tangible,tagging,swallowing,superheroes,studs,strep,stowed,stomping,steffy,sprain,spouting,sponsoring,sneezing,smeared,slink,shakin,sewed,seatbelt,scariest,scammed,sanctimonious,roasting,rightly,retinal,rethinking,resented,reruns,remover,racks,purest,progressing,presidente,preeclampsia,postponement,portals,poppa,pliers,pinning,pelvic,pampered,padding,overjoyed,ooooo,one'll,octavius,nonono,nicknames,neurosurgeon,narrows,misled,mislead,mishap,milltown,milking,meticulous,mediocrity,meatballs,machete,lurch,layin,knockin,khruschev,jurors,jumpin,jugular,jeweler,intellectually,inquiries,indulging,indestructible,indebted,imitate,ignores,hyperventilating,hyenas,hurrying,hermano,hellish,heheh,harshly,handout,grunemann,glances,giveaway,getup,gerome,furthest,frosting,frail,forwarded,forceful,flavored,flammable,flaky,fingered,fatherly,ethic,embezzlement,duffel,dotted,distressed,disobey,disappearances,dinky,diminish,diaphragm,deuces,creme,courteous,comforts,coerced,clots,clarification,chunks,chickie,chases,chaperoning,cartons,caper,calves,caged,bustin,bulging,bringin,boomhauer,blowin,blindfolded,biscotti,ballplayer,bagging,auster,assurances,aschen,arraigned,anonymity,alters,albatross,agreeable,adoring,abduct,wolfi,weirded,watchers,washroom,warheads,vincennes,urgency,understandably,uncomplicated,uhhhh,twitching,treadmill,thermos,tenorman,tangle,talkative,swarm,surrendering,summoning,strive,stilts,stickers,squashed,spraying,sparring,soaring,snort,sneezed,slaps,skanky,singin,sidle,shreck,shortness,shorthand,sharper,shamed,sadist,rydell,rusik,roulette,resumes,respiration,recount,reacts,purgatory,princesses,presentable,ponytail,plotted,pinot,pigtails,phillippe,peddling,paroled,orbed,offends,o'hara,moonlit,minefield,metaphors,malignant,mainframe,magicks,maggots,maclaine,loathing,leper,leaps,leaping,lashed,larch,larceny,lapses,ladyship,juncture,jiffy,jakov,invoke,infantile,inadmissible,horoscope,hinting,hideaway,hesitating,heddy,heckles,hairline,gripe,gratifying,governess,goebbels,freddo,foresee,fascination,exemplary,executioner,etcetera,escorts,endearing,eaters,earplugs,draped,disrupting,disagrees,dimes,devastate,detain,depositions,delicacy,darklighter,cynicism,cyanide,cutters,cronus,continuance,conquering,confiding,compartments,combing,cofell,clingy,cleanse,christmases,cheered,cheekbones,buttle,burdened,bruenell,broomstick,brained,bozos,bontecou,bluntman,blazes,blameless,bizarro,bellboy,beaucoup,barkeep,awaken,astray,assailant,appease,aphrodisiac,alleys,yesss,wrecks,woodpecker,wondrous,wimpy,willpower,wheeling,weepy,waxing,waive,videotaped,veritable,untouched,unlisted,unfounded,unforeseen,twinge,triggers,traipsing,toxin,tombstone,thumping,therein,testicles,telephones,tarmac,talby,tackled,swirling,suicides,suckered,subtitles,sturdy,strangler,stockbroker,stitching,steered,standup,squeal,sprinkler,spontaneously,splendor,spiking,spender,snipe,snagged,skimming,siddown,showroom,shovels,shotguns,shoelaces,shitload,shellfish,sharpest,shadowy,seizing,scrounge,scapegoat,sayonara,saddled,rummaging,roomful,renounce,reconsidered,recharge,realistically,radioed,quirks,quadrant,punctual,practising,pours,poolhouse,poltergeist,pocketbook,plainly,picnics,pesto,pawing,passageway,partied,oneself,numero,nostalgia,nitwit,neuro,mixer,meanest,mcbeal,matinee,margate,marce,manipulations,manhunt,manger,magicians,loafers,litvack,lightheaded,lifeguard,lawns,laughingstock,ingested,indignation,inconceivable,imposition,impersonal,imbecile,huddled,housewarming,horizons,homicides,hiccups,hearse,hardened,gushing,gushie,greased,goddamit,freelancer,forging,fondue,flustered,flung,flinch,flicker,fixin,festivus,fertilizer,farted,faggots,exonerate,evict,enormously,encrypted,emdash,embracing,duress,dupres,dowser,doormat,disfigured,disciplined,dibbs,depository,deathbed,dazzled,cuttin,cures,crowding,crepe,crammed,copycat,contradict,confidant,condemning,conceited,commute,comatose,clapping,circumference,chuppah,chore,choksondik,chestnuts,briault,bottomless,bonnet,blokes,berluti,beret,beggars,bankroll,bania,athos,arsenic,apperantly,ahhhhhh,afloat,accents,zipped,zeros,zeroes,zamir,yuppie,youngsters,yorkers,wisest,wipes,wield,whyn't,weirdos,wednesdays,vicksburg,upchuck,untraceable,unsupervised,unpleasantness,unhook,unconscionable,uncalled,trappings,tragedies,townie,thurgood,things'll,thine,tetanus,terrorize,temptations,tanning,tampons,swarming,straitjacket,steroid,startling,starry,squander,speculating,sollozzo,sneaked,slugs,skedaddle,sinker,silky,shortcomings,sellin,seasoned,scrubbed,screwup,scrapes,scarves,sandbox,salesmen,rooming,romances,revere,reproach,reprieve,rearranging,ravine,rationalize,raffle,punchy,psychobabble,provocation,profoundly,prescriptions,preferable,polishing,poached,pledges,pirelli,perverts,oversized,overdressed,outdid,nuptials,nefarious,mouthpiece,motels,mopping,mongrel,missin,metaphorically,mertin,memos,melodrama,melancholy,measles,meaner,mantel,maneuvering,mailroom,luring,listenin,lifeless,licks,levon,legwork,kneecaps,kippur,kiddie,kaput,justifiable,insistent,insidious,innuendo,innit,indecent,imaginable,horseshit,hemorrhoid,hella,healthiest,haywire,hamsters,hairbrush,grouchy,grisly,gratuitous,glutton,glimmer,gibberish,ghastly,gentler,generously,geeky,fuhrer,fronting,foolin,faxes,faceless,extinguisher,expel,etched,endangering,ducked,dodgeball,dives,dislocated,discrepancy,devour,derail,dementia,daycare,cynic,crumbling,cowardice,covet,cornwallis,corkscrew,cookbook,commandments,coincidental,cobwebs,clouded,clogging,clicking,clasp,chopsticks,chefs,chaps,cashing,carat,calmer,brazen,brainwashing,bradys,bowing,boned,bloodsucking,bleachers,bleached,bedpan,bearded,barrenger,bachelors,awwww,assures,assigning,asparagus,apprehend,anecdote,amoral,aggravation,afoot,acquaintances,accommodating,yakking,worshipping,wladek,willya,willies,wigged,whoosh,whisked,watered,warpath,volts,violates,valuables,uphill,unwise,untimely,unsavory,unresponsive,unpunished,unexplained,tubby,trolling,toxicology,tormented,toothache,tingly,timmiihh,thursdays,thoreau,terrifies,temperamental,telegrams,talkie,takers,symbiote,swirl,suffocate,stupider,strapping,steckler,springing,someway,sleepyhead,sledgehammer,slant,slams,showgirl,shoveling,shmoopy,sharkbait,shan't,scrambling,schematics,sandeman,sabbatical,rummy,reykjavik,revert,responsive,rescheduled,requisition,relinquish,rejoice,reckoning,recant,rebadow,reassurance,rattlesnake,ramble,primed,pricey,prance,pothole,pocus,persist,perpetrated,pekar,peeling,pastime,parmesan,pacemaker,overdrive,ominous,observant,nothings,noooooo,nonexistent,nodded,nieces,neglecting,nauseating,mutated,musket,mumbling,mowing,mouthful,mooseport,monologue,mistrust,meetin,masseuse,mantini,mailer,madre,lowlifes,locksmith,livid,liven,limos,liberating,lhasa,leniency,leering,laughable,lashes,lasagne,laceration,korben,katan,kalen,jittery,jammies,irreplaceable,intubate,intolerant,inhaler,inhaled,indifferent,indifference,impound,impolite,humbly,heroics,heigh,guillotine,guesthouse,grounding,grips,gossiping,goatee,gnomes,gellar,frutt,frobisher,freudian,foolishness,flagged,femme,fatso,fatherhood,fantasized,fairest,faintest,eyelids,extravagant,extraterrestrial,extraordinarily,escalator,elevate,drivel,dissed,dismal,disarray,dinnertime,devastation,dermatologist,delicately,defrost,debutante,debacle,damone,dainty,cuvee,culpa,crucified,creeped,crayons,courtship,convene,congresswoman,concocted,compromises,comprende,comma,coleslaw,clothed,clinically,chickenshit,checkin,cesspool,caskets,calzone,brothel,boomerang,bodega,blasphemy,bitsy,bicentennial,berlini,beatin,beards,barbas,barbarians,backpacking,arrhythmia,arousing,arbitrator,antagonize,angling,anesthetic,altercation,aggressor,adversity,acathla,aaahhh,wreaking,workup,wonderin,wither,wielding,what'm,what'cha,waxed,vibrating,veterinarian,venting,vasey,valor,validate,upholstery,untied,unscathed,uninterrupted,unforgiving,undies,uncut,twinkies,tucking,treatable,treasured,tranquility,townspeople,torso,tomei,tipsy,tinsel,tidings,thirtieth,tantrums,tamper,talky,swayed,swapping,suitor,stylist,stirs,standoff,sprinklers,sparkly,snobby,snatcher,smoother,sleepin,shrug,shoebox,sheesh,shackles,setbacks,sedatives,screeching,scorched,scanned,satyr,roadblock,riverbank,ridiculed,resentful,repellent,recreate,reconvene,rebuttal,realmedia,quizzes,questionnaire,punctured,pucker,prolong,professionalism,pleasantly,pigsty,penniless,paychecks,patiently,parading,overactive,ovaries,orderlies,oracles,oiled,offending,nudie,neonatal,neighborly,moops,moonlighting,mobilize,mmmmmm,milkshake,menial,meats,mayan,maxed,mangled,magua,lunacy,luckier,liters,lansbury,kooky,knowin,jeopardized,inkling,inhalation,inflated,infecting,incense,inbound,impractical,impenetrable,idealistic,i'mma,hypocrites,hurtin,humbled,hologram,hokey,hocus,hitchhiking,hemorrhoids,headhunter,hassled,harts,hardworking,haircuts,hacksaw,genitals,gazillion,gammy,gamesphere,fugue,footwear,folly,flashlights,fives,filet,extenuating,estrogen,entails,embezzled,eloquent,egomaniac,ducts,drowsy,drones,doree,donovon,disguises,diggin,deserting,depriving,defying,deductible,decorum,decked,daylights,daybreak,dashboard,damnation,cuddling,crunching,crickets,crazies,councilman,coughed,conundrum,complimented,cohaagen,clutching,clued,clader,cheques,checkpoint,chats,channeling,ceases,carasco,capisce,cantaloupe,cancelling,campsite,burglars,breakfasts,bra'tac,blueprint,bleedin,blabbed,beneficiary,basing,avert,atone,arlyn,approves,apothecary,antiseptic,aleikuum,advisement,zadir,wobbly,withnail,whattaya,whacking,wedged,wanders,vaginal,unimaginable,undeniable,unconditionally,uncharted,unbridled,tweezers,tvmegasite,trumped,triumphant,trimming,treading,tranquilizers,toontown,thunk,suture,suppressing,strays,stonewall,stogie,stepdaughter,stace,squint,spouses,splashed,speakin,sounder,sorrier,sorrel,sombrero,solemnly,softened,snobs,snippy,snare,smoothing,slump,slimeball,slaving,silently,shiller,shakedown,sensations,scrying,scrumptious,screamin,saucy,santoses,roundup,roughed,rosary,robechaux,retrospect,rescind,reprehensible,repel,remodeling,reconsidering,reciprocate,railroaded,psychics,promos,prob'ly,pristine,printout,priestess,prenuptial,precedes,pouty,phoning,peppy,pariah,parched,panes,overloaded,overdoing,nymphs,nother,notebooks,nearing,nearer,monstrosity,milady,mieke,mephesto,medicated,marshals,manilow,mammogram,m'lady,lotsa,loopy,lesion,lenient,learner,laszlo,kross,kinks,jinxed,involuntary,insubordination,ingrate,inflatable,incarnate,inane,hypoglycemia,huntin,humongous,hoodlum,honking,hemorrhage,helpin,hathor,hatching,grotto,grandmama,gorillas,godless,girlish,ghouls,gershwin,frosted,flutter,flagpole,fetching,fatter,faithfully,exert,evasion,escalate,enticing,enchantress,elopement,drills,downtime,downloading,dorks,doorways,divulge,dissociative,disgraceful,disconcerting,deteriorate,destinies,depressive,dented,denim,decruz,decidedly,deactivate,daydreams,curls,culprit,cruelest,crippling,cranberries,corvis,copped,commend,coastguard,cloning,cirque,churning,chock,chivalry,catalogues,cartwheels,carols,canister,buttered,bundt,buljanoff,bubbling,brokers,broaden,brimstone,brainless,bores,badmouthing,autopilot,ascertain,aorta,ampata,allenby,accosted,absolve,aborted,aaagh,aaaaaah,yonder,yellin,wyndham,wrongdoing,woodsboro,wigging,wasteland,warranty,waltzed,walnuts,vividly,veggie,unnecessarily,unloaded,unicorns,understated,unclean,umbrellas,twirling,turpentine,tupperware,triage,treehouse,tidbit,tickled,threes,thousandth,thingie,terminally,teething,tassel,talkies,swoon,switchboard,swerved,suspiciously,subsequentlyne,subscribe,strudel,stroking,strictest,stensland,starin,stannart,squirming,squealing,sorely,softie,snookums,sniveling,smidge,sloth,skulking,simian,sightseeing,siamese,shudder,shoppers,sharpen,shannen,semtex,secondhand,seance,scowl,scorn,safekeeping,russe,rummage,roshman,roomies,roaches,rinds,retrace,retires,resuscitate,rerun,reputations,rekall,refreshment,reenactment,recluse,ravioli,raves,raking,purses,punishable,punchline,puked,prosky,previews,poughkeepsie,poppins,polluted,placenta,pissy,petulant,perseverance,pears,pawns,pastries,partake,panky,palate,overzealous,orchids,obstructing,objectively,obituaries,obedient,nothingness,musty,motherly,mooning,momentous,mistaking,minutemen,milos,microchip,meself,merciless,menelaus,mazel,masturbate,mahogany,lysistrata,lillienfield,likable,liberate,leveled,letdown,larynx,lardass,lainey,lagged,klorel,kidnappings,keyed,karmic,jeebies,irate,invulnerable,intrusive,insemination,inquire,injecting,informative,informants,impure,impasse,imbalance,illiterate,hurled,hunts,hematoma,headstrong,handmade,handiwork,growling,gorky,getcha,gesundheit,gazing,galley,foolishly,fondness,floris,ferocious,feathered,fateful,fancies,fakes,faker,expire,ever'body,essentials,eskimos,enlightening,enchilada,emissary,embolism,elsinore,ecklie,drenched,drazi,doped,dogging,doable,dislikes,dishonesty,disengage,discouraging,derailed,deformed,deflect,defer,deactivated,crips,constellations,congressmen,complimenting,clubbing,clawing,chromium,chimes,chews,cheatin,chaste,cellblock,caving,catered,catacombs,calamari,bucking,brulee,brits,brisk,breezes,bounces,boudoir,binks,better'n,bellied,behrani,behaves,bedding,balmy,badmouth,backers,avenging,aromatherapy,armpit,armoire,anythin,anonymously,anniversaries,aftershave,affliction,adrift,admissible,adieu,acquittal,yucky,yearn,whitter,whirlpool,wendigo,watchdog,wannabes,wakey,vomited,voicemail,valedictorian,uttered,unwed,unrequited,unnoticed,unnerving,unkind,unjust,uniformed,unconfirmed,unadulterated,unaccounted,uglier,turnoff,trampled,tramell,toads,timbuktu,throwback,thimble,tasteless,tarantula,tamale,takeovers,swish,supposing,streaking,stargher,stanzi,stabs,squeamish,splattered,spiritually,spilt,speciality,smacking,skywire,skips,skaara,simpatico,shredding,showin,shortcuts,shite,shielding,shamelessly,serafine,sentimentality,seasick,schemer,scandalous,sainted,riedenschneider,rhyming,revel,retractor,retards,resurrect,remiss,reminiscing,remanded,reiben,regains,refuel,refresher,redoing,redheaded,reassured,rearranged,rapport,qumar,prowling,prejudices,precarious,powwow,pondering,plunger,plunged,pleasantville,playpen,phlegm,perfected,pancreas,paley,ovary,outbursts,oppressed,ooohhh,omoroca,offed,o'toole,nurture,nursemaid,nosebleed,necktie,muttering,munchies,mucking,mogul,mitosis,misdemeanor,miscarried,millionth,migraines,midler,manicurist,mandelbaum,manageable,malfunctioned,magnanimous,loudmouth,longed,lifestyles,liddy,lickety,leprechauns,komako,klute,kennel,justifying,irreversible,inventing,intergalactic,insinuate,inquiring,ingenuity,inconclusive,incessant,improv,impersonation,hyena,humperdinck,hubba,housework,hoffa,hither,hissy,hippy,hijacked,heparin,hellooo,hearth,hassles,hairstyle,hahahaha,hadda,guys'll,gutted,gulls,gritty,grievous,graft,gossamer,gooder,gambled,gadgets,fundamentals,frustrations,frolicking,frock,frilly,foreseen,footloose,fondly,flirtation,flinched,flatten,farthest,exposer,evading,escrow,empathize,embryos,embodiment,ellsberg,ebola,dulcinea,dreamin,drawbacks,doting,doose,doofy,disturbs,disorderly,disgusts,detox,denominator,demeanor,deliriously,decode,debauchery,croissant,cravings,cranked,coworkers,councilor,confuses,confiscate,confines,conduit,compress,combed,clouding,clamps,cinch,chinnery,celebratory,catalogs,carpenters,carnal,canin,bundys,bulldozer,buggers,bueller,brainy,booming,bookstores,bloodbath,bittersweet,bellhop,beeping,beanstalk,beady,baudelaire,bartenders,bargains,averted,armadillo,appreciating,appraised,antlers,aloof,allowances,alleyway,affleck,abject,zilch,youore,xanax,wrenching,wouldn,witted,wicca,whorehouse,whooo,whips,vouchers,victimized,vicodin,untested,unsolicited,unfocused,unfettered,unfeeling,unexplainable,understaffed,underbelly,tutorial,tryst,trampoline,towering,tirade,thieving,thang,swimmin,swayzak,suspecting,superstitions,stubbornness,streamers,strattman,stonewalling,stiffs,stacking,spout,splice,sonrisa,smarmy,slows,slicing,sisterly,shrill,shined,seeming,sedley,seatbelts,scour,scold,schoolyard,scarring,salieri,rustling,roxbury,rewire,revved,retriever,reputable,remodel,reins,reincarnation,rance,rafters,rackets,quail,pumbaa,proclaim,probing,privates,pried,prewedding,premeditation,posturing,posterity,pleasurable,pizzeria,pimps,penmanship,penchant,pelvis,overturn,overstepped,overcoat,ovens,outsmart,outed,ooohh,oncologist,omission,offhand,odour,nyazian,notarized,nobody'll,nightie,navel,nabbed,mystique,mover,mortician,morose,moratorium,mockingbird,mobsters,mingling,methinks,messengered,merde,masochist,martouf,martians,marinara,manray,majorly,magnifying,mackerel,lurid,lugging,lonnegan,loathsome,llantano,liberace,leprosy,latinos,lanterns,lamest,laferette,kraut,intestine,innocencia,inhibitions,ineffectual,indisposed,incurable,inconvenienced,inanimate,improbable,implode,hydrant,hustling,hustled,huevos,how'm,hooey,hoods,honcho,hinge,hijack,heimlich,hamunaptra,haladki,haiku,haggle,gutsy,grunting,grueling,gribbs,greevy,grandstanding,godparents,glows,glistening,gimmick,gaping,fraiser,formalities,foreigner,folders,foggy,fitty,fiends,fe'nos,favours,eyeing,extort,expedite,escalating,epinephrine,entitles,entice,eminence,eights,earthlings,eagerly,dunville,dugout,doublemeat,doling,dispensing,dispatcher,discoloration,diners,diddly,dictates,diazepam,derogatory,delights,defies,decoder,dealio,danson,cutthroat,crumbles,croissants,crematorium,craftsmanship,could'a,cordless,cools,conked,confine,concealing,complicates,communique,cockamamie,coasters,clobbered,clipping,clipboard,clemenza,cleanser,circumcision,chanukah,certainaly,cellmate,cancels,cadmium,buzzed,bumstead,bucko,browsing,broth,braver,boggling,bobbing,blurred,birkhead,benet,belvedere,bellies,begrudge,beckworth,banky,baldness,baggy,babysitters,aversion,astonished,assorted,appetites,angina,amiss,ambulances,alibis,airway,admires,adhesive,yoyou,xxxxxx,wreaked,wracking,woooo,wooing,wised,wilshire,wedgie,waging,violets,vincey,uplifting,untrustworthy,unmitigated,uneventful,undressing,underprivileged,unburden,umbilical,tweaking,turquoise,treachery,tosses,torching,toothpick,toasts,thickens,tereza,tenacious,teldar,taint,swill,sweatin,subtly,subdural,streep,stopwatch,stockholder,stillwater,stalkers,squished,squeegee,splinters,spliced,splat,spied,spackle,sophistication,snapshots,smite,sluggish,slithered,skeeters,sidewalks,sickly,shrugs,shrubbery,shrieking,shitless,settin,sentinels,selfishly,scarcely,sangria,sanctum,sahjhan,rustle,roving,rousing,rosomorf,riddled,responsibly,renoir,remoray,remedial,refundable,redirect,recheck,ravenwood,rationalizing,ramus,ramelle,quivering,pyjamas,psychos,provocations,prouder,protestors,prodded,proctologist,primordial,pricks,prickly,precedents,pentangeli,pathetically,parka,parakeet,panicky,overthruster,outsmarted,orthopedic,oncoming,offing,nutritious,nuthouse,nourishment,nibbling,newlywed,narcissist,mutilation,mundane,mummies,mumble,mowed,morvern,mortem,mopes,molasses,misplace,miscommunication,miney,midlife,menacing,memorizing,massaging,masking,magnets,luxuries,lounging,lothario,liposuction,lidocaine,libbets,levitate,leeway,launcelot,larek,lackeys,kumbaya,kryptonite,knapsack,keyhole,katarangura,juiced,jakey,ironclad,invoice,intertwined,interlude,interferes,injure,infernal,indeedy,incur,incorrigible,incantations,impediment,igloo,hysterectomy,hounded,hollering,hindsight,heebie,havesham,hasenfuss,hankering,hangers,hakuna,gutless,gusto,grubbing,grrrr,grazed,gratification,grandeur,gorak,godammit,gnawing,glanced,frostbite,frees,frazzled,fraulein,fraternizing,fortuneteller,formaldehyde,followup,foggiest,flunky,flickering,firecrackers,figger,fetuses,fates,eyeliner,extremities,extradited,expires,exceedingly,evaporate,erupt,epileptic,entrails,emporium,egregious,eggshells,easing,duwayne,droll,dreyfuss,dovey,doubly,doozy,donkeys,donde,distrust,distressing,disintegrate,discreetly,decapitated,dealin,deader,dashed,darkroom,dares,daddies,dabble,cushy,cupcakes,cuffed,croupier,croak,crapped,coursing,coolers,contaminate,consummated,construed,condos,concoction,compulsion,commish,coercion,clemency,clairvoyant,circulate,chesterton,checkered,charlatan,chaperones,categorically,cataracts,carano,capsules,capitalize,burdon,bullshitting,brewed,breathless,breasted,brainstorming,bossing,borealis,bonsoir,bobka,boast,blimp,bleep,bleeder,blackouts,bisque,billboards,beatings,bayberry,bashed,bamboozled,balding,baklava,baffled,backfires,babak,awkwardness,attest,attachments,apologizes,anyhoo,antiquated,alcante,advisable,aahhh,aaahh,zatarc,yearbooks,wuddya,wringing,womanhood,witless,winging,whatsa,wetting,waterproof,wastin,vogelman,vocation,vindicated,vigilance,vicariously,venza,vacuuming,utensils,uplink,unveil,unloved,unloading,uninhibited,unattached,tweaked,turnips,trinkets,toughen,toting,topside,terrors,terrify,technologically,tarnish,tagliati,szpilman,surly,supple,summation,suckin,stepmom,squeaking,splashmore,souffle,solitaire,solicitation,solarium,smokers,slugged,slobbering,skylight,skimpy,sinuses,silenced,sideburns,shrinkage,shoddy,shhhhhh,shelled,shareef,shangri,seuss,serenade,scuffle,scoff,scanners,sauerkraut,sardines,sarcophagus,salvy,rusted,russells,rowboat,rolfsky,ringside,respectability,reparations,renegotiate,reminisce,reimburse,regimen,raincoat,quibble,puzzled,purposefully,pubic,proofing,prescribing,prelim,poisons,poaching,personalized,personable,peroxide,pentonville,payphone,payoffs,paleontology,overflowing,oompa,oddest,objecting,o'hare,o'daniel,notches,nobody'd,nightstand,neutralized,nervousness,nerdy,needlessly,naquadah,nappy,nantucket,nambla,mountaineer,motherfuckin,morrie,monopolizing,mohel,mistreated,misreading,misbehave,miramax,minivan,milligram,milkshakes,metamorphosis,medics,mattresses,mathesar,matchbook,matata,marys,malucci,magilla,lymphoma,lowers,lordy,linens,lindenmeyer,limelight,leapt,laxative,lather,lapel,lamppost,laguardia,kindling,kegger,kawalsky,juries,jokin,jesminder,interning,innermost,injun,infallible,industrious,indulgence,incinerator,impossibility,impart,illuminate,iguanas,hypnotic,hyped,hospitable,hoses,homemaker,hirschmuller,helpers,headset,guardianship,guapo,grubby,granola,granddaddy,goren,goblet,gluttony,globes,giorno,getter,geritol,gassed,gaggle,foxhole,fouled,foretold,floorboards,flippers,flaked,fireflies,feedings,fashionably,farragut,fallback,facials,exterminate,excites,everything'll,evenin,ethically,ensue,enema,empath,eluded,eloquently,eject,edema,dumpling,droppings,dolled,distasteful,disputing,displeasure,disdain,deterrent,dehydration,defied,decomposing,dawned,dailies,custodian,crusts,crucifix,crowning,crier,crept,craze,crawls,couldn,correcting,corkmaster,copperfield,cooties,contraption,consumes,conspire,consenting,consented,conquers,congeniality,complains,communicator,commendable,collide,coladas,colada,clout,clooney,classifieds,clammy,civility,cirrhosis,chink,catskills,carvers,carpool,carelessness,cardio,carbs,capades,butabi,busmalis,burping,burdens,bunks,buncha,bulldozers,browse,brockovich,breakthroughs,bravado,boogety,blossoms,blooming,bloodsucker,blight,betterton,betrayer,belittle,beeps,bawling,barts,bartending,bankbooks,babish,atropine,assertive,armbrust,anyanka,annoyance,anemic,anago,airwaves,aimlessly,aaargh,aaand,yoghurt,writhing,workable,winking,winded,widen,whooping,whiter,whatya,wazoo,voila,virile,vests,vestibule,versed,vanishes,urkel,uproot,unwarranted,unscheduled,unparalleled,undergrad,tweedle,turtleneck,turban,trickery,transponder,toyed,townhouse,thyself,thunderstorm,thinning,thawed,tether,technicalities,tau'ri,tarnished,taffeta,tacked,systolic,swerve,sweepstakes,swabs,suspenders,superwoman,sunsets,succulent,subpoenas,stumper,stosh,stomachache,stewed,steppin,stepatech,stateside,spicoli,sparing,soulless,sonnets,sockets,snatching,smothering,slush,sloman,slashing,sitters,simpleton,sighs,sidra,sickens,shunned,shrunken,showbiz,shopped,shimmering,shagging,semblance,segue,sedation,scuzzlebutt,scumbags,screwin,scoundrels,scarsdale,scabs,saucers,saintly,saddened,runaways,runaround,rheya,resenting,rehashing,rehabilitated,regrettable,refreshed,redial,reconnecting,ravenous,raping,rafting,quandary,pylea,putrid,puffing,psychopathic,prunes,probate,prayin,pomegranate,plummeting,planing,plagues,pinata,pithy,perversion,personals,perched,peeps,peckish,pavarotti,pajama,packin,pacifier,overstepping,okama,obstetrician,nutso,nuance,normalcy,nonnegotiable,nomak,ninny,nines,nicey,newsflash,neutered,nether,negligee,necrosis,navigating,narcissistic,mylie,muses,momento,moisturizer,moderation,misinformed,misconception,minnifield,mikkos,methodical,mebbe,meager,maybes,matchmaking,masry,markovic,malakai,luzhin,lusting,lumberjack,loopholes,loaning,lightening,leotard,launder,lamaze,kubla,kneeling,kibosh,jumpsuit,joliet,jogger,janover,jakovasaurs,irreparable,innocently,inigo,infomercial,inexplicable,indispensable,impregnated,impossibly,imitating,hunches,hummus,houmfort,hothead,hostiles,hooves,hooligans,homos,homie,hisself,heyyy,hesitant,hangout,handsomest,handouts,hairless,gwennie,guzzling,guinevere,grungy,goading,glaring,gavel,gardino,gangrene,fruitful,friendlier,freckle,freakish,forthright,forearm,footnote,flops,fixer,firecracker,finito,figgered,fezzik,fastened,farfetched,fanciful,familiarize,faire,fahrenheit,extravaganza,exploratory,explanatory,everglades,eunuch,estas,escapade,erasers,emptying,embarassing,dweeb,dutiful,dumplings,dries,drafty,dollhouse,dismissing,disgraced,discrepancies,disbelief,disagreeing,digestion,didnt,deviled,deviated,demerol,delectable,decaying,decadent,dears,dateless,d'algout,cultivating,cryto,crumpled,crumbled,cronies,crease,craves,cozying,corduroy,congratulated,confidante,compressions,complicating,compadre,coerce,classier,chums,chumash,chivalrous,chinpoko,charred,chafing,celibacy,carted,carryin,carpeting,carotid,cannibals,candor,butterscotch,busts,busier,bullcrap,buggin,brookside,brodski,brassiere,brainwash,brainiac,botrelle,bonbon,boatload,blimey,blaring,blackness,bipartisan,bimbos,bigamist,biebe,biding,betrayals,bestow,bellerophon,bedpans,bassinet,basking,barzini,barnyard,barfed,backups,audited,asinine,asalaam,arouse,applejack,annoys,anchovies,ampule,alameida,aggravate,adage,accomplices,yokel,y'ever,wringer,witwer,withdrawals,windward,willfully,whorfin,whimsical,whimpering,weddin,weathered,warmest,wanton,volant,visceral,vindication,veggies,urinate,uproar,unwritten,unwrap,unsung,unsubstantiated,unspeakably,unscrupulous,unraveling,unquote,unqualified,unfulfilled,undetectable,underlined,unattainable,unappreciated,ummmm,ulcers,tylenol,tweak,turnin,tuatha,tropez,trellis,toppings,tootin,toodle,tinkering,thrives,thespis,theatrics,thatherton,tempers,tavington,tartar,tampon,swelled,sutures,sustenance,sunflowers,sublet,stubbins,strutting,strewn,stowaway,stoic,sternin,stabilizing,spiraling,spinster,speedometer,speakeasy,soooo,soiled,sneakin,smithereens,smelt,smacks,slaughterhouse,slacks,skids,sketching,skateboards,sizzling,sixes,sirree,simplistic,shouts,shorted,shoelace,sheeit,shards,shackled,sequestered,selmak,seduces,seclusion,seamstress,seabeas,scoops,scooped,scavenger,satch,s'more,rudeness,romancing,rioja,rifkin,rieper,revise,reunions,repugnant,replicating,repaid,renewing,relaxes,rekindle,regrettably,regenerate,reels,reciting,reappear,readin,ratting,rapes,rancher,rammed,rainstorm,railroading,queers,punxsutawney,punishes,pssst,prudy,proudest,protectors,procrastinating,proactive,priss,postmortem,pompoms,poise,pickings,perfectionist,peretti,people'll,pecking,patrolman,paralegal,paragraphs,paparazzi,pankot,pampering,overstep,overpower,outweigh,omnipotent,odious,nuwanda,nurtured,newsroom,neeson,needlepoint,necklaces,neato,muggers,muffler,mousy,mourned,mosey,mopey,mongolians,moldy,misinterpret,minibar,microfilm,mendola,mended,melissande,masturbating,masbath,manipulates,maimed,mailboxes,magnetism,m'lord,m'honey,lymph,lunge,lovelier,lefferts,leezak,ledgers,larraby,laloosh,kundun,kozinski,knockoff,kissin,kiosk,kennedys,kellman,karlo,kaleidoscope,jeffy,jaywalking,instructing,infraction,informer,infarction,impulsively,impressing,impersonated,impeach,idiocy,hyperbole,hurray,humped,huhuh,hsing,hordes,hoodlums,honky,hitchhiker,hideously,heaving,heathcliff,headgear,headboard,hazing,harem,handprint,hairspray,gutiurrez,goosebumps,gondola,glitches,gasping,frolic,freeways,frayed,fortitude,forgetful,forefathers,fonder,foiled,foaming,flossing,flailing,fitzgeralds,firehouse,finders,fiftieth,fellah,fawning,farquaad,faraway,fancied,extremists,exorcist,exhale,ethros,entrust,ennui,energized,encephalitis,embezzling,elster,elixir,electrolytes,duplex,dryers,drexl,dredging,drawback,don'ts,dobisch,divorcee,disrespected,disprove,disobeying,disinfectant,dingy,digress,dieting,dictating,devoured,devise,detonators,desist,deserter,derriere,deron,deceptive,debilitating,deathwok,daffodils,curtsy,cursory,cuppa,cumin,cronkite,cremation,credence,cranking,coverup,courted,countin,counselling,cornball,contentment,consensual,compost,cluett,cleverly,cleansed,cleanliness,chopec,chomp,chins,chime,cheswick,chessler,cheapest,chatted,cauliflower,catharsis,catchin,caress,camcorder,calorie,cackling,bystanders,buttoned,buttering,butted,buries,burgel,buffoon,brogna,bragged,boutros,bogeyman,blurting,blurb,blowup,bloodhound,blissful,birthmark,bigot,bestest,belted,belligerent,beggin,befall,beeswax,beatnik,beaming,barricade,baggoli,badness,awoke,artsy,artful,aroun,armpits,arming,annihilate,anise,angiogram,anaesthetic,amorous,ambiance,alligators,adoration,admittance,adama,abydos,zonked,zhivago,yorkin,wrongfully,writin,wrappers,worrywart,woops,wonderfalls,womanly,wickedness,whoopie,wholeheartedly,whimper,which'll,wheelchairs,what'ya,warranted,wallop,wading,wacked,virginal,vermouth,vermeil,verger,ventriss,veneer,vampira,utero,ushers,urgently,untoward,unshakable,unsettled,unruly,unlocks,ungodly,undue,uncooperative,uncontrollably,unbeatable,twitchy,tumbler,truest,triumphs,triplicate,tribbey,tortures,tongaree,tightening,thorazine,theres,testifies,teenaged,tearful,taxing,taldor,syllabus,swoops,swingin,suspending,sunburn,stuttering,stupor,strides,strategize,strangulation,stooped,stipulation,stingy,stapled,squeaks,squawking,spoilsport,splicing,spiel,spencers,spasms,spaniard,softener,sodding,soapbox,smoldering,smithbauer,skittish,sifting,sickest,sicilians,shuffling,shrivel,segretti,seeping,securely,scurrying,scrunch,scrote,screwups,schenkman,sawing,savin,satine,sapiens,salvaging,salmonella,sacrilege,rumpus,ruffle,roughing,rotted,rondall,ridding,rickshaw,rialto,rhinestone,restrooms,reroute,requisite,repress,rednecks,redeeming,rayed,ravell,raked,raincheck,raffi,racked,pushin,profess,prodding,procure,presuming,preppy,prednisone,potted,posttraumatic,poorhouse,podiatrist,plowed,pledging,playroom,plait,placate,pinback,picketing,photographing,pharoah,petrak,petal,persecuting,perchance,pellets,peeved,peerless,payable,pauses,pathologist,pagliacci,overwrought,overreaction,overqualified,overheated,outcasts,otherworldly,opinionated,oodles,oftentimes,occured,obstinate,nutritionist,numbness,nubile,nooooooo,nobodies,nepotism,neanderthals,mushu,mucus,mothering,mothballs,monogrammed,molesting,misspoke,misspelled,misconstrued,miscalculated,minimums,mince,mildew,mighta,middleman,mementos,mellowed,mayol,mauled,massaged,marmalade,mardi,makings,lundegaard,lovingly,loudest,lotto,loosing,loompa,looming,longs,loathes,littlest,littering,lifelike,legalities,laundered,lapdog,lacerations,kopalski,knobs,knitted,kittridge,kidnaps,kerosene,karras,jungles,jockeys,iranoff,invoices,invigorating,insolence,insincere,insectopia,inhumane,inhaling,ingrates,infestation,individuality,indeterminate,incomprehensible,inadequacy,impropriety,importer,imaginations,illuminating,ignite,hysterics,hypodermic,hyperventilate,hyperactive,humoring,honeymooning,honed,hoist,hoarding,hitching,hiker,hightail,hemoglobin,hell'd,heinie,growin,grasped,grandparent,granddaughters,gouged,goblins,gleam,glades,gigantor,get'em,geriatric,gatekeeper,gargoyles,gardenias,garcon,garbo,gallows,gabbing,futon,fulla,frightful,freshener,fortuitous,forceps,fogged,fodder,foamy,flogging,flaun,flared,fireplaces,feverish,favell,fattest,fattening,fallow,extraordinaire,evacuating,errant,envied,enchant,enamored,egocentric,dussander,dunwitty,dullest,dropout,dredged,dorsia,doornail,donot,dongs,dogged,dodgy,ditty,dishonorable,discriminating,discontinue,dings,dilly,dictation,dialysis,delly,delightfully,daryll,dandruff,cruddy,croquet,cringe,crimp,credo,crackling,courtside,counteroffer,counterfeiting,corrupting,copping,conveyor,contusions,contusion,conspirator,consoling,connoisseur,confetti,composure,compel,colic,coddle,cocksuckers,coattails,cloned,claustrophobia,clamoring,churn,chugga,chirping,chasin,chapped,chalkboard,centimeter,caymans,catheter,casings,caprica,capelli,cannolis,cannoli,camogli,camembert,butchers,butchered,busboys,bureaucrats,buckled,bubbe,brownstone,bravely,brackley,bouquets,botox,boozing,boosters,bodhi,blunders,blunder,blockage,biocyte,betrays,bested,beryllium,beheading,beggar,begbie,beamed,bastille,barstool,barricades,barbecues,barbecued,bandwagon,backfiring,bacarra,avenged,autopsies,aunties,associating,artichoke,arrowhead,appendage,apostrophe,antacid,ansel,annul,amuses,amped,amicable,amberg,alluring,adversaries,admirers,adlai,acupuncture,abnormality,aaaahhhh,zooming,zippity,zipping,zeroed,yuletide,yoyodyne,yengeese,yeahhh,wrinkly,wracked,withered,winks,windmills,whopping,wendle,weigart,waterworks,waterbed,watchful,wantin,wagging,waaah,vying,ventricle,varnish,vacuumed,unreachable,unprovoked,unmistakable,unfriendly,unfolding,underpaid,uncuff,unappealing,unabomber,typhoid,tuxedos,tushie,turds,tumnus,troubadour,trinium,treaters,treads,transpired,transgression,tought,thready,thins,thinners,techs,teary,tattaglia,tassels,tarzana,tanking,tablecloths,synchronize,symptomatic,sycophant,swimmingly,sweatshop,surfboard,superpowers,sunroom,sunblock,sugarplum,stupidly,strumpet,strapless,stooping,stools,stealthy,stalks,stairmaster,staffer,sshhh,squatting,squatters,spectacularly,sorbet,socked,sociable,snubbed,snorting,sniffles,snazzy,snakebite,smuggler,smorgasbord,smooching,slurping,slouch,slingshot,slaved,skimmed,sisterhood,silliest,sidarthur,sheraton,shebang,sharpening,shanghaied,shakers,sendoff,scurvy,scoliosis,scaredy,scagnetti,sawchuk,saugus,sasquatch,sandbag,saltines,s'pose,roston,rostle,riveting,ristle,rifling,revulsion,reverently,retrograde,restful,resents,reptilian,reorganize,renovating,reiterate,reinvent,reinmar,reibers,reechard,recuse,reconciling,recognizance,reclaiming,recitation,recieved,rebate,reacquainted,rascals,railly,quintuplets,quahog,pygmies,puzzling,punctuality,prosthetic,proms,probie,preys,preserver,preppie,poachers,plummet,plumbers,plannin,pitying,pitfalls,piqued,pinecrest,pinches,pillage,pigheaded,physique,pessimistic,persecute,perjure,percentile,pentothal,pensky,penises,peini,pazzi,pastels,parlour,paperweight,pamper,pained,overwhelm,overalls,outrank,outpouring,outhouse,outage,ouija,obstructed,obsessions,obeying,obese,o'riley,o'higgins,nosebleeds,norad,noooooooo,nononono,nonchalant,nippy,neurosis,nekhorvich,necronomicon,naquada,n'est,mystik,mystified,mumps,muddle,mothership,moped,monumentally,monogamous,mondesi,misogynistic,misinterpreting,mindlock,mending,megaphone,meeny,medicating,meanie,masseur,markstrom,marklars,margueritas,manifesting,maharajah,lukewarm,loveliest,loran,lizardo,liquored,lipped,lingers,limey,lemkin,leisurely,lathe,latched,lapping,ladle,krevlorneswath,kosygin,khakis,kenaru,keats,kaitlan,julliard,jollies,jaundice,jargon,jackals,invisibility,insipid,inflamed,inferiority,inexperience,incinerated,incinerate,incendiary,incan,inbred,implicating,impersonator,hunks,horsing,hooded,hippopotamus,hiked,hetson,hetero,hessian,henslowe,hendler,hellstrom,headstone,hayloft,harbucks,handguns,hallucinate,haldol,haggling,gynaecologist,gulag,guilder,guaranteeing,groundskeeper,grindstone,grimoir,grievance,griddle,gribbit,greystone,graceland,gooders,goeth,gentlemanly,gelatin,gawking,ganged,fukes,fromby,frenchmen,foursome,forsley,forbids,footwork,foothold,floater,flinging,flicking,fittest,fistfight,fireballs,fillings,fiddling,fennyman,felonious,felonies,feces,favoritism,fatten,fanatics,faceman,excusing,excepted,entwined,entree,ensconced,eladio,ehrlichman,easterland,dueling,dribbling,drape,downtrodden,doused,dosed,dorleen,dokie,distort,displeased,disown,dismount,disinherited,disarmed,disapproves,diperna,dined,diligent,dicaprio,depress,decoded,debatable,dealey,darsh,damsels,damning,dad'll,d'oeuvre,curlers,curie,cubed,crikey,crepes,countrymen,cornfield,coppers,copilot,copier,cooing,conspiracies,consigliere,condoning,commoner,commies,combust,comas,colds,clawed,clamped,choosy,chomping,chimps,chigorin,chianti,cheep,checkups,cheaters,celibate,cautiously,cautionary,castell,carpentry,caroling,carjacking,caritas,caregiver,cardiology,candlesticks,canasta,cain't,burro,burnin,bunking,bumming,bullwinkle,brummel,brooms,brews,breathin,braslow,bracing,botulism,boorish,bloodless,blayne,blatantly,blankie,bedbugs,becuase,barmaid,bared,baracus,banal,bakes,backpacks,attentions,atrocious,ativan,athame,asunder,astound,assuring,aspirins,asphyxiation,ashtrays,aryans,arnon,apprehension,applauding,anvil,antiquing,antidepressants,annoyingly,amputate,altruistic,alotta,alerting,afterthought,affront,affirm,actuality,abysmal,absentee,yeller,yakushova,wuzzy,wriggle,worrier,woogyman,womanizer,windpipe,windbag,willin,whisking,whimsy,wendall,weeny,weensy,weasels,watery,watcha,wasteful,waski,washcloth,waaay,vouched,viznick,ventriloquist,vendettas,veils,vayhue,vamanos,vadimus,upstage,uppity,unsaid,unlocking,unintentionally,undetected,undecided,uncaring,unbearably,tween,tryout,trotting,trini,trimmings,trickier,treatin,treadstone,trashcan,transcendent,tramps,townsfolk,torturous,torrid,toothpicks,tolerable,tireless,tiptoeing,timmay,tillinghouse,tidying,tibia,thumbing,thrusters,thrashing,these'll,thatos,testicular,teriyaki,tenors,tenacity,tellers,telemetry,tarragon,switchblade,swicker,swells,sweatshirts,swatches,surging,supremely,sump'n,succumb,subsidize,stumbles,stuffs,stoppin,stipulate,stenographer,steamroll,stasis,stagger,squandered,splint,splendidly,splashy,splashing,specter,sorcerers,somewheres,somber,snuggled,snowmobile,sniffed,snags,smugglers,smudged,smirking,smearing,slings,sleet,sleepovers,sleek,slackers,siree,siphoning,singed,sincerest,sickened,shuffled,shriveled,shorthanded,shittin,shish,shipwrecked,shins,sheetrock,shawshank,shamu,sha're,servitude,sequins,seascape,scrapings,scoured,scorching,sandpaper,saluting,salud,ruffled,roughnecks,rougher,rosslyn,rosses,roost,roomy,romping,revolutionize,reprimanded,refute,refrigerated,reeled,redundancies,rectal,recklessly,receding,reassignment,reapers,readout,ration,raring,ramblings,raccoons,quarantined,purging,punters,psychically,premarital,pregnancies,predisposed,precautionary,pollute,podunk,plums,plaything,pixilated,pitting,piranhas,pieced,piddles,pickled,photogenic,phosphorous,pffft,pestilence,pessimist,perspiration,perps,penticoff,passageways,pardons,panics,pancamo,paleontologist,overwhelms,overstating,overpaid,overdid,outlive,orthodontist,orgies,oreos,ordover,ordinates,ooooooh,oooohhh,omelettes,officiate,obtuse,obits,nymph,novocaine,noooooooooo,nipping,nilly,nightstick,negate,neatness,natured,narcotic,narcissism,namun,nakatomi,murky,muchacho,mouthwash,motzah,morsel,morph,morlocks,mooch,moloch,molest,mohra,modus,modicum,mockolate,misdemeanors,miscalculation,middies,meringue,mercilessly,meditating,mayakovsky,maximillian,marlee,markovski,maniacal,maneuvered,magnificence,maddening,lutze,lunged,lovelies,lorry,loosening,lookee,littered,lilac,lightened,laces,kurzon,kurtzweil,kind've,kimono,kenji,kembu,keanu,kazuo,jonesing,jilted,jiggling,jewelers,jewbilee,jacqnoud,jacksons,ivories,insurmountable,innocuous,innkeeper,infantery,indulged,indescribable,incoherent,impervious,impertinent,imperfections,hunnert,huffy,horsies,horseradish,hollowed,hogwash,hockley,hissing,hiromitsu,hidin,hereafter,helpmann,hehehe,haughty,happenings,hankie,handsomely,halliwells,haklar,haise,gunsights,grossly,grope,grocer,grits,gripping,grabby,glorificus,gizzard,gilardi,gibarian,geminon,gasses,garnish,galloping,gairwyn,futterman,futility,fumigated,fruitless,friendless,freon,foregone,forego,floored,flighty,flapjacks,fizzled,ficus,festering,farbman,fabricate,eyghon,extricate,exalted,eventful,esophagus,enterprising,entail,endor,emphatically,embarrasses,electroshock,easel,duffle,drumsticks,dissection,dissected,disposing,disparaging,disorientation,disintegrated,disarming,devoting,dessaline,deprecating,deplorable,delve,degenerative,deduct,decomposed,deathly,dearie,daunting,dankova,cyclotron,cyberspace,cutbacks,culpable,cuddled,crumpets,cruelly,crouching,cranium,cramming,cowering,couric,cordesh,conversational,conclusively,clung,clotting,cleanest,chipping,chimpanzee,chests,cheapen,chainsaws,censure,catapult,caravaggio,carats,captivating,calrissian,butlers,busybody,bussing,bunion,bulimic,budging,brung,browbeat,brokenhearted,brecher,breakdowns,bracebridge,boning,blowhard,blisters,blackboard,bigotry,bialy,bhamra,bended,begat,battering,baste,basquiat,barricaded,barometer,balled,baited,badenweiler,backhand,ascenscion,argumentative,appendicitis,apparition,anxiously,antagonistic,angora,anacott,amniotic,ambience,alonna,aleck,akashic,ageless,abouts,aawwww,aaaaarrrrrrggghhh,aaaaaa,zendi,yuppies,yodel,y'hear,wrangle,wombosi,wittle,withstanding,wisecracks,wiggling,wierd,whittlesley,whipper,whattya,whatsamatter,whatchamacallit,whassup,whad'ya,weakling,warfarin,waponis,wampum,wadn't,vorash,vizzini,virtucon,viridiana,veracity,ventilated,varicose,varcon,vandalized,vamos,vamoose,vaccinated,vacationing,usted,urinal,uppers,unwittingly,unsealed,unplanned,unhinged,unhand,unfathomable,unequivocally,unbreakable,unadvisedly,udall,tynacorp,tuxes,tussle,turati,tunic,tsavo,trussed,troublemakers,trollop,tremors,transsexual,transfusions,toothbrushes,toned,toddlers,tinted,tightened,thundering,thorpey,this'd,thespian,thaddius,tenuous,tenths,tenement,telethon,teleprompter,teaspoon,taunted,tattle,tardiness,taraka,tappy,tapioca,tapeworm,talcum,tacks,swivel,swaying,superpower,summarize,sumbitch,sultry,suburbia,styrofoam,stylings,strolls,strobe,stockpile,stewardesses,sterilized,sterilize,stealin,stakeouts,squawk,squalor,squabble,sprinkled,sportsmanship,spokes,spiritus,sparklers,spareribs,sowing,sororities,sonovabitch,solicit,softy,softness,softening,snuggling,snatchers,snarling,snarky,snacking,smears,slumped,slowest,slithering,sleazebag,slayed,slaughtering,skidded,skated,sivapathasundaram,sissies,silliness,silences,sidecar,sicced,shylock,shtick,shrugged,shriek,shoves,should'a,shortcake,shockingly,shirking,shaves,shatner,sharpener,shapely,shafted,sexless,septum,selflessness,seabea,scuff,screwball,scoping,scooch,scolding,schnitzel,schemed,scalper,santy,sankara,sanest,salesperson,sakulos,safehouse,sabers,runes,rumblings,rumbling,ruijven,ringers,righto,rhinestones,retrieving,reneging,remodelling,relentlessly,regurgitate,refills,reeking,reclusive,recklessness,recanted,ranchers,rafer,quaking,quacks,prophesied,propensity,profusely,problema,prided,prays,postmark,popsicles,poodles,pollyanna,polaroids,pokes,poconos,pocketful,plunging,plugging,pleeease,platters,pitied,pinetti,piercings,phooey,phonies,pestering,periscope,pentagram,pelts,patronized,paramour,paralyze,parachutes,pales,paella,paducci,owatta,overdone,overcrowded,overcompensating,ostracized,ordinate,optometrist,operandi,omens,okayed,oedipal,nuttier,nuptial,nunheim,noxious,nourish,notepad,nitroglycerin,nibblet,neuroses,nanosecond,nabbit,mythic,munchkins,multimillion,mulroney,mucous,muchas,mountaintop,morlin,mongorians,moneybags,mom'll,molto,mixup,misgivings,mindset,michalchuk,mesmerized,merman,mensa,meaty,mbwun,materialize,materialistic,masterminded,marginally,mapuhe,malfunctioning,magnify,macnamara,macinerney,machinations,macadamia,lysol,lurks,lovelorn,lopsided,locator,litback,litany,linea,limousines,limes,lighters,liebkind,levity,levelheaded,letterhead,lesabre,leron,lepers,lefts,leftenant,laziness,layaway,laughlan,lascivious,laryngitis,lapsed,landok,laminated,kurten,kobol,knucklehead,knowed,knotted,kirkeby,kinsa,karnovsky,jolla,jimson,jettison,jeric,jawed,jankis,janitors,jango,jalopy,jailbreak,jackers,jackasses,invalidate,intercepting,intercede,insinuations,infertile,impetuous,impaled,immerse,immaterial,imbeciles,imagines,idyllic,idolized,icebox,i'd've,hypochondriac,hyphen,hurtling,hurried,hunchback,hullo,horsting,hoooo,homeboys,hollandaise,hoity,hijinks,hesitates,herrero,herndorff,helplessly,heeyy,heathen,hearin,headband,harrassment,harpies,halstrom,hahahahaha,hacer,grumbling,grimlocks,grift,greets,grandmothers,grander,grafts,gordievsky,gondorff,godorsky,glscripts,gaudy,gardeners,gainful,fuses,fukienese,frizzy,freshness,freshening,fraught,frantically,foxbooks,fortieth,forked,foibles,flunkies,fleece,flatbed,fisted,firefight,fingerpaint,filibuster,fhloston,fenceline,femur,fatigues,fanucci,fantastically,familiars,falafel,fabulously,eyesore,expedient,ewwww,eviscerated,erogenous,epidural,enchante,embarassed,embarass,embalming,elude,elspeth,electrocute,eigth,eggshell,echinacea,eases,earpiece,earlobe,dumpsters,dumbshit,dumbasses,duloc,duisberg,drummed,drinkers,dressy,dorma,doily,divvy,diverting,dissuade,disrespecting,displace,disorganized,disgustingly,discord,disapproving,diligence,didja,diced,devouring,detach,destructing,desolate,demerits,delude,delirium,degrade,deevak,deemesa,deductions,deduce,debriefed,deadbeats,dateline,darndest,damnable,dalliance,daiquiri,d'agosta,cussing,cryss,cripes,cretins,crackerjack,cower,coveting,couriers,countermission,cotswolds,convertibles,conversationalist,consorting,consoled,consarn,confides,confidentially,commited,commiserate,comme,comforter,comeuppance,combative,comanches,colosseum,colling,coexist,coaxing,cliffside,chutes,chucked,chokes,childlike,childhoods,chickening,chenowith,charmingly,changin,catsup,captioning,capsize,cappucino,capiche,candlewell,cakewalk,cagey,caddie,buxley,bumbling,bulky,buggered,brussel,brunettes,brumby,brotha,bronck,brisket,bridegroom,braided,bovary,bookkeeper,bluster,bloodline,blissfully,blase,billionaires,bicker,berrisford,bereft,berating,berate,bendy,belive,belated,beikoku,beens,bedspread,bawdy,barreling,baptize,banya,balthazar,balmoral,bakshi,bails,badgered,backstreet,awkwardly,auras,attuned,atheists,astaire,assuredly,arrivederci,appetit,appendectomy,apologetic,antihistamine,anesthesiologist,amulets,albie,alarmist,aiight,adstream,admirably,acquaint,abound,abominable,aaaaaaah,zekes,zatunica,wussy,worded,wooed,woodrell,wiretap,windowsill,windjammer,windfall,whisker,whims,whatiya,whadya,weirdly,weenies,waunt,washout,wanto,waning,victimless,verdad,veranda,vandaley,vancomycin,valise,vaguest,upshot,unzip,unwashed,untrained,unstuck,unprincipled,unmentionables,unjustly,unfolds,unemployable,uneducated,unduly,undercut,uncovering,unconsciousness,unconsciously,tyndareus,turncoat,turlock,tulle,tryouts,trouper,triplette,trepkos,tremor,treeger,trapeze,traipse,tradeoff,trach,torin,tommorow,tollan,toity,timpani,thumbprint,thankless,tell'em,telepathy,telemarketing,telekinesis,teevee,teeming,tarred,tambourine,talentless,swooped,switcheroo,swirly,sweatpants,sunstroke,suitors,sugarcoat,subways,subterfuge,subservient,subletting,stunningly,strongbox,striptease,stravanavitch,stradling,stoolie,stodgy,stocky,stifle,stealer,squeezes,squatter,squarely,sprouted,spool,spindly,speedos,soups,soundly,soulmates,somebody'll,soliciting,solenoid,sobering,snowflakes,snowballs,snores,slung,slimming,skulk,skivvies,skewered,skewer,sizing,sistine,sidebar,sickos,shushing,shunt,shugga,shone,shol'va,sharpened,shapeshifter,shadowing,shadoe,selectman,sefelt,seared,scrounging,scribbling,scooping,scintillating,schmoozing,scallops,sapphires,sanitarium,sanded,safes,rudely,roust,rosebush,rosasharn,rondell,roadhouse,riveted,rewrote,revamp,retaliatory,reprimand,replicators,replaceable,remedied,relinquishing,rejoicing,reincarnated,reimbursed,reevaluate,redid,redefine,recreating,reconnected,rebelling,reassign,rearview,rayne,ravings,ratso,rambunctious,radiologist,quiver,quiero,queef,qualms,pyrotechnics,pulsating,psychosomatic,proverb,promiscuous,profanity,prioritize,preying,predisposition,precocious,precludes,prattling,prankster,povich,potting,postpartum,porridge,polluting,plowing,pistachio,pissin,pickpocket,physicals,peruse,pertains,personified,personalize,perjured,perfecting,pepys,pepperdine,pembry,peering,peels,pedophile,patties,passkey,paratrooper,paraphernalia,paralyzing,pandering,paltry,palpable,pagers,pachyderm,overstay,overestimated,overbite,outwit,outgrow,outbid,ooops,oomph,oohhh,oldie,obliterate,objectionable,nygma,notting,noches,nitty,nighters,newsstands,newborns,neurosurgery,nauseated,nastiest,narcolepsy,mutilate,muscled,murmur,mulva,mulling,mukada,muffled,morgues,moonbeams,monogamy,molester,molestation,molars,moans,misprint,mismatched,mirth,mindful,mimosas,millander,mescaline,menstrual,menage,mellowing,medevac,meddlesome,matey,manicures,malevolent,madmen,macaroons,lydell,lycra,lunchroom,lunching,lozenges,looped,litigious,liquidate,linoleum,lingk,limitless,limber,lilacs,ligature,liftoff,lemmiwinks,leggo,learnin,lazarre,lawyered,lactose,knelt,kenosha,kemosabe,jussy,junky,jordy,jimmies,jeriko,jakovasaur,issacs,isabela,irresponsibility,ironed,intoxication,insinuated,inherits,ingest,ingenue,inflexible,inflame,inevitability,inedible,inducement,indignant,indictments,indefensible,incomparable,incommunicado,improvising,impounded,illogical,ignoramus,hydrochloric,hydrate,hungover,humorless,humiliations,hugest,hoverdrone,hovel,hmmph,hitchhike,hibernating,henchman,helloooo,heirlooms,heartsick,headdress,hatches,harebrained,hapless,hanen,handsomer,hallows,habitual,guten,gummy,guiltier,guidebook,gstaad,gruff,griss,grieved,grata,gorignak,goosed,goofed,glowed,glitz,glimpses,glancing,gilmores,gianelli,geraniums,garroway,gangbusters,gamblers,galls,fuddy,frumpy,frowning,frothy,fro'tak,frere,fragrances,forgettin,follicles,flowery,flophouse,floatin,flirts,flings,flatfoot,fingerprinting,fingerprinted,fingering,finald,fillet,fianc,femoral,federales,fawkes,fascinates,farfel,fambly,falsified,fabricating,exterminators,expectant,excusez,excrement,excercises,evian,etins,esophageal,equivalency,equate,equalizer,entrees,enquire,endearment,empathetic,emailed,eggroll,earmuffs,dyslexic,duper,duesouth,drunker,druggie,dreadfully,dramatics,dragline,downplay,downers,dominatrix,doers,docket,docile,diversify,distracts,disloyalty,disinterested,discharging,disagreeable,dirtier,dinghy,dimwitted,dimoxinil,dimmy,diatribe,devising,deviate,detriment,desertion,depressants,depravity,deniability,delinquents,defiled,deepcore,deductive,decimate,deadbolt,dauthuille,dastardly,daiquiris,daggers,dachau,curiouser,curdled,cucamonga,cruller,cruces,crosswalk,crinkle,crescendo,cremate,counseled,couches,cornea,corday,copernicus,contrition,contemptible,constipated,conjoined,confounded,condescend,concoct,conch,compensating,committment,commandeered,comely,coddled,cockfight,cluttered,clunky,clownfish,cloaked,clenched,cleanin,civilised,circumcised,cimmeria,cilantro,chutzpah,chucking,chiseled,chicka,chattering,cervix,carrey,carpal,carnations,cappuccinos,candied,calluses,calisthenics,bushy,burners,budington,buchanans,brimming,braids,boycotting,bouncers,botticelli,botherin,bookkeeping,bogyman,bogged,bloodthirsty,blintzes,blanky,binturong,billable,bigboote,bewildered,betas,bequeath,behoove,befriend,bedpost,bedded,baudelaires,barreled,barboni,barbeque,bangin,baltus,bailout,backstabber,baccarat,awning,augie,arguillo,archway,apricots,apologising,annyong,anchorman,amenable,amazement,allspice,alannis,airfare,airbags,ahhhhhhhhh,ahhhhhhhh,ahhhhhhh,agitator,adrenal,acidosis,achoo,accessorizing,accentuate,abrasions,abductor,aaaahhh,aaaaaaaa,aaaaaaa,zeroing,zelner,zeldy,yevgeny,yeska,yellows,yeesh,yeahh,yamuri,wouldn't've,workmanship,woodsman,winnin,winked,wildness,whoring,whitewash,whiney,when're,wheezer,wheelman,wheelbarrow,westerburg,weeding,watermelons,washboard,waltzes,wafting,voulez,voluptuous,vitone,vigilantes,videotaping,viciously,vices,veruca,vermeer,verifying,vasculitis,valets,upholstered,unwavering,untold,unsympathetic,unromantic,unrecognizable,unpredictability,unmask,unleashing,unintentional,unglued,unequivocal,underrated,underfoot,unchecked,unbutton,unbind,unbiased,unagi,uhhhhh,tugging,triads,trespasses,treehorn,traviata,trappers,transplants,trannie,tramping,tracheotomy,tourniquet,tooty,toothless,tomarrow,toasters,thruster,thoughtfulness,thornwood,tengo,tenfold,telltale,telephoto,telephoned,telemarketer,tearin,tastic,tastefully,tasking,taser,tamed,tallow,taketh,taillight,tadpoles,tachibana,syringes,sweated,swarthy,swagger,surges,supermodels,superhighway,sunup,sun'll,sulfa,sugarless,sufficed,subside,strolled,stringy,strengthens,straightest,straightens,storefront,stopper,stockpiling,stimulant,stiffed,steyne,sternum,stepladder,stepbrother,steers,steelheads,steakhouse,stathis,stankylecartmankennymr,standoffish,stalwart,squirted,spritz,sprig,sprawl,spousal,sphincter,spenders,spearmint,spatter,spangled,southey,soured,sonuvabitch,somethng,snuffed,sniffs,smokescreen,smilin,slobs,sleepwalker,sleds,slays,slayage,skydiving,sketched,skanks,sixed,siphoned,siphon,simpering,sigfried,sidearm,siddons,sickie,shuteye,shuffleboard,shrubberies,shrouded,showmanship,shouldn't've,shoplift,shiatsu,sentries,sentance,sensuality,seething,secretions,searing,scuttlebutt,sculpt,scowling,scouring,scorecard,schoolers,schmucks,scepters,scaly,scalps,scaffolding,sauces,sartorius,santen,salivating,sainthood,saget,saddens,rygalski,rusting,ruination,rueland,rudabaga,rottweiler,roofies,romantics,rollerblading,roldy,roadshow,rickets,rible,rheza,revisiting,retentive,resurface,restores,respite,resounding,resorting,resists,repulse,repressing,repaying,reneged,refunds,rediscover,redecorated,reconstructive,recommitted,recollect,receptacle,reassess,reanimation,realtors,razinin,rationalization,ratatouille,rashum,rasczak,rancheros,rampler,quizzing,quips,quartered,purring,pummeling,puede,proximo,prospectus,pronouncing,prolonging,procreation,proclamations,principled,prides,preoccupation,prego,precog,prattle,pounced,potshots,potpourri,porque,pomegranates,polenta,plying,pluie,plesac,playmates,plantains,pillowcase,piddle,pickers,photocopied,philistine,perpetuate,perpetually,perilous,pawned,pausing,pauper,parter,parlez,parlay,pally,ovulation,overtake,overstate,overpowering,overpowered,overconfident,overbooked,ovaltine,outweighs,outings,ottos,orrin,orifice,orangutan,oopsy,ooooooooh,oooooo,ooohhhh,ocular,obstruct,obscenely,o'dwyer,nutjob,nunur,notifying,nostrand,nonny,nonfat,noblest,nimble,nikes,nicht,newsworthy,nestled,nearsighted,ne'er,nastier,narco,nakedness,muted,mummified,mudda,mozzarella,moxica,motivator,motility,mothafucka,mortmain,mortgaged,mores,mongers,mobbed,mitigating,mistah,misrepresented,mishke,misfortunes,misdirection,mischievous,mineshaft,millaney,microwaves,metzenbaum,mccovey,masterful,masochistic,marliston,marijawana,manya,mantumbi,malarkey,magnifique,madrona,madox,machida,m'hidi,lullabies,loveliness,lotions,looka,lompoc,litterbug,litigator,lithe,liquorice,linds,limericks,lightbulb,lewises,letch,lemec,layover,lavatory,laurels,lateness,laparotomy,laboring,kuato,kroff,krispy,krauts,knuckleheads,kitschy,kippers,kimbrow,keypad,keepsake,kebab,karloff,junket,judgemental,jointed,jezzie,jetting,jeeze,jeeter,jeesus,jeebs,janeane,jails,jackhammer,ixnay,irritates,irritability,irrevocable,irrefutable,irked,invoking,intricacies,interferon,intents,insubordinate,instructive,instinctive,inquisitive,inlay,injuns,inebriated,indignity,indecisive,incisors,incacha,inalienable,impresses,impregnate,impregnable,implosion,idolizes,hypothyroidism,hypoglycemic,huseni,humvee,huddling,honing,hobnobbing,hobnob,histrionics,histamine,hirohito,hippocratic,hindquarters,hikita,hikes,hightailed,hieroglyphics,heretofore,herbalist,hehey,hedriks,heartstrings,headmistress,headlight,hardheaded,happend,handlebars,hagitha,habla,gyroscope,guys'd,guy'd,guttersnipe,grump,growed,grovelling,groan,greenbacks,gravedigger,grating,grasshoppers,grandiose,grandest,grafted,gooood,goood,gooks,godsakes,goaded,glamorama,giveth,gingham,ghostbusters,germane,georgy,gazzo,gazelles,gargle,garbled,galgenstein,gaffe,g'day,fyarl,furnish,furies,fulfills,frowns,frowned,frighteningly,freebies,freakishly,forewarned,foreclose,forearms,fordson,fonics,flushes,flitting,flemmer,flabby,fishbowl,fidgeting,fevers,feigning,faxing,fatigued,fathoms,fatherless,fancier,fanatical,factored,eyelid,eyeglasses,expresso,expletive,expectin,excruciatingly,evidentiary,ever'thing,eurotrash,eubie,estrangement,erlich,epitome,entrap,enclose,emphysema,embers,emasculating,eighths,eardrum,dyslexia,duplicitous,dumpty,dumbledore,dufus,duddy,duchamp,drunkenness,drumlin,drowns,droid,drinky,drifts,drawbridge,dramamine,douggie,douchebag,dostoyevsky,doodling,don'tcha,domineering,doings,dogcatcher,doctoring,ditzy,dissimilar,dissecting,disparage,disliking,disintegrating,dishwalla,dishonored,dishing,disengaged,disavowed,dippy,diorama,dimmed,dilate,digitalis,diggory,dicing,diagnosing,devola,desolation,dennings,denials,deliverance,deliciously,delicacies,degenerates,degas,deflector,defile,deference,decrepit,deciphered,dawdle,dauphine,daresay,dangles,dampen,damndest,cucumbers,cucaracha,cryogenically,croaks,croaked,criticise,crisper,creepiest,creams,crackle,crackin,covertly,counterintelligence,corrosive,cordially,cops'll,convulsions,convoluted,conversing,conga,confrontational,confab,condolence,condiments,complicit,compiegne,commodus,comings,cometh,collusion,collared,cockeyed,clobber,clemonds,clarithromycin,cienega,christmasy,christmassy,chloroform,chippie,chested,cheeco,checklist,chauvinist,chandlers,chambermaid,chakras,cellophane,caveat,cataloguing,cartmanland,carples,carny,carded,caramels,cappy,caped,canvassing,callback,calibrated,calamine,buttermilk,butterfingers,bunsen,bulimia,bukatari,buildin,budged,brobich,bringer,brendell,brawling,bratty,braised,boyish,boundless,botch,boosh,bookies,bonbons,bodes,bobunk,bluntly,blossoming,bloomers,bloodstains,bloodhounds,blech,biter,biometric,bioethics,bijan,bigoted,bicep,bereaved,bellowing,belching,beholden,beached,batmobile,barcodes,barch,barbecuing,bandanna,backwater,backtrack,backdraft,augustino,atrophy,atrocity,atley,atchoo,asthmatic,assoc,armchair,arachnids,aptly,appetizing,antisocial,antagonizing,anorexia,anini,andersons,anagram,amputation,alleluia,airlock,aimless,agonized,agitate,aggravating,aerosol,acing,accomplishing,accidently,abuser,abstain,abnormally,aberration,aaaaahh,zlotys,zesty,zerzura,zapruder,zantopia,yelburton,yeess,y'knowwhati'msayin,wwhat,wussies,wrenched,would'a,worryin,wormser,wooooo,wookiee,wolchek,wishin,wiseguys,windbreaker,wiggy,wieners,wiedersehen,whoopin,whittled,wherefore,wharvey,welts,wellstone,wedges,wavered,watchit,wastebasket,wango,waken,waitressed,wacquiem,vrykolaka,voula,vitally,visualizing,viciousness,vespers,vertes,verily,vegetarians,vater,vaporize,vannacutt,vallens,ussher,urinating,upping,unwitting,untangle,untamed,unsanitary,unraveled,unopened,unisex,uninvolved,uninteresting,unintelligible,unimaginative,undeserving,undermines,undergarments,unconcerned,tyrants,typist,tykes,tybalt,twosome,twits,tutti,turndown,tularemia,tuberculoma,tsimshian,truffaut,truer,truant,trove,triumphed,tripe,trigonometry,trifled,trifecta,tribulations,tremont,tremoille,transcends,trafficker,touchin,tomfoolery,tinkered,tinfoil,tightrope,thousan,thoracotomy,thesaurus,thawing,thatta,tessio,temps,taxidermist,tator,tachycardia,t'akaya,swelco,sweetbreads,swatting,supercollider,sunbathing,summarily,suffocation,sueleen,succinct,subsided,submissive,subjecting,subbing,subatomic,stupendous,stunted,stubble,stubbed,streetwalker,strategizing,straining,straightaway,stoli,stiffer,stickup,stens,steamroller,steadwell,steadfast,stateroom,stans,sshhhh,squishing,squinting,squealed,sprouting,sprimp,spreadsheets,sprawled,spotlights,spooning,spirals,speedboat,spectacles,speakerphone,southglen,souse,soundproof,soothsayer,sommes,somethings,solidify,soars,snorted,snorkeling,snitches,sniping,snifter,sniffin,snickering,sneer,snarl,smila,slinking,slanted,slanderous,slammin,skimp,skilosh,siteid,sirloin,singe,sighing,sidekicks,sicken,showstopper,shoplifter,shimokawa,sherborne,shavadai,sharpshooters,sharking,shagged,shaddup,senorita,sesterces,sensuous,seahaven,scullery,scorcher,schotzie,schnoz,schmooze,schlep,schizo,scents,scalping,scalped,scallop,scalding,sayeth,saybrooke,sawed,savoring,sardine,sandstorm,sandalwood,salutations,sagman,s'okay,rsvp'd,rousted,rootin,romper,romanovs,rollercoaster,rolfie,robinsons,ritzy,ritualistic,ringwald,rhymed,rheingold,rewrites,revoking,reverts,retrofit,retort,retinas,respirations,reprobate,replaying,repaint,renquist,renege,relapsing,rekindled,rejuvenating,rejuvenated,reinstating,recriminations,rechecked,reassemble,rears,reamed,reacquaint,rayanne,ravish,rathole,raspail,rarest,rapists,rants,racketeer,quittin,quitters,quintessential,queremos,quellek,quelle,quasimodo,pyromaniac,puttanesca,puritanical,purer,puree,pungent,pummel,puedo,psychotherapist,prosecutorial,prosciutto,propositioning,procrastination,probationary,primping,preventative,prevails,preservatives,preachy,praetorians,practicality,powders,potus,postop,positives,poser,portolano,portokalos,poolside,poltergeists,pocketed,poach,plummeted,plucking,plimpton,playthings,plastique,plainclothes,pinpointed,pinkus,pinks,pigskin,piffle,pictionary,piccata,photocopy,phobias,perignon,perfumes,pecks,pecked,patently,passable,parasailing,paramus,papier,paintbrush,pacer,paaiint,overtures,overthink,overstayed,overrule,overestimate,overcooked,outlandish,outgrew,outdoorsy,outdo,orchestrate,oppress,opposable,oooohh,oomupwah,okeydokey,okaaay,ohashi,of'em,obscenities,oakie,o'gar,nurection,nostradamus,norther,norcom,nooch,nonsensical,nipped,nimbala,nervously,neckline,nebbleman,narwhal,nametag,n'n't,mycenae,muzak,muumuu,mumbled,mulvehill,muggings,muffet,mouthy,motivates,motaba,moocher,mongi,moley,moisturize,mohair,mocky,mmkay,mistuh,missis,misdeeds,mincemeat,miggs,miffed,methadone,messieur,menopausal,menagerie,mcgillicuddy,mayflowers,matrimonial,matick,masai,marzipan,maplewood,manzelle,mannequins,manhole,manhandle,malfunctions,madwoman,machiavelli,lynley,lynched,lurconis,lujack,lubricant,looove,loons,loofah,lonelyhearts,lollipops,lineswoman,lifers,lexter,lepner,lemony,leggy,leafy,leadeth,lazerus,lazare,lawford,languishing,lagoda,ladman,kundera,krinkle,krendler,kreigel,kowolski,knockdown,knifed,kneed,kneecap,kids'll,kennie,kenmore,keeled,kazootie,katzenmoyer,kasdan,karak,kapowski,kakistos,julyan,jockstrap,jobless,jiggly,jaunt,jarring,jabbering,irrigate,irrevocably,irrationally,ironies,invitro,intimated,intently,intentioned,intelligently,instill,instigator,instep,inopportune,innuendoes,inflate,infects,infamy,indiscretions,indiscreet,indio,indignities,indict,indecision,inconspicuous,inappropriately,impunity,impudent,impotence,implicates,implausible,imperfection,impatience,immutable,immobilize,idealist,iambic,hysterically,hyperspace,hygienist,hydraulics,hydrated,huzzah,husks,hunched,huffed,hubris,hubbub,hovercraft,houngan,hosed,horoscopes,hopelessness,hoodwinked,honorably,honeysuckle,homegirl,holiest,hippity,hildie,hieroglyphs,hexton,herein,heckle,heaping,healthilizer,headfirst,hatsue,harlot,hardwired,halothane,hairstyles,haagen,haaaaa,gutting,gummi,groundless,groaning,gristle,grills,graynamore,grabbin,goodes,goggle,glittering,glint,gleaming,glassy,girth,gimbal,giblets,gellers,geezers,geeze,garshaw,gargantuan,garfunkel,gangway,gandarium,gamut,galoshes,gallivanting,gainfully,gachnar,fusionlips,fusilli,furiously,frugal,fricking,frederika,freckling,frauds,fountainhead,forthwith,forgo,forgettable,foresight,foresaw,fondling,fondled,fondle,folksy,fluttering,fluffing,floundering,flirtatious,flexing,flatterer,flaring,fixating,finchy,figurehead,fiendish,fertilize,ferment,fending,fellahs,feelers,fascinate,fantabulous,falsify,fallopian,faithless,fairer,fainter,failings,facetious,eyepatch,exxon,extraterrestrials,extradite,extracurriculars,extinguish,expunged,expelling,exorbitant,exhilarated,exertion,exerting,excercise,everbody,evaporated,escargot,escapee,erases,epizootics,epithelials,ephrum,entanglements,enslave,engrossed,emphatic,emeralds,ember,emancipated,elevates,ejaculate,effeminate,eccentricities,easygoing,earshot,dunks,dullness,dulli,dulled,drumstick,dropper,driftwood,dregs,dreck,dreamboat,draggin,downsizing,donowitz,dominoes,diversions,distended,dissipate,disraeli,disqualify,disowned,dishwashing,disciplining,discerning,disappoints,dinged,digested,dicking,detonating,despising,depressor,depose,deport,dents,defused,deflecting,decryption,decoys,decoupage,decompress,decibel,decadence,deafening,dawning,dater,darkened,dappy,dallying,dagon,czechoslovakians,cuticles,cuteness,cupboards,culottes,cruisin,crosshairs,cronyn,criminalistics,creatively,creaming,crapping,cranny,cowed,contradicting,constipation,confining,confidences,conceiving,conceivably,concealment,compulsively,complainin,complacent,compels,communing,commode,comming,commensurate,columnists,colonoscopy,colchicine,coddling,clump,clubbed,clowning,cliffhanger,clang,cissy,choosers,choker,chiffon,channeled,chalet,cellmates,cathartic,caseload,carjack,canvass,canisters,candlestick,candlelit,camry,calzones,calitri,caldy,byline,butterball,bustier,burlap,bureaucrat,buffoons,buenas,brookline,bronzed,broiled,broda,briss,brioche,briar,breathable,brays,brassieres,boysenberry,bowline,boooo,boonies,booklets,bookish,boogeyman,boogey,bogas,boardinghouse,bluuch,blundering,bluer,blowed,blotchy,blossomed,bloodwork,bloodied,blithering,blinks,blathering,blasphemous,blacking,birdson,bings,bfmid,bfast,bettin,berkshires,benjamins,benevolence,benched,benatar,bellybutton,belabor,behooves,beddy,beaujolais,beattle,baxworth,baseless,barfing,bannish,bankrolled,banek,ballsy,ballpoint,baffling,badder,badda,bactine,backgammon,baako,aztreonam,authoritah,auctioning,arachtoids,apropos,aprons,apprised,apprehensive,anythng,antivenin,antichrist,anorexic,anoint,anguished,angioplasty,angio,amply,ampicillin,amphetamines,alternator,alcove,alabaster,airlifted,agrabah,affidavits,admonished,admonish,addled,addendum,accuser,accompli,absurdity,absolved,abrusso,abreast,aboot,abductions,abducting,aback,ababwa,aaahhhh,zorin,zinthar,zinfandel,zillions,zephyrs,zatarcs,zacks,youuu,yokels,yardstick,yammer,y'understand,wynette,wrung,wreaths,wowed,wouldn'ta,worming,wormed,workday,woodsy,woodshed,woodchuck,wojadubakowski,withering,witching,wiseass,wiretaps,wining,willoby,wiccaning,whupped,whoopi,whoomp,wholesaler,whiteness,whiner,whatchya,wharves,wenus,weirdoes,weaning,watusi,waponi,waistband,wackos,vouching,votre,vivica,viveca,vivant,vivacious,visor,visitin,visage,vicrum,vetted,ventriloquism,venison,varnsen,vaporized,vapid,vanstock,uuuuh,ushering,urologist,urination,upstart,uprooted,unsubtitled,unspoiled,unseat,unseasonably,unseal,unsatisfying,unnerve,unlikable,unleaded,uninsured,uninspired,unicycle,unhooked,unfunny,unfreezing,unflattering,unfairness,unexpressed,unending,unencumbered,unearth,undiscovered,undisciplined,understan,undershirt,underlings,underline,undercurrent,uncivilized,uncharacteristic,umpteenth,uglies,tuney,trumps,truckasaurus,trubshaw,trouser,tringle,trifling,trickster,trespassers,trespasser,traumas,trattoria,trashes,transgressions,trampling,tp'ed,toxoplasmosis,tounge,tortillas,topsy,topple,topnotch,tonsil,tions,timmuh,timithious,tilney,tighty,tightness,tightens,tidbits,ticketed,thyme,threepio,thoughtfully,thorkel,thommo,thing'll,thefts,that've,thanksgivings,tetherball,testikov,terraforming,tepid,tendonitis,tenboom,telex,teenybopper,tattered,tattaglias,tanneke,tailspin,tablecloth,swooping,swizzle,swiping,swindled,swilling,swerving,sweatshops,swaddling,swackhammer,svetkoff,supossed,superdad,sumptuous,sugary,sugai,subvert,substantiate,submersible,sublimating,subjugation,stymied,strychnine,streetlights,strassmans,stranglehold,strangeness,straddling,straddle,stowaways,stotch,stockbrokers,stifling,stepford,steerage,steena,statuary,starlets,staggeringly,ssshhh,squaw,spurt,spungeon,spritzer,sprightly,sprays,sportswear,spoonful,splittin,splitsville,speedily,specialise,spastic,sparrin,souvlaki,southie,sourpuss,soupy,soundstage,soothes,somebody'd,softest,sociopathic,socialized,snyders,snowmobiles,snowballed,snatches,smugness,smoothest,smashes,sloshed,sleight,skyrocket,skied,skewed,sixpence,sipowicz,singling,simulates,shyness,shuvanis,showoff,shortsighted,shopkeeper,shoehorn,shithouse,shirtless,shipshape,shifu,shelve,shelbyville,sheepskin,sharpens,shaquille,shanshu,servings,sequined,seizes,seashells,scrambler,scopes,schnauzer,schmo,schizoid,scampered,savagely,saudis,santas,sandovals,sanding,saleswoman,sagging,s'cuse,rutting,ruthlessly,runneth,ruffians,rubes,rosalita,rollerblades,rohypnol,roasts,roadies,ritten,rippling,ripples,rigoletto,richardo,rethought,reshoot,reserving,reseda,rescuer,reread,requisitions,repute,reprogram,replenish,repetitious,reorganizing,reinventing,reinvented,reheat,refrigerators,reenter,recruiter,recliner,rawdy,rashes,rajeski,raison,raisers,rages,quinine,questscape,queller,pygmalion,pushers,pusan,purview,pumpin,pubescent,prudes,provolone,propriety,propped,procrastinate,processional,preyed,pretrial,portent,pooling,poofy,polloi,policia,poacher,pluses,pleasuring,platitudes,plateaued,plaguing,pittance,pinheads,pincushion,pimply,pimped,piggyback,piecing,phillipe,philipse,philby,pharaohs,petyr,petitioner,peshtigo,pesaram,persnickety,perpetrate,percolating,pepto,penne,penell,pemmican,peeks,pedaling,peacemaker,pawnshop,patting,pathologically,patchouli,pasts,pasties,passin,parlors,paltrow,palamon,padlock,paddling,oversleep,overheating,overdosed,overcharge,overblown,outrageously,ornery,opportune,oooooooooh,oohhhh,ohhhhhh,ogres,odorless,obliterated,nyong,nymphomaniac,ntozake,novocain,nough,nonnie,nonissue,nodules,nightmarish,nightline,niceties,newsman,needra,nedry,necking,navour,nauseam,nauls,narim,namath,nagged,naboo,n'sync,myslexia,mutator,mustafi,musketeer,murtaugh,murderess,munching,mumsy,muley,mouseville,mortifying,morgendorffers,moola,montel,mongoloid,molestered,moldings,mocarbies,mo'ss,mixers,misrell,misnomer,misheard,mishandled,miscreant,misconceptions,miniscule,millgate,mettle,metricconverter,meteors,menorah,mengele,melding,meanness,mcgruff,mcarnold,matzoh,matted,mastectomy,massager,marveling,marooned,marmaduke,marick,manhandled,manatees,man'll,maltin,maliciously,malfeasance,malahide,maketh,makeovers,maiming,machismo,lumpectomy,lumbering,lucci,lording,lorca,lookouts,loogie,loners,loathed,lissen,lighthearted,lifer,lickin,lewen,levitation,lestercorp,lessee,lentils,legislate,legalizing,lederhosen,lawmen,lasskopf,lardner,lambeau,lamagra,ladonn,lactic,lacquer,labatier,krabappel,kooks,knickknacks,klutzy,kleynach,klendathu,kinross,kinkaid,kind'a,ketch,kesher,karikos,karenina,kanamits,junshi,jumbled,joust,jotted,jobson,jingling,jigalong,jerries,jellies,jeeps,javna,irresistable,internist,intercranial,inseminated,inquisitor,infuriate,inflating,infidelities,incessantly,incensed,incase,incapacitate,inasmuch,inaccuracies,imploding,impeding,impediments,immaturity,illegible,iditarod,icicles,ibuprofen,i'i'm,hymie,hydrolase,hunker,humps,humons,humidor,humdinger,humbling,huggin,huffing,housecleaning,hothouse,hotcakes,hosty,hootenanny,hootchie,hoosegow,honks,honeymooners,homily,homeopathic,hitchhikers,hissed,hillnigger,hexavalent,hewwo,hershe,hermey,hergott,henny,hennigans,henhouse,hemolytic,helipad,heifer,hebrews,hebbing,heaved,headlock,harrowing,harnessed,hangovers,handi,handbasket,halfrek,hacene,gyges,guys're,gundersons,gumption,gruntmaster,grubs,grossie,groped,grins,greaseball,gravesite,gratuity,granma,grandfathers,grandbaby,gradski,gracing,gossips,gooble,goners,golitsyn,gofer,godsake,goddaughter,gnats,gluing,glares,givers,ginza,gimmie,gimmee,gennero,gemme,gazpacho,gazed,gassy,gargling,gandhiji,galvanized,gallbladder,gaaah,furtive,fumigation,fucka,fronkonsteen,frills,freezin,freewald,freeloader,frailty,forger,foolhardy,fondest,fomin,followin,follicle,flotation,flopping,floodgates,flogged,flicked,flenders,fleabag,fixings,fixable,fistful,firewater,firelight,fingerbang,finalizing,fillin,filipov,fiderer,felling,feldberg,feign,faunia,fatale,farkus,fallible,faithfulness,factoring,eyeful,extramarital,exterminated,exhume,exasperated,eviscerate,estoy,esmerelda,escapades,epoxy,enticed,enthused,entendre,engrossing,endorphins,emptive,emmys,eminently,embezzler,embarressed,embarrassingly,embalmed,eludes,eling,elated,eirie,egotitis,effecting,eerily,eecom,eczema,earthy,earlobes,eally,dyeing,dwells,duvet,duncans,dulcet,droves,droppin,drools,drey'auc,downriver,domesticity,dollop,doesnt,dobler,divulged,diversionary,distancing,dispensers,disorienting,disneyworld,dismissive,disingenuous,disheveled,disfiguring,dinning,dimming,diligently,dilettante,dilation,dickensian,diaphragms,devastatingly,destabilize,desecrate,deposing,deniece,demony,delving,delicates,deigned,defraud,deflower,defibrillator,defiantly,defenceless,defacing,deconstruction,decompose,deciphering,decibels,deceptively,deceptions,decapitation,debutantes,debonair,deadlier,dawdling,davic,darwinism,darnit,darks,danke,danieljackson,dangled,cytoxan,cutout,cutlery,curveball,curfews,cummerbund,crunches,crouched,crisps,cripples,crilly,cribs,crewman,creepin,creeds,credenza,creak,crawly,crawlin,crawlers,crated,crackheads,coworker,couldn't've,corwins,coriander,copiously,convenes,contraceptives,contingencies,contaminating,conniption,condiment,concocting,comprehending,complacency,commendatore,comebacks,com'on,collarbone,colitis,coldly,coiffure,coffers,coeds,codependent,cocksucking,cockney,cockles,clutched,closeted,cloistered,cleve,cleats,clarifying,clapped,cinnabar,chunnel,chumps,cholinesterase,choirboy,chocolatey,chlamydia,chigliak,cheesie,chauvinistic,chasm,chartreuse,charo,charnier,chapil,chalked,chadway,certifiably,cellulite,celled,cavalcade,cataloging,castrated,cassio,cashews,cartouche,carnivore,carcinogens,capulet,captivated,capt'n,cancellations,campin,callate,callar,caffeinated,cadavers,cacophony,cackle,buzzes,buttoning,busload,burglaries,burbs,buona,bunions,bullheaded,buffs,bucyk,buckling,bruschetta,browbeating,broomsticks,broody,bromly,brolin,briefings,brewskies,breathalyzer,breakups,bratwurst,brania,braiding,brags,braggin,bradywood,bottomed,bossa,bordello,bookshelf,boogida,bondsman,bolder,boggles,bludgeoned,blowtorch,blotter,blips,blemish,bleaching,blainetologists,blading,blabbermouth,birdseed,bimmel,biloxi,biggly,bianchinni,betadine,berenson,belus,belloq,begets,befitting,beepers,beelzebub,beefed,bedridden,bedevere,beckons,beaded,baubles,bauble,battleground,bathrobes,basketballs,basements,barroom,barnacle,barkin,barked,baretta,bangles,bangler,banality,bambang,baltar,ballplayers,bagman,baffles,backroom,babysat,baboons,averse,audiotape,auctioneer,atten,atcha,astonishment,arugula,arroz,antihistamines,annoyances,anesthesiology,anatomically,anachronism,amiable,amaretto,allahu,alight,aimin,ailment,afterglow,affronte,advil,adrenals,actualization,acrost,ached,accursed,accoutrements,absconded,aboveboard,abetted,aargh,aaaahh,zuwicky,zolda,ziploc,zakamatak,youve,yippie,yesterdays,yella,yearns,yearnings,yearned,yawning,yalta,yahtzee,y'mean,y'are,wuthering,wreaks,worrisome,workiiing,wooooooo,wonky,womanizing,wolodarsky,wiwith,withdraws,wishy,wisht,wipers,wiper,winos,windthorne,windsurfing,windermere,wiggled,wiggen,whwhat,whodunit,whoaaa,whittling,whitesnake,whereof,wheezing,wheeze,whatd'ya,whataya,whammo,whackin,wellll,weightless,weevil,wedgies,webbing,weasly,wayside,waxes,waturi,washy,washrooms,wandell,waitaminute,waddya,waaaah,vornac,vishnoor,virulent,vindictiveness,vinceres,villier,vigeous,vestigial,ventilate,vented,venereal,veering,veered,veddy,vaslova,valosky,vailsburg,vaginas,vagas,urethra,upstaged,uploading,unwrapping,unwieldy,untapped,unsatisfied,unquenchable,unnerved,unmentionable,unlovable,unknowns,uninformed,unimpressed,unhappily,unguarded,unexplored,undergarment,undeniably,unclench,unclaimed,uncharacteristically,unbuttoned,unblemished,ululd,uhhhm,tweeze,tutsami,tushy,tuscarora,turkle,turghan,turbinium,tubers,trucoat,troxa,tropicana,triquetra,trimmers,triceps,trespassed,traya,traumatizing,transvestites,trainors,tradin,trackers,townies,tourelles,toucha,tossin,tortious,topshop,topes,tonics,tongs,tomsk,tomorrows,toiling,toddle,tizzy,tippers,timmi,thwap,thusly,ththe,thrusts,throwers,throwed,throughway,thickening,thermonuclear,thelwall,thataway,terrifically,tendons,teleportation,telepathically,telekinetic,teetering,teaspoons,tarantulas,tapas,tanned,tangling,tamales,tailors,tahitian,tactful,tachy,tablespoon,syrah,synchronicity,synch,synapses,swooning,switchman,swimsuits,sweltering,sweetly,suvolte,suslov,surfed,supposition,suppertime,supervillains,superfluous,superego,sunspots,sunning,sunless,sundress,suckah,succotash,sublevel,subbasement,studious,striping,strenuously,straights,stonewalled,stillness,stilettos,stevesy,steno,steenwyck,stargates,stammering,staedert,squiggly,squiggle,squashing,squaring,spreadsheet,spramp,spotters,sporto,spooking,splendido,spittin,spirulina,spiky,spate,spartacus,spacerun,soonest,something'll,someth,somepin,someone'll,sofas,soberly,sobered,snowmen,snowbank,snowballing,snivelling,sniffling,snakeskin,snagging,smush,smooter,smidgen,smackers,slumlord,slossum,slimmer,slighted,sleepwalk,sleazeball,skokie,skeptic,sitarides,sistah,sipped,sindell,simpletons,simony,silkwood,silks,silken,sightless,sideboard,shuttles,shrugging,shrouds,showy,shoveled,shouldn'ta,shoplifters,shitstorm,sheeny,shapetype,shaming,shallows,shackle,shabbily,shabbas,seppuku,senility,semite,semiautomatic,selznick,secretarial,sebacio,scuzzy,scummy,scrutinized,scrunchie,scribbled,scotches,scolded,scissor,schlub,scavenging,scarin,scarfing,scallions,scald,savour,savored,saute,sarcoidosis,sandbar,saluted,salish,saith,sailboats,sagittarius,sacre,saccharine,sacamano,rushdie,rumpled,rumba,rulebook,rubbers,roughage,rotisserie,rootie,roofy,roofie,romanticize,rittle,ristorante,rippin,rinsing,ringin,rincess,rickety,reveling,retest,retaliating,restorative,reston,restaurateur,reshoots,resetting,resentments,reprogramming,repossess,repartee,renzo,remore,remitting,remeber,relaxants,rejuvenate,rejections,regenerated,refocus,referrals,reeno,recycles,recrimination,reclining,recanting,reattach,reassigning,razgul,raved,rattlesnakes,rattles,rashly,raquetball,ransack,raisinettes,raheem,radisson,radishes,raban,quoth,qumari,quints,quilts,quilting,quien,quarreled,purty,purblind,punchbowl,publically,psychotics,psychopaths,psychoanalyze,pruning,provasik,protectin,propping,proportioned,prophylactic,proofed,prompter,procreate,proclivities,prioritizing,prinze,pricked,press'll,presets,prescribes,preocupe,prejudicial,prefex,preconceived,precipice,pralines,pragmatist,powerbar,pottie,pottersville,potsie,potholes,posses,posies,portkey,porterhouse,pornographers,poring,poppycock,poppers,pomponi,pokin,poitier,podiatry,pleeze,pleadings,playbook,platelets,plane'arium,placebos,place'll,pistachios,pirated,pinochle,pineapples,pinafore,pimples,piggly,piddling,picon,pickpockets,picchu,physiologically,physic,phobic,philandering,phenomenally,pheasants,pewter,petticoat,petronis,petitioning,perturbed,perpetuating,permutat,perishable,perimeters,perfumed,percocet,per'sus,pepperjack,penalize,pelting,pellet,peignoir,pedicures,peckers,pecans,pawning,paulsson,pattycake,patrolmen,patois,pathos,pasted,parishioner,parcheesi,parachuting,papayas,pantaloons,palpitations,palantine,paintballing,overtired,overstress,oversensitive,overnights,overexcited,overanxious,overachiever,outwitted,outvoted,outnumber,outlast,outlander,out've,orphey,orchestrating,openers,ooooooo,okies,ohhhhhhhhh,ohhhhhhhh,ogling,offbeat,obsessively,obeyed,o'hana,o'bannon,o'bannion,numpce,nummy,nuked,nuances,nourishing,nosedive,norbu,nomlies,nomine,nixed,nihilist,nightshift,newmeat,neglectful,neediness,needin,naphthalene,nanocytes,nanite,naivete,n'yeah,mystifying,myhnegon,mutating,musing,mulled,muggy,muerto,muckraker,muchachos,mountainside,motherless,mosquitos,morphed,mopped,moodoo,moncho,mollem,moisturiser,mohicans,mocks,mistresses,misspent,misinterpretation,miscarry,minuses,mindee,mimes,millisecond,milked,mightn't,mightier,mierzwiak,microchips,meyerling,mesmerizing,mershaw,meecrob,medicate,meddled,mckinnons,mcgewan,mcdunnough,mcats,mbien,matzah,matriarch,masturbated,masselin,martialed,marlboros,marksmanship,marinate,marchin,manicured,malnourished,malign,majorek,magnon,magnificently,macking,machiavellian,macdougal,macchiato,macaws,macanaw,m'self,lydells,lusts,lucite,lubricants,lopper,lopped,loneliest,lonelier,lomez,lojack,loath,liquefy,lippy,limps,likin,lightness,liesl,liebchen,licious,libris,libation,lhamo,leotards,leanin,laxatives,lavished,latka,lanyard,lanky,landmines,lameness,laddies,lacerated,labored,l'amour,kreskin,kovitch,kournikova,kootchy,konoss,knknow,knickety,knackety,kmart,klicks,kiwanis,kissable,kindergartners,kilter,kidnet,kid'll,kicky,kickbacks,kickback,kholokov,kewpie,kendo,katra,kareoke,kafelnikov,kabob,junjun,jumba,julep,jordie,jondy,jolson,jenoff,jawbone,janitorial,janiro,ipecac,invigorated,intruded,intros,intravenously,interruptus,interrogations,interject,interfacing,interestin,insuring,instilled,insensitivity,inscrutable,inroads,innards,inlaid,injector,ingratitude,infuriates,infra,infliction,indelicate,incubators,incrimination,inconveniencing,inconsolable,incestuous,incas,incarcerate,inbreeding,impudence,impressionists,impeached,impassioned,imipenem,idling,idiosyncrasies,icebergs,hypotensive,hydrochloride,hushed,humus,humph,hummm,hulking,hubcaps,hubald,howya,howbout,how'll,housebroken,hotwire,hotspots,hotheaded,horrace,hopsfield,honto,honkin,honeymoons,homewrecker,hombres,hollers,hollerin,hoedown,hoboes,hobbling,hobble,hoarse,hinky,highlighters,hexes,heru'ur,hernias,heppleman,hell're,heighten,heheheheheh,heheheh,hedging,heckling,heckled,heavyset,heatshield,heathens,heartthrob,headpiece,hayseed,haveo,hauls,hasten,harridan,harpoons,hardens,harcesis,harbouring,hangouts,halkein,haleh,halberstam,hairnet,hairdressers,hacky,haaaa,h'yah,gusta,gushy,gurgling,guilted,gruel,grudging,grrrrrr,grosses,groomsmen,griping,gravest,gratified,grated,goulash,goopy,goona,goodly,godliness,godawful,godamn,glycerin,glutes,glowy,globetrotters,glimpsed,glenville,glaucoma,girlscout,giraffes,gilbey,gigglepuss,ghora,gestating,gelato,geishas,gearshift,gayness,gasped,gaslighting,garretts,garba,gablyczyck,g'head,fumigating,fumbling,fudged,fuckwad,fuck're,fuchsia,fretting,freshest,frenchies,freezers,fredrica,fraziers,fraidy,foxholes,fourty,fossilized,forsake,forfeits,foreclosed,foreal,footsies,florists,flopped,floorshow,floorboard,flinching,flecks,flaubert,flatware,flatulence,flatlined,flashdance,flail,flagging,fiver,fitzy,fishsticks,finetti,finelli,finagle,filko,fieldstone,fibber,ferrini,feedin,feasting,favore,fathering,farrouhk,farmin,fairytale,fairservice,factoid,facedown,fabled,eyeballin,extortionist,exquisitely,expedited,exorcise,existentialist,execs,exculpatory,exacerbate,everthing,eventuality,evander,euphoric,euphemisms,estamos,erred,entitle,enquiries,enormity,enfants,endive,encyclopedias,emulating,embittered,effortless,ectopic,ecirc,easely,earphones,earmarks,dweller,durslar,durned,dunois,dunking,dunked,dumdum,dullard,dudleys,druthers,druggist,drossos,drooled,driveways,drippy,dreamless,drawstring,drang,drainpipe,dozing,dotes,dorkface,doorknobs,doohickey,donnatella,doncha,domicile,dokos,dobermans,dizzying,divola,ditsy,distaste,disservice,dislodged,dislodge,disinherit,disinformation,discounting,dinka,dimly,digesting,diello,diddling,dictatorships,dictators,diagnostician,devours,devilishly,detract,detoxing,detours,detente,destructs,desecrated,derris,deplore,deplete,demure,demolitions,demean,delish,delbruck,delaford,degaulle,deftly,deformity,deflate,definatly,defector,decrypted,decontamination,decapitate,decanter,dardis,dampener,damme,daddy'll,dabbling,dabbled,d'etre,d'argent,d'alene,d'agnasti,czechoslovakian,cymbal,cyberdyne,cutoffs,cuticle,curvaceous,curiousity,crowing,crowed,croutons,cropped,criminy,crescentis,crashers,cranwell,coverin,courtrooms,countenance,cosmically,cosign,corroboration,coroners,cornflakes,copperpot,copperhead,copacetic,coordsize,convulsing,consults,conjures,congenial,concealer,compactor,commercialism,cokey,cognizant,clunkers,clumsily,clucking,cloves,cloven,cloths,clothe,clods,clocking,clings,clavicle,classless,clashing,clanking,clanging,clamping,civvies,citywide,circulatory,circuited,chronisters,chromic,choos,chloroformed,chillun,cheesed,chatterbox,chaperoned,channukah,cerebellum,centerpieces,centerfold,ceecee,ccedil,cavorting,cavemen,cauterized,cauldwell,catting,caterine,cassiopeia,carves,cartwheel,carpeted,carob,caressing,carelessly,careening,capricious,capitalistic,capillaries,candidly,camaraderie,callously,calfskin,caddies,buttholes,busywork,busses,burps,burgomeister,bunkhouse,bungchow,bugler,buffets,buffed,brutish,brusque,bronchitis,bromden,brolly,broached,brewskis,brewin,brean,breadwinner,brana,bountiful,bouncin,bosoms,borgnine,bopping,bootlegs,booing,bombosity,bolting,boilerplate,bluey,blowback,blouses,bloodsuckers,bloodstained,bloat,bleeth,blackface,blackest,blackened,blacken,blackballed,blabs,blabbering,birdbrain,bipartisanship,biodegradable,biltmore,bilked,big'uns,bidet,besotted,bernheim,benegas,bendiga,belushi,bellboys,belittling,behinds,begone,bedsheets,beckoning,beaute,beaudine,beastly,beachfront,bathes,batak,baser,baseballs,barbella,bankrolling,bandaged,baerly,backlog,backin,babying,azkaban,awwwww,aviary,authorizes,austero,aunty,attics,atreus,astounded,astonish,artemus,arses,arintero,appraiser,apathetic,anybody'd,anxieties,anticlimactic,antar,anglos,angleman,anesthetist,androscoggin,andolini,andale,amway,amuck,amniocentesis,amnesiac,americano,amara,alvah,altruism,alternapalooza,alphabetize,alpaca,allus,allergist,alexandros,alaikum,akimbo,agoraphobia,agides,aggrhh,aftertaste,adoptions,adjuster,addictions,adamantium,activator,accomplishes,aberrant,aaaaargh,aaaaaaaaaaaaa,a'ight,zzzzzzz,zucchini,zookeeper,zirconia,zippers,zequiel,zellary,zeitgeist,zanuck,zagat,you'n,ylang,yes'm,yenta,yecchh,yecch,yawns,yankin,yahdah,yaaah,y'got,xeroxed,wwooww,wristwatch,wrangled,wouldst,worthiness,worshiping,wormy,wormtail,wormholes,woosh,wollsten,wolfing,woefully,wobbling,wintry,wingding,windstorm,windowtext,wiluna,wilting,wilted,willick,willenholly,wildflowers,wildebeest,whyyy,whoppers,whoaa,whizzing,whizz,whitest,whistled,whist,whinny,wheelies,whazzup,whatwhatwhaaat,whato,whatdya,what'dya,whacks,wewell,wetsuit,welluh,weeps,waylander,wavin,wassail,wasnt,warneford,warbucks,waltons,wallbanger,waiving,waitwait,vowing,voucher,vornoff,vorhees,voldemort,vivre,vittles,vindaloo,videogames,vichyssoise,vicarious,vesuvius,verguenza,ven't,velveteen,velour,velociraptor,vastness,vasectomies,vapors,vanderhof,valmont,validates,valiantly,vacuums,usurp,usernum,us'll,urinals,unyielding,unvarnished,unturned,untouchables,untangled,unsecured,unscramble,unreturned,unremarkable,unpretentious,unnerstand,unmade,unimpeachable,unfashionable,underwrite,underlining,underling,underestimates,underappreciated,uncouth,uncork,uncommonly,unclog,uncircumcised,unchallenged,uncas,unbuttoning,unapproved,unamerican,unafraid,umpteen,umhmm,uhwhy,ughuh,typewriters,twitches,twitched,twirly,twinkling,twinges,twiddling,turners,turnabout,tumblin,tryed,trowel,trousseau,trivialize,trifles,tribianni,trenchcoat,trembled,traumatize,transitory,transients,transfuse,transcribing,tranq,trampy,traipsed,trainin,trachea,traceable,touristy,toughie,toscanini,tortola,tortilla,torreon,toreador,tommorrow,tollbooth,tollans,toidy,togas,tofurkey,toddling,toddies,toasties,toadstool,to've,tingles,timin,timey,timetables,tightest,thuggee,thrusting,thrombus,throes,thrifty,thornharts,thinnest,thicket,thetas,thesulac,tethered,testaburger,tersenadine,terrif,terdlington,tepui,temping,tector,taxidermy,tastebuds,tartlets,tartabull,tar'd,tantamount,tangy,tangles,tamer,tabula,tabletops,tabithia,szechwan,synthedyne,svenjolly,svengali,survivalists,surmise,surfboards,surefire,suprise,supremacists,suppositories,superstore,supercilious,suntac,sunburned,summercliff,sullied,sugared,suckle,subtleties,substantiated,subsides,subliminal,subhuman,strowman,stroked,stroganoff,streetlight,straying,strainer,straighter,straightener,stoplight,stirrups,stewing,stereotyping,stepmommy,stephano,stashing,starshine,stairwells,squatsie,squandering,squalid,squabbling,squab,sprinkling,spreader,spongy,spokesmen,splintered,spittle,spitter,spiced,spews,spendin,spect,spearchucker,spatulas,southtown,soused,soshi,sorter,sorrowful,sooth,some'in,soliloquy,soiree,sodomized,sobriki,soaping,snows,snowcone,snitching,snitched,sneering,snausages,snaking,smoothed,smoochies,smarten,smallish,slushy,slurring,sluman,slithers,slippin,sleuthing,sleeveless,skinless,skillfully,sketchbook,skagnetti,sista,sinning,singularly,sinewy,silverlake,siguto,signorina,sieve,sidearms,shying,shunning,shtud,shrieks,shorting,shortbread,shopkeepers,shmancy,shizzit,shitheads,shitfaced,shipmates,shiftless,shelving,shedlow,shavings,shatters,sharifa,shampoos,shallots,shafter,sha'nauc,sextant,serviceable,sepsis,senores,sendin,semis,semanski,selflessly,seinfelds,seers,seeps,seductress,secaucus,sealant,scuttling,scusa,scrunched,scissorhands,schreber,schmancy,scamps,scalloped,savoir,savagery,sarong,sarnia,santangel,samool,sallow,salino,safecracker,sadism,sacrilegious,sabrini,sabath,s'aright,ruttheimer,rudest,rubbery,rousting,rotarian,roslin,roomed,romari,romanica,rolltop,rolfski,rockettes,roared,ringleader,riffing,ribcage,rewired,retrial,reting,resuscitated,restock,resale,reprogrammed,replicant,repentant,repellant,repays,repainting,renegotiating,rendez,remem,relived,relinquishes,relearn,relaxant,rekindling,rehydrate,refueled,refreshingly,refilling,reexamine,reeseman,redness,redeemable,redcoats,rectangles,recoup,reciprocated,reassessing,realy,realer,reachin,re'kali,rawlston,ravages,rappaports,ramoray,ramming,raindrops,rahesh,radials,racists,rabartu,quiches,quench,quarreling,quaintly,quadrants,putumayo,put'em,purifier,pureed,punitis,pullout,pukin,pudgy,puddings,puckering,pterodactyl,psychodrama,psats,protestations,protectee,prosaic,propositioned,proclivity,probed,printouts,prevision,pressers,preset,preposition,preempt,preemie,preconceptions,prancan,powerpuff,potties,potpie,poseur,porthole,poops,pooping,pomade,polyps,polymerized,politeness,polisher,polack,pocketknife,poatia,plebeian,playgroup,platonically,platitude,plastering,plasmapheresis,plaids,placemats,pizzazz,pintauro,pinstripes,pinpoints,pinkner,pincer,pimento,pileup,pilates,pigmen,pieeee,phrased,photocopies,phoebes,philistines,philanderer,pheromone,phasers,pfeffernuesse,pervs,perspire,personify,perservere,perplexed,perpetrating,perkiness,perjurer,periodontist,perfunctory,perdido,percodan,pentameter,pentacle,pensive,pensione,pennybaker,pennbrooke,penhall,pengin,penetti,penetrates,pegnoir,peeve,peephole,pectorals,peckin,peaky,peaksville,paxcow,paused,patted,parkishoff,parkers,pardoning,paraplegic,paraphrasing,paperers,papered,pangs,paneling,palooza,palmed,palmdale,palatable,pacify,pacified,owwwww,oversexed,overrides,overpaying,overdrawn,overcompensate,overcomes,overcharged,outmaneuver,outfoxed,oughtn't,ostentatious,oshun,orthopedist,or'derves,ophthalmologist,operagirl,oozes,oooooooh,onesie,omnis,omelets,oktoberfest,okeydoke,ofthe,ofher,obstetrical,obeys,obeah,o'henry,nyquil,nyanyanyanyah,nuttin,nutsy,nutball,nurhachi,numbskull,nullifies,nullification,nucking,nubbin,nourished,nonspecific,noing,noinch,nohoho,nobler,nitwits,newsprint,newspaperman,newscaster,neuropathy,netherworld,neediest,navasky,narcissists,napped,nafta,mache,mykonos,mutilating,mutherfucker,mutha,mutates,mutate,musn't,murchy,multitasking,mujeeb,mudslinging,muckraking,mousetrap,mourns,mournful,motherf,mostro,morphing,morphate,moralistic,moochy,mooching,monotonous,monopolize,monocle,molehill,moland,mofet,mockup,mobilizing,mmmmmmm,mitzvahs,mistreating,misstep,misjudge,misinformation,misdirected,miscarriages,miniskirt,mindwarped,minced,milquetoast,miguelito,mightily,midstream,midriff,mideast,microbe,methuselah,mesdames,mescal,men'll,memma,megaton,megara,megalomaniac,meeee,medulla,medivac,meaninglessness,mcnuggets,mccarthyism,maypole,may've,mauve,mateys,marshack,markles,marketable,mansiere,manservant,manse,manhandling,mallomars,malcontent,malaise,majesties,mainsail,mailmen,mahandra,magnolias,magnified,magev,maelstrom,machu,macado,m'boy,m'appelle,lustrous,lureen,lunges,lumped,lumberyard,lulled,luego,lucks,lubricated,loveseat,loused,lounger,loski,lorre,loora,looong,loonies,loincloth,lofts,lodgers,lobbing,loaner,livered,liqueur,ligourin,lifesaving,lifeguards,lifeblood,liaisons,let'em,lesbianism,lence,lemonlyman,legitimize,leadin,lazars,lazarro,lawyering,laugher,laudanum,latrines,lations,laters,lapels,lakefront,lahit,lafortunata,lachrymose,l'italien,kwaini,kruczynski,kramerica,kowtow,kovinsky,korsekov,kopek,knowakowski,knievel,knacks,kiowas,killington,kickball,keyworth,keymaster,kevie,keveral,kenyons,keggers,keepsakes,kechner,keaty,kavorka,karajan,kamerev,kaggs,jujyfruit,jostled,jonestown,jokey,joists,jocko,jimmied,jiggled,jests,jenzen,jenko,jellyman,jedediah,jealitosis,jaunty,jarmel,jankle,jagoff,jagielski,jackrabbits,jabbing,jabberjaw,izzat,irresponsibly,irrepressible,irregularity,irredeemable,inuvik,intuitions,intubated,intimates,interminable,interloper,intercostal,instyle,instigate,instantaneously,ining,ingrown,ingesting,infusing,infringe,infinitum,infact,inequities,indubitably,indisputable,indescribably,indentation,indefinable,incontrovertible,inconsequential,incompletes,incoherently,inclement,incidentals,inarticulate,inadequacies,imprudent,improprieties,imprison,imprinted,impressively,impostors,importante,imperious,impale,immodest,immobile,imbedded,imbecilic,illegals,idn't,hysteric,hypotenuse,hygienic,hyeah,hushpuppies,hunhh,humpback,humored,hummed,humiliates,humidifier,huggy,huggers,huckster,hotbed,hosing,hosers,horsehair,homebody,homebake,holing,holies,hoisting,hogwallop,hocks,hobbits,hoaxes,hmmmmm,hisses,hippest,hillbillies,hilarity,heurh,herniated,hermaphrodite,hennifer,hemlines,hemline,hemery,helplessness,helmsley,hellhound,heheheheh,heeey,hedda,heartbeats,heaped,healers,headstart,headsets,headlong,hawkland,havta,haulin,harvey'll,hanta,hansom,hangnail,handstand,handrail,handoff,hallucinogen,hallor,halitosis,haberdashery,gypped,guy'll,gumbel,guerillas,guava,guardrail,grunther,grunick,groppi,groomer,grodin,gripes,grinds,grifters,gretch,greevey,greasing,graveyards,grandkid,grainy,gouging,gooney,googly,goldmuff,goldenrod,goingo,godly,gobbledygook,gobbledegook,glues,gloriously,glengarry,glassware,glamor,gimmicks,giggly,giambetti,ghoulish,ghettos,ghali,gether,geriatrics,gerbils,geosynchronous,georgio,gente,gendarme,gelbman,gazillionth,gayest,gauging,gastro,gaslight,gasbag,garters,garish,garas,gantu,gangy,gangly,gangland,galling,gadda,furrowed,funnies,funkytown,fugimotto,fudging,fuckeen,frustrates,froufrou,froot,fromberge,frizzies,fritters,frightfully,friendliest,freeloading,freelancing,freakazoid,fraternization,framers,fornication,fornicating,forethought,footstool,foisting,focussing,focking,flurries,fluffed,flintstones,fledermaus,flayed,flawlessly,flatters,flashbang,flapped,fishies,firmer,fireproof,firebug,fingerpainting,finessed,findin,financials,finality,fillets,fiercest,fiefdom,fibbing,fervor,fentanyl,fenelon,fedorchuk,feckless,feathering,faucets,farewells,fantasyland,fanaticism,faltered,faggy,faberge,extorting,extorted,exterminating,exhumation,exhilaration,exhausts,exfoliate,excels,exasperating,exacting,everybody'd,evasions,espressos,esmail,errrr,erratically,eroding,ernswiler,epcot,enthralled,ensenada,enriching,enrage,enhancer,endear,encrusted,encino,empathic,embezzle,emanates,electricians,eking,egomaniacal,egging,effacing,ectoplasm,eavesdropped,dummkopf,dugray,duchaisne,drunkard,drudge,droop,droids,drips,dripped,dribbles,drazens,downy,downsize,downpour,dosages,doppelganger,dopes,doohicky,dontcha,doneghy,divining,divest,diuretics,diuretic,distrustful,disrupts,dismemberment,dismember,disinfect,disillusionment,disheartening,discourteous,discotheque,discolored,dirtiest,diphtheria,dinks,dimpled,didya,dickwad,diatribes,diathesis,diabetics,deviants,detonates,detests,detestable,detaining,despondent,desecration,derision,derailing,deputized,depressors,dependant,dentures,denominators,demur,demonology,delts,dellarte,delacour,deflated,defib,defaced,decorators,deaqon,davola,datin,darwinian,darklighters,dandelions,dampened,damaskinos,dalrimple,d'peshu,d'hoffryn,d'astier,cynics,cutesy,cutaway,curmudgeon,curdle,culpability,cuisinart,cuffing,crypts,cryptid,crunched,crumblers,crudely,crosscheck,croon,crissake,crevasse,creswood,creepo,creases,creased,creaky,cranks,crabgrass,coveralls,couple'a,coughs,coslaw,corporeal,cornucopia,cornering,corks,cordoned,coolly,coolin,cookbooks,contrite,contented,constrictor,confound,confit,confiscating,condoned,conditioners,concussions,comprendo,comers,combustible,combusted,collingswood,coldness,coitus,codicil,coasting,clydesdale,cluttering,clunker,clunk,clumsiness,clotted,clothesline,clinches,clincher,cleverness,clench,clein,cleanses,claymores,clammed,chugging,chronically,christsakes,choque,chompers,chiseling,chirpy,chirp,chinks,chingachgook,chickenpox,chickadee,chewin,chessboard,chargin,chanteuse,chandeliers,chamdo,chagrined,chaff,certs,certainties,cerreno,cerebrum,censured,cemetary,caterwauling,cataclysmic,casitas,cased,carvel,carting,carrear,carolling,carolers,carnie,cardiogram,carbuncle,capulets,canines,candaules,canape,caldecott,calamitous,cadillacs,cachet,cabeza,cabdriver,buzzards,butai,businesswomen,bungled,bumpkins,bummers,bulldoze,buffybot,bubut,bubbies,brrrrr,brownout,brouhaha,bronzing,bronchial,broiler,briskly,briefcases,bricked,breezing,breeher,breakable,breadstick,bravenet,braved,brandies,brainwaves,brainiest,braggart,bradlee,boys're,boys'll,boys'd,boutonniere,bossed,bosomy,borans,boosts,bookshelves,bookends,boneless,bombarding,bollo,boinked,boink,bluest,bluebells,bloodshot,blockhead,blockbusters,blithely,blather,blankly,bladders,blackbeard,bitte,bippy,biogenetics,bilge,bigglesworth,bicuspids,beususe,betaseron,besmirch,bernece,bereavement,bentonville,benchley,benching,bembe,bellyaching,bellhops,belie,beleaguered,behrle,beginnin,begining,beenie,beefs,beechwood,becau,beaverhausen,beakers,bazillion,baudouin,barrytown,barringtons,barneys,barbs,barbers,barbatus,bankrupted,bailiffs,backslide,baby'd,baaad,b'fore,awwwk,aways,awakes,automatics,authenticate,aught,aubyn,attired,attagirl,atrophied,asystole,astroturf,assertiveness,artichokes,arquillians,aright,archenemy,appraise,appeased,antin,anspaugh,anesthetics,anaphylactic,amscray,ambivalence,amalio,alriiight,alphabetized,alpena,alouette,allora,alliteration,allenwood,allegiances,algerians,alcerro,alastor,ahaha,agitators,aforethought,advertises,admonition,adirondacks,adenoids,acupuncturist,acula,actuarial,activators,actionable,achingly,accusers,acclimated,acclimate,absurdly,absorbent,absolvo,absolutes,absences,abdomenizer,aaaaaaaaah,aaaaaaaaaa,a'right".split(","),
    male_names: "james,john,robert,michael,william,david,richard,charles,joseph,thomas,christopher,daniel,paul,mark,donald,george,kenneth,steven,edward,brian,ronald,anthony,kevin,jason,matthew,gary,timothy,jose,larry,jeffrey,frank,scott,eric,stephen,andrew,raymond,gregory,joshua,jerry,dennis,walter,patrick,peter,harold,douglas,henry,carl,arthur,ryan,roger,joe,juan,jack,albert,jonathan,justin,terry,gerald,keith,samuel,willie,ralph,lawrence,nicholas,roy,benjamin,bruce,brandon,adam,harry,fred,wayne,billy,steve,louis,jeremy,aaron,randy,eugene,carlos,russell,bobby,victor,ernest,phillip,todd,jesse,craig,alan,shawn,clarence,sean,philip,chris,johnny,earl,jimmy,antonio,danny,bryan,tony,luis,mike,stanley,leonard,nathan,dale,manuel,rodney,curtis,norman,marvin,vincent,glenn,jeffery,travis,jeff,chad,jacob,melvin,alfred,kyle,francis,bradley,jesus,herbert,frederick,ray,joel,edwin,don,eddie,ricky,troy,randall,barry,bernard,mario,leroy,francisco,marcus,micheal,theodore,clifford,miguel,oscar,jay,jim,tom,calvin,alex,jon,ronnie,bill,lloyd,tommy,leon,derek,darrell,jerome,floyd,leo,alvin,tim,wesley,dean,greg,jorge,dustin,pedro,derrick,dan,zachary,corey,herman,maurice,vernon,roberto,clyde,glen,hector,shane,ricardo,sam,rick,lester,brent,ramon,tyler,gilbert,gene,marc,reginald,ruben,brett,nathaniel,rafael,edgar,milton,raul,ben,cecil,duane,andre,elmer,brad,gabriel,ron,roland,jared,adrian,karl,cory,claude,erik,darryl,neil,christian,javier,fernando,clinton,ted,mathew,tyrone,darren,lonnie,lance,cody,julio,kurt,allan,clayton,hugh,max,dwayne,dwight,armando,felix,jimmie,everett,ian,ken,bob,jaime,casey,alfredo,alberto,dave,ivan,johnnie,sidney,byron,julian,isaac,clifton,willard,daryl,virgil,andy,salvador,kirk,sergio,seth,kent,terrance,rene,eduardo,terrence,enrique,freddie,stuart,fredrick,arturo,alejandro,joey,nick,luther,wendell,jeremiah,evan,julius,donnie,otis,trevor,luke,homer,gerard,doug,kenny,hubert,angelo,shaun,lyle,matt,alfonso,orlando,rex,carlton,ernesto,pablo,lorenzo,omar,wilbur,blake,horace,roderick,kerry,abraham,rickey,ira,andres,cesar,johnathan,malcolm,rudolph,damon,kelvin,rudy,preston,alton,archie,marco,pete,randolph,garry,geoffrey,jonathon,felipe,bennie,gerardo,dominic,loren,delbert,colin,guillermo,earnest,benny,noel,rodolfo,myron,edmund,salvatore,cedric,lowell,gregg,sherman,devin,sylvester,roosevelt,israel,jermaine,forrest,wilbert,leland,simon,irving,owen,rufus,woodrow,sammy,kristopher,levi,marcos,gustavo,jake,lionel,marty,gilberto,clint,nicolas,laurence,ismael,orville,drew,ervin,dewey,wilfred,josh,hugo,ignacio,caleb,tomas,sheldon,erick,frankie,darrel,rogelio,terence,alonzo,elias,bert,elbert,ramiro,conrad,noah,grady,phil,cornelius,lamar,rolando,clay,percy,bradford,merle,darin,amos,terrell,moses,irvin,saul,roman,darnell,randal,tommie,timmy,darrin,brendan,toby,van,abel,dominick,emilio,elijah,cary,domingo,aubrey,emmett,marlon,emanuel,jerald,edmond,emil,dewayne,otto,teddy,reynaldo,bret,jess,trent,humberto,emmanuel,stephan,louie,vicente,lamont,garland,micah,efrain,heath,rodger,demetrius,ethan,eldon,rocky,pierre,eli,bryce,antoine,robbie,kendall,royce,sterling,grover,elton,cleveland,dylan,chuck,damian,reuben,stan,leonardo,russel,erwin,benito,hans,monte,blaine,ernie,curt,quentin,agustin,jamal,devon,adolfo,tyson,wilfredo,bart,jarrod,vance,denis,damien,joaquin,harlan,desmond,elliot,darwin,gregorio,kermit,roscoe,esteban,anton,solomon,norbert,elvin,nolan,carey,rod,quinton,hal,brain,rob,elwood,kendrick,darius,moises,marlin,fidel,thaddeus,cliff,marcel,ali,raphael,bryon,armand,alvaro,jeffry,dane,joesph,thurman,ned,sammie,rusty,michel,monty,rory,fabian,reggie,kris,isaiah,gus,avery,loyd,diego,adolph,millard,rocco,gonzalo,derick,rodrigo,gerry,rigoberto,alphonso,rickie,noe,vern,elvis,bernardo,mauricio,hiram,donovan,basil,nickolas,scot,vince,quincy,eddy,sebastian,federico,ulysses,heriberto,donnell,denny,gavin,emery,romeo,jayson,dion,dante,clement,coy,odell,jarvis,bruno,issac,dudley,sanford,colby,carmelo,nestor,hollis,stefan,donny,linwood,beau,weldon,galen,isidro,truman,delmar,johnathon,silas,frederic,irwin,merrill,charley,marcelino,carlo,trenton,kurtis,aurelio,winfred,vito,collin,denver,leonel,emory,pasquale,mohammad,mariano,danial,landon,dirk,branden,adan,numbers,clair,buford,bernie,wilmer,emerson,zachery,jacques,errol,josue,edwardo,wilford,theron,raymundo,daren,tristan,robby,lincoln,jame,genaro,octavio,cornell,hung,arron,antony,herschel,alva,giovanni,garth,cyrus,cyril,ronny,stevie,lon,kennith,carmine,augustine,erich,chadwick,wilburn,russ,myles,jonas,mitchel,mervin,zane,jamel,lazaro,alphonse,randell,johnie,jarrett,ariel,abdul,dusty,luciano,seymour,scottie,eugenio,mohammed,arnulfo,lucien,ferdinand,thad,ezra,aldo,rubin,mitch,earle,abe,marquis,lanny,kareem,jamar,boris,isiah,emile,elmo,aron,leopoldo,everette,josef,eloy,dorian,rodrick,reinaldo,lucio,jerrod,weston,hershel,lemuel,lavern,burt,jules,gil,eliseo,ahmad,nigel,efren,antwan,alden,margarito,refugio,dino,osvaldo,les,deandre,normand,kieth,ivory,trey,norberto,napoleon,jerold,fritz,rosendo,milford,sang,deon,christoper,alfonzo,lyman,josiah,brant,wilton,rico,jamaal,dewitt,brenton,yong,olin,faustino,claudio,judson,gino,edgardo,alec,jarred,donn,trinidad,tad,porfirio,odis,lenard,chauncey,tod,mel,marcelo,kory,augustus,keven,hilario,bud,sal,orval,mauro,dannie,zachariah,olen,anibal,milo,jed,thanh,amado,lenny,tory,richie,horacio,brice,mohamed,delmer,dario,mac,jonah,jerrold,robt,hank,sung,rupert,rolland,kenton,damion,chi,antone,waldo,fredric,bradly,kip,burl,tyree,jefferey,ahmed,willy,stanford,oren,moshe,mikel,enoch,brendon,quintin,jamison,florencio,darrick,tobias,minh,hassan,giuseppe,demarcus,cletus,tyrell,lyndon,keenan,werner,theo,geraldo,columbus,chet,bertram,markus,huey,hilton,dwain,donte,tyron,omer,isaias,hipolito,fermin,chung,adalberto,jamey,teodoro,mckinley,maximo,raleigh,lawerence,abram,rashad,emmitt,daron,chong,samual,otha,miquel,eusebio,dong,domenic,darron,wilber,renato,hoyt,haywood,ezekiel,chas,florentino,elroy,clemente,arden,neville,edison,deshawn,carrol,shayne,nathanial,jordon,danilo,claud,sherwood,raymon,rayford,cristobal,ambrose,titus,hyman,felton,ezequiel,erasmo,lonny,milan,lino,jarod,herb,andreas,rhett,jude,douglass,cordell,oswaldo,ellsworth,virgilio,toney,nathanael,benedict,mose,hong,isreal,garret,fausto,arlen,zack,modesto,francesco,manual,gaylord,gaston,filiberto,deangelo,michale,granville,malik,zackary,tuan,nicky,cristopher,antione,malcom,korey,jospeh,colton,waylon,hosea,shad,santo,rudolf,rolf,renaldo,marcellus,lucius,kristofer,harland,arnoldo,rueben,leandro,kraig,jerrell,jeromy,hobert,cedrick,arlie,winford,wally,luigi,keneth,jacinto,graig,franklyn,edmundo,leif,jeramy,willian,vincenzo,shon,michal,lynwood,jere,elden,darell,broderick,alonso".split(",")
};
module.exports = $3daeed971962dd76$var$frequency_lists;

});

parcelRegister("271js", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $189d40e8fc2d78a5$var$adjacency_graphs;
$189d40e8fc2d78a5$var$adjacency_graphs = {
    qwerty: {
        "!": [
            "`~",
            null,
            null,
            "2@",
            "qQ",
            null
        ],
        "\"": [
            ";:",
            "[{",
            "]}",
            null,
            null,
            "/?"
        ],
        "#": [
            "2@",
            null,
            null,
            "4$",
            "eE",
            "wW"
        ],
        "$": [
            "3#",
            null,
            null,
            "5%",
            "rR",
            "eE"
        ],
        "%": [
            "4$",
            null,
            null,
            "6^",
            "tT",
            "rR"
        ],
        "&": [
            "6^",
            null,
            null,
            "8*",
            "uU",
            "yY"
        ],
        "'": [
            ";:",
            "[{",
            "]}",
            null,
            null,
            "/?"
        ],
        "(": [
            "8*",
            null,
            null,
            "0)",
            "oO",
            "iI"
        ],
        ")": [
            "9(",
            null,
            null,
            "-_",
            "pP",
            "oO"
        ],
        "*": [
            "7&",
            null,
            null,
            "9(",
            "iI",
            "uU"
        ],
        "+": [
            "-_",
            null,
            null,
            null,
            "]}",
            "[{"
        ],
        ",": [
            "mM",
            "kK",
            "lL",
            ".>",
            null,
            null
        ],
        "-": [
            "0)",
            null,
            null,
            "=+",
            "[{",
            "pP"
        ],
        ".": [
            ",<",
            "lL",
            ";:",
            "/?",
            null,
            null
        ],
        "/": [
            ".>",
            ";:",
            "'\"",
            null,
            null,
            null
        ],
        "0": [
            "9(",
            null,
            null,
            "-_",
            "pP",
            "oO"
        ],
        "1": [
            "`~",
            null,
            null,
            "2@",
            "qQ",
            null
        ],
        "2": [
            "1!",
            null,
            null,
            "3#",
            "wW",
            "qQ"
        ],
        "3": [
            "2@",
            null,
            null,
            "4$",
            "eE",
            "wW"
        ],
        "4": [
            "3#",
            null,
            null,
            "5%",
            "rR",
            "eE"
        ],
        "5": [
            "4$",
            null,
            null,
            "6^",
            "tT",
            "rR"
        ],
        "6": [
            "5%",
            null,
            null,
            "7&",
            "yY",
            "tT"
        ],
        "7": [
            "6^",
            null,
            null,
            "8*",
            "uU",
            "yY"
        ],
        "8": [
            "7&",
            null,
            null,
            "9(",
            "iI",
            "uU"
        ],
        "9": [
            "8*",
            null,
            null,
            "0)",
            "oO",
            "iI"
        ],
        ":": [
            "lL",
            "pP",
            "[{",
            "'\"",
            "/?",
            ".>"
        ],
        ";": [
            "lL",
            "pP",
            "[{",
            "'\"",
            "/?",
            ".>"
        ],
        "<": [
            "mM",
            "kK",
            "lL",
            ".>",
            null,
            null
        ],
        "=": [
            "-_",
            null,
            null,
            null,
            "]}",
            "[{"
        ],
        ">": [
            ",<",
            "lL",
            ";:",
            "/?",
            null,
            null
        ],
        "?": [
            ".>",
            ";:",
            "'\"",
            null,
            null,
            null
        ],
        "@": [
            "1!",
            null,
            null,
            "3#",
            "wW",
            "qQ"
        ],
        "A": [
            null,
            "qQ",
            "wW",
            "sS",
            "zZ",
            null
        ],
        "B": [
            "vV",
            "gG",
            "hH",
            "nN",
            null,
            null
        ],
        "C": [
            "xX",
            "dD",
            "fF",
            "vV",
            null,
            null
        ],
        "D": [
            "sS",
            "eE",
            "rR",
            "fF",
            "cC",
            "xX"
        ],
        "E": [
            "wW",
            "3#",
            "4$",
            "rR",
            "dD",
            "sS"
        ],
        "F": [
            "dD",
            "rR",
            "tT",
            "gG",
            "vV",
            "cC"
        ],
        "G": [
            "fF",
            "tT",
            "yY",
            "hH",
            "bB",
            "vV"
        ],
        "H": [
            "gG",
            "yY",
            "uU",
            "jJ",
            "nN",
            "bB"
        ],
        "I": [
            "uU",
            "8*",
            "9(",
            "oO",
            "kK",
            "jJ"
        ],
        "J": [
            "hH",
            "uU",
            "iI",
            "kK",
            "mM",
            "nN"
        ],
        "K": [
            "jJ",
            "iI",
            "oO",
            "lL",
            ",<",
            "mM"
        ],
        "L": [
            "kK",
            "oO",
            "pP",
            ";:",
            ".>",
            ",<"
        ],
        "M": [
            "nN",
            "jJ",
            "kK",
            ",<",
            null,
            null
        ],
        "N": [
            "bB",
            "hH",
            "jJ",
            "mM",
            null,
            null
        ],
        "O": [
            "iI",
            "9(",
            "0)",
            "pP",
            "lL",
            "kK"
        ],
        "P": [
            "oO",
            "0)",
            "-_",
            "[{",
            ";:",
            "lL"
        ],
        "Q": [
            null,
            "1!",
            "2@",
            "wW",
            "aA",
            null
        ],
        "R": [
            "eE",
            "4$",
            "5%",
            "tT",
            "fF",
            "dD"
        ],
        "S": [
            "aA",
            "wW",
            "eE",
            "dD",
            "xX",
            "zZ"
        ],
        "T": [
            "rR",
            "5%",
            "6^",
            "yY",
            "gG",
            "fF"
        ],
        "U": [
            "yY",
            "7&",
            "8*",
            "iI",
            "jJ",
            "hH"
        ],
        "V": [
            "cC",
            "fF",
            "gG",
            "bB",
            null,
            null
        ],
        "W": [
            "qQ",
            "2@",
            "3#",
            "eE",
            "sS",
            "aA"
        ],
        "X": [
            "zZ",
            "sS",
            "dD",
            "cC",
            null,
            null
        ],
        "Y": [
            "tT",
            "6^",
            "7&",
            "uU",
            "hH",
            "gG"
        ],
        "Z": [
            null,
            "aA",
            "sS",
            "xX",
            null,
            null
        ],
        "[": [
            "pP",
            "-_",
            "=+",
            "]}",
            "'\"",
            ";:"
        ],
        "\\": [
            "]}",
            null,
            null,
            null,
            null,
            null
        ],
        "]": [
            "[{",
            "=+",
            null,
            "\\|",
            null,
            "'\""
        ],
        "^": [
            "5%",
            null,
            null,
            "7&",
            "yY",
            "tT"
        ],
        "_": [
            "0)",
            null,
            null,
            "=+",
            "[{",
            "pP"
        ],
        "`": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ],
        "a": [
            null,
            "qQ",
            "wW",
            "sS",
            "zZ",
            null
        ],
        "b": [
            "vV",
            "gG",
            "hH",
            "nN",
            null,
            null
        ],
        "c": [
            "xX",
            "dD",
            "fF",
            "vV",
            null,
            null
        ],
        "d": [
            "sS",
            "eE",
            "rR",
            "fF",
            "cC",
            "xX"
        ],
        "e": [
            "wW",
            "3#",
            "4$",
            "rR",
            "dD",
            "sS"
        ],
        "f": [
            "dD",
            "rR",
            "tT",
            "gG",
            "vV",
            "cC"
        ],
        "g": [
            "fF",
            "tT",
            "yY",
            "hH",
            "bB",
            "vV"
        ],
        "h": [
            "gG",
            "yY",
            "uU",
            "jJ",
            "nN",
            "bB"
        ],
        "i": [
            "uU",
            "8*",
            "9(",
            "oO",
            "kK",
            "jJ"
        ],
        "j": [
            "hH",
            "uU",
            "iI",
            "kK",
            "mM",
            "nN"
        ],
        "k": [
            "jJ",
            "iI",
            "oO",
            "lL",
            ",<",
            "mM"
        ],
        "l": [
            "kK",
            "oO",
            "pP",
            ";:",
            ".>",
            ",<"
        ],
        "m": [
            "nN",
            "jJ",
            "kK",
            ",<",
            null,
            null
        ],
        "n": [
            "bB",
            "hH",
            "jJ",
            "mM",
            null,
            null
        ],
        "o": [
            "iI",
            "9(",
            "0)",
            "pP",
            "lL",
            "kK"
        ],
        "p": [
            "oO",
            "0)",
            "-_",
            "[{",
            ";:",
            "lL"
        ],
        "q": [
            null,
            "1!",
            "2@",
            "wW",
            "aA",
            null
        ],
        "r": [
            "eE",
            "4$",
            "5%",
            "tT",
            "fF",
            "dD"
        ],
        "s": [
            "aA",
            "wW",
            "eE",
            "dD",
            "xX",
            "zZ"
        ],
        "t": [
            "rR",
            "5%",
            "6^",
            "yY",
            "gG",
            "fF"
        ],
        "u": [
            "yY",
            "7&",
            "8*",
            "iI",
            "jJ",
            "hH"
        ],
        "v": [
            "cC",
            "fF",
            "gG",
            "bB",
            null,
            null
        ],
        "w": [
            "qQ",
            "2@",
            "3#",
            "eE",
            "sS",
            "aA"
        ],
        "x": [
            "zZ",
            "sS",
            "dD",
            "cC",
            null,
            null
        ],
        "y": [
            "tT",
            "6^",
            "7&",
            "uU",
            "hH",
            "gG"
        ],
        "z": [
            null,
            "aA",
            "sS",
            "xX",
            null,
            null
        ],
        "{": [
            "pP",
            "-_",
            "=+",
            "]}",
            "'\"",
            ";:"
        ],
        "|": [
            "]}",
            null,
            null,
            null,
            null,
            null
        ],
        "}": [
            "[{",
            "=+",
            null,
            "\\|",
            null,
            "'\""
        ],
        "~": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ]
    },
    dvorak: {
        "!": [
            "`~",
            null,
            null,
            "2@",
            "'\"",
            null
        ],
        "\"": [
            null,
            "1!",
            "2@",
            ",<",
            "aA",
            null
        ],
        "#": [
            "2@",
            null,
            null,
            "4$",
            ".>",
            ",<"
        ],
        "$": [
            "3#",
            null,
            null,
            "5%",
            "pP",
            ".>"
        ],
        "%": [
            "4$",
            null,
            null,
            "6^",
            "yY",
            "pP"
        ],
        "&": [
            "6^",
            null,
            null,
            "8*",
            "gG",
            "fF"
        ],
        "'": [
            null,
            "1!",
            "2@",
            ",<",
            "aA",
            null
        ],
        "(": [
            "8*",
            null,
            null,
            "0)",
            "rR",
            "cC"
        ],
        ")": [
            "9(",
            null,
            null,
            "[{",
            "lL",
            "rR"
        ],
        "*": [
            "7&",
            null,
            null,
            "9(",
            "cC",
            "gG"
        ],
        "+": [
            "/?",
            "]}",
            null,
            "\\|",
            null,
            "-_"
        ],
        ",": [
            "'\"",
            "2@",
            "3#",
            ".>",
            "oO",
            "aA"
        ],
        "-": [
            "sS",
            "/?",
            "=+",
            null,
            null,
            "zZ"
        ],
        ".": [
            ",<",
            "3#",
            "4$",
            "pP",
            "eE",
            "oO"
        ],
        "/": [
            "lL",
            "[{",
            "]}",
            "=+",
            "-_",
            "sS"
        ],
        "0": [
            "9(",
            null,
            null,
            "[{",
            "lL",
            "rR"
        ],
        "1": [
            "`~",
            null,
            null,
            "2@",
            "'\"",
            null
        ],
        "2": [
            "1!",
            null,
            null,
            "3#",
            ",<",
            "'\""
        ],
        "3": [
            "2@",
            null,
            null,
            "4$",
            ".>",
            ",<"
        ],
        "4": [
            "3#",
            null,
            null,
            "5%",
            "pP",
            ".>"
        ],
        "5": [
            "4$",
            null,
            null,
            "6^",
            "yY",
            "pP"
        ],
        "6": [
            "5%",
            null,
            null,
            "7&",
            "fF",
            "yY"
        ],
        "7": [
            "6^",
            null,
            null,
            "8*",
            "gG",
            "fF"
        ],
        "8": [
            "7&",
            null,
            null,
            "9(",
            "cC",
            "gG"
        ],
        "9": [
            "8*",
            null,
            null,
            "0)",
            "rR",
            "cC"
        ],
        ":": [
            null,
            "aA",
            "oO",
            "qQ",
            null,
            null
        ],
        ";": [
            null,
            "aA",
            "oO",
            "qQ",
            null,
            null
        ],
        "<": [
            "'\"",
            "2@",
            "3#",
            ".>",
            "oO",
            "aA"
        ],
        "=": [
            "/?",
            "]}",
            null,
            "\\|",
            null,
            "-_"
        ],
        ">": [
            ",<",
            "3#",
            "4$",
            "pP",
            "eE",
            "oO"
        ],
        "?": [
            "lL",
            "[{",
            "]}",
            "=+",
            "-_",
            "sS"
        ],
        "@": [
            "1!",
            null,
            null,
            "3#",
            ",<",
            "'\""
        ],
        "A": [
            null,
            "'\"",
            ",<",
            "oO",
            ";:",
            null
        ],
        "B": [
            "xX",
            "dD",
            "hH",
            "mM",
            null,
            null
        ],
        "C": [
            "gG",
            "8*",
            "9(",
            "rR",
            "tT",
            "hH"
        ],
        "D": [
            "iI",
            "fF",
            "gG",
            "hH",
            "bB",
            "xX"
        ],
        "E": [
            "oO",
            ".>",
            "pP",
            "uU",
            "jJ",
            "qQ"
        ],
        "F": [
            "yY",
            "6^",
            "7&",
            "gG",
            "dD",
            "iI"
        ],
        "G": [
            "fF",
            "7&",
            "8*",
            "cC",
            "hH",
            "dD"
        ],
        "H": [
            "dD",
            "gG",
            "cC",
            "tT",
            "mM",
            "bB"
        ],
        "I": [
            "uU",
            "yY",
            "fF",
            "dD",
            "xX",
            "kK"
        ],
        "J": [
            "qQ",
            "eE",
            "uU",
            "kK",
            null,
            null
        ],
        "K": [
            "jJ",
            "uU",
            "iI",
            "xX",
            null,
            null
        ],
        "L": [
            "rR",
            "0)",
            "[{",
            "/?",
            "sS",
            "nN"
        ],
        "M": [
            "bB",
            "hH",
            "tT",
            "wW",
            null,
            null
        ],
        "N": [
            "tT",
            "rR",
            "lL",
            "sS",
            "vV",
            "wW"
        ],
        "O": [
            "aA",
            ",<",
            ".>",
            "eE",
            "qQ",
            ";:"
        ],
        "P": [
            ".>",
            "4$",
            "5%",
            "yY",
            "uU",
            "eE"
        ],
        "Q": [
            ";:",
            "oO",
            "eE",
            "jJ",
            null,
            null
        ],
        "R": [
            "cC",
            "9(",
            "0)",
            "lL",
            "nN",
            "tT"
        ],
        "S": [
            "nN",
            "lL",
            "/?",
            "-_",
            "zZ",
            "vV"
        ],
        "T": [
            "hH",
            "cC",
            "rR",
            "nN",
            "wW",
            "mM"
        ],
        "U": [
            "eE",
            "pP",
            "yY",
            "iI",
            "kK",
            "jJ"
        ],
        "V": [
            "wW",
            "nN",
            "sS",
            "zZ",
            null,
            null
        ],
        "W": [
            "mM",
            "tT",
            "nN",
            "vV",
            null,
            null
        ],
        "X": [
            "kK",
            "iI",
            "dD",
            "bB",
            null,
            null
        ],
        "Y": [
            "pP",
            "5%",
            "6^",
            "fF",
            "iI",
            "uU"
        ],
        "Z": [
            "vV",
            "sS",
            "-_",
            null,
            null,
            null
        ],
        "[": [
            "0)",
            null,
            null,
            "]}",
            "/?",
            "lL"
        ],
        "\\": [
            "=+",
            null,
            null,
            null,
            null,
            null
        ],
        "]": [
            "[{",
            null,
            null,
            null,
            "=+",
            "/?"
        ],
        "^": [
            "5%",
            null,
            null,
            "7&",
            "fF",
            "yY"
        ],
        "_": [
            "sS",
            "/?",
            "=+",
            null,
            null,
            "zZ"
        ],
        "`": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ],
        "a": [
            null,
            "'\"",
            ",<",
            "oO",
            ";:",
            null
        ],
        "b": [
            "xX",
            "dD",
            "hH",
            "mM",
            null,
            null
        ],
        "c": [
            "gG",
            "8*",
            "9(",
            "rR",
            "tT",
            "hH"
        ],
        "d": [
            "iI",
            "fF",
            "gG",
            "hH",
            "bB",
            "xX"
        ],
        "e": [
            "oO",
            ".>",
            "pP",
            "uU",
            "jJ",
            "qQ"
        ],
        "f": [
            "yY",
            "6^",
            "7&",
            "gG",
            "dD",
            "iI"
        ],
        "g": [
            "fF",
            "7&",
            "8*",
            "cC",
            "hH",
            "dD"
        ],
        "h": [
            "dD",
            "gG",
            "cC",
            "tT",
            "mM",
            "bB"
        ],
        "i": [
            "uU",
            "yY",
            "fF",
            "dD",
            "xX",
            "kK"
        ],
        "j": [
            "qQ",
            "eE",
            "uU",
            "kK",
            null,
            null
        ],
        "k": [
            "jJ",
            "uU",
            "iI",
            "xX",
            null,
            null
        ],
        "l": [
            "rR",
            "0)",
            "[{",
            "/?",
            "sS",
            "nN"
        ],
        "m": [
            "bB",
            "hH",
            "tT",
            "wW",
            null,
            null
        ],
        "n": [
            "tT",
            "rR",
            "lL",
            "sS",
            "vV",
            "wW"
        ],
        "o": [
            "aA",
            ",<",
            ".>",
            "eE",
            "qQ",
            ";:"
        ],
        "p": [
            ".>",
            "4$",
            "5%",
            "yY",
            "uU",
            "eE"
        ],
        "q": [
            ";:",
            "oO",
            "eE",
            "jJ",
            null,
            null
        ],
        "r": [
            "cC",
            "9(",
            "0)",
            "lL",
            "nN",
            "tT"
        ],
        "s": [
            "nN",
            "lL",
            "/?",
            "-_",
            "zZ",
            "vV"
        ],
        "t": [
            "hH",
            "cC",
            "rR",
            "nN",
            "wW",
            "mM"
        ],
        "u": [
            "eE",
            "pP",
            "yY",
            "iI",
            "kK",
            "jJ"
        ],
        "v": [
            "wW",
            "nN",
            "sS",
            "zZ",
            null,
            null
        ],
        "w": [
            "mM",
            "tT",
            "nN",
            "vV",
            null,
            null
        ],
        "x": [
            "kK",
            "iI",
            "dD",
            "bB",
            null,
            null
        ],
        "y": [
            "pP",
            "5%",
            "6^",
            "fF",
            "iI",
            "uU"
        ],
        "z": [
            "vV",
            "sS",
            "-_",
            null,
            null,
            null
        ],
        "{": [
            "0)",
            null,
            null,
            "]}",
            "/?",
            "lL"
        ],
        "|": [
            "=+",
            null,
            null,
            null,
            null,
            null
        ],
        "}": [
            "[{",
            null,
            null,
            null,
            "=+",
            "/?"
        ],
        "~": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ]
    },
    keypad: {
        "*": [
            "/",
            null,
            null,
            null,
            "-",
            "+",
            "9",
            "8"
        ],
        "+": [
            "9",
            "*",
            "-",
            null,
            null,
            null,
            null,
            "6"
        ],
        "-": [
            "*",
            null,
            null,
            null,
            null,
            null,
            "+",
            "9"
        ],
        ".": [
            "0",
            "2",
            "3",
            null,
            null,
            null,
            null,
            null
        ],
        "/": [
            null,
            null,
            null,
            null,
            "*",
            "9",
            "8",
            "7"
        ],
        "0": [
            null,
            "1",
            "2",
            "3",
            ".",
            null,
            null,
            null
        ],
        "1": [
            null,
            null,
            "4",
            "5",
            "2",
            "0",
            null,
            null
        ],
        "2": [
            "1",
            "4",
            "5",
            "6",
            "3",
            ".",
            "0",
            null
        ],
        "3": [
            "2",
            "5",
            "6",
            null,
            null,
            null,
            ".",
            "0"
        ],
        "4": [
            null,
            null,
            "7",
            "8",
            "5",
            "2",
            "1",
            null
        ],
        "5": [
            "4",
            "7",
            "8",
            "9",
            "6",
            "3",
            "2",
            "1"
        ],
        "6": [
            "5",
            "8",
            "9",
            "+",
            null,
            null,
            "3",
            "2"
        ],
        "7": [
            null,
            null,
            null,
            "/",
            "8",
            "5",
            "4",
            null
        ],
        "8": [
            "7",
            null,
            "/",
            "*",
            "9",
            "6",
            "5",
            "4"
        ],
        "9": [
            "8",
            "/",
            "*",
            "-",
            "+",
            null,
            "6",
            "5"
        ]
    },
    mac_keypad: {
        "*": [
            "/",
            null,
            null,
            null,
            null,
            null,
            "-",
            "9"
        ],
        "+": [
            "6",
            "9",
            "-",
            null,
            null,
            null,
            null,
            "3"
        ],
        "-": [
            "9",
            "/",
            "*",
            null,
            null,
            null,
            "+",
            "6"
        ],
        ".": [
            "0",
            "2",
            "3",
            null,
            null,
            null,
            null,
            null
        ],
        "/": [
            "=",
            null,
            null,
            null,
            "*",
            "-",
            "9",
            "8"
        ],
        "0": [
            null,
            "1",
            "2",
            "3",
            ".",
            null,
            null,
            null
        ],
        "1": [
            null,
            null,
            "4",
            "5",
            "2",
            "0",
            null,
            null
        ],
        "2": [
            "1",
            "4",
            "5",
            "6",
            "3",
            ".",
            "0",
            null
        ],
        "3": [
            "2",
            "5",
            "6",
            "+",
            null,
            null,
            ".",
            "0"
        ],
        "4": [
            null,
            null,
            "7",
            "8",
            "5",
            "2",
            "1",
            null
        ],
        "5": [
            "4",
            "7",
            "8",
            "9",
            "6",
            "3",
            "2",
            "1"
        ],
        "6": [
            "5",
            "8",
            "9",
            "-",
            "+",
            null,
            "3",
            "2"
        ],
        "7": [
            null,
            null,
            null,
            "=",
            "8",
            "5",
            "4",
            null
        ],
        "8": [
            "7",
            null,
            "=",
            "/",
            "9",
            "6",
            "5",
            "4"
        ],
        "9": [
            "8",
            "=",
            "/",
            "*",
            "-",
            "+",
            "6",
            "5"
        ],
        "=": [
            null,
            null,
            null,
            null,
            "/",
            "9",
            "8",
            "7"
        ]
    }
};
module.exports = $189d40e8fc2d78a5$var$adjacency_graphs;

});

parcelRegister("fWMoF", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $b9c1d068d37b09f7$var$BRUTEFORCE_CARDINALITY, $b9c1d068d37b09f7$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE, $b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR, $b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR, $b9c1d068d37b09f7$var$adjacency_graphs, $b9c1d068d37b09f7$var$calc_average_degree, $b9c1d068d37b09f7$var$k, $b9c1d068d37b09f7$var$scoring, $b9c1d068d37b09f7$var$v;

$b9c1d068d37b09f7$var$adjacency_graphs = (parcelRequire("271js"));
$b9c1d068d37b09f7$var$calc_average_degree = function(graph) {
    var average, k, key, n, neighbors, v;
    average = 0;
    for(key in graph){
        neighbors = graph[key];
        average += function() {
            var len, o, results;
            results = [];
            for(o = 0, len = neighbors.length; o < len; o++){
                n = neighbors[o];
                if (n) results.push(n);
            }
            return results;
        }().length;
    }
    average /= function() {
        var results;
        results = [];
        for(k in graph){
            v = graph[k];
            results.push(k);
        }
        return results;
    }().length;
    return average;
};
$b9c1d068d37b09f7$var$BRUTEFORCE_CARDINALITY = 10;
$b9c1d068d37b09f7$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE = 10000;
$b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR = 10;
$b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR = 50;
$b9c1d068d37b09f7$var$scoring = {
    nCk: function(n, k) {
        var d, o, r, ref;
        if (k > n) return 0;
        if (k === 0) return 1;
        r = 1;
        for(d = o = 1, ref = k; 1 <= ref ? o <= ref : o >= ref; d = 1 <= ref ? ++o : --o){
            r *= n;
            r /= d;
            n -= 1;
        }
        return r;
    },
    log10: function(n) {
        return Math.log(n) / Math.log(10);
    },
    log2: function(n) {
        return Math.log(n) / Math.log(2);
    },
    factorial: function(n) {
        var f, i, o, ref;
        if (n < 2) return 1;
        f = 1;
        for(i = o = 2, ref = n; 2 <= ref ? o <= ref : o >= ref; i = 2 <= ref ? ++o : --o)f *= i;
        return f;
    },
    most_guessable_match_sequence: function(password, matches, _exclude_additive) {
        var _, bruteforce_update, guesses, k, l, len, len1, len2, lst, m, make_bruteforce_match, matches_by_j, n, o, optimal, optimal_l, optimal_match_sequence, q, ref, ref1, u, unwind, update, w;
        if (_exclude_additive == null) _exclude_additive = false;
        n = password.length;
        matches_by_j = function() {
            var o, ref, results;
            results = [];
            for(_ = o = 0, ref = n; 0 <= ref ? o < ref : o > ref; _ = 0 <= ref ? ++o : --o)results.push([]);
            return results;
        }();
        for(o = 0, len = matches.length; o < len; o++){
            m = matches[o];
            matches_by_j[m.j].push(m);
        }
        for(q = 0, len1 = matches_by_j.length; q < len1; q++){
            lst = matches_by_j[q];
            lst.sort(function(m1, m2) {
                return m1.i - m2.i;
            });
        }
        optimal = {
            m: function() {
                var ref, results, u;
                results = [];
                for(_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u)results.push({});
                return results;
            }(),
            pi: function() {
                var ref, results, u;
                results = [];
                for(_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u)results.push({});
                return results;
            }(),
            g: function() {
                var ref, results, u;
                results = [];
                for(_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u)results.push({});
                return results;
            }()
        };
        update = function(_this) {
            return function(m, l) {
                var competing_g, competing_l, g, k, pi, ref;
                k = m.j;
                pi = _this.estimate_guesses(m, password);
                if (l > 1) pi *= optimal.pi[m.i - 1][l - 1];
                g = _this.factorial(l) * pi;
                if (!_exclude_additive) g += Math.pow($b9c1d068d37b09f7$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE, l - 1);
                ref = optimal.g[k];
                for(competing_l in ref){
                    competing_g = ref[competing_l];
                    if (competing_l > l) continue;
                    if (competing_g <= g) return;
                }
                optimal.g[k][l] = g;
                optimal.m[k][l] = m;
                return optimal.pi[k][l] = pi;
            };
        }(this);
        bruteforce_update = function(_this) {
            return function(k) {
                var i, l, last_m, ref, results, u;
                m = make_bruteforce_match(0, k);
                update(m, 1);
                results = [];
                for(i = u = 1, ref = k; 1 <= ref ? u <= ref : u >= ref; i = 1 <= ref ? ++u : --u){
                    m = make_bruteforce_match(i, k);
                    results.push(function() {
                        var ref1, results1;
                        ref1 = optimal.m[i - 1];
                        results1 = [];
                        for(l in ref1){
                            last_m = ref1[l];
                            l = parseInt(l);
                            if (last_m.pattern === 'bruteforce') continue;
                            results1.push(update(m, l + 1));
                        }
                        return results1;
                    }());
                }
                return results;
            };
        }(this);
        make_bruteforce_match = function(_this) {
            return function(i, j) {
                return {
                    pattern: 'bruteforce',
                    token: password.slice(i, +j + 1 || 9e9),
                    i: i,
                    j: j
                };
            };
        }(this);
        unwind = function(_this) {
            return function(n) {
                var candidate_g, candidate_l, g, k, l, optimal_match_sequence, ref;
                optimal_match_sequence = [];
                k = n - 1;
                l = void 0;
                g = Infinity;
                ref = optimal.g[k];
                for(candidate_l in ref){
                    candidate_g = ref[candidate_l];
                    if (candidate_g < g) {
                        l = candidate_l;
                        g = candidate_g;
                    }
                }
                while(k >= 0){
                    m = optimal.m[k][l];
                    optimal_match_sequence.unshift(m);
                    k = m.i - 1;
                    l--;
                }
                return optimal_match_sequence;
            };
        }(this);
        for(k = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; k = 0 <= ref ? ++u : --u){
            ref1 = matches_by_j[k];
            for(w = 0, len2 = ref1.length; w < len2; w++){
                m = ref1[w];
                if (m.i > 0) for(l in optimal.m[m.i - 1]){
                    l = parseInt(l);
                    update(m, l + 1);
                }
                else update(m, 1);
            }
            bruteforce_update(k);
        }
        optimal_match_sequence = unwind(n);
        optimal_l = optimal_match_sequence.length;
        if (password.length === 0) guesses = 1;
        else guesses = optimal.g[n - 1][optimal_l];
        return {
            password: password,
            guesses: guesses,
            guesses_log10: this.log10(guesses),
            sequence: optimal_match_sequence
        };
    },
    estimate_guesses: function(match, password) {
        var estimation_functions, guesses, min_guesses;
        if (match.guesses != null) return match.guesses;
        min_guesses = 1;
        if (match.token.length < password.length) min_guesses = match.token.length === 1 ? $b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR : $b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR;
        estimation_functions = {
            bruteforce: this.bruteforce_guesses,
            dictionary: this.dictionary_guesses,
            spatial: this.spatial_guesses,
            repeat: this.repeat_guesses,
            sequence: this.sequence_guesses,
            regex: this.regex_guesses,
            date: this.date_guesses
        };
        guesses = estimation_functions[match.pattern].call(this, match);
        match.guesses = Math.max(guesses, min_guesses);
        match.guesses_log10 = this.log10(match.guesses);
        return match.guesses;
    },
    bruteforce_guesses: function(match) {
        var guesses, min_guesses;
        guesses = Math.pow($b9c1d068d37b09f7$var$BRUTEFORCE_CARDINALITY, match.token.length);
        if (guesses === Number.POSITIVE_INFINITY) guesses = Number.MAX_VALUE;
        min_guesses = match.token.length === 1 ? $b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR + 1 : $b9c1d068d37b09f7$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR + 1;
        return Math.max(guesses, min_guesses);
    },
    repeat_guesses: function(match) {
        return match.base_guesses * match.repeat_count;
    },
    sequence_guesses: function(match) {
        var base_guesses, first_chr;
        first_chr = match.token.charAt(0);
        if (first_chr === 'a' || first_chr === 'A' || first_chr === 'z' || first_chr === 'Z' || first_chr === '0' || first_chr === '1' || first_chr === '9') base_guesses = 4;
        else if (first_chr.match(/\d/)) base_guesses = 10;
        else base_guesses = 26;
        if (!match.ascending) base_guesses *= 2;
        return base_guesses * match.token.length;
    },
    MIN_YEAR_SPACE: 20,
    REFERENCE_YEAR: new Date().getFullYear(),
    regex_guesses: function(match) {
        var char_class_bases, year_space;
        char_class_bases = {
            alpha_lower: 26,
            alpha_upper: 26,
            alpha: 52,
            alphanumeric: 62,
            digits: 10,
            symbols: 33
        };
        if (match.regex_name in char_class_bases) return Math.pow(char_class_bases[match.regex_name], match.token.length);
        else switch(match.regex_name){
            case 'recent_year':
                year_space = Math.abs(parseInt(match.regex_match[0]) - this.REFERENCE_YEAR);
                year_space = Math.max(year_space, this.MIN_YEAR_SPACE);
                return year_space;
        }
    },
    date_guesses: function(match) {
        var guesses, year_space;
        year_space = Math.max(Math.abs(match.year - this.REFERENCE_YEAR), this.MIN_YEAR_SPACE);
        guesses = year_space * 365;
        if (match.separator) guesses *= 4;
        return guesses;
    },
    KEYBOARD_AVERAGE_DEGREE: $b9c1d068d37b09f7$var$calc_average_degree($b9c1d068d37b09f7$var$adjacency_graphs.qwerty),
    KEYPAD_AVERAGE_DEGREE: $b9c1d068d37b09f7$var$calc_average_degree($b9c1d068d37b09f7$var$adjacency_graphs.keypad),
    KEYBOARD_STARTING_POSITIONS: function() {
        var ref, results;
        ref = $b9c1d068d37b09f7$var$adjacency_graphs.qwerty;
        results = [];
        for($b9c1d068d37b09f7$var$k in ref){
            $b9c1d068d37b09f7$var$v = ref[$b9c1d068d37b09f7$var$k];
            results.push($b9c1d068d37b09f7$var$k);
        }
        return results;
    }().length,
    KEYPAD_STARTING_POSITIONS: function() {
        var ref, results;
        ref = $b9c1d068d37b09f7$var$adjacency_graphs.keypad;
        results = [];
        for($b9c1d068d37b09f7$var$k in ref){
            $b9c1d068d37b09f7$var$v = ref[$b9c1d068d37b09f7$var$k];
            results.push($b9c1d068d37b09f7$var$k);
        }
        return results;
    }().length,
    spatial_guesses: function(match) {
        var L, S, U, d, guesses, i, j, o, possible_turns, q, ref, ref1, ref2, ref3, s, shifted_variations, t, u;
        if ((ref = match.graph) === 'qwerty' || ref === 'dvorak') {
            s = this.KEYBOARD_STARTING_POSITIONS;
            d = this.KEYBOARD_AVERAGE_DEGREE;
        } else {
            s = this.KEYPAD_STARTING_POSITIONS;
            d = this.KEYPAD_AVERAGE_DEGREE;
        }
        guesses = 0;
        L = match.token.length;
        t = match.turns;
        for(i = o = 2, ref1 = L; 2 <= ref1 ? o <= ref1 : o >= ref1; i = 2 <= ref1 ? ++o : --o){
            possible_turns = Math.min(t, i - 1);
            for(j = q = 1, ref2 = possible_turns; 1 <= ref2 ? q <= ref2 : q >= ref2; j = 1 <= ref2 ? ++q : --q)guesses += this.nCk(i - 1, j - 1) * s * Math.pow(d, j);
        }
        if (match.shifted_count) {
            S = match.shifted_count;
            U = match.token.length - match.shifted_count;
            if (S === 0 || U === 0) guesses *= 2;
            else {
                shifted_variations = 0;
                for(i = u = 1, ref3 = Math.min(S, U); 1 <= ref3 ? u <= ref3 : u >= ref3; i = 1 <= ref3 ? ++u : --u)shifted_variations += this.nCk(S + U, i);
                guesses *= shifted_variations;
            }
        }
        return guesses;
    },
    dictionary_guesses: function(match) {
        var reversed_variations;
        match.base_guesses = match.rank;
        match.uppercase_variations = this.uppercase_variations(match);
        match.l33t_variations = this.l33t_variations(match);
        reversed_variations = match.reversed && 2 || 1;
        return match.base_guesses * match.uppercase_variations * match.l33t_variations * reversed_variations;
    },
    START_UPPER: /^[A-Z][^A-Z]+$/,
    END_UPPER: /^[^A-Z]+[A-Z]$/,
    ALL_UPPER: /^[^a-z]+$/,
    ALL_LOWER: /^[^A-Z]+$/,
    uppercase_variations: function(match) {
        var L, U, chr, i, len, o, q, ref, ref1, regex, variations, word;
        word = match.token;
        if (word.match(this.ALL_LOWER) || word.toLowerCase() === word) return 1;
        ref = [
            this.START_UPPER,
            this.END_UPPER,
            this.ALL_UPPER
        ];
        for(o = 0, len = ref.length; o < len; o++){
            regex = ref[o];
            if (word.match(regex)) return 2;
        }
        U = function() {
            var len1, q, ref1, results;
            ref1 = word.split('');
            results = [];
            for(q = 0, len1 = ref1.length; q < len1; q++){
                chr = ref1[q];
                if (chr.match(/[A-Z]/)) results.push(chr);
            }
            return results;
        }().length;
        L = function() {
            var len1, q, ref1, results;
            ref1 = word.split('');
            results = [];
            for(q = 0, len1 = ref1.length; q < len1; q++){
                chr = ref1[q];
                if (chr.match(/[a-z]/)) results.push(chr);
            }
            return results;
        }().length;
        variations = 0;
        for(i = q = 1, ref1 = Math.min(U, L); 1 <= ref1 ? q <= ref1 : q >= ref1; i = 1 <= ref1 ? ++q : --q)variations += this.nCk(U + L, i);
        return variations;
    },
    l33t_variations: function(match) {
        var S, U, chr, chrs, i, o, p, possibilities, ref, ref1, subbed, unsubbed, variations;
        if (!match.l33t) return 1;
        variations = 1;
        ref = match.sub;
        for(subbed in ref){
            unsubbed = ref[subbed];
            chrs = match.token.toLowerCase().split('');
            S = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = chrs.length; o < len; o++){
                    chr = chrs[o];
                    if (chr === subbed) results.push(chr);
                }
                return results;
            }().length;
            U = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = chrs.length; o < len; o++){
                    chr = chrs[o];
                    if (chr === unsubbed) results.push(chr);
                }
                return results;
            }().length;
            if (S === 0 || U === 0) variations *= 2;
            else {
                p = Math.min(U, S);
                possibilities = 0;
                for(i = o = 1, ref1 = p; 1 <= ref1 ? o <= ref1 : o >= ref1; i = 1 <= ref1 ? ++o : --o)possibilities += this.nCk(U + S, i);
                variations *= possibilities;
            }
        }
        return variations;
    }
};
module.exports = $b9c1d068d37b09f7$var$scoring;

});


parcelRegister("jFojO", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $e514b5cfd1b2aec0$var$time_estimates;
$e514b5cfd1b2aec0$var$time_estimates = {
    estimate_attack_times: function(guesses) {
        var crack_times_display, crack_times_seconds, scenario, seconds;
        crack_times_seconds = {
            online_throttling_100_per_hour: guesses / (100 / 3600),
            online_no_throttling_10_per_second: guesses / 10,
            offline_slow_hashing_1e4_per_second: guesses / 1e4,
            offline_fast_hashing_1e10_per_second: guesses / 1e10
        };
        crack_times_display = {};
        for(scenario in crack_times_seconds){
            seconds = crack_times_seconds[scenario];
            crack_times_display[scenario] = this.display_time(seconds);
        }
        return {
            crack_times_seconds: crack_times_seconds,
            crack_times_display: crack_times_display,
            score: this.guesses_to_score(guesses)
        };
    },
    guesses_to_score: function(guesses) {
        var DELTA;
        DELTA = 5;
        if (guesses < 1e3 + DELTA) return 0;
        else if (guesses < 1e6 + DELTA) return 1;
        else if (guesses < 1e8 + DELTA) return 2;
        else if (guesses < 1e10 + DELTA) return 3;
        else return 4;
    },
    display_time: function(seconds) {
        var base, century, day, display_num, display_str, hour, minute, month, ref, year;
        minute = 60;
        hour = minute * 60;
        day = hour * 24;
        month = day * 31;
        year = month * 12;
        century = year * 100;
        ref = seconds < 1 ? [
            null,
            'less than a second'
        ] : seconds < minute ? (base = Math.round(seconds), [
            base,
            base + " second"
        ]) : seconds < hour ? (base = Math.round(seconds / minute), [
            base,
            base + " minute"
        ]) : seconds < day ? (base = Math.round(seconds / hour), [
            base,
            base + " hour"
        ]) : seconds < month ? (base = Math.round(seconds / day), [
            base,
            base + " day"
        ]) : seconds < year ? (base = Math.round(seconds / month), [
            base,
            base + " month"
        ]) : seconds < century ? (base = Math.round(seconds / year), [
            base,
            base + " year"
        ]) : [
            null,
            'centuries'
        ], display_num = ref[0], display_str = ref[1];
        if (display_num != null && display_num !== 1) display_str += 's';
        return display_str;
    }
};
module.exports = $e514b5cfd1b2aec0$var$time_estimates;

});

parcelRegister("k6zYl", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $ea304584cfc0f430$var$feedback, $ea304584cfc0f430$var$scoring;

$ea304584cfc0f430$var$scoring = (parcelRequire("fWMoF"));
$ea304584cfc0f430$var$feedback = {
    default_feedback: {
        warning: '',
        suggestions: [
            "Use a few words, avoid common phrases",
            "No need for symbols, digits, or uppercase letters"
        ]
    },
    get_feedback: function(score, sequence) {
        var extra_feedback, i, len, longest_match, match, ref;
        if (sequence.length === 0) return this.default_feedback;
        if (score > 2) return {
            warning: '',
            suggestions: []
        };
        longest_match = sequence[0];
        ref = sequence.slice(1);
        for(i = 0, len = ref.length; i < len; i++){
            match = ref[i];
            if (match.token.length > longest_match.token.length) longest_match = match;
        }
        $ea304584cfc0f430$var$feedback = this.get_match_feedback(longest_match, sequence.length === 1);
        extra_feedback = 'Add another word or two. Uncommon words are better.';
        if ($ea304584cfc0f430$var$feedback != null) {
            $ea304584cfc0f430$var$feedback.suggestions.unshift(extra_feedback);
            if ($ea304584cfc0f430$var$feedback.warning == null) $ea304584cfc0f430$var$feedback.warning = '';
        } else $ea304584cfc0f430$var$feedback = {
            warning: '',
            suggestions: [
                extra_feedback
            ]
        };
        return $ea304584cfc0f430$var$feedback;
    },
    get_match_feedback: function(match, is_sole_match) {
        var layout, warning;
        switch(match.pattern){
            case 'dictionary':
                return this.get_dictionary_match_feedback(match, is_sole_match);
            case 'spatial':
                layout = match.graph.toUpperCase();
                warning = match.turns === 1 ? 'Straight rows of keys are easy to guess' : 'Short keyboard patterns are easy to guess';
                return {
                    warning: warning,
                    suggestions: [
                        'Use a longer keyboard pattern with more turns'
                    ]
                };
            case 'repeat':
                warning = match.base_token.length === 1 ? 'Repeats like "aaa" are easy to guess' : 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"';
                return {
                    warning: warning,
                    suggestions: [
                        'Avoid repeated words and characters'
                    ]
                };
            case 'sequence':
                return {
                    warning: "Sequences like abc or 6543 are easy to guess",
                    suggestions: [
                        'Avoid sequences'
                    ]
                };
            case 'regex':
                if (match.regex_name === 'recent_year') return {
                    warning: "Recent years are easy to guess",
                    suggestions: [
                        'Avoid recent years',
                        'Avoid years that are associated with you'
                    ]
                };
                break;
            case 'date':
                return {
                    warning: "Dates are often easy to guess",
                    suggestions: [
                        'Avoid dates and years that are associated with you'
                    ]
                };
        }
    },
    get_dictionary_match_feedback: function(match, is_sole_match) {
        var ref, result, suggestions, warning, word;
        warning = match.dictionary_name === 'passwords' ? is_sole_match && !match.l33t && !match.reversed ? match.rank <= 10 ? 'This is a top-10 common password' : match.rank <= 100 ? 'This is a top-100 common password' : 'This is a very common password' : match.guesses_log10 <= 4 ? 'This is similar to a commonly used password' : void 0 : match.dictionary_name === 'english_wikipedia' ? is_sole_match ? 'A word by itself is easy to guess' : void 0 : (ref = match.dictionary_name) === 'surnames' || ref === 'male_names' || ref === 'female_names' ? is_sole_match ? 'Names and surnames by themselves are easy to guess' : 'Common names and surnames are easy to guess' : '';
        suggestions = [];
        word = match.token;
        if (word.match($ea304584cfc0f430$var$scoring.START_UPPER)) suggestions.push("Capitalization doesn't help very much");
        else if (word.match($ea304584cfc0f430$var$scoring.ALL_UPPER) && word.toLowerCase() !== word) suggestions.push("All-uppercase is almost as easy to guess as all-lowercase");
        if (match.reversed && match.token.length >= 4) suggestions.push("Reversed words aren't much harder to guess");
        if (match.l33t) suggestions.push("Predictable substitutions like '@' instead of 'a' don't help very much");
        result = {
            warning: warning,
            suggestions: suggestions
        };
        return result;
    }
};
module.exports = $ea304584cfc0f430$var$feedback;

});

parcelRegister("aFsEI", function(module, exports) {

!function(e, t) {
    t(module.exports, (parcelRequire("70fFQ")));
}(module.exports, function(e, t) {
    "use strict";
    function n(e, t, n, o, r, i, u) {
        try {
            var l = e[i](u), s = l.value;
        } catch (e) {
            return void n(e);
        }
        l.done ? t(s) : Promise.resolve(s).then(o, r);
    }
    function o(e) {
        return function() {
            var t = this, o = arguments;
            return new Promise(function(r, i) {
                var u = e.apply(t, o);
                function l(e) {
                    n(u, r, i, l, s, "next", e);
                }
                function s(e) {
                    n(u, r, i, l, s, "throw", e);
                }
                l(void 0);
            });
        };
    }
    function r() {
        return (r = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
        }).apply(this, arguments);
    }
    function i(e, t) {
        if (null == e) return {};
        var n, o, r = {}, i = Object.keys(e);
        for(o = 0; o < i.length; o++)n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }
    function u(e) {
        var t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    var l = {
        init: "init"
    }, s = function(e) {
        var t = e.value;
        return void 0 === t ? "" : t;
    }, a = function() {
        return t.createElement(t.Fragment, null, "\xa0");
    }, c = {
        Cell: s,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
    };
    function d() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        return t.reduce(function(e, t) {
            var n = t.style, o = t.className;
            return e = r({}, e, {}, i(t, [
                "style",
                "className"
            ])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
        }, {});
    }
    var f = function(e, t) {
        return void 0 === t && (t = {}), function(n) {
            return void 0 === n && (n = {}), [].concat(e, [
                n
            ]).reduce(function(e, o) {
                return function e(t, n, o) {
                    return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [
                        t
                    ].concat(n)) : d(t, n);
                }(e, o, r({}, t, {
                    userProps: n
                }));
            }, {});
        };
    }, p = function(e, t, n, o) {
        return void 0 === n && (n = {}), e.reduce(function(e, t) {
            return t(e, n);
        }, t);
    }, g = function(e, t, n) {
        return void 0 === n && (n = {}), e.forEach(function(e) {
            e(t, n);
        });
    };
    function v(e, t, n, o) {
        e.findIndex(function(e) {
            return e.pluginName === n;
        });
        t.forEach(function(t) {
            e.findIndex(function(e) {
                return e.pluginName === t;
            });
        });
    }
    function m(e, t) {
        return "function" == typeof e ? e(t) : e;
    }
    function h(e) {
        var n = t.useRef();
        return n.current = e, t.useCallback(function() {
            return n.current;
        }, []);
    }
    var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
    function w(e, n) {
        var o = t.useRef(!1);
        y(function() {
            o.current && e(), o.current = !0;
        }, n);
    }
    function R(e, t, n) {
        return void 0 === n && (n = {}), function(o, i) {
            void 0 === i && (i = {});
            var u = "string" == typeof o ? t[o] : o;
            if (void 0 === u) throw console.info(t), new Error("Renderer Error \u261D\uFE0F");
            return b(u, r({}, e, {
                column: t
            }, n, {}, i));
        };
    }
    function b(e, n) {
        var o;
        return function(e) {
            var t;
            return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
        }(o = e) || "function" == typeof o || function(e) {
            return "object" == typeof e && "symbol" == typeof e.$$typeof && [
                "react.memo",
                "react.forward_ref"
            ].includes(e.$$typeof.description);
        }(o) ? t.createElement(e, n) : e;
    }
    function S(e, t, n) {
        return void 0 === n && (n = 0), e.map(function(e) {
            return x(e = r({}, e, {
                parent: t,
                depth: n
            })), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
        });
    }
    function C(e) {
        return G(e, "columns");
    }
    function x(e) {
        var t = e.id, n = e.accessor, o = e.Header;
        if ("string" == typeof n) {
            t = t || n;
            var r = n.split(".");
            n = function(e) {
                return function(e, t, n) {
                    if (!t) return e;
                    var o, r = "function" == typeof t ? t : JSON.stringify(t), i = E.get(r) || function() {
                        var e = function(e) {
                            return (function e(t, n) {
                                void 0 === n && (n = []);
                                if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)e(t[o], n);
                                else n.push(t);
                                return n;
                            })(e).map(function(e) {
                                return String(e).replace(".", "_");
                            }).join(".").replace(T, ".").replace(O, "").split(".");
                        }(t);
                        return E.set(r, e), e;
                    }();
                    try {
                        o = i.reduce(function(e, t) {
                            return e[t];
                        }, e);
                    } catch (e) {}
                    return void 0 !== o ? o : n;
                }(e, r);
            };
        }
        if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
        if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
        return Object.assign(e, {
            id: t,
            accessor: n
        }), e;
    }
    function P(e, t) {
        if (!t) throw new Error;
        return Object.assign(e, r({
            Header: a,
            Footer: a
        }, c, {}, t, {}, e)), Object.assign(e, {
            originalWidth: e.width
        }), e;
    }
    function B(e, t, n) {
        void 0 === n && (n = function() {
            return {};
        });
        for(var o = [], i = e, u = 0, l = function() {
            return u++;
        }, s = function() {
            var e = {
                headers: []
            }, u = [], s = i.some(function(e) {
                return e.parent;
            });
            i.forEach(function(o) {
                var i, a = [].concat(u).reverse()[0];
                if (s) {
                    if (o.parent) i = r({}, o.parent, {
                        originalId: o.parent.id,
                        id: o.parent.id + "_" + l(),
                        headers: [
                            o
                        ]
                    }, n(o));
                    else i = P(r({
                        originalId: o.id + "_placeholder",
                        id: o.id + "_placeholder_" + l(),
                        placeholderOf: o,
                        headers: [
                            o
                        ]
                    }, n(o)), t);
                    a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
                }
                e.headers.push(o);
            }), o.push(e), i = u;
        }; i.length;)s();
        return o.reverse();
    }
    var E = new Map;
    function I() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        for(var o = 0; o < t.length; o += 1)if (void 0 !== t[o]) return t[o];
    }
    function F(e) {
        if ("function" == typeof e) return e;
    }
    function G(e, t) {
        var n = [];
        return function e(o) {
            o.forEach(function(o) {
                o[t] ? e(o[t]) : n.push(o);
            });
        }(e), n;
    }
    function A(e, t) {
        var n = t.manualExpandedKey, o = t.expanded, r = t.expandSubRows, i = void 0 === r || r, u = [];
        return e.forEach(function(e) {
            return function e(t, r) {
                void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(function(t) {
                    return e(t, i);
                });
            }(e);
        }), u;
    }
    function k(e, t, n) {
        return F(e) || t[e] || n[e] || n.text;
    }
    function H(e, t, n) {
        return e ? e(t, n) : void 0 === t;
    }
    function W() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z = null;
    var T = /\[/g, O = /\]/g;
    var M = function(e) {
        return r({
            role: "table"
        }, e);
    }, j = function(e) {
        return r({
            role: "rowgroup"
        }, e);
    }, L = function(e, t) {
        var n = t.column;
        return r({
            key: "header_" + n.id,
            colSpan: n.totalVisibleHeaderCount,
            role: "columnheader"
        }, e);
    }, N = function(e, t) {
        var n = t.column;
        return r({
            key: "footer_" + n.id,
            colSpan: n.totalVisibleHeaderCount
        }, e);
    }, D = function(e, t) {
        return r({
            key: "headerGroup_" + t.index,
            role: "row"
        }, e);
    }, V = function(e, t) {
        return r({
            key: "footerGroup_" + t.index
        }, e);
    }, _ = function(e, t) {
        return r({
            key: "row_" + t.row.id,
            role: "row"
        }, e);
    }, X = function(e, t) {
        var n = t.cell;
        return r({
            key: "cell_" + n.row.id + "_" + n.column.id,
            role: "cell"
        }, e);
    };
    function q() {
        return {
            useOptions: [],
            stateReducers: [],
            useControlledState: [],
            columns: [],
            columnsDeps: [],
            allColumns: [],
            allColumnsDeps: [],
            accessValue: [],
            materializedColumns: [],
            materializedColumnsDeps: [],
            useInstanceAfterData: [],
            visibleColumns: [],
            visibleColumnsDeps: [],
            headerGroups: [],
            headerGroupsDeps: [],
            useInstanceBeforeDimensions: [],
            useInstance: [],
            prepareRow: [],
            getTableProps: [
                M
            ],
            getTableBodyProps: [
                j
            ],
            getHeaderGroupProps: [
                D
            ],
            getFooterGroupProps: [
                V
            ],
            getHeaderProps: [
                L
            ],
            getFooterProps: [
                N
            ],
            getRowProps: [
                _
            ],
            getCellProps: [
                X
            ],
            useFinalInstance: []
        };
    }
    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e) {
        e.getToggleHiddenProps = [
            U
        ], e.getToggleHideAllColumnsProps = [
            $
        ], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.hiddenColumns
            ]);
        }), e.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHidden(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isVisible,
                title: "Toggle Column Visible"
            }
        ];
    }, $ = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHideAllColumns(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
                title: "Toggle All Columns Hidden",
                indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
            }
        ];
    };
    function J(e, t, n, o) {
        if (t.type === l.init) return r({
            hiddenColumns: []
        }, e);
        if (t.type === l.resetHiddenColumns) return r({}, e, {
            hiddenColumns: o.initialState.hiddenColumns || []
        });
        if (t.type === l.toggleHideColumn) {
            var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [
                t.columnId
            ]) : e.hiddenColumns.filter(function(e) {
                return e !== t.columnId;
            });
            return r({}, e, {
                hiddenColumns: i
            });
        }
        return t.type === l.setHiddenColumns ? r({}, e, {
            hiddenColumns: m(t.value, e.hiddenColumns)
        }) : t.type === l.toggleHideAllColumns ? r({}, e, {
            hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function(e) {
                return e.id;
            }) : []
        }) : void 0;
    }
    function Y(e) {
        var n = e.headers, o = e.state.hiddenColumns;
        t.useRef(!1).current;
        var r = 0;
        n.forEach(function(e) {
            return r += function e(t, n) {
                t.isVisible = n && !o.includes(t.id);
                var r = 0;
                return t.headers && t.headers.length ? t.headers.forEach(function(n) {
                    return r += e(n, t.isVisible);
                }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
            }(e, !0);
        });
    }
    function Q(e) {
        var n = e.columns, o = e.flatHeaders, r = e.dispatch, i = e.allColumns, u = e.getHooks, s = e.state.hiddenColumns, a = e.autoResetHiddenColumns, c = void 0 === a || a, d = h(e), p = i.length === s.length, g = t.useCallback(function(e, t) {
            return r({
                type: l.toggleHideColumn,
                columnId: e,
                value: t
            });
        }, [
            r
        ]), v = t.useCallback(function(e) {
            return r({
                type: l.setHiddenColumns,
                value: e
            });
        }, [
            r
        ]), m = t.useCallback(function(e) {
            return r({
                type: l.toggleHideAllColumns,
                value: e
            });
        }, [
            r
        ]), y = f(u().getToggleHideAllColumnsProps, {
            instance: d()
        });
        o.forEach(function(e) {
            e.toggleHidden = function(t) {
                r({
                    type: l.toggleHideColumn,
                    columnId: e.id,
                    value: t
                });
            }, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
                instance: d(),
                column: e
            });
        });
        var R = h(c);
        w(function() {
            R() && r({
                type: l.resetHiddenColumns
            });
        }, [
            r,
            n
        ]), Object.assign(e, {
            allColumnsHidden: p,
            toggleHideColumn: g,
            setHiddenColumns: v,
            toggleHideAllColumns: m,
            getToggleHideAllColumnsProps: y
        });
    }
    var Z = {}, ee = {}, te = function(e, t, n) {
        return e;
    }, ne = function(e, t) {
        return e.subRows || [];
    }, oe = function(e, t, n) {
        return "" + (n ? [
            n.id,
            t
        ].join(".") : t);
    }, re = function(e) {
        return e;
    };
    function ie(e) {
        var t = e.initialState, n = void 0 === t ? Z : t, o = e.defaultColumn, u = void 0 === o ? ee : o, l = e.getSubRows, s = void 0 === l ? ne : l, a = e.getRowId, c = void 0 === a ? oe : a, d = e.stateReducer, f = void 0 === d ? te : d, p = e.useControlledState, g = void 0 === p ? re : p;
        return r({}, i(e, [
            "initialState",
            "defaultColumn",
            "getSubRows",
            "getRowId",
            "stateReducer",
            "useControlledState"
        ]), {
            initialState: n,
            defaultColumn: u,
            getSubRows: s,
            getRowId: c,
            stateReducer: f,
            useControlledState: g
        });
    }
    function ue(e, t) {
        void 0 === t && (t = 0);
        var n = 0, o = 0, r = 0, i = 0;
        return e.forEach(function(e) {
            var u = e.headers;
            if (e.totalLeft = t, u && u.length) {
                var l = ue(u, t), s = l[0], a = l[1], c = l[2], d = l[3];
                e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
            } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
            e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
        }), [
            n,
            o,
            r,
            i
        ];
    }
    function le(e) {
        var t = e.data, n = e.rows, o = e.flatRows, r = e.rowsById, i = e.column, u = e.getRowId, l = e.getSubRows, s = e.accessValueHooks, a = e.getInstance;
        t.forEach(function(e, c) {
            return function e(n, c, d, f, g) {
                void 0 === d && (d = 0);
                var v = n, m = u(n, c, f), h = r[m];
                if (h) h.subRows && h.originalSubRows.forEach(function(t, n) {
                    return e(t, n, d + 1, h);
                });
                else if ((h = {
                    id: m,
                    original: v,
                    index: c,
                    depth: d,
                    cells: [
                        {}
                    ]
                }).cells.map = W, h.cells.filter = W, h.cells.forEach = W, h.cells[0].getCellProps = W, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
                    var y = [];
                    h.originalSubRows.forEach(function(t, n) {
                        return e(t, n, d + 1, h, y);
                    }), h.subRows = y;
                }
                i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
                    row: h,
                    column: i,
                    instance: a()
                });
            }(e, c, 0, void 0, n);
        });
    }
    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e) {
        e.getToggleAllRowsExpandedProps = [
            ae
        ], e.getToggleRowExpandedProps = [
            ce
        ], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onClick: function(e) {
                    n.toggleAllRowsExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle All Rows Expanded"
            }
        ];
    }, ce = function(e, t) {
        var n = t.row;
        return [
            e,
            {
                onClick: function() {
                    n.toggleRowExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle Row Expanded"
            }
        ];
    };
    function de(e, t, n, o) {
        if (t.type === l.init) return r({
            expanded: {}
        }, e);
        if (t.type === l.resetExpanded) return r({}, e, {
            expanded: o.initialState.expanded || {}
        });
        if (t.type === l.toggleAllRowsExpanded) {
            var s = t.value, a = o.rowsById, c = Object.keys(a).length === Object.keys(e.expanded).length;
            if (void 0 !== s ? s : !c) {
                var d = {};
                return Object.keys(a).forEach(function(e) {
                    d[e] = !0;
                }), r({}, e, {
                    expanded: d
                });
            }
            return r({}, e, {
                expanded: {}
            });
        }
        if (t.type === l.toggleRowExpanded) {
            var f, p = t.id, g = t.value, v = e.expanded[p], m = void 0 !== g ? g : !v;
            if (!v && m) return r({}, e, {
                expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
            });
            if (v && !m) {
                var h = e.expanded;
                h[p];
                return r({}, e, {
                    expanded: i(h, [
                        p
                    ].map(u))
                });
            }
            return e;
        }
    }
    function fe(e) {
        var n = e.data, o = e.rows, r = e.rowsById, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.paginateExpandedRows, a = void 0 === s || s, c = e.expandSubRows, d = void 0 === c || c, p = e.autoResetExpanded, g = void 0 === p || p, m = e.getHooks, y = e.plugins, R = e.state.expanded, b = e.dispatch;
        v(y, [
            "useSortBy",
            "useGroupBy",
            "usePivotColumns",
            "useGlobalFilter"
        ], "useExpanded");
        var S = h(g), C = Boolean(Object.keys(r).length && Object.keys(R).length);
        C && Object.keys(r).some(function(e) {
            return !R[e];
        }) && (C = !1), w(function() {
            S() && b({
                type: l.resetExpanded
            });
        }, [
            b,
            n
        ]);
        var x = t.useCallback(function(e, t) {
            b({
                type: l.toggleRowExpanded,
                id: e,
                value: t
            });
        }, [
            b
        ]), P = t.useCallback(function(e) {
            return b({
                type: l.toggleAllRowsExpanded,
                value: e
            });
        }, [
            b
        ]), B = t.useMemo(function() {
            return a ? A(o, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: d
            }) : o;
        }, [
            a,
            o,
            u,
            R,
            d
        ]), E = t.useMemo(function() {
            return function(e) {
                var t = 0;
                return Object.keys(e).forEach(function(e) {
                    var n = e.split(".");
                    t = Math.max(t, n.length);
                }), t;
            }(R);
        }, [
            R
        ]), I = h(e), F = f(m().getToggleAllRowsExpandedProps, {
            instance: I()
        });
        Object.assign(e, {
            preExpandedRows: o,
            expandedRows: B,
            rows: B,
            expandedDepth: E,
            isAllRowsExpanded: C,
            toggleRowExpanded: x,
            toggleAllRowsExpanded: P,
            getToggleAllRowsExpandedProps: F
        });
    }
    function pe(e, t) {
        var n = t.instance.getHooks, o = t.instance;
        e.toggleRowExpanded = function(t) {
            return o.toggleRowExpanded(e.id, t);
        }, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
            instance: o,
            row: e
        });
    }
    var ge = function(e, t, n) {
        return e = e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return String(o).toLowerCase().includes(String(n).toLowerCase());
            });
        });
    };
    ge.autoRemove = function(e) {
        return !e;
    };
    var ve = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
            });
        });
    };
    ve.autoRemove = function(e) {
        return !e;
    };
    var me = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o) === String(n);
            });
        });
    };
    me.autoRemove = function(e) {
        return !e;
    };
    var he = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t].includes(n);
            });
        });
    };
    he.autoRemove = function(e) {
        return !e || !e.length;
    };
    var ye = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.every(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    ye.autoRemove = function(e) {
        return !e || !e.length;
    };
    var we = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.some(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    we.autoRemove = function(e) {
        return !e || !e.length;
    };
    var Re = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return n.includes(o);
            });
        });
    };
    Re.autoRemove = function(e) {
        return !e || !e.length;
    };
    var be = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] === n;
            });
        });
    };
    be.autoRemove = function(e) {
        return void 0 === e;
    };
    var Se = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] == n;
            });
        });
    };
    Se.autoRemove = function(e) {
        return null == e;
    };
    var Ce = function(e, t, n) {
        var o = n || [], r = o[0], i = o[1];
        if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
            var u = r;
            r = i, i = u;
        }
        return e.filter(function(e) {
            return t.some(function(t) {
                var n = e.values[t];
                return n >= r && n <= i;
            });
        });
    };
    Ce.autoRemove = function(e) {
        return !e || "number" != typeof e[0] && "number" != typeof e[1];
    };
    var xe = Object.freeze({
        __proto__: null,
        text: ge,
        exactText: ve,
        exactTextCase: me,
        includes: he,
        includesAll: ye,
        includesSome: we,
        includesValue: Re,
        exact: be,
        equals: Se,
        between: Ce
    });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
    var Pe = function(e) {
        e.stateReducers.push(Be), e.useInstance.push(Ee);
    };
    function Be(e, t, n, o) {
        if (t.type === l.init) return r({
            filters: []
        }, e);
        if (t.type === l.resetFilters) return r({}, e, {
            filters: o.initialState.filters || []
        });
        if (t.type === l.setFilter) {
            var i = t.columnId, u = t.filterValue, s = o.allColumns, a = o.filterTypes, c = s.find(function(e) {
                return e.id === i;
            });
            if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
            var d = k(c.filter, a || {}, xe), f = e.filters.find(function(e) {
                return e.id === i;
            }), p = m(u, f && f.value);
            return H(d.autoRemove, p, c) ? r({}, e, {
                filters: e.filters.filter(function(e) {
                    return e.id !== i;
                })
            }) : r({}, e, f ? {
                filters: e.filters.map(function(e) {
                    return e.id === i ? {
                        id: i,
                        value: p
                    } : e;
                })
            } : {
                filters: [].concat(e.filters, [
                    {
                        id: i,
                        value: p
                    }
                ])
            });
        }
        if (t.type === l.setAllFilters) {
            var g = t.filters, v = o.allColumns, h = o.filterTypes;
            return r({}, e, {
                filters: m(g, e.filters).filter(function(e) {
                    var t = v.find(function(t) {
                        return t.id === e.id;
                    });
                    return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
                })
            });
        }
    }
    function Ee(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.manualFilters, c = e.defaultCanFilter, d = void 0 !== c && c, f = e.disableFilters, p = e.state.filters, g = e.dispatch, v = e.autoResetFilters, m = void 0 === v || v, y = t.useCallback(function(e, t) {
            g({
                type: l.setFilter,
                columnId: e,
                filterValue: t
            });
        }, [
            g
        ]), R = t.useCallback(function(e) {
            g({
                type: l.setAllFilters,
                filters: e
            });
        }, [
            g
        ]);
        u.forEach(function(e) {
            var t = e.id, n = e.accessor, o = e.defaultCanFilter, r = e.disableFilters;
            e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function(t) {
                return y(e.id, t);
            };
            var i = p.find(function(e) {
                return e.id === t;
            });
            e.filterValue = i && i.value;
        });
        var b = t.useMemo(function() {
            if (a || !p.length) return [
                o,
                r,
                i
            ];
            var e = [], t = {};
            return [
                function n(o, r) {
                    void 0 === r && (r = 0);
                    var i = o;
                    return (i = p.reduce(function(e, t) {
                        var n = t.id, o = t.value, i = u.find(function(e) {
                            return e.id === n;
                        });
                        if (!i) return e;
                        0 === r && (i.preFilteredRows = e);
                        var l = k(i.filter, s || {}, xe);
                        return l ? (i.filteredRows = l(e, [
                            n
                        ], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
                    }, o)).forEach(function(o) {
                        e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
                    }), i;
                }(o),
                e,
                t
            ];
        }, [
            a,
            p,
            o,
            r,
            i,
            u,
            s
        ]), S = b[0], C = b[1], x = b[2];
        t.useMemo(function() {
            u.filter(function(e) {
                return !p.find(function(t) {
                    return t.id === e.id;
                });
            }).forEach(function(e) {
                e.preFilteredRows = S, e.filteredRows = S;
            });
        }, [
            S,
            p,
            u
        ]);
        var P = h(m);
        w(function() {
            P() && g({
                type: l.resetFilters
            });
        }, [
            g,
            a ? null : n
        ]), Object.assign(e, {
            preFilteredRows: o,
            preFilteredFlatRows: r,
            preFilteredRowsById: i,
            filteredRows: S,
            filteredFlatRows: C,
            filteredRowsById: x,
            rows: S,
            flatRows: C,
            rowsById: x,
            setFilter: y,
            setAllFilters: R
        });
    }
    Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e) {
        e.stateReducers.push(Fe), e.useInstance.push(Ge);
    };
    function Fe(e, t, n, o) {
        if (t.type === l.resetGlobalFilter) return r({}, e, {
            globalFilter: o.initialState.globalFilter || void 0
        });
        if (t.type === l.setGlobalFilter) {
            var u = t.filterValue, s = o.userFilterTypes, a = k(o.globalFilter, s || {}, xe), c = m(u, e.globalFilter);
            if (H(a.autoRemove, c)) {
                e.globalFilter;
                return i(e, [
                    "globalFilter"
                ]);
            }
            return r({}, e, {
                globalFilter: c
            });
        }
    }
    function Ge(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.globalFilter, c = e.manualGlobalFilter, d = e.state.globalFilter, f = e.dispatch, p = e.autoResetGlobalFilter, g = void 0 === p || p, v = e.disableGlobalFilter, m = t.useCallback(function(e) {
            f({
                type: l.setGlobalFilter,
                filterValue: e
            });
        }, [
            f
        ]), y = t.useMemo(function() {
            if (c || void 0 === d) return [
                o,
                r,
                i
            ];
            var e = [], t = {}, n = k(a, s || {}, xe);
            if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
            u.forEach(function(e) {
                var t = e.disableGlobalFilter;
                e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
            });
            var l = u.filter(function(e) {
                return !0 === e.canFilter;
            });
            return [
                function o(r) {
                    return (r = n(r, l.map(function(e) {
                        return e.id;
                    }), d)).forEach(function(n) {
                        e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
                    }), r;
                }(o),
                e,
                t
            ];
        }, [
            c,
            d,
            a,
            s,
            u,
            o,
            r,
            i,
            v
        ]), R = y[0], b = y[1], S = y[2], C = h(g);
        w(function() {
            C() && f({
                type: l.resetGlobalFilter
            });
        }, [
            f,
            c ? null : n
        ]), Object.assign(e, {
            preGlobalFilteredRows: o,
            preGlobalFilteredFlatRows: r,
            preGlobalFilteredRowsById: i,
            globalFilteredRows: R,
            globalFilteredFlatRows: b,
            globalFilteredRowsById: S,
            rows: R,
            flatRows: b,
            rowsById: S,
            setGlobalFilter: m,
            disableGlobalFilter: v
        });
    }
    function Ae(e, t) {
        return t.reduce(function(e, t) {
            return e + ("number" == typeof t ? t : 0);
        }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({
        __proto__: null,
        sum: Ae,
        min: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e));
            }), t;
        },
        max: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.max(t, e));
            }), t;
        },
        minMax: function(e) {
            var t = e[0] || 0, n = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
            }), t + ".." + n;
        },
        average: function(e) {
            return Ae(0, e) / e.length;
        },
        median: function(e) {
            if (!e.length) return null;
            var t = Math.floor(e.length / 2), n = [].concat(e).sort(function(e, t) {
                return e - t;
            });
            return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
        },
        unique: function(e) {
            return Array.from(new Set(e).values());
        },
        uniqueCount: function(e) {
            return new Set(e).size;
        },
        count: function(e) {
            return e.length;
        }
    }), He = [], We = {};
    l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
    var ze = function(e) {
        e.getGroupByToggleProps = [
            Te
        ], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.groupBy
            ]);
        }), e.visibleColumns.push(Me), e.useInstance.push(Le), e.prepareRow.push(Ne);
    };
    ze.pluginName = "useGroupBy";
    var Te = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canGroupBy ? function(e) {
                    e.persist(), n.toggleGroupBy();
                } : void 0,
                style: {
                    cursor: n.canGroupBy ? "pointer" : void 0
                },
                title: "Toggle GroupBy"
            }
        ];
    };
    function Oe(e, t, n, o) {
        if (t.type === l.init) return r({
            groupBy: []
        }, e);
        if (t.type === l.resetGroupBy) return r({}, e, {
            groupBy: o.initialState.groupBy || []
        });
        if (t.type === l.setGroupBy) return r({}, e, {
            groupBy: t.value
        });
        if (t.type === l.toggleGroupBy) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.groupBy.includes(i);
            return r({}, e, s ? {
                groupBy: [].concat(e.groupBy, [
                    i
                ])
            } : {
                groupBy: e.groupBy.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function Me(e, t) {
        var n = t.instance.state.groupBy, o = n.map(function(t) {
            return e.find(function(e) {
                return e.id === t;
            });
        }).filter(Boolean), r = e.filter(function(e) {
            return !n.includes(e.id);
        });
        return (e = [].concat(o, r)).forEach(function(e) {
            e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
        }), e;
    }
    var je = {};
    function Le(e) {
        var n = e.data, o = e.rows, i = e.flatRows, u = e.rowsById, s = e.allColumns, a = e.flatHeaders, c = e.groupByFn, d = void 0 === c ? De : c, p = e.manualGroupBy, g = e.aggregations, m = void 0 === g ? je : g, y = e.plugins, R = e.state.groupBy, b = e.dispatch, S = e.autoResetGroupBy, C = void 0 === S || S, x = e.disableGroupBy, P = e.defaultCanGroupBy, B = e.getHooks;
        v(y, [
            "useColumnOrder",
            "useFilters"
        ], "useGroupBy");
        var E = h(e);
        s.forEach(function(t) {
            var n = t.accessor, o = t.defaultGroupBy, r = t.disableGroupBy;
            t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== x && void 0, !0) : I(t.canGroupBy, o, P, !1), t.canGroupBy && (t.toggleGroupBy = function() {
                return e.toggleGroupBy(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        var F = t.useCallback(function(e, t) {
            b({
                type: l.toggleGroupBy,
                columnId: e,
                value: t
            });
        }, [
            b
        ]), A = t.useCallback(function(e) {
            b({
                type: l.setGroupBy,
                value: e
            });
        }, [
            b
        ]);
        a.forEach(function(e) {
            e.getGroupByToggleProps = f(B().getGroupByToggleProps, {
                instance: E(),
                header: e
            });
        });
        var k = t.useMemo(function() {
            if (p || !R.length) return [
                o,
                i,
                u,
                He,
                We,
                i,
                u
            ];
            var e = R.filter(function(e) {
                return s.find(function(t) {
                    return t.id === e;
                });
            }), t = [], n = {}, l = [], a = {}, c = [], f = {}, g = function o(i, u, p) {
                if (void 0 === u && (u = 0), u === e.length) return i.map(function(e) {
                    return r({}, e, {
                        depth: u
                    });
                });
                var g = e[u], v = d(i, g);
                return Object.entries(v).map(function(r, i) {
                    var d = r[0], v = r[1], h = g + ":" + d, y = o(v, u + 1, h = p ? p + ">" + h : h), w = u ? G(v, "leafRows") : v, R = function(t, n, o) {
                        var r = {};
                        return s.forEach(function(i) {
                            if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;
                            else {
                                var u = "function" == typeof i.aggregate ? i.aggregate : m[i.aggregate] || ke[i.aggregate];
                                if (u) {
                                    var l = n.map(function(e) {
                                        return e.values[i.id];
                                    }), s = t.map(function(e) {
                                        var t = e.values[i.id];
                                        if (!o && i.aggregateValue) {
                                            var n = "function" == typeof i.aggregateValue ? i.aggregateValue : m[i.aggregateValue] || ke[i.aggregateValue];
                                            if (!n) throw console.info({
                                                column: i
                                            }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                                            t = n(t, e, i);
                                        }
                                        return t;
                                    });
                                    r[i.id] = u(s, l);
                                } else {
                                    if (i.aggregate) throw console.info({
                                        column: i
                                    }), new Error("React Table: Invalid column.aggregate option for column listed above");
                                    r[i.id] = null;
                                }
                            }
                        }), r;
                    }(w, v, u), b = {
                        id: h,
                        isGrouped: !0,
                        groupByID: g,
                        groupByVal: d,
                        values: R,
                        subRows: y,
                        leafRows: w,
                        depth: u,
                        index: i
                    };
                    return y.forEach(function(e) {
                        t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
                    }), b;
                });
            }(o);
            return g.forEach(function(e) {
                t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
            }), [
                g,
                t,
                n,
                l,
                a,
                c,
                f
            ];
        }, [
            p,
            R,
            o,
            i,
            u,
            s,
            m,
            d
        ]), H = k[0], W = k[1], z = k[2], T = k[3], O = k[4], M = k[5], j = k[6], L = h(C);
        w(function() {
            L() && b({
                type: l.resetGroupBy
            });
        }, [
            b,
            p ? null : n
        ]), Object.assign(e, {
            preGroupedRows: o,
            preGroupedFlatRow: i,
            preGroupedRowsById: u,
            groupedRows: H,
            groupedFlatRows: W,
            groupedRowsById: z,
            onlyGroupedFlatRows: T,
            onlyGroupedRowsById: O,
            nonGroupedFlatRows: M,
            nonGroupedRowsById: j,
            rows: H,
            flatRows: W,
            rowsById: z,
            toggleGroupBy: F,
            setGroupBy: A
        });
    }
    function Ne(e) {
        e.allCells.forEach(function(t) {
            var n;
            t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
        });
    }
    function De(e, t) {
        return e.reduce(function(e, n, o) {
            var r = "" + n.values[t];
            return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
        }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e(e, t) {
        return e === t ? 0 : e > t ? 1 : -1;
    }
    function Xe(e, t, n) {
        return [
            e.values[n],
            t.values[n]
        ];
    }
    function qe(e) {
        return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
    }
    var Ke = Object.freeze({
        __proto__: null,
        alphanumeric: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = qe(r), i = qe(i), r = r.split(Ve).filter(Boolean), i = i.split(Ve).filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = parseInt(u, 10), a = parseInt(l, 10), c = [
                    s,
                    a
                ].sort();
                if (isNaN(c[0])) {
                    if (u > l) return 1;
                    if (l > u) return -1;
                } else {
                    if (isNaN(c[1])) return isNaN(s) ? -1 : 1;
                    if (s > a) return 1;
                    if (a > s) return -1;
                }
            }
            return r.length - i.length;
        },
        datetime: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            return _e(r = r.getTime(), i = i.getTime());
        },
        basic: function(e, t, n) {
            var o = Xe(e, t, n);
            return _e(o[0], o[1]);
        },
        string: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = r.split("").filter(Boolean), i = i.split("").filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = u.toLowerCase(), a = l.toLowerCase();
                if (s > a) return 1;
                if (a > s) return -1;
                if (u > l) return 1;
                if (l > u) return -1;
            }
            return r.length - i.length;
        },
        number: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1], u = /[^0-9.]/gi;
            return _e(r = Number(String(r).replace(u, "")), i = Number(String(i).replace(u, "")));
        }
    });
    l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;
    var Ue = function(e) {
        e.getSortByToggleProps = [
            $e
        ], e.stateReducers.push(Je), e.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e, t) {
        var n = t.instance, o = t.column, r = n.isMultiSortEvent, i = void 0 === r ? function(e) {
            return e.shiftKey;
        } : r;
        return [
            e,
            {
                onClick: o.canSort ? function(e) {
                    e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
                } : void 0,
                style: {
                    cursor: o.canSort ? "pointer" : void 0
                },
                title: o.canSort ? "Toggle SortBy" : void 0
            }
        ];
    };
    function Je(e, t, n, o) {
        if (t.type === l.init) return r({
            sortBy: []
        }, e);
        if (t.type === l.resetSortBy) return r({}, e, {
            sortBy: o.initialState.sortBy || []
        });
        if (t.type === l.clearSortBy) return r({}, e, {
            sortBy: e.sortBy.filter(function(e) {
                return e.id !== t.columnId;
            })
        });
        if (t.type === l.setSortBy) return r({}, e, {
            sortBy: t.sortBy
        });
        if (t.type === l.toggleSortBy) {
            var i, u = t.columnId, s = t.desc, a = t.multi, c = o.allColumns, d = o.disableMultiSort, f = o.disableSortRemove, p = o.disableMultiRemove, g = o.maxMultiSortColCount, v = void 0 === g ? Number.MAX_SAFE_INTEGER : g, m = e.sortBy, h = c.find(function(e) {
                return e.id === u;
            }).sortDescFirst, y = m.find(function(e) {
                return e.id === u;
            }), w = m.findIndex(function(e) {
                return e.id === u;
            }), R = null != s, b = [];
            return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [
                {
                    id: u,
                    desc: R ? s : h
                }
            ] : "add" === i ? (b = [].concat(m, [
                {
                    id: u,
                    desc: R ? s : h
                }
            ])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function(e) {
                return e.id === u ? r({}, e, {
                    desc: R ? s : !y.desc
                }) : e;
            }) : "remove" === i && (b = m.filter(function(e) {
                return e.id !== u;
            })), r({}, e, {
                sortBy: b
            });
        }
    }
    function Ye(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.allColumns, u = e.orderByFn, s = void 0 === u ? Qe : u, a = e.sortTypes, c = e.manualSortBy, d = e.defaultCanSort, p = e.disableSortBy, g = e.flatHeaders, m = e.state.sortBy, y = e.dispatch, R = e.plugins, b = e.getHooks, S = e.autoResetSortBy, C = void 0 === S || S;
        v(R, [
            "useFilters",
            "useGlobalFilter",
            "useGroupBy",
            "usePivotColumns"
        ], "useSortBy");
        var x = t.useCallback(function(e) {
            y({
                type: l.setSortBy,
                sortBy: e
            });
        }, [
            y
        ]), P = t.useCallback(function(e, t, n) {
            y({
                type: l.toggleSortBy,
                columnId: e,
                desc: t,
                multi: n
            });
        }, [
            y
        ]), B = h(e);
        g.forEach(function(e) {
            var t = e.accessor, n = e.canSort, o = e.disableSortBy, r = e.id, i = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1);
            e.canSort = i, e.canSort && (e.toggleSortBy = function(t, n) {
                return P(e.id, t, n);
            }, e.clearSortBy = function() {
                y({
                    type: l.clearSortBy,
                    columnId: e.id
                });
            }), e.getSortByToggleProps = f(b().getSortByToggleProps, {
                instance: B(),
                column: e
            });
            var u = m.find(function(e) {
                return e.id === r;
            });
            e.isSorted = !!u, e.sortedIndex = m.findIndex(function(e) {
                return e.id === r;
            }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
        });
        var E = t.useMemo(function() {
            if (c || !m.length) return [
                o,
                r
            ];
            var e = [], t = m.filter(function(e) {
                return i.find(function(t) {
                    return t.id === e.id;
                });
            });
            return [
                function n(o) {
                    var r = s(o, t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
                        var n = t.sortType, o = F(n) || (a || {})[n] || Ke[n];
                        if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
                        return function(t, n) {
                            return o(t, n, e.id, e.desc);
                        };
                    }), t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        return t && t.sortInverted ? e.desc : !e.desc;
                    }));
                    return r.forEach(function(t) {
                        e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
                    }), r;
                }(o),
                e
            ];
        }, [
            c,
            m,
            o,
            r,
            i,
            s,
            a
        ]), G = E[0], A = E[1], k = h(C);
        w(function() {
            k() && y({
                type: l.resetSortBy
            });
        }, [
            c ? null : n
        ]), Object.assign(e, {
            preSortedRows: o,
            preSortedFlatRows: r,
            sortedRows: G,
            sortedFlatRows: A,
            rows: G,
            flatRows: A,
            setSortBy: x,
            toggleSortBy: P
        });
    }
    function Qe(e, t, n) {
        return [].concat(e).sort(function(e, o) {
            for(var r = 0; r < t.length; r += 1){
                var i = t[r], u = !1 === n[r] || "desc" === n[r], l = i(e, o);
                if (0 !== l) return u ? -l : l;
            }
            return n[0] ? e.index - o.index : o.index - e.index;
        });
    }
    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
    var Ze = function(e) {
        e.stateReducers.push(et), e.useInstance.push(tt);
    };
    function et(e, t, n, o) {
        if (t.type === l.init) return r({
            pageSize: 10,
            pageIndex: 0
        }, e);
        if (t.type === l.resetPage) return r({}, e, {
            pageIndex: o.initialState.pageIndex || 0
        });
        if (t.type === l.gotoPage) {
            var i = o.pageCount, u = o.page, s = m(t.pageIndex, e.pageIndex), a = !1;
            return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, {
                pageIndex: s
            }) : e;
        }
        if (t.type === l.setPageSize) {
            var c = t.pageSize, d = e.pageSize * e.pageIndex;
            return r({}, e, {
                pageIndex: Math.floor(d / c),
                pageSize: c
            });
        }
    }
    function tt(e) {
        var n = e.rows, o = e.autoResetPage, r = void 0 === o || o, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.plugins, a = e.pageCount, c = e.paginateExpandedRows, d = void 0 === c || c, f = e.expandSubRows, p = void 0 === f || f, g = e.state, m = g.pageSize, y = g.pageIndex, R = g.expanded, b = g.globalFilter, S = g.filters, C = g.groupBy, x = g.sortBy, P = e.dispatch, B = e.data, E = e.manualPagination;
        v(s, [
            "useGlobalFilter",
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded"
        ], "usePagination");
        var I = h(r);
        w(function() {
            I() && P({
                type: l.resetPage
            });
        }, [
            P,
            E ? null : B,
            b,
            S,
            C,
            x
        ]);
        var F = E ? a : Math.ceil(n.length / m), G = t.useMemo(function() {
            return F > 0 ? [].concat(new Array(F)).fill(null).map(function(e, t) {
                return t;
            }) : [];
        }, [
            F
        ]), k = t.useMemo(function() {
            var e;
            if (E) e = n;
            else {
                var t = m * y, o = t + m;
                e = n.slice(t, o);
            }
            return d ? e : A(e, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: p
            });
        }, [
            p,
            R,
            u,
            E,
            y,
            m,
            d,
            n
        ]), H = y > 0, W = -1 === F ? k.length >= m : y < F - 1, z = t.useCallback(function(e) {
            P({
                type: l.gotoPage,
                pageIndex: e
            });
        }, [
            P
        ]), T = t.useCallback(function() {
            return z(function(e) {
                return e - 1;
            });
        }, [
            z
        ]), O = t.useCallback(function() {
            return z(function(e) {
                return e + 1;
            });
        }, [
            z
        ]), M = t.useCallback(function(e) {
            P({
                type: l.setPageSize,
                pageSize: e
            });
        }, [
            P
        ]);
        Object.assign(e, {
            pageOptions: G,
            pageCount: F,
            page: k,
            canPreviousPage: H,
            canNextPage: W,
            gotoPage: z,
            previousPage: T,
            nextPage: O,
            setPageSize: M
        });
    }
    Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
    var nt = function(e) {
        e.getPivotToggleProps = [
            rt
        ], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canPivot ? function(e) {
                    e.persist(), n.togglePivot();
                } : void 0,
                style: {
                    cursor: n.canPivot ? "pointer" : void 0
                },
                title: "Toggle Pivot"
            }
        ];
    };
    function it(e, t, n, o) {
        if (t.type === l.init) return r({
            pivotColumns: ot
        }, e);
        if (t.type === l.resetPivot) return r({}, e, {
            pivotColumns: o.initialState.pivotColumns || ot
        });
        if (t.type === l.togglePivot) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.pivotColumns.includes(i);
            return r({}, e, s ? {
                pivotColumns: [].concat(e.pivotColumns, [
                    i
                ])
            } : {
                pivotColumns: e.pivotColumns.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function ut(e) {
        e.allColumns.forEach(function(t) {
            t.isPivotSource = e.state.pivotColumns.includes(t.id);
        });
    }
    function lt(e, t) {
        var n = t.instance;
        return e.forEach(function(e) {
            e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set;
        }), e;
    }
    function st(e, t) {
        var n = t.column;
        return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
    }
    function at(e, t) {
        var n = t.instance, o = n.allColumns, i = n.state;
        if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
        var u = i.pivotColumns.map(function(e) {
            return o.find(function(t) {
                return t.id === e;
            });
        }).filter(Boolean), l = o.filter(function(e) {
            return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
        }), s = C(function e(t, n, o) {
            void 0 === t && (t = 0), void 0 === o && (o = []);
            var i = u[t];
            return i ? Array.from(i.uniqueValues).sort().map(function(u) {
                var l = r({}, i, {
                    Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
                    isPivotGroup: !0,
                    parent: n,
                    depth: t,
                    id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
                    pivotValue: u
                });
                return l.columns = e(t + 1, l, [].concat(o, [
                    function(e) {
                        return e.values[i.id] === u;
                    }
                ])), l;
            }) : l.map(function(e) {
                return r({}, e, {
                    canPivot: !1,
                    isPivoted: !0,
                    parent: n,
                    depth: t,
                    id: "" + (n ? n.id + "." + e.id : e.id),
                    accessor: function(t, n, r) {
                        if (o.every(function(e) {
                            return e(r);
                        })) return r.values[e.id];
                    }
                });
            });
        }());
        return [].concat(e, s);
    }
    function ct(e, t) {
        var n = t.instance.state, o = n.pivotColumns, r = n.groupBy;
        return [].concat(e, [
            o,
            r
        ]);
    }
    function dt(e, t) {
        var n = t.instance.state;
        return e = e.filter(function(e) {
            return !e.isPivotSource;
        }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function(e) {
            return e.isGrouped || e.isPivoted;
        })), e;
    }
    function ft(e, t) {
        var n = t.instance;
        return [].concat(e, [
            n.state.pivotColumns,
            n.state.groupBy
        ]);
    }
    function pt(e) {
        var t = e.columns, n = e.allColumns, o = e.flatHeaders, r = e.getHooks, i = e.plugins, u = e.dispatch, s = e.autoResetPivot, a = void 0 === s || s, c = e.manaulPivot, d = e.disablePivot, p = e.defaultCanPivot;
        v(i, [
            "useGroupBy"
        ], "usePivotColumns");
        var g = h(e);
        n.forEach(function(t) {
            var n = t.accessor, o = t.defaultPivot, r = t.disablePivot;
            t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function() {
                return e.togglePivot(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        o.forEach(function(e) {
            e.getPivotToggleProps = f(r().getPivotToggleProps, {
                instance: g(),
                header: e
            });
        });
        var m = h(a);
        w(function() {
            m() && u({
                type: l.resetPivot
            });
        }, [
            u,
            c ? null : t
        ]), Object.assign(e, {
            togglePivot: function(e, t) {
                u({
                    type: l.togglePivot,
                    columnId: e,
                    value: t
                });
            }
        });
    }
    function gt(e) {
        e.allCells.forEach(function(e) {
            e.isPivoted = e.column.isPivoted;
        });
    }
    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e) {
        e.getToggleRowSelectedProps = [
            mt
        ], e.getToggleAllRowsSelectedProps = [
            ht
        ], e.getToggleAllPageRowsSelectedProps = [
            yt
        ], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e, t) {
        var n = t.instance, o = t.row, r = n.manualRowSelectedKey, i = void 0 === r ? "isSelected" : r;
        return [
            e,
            {
                onChange: function(e) {
                    o.toggleRowSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !(!o.original || !o.original[i]) || o.isSelected,
                title: "Toggle Row Selected",
                indeterminate: o.isSomeSelected
            }
        ];
    }, ht = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllRowsSelected,
                title: "Toggle All Rows Selected",
                indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
            }
        ];
    }, yt = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllPageRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllPageRowsSelected,
                title: "Toggle All Current Page Rows Selected",
                indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some(function(e) {
                    var t = e.id;
                    return n.state.selectedRowIds[t];
                }))
            }
        ];
    };
    function wt(e, t, n, o) {
        if (t.type === l.init) return r({
            selectedRowIds: {}
        }, e);
        if (t.type === l.resetSelectedRows) return r({}, e, {
            selectedRowIds: o.initialState.selectedRowIds || {}
        });
        if (t.type === l.toggleAllRowsSelected) {
            var i = t.value, u = o.isAllRowsSelected, s = o.rowsById, a = o.nonGroupedRowsById, c = void 0 === a ? s : a, d = void 0 !== i ? i : !u, f = Object.assign({}, e.selectedRowIds);
            return d ? Object.keys(c).forEach(function(e) {
                f[e] = !0;
            }) : Object.keys(c).forEach(function(e) {
                delete f[e];
            }), r({}, e, {
                selectedRowIds: f
            });
        }
        if (t.type === l.toggleRowSelected) {
            var p = t.id, g = t.value, v = o.rowsById, m = o.selectSubRows, h = void 0 === m || m, y = o.getSubRows, w = e.selectedRowIds[p], R = void 0 !== g ? g : !w;
            if (w === R) return e;
            var b = r({}, e.selectedRowIds);
            return function e(t) {
                var n = v[t];
                if (n && (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n))) return y(n).forEach(function(t) {
                    return e(t.id);
                });
            }(p), r({}, e, {
                selectedRowIds: b
            });
        }
        if (t.type === l.toggleAllPageRowsSelected) {
            var S = t.value, C = o.page, x = o.rowsById, P = o.selectSubRows, B = void 0 === P || P, E = o.isAllPageRowsSelected, I = o.getSubRows, F = void 0 !== S ? S : !E, G = r({}, e.selectedRowIds);
            return C.forEach(function(e) {
                return function e(t) {
                    var n = x[t];
                    if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach(function(t) {
                        return e(t.id);
                    });
                }(e.id);
            }), r({}, e, {
                selectedRowIds: G
            });
        }
        return e;
    }
    function Rt(e) {
        var n = e.data, o = e.rows, r = e.getHooks, i = e.plugins, u = e.rowsById, s = e.nonGroupedRowsById, a = void 0 === s ? u : s, c = e.autoResetSelectedRows, d = void 0 === c || c, p = e.state.selectedRowIds, g = e.selectSubRows, m = void 0 === g || g, y = e.dispatch, R = e.page, b = e.getSubRows;
        v(i, [
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded",
            "usePagination"
        ], "useRowSelect");
        var S = t.useMemo(function() {
            var e = [];
            return o.forEach(function(t) {
                var n = m ? function e(t, n, o) {
                    if (n[t.id]) return !0;
                    var r = o(t);
                    if (r && r.length) {
                        var i = !0, u = !1;
                        return r.forEach(function(t) {
                            u && !i || (e(t, n, o) ? u = !0 : i = !1);
                        }), !!i || !!u && null;
                    }
                    return !1;
                }(t, p, b) : !!p[t.id];
                t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
            }), e;
        }, [
            o,
            m,
            p,
            b
        ]), C = Boolean(Object.keys(a).length && Object.keys(p).length), x = C;
        C && Object.keys(a).some(function(e) {
            return !p[e];
        }) && (C = !1), C || R && R.length && R.some(function(e) {
            var t = e.id;
            return !p[t];
        }) && (x = !1);
        var P = h(d);
        w(function() {
            P() && y({
                type: l.resetSelectedRows
            });
        }, [
            y,
            n
        ]);
        var B = t.useCallback(function(e) {
            return y({
                type: l.toggleAllRowsSelected,
                value: e
            });
        }, [
            y
        ]), E = t.useCallback(function(e) {
            return y({
                type: l.toggleAllPageRowsSelected,
                value: e
            });
        }, [
            y
        ]), I = t.useCallback(function(e, t) {
            return y({
                type: l.toggleRowSelected,
                id: e,
                value: t
            });
        }, [
            y
        ]), F = h(e), G = f(r().getToggleAllRowsSelectedProps, {
            instance: F()
        }), A = f(r().getToggleAllPageRowsSelectedProps, {
            instance: F()
        });
        Object.assign(e, {
            selectedFlatRows: S,
            isAllRowsSelected: C,
            isAllPageRowsSelected: x,
            toggleRowSelected: I,
            toggleAllRowsSelected: B,
            getToggleAllRowsSelectedProps: G,
            getToggleAllPageRowsSelectedProps: A,
            toggleAllPageRowsSelected: E
        });
    }
    function bt(e, t) {
        var n = t.instance;
        e.toggleRowSelected = function(t) {
            return n.toggleRowSelected(e.id, t);
        }, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
            instance: n,
            row: e
        });
    }
    var St = function(e) {
        return {};
    }, Ct = function(e) {
        return {};
    };
    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
    var xt = function(e) {
        e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
    };
    function Pt(e, t, n, o) {
        var i = o.initialRowStateAccessor, u = void 0 === i ? St : i, s = o.initialCellStateAccessor, a = void 0 === s ? Ct : s, c = o.rowsById;
        if (t.type === l.init) return r({
            rowState: {}
        }, e);
        if (t.type === l.resetRowState) return r({}, e, {
            rowState: o.initialState.rowState || {}
        });
        if (t.type === l.setRowState) {
            var d, f = t.rowId, p = t.value, g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
            return r({}, e, {
                rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d))
            });
        }
        if (t.type === l.setCellState) {
            var v, h, y, w, R, b = t.rowId, S = t.columnId, C = t.value, x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]), P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find(function(e) {
                return e.column.id === S;
            }));
            return r({}, e, {
                rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, {
                    cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w))
                }), R))
            });
        }
    }
    function Bt(e) {
        var n = e.autoResetRowState, o = void 0 === n || n, r = e.data, i = e.dispatch, u = t.useCallback(function(e, t) {
            return i({
                type: l.setRowState,
                rowId: e,
                value: t
            });
        }, [
            i
        ]), s = t.useCallback(function(e, t, n) {
            return i({
                type: l.setCellState,
                rowId: e,
                columnId: t,
                value: n
            });
        }, [
            i
        ]), a = h(o);
        w(function() {
            a() && i({
                type: l.resetRowState
            });
        }, [
            r
        ]), Object.assign(e, {
            setRowState: u,
            setCellState: s
        });
    }
    function Et(e, t) {
        var n = t.instance, o = n.initialRowStateAccessor, r = void 0 === o ? St : o, i = n.initialCellStateAccessor, u = void 0 === i ? Ct : i, l = n.state.rowState;
        e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function(t) {
            return n.setRowState(e.id, t);
        }, e.cells.forEach(function(t) {
            e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function(o) {
                return n.setCellState(e.id, t.column.id, o);
            };
        }));
    }
    xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
    var It = function(e) {
        e.stateReducers.push(Ft), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.columnOrder
            ]);
        }), e.visibleColumns.push(Gt), e.useInstance.push(At);
    };
    function Ft(e, t, n, o) {
        return t.type === l.init ? r({
            columnOrder: []
        }, e) : t.type === l.resetColumnOrder ? r({}, e, {
            columnOrder: o.initialState.columnOrder || []
        }) : t.type === l.setColumnOrder ? r({}, e, {
            columnOrder: m(t.columnOrder, e.columnOrder)
        }) : void 0;
    }
    function Gt(e, t) {
        var n = t.instance.state.columnOrder;
        if (!n || !n.length) return e;
        for(var o = [].concat(n), r = [].concat(e), i = [], u = function() {
            var e = o.shift(), t = r.findIndex(function(t) {
                return t.id === e;
            });
            t > -1 && i.push(r.splice(t, 1)[0]);
        }; r.length && o.length;)u();
        return [].concat(i, r);
    }
    function At(e) {
        var n = e.dispatch;
        e.setColumnOrder = t.useCallback(function(e) {
            return n({
                type: l.setColumnOrder,
                columnOrder: e
            });
        }, [
            n
        ]);
    }
    It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
    var kt = function(e) {
        e.getResizerProps = [
            Ht
        ], e.getHeaderProps.push({
            style: {
                position: "relative"
            }
        }), e.stateReducers.push(Wt), e.useInstance.push(Tt), e.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e, t) {
        var n = t.instance, o = t.header, r = n.dispatch, i = function(e, t) {
            var n = !1;
            if ("touchstart" === e.type) {
                if (e.touches && e.touches.length > 1) return;
                n = !0;
            }
            var o, i, u = (function(e) {
                var t = [];
                return function e(n) {
                    n.columns && n.columns.length && n.columns.map(e);
                    t.push(n);
                }(e), t;
            })(t).map(function(e) {
                return [
                    e.id,
                    e.totalWidth
                ];
            }), s = n ? Math.round(e.touches[0].clientX) : e.clientX, a = function() {
                window.cancelAnimationFrame(o), o = null, r({
                    type: l.columnDoneResizing
                });
            }, c = function() {
                window.cancelAnimationFrame(o), o = null, r({
                    type: l.columnResizing,
                    clientX: i
                });
            }, d = function(e) {
                i = e, o || (o = window.requestAnimationFrame(c));
            }, f = {
                mouse: {
                    moveEvent: "mousemove",
                    moveHandler: function(e) {
                        return d(e.clientX);
                    },
                    upEvent: "mouseup",
                    upHandler: function(e) {
                        document.removeEventListener("mousemove", f.mouse.moveHandler), document.removeEventListener("mouseup", f.mouse.upHandler), a();
                    }
                },
                touch: {
                    moveEvent: "touchmove",
                    moveHandler: function(e) {
                        return e.cancelable && (e.preventDefault(), e.stopPropagation()), d(e.touches[0].clientX), !1;
                    },
                    upEvent: "touchend",
                    upHandler: function(e) {
                        document.removeEventListener(f.touch.moveEvent, f.touch.moveHandler), document.removeEventListener(f.touch.upEvent, f.touch.moveHandler), a();
                    }
                }
            }, p = n ? f.touch : f.mouse, g = !!function() {
                if ("boolean" == typeof z) return z;
                var e = !1;
                try {
                    var t = {
                        get passive () {
                            return e = !0, !1;
                        }
                    };
                    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                } catch (t) {
                    e = !1;
                }
                return z = e;
            }() && {
                passive: !1
            };
            document.addEventListener(p.moveEvent, p.moveHandler, g), document.addEventListener(p.upEvent, p.upHandler, g), r({
                type: l.columnStartResizing,
                columnId: t.id,
                columnWidth: t.totalWidth,
                headerIdWidths: u,
                clientX: s
            });
        };
        return [
            e,
            {
                onMouseDown: function(e) {
                    return e.persist() || i(e, o);
                },
                onTouchStart: function(e) {
                    return e.persist() || i(e, o);
                },
                style: {
                    cursor: "col-resize"
                },
                draggable: !1,
                role: "separator"
            }
        ];
    };
    function Wt(e, t) {
        if (t.type === l.init) return r({
            columnResizing: {
                columnWidths: {}
            }
        }, e);
        if (t.type === l.resetResize) return r({}, e, {
            columnResizing: {
                columnWidths: {}
            }
        });
        if (t.type === l.columnStartResizing) {
            var n = t.clientX, o = t.columnId, i = t.columnWidth, u = t.headerIdWidths;
            return r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    startX: n,
                    headerIdWidths: u,
                    columnWidth: i,
                    isResizingColumn: o
                })
            });
        }
        if (t.type === l.columnResizing) {
            var s = t.clientX, a = e.columnResizing, c = a.startX, d = a.columnWidth, f = a.headerIdWidths, p = (s - c) / d, g = {};
            return (void 0 === f ? [] : f).forEach(function(e) {
                var t = e[0], n = e[1];
                g[t] = Math.max(n + n * p, 0);
            }), r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
                })
            });
        }
        return t.type === l.columnDoneResizing ? r({}, e, {
            columnResizing: r({}, e.columnResizing, {
                startX: null,
                isResizingColumn: null
            })
        }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e) {
        var t = e.flatHeaders, n = e.disableResizing, o = e.getHooks, r = e.state.columnResizing, i = h(e);
        t.forEach(function(e) {
            var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
            e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
                instance: i(),
                header: e
            }));
        });
    };
    function Tt(e) {
        var n = e.plugins, o = e.dispatch, r = e.autoResetResize, i = void 0 === r || r, u = e.columns;
        v(n, [
            "useAbsoluteLayout"
        ], "useResizeColumns");
        var s = h(i);
        w(function() {
            s() && o({
                type: l.resetResize
            });
        }, [
            u
        ]);
        var a = t.useCallback(function() {
            return o({
                type: l.resetResize
            });
        }, [
            o
        ]);
        Object.assign(e, {
            resetResizing: a
        });
    }
    var Ot = {
        position: "absolute",
        top: 0
    }, Mt = function(e) {
        e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.column.totalLeft + "px",
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e, t) {
        return [
            e,
            {
                style: {
                    position: "relative",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Lt = {
        display: "inline-block",
        boxSizing: "border-box"
    }, Nt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Dt = function(e) {
        e.getRowProps.push(Nt), e.getHeaderGroupProps.push(Nt), e.getFooterGroupProps.push(Nt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Lt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Lt, {
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Lt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    function Vt(e) {
        e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
    }
    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e, t) {
        return [
            e,
            {
                style: {
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, Xt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    flex: "1 0 auto",
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, qt = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    }, Kt = function(e, t) {
        var n = t.cell;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.column.totalFlexWidth + " 0 auto",
                    minWidth: n.column.totalMinWidth + "px",
                    width: n.column.totalWidth + "px"
                }
            }
        ];
    }, Ut = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    };
    function $t(e) {
        e.stateReducers.push(Zt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt), e.getRowProps.push(Qt);
    }
    l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize", $t.pluginName = "useGridLayout";
    var Jt = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                style: {
                    display: "grid",
                    gridTemplateColumns: n.visibleColumns.map(function(e) {
                        var t;
                        return n.state.gridLayout.columnWidths[e.id] ? n.state.gridLayout.columnWidths[e.id] + "px" : (null == (t = n.state.columnResizing) ? void 0 : t.isResizingColumn) ? n.state.gridLayout.startWidths[e.id] + "px" : "number" == typeof e.width ? e.width + "px" : e.width;
                    }).join(" ")
                }
            }
        ];
    }, Yt = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                id: "header-cell-" + n.id,
                style: {
                    position: "sticky",
                    gridColumn: "span " + n.totalVisibleHeaderCount
                }
            }
        ];
    }, Qt = function(e, t) {
        var n = t.row;
        return n.isExpanded ? [
            e,
            {
                style: {
                    gridColumn: "1 / " + (n.cells.length + 1)
                }
            }
        ] : [
            e,
            {}
        ];
    };
    function Zt(e, t, n, o) {
        if (t.type === l.init) return r({
            gridLayout: {
                columnWidths: {}
            }
        }, e);
        if (t.type === l.resetResize) return r({}, e, {
            gridLayout: {
                columnWidths: {}
            }
        });
        if (t.type === l.columnStartResizing) {
            var i = t.columnId, u = t.headerIdWidths, s = en(i);
            if (void 0 !== s) {
                var a = o.visibleColumns.reduce(function(e, t) {
                    var n;
                    return r({}, e, ((n = {})[t.id] = en(t.id), n));
                }, {}), c = o.visibleColumns.reduce(function(e, t) {
                    var n;
                    return r({}, e, ((n = {})[t.id] = t.minWidth, n));
                }, {}), d = o.visibleColumns.reduce(function(e, t) {
                    var n;
                    return r({}, e, ((n = {})[t.id] = t.maxWidth, n));
                }, {}), f = u.map(function(e) {
                    var t = e[0];
                    return [
                        t,
                        en(t)
                    ];
                });
                return r({}, e, {
                    gridLayout: r({}, e.gridLayout, {
                        startWidths: a,
                        minWidths: c,
                        maxWidths: d,
                        headerIdGridWidths: f,
                        columnWidth: s
                    })
                });
            }
            return e;
        }
        if (t.type === l.columnResizing) {
            var p = t.clientX, g = e.columnResizing.startX, v = e.gridLayout, m = v.columnWidth, h = v.minWidths, y = v.maxWidths, w = v.headerIdGridWidths, R = (p - g) / m, b = {};
            return (void 0 === w ? [] : w).forEach(function(e) {
                var t = e[0], n = e[1];
                b[t] = Math.min(Math.max(h[t], n + n * R), y[t]);
            }), r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnWidths: r({}, e.gridLayout.columnWidths, {}, b)
                })
            });
        }
        return t.type === l.columnDoneResizing ? r({}, e, {
            gridLayout: r({}, e.gridLayout, {
                startWidths: {},
                minWidths: {},
                maxWidths: {}
            })
        }) : void 0;
    }
    function en(e) {
        var t, n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
        if (void 0 !== n) return n;
    }
    e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function(e, n) {
        void 0 === n && (n = 0);
        var r = t.useRef({}), i = h(e), u = h(n);
        return t.useCallback(function() {
            var e = o(regeneratorRuntime.mark(function e() {
                var t, n, l, s = arguments;
                return regeneratorRuntime.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            for(t = s.length, n = new Array(t), l = 0; l < t; l++)n[l] = s[l];
                            return r.current.promise || (r.current.promise = new Promise(function(e, t) {
                                r.current.resolve = e, r.current.reject = t;
                            })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e() {
                                return regeneratorRuntime.wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);
                                        case 5:
                                            e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
                                            break;
                                        case 9:
                                            e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);
                                        case 12:
                                            return e.prev = 12, delete r.current.promise, e.finish(12);
                                        case 15:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, null, [
                                    [
                                        1,
                                        9,
                                        12,
                                        15
                                    ]
                                ]);
                            })), u()), e.abrupt("return", r.current.promise);
                        case 5:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }(), [
            i,
            u
        ]);
    }, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function(e) {
        for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
        e = ie(e), o = [
            K
        ].concat(o);
        var u = t.useRef({}), s = h(u.current);
        Object.assign(s(), r({}, e, {
            plugins: o,
            hooks: q()
        })), o.filter(Boolean).forEach(function(e) {
            e(s().hooks);
        });
        var a = h(s().hooks);
        s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
        var c = s(), d = c.data, v = c.columns, m = c.initialState, y = c.defaultColumn, w = c.getSubRows, b = c.getRowId, E = c.stateReducer, I = c.useControlledState, F = h(E), G = t.useCallback(function(e, t) {
            if (!t.type) throw console.info({
                action: t
            }), new Error("Unknown Action \uD83D\uDC46");
            return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [
                F()
            ]).reduce(function(n, o) {
                return o(n, t, e, s()) || n;
            }, e);
        }, [
            a,
            F,
            s
        ]), A = t.useReducer(G, void 0, function() {
            return G(m, {
                type: l.init
            });
        }), k = A[0], H = A[1], W = p([].concat(a().useControlledState, [
            I
        ]), k, {
            instance: s()
        });
        Object.assign(s(), {
            state: W,
            dispatch: H
        });
        var z = t.useMemo(function() {
            return S(p(a().columns, v, {
                instance: s()
            }));
        }, [
            a,
            s,
            v
        ].concat(p(a().columnsDeps, [], {
            instance: s()
        })));
        s().columns = z;
        var T = t.useMemo(function() {
            return p(a().allColumns, C(z), {
                instance: s()
            }).map(x);
        }, [
            z,
            a,
            s
        ].concat(p(a().allColumnsDeps, [], {
            instance: s()
        })));
        s().allColumns = T;
        var O = t.useMemo(function() {
            for(var e = [], t = [], n = {}, o = [].concat(T); o.length;){
                var r = o.shift();
                le({
                    data: d,
                    rows: e,
                    flatRows: t,
                    rowsById: n,
                    column: r,
                    getRowId: b,
                    getSubRows: w,
                    accessValueHooks: a().accessValue,
                    getInstance: s
                });
            }
            return [
                e,
                t,
                n
            ];
        }, [
            T,
            d,
            b,
            w,
            a,
            s
        ]), M = O[0], j = O[1], L = O[2];
        Object.assign(s(), {
            rows: M,
            initialRows: [].concat(M),
            flatRows: j,
            rowsById: L
        }), g(a().useInstanceAfterData, s());
        var N = t.useMemo(function() {
            return p(a().visibleColumns, T, {
                instance: s()
            }).map(function(e) {
                return P(e, y);
            });
        }, [
            a,
            T,
            s,
            y
        ].concat(p(a().visibleColumnsDeps, [], {
            instance: s()
        })));
        T = t.useMemo(function() {
            var e = [].concat(N);
            return T.forEach(function(t) {
                e.find(function(e) {
                    return e.id === t.id;
                }) || e.push(t);
            }), e;
        }, [
            T,
            N
        ]), s().allColumns = T;
        var D = t.useMemo(function() {
            return p(a().headerGroups, B(N, y), s());
        }, [
            a,
            N,
            y,
            s
        ].concat(p(a().headerGroupsDeps, [], {
            instance: s()
        })));
        s().headerGroups = D;
        var V = t.useMemo(function() {
            return D.length ? D[0].headers : [];
        }, [
            D
        ]);
        s().headers = V, s().flatHeaders = D.reduce(function(e, t) {
            return [].concat(e, t.headers);
        }, []), g(a().useInstanceBeforeDimensions, s());
        var _ = N.filter(function(e) {
            return e.isVisible;
        }).map(function(e) {
            return e.id;
        }).sort().join("_");
        N = t.useMemo(function() {
            return N.filter(function(e) {
                return e.isVisible;
            });
        }, [
            N,
            _
        ]), s().visibleColumns = N;
        var X = ue(V), U = X[0], $ = X[1], J = X[2];
        return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach(function(e) {
            e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
                instance: s(),
                column: e
            }), e.getFooterProps = f(a().getFooterProps, {
                instance: s(),
                column: e
            });
        }), s().headerGroups = t.useMemo(function() {
            return D.filter(function(e, t) {
                return e.headers = e.headers.filter(function(e) {
                    return e.headers ? function e(t) {
                        return t.filter(function(t) {
                            return t.headers ? e(t.headers) : t.isVisible;
                        }).length;
                    }(e.headers) : e.isVisible;
                }), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), e.getFooterGroupProps = f(a().getFooterGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), !0);
            });
        }, [
            D,
            s,
            a
        ]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback(function(e) {
            e.getRowProps = f(a().getRowProps, {
                instance: s(),
                row: e
            }), e.allCells = T.map(function(t) {
                var n = e.values[t.id], o = {
                    column: t,
                    row: e,
                    value: n
                };
                return o.getCellProps = f(a().getCellProps, {
                    instance: s(),
                    cell: o
                }), o.render = R(s(), t, {
                    row: e,
                    cell: o,
                    value: n
                }), o;
            }), e.cells = N.map(function(t) {
                return e.allCells.find(function(e) {
                    return e.column.id === t.id;
                });
            }), g(a().prepareRow, e, {
                instance: s()
            });
        }, [
            a,
            s,
            T,
            N
        ]), s().getTableProps = f(a().getTableProps, {
            instance: s()
        }), s().getTableBodyProps = f(a().getTableBodyProps, {
            instance: s()
        }), g(a().useFinalInstance, s()), s();
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("7adkN", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $aPrk0 = parcelRequire("aPrk0");

var $0yJ19 = parcelRequire("0yJ19");

var $4HCLR = parcelRequire("4HCLR");

var $8r22E = parcelRequire("8r22E");

var $68kV9 = parcelRequire("68kV9");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5373cf85e013fcc9$var$createInstance(defaultConfig) {
    var context = new $0yJ19(defaultConfig);
    var instance = $aPrk0($0yJ19.prototype.request, context);
    // Copy axios.prototype to instance
    $lKhqw.extend(instance, $0yJ19.prototype, context);
    // Copy context to instance
    $lKhqw.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5373cf85e013fcc9$var$createInstance($4HCLR(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $5373cf85e013fcc9$var$axios = $5373cf85e013fcc9$var$createInstance($8r22E);
// Expose Axios class to allow class inheritance
$5373cf85e013fcc9$var$axios.Axios = $0yJ19;

// Expose Cancel & CancelToken
$5373cf85e013fcc9$var$axios.CanceledError = (parcelRequire("c3JFs"));

$5373cf85e013fcc9$var$axios.CancelToken = (parcelRequire("6pDYR"));

$5373cf85e013fcc9$var$axios.isCancel = (parcelRequire("HLDIA"));

$5373cf85e013fcc9$var$axios.VERSION = (parcelRequire("hIREP")).version;

$5373cf85e013fcc9$var$axios.toFormData = (parcelRequire("iAsia"));

// Expose AxiosError class
$5373cf85e013fcc9$var$axios.AxiosError = (parcelRequire("fvEIL"));
// alias for CanceledError for backward compatibility
$5373cf85e013fcc9$var$axios.Cancel = $5373cf85e013fcc9$var$axios.CanceledError;
// Expose all/spread
$5373cf85e013fcc9$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5373cf85e013fcc9$var$axios.spread = (parcelRequire("8U7FG"));

// Expose isAxiosError
$5373cf85e013fcc9$var$axios.isAxiosError = (parcelRequire("eNCTT"));
$5373cf85e013fcc9$var$axios.formToJSON = function(thing) {
    return $68kV9($lKhqw.isHTMLForm(thing) ? new FormData(thing) : thing);
};
module.exports = $5373cf85e013fcc9$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5373cf85e013fcc9$var$axios;

});
parcelRegister("lKhqw", function(module, exports) {
'use strict';

var $aPrk0 = parcelRequire("aPrk0");
// utils is a library of generic helper functions non-specific to axios
var $fd4b6975c6d4e60d$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $fd4b6975c6d4e60d$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $fd4b6975c6d4e60d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $fd4b6975c6d4e60d$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $fd4b6975c6d4e60d$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $fd4b6975c6d4e60d$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $fd4b6975c6d4e60d$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $fd4b6975c6d4e60d$var$isBuffer(val) {
    return val !== null && !$fd4b6975c6d4e60d$var$isUndefined(val) && val.constructor !== null && !$fd4b6975c6d4e60d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $fd4b6975c6d4e60d$var$isArrayBuffer = $fd4b6975c6d4e60d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $fd4b6975c6d4e60d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $fd4b6975c6d4e60d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $fd4b6975c6d4e60d$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $fd4b6975c6d4e60d$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $fd4b6975c6d4e60d$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $fd4b6975c6d4e60d$var$isPlainObject(val) {
    if ($fd4b6975c6d4e60d$var$kindOf(val) !== 'object') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */ function $fd4b6975c6d4e60d$var$isEmptyObject(val) {
    if (!$fd4b6975c6d4e60d$var$isPlainObject(val)) return false;
    for(var key in val){
        if (Object.prototype.hasOwnProperty.call(val, key)) return false;
    }
    return true;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $fd4b6975c6d4e60d$var$isDate = $fd4b6975c6d4e60d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $fd4b6975c6d4e60d$var$isFile = $fd4b6975c6d4e60d$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $fd4b6975c6d4e60d$var$isBlob = $fd4b6975c6d4e60d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $fd4b6975c6d4e60d$var$isFileList = $fd4b6975c6d4e60d$var$kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $fd4b6975c6d4e60d$var$isFunction(val) {
    return $fd4b6975c6d4e60d$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $fd4b6975c6d4e60d$var$isStream(val) {
    return $fd4b6975c6d4e60d$var$isObject(val) && $fd4b6975c6d4e60d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $fd4b6975c6d4e60d$var$isFormData(thing) {
    var pattern = '[object FormData]';
    if (!thing) return false;
    if (typeof FormData === 'function' && thing instanceof FormData) return true;
    // Reject non-objects (strings, numbers, booleans) up front — Object.getPrototypeOf
    // throws a TypeError on primitives in ES5 environments.
    if (!$fd4b6975c6d4e60d$var$isObject(thing)) return false;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = Object.getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$fd4b6975c6d4e60d$var$isFunction(thing.append)) return false;
    return $fd4b6975c6d4e60d$var$toString.call(thing) === pattern || $fd4b6975c6d4e60d$var$isFunction(thing.toString) && thing.toString() === pattern;
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $fd4b6975c6d4e60d$var$isURLSearchParams = $fd4b6975c6d4e60d$var$kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $fd4b6975c6d4e60d$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $fd4b6975c6d4e60d$var$isStandardBrowserEnv() {
    var product;
    if (typeof navigator !== 'undefined' && ((product = navigator.product) === 'ReactNative' || product === 'NativeScript' || product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $fd4b6975c6d4e60d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($fd4b6975c6d4e60d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $fd4b6975c6d4e60d$var$merge() {
    var result = Object.create(null);
    function assignValue(val, key) {
        var target;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        target = Object.prototype.hasOwnProperty.call(result, key) ? result[key] : undefined;
        if ($fd4b6975c6d4e60d$var$isPlainObject(target) && $fd4b6975c6d4e60d$var$isPlainObject(val)) result[key] = $fd4b6975c6d4e60d$var$merge(target, val);
        else if ($fd4b6975c6d4e60d$var$isPlainObject(val)) result[key] = $fd4b6975c6d4e60d$var$merge({}, val);
        else if ($fd4b6975c6d4e60d$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$fd4b6975c6d4e60d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $fd4b6975c6d4e60d$var$extend(a, b, thisArg) {
    $fd4b6975c6d4e60d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $aPrk0(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $fd4b6975c6d4e60d$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $fd4b6975c6d4e60d$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */ function $fd4b6975c6d4e60d$var$toFlatObject(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $fd4b6975c6d4e60d$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */ function $fd4b6975c6d4e60d$var$toArray(thing) {
    if (!thing) return null;
    if ($fd4b6975c6d4e60d$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$fd4b6975c6d4e60d$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $fd4b6975c6d4e60d$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
function $fd4b6975c6d4e60d$var$forEachEntry(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
}
function $fd4b6975c6d4e60d$var$matchAll(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
}
var $fd4b6975c6d4e60d$var$isHTMLForm = $fd4b6975c6d4e60d$var$kindOfTest('HTMLFormElement');
var $fd4b6975c6d4e60d$var$hasOwnProperty = function resolver(_hasOwnProperty) {
    return function(obj, prop) {
        return _hasOwnProperty.call(obj, prop);
    };
}(Object.prototype.hasOwnProperty);
module.exports = {
    isArray: $fd4b6975c6d4e60d$var$isArray,
    isArrayBuffer: $fd4b6975c6d4e60d$var$isArrayBuffer,
    isBuffer: $fd4b6975c6d4e60d$var$isBuffer,
    isFormData: $fd4b6975c6d4e60d$var$isFormData,
    isArrayBufferView: $fd4b6975c6d4e60d$var$isArrayBufferView,
    isString: $fd4b6975c6d4e60d$var$isString,
    isNumber: $fd4b6975c6d4e60d$var$isNumber,
    isObject: $fd4b6975c6d4e60d$var$isObject,
    isPlainObject: $fd4b6975c6d4e60d$var$isPlainObject,
    isEmptyObject: $fd4b6975c6d4e60d$var$isEmptyObject,
    isUndefined: $fd4b6975c6d4e60d$var$isUndefined,
    isDate: $fd4b6975c6d4e60d$var$isDate,
    isFile: $fd4b6975c6d4e60d$var$isFile,
    isBlob: $fd4b6975c6d4e60d$var$isBlob,
    isFunction: $fd4b6975c6d4e60d$var$isFunction,
    isStream: $fd4b6975c6d4e60d$var$isStream,
    isURLSearchParams: $fd4b6975c6d4e60d$var$isURLSearchParams,
    isStandardBrowserEnv: $fd4b6975c6d4e60d$var$isStandardBrowserEnv,
    forEach: $fd4b6975c6d4e60d$var$forEach,
    merge: $fd4b6975c6d4e60d$var$merge,
    extend: $fd4b6975c6d4e60d$var$extend,
    trim: $fd4b6975c6d4e60d$var$trim,
    stripBOM: $fd4b6975c6d4e60d$var$stripBOM,
    inherits: $fd4b6975c6d4e60d$var$inherits,
    toFlatObject: $fd4b6975c6d4e60d$var$toFlatObject,
    kindOf: $fd4b6975c6d4e60d$var$kindOf,
    kindOfTest: $fd4b6975c6d4e60d$var$kindOfTest,
    endsWith: $fd4b6975c6d4e60d$var$endsWith,
    toArray: $fd4b6975c6d4e60d$var$toArray,
    isTypedArray: $fd4b6975c6d4e60d$var$isTypedArray,
    isFileList: $fd4b6975c6d4e60d$var$isFileList,
    forEachEntry: $fd4b6975c6d4e60d$var$forEachEntry,
    matchAll: $fd4b6975c6d4e60d$var$matchAll,
    isHTMLForm: $fd4b6975c6d4e60d$var$isHTMLForm,
    hasOwnProperty: $fd4b6975c6d4e60d$var$hasOwnProperty
};

});
parcelRegister("aPrk0", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
};

});


parcelRegister("0yJ19", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $iUyGw = parcelRequire("iUyGw");

var $avirQ = parcelRequire("avirQ");

var $eiKwg = parcelRequire("eiKwg");

var $4HCLR = parcelRequire("4HCLR");

var $bueOp = parcelRequire("bueOp");

var $46n07 = parcelRequire("46n07");
var $001aefe19d856021$var$validators = $46n07.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $001aefe19d856021$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $avirQ(),
        response: new $avirQ()
    };
}
/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */ $001aefe19d856021$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $4HCLR(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $46n07.assertOptions(transitional, {
        silentJSONParsing: $001aefe19d856021$var$validators.transitional($001aefe19d856021$var$validators.boolean),
        forcedJSONParsing: $001aefe19d856021$var$validators.transitional($001aefe19d856021$var$validators.boolean),
        clarifyTimeoutError: $001aefe19d856021$var$validators.transitional($001aefe19d856021$var$validators.boolean)
    }, false);
    var paramsSerializer = config.paramsSerializer;
    if (paramsSerializer != null) {
        if ($lKhqw.isFunction(paramsSerializer)) config.paramsSerializer = {
            serialize: paramsSerializer
        };
        else $46n07.assertOptions(paramsSerializer, {
            encode: $001aefe19d856021$var$validators.function,
            serialize: $001aefe19d856021$var$validators.function
        }, true);
    }
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eiKwg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eiKwg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$001aefe19d856021$var$Axios.prototype.getUri = function getUri(config) {
    config = $4HCLR(this.defaults, config);
    var fullPath = $bueOp(config.baseURL, config.url, config.allowAbsoluteUrls);
    return $iUyGw(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$lKhqw.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $001aefe19d856021$var$Axios.prototype[method] = function(url, config) {
        var requestConfig = config || {};
        return this.request($4HCLR(requestConfig, {
            method: method,
            url: url,
            data: $lKhqw.hasOwnProperty(requestConfig, 'data') ? requestConfig.data : undefined
        }));
    };
});
$lKhqw.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($4HCLR(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $001aefe19d856021$var$Axios.prototype[method] = generateHTTPMethod();
    $001aefe19d856021$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
module.exports = $001aefe19d856021$var$Axios;

});
parcelRegister("iUyGw", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $CbnE5 = parcelRequire("CbnE5");
function $dc485ca62913762a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
    var _encode = $dc485ca62913762a$var$encode;
    var serializeFn;
    if (options) {
        if ($lKhqw.isFunction(options)) serializeFn = options;
        else {
            _encode = $lKhqw.hasOwnProperty(options, 'encode') && options.encode || $dc485ca62913762a$var$encode;
            serializeFn = $lKhqw.hasOwnProperty(options, 'serialize') ? options.serialize : undefined;
        }
    }
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = $lKhqw.isURLSearchParams(params) ? params.toString() : new $CbnE5(params, options).toString(_encode);
    if (serializedParams) url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    return url;
};

});
parcelRegister("CbnE5", function(module, exports) {
'use strict';

var $iAsia = parcelRequire("iAsia");
function $072c60a19767556d$var$encode(str) {
    // Do not map `%00` back to a raw null byte: that reversed
    // the safe percent-encoding from encodeURIComponent and enabled null byte injection.
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'\(\)~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
function $072c60a19767556d$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && $iAsia(params, this, options);
}
var $072c60a19767556d$var$prototype = $072c60a19767556d$var$AxiosURLSearchParams.prototype;
$072c60a19767556d$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$072c60a19767556d$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function(value) {
        return encoder.call(this, value, $072c60a19767556d$var$encode);
    } : $072c60a19767556d$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
module.exports = $072c60a19767556d$var$AxiosURLSearchParams;

});
parcelRegister("iAsia", function(module, exports) {

var $48kA0 = parcelRequire("48kA0");
var $d88189039e2614bc$require$Buffer = $48kA0.Buffer;
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $fvEIL = parcelRequire("fvEIL");

var $tKiop = parcelRequire("tKiop");
function $d88189039e2614bc$var$isVisitable(thing) {
    return $lKhqw.isPlainObject(thing) || $lKhqw.isArray(thing);
}
function $d88189039e2614bc$var$removeBrackets(key) {
    return $lKhqw.endsWith(key, '[]') ? key.slice(0, -2) : key;
}
function $d88189039e2614bc$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d88189039e2614bc$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
function $d88189039e2614bc$var$isFlatArray(arr) {
    return $lKhqw.isArray(arr) && !arr.some($d88189039e2614bc$var$isVisitable);
}
var $d88189039e2614bc$var$predicates = $lKhqw.toFlatObject($lKhqw, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
function $d88189039e2614bc$var$isSpecCompliant(thing) {
    return thing && $lKhqw.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/ function $d88189039e2614bc$var$toFormData(obj, formData, options) {
    if (!$lKhqw.isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ($tKiop || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = $lKhqw.toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !$lKhqw.isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    var useBlob = _Blob && $d88189039e2614bc$var$isSpecCompliant(formData);
    if (!$lKhqw.isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ($lKhqw.isDate(value)) return value.toISOString();
        if (!useBlob && $lKhqw.isBlob(value)) throw new $fvEIL('Blob is not supported. Use a Buffer instead.');
        if ($lKhqw.isArrayBuffer(value) || $lKhqw.isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $d88189039e2614bc$require$Buffer.from(value);
        return value;
    }
    var stack = [];
    function assertValueDepth(value, depth) {
        if (depth > maxDepth) throw new $fvEIL('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $fvEIL.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (!$lKhqw.isObject(value) || stack.indexOf(value) !== -1) return;
        stack.push(value);
        $lKhqw.forEach(value, function each(el) {
            assertValueDepth(el, depth + 1);
        });
        stack.pop();
    }
    /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && typeof value === 'object') {
            if ($lKhqw.endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                assertValueDepth(value, 1);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ($lKhqw.isArray(value) && $d88189039e2614bc$var$isFlatArray(value) || $lKhqw.isFileList(value) || $lKhqw.endsWith(key, '[]') && (arr = $lKhqw.toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d88189039e2614bc$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !($lKhqw.isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d88189039e2614bc$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($d88189039e2614bc$var$isVisitable(value)) return true;
        formData.append($d88189039e2614bc$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var exposedHelpers = Object.assign($d88189039e2614bc$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d88189039e2614bc$var$isVisitable
    });
    function build(value, path, depth) {
        if ($lKhqw.isUndefined(value)) return;
        // eslint-disable-next-line no-param-reassign
        depth = depth || 0;
        if (depth > maxDepth) throw new $fvEIL('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $fvEIL.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        $lKhqw.forEach(value, function each(el, key) {
            var result = !($lKhqw.isUndefined(el) || el === null) && visitor.call(formData, el, $lKhqw.isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!$lKhqw.isObject(obj)) throw new TypeError('data must be an object');
    build(obj, null, 0);
    return formData;
}
module.exports = $d88189039e2614bc$var$toFormData;

});
parcelRegister("48kA0", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $3027df76fd166a36$export$a143d493d941bafc; }, function (v) { return $3027df76fd166a36$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3027df76fd166a36$export$f99ded8fe4b79145; }, function (v) { return $3027df76fd166a36$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3027df76fd166a36$export$a143d493d941bafc;
var $3027df76fd166a36$export$e4cf37d7f6fb9e0a;
var $3027df76fd166a36$export$f99ded8fe4b79145;
var $3027df76fd166a36$export$599f31c3813fae4d;
'use strict';

var $7ugUt = parcelRequire("7ugUt");

var $5EDwZ = parcelRequire("5EDwZ");
const $3027df76fd166a36$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3027df76fd166a36$export$a143d493d941bafc = $3027df76fd166a36$var$Buffer;
$3027df76fd166a36$export$e4cf37d7f6fb9e0a = $3027df76fd166a36$var$SlowBuffer;
$3027df76fd166a36$export$f99ded8fe4b79145 = 50;
const $3027df76fd166a36$var$K_MAX_LENGTH = 0x7fffffff;
$3027df76fd166a36$export$599f31c3813fae4d = $3027df76fd166a36$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3027df76fd166a36$var$Buffer.TYPED_ARRAY_SUPPORT = $3027df76fd166a36$var$typedArraySupport();
if (!$3027df76fd166a36$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3027df76fd166a36$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3027df76fd166a36$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3027df76fd166a36$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3027df76fd166a36$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3027df76fd166a36$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3027df76fd166a36$var$createBuffer(length) {
    if (length > $3027df76fd166a36$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3027df76fd166a36$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3027df76fd166a36$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3027df76fd166a36$var$allocUnsafe(arg);
    }
    return $3027df76fd166a36$var$from(arg, encodingOrOffset, length);
}
$3027df76fd166a36$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3027df76fd166a36$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3027df76fd166a36$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3027df76fd166a36$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3027df76fd166a36$var$isInstance(value, ArrayBuffer) || value && $3027df76fd166a36$var$isInstance(value.buffer, ArrayBuffer)) return $3027df76fd166a36$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3027df76fd166a36$var$isInstance(value, SharedArrayBuffer) || value && $3027df76fd166a36$var$isInstance(value.buffer, SharedArrayBuffer))) return $3027df76fd166a36$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3027df76fd166a36$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3027df76fd166a36$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3027df76fd166a36$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3027df76fd166a36$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3027df76fd166a36$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3027df76fd166a36$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3027df76fd166a36$var$Buffer, Uint8Array);
function $3027df76fd166a36$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3027df76fd166a36$var$alloc(size, fill, encoding) {
    $3027df76fd166a36$var$assertSize(size);
    if (size <= 0) return $3027df76fd166a36$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3027df76fd166a36$var$createBuffer(size).fill(fill, encoding) : $3027df76fd166a36$var$createBuffer(size).fill(fill);
    return $3027df76fd166a36$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3027df76fd166a36$var$Buffer.alloc = function(size, fill, encoding) {
    return $3027df76fd166a36$var$alloc(size, fill, encoding);
};
function $3027df76fd166a36$var$allocUnsafe(size) {
    $3027df76fd166a36$var$assertSize(size);
    return $3027df76fd166a36$var$createBuffer(size < 0 ? 0 : $3027df76fd166a36$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3027df76fd166a36$var$Buffer.allocUnsafe = function(size) {
    return $3027df76fd166a36$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3027df76fd166a36$var$Buffer.allocUnsafeSlow = function(size) {
    return $3027df76fd166a36$var$allocUnsafe(size);
};
function $3027df76fd166a36$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3027df76fd166a36$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3027df76fd166a36$var$byteLength(string, encoding) | 0;
    let buf = $3027df76fd166a36$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3027df76fd166a36$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3027df76fd166a36$var$checked(array.length) | 0;
    const buf = $3027df76fd166a36$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3027df76fd166a36$var$fromArrayView(arrayView) {
    if ($3027df76fd166a36$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3027df76fd166a36$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3027df76fd166a36$var$fromArrayLike(arrayView);
}
function $3027df76fd166a36$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3027df76fd166a36$var$Buffer.prototype);
    return buf;
}
function $3027df76fd166a36$var$fromObject(obj) {
    if ($3027df76fd166a36$var$Buffer.isBuffer(obj)) {
        const len = $3027df76fd166a36$var$checked(obj.length) | 0;
        const buf = $3027df76fd166a36$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3027df76fd166a36$var$numberIsNaN(obj.length)) return $3027df76fd166a36$var$createBuffer(0);
        return $3027df76fd166a36$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3027df76fd166a36$var$fromArrayLike(obj.data);
}
function $3027df76fd166a36$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3027df76fd166a36$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3027df76fd166a36$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3027df76fd166a36$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3027df76fd166a36$var$Buffer.alloc(+length);
}
$3027df76fd166a36$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3027df76fd166a36$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3027df76fd166a36$var$Buffer.compare = function compare(a, b) {
    if ($3027df76fd166a36$var$isInstance(a, Uint8Array)) a = $3027df76fd166a36$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3027df76fd166a36$var$isInstance(b, Uint8Array)) b = $3027df76fd166a36$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3027df76fd166a36$var$Buffer.isBuffer(a) || !$3027df76fd166a36$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3027df76fd166a36$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3027df76fd166a36$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3027df76fd166a36$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3027df76fd166a36$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3027df76fd166a36$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3027df76fd166a36$var$Buffer.isBuffer(buf)) buf = $3027df76fd166a36$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3027df76fd166a36$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3027df76fd166a36$var$byteLength(string, encoding) {
    if ($3027df76fd166a36$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3027df76fd166a36$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3027df76fd166a36$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3027df76fd166a36$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3027df76fd166a36$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3027df76fd166a36$var$Buffer.byteLength = $3027df76fd166a36$var$byteLength;
function $3027df76fd166a36$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3027df76fd166a36$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3027df76fd166a36$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3027df76fd166a36$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3027df76fd166a36$var$latin1Slice(this, start, end);
        case 'base64':
            return $3027df76fd166a36$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3027df76fd166a36$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3027df76fd166a36$var$Buffer.prototype._isBuffer = true;
function $3027df76fd166a36$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3027df76fd166a36$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3027df76fd166a36$var$swap(this, i, i + 1);
    return this;
};
$3027df76fd166a36$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3027df76fd166a36$var$swap(this, i, i + 3);
        $3027df76fd166a36$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3027df76fd166a36$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3027df76fd166a36$var$swap(this, i, i + 7);
        $3027df76fd166a36$var$swap(this, i + 1, i + 6);
        $3027df76fd166a36$var$swap(this, i + 2, i + 5);
        $3027df76fd166a36$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3027df76fd166a36$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3027df76fd166a36$var$utf8Slice(this, 0, length);
    return $3027df76fd166a36$var$slowToString.apply(this, arguments);
};
$3027df76fd166a36$var$Buffer.prototype.toLocaleString = $3027df76fd166a36$var$Buffer.prototype.toString;
$3027df76fd166a36$var$Buffer.prototype.equals = function equals(b) {
    if (!$3027df76fd166a36$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3027df76fd166a36$var$Buffer.compare(this, b) === 0;
};
$3027df76fd166a36$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3027df76fd166a36$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3027df76fd166a36$var$customInspectSymbol) $3027df76fd166a36$var$Buffer.prototype[$3027df76fd166a36$var$customInspectSymbol] = $3027df76fd166a36$var$Buffer.prototype.inspect;
$3027df76fd166a36$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3027df76fd166a36$var$isInstance(target, Uint8Array)) target = $3027df76fd166a36$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3027df76fd166a36$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3027df76fd166a36$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3027df76fd166a36$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3027df76fd166a36$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3027df76fd166a36$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3027df76fd166a36$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3027df76fd166a36$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3027df76fd166a36$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3027df76fd166a36$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3027df76fd166a36$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3027df76fd166a36$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3027df76fd166a36$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3027df76fd166a36$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3027df76fd166a36$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3027df76fd166a36$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3027df76fd166a36$var$utf8Write(buf, string, offset, length) {
    return $3027df76fd166a36$var$blitBuffer($3027df76fd166a36$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3027df76fd166a36$var$asciiWrite(buf, string, offset, length) {
    return $3027df76fd166a36$var$blitBuffer($3027df76fd166a36$var$asciiToBytes(string), buf, offset, length);
}
function $3027df76fd166a36$var$base64Write(buf, string, offset, length) {
    return $3027df76fd166a36$var$blitBuffer($3027df76fd166a36$var$base64ToBytes(string), buf, offset, length);
}
function $3027df76fd166a36$var$ucs2Write(buf, string, offset, length) {
    return $3027df76fd166a36$var$blitBuffer($3027df76fd166a36$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3027df76fd166a36$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3027df76fd166a36$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3027df76fd166a36$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3027df76fd166a36$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3027df76fd166a36$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3027df76fd166a36$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3027df76fd166a36$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3027df76fd166a36$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7ugUt.fromByteArray(buf);
    else return $7ugUt.fromByteArray(buf.slice(start, end));
}
function $3027df76fd166a36$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3027df76fd166a36$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3027df76fd166a36$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3027df76fd166a36$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3027df76fd166a36$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3027df76fd166a36$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3027df76fd166a36$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3027df76fd166a36$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3027df76fd166a36$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3027df76fd166a36$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3027df76fd166a36$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3027df76fd166a36$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3027df76fd166a36$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3027df76fd166a36$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3027df76fd166a36$var$Buffer.prototype.readUintLE = $3027df76fd166a36$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3027df76fd166a36$var$Buffer.prototype.readUintBE = $3027df76fd166a36$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3027df76fd166a36$var$Buffer.prototype.readUint8 = $3027df76fd166a36$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3027df76fd166a36$var$Buffer.prototype.readUint16LE = $3027df76fd166a36$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3027df76fd166a36$var$Buffer.prototype.readUint16BE = $3027df76fd166a36$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3027df76fd166a36$var$Buffer.prototype.readUint32LE = $3027df76fd166a36$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3027df76fd166a36$var$Buffer.prototype.readUint32BE = $3027df76fd166a36$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3027df76fd166a36$var$Buffer.prototype.readBigUInt64LE = $3027df76fd166a36$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3027df76fd166a36$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3027df76fd166a36$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3027df76fd166a36$var$Buffer.prototype.readBigUInt64BE = $3027df76fd166a36$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3027df76fd166a36$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3027df76fd166a36$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3027df76fd166a36$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3027df76fd166a36$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3027df76fd166a36$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3027df76fd166a36$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3027df76fd166a36$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3027df76fd166a36$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3027df76fd166a36$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3027df76fd166a36$var$Buffer.prototype.readBigInt64LE = $3027df76fd166a36$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3027df76fd166a36$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3027df76fd166a36$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3027df76fd166a36$var$Buffer.prototype.readBigInt64BE = $3027df76fd166a36$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3027df76fd166a36$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3027df76fd166a36$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3027df76fd166a36$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 4, this.length);
    return $5EDwZ.read(this, offset, true, 23, 4);
};
$3027df76fd166a36$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 4, this.length);
    return $5EDwZ.read(this, offset, false, 23, 4);
};
$3027df76fd166a36$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 8, this.length);
    return $5EDwZ.read(this, offset, true, 52, 8);
};
$3027df76fd166a36$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkOffset(offset, 8, this.length);
    return $5EDwZ.read(this, offset, false, 52, 8);
};
function $3027df76fd166a36$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3027df76fd166a36$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3027df76fd166a36$var$Buffer.prototype.writeUintLE = $3027df76fd166a36$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3027df76fd166a36$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3027df76fd166a36$var$Buffer.prototype.writeUintBE = $3027df76fd166a36$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3027df76fd166a36$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3027df76fd166a36$var$Buffer.prototype.writeUint8 = $3027df76fd166a36$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3027df76fd166a36$var$Buffer.prototype.writeUint16LE = $3027df76fd166a36$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3027df76fd166a36$var$Buffer.prototype.writeUint16BE = $3027df76fd166a36$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3027df76fd166a36$var$Buffer.prototype.writeUint32LE = $3027df76fd166a36$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3027df76fd166a36$var$Buffer.prototype.writeUint32BE = $3027df76fd166a36$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3027df76fd166a36$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3027df76fd166a36$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3027df76fd166a36$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3027df76fd166a36$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3027df76fd166a36$var$Buffer.prototype.writeBigUInt64LE = $3027df76fd166a36$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3027df76fd166a36$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3027df76fd166a36$var$Buffer.prototype.writeBigUInt64BE = $3027df76fd166a36$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3027df76fd166a36$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3027df76fd166a36$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3027df76fd166a36$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3027df76fd166a36$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3027df76fd166a36$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3027df76fd166a36$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3027df76fd166a36$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3027df76fd166a36$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3027df76fd166a36$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3027df76fd166a36$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3027df76fd166a36$var$Buffer.prototype.writeBigInt64LE = $3027df76fd166a36$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3027df76fd166a36$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3027df76fd166a36$var$Buffer.prototype.writeBigInt64BE = $3027df76fd166a36$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3027df76fd166a36$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3027df76fd166a36$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3027df76fd166a36$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5EDwZ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3027df76fd166a36$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3027df76fd166a36$var$writeFloat(this, value, offset, true, noAssert);
};
$3027df76fd166a36$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3027df76fd166a36$var$writeFloat(this, value, offset, false, noAssert);
};
function $3027df76fd166a36$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3027df76fd166a36$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5EDwZ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3027df76fd166a36$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3027df76fd166a36$var$writeDouble(this, value, offset, true, noAssert);
};
$3027df76fd166a36$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3027df76fd166a36$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3027df76fd166a36$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3027df76fd166a36$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3027df76fd166a36$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3027df76fd166a36$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3027df76fd166a36$var$Buffer.isBuffer(val) ? val : $3027df76fd166a36$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3027df76fd166a36$var$errors = {};
function $3027df76fd166a36$var$E(sym, getMessage, Base) {
    $3027df76fd166a36$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$3027df76fd166a36$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3027df76fd166a36$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3027df76fd166a36$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3027df76fd166a36$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3027df76fd166a36$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3027df76fd166a36$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3027df76fd166a36$var$checkBounds(buf, offset, byteLength) {
    $3027df76fd166a36$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3027df76fd166a36$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3027df76fd166a36$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3027df76fd166a36$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3027df76fd166a36$var$checkBounds(buf, offset, byteLength);
}
function $3027df76fd166a36$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3027df76fd166a36$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3027df76fd166a36$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3027df76fd166a36$var$validateNumber(value, type);
        throw new $3027df76fd166a36$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3027df76fd166a36$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3027df76fd166a36$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3027df76fd166a36$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3027df76fd166a36$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3027df76fd166a36$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3027df76fd166a36$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3027df76fd166a36$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3027df76fd166a36$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3027df76fd166a36$var$base64ToBytes(str) {
    return $7ugUt.toByteArray($3027df76fd166a36$var$base64clean(str));
}
function $3027df76fd166a36$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3027df76fd166a36$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3027df76fd166a36$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3027df76fd166a36$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3027df76fd166a36$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3027df76fd166a36$var$BufferBigIntNotDefined : fn;
}
function $3027df76fd166a36$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("7ugUt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $573873af918bbe5c$export$d622b2ad8d90c771; }, function (v) { return $573873af918bbe5c$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $573873af918bbe5c$export$6100ba28696e12de; }, function (v) { return $573873af918bbe5c$export$6100ba28696e12de = v; });
var $573873af918bbe5c$export$a48f0734ac7c2329;
var $573873af918bbe5c$export$d622b2ad8d90c771;
var $573873af918bbe5c$export$6100ba28696e12de;
'use strict';
$573873af918bbe5c$export$a48f0734ac7c2329 = $573873af918bbe5c$var$byteLength;
$573873af918bbe5c$export$d622b2ad8d90c771 = $573873af918bbe5c$var$toByteArray;
$573873af918bbe5c$export$6100ba28696e12de = $573873af918bbe5c$var$fromByteArray;
var $573873af918bbe5c$var$lookup = [];
var $573873af918bbe5c$var$revLookup = [];
var $573873af918bbe5c$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $573873af918bbe5c$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $573873af918bbe5c$var$i = 0, $573873af918bbe5c$var$len = $573873af918bbe5c$var$code.length; $573873af918bbe5c$var$i < $573873af918bbe5c$var$len; ++$573873af918bbe5c$var$i){
    $573873af918bbe5c$var$lookup[$573873af918bbe5c$var$i] = $573873af918bbe5c$var$code[$573873af918bbe5c$var$i];
    $573873af918bbe5c$var$revLookup[$573873af918bbe5c$var$code.charCodeAt($573873af918bbe5c$var$i)] = $573873af918bbe5c$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$573873af918bbe5c$var$revLookup['-'.charCodeAt(0)] = 62;
$573873af918bbe5c$var$revLookup['_'.charCodeAt(0)] = 63;
function $573873af918bbe5c$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $573873af918bbe5c$var$byteLength(b64) {
    var lens = $573873af918bbe5c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $573873af918bbe5c$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $573873af918bbe5c$var$toByteArray(b64) {
    var tmp;
    var lens = $573873af918bbe5c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $573873af918bbe5c$var$Arr($573873af918bbe5c$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $573873af918bbe5c$var$revLookup[b64.charCodeAt(i)] << 18 | $573873af918bbe5c$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $573873af918bbe5c$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $573873af918bbe5c$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $573873af918bbe5c$var$revLookup[b64.charCodeAt(i)] << 2 | $573873af918bbe5c$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $573873af918bbe5c$var$revLookup[b64.charCodeAt(i)] << 10 | $573873af918bbe5c$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $573873af918bbe5c$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $573873af918bbe5c$var$tripletToBase64(num) {
    return $573873af918bbe5c$var$lookup[num >> 18 & 0x3F] + $573873af918bbe5c$var$lookup[num >> 12 & 0x3F] + $573873af918bbe5c$var$lookup[num >> 6 & 0x3F] + $573873af918bbe5c$var$lookup[num & 0x3F];
}
function $573873af918bbe5c$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($573873af918bbe5c$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $573873af918bbe5c$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($573873af918bbe5c$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($573873af918bbe5c$var$lookup[tmp >> 2] + $573873af918bbe5c$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($573873af918bbe5c$var$lookup[tmp >> 10] + $573873af918bbe5c$var$lookup[tmp >> 4 & 0x3F] + $573873af918bbe5c$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("5EDwZ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $41df5a3ed97c2473$export$aafa59e2e03f2942; }, function (v) { return $41df5a3ed97c2473$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $41df5a3ed97c2473$export$68d8715fc104d294; }, function (v) { return $41df5a3ed97c2473$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $41df5a3ed97c2473$export$aafa59e2e03f2942;
var $41df5a3ed97c2473$export$68d8715fc104d294;
$41df5a3ed97c2473$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$41df5a3ed97c2473$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("fvEIL", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $hfofc = parcelRequire("hfofc");
var $b4a9569f70dbe2ea$var$REDACTED_VALUE = '[REDACTED ****]';
function $b4a9569f70dbe2ea$var$makeValueDescriptor(value) {
    var descriptor = Object.create(null);
    descriptor.value = value;
    return descriptor;
}
function $b4a9569f70dbe2ea$var$getRedactKeys(config) {
    // An empty array is treated as "no override" so an upstream `redact: []` cannot
    // silently disable redaction. To opt out, pass non-string values or unset keys.
    var override = config && $lKhqw.isArray(config.redact) && config.redact.length ? config.redact : null;
    var redact = override || $hfofc;
    var keys = {};
    $lKhqw.forEach(redact, function eachRedactKey(key) {
        if (typeof key === 'string') keys[key.toLowerCase()] = true;
    });
    return keys;
}
function $b4a9569f70dbe2ea$var$shouldRedact(key, keys) {
    return typeof key === 'string' && keys[key.toLowerCase()];
}
var $b4a9569f70dbe2ea$var$CIRCULAR_VALUE = '[Circular]';
function $b4a9569f70dbe2ea$var$serializeConfigValue(value, keys, key, seen) {
    var result;
    if ($b4a9569f70dbe2ea$var$shouldRedact(key, keys)) return $b4a9569f70dbe2ea$var$REDACTED_VALUE;
    if ($lKhqw.isArray(value)) {
        if (seen.indexOf(value) !== -1) return $b4a9569f70dbe2ea$var$CIRCULAR_VALUE;
        seen.push(value);
        result = [];
        $lKhqw.forEach(value, function eachArrayValue(item, index) {
            result[index] = $b4a9569f70dbe2ea$var$serializeConfigValue(item, keys, index, seen);
        });
        seen.pop();
        return result;
    }
    if ($lKhqw.isPlainObject(value)) {
        if (seen.indexOf(value) !== -1) return $b4a9569f70dbe2ea$var$CIRCULAR_VALUE;
        seen.push(value);
        result = {};
        $lKhqw.forEach(value, function eachObjectValue(item, itemKey) {
            result[itemKey] = $b4a9569f70dbe2ea$var$serializeConfigValue(item, keys, itemKey, seen);
        });
        seen.pop();
        return result;
    }
    return value;
}
function $b4a9569f70dbe2ea$var$serializeConfig(config) {
    if (!config) return config;
    return $b4a9569f70dbe2ea$var$serializeConfigValue(config, $b4a9569f70dbe2ea$var$getRedactKeys(config), undefined, []);
}
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $b4a9569f70dbe2ea$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$lKhqw.inherits($b4a9569f70dbe2ea$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: $b4a9569f70dbe2ea$var$serializeConfig(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $b4a9569f70dbe2ea$var$prototype = $b4a9569f70dbe2ea$var$AxiosError.prototype;
var $b4a9569f70dbe2ea$var$descriptors = Object.create(null);
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL',
    'ERR_FORM_DATA_DEPTH_EXCEEDED'
].forEach(function(code) {
    $b4a9569f70dbe2ea$var$descriptors[code] = $b4a9569f70dbe2ea$var$makeValueDescriptor(code);
});
Object.defineProperties($b4a9569f70dbe2ea$var$AxiosError, $b4a9569f70dbe2ea$var$descriptors);
Object.defineProperty($b4a9569f70dbe2ea$var$prototype, 'isAxiosError', $b4a9569f70dbe2ea$var$makeValueDescriptor(true));
// eslint-disable-next-line func-names
$b4a9569f70dbe2ea$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($b4a9569f70dbe2ea$var$prototype);
    $lKhqw.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $b4a9569f70dbe2ea$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $b4a9569f70dbe2ea$var$AxiosError;

});
parcelRegister("hfofc", function(module, exports) {
'use strict';
module.exports = [
    'authorization',
    'proxy-authorization',
    'cookie',
    'set-cookie',
    'x-api-key',
    'password'
];

});


parcelRegister("tKiop", function(module, exports) {
// eslint-disable-next-line strict

module.exports = (parcelRequire("3v3K8"));

});
parcelRegister("3v3K8", function(module, exports) {
'use strict';
/* eslint-env browser */ module.exports = typeof self === 'object' ? self.FormData : window.FormData;

});





parcelRegister("avirQ", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
function $7a5b1c0937c752f6$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $7a5b1c0937c752f6$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $7a5b1c0937c752f6$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Clear all interceptors from the stack
 */ $7a5b1c0937c752f6$var$InterceptorManager.prototype.clear = function clear() {
    if (this.handlers) this.handlers = [];
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $7a5b1c0937c752f6$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $lKhqw.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $7a5b1c0937c752f6$var$InterceptorManager;

});

parcelRegister("eiKwg", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $lgs8l = parcelRequire("lgs8l");

var $HLDIA = parcelRequire("HLDIA");

var $8r22E = parcelRequire("8r22E");

var $c3JFs = parcelRequire("c3JFs");

var $8L8x3 = parcelRequire("8L8x3");

var $8fm95 = parcelRequire("8fm95");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $a696d4ee9286baa4$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $c3JFs();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a696d4ee9286baa4$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $lgs8l.call(config, config.data, config.headers, null, config.transformRequest);
    $8L8x3(config.headers, 'Accept');
    $8L8x3(config.headers, 'Content-Type');
    // Flatten headers
    var commonHeaders = $lKhqw.hasOwnProperty(config.headers, 'common') && config.headers.common ? config.headers.common : {};
    var methodHeaders = config.method && $lKhqw.hasOwnProperty(config.headers, config.method) && config.headers[config.method] ? config.headers[config.method] : {};
    config.headers = $lKhqw.merge(commonHeaders, methodHeaders, config.headers);
    $lKhqw.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    $lKhqw.forEach(config.headers, function sanitizeHeaderConfigValue(value, header) {
        config.headers[header] = $8fm95(value);
    });
    var adapter = config.adapter || $8r22E.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a696d4ee9286baa4$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $lgs8l.call(config, response.data, response.headers, response.status, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$HLDIA(reason)) {
            $a696d4ee9286baa4$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $lgs8l.call(config, reason.response.data, reason.response.headers, reason.response.status, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("lgs8l", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $8r22E = parcelRequire("8r22E");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, status, fns) {
    var context = this || $8r22E;
    /*eslint no-param-reassign:0*/ $lKhqw.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers, status);
    });
    return data;
};

});
parcelRegister("8r22E", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $8L8x3 = parcelRequire("8L8x3");

var $fvEIL = parcelRequire("fvEIL");

var $jTLmY = parcelRequire("jTLmY");

var $iAsia = parcelRequire("iAsia");

var $69wFm = parcelRequire("69wFm");

var $fXC4J = parcelRequire("fXC4J");

var $68kV9 = parcelRequire("68kV9");

var $hfofc = parcelRequire("hfofc");
var $62426dc953835d5e$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $62426dc953835d5e$var$setContentTypeIfUnset(headers, value) {
    if (!$lKhqw.isUndefined(headers) && $lKhqw.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $62426dc953835d5e$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("9gGJV"));
    return adapter;
}
function $62426dc953835d5e$var$stringifySafely(rawValue, parser, encoder) {
    if ($lKhqw.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $lKhqw.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $62426dc953835d5e$var$defaults = {
    transitional: $jTLmY,
    adapter: $62426dc953835d5e$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $8L8x3(headers, 'Accept');
            $8L8x3(headers, 'Content-Type');
            var contentType = headers && headers['Content-Type'] || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = $lKhqw.isObject(data);
            if (isObjectPayload && $lKhqw.isHTMLForm(data)) data = new FormData(data);
            var isFormData = $lKhqw.isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify($68kV9(data)) : data;
            if ($lKhqw.isArrayBuffer(data) || $lKhqw.isBuffer(data) || $lKhqw.isStream(data) || $lKhqw.isFile(data) || $lKhqw.isBlob(data)) return data;
            if ($lKhqw.isArrayBufferView(data)) return data.buffer;
            if ($lKhqw.isURLSearchParams(data)) {
                $62426dc953835d5e$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                var formSerializer = $lKhqw.hasOwnProperty(this, 'formSerializer') ? this.formSerializer : undefined;
                var envOption = $lKhqw.hasOwnProperty(this, 'env') ? this.env : undefined;
                if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) return $69wFm(data, formSerializer).toString();
                if ((isFileList = $lKhqw.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = envOption && envOption.FormData;
                    return $iAsia(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                $62426dc953835d5e$var$setContentTypeIfUnset(headers, 'application/json');
                return $62426dc953835d5e$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $62426dc953835d5e$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if (data && $lKhqw.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw $fvEIL.from(e, $fvEIL.ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    redact: $hfofc.slice(),
    env: {
        FormData: $fXC4J.classes.FormData,
        Blob: $fXC4J.classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$lKhqw.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $62426dc953835d5e$var$defaults.headers[method] = {};
});
$lKhqw.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $62426dc953835d5e$var$defaults.headers[method] = $lKhqw.merge($62426dc953835d5e$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $62426dc953835d5e$var$defaults;

});
parcelRegister("8L8x3", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $lKhqw.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("jTLmY", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("69wFm", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $iAsia = parcelRequire("iAsia");

var $fXC4J = parcelRequire("fXC4J");
module.exports = function toURLEncodedForm(data, options) {
    return $iAsia(data, new $fXC4J.classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ($fXC4J.isNode && $lKhqw.isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
};

});
parcelRegister("fXC4J", function(module, exports) {
'use strict';

module.exports = (parcelRequire("KNlnY"));

});
parcelRegister("KNlnY", function(module, exports) {
'use strict';


module.exports = {
    isBrowser: true,
    classes: {
        URLSearchParams: (parcelRequire("dKhp6")),
        FormData: (parcelRequire("kagez")),
        Blob: Blob
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("dKhp6", function(module, exports) {
'use strict';

var $CbnE5 = parcelRequire("CbnE5");
module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : $CbnE5;

});

parcelRegister("kagez", function(module, exports) {
'use strict';
module.exports = FormData;

});




parcelRegister("68kV9", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $fvEIL = parcelRequire("fvEIL");
var $4773b7e09a106bd1$var$MAX_FORM_DATA_TO_JSON_DEPTH = 100;
function $4773b7e09a106bd1$var$assertPathDepth(path) {
    var depth = path.length - 1;
    if (depth > $4773b7e09a106bd1$var$MAX_FORM_DATA_TO_JSON_DEPTH) throw new $fvEIL('Maximum object depth of ' + $4773b7e09a106bd1$var$MAX_FORM_DATA_TO_JSON_DEPTH + ' exceeded (got ' + depth + ' levels)', $fvEIL.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function $4773b7e09a106bd1$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return $lKhqw.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
function $4773b7e09a106bd1$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
function $4773b7e09a106bd1$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && $lKhqw.isArray(target) ? target.length : name;
        if (isLast) {
            if ($lKhqw.hasOwnProperty(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !$lKhqw.isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && $lKhqw.isArray(target[name])) target[name] = $4773b7e09a106bd1$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ($lKhqw.isFormData(formData) && $lKhqw.isFunction(formData.entries)) {
        var obj = {};
        $lKhqw.forEachEntry(formData, function(name, value) {
            var path = $4773b7e09a106bd1$var$parsePropPath(name);
            $4773b7e09a106bd1$var$assertPathDepth(path);
            buildPath(path, value, obj, 0);
        });
        return obj;
    }
    return null;
}
module.exports = $4773b7e09a106bd1$var$formDataToJSON;

});

parcelRegister("9gGJV", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");

var $lDK0X = parcelRequire("lDK0X");

var $3PTc0 = parcelRequire("3PTc0");

var $iUyGw = parcelRequire("iUyGw");

var $bueOp = parcelRequire("bueOp");

var $fqmMy = parcelRequire("fqmMy");

var $6YDQT = parcelRequire("6YDQT");

var $jTLmY = parcelRequire("jTLmY");

var $fvEIL = parcelRequire("fvEIL");

var $c3JFs = parcelRequire("c3JFs");

var $7Hlzh = parcelRequire("7Hlzh");

var $fXC4J = parcelRequire("fXC4J");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        // Guard against prototype pollution: only honor own properties.
        var withXSRFToken = $lKhqw.hasOwnProperty(config, 'withXSRFToken') ? config.withXSRFToken : undefined;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($lKhqw.isFormData(requestData) && $lKhqw.isStandardBrowserEnv()) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        var configAuth = $lKhqw.hasOwnProperty(config, 'auth') ? config.auth : undefined;
        if (configAuth) {
            var username = $lKhqw.hasOwnProperty(configAuth, 'username') ? configAuth.username || '' : '';
            var password = $lKhqw.hasOwnProperty(configAuth, 'password') && configAuth.password ? unescape(encodeURIComponent(configAuth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $bueOp(config.baseURL, config.url, config.allowAbsoluteUrls);
        request.open(config.method.toUpperCase(), $iUyGw(fullPath, config.params, $lKhqw.hasOwnProperty(config, 'paramsSerializer') ? config.paramsSerializer : undefined), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $fqmMy(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $lDK0X(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $fvEIL('Request aborted', $fvEIL.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $fvEIL('Network Error', $fvEIL.ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $jTLmY;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $fvEIL(timeoutErrorMessage, transitional.clarifyTimeoutError ? $fvEIL.ETIMEDOUT : $fvEIL.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($lKhqw.isStandardBrowserEnv()) {
            // Add xsrf header
            if ($lKhqw.isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(config);
            // Strict boolean check: only `true` short-circuits the same-origin guard.
            if (withXSRFToken === true || withXSRFToken !== false && $6YDQT(fullPath)) {
                // Add xsrf header
                var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && $3PTc0.read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $lKhqw.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$lKhqw.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new $c3JFs(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        // false, 0 (zero number), and '' (empty string) are valid JSON values
        if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') requestData = null;
        var protocol = $7Hlzh(fullPath);
        if (protocol && $fXC4J.protocols.indexOf(protocol) === -1) {
            reject(new $fvEIL('Unsupported protocol ' + protocol + ':', $fvEIL.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("lDK0X", function(module, exports) {
'use strict';

var $fvEIL = parcelRequire("fvEIL");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $fvEIL('Request failed with status code ' + response.status, [
        $fvEIL.ERR_BAD_REQUEST,
        $fvEIL.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("3PTc0", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
module.exports = $lKhqw.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($lKhqw.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($lKhqw.isString(path)) cookie.push('path=' + path);
            if ($lKhqw.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var nameEQ = name + '=';
            var cookies = document.cookie.split(';');
            var cookie;
            for(var i = 0; i < cookies.length; i++){
                cookie = cookies[i];
                while(cookie.charAt(0) === ' ')cookie = cookie.substring(1);
                if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length));
            }
            return null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("bueOp", function(module, exports) {
'use strict';

var $7sSu0 = parcelRequire("7sSu0");

var $1Sn7d = parcelRequire("1Sn7d");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @param {boolean} allowAbsoluteUrls Set to true to allow absolute URLs
 *
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeURL = !$7sSu0(requestedURL);
    if (baseURL && (isRelativeURL || allowAbsoluteUrls === false)) return $1Sn7d(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("7sSu0", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("1Sn7d", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("fqmMy", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $b3aaf4cd5be16710$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $lKhqw.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $lKhqw.trim(line.slice(0, i)).toLowerCase();
        val = $lKhqw.trim(line.slice(i + 1));
        if (key) {
            if (parsed[key] && $b3aaf4cd5be16710$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("6YDQT", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
module.exports = $lKhqw.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */ return function isURLSameOrigin(requestURL) {
        var parsed = $lKhqw.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("c3JFs", function(module, exports) {
'use strict';

var $fvEIL = parcelRequire("fvEIL");

var $lKhqw = parcelRequire("lKhqw");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */ function $8c793084adbb1cd9$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $fvEIL.call(this, message == null ? 'canceled' : message, $fvEIL.ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
$lKhqw.inherits($8c793084adbb1cd9$var$CanceledError, $fvEIL, {
    __CANCEL__: true
});
module.exports = $8c793084adbb1cd9$var$CanceledError;

});

parcelRegister("7Hlzh", function(module, exports) {
'use strict';
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
};

});




parcelRegister("HLDIA", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("8fm95", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
var $6010e71976711374$var$INVALID_HEADER_VALUE_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
var $6010e71976711374$var$BOUNDARY_WHITESPACE_RE = /^[\x09\x20]+|[\x09\x20]+$/g;
function $6010e71976711374$var$sanitizeHeaderValue(value) {
    if (value === false || value == null) return value;
    if ($lKhqw.isArray(value)) return value.map($6010e71976711374$var$sanitizeHeaderValue);
    return String(value).replace($6010e71976711374$var$INVALID_HEADER_VALUE_RE, '').replace($6010e71976711374$var$BOUNDARY_WHITESPACE_RE, '');
}
module.exports = $6010e71976711374$var$sanitizeHeaderValue;

});


parcelRegister("4HCLR", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so a polluted Object.prototype cannot leak
    // values (e.g. transport, adapter) into the returned config via inheritance.
    var config = Object.create(null);
    function getOwn(source, prop) {
        return $lKhqw.hasOwnProperty(source, prop) ? source[prop] : undefined;
    }
    function hasOwn(source, prop) {
        return $lKhqw.hasOwnProperty(source, prop);
    }
    function getMergedValue(target, source) {
        if ($lKhqw.isPlainObject(target) && $lKhqw.isPlainObject(source)) return $lKhqw.merge(target, source);
        else if ($lKhqw.isEmptyObject(source)) return $lKhqw.merge({}, target);
        else if ($lKhqw.isPlainObject(source)) return $lKhqw.merge({}, source);
        else if ($lKhqw.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (hasOwn(config2, prop) && !$lKhqw.isUndefined(config2[prop])) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop) && !$lKhqw.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (hasOwn(config2, prop) && !$lKhqw.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (hasOwn(config2, prop) && !$lKhqw.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (hasOwn(config1, prop) && !$lKhqw.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (hasOwn(config2, prop)) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop)) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'withXSRFToken': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'beforeRedirect': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'allowedSocketPaths': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $lKhqw.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        var merge = $lKhqw.hasOwnProperty(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        var configValue = merge(prop);
        $lKhqw.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("46n07", function(module, exports) {
'use strict';

var $hIREP = parcelRequire("hIREP");
var $2fc99072959eb0fa$require$VERSION = $hIREP.version;

var $fvEIL = parcelRequire("fvEIL");
var $2fc99072959eb0fa$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $2fc99072959eb0fa$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $2fc99072959eb0fa$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $2fc99072959eb0fa$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $2fc99072959eb0fa$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $fvEIL(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), $fvEIL.ERR_DEPRECATED);
        if (version && !$2fc99072959eb0fa$var$deprecatedWarnings[opt]) {
            $2fc99072959eb0fa$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $2fc99072959eb0fa$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new $fvEIL('options must be an object', $fvEIL.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $fvEIL('option ' + opt + ' must be ' + result, $fvEIL.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $fvEIL('Unknown option ' + opt, $fvEIL.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $2fc99072959eb0fa$var$assertOptions,
    validators: $2fc99072959eb0fa$var$validators
};

});
parcelRegister("hIREP", function(module, exports) {
module.exports = {
    "version": "0.33.0"
};

});



parcelRegister("6pDYR", function(module, exports) {
'use strict';

var $c3JFs = parcelRequire("c3JFs");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $4ab41735eb671710$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i = token._listeners.length;
        while(i-- > 0)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message, config, request) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $c3JFs(message, config, request);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $4ab41735eb671710$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $4ab41735eb671710$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $4ab41735eb671710$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $4ab41735eb671710$var$CancelToken.source = function source() {
    var cancel;
    var token = new $4ab41735eb671710$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $4ab41735eb671710$var$CancelToken;

});

parcelRegister("8U7FG", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("eNCTT", function(module, exports) {
'use strict';

var $lKhqw = parcelRequire("lKhqw");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $lKhqw.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("dDAvp", function(module, exports) {

var $3KrFG = parcelRequire("3KrFG");

var $6M9E7 = parcelRequire("6M9E7");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $3KrFG.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6M9E7;
module.exports = isBuffer;

});
parcelRegister("3KrFG", function(module, exports) {

var $6ab14 = parcelRequire("6ab14");
/** Detect free variable `self`. */ var $2bab21e927496959$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2bab21e927496959$var$root = $6ab14 || $2bab21e927496959$var$freeSelf || Function('return this')();
module.exports = $2bab21e927496959$var$root;

});
parcelRegister("6ab14", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $47cc38dbd464cc7c$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $47cc38dbd464cc7c$var$freeGlobal;

});


parcelRegister("6M9E7", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $4eeeb54294e2f424$var$stubFalse() {
    return false;
}
module.exports = $4eeeb54294e2f424$var$stubFalse;

});


parcelRegister("6wVNP", function(module, exports) {

var $6ab14 = parcelRequire("6ab14");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $6ab14.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("cXAH8", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $96f775841c7ea479$export$2b8d127b894957b9; }, function (v) { return $96f775841c7ea479$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $96f775841c7ea479$export$cea3a54a6425200c; }, function (v) { return $96f775841c7ea479$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $96f775841c7ea479$export$a7c73072b1a182ae; }, function (v) { return $96f775841c7ea479$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $96f775841c7ea479$export$9f27bc3417b4524d; }, function (v) { return $96f775841c7ea479$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $96f775841c7ea479$export$db77ccec0bb4ccac; }, function (v) { return $96f775841c7ea479$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $96f775841c7ea479$export$8392c0c9d3dcbd35; }, function (v) { return $96f775841c7ea479$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $96f775841c7ea479$export$ffb0004e005737fa; }, function (v) { return $96f775841c7ea479$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $96f775841c7ea479$export$b624eff549462981; }, function (v) { return $96f775841c7ea479$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $96f775841c7ea479$export$7897aa7841a5380c; }, function (v) { return $96f775841c7ea479$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $96f775841c7ea479$export$602eac185826482c; }, function (v) { return $96f775841c7ea479$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $96f775841c7ea479$export$e2c29f18771995cb; }, function (v) { return $96f775841c7ea479$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $96f775841c7ea479$export$5f8d39834fd61797; }, function (v) { return $96f775841c7ea479$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $96f775841c7ea479$export$74bf444e3cd11ea5; }, function (v) { return $96f775841c7ea479$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $96f775841c7ea479$export$92387174baf9b227; }, function (v) { return $96f775841c7ea479$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $96f775841c7ea479$export$ec112efeb987d9c6; }, function (v) { return $96f775841c7ea479$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $96f775841c7ea479$export$b706b080d889d2c9; }, function (v) { return $96f775841c7ea479$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $96f775841c7ea479$export$5be5a87408f70ddc; }, function (v) { return $96f775841c7ea479$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $96f775841c7ea479$export$45a5e7f76e0caa8d; }, function (v) { return $96f775841c7ea479$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $96f775841c7ea479$export$455c2e768291efa6; }, function (v) { return $96f775841c7ea479$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $96f775841c7ea479$export$9522e17588c12572; }, function (v) { return $96f775841c7ea479$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $96f775841c7ea479$export$2110ac352bb060b9; }, function (v) { return $96f775841c7ea479$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $96f775841c7ea479$export$56885ab8b9c456ab; }, function (v) { return $96f775841c7ea479$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $96f775841c7ea479$export$d927fcb6adf8f9de; }, function (v) { return $96f775841c7ea479$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $96f775841c7ea479$export$b82d16f27459e05a; }, function (v) { return $96f775841c7ea479$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $96f775841c7ea479$export$522c17b4f5e123e8; }, function (v) { return $96f775841c7ea479$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $96f775841c7ea479$export$1aabd8a0274ecfd6; }, function (v) { return $96f775841c7ea479$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $96f775841c7ea479$export$9b621391a187a31a; }, function (v) { return $96f775841c7ea479$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $96f775841c7ea479$export$f5bbd400c2f4426f; }, function (v) { return $96f775841c7ea479$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $96f775841c7ea479$export$2b8d127b894957b9;
var $96f775841c7ea479$export$cea3a54a6425200c;
var $96f775841c7ea479$export$a7c73072b1a182ae;
var $96f775841c7ea479$export$9f27bc3417b4524d;
var $96f775841c7ea479$export$db77ccec0bb4ccac;
var $96f775841c7ea479$export$8392c0c9d3dcbd35;
var $96f775841c7ea479$export$ffb0004e005737fa;
var $96f775841c7ea479$export$b624eff549462981;
var $96f775841c7ea479$export$7897aa7841a5380c;
var $96f775841c7ea479$export$602eac185826482c;
var $96f775841c7ea479$export$e2c29f18771995cb;
var $96f775841c7ea479$export$5f8d39834fd61797;
var $96f775841c7ea479$export$74bf444e3cd11ea5;
var $96f775841c7ea479$export$92387174baf9b227;
var $96f775841c7ea479$export$ec112efeb987d9c6;
var $96f775841c7ea479$export$b706b080d889d2c9;
var $96f775841c7ea479$export$5be5a87408f70ddc;
var $96f775841c7ea479$export$45a5e7f76e0caa8d;
var $96f775841c7ea479$export$455c2e768291efa6;
var $96f775841c7ea479$export$9522e17588c12572;
var $96f775841c7ea479$export$2110ac352bb060b9;
var $96f775841c7ea479$export$56885ab8b9c456ab;
var $96f775841c7ea479$export$d927fcb6adf8f9de;
var $96f775841c7ea479$export$b82d16f27459e05a;
var $96f775841c7ea479$export$522c17b4f5e123e8;
var $96f775841c7ea479$export$1aabd8a0274ecfd6;
var $96f775841c7ea479$export$9b621391a187a31a;
var $96f775841c7ea479$export$f5bbd400c2f4426f;
'use strict';
var $96f775841c7ea479$var$b = "function" === typeof Symbol && Symbol.for, $96f775841c7ea479$var$c = $96f775841c7ea479$var$b ? Symbol.for("react.element") : 60103, $96f775841c7ea479$var$d = $96f775841c7ea479$var$b ? Symbol.for("react.portal") : 60106, $96f775841c7ea479$var$e = $96f775841c7ea479$var$b ? Symbol.for("react.fragment") : 60107, $96f775841c7ea479$var$f = $96f775841c7ea479$var$b ? Symbol.for("react.strict_mode") : 60108, $96f775841c7ea479$var$g = $96f775841c7ea479$var$b ? Symbol.for("react.profiler") : 60114, $96f775841c7ea479$var$h = $96f775841c7ea479$var$b ? Symbol.for("react.provider") : 60109, $96f775841c7ea479$var$k = $96f775841c7ea479$var$b ? Symbol.for("react.context") : 60110, $96f775841c7ea479$var$l = $96f775841c7ea479$var$b ? Symbol.for("react.async_mode") : 60111, $96f775841c7ea479$var$m = $96f775841c7ea479$var$b ? Symbol.for("react.concurrent_mode") : 60111, $96f775841c7ea479$var$n = $96f775841c7ea479$var$b ? Symbol.for("react.forward_ref") : 60112, $96f775841c7ea479$var$p = $96f775841c7ea479$var$b ? Symbol.for("react.suspense") : 60113, $96f775841c7ea479$var$q = $96f775841c7ea479$var$b ? Symbol.for("react.suspense_list") : 60120, $96f775841c7ea479$var$r = $96f775841c7ea479$var$b ? Symbol.for("react.memo") : 60115, $96f775841c7ea479$var$t = $96f775841c7ea479$var$b ? Symbol.for("react.lazy") : 60116, $96f775841c7ea479$var$v = $96f775841c7ea479$var$b ? Symbol.for("react.block") : 60121, $96f775841c7ea479$var$w = $96f775841c7ea479$var$b ? Symbol.for("react.fundamental") : 60117, $96f775841c7ea479$var$x = $96f775841c7ea479$var$b ? Symbol.for("react.responder") : 60118, $96f775841c7ea479$var$y = $96f775841c7ea479$var$b ? Symbol.for("react.scope") : 60119;
function $96f775841c7ea479$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $96f775841c7ea479$var$c:
                switch(a = a.type, a){
                    case $96f775841c7ea479$var$l:
                    case $96f775841c7ea479$var$m:
                    case $96f775841c7ea479$var$e:
                    case $96f775841c7ea479$var$g:
                    case $96f775841c7ea479$var$f:
                    case $96f775841c7ea479$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $96f775841c7ea479$var$k:
                            case $96f775841c7ea479$var$n:
                            case $96f775841c7ea479$var$t:
                            case $96f775841c7ea479$var$r:
                            case $96f775841c7ea479$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $96f775841c7ea479$var$d:
                return u;
        }
    }
}
function $96f775841c7ea479$var$A(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$m;
}
$96f775841c7ea479$export$2b8d127b894957b9 = $96f775841c7ea479$var$l;
$96f775841c7ea479$export$cea3a54a6425200c = $96f775841c7ea479$var$m;
$96f775841c7ea479$export$a7c73072b1a182ae = $96f775841c7ea479$var$k;
$96f775841c7ea479$export$9f27bc3417b4524d = $96f775841c7ea479$var$h;
$96f775841c7ea479$export$db77ccec0bb4ccac = $96f775841c7ea479$var$c;
$96f775841c7ea479$export$8392c0c9d3dcbd35 = $96f775841c7ea479$var$n;
$96f775841c7ea479$export$ffb0004e005737fa = $96f775841c7ea479$var$e;
$96f775841c7ea479$export$b624eff549462981 = $96f775841c7ea479$var$t;
$96f775841c7ea479$export$7897aa7841a5380c = $96f775841c7ea479$var$r;
$96f775841c7ea479$export$602eac185826482c = $96f775841c7ea479$var$d;
$96f775841c7ea479$export$e2c29f18771995cb = $96f775841c7ea479$var$g;
$96f775841c7ea479$export$5f8d39834fd61797 = $96f775841c7ea479$var$f;
$96f775841c7ea479$export$74bf444e3cd11ea5 = $96f775841c7ea479$var$p;
$96f775841c7ea479$export$92387174baf9b227 = function(a) {
    return $96f775841c7ea479$var$A(a) || $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$l;
};
$96f775841c7ea479$export$ec112efeb987d9c6 = $96f775841c7ea479$var$A;
$96f775841c7ea479$export$b706b080d889d2c9 = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$k;
};
$96f775841c7ea479$export$5be5a87408f70ddc = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$h;
};
$96f775841c7ea479$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $96f775841c7ea479$var$c;
};
$96f775841c7ea479$export$455c2e768291efa6 = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$n;
};
$96f775841c7ea479$export$9522e17588c12572 = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$e;
};
$96f775841c7ea479$export$2110ac352bb060b9 = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$t;
};
$96f775841c7ea479$export$56885ab8b9c456ab = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$r;
};
$96f775841c7ea479$export$d927fcb6adf8f9de = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$d;
};
$96f775841c7ea479$export$b82d16f27459e05a = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$g;
};
$96f775841c7ea479$export$522c17b4f5e123e8 = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$f;
};
$96f775841c7ea479$export$1aabd8a0274ecfd6 = function(a) {
    return $96f775841c7ea479$var$z(a) === $96f775841c7ea479$var$p;
};
$96f775841c7ea479$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $96f775841c7ea479$var$e || a === $96f775841c7ea479$var$m || a === $96f775841c7ea479$var$g || a === $96f775841c7ea479$var$f || a === $96f775841c7ea479$var$p || a === $96f775841c7ea479$var$q || "object" === typeof a && null !== a && (a.$$typeof === $96f775841c7ea479$var$t || a.$$typeof === $96f775841c7ea479$var$r || a.$$typeof === $96f775841c7ea479$var$h || a.$$typeof === $96f775841c7ea479$var$k || a.$$typeof === $96f775841c7ea479$var$n || a.$$typeof === $96f775841c7ea479$var$w || a.$$typeof === $96f775841c7ea479$var$x || a.$$typeof === $96f775841c7ea479$var$y || a.$$typeof === $96f775841c7ea479$var$v);
};
$96f775841c7ea479$export$f5bbd400c2f4426f = $96f775841c7ea479$var$z;

});

parcelRegister("lmnjA", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("8qOkl"));

});
parcelRegister("8qOkl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $6zSoD.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $6zSoD.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $eqDl2.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $eqDl2.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $9Koi4.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $9Koi4.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $9Koi4.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $9Koi4.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $6237ca60769398a3$var$_symbol.symbolsStroke;
    }
});

var $6237ca60769398a3$var$_arc = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("fWqxJ")));

var $6237ca60769398a3$var$_area = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("jNuNu")));

var $6237ca60769398a3$var$_line = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("eFopW")));

var $6237ca60769398a3$var$_pie = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("ccRkK")));

var $6237ca60769398a3$var$_areaRadial = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("exLuC")));

var $6237ca60769398a3$var$_lineRadial = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("axDWQ")));

var $6237ca60769398a3$var$_pointRadial = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("bDhxk")));

var $9Koi4 = parcelRequire("9Koi4");

var $6237ca60769398a3$var$_symbol = $6237ca60769398a3$var$_interopRequireWildcard((parcelRequire("hAOMy")));

var $6237ca60769398a3$var$_asterisk = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("cgmji")));

var $6237ca60769398a3$var$_circle = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("eKInh")));

var $6237ca60769398a3$var$_cross = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("dKf35")));

var $6237ca60769398a3$var$_diamond = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("j3Sri")));

var $6237ca60769398a3$var$_diamond2 = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("b2KEh")));

var $6237ca60769398a3$var$_plus = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("54lE4")));

var $6237ca60769398a3$var$_square = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("atbx8")));

var $6237ca60769398a3$var$_square2 = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("h6W3p")));

var $6237ca60769398a3$var$_star = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("90SWr")));

var $6237ca60769398a3$var$_triangle = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("iz8wS")));

var $6237ca60769398a3$var$_triangle2 = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("3iSnr")));

var $6237ca60769398a3$var$_wye = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("gO1S5")));

var $6237ca60769398a3$var$_x = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("ZkaZG")));

var $6237ca60769398a3$var$_basisClosed = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("fbx4U")));

var $6237ca60769398a3$var$_basisOpen = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("bzHwV")));

var $6237ca60769398a3$var$_basis = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("bhqrp")));

var $6zSoD = parcelRequire("6zSoD");

var $6237ca60769398a3$var$_bundle = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("9Rt57")));

var $6237ca60769398a3$var$_cardinalClosed = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("FguEO")));

var $6237ca60769398a3$var$_cardinalOpen = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("jK3C1")));

var $6237ca60769398a3$var$_cardinal = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("59JRC")));

var $6237ca60769398a3$var$_catmullRomClosed = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("4JZTt")));

var $6237ca60769398a3$var$_catmullRomOpen = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("1R87b")));

var $6237ca60769398a3$var$_catmullRom = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("dHOVI")));

var $6237ca60769398a3$var$_linearClosed = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("kx6bW")));

var $6237ca60769398a3$var$_linear = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("8QEPZ")));

var $eqDl2 = parcelRequire("eqDl2");

var $6237ca60769398a3$var$_natural = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("4mavy")));

var $6237ca60769398a3$var$_step = $6237ca60769398a3$var$_interopRequireWildcard((parcelRequire("jAEei")));

var $6237ca60769398a3$var$_stack = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("kuaoz")));

var $6237ca60769398a3$var$_expand = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("by8mw")));

var $6237ca60769398a3$var$_diverging = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("7w0VI")));

var $6237ca60769398a3$var$_none = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("aN35u")));

var $6237ca60769398a3$var$_silhouette = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("4E1sl")));

var $6237ca60769398a3$var$_wiggle = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("gJz45")));

var $6237ca60769398a3$var$_appearance = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("laBy0")));

var $6237ca60769398a3$var$_ascending = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("4TEbR")));

var $6237ca60769398a3$var$_descending = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("689XD")));

var $6237ca60769398a3$var$_insideOut = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("9QAUG")));

var $6237ca60769398a3$var$_none2 = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("aTlDB")));

var $6237ca60769398a3$var$_reverse = $6237ca60769398a3$var$_interopRequireDefault((parcelRequire("fr5UE")));
function $6237ca60769398a3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6237ca60769398a3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6237ca60769398a3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6237ca60769398a3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6237ca60769398a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("fWqxJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b9b0dcb51996021a$var$_default;

var $6QjrA = parcelRequire("6QjrA");

var $b9b0dcb51996021a$var$_constant = $b9b0dcb51996021a$var$_interopRequireDefault((parcelRequire("aM9TR")));

var $1S6zd = parcelRequire("1S6zd");
function $b9b0dcb51996021a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b9b0dcb51996021a$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $b9b0dcb51996021a$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $b9b0dcb51996021a$var$arcStartAngle(d) {
    return d.startAngle;
}
function $b9b0dcb51996021a$var$arcEndAngle(d) {
    return d.endAngle;
}
function $b9b0dcb51996021a$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $b9b0dcb51996021a$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $1S6zd.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $b9b0dcb51996021a$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $1S6zd.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $1S6zd.sqrt)((0, $1S6zd.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $b9b0dcb51996021a$var$_default() {
    var innerRadius = $b9b0dcb51996021a$var$arcInnerRadius, outerRadius = $b9b0dcb51996021a$var$arcOuterRadius, cornerRadius = (0, $b9b0dcb51996021a$var$_constant.default)(0), padRadius = null, startAngle = $b9b0dcb51996021a$var$arcStartAngle, endAngle = $b9b0dcb51996021a$var$arcEndAngle, padAngle = $b9b0dcb51996021a$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $1S6zd.halfPi, a1 = endAngle.apply(this, arguments) - $1S6zd.halfPi, da = (0, $1S6zd.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $6QjrA.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $1S6zd.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $1S6zd.tau - $1S6zd.epsilon) {
            context.moveTo(r1 * (0, $1S6zd.cos)(a0), r1 * (0, $1S6zd.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $1S6zd.epsilon) {
                context.moveTo(r0 * (0, $1S6zd.cos)(a1), r0 * (0, $1S6zd.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $1S6zd.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $1S6zd.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $1S6zd.min)((0, $1S6zd.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $1S6zd.epsilon) {
                var p0 = (0, $1S6zd.asin)(rp / r0 * (0, $1S6zd.sin)(ap)), p1 = (0, $1S6zd.asin)(rp / r1 * (0, $1S6zd.sin)(ap));
                if ((da0 -= p0 * 2) > $1S6zd.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $1S6zd.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $1S6zd.cos)(a01), y01 = r1 * (0, $1S6zd.sin)(a01), x10 = r0 * (0, $1S6zd.cos)(a10), y10 = r0 * (0, $1S6zd.sin)(a10); // Apply rounded corners?
            if (rc > $1S6zd.epsilon) {
                var x11 = r1 * (0, $1S6zd.cos)(a11), y11 = r1 * (0, $1S6zd.sin)(a11), x00 = r0 * (0, $1S6zd.cos)(a00), y00 = r0 * (0, $1S6zd.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $1S6zd.pi && (oc = $b9b0dcb51996021a$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $1S6zd.sin)((0, $1S6zd.acos)((ax * bx + ay * by) / ((0, $1S6zd.sqrt)(ax * ax + ay * ay) * (0, $1S6zd.sqrt)(bx * bx + by * by))) / 2), lc = (0, $1S6zd.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $1S6zd.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $1S6zd.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $1S6zd.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $1S6zd.epsilon) {
                t0 = $b9b0dcb51996021a$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $b9b0dcb51996021a$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $1S6zd.atan2)(t0.y01, t0.x01), (0, $1S6zd.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $1S6zd.atan2)(t0.y01, t0.x01), (0, $1S6zd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $1S6zd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $1S6zd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $1S6zd.atan2)(t1.y11, t1.x11), (0, $1S6zd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $1S6zd.epsilon) || !(da0 > $1S6zd.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $1S6zd.epsilon) {
                t0 = $b9b0dcb51996021a$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $b9b0dcb51996021a$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $1S6zd.atan2)(t0.y01, t0.x01), (0, $1S6zd.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $1S6zd.atan2)(t0.y01, t0.x01), (0, $1S6zd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $1S6zd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $1S6zd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $1S6zd.atan2)(t1.y11, t1.x11), (0, $1S6zd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $1S6zd.pi / 2;
        return [
            (0, $1S6zd.cos)(a) * r,
            (0, $1S6zd.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $b9b0dcb51996021a$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $b9b0dcb51996021a$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $b9b0dcb51996021a$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $b9b0dcb51996021a$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $b9b0dcb51996021a$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $b9b0dcb51996021a$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $b9b0dcb51996021a$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("6QjrA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $4fb6ae907cfb239a$var$_path.default;
    }
});

var $4fb6ae907cfb239a$var$_path = $4fb6ae907cfb239a$var$_interopRequireDefault((parcelRequire("e1HNW")));
function $4fb6ae907cfb239a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("e1HNW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a36323596d263ac1$var$pi = Math.PI, $a36323596d263ac1$var$tau = 2 * $a36323596d263ac1$var$pi, $a36323596d263ac1$var$epsilon = 1e-6, $a36323596d263ac1$var$tauEpsilon = $a36323596d263ac1$var$tau - $a36323596d263ac1$var$epsilon;
function $a36323596d263ac1$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $a36323596d263ac1$var$path() {
    return new $a36323596d263ac1$var$Path();
}
$a36323596d263ac1$var$Path.prototype = $a36323596d263ac1$var$path.prototype = {
    constructor: $a36323596d263ac1$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $a36323596d263ac1$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $a36323596d263ac1$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($a36323596d263ac1$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $a36323596d263ac1$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $a36323596d263ac1$var$epsilon || Math.abs(this._y1 - y0) > $a36323596d263ac1$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $a36323596d263ac1$var$tau + $a36323596d263ac1$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $a36323596d263ac1$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $a36323596d263ac1$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $a36323596d263ac1$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $a36323596d263ac1$var$_default = $a36323596d263ac1$var$path;
module.exports.default = $a36323596d263ac1$var$_default;

});


parcelRegister("aM9TR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d8610fe384ea67d$var$_default;
function $7d8610fe384ea67d$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("1S6zd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $15cfedac1cca86d9$var$acos;
module.exports.asin = $15cfedac1cca86d9$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $15cfedac1cca86d9$var$abs = Math.abs;
module.exports.abs = $15cfedac1cca86d9$var$abs;
const $15cfedac1cca86d9$var$atan2 = Math.atan2;
module.exports.atan2 = $15cfedac1cca86d9$var$atan2;
const $15cfedac1cca86d9$var$cos = Math.cos;
module.exports.cos = $15cfedac1cca86d9$var$cos;
const $15cfedac1cca86d9$var$max = Math.max;
module.exports.max = $15cfedac1cca86d9$var$max;
const $15cfedac1cca86d9$var$min = Math.min;
module.exports.min = $15cfedac1cca86d9$var$min;
const $15cfedac1cca86d9$var$sin = Math.sin;
module.exports.sin = $15cfedac1cca86d9$var$sin;
const $15cfedac1cca86d9$var$sqrt = Math.sqrt;
module.exports.sqrt = $15cfedac1cca86d9$var$sqrt;
const $15cfedac1cca86d9$var$epsilon = 1e-12;
module.exports.epsilon = $15cfedac1cca86d9$var$epsilon;
const $15cfedac1cca86d9$var$pi = Math.PI;
module.exports.pi = $15cfedac1cca86d9$var$pi;
const $15cfedac1cca86d9$var$halfPi = $15cfedac1cca86d9$var$pi / 2;
module.exports.halfPi = $15cfedac1cca86d9$var$halfPi;
const $15cfedac1cca86d9$var$tau = 2 * $15cfedac1cca86d9$var$pi;
module.exports.tau = $15cfedac1cca86d9$var$tau;
function $15cfedac1cca86d9$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $15cfedac1cca86d9$var$pi : Math.acos(x);
}
function $15cfedac1cca86d9$var$asin(x) {
    return x >= 1 ? $15cfedac1cca86d9$var$halfPi : x <= -1 ? -$15cfedac1cca86d9$var$halfPi : Math.asin(x);
}

});


parcelRegister("jNuNu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e69a7ba120a45389$var$_default;

var $6QjrA = parcelRequire("6QjrA");

var $e69a7ba120a45389$var$_array = $e69a7ba120a45389$var$_interopRequireDefault((parcelRequire("ih0Eq")));

var $e69a7ba120a45389$var$_constant = $e69a7ba120a45389$var$_interopRequireDefault((parcelRequire("aM9TR")));

var $e69a7ba120a45389$var$_linear = $e69a7ba120a45389$var$_interopRequireDefault((parcelRequire("8QEPZ")));

var $e69a7ba120a45389$var$_line = $e69a7ba120a45389$var$_interopRequireDefault((parcelRequire("eFopW")));

var $ayP8a = parcelRequire("ayP8a");
function $e69a7ba120a45389$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e69a7ba120a45389$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $e69a7ba120a45389$var$_constant.default)(true), context = null, curve = $e69a7ba120a45389$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $ayP8a.x : (0, $e69a7ba120a45389$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $e69a7ba120a45389$var$_constant.default)(0) : (0, $e69a7ba120a45389$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $ayP8a.y : (0, $e69a7ba120a45389$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $e69a7ba120a45389$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $6QjrA.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $e69a7ba120a45389$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e69a7ba120a45389$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e69a7ba120a45389$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e69a7ba120a45389$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e69a7ba120a45389$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e69a7ba120a45389$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e69a7ba120a45389$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $e69a7ba120a45389$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("ih0Eq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4da51d08f848657$var$_default;
module.exports.slice = void 0;
var $d4da51d08f848657$var$slice = Array.prototype.slice;
module.exports.slice = $d4da51d08f848657$var$slice;
function $d4da51d08f848657$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("8QEPZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6712db8ac7003473$var$_default;
function $6712db8ac7003473$var$Linear(context) {
    this._context = context;
}
$6712db8ac7003473$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $6712db8ac7003473$var$_default(context) {
    return new $6712db8ac7003473$var$Linear(context);
}

});

parcelRegister("eFopW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aad7d5d5d4472217$var$_default;

var $6QjrA = parcelRequire("6QjrA");

var $aad7d5d5d4472217$var$_array = $aad7d5d5d4472217$var$_interopRequireDefault((parcelRequire("ih0Eq")));

var $aad7d5d5d4472217$var$_constant = $aad7d5d5d4472217$var$_interopRequireDefault((parcelRequire("aM9TR")));

var $aad7d5d5d4472217$var$_linear = $aad7d5d5d4472217$var$_interopRequireDefault((parcelRequire("8QEPZ")));

var $ayP8a = parcelRequire("ayP8a");
function $aad7d5d5d4472217$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aad7d5d5d4472217$var$_default(x, y) {
    var defined = (0, $aad7d5d5d4472217$var$_constant.default)(true), context = null, curve = $aad7d5d5d4472217$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $ayP8a.x : (0, $aad7d5d5d4472217$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $ayP8a.y : (0, $aad7d5d5d4472217$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $aad7d5d5d4472217$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $6QjrA.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $aad7d5d5d4472217$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $aad7d5d5d4472217$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $aad7d5d5d4472217$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("ayP8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $7b04bdd796452f04$var$x;
module.exports.y = $7b04bdd796452f04$var$y;
function $7b04bdd796452f04$var$x(p) {
    return p[0];
}
function $7b04bdd796452f04$var$y(p) {
    return p[1];
}

});



parcelRegister("ccRkK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e2ff9f8f31aed3c$var$_default;

var $8e2ff9f8f31aed3c$var$_array = $8e2ff9f8f31aed3c$var$_interopRequireDefault((parcelRequire("ih0Eq")));

var $8e2ff9f8f31aed3c$var$_constant = $8e2ff9f8f31aed3c$var$_interopRequireDefault((parcelRequire("aM9TR")));

var $8e2ff9f8f31aed3c$var$_descending = $8e2ff9f8f31aed3c$var$_interopRequireDefault((parcelRequire("k13lt")));

var $8e2ff9f8f31aed3c$var$_identity = $8e2ff9f8f31aed3c$var$_interopRequireDefault((parcelRequire("lq1MC")));

var $1S6zd = parcelRequire("1S6zd");
function $8e2ff9f8f31aed3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8e2ff9f8f31aed3c$var$_default() {
    var value = $8e2ff9f8f31aed3c$var$_identity.default, sortValues = $8e2ff9f8f31aed3c$var$_descending.default, sort = null, startAngle = (0, $8e2ff9f8f31aed3c$var$_constant.default)(0), endAngle = (0, $8e2ff9f8f31aed3c$var$_constant.default)($1S6zd.tau), padAngle = (0, $8e2ff9f8f31aed3c$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $8e2ff9f8f31aed3c$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($1S6zd.tau, Math.max(-$1S6zd.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $8e2ff9f8f31aed3c$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $8e2ff9f8f31aed3c$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $8e2ff9f8f31aed3c$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $8e2ff9f8f31aed3c$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("k13lt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9267ef8fc53eea3$var$_default;
function $e9267ef8fc53eea3$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("lq1MC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f97d68c73da2d45f$var$_default;
function $f97d68c73da2d45f$var$_default(d) {
    return d;
}

});


parcelRegister("exLuC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a968fcd6e1742299$var$_default;

var $a968fcd6e1742299$var$_radial = $a968fcd6e1742299$var$_interopRequireWildcard((parcelRequire("aYObI")));

var $a968fcd6e1742299$var$_area = $a968fcd6e1742299$var$_interopRequireDefault((parcelRequire("jNuNu")));

var $axDWQ = parcelRequire("axDWQ");
function $a968fcd6e1742299$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a968fcd6e1742299$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a968fcd6e1742299$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a968fcd6e1742299$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a968fcd6e1742299$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a968fcd6e1742299$var$_default() {
    var a = (0, $a968fcd6e1742299$var$_area.default)().curve($a968fcd6e1742299$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $axDWQ.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $axDWQ.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $axDWQ.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $axDWQ.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $a968fcd6e1742299$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("aYObI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $7fe670454546f9f1$var$curveRadial;

var $7fe670454546f9f1$var$_linear = $7fe670454546f9f1$var$_interopRequireDefault((parcelRequire("8QEPZ")));
function $7fe670454546f9f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7fe670454546f9f1$var$curveRadialLinear = $7fe670454546f9f1$var$curveRadial($7fe670454546f9f1$var$_linear.default);
module.exports.curveRadialLinear = $7fe670454546f9f1$var$curveRadialLinear;
function $7fe670454546f9f1$var$Radial(curve) {
    this._curve = curve;
}
$7fe670454546f9f1$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $7fe670454546f9f1$var$curveRadial(curve) {
    function radial(context) {
        return new $7fe670454546f9f1$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("axDWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7acbf94984ebebae$var$_default;
module.exports.lineRadial = $7acbf94984ebebae$var$lineRadial;

var $7acbf94984ebebae$var$_radial = $7acbf94984ebebae$var$_interopRequireWildcard((parcelRequire("aYObI")));

var $7acbf94984ebebae$var$_line = $7acbf94984ebebae$var$_interopRequireDefault((parcelRequire("eFopW")));
function $7acbf94984ebebae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7acbf94984ebebae$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7acbf94984ebebae$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7acbf94984ebebae$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7acbf94984ebebae$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7acbf94984ebebae$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $7acbf94984ebebae$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $7acbf94984ebebae$var$_default() {
    return $7acbf94984ebebae$var$lineRadial((0, $7acbf94984ebebae$var$_line.default)().curve($7acbf94984ebebae$var$_radial.curveRadialLinear));
}

});


parcelRegister("bDhxk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8780f0a19c0f7de1$var$_default;
function $8780f0a19c0f7de1$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("9Koi4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $718b407df7202c2a$var$link;
module.exports.linkHorizontal = $718b407df7202c2a$var$linkHorizontal;
module.exports.linkRadial = $718b407df7202c2a$var$linkRadial;
module.exports.linkVertical = $718b407df7202c2a$var$linkVertical;

var $6QjrA = parcelRequire("6QjrA");

var $ih0Eq = parcelRequire("ih0Eq");

var $718b407df7202c2a$var$_constant = $718b407df7202c2a$var$_interopRequireDefault((parcelRequire("aM9TR")));

var $6zSoD = parcelRequire("6zSoD");

var $ayP8a = parcelRequire("ayP8a");
function $718b407df7202c2a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $718b407df7202c2a$var$linkSource(d) {
    return d.source;
}
function $718b407df7202c2a$var$linkTarget(d) {
    return d.target;
}
function $718b407df7202c2a$var$link(curve) {
    let source = $718b407df7202c2a$var$linkSource;
    let target = $718b407df7202c2a$var$linkTarget;
    let x = $ayP8a.x;
    let y = $ayP8a.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $ih0Eq.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $6QjrA.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $718b407df7202c2a$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $718b407df7202c2a$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $718b407df7202c2a$var$linkHorizontal() {
    return $718b407df7202c2a$var$link($6zSoD.bumpX);
}
function $718b407df7202c2a$var$linkVertical() {
    return $718b407df7202c2a$var$link($6zSoD.bumpY);
}
function $718b407df7202c2a$var$linkRadial() {
    const l = $718b407df7202c2a$var$link($6zSoD.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("6zSoD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $013c63f3474d9d8e$var$bumpRadial;
module.exports.bumpX = $013c63f3474d9d8e$var$bumpX;
module.exports.bumpY = $013c63f3474d9d8e$var$bumpY;

var $013c63f3474d9d8e$var$_pointRadial = $013c63f3474d9d8e$var$_interopRequireDefault((parcelRequire("bDhxk")));
function $013c63f3474d9d8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $013c63f3474d9d8e$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $013c63f3474d9d8e$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $013c63f3474d9d8e$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $013c63f3474d9d8e$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $013c63f3474d9d8e$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $013c63f3474d9d8e$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $013c63f3474d9d8e$var$bumpX(context) {
    return new $013c63f3474d9d8e$var$Bump(context, true);
}
function $013c63f3474d9d8e$var$bumpY(context) {
    return new $013c63f3474d9d8e$var$Bump(context, false);
}
function $013c63f3474d9d8e$var$bumpRadial(context) {
    return new $013c63f3474d9d8e$var$BumpRadial(context);
}

});


parcelRegister("hAOMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cced30c167806fe8$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $6QjrA = parcelRequire("6QjrA");

var $cced30c167806fe8$var$_constant = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("aM9TR")));

var $cced30c167806fe8$var$_asterisk = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("cgmji")));

var $cced30c167806fe8$var$_circle = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("eKInh")));

var $cced30c167806fe8$var$_cross = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("dKf35")));

var $cced30c167806fe8$var$_diamond = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("j3Sri")));

var $cced30c167806fe8$var$_diamond2 = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("b2KEh")));

var $cced30c167806fe8$var$_plus = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("54lE4")));

var $cced30c167806fe8$var$_square = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("atbx8")));

var $cced30c167806fe8$var$_square2 = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("h6W3p")));

var $cced30c167806fe8$var$_star = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("90SWr")));

var $cced30c167806fe8$var$_triangle = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("iz8wS")));

var $cced30c167806fe8$var$_triangle2 = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("3iSnr")));

var $cced30c167806fe8$var$_wye = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("gO1S5")));

var $cced30c167806fe8$var$_x = $cced30c167806fe8$var$_interopRequireDefault((parcelRequire("ZkaZG")));
function $cced30c167806fe8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $cced30c167806fe8$var$symbolsFill = [
    $cced30c167806fe8$var$_circle.default,
    $cced30c167806fe8$var$_cross.default,
    $cced30c167806fe8$var$_diamond.default,
    $cced30c167806fe8$var$_square.default,
    $cced30c167806fe8$var$_star.default,
    $cced30c167806fe8$var$_triangle.default,
    $cced30c167806fe8$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $cced30c167806fe8$var$symbolsFill;
const $cced30c167806fe8$var$symbolsStroke = [
    $cced30c167806fe8$var$_circle.default,
    $cced30c167806fe8$var$_plus.default,
    $cced30c167806fe8$var$_x.default,
    $cced30c167806fe8$var$_triangle2.default,
    $cced30c167806fe8$var$_asterisk.default,
    $cced30c167806fe8$var$_square2.default,
    $cced30c167806fe8$var$_diamond2.default
];
module.exports.symbolsStroke = $cced30c167806fe8$var$symbolsStroke;
function $cced30c167806fe8$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $cced30c167806fe8$var$_constant.default)(type || $cced30c167806fe8$var$_circle.default);
    size = typeof size === "function" ? size : (0, $cced30c167806fe8$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $6QjrA.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $cced30c167806fe8$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $cced30c167806fe8$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("cgmji", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
const $8ed84906b118f28b$var$sqrt3 = (0, $1S6zd.sqrt)(3);
var $8ed84906b118f28b$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size + (0, $1S6zd.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $8ed84906b118f28b$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $8ed84906b118f28b$var$_default;

});

parcelRegister("eKInh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
var $abd7c86c74c45c37$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size / $1S6zd.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $1S6zd.tau);
    }
};
module.exports.default = $abd7c86c74c45c37$var$_default;

});

parcelRegister("dKf35", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
var $a01b3e96d68ce81b$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $a01b3e96d68ce81b$var$_default;

});

parcelRegister("j3Sri", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
const $de08869d16f0bc2e$var$tan30 = (0, $1S6zd.sqrt)(1 / 3);
const $de08869d16f0bc2e$var$tan30_2 = $de08869d16f0bc2e$var$tan30 * 2;
var $de08869d16f0bc2e$var$_default = {
    draw (context, size) {
        const y = (0, $1S6zd.sqrt)(size / $de08869d16f0bc2e$var$tan30_2);
        const x = y * $de08869d16f0bc2e$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $de08869d16f0bc2e$var$_default;

});

parcelRegister("b2KEh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
var $80a4111626b56065$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $80a4111626b56065$var$_default;

});

parcelRegister("54lE4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
var $3b0e1dc9d3ba80a5$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size - (0, $1S6zd.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $3b0e1dc9d3ba80a5$var$_default;

});

parcelRegister("atbx8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
var $79f58f1b0a20cf13$var$_default = {
    draw (context, size) {
        const w = (0, $1S6zd.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $79f58f1b0a20cf13$var$_default;

});

parcelRegister("h6W3p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
var $c750078728cf14e8$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $c750078728cf14e8$var$_default;

});

parcelRegister("90SWr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
const $68febb63b7baa3aa$var$ka = 0.89081309152928522810;
const $68febb63b7baa3aa$var$kr = (0, $1S6zd.sin)($1S6zd.pi / 10) / (0, $1S6zd.sin)(7 * $1S6zd.pi / 10);
const $68febb63b7baa3aa$var$kx = (0, $1S6zd.sin)($1S6zd.tau / 10) * $68febb63b7baa3aa$var$kr;
const $68febb63b7baa3aa$var$ky = -(0, $1S6zd.cos)($1S6zd.tau / 10) * $68febb63b7baa3aa$var$kr;
var $68febb63b7baa3aa$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size * $68febb63b7baa3aa$var$ka);
        const x = $68febb63b7baa3aa$var$kx * r;
        const y = $68febb63b7baa3aa$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $1S6zd.tau * i / 5;
            const c = (0, $1S6zd.cos)(a);
            const s = (0, $1S6zd.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $68febb63b7baa3aa$var$_default;

});

parcelRegister("iz8wS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
const $d8421ca2a015d52a$var$sqrt3 = (0, $1S6zd.sqrt)(3);
var $d8421ca2a015d52a$var$_default = {
    draw (context, size) {
        const y = -(0, $1S6zd.sqrt)(size / ($d8421ca2a015d52a$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$d8421ca2a015d52a$var$sqrt3 * y, -y);
        context.lineTo($d8421ca2a015d52a$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $d8421ca2a015d52a$var$_default;

});

parcelRegister("3iSnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
const $267d3bb4e68214ef$var$sqrt3 = (0, $1S6zd.sqrt)(3);
var $267d3bb4e68214ef$var$_default = {
    draw (context, size) {
        const s = (0, $1S6zd.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $267d3bb4e68214ef$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $267d3bb4e68214ef$var$_default;

});

parcelRegister("gO1S5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
const $c3c2c476cc3910dc$var$c = -0.5;
const $c3c2c476cc3910dc$var$s = (0, $1S6zd.sqrt)(3) / 2;
const $c3c2c476cc3910dc$var$k = 1 / (0, $1S6zd.sqrt)(12);
const $c3c2c476cc3910dc$var$a = ($c3c2c476cc3910dc$var$k / 2 + 1) * 3;
var $c3c2c476cc3910dc$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size / $c3c2c476cc3910dc$var$a);
        const x0 = r / 2, y0 = r * $c3c2c476cc3910dc$var$k;
        const x1 = x0, y1 = r * $c3c2c476cc3910dc$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($c3c2c476cc3910dc$var$c * x0 - $c3c2c476cc3910dc$var$s * y0, $c3c2c476cc3910dc$var$s * x0 + $c3c2c476cc3910dc$var$c * y0);
        context.lineTo($c3c2c476cc3910dc$var$c * x1 - $c3c2c476cc3910dc$var$s * y1, $c3c2c476cc3910dc$var$s * x1 + $c3c2c476cc3910dc$var$c * y1);
        context.lineTo($c3c2c476cc3910dc$var$c * x2 - $c3c2c476cc3910dc$var$s * y2, $c3c2c476cc3910dc$var$s * x2 + $c3c2c476cc3910dc$var$c * y2);
        context.lineTo($c3c2c476cc3910dc$var$c * x0 + $c3c2c476cc3910dc$var$s * y0, $c3c2c476cc3910dc$var$c * y0 - $c3c2c476cc3910dc$var$s * x0);
        context.lineTo($c3c2c476cc3910dc$var$c * x1 + $c3c2c476cc3910dc$var$s * y1, $c3c2c476cc3910dc$var$c * y1 - $c3c2c476cc3910dc$var$s * x1);
        context.lineTo($c3c2c476cc3910dc$var$c * x2 + $c3c2c476cc3910dc$var$s * y2, $c3c2c476cc3910dc$var$c * y2 - $c3c2c476cc3910dc$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $c3c2c476cc3910dc$var$_default;

});

parcelRegister("ZkaZG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1S6zd = parcelRequire("1S6zd");
var $0b85593799378893$var$_default = {
    draw (context, size) {
        const r = (0, $1S6zd.sqrt)(size - (0, $1S6zd.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $0b85593799378893$var$_default;

});


parcelRegister("fbx4U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b0e18aba634faf69$var$_default;

var $b0e18aba634faf69$var$_noop = $b0e18aba634faf69$var$_interopRequireDefault((parcelRequire("lOJUf")));

var $bhqrp = parcelRequire("bhqrp");
function $b0e18aba634faf69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b0e18aba634faf69$var$BasisClosed(context) {
    this._context = context;
}
$b0e18aba634faf69$var$BasisClosed.prototype = {
    areaStart: $b0e18aba634faf69$var$_noop.default,
    areaEnd: $b0e18aba634faf69$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $bhqrp.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $b0e18aba634faf69$var$_default(context) {
    return new $b0e18aba634faf69$var$BasisClosed(context);
}

});
parcelRegister("lOJUf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe21e07f0e13d647$var$_default;
function $fe21e07f0e13d647$var$_default() {}

});

parcelRegister("bhqrp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $8365caea01315b87$var$Basis;
module.exports.default = $8365caea01315b87$var$_default;
module.exports.point = $8365caea01315b87$var$point;
function $8365caea01315b87$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $8365caea01315b87$var$Basis(context) {
    this._context = context;
}
$8365caea01315b87$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $8365caea01315b87$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $8365caea01315b87$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $8365caea01315b87$var$_default(context) {
    return new $8365caea01315b87$var$Basis(context);
}

});


parcelRegister("bzHwV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86d4babc6ae71093$var$_default;

var $bhqrp = parcelRequire("bhqrp");
function $86d4babc6ae71093$var$BasisOpen(context) {
    this._context = context;
}
$86d4babc6ae71093$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $bhqrp.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $86d4babc6ae71093$var$_default(context) {
    return new $86d4babc6ae71093$var$BasisOpen(context);
}

});

parcelRegister("9Rt57", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bhqrp = parcelRequire("bhqrp");
function $72df9f4cd0893f63$var$Bundle(context, beta) {
    this._basis = new $bhqrp.Basis(context);
    this._beta = beta;
}
$72df9f4cd0893f63$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $72df9f4cd0893f63$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $bhqrp.Basis(context) : new $72df9f4cd0893f63$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $72df9f4cd0893f63$var$_default;

});

parcelRegister("FguEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $07c09fb5b5d0e50d$var$CardinalClosed;
module.exports.default = void 0;

var $07c09fb5b5d0e50d$var$_noop = $07c09fb5b5d0e50d$var$_interopRequireDefault((parcelRequire("lOJUf")));

var $59JRC = parcelRequire("59JRC");
function $07c09fb5b5d0e50d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $07c09fb5b5d0e50d$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$07c09fb5b5d0e50d$var$CardinalClosed.prototype = {
    areaStart: $07c09fb5b5d0e50d$var$_noop.default,
    areaEnd: $07c09fb5b5d0e50d$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $59JRC.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $07c09fb5b5d0e50d$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $07c09fb5b5d0e50d$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $07c09fb5b5d0e50d$var$_default;

});
parcelRegister("59JRC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $3c115e9b1bb6b382$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $3c115e9b1bb6b382$var$point;
function $3c115e9b1bb6b382$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $3c115e9b1bb6b382$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$3c115e9b1bb6b382$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $3c115e9b1bb6b382$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $3c115e9b1bb6b382$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $3c115e9b1bb6b382$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $3c115e9b1bb6b382$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $3c115e9b1bb6b382$var$_default;

});


parcelRegister("jK3C1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $e5f51d8442dce275$var$CardinalOpen;
module.exports.default = void 0;

var $59JRC = parcelRequire("59JRC");
function $e5f51d8442dce275$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e5f51d8442dce275$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $59JRC.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e5f51d8442dce275$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e5f51d8442dce275$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e5f51d8442dce275$var$_default;

});

parcelRegister("4JZTt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $FguEO = parcelRequire("FguEO");

var $373b60359b649e24$var$_noop = $373b60359b649e24$var$_interopRequireDefault((parcelRequire("lOJUf")));

var $dHOVI = parcelRequire("dHOVI");
function $373b60359b649e24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $373b60359b649e24$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$373b60359b649e24$var$CatmullRomClosed.prototype = {
    areaStart: $373b60359b649e24$var$_noop.default,
    areaEnd: $373b60359b649e24$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $dHOVI.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $373b60359b649e24$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $373b60359b649e24$var$CatmullRomClosed(context, alpha) : new $FguEO.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $373b60359b649e24$var$_default;

});
parcelRegister("dHOVI", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $1S6zd = parcelRequire("1S6zd");

var $59JRC = parcelRequire("59JRC");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $1S6zd.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $1S6zd.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $59JRC.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("1R87b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jK3C1 = parcelRequire("jK3C1");

var $dHOVI = parcelRequire("dHOVI");
function $15a10924ac408608$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$15a10924ac408608$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $dHOVI.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $15a10924ac408608$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $15a10924ac408608$var$CatmullRomOpen(context, alpha) : new $jK3C1.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $15a10924ac408608$var$_default;

});

parcelRegister("kx6bW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef2bb1396c21afe7$var$_default;

var $ef2bb1396c21afe7$var$_noop = $ef2bb1396c21afe7$var$_interopRequireDefault((parcelRequire("lOJUf")));
function $ef2bb1396c21afe7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef2bb1396c21afe7$var$LinearClosed(context) {
    this._context = context;
}
$ef2bb1396c21afe7$var$LinearClosed.prototype = {
    areaStart: $ef2bb1396c21afe7$var$_noop.default,
    areaEnd: $ef2bb1396c21afe7$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $ef2bb1396c21afe7$var$_default(context) {
    return new $ef2bb1396c21afe7$var$LinearClosed(context);
}

});

parcelRegister("eqDl2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $a812022e61ac9833$var$monotoneX;
module.exports.monotoneY = $a812022e61ac9833$var$monotoneY;
function $a812022e61ac9833$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a812022e61ac9833$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a812022e61ac9833$var$sign(s0) + $a812022e61ac9833$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $a812022e61ac9833$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a812022e61ac9833$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a812022e61ac9833$var$MonotoneX(context) {
    this._context = context;
}
$a812022e61ac9833$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a812022e61ac9833$var$point(this, this._t0, $a812022e61ac9833$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a812022e61ac9833$var$point(this, $a812022e61ac9833$var$slope2(this, t1 = $a812022e61ac9833$var$slope3(this, x, y)), t1);
                break;
            default:
                $a812022e61ac9833$var$point(this, this._t0, t1 = $a812022e61ac9833$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a812022e61ac9833$var$MonotoneY(context) {
    this._context = new $a812022e61ac9833$var$ReflectContext(context);
}
($a812022e61ac9833$var$MonotoneY.prototype = Object.create($a812022e61ac9833$var$MonotoneX.prototype)).point = function(x, y) {
    $a812022e61ac9833$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a812022e61ac9833$var$ReflectContext(context) {
    this._context = context;
}
$a812022e61ac9833$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a812022e61ac9833$var$monotoneX(context) {
    return new $a812022e61ac9833$var$MonotoneX(context);
}
function $a812022e61ac9833$var$monotoneY(context) {
    return new $a812022e61ac9833$var$MonotoneY(context);
}

});

parcelRegister("4mavy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32c15e27367e1f38$var$_default;
function $32c15e27367e1f38$var$Natural(context) {
    this._context = context;
}
$32c15e27367e1f38$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $32c15e27367e1f38$var$controlPoints(x), py = $32c15e27367e1f38$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $32c15e27367e1f38$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $32c15e27367e1f38$var$_default(context) {
    return new $32c15e27367e1f38$var$Natural(context);
}

});

parcelRegister("jAEei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e43095dea6b2a98c$var$_default;
module.exports.stepAfter = $e43095dea6b2a98c$var$stepAfter;
module.exports.stepBefore = $e43095dea6b2a98c$var$stepBefore;
function $e43095dea6b2a98c$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$e43095dea6b2a98c$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $e43095dea6b2a98c$var$_default(context) {
    return new $e43095dea6b2a98c$var$Step(context, 0.5);
}
function $e43095dea6b2a98c$var$stepBefore(context) {
    return new $e43095dea6b2a98c$var$Step(context, 0);
}
function $e43095dea6b2a98c$var$stepAfter(context) {
    return new $e43095dea6b2a98c$var$Step(context, 1);
}

});

parcelRegister("kuaoz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee9eac4d703b4078$var$_default;

var $ee9eac4d703b4078$var$_array = $ee9eac4d703b4078$var$_interopRequireDefault((parcelRequire("ih0Eq")));

var $ee9eac4d703b4078$var$_constant = $ee9eac4d703b4078$var$_interopRequireDefault((parcelRequire("aM9TR")));

var $ee9eac4d703b4078$var$_none = $ee9eac4d703b4078$var$_interopRequireDefault((parcelRequire("aN35u")));

var $ee9eac4d703b4078$var$_none2 = $ee9eac4d703b4078$var$_interopRequireDefault((parcelRequire("aTlDB")));
function $ee9eac4d703b4078$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee9eac4d703b4078$var$stackValue(d, key) {
    return d[key];
}
function $ee9eac4d703b4078$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $ee9eac4d703b4078$var$_default() {
    var keys = (0, $ee9eac4d703b4078$var$_constant.default)([]), order = $ee9eac4d703b4078$var$_none2.default, offset = $ee9eac4d703b4078$var$_none.default, value = $ee9eac4d703b4078$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $ee9eac4d703b4078$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $ee9eac4d703b4078$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $ee9eac4d703b4078$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ee9eac4d703b4078$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $ee9eac4d703b4078$var$_none2.default : typeof _ === "function" ? _ : (0, $ee9eac4d703b4078$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $ee9eac4d703b4078$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("aN35u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7db0e01ded73fe7d$var$_default;
function $7db0e01ded73fe7d$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("aTlDB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7edfd33adcc9b758$var$_default;
function $7edfd33adcc9b758$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("by8mw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86895b46009e6a20$var$_default;

var $86895b46009e6a20$var$_none = $86895b46009e6a20$var$_interopRequireDefault((parcelRequire("aN35u")));
function $86895b46009e6a20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86895b46009e6a20$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $86895b46009e6a20$var$_none.default)(series, order);
}

});

parcelRegister("7w0VI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $578c3e3b330acf19$var$_default;
function $578c3e3b330acf19$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("4E1sl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $361c07011ab0678b$var$_default;

var $361c07011ab0678b$var$_none = $361c07011ab0678b$var$_interopRequireDefault((parcelRequire("aN35u")));
function $361c07011ab0678b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $361c07011ab0678b$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $361c07011ab0678b$var$_none.default)(series, order);
}

});

parcelRegister("gJz45", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2ec0c7c69e471c2$var$_default;

var $c2ec0c7c69e471c2$var$_none = $c2ec0c7c69e471c2$var$_interopRequireDefault((parcelRequire("aN35u")));
function $c2ec0c7c69e471c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c2ec0c7c69e471c2$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $c2ec0c7c69e471c2$var$_none.default)(series, order);
}

});

parcelRegister("laBy0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f697a84ddb296446$var$_default;

var $f697a84ddb296446$var$_none = $f697a84ddb296446$var$_interopRequireDefault((parcelRequire("aTlDB")));
function $f697a84ddb296446$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f697a84ddb296446$var$_default(series) {
    var peaks = series.map($f697a84ddb296446$var$peak);
    return (0, $f697a84ddb296446$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $f697a84ddb296446$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("4TEbR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $390b7969d0671bf5$var$_default;
module.exports.sum = $390b7969d0671bf5$var$sum;

var $390b7969d0671bf5$var$_none = $390b7969d0671bf5$var$_interopRequireDefault((parcelRequire("aTlDB")));
function $390b7969d0671bf5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $390b7969d0671bf5$var$_default(series) {
    var sums = series.map($390b7969d0671bf5$var$sum);
    return (0, $390b7969d0671bf5$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $390b7969d0671bf5$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("689XD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $476b3779ca5ddb95$var$_default;

var $476b3779ca5ddb95$var$_ascending = $476b3779ca5ddb95$var$_interopRequireDefault((parcelRequire("4TEbR")));
function $476b3779ca5ddb95$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $476b3779ca5ddb95$var$_default(series) {
    return (0, $476b3779ca5ddb95$var$_ascending.default)(series).reverse();
}

});

parcelRegister("9QAUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72b59a9707715752$var$_default;

var $72b59a9707715752$var$_appearance = $72b59a9707715752$var$_interopRequireDefault((parcelRequire("laBy0")));

var $4TEbR = parcelRequire("4TEbR");
function $72b59a9707715752$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $72b59a9707715752$var$_default(series) {
    var n = series.length, i, j, sums = series.map($4TEbR.sum), order = (0, $72b59a9707715752$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("fr5UE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3cdf6c485121791$var$_default;

var $b3cdf6c485121791$var$_none = $b3cdf6c485121791$var$_interopRequireDefault((parcelRequire("aTlDB")));
function $b3cdf6c485121791$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3cdf6c485121791$var$_default(series) {
    return (0, $b3cdf6c485121791$var$_none.default)(series).reverse();
}

});



parcelRegister("3hNZR", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("c9f4g"));

});
parcelRegister("c9f4g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $8d82036e4d4de3bd$var$_tickFormat.default;
    }
});

var $8d82036e4d4de3bd$var$_band = $8d82036e4d4de3bd$var$_interopRequireWildcard((parcelRequire("lcdgP")));

var $8d82036e4d4de3bd$var$_identity = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("djEl0")));

var $8d82036e4d4de3bd$var$_linear = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("5bduu")));

var $8d82036e4d4de3bd$var$_log = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("75EHI")));

var $8d82036e4d4de3bd$var$_symlog = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("9Q5Vk")));

var $8d82036e4d4de3bd$var$_ordinal = $8d82036e4d4de3bd$var$_interopRequireWildcard((parcelRequire("28Bju")));

var $8d82036e4d4de3bd$var$_pow = $8d82036e4d4de3bd$var$_interopRequireWildcard((parcelRequire("kY7x4")));

var $8d82036e4d4de3bd$var$_radial = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("gDSqp")));

var $8d82036e4d4de3bd$var$_quantile = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("1TA3g")));

var $8d82036e4d4de3bd$var$_quantize = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("2nKUE")));

var $8d82036e4d4de3bd$var$_threshold = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("khxVo")));

var $8d82036e4d4de3bd$var$_time = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("hs3Zo")));

var $8d82036e4d4de3bd$var$_utcTime = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("6pUGr")));

var $8d82036e4d4de3bd$var$_sequential = $8d82036e4d4de3bd$var$_interopRequireWildcard((parcelRequire("7TO5p")));

var $8d82036e4d4de3bd$var$_sequentialQuantile = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("lnjXX")));

var $8d82036e4d4de3bd$var$_diverging = $8d82036e4d4de3bd$var$_interopRequireWildcard((parcelRequire("7ku9P")));

var $8d82036e4d4de3bd$var$_tickFormat = $8d82036e4d4de3bd$var$_interopRequireDefault((parcelRequire("bShky")));
function $8d82036e4d4de3bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8d82036e4d4de3bd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8d82036e4d4de3bd$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8d82036e4d4de3bd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8d82036e4d4de3bd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("lcdgP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6e5032b4c61ce26$var$band;
module.exports.point = $f6e5032b4c61ce26$var$point;

var $xfpL5 = parcelRequire("xfpL5");

var $bQI8z = parcelRequire("bQI8z");

var $f6e5032b4c61ce26$var$_ordinal = $f6e5032b4c61ce26$var$_interopRequireDefault((parcelRequire("28Bju")));
function $f6e5032b4c61ce26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6e5032b4c61ce26$var$band() {
    var scale = (0, $f6e5032b4c61ce26$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $xfpL5.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $f6e5032b4c61ce26$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $bQI8z.initRange.apply(rescale(), arguments);
}
function $f6e5032b4c61ce26$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $f6e5032b4c61ce26$var$pointish(copy());
    };
    return scale;
}
function $f6e5032b4c61ce26$var$point() {
    return $f6e5032b4c61ce26$var$pointish($f6e5032b4c61ce26$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("xfpL5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $QHmir.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $hhLyY.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $hhLyY.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $QHmir.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $QHmir.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $063f0a2c27971207$var$_zip.default;
    }
});

var $063f0a2c27971207$var$_bisect = $063f0a2c27971207$var$_interopRequireWildcard((parcelRequire("4lnhJ")));

var $063f0a2c27971207$var$_ascending = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $063f0a2c27971207$var$_bisector = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("7wd8W")));

var $063f0a2c27971207$var$_count = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("5mquz")));

var $063f0a2c27971207$var$_cross = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("8LWcm")));

var $063f0a2c27971207$var$_cumsum = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("4Qomh")));

var $063f0a2c27971207$var$_descending = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("ka8Rw")));

var $063f0a2c27971207$var$_deviation = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("3xDkJ")));

var $063f0a2c27971207$var$_extent = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("cw75J")));

var $QHmir = parcelRequire("QHmir");

var $063f0a2c27971207$var$_group = $063f0a2c27971207$var$_interopRequireWildcard((parcelRequire("26fad")));

var $063f0a2c27971207$var$_groupSort = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("fjUwP")));

var $063f0a2c27971207$var$_bin = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("gmiY8")));

var $063f0a2c27971207$var$_freedmanDiaconis = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("1ZaDK")));

var $063f0a2c27971207$var$_scott = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("f6HWZ")));

var $063f0a2c27971207$var$_sturges = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("b72Aj")));

var $063f0a2c27971207$var$_max = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("6OINK")));

var $063f0a2c27971207$var$_maxIndex = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("h1ZdX")));

var $063f0a2c27971207$var$_mean = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("g7R2N")));

var $063f0a2c27971207$var$_median = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("hbW8L")));

var $063f0a2c27971207$var$_merge = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("7hd24")));

var $063f0a2c27971207$var$_min = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("g4QGg")));

var $063f0a2c27971207$var$_minIndex = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("dSS8z")));

var $063f0a2c27971207$var$_mode = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("2Jkdv")));

var $063f0a2c27971207$var$_nice = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("5hlZM")));

var $063f0a2c27971207$var$_pairs = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("MVTY9")));

var $063f0a2c27971207$var$_permute = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("lwyGj")));

var $063f0a2c27971207$var$_quantile = $063f0a2c27971207$var$_interopRequireWildcard((parcelRequire("7hRz2")));

var $063f0a2c27971207$var$_quickselect = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("gt1sJ")));

var $063f0a2c27971207$var$_range = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("f8r5h")));

var $063f0a2c27971207$var$_rank = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("cDIcf")));

var $063f0a2c27971207$var$_least = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("fqE4D")));

var $063f0a2c27971207$var$_leastIndex = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("hShgB")));

var $063f0a2c27971207$var$_greatest = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("k2m84")));

var $063f0a2c27971207$var$_greatestIndex = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("jtbb0")));

var $063f0a2c27971207$var$_scan = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("2jKqk")));

var $063f0a2c27971207$var$_shuffle = $063f0a2c27971207$var$_interopRequireWildcard((parcelRequire("24eBm")));

var $063f0a2c27971207$var$_sum = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("gDgA6")));

var $063f0a2c27971207$var$_ticks = $063f0a2c27971207$var$_interopRequireWildcard((parcelRequire("7mQKL")));

var $063f0a2c27971207$var$_transpose = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("gVomG")));

var $063f0a2c27971207$var$_variance = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("77Zi3")));

var $063f0a2c27971207$var$_zip = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("l3WNz")));

var $063f0a2c27971207$var$_every = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("gyKIr")));

var $063f0a2c27971207$var$_some = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("4osSC")));

var $063f0a2c27971207$var$_filter = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("l4Yz3")));

var $063f0a2c27971207$var$_map = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("kBgUG")));

var $063f0a2c27971207$var$_reduce = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("4S4l9")));

var $063f0a2c27971207$var$_reverse = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("atf0d")));

var $063f0a2c27971207$var$_sort = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("QuUhK")));

var $063f0a2c27971207$var$_difference = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("6eVXW")));

var $063f0a2c27971207$var$_disjoint = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("gPeds")));

var $063f0a2c27971207$var$_intersection = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("h856s")));

var $063f0a2c27971207$var$_subset = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("atlNT")));

var $063f0a2c27971207$var$_superset = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("btwMV")));

var $063f0a2c27971207$var$_union = $063f0a2c27971207$var$_interopRequireDefault((parcelRequire("50pFt")));

var $hhLyY = parcelRequire("hhLyY");
function $063f0a2c27971207$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $063f0a2c27971207$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($063f0a2c27971207$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $063f0a2c27971207$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $063f0a2c27971207$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("4lnhJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $329b2f87c91e86d3$var$_ascending = $329b2f87c91e86d3$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $329b2f87c91e86d3$var$_bisector = $329b2f87c91e86d3$var$_interopRequireDefault((parcelRequire("7wd8W")));

var $329b2f87c91e86d3$var$_number = $329b2f87c91e86d3$var$_interopRequireDefault((parcelRequire("kFWGP")));
function $329b2f87c91e86d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $329b2f87c91e86d3$var$ascendingBisect = (0, $329b2f87c91e86d3$var$_bisector.default)($329b2f87c91e86d3$var$_ascending.default);
const $329b2f87c91e86d3$var$bisectRight = $329b2f87c91e86d3$var$ascendingBisect.right;
module.exports.bisectRight = $329b2f87c91e86d3$var$bisectRight;
const $329b2f87c91e86d3$var$bisectLeft = $329b2f87c91e86d3$var$ascendingBisect.left;
module.exports.bisectLeft = $329b2f87c91e86d3$var$bisectLeft;
const $329b2f87c91e86d3$var$bisectCenter = (0, $329b2f87c91e86d3$var$_bisector.default)($329b2f87c91e86d3$var$_number.default).center;
module.exports.bisectCenter = $329b2f87c91e86d3$var$bisectCenter;
var $329b2f87c91e86d3$var$_default = $329b2f87c91e86d3$var$bisectRight;
module.exports.default = $329b2f87c91e86d3$var$_default;

});
parcelRegister("5gKrb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d6277e30430d0fb$var$ascending;
function $3d6277e30430d0fb$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("7wd8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5795b785881b7679$var$bisector;

var $5795b785881b7679$var$_ascending = $5795b785881b7679$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $5795b785881b7679$var$_descending = $5795b785881b7679$var$_interopRequireDefault((parcelRequire("ka8Rw")));
function $5795b785881b7679$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5795b785881b7679$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $5795b785881b7679$var$_ascending.default;
        compare2 = (d, x)=>(0, $5795b785881b7679$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $5795b785881b7679$var$_ascending.default || f === $5795b785881b7679$var$_descending.default ? f : $5795b785881b7679$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $5795b785881b7679$var$zero() {
    return 0;
}

});
parcelRegister("ka8Rw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eadb9dae57927ba5$var$descending;
function $eadb9dae57927ba5$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("kFWGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0d52990b7fe1f3c$var$number;
module.exports.numbers = $f0d52990b7fe1f3c$var$numbers;
function $f0d52990b7fe1f3c$var$number(x) {
    return x === null ? NaN : +x;
}
function* $f0d52990b7fe1f3c$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("5mquz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e738e9654cd8865$var$count;
function $3e738e9654cd8865$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("8LWcm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $662fdb7f8b13fe9e$var$cross;
function $662fdb7f8b13fe9e$var$length(array) {
    return array.length | 0;
}
function $662fdb7f8b13fe9e$var$empty(length) {
    return !(length > 0);
}
function $662fdb7f8b13fe9e$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $662fdb7f8b13fe9e$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $662fdb7f8b13fe9e$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $662fdb7f8b13fe9e$var$reducer(values.pop());
    values = values.map($662fdb7f8b13fe9e$var$arrayify);
    const lengths = values.map($662fdb7f8b13fe9e$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($662fdb7f8b13fe9e$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("4Qomh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $386ee9d1ad7bbec2$var$cumsum;
function $386ee9d1ad7bbec2$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("3xDkJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2942f6f125c182d5$var$deviation;

var $2942f6f125c182d5$var$_variance = $2942f6f125c182d5$var$_interopRequireDefault((parcelRequire("77Zi3")));
function $2942f6f125c182d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2942f6f125c182d5$var$deviation(values, valueof) {
    const v = (0, $2942f6f125c182d5$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("77Zi3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0156d9b90c421a50$var$variance;
function $0156d9b90c421a50$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("cw75J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $91cdf96342edbf20$var$extent;
function $91cdf96342edbf20$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("QHmir", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $09e67d8fd0feeb9f$var$fcumsum;
module.exports.fsum = $09e67d8fd0feeb9f$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $09e67d8fd0feeb9f$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $09e67d8fd0feeb9f$var$Adder;
function $09e67d8fd0feeb9f$var$fsum(values, valueof) {
    const adder = new $09e67d8fd0feeb9f$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $09e67d8fd0feeb9f$var$fcumsum(values, valueof) {
    const adder = new $09e67d8fd0feeb9f$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("26fad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1877e7834b5402a6$var$group;
module.exports.flatGroup = $1877e7834b5402a6$var$flatGroup;
module.exports.flatRollup = $1877e7834b5402a6$var$flatRollup;
module.exports.groups = $1877e7834b5402a6$var$groups;
module.exports.index = $1877e7834b5402a6$var$index;
module.exports.indexes = $1877e7834b5402a6$var$indexes;
module.exports.rollup = $1877e7834b5402a6$var$rollup;
module.exports.rollups = $1877e7834b5402a6$var$rollups;

var $hhLyY = parcelRequire("hhLyY");

var $1877e7834b5402a6$var$_identity = $1877e7834b5402a6$var$_interopRequireDefault((parcelRequire("hymzO")));
function $1877e7834b5402a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1877e7834b5402a6$var$group(values, ...keys) {
    return $1877e7834b5402a6$var$nest(values, $1877e7834b5402a6$var$_identity.default, $1877e7834b5402a6$var$_identity.default, keys);
}
function $1877e7834b5402a6$var$groups(values, ...keys) {
    return $1877e7834b5402a6$var$nest(values, Array.from, $1877e7834b5402a6$var$_identity.default, keys);
}
function $1877e7834b5402a6$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $1877e7834b5402a6$var$flatGroup(values, ...keys) {
    return $1877e7834b5402a6$var$flatten($1877e7834b5402a6$var$groups(values, ...keys), keys);
}
function $1877e7834b5402a6$var$flatRollup(values, reduce, ...keys) {
    return $1877e7834b5402a6$var$flatten($1877e7834b5402a6$var$rollups(values, reduce, ...keys), keys);
}
function $1877e7834b5402a6$var$rollup(values, reduce, ...keys) {
    return $1877e7834b5402a6$var$nest(values, $1877e7834b5402a6$var$_identity.default, reduce, keys);
}
function $1877e7834b5402a6$var$rollups(values, reduce, ...keys) {
    return $1877e7834b5402a6$var$nest(values, Array.from, reduce, keys);
}
function $1877e7834b5402a6$var$index(values, ...keys) {
    return $1877e7834b5402a6$var$nest(values, $1877e7834b5402a6$var$_identity.default, $1877e7834b5402a6$var$unique, keys);
}
function $1877e7834b5402a6$var$indexes(values, ...keys) {
    return $1877e7834b5402a6$var$nest(values, Array.from, $1877e7834b5402a6$var$unique, keys);
}
function $1877e7834b5402a6$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $1877e7834b5402a6$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $hhLyY.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("hhLyY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $c958eb39c0da495b$var$InternMap extends Map {
    constructor(entries, key = $c958eb39c0da495b$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($c958eb39c0da495b$var$intern_get(this, key));
    }
    has(key) {
        return super.has($c958eb39c0da495b$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($c958eb39c0da495b$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($c958eb39c0da495b$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $c958eb39c0da495b$var$InternMap;
class $c958eb39c0da495b$var$InternSet extends Set {
    constructor(values, key = $c958eb39c0da495b$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($c958eb39c0da495b$var$intern_get(this, value));
    }
    add(value) {
        return super.add($c958eb39c0da495b$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($c958eb39c0da495b$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $c958eb39c0da495b$var$InternSet;
function $c958eb39c0da495b$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $c958eb39c0da495b$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $c958eb39c0da495b$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $c958eb39c0da495b$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("hymzO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc771fe179a9ddf6$var$identity;
function $cc771fe179a9ddf6$var$identity(x) {
    return x;
}

});


parcelRegister("fjUwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2747abb19873533$var$groupSort;

var $b2747abb19873533$var$_ascending = $b2747abb19873533$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $b2747abb19873533$var$_group = $b2747abb19873533$var$_interopRequireWildcard((parcelRequire("26fad")));

var $b2747abb19873533$var$_sort = $b2747abb19873533$var$_interopRequireDefault((parcelRequire("QuUhK")));
function $b2747abb19873533$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b2747abb19873533$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b2747abb19873533$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b2747abb19873533$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b2747abb19873533$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2747abb19873533$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $b2747abb19873533$var$_sort.default)((0, $b2747abb19873533$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $b2747abb19873533$var$_ascending.default)(av, bv) || (0, $b2747abb19873533$var$_ascending.default)(ak, bk)) : (0, $b2747abb19873533$var$_sort.default)((0, $b2747abb19873533$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $b2747abb19873533$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("QuUhK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $09dcd4e55016755c$var$ascendingDefined;
module.exports.compareDefined = $09dcd4e55016755c$var$compareDefined;
module.exports.default = $09dcd4e55016755c$var$sort;

var $09dcd4e55016755c$var$_ascending = $09dcd4e55016755c$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $09dcd4e55016755c$var$_permute = $09dcd4e55016755c$var$_interopRequireDefault((parcelRequire("lwyGj")));
function $09dcd4e55016755c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $09dcd4e55016755c$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $09dcd4e55016755c$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$09dcd4e55016755c$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $09dcd4e55016755c$var$_permute.default)(values, index);
    }
    return values.sort($09dcd4e55016755c$var$compareDefined(f));
}
function $09dcd4e55016755c$var$compareDefined(compare = $09dcd4e55016755c$var$_ascending.default) {
    if (compare === $09dcd4e55016755c$var$_ascending.default) return $09dcd4e55016755c$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $09dcd4e55016755c$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("lwyGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fab77d23bcdf1540$var$permute;
function $fab77d23bcdf1540$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("gmiY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be8d6a3f80db3119$var$bin;

var $6viNg = parcelRequire("6viNg");

var $be8d6a3f80db3119$var$_bisect = $be8d6a3f80db3119$var$_interopRequireDefault((parcelRequire("4lnhJ")));

var $be8d6a3f80db3119$var$_constant = $be8d6a3f80db3119$var$_interopRequireDefault((parcelRequire("fk5cr")));

var $be8d6a3f80db3119$var$_extent = $be8d6a3f80db3119$var$_interopRequireDefault((parcelRequire("cw75J")));

var $be8d6a3f80db3119$var$_identity = $be8d6a3f80db3119$var$_interopRequireDefault((parcelRequire("hymzO")));

var $be8d6a3f80db3119$var$_nice = $be8d6a3f80db3119$var$_interopRequireDefault((parcelRequire("5hlZM")));

var $be8d6a3f80db3119$var$_ticks = $be8d6a3f80db3119$var$_interopRequireWildcard((parcelRequire("7mQKL")));

var $be8d6a3f80db3119$var$_sturges = $be8d6a3f80db3119$var$_interopRequireDefault((parcelRequire("b72Aj")));
function $be8d6a3f80db3119$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($be8d6a3f80db3119$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $be8d6a3f80db3119$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $be8d6a3f80db3119$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $be8d6a3f80db3119$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $be8d6a3f80db3119$var$bin() {
    var value = $be8d6a3f80db3119$var$_identity.default, domain = $be8d6a3f80db3119$var$_extent.default, threshold = $be8d6a3f80db3119$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $be8d6a3f80db3119$var$_extent.default) [x0, x1] = (0, $be8d6a3f80db3119$var$_nice.default)(x0, x1, tn);
            tz = (0, $be8d6a3f80db3119$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $be8d6a3f80db3119$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $be8d6a3f80db3119$var$_extent.default) {
                    const step = (0, $be8d6a3f80db3119$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $be8d6a3f80db3119$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $be8d6a3f80db3119$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $be8d6a3f80db3119$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $be8d6a3f80db3119$var$_constant.default)($6viNg.slice.call(_)) : (0, $be8d6a3f80db3119$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("6viNg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $4bc4375879de8caf$var$array = Array.prototype;
var $4bc4375879de8caf$var$slice = $4bc4375879de8caf$var$array.slice;
module.exports.slice = $4bc4375879de8caf$var$slice;
var $4bc4375879de8caf$var$map = $4bc4375879de8caf$var$array.map;
module.exports.map = $4bc4375879de8caf$var$map;

});

parcelRegister("fk5cr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b27cc1d147acacd1$var$constant;
function $b27cc1d147acacd1$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("5hlZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d7f9a239ff04342$var$nice;

var $7mQKL = parcelRequire("7mQKL");
function $3d7f9a239ff04342$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $7mQKL.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("7mQKL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55d3822c6371f453$var$ticks;
module.exports.tickIncrement = $55d3822c6371f453$var$tickIncrement;
module.exports.tickStep = $55d3822c6371f453$var$tickStep;
var $55d3822c6371f453$var$e10 = Math.sqrt(50), $55d3822c6371f453$var$e5 = Math.sqrt(10), $55d3822c6371f453$var$e2 = Math.sqrt(2);
function $55d3822c6371f453$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $55d3822c6371f453$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $55d3822c6371f453$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $55d3822c6371f453$var$e10 ? 10 : error >= $55d3822c6371f453$var$e5 ? 5 : error >= $55d3822c6371f453$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $55d3822c6371f453$var$e10 ? 10 : error >= $55d3822c6371f453$var$e5 ? 5 : error >= $55d3822c6371f453$var$e2 ? 2 : 1);
}
function $55d3822c6371f453$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $55d3822c6371f453$var$e10) step1 *= 10;
    else if (error >= $55d3822c6371f453$var$e5) step1 *= 5;
    else if (error >= $55d3822c6371f453$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("b72Aj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81725a6f9cdb6f58$var$thresholdSturges;

var $81725a6f9cdb6f58$var$_count = $81725a6f9cdb6f58$var$_interopRequireDefault((parcelRequire("5mquz")));
function $81725a6f9cdb6f58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $81725a6f9cdb6f58$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $81725a6f9cdb6f58$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("1ZaDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1723bdd6cc790493$var$thresholdFreedmanDiaconis;

var $1723bdd6cc790493$var$_count = $1723bdd6cc790493$var$_interopRequireDefault((parcelRequire("5mquz")));

var $1723bdd6cc790493$var$_quantile = $1723bdd6cc790493$var$_interopRequireDefault((parcelRequire("7hRz2")));
function $1723bdd6cc790493$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1723bdd6cc790493$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $1723bdd6cc790493$var$_quantile.default)(values, 0.75) - (0, $1723bdd6cc790493$var$_quantile.default)(values, 0.25)) * Math.pow((0, $1723bdd6cc790493$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("7hRz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54e3aba6a17afac8$var$quantile;
module.exports.quantileSorted = $54e3aba6a17afac8$var$quantileSorted;

var $54e3aba6a17afac8$var$_max = $54e3aba6a17afac8$var$_interopRequireDefault((parcelRequire("6OINK")));

var $54e3aba6a17afac8$var$_min = $54e3aba6a17afac8$var$_interopRequireDefault((parcelRequire("g4QGg")));

var $54e3aba6a17afac8$var$_quickselect = $54e3aba6a17afac8$var$_interopRequireDefault((parcelRequire("gt1sJ")));

var $54e3aba6a17afac8$var$_number = $54e3aba6a17afac8$var$_interopRequireWildcard((parcelRequire("kFWGP")));
function $54e3aba6a17afac8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($54e3aba6a17afac8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $54e3aba6a17afac8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $54e3aba6a17afac8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $54e3aba6a17afac8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $54e3aba6a17afac8$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $54e3aba6a17afac8$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $54e3aba6a17afac8$var$_min.default)(values);
    if (p >= 1) return (0, $54e3aba6a17afac8$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $54e3aba6a17afac8$var$_max.default)((0, $54e3aba6a17afac8$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $54e3aba6a17afac8$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $54e3aba6a17afac8$var$quantileSorted(values, p, valueof = $54e3aba6a17afac8$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("6OINK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4f6a2a3065df3d9b$var$max;
function $4f6a2a3065df3d9b$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("g4QGg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb45e257a97948dd$var$min;
function $bb45e257a97948dd$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("gt1sJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfd07d2a7103574a$var$quickselect;

var $QuUhK = parcelRequire("QuUhK");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $bfd07d2a7103574a$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $QuUhK.ascendingDefined : (0, $QuUhK.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $bfd07d2a7103574a$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $bfd07d2a7103574a$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $bfd07d2a7103574a$var$swap(array, left, right);
        while(i < j){
            $bfd07d2a7103574a$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $bfd07d2a7103574a$var$swap(array, left, j);
        else ++j, $bfd07d2a7103574a$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $bfd07d2a7103574a$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("f6HWZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aff98231e6657206$var$thresholdScott;

var $aff98231e6657206$var$_count = $aff98231e6657206$var$_interopRequireDefault((parcelRequire("5mquz")));

var $aff98231e6657206$var$_deviation = $aff98231e6657206$var$_interopRequireDefault((parcelRequire("3xDkJ")));
function $aff98231e6657206$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aff98231e6657206$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $aff98231e6657206$var$_count.default)(values)) / (3.49 * (0, $aff98231e6657206$var$_deviation.default)(values)));
}

});

parcelRegister("h1ZdX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c662058490228f0e$var$maxIndex;
function $c662058490228f0e$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("g7R2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bbd67242ac1b5cea$var$mean;
function $bbd67242ac1b5cea$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("hbW8L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c84090350da5af82$var$median;

var $c84090350da5af82$var$_quantile = $c84090350da5af82$var$_interopRequireDefault((parcelRequire("7hRz2")));
function $c84090350da5af82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c84090350da5af82$var$median(values, valueof) {
    return (0, $c84090350da5af82$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("7hd24", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54c43ae480ddf44d$var$merge;
function* $54c43ae480ddf44d$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $54c43ae480ddf44d$var$merge(arrays) {
    return Array.from($54c43ae480ddf44d$var$flatten(arrays));
}

});

parcelRegister("dSS8z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a1ba50058a533b49$var$minIndex;
function $a1ba50058a533b49$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("2Jkdv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fcf775f4ab87be7$var$mode;

var $hhLyY = parcelRequire("hhLyY");
function $1fcf775f4ab87be7$var$mode(values, valueof) {
    const counts = new $hhLyY.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("MVTY9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $093165e3157bb2af$var$pairs;
module.exports.pair = $093165e3157bb2af$var$pair;
function $093165e3157bb2af$var$pairs(values, pairof = $093165e3157bb2af$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $093165e3157bb2af$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("f8r5h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b04c9cb8cd6f0427$var$range;
function $b04c9cb8cd6f0427$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("cDIcf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $933b691376165e91$var$rank;

var $933b691376165e91$var$_ascending = $933b691376165e91$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $QuUhK = parcelRequire("QuUhK");
function $933b691376165e91$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $933b691376165e91$var$rank(values, valueof = $933b691376165e91$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $933b691376165e91$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $933b691376165e91$var$_ascending.default ? (i, j)=>(0, $QuUhK.ascendingDefined)(V[i], V[j]) : (0, $QuUhK.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("fqE4D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3b85e8382d1a1ed$var$least;

var $b3b85e8382d1a1ed$var$_ascending = $b3b85e8382d1a1ed$var$_interopRequireDefault((parcelRequire("5gKrb")));
function $b3b85e8382d1a1ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3b85e8382d1a1ed$var$least(values, compare = $b3b85e8382d1a1ed$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $b3b85e8382d1a1ed$var$_ascending.default)(value, minValue) < 0 : (0, $b3b85e8382d1a1ed$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("hShgB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d034df9fc61236eb$var$leastIndex;

var $d034df9fc61236eb$var$_ascending = $d034df9fc61236eb$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $d034df9fc61236eb$var$_minIndex = $d034df9fc61236eb$var$_interopRequireDefault((parcelRequire("dSS8z")));
function $d034df9fc61236eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d034df9fc61236eb$var$leastIndex(values, compare = $d034df9fc61236eb$var$_ascending.default) {
    if (compare.length === 1) return (0, $d034df9fc61236eb$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("k2m84", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e96528eb145d3af7$var$greatest;

var $e96528eb145d3af7$var$_ascending = $e96528eb145d3af7$var$_interopRequireDefault((parcelRequire("5gKrb")));
function $e96528eb145d3af7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e96528eb145d3af7$var$greatest(values, compare = $e96528eb145d3af7$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $e96528eb145d3af7$var$_ascending.default)(value, maxValue) > 0 : (0, $e96528eb145d3af7$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("jtbb0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e2c9652c6ad9353a$var$greatestIndex;

var $e2c9652c6ad9353a$var$_ascending = $e2c9652c6ad9353a$var$_interopRequireDefault((parcelRequire("5gKrb")));

var $e2c9652c6ad9353a$var$_maxIndex = $e2c9652c6ad9353a$var$_interopRequireDefault((parcelRequire("h1ZdX")));
function $e2c9652c6ad9353a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e2c9652c6ad9353a$var$greatestIndex(values, compare = $e2c9652c6ad9353a$var$_ascending.default) {
    if (compare.length === 1) return (0, $e2c9652c6ad9353a$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("2jKqk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b015de68e8d6930$var$scan;

var $1b015de68e8d6930$var$_leastIndex = $1b015de68e8d6930$var$_interopRequireDefault((parcelRequire("hShgB")));
function $1b015de68e8d6930$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1b015de68e8d6930$var$scan(values, compare) {
    const index = (0, $1b015de68e8d6930$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("24eBm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $1817480d4d7b5aa7$var$shuffler;
var $1817480d4d7b5aa7$var$_default = $1817480d4d7b5aa7$var$shuffler(Math.random);
module.exports.default = $1817480d4d7b5aa7$var$_default;
function $1817480d4d7b5aa7$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("gDgA6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1bd268ec38ad107$var$sum;
function $c1bd268ec38ad107$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("gVomG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c524de8c8e9b32cf$var$transpose;

var $c524de8c8e9b32cf$var$_min = $c524de8c8e9b32cf$var$_interopRequireDefault((parcelRequire("g4QGg")));
function $c524de8c8e9b32cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c524de8c8e9b32cf$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $c524de8c8e9b32cf$var$_min.default)(matrix, $c524de8c8e9b32cf$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $c524de8c8e9b32cf$var$length(d) {
    return d.length;
}

});

parcelRegister("l3WNz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5577cefaab0a0cd$var$zip;

var $f5577cefaab0a0cd$var$_transpose = $f5577cefaab0a0cd$var$_interopRequireDefault((parcelRequire("gVomG")));
function $f5577cefaab0a0cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5577cefaab0a0cd$var$zip() {
    return (0, $f5577cefaab0a0cd$var$_transpose.default)(arguments);
}

});

parcelRegister("gyKIr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0e40f18979348db$var$every;
function $c0e40f18979348db$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("4osSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $332fce41d52acd0a$var$some;
function $332fce41d52acd0a$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("l4Yz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f588f38092f891ac$var$filter;
function $f588f38092f891ac$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("kBgUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eff461fd8b772aef$var$map;
function $eff461fd8b772aef$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("4S4l9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $38bf927522e62801$var$reduce;
function $38bf927522e62801$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("atf0d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79f84002a109b8ed$var$reverse;
function $79f84002a109b8ed$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("6eVXW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48b103aef2d58162$var$difference;

var $hhLyY = parcelRequire("hhLyY");
function $48b103aef2d58162$var$difference(values, ...others) {
    values = new $hhLyY.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("gPeds", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3fc6fcc61060193$var$disjoint;

var $hhLyY = parcelRequire("hhLyY");
function $c3fc6fcc61060193$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $hhLyY.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("h856s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7872462b26dcbe4$var$intersection;

var $hhLyY = parcelRequire("hhLyY");
function $c7872462b26dcbe4$var$intersection(values, ...others) {
    values = new $hhLyY.InternSet(values);
    others = others.map($c7872462b26dcbe4$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $c7872462b26dcbe4$var$set(values) {
    return values instanceof $hhLyY.InternSet ? values : new $hhLyY.InternSet(values);
}

});

parcelRegister("atlNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79fd8699d041affa$var$subset;

var $79fd8699d041affa$var$_superset = $79fd8699d041affa$var$_interopRequireDefault((parcelRequire("btwMV")));
function $79fd8699d041affa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79fd8699d041affa$var$subset(values, other) {
    return (0, $79fd8699d041affa$var$_superset.default)(other, values);
}

});
parcelRegister("btwMV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85abd62f54dc5db0$var$superset;
function $85abd62f54dc5db0$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $85abd62f54dc5db0$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $85abd62f54dc5db0$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $85abd62f54dc5db0$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("50pFt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a50dcf22930617b$var$union;

var $hhLyY = parcelRequire("hhLyY");
function $3a50dcf22930617b$var$union(...others) {
    const set = new $hhLyY.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("bQI8z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $8a06c9c2a18a21f0$var$initInterpolator;
module.exports.initRange = $8a06c9c2a18a21f0$var$initRange;
function $8a06c9c2a18a21f0$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $8a06c9c2a18a21f0$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("28Bju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18e945c98460eaa1$var$ordinal;
module.exports.implicit = void 0;

var $xfpL5 = parcelRequire("xfpL5");

var $bQI8z = parcelRequire("bQI8z");
const $18e945c98460eaa1$var$implicit = Symbol("implicit");
module.exports.implicit = $18e945c98460eaa1$var$implicit;
function $18e945c98460eaa1$var$ordinal() {
    var index = new $xfpL5.InternMap(), domain = [], range = [], unknown = $18e945c98460eaa1$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $18e945c98460eaa1$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $xfpL5.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $18e945c98460eaa1$var$ordinal(domain, range).unknown(unknown);
    };
    $bQI8z.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("djEl0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b1c56f6fa54bb05$var$identity;

var $5bduu = parcelRequire("5bduu");

var $9b1c56f6fa54bb05$var$_number = $9b1c56f6fa54bb05$var$_interopRequireDefault((parcelRequire("5qJvW")));
function $9b1c56f6fa54bb05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b1c56f6fa54bb05$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $9b1c56f6fa54bb05$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $9b1c56f6fa54bb05$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $9b1c56f6fa54bb05$var$_number.default) : [
        0,
        1
    ];
    return (0, $5bduu.linearish)(scale);
}

});
parcelRegister("5bduu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c5871d6a6ef6a64$var$linear;
module.exports.linearish = $3c5871d6a6ef6a64$var$linearish;

var $xfpL5 = parcelRequire("xfpL5");

var $3c5871d6a6ef6a64$var$_continuous = $3c5871d6a6ef6a64$var$_interopRequireWildcard((parcelRequire("dnDEZ")));

var $bQI8z = parcelRequire("bQI8z");

var $3c5871d6a6ef6a64$var$_tickFormat = $3c5871d6a6ef6a64$var$_interopRequireDefault((parcelRequire("bShky")));
function $3c5871d6a6ef6a64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c5871d6a6ef6a64$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3c5871d6a6ef6a64$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3c5871d6a6ef6a64$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3c5871d6a6ef6a64$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3c5871d6a6ef6a64$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $xfpL5.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $3c5871d6a6ef6a64$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $xfpL5.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $3c5871d6a6ef6a64$var$linear() {
    var scale = (0, $3c5871d6a6ef6a64$var$_continuous.default)();
    scale.copy = function() {
        return (0, $3c5871d6a6ef6a64$var$_continuous.copy)(scale, $3c5871d6a6ef6a64$var$linear());
    };
    $bQI8z.initRange.apply(scale, arguments);
    return $3c5871d6a6ef6a64$var$linearish(scale);
}

});
parcelRegister("dnDEZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $9bdc3002ef04ecf6$var$copy;
module.exports.default = $9bdc3002ef04ecf6$var$continuous;
module.exports.identity = $9bdc3002ef04ecf6$var$identity;
module.exports.transformer = $9bdc3002ef04ecf6$var$transformer;

var $xfpL5 = parcelRequire("xfpL5");

var $eBA7s = parcelRequire("eBA7s");

var $9bdc3002ef04ecf6$var$_constant = $9bdc3002ef04ecf6$var$_interopRequireDefault((parcelRequire("6DiaI")));

var $9bdc3002ef04ecf6$var$_number = $9bdc3002ef04ecf6$var$_interopRequireDefault((parcelRequire("5qJvW")));
function $9bdc3002ef04ecf6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9bdc3002ef04ecf6$var$unit = [
    0,
    1
];
function $9bdc3002ef04ecf6$var$identity(x) {
    return x;
}
function $9bdc3002ef04ecf6$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $9bdc3002ef04ecf6$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $9bdc3002ef04ecf6$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $9bdc3002ef04ecf6$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $9bdc3002ef04ecf6$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $9bdc3002ef04ecf6$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $9bdc3002ef04ecf6$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $9bdc3002ef04ecf6$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $xfpL5.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $9bdc3002ef04ecf6$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $9bdc3002ef04ecf6$var$transformer() {
    var domain = $9bdc3002ef04ecf6$var$unit, range = $9bdc3002ef04ecf6$var$unit, interpolate = $eBA7s.interpolate, transform, untransform, unknown, clamp = $9bdc3002ef04ecf6$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $9bdc3002ef04ecf6$var$identity) clamp = $9bdc3002ef04ecf6$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $9bdc3002ef04ecf6$var$polymap : $9bdc3002ef04ecf6$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $eBA7s.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $9bdc3002ef04ecf6$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $eBA7s.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $9bdc3002ef04ecf6$var$identity, rescale()) : clamp !== $9bdc3002ef04ecf6$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $9bdc3002ef04ecf6$var$continuous() {
    return $9bdc3002ef04ecf6$var$transformer()($9bdc3002ef04ecf6$var$identity, $9bdc3002ef04ecf6$var$identity);
}

});
parcelRegister("eBA7s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $i7UTu.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $i7UTu.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $aa2089ecf3c23596$var$_quantize.default;
    }
});

var $aa2089ecf3c23596$var$_value = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("cvJcJ")));

var $aa2089ecf3c23596$var$_array = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("6qHoN")));

var $aa2089ecf3c23596$var$_basis = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("2yUSK")));

var $aa2089ecf3c23596$var$_basisClosed = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("adtFf")));

var $aa2089ecf3c23596$var$_date = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("kRAjn")));

var $aa2089ecf3c23596$var$_discrete = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("lL8UP")));

var $aa2089ecf3c23596$var$_hue = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("q89Af")));

var $aa2089ecf3c23596$var$_number = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("1wmyP")));

var $aa2089ecf3c23596$var$_numberArray = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("apjaS")));

var $aa2089ecf3c23596$var$_object = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("25ztx")));

var $aa2089ecf3c23596$var$_round = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("1XgE1")));

var $aa2089ecf3c23596$var$_string = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("bWuJv")));

var $i7UTu = parcelRequire("i7UTu");

var $aa2089ecf3c23596$var$_zoom = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("6U8be")));

var $aa2089ecf3c23596$var$_rgb = $aa2089ecf3c23596$var$_interopRequireWildcard((parcelRequire("8cg9T")));

var $aa2089ecf3c23596$var$_hsl = $aa2089ecf3c23596$var$_interopRequireWildcard((parcelRequire("bN8NF")));

var $aa2089ecf3c23596$var$_lab = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("950Ew")));

var $aa2089ecf3c23596$var$_hcl = $aa2089ecf3c23596$var$_interopRequireWildcard((parcelRequire("lMiOk")));

var $aa2089ecf3c23596$var$_cubehelix = $aa2089ecf3c23596$var$_interopRequireWildcard((parcelRequire("daajM")));

var $aa2089ecf3c23596$var$_piecewise = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("8CBJF")));

var $aa2089ecf3c23596$var$_quantize = $aa2089ecf3c23596$var$_interopRequireDefault((parcelRequire("OhGZY")));
function $aa2089ecf3c23596$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($aa2089ecf3c23596$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $aa2089ecf3c23596$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $aa2089ecf3c23596$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $aa2089ecf3c23596$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("cvJcJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $91bb71eefbf61044$var$_default;

var $eGe63 = parcelRequire("eGe63");

var $91bb71eefbf61044$var$_rgb = $91bb71eefbf61044$var$_interopRequireDefault((parcelRequire("8cg9T")));

var $6qHoN = parcelRequire("6qHoN");

var $91bb71eefbf61044$var$_date = $91bb71eefbf61044$var$_interopRequireDefault((parcelRequire("kRAjn")));

var $91bb71eefbf61044$var$_number = $91bb71eefbf61044$var$_interopRequireDefault((parcelRequire("1wmyP")));

var $91bb71eefbf61044$var$_object = $91bb71eefbf61044$var$_interopRequireDefault((parcelRequire("25ztx")));

var $91bb71eefbf61044$var$_string = $91bb71eefbf61044$var$_interopRequireDefault((parcelRequire("bWuJv")));

var $91bb71eefbf61044$var$_constant = $91bb71eefbf61044$var$_interopRequireDefault((parcelRequire("j0JjV")));

var $91bb71eefbf61044$var$_numberArray = $91bb71eefbf61044$var$_interopRequireWildcard((parcelRequire("apjaS")));
function $91bb71eefbf61044$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($91bb71eefbf61044$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $91bb71eefbf61044$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $91bb71eefbf61044$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $91bb71eefbf61044$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91bb71eefbf61044$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $91bb71eefbf61044$var$_constant.default)(b) : (t === "number" ? $91bb71eefbf61044$var$_number.default : t === "string" ? (c = (0, $eGe63.color)(b)) ? (b = c, $91bb71eefbf61044$var$_rgb.default) : $91bb71eefbf61044$var$_string.default : b instanceof $eGe63.color ? $91bb71eefbf61044$var$_rgb.default : b instanceof Date ? $91bb71eefbf61044$var$_date.default : (0, $91bb71eefbf61044$var$_numberArray.isNumberArray)(b) ? $91bb71eefbf61044$var$_numberArray.default : Array.isArray(b) ? $6qHoN.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $91bb71eefbf61044$var$_object.default : $91bb71eefbf61044$var$_number.default)(a, b);
}

});
parcelRegister("eGe63", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $aaffec3d04b4566a$var$_color.rgb;
    }
});

var $aaffec3d04b4566a$var$_color = $aaffec3d04b4566a$var$_interopRequireWildcard((parcelRequire("gpMPK")));

var $aaffec3d04b4566a$var$_lab = $aaffec3d04b4566a$var$_interopRequireWildcard((parcelRequire("7GuQ5")));

var $aaffec3d04b4566a$var$_cubehelix = $aaffec3d04b4566a$var$_interopRequireDefault((parcelRequire("5AeQH")));
function $aaffec3d04b4566a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aaffec3d04b4566a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($aaffec3d04b4566a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $aaffec3d04b4566a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $aaffec3d04b4566a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("gpMPK", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("9ndG2")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("9ndG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d30defe2463fa52$var$_default;
module.exports.extend = $6d30defe2463fa52$var$extend;
function $6d30defe2463fa52$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $6d30defe2463fa52$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("7GuQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $598460a5c13dd4c5$var$Hcl;
module.exports.Lab = $598460a5c13dd4c5$var$Lab;
module.exports.default = $598460a5c13dd4c5$var$lab;
module.exports.gray = $598460a5c13dd4c5$var$gray;
module.exports.hcl = $598460a5c13dd4c5$var$hcl;
module.exports.lch = $598460a5c13dd4c5$var$lch;

var $598460a5c13dd4c5$var$_define = $598460a5c13dd4c5$var$_interopRequireWildcard((parcelRequire("9ndG2")));

var $gpMPK = parcelRequire("gpMPK");

var $GM0yf = parcelRequire("GM0yf");
function $598460a5c13dd4c5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($598460a5c13dd4c5$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $598460a5c13dd4c5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $598460a5c13dd4c5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $598460a5c13dd4c5$var$K = 18, $598460a5c13dd4c5$var$Xn = 0.96422, $598460a5c13dd4c5$var$Yn = 1, $598460a5c13dd4c5$var$Zn = 0.82521, $598460a5c13dd4c5$var$t0 = 4 / 29, $598460a5c13dd4c5$var$t1 = 6 / 29, $598460a5c13dd4c5$var$t2 = 3 * $598460a5c13dd4c5$var$t1 * $598460a5c13dd4c5$var$t1, $598460a5c13dd4c5$var$t3 = $598460a5c13dd4c5$var$t1 * $598460a5c13dd4c5$var$t1 * $598460a5c13dd4c5$var$t1;
function $598460a5c13dd4c5$var$labConvert(o) {
    if (o instanceof $598460a5c13dd4c5$var$Lab) return new $598460a5c13dd4c5$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $598460a5c13dd4c5$var$Hcl) return $598460a5c13dd4c5$var$hcl2lab(o);
    if (!(o instanceof $gpMPK.Rgb)) o = (0, $gpMPK.rgbConvert)(o);
    var r = $598460a5c13dd4c5$var$rgb2lrgb(o.r), g = $598460a5c13dd4c5$var$rgb2lrgb(o.g), b = $598460a5c13dd4c5$var$rgb2lrgb(o.b), y = $598460a5c13dd4c5$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $598460a5c13dd4c5$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $598460a5c13dd4c5$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $598460a5c13dd4c5$var$Xn);
        z = $598460a5c13dd4c5$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $598460a5c13dd4c5$var$Zn);
    }
    return new $598460a5c13dd4c5$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $598460a5c13dd4c5$var$gray(l, opacity) {
    return new $598460a5c13dd4c5$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $598460a5c13dd4c5$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $598460a5c13dd4c5$var$labConvert(l) : new $598460a5c13dd4c5$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $598460a5c13dd4c5$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $598460a5c13dd4c5$var$_define.default)($598460a5c13dd4c5$var$Lab, $598460a5c13dd4c5$var$lab, (0, $598460a5c13dd4c5$var$_define.extend)($gpMPK.Color, {
    brighter (k) {
        return new $598460a5c13dd4c5$var$Lab(this.l + $598460a5c13dd4c5$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $598460a5c13dd4c5$var$Lab(this.l - $598460a5c13dd4c5$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $598460a5c13dd4c5$var$Xn * $598460a5c13dd4c5$var$lab2xyz(x);
        y = $598460a5c13dd4c5$var$Yn * $598460a5c13dd4c5$var$lab2xyz(y);
        z = $598460a5c13dd4c5$var$Zn * $598460a5c13dd4c5$var$lab2xyz(z);
        return new $gpMPK.Rgb($598460a5c13dd4c5$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $598460a5c13dd4c5$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $598460a5c13dd4c5$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $598460a5c13dd4c5$var$xyz2lab(t) {
    return t > $598460a5c13dd4c5$var$t3 ? Math.pow(t, 1 / 3) : t / $598460a5c13dd4c5$var$t2 + $598460a5c13dd4c5$var$t0;
}
function $598460a5c13dd4c5$var$lab2xyz(t) {
    return t > $598460a5c13dd4c5$var$t1 ? t * t * t : $598460a5c13dd4c5$var$t2 * (t - $598460a5c13dd4c5$var$t0);
}
function $598460a5c13dd4c5$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $598460a5c13dd4c5$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $598460a5c13dd4c5$var$hclConvert(o) {
    if (o instanceof $598460a5c13dd4c5$var$Hcl) return new $598460a5c13dd4c5$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $598460a5c13dd4c5$var$Lab)) o = $598460a5c13dd4c5$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $598460a5c13dd4c5$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $GM0yf.degrees;
    return new $598460a5c13dd4c5$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $598460a5c13dd4c5$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $598460a5c13dd4c5$var$hclConvert(l) : new $598460a5c13dd4c5$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $598460a5c13dd4c5$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $598460a5c13dd4c5$var$hclConvert(h) : new $598460a5c13dd4c5$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $598460a5c13dd4c5$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $598460a5c13dd4c5$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $598460a5c13dd4c5$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $GM0yf.radians;
    return new $598460a5c13dd4c5$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $598460a5c13dd4c5$var$_define.default)($598460a5c13dd4c5$var$Hcl, $598460a5c13dd4c5$var$hcl, (0, $598460a5c13dd4c5$var$_define.extend)($gpMPK.Color, {
    brighter (k) {
        return new $598460a5c13dd4c5$var$Hcl(this.h, this.c, this.l + $598460a5c13dd4c5$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $598460a5c13dd4c5$var$Hcl(this.h, this.c, this.l - $598460a5c13dd4c5$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $598460a5c13dd4c5$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("GM0yf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $080929b9cdf36570$var$radians = Math.PI / 180;
module.exports.radians = $080929b9cdf36570$var$radians;
const $080929b9cdf36570$var$degrees = 180 / Math.PI;
module.exports.degrees = $080929b9cdf36570$var$degrees;

});


parcelRegister("5AeQH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $410bd54011e96422$var$Cubehelix;
module.exports.default = $410bd54011e96422$var$cubehelix;

var $410bd54011e96422$var$_define = $410bd54011e96422$var$_interopRequireWildcard((parcelRequire("9ndG2")));

var $gpMPK = parcelRequire("gpMPK");

var $GM0yf = parcelRequire("GM0yf");
function $410bd54011e96422$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($410bd54011e96422$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $410bd54011e96422$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $410bd54011e96422$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $410bd54011e96422$var$A = -0.14861, $410bd54011e96422$var$B = 1.78277, $410bd54011e96422$var$C = -0.29227, $410bd54011e96422$var$D = -0.90649, $410bd54011e96422$var$E = 1.97294, $410bd54011e96422$var$ED = $410bd54011e96422$var$E * $410bd54011e96422$var$D, $410bd54011e96422$var$EB = $410bd54011e96422$var$E * $410bd54011e96422$var$B, $410bd54011e96422$var$BC_DA = $410bd54011e96422$var$B * $410bd54011e96422$var$C - $410bd54011e96422$var$D * $410bd54011e96422$var$A;
function $410bd54011e96422$var$cubehelixConvert(o) {
    if (o instanceof $410bd54011e96422$var$Cubehelix) return new $410bd54011e96422$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $gpMPK.Rgb)) o = (0, $gpMPK.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($410bd54011e96422$var$BC_DA * b + $410bd54011e96422$var$ED * r - $410bd54011e96422$var$EB * g) / ($410bd54011e96422$var$BC_DA + $410bd54011e96422$var$ED - $410bd54011e96422$var$EB), bl = b - l, k = ($410bd54011e96422$var$E * (g - l) - $410bd54011e96422$var$C * bl) / $410bd54011e96422$var$D, s = Math.sqrt(k * k + bl * bl) / ($410bd54011e96422$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $GM0yf.degrees - 120 : NaN;
    return new $410bd54011e96422$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $410bd54011e96422$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $410bd54011e96422$var$cubehelixConvert(h) : new $410bd54011e96422$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $410bd54011e96422$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $410bd54011e96422$var$_define.default)($410bd54011e96422$var$Cubehelix, $410bd54011e96422$var$cubehelix, (0, $410bd54011e96422$var$_define.extend)($gpMPK.Color, {
    brighter (k) {
        k = k == null ? $gpMPK.brighter : Math.pow($gpMPK.brighter, k);
        return new $410bd54011e96422$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $gpMPK.darker : Math.pow($gpMPK.darker, k);
        return new $410bd54011e96422$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $GM0yf.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $gpMPK.Rgb(255 * (l + a * ($410bd54011e96422$var$A * cosh + $410bd54011e96422$var$B * sinh)), 255 * (l + a * ($410bd54011e96422$var$C * cosh + $410bd54011e96422$var$D * sinh)), 255 * (l + a * ($410bd54011e96422$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("8cg9T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $eGe63 = parcelRequire("eGe63");

var $5f7bfa7958d13aa6$var$_basis = $5f7bfa7958d13aa6$var$_interopRequireDefault((parcelRequire("2yUSK")));

var $5f7bfa7958d13aa6$var$_basisClosed = $5f7bfa7958d13aa6$var$_interopRequireDefault((parcelRequire("adtFf")));

var $5f7bfa7958d13aa6$var$_color = $5f7bfa7958d13aa6$var$_interopRequireWildcard((parcelRequire("fZu4A")));
function $5f7bfa7958d13aa6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5f7bfa7958d13aa6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5f7bfa7958d13aa6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f7bfa7958d13aa6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5f7bfa7958d13aa6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5f7bfa7958d13aa6$var$_default = function rgbGamma(y) {
    var color = (0, $5f7bfa7958d13aa6$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $eGe63.rgb)(start)).r, (end = (0, $eGe63.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $5f7bfa7958d13aa6$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $5f7bfa7958d13aa6$var$_default;
function $5f7bfa7958d13aa6$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $eGe63.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $5f7bfa7958d13aa6$var$rgbBasis = $5f7bfa7958d13aa6$var$rgbSpline($5f7bfa7958d13aa6$var$_basis.default);
module.exports.rgbBasis = $5f7bfa7958d13aa6$var$rgbBasis;
var $5f7bfa7958d13aa6$var$rgbBasisClosed = $5f7bfa7958d13aa6$var$rgbSpline($5f7bfa7958d13aa6$var$_basisClosed.default);
module.exports.rgbBasisClosed = $5f7bfa7958d13aa6$var$rgbBasisClosed;

});
parcelRegister("2yUSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $1ddae15451edfa66$var$basis;
module.exports.default = $1ddae15451edfa66$var$_default;
function $1ddae15451edfa66$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $1ddae15451edfa66$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $1ddae15451edfa66$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("adtFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7702210346a56a8d$var$_default;

var $2yUSK = parcelRequire("2yUSK");
function $7702210346a56a8d$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $2yUSK.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("fZu4A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba43e15d0177bd3f$var$nogamma;
module.exports.gamma = $ba43e15d0177bd3f$var$gamma;
module.exports.hue = $ba43e15d0177bd3f$var$hue;

var $ba43e15d0177bd3f$var$_constant = $ba43e15d0177bd3f$var$_interopRequireDefault((parcelRequire("j0JjV")));
function $ba43e15d0177bd3f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba43e15d0177bd3f$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $ba43e15d0177bd3f$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $ba43e15d0177bd3f$var$hue(a, b) {
    var d = b - a;
    return d ? $ba43e15d0177bd3f$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $ba43e15d0177bd3f$var$_constant.default)(isNaN(a) ? b : a);
}
function $ba43e15d0177bd3f$var$gamma(y) {
    return (y = +y) === 1 ? $ba43e15d0177bd3f$var$nogamma : function(a, b) {
        return b - a ? $ba43e15d0177bd3f$var$exponential(a, b, y) : (0, $ba43e15d0177bd3f$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $ba43e15d0177bd3f$var$nogamma(a, b) {
    var d = b - a;
    return d ? $ba43e15d0177bd3f$var$linear(a, d) : (0, $ba43e15d0177bd3f$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("j0JjV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dd712c1889946b09$var$_default = (x)=>()=>x;
module.exports.default = $dd712c1889946b09$var$_default;

});



parcelRegister("6qHoN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ae6d5ee6eb28ed0$var$_default;
module.exports.genericArray = $4ae6d5ee6eb28ed0$var$genericArray;

var $4ae6d5ee6eb28ed0$var$_value = $4ae6d5ee6eb28ed0$var$_interopRequireDefault((parcelRequire("cvJcJ")));

var $4ae6d5ee6eb28ed0$var$_numberArray = $4ae6d5ee6eb28ed0$var$_interopRequireWildcard((parcelRequire("apjaS")));
function $4ae6d5ee6eb28ed0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4ae6d5ee6eb28ed0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4ae6d5ee6eb28ed0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4ae6d5ee6eb28ed0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4ae6d5ee6eb28ed0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4ae6d5ee6eb28ed0$var$_default(a, b) {
    return ((0, $4ae6d5ee6eb28ed0$var$_numberArray.isNumberArray)(b) ? $4ae6d5ee6eb28ed0$var$_numberArray.default : $4ae6d5ee6eb28ed0$var$genericArray)(a, b);
}
function $4ae6d5ee6eb28ed0$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $4ae6d5ee6eb28ed0$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("apjaS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $793b1ccda2d887b3$var$_default;
module.exports.isNumberArray = $793b1ccda2d887b3$var$isNumberArray;
function $793b1ccda2d887b3$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $793b1ccda2d887b3$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("kRAjn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f304ec9c23cac2bf$var$_default;
function $f304ec9c23cac2bf$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("1wmyP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11ba47b7a6ff2cb5$var$_default;
function $11ba47b7a6ff2cb5$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("25ztx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $185791136c40307d$var$_default;

var $185791136c40307d$var$_value = $185791136c40307d$var$_interopRequireDefault((parcelRequire("cvJcJ")));
function $185791136c40307d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $185791136c40307d$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $185791136c40307d$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("bWuJv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b1cf3702b1852cc$var$_default;

var $8b1cf3702b1852cc$var$_number = $8b1cf3702b1852cc$var$_interopRequireDefault((parcelRequire("1wmyP")));
function $8b1cf3702b1852cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b1cf3702b1852cc$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $8b1cf3702b1852cc$var$reB = new RegExp($8b1cf3702b1852cc$var$reA.source, "g");
function $8b1cf3702b1852cc$var$zero(b) {
    return function() {
        return b;
    };
}
function $8b1cf3702b1852cc$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $8b1cf3702b1852cc$var$_default(a, b) {
    var bi = $8b1cf3702b1852cc$var$reA.lastIndex = $8b1cf3702b1852cc$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $8b1cf3702b1852cc$var$reA.exec(a)) && (bm = $8b1cf3702b1852cc$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $8b1cf3702b1852cc$var$_number.default)(am, bm)
            });
        }
        bi = $8b1cf3702b1852cc$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $8b1cf3702b1852cc$var$one(q[0].x) : $8b1cf3702b1852cc$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("lL8UP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd74e73bd4616f3e$var$_default;
function $fd74e73bd4616f3e$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("q89Af", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $04e8c0f3f1249c1e$var$_default;

var $fZu4A = parcelRequire("fZu4A");
function $04e8c0f3f1249c1e$var$_default(a, b) {
    var i = (0, $fZu4A.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("1XgE1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $16c836684bf9201e$var$_default;
function $16c836684bf9201e$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("i7UTu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $d325036db202822f$var$_number = $d325036db202822f$var$_interopRequireDefault((parcelRequire("1wmyP")));

var $i7n3B = parcelRequire("i7n3B");
function $d325036db202822f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d325036db202822f$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $d325036db202822f$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $d325036db202822f$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $d325036db202822f$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $d325036db202822f$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $d325036db202822f$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $d325036db202822f$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $d325036db202822f$var$interpolateTransformCss = $d325036db202822f$var$interpolateTransform($i7n3B.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $d325036db202822f$var$interpolateTransformCss;
var $d325036db202822f$var$interpolateTransformSvg = $d325036db202822f$var$interpolateTransform($i7n3B.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $d325036db202822f$var$interpolateTransformSvg;

});
parcelRegister("i7n3B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $d30ac4174a7c6104$var$parseCss;
module.exports.parseSvg = $d30ac4174a7c6104$var$parseSvg;

var $d30ac4174a7c6104$var$_decompose = $d30ac4174a7c6104$var$_interopRequireWildcard((parcelRequire("TgTgR")));
function $d30ac4174a7c6104$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d30ac4174a7c6104$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d30ac4174a7c6104$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d30ac4174a7c6104$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $d30ac4174a7c6104$var$svgNode;
/* eslint-disable no-undef */ function $d30ac4174a7c6104$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $d30ac4174a7c6104$var$_decompose.identity : (0, $d30ac4174a7c6104$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $d30ac4174a7c6104$var$parseSvg(value) {
    if (value == null) return $d30ac4174a7c6104$var$_decompose.identity;
    if (!$d30ac4174a7c6104$var$svgNode) $d30ac4174a7c6104$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $d30ac4174a7c6104$var$svgNode.setAttribute("transform", value);
    if (!(value = $d30ac4174a7c6104$var$svgNode.transform.baseVal.consolidate())) return $d30ac4174a7c6104$var$_decompose.identity;
    value = value.matrix;
    return (0, $d30ac4174a7c6104$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("TgTgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a623d4385ddb644$var$_default;
module.exports.identity = void 0;
var $0a623d4385ddb644$var$degrees = 180 / Math.PI;
var $0a623d4385ddb644$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $0a623d4385ddb644$var$identity;
function $0a623d4385ddb644$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $0a623d4385ddb644$var$degrees,
        skewX: Math.atan(skewX) * $0a623d4385ddb644$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("6U8be", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $506e51715b0139c5$var$epsilon2 = 1e-12;
function $506e51715b0139c5$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $506e51715b0139c5$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $506e51715b0139c5$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $506e51715b0139c5$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $506e51715b0139c5$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $506e51715b0139c5$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $506e51715b0139c5$var$tanh(rho * s + r0) - $506e51715b0139c5$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $506e51715b0139c5$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $506e51715b0139c5$var$_default;

});

parcelRegister("bN8NF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $eGe63 = parcelRequire("eGe63");

var $0237258fceaa68f8$var$_color = $0237258fceaa68f8$var$_interopRequireWildcard((parcelRequire("fZu4A")));
function $0237258fceaa68f8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0237258fceaa68f8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0237258fceaa68f8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0237258fceaa68f8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0237258fceaa68f8$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $eGe63.hsl)(start)).h, (end = (0, $eGe63.hsl)(end)).h), s = (0, $0237258fceaa68f8$var$_color.default)(start.s, end.s), l = (0, $0237258fceaa68f8$var$_color.default)(start.l, end.l), opacity = (0, $0237258fceaa68f8$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $0237258fceaa68f8$var$_default = $0237258fceaa68f8$var$hsl($0237258fceaa68f8$var$_color.hue);
module.exports.default = $0237258fceaa68f8$var$_default;
var $0237258fceaa68f8$var$hslLong = $0237258fceaa68f8$var$hsl($0237258fceaa68f8$var$_color.default);
module.exports.hslLong = $0237258fceaa68f8$var$hslLong;

});

parcelRegister("950Ew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $69c5164a4e4c43dd$var$lab;

var $eGe63 = parcelRequire("eGe63");

var $69c5164a4e4c43dd$var$_color = $69c5164a4e4c43dd$var$_interopRequireDefault((parcelRequire("fZu4A")));
function $69c5164a4e4c43dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $69c5164a4e4c43dd$var$lab(start, end) {
    var l = (0, $69c5164a4e4c43dd$var$_color.default)((start = (0, $eGe63.lab)(start)).l, (end = (0, $eGe63.lab)(end)).l), a = (0, $69c5164a4e4c43dd$var$_color.default)(start.a, end.a), b = (0, $69c5164a4e4c43dd$var$_color.default)(start.b, end.b), opacity = (0, $69c5164a4e4c43dd$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("lMiOk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $eGe63 = parcelRequire("eGe63");

var $fdacac14379e2209$var$_color = $fdacac14379e2209$var$_interopRequireWildcard((parcelRequire("fZu4A")));
function $fdacac14379e2209$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fdacac14379e2209$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fdacac14379e2209$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fdacac14379e2209$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fdacac14379e2209$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $eGe63.hcl)(start)).h, (end = (0, $eGe63.hcl)(end)).h), c = (0, $fdacac14379e2209$var$_color.default)(start.c, end.c), l = (0, $fdacac14379e2209$var$_color.default)(start.l, end.l), opacity = (0, $fdacac14379e2209$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $fdacac14379e2209$var$_default = $fdacac14379e2209$var$hcl($fdacac14379e2209$var$_color.hue);
module.exports.default = $fdacac14379e2209$var$_default;
var $fdacac14379e2209$var$hclLong = $fdacac14379e2209$var$hcl($fdacac14379e2209$var$_color.default);
module.exports.hclLong = $fdacac14379e2209$var$hclLong;

});

parcelRegister("daajM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $eGe63 = parcelRequire("eGe63");

var $99543680e101dfd1$var$_color = $99543680e101dfd1$var$_interopRequireWildcard((parcelRequire("fZu4A")));
function $99543680e101dfd1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($99543680e101dfd1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $99543680e101dfd1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $99543680e101dfd1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $99543680e101dfd1$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $eGe63.cubehelix)(start)).h, (end = (0, $eGe63.cubehelix)(end)).h), s = (0, $99543680e101dfd1$var$_color.default)(start.s, end.s), l = (0, $99543680e101dfd1$var$_color.default)(start.l, end.l), opacity = (0, $99543680e101dfd1$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $99543680e101dfd1$var$_default = $99543680e101dfd1$var$cubehelix($99543680e101dfd1$var$_color.hue);
module.exports.default = $99543680e101dfd1$var$_default;
var $99543680e101dfd1$var$cubehelixLong = $99543680e101dfd1$var$cubehelix($99543680e101dfd1$var$_color.default);
module.exports.cubehelixLong = $99543680e101dfd1$var$cubehelixLong;

});

parcelRegister("8CBJF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $646f24dc773c5b4c$var$piecewise;

var $646f24dc773c5b4c$var$_value = $646f24dc773c5b4c$var$_interopRequireDefault((parcelRequire("cvJcJ")));
function $646f24dc773c5b4c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $646f24dc773c5b4c$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $646f24dc773c5b4c$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("OhGZY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $097264fe3af12b27$var$_default;
function $097264fe3af12b27$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("6DiaI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d447b1e9dff3eac$var$constants;
function $4d447b1e9dff3eac$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("5qJvW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f42afa02e6dbd73$var$number;
function $3f42afa02e6dbd73$var$number(x) {
    return +x;
}

});


parcelRegister("bShky", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a522e5a04594404$var$tickFormat;

var $xfpL5 = parcelRequire("xfpL5");

var $4JmPq = parcelRequire("4JmPq");
function $8a522e5a04594404$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $xfpL5.tickStep)(start, stop, count), precision;
    specifier = (0, $4JmPq.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $4JmPq.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $4JmPq.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $4JmPq.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $4JmPq.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $4JmPq.format)(specifier);
}

});
parcelRegister("4JmPq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $371d12a2d77f2e0b$var$_precisionRound.default;
    }
});

var $371d12a2d77f2e0b$var$_defaultLocale = $371d12a2d77f2e0b$var$_interopRequireWildcard((parcelRequire("hgJXy")));

var $371d12a2d77f2e0b$var$_locale = $371d12a2d77f2e0b$var$_interopRequireDefault((parcelRequire("5R2q3")));

var $371d12a2d77f2e0b$var$_formatSpecifier = $371d12a2d77f2e0b$var$_interopRequireWildcard((parcelRequire("6eVTa")));

var $371d12a2d77f2e0b$var$_precisionFixed = $371d12a2d77f2e0b$var$_interopRequireDefault((parcelRequire("cxuJL")));

var $371d12a2d77f2e0b$var$_precisionPrefix = $371d12a2d77f2e0b$var$_interopRequireDefault((parcelRequire("78BK9")));

var $371d12a2d77f2e0b$var$_precisionRound = $371d12a2d77f2e0b$var$_interopRequireDefault((parcelRequire("gKLp3")));
function $371d12a2d77f2e0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $371d12a2d77f2e0b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($371d12a2d77f2e0b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $371d12a2d77f2e0b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $371d12a2d77f2e0b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("hgJXy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c92794e18001e8b2$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $c92794e18001e8b2$var$_locale = $c92794e18001e8b2$var$_interopRequireDefault((parcelRequire("5R2q3")));
function $c92794e18001e8b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c92794e18001e8b2$var$locale;
var $c92794e18001e8b2$var$format;
module.exports.format = $c92794e18001e8b2$var$format;
var $c92794e18001e8b2$var$formatPrefix;
module.exports.formatPrefix = $c92794e18001e8b2$var$formatPrefix;
$c92794e18001e8b2$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $c92794e18001e8b2$var$defaultLocale(definition) {
    $c92794e18001e8b2$var$locale = (0, $c92794e18001e8b2$var$_locale.default)(definition);
    module.exports.format = $c92794e18001e8b2$var$format = $c92794e18001e8b2$var$locale.format;
    module.exports.formatPrefix = $c92794e18001e8b2$var$formatPrefix = $c92794e18001e8b2$var$locale.formatPrefix;
    return $c92794e18001e8b2$var$locale;
}

});
parcelRegister("5R2q3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4433c76b61bf9ada$var$_default;

var $4433c76b61bf9ada$var$_exponent = $4433c76b61bf9ada$var$_interopRequireDefault((parcelRequire("en4GL")));

var $4433c76b61bf9ada$var$_formatGroup = $4433c76b61bf9ada$var$_interopRequireDefault((parcelRequire("gEz7c")));

var $4433c76b61bf9ada$var$_formatNumerals = $4433c76b61bf9ada$var$_interopRequireDefault((parcelRequire("4QS5P")));

var $4433c76b61bf9ada$var$_formatSpecifier = $4433c76b61bf9ada$var$_interopRequireDefault((parcelRequire("6eVTa")));

var $4433c76b61bf9ada$var$_formatTrim = $4433c76b61bf9ada$var$_interopRequireDefault((parcelRequire("ghMdF")));

var $4433c76b61bf9ada$var$_formatTypes = $4433c76b61bf9ada$var$_interopRequireDefault((parcelRequire("aYbju")));

var $e4Jcj = parcelRequire("e4Jcj");

var $4433c76b61bf9ada$var$_identity = $4433c76b61bf9ada$var$_interopRequireDefault((parcelRequire("cQTwd")));
function $4433c76b61bf9ada$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4433c76b61bf9ada$var$map = Array.prototype.map, $4433c76b61bf9ada$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $4433c76b61bf9ada$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $4433c76b61bf9ada$var$_identity.default : (0, $4433c76b61bf9ada$var$_formatGroup.default)($4433c76b61bf9ada$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $4433c76b61bf9ada$var$_identity.default : (0, $4433c76b61bf9ada$var$_formatNumerals.default)($4433c76b61bf9ada$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $4433c76b61bf9ada$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$4433c76b61bf9ada$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $4433c76b61bf9ada$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $4433c76b61bf9ada$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $4433c76b61bf9ada$var$prefixes[8 + $e4Jcj.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $4433c76b61bf9ada$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $4433c76b61bf9ada$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $4433c76b61bf9ada$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("en4GL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a766d9be8d4da1b7$var$_default;

var $a7Qek = parcelRequire("a7Qek");
function $a766d9be8d4da1b7$var$_default(x) {
    return x = (0, $a7Qek.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("a7Qek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $75f312a751dbed6d$var$_default;
module.exports.formatDecimalParts = $75f312a751dbed6d$var$formatDecimalParts;
function $75f312a751dbed6d$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $75f312a751dbed6d$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("gEz7c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1fb9ee36e07a1f2$var$_default;
function $c1fb9ee36e07a1f2$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("4QS5P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3885fa7daccb6a7e$var$_default;
function $3885fa7daccb6a7e$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("6eVTa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $48b0f463f342f2d4$var$FormatSpecifier;
module.exports.default = $48b0f463f342f2d4$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $48b0f463f342f2d4$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $48b0f463f342f2d4$var$formatSpecifier(specifier) {
    if (!(match = $48b0f463f342f2d4$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $48b0f463f342f2d4$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$48b0f463f342f2d4$var$formatSpecifier.prototype = $48b0f463f342f2d4$var$FormatSpecifier.prototype; // instanceof
function $48b0f463f342f2d4$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$48b0f463f342f2d4$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("ghMdF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdb3a33cab3316f4$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $bdb3a33cab3316f4$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("aYbju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fc8488e028a8ab1$var$_formatDecimal = $7fc8488e028a8ab1$var$_interopRequireDefault((parcelRequire("a7Qek")));

var $7fc8488e028a8ab1$var$_formatPrefixAuto = $7fc8488e028a8ab1$var$_interopRequireDefault((parcelRequire("e4Jcj")));

var $7fc8488e028a8ab1$var$_formatRounded = $7fc8488e028a8ab1$var$_interopRequireDefault((parcelRequire("lH5g1")));
function $7fc8488e028a8ab1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7fc8488e028a8ab1$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $7fc8488e028a8ab1$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $7fc8488e028a8ab1$var$_formatRounded.default)(x * 100, p),
    "r": $7fc8488e028a8ab1$var$_formatRounded.default,
    "s": $7fc8488e028a8ab1$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $7fc8488e028a8ab1$var$_default;

});
parcelRegister("e4Jcj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3f47fb77664e995$var$_default;
module.exports.prefixExponent = void 0;

var $a7Qek = parcelRequire("a7Qek");
var $a3f47fb77664e995$var$prefixExponent;
module.exports.prefixExponent = $a3f47fb77664e995$var$prefixExponent;
function $a3f47fb77664e995$var$_default(x, p) {
    var d = (0, $a7Qek.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $a3f47fb77664e995$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $a7Qek.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("lH5g1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fcb1b11dbaec4973$var$_default;

var $a7Qek = parcelRequire("a7Qek");
function $fcb1b11dbaec4973$var$_default(x, p) {
    var d = (0, $a7Qek.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("cQTwd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $95b5682d8c286402$var$_default;
function $95b5682d8c286402$var$_default(x) {
    return x;
}

});



parcelRegister("cxuJL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $921068dfd860b506$var$_default;

var $921068dfd860b506$var$_exponent = $921068dfd860b506$var$_interopRequireDefault((parcelRequire("en4GL")));
function $921068dfd860b506$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $921068dfd860b506$var$_default(step) {
    return Math.max(0, -(0, $921068dfd860b506$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("78BK9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $53268ecfbb7f9d91$var$_default;

var $53268ecfbb7f9d91$var$_exponent = $53268ecfbb7f9d91$var$_interopRequireDefault((parcelRequire("en4GL")));
function $53268ecfbb7f9d91$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $53268ecfbb7f9d91$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $53268ecfbb7f9d91$var$_exponent.default)(value) / 3))) * 3 - (0, $53268ecfbb7f9d91$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("gKLp3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c325b6806d21f911$var$_default;

var $c325b6806d21f911$var$_exponent = $c325b6806d21f911$var$_interopRequireDefault((parcelRequire("en4GL")));
function $c325b6806d21f911$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c325b6806d21f911$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $c325b6806d21f911$var$_exponent.default)(max) - (0, $c325b6806d21f911$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("75EHI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52989307b09ee6f8$var$log;
module.exports.loggish = $52989307b09ee6f8$var$loggish;

var $xfpL5 = parcelRequire("xfpL5");

var $4JmPq = parcelRequire("4JmPq");

var $52989307b09ee6f8$var$_nice = $52989307b09ee6f8$var$_interopRequireDefault((parcelRequire("hnVQq")));

var $dnDEZ = parcelRequire("dnDEZ");

var $bQI8z = parcelRequire("bQI8z");
function $52989307b09ee6f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52989307b09ee6f8$var$transformLog(x) {
    return Math.log(x);
}
function $52989307b09ee6f8$var$transformExp(x) {
    return Math.exp(x);
}
function $52989307b09ee6f8$var$transformLogn(x) {
    return -Math.log(-x);
}
function $52989307b09ee6f8$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $52989307b09ee6f8$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $52989307b09ee6f8$var$powp(base) {
    return base === 10 ? $52989307b09ee6f8$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $52989307b09ee6f8$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $52989307b09ee6f8$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $52989307b09ee6f8$var$loggish(transform) {
    const scale = transform($52989307b09ee6f8$var$transformLog, $52989307b09ee6f8$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $52989307b09ee6f8$var$logp(base), pows = $52989307b09ee6f8$var$powp(base);
        if (domain()[0] < 0) {
            logs = $52989307b09ee6f8$var$reflect(logs), pows = $52989307b09ee6f8$var$reflect(pows);
            transform($52989307b09ee6f8$var$transformLogn, $52989307b09ee6f8$var$transformExpn);
        } else transform($52989307b09ee6f8$var$transformLog, $52989307b09ee6f8$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $xfpL5.ticks)(u, v, n);
        } else z = (0, $xfpL5.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $4JmPq.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $4JmPq.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $52989307b09ee6f8$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $52989307b09ee6f8$var$log() {
    const scale = $52989307b09ee6f8$var$loggish((0, $dnDEZ.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $dnDEZ.copy)(scale, $52989307b09ee6f8$var$log()).base(scale.base());
    $bQI8z.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("hnVQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca8174610637af3a$var$nice;
function $ca8174610637af3a$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("9Q5Vk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $729d90b7e3581895$var$symlog;
module.exports.symlogish = $729d90b7e3581895$var$symlogish;

var $5bduu = parcelRequire("5bduu");

var $dnDEZ = parcelRequire("dnDEZ");

var $bQI8z = parcelRequire("bQI8z");
function $729d90b7e3581895$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $729d90b7e3581895$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $729d90b7e3581895$var$symlogish(transform) {
    var c = 1, scale = transform($729d90b7e3581895$var$transformSymlog(c), $729d90b7e3581895$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($729d90b7e3581895$var$transformSymlog(c = +_), $729d90b7e3581895$var$transformSymexp(c)) : c;
    };
    return (0, $5bduu.linearish)(scale);
}
function $729d90b7e3581895$var$symlog() {
    var scale = $729d90b7e3581895$var$symlogish((0, $dnDEZ.transformer)());
    scale.copy = function() {
        return (0, $dnDEZ.copy)(scale, $729d90b7e3581895$var$symlog()).constant(scale.constant());
    };
    return $bQI8z.initRange.apply(scale, arguments);
}

});

parcelRegister("kY7x4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f43f4104c101d5ba$var$pow;
module.exports.powish = $f43f4104c101d5ba$var$powish;
module.exports.sqrt = $f43f4104c101d5ba$var$sqrt;

var $5bduu = parcelRequire("5bduu");

var $dnDEZ = parcelRequire("dnDEZ");

var $bQI8z = parcelRequire("bQI8z");
function $f43f4104c101d5ba$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $f43f4104c101d5ba$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $f43f4104c101d5ba$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $f43f4104c101d5ba$var$powish(transform) {
    var scale = transform($dnDEZ.identity, $dnDEZ.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($dnDEZ.identity, $dnDEZ.identity) : exponent === 0.5 ? transform($f43f4104c101d5ba$var$transformSqrt, $f43f4104c101d5ba$var$transformSquare) : transform($f43f4104c101d5ba$var$transformPow(exponent), $f43f4104c101d5ba$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $5bduu.linearish)(scale);
}
function $f43f4104c101d5ba$var$pow() {
    var scale = $f43f4104c101d5ba$var$powish((0, $dnDEZ.transformer)());
    scale.copy = function() {
        return (0, $dnDEZ.copy)(scale, $f43f4104c101d5ba$var$pow()).exponent(scale.exponent());
    };
    $bQI8z.initRange.apply(scale, arguments);
    return scale;
}
function $f43f4104c101d5ba$var$sqrt() {
    return $f43f4104c101d5ba$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("gDSqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1da8187989234fe$var$radial;

var $c1da8187989234fe$var$_continuous = $c1da8187989234fe$var$_interopRequireDefault((parcelRequire("dnDEZ")));

var $bQI8z = parcelRequire("bQI8z");

var $5bduu = parcelRequire("5bduu");

var $c1da8187989234fe$var$_number = $c1da8187989234fe$var$_interopRequireDefault((parcelRequire("5qJvW")));
function $c1da8187989234fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c1da8187989234fe$var$square(x) {
    return Math.sign(x) * x * x;
}
function $c1da8187989234fe$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $c1da8187989234fe$var$radial() {
    var squared = (0, $c1da8187989234fe$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $c1da8187989234fe$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($c1da8187989234fe$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $c1da8187989234fe$var$_number.default)).map($c1da8187989234fe$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c1da8187989234fe$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $bQI8z.initRange.apply(scale, arguments);
    return (0, $5bduu.linearish)(scale);
}

});

parcelRegister("1TA3g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1616e49e6d1933f7$var$quantile;

var $xfpL5 = parcelRequire("xfpL5");

var $bQI8z = parcelRequire("bQI8z");
function $1616e49e6d1933f7$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $xfpL5.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $xfpL5.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($xfpL5.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $1616e49e6d1933f7$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $bQI8z.initRange.apply(scale, arguments);
}

});

parcelRegister("2nKUE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1bc21e9e7636638a$var$quantize;

var $xfpL5 = parcelRequire("xfpL5");

var $5bduu = parcelRequire("5bduu");

var $bQI8z = parcelRequire("bQI8z");
function $1bc21e9e7636638a$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $xfpL5.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $1bc21e9e7636638a$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $bQI8z.initRange.apply((0, $5bduu.linearish)(scale), arguments);
}

});

parcelRegister("khxVo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec3fb5ea417d3732$var$threshold;

var $xfpL5 = parcelRequire("xfpL5");

var $bQI8z = parcelRequire("bQI8z");
function $ec3fb5ea417d3732$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $xfpL5.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $ec3fb5ea417d3732$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $bQI8z.initRange.apply(scale, arguments);
}

});

parcelRegister("hs3Zo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $cb482559203e9143$var$calendar;
module.exports.default = $cb482559203e9143$var$time;

var $ab1Kx = parcelRequire("ab1Kx");

var $5qVAu = parcelRequire("5qVAu");

var $cb482559203e9143$var$_continuous = $cb482559203e9143$var$_interopRequireWildcard((parcelRequire("dnDEZ")));

var $bQI8z = parcelRequire("bQI8z");

var $cb482559203e9143$var$_nice = $cb482559203e9143$var$_interopRequireDefault((parcelRequire("hnVQq")));
function $cb482559203e9143$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb482559203e9143$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cb482559203e9143$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cb482559203e9143$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cb482559203e9143$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cb482559203e9143$var$date(t) {
    return new Date(t);
}
function $cb482559203e9143$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $cb482559203e9143$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $cb482559203e9143$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $cb482559203e9143$var$number)) : domain().map($cb482559203e9143$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $cb482559203e9143$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $cb482559203e9143$var$_continuous.copy)(scale, $cb482559203e9143$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $cb482559203e9143$var$time() {
    return $bQI8z.initRange.apply($cb482559203e9143$var$calendar($ab1Kx.timeTicks, $ab1Kx.timeTickInterval, $ab1Kx.timeYear, $ab1Kx.timeMonth, $ab1Kx.timeWeek, $ab1Kx.timeDay, $ab1Kx.timeHour, $ab1Kx.timeMinute, $ab1Kx.timeSecond, $5qVAu.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("ab1Kx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $8L3hL.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $8L3hL.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $8L3hL.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $8L3hL.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $8L3hL.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $8L3hL.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $8L3hL.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $8L3hL.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $8L3hL.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $8L3hL.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $3V4ZU.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $3V4ZU.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $8L3hL.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $8L3hL.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $8L3hL.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $8L3hL.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $8L3hL.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $8L3hL.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $3V4ZU.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $3V4ZU.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $cDAaB.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $01e97d101fa2a988$var$_utcYear.utcYears;
    }
});

var $01e97d101fa2a988$var$_interval = $01e97d101fa2a988$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $01e97d101fa2a988$var$_millisecond = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("2HCgf")));

var $01e97d101fa2a988$var$_second = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("6GHVI")));

var $01e97d101fa2a988$var$_minute = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("djiOY")));

var $01e97d101fa2a988$var$_hour = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("2LgpC")));

var $01e97d101fa2a988$var$_day = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("bkNcy")));

var $8L3hL = parcelRequire("8L3hL");

var $01e97d101fa2a988$var$_month = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("lXUjZ")));

var $01e97d101fa2a988$var$_year = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("li6Pi")));

var $01e97d101fa2a988$var$_utcMinute = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("2EWTA")));

var $01e97d101fa2a988$var$_utcHour = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("6jY2x")));

var $01e97d101fa2a988$var$_utcDay = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("aps96")));

var $cDAaB = parcelRequire("cDAaB");

var $01e97d101fa2a988$var$_utcMonth = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("5WmNX")));

var $01e97d101fa2a988$var$_utcYear = $01e97d101fa2a988$var$_interopRequireWildcard((parcelRequire("kwPwA")));

var $3V4ZU = parcelRequire("3V4ZU");
function $01e97d101fa2a988$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($01e97d101fa2a988$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $01e97d101fa2a988$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $01e97d101fa2a988$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $01e97d101fa2a988$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("4y1mM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34fb65bf67b5b7f3$var$newInterval;
var $34fb65bf67b5b7f3$var$t0 = new Date(), $34fb65bf67b5b7f3$var$t1 = new Date();
function $34fb65bf67b5b7f3$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $34fb65bf67b5b7f3$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $34fb65bf67b5b7f3$var$t0.setTime(+start), $34fb65bf67b5b7f3$var$t1.setTime(+end);
            floori($34fb65bf67b5b7f3$var$t0), floori($34fb65bf67b5b7f3$var$t1);
            return Math.floor(count($34fb65bf67b5b7f3$var$t0, $34fb65bf67b5b7f3$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("2HCgf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $1f7d46c3332b4735$var$_interval = $1f7d46c3332b4735$var$_interopRequireDefault((parcelRequire("4y1mM")));
function $1f7d46c3332b4735$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1f7d46c3332b4735$var$millisecond = (0, $1f7d46c3332b4735$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$1f7d46c3332b4735$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $1f7d46c3332b4735$var$millisecond;
    return (0, $1f7d46c3332b4735$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $1f7d46c3332b4735$var$_default = $1f7d46c3332b4735$var$millisecond;
module.exports.default = $1f7d46c3332b4735$var$_default;
var $1f7d46c3332b4735$var$milliseconds = $1f7d46c3332b4735$var$millisecond.range;
module.exports.milliseconds = $1f7d46c3332b4735$var$milliseconds;

});

parcelRegister("6GHVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $4de8bde5bdb4d1c3$var$_interval = $4de8bde5bdb4d1c3$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $4de8bde5bdb4d1c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4de8bde5bdb4d1c3$var$second = (0, $4de8bde5bdb4d1c3$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $9wNmm.durationSecond);
}, function(start, end) {
    return (end - start) / $9wNmm.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $4de8bde5bdb4d1c3$var$_default = $4de8bde5bdb4d1c3$var$second;
module.exports.default = $4de8bde5bdb4d1c3$var$_default;
var $4de8bde5bdb4d1c3$var$seconds = $4de8bde5bdb4d1c3$var$second.range;
module.exports.seconds = $4de8bde5bdb4d1c3$var$seconds;

});
parcelRegister("9wNmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $6efd640234179741$var$durationSecond = 1000;
module.exports.durationSecond = $6efd640234179741$var$durationSecond;
const $6efd640234179741$var$durationMinute = $6efd640234179741$var$durationSecond * 60;
module.exports.durationMinute = $6efd640234179741$var$durationMinute;
const $6efd640234179741$var$durationHour = $6efd640234179741$var$durationMinute * 60;
module.exports.durationHour = $6efd640234179741$var$durationHour;
const $6efd640234179741$var$durationDay = $6efd640234179741$var$durationHour * 24;
module.exports.durationDay = $6efd640234179741$var$durationDay;
const $6efd640234179741$var$durationWeek = $6efd640234179741$var$durationDay * 7;
module.exports.durationWeek = $6efd640234179741$var$durationWeek;
const $6efd640234179741$var$durationMonth = $6efd640234179741$var$durationDay * 30;
module.exports.durationMonth = $6efd640234179741$var$durationMonth;
const $6efd640234179741$var$durationYear = $6efd640234179741$var$durationDay * 365;
module.exports.durationYear = $6efd640234179741$var$durationYear;

});


parcelRegister("djiOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $9b0ba637e218a4c7$var$_interval = $9b0ba637e218a4c7$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $9b0ba637e218a4c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9b0ba637e218a4c7$var$minute = (0, $9b0ba637e218a4c7$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $9wNmm.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $9wNmm.durationMinute);
}, function(start, end) {
    return (end - start) / $9wNmm.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $9b0ba637e218a4c7$var$_default = $9b0ba637e218a4c7$var$minute;
module.exports.default = $9b0ba637e218a4c7$var$_default;
var $9b0ba637e218a4c7$var$minutes = $9b0ba637e218a4c7$var$minute.range;
module.exports.minutes = $9b0ba637e218a4c7$var$minutes;

});

parcelRegister("2LgpC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $202cb3a9ee942e30$var$_interval = $202cb3a9ee942e30$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $202cb3a9ee942e30$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $202cb3a9ee942e30$var$hour = (0, $202cb3a9ee942e30$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $9wNmm.durationSecond - date.getMinutes() * $9wNmm.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $9wNmm.durationHour);
}, function(start, end) {
    return (end - start) / $9wNmm.durationHour;
}, function(date) {
    return date.getHours();
});
var $202cb3a9ee942e30$var$_default = $202cb3a9ee942e30$var$hour;
module.exports.default = $202cb3a9ee942e30$var$_default;
var $202cb3a9ee942e30$var$hours = $202cb3a9ee942e30$var$hour.range;
module.exports.hours = $202cb3a9ee942e30$var$hours;

});

parcelRegister("bkNcy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $8407ba6010d2563a$var$_interval = $8407ba6010d2563a$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $8407ba6010d2563a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8407ba6010d2563a$var$day = (0, $8407ba6010d2563a$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $9wNmm.durationMinute) / $9wNmm.durationDay, (date)=>date.getDate() - 1);
var $8407ba6010d2563a$var$_default = $8407ba6010d2563a$var$day;
module.exports.default = $8407ba6010d2563a$var$_default;
var $8407ba6010d2563a$var$days = $8407ba6010d2563a$var$day.range;
module.exports.days = $8407ba6010d2563a$var$days;

});

parcelRegister("8L3hL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $660542f832af633f$var$_interval = $660542f832af633f$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $660542f832af633f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $660542f832af633f$var$weekday(i) {
    return (0, $660542f832af633f$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $9wNmm.durationMinute) / $9wNmm.durationWeek;
    });
}
var $660542f832af633f$var$sunday = $660542f832af633f$var$weekday(0);
module.exports.sunday = $660542f832af633f$var$sunday;
var $660542f832af633f$var$monday = $660542f832af633f$var$weekday(1);
module.exports.monday = $660542f832af633f$var$monday;
var $660542f832af633f$var$tuesday = $660542f832af633f$var$weekday(2);
module.exports.tuesday = $660542f832af633f$var$tuesday;
var $660542f832af633f$var$wednesday = $660542f832af633f$var$weekday(3);
module.exports.wednesday = $660542f832af633f$var$wednesday;
var $660542f832af633f$var$thursday = $660542f832af633f$var$weekday(4);
module.exports.thursday = $660542f832af633f$var$thursday;
var $660542f832af633f$var$friday = $660542f832af633f$var$weekday(5);
module.exports.friday = $660542f832af633f$var$friday;
var $660542f832af633f$var$saturday = $660542f832af633f$var$weekday(6);
module.exports.saturday = $660542f832af633f$var$saturday;
var $660542f832af633f$var$sundays = $660542f832af633f$var$sunday.range;
module.exports.sundays = $660542f832af633f$var$sundays;
var $660542f832af633f$var$mondays = $660542f832af633f$var$monday.range;
module.exports.mondays = $660542f832af633f$var$mondays;
var $660542f832af633f$var$tuesdays = $660542f832af633f$var$tuesday.range;
module.exports.tuesdays = $660542f832af633f$var$tuesdays;
var $660542f832af633f$var$wednesdays = $660542f832af633f$var$wednesday.range;
module.exports.wednesdays = $660542f832af633f$var$wednesdays;
var $660542f832af633f$var$thursdays = $660542f832af633f$var$thursday.range;
module.exports.thursdays = $660542f832af633f$var$thursdays;
var $660542f832af633f$var$fridays = $660542f832af633f$var$friday.range;
module.exports.fridays = $660542f832af633f$var$fridays;
var $660542f832af633f$var$saturdays = $660542f832af633f$var$saturday.range;
module.exports.saturdays = $660542f832af633f$var$saturdays;

});

parcelRegister("lXUjZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $ffdacbea7b863147$var$_interval = $ffdacbea7b863147$var$_interopRequireDefault((parcelRequire("4y1mM")));
function $ffdacbea7b863147$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ffdacbea7b863147$var$month = (0, $ffdacbea7b863147$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $ffdacbea7b863147$var$_default = $ffdacbea7b863147$var$month;
module.exports.default = $ffdacbea7b863147$var$_default;
var $ffdacbea7b863147$var$months = $ffdacbea7b863147$var$month.range;
module.exports.months = $ffdacbea7b863147$var$months;

});

parcelRegister("li6Pi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $f80092f92cd1f3b2$var$_interval = $f80092f92cd1f3b2$var$_interopRequireDefault((parcelRequire("4y1mM")));
function $f80092f92cd1f3b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f80092f92cd1f3b2$var$year = (0, $f80092f92cd1f3b2$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$f80092f92cd1f3b2$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f80092f92cd1f3b2$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $f80092f92cd1f3b2$var$_default = $f80092f92cd1f3b2$var$year;
module.exports.default = $f80092f92cd1f3b2$var$_default;
var $f80092f92cd1f3b2$var$years = $f80092f92cd1f3b2$var$year.range;
module.exports.years = $f80092f92cd1f3b2$var$years;

});

parcelRegister("2EWTA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $1efd00a2a92567c2$var$_interval = $1efd00a2a92567c2$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $1efd00a2a92567c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1efd00a2a92567c2$var$utcMinute = (0, $1efd00a2a92567c2$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $9wNmm.durationMinute);
}, function(start, end) {
    return (end - start) / $9wNmm.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $1efd00a2a92567c2$var$_default = $1efd00a2a92567c2$var$utcMinute;
module.exports.default = $1efd00a2a92567c2$var$_default;
var $1efd00a2a92567c2$var$utcMinutes = $1efd00a2a92567c2$var$utcMinute.range;
module.exports.utcMinutes = $1efd00a2a92567c2$var$utcMinutes;

});

parcelRegister("6jY2x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $49a3171affb1043c$var$_interval = $49a3171affb1043c$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $49a3171affb1043c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $49a3171affb1043c$var$utcHour = (0, $49a3171affb1043c$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $9wNmm.durationHour);
}, function(start, end) {
    return (end - start) / $9wNmm.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $49a3171affb1043c$var$_default = $49a3171affb1043c$var$utcHour;
module.exports.default = $49a3171affb1043c$var$_default;
var $49a3171affb1043c$var$utcHours = $49a3171affb1043c$var$utcHour.range;
module.exports.utcHours = $49a3171affb1043c$var$utcHours;

});

parcelRegister("aps96", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $79421258fe07a332$var$_interval = $79421258fe07a332$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $79421258fe07a332$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $79421258fe07a332$var$utcDay = (0, $79421258fe07a332$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $9wNmm.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $79421258fe07a332$var$_default = $79421258fe07a332$var$utcDay;
module.exports.default = $79421258fe07a332$var$_default;
var $79421258fe07a332$var$utcDays = $79421258fe07a332$var$utcDay.range;
module.exports.utcDays = $79421258fe07a332$var$utcDays;

});

parcelRegister("cDAaB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $93352f295b1ed985$var$_interval = $93352f295b1ed985$var$_interopRequireDefault((parcelRequire("4y1mM")));

var $9wNmm = parcelRequire("9wNmm");
function $93352f295b1ed985$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $93352f295b1ed985$var$utcWeekday(i) {
    return (0, $93352f295b1ed985$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $9wNmm.durationWeek;
    });
}
var $93352f295b1ed985$var$utcSunday = $93352f295b1ed985$var$utcWeekday(0);
module.exports.utcSunday = $93352f295b1ed985$var$utcSunday;
var $93352f295b1ed985$var$utcMonday = $93352f295b1ed985$var$utcWeekday(1);
module.exports.utcMonday = $93352f295b1ed985$var$utcMonday;
var $93352f295b1ed985$var$utcTuesday = $93352f295b1ed985$var$utcWeekday(2);
module.exports.utcTuesday = $93352f295b1ed985$var$utcTuesday;
var $93352f295b1ed985$var$utcWednesday = $93352f295b1ed985$var$utcWeekday(3);
module.exports.utcWednesday = $93352f295b1ed985$var$utcWednesday;
var $93352f295b1ed985$var$utcThursday = $93352f295b1ed985$var$utcWeekday(4);
module.exports.utcThursday = $93352f295b1ed985$var$utcThursday;
var $93352f295b1ed985$var$utcFriday = $93352f295b1ed985$var$utcWeekday(5);
module.exports.utcFriday = $93352f295b1ed985$var$utcFriday;
var $93352f295b1ed985$var$utcSaturday = $93352f295b1ed985$var$utcWeekday(6);
module.exports.utcSaturday = $93352f295b1ed985$var$utcSaturday;
var $93352f295b1ed985$var$utcSundays = $93352f295b1ed985$var$utcSunday.range;
module.exports.utcSundays = $93352f295b1ed985$var$utcSundays;
var $93352f295b1ed985$var$utcMondays = $93352f295b1ed985$var$utcMonday.range;
module.exports.utcMondays = $93352f295b1ed985$var$utcMondays;
var $93352f295b1ed985$var$utcTuesdays = $93352f295b1ed985$var$utcTuesday.range;
module.exports.utcTuesdays = $93352f295b1ed985$var$utcTuesdays;
var $93352f295b1ed985$var$utcWednesdays = $93352f295b1ed985$var$utcWednesday.range;
module.exports.utcWednesdays = $93352f295b1ed985$var$utcWednesdays;
var $93352f295b1ed985$var$utcThursdays = $93352f295b1ed985$var$utcThursday.range;
module.exports.utcThursdays = $93352f295b1ed985$var$utcThursdays;
var $93352f295b1ed985$var$utcFridays = $93352f295b1ed985$var$utcFriday.range;
module.exports.utcFridays = $93352f295b1ed985$var$utcFridays;
var $93352f295b1ed985$var$utcSaturdays = $93352f295b1ed985$var$utcSaturday.range;
module.exports.utcSaturdays = $93352f295b1ed985$var$utcSaturdays;

});

parcelRegister("5WmNX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $45340f1842f28fcd$var$_interval = $45340f1842f28fcd$var$_interopRequireDefault((parcelRequire("4y1mM")));
function $45340f1842f28fcd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $45340f1842f28fcd$var$utcMonth = (0, $45340f1842f28fcd$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $45340f1842f28fcd$var$_default = $45340f1842f28fcd$var$utcMonth;
module.exports.default = $45340f1842f28fcd$var$_default;
var $45340f1842f28fcd$var$utcMonths = $45340f1842f28fcd$var$utcMonth.range;
module.exports.utcMonths = $45340f1842f28fcd$var$utcMonths;

});

parcelRegister("kwPwA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $ef1ec38290535f76$var$_interval = $ef1ec38290535f76$var$_interopRequireDefault((parcelRequire("4y1mM")));
function $ef1ec38290535f76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ef1ec38290535f76$var$utcYear = (0, $ef1ec38290535f76$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$ef1ec38290535f76$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ef1ec38290535f76$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $ef1ec38290535f76$var$_default = $ef1ec38290535f76$var$utcYear;
module.exports.default = $ef1ec38290535f76$var$_default;
var $ef1ec38290535f76$var$utcYears = $ef1ec38290535f76$var$utcYear.range;
module.exports.utcYears = $ef1ec38290535f76$var$utcYears;

});

parcelRegister("3V4ZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $xfpL5 = parcelRequire("xfpL5");

var $9wNmm = parcelRequire("9wNmm");

var $2daa92635b9e13e4$var$_millisecond = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("2HCgf")));

var $2daa92635b9e13e4$var$_second = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("6GHVI")));

var $2daa92635b9e13e4$var$_minute = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("djiOY")));

var $2daa92635b9e13e4$var$_hour = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("2LgpC")));

var $2daa92635b9e13e4$var$_day = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("bkNcy")));

var $8L3hL = parcelRequire("8L3hL");

var $2daa92635b9e13e4$var$_month = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("lXUjZ")));

var $2daa92635b9e13e4$var$_year = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("li6Pi")));

var $2daa92635b9e13e4$var$_utcMinute = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("2EWTA")));

var $2daa92635b9e13e4$var$_utcHour = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("6jY2x")));

var $2daa92635b9e13e4$var$_utcDay = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("aps96")));

var $cDAaB = parcelRequire("cDAaB");

var $2daa92635b9e13e4$var$_utcMonth = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("5WmNX")));

var $2daa92635b9e13e4$var$_utcYear = $2daa92635b9e13e4$var$_interopRequireDefault((parcelRequire("kwPwA")));
function $2daa92635b9e13e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2daa92635b9e13e4$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $2daa92635b9e13e4$var$_second.default,
            1,
            $9wNmm.durationSecond
        ],
        [
            $2daa92635b9e13e4$var$_second.default,
            5,
            5 * $9wNmm.durationSecond
        ],
        [
            $2daa92635b9e13e4$var$_second.default,
            15,
            15 * $9wNmm.durationSecond
        ],
        [
            $2daa92635b9e13e4$var$_second.default,
            30,
            30 * $9wNmm.durationSecond
        ],
        [
            minute,
            1,
            $9wNmm.durationMinute
        ],
        [
            minute,
            5,
            5 * $9wNmm.durationMinute
        ],
        [
            minute,
            15,
            15 * $9wNmm.durationMinute
        ],
        [
            minute,
            30,
            30 * $9wNmm.durationMinute
        ],
        [
            hour,
            1,
            $9wNmm.durationHour
        ],
        [
            hour,
            3,
            3 * $9wNmm.durationHour
        ],
        [
            hour,
            6,
            6 * $9wNmm.durationHour
        ],
        [
            hour,
            12,
            12 * $9wNmm.durationHour
        ],
        [
            day,
            1,
            $9wNmm.durationDay
        ],
        [
            day,
            2,
            2 * $9wNmm.durationDay
        ],
        [
            week,
            1,
            $9wNmm.durationWeek
        ],
        [
            month,
            1,
            $9wNmm.durationMonth
        ],
        [
            month,
            3,
            3 * $9wNmm.durationMonth
        ],
        [
            year,
            1,
            $9wNmm.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $xfpL5.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $xfpL5.tickStep)(start / $9wNmm.durationYear, stop / $9wNmm.durationYear, count));
        if (i === 0) return $2daa92635b9e13e4$var$_millisecond.default.every(Math.max((0, $xfpL5.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$2daa92635b9e13e4$var$utcTicks, $2daa92635b9e13e4$var$utcTickInterval] = $2daa92635b9e13e4$var$ticker($2daa92635b9e13e4$var$_utcYear.default, $2daa92635b9e13e4$var$_utcMonth.default, $cDAaB.utcSunday, $2daa92635b9e13e4$var$_utcDay.default, $2daa92635b9e13e4$var$_utcHour.default, $2daa92635b9e13e4$var$_utcMinute.default);
module.exports.utcTickInterval = $2daa92635b9e13e4$var$utcTickInterval;
module.exports.utcTicks = $2daa92635b9e13e4$var$utcTicks;
const [$2daa92635b9e13e4$var$timeTicks, $2daa92635b9e13e4$var$timeTickInterval] = $2daa92635b9e13e4$var$ticker($2daa92635b9e13e4$var$_year.default, $2daa92635b9e13e4$var$_month.default, $8L3hL.sunday, $2daa92635b9e13e4$var$_day.default, $2daa92635b9e13e4$var$_hour.default, $2daa92635b9e13e4$var$_minute.default);
module.exports.timeTickInterval = $2daa92635b9e13e4$var$timeTickInterval;
module.exports.timeTicks = $2daa92635b9e13e4$var$timeTicks;

});


parcelRegister("5qVAu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $3f4c0d2065723a26$var$_defaultLocale.utcParse;
    }
});

var $3f4c0d2065723a26$var$_defaultLocale = $3f4c0d2065723a26$var$_interopRequireWildcard((parcelRequire("e45zi")));

var $3f4c0d2065723a26$var$_locale = $3f4c0d2065723a26$var$_interopRequireDefault((parcelRequire("5nN2R")));

var $3f4c0d2065723a26$var$_isoFormat = $3f4c0d2065723a26$var$_interopRequireDefault((parcelRequire("gWyRV")));

var $3f4c0d2065723a26$var$_isoParse = $3f4c0d2065723a26$var$_interopRequireDefault((parcelRequire("7ohSX")));
function $3f4c0d2065723a26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f4c0d2065723a26$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3f4c0d2065723a26$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3f4c0d2065723a26$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3f4c0d2065723a26$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("e45zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3d5c226c053ac1a$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $a3d5c226c053ac1a$var$_locale = $a3d5c226c053ac1a$var$_interopRequireDefault((parcelRequire("5nN2R")));
function $a3d5c226c053ac1a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a3d5c226c053ac1a$var$locale;
var $a3d5c226c053ac1a$var$timeFormat;
module.exports.timeFormat = $a3d5c226c053ac1a$var$timeFormat;
var $a3d5c226c053ac1a$var$timeParse;
module.exports.timeParse = $a3d5c226c053ac1a$var$timeParse;
var $a3d5c226c053ac1a$var$utcFormat;
module.exports.utcFormat = $a3d5c226c053ac1a$var$utcFormat;
var $a3d5c226c053ac1a$var$utcParse;
module.exports.utcParse = $a3d5c226c053ac1a$var$utcParse;
$a3d5c226c053ac1a$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $a3d5c226c053ac1a$var$defaultLocale(definition) {
    $a3d5c226c053ac1a$var$locale = (0, $a3d5c226c053ac1a$var$_locale.default)(definition);
    module.exports.timeFormat = $a3d5c226c053ac1a$var$timeFormat = $a3d5c226c053ac1a$var$locale.format;
    module.exports.timeParse = $a3d5c226c053ac1a$var$timeParse = $a3d5c226c053ac1a$var$locale.parse;
    module.exports.utcFormat = $a3d5c226c053ac1a$var$utcFormat = $a3d5c226c053ac1a$var$locale.utcFormat;
    module.exports.utcParse = $a3d5c226c053ac1a$var$utcParse = $a3d5c226c053ac1a$var$locale.utcParse;
    return $a3d5c226c053ac1a$var$locale;
}

});
parcelRegister("5nN2R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3eb52519921d4df9$var$formatLocale;

var $ab1Kx = parcelRequire("ab1Kx");
function $3eb52519921d4df9$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $3eb52519921d4df9$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $3eb52519921d4df9$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $3eb52519921d4df9$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $3eb52519921d4df9$var$formatRe(locale_periods), periodLookup = $3eb52519921d4df9$var$formatLookup(locale_periods), weekdayRe = $3eb52519921d4df9$var$formatRe(locale_weekdays), weekdayLookup = $3eb52519921d4df9$var$formatLookup(locale_weekdays), shortWeekdayRe = $3eb52519921d4df9$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $3eb52519921d4df9$var$formatLookup(locale_shortWeekdays), monthRe = $3eb52519921d4df9$var$formatRe(locale_months), monthLookup = $3eb52519921d4df9$var$formatLookup(locale_months), shortMonthRe = $3eb52519921d4df9$var$formatRe(locale_shortMonths), shortMonthLookup = $3eb52519921d4df9$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $3eb52519921d4df9$var$formatDayOfMonth,
        "e": $3eb52519921d4df9$var$formatDayOfMonth,
        "f": $3eb52519921d4df9$var$formatMicroseconds,
        "g": $3eb52519921d4df9$var$formatYearISO,
        "G": $3eb52519921d4df9$var$formatFullYearISO,
        "H": $3eb52519921d4df9$var$formatHour24,
        "I": $3eb52519921d4df9$var$formatHour12,
        "j": $3eb52519921d4df9$var$formatDayOfYear,
        "L": $3eb52519921d4df9$var$formatMilliseconds,
        "m": $3eb52519921d4df9$var$formatMonthNumber,
        "M": $3eb52519921d4df9$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $3eb52519921d4df9$var$formatUnixTimestamp,
        "s": $3eb52519921d4df9$var$formatUnixTimestampSeconds,
        "S": $3eb52519921d4df9$var$formatSeconds,
        "u": $3eb52519921d4df9$var$formatWeekdayNumberMonday,
        "U": $3eb52519921d4df9$var$formatWeekNumberSunday,
        "V": $3eb52519921d4df9$var$formatWeekNumberISO,
        "w": $3eb52519921d4df9$var$formatWeekdayNumberSunday,
        "W": $3eb52519921d4df9$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $3eb52519921d4df9$var$formatYear,
        "Y": $3eb52519921d4df9$var$formatFullYear,
        "Z": $3eb52519921d4df9$var$formatZone,
        "%": $3eb52519921d4df9$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $3eb52519921d4df9$var$formatUTCDayOfMonth,
        "e": $3eb52519921d4df9$var$formatUTCDayOfMonth,
        "f": $3eb52519921d4df9$var$formatUTCMicroseconds,
        "g": $3eb52519921d4df9$var$formatUTCYearISO,
        "G": $3eb52519921d4df9$var$formatUTCFullYearISO,
        "H": $3eb52519921d4df9$var$formatUTCHour24,
        "I": $3eb52519921d4df9$var$formatUTCHour12,
        "j": $3eb52519921d4df9$var$formatUTCDayOfYear,
        "L": $3eb52519921d4df9$var$formatUTCMilliseconds,
        "m": $3eb52519921d4df9$var$formatUTCMonthNumber,
        "M": $3eb52519921d4df9$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $3eb52519921d4df9$var$formatUnixTimestamp,
        "s": $3eb52519921d4df9$var$formatUnixTimestampSeconds,
        "S": $3eb52519921d4df9$var$formatUTCSeconds,
        "u": $3eb52519921d4df9$var$formatUTCWeekdayNumberMonday,
        "U": $3eb52519921d4df9$var$formatUTCWeekNumberSunday,
        "V": $3eb52519921d4df9$var$formatUTCWeekNumberISO,
        "w": $3eb52519921d4df9$var$formatUTCWeekdayNumberSunday,
        "W": $3eb52519921d4df9$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $3eb52519921d4df9$var$formatUTCYear,
        "Y": $3eb52519921d4df9$var$formatUTCFullYear,
        "Z": $3eb52519921d4df9$var$formatUTCZone,
        "%": $3eb52519921d4df9$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $3eb52519921d4df9$var$parseDayOfMonth,
        "e": $3eb52519921d4df9$var$parseDayOfMonth,
        "f": $3eb52519921d4df9$var$parseMicroseconds,
        "g": $3eb52519921d4df9$var$parseYear,
        "G": $3eb52519921d4df9$var$parseFullYear,
        "H": $3eb52519921d4df9$var$parseHour24,
        "I": $3eb52519921d4df9$var$parseHour24,
        "j": $3eb52519921d4df9$var$parseDayOfYear,
        "L": $3eb52519921d4df9$var$parseMilliseconds,
        "m": $3eb52519921d4df9$var$parseMonthNumber,
        "M": $3eb52519921d4df9$var$parseMinutes,
        "p": parsePeriod,
        "q": $3eb52519921d4df9$var$parseQuarter,
        "Q": $3eb52519921d4df9$var$parseUnixTimestamp,
        "s": $3eb52519921d4df9$var$parseUnixTimestampSeconds,
        "S": $3eb52519921d4df9$var$parseSeconds,
        "u": $3eb52519921d4df9$var$parseWeekdayNumberMonday,
        "U": $3eb52519921d4df9$var$parseWeekNumberSunday,
        "V": $3eb52519921d4df9$var$parseWeekNumberISO,
        "w": $3eb52519921d4df9$var$parseWeekdayNumberSunday,
        "W": $3eb52519921d4df9$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $3eb52519921d4df9$var$parseYear,
        "Y": $3eb52519921d4df9$var$parseFullYear,
        "Z": $3eb52519921d4df9$var$parseZone,
        "%": $3eb52519921d4df9$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $3eb52519921d4df9$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $3eb52519921d4df9$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $3eb52519921d4df9$var$utcDate($3eb52519921d4df9$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $ab1Kx.utcMonday.ceil(week) : (0, $ab1Kx.utcMonday)(week);
                    week = $ab1Kx.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $3eb52519921d4df9$var$localDate($3eb52519921d4df9$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $ab1Kx.timeMonday.ceil(week) : (0, $ab1Kx.timeMonday)(week);
                    week = $ab1Kx.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $3eb52519921d4df9$var$utcDate($3eb52519921d4df9$var$newDate(d.y, 0, 1)).getUTCDay() : $3eb52519921d4df9$var$localDate($3eb52519921d4df9$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $3eb52519921d4df9$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $3eb52519921d4df9$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $3eb52519921d4df9$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $3eb52519921d4df9$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $3eb52519921d4df9$var$numberRe = /^\s*\d+/, // note: ignores next directive
$3eb52519921d4df9$var$percentRe = /^%/, $3eb52519921d4df9$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $3eb52519921d4df9$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $3eb52519921d4df9$var$requote(s) {
    return s.replace($3eb52519921d4df9$var$requoteRe, "\\$&");
}
function $3eb52519921d4df9$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($3eb52519921d4df9$var$requote).join("|") + ")", "i");
}
function $3eb52519921d4df9$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $3eb52519921d4df9$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseWeekNumberSunday(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseWeekNumberISO(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseWeekNumberMonday(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseFullYear(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseYear(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseQuarter(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseMonthNumber(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseDayOfMonth(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseDayOfYear(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseHour24(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseMinutes(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseSeconds(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseMilliseconds(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseMicroseconds(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseLiteralPercent(d, string, i) {
    var n = $3eb52519921d4df9$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $3eb52519921d4df9$var$parseUnixTimestamp(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $3eb52519921d4df9$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $3eb52519921d4df9$var$formatDayOfMonth(d, p) {
    return $3eb52519921d4df9$var$pad(d.getDate(), p, 2);
}
function $3eb52519921d4df9$var$formatHour24(d, p) {
    return $3eb52519921d4df9$var$pad(d.getHours(), p, 2);
}
function $3eb52519921d4df9$var$formatHour12(d, p) {
    return $3eb52519921d4df9$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $3eb52519921d4df9$var$formatDayOfYear(d, p) {
    return $3eb52519921d4df9$var$pad(1 + $ab1Kx.timeDay.count((0, $ab1Kx.timeYear)(d), d), p, 3);
}
function $3eb52519921d4df9$var$formatMilliseconds(d, p) {
    return $3eb52519921d4df9$var$pad(d.getMilliseconds(), p, 3);
}
function $3eb52519921d4df9$var$formatMicroseconds(d, p) {
    return $3eb52519921d4df9$var$formatMilliseconds(d, p) + "000";
}
function $3eb52519921d4df9$var$formatMonthNumber(d, p) {
    return $3eb52519921d4df9$var$pad(d.getMonth() + 1, p, 2);
}
function $3eb52519921d4df9$var$formatMinutes(d, p) {
    return $3eb52519921d4df9$var$pad(d.getMinutes(), p, 2);
}
function $3eb52519921d4df9$var$formatSeconds(d, p) {
    return $3eb52519921d4df9$var$pad(d.getSeconds(), p, 2);
}
function $3eb52519921d4df9$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $3eb52519921d4df9$var$formatWeekNumberSunday(d, p) {
    return $3eb52519921d4df9$var$pad($ab1Kx.timeSunday.count((0, $ab1Kx.timeYear)(d) - 1, d), p, 2);
}
function $3eb52519921d4df9$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $ab1Kx.timeThursday)(d) : $ab1Kx.timeThursday.ceil(d);
}
function $3eb52519921d4df9$var$formatWeekNumberISO(d, p) {
    d = $3eb52519921d4df9$var$dISO(d);
    return $3eb52519921d4df9$var$pad($ab1Kx.timeThursday.count((0, $ab1Kx.timeYear)(d), d) + ((0, $ab1Kx.timeYear)(d).getDay() === 4), p, 2);
}
function $3eb52519921d4df9$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $3eb52519921d4df9$var$formatWeekNumberMonday(d, p) {
    return $3eb52519921d4df9$var$pad($ab1Kx.timeMonday.count((0, $ab1Kx.timeYear)(d) - 1, d), p, 2);
}
function $3eb52519921d4df9$var$formatYear(d, p) {
    return $3eb52519921d4df9$var$pad(d.getFullYear() % 100, p, 2);
}
function $3eb52519921d4df9$var$formatYearISO(d, p) {
    d = $3eb52519921d4df9$var$dISO(d);
    return $3eb52519921d4df9$var$pad(d.getFullYear() % 100, p, 2);
}
function $3eb52519921d4df9$var$formatFullYear(d, p) {
    return $3eb52519921d4df9$var$pad(d.getFullYear() % 10000, p, 4);
}
function $3eb52519921d4df9$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $ab1Kx.timeThursday)(d) : $ab1Kx.timeThursday.ceil(d);
    return $3eb52519921d4df9$var$pad(d.getFullYear() % 10000, p, 4);
}
function $3eb52519921d4df9$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $3eb52519921d4df9$var$pad(z / 60 | 0, "0", 2) + $3eb52519921d4df9$var$pad(z % 60, "0", 2);
}
function $3eb52519921d4df9$var$formatUTCDayOfMonth(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCDate(), p, 2);
}
function $3eb52519921d4df9$var$formatUTCHour24(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCHours(), p, 2);
}
function $3eb52519921d4df9$var$formatUTCHour12(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $3eb52519921d4df9$var$formatUTCDayOfYear(d, p) {
    return $3eb52519921d4df9$var$pad(1 + $ab1Kx.utcDay.count((0, $ab1Kx.utcYear)(d), d), p, 3);
}
function $3eb52519921d4df9$var$formatUTCMilliseconds(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $3eb52519921d4df9$var$formatUTCMicroseconds(d, p) {
    return $3eb52519921d4df9$var$formatUTCMilliseconds(d, p) + "000";
}
function $3eb52519921d4df9$var$formatUTCMonthNumber(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $3eb52519921d4df9$var$formatUTCMinutes(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCMinutes(), p, 2);
}
function $3eb52519921d4df9$var$formatUTCSeconds(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCSeconds(), p, 2);
}
function $3eb52519921d4df9$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $3eb52519921d4df9$var$formatUTCWeekNumberSunday(d, p) {
    return $3eb52519921d4df9$var$pad($ab1Kx.utcSunday.count((0, $ab1Kx.utcYear)(d) - 1, d), p, 2);
}
function $3eb52519921d4df9$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $ab1Kx.utcThursday)(d) : $ab1Kx.utcThursday.ceil(d);
}
function $3eb52519921d4df9$var$formatUTCWeekNumberISO(d, p) {
    d = $3eb52519921d4df9$var$UTCdISO(d);
    return $3eb52519921d4df9$var$pad($ab1Kx.utcThursday.count((0, $ab1Kx.utcYear)(d), d) + ((0, $ab1Kx.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $3eb52519921d4df9$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $3eb52519921d4df9$var$formatUTCWeekNumberMonday(d, p) {
    return $3eb52519921d4df9$var$pad($ab1Kx.utcMonday.count((0, $ab1Kx.utcYear)(d) - 1, d), p, 2);
}
function $3eb52519921d4df9$var$formatUTCYear(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $3eb52519921d4df9$var$formatUTCYearISO(d, p) {
    d = $3eb52519921d4df9$var$UTCdISO(d);
    return $3eb52519921d4df9$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $3eb52519921d4df9$var$formatUTCFullYear(d, p) {
    return $3eb52519921d4df9$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $3eb52519921d4df9$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $ab1Kx.utcThursday)(d) : $ab1Kx.utcThursday.ceil(d);
    return $3eb52519921d4df9$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $3eb52519921d4df9$var$formatUTCZone() {
    return "+0000";
}
function $3eb52519921d4df9$var$formatLiteralPercent() {
    return "%";
}
function $3eb52519921d4df9$var$formatUnixTimestamp(d) {
    return +d;
}
function $3eb52519921d4df9$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("gWyRV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $e45zi = parcelRequire("e45zi");
var $c55d1c526b15c519$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $c55d1c526b15c519$var$isoSpecifier;
function $c55d1c526b15c519$var$formatIsoNative(date) {
    return date.toISOString();
}
var $c55d1c526b15c519$var$formatIso = Date.prototype.toISOString ? $c55d1c526b15c519$var$formatIsoNative : (0, $e45zi.utcFormat)($c55d1c526b15c519$var$isoSpecifier);
var $c55d1c526b15c519$var$_default = $c55d1c526b15c519$var$formatIso;
module.exports.default = $c55d1c526b15c519$var$_default;

});

parcelRegister("7ohSX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $gWyRV = parcelRequire("gWyRV");

var $e45zi = parcelRequire("e45zi");
function $5618a5fc8526805f$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $5618a5fc8526805f$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $5618a5fc8526805f$var$parseIsoNative : (0, $e45zi.utcParse)($gWyRV.isoSpecifier);
var $5618a5fc8526805f$var$_default = $5618a5fc8526805f$var$parseIso;
module.exports.default = $5618a5fc8526805f$var$_default;

});



parcelRegister("6pUGr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ac10c0f466a50dd$var$utcTime;

var $ab1Kx = parcelRequire("ab1Kx");

var $5qVAu = parcelRequire("5qVAu");

var $hs3Zo = parcelRequire("hs3Zo");

var $bQI8z = parcelRequire("bQI8z");
function $4ac10c0f466a50dd$var$utcTime() {
    return $bQI8z.initRange.apply((0, $hs3Zo.calendar)($ab1Kx.utcTicks, $ab1Kx.utcTickInterval, $ab1Kx.utcYear, $ab1Kx.utcMonth, $ab1Kx.utcWeek, $ab1Kx.utcDay, $ab1Kx.utcHour, $ab1Kx.utcMinute, $ab1Kx.utcSecond, $5qVAu.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("7TO5p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $5c048590f8b3f883$var$copy;
module.exports.default = $5c048590f8b3f883$var$sequential;
module.exports.sequentialLog = $5c048590f8b3f883$var$sequentialLog;
module.exports.sequentialPow = $5c048590f8b3f883$var$sequentialPow;
module.exports.sequentialSqrt = $5c048590f8b3f883$var$sequentialSqrt;
module.exports.sequentialSymlog = $5c048590f8b3f883$var$sequentialSymlog;

var $eBA7s = parcelRequire("eBA7s");

var $dnDEZ = parcelRequire("dnDEZ");

var $bQI8z = parcelRequire("bQI8z");

var $5bduu = parcelRequire("5bduu");

var $75EHI = parcelRequire("75EHI");

var $9Q5Vk = parcelRequire("9Q5Vk");

var $kY7x4 = parcelRequire("kY7x4");
function $5c048590f8b3f883$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $dnDEZ.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($eBA7s.interpolate);
    scale.rangeRound = range($eBA7s.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $5c048590f8b3f883$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $5c048590f8b3f883$var$sequential() {
    var scale = (0, $5bduu.linearish)($5c048590f8b3f883$var$transformer()($dnDEZ.identity));
    scale.copy = function() {
        return $5c048590f8b3f883$var$copy(scale, $5c048590f8b3f883$var$sequential());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5c048590f8b3f883$var$sequentialLog() {
    var scale = (0, $75EHI.loggish)($5c048590f8b3f883$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $5c048590f8b3f883$var$copy(scale, $5c048590f8b3f883$var$sequentialLog()).base(scale.base());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5c048590f8b3f883$var$sequentialSymlog() {
    var scale = (0, $9Q5Vk.symlogish)($5c048590f8b3f883$var$transformer());
    scale.copy = function() {
        return $5c048590f8b3f883$var$copy(scale, $5c048590f8b3f883$var$sequentialSymlog()).constant(scale.constant());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5c048590f8b3f883$var$sequentialPow() {
    var scale = (0, $kY7x4.powish)($5c048590f8b3f883$var$transformer());
    scale.copy = function() {
        return $5c048590f8b3f883$var$copy(scale, $5c048590f8b3f883$var$sequentialPow()).exponent(scale.exponent());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5c048590f8b3f883$var$sequentialSqrt() {
    return $5c048590f8b3f883$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("lnjXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8fb3bd258bf7f73$var$sequentialQuantile;

var $xfpL5 = parcelRequire("xfpL5");

var $dnDEZ = parcelRequire("dnDEZ");

var $bQI8z = parcelRequire("bQI8z");
function $f8fb3bd258bf7f73$var$sequentialQuantile() {
    var domain = [], interpolator = $dnDEZ.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $xfpL5.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($xfpL5.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $xfpL5.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $f8fb3bd258bf7f73$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("7ku9P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5561cb54aec6d4b5$var$diverging;
module.exports.divergingLog = $5561cb54aec6d4b5$var$divergingLog;
module.exports.divergingPow = $5561cb54aec6d4b5$var$divergingPow;
module.exports.divergingSqrt = $5561cb54aec6d4b5$var$divergingSqrt;
module.exports.divergingSymlog = $5561cb54aec6d4b5$var$divergingSymlog;

var $eBA7s = parcelRequire("eBA7s");

var $dnDEZ = parcelRequire("dnDEZ");

var $bQI8z = parcelRequire("bQI8z");

var $5bduu = parcelRequire("5bduu");

var $75EHI = parcelRequire("75EHI");

var $7TO5p = parcelRequire("7TO5p");

var $9Q5Vk = parcelRequire("9Q5Vk");

var $kY7x4 = parcelRequire("kY7x4");
function $5561cb54aec6d4b5$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $dnDEZ.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $eBA7s.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($eBA7s.interpolate);
    scale.rangeRound = range($eBA7s.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $5561cb54aec6d4b5$var$diverging() {
    var scale = (0, $5bduu.linearish)($5561cb54aec6d4b5$var$transformer()($dnDEZ.identity));
    scale.copy = function() {
        return (0, $7TO5p.copy)(scale, $5561cb54aec6d4b5$var$diverging());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5561cb54aec6d4b5$var$divergingLog() {
    var scale = (0, $75EHI.loggish)($5561cb54aec6d4b5$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $7TO5p.copy)(scale, $5561cb54aec6d4b5$var$divergingLog()).base(scale.base());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5561cb54aec6d4b5$var$divergingSymlog() {
    var scale = (0, $9Q5Vk.symlogish)($5561cb54aec6d4b5$var$transformer());
    scale.copy = function() {
        return (0, $7TO5p.copy)(scale, $5561cb54aec6d4b5$var$divergingSymlog()).constant(scale.constant());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5561cb54aec6d4b5$var$divergingPow() {
    var scale = (0, $kY7x4.powish)($5561cb54aec6d4b5$var$transformer());
    scale.copy = function() {
        return (0, $7TO5p.copy)(scale, $5561cb54aec6d4b5$var$divergingPow()).exponent(scale.exponent());
    };
    return $bQI8z.initInterpolator.apply(scale, arguments);
}
function $5561cb54aec6d4b5$var$divergingSqrt() {
    return $5561cb54aec6d4b5$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



var $42026bd2a6336480$exports = {};
$parcel$extendImportMap({
    "aznXx": "earth.3404302e.png",
    "hwsqy": "space.2e06c2de.png"
});

var $34ccb6660205eec8$exports = {};
'use strict';

$34ccb6660205eec8$exports = (parcelRequire("ifLAN"));



var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");
function $1771723e14e11c61$export$2e2bcd8739ae039() {
    return $1771723e14e11c61$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1771723e14e11c61$export$2e2bcd8739ae039.apply(null, arguments);
}



var $539d432685acadfb$export$6acf61af03e62db = typeof window === 'undefined';
function $539d432685acadfb$export$8793edee2d425525() {
    return undefined;
}
function $539d432685acadfb$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $539d432685acadfb$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $539d432685acadfb$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $539d432685acadfb$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $539d432685acadfb$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $539d432685acadfb$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $539d432685acadfb$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$539d432685acadfb$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg2, {
        queryKey: arg1
    });
}
function $539d432685acadfb$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($539d432685acadfb$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg1);
}
function $539d432685acadfb$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $539d432685acadfb$export$aaae5295ec3351c9(arg1) ? [
        (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $539d432685acadfb$export$42387eeaac09cf54(arg1, arg2) {
    return $539d432685acadfb$export$aaae5295ec3351c9(arg1) ? (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $539d432685acadfb$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function $539d432685acadfb$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($539d432685acadfb$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $539d432685acadfb$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$539d432685acadfb$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $539d432685acadfb$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $539d432685acadfb$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($539d432685acadfb$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($539d432685acadfb$export$5fcb678681417b54(mutation.options.mutationKey) !== $539d432685acadfb$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$539d432685acadfb$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $539d432685acadfb$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $539d432685acadfb$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $539d432685acadfb$export$5fcb678681417b54(queryKey) {
    var asArray = $539d432685acadfb$export$4d32d63f64b825b9(queryKey);
    return $539d432685acadfb$export$e7f2f041280beb00(asArray);
}
function $539d432685acadfb$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $539d432685acadfb$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $539d432685acadfb$export$2f07189bb9fa26a7(a, b) {
    return $539d432685acadfb$export$3bc9138b70293839($539d432685acadfb$export$4d32d63f64b825b9(a), $539d432685acadfb$export$4d32d63f64b825b9(b));
}
function $539d432685acadfb$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !$539d432685acadfb$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $539d432685acadfb$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $539d432685acadfb$export$53b83ca8eaab0383(a) && $539d432685acadfb$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $539d432685acadfb$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $539d432685acadfb$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $539d432685acadfb$export$53b83ca8eaab0383(o) {
    if (!$539d432685acadfb$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$539d432685acadfb$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $539d432685acadfb$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $539d432685acadfb$export$aaae5295ec3351c9(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function $539d432685acadfb$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $539d432685acadfb$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $539d432685acadfb$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $539d432685acadfb$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
}


function $8a34227ecc16a73c$export$2e2bcd8739ae039(t, e) {
    return $8a34227ecc16a73c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8a34227ecc16a73c$export$2e2bcd8739ae039(t, e);
}


function $803c8d214cd5af94$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $8a34227ecc16a73c$export$2e2bcd8739ae039)(t, o);
}






var $6abe09e890d1ce84$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $539d432685acadfb$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    };
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $539d432685acadfb$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    };
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    };
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $6abe09e890d1ce84$export$520687f44db6e1ab = new $6abe09e890d1ce84$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $192640f7e0cad21b$var$logger = console;
function $192640f7e0cad21b$export$2b1d391cd05230fd() {
    return $192640f7e0cad21b$var$logger;
}
function $192640f7e0cad21b$export$3abbd92f765bee58(newLogger) {
    $192640f7e0cad21b$var$logger = newLogger;
}



var $087a5ebf12449359$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $239b070c3c741028$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $539d432685acadfb$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $087a5ebf12449359$export$d26086b469ecdbcc));
var $239b070c3c741028$export$6bf54661be5b02cf = new $239b070c3c741028$export$86f1af424b2ca4de();





var $c14e2200af18da1d$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $539d432685acadfb$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $087a5ebf12449359$export$d26086b469ecdbcc));
var $c14e2200af18da1d$export$b113e788b2dd3fdc = new $c14e2200af18da1d$export$58774fb55d5ff7fc();



function $5b2826f69d5f894f$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $5b2826f69d5f894f$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var $5b2826f69d5f894f$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $5b2826f69d5f894f$export$986cc6445c1d323(value) {
    return value instanceof $5b2826f69d5f894f$export$a8430ed4188f35a9;
} // CLASS
var $5b2826f69d5f894f$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $5b2826f69d5f894f$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($5b2826f69d5f894f$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $5b2826f69d5f894f$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $5b2826f69d5f894f$var$defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $539d432685acadfb$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $239b070c3c741028$export$6bf54661be5b02cf).isFocused() || !(0, $c14e2200af18da1d$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $4bf20ff30ac160d8$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $539d432685acadfb$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $539d432685acadfb$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $539d432685acadfb$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $539d432685acadfb$export$8793edee2d425525)).catch((0, $539d432685acadfb$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $539d432685acadfb$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $539d432685acadfb$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $539d432685acadfb$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $5b2826f69d5f894f$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $5b2826f69d5f894f$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, $5b2826f69d5f894f$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $192640f7e0cad21b$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, $5b2826f69d5f894f$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, this.revertState);
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $29ae3f4921b3da3b$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $539d432685acadfb$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $4bf20ff30ac160d8$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $539d432685acadfb$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $539d432685acadfb$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $087a5ebf12449359$export$d26086b469ecdbcc));









var $a542956ca3550b1e$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $a542956ca3550b1e$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $539d432685acadfb$export$8793edee2d425525)).catch((0, $539d432685acadfb$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $192640f7e0cad21b$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $5b2826f69d5f894f$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $a542956ca3550b1e$var$reducer(this.state, action);
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $a542956ca3550b1e$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function $a542956ca3550b1e$var$reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, action.state);
        default:
            return state;
    }
}




var $008b5ed7c7f9bba9$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $a542956ca3550b1e$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $539d432685acadfb$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $539d432685acadfb$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $539d432685acadfb$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $087a5ebf12449359$export$d26086b469ecdbcc));







function $b48989c6dfec3c20$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $539d432685acadfb$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $5b2826f69d5f894f$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : $b48989c6dfec3c20$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : $b48989c6dfec3c20$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $b48989c6dfec3c20$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $5b2826f69d5f894f$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $b48989c6dfec3c20$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $b48989c6dfec3c20$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $b48989c6dfec3c20$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $b48989c6dfec3c20$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function $b48989c6dfec3c20$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $b48989c6dfec3c20$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}


var $1f0fe77b5c426c98$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $29ae3f4921b3da3b$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $008b5ed7c7f9bba9$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $239b070c3c741028$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $239b070c3c741028$export$6bf54661be5b02cf).isFocused() && (0, $c14e2200af18da1d$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $c14e2200af18da1d$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $239b070c3c741028$export$6bf54661be5b02cf).isFocused() && (0, $c14e2200af18da1d$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $539d432685acadfb$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, filters, {
            active: true
        });
        return (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $539d432685acadfb$export$8793edee2d425525)).catch((0, $539d432685acadfb$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $539d432685acadfb$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $539d432685acadfb$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $539d432685acadfb$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $539d432685acadfb$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $539d432685acadfb$export$8793edee2d425525)).catch((0, $539d432685acadfb$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $539d432685acadfb$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $b48989c6dfec3c20$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $539d432685acadfb$export$8793edee2d425525)).catch((0, $539d432685acadfb$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $539d432685acadfb$export$8793edee2d425525)).catch((0, $539d432685acadfb$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $539d432685acadfb$export$5fcb678681417b54)(queryKey) === (0, $539d432685acadfb$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $539d432685acadfb$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $539d432685acadfb$export$5fcb678681417b54)(mutationKey) === (0, $539d432685acadfb$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $539d432685acadfb$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $539d432685acadfb$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $3glZ1 = parcelRequire("3glZ1");
var $47e177d9ed463a91$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).unstable_batchedUpdates;


(0, $6abe09e890d1ce84$export$520687f44db6e1ab).setBatchNotifyFunction((0, $47e177d9ed463a91$export$c78a37762a8d58e1));



var $1261c6b145be35e8$export$af88d00dbe7f521 = console;


(0, $192640f7e0cad21b$export$3abbd92f765bee58)((0, $1261c6b145be35e8$export$af88d00dbe7f521));



var $70fFQ = parcelRequire("70fFQ");
var $7e71e0df4024a5cb$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(undefined);
var $7e71e0df4024a5cb$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $7e71e0df4024a5cb$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $7e71e0df4024a5cb$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $7e71e0df4024a5cb$var$defaultContext;
}
var $7e71e0df4024a5cb$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useContext($7e71e0df4024a5cb$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useContext($7e71e0df4024a5cb$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var $7e71e0df4024a5cb$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $7e71e0df4024a5cb$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7e71e0df4024a5cb$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(Context.Provider, {
        value: client
    }, children));
};







var $70fFQ = parcelRequire("70fFQ");







var $8ae1b318d0f04a62$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $a542956ca3550b1e$export$a1659b54bac3252a)();
        var result = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $087a5ebf12449359$export$d26086b469ecdbcc));



function $db08d698af6bc2d0$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $4590a457b11e610e$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $539d432685acadfb$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $7e71e0df4024a5cb$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $8ae1b318d0f04a62$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $6abe09e890d1ce84$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $539d432685acadfb$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $db08d698af6bc2d0$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}










var $386472e220e55301$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($386472e220e55301$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $386472e220e55301$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $386472e220e55301$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $386472e220e55301$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp('error');
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $539d432685acadfb$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $539d432685acadfb$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $539d432685acadfb$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $539d432685acadfb$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $539d432685acadfb$export$6acf61af03e62db) || this.options.enabled === false || !(0, $539d432685acadfb$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $239b070c3c741028$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $386472e220e55301$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $386472e220e55301$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = 'loading';
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $539d432685acadfb$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $192640f7e0cad21b$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $539d432685acadfb$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $192640f7e0cad21b$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        var result = {
            status: status,
            isLoading: status === 'loading',
            isSuccess: status === 'success',
            isError: status === 'error',
            isIdle: status === 'idle',
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== 'loading',
            isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
            isStale: $386472e220e55301$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $539d432685acadfb$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error' && !(0, $5b2826f69d5f894f$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    };
    return QueryObserver;
}((0, $087a5ebf12449359$export$d26086b469ecdbcc));
function $386472e220e55301$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $386472e220e55301$var$shouldFetchOnMount(query, options) {
    return $386472e220e55301$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $386472e220e55301$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $386472e220e55301$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $386472e220e55301$var$isStale(query, options);
    }
    return false;
}
function $386472e220e55301$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $386472e220e55301$var$isStale(query, options);
}
function $386472e220e55301$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $70fFQ = parcelRequire("70fFQ");


var $70fFQ = parcelRequire("70fFQ");
function $b411501fb84ca53d$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $b411501fb84ca53d$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext($b411501fb84ca53d$var$createValue()); // HOOK
var $b411501fb84ca53d$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useContext($b411501fb84ca53d$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $b411501fb84ca53d$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useMemo(function() {
        return $b411501fb84ca53d$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($b411501fb84ca53d$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




function $b5280f22f54d587b$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $7e71e0df4024a5cb$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $b411501fb84ca53d$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $6abe09e890d1ce84$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $db08d698af6bc2d0$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === 'tracked') result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $44ac4c87cce0b07f$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $539d432685acadfb$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $b5280f22f54d587b$export$fff0865807e996c5)(parsedOptions, (0, $386472e220e55301$export$a06cf8c0066f0d4c));
}



var $70fFQ = parcelRequire("70fFQ");






var $9b0fc383b3c5a703$export$15352e437905ad4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(QueriesObserver, _Subscribable);
    function QueriesObserver(client, queries) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.queries = [];
        _this.result = [];
        _this.observers = [];
        _this.observersMap = {};
        if (queries) _this.setQueries(queries);
        return _this;
    }
    var _proto = QueriesObserver.prototype;
    _proto.onSubscribe = function onSubscribe() {
        var _this2 = this;
        if (this.listeners.length === 1) this.observers.forEach(function(observer) {
            observer.subscribe(function(result) {
                _this2.onUpdate(observer, result);
            });
        });
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.observers.forEach(function(observer) {
            observer.destroy();
        });
    };
    _proto.setQueries = function setQueries(queries, notifyOptions) {
        this.queries = queries;
        this.updateObservers(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.result;
    };
    _proto.getOptimisticResult = function getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map(function(match) {
            return match.observer.getOptimisticResult(match.defaultedQueryOptions);
        });
    };
    _proto.findMatchingObservers = function findMatchingObservers(queries) {
        var _this3 = this;
        var prevObservers = this.observers;
        var defaultedQueryOptions = queries.map(function(options) {
            return _this3.client.defaultQueryObserverOptions(options);
        });
        var matchingObservers = defaultedQueryOptions.flatMap(function(defaultedOptions) {
            var match = prevObservers.find(function(observer) {
                return observer.options.queryHash === defaultedOptions.queryHash;
            });
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        var matchedQueryHashes = matchingObservers.map(function(match) {
            return match.defaultedQueryOptions.queryHash;
        });
        var unmatchedQueries = defaultedQueryOptions.filter(function(defaultedOptions) {
            return !matchedQueryHashes.includes(defaultedOptions.queryHash);
        });
        var unmatchedObservers = prevObservers.filter(function(prevObserver) {
            return !matchingObservers.some(function(match) {
                return match.observer === prevObserver;
            });
        });
        var newOrReusedObservers = unmatchedQueries.map(function(options, index) {
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                var previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: _this3.getObserver(options)
            };
        });
        var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
            return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        };
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    };
    _proto.getObserver = function getObserver(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var currentObserver = this.observersMap[defaultedOptions.queryHash];
        return currentObserver != null ? currentObserver : new (0, $386472e220e55301$export$a06cf8c0066f0d4c)(this.client, defaultedOptions);
    };
    _proto.updateObservers = function updateObservers(notifyOptions) {
        var _this4 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            var prevObservers = _this4.observers;
            var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach(function(match) {
                return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
            });
            var newObservers = newObserverMatches.map(function(match) {
                return match.observer;
            });
            var newObserversMap = Object.fromEntries(newObservers.map(function(observer) {
                return [
                    observer.options.queryHash,
                    observer
                ];
            }));
            var newResult = newObservers.map(function(observer) {
                return observer.getCurrentResult();
            });
            var hasIndexChange = newObservers.some(function(observer, index) {
                return observer !== prevObservers[index];
            });
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            _this4.observers = newObservers;
            _this4.observersMap = newObserversMap;
            _this4.result = newResult;
            if (!_this4.hasListeners()) return;
            (0, $539d432685acadfb$export$acaf96a27438246b)(prevObservers, newObservers).forEach(function(observer) {
                observer.destroy();
            });
            (0, $539d432685acadfb$export$acaf96a27438246b)(newObservers, prevObservers).forEach(function(observer) {
                observer.subscribe(function(result) {
                    _this4.onUpdate(observer, result);
                });
            });
            _this4.notify();
        });
    };
    _proto.onUpdate = function onUpdate(observer, result) {
        var index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, $539d432685acadfb$export$224e3b7078227b8a)(this.result, index, result);
            this.notify();
        }
    };
    _proto.notify = function notify() {
        var _this5 = this;
        (0, $6abe09e890d1ce84$export$520687f44db6e1ab).batch(function() {
            _this5.listeners.forEach(function(listener) {
                listener(_this5.result);
            });
        });
    };
    return QueriesObserver;
}((0, $087a5ebf12449359$export$d26086b469ecdbcc));



function $c3bf82321f15cb6e$export$408667c6c87da1e5(queries) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $7e71e0df4024a5cb$export$22e77b9572c4fded)();
    var defaultedQueries = (0, $70fFQ.useMemo)(function() {
        return queries.map(function(options) {
            var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions.optimisticResults = true;
            return defaultedOptions;
        });
    }, [
        queries,
        queryClient
    ]);
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(function() {
        return new (0, $9b0fc383b3c5a703$export$15352e437905ad4c)(queryClient, defaultedQueries);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedQueries);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = observer.subscribe((0, $6abe09e890d1ce84$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    return result;
}






var $b5266616c3bbb7f4$export$85d960eb3ab339c8 = /*#__PURE__*/ function(_QueryObserver) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(InfiniteQueryObserver, _QueryObserver);
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function InfiniteQueryObserver(client, options) {
        return _QueryObserver.call(this, client, options) || this;
    }
    var _proto = InfiniteQueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        _QueryObserver.prototype.bindMethods.call(this);
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        _QueryObserver.prototype.setOptions.call(this, (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, options, {
            behavior: (0, $b48989c6dfec3c20$export$84470d1367601e8d)()
        }), notifyOptions);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        options.behavior = (0, $b48989c6dfec3c20$export$84470d1367601e8d)();
        return _QueryObserver.prototype.getOptimisticResult.call(this, options);
    };
    _proto.fetchNextPage = function fetchNextPage(options) {
        var _options$cancelRefetc;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: 'forward',
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.fetchPreviousPage = function fetchPreviousPage(options) {
        var _options$cancelRefetc2;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: 'backward',
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.createResult = function createResult(query, options) {
        var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;
        var state = query.state;
        var result = _QueryObserver.prototype.createResult.call(this, query, options);
        return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, result, {
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $b48989c6dfec3c20$export$b9c88add8b8b5e6a)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, $b48989c6dfec3c20$export$db1663b730a8e6e4)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
            isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
        });
    };
    return InfiniteQueryObserver;
}((0, $386472e220e55301$export$a06cf8c0066f0d4c));




function $924889e2158d19ef$export$bdc59d3c1a6569aa(arg1, arg2, arg3) {
    var options = (0, $539d432685acadfb$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $b5280f22f54d587b$export$fff0865807e996c5)(options, (0, $b5266616c3bbb7f4$export$85d960eb3ab339c8));
}








/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $91c606d8f02f7c37$var$_extends() {
    return $91c606d8f02f7c37$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $91c606d8f02f7c37$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $91c606d8f02f7c37$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($91c606d8f02f7c37$export$e19cd5f9376f8cee || ($91c606d8f02f7c37$export$e19cd5f9376f8cee = {}));
const $91c606d8f02f7c37$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $91c606d8f02f7c37$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $91c606d8f02f7c37$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $91c606d8f02f7c37$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $91c606d8f02f7c37$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $91c606d8f02f7c37$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $91c606d8f02f7c37$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $91c606d8f02f7c37$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $91c606d8f02f7c37$export$fe53371bee54353d(to);
    }
    return $91c606d8f02f7c37$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $91c606d8f02f7c37$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $91c606d8f02f7c37$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $91c606d8f02f7c37$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $91c606d8f02f7c37$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $91c606d8f02f7c37$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $91c606d8f02f7c37$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $91c606d8f02f7c37$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $91c606d8f02f7c37$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $91c606d8f02f7c37$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $91c606d8f02f7c37$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $91c606d8f02f7c37$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $91c606d8f02f7c37$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $91c606d8f02f7c37$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $91c606d8f02f7c37$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $91c606d8f02f7c37$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $91c606d8f02f7c37$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $91c606d8f02f7c37$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($91c606d8f02f7c37$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Push;
        let location = $91c606d8f02f7c37$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $91c606d8f02f7c37$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Replace;
        let location = $91c606d8f02f7c37$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $91c606d8f02f7c37$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $91c606d8f02f7c37$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $91c606d8f02f7c37$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($91c606d8f02f7c37$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($91c606d8f02f7c37$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $91c606d8f02f7c37$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($91c606d8f02f7c37$var$ResultType || ($91c606d8f02f7c37$var$ResultType = {}));
const $91c606d8f02f7c37$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $91c606d8f02f7c37$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $91c606d8f02f7c37$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $91c606d8f02f7c37$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $91c606d8f02f7c37$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($91c606d8f02f7c37$var$isIndexRoute(route)) {
            let indexRoute = $91c606d8f02f7c37$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $91c606d8f02f7c37$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $91c606d8f02f7c37$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $91c606d8f02f7c37$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $91c606d8f02f7c37$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $91c606d8f02f7c37$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $91c606d8f02f7c37$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $91c606d8f02f7c37$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $91c606d8f02f7c37$var$flattenRoutes(routes);
    $91c606d8f02f7c37$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $91c606d8f02f7c37$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $91c606d8f02f7c37$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $91c606d8f02f7c37$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $91c606d8f02f7c37$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $91c606d8f02f7c37$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $91c606d8f02f7c37$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $91c606d8f02f7c37$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $91c606d8f02f7c37$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $91c606d8f02f7c37$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $91c606d8f02f7c37$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $91c606d8f02f7c37$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $91c606d8f02f7c37$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $91c606d8f02f7c37$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $91c606d8f02f7c37$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $91c606d8f02f7c37$var$paramRe = /^:[\w-]+$/;
const $91c606d8f02f7c37$var$dynamicSegmentValue = 3;
const $91c606d8f02f7c37$var$indexRouteValue = 2;
const $91c606d8f02f7c37$var$emptySegmentValue = 1;
const $91c606d8f02f7c37$var$staticSegmentValue = 10;
const $91c606d8f02f7c37$var$splatPenalty = -2;
const $91c606d8f02f7c37$var$isSplat = (s)=>s === "*";
function $91c606d8f02f7c37$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($91c606d8f02f7c37$var$isSplat)) initialScore += $91c606d8f02f7c37$var$splatPenalty;
    if (index) initialScore += $91c606d8f02f7c37$var$indexRouteValue;
    return segments.filter((s)=>!$91c606d8f02f7c37$var$isSplat(s)).reduce((score, segment)=>score + ($91c606d8f02f7c37$var$paramRe.test(segment) ? $91c606d8f02f7c37$var$dynamicSegmentValue : segment === "" ? $91c606d8f02f7c37$var$emptySegmentValue : $91c606d8f02f7c37$var$staticSegmentValue), initialScore);
}
function $91c606d8f02f7c37$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $91c606d8f02f7c37$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $91c606d8f02f7c37$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $91c606d8f02f7c37$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $91c606d8f02f7c37$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $91c606d8f02f7c37$export$a5c6d149b50c1d86($91c606d8f02f7c37$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $91c606d8f02f7c37$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $91c606d8f02f7c37$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $91c606d8f02f7c37$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $91c606d8f02f7c37$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $91c606d8f02f7c37$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $91c606d8f02f7c37$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $91c606d8f02f7c37$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $91c606d8f02f7c37$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $91c606d8f02f7c37$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $91c606d8f02f7c37$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $91c606d8f02f7c37$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $91c606d8f02f7c37$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $91c606d8f02f7c37$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $91c606d8f02f7c37$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $91c606d8f02f7c37$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $91c606d8f02f7c37$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $91c606d8f02f7c37$var$normalizeSearch(search),
        hash: $91c606d8f02f7c37$var$normalizeHash(hash)
    };
}
function $91c606d8f02f7c37$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $91c606d8f02f7c37$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $91c606d8f02f7c37$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $91c606d8f02f7c37$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $91c606d8f02f7c37$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $91c606d8f02f7c37$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $91c606d8f02f7c37$export$8ccf933b0513f8d0(toArg);
    else {
        to = $91c606d8f02f7c37$var$_extends({}, toArg);
        $91c606d8f02f7c37$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $91c606d8f02f7c37$var$getInvalidPathError("?", "pathname", "search", to));
        $91c606d8f02f7c37$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $91c606d8f02f7c37$var$getInvalidPathError("#", "pathname", "hash", to));
        $91c606d8f02f7c37$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $91c606d8f02f7c37$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $91c606d8f02f7c37$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $91c606d8f02f7c37$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $91c606d8f02f7c37$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $91c606d8f02f7c37$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $91c606d8f02f7c37$export$86d9a7913e44197e = (paths)=>$91c606d8f02f7c37$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $91c606d8f02f7c37$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $91c606d8f02f7c37$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $91c606d8f02f7c37$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $91c606d8f02f7c37$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $91c606d8f02f7c37$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $91c606d8f02f7c37$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $91c606d8f02f7c37$export$4051a07651545597(data, init) {
    return new $91c606d8f02f7c37$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $91c606d8f02f7c37$export$42a99a7a4bc0e76a extends Error {
}
class $91c606d8f02f7c37$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $91c606d8f02f7c37$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $91c606d8f02f7c37$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $91c606d8f02f7c37$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $91c606d8f02f7c37$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $91c606d8f02f7c37$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $91c606d8f02f7c37$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $91c606d8f02f7c37$var$unwrapTrackedPromise(value) {
    if (!$91c606d8f02f7c37$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $91c606d8f02f7c37$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $91c606d8f02f7c37$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $91c606d8f02f7c37$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $91c606d8f02f7c37$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $91c606d8f02f7c37$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $91c606d8f02f7c37$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $91c606d8f02f7c37$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $91c606d8f02f7c37$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $91c606d8f02f7c37$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $91c606d8f02f7c37$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $91c606d8f02f7c37$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $91c606d8f02f7c37$var$validMutationMethods = new Set($91c606d8f02f7c37$var$validMutationMethodsArr);
const $91c606d8f02f7c37$var$validRequestMethodsArr = [
    "get",
    ...$91c606d8f02f7c37$var$validMutationMethodsArr
];
const $91c606d8f02f7c37$var$validRequestMethods = new Set($91c606d8f02f7c37$var$validRequestMethodsArr);
const $91c606d8f02f7c37$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $91c606d8f02f7c37$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $91c606d8f02f7c37$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $91c606d8f02f7c37$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $91c606d8f02f7c37$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $91c606d8f02f7c37$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $91c606d8f02f7c37$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $91c606d8f02f7c37$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $91c606d8f02f7c37$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $91c606d8f02f7c37$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $91c606d8f02f7c37$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $91c606d8f02f7c37$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $91c606d8f02f7c37$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $91c606d8f02f7c37$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $91c606d8f02f7c37$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $91c606d8f02f7c37$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $91c606d8f02f7c37$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$91c606d8f02f7c37$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$91c606d8f02f7c37$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $91c606d8f02f7c37$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $91c606d8f02f7c37$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $91c606d8f02f7c37$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $91c606d8f02f7c37$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$91c606d8f02f7c37$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $91c606d8f02f7c37$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $91c606d8f02f7c37$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $91c606d8f02f7c37$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $91c606d8f02f7c37$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $91c606d8f02f7c37$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $91c606d8f02f7c37$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $91c606d8f02f7c37$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($91c606d8f02f7c37$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $91c606d8f02f7c37$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $91c606d8f02f7c37$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $91c606d8f02f7c37$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $91c606d8f02f7c37$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $91c606d8f02f7c37$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $91c606d8f02f7c37$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $91c606d8f02f7c37$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $91c606d8f02f7c37$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $91c606d8f02f7c37$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $91c606d8f02f7c37$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $91c606d8f02f7c37$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $91c606d8f02f7c37$var$findNearestBoundary(matches).route.id,
            {
                type: $91c606d8f02f7c37$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $91c606d8f02f7c37$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($91c606d8f02f7c37$var$isErrorResult(result) && $91c606d8f02f7c37$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $91c606d8f02f7c37$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $91c606d8f02f7c37$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $91c606d8f02f7c37$var$_extends({
            matches: updatedMatches || matches
        }, $91c606d8f02f7c37$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $91c606d8f02f7c37$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $91c606d8f02f7c37$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $91c606d8f02f7c37$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $91c606d8f02f7c37$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $91c606d8f02f7c37$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $91c606d8f02f7c37$var$ResultType.error,
            error: $91c606d8f02f7c37$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($91c606d8f02f7c37$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $91c606d8f02f7c37$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($91c606d8f02f7c37$var$isDeferredResult(result)) throw $91c606d8f02f7c37$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($91c606d8f02f7c37$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $91c606d8f02f7c37$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $91c606d8f02f7c37$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $91c606d8f02f7c37$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $91c606d8f02f7c37$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($91c606d8f02f7c37$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $91c606d8f02f7c37$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $91c606d8f02f7c37$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $91c606d8f02f7c37$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $91c606d8f02f7c37$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $91c606d8f02f7c37$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $91c606d8f02f7c37$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $91c606d8f02f7c37$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $91c606d8f02f7c37$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $91c606d8f02f7c37$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $91c606d8f02f7c37$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $91c606d8f02f7c37$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $91c606d8f02f7c37$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $91c606d8f02f7c37$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $91c606d8f02f7c37$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $91c606d8f02f7c37$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $91c606d8f02f7c37$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $91c606d8f02f7c37$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $91c606d8f02f7c37$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $91c606d8f02f7c37$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $91c606d8f02f7c37$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $91c606d8f02f7c37$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($91c606d8f02f7c37$var$isRedirectResult(actionResult) || $91c606d8f02f7c37$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $91c606d8f02f7c37$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($91c606d8f02f7c37$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $91c606d8f02f7c37$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $91c606d8f02f7c37$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($91c606d8f02f7c37$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($91c606d8f02f7c37$var$isDeferredResult(actionResult)) throw $91c606d8f02f7c37$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $91c606d8f02f7c37$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $91c606d8f02f7c37$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $91c606d8f02f7c37$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $91c606d8f02f7c37$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $91c606d8f02f7c37$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $91c606d8f02f7c37$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $91c606d8f02f7c37$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $91c606d8f02f7c37$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $91c606d8f02f7c37$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $91c606d8f02f7c37$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $91c606d8f02f7c37$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $91c606d8f02f7c37$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $91c606d8f02f7c37$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $91c606d8f02f7c37$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $91c606d8f02f7c37$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $91c606d8f02f7c37$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($91c606d8f02f7c37$var$isDeferredResult(result)) result = await $91c606d8f02f7c37$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $91c606d8f02f7c37$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($91c606d8f02f7c37$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $91c606d8f02f7c37$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($91c606d8f02f7c37$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $91c606d8f02f7c37$export$3e9cee6b33872309(!$91c606d8f02f7c37$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $91c606d8f02f7c37$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $91c606d8f02f7c37$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $91c606d8f02f7c37$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $91c606d8f02f7c37$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($91c606d8f02f7c37$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $91c606d8f02f7c37$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $91c606d8f02f7c37$export$e19cd5f9376f8cee.Replace : $91c606d8f02f7c37$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $91c606d8f02f7c37$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($91c606d8f02f7c37$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $91c606d8f02f7c37$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $91c606d8f02f7c37$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $91c606d8f02f7c37$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $91c606d8f02f7c37$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $91c606d8f02f7c37$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($91c606d8f02f7c37$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $91c606d8f02f7c37$var$ResultType.redirect,
                response: $91c606d8f02f7c37$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $91c606d8f02f7c37$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $91c606d8f02f7c37$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $91c606d8f02f7c37$var$ResultType.error,
                    error: $91c606d8f02f7c37$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $91c606d8f02f7c37$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $91c606d8f02f7c37$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $91c606d8f02f7c37$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $91c606d8f02f7c37$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $91c606d8f02f7c37$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $91c606d8f02f7c37$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $91c606d8f02f7c37$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $91c606d8f02f7c37$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $91c606d8f02f7c37$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $91c606d8f02f7c37$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $91c606d8f02f7c37$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $91c606d8f02f7c37$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $91c606d8f02f7c37$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $91c606d8f02f7c37$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$91c606d8f02f7c37$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $91c606d8f02f7c37$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $91c606d8f02f7c37$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $91c606d8f02f7c37$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $91c606d8f02f7c37$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $91c606d8f02f7c37$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $91c606d8f02f7c37$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $91c606d8f02f7c37$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $91c606d8f02f7c37$export$4d0306f8f6a4585b = Symbol("deferred");
function $91c606d8f02f7c37$export$3336b097a6fbc59a(routes, opts) {
    $91c606d8f02f7c37$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $91c606d8f02f7c37$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $91c606d8f02f7c37$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $91c606d8f02f7c37$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $91c606d8f02f7c37$var$createLocation("", $91c606d8f02f7c37$export$fe53371bee54353d(url), null, "default");
        let matches = $91c606d8f02f7c37$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$91c606d8f02f7c37$var$isValidMethod(method) && method !== "HEAD") {
            let error = $91c606d8f02f7c37$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $91c606d8f02f7c37$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $91c606d8f02f7c37$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $91c606d8f02f7c37$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($91c606d8f02f7c37$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $91c606d8f02f7c37$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $91c606d8f02f7c37$var$createLocation("", $91c606d8f02f7c37$export$fe53371bee54353d(url), null, "default");
        let matches = $91c606d8f02f7c37$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$91c606d8f02f7c37$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $91c606d8f02f7c37$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $91c606d8f02f7c37$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $91c606d8f02f7c37$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $91c606d8f02f7c37$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $91c606d8f02f7c37$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($91c606d8f02f7c37$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$91c606d8f02f7c37$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $91c606d8f02f7c37$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($91c606d8f02f7c37$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $91c606d8f02f7c37$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $91c606d8f02f7c37$var$isResponse(result) ? result : $91c606d8f02f7c37$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($91c606d8f02f7c37$var$isDataStrategyResult(e) && $91c606d8f02f7c37$var$isResponse(e.result)) {
                if (e.type === $91c606d8f02f7c37$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($91c606d8f02f7c37$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $91c606d8f02f7c37$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $91c606d8f02f7c37$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $91c606d8f02f7c37$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($91c606d8f02f7c37$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($91c606d8f02f7c37$var$isDeferredResult(result)) {
            let error = $91c606d8f02f7c37$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $91c606d8f02f7c37$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($91c606d8f02f7c37$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($91c606d8f02f7c37$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $91c606d8f02f7c37$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $91c606d8f02f7c37$var$_extends({}, context, {
                statusCode: $91c606d8f02f7c37$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $91c606d8f02f7c37$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $91c606d8f02f7c37$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $91c606d8f02f7c37$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1]) ? $91c606d8f02f7c37$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $91c606d8f02f7c37$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $91c606d8f02f7c37$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $91c606d8f02f7c37$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $91c606d8f02f7c37$var$callDataStrategyImpl(dataStrategy || $91c606d8f02f7c37$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($91c606d8f02f7c37$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $91c606d8f02f7c37$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($91c606d8f02f7c37$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $91c606d8f02f7c37$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $91c606d8f02f7c37$export$fec11da027c70692(routes, context, error) {
    let newContext = $91c606d8f02f7c37$var$_extends({}, context, {
        statusCode: $91c606d8f02f7c37$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $91c606d8f02f7c37$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $91c606d8f02f7c37$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $91c606d8f02f7c37$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $91c606d8f02f7c37$export$cae722b0cc860f13(to ? to : ".", $91c606d8f02f7c37$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $91c606d8f02f7c37$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $91c606d8f02f7c37$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $91c606d8f02f7c37$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $91c606d8f02f7c37$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $91c606d8f02f7c37$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$91c606d8f02f7c37$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$91c606d8f02f7c37$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $91c606d8f02f7c37$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $91c606d8f02f7c37$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $91c606d8f02f7c37$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$91c606d8f02f7c37$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$91c606d8f02f7c37$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $91c606d8f02f7c37$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $91c606d8f02f7c37$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $91c606d8f02f7c37$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $91c606d8f02f7c37$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $91c606d8f02f7c37$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($91c606d8f02f7c37$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $91c606d8f02f7c37$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $91c606d8f02f7c37$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $91c606d8f02f7c37$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $91c606d8f02f7c37$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $91c606d8f02f7c37$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $91c606d8f02f7c37$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $91c606d8f02f7c37$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $91c606d8f02f7c37$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($91c606d8f02f7c37$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $91c606d8f02f7c37$var$shouldRevalidateLoader(match, $91c606d8f02f7c37$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $91c606d8f02f7c37$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $91c606d8f02f7c37$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $91c606d8f02f7c37$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $91c606d8f02f7c37$var$shouldRevalidateLoader(fetcherMatch, $91c606d8f02f7c37$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $91c606d8f02f7c37$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $91c606d8f02f7c37$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $91c606d8f02f7c37$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $91c606d8f02f7c37$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $91c606d8f02f7c37$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $91c606d8f02f7c37$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$91c606d8f02f7c37$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $91c606d8f02f7c37$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $91c606d8f02f7c37$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$91c606d8f02f7c37$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $91c606d8f02f7c37$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $91c606d8f02f7c37$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $91c606d8f02f7c37$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$91c606d8f02f7c37$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $91c606d8f02f7c37$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $91c606d8f02f7c37$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $91c606d8f02f7c37$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $91c606d8f02f7c37$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $91c606d8f02f7c37$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $91c606d8f02f7c37$var$ResultType.data,
                result: undefined
            });
        };
        return $91c606d8f02f7c37$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $91c606d8f02f7c37$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $91c606d8f02f7c37$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $91c606d8f02f7c37$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $91c606d8f02f7c37$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $91c606d8f02f7c37$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $91c606d8f02f7c37$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $91c606d8f02f7c37$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($91c606d8f02f7c37$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $91c606d8f02f7c37$var$ResultType.error,
                error: e
            };
        }
        if (type === $91c606d8f02f7c37$var$ResultType.error) return {
            type: $91c606d8f02f7c37$var$ResultType.error,
            error: new $91c606d8f02f7c37$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $91c606d8f02f7c37$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $91c606d8f02f7c37$var$ResultType.error) {
        if ($91c606d8f02f7c37$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $91c606d8f02f7c37$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $91c606d8f02f7c37$var$ResultType.error,
                error: new $91c606d8f02f7c37$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $91c606d8f02f7c37$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $91c606d8f02f7c37$var$ResultType.error,
            error: result,
            statusCode: $91c606d8f02f7c37$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($91c606d8f02f7c37$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $91c606d8f02f7c37$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($91c606d8f02f7c37$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $91c606d8f02f7c37$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $91c606d8f02f7c37$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $91c606d8f02f7c37$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $91c606d8f02f7c37$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$91c606d8f02f7c37$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $91c606d8f02f7c37$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $91c606d8f02f7c37$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($91c606d8f02f7c37$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $91c606d8f02f7c37$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $91c606d8f02f7c37$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $91c606d8f02f7c37$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($91c606d8f02f7c37$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $91c606d8f02f7c37$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $91c606d8f02f7c37$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $91c606d8f02f7c37$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $91c606d8f02f7c37$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $91c606d8f02f7c37$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $91c606d8f02f7c37$export$3e9cee6b33872309(!$91c606d8f02f7c37$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($91c606d8f02f7c37$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $91c606d8f02f7c37$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $91c606d8f02f7c37$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($91c606d8f02f7c37$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $91c606d8f02f7c37$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $91c606d8f02f7c37$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $91c606d8f02f7c37$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($91c606d8f02f7c37$var$isErrorResult(result)) {
            let boundaryMatch = $91c606d8f02f7c37$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $91c606d8f02f7c37$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($91c606d8f02f7c37$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $91c606d8f02f7c37$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($91c606d8f02f7c37$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $91c606d8f02f7c37$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $91c606d8f02f7c37$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $91c606d8f02f7c37$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $91c606d8f02f7c37$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $91c606d8f02f7c37$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $91c606d8f02f7c37$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $91c606d8f02f7c37$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $91c606d8f02f7c37$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $91c606d8f02f7c37$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $91c606d8f02f7c37$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $91c606d8f02f7c37$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($91c606d8f02f7c37$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $91c606d8f02f7c37$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $91c606d8f02f7c37$export$8ccf933b0513f8d0(path) : path;
    return $91c606d8f02f7c37$export$fe53371bee54353d($91c606d8f02f7c37$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $91c606d8f02f7c37$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $91c606d8f02f7c37$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $91c606d8f02f7c37$var$ResultType.data || result.type === $91c606d8f02f7c37$var$ResultType.error);
}
function $91c606d8f02f7c37$var$isRedirectDataStrategyResultResult(result) {
    return $91c606d8f02f7c37$var$isResponse(result.result) && $91c606d8f02f7c37$var$redirectStatusCodes.has(result.result.status);
}
function $91c606d8f02f7c37$var$isDeferredResult(result) {
    return result.type === $91c606d8f02f7c37$var$ResultType.deferred;
}
function $91c606d8f02f7c37$var$isErrorResult(result) {
    return result.type === $91c606d8f02f7c37$var$ResultType.error;
}
function $91c606d8f02f7c37$var$isRedirectResult(result) {
    return (result && result.type) === $91c606d8f02f7c37$var$ResultType.redirect;
}
function $91c606d8f02f7c37$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $91c606d8f02f7c37$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $91c606d8f02f7c37$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $91c606d8f02f7c37$var$isRedirectResponse(result) {
    if (!$91c606d8f02f7c37$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $91c606d8f02f7c37$var$isValidMethod(method) {
    return $91c606d8f02f7c37$var$validRequestMethods.has(method.toLowerCase());
}
function $91c606d8f02f7c37$var$isMutationMethod(method) {
    return $91c606d8f02f7c37$var$validMutationMethods.has(method.toLowerCase());
}
async function $91c606d8f02f7c37$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$91c606d8f02f7c37$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($91c606d8f02f7c37$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $91c606d8f02f7c37$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $91c606d8f02f7c37$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($91c606d8f02f7c37$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $91c606d8f02f7c37$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $91c606d8f02f7c37$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $91c606d8f02f7c37$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $91c606d8f02f7c37$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $91c606d8f02f7c37$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $91c606d8f02f7c37$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $91c606d8f02f7c37$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $91c606d8f02f7c37$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $91c606d8f02f7c37$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $91c606d8f02f7c37$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $91c606d8f02f7c37$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $91c606d8f02f7c37$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $91c606d8f02f7c37$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $91c606d8f02f7c37$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $91c606d8f02f7c37$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $91c606d8f02f7c37$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $91c606d8f02f7c37$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $91c606d8f02f7c37$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($91c606d8f02f7c37$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $91c606d8f02f7c37$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($91c606d8f02f7c37$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $91c606d8f02f7c37$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $70fFQ = parcelRequire("70fFQ");

function $9a6b443e2c413186$var$_extends() {
    return $9a6b443e2c413186$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9a6b443e2c413186$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $9a6b443e2c413186$export$3add0d5dce533e2e = /*#__PURE__*/ $70fFQ.createContext(null);
const $9a6b443e2c413186$export$145dfa71566a64dc = /*#__PURE__*/ $70fFQ.createContext(null);
const $9a6b443e2c413186$var$AwaitContext = /*#__PURE__*/ $70fFQ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $9a6b443e2c413186$export$26749e8557646306 = /*#__PURE__*/ $70fFQ.createContext(null);
const $9a6b443e2c413186$export$c7914228fb69b0f5 = /*#__PURE__*/ $70fFQ.createContext(null);
const $9a6b443e2c413186$export$9072aa6dd1f93057 = /*#__PURE__*/ $70fFQ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $9a6b443e2c413186$var$RouteErrorContext = /*#__PURE__*/ $70fFQ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $9a6b443e2c413186$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$9a6b443e2c413186$export$9c954a9d03d32f4a() && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $70fFQ.useContext($9a6b443e2c413186$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $9a6b443e2c413186$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $91c606d8f02f7c37$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $9a6b443e2c413186$export$9c954a9d03d32f4a() {
    return $70fFQ.useContext($9a6b443e2c413186$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $9a6b443e2c413186$export$45d76561a5302f2b() {
    !$9a6b443e2c413186$export$9c954a9d03d32f4a() && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    return $70fFQ.useContext($9a6b443e2c413186$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $9a6b443e2c413186$export$1b3f31771c5d07c() {
    return $70fFQ.useContext($9a6b443e2c413186$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $9a6b443e2c413186$export$6c330e8992e8a295(pattern) {
    !$9a6b443e2c413186$export$9c954a9d03d32f4a() && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $9a6b443e2c413186$export$45d76561a5302f2b();
    return $70fFQ.useMemo(()=>(0, $91c606d8f02f7c37$export$81336c211d5ff295)(pattern, (0, $91c606d8f02f7c37$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $9a6b443e2c413186$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9a6b443e2c413186$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $70fFQ.useContext($9a6b443e2c413186$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $70fFQ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $9a6b443e2c413186$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9a6b443e2c413186$var$useNavigateStable() : $9a6b443e2c413186$var$useNavigateUnstable();
}
function $9a6b443e2c413186$var$useNavigateUnstable() {
    !$9a6b443e2c413186$export$9c954a9d03d32f4a() && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    let dataRouterContext = $70fFQ.useContext($9a6b443e2c413186$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $70fFQ.useContext($9a6b443e2c413186$export$26749e8557646306);
    let { matches: matches } = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9a6b443e2c413186$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $91c606d8f02f7c37$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $70fFQ.useRef(false);
    $9a6b443e2c413186$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $70fFQ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $91c606d8f02f7c37$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $91c606d8f02f7c37$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $9a6b443e2c413186$var$OutletContext = /*#__PURE__*/ $70fFQ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $9a6b443e2c413186$export$4138103a3ae699cc() {
    return $70fFQ.useContext($9a6b443e2c413186$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $9a6b443e2c413186$export$a3be3530d8e40d0b(context) {
    let outlet = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $9a6b443e2c413186$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $9a6b443e2c413186$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $70fFQ.useContext($9a6b443e2c413186$export$26749e8557646306);
    let { matches: matches } = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9a6b443e2c413186$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $91c606d8f02f7c37$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $70fFQ.useMemo(()=>(0, $91c606d8f02f7c37$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $9a6b443e2c413186$export$5d3fca4a98652595(routes, locationArg) {
    return $9a6b443e2c413186$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9a6b443e2c413186$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9a6b443e2c413186$export$9c954a9d03d32f4a() && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $70fFQ.useContext($9a6b443e2c413186$export$26749e8557646306);
    let { matches: parentMatches } = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $9a6b443e2c413186$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $91c606d8f02f7c37$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $91c606d8f02f7c37$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $9a6b443e2c413186$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $91c606d8f02f7c37$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $91c606d8f02f7c37$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9a6b443e2c413186$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $91c606d8f02f7c37$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9a6b443e2c413186$var$DefaultErrorComponent() {
    let error = $9a6b443e2c413186$export$ed527bf60f6e05f2();
    let message = (0, $91c606d8f02f7c37$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $70fFQ.createElement($70fFQ.Fragment, null, /*#__PURE__*/ $70fFQ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $70fFQ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $70fFQ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $9a6b443e2c413186$var$defaultErrorElement = /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$DefaultErrorComponent, null);
class $9a6b443e2c413186$var$RenderErrorBoundary extends $70fFQ.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $9a6b443e2c413186$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $70fFQ.useContext($9a6b443e2c413186$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9a6b443e2c413186$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9a6b443e2c413186$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9a6b443e2c413186$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $70fFQ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9a6b443e2c413186$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9a6b443e2c413186$var$DataRouterHook || {});
var $9a6b443e2c413186$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9a6b443e2c413186$var$DataRouterStateHook || {});
function $9a6b443e2c413186$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $9a6b443e2c413186$var$useDataRouterContext(hookName) {
    let ctx = $70fFQ.useContext($9a6b443e2c413186$export$3add0d5dce533e2e);
    !ctx && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    return ctx;
}
function $9a6b443e2c413186$var$useDataRouterState(hookName) {
    let state = $70fFQ.useContext($9a6b443e2c413186$export$145dfa71566a64dc);
    !state && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    return state;
}
function $9a6b443e2c413186$var$useRouteContext(hookName) {
    let route = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057);
    !route && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9a6b443e2c413186$var$useCurrentRouteId(hookName) {
    let route = $9a6b443e2c413186$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9a6b443e2c413186$export$5fc8298006ad9e58() {
    return $9a6b443e2c413186$var$useCurrentRouteId($9a6b443e2c413186$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9a6b443e2c413186$export$d0fd4b7106de2769() {
    let state = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9a6b443e2c413186$export$600dc272ed516c15() {
    let dataRouterContext = $9a6b443e2c413186$var$useDataRouterContext($9a6b443e2c413186$var$DataRouterHook.UseRevalidator);
    let state = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseRevalidator);
    return $70fFQ.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9a6b443e2c413186$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseMatches);
    return $70fFQ.useMemo(()=>matches.map((m)=>(0, $91c606d8f02f7c37$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9a6b443e2c413186$export$1448a5050d252c4d() {
    let state = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseLoaderData);
    let routeId = $9a6b443e2c413186$var$useCurrentRouteId($9a6b443e2c413186$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9a6b443e2c413186$export$fd5d37484eab868d(routeId) {
    let state = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9a6b443e2c413186$export$fdc00f3f26066d5e() {
    let state = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseActionData);
    let routeId = $9a6b443e2c413186$var$useCurrentRouteId($9a6b443e2c413186$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9a6b443e2c413186$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $70fFQ.useContext($9a6b443e2c413186$var$RouteErrorContext);
    let state = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseRouteError);
    let routeId = $9a6b443e2c413186$var$useCurrentRouteId($9a6b443e2c413186$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9a6b443e2c413186$export$78a72ddb39bdd145() {
    let value = $70fFQ.useContext($9a6b443e2c413186$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9a6b443e2c413186$export$17f53340677d5831() {
    let value = $70fFQ.useContext($9a6b443e2c413186$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $9a6b443e2c413186$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9a6b443e2c413186$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $9a6b443e2c413186$var$useDataRouterContext($9a6b443e2c413186$var$DataRouterHook.UseBlocker);
    let state = $9a6b443e2c413186$var$useDataRouterState($9a6b443e2c413186$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $70fFQ.useState("");
    let blockerFunction = $70fFQ.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $9a6b443e2c413186$var$_extends({}, currentLocation, {
                pathname: (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9a6b443e2c413186$var$_extends({}, nextLocation, {
                pathname: (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $70fFQ.useEffect(()=>{
        let key = String(++$9a6b443e2c413186$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $70fFQ.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $91c606d8f02f7c37$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9a6b443e2c413186$var$useNavigateStable() {
    let { router: router } = $9a6b443e2c413186$var$useDataRouterContext($9a6b443e2c413186$var$DataRouterHook.UseNavigateStable);
    let id = $9a6b443e2c413186$var$useCurrentRouteId($9a6b443e2c413186$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $70fFQ.useRef(false);
    $9a6b443e2c413186$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $70fFQ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9a6b443e2c413186$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $9a6b443e2c413186$var$alreadyWarned$1 = {};
function $9a6b443e2c413186$var$warningOnce(key, cond, message) {
    if (!cond && !$9a6b443e2c413186$var$alreadyWarned$1[key]) $9a6b443e2c413186$var$alreadyWarned$1[key] = true;
}
const $9a6b443e2c413186$var$alreadyWarned = {};
function $9a6b443e2c413186$var$warnOnce(key, message) {}
const $9a6b443e2c413186$var$logDeprecation = (flag, msg, link)=>$9a6b443e2c413186$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $9a6b443e2c413186$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $9a6b443e2c413186$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $9a6b443e2c413186$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $9a6b443e2c413186$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $9a6b443e2c413186$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $9a6b443e2c413186$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $9a6b443e2c413186$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $9a6b443e2c413186$var$START_TRANSITION = "startTransition";
const $9a6b443e2c413186$var$startTransitionImpl = $70fFQ[$9a6b443e2c413186$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9a6b443e2c413186$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $70fFQ.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $70fFQ.useCallback((newState)=>{
        if (v7_startTransition && $9a6b443e2c413186$var$startTransitionImpl) $9a6b443e2c413186$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $70fFQ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $70fFQ.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $70fFQ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $70fFQ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $70fFQ.useEffect(()=>$9a6b443e2c413186$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $70fFQ.createElement($70fFQ.Fragment, null, /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9a6b443e2c413186$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $9a6b443e2c413186$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $9a6b443e2c413186$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $70fFQ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $91c606d8f02f7c37$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $70fFQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $70fFQ.useCallback((newState)=>{
        v7_startTransition && $9a6b443e2c413186$var$startTransitionImpl ? $9a6b443e2c413186$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $70fFQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $70fFQ.useEffect(()=>$9a6b443e2c413186$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $9a6b443e2c413186$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$9a6b443e2c413186$export$9c954a9d03d32f4a() && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $70fFQ.useContext($9a6b443e2c413186$export$26749e8557646306);
    let { matches: matches } = $70fFQ.useContext($9a6b443e2c413186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9a6b443e2c413186$export$45d76561a5302f2b();
    let navigate = $9a6b443e2c413186$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $91c606d8f02f7c37$export$cae722b0cc860f13)(to, (0, $91c606d8f02f7c37$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $70fFQ.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $9a6b443e2c413186$export$910ae8079b2c2852(props) {
    return $9a6b443e2c413186$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $9a6b443e2c413186$export$e7b0ac011bb776c6(_props) {
    (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $9a6b443e2c413186$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $91c606d8f02f7c37$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$9a6b443e2c413186$export$9c954a9d03d32f4a() && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $70fFQ.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9a6b443e2c413186$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $91c606d8f02f7c37$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $70fFQ.useMemo(()=>{
        let trailingPathname = (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $9a6b443e2c413186$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $9a6b443e2c413186$export$5d3fca4a98652595($9a6b443e2c413186$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9a6b443e2c413186$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$ResolveAwait, null, children));
}
var $9a6b443e2c413186$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9a6b443e2c413186$var$AwaitRenderStatus || {});
const $9a6b443e2c413186$var$neverSettledPromise = new Promise(()=>{});
class $9a6b443e2c413186$var$AwaitErrorBoundary extends $70fFQ.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $9a6b443e2c413186$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $9a6b443e2c413186$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $9a6b443e2c413186$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $9a6b443e2c413186$var$AwaitRenderStatus.error : "_data" in promise ? $9a6b443e2c413186$var$AwaitRenderStatus.success : $9a6b443e2c413186$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $9a6b443e2c413186$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $9a6b443e2c413186$var$AwaitRenderStatus.error && promise._error instanceof (0, $91c606d8f02f7c37$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $9a6b443e2c413186$var$neverSettledPromise;
        if (status === $9a6b443e2c413186$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $9a6b443e2c413186$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $9a6b443e2c413186$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $70fFQ.createElement($9a6b443e2c413186$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9a6b443e2c413186$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $9a6b443e2c413186$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $70fFQ.createElement($70fFQ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $9a6b443e2c413186$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $70fFQ.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $70fFQ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $70fFQ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9a6b443e2c413186$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9a6b443e2c413186$export$e7b0ac011bb776c6) && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9a6b443e2c413186$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9a6b443e2c413186$export$daf73786167a7f72(matches) {
    return $9a6b443e2c413186$var$_renderMatches(matches);
}
function $9a6b443e2c413186$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $70fFQ.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $70fFQ.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $70fFQ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9a6b443e2c413186$export$f30f7e456d254e83(routes, opts) {
    return (0, $91c606d8f02f7c37$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9a6b443e2c413186$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $91c606d8f02f7c37$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9a6b443e2c413186$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $ff1ed43a67e50aba$var$_extends() {
    return $ff1ed43a67e50aba$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ff1ed43a67e50aba$var$_extends.apply(null, arguments);
}
function $ff1ed43a67e50aba$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $ff1ed43a67e50aba$var$defaultMethod = "get";
const $ff1ed43a67e50aba$var$defaultEncType = "application/x-www-form-urlencoded";
function $ff1ed43a67e50aba$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ff1ed43a67e50aba$var$isButtonElement(object) {
    return $ff1ed43a67e50aba$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ff1ed43a67e50aba$var$isFormElement(object) {
    return $ff1ed43a67e50aba$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ff1ed43a67e50aba$var$isInputElement(object) {
    return $ff1ed43a67e50aba$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ff1ed43a67e50aba$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ff1ed43a67e50aba$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ff1ed43a67e50aba$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ff1ed43a67e50aba$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ff1ed43a67e50aba$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ff1ed43a67e50aba$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $ff1ed43a67e50aba$var$_formDataSupportsSubmitter = null;
function $ff1ed43a67e50aba$var$isFormDataSubmitterSupported() {
    if ($ff1ed43a67e50aba$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ff1ed43a67e50aba$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ff1ed43a67e50aba$var$_formDataSupportsSubmitter = true;
    }
    return $ff1ed43a67e50aba$var$_formDataSupportsSubmitter;
}
const $ff1ed43a67e50aba$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ff1ed43a67e50aba$var$getFormEncType(encType) {
    if (encType != null && !$ff1ed43a67e50aba$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ff1ed43a67e50aba$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ff1ed43a67e50aba$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $ff1ed43a67e50aba$var$defaultMethod;
        encType = $ff1ed43a67e50aba$var$getFormEncType(target.getAttribute("enctype")) || $ff1ed43a67e50aba$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ff1ed43a67e50aba$var$isButtonElement(target) || $ff1ed43a67e50aba$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ff1ed43a67e50aba$var$defaultMethod;
        encType = $ff1ed43a67e50aba$var$getFormEncType(target.getAttribute("formenctype")) || $ff1ed43a67e50aba$var$getFormEncType(form.getAttribute("enctype")) || $ff1ed43a67e50aba$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ff1ed43a67e50aba$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ff1ed43a67e50aba$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ff1ed43a67e50aba$var$defaultMethod;
        action = null;
        encType = $ff1ed43a67e50aba$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $ff1ed43a67e50aba$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $ff1ed43a67e50aba$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $ff1ed43a67e50aba$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $ff1ed43a67e50aba$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $ff1ed43a67e50aba$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $ff1ed43a67e50aba$export$1f3f55432a00e06d(routes, opts) {
    return (0, $91c606d8f02f7c37$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ff1ed43a67e50aba$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $91c606d8f02f7c37$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ff1ed43a67e50aba$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9a6b443e2c413186$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ff1ed43a67e50aba$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $91c606d8f02f7c37$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ff1ed43a67e50aba$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $91c606d8f02f7c37$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ff1ed43a67e50aba$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9a6b443e2c413186$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ff1ed43a67e50aba$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ff1ed43a67e50aba$var$_extends({}, state, {
        errors: $ff1ed43a67e50aba$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ff1ed43a67e50aba$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $91c606d8f02f7c37$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $ff1ed43a67e50aba$export$7ad602f0e94e62d1 = /*#__PURE__*/ $70fFQ.createContext({
    isTransitioning: false
});
const $ff1ed43a67e50aba$export$148fd98d095596d4 = /*#__PURE__*/ $70fFQ.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ff1ed43a67e50aba$var$START_TRANSITION = "startTransition";
const $ff1ed43a67e50aba$var$startTransitionImpl = $70fFQ[$ff1ed43a67e50aba$var$START_TRANSITION];
const $ff1ed43a67e50aba$var$FLUSH_SYNC = "flushSync";
const $ff1ed43a67e50aba$var$flushSyncImpl = $3glZ1[$ff1ed43a67e50aba$var$FLUSH_SYNC];
const $ff1ed43a67e50aba$var$USE_ID = "useId";
const $ff1ed43a67e50aba$var$useIdImpl = $70fFQ[$ff1ed43a67e50aba$var$USE_ID];
function $ff1ed43a67e50aba$var$startTransitionSafe(cb) {
    if ($ff1ed43a67e50aba$var$startTransitionImpl) $ff1ed43a67e50aba$var$startTransitionImpl(cb);
    else cb();
}
function $ff1ed43a67e50aba$var$flushSyncSafe(cb) {
    if ($ff1ed43a67e50aba$var$flushSyncImpl) $ff1ed43a67e50aba$var$flushSyncImpl(cb);
    else cb();
}
class $ff1ed43a67e50aba$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ff1ed43a67e50aba$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $70fFQ.useState(router.state);
    let [pendingState, setPendingState] = $70fFQ.useState();
    let [vtContext, setVtContext] = $70fFQ.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $70fFQ.useState();
    let [transition, setTransition] = $70fFQ.useState();
    let [interruption, setInterruption] = $70fFQ.useState();
    let fetcherData = $70fFQ.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $70fFQ.useCallback((cb)=>{
        if (v7_startTransition) $ff1ed43a67e50aba$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $70fFQ.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $ff1ed43a67e50aba$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $ff1ed43a67e50aba$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $ff1ed43a67e50aba$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $ff1ed43a67e50aba$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $ff1ed43a67e50aba$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $70fFQ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $70fFQ.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ff1ed43a67e50aba$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $70fFQ.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $70fFQ.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $70fFQ.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $70fFQ.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $70fFQ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $70fFQ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $70fFQ.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $70fFQ.useEffect(()=>(0, $9a6b443e2c413186$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $70fFQ.createElement($70fFQ.Fragment, null, /*#__PURE__*/ $70fFQ.createElement((0, $9a6b443e2c413186$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $70fFQ.createElement((0, $9a6b443e2c413186$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $70fFQ.createElement($ff1ed43a67e50aba$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $70fFQ.createElement($ff1ed43a67e50aba$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $70fFQ.createElement((0, $9a6b443e2c413186$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $70fFQ.createElement($ff1ed43a67e50aba$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $ff1ed43a67e50aba$var$MemoizedDataRoutes = /*#__PURE__*/ $70fFQ.memo($ff1ed43a67e50aba$var$DataRoutes);
function $ff1ed43a67e50aba$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $9a6b443e2c413186$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ff1ed43a67e50aba$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $70fFQ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $91c606d8f02f7c37$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $70fFQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $70fFQ.useCallback((newState)=>{
        v7_startTransition && $ff1ed43a67e50aba$var$startTransitionImpl ? $ff1ed43a67e50aba$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $70fFQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $70fFQ.useEffect(()=>(0, $9a6b443e2c413186$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $70fFQ.createElement((0, $9a6b443e2c413186$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ff1ed43a67e50aba$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $70fFQ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $91c606d8f02f7c37$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $70fFQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $70fFQ.useCallback((newState)=>{
        v7_startTransition && $ff1ed43a67e50aba$var$startTransitionImpl ? $ff1ed43a67e50aba$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $70fFQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $70fFQ.useEffect(()=>(0, $9a6b443e2c413186$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $70fFQ.createElement((0, $9a6b443e2c413186$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ff1ed43a67e50aba$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $70fFQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $70fFQ.useCallback((newState)=>{
        v7_startTransition && $ff1ed43a67e50aba$var$startTransitionImpl ? $ff1ed43a67e50aba$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $70fFQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $70fFQ.useEffect(()=>(0, $9a6b443e2c413186$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $70fFQ.createElement((0, $9a6b443e2c413186$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $ff1ed43a67e50aba$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $ff1ed43a67e50aba$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $ff1ed43a67e50aba$export$a6c7ac8248d6e38a = /*#__PURE__*/ $70fFQ.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $ff1ed43a67e50aba$var$_objectWithoutPropertiesLoose(_ref7, $ff1ed43a67e50aba$var$_excluded);
    let { basename: basename } = $70fFQ.useContext((0, $9a6b443e2c413186$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $ff1ed43a67e50aba$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ff1ed43a67e50aba$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $9a6b443e2c413186$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $ff1ed43a67e50aba$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $70fFQ.createElement("a", $ff1ed43a67e50aba$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $ff1ed43a67e50aba$export$b0d92dbee9b5b60d = /*#__PURE__*/ $70fFQ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $ff1ed43a67e50aba$var$_objectWithoutPropertiesLoose(_ref8, $ff1ed43a67e50aba$var$_excluded2);
    let path = (0, $9a6b443e2c413186$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    let routerState = $70fFQ.useContext((0, $9a6b443e2c413186$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $70fFQ.useContext((0, $9a6b443e2c413186$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ff1ed43a67e50aba$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $70fFQ.createElement($ff1ed43a67e50aba$export$a6c7ac8248d6e38a, $ff1ed43a67e50aba$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $ff1ed43a67e50aba$export$a7fed597f4b8afd8 = /*#__PURE__*/ $70fFQ.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $ff1ed43a67e50aba$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $ff1ed43a67e50aba$var$_objectWithoutPropertiesLoose(_ref9, $ff1ed43a67e50aba$var$_excluded3);
    let submit = $ff1ed43a67e50aba$export$47c85c6e3a081d3();
    let formAction = $ff1ed43a67e50aba$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $70fFQ.createElement("form", $ff1ed43a67e50aba$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ff1ed43a67e50aba$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $ff1ed43a67e50aba$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ff1ed43a67e50aba$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ff1ed43a67e50aba$var$DataRouterHook || ($ff1ed43a67e50aba$var$DataRouterHook = {}));
var $ff1ed43a67e50aba$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ff1ed43a67e50aba$var$DataRouterStateHook || ($ff1ed43a67e50aba$var$DataRouterStateHook = {}));
// Internal hooks
function $ff1ed43a67e50aba$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $ff1ed43a67e50aba$var$useDataRouterContext(hookName) {
    let ctx = $70fFQ.useContext((0, $9a6b443e2c413186$export$3add0d5dce533e2e));
    !ctx && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ff1ed43a67e50aba$var$useDataRouterState(hookName) {
    let state = $70fFQ.useContext((0, $9a6b443e2c413186$export$145dfa71566a64dc));
    !state && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ff1ed43a67e50aba$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    let location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    let path = (0, $9a6b443e2c413186$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $70fFQ.useCallback((event)=>{
        if ($ff1ed43a67e50aba$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $91c606d8f02f7c37$export$fe53371bee54353d)(location) === (0, $91c606d8f02f7c37$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ff1ed43a67e50aba$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $70fFQ.useRef($ff1ed43a67e50aba$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $70fFQ.useRef(false);
    let location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    let searchParams = $70fFQ.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ff1ed43a67e50aba$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    let setSearchParams = $70fFQ.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ff1ed43a67e50aba$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ff1ed43a67e50aba$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $ff1ed43a67e50aba$var$fetcherId = 0;
let $ff1ed43a67e50aba$var$getUniqueFetcherId = ()=>"__" + String(++$ff1ed43a67e50aba$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ff1ed43a67e50aba$export$47c85c6e3a081d3() {
    let { router: router } = $ff1ed43a67e50aba$var$useDataRouterContext($ff1ed43a67e50aba$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $70fFQ.useContext((0, $9a6b443e2c413186$export$26749e8557646306));
    let currentRouteId = (0, $9a6b443e2c413186$export$5fc8298006ad9e58)();
    return $70fFQ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ff1ed43a67e50aba$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ff1ed43a67e50aba$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ff1ed43a67e50aba$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ff1ed43a67e50aba$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $70fFQ.useContext((0, $9a6b443e2c413186$export$26749e8557646306));
    let routeContext = $70fFQ.useContext((0, $9a6b443e2c413186$export$9072aa6dd1f93057));
    !routeContext && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $ff1ed43a67e50aba$var$_extends({}, (0, $9a6b443e2c413186$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $91c606d8f02f7c37$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $91c606d8f02f7c37$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ff1ed43a67e50aba$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $ff1ed43a67e50aba$var$useDataRouterContext($ff1ed43a67e50aba$var$DataRouterHook.UseFetcher);
    let state = $ff1ed43a67e50aba$var$useDataRouterState($ff1ed43a67e50aba$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $70fFQ.useContext($ff1ed43a67e50aba$export$148fd98d095596d4);
    let route = $70fFQ.useContext((0, $9a6b443e2c413186$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    !route && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $ff1ed43a67e50aba$var$useIdImpl ? $ff1ed43a67e50aba$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $70fFQ.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($ff1ed43a67e50aba$var$getUniqueFetcherId());
    // Registration/cleanup
    $70fFQ.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $70fFQ.useCallback((href, opts)=>{
        !routeId && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ff1ed43a67e50aba$export$47c85c6e3a081d3();
    let submit = $70fFQ.useCallback((target, opts)=>{
        submitImpl(target, $ff1ed43a67e50aba$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $70fFQ.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $70fFQ.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $70fFQ.createElement($ff1ed43a67e50aba$export$a7fed597f4b8afd8, $ff1ed43a67e50aba$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $91c606d8f02f7c37$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $70fFQ.useMemo(()=>$ff1ed43a67e50aba$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ff1ed43a67e50aba$export$fa996778a3a31087() {
    let state = $ff1ed43a67e50aba$var$useDataRouterState($ff1ed43a67e50aba$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $ff1ed43a67e50aba$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $ff1ed43a67e50aba$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $ff1ed43a67e50aba$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ff1ed43a67e50aba$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $ff1ed43a67e50aba$var$useDataRouterContext($ff1ed43a67e50aba$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ff1ed43a67e50aba$var$useDataRouterState($ff1ed43a67e50aba$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $70fFQ.useContext((0, $9a6b443e2c413186$export$26749e8557646306));
    let location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    let matches = (0, $9a6b443e2c413186$export$2378eb7f5ff86053)();
    let navigation = (0, $9a6b443e2c413186$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $70fFQ.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ff1ed43a67e50aba$var$usePageHide($70fFQ.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $ff1ed43a67e50aba$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ff1ed43a67e50aba$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ff1ed43a67e50aba$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $70fFQ.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ff1ed43a67e50aba$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ff1ed43a67e50aba$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $70fFQ.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($ff1ed43a67e50aba$var$_extends({}, location, {
                    pathname: (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ff1ed43a67e50aba$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $70fFQ.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ff1ed43a67e50aba$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $70fFQ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ff1ed43a67e50aba$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $70fFQ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ff1ed43a67e50aba$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $9a6b443e2c413186$export$b273b3273281a049)(when);
    $70fFQ.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $70fFQ.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ff1ed43a67e50aba$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $70fFQ.useContext($ff1ed43a67e50aba$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $91c606d8f02f7c37$export$3e9cee6b33872309)(false);
    let { basename: basename } = $ff1ed43a67e50aba$var$useDataRouterContext($ff1ed43a67e50aba$var$DataRouterHook.useViewTransitionState);
    let path = (0, $9a6b443e2c413186$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $91c606d8f02f7c37$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $91c606d8f02f7c37$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $91c606d8f02f7c37$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $e42cae22e74e223a$exports = {};

$parcel$defineInteropFlag($e42cae22e74e223a$exports);

$parcel$export($e42cae22e74e223a$exports, "isStyledComponent", function () { return $e42cae22e74e223a$export$7ba318d8d2f06c76; });
$parcel$export($e42cae22e74e223a$exports, "version", function () { return $e42cae22e74e223a$export$83d89fbfd8236492; });
$parcel$export($e42cae22e74e223a$exports, "StyleSheetContext", function () { return $e42cae22e74e223a$export$8c190ef828af4c86; });
$parcel$export($e42cae22e74e223a$exports, "StyleSheetConsumer", function () { return $e42cae22e74e223a$export$91317688fc694efa; });
$parcel$export($e42cae22e74e223a$exports, "StyleSheetManager", function () { return $e42cae22e74e223a$export$a473771da2f0ff7c; });
$parcel$export($e42cae22e74e223a$exports, "css", function () { return $e42cae22e74e223a$export$dbf350e5966cf602; });
$parcel$export($e42cae22e74e223a$exports, "ThemeContext", function () { return $e42cae22e74e223a$export$2c657da244d00bd6; });
$parcel$export($e42cae22e74e223a$exports, "ThemeConsumer", function () { return $e42cae22e74e223a$export$b631efc24e9d5e2f; });
$parcel$export($e42cae22e74e223a$exports, "ThemeProvider", function () { return $e42cae22e74e223a$export$d8964aec282183a3; });
$parcel$export($e42cae22e74e223a$exports, "createGlobalStyle", function () { return $e42cae22e74e223a$export$f0f03736edb61697; });
$parcel$export($e42cae22e74e223a$exports, "keyframes", function () { return $e42cae22e74e223a$export$d25ddfdf17c3ad3e; });
$parcel$export($e42cae22e74e223a$exports, "ServerStyleSheet", function () { return $e42cae22e74e223a$export$ae8c7d15c8b89a20; });
$parcel$export($e42cae22e74e223a$exports, "withTheme", function () { return $e42cae22e74e223a$export$e8748c6a27b910dc; });
$parcel$export($e42cae22e74e223a$exports, "useTheme", function () { return $e42cae22e74e223a$export$93d4e7f90805808f; });
$parcel$export($e42cae22e74e223a$exports, "__PRIVATE__", function () { return $e42cae22e74e223a$export$5c87cfe6c475f500; });
$parcel$export($e42cae22e74e223a$exports, "default", function () { return $e42cae22e74e223a$export$2e2bcd8739ae039; });
var $ed929961d198687b$exports = {};
'use strict';

$ed929961d198687b$exports = (parcelRequire("4GSL4"));



var $70fFQ = parcelRequire("70fFQ");
var $cf465417d1f5e24d$exports = {};
//
$cf465417d1f5e24d$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $0bfc47a828bf38d5$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $0bfc47a828bf38d5$export$2e2bcd8739ae039 = $0bfc47a828bf38d5$var$stylis_min;


var $f166b543ff6f8d23$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $f166b543ff6f8d23$export$2e2bcd8739ae039 = $f166b543ff6f8d23$var$unitlessKeys;


function $e0798f8a32ae3f97$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $e0798f8a32ae3f97$export$2e2bcd8739ae039 = $e0798f8a32ae3f97$var$memoize;


var $b2396c2a28662146$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $b2396c2a28662146$var$isPropValid = /* #__PURE__ */ (0, $e0798f8a32ae3f97$export$2e2bcd8739ae039)(function(prop) {
    return $b2396c2a28662146$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $b2396c2a28662146$export$2e2bcd8739ae039 = $b2396c2a28662146$var$isPropValid;


var $4a334922dedd850b$exports = {};
'use strict';
var $a8311da66e736797$exports = {};
'use strict';

$a8311da66e736797$exports = (parcelRequire("2vcBV"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4a334922dedd850b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4a334922dedd850b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4a334922dedd850b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4a334922dedd850b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4a334922dedd850b$var$TYPE_STATICS = {};
$4a334922dedd850b$var$TYPE_STATICS[$a8311da66e736797$exports.ForwardRef] = $4a334922dedd850b$var$FORWARD_REF_STATICS;
$4a334922dedd850b$var$TYPE_STATICS[$a8311da66e736797$exports.Memo] = $4a334922dedd850b$var$MEMO_STATICS;
function $4a334922dedd850b$var$getStatics(component) {
    // React v16.11 and below
    if ($a8311da66e736797$exports.isMemo(component)) return $4a334922dedd850b$var$MEMO_STATICS;
     // React v16.12 and above
    return $4a334922dedd850b$var$TYPE_STATICS[component['$$typeof']] || $4a334922dedd850b$var$REACT_STATICS;
}
var $4a334922dedd850b$var$defineProperty = Object.defineProperty;
var $4a334922dedd850b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4a334922dedd850b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4a334922dedd850b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4a334922dedd850b$var$getPrototypeOf = Object.getPrototypeOf;
var $4a334922dedd850b$var$objectPrototype = Object.prototype;
function $4a334922dedd850b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4a334922dedd850b$var$objectPrototype) {
            var inheritedComponent = $4a334922dedd850b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4a334922dedd850b$var$objectPrototype) $4a334922dedd850b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4a334922dedd850b$var$getOwnPropertyNames(sourceComponent);
        if ($4a334922dedd850b$var$getOwnPropertySymbols) keys = keys.concat($4a334922dedd850b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4a334922dedd850b$var$getStatics(targetComponent);
        var sourceStatics = $4a334922dedd850b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4a334922dedd850b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4a334922dedd850b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4a334922dedd850b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$4a334922dedd850b$exports = $4a334922dedd850b$var$hoistNonReactStatics;


function $e42cae22e74e223a$var$v() {
    return ($e42cae22e74e223a$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $e42cae22e74e223a$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $e42cae22e74e223a$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $ed929961d198687b$exports.typeOf)(t);
}, $e42cae22e74e223a$var$w = Object.freeze([]), $e42cae22e74e223a$var$E = Object.freeze({});
function $e42cae22e74e223a$var$b(e) {
    return "function" == typeof e;
}
function $e42cae22e74e223a$var$_(e) {
    return e.displayName || e.name || "Component";
}
function $e42cae22e74e223a$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $e42cae22e74e223a$var$A = "data-styled", $e42cae22e74e223a$export$83d89fbfd8236492 = "5.3.6", $e42cae22e74e223a$var$I = "undefined" != typeof window && "HTMLElement" in window, $e42cae22e74e223a$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $e42cae22e74e223a$var$O = {}, $e42cae22e74e223a$var$R = {};
function $e42cae22e74e223a$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $e42cae22e74e223a$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $e42cae22e74e223a$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $e42cae22e74e223a$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $e42cae22e74e223a$var$x = new Map, $e42cae22e74e223a$var$k = new Map, $e42cae22e74e223a$var$V = 1, $e42cae22e74e223a$var$B = function(e) {
    if ($e42cae22e74e223a$var$x.has(e)) return $e42cae22e74e223a$var$x.get(e);
    for(; $e42cae22e74e223a$var$k.has($e42cae22e74e223a$var$V);)$e42cae22e74e223a$var$V++;
    var t = $e42cae22e74e223a$var$V++;
    return $e42cae22e74e223a$var$x.set(e, t), $e42cae22e74e223a$var$k.set(t, e), t;
}, $e42cae22e74e223a$var$z = function(e) {
    return $e42cae22e74e223a$var$k.get(e);
}, $e42cae22e74e223a$var$M = function(e, t) {
    t >= $e42cae22e74e223a$var$V && ($e42cae22e74e223a$var$V = t + 1), $e42cae22e74e223a$var$x.set(e, t), $e42cae22e74e223a$var$k.set(t, e);
}, $e42cae22e74e223a$var$G = "style[" + $e42cae22e74e223a$var$A + '][data-styled-version="5.3.6"]', $e42cae22e74e223a$var$L = new RegExp("^" + $e42cae22e74e223a$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $e42cae22e74e223a$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $e42cae22e74e223a$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($e42cae22e74e223a$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($e42cae22e74e223a$var$M(u, c), $e42cae22e74e223a$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $e42cae22e74e223a$var$q = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $e42cae22e74e223a$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($e42cae22e74e223a$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($e42cae22e74e223a$var$A, "active"), r.setAttribute("data-styled-version", "5.3.6");
    var i = $e42cae22e74e223a$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $e42cae22e74e223a$var$$ = function() {
    function e(e) {
        var t = this.element = $e42cae22e74e223a$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $e42cae22e74e223a$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $e42cae22e74e223a$var$W = function() {
    function e(e) {
        var t = this.element = $e42cae22e74e223a$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e42cae22e74e223a$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e42cae22e74e223a$var$J = $e42cae22e74e223a$var$I, $e42cae22e74e223a$var$X = {
    isServer: !$e42cae22e74e223a$var$I,
    useCSSOMInjection: !$e42cae22e74e223a$var$P
}, $e42cae22e74e223a$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $e42cae22e74e223a$var$E), void 0 === t && (t = {}), this.options = $e42cae22e74e223a$var$v({}, $e42cae22e74e223a$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $e42cae22e74e223a$var$I && $e42cae22e74e223a$var$J && ($e42cae22e74e223a$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($e42cae22e74e223a$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($e42cae22e74e223a$var$A) && ($e42cae22e74e223a$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $e42cae22e74e223a$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($e42cae22e74e223a$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $e42cae22e74e223a$var$U(o) : r ? new $e42cae22e74e223a$var$$(o) : new $e42cae22e74e223a$var$W(o), new $e42cae22e74e223a$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($e42cae22e74e223a$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e42cae22e74e223a$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($e42cae22e74e223a$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $e42cae22e74e223a$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $e42cae22e74e223a$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $e42cae22e74e223a$var$K = /(a)(d)/gi, $e42cae22e74e223a$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e42cae22e74e223a$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $e42cae22e74e223a$var$Q(t % 52) + n;
    return ($e42cae22e74e223a$var$Q(t % 52) + n).replace($e42cae22e74e223a$var$K, "$1-$2");
}
var $e42cae22e74e223a$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e42cae22e74e223a$var$ne = function(e) {
    return $e42cae22e74e223a$var$te(5381, e);
};
function $e42cae22e74e223a$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e42cae22e74e223a$var$b(n) && !$e42cae22e74e223a$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e42cae22e74e223a$var$oe = $e42cae22e74e223a$var$ne("5.3.6"), $e42cae22e74e223a$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e42cae22e74e223a$var$re(e), this.componentId = t, this.baseHash = $e42cae22e74e223a$var$te($e42cae22e74e223a$var$oe, t), this.baseStyle = n, $e42cae22e74e223a$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $e42cae22e74e223a$var$Ne(this.rules, e, t, n).join(""), i = $e42cae22e74e223a$var$ee($e42cae22e74e223a$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $e42cae22e74e223a$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $e42cae22e74e223a$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $e42cae22e74e223a$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $e42cae22e74e223a$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $e42cae22e74e223a$var$ie = /^\s*\/\/.*$/gm, $e42cae22e74e223a$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $e42cae22e74e223a$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $e42cae22e74e223a$var$E : e, i = s.options, a = void 0 === i ? $e42cae22e74e223a$var$E : i, c = s.plugins, u = void 0 === c ? $e42cae22e74e223a$var$w : c, l = new (0, $0bfc47a828bf38d5$export$2e2bcd8739ae039)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $e42cae22e74e223a$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($e42cae22e74e223a$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $e42cae22e74e223a$var$j(15), $e42cae22e74e223a$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $e42cae22e74e223a$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(), $e42cae22e74e223a$export$91317688fc694efa = $e42cae22e74e223a$export$8c190ef828af4c86.Consumer, $e42cae22e74e223a$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(), $e42cae22e74e223a$var$he = ($e42cae22e74e223a$var$de.Consumer, new $e42cae22e74e223a$var$Z), $e42cae22e74e223a$var$pe = $e42cae22e74e223a$var$ce();
function $e42cae22e74e223a$var$fe() {
    return (0, $70fFQ.useContext)($e42cae22e74e223a$export$8c190ef828af4c86) || $e42cae22e74e223a$var$he;
}
function $e42cae22e74e223a$var$me() {
    return (0, $70fFQ.useContext)($e42cae22e74e223a$var$de) || $e42cae22e74e223a$var$pe;
}
function $e42cae22e74e223a$export$a473771da2f0ff7c(e) {
    var t = (0, $70fFQ.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $e42cae22e74e223a$var$fe(), u = (0, $70fFQ.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $70fFQ.useMemo)(function() {
        return $e42cae22e74e223a$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $70fFQ.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cf465417d1f5e24d$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e42cae22e74e223a$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e42cae22e74e223a$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $e42cae22e74e223a$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e42cae22e74e223a$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $e42cae22e74e223a$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e42cae22e74e223a$var$pe), this.name + e.hash;
    }, e;
}(), $e42cae22e74e223a$var$ge = /([A-Z])/, $e42cae22e74e223a$var$Se = /([A-Z])/g, $e42cae22e74e223a$var$we = /^ms-/, $e42cae22e74e223a$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $e42cae22e74e223a$var$be(e) {
    return $e42cae22e74e223a$var$ge.test(e) ? e.replace($e42cae22e74e223a$var$Se, $e42cae22e74e223a$var$Ee).replace($e42cae22e74e223a$var$we, "-ms-") : e;
}
var $e42cae22e74e223a$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $e42cae22e74e223a$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $e42cae22e74e223a$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($e42cae22e74e223a$var$_e(e)) return "";
    if ($e42cae22e74e223a$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($e42cae22e74e223a$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $e42cae22e74e223a$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $e42cae22e74e223a$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $e42cae22e74e223a$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$e42cae22e74e223a$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $e42cae22e74e223a$var$b(t[i]) ? s.push($e42cae22e74e223a$var$be(i) + ":", t[i], ";") : $e42cae22e74e223a$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($e42cae22e74e223a$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $f166b543ff6f8d23$export$2e2bcd8739ae039) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $e42cae22e74e223a$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $e42cae22e74e223a$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $e42cae22e74e223a$var$b(e) || $e42cae22e74e223a$var$S(e) ? $e42cae22e74e223a$var$Ae($e42cae22e74e223a$var$Ne($e42cae22e74e223a$var$g($e42cae22e74e223a$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $e42cae22e74e223a$var$Ae($e42cae22e74e223a$var$Ne($e42cae22e74e223a$var$g(e, n)));
}
var $e42cae22e74e223a$var$Ie = /invalid hook call/i, $e42cae22e74e223a$var$Pe = new Set, $e42cae22e74e223a$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $e42cae22e74e223a$var$Re = function(e, t, n) {
    return void 0 === n && (n = $e42cae22e74e223a$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $e42cae22e74e223a$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e42cae22e74e223a$var$je = /(^-|-$)/g;
function $e42cae22e74e223a$var$Te(e) {
    return e.replace($e42cae22e74e223a$var$De, "-").replace($e42cae22e74e223a$var$je, "");
}
var $e42cae22e74e223a$var$xe = function(e) {
    return $e42cae22e74e223a$var$ee($e42cae22e74e223a$var$ne(e) >>> 0);
};
function $e42cae22e74e223a$var$ke(e) {
    return "string" == typeof e && true;
}
var $e42cae22e74e223a$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $e42cae22e74e223a$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $e42cae22e74e223a$var$ze(e, t, n) {
    var r = e[n];
    $e42cae22e74e223a$var$Ve(t) && $e42cae22e74e223a$var$Ve(r) ? $e42cae22e74e223a$var$Me(r, t) : e[n] = t;
}
function $e42cae22e74e223a$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($e42cae22e74e223a$var$Ve(i)) for(var a in i)$e42cae22e74e223a$var$Be(a) && $e42cae22e74e223a$var$ze(e, i[a], a);
    }
    return e;
}
var $e42cae22e74e223a$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(), $e42cae22e74e223a$export$b631efc24e9d5e2f = $e42cae22e74e223a$export$2c657da244d00bd6.Consumer;
function $e42cae22e74e223a$export$d8964aec282183a3(e) {
    var t = (0, $70fFQ.useContext)($e42cae22e74e223a$export$2c657da244d00bd6), n = (0, $70fFQ.useMemo)(function() {
        return function(e, t) {
            if (!e) return $e42cae22e74e223a$var$j(14);
            if ($e42cae22e74e223a$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $e42cae22e74e223a$var$j(8) : t ? $e42cae22e74e223a$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e42cae22e74e223a$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $e42cae22e74e223a$var$Ye = {};
function $e42cae22e74e223a$var$qe(e, t, n) {
    var o = $e42cae22e74e223a$export$7ba318d8d2f06c76(e), i = !$e42cae22e74e223a$var$ke(e), a = t.attrs, c = void 0 === a ? $e42cae22e74e223a$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e42cae22e74e223a$var$Te(e);
        $e42cae22e74e223a$var$Ye[n] = ($e42cae22e74e223a$var$Ye[n] || 0) + 1;
        var r = n + "-" + $e42cae22e74e223a$var$xe("5.3.6" + n + $e42cae22e74e223a$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $e42cae22e74e223a$var$ke(e) ? "styled." + e : "Styled(" + $e42cae22e74e223a$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $e42cae22e74e223a$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $e42cae22e74e223a$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $e42cae22e74e223a$var$E);
                var r = $e42cae22e74e223a$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $e42cae22e74e223a$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($e42cae22e74e223a$var$Re(t, (0, $70fFQ.useContext)($e42cae22e74e223a$export$2c657da244d00bd6), a) || $e42cae22e74e223a$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $e42cae22e74e223a$var$fe(), s = $e42cae22e74e223a$var$me(), i = t ? e.generateAndInjectStyles($e42cae22e74e223a$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $e42cae22e74e223a$var$ke(_), A = g !== t ? $e42cae22e74e223a$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $b2396c2a28662146$export$2e2bcd8739ae039), _) : !N || (0, $b2396c2a28662146$export$2e2bcd8739ae039)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $e42cae22e74e223a$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $70fFQ.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $e42cae22e74e223a$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($e42cae22e74e223a$var$ke(e) ? e : $e42cae22e74e223a$var$Te($e42cae22e74e223a$var$_(e)));
        return $e42cae22e74e223a$var$qe(e, $e42cae22e74e223a$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $e42cae22e74e223a$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($4a334922dedd850b$exports)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $e42cae22e74e223a$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $e42cae22e74e223a$var$E), !(0, $ed929961d198687b$exports.isValidElementType)(r)) return $e42cae22e74e223a$var$j(1, String(r));
        var s = function() {
            return t(r, o, $e42cae22e74e223a$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $e42cae22e74e223a$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $e42cae22e74e223a$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($e42cae22e74e223a$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $e42cae22e74e223a$var$He[e] = $e42cae22e74e223a$var$He(e);
});
var $e42cae22e74e223a$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e42cae22e74e223a$var$re(e), $e42cae22e74e223a$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($e42cae22e74e223a$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $e42cae22e74e223a$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $e42cae22e74e223a$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $e42cae22e74e223a$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $e42cae22e74e223a$var$xe(JSON.stringify(i)), u = new $e42cae22e74e223a$var$$e(i, a);
    function l(e) {
        var t = $e42cae22e74e223a$var$fe(), n = $e42cae22e74e223a$var$me(), o = (0, $70fFQ.useContext)($e42cae22e74e223a$export$2c657da244d00bd6), l = (0, $70fFQ.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $70fFQ.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $e42cae22e74e223a$var$O, n, o);
        else {
            var s = $e42cae22e74e223a$var$v({}, t, {
                theme: $e42cae22e74e223a$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).memo(l);
}
function $e42cae22e74e223a$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $e42cae22e74e223a$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $e42cae22e74e223a$var$xe(o);
    return new $e42cae22e74e223a$var$ve(s, o);
}
var $e42cae22e74e223a$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e42cae22e74e223a$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $e42cae22e74e223a$var$A + '="true"',
                'data-styled-version="5.3.6"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $e42cae22e74e223a$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $e42cae22e74e223a$var$j(2);
            var n = ((t = {})[$e42cae22e74e223a$var$A] = "", t["data-styled-version"] = "5.3.6", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $e42cae22e74e223a$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("style", $e42cae22e74e223a$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e42cae22e74e223a$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $e42cae22e74e223a$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e42cae22e74e223a$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $e42cae22e74e223a$var$j(3);
    }, e;
}(), $e42cae22e74e223a$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(function(t, n) {
        var o = (0, $70fFQ.useContext)($e42cae22e74e223a$export$2c657da244d00bd6), i = e.defaultProps, a = $e42cae22e74e223a$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(e, $e42cae22e74e223a$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($4a334922dedd850b$exports)))(t, e), t.displayName = "WithTheme(" + $e42cae22e74e223a$var$_(e) + ")", t;
}, $e42cae22e74e223a$export$93d4e7f90805808f = function() {
    return (0, $70fFQ.useContext)($e42cae22e74e223a$export$2c657da244d00bd6);
}, $e42cae22e74e223a$export$5c87cfe6c475f500 = {
    StyleSheet: $e42cae22e74e223a$var$Z,
    masterSheet: $e42cae22e74e223a$var$he
};
var $e42cae22e74e223a$export$2e2bcd8739ae039 = $e42cae22e74e223a$var$He;


var $dfd33cee3229493c$exports = {};


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");

var $hI4Hx = parcelRequire("hI4Hx");



function $53548097e910e6ba$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $70fFQ = parcelRequire("70fFQ");


//      
var $0d6cd897c1522156$var$charCodeOfDot = ".".charCodeAt(0);
var $0d6cd897c1522156$var$reEscapeChar = /\\(\\)?/g;
var $0d6cd897c1522156$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $0d6cd897c1522156$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $0d6cd897c1522156$var$charCodeOfDot) result.push("");
    string.replace($0d6cd897c1522156$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($0d6cd897c1522156$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $0d6cd897c1522156$var$keysCache = {};
var $0d6cd897c1522156$var$keysRegex = /[.[\]]+/;
var $0d6cd897c1522156$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($0d6cd897c1522156$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $0d6cd897c1522156$var$keysCache[key] = key.split($0d6cd897c1522156$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $0d6cd897c1522156$var$keysCache[key] = $0d6cd897c1522156$var$stringToPath(key);
    }
    return $0d6cd897c1522156$var$keysCache[key];
};
//      
var $0d6cd897c1522156$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $0d6cd897c1522156$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $0d6cd897c1522156$var$_toPropertyKey(arg) {
    var key = $0d6cd897c1522156$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $0d6cd897c1522156$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0d6cd897c1522156$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $53548097e910e6ba$export$2e2bcd8739ae039)(current, [
                key
            ].map($0d6cd897c1522156$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $0d6cd897c1522156$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $0d6cd897c1522156$var$setInRecursor(state, 0, $0d6cd897c1522156$var$toPath(key), value1, destroyArrays);
};
var $0d6cd897c1522156$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $0d6cd897c1522156$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $0d6cd897c1522156$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $0d6cd897c1522156$export$c52e5867d5879e24(values, name);
    var error = $0d6cd897c1522156$export$c52e5867d5879e24(errors, name);
    if (error && error[$0d6cd897c1522156$export$735bebc8ffabf28a]) error = error[$0d6cd897c1522156$export$735bebc8ffabf28a];
    var submitError = submitErrors && $0d6cd897c1522156$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $0d6cd897c1522156$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($0d6cd897c1522156$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $0d6cd897c1522156$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $0d6cd897c1522156$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $0d6cd897c1522156$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$0d6cd897c1522156$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $0d6cd897c1522156$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $0d6cd897c1522156$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $0d6cd897c1522156$var$subscriptionFilter(result, state, previousState, subscription, $0d6cd897c1522156$export$41e855cb628c1b55, $0d6cd897c1522156$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $0d6cd897c1522156$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $0d6cd897c1522156$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $0d6cd897c1522156$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $0d6cd897c1522156$var$subscriptionFilter(result, state, previousState, subscription, $0d6cd897c1522156$export$f1ff97b9d1c7a3c3, $0d6cd897c1522156$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $0d6cd897c1522156$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$0d6cd897c1522156$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $0d6cd897c1522156$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $0d6cd897c1522156$export$83d89fbfd8236492 = "4.20.10";
var $0d6cd897c1522156$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $0d6cd897c1522156$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $0d6cd897c1522156$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $0d6cd897c1522156$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $0d6cd897c1522156$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $0d6cd897c1522156$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $0d6cd897c1522156$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $0d6cd897c1522156$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($0d6cd897c1522156$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $0d6cd897c1522156$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $0d6cd897c1522156$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $0d6cd897c1522156$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $0d6cd897c1522156$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $0d6cd897c1522156$export$e6bdf135a54e021b,
                    shallowEqual: $0d6cd897c1522156$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state.formState.values)); // clone to avoid writing
            if ($0d6cd897c1522156$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($0d6cd897c1522156$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $0d6cd897c1522156$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $0d6cd897c1522156$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $0d6cd897c1522156$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $0d6cd897c1522156$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $0d6cd897c1522156$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$0d6cd897c1522156$export$735bebc8ffabf28a]) {
                    var existing = $0d6cd897c1522156$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$0d6cd897c1522156$export$735bebc8ffabf28a] = error[$0d6cd897c1522156$export$735bebc8ffabf28a];
                    merged = $0d6cd897c1522156$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$0d6cd897c1522156$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$0d6cd897c1522156$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $0d6cd897c1522156$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $0d6cd897c1522156$var$notify(fieldSubscriber, fieldState, lastFieldState, $0d6cd897c1522156$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $0d6cd897c1522156$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($0d6cd897c1522156$export$c52e5867d5879e24(formState.values, key), $0d6cd897c1522156$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($0d6cd897c1522156$export$c52e5867d5879e24(formState.values, key), $0d6cd897c1522156$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$0d6cd897c1522156$var$hasAnyError(formState.errors) && !(formState.submitErrors && $0d6cd897c1522156$var$hasAnyError(formState.submitErrors));
        var nextFormState = $0d6cd897c1522156$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $0d6cd897c1522156$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $0d6cd897c1522156$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $0d6cd897c1522156$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $0d6cd897c1522156$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $0d6cd897c1522156$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $0d6cd897c1522156$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $0d6cd897c1522156$var$notify(state.subscribers, nextFormState, lastFormState, $0d6cd897c1522156$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($0d6cd897c1522156$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($0d6cd897c1522156$export$c52e5867d5879e24(formState.values, key), $0d6cd897c1522156$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $0d6cd897c1522156$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $0d6cd897c1522156$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $0d6cd897c1522156$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $0d6cd897c1522156$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $0d6cd897c1522156$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $0d6cd897c1522156$export$c52e5867d5879e24(state.formState.values, name) === $0d6cd897c1522156$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $0d6cd897c1522156$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $0d6cd897c1522156$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $0d6cd897c1522156$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$0d6cd897c1522156$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $0d6cd897c1522156$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $0d6cd897c1522156$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $0d6cd897c1522156$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $0d6cd897c1522156$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}


var $42456926338d44c1$var$_excluded$3 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $42456926338d44c1$var$renderComponent(props, lazyProps, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, $53548097e910e6ba$export$2e2bcd8739ae039)(props, $42456926338d44c1$var$_excluded$3);
    if (component) return /*#__PURE__*/ $70fFQ.createElement(component, Object.assign(lazyProps, rest, {
        children: children,
        render: render
    }));
    if (render) return render(children === undefined ? Object.assign(lazyProps, rest) : Object.assign(lazyProps, rest, {
        children: children
    }));
    if (typeof children !== "function") throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    return children(Object.assign(lazyProps, rest));
}
function $42456926338d44c1$var$useWhenValueChanges(value, callback, isEqual) {
    if (isEqual === void 0) isEqual = function isEqual(a, b) {
        return a === b;
    };
    var previous = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        if (!isEqual(value, previous.current)) {
            callback();
            previous.current = value;
        }
    });
}
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */ function $42456926338d44c1$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef();
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $42456926338d44c1$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
var $42456926338d44c1$var$isSyntheticEvent = function isSyntheticEvent(candidate) {
    return !!(candidate && typeof candidate.stopPropagation === "function");
};
var $42456926338d44c1$var$ReactFinalFormContext = /*#__PURE__*/ $70fFQ.createContext();
function $42456926338d44c1$var$useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        ref.current = value;
    });
    return ref;
}
var $42456926338d44c1$export$83d89fbfd8236492 = "6.5.8";
var $42456926338d44c1$var$addLazyState = function addLazyState(dest, state, keys) {
    keys.forEach(function(key) {
        Object.defineProperty(dest, key, {
            get: function get() {
                return state[key];
            },
            enumerable: true
        });
    });
};
var $42456926338d44c1$var$addLazyFormState = function addLazyFormState(dest, state) {
    return $42456926338d44c1$var$addLazyState(dest, state, [
        "active",
        "dirty",
        "dirtyFields",
        "dirtySinceLastSubmit",
        "dirtyFieldsSinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ]);
};
var $42456926338d44c1$var$addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
    return $42456926338d44c1$var$addLazyState(dest, state, [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "visited"
    ]);
};
var $42456926338d44c1$var$_excluded$2 = [
    "debug",
    "decorators",
    "destroyOnUnregister",
    "form",
    "initialValues",
    "initialValuesEqual",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "subscription",
    "validate",
    "validateOnBlur"
];
var $42456926338d44c1$var$versions = {
    "final-form": (0, $0d6cd897c1522156$export$83d89fbfd8236492),
    "react-final-form": $42456926338d44c1$export$83d89fbfd8236492
};
var $42456926338d44c1$var$all$1 = (0, $0d6cd897c1522156$export$f1ff97b9d1c7a3c3).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
function $42456926338d44c1$export$a7fed597f4b8afd8(_ref) {
    var debug = _ref.debug, _ref$decorators = _ref.decorators, decorators = _ref$decorators === void 0 ? [] : _ref$decorators, destroyOnUnregister = _ref.destroyOnUnregister, alternateFormApi = _ref.form, initialValues = _ref.initialValues, initialValuesEqual = _ref.initialValuesEqual, keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize, mutators = _ref.mutators, onSubmit = _ref.onSubmit, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $42456926338d44c1$var$all$1 : _ref$subscription, validate = _ref.validate, validateOnBlur = _ref.validateOnBlur, rest = (0, $53548097e910e6ba$export$2e2bcd8739ae039)(_ref, $42456926338d44c1$var$_excluded$2);
    var config = {
        debug: debug,
        destroyOnUnregister: destroyOnUnregister,
        initialValues: initialValues,
        keepDirtyOnReinitialize: keepDirtyOnReinitialize,
        mutators: mutators,
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: validateOnBlur
    };
    var form = $42456926338d44c1$var$useConstant(function() {
        var f = alternateFormApi || (0, $0d6cd897c1522156$export$f681a8129d2e9d28)(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
        f.pauseValidation();
        return f;
    }); // synchronously register and unregister to query form state for our subscription on first render
    var _React$useState = $70fFQ.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1]; // save a copy of state that can break through the closure
    // on the shallowEqual() line below.
    var stateRef = $42456926338d44c1$var$useLatest(state);
    $70fFQ.useEffect(function() {
        // We have rendered, so all fields are now registered, so we can unpause validation
        form.isValidationPaused() && form.resumeValidation();
        var unsubscriptions = [
            form.subscribe(function(s) {
                if (!$42456926338d44c1$var$shallowEqual(s, stateRef.current)) setState(s);
            }, subscription)
        ].concat(decorators ? decorators.map(function(decorator) {
            return(// istanbul ignore next
            decorator(form));
        }) : []);
        return function() {
            form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
            unsubscriptions.reverse().forEach(function(unsubscribe) {
                return unsubscribe();
            }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, decorators); // warn about decorator changes
    $42456926338d44c1$var$useWhenValueChanges(debug, function() {
        form.setConfig("debug", debug);
    });
    $42456926338d44c1$var$useWhenValueChanges(destroyOnUnregister, function() {
        form.destroyOnUnregister = !!destroyOnUnregister;
    });
    $42456926338d44c1$var$useWhenValueChanges(keepDirtyOnReinitialize, function() {
        form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
    });
    $42456926338d44c1$var$useWhenValueChanges(initialValues, function() {
        form.setConfig("initialValues", initialValues);
    }, initialValuesEqual || $42456926338d44c1$var$shallowEqual);
    $42456926338d44c1$var$useWhenValueChanges(mutators, function() {
        form.setConfig("mutators", mutators);
    });
    $42456926338d44c1$var$useWhenValueChanges(onSubmit, function() {
        form.setConfig("onSubmit", onSubmit);
    });
    $42456926338d44c1$var$useWhenValueChanges(validate, function() {
        form.setConfig("validate", validate);
    });
    $42456926338d44c1$var$useWhenValueChanges(validateOnBlur, function() {
        form.setConfig("validateOnBlur", validateOnBlur);
    });
    var handleSubmit = function handleSubmit(event) {
        if (event) {
            // sometimes not true, e.g. React Native
            if (typeof event.preventDefault === "function") event.preventDefault();
            if (typeof event.stopPropagation === "function") // prevent any outer forms from receiving the event too
            event.stopPropagation();
        }
        return form.submit();
    };
    var renderProps = {
        form: (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, form, {
            reset: function reset(eventOrValues) {
                if ($42456926338d44c1$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                form.reset();
                else form.reset(eventOrValues);
            }
        }),
        handleSubmit: handleSubmit
    };
    $42456926338d44c1$var$addLazyFormState(renderProps, state);
    return /*#__PURE__*/ $70fFQ.createElement($42456926338d44c1$var$ReactFinalFormContext.Provider, {
        value: form
    }, $42456926338d44c1$var$renderComponent((0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, rest, {
        __versions: $42456926338d44c1$var$versions
    }), renderProps, "ReactFinalForm"));
}
function $42456926338d44c1$export$87c0cf8eb5a167e0(componentName) {
    var form = $70fFQ.useContext($42456926338d44c1$var$ReactFinalFormContext);
    if (!form) throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
    return form;
}
function $42456926338d44c1$export$606f11b2eb45ecc6(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, onChange = _ref.onChange, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $42456926338d44c1$var$all$1 : _ref$subscription;
    var form = $42456926338d44c1$export$87c0cf8eb5a167e0("useFormState");
    var firstRender = $70fFQ.useRef(true);
    var onChangeRef = $70fFQ.useRef(onChange);
    onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $70fFQ.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        if (onChange) onChange(initialState);
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $70fFQ.useEffect(function() {
        return form.subscribe(function(newState) {
            if (firstRender.current) firstRender.current = false;
            else {
                setState(newState);
                if (onChangeRef.current) onChangeRef.current(newState);
            }
        }, subscription);
    }, []);
    var lazyState = {};
    $42456926338d44c1$var$addLazyFormState(lazyState, state);
    return lazyState;
}
var $42456926338d44c1$var$_excluded$1 = [
    "onChange",
    "subscription"
];
function $42456926338d44c1$export$d2e89184086487cb(_ref) {
    var onChange = _ref.onChange, subscription = _ref.subscription, rest = (0, $53548097e910e6ba$export$2e2bcd8739ae039)(_ref, $42456926338d44c1$var$_excluded$1);
    var reactFinalForm = $42456926338d44c1$export$87c0cf8eb5a167e0("FormSpy");
    var state = $42456926338d44c1$export$606f11b2eb45ecc6({
        onChange: onChange,
        subscription: subscription
    });
    if (onChange) return null;
    var renderProps = {
        form: (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, reactFinalForm, {
            reset: function reset(eventOrValues) {
                if ($42456926338d44c1$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                reactFinalForm.reset();
                else reactFinalForm.reset(eventOrValues);
            }
        })
    };
    return $42456926338d44c1$var$renderComponent((0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, rest, renderProps), state, "FormSpy");
}
var $42456926338d44c1$var$isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var $42456926338d44c1$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $42456926338d44c1$var$getValue = function getValue(event, currentValue, valueProp, isReactNative) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
    if (isReactNative && event.nativeEvent) return event.nativeEvent.text;
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked;
    switch(type){
        case "checkbox":
            if (valueProp !== undefined) {
                // we are maintaining an array, not just a boolean
                if (checked) // add value to current array value
                return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [
                    valueProp
                ];
                else {
                    // remove value from current array value
                    if (!Array.isArray(currentValue)) return currentValue;
                    var index = currentValue.indexOf(valueProp);
                    if (index < 0) return currentValue;
                    else return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
                }
            } else // it's just a boolean
            return !!checked;
        case "select-multiple":
            return $42456926338d44c1$var$getSelectedValues(event.target.options);
        default:
            return value;
    }
};
/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */ function $42456926338d44c1$var$useConstantCallback(callback) {
    var ref = $70fFQ.useRef(callback);
    $70fFQ.useEffect(function() {
        ref.current = callback;
    });
    return $70fFQ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(null, args);
    }, []);
}
var $42456926338d44c1$var$all = (0, $0d6cd897c1522156$export$41e855cb628c1b55).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $42456926338d44c1$var$defaultFormat = function defaultFormat(value, name) {
    return value === undefined ? "" : value;
};
var $42456926338d44c1$var$defaultParse = function defaultParse(value, name) {
    return value === "" ? undefined : value;
};
var $42456926338d44c1$var$defaultIsEqual = function defaultIsEqual(a, b) {
    return a === b;
};
function $42456926338d44c1$export$294aa081a6c6f55d(name, config) {
    if (config === void 0) config = {};
    var _config = config, afterSubmit = _config.afterSubmit, allowNull = _config.allowNull, component = _config.component, data = _config.data, defaultValue = _config.defaultValue, _config$format = _config.format, format = _config$format === void 0 ? $42456926338d44c1$var$defaultFormat : _config$format, formatOnBlur = _config.formatOnBlur, initialValue = _config.initialValue, multiple = _config.multiple, _config$parse = _config.parse, parse = _config$parse === void 0 ? $42456926338d44c1$var$defaultParse : _config$parse, _config$subscription = _config.subscription, subscription = _config$subscription === void 0 ? $42456926338d44c1$var$all : _config$subscription, type = _config.type, validateFields = _config.validateFields, _value = _config.value;
    var form = $42456926338d44c1$export$87c0cf8eb5a167e0("useField");
    var configRef = $42456926338d44c1$var$useLatest(config);
    var register = function register(callback, silent) {
        return(// because they would refer `state` from current execution context
        // whereas actual `state` would defined in the subsequent `useField` hook
        // execution
        // (that would be caused by `setState` call performed in `register` callback)
        form.registerField(name, callback, subscription, {
            afterSubmit: afterSubmit,
            beforeSubmit: function beforeSubmit() {
                var _configRef$current = configRef.current, beforeSubmit = _configRef$current.beforeSubmit, formatOnBlur = _configRef$current.formatOnBlur, _configRef$current$fo = _configRef$current.format, format = _configRef$current$fo === void 0 ? $42456926338d44c1$var$defaultFormat : _configRef$current$fo;
                if (formatOnBlur) {
                    var _ref = form.getFieldState(name), value = _ref.value;
                    var formatted = format(value, name);
                    if (formatted !== value) form.change(name, formatted);
                }
                return beforeSubmit && beforeSubmit();
            },
            data: data,
            defaultValue: defaultValue,
            getValidator: function getValidator() {
                return configRef.current.validate;
            },
            initialValue: initialValue,
            isEqual: function isEqual(a, b) {
                return (configRef.current.isEqual || $42456926338d44c1$var$defaultIsEqual)(a, b);
            },
            silent: silent,
            validateFields: validateFields
        }));
    };
    var firstRender = $70fFQ.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $70fFQ.useState(function() {
        var initialState = {}; // temporarily disable destroyOnUnregister
        // temporarily disable destroyOnUnregister
        var destroyOnUnregister = form.destroyOnUnregister;
        form.destroyOnUnregister = false;
        register(function(state) {
            initialState = state;
        }, true)(); // return destroyOnUnregister to its original value
        // return destroyOnUnregister to its original value
        form.destroyOnUnregister = destroyOnUnregister;
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $70fFQ.useEffect(function() {
        return register(function(state) {
            if (firstRender.current) firstRender.current = false;
            else setState(state);
        }, false);
    }, [
        name,
        data,
        defaultValue,
        // cannot reregister field every time validate function !==.
        // validate,
        initialValue // The validateFields array is often passed as validateFields={[]}, creating
    ]);
    var meta = {};
    $42456926338d44c1$var$addLazyFieldMetaState(meta, state);
    var input = {
        name: name,
        get value () {
            var value = state.value;
            if (formatOnBlur) {
                if (component === "input") value = $42456926338d44c1$var$defaultFormat(value);
            } else value = format(value, name);
            if (value === null && !allowNull) value = "";
            if (type === "checkbox" || type === "radio") return _value;
            else if (component === "select" && multiple) return value || [];
            return value;
        },
        get checked () {
            var value1 = state.value;
            if (type === "checkbox") {
                value1 = format(value1, name);
                if (_value === undefined) return !!value1;
                else return !!(Array.isArray(value1) && ~value1.indexOf(_value));
            } else if (type === "radio") return format(value1, name) === _value;
            return undefined;
        },
        onBlur: $42456926338d44c1$var$useConstantCallback(function(event) {
            state.blur();
            if (formatOnBlur) {
                /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */ var fieldState = form.getFieldState(state.name);
                state.change(format(fieldState.value, state.name));
            }
        }),
        onChange: $42456926338d44c1$var$useConstantCallback(function(event) {
            var targetType, unknown, _value2;
            var value = event && event.target ? $42456926338d44c1$var$getValue(event, state.value, _value, $42456926338d44c1$var$isReactNative) : event;
            state.change(parse(value, name));
        }),
        onFocus: $42456926338d44c1$var$useConstantCallback(function(event) {
            return state.focus();
        })
    };
    if (multiple) input.multiple = multiple;
    if (type !== undefined) input.type = type;
    var renderProps = {
        input: input,
        meta: meta
    }; // assign to force Flow check
    return renderProps;
}
var $42456926338d44c1$var$_excluded = [
    "afterSubmit",
    "allowNull",
    "beforeSubmit",
    "children",
    "component",
    "data",
    "defaultValue",
    "format",
    "formatOnBlur",
    "initialValue",
    "isEqual",
    "multiple",
    "name",
    "parse",
    "subscription",
    "type",
    "validate",
    "validateFields",
    "value"
];
var $42456926338d44c1$export$a455218a85c89869 = /*#__PURE__*/ $70fFQ.forwardRef(function Field(_ref, ref) {
    var afterSubmit = _ref.afterSubmit, allowNull = _ref.allowNull, beforeSubmit = _ref.beforeSubmit, children = _ref.children, component = _ref.component, data = _ref.data, defaultValue = _ref.defaultValue, format = _ref.format, formatOnBlur = _ref.formatOnBlur, initialValue = _ref.initialValue, isEqual = _ref.isEqual, multiple = _ref.multiple, name = _ref.name, parse = _ref.parse, subscription = _ref.subscription, type = _ref.type, validate = _ref.validate, validateFields = _ref.validateFields, value = _ref.value, rest = (0, $53548097e910e6ba$export$2e2bcd8739ae039)(_ref, $42456926338d44c1$var$_excluded);
    var field = $42456926338d44c1$export$294aa081a6c6f55d(name, {
        afterSubmit: afterSubmit,
        allowNull: allowNull,
        beforeSubmit: beforeSubmit,
        children: children,
        component: component,
        data: data,
        defaultValue: defaultValue,
        format: format,
        formatOnBlur: formatOnBlur,
        initialValue: initialValue,
        isEqual: isEqual,
        multiple: multiple,
        parse: parse,
        subscription: subscription,
        type: type,
        validate: validate,
        validateFields: validateFields,
        value: value
    });
    if (typeof children === "function") return children((0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, field, rest));
    if (typeof component === "string") // ignore meta, combine input with any other props
    return /*#__PURE__*/ $70fFQ.createElement(component, (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, field.input, {
        children: children,
        ref: ref
    }, rest));
    if (!name) throw new Error("prop name cannot be undefined in <Field> component");
    return $42456926338d44c1$var$renderComponent((0, $1771723e14e11c61$export$2e2bcd8739ae039)({
        children: children,
        component: component,
        ref: ref
    }, rest), field, "Field(" + name + ")");
});
function $42456926338d44c1$export$38f9b05178901e14() {
    return {
        Form: $42456926338d44c1$export$a7fed597f4b8afd8,
        FormSpy: $42456926338d44c1$export$d2e89184086487cb
    };
}


var $49904825305e3300$exports = {};
"use strict";
Object.defineProperty($49904825305e3300$exports, "__esModule", {
    value: true
});
var $b791e244c28972b4$exports = {};
"use strict";
Object.defineProperty($b791e244c28972b4$exports, "__esModule", {
    value: true
});
$b791e244c28972b4$exports.bodyOpenClassName = $b791e244c28972b4$exports.portalClassName = undefined;
var $b791e244c28972b4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b791e244c28972b4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $70fFQ = parcelRequire("70fFQ");
var $b791e244c28972b4$var$_react2 = $b791e244c28972b4$var$_interopRequireDefault($70fFQ);

var $3glZ1 = parcelRequire("3glZ1");
var $b791e244c28972b4$var$_reactDom2 = $b791e244c28972b4$var$_interopRequireDefault($3glZ1);

var $cd0Jr = parcelRequire("cd0Jr");
var $b791e244c28972b4$var$_propTypes2 = $b791e244c28972b4$var$_interopRequireDefault($cd0Jr);
var $ca98da2a0e39ab07$exports = {};
"use strict";
Object.defineProperty($ca98da2a0e39ab07$exports, "__esModule", {
    value: true
});
var $ca98da2a0e39ab07$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ca98da2a0e39ab07$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $ca98da2a0e39ab07$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");
var $ca98da2a0e39ab07$var$_propTypes2 = $ca98da2a0e39ab07$var$_interopRequireDefault($cd0Jr);
var $cf14ece6dd9385e9$exports = {};
"use strict";
Object.defineProperty($cf14ece6dd9385e9$exports, "__esModule", {
    value: true
});
$cf14ece6dd9385e9$exports.resetState = $cf14ece6dd9385e9$var$resetState;
$cf14ece6dd9385e9$exports.log = $cf14ece6dd9385e9$var$log;
$cf14ece6dd9385e9$exports.handleBlur = $cf14ece6dd9385e9$var$handleBlur;
$cf14ece6dd9385e9$exports.handleFocus = $cf14ece6dd9385e9$var$handleFocus;
$cf14ece6dd9385e9$exports.markForFocusLater = $cf14ece6dd9385e9$var$markForFocusLater;
$cf14ece6dd9385e9$exports.returnFocus = $cf14ece6dd9385e9$var$returnFocus;
$cf14ece6dd9385e9$exports.popWithoutFocus = $cf14ece6dd9385e9$var$popWithoutFocus;
$cf14ece6dd9385e9$exports.setupScopedFocus = $cf14ece6dd9385e9$var$setupScopedFocus;
$cf14ece6dd9385e9$exports.teardownScopedFocus = $cf14ece6dd9385e9$var$teardownScopedFocus;
var $3da04fe25e0bce95$exports = {};
"use strict";
Object.defineProperty($3da04fe25e0bce95$exports, "__esModule", {
    value: true
});
$3da04fe25e0bce95$exports.default = $3da04fe25e0bce95$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $3da04fe25e0bce95$var$DISPLAY_NONE = "none";
var $3da04fe25e0bce95$var$DISPLAY_CONTENTS = "contents";
// match the whole word to prevent fuzzy searching
var $3da04fe25e0bce95$var$tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
function $3da04fe25e0bce95$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $3da04fe25e0bce95$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $3da04fe25e0bce95$var$DISPLAY_CONTENTS && $3da04fe25e0bce95$var$isNotOverflowing(element, style) : displayValue === $3da04fe25e0bce95$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $3da04fe25e0bce95$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($3da04fe25e0bce95$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $3da04fe25e0bce95$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $3da04fe25e0bce95$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $3da04fe25e0bce95$var$visible(element);
}
function $3da04fe25e0bce95$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $3da04fe25e0bce95$var$focusable(element, !isTabIndexNaN);
}
function $3da04fe25e0bce95$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $3da04fe25e0bce95$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($3da04fe25e0bce95$var$tabbable);
}
$3da04fe25e0bce95$exports = $3da04fe25e0bce95$exports["default"];


var $cf14ece6dd9385e9$var$_tabbable2 = $cf14ece6dd9385e9$var$_interopRequireDefault($3da04fe25e0bce95$exports);
function $cf14ece6dd9385e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cf14ece6dd9385e9$var$focusLaterElements = [];
var $cf14ece6dd9385e9$var$modalElement = null;
var $cf14ece6dd9385e9$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $cf14ece6dd9385e9$var$resetState() {
    $cf14ece6dd9385e9$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $cf14ece6dd9385e9$var$log() {}
/* eslint-enable no-console */ function $cf14ece6dd9385e9$var$handleBlur() {
    $cf14ece6dd9385e9$var$needToFocus = true;
}
function $cf14ece6dd9385e9$var$handleFocus() {
    if ($cf14ece6dd9385e9$var$needToFocus) {
        $cf14ece6dd9385e9$var$needToFocus = false;
        if (!$cf14ece6dd9385e9$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($cf14ece6dd9385e9$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $cf14ece6dd9385e9$var$_tabbable2.default)($cf14ece6dd9385e9$var$modalElement)[0] || $cf14ece6dd9385e9$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $cf14ece6dd9385e9$var$markForFocusLater() {
    $cf14ece6dd9385e9$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $cf14ece6dd9385e9$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($cf14ece6dd9385e9$var$focusLaterElements.length !== 0) {
            toFocus = $cf14ece6dd9385e9$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $cf14ece6dd9385e9$var$popWithoutFocus() {
    $cf14ece6dd9385e9$var$focusLaterElements.length > 0 && $cf14ece6dd9385e9$var$focusLaterElements.pop();
}
function $cf14ece6dd9385e9$var$setupScopedFocus(element) {
    $cf14ece6dd9385e9$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $cf14ece6dd9385e9$var$handleBlur, false);
        document.addEventListener("focus", $cf14ece6dd9385e9$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $cf14ece6dd9385e9$var$handleBlur);
        document.attachEvent("onFocus", $cf14ece6dd9385e9$var$handleFocus);
    }
}
function $cf14ece6dd9385e9$var$teardownScopedFocus() {
    $cf14ece6dd9385e9$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $cf14ece6dd9385e9$var$handleBlur);
        document.removeEventListener("focus", $cf14ece6dd9385e9$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $cf14ece6dd9385e9$var$handleBlur);
        document.detachEvent("onFocus", $cf14ece6dd9385e9$var$handleFocus);
    }
}


var $ca98da2a0e39ab07$var$focusManager = $ca98da2a0e39ab07$var$_interopRequireWildcard($cf14ece6dd9385e9$exports);
var $c7cbcac2e2936a44$exports = {};
"use strict";
Object.defineProperty($c7cbcac2e2936a44$exports, "__esModule", {
    value: true
});
$c7cbcac2e2936a44$exports.default = $c7cbcac2e2936a44$var$scopeTab;

var $c7cbcac2e2936a44$var$_tabbable2 = $c7cbcac2e2936a44$var$_interopRequireDefault($3da04fe25e0bce95$exports);
function $c7cbcac2e2936a44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c7cbcac2e2936a44$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $c7cbcac2e2936a44$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $c7cbcac2e2936a44$var$scopeTab(node, event) {
    var tabbable = (0, $c7cbcac2e2936a44$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $c7cbcac2e2936a44$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$c7cbcac2e2936a44$exports = $c7cbcac2e2936a44$exports["default"];


var $ca98da2a0e39ab07$var$_scopeTab2 = $ca98da2a0e39ab07$var$_interopRequireDefault($c7cbcac2e2936a44$exports);
var $1bcf592ec5ea790a$exports = {};
"use strict";
Object.defineProperty($1bcf592ec5ea790a$exports, "__esModule", {
    value: true
});
$1bcf592ec5ea790a$exports.resetState = $1bcf592ec5ea790a$var$resetState;
$1bcf592ec5ea790a$exports.log = $1bcf592ec5ea790a$var$log;
$1bcf592ec5ea790a$exports.assertNodeList = $1bcf592ec5ea790a$var$assertNodeList;
$1bcf592ec5ea790a$exports.setElement = $1bcf592ec5ea790a$var$setElement;
$1bcf592ec5ea790a$exports.validateElement = $1bcf592ec5ea790a$var$validateElement;
$1bcf592ec5ea790a$exports.hide = $1bcf592ec5ea790a$var$hide;
$1bcf592ec5ea790a$exports.show = $1bcf592ec5ea790a$var$show;
$1bcf592ec5ea790a$exports.documentNotReadyOrSSRTesting = $1bcf592ec5ea790a$var$documentNotReadyOrSSRTesting;
var $24d5950e74790b9d$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $24d5950e74790b9d$var$__DEV__ = false;
var $24d5950e74790b9d$var$warning = function() {};
if ($24d5950e74790b9d$var$__DEV__) {
    var $24d5950e74790b9d$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $24d5950e74790b9d$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $24d5950e74790b9d$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$24d5950e74790b9d$exports = $24d5950e74790b9d$var$warning;


var $1bcf592ec5ea790a$var$_warning2 = $1bcf592ec5ea790a$var$_interopRequireDefault($24d5950e74790b9d$exports);
var $82c51f7eab640631$exports = {};
"use strict";
Object.defineProperty($82c51f7eab640631$exports, "__esModule", {
    value: true
});
$82c51f7eab640631$exports.canUseDOM = $82c51f7eab640631$exports.SafeNodeList = $82c51f7eab640631$exports.SafeHTMLCollection = undefined;
var $19564147faff7b04$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if ($19564147faff7b04$exports) $19564147faff7b04$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $82c51f7eab640631$var$_exenv2 = $82c51f7eab640631$var$_interopRequireDefault($19564147faff7b04$exports);
function $82c51f7eab640631$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $82c51f7eab640631$var$EE = $82c51f7eab640631$var$_exenv2.default;
var $82c51f7eab640631$var$SafeHTMLElement = $82c51f7eab640631$var$EE.canUseDOM ? window.HTMLElement : {};
var $82c51f7eab640631$var$SafeHTMLCollection = $82c51f7eab640631$exports.SafeHTMLCollection = $82c51f7eab640631$var$EE.canUseDOM ? window.HTMLCollection : {};
var $82c51f7eab640631$var$SafeNodeList = $82c51f7eab640631$exports.SafeNodeList = $82c51f7eab640631$var$EE.canUseDOM ? window.NodeList : {};
var $82c51f7eab640631$var$canUseDOM = $82c51f7eab640631$exports.canUseDOM = $82c51f7eab640631$var$EE.canUseDOM;
$82c51f7eab640631$exports.default = $82c51f7eab640631$var$SafeHTMLElement;


function $1bcf592ec5ea790a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1bcf592ec5ea790a$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $1bcf592ec5ea790a$var$resetState() {
    if ($1bcf592ec5ea790a$var$globalElement) {
        if ($1bcf592ec5ea790a$var$globalElement.removeAttribute) $1bcf592ec5ea790a$var$globalElement.removeAttribute("aria-hidden");
        else if ($1bcf592ec5ea790a$var$globalElement.length != null) $1bcf592ec5ea790a$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($1bcf592ec5ea790a$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $1bcf592ec5ea790a$var$globalElement = null;
}
/* istanbul ignore next */ function $1bcf592ec5ea790a$var$log() {
    var check;
}
/* eslint-enable no-console */ function $1bcf592ec5ea790a$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $1bcf592ec5ea790a$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $82c51f7eab640631$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $1bcf592ec5ea790a$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $1bcf592ec5ea790a$var$globalElement = useElement || $1bcf592ec5ea790a$var$globalElement;
    return $1bcf592ec5ea790a$var$globalElement;
}
function $1bcf592ec5ea790a$var$validateElement(appElement) {
    var el = appElement || $1bcf592ec5ea790a$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $1bcf592ec5ea790a$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $1bcf592ec5ea790a$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $1bcf592ec5ea790a$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $1bcf592ec5ea790a$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $1bcf592ec5ea790a$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $1bcf592ec5ea790a$var$documentNotReadyOrSSRTesting() {
    $1bcf592ec5ea790a$var$globalElement = null;
}


var $ca98da2a0e39ab07$var$ariaAppHider = $ca98da2a0e39ab07$var$_interopRequireWildcard($1bcf592ec5ea790a$exports);
var $86dacc7fa34a41bf$exports = {};
"use strict";
Object.defineProperty($86dacc7fa34a41bf$exports, "__esModule", {
    value: true
});
$86dacc7fa34a41bf$exports.resetState = $86dacc7fa34a41bf$var$resetState;
$86dacc7fa34a41bf$exports.log = $86dacc7fa34a41bf$var$log;
var $86dacc7fa34a41bf$var$htmlClassList = {};
var $86dacc7fa34a41bf$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $86dacc7fa34a41bf$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $86dacc7fa34a41bf$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $86dacc7fa34a41bf$var$htmlClassList)$86dacc7fa34a41bf$var$removeClass(htmlElement, $86dacc7fa34a41bf$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $86dacc7fa34a41bf$var$docBodyClassList)$86dacc7fa34a41bf$var$removeClass(body, $86dacc7fa34a41bf$var$docBodyClassList[_cls]);
    $86dacc7fa34a41bf$var$htmlClassList = {};
    $86dacc7fa34a41bf$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $86dacc7fa34a41bf$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $86dacc7fa34a41bf$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $86dacc7fa34a41bf$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $86dacc7fa34a41bf$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $86dacc7fa34a41bf$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $86dacc7fa34a41bf$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $86dacc7fa34a41bf$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $86dacc7fa34a41bf$var$add = $86dacc7fa34a41bf$exports.add = function add(element, classString) {
    return $86dacc7fa34a41bf$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $86dacc7fa34a41bf$var$htmlClassList : $86dacc7fa34a41bf$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $86dacc7fa34a41bf$var$remove = $86dacc7fa34a41bf$exports.remove = function remove(element, classString) {
    return $86dacc7fa34a41bf$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $86dacc7fa34a41bf$var$htmlClassList : $86dacc7fa34a41bf$var$docBodyClassList, classString.split(" "));
};


var $ca98da2a0e39ab07$var$classList = $ca98da2a0e39ab07$var$_interopRequireWildcard($86dacc7fa34a41bf$exports);

var $ca98da2a0e39ab07$var$_safeHTMLElement2 = $ca98da2a0e39ab07$var$_interopRequireDefault($82c51f7eab640631$exports);
var $a6bef2b1ac182d23$exports = {};
"use strict";
Object.defineProperty($a6bef2b1ac182d23$exports, "__esModule", {
    value: true
});
$a6bef2b1ac182d23$exports.log = $a6bef2b1ac182d23$var$log;
$a6bef2b1ac182d23$exports.resetState = $a6bef2b1ac182d23$var$resetState;
function $a6bef2b1ac182d23$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $a6bef2b1ac182d23$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $a6bef2b1ac182d23$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $a6bef2b1ac182d23$var$portalOpenInstances = new $a6bef2b1ac182d23$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $a6bef2b1ac182d23$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($a6bef2b1ac182d23$var$portalOpenInstances.openInstances.length);
    $a6bef2b1ac182d23$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $a6bef2b1ac182d23$var$resetState() {
    $a6bef2b1ac182d23$var$portalOpenInstances = new $a6bef2b1ac182d23$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $a6bef2b1ac182d23$exports.default = $a6bef2b1ac182d23$var$portalOpenInstances;


var $ca98da2a0e39ab07$var$_portalOpenInstances2 = $ca98da2a0e39ab07$var$_interopRequireDefault($a6bef2b1ac182d23$exports);
var $24cdb6526de15970$exports = {};
"use strict";
Object.defineProperty($24cdb6526de15970$exports, "__esModule", {
    value: true
});
$24cdb6526de15970$exports.resetState = $24cdb6526de15970$var$resetState;
$24cdb6526de15970$exports.log = $24cdb6526de15970$var$log;

var $24cdb6526de15970$var$_portalOpenInstances2 = $24cdb6526de15970$var$_interopRequireDefault($a6bef2b1ac182d23$exports);
function $24cdb6526de15970$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $24cdb6526de15970$var$before = void 0, $24cdb6526de15970$var$after = void 0, $24cdb6526de15970$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $24cdb6526de15970$var$resetState() {
    var _arr = [
        $24cdb6526de15970$var$before,
        $24cdb6526de15970$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $24cdb6526de15970$var$before = $24cdb6526de15970$var$after = null;
    $24cdb6526de15970$var$instances = [];
}
/* istanbul ignore next */ function $24cdb6526de15970$var$log() {
    console.log("bodyTrap ----------");
    console.log($24cdb6526de15970$var$instances.length);
    var _arr2 = [
        $24cdb6526de15970$var$before,
        $24cdb6526de15970$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $24cdb6526de15970$var$focusContent() {
    if ($24cdb6526de15970$var$instances.length === 0) return;
    $24cdb6526de15970$var$instances[$24cdb6526de15970$var$instances.length - 1].focusContent();
}
function $24cdb6526de15970$var$bodyTrap(eventType, openInstances) {
    if (!$24cdb6526de15970$var$before && !$24cdb6526de15970$var$after) {
        $24cdb6526de15970$var$before = document.createElement("div");
        $24cdb6526de15970$var$before.setAttribute("data-react-modal-body-trap", "");
        $24cdb6526de15970$var$before.style.position = "absolute";
        $24cdb6526de15970$var$before.style.opacity = "0";
        $24cdb6526de15970$var$before.setAttribute("tabindex", "0");
        $24cdb6526de15970$var$before.addEventListener("focus", $24cdb6526de15970$var$focusContent);
        $24cdb6526de15970$var$after = $24cdb6526de15970$var$before.cloneNode();
        $24cdb6526de15970$var$after.addEventListener("focus", $24cdb6526de15970$var$focusContent);
    }
    $24cdb6526de15970$var$instances = openInstances;
    if ($24cdb6526de15970$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $24cdb6526de15970$var$before) document.body.insertBefore($24cdb6526de15970$var$before, document.body.firstChild);
        if (document.body.lastChild !== $24cdb6526de15970$var$after) document.body.appendChild($24cdb6526de15970$var$after);
    } else {
        // Remove focus trap
        if ($24cdb6526de15970$var$before.parentElement) $24cdb6526de15970$var$before.parentElement.removeChild($24cdb6526de15970$var$before);
        if ($24cdb6526de15970$var$after.parentElement) $24cdb6526de15970$var$after.parentElement.removeChild($24cdb6526de15970$var$after);
    }
}
$24cdb6526de15970$var$_portalOpenInstances2.default.subscribe($24cdb6526de15970$var$bodyTrap);


function $ca98da2a0e39ab07$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ca98da2a0e39ab07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca98da2a0e39ab07$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ca98da2a0e39ab07$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ca98da2a0e39ab07$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $ca98da2a0e39ab07$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $ca98da2a0e39ab07$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $ca98da2a0e39ab07$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $ca98da2a0e39ab07$var$ariaHiddenInstances = 0;
var $ca98da2a0e39ab07$var$ModalPortal = function(_Component) {
    $ca98da2a0e39ab07$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $ca98da2a0e39ab07$var$_classCallCheck(this, ModalPortal);
        var _this = $ca98da2a0e39ab07$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $ca98da2a0e39ab07$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $ca98da2a0e39ab07$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $ca98da2a0e39ab07$var$ariaHiddenInstances > 0) {
                $ca98da2a0e39ab07$var$ariaHiddenInstances -= 1;
                if ($ca98da2a0e39ab07$var$ariaHiddenInstances === 0) $ca98da2a0e39ab07$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $ca98da2a0e39ab07$var$focusManager.returnFocus(_this.props.preventScroll);
                    $ca98da2a0e39ab07$var$focusManager.teardownScopedFocus();
                } else $ca98da2a0e39ab07$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $ca98da2a0e39ab07$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $ca98da2a0e39ab07$var$focusManager.setupScopedFocus(_this.node);
                    $ca98da2a0e39ab07$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($ca98da2a0e39ab07$var$isTabKey(event)) (0, $ca98da2a0e39ab07$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $ca98da2a0e39ab07$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $ca98da2a0e39ab07$var$_typeof(additional)) === "object" ? additional : {
                base: $ca98da2a0e39ab07$var$CLASS_NAMES[which],
                afterOpen: $ca98da2a0e39ab07$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $ca98da2a0e39ab07$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $ca98da2a0e39ab07$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $ca98da2a0e39ab07$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $ca98da2a0e39ab07$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $ca98da2a0e39ab07$var$ariaHiddenInstances += 1;
                    $ca98da2a0e39ab07$var$ariaAppHider.hide(appElement);
                }
                $ca98da2a0e39ab07$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $ca98da2a0e39ab07$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $ca98da2a0e39ab07$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $ca98da2a0e39ab07$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $ca98da2a0e39ab07$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($70fFQ.Component);
$ca98da2a0e39ab07$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$ca98da2a0e39ab07$var$ModalPortal.propTypes = {
    isOpen: $ca98da2a0e39ab07$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $ca98da2a0e39ab07$var$_propTypes2.default.shape({
        content: $ca98da2a0e39ab07$var$_propTypes2.default.object,
        overlay: $ca98da2a0e39ab07$var$_propTypes2.default.object
    }),
    style: $ca98da2a0e39ab07$var$_propTypes2.default.shape({
        content: $ca98da2a0e39ab07$var$_propTypes2.default.object,
        overlay: $ca98da2a0e39ab07$var$_propTypes2.default.object
    }),
    className: $ca98da2a0e39ab07$var$_propTypes2.default.oneOfType([
        $ca98da2a0e39ab07$var$_propTypes2.default.string,
        $ca98da2a0e39ab07$var$_propTypes2.default.object
    ]),
    overlayClassName: $ca98da2a0e39ab07$var$_propTypes2.default.oneOfType([
        $ca98da2a0e39ab07$var$_propTypes2.default.string,
        $ca98da2a0e39ab07$var$_propTypes2.default.object
    ]),
    parentSelector: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    bodyOpenClassName: $ca98da2a0e39ab07$var$_propTypes2.default.string,
    htmlOpenClassName: $ca98da2a0e39ab07$var$_propTypes2.default.string,
    ariaHideApp: $ca98da2a0e39ab07$var$_propTypes2.default.bool,
    appElement: $ca98da2a0e39ab07$var$_propTypes2.default.oneOfType([
        $ca98da2a0e39ab07$var$_propTypes2.default.instanceOf($ca98da2a0e39ab07$var$_safeHTMLElement2.default),
        $ca98da2a0e39ab07$var$_propTypes2.default.instanceOf($82c51f7eab640631$exports.SafeHTMLCollection),
        $ca98da2a0e39ab07$var$_propTypes2.default.instanceOf($82c51f7eab640631$exports.SafeNodeList),
        $ca98da2a0e39ab07$var$_propTypes2.default.arrayOf($ca98da2a0e39ab07$var$_propTypes2.default.instanceOf($ca98da2a0e39ab07$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    onAfterClose: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    onRequestClose: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    closeTimeoutMS: $ca98da2a0e39ab07$var$_propTypes2.default.number,
    shouldFocusAfterRender: $ca98da2a0e39ab07$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $ca98da2a0e39ab07$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $ca98da2a0e39ab07$var$_propTypes2.default.bool,
    preventScroll: $ca98da2a0e39ab07$var$_propTypes2.default.bool,
    role: $ca98da2a0e39ab07$var$_propTypes2.default.string,
    contentLabel: $ca98da2a0e39ab07$var$_propTypes2.default.string,
    aria: $ca98da2a0e39ab07$var$_propTypes2.default.object,
    data: $ca98da2a0e39ab07$var$_propTypes2.default.object,
    children: $ca98da2a0e39ab07$var$_propTypes2.default.node,
    shouldCloseOnEsc: $ca98da2a0e39ab07$var$_propTypes2.default.bool,
    overlayRef: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    contentRef: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    id: $ca98da2a0e39ab07$var$_propTypes2.default.string,
    overlayElement: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    contentElement: $ca98da2a0e39ab07$var$_propTypes2.default.func,
    testId: $ca98da2a0e39ab07$var$_propTypes2.default.string
};
$ca98da2a0e39ab07$exports.default = $ca98da2a0e39ab07$var$ModalPortal;
$ca98da2a0e39ab07$exports = $ca98da2a0e39ab07$exports["default"];


var $b791e244c28972b4$var$_ModalPortal2 = $b791e244c28972b4$var$_interopRequireDefault($ca98da2a0e39ab07$exports);

var $b791e244c28972b4$var$ariaAppHider = $b791e244c28972b4$var$_interopRequireWildcard($1bcf592ec5ea790a$exports);

var $b791e244c28972b4$var$_safeHTMLElement2 = $b791e244c28972b4$var$_interopRequireDefault($82c51f7eab640631$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c7467548cdf961da$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c7467548cdf961da$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c7467548cdf961da$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c7467548cdf961da$var$componentWillMount.__suppressDeprecationWarning = true;
$c7467548cdf961da$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c7467548cdf961da$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c7467548cdf961da$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c7467548cdf961da$var$componentWillMount;
        prototype.componentWillReceiveProps = $c7467548cdf961da$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c7467548cdf961da$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $b791e244c28972b4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $b791e244c28972b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b791e244c28972b4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b791e244c28972b4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b791e244c28972b4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b791e244c28972b4$var$portalClassName = $b791e244c28972b4$exports.portalClassName = "ReactModalPortal";
var $b791e244c28972b4$var$bodyOpenClassName = $b791e244c28972b4$exports.bodyOpenClassName = "ReactModal__Body--open";
var $b791e244c28972b4$var$isReact16 = $82c51f7eab640631$exports.canUseDOM && $b791e244c28972b4$var$_reactDom2.default.createPortal !== undefined;
var $b791e244c28972b4$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $b791e244c28972b4$var$getCreatePortal = function getCreatePortal() {
    return $b791e244c28972b4$var$isReact16 ? $b791e244c28972b4$var$_reactDom2.default.createPortal : $b791e244c28972b4$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $b791e244c28972b4$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $b791e244c28972b4$var$Modal = function(_Component) {
    $b791e244c28972b4$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $b791e244c28972b4$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $b791e244c28972b4$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$b791e244c28972b4$var$isReact16 && $b791e244c28972b4$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $b791e244c28972b4$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $b791e244c28972b4$var$getCreatePortal();
            var portal = createPortal(_this, $b791e244c28972b4$var$_react2.default.createElement($b791e244c28972b4$var$_ModalPortal2.default, $b791e244c28972b4$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $b791e244c28972b4$var$_possibleConstructorReturn(_this, _ret);
    }
    $b791e244c28972b4$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$82c51f7eab640631$exports.canUseDOM) return;
                if (!$b791e244c28972b4$var$isReact16) this.node = $b791e244c28972b4$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $b791e244c28972b4$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$b791e244c28972b4$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $b791e244c28972b4$var$getParentElement(prevProps.parentSelector);
                var nextParent = $b791e244c28972b4$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$82c51f7eab640631$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$b791e244c28972b4$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$82c51f7eab640631$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$82c51f7eab640631$exports.canUseDOM || !$b791e244c28972b4$var$isReact16) return null;
                if (!this.node && $b791e244c28972b4$var$isReact16) this.node = $b791e244c28972b4$var$createHTMLElement("div");
                var createPortal = $b791e244c28972b4$var$getCreatePortal();
                return createPortal($b791e244c28972b4$var$_react2.default.createElement($b791e244c28972b4$var$_ModalPortal2.default, $b791e244c28972b4$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $b791e244c28972b4$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($70fFQ.Component);
$b791e244c28972b4$var$Modal.propTypes = {
    isOpen: $b791e244c28972b4$var$_propTypes2.default.bool.isRequired,
    style: $b791e244c28972b4$var$_propTypes2.default.shape({
        content: $b791e244c28972b4$var$_propTypes2.default.object,
        overlay: $b791e244c28972b4$var$_propTypes2.default.object
    }),
    portalClassName: $b791e244c28972b4$var$_propTypes2.default.string,
    bodyOpenClassName: $b791e244c28972b4$var$_propTypes2.default.string,
    htmlOpenClassName: $b791e244c28972b4$var$_propTypes2.default.string,
    className: $b791e244c28972b4$var$_propTypes2.default.oneOfType([
        $b791e244c28972b4$var$_propTypes2.default.string,
        $b791e244c28972b4$var$_propTypes2.default.shape({
            base: $b791e244c28972b4$var$_propTypes2.default.string.isRequired,
            afterOpen: $b791e244c28972b4$var$_propTypes2.default.string.isRequired,
            beforeClose: $b791e244c28972b4$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $b791e244c28972b4$var$_propTypes2.default.oneOfType([
        $b791e244c28972b4$var$_propTypes2.default.string,
        $b791e244c28972b4$var$_propTypes2.default.shape({
            base: $b791e244c28972b4$var$_propTypes2.default.string.isRequired,
            afterOpen: $b791e244c28972b4$var$_propTypes2.default.string.isRequired,
            beforeClose: $b791e244c28972b4$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $b791e244c28972b4$var$_propTypes2.default.oneOfType([
        $b791e244c28972b4$var$_propTypes2.default.instanceOf($b791e244c28972b4$var$_safeHTMLElement2.default),
        $b791e244c28972b4$var$_propTypes2.default.instanceOf($82c51f7eab640631$exports.SafeHTMLCollection),
        $b791e244c28972b4$var$_propTypes2.default.instanceOf($82c51f7eab640631$exports.SafeNodeList),
        $b791e244c28972b4$var$_propTypes2.default.arrayOf($b791e244c28972b4$var$_propTypes2.default.instanceOf($b791e244c28972b4$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $b791e244c28972b4$var$_propTypes2.default.func,
    onRequestClose: $b791e244c28972b4$var$_propTypes2.default.func,
    closeTimeoutMS: $b791e244c28972b4$var$_propTypes2.default.number,
    ariaHideApp: $b791e244c28972b4$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $b791e244c28972b4$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $b791e244c28972b4$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $b791e244c28972b4$var$_propTypes2.default.bool,
    preventScroll: $b791e244c28972b4$var$_propTypes2.default.bool,
    parentSelector: $b791e244c28972b4$var$_propTypes2.default.func,
    aria: $b791e244c28972b4$var$_propTypes2.default.object,
    data: $b791e244c28972b4$var$_propTypes2.default.object,
    role: $b791e244c28972b4$var$_propTypes2.default.string,
    contentLabel: $b791e244c28972b4$var$_propTypes2.default.string,
    shouldCloseOnEsc: $b791e244c28972b4$var$_propTypes2.default.bool,
    overlayRef: $b791e244c28972b4$var$_propTypes2.default.func,
    contentRef: $b791e244c28972b4$var$_propTypes2.default.func,
    id: $b791e244c28972b4$var$_propTypes2.default.string,
    overlayElement: $b791e244c28972b4$var$_propTypes2.default.func,
    contentElement: $b791e244c28972b4$var$_propTypes2.default.func
};
$b791e244c28972b4$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $b791e244c28972b4$var$portalClassName,
    bodyOpenClassName: $b791e244c28972b4$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $b791e244c28972b4$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $b791e244c28972b4$var$_react2.default.createElement("div", props, children);
    }
};
$b791e244c28972b4$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $c7467548cdf961da$export$cea1c58a6db52bca)($b791e244c28972b4$var$Modal);
$b791e244c28972b4$exports.default = $b791e244c28972b4$var$Modal;


var $49904825305e3300$var$_Modal2 = $49904825305e3300$var$_interopRequireDefault($b791e244c28972b4$exports);
function $49904825305e3300$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$49904825305e3300$exports.default = $49904825305e3300$var$_Modal2.default;
$49904825305e3300$exports = $49904825305e3300$exports["default"];



var $3glZ1 = parcelRequire("3glZ1");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$DOMPropNames = new Set([
    'id'
]);
const $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details'
]);
// See LinkDOMProps in dom.d.ts.
const $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$linkPropNames = new Set([
    'href',
    'hrefLang',
    'target',
    'rel',
    'download',
    'ping',
    'referrerPolicy'
]);
const $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$globalAttrs = new Set([
    'dir',
    'lang',
    'hidden',
    'inert',
    'translate'
]);
const $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$globalEvents = new Set([
    'onClick',
    'onAuxClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onScroll',
    'onWheel',
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration',
    'onTransitionCancel',
    'onTransitionEnd',
    'onTransitionRun',
    'onTransitionStart'
]);
const $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$propRe = /^(data-.*)$/;
function $3521997fbd9016c9$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, global: global, events: events = global, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$DOMPropNames.has(prop) || labelable && $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$labelablePropNames.has(prop) || isLink && $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$linkPropNames.has(prop) || global && $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$globalAttrs.has(prop) || events && ($3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$globalEvents.has(prop) || prop.endsWith('Capture') && $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$globalEvents.has(prop.slice(0, -7))) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $3521997fbd9016c9$var$$6a28a4717b9a4e1c$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}


const $0be158cb8722d424$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $0be158cb8722d424$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $0be158cb8722d424$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/**
 * Type guard that checks if a value is a Node. Verifies the presence and type of the nodeType property.
 */ function $0be158cb8722d424$var$$cc3c3666b64debad$var$isNode(value) {
    return value !== null && typeof value === 'object' && 'nodeType' in value && typeof value.nodeType === 'number';
}
function $0be158cb8722d424$export$af51f0f06c0f328a(node) {
    return $0be158cb8722d424$var$$cc3c3666b64debad$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && 'host' in node;
}


/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $439a154e6c47d7e2$var$$ed892adb18214553$var$_tableNestedRows = false;
let $439a154e6c47d7e2$var$$ed892adb18214553$var$_shadowDOM = false;
function $439a154e6c47d7e2$export$d9d8a0f82de49530() {
    $439a154e6c47d7e2$var$$ed892adb18214553$var$_tableNestedRows = true;
}
function $439a154e6c47d7e2$export$1b00cb14a96194e6() {
    return $439a154e6c47d7e2$var$$ed892adb18214553$var$_tableNestedRows;
}
function $439a154e6c47d7e2$export$12b151d9882e9985() {
    $439a154e6c47d7e2$var$$ed892adb18214553$var$_shadowDOM = true;
}
function $439a154e6c47d7e2$export$98658e8c59125e6a() {
    return $439a154e6c47d7e2$var$$ed892adb18214553$var$_shadowDOM;
}


// Source: https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/DOMFunctions.ts#L16
/* eslint-disable rsp-rules/no-non-shadow-contains, rsp-rules/safe-event-target */ function $3086a20958df8aeb$export$4282f70798064fe0(node, otherNode) {
    if (!(0, $439a154e6c47d7e2$export$98658e8c59125e6a)()) return otherNode && node ? node.contains(otherNode) : false;
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode !== null){
        if (currentNode === node) return true;
        if (currentNode.tagName === 'SLOT' && currentNode.assignedSlot) currentNode = currentNode.assignedSlot.parentNode;
        else if ((0, $0be158cb8722d424$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
const $3086a20958df8aeb$export$cd4e5573fbe2b576 = (doc = document)=>{
    var _activeElement_shadowRoot;
    if (!(0, $439a154e6c47d7e2$export$98658e8c59125e6a)()) return doc.activeElement;
    let activeElement = doc.activeElement;
    while(activeElement && 'shadowRoot' in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement))activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
};
function $3086a20958df8aeb$export$e58f029f0fbfdb29(event) {
    if ((0, $439a154e6c47d7e2$export$98658e8c59125e6a)() && event.target instanceof Element && event.target.shadowRoot) {
        var _event_composedPath_, _event_nativeEvent_composedPath_;
        if ('composedPath' in event) return (_event_composedPath_ = event.composedPath()[0]) !== null && _event_composedPath_ !== void 0 ? _event_composedPath_ : null;
        else if ('composedPath' in event.nativeEvent) return (_event_nativeEvent_composedPath_ = event.nativeEvent.composedPath()[0]) !== null && _event_nativeEvent_composedPath_ !== void 0 ? _event_nativeEvent_composedPath_ : null;
    }
    return event.target;
}
function $3086a20958df8aeb$export$b4f377a2b6254582(node) {
    if (!node) return false;
    // Get the active element within the node's parent shadow root (or the document). Can return null.
    let root = node.getRootNode();
    let ownerWindow = (0, $0be158cb8722d424$export$f21a1ffae260145a)(node);
    if (!(root instanceof ownerWindow.Document || root instanceof ownerWindow.ShadowRoot)) return false;
    let activeElement = root.activeElement;
    // Check if the active element is within this node. These nodes are within the same shadow root.
    return activeElement != null && node.contains(activeElement);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $38a92f51669597be$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === 'function') callback(...args);
    };
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $58f47a33590a2f93$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useLayoutEffect : ()=>{};



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $f0b318f29420a1e2$var$$85138adc03e1f057$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $f0b318f29420a1e2$var$$85138adc03e1f057$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext($f0b318f29420a1e2$var$$85138adc03e1f057$var$defaultContext);
const $f0b318f29420a1e2$var$$85138adc03e1f057$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(false);
// This is only used in React < 18.
function $f0b318f29420a1e2$var$$85138adc03e1f057$var$LegacySSRProvider(props) {
    let cur = (0, $70fFQ.useContext)($f0b318f29420a1e2$var$$85138adc03e1f057$var$SSRContext);
    let counter = $f0b318f29420a1e2$var$$85138adc03e1f057$var$useCounter(cur === $f0b318f29420a1e2$var$$85138adc03e1f057$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $70fFQ.useState)(true);
    let value = (0, $70fFQ.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $f0b318f29420a1e2$var$$85138adc03e1f057$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $70fFQ.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f0b318f29420a1e2$var$$85138adc03e1f057$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f0b318f29420a1e2$var$$85138adc03e1f057$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $f0b318f29420a1e2$var$$85138adc03e1f057$var$warnedAboutSSRProvider = false;
function $f0b318f29420a1e2$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f0b318f29420a1e2$var$$85138adc03e1f057$var$LegacySSRProvider, props);
}
let $f0b318f29420a1e2$var$$85138adc03e1f057$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $f0b318f29420a1e2$var$$85138adc03e1f057$var$componentIds = new WeakMap();
function $f0b318f29420a1e2$var$$85138adc03e1f057$var$useCounter(isDisabled = false) {
    let ctx = (0, $70fFQ.useContext)($f0b318f29420a1e2$var$$85138adc03e1f057$var$SSRContext);
    let ref = (0, $70fFQ.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $f0b318f29420a1e2$var$$85138adc03e1f057$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $f0b318f29420a1e2$var$$85138adc03e1f057$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $f0b318f29420a1e2$var$$85138adc03e1f057$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $f0b318f29420a1e2$var$$85138adc03e1f057$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $70fFQ.useContext)($f0b318f29420a1e2$var$$85138adc03e1f057$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $f0b318f29420a1e2$var$$85138adc03e1f057$var$defaultContext && $f0b318f29420a1e2$var$$85138adc03e1f057$var$canUseDOM;
    let counter = $f0b318f29420a1e2$var$$85138adc03e1f057$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $f0b318f29420a1e2$var$$85138adc03e1f057$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useId();
    let [didSSR] = (0, $70fFQ.useState)($f0b318f29420a1e2$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$f0b318f29420a1e2$var$$85138adc03e1f057$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $f0b318f29420a1e2$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ)))['useId'] === 'function' ? $f0b318f29420a1e2$var$$85138adc03e1f057$var$useModernSSRSafeId : $f0b318f29420a1e2$var$$85138adc03e1f057$var$useLegacySSRSafeId;
function $f0b318f29420a1e2$var$$85138adc03e1f057$var$getSnapshot() {
    return false;
}
function $f0b318f29420a1e2$var$$85138adc03e1f057$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $f0b318f29420a1e2$var$$85138adc03e1f057$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $f0b318f29420a1e2$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ)))['useSyncExternalStore']($f0b318f29420a1e2$var$$85138adc03e1f057$var$subscribe, $f0b318f29420a1e2$var$$85138adc03e1f057$var$getSnapshot, $f0b318f29420a1e2$var$$85138adc03e1f057$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $70fFQ.useContext)($f0b318f29420a1e2$var$$85138adc03e1f057$var$IsSSRContext);
}




var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d877b65978d2e887$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $70fFQ.useState)(defaultValue);
    // Keep an up to date copy of value in a ref so we can access the current value in the generator.
    // This allows us to maintain a stable queue function.
    let currValue = (0, $70fFQ.useRef)(value);
    let effect = (0, $70fFQ.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $70fFQ.useRef)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (currValue.current === newValue.value) nextRef.current();
        else setValue(newValue.value);
    });
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        currValue.current = value;
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (0, $70fFQ.useCallback)((fn)=>{
        effect.current = fn(currValue.current);
        nextRef.current();
    }, [
        nextRef
    ]);
    return [
        value,
        queue
    ];
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $57d6fc3c99b86009$var$$0292efe68908de6b$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $57d6fc3c99b86009$export$d41a04c74483c6ef = new Map();
// This allows us to clean up the idsUpdaterMap when the id is no longer used.
// Map is a strong reference, so unused ids wouldn't be cleaned up otherwise.
// This can happen in suspended components where mount/unmount is not called.
let $57d6fc3c99b86009$var$$0292efe68908de6b$var$registry;
if (typeof FinalizationRegistry !== 'undefined') $57d6fc3c99b86009$var$$0292efe68908de6b$var$registry = new FinalizationRegistry((heldValue)=>{
    $57d6fc3c99b86009$export$d41a04c74483c6ef.delete(heldValue);
});
function $57d6fc3c99b86009$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $70fFQ.useState)(defaultId);
    let nextId = (0, $70fFQ.useRef)(null);
    let res = (0, $f0b318f29420a1e2$export$619500959fc48b26)(value);
    let cleanupRef = (0, $70fFQ.useRef)(null);
    if ($57d6fc3c99b86009$var$$0292efe68908de6b$var$registry) $57d6fc3c99b86009$var$$0292efe68908de6b$var$registry.register(cleanupRef, res);
    if ($57d6fc3c99b86009$var$$0292efe68908de6b$var$canUseDOM) {
        const cacheIdRef = $57d6fc3c99b86009$export$d41a04c74483c6ef.get(res);
        if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);
        else $57d6fc3c99b86009$export$d41a04c74483c6ef.set(res, [
            nextId
        ]);
    }
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            // In Suspense, the cleanup function may be not called
            // when it is though, also remove it from the finalization registry.
            if ($57d6fc3c99b86009$var$$0292efe68908de6b$var$registry) $57d6fc3c99b86009$var$$0292efe68908de6b$var$registry.unregister(cleanupRef);
            $57d6fc3c99b86009$export$d41a04c74483c6ef.delete(r);
        };
    }, [
        res
    ]);
    (0, $70fFQ.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) setValue(newId);
        return ()=>{
            if (newId) nextId.current = null;
        };
    });
    return res;
}
function $57d6fc3c99b86009$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdsA = $57d6fc3c99b86009$export$d41a04c74483c6ef.get(idA);
    if (setIdsA) {
        setIdsA.forEach((ref)=>ref.current = idB);
        return idB;
    }
    let setIdsB = $57d6fc3c99b86009$export$d41a04c74483c6ef.get(idB);
    if (setIdsB) {
        setIdsB.forEach((ref)=>ref.current = idA);
        return idA;
    }
    return idB;
}
function $57d6fc3c99b86009$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $57d6fc3c99b86009$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $d877b65978d2e887$export$14d238f342723f25)(id);
    let updateId = (0, $70fFQ.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0a856c3463ed1009$export$c9058316764c140e(...refs) {
    if (refs.length === 1 && refs[0]) return refs[0];
    return (value)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $0a856c3463ed1009$var$$d49e67a55e1d0418$var$setRef(ref, value);
            hasCleanup || (hasCleanup = typeof cleanup == 'function');
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            cleanups.forEach((cleanup, i)=>{
                if (typeof cleanup === 'function') cleanup();
                else $0a856c3463ed1009$var$$d49e67a55e1d0418$var$setRef(refs[i], null);
            });
        };
    };
}
function $0a856c3463ed1009$var$$d49e67a55e1d0418$var$setRef(ref, value) {
    if (typeof ref === 'function') return ref(value);
    else if (ref != null) ref.current = value;
}



var $axMmP = parcelRequire("axMmP");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4e4840536c52e885$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
            key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $38a92f51669597be$export$e08e3b67e392101e)(a, b);
            else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = (0, $axMmP.default)(a, b);
            else if (key === 'id' && a && b) result.id = (0, $57d6fc3c99b86009$export$cd8c9cb68f842629)(a, b);
            else if (key === 'ref' && a && b) result.ref = (0, $0a856c3463ed1009$export$c9058316764c140e)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c6efdf0de8a9630d$export$de79e2c695e052f3(element) {
    if ($c6efdf0de8a9630d$var$$d559d872031c749f$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $c6efdf0de8a9630d$var$$d559d872031c749f$var$getScrollableElements(element);
        element.focus();
        $c6efdf0de8a9630d$var$$d559d872031c749f$var$restoreScrollPosition(scrollableElements);
    }
}
let $c6efdf0de8a9630d$var$$d559d872031c749f$var$supportsPreventScrollCached = null;
function $c6efdf0de8a9630d$var$$d559d872031c749f$var$supportsPreventScroll() {
    if ($c6efdf0de8a9630d$var$$d559d872031c749f$var$supportsPreventScrollCached == null) {
        $c6efdf0de8a9630d$var$$d559d872031c749f$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $c6efdf0de8a9630d$var$$d559d872031c749f$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch  {
        // Ignore
        }
    }
    return $c6efdf0de8a9630d$var$$d559d872031c749f$var$supportsPreventScrollCached;
}
function $c6efdf0de8a9630d$var$$d559d872031c749f$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $c6efdf0de8a9630d$var$$d559d872031c749f$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}









/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $29a59160d66216d2$var$$7570c7c1cd2bea0b$var$supportsCheckVisibility = typeof Element !== 'undefined' && 'checkVisibility' in Element.prototype;
function $29a59160d66216d2$var$$7570c7c1cd2bea0b$var$isStyleVisible(element) {
    const windowObject = (0, $0be158cb8722d424$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $29a59160d66216d2$var$$7570c7c1cd2bea0b$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $29a59160d66216d2$export$e989c0fffaa6b27a(element, childElement) {
    if ($29a59160d66216d2$var$$7570c7c1cd2bea0b$var$supportsCheckVisibility) return element.checkVisibility({
        visibilityProperty: true
    }) && !element.closest('[data-react-aria-prevent-focus]');
    return element.nodeName !== '#comment' && $29a59160d66216d2$var$$7570c7c1cd2bea0b$var$isStyleVisible(element) && $29a59160d66216d2$var$$7570c7c1cd2bea0b$var$isAttributeVisible(element, childElement) && (!element.parentElement || $29a59160d66216d2$export$e989c0fffaa6b27a(element.parentElement, element));
}


/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c5642333d79ce5b3$var$$ee5e22534121197a$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable^="false"])',
    'permission'
];
const $c5642333d79ce5b3$var$$ee5e22534121197a$var$FOCUSABLE_ELEMENT_SELECTOR = $c5642333d79ce5b3$var$$ee5e22534121197a$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$c5642333d79ce5b3$var$$ee5e22534121197a$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $c5642333d79ce5b3$var$$ee5e22534121197a$var$TABBABLE_ELEMENT_SELECTOR = $c5642333d79ce5b3$var$$ee5e22534121197a$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $c5642333d79ce5b3$export$4c063cf1350e6fed(element, options) {
    return element.matches($c5642333d79ce5b3$var$$ee5e22534121197a$var$FOCUSABLE_ELEMENT_SELECTOR) && !$c5642333d79ce5b3$var$$ee5e22534121197a$var$isInert(element) && ((options === null || options === void 0 ? void 0 : options.skipVisibilityCheck) || (0, $29a59160d66216d2$export$e989c0fffaa6b27a)(element));
}
function $c5642333d79ce5b3$export$bebd5a1431fec25d(element) {
    return element.matches($c5642333d79ce5b3$var$$ee5e22534121197a$var$TABBABLE_ELEMENT_SELECTOR) && (0, $29a59160d66216d2$export$e989c0fffaa6b27a)(element) && !$c5642333d79ce5b3$var$$ee5e22534121197a$var$isInert(element);
}
function $c5642333d79ce5b3$var$$ee5e22534121197a$var$isInert(element) {
    let node = element;
    while(node != null){
        if (node instanceof node.ownerDocument.defaultView.HTMLElement && node.inert) return true;
        node = node.parentElement;
    }
    return false;
}




var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ad5cf595cca499ee$export$525bc4921d56d4a(nativeEvent) {
    let event = nativeEvent;
    event.nativeEvent = nativeEvent;
    event.isDefaultPrevented = ()=>event.defaultPrevented;
    // cancelBubble is technically deprecated in the spec, but still supported in all browsers.
    event.isPropagationStopped = ()=>event.cancelBubble;
    event.persist = ()=>{};
    return event;
}
function $ad5cf595cca499ee$export$c2b7abe5d61ec696(event, target) {
    Object.defineProperty(event, 'target', {
        value: target
    });
    Object.defineProperty(event, 'currentTarget', {
        value: target
    });
}
function $ad5cf595cca499ee$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $70fFQ.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (0, $70fFQ.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        let eventTarget = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
        if (eventTarget instanceof HTMLButtonElement || eventTarget instanceof HTMLInputElement || eventTarget instanceof HTMLTextAreaElement || eventTarget instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = eventTarget;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) {
                    // For backward compatibility, dispatch a (fake) React synthetic event.
                    let event = $ad5cf595cca499ee$export$525bc4921d56d4a(e);
                    onBlur === null || onBlur === void 0 || onBlur(event);
                }
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)() ? null : (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)();
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        onBlur
    ]);
}
let $ad5cf595cca499ee$export$fda7da73ab5d4c48 = false;
function $ad5cf595cca499ee$export$cabe61c495ee3649(target) {
    // The browser will focus the nearest focusable ancestor of our target.
    while(target && !(0, $c5642333d79ce5b3$export$4c063cf1350e6fed)(target, {
        skipVisibilityCheck: true
    }))target = target.parentElement;
    let window = (0, $0be158cb8722d424$export$f21a1ffae260145a)(target);
    let activeElement = window.document.activeElement;
    if (!activeElement || activeElement === target) return;
    $ad5cf595cca499ee$export$fda7da73ab5d4c48 = true;
    let isRefocusing = false;
    let onBlur = (e)=>{
        if ((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) === activeElement || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusOut = (e)=>{
        if ((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) === activeElement || isRefocusing) {
            e.stopImmediatePropagation();
            // If there was no focusable ancestor, we don't expect a focus event.
            // Re-focus the original active element here.
            if (!target && !isRefocusing) {
                isRefocusing = true;
                (0, $c6efdf0de8a9630d$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    let onFocus = (e)=>{
        if ((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) === target || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusIn = (e)=>{
        if ((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) === target || isRefocusing) {
            e.stopImmediatePropagation();
            if (!isRefocusing) {
                isRefocusing = true;
                (0, $c6efdf0de8a9630d$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    window.addEventListener('blur', onBlur, true);
    window.addEventListener('focusout', onFocusOut, true);
    window.addEventListener('focusin', onFocusIn, true);
    window.addEventListener('focus', onFocus, true);
    let cleanup = ()=>{
        cancelAnimationFrame(raf);
        window.removeEventListener('blur', onBlur, true);
        window.removeEventListener('focusout', onFocusOut, true);
        window.removeEventListener('focusin', onFocusIn, true);
        window.removeEventListener('focus', onFocus, true);
        $ad5cf595cca499ee$export$fda7da73ab5d4c48 = false;
        isRefocusing = false;
    };
    let raf = requestAnimationFrame(cleanup);
    return cleanup;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $86098bbbd8e8a169$var$$d5a2be505488529f$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    let brands = (_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands;
    return Array.isArray(brands) && brands.some((brand)=>re.test(brand.brand)) || re.test(window.navigator.userAgent);
}
function $86098bbbd8e8a169$var$$d5a2be505488529f$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $86098bbbd8e8a169$export$9ac100e40613ea10 = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$var$$d5a2be505488529f$var$testPlatform(/^Mac/i);
});
const $86098bbbd8e8a169$export$186c6964ca17d99 = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$var$$d5a2be505488529f$var$testPlatform(/^iPhone/i);
});
const $86098bbbd8e8a169$export$7bef049ce92e4224 = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$var$$d5a2be505488529f$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $86098bbbd8e8a169$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $86098bbbd8e8a169$export$fedb369cb70207f1 = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$export$186c6964ca17d99() || $86098bbbd8e8a169$export$7bef049ce92e4224();
});
const $86098bbbd8e8a169$export$e1865c3bedcd822b = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$export$9ac100e40613ea10() || $86098bbbd8e8a169$export$fedb369cb70207f1();
});
const $86098bbbd8e8a169$export$78551043582a6a98 = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$var$$d5a2be505488529f$var$testUserAgent(/AppleWebKit/i) && !$86098bbbd8e8a169$export$6446a186d09e379e();
});
const $86098bbbd8e8a169$export$6446a186d09e379e = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$var$$d5a2be505488529f$var$testUserAgent(/Chrome/i);
});
const $86098bbbd8e8a169$export$a11b0059900ceec8 = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$var$$d5a2be505488529f$var$testUserAgent(/Android/i);
});
const $86098bbbd8e8a169$export$b7d78993b74f766d = $86098bbbd8e8a169$var$$d5a2be505488529f$var$cached(function() {
    return $86098bbbd8e8a169$var$$d5a2be505488529f$var$testUserAgent(/Firefox/i);
});



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4180de1039dadb35$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.pointerType === '' && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $86098bbbd8e8a169$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $4180de1039dadb35$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $86098bbbd8e8a169$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}





var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $74847c07cc15756a$var$$044d3c97ce5d6621$var$RouterContext = (0, $70fFQ.createContext)({
    isNative: true,
    open: $74847c07cc15756a$var$$044d3c97ce5d6621$var$openSyntheticLink,
    useHref: (href)=>href
});
function $74847c07cc15756a$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $70fFQ.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $74847c07cc15756a$var$$044d3c97ce5d6621$var$getSyntheticLink(target, (link)=>{
                    if ($74847c07cc15756a$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $74847c07cc15756a$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($74847c07cc15756a$var$$044d3c97ce5d6621$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $74847c07cc15756a$export$9a302a45f65d0572() {
    return (0, $70fFQ.useContext)($74847c07cc15756a$var$$044d3c97ce5d6621$var$RouterContext);
}
function $74847c07cc15756a$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute('target');
    return (!target || target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $74847c07cc15756a$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $86098bbbd8e8a169$export$b7d78993b74f766d)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith('key')) && target.target === '_blank') {
        if ((0, $86098bbbd8e8a169$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $86098bbbd8e8a169$export$78551043582a6a98)() && (0, $86098bbbd8e8a169$export$9ac100e40613ea10)() && !(0, $86098bbbd8e8a169$export$7bef049ce92e4224)() && true ? new KeyboardEvent('keydown', {
        keyIdentifier: 'Enter',
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent('click', {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        detail: 1,
        bubbles: true,
        cancelable: true
    });
    $74847c07cc15756a$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $c6efdf0de8a9630d$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $74847c07cc15756a$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$74847c07cc15756a$export$95185d699e05d4d7.isOpening = false;
function $74847c07cc15756a$var$$044d3c97ce5d6621$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute('data-href')) {
        let link = document.createElement('a');
        link.href = target.getAttribute('data-href');
        if (target.hasAttribute('data-target')) link.target = target.getAttribute('data-target');
        if (target.hasAttribute('data-rel')) link.rel = target.getAttribute('data-rel');
        if (target.hasAttribute('data-download')) link.download = target.getAttribute('data-download');
        if (target.hasAttribute('data-ping')) link.ping = target.getAttribute('data-ping');
        if (target.hasAttribute('data-referrer-policy')) link.referrerPolicy = target.getAttribute('data-referrer-policy');
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $74847c07cc15756a$var$$044d3c97ce5d6621$var$openSyntheticLink(target, modifiers) {
    $74847c07cc15756a$var$$044d3c97ce5d6621$var$getSyntheticLink(target, (link)=>$74847c07cc15756a$export$95185d699e05d4d7(link, modifiers));
}
function $74847c07cc15756a$export$bdc77b0c0a3a85d6(props) {
    let router = $74847c07cc15756a$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        'data-href': props.href ? href : undefined,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $74847c07cc15756a$export$51437d503373d223(props) {
    return {
        'data-href': props.href,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $74847c07cc15756a$export$7e924b3091a3bd18(props) {
    let router = $74847c07cc15756a$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props === null || props === void 0 ? void 0 : props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? href : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}
function $74847c07cc15756a$export$13aea1a3cb5e3f1f(e, router, href, routerOptions) {
    // If a custom router is provided, prevent default and forward if this link should client navigate.
    if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
    !e.isDefaultPrevented() && $74847c07cc15756a$export$efa8c9099e530235(e.currentTarget, e) && href) {
        e.preventDefault();
        router.open(e.currentTarget, e, href, routerOptions);
    }
}




var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality = null;
let $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentPointerType = 'keyboard';
const $bad2a4032856d574$export$901e90a13c50a14e = new Set();
let $bad2a4032856d574$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = false;
let $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $bad2a4032856d574$var$$b50b1cc8a843ace7$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$triggerChangeHandlers(modality, e) {
    for (let handler of $bad2a4032856d574$export$901e90a13c50a14e)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $86098bbbd8e8a169$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleKeyboardEvent(e) {
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
    if (!(0, $74847c07cc15756a$export$95185d699e05d4d7).isOpening && $bad2a4032856d574$var$$b50b1cc8a843ace7$var$isValidKey(e)) {
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality = 'keyboard';
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentPointerType = 'keyboard';
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$triggerChangeHandlers('keyboard', e);
    }
}
function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handlePointerEvent(e) {
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality = 'pointer';
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentPointerType = 'pointerType' in e ? e.pointerType : 'mouse';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$triggerChangeHandlers('pointer', e);
    }
}
function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleClickEvent(e) {
    if (!(0, $74847c07cc15756a$export$95185d699e05d4d7).isOpening && (0, $4180de1039dadb35$export$60278871457622de)(e)) {
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality = 'virtual';
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentPointerType = 'virtual';
    }
}
function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    let ownerWindow = (0, $0be158cb8722d424$export$f21a1ffae260145a)((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e));
    let ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e));
    if ((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) === ownerWindow || (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) === ownerDocument || (0, $ad5cf595cca499ee$export$fda7da73ab5d4c48) || !e.isTrusted) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus && !$bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently) {
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality = 'virtual';
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentPointerType = 'virtual';
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$triggerChangeHandlers('virtual', e);
    }
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = false;
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently = false;
}
function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleWindowBlur() {
    if (0, $ad5cf595cca499ee$export$fda7da73ab5d4c48) return;
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = false;
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents(element) {
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const windowObject = (0, $0be158cb8722d424$export$f21a1ffae260145a)(element);
    const documentObject = (0, $0be158cb8722d424$export$b204af158042fbac)(element);
    if ($bad2a4032856d574$export$d90243b58daecda7.get(windowObject)) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $bad2a4032856d574$var$$b50b1cc8a843ace7$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $bad2a4032856d574$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $bad2a4032856d574$var$$b50b1cc8a843ace7$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $0be158cb8722d424$export$f21a1ffae260145a)(element);
    const documentObject = (0, $0be158cb8722d424$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$bad2a4032856d574$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $bad2a4032856d574$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $bad2a4032856d574$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
    }
    $bad2a4032856d574$export$d90243b58daecda7.delete(windowObject);
};
function $bad2a4032856d574$export$2f1888112f558a7d(element) {
    const documentObject = (0, $0be158cb8722d424$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $bad2a4032856d574$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $bad2a4032856d574$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$bad2a4032856d574$var$$b50b1cc8a843ace7$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $bad2a4032856d574$export$2f1888112f558a7d();
function $bad2a4032856d574$export$b9b3dfddab17db27() {
    return $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality !== 'pointer';
}
function $bad2a4032856d574$export$630ff653c5ada6a9() {
    return $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality;
}
function $bad2a4032856d574$export$8397ddfc504fdb9a(modality) {
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality = modality;
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentPointerType = modality === 'pointer' ? 'mouse' : modality;
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$triggerChangeHandlers(modality, null);
}
function $bad2a4032856d574$export$887a228355cf7d95() {
    return $bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentPointerType;
}
function $bad2a4032856d574$export$98e20ec92f614cfe() {
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $70fFQ.useState)($bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality);
    (0, $70fFQ.useEffect)(()=>{
        let handler = ()=>{
            setModality($bad2a4032856d574$var$$b50b1cc8a843ace7$var$currentModality);
        };
        $bad2a4032856d574$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $bad2a4032856d574$export$901e90a13c50a14e.delete(handler);
        };
    }, []);
    return (0, $f0b318f29420a1e2$export$535bd6ca7f90a273)() ? null : modality;
}
const $bad2a4032856d574$var$$b50b1cc8a843ace7$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $bad2a4032856d574$var$$b50b1cc8a843ace7$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    let eventTarget = e ? (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) : undefined;
    let document1 = (0, $0be158cb8722d424$export$b204af158042fbac)(eventTarget);
    let ownerWindow = (0, $0be158cb8722d424$export$f21a1ffae260145a)(eventTarget);
    const IHTMLInputElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof ownerWindow !== 'undefined' ? ownerWindow.KeyboardEvent : KeyboardEvent;
    // For keyboard events that occur on a non-input element that will move focus into input element (aka ArrowLeft going from Datepicker button to the main input group)
    // we need to rely on the user passing isTextInput into here. This way we can skip toggling focus visiblity for said input element
    let activeElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(document1);
    isTextInput = isTextInput || activeElement instanceof IHTMLInputElement && !$bad2a4032856d574$var$$b50b1cc8a843ace7$var$nonTextInputTypes.has(activeElement.type) || activeElement instanceof IHTMLTextAreaElement || activeElement instanceof IHTMLElement && activeElement.isContentEditable;
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$bad2a4032856d574$var$$b50b1cc8a843ace7$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $bad2a4032856d574$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $70fFQ.useState)(autoFocus || $bad2a4032856d574$export$b9b3dfddab17db27());
    $bad2a4032856d574$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $bad2a4032856d574$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $bad2a4032856d574$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents();
    (0, $70fFQ.useEffect)(()=>{
        if ((opts === null || opts === void 0 ? void 0 : opts.enabled) === false) return;
        let handler = (modality, e)=>{
            // We want to early return for any keyboard events that occur inside text inputs EXCEPT for Tab and Escape
            if (!$bad2a4032856d574$var$$b50b1cc8a843ace7$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($bad2a4032856d574$export$b9b3dfddab17db27());
        };
        $bad2a4032856d574$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $bad2a4032856d574$export$901e90a13c50a14e.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionCallbacks = new Set();
function $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$setupGlobalEvents() {
    if (typeof window === 'undefined') return;
    function isTransitionEvent(event) {
        return 'propertyName' in event;
    }
    let onTransitionStart = (e)=>{
        let eventTarget = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
        if (!isTransitionEvent(e) || !eventTarget) return;
        // Add the transitioning property to the list for this element.
        let transitions = $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement.get(eventTarget);
        if (!transitions) {
            transitions = new Set();
            $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement.set(eventTarget, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            eventTarget.addEventListener('transitioncancel', onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        let eventTarget = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
        if (!isTransitionEvent(e) || !eventTarget) return;
        // Remove property from list of transitioning properties.
        let properties = $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement.get(eventTarget);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            eventTarget.removeEventListener('transitioncancel', onTransitionEnd);
            $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement.delete(eventTarget);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement.size === 0) {
            for (let cb of $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionCallbacks)cb();
            $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener('transitionrun', onTransitionStart);
    document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$setupGlobalEvents();
    else document.addEventListener('DOMContentLoaded', $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$setupGlobalEvents);
}
/**
 * Cleans up any elements that are no longer in the document.
 * This is necessary because we can't rely on transitionend events to fire
 * for elements that are removed from the document while transitioning.
 */ function $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$cleanupDetachedElements() {
    for (const [eventTarget] of $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement)// the explicit instanceof check, since it may be different in different contexts.
    if ('isConnected' in eventTarget && !eventTarget.isConnected) $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement.delete(eventTarget);
}
function $d55d5a3ca38f7b61$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$cleanupDetachedElements();
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionsByElement.size === 0) fn();
        else $d55d5a3ca38f7b61$var$$aa33e9569e5401d5$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $158b2efc209f9857$export$80f3e147d781571c(element) {
    if (!element.isConnected) return;
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(element);
    if ((0, $bad2a4032856d574$export$630ff653c5ada6a9)() === 'virtual') {
        let lastFocusedElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument);
        (0, $d55d5a3ca38f7b61$export$24490316f764c430)(()=>{
            const activeElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument);
            // If focus did not move or focus was lost to the body, and the element is still in the document, focus it.
            if ((activeElement === lastFocusedElement || activeElement === ownerDocument.body) && element.isConnected) (0, $c6efdf0de8a9630d$export$de79e2c695e052f3)(element);
        });
    } else (0, $c6efdf0de8a9630d$export$de79e2c695e052f3)(element);
}










var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $63371001fd19f185$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $70fFQ.useCallback)((e)=>{
        if ((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e) === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $ad5cf595cca499ee$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $70fFQ.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(eventTarget);
        const activeElement = ownerDocument ? (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument) : (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)();
        if (eventTarget === e.currentTarget && eventTarget === activeElement) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4f4cead23539c8d5$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                shouldStopPropagation = true;
            },
            continuePropagation () {
                shouldStopPropagation = false;
            },
            isPropagationStopped () {
                return shouldStopPropagation;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8c787384acd8a28a$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $4f4cead23539c8d5$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $4f4cead23539c8d5$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $78182bab95129cb9$export$4338b53315abf666(ref) {
    const objRef = (0, $70fFQ.useRef)(null);
    const cleanupRef = (0, $70fFQ.useRef)(undefined);
    const refEffect = (0, $70fFQ.useCallback)((instance)=>{
        if (typeof ref === 'function') {
            const refCallback = ref;
            const refCleanup = refCallback(instance);
            return ()=>{
                if (typeof refCleanup === 'function') refCleanup();
                else refCallback(null);
            };
        } else if (ref) {
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        }
    }, [
        ref
    ]);
    return (0, $70fFQ.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (cleanupRef.current) {
                    cleanupRef.current();
                    cleanupRef.current = undefined;
                }
                if (value != null) cleanupRef.current = refEffect(value);
            }
        }), [
        refEffect
    ]);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $61161fa68cd2c06e$export$4debdb1a3f0fa79e(context, ref) {
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $a5b5972f65b7b461$export$f9762fab77588ecb = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(null);
function $a5b5972f65b7b461$var$$088f27a386bc4a8f$var$useFocusableContext(ref) {
    let context = (0, $70fFQ.useContext)($a5b5972f65b7b461$export$f9762fab77588ecb) || {};
    (0, $61161fa68cd2c06e$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
const $a5b5972f65b7b461$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(function FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $78182bab95129cb9$export$4338b53315abf666)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($a5b5972f65b7b461$export$f9762fab77588ecb.Provider, {
        value: context
    }, children);
});
function $a5b5972f65b7b461$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $63371001fd19f185$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $8c787384acd8a28a$export$8f71654801c2f7cd)(props);
    let interactions = (0, $4e4840536c52e885$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $a5b5972f65b7b461$var$$088f27a386bc4a8f$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $70fFQ.useRef)(props.autoFocus);
    (0, $70fFQ.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $158b2efc209f9857$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    // Always set a tabIndex so that Safari allows focusing native buttons and inputs.
    let tabIndex = props.excludeFromTabOrder ? -1 : 0;
    if (props.isDisabled) tabIndex = undefined;
    return {
        focusableProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: tabIndex
        }, interactionProps)
    };
}
const $a5b5972f65b7b461$export$35a3bebf7ef2d934 = (0, $70fFQ.forwardRef)(({ children: children, ...props }, ref)=>{
    ref = (0, $78182bab95129cb9$export$4338b53315abf666)(ref);
    let { focusableProps: focusableProps } = $a5b5972f65b7b461$export$4c014de7c8940b4c(props, ref);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.only(children);
    (0, $70fFQ.useEffect)(()=>{
        return;
    }, [
        ref,
        props.isDisabled
    ]);
    // @ts-ignore
    let childRef = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).version, 10) < 19 ? child.ref : child.props.ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(child, {
        ...(0, $4e4840536c52e885$export$9d1611c77c2fe928)(focusableProps, child.props),
        // @ts-ignore
        ref: (0, $0a856c3463ed1009$export$c9058316764c140e)(childRef, ref)
    });
});




var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $5ff35cebe086a8a9$var$$85567ef950781b7d$var$_React_useInsertionEffect;
// Use the earliest effect type possible. useInsertionEffect runs during the mutation phase,
// before all layout effects, but is available only in React 18 and later.
const $5ff35cebe086a8a9$var$$85567ef950781b7d$var$useEarlyEffect = ($5ff35cebe086a8a9$var$$85567ef950781b7d$var$_React_useInsertionEffect = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ)))['useInsertionEffect']) !== null && $5ff35cebe086a8a9$var$$85567ef950781b7d$var$_React_useInsertionEffect !== void 0 ? $5ff35cebe086a8a9$var$$85567ef950781b7d$var$_React_useInsertionEffect : (0, $58f47a33590a2f93$export$e5c5a5f917a5871c);
function $5ff35cebe086a8a9$export$7f54fc3180508a52(fn) {
    const ref = (0, $70fFQ.useRef)(null);
    $5ff35cebe086a8a9$var$$85567ef950781b7d$var$useEarlyEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $70fFQ.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4ff2f40121425aba$export$5add1d006293d136(ref, initialValue, onReset) {
    let handleReset = (0, $5ff35cebe086a8a9$export$7f54fc3180508a52)((e)=>{
        if (onReset && !e.defaultPrevented) onReset(initialValue);
    });
    (0, $70fFQ.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener('reset', handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener('reset', handleReset);
        };
    }, [
        ref
    ]);
}







/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $b782d35405753235$var$$913e9bb378fa8235$var$state = 'default';
let $b782d35405753235$var$$913e9bb378fa8235$var$savedUserSelect = '';
let $b782d35405753235$var$$913e9bb378fa8235$var$modifiedElementMap = new WeakMap();
function $b782d35405753235$export$16a4697467175487(target) {
    if ((0, $86098bbbd8e8a169$export$fedb369cb70207f1)()) {
        if ($b782d35405753235$var$$913e9bb378fa8235$var$state === 'default') {
            const documentObject = (0, $0be158cb8722d424$export$b204af158042fbac)(target);
            $b782d35405753235$var$$913e9bb378fa8235$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = 'none';
        }
        $b782d35405753235$var$$913e9bb378fa8235$var$state = 'disabled';
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
        $b782d35405753235$var$$913e9bb378fa8235$var$modifiedElementMap.set(target, target.style[property]);
        target.style[property] = 'none';
    }
}
function $b782d35405753235$export$b0d6fa1ab32e3295(target) {
    if ((0, $86098bbbd8e8a169$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($b782d35405753235$var$$913e9bb378fa8235$var$state !== 'disabled') return;
        $b782d35405753235$var$$913e9bb378fa8235$var$state = 'restoring';
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $d55d5a3ca38f7b61$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($b782d35405753235$var$$913e9bb378fa8235$var$state === 'restoring') {
                    const documentObject = (0, $0be158cb8722d424$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === 'none') documentObject.documentElement.style.webkitUserSelect = $b782d35405753235$var$$913e9bb378fa8235$var$savedUserSelect || '';
                    $b782d35405753235$var$$913e9bb378fa8235$var$savedUserSelect = '';
                    $b782d35405753235$var$$913e9bb378fa8235$var$state = 'default';
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $b782d35405753235$var$$913e9bb378fa8235$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $b782d35405753235$var$$913e9bb378fa8235$var$modifiedElementMap.get(target);
            let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
            if (target.style[property] === 'none') target.style[property] = targetOldUserSelect;
            if (target.getAttribute('style') === '') target.removeAttribute('style');
            $b782d35405753235$var$$913e9bb378fa8235$var$modifiedElementMap.delete(target);
        }
    }
}





/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a2f8c65b815ba806$var$$fb5d33e131fca75a$var$getWebpackNonce(doc) {
    let ownerWindow = doc === null || doc === void 0 ? void 0 : doc.defaultView;
    return (ownerWindow === null || ownerWindow === void 0 ? void 0 : ownerWindow.__webpack_nonce__) || globalThis['__webpack_nonce__'] || undefined;
}
let $a2f8c65b815ba806$var$$fb5d33e131fca75a$var$nonceCache = new WeakMap();
function $a2f8c65b815ba806$export$88b319273f3705b4() {
    $a2f8c65b815ba806$var$$fb5d33e131fca75a$var$nonceCache = new WeakMap();
}
function $a2f8c65b815ba806$export$2b85b721e524d74b(doc) {
    let d = doc !== null && doc !== void 0 ? doc : typeof document !== 'undefined' ? document : undefined;
    if (!d) return $a2f8c65b815ba806$var$$fb5d33e131fca75a$var$getWebpackNonce(d);
    if ($a2f8c65b815ba806$var$$fb5d33e131fca75a$var$nonceCache.has(d)) return $a2f8c65b815ba806$var$$fb5d33e131fca75a$var$nonceCache.get(d);
    let meta = d.querySelector('meta[property="csp-nonce"]');
    let nonce = meta && meta instanceof (0, $0be158cb8722d424$export$f21a1ffae260145a)(meta).HTMLMetaElement && (meta.nonce || meta.content) || $a2f8c65b815ba806$var$$fb5d33e131fca75a$var$getWebpackNonce(d) || undefined;
    if (nonce !== undefined) $a2f8c65b815ba806$var$$fb5d33e131fca75a$var$nonceCache.set(d, nonce);
    return nonce;
}








var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $14c158683aa57895$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext({
    register: ()=>{}
});
$14c158683aa57895$export$5165eccb35aaadb5.displayName = 'PressResponderContext';




var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2736dfdb74f3103f$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $70fFQ.useRef)(new Map());
    let addGlobalListener = (0, $70fFQ.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, fn, options);
    }, []);
    let removeGlobalListener = (0, $70fFQ.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $70fFQ.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $70fFQ.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}



function $cfe4c6e8ab9c5885$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $afcb7f651bfccf3d$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $393389e5586e42d1$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $afcb7f651bfccf3d$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $cfe4c6e8ab9c5885$export$71511d61b312f219)(receiver, descriptor);
}


function $4edbbfc50a8a3f4f$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $a3f17f7410fc1b6a$export$71511d61b312f219(obj, privateMap, value) {
    (0, $4edbbfc50a8a3f4f$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $ebeacef92025d623$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $a60c9490a2be38b8$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $afcb7f651bfccf3d$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $ebeacef92025d623$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


parcelRequire("3glZ1");

var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $70fFQ.useContext)((0, $14c158683aa57895$export$5165eccb35aaadb5));
    if (context) {
        // Prevent mergeProps from merging ref.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let { register: register, ref: ref, ...contextProps } = context;
        props = (0, $4e4840536c52e885$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $61161fa68cd2c06e$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PressEvent {
    continuePropagation() {
        (0, $a60c9490a2be38b8$export$71511d61b312f219)(this, $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $393389e5586e42d1$export$71511d61b312f219)(this, $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent, state){
        (0, $a3f17f7410fc1b6a$export$71511d61b312f219)(this, $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $a60c9490a2be38b8$export$71511d61b312f219)(this, $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$_shouldStopPropagation, true);
        var _state_target;
        let currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
        const rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
        let x, y = 0;
        let clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
        this.key = originalEvent.key;
    }
}
const $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$LINK_CLICKED = Symbol('linkClicked');
const $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$STYLE_ID = 'react-aria-pressable-style';
const $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PRESSABLE_ATTRIBUTE = 'data-react-aria-pressable';
function $ecc4b8c956bf739d$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onClick: onClick, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: domRef, ...domProps } = $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $70fFQ.useState)(false);
    let ref = (0, $70fFQ.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null,
        disposables: []
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $2736dfdb74f3103f$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $70fFQ.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PressEvent('pressstart', pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressStart,
        onPressChange
    ]);
    let triggerPressEnd = (0, $70fFQ.useCallback)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PressEvent('pressend', pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PressEvent('press', pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressEnd,
        onPressChange,
        onPress
    ]);
    let triggerPressEndEvent = (0, $5ff35cebe086a8a9$export$7f54fc3180508a52)(triggerPressEnd);
    let triggerPressUp = (0, $70fFQ.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PressEvent('pressup', pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    }, [
        isDisabled,
        onPressUp
    ]);
    let triggerPressUpEvent = (0, $5ff35cebe086a8a9$export$7f54fc3180508a52)(triggerPressUp);
    let cancel = (0, $70fFQ.useCallback)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.didFirePressStart && state.pointerType != null) triggerPressEnd($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $b782d35405753235$export$b0d6fa1ab32e3295)(state.target);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        }
    }, [
        allowTextSelectionOnPress,
        removeAllGlobalListeners,
        triggerPressEnd
    ]);
    let cancelEvent = (0, $5ff35cebe086a8a9$export$7f54fc3180508a52)(cancel);
    let cancelOnPointerExit = (0, $70fFQ.useCallback)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    }, [
        shouldCancelOnPointerExit,
        cancel
    ]);
    let triggerClick = (0, $70fFQ.useCallback)((e)=>{
        if (isDisabled) return;
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        isDisabled,
        onClick
    ]);
    let triggerSyntheticClick = (0, $70fFQ.useCallback)((e, target)=>{
        if (isDisabled) return;
        // Some third-party libraries pass in onClick instead of onPress.
        // Create a fake mouse event and trigger onClick as well.
        // This matches the browser's native activation behavior for certain elements (e.g. button).
        // https://html.spec.whatwg.org/#activation
        // https://html.spec.whatwg.org/#fire-a-synthetic-pointer-event
        if (onClick) {
            let event = new MouseEvent('click', e);
            (0, $ad5cf595cca499ee$export$c2b7abe5d61ec696)(event, target);
            onClick((0, $ad5cf595cca499ee$export$525bc4921d56d4a)(event));
        }
    }, [
        isDisabled,
        onClick
    ]);
    let pressProps = (0, $70fFQ.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && (0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e))) {
                    var _state_metaKeyEvents;
                    if ($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$shouldPreventDefaultKeyboard((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e), e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        state.pointerType = 'keyboard';
                        shouldStopPropagation = triggerPressStart(e, 'keyboard');
                    }
                    // Focus may move before the key up event, so register the event on the document
                    // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                    // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                    let originalTarget = e.currentTarget;
                    let pressUp = (e)=>{
                        if ($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && (0, $3086a20958df8aeb$export$4282f70798064fe0)(originalTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e)) && state.target) triggerPressUpEvent($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(state.target, e), 'keyboard');
                    };
                    addGlobalListener((0, $0be158cb8722d424$export$b204af158042fbac)(e.currentTarget), 'keyup', (0, $38a92f51669597be$export$e08e3b67e392101e)(pressUp, onKeyUp), true);
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $86098bbbd8e8a169$export$9ac100e40613ea10)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === 'Meta') state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e))) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $74847c07cc15756a$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === 'virtual' || (0, $4180de1039dadb35$export$60278871457622de)(e.nativeEvent))) {
                        let stopPressStart = triggerPressStart(e, 'virtual');
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressUp = triggerPressUpEvent(e, 'virtual');
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressEnd = triggerPressEndEvent(e, 'virtual');
                        triggerClick(e);
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    } else if (state.isPressed && state.pointerType !== 'keyboard') {
                        let pointerType = state.pointerType || e.nativeEvent.pointerType || 'virtual';
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressUp = triggerPressUpEvent($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(e.currentTarget, e), pointerType);
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressEnd = triggerPressEndEvent($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(e.currentTarget, e), pointerType, true);
                        shouldStopPropagation = stopPressUp && stopPressEnd;
                        state.isOverTarget = false;
                        triggerClick(e);
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        cancelEvent(e);
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$shouldPreventDefaultKeyboard((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e), e.key)) e.preventDefault();
                let target = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
                let wasPressed = (0, $3086a20958df8aeb$export$4282f70798064fe0)(state.target, target);
                // eslint-disable-next-line react-hooks/rules-of-hooks
                triggerPressEndEvent($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(state.target, e), 'keyboard', wasPressed);
                if (wasPressed) triggerSyntheticClick(e, state.target);
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== 'Enter' && $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isHTMLAnchorLink(state.target) && (0, $3086a20958df8aeb$export$4282f70798064fe0)(state.target, target) && !e[$ecc4b8c956bf739d$var$$a87f4c40785e693b$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$ecc4b8c956bf739d$var$$a87f4c40785e693b$var$LINK_CLICKED] = true;
                    (0, $74847c07cc15756a$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === 'Meta' && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent('keyup', event));
            }
        };
        if (typeof PointerEvent !== 'undefined') {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e))) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $4180de1039dadb35$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = 'virtual';
                    return;
                }
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!allowTextSelectionOnPress) (0, $b782d35405753235$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    // Release pointer capture so that touch interactions can leave the original target.
                    // This enables onPointerLeave and onPointerEnter to fire.
                    let target = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
                    if ('releasePointerCapture' in target) {
                        if ('hasPointerCapture' in target) {
                            if (target.hasPointerCapture(e.pointerId)) target.releasePointerCapture(e.pointerId);
                        } else target.releasePointerCapture(e.pointerId);
                    }
                    addGlobalListener((0, $0be158cb8722d424$export$b204af158042fbac)(e.currentTarget), 'pointerup', onPointerUp, false);
                    addGlobalListener((0, $0be158cb8722d424$export$b204af158042fbac)(e.currentTarget), 'pointercancel', onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e))) return;
                if (e.button === 0) {
                    if (preventFocusOnPress) {
                        let dispose = (0, $ad5cf595cca499ee$export$cabe61c495ee3649)(e.target);
                        if (dispose) state.disposables.push(dispose);
                    }
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e)) || state.pointerType === 'virtual') return;
                // Only handle left clicks. If isPressed is true, delay until onClick.
                if (e.button === 0 && !state.isPressed) triggerPressUpEvent(e, state.pointerType || e.pointerType);
            };
            pressProps.onPointerEnter = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && !state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = true;
                    triggerPressStart($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(state.target, e), state.pointerType);
                }
            };
            pressProps.onPointerLeave = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    triggerPressEndEvent($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ((0, $3086a20958df8aeb$export$4282f70798064fe0)(state.target, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e)) && state.pointerType != null) {
                        // Wait for onClick to fire onPress. This avoids browser issues when the DOM
                        // is mutated between onPointerUp and onClick, and is more compatible with third party libraries.
                        // https://github.com/adobe/react-spectrum/issues/1513
                        // https://issues.chromium.org/issues/40732224
                        // However, iOS and Android do not focus or fire onClick after a long press.
                        // We work around this by triggering a click ourselves after a timeout.
                        // This timeout is canceled during the click event in case the real one fires first.
                        // The timeout must be at least 32ms, because Safari on iOS delays the click event on
                        // non-form elements without certain ARIA roles (for hover emulation).
                        // https://github.com/WebKit/WebKit/blob/dccfae42bb29bd4bdef052e469f604a9387241c0/Source/WebKit/WebProcess/WebPage/ios/WebPageIOS.mm#L875-L892
                        let clicked = false;
                        let timeout = setTimeout(()=>{
                            if (state.isPressed && state.target instanceof HTMLElement) {
                                if (clicked) cancelEvent(e);
                                else {
                                    (0, $c6efdf0de8a9630d$export$de79e2c695e052f3)(state.target);
                                    state.target.click();
                                }
                            }
                        }, 80);
                        // Use a capturing listener to track if a click occurred.
                        // If stopPropagation is called it may never reach our handler.
                        addGlobalListener(e.currentTarget, 'click', ()=>clicked = true, true);
                        state.disposables.push(()=>clearTimeout(timeout));
                    } else cancelEvent(e);
                    // Ignore subsequent onPointerLeave event before onClick on touch devices.
                    state.isOverTarget = false;
                }
            };
            let onPointerCancel = (e)=>{
                // eslint-disable-next-line react-hooks/rules-of-hooks
                cancelEvent(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e))) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                cancelEvent(e);
            };
        } else var e, e1, e2, e3, e4, e5, e6, e7, e8;
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancelOnPointerExit,
        triggerPressStart,
        triggerClick,
        triggerSyntheticClick
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (!domRef || false) return;
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(domRef.current);
        if (!ownerDocument || !ownerDocument.head || ownerDocument.getElementById($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$STYLE_ID)) return;
        const style = ownerDocument.createElement('style');
        style.id = $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$STYLE_ID;
        let nonce = (0, $a2f8c65b815ba806$export$2b85b721e524d74b)(ownerDocument);
        if (nonce) style.nonce = nonce;
        // touchAction: 'manipulation' is supposed to be equivalent, but in
        // Safari it causes onPointerCancel not to fire on scroll.
        // https://bugs.webkit.org/show_bug.cgi?id=240917
        style.textContent = `
@layer {
  [${$ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PRESSABLE_ATTRIBUTE}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim();
        ownerDocument.head.prepend(style);
    }, [
        domRef
    ]);
    (0, $70fFQ.useEffect)(()=>{
        let state = ref.current;
        return ()=>{
            var _state_target;
            if (!allowTextSelectionOnPress) (0, $b782d35405753235$export$b0d6fa1ab32e3295)((_state_target = state.target) !== null && _state_target !== void 0 ? _state_target : undefined);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)(domProps, pressProps, {
            [$ecc4b8c956bf739d$var$$a87f4c40785e693b$var$PRESSABLE_ATTRIBUTE]: true
        })
    };
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isHTMLAnchorLink(target) {
    return target.tagName === 'A' && target.hasAttribute('href');
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute('role');
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && !(element instanceof (0, $0be158cb8722d424$export$f21a1ffae260145a)(element).HTMLInputElement && !$ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isValidInputKey(element, key) || element instanceof (0, $0be158cb8722d424$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === 'link' || !role && $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isHTMLAnchorLink(element)) && key !== 'Enter');
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createTouchEvent(target, e) {
    let clientX = 0;
    let clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$createEvent(target, e) {
    let clientX = e.clientX;
    let clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY,
        key: e.key
    };
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$getPointClientRect(point);
    return $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$areRectanglesOverlapping(rect, pointRect);
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$shouldPreventDefaultUp(target) {
    if (target instanceof HTMLInputElement) return false;
    if (target instanceof HTMLButtonElement) return target.type !== 'submit' && target.type !== 'reset';
    if ($ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isHTMLAnchorLink(target)) return false;
    return true;
}
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isValidInputKey(target, key);
    return $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$shouldPreventDefaultUp(target);
}
const $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === 'checkbox' || target.type === 'radio' ? key === ' ' : $ecc4b8c956bf739d$var$$a87f4c40785e693b$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f8ccf0fecb347b61$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, value: value, name: name, form: form, children: children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, validationState: validationState = 'valid', isInvalid: isInvalid, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, onPressUp: onPressUp, onClick: onClick } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e).checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $ecc4b8c956bf739d$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $ecc4b8c956bf739d$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPressUp: onPressUp,
        onClick: onClick,
        onPress (e) {
            var _ref_current;
            onPress === null || onPress === void 0 || onPress(e);
            state.toggle();
            (_ref_current = ref.current) === null || _ref_current === void 0 || _ref_current.focus();
        },
        isDisabled: isDisabled || isReadOnly
    });
    let { focusableProps: focusableProps } = (0, $a5b5972f65b7b461$export$4c014de7c8940b4c)(props, ref);
    let interactions = (0, $4e4840536c52e885$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = (0, $3521997fbd9016c9$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    (0, $4ff2f40121425aba$export$5add1d006293d136)(ref, state.defaultSelected, state.setSelected);
    return {
        labelProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)(domProps, {
            'aria-invalid': isInvalid || validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value: value
            },
            name: name,
            form: form,
            type: 'checkbox',
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || validationState === 'invalid'
    };
}








var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $54702a482e9f562d$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        if (validationBehavior === 'native' && (ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.disabled) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(' ') || 'Invalid value.' : '';
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute('title')) ref.current.title = '';
            if (!state.realtimeValidation.isInvalid) state.updateValidation($54702a482e9f562d$var$$3bea40a930a50ce5$var$getNativeValidity(ref.current));
        }
    });
    let isIgnoredReset = (0, $70fFQ.useRef)(false);
    let onReset = (0, $5ff35cebe086a8a9$export$7f54fc3180508a52)(()=>{
        if (!isIgnoredReset.current) state.resetValidation();
    });
    let onInvalid = (0, $5ff35cebe086a8a9$export$7f54fc3180508a52)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $54702a482e9f562d$var$$3bea40a930a50ce5$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $bad2a4032856d574$export$8397ddfc504fdb9a)('keyboard');
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $5ff35cebe086a8a9$export$7f54fc3180508a52)(()=>{
        state.commitValidation();
    });
    (0, $70fFQ.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        let reset = form === null || form === void 0 ? void 0 : form.reset;
        if (form) // validation errors that are returned by server actions.
        // To do this, we ignore programmatic form resets that occur outside a user event.
        // This is best-effort. There may be false positives, e.g. setTimeout.
        form.reset = ()=>{
            // React uses MessageChannel for scheduling, so ignore 'message' events.
            isIgnoredReset.current = !window.event || window.event.type === 'message' && (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(window.event) instanceof MessagePort;
            reset === null || reset === void 0 || reset.call(form);
            isIgnoredReset.current = false;
        };
        input.addEventListener('invalid', onInvalid);
        input.addEventListener('change', onChange);
        form === null || form === void 0 || form.addEventListener('reset', onReset);
        return ()=>{
            input.removeEventListener('invalid', onInvalid);
            input.removeEventListener('change', onChange);
            form === null || form === void 0 || form.removeEventListener('reset', onReset);
            if (form) form.reset = reset;
        };
    }, [
        ref,
        validationBehavior
    ]);
}
function $54702a482e9f562d$var$$3bea40a930a50ce5$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $54702a482e9f562d$var$$3bea40a930a50ce5$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $54702a482e9f562d$var$$3bea40a930a50ce5$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $54702a482e9f562d$var$$3bea40a930a50ce5$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        var _element_validity;
        let element = form.elements[i];
        if (((_element_validity = element.validity) === null || _element_validity === void 0 ? void 0 : _element_validity.valid) === false) return element;
    }
    return null;
}




var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $245b40a25281bbdb$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $245b40a25281bbdb$var$$d085204f885ad67a$var$CUSTOM_VALIDITY_STATE = {
    ...$245b40a25281bbdb$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $245b40a25281bbdb$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $245b40a25281bbdb$export$aca958c65c314e6c,
    validationErrors: []
};
const $245b40a25281bbdb$export$571b5131b7e65c11 = (0, $70fFQ.createContext)({});
const $245b40a25281bbdb$export$a763b9476acd3eb = '__reactAriaFormValidationState';
function $245b40a25281bbdb$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$245b40a25281bbdb$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$245b40a25281bbdb$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $245b40a25281bbdb$var$$d085204f885ad67a$var$useFormValidationStateImpl(props);
}
function $245b40a25281bbdb$var$$d085204f885ad67a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = 'aria' } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === 'invalid');
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $245b40a25281bbdb$var$$d085204f885ad67a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $70fFQ.useMemo)(()=>{
        if (!validate || value == null) return null;
        let validateErrors = $245b40a25281bbdb$var$$d085204f885ad67a$var$runValidate(validate, value);
        return $245b40a25281bbdb$var$$d085204f885ad67a$var$getValidationResult(validateErrors);
    }, [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = undefined;
    // Get relevant server errors from the form.
    let serverErrors = (0, $70fFQ.useContext)($245b40a25281bbdb$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $70fFQ.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$245b40a25281bbdb$var$$d085204f885ad67a$var$asArray(serverErrors[name])) : $245b40a25281bbdb$var$$d085204f885ad67a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $70fFQ.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $70fFQ.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $70fFQ.useMemo)(()=>$245b40a25281bbdb$var$$d085204f885ad67a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $70fFQ.useRef)($245b40a25281bbdb$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $70fFQ.useState)($245b40a25281bbdb$export$dad6ae84456c676a);
    let lastError = (0, $70fFQ.useRef)($245b40a25281bbdb$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$245b40a25281bbdb$var$$d085204f885ad67a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $70fFQ.useState)(false);
    (0, $70fFQ.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $245b40a25281bbdb$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === 'native' ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === 'aria' && !$245b40a25281bbdb$var$$d085204f885ad67a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $245b40a25281bbdb$export$dad6ae84456c676a;
            if (!$245b40a25281bbdb$var$$d085204f885ad67a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === 'native') setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === 'native') setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $245b40a25281bbdb$var$$d085204f885ad67a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $245b40a25281bbdb$var$$d085204f885ad67a$var$runValidate(validate, value) {
    if (typeof validate === 'function') {
        let e = validate(value);
        if (e && typeof e !== 'boolean') return $245b40a25281bbdb$var$$d085204f885ad67a$var$asArray(e);
    }
    return [];
}
function $245b40a25281bbdb$var$$d085204f885ad67a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $245b40a25281bbdb$var$$d085204f885ad67a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $245b40a25281bbdb$var$$d085204f885ad67a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return !!a && !!b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $245b40a25281bbdb$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$245b40a25281bbdb$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dc14a8cdff83acd7$export$e375f10ce42261c5(props, state, inputRef) {
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    let validationState = (0, $245b40a25281bbdb$export$fc1a364ae1f3ff10)({
        ...props,
        value: state.isSelected
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly } = (0, $f8ccf0fecb347b61$export$cbe85ee05b554577)({
        ...props,
        isInvalid: isInvalid
    }, state, inputRef);
    (0, $54702a482e9f562d$export$b8473d3665f3a75a)(props, validationState, inputRef);
    let { isIndeterminate: isIndeterminate, isRequired: isRequired, validationBehavior: validationBehavior = 'aria' } = props;
    (0, $70fFQ.useEffect)(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    // Reset validation state on label press for checkbox with a hidden input.
    let { pressProps: pressProps } = (0, $ecc4b8c956bf739d$export$45712eceda6fad21)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            // @ts-expect-error
            let { [(0, $245b40a25281bbdb$export$a763b9476acd3eb)]: groupValidationState } = props;
            let { commitValidation: commitValidation } = groupValidationState ? groupValidationState : validationState;
            commitValidation();
        }
    });
    return {
        labelProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)(labelProps, pressProps, (0, $70fFQ.useMemo)(()=>({
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: {
            ...inputProps,
            checked: isSelected,
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            required: isRequired && validationBehavior === 'native'
        },
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}








var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $b3e7e2b301c53c40$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $70fFQ.useRef)({
        isFocusWithin: false
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $2736dfdb74f3103f$export$4eaf04e54aa8eed6)();
    let onBlur = (0, $70fFQ.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e))) return;
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, e.relatedTarget)) {
            state.current.isFocusWithin = false;
            removeAllGlobalListeners();
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state,
        removeAllGlobalListeners
    ]);
    let onSyntheticFocus = (0, $ad5cf595cca499ee$export$715c682d09d639cc)(onBlur);
    let onFocus = (0, $70fFQ.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $3086a20958df8aeb$export$4282f70798064fe0)(e.currentTarget, (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e))) return;
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(eventTarget);
        const activeElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument);
        if (!state.current.isFocusWithin && activeElement === eventTarget) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
            // Browsers don't fire blur events when elements are removed from the DOM.
            // However, if a focus event occurs outside the element we're tracking, we
            // can manually fire onBlur.
            let currentTarget = e.currentTarget;
            addGlobalListener(ownerDocument, 'focus', (e)=>{
                let eventTarget = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
                if (state.current.isFocusWithin && !(0, $3086a20958df8aeb$export$4282f70798064fe0)(currentTarget, eventTarget)) {
                    let nativeEvent = new ownerDocument.defaultView.FocusEvent('blur', {
                        relatedTarget: eventTarget
                    });
                    (0, $ad5cf595cca499ee$export$c2b7abe5d61ec696)(nativeEvent, currentTarget);
                    let event = (0, $ad5cf595cca499ee$export$525bc4921d56d4a)(nativeEvent);
                    onBlur(event);
                }
            }, {
                capture: true
            });
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus,
        addGlobalListener,
        onBlur
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These cannot be null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $730ba0c4b6fc7e48$var$$6947385881e3ae0e$var$styles = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap'
};
function $730ba0c4b6fc7e48$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $70fFQ.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $b3e7e2b301c53c40$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $70fFQ.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$730ba0c4b6fc7e48$var$$6947385881e3ae0e$var$styles,
            ...style
        };
        else return $730ba0c4b6fc7e48$var$$6947385881e3ae0e$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $730ba0c4b6fc7e48$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = 'div', isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $730ba0c4b6fc7e48$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(Element, (0, $4e4840536c52e885$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}




var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e2e452c03460cda8$var$$2a35a170cf8e413e$var$_React_useInsertionEffect;
// Use the earliest effect possible to reset the ref below.
const $e2e452c03460cda8$var$$2a35a170cf8e413e$var$useEarlyEffect = typeof document !== 'undefined' ? ($e2e452c03460cda8$var$$2a35a170cf8e413e$var$_React_useInsertionEffect = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ)))['useInsertionEffect']) !== null && $e2e452c03460cda8$var$$2a35a170cf8e413e$var$_React_useInsertionEffect !== void 0 ? $e2e452c03460cda8$var$$2a35a170cf8e413e$var$_React_useInsertionEffect : (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useLayoutEffect : ()=>{};
function $e2e452c03460cda8$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    // Store the value in both state and a ref. The state value will only be used when uncontrolled.
    // The ref is used to track the most current value, which is passed to the function setState callback.
    let [stateValue, setStateValue] = (0, $70fFQ.useState)(value || defaultValue);
    let valueRef = (0, $70fFQ.useRef)(stateValue);
    let isControlledRef = (0, $70fFQ.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $70fFQ.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    // After each render, update the ref to the current value.
    // This ensures that the setState callback argument is reset.
    // Note: the effect should not have any dependencies so that controlled values always reset.
    let currentValue = isControlled ? value : stateValue;
    $e2e452c03460cda8$var$$2a35a170cf8e413e$var$useEarlyEffect(()=>{
        valueRef.current = currentValue;
    });
    let [, forceUpdate] = (0, $70fFQ.useReducer)(()=>({}), {});
    let setValue = (0, $70fFQ.useCallback)((value, ...args)=>{
        // @ts-ignore - TS doesn't know that T cannot be a function.
        let newValue = typeof value === 'function' ? value(valueRef.current) : value;
        if (!Object.is(valueRef.current, newValue)) {
            // Update the ref so that the next setState callback has the most recent value.
            valueRef.current = newValue;
            setStateValue(newValue);
            // Always trigger a re-render, even when controlled, so that the layout effect above runs to reset the value.
            forceUpdate();
            // Trigger onChange. Note that if setState is called multiple times in a single event,
            // onChange will be called for each one instead of only once.
            onChange === null || onChange === void 0 || onChange(newValue, ...args);
        }
    }, [
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $054a18064d19e0b5$var$$14031cfad4eebf54$var$instance = Math.round(Math.random() * 10000000000);
let $054a18064d19e0b5$var$$14031cfad4eebf54$var$i = 0;
function $054a18064d19e0b5$export$bca9d026f8e704eb(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (0, $70fFQ.useMemo)(()=>props.name || `radio-group-${$054a18064d19e0b5$var$$14031cfad4eebf54$var$instance}-${++$054a18064d19e0b5$var$$14031cfad4eebf54$var$i}`, [
        props.name
    ]);
    var _props_defaultValue;
    let [selectedValue, setSelected] = (0, $e2e452c03460cda8$export$40bfa8c7b0832715)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
    let [initialValue] = (0, $70fFQ.useState)(selectedValue);
    let [lastFocusedValue, setLastFocusedValue] = (0, $70fFQ.useState)(null);
    let validation = (0, $245b40a25281bbdb$export$fc1a364ae1f3ff10)({
        ...props,
        value: selectedValue
    });
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    let isInvalid = validation.displayValidation.isInvalid;
    var _props_defaultValue1;
    return {
        ...validation,
        name: name,
        selectedValue: selectedValue,
        defaultSelectedValue: props.value !== undefined ? initialValue : (_props_defaultValue1 = props.defaultValue) !== null && _props_defaultValue1 !== void 0 ? _props_defaultValue1 : null,
        setSelectedValue: setSelectedValue,
        lastFocusedValue: lastFocusedValue,
        setLastFocusedValue: setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? 'invalid' : null),
        isInvalid: isInvalid
    };
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $401c3720dbbec518$export$8042c6c013fd5226(props = {}) {
    let { isReadOnly: isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, $e2e452c03460cda8$export$40bfa8c7b0832715)(props.isSelected, props.defaultSelected || false, props.onChange);
    let [initialValue] = (0, $70fFQ.useState)(isSelected);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    var _props_defaultSelected;
    return {
        isSelected: isSelected,
        defaultSelected: (_props_defaultSelected = props.defaultSelected) !== null && _props_defaultSelected !== void 0 ? _props_defaultSelected : initialValue,
        setSelected: updateSelected,
        toggle: toggleState
    };
}


var $91f5eddb5f5d2479$exports = {};
/*!
  react-datepicker v6.9.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 
































































!function(e, t) {
    t($91f5eddb5f5d2479$exports, (parcelRequire("70fFQ")), (parcelRequire("cd0Jr")), (parcelRequire("axMmP")), (parcelRequire("bht2X")), (parcelRequire("4pFgQ")), (parcelRequire("9IzSo")), (parcelRequire("9VdIH")), (parcelRequire("lk4ac")), (parcelRequire("2vrAW")), (parcelRequire("1hExc")), (parcelRequire("1uoU9")), (parcelRequire("ejkpp")), (parcelRequire("bvEuC")), (parcelRequire("5BZWP")), (parcelRequire("4YyMs")), (parcelRequire("baGWJ")), (parcelRequire("ba81a")), (parcelRequire("aZjqa")), (parcelRequire("cDEq1")), (parcelRequire("lvYCh")), (parcelRequire("lk486")), (parcelRequire("7Vb0N")), (parcelRequire("4sou0")), (parcelRequire("5MJAb")), (parcelRequire("7ivcB")), (parcelRequire("gTkms")), (parcelRequire("d8MXz")), (parcelRequire("bUKY3")), (parcelRequire("6dtTI")), (parcelRequire("kMcoB")), (parcelRequire("uw6ye")), (parcelRequire("lf7yb")), (parcelRequire("g5M5t")), (parcelRequire("fgH89")), (parcelRequire("dczK0")), (parcelRequire("7nRuI")), (parcelRequire("jaIwE")), (parcelRequire("8pkT1")), (parcelRequire("8EzaS")), (parcelRequire("lesSB")), (parcelRequire("ePNEc")), (parcelRequire("dembC")), (parcelRequire("fNVra")), (parcelRequire("5tBn0")), (parcelRequire("2pG9s")), (parcelRequire("exWqC")), (parcelRequire("8mcDi")), (parcelRequire("lVNbV")), (parcelRequire("72tdj")), (parcelRequire("ky24C")), (parcelRequire("73v8c")), (parcelRequire("9qPPc")), (parcelRequire("82gj4")), (parcelRequire("g5oPq")), (parcelRequire("7s5Ss")), (parcelRequire("fLOXb")), (parcelRequire("flwHs")), (parcelRequire("7NYl1")), (parcelRequire("l1Ixk")), (parcelRequire("5WWIe")), (parcelRequire("aECmM")), (parcelRequire("aRv2D")), (parcelRequire("3glZ1")), (parcelRequire("hQ3sB")), (parcelRequire("4znFA")));
}($91f5eddb5f5d2479$exports, function(e, t, r, n, a, o, s, i, p, c, l, d, u, h, f, m, y, g, v, D, k, w, b, S, M, C, _, Y, E, P, N, O, x, I, T, R, L, F, A, W, Q, K, q, B, H, j, V, U, $, z, G, J, X, Z, ee, te, re, ne, ae, oe, se, ie, pe, ce, le, de) {
    "use strict";
    function ue(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var he = ue(t), fe = ue(pe), me = ue(ce);
    function ye(e, t, r) {
        return t = Ee(t), function(e, t) {
            if (t && ("object" == typeof t || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e);
        }(e, ge() ? Reflect.construct(t, r || [], Ee(e).constructor) : t.apply(e, r));
    }
    function ge() {
        try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (e) {}
        return (ge = function() {
            return !!e;
        })();
    }
    function ve(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function De(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ve(Object(r), !0).forEach(function(t) {
                Ce(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ve(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ke(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
                var n = r.call(e, t || "default");
                if ("object" != typeof n) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }
    function we(e) {
        return we = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, we(e);
    }
    function be(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Se(e, t) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ke(n.key), n);
        }
    }
    function Me(e, t, r) {
        return t && Se(e.prototype, t), r && Se(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Ce(e, t, r) {
        return (t = ke(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function _e() {
        return _e = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, _e.apply(this, arguments);
    }
    function Ye(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && Pe(e, t);
    }
    function Ee(e) {
        return Ee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, Ee(e);
    }
    function Pe(e, t) {
        return Pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        }, Pe(e, t);
    }
    function Ne(e) {
        return function(e) {
            if (Array.isArray(e)) return Oe(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Oe(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Oe(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Oe(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
        return n;
    }
    var xe = 12, Ie = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Te(e) {
        var t = e ? "string" == typeof e || e instanceof String ? se.parseISO(e) : ae.toDate(e) : new Date;
        return Re(t) ? t : null;
    }
    function Re(e, t) {
        return t = t || new Date("1/1/1000"), o.isValid(e) && !re.isBefore(e, t);
    }
    function Le(e, t, r) {
        if ("en" === r) return s.format(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var n = Je(r);
        return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && Ge() && Je(Ge()) && (n = Je(Ge())), s.format(e, t, {
            locale: n || null,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Fe(e, t) {
        var r = t.dateFormat, n = t.locale;
        return e && Le(e, Array.isArray(r) ? r[0] : r, n) || "";
    }
    function Ae(e, t) {
        var r = t.hour, n = void 0 === r ? 0 : r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second, i = void 0 === s ? 0 : s;
        return O.setHours(N.setMinutes(P.setSeconds(e, i), o), n);
    }
    function We(e, t, r) {
        var n = Je(t || Ge());
        return q.startOfWeek(e, {
            locale: n,
            weekStartsOn: r
        });
    }
    function Qe(e) {
        return B.startOfMonth(e);
    }
    function Ke(e) {
        return j.startOfYear(e);
    }
    function qe(e) {
        return H.startOfQuarter(e);
    }
    function Be() {
        return K.startOfDay(Te());
    }
    function He(e, t) {
        return e && t ? Z.isSameYear(e, t) : !e && !t;
    }
    function je(e, t) {
        return e && t ? X.isSameMonth(e, t) : !e && !t;
    }
    function Ve(e, t) {
        return e && t ? ee.isSameQuarter(e, t) : !e && !t;
    }
    function Ue(e, t) {
        return e && t ? J.isSameDay(e, t) : !e && !t;
    }
    function $e(e, t) {
        return e && t ? G.isEqual(e, t) : !e && !t;
    }
    function ze(e, t, r) {
        var n, a = K.startOfDay(t), o = V.endOfDay(r);
        try {
            n = ne.isWithinInterval(e, {
                start: a,
                end: o
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function Ge() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Je(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Xe(e, t) {
        return Le(x.setMonth(Te(), e), "LLLL", t);
    }
    function Ze(e, t) {
        return Le(x.setMonth(Te(), e), "LLL", t);
    }
    function et(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return pt(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Ue(e, t.date ? t.date : t);
        }) || o && o.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || s && !s.some(function(t) {
            return Ue(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || p && !p(Te(e)) || !1;
    }
    function tt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, n = t.excludeDateIntervals;
        return n && n.length > 0 ? n.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) : r && r.some(function(t) {
            return Ue(e, t.date ? t.date : t);
        }) || !1;
    }
    function rt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return pt(e, {
            minDate: B.startOfMonth(r),
            maxDate: $.endOfMonth(n)
        }) || a && a.some(function(t) {
            return je(e, t);
        }) || o && !o.some(function(t) {
            return je(e, t);
        }) || s && !s(Te(e)) || !1;
    }
    function nt(e, t, r, n) {
        var a = Y.getYear(e), o = C.getMonth(e), s = Y.getYear(t), i = C.getMonth(t), p = Y.getYear(n);
        return a === s && a === p ? o <= r && r <= i : a < s ? p === a && o <= r || p === s && i >= r || p < s && p > a : void 0;
    }
    function at(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return pt(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Ve(e, t);
        }) || o && !o.some(function(t) {
            return Ve(e, t);
        }) || s && !s(Te(e)) || !1;
    }
    function ot(e, t, r) {
        if (!o.isValid(t) || !o.isValid(r)) return !1;
        var n = Y.getYear(t), a = Y.getYear(r);
        return n <= e && a >= e;
    }
    function st(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate, i = new Date(e, 0, 1);
        return pt(i, {
            minDate: j.startOfYear(r),
            maxDate: z.endOfYear(n)
        }) || a && a.some(function(e) {
            return He(i, e);
        }) || o && !o.some(function(e) {
            return He(i, e);
        }) || s && !s(Te(i)) || !1;
    }
    function it(e, t, r, n) {
        var a = Y.getYear(e), o = _.getQuarter(e), s = Y.getYear(t), i = _.getQuarter(t), p = Y.getYear(n);
        return a === s && a === p ? o <= r && r <= i : a < s ? p === a && o <= r || p === s && i >= r || p < s && p > a : void 0;
    }
    function pt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate;
        return r && F.differenceInCalendarDays(e, r) < 0 || n && F.differenceInCalendarDays(e, n) > 0;
    }
    function ct(e, t) {
        return t.some(function(t) {
            return w.getHours(t) === w.getHours(e) && k.getMinutes(t) === k.getMinutes(e) && D.getSeconds(t) === D.getSeconds(e);
        });
    }
    function lt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, n = t.includeTimes, a = t.filterTime;
        return r && ct(e, r) || n && !ct(e, n) || a && !a(e) || !1;
    }
    function dt(e, t) {
        var r = t.minTime, n = t.maxTime;
        if (!r || !n) throw new Error("Both minTime and maxTime props required");
        var a = Te();
        a = O.setHours(a, w.getHours(e)), a = N.setMinutes(a, k.getMinutes(e)), a = P.setSeconds(a, D.getSeconds(e));
        var o = Te();
        o = O.setHours(o, w.getHours(r)), o = N.setMinutes(o, k.getMinutes(r)), o = P.setSeconds(o, D.getSeconds(r));
        var s, i = Te();
        i = O.setHours(i, w.getHours(n)), i = N.setMinutes(i, k.getMinutes(n)), i = P.setSeconds(i, D.getSeconds(n));
        try {
            s = !ne.isWithinInterval(a, {
                start: o,
                end: i
            });
        } catch (e) {
            s = !1;
        }
        return s;
    }
    function ut(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = y.subMonths(e, 1);
        return r && A.differenceInCalendarMonths(r, a) > 0 || n && n.every(function(e) {
            return A.differenceInCalendarMonths(e, a) > 0;
        }) || !1;
    }
    function ht(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = d.addMonths(e, 1);
        return r && A.differenceInCalendarMonths(a, r) > 0 || n && n.every(function(e) {
            return A.differenceInCalendarMonths(a, e) > 0;
        }) || !1;
    }
    function ft(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = v.subYears(e, 1);
        return r && W.differenceInCalendarYears(r, a) > 0 || n && n.every(function(e) {
            return W.differenceInCalendarYears(e, a) > 0;
        }) || !1;
    }
    function mt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = h.addYears(e, 1);
        return r && W.differenceInCalendarYears(a, r) > 0 || n && n.every(function(e) {
            return W.differenceInCalendarYears(a, e) > 0;
        }) || !1;
    }
    function yt(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return F.differenceInCalendarDays(e, t) >= 0;
            });
            return R.min(n);
        }
        return r ? R.min(r) : t;
    }
    function gt(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return F.differenceInCalendarDays(e, t) <= 0;
            });
            return L.max(n);
        }
        return r ? L.max(r) : t;
    }
    function vt() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, n = 0, o = e.length; n < o; n++){
            var s = e[n];
            if (a.isDate(s)) {
                var i = Le(s, "MM.dd.yyyy"), p = r.get(i) || [];
                p.includes(t) || (p.push(t), r.set(i, p));
            } else if ("object" === we(s)) {
                var c = Object.keys(s), l = c[0], d = s[c[0]];
                if ("string" == typeof l && d.constructor === Array) for(var u = 0, h = d.length; u < h; u++){
                    var f = Le(d[u], "MM.dd.yyyy"), m = r.get(f) || [];
                    m.includes(l) || (m.push(l), r.set(f, m));
                }
            }
        }
        return r;
    }
    function Dt() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--holidays", r = new Map;
        return e.forEach(function(e) {
            var n = e.date, o = e.holidayName;
            if (a.isDate(n)) {
                var s = Le(n, "MM.dd.yyyy"), i = r.get(s) || {};
                if (!("className" in i) || i.className !== t || (p = i.holidayNames, c = [
                    o
                ], p.length !== c.length || !p.every(function(e, t) {
                    return e === c[t];
                }))) {
                    var p, c;
                    i.className = t;
                    var l = i.holidayNames;
                    i.holidayNames = l ? [].concat(Ne(l), [
                        o
                    ]) : [
                        o
                    ], r.set(s, i);
                }
            }
        }), r;
    }
    function kt(e, t, r, n, a) {
        for(var o = a.length, s = [], c = 0; c < o; c++){
            var l = e;
            l = p.addHours(l, w.getHours(a[c])), l = i.addMinutes(l, k.getMinutes(a[c])), l = ie.addSeconds(l, D.getSeconds(a[c]));
            var d = i.addMinutes(e, (r + 1) * n);
            te.isAfter(l, t) && re.isBefore(l, d) && s.push(a[c]);
        }
        return s;
    }
    function wt(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function bt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xe, r = Math.ceil(Y.getYear(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function St(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return ae.toDate(e.getTime() - 1e3 * t - r);
    }
    function Mt(e) {
        if (!a.isDate(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function Ct(e, t) {
        if (!a.isDate(e) || !a.isDate(t)) throw new Error("Invalid date received");
        var r = Mt(e), n = Mt(t);
        return re.isBefore(r, n);
    }
    function _t(e) {
        return " " === e.key;
    }
    function Yt(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Y.getYear(r) <= s), n && i && (i = Y.getYear(n) >= s), i && a.push(s);
        }
        return a;
    }
    var Et = function(e) {
        function r(e) {
            var n;
            be(this, r), Ce(n = ye(this, r, [
                e
            ]), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return he.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(n, t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? he.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Y.getYear(n.props.minDate) : null, a = n.props.maxDate ? Y.getYear(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(he.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, he.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(he.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, he.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Ce(n, "onChange", function(e) {
                n.props.onChange(e);
            }), Ce(n, "handleClickOutside", function() {
                n.props.onCancel();
            }), Ce(n, "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Ce(n, "incrementYears", function() {
                return n.shiftYears(1);
            }), Ce(n, "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var a = e.yearDropdownItemNumber, o = e.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return n.state = {
                yearsList: Yt(n.props.year, s, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return Ye(r, e), Me(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    if (e) {
                        var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                            return e.ariaSelected;
                        }) : null;
                        e.scrollTop = r ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = n.clsx({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return he.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), Pt = fe.default(Et), Nt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Y.getYear(e.props.minDate) : 1900, r = e.props.maxDate ? Y.getYear(e.props.maxDate) : 2100, n = [], a = t; a <= r; a++)n.push(he.default.createElement("option", {
                    key: a,
                    value: a
                }, a));
                return n;
            }), Ce(e, "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Ce(e, "renderSelectMode", function() {
                return he.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Ce(e, "renderReadView", function(t) {
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, he.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Ce(e, "renderDropdown", function() {
                return he.default.createElement(Pt, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Ce(e, "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Ce(e, "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Ce(e, "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Ce(e, "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Ce(e, "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component), Ot = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Ce(e, "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return he.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(e, r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? he.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Ce(e, "onChange", function(t) {
                return e.props.onChange(t);
            }), Ce(e, "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), xt = fe.default(Ot), It = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return he.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Ce(e, "renderSelectMode", function(t) {
                return he.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Ce(e, "renderReadView", function(t, r) {
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, he.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Ce(e, "renderDropdown", function(t) {
                return he.default.createElement(xt, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Ce(e, "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, n = [
                    e.renderReadView(!r, t)
                ];
                return r && n.unshift(e.renderDropdown(t)), n;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Ce(e, "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return Ze(e, t.props.locale);
                    } : function(e) {
                        return Xe(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component);
    function Tt(e, t) {
        for(var r = [], n = Qe(e), a = Qe(t); !te.isAfter(n, a);)r.push(Te(n)), n = d.addMonths(n, 1);
        return r;
    }
    var Rt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "renderOptions", function() {
                return r.state.monthYearsList.map(function(e) {
                    var t = E.getTime(e), n = He(r.props.date, e) && je(r.props.date, e);
                    return he.default.createElement("div", {
                        className: n ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: r.onChange.bind(r, t),
                        "aria-selected": n ? "true" : void 0
                    }, n ? he.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Le(e, r.props.dateFormat, r.props.locale));
                });
            }), Ce(r, "onChange", function(e) {
                return r.props.onChange(e);
            }), Ce(r, "handleClickOutside", function() {
                r.props.onCancel();
            }), r.state = {
                monthYearsList: Tt(r.props.minDate, r.props.maxDate)
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = n.clsx({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return he.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), Lt = fe.default(Rt), Ft = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function() {
                for(var t = Qe(e.props.minDate), r = Qe(e.props.maxDate), n = []; !te.isAfter(t, r);){
                    var a = E.getTime(t);
                    n.push(he.default.createElement("option", {
                        key: a,
                        value: a
                    }, Le(t, e.props.dateFormat, e.props.locale))), t = d.addMonths(t, 1);
                }
                return n;
            }), Ce(e, "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Ce(e, "renderSelectMode", function() {
                return he.default.createElement("select", {
                    value: E.getTime(Qe(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Ce(e, "renderReadView", function(t) {
                var r = Le(e.props.date, e.props.dateFormat, e.props.locale);
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, he.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Ce(e, "renderDropdown", function() {
                return he.default.createElement(Lt, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Ce(e, "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown();
                var r = Te(parseInt(t));
                He(e.props.date, r) && je(e.props.date, r) || e.props.onChange(r);
            }), Ce(e, "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component), At = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, a = new Array(r), o = 0; o < r; o++)a[o] = arguments[o];
            return Ce(e = ye(this, t, [].concat(a)), "dayEl", he.default.createRef()), Ce(e, "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Ce(e, "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Ce(e, "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Ce(e, "isSameDay", function(t) {
                return Ue(e.props.day, t);
            }), Ce(e, "isKeyboardSelected", function() {
                var t;
                return !e.props.disabledKeyboardNavigation && !(e.props.selectsMultiple ? null === (t = e.props.selectedDates) || void 0 === t ? void 0 : t.some(function(t) {
                    return e.isSameDayOrWeek(t);
                }) : e.isSameDayOrWeek(e.props.selected)) && e.isSameDayOrWeek(e.props.preSelection);
            }), Ce(e, "isDisabled", function() {
                return et(e.props.day, e.props);
            }), Ce(e, "isExcluded", function() {
                return tt(e.props.day, e.props);
            }), Ce(e, "isStartOfWeek", function() {
                return Ue(e.props.day, We(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Ce(e, "isSameWeek", function(t) {
                return e.props.showWeekPicker && Ue(t, We(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Ce(e, "isSameDayOrWeek", function(t) {
                return e.isSameDay(t) || e.isSameWeek(t);
            }), Ce(e, "getHighLightedClass", function() {
                var t = e.props, r = t.day, n = t.highlightDates;
                if (!n) return !1;
                var a = Le(r, "MM.dd.yyyy");
                return n.get(a);
            }), Ce(e, "getHolidaysClass", function() {
                var t = e.props, r = t.day, n = t.holidays;
                if (!n) return !1;
                var a = Le(r, "MM.dd.yyyy");
                return n.has(a) ? [
                    n.get(a).className
                ] : void 0;
            }), Ce(e, "isInRange", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && ze(r, n, a);
            }), Ce(e, "isInSelectingRange", function() {
                var t, r = e.props, n = r.day, a = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, c = r.endDate, l = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(a || o || s) || !l || !i && e.isDisabled()) && (a && c && (re.isBefore(l, c) || $e(l, c)) ? ze(n, l, c) : (o && p && (te.isAfter(l, p) || $e(l, p)) || !(!s || !p || c || !te.isAfter(l, p) && !$e(l, p))) && ze(n, p, l));
            }), Ce(e, "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, n = r.day, a = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Ue(n, o ? s : a);
            }), Ce(e, "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, n = r.day, a = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Ue(n, o || s ? i : a);
            }), Ce(e, "isRangeStart", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && Ue(n, r);
            }), Ce(e, "isRangeEnd", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && Ue(a, r);
            }), Ce(e, "isWeekend", function() {
                var t = b.getDay(e.props.day);
                return 0 === t || 6 === t;
            }), Ce(e, "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === C.getMonth(e.props.day);
            }), Ce(e, "isBeforeMonth", function() {
                return void 0 !== e.props.month && (C.getMonth(e.props.day) + 1) % 12 === e.props.month;
            }), Ce(e, "isCurrentDay", function() {
                return e.isSameDay(Te());
            }), Ce(e, "isSelected", function() {
                var t;
                return e.props.selectsMultiple ? null === (t = e.props.selectedDates) || void 0 === t ? void 0 : t.some(function(t) {
                    return e.isSameDayOrWeek(t);
                }) : e.isSameDayOrWeek(e.props.selected);
            }), Ce(e, "getClassNames", function(t) {
                var r, a = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return n.clsx("react-datepicker__day", a, "react-datepicker__day--" + Le(e.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"), e.getHolidaysClass());
            }), Ce(e, "getAriaLabel", function() {
                var t = e.props, r = t.day, n = t.ariaLabelPrefixWhenEnabled, a = void 0 === n ? "Choose" : n, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : a;
                return "".concat(i, " ").concat(Le(r, "PPPP", e.props.locale));
            }), Ce(e, "getTitle", function() {
                var t = e.props, r = t.day, n = t.holidays, a = void 0 === n ? new Map : n, o = t.excludeDates, s = Le(r, "MM.dd.yyyy"), i = [];
                return a.has(s) && i.push.apply(i, Ne(a.get(s).holidayNames)), e.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return Ue(e.date ? e.date : e, r);
                }).map(function(e) {
                    return e.message;
                })), i.join(", ");
            }), Ce(e, "getTabIndex", function(t, r) {
                var n = t || e.props.selected, a = r || e.props.preSelection;
                return (!e.props.showWeekPicker || !e.props.showWeekNumber && e.isStartOfWeek()) && (e.isKeyboardSelected() || e.isSameDay(n) && Ue(a, n)) ? 0 : -1;
            }), Ce(e, "handleFocusDay", function() {
                var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = !1;
                0 === e.getTabIndex() && !r.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (n = !0), e.props.inline && !e.props.shouldFocusDayInline && (n = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (n = !0), e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() && (n = !1), e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() && (n = !1)), n && (null === (t = e.dayEl.current) || void 0 === t || t.focus({
                    preventScroll: !0
                }));
            }), Ce(e, "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(S.getDate(e.props.day), e.props.day) : S.getDate(e.props.day);
            }), Ce(e, "render", function() {
                return he.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.props.usePointerEvent ? void 0 : e.handleMouseEnter,
                    onPointerEnter: e.props.usePointerEvent ? e.handleMouseEnter : void 0,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    title: e.getTitle(),
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected() || e.isInRange()
                }, e.renderDayContents(), "" !== e.getTitle() && he.default.createElement("span", {
                    className: "overlay"
                }, e.getTitle()));
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]);
    }(he.default.Component), Wt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "weekNumberEl", he.default.createRef()), Ce(e, "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), Ce(e, "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Ce(e, "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Ue(e.props.date, e.props.selected) && Ue(e.props.date, e.props.preSelection);
            }), Ce(e, "getTabIndex", function() {
                return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || Ue(e.props.date, e.props.selected) && Ue(e.props.preSelection, e.props.selected)) ? 0 : -1;
            }), Ce(e, "handleFocusWeekNumber", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && Ue(e.props.date, e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && e.weekNumberEl.current && e.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusWeekNumber();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusWeekNumber(e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, o = e.onClick, s = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!o,
                        "react-datepicker__week-number--selected": !!o && Ue(this.props.date, this.props.selected),
                        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
                    };
                    return he.default.createElement("div", {
                        ref: this.weekNumberEl,
                        className: n.clsx(s),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick,
                        onKeyDown: this.handleOnKeyDown,
                        tabIndex: this.getTabIndex()
                    }, t);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        ariaLabelPrefix: "week "
                    };
                }
            }
        ]);
    }(he.default.Component), Qt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Ce(e, "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Ce(e, "handleWeekClick", function(t, r, n) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, n), e.props.showWeekPicker && e.handleDayClick(t, n), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Ce(e, "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : function(e, t) {
                    var r = t && Je(t) || Ge() && Je(Ge());
                    return M.getISOWeek(e, r ? {
                        locale: r
                    } : null);
                }(t);
            }), Ce(e, "renderDays", function() {
                var t = e.startOfWeek(), r = [], n = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var a = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(e, t, n) : void 0;
                    r.push(he.default.createElement(Wt, {
                        key: "W",
                        weekNumber: n,
                        date: t,
                        onClick: a,
                        selected: e.props.selected,
                        preSelection: e.props.preSelection,
                        ariaLabelPrefix: e.props.ariaLabelPrefix,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var n = c.addDays(t, r);
                    return he.default.createElement(At, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: n.valueOf(),
                        day: n,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(e, n),
                        usePointerEvent: e.props.usePointerEvent,
                        onMouseEnter: e.handleDayMouseEnter.bind(e, n),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        calendarStartDay: e.props.calendarStartDay,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        holidays: e.props.holidays,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        selectsMultiple: e.props.selectsMultiple,
                        selectedDates: e.props.selectedDates,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), Ce(e, "startOfWeek", function() {
                return We(e.props.day, e.props.locale, e.props.calendarStartDay);
            }), Ce(e, "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Ue(e.startOfWeek(), e.props.selected) && Ue(e.startOfWeek(), e.props.preSelection);
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = {
                        "react-datepicker__week": !0,
                        "react-datepicker__week--selected": Ue(this.startOfWeek(), this.props.selected),
                        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
                    };
                    return he.default.createElement("div", {
                        className: n.clsx(e)
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]);
    }(he.default.Component), Kt = "two_columns", qt = "three_columns", Bt = "four_columns", Ht = Ce(Ce(Ce({}, Kt, {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }), qt, {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }), Bt, {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    });
    function jt(e, t) {
        return e ? Bt : t ? Kt : qt;
    }
    var Vt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, a = new Array(r), o = 0; o < r; o++)a[o] = arguments[o];
            return Ce(e = ye(this, t, [].concat(a)), "MONTH_REFS", Ne(Array(12)).map(function() {
                return he.default.createRef();
            })), Ce(e, "QUARTER_REFS", Ne(Array(4)).map(function() {
                return he.default.createRef();
            })), Ce(e, "isDisabled", function(t) {
                return et(t, e.props);
            }), Ce(e, "isExcluded", function(t) {
                return tt(t, e.props);
            }), Ce(e, "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Ce(e, "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Ce(e, "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Ce(e, "isRangeStartMonth", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && je(x.setMonth(n, t), a);
            }), Ce(e, "isRangeStartQuarter", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && Ve(I.setQuarter(n, t), a);
            }), Ce(e, "isRangeEndMonth", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && je(x.setMonth(n, t), o);
            }), Ce(e, "isRangeEndQuarter", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && Ve(I.setQuarter(n, t), o);
            }), Ce(e, "isInSelectingRangeMonth", function(t) {
                var r, n = e.props, a = n.day, o = n.selectsStart, s = n.selectsEnd, i = n.selectsRange, p = n.startDate, c = n.endDate, l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !l) && (o && c ? nt(l, c, t, a) : (s && p || !(!i || !p || c)) && nt(p, l, t, a));
            }), Ce(e, "isSelectingMonthRangeStart", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var n = e.props, a = n.day, o = n.startDate, s = n.selectsStart, i = x.setMonth(a, t), p = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return je(i, s ? p : o);
            }), Ce(e, "isSelectingMonthRangeEnd", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var n = e.props, a = n.day, o = n.endDate, s = n.selectsEnd, i = n.selectsRange, p = x.setMonth(a, t), c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return je(p, s || i ? c : o);
            }), Ce(e, "isInSelectingRangeQuarter", function(t) {
                var r, n = e.props, a = n.day, o = n.selectsStart, s = n.selectsEnd, i = n.selectsRange, p = n.startDate, c = n.endDate, l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !l) && (o && c ? it(l, c, t, a) : (s && p || !(!i || !p || c)) && it(p, l, t, a));
            }), Ce(e, "isWeekInMonth", function(t) {
                var r = e.props.day, n = c.addDays(t, 6);
                return je(t, r) || je(n, r);
            }), Ce(e, "isCurrentMonth", function(e, t) {
                return Y.getYear(e) === Y.getYear(Te()) && t === C.getMonth(Te());
            }), Ce(e, "isCurrentQuarter", function(e, t) {
                return Y.getYear(e) === Y.getYear(Te()) && t === _.getQuarter(Te());
            }), Ce(e, "isSelectedMonth", function(e, t, r) {
                return C.getMonth(r) === t && Y.getYear(e) === Y.getYear(r);
            }), Ce(e, "isSelectedQuarter", function(e, t, r) {
                return _.getQuarter(e) === t && Y.getYear(e) === Y.getYear(r);
            }), Ce(e, "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, n = 0, a = !1, o = We(Qe(e.props.day), e.props.locale, e.props.calendarStartDay), s = e.props.showWeekPicker ? We(e.props.selected, e.props.locale, e.props.calendarStartDay) : e.props.selected, i = e.props.showWeekPicker ? We(e.props.preSelection, e.props.locale, e.props.calendarStartDay) : e.props.preSelection; t.push(he.default.createElement(Qt, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: n,
                    day: o,
                    month: C.getMonth(e.props.day),
                    onDayClick: e.handleDayClick,
                    usePointerEvent: e.props.usePointerEvent,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    holidays: e.props.holidays,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: i,
                    selected: s,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    selectsMultiple: e.props.selectsMultiple,
                    selectedDates: e.props.selectedDates,
                    showWeekNumber: e.props.showWeekNumbers,
                    showWeekPicker: e.props.showWeekPicker,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !a;){
                    n++, o = l.addWeeks(o, 1);
                    var p = r && n >= 6, c = !r && !e.isWeekInMonth(o);
                    if (p || c) {
                        if (!e.props.peekNextMonth) break;
                        a = !0;
                    }
                }
                return t;
            }), Ce(e, "onMonthClick", function(t, r) {
                var n = x.setMonth(e.props.day, r);
                rt(n, e.props) || e.handleDayClick(Qe(n), t);
            }), Ce(e, "onMonthMouseEnter", function(t) {
                var r = x.setMonth(e.props.day, t);
                rt(r, e.props) || e.handleDayMouseEnter(Qe(r));
            }), Ce(e, "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Ce(e, "onMonthKeyDown", function(t, r) {
                var n = e.props, a = n.selected, o = n.preSelection, s = n.disabledKeyboardNavigation, i = n.showTwoColumnMonthYearPicker, p = n.showFourColumnMonthYearPicker, c = n.setPreSelection, l = n.handleOnMonthKeyDown, u = t.key;
                if ("Tab" !== u && t.preventDefault(), !s) {
                    var h = jt(p, i), f = Ht[h].verticalNavigationOffset, m = Ht[h].grid;
                    switch(u){
                        case "Enter":
                            e.onMonthClick(t, r), c(a);
                            break;
                        case "ArrowRight":
                            e.handleMonthNavigation(11 === r ? 0 : r + 1, d.addMonths(o, 1));
                            break;
                        case "ArrowLeft":
                            e.handleMonthNavigation(0 === r ? 11 : r - 1, y.subMonths(o, 1));
                            break;
                        case "ArrowUp":
                            e.handleMonthNavigation(m[0].includes(r) ? r + 12 - f : r - f, y.subMonths(o, f));
                            break;
                        case "ArrowDown":
                            e.handleMonthNavigation(m[m.length - 1].includes(r) ? r - 12 + f : r + f, d.addMonths(o, f));
                    }
                }
                l && l(t);
            }), Ce(e, "onQuarterClick", function(t, r) {
                var n = I.setQuarter(e.props.day, r);
                at(n, e.props) || e.handleDayClick(qe(n), t);
            }), Ce(e, "onQuarterMouseEnter", function(t) {
                var r = I.setQuarter(e.props.day, t);
                at(r, e.props) || e.handleDayMouseEnter(qe(r));
            }), Ce(e, "handleQuarterNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.QUARTER_REFS[t - 1].current && e.QUARTER_REFS[t - 1].current.focus());
            }), Ce(e, "onQuarterKeyDown", function(t, r) {
                var n = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(n){
                    case "Enter":
                        e.onQuarterClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleQuarterNavigation(4 === r ? 1 : r + 1, u.addQuarters(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleQuarterNavigation(1 === r ? 4 : r - 1, g.subQuarters(e.props.preSelection, 1));
                }
            }), Ce(e, "isMonthDisabled", function(t) {
                var r = e.props, n = r.day, a = r.minDate, o = r.maxDate, s = r.excludeDates, i = r.includeDates, p = x.setMonth(n, t);
                return (a || o || s || i) && rt(p, e.props);
            }), Ce(e, "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, p = r.preSelection, c = r.monthClassName, l = c ? c(x.setMonth(a, t)) : void 0;
                return n.clsx("react-datepicker__month-text", "react-datepicker__month-".concat(t), l, {
                    "react-datepicker__month-text--disabled": e.isMonthDisabled(t),
                    "react-datepicker__month-text--selected": e.isSelectedMonth(a, t, i),
                    "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && e.isSelectedMonth(a, t, p),
                    "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(t),
                    "react-datepicker__month-text--in-range": nt(o, s, t, a),
                    "react-datepicker__month-text--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month-text--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(t),
                    "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Ce(e, "getTabIndex", function(t) {
                var r = C.getMonth(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Ce(e, "getQuarterTabIndex", function(t) {
                var r = _.getQuarter(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Ce(e, "getAriaLabel", function(t) {
                var r = e.props, n = r.chooseDayAriaLabelPrefix, a = void 0 === n ? "Choose" : n, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = r.locale, c = x.setMonth(i, t), l = e.isDisabled(c) || e.isExcluded(c) ? s : a;
                return "".concat(l, " ").concat(Le(c, "MMMM yyyy", p));
            }), Ce(e, "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, p = r.minDate, c = r.maxDate, l = r.preSelection, d = r.disabledKeyboardNavigation;
                return n.clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter-text--disabled": (p || c) && at(I.setQuarter(a, t), e.props),
                    "react-datepicker__quarter-text--selected": e.isSelectedQuarter(a, t, i),
                    "react-datepicker__quarter-text--keyboard-selected": !d && e.isSelectedQuarter(a, t, l),
                    "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(t),
                    "react-datepicker__quarter-text--in-range": it(o, s, t, a),
                    "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(t)
                });
            }), Ce(e, "getMonthContent", function(t) {
                var r = e.props, n = r.showFullMonthYearPicker, a = r.renderMonthContent, o = r.locale, s = r.day, i = Ze(t, o), p = Xe(t, o);
                return a ? a(t, i, p, s) : n ? p : i;
            }), Ce(e, "getQuarterContent", function(t) {
                var r = e.props, n = r.renderQuarterContent, a = function(e, t) {
                    return Le(I.setQuarter(Te(), e), "QQQ", t);
                }(t, r.locale);
                return n ? n(t, a) : a;
            }), Ce(e, "renderMonths", function() {
                var t = e.props, r = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, a = t.day, o = t.selected;
                return Ht[jt(n, r)].grid.map(function(t, r) {
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, t.map(function(t, r) {
                        return he.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: r,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                _t(r) && (r.preventDefault(), r.key = "Enter"), e.onMonthKeyDown(r, t);
                            },
                            onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
                                return e.onMonthMouseEnter(t);
                            },
                            onPointerEnter: e.props.usePointerEvent ? function() {
                                return e.onMonthMouseEnter(t);
                            } : void 0,
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            "aria-disabled": e.isMonthDisabled(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(a, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(a, t, o)
                        }, e.getMonthContent(t));
                    }));
                });
            }), Ce(e, "renderQuarters", function() {
                var t = e.props, r = t.day, n = t.selected;
                return he.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, a) {
                    return he.default.createElement("div", {
                        key: a,
                        ref: e.QUARTER_REFS[a],
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        onKeyDown: function(r) {
                            e.onQuarterKeyDown(r, t);
                        },
                        onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
                            return e.onQuarterMouseEnter(t);
                        },
                        onPointerEnter: e.props.usePointerEvent ? function() {
                            return e.onQuarterMouseEnter(t);
                        } : void 0,
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, n),
                        tabIndex: e.getQuarterTabIndex(t),
                        "aria-current": e.isCurrentQuarter(r, t) ? "date" : void 0
                    }, e.getQuarterContent(t));
                }));
            }), Ce(e, "getClassNames", function() {
                var t = e.props, r = t.selectingDate, a = t.selectsStart, o = t.selectsEnd, s = t.showMonthYearPicker, i = t.showQuarterYearPicker, p = t.showWeekPicker;
                return n.clsx("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": i
                }, {
                    "react-datepicker__weekPicker": p
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, n = e.day, a = e.ariaLabelPrefix, o = void 0 === a ? "Month " : a, s = o ? o.trim() + " " : "";
                    return he.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
                        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
                        "aria-label": "".concat(s).concat(Le(n, "MMMM, yyyy", this.props.locale)),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]);
    }(he.default.Component), Ut = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                height: null
            }), Ce(e, "scrollToTheSelectedTime", function() {
                requestAnimationFrame(function() {
                    e.list && (e.list.scrollTop = e.centerLi && t.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - e.header.clientHeight : e.list.clientHeight, e.centerLi));
                });
            }), Ce(e, "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && dt(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && lt(t, e.props) || e.props.onChange(t);
            }), Ce(e, "isSelectedTime", function(t) {
                var r, n;
                return e.props.selected && (r = e.props.selected, n = t, St(r).getTime() === St(n).getTime());
            }), Ce(e, "isDisabledTime", function(t) {
                return (e.props.minTime || e.props.maxTime) && dt(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && lt(t, e.props);
            }), Ce(e, "liClasses", function(t) {
                var r = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t) : void 0
                ];
                return e.isSelectedTime(t) && r.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(t) && r.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (3600 * w.getHours(t) + 60 * k.getMinutes(t) + ie.getSeconds(t)) % (60 * e.props.intervals) != 0 && r.push("react-datepicker__time-list-item--injected"), r.join(" ");
            }), Ce(e, "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "ArrowUp" !== t.key && "ArrowLeft" !== t.key || !t.target.previousSibling || (t.preventDefault(), t.target.previousSibling.focus()), "ArrowDown" !== t.key && "ArrowRight" !== t.key || !t.target.nextSibling || (t.preventDefault(), t.target.nextSibling.focus()), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Ce(e, "renderTimes", function() {
                for(var t, r = [], n = e.props.format ? e.props.format : "p", a = e.props.intervals, o = e.props.selected || e.props.openToDate || Te(), s = (t = o, K.startOfDay(t)), p = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), c = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(o), l = c / a, d = 0; d < l; d++){
                    var u = i.addMinutes(s, d * a);
                    if (r.push(u), p) {
                        var h = kt(s, u, d, a, p);
                        r = r.concat(h);
                    }
                }
                var f = r.reduce(function(e, t) {
                    return t.getTime() <= o.getTime() ? t : e;
                }, r[0]);
                return r.map(function(t, r) {
                    return he.default.createElement("li", {
                        key: r,
                        onClick: e.handleClick.bind(e, t),
                        className: e.liClasses(t),
                        ref: function(r) {
                            t === f && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: t === f ? 0 : -1,
                        role: "option",
                        "aria-selected": e.isSelectedTime(t) ? "true" : void 0,
                        "aria-disabled": e.isDisabledTime(t) ? "true" : void 0
                    }, Le(t, n, e.props.locale));
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return he.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, he.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), he.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, he.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, he.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        role: "listbox",
                        "aria-label": this.props.timeCaption
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]);
    }(he.default.Component);
    Ce(Ut, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var $t = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "YEAR_REFS", Ne(Array(r.props.yearItemNumber)).map(function() {
                return he.default.createRef();
            })), Ce(r, "isDisabled", function(e) {
                return et(e, r.props);
            }), Ce(r, "isExcluded", function(e) {
                return tt(e, r.props);
            }), Ce(r, "selectingDate", function() {
                var e;
                return null !== (e = r.props.selectingDate) && void 0 !== e ? e : r.props.preSelection;
            }), Ce(r, "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(r);
                window.requestAnimationFrame(t);
            }), Ce(r, "handleYearClick", function(e, t) {
                r.props.onDayClick && r.props.onDayClick(e, t);
            }), Ce(r, "handleYearNavigation", function(e, t) {
                var n = r.props, a = n.date, o = n.yearItemNumber, s = bt(a, o).startPeriod;
                r.isDisabled(t) || r.isExcluded(t) || (r.props.setPreSelection(t), e - s < 0 ? r.updateFocusOnPaginate(o - (s - e)) : e - s >= o ? r.updateFocusOnPaginate(Math.abs(o - (e - s))) : r.YEAR_REFS[e - s].current.focus());
            }), Ce(r, "isSameDay", function(e, t) {
                return Ue(e, t);
            }), Ce(r, "isCurrentYear", function(e) {
                return e === Y.getYear(Te());
            }), Ce(r, "isRangeStart", function(e) {
                return r.props.startDate && r.props.endDate && He(T.setYear(Te(), e), r.props.startDate);
            }), Ce(r, "isRangeEnd", function(e) {
                return r.props.startDate && r.props.endDate && He(T.setYear(Te(), e), r.props.endDate);
            }), Ce(r, "isInRange", function(e) {
                return ot(e, r.props.startDate, r.props.endDate);
            }), Ce(r, "isInSelectingRange", function(e) {
                var t = r.props, n = t.selectsStart, a = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(n || a || o) || !r.selectingDate()) && (n && i ? ot(e, r.selectingDate(), i) : (a && s || !(!o || !s || i)) && ot(e, s, r.selectingDate()));
            }), Ce(r, "isSelectingRangeStart", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, n = t.startDate, a = t.selectsStart, o = T.setYear(Te(), e);
                return He(o, a ? r.selectingDate() : n);
            }), Ce(r, "isSelectingRangeEnd", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, n = t.endDate, a = t.selectsEnd, o = t.selectsRange, s = T.setYear(Te(), e);
                return He(s, a || o ? r.selectingDate() : n);
            }), Ce(r, "isKeyboardSelected", function(e) {
                var t = Ke(T.setYear(r.props.date, e));
                return !r.props.disabledKeyboardNavigation && !r.props.inline && !Ue(t, Ke(r.props.selected)) && Ue(t, Ke(r.props.preSelection));
            }), Ce(r, "onYearClick", function(e, t) {
                var n = r.props.date;
                r.handleYearClick(Ke(T.setYear(n, t)), e);
            }), Ce(r, "onYearKeyDown", function(e, t) {
                var n = e.key, a = r.props, o = a.date, s = a.yearItemNumber, i = a.handleOnKeyDown;
                if ("Tab" !== n && e.preventDefault(), !r.props.disabledKeyboardNavigation) switch(n){
                    case "Enter":
                        r.onYearClick(e, t), r.props.setPreSelection(r.props.selected);
                        break;
                    case "ArrowRight":
                        r.handleYearNavigation(t + 1, h.addYears(r.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        r.handleYearNavigation(t - 1, v.subYears(r.props.preSelection, 1));
                        break;
                    case "ArrowUp":
                        var p = bt(o, s).startPeriod, c = 3, l = t - c;
                        if (l < p) {
                            var d = s % c;
                            t >= p && t < p + d ? c = d : c += d, l = t - c;
                        }
                        r.handleYearNavigation(l, v.subYears(r.props.preSelection, c));
                        break;
                    case "ArrowDown":
                        var u = bt(o, s).endPeriod, f = 3, m = t + f;
                        if (m > u) {
                            var y = s % f;
                            t <= u && t > u - y ? f = y : f += y, m = t + f;
                        }
                        r.handleYearNavigation(m, h.addYears(r.props.preSelection, f));
                }
                i && i(e);
            }), Ce(r, "getYearClassNames", function(e) {
                var t = r.props, a = t.date, o = t.minDate, s = t.maxDate, i = t.selected, p = t.excludeDates, c = t.includeDates, l = t.filterDate, d = t.yearClassName;
                return n.clsx("react-datepicker__year-text", "react-datepicker__year-".concat(e), d ? d(T.setYear(a, e)) : void 0, {
                    "react-datepicker__year-text--selected": e === Y.getYear(i),
                    "react-datepicker__year-text--disabled": (o || s || p || c || l) && st(e, r.props),
                    "react-datepicker__year-text--keyboard-selected": r.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": r.isRangeStart(e),
                    "react-datepicker__year-text--range-end": r.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": r.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": r.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": r.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": r.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": r.isCurrentYear(e)
                });
            }), Ce(r, "getYearTabIndex", function(e) {
                return r.props.disabledKeyboardNavigation ? "-1" : e === Y.getYear(r.props.preSelection) ? "0" : "-1";
            }), Ce(r, "getYearContainerClassNames", function() {
                var e = r.props, t = e.selectingDate, a = e.selectsStart, o = e.selectsEnd, s = e.selectsRange;
                return n.clsx("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": t && (a || o || s)
                });
            }), Ce(r, "getYearContent", function(e) {
                return r.props.renderYearContent ? r.props.renderYearContent(e) : e;
            }), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, n = r.date, a = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave, i = bt(n, a), p = i.startPeriod, c = i.endPeriod, l = function(r) {
                        t.push(he.default.createElement("div", {
                            ref: e.YEAR_REFS[r - p],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                _t(t) && (t.preventDefault(), t.key = "Enter"), e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            onMouseEnter: e.props.usePointerEvent ? void 0 : function(e) {
                                return o(e, r);
                            },
                            onPointerEnter: e.props.usePointerEvent ? function(e) {
                                return o(e, r);
                            } : void 0,
                            onMouseLeave: e.props.usePointerEvent ? void 0 : function(e) {
                                return s(e, r);
                            },
                            onPointerLeave: e.props.usePointerEvent ? function(e) {
                                return s(e, r);
                            } : void 0,
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, e.getYearContent(r)));
                    }, d = p; d <= c; d++)l(d);
                    return he.default.createElement("div", {
                        className: this.getYearContainerClassNames()
                    }, he.default.createElement("div", {
                        className: "react-datepicker__year-wrapper",
                        onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
                        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
                    }, t));
                }
            }
        ]);
    }(he.default.Component), zt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "onTimeChange", function(e) {
                r.setState({
                    time: e
                });
                var t = r.props.date, n = t instanceof Date && !isNaN(t) ? t : new Date;
                n.setHours(e.split(":")[0]), n.setMinutes(e.split(":")[1]), r.props.onChange(n);
            }), Ce(r, "renderTimeInput", function() {
                var e = r.state.time, t = r.props, n = t.date, a = t.timeString, o = t.customTimeInput;
                return o ? he.default.cloneElement(o, {
                    date: n,
                    value: e,
                    onChange: r.onTimeChange
                }) : he.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        r.onTimeChange(e.target.value || a);
                    }
                });
            }), r.state = {
                time: r.props.timeString
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return he.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), he.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]);
    }(he.default.Component);
    function Gt(e) {
        var t = e.showTimeSelectOnly, r = void 0 !== t && t, n = e.showTime, a = void 0 !== n && n, o = e.className, s = e.children, i = r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
        return he.default.createElement("div", {
            className: o,
            role: "dialog",
            "aria-label": i,
            "aria-modal": "true"
        }, s);
    }
    var Jt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Xt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "handleClickOutside", function(e) {
                r.props.onClickOutside(e);
            }), Ce(r, "setClickOutsideRef", function() {
                return r.containerRef.current;
            }), Ce(r, "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Jt.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && r.props.onDropdownFocus();
            }), Ce(r, "getDateInView", function() {
                var e = r.props, t = e.preSelection, n = e.selected, a = e.openToDate, o = yt(r.props), s = gt(r.props), i = Te(), p = a || n || t;
                return p || (o && re.isBefore(i, o) ? o : s && te.isAfter(i, s) ? s : i);
            }), Ce(r, "increaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: d.addMonths(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "decreaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: y.subMonths(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "handleDayClick", function(e, t, n) {
                r.props.onSelect(e, t, n), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleDayMouseEnter", function(e) {
                r.setState({
                    selectingDate: e
                }), r.props.onDayMouseEnter && r.props.onDayMouseEnter(e);
            }), Ce(r, "handleMonthMouseLeave", function() {
                r.setState({
                    selectingDate: null
                }), r.props.onMonthMouseLeave && r.props.onMonthMouseLeave();
            }), Ce(r, "handleYearMouseEnter", function(e, t) {
                r.setState({
                    selectingDate: T.setYear(Te(), t)
                }), r.props.onYearMouseEnter && r.props.onYearMouseEnter(e, t);
            }), Ce(r, "handleYearMouseLeave", function(e, t) {
                r.props.onYearMouseLeave && r.props.onYearMouseLeave(e, t);
            }), Ce(r, "handleYearChange", function(e) {
                r.props.onYearChange && (r.props.onYearChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleMonthChange", function(e) {
                r.handleCustomMonthChange(e), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleCustomMonthChange", function(e) {
                r.props.onMonthChange && (r.props.onMonthChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }), Ce(r, "handleMonthYearChange", function(e) {
                r.handleYearChange(e), r.handleMonthChange(e);
            }), Ce(r, "changeYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: T.setYear(r, e)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "changeMonth", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: x.setMonth(r, e)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "changeMonthYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: T.setYear(x.setMonth(r, C.getMonth(e)), Y.getYear(e))
                    };
                }, function() {
                    return r.handleMonthYearChange(r.state.date);
                });
            }), Ce(r, "header", function() {
                var e = We(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, r.props.locale, r.props.calendarStartDay), t = [];
                return r.props.showWeekNumbers && t.push(he.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, r.props.weekLabel || "#")), t.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(t) {
                    var a = c.addDays(e, t), o = r.formatWeekday(a, r.props.locale), s = r.props.weekDayClassName ? r.props.weekDayClassName(a) : void 0;
                    return he.default.createElement("div", {
                        key: t,
                        "aria-label": Le(a, "EEEE", r.props.locale),
                        className: n.clsx("react-datepicker__day-name", s)
                    }, o);
                }));
            }), Ce(r, "formatWeekday", function(e, t) {
                return r.props.formatWeekDay ? function(e, t, r) {
                    return t(Le(e, "EEEE", r));
                }(e, r.props.formatWeekDay, t) : r.props.useWeekdaysShort ? function(e, t) {
                    return Le(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Le(e, "EEEEEE", t);
                }(e, t);
            }), Ce(r, "decreaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: v.subYears(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "clearSelectingDate", function() {
                r.setState({
                    selectingDate: null
                });
            }), Ce(r, "renderPreviousButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = ft(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.yearItemNumber, a = void 0 === n ? xe : n, o = bt(Ke(v.subYears(e, a)), a).endPeriod, s = r && Y.getYear(r);
                                return s && s > o || !1;
                            }(r.state.date, r.props);
                            break;
                        case r.props.showQuarterYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = j.startOfYear(e), o = g.subQuarters(a, 1);
                                return r && Q.differenceInCalendarQuarters(r, o) > 0 || n && n.every(function(e) {
                                    return Q.differenceInCalendarQuarters(e, o) > 0;
                                }) || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = ut(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], n = r.decreaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (n = r.decreaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), n = null);
                        var a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = r.props, c = p.previousMonthAriaLabel, l = void 0 === c ? "string" == typeof s ? s : "Previous Month" : c, d = p.previousYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Previous Year" : d;
                        return he.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: n,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": a ? u : l
                        }, he.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, a ? r.props.previousYearButtonLabel : r.props.previousMonthButtonLabel));
                    }
                }
            }), Ce(r, "increaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: h.addYears(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "renderNextButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = mt(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.yearItemNumber, a = void 0 === n ? xe : n, o = bt(h.addYears(e, a), a).startPeriod, s = r && Y.getYear(r);
                                return s && s < o || !1;
                            }(r.state.date, r.props);
                            break;
                        case r.props.showQuarterYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = z.endOfYear(e), o = u.addQuarters(a, 1);
                                return r && Q.differenceInCalendarQuarters(o, r) > 0 || n && n.every(function(e) {
                                    return Q.differenceInCalendarQuarters(o, e) > 0;
                                }) || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = ht(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        r.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), r.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var n = r.increaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (n = r.increaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), n = null);
                        var a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = r.props, c = p.nextMonthAriaLabel, l = void 0 === c ? "string" == typeof s ? s : "Next Month" : c, d = p.nextYearAriaLabel, f = void 0 === d ? "string" == typeof i ? i : "Next Year" : d;
                        return he.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: n,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": a ? f : l
                        }, he.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, a ? r.props.nextYearButtonLabel : r.props.nextMonthButtonLabel));
                    }
                }
            }), Ce(r, "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return r.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), r.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), r.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), he.default.createElement("div", {
                    className: t.join(" ")
                }, Le(e, r.props.dateFormat, r.props.locale));
            }), Ce(r, "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showYearDropdown && !e) return he.default.createElement(Nt, {
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    date: r.state.date,
                    onSelect: r.props.onSelect,
                    setOpen: r.props.setOpen,
                    dropdownMode: r.props.dropdownMode,
                    onChange: r.changeYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    year: Y.getYear(r.state.date),
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber
                });
            }), Ce(r, "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthDropdown && !e) return he.default.createElement(It, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    onChange: r.changeMonth,
                    month: C.getMonth(r.state.date),
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown
                });
            }), Ce(r, "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthYearDropdown && !e) return he.default.createElement(Ft, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    dateFormat: r.props.dateFormat,
                    onChange: r.changeMonthYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    date: r.state.date,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown
                });
            }), Ce(r, "handleTodayButtonClick", function(e) {
                r.props.onSelect(Be(), e), r.props.setPreSelection && r.props.setPreSelection(Be());
            }), Ce(r, "renderTodayButton", function() {
                if (r.props.todayButton && !r.props.showTimeSelectOnly) return he.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return r.handleTodayButtonClick(e);
                    }
                }, r.props.todayButton);
            }), Ce(r, "renderDefaultHeader", function(e) {
                var t = e.monthDate, n = e.i;
                return he.default.createElement("div", {
                    className: "react-datepicker__header ".concat(r.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, r.renderCurrentMonth(t), he.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),
                    onFocus: r.handleDropdownFocus
                }, r.renderMonthDropdown(0 !== n), r.renderMonthYearDropdown(0 !== n), r.renderYearDropdown(0 !== n)), he.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Ce(r, "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, n = e.i;
                if (r.props.showTimeSelect && !r.state.monthContainer || r.props.showTimeSelectOnly) return null;
                var a = ut(r.state.date, r.props), o = ht(r.state.date, r.props), s = ft(r.state.date, r.props), i = mt(r.state.date, r.props), p = !r.props.showMonthYearPicker && !r.props.showQuarterYearPicker && !r.props.showYearPicker;
                return he.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: r.props.onDropdownFocus
                }, r.props.renderCustomHeader(De(De({}, r.state), {}, {
                    customHeaderCount: n,
                    monthDate: t,
                    changeMonth: r.changeMonth,
                    changeYear: r.changeYear,
                    decreaseMonth: r.decreaseMonth,
                    increaseMonth: r.increaseMonth,
                    decreaseYear: r.decreaseYear,
                    increaseYear: r.increaseYear,
                    prevMonthButtonDisabled: a,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && he.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Ce(r, "renderYearHeader", function(e) {
                var t = e.monthDate, n = r.props, a = n.showYearPicker, o = bt(t, n.yearItemNumber), s = o.startPeriod, i = o.endPeriod;
                return he.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, a ? "".concat(s, " - ").concat(i) : Y.getYear(t));
            }), Ce(r, "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== r.props.renderCustomHeader:
                        return r.renderCustomHeader(e);
                    case r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker:
                        return r.renderYearHeader(e);
                    default:
                        return r.renderDefaultHeader(e);
                }
            }), Ce(r, "renderMonths", function() {
                var e;
                if (!r.props.showTimeSelectOnly && !r.props.showYearPicker) {
                    for(var t = [], n = r.props.showPreviousMonths ? r.props.monthsShown - 1 : 0, a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? h.addYears(r.state.date, n) : y.subMonths(r.state.date, n), o = null !== (e = r.props.monthSelectedIn) && void 0 !== e ? e : n, s = 0; s < r.props.monthsShown; ++s){
                        var i = s - o + n, p = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? h.addYears(a, i) : d.addMonths(a, i), c = "month-".concat(s), l = s < r.props.monthsShown - 1, u = s > 0;
                        t.push(he.default.createElement("div", {
                            key: c,
                            ref: function(e) {
                                r.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, r.renderHeader({
                            monthDate: p,
                            i: s
                        }), he.default.createElement(Vt, {
                            chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: r.props.monthAriaLabelPrefix,
                            onChange: r.changeMonthYear,
                            day: p,
                            dayClassName: r.props.dayClassName,
                            calendarStartDay: r.props.calendarStartDay,
                            monthClassName: r.props.monthClassName,
                            onDayClick: r.handleDayClick,
                            handleOnKeyDown: r.props.handleOnDayKeyDown,
                            handleOnMonthKeyDown: r.props.handleOnKeyDown,
                            usePointerEvent: r.props.usePointerEvent,
                            onDayMouseEnter: r.handleDayMouseEnter,
                            onMouseLeave: r.handleMonthMouseLeave,
                            onWeekSelect: r.props.onWeekSelect,
                            orderInDisplay: s,
                            formatWeekNumber: r.props.formatWeekNumber,
                            locale: r.props.locale,
                            minDate: r.props.minDate,
                            maxDate: r.props.maxDate,
                            excludeDates: r.props.excludeDates,
                            excludeDateIntervals: r.props.excludeDateIntervals,
                            highlightDates: r.props.highlightDates,
                            holidays: r.props.holidays,
                            selectingDate: r.state.selectingDate,
                            includeDates: r.props.includeDates,
                            includeDateIntervals: r.props.includeDateIntervals,
                            inline: r.props.inline,
                            shouldFocusDayInline: r.props.shouldFocusDayInline,
                            fixedHeight: r.props.fixedHeight,
                            filterDate: r.props.filterDate,
                            preSelection: r.props.preSelection,
                            setPreSelection: r.props.setPreSelection,
                            selected: r.props.selected,
                            selectsStart: r.props.selectsStart,
                            selectsEnd: r.props.selectsEnd,
                            selectsRange: r.props.selectsRange,
                            selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                            selectsMultiple: r.props.selectsMultiple,
                            selectedDates: r.props.selectedDates,
                            showWeekNumbers: r.props.showWeekNumbers,
                            startDate: r.props.startDate,
                            endDate: r.props.endDate,
                            peekNextMonth: r.props.peekNextMonth,
                            setOpen: r.props.setOpen,
                            shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                            renderDayContents: r.props.renderDayContents,
                            renderMonthContent: r.props.renderMonthContent,
                            renderQuarterContent: r.props.renderQuarterContent,
                            renderYearContent: r.props.renderYearContent,
                            disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                            showMonthYearPicker: r.props.showMonthYearPicker,
                            showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                            showYearPicker: r.props.showYearPicker,
                            showQuarterYearPicker: r.props.showQuarterYearPicker,
                            showWeekPicker: r.props.showWeekPicker,
                            isInputFocused: r.props.isInputFocused,
                            containerRef: r.containerRef,
                            monthShowsDuplicateDaysEnd: l,
                            monthShowsDuplicateDaysStart: u
                        })));
                    }
                    return t;
                }
            }), Ce(r, "renderYears", function() {
                if (!r.props.showTimeSelectOnly) return r.props.showYearPicker ? he.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, r.renderHeader({
                    monthDate: r.state.date
                }), he.default.createElement($t, _e({
                    onDayClick: r.handleDayClick,
                    selectingDate: r.state.selectingDate,
                    clearSelectingDate: r.clearSelectingDate,
                    date: r.state.date
                }, r.props, {
                    onYearMouseEnter: r.handleYearMouseEnter,
                    onYearMouseLeave: r.handleYearMouseLeave
                }))) : void 0;
            }), Ce(r, "renderTimeSection", function() {
                if (r.props.showTimeSelect && (r.state.monthContainer || r.props.showTimeSelectOnly)) return he.default.createElement(Ut, {
                    selected: r.props.selected,
                    openToDate: r.props.openToDate,
                    onChange: r.props.onTimeChange,
                    timeClassName: r.props.timeClassName,
                    format: r.props.timeFormat,
                    includeTimes: r.props.includeTimes,
                    intervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    todayButton: r.props.todayButton,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    monthRef: r.state.monthContainer,
                    injectTimes: r.props.injectTimes,
                    locale: r.props.locale,
                    handleOnKeyDown: r.props.handleOnKeyDown,
                    showTimeSelectOnly: r.props.showTimeSelectOnly
                });
            }), Ce(r, "renderInputTimeSection", function() {
                var e = new Date(r.props.selected), t = Re(e) && Boolean(r.props.selected) ? "".concat(wt(e.getHours()), ":").concat(wt(e.getMinutes())) : "";
                if (r.props.showTimeInput) return he.default.createElement(zt, {
                    date: e,
                    timeString: t,
                    timeInputLabel: r.props.timeInputLabel,
                    onChange: r.props.onTimeChange,
                    customTimeInput: r.props.customTimeInput
                });
            }), Ce(r, "renderAriaLiveRegion", function() {
                var e, t = bt(r.state.date, r.props.yearItemNumber), n = t.startPeriod, a = t.endPeriod;
                return e = r.props.showYearPicker ? "".concat(n, " - ").concat(a) : r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? Y.getYear(r.state.date) : "".concat(Xe(C.getMonth(r.state.date), r.props.locale), " ").concat(Y.getYear(r.state.date)), he.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, r.state.isRenderAriaLiveMessage && e);
            }), Ce(r, "renderChildren", function() {
                if (r.props.children) return he.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, r.props.children);
            }), r.containerRef = he.default.createRef(), r.state = {
                date: r.getDateInView(),
                selectingDate: null,
                monthContainer: null,
                isRenderAriaLiveMessage: !1
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    var t = this;
                    if (!this.props.preSelection || Ue(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Ue(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                    else {
                        var r = !je(this.state.date, this.props.preSelection);
                        this.setState({
                            date: this.props.preSelection
                        }, function() {
                            return r && t.handleCustomMonthChange(t.state.date);
                        });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Gt;
                    return he.default.createElement("div", {
                        style: {
                            display: "contents"
                        },
                        ref: this.containerRef
                    }, he.default.createElement(e, {
                        className: n.clsx("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showTime: this.props.showTimeSelect || this.props.showTimeInput,
                        showTimeSelectOnly: this.props.showTimeSelectOnly
                    }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: xe
                    };
                }
            }
        ]);
    }(he.default.Component), Zt = function(e) {
        var t = e.icon, r = e.className, n = void 0 === r ? "" : r, a = e.onClick, o = "react-datepicker__calendar-icon";
        return he.default.isValidElement(t) ? he.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(n),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof a && a(e);
            }
        }) : "string" == typeof t ? he.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(n),
            "aria-hidden": "true",
            onClick: a
        }) : he.default.createElement("svg", {
            className: "".concat(o, " ").concat(n),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: a
        }, he.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, er = function(e) {
        function t(e) {
            var r;
            return be(this, t), (r = ye(this, t, [
                e
            ])).el = document.createElement("div"), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return me.default.createPortal(this.props.children, this.el);
                }
            }
        ]);
    }(he.default.Component), tr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, rr = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "getTabChildren", function() {
                return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(tr);
            }), Ce(r, "handleFocusStart", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }), Ce(r, "handleFocusEnd", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }), r.tabLoopRef = he.default.createRef(), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? he.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, he.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, he.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]);
    }(he.default.Component);
    var nr, ar = function(e) {
        function t() {
            return be(this, t), ye(this, t, arguments);
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, o = t.hidePopper, s = t.popperComponent, i = t.targetComponent, p = t.enableTabLoop, c = t.popperOnKeyDown, l = t.portalId, d = t.portalHost, u = t.popperProps, h = t.showArrow;
                    if (!o) {
                        var f = n.clsx("react-datepicker-popper", r);
                        e = he.default.createElement(rr, {
                            enableTabLoop: p
                        }, he.default.createElement("div", {
                            ref: u.refs.setFloating,
                            style: u.floatingStyles,
                            className: f,
                            "data-placement": u.placement,
                            onKeyDown: c
                        }, s, h && he.default.createElement(le.FloatingArrow, {
                            ref: u.arrowRef,
                            context: u.context,
                            fill: "currentColor",
                            strokeWidth: 1,
                            height: 8,
                            width: 16,
                            style: {
                                transform: "translateY(-1px)"
                            },
                            className: "react-datepicker__triangle"
                        })));
                    }
                    this.props.popperContainer && (e = he.default.createElement(this.props.popperContainer, {}, e)), l && !o && (e = he.default.createElement(er, {
                        portalId: l,
                        portalHost: d
                    }, e));
                    var m = n.clsx("react-datepicker-wrapper", a);
                    return he.default.createElement(he.default.Fragment, null, he.default.createElement("div", {
                        ref: u.refs.setReference,
                        className: m
                    }, i), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0
                    };
                }
            }
        ]);
    }(he.default.Component), or = (nr = ar, function(e) {
        var t = De(De({}, e), {}, {
            popperModifiers: e.popperModifiers || [],
            popperProps: e.popperProps || {},
            hidePopper: "boolean" != typeof e.hidePopper || e.hidePopper
        }), r = he.default.useRef(), n = le.useFloating(De({
            open: !t.hidePopper,
            whileElementsMounted: le.autoUpdate,
            placement: t.popperPlacement,
            middleware: [
                le.flip({
                    padding: 15
                }),
                le.offset(10),
                le.arrow({
                    element: r
                })
            ].concat(Ne(t.popperModifiers))
        }, t.popperProps));
        return he.default.createElement(nr, _e({}, t, {
            popperProps: De(De({}, n), {}, {
                arrowRef: r
            })
        }));
    }), sr = "react-datepicker-ignore-onclickoutside", ir = fe.default(Xt);
    var pr = "Date input not valid.", cr = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "getPreSelection", function() {
                return r.props.openToDate ? r.props.openToDate : r.props.selectsEnd && r.props.startDate ? r.props.startDate : r.props.selectsStart && r.props.endDate ? r.props.endDate : Te();
            }), Ce(r, "modifyHolidays", function() {
                var e;
                return null === (e = r.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return o.isValid(r) ? [].concat(Ne(e), [
                        De(De({}, t), {}, {
                            date: r
                        })
                    ]) : e;
                }, []);
            }), Ce(r, "calcInitialState", function() {
                var e, t = r.getPreSelection(), n = yt(r.props), a = gt(r.props), o = n && re.isBefore(t, K.startOfDay(n)) ? n : a && te.isAfter(t, V.endOfDay(a)) ? a : t;
                return {
                    open: r.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = r.props.selectsRange ? r.props.startDate : r.props.selected) && void 0 !== e ? e : o,
                    highlightDates: vt(r.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1
                };
            }), Ce(r, "clearPreventFocusTimeout", function() {
                r.preventFocusTimeout && clearTimeout(r.preventFocusTimeout);
            }), Ce(r, "setFocus", function() {
                r.input && r.input.focus && r.input.focus({
                    preventScroll: !0
                });
            }), Ce(r, "setBlur", function() {
                r.input && r.input.blur && r.input.blur(), r.cancelFocusInput();
            }), Ce(r, "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                r.setState({
                    open: e,
                    preSelection: e && r.state.open ? r.state.preSelection : r.calcInitialState().preSelection,
                    lastPreSelectChange: dr
                }, function() {
                    e || r.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && r.setBlur(), r.setState({
                            inputValue: null
                        });
                    });
                });
            }), Ce(r, "inputOk", function() {
                return a.isDate(r.state.preSelection);
            }), Ce(r, "isCalendarOpen", function() {
                return void 0 === r.props.open ? r.state.open && !r.props.disabled && !r.props.readOnly : r.props.open;
            }), Ce(r, "handleFocus", function(e) {
                r.state.preventFocus || (r.props.onFocus(e), r.props.preventOpenOnFocus || r.props.readOnly || r.setOpen(!0)), r.setState({
                    focused: !0
                });
            }), Ce(r, "sendFocusBackToInput", function() {
                r.preventFocusTimeout && r.clearPreventFocusTimeout(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.preventFocusTimeout = setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                });
            }), Ce(r, "cancelFocusInput", function() {
                clearTimeout(r.inputFocusTimeout), r.inputFocusTimeout = null;
            }), Ce(r, "deferFocusInput", function() {
                r.cancelFocusInput(), r.inputFocusTimeout = setTimeout(function() {
                    return r.setFocus();
                }, 1);
            }), Ce(r, "handleDropdownFocus", function() {
                r.cancelFocusInput();
            }), Ce(r, "handleBlur", function(e) {
                (!r.state.open || r.props.withPortal || r.props.showTimeInput) && r.props.onBlur(e), r.setState({
                    focused: !1
                });
            }), Ce(r, "handleCalendarClickOutside", function(e) {
                r.props.inline || r.setOpen(!1), r.props.onClickOutside(e), r.props.withPortal && e.preventDefault();
            }), Ce(r, "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                var a = t[0];
                if (!r.props.onChangeRaw || (r.props.onChangeRaw.apply(r, t), "function" == typeof a.isDefaultPrevented && !a.isDefaultPrevented())) {
                    r.setState({
                        inputValue: a.target.value,
                        lastPreSelectChange: lr
                    });
                    var o, i, p, c, l, d, u, h, f = (o = a.target.value, i = r.props.dateFormat, p = r.props.locale, c = r.props.strictParsing, l = r.props.minDate, d = null, u = Je(p) || Je(Ge()), h = !0, Array.isArray(i) ? (i.forEach(function(e) {
                        var t = oe.parse(o, e, new Date, {
                            locale: u,
                            useAdditionalWeekYearTokens: !0,
                            useAdditionalDayOfYearTokens: !0
                        });
                        c && (h = Re(t, l) && o === Le(t, e, p)), Re(t, l) && h && (d = t);
                    }), d) : (d = oe.parse(o, i, new Date, {
                        locale: u,
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    }), c ? h = Re(d) && o === Le(d, i, p) : Re(d) || (i = i.match(Ie).map(function(e) {
                        var t = e[0];
                        if ("p" === t || "P" === t) {
                            var r = s.longFormatters[t];
                            return u ? r(e, u.formatLong) : t;
                        }
                        return e;
                    }).join(""), o.length > 0 && (d = oe.parse(o, i.slice(0, o.length), new Date, {
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    })), Re(d) || (d = new Date(o))), Re(d) && h ? d : null));
                    r.props.showTimeSelectOnly && r.props.selected && f && !Ue(f, r.props.selected) && (f = de.set(r.props.selected, {
                        hours: w.getHours(f),
                        minutes: k.getMinutes(f),
                        seconds: D.getSeconds(f)
                    })), !f && a.target.value || r.setSelected(f, a, !0);
                }
            }), Ce(r, "handleSelect", function(e, t, n) {
                if (r.props.shouldCloseOnSelect && !r.props.showTimeSelect && r.sendFocusBackToInput(), r.props.onChangeRaw && r.props.onChangeRaw(t), r.setSelected(e, t, !1, n), r.props.showDateSelect && r.setState({
                    isRenderAriaLiveMessage: !0
                }), !r.props.shouldCloseOnSelect || r.props.showTimeSelect) r.setPreSelection(e);
                else if (!r.props.inline) {
                    r.props.selectsRange || r.setOpen(!1);
                    var a = r.props, o = a.startDate, s = a.endDate;
                    !o || s || !r.props.swapRange && Ct(e, o) || r.setOpen(!1);
                }
            }), Ce(r, "setSelected", function(e, t, n, a) {
                var o = e;
                if (r.props.showYearPicker) {
                    if (null !== o && st(Y.getYear(o), r.props)) return;
                } else if (r.props.showMonthYearPicker) {
                    if (null !== o && rt(o, r.props)) return;
                } else if (null !== o && et(o, r.props)) return;
                var s = r.props, i = s.onChange, p = s.selectsRange, c = s.startDate, l = s.endDate, d = s.selectsMultiple, u = s.selectedDates, h = s.minTime, f = s.swapRange;
                if (!$e(r.props.selected, o) || r.props.allowSameDay || p || d) {
                    if (null !== o && (!r.props.selected || n && (r.props.showTimeSelect || r.props.showTimeSelectOnly || r.props.showTimeInput) || (o = Ae(o, {
                        hour: w.getHours(r.props.selected),
                        minute: k.getMinutes(r.props.selected),
                        second: D.getSeconds(r.props.selected)
                    })), n || !r.props.showTimeSelect && !r.props.showTimeSelectOnly || h && (o = Ae(o, {
                        hour: h.getHours(),
                        minute: h.getMinutes(),
                        second: h.getSeconds()
                    })), r.props.inline || r.setState({
                        preSelection: o
                    }), r.props.focusSelectedMonth || r.setState({
                        monthSelectedIn: a
                    })), p) {
                        var m = c && !l, y = c && l;
                        !c && !l ? i([
                            o,
                            null
                        ], t) : m && (null === o ? i([
                            null,
                            null
                        ], t) : Ct(o, c) ? i(f ? [
                            o,
                            c
                        ] : [
                            o,
                            null
                        ], t) : i([
                            c,
                            o
                        ], t)), y && i([
                            o,
                            null
                        ], t);
                    } else if (d) {
                        if (null != u && u.length) {
                            if (u.some(function(e) {
                                return Ue(e, o);
                            })) i(u.filter(function(e) {
                                return !Ue(e, o);
                            }), t);
                            else i([].concat(Ne(u), [
                                o
                            ]), t);
                        } else i([
                            o
                        ], t);
                    } else i(o, t);
                }
                n || (r.props.onSelect(o, t), r.setState({
                    inputValue: null
                }));
            }), Ce(r, "setPreSelection", function(e) {
                var t = void 0 !== r.props.minDate, n = void 0 !== r.props.maxDate, a = !0;
                if (e) {
                    var o = K.startOfDay(e);
                    if (t && n) a = ze(e, r.props.minDate, r.props.maxDate);
                    else if (t) {
                        var s = K.startOfDay(r.props.minDate);
                        a = te.isAfter(e, s) || $e(o, s);
                    } else if (n) {
                        var i = V.endOfDay(r.props.maxDate);
                        a = re.isBefore(e, i) || $e(o, i);
                    }
                }
                a && r.setState({
                    preSelection: e
                });
            }), Ce(r, "toggleCalendar", function() {
                r.setOpen(!r.state.open);
            }), Ce(r, "handleTimeChange", function(e) {
                var t = r.props.selected ? r.props.selected : r.getPreSelection(), n = r.props.selected ? e : Ae(t, {
                    hour: w.getHours(e),
                    minute: k.getMinutes(e)
                });
                r.setState({
                    preSelection: n
                }), r.props.onChange(n), r.props.shouldCloseOnSelect && (r.sendFocusBackToInput(), r.setOpen(!1)), r.props.showTimeInput && r.setOpen(!0), (r.props.showTimeSelectOnly || r.props.showTimeSelect) && r.setState({
                    isRenderAriaLiveMessage: !0
                }), r.setState({
                    inputValue: null
                });
            }), Ce(r, "onInputClick", function() {
                r.props.disabled || r.props.readOnly || r.setOpen(!0), r.props.onInputClick();
            }), Ce(r, "onInputKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t = e.key;
                if (r.state.open || r.props.inline || r.props.preventOpenOnFocus) {
                    if (r.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var n = r.props.showWeekPicker && r.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : r.props.showFullMonthYearPicker || r.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', a = r.calendar.componentNode && r.calendar.componentNode.querySelector(n);
                            return void (a && a.focus({
                                preventScroll: !0
                            }));
                        }
                        var o = Te(r.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), r.inputOk() && r.state.lastPreSelectChange === dr ? (r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o)) : r.setOpen(!1)) : "Escape" === t ? (e.preventDefault(), r.sendFocusBackToInput(), r.setOpen(!1)) : "Tab" === t && r.setOpen(!1), r.inputOk() || r.props.onInputError({
                            code: 1,
                            msg: pr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || r.onInputClick();
            }), Ce(r, "onPortalKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.setOpen(!1), setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Ce(r, "onDayKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t, n = e.key, a = e.shiftKey, o = Te(r.state.preSelection);
                if ("Enter" === n) e.preventDefault(), r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o);
                else if ("Escape" === n) e.preventDefault(), r.setOpen(!1), r.inputOk() || r.props.onInputError({
                    code: 1,
                    msg: pr
                });
                else if (!r.props.disabledKeyboardNavigation) {
                    var s;
                    switch(n){
                        case "ArrowLeft":
                            s = r.props.showWeekPicker ? m.subWeeks(o, 1) : f.subDays(o, 1);
                            break;
                        case "ArrowRight":
                            s = r.props.showWeekPicker ? l.addWeeks(o, 1) : c.addDays(o, 1);
                            break;
                        case "ArrowUp":
                            s = m.subWeeks(o, 1);
                            break;
                        case "ArrowDown":
                            s = l.addWeeks(o, 1);
                            break;
                        case "PageUp":
                            s = a ? v.subYears(o, 1) : y.subMonths(o, 1);
                            break;
                        case "PageDown":
                            s = a ? h.addYears(o, 1) : d.addMonths(o, 1);
                            break;
                        case "Home":
                            s = We(o, r.props.locale, r.props.calendarStartDay);
                            break;
                        case "End":
                            t = o, s = U.endOfWeek(t);
                            break;
                        default:
                            s = null;
                    }
                    if (!s) return void (r.props.onInputError && r.props.onInputError({
                        code: 1,
                        msg: pr
                    }));
                    if (e.preventDefault(), r.setState({
                        lastPreSelectChange: dr
                    }), r.props.adjustDateOnChange && r.setSelected(s), r.setPreSelection(s), r.props.inline) {
                        var i = C.getMonth(o), p = C.getMonth(s), u = Y.getYear(o), g = Y.getYear(s);
                        i !== p || u !== g ? r.setState({
                            shouldFocusDayInline: !0
                        }) : r.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Ce(r, "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.sendFocusBackToInput());
            }), Ce(r, "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), r.sendFocusBackToInput(), r.props.selectsRange ? r.props.onChange([
                    null,
                    null
                ], e) : r.props.onChange(null, e), r.setState({
                    inputValue: null
                });
            }), Ce(r, "clear", function() {
                r.onClearClick();
            }), Ce(r, "onScroll", function(e) {
                "boolean" == typeof r.props.closeOnScroll && r.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || r.setOpen(!1) : "function" == typeof r.props.closeOnScroll && r.props.closeOnScroll(e) && r.setOpen(!1);
            }), Ce(r, "renderCalendar", function() {
                return r.props.inline || r.isCalendarOpen() ? he.default.createElement(ir, {
                    ref: function(e) {
                        r.calendar = e;
                    },
                    locale: r.props.locale,
                    calendarStartDay: r.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: r.props.monthAriaLabelPrefix,
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    setOpen: r.setOpen,
                    shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                    dateFormat: r.props.dateFormatCalendar,
                    useWeekdaysShort: r.props.useWeekdaysShort,
                    formatWeekDay: r.props.formatWeekDay,
                    dropdownMode: r.props.dropdownMode,
                    selected: r.props.selected,
                    preSelection: r.state.preSelection,
                    onSelect: r.handleSelect,
                    onWeekSelect: r.props.onWeekSelect,
                    openToDate: r.props.openToDate,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    selectsStart: r.props.selectsStart,
                    selectsEnd: r.props.selectsEnd,
                    selectsRange: r.props.selectsRange,
                    selectsMultiple: r.props.selectsMultiple,
                    selectedDates: r.props.selectedDates,
                    startDate: r.props.startDate,
                    endDate: r.props.endDate,
                    excludeDates: r.props.excludeDates,
                    excludeDateIntervals: r.props.excludeDateIntervals,
                    filterDate: r.props.filterDate,
                    onClickOutside: r.handleCalendarClickOutside,
                    formatWeekNumber: r.props.formatWeekNumber,
                    highlightDates: r.state.highlightDates,
                    holidays: Dt(r.modifyHolidays()),
                    includeDates: r.props.includeDates,
                    includeDateIntervals: r.props.includeDateIntervals,
                    includeTimes: r.props.includeTimes,
                    injectTimes: r.props.injectTimes,
                    inline: r.props.inline,
                    shouldFocusDayInline: r.state.shouldFocusDayInline,
                    peekNextMonth: r.props.peekNextMonth,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showPreviousMonths: r.props.showPreviousMonths,
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showWeekNumbers: r.props.showWeekNumbers,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    forceShowMonthNavigation: r.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: r.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown,
                    todayButton: r.props.todayButton,
                    weekLabel: r.props.weekLabel,
                    outsideClickIgnoreClass: sr,
                    fixedHeight: r.props.fixedHeight,
                    monthsShown: r.props.monthsShown,
                    monthSelectedIn: r.state.monthSelectedIn,
                    onDropdownFocus: r.handleDropdownFocus,
                    onMonthChange: r.props.onMonthChange,
                    onYearChange: r.props.onYearChange,
                    dayClassName: r.props.dayClassName,
                    weekDayClassName: r.props.weekDayClassName,
                    monthClassName: r.props.monthClassName,
                    timeClassName: r.props.timeClassName,
                    showDateSelect: r.props.showDateSelect,
                    showTimeSelect: r.props.showTimeSelect,
                    showTimeSelectOnly: r.props.showTimeSelectOnly,
                    onTimeChange: r.handleTimeChange,
                    timeFormat: r.props.timeFormat,
                    timeIntervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    className: r.props.calendarClassName,
                    container: r.props.calendarContainer,
                    yearItemNumber: r.props.yearItemNumber,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: r.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: r.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: r.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: r.props.nextMonthButtonLabel,
                    previousYearAriaLabel: r.props.previousYearAriaLabel,
                    previousYearButtonLabel: r.props.previousYearButtonLabel,
                    nextYearAriaLabel: r.props.nextYearAriaLabel,
                    nextYearButtonLabel: r.props.nextYearButtonLabel,
                    timeInputLabel: r.props.timeInputLabel,
                    disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                    renderCustomHeader: r.props.renderCustomHeader,
                    popperProps: r.props.popperProps,
                    renderDayContents: r.props.renderDayContents,
                    renderMonthContent: r.props.renderMonthContent,
                    renderQuarterContent: r.props.renderQuarterContent,
                    renderYearContent: r.props.renderYearContent,
                    onDayMouseEnter: r.props.onDayMouseEnter,
                    onMonthMouseLeave: r.props.onMonthMouseLeave,
                    onYearMouseEnter: r.props.onYearMouseEnter,
                    onYearMouseLeave: r.props.onYearMouseLeave,
                    selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                    showTimeInput: r.props.showTimeInput,
                    showMonthYearPicker: r.props.showMonthYearPicker,
                    showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                    showYearPicker: r.props.showYearPicker,
                    showQuarterYearPicker: r.props.showQuarterYearPicker,
                    showWeekPicker: r.props.showWeekPicker,
                    excludeScrollbar: r.props.excludeScrollbar,
                    handleOnKeyDown: r.props.onKeyDown,
                    handleOnDayKeyDown: r.onDayKeyDown,
                    isInputFocused: r.state.focused,
                    customTimeInput: r.props.customTimeInput,
                    setPreSelection: r.setPreSelection,
                    usePointerEvent: r.props.usePointerEvent,
                    yearClassName: r.props.yearClassName
                }, r.props.children) : null;
            }), Ce(r, "renderAriaLiveRegion", function() {
                var e, t = r.props, n = t.dateFormat, a = t.locale, o = r.props.showTimeInput || r.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = r.props.selectsRange ? "Selected start date: ".concat(Fe(r.props.startDate, {
                    dateFormat: o,
                    locale: a
                }), ". ").concat(r.props.endDate ? "End date: " + Fe(r.props.endDate, {
                    dateFormat: o,
                    locale: a
                }) : "") : r.props.showTimeSelectOnly ? "Selected time: ".concat(Fe(r.props.selected, {
                    dateFormat: n,
                    locale: a
                })) : r.props.showYearPicker ? "Selected year: ".concat(Fe(r.props.selected, {
                    dateFormat: "yyyy",
                    locale: a
                })) : r.props.showMonthYearPicker ? "Selected month: ".concat(Fe(r.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: a
                })) : r.props.showQuarterYearPicker ? "Selected quarter: ".concat(Fe(r.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: a
                })) : "Selected date: ".concat(Fe(r.props.selected, {
                    dateFormat: o,
                    locale: a
                })), he.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }), Ce(r, "renderDateInput", function() {
                var e, t = n.clsx(r.props.className, Ce({}, sr, r.state.open)), a = r.props.customInput || he.default.createElement("input", {
                    type: "text"
                }), o = r.props.customInputRef || "ref", s = "string" == typeof r.props.value ? r.props.value : "string" == typeof r.state.inputValue ? r.state.inputValue : r.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var n = Fe(e, r), a = t ? Fe(t, r) : "";
                    return "".concat(n, " - ").concat(a);
                }(r.props.startDate, r.props.endDate, r.props) : r.props.selectsMultiple ? function(e, t) {
                    if (null == e || !e.length) return "";
                    var r = Fe(e[0], t);
                    if (1 === e.length) return r;
                    if (2 === e.length) {
                        var n = Fe(e[1], t);
                        return "".concat(r, ", ").concat(n);
                    }
                    var a = e.length - 1;
                    return "".concat(r, " (+").concat(a, ")");
                }(r.props.selectedDates, r.props) : Fe(r.props.selected, r.props);
                return he.default.cloneElement(a, (Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(e = {}, o, function(e) {
                    r.input = e;
                }), "value", s), "onBlur", r.handleBlur), "onChange", r.handleChange), "onClick", r.onInputClick), "onFocus", r.handleFocus), "onKeyDown", r.onInputKeyDown), "id", r.props.id), "name", r.props.name), "form", r.props.form), Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(e, "autoFocus", r.props.autoFocus), "placeholder", r.props.placeholderText), "disabled", r.props.disabled), "autoComplete", r.props.autoComplete), "className", n.clsx(a.props.className, t)), "title", r.props.title), "readOnly", r.props.readOnly), "required", r.props.required), "tabIndex", r.props.tabIndex), "aria-describedby", r.props.ariaDescribedBy), Ce(Ce(Ce(e, "aria-invalid", r.props.ariaInvalid), "aria-labelledby", r.props.ariaLabelledBy), "aria-required", r.props.ariaRequired)));
            }), Ce(r, "renderClearButton", function() {
                var e = r.props, t = e.isClearable, a = e.disabled, o = e.selected, s = e.startDate, i = e.endDate, p = e.clearButtonTitle, c = e.clearButtonClassName, l = void 0 === c ? "" : c, d = e.ariaLabelClose, u = void 0 === d ? "Close" : d, h = e.selectedDates;
                return t && (null != o || null != s || null != i || null != h && h.length) ? he.default.createElement("button", {
                    type: "button",
                    className: n.clsx("react-datepicker__close-icon", l, {
                        "react-datepicker__close-icon--disabled": a
                    }),
                    disabled: a,
                    "aria-label": u,
                    onClick: r.onClearClick,
                    title: p,
                    tabIndex: -1
                }) : null;
            }), r.state = r.calcInitialState(), r.preventFocusTimeout = null, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, n;
                    e.inline && (r = e.selected, n = this.props.selected, r && n ? C.getMonth(r) !== C.getMonth(n) || Y.getYear(r) !== Y.getYear(n) : r !== n) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: vt(this.props.highlightDates)
                    }), t.focused || $e(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    var e = this.props, t = e.showIcon, r = e.icon, n = e.calendarIconClassname, a = e.toggleCalendarOnIconClick, o = this.state.open;
                    return he.default.createElement("div", {
                        className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "")
                    }, t && he.default.createElement(Zt, _e({
                        icon: r,
                        className: "".concat(n, " ").concat(o && "react-datepicker-ignore-onclickoutside")
                    }, a ? {
                        onClick: this.toggleCalendar
                    } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? he.default.createElement(rr, {
                            enableTabLoop: this.props.enableTabLoop
                        }, he.default.createElement("div", {
                            className: "react-datepicker__portal",
                            tabIndex: -1,
                            onKeyDown: this.onPortalKeyDown
                        }, e)) : null;
                        return this.state.open && this.props.portalId && (t = he.default.createElement(er, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), he.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return he.default.createElement(or, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop,
                        showArrow: this.props.showPopperArrow
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        showWeekPicker: !1,
                        strictParsing: !1,
                        swapRange: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: xe,
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0,
                        toggleCalendarOnIconClick: !1,
                        usePointerEvent: !1
                    };
                }
            }
        ]);
    }(he.default.Component), lr = "input", dr = "navigate";
    e.CalendarContainer = Gt, e.default = cr, e.getDefaultLocale = Ge, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});



var $db7e45bc78c04383$exports = {};
// Generated by CoffeeScript 1.10.0
var $db7e45bc78c04383$var$feedback, $db7e45bc78c04383$var$matching, $db7e45bc78c04383$var$scoring, $db7e45bc78c04383$var$time, $db7e45bc78c04383$var$time_estimates, $db7e45bc78c04383$var$zxcvbn;

$db7e45bc78c04383$var$matching = (parcelRequire("jYkpI"));

$db7e45bc78c04383$var$scoring = (parcelRequire("fWMoF"));

$db7e45bc78c04383$var$time_estimates = (parcelRequire("jFojO"));

$db7e45bc78c04383$var$feedback = (parcelRequire("k6zYl"));
$db7e45bc78c04383$var$time = function() {
    return new Date().getTime();
};
$db7e45bc78c04383$var$zxcvbn = function(password, user_inputs) {
    var arg, attack_times, i, len, matches, prop, ref, result, sanitized_inputs, start, val;
    if (user_inputs == null) user_inputs = [];
    start = $db7e45bc78c04383$var$time();
    sanitized_inputs = [];
    for(i = 0, len = user_inputs.length; i < len; i++){
        arg = user_inputs[i];
        if ((ref = typeof arg) === "string" || ref === "number" || ref === "boolean") sanitized_inputs.push(arg.toString().toLowerCase());
    }
    $db7e45bc78c04383$var$matching.set_user_input_dictionary(sanitized_inputs);
    matches = $db7e45bc78c04383$var$matching.omnimatch(password);
    result = $db7e45bc78c04383$var$scoring.most_guessable_match_sequence(password, matches);
    result.calc_time = $db7e45bc78c04383$var$time() - start;
    attack_times = $db7e45bc78c04383$var$time_estimates.estimate_attack_times(result.guesses);
    for(prop in attack_times){
        val = attack_times[prop];
        result[prop] = val;
    }
    result.feedback = $db7e45bc78c04383$var$feedback.get_feedback(result.score, result.sequence);
    return result;
};
$db7e45bc78c04383$exports = $db7e45bc78c04383$var$zxcvbn;




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c67230782f8454df$export$37b65e5b5444d35c = new WeakMap();







var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $caeb06b22505de77$export$37b0961d2f4751e2(props, state, ref) {
    let { value: value, children: children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, onPressUp: onPressUp, onClick: onClick } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $ecc4b8c956bf739d$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $ecc4b8c956bf739d$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        onPress (e) {
            var _ref_current;
            onPress === null || onPress === void 0 || onPress(e);
            state.setSelectedValue(value);
            (_ref_current = ref.current) === null || _ref_current === void 0 || _ref_current.focus();
        }
    });
    let { focusableProps: focusableProps } = (0, $a5b5972f65b7b461$export$4c014de7c8940b4c)((0, $4e4840536c52e885$export$9d1611c77c2fe928)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = (0, $4e4840536c52e885$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = (0, $3521997fbd9016c9$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    let { name: name, form: form, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $c67230782f8454df$export$37b65e5b5444d35c).get(state);
    (0, $4ff2f40121425aba$export$5add1d006293d136)(ref, state.defaultSelectedValue, state.setSelectedValue);
    (0, $54702a482e9f562d$export$b8473d3665f3a75a)({
        validationBehavior: validationBehavior
    }, state, ref);
    return {
        labelProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)(labelProps, (0, $70fFQ.useMemo)(()=>({
                onClick: (e)=>e.preventDefault(),
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)(domProps, {
            ...interactions,
            type: 'radio',
            name: name,
            form: form,
            tabIndex: tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === 'native',
            checked: checked,
            value: value,
            onChange: onChange,
            'aria-describedby': [
                props['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }),
        isDisabled: isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}





// https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/ShadowTreeWalker.ts
class $b0c3259b8293045d$export$63eb3ababa9c55c4 {
    get currentNode() {
        return this._currentNode;
    }
    set currentNode(node) {
        if (!(0, $3086a20958df8aeb$export$4282f70798064fe0)(this.root, node)) throw new Error('Cannot set currentNode to a node that is not contained by the root node.');
        const walkers = [];
        let curNode = node;
        let currentWalkerCurrentNode = node;
        this._currentNode = node;
        while(curNode && curNode !== this.root)if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            const shadowRoot = curNode;
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            walkers.push(walker);
            walker.currentNode = currentWalkerCurrentNode;
            this._currentSetFor.add(walker);
            curNode = currentWalkerCurrentNode = shadowRoot.host;
        } else curNode = curNode.parentNode;
        const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
            acceptNode: this._acceptNode
        });
        walkers.push(walker);
        walker.currentNode = currentWalkerCurrentNode;
        this._currentSetFor.add(walker);
        this._walkerStack = walkers;
    }
    get doc() {
        return this._doc;
    }
    firstChild() {
        let currentNode = this.currentNode;
        let newNode = this.nextNode();
        if (!(0, $3086a20958df8aeb$export$4282f70798064fe0)(currentNode, newNode)) {
            this.currentNode = currentNode;
            return null;
        }
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    lastChild() {
        let walker = this._walkerStack[0];
        let newNode = walker.lastChild();
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    nextNode() {
        const nextNode = this._walkerStack[0].nextNode();
        if (nextNode) {
            const shadowRoot = nextNode.shadowRoot;
            if (shadowRoot) {
                var _this_filter;
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(nextNode);
                else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    this.currentNode = nextNode;
                    return nextNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (nextNode) this.currentNode = nextNode;
            return nextNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    previousNode() {
        const currentWalker = this._walkerStack[0];
        if (currentWalker.currentNode === currentWalker.root) {
            if (this._currentSetFor.has(currentWalker)) {
                this._currentSetFor.delete(currentWalker);
                if (this._walkerStack.length > 1) {
                    this._walkerStack.shift();
                    let newNode = this.previousNode();
                    if (newNode) this.currentNode = newNode;
                    return newNode;
                } else return null;
            }
            return null;
        }
        const previousNode = currentWalker.previousNode();
        if (previousNode) {
            const shadowRoot = previousNode.shadowRoot;
            if (shadowRoot) {
                var _this_filter;
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(previousNode);
                else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    if (previousNode) this.currentNode = previousNode;
                    return previousNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.lastChild();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (previousNode) this.currentNode = previousNode;
            return previousNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.previousNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    /**
     * @deprecated
     */ nextSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
     * @deprecated
     */ previousSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
     * @deprecated
     */ parentNode() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    constructor(doc, root, whatToShow, filter){
        this._walkerStack = [];
        this._currentSetFor = new Set();
        this._acceptNode = (node)=>{
            if (node.nodeType === Node.ELEMENT_NODE) {
                const shadowRoot = node.shadowRoot;
                if (shadowRoot) {
                    const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                        acceptNode: this._acceptNode
                    });
                    this._walkerStack.unshift(walker);
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    var _this_filter;
                    if (typeof this.filter === 'function') return this.filter(node);
                    else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) return this.filter.acceptNode(node);
                    else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
                }
            }
            return NodeFilter.FILTER_SKIP;
        };
        this._doc = doc;
        this.root = root;
        this.filter = filter !== null && filter !== void 0 ? filter : null;
        this.whatToShow = whatToShow !== null && whatToShow !== void 0 ? whatToShow : NodeFilter.SHOW_ALL;
        this._currentNode = root;
        this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
        const shadowRoot = root.shadowRoot;
        if (shadowRoot) {
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            this._walkerStack.unshift(walker);
        }
    }
}
function $b0c3259b8293045d$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter) {
    if ((0, $439a154e6c47d7e2$export$98658e8c59125e6a)()) return new $b0c3259b8293045d$export$63eb3ababa9c55c4(doc, root, whatToShow, filter);
    return doc.createTreeWalker(root, whatToShow, filter);
}










var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(null);
const $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$RESTORE_FOCUS_EVENT = 'react-aria-focus-scope-restore';
let $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = null;
function $43a6dfd5ffa43457$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $70fFQ.useRef)(null);
    let endRef = (0, $70fFQ.useRef)(null);
    let scopeRef = (0, $70fFQ.useRef)([]);
    let { parentNode: parentNode } = (0, $70fFQ.useContext)($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $70fFQ.useMemo)(()=>new $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $43a6dfd5ffa43457$export$d06fae2ee68b101e.root;
        if ($43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope && !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isAncestorScope($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope, parent.scopeRef)) {
            let activeNode = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $43a6dfd5ffa43457$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        let node = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        let stopPropagation = (e)=>e.stopPropagation();
        while(node && node !== endRef.current){
            nodes.push(node);
            // Stop custom restore focus event from propagating to parent focus scopes.
            node.addEventListener($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$RESTORE_FOCUS_EVENT, stopPropagation);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
        return ()=>{
            for (let node of nodes)node.removeEventListener($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$RESTORE_FOCUS_EVENT, stopPropagation);
        };
    }, [
        children
    ]);
    $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useFocusContainment(scopeRef, contain);
    $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useAutoFocus(scopeRef, autoFocus);
    (0, $70fFQ.useEffect)(()=>{
        const activeElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)((0, $0be158cb8722d424$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined));
        let scope = null;
        if ($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $43a6dfd5ffa43457$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope || $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isAncestorScope(scopeRef, $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope)) && (!parentScope || $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(parentScope))) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = parentScope;
            $43a6dfd5ffa43457$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $70fFQ.useMemo)(()=>$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $70fFQ.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $43a6dfd5ffa43457$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $70fFQ.useContext)($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            var _scope_;
            let node = from || (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)((0, $0be158cb8722d424$export$b204af158042fbac)((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : undefined));
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope);
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            var _scope_;
            let node = from || (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)((0, $0be158cb8722d424$export$b204af158042fbac)((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : undefined));
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope);
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope);
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope);
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldContainFocus(scopeRef) {
    let scope = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getRadiosInGroup(element) {
    if (!element.form) return Array.from((0, $0be158cb8722d424$export$b204af158042fbac)(element).querySelectorAll(`input[type="radio"][name="${CSS.escape(element.name)}"]`)).filter((radio)=>!radio.form);
    // namedItem returns RadioNodeList (iterable) for 2+ elements, but a single Element for exactly 1.
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormControlsCollection/namedItem
    const radioList = element.form.elements.namedItem(element.name);
    let ownerWindow = (0, $0be158cb8722d424$export$f21a1ffae260145a)(element);
    if (radioList instanceof ownerWindow.RadioNodeList) return Array.from(radioList).filter((el)=>el instanceof ownerWindow.HTMLInputElement);
    if (radioList instanceof ownerWindow.HTMLInputElement) return [
        radioList
    ];
    return [];
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isTabbableRadio(element) {
    if (element.checked) return true;
    const radios = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getRadiosInGroup(element);
    return radios.length > 0 && !radios.some((radio)=>radio.checked);
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $70fFQ.useRef)(undefined);
    let raf = (0, $70fFQ.useRef)(undefined);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument);
            let scope = scopeRef.current;
            if (!scope || !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope);
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) {
                $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(nextElement, true);
                if (nextElement instanceof (0, $0be158cb8722d424$export$f21a1ffae260145a)(nextElement).HTMLInputElement) nextElement.select();
            }
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope || $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isAncestorScope($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope, scopeRef)) && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e), scopeRef.current)) {
                $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = scopeRef;
                focusedNode.current = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
            } else if ($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldContainFocus(scopeRef) && !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope((0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e), scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope.current) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusFirstInScope($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope.current);
            } else if ($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldContainFocus(scopeRef)) focusedNode.current = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Patches infinite focus coersion loop for Android Talkback where the user isn't able to move the virtual cursor
                // if within a containing focus scope. Bug filed against Chrome: https://issuetracker.google.com/issues/384844019.
                // Note that this means focus can leave focus containing modals due to this, but it is isolated to Chrome Talkback.
                let modality = (0, $bad2a4032856d574$export$630ff653c5ada6a9)();
                let shouldSkipFocusRestore = (modality === 'virtual' || modality === null) && (0, $86098bbbd8e8a169$export$a11b0059900ceec8)() && (0, $86098bbbd8e8a169$export$6446a186d09e379e)();
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                let activeElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument);
                if (!shouldSkipFocusRestore && activeElement && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldContainFocus(scopeRef) && !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(activeElement, scopeRef)) {
                    $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = scopeRef;
                    let target = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
                    if (target && target.isConnected) {
                        var _focusedNode_current;
                        focusedNode.current = target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope.current) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusFirstInScope($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener('keydown', onKeyDown, false);
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusout', onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener('keydown', onKeyDown, false);
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusout', onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInAnyScope(element) {
    return $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(element);
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>(0, $3086a20958df8aeb$export$4282f70798064fe0)(node, element));
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest('[data-react-aria-top-layer]')) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $43a6dfd5ffa43457$export$d06fae2ee68b101e.traverse($43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $43a6dfd5ffa43457$export$1258395f99bf9cbf(element) {
    return $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(element, $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope);
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $158b2efc209f9857$export$80f3e147d781571c)(element);
    } catch  {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch  {
    // ignore
    }
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope);
    let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getScopeRoot(scope);
        walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    return nextNode;
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusFirstInScope(scope, tabbable = true) {
    $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getFirstInScope(scope, tabbable));
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(autoFocus);
    (0, $70fFQ.useEffect)(()=>{
        if (autoFocusRef.current) {
            $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = scopeRef;
            const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope((0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument), $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope.current) && scopeRef.current) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e);
            if ($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(target, scopeRef.current)) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = scopeRef;
            else if (!$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInAnyScope(target)) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = null;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldRestoreFocus(scopeRef) {
    let scope = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (0, $70fFQ.useRef)(typeof document !== 'undefined' ? (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)((0, $0be158cb8722d424$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined)) : null);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope || $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isAncestorScope($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope, scopeRef)) && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope((0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument), scopeRef.current)) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(focusedElement, scopeRef) || !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldRestoreFocus(scopeRef)) return;
            let treeNode = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !nodeToRestore.isConnected || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(nextElement, scopeRef));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $58f47a33590a2f93$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $0be158cb8722d424$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            let activeElement = (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)(ownerDocument);
            if (restoreFocus && nodeToRestore && (activeElement && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInChildScope(activeElement, scopeRef) || activeElement === ownerDocument.body && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $43a6dfd5ffa43457$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$restoreFocusToElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $43a6dfd5ffa43457$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                let node = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$getFirstInScope(treeNode.scopeRef.current, true);
                                $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$restoreFocusToElement(node);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$restoreFocusToElement(node) {
    // Dispatch a custom event that parent elements can intercept to customize focus restoration.
    // For example, virtualized collection components reuse DOM elements, so the original element
    // might still exist in the DOM but representing a different item.
    if (node.dispatchEvent(new CustomEvent($43a6dfd5ffa43457$var$$903814aeb7d53b38$var$RESTORE_FOCUS_EVENT, {
        bubbles: true,
        cancelable: true
    }))) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(node);
}
function $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(root, opts, scope) {
    let filter = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? (0, $c5642333d79ce5b3$export$bebd5a1431fec25d) : (0, $c5642333d79ce5b3$export$4c063cf1350e6fed);
    // Ensure that root is an Element or fall back appropriately
    let rootElement = (root === null || root === void 0 ? void 0 : root.nodeType) === Node.ELEMENT_NODE ? root : null;
    // Determine the document to use
    let doc = (0, $0be158cb8722d424$export$b204af158042fbac)(rootElement);
    // Create a TreeWalker, ensuring the root is an Element or Document
    let walker = (0, $b0c3259b8293045d$export$4d0f8be8b12a7ef6)(doc, root || doc, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // Skip nodes inside the starting node.
            if ((0, $3086a20958df8aeb$export$4282f70798064fe0)(opts === null || opts === void 0 ? void 0 : opts.from, node)) return NodeFilter.FILTER_REJECT;
            if ((opts === null || opts === void 0 ? void 0 : opts.tabbable) && node.tagName === 'INPUT' && node.getAttribute('type') === 'radio') {
                // If the radio is in a form, we can get all the other radios by name
                if (!$43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isTabbableRadio(node)) return NodeFilter.FILTER_REJECT;
                // If the radio is in the same group as the current node and none are selected, we can skip it
                if (walker.currentNode.tagName === 'INPUT' && walker.currentNode.type === 'radio' && walker.currentNode.name === node.name) return NodeFilter.FILTER_REJECT;
            }
            if (filter(node) && (!scope || $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $43a6dfd5ffa43457$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)((0, $0be158cb8722d424$export$b204af158042fbac)(root));
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if ((0, $3086a20958df8aeb$export$4282f70798064fe0)(root, node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $3086a20958df8aeb$export$cd4e5573fbe2b576)((0, $0be158cb8722d424$export$b204af158042fbac)(root));
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if ((0, $3086a20958df8aeb$export$4282f70798064fe0)(root, node)) walker.currentNode = node;
            else {
                let next = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$last(walker);
                if (next) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $43a6dfd5ffa43457$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$last(walker);
            if (next) $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $43a6dfd5ffa43457$export$d06fae2ee68b101e = new $43a6dfd5ffa43457$var$$903814aeb7d53b38$var$Tree();







/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6f91b2ef525822a6$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, 'aria-label': label, 'aria-labelledby': labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $57d6fc3c99b86009$export$f680877a34711e37)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(' ');
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        'aria-label': label,
        'aria-labelledby': labelledBy
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8b221e9f34d95b3c$export$8467354a121f1b9f(props) {
    let { id: id, label: label, 'aria-labelledby': ariaLabelledby, 'aria-label': ariaLabel, labelElementType: labelElementType = 'label' } = props;
    id = (0, $57d6fc3c99b86009$export$f680877a34711e37)(id);
    let labelId = (0, $57d6fc3c99b86009$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else !ariaLabelledby && ariaLabel;
    let fieldProps = (0, $6f91b2ef525822a6$export$d6875122194c7b44)({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}




/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $99ce72c801092870$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $8b221e9f34d95b3c$export$8467354a121f1b9f)(props);
    let descriptionId = (0, $57d6fc3c99b86009$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $57d6fc3c99b86009$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $4e4840536c52e885$export$9d1611c77c2fe928)(fieldProps, {
        'aria-describedby': [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $4040b547e190e5b2$var$$80de4f1e59ad92d4$var$RTL_SCRIPTS = new Set([
    'Arab',
    'Syrc',
    'Samr',
    'Mand',
    'Thaa',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Hebr'
]);
const $4040b547e190e5b2$var$$80de4f1e59ad92d4$var$RTL_LANGS = new Set([
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
]);
function $4040b547e190e5b2$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === 'function' ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === 'rtl';
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $4040b547e190e5b2$var$$80de4f1e59ad92d4$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split('-')[0];
    return $4040b547e190e5b2$var$$80de4f1e59ad92d4$var$RTL_LANGS.has(lang);
}





var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
function $4d3cf5b5e457ff95$export$f09106e7c6677ec5() {
    let locale = typeof window !== 'undefined' && window[$4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$localeSymbol] || typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch  {
        locale = 'en-US';
    }
    return {
        locale: locale,
        direction: (0, $4040b547e190e5b2$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
    };
}
let $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$currentLocale = $4d3cf5b5e457ff95$export$f09106e7c6677ec5();
let $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$listeners = new Set();
function $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$updateLocale() {
    $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$currentLocale = $4d3cf5b5e457ff95$export$f09106e7c6677ec5();
    for (let listener of $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$listeners)listener($4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$currentLocale);
}
function $4d3cf5b5e457ff95$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $f0b318f29420a1e2$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $70fFQ.useState)($4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$currentLocale);
    (0, $70fFQ.useEffect)(()=>{
        if ($4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$listeners.size === 0) window.addEventListener('languagechange', $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$updateLocale);
        $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$listeners.add(setDefaultLocale);
        return ()=>{
            $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$listeners.delete(setDefaultLocale);
            if ($4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$listeners.size === 0) window.removeEventListener('languagechange', $4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) {
        let locale = typeof window !== 'undefined' && window[$4d3cf5b5e457ff95$var$$7c8c20f0715e2860$var$localeSymbol];
        return {
            locale: locale || 'en-US',
            direction: 'ltr'
        };
    }
    return defaultLocale;
}



var $70fFQ = parcelRequire("70fFQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8e195bd231e2877f$var$$4defb058003b3e05$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(null);
/**
 * Internal component that handles the case when locale is provided.
 */ function $8e195bd231e2877f$var$$4defb058003b3e05$var$I18nProviderWithLocale(props) {
    let { locale: locale, children: children } = props;
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useMemo(()=>({
            locale: locale,
            direction: (0, $4040b547e190e5b2$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
        }), [
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($8e195bd231e2877f$var$$4defb058003b3e05$var$I18nContext.Provider, {
        value: value
    }, children);
}
/**
 * Internal component that handles the case when no locale is provided.
 */ function $8e195bd231e2877f$var$$4defb058003b3e05$var$I18nProviderWithDefaultLocale(props) {
    let { children: children } = props;
    let defaultLocale = (0, $4d3cf5b5e457ff95$export$188ec29ebc2bdc3a)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($8e195bd231e2877f$var$$4defb058003b3e05$var$I18nContext.Provider, {
        value: defaultLocale
    }, children);
}
function $8e195bd231e2877f$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    // Conditionally render different components to avoid calling useDefaultLocale.
    // This is necessary because useDefaultLocale triggers a re-render.
    if (locale) return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($8e195bd231e2877f$var$$4defb058003b3e05$var$I18nProviderWithLocale, {
        locale: locale,
        children: children
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($8e195bd231e2877f$var$$4defb058003b3e05$var$I18nProviderWithDefaultLocale, {
        children: children
    });
}
function $8e195bd231e2877f$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $4d3cf5b5e457ff95$export$188ec29ebc2bdc3a)();
    let context = (0, $70fFQ.useContext)($8e195bd231e2877f$var$$4defb058003b3e05$var$I18nContext);
    return context || defaultLocale;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $25e8fa3cc2920a8a$export$62b9571f283ff5c2(props, state) {
    let { name: name, form: form, isReadOnly: isReadOnly, isRequired: isRequired, isDisabled: isDisabled, orientation: orientation = 'vertical', validationBehavior: validationBehavior = 'aria' } = props;
    let { direction: direction } = (0, $8e195bd231e2877f$export$43bb16f9c6d9e3f7)();
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $99ce72c801092870$export$294aa081a6c6f55d)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $3521997fbd9016c9$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps: focusWithinProps } = (0, $b3e7e2b301c53c40$export$420e68273165f4ec)({
        onBlurWithin (e) {
            var _props_onBlur;
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case 'ArrowRight':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'prev';
                else nextDir = 'next';
                break;
            case 'ArrowLeft':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'next';
                else nextDir = 'prev';
                break;
            case 'ArrowDown':
                nextDir = 'next';
                break;
            case 'ArrowUp':
                nextDir = 'prev';
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = (0, $43a6dfd5ffa43457$export$2d6ec8fc375ceafa)(e.currentTarget, {
            from: (0, $3086a20958df8aeb$export$e58f029f0fbfdb29)(e),
            accept: (node)=>node instanceof (0, $0be158cb8722d424$export$f21a1ffae260145a)(node).HTMLInputElement && node.type === 'radio'
        });
        let nextElem;
        if (nextDir === 'next') {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = (0, $57d6fc3c99b86009$export$f680877a34711e37)(name);
    (0, $c67230782f8454df$export$37b65e5b5444d35c).set(state, {
        name: groupName,
        form: form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    return {
        radioGroupProps: (0, $4e4840536c52e885$export$9d1611c77c2fe928)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: 'radiogroup',
            onKeyDown: onKeyDown,
            'aria-invalid': state.isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            'aria-disabled': isDisabled || undefined,
            'aria-orientation': orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}


var $1ab16fa43c767403$exports = {};
function $1ab16fa43c767403$var$_extends() {
    return $1ab16fa43c767403$exports = $1ab16fa43c767403$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1ab16fa43c767403$exports.__esModule = true, $1ab16fa43c767403$exports["default"] = $1ab16fa43c767403$exports, $1ab16fa43c767403$var$_extends.apply(null, arguments);
}
$1ab16fa43c767403$exports = $1ab16fa43c767403$var$_extends, $1ab16fa43c767403$exports.__esModule = true, $1ab16fa43c767403$exports["default"] = $1ab16fa43c767403$exports;


var $6160d31992be02bd$exports = {};
function $6160d31992be02bd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$6160d31992be02bd$exports = $6160d31992be02bd$var$_objectWithoutPropertiesLoose, $6160d31992be02bd$exports.__esModule = true, $6160d31992be02bd$exports["default"] = $6160d31992be02bd$exports;





var $70fFQ = parcelRequire("70fFQ");
var $bd7cd108646cef09$var$_excluded$2 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $bd7cd108646cef09$var$renderComponent(props, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, (/*@__PURE__*/$parcel$interopDefault($6160d31992be02bd$exports)))(props, $bd7cd108646cef09$var$_excluded$2);
    if (component) return /*#__PURE__*/ $70fFQ.createElement(component, (0, (/*@__PURE__*/$parcel$interopDefault($1ab16fa43c767403$exports)))({}, rest, {
        children: children,
        render: render
    })); // inject children back in
    if (render) return render(children === undefined ? rest : (0, (/*@__PURE__*/$parcel$interopDefault($1ab16fa43c767403$exports)))({}, rest, {
        children: children
    })); // inject children back in
    if (typeof children !== 'function') throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    return children(rest);
}
var $bd7cd108646cef09$var$defaultIsEqual = function defaultIsEqual(aArray, bArray) {
    return aArray === bArray || Array.isArray(aArray) && Array.isArray(bArray) && aArray.length === bArray.length && !aArray.some(function(a, index) {
        return a !== bArray[index];
    });
};
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */ function $bd7cd108646cef09$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef();
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $bd7cd108646cef09$var$_excluded$1 = [
    "length"
], $bd7cd108646cef09$var$_excluded2 = [
    "meta",
    "input"
];
var $bd7cd108646cef09$var$all = (0, $0d6cd897c1522156$export$41e855cb628c1b55).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $bd7cd108646cef09$export$310131896651d559 = function useFieldArray(name, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $bd7cd108646cef09$var$all : _ref$subscription, defaultValue = _ref.defaultValue, initialValue = _ref.initialValue, _ref$isEqual = _ref.isEqual, isEqual = _ref$isEqual === void 0 ? $bd7cd108646cef09$var$defaultIsEqual : _ref$isEqual, validateProp = _ref.validate;
    var form = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)('useFieldArray');
    var formMutators = form.mutators;
    var hasMutators = !!(formMutators && formMutators.push && formMutators.pop);
    if (!hasMutators) throw new Error('Array mutators not found. You need to provide the mutators from final-form-arrays to your form');
    var mutators = (0, $70fFQ.useMemo)(function() {
        return(// curry the field name onto all mutator calls
        Object.keys(formMutators).reduce(function(result, key) {
            result[key] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return formMutators[key].apply(formMutators, [
                    name
                ].concat(args));
            };
            return result;
        }, {}));
    }, [
        name,
        formMutators
    ]);
    var validate = $bd7cd108646cef09$var$useConstant(function() {
        return function(value, allValues, meta) {
            if (!validateProp) return undefined;
            var error = validateProp(value, allValues, meta);
            if (!error || Array.isArray(error)) return error;
            else {
                var arrayError = [];
                arrayError[0, $0d6cd897c1522156$export$735bebc8ffabf28a] = error;
                return arrayError;
            }
        };
    });
    var _useField = (0, $42456926338d44c1$export$294aa081a6c6f55d)(name, {
        subscription: (0, (/*@__PURE__*/$parcel$interopDefault($1ab16fa43c767403$exports)))({}, subscription, {
            length: true
        }),
        defaultValue: defaultValue,
        initialValue: initialValue,
        isEqual: isEqual,
        validate: validate,
        format: function format(v) {
            return v;
        }
    }), _useField$meta = _useField.meta, length = _useField$meta.length, meta = (0, (/*@__PURE__*/$parcel$interopDefault($6160d31992be02bd$exports)))(_useField$meta, $bd7cd108646cef09$var$_excluded$1), input = _useField.input, fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($6160d31992be02bd$exports)))(_useField, $bd7cd108646cef09$var$_excluded2);
    var forEach = function forEach(iterator) {
        // required || for Flow, but results in uncovered line in Jest/Istanbul
        // istanbul ignore next
        var len = length || 0;
        for(var i = 0; i < len; i++)iterator(name + "[" + i + "]", i);
    };
    var map = function map(iterator) {
        // required || for Flow, but results in uncovered line in Jest/Istanbul
        // istanbul ignore next
        var len = length || 0;
        var results = [];
        for(var i = 0; i < len; i++)results.push(iterator(name + "[" + i + "]", i));
        return results;
    };
    return {
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($1ab16fa43c767403$exports)))({
            name: name,
            forEach: forEach,
            length: length || 0,
            map: map
        }, mutators, fieldState, {
            value: input.value
        }),
        meta: meta
    };
};
var $bd7cd108646cef09$export$83d89fbfd8236492 = "3.1.3";
var $bd7cd108646cef09$var$_excluded = [
    "name",
    "subscription",
    "defaultValue",
    "initialValue",
    "isEqual",
    "validate"
];
var $bd7cd108646cef09$var$versions = {
    'final-form': (0, $0d6cd897c1522156$export$83d89fbfd8236492),
    'react-final-form': (0, $42456926338d44c1$export$83d89fbfd8236492),
    'react-final-form-arrays': $bd7cd108646cef09$export$83d89fbfd8236492
};
var $bd7cd108646cef09$export$2683597413c8b91 = function FieldArray(_ref) {
    var name = _ref.name, subscription = _ref.subscription, defaultValue = _ref.defaultValue, initialValue = _ref.initialValue, isEqual = _ref.isEqual, validate = _ref.validate, rest = (0, (/*@__PURE__*/$parcel$interopDefault($6160d31992be02bd$exports)))(_ref, $bd7cd108646cef09$var$_excluded);
    var _useFieldArray = $bd7cd108646cef09$export$310131896651d559(name, {
        subscription: subscription,
        defaultValue: defaultValue,
        initialValue: initialValue,
        isEqual: isEqual,
        validate: validate
    }), fields = _useFieldArray.fields, meta = _useFieldArray.meta;
    return $bd7cd108646cef09$var$renderComponent((0, (/*@__PURE__*/$parcel$interopDefault($1ab16fa43c767403$exports)))({
        fields: fields,
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($1ab16fa43c767403$exports)))({}, meta, {
            __versions: $bd7cd108646cef09$var$versions
        })
    }, rest), "FieldArray(" + name + ")");
};


var $53461e26c6509d18$exports = {};

$53461e26c6509d18$exports = (parcelRequire("aFsEI"));


function $dfd33cee3229493c$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $dfd33cee3229493c$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $dfd33cee3229493c$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$exports, "YukaThemeProvider", ()=>$dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$exports, "TruncatedText", ()=>$dfd33cee3229493c$var$$e31c7335eaf29ffe$export$2e2bcd8739ae039);
var $dfd33cee3229493c$var$$0d8b515cb6593639$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0d8b515cb6593639$exports, "Avatar", ()=>$dfd33cee3229493c$var$$907f6d30d9122715$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0d8b515cb6593639$exports, "Thumbnail", ()=>$dfd33cee3229493c$var$$8f6d7344e3ba359e$export$2e2bcd8739ae039);
var $dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "PrimaryColorPalette", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "YukaColorPalette", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "ColorPalette", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "TableColors", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$339ad1512bbbf7ac);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "LiveTicketChartColors", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$f81cce92bf9f8642);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "Z_INDEXES", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "MEDIA_QUERIES", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$9f723b75f1efe23a);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "Orientations", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "SelectAnchorTypes", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports, "DEFAULT_COLOR_THEME", ()=>$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$c8e3bfd6e31baa27);
/* eslint-disable no-magic-numbers, import/prefer-default-export */ // The variables here correspond to those in variables.less and colors.less
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e = {
    blue900: "#ccfafd",
    blue800: "#99f5fb",
    blue700: "#66f0fa",
    blue600: "#33ebf8",
    blue500: "#00e6f6",
    blue400: "#05bdca",
    blue300: "#0a949e",
    blue200: "#106c72",
    blue100: "#154346",
    white100: "rgba(255, 255, 255, 1)",
    white80: "rgba(255, 255, 255, .8)",
    white50: "rgba(255, 255, 255, .5)",
    white30: "rgba(255, 255, 255, .3)",
    white15: "rgba(255, 255, 255, .15)",
    black100: "rgba(0, 0, 0, 1)",
    black80: "rgba(0, 0, 0, .8)",
    black50: "rgba(0, 0, 0, .5)",
    black30: "rgba(0, 0, 0, .3)",
    black15: "rgba(0, 0, 0, .15)",
    sell: "#ff6262",
    buy: "#00f68b",
    alert: "#fad656"
};
$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.accent = $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue500;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$OldColorPalette = {
    // This is for setting colors in SVGs, and should mirror the colors in colors.less
    // green
    greenLight: "#00f4b6",
    greenFaint: "#ccfcf0",
    greenNormal: "#1eb980",
    greenDark: "#00804d",
    greenOff: "#005f56",
    // red
    redFaint: "#ffe5e3",
    redLight: "#ffd5ce",
    redNormal: "#ff7d77",
    redDark: "#ff5b50",
    redOff: "#a5473d",
    // violet
    violetLight: "#c5cae9",
    violetNormal: "#7986cb",
    violetDark: "#3f51b5",
    // yellow
    yellowLight: "#ffa900",
    // white
    fullWhite: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white100,
    darkWhite: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
    lightWhite: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50,
    faintWhite: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30,
    minWhite: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15,
    white10: "rgba(255, 255, 255, 0.1)",
    // Active states
    white05: "rgba(255, 255, 255, 0.05)",
    // black
    fullBlack: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black100,
    darkBlack: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80,
    lightBlack: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black50,
    faintBlack: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black30,
    minBlack: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black15,
    black10: "rgba(0, 0, 0, 0.1)",
    black05: "rgba(0, 0, 0, 0.05)",
    // darken the background to create layers
    // solid greyscale
    lightGray: "#6b6b6b",
    // elevation
    elevation0: "#1b1b1b",
    elevation1: "#242424",
    elevation2: "#2b2b2b",
    elevation3: "#3b3b3b",
    elevation4: "#4b4b4b",
    elevation5: "#5b5b5b"
};
// Remapping of old colors to new ones where they differ
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$RemappedColorPalette = {
    yellowLight: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.alert,
    redDark: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.sell,
    greenNormal: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.buy
};
// Colors internal to yuka
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61 = {
    // elevation
    surface0: "#0a0a0a",
    surface1: "#1a1a1a",
    surface2: "#2a2a2a",
    surface3: "#3a3a3a",
    surface4: "#4a4a4a",
    surface5: "#5a5a5a",
    hoverTransparent: "rgba(255, 255, 255, 0.05)",
    activeTransparent: "rgba(255, 255, 255, 0.07)",
    avatarGreen: "#05ca9b",
    avatarDarkBlue: "#3c6fbc",
    avatarPurple: "#8e5cce",
    avatarPink: "#d87cc9",
    avatarOrange: "#e96e6e"
};
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff = {
    ...$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$OldColorPalette,
    ...$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$RemappedColorPalette,
    ...$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e
};
// dark table colors TODO possibly remove this?
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$339ad1512bbbf7ac = {
    border: "#4b4b4b",
    header: "#4b4b4b",
    headerText: "rgba(255, 255, 255, .5)",
    headerActive: "#6b6b6b",
    headerHover: "#555555",
    row: "#3b3b3b",
    rowText: "rgba(255, 255, 255, .5)",
    rowActive: "#555555",
    rowActiveText: "rgba(255, 255, 255, 1)",
    rowHover: "#444444",
    rowSelected: "#1dca7f",
    rowSelectedText: "rgba(255, 255, 255, 1)"
};
// Used in Live Tickets sections in Activity Tab. Most are one-off colors.
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$f81cce92bf9f8642 = [
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.violetNormal,
    "#c885c5",
    "#fb8ba6",
    "#ffa581",
    "#f9cb6f",
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.lightWhite
];
// Z-INDEXES
// ---------
// relevant context from 3rd party libraries:
// .selectize-dropdown: 10  <- low but it is okay because selectize is nested in the DOM
// #nprogress .bar/.spinner: 1031
// .qtip: ~ 15000  <- it is set inline by the library to approximate values
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexVisible = 1; // when you just need an element to have ANY value
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexExtraVisible = $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexVisible + 1; // when it needs to be above that
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexModal = 100;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexModalVisible = $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexModal + 1;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c = {
    zIndexVisible: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexVisible,
    zIndexExtraVisible: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexExtraVisible,
    zIndexModal: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexModal,
    zIndexModalVisible: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$zIndexModalVisible
};
// Breakpoints for responsive sizing
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mobileScreen = 420;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$smallScreen = 600;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mediumScreen = 992;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$largeScreen = 1200;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$extraLargeScreen = 1440;
// Media screen settings
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$smallAndUp = `only screen and (min-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mobileScreen + 1}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mediumAndUp = `only screen and (min-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$smallScreen + 1}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$largeAndUp = `only screen and (min-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mediumScreen + 1}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$extraLargeAndUp = `only screen and (min-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$largeScreen + 1}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mobileAndDown = `only screen and (max-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mobileScreen}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$smallAndDown = `only screen and (max-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$smallScreen}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mediumAndDown = `only screen and (max-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mediumScreen}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$largeAndDown = `only screen and (max-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$largeScreen}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$extraLargeAndDown = `only screen and (max-width : ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$extraLargeScreen}px)`;
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$9f723b75f1efe23a = {
    smallAndUp: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$smallAndUp,
    mediumAndUp: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mediumAndUp,
    largeAndUp: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$largeAndUp,
    extraLargeAndUp: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$extraLargeAndUp,
    mobileAndDown: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mobileAndDown,
    smallAndDown: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$smallAndDown,
    mediumAndDown: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$mediumAndDown,
    largeAndDown: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$largeAndDown,
    extraLargeAndDown: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$var$extraLargeAndDown
};
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a = {
    VERTICAL: "vertical",
    HORIZONTAL: "horizontal"
};
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef = {
    TEXT_BOX: "text_box",
    CHIP: "chip"
};
const $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$c8e3bfd6e31baa27 = {
    branding900: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue900,
    branding800: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue800,
    branding700: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue700,
    branding600: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue600,
    branding500: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue500,
    branding400: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400,
    branding300: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue300,
    branding200: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue200,
    branding100: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue100,
    red: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.sell,
    redHover: "#ff7272",
    redActive: "#ff7a7a",
    green: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.buy,
    greenHover: "#33f8a2",
    greenActive: "#66fab9",
    yellow: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.alert,
    /* Component-specific coloring */ link: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400,
    checkbox: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400,
    tabItem: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400,
    focussedInputBorder: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400
};
var $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "size12", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$2ad68e3d550fcadd);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "size14", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$3179ec1330538caa);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "headline5", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e8107e2c45e8ba92);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "headline4", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e84b9789d419fd2b);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "headline3", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$6af3c3acbb3cb12);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "headline2", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$b68c94e7d753c71b);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "headline1", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$2cb138ab94eaf6b5);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "body2", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$79846c98ead4e525);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "body1", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "caption2", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "caption1", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$672392da99d9bca0);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "overline", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "TextModifiers", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$8ad8d5b8f52ab54);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "FontWeights", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$32743b01f42d159e);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "FontColors", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledHeadline1", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$f47de4a9710d6029);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledHeadline2", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$c9a09f931ddc2bb1);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledHeadline3", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$3cf1fc60d6725a1a);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledHeadline4", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e6e0de481ec1f0b9);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledHeadline5", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$9a7613b41e137f47);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledBody1", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$93db1c4064a2ca6);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledBody2", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$f68165928c4f458d);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledCaption1", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$5b5a1974e2dd21c0);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledCaption2", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$a2c12df47548b0d7);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "StyledOverline", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$ad70e152d33af944);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports, "Fonts", ()=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3);
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyHeadline = '"Google Sans", "Roboto", sans-serif';
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyBody = '"Google Sans Text", "Google Sans", "Roboto", sans-serif';
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size11 = "0.6875rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$2ad68e3d550fcadd = "0.75rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$3179ec1330538caa = "0.875rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size16 = "1rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size18 = "1.125rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size20 = "1.25rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size24 = "1.5rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size34 = "2.125rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size48 = "3rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal = "400";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightBold = "700";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightTitle = "1.25";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightNormal = "1.5";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightMinimum = "1";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1 = "0";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing2 = "0.05rem";
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e8107e2c45e8ba92 = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyHeadline,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size48,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightTitle,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e84b9789d419fd2b = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyHeadline,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size34,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightTitle,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$6af3c3acbb3cb12 = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyHeadline,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size24,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightTitle,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$b68c94e7d753c71b = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyHeadline,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size20,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightTitle,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$2cb138ab94eaf6b5 = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyHeadline,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size18,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightTitle,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$79846c98ead4e525 = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyBody,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size16,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightTitle,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyBody,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$3179ec1330538caa,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightNormal,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0 = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyBody,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$2ad68e3d550fcadd,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightNormal,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$672392da99d9bca0 = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyBody,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size11,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightMinimum,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing1
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7 = {
    "font-family": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$fontFamilyBody,
    "font-size": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$size11,
    "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal,
    "line-height": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$lineHeightMinimum,
    "letter-spacing": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$letterSpacing2,
    "text-transform": "uppercase"
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$8ad8d5b8f52ab54 = {
    transformUpper: {
        "text-transform": "uppercase"
    },
    transformLower: {
        "text-transform": "lowercase"
    },
    strikethrough: {
        "text-decoration": "line-through"
    },
    underline: {
        "text-decoration": "underline"
    }
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$32743b01f42d159e = {
    normal: {
        "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightNormal
    },
    bold: {
        "font-weight": $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$weightBold
    }
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontColorByTheme = (theme, opacity = 80)=>{
    // If we don't have a mode - use default which is dark
    const modeToFont = theme.mode === "light" ? "black" : "white";
    return {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e[`${modeToFont}${opacity}`]
    };
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontThemeColor = (theme, color)=>{
    if (!theme?.colors?.[color]) return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$c8e3bfd6e31baa27[color];
    return theme.colors[color];
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895 = {
    theme15: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontColorByTheme(props.theme, 15)}
  `,
    theme30: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontColorByTheme(props.theme, 30)}
  `,
    theme50: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontColorByTheme(props.theme, 50)}
  `,
    theme80: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontColorByTheme(props.theme, 80)}
  `,
    theme100: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontColorByTheme(props.theme, 100)}
  `,
    buy: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>({
            color: $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontThemeColor(props.theme, "green")
        })}
  `,
    sell: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>({
            color: $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontThemeColor(props.theme, "red")
        })}
  `,
    yellow: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>({
            color: $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontThemeColor(props.theme, "yellow")
        })}
  `,
    branding: (0, $e42cae22e74e223a$exports.css)`
    ${(props)=>({
            color: $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$var$getFontThemeColor(props.theme, "branding500")
        })}
  `
};
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$f47de4a9710d6029 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).h1`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$2cb138ab94eaf6b5}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$c9a09f931ddc2bb1 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).h2`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$b68c94e7d753c71b}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$3cf1fc60d6725a1a = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).h3`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$6af3c3acbb3cb12}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e6e0de481ec1f0b9 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).h4`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e84b9789d419fd2b}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$9a7613b41e137f47 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).h5`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e8107e2c45e8ba92}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$93db1c4064a2ca6 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$f68165928c4f458d = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$79846c98ead4e525}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$5b5a1974e2dd21c0 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$672392da99d9bca0}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$a2c12df47548b0d7 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$ad70e152d33af944 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7}${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
`;
const $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3 = {};
Object.keys($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895).forEach((color)=>{
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Headline1${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$2cb138ab94eaf6b5}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Headline2${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$b68c94e7d753c71b}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Headline3${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$6af3c3acbb3cb12}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Headline4${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e84b9789d419fd2b}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Headline5${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e8107e2c45e8ba92}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Body1${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Body2${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$79846c98ead4e525}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Caption1${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$672392da99d9bca0}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Caption2${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  `;
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[`Overline${color}`] = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895[color]}
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7}
  `;
});
Object.keys($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3).forEach((key)=>{
    $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3[key].displayName = `Fonts.${key}`;
});
const $dfd33cee3229493c$var$$907f6d30d9122715$var$FONT_SIZES = {
    "18px": "9px",
    "24px": "12px",
    "32px": "16px",
    "48px": "24px",
    "64px": "32px",
    "96px": "48px"
};
const $dfd33cee3229493c$var$$907f6d30d9122715$var$DEFAULT_BACKGROUND_COLORS = [
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue400,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.avatarGreen,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.avatarDarkBlue,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.avatarPurple,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.avatarPink,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.avatarOrange
];
const $dfd33cee3229493c$var$$907f6d30d9122715$var$StyledAvatar = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).img`
  border-radius: 50%;
  box-sizing: border-box;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme100}
  display: flex;
  font-weight: bold;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-shrink: 0;

  ${(props)=>`
    height: ${props.$size};
    line-height: ${props.$size};
    width: ${props.$size};
  `}

  ${(props)=>props.onClick ? `
    cursor: pointer;
  ` : ""}
`;
/**
 * Yuka v2.0
 * This returns a circular avatar wrapped in a container based on the dimensions.
 * By default, this will return a gray background avatar with the user's initials.
 */ const $dfd33cee3229493c$var$$907f6d30d9122715$var$Avatar = (props)=>{
    const fontSize = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).get($dfd33cee3229493c$var$$907f6d30d9122715$var$FONT_SIZES, props.size);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$907f6d30d9122715$var$StyledAvatar, {
        as: props.avatar ? "img" : "div",
        alt: props.avatarAlt,
        className: props.className,
        onClick: props.onClick,
        src: props.avatar,
        $size: props.size,
        style: {
            fontSize: fontSize,
            // This is for alt text / initials text
            backgroundColor: !props.avatar && $dfd33cee3229493c$var$$907f6d30d9122715$var$DEFAULT_BACKGROUND_COLORS[props.colorId % $dfd33cee3229493c$var$$907f6d30d9122715$var$DEFAULT_BACKGROUND_COLORS.length]
        },
        children: props.avatar ? undefined : props.avatarAlt
    });
};
$dfd33cee3229493c$var$$907f6d30d9122715$var$Avatar.propTypes = {
    avatar: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    avatarAlt: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * stable number to use for the random background color.
   * not using avatarAlt so that adjacent elements in a table are not the same
   */ colorId: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.keys($dfd33cee3229493c$var$$907f6d30d9122715$var$FONT_SIZES)),
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$907f6d30d9122715$var$Avatar.defaultProps = {
    avatar: "",
    avatarAlt: "",
    colorId: 0,
    size: "32px"
};
$dfd33cee3229493c$var$$907f6d30d9122715$var$Avatar.displayName = "Avatar";
var $dfd33cee3229493c$var$$907f6d30d9122715$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$907f6d30d9122715$var$Avatar;
const $dfd33cee3229493c$var$$8f6d7344e3ba359e$var$SIZE_TO_RADIUS = {
    "24px": "6px",
    "32px": "8px",
    "48px": "12px",
    "64px": "16px",
    "96px": "24px"
};
const $dfd33cee3229493c$var$$8f6d7344e3ba359e$var$StyledThumbnail = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).img`
  ${(props)=>`
    height: ${props.size};
    width: ${props.size};
    border-radius: ${$dfd33cee3229493c$var$$8f6d7344e3ba359e$var$SIZE_TO_RADIUS[props.size]};
  `}
`;
/**
 * Yuka v2.0
 * This returns a rounded square with a logo inside.
 */ const $dfd33cee3229493c$var$$8f6d7344e3ba359e$var$Thumbnail = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$8f6d7344e3ba359e$var$StyledThumbnail, {
        className: props.className,
        alt: props.alt,
        size: props.size,
        src: props.src
    });
$dfd33cee3229493c$var$$8f6d7344e3ba359e$var$Thumbnail.propTypes = {
    alt: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    src: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    /** Provided as px since that is what we read off of zeplin mockups */ size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
        "24px",
        "32px",
        "48px",
        "64px",
        "96px"
    ]).isRequired
};
$dfd33cee3229493c$var$$8f6d7344e3ba359e$var$Thumbnail.defaultProps = {
    alt: ""
};
$dfd33cee3229493c$var$$8f6d7344e3ba359e$var$Thumbnail.displayName = "Thumbnail";
var $dfd33cee3229493c$var$$8f6d7344e3ba359e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8f6d7344e3ba359e$var$Thumbnail;
var $dfd33cee3229493c$var$$fe1ba5810fdf797e$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$fe1ba5810fdf797e$exports, "BadgeStylePropType", ()=>$dfd33cee3229493c$var$$fe1ba5810fdf797e$export$54f72bf989ec8c70);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$fe1ba5810fdf797e$exports, "BadgeStyles", ()=>$dfd33cee3229493c$var$$14202c65a8343c87$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$fe1ba5810fdf797e$exports, "Badge", ()=>$dfd33cee3229493c$var$$0e049761bcecbff8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$fe1ba5810fdf797e$exports, "BadgeList", ()=>$dfd33cee3229493c$var$$5c43562bf1ac9d76$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$fe1ba5810fdf797e$exports, "IndicatorBadge", ()=>$dfd33cee3229493c$var$$310d86a3e565de36$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$fe1ba5810fdf797e$exports, "IndicatorStatuses", ()=>$dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d);
const $dfd33cee3229493c$var$$14202c65a8343c87$var$BadgeStyles = {
    DARK_GRAY: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15
    },
    MEDIUM_GRAY: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30
    },
    LIGHT_GRAY: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50
    },
    WHITE: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white100
    },
    BLACK: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black100
    },
    TEAL: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80,
        backgroundColor: "#00f6ca"
    },
    LIGHT_BLUE: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue500
    },
    MEDIUM_BLUE: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80,
        backgroundColor: "#00acf6"
    },
    DARK_BLUE: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: "#0071f6"
    },
    PURPLE: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: "#7b00f6"
    },
    PINK: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: "#e063eb"
    },
    SELL_RED: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.sell
    },
    BUY_GREEN: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.buy
    },
    YELLOW: {
        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80,
        backgroundColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.alert
    }
};
var $dfd33cee3229493c$var$$14202c65a8343c87$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$14202c65a8343c87$var$BadgeStyles;
const $dfd33cee3229493c$var$$0e049761bcecbff8$var$Badge = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div.attrs({
    className: "badge"
})`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7};
  line-height: 12px;
  letter-spacing: 0.05em;
  align-items: center;
  border-radius: 4px;
  box-sizing: border-box;
  display: inline-flex;
  height: 16px;
  padding: 2px 4px;
  background-color: ${(props)=>props.badgeStyle.backgroundColor};
  color: ${(props)=>props.badgeStyle.color};
  text-wrap: nowrap;
`;
$dfd33cee3229493c$var$$0e049761bcecbff8$var$Badge.propTypes = {
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    badgeStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$14202c65a8343c87$export$2e2bcd8739ae039))
};
$dfd33cee3229493c$var$$0e049761bcecbff8$var$Badge.defaultProps = {
    className: "",
    badgeStyle: $dfd33cee3229493c$var$$14202c65a8343c87$export$2e2bcd8739ae039.DARK_GRAY
};
$dfd33cee3229493c$var$$0e049761bcecbff8$var$Badge.displayName = "Badge";
var /* @component */ $dfd33cee3229493c$var$$0e049761bcecbff8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0e049761bcecbff8$var$Badge;
/**
 * Yuka v2.0
 *
 * @param {object} props
 * @returns {Element}
 */ const $dfd33cee3229493c$var$$5c43562bf1ac9d76$var$BadgeList = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div.attrs({
    className: "badge-list"
})`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  margin: -4px 0 0 -4px;

  > ${$dfd33cee3229493c$var$$0e049761bcecbff8$export$2e2bcd8739ae039} {
    margin: 4px;
    width: auto; // revert width change below
  }
`;
$dfd33cee3229493c$var$$5c43562bf1ac9d76$var$BadgeList.displayName = "BadgeList";
var /* @component */ $dfd33cee3229493c$var$$5c43562bf1ac9d76$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5c43562bf1ac9d76$var$BadgeList;
var $dfd33cee3229493c$var$$5e30a8781de33a30$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ActivityIcon", ()=>$dfd33cee3229493c$var$$3d20c71713f93433$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "AlarmClockIcon", ()=>$dfd33cee3229493c$var$$e6e3e32b8931dc77$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "AlertCircleIcon", ()=>$dfd33cee3229493c$var$$21f83932bf995e14$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "AlertTriangleIcon", ()=>$dfd33cee3229493c$var$$fc98fab14fed9e66$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "AnnouncementIcon", ()=>$dfd33cee3229493c$var$$729c7f0697054745$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArchiveIcon", ()=>$dfd33cee3229493c$var$$a7f98af8e01045dc$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowCircleBrokenDownLeftIcon", ()=>$dfd33cee3229493c$var$$93fcc61574340400$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowCircleBrokenUpRightIcon", ()=>$dfd33cee3229493c$var$$a013cd4f76042243$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowDownLeftIcon", ()=>$dfd33cee3229493c$var$$313cf9fd518e9fbb$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowDownRightIcon", ()=>$dfd33cee3229493c$var$$c676841986381b48$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowDownIcon", ()=>$dfd33cee3229493c$var$$9b205aa1790e85a4$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowLeftIcon", ()=>$dfd33cee3229493c$var$$597e13955d1d36c7$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowRightIcon", ()=>$dfd33cee3229493c$var$$a9c5648b814da0ff$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowUpLeftIcon", ()=>$dfd33cee3229493c$var$$cc22dfe2f0a1a108$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowUpRightIcon", ()=>$dfd33cee3229493c$var$$2fe482f7f4755824$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowUpIcon", ()=>$dfd33cee3229493c$var$$502f458cee51ae7f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowsDownIcon", ()=>$dfd33cee3229493c$var$$73927199061ba6fd$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ArrowsUpIcon", ()=>$dfd33cee3229493c$var$$b14fbf504f20983a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "AtSignIcon", ()=>$dfd33cee3229493c$var$$24ff9bbc80f3de54$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BackspaceIcon", ()=>$dfd33cee3229493c$var$$6dbaa37472eb33b5$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BackwardIcon", ()=>$dfd33cee3229493c$var$$e07c0e04d27ff8a7$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BankIcon", ()=>$dfd33cee3229493c$var$$0d0984a7cc96eb84$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BarChartIcon", ()=>$dfd33cee3229493c$var$$fa2e3dd98b4ea0fa$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BarLineChartIcon", ()=>$dfd33cee3229493c$var$$0c5fecbc78a4424d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BellOffIcon", ()=>$dfd33cee3229493c$var$$45f4829fc2b16890$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BellRingingIcon", ()=>$dfd33cee3229493c$var$$56e4c9fb5e3dc523$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BellIcon", ()=>$dfd33cee3229493c$var$$50e50a968c2c5c02$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BookClosedIcon", ()=>$dfd33cee3229493c$var$$735a5d71965ef559$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BookOpenIcon", ()=>$dfd33cee3229493c$var$$024bee86378197e3$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BookmarkFilledIcon", ()=>$dfd33cee3229493c$var$$9bee1ef65a69ab49$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BookmarkIcon", ()=>$dfd33cee3229493c$var$$7f249b4d1cf7dc29$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BriefcaseIcon", ()=>$dfd33cee3229493c$var$$14afd430cf2d82c2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "BuildingIcon", ()=>$dfd33cee3229493c$var$$17898e4ed1194be2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CalculatorIcon", ()=>$dfd33cee3229493c$var$$e964850d20fc6b87$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CalendarIcon", ()=>$dfd33cee3229493c$var$$5ce412261b038a8e$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CashIcon", ()=>$dfd33cee3229493c$var$$2fe52e0d65c20534$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CertificateIcon", ()=>$dfd33cee3229493c$var$$c11700b54c4cdfb3$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CheckCircleIcon", ()=>$dfd33cee3229493c$var$$b5d06cbafcca8e35$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CheckSquareIcon", ()=>$dfd33cee3229493c$var$$99e6284b7dcff5d4$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CheckIcon", ()=>$dfd33cee3229493c$var$$4ec7b3a9b1d27820$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ChevronDownIcon", ()=>$dfd33cee3229493c$var$$a91646f62d6b2784$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ChevronLeftIcon", ()=>$dfd33cee3229493c$var$$91cd663de23e2605$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ChevronRightIcon", ()=>$dfd33cee3229493c$var$$f9cd72ca6584e2be$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ChevronSelectorIcon", ()=>$dfd33cee3229493c$var$$43f47deccd11679a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ChevronUpIcon", ()=>$dfd33cee3229493c$var$$082f0a59b33f843a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CircleIcon", ()=>$dfd33cee3229493c$var$$cc4df49125c3c0d9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ClipboardIcon", ()=>$dfd33cee3229493c$var$$54ec7b9281c893c0$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ClockIcon", ()=>$dfd33cee3229493c$var$$dd1c1e541c38bb5e$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CodeSnippetIcon", ()=>$dfd33cee3229493c$var$$2a1012ad8c51e960$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CoinsIcon", ()=>$dfd33cee3229493c$var$$0ef015b5d730df8f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ColumnsIcon", ()=>$dfd33cee3229493c$var$$cc0290529cf213df$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CommandIcon", ()=>$dfd33cee3229493c$var$$7b30c932c1359ed0$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CompareArrowsIcon", ()=>$dfd33cee3229493c$var$$964109b4c988d171$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CompassIcon", ()=>$dfd33cee3229493c$var$$f77c7884b5abe8c5$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "Copy03Icon", ()=>$dfd33cee3229493c$var$$63a02c97cadfdcdd$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CornerDownLeftIcon", ()=>$dfd33cee3229493c$var$$967002e0b4faa9b2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CurrencyIcon", ()=>$dfd33cee3229493c$var$$e5e716939e4fbc68$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "CursorIcon", ()=>$dfd33cee3229493c$var$$564791ab830da4b8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "DollarIcon", ()=>$dfd33cee3229493c$var$$b2ea0f3f4ff62475$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "DotpointsIcon", ()=>$dfd33cee3229493c$var$$b1009b85022de90f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "DotsColumnIcon", ()=>$dfd33cee3229493c$var$$3ed1542d8cf6fcbb$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "DotsGridIcon", ()=>$dfd33cee3229493c$var$$eedd861690c5ed79$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "DotsHorizontalIcon", ()=>$dfd33cee3229493c$var$$87e56bf51a2f4dd7$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "DotsVerticalIcon", ()=>$dfd33cee3229493c$var$$cf5d208a3a744514$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "DownloadIcon", ()=>$dfd33cee3229493c$var$$bf297594d23644b4$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "EditIcon", ()=>$dfd33cee3229493c$var$$78647909745e6aa7$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ExchangeIcon", ()=>$dfd33cee3229493c$var$$e3ea11997e722fc9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ExpandIcon", ()=>$dfd33cee3229493c$var$$cf9677abfb23c369$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "EyeOffIcon", ()=>$dfd33cee3229493c$var$$0e0b5de26af5ed5f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "EyeIcon", ()=>$dfd33cee3229493c$var$$f6bdb5fbb8ddc23c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FaceHappyIcon", ()=>$dfd33cee3229493c$var$$9b550ea789a70b83$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FaceIdIcon", ()=>$dfd33cee3229493c$var$$ab57b4a7487e25a5$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FaceSadIcon", ()=>$dfd33cee3229493c$var$$73d4497baea6c8af$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FileAttachmentIcon", ()=>$dfd33cee3229493c$var$$b26edbab562203aa$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FileEmptyIcon", ()=>$dfd33cee3229493c$var$$3b6f340d79ba8d42$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FileLockIcon", ()=>$dfd33cee3229493c$var$$312750c5044f5629$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FilePlusIcon", ()=>$dfd33cee3229493c$var$$c712c8c626b2c48f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FileIcon", ()=>$dfd33cee3229493c$var$$04665d8c3b7e64ff$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FilterIcon", ()=>$dfd33cee3229493c$var$$783c5587828f0531$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FingerprintIcon", ()=>$dfd33cee3229493c$var$$b62fbfb04a46ecd8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FlashIcon", ()=>$dfd33cee3229493c$var$$6c8babbfc3ede4ae$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FolderCheckIcon", ()=>$dfd33cee3229493c$var$$60546b3d725b9d13$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FolderLockIcon", ()=>$dfd33cee3229493c$var$$e5003d188626ebef$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FolderMinusIcon", ()=>$dfd33cee3229493c$var$$847ec600760b4fc2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FolderPlusIcon", ()=>$dfd33cee3229493c$var$$c84b5f1d0f7663c9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FolderShieldIcon", ()=>$dfd33cee3229493c$var$$7e85b93997ca2f4c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FolderIcon", ()=>$dfd33cee3229493c$var$$a87614b715672546$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "FunctionIcon", ()=>$dfd33cee3229493c$var$$af6490b73f4e67e3$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "GlobeIcon", ()=>$dfd33cee3229493c$var$$9ee9cb3908de2775$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "GridIcon", ()=>$dfd33cee3229493c$var$$5967c2124168659e$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "HandIcon", ()=>$dfd33cee3229493c$var$$071fc2a6e61d32b7$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "HashIcon", ()=>$dfd33cee3229493c$var$$078b145b2ca47ae6$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "HeartIcon", ()=>$dfd33cee3229493c$var$$e45010246229a52c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "HelpCircleIcon", ()=>$dfd33cee3229493c$var$$88c382020d5989db$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "HomeIcon", ()=>$dfd33cee3229493c$var$$0b65397d53bc7401$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ImagePlusIcon", ()=>$dfd33cee3229493c$var$$4ed41d502fd4b10f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ImageIcon", ()=>$dfd33cee3229493c$var$$461ac26c4c6cbf7a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "InfoCircleIcon", ()=>$dfd33cee3229493c$var$$8c7a0bab804af32d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "KeyIcon", ()=>$dfd33cee3229493c$var$$04cc33e0010a88fd$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "KeyboardIcon", ()=>$dfd33cee3229493c$var$$8f3877a22db00c15$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LayoutBottomIcon", ()=>$dfd33cee3229493c$var$$8109d312553946dc$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LayoutLeftIcon", ()=>$dfd33cee3229493c$var$$a20a17ce116281c8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LayoutRightIcon", ()=>$dfd33cee3229493c$var$$558d9d9264192066$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LayoutTopIcon", ()=>$dfd33cee3229493c$var$$58a242424c31cbea$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LayoutIcon", ()=>$dfd33cee3229493c$var$$ac5d6a02d4fd7a75$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LeftIndentIcon", ()=>$dfd33cee3229493c$var$$191527481a0c9aee$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LightbulbIcon", ()=>$dfd33cee3229493c$var$$0fe384fe0ace939a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LineChartUpIcon", ()=>$dfd33cee3229493c$var$$30828e1724cf1454$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LineChartIcon", ()=>$dfd33cee3229493c$var$$ce90a2e1bfe9b355$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LinkExternalIcon", ()=>$dfd33cee3229493c$var$$6a017a6b0b6ab383$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LinkIcon", ()=>$dfd33cee3229493c$var$$2305b07e90d9d0db$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ListIcon", ()=>$dfd33cee3229493c$var$$572fb6a1e3f0d886$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LocationIcon", ()=>$dfd33cee3229493c$var$$90af8029d940d5b1$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LockUnlockedIcon", ()=>$dfd33cee3229493c$var$$83aefe9987b5f24b$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LockIcon", ()=>$dfd33cee3229493c$var$$adab9ddd77011d91$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "LogOutIcon", ()=>$dfd33cee3229493c$var$$46616a4c77b270f1$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MailIcon", ()=>$dfd33cee3229493c$var$$cb74b0bb711ee681$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MaximizeIcon", ()=>$dfd33cee3229493c$var$$c2a9407f37216f91$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MedalFirstIcon", ()=>$dfd33cee3229493c$var$$65fb8bc58d7e50c2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MenuIcon", ()=>$dfd33cee3229493c$var$$33f70316b36518ce$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MinimizeIcon", ()=>$dfd33cee3229493c$var$$7d9e027fd6935370$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MinusCircleIcon", ()=>$dfd33cee3229493c$var$$fbe87c02bb0be81b$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MinusIcon", ()=>$dfd33cee3229493c$var$$1717380490155c4f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MoonIcon", ()=>$dfd33cee3229493c$var$$90e541104d06c64e$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MsgChatCirclesIcon", ()=>$dfd33cee3229493c$var$$3f5ab6f404c2853c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MsgCircleIcon", ()=>$dfd33cee3229493c$var$$7964eb7702f2ba10$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MsgDotsCircleIcon", ()=>$dfd33cee3229493c$var$$55ff7b0afa02b54a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MsgDotsSquareIcon", ()=>$dfd33cee3229493c$var$$de02b3469de91eed$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "MsgPlusCircleIcon", ()=>$dfd33cee3229493c$var$$a2f437797616eed8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "NotificationMsgIcon", ()=>$dfd33cee3229493c$var$$0acd9437c449e160$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PaperclipIcon", ()=>$dfd33cee3229493c$var$$e1860d04a60482a5$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PasswordLockIcon", ()=>$dfd33cee3229493c$var$$c745bc4c74d1f069$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PasswordIcon", ()=>$dfd33cee3229493c$var$$e8d23bb6e9de7010$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PencilIcon", ()=>$dfd33cee3229493c$var$$9bb22cf52b7e2cb1$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PercentIcon", ()=>$dfd33cee3229493c$var$$d9737fe2f4c9fce0$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PhoneIcon", ()=>$dfd33cee3229493c$var$$a2ee935c3d91fd2d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PieChartIcon", ()=>$dfd33cee3229493c$var$$ced1a0be0e9c4643$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PinFilledIcon", ()=>$dfd33cee3229493c$var$$efc4065fdc6fcd4a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PinIcon", ()=>$dfd33cee3229493c$var$$99d12cb68ffbb00a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PlusCircleIcon", ()=>$dfd33cee3229493c$var$$e99f01b9ad47095d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PlusIcon", ()=>$dfd33cee3229493c$var$$7c04a01cdc660930$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "PostEditIcon", ()=>$dfd33cee3229493c$var$$ce149b523aa981d8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "RefreshIcon", ()=>$dfd33cee3229493c$var$$d9becaa6c2fa453e$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ReverseLeftIcon", ()=>$dfd33cee3229493c$var$$0391056c70305a6d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ReverseRightIcon", ()=>$dfd33cee3229493c$var$$4e3f3f281bf4a641$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "RowsIcon", ()=>$dfd33cee3229493c$var$$fef902a36f31556a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SaveIcon", ()=>$dfd33cee3229493c$var$$43ac066c7f47d4dd$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ScissorIcon", ()=>$dfd33cee3229493c$var$$44d631dbd3e1fbbd$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SearchIcon", ()=>$dfd33cee3229493c$var$$30232b0a804943c9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SendIcon", ()=>$dfd33cee3229493c$var$$840498a943912e57$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SettingsIcon", ()=>$dfd33cee3229493c$var$$fa2608328c23e411$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ShareIcon", ()=>$dfd33cee3229493c$var$$dd53c1403644759c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SheetIcon", ()=>$dfd33cee3229493c$var$$e4bc726ff1c141fb$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ShieldCheckIcon", ()=>$dfd33cee3229493c$var$$ee0b034933fb5fa2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ShieldOffIcon", ()=>$dfd33cee3229493c$var$$7b34b566e7853278$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ShieldPlusIcon", ()=>$dfd33cee3229493c$var$$66961b15ca10f609$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ShieldIcon", ()=>$dfd33cee3229493c$var$$147df14d628cc88d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SignalIcon", ()=>$dfd33cee3229493c$var$$b7e33483ea5f2267$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SlashCircleIcon", ()=>$dfd33cee3229493c$var$$991a7cae02b2598d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SlashIcon", ()=>$dfd33cee3229493c$var$$32234019b34bf4f6$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SlidersIcon", ()=>$dfd33cee3229493c$var$$57f2b06fd58bbe57$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SortIcon", ()=>$dfd33cee3229493c$var$$3f03f07f1b719193$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SpeedometerIcon", ()=>$dfd33cee3229493c$var$$118dc467b8b60f5d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SquareIcon", ()=>$dfd33cee3229493c$var$$43682b5cb6a1674a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "StarIcon", ()=>$dfd33cee3229493c$var$$5534c0ecbb646332$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "SunIcon", ()=>$dfd33cee3229493c$var$$cfef798d67f41737$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "TargetIcon", ()=>$dfd33cee3229493c$var$$89f870dfc8512ab5$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ThumbsDownIcon", ()=>$dfd33cee3229493c$var$$114d36f778f054e3$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ThumbsUpIcon", ()=>$dfd33cee3229493c$var$$d83713eaceeec7e4$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ToggleLeftIcon", ()=>$dfd33cee3229493c$var$$4f047bd87d52fd7e$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ToggleRightIcon", ()=>$dfd33cee3229493c$var$$a4f9bf3a51d78122$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "ToolIcon", ()=>$dfd33cee3229493c$var$$2dfdce118f498a96$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "TrashIcon", ()=>$dfd33cee3229493c$var$$b22b22e014672977$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "TripleChevronDownIcon", ()=>$dfd33cee3229493c$var$$f6c7f631126d86a9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "TripleChevronUpIcon", ()=>$dfd33cee3229493c$var$$4682c351f3717a32$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "TrophyIcon", ()=>$dfd33cee3229493c$var$$83519f4b734c9fa9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "TypeIcon", ()=>$dfd33cee3229493c$var$$3f5c86e66ed086ac$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "UploadIcon", ()=>$dfd33cee3229493c$var$$37252f54693c4c23$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "UserCircleIcon", ()=>$dfd33cee3229493c$var$$1be94b3ec3f3e84c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "UsersEditIcon", ()=>$dfd33cee3229493c$var$$54933d3b7da008e2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "WifiIcon", ()=>$dfd33cee3229493c$var$$41f086e6a945dc2a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "XCircleIcon", ()=>$dfd33cee3229493c$var$$5186db77bb5db429$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5e30a8781de33a30$exports, "XCloseIcon", ()=>$dfd33cee3229493c$var$$e70e94b576d9ab55$export$2e2bcd8739ae039);
// DO NOT add or modify this file directly.
// Instead, read the instructions in and update the convert_svg_to_jsx.py script
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``activity.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$3d20c71713f93433$var$ActivityIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.75 1.5C7.07282 1.5 7.35943 1.70657 7.46151 2.01283L11.25 13.3783L12.7885 8.76283C12.8906 8.45657 13.1772 8.25 13.5 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H14.0406L11.9615 15.9872C11.8594 16.2934 11.5728 16.5 11.25 16.5C10.9272 16.5 10.6406 16.2934 10.5385 15.9872L6.75 4.62171L5.21151 9.23717C5.10943 9.54343 4.82282 9.75 4.5 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H3.95943L6.03849 2.01283C6.14057 1.70657 6.42718 1.5 6.75 1.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$3d20c71713f93433$var$ActivityIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$3d20c71713f93433$var$ActivityIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$3d20c71713f93433$var$ActivityIcon.displayName = "ActivityIcon";
var $dfd33cee3229493c$var$$3d20c71713f93433$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3d20c71713f93433$var$ActivityIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``alarm-clock.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e6e3e32b8931dc77$var$AlarmClockIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.28033 1.71967C4.57322 2.01256 4.57322 2.48744 4.28033 2.78033L2.03033 5.03033C1.73744 5.32322 1.26256 5.32322 0.96967 5.03033C0.676777 4.73744 0.676777 4.26256 0.96967 3.96967L3.21967 1.71967C3.51256 1.42678 3.98744 1.42678 4.28033 1.71967ZM13.7197 1.71967C14.0126 1.42678 14.4874 1.42678 14.7803 1.71967L17.0303 3.96967C17.3232 4.26256 17.3232 4.73744 17.0303 5.03033C16.7374 5.32322 16.2626 5.32322 15.9697 5.03033L13.7197 2.78033C13.4268 2.48744 13.4268 2.01256 13.7197 1.71967ZM4.22703 4.97703C5.4929 3.71116 7.20979 3 9 3C10.7902 3 12.5071 3.71116 13.773 4.97703C15.0388 6.2429 15.75 7.95979 15.75 9.75C15.75 11.2884 15.2248 12.7727 14.2738 13.9631L15.5303 15.2197C15.8232 15.5126 15.8232 15.9874 15.5303 16.2803C15.2374 16.5732 14.7626 16.5732 14.4697 16.2803L13.2131 15.0238C12.0227 15.9748 10.5384 16.5 9 16.5C7.46159 16.5 5.97733 15.9748 4.7869 15.0238L3.53033 16.2803C3.23744 16.5732 2.76256 16.5732 2.46967 16.2803C2.17678 15.9874 2.17678 15.5126 2.46967 15.2197L3.72624 13.9631C2.77517 12.7727 2.25 11.2884 2.25 9.75C2.25 7.95979 2.96116 6.2429 4.22703 4.97703ZM9 4.5C7.60761 4.5 6.27226 5.05312 5.28769 6.03769C4.30312 7.02226 3.75 8.35761 3.75 9.75C3.75 11.1424 4.30312 12.4777 5.28769 13.4623C6.27226 14.4469 7.60761 15 9 15C10.3924 15 11.7277 14.4469 12.7123 13.4623C13.6969 12.4777 14.25 11.1424 14.25 9.75C14.25 8.35761 13.6969 7.02226 12.7123 6.03769C11.7277 5.05312 10.3924 4.5 9 4.5ZM9 6C9.41421 6 9.75 6.33579 9.75 6.75V9.43934L11.0303 10.7197C11.3232 11.0126 11.3232 11.4874 11.0303 11.7803C10.7374 12.0732 10.2626 12.0732 9.96967 11.7803L8.46967 10.2803C8.32902 10.1397 8.25 9.94891 8.25 9.75V6.75C8.25 6.33579 8.58579 6 9 6Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e6e3e32b8931dc77$var$AlarmClockIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e6e3e32b8931dc77$var$AlarmClockIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e6e3e32b8931dc77$var$AlarmClockIcon.displayName = "AlarmClockIcon";
var $dfd33cee3229493c$var$$e6e3e32b8931dc77$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e6e3e32b8931dc77$var$AlarmClockIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``alert-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$21f83932bf995e14$var$AlertCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9V6C8.25 5.58579 8.58579 5.25 9 5.25ZM8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H9.0075C9.42171 11.25 9.7575 11.5858 9.7575 12C9.7575 12.4142 9.42171 12.75 9.0075 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$21f83932bf995e14$var$AlertCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$21f83932bf995e14$var$AlertCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$21f83932bf995e14$var$AlertCircleIcon.displayName = "AlertCircleIcon";
var $dfd33cee3229493c$var$$21f83932bf995e14$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$21f83932bf995e14$var$AlertCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``alert-triangle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$fc98fab14fed9e66$var$AlertTriangleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "",
                d: "M7.515 2.9175C7.92 2.2125 8.145 1.8225 8.595 1.6275C8.985 1.455 9.4275 1.455 9.81 1.6275C10.2525 1.8225 10.4775 2.2125 10.89 2.9175L17.055 13.575C17.4675 14.28 17.6925 14.67 17.64 15.1575C17.595 15.5775 17.37 15.9675 17.0325 16.215C16.635 16.5 16.185 16.5 15.3675 16.5H3.03C2.2125 16.5 1.7625 16.5 1.365 16.215C1.02 15.9675 0.802497 15.5775 0.757497 15.1575C0.704997 14.67 0.929997 14.28 1.3425 13.575L7.515 2.9175ZM8.805 3.675L2.64 14.325C2.49 14.58 2.34 14.835 2.28 14.985C2.4375 15 2.7375 15 3.03 15H15.3675C15.66 15 15.96 15 16.1175 14.985C16.05 14.8425 15.9 14.58 15.7575 14.325L9.585 3.675C9.4425 3.42 9.285 3.165 9.195 3.0375C9.105 3.1575 8.955 3.42 8.805 3.675ZM9.2025 13.875C8.79 13.875 8.4525 13.5375 8.4525 13.125C8.4525 12.7125 8.7825 12.375 9.2025 12.375H9.21C9.6225 12.375 9.96 12.7125 9.96 13.125C9.96 13.5375 9.6225 13.875 9.2025 13.875ZM9.195 10.875C8.7825 10.875 8.445 10.5375 8.445 10.125V7.125C8.445 6.7125 8.7825 6.375 9.195 6.375C9.6075 6.375 9.945 6.7125 9.945 7.125V10.125C9.945 10.545 9.615 10.875 9.195 10.875Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$fc98fab14fed9e66$var$AlertTriangleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$fc98fab14fed9e66$var$AlertTriangleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$fc98fab14fed9e66$var$AlertTriangleIcon.displayName = "AlertTriangleIcon";
var $dfd33cee3229493c$var$$fc98fab14fed9e66$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$fc98fab14fed9e66$var$AlertTriangleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``announcement.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$729c7f0697054745$var$AnnouncementIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M12.6792 4.03343C12.2738 4.78639 12 5.87808 12 7.125C12 8.37192 12.2738 9.46361 12.6792 10.2166C12.9815 10.778 13.3019 11.0655 13.5758 11.1833L13.9294 11.2476C14.2428 11.2204 14.6725 10.9562 15.0708 10.2166C15.4762 9.46361 15.75 8.37192 15.75 7.125C15.75 5.87808 15.4762 4.78639 15.0708 4.03343C14.6725 3.29376 14.2428 3.02963 13.9294 3.0024L13.5758 3.06669C13.3019 3.18454 12.9815 3.472 12.6792 4.03343ZM11.2742 3.48517C10.7816 4.47605 10.5 5.75581 10.5 7.125C10.5 8.49419 10.7816 9.77395 11.2742 10.7648L4.21682 9.48167C3.47366 9.34655 3.25307 9.2993 3.08866 9.21854C2.70723 9.03118 2.42318 8.69082 2.30707 8.28203C2.25703 8.10583 2.25 7.88035 2.25 7.125C2.25 6.36965 2.25703 6.14417 2.30707 5.96797C2.42318 5.55918 2.70723 5.21882 3.08866 5.03146C3.25307 4.9507 3.47366 4.90345 4.21682 4.76833L11.2742 3.48517ZM13.1581 1.61806L3.94849 3.29252C3.91435 3.29873 3.88069 3.30483 3.8475 3.31085C3.25059 3.41902 2.80442 3.49988 2.42732 3.68512C1.66447 4.05984 1.09636 4.74056 0.864145 5.55814C0.749357 5.96228 0.749615 6.41572 0.749961 7.02236C0.74998 7.05609 0.75 7.0903 0.75 7.125C0.75 7.1597 0.74998 7.19391 0.749961 7.22764C0.749615 7.83428 0.749357 8.28772 0.864145 8.69186C1.09636 9.50944 1.66447 10.1902 2.42733 10.5649C2.60571 10.6525 2.79955 10.7168 3.01749 10.7716L3.29892 14.7117C3.31152 14.8883 3.32387 15.0616 3.34609 15.2083C3.37064 15.3703 3.41467 15.5591 3.52247 15.7468C3.67291 16.0089 3.89899 16.2194 4.1711 16.3508C4.36607 16.4449 4.55749 16.4754 4.72085 16.4883C4.86873 16.5 5.04245 16.5 5.21956 16.5H6.60429C6.80757 16.5 7.00392 16.5 7.16923 16.4861C7.34944 16.471 7.56392 16.4351 7.77668 16.3205C8.0694 16.1627 8.30142 15.9122 8.43625 15.6082C8.53425 15.3873 8.55354 15.1707 8.55484 14.9898C8.55603 14.824 8.54095 14.6282 8.52533 14.4255L8.31969 11.7522L13.1581 12.6319C13.3828 12.708 13.622 12.75 13.875 12.75C15.008 12.75 15.8633 11.9086 16.3915 10.9277C16.9361 9.91627 17.25 8.57047 17.25 7.125C17.25 5.67953 16.9361 4.33373 16.3915 3.32228C15.8633 2.34138 15.008 1.5 13.875 1.5C13.622 1.5 13.3828 1.54196 13.1581 1.61806ZM6.79392 11.4748L4.5423 11.0654L4.79349 14.5821C4.80836 14.7903 4.81696 14.903 4.82917 14.9836C4.82963 14.9866 4.83009 14.9895 4.83053 14.9923C4.83329 14.9925 4.83622 14.9928 4.8393 14.993C4.92058 14.9995 5.03356 15 5.24234 15H6.57915C6.81705 15 6.94887 14.9994 7.04346 14.9914C7.04743 14.9911 7.05119 14.9907 7.05473 14.9904C7.0548 14.9869 7.05485 14.9831 7.05488 14.9791C7.05556 14.8842 7.04607 14.7527 7.02782 14.5155L6.79392 11.4748Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$729c7f0697054745$var$AnnouncementIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$729c7f0697054745$var$AnnouncementIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$729c7f0697054745$var$AnnouncementIcon.displayName = "AnnouncementIcon";
var $dfd33cee3229493c$var$$729c7f0697054745$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$729c7f0697054745$var$AnnouncementIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``archive.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a7f98af8e01045dc$var$ArchiveIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.31209 1.49997C3.33285 1.49999 3.35382 1.5 3.375 1.5H14.625C14.6462 1.5 14.6672 1.49999 14.6879 1.49997C14.9734 1.49974 15.2193 1.49955 15.439 1.54324C16.3315 1.72078 17.0292 2.4185 17.2068 3.31105C17.2505 3.53069 17.2503 3.77657 17.25 4.0621C17.25 4.08286 17.25 4.10382 17.25 4.125C17.25 4.14619 17.25 4.16715 17.25 4.18791C17.2503 4.47344 17.2505 4.71931 17.2068 4.93896C17.0504 5.72486 16.4908 6.35971 15.75 6.62141V12.181C15.75 12.7847 15.75 13.283 15.7169 13.6889C15.6824 14.1104 15.6085 14.498 15.423 14.862C15.1354 15.4265 14.6765 15.8854 14.112 16.173C13.748 16.3585 13.3604 16.4324 12.9389 16.4669C12.533 16.5 12.0347 16.5 11.431 16.5H6.56901C5.96529 16.5 5.46703 16.5 5.06113 16.4669C4.63956 16.4324 4.25203 16.3585 3.88803 16.173C3.32355 15.8854 2.8646 15.4265 2.57698 14.862C2.39152 14.498 2.31759 14.1104 2.28315 13.6889C2.24999 13.283 2.24999 12.7847 2.25 12.181L2.25 6.62141C1.50919 6.35971 0.949564 5.72486 0.793238 4.93896C0.749548 4.71932 0.749744 4.47344 0.749971 4.18792C0.749988 4.16716 0.750004 4.14619 0.750004 4.125C0.750004 4.10382 0.749988 4.08285 0.749971 4.06209C0.749744 3.77657 0.749548 3.53069 0.793238 3.31105C0.970778 2.4185 1.6685 1.72078 2.56105 1.54324C2.78069 1.49955 3.02657 1.49974 3.31209 1.49997ZM3.75 6.75V12.15C3.75 12.7924 3.75059 13.2292 3.77817 13.5667C3.80503 13.8955 3.85373 14.0637 3.91349 14.181C4.0573 14.4632 4.28678 14.6927 4.56902 14.8365C4.68632 14.8963 4.85447 14.945 5.18328 14.9718C5.52085 14.9994 5.95757 15 6.6 15H11.4C12.0424 15 12.4792 14.9994 12.8167 14.9718C13.1455 14.945 13.3137 14.8963 13.431 14.8365C13.7132 14.6927 13.9427 14.4632 14.0865 14.181C14.1463 14.0637 14.195 13.8955 14.2218 13.5667C14.2494 13.2292 14.25 12.7924 14.25 12.15V6.75H3.75ZM14.9379 5.25H3.0621C3.04796 5.24884 3.03371 5.24807 3.01935 5.2477C2.91169 5.24492 2.87193 5.23922 2.85369 5.23559C2.55617 5.17641 2.3236 4.94384 2.26442 4.64632C2.25364 4.59214 2.25 4.50944 2.25 4.125C2.25 3.74057 2.25364 3.65787 2.26442 3.60369C2.3236 3.30617 2.55617 3.0736 2.85369 3.01442C2.90787 3.00364 2.99057 3 3.375 3H14.625C15.0094 3 15.0921 3.00364 15.1463 3.01442C15.4438 3.0736 15.6764 3.30617 15.7356 3.60369C15.7464 3.65787 15.75 3.74057 15.75 4.125C15.75 4.50944 15.7464 4.59214 15.7356 4.64632C15.6764 4.94384 15.4438 5.17641 15.1463 5.23559C15.1281 5.23922 15.0883 5.24492 14.9807 5.2477C14.9663 5.24807 14.9521 5.24884 14.9379 5.25ZM6.75 9.75C6.75 9.33579 7.08579 9 7.5 9H10.5C10.9142 9 11.25 9.33579 11.25 9.75C11.25 10.1642 10.9142 10.5 10.5 10.5H7.5C7.08579 10.5 6.75 10.1642 6.75 9.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a7f98af8e01045dc$var$ArchiveIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a7f98af8e01045dc$var$ArchiveIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a7f98af8e01045dc$var$ArchiveIcon.displayName = "ArchiveIcon";
var $dfd33cee3229493c$var$$a7f98af8e01045dc$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a7f98af8e01045dc$var$ArchiveIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-circle-broken-down-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$93fcc61574340400$var$ArrowCircleBrokenDownLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M10.7486 2.47918C8.49453 1.87722 5.993 2.46106 4.227 4.22707C1.59096 6.86311 1.59096 11.137 4.227 13.773C6.86304 16.409 11.1369 16.409 13.7729 13.773C15.5389 12.007 16.1228 9.50548 15.5208 7.25138C15.414 6.85119 15.6517 6.44014 16.0519 6.33327C16.4521 6.2264 16.8632 6.46418 16.97 6.86437C17.7045 9.61452 16.9935 12.6737 14.8336 14.8337C11.6118 18.0555 6.38816 18.0555 3.16634 14.8337C-0.0554865 11.6118 -0.055487 6.38823 3.16634 3.16641C5.32627 1.00647 8.38549 0.295535 11.1356 1.02997C11.5358 1.13684 11.7736 1.54789 11.6667 1.94808C11.5599 2.34827 11.1488 2.58605 10.7486 2.47918ZM14.7803 3.21966C15.0732 3.51255 15.0732 3.98743 14.7803 4.28032L8.56078 10.5H11.2501C11.6644 10.5 12.0001 10.8358 12.0001 11.25C12.0001 11.6643 11.6644 12 11.2501 12H6.75015C6.33593 12 6.00015 11.6643 6.00015 11.25V6.75004C6.00015 6.33583 6.33593 6.00004 6.75015 6.00004C7.16436 6.00004 7.50015 6.33583 7.50015 6.75004V9.43935L13.7197 3.21968C14.0126 2.92678 14.4874 2.92677 14.7803 3.21966Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$93fcc61574340400$var$ArrowCircleBrokenDownLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$93fcc61574340400$var$ArrowCircleBrokenDownLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$93fcc61574340400$var$ArrowCircleBrokenDownLeftIcon.displayName = "ArrowCircleBrokenDownLeftIcon";
var $dfd33cee3229493c$var$$93fcc61574340400$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$93fcc61574340400$var$ArrowCircleBrokenDownLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-circle-broken-up-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a013cd4f76042243$var$ArrowCircleBrokenUpRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M13.773 4.22699C11.137 1.59095 6.86309 1.59095 4.22705 4.22699C2.46105 5.993 1.87721 8.49452 2.47916 10.7486C2.58604 11.1488 2.34825 11.5599 1.94806 11.6667C1.54787 11.7736 1.13682 11.5358 1.02995 11.1356C0.29552 8.38548 1.00646 5.32627 3.16639 3.16633C6.38822 -0.0554945 11.6118 -0.0554947 14.8337 3.16633C18.0555 6.38816 18.0555 11.6118 14.8337 14.8336C12.6737 16.9935 9.61451 17.7045 6.86435 16.97C6.46416 16.8632 6.22638 16.4521 6.33325 16.0519C6.44012 15.6517 6.85118 15.4139 7.25137 15.5208C9.50546 16.1228 12.007 15.5389 13.773 13.7729C16.409 11.1369 16.409 6.86303 13.773 4.22699ZM6.00012 6.75004C6.00012 6.33583 6.33591 6.00004 6.75012 6.00004H11.2501C11.6643 6.00004 12.0001 6.33583 12.0001 6.75004V11.25C12.0001 11.6643 11.6643 12 11.2501 12C10.8359 12 10.5001 11.6643 10.5001 11.25V8.56067L4.28031 14.7803C3.98741 15.0732 3.51254 15.0732 3.21965 14.7803C2.92676 14.4874 2.92676 14.0126 3.21966 13.7197L9.43944 7.50004H6.75012C6.33591 7.50004 6.00012 7.16425 6.00012 6.75004Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a013cd4f76042243$var$ArrowCircleBrokenUpRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a013cd4f76042243$var$ArrowCircleBrokenUpRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a013cd4f76042243$var$ArrowCircleBrokenUpRightIcon.displayName = "ArrowCircleBrokenUpRightIcon";
var $dfd33cee3229493c$var$$a013cd4f76042243$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a013cd4f76042243$var$ArrowCircleBrokenUpRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-down-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$313cf9fd518e9fbb$var$ArrowDownLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.25 4.5C5.66421 4.5 6 4.83579 6 5.25V10.9393L12.2197 4.71967C12.5126 4.42678 12.9874 4.42678 13.2803 4.71967C13.5732 5.01256 13.5732 5.48744 13.2803 5.78033L7.06066 12H12.75C13.1642 12 13.5 12.3358 13.5 12.75C13.5 13.1642 13.1642 13.5 12.75 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75V5.25C4.5 4.83579 4.83579 4.5 5.25 4.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$313cf9fd518e9fbb$var$ArrowDownLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$313cf9fd518e9fbb$var$ArrowDownLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$313cf9fd518e9fbb$var$ArrowDownLeftIcon.displayName = "ArrowDownLeftIcon";
var $dfd33cee3229493c$var$$313cf9fd518e9fbb$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$313cf9fd518e9fbb$var$ArrowDownLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-down-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$c676841986381b48$var$ArrowDownRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L12 10.9393V5.25C12 4.83579 12.3358 4.5 12.75 4.5C13.1642 4.5 13.5 4.83579 13.5 5.25V12.75C13.5 13.1642 13.1642 13.5 12.75 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H10.9393L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$c676841986381b48$var$ArrowDownRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$c676841986381b48$var$ArrowDownRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$c676841986381b48$var$ArrowDownRightIcon.displayName = "ArrowDownRightIcon";
var $dfd33cee3229493c$var$$c676841986381b48$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c676841986381b48$var$ArrowDownRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-down.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$9b205aa1790e85a4$var$ArrowDownIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 3C9.41421 3 9.75 3.33579 9.75 3.75V12.4393L13.7197 8.46967C14.0126 8.17678 14.4874 8.17678 14.7803 8.46967C15.0732 8.76256 15.0732 9.23744 14.7803 9.53033L9.53033 14.7803C9.23744 15.0732 8.76256 15.0732 8.46967 14.7803L3.21967 9.53033C2.92678 9.23744 2.92678 8.76256 3.21967 8.46967C3.51256 8.17678 3.98744 8.17678 4.28033 8.46967L8.25 12.4393V3.75C8.25 3.33579 8.58579 3 9 3Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$9b205aa1790e85a4$var$ArrowDownIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$9b205aa1790e85a4$var$ArrowDownIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$9b205aa1790e85a4$var$ArrowDownIcon.displayName = "ArrowDownIcon";
var $dfd33cee3229493c$var$$9b205aa1790e85a4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9b205aa1790e85a4$var$ArrowDownIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$597e13955d1d36c7$var$ArrowLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9.53033 3.21967C9.82322 3.51256 9.82322 3.98744 9.53033 4.28033L5.56066 8.25H14.25C14.6642 8.25 15 8.58579 15 9C15 9.41421 14.6642 9.75 14.25 9.75H5.56066L9.53033 13.7197C9.82322 14.0126 9.82322 14.4874 9.53033 14.7803C9.23744 15.0732 8.76256 15.0732 8.46967 14.7803L3.21967 9.53033C2.92678 9.23744 2.92678 8.76256 3.21967 8.46967L8.46967 3.21967C8.76256 2.92678 9.23744 2.92678 9.53033 3.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$597e13955d1d36c7$var$ArrowLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$597e13955d1d36c7$var$ArrowLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$597e13955d1d36c7$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $dfd33cee3229493c$var$$597e13955d1d36c7$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$597e13955d1d36c7$var$ArrowLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a9c5648b814da0ff$var$ArrowRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.46967 3.21967C8.76256 2.92678 9.23744 2.92678 9.53033 3.21967L14.7803 8.46967C15.0732 8.76256 15.0732 9.23744 14.7803 9.53033L9.53033 14.7803C9.23744 15.0732 8.76256 15.0732 8.46967 14.7803C8.17678 14.4874 8.17678 14.0126 8.46967 13.7197L12.4393 9.75H3.75C3.33579 9.75 3 9.41421 3 9C3 8.58579 3.33579 8.25 3.75 8.25H12.4393L8.46967 4.28033C8.17678 3.98744 8.17678 3.51256 8.46967 3.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a9c5648b814da0ff$var$ArrowRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a9c5648b814da0ff$var$ArrowRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a9c5648b814da0ff$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $dfd33cee3229493c$var$$a9c5648b814da0ff$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a9c5648b814da0ff$var$ArrowRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-up-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$cc22dfe2f0a1a108$var$ArrowUpLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.5 5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H12.75C13.1642 4.5 13.5 4.83579 13.5 5.25C13.5 5.66421 13.1642 6 12.75 6H7.06066L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L6 7.06066V12.75C6 13.1642 5.66421 13.5 5.25 13.5C4.83579 13.5 4.5 13.1642 4.5 12.75V5.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$cc22dfe2f0a1a108$var$ArrowUpLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cc22dfe2f0a1a108$var$ArrowUpLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$cc22dfe2f0a1a108$var$ArrowUpLeftIcon.displayName = "ArrowUpLeftIcon";
var $dfd33cee3229493c$var$$cc22dfe2f0a1a108$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cc22dfe2f0a1a108$var$ArrowUpLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-up-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$2fe482f7f4755824$var$ArrowUpRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.25 6C4.83579 6 4.5 5.66421 4.5 5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H12.75C13.1642 4.5 13.5 4.83579 13.5 5.25V12.75C13.5 13.1642 13.1642 13.5 12.75 13.5C12.3358 13.5 12 13.1642 12 12.75V7.06066L5.78033 13.2803C5.48744 13.5732 5.01256 13.5732 4.71967 13.2803C4.42678 12.9874 4.42678 12.5126 4.71967 12.2197L10.9393 6H5.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$2fe482f7f4755824$var$ArrowUpRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$2fe482f7f4755824$var$ArrowUpRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$2fe482f7f4755824$var$ArrowUpRightIcon.displayName = "ArrowUpRightIcon";
var $dfd33cee3229493c$var$$2fe482f7f4755824$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2fe482f7f4755824$var$ArrowUpRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrow-up.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$502f458cee51ae7f$var$ArrowUpIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.46967 3.21967C8.76256 2.92678 9.23744 2.92678 9.53033 3.21967L14.7803 8.46967C15.0732 8.76256 15.0732 9.23744 14.7803 9.53033C14.4874 9.82322 14.0126 9.82322 13.7197 9.53033L9.75 5.56066V14.25C9.75 14.6642 9.41421 15 9 15C8.58579 15 8.25 14.6642 8.25 14.25V5.56066L4.28033 9.53033C3.98744 9.82322 3.51256 9.82322 3.21967 9.53033C2.92678 9.23744 2.92678 8.76256 3.21967 8.46967L8.46967 3.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$502f458cee51ae7f$var$ArrowUpIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$502f458cee51ae7f$var$ArrowUpIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$502f458cee51ae7f$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $dfd33cee3229493c$var$$502f458cee51ae7f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$502f458cee51ae7f$var$ArrowUpIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrows-down.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$73927199061ba6fd$var$ArrowsDownIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.25 2.25C5.66421 2.25 6 2.58579 6 3V13.1893L7.71967 11.4697C8.01256 11.1768 8.48744 11.1768 8.78033 11.4697C9.07322 11.7626 9.07322 12.2374 8.78033 12.5303L5.78033 15.5303C5.48744 15.8232 5.01256 15.8232 4.71967 15.5303L1.71967 12.5303C1.42678 12.2374 1.42678 11.7626 1.71967 11.4697C2.01256 11.1768 2.48744 11.1768 2.78033 11.4697L4.5 13.1893V3C4.5 2.58579 4.83579 2.25 5.25 2.25ZM12.75 2.25C13.1642 2.25 13.5 2.58579 13.5 3V9.43934L15.2197 7.71967C15.5126 7.42678 15.9874 7.42678 16.2803 7.71967C16.5732 8.01256 16.5732 8.48744 16.2803 8.78033L13.2803 11.7803C12.9874 12.0732 12.5126 12.0732 12.2197 11.7803L9.21967 8.78033C8.92678 8.48744 8.92678 8.01256 9.21967 7.71967C9.51256 7.42678 9.98744 7.42678 10.2803 7.71967L12 9.43934V3C12 2.58579 12.3358 2.25 12.75 2.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$73927199061ba6fd$var$ArrowsDownIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$73927199061ba6fd$var$ArrowsDownIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$73927199061ba6fd$var$ArrowsDownIcon.displayName = "ArrowsDownIcon";
var $dfd33cee3229493c$var$$73927199061ba6fd$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$73927199061ba6fd$var$ArrowsDownIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``arrows-up.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b14fbf504f20983a$var$ArrowsUpIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.71967 2.46967C5.01256 2.17678 5.48744 2.17678 5.78033 2.46967L8.78033 5.46967C9.07322 5.76256 9.07322 6.23744 8.78033 6.53033C8.48744 6.82322 8.01256 6.82322 7.71967 6.53033L6 4.81066V15C6 15.4142 5.66421 15.75 5.25 15.75C4.83579 15.75 4.5 15.4142 4.5 15V4.81066L2.78033 6.53033C2.48744 6.82322 2.01256 6.82322 1.71967 6.53033C1.42678 6.23744 1.42678 5.76256 1.71967 5.46967L4.71967 2.46967ZM12.2197 6.21967C12.5126 5.92678 12.9874 5.92678 13.2803 6.21967L16.2803 9.21967C16.5732 9.51256 16.5732 9.98744 16.2803 10.2803C15.9874 10.5732 15.5126 10.5732 15.2197 10.2803L13.5 8.56066V15C13.5 15.4142 13.1642 15.75 12.75 15.75C12.3358 15.75 12 15.4142 12 15V8.56066L10.2803 10.2803C9.98744 10.5732 9.51256 10.5732 9.21967 10.2803C8.92678 9.98744 8.92678 9.51256 9.21967 9.21967L12.2197 6.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b14fbf504f20983a$var$ArrowsUpIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b14fbf504f20983a$var$ArrowsUpIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b14fbf504f20983a$var$ArrowsUpIcon.displayName = "ArrowsUpIcon";
var $dfd33cee3229493c$var$$b14fbf504f20983a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b14fbf504f20983a$var$ArrowsUpIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``at-sign.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$24ff9bbc80f3de54$var$AtSignIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.47507 1.54142C7.15855 0.745855 9.06166 0.543176 10.8749 0.966341C12.6882 1.38951 14.305 2.41363 15.4625 3.87218C16.6199 5.33074 17.2499 7.13794 17.25 8.99994V9.74999C17.25 10.5456 16.9339 11.3087 16.3713 11.8713C15.8087 12.4339 15.0457 12.75 14.25 12.75C13.4544 12.75 12.6913 12.4339 12.1287 11.8713C12.0096 11.7522 11.9016 11.6242 11.8052 11.4887C11.1183 12.2624 10.1161 12.75 9.00001 12.75C6.92894 12.75 5.25001 11.0711 5.25001 8.99999C5.25001 6.92892 6.92894 5.24999 9.00001 5.24999C9.84421 5.24999 10.6233 5.52895 11.25 5.99972C11.2502 5.58563 11.5859 5.24999 12 5.24999C12.4142 5.24999 12.75 5.58578 12.75 5.99999V9.74999C12.75 10.1478 12.908 10.5293 13.1893 10.8107C13.4707 11.092 13.8522 11.25 14.25 11.25C14.6478 11.25 15.0294 11.092 15.3107 10.8107C15.592 10.5293 15.75 10.1478 15.75 9.74999V9.00004C15.75 9.00002 15.75 9.00006 15.75 9.00004C15.7499 7.4766 15.2345 5.99795 14.2875 4.8046C13.3405 3.61124 12.0176 2.77332 10.534 2.42709C9.05045 2.08086 7.49336 2.24669 6.11597 2.89761C4.73857 3.54853 3.62188 4.64626 2.94746 6.0123C2.27304 7.37835 2.08056 8.93236 2.40132 10.4217C2.72208 11.911 3.53722 13.248 4.71418 14.2153C5.89115 15.1826 7.36072 15.7233 8.88396 15.7495C10.4072 15.7757 11.8945 15.2858 13.104 14.3595C13.4329 14.1077 13.9036 14.1701 14.1555 14.499C14.4073 14.8279 14.3449 15.2986 14.016 15.5504C12.5377 16.6825 10.7199 17.2813 8.85817 17.2492C6.99644 17.2172 5.20029 16.5564 3.76178 15.3741C2.32326 14.1919 1.32699 12.5577 0.934946 10.7375C0.542905 8.91723 0.778155 7.01788 1.60245 5.34827C2.42674 3.67866 3.79159 2.33699 5.47507 1.54142ZM11.25 8.99999C11.25 7.75735 10.2427 6.74999 9.00001 6.74999C7.75737 6.74999 6.75001 7.75735 6.75001 8.99999C6.75001 10.2426 7.75737 11.25 9.00001 11.25C10.2426 11.25 11.25 10.2426 11.25 8.99999Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$24ff9bbc80f3de54$var$AtSignIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$24ff9bbc80f3de54$var$AtSignIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$24ff9bbc80f3de54$var$AtSignIcon.displayName = "AtSignIcon";
var $dfd33cee3229493c$var$$24ff9bbc80f3de54$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$24ff9bbc80f3de54$var$AtSignIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``backspace.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$6dbaa37472eb33b5$var$BackspaceIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.12456 2.24993C7.1495 2.24996 7.17465 2.24999 7.2 2.24999L12.931 2.24999C13.5347 2.24998 14.033 2.24997 14.4389 2.28313C14.8604 2.31758 15.248 2.3915 15.612 2.57697C16.1765 2.86459 16.6354 3.32353 16.923 3.88802C17.1085 4.25202 17.1824 4.63954 17.2169 5.06112C17.25 5.46701 17.25 5.96527 17.25 6.56899V11.431C17.25 12.0347 17.25 12.533 17.2169 12.9389C17.1824 13.3604 17.1085 13.748 16.923 14.112C16.6354 14.6764 16.1765 15.1354 15.612 15.423C15.248 15.6085 14.8604 15.6824 14.4389 15.7168C14.033 15.75 13.5347 15.75 12.931 15.75H7.2C7.17465 15.75 7.1495 15.75 7.12456 15.75C6.75946 15.7504 6.43785 15.7508 6.13212 15.6635C5.86385 15.5869 5.61218 15.461 5.38993 15.2924C5.13664 15.1002 4.94396 14.8427 4.72522 14.5504C4.71028 14.5304 4.69521 14.5103 4.68 14.49L1.44 10.17C1.42665 10.1522 1.41284 10.1339 1.39868 10.1152C1.2499 9.91868 1.06337 9.67225 0.986917 9.38184C0.921028 9.13153 0.921028 8.86844 0.986917 8.61814C1.06337 8.32772 1.2499 8.08129 1.39868 7.88474C1.41284 7.86604 1.42665 7.84778 1.44 7.82999L4.68 3.50999C4.69521 3.4897 4.71028 3.46957 4.72522 3.4496C4.94396 3.15728 5.13664 2.89978 5.38993 2.70758C5.61218 2.53894 5.86385 2.4131 6.13212 2.33649C6.43785 2.24918 6.75946 2.24953 7.12456 2.24993ZM7.2 3.74999C6.71653 3.74999 6.62127 3.75676 6.54404 3.77882C6.45462 3.80436 6.37073 3.8463 6.29664 3.90252C6.23266 3.95107 6.17008 4.02321 5.88 4.40999L2.64 8.72999C2.53692 8.86743 2.48312 8.93989 2.44771 8.99476C2.44654 8.99659 2.44542 8.99832 2.44437 8.99998C2.44542 9.00164 2.44654 9.00339 2.44771 9.00521C2.48312 9.06009 2.53692 9.13255 2.64 9.26999L5.88 13.59C6.17008 13.9768 6.23266 14.0489 6.29664 14.0975C6.37073 14.1537 6.45462 14.1956 6.54404 14.2212C6.62127 14.2432 6.71653 14.25 7.2 14.25H12.9C13.5424 14.25 13.9792 14.2494 14.3167 14.2218C14.6455 14.195 14.8137 14.1463 14.931 14.0865C15.2132 13.9427 15.4427 13.7132 15.5865 13.431C15.6463 13.3137 15.695 13.1455 15.7218 12.8167C15.7494 12.4791 15.75 12.0424 15.75 11.4V6.59999C15.75 5.95755 15.7494 5.52083 15.7218 5.18327C15.695 4.85445 15.6463 4.6863 15.5865 4.569C15.4427 4.28676 15.2132 4.05729 14.931 3.91348C14.8137 3.85371 14.6455 3.80502 14.3167 3.77815C13.9792 3.75057 13.5424 3.74999 12.9 3.74999H7.2ZM7.71967 6.21966C8.01256 5.92676 8.48744 5.92676 8.78033 6.21966L10.5 7.93933L12.2197 6.21966C12.5126 5.92676 12.9874 5.92676 13.2803 6.21966C13.5732 6.51255 13.5732 6.98742 13.2803 7.28032L11.5607 8.99999L13.2803 10.7197C13.5732 11.0125 13.5732 11.4874 13.2803 11.7803C12.9874 12.0732 12.5126 12.0732 12.2197 11.7803L10.5 10.0606L8.78033 11.7803C8.48744 12.0732 8.01256 12.0732 7.71967 11.7803C7.42678 11.4874 7.42678 11.0125 7.71967 10.7197L9.43934 8.99999L7.71967 7.28032C7.42678 6.98742 7.42678 6.51255 7.71967 6.21966Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$6dbaa37472eb33b5$var$BackspaceIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$6dbaa37472eb33b5$var$BackspaceIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$6dbaa37472eb33b5$var$BackspaceIcon.displayName = "BackspaceIcon";
var $dfd33cee3229493c$var$$6dbaa37472eb33b5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6dbaa37472eb33b5$var$BackspaceIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``backward.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e07c0e04d27ff8a7$var$BackwardIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.78033 3.21967C6.07322 3.51256 6.07322 3.98744 5.78033 4.28033L4.06066 6H12.375C14.6532 6 16.5 7.84683 16.5 10.125C16.5 12.4032 14.6532 14.25 12.375 14.25H9C8.58579 14.25 8.25 13.9142 8.25 13.5C8.25 13.0858 8.58579 12.75 9 12.75H12.375C13.8247 12.75 15 11.5747 15 10.125C15 8.67525 13.8247 7.5 12.375 7.5H4.06066L5.78033 9.21967C6.07322 9.51256 6.07322 9.98744 5.78033 10.2803C5.48744 10.5732 5.01256 10.5732 4.71967 10.2803L1.71967 7.28033C1.42678 6.98744 1.42678 6.51256 1.71967 6.21967L4.71967 3.21967C5.01256 2.92678 5.48744 2.92678 5.78033 3.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e07c0e04d27ff8a7$var$BackwardIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e07c0e04d27ff8a7$var$BackwardIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e07c0e04d27ff8a7$var$BackwardIcon.displayName = "BackwardIcon";
var $dfd33cee3229493c$var$$e07c0e04d27ff8a7$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e07c0e04d27ff8a7$var$BackwardIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bank.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0d0984a7cc96eb84$var$BankIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.75072 0.845181C8.91481 0.807893 9.08519 0.807893 9.24928 0.845181C9.44415 0.889463 9.61213 0.996793 9.69312 1.04854C9.70154 1.05392 9.70902 1.0587 9.7155 1.06275L15.3975 4.614C15.6812 4.79133 15.8132 5.13514 15.7209 5.45676C15.6287 5.77838 15.3346 6 15 6H3C2.66542 6 2.3713 5.77838 2.27906 5.45676C2.18682 5.13514 2.31878 4.79133 2.6025 4.614L8.2845 1.06275C8.29098 1.0587 8.29846 1.05392 8.30688 1.04854C8.38787 0.996793 8.55584 0.889463 8.75072 0.845181ZM9 2.38443L5.6151 4.5H12.3849L9 2.38443ZM4.5 6.75C4.91421 6.75 5.25 7.08578 5.25 7.5V13.5C5.25 13.9142 4.91421 14.25 4.5 14.25C4.08579 14.25 3.75 13.9142 3.75 13.5V7.5C3.75 7.08578 4.08579 6.75 4.5 6.75ZM7.5 6.75C7.91421 6.75 8.25 7.08578 8.25 7.5V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V7.5C6.75 7.08578 7.08579 6.75 7.5 6.75ZM10.5 6.75C10.9142 6.75 11.25 7.08578 11.25 7.5V13.5C11.25 13.9142 10.9142 14.25 10.5 14.25C10.0858 14.25 9.75 13.9142 9.75 13.5V7.5C9.75 7.08578 10.0858 6.75 10.5 6.75ZM13.5 6.75C13.9142 6.75 14.25 7.08578 14.25 7.5V13.5C14.25 13.9142 13.9142 14.25 13.5 14.25C13.0858 14.25 12.75 13.9142 12.75 13.5V7.5C12.75 7.08578 13.0858 6.75 13.5 6.75ZM1.5 15.75C1.5 15.3358 1.83579 15 2.25 15H15.75C16.1642 15 16.5 15.3358 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0d0984a7cc96eb84$var$BankIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0d0984a7cc96eb84$var$BankIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0d0984a7cc96eb84$var$BankIcon.displayName = "BankIcon";
var $dfd33cee3229493c$var$$0d0984a7cc96eb84$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0d0984a7cc96eb84$var$BankIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bar-chart.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$fa2e3dd98b4ea0fa$var$BarChartIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M10.4815 3.00773C10.3941 3.00059 10.2724 3 10.05 3H7.95C7.7276 3 7.60591 3.00059 7.51848 3.00773C7.51499 3.00802 7.5117 3.0083 7.50859 3.00859C7.5083 3.0117 7.50801 3.015 7.50773 3.01848C7.50058 3.10592 7.5 3.22761 7.5 3.45V5.24921C7.5 5.24948 7.5 5.24974 7.5 5.25C7.5 5.25027 7.5 5.25053 7.5 5.2508V15H10.5V3.45C10.5 3.22761 10.4994 3.10592 10.4923 3.01848C10.492 3.015 10.4917 3.0117 10.4914 3.00859C10.4883 3.0083 10.485 3.00802 10.4815 3.00773ZM12 7.5L12 3.42607C12 3.23679 12 3.05245 11.9873 2.89633C11.9733 2.72489 11.9402 2.52259 11.8365 2.31902C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.9774 1.55977 10.7751 1.52672 10.6037 1.51271C10.4476 1.49996 10.2632 1.49998 10.0739 1.5L7.92608 1.5C7.73679 1.49998 7.55245 1.49996 7.39633 1.51271C7.22488 1.52672 7.02258 1.55977 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31902C6.05977 2.52259 6.02672 2.72489 6.01271 2.89633C5.99995 3.05245 5.99998 3.23679 6 3.42608C6 3.43405 6 3.44202 6 3.45V4.5H3.45C3.44202 4.5 3.43404 4.5 3.42608 4.5C3.23679 4.49998 3.05245 4.49996 2.89633 4.51271C2.72488 4.52672 2.52258 4.55977 2.31901 4.66349C2.03677 4.8073 1.8073 5.03678 1.66349 5.31902C1.55977 5.52259 1.52672 5.72489 1.51271 5.89633C1.49995 6.05245 1.49998 6.23679 1.5 6.42608C1.5 6.43405 1.5 6.44202 1.5 6.45L1.5 14.5739C1.49998 14.7632 1.49995 14.9476 1.51271 15.1037C1.52672 15.2751 1.55977 15.4774 1.66349 15.681C1.8073 15.9632 2.03677 16.1927 2.31902 16.3365C2.52258 16.4402 2.72488 16.4733 2.89633 16.4873C3.05244 16.5001 3.23678 16.5 3.42606 16.5H14.5739C14.7632 16.5 14.9476 16.5001 15.1037 16.4873C15.2751 16.4733 15.4774 16.4402 15.681 16.3365C15.9632 16.1927 16.1927 15.9632 16.3365 15.681C16.4402 15.4774 16.4733 15.2751 16.4873 15.1037C16.5 14.9476 16.5 14.7632 16.5 14.5739V9.42607C16.5 9.23678 16.5 9.05245 16.4873 8.89633C16.4733 8.72489 16.4402 8.52259 16.3365 8.31902C16.1927 8.03677 15.9632 7.8073 15.681 7.66349C15.4774 7.55977 15.2751 7.52672 15.1037 7.51271C14.9476 7.49996 14.7632 7.49998 14.5739 7.5L12 7.5ZM12 9V15H14.55C14.7724 15 14.8941 14.9994 14.9815 14.9923C14.985 14.992 14.9883 14.9917 14.9914 14.9914C14.9917 14.9883 14.992 14.985 14.9923 14.9815C14.9994 14.8941 15 14.7724 15 14.55V9.45C15 9.22761 14.9994 9.10592 14.9923 9.01848C14.992 9.015 14.9917 9.0117 14.9914 9.00859C14.9883 9.0083 14.985 9.00802 14.9815 9.00773C14.8941 9.00059 14.7724 9 14.55 9H12ZM6 6H3.45C3.2276 6 3.10591 6.00059 3.01848 6.00773C3.01499 6.00802 3.0117 6.0083 3.00859 6.00859C3.0083 6.0117 3.00801 6.015 3.00773 6.01848C3.00058 6.10592 3 6.22761 3 6.45V14.55C3 14.7724 3.00058 14.8941 3.00773 14.9815C3.00801 14.985 3.0083 14.9883 3.00859 14.9914C3.0117 14.9917 3.015 14.992 3.01848 14.9923C3.10591 14.9994 3.2276 15 3.45 15H6V6ZM2.31902 16.3365C2.31902 16.3365 2.31902 16.3365 2.31902 16.3365V16.3365Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$fa2e3dd98b4ea0fa$var$BarChartIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$fa2e3dd98b4ea0fa$var$BarChartIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$fa2e3dd98b4ea0fa$var$BarChartIcon.displayName = "BarChartIcon";
var $dfd33cee3229493c$var$$fa2e3dd98b4ea0fa$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$fa2e3dd98b4ea0fa$var$BarChartIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bar-line-chart.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0c5fecbc78a4424d$var$BarLineChartIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M2.25 1.5C2.66421 1.5 3 1.83579 3 2.25V13.35C3 13.7824 3.00058 14.0616 3.01795 14.2741C3.03459 14.4779 3.06285 14.5534 3.08175 14.5905C3.15365 14.7316 3.26839 14.8463 3.40951 14.9183C3.44659 14.9371 3.52213 14.9654 3.72588 14.9821C3.93838 14.9994 4.21759 15 4.65 15H15.75C16.1642 15 16.5 15.3358 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H4.62108C4.22572 16.5 3.88466 16.5 3.60373 16.4771C3.30722 16.4528 3.01231 16.3994 2.72852 16.2548C2.30516 16.039 1.96095 15.6948 1.74524 15.2715C1.60064 14.9877 1.54715 14.6928 1.52293 14.3963C1.49998 14.1153 1.49999 13.7743 1.5 13.3789L1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5ZM15.375 3.375C15.7892 3.375 16.125 3.71079 16.125 4.125V13.125C16.125 13.5392 15.7892 13.875 15.375 13.875C14.9608 13.875 14.625 13.5392 14.625 13.125V4.125C14.625 3.71079 14.9608 3.375 15.375 3.375ZM12 5.625C12.4142 5.625 12.75 5.96079 12.75 6.375V13.125C12.75 13.5392 12.4142 13.875 12 13.875C11.5858 13.875 11.25 13.5392 11.25 13.125V6.375C11.25 5.96079 11.5858 5.625 12 5.625ZM8.625 7.875C9.03922 7.875 9.375 8.21079 9.375 8.625V13.125C9.375 13.5392 9.03922 13.875 8.625 13.875C8.21079 13.875 7.875 13.5392 7.875 13.125V8.625C7.875 8.21079 8.21079 7.875 8.625 7.875ZM5.25 10.125C5.66422 10.125 6 10.4608 6 10.875V13.125C6 13.5392 5.66422 13.875 5.25 13.875C4.83579 13.875 4.5 13.5392 4.5 13.125V10.875C4.5 10.4608 4.83579 10.125 5.25 10.125Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0c5fecbc78a4424d$var$BarLineChartIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0c5fecbc78a4424d$var$BarLineChartIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0c5fecbc78a4424d$var$BarLineChartIcon.displayName = "BarLineChartIcon";
var $dfd33cee3229493c$var$$0c5fecbc78a4424d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0c5fecbc78a4424d$var$BarLineChartIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bell-off.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$45f4829fc2b16890$var$BellOffIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.99999 2.25C8.37867 2.25 7.87499 2.75368 7.87499 3.375C7.87499 3.52822 7.90521 3.67249 7.9593 3.8036L7.96851 3.82577C7.96975 3.82652 7.97102 3.82728 7.97231 3.82804C7.97234 3.82803 7.97227 3.82804 7.97231 3.82804C7.99451 3.82699 8.02621 3.8244 8.07473 3.81902C8.12355 3.8136 8.17979 3.80648 8.253 3.79718C8.49906 3.76593 8.74865 3.75 8.99999 3.75C9.07221 3.75 9.14429 3.75132 9.21618 3.75393C9.48924 3.76387 9.75968 3.79257 10.0252 3.83929C10.0894 3.69783 10.125 3.5408 10.125 3.375C10.125 2.75368 9.62131 2.25 8.99999 2.25ZM11.4605 4.29111C11.5668 4.0058 11.625 3.69704 11.625 3.375C11.625 1.92525 10.4497 0.75 8.99999 0.75C7.55025 0.75 6.37499 1.92525 6.37499 3.375C6.37499 3.7279 6.44504 4.06632 6.57269 4.37571C6.57399 4.37884 6.57537 4.38222 6.57685 4.38583C6.59664 4.43405 6.63316 4.52307 6.68764 4.61387C6.75242 4.72185 6.82721 4.80968 6.90827 4.89111C7.00908 4.9924 7.12738 5.0719 7.2199 5.12569C7.31241 5.17947 7.44003 5.24293 7.57794 5.28041C7.87116 5.36012 8.15952 5.32224 8.38396 5.29276C8.40381 5.29016 8.42317 5.28761 8.44198 5.28522C8.62551 5.26192 8.81198 5.25 8.99999 5.25C9.04936 5.25 9.09862 5.25082 9.14774 5.25245C9.49158 5.26389 9.82869 5.31509 10.1505 5.40263C10.1527 5.40322 10.1549 5.40381 10.1571 5.40438C10.737 5.56316 11.2641 5.8393 11.6908 6.20905C12.3851 6.81082 12.75 7.60203 12.75 8.4C12.75 8.66472 12.7572 8.91987 12.771 9.16573C12.7941 9.5793 13.1481 9.89582 13.5616 9.8727C13.9752 9.84958 14.2917 9.49558 14.2686 9.08201C14.2565 8.86465 14.25 8.63743 14.25 8.4C14.25 7.12928 13.6666 5.93653 12.6732 5.07552C12.309 4.75993 11.8999 4.49719 11.4605 4.29111ZM1.68944 2.50173C1.96462 2.19214 2.43868 2.16425 2.74827 2.43944L5.974 5.30676C6.00073 5.32623 6.02648 5.3477 6.05106 5.37117C6.06231 5.38191 6.07314 5.39291 6.08358 5.40416L15.3606 13.6504C15.3933 13.675 15.424 13.7023 15.4523 13.7319L16.2483 14.4394C16.5579 14.7146 16.5857 15.1887 16.3106 15.4983C16.0354 15.8079 15.5613 15.8357 15.2517 15.5606L14.6211 15H11.9055C11.5724 16.2939 10.3979 17.25 8.99999 17.25C7.60211 17.25 6.42754 16.2939 6.09451 15H4.37651C3.89417 15 3.51137 15 3.23759 14.9905C3.10026 14.9858 2.9685 14.978 2.85534 14.9629C2.79874 14.9553 2.73048 14.9438 2.66024 14.9244C2.60072 14.9079 2.4812 14.8704 2.36177 14.7831C2.28848 14.7295 2.1443 14.6207 2.0398 14.4375C1.9353 14.2543 1.91503 14.0748 1.9062 13.9844C1.89011 13.8199 1.9288 13.6841 1.94452 13.6317C1.96561 13.5614 1.99267 13.4953 2.01721 13.4402C2.06668 13.3291 2.13473 13.1993 2.21207 13.0594C2.36678 12.7793 2.59746 12.3892 2.89281 11.8897L2.90046 11.8768C3.3598 11.0999 3.74999 9.98074 3.74999 8.4C3.74999 7.53984 4.01764 6.71404 4.49962 6.00314L1.75172 3.56056C1.44213 3.28537 1.41425 2.81131 1.68944 2.50173ZM5.63519 7.01253C5.38106 7.44603 5.24999 7.92124 5.24999 8.4C5.24999 10.242 4.79138 11.6259 4.19163 12.6402C3.98532 12.9891 3.81811 13.272 3.68733 13.4985C3.88179 13.5 4.11528 13.5 4.39363 13.5H12.9336L5.63519 7.01253ZM10.2993 15H7.70067C7.96002 15.4484 8.44478 15.75 8.99999 15.75C9.5552 15.75 10.04 15.4484 10.2993 15Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$45f4829fc2b16890$var$BellOffIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$45f4829fc2b16890$var$BellOffIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$45f4829fc2b16890$var$BellOffIcon.displayName = "BellOffIcon";
var $dfd33cee3229493c$var$$45f4829fc2b16890$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$45f4829fc2b16890$var$BellOffIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bell-ringing.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$56e4c9fb5e3dc523$var$BellRingingIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.55748 3.1038C8.39667 2.50365 7.7798 2.14749 7.17965 2.3083C6.5795 2.46911 6.22334 3.08599 6.38415 3.68614C6.42706 3.8463 6.50207 3.98878 6.60069 4.10881C6.91 3.96471 7.23382 3.84668 7.56783 3.75719C7.90186 3.66768 8.24135 3.60799 8.58128 3.57813C8.60668 3.42486 8.6004 3.26396 8.55748 3.1038ZM10.0846 3.64304C10.1134 3.33994 10.0897 3.02663 10.0064 2.71557C9.63115 1.31522 8.19177 0.484192 6.79142 0.859414C5.39107 1.23464 4.56004 2.67402 4.93526 4.07437C5.01861 4.38542 5.15473 4.66859 5.33123 4.91666C4.96011 5.22946 4.63294 5.58914 4.36288 5.98823C3.6261 7.07703 3.37134 8.38012 3.70023 9.60754C4.10935 11.1344 4.02212 12.3165 3.77949 13.1857L3.77549 13.2001C3.61946 13.759 3.49761 14.1956 3.42064 14.5062C3.38216 14.6614 3.35002 14.8044 3.33098 14.9245C3.32154 14.984 3.31252 15.0549 3.31033 15.1283C3.3087 15.1829 3.30648 15.3241 3.36462 15.4789C3.39654 15.5639 3.46257 15.732 3.61093 15.8819C3.75928 16.0318 3.9267 16.0996 4.01137 16.1324C4.14934 16.1859 4.27447 16.1911 4.33623 16.1916C4.40912 16.1922 4.47803 16.1857 4.53465 16.1783C4.64788 16.1637 4.77715 16.137 4.91104 16.1061C5.17799 16.0444 5.54783 15.9453 6.01386 15.8204L6.94874 15.5699C7.60531 16.7336 8.98733 17.3531 10.3376 16.9913C11.6879 16.6295 12.575 15.402 12.5617 14.0659L14.9455 13.4272C15.4114 13.3024 15.7811 13.2033 16.0431 13.1233C16.1746 13.0831 16.2998 13.0415 16.4052 12.9976C16.4579 12.9757 16.5209 12.9469 16.5837 12.9099C16.6369 12.8786 16.7427 12.8115 16.8354 12.6962C16.8924 12.6255 17.0035 12.4831 17.057 12.2791C17.1105 12.0751 17.0836 11.8965 17.0688 11.8069C17.0417 11.6437 16.9692 11.5226 16.9405 11.4761C16.9019 11.4137 16.8586 11.3568 16.8207 11.3099C16.7441 11.2154 16.6448 11.1077 16.5339 10.9925C16.312 10.762 15.9882 10.4449 15.5736 10.0389L15.5629 10.0284C14.9181 9.39689 14.2516 8.41682 13.8424 6.88994C13.5136 5.66252 12.6414 4.66139 11.4589 4.08685C11.0255 3.87627 10.5624 3.72837 10.0846 3.64304ZM9.09128 5.05565C9.10131 5.05589 9.11133 5.05593 9.12133 5.05577C9.71984 5.0601 10.2977 5.19034 10.8034 5.43602C11.6298 5.83757 12.187 6.50739 12.3936 7.27817C12.8703 9.05737 13.6715 10.2755 14.5133 11.1C14.8029 11.3836 15.0376 11.6136 15.2226 11.7985C15.0351 11.8502 14.8096 11.9107 14.5407 11.9827L5.64191 14.3672C5.37304 14.4392 5.1475 14.4996 4.95929 14.5485C5.02699 14.2959 5.11529 13.9794 5.22427 13.589C5.54107 12.454 5.62585 10.9985 5.14912 9.21931C4.94258 8.44853 5.09024 7.58985 5.60518 6.82887C5.92009 6.3635 6.35518 5.96193 6.87102 5.65897C6.8803 5.65382 6.88949 5.64848 6.89857 5.64293C7.22297 5.45565 7.57868 5.30719 7.95606 5.20607C8.33377 5.10487 8.71639 5.05558 9.09128 5.05565ZM11.0103 14.4816L8.50016 15.1542C8.86672 15.5202 9.41305 15.6861 9.94936 15.5424C10.4857 15.3987 10.8758 14.9818 11.0103 14.4816ZM12.3575 2.69766C12.4607 2.29652 12.8696 2.05503 13.2708 2.15828C14.5896 2.49772 15.6262 3.53431 15.9656 4.85315C16.0689 5.25429 15.8274 5.66317 15.4262 5.76642C15.0251 5.86967 14.6162 5.62818 14.513 5.22704C14.3097 4.43746 13.6864 3.81416 12.8969 3.61093C12.4957 3.50769 12.2542 3.0988 12.3575 2.69766ZM2.86716 5.24056C3.15715 5.53634 3.15245 6.01119 2.85668 6.30117C2.2745 6.87196 2.04635 7.7234 2.26515 8.50881C2.3763 8.90783 2.14294 9.32141 1.74392 9.43257C1.3449 9.54372 0.931321 9.31036 0.820165 8.91134C0.454715 7.59947 0.834134 6.18346 1.80656 5.23008C2.10233 4.9401 2.57718 4.94479 2.86716 5.24056Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$56e4c9fb5e3dc523$var$BellRingingIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$56e4c9fb5e3dc523$var$BellRingingIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$56e4c9fb5e3dc523$var$BellRingingIcon.displayName = "BellRingingIcon";
var $dfd33cee3229493c$var$$56e4c9fb5e3dc523$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$56e4c9fb5e3dc523$var$BellRingingIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bell.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$50e50a968c2c5c02$var$BellIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.61632 3.10377C7.45552 2.50362 6.83864 2.14746 6.23849 2.30827C5.63834 2.46908 5.28218 3.08596 5.44299 3.68611C5.48591 3.84627 5.56092 3.98876 5.65955 4.1088C5.96886 3.9647 6.2927 3.84666 6.62672 3.75716C6.96073 3.66766 7.3002 3.60796 7.64012 3.57811C7.66552 3.42483 7.65924 3.26393 7.61632 3.10377ZM9.14343 3.643C9.17226 3.33991 9.14856 3.0266 9.06521 2.71554C8.68999 1.31519 7.25061 0.484161 5.85026 0.859383C4.44991 1.23461 3.61888 2.67399 3.9941 4.07434C4.07745 4.3854 4.21358 4.66858 4.3901 4.91666C4.01898 5.22945 3.69181 5.58912 3.42177 5.9882C2.68499 7.07701 2.43023 8.3801 2.75911 9.60752C3.16824 11.1344 3.08101 12.3164 2.83838 13.1857L2.83437 13.2001C2.67835 13.759 2.55649 14.1956 2.47952 14.5062C2.44105 14.6614 2.4089 14.8043 2.38987 14.9244C2.38043 14.984 2.37141 15.0549 2.36922 15.1282C2.36759 15.1829 2.36537 15.3241 2.42351 15.4789C2.45543 15.5639 2.52146 15.732 2.66981 15.8819C2.81817 16.0318 2.98559 16.0996 3.07025 16.1324C3.20822 16.1858 3.33336 16.1911 3.39512 16.1916C3.468 16.1922 3.53691 16.1856 3.59354 16.1783C3.70676 16.1637 3.83604 16.137 3.96992 16.1061C4.23688 16.0444 4.60672 15.9453 5.07275 15.8204L6.0075 15.5699C6.66407 16.7336 8.04608 17.3531 9.39633 16.9913C10.7466 16.6295 11.6337 15.402 11.6205 14.0659L14.0044 13.4272C14.4703 13.3023 14.84 13.2033 15.102 13.1232C15.2334 13.0831 15.3587 13.0415 15.4641 12.9976C15.5168 12.9756 15.5798 12.9469 15.6426 12.9099C15.6958 12.8786 15.8016 12.8115 15.8943 12.6962C15.9512 12.6255 16.0623 12.483 16.1159 12.279C16.1694 12.075 16.1425 11.8964 16.1277 11.8069C16.1006 11.6437 16.0281 11.5226 15.9993 11.476C15.9608 11.4137 15.9175 11.3568 15.8796 11.3099C15.803 11.2154 15.7037 11.1077 15.5928 10.9925C15.3709 10.762 15.0471 10.4449 14.6326 10.0389L14.6218 10.0283C13.977 9.39687 13.3105 8.4168 12.9013 6.88992C12.5724 5.6625 11.7003 4.66137 10.5178 4.08682C10.0844 3.87624 9.62123 3.72833 9.14343 3.643ZM8.15034 5.05563C8.16023 5.05586 8.1701 5.0559 8.17997 5.05574C8.77857 5.06004 9.35655 5.19028 9.86226 5.436C10.6887 5.83755 11.2459 6.50736 11.4524 7.27814C11.9292 9.05734 12.7304 10.2755 13.5722 11.1C13.8618 11.3836 14.0965 11.6135 14.2815 11.7985C14.094 11.8502 13.8685 11.9107 13.5996 11.9827L4.7008 14.3672C4.43193 14.4392 4.20639 14.4996 4.01817 14.5485C4.08588 14.2959 4.17418 13.9794 4.28315 13.589C4.59995 12.454 4.68474 10.9985 4.208 9.21929C4.00147 8.4485 4.14913 7.58982 4.66407 6.82885C4.97917 6.36319 5.4146 5.96141 5.93085 5.65839C5.93947 5.65359 5.94801 5.64863 5.95645 5.64348C6.28112 5.45593 6.63718 5.30727 7.01494 5.20605C7.39271 5.10483 7.77539 5.05554 8.15034 5.05563ZM7.55893 15.1542C7.92549 15.5202 8.47181 15.6861 9.0081 15.5424C9.54439 15.3987 9.93456 14.9818 10.069 14.4816L7.55893 15.1542Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$50e50a968c2c5c02$var$BellIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$50e50a968c2c5c02$var$BellIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$50e50a968c2c5c02$var$BellIcon.displayName = "BellIcon";
var $dfd33cee3229493c$var$$50e50a968c2c5c02$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$50e50a968c2c5c02$var$BellIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``book-closed.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$735a5d71965ef559$var$BookClosedIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M13.5241 2.26795C13.3116 2.25058 13.0324 2.25 12.6 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06902C3.85372 3.18632 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V11.6513C4.19126 11.3961 4.70357 11.25 5.25 11.25H14.25V3.9C14.25 3.46759 14.2494 3.18838 14.2321 2.97588C14.2154 2.77213 14.1872 2.69659 14.1683 2.65951C14.0963 2.51839 13.9816 2.40365 13.8405 2.33175C13.8034 2.31285 13.7279 2.28459 13.5241 2.26795ZM15.75 3.87108C15.75 3.47572 15.75 3.13466 15.7271 2.85373C15.7028 2.55722 15.6494 2.26231 15.5048 1.97852C15.289 1.55516 14.9448 1.21095 14.5215 0.995237C14.2377 0.850641 13.9428 0.797154 13.6463 0.772928C13.3653 0.749976 13.0243 0.749987 12.6289 0.750001L6.56903 0.750001C5.9653 0.749991 5.46703 0.749984 5.06113 0.783147C4.63956 0.81759 4.25203 0.891514 3.88803 1.07698C3.32354 1.3646 2.8646 1.82354 2.57698 2.38803C2.39151 2.75203 2.31759 3.13956 2.28315 3.56113C2.24998 3.96703 2.24999 4.4653 2.25 5.06903V12.931C2.24999 13.3347 2.24999 13.6912 2.2599 14.0045C2.25334 14.0855 2.25 14.1673 2.25 14.25C2.25 14.3314 2.26296 14.4097 2.28691 14.4831C2.32291 14.8876 2.39801 15.2607 2.57698 15.612C2.8646 16.1765 3.32354 16.6354 3.88803 16.923C4.25203 17.1085 4.63956 17.1824 5.06113 17.2169C5.46702 17.25 5.96529 17.25 6.56901 17.25H12.6289C13.0243 17.25 13.3653 17.25 13.6463 17.2271C13.9428 17.2028 14.2377 17.1494 14.5215 17.0048C14.9448 16.7891 15.289 16.4448 15.5048 16.0215C15.6494 15.7377 15.7028 15.4428 15.7271 15.1463C15.7475 14.896 15.7497 14.5979 15.75 14.2562C15.75 14.2541 15.75 14.2521 15.75 14.25V14.1797C15.75 14.1629 15.75 14.1459 15.75 14.1289V3.87108ZM3.76259 14.0547C3.76647 14.1488 3.77154 14.2356 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H12.6C13.0324 15.75 13.3116 15.7494 13.5241 15.7321C13.7279 15.7154 13.8034 15.6872 13.8405 15.6683C13.9816 15.5963 14.0964 15.4816 14.1683 15.3405C14.1872 15.3034 14.2154 15.2279 14.2321 15.0241C14.2494 14.8116 14.25 14.5324 14.25 14.1V12.75H5.25C4.48775 12.75 3.85829 13.3186 3.76259 14.0547Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$735a5d71965ef559$var$BookClosedIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$735a5d71965ef559$var$BookClosedIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$735a5d71965ef559$var$BookClosedIcon.displayName = "BookClosedIcon";
var $dfd33cee3229493c$var$$735a5d71965ef559$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$735a5d71965ef559$var$BookClosedIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``book-open.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$024bee86378197e3$var$BookOpenIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.87109 1.5L4.23211 1.5C5.04495 1.49999 5.70056 1.49999 6.23147 1.54336C6.77811 1.58803 7.25825 1.68239 7.70247 1.90873C8.21514 2.16995 8.65816 2.54421 9 3C9.34184 2.54421 9.78487 2.16995 10.2975 1.90873C10.7418 1.68239 11.2219 1.58803 11.7685 1.54336C12.2994 1.49999 12.9551 1.49999 13.7679 1.5L14.1289 1.5C14.5243 1.49999 14.8653 1.49998 15.1463 1.52293C15.4428 1.54715 15.7377 1.60064 16.0215 1.74524C16.4448 1.96095 16.7891 2.30516 17.0048 2.72852C17.1494 3.01231 17.2028 3.30722 17.2271 3.60373C17.25 3.88466 17.25 4.22572 17.25 4.62108V11.1289C17.25 11.5243 17.25 11.8653 17.2271 12.1463C17.2028 12.4428 17.1494 12.7377 17.0048 13.0215C16.7891 13.4448 16.4448 13.7891 16.0215 14.0048C15.7377 14.1494 15.4428 14.2028 15.1463 14.2271C14.8653 14.25 14.5243 14.25 14.1289 14.25H13.0689C12.083 14.25 11.7463 14.2576 11.4517 14.3471C11.1687 14.433 10.9054 14.574 10.6769 14.7618C10.4391 14.9572 10.246 15.2331 9.69908 16.0535L9.62404 16.166C9.48494 16.3747 9.25077 16.5 9 16.5C8.74924 16.5 8.51506 16.3747 8.37596 16.166L8.30092 16.0535C7.75404 15.2331 7.56092 14.9572 7.32311 14.7618C7.0946 14.574 6.83129 14.433 6.54827 14.3471C6.25373 14.2576 5.91703 14.25 4.93112 14.25H3.87108C3.47572 14.25 3.13466 14.25 2.85373 14.2271C2.55722 14.2028 2.26231 14.1494 1.97852 14.0048C1.55516 13.7891 1.21095 13.4448 0.995237 13.0215C0.850641 12.7377 0.797154 12.4428 0.772928 12.1463C0.749976 11.8653 0.749987 11.5243 0.750001 11.1289V4.62109C0.749987 4.22573 0.749976 3.88466 0.772928 3.60373C0.797154 3.30722 0.850641 3.01231 0.995237 2.72852C1.21095 2.30516 1.55516 1.96095 1.97852 1.74524C2.26231 1.60064 2.55722 1.54715 2.85373 1.52293C3.13466 1.49998 3.47573 1.49999 3.87109 1.5ZM8.25 7.05C8.25 6.19755 8.24942 5.60331 8.21162 5.14068C8.17454 4.68681 8.10541 4.42604 8.00477 4.22852C7.78905 3.80516 7.44484 3.46095 7.02148 3.24524C6.82396 3.1446 6.5632 3.07547 6.10932 3.03838C5.64669 3.00058 5.05246 3 4.2 3H3.9C3.46759 3 3.18838 3.00058 2.97588 3.01795C2.77213 3.03459 2.69659 3.06285 2.65951 3.08175C2.51839 3.15365 2.40365 3.26839 2.33175 3.40951C2.31285 3.44659 2.28459 3.52213 2.26795 3.72588C2.25058 3.93838 2.25 4.21759 2.25 4.65V11.1C2.25 11.5324 2.25058 11.8116 2.26795 12.0241C2.28459 12.2279 2.31285 12.3034 2.33175 12.3405C2.40365 12.4816 2.51839 12.5964 2.65951 12.6683C2.69659 12.6872 2.77213 12.7154 2.97588 12.7321C3.18838 12.7494 3.46759 12.75 3.9 12.75H4.93112C4.96852 12.75 5.00541 12.75 5.04181 12.75C5.87405 12.7497 6.44954 12.7495 6.98414 12.9118C7.44534 13.0519 7.87512 13.2795 8.25 13.5821V7.05ZM9.75 13.5821C10.1249 13.2795 10.5547 13.0519 11.0159 12.9118C11.5505 12.7495 12.1259 12.7497 12.9582 12.75C12.9946 12.75 13.0315 12.75 13.0689 12.75H14.1C14.5324 12.75 14.8116 12.7494 15.0241 12.7321C15.2279 12.7154 15.3034 12.6872 15.3405 12.6683C15.4816 12.5964 15.5963 12.4816 15.6683 12.3405C15.6872 12.3034 15.7154 12.2279 15.7321 12.0241C15.7494 11.8116 15.75 11.5324 15.75 11.1V4.65C15.75 4.21759 15.7494 3.93838 15.7321 3.72588C15.7154 3.52213 15.6872 3.44659 15.6683 3.40951C15.5963 3.26839 15.4816 3.15365 15.3405 3.08175C15.3034 3.06285 15.2279 3.03459 15.0241 3.01795C14.8116 3.00058 14.5324 3 14.1 3H13.8C12.9475 3 12.3533 3.00058 11.8907 3.03838C11.4368 3.07547 11.176 3.1446 10.9785 3.24524C10.5552 3.46095 10.211 3.80516 9.99524 4.22852C9.8946 4.42604 9.82547 4.68681 9.78838 5.14068C9.75059 5.60331 9.75 6.19755 9.75 7.05V13.5821Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$024bee86378197e3$var$BookOpenIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$024bee86378197e3$var$BookOpenIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$024bee86378197e3$var$BookOpenIcon.displayName = "BookOpenIcon";
var $dfd33cee3229493c$var$$024bee86378197e3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$024bee86378197e3$var$BookOpenIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bookmark-filled.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$9bee1ef65a69ab49$var$BookmarkFilledIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "",
                d: "M7.31903 1.5H10.681C11.2847 1.49999 11.783 1.49998 12.1889 1.53315C12.6104 1.56759 12.998 1.64151 13.362 1.82698C13.9265 2.1146 14.3854 2.57354 14.673 3.13803C14.8585 3.50203 14.9324 3.88956 14.9669 4.31113C15 4.71703 15 5.21531 15 5.81904V15.75C15 16.0174 14.8577 16.2645 14.6264 16.3987C14.3952 16.5329 14.11 16.5338 13.8779 16.4012L9 13.6138L4.12211 16.4012C3.88998 16.5338 3.60479 16.5329 3.37356 16.3987C3.14232 16.2645 3 16.0174 3 15.75V5.81903C2.99999 5.21531 2.99998 4.71702 3.03315 4.31113C3.06759 3.88956 3.14151 3.50203 3.32698 3.13803C3.6146 2.57354 4.07354 2.1146 4.63803 1.82698C5.00203 1.64151 5.38956 1.56759 5.81113 1.53315C6.21703 1.49998 6.7153 1.49999 7.31903 1.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$9bee1ef65a69ab49$var$BookmarkFilledIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$9bee1ef65a69ab49$var$BookmarkFilledIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$9bee1ef65a69ab49$var$BookmarkFilledIcon.displayName = "BookmarkFilledIcon";
var $dfd33cee3229493c$var$$9bee1ef65a69ab49$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9bee1ef65a69ab49$var$BookmarkFilledIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``bookmark.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$7f249b4d1cf7dc29$var$BookmarkIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.31903 1.5H10.681C11.2847 1.49999 11.783 1.49998 12.1889 1.53315C12.6104 1.56759 12.998 1.64151 13.362 1.82698C13.9265 2.1146 14.3854 2.57354 14.673 3.13803C14.8585 3.50203 14.9324 3.88956 14.9669 4.31113C15 4.71703 15 5.21531 15 5.81904V15.75C15 16.0174 14.8577 16.2645 14.6264 16.3987C14.3952 16.5329 14.11 16.5338 13.8779 16.4012L9 13.6138L4.1221 16.4012C3.88998 16.5338 3.60479 16.5329 3.37356 16.3987C3.14232 16.2645 3 16.0174 3 15.75L3 5.81903C2.99999 5.2153 2.99998 4.71703 3.03315 4.31113C3.06759 3.88956 3.14151 3.50203 3.32698 3.13803C3.6146 2.57354 4.07354 2.1146 4.63803 1.82698C5.00203 1.64151 5.38956 1.56759 5.81113 1.53315C6.21703 1.49998 6.7153 1.49999 7.31903 1.5ZM5.93328 3.02816C5.60447 3.05503 5.43631 3.10372 5.31902 3.16349C5.03677 3.3073 4.8073 3.53677 4.66349 3.81902C4.60372 3.93631 4.55503 4.10447 4.52816 4.43328C4.50058 4.77085 4.5 5.20757 4.5 5.85V14.4576L8.6279 12.0988C8.85847 11.9671 9.14153 11.9671 9.3721 12.0988L13.5 14.4576V5.85C13.5 5.20757 13.4994 4.77085 13.4718 4.43328C13.445 4.10447 13.3963 3.93631 13.3365 3.81902C13.1927 3.53677 12.9632 3.3073 12.681 3.16349C12.5637 3.10372 12.3955 3.05503 12.0667 3.02816C11.7292 3.00058 11.2924 3 10.65 3H7.35C6.70757 3 6.27085 3.00058 5.93328 3.02816Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$7f249b4d1cf7dc29$var$BookmarkIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$7f249b4d1cf7dc29$var$BookmarkIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$7f249b4d1cf7dc29$var$BookmarkIcon.displayName = "BookmarkIcon";
var $dfd33cee3229493c$var$$7f249b4d1cf7dc29$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7f249b4d1cf7dc29$var$BookmarkIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``briefcase.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$14afd430cf2d82c2$var$BriefcaseIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.89682 1.49997C8.93071 1.49999 8.9651 1.50001 9 1.50001C9.0349 1.50001 9.06929 1.49999 9.10319 1.49997C9.69972 1.49965 10.1427 1.49941 10.5265 1.60223C11.5617 1.87964 12.3704 2.68828 12.6478 3.72355C12.7096 3.95415 12.7341 4.20615 12.7438 4.50001L14.1289 4.50001C14.5243 4.5 14.8653 4.49999 15.1463 4.52294C15.4428 4.54716 15.7377 4.60065 16.0215 4.74525C16.4448 4.96096 16.7891 5.30517 17.0048 5.72853C17.1494 6.01232 17.2028 6.30723 17.2271 6.60374C17.25 6.88467 17.25 7.22573 17.25 7.62109V13.3789C17.25 13.7743 17.25 14.1154 17.2271 14.3963C17.2028 14.6928 17.1494 14.9877 17.0048 15.2715C16.7891 15.6949 16.4448 16.0391 16.0215 16.2548C15.7377 16.3994 15.4428 16.4529 15.1463 16.4771C14.8653 16.5 14.5243 16.5 14.1289 16.5H3.87108C3.47572 16.5 3.13466 16.5 2.85373 16.4771C2.55722 16.4529 2.26231 16.3994 1.97852 16.2548C1.55516 16.0391 1.21095 15.6949 0.995237 15.2715C0.850641 14.9877 0.797154 14.6928 0.772928 14.3963C0.749976 14.1154 0.749987 13.7743 0.750001 13.3789V7.6211C0.749987 7.22574 0.749976 6.88467 0.772928 6.60374C0.797154 6.30723 0.850641 6.01232 0.995237 5.72853C1.21095 5.30517 1.55516 4.96096 1.97852 4.74525C2.26231 4.60065 2.55722 4.54716 2.85373 4.52294C3.13466 4.49999 3.47573 4.5 3.87109 4.50001L5.25616 4.50001C5.26586 4.20615 5.29043 3.95415 5.35222 3.72355C5.62963 2.68828 6.43827 1.87964 7.47354 1.60223C7.85728 1.49941 8.30028 1.49965 8.89682 1.49997ZM5.25 6.00001H3.9C3.46759 6.00001 3.18838 6.00059 2.97588 6.01796C2.77213 6.0346 2.69659 6.06286 2.65951 6.08176C2.51839 6.15366 2.40365 6.2684 2.33175 6.40952C2.31285 6.4466 2.28459 6.52214 2.26795 6.72589C2.25058 6.93839 2.25 7.2176 2.25 7.65001V13.35C2.25 13.7824 2.25058 14.0616 2.26795 14.2741C2.28459 14.4779 2.31285 14.5534 2.33175 14.5905C2.40365 14.7316 2.51839 14.8464 2.65951 14.9183C2.69659 14.9372 2.77213 14.9654 2.97588 14.9821C3.18838 14.9994 3.46759 15 3.9 15H5.25V6.00001ZM6.75 15V6.00001H11.25V15H6.75ZM12.75 15H14.1C14.5324 15 14.8116 14.9994 15.0241 14.9821C15.2279 14.9654 15.3034 14.9372 15.3405 14.9183C15.4816 14.8464 15.5964 14.7316 15.6683 14.5905C15.6872 14.5534 15.7154 14.4779 15.7321 14.2741C15.7494 14.0616 15.75 13.7824 15.75 13.35V7.65001C15.75 7.2176 15.7494 6.93839 15.7321 6.72589C15.7154 6.52214 15.6872 6.4466 15.6683 6.40952C15.5963 6.2684 15.4816 6.15366 15.3405 6.08176C15.3034 6.06286 15.2279 6.0346 15.0241 6.01796C14.8116 6.00059 14.5324 6.00001 14.1 6.00001H12.75V15ZM11.2426 4.50001H6.7574C6.76429 4.30683 6.77724 4.20088 6.80111 4.11178C6.93981 3.59414 7.34414 3.18982 7.86177 3.05112C8.02848 3.00645 8.25424 3.00001 9 3.00001C9.74577 3.00001 9.97152 3.00645 10.1382 3.05112C10.6559 3.18982 11.0602 3.59414 11.1989 4.11178C11.2228 4.20088 11.2357 4.30683 11.2426 4.50001Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$14afd430cf2d82c2$var$BriefcaseIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$14afd430cf2d82c2$var$BriefcaseIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$14afd430cf2d82c2$var$BriefcaseIcon.displayName = "BriefcaseIcon";
var $dfd33cee3229493c$var$$14afd430cf2d82c2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$14afd430cf2d82c2$var$BriefcaseIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``building.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$17898e4ed1194be2$var$BuildingIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.99609 1.5H10.0039C10.3993 1.49999 10.7403 1.49998 11.0213 1.52293C11.3178 1.54715 11.6127 1.60064 11.8965 1.74524C12.3198 1.96095 12.6641 2.30516 12.8798 2.72852C13.0244 3.01231 13.0778 3.30722 13.1021 3.60373C13.125 3.88466 13.125 4.22574 13.125 4.62111V7.5L14.5739 7.5C14.7632 7.49998 14.9476 7.49995 15.1037 7.51271C15.2751 7.52672 15.4774 7.55977 15.681 7.66349C15.9632 7.8073 16.1927 8.03677 16.3365 8.31902C16.4402 8.52258 16.4733 8.72488 16.4873 8.89633C16.5 9.05244 16.5 9.23678 16.5 9.42606L16.5 15C16.9142 15 17.25 15.3358 17.25 15.75C17.25 16.1642 16.9142 16.5 16.5 16.5H1.5C1.08579 16.5 0.75 16.1642 0.75 15.75C0.75 15.3358 1.08579 15 1.5 15L1.5 9.42608C1.49998 9.23679 1.49995 9.05245 1.51271 8.89633C1.52672 8.72488 1.55977 8.52258 1.66349 8.31902C1.8073 8.03677 2.03677 7.8073 2.31901 7.66349C2.52258 7.55977 2.72488 7.52672 2.89633 7.51271C3.05245 7.49995 3.23679 7.49998 3.42608 7.5C3.43404 7.5 3.44202 7.5 3.45 7.5H4.875L4.875 4.62109C4.87499 4.22573 4.87497 3.88466 4.89793 3.60373C4.92215 3.30722 4.97564 3.01231 5.12024 2.72852C5.33595 2.30516 5.68016 1.96095 6.10352 1.74524C6.38731 1.60064 6.68222 1.54715 6.97873 1.52293C7.25966 1.49998 7.60073 1.49999 7.99609 1.5ZM4.875 9H3.45C3.2276 9 3.10591 9.00058 3.01848 9.00773C3.01499 9.00801 3.0117 9.0083 3.00859 9.00859C3.0083 9.0117 3.00801 9.01499 3.00773 9.01848C3.00058 9.10592 3 9.22761 3 9.45V15H4.875V9ZM6.375 15V4.65C6.375 4.21759 6.37558 3.93838 6.39295 3.72588C6.40959 3.52213 6.43785 3.44659 6.45675 3.40951C6.52865 3.26839 6.64339 3.15365 6.78451 3.08175C6.82159 3.06285 6.89713 3.03459 7.10088 3.01795C7.31338 3.00058 7.59258 3 8.025 3H9.975C10.4074 3 10.6866 3.00058 10.8991 3.01795C11.1029 3.03459 11.1784 3.06285 11.2155 3.08175C11.3566 3.15365 11.4713 3.26839 11.5433 3.40951C11.5622 3.44659 11.5904 3.52213 11.6071 3.72588C11.6244 3.93838 11.625 4.21759 11.625 4.65V15H6.375ZM13.125 15H15V9.45C15 9.22761 14.9994 9.10592 14.9923 9.01848C14.992 9.015 14.9917 9.0117 14.9914 9.00859C14.9883 9.0083 14.985 9.00801 14.9815 9.00773C14.8941 9.00058 14.7724 9 14.55 9H13.125V15ZM7.5 5.25C7.5 4.83579 7.83579 4.5 8.25 4.5H9.75C10.1642 4.5 10.5 4.83579 10.5 5.25C10.5 5.66422 10.1642 6 9.75 6H8.25C7.83579 6 7.5 5.66422 7.5 5.25ZM7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5H9.75C10.1642 7.5 10.5 7.83579 10.5 8.25C10.5 8.66422 10.1642 9 9.75 9H8.25C7.83579 9 7.5 8.66422 7.5 8.25ZM7.5 11.25C7.5 10.8358 7.83579 10.5 8.25 10.5H9.75C10.1642 10.5 10.5 10.8358 10.5 11.25C10.5 11.6642 10.1642 12 9.75 12H8.25C7.83579 12 7.5 11.6642 7.5 11.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$17898e4ed1194be2$var$BuildingIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$17898e4ed1194be2$var$BuildingIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$17898e4ed1194be2$var$BuildingIcon.displayName = "BuildingIcon";
var $dfd33cee3229493c$var$$17898e4ed1194be2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$17898e4ed1194be2$var$BuildingIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``calculator.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e964850d20fc6b87$var$CalculatorIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81901C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77085 3 5.20757 3 5.85V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81901C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H5.85C5.20757 3 4.77085 3.00058 4.43328 3.02816ZM6.375 4.125C6.78921 4.125 7.125 4.46079 7.125 4.875V5.625H7.875C8.28921 5.625 8.625 5.96079 8.625 6.375C8.625 6.78921 8.28921 7.125 7.875 7.125H7.125V7.875C7.125 8.28921 6.78921 8.625 6.375 8.625C5.96079 8.625 5.625 8.28921 5.625 7.875V7.125H4.875C4.46079 7.125 4.125 6.78921 4.125 6.375C4.125 5.96079 4.46079 5.625 4.875 5.625H5.625V4.875C5.625 4.46079 5.96079 4.125 6.375 4.125ZM12.5947 4.34467C12.8876 4.05178 13.3624 4.05178 13.6553 4.34467C13.9482 4.63756 13.9482 5.11244 13.6553 5.40533L5.40533 13.6553C5.11244 13.9482 4.63756 13.9482 4.34467 13.6553C4.05178 13.3624 4.05178 12.8876 4.34467 12.5947L12.5947 4.34467ZM9.375 11.625C9.375 11.2108 9.71079 10.875 10.125 10.875H13.125C13.5392 10.875 13.875 11.2108 13.875 11.625C13.875 12.0392 13.5392 12.375 13.125 12.375H10.125C9.71079 12.375 9.375 12.0392 9.375 11.625Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e964850d20fc6b87$var$CalculatorIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e964850d20fc6b87$var$CalculatorIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e964850d20fc6b87$var$CalculatorIcon.displayName = "CalculatorIcon";
var $dfd33cee3229493c$var$$e964850d20fc6b87$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e964850d20fc6b87$var$CalculatorIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``calendar.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$5ce412261b038a8e$var$CalendarIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6 0.75C6.41421 0.75 6.75 1.08579 6.75 1.5V2.25H11.25V1.5C11.25 1.08579 11.5858 0.75 12 0.75C12.4142 0.75 12.75 1.08579 12.75 1.5V2.25122C13.1066 2.25367 13.4183 2.26104 13.6889 2.28315C14.1104 2.31759 14.498 2.39151 14.862 2.57698C15.4265 2.8646 15.8854 3.32354 16.173 3.88803C16.3585 4.25203 16.4324 4.63956 16.4669 5.06113C16.5 5.46702 16.5 5.96529 16.5 6.56901V12.931C16.5 13.5347 16.5 14.033 16.4669 14.4389C16.4324 14.8604 16.3585 15.248 16.173 15.612C15.8854 16.1765 15.4265 16.6354 14.862 16.923C14.498 17.1085 14.1104 17.1824 13.6889 17.2169C13.283 17.25 12.7847 17.25 12.181 17.25H5.81901C5.21529 17.25 4.71702 17.25 4.31113 17.2169C3.88956 17.1824 3.50203 17.1085 3.13803 16.923C2.57354 16.6354 2.1146 16.1765 1.82698 15.612C1.64151 15.248 1.56759 14.8604 1.53315 14.4389C1.49998 14.033 1.49999 13.5347 1.5 12.931V6.56903C1.49999 5.9653 1.49998 5.46703 1.53315 5.06113C1.56759 4.63956 1.64151 4.25203 1.82698 3.88803C2.1146 3.32354 2.57354 2.8646 3.13803 2.57698C3.50203 2.39151 3.88956 2.31759 4.31113 2.28315C4.58174 2.26104 4.8934 2.25367 5.25 2.25122V1.5C5.25 1.08579 5.58579 0.75 6 0.75ZM5.25 3.75132C4.91585 3.75367 4.65347 3.76017 4.43328 3.77816C4.10447 3.80503 3.93631 3.85372 3.81902 3.91349C3.53677 4.0573 3.3073 4.28677 3.16349 4.56901C3.10372 4.68631 3.05503 4.85447 3.02816 5.18328C3.00058 5.52085 3 5.95757 3 6.6V6.75H15V6.6C15 5.95757 14.9994 5.52085 14.9718 5.18328C14.945 4.85447 14.8963 4.68631 14.8365 4.56901C14.6927 4.28677 14.4632 4.0573 14.181 3.91349C14.0637 3.85372 13.8955 3.80503 13.5667 3.77816C13.3465 3.76017 13.0841 3.75367 12.75 3.75132V4.5C12.75 4.91421 12.4142 5.25 12 5.25C11.5858 5.25 11.25 4.91421 11.25 4.5V3.75H6.75V4.5C6.75 4.91421 6.41421 5.25 6 5.25C5.58579 5.25 5.25 4.91421 5.25 4.5V3.75132ZM15 8.25H3V12.9C3 13.5424 3.00058 13.9792 3.02816 14.3167C3.05503 14.6455 3.10372 14.8137 3.16349 14.931C3.3073 15.2132 3.53677 15.4427 3.81902 15.5865C3.93631 15.6463 4.10447 15.695 4.43328 15.7218C4.77085 15.7494 5.20757 15.75 5.85 15.75H12.15C12.7924 15.75 13.2292 15.7494 13.5667 15.7218C13.8955 15.695 14.0637 15.6463 14.181 15.5865C14.4632 15.4427 14.6927 15.2132 14.8365 14.931C14.8963 14.8137 14.945 14.6455 14.9718 14.3167C14.9994 13.9792 15 13.5424 15 12.9V8.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$5ce412261b038a8e$var$CalendarIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$5ce412261b038a8e$var$CalendarIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$5ce412261b038a8e$var$CalendarIcon.displayName = "CalendarIcon";
var $dfd33cee3229493c$var$$5ce412261b038a8e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5ce412261b038a8e$var$CalendarIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``cash.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$2fe52e0d65c20534$var$CashIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.6582 4.5538C7.56513 4.89283 6.41358 5.25 5.25 5.25C4.4796 5.25 3.79084 5.16814 3.20936 5.05641C2.81349 4.98035 2.54975 4.93 2.35979 4.90489C2.32236 4.89994 2.29137 4.89648 2.2659 4.89413C2.26427 4.91063 2.26263 4.93005 2.26113 4.95269C2.2504 5.11412 2.25 5.33988 2.25 5.69164L2.25 13.7529C2.25 13.7808 2.25003 13.7987 2.25023 13.8126C2.25189 13.8153 2.25361 13.8179 2.25538 13.8206C2.25713 13.8233 2.25888 13.826 2.2606 13.8285C2.65155 13.9942 3.5346 14.25 5.25 14.25C6.62778 14.25 7.84623 13.9068 9.06069 13.5332C9.15394 13.5045 9.24766 13.4754 9.34181 13.4462C10.4349 13.1072 11.5864 12.75 12.75 12.75C13.5204 12.75 14.2092 12.8319 14.7906 12.9436C15.1865 13.0196 15.4503 13.07 15.6402 13.0951C15.6776 13.1001 15.7086 13.1035 15.7341 13.1059C15.7357 13.0894 15.7374 13.0699 15.7389 13.0473C15.7496 12.8859 15.75 12.6601 15.75 12.3084V4.24706C15.75 4.21917 15.75 4.20131 15.7498 4.18736C15.7481 4.18474 15.7464 4.18206 15.7446 4.17935C15.7429 4.17666 15.7411 4.17402 15.7394 4.17146C15.3485 4.00579 14.4654 3.75 12.75 3.75C11.3722 3.75 10.1538 4.09315 8.93932 4.46683C8.84606 4.49553 8.75235 4.52459 8.6582 4.5538ZM15.8229 13.1102C15.8246 13.1101 15.8255 13.11 15.8257 13.11L15.8229 13.1102ZM2.1771 4.88977C2.17525 4.88995 2.17427 4.88999 2.17424 4.88997L2.1771 4.88977ZM8.49819 3.03317C9.72123 2.65684 11.1278 2.25 12.75 2.25C14.6592 2.25 15.762 2.54168 16.3768 2.81288C16.3786 2.81366 16.3805 2.81452 16.3827 2.81547C16.4152 2.82971 16.4897 2.86236 16.5715 2.91603C16.6549 2.97075 16.7245 3.03242 16.7856 3.09071C16.8801 3.18085 16.9591 3.29553 17.0012 3.36023C17.0434 3.42492 17.1164 3.54348 17.1608 3.66628C17.2501 3.91355 17.2501 4.08912 17.25 4.23698L17.25 12.3337C17.25 12.6528 17.25 12.9293 17.2356 13.1467C17.2221 13.3497 17.1917 13.6335 17.0456 13.8839C16.9661 14.0202 16.8623 14.1642 16.71 14.29C16.5578 14.4158 16.3968 14.4905 16.2479 14.5429C15.9639 14.6428 15.6533 14.6099 15.4436 14.5822C15.2047 14.5506 14.8973 14.4915 14.5312 14.4212L14.5076 14.4166C14.0079 14.3206 13.4144 14.25 12.75 14.25C11.8241 14.25 10.8856 14.5397 9.73023 14.8964C9.65503 14.9196 9.57891 14.9431 9.50182 14.9668C8.27878 15.3432 6.87223 15.75 5.25 15.75C3.34085 15.75 2.23804 15.4583 1.62323 15.1871C1.62145 15.1863 1.61948 15.1855 1.61732 15.1845C1.58482 15.1703 1.51031 15.1376 1.42852 15.084C1.34512 15.0292 1.27548 14.9676 1.2144 14.9093C1.11995 14.8191 1.04095 14.7045 0.998783 14.6398C0.956612 14.5751 0.883566 14.4565 0.839209 14.3337C0.7499 14.0865 0.749955 13.9109 0.750002 13.763L0.750004 5.6663C0.749994 5.34719 0.749985 5.07066 0.76443 4.85325C0.777915 4.6503 0.808326 4.36652 0.954421 4.11613C1.03396 3.97982 1.13772 3.83579 1.28996 3.71002C1.4422 3.58424 1.60322 3.50952 1.75209 3.45713C2.03614 3.35718 2.34675 3.39011 2.55636 3.41782C2.79528 3.4494 3.10272 3.50848 3.4688 3.57882L3.49239 3.58336C3.9921 3.67937 4.58563 3.75 5.25 3.75C6.17594 3.75 7.11438 3.46029 8.26978 3.1036C8.34498 3.08039 8.4211 3.05689 8.49819 3.03317ZM13.5 6C13.9142 6 14.25 6.33579 14.25 6.75V9.75C14.25 10.1642 13.9142 10.5 13.5 10.5C13.0858 10.5 12.75 10.1642 12.75 9.75V6.75C12.75 6.33579 13.0858 6 13.5 6ZM9 7.875C8.37868 7.875 7.875 8.37868 7.875 9C7.875 9.62132 8.37868 10.125 9 10.125C9.62132 10.125 10.125 9.62132 10.125 9C10.125 8.37868 9.62132 7.875 9 7.875ZM6.375 9C6.375 7.55025 7.55026 6.375 9 6.375C10.4498 6.375 11.625 7.55025 11.625 9C11.625 10.4497 10.4498 11.625 9 11.625C7.55026 11.625 6.375 10.4497 6.375 9ZM4.5 7.5C4.91422 7.5 5.25 7.83579 5.25 8.25V11.25C5.25 11.6642 4.91422 12 4.5 12C4.08579 12 3.75 11.6642 3.75 11.25V8.25C3.75 7.83579 4.08579 7.5 4.5 7.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$2fe52e0d65c20534$var$CashIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$2fe52e0d65c20534$var$CashIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$2fe52e0d65c20534$var$CashIcon.displayName = "CashIcon";
var $dfd33cee3229493c$var$$2fe52e0d65c20534$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2fe52e0d65c20534$var$CashIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``certificate.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$c11700b54c4cdfb3$var$CertificateIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 3C1.5 1.75736 2.50736 0.75 3.75 0.75H14.25C15.4926 0.75 16.5 1.75736 16.5 3V13.5C16.5 14.7426 15.4926 15.75 14.25 15.75H13.3497L11.9249 17.1748C11.6321 17.4676 11.1572 17.4676 10.8643 17.1748L9.00798 15.3186L7.15183 17.1748C6.85894 17.4676 6.38407 17.4676 6.09117 17.1748L4.66642 15.75H3.75C2.50736 15.75 1.5 14.7426 1.5 13.5V3ZM5.56084 14.5231L6.6215 15.5838L7.56829 14.637C7.12151 14.3939 6.74338 14.0406 6.47042 13.6135L5.56084 14.5231ZM6.00023 11.9624L3.96985 13.9928C3.89592 14.0667 3.83902 14.1545 3.80167 14.25H3.75C3.33579 14.25 3 13.9142 3 13.5V3C3 2.58579 3.33579 2.25 3.75 2.25H14.25C14.6642 2.25 15 2.58579 15 3V13.5C15 13.9142 14.6642 14.25 14.25 14.25H14.2144C14.1771 14.1545 14.1202 14.0667 14.0463 13.9928L11.9995 11.946C11.9707 10.3141 10.6388 9 9 9C7.3557 9 6.02037 10.3229 6.00023 11.9624ZM7.5101 12.175C7.50993 12.1734 7.50975 12.1719 7.50956 12.1703C7.50325 12.1144 7.5 12.0576 7.5 12C7.5 11.1716 8.17157 10.5 9 10.5C9.82843 10.5 10.5 11.1716 10.5 12C10.5 12.8215 9.83966 13.4887 9.02083 13.4999C9.01683 13.4998 9.01282 13.4998 9.00881 13.4999L8.99675 13.5C8.22899 13.4984 7.59667 12.9199 7.5101 12.175ZM10.4421 14.6313C10.8877 14.3865 11.2645 14.0318 11.5358 13.6037L12.4553 14.5231L11.3946 15.5838L10.4421 14.6313ZM6 4.5C6 4.08579 6.33579 3.75 6.75 3.75H11.25C11.6642 3.75 12 4.08579 12 4.5C12 4.91421 11.6642 5.25 11.25 5.25H6.75C6.33579 5.25 6 4.91421 6 4.5ZM4.5 7.125C4.5 6.71079 4.83579 6.375 5.25 6.375H12.75C13.1642 6.375 13.5 6.71079 13.5 7.125C13.5 7.53921 13.1642 7.875 12.75 7.875H5.25C4.83579 7.875 4.5 7.53921 4.5 7.125Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$c11700b54c4cdfb3$var$CertificateIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$c11700b54c4cdfb3$var$CertificateIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$c11700b54c4cdfb3$var$CertificateIcon.displayName = "CertificateIcon";
var $dfd33cee3229493c$var$$c11700b54c4cdfb3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c11700b54c4cdfb3$var$CertificateIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``check-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b5d06cbafcca8e35$var$CheckCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM12.9053 6.21967C13.1982 6.51256 13.1982 6.98744 12.9053 7.28033L8.40533 11.7803C8.11244 12.0732 7.63756 12.0732 7.34467 11.7803L5.09467 9.53033C4.80178 9.23744 4.80178 8.76256 5.09467 8.46967C5.38756 8.17678 5.86244 8.17678 6.15533 8.46967L7.875 10.1893L11.8447 6.21967C12.1376 5.92678 12.6124 5.92678 12.9053 6.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b5d06cbafcca8e35$var$CheckCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b5d06cbafcca8e35$var$CheckCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b5d06cbafcca8e35$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $dfd33cee3229493c$var$$b5d06cbafcca8e35$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b5d06cbafcca8e35$var$CheckCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``check-square.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$99e6284b7dcff5d4$var$CheckSquareIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81902C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77085 3 5.20757 3 5.85V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H5.85C5.20757 3 4.77085 3.00058 4.43328 3.02816ZM12.9053 6.21967C13.1982 6.51256 13.1982 6.98744 12.9053 7.28033L8.40533 11.7803C8.11244 12.0732 7.63756 12.0732 7.34467 11.7803L5.09467 9.53033C4.80178 9.23744 4.80178 8.76256 5.09467 8.46967C5.38756 8.17678 5.86244 8.17678 6.15533 8.46967L7.875 10.1893L11.8447 6.21967C12.1376 5.92678 12.6124 5.92678 12.9053 6.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$99e6284b7dcff5d4$var$CheckSquareIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$99e6284b7dcff5d4$var$CheckSquareIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$99e6284b7dcff5d4$var$CheckSquareIcon.displayName = "CheckSquareIcon";
var $dfd33cee3229493c$var$$99e6284b7dcff5d4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$99e6284b7dcff5d4$var$CheckSquareIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``check.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$4ec7b3a9b1d27820$var$CheckIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M15.5303 3.96967C15.8232 4.26256 15.8232 4.73744 15.5303 5.03033L7.28033 13.2803C6.98744 13.5732 6.51256 13.5732 6.21967 13.2803L2.46967 9.53033C2.17678 9.23744 2.17678 8.76256 2.46967 8.46967C2.76256 8.17678 3.23744 8.17678 3.53033 8.46967L6.75 11.6893L14.4697 3.96967C14.7626 3.67678 15.2374 3.67678 15.5303 3.96967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$4ec7b3a9b1d27820$var$CheckIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$4ec7b3a9b1d27820$var$CheckIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$4ec7b3a9b1d27820$var$CheckIcon.displayName = "CheckIcon";
var $dfd33cee3229493c$var$$4ec7b3a9b1d27820$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4ec7b3a9b1d27820$var$CheckIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``chevron-down.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a91646f62d6b2784$var$ChevronDownIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.96967 6.21967C4.26256 5.92678 4.73744 5.92678 5.03033 6.21967L9 10.1893L12.9697 6.21967C13.2626 5.92678 13.7374 5.92678 14.0303 6.21967C14.3232 6.51256 14.3232 6.98744 14.0303 7.28033L9.53033 11.7803C9.23744 12.0732 8.76256 12.0732 8.46967 11.7803L3.96967 7.28033C3.67678 6.98744 3.67678 6.51256 3.96967 6.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a91646f62d6b2784$var$ChevronDownIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a91646f62d6b2784$var$ChevronDownIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a91646f62d6b2784$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $dfd33cee3229493c$var$$a91646f62d6b2784$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a91646f62d6b2784$var$ChevronDownIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``chevron-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$91cd663de23e2605$var$ChevronLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M11.7803 3.96967C12.0732 4.26256 12.0732 4.73744 11.7803 5.03033L7.81066 9L11.7803 12.9697C12.0732 13.2626 12.0732 13.7374 11.7803 14.0303C11.4874 14.3232 11.0126 14.3232 10.7197 14.0303L6.21967 9.53033C5.92678 9.23744 5.92678 8.76256 6.21967 8.46967L10.7197 3.96967C11.0126 3.67678 11.4874 3.67678 11.7803 3.96967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$91cd663de23e2605$var$ChevronLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$91cd663de23e2605$var$ChevronLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$91cd663de23e2605$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $dfd33cee3229493c$var$$91cd663de23e2605$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$91cd663de23e2605$var$ChevronLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``chevron-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$f9cd72ca6584e2be$var$ChevronRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.21967 3.96967C6.51256 3.67678 6.98744 3.67678 7.28033 3.96967L11.7803 8.46967C12.0732 8.76256 12.0732 9.23744 11.7803 9.53033L7.28033 14.0303C6.98744 14.3232 6.51256 14.3232 6.21967 14.0303C5.92678 13.7374 5.92678 13.2626 6.21967 12.9697L10.1893 9L6.21967 5.03033C5.92678 4.73744 5.92678 4.26256 6.21967 3.96967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$f9cd72ca6584e2be$var$ChevronRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$f9cd72ca6584e2be$var$ChevronRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$f9cd72ca6584e2be$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $dfd33cee3229493c$var$$f9cd72ca6584e2be$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f9cd72ca6584e2be$var$ChevronRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``chevron-selector.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$43f47deccd11679a$var$ChevronSelectorIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.46967 2.46967C8.76256 2.17678 9.23744 2.17678 9.53033 2.46967L13.2803 6.21967C13.5732 6.51256 13.5732 6.98744 13.2803 7.28033C12.9874 7.57322 12.5126 7.57322 12.2197 7.28033L9 4.06066L5.78033 7.28033C5.48744 7.57322 5.01256 7.57322 4.71967 7.28033C4.42678 6.98744 4.42678 6.51256 4.71967 6.21967L8.46967 2.46967ZM4.71967 10.7197C5.01256 10.4268 5.48744 10.4268 5.78033 10.7197L9 13.9393L12.2197 10.7197C12.5126 10.4268 12.9874 10.4268 13.2803 10.7197C13.5732 11.0126 13.5732 11.4874 13.2803 11.7803L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303L4.71967 11.7803C4.42678 11.4874 4.42678 11.0126 4.71967 10.7197Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$43f47deccd11679a$var$ChevronSelectorIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$43f47deccd11679a$var$ChevronSelectorIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$43f47deccd11679a$var$ChevronSelectorIcon.displayName = "ChevronSelectorIcon";
var $dfd33cee3229493c$var$$43f47deccd11679a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$43f47deccd11679a$var$ChevronSelectorIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``chevron-up.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$082f0a59b33f843a$var$ChevronUpIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.46967 6.21967C8.76256 5.92678 9.23744 5.92678 9.53033 6.21967L14.0303 10.7197C14.3232 11.0126 14.3232 11.4874 14.0303 11.7803C13.7374 12.0732 13.2626 12.0732 12.9697 11.7803L9 7.81066L5.03033 11.7803C4.73744 12.0732 4.26256 12.0732 3.96967 11.7803C3.67678 11.4874 3.67678 11.0126 3.96967 10.7197L8.46967 6.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$082f0a59b33f843a$var$ChevronUpIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$082f0a59b33f843a$var$ChevronUpIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$082f0a59b33f843a$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $dfd33cee3229493c$var$$082f0a59b33f843a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$082f0a59b33f843a$var$ChevronUpIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$cc4df49125c3c0d9$var$CircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$cc4df49125c3c0d9$var$CircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cc4df49125c3c0d9$var$CircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$cc4df49125c3c0d9$var$CircleIcon.displayName = "CircleIcon";
var $dfd33cee3229493c$var$$cc4df49125c3c0d9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cc4df49125c3c0d9$var$CircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``clipboard.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$54ec7b9281c893c0$var$ClipboardIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.17608 0.750002C7.18404 0.750003 7.19202 0.750004 7.2 0.750004L10.8239 0.750002C11.0132 0.749979 11.1976 0.749957 11.3537 0.762713C11.5251 0.77672 11.7274 0.809771 11.931 0.913494C12.2132 1.0573 12.4427 1.28678 12.5865 1.56902C12.6902 1.77259 12.7233 1.97489 12.7373 2.14633C12.7402 2.18153 12.7424 2.21817 12.7441 2.25597C13.0405 2.26554 13.2943 2.29003 13.5265 2.35223C14.5617 2.62963 15.3704 3.43827 15.6478 4.47355C15.7506 4.85729 15.7504 5.30028 15.75 5.89682C15.75 5.93072 15.75 5.9651 15.75 6V12.931C15.75 13.5347 15.75 14.033 15.7169 14.4389C15.6824 14.8604 15.6085 15.248 15.423 15.612C15.1354 16.1765 14.6765 16.6354 14.112 16.923C13.748 17.1085 13.3604 17.1824 12.9389 17.2169C12.533 17.25 12.0347 17.25 11.431 17.25H6.56901C5.96529 17.25 5.46702 17.25 5.06113 17.2169C4.63956 17.1824 4.25203 17.1085 3.88803 16.923C3.32354 16.6354 2.8646 16.1765 2.57698 15.612C2.39151 15.248 2.31759 14.8604 2.28315 14.4389C2.24998 14.033 2.24999 13.5347 2.25 12.931L2.25 6C2.25 5.9651 2.24998 5.93071 2.24996 5.89682C2.24964 5.30028 2.2494 4.85729 2.35222 4.47355C2.62962 3.43827 3.43827 2.62963 4.47354 2.35223C4.70568 2.29003 4.9595 2.26554 5.25588 2.25597C5.25761 2.21817 5.25983 2.18153 5.26271 2.14633C5.27672 1.97489 5.30977 1.77259 5.41349 1.56902C5.5573 1.28677 5.78677 1.0573 6.06901 0.913494C6.27258 0.809771 6.47488 0.77672 6.64633 0.762713C6.80245 0.749957 6.98679 0.749979 7.17608 0.750002ZM5.2565 3.75717C5.05919 3.764 4.95186 3.77698 4.86177 3.80112C4.34413 3.93982 3.93981 4.34414 3.80111 4.86178C3.75644 5.02848 3.75 5.25424 3.75 6V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56901 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H11.4C12.0424 15.75 12.4792 15.7494 12.8167 15.7218C13.1455 15.695 13.3137 15.6463 13.431 15.5865C13.7132 15.4427 13.9427 15.2132 14.0865 14.931C14.1463 14.8137 14.195 14.6455 14.2218 14.3167C14.2494 13.9792 14.25 13.5424 14.25 12.9V6C14.25 5.25424 14.2436 5.02848 14.1989 4.86178C14.0602 4.34414 13.6559 3.93982 13.1382 3.80112C13.0481 3.77698 12.9408 3.764 12.7435 3.75717C12.7419 3.79034 12.7398 3.82257 12.7373 3.85368C12.7233 4.02512 12.6902 4.22742 12.5865 4.43099C12.4427 4.71323 12.2132 4.9427 11.931 5.08651C11.7274 5.19024 11.5251 5.22329 11.3537 5.2373C11.1976 5.25005 11.0132 5.25003 10.8239 5.25001L7.2 5.25C7.19202 5.25 7.18404 5.25 7.17608 5.25001C6.98679 5.25003 6.80245 5.25005 6.64633 5.2373C6.47488 5.22329 6.27258 5.19024 6.06901 5.08651C5.78677 4.9427 5.5573 4.71323 5.41349 4.43099C5.30977 4.22742 5.27672 4.02512 5.26271 3.85368C5.26017 3.82257 5.25813 3.79034 5.2565 3.75717ZM11.25 2.7C11.25 2.47761 11.2494 2.35592 11.2423 2.26848C11.242 2.265 11.2417 2.2617 11.2414 2.25859C11.2383 2.2583 11.235 2.25802 11.2315 2.25773C11.1441 2.25059 11.0224 2.25 10.8 2.25H7.2C6.9776 2.25 6.85591 2.25059 6.76848 2.25773C6.76499 2.25802 6.7617 2.2583 6.75859 2.25859C6.7583 2.2617 6.75801 2.265 6.75773 2.26848C6.75058 2.35592 6.75 2.47761 6.75 2.7V3.3C6.75 3.5224 6.75058 3.64409 6.75773 3.73153C6.75801 3.73501 6.7583 3.73831 6.75859 3.74142C6.7617 3.7417 6.76499 3.74199 6.76847 3.74228C6.85591 3.74942 6.9776 3.75 7.2 3.75H10.8C11.0224 3.75 11.1441 3.74942 11.2315 3.74228C11.235 3.74199 11.2383 3.7417 11.2414 3.74142C11.2417 3.73831 11.242 3.73501 11.2423 3.73153C11.2494 3.64409 11.25 3.5224 11.25 3.3V2.7Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$54ec7b9281c893c0$var$ClipboardIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$54ec7b9281c893c0$var$ClipboardIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$54ec7b9281c893c0$var$ClipboardIcon.displayName = "ClipboardIcon";
var $dfd33cee3229493c$var$$54ec7b9281c893c0$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$54ec7b9281c893c0$var$ClipboardIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``clock.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$dd1c1e541c38bb5e$var$ClockIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM9 3.75C9.41421 3.75 9.75 4.08579 9.75 4.5V8.53647L12.3354 9.82918C12.7059 10.0144 12.8561 10.4649 12.6708 10.8354C12.4856 11.2059 12.0351 11.3561 11.6646 11.1708L8.66459 9.67082C8.4105 9.54378 8.25 9.28408 8.25 9V4.5C8.25 4.08579 8.58579 3.75 9 3.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$dd1c1e541c38bb5e$var$ClockIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$dd1c1e541c38bb5e$var$ClockIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$dd1c1e541c38bb5e$var$ClockIcon.displayName = "ClockIcon";
var $dfd33cee3229493c$var$$dd1c1e541c38bb5e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$dd1c1e541c38bb5e$var$ClockIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``code-snippet.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$2a1012ad8c51e960$var$CodeSnippetIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M10.6627 1.51787C11.067 1.60772 11.322 2.00836 11.2321 2.41271L8.23214 15.9127C8.14228 16.3171 7.74165 16.572 7.3373 16.4821C6.93295 16.3923 6.678 15.9917 6.76786 15.5873L9.76786 2.08731C9.85772 1.68296 10.2583 1.42801 10.6627 1.51787ZM5.78033 4.71968C6.07322 5.01257 6.07322 5.48744 5.78033 5.78034L2.56066 9.00001L5.78033 12.2197C6.07322 12.5126 6.07322 12.9874 5.78033 13.2803C5.48744 13.5732 5.01256 13.5732 4.71967 13.2803L0.96967 9.53034C0.676777 9.23745 0.676777 8.76257 0.96967 8.46968L4.71967 4.71968C5.01256 4.42678 5.48744 4.42678 5.78033 4.71968ZM12.2197 4.71968C12.5126 4.42678 12.9874 4.42678 13.2803 4.71968L17.0303 8.46968C17.3232 8.76257 17.3232 9.23745 17.0303 9.53034L13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803C11.9268 12.9874 11.9268 12.5126 12.2197 12.2197L15.4393 9.00001L12.2197 5.78034C11.9268 5.48744 11.9268 5.01257 12.2197 4.71968Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$2a1012ad8c51e960$var$CodeSnippetIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$2a1012ad8c51e960$var$CodeSnippetIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$2a1012ad8c51e960$var$CodeSnippetIcon.displayName = "CodeSnippetIcon";
var $dfd33cee3229493c$var$$2a1012ad8c51e960$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2a1012ad8c51e960$var$CodeSnippetIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``coins.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0ef015b5d730df8f$var$CoinsIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M2.29597 3.75C2.30123 3.75479 2.30693 3.75984 2.31311 3.76515C2.42835 3.86423 2.63899 3.98745 2.96449 4.10582C3.60932 4.3403 4.54985 4.5 5.625 4.5C6.70015 4.5 7.64068 4.3403 8.28551 4.10582C8.61101 3.98745 8.82165 3.86423 8.9369 3.76515C8.94307 3.75985 8.94877 3.75479 8.95403 3.75C8.94877 3.74521 8.94307 3.74015 8.9369 3.73485C8.82165 3.63577 8.61101 3.51255 8.28551 3.39418C7.64068 3.1597 6.70015 3 5.625 3C4.54985 3 3.60932 3.1597 2.96449 3.39418C2.63899 3.51255 2.42835 3.63577 2.31311 3.73485C2.30693 3.74016 2.30123 3.74521 2.29597 3.75ZM9 5.43747C8.93361 5.46475 8.86623 5.49074 8.79812 5.51551C7.95 5.82391 6.82803 6 5.625 6C4.42197 6 3.3 5.82391 2.45188 5.51551C2.38377 5.49074 2.31639 5.46475 2.25 5.43747V7.07759C2.26096 7.09109 2.28037 7.11201 2.31311 7.14015C2.42835 7.23923 2.63899 7.36245 2.96449 7.48081C3.60932 7.7153 4.54985 7.875 5.625 7.875C6.70015 7.875 7.64068 7.7153 8.28551 7.48081C8.61101 7.36245 8.82165 7.23923 8.9369 7.14015C8.96963 7.11201 8.98904 7.09109 9 7.07759V5.43747ZM9 8.81247C8.93361 8.83975 8.86623 8.86574 8.79812 8.8905C7.95 9.19891 6.82803 9.375 5.625 9.375C4.42197 9.375 3.3 9.19891 2.45188 8.8905C2.38377 8.86574 2.31639 8.83975 2.25 8.81247V10.4526C2.26096 10.4661 2.28037 10.487 2.31311 10.5152C2.42835 10.6142 2.63899 10.7375 2.96449 10.8558C3.60932 11.0903 4.54985 11.25 5.625 11.25C6.39545 11.25 7.10243 11.1679 7.6826 11.0322C8.18537 10.9146 8.55221 10.7663 8.78201 10.6256C8.84906 10.5006 8.92184 10.3792 9 10.2617V8.81247ZM10.5 8.85202V3.75C10.5 3.24207 10.2146 2.85516 9.91478 2.59742C9.61255 2.33758 9.2191 2.13758 8.79812 1.98449C7.95 1.67609 6.82803 1.5 5.625 1.5C4.42197 1.5 3.3 1.67609 2.45188 1.98449C2.0309 2.13758 1.63745 2.33758 1.33522 2.59742C1.03543 2.85516 0.75 3.24207 0.75 3.75V13.875C0.75 14.3829 1.03543 14.7698 1.33522 15.0276C1.63745 15.2874 2.0309 15.4874 2.45188 15.6405C3.3 15.9489 4.42197 16.125 5.625 16.125C6.52662 16.125 7.3767 16.0262 8.09842 15.8501C8.48111 15.7567 8.84907 15.6364 9.17671 15.4856C9.99919 16.5583 11.2938 17.25 12.75 17.25C15.2353 17.25 17.25 15.2353 17.25 12.75C17.25 10.2647 15.2353 8.25 12.75 8.25C11.9304 8.25 11.1619 8.46914 10.5 8.85202ZM8.25147 12.8661C8.26286 13.3157 8.34019 13.749 8.47416 14.1565C8.27996 14.2395 8.03663 14.3211 7.74283 14.3928C7.15206 14.537 6.42277 14.625 5.625 14.625C4.54985 14.625 3.60932 14.4653 2.96449 14.2308C2.63899 14.1125 2.42835 13.9892 2.31311 13.8902C2.28037 13.862 2.26096 13.8411 2.25 13.8276V12.1875C2.31639 12.2147 2.38377 12.2407 2.45188 12.2655C3.3 12.5739 4.42197 12.75 5.625 12.75C6.4963 12.75 7.31907 12.6577 8.0242 12.4928C8.10391 12.4742 8.18289 12.4544 8.26096 12.4335C8.25369 12.5381 8.25 12.6436 8.25 12.75C8.25 12.7888 8.25049 12.8275 8.25147 12.8661ZM9.75 12.75C9.75 14.4069 11.0931 15.75 12.75 15.75C14.4069 15.75 15.75 14.4069 15.75 12.75C15.75 11.0931 14.4069 9.75 12.75 9.75C11.0931 9.75 9.75 11.0931 9.75 12.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0ef015b5d730df8f$var$CoinsIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0ef015b5d730df8f$var$CoinsIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0ef015b5d730df8f$var$CoinsIcon.displayName = "CoinsIcon";
var $dfd33cee3229493c$var$$0ef015b5d730df8f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0ef015b5d730df8f$var$CoinsIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``columns.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$cc0290529cf213df$var$ColumnsIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM7.5 15H10.5V3H7.5V15ZM6 3V15H5.85C5.20757 15 4.77085 14.9994 4.43328 14.9718C4.10447 14.945 3.93631 14.8963 3.81902 14.8365C3.53677 14.6927 3.3073 14.4632 3.16349 14.181C3.10372 14.0637 3.05503 13.8955 3.02816 13.5667C3.00058 13.2292 3 12.7924 3 12.15V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H6ZM12 3V15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H12Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$cc0290529cf213df$var$ColumnsIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cc0290529cf213df$var$ColumnsIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$cc0290529cf213df$var$ColumnsIcon.displayName = "ColumnsIcon";
var $dfd33cee3229493c$var$$cc0290529cf213df$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cc0290529cf213df$var$ColumnsIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``command.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$7b30c932c1359ed0$var$CommandIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 4.5C1.5 2.84315 2.84315 1.5 4.5 1.5C6.15685 1.5 7.5 2.84315 7.5 4.5V6H10.5V4.5C10.5 2.84315 11.8431 1.5 13.5 1.5C15.1569 1.5 16.5 2.84315 16.5 4.5C16.5 6.15685 15.1569 7.5 13.5 7.5H12V10.5H13.5C15.1569 10.5 16.5 11.8431 16.5 13.5C16.5 15.1569 15.1569 16.5 13.5 16.5C11.8431 16.5 10.5 15.1569 10.5 13.5V12H7.5V13.5C7.5 15.1569 6.15685 16.5 4.5 16.5C2.84315 16.5 1.5 15.1569 1.5 13.5C1.5 11.8431 2.84315 10.5 4.5 10.5H6V7.5H4.5C2.84315 7.5 1.5 6.15685 1.5 4.5ZM6 6V4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6H6ZM7.5 7.5V10.5H10.5V7.5H7.5ZM6 12H4.5C3.67157 12 3 12.6716 3 13.5C3 14.3284 3.67157 15 4.5 15C5.32843 15 6 14.3284 6 13.5V12ZM12 12V13.5C12 14.3284 12.6716 15 13.5 15C14.3284 15 15 14.3284 15 13.5C15 12.6716 14.3284 12 13.5 12H12ZM12 6H13.5C14.3284 6 15 5.32843 15 4.5C15 3.67157 14.3284 3 13.5 3C12.6716 3 12 3.67157 12 4.5V6Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$7b30c932c1359ed0$var$CommandIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$7b30c932c1359ed0$var$CommandIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$7b30c932c1359ed0$var$CommandIcon.displayName = "CommandIcon";
var $dfd33cee3229493c$var$$7b30c932c1359ed0$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7b30c932c1359ed0$var$CommandIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``compare-arrows.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$964109b4c988d171$var$CompareArrowsIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "",
                d: "M5.94375 15L5.15625 14.2125L7.425 11.9438H1.5V10.8188H7.425L5.15625 8.55L5.94375 7.7625L9.5625 11.3813L5.94375 15ZM12.0563 10.2375L8.4375 6.61875L12.0563 3L12.8438 3.7875L10.575 6.05625H16.5V7.18125H10.575L12.8438 9.45L12.0563 10.2375Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$964109b4c988d171$var$CompareArrowsIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$964109b4c988d171$var$CompareArrowsIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$964109b4c988d171$var$CompareArrowsIcon.displayName = "CompareArrowsIcon";
var $dfd33cee3229493c$var$$964109b4c988d171$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$964109b4c988d171$var$CompareArrowsIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``compass.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$f77c7884b5abe8c5$var$CompassIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM10.9941 7.00585L8.00293 8.00293L7.00585 10.9941L9.99707 9.99707L10.9941 7.00585ZM11.2975 5.33739C11.4344 5.3052 11.6907 5.25548 11.9649 5.35328C12.283 5.4667 12.5333 5.717 12.6467 6.03506C12.7445 6.30933 12.6948 6.56557 12.6626 6.70254C12.6295 6.8434 12.5741 7.00942 12.5203 7.17074C12.5176 7.17904 12.5148 7.18732 12.512 7.19559L11.3964 10.5426C11.3944 10.5485 11.3922 10.5553 11.3897 10.563C11.3655 10.6377 11.3153 10.7924 11.2221 10.9287C11.1433 11.0438 11.0438 11.1433 10.9287 11.2221C10.7924 11.3153 10.6377 11.3655 10.563 11.3897C10.5553 11.3922 10.5485 11.3944 10.5426 11.3964L7.17074 12.5203C7.00942 12.5741 6.84339 12.6295 6.70254 12.6626C6.56557 12.6948 6.30933 12.7445 6.03506 12.6467C5.717 12.5333 5.4667 12.283 5.35328 11.9649C5.25548 11.6907 5.3052 11.4344 5.33739 11.2975C5.37048 11.1566 5.42586 10.9906 5.47967 10.8293C5.48244 10.821 5.48521 10.8127 5.48796 10.8044L6.60362 7.45743C6.60558 7.45154 6.6078 7.44469 6.6103 7.43699C6.63453 7.36227 6.68467 7.20762 6.77792 7.0713C6.85668 6.95616 6.95616 6.85668 7.0713 6.77792C7.20762 6.68467 7.36227 6.63453 7.43699 6.6103C7.44469 6.6078 7.45154 6.60558 7.45743 6.60362L10.8044 5.48796C10.8127 5.48521 10.8209 5.48245 10.8292 5.47968C10.9906 5.42587 11.1566 5.37049 11.2975 5.33739Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$f77c7884b5abe8c5$var$CompassIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$f77c7884b5abe8c5$var$CompassIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$f77c7884b5abe8c5$var$CompassIcon.displayName = "CompassIcon";
var $dfd33cee3229493c$var$$f77c7884b5abe8c5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f77c7884b5abe8c5$var$CompassIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``copy-03.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$63a02c97cadfdcdd$var$Copy03Icon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.37109 0.750001H14.1289C14.5243 0.749987 14.8653 0.749976 15.1463 0.772928C15.4428 0.797154 15.7377 0.850641 16.0215 0.995237C16.4448 1.21095 16.7891 1.55516 17.0048 1.97852C17.1494 2.26231 17.2028 2.55722 17.2271 2.85373C17.25 3.13466 17.25 3.47572 17.25 3.87108V9.62893C17.25 10.0243 17.25 10.3653 17.2271 10.6463C17.2028 10.9428 17.1494 11.2377 17.0048 11.5215C16.7891 11.9448 16.4448 12.2891 16.0215 12.5048C15.7377 12.6494 15.4428 12.7028 15.1463 12.7271C14.8653 12.75 14.5243 12.75 14.1289 12.75H12.75V14.1289C12.75 14.5243 12.75 14.8653 12.7271 15.1463C12.7028 15.4428 12.6494 15.7377 12.5048 16.0215C12.2891 16.4448 11.9448 16.7891 11.5215 17.0048C11.2377 17.1494 10.9428 17.2028 10.6463 17.2271C10.3653 17.25 10.0243 17.25 9.62893 17.25H3.87108C3.47572 17.25 3.13466 17.25 2.85373 17.2271C2.55722 17.2028 2.26231 17.1494 1.97852 17.0048C1.55516 16.7891 1.21095 16.4448 0.995237 16.0215C0.850641 15.7377 0.797154 15.4428 0.772928 15.1463C0.749976 14.8653 0.749987 14.5243 0.750001 14.1289V8.37109C0.749987 7.97573 0.749976 7.63466 0.772928 7.35373C0.797154 7.05722 0.850641 6.76231 0.995237 6.47852C1.21095 6.05516 1.55516 5.71095 1.97852 5.49524C2.26231 5.35064 2.55722 5.29715 2.85373 5.27293C3.13466 5.24998 3.47573 5.24999 3.87109 5.25L5.25 5.25L5.25 3.87109C5.24999 3.47573 5.24998 3.13466 5.27293 2.85373C5.29715 2.55722 5.35064 2.26231 5.49524 1.97852C5.71095 1.55516 6.05516 1.21095 6.47852 0.995237C6.76231 0.850641 7.05722 0.797154 7.35373 0.772928C7.63466 0.749976 7.97573 0.749987 8.37109 0.750001ZM3.9 6.75C3.46759 6.75 3.18838 6.75058 2.97588 6.76795C2.77213 6.78459 2.69659 6.81285 2.65951 6.83175C2.51839 6.90365 2.40365 7.01839 2.33175 7.15951C2.31285 7.19659 2.28459 7.27213 2.26795 7.47588C2.25058 7.68838 2.25 7.96759 2.25 8.4V14.1C2.25 14.5324 2.25058 14.8116 2.26795 15.0241C2.28459 15.2279 2.31285 15.3034 2.33175 15.3405C2.40365 15.4816 2.51839 15.5963 2.65951 15.6683C2.69659 15.6872 2.77213 15.7154 2.97588 15.7321C3.18838 15.7494 3.46759 15.75 3.9 15.75H9.6C10.0324 15.75 10.3116 15.7494 10.5241 15.7321C10.7279 15.7154 10.8034 15.6872 10.8405 15.6683C10.9816 15.5963 11.0964 15.4816 11.1683 15.3405C11.1872 15.3034 11.2154 15.2279 11.2321 15.0241C11.2494 14.8116 11.25 14.5324 11.25 14.1V8.4C11.25 7.96759 11.2494 7.68838 11.2321 7.47588C11.2154 7.27213 11.1872 7.19659 11.1683 7.15951C11.0964 7.01839 10.9816 6.90365 10.8405 6.83175C10.8034 6.81285 10.7279 6.78459 10.5241 6.76795C10.3116 6.75058 10.0324 6.75 9.6 6.75H3.9ZM12.75 11.25V8.37111C12.75 7.97574 12.75 7.63466 12.7271 7.35373C12.7028 7.05722 12.6494 6.76231 12.5048 6.47852C12.2891 6.05516 11.9448 5.71095 11.5215 5.49524C11.2377 5.35064 10.9428 5.29715 10.6463 5.27293C10.3653 5.24998 10.0243 5.24999 9.62891 5.25L6.75 5.25V3.9C6.75 3.46759 6.75058 3.18838 6.76795 2.97588C6.78459 2.77213 6.81285 2.69659 6.83175 2.65951C6.90365 2.51839 7.01839 2.40365 7.15951 2.33175C7.19659 2.31285 7.27213 2.28459 7.47588 2.26795C7.68838 2.25058 7.96759 2.25 8.4 2.25H14.1C14.5324 2.25 14.8116 2.25058 15.0241 2.26795C15.2279 2.28459 15.3034 2.31285 15.3405 2.33175C15.4816 2.40365 15.5963 2.51839 15.6683 2.65951C15.6872 2.69659 15.7154 2.77213 15.7321 2.97588C15.7494 3.18838 15.75 3.46759 15.75 3.9V9.6C15.75 10.0324 15.7494 10.3116 15.7321 10.5241C15.7154 10.7279 15.6872 10.8034 15.6683 10.8405C15.5963 10.9816 15.4816 11.0964 15.3405 11.1683C15.3034 11.1872 15.2279 11.2154 15.0241 11.2321C14.8116 11.2494 14.5324 11.25 14.1 11.25H12.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$63a02c97cadfdcdd$var$Copy03Icon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$63a02c97cadfdcdd$var$Copy03Icon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$63a02c97cadfdcdd$var$Copy03Icon.displayName = "Copy03Icon";
var $dfd33cee3229493c$var$$63a02c97cadfdcdd$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$63a02c97cadfdcdd$var$Copy03Icon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``corner-down-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$967002e0b4faa9b2$var$CornerDownLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M15 2.25C15.4142 2.25 15.75 2.58579 15.75 3V4.08333C15.75 5.31523 15.75 6.28569 15.6862 7.06667C15.6211 7.86343 15.4859 8.5288 15.1778 9.13345C14.6744 10.1213 13.8713 10.9244 12.8834 11.4278C12.2788 11.7359 11.6134 11.8711 10.8167 11.9362C10.0357 12 9.06521 12 7.83329 12H4.81066L7.28033 14.4697C7.57322 14.7626 7.57322 15.2374 7.28033 15.5303C6.98744 15.8232 6.51256 15.8232 6.21967 15.5303L2.46967 11.7803C2.17678 11.4874 2.17678 11.0126 2.46967 10.7197L6.21967 6.96967C6.51256 6.67678 6.98744 6.67678 7.28033 6.96967C7.57322 7.26256 7.57322 7.73744 7.28033 8.03033L4.81066 10.5H7.8C9.07249 10.5 9.98176 10.4994 10.6945 10.4412C11.3985 10.3837 11.8445 10.2737 12.2025 10.0913C12.9081 9.73175 13.4817 9.15807 13.8413 8.45246C14.0237 8.09451 14.1337 7.64852 14.1912 6.94452C14.2494 6.23176 14.25 5.32249 14.25 4.05V3C14.25 2.58579 14.5858 2.25 15 2.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$967002e0b4faa9b2$var$CornerDownLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$967002e0b4faa9b2$var$CornerDownLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$967002e0b4faa9b2$var$CornerDownLeftIcon.displayName = "CornerDownLeftIcon";
var $dfd33cee3229493c$var$$967002e0b4faa9b2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$967002e0b4faa9b2$var$CornerDownLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``currency.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e5e716939e4fbc68$var$CurrencyIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM9 3.375C9.41421 3.375 9.75 3.71079 9.75 4.125V4.5H9.875C11.2557 4.5 12.375 5.61929 12.375 7C12.375 7.41421 12.0392 7.75 11.625 7.75C11.2108 7.75 10.875 7.41421 10.875 7C10.875 6.44772 10.4273 6 9.875 6H8.25C7.62868 6 7.125 6.50368 7.125 7.125C7.125 7.74632 7.62868 8.25 8.25 8.25H9.75C11.1997 8.25 12.375 9.42525 12.375 10.875C12.375 12.3247 11.1997 13.5 9.75 13.5V13.875C9.75 14.2892 9.41421 14.625 9 14.625C8.58579 14.625 8.25 14.2892 8.25 13.875V13.5H8.125C6.74429 13.5 5.625 12.3807 5.625 11C5.625 10.5858 5.96079 10.25 6.375 10.25C6.78921 10.25 7.125 10.5858 7.125 11C7.125 11.5523 7.57271 12 8.125 12H9.75C10.3713 12 10.875 11.4963 10.875 10.875C10.875 10.2537 10.3713 9.75 9.75 9.75H8.25C6.80025 9.75 5.625 8.57475 5.625 7.125C5.625 5.67525 6.80025 4.5 8.25 4.5V4.125C8.25 3.71079 8.58579 3.375 9 3.375Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e5e716939e4fbc68$var$CurrencyIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e5e716939e4fbc68$var$CurrencyIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e5e716939e4fbc68$var$CurrencyIcon.displayName = "CurrencyIcon";
var $dfd33cee3229493c$var$$e5e716939e4fbc68$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e5e716939e4fbc68$var$CurrencyIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``cursor.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$564791ab830da4b8$var$CursorIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.67539 1.96481C3.6838 1.96783 3.6922 1.97085 3.70059 1.97386L15.6448 6.26153C15.855 6.33696 16.0566 6.40929 16.2119 6.48067C16.3431 6.54098 16.6301 6.67813 16.7924 6.97634C16.9698 7.3024 16.9749 7.69501 16.8061 8.02563C16.6518 8.32799 16.3684 8.47262 16.2388 8.53636C16.0855 8.61179 15.8859 8.68939 15.6777 8.7703L10.7043 10.7044L8.77026 15.6778C8.68935 15.8859 8.61176 16.0855 8.53632 16.2389C8.47259 16.3684 8.32795 16.6518 8.0256 16.8062C7.69498 16.975 7.30237 16.9698 6.9763 16.7924C6.6781 16.6301 6.54095 16.3431 6.48064 16.2119C6.40925 16.0566 6.33692 15.855 6.2615 15.6448L1.97386 3.70059C1.97084 3.69219 1.96783 3.68379 1.96481 3.67539C1.90411 3.5064 1.84252 3.33494 1.8049 3.19017C1.7692 3.05283 1.71003 2.78768 1.80848 2.5034C1.92135 2.17748 2.17748 1.92135 2.5034 1.80848C2.78768 1.71003 3.05283 1.7692 3.19017 1.8049C3.33494 1.84253 3.5064 1.90411 3.67539 1.96481ZM10.7575 10.5694C10.7575 10.5693 10.7575 10.5693 10.7575 10.5694V10.5694ZM10.5694 10.7575C10.5693 10.7575 10.5693 10.7575 10.5694 10.7575V10.7575ZM3.49309 3.49309L7.52806 14.7334L9.33026 10.0992C9.33226 10.0941 9.33453 10.0881 9.33707 10.0814C9.36189 10.0162 9.41319 9.88138 9.49877 9.76139C9.57115 9.65993 9.65989 9.57119 9.76136 9.49881C9.88134 9.41323 10.0162 9.36193 10.0814 9.33711C10.0881 9.33457 10.094 9.3323 10.0992 9.3303L14.7334 7.52809L3.49309 3.49309Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$564791ab830da4b8$var$CursorIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$564791ab830da4b8$var$CursorIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$564791ab830da4b8$var$CursorIcon.displayName = "CursorIcon";
var $dfd33cee3229493c$var$$564791ab830da4b8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$564791ab830da4b8$var$CursorIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``dollar.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b2ea0f3f4ff62475$var$DollarIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V2.25H10.5C12.5711 2.25 14.25 3.92893 14.25 6C14.25 6.41421 13.9142 6.75 13.5 6.75C13.0858 6.75 12.75 6.41421 12.75 6C12.75 4.75736 11.7426 3.75 10.5 3.75H9.75V8.25H10.5C12.5711 8.25 14.25 9.92893 14.25 12C14.25 14.0711 12.5711 15.75 10.5 15.75H9.75V16.5C9.75 16.9142 9.41421 17.25 9 17.25C8.58579 17.25 8.25 16.9142 8.25 16.5V15.75H7.5C5.42893 15.75 3.75 14.0711 3.75 12C3.75 11.5858 4.08579 11.25 4.5 11.25C4.91421 11.25 5.25 11.5858 5.25 12C5.25 13.2426 6.25736 14.25 7.5 14.25H8.25V9.75H7.5C5.42893 9.75 3.75 8.07107 3.75 6C3.75 3.92893 5.42893 2.25 7.5 2.25H8.25V1.5C8.25 1.08579 8.58579 0.75 9 0.75ZM8.25 3.75H7.5C6.25736 3.75 5.25 4.75736 5.25 6C5.25 7.24264 6.25736 8.25 7.5 8.25H8.25V3.75ZM9.75 9.75V14.25H10.5C11.7426 14.25 12.75 13.2426 12.75 12C12.75 10.7574 11.7426 9.75 10.5 9.75H9.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b2ea0f3f4ff62475$var$DollarIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b2ea0f3f4ff62475$var$DollarIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b2ea0f3f4ff62475$var$DollarIcon.displayName = "DollarIcon";
var $dfd33cee3229493c$var$$b2ea0f3f4ff62475$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b2ea0f3f4ff62475$var$DollarIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``dotpoints.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b1009b85022de90f$var$DotpointsIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 4.5C1.5 3.67157 2.17157 3 3 3C3.82843 3 4.5 3.67157 4.5 4.5C4.5 5.32843 3.82843 6 3 6C2.17157 6 1.5 5.32843 1.5 4.5ZM6 4.5C6 4.08579 6.33579 3.75 6.75 3.75H15.75C16.1642 3.75 16.5 4.08579 16.5 4.5C16.5 4.91421 16.1642 5.25 15.75 5.25L6.75 5.25C6.33579 5.25 6 4.91421 6 4.5ZM1.5 9C1.5 8.17157 2.17157 7.5 3 7.5C3.82843 7.5 4.5 8.17157 4.5 9C4.5 9.82843 3.82843 10.5 3 10.5C2.17157 10.5 1.5 9.82843 1.5 9ZM6 9C6 8.58579 6.33579 8.25 6.75 8.25L15.75 8.25C16.1642 8.25 16.5 8.58579 16.5 9C16.5 9.41421 16.1642 9.75 15.75 9.75L6.75 9.75C6.33579 9.75 6 9.41421 6 9ZM1.5 13.5C1.5 12.6716 2.17157 12 3 12C3.82843 12 4.5 12.6716 4.5 13.5C4.5 14.3284 3.82843 15 3 15C2.17157 15 1.5 14.3284 1.5 13.5ZM6 13.5C6 13.0858 6.33579 12.75 6.75 12.75L15.75 12.75C16.1642 12.75 16.5 13.0858 16.5 13.5C16.5 13.9142 16.1642 14.25 15.75 14.25L6.75 14.25C6.33579 14.25 6 13.9142 6 13.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b1009b85022de90f$var$DotpointsIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b1009b85022de90f$var$DotpointsIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b1009b85022de90f$var$DotpointsIcon.displayName = "DotpointsIcon";
var $dfd33cee3229493c$var$$b1009b85022de90f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b1009b85022de90f$var$DotpointsIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``dots-column.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$3ed1542d8cf6fcbb$var$DotsColumnIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.5 3.75C4.5 2.92157 5.17157 2.25 6 2.25C6.82843 2.25 7.5 2.92157 7.5 3.75C7.5 4.57843 6.82843 5.25 6 5.25C5.17157 5.25 4.5 4.57843 4.5 3.75ZM10.5 3.75C10.5 2.92157 11.1716 2.25 12 2.25C12.8284 2.25 13.5 2.92157 13.5 3.75C13.5 4.57843 12.8284 5.25 12 5.25C11.1716 5.25 10.5 4.57843 10.5 3.75ZM4.5 9C4.5 8.17157 5.17157 7.5 6 7.5C6.82843 7.5 7.5 8.17157 7.5 9C7.5 9.82843 6.82843 10.5 6 10.5C5.17157 10.5 4.5 9.82843 4.5 9ZM10.5 9C10.5 8.17157 11.1716 7.5 12 7.5C12.8284 7.5 13.5 8.17157 13.5 9C13.5 9.82843 12.8284 10.5 12 10.5C11.1716 10.5 10.5 9.82843 10.5 9ZM4.5 14.25C4.5 13.4216 5.17157 12.75 6 12.75C6.82843 12.75 7.5 13.4216 7.5 14.25C7.5 15.0784 6.82843 15.75 6 15.75C5.17157 15.75 4.5 15.0784 4.5 14.25ZM10.5 14.25C10.5 13.4216 11.1716 12.75 12 12.75C12.8284 12.75 13.5 13.4216 13.5 14.25C13.5 15.0784 12.8284 15.75 12 15.75C11.1716 15.75 10.5 15.0784 10.5 14.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$3ed1542d8cf6fcbb$var$DotsColumnIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$3ed1542d8cf6fcbb$var$DotsColumnIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$3ed1542d8cf6fcbb$var$DotsColumnIcon.displayName = "DotsColumnIcon";
var $dfd33cee3229493c$var$$3ed1542d8cf6fcbb$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3ed1542d8cf6fcbb$var$DotsColumnIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``dots-grid.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$eedd861690c5ed79$var$DotsGridIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M2.25 3.75C2.25 2.92157 2.92157 2.25 3.75 2.25C4.57843 2.25 5.25 2.92157 5.25 3.75C5.25 4.57843 4.57843 5.25 3.75 5.25C2.92157 5.25 2.25 4.57843 2.25 3.75ZM7.5 3.75C7.5 2.92157 8.17157 2.25 9 2.25C9.82843 2.25 10.5 2.92157 10.5 3.75C10.5 4.57843 9.82843 5.25 9 5.25C8.17157 5.25 7.5 4.57843 7.5 3.75ZM12.75 3.75C12.75 2.92157 13.4216 2.25 14.25 2.25C15.0784 2.25 15.75 2.92157 15.75 3.75C15.75 4.57843 15.0784 5.25 14.25 5.25C13.4216 5.25 12.75 4.57843 12.75 3.75ZM2.25 9C2.25 8.17157 2.92157 7.5 3.75 7.5C4.57843 7.5 5.25 8.17157 5.25 9C5.25 9.82843 4.57843 10.5 3.75 10.5C2.92157 10.5 2.25 9.82843 2.25 9ZM7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9ZM12.75 9C12.75 8.17157 13.4216 7.5 14.25 7.5C15.0784 7.5 15.75 8.17157 15.75 9C15.75 9.82843 15.0784 10.5 14.25 10.5C13.4216 10.5 12.75 9.82843 12.75 9ZM2.25 14.25C2.25 13.4216 2.92157 12.75 3.75 12.75C4.57843 12.75 5.25 13.4216 5.25 14.25C5.25 15.0784 4.57843 15.75 3.75 15.75C2.92157 15.75 2.25 15.0784 2.25 14.25ZM7.5 14.25C7.5 13.4216 8.17157 12.75 9 12.75C9.82843 12.75 10.5 13.4216 10.5 14.25C10.5 15.0784 9.82843 15.75 9 15.75C8.17157 15.75 7.5 15.0784 7.5 14.25ZM12.75 14.25C12.75 13.4216 13.4216 12.75 14.25 12.75C15.0784 12.75 15.75 13.4216 15.75 14.25C15.75 15.0784 15.0784 15.75 14.25 15.75C13.4216 15.75 12.75 15.0784 12.75 14.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$eedd861690c5ed79$var$DotsGridIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$eedd861690c5ed79$var$DotsGridIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$eedd861690c5ed79$var$DotsGridIcon.displayName = "DotsGridIcon";
var $dfd33cee3229493c$var$$eedd861690c5ed79$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$eedd861690c5ed79$var$DotsGridIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``dots-horizontal.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$87e56bf51a2f4dd7$var$DotsHorizontalIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M2.25 9C2.25 8.17157 2.92157 7.5 3.75 7.5C4.57843 7.5 5.25 8.17157 5.25 9C5.25 9.82843 4.57843 10.5 3.75 10.5C2.92157 10.5 2.25 9.82843 2.25 9ZM7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9ZM12.75 9C12.75 8.17157 13.4216 7.5 14.25 7.5C15.0784 7.5 15.75 8.17157 15.75 9C15.75 9.82843 15.0784 10.5 14.25 10.5C13.4216 10.5 12.75 9.82843 12.75 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$87e56bf51a2f4dd7$var$DotsHorizontalIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$87e56bf51a2f4dd7$var$DotsHorizontalIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$87e56bf51a2f4dd7$var$DotsHorizontalIcon.displayName = "DotsHorizontalIcon";
var $dfd33cee3229493c$var$$87e56bf51a2f4dd7$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$87e56bf51a2f4dd7$var$DotsHorizontalIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``dots-vertical.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$cf5d208a3a744514$var$DotsVerticalIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5 3.75C7.5 2.92157 8.17157 2.25 9 2.25C9.82843 2.25 10.5 2.92157 10.5 3.75C10.5 4.57843 9.82843 5.25 9 5.25C8.17157 5.25 7.5 4.57843 7.5 3.75ZM7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9ZM7.5 14.25C7.5 13.4216 8.17157 12.75 9 12.75C9.82843 12.75 10.5 13.4216 10.5 14.25C10.5 15.0784 9.82843 15.75 9 15.75C8.17157 15.75 7.5 15.0784 7.5 14.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$cf5d208a3a744514$var$DotsVerticalIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cf5d208a3a744514$var$DotsVerticalIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$cf5d208a3a744514$var$DotsVerticalIcon.displayName = "DotsVerticalIcon";
var $dfd33cee3229493c$var$$cf5d208a3a744514$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cf5d208a3a744514$var$DotsVerticalIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``download.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$bf297594d23644b4$var$DownloadIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 1.5C9.41421 1.5 9.75 1.83579 9.75 2.25V9.43934L12.2197 6.96967C12.5126 6.67678 12.9874 6.67678 13.2803 6.96967C13.5732 7.26256 13.5732 7.73744 13.2803 8.03033L9.53033 11.7803C9.23744 12.0732 8.76256 12.0732 8.46967 11.7803L4.71967 8.03033C4.42678 7.73744 4.42678 7.26256 4.71967 6.96967C5.01256 6.67678 5.48744 6.67678 5.78033 6.96967L8.25 9.43934V2.25C8.25 1.83579 8.58579 1.5 9 1.5ZM2.25 10.5C2.66421 10.5 3 10.8358 3 11.25V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81901 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V11.25C15 10.8358 15.3358 10.5 15.75 10.5C16.1642 10.5 16.5 10.8358 16.5 11.25V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181L1.5 11.25C1.5 10.8358 1.83579 10.5 2.25 10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$bf297594d23644b4$var$DownloadIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$bf297594d23644b4$var$DownloadIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$bf297594d23644b4$var$DownloadIcon.displayName = "DownloadIcon";
var $dfd33cee3229493c$var$$bf297594d23644b4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$bf297594d23644b4$var$DownloadIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``edit.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$78647909745e6aa7$var$EditIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M12.2197 1.71968C13.341 0.598362 15.159 0.598364 16.2804 1.71968C17.4017 2.841 17.4017 4.65902 16.2804 5.78034L14.0323 8.02837C14.0317 8.02903 14.031 8.02969 14.0304 8.03034C14.0297 8.031 14.029 8.03166 14.0284 8.03231L6.37563 15.6851C6.36306 15.6976 6.3506 15.7101 6.33824 15.7225C6.15457 15.9064 5.99255 16.0687 5.80005 16.1957C5.63081 16.3073 5.44726 16.3955 5.25438 16.4579C5.035 16.5289 4.80707 16.5541 4.54866 16.5826C4.53128 16.5845 4.51377 16.5864 4.4961 16.5884L1.95783 16.8704C1.73138 16.8956 1.50578 16.8165 1.34467 16.6553C1.18357 16.4942 1.10443 16.2686 1.12959 16.0422L1.41162 13.5039C1.41359 13.4862 1.41552 13.4687 1.41744 13.4513C1.44594 13.1929 1.47108 12.965 1.5421 12.7456C1.60454 12.5528 1.69276 12.3692 1.80436 12.2C1.9313 12.0075 2.09358 11.8454 2.27755 11.6618C2.28992 11.6494 2.3024 11.637 2.31497 11.6244L12.2197 1.71968ZM10.5 5.56067L3.37563 12.685C3.13375 12.9269 3.08885 12.9768 3.0566 13.0257C3.0194 13.0821 2.99 13.1433 2.96918 13.2076C2.95114 13.2633 2.94022 13.3296 2.90245 13.6696L2.72395 15.2761L4.33046 15.0976C4.67043 15.0598 4.73667 15.0489 4.7924 15.0308C4.85669 15.01 4.91787 14.9806 4.97429 14.9434C5.02319 14.9112 5.07309 14.8663 5.31497 14.6244L12.4394 7.50001L10.5 5.56067ZM13.5 6.43935L11.5607 4.50001L13.2804 2.78034C13.8159 2.24481 14.6842 2.24481 15.2197 2.78034C15.7552 3.31588 15.7552 4.18415 15.2197 4.71968L13.5 6.43935Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$78647909745e6aa7$var$EditIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$78647909745e6aa7$var$EditIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$78647909745e6aa7$var$EditIcon.displayName = "EditIcon";
var $dfd33cee3229493c$var$$78647909745e6aa7$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$78647909745e6aa7$var$EditIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``exchange.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e3ea11997e722fc9$var$ExchangeIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.96967 0.96967C4.26256 0.676777 4.73744 0.676777 5.03033 0.96967L6.53033 2.46967C6.82322 2.76256 6.82322 3.23744 6.53033 3.53033L5.03033 5.03033C4.73744 5.32322 4.26256 5.32322 3.96967 5.03033C3.67678 4.73744 3.67678 4.26256 3.96967 3.96967L4.16449 3.77484C3.08099 3.93683 2.25 4.87137 2.25 6C2.25 6.41421 1.91421 6.75 1.5 6.75C1.08579 6.75 0.75 6.41421 0.75 6C0.75 4.02955 2.26977 2.41405 4.20108 2.26174L3.96967 2.03033C3.67678 1.73744 3.67678 1.26256 3.96967 0.96967ZM6.91544 4.68806C7.49821 2.42386 9.55268 0.75 12 0.75C14.8995 0.75 17.25 3.10051 17.25 6C17.25 8.4473 15.5762 10.5018 13.312 11.0845C12.9109 11.1878 12.502 10.9463 12.3987 10.5452C12.2955 10.144 12.537 9.73514 12.9381 9.63189C14.5556 9.21555 15.75 7.74631 15.75 6C15.75 3.92893 14.0711 2.25 12 2.25C10.2537 2.25 8.78443 3.44438 8.3681 5.06194C8.26485 5.46308 7.85597 5.70457 7.45483 5.60133C7.05369 5.49808 6.8122 5.0892 6.91544 4.68806ZM6 8.25C3.92893 8.25 2.25 9.92893 2.25 12C2.25 14.0711 3.92893 15.75 6 15.75C8.07107 15.75 9.75 14.0711 9.75 12C9.75 9.92893 8.07107 8.25 6 8.25ZM0.75 12C0.75 9.1005 3.10051 6.75 6 6.75C8.8995 6.75 11.25 9.1005 11.25 12C11.25 14.8995 8.8995 17.25 6 17.25C3.10051 17.25 0.75 14.8995 0.75 12ZM16.5 11.25C16.9142 11.25 17.25 11.5858 17.25 12C17.25 13.9705 15.7302 15.5859 13.7989 15.7383L14.0303 15.9697C14.3232 16.2626 14.3232 16.7374 14.0303 17.0303C13.7374 17.3232 13.2626 17.3232 12.9697 17.0303L11.4697 15.5303C11.1768 15.2374 11.1768 14.7626 11.4697 14.4697L12.9697 12.9697C13.2626 12.6768 13.7374 12.6768 14.0303 12.9697C14.3232 13.2626 14.3232 13.7374 14.0303 14.0303L13.8355 14.2252C14.919 14.0632 15.75 13.1286 15.75 12C15.75 11.5858 16.0858 11.25 16.5 11.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e3ea11997e722fc9$var$ExchangeIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e3ea11997e722fc9$var$ExchangeIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e3ea11997e722fc9$var$ExchangeIcon.displayName = "ExchangeIcon";
var $dfd33cee3229493c$var$$e3ea11997e722fc9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e3ea11997e722fc9$var$ExchangeIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``expand.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$cf9677abfb23c369$var$ExpandIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3 4.06066L3 6.75C3 7.16421 2.66421 7.5 2.25 7.5C1.83579 7.5 1.5 7.16421 1.5 6.75L1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5L6.75 1.5C7.16421 1.5 7.5 1.83579 7.5 2.25C7.5 2.66421 7.16421 3 6.75 3L4.06066 3L7.28033 6.21967C7.57322 6.51256 7.57322 6.98744 7.28033 7.28033C6.98744 7.57322 6.51256 7.57322 6.21967 7.28033L3 4.06066ZM11.25 3C10.8358 3 10.5 2.66421 10.5 2.25C10.5 1.83579 10.8358 1.5 11.25 1.5H15.75C16.1642 1.5 16.5 1.83579 16.5 2.25V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5C15.3358 7.5 15 7.16421 15 6.75V4.06066L11.7803 7.28033C11.4874 7.57322 11.0126 7.57322 10.7197 7.28033C10.4268 6.98744 10.4268 6.51256 10.7197 6.21967L13.9393 3H11.25ZM2.25 10.5C2.66421 10.5 3 10.8358 3 11.25L3 13.9393L6.21967 10.7197C6.51256 10.4268 6.98744 10.4268 7.28033 10.7197C7.57322 11.0126 7.57322 11.4874 7.28033 11.7803L4.06066 15H6.75C7.16421 15 7.5 15.3358 7.5 15.75C7.5 16.1642 7.16421 16.5 6.75 16.5H2.25C2.05109 16.5 1.86032 16.421 1.71967 16.2803C1.57902 16.1397 1.5 15.9489 1.5 15.75L1.5 11.25C1.5 10.8358 1.83579 10.5 2.25 10.5ZM13.9393 15L10.7197 11.7803C10.4268 11.4874 10.4268 11.0126 10.7197 10.7197C11.0126 10.4268 11.4874 10.4268 11.7803 10.7197L15 13.9393V11.25C15 10.8358 15.3358 10.5 15.75 10.5C16.1642 10.5 16.5 10.8358 16.5 11.25V15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H11.25C10.8358 16.5 10.5 16.1642 10.5 15.75C10.5 15.3358 10.8358 15 11.25 15H13.9393Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$cf9677abfb23c369$var$ExpandIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cf9677abfb23c369$var$ExpandIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$cf9677abfb23c369$var$ExpandIcon.displayName = "ExpandIcon";
var $dfd33cee3229493c$var$$cf9677abfb23c369$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cf9677abfb23c369$var$ExpandIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``eye-off.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0e0b5de26af5ed5f$var$EyeOffIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.71998 1.71967C2.01287 1.42678 2.48775 1.42678 2.78064 1.71967L5.50969 4.44872C5.55341 4.48345 5.59378 4.52354 5.62977 4.5688L13.423 12.3621C13.4739 12.4011 13.5204 12.4471 13.561 12.5L16.2806 15.2197C16.5735 15.5126 16.5735 15.9874 16.2806 16.2803C15.9877 16.5732 15.5129 16.5732 15.22 16.2803L12.8547 13.915C11.771 14.5491 10.479 15 9.00031 15C6.85406 15 5.10432 14.0515 3.80787 12.9694C2.51318 11.8889 1.62553 10.6393 1.18098 9.93536C1.1751 9.92606 1.16907 9.91657 1.16291 9.90687C1.07468 9.768 0.960135 9.5877 0.902237 9.33506C0.85549 9.13108 0.855506 8.86871 0.902276 8.66474C0.960212 8.41207 1.07508 8.23131 1.16354 8.09212C1.16975 8.08235 1.17583 8.07278 1.18175 8.06341C1.63353 7.34824 2.55099 6.05644 3.89682 4.95717L1.71998 2.78033C1.42709 2.48744 1.42709 2.01256 1.71998 1.71967ZM4.96371 6.02406C3.73433 6.99464 2.87554 8.19074 2.44991 8.86452C2.42329 8.90666 2.40463 8.93624 2.38903 8.96192C2.37862 8.97905 2.37176 8.99088 2.36719 8.99912C2.36719 8.99941 2.36719 8.99969 2.36719 8.99998C2.36719 9.00029 2.36719 9.00059 2.36719 9.00089C2.3717 9.00902 2.37845 9.02067 2.38868 9.0375C2.40417 9.06302 2.42272 9.09243 2.44923 9.1344C2.84872 9.76697 3.6393 10.8749 4.76902 11.8178C5.89697 12.7592 7.31781 13.5 9.00031 13.5C10.015 13.5 10.9334 13.2311 11.7506 12.8109L10.5242 11.5845C10.0776 11.8483 9.55635 12 9.00031 12C7.34346 12 6.00031 10.6569 6.00031 9C6.00031 8.44396 6.15203 7.92272 6.41579 7.47614L4.96371 6.02406ZM7.551 8.61135C7.51791 8.73524 7.50031 8.86549 7.50031 9C7.50031 9.82843 8.17188 10.5 9.00031 10.5C9.13482 10.5 9.26507 10.4824 9.38896 10.4493L7.551 8.61135ZM9.00031 4.5C8.71392 4.5 8.43614 4.52137 8.1669 4.56117C7.75714 4.62176 7.37586 4.33869 7.31527 3.92893C7.25469 3.51917 7.53776 3.13789 7.94751 3.0773C8.28789 3.02698 8.63899 3 9.00031 3C11.1466 3 12.8963 3.94854 14.1928 5.03057C15.4874 6.11113 16.3751 7.36072 16.8196 8.06464C16.8255 8.07394 16.8316 8.08343 16.8377 8.09312C16.9259 8.23201 17.0405 8.41232 17.0984 8.66498C17.1451 8.86897 17.1451 9.13136 17.0983 9.33533C17.0404 9.58804 16.9253 9.76906 16.8367 9.90844C16.8305 9.91825 16.8244 9.92786 16.8184 9.93727C16.5797 10.3152 16.2174 10.8436 15.7374 11.4168C15.4715 11.7344 14.9985 11.7763 14.6809 11.5104C14.3633 11.2445 14.3214 10.7714 14.5873 10.4539C15.0158 9.94209 15.3393 9.47006 15.5503 9.13608C15.577 9.09384 15.5957 9.06416 15.6114 9.0384C15.6219 9.02109 15.6288 9.00916 15.6334 9.00086C15.6334 9.00059 15.6334 9.00031 15.6334 9.00003C15.6334 8.99972 15.6334 8.99942 15.6334 8.99911C15.6289 8.99099 15.6222 8.97934 15.6119 8.9625C15.5965 8.93698 15.5779 8.90757 15.5514 8.8656C15.1519 8.23303 14.3613 7.12506 13.2316 6.18218C12.1037 5.24078 10.6828 4.5 9.00031 4.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0e0b5de26af5ed5f$var$EyeOffIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0e0b5de26af5ed5f$var$EyeOffIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0e0b5de26af5ed5f$var$EyeOffIcon.displayName = "EyeOffIcon";
var $dfd33cee3229493c$var$$0e0b5de26af5ed5f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0e0b5de26af5ed5f$var$EyeOffIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``eye.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$f6bdb5fbb8ddc23c$var$EyeIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.76901 6.18218C3.63929 7.12505 2.84871 8.23303 2.44922 8.8656C2.42271 8.90757 2.40417 8.93697 2.38868 8.96248C2.37845 8.97932 2.3717 8.99097 2.36719 8.99909C2.36719 8.99939 2.36719 8.9997 2.36719 9C2.36719 9.0003 2.36719 9.00061 2.36719 9.00091C2.3717 9.00903 2.37845 9.02068 2.38868 9.03752C2.40417 9.06303 2.42271 9.09243 2.44922 9.1344C2.84871 9.76697 3.63929 10.8749 4.76901 11.8178C5.89696 12.7592 7.3178 13.5 9.0003 13.5C10.6828 13.5 12.1036 12.7592 13.2316 11.8178C14.3613 10.8749 15.1519 9.76697 15.5514 9.1344C15.5779 9.09243 15.5964 9.06303 15.6119 9.03751C15.6222 9.02068 15.6289 9.00903 15.6334 9.00091C15.6334 9.00061 15.6334 9.0003 15.6334 9C15.6334 8.9997 15.6334 8.99939 15.6334 8.99909C15.6289 8.99097 15.6222 8.97932 15.6119 8.96249C15.5964 8.93697 15.5779 8.90757 15.5514 8.8656C15.1519 8.23303 14.3613 7.12505 13.2316 6.18218C12.1036 5.24077 10.6828 4.5 9.0003 4.5C7.3178 4.5 5.89696 5.24078 4.76901 6.18218ZM3.80786 5.03057C5.10431 3.94854 6.85405 3 9.0003 3C11.1466 3 12.8963 3.94854 14.1927 5.03057C15.4874 6.11113 16.3751 7.36071 16.8196 8.06464C16.8255 8.07394 16.8315 8.08343 16.8377 8.09313C16.9259 8.23198 17.0405 8.41227 17.0984 8.66488C17.1451 8.86884 17.1451 9.13116 17.0984 9.33512C17.0405 9.58773 16.9259 9.76802 16.8377 9.90687C16.8315 9.91657 16.8255 9.92606 16.8196 9.93536C16.3751 10.6393 15.4874 11.8889 14.1927 12.9694C12.8963 14.0515 11.1466 15 9.0003 15C6.85405 15 5.10431 14.0515 3.80786 12.9694C2.51318 11.8889 1.62553 10.6393 1.18097 9.93536C1.17509 9.92606 1.16906 9.91657 1.1629 9.90688C1.07469 9.76802 0.960152 9.58774 0.902251 9.33512C0.8555 9.13116 0.8555 8.86884 0.902251 8.66488C0.960152 8.41226 1.07469 8.23198 1.1629 8.09312C1.16906 8.08343 1.17509 8.07394 1.18097 8.06464C1.62553 7.36071 2.51318 6.11113 3.80786 5.03057ZM9.0003 7.5C8.17188 7.5 7.5003 8.17157 7.5003 9C7.5003 9.82843 8.17188 10.5 9.0003 10.5C9.82873 10.5 10.5003 9.82843 10.5003 9C10.5003 8.17157 9.82873 7.5 9.0003 7.5ZM6.0003 9C6.0003 7.34315 7.34345 6 9.0003 6C10.6572 6 12.0003 7.34315 12.0003 9C12.0003 10.6569 10.6572 12 9.0003 12C7.34345 12 6.0003 10.6569 6.0003 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$f6bdb5fbb8ddc23c$var$EyeIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$f6bdb5fbb8ddc23c$var$EyeIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$f6bdb5fbb8ddc23c$var$EyeIcon.displayName = "EyeIcon";
var $dfd33cee3229493c$var$$f6bdb5fbb8ddc23c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f6bdb5fbb8ddc23c$var$EyeIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``face-happy.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$9b550ea789a70b83$var$FaceHappyIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM5.625 6.75C5.625 6.12868 6.12868 5.625 6.75 5.625C7.37132 5.625 7.875 6.12868 7.875 6.75C7.875 7.37132 7.37132 7.875 6.75 7.875C6.12868 7.875 5.625 7.37132 5.625 6.75ZM10.125 6.75C10.125 6.12868 10.6287 5.625 11.25 5.625C11.8713 5.625 12.375 6.12868 12.375 6.75C12.375 7.37132 11.8713 7.875 11.25 7.875C10.6287 7.875 10.125 7.37132 10.125 6.75ZM4.875 10.5C4.875 10.0858 5.21079 9.75 5.625 9.75H12.375C12.7892 9.75 13.125 10.0858 13.125 10.5C13.125 11.4183 12.5883 12.2689 11.8665 12.8611C11.1299 13.4655 10.1198 13.875 9 13.875C7.88016 13.875 6.87009 13.4655 6.13349 12.8611C5.41167 12.2689 4.875 11.4183 4.875 10.5ZM6.65629 11.25C6.7648 11.4018 6.9066 11.5552 7.08498 11.7015C7.56703 12.0971 8.24446 12.375 9 12.375C9.75554 12.375 10.433 12.0971 10.915 11.7015C11.0934 11.5552 11.2352 11.4018 11.3437 11.25H6.65629Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$9b550ea789a70b83$var$FaceHappyIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$9b550ea789a70b83$var$FaceHappyIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$9b550ea789a70b83$var$FaceHappyIcon.displayName = "FaceHappyIcon";
var $dfd33cee3229493c$var$$9b550ea789a70b83$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9b550ea789a70b83$var$FaceHappyIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``face-id.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$ab57b4a7487e25a5$var$FaceIdIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5L6 1.5C6.41421 1.5 6.75 1.83579 6.75 2.25C6.75 2.66421 6.41421 3 6 3H5.85C5.20757 3 4.77085 3.00058 4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81902C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77085 3 5.20757 3 5.85V6C3 6.41421 2.66421 6.75 2.25 6.75C1.83579 6.75 1.5 6.41421 1.5 6L1.5 5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H12C11.5858 3 11.25 2.66421 11.25 2.25C11.25 1.83579 11.5858 1.5 12 1.5L12.181 1.5C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V6C16.5 6.41421 16.1642 6.75 15.75 6.75C15.3358 6.75 15 6.41421 15 6V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93632 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816ZM5.625 5.25C6.03921 5.25 6.375 5.58579 6.375 6V7.125C6.375 7.53921 6.03921 7.875 5.625 7.875C5.21079 7.875 4.875 7.53921 4.875 7.125V6C4.875 5.58579 5.21079 5.25 5.625 5.25ZM9.375 5.25C9.78922 5.25 10.125 5.58579 10.125 6V8.32507C10.125 9.33929 9.26421 10.2001 8.25 10.2001C7.83579 10.2001 7.5 9.86429 7.5 9.45007C7.5 9.03586 7.83579 8.70007 8.25 8.70007C8.43579 8.70007 8.625 8.51086 8.625 8.32507V6C8.625 5.58579 8.96079 5.25 9.375 5.25ZM12.375 5.25C12.7892 5.25 13.125 5.58579 13.125 6V7.125C13.125 7.53921 12.7892 7.875 12.375 7.875C11.9608 7.875 11.625 7.53921 11.625 7.125V6C11.625 5.58579 11.9608 5.25 12.375 5.25ZM5.99482 10.8696C6.28771 10.5767 6.76258 10.5767 7.05548 10.8696C8.11258 11.9267 9.81271 11.9267 10.8698 10.8696C11.1627 10.5767 11.6376 10.5767 11.9305 10.8696C12.2234 11.1625 12.2234 11.6374 11.9305 11.9303C10.2876 13.5732 7.63771 13.5732 5.99482 11.9303C5.70192 11.6374 5.70192 11.1625 5.99482 10.8696ZM2.25 11.25C2.66421 11.25 3 11.5858 3 12V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81901 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H6C6.41421 15 6.75 15.3358 6.75 15.75C6.75 16.1642 6.41421 16.5 6 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181L1.5 12C1.5 11.5858 1.83579 11.25 2.25 11.25ZM15.75 11.25C16.1642 11.25 16.5 11.5858 16.5 12V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H12C11.5858 16.5 11.25 16.1642 11.25 15.75C11.25 15.3358 11.5858 15 12 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V12C15 11.5858 15.3358 11.25 15.75 11.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$ab57b4a7487e25a5$var$FaceIdIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$ab57b4a7487e25a5$var$FaceIdIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$ab57b4a7487e25a5$var$FaceIdIcon.displayName = "FaceIdIcon";
var $dfd33cee3229493c$var$$ab57b4a7487e25a5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ab57b4a7487e25a5$var$FaceIdIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``face-sad.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$73d4497baea6c8af$var$FaceSadIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM7.97362 6.34846C8.29479 6.61004 8.34311 7.08245 8.08154 7.40362C7.66142 7.91945 7.05213 8.25 6.375 8.25C5.69035 8.25 5.0991 7.91322 4.67724 7.41419C4.40982 7.09786 4.44948 6.62465 4.76581 6.35723C5.08214 6.08982 5.55535 6.12948 5.82276 6.44581C6.0159 6.67428 6.21215 6.75 6.375 6.75C6.54536 6.75 6.74608 6.66804 6.91846 6.45638C7.18004 6.1352 7.65245 6.08689 7.97362 6.34846ZM13.2236 6.34846C13.5448 6.61004 13.5931 7.08245 13.3315 7.40362C12.9114 7.91945 12.3021 8.25 11.625 8.25C10.9404 8.25 10.3491 7.91322 9.92724 7.41419C9.65982 7.09786 9.69948 6.62465 10.0158 6.35723C10.3321 6.08982 10.8054 6.12948 11.0728 6.44581C11.2659 6.67428 11.4621 6.75 11.625 6.75C11.7954 6.75 11.9961 6.66804 12.1685 6.45638C12.43 6.1352 12.9024 6.08689 13.2236 6.34846ZM6.35575 10.6434C6.9542 10.2082 7.85585 9.75 9 9.75C10.1441 9.75 11.0458 10.2082 11.6443 10.6434C11.9449 10.8621 12.1774 11.0807 12.3364 11.2467C12.4163 11.33 12.4785 11.401 12.5225 11.4534C12.5445 11.4796 12.562 11.5013 12.5749 11.5176L12.5909 11.5381L12.5963 11.5451L12.5984 11.5478L12.5992 11.549C12.5994 11.5492 12.6 11.55 12 12L12.6 11.55C12.8485 11.8814 12.7814 12.3515 12.45 12.6C12.1197 12.8477 11.6515 12.7818 11.4024 12.4531L11.3989 12.4487C11.3944 12.443 11.3859 12.4325 11.3735 12.4177C11.3487 12.3881 11.3084 12.3419 11.2534 12.2846C11.143 12.1693 10.9769 12.0129 10.762 11.8566C10.3292 11.5418 9.73085 11.25 9 11.25C8.26915 11.25 7.6708 11.5418 7.238 11.8566C7.02305 12.0129 6.85704 12.1693 6.74657 12.2846C6.69164 12.3419 6.65135 12.3881 6.62648 12.4177C6.61408 12.4325 6.60559 12.443 6.60113 12.4487L6.59797 12.4527L6.59879 12.4516L6.59935 12.4509M6.59935 12.4509C6.59868 12.4518 6.59864 12.4518 6.59797 12.4527C6.34883 12.7814 5.88033 12.8477 5.55 12.6C5.21863 12.3515 5.15147 11.8814 5.4 11.55L6 12C5.4 11.55 5.39982 11.5502 5.4 11.55L5.40162 11.5478L5.40368 11.5451L5.40908 11.5381L5.42506 11.5176C5.43799 11.5013 5.4555 11.4796 5.47752 11.4534C5.5215 11.401 5.58375 11.33 5.66359 11.2467C5.82264 11.0807 6.05507 10.8621 6.35575 10.6434",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$73d4497baea6c8af$var$FaceSadIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$73d4497baea6c8af$var$FaceSadIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$73d4497baea6c8af$var$FaceSadIcon.displayName = "FaceSadIcon";
var $dfd33cee3229493c$var$$73d4497baea6c8af$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$73d4497baea6c8af$var$FaceSadIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``file-attachment.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b26edbab562203aa$var$FileAttachmentIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.56903 0.75H11.431C12.0347 0.749991 12.533 0.749983 12.9389 0.783146C13.3604 0.81759 13.748 0.891513 14.112 1.07698C14.6765 1.3646 15.1354 1.82354 15.423 2.38803C15.6085 2.75203 15.6824 3.13956 15.7169 3.56113C15.75 3.96702 15.75 4.46529 15.75 5.06901V12.931C15.75 13.5347 15.75 14.033 15.7169 14.4389C15.6824 14.8604 15.6085 15.248 15.423 15.612C15.1354 16.1765 14.6765 16.6354 14.112 16.923C13.748 17.1085 13.3604 17.1824 12.9389 17.2169C12.533 17.25 12.0347 17.25 11.431 17.25H6.56901C5.96529 17.25 5.46702 17.25 5.06113 17.2169C4.63956 17.1824 4.25203 17.1085 3.88803 16.923C3.32354 16.6354 2.8646 16.1765 2.57698 15.612C2.39151 15.248 2.31759 14.8604 2.28315 14.4389C2.24998 14.033 2.24999 13.5347 2.25 12.931V5.06903C2.24999 4.4653 2.24998 3.96703 2.28315 3.56113C2.31759 3.13956 2.39151 2.75203 2.57698 2.38803C2.8646 1.82354 3.32354 1.3646 3.88803 1.07698C4.25203 0.891513 4.63956 0.81759 5.06113 0.783146C5.46703 0.749983 5.9653 0.749991 6.56903 0.75ZM5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06902C3.85372 3.18631 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H11.4C12.0424 15.75 12.4792 15.7494 12.8167 15.7218C13.1455 15.695 13.3137 15.6463 13.431 15.5865C13.7132 15.4427 13.9427 15.2132 14.0865 14.931C14.1463 14.8137 14.195 14.6455 14.2218 14.3167C14.2494 13.9792 14.25 13.5424 14.25 12.9V5.1C14.25 4.45757 14.2494 4.02085 14.2218 3.68328C14.195 3.35447 14.1463 3.18631 14.0865 3.06902C13.9427 2.78677 13.7132 2.5573 13.431 2.41349C13.3137 2.35372 13.1455 2.30503 12.8167 2.27816C12.4792 2.25058 12.0424 2.25 11.4 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816ZM10.125 6C9.91789 6 9.75 6.16789 9.75 6.375V10.5C9.75 10.9142 9.41421 11.25 9 11.25C8.58579 11.25 8.25 10.9142 8.25 10.5V6.375C8.25 5.33947 9.08947 4.5 10.125 4.5C11.1605 4.5 12 5.33947 12 6.375V10.5C12 12.1569 10.6569 13.5 9 13.5C7.34315 13.5 6 12.1569 6 10.5V7.5C6 7.08579 6.33579 6.75 6.75 6.75C7.16421 6.75 7.5 7.08579 7.5 7.5V10.5C7.5 11.3284 8.17157 12 9 12C9.82843 12 10.5 11.3284 10.5 10.5V6.375C10.5 6.16789 10.3321 6 10.125 6Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b26edbab562203aa$var$FileAttachmentIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b26edbab562203aa$var$FileAttachmentIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b26edbab562203aa$var$FileAttachmentIcon.displayName = "FileAttachmentIcon";
var $dfd33cee3229493c$var$$b26edbab562203aa$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b26edbab562203aa$var$FileAttachmentIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``file-empty.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$3b6f340d79ba8d42$var$FileEmptyIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9.75 2.26488C9.61073 2.2522 9.40436 2.25 9.00883 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06901C3.85372 3.18631 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H11.4C12.0424 15.75 12.4792 15.7494 12.8167 15.7218C13.1455 15.695 13.3137 15.6463 13.431 15.5865C13.7132 15.4427 13.9427 15.2132 14.0865 14.931C14.1463 14.8137 14.195 14.6455 14.2218 14.3167C14.2494 13.9792 14.25 13.5424 14.25 12.9V7.49117C14.25 7.09564 14.2478 6.88927 14.2351 6.75L11.6761 6.75C11.4868 6.75002 11.3024 6.75005 11.1463 6.73729C10.9749 6.72328 10.7726 6.69023 10.569 6.58651C10.2868 6.4427 10.0573 6.21323 9.91349 5.93099C9.80977 5.72742 9.77672 5.52512 9.76271 5.35367C9.74995 5.19755 9.74998 5.0132 9.75 4.82391L9.75 2.26488ZM10.7927 1.01135C10.624 0.935938 10.4485 0.876147 10.2684 0.83289C9.92134 0.749578 9.56149 0.749749 9.08524 0.749976C9.0601 0.749988 9.03464 0.75 9.00883 0.75L6.56903 0.75C5.9653 0.74999 5.46703 0.749982 5.06113 0.783145C4.63956 0.817589 4.25203 0.891512 3.88803 1.07698C3.32354 1.3646 2.8646 1.82354 2.57698 2.38803C2.39151 2.75203 2.31759 3.13956 2.28315 3.56113C2.24998 3.96703 2.24999 4.4653 2.25 5.06903V12.931C2.24999 13.5347 2.24998 14.033 2.28315 14.4389C2.31759 14.8604 2.39151 15.248 2.57698 15.612C2.8646 16.1765 3.32354 16.6354 3.88803 16.923C4.25203 17.1085 4.63956 17.1824 5.06113 17.2169C5.46702 17.25 5.96529 17.25 6.56901 17.25H11.431C12.0347 17.25 12.533 17.25 12.9389 17.2169C13.3604 17.1824 13.748 17.1085 14.112 16.923C14.6765 16.6354 15.1354 16.1765 15.423 15.612C15.6085 15.248 15.6824 14.8604 15.7169 14.4389C15.75 14.033 15.75 13.5347 15.75 12.931V7.49117C15.75 7.46537 15.75 7.4399 15.75 7.41477C15.7502 6.93851 15.7504 6.57867 15.6671 6.23164C15.6239 6.05146 15.5641 5.87595 15.4886 5.70729C15.4837 5.69555 15.4784 5.68396 15.4728 5.67253C15.424 5.56688 15.3689 5.46402 15.3079 5.36448C15.1214 5.06019 14.8669 4.80586 14.53 4.46926C14.5122 4.45149 14.4942 4.4335 14.4759 4.41525L12.0847 2.02409C12.0665 2.00584 12.0485 1.98782 12.0307 1.97004C11.6941 1.63312 11.4398 1.37855 11.1355 1.19208C11.036 1.13109 10.9331 1.07605 10.8275 1.02718C10.8161 1.02162 10.8044 1.01634 10.7927 1.01135ZM11.25 3.31066V4.8C11.25 5.0224 11.2506 5.14409 11.2577 5.23152C11.258 5.23501 11.2583 5.2383 11.2586 5.24141C11.2617 5.2417 11.265 5.24199 11.2685 5.24227C11.3559 5.24942 11.4776 5.25 11.7 5.25H13.1893L11.25 3.31066Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$3b6f340d79ba8d42$var$FileEmptyIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$3b6f340d79ba8d42$var$FileEmptyIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$3b6f340d79ba8d42$var$FileEmptyIcon.displayName = "FileEmptyIcon";
var $dfd33cee3229493c$var$$3b6f340d79ba8d42$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3b6f340d79ba8d42$var$FileEmptyIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``file-lock.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$312750c5044f5629$var$FileLockIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.56903 0.75H11.431C12.0347 0.74999 12.533 0.749982 12.9389 0.783145C13.3604 0.817589 13.748 0.891512 14.112 1.07698C14.6765 1.3646 15.1354 1.82354 15.423 2.38803C15.6085 2.75203 15.6824 3.13956 15.7169 3.56113C15.75 3.96702 15.75 4.46529 15.75 5.06901V7.5C15.75 7.91421 15.4142 8.25 15 8.25C14.5858 8.25 14.25 7.91421 14.25 7.5V5.1C14.25 4.45757 14.2494 4.02085 14.2218 3.68328C14.195 3.35447 14.1463 3.18631 14.0865 3.06901C13.9427 2.78677 13.7132 2.5573 13.431 2.41349C13.3137 2.35372 13.1455 2.30503 12.8167 2.27816C12.4792 2.25058 12.0424 2.25 11.4 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06901C3.85372 3.18631 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H7.875C8.28921 15.75 8.625 16.0858 8.625 16.5C8.625 16.9142 8.28921 17.25 7.875 17.25H6.56901C5.96529 17.25 5.46702 17.25 5.06113 17.2169C4.63956 17.1824 4.25203 17.1085 3.88803 16.923C3.32354 16.6354 2.8646 16.1765 2.57698 15.612C2.39151 15.248 2.31759 14.8604 2.28315 14.4389C2.24998 14.033 2.24999 13.5347 2.25 12.931V5.06903C2.24999 4.4653 2.24998 3.96703 2.28315 3.56113C2.31759 3.13956 2.39151 2.75203 2.57698 2.38803C2.8646 1.82354 3.32354 1.3646 3.88803 1.07698C4.25203 0.891512 4.63956 0.817589 5.06113 0.783145C5.46703 0.749982 5.9653 0.74999 6.56903 0.75ZM11.0625 11.4375C11.0625 10.2984 11.9859 9.375 13.125 9.375C14.2641 9.375 15.1875 10.2984 15.1875 11.4375V12.021C15.3394 12.039 15.5097 12.0762 15.681 12.1635C15.9632 12.3073 16.1927 12.5368 16.3365 12.819C16.4402 13.0226 16.4733 13.2249 16.4873 13.3963C16.5 13.5524 16.5 13.7368 16.5 13.9261V14.5739C16.5 14.7632 16.5 14.9476 16.4873 15.1037C16.4733 15.2751 16.4402 15.4774 16.3365 15.681C16.1927 15.9632 15.9632 16.1927 15.681 16.3365C15.4774 16.4402 15.2751 16.4733 15.1037 16.4873C14.9476 16.5 14.7632 16.5 14.5739 16.5H11.6761C11.4868 16.5 11.3024 16.5 11.1463 16.4873C10.9749 16.4733 10.7726 16.4402 10.569 16.3365C10.2868 16.1927 10.0573 15.9632 9.91349 15.681C9.80977 15.4774 9.77672 15.2751 9.76271 15.1037C9.74995 14.9475 9.74998 14.7632 9.75 14.5739V13.9261C9.74998 13.7368 9.74995 13.5524 9.76271 13.3963C9.77672 13.2249 9.80977 13.0226 9.91349 12.819C10.0573 12.5368 10.2868 12.3073 10.569 12.1635C10.7403 12.0762 10.9106 12.039 11.0625 12.021V11.4375ZM11.7 13.5C11.4776 13.5 11.3559 13.5006 11.2685 13.5077C11.265 13.508 11.2617 13.5083 11.2586 13.5086C11.2583 13.5117 11.258 13.515 11.2577 13.5185C11.2506 13.6059 11.25 13.7276 11.25 13.95V14.55C11.25 14.7724 11.2506 14.8941 11.2577 14.9815C11.258 14.985 11.2583 14.9883 11.2586 14.9914C11.2617 14.9917 11.265 14.992 11.2685 14.9923C11.3559 14.9994 11.4776 15 11.7 15H14.55C14.7724 15 14.8941 14.9994 14.9815 14.9923C14.985 14.992 14.9883 14.9917 14.9914 14.9914C14.9917 14.9883 14.992 14.985 14.9923 14.9815C14.9994 14.8941 15 14.7724 15 14.55V13.95C15 13.7276 14.9994 13.6059 14.9923 13.5185C14.992 13.515 14.9917 13.5117 14.9914 13.5086C14.9883 13.5083 14.985 13.508 14.9815 13.5077C14.8941 13.5006 14.7724 13.5 14.55 13.5H11.7ZM13.6875 12H12.5625V11.4375C12.5625 11.1268 12.8143 10.875 13.125 10.875C13.4357 10.875 13.6875 11.1268 13.6875 11.4375V12Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$312750c5044f5629$var$FileLockIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$312750c5044f5629$var$FileLockIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$312750c5044f5629$var$FileLockIcon.displayName = "FileLockIcon";
var $dfd33cee3229493c$var$$312750c5044f5629$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$312750c5044f5629$var$FileLockIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``file-plus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$c712c8c626b2c48f$var$FilePlusIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.56903 0.75H11.431C12.0347 0.749991 12.533 0.749983 12.9389 0.783146C13.3604 0.81759 13.748 0.891513 14.112 1.07698C14.6765 1.3646 15.1354 1.82354 15.423 2.38803C15.6085 2.75203 15.6824 3.13956 15.7169 3.56113C15.75 3.96702 15.75 4.46529 15.75 5.06901V7.875C15.75 8.28921 15.4142 8.625 15 8.625C14.5858 8.625 14.25 8.28921 14.25 7.875V5.1C14.25 4.45757 14.2494 4.02085 14.2218 3.68328C14.195 3.35447 14.1463 3.18631 14.0865 3.06901C13.9427 2.78677 13.7132 2.5573 13.431 2.41349C13.3137 2.35372 13.1455 2.30503 12.8167 2.27816C12.4792 2.25058 12.0424 2.25 11.4 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06902C3.85372 3.18631 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H9C9.41421 15.75 9.75 16.0858 9.75 16.5C9.75 16.9142 9.41421 17.25 9 17.25H6.56901C5.96529 17.25 5.46702 17.25 5.06113 17.2169C4.63956 17.1824 4.25203 17.1085 3.88803 16.923C3.32354 16.6354 2.8646 16.1765 2.57698 15.612C2.39151 15.248 2.31759 14.8604 2.28315 14.4389C2.24998 14.033 2.24999 13.5347 2.25 12.931V5.06903C2.24999 4.4653 2.24998 3.96703 2.28315 3.56113C2.31759 3.13956 2.39151 2.75203 2.57698 2.38803C2.8646 1.82354 3.32354 1.3646 3.88803 1.07698C4.25203 0.891513 4.63956 0.81759 5.06113 0.783146C5.46703 0.749983 5.9653 0.749991 6.56903 0.75ZM5.25 5.25C5.25 4.83579 5.58579 4.5 6 4.5H12C12.4142 4.5 12.75 4.83579 12.75 5.25C12.75 5.66421 12.4142 6 12 6H6C5.58579 6 5.25 5.66421 5.25 5.25ZM5.25 8.25C5.25 7.83579 5.58579 7.5 6 7.5H10.5C10.9142 7.5 11.25 7.83579 11.25 8.25C11.25 8.66421 10.9142 9 10.5 9H6C5.58579 9 5.25 8.66421 5.25 8.25ZM5.25 11.25C5.25 10.8358 5.58579 10.5 6 10.5H7.5C7.91421 10.5 8.25 10.8358 8.25 11.25C8.25 11.6642 7.91421 12 7.5 12H6C5.58579 12 5.25 11.6642 5.25 11.25ZM13.5 10.5C13.9142 10.5 14.25 10.8358 14.25 11.25V12.75H15.75C16.1642 12.75 16.5 13.0858 16.5 13.5C16.5 13.9142 16.1642 14.25 15.75 14.25H14.25V15.75C14.25 16.1642 13.9142 16.5 13.5 16.5C13.0858 16.5 12.75 16.1642 12.75 15.75V14.25H11.25C10.8358 14.25 10.5 13.9142 10.5 13.5C10.5 13.0858 10.8358 12.75 11.25 12.75H12.75V11.25C12.75 10.8358 13.0858 10.5 13.5 10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$c712c8c626b2c48f$var$FilePlusIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$c712c8c626b2c48f$var$FilePlusIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$c712c8c626b2c48f$var$FilePlusIcon.displayName = "FilePlusIcon";
var $dfd33cee3229493c$var$$c712c8c626b2c48f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c712c8c626b2c48f$var$FilePlusIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``file.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$04665d8c3b7e64ff$var$FileIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.56903 0.75L10.5 0.750001C10.6989 0.750001 10.8897 0.829018 11.0303 0.969671L15.5303 5.46967C15.671 5.61032 15.75 5.80109 15.75 6V12.931C15.75 13.5347 15.75 14.033 15.7169 14.4389C15.6824 14.8604 15.6085 15.248 15.423 15.612C15.1354 16.1765 14.6765 16.6354 14.112 16.923C13.748 17.1085 13.3604 17.1824 12.9389 17.2169C12.533 17.25 12.0347 17.25 11.431 17.25H6.56901C5.96529 17.25 5.46702 17.25 5.06113 17.2169C4.63956 17.1824 4.25203 17.1085 3.88803 16.923C3.32354 16.6354 2.8646 16.1765 2.57698 15.612C2.39151 15.248 2.31759 14.8604 2.28315 14.4389C2.24998 14.033 2.24999 13.5347 2.25 12.931V5.06903C2.24999 4.4653 2.24998 3.96703 2.28315 3.56113C2.31759 3.13956 2.39151 2.75203 2.57698 2.38803C2.8646 1.82354 3.32354 1.3646 3.88803 1.07698C4.25203 0.891513 4.63956 0.81759 5.06113 0.783146C5.46703 0.749983 5.9653 0.749991 6.56903 0.75ZM5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06902C3.85372 3.18631 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H11.4C12.0424 15.75 12.4792 15.7494 12.8167 15.7218C13.1455 15.695 13.3137 15.6463 13.431 15.5865C13.7132 15.4427 13.9427 15.2132 14.0865 14.931C14.1463 14.8137 14.195 14.6455 14.2218 14.3167C14.2494 13.9792 14.25 13.5424 14.25 12.9V6.75005L11.6761 6.75006C11.4868 6.75008 11.3024 6.7501 11.1463 6.73734C10.9749 6.72334 10.7726 6.69029 10.569 6.58656C10.2868 6.44275 10.0573 6.21328 9.91349 5.93104C9.80977 5.72747 9.77672 5.52517 9.76271 5.35373C9.74995 5.1976 9.74998 5.01326 9.75 4.82397L9.75 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816ZM11.25 3.31066L13.1894 5.25005H11.7C11.4776 5.25005 11.3559 5.24947 11.2685 5.24233C11.265 5.24204 11.2617 5.24176 11.2586 5.24147C11.2583 5.23835 11.258 5.23506 11.2577 5.23158C11.2506 5.14414 11.25 5.02245 11.25 4.80006V3.31066ZM5.25 6.75C5.25 6.33579 5.58579 6 6 6H7.5C7.91421 6 8.25 6.33579 8.25 6.75C8.25 7.16421 7.91421 7.5 7.5 7.5H6C5.58579 7.5 5.25 7.16421 5.25 6.75ZM5.25 9.75C5.25 9.33579 5.58579 9 6 9H12C12.4142 9 12.75 9.33579 12.75 9.75C12.75 10.1642 12.4142 10.5 12 10.5H6C5.58579 10.5 5.25 10.1642 5.25 9.75ZM5.25 12.75C5.25 12.3358 5.58579 12 6 12H12C12.4142 12 12.75 12.3358 12.75 12.75C12.75 13.1642 12.4142 13.5 12 13.5H6C5.58579 13.5 5.25 13.1642 5.25 12.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$04665d8c3b7e64ff$var$FileIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$04665d8c3b7e64ff$var$FileIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$04665d8c3b7e64ff$var$FileIcon.displayName = "FileIcon";
var $dfd33cee3229493c$var$$04665d8c3b7e64ff$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$04665d8c3b7e64ff$var$FileIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``filter.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$783c5587828f0531$var$FilterIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H15.75C16.1642 3.75 16.5 4.08579 16.5 4.5C16.5 4.91421 16.1642 5.25 15.75 5.25H2.25C1.83579 5.25 1.5 4.91421 1.5 4.5ZM3.75 9C3.75 8.58579 4.08579 8.25 4.5 8.25H13.5C13.9142 8.25 14.25 8.58579 14.25 9C14.25 9.41421 13.9142 9.75 13.5 9.75H4.5C4.08579 9.75 3.75 9.41421 3.75 9ZM6 13.5C6 13.0858 6.33579 12.75 6.75 12.75H11.25C11.6642 12.75 12 13.0858 12 13.5C12 13.9142 11.6642 14.25 11.25 14.25H6.75C6.33579 14.25 6 13.9142 6 13.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$783c5587828f0531$var$FilterIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$783c5587828f0531$var$FilterIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$783c5587828f0531$var$FilterIcon.displayName = "FilterIcon";
var $dfd33cee3229493c$var$$783c5587828f0531$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$783c5587828f0531$var$FilterIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``fingerprint.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b62fbfb04a46ecd8$var$FingerprintIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.62446 2.40349C6.61806 1.82872 7.77178 1.5 9 1.5C12.7279 1.5 15.75 4.52208 15.75 8.25C15.75 10.175 15.4812 12.0385 14.9786 13.8043C14.8652 14.2027 14.4503 14.4337 14.0519 14.3203C13.6535 14.2069 13.4225 13.792 13.5359 13.3937C14.0009 11.7601 14.25 10.0348 14.25 8.25C14.25 5.3505 11.8995 3 9 3C8.0425 3 7.14699 3.25564 6.37555 3.7019C6.017 3.90931 5.55821 3.78678 5.3508 3.42824C5.14339 3.06969 5.26591 2.6109 5.62446 2.40349ZM4.17824 4.6008C4.53679 4.8082 4.65931 5.267 4.4519 5.62554C4.00565 6.39699 3.75 7.2925 3.75 8.25C3.75 9.53947 3.45364 10.7618 2.92461 11.8508C2.74361 12.2234 2.29485 12.3787 1.92228 12.1977C1.5497 12.0167 1.3944 11.5679 1.5754 11.1954C2.00736 10.3062 2.25 9.3075 2.25 8.25C2.25 7.02178 2.57873 5.86805 3.15349 4.87446C3.3609 4.51591 3.81969 4.39339 4.17824 4.6008ZM5.24993 8.25C5.24993 6.17893 6.92887 4.5 8.99993 4.5C11.071 4.5 12.7499 6.17893 12.7499 8.25C12.7499 9.04685 12.6957 9.83192 12.5906 10.6015C12.5345 11.0119 12.1564 11.2992 11.746 11.2431C11.3356 11.187 11.0483 10.8089 11.1044 10.3985C11.2003 9.69595 11.2499 8.9787 11.2499 8.25C11.2499 7.00736 10.2426 6 8.99993 6C7.75729 6 6.74993 7.00736 6.74993 8.25C6.74993 10.4517 6.11974 12.4993 5.03082 14.2304C5.0203 14.2471 5.01003 14.2639 5.00001 14.2807C4.7885 14.6369 4.32833 14.7541 3.97219 14.5426C3.61605 14.3311 3.4988 13.8709 3.71032 13.5148C3.72686 13.4869 3.7438 13.4592 3.76114 13.4317L4.39598 13.831L3.76114 13.4317C4.70396 11.9329 5.24993 10.161 5.24993 8.25ZM8.99991 7.5C9.41412 7.5 9.74991 7.83579 9.74991 8.25C9.74991 11.0333 8.95119 13.6323 7.57014 15.8278C7.34959 16.1784 6.88657 16.2838 6.53596 16.0632C6.18534 15.8427 6.07991 15.3797 6.30047 15.0291C7.53545 13.0658 8.24991 10.7425 8.24991 8.25C8.24991 7.83579 8.58569 7.5 8.99991 7.5ZM11.5823 12.0283C11.9808 12.1411 12.2125 12.5556 12.0997 12.9542C11.803 14.0028 11.4097 15.0111 10.93 15.9687C10.7444 16.339 10.2938 16.4888 9.92348 16.3033C9.55314 16.1177 9.40332 15.6671 9.58886 15.2968C10.0267 14.4228 10.3856 13.5025 10.6564 12.5458C10.7692 12.1472 11.1837 11.9156 11.5823 12.0283Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b62fbfb04a46ecd8$var$FingerprintIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b62fbfb04a46ecd8$var$FingerprintIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b62fbfb04a46ecd8$var$FingerprintIcon.displayName = "FingerprintIcon";
var $dfd33cee3229493c$var$$b62fbfb04a46ecd8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b62fbfb04a46ecd8$var$FingerprintIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``flash.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$6c8babbfc3ede4ae$var$FlashIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M10.0486 0.812035C10.354 0.944612 10.5355 1.26266 10.4942 1.59304L9.84957 6.75001L14.4958 6.75001C14.6766 6.74997 14.8596 6.74994 15.0092 6.76348C15.1507 6.77629 15.4215 6.81017 15.6564 7C15.9254 7.21732 16.0794 7.54624 16.0742 7.89197C16.0697 8.19397 15.9223 8.42375 15.8416 8.54061C15.7562 8.66418 15.639 8.80479 15.5233 8.94361L8.82615 16.9801C8.61301 17.2359 8.25675 17.3206 7.95134 17.188C7.64593 17.0554 7.46448 16.7374 7.50578 16.407L8.1504 11.25L3.50416 11.25C3.32341 11.25 3.14034 11.2501 2.99077 11.2365C2.84932 11.2237 2.57845 11.1899 2.34353 11C2.0746 10.7827 1.92054 10.4538 1.92576 10.108C1.93031 9.80606 2.07769 9.57628 2.15841 9.45941C2.24376 9.33583 2.361 9.19521 2.47674 9.05637C2.48247 9.0495 2.48819 9.04263 2.49391 9.03576L9.17382 1.01987C9.38697 0.764098 9.74322 0.679459 10.0486 0.812035ZM3.85127 9.75001H8.99999C9.21511 9.75001 9.41988 9.84239 9.56225 10.0037C9.70462 10.1649 9.77088 10.3796 9.7442 10.593L9.31149 14.0547L14.1487 8.25001H8.99999C8.78486 8.25001 8.5801 8.15764 8.43773 7.99636C8.29536 7.83509 8.2291 7.62045 8.25578 7.40699L8.68848 3.94535L3.85127 9.75001Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$6c8babbfc3ede4ae$var$FlashIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$6c8babbfc3ede4ae$var$FlashIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$6c8babbfc3ede4ae$var$FlashIcon.displayName = "FlashIcon";
var $dfd33cee3229493c$var$$6c8babbfc3ede4ae$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6c8babbfc3ede4ae$var$FlashIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``folder-check.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$60546b3d725b9d13$var$FolderCheckIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5675 3.04098C7.47703 3.00978 7.35953 2.99999 6.76672 2.99999H3.9C3.46759 2.99999 3.18838 3.00058 2.97588 3.01794C2.77213 3.03459 2.69659 3.06284 2.65951 3.08174C2.51839 3.15364 2.40365 3.26838 2.33175 3.4095C2.31285 3.44658 2.28459 3.52212 2.26795 3.72587C2.25268 3.91273 2.25039 4.15117 2.25006 4.49999H8.53648L8.24253 3.91209C7.97742 3.38188 7.91611 3.28114 7.84774 3.21418C7.76832 3.13639 7.6726 3.07723 7.5675 3.04098ZM10.2135 4.49999L9.58417 3.24127C9.57015 3.21323 9.55628 3.18541 9.54253 3.15782C9.34397 2.75938 9.16935 2.40899 8.89732 2.14255C8.65905 1.90919 8.37189 1.73171 8.05661 1.62297C7.69665 1.49881 7.30516 1.49932 6.85999 1.49991C6.82916 1.49995 6.79807 1.49999 6.76672 1.49999L3.87109 1.49999C3.47573 1.49998 3.13466 1.49997 2.85373 1.52292C2.55722 1.54715 2.26231 1.60063 1.97852 1.74523C1.55516 1.96094 1.21095 2.30515 0.995237 2.72851C0.850641 3.0123 0.797154 3.30721 0.772928 3.60372C0.749976 3.88465 0.749987 4.22572 0.750001 4.62109L0.750001 12.181C0.749991 12.7847 0.749984 13.283 0.783147 13.6889C0.81759 14.1104 0.891514 14.498 1.07698 14.862C1.3646 15.4265 1.82354 15.8854 2.38803 16.173C2.75203 16.3585 3.13956 16.4324 3.56113 16.4668C3.96702 16.5 4.46529 16.5 5.06901 16.5H12.931C13.5347 16.5 14.033 16.5 14.4389 16.4668C14.8604 16.4324 15.248 16.3585 15.612 16.173C16.1765 15.8854 16.6354 15.4265 16.923 14.862C17.1085 14.498 17.1824 14.1104 17.2169 13.6889C17.25 13.283 17.25 12.7847 17.25 12.181V8.819C17.25 8.21528 17.25 7.71702 17.2169 7.31112C17.1824 6.88955 17.1085 6.50202 16.923 6.13802C16.6354 5.57354 16.1765 5.11459 15.612 4.82697C15.248 4.64151 14.8604 4.56758 14.4389 4.53314C14.033 4.49998 13.5347 4.49998 12.931 4.49999L10.2135 4.49999ZM9.73491 5.99999C9.74534 6.00021 9.75579 6.00021 9.76625 5.99999H12.9C13.5424 5.99999 13.9792 6.00058 14.3167 6.02816C14.6455 6.05502 14.8137 6.10372 14.931 6.16348C15.2132 6.30729 15.4427 6.53677 15.5865 6.81901C15.6463 6.93631 15.695 7.10446 15.7218 7.43327C15.7494 7.77084 15.75 8.20756 15.75 8.84999V12.15C15.75 12.7924 15.7494 13.2291 15.7218 13.5667C15.695 13.8955 15.6463 14.0637 15.5865 14.181C15.4427 14.4632 15.2132 14.6927 14.931 14.8365C14.8137 14.8963 14.6455 14.945 14.3167 14.9718C13.9792 14.9994 13.5424 15 12.9 15H5.1C4.45757 15 4.02085 14.9994 3.68328 14.9718C3.35447 14.945 3.18632 14.8963 3.06902 14.8365C2.78677 14.6927 2.5573 14.4632 2.41349 14.181C2.35372 14.0637 2.30503 13.8955 2.27816 13.5667C2.25058 13.2291 2.25 12.7924 2.25 12.15V5.99999H9.73491ZM12.1553 8.09466C12.4482 8.38756 12.4482 8.86243 12.1553 9.15532L8.78033 12.5303C8.48744 12.8232 8.01256 12.8232 7.71967 12.5303L6.21967 11.0303C5.92678 10.7374 5.92678 10.2626 6.21967 9.96966C6.51256 9.67677 6.98744 9.67677 7.28033 9.96966L8.25 10.9393L11.0947 8.09466C11.3876 7.80177 11.8624 7.80177 12.1553 8.09466Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$60546b3d725b9d13$var$FolderCheckIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$60546b3d725b9d13$var$FolderCheckIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$60546b3d725b9d13$var$FolderCheckIcon.displayName = "FolderCheckIcon";
var $dfd33cee3229493c$var$$60546b3d725b9d13$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$60546b3d725b9d13$var$FolderCheckIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``folder-lock.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e5003d188626ebef$var$FolderLockIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5675 3.04098C7.47703 3.00978 7.35953 2.99999 6.76672 2.99999H3.9C3.46759 2.99999 3.18838 3.00058 2.97588 3.01794C2.77213 3.03459 2.69659 3.06284 2.65951 3.08174C2.51839 3.15364 2.40365 3.26838 2.33175 3.4095C2.31285 3.44658 2.28459 3.52212 2.26795 3.72587C2.25268 3.91273 2.25039 4.15117 2.25006 4.49999H8.53648L8.24253 3.91209C7.97742 3.38188 7.91611 3.28114 7.84774 3.21418C7.76832 3.13639 7.6726 3.07723 7.5675 3.04098ZM10.2135 4.49999L9.58417 3.24127C9.57015 3.21323 9.55628 3.18541 9.54253 3.15782C9.34397 2.75938 9.16935 2.40899 8.89732 2.14255C8.65905 1.90919 8.37189 1.73171 8.05661 1.62297C7.69665 1.49881 7.30516 1.49932 6.85999 1.49991C6.82916 1.49995 6.79807 1.49999 6.76672 1.49999L3.87109 1.49999C3.47573 1.49998 3.13466 1.49997 2.85373 1.52292C2.55722 1.54715 2.26231 1.60063 1.97852 1.74523C1.55516 1.96094 1.21095 2.30515 0.995237 2.72851C0.850641 3.0123 0.797154 3.30721 0.772928 3.60372C0.749976 3.88465 0.749987 4.22572 0.750001 4.62109L0.750001 12.181C0.749991 12.7847 0.749984 13.283 0.783147 13.6889C0.81759 14.1104 0.891514 14.498 1.07698 14.862C1.3646 15.4265 1.82354 15.8854 2.38803 16.173C2.75203 16.3585 3.13956 16.4324 3.56113 16.4668C3.96702 16.5 4.46529 16.5 5.06901 16.5H12.931C13.5347 16.5 14.033 16.5 14.4389 16.4668C14.8604 16.4324 15.248 16.3585 15.612 16.173C16.1765 15.8854 16.6354 15.4265 16.923 14.862C17.1085 14.498 17.1824 14.1104 17.2169 13.6889C17.25 13.283 17.25 12.7847 17.25 12.181V8.819C17.25 8.21528 17.25 7.71702 17.2169 7.31112C17.1824 6.88955 17.1085 6.50202 16.923 6.13802C16.6354 5.57354 16.1765 5.11459 15.612 4.82697C15.248 4.64151 14.8604 4.56758 14.4389 4.53314C14.033 4.49998 13.5347 4.49998 12.931 4.49999L10.2135 4.49999ZM9.73491 5.99999C9.74534 6.00021 9.75579 6.00021 9.76625 5.99999H12.9C13.5424 5.99999 13.9792 6.00058 14.3167 6.02816C14.6455 6.05502 14.8137 6.10372 14.931 6.16348C15.2132 6.30729 15.4427 6.53677 15.5865 6.81901C15.6463 6.93631 15.695 7.10446 15.7218 7.43327C15.7494 7.77084 15.75 8.20756 15.75 8.84999V12.15C15.75 12.7924 15.7494 13.2291 15.7218 13.5667C15.695 13.8955 15.6463 14.0637 15.5865 14.181C15.4427 14.4632 15.2132 14.6927 14.931 14.8365C14.8137 14.8963 14.6455 14.945 14.3167 14.9718C13.9792 14.9994 13.5424 15 12.9 15H5.1C4.45757 15 4.02085 14.9994 3.68328 14.9718C3.35447 14.945 3.18632 14.8963 3.06902 14.8365C2.78677 14.6927 2.5573 14.4632 2.41349 14.181C2.35372 14.0637 2.30503 13.8955 2.27816 13.5667C2.25058 13.2291 2.25 12.7924 2.25 12.15V5.99999H9.73491ZM6.9375 8.81249C6.9375 7.67341 7.86091 6.74999 9 6.74999C10.1391 6.74999 11.0625 7.67341 11.0625 8.81249V9.39602C11.2144 9.41398 11.3847 9.45122 11.556 9.53848C11.8382 9.68229 12.0677 9.91176 12.2115 10.194C12.3152 10.3976 12.3483 10.5999 12.3623 10.7713C12.375 10.9274 12.375 11.1118 12.375 11.3011V11.9489C12.375 12.1382 12.375 12.3225 12.3623 12.4787C12.3483 12.6501 12.3152 12.8524 12.2115 13.056C12.0677 13.3382 11.8382 13.5677 11.556 13.7115C11.3524 13.8152 11.1501 13.8483 10.9787 13.8623C10.8226 13.875 10.6382 13.875 10.4489 13.875H7.55109C7.3618 13.875 7.17745 13.875 7.02133 13.8623C6.84988 13.8483 6.64758 13.8152 6.44402 13.7115C6.16177 13.5677 5.9323 13.3382 5.78849 13.056C5.68477 12.8524 5.65172 12.6501 5.63771 12.4787C5.62496 12.3225 5.62498 12.1382 5.625 11.9489V11.3011C5.62498 11.1118 5.62496 10.9274 5.63771 10.7713C5.65172 10.5999 5.68477 10.3976 5.78849 10.194C5.9323 9.91176 6.16177 9.68229 6.44402 9.53848C6.61528 9.45122 6.78565 9.41398 6.9375 9.39602V8.81249ZM8.4375 9.37499H9.5625V8.81249C9.5625 8.50183 9.31066 8.24999 9 8.24999C8.68934 8.24999 8.4375 8.50183 8.4375 8.81249V9.37499ZM7.575 10.875C7.35261 10.875 7.23092 10.8756 7.14348 10.8827C7.13999 10.883 7.1367 10.8833 7.13359 10.8836C7.1333 10.8867 7.13301 10.89 7.13273 10.8935C7.12558 10.9809 7.125 11.1026 7.125 11.325V11.925C7.125 12.1474 7.12558 12.2691 7.13273 12.3565C7.13301 12.36 7.1333 12.3633 7.13359 12.3664C7.1367 12.3667 7.13999 12.367 7.14348 12.3673C7.23092 12.3744 7.35261 12.375 7.575 12.375H10.425C10.6474 12.375 10.7691 12.3744 10.8565 12.3673C10.86 12.367 10.8633 12.3667 10.8664 12.3664C10.8667 12.3633 10.867 12.36 10.8673 12.3565C10.8744 12.2691 10.875 12.1474 10.875 11.925V11.325C10.875 11.1026 10.8744 10.9809 10.8673 10.8935C10.867 10.89 10.8667 10.8867 10.8664 10.8836C10.8633 10.8833 10.86 10.883 10.8565 10.8827C10.7691 10.8756 10.6474 10.875 10.425 10.875H7.575Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e5003d188626ebef$var$FolderLockIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e5003d188626ebef$var$FolderLockIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e5003d188626ebef$var$FolderLockIcon.displayName = "FolderLockIcon";
var $dfd33cee3229493c$var$$e5003d188626ebef$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e5003d188626ebef$var$FolderLockIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``folder-minus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$847ec600760b4fc2$var$FolderMinusIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5675 3.04098C7.47703 3.00978 7.35953 2.99999 6.76672 2.99999H3.9C3.46759 2.99999 3.18838 3.00058 2.97588 3.01794C2.77213 3.03459 2.69659 3.06284 2.65951 3.08174C2.51839 3.15364 2.40365 3.26838 2.33175 3.4095C2.31285 3.44658 2.28459 3.52212 2.26795 3.72587C2.25268 3.91273 2.25039 4.15117 2.25006 4.49999H8.53648L8.24253 3.91209C7.97742 3.38188 7.91611 3.28114 7.84774 3.21418C7.76832 3.13639 7.6726 3.07723 7.5675 3.04098ZM10.2135 4.49999L9.58417 3.24127C9.57015 3.21323 9.55628 3.18541 9.54253 3.15782C9.34397 2.75938 9.16935 2.40899 8.89732 2.14255C8.65905 1.90919 8.37189 1.73171 8.05661 1.62297C7.69665 1.49881 7.30516 1.49932 6.85999 1.49991C6.82916 1.49995 6.79807 1.49999 6.76672 1.49999L3.87109 1.49999C3.47573 1.49998 3.13466 1.49997 2.85373 1.52292C2.55722 1.54715 2.26231 1.60063 1.97852 1.74523C1.55516 1.96094 1.21095 2.30515 0.995237 2.72851C0.850641 3.0123 0.797154 3.30721 0.772928 3.60372C0.749976 3.88465 0.749987 4.22572 0.750001 4.62109L0.750001 12.181C0.749991 12.7847 0.749984 13.283 0.783147 13.6889C0.81759 14.1104 0.891514 14.498 1.07698 14.862C1.3646 15.4265 1.82354 15.8854 2.38803 16.173C2.75203 16.3585 3.13956 16.4324 3.56113 16.4668C3.96702 16.5 4.46529 16.5 5.06901 16.5H12.931C13.5347 16.5 14.033 16.5 14.4389 16.4668C14.8604 16.4324 15.248 16.3585 15.612 16.173C16.1765 15.8854 16.6354 15.4265 16.923 14.862C17.1085 14.498 17.1824 14.1104 17.2169 13.6889C17.25 13.283 17.25 12.7847 17.25 12.181V8.819C17.25 8.21528 17.25 7.71702 17.2169 7.31112C17.1824 6.88955 17.1085 6.50202 16.923 6.13802C16.6354 5.57354 16.1765 5.11459 15.612 4.82697C15.248 4.64151 14.8604 4.56758 14.4389 4.53314C14.033 4.49998 13.5347 4.49998 12.931 4.49999L10.2135 4.49999ZM9.73491 5.99999C9.74534 6.00021 9.75579 6.00021 9.76625 5.99999H12.9C13.5424 5.99999 13.9792 6.00058 14.3167 6.02816C14.6455 6.05502 14.8137 6.10372 14.931 6.16348C15.2132 6.30729 15.4427 6.53677 15.5865 6.81901C15.6463 6.93631 15.695 7.10446 15.7218 7.43327C15.7494 7.77084 15.75 8.20756 15.75 8.84999V12.15C15.75 12.7924 15.7494 13.2291 15.7218 13.5667C15.695 13.8955 15.6463 14.0637 15.5865 14.181C15.4427 14.4632 15.2132 14.6927 14.931 14.8365C14.8137 14.8963 14.6455 14.945 14.3167 14.9718C13.9792 14.9994 13.5424 15 12.9 15H5.1C4.45757 15 4.02085 14.9994 3.68328 14.9718C3.35447 14.945 3.18632 14.8963 3.06902 14.8365C2.78677 14.6927 2.5573 14.4632 2.41349 14.181C2.35372 14.0637 2.30503 13.8955 2.27816 13.5667C2.25058 13.2291 2.25 12.7924 2.25 12.15V5.99999H9.73491ZM6 10.5C6 10.0858 6.33579 9.74999 6.75 9.74999H11.25C11.6642 9.74999 12 10.0858 12 10.5C12 10.9142 11.6642 11.25 11.25 11.25H6.75C6.33579 11.25 6 10.9142 6 10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$847ec600760b4fc2$var$FolderMinusIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$847ec600760b4fc2$var$FolderMinusIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$847ec600760b4fc2$var$FolderMinusIcon.displayName = "FolderMinusIcon";
var $dfd33cee3229493c$var$$847ec600760b4fc2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$847ec600760b4fc2$var$FolderMinusIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``folder-plus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$c84b5f1d0f7663c9$var$FolderPlusIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5675 3.041C7.47703 3.00979 7.35953 3.00001 6.76672 3.00001H3.9C3.46759 3.00001 3.18838 3.00059 2.97588 3.01795C2.77213 3.0346 2.69659 3.06286 2.65951 3.08175C2.51839 3.15366 2.40365 3.26839 2.33175 3.40952C2.31285 3.4466 2.28459 3.52214 2.26795 3.72589C2.25268 3.91275 2.25039 4.15118 2.25006 4.50001H8.53648L8.24253 3.91211C7.97742 3.38189 7.91611 3.28116 7.84774 3.2142C7.76832 3.13641 7.6726 3.07725 7.5675 3.041ZM10.2135 4.50001L9.58417 3.24129C9.57015 3.21325 9.55628 3.18542 9.54253 3.15783C9.34397 2.7594 9.16935 2.409 8.89732 2.14257C8.65905 1.90921 8.37189 1.73173 8.05661 1.62298C7.69665 1.49882 7.30516 1.49934 6.85999 1.49993C6.82916 1.49997 6.79807 1.50001 6.76672 1.50001L3.87109 1.50001C3.47573 1.49999 3.13466 1.49998 2.85373 1.52294C2.55722 1.54716 2.26231 1.60065 1.97852 1.74524C1.55516 1.96096 1.21095 2.30517 0.995237 2.72853C0.850641 3.01231 0.797154 3.30723 0.772928 3.60374C0.749976 3.88467 0.749987 4.22574 0.750001 4.6211L0.750001 12.181C0.749991 12.7847 0.749984 13.283 0.783147 13.6889C0.81759 14.1105 0.891514 14.498 1.07698 14.862C1.3646 15.4265 1.82354 15.8854 2.38803 16.173C2.75203 16.3585 3.13956 16.4324 3.56113 16.4669C3.96702 16.5 4.46529 16.5 5.06901 16.5H12.931C13.5347 16.5 14.033 16.5 14.4389 16.4669C14.8604 16.4324 15.248 16.3585 15.612 16.173C16.1765 15.8854 16.6354 15.4265 16.923 14.862C17.1085 14.498 17.1824 14.1105 17.2169 13.6889C17.25 13.283 17.25 12.7847 17.25 12.181V8.81902C17.25 8.2153 17.25 7.71703 17.2169 7.31114C17.1824 6.88957 17.1085 6.50204 16.923 6.13804C16.6354 5.57355 16.1765 5.11461 15.612 4.82699C15.248 4.64152 14.8604 4.5676 14.4389 4.53315C14.033 4.49999 13.5347 4.5 12.931 4.50001L10.2135 4.50001ZM9.73491 6.00001C9.74534 6.00023 9.75579 6.00023 9.76625 6.00001H12.9C13.5424 6.00001 13.9792 6.00059 14.3167 6.02817C14.6455 6.05504 14.8137 6.10373 14.931 6.1635C15.2132 6.30731 15.4427 6.53678 15.5865 6.81902C15.6463 6.93632 15.695 7.10448 15.7218 7.43329C15.7494 7.77085 15.75 8.20757 15.75 8.85001V12.15C15.75 12.7924 15.7494 13.2292 15.7218 13.5667C15.695 13.8955 15.6463 14.0637 15.5865 14.181C15.4427 14.4632 15.2132 14.6927 14.931 14.8365C14.8137 14.8963 14.6455 14.945 14.3167 14.9718C13.9792 14.9994 13.5424 15 12.9 15H5.1C4.45757 15 4.02085 14.9994 3.68328 14.9718C3.35447 14.945 3.18632 14.8963 3.06902 14.8365C2.78677 14.6927 2.5573 14.4632 2.41349 14.181C2.35372 14.0637 2.30503 13.8955 2.27816 13.5667C2.25058 13.2292 2.25 12.7924 2.25 12.15V6.00001H9.73491ZM9 7.50001C9.41422 7.50001 9.75 7.8358 9.75 8.25001V9.75001H11.25C11.6642 9.75001 12 10.0858 12 10.5C12 10.9142 11.6642 11.25 11.25 11.25H9.75V12.75C9.75 13.1642 9.41422 13.5 9 13.5C8.58579 13.5 8.25 13.1642 8.25 12.75V11.25H6.75C6.33579 11.25 6 10.9142 6 10.5C6 10.0858 6.33579 9.75001 6.75 9.75001H8.25V8.25001C8.25 7.8358 8.58579 7.50001 9 7.50001Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$c84b5f1d0f7663c9$var$FolderPlusIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$c84b5f1d0f7663c9$var$FolderPlusIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$c84b5f1d0f7663c9$var$FolderPlusIcon.displayName = "FolderPlusIcon";
var $dfd33cee3229493c$var$$c84b5f1d0f7663c9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c84b5f1d0f7663c9$var$FolderPlusIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``folder-shield.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$7e85b93997ca2f4c$var$FolderShieldIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5675 3.04099C7.47703 3.00979 7.35953 3 6.76672 3H3.9C3.46759 3 3.18838 3.00058 2.97588 3.01795C2.77213 3.03459 2.69659 3.06285 2.65951 3.08175C2.51839 3.15365 2.40365 3.26839 2.33175 3.40951C2.31285 3.44659 2.28459 3.52213 2.26795 3.72588C2.25268 3.91274 2.25039 4.15117 2.25006 4.5H8.53648L8.24253 3.9121C7.97742 3.38188 7.91611 3.28115 7.84774 3.21419C7.76832 3.1364 7.6726 3.07724 7.5675 3.04099ZM10.2135 4.5L9.58417 3.24128C9.57015 3.21324 9.55628 3.18542 9.54253 3.15782C9.34397 2.75939 9.16935 2.409 8.89732 2.14256C8.65905 1.9092 8.37189 1.73172 8.05661 1.62297C7.69665 1.49881 7.30516 1.49933 6.85999 1.49992C6.82916 1.49996 6.79807 1.5 6.76672 1.5L3.87109 1.5C3.47573 1.49999 3.13466 1.49998 2.85373 1.52293C2.55722 1.54715 2.26231 1.60064 1.97852 1.74524C1.55516 1.96095 1.21095 2.30516 0.995237 2.72852C0.850641 3.01231 0.797154 3.30722 0.772928 3.60373C0.749976 3.88466 0.749987 4.22573 0.750001 4.62109L0.750001 12.181C0.749991 12.7847 0.749984 13.283 0.783147 13.6889C0.81759 14.1104 0.891514 14.498 1.07698 14.862C1.3646 15.4265 1.82354 15.8854 2.38803 16.173C2.75203 16.3585 3.13956 16.4324 3.56113 16.4669C3.96702 16.5 4.46529 16.5 5.06901 16.5H12.931C13.5347 16.5 14.033 16.5 14.4389 16.4669C14.8604 16.4324 15.248 16.3585 15.612 16.173C16.1765 15.8854 16.6354 15.4265 16.923 14.862C17.1085 14.498 17.1824 14.1104 17.2169 13.6889C17.25 13.283 17.25 12.7847 17.25 12.181V8.81901C17.25 8.21529 17.25 7.71702 17.2169 7.31113C17.1824 6.88956 17.1085 6.50203 16.923 6.13803C16.6354 5.57354 16.1765 5.1146 15.612 4.82698C15.248 4.64151 14.8604 4.56759 14.4389 4.53315C14.033 4.49998 13.5347 4.49999 12.931 4.5L10.2135 4.5ZM9.73491 6C9.74534 6.00022 9.75579 6.00022 9.76625 6H12.9C13.5424 6 13.9792 6.00058 14.3167 6.02816C14.6455 6.05503 14.8137 6.10372 14.931 6.16349C15.2132 6.3073 15.4427 6.53677 15.5865 6.81902C15.6463 6.93632 15.695 7.10447 15.7218 7.43328C15.7494 7.77085 15.75 8.20757 15.75 8.85V12.15C15.75 12.7924 15.7494 13.2292 15.7218 13.5667C15.695 13.8955 15.6463 14.0637 15.5865 14.181C15.4427 14.4632 15.2132 14.6927 14.931 14.8365C14.8137 14.8963 14.6455 14.945 14.3167 14.9718C13.9792 14.9994 13.5424 15 12.9 15H5.1C4.45757 15 4.02085 14.9994 3.68328 14.9718C3.35447 14.945 3.18632 14.8963 3.06902 14.8365C2.78677 14.6927 2.5573 14.4632 2.41349 14.181C2.35372 14.0637 2.30503 13.8955 2.27816 13.5667C2.25058 13.2292 2.25 12.7924 2.25 12.15V6H9.73491ZM9.86222 7.27484C9.86228 7.27486 9.86215 7.27481 9.86222 7.27484L11.5024 7.8609C11.8008 7.96754 12 8.25025 12 8.56717V10.4439C12 11.5982 11.2077 12.4613 10.6054 12.9636C10.2856 13.2304 9.96966 13.4371 9.73544 13.5766C9.61751 13.6469 9.5182 13.7014 9.44671 13.7391C9.41092 13.758 9.38194 13.7727 9.36093 13.7833L9.33547 13.7959L9.32745 13.7997L9.32466 13.8011L9.32357 13.8016C9.32336 13.8017 9.3227 13.802 9 13.125C8.67731 13.802 8.6771 13.8019 8.67689 13.8018L8.67534 13.8011L8.67255 13.7997L8.66453 13.7959L8.63907 13.7833C8.61806 13.7727 8.58909 13.758 8.55329 13.7391C8.4818 13.7014 8.38249 13.6469 8.26456 13.5766C8.03035 13.4371 7.7144 13.2304 7.3946 12.9636C6.79234 12.4613 6 11.5982 6 10.4439V8.56717C6 8.2503 6.19914 7.96762 6.49751 7.86094L8.13689 7.27484C8.13703 7.27478 8.13674 7.27489 8.13689 7.27484C8.69443 7.07523 9.30469 7.07517 9.86222 7.27484ZM9 13.125L8.67689 13.8018C8.88102 13.8991 9.11857 13.8993 9.3227 13.802L9 13.125ZM9 12.2686C9.18315 12.1578 9.41559 12.0028 9.6446 11.8118C10.1673 11.3757 10.5 10.8983 10.5 10.4439V9.09561L9.35694 8.68717C9.12626 8.60454 8.87339 8.60434 8.64272 8.68697L7.5 9.09552V10.4439C7.5 10.8983 7.83266 11.3757 8.3554 11.8118C8.58441 12.0028 8.81685 12.1578 9 12.2686Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$7e85b93997ca2f4c$var$FolderShieldIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$7e85b93997ca2f4c$var$FolderShieldIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$7e85b93997ca2f4c$var$FolderShieldIcon.displayName = "FolderShieldIcon";
var $dfd33cee3229493c$var$$7e85b93997ca2f4c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7e85b93997ca2f4c$var$FolderShieldIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``folder.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a87614b715672546$var$FolderIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5675 3.04099C7.47703 3.00979 7.35953 3 6.76672 3H3.9C3.46759 3 3.18838 3.00058 2.97588 3.01795C2.77213 3.03459 2.69659 3.06285 2.65951 3.08175C2.51839 3.15365 2.40365 3.26839 2.33175 3.40951C2.31285 3.44659 2.28459 3.52213 2.26795 3.72588C2.25268 3.91274 2.25039 4.15117 2.25006 4.5H8.53648L8.24253 3.9121C7.97742 3.38188 7.91611 3.28115 7.84774 3.21419C7.76832 3.1364 7.6726 3.07724 7.5675 3.04099ZM10.2135 4.5L9.58417 3.24128C9.57015 3.21324 9.55628 3.18542 9.54253 3.15782C9.34397 2.75939 9.16935 2.409 8.89732 2.14256C8.65905 1.9092 8.37189 1.73172 8.05661 1.62297C7.69665 1.49881 7.30516 1.49933 6.85999 1.49992C6.82916 1.49996 6.79807 1.5 6.76672 1.5L3.87109 1.5C3.47573 1.49999 3.13466 1.49998 2.85373 1.52293C2.55722 1.54715 2.26231 1.60064 1.97852 1.74524C1.55516 1.96095 1.21095 2.30516 0.995237 2.72852C0.850641 3.01231 0.797154 3.30722 0.772928 3.60373C0.749976 3.88466 0.749987 4.22573 0.750001 4.62109L0.750001 12.181C0.749991 12.7847 0.749984 13.283 0.783147 13.6889C0.81759 14.1104 0.891514 14.498 1.07698 14.862C1.3646 15.4265 1.82354 15.8854 2.38803 16.173C2.75203 16.3585 3.13956 16.4324 3.56113 16.4669C3.96702 16.5 4.46529 16.5 5.06901 16.5H12.931C13.5347 16.5 14.033 16.5 14.4389 16.4669C14.8604 16.4324 15.248 16.3585 15.612 16.173C16.1765 15.8854 16.6354 15.4265 16.923 14.862C17.1085 14.498 17.1824 14.1104 17.2169 13.6889C17.25 13.283 17.25 12.7847 17.25 12.181V8.81901C17.25 8.21529 17.25 7.71702 17.2169 7.31113C17.1824 6.88956 17.1085 6.50203 16.923 6.13803C16.6354 5.57354 16.1765 5.1146 15.612 4.82698C15.248 4.64151 14.8604 4.56759 14.4389 4.53315C14.033 4.49998 13.5347 4.49999 12.931 4.5L10.2135 4.5ZM9.73491 6C9.74534 6.00022 9.75579 6.00022 9.76625 6H12.9C13.5424 6 13.9792 6.00058 14.3167 6.02816C14.6455 6.05503 14.8137 6.10372 14.931 6.16349C15.2132 6.3073 15.4427 6.53677 15.5865 6.81902C15.6463 6.93632 15.695 7.10447 15.7218 7.43328C15.7494 7.77085 15.75 8.20757 15.75 8.85V12.15C15.75 12.7924 15.7494 13.2292 15.7218 13.5667C15.695 13.8955 15.6463 14.0637 15.5865 14.181C15.4427 14.4632 15.2132 14.6927 14.931 14.8365C14.8137 14.8963 14.6455 14.945 14.3167 14.9718C13.9792 14.9994 13.5424 15 12.9 15H5.1C4.45757 15 4.02085 14.9994 3.68328 14.9718C3.35447 14.945 3.18632 14.8963 3.06902 14.8365C2.78677 14.6927 2.5573 14.4632 2.41349 14.181C2.35372 14.0637 2.30503 13.8955 2.27816 13.5667C2.25058 13.2292 2.25 12.7924 2.25 12.15V6H9.73491Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a87614b715672546$var$FolderIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a87614b715672546$var$FolderIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a87614b715672546$var$FolderIcon.displayName = "FolderIcon";
var $dfd33cee3229493c$var$$a87614b715672546$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a87614b715672546$var$FolderIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``function.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$af6490b73f4e67e3$var$FunctionIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M11.4374 4.58036H9.47662L8.80751 6.64286H10.5859C11.0247 6.64286 11.4394 6.84932 11.7113 7.2032L12.8805 8.72495L14.8745 6.87132C15.2268 6.54379 15.7708 6.57174 16.0896 6.93374C16.4083 7.29575 16.3811 7.85472 16.0288 8.18225L13.9491 10.1156L15.8405 12.5773C16.1349 12.9604 16.0712 13.5163 15.6983 13.8188C15.3254 14.1213 14.7844 14.0559 14.49 13.6727L12.6703 11.3044L10.0068 13.7805C9.65449 14.108 9.11046 14.08 8.7917 13.718C8.47293 13.356 8.50013 12.7971 8.85245 12.4695L11.6018 9.9137L10.4469 8.41071H8.23398L6.36227 14.1802C6.16711 14.7817 5.6192 15.1875 5.00204 15.1875H2.54779C2.07266 15.1875 1.6875 14.7918 1.6875 14.3036C1.6875 13.8154 2.07266 13.4196 2.54779 13.4196H4.79535L6.42034 8.41071H3.69476C3.21964 8.41071 2.83447 8.01497 2.83447 7.52679C2.83447 7.03861 3.21964 6.64286 3.69476 6.64286H6.99386L7.9097 3.81984C8.10486 3.21826 8.65278 2.8125 9.26994 2.8125H11.4374C11.9125 2.8125 12.2977 3.20825 12.2977 3.69643C12.2977 4.18461 11.9125 4.58036 11.4374 4.58036Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$af6490b73f4e67e3$var$FunctionIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$af6490b73f4e67e3$var$FunctionIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$af6490b73f4e67e3$var$FunctionIcon.displayName = "FunctionIcon";
var $dfd33cee3229493c$var$$af6490b73f4e67e3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$af6490b73f4e67e3$var$FunctionIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``globe.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$9ee9cb3908de2775$var$GlobeIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M2.41726 7.5C2.3078 7.98242 2.25 8.48446 2.25 9C2.25 9.51554 2.3078 10.0176 2.41726 10.5H5.3718C5.30144 10.0104 5.26056 9.51475 5.25016 9.01562C5.24995 9.00521 5.24995 8.99479 5.25016 8.98438C5.26056 8.48525 5.30144 7.98961 5.3718 7.5H2.41726ZM2.95164 6H5.68439C6.0288 4.74661 6.57164 3.55354 7.29428 2.46737C5.38861 2.96357 3.81059 4.27158 2.95164 6ZM9 2.6631C8.22024 3.6677 7.62896 4.79844 7.24829 6H10.7517C10.371 4.79844 9.77975 3.6677 9 2.6631ZM11.1106 7.5H6.88941C6.8083 7.99361 6.76144 8.49474 6.75017 9C6.76144 9.50526 6.8083 10.0064 6.88941 10.5H11.1106C11.1917 10.0064 11.2386 9.50526 11.2498 9C11.2386 8.49474 11.1917 7.99361 11.1106 7.5ZM12.6282 10.5C12.6986 10.0104 12.7394 9.51475 12.7498 9.01562C12.7501 9.00521 12.7501 8.99479 12.7498 8.98438C12.7394 8.48525 12.6986 7.98961 12.6282 7.5H15.5827C15.6922 7.98242 15.75 8.48446 15.75 9C15.75 9.51554 15.6922 10.0176 15.5827 10.5H12.6282ZM10.7517 12H7.24829C7.62896 13.2016 8.22024 14.3323 9 15.3369C9.77975 14.3323 10.371 13.2016 10.7517 12ZM7.29428 15.5326C6.57164 14.4465 6.0288 13.2534 5.68439 12H2.95164C3.81059 13.7284 5.38861 15.0364 7.29428 15.5326ZM10.7057 15.5326C11.4284 14.4465 11.9712 13.2534 12.3156 12H15.0484C14.1894 13.7284 12.6114 15.0364 10.7057 15.5326ZM15.0484 6H12.3156C11.9712 4.74661 11.4284 3.55354 10.7057 2.46737C12.6114 2.96357 14.1894 4.27158 15.0484 6ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$9ee9cb3908de2775$var$GlobeIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$9ee9cb3908de2775$var$GlobeIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$9ee9cb3908de2775$var$GlobeIcon.displayName = "GlobeIcon";
var $dfd33cee3229493c$var$$9ee9cb3908de2775$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9ee9cb3908de2775$var$GlobeIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``grid.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$5967c2124168659e$var$GridIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.42608 1.5C3.43405 1.5 3.44202 1.5 3.45 1.5H6.3C6.30799 1.5 6.31596 1.5 6.32393 1.5C6.51321 1.49998 6.69756 1.49996 6.85368 1.51271C7.02512 1.52672 7.22742 1.55977 7.43099 1.66349C7.71323 1.8073 7.9427 2.03678 8.08651 2.31902C8.19024 2.52259 8.22329 2.72489 8.2373 2.89633C8.25005 3.05245 8.25003 3.2368 8.25 3.42609V6.32391C8.25003 6.51321 8.25005 6.69755 8.2373 6.85368C8.22329 7.02512 8.19024 7.22742 8.08651 7.43099C7.9427 7.71323 7.71323 7.9427 7.43099 8.08651C7.22742 8.19024 7.02512 8.22329 6.85368 8.2373C6.69755 8.25005 6.51321 8.25003 6.32391 8.25H3.42609C3.2368 8.25003 3.05245 8.25005 2.89633 8.2373C2.72489 8.22329 2.52259 8.19024 2.31902 8.08651C2.03678 7.9427 1.8073 7.71323 1.66349 7.43099C1.55977 7.22742 1.52672 7.02512 1.51271 6.85368C1.49996 6.69756 1.49998 6.51321 1.5 6.32393C1.5 6.31596 1.5 6.30799 1.5 6.3V3.45C1.5 3.44202 1.5 3.43405 1.5 3.42608C1.49998 3.23679 1.49996 3.05245 1.51271 2.89633C1.52672 2.72489 1.55977 2.52259 1.66349 2.31902C1.8073 2.03677 2.03677 1.8073 2.31902 1.66349C2.52259 1.55977 2.72489 1.52672 2.89633 1.51271C3.05245 1.49996 3.23679 1.49998 3.42608 1.5ZM3.00859 3.00859C3.0083 3.0117 3.00802 3.015 3.00773 3.01848C3.00059 3.10592 3 3.22761 3 3.45V6.3C3 6.5224 3.00059 6.64409 3.00773 6.73153C3.00802 6.73501 3.0083 6.73831 3.00859 6.74142C3.0117 6.7417 3.015 6.74199 3.01848 6.74228C3.10592 6.74942 3.22761 6.75 3.45 6.75H6.3C6.5224 6.75 6.64409 6.74942 6.73153 6.74228C6.73501 6.74199 6.73831 6.7417 6.74142 6.74142C6.7417 6.73831 6.74199 6.73501 6.74228 6.73153C6.74942 6.64409 6.75 6.5224 6.75 6.3V3.45C6.75 3.22761 6.74942 3.10592 6.74228 3.01848C6.74199 3.015 6.7417 3.0117 6.74142 3.00859C6.73831 3.0083 6.73501 3.00802 6.73153 3.00773C6.64409 3.00059 6.5224 3 6.3 3H3.45C3.22761 3 3.10592 3.00059 3.01848 3.00773C3.015 3.00802 3.0117 3.0083 3.00859 3.00859ZM11.6761 1.5H14.5739C14.7632 1.49998 14.9476 1.49996 15.1037 1.51271C15.2751 1.52672 15.4774 1.55977 15.681 1.66349C15.9632 1.8073 16.1927 2.03678 16.3365 2.31902C16.4402 2.52259 16.4733 2.72489 16.4873 2.89633C16.5001 3.05245 16.5 3.23678 16.5 3.42607V6.32394C16.5 6.51322 16.5001 6.69756 16.4873 6.85368C16.4733 7.02512 16.4402 7.22742 16.3365 7.43099C16.1927 7.71323 15.9632 7.9427 15.681 8.08651C15.4774 8.19024 15.2751 8.22329 15.1037 8.2373C14.9476 8.25005 14.7632 8.25003 14.5739 8.25H11.6761C11.4868 8.25003 11.3025 8.25005 11.1463 8.2373C10.9749 8.22329 10.7726 8.19024 10.569 8.08651C10.2868 7.9427 10.0573 7.71323 9.91349 7.43099C9.80977 7.22742 9.77672 7.02512 9.76271 6.85368C9.74996 6.69755 9.74998 6.51321 9.75 6.32392V3.42609C9.74998 3.2368 9.74996 3.05245 9.76271 2.89633C9.77672 2.72489 9.80977 2.52259 9.91349 2.31902C10.0573 2.03678 10.2868 1.8073 10.569 1.66349C10.7726 1.55977 10.9749 1.52672 11.1463 1.51271C11.3025 1.49996 11.4868 1.49998 11.6761 1.5ZM11.2586 3.00859C11.2583 3.0117 11.258 3.015 11.2577 3.01848C11.2506 3.10592 11.25 3.22761 11.25 3.45V6.3C11.25 6.5224 11.2506 6.64409 11.2577 6.73153C11.258 6.73501 11.2583 6.73831 11.2586 6.74142C11.2617 6.7417 11.265 6.74199 11.2685 6.74228C11.3559 6.74942 11.4776 6.75 11.7 6.75H14.55C14.7724 6.75 14.8941 6.74942 14.9815 6.74228C14.985 6.74199 14.9883 6.7417 14.9914 6.74141C14.9917 6.7383 14.992 6.73501 14.9923 6.73153C14.9994 6.64409 15 6.5224 15 6.3V3.45C15 3.22761 14.9994 3.10592 14.9923 3.01848C14.992 3.015 14.9917 3.0117 14.9914 3.00859C14.9883 3.0083 14.985 3.00802 14.9815 3.00773C14.8941 3.00059 14.7724 3 14.55 3H11.7C11.4776 3 11.3559 3.00059 11.2685 3.00773C11.265 3.00802 11.2617 3.0083 11.2586 3.00859ZM3.42609 9.75H6.32392C6.51321 9.74998 6.69755 9.74996 6.85368 9.76271C7.02512 9.77672 7.22742 9.80977 7.43099 9.91349C7.71323 10.0573 7.9427 10.2868 8.08651 10.569C8.19024 10.7726 8.22329 10.9749 8.2373 11.1463C8.25005 11.3025 8.25003 11.4868 8.25 11.6761V14.5739C8.25003 14.7632 8.25005 14.9476 8.2373 15.1037C8.22329 15.2751 8.19024 15.4774 8.08651 15.681C7.9427 15.9632 7.71323 16.1927 7.43099 16.3365C7.22742 16.4402 7.02512 16.4733 6.85368 16.4873C6.69756 16.5001 6.51322 16.5 6.32394 16.5H3.42607C3.23678 16.5 3.05245 16.5001 2.89633 16.4873C2.72489 16.4733 2.52259 16.4402 2.31902 16.3365C2.03678 16.1927 1.8073 15.9632 1.66349 15.681C1.55977 15.4774 1.52672 15.2751 1.51271 15.1037C1.49996 14.9476 1.49998 14.7632 1.5 14.5739V11.6761C1.49998 11.4868 1.49996 11.3025 1.51271 11.1463C1.52672 10.9749 1.55977 10.7726 1.66349 10.569C1.8073 10.2868 2.03678 10.0573 2.31902 9.91349C2.52259 9.80977 2.72489 9.77672 2.89633 9.76271C3.05245 9.74996 3.2368 9.74998 3.42609 9.75ZM3.00859 11.2586C3.0083 11.2617 3.00802 11.265 3.00773 11.2685C3.00059 11.3559 3 11.4776 3 11.7V14.55C3 14.7724 3.00059 14.8941 3.00773 14.9815C3.00802 14.985 3.0083 14.9883 3.00859 14.9914C3.0117 14.9917 3.015 14.992 3.01848 14.9923C3.10592 14.9994 3.22761 15 3.45 15H6.3C6.5224 15 6.64409 14.9994 6.73153 14.9923C6.73501 14.992 6.73831 14.9917 6.74142 14.9914C6.74171 14.9883 6.74199 14.985 6.74228 14.9815C6.74942 14.8941 6.75 14.7724 6.75 14.55V11.7C6.75 11.4776 6.74942 11.3559 6.74228 11.2685C6.74199 11.265 6.7417 11.2617 6.74142 11.2586C6.73831 11.2583 6.73501 11.258 6.73153 11.2577C6.64409 11.2506 6.5224 11.25 6.3 11.25H3.45C3.22761 11.25 3.10592 11.2506 3.01848 11.2577C3.015 11.258 3.0117 11.2583 3.00859 11.2586ZM11.6761 9.75H14.5739C14.7632 9.74998 14.9476 9.74996 15.1037 9.76271C15.2751 9.77672 15.4774 9.80977 15.681 9.91349C15.9632 10.0573 16.1927 10.2868 16.3365 10.569C16.4402 10.7726 16.4733 10.9749 16.4873 11.1463C16.5001 11.3024 16.5 11.4868 16.5 11.6761V14.5739C16.5 14.7632 16.5001 14.9476 16.4873 15.1037C16.4733 15.2751 16.4402 15.4774 16.3365 15.681C16.1927 15.9632 15.9632 16.1927 15.681 16.3365C15.4774 16.4402 15.2751 16.4733 15.1037 16.4873C14.9476 16.5001 14.7632 16.5 14.5739 16.5H11.6761C11.4868 16.5 11.3024 16.5001 11.1463 16.4873C10.9749 16.4733 10.7726 16.4402 10.569 16.3365C10.2868 16.1927 10.0573 15.9632 9.91349 15.681C9.80977 15.4774 9.77672 15.2751 9.76271 15.1037C9.74996 14.9476 9.74998 14.7632 9.75 14.5739V11.6761C9.74998 11.4868 9.74996 11.3025 9.76271 11.1463C9.77672 10.9749 9.80977 10.7726 9.91349 10.569C10.0573 10.2868 10.2868 10.0573 10.569 9.91349C10.7726 9.80977 10.9749 9.77672 11.1463 9.76271C11.3025 9.74996 11.4868 9.74998 11.6761 9.75ZM11.2586 11.2586C11.2583 11.2617 11.258 11.265 11.2577 11.2685C11.2506 11.3559 11.25 11.4776 11.25 11.7V14.55C11.25 14.7724 11.2506 14.8941 11.2577 14.9815C11.258 14.985 11.2583 14.9883 11.2586 14.9914C11.2617 14.9917 11.265 14.992 11.2685 14.9923C11.3559 14.9994 11.4776 15 11.7 15H14.55C14.7724 15 14.8941 14.9994 14.9815 14.9923C14.985 14.992 14.9883 14.9917 14.9914 14.9914C14.9917 14.9883 14.992 14.985 14.9923 14.9815C14.9994 14.8941 15 14.7724 15 14.55V11.7C15 11.4776 14.9994 11.3559 14.9923 11.2685C14.992 11.265 14.9917 11.2617 14.9914 11.2586C14.9883 11.2583 14.985 11.258 14.9815 11.2577C14.8941 11.2506 14.7724 11.25 14.55 11.25H11.7C11.4776 11.25 11.3559 11.2506 11.2685 11.2577C11.265 11.258 11.2617 11.2583 11.2586 11.2586Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$5967c2124168659e$var$GridIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$5967c2124168659e$var$GridIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$5967c2124168659e$var$GridIcon.displayName = "GridIcon";
var $dfd33cee3229493c$var$$5967c2124168659e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5967c2124168659e$var$GridIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``hand.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$071fc2a6e61d32b7$var$HandIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C8.69598 2.25 8.475 2.48779 8.475 2.75V8.16667C8.475 8.58088 8.13921 8.91667 7.725 8.91667C7.31079 8.91667 6.975 8.58088 6.975 8.16667V3.58333C6.975 3.32112 6.75402 3.08333 6.45 3.08333C6.14598 3.08333 5.925 3.32112 5.925 3.58333V10.6667C5.925 11.0809 5.58921 11.4167 5.175 11.4167C4.76079 11.4167 4.425 11.0809 4.425 10.6667V8.58333C4.425 8.32112 4.20402 8.08333 3.9 8.08333C3.59598 8.08333 3.375 8.32112 3.375 8.58333V10.25C3.375 13.2736 5.87933 15.75 9 15.75C12.1207 15.75 14.625 13.2736 14.625 10.25V6.08333C14.625 5.82112 14.404 5.58333 14.1 5.58333C13.796 5.58333 13.575 5.82112 13.575 6.08333V8.16667C13.575 8.58088 13.2392 8.91667 12.825 8.91667C12.4108 8.91667 12.075 8.58088 12.075 8.16667V3.58333C12.075 3.32112 11.854 3.08333 11.55 3.08333C11.246 3.08333 11.025 3.32112 11.025 3.58333V8.16667C11.025 8.58088 10.6892 8.91667 10.275 8.91667C9.86079 8.91667 9.525 8.58088 9.525 8.16667V2.75C9.525 2.48779 9.30402 2.25 9 2.25ZM10.7518 1.7452C10.3988 1.14656 9.74068 0.75 9 0.75C8.25932 0.75 7.60124 1.14656 7.24816 1.7452C7.00229 1.64087 6.73214 1.58333 6.45 1.58333C5.34569 1.58333 4.425 2.46483 4.425 3.58333V6.65155C4.2571 6.60702 4.08102 6.58333 3.9 6.58333C2.79569 6.58333 1.875 7.46483 1.875 8.58333V10.25C1.875 14.1299 5.07904 17.25 9 17.25C12.921 17.25 16.125 14.1299 16.125 10.25V6.08333C16.125 4.96483 15.2043 4.08333 14.1 4.08333C13.919 4.08333 13.7429 4.10702 13.575 4.15155V3.58333C13.575 2.46483 12.6543 1.58333 11.55 1.58333C11.2679 1.58333 10.9977 1.64087 10.7518 1.7452Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$071fc2a6e61d32b7$var$HandIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$071fc2a6e61d32b7$var$HandIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$071fc2a6e61d32b7$var$HandIcon.displayName = "HandIcon";
var $dfd33cee3229493c$var$$071fc2a6e61d32b7$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$071fc2a6e61d32b7$var$HandIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``hash.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$078b145b2ca47ae6$var$HashIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.24829 1.5102C7.65687 1.5783 7.93288 1.96472 7.86478 2.37329L7.38533 5.24999H11.8646L12.3852 2.1267C12.4533 1.71812 12.8397 1.4421 13.2483 1.5102C13.6569 1.5783 13.9329 1.96472 13.8648 2.37329L13.3853 5.24999H15.375C15.7892 5.24999 16.125 5.58578 16.125 5.99999C16.125 6.41421 15.7892 6.74999 15.375 6.74999H13.1353L12.3853 11.25H14.625C15.0392 11.25 15.375 11.5858 15.375 12C15.375 12.4142 15.0392 12.75 14.625 12.75H12.1353L11.6148 15.8733C11.5467 16.2819 11.1603 16.5579 10.7517 16.4898C10.3431 16.4217 10.0671 16.0353 10.1352 15.6267L10.6146 12.75H6.13533L5.61478 15.8733C5.54669 16.2819 5.16027 16.5579 4.75169 16.4898C4.34311 16.4217 4.0671 16.0353 4.13519 15.6267L4.61464 12.75H1.875C1.46079 12.75 1.125 12.4142 1.125 12C1.125 11.5858 1.46079 11.25 1.875 11.25H4.86464L5.61464 6.74999H2.625C2.21079 6.74999 1.875 6.41421 1.875 5.99999C1.875 5.58578 2.21079 5.24999 2.625 5.24999H5.86464L6.38519 2.1267C6.45329 1.71812 6.83971 1.4421 7.24829 1.5102ZM7.13533 6.74999L6.38533 11.25H10.8646L11.6146 6.74999H7.13533Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$078b145b2ca47ae6$var$HashIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$078b145b2ca47ae6$var$HashIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$078b145b2ca47ae6$var$HashIcon.displayName = "HashIcon";
var $dfd33cee3229493c$var$$078b145b2ca47ae6$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$078b145b2ca47ae6$var$HashIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``heart.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e45010246229a52c$var$HeartIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.9946 2.78774C7.23967 1.25408 4.64433 0.940234 2.62885 2.6623C0.448756 4.52502 0.132009 7.66213 1.85597 9.88052C2.51037 10.7226 3.78761 11.9877 5.01507 13.1462C6.2569 14.3184 7.49586 15.426 8.10686 15.9671L8.11849 15.9774C8.17594 16.0283 8.24746 16.0917 8.31602 16.1433C8.3981 16.2051 8.51593 16.2819 8.67328 16.3288C8.88246 16.3912 9.10732 16.3912 9.3165 16.3288C9.47385 16.2819 9.59168 16.2051 9.67376 16.1433C9.74232 16.0917 9.81384 16.0283 9.87129 15.9774L9.88292 15.9671C10.4939 15.426 11.7329 14.3184 12.9747 13.1462C14.2022 11.9877 15.4794 10.7226 16.1338 9.88052C17.8511 7.67065 17.5833 4.50935 15.3531 2.65572C13.3152 0.961905 10.7475 1.25349 8.9946 2.78774ZM8.42495 4.33937C7.14615 2.84435 5.11344 2.51238 3.60325 3.80272C2.02576 5.15056 1.81349 7.38134 3.04038 8.96009C3.6127 9.69655 4.80504 10.8853 6.04468 12.0554C7.20196 13.1478 8.35958 14.1859 8.99489 14.7498C9.6302 14.1859 10.7878 13.1478 11.9451 12.0554C13.1847 10.8853 14.3771 9.69655 14.9494 8.96009C16.1829 7.37282 15.9863 5.13246 14.3943 3.8093C12.8441 2.52085 10.838 2.85095 9.56483 4.33937C9.42234 4.50596 9.2141 4.60186 8.99489 4.60186C8.77568 4.60186 8.56744 4.50596 8.42495 4.33937Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e45010246229a52c$var$HeartIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e45010246229a52c$var$HeartIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e45010246229a52c$var$HeartIcon.displayName = "HeartIcon";
var $dfd33cee3229493c$var$$e45010246229a52c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e45010246229a52c$var$HeartIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``help-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$88c382020d5989db$var$HelpCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM9.19359 6.01824C8.84445 5.95835 8.48538 6.02396 8.17998 6.20345C7.87458 6.38294 7.64255 6.66472 7.525 6.99888C7.38755 7.38962 6.95936 7.59496 6.56862 7.4575C6.17788 7.32005 5.97255 6.89186 6.11 6.50112C6.3451 5.83279 6.80915 5.26922 7.41995 4.91025C8.03076 4.55128 8.74889 4.42006 9.44718 4.53983C10.1455 4.6596 10.7788 5.02264 11.2351 5.56465C11.6912 6.10654 11.941 6.79236 11.94 7.50068C11.9397 8.64845 11.0887 9.40642 10.481 9.81154C10.1543 10.0294 9.83292 10.1895 9.59617 10.2947C9.47673 10.3478 9.37615 10.3881 9.30368 10.4157C9.26738 10.4295 9.23795 10.4403 9.21653 10.4479L9.19048 10.457L9.18218 10.4598L9.17926 10.4608L9.17811 10.4612C9.17788 10.4613 9.17717 10.4615 8.94 9.75L9.17717 10.4615C8.78421 10.5925 8.35947 10.3801 8.22849 9.98717C8.09755 9.59434 8.30973 9.16976 8.70244 9.03862L8.71401 9.03455C8.72555 9.03045 8.74446 9.02359 8.76968 9.01398C8.82026 8.99471 8.89546 8.96468 8.98696 8.92402C9.17208 8.84174 9.4132 8.72065 9.64898 8.56346C10.1662 8.21866 10.44 7.85185 10.44 7.5V7.49888C10.4405 7.14464 10.3157 6.80165 10.0875 6.53065C9.85941 6.25964 9.54273 6.07813 9.19359 6.01824ZM8.25 12.75C8.25 12.3358 8.58579 12 9 12H9.0075C9.42171 12 9.7575 12.3358 9.7575 12.75C9.7575 13.1642 9.42171 13.5 9.0075 13.5H9C8.58579 13.5 8.25 13.1642 8.25 12.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$88c382020d5989db$var$HelpCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$88c382020d5989db$var$HelpCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$88c382020d5989db$var$HelpCircleIcon.displayName = "HelpCircleIcon";
var $dfd33cee3229493c$var$$88c382020d5989db$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$88c382020d5989db$var$HelpCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``home.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0b65397d53bc7401$var$HomeIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.60796 1.00227C8.86469 0.932757 9.13528 0.932757 9.392 1.00227C9.69003 1.08296 9.94094 1.27995 10.1412 1.43718C10.1603 1.45219 10.179 1.46684 10.1972 1.48099L15.2839 5.43733C15.3035 5.45256 15.3229 5.46764 15.3422 5.4826C15.6247 5.70181 15.8735 5.89493 16.059 6.14566C16.2217 6.36569 16.3429 6.61358 16.4167 6.87713C16.5008 7.17744 16.5004 7.49245 16.5 7.85C16.5 7.8744 16.5 7.89899 16.5 7.92379V13.3789C16.5 13.7743 16.5 14.1153 16.4771 14.3963C16.4528 14.6928 16.3993 14.9877 16.2547 15.2715C16.039 15.6948 15.6948 16.039 15.2715 16.2548C14.9877 16.3993 14.6928 16.4528 14.3963 16.4771C14.1153 16.5 13.7743 16.5 13.3789 16.5H4.62106C4.2257 16.5 3.88464 16.5 3.60371 16.4771C3.3072 16.4528 3.01229 16.3993 2.7285 16.2548C2.30514 16.039 1.96093 15.6948 1.74522 15.2715C1.60062 14.9877 1.54714 14.6928 1.52291 14.3963C1.49996 14.1153 1.49997 13.7743 1.49998 13.3789L1.49998 7.92379C1.49998 7.89899 1.49996 7.8744 1.49993 7.85C1.49954 7.49244 1.4992 7.17744 1.58326 6.87713C1.65703 6.61357 1.77827 6.36569 1.94101 6.14566C2.12646 5.89493 2.37532 5.7018 2.65779 5.48259C2.67707 5.46763 2.69649 5.45255 2.71607 5.43733L7.8028 1.48098C7.82099 1.46683 7.83965 1.45219 7.85877 1.43718C8.05902 1.27995 8.30994 1.08296 8.60796 1.00227ZM8.99451 2.46115C8.93814 2.4988 8.86389 2.55598 8.72371 2.66501L3.63698 6.62136C3.26343 6.9119 3.19386 6.97426 3.14699 7.03763C3.09274 7.11097 3.05233 7.1936 3.02774 7.28145C3.0065 7.35735 2.99998 7.45055 2.99998 7.92379V13.35C2.99998 13.7824 3.00057 14.0616 3.01793 14.2741C3.03457 14.4779 3.06283 14.5534 3.08173 14.5905C3.15363 14.7316 3.26837 14.8463 3.40949 14.9182C3.44657 14.9371 3.52211 14.9654 3.72586 14.982C3.93836 14.9994 4.21757 15 4.64998 15H13.35C13.7824 15 14.0616 14.9994 14.2741 14.982C14.4779 14.9654 14.5534 14.9371 14.5905 14.9182C14.7316 14.8463 14.8463 14.7316 14.9182 14.5905C14.9371 14.5534 14.9654 14.4779 14.982 14.2741C14.9994 14.0616 15 13.7824 15 13.35V7.92379C15 7.45055 14.9935 7.35735 14.9722 7.28145C14.9476 7.1936 14.9072 7.11097 14.853 7.03763C14.8061 6.97426 14.7365 6.9119 14.363 6.62136L9.27626 2.66501C9.13608 2.55598 9.06182 2.4988 9.00546 2.46115C9.00355 2.45987 9.00172 2.45866 8.99998 2.45752C8.99824 2.45866 8.99642 2.45987 8.99451 2.46115ZM5.90755 9.77366C6.30869 9.67041 6.71758 9.9119 6.82082 10.313C7.07064 11.2836 7.9526 12 8.99998 12C10.0474 12 10.9293 11.2836 11.1791 10.313C11.2824 9.9119 11.6913 9.67041 12.0924 9.77366C12.4936 9.87691 12.735 10.2858 12.6318 10.6869C12.2155 12.3042 10.7484 13.5 8.99998 13.5C7.2516 13.5 5.78442 12.3042 5.36817 10.6869C5.26492 10.2858 5.50641 9.87691 5.90755 9.77366Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0b65397d53bc7401$var$HomeIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0b65397d53bc7401$var$HomeIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0b65397d53bc7401$var$HomeIcon.displayName = "HomeIcon";
var $dfd33cee3229493c$var$$0b65397d53bc7401$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0b65397d53bc7401$var$HomeIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``image-plus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$4ed41d502fd4b10f$var$ImagePlusIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M14.25 0.75C14.6642 0.75 15 1.08579 15 1.5V3H16.5C16.9142 3 17.25 3.33579 17.25 3.75C17.25 4.16421 16.9142 4.5 16.5 4.5H15V6C15 6.41421 14.6642 6.75 14.25 6.75C13.8358 6.75 13.5 6.41421 13.5 6V4.5H12C11.5858 4.5 11.25 4.16421 11.25 3.75C11.25 3.33579 11.5858 3 12 3H13.5V1.5C13.5 1.08579 13.8358 0.75 14.25 0.75ZM5.81903 1.5H9.375C9.78922 1.5 10.125 1.83579 10.125 2.25C10.125 2.66421 9.78922 3 9.375 3H5.85C5.20757 3 4.77085 3.00058 4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81901C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77084 3 5.20756 3 5.85V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.2979 14.4448 3.50715 14.6625 3.76438 14.8072C3.82918 14.7057 3.89851 14.6289 3.94414 14.5795C4.05792 14.4564 4.2127 14.3157 4.37281 14.1702L10.7539 8.36926C10.8746 8.25949 10.9939 8.15094 11.1032 8.06577C11.2247 7.97109 11.3753 7.8712 11.5677 7.8087C11.8382 7.72084 12.1281 7.7117 12.4036 7.78233C12.5996 7.83257 12.7562 7.92277 12.8834 8.00961C12.9978 8.08772 13.1238 8.18853 13.2512 8.29047L15.3658 9.98219C15.3822 9.99525 15.3984 10.0082 15.4144 10.021C15.6501 10.2092 15.8575 10.3748 16.0199 10.5817C16.2221 10.8393 16.3656 11.1379 16.4404 11.4567C16.5006 11.7127 16.5003 11.9782 16.5 12.2798C16.5 12.3004 16.5 12.3211 16.5 12.342V12.3685C16.5 12.4933 16.5 12.6128 16.4997 12.7272C16.4999 12.7348 16.5 12.7424 16.5 12.75C16.5 12.7849 16.5 12.8193 16.5 12.8532C16.5004 13.4497 16.5006 13.8927 16.3978 14.2765C16.2764 14.7294 16.0534 15.1389 15.7541 15.4796C15.647 15.6016 15.53 15.7148 15.4045 15.818C15.0794 16.0852 14.6966 16.2852 14.2765 16.3978C13.8927 16.5006 13.4497 16.5004 12.8532 16.5C12.8193 16.5 12.7849 16.5 12.75 16.5H12.414C12.3989 16.5 12.3837 16.5 12.3685 16.5H5.81901C5.80092 16.5 5.78292 16.5 5.76502 16.5L5.27354 16.5C5.08168 16.5 4.89548 16.5 4.73932 16.4899C4.58641 16.485 4.44383 16.4777 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM14.6925 14.4099C14.7671 14.3122 14.83 14.2048 14.8791 14.09C14.9231 13.9872 14.9593 13.8402 14.9792 13.5567C14.9996 13.2663 15 12.8922 15 12.342C15 11.9432 14.9953 11.8643 14.9801 11.7995C14.9552 11.6933 14.9074 11.5937 14.84 11.5079C14.7989 11.4556 14.7402 11.4026 14.4288 11.1535L12.3309 9.47515C12.1801 9.35454 12.0992 9.29049 12.0377 9.24847C12.0355 9.24697 12.0334 9.24555 12.0314 9.2442C12.0295 9.24567 12.0274 9.24722 12.0253 9.24886C11.9666 9.29468 11.8899 9.3637 11.747 9.49356L5.68999 15C5.74187 15 5.79519 15 5.85 15H12.342C12.8922 15 13.2663 14.9996 13.5567 14.9792C13.8402 14.9593 13.9872 14.9231 14.09 14.8791C14.2067 14.8292 14.3157 14.765 14.4147 14.6888C14.5191 14.6085 14.6126 14.5147 14.6925 14.4099ZM6.375 5.625C5.96079 5.625 5.625 5.96079 5.625 6.375C5.625 6.78921 5.96079 7.125 6.375 7.125C6.78921 7.125 7.125 6.78921 7.125 6.375C7.125 5.96079 6.78921 5.625 6.375 5.625ZM4.125 6.375C4.125 5.13236 5.13236 4.125 6.375 4.125C7.61764 4.125 8.625 5.13236 8.625 6.375C8.625 7.61764 7.61764 8.625 6.375 8.625C5.13236 8.625 4.125 7.61764 4.125 6.375Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$4ed41d502fd4b10f$var$ImagePlusIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$4ed41d502fd4b10f$var$ImagePlusIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$4ed41d502fd4b10f$var$ImagePlusIcon.displayName = "ImagePlusIcon";
var $dfd33cee3229493c$var$$4ed41d502fd4b10f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4ed41d502fd4b10f$var$ImagePlusIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``image.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$461ac26c4c6cbf7a$var$ImageIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.80092 16.5 5.78292 16.5 5.76502 16.5L5.17062 16.5C4.96783 16.5 4.7685 16.5001 4.60802 16.4858C4.60203 16.4853 4.59576 16.4847 4.58925 16.4841C4.49208 16.4797 4.39942 16.4741 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM5.85 15C5.74862 15 5.65236 15 5.56081 14.9999L11.6818 8.87886C11.8391 8.7216 11.9255 8.63597 11.9924 8.57919C11.9951 8.57693 11.9976 8.5748 12 8.5728C12.0024 8.5748 12.0049 8.57693 12.0076 8.57919C12.0745 8.63597 12.1609 8.7216 12.3182 8.87886L15 11.5607V12.15C15 12.7924 14.9994 13.2292 14.9718 13.5667C14.945 13.8955 14.8963 14.0637 14.8365 14.181C14.6927 14.4632 14.4632 14.6927 14.181 14.8365C14.0637 14.8963 13.8955 14.945 13.5667 14.9718C13.2292 14.9994 12.7924 15 12.15 15H5.85ZM15 9.43934L13.362 7.8013C13.2281 7.66743 13.0978 7.53706 12.9784 7.43568C12.8472 7.32435 12.6808 7.20468 12.4635 7.13408C12.1623 7.03619 11.8377 7.03619 11.5365 7.13408C11.3192 7.20468 11.1528 7.32436 11.0216 7.43568C10.9022 7.53706 10.7719 7.66742 10.6381 7.80129L4.22421 14.2151C4.08079 14.3585 3.93982 14.4994 3.83639 14.623C3.80446 14.6611 3.76141 14.7139 3.71772 14.7799C3.48183 14.6357 3.28968 14.4287 3.16349 14.181C3.10372 14.0637 3.05503 13.8955 3.02816 13.5667C3.00058 13.2292 3 12.7924 3 12.15V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H12.15C12.7924 3 13.2292 3.00058 13.5667 3.02816C13.8955 3.05503 14.0637 3.10372 14.181 3.16349C14.4632 3.3073 14.6927 3.53677 14.8365 3.81902C14.8963 3.93631 14.945 4.10447 14.9718 4.43328C14.9994 4.77085 15 5.20757 15 5.85V9.43934ZM6.375 5.625C5.96079 5.625 5.625 5.96079 5.625 6.375C5.625 6.78921 5.96079 7.125 6.375 7.125C6.78921 7.125 7.125 6.78921 7.125 6.375C7.125 5.96079 6.78921 5.625 6.375 5.625ZM4.125 6.375C4.125 5.13236 5.13236 4.125 6.375 4.125C7.61764 4.125 8.625 5.13236 8.625 6.375C8.625 7.61764 7.61764 8.625 6.375 8.625C5.13236 8.625 4.125 7.61764 4.125 6.375Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$461ac26c4c6cbf7a$var$ImageIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$461ac26c4c6cbf7a$var$ImageIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$461ac26c4c6cbf7a$var$ImageIcon.displayName = "ImageIcon";
var $dfd33cee3229493c$var$$461ac26c4c6cbf7a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$461ac26c4c6cbf7a$var$ImageIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``info-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$8c7a0bab804af32d$var$InfoCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM8.25 6C8.25 5.58579 8.58579 5.25 9 5.25H9.0075C9.42171 5.25 9.7575 5.58579 9.7575 6C9.7575 6.41421 9.42171 6.75 9.0075 6.75H9C8.58579 6.75 8.25 6.41421 8.25 6ZM9 8.25C9.41421 8.25 9.75 8.58579 9.75 9V12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12V9C8.25 8.58579 8.58579 8.25 9 8.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$8c7a0bab804af32d$var$InfoCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$8c7a0bab804af32d$var$InfoCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$8c7a0bab804af32d$var$InfoCircleIcon.displayName = "InfoCircleIcon";
var $dfd33cee3229493c$var$$8c7a0bab804af32d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8c7a0bab804af32d$var$InfoCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``key.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$04cc33e0010a88fd$var$KeyIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.00001 6.75C6.00001 3.8505 8.35051 1.5 11.25 1.5C14.1495 1.5 16.5 3.8505 16.5 6.75C16.5 9.64949 14.1495 12 11.25 12C11.0112 12 10.7758 11.984 10.5448 11.953C10.376 11.9303 10.2704 11.9162 10.1935 11.9088C10.1797 11.9074 10.1685 11.9065 10.1594 11.9058C10.1571 11.9079 10.1547 11.9101 10.152 11.9125C10.1119 11.949 10.0591 12.0015 9.96469 12.096L8.78034 13.2803C8.63968 13.421 8.44892 13.5 8.25001 13.5H7.50001V14.25C7.50001 14.6642 7.16422 15 6.75001 15H6.00001V15.75C6.00001 16.1642 5.66422 16.5 5.25001 16.5L3.42607 16.5C3.23679 16.5 3.05245 16.5 2.89633 16.4873C2.72489 16.4733 2.52259 16.4402 2.31902 16.3365C2.03678 16.1927 1.80731 15.9632 1.6635 15.681C1.55977 15.4774 1.52672 15.2751 1.51271 15.1037C1.49996 14.9476 1.49998 14.7632 1.5 14.5739L1.50001 13.2471C1.50001 13.2346 1.49997 13.2219 1.49994 13.2088C1.49956 13.0663 1.49908 12.887 1.54145 12.7105C1.5782 12.5574 1.6388 12.4111 1.72105 12.2769C1.81589 12.1221 1.94305 11.9957 2.04403 11.8952C2.05331 11.886 2.06236 11.877 2.07115 11.8682L5.90403 8.03532C5.99847 7.94088 6.05096 7.88811 6.0875 7.848C6.08993 7.84533 6.09215 7.84286 6.09417 7.8406C6.0935 7.83153 6.09257 7.82026 6.09124 7.80654C6.08381 7.72956 6.06974 7.62396 6.04705 7.45521C6.016 7.22421 6.00001 6.98877 6.00001 6.75ZM6.00001 13.5V12.75C6.00001 12.3358 6.33579 12 6.75001 12H7.93935L8.90403 11.0353C8.91683 11.0225 8.92993 11.0093 8.94331 10.9959C9.07775 10.8606 9.24127 10.696 9.42765 10.5918C9.60272 10.494 9.74858 10.4447 9.94712 10.4163C10.0922 10.3955 10.2334 10.4056 10.3376 10.4157C10.446 10.4262 10.5799 10.4442 10.7313 10.4645L10.7447 10.4663C10.9096 10.4885 11.0783 10.5 11.25 10.5C13.3211 10.5 15 8.82107 15 6.75C15 4.67893 13.3211 3 11.25 3C9.17894 3 7.50001 4.67893 7.50001 6.75C7.50001 6.92174 7.5115 7.09041 7.53368 7.25535L7.53547 7.2687C7.55583 7.42008 7.57383 7.55398 7.5843 7.66239C7.59436 7.7666 7.60448 7.90784 7.58374 8.05289C7.55534 8.25142 7.50605 8.39729 7.4082 8.57235C7.30402 8.75873 7.13945 8.92225 7.00414 9.05669C6.99067 9.07008 6.97749 9.08318 6.96469 9.09598L3.13181 12.9289C3.06233 12.9983 3.02779 13.0331 3.00375 13.0595C3.00312 13.0602 3.00252 13.0608 3.00194 13.0615C3.0019 13.0623 3.00186 13.0632 3.00181 13.0642C3.00018 13.0998 3.00001 13.1488 3.00001 13.2471V14.55C3.00001 14.7724 3.00059 14.8941 3.00773 14.9815C3.00802 14.985 3.0083 14.9883 3.00859 14.9914C3.0117 14.9917 3.015 14.992 3.01848 14.9923C3.10592 14.9994 3.22761 15 3.45001 15H4.50001V14.25C4.50001 13.8358 4.83579 13.5 5.25001 13.5H6.00001ZM10.5 5.25C10.5 4.83579 10.8358 4.5 11.25 4.5C11.8247 4.5 12.4018 4.71982 12.841 5.15901C13.2802 5.59819 13.5 6.17529 13.5 6.74994C13.5 7.16415 13.1642 7.49994 12.75 7.49996C12.3358 7.49997 12 7.16419 12 6.74998C12 6.55688 11.9269 6.36626 11.7803 6.21967C11.6337 6.07308 11.4431 6 11.25 6C10.8358 6 10.5 5.66421 10.5 5.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$04cc33e0010a88fd$var$KeyIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$04cc33e0010a88fd$var$KeyIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$04cc33e0010a88fd$var$KeyIcon.displayName = "KeyIcon";
var $dfd33cee3229493c$var$$04cc33e0010a88fd$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$04cc33e0010a88fd$var$KeyIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``keyboard.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$8f3877a22db00c15$var$KeyboardIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.87109 3.75H14.1289C14.5243 3.74999 14.8653 3.74998 15.1463 3.77293C15.4428 3.79715 15.7377 3.85064 16.0215 3.99524C16.4448 4.21095 16.7891 4.55516 17.0048 4.97852C17.1494 5.26231 17.2028 5.55722 17.2271 5.85373C17.25 6.13466 17.25 6.47572 17.25 6.87108V11.1289C17.25 11.5243 17.25 11.8653 17.2271 12.1463C17.2028 12.4428 17.1494 12.7377 17.0048 13.0215C16.7891 13.4448 16.4448 13.7891 16.0215 14.0048C15.7377 14.1494 15.4428 14.2028 15.1463 14.2271C14.8653 14.25 14.5243 14.25 14.1289 14.25H3.87111C3.47574 14.25 3.13466 14.25 2.85373 14.2271C2.55722 14.2028 2.26231 14.1494 1.97852 14.0048C1.55516 13.7891 1.21095 13.4448 0.995237 13.0215C0.850641 12.7377 0.797154 12.4428 0.772928 12.1463C0.749976 11.8653 0.749987 11.5243 0.750001 11.1289V6.87109C0.749987 6.47573 0.749976 6.13466 0.772928 5.85373C0.797154 5.55722 0.850641 5.26231 0.995237 4.97852C1.21095 4.55516 1.55516 4.21095 1.97852 3.99524C2.26231 3.85064 2.55722 3.79715 2.85373 3.77293C3.13466 3.74998 3.47573 3.74999 3.87109 3.75ZM2.97588 5.26795C2.77213 5.28459 2.69659 5.31285 2.65951 5.33175C2.51839 5.40365 2.40365 5.51839 2.33175 5.65951C2.31285 5.69659 2.28459 5.77213 2.26795 5.97588C2.25058 6.18838 2.25 6.46759 2.25 6.9V11.1C2.25 11.5324 2.25058 11.8116 2.26795 12.0241C2.28459 12.2279 2.31285 12.3034 2.33175 12.3405C2.40365 12.4816 2.51839 12.5964 2.65951 12.6683C2.69659 12.6872 2.77213 12.7154 2.97588 12.7321C3.18838 12.7494 3.46759 12.75 3.9 12.75H14.1C14.5324 12.75 14.8116 12.7494 15.0241 12.7321C15.2279 12.7154 15.3034 12.6872 15.3405 12.6683C15.4816 12.5964 15.5963 12.4816 15.6683 12.3405C15.6872 12.3034 15.7154 12.2279 15.7321 12.0241C15.7494 11.8116 15.75 11.5324 15.75 11.1V6.9C15.75 6.46759 15.7494 6.18838 15.7321 5.97588C15.7154 5.77213 15.6872 5.69659 15.6683 5.65951C15.5963 5.51839 15.4816 5.40365 15.3405 5.33175C15.3034 5.31285 15.2279 5.28459 15.0241 5.26795C14.8116 5.25058 14.5324 5.25 14.1 5.25H3.9C3.46759 5.25 3.18838 5.25058 2.97588 5.26795ZM3.75 7.5C3.75 7.08579 4.08579 6.75 4.5 6.75H4.5075C4.92172 6.75 5.2575 7.08579 5.2575 7.5C5.2575 7.91422 4.92172 8.25 4.5075 8.25H4.5C4.08579 8.25 3.75 7.91422 3.75 7.5ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75H7.5075C7.92172 6.75 8.2575 7.08579 8.2575 7.5C8.2575 7.91422 7.92172 8.25 7.5075 8.25H7.5C7.08579 8.25 6.75 7.91422 6.75 7.5ZM9.75 7.5C9.75 7.08579 10.0858 6.75 10.5 6.75H10.5075C10.9217 6.75 11.2575 7.08579 11.2575 7.5C11.2575 7.91422 10.9217 8.25 10.5075 8.25H10.5C10.0858 8.25 9.75 7.91422 9.75 7.5ZM12.75 7.5C12.75 7.08579 13.0858 6.75 13.5 6.75H13.5075C13.9217 6.75 14.2575 7.08579 14.2575 7.5C14.2575 7.91422 13.9217 8.25 13.5075 8.25H13.5C13.0858 8.25 12.75 7.91422 12.75 7.5ZM4.5 10.875C4.5 10.4608 4.83579 10.125 5.25 10.125H12.75C13.1642 10.125 13.5 10.4608 13.5 10.875C13.5 11.2892 13.1642 11.625 12.75 11.625H5.25C4.83579 11.625 4.5 11.2892 4.5 10.875Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$8f3877a22db00c15$var$KeyboardIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$8f3877a22db00c15$var$KeyboardIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$8f3877a22db00c15$var$KeyboardIcon.displayName = "KeyboardIcon";
var $dfd33cee3229493c$var$$8f3877a22db00c15$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8f3877a22db00c15$var$KeyboardIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``layout-bottom.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$8109d312553946dc$var$LayoutBottomIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM3 12V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V12H3ZM15 10.5H3V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H12.15C12.7924 3 13.2292 3.00058 13.5667 3.02816C13.8955 3.05503 14.0637 3.10372 14.181 3.16349C14.4632 3.3073 14.6927 3.53677 14.8365 3.81902C14.8963 3.93631 14.945 4.10447 14.9718 4.43328C14.9994 4.77085 15 5.20757 15 5.85V10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$8109d312553946dc$var$LayoutBottomIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$8109d312553946dc$var$LayoutBottomIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$8109d312553946dc$var$LayoutBottomIcon.displayName = "LayoutBottomIcon";
var $dfd33cee3229493c$var$$8109d312553946dc$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8109d312553946dc$var$LayoutBottomIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``layout-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a20a17ce116281c8$var$LayoutLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM7.5 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H7.5V15ZM6 3V15H5.85C5.20757 15 4.77085 14.9994 4.43328 14.9718C4.10447 14.945 3.93631 14.8963 3.81902 14.8365C3.53677 14.6927 3.3073 14.4632 3.16349 14.181C3.10372 14.0637 3.05503 13.8955 3.02816 13.5667C3.00058 13.2292 3 12.7924 3 12.15V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H6Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a20a17ce116281c8$var$LayoutLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a20a17ce116281c8$var$LayoutLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a20a17ce116281c8$var$LayoutLeftIcon.displayName = "LayoutLeftIcon";
var $dfd33cee3229493c$var$$a20a17ce116281c8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a20a17ce116281c8$var$LayoutLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``layout-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$558d9d9264192066$var$LayoutRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM12 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H12V15ZM10.5 3V15H5.85C5.20757 15 4.77085 14.9994 4.43328 14.9718C4.10447 14.945 3.93631 14.8963 3.81902 14.8365C3.53677 14.6927 3.3073 14.4632 3.16349 14.181C3.10372 14.0637 3.05503 13.8955 3.02816 13.5667C3.00058 13.2292 3 12.7924 3 12.15V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$558d9d9264192066$var$LayoutRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$558d9d9264192066$var$LayoutRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$558d9d9264192066$var$LayoutRightIcon.displayName = "LayoutRightIcon";
var $dfd33cee3229493c$var$$558d9d9264192066$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$558d9d9264192066$var$LayoutRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``layout-top.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$58a242424c31cbea$var$LayoutTopIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM3 7.5V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V7.5H3ZM15 6H3V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H12.15C12.7924 3 13.2292 3.00058 13.5667 3.02816C13.8955 3.05503 14.0637 3.10372 14.181 3.16349C14.4632 3.3073 14.6927 3.53677 14.8365 3.81902C14.8963 3.93631 14.945 4.10447 14.9718 4.43328C14.9994 4.77085 15 5.20757 15 5.85V6Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$58a242424c31cbea$var$LayoutTopIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$58a242424c31cbea$var$LayoutTopIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$58a242424c31cbea$var$LayoutTopIcon.displayName = "LayoutTopIcon";
var $dfd33cee3229493c$var$$58a242424c31cbea$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$58a242424c31cbea$var$LayoutTopIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``layout.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$ac5d6a02d4fd7a75$var$LayoutIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM3 7.5V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H6V7.5H3ZM3 6V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H12.15C12.7924 3 13.2292 3.00058 13.5667 3.02816C13.8955 3.05503 14.0637 3.10372 14.181 3.16349C14.4632 3.3073 14.6927 3.53677 14.8365 3.81902C14.8963 3.93631 14.945 4.10447 14.9718 4.43328C14.9994 4.77085 15 5.20757 15 5.85V6H3ZM7.5 7.5V15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V7.5H7.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$ac5d6a02d4fd7a75$var$LayoutIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$ac5d6a02d4fd7a75$var$LayoutIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$ac5d6a02d4fd7a75$var$LayoutIcon.displayName = "LayoutIcon";
var $dfd33cee3229493c$var$$ac5d6a02d4fd7a75$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ac5d6a02d4fd7a75$var$LayoutIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``left-indent.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$191527481a0c9aee$var$LeftIndentIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.63906 1.60431C3.64606 1.60956 3.65304 1.6148 3.66001 1.62002L6.56001 3.79502C6.56561 3.79922 6.57126 3.80346 6.57696 3.80773C6.67037 3.87774 6.77598 3.9569 6.86067 4.03307C6.95406 4.11707 7.09161 4.25669 7.1735 4.46724C7.27551 4.72953 7.27551 5.02052 7.1735 5.2828C7.09161 5.49335 6.95406 5.63298 6.86067 5.71698C6.77598 5.79315 6.67037 5.8723 6.57696 5.94231C6.57126 5.94659 6.56561 5.95082 6.56001 5.95502L3.66001 8.13002C3.65304 8.13525 3.64605 8.14049 3.63906 8.14574C3.50303 8.2478 3.36304 8.35285 3.23988 8.42879C3.12011 8.50264 2.89274 8.63083 2.60162 8.62478C2.26401 8.61776 1.94741 8.45946 1.73923 8.19359C1.55972 7.96432 1.52585 7.7055 1.51308 7.56539C1.49993 7.42129 1.49997 7.24627 1.5 7.07621C1.50001 7.06746 1.50001 7.05874 1.50001 7.05002V2.70002C1.50001 2.69131 1.50001 2.68259 1.5 2.67384C1.49997 2.50378 1.49993 2.32876 1.51308 2.18466C1.52585 2.04455 1.55972 1.78573 1.73923 1.55646C1.94741 1.29059 2.26401 1.13229 2.60162 1.12527C2.89274 1.11922 3.12012 1.24742 3.23988 1.32126C3.36304 1.3972 3.50304 1.50225 3.63906 1.60431ZM3.00001 3.00002V6.75002L5.50001 4.87502L3.00001 3.00002ZM8.25001 3.00002C8.25001 2.58581 8.58579 2.25002 9.00001 2.25002L15.75 2.25003C16.1642 2.25003 16.5 2.58581 16.5 3.00003C16.5 3.41424 16.1642 3.75003 15.75 3.75003L9.00001 3.75002C8.58579 3.75002 8.25001 3.41424 8.25001 3.00002ZM8.25001 6.93752C8.25001 6.52331 8.58579 6.18752 9.00001 6.18752H15.75C16.1642 6.18752 16.5 6.52331 16.5 6.93752C16.5 7.35174 16.1642 7.68752 15.75 7.68752H9.00001C8.58579 7.68752 8.25001 7.35174 8.25001 6.93752ZM1.50001 11.0625C1.50001 10.6483 1.83579 10.3125 2.25001 10.3125H15.75C16.1642 10.3125 16.5 10.6483 16.5 11.0625C16.5 11.4767 16.1642 11.8125 15.75 11.8125H2.25001C1.83579 11.8125 1.50001 11.4767 1.50001 11.0625ZM1.50001 15C1.50001 14.5858 1.83579 14.25 2.25001 14.25H15.75C16.1642 14.25 16.5 14.5858 16.5 15C16.5 15.4142 16.1642 15.75 15.75 15.75H2.25001C1.83579 15.75 1.50001 15.4142 1.50001 15Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$191527481a0c9aee$var$LeftIndentIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$191527481a0c9aee$var$LeftIndentIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$191527481a0c9aee$var$LeftIndentIcon.displayName = "LeftIndentIcon";
var $dfd33cee3229493c$var$$191527481a0c9aee$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$191527481a0c9aee$var$LeftIndentIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``lightbulb.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0fe384fe0ace939a$var$LightbulbIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V2.25C9.75 2.66421 9.41421 3 9 3C8.58579 3 8.25 2.66421 8.25 2.25V1.5C8.25 1.08579 8.58579 0.75 9 0.75ZM3.1446 3.1446C3.43749 2.8517 3.91236 2.8517 4.20526 3.1446L4.65533 3.59467C4.94822 3.88756 4.94822 4.36244 4.65533 4.65533C4.36244 4.94822 3.88756 4.94822 3.59467 4.65533L3.1446 4.20526C2.8517 3.91236 2.8517 3.43749 3.1446 3.1446ZM14.8556 3.14466C15.1484 3.43759 15.1484 3.91247 14.8554 4.20532L14.4053 4.6554C14.1123 4.94825 13.6375 4.94819 13.3446 4.65526C13.0517 4.36233 13.0518 3.88746 13.3447 3.5946L13.7949 3.14453C14.0879 2.85167 14.5627 2.85173 14.8556 3.14466ZM3.75 9C3.75 6.1005 6.1005 3.75 9 3.75C11.8995 3.75 14.25 6.10051 14.25 9C14.25 10.6149 13.5202 12.0594 12.375 13.0215V14.1289C12.375 14.5243 12.375 14.8653 12.3521 15.1463C12.3278 15.4428 12.2744 15.7377 12.1298 16.0215C11.914 16.4448 11.5698 16.7891 11.1465 17.0048C10.8627 17.1494 10.5678 17.2028 10.2713 17.2271C9.99035 17.25 9.64928 17.25 9.25393 17.25H8.74607C8.35072 17.25 8.00965 17.25 7.72873 17.2271C7.43222 17.2028 7.13731 17.1494 6.85352 17.0048C6.43016 16.7891 6.08595 16.4448 5.87024 16.0215C5.72564 15.7377 5.67215 15.4428 5.64793 15.1463C5.62497 14.8653 5.62499 14.5243 5.625 14.1289L5.625 13.0215C4.47979 12.0594 3.75 10.6149 3.75 9ZM9 5.25C6.92893 5.25 5.25 6.92893 5.25 9C5.25 10.2541 5.8649 11.3646 6.81298 12.0466C7.00888 12.1876 7.125 12.4141 7.125 12.6555V14.1C7.125 14.5324 7.12558 14.8116 7.14295 15.0241C7.15959 15.2279 7.18785 15.3034 7.20675 15.3405C7.27865 15.4816 7.39338 15.5963 7.53451 15.6683C7.57159 15.6871 7.64713 15.7154 7.85088 15.7321C8.06338 15.7494 8.34258 15.75 8.775 15.75H9.225C9.65742 15.75 9.93662 15.7494 10.1491 15.7321C10.3529 15.7154 10.4284 15.6871 10.4655 15.6683C10.6066 15.5963 10.7213 15.4816 10.7933 15.3405C10.8122 15.3034 10.8404 15.2279 10.8571 15.0241C10.8744 14.8116 10.875 14.5324 10.875 14.1V12.6555C10.875 12.4141 10.9911 12.1876 11.187 12.0466C12.1351 11.3646 12.75 10.2541 12.75 9C12.75 6.92893 11.0711 5.25 9 5.25ZM0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H2.25C2.66421 8.25 3 8.58579 3 9C3 9.41421 2.66421 9.75 2.25 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9ZM15 9C15 8.58579 15.3358 8.25 15.75 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H15.75C15.3358 9.75 15 9.41421 15 9ZM6.75 10.125C6.75 9.71079 7.08579 9.375 7.5 9.375H10.5C10.9142 9.375 11.25 9.71079 11.25 10.125C11.25 10.5392 10.9142 10.875 10.5 10.875H9.75V13.875C9.75 14.2892 9.41421 14.625 9 14.625C8.58579 14.625 8.25 14.2892 8.25 13.875V10.875H7.5C7.08579 10.875 6.75 10.5392 6.75 10.125Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0fe384fe0ace939a$var$LightbulbIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0fe384fe0ace939a$var$LightbulbIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0fe384fe0ace939a$var$LightbulbIcon.displayName = "LightbulbIcon";
var $dfd33cee3229493c$var$$0fe384fe0ace939a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0fe384fe0ace939a$var$LightbulbIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``line-chart-up.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$30828e1724cf1454$var$LineChartUpIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.51205 13.4307 1.50438 13.1352 1.50159 12.799C1.4997 12.7699 1.4995 12.7407 1.50098 12.7117C1.49999 12.5446 1.5 12.3678 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM3.00521 13.0555C3.00914 13.251 3.01605 13.4184 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H5.85C5.20757 3 4.77085 3.00058 4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81902C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77085 3 5.20757 3 5.85V10.9393L5.04541 8.89393C5.04944 8.8899 5.05353 8.88581 5.05767 8.88166C5.12082 8.81847 5.19624 8.74299 5.26813 8.68196C5.35143 8.61124 5.47788 8.51708 5.65236 8.46039C5.87831 8.38698 6.1217 8.38698 6.34764 8.46039C6.52212 8.51708 6.64857 8.61124 6.73187 8.68196C6.80377 8.74299 6.87918 8.81847 6.94233 8.88166C6.94647 8.88581 6.95056 8.8899 6.9546 8.89393L8.25 10.1893L10.9393 7.5H9.75C9.33579 7.5 9 7.16421 9 6.75C9 6.33579 9.33579 6 9.75 6H12.75C13.1642 6 13.5 6.33579 13.5 6.75V9.75C13.5 10.1642 13.1642 10.5 12.75 10.5C12.3358 10.5 12 10.1642 12 9.75V8.56066L9.20459 11.3561C9.20056 11.3601 9.19647 11.3642 9.19233 11.3683C9.12918 11.4315 9.05377 11.507 8.98187 11.568C8.89857 11.6388 8.77212 11.7329 8.59764 11.7896C8.3717 11.863 8.12831 11.863 7.90236 11.7896C7.72788 11.7329 7.60143 11.6388 7.51813 11.568C7.44624 11.507 7.37082 11.4315 7.30768 11.3683C7.30353 11.3642 7.29944 11.3601 7.29541 11.3561L6 10.0607L3.00521 13.0555Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$30828e1724cf1454$var$LineChartUpIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$30828e1724cf1454$var$LineChartUpIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$30828e1724cf1454$var$LineChartUpIcon.displayName = "LineChartUpIcon";
var $dfd33cee3229493c$var$$30828e1724cf1454$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$30828e1724cf1454$var$LineChartUpIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``line-chart.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$ce90a2e1bfe9b355$var$LineChartIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5C2.66421 1.5 3 1.83579 3 2.25V15H15.75C16.1642 15 16.5 15.3358 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75V2.25ZM15.5473 6.51279C15.8305 6.21052 15.8151 5.7359 15.5128 5.45269C15.2105 5.16949 14.7359 5.18494 14.4527 5.48721L11.5913 8.54126L9.24911 7.32513L9.22113 7.3103C9.12082 7.25672 8.91249 7.14545 8.68033 7.12453C8.48549 7.10697 8.28944 7.14053 8.11154 7.22188C7.89955 7.31882 7.74008 7.49304 7.6633 7.57693L7.64185 7.60022L4.70269 10.7372C4.41949 11.0395 4.43494 11.5141 4.73721 11.7973C5.03948 12.0805 5.5141 12.0651 5.79731 11.7628L8.65875 8.70874L11.0009 9.92488L11.0289 9.9397C11.1292 9.99328 11.3375 10.1046 11.5697 10.1255C11.7645 10.143 11.9606 10.1095 12.1385 10.0281C12.3505 9.93119 12.5099 9.75696 12.5867 9.67307L12.6082 9.64979L15.5473 6.51279Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$ce90a2e1bfe9b355$var$LineChartIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$ce90a2e1bfe9b355$var$LineChartIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$ce90a2e1bfe9b355$var$LineChartIcon.displayName = "LineChartIcon";
var $dfd33cee3229493c$var$$ce90a2e1bfe9b355$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ce90a2e1bfe9b355$var$LineChartIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``link-external.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$6a017a6b0b6ab383$var$LinkExternalIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M10.5 2.25C10.5 1.83579 10.8358 1.5 11.25 1.5H15.75C16.1642 1.5 16.5 1.83579 16.5 2.25L16.5 6.75C16.5 7.16421 16.1642 7.5 15.75 7.5C15.3358 7.5 15 7.16421 15 6.75L15 4.06066L10.2803 8.78033C9.98744 9.07322 9.51256 9.07322 9.21967 8.78033C8.92678 8.48744 8.92678 8.01256 9.21967 7.71967L13.9393 3H11.25C10.8358 3 10.5 2.66421 10.5 2.25ZM5.81903 3L7.5 3C7.91421 3 8.25 3.33579 8.25 3.75C8.25 4.16421 7.91421 4.5 7.5 4.5H5.85C5.20757 4.5 4.77085 4.50058 4.43328 4.52816C4.10447 4.55503 3.93631 4.60372 3.81902 4.66349C3.53677 4.8073 3.3073 5.03677 3.16349 5.31901C3.10372 5.43631 3.05503 5.60447 3.02816 5.93328C3.00058 6.27085 3 6.70757 3 7.35V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81901 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H10.65C11.2924 15 11.7292 14.9994 12.0667 14.9718C12.3955 14.945 12.5637 14.8963 12.681 14.8365C12.9632 14.6927 13.1927 14.4632 13.3365 14.181C13.3963 14.0637 13.445 13.8955 13.4718 13.5667C13.4994 13.2292 13.5 12.7924 13.5 12.15V10.5C13.5 10.0858 13.8358 9.75 14.25 9.75C14.6642 9.75 15 10.0858 15 10.5V12.181C15 12.7847 15 13.283 14.9669 13.6889C14.9324 14.1104 14.8585 14.498 14.673 14.862C14.3854 15.4265 13.9265 15.8854 13.362 16.173C12.998 16.3585 12.6104 16.4324 12.1889 16.4669C11.783 16.5 11.2847 16.5 10.681 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V7.31903C1.49999 6.7153 1.49998 6.21703 1.53315 5.81113C1.56759 5.38956 1.64151 5.00203 1.82698 4.63803C2.1146 4.07354 2.57354 3.6146 3.13803 3.32698C3.50203 3.14151 3.88956 3.06759 4.31113 3.03315C4.71703 2.99998 5.2153 2.99999 5.81903 3Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$6a017a6b0b6ab383$var$LinkExternalIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$6a017a6b0b6ab383$var$LinkExternalIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$6a017a6b0b6ab383$var$LinkExternalIcon.displayName = "LinkExternalIcon";
var $dfd33cee3229493c$var$$6a017a6b0b6ab383$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6a017a6b0b6ab383$var$LinkExternalIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``link.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$2305b07e90d9d0db$var$LinkIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9.58149 2.06301C10.4302 1.2433 11.5669 0.789722 12.7468 0.799975C13.9267 0.810228 15.0553 1.28349 15.8897 2.11782C16.724 2.95216 17.1973 4.08082 17.2075 5.2607C17.2178 6.44059 16.7642 7.5773 15.9445 8.42601L15.9354 8.4353L13.6855 10.6852C13.6854 10.6852 13.6855 10.6852 13.6855 10.6852C13.2293 11.1415 12.6802 11.4945 12.0757 11.72C11.4711 11.9455 10.8251 12.0384 10.1814 11.9923C9.53781 11.9462 8.91162 11.7622 8.34535 11.4529C7.77908 11.1435 7.28596 10.7159 6.89946 10.1992C6.65135 9.86752 6.71911 9.39751 7.05079 9.1494C7.38248 8.9013 7.8525 8.96905 8.1006 9.30074C8.35827 9.64522 8.68702 9.93025 9.06453 10.1365C9.44205 10.3428 9.85951 10.4654 10.2886 10.4961C10.7177 10.5269 11.1484 10.465 11.5514 10.3146C11.9545 10.1643 12.3205 9.92898 12.6246 9.62474L14.8699 7.37948C15.4136 6.81415 15.7144 6.05826 15.7076 5.27374C15.7008 4.48715 15.3852 3.73471 14.829 3.17848C14.2728 2.62226 13.5204 2.30675 12.7338 2.29992C11.9489 2.2931 11.1927 2.59416 10.6272 3.13839L9.34131 4.41685C9.04756 4.70889 8.57269 4.7075 8.28065 4.41376C7.98862 4.12001 7.99 3.64514 8.28375 3.3531L9.57375 2.0706L9.58149 2.06301ZM5.92439 6.27994C6.52897 6.05441 7.17499 5.96154 7.81862 6.00764C8.46224 6.05374 9.08843 6.23771 9.65471 6.54709C10.221 6.85648 10.7141 7.28402 11.1006 7.80074C11.3487 8.13243 11.281 8.60244 10.9493 8.85055C10.6176 9.09865 10.1476 9.0309 9.89945 8.69921C9.64178 8.35473 9.31304 8.0697 8.93552 7.86344C8.55801 7.65719 8.14055 7.53454 7.71146 7.50381C7.28238 7.47308 6.8517 7.53499 6.44865 7.68534C6.04559 7.83569 5.67959 8.07097 5.37545 8.37521L3.13022 10.6204C2.58644 11.1858 2.28565 11.9417 2.29247 12.7262C2.29931 13.5128 2.61481 14.2652 3.17104 14.8215C3.72726 15.3777 4.4797 15.6932 5.26629 15.7C6.05083 15.7068 6.80674 15.4061 7.37207 14.8623L8.6497 13.5846C8.94259 13.2917 9.41746 13.2917 9.71036 13.5846C10.0033 13.8775 10.0033 14.3524 9.71036 14.6453L8.42786 15.9278L8.41856 15.9369C7.56985 16.7567 6.43314 17.2102 5.25326 17.2C4.07337 17.1897 2.94471 16.7165 2.11038 15.8821C1.27604 15.0478 0.802781 13.9191 0.792529 12.7392C0.782276 11.5594 1.23585 10.4227 2.05556 9.57394L2.0647 9.56464L4.3146 7.31474C4.31463 7.31471 4.31457 7.31477 4.3146 7.31474C4.77078 6.85842 5.31985 6.50545 5.92439 6.27994Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$2305b07e90d9d0db$var$LinkIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$2305b07e90d9d0db$var$LinkIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$2305b07e90d9d0db$var$LinkIcon.displayName = "LinkIcon";
var $dfd33cee3229493c$var$$2305b07e90d9d0db$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2305b07e90d9d0db$var$LinkIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``list.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$572fb6a1e3f0d886$var$ListIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 4.5C1.5 3.67157 2.17157 3 3 3C3.82843 3 4.5 3.67157 4.5 4.5C4.5 5.32843 3.82843 6 3 6C2.17157 6 1.5 5.32843 1.5 4.5ZM6 4.5C6 4.08579 6.33579 3.75 6.75 3.75H15.75C16.1642 3.75 16.5 4.08579 16.5 4.5C16.5 4.91421 16.1642 5.25 15.75 5.25L6.75 5.25C6.33579 5.25 6 4.91421 6 4.5ZM1.5 9C1.5 8.17157 2.17157 7.5 3 7.5C3.82843 7.5 4.5 8.17157 4.5 9C4.5 9.82843 3.82843 10.5 3 10.5C2.17157 10.5 1.5 9.82843 1.5 9ZM6 9C6 8.58579 6.33579 8.25 6.75 8.25L15.75 8.25C16.1642 8.25 16.5 8.58579 16.5 9C16.5 9.41421 16.1642 9.75 15.75 9.75L6.75 9.75C6.33579 9.75 6 9.41421 6 9ZM1.5 13.5C1.5 12.6716 2.17157 12 3 12C3.82843 12 4.5 12.6716 4.5 13.5C4.5 14.3284 3.82843 15 3 15C2.17157 15 1.5 14.3284 1.5 13.5ZM6 13.5C6 13.0858 6.33579 12.75 6.75 12.75L15.75 12.75C16.1642 12.75 16.5 13.0858 16.5 13.5C16.5 13.9142 16.1642 14.25 15.75 14.25L6.75 14.25C6.33579 14.25 6 13.9142 6 13.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$572fb6a1e3f0d886$var$ListIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$572fb6a1e3f0d886$var$ListIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$572fb6a1e3f0d886$var$ListIcon.displayName = "ListIcon";
var $dfd33cee3229493c$var$$572fb6a1e3f0d886$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$572fb6a1e3f0d886$var$ListIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``location.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$90af8029d940d5b1$var$LocationIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C6.1005 2.25 3.75 4.6005 3.75 7.5C3.75 8.91908 4.38988 10.2585 5.46921 11.66C6.38056 12.8434 7.54705 14.0004 8.79921 15.2425C8.8659 15.3086 8.93284 15.375 9 15.4417C9.06716 15.375 9.1341 15.3086 9.20079 15.2425C10.4529 14.0004 11.6194 12.8434 12.5308 11.66C13.6101 10.2585 14.25 8.91908 14.25 7.5C14.25 4.6005 11.8995 2.25 9 2.25ZM2.25 7.5C2.25 3.77208 5.27208 0.75 9 0.75C12.7279 0.75 15.75 3.77208 15.75 7.5C15.75 9.39463 14.8899 11.0552 13.7192 12.5753C12.741 13.8455 11.4889 15.0867 10.2381 16.3266C10.0015 16.5612 9.76497 16.7957 9.53033 17.0303C9.23744 17.3232 8.76256 17.3232 8.46967 17.0303C8.23503 16.7957 7.99848 16.5612 7.76188 16.3266C6.5111 15.0867 5.25904 13.8455 4.28079 12.5753C3.11012 11.0552 2.25 9.39463 2.25 7.5ZM9 6C8.17157 6 7.5 6.67157 7.5 7.5C7.5 8.32843 8.17157 9 9 9C9.82843 9 10.5 8.32843 10.5 7.5C10.5 6.67157 9.82843 6 9 6ZM6 7.5C6 5.84315 7.34315 4.5 9 4.5C10.6569 4.5 12 5.84315 12 7.5C12 9.15685 10.6569 10.5 9 10.5C7.34315 10.5 6 9.15685 6 7.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$90af8029d940d5b1$var$LocationIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$90af8029d940d5b1$var$LocationIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$90af8029d940d5b1$var$LocationIcon.displayName = "LocationIcon";
var $dfd33cee3229493c$var$$90af8029d940d5b1$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$90af8029d940d5b1$var$LocationIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``lock-unlocked.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$83aefe9987b5f24b$var$LockUnlockedIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C10.8465 1.5 12.4315 2.61198 13.1252 4.19972C13.2911 4.57929 13.1178 5.02143 12.7382 5.18726C12.3587 5.3531 11.9165 5.17984 11.7507 4.80028C11.2871 3.73917 10.229 3 9 3C7.34315 3 6 4.34315 6 6V6.75122C6.17828 6.74999 6.3678 6.75 6.56903 6.75H11.431C12.0347 6.74999 12.533 6.74998 12.9389 6.78315C13.3604 6.81759 13.748 6.89151 14.112 7.07698C14.6765 7.3646 15.1354 7.82354 15.423 8.38803C15.6085 8.75203 15.6824 9.13956 15.7169 9.56113C15.75 9.96702 15.75 10.4653 15.75 11.069V12.181C15.75 12.7847 15.75 13.283 15.7169 13.6889C15.6824 14.1104 15.6085 14.498 15.423 14.862C15.1354 15.4265 14.6765 15.8854 14.112 16.173C13.748 16.3585 13.3604 16.4324 12.9389 16.4669C12.533 16.5 12.0347 16.5 11.431 16.5H6.56901C5.96529 16.5 5.46702 16.5 5.06113 16.4669C4.63956 16.4324 4.25203 16.3585 3.88803 16.173C3.32354 15.8854 2.8646 15.4265 2.57698 14.862C2.39151 14.498 2.31759 14.1104 2.28315 13.6889C2.24998 13.283 2.24999 12.7847 2.25 12.181V11.069C2.24999 10.4653 2.24998 9.96703 2.28315 9.56113C2.31759 9.13956 2.39151 8.75203 2.57698 8.38803C2.8646 7.82354 3.32354 7.3646 3.88803 7.07698C4.08461 6.97682 4.28804 6.90919 4.5 6.86274V6ZM5.18328 8.27816C4.85447 8.30503 4.68631 8.35372 4.56902 8.41349C4.28677 8.5573 4.0573 8.78677 3.91349 9.06901C3.85372 9.18631 3.80503 9.35447 3.77816 9.68328C3.75058 10.0208 3.75 10.4576 3.75 11.1V12.15C3.75 12.7924 3.75058 13.2292 3.77816 13.5667C3.80503 13.8955 3.85372 14.0637 3.91349 14.181C4.0573 14.4632 4.28677 14.6927 4.56902 14.8365C4.68631 14.8963 4.85447 14.945 5.18328 14.9718C5.52085 14.9994 5.95757 15 6.6 15H11.4C12.0424 15 12.4792 14.9994 12.8167 14.9718C13.1455 14.945 13.3137 14.8963 13.431 14.8365C13.7132 14.6927 13.9427 14.4632 14.0865 14.181C14.1463 14.0637 14.195 13.8955 14.2218 13.5667C14.2494 13.2292 14.25 12.7924 14.25 12.15V11.1C14.25 10.4576 14.2494 10.0208 14.2218 9.68328C14.195 9.35447 14.1463 9.18631 14.0865 9.06901C13.9427 8.78677 13.7132 8.5573 13.431 8.41349C13.3137 8.35372 13.1455 8.30503 12.8167 8.27816C12.4792 8.25058 12.0424 8.25 11.4 8.25H6.6C5.95757 8.25 5.52085 8.25058 5.18328 8.27816ZM9 10.125C9.41421 10.125 9.75 10.4608 9.75 10.875V12.375C9.75 12.7892 9.41421 13.125 9 13.125C8.58579 13.125 8.25 12.7892 8.25 12.375V10.875C8.25 10.4608 8.58579 10.125 9 10.125Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$83aefe9987b5f24b$var$LockUnlockedIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$83aefe9987b5f24b$var$LockUnlockedIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$83aefe9987b5f24b$var$LockUnlockedIcon.displayName = "LockUnlockedIcon";
var $dfd33cee3229493c$var$$83aefe9987b5f24b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$83aefe9987b5f24b$var$LockUnlockedIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``lock.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$adab9ddd77011d91$var$LockIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6V6.86274C13.712 6.90919 13.9154 6.97682 14.112 7.07698C14.6765 7.3646 15.1354 7.82354 15.423 8.38803C15.6085 8.75203 15.6824 9.13956 15.7169 9.56113C15.75 9.96702 15.75 10.4653 15.75 11.069V12.181C15.75 12.7847 15.75 13.283 15.7169 13.6889C15.6824 14.1104 15.6085 14.498 15.423 14.862C15.1354 15.4265 14.6765 15.8854 14.112 16.173C13.748 16.3585 13.3604 16.4324 12.9389 16.4669C12.533 16.5 12.0347 16.5 11.431 16.5H6.56901C5.96529 16.5 5.46702 16.5 5.06113 16.4669C4.63956 16.4324 4.25203 16.3585 3.88803 16.173C3.32354 15.8854 2.8646 15.4265 2.57698 14.862C2.39151 14.498 2.31759 14.1104 2.28315 13.6889C2.24998 13.283 2.24999 12.7847 2.25 12.181V11.069C2.24999 10.4653 2.24998 9.96703 2.28315 9.56113C2.31759 9.13956 2.39151 8.75203 2.57698 8.38803C2.8646 7.82354 3.32354 7.3646 3.88803 7.07698C4.08461 6.97682 4.28804 6.90919 4.5 6.86274V6ZM6 6.75122C6.17828 6.74999 6.3678 6.75 6.56903 6.75H11.431C11.6322 6.75 11.8217 6.74999 12 6.75122V6C12 4.34315 10.6569 3 9 3C7.34315 3 6 4.34315 6 6V6.75122ZM5.18328 8.27816C4.85447 8.30503 4.68631 8.35372 4.56902 8.41349C4.28677 8.5573 4.0573 8.78677 3.91349 9.06901C3.85372 9.18631 3.80503 9.35447 3.77816 9.68328C3.75058 10.0208 3.75 10.4576 3.75 11.1V12.15C3.75 12.7924 3.75058 13.2292 3.77816 13.5667C3.80503 13.8955 3.85372 14.0637 3.91349 14.181C4.0573 14.4632 4.28677 14.6927 4.56902 14.8365C4.68631 14.8963 4.85447 14.945 5.18328 14.9718C5.52085 14.9994 5.95757 15 6.6 15H11.4C12.0424 15 12.4792 14.9994 12.8167 14.9718C13.1455 14.945 13.3137 14.8963 13.431 14.8365C13.7132 14.6927 13.9427 14.4632 14.0865 14.181C14.1463 14.0637 14.195 13.8955 14.2218 13.5667C14.2494 13.2292 14.25 12.7924 14.25 12.15V11.1C14.25 10.4576 14.2494 10.0208 14.2218 9.68328C14.195 9.35447 14.1463 9.18631 14.0865 9.06901C13.9427 8.78677 13.7132 8.5573 13.431 8.41349C13.3137 8.35372 13.1455 8.30503 12.8167 8.27816C12.4792 8.25058 12.0424 8.25 11.4 8.25H6.6C5.95757 8.25 5.52085 8.25058 5.18328 8.27816ZM9 10.125C9.41421 10.125 9.75 10.4608 9.75 10.875V12.375C9.75 12.7892 9.41421 13.125 9 13.125C8.58579 13.125 8.25 12.7892 8.25 12.375V10.875C8.25 10.4608 8.58579 10.125 9 10.125Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$adab9ddd77011d91$var$LockIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$adab9ddd77011d91$var$LockIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$adab9ddd77011d91$var$LockIcon.displayName = "LockIcon";
var $dfd33cee3229493c$var$$adab9ddd77011d91$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$adab9ddd77011d91$var$LockIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``log-out.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$46616a4c77b270f1$var$LogOutIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M0.75 9C0.75 4.88479 3.96951 1.5 8 1.5C9.325 1.5 10.5679 1.86834 11.6362 2.51011C11.9913 2.72341 12.1062 3.18417 11.8929 3.53924C11.6796 3.89431 11.2189 4.00924 10.8638 3.79595C10.02 3.28907 9.04287 3 8 3C4.85079 3 2.25 5.65936 2.25 9C2.25 12.3406 4.85079 15 8 15C9.04287 15 10.02 14.7109 10.8638 14.2041C11.2189 13.9908 11.6796 14.1057 11.8929 14.4608C12.1062 14.8158 11.9913 15.2766 11.6362 15.4899C10.5679 16.1317 9.325 16.5 8 16.5C3.96951 16.5 0.75 13.1152 0.75 9ZM12.9697 5.46967C13.2626 5.17678 13.7374 5.17678 14.0303 5.46967L17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L14.0303 12.5303C13.7374 12.8232 13.2626 12.8232 12.9697 12.5303C12.6768 12.2374 12.6768 11.7626 12.9697 11.4697L14.6893 9.75H6.75C6.33579 9.75 6 9.41421 6 9C6 8.58579 6.33579 8.25 6.75 8.25H14.6893L12.9697 6.53033C12.6768 6.23744 12.6768 5.76256 12.9697 5.46967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$46616a4c77b270f1$var$LogOutIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$46616a4c77b270f1$var$LogOutIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$46616a4c77b270f1$var$LogOutIcon.displayName = "LogOutIcon";
var $dfd33cee3229493c$var$$46616a4c77b270f1$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$46616a4c77b270f1$var$LogOutIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``mail.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$cb74b0bb711ee681$var$MailIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.06903 2.25H12.931C13.5347 2.24999 14.033 2.24998 14.4389 2.28315C14.8604 2.31759 15.248 2.39151 15.612 2.57698C16.1765 2.8646 16.6354 3.32354 16.923 3.88803C17.102 4.23929 17.1771 4.61245 17.2131 5.01698C17.2532 5.13953 17.2602 5.26879 17.2364 5.3922C17.25 5.72979 17.25 6.12027 17.25 6.56901V11.431C17.25 12.0347 17.25 12.533 17.2169 12.9389C17.1824 13.3604 17.1085 13.748 16.923 14.112C16.6354 14.6765 16.1765 15.1354 15.612 15.423C15.248 15.6085 14.8604 15.6824 14.4389 15.7169C14.033 15.75 13.5347 15.75 12.931 15.75H5.06901C4.46529 15.75 3.96702 15.75 3.56113 15.7169C3.13956 15.6824 2.75203 15.6085 2.38803 15.423C1.82354 15.1354 1.3646 14.6765 1.07698 14.112C0.891512 13.748 0.817589 13.3604 0.783145 12.9389C0.749982 12.533 0.74999 12.0347 0.749999 11.431V6.56903C0.749992 6.12028 0.749986 5.72979 0.763602 5.3922C0.739785 5.26879 0.746815 5.13952 0.786911 5.01697C0.822902 4.61245 0.898006 4.23929 1.07698 3.88803C1.3646 3.32354 1.82354 2.8646 2.38803 2.57698C2.75203 2.39151 3.13956 2.31759 3.56113 2.28315C3.96703 2.24998 4.4653 2.24999 5.06903 2.25ZM2.25 6.69049V11.4C2.25 12.0424 2.25058 12.4792 2.27816 12.8167C2.30503 13.1455 2.35372 13.3137 2.41349 13.431C2.5573 13.7132 2.78677 13.9427 3.06901 14.0865C3.18631 14.1463 3.35447 14.195 3.68328 14.2218C4.02085 14.2494 4.45757 14.25 5.1 14.25H12.9C13.5424 14.25 13.9792 14.2494 14.3167 14.2218C14.6455 14.195 14.8137 14.1463 14.931 14.0865C15.2132 13.9427 15.4427 13.7132 15.5865 13.431C15.6463 13.3137 15.695 13.1455 15.7218 12.8167C15.7494 12.4792 15.75 12.0424 15.75 11.4V6.69049L10.8064 10.151C10.7773 10.1714 10.7485 10.1916 10.7199 10.2117C10.3114 10.4985 9.95272 10.7504 9.5442 10.8522C9.18687 10.9413 8.81313 10.9413 8.4558 10.8522C8.04728 10.7504 7.68859 10.4985 7.2801 10.2117C7.25152 10.1916 7.2227 10.1714 7.19359 10.151L2.25 6.69049ZM15.6879 4.90296L9.94621 8.92216C9.39951 9.30485 9.28368 9.37125 9.1814 9.39675C9.06229 9.42644 8.93771 9.42644 8.8186 9.39675C8.71632 9.37125 8.60049 9.30485 8.05379 8.92216L2.31208 4.90296C2.33887 4.74759 2.37373 4.64705 2.41349 4.56902C2.5573 4.28677 2.78677 4.0573 3.06901 3.91349C3.18631 3.85372 3.35447 3.80503 3.68328 3.77816C4.02085 3.75058 4.45757 3.75 5.1 3.75H12.9C13.5424 3.75 13.9792 3.75058 14.3167 3.77816C14.6455 3.80503 14.8137 3.85372 14.931 3.91349C15.2132 4.0573 15.4427 4.28677 15.5865 4.56902C15.6263 4.64705 15.6611 4.74759 15.6879 4.90296Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$cb74b0bb711ee681$var$MailIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cb74b0bb711ee681$var$MailIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$cb74b0bb711ee681$var$MailIcon.displayName = "MailIcon";
var $dfd33cee3229493c$var$$cb74b0bb711ee681$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cb74b0bb711ee681$var$MailIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``maximize.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$c2a9407f37216f91$var$MaximizeIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M11.25 3C10.8358 3 10.5 2.66421 10.5 2.25C10.5 1.83579 10.8358 1.5 11.25 1.5H15.75C16.1642 1.5 16.5 1.83579 16.5 2.25V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5C15.3358 7.5 15 7.16421 15 6.75V4.06066L11.0303 8.03033C10.7374 8.32322 10.2626 8.32322 9.96967 8.03033C9.67678 7.73744 9.67678 7.26256 9.96967 6.96967L13.9393 3H11.25ZM8.03033 9.96967C8.32322 10.2626 8.32322 10.7374 8.03033 11.0303L4.06066 15H6.75C7.16421 15 7.5 15.3358 7.5 15.75C7.5 16.1642 7.16421 16.5 6.75 16.5H2.25C2.05109 16.5 1.86032 16.421 1.71967 16.2803C1.57902 16.1397 1.5 15.9489 1.5 15.75L1.5 11.25C1.5 10.8358 1.83579 10.5 2.25 10.5C2.66421 10.5 3 10.8358 3 11.25L3 13.9393L6.96967 9.96967C7.26256 9.67678 7.73744 9.67678 8.03033 9.96967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$c2a9407f37216f91$var$MaximizeIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$c2a9407f37216f91$var$MaximizeIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$c2a9407f37216f91$var$MaximizeIcon.displayName = "MaximizeIcon";
var $dfd33cee3229493c$var$$c2a9407f37216f91$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c2a9407f37216f91$var$MaximizeIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``medal-first.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$65fb8bc58d7e50c2$var$MedalFirstIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "",
                d: "M8.19333 15.3333C6.91333 15.3333 5.63333 14.8467 4.66 13.8733C2.9 12.1133 2.72667 9.35334 4.15334 7.4L1.83334 3.24667C1.48667 2.62 1.29334 2.27334 1.34 1.84667C1.38667 1.47334 1.58 1.14 1.88667 0.920004C2.23334 0.66667 2.63334 0.66667 3.34667 0.66667H4.83333C5.1 0.66667 5.27333 0.66667 5.47333 0.733337C5.65334 0.793337 5.81333 0.880004 5.95333 1.00667C6.10667 1.14667 6.2 1.29334 6.33333 1.52667L8.2 4.69334L10.06 1.52C10.1933 1.29334 10.28 1.14 10.44 1C10.5733 0.880004 10.74 0.78667 10.9133 0.72667C11.1133 0.660004 11.2867 0.660004 11.5533 0.660004H13.0467C13.7667 0.660004 14.16 0.660004 14.5067 0.913337C14.8133 1.13334 15.0067 1.47334 15.0533 1.84C15.1 2.26667 14.9133 2.61334 14.56 3.24L12.24 7.38667C13.66 9.34 13.4933 12.1 11.7333 13.86C10.76 14.8333 9.48 15.32 8.2 15.32L8.19333 15.3333ZM5.44 7.91334C4.17334 9.35334 4.22667 11.5533 5.6 12.9267C7.02667 14.3533 9.35333 14.3533 10.7867 12.9267C12.16 11.5533 12.2133 9.35334 10.9467 7.91334C10.9467 7.90667 10.9333 7.9 10.9267 7.89334C10.88 7.84 10.8333 7.79334 10.7867 7.74C9.35333 6.31334 7.03334 6.31334 5.6 7.74C5.55334 7.78667 5.50667 7.84 5.46 7.89334C5.46 7.9 5.44667 7.90667 5.44 7.91334ZM9.28667 5.45334C9.99333 5.61334 10.6733 5.92 11.2667 6.38667L13.3867 2.59334C13.5133 2.37334 13.64 2.14 13.6933 2.01334C13.5533 2 13.2933 2 13.0333 2H11.54C11.4267 2 11.3533 2 11.2933 2C11.2933 2.02667 11.26 2.09334 11.2 2.18667L9.28 5.44667L9.28667 5.45334ZM2.69334 2.01334C2.74667 2.14 2.87334 2.37334 3 2.59334L5.12 6.38667C5.71334 5.92 6.39333 5.60667 7.1 5.45334L5.18 2.2C5.12 2.1 5.08667 2.03334 5.05333 1.98667C5.02667 1.99334 4.95334 2 4.84 2H3.34667C3.09334 2 2.82667 2 2.68667 2.01334H2.69334ZM9.03333 12.6667H7.36667C7 12.6667 6.7 12.3667 6.7 12C6.7 11.6333 7 11.3333 7.36667 11.3333H7.53334V9.91334C7.23334 10.0867 6.84 10 6.64667 9.70667C6.44 9.4 6.52667 8.98667 6.83333 8.78L7.83333 8.11334C8.04 7.98 8.3 7.96667 8.52 8.08C8.74 8.19334 8.87333 8.42 8.87333 8.66667V11.3333H9.04C9.40667 11.3333 9.70667 11.6333 9.70667 12C9.70667 12.3667 9.40667 12.6667 9.04 12.6667H9.03333Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$65fb8bc58d7e50c2$var$MedalFirstIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$65fb8bc58d7e50c2$var$MedalFirstIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$65fb8bc58d7e50c2$var$MedalFirstIcon.displayName = "MedalFirstIcon";
var $dfd33cee3229493c$var$$65fb8bc58d7e50c2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$65fb8bc58d7e50c2$var$MedalFirstIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``menu.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$33f70316b36518ce$var$MenuIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H15.75C16.1642 3.75 16.5 4.08579 16.5 4.5C16.5 4.91421 16.1642 5.25 15.75 5.25H2.25C1.83579 5.25 1.5 4.91421 1.5 4.5ZM1.5 9C1.5 8.58579 1.83579 8.25 2.25 8.25H15.75C16.1642 8.25 16.5 8.58579 16.5 9C16.5 9.41421 16.1642 9.75 15.75 9.75H2.25C1.83579 9.75 1.5 9.41421 1.5 9ZM1.5 13.5C1.5 13.0858 1.83579 12.75 2.25 12.75H15.75C16.1642 12.75 16.5 13.0858 16.5 13.5C16.5 13.9142 16.1642 14.25 15.75 14.25H2.25C1.83579 14.25 1.5 13.9142 1.5 13.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$33f70316b36518ce$var$MenuIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$33f70316b36518ce$var$MenuIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$33f70316b36518ce$var$MenuIcon.displayName = "MenuIcon";
var $dfd33cee3229493c$var$$33f70316b36518ce$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$33f70316b36518ce$var$MenuIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``minimize.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$7d9e027fd6935370$var$MinimizeIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M15.2197 1.71967C15.5126 1.42678 15.9874 1.42678 16.2803 1.71967C16.5732 2.01256 16.5732 2.48744 16.2803 2.78033L12.3107 6.75H15C15.4142 6.75 15.75 7.08579 15.75 7.5C15.75 7.91421 15.4142 8.25 15 8.25H10.5C10.0858 8.25 9.75 7.91421 9.75 7.5V3C9.75 2.58579 10.0858 2.25 10.5 2.25C10.9142 2.25 11.25 2.58579 11.25 3V5.68934L15.2197 1.71967ZM2.25 10.5C2.25 10.0858 2.58579 9.75 3 9.75H7.5C7.91421 9.75 8.25 10.0858 8.25 10.5V15C8.25 15.4142 7.91421 15.75 7.5 15.75C7.08579 15.75 6.75 15.4142 6.75 15V12.3107L2.78033 16.2803C2.48744 16.5732 2.01256 16.5732 1.71967 16.2803C1.42678 15.9874 1.42678 15.5126 1.71967 15.2197L5.68934 11.25H3C2.58579 11.25 2.25 10.9142 2.25 10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$7d9e027fd6935370$var$MinimizeIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$7d9e027fd6935370$var$MinimizeIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$7d9e027fd6935370$var$MinimizeIcon.displayName = "MinimizeIcon";
var $dfd33cee3229493c$var$$7d9e027fd6935370$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7d9e027fd6935370$var$MinimizeIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``minus-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$fbe87c02bb0be81b$var$MinusCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM5.25 9C5.25 8.58579 5.58579 8.25 6 8.25H12C12.4142 8.25 12.75 8.58579 12.75 9C12.75 9.41421 12.4142 9.75 12 9.75H6C5.58579 9.75 5.25 9.41421 5.25 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$fbe87c02bb0be81b$var$MinusCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$fbe87c02bb0be81b$var$MinusCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$fbe87c02bb0be81b$var$MinusCircleIcon.displayName = "MinusCircleIcon";
var $dfd33cee3229493c$var$$fbe87c02bb0be81b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$fbe87c02bb0be81b$var$MinusCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``minus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$1717380490155c4f$var$MinusIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3 9C3 8.58579 3.33579 8.25 3.75 8.25H14.25C14.6642 8.25 15 8.58579 15 9C15 9.41421 14.6642 9.75 14.25 9.75H3.75C3.33579 9.75 3 9.41421 3 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$1717380490155c4f$var$MinusIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$1717380490155c4f$var$MinusIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$1717380490155c4f$var$MinusIcon.displayName = "MinusIcon";
var $dfd33cee3229493c$var$$1717380490155c4f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$1717380490155c4f$var$MinusIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``moon.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$90e541104d06c64e$var$MoonIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.9983 1.30776C9.10487 1.64477 8.96168 2.01046 8.65459 2.18549C7.0674 3.09015 6 4.79603 6 6.75027C6 9.64977 8.35051 12.0003 11.25 12.0003C13.2041 12.0003 14.9099 10.933 15.8146 9.34605C15.9896 9.03898 16.3553 8.89581 16.6923 9.00241C17.0293 9.10902 17.2462 9.43646 17.2128 9.78834C16.8155 13.9753 13.2906 17.2501 9 17.2501C4.44365 17.2501 0.75 13.5564 0.75 9.00009C0.75 4.70926 4.02513 1.18427 8.21241 0.787251C8.5643 0.753886 8.89172 0.970743 8.9983 1.30776ZM5.48632 3.23544C3.54557 4.42104 2.25 6.55948 2.25 9.00009C2.25 12.728 5.27208 15.7501 9 15.7501C11.4404 15.7501 13.5787 14.4547 14.7644 12.5142C13.7409 13.1396 12.5377 13.5003 11.25 13.5003C7.52208 13.5003 4.5 10.4782 4.5 6.75027C4.5 5.46237 4.86079 4.25898 5.48632 3.23544Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$90e541104d06c64e$var$MoonIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$90e541104d06c64e$var$MoonIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$90e541104d06c64e$var$MoonIcon.displayName = "MoonIcon";
var $dfd33cee3229493c$var$$90e541104d06c64e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$90e541104d06c64e$var$MoonIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``msg-chat-circles.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$3f5ab6f404c2853c$var$MsgChatCirclesIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.74997 7.5C3.74997 3.76745 6.79437 0.75 10.5394 0.75C14.2845 0.75 17.3289 3.76745 17.3289 7.5C17.3289 8.34139 17.1737 9.14843 16.8896 9.89319C16.8622 9.9651 16.8462 10.0071 16.8352 10.0381C16.8338 10.0421 16.8326 10.0456 16.8316 10.0485C16.8317 10.0495 16.8318 10.0506 16.8319 10.0518C16.8342 10.0765 16.8383 10.1103 16.8463 10.1746L17.1508 12.6481C17.1649 12.7622 17.1808 12.8917 17.1846 13.0043C17.1888 13.129 17.1836 13.3226 17.0907 13.5257C16.9746 13.7794 16.7684 13.9809 16.5121 14.0911C16.3069 14.1794 16.1132 14.1801 15.9886 14.1731C15.8761 14.1666 15.747 14.1477 15.6333 14.131C15.6263 14.13 15.6194 14.1289 15.6125 14.1279L13.2236 13.7778C13.1572 13.768 13.1223 13.763 13.0968 13.76C13.0956 13.7598 13.0944 13.7597 13.0934 13.7596C13.0904 13.7606 13.0869 13.7618 13.0828 13.7632C13.0507 13.7743 13.0072 13.7906 12.9328 13.8184C12.1874 14.0976 11.3804 14.25 10.5394 14.25C10.4048 14.25 10.2709 14.2461 10.1381 14.2384C9.42329 15.9999 7.72507 17.25 5.72368 17.25C5.17795 17.25 4.65222 17.1563 4.16209 16.9833C4.08109 16.9547 4.03084 16.937 3.99398 16.9248C3.9873 16.9226 3.98182 16.9208 3.97744 16.9194C3.97618 16.9196 3.97483 16.9197 3.97337 16.9199C3.94764 16.9227 3.91258 16.9275 3.84759 16.9363L1.60149 17.2431C1.35844 17.2763 1.11453 17.1885 0.948346 17.0081C0.782161 16.8277 0.714709 16.5774 0.767726 16.3379L1.22623 14.2666C1.24217 14.1947 1.25069 14.1558 1.25617 14.1273C1.25648 14.1256 1.25676 14.1241 1.25702 14.1227C1.25566 14.118 1.25393 14.1121 1.25178 14.105C1.23943 14.0641 1.22126 14.0083 1.19174 13.9179C1.03297 13.4319 0.947368 12.9129 0.947368 12.375C0.947368 10.4054 2.09728 8.69353 3.76339 7.92748C3.75449 7.78605 3.74997 7.64351 3.74997 7.5ZM5.25002 7.52357C5.40574 7.50798 5.56375 7.5 5.72368 7.5C8.37858 7.5 10.5 9.69983 10.5 12.375C10.5 12.501 10.4953 12.626 10.486 12.7497C10.5038 12.7499 10.5216 12.75 10.5394 12.75C11.1982 12.75 11.8271 12.6308 12.4067 12.4137C12.4172 12.4098 12.4279 12.4058 12.4388 12.4017C12.5448 12.3618 12.6698 12.3147 12.7841 12.2907C12.8884 12.2687 12.9776 12.2592 13.0842 12.2586C13.2005 12.2579 13.3189 12.2755 13.4144 12.2897C13.4235 12.291 13.4324 12.2923 13.4411 12.2936L15.6354 12.6153L15.3575 10.3579C15.3565 10.3495 15.3554 10.3408 15.3543 10.332C15.3427 10.2394 15.3284 10.1247 15.3311 10.0124C15.3335 9.90931 15.3439 9.82348 15.3663 9.72284C15.3907 9.61274 15.437 9.49203 15.4762 9.38968C15.4803 9.3791 15.4842 9.36872 15.4881 9.35856C15.7082 8.78175 15.8289 8.15571 15.8289 7.5C15.8289 4.60513 13.4654 2.25 10.5394 2.25C7.6135 2.25 5.24997 4.60513 5.24997 7.5C5.24997 7.50786 5.24999 7.51572 5.25002 7.52357ZM8.89561 13.225C8.96371 12.9539 9 12.6692 9 12.375C9 10.4938 7.51613 9 5.72368 9C3.93124 9 2.44737 10.4938 2.44737 12.375C2.44737 12.753 2.50744 13.115 2.61758 13.4522C2.62196 13.4655 2.62643 13.4792 2.63098 13.493C2.67316 13.6213 2.72097 13.7668 2.74017 13.8892C2.75819 14.004 2.76252 14.0923 2.75581 14.2083C2.74869 14.3315 2.7204 14.4581 2.69734 14.5614C2.69509 14.5714 2.6929 14.5813 2.69078 14.5908L2.46489 15.6113L3.64461 15.4501C3.65326 15.449 3.66213 15.4477 3.67119 15.4465C3.76448 15.4336 3.87888 15.4178 3.98861 15.4185C4.0925 15.4192 4.16982 15.4271 4.27172 15.4474C4.3798 15.469 4.50945 15.515 4.6245 15.5558C4.63696 15.5602 4.64924 15.5645 4.66131 15.5688C4.99367 15.6861 5.35071 15.75 5.72368 15.75C7.22337 15.75 8.50705 14.7043 8.88637 13.2609C8.88917 13.2488 8.89225 13.2368 8.89561 13.225Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$3f5ab6f404c2853c$var$MsgChatCirclesIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$3f5ab6f404c2853c$var$MsgChatCirclesIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$3f5ab6f404c2853c$var$MsgChatCirclesIcon.displayName = "MsgChatCirclesIcon";
var $dfd33cee3229493c$var$$3f5ab6f404c2853c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3f5ab6f404c2853c$var$MsgChatCirclesIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``msg-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$7964eb7702f2ba10$var$MsgCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C8.00376 16.5 7.05112 16.3054 6.17941 15.9513C6.10067 15.9194 6.05521 15.901 6.02165 15.8884C6.01768 15.8869 6.01423 15.8856 6.01128 15.8845C6.01017 15.8847 6.00899 15.8848 6.00772 15.885C5.98004 15.8888 5.94232 15.895 5.87029 15.907L3.20187 16.3517C3.19475 16.3529 3.18756 16.3541 3.18033 16.3553C3.05986 16.3754 2.92508 16.3979 2.80803 16.4068C2.68039 16.4164 2.47734 16.4197 2.26275 16.3277C1.99747 16.2139 1.78608 16.0025 1.6723 15.7372C1.58026 15.5227 1.58361 15.3196 1.59325 15.192C1.60208 15.0749 1.62459 14.9401 1.64471 14.8197C1.64591 14.8124 1.64711 14.8053 1.6483 14.7981L2.09304 12.1297C2.10504 12.0577 2.11125 12.02 2.115 11.9923C2.11517 11.991 2.11533 11.9898 2.11547 11.9887C2.1144 11.9858 2.11313 11.9823 2.11164 11.9784C2.09904 11.9448 2.08064 11.8993 2.04867 11.8206C1.69464 10.9489 1.5 9.99624 1.5 9ZM9 3C5.68629 3 3 5.68629 3 9C3 9.79948 3.15596 10.5607 3.43843 11.2562C3.44289 11.2672 3.44749 11.2784 3.45217 11.2899C3.49797 11.402 3.55243 11.5354 3.58034 11.6599C3.60569 11.773 3.61664 11.8719 3.61666 11.9878C3.61667 12.115 3.59498 12.2436 3.57749 12.3474C3.57582 12.3573 3.57419 12.3669 3.57263 12.3763L3.16241 14.8376L5.62369 14.4274C5.63309 14.4258 5.64274 14.4242 5.65261 14.4225C5.75637 14.405 5.88498 14.3833 6.0122 14.3833C6.12811 14.3834 6.22697 14.3943 6.34008 14.4197C6.4646 14.4476 6.59796 14.502 6.71011 14.5478C6.72158 14.5525 6.73283 14.5571 6.74383 14.5616C7.43933 14.844 8.20052 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$7964eb7702f2ba10$var$MsgCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$7964eb7702f2ba10$var$MsgCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$7964eb7702f2ba10$var$MsgCircleIcon.displayName = "MsgCircleIcon";
var $dfd33cee3229493c$var$$7964eb7702f2ba10$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7964eb7702f2ba10$var$MsgCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``msg-dots-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$55ff7b0afa02b54a$var$MsgDotsCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C8.00376 16.5 7.05112 16.3054 6.17941 15.9513C6.10067 15.9194 6.05521 15.901 6.02165 15.8884C6.01768 15.8869 6.01423 15.8856 6.01128 15.8845C6.01017 15.8847 6.00899 15.8848 6.00772 15.885C5.98004 15.8888 5.94232 15.895 5.87029 15.907L3.20187 16.3517C3.19475 16.3529 3.18756 16.3541 3.18033 16.3553C3.05986 16.3754 2.92508 16.3979 2.80803 16.4068C2.68039 16.4164 2.47734 16.4197 2.26275 16.3277C1.99747 16.2139 1.78608 16.0025 1.6723 15.7372C1.58026 15.5227 1.58361 15.3196 1.59325 15.192C1.60208 15.0749 1.62459 14.9401 1.64471 14.8197C1.64591 14.8124 1.64711 14.8053 1.6483 14.7981L2.09304 12.1297C2.10504 12.0577 2.11125 12.02 2.115 11.9923C2.11517 11.991 2.11533 11.9898 2.11547 11.9887C2.1144 11.9858 2.11313 11.9823 2.11164 11.9784C2.09904 11.9448 2.08064 11.8993 2.04867 11.8206C1.69464 10.9489 1.5 9.99624 1.5 9ZM9 3C5.68629 3 3 5.68629 3 9C3 9.79948 3.15596 10.5607 3.43843 11.2562C3.44289 11.2672 3.44749 11.2784 3.45217 11.2899C3.49797 11.402 3.55243 11.5354 3.58034 11.6599C3.60569 11.773 3.61664 11.8719 3.61666 11.9878C3.61667 12.115 3.59498 12.2436 3.57749 12.3474C3.57582 12.3573 3.57419 12.3669 3.57263 12.3763L3.16241 14.8376L5.62369 14.4274C5.63309 14.4258 5.64274 14.4242 5.65261 14.4225C5.75637 14.405 5.88498 14.3833 6.0122 14.3833C6.12811 14.3834 6.22697 14.3943 6.34008 14.4197C6.4646 14.4476 6.59796 14.502 6.71011 14.5478C6.72158 14.5525 6.73283 14.5571 6.74383 14.5616C7.43933 14.844 8.20052 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3ZM4.5 9C4.5 8.37868 5.00368 7.875 5.625 7.875C6.24632 7.875 6.75 8.37868 6.75 9C6.75 9.62132 6.24632 10.125 5.625 10.125C5.00368 10.125 4.5 9.62132 4.5 9ZM7.875 9C7.875 8.37868 8.37868 7.875 9 7.875C9.62132 7.875 10.125 8.37868 10.125 9C10.125 9.62132 9.62132 10.125 9 10.125C8.37868 10.125 7.875 9.62132 7.875 9ZM11.25 9C11.25 8.37868 11.7537 7.875 12.375 7.875C12.9963 7.875 13.5 8.37868 13.5 9C13.5 9.62132 12.9963 10.125 12.375 10.125C11.7537 10.125 11.25 9.62132 11.25 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$55ff7b0afa02b54a$var$MsgDotsCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$55ff7b0afa02b54a$var$MsgDotsCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$55ff7b0afa02b54a$var$MsgDotsCircleIcon.displayName = "MsgDotsCircleIcon";
var $dfd33cee3229493c$var$$55ff7b0afa02b54a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$55ff7b0afa02b54a$var$MsgDotsCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``msg-dots-square.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$de02b3469de91eed$var$MsgDotsSquareIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81904 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1105 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V9.93099C16.5 10.5347 16.5 11.033 16.4669 11.4389C16.4324 11.8604 16.3585 12.248 16.173 12.612C15.8854 13.1765 15.4265 13.6354 14.862 13.923C14.498 14.1085 14.1105 14.1824 13.6889 14.2169C13.283 14.25 12.7847 14.25 12.181 14.25H10.2628C9.76474 14.25 9.61969 14.2535 9.4877 14.2806C9.35531 14.3078 9.2272 14.3527 9.10684 14.4142C8.98685 14.4755 8.87138 14.5634 8.48244 14.8745L6.6726 16.3224C6.53484 16.4327 6.39442 16.545 6.27096 16.6267C6.15289 16.7047 5.92396 16.8444 5.62623 16.8448C5.28362 16.8451 4.95951 16.6894 4.74578 16.4216C4.56003 16.1889 4.52613 15.9229 4.51333 15.7819C4.49994 15.6345 4.49997 15.4547 4.50001 15.2782L4.50001 14.2438C4.20615 14.2341 3.95415 14.2096 3.72355 14.1478C2.68828 13.8704 1.87964 13.0617 1.60223 12.0265C1.49941 11.6427 1.49965 11.1997 1.49997 10.6032C1.49999 10.5693 1.50001 10.5349 1.50001 10.5L1.50001 5.81903C1.5 5.2153 1.49999 4.71703 1.53316 4.31113C1.5676 3.88956 1.64152 3.50203 1.82699 3.13803C2.11461 2.57354 2.57355 2.1146 3.13804 1.82698C3.50204 1.64151 3.88957 1.56759 4.31114 1.53315C4.71704 1.49998 5.21531 1.49999 5.81904 1.5ZM4.43329 3.02816C4.10448 3.05503 3.93633 3.10372 3.81903 3.16349C3.53678 3.3073 3.30731 3.53677 3.1635 3.81902C3.10373 3.93631 3.05504 4.10447 3.02817 4.43328C3.00059 4.77085 3.00001 5.20757 3.00001 5.85V10.5C3.00001 11.2458 3.00645 11.4715 3.05112 11.6382C3.18982 12.1559 3.59414 12.5602 4.11178 12.6989C4.27849 12.7436 4.50425 12.75 5.25001 12.75C5.66422 12.75 6.00001 13.0858 6.00001 13.5V14.9395L7.5454 13.7032C7.56245 13.6896 7.57928 13.6761 7.59589 13.6628C7.91244 13.4094 8.15173 13.2178 8.42441 13.0785C8.66512 12.9555 8.92135 12.8656 9.18614 12.8113C9.48609 12.7497 9.79264 12.7498 10.1982 12.75C10.2194 12.75 10.241 12.75 10.2628 12.75H12.15C12.7924 12.75 13.2292 12.7494 13.5667 12.7218C13.8955 12.695 14.0637 12.6463 14.181 12.5865C14.4632 12.4427 14.6927 12.2132 14.8365 11.931C14.8963 11.8137 14.945 11.6455 14.9718 11.3167C14.9994 10.9792 15 10.5424 15 9.9V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H5.85001C5.20758 3 4.77086 3.00058 4.43329 3.02816ZM4.50001 7.875C4.50001 7.25368 5.00369 6.75 5.62501 6.75C6.24633 6.75 6.75001 7.25368 6.75001 7.875C6.75001 8.49632 6.24633 9 5.62501 9C5.00369 9 4.50001 8.49632 4.50001 7.875ZM7.87501 7.875C7.87501 7.25368 8.37869 6.75 9.00001 6.75C9.62133 6.75 10.125 7.25368 10.125 7.875C10.125 8.49632 9.62133 9 9.00001 9C8.37869 9 7.87501 8.49632 7.87501 7.875ZM11.25 7.875C11.25 7.25368 11.7537 6.75 12.375 6.75C12.9963 6.75 13.5 7.25368 13.5 7.875C13.5 8.49632 12.9963 9 12.375 9C11.7537 9 11.25 8.49632 11.25 7.875Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$de02b3469de91eed$var$MsgDotsSquareIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$de02b3469de91eed$var$MsgDotsSquareIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$de02b3469de91eed$var$MsgDotsSquareIcon.displayName = "MsgDotsSquareIcon";
var $dfd33cee3229493c$var$$de02b3469de91eed$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$de02b3469de91eed$var$MsgDotsSquareIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``msg-plus-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a2f437797616eed8$var$MsgPlusCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M2.24973 8.625C2.24973 4.68997 5.4397 1.5 9.37473 1.5C13.3098 1.5 16.4997 4.68997 16.4997 8.625C16.4997 12.56 13.3098 15.75 9.37473 15.75C8.47351 15.75 7.60968 15.5823 6.81397 15.2758C6.74576 15.2495 6.70624 15.2343 6.6771 15.2238C6.67354 15.2225 6.67045 15.2215 6.66783 15.2205C6.66688 15.2206 6.66586 15.2207 6.66477 15.2208C6.64106 15.2226 6.60869 15.2259 6.54677 15.2323L2.706 15.6293C2.69756 15.6302 2.68908 15.6311 2.68059 15.6319C2.51995 15.6486 2.35237 15.6659 2.2122 15.6676C2.07289 15.6692 1.8218 15.6613 1.58104 15.5145C1.29883 15.3423 1.10662 15.0548 1.05545 14.7282C1.0118 14.4496 1.10051 14.2145 1.15528 14.0864C1.21039 13.9575 1.2905 13.8093 1.36729 13.6673L2.60619 11.3741C2.65979 11.2749 2.68844 11.2215 2.70771 11.1818C2.70873 11.1797 2.70966 11.1777 2.71053 11.1759C2.70908 11.1707 2.70733 11.1646 2.70521 11.1574C2.68897 11.1025 2.66399 11.0279 2.62154 10.902C2.38022 10.1861 2.24973 9.42 2.24973 8.625ZM9.37473 3C6.26813 3 3.74973 5.5184 3.74973 8.625C3.74973 9.25499 3.85301 9.85933 4.04297 10.4229C4.04901 10.4408 4.05523 10.4591 4.06157 10.4777C4.12243 10.6566 4.19392 10.8668 4.20896 11.0569C4.22268 11.2302 4.21018 11.3767 4.1673 11.5452C4.12041 11.7295 4.02511 11.9046 3.94781 12.0467C3.94032 12.0605 3.933 12.074 3.92591 12.0871L2.83406 14.1081L6.39254 13.7402C6.40061 13.7394 6.4089 13.7385 6.41737 13.7376C6.50663 13.7283 6.61723 13.7167 6.72578 13.7208C6.825 13.7246 6.9086 13.7357 7.00534 13.758C7.11154 13.7825 7.22675 13.8271 7.32392 13.8647C7.33389 13.8686 7.34366 13.8724 7.35322 13.876C7.97959 14.1174 8.66079 14.25 9.37473 14.25C12.4813 14.25 14.9997 11.7316 14.9997 8.625C14.9997 5.5184 12.4813 3 9.37473 3ZM9.37473 5.625C9.78894 5.625 10.1247 5.96079 10.1247 6.375V7.875H11.6247C12.0389 7.875 12.3747 8.21079 12.3747 8.625C12.3747 9.03921 12.0389 9.375 11.6247 9.375H10.1247V10.875C10.1247 11.2892 9.78894 11.625 9.37473 11.625C8.96052 11.625 8.62473 11.2892 8.62473 10.875V9.375H7.12473C6.71052 9.375 6.37473 9.03921 6.37473 8.625C6.37473 8.21079 6.71052 7.875 7.12473 7.875H8.62473V6.375C8.62473 5.96079 8.96052 5.625 9.37473 5.625Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a2f437797616eed8$var$MsgPlusCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a2f437797616eed8$var$MsgPlusCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a2f437797616eed8$var$MsgPlusCircleIcon.displayName = "MsgPlusCircleIcon";
var $dfd33cee3229493c$var$$a2f437797616eed8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a2f437797616eed8$var$MsgPlusCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``notification-msg.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0acd9437c449e160$var$NotificationMsgIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M14.5607 3.43934C13.9749 2.85355 13.0251 2.85355 12.4393 3.43934C11.8536 4.02513 11.8536 4.97487 12.4393 5.56066C13.0251 6.14645 13.9749 6.14645 14.5607 5.56066C15.1464 4.97487 15.1464 4.02513 14.5607 3.43934ZM11.3787 2.37868C12.5503 1.20711 14.4497 1.20711 15.6213 2.37868C16.7929 3.55025 16.7929 5.44975 15.6213 6.62132C14.4497 7.79289 12.5503 7.79289 11.3787 6.62132C10.2071 5.44975 10.2071 3.55025 11.3787 2.37868ZM5.81903 2.25H8.25C8.66421 2.25 9 2.58579 9 3C9 3.41421 8.66421 3.75 8.25 3.75H5.85C5.20757 3.75 4.77085 3.75058 4.43328 3.77816C4.10447 3.80503 3.93631 3.85372 3.81902 3.91349C3.53677 4.0573 3.3073 4.28677 3.16349 4.56901C3.10372 4.68631 3.05503 4.85447 3.02816 5.18328C3.00058 5.52085 3 5.95756 3 6.6V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H11.4C12.0424 15 12.4792 14.9994 12.8167 14.9718C13.1455 14.945 13.3137 14.8963 13.431 14.8365C13.7132 14.6927 13.9427 14.4632 14.0865 14.181C14.1463 14.0637 14.195 13.8955 14.2218 13.5667C14.2494 13.2292 14.25 12.7924 14.25 12.15V9.75C14.25 9.33579 14.5858 9 15 9C15.4142 9 15.75 9.33579 15.75 9.75V12.181C15.75 12.7847 15.75 13.283 15.7169 13.6889C15.6824 14.1104 15.6085 14.498 15.423 14.862C15.1354 15.4265 14.6765 15.8854 14.112 16.173C13.748 16.3585 13.3604 16.4324 12.9389 16.4669C12.533 16.5 12.0347 16.5 11.431 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V6.56903C1.49999 5.9653 1.49998 5.46703 1.53315 5.06113C1.56759 4.63956 1.64151 4.25203 1.82698 3.88803C2.1146 3.32354 2.57354 2.8646 3.13803 2.57698C3.50203 2.39151 3.88956 2.31759 4.31113 2.28315C4.71703 2.24998 5.2153 2.24999 5.81903 2.25ZM4.5 9.75C4.5 9.33579 4.83579 9 5.25 9H11.25C11.6642 9 12 9.33579 12 9.75C12 10.1642 11.6642 10.5 11.25 10.5H5.25C4.83579 10.5 4.5 10.1642 4.5 9.75ZM4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H9.75C10.1642 12 10.5 12.3358 10.5 12.75C10.5 13.1642 10.1642 13.5 9.75 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0acd9437c449e160$var$NotificationMsgIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0acd9437c449e160$var$NotificationMsgIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0acd9437c449e160$var$NotificationMsgIcon.displayName = "NotificationMsgIcon";
var $dfd33cee3229493c$var$$0acd9437c449e160$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0acd9437c449e160$var$NotificationMsgIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``paperclip.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e1860d04a60482a5$var$PaperclipIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M13.4779 3.13649C12.7457 2.40425 11.5585 2.40425 10.8262 3.13649L4.06454 9.89819C2.81974 11.143 2.81974 13.1612 4.06454 14.406C5.30933 15.6508 7.32755 15.6508 8.57234 14.406L15.3341 7.64429C15.6269 7.3514 16.1018 7.3514 16.3947 7.64429C16.6876 7.93718 16.6876 8.41206 16.3947 8.70495L9.633 15.4667C7.80242 17.2972 4.83446 17.2972 3.00388 15.4667C1.17329 13.6361 1.17329 10.6681 3.00388 8.83753L9.76558 2.07583C11.0836 0.757806 13.2205 0.757806 14.5386 2.07583C15.8566 3.39384 15.8566 5.53078 14.5386 6.8488L8.04201 13.3453C7.23656 14.1508 5.93065 14.1508 5.1252 13.3453C4.31974 12.5399 4.31974 11.234 5.1252 10.4285L10.8262 4.72748C11.1191 4.43458 11.594 4.43458 11.8869 4.72748C12.1798 5.02037 12.1798 5.49524 11.8869 5.78814L6.18586 11.4892C5.96619 11.7089 5.96619 12.065 6.18586 12.2847C6.40553 12.5043 6.76168 12.5043 6.98135 12.2847L13.4779 5.78814C14.2101 5.0559 14.2101 3.86872 13.4779 3.13649Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e1860d04a60482a5$var$PaperclipIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e1860d04a60482a5$var$PaperclipIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e1860d04a60482a5$var$PaperclipIcon.displayName = "PaperclipIcon";
var $dfd33cee3229493c$var$$e1860d04a60482a5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e1860d04a60482a5$var$PaperclipIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``password-lock.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$c745bc4c74d1f069$var$PasswordLockIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.87109 3H14.1289C14.5243 2.99999 14.8653 2.99998 15.1463 3.02293C15.4428 3.04715 15.7377 3.10064 16.0215 3.24524C16.4448 3.46095 16.7891 3.80516 17.0048 4.22852C17.1494 4.51231 17.2028 4.80722 17.2271 5.10373C17.25 5.38466 17.25 5.72572 17.25 6.12108V8.25C17.25 8.66422 16.9142 9 16.5 9C16.0858 9 15.75 8.66422 15.75 8.25V6.15C15.75 5.71759 15.7494 5.43838 15.7321 5.22588C15.7154 5.02213 15.6872 4.94659 15.6683 4.90951C15.5964 4.76839 15.4816 4.65365 15.3405 4.58175C15.3034 4.56285 15.2279 4.53459 15.0241 4.51795C14.8116 4.50058 14.5324 4.5 14.1 4.5H3.9C3.46759 4.5 3.18838 4.50058 2.97588 4.51795C2.77213 4.53459 2.69659 4.56285 2.65951 4.58175C2.51839 4.65365 2.40365 4.76839 2.33175 4.90951C2.31285 4.94659 2.28459 5.02213 2.26795 5.22588C2.25058 5.43838 2.25 5.71759 2.25 6.15V8.85C2.25 9.28242 2.25058 9.56162 2.26795 9.77413C2.28459 9.97787 2.31285 10.0534 2.33175 10.0905C2.40365 10.2316 2.51839 10.3464 2.65951 10.4183C2.69659 10.4372 2.77213 10.4654 2.97588 10.4821C3.18838 10.4994 3.46759 10.5 3.9 10.5H8.25C8.66422 10.5 9 10.8358 9 11.25C9 11.6642 8.66422 12 8.25 12H3.87111C3.47574 12 3.13466 12 2.85373 11.9771C2.55722 11.9528 2.26231 11.8994 1.97852 11.7548C1.55516 11.5391 1.21095 11.1948 0.995237 10.7715C0.850641 10.4877 0.797154 10.1928 0.772928 9.89627C0.749976 9.61534 0.749987 9.27427 0.750001 8.87891V6.12109C0.749987 5.72573 0.749976 5.38466 0.772928 5.10373C0.797154 4.80722 0.850641 4.51231 0.995237 4.22852C1.21095 3.80516 1.55516 3.46095 1.97852 3.24524C2.26231 3.10064 2.55722 3.04715 2.85373 3.02293C3.13466 2.99998 3.47573 2.99999 3.87109 3ZM4.3125 7.5C4.3125 6.98223 4.73223 6.5625 5.25 6.5625C5.76777 6.5625 6.1875 6.98223 6.1875 7.5C6.1875 8.01777 5.76777 8.4375 5.25 8.4375C4.73223 8.4375 4.3125 8.01777 4.3125 7.5ZM8.0625 7.5C8.0625 6.98223 8.48223 6.5625 9 6.5625C9.51777 6.5625 9.9375 6.98223 9.9375 7.5C9.9375 8.01777 9.51777 8.4375 9 8.4375C8.48223 8.4375 8.0625 8.01777 8.0625 7.5ZM11.8125 7.5C11.8125 6.98223 12.2322 6.5625 12.75 6.5625C13.2678 6.5625 13.6875 6.98223 13.6875 7.5C13.6875 8.01777 13.2678 8.4375 12.75 8.4375C12.2322 8.4375 11.8125 8.01777 11.8125 7.5ZM11.0625 11.4375C11.0625 10.2984 11.9859 9.375 13.125 9.375C14.2641 9.375 15.1875 10.2984 15.1875 11.4375V12.021C15.3394 12.039 15.5097 12.0762 15.681 12.1635C15.9632 12.3073 16.1927 12.5368 16.3365 12.819C16.4402 13.0226 16.4733 13.2249 16.4873 13.3963C16.5 13.5524 16.5 13.7368 16.5 13.9261V14.5739C16.5 14.7632 16.5 14.9476 16.4873 15.1037C16.4733 15.2751 16.4402 15.4774 16.3365 15.681C16.1927 15.9632 15.9632 16.1927 15.681 16.3365C15.4774 16.4402 15.2751 16.4733 15.1037 16.4873C14.9476 16.5 14.7632 16.5 14.5739 16.5H11.6761C11.4868 16.5 11.3024 16.5 11.1463 16.4873C10.9749 16.4733 10.7726 16.4402 10.569 16.3365C10.2868 16.1927 10.0573 15.9632 9.91349 15.681C9.80977 15.4774 9.77672 15.2751 9.76271 15.1037C9.74996 14.9475 9.74998 14.7632 9.75 14.5739V13.9261C9.74998 13.7368 9.74996 13.5525 9.76271 13.3963C9.77672 13.2249 9.80977 13.0226 9.91349 12.819C10.0573 12.5368 10.2868 12.3073 10.569 12.1635C10.7403 12.0762 10.9107 12.039 11.0625 12.021V11.4375ZM11.7 13.5C11.4776 13.5 11.3559 13.5006 11.2685 13.5077C11.265 13.508 11.2617 13.5083 11.2586 13.5086C11.2583 13.5117 11.258 13.515 11.2577 13.5185C11.2506 13.6059 11.25 13.7276 11.25 13.95V14.55C11.25 14.7724 11.2506 14.8941 11.2577 14.9815C11.258 14.985 11.2583 14.9883 11.2586 14.9914C11.2617 14.9917 11.265 14.992 11.2685 14.9923C11.3559 14.9994 11.4776 15 11.7 15H14.55C14.7724 15 14.8941 14.9994 14.9815 14.9923C14.985 14.992 14.9883 14.9917 14.9914 14.9914C14.9917 14.9883 14.992 14.985 14.9923 14.9815C14.9994 14.8941 15 14.7724 15 14.55V13.95C15 13.7276 14.9994 13.6059 14.9923 13.5185C14.992 13.515 14.9917 13.5117 14.9914 13.5086C14.9883 13.5083 14.985 13.508 14.9815 13.5077C14.8941 13.5006 14.7724 13.5 14.55 13.5H11.7ZM13.6875 12H12.5625V11.4375C12.5625 11.1268 12.8143 10.875 13.125 10.875C13.4357 10.875 13.6875 11.1268 13.6875 11.4375V12Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$c745bc4c74d1f069$var$PasswordLockIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$c745bc4c74d1f069$var$PasswordLockIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$c745bc4c74d1f069$var$PasswordLockIcon.displayName = "PasswordLockIcon";
var $dfd33cee3229493c$var$$c745bc4c74d1f069$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c745bc4c74d1f069$var$PasswordLockIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``password.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e8d23bb6e9de7010$var$PasswordIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.87109 4.5H14.1289C14.5243 4.49999 14.8653 4.49998 15.1463 4.52293C15.4428 4.54715 15.7377 4.60064 16.0215 4.74524C16.4448 4.96095 16.7891 5.30516 17.0048 5.72852C17.1494 6.01231 17.2028 6.30722 17.2271 6.60373C17.25 6.88466 17.25 7.22572 17.25 7.62108V10.3789C17.25 10.7743 17.25 11.1153 17.2271 11.3963C17.2028 11.6928 17.1494 11.9877 17.0048 12.2715C16.7891 12.6948 16.4448 13.0391 16.0215 13.2548C15.7377 13.3994 15.4428 13.4528 15.1463 13.4771C14.8653 13.5 14.5243 13.5 14.1289 13.5H3.87111C3.47574 13.5 3.13466 13.5 2.85373 13.4771C2.55722 13.4528 2.26231 13.3994 1.97852 13.2548C1.55516 13.0391 1.21095 12.6948 0.995237 12.2715C0.850641 11.9877 0.797154 11.6928 0.772928 11.3963C0.749976 11.1153 0.749987 10.7743 0.750001 10.3789V7.62109C0.749987 7.22573 0.749976 6.88466 0.772928 6.60373C0.797154 6.30722 0.850641 6.01231 0.995237 5.72852C1.21095 5.30516 1.55516 4.96095 1.97852 4.74524C2.26231 4.60064 2.55722 4.54715 2.85373 4.52293C3.13466 4.49998 3.47573 4.49999 3.87109 4.5ZM2.97588 6.01795C2.77213 6.03459 2.69659 6.06285 2.65951 6.08175C2.51839 6.15365 2.40365 6.26839 2.33175 6.40951C2.31285 6.44659 2.28459 6.52213 2.26795 6.72588C2.25058 6.93838 2.25 7.21759 2.25 7.65V10.35C2.25 10.7824 2.25058 11.0616 2.26795 11.2741C2.28459 11.4779 2.31285 11.5534 2.33175 11.5905C2.40365 11.7316 2.51839 11.8464 2.65951 11.9183C2.69659 11.9372 2.77213 11.9654 2.97588 11.9821C3.18838 11.9994 3.46759 12 3.9 12H14.1C14.5324 12 14.8116 11.9994 15.0241 11.9821C15.2279 11.9654 15.3034 11.9372 15.3405 11.9183C15.4816 11.8464 15.5964 11.7316 15.6683 11.5905C15.6871 11.5534 15.7154 11.4779 15.7321 11.2741C15.7494 11.0616 15.75 10.7824 15.75 10.35V7.65C15.75 7.21759 15.7494 6.93838 15.7321 6.72588C15.7154 6.52213 15.6872 6.44659 15.6683 6.40951C15.5964 6.26839 15.4816 6.15365 15.3405 6.08175C15.3034 6.06285 15.2279 6.03459 15.0241 6.01795C14.8116 6.00058 14.5324 6 14.1 6H3.9C3.46759 6 3.18838 6.00058 2.97588 6.01795ZM4.3125 9C4.3125 8.48223 4.73223 8.0625 5.25 8.0625C5.76777 8.0625 6.1875 8.48223 6.1875 9C6.1875 9.51777 5.76777 9.9375 5.25 9.9375C4.73223 9.9375 4.3125 9.51777 4.3125 9ZM8.0625 9C8.0625 8.48223 8.48223 8.0625 9 8.0625C9.51777 8.0625 9.9375 8.48223 9.9375 9C9.9375 9.51777 9.51777 9.9375 9 9.9375C8.48223 9.9375 8.0625 9.51777 8.0625 9ZM11.8125 9C11.8125 8.48223 12.2322 8.0625 12.75 8.0625C13.2678 8.0625 13.6875 8.48223 13.6875 9C13.6875 9.51777 13.2678 9.9375 12.75 9.9375C12.2322 9.9375 11.8125 9.51777 11.8125 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e8d23bb6e9de7010$var$PasswordIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e8d23bb6e9de7010$var$PasswordIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e8d23bb6e9de7010$var$PasswordIcon.displayName = "PasswordIcon";
var $dfd33cee3229493c$var$$e8d23bb6e9de7010$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e8d23bb6e9de7010$var$PasswordIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``pencil.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$9bb22cf52b7e2cb1$var$PencilIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M12.9697 0.96967C13.2626 0.676777 13.7374 0.676777 14.0303 0.96967L17.0303 3.96967C17.3232 4.26256 17.3232 4.73744 17.0303 5.03033C16.7374 5.32322 16.2626 5.32322 15.9697 5.03033L12.9697 2.03033C12.6768 1.73744 12.6768 1.26256 12.9697 0.96967ZM10.9024 3.21039C11.1283 3.13698 11.3717 3.13698 11.5976 3.21039C11.7721 3.26708 11.8986 3.36124 11.9819 3.43196C12.0538 3.49299 12.1292 3.56846 12.1923 3.63165C12.1965 3.6358 12.2006 3.6399 12.2046 3.64393L14.3684 5.8077C14.4316 5.87084 14.507 5.94624 14.568 6.01813C14.6388 6.10143 14.7329 6.22788 14.7896 6.40236C14.863 6.6283 14.863 6.8717 14.7896 7.09764C14.7329 7.27212 14.6388 7.39857 14.568 7.48187C14.507 7.55377 14.4315 7.62919 14.3683 7.69234L6.60601 15.4547C6.5965 15.4642 6.58707 15.4736 6.57772 15.483C6.4377 15.6232 6.31414 15.7469 6.17096 15.8512C6.04498 15.943 5.90979 16.0214 5.76758 16.0853C5.60597 16.1578 5.43725 16.2037 5.24608 16.2558C5.2333 16.2592 5.22043 16.2627 5.20744 16.2663L1.69734 17.2236C1.43768 17.2944 1.15998 17.2206 0.969672 17.0303C0.779359 16.84 0.705613 16.5623 0.776429 16.3027L1.73373 12.7926C1.73727 12.7796 1.74077 12.7667 1.74425 12.7539C1.79626 12.5627 1.84217 12.394 1.91472 12.2324C1.97857 12.0902 2.05702 11.955 2.14882 11.829C2.25313 11.6859 2.37684 11.5623 2.51703 11.4223C2.52639 11.4129 2.53584 11.4035 2.54535 11.394L10.2954 3.64393C10.2994 3.6399 10.3035 3.63581 10.3077 3.63167C10.3708 3.56847 10.4462 3.493 10.5181 3.43196C10.6014 3.36124 10.7279 3.26708 10.9024 3.21039ZM11.25 4.81066L3.60601 12.4547C3.42221 12.6385 3.38773 12.6759 3.36116 12.7123C3.33056 12.7543 3.30441 12.7994 3.28313 12.8468C3.26466 12.8879 3.24927 12.9365 3.18088 13.1872L2.56892 15.4311L4.81277 14.8191C5.06355 14.7507 5.11205 14.7353 5.1532 14.7169C5.2006 14.6956 5.24566 14.6694 5.28766 14.6388C5.32412 14.6123 5.36155 14.5778 5.54535 14.394L13.1893 6.75L11.25 4.81066Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$9bb22cf52b7e2cb1$var$PencilIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$9bb22cf52b7e2cb1$var$PencilIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$9bb22cf52b7e2cb1$var$PencilIcon.displayName = "PencilIcon";
var $dfd33cee3229493c$var$$9bb22cf52b7e2cb1$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9bb22cf52b7e2cb1$var$PencilIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``percent.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$d9737fe2f4c9fce0$var$PercentIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25C4.5 5.66421 4.83579 6 5.25 6C5.66421 6 6 5.66421 6 5.25C6 4.83579 5.66421 4.5 5.25 4.5ZM3 5.25C3 4.00736 4.00736 3 5.25 3C6.49264 3 7.5 4.00736 7.5 5.25C7.5 6.49264 6.49264 7.5 5.25 7.5C4.00736 7.5 3 6.49264 3 5.25ZM14.7803 3.21967C15.0732 3.51256 15.0732 3.98744 14.7803 4.28033L4.28033 14.7803C3.98744 15.0732 3.51256 15.0732 3.21967 14.7803C2.92678 14.4874 2.92678 14.0126 3.21967 13.7197L13.7197 3.21967C14.0126 2.92678 14.4874 2.92678 14.7803 3.21967ZM12.75 12C12.3358 12 12 12.3358 12 12.75C12 13.1642 12.3358 13.5 12.75 13.5C13.1642 13.5 13.5 13.1642 13.5 12.75C13.5 12.3358 13.1642 12 12.75 12ZM10.5 12.75C10.5 11.5074 11.5074 10.5 12.75 10.5C13.9926 10.5 15 11.5074 15 12.75C15 13.9926 13.9926 15 12.75 15C11.5074 15 10.5 13.9926 10.5 12.75Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$d9737fe2f4c9fce0$var$PercentIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$d9737fe2f4c9fce0$var$PercentIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$d9737fe2f4c9fce0$var$PercentIcon.displayName = "PercentIcon";
var $dfd33cee3229493c$var$$d9737fe2f4c9fce0$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$d9737fe2f4c9fce0$var$PercentIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``phone.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a2ee935c3d91fd2d$var$PhoneIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.17876 2.74666C4.96593 2.63901 4.71458 2.63901 4.50174 2.74666C4.4217 2.78715 4.32192 2.87359 3.88165 3.31386L3.76343 3.43209C3.34326 3.85225 3.23001 3.97377 3.13948 4.13493C3.03454 4.32173 2.94663 4.65979 2.94727 4.87404C2.94784 5.0647 2.97598 5.17951 3.09993 5.6162C3.71163 7.77138 4.86558 9.80521 6.56382 11.5035C8.26207 13.2017 10.2959 14.3556 12.4511 14.9674C12.8878 15.0913 13.0026 15.1194 13.1932 15.12C13.4075 15.1207 13.7456 15.0327 13.9324 14.9278C14.0935 14.8373 14.215 14.724 14.6352 14.3039L14.7534 14.1856C15.1937 13.7454 15.2801 13.6456 15.3206 13.5655C15.4283 13.3527 15.4283 13.1014 15.3206 12.8885C15.2801 12.8085 15.1937 12.7087 14.7534 12.2684L15.2838 11.7381L14.7534 12.2684L14.6073 12.1223C14.318 11.833 14.2529 11.7738 14.2036 11.7417C13.9551 11.5801 13.6346 11.5801 13.386 11.7417C13.3367 11.7738 13.2717 11.833 12.9824 12.1223C12.9767 12.128 12.9708 12.1339 12.9648 12.1399C12.8975 12.2074 12.8123 12.2929 12.71 12.3662L12.2733 11.7564L12.71 12.3662C12.3447 12.6278 11.8482 12.7124 11.4169 12.5867C11.2966 12.5516 11.1976 12.5039 11.1206 12.4668C11.1145 12.4638 11.1086 12.461 11.1027 12.4582C9.94027 11.9001 8.85151 11.1395 7.88965 10.1776C6.92779 9.21578 6.16723 8.12701 5.6091 6.96454C5.6063 6.95872 5.60343 6.95277 5.6005 6.94668C5.56337 6.86966 5.51564 6.77065 5.48058 6.65037L6.20061 6.44048L5.48058 6.65037C5.35486 6.21909 5.43953 5.72255 5.70106 5.35731L5.70106 5.3573C5.77433 5.25497 5.85985 5.16977 5.9274 5.10247C5.93342 5.09647 5.93929 5.09062 5.945 5.08491C6.23429 4.79562 6.29352 4.73058 6.32557 4.68128L6.32557 4.68128C6.48719 4.43269 6.48719 4.11223 6.32557 3.86364C6.29352 3.81434 6.23428 3.7493 5.945 3.46001L5.79885 3.31386C5.35858 2.87359 5.2588 2.78715 5.17876 2.74666ZM3.82472 1.40814C4.46323 1.08519 5.21728 1.08519 5.85578 1.40814C6.18023 1.57224 6.46189 1.85463 6.78772 2.18129C6.81141 2.20504 6.83533 2.22902 6.85951 2.2532L7.00566 2.39935C7.0216 2.41529 7.03739 2.43105 7.05302 2.44665C7.26801 2.66129 7.45321 2.84617 7.58314 3.04601L6.95435 3.45482L7.58314 3.04601C8.06801 3.79176 8.06801 4.75316 7.58314 5.49891C7.45321 5.69875 7.26801 5.88364 7.05302 6.09826C7.03739 6.11387 7.0216 6.12963 7.00566 6.14557C6.96246 6.18877 6.94042 6.21093 6.92506 6.22717C6.92478 6.22839 6.92451 6.22974 6.92426 6.23121C6.92398 6.23283 6.92378 6.23434 6.92363 6.23569C6.92611 6.24118 6.92945 6.24843 6.93406 6.25823C6.94127 6.27355 6.94974 6.2912 6.96132 6.31531C7.44718 7.32727 8.1098 8.27646 8.95031 9.11697C9.79082 9.95748 10.74 10.6201 11.752 11.106L11.4274 11.7821L11.752 11.106C11.7761 11.1175 11.7937 11.126 11.8091 11.1332C11.8189 11.1378 11.8261 11.1412 11.8316 11.1436C11.8329 11.1435 11.8345 11.1433 11.8361 11.143C11.8375 11.1428 11.8389 11.1425 11.8401 11.1422C11.8564 11.1269 11.8785 11.1048 11.9217 11.0616C11.9377 11.0457 11.9534 11.0299 11.969 11.0143C12.1837 10.7993 12.3685 10.6141 12.5684 10.4841C13.3141 9.99928 14.2755 9.99928 15.0213 10.4841C15.2211 10.6141 15.406 10.7993 15.6206 11.0143C15.6362 11.0299 15.652 11.0457 15.6679 11.0616L15.1376 11.592L15.6679 11.0616L15.8141 11.2078C15.8383 11.232 15.8622 11.2559 15.886 11.2796C16.2127 11.6054 16.495 11.8871 16.6591 12.2115C16.9821 12.85 16.9821 13.6041 16.6591 14.2426C16.495 14.567 16.2127 14.8487 15.886 15.1745C15.8622 15.1982 15.8383 15.2221 15.8141 15.2463L15.6959 15.3645C15.6787 15.3816 15.6618 15.3986 15.6451 15.4153C15.2961 15.7646 15.0285 16.0325 14.667 16.2356C14.2545 16.4673 13.6619 16.6214 13.1888 16.62C12.7749 16.6188 12.473 16.533 12.0838 16.4224C12.0698 16.4184 12.0557 16.4144 12.0415 16.4104C9.6466 15.7306 7.38689 14.4478 5.50316 12.5641C3.61944 10.6804 2.33668 8.42069 1.65693 6.02577C1.6529 6.01157 1.64889 5.99749 1.64493 5.98353C1.5343 5.59427 1.44851 5.29242 1.44728 4.8785C1.44587 4.40543 1.6 3.81275 1.83169 3.40029L1.83169 3.40029C2.03479 3.03874 2.30266 2.77114 2.65196 2.4222C2.66871 2.40547 2.68564 2.38855 2.70277 2.37143L2.82099 2.2532C2.84518 2.22902 2.8691 2.20504 2.89278 2.18129C3.21861 1.85463 3.50028 1.57224 3.82472 1.40814L4.1594 2.06982L3.82472 1.40814Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a2ee935c3d91fd2d$var$PhoneIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a2ee935c3d91fd2d$var$PhoneIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a2ee935c3d91fd2d$var$PhoneIcon.displayName = "PhoneIcon";
var $dfd33cee3229493c$var$$a2ee935c3d91fd2d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a2ee935c3d91fd2d$var$PhoneIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``pie-chart.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$ced1a0be0e9c4643$var$PieChartIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.25 2.2912C4.87504 2.66428 2.25 5.52558 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C10.2138 15.75 11.3527 15.4296 12.3369 14.8688L8.39324 9.44084C8.30014 9.3127 8.25 9.15838 8.25 9V2.2912ZM9.75 2.2918V8.25L15.7082 8.25C15.6379 7.62106 15.4793 7.00387 15.2362 6.41689C14.9028 5.61213 14.417 4.87964 13.8054 4.25972C13.7839 4.23786 13.7621 4.21613 13.7403 4.19456C13.1204 3.58305 12.3879 3.09715 11.5831 2.76381C10.9961 2.52068 10.3789 2.36211 9.75 2.2918ZM15.7082 9.75L10.472 9.75L13.5497 13.9862C14.148 13.4403 14.6447 12.7897 15.0143 12.0644C15.3838 11.3392 15.6182 10.5549 15.7082 9.75ZM17.25 9C17.25 13.5564 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C11.2534 0.75 13.2958 1.65345 14.7847 3.11789C14.8011 3.13398 14.8174 3.15014 14.8336 3.16637C14.8499 3.1826 14.866 3.1989 14.8821 3.21526C16.3466 4.70419 17.25 6.74659 17.25 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$ced1a0be0e9c4643$var$PieChartIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$ced1a0be0e9c4643$var$PieChartIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$ced1a0be0e9c4643$var$PieChartIcon.displayName = "PieChartIcon";
var $dfd33cee3229493c$var$$ced1a0be0e9c4643$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ced1a0be0e9c4643$var$PieChartIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``pin-filled.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$efc4065fdc6fcd4a$var$PinFilledIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "",
                d: "M9.66561 1.24573C9.99615 1.02894 10.3989 0.951373 10.7863 1.02991C11.0788 1.0892 11.3023 1.24678 11.4688 1.3856C11.6279 1.51827 11.8061 1.69647 11.9979 1.88827L11.9979 1.88831L15.8973 5.78771L15.8973 5.78772C16.0891 5.97949 16.2674 6.15767 16.4 6.31683C16.5388 6.48337 16.6964 6.70684 16.7557 6.99932C16.8343 7.38673 16.7567 7.78948 16.5399 8.12002C16.3762 8.36956 16.1469 8.51852 15.9562 8.62159C15.7739 8.7201 15.5422 8.81936 15.2929 8.92619L13.3948 9.73964C13.3522 9.7579 13.3314 9.76685 13.3164 9.77368L13.3154 9.77415L13.3146 9.77492C13.3027 9.78631 13.2867 9.80227 13.2539 9.83505L12.0832 11.0057C12.032 11.0569 12.0068 11.0822 11.9891 11.1012L11.9879 11.1026L11.9874 11.1044C11.9815 11.1297 11.9744 11.1646 11.9601 11.2357L11.4041 14.0158C11.3382 14.3456 11.2789 14.6421 11.2098 14.8749C11.1406 15.1078 11.0267 15.4088 10.7703 15.6363C10.4422 15.9274 10.0032 16.0604 9.56872 16.0001C9.22908 15.953 8.96747 15.7658 8.78067 15.6104C8.59402 15.455 8.38022 15.2412 8.14245 15.0034L8.14244 15.0034L5.99265 12.8536L2.28033 16.5659C1.98744 16.8588 1.51256 16.8588 1.21967 16.5659C0.926777 16.273 0.926777 15.7982 1.21967 15.5053L4.93199 11.7929L2.78225 9.6432L2.78222 9.64317C2.54442 9.40541 2.33059 9.1916 2.17527 9.00496C2.01984 8.81816 1.83258 8.55655 1.7855 8.21691C1.72527 7.78247 1.8582 7.34343 2.1493 7.01537C2.37687 6.75889 2.67779 6.64508 2.91074 6.57588C3.14351 6.50673 3.44005 6.44744 3.76982 6.38151L6.54997 5.82548C6.62099 5.81127 6.65596 5.80418 6.68124 5.7982L6.68304 5.79777L6.68439 5.79652C6.70339 5.7788 6.72869 5.75364 6.77991 5.70242L7.95058 4.53175C7.98336 4.49897 7.99932 4.48295 8.01071 4.47103L8.01148 4.47022L8.01195 4.4692C8.01878 4.4542 8.02773 4.43343 8.04599 4.39082L8.85945 2.49275C8.96628 2.24342 9.06553 2.01176 9.16404 1.82946C9.26711 1.63872 9.41607 1.40941 9.66561 1.24573Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$efc4065fdc6fcd4a$var$PinFilledIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$efc4065fdc6fcd4a$var$PinFilledIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$efc4065fdc6fcd4a$var$PinFilledIcon.displayName = "PinFilledIcon";
var $dfd33cee3229493c$var$$efc4065fdc6fcd4a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$efc4065fdc6fcd4a$var$PinFilledIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``pin.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$99d12cb68ffbb00a$var$PinIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9.9555 1.16503C10.286 0.948232 10.6888 0.870669 11.0762 0.949204C11.3687 1.00849 11.5921 1.16608 11.7587 1.3049C11.9178 1.43758 12.096 1.61579 12.2878 1.80761L16.1872 5.707C16.379 5.89878 16.5572 6.07697 16.6899 6.23613C16.8287 6.40267 16.9863 6.62614 17.0456 6.91862C17.1241 7.30603 17.0466 7.70878 16.8298 8.03931C16.6661 8.28885 16.4368 8.43782 16.2461 8.54088C16.0637 8.63939 15.8321 8.73865 15.5828 8.84548L13.6847 9.65893C13.6421 9.6772 13.6213 9.68615 13.6063 9.69298C13.606 9.69314 13.6056 9.69329 13.6053 9.69344C13.605 9.69369 13.6048 9.69395 13.6045 9.69422C13.5926 9.70561 13.5765 9.72157 13.5438 9.75435L12.3731 10.925C12.3219 10.9762 12.2967 11.0015 12.279 11.0205C12.2786 11.021 12.2781 11.0215 12.2777 11.0219C12.2776 11.0225 12.2775 11.0231 12.2773 11.0237C12.2713 11.049 12.2642 11.0839 12.25 11.155L11.694 13.9351C11.6281 14.2649 11.5688 14.5614 11.4996 14.7942C11.4304 15.0271 11.3166 15.3281 11.0602 15.5556C10.7321 15.8467 10.293 15.9797 9.85861 15.9194C9.51897 15.8723 9.25735 15.6851 9.07056 15.5297C8.88391 15.3743 8.6701 15.1605 8.43233 14.9227L6.28254 12.7729L2.57022 16.4852C2.27732 16.7781 1.80245 16.7781 1.50956 16.4852C1.21666 16.1923 1.21666 15.7175 1.50956 15.4246L5.22188 11.7122L3.07213 9.5625C2.83432 9.32472 2.62048 9.11091 2.46516 8.92425C2.30972 8.73746 2.12247 8.47585 2.07538 8.1362C2.01516 7.70176 2.14808 7.26273 2.43918 6.93466C2.66676 6.67818 2.96768 6.56437 3.20062 6.49517C3.4334 6.42602 3.72993 6.36674 4.05971 6.30081L6.83985 5.74478C6.91088 5.73057 6.94585 5.72347 6.97113 5.7175C6.97175 5.71735 6.97235 5.71721 6.97293 5.71707C6.97336 5.71667 6.97381 5.71625 6.97428 5.71581C6.99327 5.69809 7.01858 5.67293 7.0698 5.62171L8.24046 4.45105C8.27324 4.41827 8.28921 4.40224 8.30059 4.39033C8.30086 4.39005 8.30112 4.38978 8.30137 4.38952C8.30152 4.38919 8.30167 4.38885 8.30183 4.3885C8.30867 4.3735 8.31762 4.35273 8.33588 4.31011L9.14934 2.41204C9.25616 2.16272 9.35542 1.93106 9.45393 1.74876C9.557 1.55801 9.70596 1.3287 9.9555 1.16503ZM9.47004 13.8391C9.73809 14.1071 9.9028 14.2708 10.03 14.3766C10.0382 14.3835 10.0459 14.3897 10.053 14.3954C10.0558 14.3867 10.0587 14.3773 10.0617 14.367C10.1089 14.2084 10.1551 13.9809 10.2295 13.6091L10.7792 10.8608C10.781 10.8519 10.7828 10.8427 10.7846 10.8333C10.8051 10.73 10.8308 10.5998 10.8803 10.4736C10.9233 10.364 10.9791 10.2599 11.0464 10.1633C11.124 10.0521 11.218 9.95849 11.2926 9.88417C11.2994 9.8774 11.306 9.8708 11.3124 9.86436L12.4831 8.69369C12.4872 8.68958 12.4914 8.68536 12.4957 8.68104C12.5434 8.63321 12.6035 8.57296 12.6721 8.5185C12.7317 8.47115 12.7949 8.4284 12.861 8.39063C12.937 8.34719 13.0153 8.31377 13.0774 8.28724C13.083 8.28484 13.0885 8.2825 13.0938 8.28022L14.9646 7.47846C15.2507 7.35585 15.418 7.28332 15.533 7.22122C15.5391 7.21789 15.5449 7.21474 15.5502 7.21175C15.5463 7.20701 15.5422 7.20195 15.5377 7.19658C15.4541 7.09623 15.3256 6.96673 15.1055 6.74664L11.2482 2.88929C11.0281 2.66921 10.8986 2.54074 10.7982 2.45709C10.7929 2.45261 10.7878 2.44847 10.7831 2.44464C10.7801 2.44996 10.7769 2.45568 10.7736 2.46183C10.7115 2.57677 10.639 2.74415 10.5164 3.03023L9.7146 4.90099C9.71231 4.90634 9.70996 4.91182 9.70756 4.91744C9.68104 4.97956 9.64762 5.05782 9.60418 5.13384C9.56641 5.19996 9.52367 5.2631 9.47631 5.32271C9.42185 5.39128 9.3616 5.45137 9.31377 5.49908C9.30945 5.50339 9.30523 5.5076 9.30112 5.51171L8.13046 6.68237C8.12401 6.68882 8.11741 6.69545 8.11064 6.70224C8.03632 6.77686 7.94271 6.87084 7.83152 6.94839C7.73495 7.01574 7.63079 7.07149 7.52118 7.11448C7.39499 7.16398 7.26486 7.18973 7.16155 7.21018C7.15214 7.21204 7.14296 7.21386 7.13403 7.21565L4.38568 7.76532C4.01395 7.83966 3.78642 7.88594 3.62778 7.93307C3.61755 7.9361 3.60811 7.93901 3.59939 7.94179C3.60511 7.94893 3.61135 7.9566 3.61817 7.96479C3.72403 8.09201 3.88768 8.25672 4.15573 8.52478L9.47004 13.8391Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$99d12cb68ffbb00a$var$PinIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$99d12cb68ffbb00a$var$PinIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$99d12cb68ffbb00a$var$PinIcon.displayName = "PinIcon";
var $dfd33cee3229493c$var$$99d12cb68ffbb00a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$99d12cb68ffbb00a$var$PinIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``plus-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e99f01b9ad47095d$var$PlusCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V8.25H12C12.4142 8.25 12.75 8.58579 12.75 9C12.75 9.41421 12.4142 9.75 12 9.75H9.75V12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12V9.75H6C5.58579 9.75 5.25 9.41421 5.25 9C5.25 8.58579 5.58579 8.25 6 8.25H8.25V6C8.25 5.58579 8.58579 5.25 9 5.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e99f01b9ad47095d$var$PlusCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e99f01b9ad47095d$var$PlusCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e99f01b9ad47095d$var$PlusCircleIcon.displayName = "PlusCircleIcon";
var $dfd33cee3229493c$var$$e99f01b9ad47095d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e99f01b9ad47095d$var$PlusCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``plus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$7c04a01cdc660930$var$PlusIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 3C9.41421 3 9.75 3.33579 9.75 3.75V8.25H14.25C14.6642 8.25 15 8.58579 15 9C15 9.41421 14.6642 9.75 14.25 9.75H9.75V14.25C9.75 14.6642 9.41421 15 9 15C8.58579 15 8.25 14.6642 8.25 14.25V9.75H3.75C3.33579 9.75 3 9.41421 3 9C3 8.58579 3.33579 8.25 3.75 8.25H8.25V3.75C8.25 3.33579 8.58579 3 9 3Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$7c04a01cdc660930$var$PlusIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$7c04a01cdc660930$var$PlusIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$7c04a01cdc660930$var$PlusIcon.displayName = "PlusIcon";
var $dfd33cee3229493c$var$$7c04a01cdc660930$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7c04a01cdc660930$var$PlusIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``post-edit.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$ce149b523aa981d8$var$PostEditIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M11.862 1.19529C12.6746 0.382656 13.9922 0.382658 14.8048 1.19529C15.6175 2.00793 15.6175 3.32547 14.8048 4.1381L8.42966 10.5133C8.41646 10.5265 8.40339 10.5396 8.39042 10.5526C8.19878 10.7445 8.02982 10.9138 7.82613 11.0386C7.64718 11.1483 7.45209 11.2291 7.24802 11.2781C7.01572 11.3339 6.77656 11.3336 6.50529 11.3334C6.48693 11.3334 6.46842 11.3334 6.44976 11.3334H5.3334C4.96521 11.3334 4.66673 11.0349 4.66673 10.6667V9.55035C4.66673 9.53169 4.66671 9.51318 4.6667 9.49481C4.66644 9.22355 4.66622 8.98439 4.72199 8.75209C4.77099 8.54802 4.85179 8.35293 4.96145 8.17398C5.08628 7.97029 5.25555 7.80133 5.44754 7.6097C5.46054 7.59672 5.47364 7.58365 5.48683 7.57045L11.862 1.19529ZM13.862 2.1381C13.5701 1.84617 13.0968 1.84616 12.8048 2.1381L6.42964 8.51326C6.1766 8.7663 6.12994 8.81902 6.0983 8.87065C6.06175 8.9303 6.03482 8.99533 6.01848 9.06335C6.00435 9.12223 6.00006 9.1925 6.00006 9.55035V10H6.44976C6.80761 10 6.87788 9.99574 6.93676 9.98161C7.00479 9.96528 7.06982 9.93834 7.12946 9.90179C7.18109 9.87015 7.23381 9.82349 7.48685 9.57045L13.862 3.19529C14.1539 2.90336 14.1539 2.43004 13.862 2.1381ZM4.50588 2.00003L7.33342 2.00003C7.70161 2.00003 8.00008 2.29851 8.00008 2.6667C8.00008 3.03489 7.70161 3.33336 7.33342 3.33336H4.53342C3.96236 3.33336 3.57417 3.33388 3.27411 3.3584C2.98183 3.38228 2.83236 3.42556 2.72809 3.47869C2.47721 3.60652 2.27324 3.81049 2.14541 4.06138C2.09228 4.16564 2.049 4.31511 2.02512 4.60739C2.0006 4.90745 2.00008 5.29564 2.00008 5.8667V11.4667C2.00008 12.0377 2.0006 12.4259 2.02512 12.726C2.049 13.0183 2.09228 13.1677 2.14541 13.272C2.27324 13.5229 2.47721 13.7269 2.7281 13.8547C2.83236 13.9078 2.98183 13.9511 3.27411 13.975C3.57417 13.9995 3.96236 14 4.53342 14H10.1334C10.7045 14 11.0927 13.9995 11.3927 13.975C11.685 13.9511 11.8345 13.9078 11.9387 13.8547C12.1896 13.7269 12.3936 13.5229 12.5214 13.272C12.5745 13.1677 12.6178 13.0183 12.6417 12.726C12.6662 12.4259 12.6667 12.0377 12.6667 11.4667V8.6667C12.6667 8.29851 12.9652 8.00003 13.3334 8.00003C13.7016 8.00003 14.0001 8.29851 14.0001 8.6667V11.4942C14.0001 12.0309 14.0001 12.4738 13.9706 12.8346C13.94 13.2093 13.8743 13.5538 13.7094 13.8773C13.4538 14.3791 13.0458 14.7871 12.5441 15.0427C12.2205 15.2076 11.876 15.2733 11.5013 15.3039C11.1405 15.3334 10.6976 15.3334 10.161 15.3334H4.50587C3.96923 15.3334 3.52632 15.3334 3.16553 15.3039C2.7908 15.2733 2.44633 15.2076 2.12277 15.0427C1.62101 14.7871 1.21306 14.3791 0.957398 13.8773C0.792537 13.5538 0.726828 13.2093 0.696211 12.8346C0.666733 12.4738 0.66674 12.0309 0.666748 11.4942V5.83916C0.66674 5.30252 0.666733 4.85961 0.696211 4.49881C0.726828 4.12408 0.792537 3.77961 0.957398 3.45605C1.21306 2.95429 1.62101 2.54634 2.12277 2.29068C2.44633 2.12582 2.7908 2.06011 3.16553 2.02949C3.52633 2.00001 3.96924 2.00002 4.50588 2.00003Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$ce149b523aa981d8$var$PostEditIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$ce149b523aa981d8$var$PostEditIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$ce149b523aa981d8$var$PostEditIcon.displayName = "PostEditIcon";
var $dfd33cee3229493c$var$$ce149b523aa981d8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ce149b523aa981d8$var$PostEditIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``refresh.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$d9becaa6c2fa453e$var$RefreshIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 3C7.34219 3 5.84261 3.67136 4.75589 4.75883C4.1876 5.32752 3.54226 6.09846 3.02309 6.75H6C6.41421 6.75 6.75 7.08579 6.75 7.5C6.75 7.91421 6.41421 8.25 6 8.25H1.5C1.08579 8.25 0.75 7.91421 0.75 7.5V3C0.75 2.58579 1.08579 2.25 1.5 2.25C1.91421 2.25 2.25 2.58579 2.25 3V5.32083C2.70141 4.77186 3.21514 4.17859 3.69486 3.69853C5.05142 2.34105 6.9282 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C5.57966 16.5 2.69588 14.2111 1.79323 11.0829C1.67839 10.685 1.90791 10.2692 2.30589 10.1544C2.70386 10.0396 3.11958 10.2691 3.23442 10.6671C3.95678 13.1704 6.2657 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$d9becaa6c2fa453e$var$RefreshIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$d9becaa6c2fa453e$var$RefreshIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$d9becaa6c2fa453e$var$RefreshIcon.displayName = "RefreshIcon";
var $dfd33cee3229493c$var$$d9becaa6c2fa453e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$d9becaa6c2fa453e$var$RefreshIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``reverse-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$0391056c70305a6d$var$ReverseLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6.53033 1.71967C6.82322 2.01256 6.82322 2.48744 6.53033 2.78033L4.81066 4.5H10.5C13.3995 4.5 15.75 6.85051 15.75 9.75C15.75 12.6495 13.3995 15 10.5 15H3C2.58579 15 2.25 14.6642 2.25 14.25C2.25 13.8358 2.58579 13.5 3 13.5H10.5C12.5711 13.5 14.25 11.8211 14.25 9.75C14.25 7.67893 12.5711 6 10.5 6H4.81066L6.53033 7.71967C6.82322 8.01256 6.82322 8.48744 6.53033 8.78033C6.23744 9.07322 5.76256 9.07322 5.46967 8.78033L2.46967 5.78033C2.17678 5.48744 2.17678 5.01256 2.46967 4.71967L5.46967 1.71967C5.76256 1.42678 6.23744 1.42678 6.53033 1.71967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$0391056c70305a6d$var$ReverseLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$0391056c70305a6d$var$ReverseLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$0391056c70305a6d$var$ReverseLeftIcon.displayName = "ReverseLeftIcon";
var $dfd33cee3229493c$var$$0391056c70305a6d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$0391056c70305a6d$var$ReverseLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``reverse-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$4e3f3f281bf4a641$var$ReverseRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M11.4697 1.71967C11.7626 1.42678 12.2374 1.42678 12.5303 1.71967L15.5303 4.71967C15.8232 5.01256 15.8232 5.48744 15.5303 5.78033L12.5303 8.78033C12.2374 9.07322 11.7626 9.07322 11.4697 8.78033C11.1768 8.48744 11.1768 8.01256 11.4697 7.71967L13.1893 6H7.5C5.42893 6 3.75 7.67893 3.75 9.75C3.75 11.8211 5.42893 13.5 7.5 13.5H15C15.4142 13.5 15.75 13.8358 15.75 14.25C15.75 14.6642 15.4142 15 15 15H7.5C4.60051 15 2.25 12.6495 2.25 9.75C2.25 6.85051 4.60051 4.5 7.5 4.5H13.1893L11.4697 2.78033C11.1768 2.48744 11.1768 2.01256 11.4697 1.71967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$4e3f3f281bf4a641$var$ReverseRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$4e3f3f281bf4a641$var$ReverseRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$4e3f3f281bf4a641$var$ReverseRightIcon.displayName = "ReverseRightIcon";
var $dfd33cee3229493c$var$$4e3f3f281bf4a641$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4e3f3f281bf4a641$var$ReverseRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``rows.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$fef902a36f31556a$var$RowsIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM3 7.5V10.5H15V7.5H3ZM15 6H3V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H12.15C12.7924 3 13.2292 3.00058 13.5667 3.02816C13.8955 3.05503 14.0637 3.10372 14.181 3.16349C14.4632 3.3073 14.6927 3.53677 14.8365 3.81902C14.8963 3.93631 14.945 4.10447 14.9718 4.43328C14.9994 4.77085 15 5.20757 15 5.85V6ZM15 12H3V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V12Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$fef902a36f31556a$var$RowsIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$fef902a36f31556a$var$RowsIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$fef902a36f31556a$var$RowsIcon.displayName = "RowsIcon";
var $dfd33cee3229493c$var$$fef902a36f31556a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$fef902a36f31556a$var$RowsIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``save.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$43ac066c7f47d4dd$var$SaveIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M11.5538 3.02072C11.4875 3.00482 11.4085 3 11.0059 3H6V4.8C6 5.0224 6.00058 5.14409 6.00773 5.23152C6.00801 5.23501 6.0083 5.2383 6.00859 5.24141C6.0117 5.2417 6.01499 5.24199 6.01848 5.24227C6.10592 5.24942 6.22761 5.25 6.45 5.25H11.55C11.7724 5.25 11.8941 5.24942 11.9815 5.24227C11.985 5.24199 11.9883 5.2417 11.9914 5.24141C11.9917 5.2383 11.992 5.23501 11.9923 5.23152C11.9994 5.14409 12 5.0224 12 4.8V3.31203C11.8588 3.17378 11.8143 3.13735 11.7706 3.11052C11.7035 3.0694 11.6303 3.0391 11.5538 3.02072ZM13.2802 2.46957L13.2333 2.42261C13.2184 2.40777 13.2037 2.39303 13.1891 2.37841C12.9735 2.16242 12.7835 1.97199 12.5543 1.83156C12.353 1.7082 12.1335 1.61729 11.9039 1.56217C11.6426 1.49943 11.3735 1.49968 11.0684 1.49996C11.0477 1.49998 11.0269 1.5 11.0059 1.5L5.81903 1.5C5.63224 1.5 5.45554 1.49999 5.28855 1.50097C5.27578 1.50033 5.26293 1.5 5.25 1.5C5.23345 1.5 5.21702 1.50054 5.20074 1.50159C4.86462 1.50438 4.5692 1.51206 4.31113 1.53315C3.88956 1.56759 3.50203 1.64151 3.13803 1.82698C2.57354 2.1146 2.1146 2.57354 1.82698 3.13803C1.64151 3.50203 1.56759 3.88956 1.53315 4.31113C1.49998 4.71703 1.49999 5.2153 1.5 5.81903V12.181C1.49999 12.7847 1.49998 13.283 1.53315 13.6889C1.56759 14.1104 1.64151 14.498 1.82698 14.862C2.1146 15.4265 2.57354 15.8854 3.13803 16.173C3.50203 16.3585 3.88956 16.4324 4.31113 16.4669C4.5692 16.4879 4.86462 16.4956 5.20074 16.4984C5.21702 16.4995 5.23345 16.5 5.25 16.5C5.26293 16.5 5.27578 16.4997 5.28855 16.499C5.45553 16.5 5.63222 16.5 5.81901 16.5H12.181C12.3678 16.5 12.5445 16.5 12.7115 16.499C12.7242 16.4997 12.7371 16.5 12.75 16.5C12.7666 16.5 12.783 16.4995 12.7993 16.4984C13.1354 16.4956 13.4308 16.4879 13.6889 16.4669C14.1104 16.4324 14.498 16.3585 14.862 16.173C15.4265 15.8854 15.8854 15.4265 16.173 14.862C16.3585 14.498 16.4324 14.1104 16.4669 13.6889C16.5 13.283 16.5 12.7847 16.5 12.181V6.99411C16.5 6.97311 16.5 6.95229 16.5 6.93162C16.5003 6.62646 16.5006 6.3574 16.4378 6.09607C16.3827 5.86649 16.2918 5.64701 16.1684 5.4457C16.028 5.21655 15.8376 5.02647 15.6216 4.81088C15.607 4.79629 15.5922 4.78158 15.5774 4.76673L13.2802 2.46957C13.2802 2.4695 13.2803 2.46964 13.2802 2.46957ZM13.5 4.81066V4.82391C13.5 5.0132 13.5 5.19755 13.4873 5.35367C13.4733 5.52512 13.4402 5.72742 13.3365 5.93099C13.1927 6.21323 12.9632 6.4427 12.681 6.58651C12.4774 6.69023 12.2751 6.72328 12.1037 6.73729C11.9476 6.75005 11.7632 6.75002 11.5739 6.75L6.45 6.75C6.44202 6.75 6.43404 6.75 6.42608 6.75C6.23679 6.75002 6.05245 6.75005 5.89633 6.73729C5.72488 6.72328 5.52258 6.69023 5.31902 6.58651C5.03677 6.4427 4.8073 6.21323 4.66349 5.93099C4.55977 5.72742 4.52672 5.52512 4.51271 5.35367C4.49995 5.19755 4.49998 5.01321 4.5 4.82392C4.5 4.81596 4.5 4.80798 4.5 4.8V3.02315C4.47733 3.02471 4.4551 3.02638 4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81901C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77085 3 5.20757 3 5.85V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.4551 14.9736 4.47733 14.9753 4.5 14.9769L4.5 10.9261C4.49998 10.7368 4.49995 10.5524 4.51271 10.3963C4.52672 10.2249 4.55977 10.0226 4.66349 9.81901C4.8073 9.53677 5.03677 9.3073 5.31902 9.16349C5.52258 9.05977 5.72488 9.02672 5.89633 9.01271C6.05245 8.99995 6.2368 8.99998 6.42609 9H11.5739C11.7632 8.99998 11.9475 8.99995 12.1037 9.01271C12.2751 9.02672 12.4774 9.05977 12.681 9.16349C12.9632 9.3073 13.1927 9.53677 13.3365 9.81902C13.4402 10.0226 13.4733 10.2249 13.4873 10.3963C13.5 10.5525 13.5 10.7368 13.5 10.9261L13.5 14.9769C13.5227 14.9753 13.5449 14.9736 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V6.99411C15 6.59153 14.9952 6.51248 14.9793 6.44624C14.9609 6.36971 14.9306 6.29655 14.8895 6.22945C14.8539 6.17136 14.8014 6.11206 14.5167 5.82739L13.5 4.81066ZM12 15V10.95C12 10.7276 11.9994 10.6059 11.9923 10.5185C11.992 10.515 11.9917 10.5117 11.9914 10.5086C11.9883 10.5083 11.985 10.508 11.9815 10.5077C11.8941 10.5006 11.7724 10.5 11.55 10.5H6.45C6.22761 10.5 6.10592 10.5006 6.01848 10.5077C6.01499 10.508 6.0117 10.5083 6.00859 10.5086C6.0083 10.5117 6.00801 10.515 6.00773 10.5185C6.00058 10.6059 6 10.7276 6 10.95V15H12Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$43ac066c7f47d4dd$var$SaveIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$43ac066c7f47d4dd$var$SaveIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$43ac066c7f47d4dd$var$SaveIcon.displayName = "SaveIcon";
var $dfd33cee3229493c$var$$43ac066c7f47d4dd$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$43ac066c7f47d4dd$var$SaveIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``scissor.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$44d631dbd3e1fbbd$var$ScissorIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.05513 3.30156 5.53982 3.74979 5.79921L3.89292 5.87207C4.07852 5.95431 4.28392 6 4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3ZM6.13692 7.01447C6.95758 6.47913 7.5 5.55291 7.5 4.5C7.5 2.84315 6.15685 1.5 4.5 1.5C2.84315 1.5 1.5 2.84315 1.5 4.5C1.5 5.59593 2.08765 6.5546 2.96503 7.07811C2.98688 7.09233 3.00969 7.10556 3.03342 7.1177C3.10401 7.15734 3.17638 7.1942 3.25036 7.22814L6.73079 9L3.25037 10.7719C3.17638 10.8058 3.10401 10.8427 3.03341 10.8823C3.00968 10.8944 2.98688 10.9077 2.96503 10.9219C2.08765 11.4454 1.5 12.4041 1.5 13.5C1.5 15.1569 2.84315 16.5 4.5 16.5C6.15685 16.5 7.5 15.1569 7.5 13.5C7.5 12.4471 6.95758 11.5209 6.13692 10.9855L8.38393 9.8416L15.4097 13.4184C15.7789 13.6063 16.2304 13.4594 16.4184 13.0903C16.6063 12.7211 16.4594 12.2695 16.0903 12.0816L10.0371 9L16.0903 5.91837C16.4594 5.73045 16.6063 5.27887 16.4184 4.90974C16.2304 4.54061 15.7789 4.39371 15.4097 4.58163L8.38393 8.1584L6.13692 7.01447ZM3.7498 12.2008L3.89291 12.1279C4.07852 12.0457 4.28392 12 4.5 12C5.32843 12 6 12.6716 6 13.5C6 14.3284 5.32843 15 4.5 15C3.67157 15 3 14.3284 3 13.5C3 12.9449 3.30156 12.4602 3.7498 12.2008Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$44d631dbd3e1fbbd$var$ScissorIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$44d631dbd3e1fbbd$var$ScissorIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$44d631dbd3e1fbbd$var$ScissorIcon.displayName = "ScissorIcon";
var $dfd33cee3229493c$var$$44d631dbd3e1fbbd$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$44d631dbd3e1fbbd$var$ScissorIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``search.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$30232b0a804943c9$var$SearchIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.5 3C5.01472 3 3 5.01472 3 7.5C3 9.98528 5.01472 12 7.5 12C9.98528 12 12 9.98528 12 7.5C12 5.01472 9.98528 3 7.5 3ZM1.5 7.5C1.5 4.18629 4.18629 1.5 7.5 1.5C10.8137 1.5 13.5 4.18629 13.5 7.5C13.5 8.88652 13.0297 10.1632 12.2399 11.1792L16.2803 15.2197C16.5732 15.5126 16.5732 15.9874 16.2803 16.2803C15.9874 16.5732 15.5126 16.5732 15.2197 16.2803L11.1793 12.2399C10.1633 13.0297 8.88655 13.5 7.5 13.5C4.18629 13.5 1.5 10.8137 1.5 7.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$30232b0a804943c9$var$SearchIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$30232b0a804943c9$var$SearchIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$30232b0a804943c9$var$SearchIcon.displayName = "SearchIcon";
var $dfd33cee3229493c$var$$30232b0a804943c9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$30232b0a804943c9$var$SearchIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``send.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$840498a943912e57$var$SendIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M14.5005 4.55986L8.75102 10.3093L10.5009 14.8089L14.5005 4.55986ZM7.69036 9.24866L13.4398 3.4992L3.19079 7.49882L7.69036 9.24866ZM15.4854 1.10563C15.6228 1.06572 15.8991 0.994013 16.1959 1.09317C16.5313 1.20521 16.7945 1.46839 16.9065 1.80375C17.0057 2.10057 16.934 2.37692 16.894 2.51431C16.8506 2.66403 16.7809 2.84247 16.711 3.0215L11.7479 15.7393C11.6699 15.9395 11.5943 16.1333 11.5203 16.2829C11.4564 16.4122 11.3141 16.6869 11.0189 16.8403C10.6933 17.0094 10.3058 17.0092 9.98043 16.8397C9.68541 16.686 9.54347 16.411 9.4797 16.2817C9.4059 16.132 9.33053 15.9381 9.2527 15.7379L7.29525 10.7044L2.28825 8.75727C2.27943 8.75384 2.27061 8.75041 2.26181 8.74699C2.06159 8.66915 1.86768 8.59377 1.71798 8.51998C1.58864 8.45621 1.31372 8.31427 1.16001 8.01924C0.990499 7.6939 0.990271 7.30633 1.1594 6.98079C1.31276 6.68558 1.58752 6.54332 1.71678 6.4794C1.86639 6.40542 2.06021 6.32982 2.26034 6.25175C2.26914 6.24831 2.27796 6.24488 2.28678 6.24143L14.9782 1.28869C15.1572 1.21879 15.3356 1.14912 15.4854 1.10563Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$840498a943912e57$var$SendIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$840498a943912e57$var$SendIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$840498a943912e57$var$SendIcon.displayName = "SendIcon";
var $dfd33cee3229493c$var$$840498a943912e57$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$840498a943912e57$var$SendIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``settings.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$fa2608328c23e411$var$SettingsIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M13.125 3C12.0895 3 11.25 3.83947 11.25 4.875C11.25 5.91053 12.0895 6.75 13.125 6.75C14.1605 6.75 15 5.91053 15 4.875C15 3.83947 14.1605 3 13.125 3ZM11.0035 2.25C11.5831 1.78095 12.3213 1.5 13.125 1.5C14.989 1.5 16.5 3.01104 16.5 4.875C16.5 6.73896 14.989 8.25 13.125 8.25C12.3213 8.25 11.5831 7.96905 11.0035 7.5H4.125C2.67525 7.5 1.5 6.32475 1.5 4.875C1.5 3.42525 2.67525 2.25 4.125 2.25H11.0035ZM9.94204 3.75H4.125C3.50368 3.75 3 4.25368 3 4.875C3 5.49632 3.50368 6 4.125 6H9.94204C9.81767 5.64812 9.75 5.26946 9.75 4.875C9.75 4.48054 9.81767 4.10188 9.94204 3.75ZM1.5 13.125C1.5 11.261 3.01104 9.75 4.875 9.75C5.67874 9.75 6.41685 10.031 6.9965 10.5H13.875C15.3247 10.5 16.5 11.6753 16.5 13.125C16.5 14.5747 15.3247 15.75 13.875 15.75H6.9965C6.41685 16.2191 5.67874 16.5 4.875 16.5C3.01104 16.5 1.5 14.989 1.5 13.125ZM8.05796 14.25H13.875C14.4963 14.25 15 13.7463 15 13.125C15 12.5037 14.4963 12 13.875 12H8.05796C8.18233 12.3519 8.25 12.7305 8.25 13.125C8.25 13.5195 8.18233 13.8981 8.05796 14.25ZM4.875 11.25C3.83947 11.25 3 12.0895 3 13.125C3 14.1605 3.83947 15 4.875 15C5.91053 15 6.75 14.1605 6.75 13.125C6.75 12.0895 5.91053 11.25 4.875 11.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$fa2608328c23e411$var$SettingsIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$fa2608328c23e411$var$SettingsIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$fa2608328c23e411$var$SettingsIcon.displayName = "SettingsIcon";
var $dfd33cee3229493c$var$$fa2608328c23e411$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$fa2608328c23e411$var$SettingsIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``share.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$dd53c1403644759c$var$ShareIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5L7.5 1.5C7.91421 1.5 8.25 1.83579 8.25 2.25C8.25 2.66421 7.91421 3 7.5 3H5.85C5.20757 3 4.77085 3.00058 4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81901C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77085 3 5.20757 3 5.85V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V10.5C15 10.0858 15.3358 9.75 15.75 9.75C16.1642 9.75 16.5 10.0858 16.5 10.5V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM12.9697 1.71967C13.2626 1.42678 13.7374 1.42678 14.0303 1.71967L16.2803 3.96967C16.5732 4.26256 16.5732 4.73744 16.2803 5.03033L14.0303 7.28033C13.7374 7.57322 13.2626 7.57322 12.9697 7.28033C12.6768 6.98744 12.6768 6.51256 12.9697 6.21967L13.9393 5.25H13.35C12.7076 5.25 12.2708 5.25058 11.9333 5.27816C11.6045 5.30503 11.4363 5.35372 11.319 5.41349C11.0368 5.5573 10.8073 5.78677 10.6635 6.06901C10.6037 6.18631 10.555 6.35447 10.5282 6.68328C10.5006 7.02085 10.5 7.45757 10.5 8.1V9C10.5 9.41421 10.1642 9.75 9.75 9.75C9.33579 9.75 9 9.41421 9 9V8.06904C8.99999 7.46531 8.99998 6.96703 9.03315 6.56113C9.06759 6.13956 9.14151 5.75203 9.32698 5.38803C9.6146 4.82354 10.0735 4.3646 10.638 4.07698C11.002 3.89151 11.3896 3.81759 11.8111 3.78315C12.217 3.74998 12.7153 3.74999 13.319 3.75L13.9393 3.75L12.9697 2.78033C12.6768 2.48744 12.6768 2.01256 12.9697 1.71967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$dd53c1403644759c$var$ShareIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$dd53c1403644759c$var$ShareIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$dd53c1403644759c$var$ShareIcon.displayName = "ShareIcon";
var $dfd33cee3229493c$var$$dd53c1403644759c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$dd53c1403644759c$var$ShareIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``sheet.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e4bc726ff1c141fb$var$SheetIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM3 7.5V10.5H8.25V7.5H3ZM8.25 6H3V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3H8.25V6ZM9.75 7.5V10.5H15V7.5H9.75ZM15 6H9.75V3H12.15C12.7924 3 13.2292 3.00058 13.5667 3.02816C13.8955 3.05503 14.0637 3.10372 14.181 3.16349C14.4632 3.3073 14.6927 3.53677 14.8365 3.81902C14.8963 3.93631 14.945 4.10447 14.9718 4.43328C14.9994 4.77085 15 5.20757 15 5.85V6ZM15 12H9.75V15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V12ZM8.25 15V12H3V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H8.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e4bc726ff1c141fb$var$SheetIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e4bc726ff1c141fb$var$SheetIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e4bc726ff1c141fb$var$SheetIcon.displayName = "SheetIcon";
var $dfd33cee3229493c$var$$e4bc726ff1c141fb$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e4bc726ff1c141fb$var$SheetIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``shield-check.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$ee0b034933fb5fa2$var$ShieldCheckIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.78548 0.816414C8.92775 0.795855 9.07225 0.795855 9.21452 0.816414C9.3785 0.840109 9.53108 0.897751 9.65223 0.94352C9.66332 0.947709 9.67414 0.951798 9.68469 0.955753L13.706 2.46376C13.739 2.47611 13.7716 2.4883 13.804 2.50039C14.2674 2.67338 14.6743 2.8253 14.9876 3.10147C15.2618 3.34306 15.4729 3.64778 15.6029 3.98929C15.7514 4.37967 15.7508 4.81401 15.7501 5.30859C15.7501 5.34316 15.75 5.37803 15.75 5.4132V8.99999C15.75 11.12 14.597 12.8874 13.3507 14.1858C12.096 15.4929 10.6605 16.4161 9.90143 16.859C9.89141 16.8648 9.88117 16.8708 9.87069 16.877C9.73217 16.9583 9.55238 17.0639 9.31452 17.1149C9.11993 17.1566 8.88007 17.1566 8.68548 17.1149C8.44762 17.0639 8.26783 16.9583 8.1293 16.877C8.11883 16.8708 8.10859 16.8648 8.09858 16.859C7.3395 16.4161 5.90397 15.4929 4.64929 14.1858C3.40297 12.8874 2.25 11.12 2.25 8.99999V5.4132C2.25 5.37803 2.24995 5.34316 2.2499 5.30859C2.24918 4.81401 2.24855 4.37967 2.39711 3.98929C2.52706 3.64778 2.73823 3.34306 3.01237 3.10147C3.32573 2.8253 3.73264 2.67338 4.19598 2.50039C4.22837 2.4883 4.26103 2.47611 4.29396 2.46376L8.31531 0.955753C8.32586 0.951798 8.33668 0.947709 8.34777 0.943519C8.46892 0.89775 8.6215 0.840109 8.78548 0.816414ZM8.99774 2.30345C8.9671 2.31349 8.92555 2.32891 8.84199 2.36025L4.82065 3.86825C4.20172 4.10035 4.08261 4.15765 4.00412 4.22682C3.91274 4.30735 3.84235 4.40892 3.79904 4.52276C3.76183 4.62053 3.75 4.75218 3.75 5.4132V8.99999C3.75 10.5614 4.60477 11.9733 5.73144 13.1471C6.84975 14.3121 8.15248 15.1538 8.85444 15.5633C8.89734 15.5884 8.92829 15.6064 8.9552 15.6215C8.97632 15.6334 8.99037 15.6409 9 15.6458C9.00963 15.6409 9.02369 15.6334 9.0448 15.6215C9.07171 15.6064 9.10266 15.5884 9.14556 15.5633C9.84752 15.1538 11.1502 14.3121 12.2686 13.1471C13.3952 11.9733 14.25 10.5614 14.25 8.99999V5.4132C14.25 4.75218 14.2382 4.62053 14.201 4.52276C14.1576 4.40892 14.0873 4.30735 13.9959 4.22682C13.9174 4.15765 13.7983 4.10035 13.1794 3.86825L9.15801 2.36025C9.07445 2.32891 9.0329 2.31349 9.00226 2.30345C9.00148 2.30319 9.00072 2.30295 9 2.30271C8.99928 2.30295 8.99852 2.30319 8.99774 2.30345ZM12.1553 6.21966C12.4482 6.51256 12.4482 6.98743 12.1553 7.28032L8.78033 10.6553C8.48744 10.9482 8.01256 10.9482 7.71967 10.6553L6.21967 9.15532C5.92678 8.86243 5.92678 8.38756 6.21967 8.09466C6.51256 7.80177 6.98744 7.80177 7.28033 8.09466L8.25 9.06433L11.0947 6.21966C11.3876 5.92677 11.8624 5.92677 12.1553 6.21966Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$ee0b034933fb5fa2$var$ShieldCheckIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$ee0b034933fb5fa2$var$ShieldCheckIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$ee0b034933fb5fa2$var$ShieldCheckIcon.displayName = "ShieldCheckIcon";
var $dfd33cee3229493c$var$$ee0b034933fb5fa2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ee0b034933fb5fa2$var$ShieldCheckIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``shield-off.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$7b34b566e7853278$var$ShieldOffIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "",
                d: "M9.00001 17.175C8.88751 17.175 8.78251 17.1675 8.68501 17.145C8.45251 17.0925 8.28751 17.0025 8.10001 16.89C6.34501 15.8625 2.25001 13.05 2.25001 9.03V4.3575C2.25001 4.0725 2.33251 3.795 2.46751 3.555L1.71751 2.805C1.42501 2.5125 1.42501 2.04 1.71751 1.7475C2.01001 1.455 2.48251 1.455 2.77501 1.7475L16.2825 15.2475C16.575 15.54 16.575 16.0125 16.2825 16.305C15.99 16.5975 15.5175 16.5975 15.225 16.305L13.245 14.325C12.03 15.5625 10.6725 16.44 9.90751 16.8825C9.72001 16.995 9.55501 17.0925 9.31501 17.1375C9.21751 17.16 9.11251 17.1675 9.00001 17.1675V17.175ZM3.75001 4.8375V9.03C3.75001 12.36 7.65751 14.895 8.85751 15.5925C8.92501 15.63 8.97001 15.66 9.01501 15.6825C9.03001 15.6675 9.07501 15.6375 9.14251 15.5925C9.84001 15.1875 11.085 14.385 12.18 13.2675L3.75001 4.8375ZM14.76 11.3325C14.685 11.3325 14.61 11.325 14.5425 11.3025C14.145 11.1825 13.9275 10.7625 14.0475 10.365C14.1825 9.9225 14.25 9.4725 14.25 9.03V5.4375C14.25 4.965 14.25 4.6725 14.1975 4.545C14.1525 4.4325 14.085 4.3275 13.995 4.245C13.89 4.155 13.6275 4.0575 13.185 3.8925L9.15751 2.385C9.07501 2.355 9.03001 2.3325 8.98501 2.325C8.97001 2.3325 8.92501 2.355 8.84251 2.385L6.87001 3.1275C6.48001 3.27 6.05251 3.075 5.90251 2.6925C5.75251 2.31 5.95501 1.875 6.33751 1.725L8.31001 0.982499C8.49751 0.914999 8.61751 0.869999 8.77501 0.847499C8.92501 0.824999 9.06751 0.824999 9.20251 0.847499C9.36001 0.869999 9.48751 0.914999 9.66001 0.982499L13.695 2.4975C14.325 2.7375 14.6625 2.865 14.9775 3.135C15.255 3.375 15.465 3.6825 15.5925 4.0275C15.7425 4.41 15.7425 4.7775 15.7425 5.4525V9.0375C15.7425 9.63 15.6525 10.2225 15.4725 10.815C15.375 11.1375 15.075 11.3475 14.7525 11.3475L14.76 11.3325Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$7b34b566e7853278$var$ShieldOffIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$7b34b566e7853278$var$ShieldOffIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$7b34b566e7853278$var$ShieldOffIcon.displayName = "ShieldOffIcon";
var $dfd33cee3229493c$var$$7b34b566e7853278$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7b34b566e7853278$var$ShieldOffIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``shield-plus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$66961b15ca10f609$var$ShieldPlusIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.78548 0.816414C8.92775 0.795855 9.07225 0.795855 9.21452 0.816414C9.3785 0.840109 9.53108 0.897751 9.65223 0.94352C9.66332 0.947709 9.67414 0.951798 9.68469 0.955753L13.706 2.46376C13.739 2.47611 13.7716 2.4883 13.804 2.50039C14.2674 2.67338 14.6743 2.8253 14.9876 3.10147C15.2618 3.34306 15.4729 3.64778 15.6029 3.98929C15.7514 4.37967 15.7508 4.81401 15.7501 5.30859C15.7501 5.34316 15.75 5.37803 15.75 5.4132V8.99999C15.75 11.12 14.597 12.8874 13.3507 14.1858C12.096 15.4929 10.6605 16.4161 9.90143 16.859C9.89141 16.8648 9.88117 16.8708 9.87069 16.877C9.73217 16.9583 9.55238 17.0639 9.31452 17.1149C9.11993 17.1566 8.88007 17.1566 8.68548 17.1149C8.44762 17.0639 8.26783 16.9583 8.1293 16.877C8.11883 16.8708 8.10859 16.8648 8.09858 16.859C7.3395 16.4161 5.90397 15.4929 4.64929 14.1858C3.40297 12.8874 2.25 11.12 2.25 8.99999V5.4132C2.25 5.37803 2.24995 5.34316 2.2499 5.30859C2.24918 4.81401 2.24855 4.37967 2.39711 3.98929C2.52706 3.64778 2.73823 3.34306 3.01237 3.10147C3.32573 2.8253 3.73264 2.67338 4.19598 2.50039C4.22837 2.4883 4.26103 2.47611 4.29396 2.46376L8.31531 0.955753C8.32586 0.951798 8.33668 0.947709 8.34777 0.943519C8.46892 0.89775 8.6215 0.840109 8.78548 0.816414ZM8.99774 2.30345C8.9671 2.31349 8.92555 2.32891 8.84199 2.36025L4.82065 3.86825C4.20172 4.10035 4.08261 4.15765 4.00412 4.22682C3.91274 4.30735 3.84235 4.40892 3.79904 4.52276C3.76183 4.62053 3.75 4.75218 3.75 5.4132V8.99999C3.75 10.5614 4.60477 11.9733 5.73144 13.1471C6.84975 14.3121 8.15248 15.1538 8.85444 15.5633C8.89734 15.5884 8.92829 15.6064 8.9552 15.6215C8.97632 15.6334 8.99037 15.6409 9 15.6458C9.00963 15.6409 9.02369 15.6334 9.0448 15.6215C9.07171 15.6064 9.10266 15.5884 9.14556 15.5633C9.84752 15.1538 11.1502 14.3121 12.2686 13.1471C13.3952 11.9733 14.25 10.5614 14.25 8.99999V5.4132C14.25 4.75218 14.2382 4.62053 14.201 4.52276C14.1576 4.40892 14.0873 4.30735 13.9959 4.22682C13.9174 4.15765 13.7983 4.10035 13.1794 3.86825L9.15801 2.36025C9.07445 2.32891 9.0329 2.31349 9.00226 2.30345C9.00148 2.30319 9.00072 2.30295 9 2.30271C8.99928 2.30295 8.99852 2.30319 8.99774 2.30345ZM9 5.62499C9.41421 5.62499 9.75 5.96078 9.75 6.37499V7.87499H11.25C11.6642 7.87499 12 8.21078 12 8.62499C12 9.03921 11.6642 9.37499 11.25 9.37499H9.75V10.875C9.75 11.2892 9.41421 11.625 9 11.625C8.58579 11.625 8.25 11.2892 8.25 10.875V9.37499H6.75C6.33579 9.37499 6 9.03921 6 8.62499C6 8.21078 6.33579 7.87499 6.75 7.87499H8.25V6.37499C8.25 5.96078 8.58579 5.62499 9 5.62499Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$66961b15ca10f609$var$ShieldPlusIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$66961b15ca10f609$var$ShieldPlusIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$66961b15ca10f609$var$ShieldPlusIcon.displayName = "ShieldPlusIcon";
var $dfd33cee3229493c$var$$66961b15ca10f609$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$66961b15ca10f609$var$ShieldPlusIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``shield.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$147df14d628cc88d$var$ShieldIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.78548 0.816414C8.92775 0.795855 9.07225 0.795855 9.21452 0.816414C9.3785 0.840109 9.53108 0.897751 9.65223 0.94352C9.66332 0.947709 9.67414 0.951798 9.68469 0.955753L13.706 2.46376C13.739 2.47611 13.7716 2.4883 13.804 2.50039C14.2674 2.67338 14.6743 2.8253 14.9876 3.10147C15.2618 3.34306 15.4729 3.64778 15.6029 3.98929C15.7514 4.37967 15.7508 4.81401 15.7501 5.30859C15.7501 5.34316 15.75 5.37803 15.75 5.4132V8.99999C15.75 11.12 14.597 12.8874 13.3507 14.1858C12.096 15.4929 10.6605 16.4161 9.90143 16.859C9.89141 16.8648 9.88117 16.8708 9.87069 16.877C9.73217 16.9583 9.55238 17.0639 9.31452 17.1149C9.11993 17.1566 8.88007 17.1566 8.68548 17.1149C8.44762 17.0639 8.26783 16.9583 8.1293 16.877C8.11883 16.8708 8.10859 16.8648 8.09858 16.859C7.3395 16.4161 5.90397 15.4929 4.64929 14.1858C3.40297 12.8874 2.25 11.12 2.25 8.99999V5.4132C2.25 5.37803 2.24995 5.34316 2.2499 5.30859C2.24918 4.81401 2.24855 4.37967 2.39711 3.98929C2.52706 3.64778 2.73823 3.34306 3.01237 3.10147C3.32573 2.8253 3.73264 2.67338 4.19598 2.50039C4.22837 2.4883 4.26103 2.47611 4.29396 2.46376L8.31531 0.955753C8.32586 0.951798 8.33668 0.947709 8.34777 0.943519C8.46892 0.89775 8.6215 0.840109 8.78548 0.816414ZM8.99774 2.30345C8.9671 2.31349 8.92555 2.32891 8.84199 2.36025L4.82065 3.86825C4.20172 4.10035 4.08261 4.15765 4.00412 4.22682C3.91274 4.30735 3.84235 4.40892 3.79904 4.52276C3.76183 4.62053 3.75 4.75218 3.75 5.4132V8.99999C3.75 10.5614 4.60477 11.9733 5.73144 13.1471C6.84975 14.3121 8.15248 15.1538 8.85444 15.5633C8.89734 15.5884 8.92829 15.6064 8.9552 15.6215C8.97632 15.6334 8.99037 15.6409 9 15.6458C9.00963 15.6409 9.02369 15.6334 9.0448 15.6215C9.07171 15.6064 9.10266 15.5884 9.14556 15.5633C9.84752 15.1538 11.1502 14.3121 12.2686 13.1471C13.3952 11.9733 14.25 10.5614 14.25 8.99999V5.4132C14.25 4.75218 14.2382 4.62053 14.201 4.52276C14.1576 4.40892 14.0873 4.30735 13.9959 4.22682C13.9174 4.15765 13.7983 4.10035 13.1794 3.86825L9.15801 2.36025C9.07445 2.32891 9.0329 2.31349 9.00226 2.30345C9.00148 2.30319 9.00072 2.30295 9 2.30271C8.99928 2.30295 8.99852 2.30319 8.99774 2.30345Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$147df14d628cc88d$var$ShieldIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$147df14d628cc88d$var$ShieldIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$147df14d628cc88d$var$ShieldIcon.displayName = "ShieldIcon";
var $dfd33cee3229493c$var$$147df14d628cc88d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$147df14d628cc88d$var$ShieldIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``signal.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b7e33483ea5f2267$var$SignalIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M13.773 4.22703C11.1369 1.59099 6.86307 1.59099 4.22703 4.22703C1.59099 6.86307 1.59099 11.1369 4.22703 13.773C4.51992 14.0659 4.51992 14.5407 4.22703 14.8336C3.93414 15.1265 3.45926 15.1265 3.16637 14.8336C-0.0554559 11.6118 -0.0554566 6.38819 3.16637 3.16637C6.38819 -0.0554563 11.6118 -0.0554563 14.8336 3.16637C18.0555 6.38819 18.0555 11.6118 14.8336 14.8336C14.5407 15.1265 14.0659 15.1265 13.773 14.8336C13.4801 14.5407 13.4801 14.0659 13.773 13.773C16.409 11.1369 16.409 6.86307 13.773 4.22703ZM11.6517 6.34835C10.1872 4.88388 7.81282 4.88388 6.34835 6.34835C4.88388 7.81281 4.88388 10.1872 6.34835 11.6517C6.64124 11.9445 6.64124 12.4194 6.34835 12.7123C6.05546 13.0052 5.58058 13.0052 5.28769 12.7123C3.23744 10.6621 3.23744 7.33794 5.28769 5.28769C7.33794 3.23744 10.6621 3.23744 12.7123 5.28769C14.7626 7.33794 14.7626 10.6621 12.7123 12.7123C12.4194 13.0052 11.9445 13.0052 11.6517 12.7123C11.3588 12.4194 11.3588 11.9445 11.6517 11.6517C13.1161 10.1872 13.1161 7.81281 11.6517 6.34835ZM9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033C8.76256 9.82322 8.76256 10.2981 8.46967 10.591C8.17678 10.8839 7.7019 10.8839 7.40901 10.591C6.53033 9.71231 6.53033 8.28769 7.40901 7.40901C8.28769 6.53033 9.71231 6.53033 10.591 7.40901C11.4697 8.28769 11.4697 9.71231 10.591 10.591C10.2981 10.8839 9.82322 10.8839 9.53033 10.591C9.23744 10.2981 9.23744 9.82322 9.53033 9.53033C9.82322 9.23744 9.82322 8.76256 9.53033 8.46967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b7e33483ea5f2267$var$SignalIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b7e33483ea5f2267$var$SignalIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b7e33483ea5f2267$var$SignalIcon.displayName = "SignalIcon";
var $dfd33cee3229493c$var$$b7e33483ea5f2267$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b7e33483ea5f2267$var$SignalIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``slash-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$991a7cae02b2598d$var$SlashCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.72608 4.78674C2.80235 5.94149 2.25 7.40624 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C10.5938 15.75 12.0585 15.1976 13.2133 14.2739L3.72608 4.78674ZM4.78674 3.72608L14.2739 13.2133C15.1976 12.0585 15.75 10.5938 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C7.40624 2.25 5.94149 2.80235 4.78674 3.72608ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$991a7cae02b2598d$var$SlashCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$991a7cae02b2598d$var$SlashCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$991a7cae02b2598d$var$SlashCircleIcon.displayName = "SlashCircleIcon";
var $dfd33cee3229493c$var$$991a7cae02b2598d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$991a7cae02b2598d$var$SlashCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``slash.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$32234019b34bf4f6$var$SlashIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M13.0854 0.829176C13.4559 1.01442 13.606 1.46492 13.4208 1.83541L5.9208 16.8354C5.73556 17.2059 5.28506 17.3561 4.91457 17.1708C4.54409 16.9856 4.39392 16.5351 4.57916 16.1646L12.0792 1.16459C12.2644 0.794102 12.7149 0.643934 13.0854 0.829176Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$32234019b34bf4f6$var$SlashIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$32234019b34bf4f6$var$SlashIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$32234019b34bf4f6$var$SlashIcon.displayName = "SlashIcon";
var $dfd33cee3229493c$var$$32234019b34bf4f6$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$32234019b34bf4f6$var$SlashIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``sliders.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$57f2b06fd58bbe57$var$SlidersIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.75 1.5C4.16421 1.5 4.5 1.83579 4.5 2.25V5.25C4.5 5.66421 4.16421 6 3.75 6C3.33579 6 3 5.66421 3 5.25V2.25C3 1.83579 3.33579 1.5 3.75 1.5ZM9 1.5C9.41421 1.5 9.75 1.83579 9.75 2.25V4.62803C10.6239 4.93691 11.25 5.77034 11.25 6.75C11.25 7.99264 10.2426 9 9 9C7.75736 9 6.75 7.99264 6.75 6.75C6.75 5.77034 7.37611 4.93691 8.25 4.62803V2.25C8.25 1.83579 8.58579 1.5 9 1.5ZM14.25 1.5C14.6642 1.5 15 1.83579 15 2.25V6.75C15 7.16421 14.6642 7.5 14.25 7.5C13.8358 7.5 13.5 7.16421 13.5 6.75V2.25C13.5 1.83579 13.8358 1.5 14.25 1.5ZM9 6C8.58579 6 8.25 6.33579 8.25 6.75C8.25 7.16421 8.58579 7.5 9 7.5C9.41421 7.5 9.75 7.16421 9.75 6.75C9.75 6.33579 9.41421 6 9 6ZM3.75 9C3.33579 9 3 9.33579 3 9.75C3 10.1642 3.33579 10.5 3.75 10.5C4.16421 10.5 4.5 10.1642 4.5 9.75C4.5 9.33579 4.16421 9 3.75 9ZM1.5 9.75C1.5 8.50736 2.50736 7.5 3.75 7.5C4.99264 7.5 6 8.50736 6 9.75C6 10.7297 5.37389 11.5631 4.5 11.872V15.75C4.5 16.1642 4.16421 16.5 3.75 16.5C3.33579 16.5 3 16.1642 3 15.75L3 11.872C2.12611 11.5631 1.5 10.7297 1.5 9.75ZM14.25 10.5C13.8358 10.5 13.5 10.8358 13.5 11.25C13.5 11.6642 13.8358 12 14.25 12C14.6642 12 15 11.6642 15 11.25C15 10.8358 14.6642 10.5 14.25 10.5ZM12 11.25C12 10.0074 13.0074 9 14.25 9C15.4926 9 16.5 10.0074 16.5 11.25C16.5 12.2297 15.8739 13.0631 15 13.372V15.75C15 16.1642 14.6642 16.5 14.25 16.5C13.8358 16.5 13.5 16.1642 13.5 15.75V13.372C12.6261 13.0631 12 12.2297 12 11.25ZM9 10.5C9.41421 10.5 9.75 10.8358 9.75 11.25V15.75C9.75 16.1642 9.41421 16.5 9 16.5C8.58579 16.5 8.25 16.1642 8.25 15.75V11.25C8.25 10.8358 8.58579 10.5 9 10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$57f2b06fd58bbe57$var$SlidersIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$57f2b06fd58bbe57$var$SlidersIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$57f2b06fd58bbe57$var$SlidersIcon.displayName = "SlidersIcon";
var $dfd33cee3229493c$var$$57f2b06fd58bbe57$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$57f2b06fd58bbe57$var$SlidersIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``sort.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$3f03f07f1b719193$var$SortIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4.71967 2.46967C5.01256 2.17678 5.48744 2.17678 5.78033 2.46967L8.78033 5.46967C9.07322 5.76256 9.07322 6.23744 8.78033 6.53033C8.48744 6.82322 8.01256 6.82322 7.71967 6.53033L6 4.81066V15C6 15.4142 5.66421 15.75 5.25 15.75C4.83579 15.75 4.5 15.4142 4.5 15V4.81066L2.78033 6.53033C2.48744 6.82322 2.01256 6.82322 1.71967 6.53033C1.42678 6.23744 1.42678 5.76256 1.71967 5.46967L4.71967 2.46967ZM12 13.1893V3C12 2.58579 12.3358 2.25 12.75 2.25C13.1642 2.25 13.5 2.58579 13.5 3V13.1893L15.2197 11.4697C15.5126 11.1768 15.9874 11.1768 16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L13.2803 15.5303C12.9874 15.8232 12.5126 15.8232 12.2197 15.5303L9.21967 12.5303C8.92678 12.2374 8.92678 11.7626 9.21967 11.4697C9.51256 11.1768 9.98744 11.1768 10.2803 11.4697L12 13.1893Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$3f03f07f1b719193$var$SortIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$3f03f07f1b719193$var$SortIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$3f03f07f1b719193$var$SortIcon.displayName = "SortIcon";
var $dfd33cee3229493c$var$$3f03f07f1b719193$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3f03f07f1b719193$var$SortIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``speedometer.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$118dc467b8b60f5d$var$SpeedometerIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M2.2912 8.25H3.375C3.78921 8.25 4.125 8.58579 4.125 9C4.125 9.41421 3.78921 9.75 3.375 9.75H2.2912C2.43511 11.0519 2.94929 12.2422 3.72609 13.2133L4.49253 12.4468C4.78543 12.154 5.2603 12.154 5.55319 12.4468C5.84609 12.7397 5.84609 13.2146 5.55319 13.5075L4.78676 14.2739C5.75783 15.0507 6.94812 15.5649 8.25 15.7088V14.625C8.25 14.2108 8.58579 13.875 9 13.875C9.41421 13.875 9.75 14.2108 9.75 14.625V15.7088C11.0519 15.5649 12.2422 15.0507 13.2133 14.2739L12.4482 13.5088C12.1553 13.216 12.1553 12.7411 12.4482 12.4482C12.7411 12.1553 13.216 12.1553 13.5088 12.4482L14.2739 13.2133C15.0507 12.2422 15.5649 11.0519 15.7088 9.75H14.625C14.2108 9.75 13.875 9.41421 13.875 9C13.875 8.58579 14.2108 8.25 14.625 8.25H15.7088C15.5663 6.96083 15.0607 5.78108 14.2966 4.81526L11.0324 8.0335C11.1719 8.32632 11.25 8.65404 11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C9.34876 6.75 9.67898 6.82935 9.9736 6.97098L13.2417 3.74892C12.2654 2.95936 11.0646 2.43652 9.75 2.2912V3.375C9.75 3.78921 9.41421 4.125 9 4.125C8.58579 4.125 8.25 3.78921 8.25 3.375V2.2912C6.93352 2.43673 5.73115 2.96085 4.75417 3.75229L5.52389 4.52201C5.81678 4.8149 5.81678 5.28977 5.52389 5.58267C5.231 5.87556 4.75612 5.87556 4.46323 5.58267L3.70005 4.81948C2.9378 5.78452 2.4335 6.96271 2.2912 8.25ZM14.9136 14.7526C16.3595 13.2665 17.25 11.2372 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 11.2373 1.64059 13.2666 3.08659 14.7528C3.10881 14.7829 3.13358 14.8118 3.16089 14.8392C3.18821 14.8665 3.21711 14.8912 3.24729 14.9135C4.73342 16.3594 6.76271 17.25 9 17.25C11.2372 17.25 13.2665 16.3595 14.7526 14.9136C14.7828 14.8913 14.8118 14.8665 14.8392 14.8392C14.8665 14.8118 14.8913 14.7828 14.9136 14.7526ZM9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$118dc467b8b60f5d$var$SpeedometerIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$118dc467b8b60f5d$var$SpeedometerIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$118dc467b8b60f5d$var$SpeedometerIcon.displayName = "SpeedometerIcon";
var $dfd33cee3229493c$var$$118dc467b8b60f5d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$118dc467b8b60f5d$var$SpeedometerIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``square.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$43682b5cb6a1674a$var$SquareIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.81903 1.5H12.181C12.7847 1.49999 13.283 1.49998 13.6889 1.53315C14.1104 1.56759 14.498 1.64151 14.862 1.82698C15.4265 2.1146 15.8854 2.57354 16.173 3.13803C16.3585 3.50203 16.4324 3.88956 16.4669 4.31113C16.5 4.71702 16.5 5.21529 16.5 5.81901V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V5.81903C1.49999 5.2153 1.49998 4.71703 1.53315 4.31113C1.56759 3.88956 1.64151 3.50203 1.82698 3.13803C2.1146 2.57354 2.57354 2.1146 3.13803 1.82698C3.50203 1.64151 3.88956 1.56759 4.31113 1.53315C4.71703 1.49998 5.2153 1.49999 5.81903 1.5ZM4.43328 3.02816C4.10447 3.05503 3.93631 3.10372 3.81902 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81902C3.10372 3.93631 3.05503 4.10447 3.02816 4.43328C3.00058 4.77085 3 5.20757 3 5.85V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V5.85C15 5.20757 14.9994 4.77085 14.9718 4.43328C14.945 4.10447 14.8963 3.93631 14.8365 3.81902C14.6927 3.53677 14.4632 3.3073 14.181 3.16349C14.0637 3.10372 13.8955 3.05503 13.5667 3.02816C13.2292 3.00058 12.7924 3 12.15 3H5.85C5.20757 3 4.77085 3.00058 4.43328 3.02816Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$43682b5cb6a1674a$var$SquareIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$43682b5cb6a1674a$var$SquareIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$43682b5cb6a1674a$var$SquareIcon.displayName = "SquareIcon";
var $dfd33cee3229493c$var$$43682b5cb6a1674a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$43682b5cb6a1674a$var$SquareIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``star.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$5534c0ecbb646332$var$StarIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.51583 1.33174C8.82209 1.18572 9.17791 1.18572 9.48417 1.33174C9.74893 1.45798 9.89491 1.67716 9.96853 1.7974C10.0446 1.9217 10.1228 2.08006 10.1989 2.2344C10.2028 2.24228 10.2067 2.25015 10.2106 2.25801L11.8157 5.50985L15.4322 6.03846C15.6025 6.06331 15.7772 6.0888 15.9188 6.12287C16.0559 6.15584 16.3093 6.22712 16.511 6.44C16.7443 6.68628 16.8541 7.02469 16.8097 7.36102C16.7713 7.65174 16.6079 7.85818 16.5162 7.9653C16.4215 8.07602 16.295 8.19916 16.1718 8.31917L13.5559 10.867L14.1731 14.4657C14.2022 14.6354 14.2321 14.8095 14.2437 14.9548C14.2548 15.0954 14.2655 15.3585 14.1255 15.6163C13.9635 15.9145 13.6756 16.1237 13.342 16.1855C13.0535 16.239 12.8066 16.1474 12.6763 16.0934C12.5417 16.0375 12.3854 15.9553 12.233 15.8751L9 14.1749L5.767 15.8751C5.61463 15.9553 5.45832 16.0375 5.32366 16.0934C5.19343 16.1474 4.94647 16.239 4.65801 16.1855C4.32436 16.1237 4.03645 15.9145 3.87448 15.6163C3.73446 15.3585 3.74522 15.0954 3.75635 14.9548C3.76786 14.8095 3.79775 14.6354 3.82689 14.4657L4.44411 10.867L1.84711 8.33755C1.84084 8.33144 1.83456 8.32532 1.82826 8.3192C1.70499 8.19918 1.5785 8.07603 1.48376 7.9653C1.39211 7.85818 1.22873 7.65174 1.19034 7.36102C1.14592 7.02469 1.25565 6.68628 1.48897 6.44C1.69065 6.22712 1.94408 6.15584 2.08115 6.12287C2.22284 6.0888 2.39753 6.06331 2.56777 6.03846C2.57646 6.03719 2.58514 6.03592 2.5938 6.03466L6.1843 5.50985L7.78944 2.25801C7.79332 2.25015 7.79721 2.24228 7.8011 2.2344C7.87724 2.08006 7.95537 1.9217 8.03147 1.7974C8.10509 1.67716 8.25106 1.45798 8.51583 1.33174ZM6.10674 5.66514C6.10664 5.66533 6.10664 5.66533 6.10674 5.66514V5.66514ZM6.35593 5.48394C6.35614 5.4839 6.35614 5.4839 6.35593 5.48394V5.48394ZM13.5273 10.6955C13.5273 10.6953 13.5273 10.6953 13.5273 10.6955V10.6955ZM9 3.19444L7.4945 6.24442C7.49162 6.25026 7.48834 6.25705 7.48465 6.26468C7.44892 6.33867 7.37492 6.49187 7.25758 6.61817C7.15852 6.72478 7.03973 6.81116 6.90777 6.87252C6.75145 6.94522 6.5829 6.96838 6.5015 6.97957C6.4931 6.98072 6.48563 6.98175 6.47919 6.98269L3.11131 7.47495L5.54723 9.84754C5.55189 9.85208 5.55735 9.8573 5.56348 9.86318C5.62291 9.92008 5.74598 10.0379 5.82997 10.1887C5.90085 10.3161 5.94633 10.4559 5.96387 10.6006C5.98465 10.772 5.95441 10.9396 5.93981 11.0206C5.9383 11.029 5.93696 11.0364 5.93586 11.0428L5.36113 14.3938L8.37164 12.8106C8.3774 12.8075 8.38406 12.804 8.39154 12.7999C8.46402 12.761 8.61411 12.6804 8.78349 12.6472C8.92647 12.6192 9.07353 12.6192 9.21651 12.6472C9.38589 12.6804 9.53598 12.761 9.60846 12.7999C9.61594 12.804 9.62259 12.8075 9.62836 12.8106L12.6389 14.3938L12.0641 11.0428C12.063 11.0364 12.0617 11.029 12.0602 11.0206C12.0456 10.9396 12.0153 10.772 12.0361 10.6006C12.0537 10.4559 12.0991 10.3161 12.17 10.1887C12.254 10.0379 12.3771 9.92008 12.4365 9.86318C12.4426 9.85731 12.4481 9.85208 12.4528 9.84754L14.8887 7.47495L11.5208 6.98269C11.5144 6.98175 11.5069 6.98072 11.4985 6.97957C11.4171 6.96838 11.2486 6.94522 11.0922 6.87252C10.9603 6.81116 10.8415 6.72478 10.7424 6.61817C10.6251 6.49187 10.5511 6.33867 10.5153 6.26468C10.5117 6.25705 10.5084 6.25026 10.5055 6.24442L9 3.19444Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$5534c0ecbb646332$var$StarIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$5534c0ecbb646332$var$StarIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$5534c0ecbb646332$var$StarIcon.displayName = "StarIcon";
var $dfd33cee3229493c$var$$5534c0ecbb646332$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5534c0ecbb646332$var$StarIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``sun.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$cfef798d67f41737$var$SunIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V3C9.75 3.41421 9.41421 3.75 9 3.75C8.58579 3.75 8.25 3.41421 8.25 3V1.5C8.25 1.08579 8.58579 0.75 9 0.75ZM3.1446 3.1446C3.43749 2.8517 3.91236 2.8517 4.20526 3.1446L5.26592 4.20526C5.55881 4.49815 5.55881 4.97302 5.26592 5.26592C4.97302 5.55881 4.49815 5.55881 4.20526 5.26592L3.1446 4.20526C2.8517 3.91236 2.8517 3.43749 3.1446 3.1446ZM14.8554 3.1446C15.1483 3.43749 15.1483 3.91236 14.8554 4.20526L13.7947 5.26592C13.5019 5.55881 13.027 5.55881 12.7341 5.26592C12.4412 4.97302 12.4412 4.49815 12.7341 4.20526L13.7947 3.1446C14.0876 2.8517 14.5625 2.8517 14.8554 3.1446ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6ZM4.5 9C4.5 6.51472 6.51472 4.5 9 4.5C11.4853 4.5 13.5 6.51472 13.5 9C13.5 11.4853 11.4853 13.5 9 13.5C6.51472 13.5 4.5 11.4853 4.5 9ZM0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H3C3.41421 8.25 3.75 8.58579 3.75 9C3.75 9.41421 3.41421 9.75 3 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9ZM14.25 9C14.25 8.58579 14.5858 8.25 15 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H15C14.5858 9.75 14.25 9.41421 14.25 9ZM5.26592 12.7372C5.55881 13.0301 5.55881 13.5049 5.26592 13.7978L4.20526 14.8585C3.91236 15.1514 3.43749 15.1514 3.1446 14.8585C2.8517 14.5656 2.8517 14.0907 3.1446 13.7978L4.20526 12.7372C4.49815 12.4443 4.97302 12.4443 5.26592 12.7372ZM12.7341 12.7372C13.027 12.4443 13.5019 12.4443 13.7947 12.7372L14.8554 13.7978C15.1483 14.0907 15.1483 14.5656 14.8554 14.8585C14.5625 15.1514 14.0876 15.1514 13.7947 14.8585L12.7341 13.7978C12.4412 13.5049 12.4412 13.0301 12.7341 12.7372ZM9 14.25C9.41421 14.25 9.75 14.5858 9.75 15V16.5C9.75 16.9142 9.41421 17.25 9 17.25C8.58579 17.25 8.25 16.9142 8.25 16.5V15C8.25 14.5858 8.58579 14.25 9 14.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$cfef798d67f41737$var$SunIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cfef798d67f41737$var$SunIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$cfef798d67f41737$var$SunIcon.displayName = "SunIcon";
var $dfd33cee3229493c$var$$cfef798d67f41737$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cfef798d67f41737$var$SunIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``target.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$89f870dfc8512ab5$var$TargetIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M14.3701 0.759686C14.6081 0.798303 14.813 0.94896 14.9208 1.16459L15.559 2.44098L16.8354 3.07918C17.051 3.187 17.2017 3.39189 17.2403 3.62986C17.2789 3.86783 17.2008 4.10986 17.0303 4.28033L14.7803 6.53033C14.6396 6.67098 14.4489 6.75 14.25 6.75H12.3106L9.5303 9.53029C9.23741 9.82318 8.76254 9.82318 8.46965 9.53029C8.17675 9.23739 8.17676 8.76252 8.46965 8.46963L11.25 5.68934V3.75C11.25 3.55109 11.329 3.36032 11.4696 3.21967L13.7196 0.969671C13.8901 0.7992 14.1321 0.721069 14.3701 0.759686ZM12.75 5.25H13.9393L15.2338 3.95546L14.6646 3.67082C14.5194 3.59825 14.4017 3.48056 14.3291 3.33541L14.0445 2.76612L12.75 4.06066V5.25ZM9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 8.58579 16.0858 8.25 16.5 8.25C16.9142 8.25 17.25 8.58579 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.750001 9 0.750001C9.41421 0.750001 9.75 1.08579 9.75 1.5C9.75 1.91421 9.41421 2.25 9 2.25ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 8.58579 12.3358 8.25 12.75 8.25C13.1642 8.25 13.5 8.58579 13.5 9C13.5 11.4853 11.4853 13.5 9 13.5C6.51472 13.5 4.5 11.4853 4.5 9C4.5 6.51472 6.51472 4.5 9 4.5C9.41421 4.5 9.75 4.83579 9.75 5.25C9.75 5.66421 9.41421 6 9 6Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$89f870dfc8512ab5$var$TargetIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$89f870dfc8512ab5$var$TargetIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$89f870dfc8512ab5$var$TargetIcon.displayName = "TargetIcon";
var $dfd33cee3229493c$var$$89f870dfc8512ab5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$89f870dfc8512ab5$var$TargetIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``thumbs-down.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$114d36f778f054e3$var$ThumbsDownIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M15.0241 2.26795C14.8116 2.25058 14.5324 2.25 14.1 2.25H13.5V8.99995C13.5101 8.99998 13.52 9 13.5298 9H14.1C14.5324 9 14.8116 8.99942 15.0241 8.98206C15.2279 8.96541 15.3034 8.93715 15.3405 8.91826C15.4816 8.84635 15.5964 8.73162 15.6683 8.59049C15.6871 8.55341 15.7154 8.47787 15.7321 8.27412C15.7494 8.06162 15.75 7.78242 15.75 7.35V3.9C15.75 3.46759 15.7494 3.18838 15.7321 2.97588C15.7154 2.77213 15.6871 2.69659 15.6683 2.65951C15.5964 2.51839 15.4816 2.40365 15.3405 2.33175C15.3034 2.31285 15.2279 2.28459 15.0241 2.26795ZM12 9.65835V2.25H6.08851C5.52909 2.25 5.1513 2.2505 4.85698 2.27291C4.57204 2.2946 4.42124 2.33387 4.31123 2.38372C4.05114 2.50157 3.83009 2.69121 3.67406 2.93036C3.60806 3.03151 3.54632 3.17458 3.48155 3.45291C3.41465 3.7404 3.35671 4.11372 3.27165 4.66664L2.87934 7.21664C2.76741 7.94421 2.69139 8.44259 2.6656 8.82948C2.64028 9.20919 2.67068 9.40234 2.72111 9.53456C2.84518 9.85985 3.07853 10.1318 3.38117 10.3039C3.50418 10.3739 3.69047 10.4333 4.06961 10.466C4.45592 10.4993 4.96007 10.5 5.6962 10.5L6.32391 10.5C6.5132 10.5 6.69755 10.5 6.85367 10.5127C7.02512 10.5267 7.22742 10.5598 7.43098 10.6635C7.71323 10.8073 7.9427 11.0368 8.08651 11.319C8.19023 11.5226 8.22328 11.7249 8.23729 11.8963C8.25005 12.0525 8.25002 12.2368 8.25 12.4261L8.25 14.6506C8.25 15.2291 8.69675 15.7032 9.26404 15.7467L11.7479 10.158C11.7558 10.1404 11.7638 10.1221 11.772 10.1035C11.8318 9.96755 11.902 9.80776 12 9.65835ZM14.1289 0.750001C14.5243 0.749987 14.8653 0.749976 15.1463 0.772928C15.4428 0.797154 15.7377 0.850641 16.0215 0.995237C16.4448 1.21095 16.789 1.55516 17.0048 1.97852C17.1494 2.26231 17.2028 2.55722 17.2271 2.85373C17.25 3.13466 17.25 3.47572 17.25 3.87108V7.37893C17.25 7.77428 17.25 8.11535 17.2271 8.39627C17.2028 8.69278 17.1494 8.9877 17.0048 9.27148C16.789 9.69485 16.4448 10.0391 16.0215 10.2548C15.7377 10.3994 15.4428 10.4528 15.1463 10.4771C14.8653 10.5 14.5243 10.5 14.1289 10.5H13.5298C13.3793 10.5 13.3015 10.5004 13.2452 10.504C13.2435 10.5041 13.2418 10.5042 13.2402 10.5043C13.2395 10.5057 13.2387 10.5072 13.2379 10.5087C13.2117 10.5587 13.1798 10.6297 13.1186 10.7672L10.5981 16.4385C10.3787 16.932 9.88939 17.25 9.34938 17.25C7.91378 17.25 6.75 16.0862 6.75 14.6506V12.45C6.75 12.2276 6.74942 12.1059 6.74227 12.0185C6.74199 12.015 6.7417 12.0117 6.74141 12.0086C6.7383 12.0083 6.73501 12.008 6.73152 12.0077C6.64408 12.0006 6.52239 12 6.3 12H5.66263C4.96831 12 4.39913 12 3.94066 11.9605C3.46765 11.9197 3.0339 11.832 2.63971 11.6079C2.03444 11.2637 1.56773 10.7197 1.31959 10.0691C1.15799 9.64543 1.13733 9.20341 1.16892 8.72969C1.19953 8.27053 1.28609 7.70798 1.39168 7.02173L1.79338 4.41067C1.87306 3.89269 1.93921 3.46264 2.02058 3.11295C2.10554 2.74785 2.21824 2.41658 2.4178 2.11072C2.72986 1.63242 3.17196 1.25314 3.69214 1.01743C4.02479 0.866706 4.36934 0.80569 4.74312 0.777237C5.10112 0.749985 5.53622 0.749992 6.0603 0.750001L14.1289 0.750001Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$114d36f778f054e3$var$ThumbsDownIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$114d36f778f054e3$var$ThumbsDownIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$114d36f778f054e3$var$ThumbsDownIcon.displayName = "ThumbsDownIcon";
var $dfd33cee3229493c$var$$114d36f778f054e3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$114d36f778f054e3$var$ThumbsDownIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``thumbs-up.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$d83713eaceeec7e4$var$ThumbsUpIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.40193 1.56149C7.62125 1.06802 8.11061 0.75 8.65062 0.75C10.0862 0.75 11.25 1.91378 11.25 3.34938V6H13.8774C15.716 6 17.1221 7.6389 16.8425 9.45617L16.0348 14.7062C15.8096 16.1697 14.5504 17.25 13.0697 17.25H3C1.75736 17.25 0.75 16.2426 0.75 15V9.75C0.75 8.50736 1.75736 7.5 3 7.5H4.76259L7.40193 1.56149ZM6 15.75H13.0697C13.81 15.75 14.4397 15.2098 14.5522 14.4781L15.3599 9.22809C15.4997 8.31945 14.7967 7.5 13.8774 7.5H11.25C10.4216 7.5 9.75 6.82843 9.75 6V3.34938C9.75 2.77092 9.30325 2.29681 8.73595 2.25326L6.13331 8.10921C6.09578 8.19366 6.05103 8.27344 6 8.34794V15.75ZM4.5 9V15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V9.75C2.25 9.33579 2.58579 9 3 9H4.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$d83713eaceeec7e4$var$ThumbsUpIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$d83713eaceeec7e4$var$ThumbsUpIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$d83713eaceeec7e4$var$ThumbsUpIcon.displayName = "ThumbsUpIcon";
var $dfd33cee3229493c$var$$d83713eaceeec7e4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$d83713eaceeec7e4$var$ThumbsUpIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``toggle-left.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$4f047bd87d52fd7e$var$ToggleLeftIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M0.75 9C0.75 6.10051 3.10051 3.75 6 3.75H12C14.8995 3.75 17.25 6.10051 17.25 9C17.25 11.8995 14.8995 14.25 12 14.25H6C3.10051 14.25 0.75 11.8995 0.75 9ZM6 5.25C3.92893 5.25 2.25 6.92893 2.25 9C2.25 11.0711 3.92893 12.75 6 12.75H12C14.0711 12.75 15.75 11.0711 15.75 9C15.75 6.92893 14.0711 5.25 12 5.25H6ZM6 7.875C5.37868 7.875 4.875 8.37868 4.875 9C4.875 9.62132 5.37868 10.125 6 10.125C6.62132 10.125 7.125 9.62132 7.125 9C7.125 8.37868 6.62132 7.875 6 7.875ZM3.375 9C3.375 7.55025 4.55025 6.375 6 6.375C7.44975 6.375 8.625 7.55025 8.625 9C8.625 10.4497 7.44975 11.625 6 11.625C4.55025 11.625 3.375 10.4497 3.375 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$4f047bd87d52fd7e$var$ToggleLeftIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$4f047bd87d52fd7e$var$ToggleLeftIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$4f047bd87d52fd7e$var$ToggleLeftIcon.displayName = "ToggleLeftIcon";
var $dfd33cee3229493c$var$$4f047bd87d52fd7e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4f047bd87d52fd7e$var$ToggleLeftIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``toggle-right.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a4f9bf3a51d78122$var$ToggleRightIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M0.75 9C0.75 6.10051 3.10051 3.75 6 3.75H12C14.8995 3.75 17.25 6.10051 17.25 9C17.25 11.8995 14.8995 14.25 12 14.25H6C3.10051 14.25 0.75 11.8995 0.75 9ZM6 5.25C3.92893 5.25 2.25 6.92893 2.25 9C2.25 11.0711 3.92893 12.75 6 12.75H12C14.0711 12.75 15.75 11.0711 15.75 9C15.75 6.92893 14.0711 5.25 12 5.25H6ZM12 7.875C11.3787 7.875 10.875 8.37868 10.875 9C10.875 9.62132 11.3787 10.125 12 10.125C12.6213 10.125 13.125 9.62132 13.125 9C13.125 8.37868 12.6213 7.875 12 7.875ZM9.375 9C9.375 7.55025 10.5503 6.375 12 6.375C13.4497 6.375 14.625 7.55025 14.625 9C14.625 10.4497 13.4497 11.625 12 11.625C10.5503 11.625 9.375 10.4497 9.375 9Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$a4f9bf3a51d78122$var$ToggleRightIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$a4f9bf3a51d78122$var$ToggleRightIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$a4f9bf3a51d78122$var$ToggleRightIcon.displayName = "ToggleRightIcon";
var $dfd33cee3229493c$var$$a4f9bf3a51d78122$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a4f9bf3a51d78122$var$ToggleRightIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``tool.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$2dfdce118f498a96$var$ToolIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M1.71966 0.969675C1.92053 0.768801 2.21766 0.698659 2.48716 0.788493L4.73716 1.53849C5.04342 1.64058 5.24999 1.92718 5.24999 2.25001V4.18934L7.58243 6.52179C7.52823 6.23057 7.49999 5.93076 7.49999 5.62501C7.49999 2.93262 9.6826 0.750005 12.375 0.750005C13.265 0.750005 14.1014 0.989187 14.821 1.40727C15.0223 1.52422 15.1579 1.72803 15.1879 1.95888C15.218 2.18974 15.1392 2.42147 14.9746 2.58609L13.0038 4.55681C12.8466 4.71406 12.761 4.80052 12.7042 4.8674C12.7019 4.87007 12.6998 4.8726 12.6978 4.87501C12.6998 4.87741 12.7019 4.87994 12.7042 4.8826C12.761 4.94948 12.8466 5.03594 13.0038 5.1932L13.1818 5.37115C13.339 5.5284 13.4255 5.61404 13.4924 5.67082C13.4951 5.67308 13.4976 5.6752 13.5 5.6772C13.5024 5.6752 13.5049 5.67308 13.5076 5.67082C13.5745 5.61404 13.6609 5.5284 13.8182 5.37115L15.6616 3.52771C15.839 3.35033 16.0933 3.27338 16.3393 3.32266C16.5853 3.37194 16.7903 3.54093 16.8857 3.77295C17.1207 4.34496 17.25 4.97083 17.25 5.62501C17.25 7.87846 15.721 9.7748 13.6439 10.3332L15.9053 12.5946C16.8195 13.5088 16.8195 14.991 15.9053 15.9053C14.9911 16.8195 13.5089 16.8195 12.5947 15.9053L9.00003 12.3106L5.40532 15.9053C4.49111 16.8195 3.00887 16.8195 2.09466 15.9053C1.18045 14.9911 1.18045 13.5089 2.09466 12.5947L6.81433 7.875L4.18933 5.25001H2.24999C1.92717 5.25001 1.64056 5.04343 1.53848 4.73718L0.788477 2.48718C0.698644 2.21767 0.768786 1.92055 0.96966 1.71968L1.71966 0.969675ZM3.74999 3.75001V2.79057L2.45256 2.3581L2.35808 2.45257L2.79056 3.75001H3.74999ZM8.40462 8.40604L3.15532 13.6553C2.82689 13.9838 2.82689 14.5162 3.15532 14.8447C3.48375 15.1731 4.01623 15.1731 4.34466 14.8447L9.71243 9.4769C9.72661 9.46272 9.74111 9.44813 9.75591 9.43322C9.7865 9.40242 9.81841 9.3703 9.85158 9.33776L9.9244 9.26493C10.0089 9.18046 10.0998 9.10915 10.1952 9.05005C10.2235 9.03169 10.2522 9.01453 10.2815 8.99887C10.3548 8.95967 10.4437 8.91649 10.5518 8.88359C10.6599 8.8507 10.7578 8.83704 10.8405 8.8288C10.8567 8.82719 10.8728 8.82597 10.8888 8.82508C11.0913 8.80833 11.293 8.82894 11.4791 8.88C11.5571 8.90141 11.6362 8.92009 11.7164 8.93593C11.7168 8.936 11.7171 8.93606 11.7174 8.93613C11.732 8.939 11.7466 8.94178 11.7612 8.94446C11.8568 8.96199 11.9538 8.97551 12.0521 8.98481C12.1582 8.99486 12.2659 9 12.375 9C14.2389 9 15.75 7.48897 15.75 5.62501C15.75 5.6037 15.7498 5.58245 15.7494 5.56125L14.862 6.44871C14.7281 6.58258 14.5978 6.71295 14.4784 6.81433C14.3472 6.92565 14.1808 7.04533 13.9635 7.11593C13.6622 7.21382 13.3377 7.21382 13.0365 7.11593C12.8192 7.04533 12.6528 6.92565 12.5216 6.81433C12.4022 6.71295 12.2719 6.58259 12.138 6.44873L11.9263 6.23695C11.7924 6.10312 11.662 5.97278 11.5607 5.85337C11.4493 5.72224 11.3297 5.55582 11.2591 5.33853C11.1612 5.03727 11.1612 4.71274 11.2591 4.41148C11.3297 4.19419 11.4493 4.02777 11.5607 3.89664C11.662 3.77723 11.7924 3.6469 11.9263 3.51307L13.1094 2.32997C12.8732 2.27762 12.6275 2.25001 12.375 2.25001C10.511 2.25001 8.99999 3.76104 8.99999 5.62501C8.99999 5.85068 9.02203 6.07047 9.06386 6.28257L9.0666 6.29644C9.10022 6.46689 9.12951 6.61537 9.14835 6.73453C9.16602 6.84624 9.18695 7.00128 9.17119 7.15948C9.16295 7.24215 9.1493 7.34005 9.1164 7.44818C9.0835 7.55632 9.04032 7.64523 9.00112 7.71849C8.89353 7.91955 8.71475 8.0971 8.56677 8.24408C8.55187 8.25889 8.53727 8.27338 8.52309 8.28756L8.40602 8.40463C8.40579 8.40487 8.40555 8.4051 8.40532 8.40533C8.40509 8.40557 8.40485 8.4058 8.40462 8.40604ZM10.0607 11.25L13.6553 14.8446C13.9837 15.173 14.5162 15.173 14.8446 14.8446C15.1731 14.5162 15.1731 13.9837 14.8446 13.6553L11.6332 10.4438C11.564 10.4332 11.4954 10.4212 11.4272 10.4078C11.2388 10.3706 11.1187 10.3471 11.0312 10.3332C11.0141 10.3305 11.0002 10.3285 10.989 10.327C10.9862 10.3295 10.9832 10.3322 10.98 10.3351C10.9362 10.3748 10.879 10.4317 10.7795 10.5312C10.7774 10.5333 10.7752 10.5354 10.7731 10.5376L10.0607 11.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$2dfdce118f498a96$var$ToolIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$2dfdce118f498a96$var$ToolIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$2dfdce118f498a96$var$ToolIcon.displayName = "ToolIcon";
var $dfd33cee3229493c$var$$2dfdce118f498a96$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2dfdce118f498a96$var$ToolIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``trash.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$b22b22e014672977$var$TrashIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M6 2.25C6 1.83579 6.33579 1.5 6.75 1.5H11.25C11.6642 1.5 12 1.83579 12 2.25C12 2.66421 11.6642 3 11.25 3H6.75C6.33579 3 6 2.66421 6 2.25ZM3.74418 3.75H2.25C1.83579 3.75 1.5 4.08579 1.5 4.5C1.5 4.91421 1.83579 5.25 2.25 5.25H3.04834L3.52961 12.4691C3.56737 13.0357 3.59862 13.5045 3.65465 13.8862C3.71299 14.2835 3.80554 14.6466 3.99832 14.985C4.29842 15.5118 4.75109 15.9353 5.29667 16.1997C5.64714 16.3695 6.0156 16.4377 6.41594 16.4695C6.80046 16.5 7.27037 16.5 7.8382 16.5H10.1618C10.7296 16.5 11.1995 16.5 11.5841 16.4695C11.9844 16.4377 12.3529 16.3695 12.7033 16.1997C13.2489 15.9353 13.7016 15.5118 14.0017 14.985C14.1945 14.6466 14.287 14.2835 14.3453 13.8862C14.4014 13.5045 14.4326 13.0356 14.4704 12.469L14.9517 5.25H15.75C16.1642 5.25 16.5 4.91421 16.5 4.5C16.5 4.08579 16.1642 3.75 15.75 3.75H14.2558C14.2514 3.74996 14.2471 3.74996 14.2427 3.75H3.75731C3.75294 3.74996 3.74857 3.74996 3.74418 3.75ZM13.4483 5.25H4.55166L5.0243 12.3396C5.06455 12.9433 5.09238 13.3525 5.13874 13.6683C5.18377 13.9749 5.23878 14.1321 5.30166 14.2425C5.45171 14.5059 5.67804 14.7176 5.95083 14.8498C6.06513 14.9052 6.22564 14.9497 6.53464 14.9742C6.85277 14.9995 7.26289 15 7.86799 15H10.132C10.7371 15 11.1472 14.9995 11.4654 14.9742C11.7744 14.9497 11.9349 14.9052 12.0492 14.8498C12.322 14.7176 12.5483 14.5059 12.6983 14.2425C12.7612 14.1321 12.8162 13.9749 12.8613 13.6683C12.9076 13.3525 12.9354 12.9433 12.9757 12.3396L13.4483 5.25ZM7.5 7.125C7.91421 7.125 8.25 7.46079 8.25 7.875V11.625C8.25 12.0392 7.91421 12.375 7.5 12.375C7.08579 12.375 6.75 12.0392 6.75 11.625V7.875C6.75 7.46079 7.08579 7.125 7.5 7.125ZM10.5 7.125C10.9142 7.125 11.25 7.46079 11.25 7.875V11.625C11.25 12.0392 10.9142 12.375 10.5 12.375C10.0858 12.375 9.75 12.0392 9.75 11.625V7.875C9.75 7.46079 10.0858 7.125 10.5 7.125Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$b22b22e014672977$var$TrashIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$b22b22e014672977$var$TrashIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$b22b22e014672977$var$TrashIcon.displayName = "TrashIcon";
var $dfd33cee3229493c$var$$b22b22e014672977$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b22b22e014672977$var$TrashIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``triple-chevron-down.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$f6c7f631126d86a9$var$TripleChevronDownIcon = ({ color: color, bottomColor: bottomColor, middleColor: middleColor, topColor: topColor, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    fill: bottomColor || color,
                    fillRule: "evenodd",
                    d: "M9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303L4.71967 11.7803C4.42678 11.4874 4.42678 11.0126 4.71967 10.7197C5.01256 10.4268 5.48744 10.4268 5.78033 10.7197L9 13.9393L12.2197 10.7197C12.5126 10.4268 12.9874 10.4268 13.2803 10.7197C13.5732 11.0126 13.5732 11.4874 13.2803 11.7803L9.53033 15.5303Z",
                    transform: ""
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    fill: middleColor || color,
                    fillRule: "",
                    d: "M4.71967 6.46967C5.01256 6.17678 5.48744 6.17678 5.78033 6.46967L9 9.68934L12.2197 6.46967C12.5126 6.17678 12.9874 6.17678 13.2803 6.46967C13.5732 6.76256 13.5732 7.23744 13.2803 7.53033L9.53033 11.2803C9.23744 11.5732 8.76256 11.5732 8.46967 11.2803L4.71967 7.53033C4.42678 7.23744 4.42678 6.76256 4.71967 6.46967Z",
                    transform: ""
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    fill: topColor || color,
                    fillRule: "",
                    d: "M4.71967 1.96967C5.01256 1.67678 5.48744 1.67678 5.78033 1.96967L9 5.18934L12.2197 1.96967C12.5126 1.67678 12.9874 1.67678 13.2803 1.96967C13.5732 2.26256 13.5732 2.73744 13.2803 3.03033L9.53033 6.78033C9.23744 7.07322 8.76256 7.07322 8.46967 6.78033L4.71967 3.03033C4.42678 2.73744 4.42678 2.26256 4.71967 1.96967Z",
                    transform: ""
                })
            ]
        })
    });
$dfd33cee3229493c$var$$f6c7f631126d86a9$var$TripleChevronDownIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    bottomColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    middleColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    topColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$f6c7f631126d86a9$var$TripleChevronDownIcon.defaultProps = {
    color: "#ffffff",
    bottomColor: null,
    middleColor: null,
    topColor: null,
    size: 16
};
$dfd33cee3229493c$var$$f6c7f631126d86a9$var$TripleChevronDownIcon.displayName = "TripleChevronDownIcon";
var $dfd33cee3229493c$var$$f6c7f631126d86a9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f6c7f631126d86a9$var$TripleChevronDownIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``triple-chevron-up.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$4682c351f3717a32$var$TripleChevronUpIcon = ({ color: color, bottomColor: bottomColor, middleColor: middleColor, topColor: topColor, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    fill: topColor || color,
                    fillRule: "evenodd",
                    d: "M8.46967 2.46967C8.76256 2.17678 9.23744 2.17678 9.53033 2.46967L13.2803 6.21967C13.5732 6.51256 13.5732 6.98744 13.2803 7.28033C12.9874 7.57322 12.5126 7.57322 12.2197 7.28033L9 4.06066L5.78033 7.28033C5.48744 7.57322 5.01256 7.57322 4.71967 7.28033C4.42678 6.98744 4.42678 6.51256 4.71967 6.21967L8.46967 2.46967Z",
                    transform: ""
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    fill: middleColor || color,
                    fillRule: "",
                    d: "M13.2803 11.5303C12.9874 11.8232 12.5126 11.8232 12.2197 11.5303L9 8.31066L5.78033 11.5303C5.48744 11.8232 5.01256 11.8232 4.71967 11.5303C4.42678 11.2374 4.42678 10.7626 4.71967 10.4697L8.46967 6.71967C8.76256 6.42678 9.23744 6.42678 9.53033 6.71967L13.2803 10.4697C13.5732 10.7626 13.5732 11.2374 13.2803 11.5303Z",
                    transform: ""
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    fill: bottomColor || color,
                    fillRule: "",
                    d: "M13.2803 16.0303C12.9874 16.3232 12.5126 16.3232 12.2197 16.0303L9 12.8107L5.78033 16.0303C5.48744 16.3232 5.01256 16.3232 4.71967 16.0303C4.42678 15.7374 4.42678 15.2626 4.71967 14.9697L8.46967 11.2197C8.76256 10.9268 9.23744 10.9268 9.53033 11.2197L13.2803 14.9697C13.5732 15.2626 13.5732 15.7374 13.2803 16.0303Z",
                    transform: ""
                })
            ]
        })
    });
$dfd33cee3229493c$var$$4682c351f3717a32$var$TripleChevronUpIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    bottomColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    middleColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    topColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$4682c351f3717a32$var$TripleChevronUpIcon.defaultProps = {
    color: "#ffffff",
    bottomColor: null,
    middleColor: null,
    topColor: null,
    size: 16
};
$dfd33cee3229493c$var$$4682c351f3717a32$var$TripleChevronUpIcon.displayName = "TripleChevronUpIcon";
var $dfd33cee3229493c$var$$4682c351f3717a32$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4682c351f3717a32$var$TripleChevronUpIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``trophy.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$83519f4b734c9fa9$var$TrophyIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.51591 0.749816C5.53894 0.749909 5.56145 0.75 5.58334 0.75H12.4167C12.4386 0.75 12.4611 0.749909 12.4841 0.749816C12.7189 0.748867 13.0082 0.747698 13.263 0.840461C13.6797 0.992109 14.0079 1.32032 14.1596 1.73697C14.2195 1.90161 14.2402 2.08061 14.2471 2.25L15.3949 2.25C15.5524 2.24998 15.7059 2.24997 15.8364 2.25888C15.9792 2.26862 16.1485 2.29147 16.324 2.36418C16.6916 2.51642 16.9836 2.80843 17.1358 3.17597C17.2085 3.35151 17.2314 3.5208 17.2411 3.66358C17.25 3.79414 17.25 3.94761 17.25 4.10514V4.5C17.25 4.5349 17.25 4.56929 17.25 4.60318C17.2504 5.19972 17.2506 5.64272 17.1478 6.02646C16.8704 7.06173 16.0617 7.87038 15.0265 8.14778C14.741 8.22426 14.4228 8.24372 14.033 8.24854C13.4571 10.1857 11.7933 11.6546 9.75001 11.9468V12.75H10.0833C11.9703 12.75 13.5 14.2797 13.5 16.1667C13.5 16.765 13.015 17.25 12.4167 17.25H5.58334C4.98504 17.25 4.50001 16.765 4.50001 16.1667C4.50001 14.2797 6.02971 12.75 7.91668 12.75H8.25001V11.9468C6.20667 11.6546 4.54289 10.1857 3.96699 8.24854C3.57719 8.24372 3.25898 8.22426 2.97355 8.14778C1.93828 7.87038 1.12964 7.06173 0.852234 6.02646C0.749411 5.64272 0.749651 5.19972 0.749974 4.60319C0.749993 4.56929 0.750011 4.5349 0.750011 4.5V4.125C0.750011 4.11838 0.750011 4.11176 0.75001 4.10514C0.749994 3.94761 0.749979 3.79414 0.758887 3.66358C0.768629 3.5208 0.791484 3.35151 0.864192 3.17597C1.01643 2.80843 1.30844 2.51642 1.67599 2.36418C1.85152 2.29147 2.02081 2.26862 2.16359 2.25888C2.29415 2.24997 2.44762 2.24998 2.60516 2.25C2.61177 2.25 2.61839 2.25 2.62501 2.25H3.75291C3.75982 2.08061 3.78055 1.90161 3.84047 1.73697C3.99212 1.32032 4.32033 0.992109 4.73698 0.840461C4.99185 0.747698 5.28111 0.748867 5.51591 0.749816ZM3.75001 3.75H2.62501C2.44002 3.75 2.33884 3.75041 2.2657 3.7554C2.2623 3.75563 2.2591 3.75586 2.25611 3.7561C2.25588 3.75909 2.25564 3.76228 2.25541 3.76569C2.25042 3.83883 2.25001 3.94001 2.25001 4.125V4.5C2.25001 5.24576 2.25645 5.47152 2.30112 5.63823C2.43982 6.15587 2.84414 6.56019 3.36178 6.69889C3.45088 6.72276 3.55683 6.73572 3.75001 6.7426V3.75ZM5.25001 2.58333C5.25001 2.41904 5.25033 2.3292 5.25429 2.26406C5.25449 2.26079 5.25469 2.25773 5.25489 2.25488C5.25774 2.25468 5.2608 2.25447 5.26407 2.25428C5.32921 2.25032 5.41905 2.25 5.58334 2.25H12.4167C12.581 2.25 12.6708 2.25032 12.7359 2.25428C12.7392 2.25447 12.7423 2.25468 12.7451 2.25488C12.7453 2.25773 12.7455 2.26079 12.7457 2.26406C12.7497 2.3292 12.75 2.41904 12.75 2.58333V6.75C12.75 8.82107 11.0711 10.5 9.00001 10.5C6.92894 10.5 5.25001 8.82107 5.25001 6.75V2.58333ZM14.25 3.75V6.7426C14.4432 6.73572 14.5491 6.72276 14.6382 6.69889C15.1559 6.56019 15.5602 6.15587 15.6989 5.63823C15.7436 5.47152 15.75 5.24576 15.75 4.5V4.125C15.75 3.94001 15.7496 3.83883 15.7446 3.76569C15.7444 3.76229 15.7441 3.75909 15.7439 3.7561C15.7409 3.75586 15.7377 3.75563 15.7343 3.7554C15.6612 3.75041 15.56 3.75 15.375 3.75H14.25ZM7.91668 14.25C7.00122 14.25 6.23567 14.8918 6.04543 15.75H11.9546C11.7643 14.8918 10.9988 14.25 10.0833 14.25H7.91668Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$83519f4b734c9fa9$var$TrophyIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$83519f4b734c9fa9$var$TrophyIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$83519f4b734c9fa9$var$TrophyIcon.displayName = "TrophyIcon";
var $dfd33cee3229493c$var$$83519f4b734c9fa9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$83519f4b734c9fa9$var$TrophyIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``type.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$3f5c86e66ed086ac$var$TypeIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M5.22601 2.25H12.774C13.103 2.24999 13.3868 2.24998 13.6218 2.26601C13.8692 2.28289 14.1166 2.32002 14.361 2.42127C14.9124 2.64963 15.3504 3.08765 15.5787 3.63896C15.68 3.88341 15.7171 4.13084 15.734 4.37821C15.75 4.61316 15.75 4.89702 15.75 5.22601V5.25C15.75 5.66421 15.4142 6 15 6C14.5858 6 14.25 5.66421 14.25 5.25C14.25 4.89028 14.2496 4.65806 14.2375 4.48032C14.2258 4.30932 14.2058 4.2442 14.1929 4.21299C14.1168 4.02922 13.9708 3.88321 13.787 3.80709C13.7558 3.79416 13.6907 3.7742 13.5197 3.76253C13.3419 3.75041 13.1097 3.75 12.75 3.75H9.75V14.25H11.25C11.6642 14.25 12 14.5858 12 15C12 15.4142 11.6642 15.75 11.25 15.75H6.75C6.33579 15.75 6 15.4142 6 15C6 14.5858 6.33579 14.25 6.75 14.25H8.25V3.75H5.25C4.89028 3.75 4.65806 3.75041 4.48032 3.76253C4.30932 3.7742 4.2442 3.79416 4.21299 3.80709C4.02922 3.88321 3.88321 4.02922 3.80709 4.21299C3.79416 4.2442 3.7742 4.30932 3.76253 4.48032C3.75041 4.65806 3.75 4.89028 3.75 5.25C3.75 5.66421 3.41421 6 3 6C2.58579 6 2.25 5.66421 2.25 5.25L2.25 5.22601C2.24999 4.89703 2.24998 4.61316 2.26601 4.37821C2.28289 4.13084 2.32002 3.88341 2.42127 3.63896C2.64963 3.08765 3.08765 2.64963 3.63896 2.42127C3.88341 2.32002 4.13084 2.28289 4.37821 2.26601C4.61316 2.24998 4.89703 2.24999 5.22601 2.25Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$3f5c86e66ed086ac$var$TypeIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$3f5c86e66ed086ac$var$TypeIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$3f5c86e66ed086ac$var$TypeIcon.displayName = "TypeIcon";
var $dfd33cee3229493c$var$$3f5c86e66ed086ac$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3f5c86e66ed086ac$var$TypeIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``upload.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$37252f54693c4c23$var$UploadIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.46967 1.71967C8.76256 1.42678 9.23744 1.42678 9.53033 1.71967L13.2803 5.46967C13.5732 5.76256 13.5732 6.23744 13.2803 6.53033C12.9874 6.82322 12.5126 6.82322 12.2197 6.53033L9.75 4.06066V11.25C9.75 11.6642 9.41421 12 9 12C8.58579 12 8.25 11.6642 8.25 11.25V4.06066L5.78033 6.53033C5.48744 6.82322 5.01256 6.82322 4.71967 6.53033C4.42678 6.23744 4.42678 5.76256 4.71967 5.46967L8.46967 1.71967ZM2.25 10.5C2.66421 10.5 3 10.8358 3 11.25V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81901 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H12.15C12.7924 15 13.2292 14.9994 13.5667 14.9718C13.8955 14.945 14.0637 14.8963 14.181 14.8365C14.4632 14.6927 14.6927 14.4632 14.8365 14.181C14.8963 14.0637 14.945 13.8955 14.9718 13.5667C14.9994 13.2292 15 12.7924 15 12.15V11.25C15 10.8358 15.3358 10.5 15.75 10.5C16.1642 10.5 16.5 10.8358 16.5 11.25V12.181C16.5 12.7847 16.5 13.283 16.4669 13.6889C16.4324 14.1104 16.3585 14.498 16.173 14.862C15.8854 15.4265 15.4265 15.8854 14.862 16.173C14.498 16.3585 14.1104 16.4324 13.6889 16.4669C13.283 16.5 12.7847 16.5 12.181 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181L1.5 11.25C1.5 10.8358 1.83579 10.5 2.25 10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$37252f54693c4c23$var$UploadIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$37252f54693c4c23$var$UploadIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$37252f54693c4c23$var$UploadIcon.displayName = "UploadIcon";
var $dfd33cee3229493c$var$$37252f54693c4c23$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$37252f54693c4c23$var$UploadIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``user-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$1be94b3ec3f3e84c$var$UserCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 10.6659 2.85346 12.1908 3.8537 13.3681C4.54103 12.5332 5.58276 12 6.75 12H11.25C12.4172 12 13.459 12.5332 14.1463 13.3681C15.1465 12.1908 15.75 10.6659 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM14.5277 15.1244C16.1994 13.6146 17.25 11.43 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 11.43 1.80059 13.6146 3.47234 15.1244C3.48104 15.1326 3.48996 15.1407 3.49909 15.1485C4.95878 16.4553 6.88658 17.25 9 17.25C11.1134 17.25 13.0412 16.4553 14.5009 15.1485C14.51 15.1407 14.519 15.1326 14.5277 15.1244ZM13.0505 14.4001C12.6395 13.8529 11.9854 13.5 11.25 13.5H6.75C6.01457 13.5 5.3605 13.8529 4.94954 14.4001C6.07776 15.2477 7.48022 15.75 9 15.75C10.5198 15.75 11.9222 15.2477 13.0505 14.4001ZM9 4.875C7.75736 4.875 6.75 5.88236 6.75 7.125C6.75 8.36764 7.75736 9.375 9 9.375C10.2426 9.375 11.25 8.36764 11.25 7.125C11.25 5.88236 10.2426 4.875 9 4.875ZM5.25 7.125C5.25 5.05393 6.92893 3.375 9 3.375C11.0711 3.375 12.75 5.05393 12.75 7.125C12.75 9.19607 11.0711 10.875 9 10.875C6.92893 10.875 5.25 9.19607 5.25 7.125Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$1be94b3ec3f3e84c$var$UserCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$1be94b3ec3f3e84c$var$UserCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$1be94b3ec3f3e84c$var$UserCircleIcon.displayName = "UserCircleIcon";
var $dfd33cee3229493c$var$$1be94b3ec3f3e84c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$1be94b3ec3f3e84c$var$UserCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``users-edit.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$54933d3b7da008e2$var$UsersEditIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M7.125 3C5.88236 3 4.875 4.00736 4.875 5.25C4.875 6.49264 5.88236 7.5 7.125 7.5C8.36764 7.5 9.375 6.49264 9.375 5.25C9.375 4.00736 8.36764 3 7.125 3ZM3.375 5.25C3.375 3.17893 5.05393 1.5 7.125 1.5C9.19607 1.5 10.875 3.17893 10.875 5.25C10.875 7.32107 9.19607 9 7.125 9C5.05393 9 3.375 7.32107 3.375 5.25ZM10.9298 2.18666C11.0852 1.80271 11.5225 1.61745 11.9064 1.77287C13.2793 2.32861 14.25 3.67505 14.25 5.25C14.25 5.66421 13.9142 6 13.5 6C13.0858 6 12.75 5.66421 12.75 5.25C12.75 4.30692 12.1695 3.49761 11.3436 3.16327C10.9596 3.00785 10.7744 2.57061 10.9298 2.18666ZM14.0947 8.46967C14.8018 7.76256 15.9482 7.76255 16.6553 8.46963C17.3625 9.17675 17.3625 10.3232 16.6554 11.0304L11.6622 16.0234C11.6558 16.0299 11.6492 16.0365 11.6424 16.0433C11.5681 16.1179 11.4745 16.2119 11.3633 16.2894C11.2667 16.3568 11.1626 16.4125 11.053 16.4555C10.9268 16.505 10.7966 16.5308 10.6933 16.5512C10.6839 16.5531 10.6747 16.5549 10.6658 16.5567L9.14698 16.8604C8.90108 16.9096 8.64687 16.8326 8.46956 16.6553C8.29224 16.478 8.21528 16.2238 8.26448 15.9779L8.56831 14.4591C8.57009 14.4502 8.57191 14.441 8.57377 14.4316C8.59422 14.3283 8.61998 14.1982 8.66948 14.072C8.71248 13.9624 8.76822 13.8582 8.83557 13.7617C8.91311 13.6505 9.00709 13.5569 9.0817 13.4826C9.08849 13.4758 9.09512 13.4692 9.10156 13.4628L14.0947 8.46967ZM15.5947 9.53032C15.4734 9.409 15.2767 9.409 15.1553 9.53033L10.1622 14.5234C10.111 14.5747 10.0858 14.6 10.0681 14.6189C10.0677 14.6194 10.0673 14.6199 10.0669 14.6203C10.0667 14.6209 10.0666 14.6215 10.0664 14.6221C10.0605 14.6474 10.0534 14.6823 10.0392 14.7534L9.95603 15.1689L10.3716 15.0858C10.4427 15.0716 10.4776 15.0645 10.5029 15.0585C10.5035 15.0584 10.5041 15.0582 10.5047 15.0581C10.5052 15.0577 10.5056 15.0573 10.5061 15.0568C10.5251 15.0391 10.5504 15.014 10.6016 14.9628L15.5947 9.9697C15.716 9.84837 15.716 9.65165 15.5947 9.53032ZM5.97336 10.5H8.25C8.66421 10.5 9 10.8358 9 11.25C9 11.6642 8.66421 12 8.25 12H6C5.29083 12 4.79651 12.0004 4.40959 12.0268C4.0294 12.0527 3.808 12.1013 3.63896 12.1713C3.08765 12.3996 2.64963 12.8376 2.42127 13.389C2.35125 13.558 2.30275 13.7794 2.27681 14.1596C2.25041 14.5465 2.25 15.0408 2.25 15.75C2.25 16.1642 1.91421 16.5 1.5 16.5C1.08579 16.5 0.75 16.1642 0.75 15.75L0.75 15.7234C0.749995 15.047 0.749991 14.5015 0.780285 14.0575C0.811436 13.6009 0.877109 13.1972 1.03545 12.8149C1.41605 11.8961 2.14608 11.1661 3.06494 10.7855C3.44721 10.6271 3.85092 10.5614 4.30748 10.5303C4.75148 10.5 5.29704 10.5 5.97336 10.5Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$54933d3b7da008e2$var$UsersEditIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$54933d3b7da008e2$var$UsersEditIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$54933d3b7da008e2$var$UsersEditIcon.displayName = "UsersEditIcon";
var $dfd33cee3229493c$var$$54933d3b7da008e2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$54933d3b7da008e2$var$UsersEditIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``wifi.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$41f086e6a945dc2a$var$WifiIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M8.99992 4.125C6.07046 4.125 3.404 5.2437 1.40173 7.07852C1.09634 7.35836 0.621919 7.33766 0.342075 7.03227C0.0622309 6.72689 0.0829362 6.25247 0.388322 5.97262C2.65635 3.89428 5.68077 2.625 8.99992 2.625C12.3191 2.625 15.3435 3.89428 17.6115 5.97262C17.9169 6.25247 17.9376 6.72689 17.6578 7.03227C17.3779 7.33766 16.9035 7.35836 16.5981 7.07852C14.5958 5.2437 11.9294 4.125 8.99992 4.125ZM8.99999 7.875C7.09999 7.875 5.36661 8.58054 4.04471 9.74501C3.7339 10.0188 3.25997 9.9888 2.98617 9.67799C2.71237 9.36717 2.74238 8.89325 3.05319 8.61945C4.63848 7.22295 6.72113 6.375 8.99999 6.375C11.2788 6.375 13.3615 7.22295 14.9468 8.61945C15.2576 8.89325 15.2876 9.36717 15.0138 9.67799C14.74 9.9888 14.2661 10.0188 13.9553 9.74501C12.6334 8.58054 10.9 7.875 8.99999 7.875ZM8.99992 11.625C8.11394 11.625 7.30156 11.9313 6.65995 12.4444C6.33646 12.7031 5.8645 12.6506 5.6058 12.3271C5.3471 12.0036 5.39962 11.5317 5.72311 11.273C6.62104 10.5549 7.76131 10.125 8.99992 10.125C10.22 10.125 11.3448 10.5421 12.2364 11.2411C12.5624 11.4966 12.6196 11.968 12.364 12.294C12.1085 12.62 11.6371 12.6771 11.3111 12.4216C10.6741 11.9223 9.87275 11.625 8.99992 11.625ZM8.25 14.625C8.25 14.2108 8.58579 13.875 9 13.875H9.0075C9.42172 13.875 9.7575 14.2108 9.7575 14.625C9.7575 15.0392 9.42172 15.375 9.0075 15.375H9C8.58579 15.375 8.25 15.0392 8.25 14.625Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$41f086e6a945dc2a$var$WifiIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$41f086e6a945dc2a$var$WifiIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$41f086e6a945dc2a$var$WifiIcon.displayName = "WifiIcon";
var $dfd33cee3229493c$var$$41f086e6a945dc2a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$41f086e6a945dc2a$var$WifiIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``x-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$5186db77bb5db429$var$XCircleIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM6.21967 6.21967C6.51256 5.92678 6.98744 5.92678 7.28033 6.21967L9 7.93934L10.7197 6.21967C11.0126 5.92678 11.4874 5.92678 11.7803 6.21967C12.0732 6.51256 12.0732 6.98744 11.7803 7.28033L10.0607 9L11.7803 10.7197C12.0732 11.0126 12.0732 11.4874 11.7803 11.7803C11.4874 12.0732 11.0126 12.0732 10.7197 11.7803L9 10.0607L7.28033 11.7803C6.98744 12.0732 6.51256 12.0732 6.21967 11.7803C5.92678 11.4874 5.92678 11.0126 6.21967 10.7197L7.93934 9L6.21967 7.28033C5.92678 6.98744 5.92678 6.51256 6.21967 6.21967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$5186db77bb5db429$var$XCircleIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$5186db77bb5db429$var$XCircleIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$5186db77bb5db429$var$XCircleIcon.displayName = "XCircleIcon";
var $dfd33cee3229493c$var$$5186db77bb5db429$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5186db77bb5db429$var$XCircleIcon;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``x-close.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$e70e94b576d9ab55$var$XCloseIcon = ({ color: color, size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M3.96967 3.96967C4.26256 3.67678 4.73744 3.67678 5.03033 3.96967L9 7.93934L12.9697 3.96967C13.2626 3.67678 13.7374 3.67678 14.0303 3.96967C14.3232 4.26256 14.3232 4.73744 14.0303 5.03033L10.0607 9L14.0303 12.9697C14.3232 13.2626 14.3232 13.7374 14.0303 14.0303C13.7374 14.3232 13.2626 14.3232 12.9697 14.0303L9 10.0607L5.03033 14.0303C4.73744 14.3232 4.26256 14.3232 3.96967 14.0303C3.67678 13.7374 3.67678 13.2626 3.96967 12.9697L7.93934 9L3.96967 5.03033C3.67678 4.73744 3.67678 4.26256 3.96967 3.96967Z",
                transform: ""
            })
        })
    });
$dfd33cee3229493c$var$$e70e94b576d9ab55$var$XCloseIcon.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    size: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$e70e94b576d9ab55$var$XCloseIcon.defaultProps = {
    color: "#ffffff",
    size: 16
};
$dfd33cee3229493c$var$$e70e94b576d9ab55$var$XCloseIcon.displayName = "XCloseIcon";
var $dfd33cee3229493c$var$$e70e94b576d9ab55$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e70e94b576d9ab55$var$XCloseIcon;
const $dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d = {
    INCREASED: "INCREASED",
    DECREASED: "DECREASED",
    UNCHANGED: "UNCHANGED"
};
const $dfd33cee3229493c$var$$310d86a3e565de36$var$StyledBadge = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  border-radius: 16px;
  height: 32px;
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface2};
  display: inline-flex;
  align-items: center;
  padding-left: 6px;
  padding-right: 12px;

  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  line-height: 12px;
`;
const $dfd33cee3229493c$var$$310d86a3e565de36$var$StyledIndicator = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  border-radius: 50%;
  line-height: 1;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props)=>{
    if (props.$status === $dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d.INCREASED) return `
        background: rgba(0,246,139,.3); // PrimaryColorPalette.BUY with transparency
      `;
    else if (props.$status === $dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d.DECREASED) return `
        background: rgba(255,98,98,.3); // PrimaryColorPalette.SELL with transparency
      `;
    else return `
        background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
      `;
}}
`;
const $dfd33cee3229493c$var$$310d86a3e565de36$var$StyledTitle = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin-left: 6px;
  margin-right: 4px;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
`;
const $dfd33cee3229493c$var$$310d86a3e565de36$var$StyledValue = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
/**
 * Specialized badge indicating whether something has increased, decreased, or not changed.
 */ const $dfd33cee3229493c$var$$310d86a3e565de36$var$IndicatorBadge = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    let indicatorIconColor = $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80;
    let IndicatorIcon = $dfd33cee3229493c$var$$1717380490155c4f$export$2e2bcd8739ae039;
    if (props.indicator === $dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d.INCREASED) {
        indicatorIconColor = $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.buy;
        IndicatorIcon = $dfd33cee3229493c$var$$502f458cee51ae7f$export$2e2bcd8739ae039;
    } else if (props.indicator === $dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d.DECREASED) {
        indicatorIconColor = $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.sell;
        IndicatorIcon = $dfd33cee3229493c$var$$9b205aa1790e85a4$export$2e2bcd8739ae039;
    }
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$310d86a3e565de36$var$StyledBadge, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$310d86a3e565de36$var$StyledIndicator, {
                $status: props.indicator,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(IndicatorIcon, {
                    size: 16,
                    color: indicatorIconColor
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$310d86a3e565de36$var$StyledTitle, {
                children: props.title
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$310d86a3e565de36$var$StyledValue, {
                children: props.value
            })
        ]
    });
});
$dfd33cee3229493c$var$$310d86a3e565de36$var$IndicatorBadge.displayName = "IndicatorBadge";
$dfd33cee3229493c$var$$310d86a3e565de36$var$IndicatorBadge.propTypes = {
    title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    indicator: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d))
};
$dfd33cee3229493c$var$$310d86a3e565de36$var$IndicatorBadge.defaultProps = {
    indicator: $dfd33cee3229493c$var$$310d86a3e565de36$export$252a1fe4a2cc7e8d.UNCHANGED
};
var $dfd33cee3229493c$var$$310d86a3e565de36$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$310d86a3e565de36$var$IndicatorBadge;
const $dfd33cee3229493c$var$$fe1ba5810fdf797e$export$54f72bf989ec8c70 = $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$14202c65a8343c87$export$2e2bcd8739ae039));
var $dfd33cee3229493c$var$$46d5e6430c21300b$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "ButtonStyles", ()=>$dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "IconButtonStyles", ()=>$dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "Button", ()=>$dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "IconButton", ()=>$dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "HyperLink", ()=>$dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "LinkStyles", ()=>$dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "LinkTypes", ()=>$dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "FilterChip", ()=>$dfd33cee3229493c$var$$42b9a489fcea3072$export$4ebb06a5f191b0a9);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "ActionChip", ()=>$dfd33cee3229493c$var$$42b9a489fcea3072$export$340ef18e89d7d15d);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "InputChip", ()=>$dfd33cee3229493c$var$$42b9a489fcea3072$export$209d5e35e7868ba1);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$46d5e6430c21300b$exports, "ChipStyles", ()=>$dfd33cee3229493c$var$$42b9a489fcea3072$export$a1d1e6bd41d11ebc);
const $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2 = {
    OUTLINE: "OUTLINE",
    CTA: "CTA",
    BUY: "BUY",
    SELL: "SELL",
    RAISED: "RAISED"
};
const $dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0 = {
    STANDARD: "STANDARD",
    OUTLINE: "OUTLINE",
    RAISED: "RAISED"
};
/* eslint-disable react/prop-types */ const $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4 = {
    // add missing type="button" to button links
    // to prevent form submission in case they are used inside a form
    // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#notes
    BUTTON: ()=>({
            type: "button"
        }),
    DOWNLOAD: (url)=>({
            href: url,
            download: true,
            rel: "noreferrer noopener",
            target: "_blank"
        }),
    LOCAL_LINK: (url)=>({
            to: url
        }),
    EXTERNAL_LINK: (url)=>({
            href: url,
            rel: "noreferrer noopener",
            target: "_blank"
        }),
    LINK: (url)=>({
            href: url
        })
};
/**
 * A text link element with helpers to ensure attributes and navigation behaves as desired.
 *
 * Provides a backwards compatible interface with the legacy element with warnings. This can be
 * expected to be removed in a future release
 *
 * to (DEPRECATED) - This prop is a string or object that react-router can parse, and if specified, results in
 *   an `<a>` tag being rendered and managed by react router. Should be used for in-app routing
 *
 * href (DEPRECATED) - This prop is a string that is a valid href that is rendered as the corresponding
 *   attribute in an `<a>` tag managed as normal by the browser. Should be used for out of app
 *   routing.
 *
 * url - This prop is a string that is a valid href or a string/object that react-router can parse.
 *   This results in either an `<a>` tag or a `<Link>` being rendered.
 *
 * Either url, to, or href must be specified for `target`, `rel`, or `download` attributes to be applied
 *
 * LinkTypes guideline:
 * - `BUTTON` - when no navigation is performed but need a text link visually
 * - `DOWNLOAD` - when the link is directly to a document to be downloaded
 * - `LOCAL_LINK` - the link navigates within a SPA
 * - `EXTERNAL_LINK` - the link navigates away from the environment, opens in a new tab
 * - `LINK` - a traditional `<a>` tag without any special behaviors
 *
 * @param {string} url - The URL we are linking to if applicable
 * @param {function} linkType - One of LinkTypes
 * @param {object} legacyProps - The V1 hyperlink props used to map to V2 behavior
 *
 * @returns {Array}
 *   - computedLinkProps {object} - set of props to pass into the rendered link component
 *   - renderAs {string|function} - the component to render the link as
 *     either an "a", "button", or Link
 */ const $dfd33cee3229493c$var$$da5c189d3d5b3551$var$getLinkProps = (url, _linkType, legacyProps)=>{
    const linkType = _linkType ?? (url ? $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.LINK : $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.BUTTON);
    let computedLinkProps = linkType?.(url);
    let renderAs = "a";
    // Backwards compatibility with legacy HyperLink props
    if (legacyProps && (legacyProps.newTab || legacyProps.accent || legacyProps.download || legacyProps.href || legacyProps.to || legacyProps.active || legacyProps.rel || legacyProps.target)) {
        // eslint-disable-next-line no-console
        console.warn("You are passing V1 props to a V2 link-like element. Some actions may not act is expected");
        if (!_linkType) {
            computedLinkProps = {
                to: legacyProps.to,
                href: legacyProps.href,
                download: legacyProps.download,
                rel: legacyProps.newTab ? "noreferrer noopener" : "",
                target: legacyProps.newTab ? "_blank" : ""
            };
            // Compute which base element to use to render
            if (legacyProps.to) renderAs = $ff1ed43a67e50aba$export$a6c7ac8248d6e38a;
            else if (!legacyProps.href) renderAs = "button";
        }
    } else {
        // Default V2 behavior
        // Default props
        if (!computedLinkProps) {
            if (url) computedLinkProps = $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.LINK(url);
            else computedLinkProps = $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.BUTTON();
        }
        // Compute which base element to use to render
        if (linkType == $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.LOCAL_LINK) renderAs = $ff1ed43a67e50aba$export$a6c7ac8248d6e38a;
        else if (linkType == $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.BUTTON) renderAs = "button";
    }
    return [
        computedLinkProps,
        renderAs
    ];
};
var $dfd33cee3229493c$var$$da5c189d3d5b3551$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$da5c189d3d5b3551$var$getLinkProps;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_CONTAINER = (0, $e42cae22e74e223a$exports.css)`
  border-radius: 16px;
  padding: 0 12px;
  height: 32px;
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_DISABLED = (0, $e42cae22e74e223a$exports.css)`
  border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15};
  background: transparent;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$NON_OUTLINE_DISABLED = (0, $e42cae22e74e223a$exports.css)`
  border: 1px solid transparent;
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15};
  cursor: default;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: transparent;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
  border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white30};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.hoverTransparent};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.activeTransparent};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white10};
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white80};
  border: none;
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: rgba(255, 255, 255, 0.17);
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_SELECTED_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue200};
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue500};
  border: none;
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_SELECTED_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue300};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_SELECTED_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue300};
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue700};

  svg path {
    fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue700};
  }
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "branding500")};
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.black80};
  border: 1px solid transparent;
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "branding600")};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "branding700")};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "green")};
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.black80};
  border: 1px solid transparent;
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "greenHover")};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "greenActive")};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "red")};
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white100};
  border: 1px solid transparent;
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "redHover")};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "redActive")};
`;
const $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_THEME = {
    [$dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.CTA]: {
        container: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$NON_OUTLINE_DISABLED,
        default: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_DEFAULT,
        hover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_HOVER,
        active: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_ACTIVE,
        iconSize: 16,
        // TODO we do not have selected support for this button style.
        selectedDefault: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_HOVER,
        selectedActive: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$CTA_ACTIVE
    },
    [$dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.RAISED]: {
        container: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$NON_OUTLINE_DISABLED,
        default: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_DEFAULT,
        hover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_HOVER,
        active: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_ACTIVE,
        selectedDefault: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_SELECTED_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_SELECTED_HOVER,
        selectedActive: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$RAISED_SELECTED_ACTIVE,
        iconSize: 18
    },
    [$dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.OUTLINE]: {
        container: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_DISABLED,
        default: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_DEFAULT,
        hover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_HOVER,
        active: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_ACTIVE,
        iconSize: 16,
        // TODO we do not have selected support for this button style.
        selectedDefault: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_HOVER,
        selectedActive: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_ACTIVE
    },
    [$dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.BUY]: {
        container: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$NON_OUTLINE_DISABLED,
        default: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_DEFAULT,
        hover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_HOVER,
        active: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_ACTIVE,
        iconSize: 16,
        // TODO we do not have selected support for this button style.
        selectedDefault: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_HOVER,
        selectedActive: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$BUY_ACTIVE
    },
    [$dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.SELL]: {
        container: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$NON_OUTLINE_DISABLED,
        default: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_DEFAULT,
        hover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_HOVER,
        active: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_ACTIVE,
        iconSize: 16,
        // TODO we do not have selected support for this button style.
        selectedDefault: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_HOVER,
        selectedActive: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$SELL_ACTIVE
    },
    fallback: {
        container: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$NON_OUTLINE_DISABLED,
        default: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_DEFAULT,
        hover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_HOVER,
        active: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_ACTIVE,
        iconSize: 16,
        // TODO we do not have selected support for this button style.
        selectedDefault: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_HOVER,
        selectedActive: $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$OUTLINE_ACTIVE
    }
};
var $dfd33cee3229493c$var$$a891fdb8d3b0118b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a891fdb8d3b0118b$var$DEFAULT_BUTTON_THEME;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$DEFAULT_ICON_BUTTON_CONTAINER = (0, $e42cae22e74e223a$exports.css)`
  border-radius: 50%;
  border: 0 solid transparent;
  height: 32px;
  width: 32px;
  padding: 8px;
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$OUTLINE_ICON_BUTTON_CONTAINER = (0, $e42cae22e74e223a$exports.css)`
  ${$dfd33cee3229493c$var$$6204ce24041fbda2$var$DEFAULT_ICON_BUTTON_CONTAINER}
  border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white30};
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DISABLED = (0, $e42cae22e74e223a$exports.css)`
  background: transparent;
  cursor: default;
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$OUTLINE_DISABLED = (0, $e42cae22e74e223a$exports.css)`
  ${$dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DISABLED}
  border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15};
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_DISABLED = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white05};
  cursor: default;
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: transparent;
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.hoverTransparent};
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.activeTransparent};
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  border: none;
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white10};
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15};
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: rgba(255, 255, 255, 0.17);
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_SELECTED_DEFAULT = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue200};
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue500};
  border: none;
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_SELECTED_HOVER = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue300};
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_SELECTED_ACTIVE = (0, $e42cae22e74e223a$exports.css)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue300};

  svg path {
    fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue700};
  }
  circle {
    fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue700};
  }
`;
const $dfd33cee3229493c$var$$6204ce24041fbda2$var$DEFAULT_ICON_BUTTON_THEME = {
    [$dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.STANDARD]: {
        container: $dfd33cee3229493c$var$$6204ce24041fbda2$var$DEFAULT_ICON_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DISABLED,
        default: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DEFAULT,
        hover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_HOVER,
        active: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_ACTIVE,
        // TODO we do not have selected support for this icon button style.
        selectedDefault: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_HOVER,
        selectedActive: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_ACTIVE
    },
    [$dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.RAISED]: {
        container: $dfd33cee3229493c$var$$6204ce24041fbda2$var$DEFAULT_ICON_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_DISABLED,
        default: $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_DEFAULT,
        hover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_HOVER,
        active: $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_ACTIVE,
        selectedDefault: $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_SELECTED_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_SELECTED_HOVER,
        selectedActive: $dfd33cee3229493c$var$$6204ce24041fbda2$var$RAISED_SELECTED_ACTIVE
    },
    [$dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.OUTLINE]: {
        container: $dfd33cee3229493c$var$$6204ce24041fbda2$var$OUTLINE_ICON_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$6204ce24041fbda2$var$OUTLINE_DISABLED,
        default: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DEFAULT,
        hover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_HOVER,
        active: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_ACTIVE,
        // TODO we do not have selected support for this icon button style.
        selectedDefault: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_HOVER,
        selectedActive: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_ACTIVE
    },
    fallback: {
        container: $dfd33cee3229493c$var$$6204ce24041fbda2$var$DEFAULT_ICON_BUTTON_CONTAINER,
        disabled: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DISABLED,
        default: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DEFAULT,
        hover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_HOVER,
        active: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_ACTIVE,
        // TODO we do not have selected support for this icon button style.
        selectedDefault: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_DEFAULT,
        selectedHover: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_HOVER,
        selectedActive: $dfd33cee3229493c$var$$6204ce24041fbda2$var$NON_RAISED_ACTIVE
    }
};
var $dfd33cee3229493c$var$$6204ce24041fbda2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6204ce24041fbda2$var$DEFAULT_ICON_BUTTON_THEME;
const $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa = (theme, color)=>{
    if (!theme?.colors?.[color]) return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$c8e3bfd6e31baa27[color];
    return theme.colors[color];
};
const $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e70c3c2adc0993b4 = (theme, specifiedButtonStyle, field)=>{
    const buttonStyle = Object.keys($dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2).includes(specifiedButtonStyle) ? specifiedButtonStyle : "fallback";
    if (!theme?.button?.[buttonStyle]?.[field]) return $dfd33cee3229493c$var$$a891fdb8d3b0118b$export$2e2bcd8739ae039[buttonStyle][field];
    return theme.button[buttonStyle][field];
};
const $dfd33cee3229493c$var$$88a35ca95b368dbb$export$3ea6ea5cc33cf2b = (theme, specifiedButtonStyle, field)=>{
    const buttonStyle = Object.keys($dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0).includes(specifiedButtonStyle) ? specifiedButtonStyle : "fallback";
    if (!theme?.iconButton?.[buttonStyle]?.[field]) return $dfd33cee3229493c$var$$6204ce24041fbda2$export$2e2bcd8739ae039[buttonStyle][field];
    return theme.iconButton[buttonStyle][field];
};
/**
 * The default theme configuration.
 *
 * By leveraging a default theme, we can enable highly configurable styles to be defined.
 */ // Table styling constants.
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$defaultBorder = `1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15}`;
// Border used to indicate the end of the sticky column section.
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$thickenedBorder = `1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white30}`;
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors = {
    header: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface2,
    headerText: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white50,
    headerActive: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface4,
    headerHover: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface3,
    row: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface1,
    rowText: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white80,
    rowActive: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface3,
    rowActiveText: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white100,
    rowHover: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface2,
    rowSelected: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue100,
    rowSelectedText: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white80
};
// We support table coloring based on the surface level the table sits on. We need to use opaque
// colors for the table since we support side scroll. In general, table row color matches
// the surface level, and the others are derived. Headers are typically slightly lighter than
// the surface.
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_1_COLORS = {
    ...$dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors,
    header: "#212121",
    headerHover: "#2C2C2C",
    headerActive: "#313131",
    row: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface1,
    rowHover: "#252525",
    rowActive: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface2
};
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_2_COLORS = {
    ...$dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors,
    header: "#303030",
    headerHover: "#3B3B3B",
    headerActive: "#3F3F3F",
    row: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface2,
    rowHover: "#353535",
    rowActive: "#393939"
};
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_3_COLORS = {
    ...$dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors,
    header: "#404040",
    headerHover: "#4A4A4A",
    headerActive: "#4E4E4E",
    row: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface3,
    rowHover: "#444444",
    rowActive: "#484848"
};
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_4_COLORS = {
    // You should avoid using tables at this surface level.
    ...$dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors,
    header: "#4F4F4F",
    headerHover: "#585858",
    headerActive: "#5C5C5C",
    row: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface4,
    rowHover: "#535353",
    rowActive: "#575757"
};
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_5_COLORS = {
    // You should really avoid using tables at this surface level.
    ...$dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors,
    header: "#5F5F5F",
    headerHover: "#676767",
    headerActive: "#6B6B6B",
    row: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface5,
    rowHover: "#626262",
    rowActive: "#666666"
};
// Array so we can access based on surface number.
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$TABLE_SURFACE_COLORS = [
    $dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors,
    // We shouldn't be rendering tables on surface 0.
    $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_1_COLORS,
    $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_2_COLORS,
    $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_3_COLORS,
    $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_4_COLORS,
    $dfd33cee3229493c$var$$58d0bb043433b77a$var$SURFACE_5_COLORS
];
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$Header = {
    height: 40,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    paddingBottom: 16,
    borderTop: $dfd33cee3229493c$var$$58d0bb043433b77a$var$defaultBorder,
    borderRight: $dfd33cee3229493c$var$$58d0bb043433b77a$var$defaultBorder,
    thickenedBorderRight: $dfd33cee3229493c$var$$58d0bb043433b77a$var$thickenedBorder,
    borderBottom: $dfd33cee3229493c$var$$58d0bb043433b77a$var$defaultBorder,
    borderLeft: "none"
};
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$Cells = {
    height: 46,
    paddingTop: 16,
    paddingRight: 16,
    paddingBottom: 16,
    paddingLeft: 16,
    borderTop: "none",
    borderBottom: $dfd33cee3229493c$var$$58d0bb043433b77a$var$defaultBorder,
    borderRight: $dfd33cee3229493c$var$$58d0bb043433b77a$var$defaultBorder,
    borderLeft: "none",
    thickenedBorderRight: $dfd33cee3229493c$var$$58d0bb043433b77a$var$thickenedBorder
};
const $dfd33cee3229493c$var$$58d0bb043433b77a$var$DefaultStyleConfiguration = (currentSurface)=>({
        colors: currentSurface >= 0 && currentSurface <= 5 ? $dfd33cee3229493c$var$$58d0bb043433b77a$var$TABLE_SURFACE_COLORS[currentSurface] : $dfd33cee3229493c$var$$58d0bb043433b77a$var$TableColors,
        header: $dfd33cee3229493c$var$$58d0bb043433b77a$var$Header,
        cells: $dfd33cee3229493c$var$$58d0bb043433b77a$var$Cells
    });
var $dfd33cee3229493c$var$$58d0bb043433b77a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$58d0bb043433b77a$var$DefaultStyleConfiguration;
var $dfd33cee3229493c$var$$eed6a5795c5bd9a1$export$2e2bcd8739ae039 = {
    tableStyles: $dfd33cee3229493c$var$$58d0bb043433b77a$export$2e2bcd8739ae039,
    mode: "dark",
    colors: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$c8e3bfd6e31baa27,
    button: $dfd33cee3229493c$var$$a891fdb8d3b0118b$export$2e2bcd8739ae039,
    iconButton: $dfd33cee3229493c$var$$6204ce24041fbda2$export$2e2bcd8739ae039
};
const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5 = /*#__PURE__*/ (0, $70fFQ.createContext)(0);
const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$ElevationContext = /*#__PURE__*/ (0, $70fFQ.createContext)(0);
// Surfaces 0 - 5
const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceBackgrounds = [
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface0,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface1,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface2,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface3,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface4,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.surface5
];
// rgba(255, 255, 255, 0.05) on top of base background
const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceHoverBackgrounds = [
    "#171717",
    "#262626",
    "#353535",
    "#444444",
    "#535353",
    "#626262"
];
// rgba(255, 255, 255, 0.07) on top of base background
const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceActiveBackgrounds = [
    "#1b1b1b",
    "#2a2a2a",
    "#393939",
    "#484848",
    "#575757",
    "#666666"
];
// Elevation 1 - 2 + No elevation
const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$elevationShadows = [
    "none",
    "0px 1px 6px rgba(0, 0, 0, 0.5)",
    "0px 4px 8px rgba(0, 0, 0, 0.25)"
];
const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$StyledSurface = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  background: ${(props)=>$dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceBackgrounds[props.$surface]};
  box-shadow: ${(props)=>$dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$elevationShadows[props.$elevation]};
  z-index: ${(props)=>props.$elevation * 10 || "auto"};
  ${(props)=>props.onClick ? (0, $e42cae22e74e223a$exports.css)`
          cursor: pointer;
          &:hover {
            background: ${(props)=>$dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceHoverBackgrounds[props.$surface]};
          }
          &:active {
            background: ${(props)=>$dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceActiveBackgrounds[props.$surface]};
          }
        ` : ""}
`;
/**
 * An internal yuka component that manages background of successive layout elements stacked on
 * top of one another
 *
 * To use, have the wrapper element of your component reference this either directly or by
 * wrapping in a styled component
 *
 * See yuka documentation for Layout for how you can make use of this system in your product.
 */ const $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$Surface = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    let currentSurface = (0, $70fFQ.useContext)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5);
    const currentElevation = (0, $70fFQ.useContext)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$ElevationContext);
    let computedElevation = props.elevated ? Math.min(currentElevation + 1, 2) : 0;
    if (currentSurface >= $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceBackgrounds.length) {
        // eslint-disable-next-line no-console
        console.error("Too many surfaces stacked on each other");
        currentSurface = $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$surfaceBackgrounds.length - 1;
    }
    if (computedElevation >= $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$elevationShadows.length) {
        // eslint-disable-next-line no-console
        console.error("Too many elevated elements stacked on each other");
        computedElevation = $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$elevationShadows.length - 1;
    }
    const eventProps = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, [
        "onClick",
        "onMouseDown",
        "onMouseUp",
        "onMouseEnter",
        "onMouseLeave",
        "tabIndex"
    ]);
    const ariaProps = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pickBy(props, (prop)=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).startsWith(prop, "aria-"));
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5.Provider, {
        value: currentSurface + 1,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$ElevationContext.Provider, {
            value: props.elevated ? computedElevation : currentElevation,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$StyledSurface, {
                ref: ref,
                style: props.style,
                ...eventProps,
                ...ariaProps,
                role: props.role,
                className: props.className,
                $surface: currentSurface,
                $elevation: computedElevation,
                children: props.children
            })
        })
    });
});
$dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$Surface.propTypes = {
    elevated: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    style: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    role: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$Surface.defaultProps = {
    elevated: false,
    style: {},
    className: ""
};
var $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$var$Surface;
const $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd = ()=>{
    const theme = (0, $e42cae22e74e223a$exports.useTheme)();
    const computedTheme = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>({
            ...$dfd33cee3229493c$var$$eed6a5795c5bd9a1$export$2e2bcd8739ae039,
            ...theme
        }), [
        theme
    ]);
    return computedTheme;
};
/*
 * Merges default styles with user-provided theme. We only propagate values supported in the
 * base object, so no extra user input is passed through.
 */ const $dfd33cee3229493c$var$$050d353b350c191b$var$mergeWithDefaultOptions = (base, override)=>{
    if (!override || !$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isObject(override) || !Object.keys(override).length) return $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).cloneDeep(base);
    const newOptions = {};
    Object.keys(base).forEach((key)=>{
        // Possibly recurse into nested objects.
        let nextOptions = override[key] || base[key];
        if (!Array.isArray(override[key]) && $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isObject(base[key]) && $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isObject(override[key])) nextOptions = $dfd33cee3229493c$var$$050d353b350c191b$var$mergeWithDefaultOptions(base[key], override[key]);
        newOptions[key] = nextOptions;
    });
    return newOptions;
};
// eslint-disable-next-line react/prop-types
const $dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172 = ({ theme: theme = {}, children: children })=>{
    const parentTheme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    const computedTheme = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>{
        const baseTheme = {
            ...$dfd33cee3229493c$var$$eed6a5795c5bd9a1$export$2e2bcd8739ae039,
            ...parentTheme,
            ...theme
        };
        const colors = $dfd33cee3229493c$var$$050d353b350c191b$var$mergeWithDefaultOptions($dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$c8e3bfd6e31baa27, baseTheme.colors);
        const button = $dfd33cee3229493c$var$$050d353b350c191b$var$mergeWithDefaultOptions($dfd33cee3229493c$var$$eed6a5795c5bd9a1$export$2e2bcd8739ae039.button, baseTheme.button);
        const iconButton = $dfd33cee3229493c$var$$050d353b350c191b$var$mergeWithDefaultOptions($dfd33cee3229493c$var$$eed6a5795c5bd9a1$export$2e2bcd8739ae039.iconButton, baseTheme.iconButton);
        return {
            ...baseTheme,
            colors: colors,
            button: button,
            iconButton: iconButton
        };
    }, [
        theme,
        parentTheme
    ]);
    const provider = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e42cae22e74e223a$exports.ThemeProvider, {
        theme: computedTheme,
        children: children
    });
    // Intentionally only check if provided - do not want to insert providers unintentionally
    if (theme.surfaceLevel) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5.Provider, {
        value: theme.surfaceLevel,
        children: provider
    });
    return provider;
};
const $dfd33cee3229493c$var$$07a4f6eac681e0c2$var$StyledButton = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).button.attrs({
    className: "btn"
})`
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  min-width: 0;
  outline: none;
  transition: all 0.1s cubic-bezier(0.33, 0, 0.2, 1);

  // 1  - Container
  ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e70c3c2adc0993b4(props.theme, props.$buttonStyle, "container")}

  // 2 - Button Text
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c};
  line-height: 16px;

  // 3 - Leading/Trailing Icon
  // height, width, color set as props
  svg {
    &:first-child {
      margin-right: 8px;
    }

    &:last-child {
      margin-left: 8px;
    }
  }

  // 4- Disabled/selected state
  ${(props)=>{
    if (props.disabled) return $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e70c3c2adc0993b4(props.theme, props.$buttonStyle, "disabled");
    // A button cannot be simultaneously selected and disabled.
    // While the below code implies it, it should be noted that as of writing this comment
    // we do not have selected support for styles beyond the ButtonStyles.RAISED style, so
    // those buttons will default to their normal default, hover, active styles.
    return (0, $e42cae22e74e223a$exports.css)`
      ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e70c3c2adc0993b4(props.theme, props.$buttonStyle, props.$selected ? "selectedDefault" : "default")}

      &&:hover {
        ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e70c3c2adc0993b4(props.theme, props.$buttonStyle, props.$selected ? "selectedHover" : "hover")}
      }

      &&:active {
        ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e70c3c2adc0993b4(props.theme, props.$buttonStyle, props.$selected ? "selectedActive" : "active")}
      }
    `;
}}

  // Apply selector using class name instead of & because styled components acts weird
  .icon-btn + &,
  .btn + & {
    // rows of buttons are spaced out
    margin-left: 12px;
  }
`;
const $dfd33cee3229493c$var$$07a4f6eac681e0c2$var$computeButtonIconColor = (yukaTheme, buttonStyle, disabled, selected)=>{
    if (disabled) return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15;
    if (buttonStyle === $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.CTA) return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.black50;
    if (buttonStyle === $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.RAISED && selected) return $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(yukaTheme, "branding500");
    return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white50;
};
/**
 * Renders an element that looks like a button to the screen. Underlying HTML element depends on
 * function.
 *
 * url - This prop is a string that is a valid href or a string/object that react-router can parse.
 *   This results in either an `<a>` tag or a `<Link>` being rendered.
 *
 * Either url, to, or href must be specified for `target`, `rel`, or `download` attributes to be applied
 *
 * onClick - This prop is a function handler that results in an html `<button>` being rendered if
 *   none of the above are specified. Must be set for `type` to be applied.
 *
 * buttonStyle - If this prop is supplied, then we render a filled button with the given fill style.
 *   If not supplied then we render an outline button.
 *
 * LinkTypes guideline:
 * - `BUTTON` - when no navigation is performed but need a text link visually
 * - `DOWNLOAD` - when the link is directly to a document to be downloaded
 * - `LOCAL_LINK` - the link navigates within a SPA
 * - `EXTERNAL_LINK` - the link navigates away from the environment, opens in a new tab
 * - `LINK` - a traditional `<a>` tag without any special behaviors
 */ const $dfd33cee3229493c$var$$07a4f6eac681e0c2$var$Button = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const yukaTheme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    const iconColor = $dfd33cee3229493c$var$$07a4f6eac681e0c2$var$computeButtonIconColor(yukaTheme, props.buttonStyle, props.disabled, props.selected);
    const legacyProps = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, [
        "newTab",
        "accent",
        "download",
        "href",
        "to",
        "active",
        "rel",
        "target"
    ]);
    const [computedLinkProps, renderAs] = $dfd33cee3229493c$var$$da5c189d3d5b3551$export$2e2bcd8739ae039(props.url, props.linkType, legacyProps);
    // Render a slightly larger icon for key action buttons.
    const iconSize = $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e70c3c2adc0993b4(yukaTheme, props.buttonStyle, "iconSize");
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$07a4f6eac681e0c2$var$StyledButton, {
        ref: ref,
        ...computedLinkProps,
        id: props.id,
        className: props.className,
        disabled: props.disabled,
        onClick: props.onClick,
        type: props.type,
        $selected: props.selected,
        $buttonStyle: props.buttonStyle,
        as: renderAs,
        role: props.role,
        children: [
            props.leadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                color: iconColor,
                size: iconSize
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: props.children
            }),
            props.trailingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.trailingIcon, {
                color: iconColor,
                size: iconSize
            })
        ]
    });
});
$dfd33cee3229493c$var$$07a4f6eac681e0c2$var$Button.propTypes = {
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** force button disabled state */ disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** do not use with href, to, or url */ onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* Shown before children inside the button */ leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* Shown after children inside the button */ trailingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** do not use with href, to, or url */ type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** the href to use. May be renamed to href in the future if legacy compatibility is removed */ url: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
            pathname: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
            search: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        })
    ]),
    /* Filled/Outline button style. If not supplied, then the button is an outline button. */ buttonStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2)),
    /** Only available for key actions */ selected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** How the link should be treated for navigation and other best practices purposes */ linkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    /** Aria role */ role: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$07a4f6eac681e0c2$var$Button.defaultProps = {
    className: "",
    disabled: false,
    selected: false,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
    leadingIcon: null,
    trailingIcon: null,
    type: "button",
    url: null,
    buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.OUTLINE
};
$dfd33cee3229493c$var$$07a4f6eac681e0c2$var$Button.displayName = "Button";
var $dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$07a4f6eac681e0c2$var$Button;
/* eslint-disable no-unused-vars */ // needed since color isn't used in the template but appears in the replaced body
/*
 * Yuka v2.0
 * This component corresponds to ``alert_dot.svg``. A notification dot to be used in icon buttons.
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$df11a0a362830d81$var$AlertDot = ({ color: color })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
            cx: "4",
            cy: "4",
            r: "4",
            fill: color
        })
    });
$dfd33cee3229493c$var$$df11a0a362830d81$var$AlertDot.propTypes = {
    // all of these can be overriden in CSS as necessary
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$df11a0a362830d81$var$AlertDot.defaultProps = {
    color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue500
};
$dfd33cee3229493c$var$$df11a0a362830d81$var$AlertDot.displayName = "AlertDot";
var $dfd33cee3229493c$var$$df11a0a362830d81$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$df11a0a362830d81$var$AlertDot;
const $dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$StyledAlertDot = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  position: absolute;
  height: 8px;
  width: 8px;

  ${(props)=>props.$buttonStyle === $dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.RAISED ? (0, $e42cae22e74e223a$exports.css)`
          right: 12px;
          top: 8px;
        ` : (0, $e42cae22e74e223a$exports.css)`
          right: 5px;
          top: 1px;
        `}
`;
const $dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$StyledButton = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).button.attrs({
    className: "icon-btn"
})`
  // Apply selector using class name instead of & because styled components acts weird
  .btn + &,
  .icon-btn + & {
    margin-left: 12px;
  }
  position: relative;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex-grow: 0;
  flex-shrink: 0;
  outline: none;

  .flex-input + & {
    // align icon buttons with our inputs
    // we move up from the bottom because flex-input may have a label above, so centering
    // and positioning from the top are not reliable
    align-self: flex-end;
    margin-bottom: 4px;
  }

  // 1 - Icon
  // icon size and color set in props

  // 2 - Container
  ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$3ea6ea5cc33cf2b(props.theme, props.$buttonStyle, "container")}
  line-height: 16px;

  // 3 - Disabled/selected state
  ${(props)=>{
    if (props.disabled) return $dfd33cee3229493c$var$$88a35ca95b368dbb$export$3ea6ea5cc33cf2b(props.theme, props.$buttonStyle, "disabled");
    return (0, $e42cae22e74e223a$exports.css)`
      ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$3ea6ea5cc33cf2b(props.theme, props.$buttonStyle, props.$selected ? "selectedDefault" : "default")}

      &&:hover {
        ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$3ea6ea5cc33cf2b(props.theme, props.$buttonStyle, props.$selected ? "selectedHover" : "hover")}
      }

      &&:active {
        ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$3ea6ea5cc33cf2b(props.theme, props.$buttonStyle, props.$selected ? "selectedActive" : "active")}
      }
    `;
}}
`;
const $dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$computeIconButtonIconColor = (yukaTheme, buttonStyle, disabled, selected)=>{
    if (disabled) return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15;
    else if (buttonStyle === $dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.RAISED && selected) return $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(yukaTheme, "branding500");
    return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white50;
};
/**
 * Wrapper component for SVG icon buttons.
 *
 * to (DEPRECATED) - This prop is a string or object that react-router can parse, and if specified, results in
 *   an `<a>` tag being rendered and managed by react router. Should be used for in-app routing
 *
 * href (DEPRECATED) - This prop is a string that is a valid href that is rendered as the corresponding
 *   attribute in an `<a>` tag managed as normal by the browser. Should be used for out of app
 *   routing.
 *
 * url - This prop is a string that is a valid href or a string/object that react-router can parse.
 *   This results in either an `<a>` tag or a `<Link>` being rendered.
 *
 * Either url, to, or href must be specified for `target`, `rel`, or `download` attributes to be applied
 *
 * onClick - This prop is a function handler that results in an html `<button>` being rendered if
 *   none of the above are specified. Must be set for `type` to be applied.
 *
 * buttonStyle - Render a standard or outline IconButton.
 *   If not supplied then we render a standard IconButton.
 *
 * LinkTypes guideline:
 * - `BUTTON` - when no navigation is performed but need a text link visually
 * - `DOWNLOAD` - when the link is directly to a document to be downloaded
 * - `LOCAL_LINK` - the link navigates within a SPA
 * - `EXTERNAL_LINK` - the link navigates away from the environment, opens in a new tab
 * - `LINK` - a traditional `<a>` tag without any special behaviors
 */ const $dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$IconButton = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const yukaTheme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    const iconColor = props.iconColor ? props.iconColor : $dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$computeIconButtonIconColor(yukaTheme, props.buttonStyle, props.disabled, props.selected);
    const legacyProps = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, [
        "newTab",
        "accent",
        "download",
        "href",
        "to",
        "active",
        "rel",
        "target"
    ]);
    const [computedLinkProps, renderAs] = $dfd33cee3229493c$var$$da5c189d3d5b3551$export$2e2bcd8739ae039(props.url, props.linkType, legacyProps);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$StyledButton, {
        ref: ref,
        ...computedLinkProps,
        id: props.id,
        className: props.className,
        "data-testid": props.dataTestid,
        disabled: props.disabled,
        onClick: props.onClick,
        type: props.type,
        $selected: props.selected,
        $buttonStyle: props.buttonStyle,
        as: renderAs,
        role: props.role,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.icon, {
                size: 16,
                color: iconColor
            }),
            props.hasAlert && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$StyledAlertDot, {
                $buttonStyle: props.buttonStyle,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$df11a0a362830d81$export$2e2bcd8739ae039, {})
            })
        ]
    });
});
$dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$IconButton.propTypes = {
    icon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    iconColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    dataTestid: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    url: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    linkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
        ...Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)
    ]),
    selected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    hasAlert: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    buttonStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0)),
    /** Aria role */ role: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$IconButton.defaultProps = {
    className: "",
    dataTestid: "",
    selected: false,
    disabled: false,
    href: null,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
    to: null,
    url: null,
    type: "button",
    iconColor: null,
    buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.STANDARD
};
$dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$IconButton.displayName = "IconButton";
var $dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$var$IconButton;
/* eslint-disable react/prop-types */ const $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23 = {
    DEFAULT: "DEFAULT",
    // default link rules
    SUPPORT: "SUPPORT",
    // support link rules
    UNSTYLED: "UNSTYLED",
    // "link" that doesn't have actual elements for it.
    INVISIBLE: "INVISIBLE" // Inline with existing styles
};
const $dfd33cee3229493c$var$$202691c4dadcc7a2$var$StyledHyperLink = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).a`
  ${(props)=>{
    if (props.$linkStyle == $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.DEFAULT) return (0, $e42cae22e74e223a$exports.css)`
        color: ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "link")};
        &:hover {
          text-decoration: underline;
        }
      `;
    else if (props.$linkStyle == $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.SUPPORT) return (0, $e42cae22e74e223a$exports.css)`
        ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
        &:hover {
          text-decoration: underline;
        }
      `;
    else if (props.$linkStyle == $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.INVISIBLE) return (0, $e42cae22e74e223a$exports.css)`
        color: inherit;
        &:hover {
          text-decoration: underline;
        }
      `;
    else return (0, $e42cae22e74e223a$exports.css)`
        color: inherit;
      `;
}}

  text-decoration: none;
  cursor: pointer;
  // Assorted button styles to wipe and normalize
  background: none;
  letter-spacing: inherit;
  display: inline;
  border: none;
  font: inherit;
  outline: inherit;
  padding: 0;
  text-transform: inherit;
`;
/**
 * A text link element with helpers to ensure attributes and navigation behaves as desired.
 *
 * Provides a backwards compatible interface with the legacy element with warnings. This can be
 * expected to be removed in a future release
 *
 * LinkStyles.UNSTYLED may be removed in a future release. This is a backdoor for non traditional
 * link experiences to be given standardized, accessible attributes and is not officially part of
 * the yuka style guide
 *
 * LinkTypes guideline:
 * - `BUTTON` - when no navigation is performed but need a text link visually
 * - `DOWNLOAD` - when the link is directly to a document to be downloaded
 * - `LOCAL_LINK` - the link navigates within a SPA
 * - `EXTERNAL_LINK` - the link navigates away from the environment, opens in a new tab
 * - `LINK` - a traditional `<a>` tag without any special behaviors
 */ const $dfd33cee3229493c$var$$202691c4dadcc7a2$var$HyperLink = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    let computedLinkStyle = props.linkStyle;
    // Backwards compatibility with legacy HyperLink props
    if (props.newTab || props.accent || props.download || props.href || props.to || props.active) {
        // eslint-disable-next-line no-console
        console.warn("You are passing V1 props to a V2 HyperLink. Some actions may not act is expected");
        if (!props.linkStyle) computedLinkStyle = props.accent ? $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.DEFAULT : $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.SUPPORT;
    } else // Default props
    if (!computedLinkStyle) computedLinkStyle = $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.DEFAULT;
    const legacyProps = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, [
        "newTab",
        "accent",
        "download",
        "href",
        "to",
        "active",
        "rel",
        "target"
    ]);
    const [computedLinkProps, renderAs] = $dfd33cee3229493c$var$$da5c189d3d5b3551$export$2e2bcd8739ae039(props.url, props.linkType, legacyProps);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$202691c4dadcc7a2$var$StyledHyperLink, {
        ...computedLinkProps,
        id: props.id,
        className: props.className,
        onClick: props.onClick,
        as: renderAs,
        ref: ref,
        $linkStyle: computedLinkStyle,
        role: props.role,
        children: props.children
    });
});
$dfd33cee3229493c$var$$202691c4dadcc7a2$var$HyperLink.propTypes = {
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** The appearance of the link, either Default or Support. */ linkStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23)),
    /** How the link should be treated for navigation and other best practices purposes */ linkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** the href to use. May be renamed to href in the future if legacy compatibility is removed */ url: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Aria role */ role: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$202691c4dadcc7a2$var$HyperLink.displayName = "HyperLink";
var $dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$202691c4dadcc7a2$var$HyperLink;
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$FILTER = "FILTER";
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$ACTION = "ACTION";
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$INPUT = "INPUT";
const $dfd33cee3229493c$var$$42b9a489fcea3072$export$a1d1e6bd41d11ebc = {
    FILTER: $dfd33cee3229493c$var$$42b9a489fcea3072$var$FILTER,
    ACTION: $dfd33cee3229493c$var$$42b9a489fcea3072$var$ACTION,
    INPUT: $dfd33cee3229493c$var$$42b9a489fcea3072$var$INPUT
};
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledFilterIcon = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  height: 16px;
  ${(props)=>{
    if (props.$disabled) return (0, $e42cae22e74e223a$exports.css)`
        path,
        polygon {
          fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
        }
      `;
    if (props.$selected) return (0, $e42cae22e74e223a$exports.css)`
        path,
        polygon {
          fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue100};
        }
      `;
    return (0, $e42cae22e74e223a$exports.css)`
      path,
      polygon {
        fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80};
      }
    `;
}}
`;
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledActionIcon = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  height: 16px;
  ${(props)=>props.$disabled ? (0, $e42cae22e74e223a$exports.css)`
          path,
          polygon {
            fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
          }
        ` : (0, $e42cae22e74e223a$exports.css)`
          path,
          polygon {
            fill: ${props.$color || $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50};
          }
        `}
`;
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledCloseIcon = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  height: 16px;
  svg {
    pointer-events: bounding-box;
    margin-right: -6px;
  }
  path {
    ${(props)=>props.$disabled ? `
      fill ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
    ` : `
      fill ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30};
      &:hover {
        fill ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50};
      }
      &:active {
        fill ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80};
      }
    `}
  }
`;
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledChip = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).button`
  & + & {
    margin-left: 12px;
  }
  align-items: center;
  background: transparent;
  border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30};
  border-radius: 13px;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  white-space: nowrap;
  flex-grow: 0;
  flex-shrink: 0;
  width: fit-content;
  height: 26px;
  gap: 8px;
  padding: 0 12px;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  line-height: 16px;

  ${(props)=>{
    if (props.disabled) return (0, $e42cae22e74e223a$exports.css)`
        cursor: default;
        color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30};
        border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
      `;
    if (props.$selected) {
        const baseStyles = (0, $e42cae22e74e223a$exports.css)`
        background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white100};
        border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white100};
        color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue100};
      `;
        return props.$hoverable ? (0, $e42cae22e74e223a$exports.css)`
            ${baseStyles}
            &:hover {
              background: rgba(255, 255, 255, 0.95);
              border-color: rgba(255, 255, 255, 0.95);
            }
            &:active {
              background: rgba(255, 255, 255, 0.9);
              border-color: rgba(255, 255, 255, 0.9);
            }
          ` : baseStyles;
    }
    if (props.$hoverable) return (0, $e42cae22e74e223a$exports.css)`
        &:hover {
          background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.hoverTransparent};
        }
        &:active {
          background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.activeTransparent};
        }
      `;
}}
`;
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledAvatarWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin-left: -8px;
  height: 18px;
  width: 18px;
  overflow: hidden;
`;
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$ICON_TYPES = {
    FILTER: $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledFilterIcon,
    ACTION: $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledActionIcon,
    INPUT: $dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledCloseIcon
};
/**
 * A chip is an element that appears similar to a button and to a badge. Notably however, chips
 * are smaller than buttons in size, and have actions on click, which badges do not.
 *
 * Chips help people enter information, make selections, filter content or trigger actions. Chips
 * can show multiple interactive elements together in the same area, such as a list of selectable
 * filters.
 *
 */ const $dfd33cee3229493c$var$$42b9a489fcea3072$var$Chip = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const StyledIcon = $dfd33cee3229493c$var$$42b9a489fcea3072$var$ICON_TYPES[props.chipStyle];
    // Do not enable the hover state for the chip as a whole if they are hovering
    // over the close icon
    const [isHoverClose, setIsHoverClose] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(false);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledChip, {
        ref: ref,
        type: props.type,
        onClick: props.onClick,
        $hoverable: !isHoverClose && props.onClick,
        $selected: props.selected,
        disabled: props.disabled,
        className: props.className,
        children: [
            props.leadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(StyledIcon, {
                $color: props.leadingIconColor,
                $selected: props.selected,
                $disabled: props.disabled,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                    size: 16
                })
            }),
            props.avatar && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$42b9a489fcea3072$var$StyledAvatarWrapper, {
                children: props.avatar
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: props.text
            }),
            props.trailingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(StyledIcon, {
                $color: props.trailingIconColor,
                onClick: props.onClose,
                onMouseEnter: props.onClose ? ()=>{
                    setIsHoverClose(true);
                } : null,
                onMouseLeave: props.onClose ? ()=>{
                    setIsHoverClose(false);
                } : null,
                role: props.onClose ? "button" : "presentation",
                $selected: props.selected,
                $disabled: props.disabled,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.trailingIcon, {
                    size: 16
                })
            })
        ]
    });
});
$dfd33cee3229493c$var$$42b9a489fcea3072$var$Chip.propTypes = {
    /* Filter Chip Only! Display a filter as selected. This state is to be managed by the implementing component */ selected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    chipStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$42b9a489fcea3072$export$a1d1e6bd41d11ebc)).isRequired,
    /* Action Chip Only! Icon component to render to the right of the chip text */ trailingIconColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    trailingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* Action or Filter Chip Only! Icon component to render to the left of the chip text */ leadingIconColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* Input Chip Only! An element that may be display to the left of the chip text. Must be 18px square */ avatar: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    text: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* Click handler for Chips. In a FilterChip, this should toggle the selected state */ onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* HTML type attribute */ type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* InputChip only: Event handler for clicking the close icon */ onClose: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$42b9a489fcea3072$var$Chip.defaultProps = {
    type: "button",
    selected: false,
    disabled: false
};
const $dfd33cee3229493c$var$$42b9a489fcea3072$export$4ebb06a5f191b0a9 = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$42b9a489fcea3072$var$Chip, {
        ...props,
        ref: ref,
        chipStyle: $dfd33cee3229493c$var$$42b9a489fcea3072$export$a1d1e6bd41d11ebc.FILTER,
        trailingIcon: null,
        onClose: null,
        avatar: null
    }));
const $dfd33cee3229493c$var$$42b9a489fcea3072$export$340ef18e89d7d15d = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$42b9a489fcea3072$var$Chip, {
        ...props,
        ref: ref,
        chipStyle: $dfd33cee3229493c$var$$42b9a489fcea3072$export$a1d1e6bd41d11ebc.ACTION,
        selected: false,
        onClose: null,
        avatar: null
    }));
const $dfd33cee3229493c$var$$42b9a489fcea3072$var$_InputChip = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const onClose = (e)=>{
        e.stopPropagation();
        props.onClose();
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$42b9a489fcea3072$var$Chip, {
        ...props,
        ref: ref,
        onClose: onClose,
        chipStyle: $dfd33cee3229493c$var$$42b9a489fcea3072$export$a1d1e6bd41d11ebc.INPUT,
        trailingIcon: $dfd33cee3229493c$var$$5186db77bb5db429$export$2e2bcd8739ae039,
        leadingIcon: null,
        selected: false
    });
});
$dfd33cee3229493c$var$$42b9a489fcea3072$var$_InputChip.propTypes = {
    text: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    avatar: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    onClose: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
// Allow it to be used in styled components;
const $dfd33cee3229493c$var$$42b9a489fcea3072$export$209d5e35e7868ba1 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$42b9a489fcea3072$var$_InputChip)``;
var $dfd33cee3229493c$var$$42b9a489fcea3072$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$42b9a489fcea3072$var$Chip;
var $dfd33cee3229493c$var$$764502df57988970$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FormModal", ()=>$dfd33cee3229493c$var$$be25308833f7c58b$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "InputRow", ()=>$dfd33cee3229493c$var$$de07a7337aac81e2$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FieldPrefixContext", ()=>$dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$783a6a60ccdbd93e);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FormSection", ()=>$dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FullPageForm", ()=>$dfd33cee3229493c$var$$ff3c4486de82edb5$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "ControlledWizard", ()=>$dfd33cee3229493c$var$$5dfa7f39ac2312bb$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "Wizard", ()=>$dfd33cee3229493c$var$$15774296204dd8df$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FinalFormFullPageForm", ()=>$dfd33cee3229493c$var$$755087928233361e$export$1beef25d77eff929);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FinalFormControlledWizard", ()=>$dfd33cee3229493c$var$$755087928233361e$export$7ffad97d00f295e9);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FinalFormWizard", ()=>$dfd33cee3229493c$var$$755087928233361e$export$93a4b73b1d3fe50d);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "StandardWizardActions", ()=>$dfd33cee3229493c$var$$e581118688a617d8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "SimpleWizardActions", ()=>$dfd33cee3229493c$var$$978e65900c11eede$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "Filter", ()=>$dfd33cee3229493c$var$$940ab79e8b119172$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$764502df57988970$exports, "FinalFormFilter", ()=>$dfd33cee3229493c$var$$7c99044ce213d752$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$efec349ad28d603f$var$StyledHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
  ${(props)=>props.$padded ? "margin: 0 16px;" : ""}
`;
const $dfd33cee3229493c$var$$efec349ad28d603f$var$Headline = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$b68c94e7d753c71b}
`;
const $dfd33cee3229493c$var$$efec349ad28d603f$var$SupportingText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
`;
const $dfd33cee3229493c$var$$efec349ad28d603f$var$StyledLink = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039)`
  ${(props)=>props.as ? "" : $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  position: absolute;
  top: 0;
  right: 0;
`;
const $dfd33cee3229493c$var$$efec349ad28d603f$var$StyledTrailingContent = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
`;
const $dfd33cee3229493c$var$$efec349ad28d603f$var$CardHeader = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$efec349ad28d603f$var$StyledHeader, {
        $padded: props.padded,
        children: [
            props.premiumNode,
            props.headline && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$efec349ad28d603f$var$Headline, {
                id: props.id,
                children: props.headline
            }),
            props.supportingText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$efec349ad28d603f$var$SupportingText, {
                children: props.supportingText
            }),
            props.trailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$efec349ad28d603f$var$StyledTrailingContent, {
                children: props.trailingContent
            }),
            props.linkText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$efec349ad28d603f$var$StyledLink, {
                ...props.linkProps,
                children: props.linkText
            })
        ]
    });
$dfd33cee3229493c$var$$efec349ad28d603f$var$CardHeader.propTypes = {
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    padded: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    premiumNode: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    headline: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    supportingText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    linkText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    linkProps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    trailingContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
};
var $dfd33cee3229493c$var$$efec349ad28d603f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$efec349ad28d603f$var$CardHeader;
const $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec = {
    BASIC: "BASIC",
    TITLE: "TITLE",
    SECTIONED: "SECTIONED",
    VALUE: "VALUE",
    PADDED: "PADDED"
};
const $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$53685b05704c5790 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 0;
  box-sizing: border-box;
  min-width: 0;

  ${(props)=>{
    if (props.$cardStyle === $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.TITLE || props.$cardStyle === $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.SECTIONED) return "gap: 24px;";
    else if (props.$cardStyle === $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.PADDED) return `
        > :first-child:not(:last-child) {
          margin-bottom: 24px;
        }
        padding: 16px;
      `;
    else if (props.$cardStyle === $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.VALUE) return `
        position: relative;
        gap: 8px;
        padding: 16px;
      `;
    return "";
}}
`;
/**
 * A standard layout element.
 *
 * For legacy support, include title and tagline props to handle simplified header elements
 *
 * Specify `cardStyle` to get smart layout styles applied.
 * CardStyles.BASIC - no special rules
 * CardStyles.TITLE - Apply 24px spacing from the header to the main content
 * CardStyles.SECTIONED - Apply 24px spacing between all child elements. Wrap each section in a
 *   containing element.
 * CardStyles.PADDED - Applies 24px spacing from the title, and 16px padding on the sides.
 * CardStyles.VALUE - 8px spacing between children, designed to make contained cards to highlight
 *   in individual value with full control over typography and no concerns about layout.
 */ const $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$31b646acab127150 = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    let computedCardStyle = props.cardStyle ?? (props.title || props.tagline ? $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.PADDED : $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.BASIC);
    const includeHeader = Boolean(props.title || props.tagline || props.linkText || props.headerTrailingContent);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$53685b05704c5790, {
        onClick: props.onClick,
        className: props.className,
        ref: ref,
        $cardStyle: computedCardStyle,
        elevated: props.elevated,
        id: props.id && !includeHeader ? props.id : "",
        children: [
            includeHeader && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$efec349ad28d603f$export$2e2bcd8739ae039, {
                id: props.id,
                padded: computedCardStyle !== $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.PADDED,
                headline: props.title,
                supportingText: props.tagline,
                linkText: props.linkText,
                linkProps: props.linkProps,
                trailingContent: props.headerTrailingContent
            }),
            computedCardStyle === $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.TITLE && props.children ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                children: props.children
            }) : props.children
        ]
    });
});
$dfd33cee3229493c$var$$79b0bee0efaf7c48$export$31b646acab127150.propTypes = {
    /** Structure for spacing and layout of the card. Import `CardStyles` to access the constants */ cardStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec)),
    /** Indicate whether this card should receive an elevation. Generally shouldn't set explicitly in favor of Dropdowns */ elevated: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /** Shorthand for inserting a `CardHeader` with a headline specified */ title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /** Shorthand for inserting a `CardHeader` with supportingText specified */ tagline: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /** Action items in the top right of a card. Intended to be a fragment of button like elements */ headerTrailingContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /** Text used for a link like object in the top right corner of a card. In deprecation in favor of headerTrailingContent */ linkText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /** Props to specify configuration of the link in the header. In deprecation in favor of headerTrailingContent */ linkProps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$79b0bee0efaf7c48$export$31b646acab127150.displayName = "Card";
const $dfd33cee3229493c$var$$79b0bee0efaf7c48$var$Card = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$31b646acab127150)``;
var $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$79b0bee0efaf7c48$var$Card;
const $dfd33cee3229493c$var$$cb78dcf5a558c24a$export$fbc13911cd7d2bb8 = {
    BASIC: "BASIC",
    SCROLLABLE: "SCROLLABLE",
    MINIMAL: "MINIMAL" // Only use for totally custom modals that we just want the overlay for
};
const $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).header`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$b68c94e7d753c71b}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme100}
  padding: 16px;
  margin-bottom: 8px;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
`;
const $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledFooter = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).footer`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
`;
const $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledScrollContent = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin: -8px 0;
  overflow-y: auto;
  flex-grow: 1;
  padding: 24px 16px;
`;
const $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledNoScrollContent = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  overflow-y: hidden;
  flex-grow: 1;
  padding: 0 16px;
  &:first-child {
    padding-top: 16px;
  }
`;
const $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledModal = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$2e2bcd8739ae039).attrs({
    cardStyle: $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.BASIC
})`
  width: 100%;
  height: 100%;
  padding: 0;
`;
// Remove base inherited styles, rely on child surface defined above. Just position it
const $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StrippedNPMModal = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$parcel$interopDefault($49904825305e3300$exports))`
  min-width: min(400px, 100vw);
  max-width: 100vw;
  ${(props)=>props.$height ? `height: ${props.$height}px;` : ""}
  max-height: 100vh;
  &:focus-visible {
    outline: none;
  }
`;
$dfd33cee3229493c$var$$parcel$interopDefault($49904825305e3300$exports).defaultStyles.overlay = {
    ...$dfd33cee3229493c$var$$parcel$interopDefault($49904825305e3300$exports).defaultStyles.overlay,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c.zIndexModal,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
};
/**
 * Yuka modal element including a built in header and footer.
 *
 * This is best used by wrapping in other repos to inject the app element prop consistently.
 * This prop is critical for proper accessibility. By default, we will use the first div element
 * that is a direct child of body.
 */ const $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$Modal = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const root = props.appElement || document.querySelector("body > div:first-of-type");
    const { onClose: propsOnClose } = props;
    const onClose = (0, $70fFQ.useCallback)(()=>{
        if (props.closeConfirmationMessage) {
            if (confirm(props.closeConfirmationMessage)) propsOnClose();
        } else propsOnClose();
    }, [
        propsOnClose,
        props.closeConfirmationMessage
    ]);
    let contents;
    if (props.modalStyle === $dfd33cee3229493c$var$$cb78dcf5a558c24a$export$fbc13911cd7d2bb8.SCROLLABLE) contents = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledHeader, {
                as: $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039,
                children: props.title
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledScrollContent, {
                children: props.children
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledFooter, {
                as: $dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                        onClick: onClose,
                        children: props.cancelText
                    }),
                    props.onClickAlt && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                        onClick: props.onClickAlt,
                        children: props.altText
                    }),
                    props.onClickCta && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                        buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.CTA,
                        disabled: props.ctaDisabled,
                        onClick: props.onClickCta,
                        children: props.ctaText
                    })
                ]
            })
        ]
    });
    else if (props.modalStyle === $dfd33cee3229493c$var$$cb78dcf5a558c24a$export$fbc13911cd7d2bb8.BASIC) contents = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            props.title && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledHeader, {
                children: props.title
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledNoScrollContent, {
                children: props.children
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledFooter, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                        onClick: onClose,
                        children: props.cancelText
                    }),
                    props.onClickAlt && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                        onClick: props.onClickAlt,
                        children: props.altText
                    }),
                    props.onClickCta && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                        buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.CTA,
                        onClick: props.onClickCta,
                        disabled: props.ctaDisabled,
                        children: props.ctaText
                    })
                ]
            })
        ]
    });
    else if (props.modalStyle === $dfd33cee3229493c$var$$cb78dcf5a558c24a$export$fbc13911cd7d2bb8.MINIMAL) contents = props.children;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StrippedNPMModal, {
        onRequestClose: props.onClose,
        isOpen: true,
        contentLabel: props.title || "Confirm",
        appElement: root,
        $height: props.height,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5.Provider, {
            value: 2,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb78dcf5a558c24a$var$StyledModal, {
                className: props.className,
                ref: ref,
                elevated: true,
                children: contents
            })
        })
    });
});
$dfd33cee3229493c$var$$cb78dcf5a558c24a$var$Modal.propTypes = {
    modalStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$cb78dcf5a558c24a$export$fbc13911cd7d2bb8)),
    closeConfirmationMessage: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    onClose: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    ctaText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    ctaDisabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    onClickCta: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    cancelText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    onClickAlt: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    altText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    appElement: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    height: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$cb78dcf5a558c24a$var$Modal.defaultProps = {
    modalStyle: $dfd33cee3229493c$var$$cb78dcf5a558c24a$export$fbc13911cd7d2bb8.BASIC,
    cancelText: "Cancel",
    ctaDisabled: false
};
$dfd33cee3229493c$var$$cb78dcf5a558c24a$var$Modal.displayName = "Modal";
var $dfd33cee3229493c$var$$cb78dcf5a558c24a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cb78dcf5a558c24a$var$Modal;
const $dfd33cee3229493c$var$$be25308833f7c58b$var$CONFIRM_MESSAGE = "Are you sure you want to close this form? Any unsaved changes will be lost";
/**
 * A lightweight wrapper around the styleguide form component that hooks in logic for
 * determining if we should prompt on closing.
 *
 * Consider having the <form> element in here as well if handleSubmit/onSubmit provided to
 * abstract that interaction out.
 *
 * @param {object} props
 *
 * @returns {Element}
 */ const $dfd33cee3229493c$var$$be25308833f7c58b$var$FormModal = ({ submitText: submitText, onSubmit: onSubmit, requireDirtyForSubmit: requireDirtyForSubmit, ...props })=>{
    const { dirty: dirty, valid: valid, submitting: submitting } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)({
        subscription: {
            dirty: true,
            valid: true,
            submitting: true
        }
    });
    const { submit: submit } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb78dcf5a558c24a$export$2e2bcd8739ae039, {
        ...props,
        closeConfirmationMessage: dirty ? $dfd33cee3229493c$var$$be25308833f7c58b$var$CONFIRM_MESSAGE : "",
        onClickCta: onSubmit || submit,
        ctaDisabled: !((dirty || !requireDirtyForSubmit) && valid && !submitting),
        ctaText: submitText
    });
};
$dfd33cee3229493c$var$$be25308833f7c58b$var$FormModal.propTypes = {
    requireDirtyForSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    submitText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    onSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
};
$dfd33cee3229493c$var$$be25308833f7c58b$var$FormModal.defaultProps = {
    submitText: "Submit",
    requireDirtyForSubmit: true
};
var $dfd33cee3229493c$var$$be25308833f7c58b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$be25308833f7c58b$var$FormModal;
const $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$Label = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).label`
  + & {
    margin-top: 16px;
  }
  cursor: pointer;
  text-transform: none; // override default label style
  letter-spacing: initial; // override default label style
  display: flex;
  gap: 12px;
  position: relative;
  width: fit-content;
  white-space: ${(props)=>props.$wrap ? "initial" : "nowrap"};
`;
// Class name to retain inherited styles while migrating
const $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$Wrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$StyledHelpText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  ${(props)=>{
    if (props.$error) return $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.sell;
    else if (props.$disabled) return $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30;
    return $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50;
}}
`;
const $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$StyledLabel = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  ${(props)=>props.$disabled ? $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30 : $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
`;
const $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$InputAlignWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  height: 21px;
  display: flex;
  align-items: center;
`;
/**
 * Base component used to wrap an underlying field with a label and error text
 *
 * @param {object} props
 * @param {object} ref
 *
 * @returns {Element}
 */ const $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$_InlineValidatedField = /*#__PURE__*/ (0, $70fFQ.forwardRef)((props, ref)=>{
    const subprops = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).omit(props, [
        "component",
        "className",
        "label",
        "input",
        "meta",
        "onClick",
        "wrapLabel"
    ]);
    const Input = props.component;
    const showError = props.meta?.touched && props?.meta.invalid && !props?.meta.active;
    const errorMessage = showError ? props.meta?.error || props.meta?.submitError : "";
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$f29a25dd8cabf33b$var$Label, {
        className: props.className,
        htmlFor: props.id ?? props.input.name,
        onClick: props.onClick,
        $wrap: props.wrapLabel,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f29a25dd8cabf33b$var$InputAlignWrapper, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Input, {
                    ref: ref,
                    ...subprops,
                    ...props.input,
                    isInvalid: showError
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$f29a25dd8cabf33b$var$Wrapper, {
                children: [
                    props.label && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f29a25dd8cabf33b$var$StyledLabel, {
                        $disabled: props.input.disabled,
                        children: props.label
                    }),
                    props.helpText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f29a25dd8cabf33b$var$StyledHelpText, {
                        $disabled: props.input.disabled,
                        children: props.helpText
                    }),
                    errorMessage && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f29a25dd8cabf33b$var$StyledHelpText, {
                        $error: true,
                        children: errorMessage
                    })
                ]
            })
        ]
    });
});
$dfd33cee3229493c$var$$f29a25dd8cabf33b$var$_InlineValidatedField.propTypes = {
    component: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object
    ]).isRequired,
    label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    helpText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    input: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
        type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        isDisabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
    }),
    meta: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        touched: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        invalid: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        active: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        error: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        submitError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    }),
    wrapLabel: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$f29a25dd8cabf33b$var$_InlineValidatedField.defaultProps = {
    label: "",
    className: "",
    input: null,
    wrapLabel: false
};
const $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$InlineValidatedField = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$f29a25dd8cabf33b$var$_InlineValidatedField)``;
$dfd33cee3229493c$var$$f29a25dd8cabf33b$var$InlineValidatedField.displayName = "InlineValidatedField";
var $dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f29a25dd8cabf33b$var$InlineValidatedField;
const $dfd33cee3229493c$var$$de07a7337aac81e2$var$InputRow = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  width: 100%;
  margin-bottom: 16px;

  > ${$dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039} {
    align-self: center;
  }

  > .flex-input {
    flex-grow: 1;
    flex-shrink: 1;
    min-width: 0;
  }

  > ${$dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039}, > .flex-input,
  > .icon-btn,
  > .btn {
    + .flex-input,
    + ${$dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039} {
      margin-left: 12px;
    }

    + .btn,
    + .icon-btn {
      margin-left: 12px;
      // Comes out to 32px tall, input is 40. Fakes align-self: center but stays aligned when
      // error messages are visible
      margin-top: 4px;
    }
  }
`;
var $dfd33cee3229493c$var$$de07a7337aac81e2$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$de07a7337aac81e2$var$InputRow;
const $dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$783a6a60ccdbd93e = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).createContext("");
const $dfd33cee3229493c$var$$cd5da3c7f6c4a48b$var$FormSection = (props)=>{
    const parentSection = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$783a6a60ccdbd93e);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$783a6a60ccdbd93e.Provider, {
        value: `${parentSection}${props.name}.`,
        children: props.className ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
            className: props.className,
            children: props.children
        }) : props.children
    });
};
$dfd33cee3229493c$var$$cd5da3c7f6c4a48b$var$FormSection.propTypes = {
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node)
    ]).isRequired
};
$dfd33cee3229493c$var$$cd5da3c7f6c4a48b$var$FormSection.defaultProps = {
    className: null
};
var $dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cd5da3c7f6c4a48b$var$FormSection;
const $dfd33cee3229493c$var$$d0399cf1480bcd2b$var$WizardContext = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).createContext(null);
var $dfd33cee3229493c$var$$d0399cf1480bcd2b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$d0399cf1480bcd2b$var$WizardContext;
var $dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "useAnchoredMenu", ()=>$dfd33cee3229493c$var$$fdc23a95238ad2bd$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "useGlobalMenu", ()=>$dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "useDropdown", ()=>$dfd33cee3229493c$var$$218ded47fcfcecd4$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "Card", ()=>$dfd33cee3229493c$var$$79b0bee0efaf7c48$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "CardStyles", ()=>$dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "CardHeader", ()=>$dfd33cee3229493c$var$$efec349ad28d603f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "ComponentGroup", ()=>$dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "FloatingNavigation", ()=>$dfd33cee3229493c$var$$ebc11cb98845bd96$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "GlobalNavigation", ()=>$dfd33cee3229493c$var$$4a521ae1285aa79d$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "GraphLegend", ()=>$dfd33cee3229493c$var$$1c834926e8f33350$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "GraphCard", ()=>$dfd33cee3229493c$var$$8e3ca15e6f703d2a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "Modal", ()=>$dfd33cee3229493c$var$$cb78dcf5a558c24a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "ModalStyles", ()=>$dfd33cee3229493c$var$$cb78dcf5a558c24a$export$fbc13911cd7d2bb8);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "PageSection", ()=>$dfd33cee3229493c$var$$1bb044bd29f42816$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "TooltipCard", ()=>$dfd33cee3229493c$var$$444e6b6b8720e26c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports, "ValueCard", ()=>$dfd33cee3229493c$var$$e3087b75b8d21878$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$49b61417b640529d$export$cb3378c1d3c2a7ea = 2000;
const $dfd33cee3229493c$var$$49b61417b640529d$export$32c0454ceff7f92d = 1000;
const $dfd33cee3229493c$var$$49b61417b640529d$export$3b574867feb0ac0a = 500;
const $dfd33cee3229493c$var$$49b61417b640529d$export$a507d980baa6b21f = 250;
const $dfd33cee3229493c$var$$49b61417b640529d$export$34e77c57b0e8675a = 100;
const $dfd33cee3229493c$var$$49b61417b640529d$export$4dd8b86d77993832 = [
    $dfd33cee3229493c$var$$49b61417b640529d$export$cb3378c1d3c2a7ea,
    $dfd33cee3229493c$var$$49b61417b640529d$export$32c0454ceff7f92d,
    $dfd33cee3229493c$var$$49b61417b640529d$export$3b574867feb0ac0a,
    $dfd33cee3229493c$var$$49b61417b640529d$export$a507d980baa6b21f,
    $dfd33cee3229493c$var$$49b61417b640529d$export$34e77c57b0e8675a
];
const $dfd33cee3229493c$var$$49b61417b640529d$export$b171dc4840747a29 = $dfd33cee3229493c$var$$49b61417b640529d$export$34e77c57b0e8675a;
// Key Codes
const $dfd33cee3229493c$var$$49b61417b640529d$export$728705b4513abbb5 = 27;
const $dfd33cee3229493c$var$$49b61417b640529d$export$8af08f31f8e8fd43 = 37;
const $dfd33cee3229493c$var$$49b61417b640529d$export$6e306041589c0029 = 39;
const $dfd33cee3229493c$var$$49b61417b640529d$export$c6064f55c4ae4962 = 420;
const $dfd33cee3229493c$var$$49b61417b640529d$export$e618540c45827ca8 = 600;
const $dfd33cee3229493c$var$$49b61417b640529d$export$e8da4fc513559f0c = 992;
const $dfd33cee3229493c$var$$49b61417b640529d$export$20dc652ee76c0aea = 1200;
// Bowser Browser Names
const $dfd33cee3229493c$var$$49b61417b640529d$export$6f9bf4075846fe93 = "Firefox";
const $dfd33cee3229493c$var$$49b61417b640529d$export$bb5f2b5daa40e5bb = "Safari";
/**
 * Hook for tracking window dimensions.
 *
 * @returns {object} dimensions { width, height }
 */ const $dfd33cee3229493c$var$$3e3c024a820593dc$var$useWindowDimensions = ()=>{
    const [dimensions, setDimensions] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const onWindowResize = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback(()=>{
        setDimensions({
            height: window.innerHeight,
            width: window.innerWidth
        });
    }, []);
    const onWindowResizeDebounce = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).debounce(onWindowResize, $dfd33cee3229493c$var$$49b61417b640529d$export$34e77c57b0e8675a), [
        onWindowResize
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        window.addEventListener("resize", onWindowResizeDebounce);
        return ()=>{
            window.removeEventListener("resize", onWindowResizeDebounce);
        };
    }, [
        onWindowResizeDebounce
    ]);
    return dimensions;
};
var $dfd33cee3229493c$var$$3e3c024a820593dc$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3e3c024a820593dc$var$useWindowDimensions;
/**
 * Hook used to determine if the component has finished mounting.
 * Useful for suppressing hook functionality on mount.
 *
 * @returns {boolean} True if component finished mounting, False otherwise.
 */ const $dfd33cee3229493c$var$$8ea3e04a44a07747$var$useDidMount = ()=>{
    const [didMount, setDidMount] = (0, $70fFQ.useState)(false);
    (0, $70fFQ.useEffect)(()=>{
        setDidMount(true);
    }, []);
    return didMount;
};
var $dfd33cee3229493c$var$$8ea3e04a44a07747$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8ea3e04a44a07747$var$useDidMount;
const $dfd33cee3229493c$var$$9ce4b15d04da7a4d$var$useScrollPosition = (ref)=>{
    const [position, setPosition] = (0, $70fFQ.useState)({
        top: 0,
        bottom: 0,
        left: 0
    });
    const onScroll = (0, $70fFQ.useCallback)(()=>{
        if (ref.current) {
            const { top: top, bottom: bottom, left: left } = ref.current.getBoundingClientRect();
            setPosition({
                top: top,
                bottom: bottom,
                left: left
            });
        }
    }, [
        ref
    ]);
    const onScrollDebounce = (0, $70fFQ.useMemo)(()=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).debounce(onScroll, $dfd33cee3229493c$var$$49b61417b640529d$export$34e77c57b0e8675a, {
            leading: true,
            trailing: true
        }), [
        onScroll
    ]);
    (0, $70fFQ.useLayoutEffect)(()=>{
        window.addEventListener("scroll", onScrollDebounce, {
            passive: true,
            capture: true
        });
        window.addEventListener("resize", onScrollDebounce);
        onScrollDebounce();
        return ()=>{
            window.removeEventListener("scroll", onScrollDebounce);
            window.removeEventListener("resize", onScrollDebounce);
        };
    }, [
        onScrollDebounce
    ]);
    return [
        position,
        onScrollDebounce
    ];
};
var $dfd33cee3229493c$var$$9ce4b15d04da7a4d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9ce4b15d04da7a4d$var$useScrollPosition;
const $dfd33cee3229493c$var$$8af47c5213e952e5$var$OffsetContext = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).createContext({
    left: 0,
    top: 0
});
const $dfd33cee3229493c$var$$8af47c5213e952e5$var$useDynamicPosition = ({ containerRef: containerRef, elementRef: elementRef, THRESHOLD: THRESHOLD = 0, SPACING: SPACING = 0, OVERHANG: OVERHANG = 0, defaultAbove: defaultAbove = true, orientation: orientation = $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL })=>{
    const windowDimensions = $dfd33cee3229493c$var$$3e3c024a820593dc$export$2e2bcd8739ae039();
    const didMount = $dfd33cee3229493c$var$$8ea3e04a44a07747$export$2e2bcd8739ae039();
    const EARLIER_PRIMARY = `calc(-100% - ${SPACING}px)`;
    const LATER_PRIMARY = `${SPACING}px`;
    const defaultPrimaryDim = defaultAbove ? EARLIER_PRIMARY : LATER_PRIMARY;
    const defaultSecondaryDim = `${-OVERHANG}px`;
    const [above, setAbove] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(defaultAbove);
    const [xTranslate, setXTranslate] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(orientation === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL ? defaultSecondaryDim : defaultPrimaryDim);
    const [yTranslate, setYTranslate] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(orientation === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL ? defaultPrimaryDim : defaultSecondaryDim);
    const [{ top: containerTop, bottom: containerBottom, left: containerLeft }, recalculatePosition] = $dfd33cee3229493c$var$$9ce4b15d04da7a4d$export$2e2bcd8739ae039(containerRef);
    const calculateVerticalPosition = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback(()=>{
        if (didMount && elementRef.current) {
            const { left: left, width: containerWidth = 0 } = containerRef.current?.getBoundingClientRect?.() ?? {};
            const { width: width, height: height } = elementRef.current.getBoundingClientRect();
            const offset = width - containerWidth;
            const pastRightEdge = windowDimensions.width - left - width < THRESHOLD;
            const pastLeftEdge = left - offset < THRESHOLD;
            if (pastRightEdge && !pastLeftEdge) setXTranslate(`${OVERHANG - offset}px`);
            else setXTranslate(`${-OVERHANG}px`);
            const pastTopAbove = containerTop - height + SPACING < THRESHOLD;
            const pastBottomBelow = windowDimensions.height - containerBottom - height - SPACING < THRESHOLD;
            if (defaultAbove && (!pastTopAbove || pastBottomBelow) || !defaultAbove && pastBottomBelow && !pastTopAbove) {
                setAbove(true);
                setYTranslate(EARLIER_PRIMARY);
            } else {
                setAbove(false);
                setYTranslate(LATER_PRIMARY);
            }
        }
    }, [
        didMount,
        containerRef,
        windowDimensions.width,
        windowDimensions.height,
        containerTop,
        containerBottom,
        EARLIER_PRIMARY,
        LATER_PRIMARY,
        OVERHANG,
        SPACING,
        THRESHOLD,
        defaultAbove,
        elementRef
    ]);
    const calculateHorizontalPosition = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback(()=>{
        if (didMount && elementRef.current) {
            const { left: left, width: containerWidth = 0, height: containerHeight } = containerRef.current?.getBoundingClientRect?.() ?? {};
            const { width: width, height: height } = elementRef.current.getBoundingClientRect();
            const pastRightEdge = windowDimensions.width - left - width - containerWidth - SPACING < THRESHOLD;
            const pastLeftEdge = left - width + SPACING < THRESHOLD;
            if (defaultAbove && (!pastLeftEdge || pastRightEdge) || !defaultAbove && pastRightEdge && !pastLeftEdge) {
                setAbove(true);
                setXTranslate(EARLIER_PRIMARY);
            } else {
                setAbove(false);
                setXTranslate(LATER_PRIMARY);
            }
            const offset = height - containerHeight;
            const pastTopAbove = containerTop - offset < THRESHOLD;
            const pastBottomBelow = windowDimensions.height - containerBottom - offset < THRESHOLD;
            if (!pastTopAbove && pastBottomBelow) setYTranslate(`${OVERHANG - offset}px`);
            else setYTranslate(`${-OVERHANG}px`);
        }
    }, [
        didMount,
        containerRef,
        windowDimensions.width,
        windowDimensions.height,
        containerTop,
        containerBottom,
        EARLIER_PRIMARY,
        LATER_PRIMARY,
        OVERHANG,
        SPACING,
        THRESHOLD,
        defaultAbove,
        elementRef
    ]);
    const calculatePosition = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>{
        return orientation === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL ? calculateVerticalPosition : calculateHorizontalPosition;
    }, [
        orientation,
        calculateVerticalPosition,
        calculateHorizontalPosition
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useLayoutEffect(()=>{
        calculatePosition();
    }, [
        calculatePosition
    ]);
    let style;
    if (didMount && containerRef && containerRef.current) {
        // Refetch live position of left and top - if elements have loaded onto the page the container
        // might have moved without useScrollPosition capturing it.
        const { top: containerTopLive, left: containerLeftLive, height: containerHeight, width: containerWidth } = containerRef.current.getBoundingClientRect();
        if (containerTopLive !== containerTop || containerLeftLive !== containerLeft) recalculatePosition();
        if (orientation === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL) style = {
            position: "fixed",
            top: above ? containerTopLive : containerTopLive + containerHeight,
            left: containerLeftLive,
            transform: `translate(${xTranslate}, ${yTranslate})`
        };
        else style = {
            position: "fixed",
            top: containerTopLive,
            left: above ? containerLeftLive : containerLeftLive + containerWidth,
            transform: `translate(${xTranslate}, ${yTranslate})`
        };
    } else style = {
        position: "fixed"
    };
    return [
        style,
        calculatePosition
    ];
};
/**
 * If we nest elements that use `translate` css, `useDynamicPosition` will position the element
 * poorly. This notably happens when we nest multiple elements that are both based on
 * `useDynamicPosition`.
 *
 * The solution here is to store the offsets, and combined with `useIsUnderAnchor` use this to
 * detect that we have nested and render the element within a portal (see `Dropdown` or `Menu`).
 *
 * Rendering in a portal takes the element out of the translated context so the offsets are
 * correct again.
 *
 * Actual values passed to this provider are ignored currently. They could be used in the future
 * if we don't want/need the Portal for any reason.
 */ const $dfd33cee3229493c$var$$8af47c5213e952e5$export$290738bc169aadb6 = ({ left: left, top: top, children: children })=>{
    const { top: baseTop, left: baseLeft } = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$8af47c5213e952e5$var$OffsetContext);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$8af47c5213e952e5$var$OffsetContext.Provider, {
        value: {
            left: left + baseLeft,
            top: top + baseTop
        },
        children: children
    });
};
$dfd33cee3229493c$var$$8af47c5213e952e5$export$290738bc169aadb6.propTypes = {
    left: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    top: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired
};
$dfd33cee3229493c$var$$8af47c5213e952e5$export$290738bc169aadb6.defaultProps = {
    left: 0,
    top: 0
};
const $dfd33cee3229493c$var$$8af47c5213e952e5$export$3b0bcb25c964530b = ()=>{
    const { top: top, left: left } = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$8af47c5213e952e5$var$OffsetContext);
    const isUnderAnchor = Boolean(top || left);
    // When we are under a dynamically positioned element, stop propagating onClick to the body.
    // Notably, this means that `onClickOutside` in `useIsPopupOpen` doesn't trigger when nesting
    // overlay elements.
    const dontPropagateClose = (e)=>{
        e.stopPropagation();
    };
    return (el, style)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$8af47c5213e952e5$export$290738bc169aadb6, {
            left: style?.left,
            top: style?.top,
            children: isUnderAnchor ? $dfd33cee3229493c$var$$parcel$interopDefault($3glZ1).createPortal(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                onMouseDown: dontPropagateClose,
                role: "none",
                children: el
            }), document.body) : el
        });
};
var $dfd33cee3229493c$var$$8af47c5213e952e5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8af47c5213e952e5$var$useDynamicPosition;
const $dfd33cee3229493c$var$$af6555198ddb12f8$export$2467bcf8f6d5c6b6 = 240;
const $dfd33cee3229493c$var$$af6555198ddb12f8$var$MENU_HEIGHT = 320;
const $dfd33cee3229493c$var$$af6555198ddb12f8$export$acb07b4664ac227c = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
  margin: 8px 0;
  height: 1px;
  width: 100%;
`;
const $dfd33cee3229493c$var$$af6555198ddb12f8$var$StyledSurface = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  border-radius: 12px;
  box-sizing: border-box;
  max-height: ${$dfd33cee3229493c$var$$af6555198ddb12f8$var$MENU_HEIGHT}px;
  overflow-y: auto;
  padding: 12px 0;
  min-width: ${$dfd33cee3229493c$var$$af6555198ddb12f8$export$2467bcf8f6d5c6b6}px;
  ${(props)=>props.$style}
`;
const $dfd33cee3229493c$var$$af6555198ddb12f8$var$_Menu = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const render = $dfd33cee3229493c$var$$8af47c5213e952e5$export$3b0bcb25c964530b();
    const menu = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            componentVersion: 2
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$af6555198ddb12f8$var$StyledSurface, {
            role: props.role,
            tabIndex: "-1",
            $style: props.style,
            className: props.className,
            ref: ref,
            elevated: true,
            children: props.children
        })
    });
    return render(menu, props.style);
});
$dfd33cee3229493c$var$$af6555198ddb12f8$var$_Menu.propTypes = {
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Positioning styles computed at runtime */ style: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node).isRequired,
    role: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$af6555198ddb12f8$var$_Menu.defaultProps = {
    role: "menu"
};
const $dfd33cee3229493c$var$$af6555198ddb12f8$var$Menu = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$af6555198ddb12f8$var$_Menu)``;
$dfd33cee3229493c$var$$af6555198ddb12f8$var$Menu.displayName = "Menu";
var $dfd33cee3229493c$var$$af6555198ddb12f8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$af6555198ddb12f8$var$Menu;
const $dfd33cee3229493c$var$$fb72894a53085051$var$StyledText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  flex-grow: 1;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $dfd33cee3229493c$var$$fb72894a53085051$var$StyledSubtext = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
  margin-top: 4px;
  flex-grow: 1;
  ${(props)=>props.$wrap ? `
      white-space: wrap;
    ` : `
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;
const $dfd33cee3229493c$var$$fb72894a53085051$var$StyledAfterText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin-left: 24px;
  line-height: 1;
`;
const $dfd33cee3229493c$var$$fb72894a53085051$var$StyledSingleLineBeforeText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  line-height: 1;
  margin-right: 16px;
  max-width: 24px;
  max-height: 24px;
`;
const $dfd33cee3229493c$var$$fb72894a53085051$var$StyledMultiLineBeforeText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  line-height: 1;
  margin-right: 24px;
  max-width: 32px;
  max-height: 32px;
`;
const $dfd33cee3229493c$var$$fb72894a53085051$var$StyledTextWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: column;
  ${(props)=>props.$wrap ? `
    margin: 12px 0;
  ` : `
    margin: 14px 0;
  `}
  flex-grow: 1;
  min-width: 0;
  width: 100%;
`;
const $dfd33cee3229493c$var$$fb72894a53085051$var$StyledListItem = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).li`
  // normalizing buttons
  background: transparent;
  outline: none;
  border: none;
  color: inherit;
  text-align: left;
  letter-spacing: inherit;
  list-style: none;
  font-size: inherit;
  font-family: inherit;
  margin: 0;
  line-height: inherit;
  width: 100%;

  flex-shrink: 0;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  min-width: 200px;
  min-height: 48px;
  padding: 0 16px;
  ${(props)=>props.onClick || props.href || props.to ? `
    cursor: pointer;
    &:hover {
      background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.hoverTransparent};
    }
    &:active {
      background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.activeTransparent};
    }
  ` : ""}
`;
const $dfd33cee3229493c$var$$fb72894a53085051$var$SingleLineListItem = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledListItem, {
        as: props.as,
        ...props.linkProps,
        ref: ref,
        className: props.className,
        onClick: props.onClick,
        role: props.role,
        children: [
            (props.avatar || props.leadingIcon) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledSingleLineBeforeText, {
                children: props.avatar || /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                    color: props.leadingIconColor,
                    size: 18
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledText, {
                children: props.text
            }),
            props.trailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledAfterText, {
                children: props.trailingContent
            })
        ]
    }));
const $dfd33cee3229493c$var$$fb72894a53085051$var$TwoLineListItem = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledListItem, {
        as: props.as,
        ...props.linkProps,
        ref: ref,
        className: props.className,
        onClick: props.onClick,
        role: props.role,
        children: [
            (props.avatar || props.leadingIcon) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledMultiLineBeforeText, {
                children: props.avatar || /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                    color: props.leadingIconColor,
                    size: 18
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledTextWrapper, {
                $wrap: false,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledText, {
                        children: props.text
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledSubtext, {
                        $wrap: false,
                        children: props.subtext
                    })
                ]
            }),
            props.trailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledAfterText, {
                children: props.trailingContent
            })
        ]
    }));
const $dfd33cee3229493c$var$$fb72894a53085051$var$ThreeLineListItem = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledListItem, {
        as: props.as,
        ...props.linkProps,
        ref: ref,
        className: props.className,
        onClick: props.onClick,
        role: props.role,
        children: [
            (props.avatar || props.leadingIcon) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledMultiLineBeforeText, {
                children: props.avatar || /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                    color: props.leadingIconFill,
                    size: 18
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledTextWrapper, {
                $wrap: true,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledText, {
                        children: props.text
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledSubtext, {
                        $wrap: true,
                        children: props.subtext
                    })
                ]
            }),
            props.trailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$fb72894a53085051$var$StyledAfterText, {
                children: props.trailingContent
            })
        ]
    }));
const $dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c = {
    SINGLE_LINE: "SINGLE_LINE",
    TWO_LINE: "TWO_LINE",
    THREE_LINE: "THREE_LINE"
};
/**
 * A standard item in a list. Contains primary text and optionally includes:
 *
 * - leading icon or avatar
 * - subtext
 * - trailing list control or metadata
 * - onClick handler for an actionable list item
 *
 * NOTE: If using for navigation, use a `NavItem` instead. This includes the `active` state desired
 *
 * Migration from old ListItem props
 * icon => leadingIcon + leadingIconColor
 * thumbnail => avatar
 * children => trailingContent
 * nowrap => deprecated
 * active => deprecated
 */ const $dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44 = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    let StyledElement;
    switch(props.listStyle){
        case $dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c.SINGLE_LINE:
            StyledElement = $dfd33cee3229493c$var$$fb72894a53085051$var$SingleLineListItem;
            break;
        case $dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c.TWO_LINE:
            StyledElement = $dfd33cee3229493c$var$$fb72894a53085051$var$TwoLineListItem;
            break;
        case $dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c.THREE_LINE:
            StyledElement = $dfd33cee3229493c$var$$fb72894a53085051$var$ThreeLineListItem;
            break;
    }
    let [linkProps, linkAs] = $dfd33cee3229493c$var$$da5c189d3d5b3551$export$2e2bcd8739ae039(props.url, props.linkType);
    if (!props.url && !props.onClick) {
        linkAs = "li";
        // clear out link props as unneeded on a <li>
        linkProps = {};
    }
    if (props.children || props.thubnail || props.icon) console.warn("You are passing V1 props to a V2 ListItem. Trailing content and other details may be lost");
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(StyledElement, {
        ref: ref,
        as: linkAs,
        ...props,
        linkProps: linkProps
    });
});
$dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44.propTypes = {
    listStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c)),
    text: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    subtext: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$5e30a8781de33a30$exports)),
    leadingIconColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e)),
    avatar: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
    trailingContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    linkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    url: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    role: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    tabIndex: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44.defaultProps = {
    listStyle: $dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c.SINGLE_LINE,
    leadingIconColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50,
    role: "listitem"
};
$dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44.displayName = "ListItem";
$dfd33cee3229493c$var$$fb72894a53085051$var$SingleLineListItem.propTypes = $dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44.propTypes;
$dfd33cee3229493c$var$$fb72894a53085051$var$TwoLineListItem.propTypes = $dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44.propTypes;
$dfd33cee3229493c$var$$fb72894a53085051$var$ThreeLineListItem.propTypes = $dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44.propTypes;
const $dfd33cee3229493c$var$$fb72894a53085051$var$WrappedListItem = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$fb72894a53085051$export$7b497e9b71607d44)``;
$dfd33cee3229493c$var$$fb72894a53085051$var$WrappedListItem.displayName = "StyledListItem";
var $dfd33cee3229493c$var$$fb72894a53085051$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$fb72894a53085051$var$WrappedListItem;
/**
 * Hook for tracking dimensions of an element based on provided ref.
 *
 * @returns {object} dimensions { width, height }
 */ const $dfd33cee3229493c$var$$17bc54448c105b3f$var$useElementDimensions = (ref)=>{
    const didMount = $dfd33cee3229493c$var$$8ea3e04a44a07747$export$2e2bcd8739ae039();
    const [dimensions, setDimensions] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState({
        height: 0,
        width: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    });
    const onWindowResize = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback(()=>{
        if (!ref.current) {
            setDimensions({
                height: 0,
                width: 0
            });
            return;
        }
        const dims = ref.current.getBoundingClientRect();
        setDimensions(dims);
    }, [
        ref
    ]);
    const onWindowResizeDebounce = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).debounce(onWindowResize, $dfd33cee3229493c$var$$49b61417b640529d$export$b171dc4840747a29), [
        onWindowResize
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        // Arbitrarily checking dims here
        if (didMount) onWindowResize();
    }, [
        didMount,
        onWindowResize
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        window.addEventListener("resize", onWindowResizeDebounce);
        return ()=>{
            window.removeEventListener("resize", onWindowResizeDebounce);
        };
    }, [
        onWindowResizeDebounce
    ]);
    return dimensions;
};
var $dfd33cee3229493c$var$$17bc54448c105b3f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$17bc54448c105b3f$var$useElementDimensions;
// Minimum positioning from edge of screen if we can control it
const $dfd33cee3229493c$var$$e7ffc2504b395055$var$THRESHOLD = 16;
const $dfd33cee3229493c$var$$e7ffc2504b395055$var$DisabledText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
`;
const $dfd33cee3229493c$var$$e7ffc2504b395055$var$Submenu = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  position: absolute;
  top: -12px;
  z-index: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c.zIndexVisible};
  ${(props)=>props.$align}: 100%;
`;
const $dfd33cee3229493c$var$$e7ffc2504b395055$var$StyledMenuListItem = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$fb72894a53085051$export$2e2bcd8739ae039)`
  position: relative;
  min-height: 32px;
  padding: 0 12px;

  ${$dfd33cee3229493c$var$$e7ffc2504b395055$var$Submenu} {
    display: none;
  }

  ${(props)=>props.onClick ? (0, $e42cae22e74e223a$exports.css)`
          ${props.$selected ? `
            background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.hoverTransparent};
          ` : ""}
          &:hover ${$dfd33cee3229493c$var$$e7ffc2504b395055$var$Submenu} {
            display: initial;
          }
        ` : ""}
`;
/**
 * A specialized list item used in Menus
 */ const $dfd33cee3229493c$var$$e7ffc2504b395055$var$MenuItem = (props)=>{
    const defaultColor = props.leadingIconColor || $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50;
    const iconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : defaultColor;
    const hasSubmenu = Boolean(props.submenu);
    const ref = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const { width: windowWidth } = $dfd33cee3229493c$var$$3e3c024a820593dc$export$2e2bcd8739ae039();
    const { left: left, right: right, width: width } = $dfd33cee3229493c$var$$17bc54448c105b3f$export$2e2bcd8739ae039(ref);
    let trailingContent = props.trailingContent;
    if (hasSubmenu) {
        const fitsToRight = right + width + $dfd33cee3229493c$var$$e7ffc2504b395055$var$THRESHOLD < windowWidth;
        const fitsToLeft = left - width > $dfd33cee3229493c$var$$e7ffc2504b395055$var$THRESHOLD;
        // NOTE: align = css value set, opposite of actual alignment relative to item.
        // align = "right" -> submenu to left of main menu
        const align = !fitsToRight && fitsToLeft ? "right" : "left";
        // Submenu included here to be a child of the list item. Otherwise unimportant that it's here
        trailingContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f9cd72ca6584e2be$export$2e2bcd8739ae039, {
                    color: iconColor,
                    size: 16
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e7ffc2504b395055$var$Submenu, {
                    $align: align,
                    children: props.submenu
                })
            ]
        });
    }
    const text = props.disabled ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e7ffc2504b395055$var$DisabledText, {
        children: props.text
    }) : props.text;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e7ffc2504b395055$var$StyledMenuListItem, {
        tabIndex: "-1",
        role: props.role,
        ref: ref,
        url: props.url,
        linkType: props.linkType,
        leadingIcon: props.leadingIcon,
        leadingIconColor: iconColor,
        avatar: props.thumbnail,
        listStyle: $dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c.SINGLE_LINE,
        text: text,
        trailingContent: trailingContent,
        onClick: props.disabled ? null : props.onClick,
        $selected: props.selected
    });
};
$dfd33cee3229493c$var$$e7ffc2504b395055$var$MenuItem.propTypes = {
    text: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    thumbnail: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    leadingIconColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e)),
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    selected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    submenu: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
    url: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    linkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    trailingContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    role: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$e7ffc2504b395055$var$MenuItem.defaultProps = {
    role: "menuitem",
    disabled: false,
    selected: false,
    submenu: null
};
var $dfd33cee3229493c$var$$e7ffc2504b395055$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e7ffc2504b395055$var$MenuItem;
const $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd = (0, $e42cae22e74e223a$exports.css)`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  line-height: 16px;
`;
const $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$29ce903923b9e67f = (0, $e42cae22e74e223a$exports.css)`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  line-height: 18px;
`;
const $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).input`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}

  &:disabled {
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
  }

  font-family: "Google Sans", "Roboto", sans-serif;
  width: 100%;

  ${(props)=>props.readOnly ? `
    cursor: pointer;
  ` : ""}

  ::placeholder,
  ::-ms-input-placeholder,
  &-ms-input-placeholder {
    color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white30};
  }

  // Wipe defaults for everything
  padding: 0;
  border: 0;
  background: none;
  height: unset;
  min-width: 1px;
  outline: none;

  &:focus {
    outline: none;
  }
  &[required] {
    box-shadow: none;
  }

  &:hover,
  &:active {
    background: none;
  }
`;
const $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$e93364aaaa97e46f = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2).attrs({
    as: "textarea"
})`
  min-height: ${(props)=>props.$height ? props.$height : "120px"};
  box-sizing: border-box;
  padding: 11px 0;
  resize: none;
`;
const $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  cursor: text;
  display: flex;
  gap: 12px;
  align-items: center;
  border: 1px solid
    ${(props)=>props.$error ? $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "red") : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
  border-radius: 8px;
  background-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black30};
  box-sizing: border-box; // needed to adjust with padding
  min-height: ${(props)=>props.$size === $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd ? "32px" : "40px"};
  height: ${(props)=>props.$size === $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd ? "32px" : "40px"};
  padding: 0 11px;

  > svg:first-child {
    flex-shrink: 0;
  }

  > svg:last-child {
    flex-shrink: 0;
    padding-left: 12px;
  }

  input,
  textarea {
    ${(props)=>props.$size || $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$29ce903923b9e67f}
  }

  ${(props)=>!props.$error && !props.$disabled ? `
    &:hover {
      border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30};
    }
  ` : ""}
  // Menu style here applies to Select and Autocomplete
  ${$dfd33cee3229493c$var$$af6555198ddb12f8$export$2e2bcd8739ae039}:focus-within + &, &:focus-within {
    border-color: ${(props)=>$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "focussedInputBorder")};
    outline: none;

    // Not passed in HTML because focus isn't a react state 90% of the time
    svg:first-child path {
      fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50};
    }
  }
  ${(props)=>props.$disabled ? `
    background-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white05};
    border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white05};
    color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
  ` : ""}

  ${$dfd33cee3229493c$var$$42b9a489fcea3072$export$209d5e35e7868ba1} + ${$dfd33cee3229493c$var$$42b9a489fcea3072$export$209d5e35e7868ba1} {
    margin-left: 0;
  }
`;
const $dfd33cee3229493c$var$$d9ace6971f853fd7$export$518b0042a2817b1c = "k";
const $dfd33cee3229493c$var$$d9ace6971f853fd7$export$fae2b3a7b5858581 = "m";
const $dfd33cee3229493c$var$$d9ace6971f853fd7$export$6aa47da8da87f2a3 = "b";
/**
 * Converts a number in comma delimited form as a string to a number
 *
 * @param {string} value
 * @returns {number}
 */ function $dfd33cee3229493c$var$$d9ace6971f853fd7$export$fb7c4c8fae29053a(value) {
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isNumber(value)) return value;
    if (!value) return "";
    let totalValueParsed = value.replace(/[$%, ]+/g, "").match(/[0-9.-]+|[a-zA-Z]+/g);
    totalValueParsed = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).dropWhile(totalValueParsed, (segment)=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isNaN($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).toNumber(segment)));
    if (totalValueParsed == null || $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isEmpty(totalValueParsed)) return "";
    if (totalValueParsed.length === 1) return Number(totalValueParsed[0]);
    const scale = {
        [$dfd33cee3229493c$var$$d9ace6971f853fd7$export$518b0042a2817b1c]: 1000,
        [$dfd33cee3229493c$var$$d9ace6971f853fd7$export$fae2b3a7b5858581]: 1000000,
        [$dfd33cee3229493c$var$$d9ace6971f853fd7$export$6aa47da8da87f2a3]: 1000000000
    };
    const modifier = totalValueParsed[1][0].toLowerCase(); // get modifier letter (k, m, b etc)
    const amplifier = scale[modifier] || 1;
    return Number(totalValueParsed[0]) * amplifier;
}
/**
 * Strips characters from an input value. Common use case is to remove the $ or % sign to get a raw
 * number
 *
 * @param {string} value
 * @param {string} symbols
 *
 * @returns {string} value with all instances of characters in symbols removed
 */ function $dfd33cee3229493c$var$$d9ace6971f853fd7$export$c54efeba029d4fe8(value, symbols) {
    let tempValue = value;
    $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).forEach(symbols, (char)=>{
        tempValue = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).replace(tempValue, char, "");
    });
    return tempValue;
}
const $dfd33cee3229493c$var$$d9ace6971f853fd7$export$1731a8088284d4a1 = (yukaTheme, showError, disabled)=>{
    if (showError) return $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(yukaTheme, "red");
    if (disabled) return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15;
    return $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30;
};
/**
 * A wrapper around most input elements to include default icon behaviors and manage variable sizes
 *
 * NOTE: FileInput has it's own version with 2 minor adjustments for the focus action and cursor
 *
 */ const $dfd33cee3229493c$var$$9a78d71e9d90ded5$var$InputWrapper = (props)=>{
    const yukaTheme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    const TrailingIcon = props.showError ? $dfd33cee3229493c$var$$21f83932bf995e14$export$2e2bcd8739ae039 : props.trailingIcon;
    const focusChild = ()=>{
        const refCurrent = props.inputRef.current;
        // DatePicker ref is actually a class that has a ref on `input` attribute
        refCurrent?.input ? refCurrent.input.focus() : refCurrent?.focus();
    };
    const size = props.small ? $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd : $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$29ce903923b9e67f;
    const iconSize = props.small ? 16 : 18;
    const leadingIconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30;
    const trailingIconColor = $dfd33cee3229493c$var$$d9ace6971f853fd7$export$1731a8088284d4a1(yukaTheme, props.showError, props.disabled);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b, {
        $disabled: props.disabled,
        $error: props.showError,
        $size: size,
        onClick: focusChild,
        className: props.className,
        style: props.style,
        children: [
            props.leadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                size: iconSize,
                color: leadingIconColor
            }),
            props.children,
            TrailingIcon && !props.trailingIconOnClick && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(TrailingIcon, {
                size: iconSize,
                color: trailingIconColor
            }),
            TrailingIcon && props.trailingIconOnClick && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039, {
                onClick: props.trailingIconOnClick,
                iconColor: trailingIconColor,
                icon: TrailingIcon,
                size: iconSize
            })
        ]
    });
};
$dfd33cee3229493c$var$$9a78d71e9d90ded5$var$InputWrapper.propTypes = {
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool.isRequired,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool.isRequired,
    trailingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    trailingIconOnClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* ref of underlying input being wrapped */ inputRef: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object.isRequired,
    small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    style: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired
};
var $dfd33cee3229493c$var$$9a78d71e9d90ded5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9a78d71e9d90ded5$var$InputWrapper;
/**
 * A component that renders a standard text input
 */ const $dfd33cee3229493c$var$$a3428f5ff52af727$var$Input = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$9a78d71e9d90ded5$export$2e2bcd8739ae039, {
        ...props,
        inputRef: ref || internalRef,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2, {
            ref: ref || internalRef,
            ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).omit(props, [
                "leadingIcon",
                "trailingIcon",
                "showError",
                "className",
                "style"
            ])
        })
    });
});
$dfd33cee3229493c$var$$a3428f5ff52af727$var$Input.propTypes = {
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    autoComplete: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * If true, disables the input field.
   */ disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The initial value of the input.
   */ value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    // eslint-disable-line react/forbid-prop-types
    /**
   * Function to be executed by an onChange event.
   */ onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * Yuka Icon to be displayed on the left side of the input field.
   */ leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * Text that will appear if nothing has been entered in the input.
   */ placeholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * Icon to be displayed on the right side of the input filed.
   */ trailingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * When true, an error message is shown.
   */ showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /**
   * When true, the input is reduced in size
   */ small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$a3428f5ff52af727$var$Input.defaultProps = {
    name: null,
    autoComplete: "off",
    disabled: false,
    helpText: null,
    leadingIcon: null,
    placeholder: "",
    style: null,
    trailingIcon: null,
    showError: false,
    small: false
};
$dfd33cee3229493c$var$$a3428f5ff52af727$var$Input.displayName = "Input";
var $dfd33cee3229493c$var$$a3428f5ff52af727$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a3428f5ff52af727$var$Input;
/**
 * Match compare string by each part in the array of search strings (split by spaces).
 *
 * @param {string} searchString
 * @param {string} compareString
 * @returns {boolean}
 */ var $dfd33cee3229493c$var$$d88ed55ea4ae4edc$export$2e2bcd8739ae039 = (searchString, compareString)=>{
    const tokenizedSearch = searchString.toLowerCase().trim().split(/\s+/);
    return tokenizedSearch.every((keyword)=>compareString.toLowerCase().includes(keyword));
};
const $dfd33cee3229493c$var$$7678ee5d44a0da14$var$useMenuNavigation = (onItemClick, menuItems, sectioned)=>{
    const [selection, setSelection] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(null);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        setSelection(null);
    }, [
        menuItems
    ]);
    const onKeyDown = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((event)=>{
        if ((event.key === "Enter" || event.key === "Tab") && selection !== null) {
            const selectedItem = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).get(menuItems, selection);
            const onClick = selectedItem.onClick || onItemClick;
            onClick?.(selectedItem);
            setSelection(null);
            event.preventDefault();
        } else if (event.key === "ArrowUp") {
            if (sectioned) {
                // Sectioned array
                if (selection === null) {
                    // Starting arrow nav
                    const menuIndex = menuItems.findLastIndex((x)=>x.length > 0);
                    setSelection([
                        menuIndex,
                        0
                    ]);
                } else if (selection[1] > 0) setSelection([
                    selection[0],
                    selection[1] - 1
                ]);
                else if (selection[0] > 0) setSelection([
                    selection[0] - 1,
                    0
                ]);
                else {
                    // Wrap to bottom
                    const menuIndex = menuItems.findLastIndex((x)=>x.length > 0);
                    setSelection([
                        menuIndex,
                        0
                    ]);
                }
            } else if (selection === null) setSelection([
                menuItems.length - 1
            ]);
            else if (selection.length === 2) {
                // Sub menu
                if (selection[1] > 0) setSelection([
                    selection[0],
                    selection[1] - 1
                ]);
                else setSelection([
                    selection[0],
                    menuItems[selection[0]].length - 1
                ]);
            } else if (selection.length === 1) {
                // Top level menu
                if (selection[0] > 0) setSelection([
                    selection[0] - 1
                ]);
                else setSelection([
                    menuItems.length - 1
                ]);
            }
            event.preventDefault();
        } else if (event.key === "ArrowDown") {
            if (sectioned) {
                // Sectioned array
                if (selection === null) {
                    // Starting arrow nav
                    const menuIndex = menuItems.findIndex((x)=>x.length > 0);
                    setSelection([
                        menuIndex,
                        0
                    ]);
                } else if (menuItems[selection[0]].length > selection[1] + 1) setSelection([
                    selection[0],
                    selection[1] + 1
                ]);
                else if (menuItems.length > selection[0] + 1) setSelection([
                    selection[0] + 1,
                    0
                ]);
                else {
                    // Wrap to top
                    const menuIndex = menuItems.findIndex((x)=>x.length > 0);
                    setSelection([
                        menuIndex,
                        0
                    ]);
                }
            } else if (selection === null) setSelection([
                0
            ]);
            else if (selection.length === 2) {
                // Sub menu
                if (menuItems[selection[0]].length < selection[1] + 1) setSelection([
                    selection[0],
                    selection[1] + 1
                ]);
                else setSelection([
                    selection[0],
                    0
                ]);
            } else if (selection.length === 1) {
                // Top level menu
                if (menuItems.length > selection[0] + 1) setSelection([
                    selection[0] + 1
                ]);
                else setSelection([
                    0
                ]);
            }
            event.preventDefault();
        } else if (event.key === "ArrowRight" && selection.length === 1 && menuItems[selection[0]].menuItems) {
            setSelection([
                selection[0],
                0
            ]);
            event.preventDefault();
        } else if (event.key === "ArrowLeft" && selection.length === 2 && !sectioned) {
            setSelection([
                selection[0]
            ]);
            event.preventDefault();
        }
    }, [
        selection,
        onItemClick,
        menuItems
    ]);
    return [
        onKeyDown,
        selection
    ];
};
var $dfd33cee3229493c$var$$7678ee5d44a0da14$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7678ee5d44a0da14$var$useMenuNavigation;
const $dfd33cee3229493c$var$$1055ba433147a1ec$var$UnhighlightedText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
`;
const $dfd33cee3229493c$var$$1055ba433147a1ec$var$MenuSearchInput = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$a3428f5ff52af727$export$2e2bcd8739ae039)`
  border: none;
  background-color: transparent;
  height: 32px;
`;
const $dfd33cee3229493c$var$$1055ba433147a1ec$var$StyledSectionHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin-left: 12px;
  height: 32px;
  display: flex;
  align-items: center;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7}
`;
/**
 * Based on a tokenized search, highlight the matching sections of text.
 *
 * Note that the current styles have the "highlighted" text color match the default;
 * we are actually just dimming the rest of the text
 *
 * @param {string} text
 * @param {string} search
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$1055ba433147a1ec$var$highlightText = (text, search)=>{
    const tokens = search.split(" ");
    const lowerText = text.toLowerCase();
    const indexes = tokens.map((token)=>({
            index: lowerText.indexOf(token.toLowerCase()),
            token: token
        })).sort((a, b)=>a.index - b.index);
    const resultSegments = [];
    let prevEnd = 0;
    indexes.forEach(({ index: index, token: token })=>{
        if (index > prevEnd) {
            resultSegments.push(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1055ba433147a1ec$var$UnhighlightedText, {
                children: text.slice(prevEnd, index)
            }));
            prevEnd = index;
        }
        if (index + token.length > prevEnd) {
            resultSegments.push(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: text.slice(prevEnd, index + token.length)
            }));
            prevEnd = index + token.length;
        }
    });
    if (prevEnd < text.length) resultSegments.push(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1055ba433147a1ec$var$UnhighlightedText, {
        children: text.slice(prevEnd)
    }));
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($34ccb6660205eec8$exports.Fragment, {
        children: resultSegments
    });
};
/**
 * A hook that integrates the Menu element(s) into an external interface that can be used easily.
 *
 * This hook is intended to be used internally by `useAnchoredMenu` and `useGlobalMenu`
 *
 * @param menuItems - An array of objects in the following shape:
 * {
 *   text: string,
 *   icon: func (Icon component),
 *   thumbnail: Element,
 *   menuItems, // For nesting menu levels
 *   disabled: bool,
 * }
 * Optionally, this can be an array of a config, in which case each config is considered a distinct
 * section. In order to support this, specify the sectioned parameter.
 *
 * This config has the shape:
 * {
 *   header: string,
 *   menuItems: Same shape as above
 *   nonMenuItemNode: Element
 * }
 *
 * @param searchable - a boolean for whether this is searchable. Will error if using multiple
 *   sections in the menu.
 * @param sectioned - a boolean for whether menu items reflect multiple sections. Will error if
 *   enabling search as well
 * @param onSearch - callback function whenever the user searches
 * @param elementRef - ref to attach to the menu
 * @param onItemClick - handler to pass on click of any item (can also specify individually)
 * @param onSearch - handler to handle searching within the menu
 * @param keyHandlerRef - a ref to attach to an element to attach keyboard event listeners to.
 *   Falls back to elementRef
 *
 */ const $dfd33cee3229493c$var$$1055ba433147a1ec$var$useMenu = ({ menuItems: menuItems, searchable: searchable, sectioned: sectioned, elementRef: elementRef, onItemClick: onItemClick, onSearch: onSearch, keyHandlerRef: keyHandlerRef, role: role }, style)=>{
    if (sectioned && searchable) throw new Error("Menus cannot be both sectioned and searchable");
    const [searchValue, setSearch] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState("");
    const searchRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    /**
   * Convert the data in a menu item object into a menu item element
   *
   * @param {object} item
   * @returns {React.Element}
   */ const parseMenuItem = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((item)=>{
        const onClick = item.onClick || onItemClick;
        let generatedSubmenu = null;
        if (item.menuItems) generatedSubmenu = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$af6555198ddb12f8$export$2e2bcd8739ae039, {
            children: item.menuItems.map(parseMenuItem)
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e7ffc2504b395055$export$2e2bcd8739ae039, {
            ...item,
            leadingIcon: item.icon,
            leadingIconColor: item.iconColor,
            onClick: ()=>{
                // Clear search on item selection.
                setSearch("");
                onClick?.(item);
            },
            submenu: generatedSubmenu
        }, item.key || `${item.value}_$_${item.text}`);
    }, [
        onItemClick
    ]);
    const displayedUnselectedMenuItems = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>{
        if (searchable && searchValue !== "") return menuItems.filter((menuItem)=>$dfd33cee3229493c$var$$d88ed55ea4ae4edc$export$2e2bcd8739ae039(searchValue, menuItem.text));
        return menuItems;
    }, [
        searchable,
        searchValue,
        menuItems
    ]);
    const [onKeyDown, selectedElement] = $dfd33cee3229493c$var$$7678ee5d44a0da14$export$2e2bcd8739ae039(onItemClick, displayedUnselectedMenuItems, sectioned);
    const displayedMenuItems = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>{
        if (selectedElement === null) return displayedUnselectedMenuItems;
        return displayedUnselectedMenuItems.map((topLevel, topIndex)=>{
            if (selectedElement[0] === topIndex) {
                if (sectioned || topLevel.menuItems && selectedElement.length === 2) return {
                    ...topLevel,
                    menuItems: topLevel.menuItems.map((item, index)=>index === selectedElement[1] ? {
                            ...item,
                            selected: true
                        } : item)
                };
                return {
                    ...topLevel,
                    selected: true
                };
            }
            return topLevel;
        });
    }, [
        displayedUnselectedMenuItems,
        selectedElement,
        sectioned
    ]);
    const computedMenuItems = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>{
        if (sectioned) {
            const _computed = [];
            displayedMenuItems.forEach((section, sectionNumber)=>{
                if (section.header) _computed.push(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1055ba433147a1ec$var$StyledSectionHeader, {
                    children: section.header
                }));
                if (section.nonMenuItemNode) _computed.push(section.nonMenuItemNode);
                _computed.push(...section.menuItems.map(parseMenuItem));
                if (sectionNumber !== displayedMenuItems.length - 1) _computed.push(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$af6555198ddb12f8$export$acb07b4664ac227c, {
                    role: "separator"
                }, sectionNumber));
            });
            return _computed;
        }
        // filter and convert the text to a highlighted version
        if (searchable && searchValue !== "") return displayedMenuItems.map((menuItem)=>({
                ...menuItem,
                key: `${menuItem.value}_$_${menuItem.text}`,
                // explicitly use the text because it is stable
                text: $dfd33cee3229493c$var$$1055ba433147a1ec$var$highlightText(menuItem.text, searchValue)
            })).map(parseMenuItem);
        return displayedMenuItems.map(parseMenuItem);
    }, [
        displayedMenuItems,
        sectioned,
        searchable,
        searchValue,
        parseMenuItem
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        const target = searchRef.current;
        const altTarget = keyHandlerRef?.current || elementRef?.current;
        if (onKeyDown) {
            target?.addEventListener("keydown", onKeyDown);
            altTarget?.addEventListener("keydown", onKeyDown);
        }
        return ()=>{
            if (onKeyDown) {
                target?.removeEventListener("keydown", onKeyDown);
                altTarget?.removeEventListener("keydown", onKeyDown);
            }
        };
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$af6555198ddb12f8$export$2e2bcd8739ae039, {
        style: style,
        ref: elementRef,
        role: role,
        children: [
            searchable && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1055ba433147a1ec$var$MenuSearchInput, {
                ref: searchRef,
                leadingIcon: $dfd33cee3229493c$var$$30232b0a804943c9$export$2e2bcd8739ae039,
                onChange: (event)=>{
                    setSearch(event.target.value);
                    if (onSearch) onSearch(event.target.value);
                },
                autoFocus: true,
                placeholder: "Search",
                value: searchValue
            }),
            computedMenuItems
        ]
    });
};
var $dfd33cee3229493c$var$$1055ba433147a1ec$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$1055ba433147a1ec$var$useMenu;
/**
 * Manages state to detect if a popup of some kind is open and provides utilities to manage
 * visibility
 *
 * @param {object} ref
 *
 * @returns {Array}
 * - {boolean} if the popup is open
 * - {Function} toggle popup state
 * - {Function} close popup
 */ const $dfd33cee3229493c$var$$62d548a00adc04e3$var$useIsPopupOpen = (containerRef, popupRef)=>{
    const [isOpen, setIsOpen] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(false);
    const onOutsideClick = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((event)=>{
        if (!containerRef.current?.contains(event.target) && !popupRef.current?.contains(event.target) && !(containerRef.current === event.target)) setIsOpen(false);
    }, [
        containerRef,
        popupRef
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        document.addEventListener("mousedown", onOutsideClick);
        return ()=>{
            document.removeEventListener("mousedown", onOutsideClick);
        };
    });
    const toggleIsOpen = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback(()=>setIsOpen((_isOpen)=>!_isOpen), []);
    return [
        isOpen,
        toggleIsOpen
    ];
};
var $dfd33cee3229493c$var$$62d548a00adc04e3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$62d548a00adc04e3$var$useIsPopupOpen;
// Possible eventual upgrade - allow a default alignment to be specified
const $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$THRESHOLD = 16;
const $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$OVERHANG = 0;
const $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$SPACING = -4;
/**
 * A hook that integrates the Menu element(s) into an external interface that can be used easily.
 *
 * This hook is intended to be used to anchor a menu relative to an element
 *
 * @param menuItems - An array of objects in the following shape:
 * {
 *   text: string,
 *   icon: func (Icon component),
 *   submenu: menuItems,
 *   disabled: bool,
 * }
 * Optionally, this can be an array of arrays, in which case each array is considered a distinct
 * section. In order to support this, specify the sectioned parameter.
 *
 * @param searchable - a boolean for whether this is searchable. Will error if using multiple
 *   sections in the menu.
 * @param sectioned - a boolean for whether menu items reflect multiple sections. Will error if
 *   enabling search as well
 * @param defaultAbove - a boolean for whether the dropdown default positions above the anchor
 *   if enough space is available
 */ const $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$useAnchoredMenu = (menuConfig)=>{
    const containerRef = (0, $70fFQ.useRef)(null);
    const elementRef = (0, $70fFQ.useRef)(null);
    const [isOpen, toggleIsOpen] = $dfd33cee3229493c$var$$62d548a00adc04e3$export$2e2bcd8739ae039(containerRef, elementRef);
    const [style, calculatePosition] = $dfd33cee3229493c$var$$8af47c5213e952e5$export$2e2bcd8739ae039({
        containerRef: containerRef,
        elementRef: elementRef,
        THRESHOLD: $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$THRESHOLD,
        OVERHANG: $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$OVERHANG,
        SPACING: $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$SPACING,
        defaultAbove: menuConfig.defaultAbove ?? false,
        orientation: menuConfig.orientation
    });
    // Once it's visible, recalculate position - unable to listen for the ref being attached
    (0, $70fFQ.useEffect)(()=>{
        if (isOpen) calculatePosition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    const onItemClick = (item)=>{
        menuConfig.onItemClick?.(item);
        if (menuConfig.closeOnSelect) toggleIsOpen();
    };
    const ariaProps = {
        "aria-haspopup": menuConfig.role || "menu"
    };
    const menuElement = $dfd33cee3229493c$var$$1055ba433147a1ec$export$2e2bcd8739ae039({
        ...menuConfig,
        onItemClick: onItemClick,
        elementRef: elementRef
    }, style);
    return [
        isOpen ? menuElement : null,
        containerRef,
        toggleIsOpen,
        ariaProps
    ];
};
var $dfd33cee3229493c$var$$fdc23a95238ad2bd$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$fdc23a95238ad2bd$var$useAnchoredMenu;
const $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$THRESHOLD = 16;
const $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$OVERHANG = 0;
const $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$SPACING = 0;
/**
 * A hook that integrates the Menu element(s) into an external interface that can be used easily.
 *
 * This hook is intended to be used to anchor a menu relative to an element
 *
 * @param menuItems - An array of objects in the following shape:
 * {
 *   text: string,
 *   icon: func (Icon component),
 *   submenu: menuItems,
 *   disabled: bool,
 * }
 * Optionally, this can be an array of arrays, in which case each array is considered a distinct
 * section. In order to support this, specify the sectioned parameter.
 *
 * @param searchable - a boolean for whether this is searchable. Will error if using multiple
 *   sections in the menu.
 * @param sectioned - a boolean for whether menu items reflect multiple sections. Will error if
 *   enabling search as well
 */ const $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$useGlobalMenu = (menuConfig)=>{
    const elementRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const [location, setLocation] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState({});
    // Separating this from the lifecycle, combined with location being stored in state means that
    // the menu position is lagged by 1 render
    const onPositionElement = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((event)=>{
        setLocation({
            left: event.pageX,
            top: event.pageY,
            bottom: event.pageY
        });
    });
    // We need the position of the event to use as the focus.
    const fakedContainerRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>({
            current: {
                getBoundingClientRect: ()=>({
                        ...location,
                        width: 0,
                        height: 0
                    })
            }
        }), [
        location
    ]);
    const [style, calculatePosition] = $dfd33cee3229493c$var$$8af47c5213e952e5$export$2e2bcd8739ae039({
        containerRef: fakedContainerRef,
        elementRef: elementRef,
        THRESHOLD: $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$THRESHOLD,
        OVERHANG: $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$OVERHANG,
        SPACING: $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$SPACING,
        defaultAbove: false
    });
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        calculatePosition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location
    ]);
    const menu = $dfd33cee3229493c$var$$1055ba433147a1ec$export$2e2bcd8739ae039({
        ...menuConfig,
        elementRef: elementRef
    }, style);
    return [
        menu,
        onPositionElement
    ];
};
var $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5c81d7ecaf8a9fc9$var$useGlobalMenu;
const $dfd33cee3229493c$var$$61e9efb470f3c2dc$var$Dropdown = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef(({ cardStyle: cardStyle, style: style, children: children }, ref)=>{
    const render = $dfd33cee3229493c$var$$8af47c5213e952e5$export$3b0bcb25c964530b();
    const dropdown = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$53685b05704c5790, {
        elevated: true,
        style: style,
        ref: ref,
        $cardStyle: cardStyle,
        children: children
    });
    return render(dropdown, style);
});
$dfd33cee3229493c$var$$61e9efb470f3c2dc$var$Dropdown.propTypes = {
    cardStyle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec)).isRequired,
    style: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired
};
var $dfd33cee3229493c$var$$61e9efb470f3c2dc$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$61e9efb470f3c2dc$var$Dropdown;
// Possible eventual upgrade - allow a default alignment to be specified
const $dfd33cee3229493c$var$$218ded47fcfcecd4$var$THRESHOLD = 16;
const $dfd33cee3229493c$var$$218ded47fcfcecd4$var$OVERHANG = 0;
const $dfd33cee3229493c$var$$218ded47fcfcecd4$var$SPACING = -4;
/**
 * A hook that integrates an elevated surface to position relative to other elements
 *
 * This hook is intended to be used to anchor a flexible dropdown element to a referring element
 *
 * @param renderContents - a render prop for the contents of the dropdown
 * @param config - Config object for dropdown options.
 *   - defaultAbove - prefer above
 *   - orientation - position vertically overlapping an element or horizontally
 *   if enough space is available
 */ const $dfd33cee3229493c$var$$218ded47fcfcecd4$var$useDropdown = (renderContents, config)=>{
    const containerRef = (0, $70fFQ.useRef)(null);
    const elementRef = (0, $70fFQ.useRef)(null);
    const [isOpen, toggleIsOpen] = $dfd33cee3229493c$var$$62d548a00adc04e3$export$2e2bcd8739ae039(containerRef, elementRef);
    const [style, calculatePosition] = $dfd33cee3229493c$var$$8af47c5213e952e5$export$2e2bcd8739ae039({
        containerRef: containerRef,
        elementRef: elementRef,
        THRESHOLD: $dfd33cee3229493c$var$$218ded47fcfcecd4$var$THRESHOLD,
        OVERHANG: $dfd33cee3229493c$var$$218ded47fcfcecd4$var$OVERHANG,
        SPACING: $dfd33cee3229493c$var$$218ded47fcfcecd4$var$SPACING,
        defaultAbove: config?.defaultAbove ?? false,
        orientation: config?.orientation
    });
    // Once it's visible, recalculate position - unable to listen for the ref being attached
    (0, $70fFQ.useLayoutEffect)(()=>{
        if (isOpen) calculatePosition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    const dropdown = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$61e9efb470f3c2dc$export$2e2bcd8739ae039, {
        style: style,
        ref: elementRef,
        cardStyle: config?.cardStyle || $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.SECTIONED,
        children: renderContents({
            isOpen: isOpen,
            toggleIsOpen: toggleIsOpen
        })
    });
    return [
        isOpen ? dropdown : null,
        containerRef,
        toggleIsOpen
    ];
};
var $dfd33cee3229493c$var$$218ded47fcfcecd4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$218ded47fcfcecd4$var$useDropdown;
const $dfd33cee3229493c$var$$ecaf070af103a025$var$ComponentGroup = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  ${$dfd33cee3229493c$var$$de07a7337aac81e2$export$2e2bcd8739ae039} {
    margin-bottom: 0;
  }
`;
$dfd33cee3229493c$var$$ecaf070af103a025$var$ComponentGroup.propTypes = {
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$ecaf070af103a025$var$ComponentGroup.displayName = "ComponentGroup";
var /* @component */ $dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ecaf070af103a025$var$ComponentGroup;
const $dfd33cee3229493c$var$$ebc11cb98845bd96$var$StyledSurface = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  border-radius: 12px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  width: 256px;
  flex-shrink: 0;
  height: fit-content;
`;
const $dfd33cee3229493c$var$$ebc11cb98845bd96$var$StyledFooter = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$672392da99d9bca0}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
  border-top: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
  margin: 24px 12px 0;
  padding: 24px 0 0;
`;
/**
 * A floating navigation should be used within a specific page to navigate between different
 * sections within it.
 *
 * In most cases, it should be fixed on the layout so a user can always see it.
 */ const $dfd33cee3229493c$var$$ebc11cb98845bd96$var$FloatingNavigation = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            componentVersion: 2
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$ebc11cb98845bd96$var$StyledSurface, {
            role: "menubar",
            "aria-orientation": "vertical",
            children: [
                props.children,
                props.footer && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ebc11cb98845bd96$var$StyledFooter, {
                    children: props.footer
                })
            ]
        })
    });
$dfd33cee3229493c$var$$ebc11cb98845bd96$var$FloatingNavigation.propTypes = {
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    footer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
};
var $dfd33cee3229493c$var$$ebc11cb98845bd96$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ebc11cb98845bd96$var$FloatingNavigation;
const $dfd33cee3229493c$var$$30b200ee48e6674c$var$NavigationStateContext = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).createContext(false);
var $dfd33cee3229493c$var$$30b200ee48e6674c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$30b200ee48e6674c$var$NavigationStateContext;
const $dfd33cee3229493c$var$$4a521ae1285aa79d$var$StyledSurface = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  margin-right: 2px;
  height: 100vh;
  position: sticky;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  width: ${(props)=>props.$collapsed ? "66px" : "256px"};
  transition: width ${$dfd33cee3229493c$var$$49b61417b640529d$export$34e77c57b0e8675a};
  flex-shrink: 0;
`;
const $dfd33cee3229493c$var$$4a521ae1285aa79d$var$LogoWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039).attrs({
    linkStyle: $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.UNSTYLED
})`
  margin: 12px;
  padding: 12px;
`;
const $dfd33cee3229493c$var$$4a521ae1285aa79d$var$StyledFooter = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin: auto 12px 12px;
`;
const $dfd33cee3229493c$var$$4a521ae1285aa79d$var$CollapsibleIconWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  border-radius: 50%;
  position: absolute;
  top: 24px;
  right: -12px;
`;
const $dfd33cee3229493c$var$$4a521ae1285aa79d$var$ScrollContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
/**
 * The global navigation should always be an element fixed to the left of the page and will take up
 * the full page height. It may be collapsible, and generally has a footer containing an element
 * displaying basic user information that when clicked opens a menu.
 */ const $dfd33cee3229493c$var$$4a521ae1285aa79d$var$GlobalNavigation = (props)=>{
    const [collapsed, setCollapsed] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(false);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            componentVersion: 2
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$30b200ee48e6674c$export$2e2bcd8739ae039.Provider, {
            value: collapsed,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$4a521ae1285aa79d$var$StyledSurface, {
                $collapsed: collapsed,
                children: [
                    props.collapsible && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4a521ae1285aa79d$var$CollapsibleIconWrapper, {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039, {
                            icon: collapsed ? $dfd33cee3229493c$var$$f9cd72ca6584e2be$export$2e2bcd8739ae039 : $dfd33cee3229493c$var$$91cd663de23e2605$export$2e2bcd8739ae039,
                            onClick: ()=>setCollapsed((prev)=>!prev)
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4a521ae1285aa79d$var$LogoWrapper, {
                        url: props.homeUrl,
                        linkType: props.homeLinkType,
                        children: props.logo
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4a521ae1285aa79d$var$ScrollContainer, {
                        role: "menubar",
                        "aria-orientation": "vertical",
                        children: props.children
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4a521ae1285aa79d$var$StyledFooter, {
                        children: props.footer?.({
                            collapsed: collapsed
                        })
                    })
                ]
            })
        })
    });
};
$dfd33cee3229493c$var$$4a521ae1285aa79d$var$GlobalNavigation.propTypes = {
    /* URL to navigate to if logo clicked */ homeUrl: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    homeLinkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    /* Site logo */ logo: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element.isRequired,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /* can we collapse the global nav to just icons? */ collapsible: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /* render function, passes object with `collapsed` state */ footer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$4a521ae1285aa79d$var$GlobalNavigation.defaultProps = {
    homeUrl: "/",
    homeLinkType: $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.LOCAL_LINK
};
var $dfd33cee3229493c$var$$4a521ae1285aa79d$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4a521ae1285aa79d$var$GlobalNavigation;
const $dfd33cee3229493c$var$$2716d1189824a9da$var$THRESHOLD = 16;
const $dfd33cee3229493c$var$$2716d1189824a9da$var$OVERHANG = 0; // how much the element is shifted over the element
const $dfd33cee3229493c$var$$2716d1189824a9da$var$SPACING = 8; // gap from the element to the tooltip
const $dfd33cee3229493c$var$$2716d1189824a9da$var$StyledSpacingFloater = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${(props)=>props.$orientation === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL ? `
    padding: 0 ${$dfd33cee3229493c$var$$2716d1189824a9da$var$SPACING}px;
  ` : `
    padding: ${$dfd33cee3229493c$var$$2716d1189824a9da$var$SPACING}px 0;
  `}
  max-width: 240px;
  position: absolute;
  z-index: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c.zIndexModalVisible};
`;
const $dfd33cee3229493c$var$$2716d1189824a9da$var$StyledTooltip = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80};
  border-radius: 4px;
  max-width: 240px;
  padding: 4px 8px;
  width: fit-content;
  overflow-wrap: anywhere;
`;
/**
 * Yuka v2.0
 *
 * A tooltip that appear when you hover over the element with the provider ref attached.
 *
 * Use this using `useTooltip`.
 *
 * Usage: `const tooltipElement = useTooltip(ref, tooltipContents)`
 *
 * `tooltipElement` is null whenever you are not hovering the ref.
 */ const $dfd33cee3229493c$var$$2716d1189824a9da$var$Tooltip = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef(({ orientation: orientation, contents: contents, container: container, id: id }, ref)=>{
    const [style] = $dfd33cee3229493c$var$$8af47c5213e952e5$export$2e2bcd8739ae039({
        containerRef: container,
        elementRef: ref,
        OVERHANG: $dfd33cee3229493c$var$$2716d1189824a9da$var$OVERHANG,
        SPACING: 0,
        THRESHOLD: $dfd33cee3229493c$var$$2716d1189824a9da$var$THRESHOLD,
        orientation: orientation
    });
    return $dfd33cee3229493c$var$$parcel$interopDefault($3glZ1).createPortal(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            mode: "light"
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$2716d1189824a9da$var$StyledSpacingFloater, {
            style: style,
            ref: ref,
            $orientation: orientation,
            role: "presentation",
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$2716d1189824a9da$var$StyledTooltip, {
                id: id,
                role: "tooltip",
                children: contents
            })
        })
    }), document.body);
});
$dfd33cee3229493c$var$$2716d1189824a9da$var$Tooltip.propTypes = {
    contents: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    container: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        current: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object
        ])
    }),
    orientation: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
        $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL,
        $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL
    ]),
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired
};
$dfd33cee3229493c$var$$2716d1189824a9da$var$Tooltip.defaultProps = {
    contents: null,
    container: null
};
$dfd33cee3229493c$var$$2716d1189824a9da$var$Tooltip.displayName = "Tooltip";
var /* @component */ $dfd33cee3229493c$var$$2716d1189824a9da$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2716d1189824a9da$var$Tooltip;
const $dfd33cee3229493c$var$$18a3c60ce8645116$var$useMouseOver = (ref)=>{
    const [mouseOver, setMouseOver] = (0, $70fFQ.useState)(false);
    const onMouseOver = (0, $70fFQ.useCallback)(()=>{
        setMouseOver(()=>true);
    }, [
        setMouseOver
    ]);
    const onMouseOut = (0, $70fFQ.useCallback)(()=>{
        setMouseOver(()=>false);
    }, [
        setMouseOver
    ]);
    // Check :hover to avoid race condition with mouse event callbacks when moving cursor fast
    // https://github.com/facebook/react/issues/4492#issuecomment-569410248
    if (mouseOver && ref.current && !ref.current.matches(`${ref.current.nodeName.toLowerCase()}:hover`)) setMouseOver(false);
    if (!mouseOver && ref.current && ref.current.matches(`${ref.current.nodeName.toLowerCase()}:hover`)) setMouseOver(true);
    (0, $70fFQ.useEffect)(()=>{
        const myRef = ref.current;
        if (myRef) {
            myRef.addEventListener("mouseenter", onMouseOver);
            myRef.addEventListener("mouseleave", onMouseOut);
        }
        return ()=>{
            // Using myRef here because the ref is mutable. This is cleaning up the correct handler
            if (myRef) {
                myRef.removeEventListener("mouseenter", onMouseOver);
                myRef.removeEventListener("mouseleave", onMouseOut);
            }
        };
    });
    return mouseOver;
};
var $dfd33cee3229493c$var$$18a3c60ce8645116$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$18a3c60ce8645116$var$useMouseOver;
// A simple hook to generate a random id string. In React 18, use the built in useId
const $dfd33cee3229493c$var$$143a547f5a6036f0$var$useId = ()=>{
    const id = (0, $70fFQ.useMemo)(()=>Math.random().toString(36).slice(2), []);
    return id;
};
var $dfd33cee3229493c$var$$143a547f5a6036f0$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$143a547f5a6036f0$var$useId;
const $dfd33cee3229493c$var$$2615b6627b5e18e8$var$useTooltip = (ref, contents, config)=>{
    const mouseOver = $dfd33cee3229493c$var$$18a3c60ce8645116$export$2e2bcd8739ae039(ref);
    const id = $dfd33cee3229493c$var$$143a547f5a6036f0$export$2e2bcd8739ae039();
    const tooltipRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const mouseOverTooltip = $dfd33cee3229493c$var$$18a3c60ce8645116$export$2e2bcd8739ae039(tooltipRef);
    const [isEscapePressed, setIsEscapePressed] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(false);
    const isVisible = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>(mouseOver || mouseOverTooltip) && !isEscapePressed, [
        mouseOver,
        mouseOverTooltip,
        isEscapePressed
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        // Reset after mouse out
        if (!mouseOver && !mouseOverTooltip && isEscapePressed) setIsEscapePressed(false);
        const keyPressHandler = (e)=>{
            if (e.code === "Escape" && (mouseOver || mouseOverTooltip)) setIsEscapePressed(true);
        };
        window.addEventListener("keyup", keyPressHandler);
        return ()=>{
            window.removeEventListener("keyup", keyPressHandler);
        };
    }, [
        mouseOver,
        mouseOverTooltip,
        isEscapePressed
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        if (isVisible) ref.current?.setAttribute?.("aria-describedby", id);
        else ref.current?.removeAttribute?.("aria-describedby");
    }, [
        isVisible,
        id,
        ref
    ]);
    return isVisible && contents ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$2716d1189824a9da$export$2e2bcd8739ae039, {
        ref: tooltipRef,
        container: ref,
        id: id,
        contents: contents,
        ...config
    }) : null;
};
var $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2615b6627b5e18e8$var$useTooltip;
const $dfd33cee3229493c$var$$1c834926e8f33350$var$LegendContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  gap: 16px;
  padding: 0 16px;
  box-sizing: border-box;
  justify-content: space-between;
`;
const $dfd33cee3229493c$var$$1c834926e8f33350$var$LegendAlignmentSection = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props)=>props.$align && props.$align === "right" ? "flex-end" : "flex-start"};
  gap: 16px;
`;
const $dfd33cee3229493c$var$$1c834926e8f33350$var$LegendItemContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: ${(props)=>props.$reverse ? "row-reverse" : "row"};
  gap: 12px;
  align-items: center;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$1c834926e8f33350$var$LegendColor = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  height: 14px;
  width: 14px;
  background: ${(props)=>props.$color};
  border-radius: 4px;
`;
const $dfd33cee3229493c$var$$1c834926e8f33350$var$LegendItem = ({ text: text, color: color, tooltip: tooltip, align: align })=>{
    const legendRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const tooltipElement = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(legendRef, tooltip);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$1c834926e8f33350$var$LegendItemContainer, {
        $reverse: align === "right",
        ref: legendRef,
        children: [
            tooltipElement,
            color && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1c834926e8f33350$var$LegendColor, {
                $color: color
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                children: text
            })
        ]
    });
};
$dfd33cee3229493c$var$$1c834926e8f33350$var$LegendItem.propTypes = {
    color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    text: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
    ]),
    tooltip: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    align: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
        "left",
        "right"
    ])
};
const $dfd33cee3229493c$var$$1c834926e8f33350$var$GraphLegend = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$1c834926e8f33350$var$LegendContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1c834926e8f33350$var$LegendAlignmentSection, {
                $align: "left",
                children: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).map($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).filter(props.legendData, (item)=>item.align !== "right"), (legendItem, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1c834926e8f33350$var$LegendItem, {
                        ...legendItem
                    }, `legend_item_${legendItem.text}_${index}`))
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1c834926e8f33350$var$LegendAlignmentSection, {
                $align: "right",
                children: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).map($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).filter(props.legendData, (item)=>item.align === "right"), (legendItem, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1c834926e8f33350$var$LegendItem, {
                        ...legendItem
                    }, `legend_item_${legendItem.text}_${index}`))
            })
        ]
    });
$dfd33cee3229493c$var$$1c834926e8f33350$var$GraphLegend.propTypes = {
    legendData: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        color: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        text: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
        ]),
        tooltip: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        align: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
            "left",
            "right"
        ])
    })).isRequired
};
var $dfd33cee3229493c$var$$1c834926e8f33350$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$1c834926e8f33350$var$GraphLegend;
const $dfd33cee3229493c$var$$8e3ca15e6f703d2a$var$StyledGraphContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  padding: 0 16px;
  flex-grow: 1;
  min-height: 0;
`;
/**
 * In general, graph cards offer a standardized card used to display a card that contains only
 * a legend and all other children, in order. In cases where a more involved card layout involving
 * a graph is required implementors should use the standard Card component, and manually attach
 * the legend.
 *
 * Examples of "more involved layouts" include but are not limited to:
 * 1. Graph legend needs to appear below the graph.
 * 2. Card needs to render a series of filter chips above the graph's legend.
 */ const $dfd33cee3229493c$var$$8e3ca15e6f703d2a$var$GraphCard = ({ legend: legend, children: children, ...props })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$2e2bcd8739ae039, {
        cardStyle: $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.SECTIONED,
        ...props,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1c834926e8f33350$export$2e2bcd8739ae039, {
                legendData: legend
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$8e3ca15e6f703d2a$var$StyledGraphContainer, {
                children: children
            })
        ]
    });
};
$dfd33cee3229493c$var$$8e3ca15e6f703d2a$var$GraphCard.propTypes = {
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    legend: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).array
};
var $dfd33cee3229493c$var$$8e3ca15e6f703d2a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8e3ca15e6f703d2a$var$GraphCard;
const $dfd33cee3229493c$var$$1bb044bd29f42816$var$StyledSurface = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  // Assorted helpful defaults
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
const $dfd33cee3229493c$var$$1bb044bd29f42816$var$PageSection = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef(({ className: className, children: children }, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$1bb044bd29f42816$var$StyledSurface, {
        className: className,
        ref: ref,
        children: children
    }));
$dfd33cee3229493c$var$$1bb044bd29f42816$var$PageSection.propTypes = {
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
};
var $dfd33cee3229493c$var$$1bb044bd29f42816$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$1bb044bd29f42816$var$PageSection;
const $dfd33cee3229493c$var$$444e6b6b8720e26c$var$StyledSurface = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  padding: 12px;
  border-radius: 12px;
`;
const $dfd33cee3229493c$var$$444e6b6b8720e26c$var$TooltipCard = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$444e6b6b8720e26c$var$StyledSurface, {
        ref: ref,
        ...props,
        elevated: true
    }));
$dfd33cee3229493c$var$$444e6b6b8720e26c$var$TooltipCard.displayName = "TooltipCard";
var $dfd33cee3229493c$var$$444e6b6b8720e26c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$444e6b6b8720e26c$var$TooltipCard;
const $dfd33cee3229493c$var$$e3087b75b8d21878$var$StyledValueContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  gap: 8px;
  align-items: baseline;
`;
const $dfd33cee3229493c$var$$e3087b75b8d21878$var$StyledSupportContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  gap: 6px;
  align-items: center;
`;
const $dfd33cee3229493c$var$$e3087b75b8d21878$var$StyledTrailingContent = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  position: absolute;
  top: 12px;
  right: 12px;
  line-height: 0;
`;
/**
 * An opinionated card style for rendering a single value
 */ const $dfd33cee3229493c$var$$e3087b75b8d21878$var$ValueCard = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$79b0bee0efaf7c48$export$2e2bcd8739ae039, {
        className: props.className,
        cardStyle: $dfd33cee3229493c$var$$79b0bee0efaf7c48$export$e4922d83a7be6cec.VALUE,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Overlinetheme50, {
                children: props.headline
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$e3087b75b8d21878$var$StyledValueContainer, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Headline3theme80, {
                        children: props.value
                    }),
                    props.unit && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Overlinetheme30, {
                        children: props.unit
                    })
                ]
            }),
            props.supportingText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$e3087b75b8d21878$var$StyledSupportContainer, {
                children: [
                    props.supportingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.supportingIcon, {
                        color: props.supportingIconColor,
                        size: 16
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Caption2theme50, {
                        children: props.supportingText
                    })
                ]
            }),
            props.additionalText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Caption2theme50, {
                children: props.additionalText
            }),
            props.headerTrailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e3087b75b8d21878$var$StyledTrailingContent, {
                children: props.headerTrailingContent
            })
        ]
    });
$dfd33cee3229493c$var$$e3087b75b8d21878$var$ValueCard.propTypes = {
    headline: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    unit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    supportingText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    supportingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    supportingIconColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e)),
    additionalText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    headerTrailingContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
};
$dfd33cee3229493c$var$$e3087b75b8d21878$var$ValueCard.defaultProps = {
    supportingIconColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80
};
var $dfd33cee3229493c$var$$e3087b75b8d21878$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e3087b75b8d21878$var$ValueCard;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormBase = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$1bb044bd29f42816$export$2e2bcd8739ae039)`
  height: 100vh;
  padding-bottom: 32px;
  box-sizing: border-box;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
  padding: 0 32px 80px;
  max-width: 1264px;
  min-width: 1024px;
  height: fit-content;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormContents = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  gap: 16px;

  > :first-child {
    min-width: 420px;
    flex-grow: 1;
  }

  > :nth-child(2) {
    width: 420px;
    flex-grow: 0;
    flex-shrink: 0;
  }
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FormColumn = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledLogoAndCloseButton = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  margin: 32px 32px 0;
  padding-top: 4px; // to make the total height of the container with contents 80px
  align-items: center;
  justify-content: space-between;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledLogoElement = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledCloseElements = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledFooter = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Body1theme50)`
  margin-top: auto;
  padding-top: 32px;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormLayout = (props)=>{
    const { onClose: onClose } = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$d0399cf1480bcd2b$export$2e2bcd8739ae039);
    const keyPressHandler = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((e)=>{
        if (e.code === "Escape") onClose();
    }, [
        onClose
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        window.addEventListener("keyup", keyPressHandler);
        return ()=>{
            window.removeEventListener("keyup", keyPressHandler);
        };
    }, [
        keyPressHandler
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormBase, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledLogoAndCloseButton, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledLogoElement, {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039, {
                            linkStyle: $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.UNSTYLED,
                            url: props.homeUrl,
                            linkType: props.homeLinkType,
                            children: props.logo
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledCloseElements, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Caption2theme50, {
                                children: '"ESC" to Close'
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039, {
                                icon: $dfd33cee3229493c$var$$e70e94b576d9ab55$export$2e2bcd8739ae039,
                                buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.OUTLINE,
                                onClick: onClose
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormContainer, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledHeader, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Headline3theme100, {
                                children: props.title
                            }),
                            props.subtitle && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Body2theme80, {
                                children: props.subtitle
                            })
                        ]
                    }),
                    props.progressNode,
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormContents, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FormColumn, {
                                children: props.leftContent
                            }),
                            props.rightContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FormColumn, {
                                children: props.rightContent
                            })
                        ]
                    }),
                    props.footer && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4590baa9ea20b4e3$var$StyledFooter, {
                        children: props.footer
                    })
                ]
            })
        ]
    });
};
$dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormLayout.propTypes = {
    title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    subtitle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /* Disclaimers and other footer content */ footer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    progressNode: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
    leftContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element.isRequired,
    rightContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element,
    /* Site logo */ logo: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element.isRequired,
    /* URL to navigate to if logo clicked */ homeUrl: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    homeLinkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4))
};
$dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormLayout.defaultProps = {
    homeUrl: "/",
    homeLinkType: $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.LOCAL_LINK
};
var $dfd33cee3229493c$var$$4590baa9ea20b4e3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4590baa9ea20b4e3$var$FullPageFormLayout;
const $dfd33cee3229493c$var$$ff3c4486de82edb5$var$actionProps = [
    "submitText",
    "submitDisabled",
    "onSubmit",
    "onClose",
    "altText",
    "onClickAlt"
];
const $dfd33cee3229493c$var$$ff3c4486de82edb5$var$passthroughProps = [
    "title",
    "subtitle",
    "footer",
    "leftContent",
    "logo",
    "homeUrl",
    "homeLinkType"
];
/**
 * This is the base interface for creating single step forms that take up the full page.
 *
 * Consider this as a sibling to `Wizard`.
 */ const $dfd33cee3229493c$var$$ff3c4486de82edb5$var$FullPageForm = (props)=>{
    let rightContent = null;
    if (props.summary && props.rightContent) rightContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
                children: props.rightContent
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
                children: props.summary
            })
        ]
    });
    else if (props.summary) rightContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
        children: props.summary
    });
    else if (props.rightContent) rightContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
        children: props.rightContent
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$d0399cf1480bcd2b$export$2e2bcd8739ae039.Provider, {
        value: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, $dfd33cee3229493c$var$$ff3c4486de82edb5$var$actionProps),
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4590baa9ea20b4e3$export$2e2bcd8739ae039, {
            ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, $dfd33cee3229493c$var$$ff3c4486de82edb5$var$passthroughProps),
            rightContent: rightContent
        })
    });
};
$dfd33cee3229493c$var$$ff3c4486de82edb5$var$FullPageForm.propTypes = {
    /*
   * Form header. This accepts nodes in order to support custom typography formatting, but is not
   * designed for more complex elements.
   */ title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /* Disclaimers and other footer content */ footer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /* The main body content of the form */ leftContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /* Interactive elements that are supplemental parts of the form. e.g. file uploads */ rightContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /*
   * Elements that show a summary of the state of the form. Is displayed below the right side
   * content if both are specified
   */ summary: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /* Site logo */ logo: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element.isRequired,
    /* URL to navigate to if logo clicked */ homeUrl: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    homeLinkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    /* Close event handler */ onClose: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    /* Text to display for a submit button */ submitText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* Submit event handler */ onSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    /* Text to display for an alternate action. Only applicable if using the default wizard submit */ onClickAlt: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* Alternate action event handler. Only applicable if using the default wizard submit */ altText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$ff3c4486de82edb5$var$FullPageForm.defaultProps = {
    submitText: "Submit",
    homeUrl: "/",
    homeLinkType: $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.LOCAL_LINK
};
$dfd33cee3229493c$var$$ff3c4486de82edb5$var$FullPageForm.displayName = "FullPageForm";
var $dfd33cee3229493c$var$$ff3c4486de82edb5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ff3c4486de82edb5$var$FullPageForm;
const $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$ProgressBarContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  gap: 12px;
  width: 100%;
`;
const $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$WizardStepItem = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Body1theme50)`
  border-bottom: 4px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50};
  padding-bottom: 8px;
  ${(props)=>props.$showHighlight ? (0, $e42cae22e74e223a$exports.css)`
          border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue500};
          ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.branding}
        ` : ""}
  flex: 1 0 100px;
`;
const $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$actionProps = [
    "submitText",
    "advanceText",
    "submitDisabled",
    "onSubmit",
    "onClose",
    "altText",
    "onClickAlt"
];
const $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$passthroughProps = [
    "title",
    "subtitle",
    "footer",
    "leftContent",
    "logo",
    "homeUrl",
    "homeLinkType"
];
/**
 * An interface for displaying multi step forms. This component needs state to be managed
 * externally. Consider this a more flexible version of `Wizard` when you need more control over
 * implementation details.
 */ const $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$ControlledWizard = (props)=>{
    let rightContent = null;
    if (props.summary && props.rightContent) rightContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
                children: props.rightContent
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
                children: props.summary
            })
        ]
    });
    else if (props.summary) rightContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
        children: props.summary
    });
    else if (props.rightContent) rightContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ecaf070af103a025$export$2e2bcd8739ae039, {
        children: props.rightContent
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$d0399cf1480bcd2b$export$2e2bcd8739ae039.Provider, {
        value: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$actionProps),
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4590baa9ea20b4e3$export$2e2bcd8739ae039, {
            ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$passthroughProps),
            rightContent: rightContent,
            progressNode: props.stepNames.length > 1 && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$ProgressBarContainer, {
                children: props.stepNames.map((name, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$WizardStepItem, {
                        $showHighlight: index < props.currentStep,
                        children: name
                    }, name))
            })
        })
    });
};
$dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$ControlledWizard.propTypes = {
    /*
   * Form header. This accepts nodes in order to support custom typography formatting, but is not
   * designed for more complex elements.
   */ title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /* Disclaimers and other footer content */ footer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /* The main body content of the form */ leftContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /* Interactive elements that are supplemental parts of the form. e.g. file uploads */ rightContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /*
   * Elements that show a summary of the state of the form. Is displayed below the right side
   * content if both are specified
   */ summary: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    stepNames: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string).isRequired,
    currentStep: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number.isRequired,
    /* Site logo */ logo: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element.isRequired,
    /* URL to navigate to if logo clicked */ homeUrl: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    homeLinkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    /* Close event handler */ onClose: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    /* Text to display for a submit button */ submitText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* Text to display for a submit button */ advanceText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* Submit event handler */ onSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    /* Text to display for an alternate action. Only applicable if using the default wizard submit */ onClickAlt: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* Alternate action event handler. Only applicable if using the default wizard submit */ altText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$ControlledWizard.defaultProps = {
    submitText: "Submit",
    advanceText: "Next",
    altText: "Back"
};
$dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$ControlledWizard.displayName = "ControlledWizard";
var $dfd33cee3229493c$var$$5dfa7f39ac2312bb$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5dfa7f39ac2312bb$var$ControlledWizard;
const $dfd33cee3229493c$var$$bc30ae5cc45ee917$var$useWizardSteps = (steps, config)=>{
    const [currentStepNumber, setCurrentStep] = (0, $70fFQ.useState)(config.initialStep || 1);
    // 1 index "currentStep"
    const currentStepConfig = (0, $70fFQ.useMemo)(()=>steps[currentStepNumber - 1], [
        steps,
        currentStepNumber
    ]);
    const stepNames = (0, $70fFQ.useMemo)(()=>steps.map((step)=>step.name), [
        steps
    ]);
    const onClickAlt = currentStepNumber === 1 && !config.onClickAlt ? null : ()=>{
        if (currentStepNumber > 1) setCurrentStep(currentStepNumber - 1);
        config.onClickAlt?.();
    };
    const onSubmit = ()=>{
        currentStepConfig?.onAdvance?.();
        if (currentStepNumber === steps.length) config.onSubmit();
        else setCurrentStep(currentStepNumber + 1);
    };
    return {
        onSubmit: onSubmit,
        onClickAlt: onClickAlt,
        submitText: currentStepNumber === steps.length ? config.submitText : currentStepConfig?.advanceText ?? config.advanceText,
        currentStep: currentStepNumber,
        leftContent: currentStepConfig?.leftContent,
        rightContent: currentStepConfig?.rightContent,
        stepNames: stepNames
    };
};
var $dfd33cee3229493c$var$$bc30ae5cc45ee917$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$bc30ae5cc45ee917$var$useWizardSteps;
/**
 * An interface for displaying fully managed multi step forms. Use this when you don't wish to
 * manage the state for the progress of the form.
 */ const $dfd33cee3229493c$var$$15774296204dd8df$var$Wizard = ({ steps: steps, initialStep: initialStep, onSubmit: onSubmit, onClickAlt: onClickAlt, submitText: submitText, advanceText: advanceText, ...props })=>{
    const config = $dfd33cee3229493c$var$$bc30ae5cc45ee917$export$2e2bcd8739ae039(steps, {
        initialStep: initialStep,
        onSubmit: onSubmit,
        onClickAlt: onClickAlt,
        submitText: submitText,
        advanceText: advanceText
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$5dfa7f39ac2312bb$export$2e2bcd8739ae039, {
        ...props,
        ...config
    });
};
$dfd33cee3229493c$var$$15774296204dd8df$var$Wizard.propTypes = {
    /* Main configuration */ steps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        leftContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
        rightContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
        onAdvance: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    })).isRequired,
    initialStep: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    /*
   * Form header. This accepts nodes in order to support custom typography formatting, but is not
   * designed for more complex elements.
   */ title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /* Disclaimers and other footer content */ footer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /*
   * Elements that show a summary of the state of the form. Is displayed below the right side
   * content if both are specified
   */ summary: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /* Site logo */ logo: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element.isRequired,
    /* URL to navigate to if logo clicked */ homeUrl: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    homeLinkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    /* Close event handler */ onClose: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    /* Text to display for a submit button */ submitText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* Text to display for an advance button */ advanceText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* Submit event handler */ onSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired,
    /* Text to display for an alternate action. Only applicable if using the default wizard submit */ onClickAlt: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /* Alternate action event handler. Only applicable if using the default wizard submit */ altText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$15774296204dd8df$var$Wizard.defaultProps = {
    homeUrl: "/",
    homeLinkType: $dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4.LOCAL_LINK,
    initialStep: 1,
    submitText: "Submit",
    advanceText: "Next",
    altText: "Back"
};
$dfd33cee3229493c$var$$15774296204dd8df$var$Wizard.displayName = "Wizard";
var $dfd33cee3229493c$var$$15774296204dd8df$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$15774296204dd8df$var$Wizard;
const $dfd33cee3229493c$var$$755087928233361e$var$useManagedResolution = (requireDirtyForSubmit, requireValidForSubmit)=>{
    const { submit: submit } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const { valid: valid, submitting: submitting, dirty: dirty } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    return {
        submitDisabled: requireValidForSubmit && !valid || requireDirtyForSubmit && !dirty || submitting,
        onSubmit: submit,
        onClose: ()=>navigate(-1)
    };
};
const $dfd33cee3229493c$var$$755087928233361e$export$1beef25d77eff929 = ({ requireDirtyForSubmit: requireDirtyForSubmit, requireValidForSubmit: requireValidForSubmit, ...props })=>{
    const config = $dfd33cee3229493c$var$$755087928233361e$var$useManagedResolution(requireDirtyForSubmit, requireValidForSubmit);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ff3c4486de82edb5$export$2e2bcd8739ae039, {
        ...config,
        ...props
    });
};
$dfd33cee3229493c$var$$755087928233361e$export$1beef25d77eff929.displayName = "FinalFormFullPageForm";
$dfd33cee3229493c$var$$755087928233361e$export$1beef25d77eff929.propTypes = {
    requireDirtyForSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    requireValidForSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$755087928233361e$export$1beef25d77eff929.defaultProps = {
    requireDirtyForSubmit: true,
    requireValidForSubmit: true
};
const $dfd33cee3229493c$var$$755087928233361e$export$7ffad97d00f295e9 = ({ requireDirtyForSubmit: requireDirtyForSubmit, requireValidForSubmit: requireValidForSubmit, ...props })=>{
    const config = $dfd33cee3229493c$var$$755087928233361e$var$useManagedResolution(requireDirtyForSubmit, requireValidForSubmit);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$5dfa7f39ac2312bb$export$2e2bcd8739ae039, {
        ...config,
        ...props
    });
};
$dfd33cee3229493c$var$$755087928233361e$export$7ffad97d00f295e9.displayName = "FinalFormControlledWizard";
$dfd33cee3229493c$var$$755087928233361e$export$7ffad97d00f295e9.propTypes = {
    requireDirtyForSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    requireValidForSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$755087928233361e$export$7ffad97d00f295e9.defaultProps = {
    requireDirtyForSubmit: true,
    requireValidForSubmit: true
};
const $dfd33cee3229493c$var$$755087928233361e$export$93a4b73b1d3fe50d = ({ requireDirtyForSubmit: requireDirtyForSubmit, requireValidForSubmit: requireValidForSubmit, steps: steps, ...props })=>{
    const config = $dfd33cee3229493c$var$$755087928233361e$var$useManagedResolution(requireDirtyForSubmit, requireValidForSubmit);
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const wrappedSteps = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>steps.map((step)=>({
                ...step,
                onAdvance: step.onAdvance ? ()=>step.onAdvance(values) : undefined
            })), [
        steps,
        values
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$15774296204dd8df$export$2e2bcd8739ae039, {
        ...config,
        ...props,
        steps: wrappedSteps
    });
};
$dfd33cee3229493c$var$$755087928233361e$export$93a4b73b1d3fe50d.displayName = "FinalFormWizard";
$dfd33cee3229493c$var$$755087928233361e$export$93a4b73b1d3fe50d.propTypes = {
    requireDirtyForSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    requireValidForSubmit: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    steps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object).isRequired
};
$dfd33cee3229493c$var$$755087928233361e$export$93a4b73b1d3fe50d.defaultProps = {
    requireDirtyForSubmit: true,
    requireValidForSubmit: true
};
/**
 * Renders buttons to manage progress in a wizard. Notably - submit/advance, and an alternate
 * typically used to go to the previous step.
 */ const $dfd33cee3229493c$var$$e581118688a617d8$var$StandardWizardActions = ()=>{
    const { onSubmit: onSubmit, submitDisabled: submitDisabled, submitText: submitText, onClickAlt: onClickAlt, altText: altText } = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$d0399cf1480bcd2b$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
        children: [
            onClickAlt && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                onClick: onClickAlt,
                children: altText
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                disabled: submitDisabled,
                onClick: onSubmit,
                buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.CTA,
                children: submitText
            })
        ]
    });
};
var $dfd33cee3229493c$var$$e581118688a617d8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e581118688a617d8$var$StandardWizardActions;
const $dfd33cee3229493c$var$$978e65900c11eede$var$StyledButton = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039)`
  width: 100%;
`;
/**
 * Renders a simplified version of the submit buttons that only includes a single button to submit
 * and which stretches the full width of its container.
 */ const $dfd33cee3229493c$var$$978e65900c11eede$var$SimpleWizardActions = ()=>{
    const { onSubmit: onSubmit, submitDisabled: submitDisabled, submitText: submitText } = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$d0399cf1480bcd2b$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$978e65900c11eede$var$StyledButton, {
        disabled: submitDisabled,
        onClick: onSubmit,
        buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$4b45a9754d0756c2.CTA,
        children: submitText
    });
};
var $dfd33cee3229493c$var$$978e65900c11eede$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$978e65900c11eede$var$SimpleWizardActions;
const $dfd33cee3229493c$var$$940ab79e8b119172$var$StyledFilter = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).form`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px;
  gap: 12px;

  > .flex-input {
    flex-grow: 0;
    width: ${(props)=>props.$width}px;
    min-width: 100px;
  }

  > ${$dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039} {
    align-self: center;
  }

  > .btn:last-child {
    margin-left: auto;
  }
  > .btn,
  .icon-btn {
    align-self: center;
  }
`;
/**
 * A basic visual component to render filters with the traditional preferred default UX
 */ const $dfd33cee3229493c$var$$940ab79e8b119172$var$Filter = ({ onReset: onReset, resetText: resetText = "Clear all filters", resetDisabled: resetDisabled = false, width: width = 200, children: children, ...props })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$940ab79e8b119172$var$StyledFilter, {
        ...props,
        onSubmit: (e)=>e.preventDefault(),
        $width: width,
        children: [
            children,
            onReset && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                onClick: onReset,
                disabled: resetDisabled,
                leadingIcon: $dfd33cee3229493c$var$$d9becaa6c2fa453e$export$2e2bcd8739ae039,
                children: resetText
            })
        ]
    });
$dfd33cee3229493c$var$$940ab79e8b119172$var$Filter.propTypes = {
    onReset: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    resetText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    resetDisabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    width: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$940ab79e8b119172$var$Filter.displayName = "Filter";
var $dfd33cee3229493c$var$$940ab79e8b119172$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$940ab79e8b119172$var$Filter;
const $dfd33cee3229493c$var$$95fd02771a9ed6db$var$getWithExpiry = (key)=>{
    const itemStr = window.localStorage.getItem(key);
    if (!itemStr) return null;
    // Delete if expired
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (item.expiry && now.getTime() > item.expiry) {
        window.localStorage.removeItem(key);
        return null;
    }
    return item.value;
};
const $dfd33cee3229493c$var$$95fd02771a9ed6db$var$setWithExpiry = (key, value, ttl = null)=>{
    const now = new Date();
    const item = {
        value: value,
        expiry: ttl !== null ? now.getTime() + ttl : null
    };
    window.localStorage.setItem(key, JSON.stringify(item));
};
const $dfd33cee3229493c$var$$95fd02771a9ed6db$var$useLocalStorage = ()=>{
    const getItem = (0, $70fFQ.useCallback)((key)=>$dfd33cee3229493c$var$$95fd02771a9ed6db$var$getWithExpiry(key), []);
    const setItem = (0, $70fFQ.useCallback)((key, value, ttl)=>$dfd33cee3229493c$var$$95fd02771a9ed6db$var$setWithExpiry(key, value, ttl), []);
    return [
        getItem,
        setItem
    ];
};
var $dfd33cee3229493c$var$$95fd02771a9ed6db$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$95fd02771a9ed6db$var$useLocalStorage;
/**
 * A hook to add to the top level of a form to opt into storing form values in global state.
 *
 * This allows them to be extracted via `formValueSelector` and `createFormValueSelector` selectors
 * elsewhere. Does not return anything, just injects the handlers to treat this form as a filter
 *
 * Should be used to apply filtering to frontend data outside the form context. Common use case is
 * to store the filter values from a form that controls rows displayed in a table.
 *
 * @param {string} formName - the key to identify this form within redux state
 * @param {object} config
 *  - persist: If values should persist even after unmounting. Default: true
 */ const $dfd33cee3229493c$var$$83197600f97e3d4e$var$useFilter = (formName, { formApi: formApi, onChange: onChange = null, persist: persist = true, initialValues: initialValues, values: values } = {})=>{
    const localStorageId = `filter-${formName}`;
    const didMount = $dfd33cee3229493c$var$$8ea3e04a44a07747$export$2e2bcd8739ae039();
    const [getItem, setItem] = $dfd33cee3229493c$var$$95fd02771a9ed6db$export$2e2bcd8739ae039();
    const [prevValues, setPrevValues] = (0, $70fFQ.useState)(getItem(localStorageId) || initialValues || {});
    // Store updated values in local storage
    const onChangeWithLocalState = ({ values: newValues })=>{
        const diffValues = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pickBy(newValues, (value, field)=>value !== prevValues?.[field]);
        setPrevValues(()=>newValues);
        setItem(localStorageId, newValues);
        if (didMount && onChange) onChange(newValues, prevValues, diffValues);
    };
    // This is intended to only be run on initial render. Edge case where form name changes is treated
    // like a remount.
    (0, $70fFQ.useEffect)(()=>{
        // Load saved values into component state
        const diffValues = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pickBy(prevValues, (value, field)=>value !== initialValues?.[field]);
        // Passed values override persisted ones
        if (values) Object.entries(values).forEach(([field, value])=>{
            diffValues[field] = value;
        });
        if (values || !prevValues) setItem(localStorageId, {
            ...initialValues || {},
            ...prevValues || {},
            ...values || {}
        });
        formApi.batch(()=>{
            Object.entries(diffValues).forEach(([field, value])=>{
                formApi.change(field, value);
            });
        });
        return ()=>{
            if (!persist) setItem(localStorageId, null);
        };
    }, [
        formName
    ]);
    return onChangeWithLocalState;
};
var $dfd33cee3229493c$var$$83197600f97e3d4e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$83197600f97e3d4e$var$useFilter;
const $dfd33cee3229493c$var$$7c99044ce213d752$var$FinalFormFilter = ({ formName: formName, onChange: clientOnChange, initialValues: initialValues, values: values, persist: persist = true, ...props })=>{
    const formApi = (0, $0d6cd897c1522156$export$f681a8129d2e9d28)({
        initialValues: initialValues,
        onSubmit: ()=>null
    });
    const onChange = $dfd33cee3229493c$var$$83197600f97e3d4e$export$2e2bcd8739ae039(formName, {
        formApi: formApi,
        onChange: clientOnChange,
        persist: persist,
        initialValues: initialValues,
        values: values
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($42456926338d44c1$export$a7fed597f4b8afd8, {
        form: formApi,
        children: ({ form: { reset: reset }, dirty: dirty })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($42456926338d44c1$export$d2e89184086487cb, {
                        subscription: {
                            values: true
                        },
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$940ab79e8b119172$export$2e2bcd8739ae039, {
                        ...props,
                        resetDisabled: !dirty,
                        onReset: reset
                    })
                ]
            })
    });
};
$dfd33cee3229493c$var$$7c99044ce213d752$var$FinalFormFilter.propTypes = {
    formName: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    initialValues: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    /** Only observed on mount - set default filters that override previous values */ values: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    /** Should the form values be stored after unmount */ persist: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$7c99044ce213d752$var$FinalFormFilter.displayName = "FinalFormFilter";
var $dfd33cee3229493c$var$$7c99044ce213d752$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7c99044ce213d752$var$FinalFormFilter;
var $dfd33cee3229493c$var$$c010c076c78b1556$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "Checkbox", ()=>$dfd33cee3229493c$var$$6cfe30fe9315c100$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "DatePicker", ()=>$dfd33cee3229493c$var$$4e2531e555f1f9b8$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "DelimitedNumberInput", ()=>$dfd33cee3229493c$var$$b467eb62d85e0dc9$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "FileInput", ()=>$dfd33cee3229493c$var$$b616754bcddbd553$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "Input", ()=>$dfd33cee3229493c$var$$a3428f5ff52af727$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "MultipleCheckbox", ()=>$dfd33cee3229493c$var$$41830a11bf46c032$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "PasswordInput", ()=>$dfd33cee3229493c$var$$33dbf99396bbe51c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "RadioGroup", ()=>$dfd33cee3229493c$var$$568c3e0e2fd4254e$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "SelectInput", ()=>$dfd33cee3229493c$var$$c36a08b03cc5dbf3$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "SwitchInput", ()=>$dfd33cee3229493c$var$$7195e09895656fea$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "TextArea", ()=>$dfd33cee3229493c$var$$d0bc4a9b8df9b007$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "AutocompleteInput", ()=>$dfd33cee3229493c$var$$b7593ba9508daed4$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "Field", ()=>$dfd33cee3229493c$var$$2c4674390d92bf46$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "FinalFormField", ()=>$dfd33cee3229493c$var$$ae83ede378baf651$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c010c076c78b1556$exports, "FinalFormArrayField", ()=>$dfd33cee3229493c$var$$f0ac8474900a60e5$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$6cfe30fe9315c100$var$StyledCheckbox = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  box-sizing: border-box;
  display: flex;
  height: 16px;
  width: 16px;
  border-radius: 4px;
  flex-shrink: 0;

  svg {
    display: ${(props)=>props.$checked ? "initial" : "none"};
  }

  ${(props)=>{
    if (props.$disabled) return (0, $e42cae22e74e223a$exports.css)`
        border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
        background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
      `;
    if (props.$checked) return (0, $e42cae22e74e223a$exports.css)`
        border-color: ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "checkbox")};
        background: ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "checkbox")};
      `;
    return (0, $e42cae22e74e223a$exports.css)`
      border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50};
      &:hover {
        border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80};
      }
    `;
}}
`;
/**
 * A styled checkbox input.
 *
 * This uses a custom SVG with the underlying html input hidden.
 */ const $dfd33cee3229493c$var$$6cfe30fe9315c100$var$Checkbox = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const ariaProps = {
        ...props,
        defaultSelected: props.defaultChecked,
        isSelected: props.checked,
        isDisabled: props.disabled,
        "aria-labelledby": props.id ?? props.name
    };
    const state = (0, $401c3720dbbec518$export$8042c6c013fd5226)(ariaProps);
    const altRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const { inputProps: inputProps } = (0, $dc14a8cdff83acd7$export$e375f10ce42261c5)(ariaProps, state, ref || altRef);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($730ba0c4b6fc7e48$export$439d29a4e110a164, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("input", {
                    ref: ref || altRef,
                    ...inputProps
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cfe30fe9315c100$var$StyledCheckbox, {
                $checked: state.isSelected,
                $disabled: props.disabled,
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4ec7b3a9b1d27820$export$2e2bcd8739ae039, {
                    size: 16,
                    color: props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80
                })
            })
        ]
    });
});
$dfd33cee3229493c$var$$6cfe30fe9315c100$var$Checkbox.propTypes = {
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    // eslint-disable-line react/forbid-prop-types
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    style: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).objectOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    ])),
    defaultChecked: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    checked: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    wrapLabel: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$6cfe30fe9315c100$var$Checkbox.defaultProps = {
    disabled: false,
    style: null,
    wrapLabel: false
};
var $dfd33cee3229493c$var$$6cfe30fe9315c100$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6cfe30fe9315c100$var$Checkbox;
const $dfd33cee3229493c$var$$4e2531e555f1f9b8$var$DateInputWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$9a78d71e9d90ded5$export$2e2bcd8739ae039)`
  .react-datepicker__tab-loop {
    z-index: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c.zIndexModalVisible};
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
`;
/**
 * A datepicker widget. This is a wrapper around https://reactdatepicker.com/
 * with our own styling.
 *
 * Note that we currently do not pass all props down to the react-datepicker library,
 * so if you need additional configuration from the original library,
 * you may need to update our implementation.
 */ const $dfd33cee3229493c$var$$4e2531e555f1f9b8$var$DatePicker = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$4e2531e555f1f9b8$var$DateInputWrapper, {
        ...props,
        inputRef: ref || internalRef,
        trailingIcon: $dfd33cee3229493c$var$$5ce412261b038a8e$export$2e2bcd8739ae039,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).Suspense, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2, {
                as: $dfd33cee3229493c$var$$parcel$interopDefault($91f5eddb5f5d2479$exports),
                ref: ref || internalRef,
                autoComplete: "off",
                dateFormat: "MM/dd/yy",
                selected: props.value,
                onChange: props.onChange,
                onBlur: props.onBlur,
                onFocus: props.onFocus,
                disabled: props.disabled,
                maxDate: props.maxDate,
                minDate: props.minDate,
                placeholderText: props.placeholder,
                name: props.name,
                id: props.id
            })
        })
    });
});
$dfd33cee3229493c$var$$4e2531e555f1f9b8$var$DatePicker.propTypes = {
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).instanceOf(Date),
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    onBlur: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    onFocus: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    maxDate: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).instanceOf(Date),
    minDate: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).instanceOf(Date),
    placeholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$4e2531e555f1f9b8$var$DatePicker.defaultProps = {
    disabled: false,
    maxDate: null,
    minDate: null,
    placeholder: "",
    small: false
};
const $dfd33cee3229493c$var$$4e2531e555f1f9b8$export$3ae94a2503e890a1 = (value)=>{
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isDate(value)) return value;
    // https://stackoverflow.com/a/27768777 - see comment
    // 2020-01-30 gets converted as midnight UTC, 2020/01/30 gets converted to midnight local.
    // local time gives reliable value for date picker
    if (value && $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isString(value)) {
        if (!$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).includes(value, "T")) return new Date(value.replaceAll("-", "/"));
        return new Date(value);
    }
    return value;
};
var $dfd33cee3229493c$var$$4e2531e555f1f9b8$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$4e2531e555f1f9b8$var$DatePicker;
var $dfd33cee3229493c$var$$ba530530b13dfca4$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ba530530b13dfca4$exports, "setSetting", ()=>$dfd33cee3229493c$var$$ba530530b13dfca4$export$61fd6f1ddd0c20e2);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$ba530530b13dfca4$exports, "getSetting", ()=>$dfd33cee3229493c$var$$ba530530b13dfca4$export$8206e8d612b3e63);
const $dfd33cee3229493c$var$$ba530530b13dfca4$var$settings = {
    Modal: {
        onClose: (props)=>(value)=>props?.onClose && props.onClose(value)
    },
    Select: {
        matchFn: (search, comparison)=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).includes(comparison, search)
    },
    logError: ()=>null
};
const $dfd33cee3229493c$var$$ba530530b13dfca4$export$61fd6f1ddd0c20e2 = (setting, value)=>{
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).get($dfd33cee3229493c$var$$ba530530b13dfca4$var$settings, setting)) $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).set($dfd33cee3229493c$var$$ba530530b13dfca4$var$settings, setting, value);
    else throw Error("Invalid setting specified");
};
const $dfd33cee3229493c$var$$ba530530b13dfca4$export$8206e8d612b3e63 = (setting)=>{
    const value = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).get($dfd33cee3229493c$var$$ba530530b13dfca4$var$settings, setting);
    // Sanity clean to prevent overwrite, etc
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isArray(value)) return [
        ...value
    ];
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isFunction(value)) return value;
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isObject(value)) return {
        ...value
    };
    return value;
};
const $dfd33cee3229493c$var$$b467eb62d85e0dc9$var$AUTO_END_CHARACTERS = [
    ".",
    $dfd33cee3229493c$var$$d9ace6971f853fd7$export$518b0042a2817b1c,
    $dfd33cee3229493c$var$$d9ace6971f853fd7$export$fae2b3a7b5858581,
    $dfd33cee3229493c$var$$d9ace6971f853fd7$export$6aa47da8da87f2a3
];
/*
 * This function can be passed as `props.parse` to React Final Form `Field`
 */ const $dfd33cee3229493c$var$$b467eb62d85e0dc9$export$a7737621d70c08a2 = (value)=>{
    const cachedRes = value || "";
    // If trailing 0 after decimal or trailing decimal, reattach and store as string to keep those
    // characters.
    if (value === ".") return "0.";
    const trailingCharsMatch = cachedRes.match(/(\.0+)$|\.[0-9]*[1-9](0+)$|(\.)$/);
    if (trailingCharsMatch) {
        // 3 possible groups to match against above. Only 1 will actually match, grab it
        // Either trailing 0's only after the decimal, trailing 0's after decimal positions or hanging .
        // eslint-disable-next-line no-magic-numbers
        const myMatch = trailingCharsMatch[1] || trailingCharsMatch[2] || trailingCharsMatch[3];
        // Implicit conversion to string representing raw number
        return $dfd33cee3229493c$var$$d9ace6971f853fd7$export$fb7c4c8fae29053a(value) + myMatch;
    }
    return $dfd33cee3229493c$var$$d9ace6971f853fd7$export$fb7c4c8fae29053a(value);
};
/*
 * This function can be passed as `props.format` to React Final Form `Field`
 */ const $dfd33cee3229493c$var$$b467eb62d85e0dc9$export$be206aa0a590ffb3 = (storeValue)=>{
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isNil(storeValue)) return storeValue;
    // Takes numerical value (or string with trailing insignificant digits), inserts commas in
    const initialInParts = storeValue.toString().split(".");
    initialInParts[0] = initialInParts[0].split(/(?=(?:\d{3})+$)/).join(",");
    return initialInParts.join(".");
};
/**
 * This field provides additional behavior around inputting large numbers. Specifically, it
 *
 * 1. Automatically adds commas (and moves the cursor intuitively)
 * 2. Expands trailing "k", "m", and "b" with zeros
 *
 * This functionality is provided via helpers that are not actually visible within the stories
 * but are provided as helper functions for React Final Form to use alongside
 *
 * Note: This currently depends on final-form to apply formatting properly.
 */ class $dfd33cee3229493c$var$$b467eb62d85e0dc9$var$DelimitedNumberInput extends $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).Component {
    constructor(){
        super();
        this.ref = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).createRef();
        this.onChange = this.onChange.bind(this);
    }
    getSnapshotBeforeUpdate() {
        const newValue = this.props.value || "";
        // Grab the value in the actual input after the last keystroke
        const currentCommaCount = this.ref.current.value.split(",").length - 1;
        // Grab the updated value with commas inserted as appropriate
        const updatedCommaCount = newValue.split(",").length - 1;
        let cursorPos = 0;
        try {
            cursorPos = this.ref.current.selectionStart;
        } catch (e) {
            // in Safari, accessing current.selectionStart may throw a TypeError.
            // in this case, use the default value of 0
            // manually log the error because we are catching it
            const errorPostDetails = {
                e: e,
                route: window.location.href
            };
            $dfd33cee3229493c$var$$ba530530b13dfca4$export$8206e8d612b3e63("logError")(errorPostDetails);
        }
        // Grab the added commas for cursor positioning and the previous cursor position
        return {
            // The number of commas programmatically added/removed
            commaDiff: updatedCommaCount - currentCommaCount,
            cursorPos: cursorPos,
            cursorAtEnd: cursorPos === this.ref.current.value.length,
            lastChar: this.ref.current.value[this.ref.current.value.length - 1]
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        // Make sure cursor position is set correctly
        const value = this.props.value;
        // If we have a decimal at the end, cursor is at the end, stay there
        // If we used k, m, b as a shortcut, move to end of new value
        const autoEnd = value && $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).includes($dfd33cee3229493c$var$$b467eb62d85e0dc9$var$AUTO_END_CHARACTERS, $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).toLower(snapshot.lastChar)) && snapshot.cursorAtEnd;
        if (snapshot && document.activeElement === this.ref.current && !autoEnd) {
            const cursorAdjustment = snapshot.commaDiff;
            if (snapshot.cursorPos - cursorAdjustment < 0) {
                // If the cursor should go back to the beginning (deleted from front, etc)
                this.ref.current.selectionStart = 0;
                this.ref.current.selectionEnd = 0;
            } else {
                // We typed in the middle/end or removed characters from the middle
                // Position it to where the cursor was and adjust for any commas that we added/removed
                this.ref.current.selectionStart = snapshot.cursorPos + snapshot.commaDiff;
                this.ref.current.selectionEnd = snapshot.cursorPos + snapshot.commaDiff;
            }
        }
    }
    onChange(event) {
        const prevValue = this.props.value || "";
        const newValue = event.target.value || "";
        // If trying to remove a single comma, reset the cursor.
        const cursorPos = event.target.selectionStart;
        if (prevValue !== newValue && newValue && prevValue.length === newValue.length + 1 && newValue.split(",").length - prevValue.split(",").length < 0) {
            /* eslint-disable no-param-reassign */ event.target.value = this.props.value;
            event.target.selectionStart = cursorPos + 1;
            event.target.selectionEnd = cursorPos + 1;
            /* eslint-enable no-param-reassign */ return;
        }
        this.props.onChange(event);
    }
    render() {
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$9a78d71e9d90ded5$export$2e2bcd8739ae039, {
            ...this.props,
            inputRef: this.ref,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2, {
                ref: this.ref,
                ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).omit(this.props, [
                    "leadingIcon",
                    "trailingIcon",
                    "showError",
                    "className",
                    "style"
                ]),
                onChange: this.onChange,
                value: this.props.value || "",
                type: "text"
            })
        });
    }
}
$dfd33cee3229493c$var$$b467eb62d85e0dc9$var$DelimitedNumberInput.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    // eslint-disable-line react/forbid-prop-types
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    trailingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$b467eb62d85e0dc9$var$DelimitedNumberInput.defaultProps = {
    showError: false,
    small: false
};
var $dfd33cee3229493c$var$$b467eb62d85e0dc9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b467eb62d85e0dc9$var$DelimitedNumberInput;
const $dfd33cee3229493c$var$$b616754bcddbd553$var$StyledFileInputWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b)`
  cursor: default;
`;
/**
 * A standard element for uploading either a single file, or multiple files.
 */ const $dfd33cee3229493c$var$$b616754bcddbd553$var$FileInput = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const yukaTheme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const TrailingIcon = props.showError ? $dfd33cee3229493c$var$$21f83932bf995e14$export$2e2bcd8739ae039 : props.trailingIcon;
    const leadingIconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30;
    const trailingIconColor = $dfd33cee3229493c$var$$d9ace6971f853fd7$export$1731a8088284d4a1(yukaTheme, props.showError, props.disabled);
    const onChange = (e)=>{
        props.onChange(e.target.files);
    };
    const size = props.small ? $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd : $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$29ce903923b9e67f;
    const iconSize = props.small ? 16 : 18;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$b616754bcddbd553$var$StyledFileInputWrapper, {
        $disabled: props.disabled,
        $error: props.showError,
        $size: size,
        children: [
            props.leadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                size: iconSize,
                color: leadingIconColor
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2, {
                ref: ref || internalRef,
                ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).omit(props, [
                    "leadingIcon",
                    "trailingIcon",
                    "showError",
                    "className",
                    "style",
                    "value"
                ]),
                onChange: onChange,
                type: "file"
            }),
            TrailingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(TrailingIcon, {
                size: iconSize,
                color: trailingIconColor
            })
        ]
    });
});
$dfd33cee3229493c$var$$b616754bcddbd553$var$FileInput.propTypes = {
    placeholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    // eslint-disable-line react/forbid-prop-types
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    multiple: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    style: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).objectOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    ])),
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    trailingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$b616754bcddbd553$var$FileInput.defaultProps = {
    placeholder: "",
    disabled: false,
    style: null,
    multiple: false,
    showError: false,
    small: false
};
var $dfd33cee3229493c$var$$b616754bcddbd553$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b616754bcddbd553$var$FileInput;
const $dfd33cee3229493c$var$$41830a11bf46c032$var$SingleCheckbox = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039)`
  margin-top: 4px;
  & + & {
    margin-top: 8px;
  }
`;
const $dfd33cee3229493c$var$$41830a11bf46c032$var$StyledCheckboxList = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: ${(props)=>props.$horizontal ? "row" : "column"};
  gap: ${(props)=>props.$horizontal ? "24px" : "0"};
`;
/**
 * An abstraction for a set of checkboxes for 1 field
 *
 * @param {object} props
 * @returns {Element}
 */ const $dfd33cee3229493c$var$$41830a11bf46c032$var$MultipleCheckbox = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const propsValue = Array.isArray(props.value) ? props.value : [];
    const onChange = (value)=>{
        const prev = propsValue ?? [];
        if (prev.findIndex((val)=>val === value) === -1) {
            const next = [
                ...prev,
                value
            ];
            props.onChange?.(next);
        } else {
            const withoutCurrent = prev.filter((v)=>v !== value);
            props.onChange?.(withoutCurrent);
        }
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$41830a11bf46c032$var$StyledCheckboxList, {
        $horizontal: props.orientation === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL,
        children: props.options.map(({ label: label, value: value, helpText: helpText })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$41830a11bf46c032$var$SingleCheckbox, {
                input: {
                    type: "checkbox",
                    name: props.name,
                    disabled: props.disabled,
                    value: label,
                    onChange: ()=>onChange(value),
                    checked: (propsValue ?? []).includes(value)
                },
                id: label,
                label: label,
                helpText: helpText,
                wrapLabel: props.wrapLabel,
                component: $dfd33cee3229493c$var$$6cfe30fe9315c100$export$2e2bcd8739ae039
            }, label))
    });
});
$dfd33cee3229493c$var$$41830a11bf46c032$var$MultipleCheckbox.propTypes = {
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    wrapLabel: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    options: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any
    })).isRequired,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).array,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    ]),
    orientation: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
        $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL,
        $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL
    ])
};
$dfd33cee3229493c$var$$41830a11bf46c032$var$MultipleCheckbox.defaultProps = {
    wrapLabel: false,
    orientation: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL
};
var $dfd33cee3229493c$var$$41830a11bf46c032$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$41830a11bf46c032$var$MultipleCheckbox;
const $dfd33cee3229493c$var$$a682d54f8f8c4da1$var$StyledProgressBar = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  width: 240px;
  height: 4px;
  border-radius: 2px;
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white05};
`;
const $dfd33cee3229493c$var$$a682d54f8f8c4da1$var$StyledProgressMeter = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  height: 4px;
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue500};
`;
/**
 * A simple presentational component that creates a progress indicator
 *
 * @param {object} props
 *
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$a682d54f8f8c4da1$var$ProgressBar = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$a682d54f8f8c4da1$var$StyledProgressBar, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$a682d54f8f8c4da1$var$StyledProgressMeter, {
            style: {
                ...props.style,
                width: `${props.progress / props.total * 100}%`
            }
        })
    });
$dfd33cee3229493c$var$$a682d54f8f8c4da1$var$ProgressBar.propTypes = {
    progress: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number.isRequired,
    total: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number.isRequired,
    style: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object // eslint-disable-line react/forbid-prop-types
};
$dfd33cee3229493c$var$$a682d54f8f8c4da1$var$ProgressBar.defaultProps = {
    style: {}
};
$dfd33cee3229493c$var$$a682d54f8f8c4da1$var$ProgressBar.displayName = "ProgressBar";
var $dfd33cee3229493c$var$$a682d54f8f8c4da1$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a682d54f8f8c4da1$var$ProgressBar;
function $dfd33cee3229493c$var$$33dbf99396bbe51c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($dfd33cee3229493c$var$$33dbf99396bbe51c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $dfd33cee3229493c$var$$33dbf99396bbe51c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $dfd33cee3229493c$var$$33dbf99396bbe51c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$PasswordStrengthIndicator = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  width: 100%;
  .progress-bar {
    background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
    height: 8px;
    margin: 8px 0;
    width: 100%;
  }
  .progress-bar__completion {
    height: 8px;
  }
`;
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$StyledStrengthText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).p`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
  margin-bottom: 0;
`;
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$StyledStrengthScore = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
`;
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$StyledSuggestionList = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).ul`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  margin: 0;
  list-style: outside;
  padding-left: 16px;
`;
let $dfd33cee3229493c$var$$33dbf99396bbe51c$var$checker = null;
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$MAX_SCORE = 4;
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$DEFAULT_STRENGTH_INFO = {
    score: 0,
    feedback: {
        warning: "",
        suggestions: []
    }
};
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$STRENGTH_TO_FILL_MAPPING = [
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.sell,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.sell,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.alert,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.buy,
    $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.buy
];
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$STRENGTH_TO_READABLE_MAPPING = [
    "Very Weak",
    "Weak",
    "Fair",
    "Good",
    "Strong"
];
const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$getStyle = (strengthInfo)=>({
        background: $dfd33cee3229493c$var$$33dbf99396bbe51c$var$STRENGTH_TO_FILL_MAPPING[strengthInfo.score]
    });
/**
 * A password input field combined with a password strength indicator provided by zxcvbn.
 *
 * According to our Password Management Policy, we do not require any additional password
 * complexity requirements other than a minimum length of 8 characters. As a compensating
 * measure, we are required to present a password strength indicator for context for the user.
 */ const $dfd33cee3229493c$var$$33dbf99396bbe51c$var$PasswordInput = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const [checkFn, setCheckFn] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(()=>$dfd33cee3229493c$var$$33dbf99396bbe51c$var$checker);
    const [strengthInfo, setStrengthInfo] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState($dfd33cee3229493c$var$$33dbf99396bbe51c$var$DEFAULT_STRENGTH_INFO);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        if (props.displayIndicator && !checkFn) // library recommends. `checker` is a convenience to store it so we don't need to re-fetch later
        Promise.resolve().then(function() {
            return $db7e45bc78c04383$exports;
        }).then((res)=>$dfd33cee3229493c$var$$33dbf99396bbe51c$var$_interopRequireWildcard(res)).then((lib)=>{
            $dfd33cee3229493c$var$$33dbf99396bbe51c$var$checker = lib.default;
            setCheckFn(()=>lib.default);
        });
    });
    const suggestions = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).get(strengthInfo, "feedback.suggestions", []);
    const { onChange: propsOnChange } = props;
    const onChange = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((e)=>{
        propsOnChange?.(e);
        if (checkFn && e.target.value) setStrengthInfo(checkFn(e.target.value));
        else setStrengthInfo($dfd33cee3229493c$var$$33dbf99396bbe51c$var$DEFAULT_STRENGTH_INFO);
    }, [
        checkFn,
        propsOnChange
    ]);
    // set password as the type given in `props.input`
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$a3428f5ff52af727$export$2e2bcd8739ae039, {
                ref: ref,
                ...props,
                onChange: onChange
            }),
            props.displayIndicator && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$33dbf99396bbe51c$var$PasswordStrengthIndicator, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$a682d54f8f8c4da1$export$2e2bcd8739ae039, {
                        total: $dfd33cee3229493c$var$$33dbf99396bbe51c$var$MAX_SCORE,
                        progress: strengthInfo.score,
                        style: $dfd33cee3229493c$var$$33dbf99396bbe51c$var$getStyle(strengthInfo)
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$33dbf99396bbe51c$var$StyledStrengthText, {
                                children: [
                                    "Password strength:\xa0",
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$33dbf99396bbe51c$var$StyledStrengthScore, {
                                        children: $dfd33cee3229493c$var$$33dbf99396bbe51c$var$STRENGTH_TO_READABLE_MAPPING[strengthInfo.score]
                                    })
                                ]
                            }),
                            !$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isEmpty(suggestions) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$33dbf99396bbe51c$var$StyledStrengthText, {
                                        children: "Suggestion:"
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$33dbf99396bbe51c$var$StyledSuggestionList, {
                                        children: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).map(suggestions, (suggestion)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                                children: suggestion
                                            }, suggestion))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$dfd33cee3229493c$var$$33dbf99396bbe51c$var$PasswordInput.propTypes = {
    displayIndicator: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$33dbf99396bbe51c$var$PasswordInput.defaultProps = {
    displayIndicator: true
};
var $dfd33cee3229493c$var$$33dbf99396bbe51c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$33dbf99396bbe51c$var$PasswordInput;
const $dfd33cee3229493c$var$$90c57b1e46d07721$var$StyledRadioButton = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  box-sizing: border-box;
  display: flex;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;

  &:before {
    // this is the little dimple in the middle
    background: ${(props)=>props.$disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.black80};
    border-radius: 50%;
    content: "";
    display: ${(props)=>props.$checked ? "block" : "none"};
    height: 8px;
    left: 4px;
    position: absolute;
    top: 4px;
    width: 8px;
  }

  ${(props)=>{
    if (props.$disabled) return (0, $e42cae22e74e223a$exports.css)`
        background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
        ${!props.$checked ? `border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};` : ""}
      `;
    if (props.$checked) return (0, $e42cae22e74e223a$exports.css)`
        border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue400};
        background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue400};
      `;
    return (0, $e42cae22e74e223a$exports.css)`
      border: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50};
      &:hover {
        border-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80};
      }
    `;
}}
`;
const $dfd33cee3229493c$var$$90c57b1e46d07721$var$_RadioItem = (props)=>{
    const ref = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const { inputProps: inputProps } = (0, $caeb06b22505de77$export$37b0961d2f4751e2)({
        ...props,
        isDisabled: props.disabled,
        "aria-labelledby": props.id || props.name
    }, props.state, ref);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($730ba0c4b6fc7e48$export$439d29a4e110a164, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("input", {
                    ...inputProps,
                    ref: ref
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$90c57b1e46d07721$var$StyledRadioButton, {
                $checked: inputProps.checked,
                $disabled: props.disabled,
                role: "radio"
            })
        ]
    });
};
$dfd33cee3229493c$var$$90c57b1e46d07721$var$_RadioItem.propTypes = {
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    state: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object.isRequired
};
/**
 * A simple component that renders a single radio button. For use in `RadioGroup` and not exposed
 * externally.
 *
 * @param {object} props
 * @returns {React.Component}
 */ const $dfd33cee3229493c$var$$90c57b1e46d07721$var$RadioItem = (props)=>{
    // also remove whitespaces from the id
    const inputId = `${props.state.name}-${props.label}`.replace(/\s+/g, "_");
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039, {
        input: {
            type: "radio",
            ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).omit(props, [
                "label",
                "helpText"
            ]),
            name: props.state.name
        },
        id: inputId,
        label: props.label,
        helpText: props.helpText,
        wrapLabel: props.wrapLabel,
        component: $dfd33cee3229493c$var$$90c57b1e46d07721$var$_RadioItem,
        state: props.state
    });
};
$dfd33cee3229493c$var$$90c57b1e46d07721$var$RadioItem.propTypes = {
    state: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired
    }).isRequired,
    label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    helpText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    wrapLabel: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$90c57b1e46d07721$var$RadioItem.defaultProps = {
    helpText: "",
    disabled: false,
    wrapLabel: false
};
var $dfd33cee3229493c$var$$90c57b1e46d07721$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$90c57b1e46d07721$var$RadioItem;
const $dfd33cee3229493c$var$$568c3e0e2fd4254e$var$StyledRadioGroup = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-direction: ${(props)=>props.$horizontal ? "row" : "column"};
  gap: ${(props)=>props.$horizontal ? "24px" : "8px"};
  margin-top: 4px;
`;
/**
 * Creates a group of styled radio buttons determined by the items passed.
 *
 * input - A dictionary containing: onChange, the function to be executed when a
 * new radio button is selected. value, the default value of the group. name, the
 * name of the group.
 *
 * items - Either a list of labels that will be assigned a value from 0 up automatically,
 * or a dictionary of labels and values for each radio button in the group. Radio items
 * have an isDisabled field that can be set to true to disable the singular item.
 *
 * disabled - If true, disables the radio group, defaults to false.
 */ const $dfd33cee3229493c$var$$568c3e0e2fd4254e$var$RadioGroup = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef(({ items: items, ...props }, ref)=>{
    const parsedItems = (0, $70fFQ.useMemo)(()=>{
        if (!$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isEmpty(items) && $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isString($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).first(items))) return $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).map(items, (item)=>({
                value: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).toString(item),
                label: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).toString(item)
            }));
        return $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).map(items, (item)=>({
                ...item,
                value: item.value
            }));
    }, [
        items
    ]);
    const ariaProps = {
        ...props,
        isDisabled: props.disabled,
        "aria-labelledby": props.id ?? props.name
    };
    const state = (0, $054a18064d19e0b5$export$bca9d026f8e704eb)(ariaProps);
    const { radioGroupProps: radioGroupProps } = (0, $25e8fa3cc2920a8a$export$62b9571f283ff5c2)(ariaProps, state);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$568c3e0e2fd4254e$var$StyledRadioGroup, {
        $horizontal: props.orientation === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL,
        ...radioGroupProps,
        children: parsedItems.map((item)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$90c57b1e46d07721$export$2e2bcd8739ae039, {
                state: state,
                label: item.label,
                value: item.value,
                helpText: item.helpText,
                wrapLabel: props.wrapLabel,
                disabled: props.disabled || item.disabled
            }, item.label))
    });
});
const $dfd33cee3229493c$var$$568c3e0e2fd4254e$var$itemPropTypes = $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
    $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    (props, propName, componentName)=>{
        const curValue = props[propName];
        if (!$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isObject(curValue) || $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isUndefined(curValue.label) || $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isUndefined(curValue.value)) return new Error(`Invalid option prop '${curValue}' supplied to ${componentName}`);
        return null;
    }
]));
$dfd33cee3229493c$var$$568c3e0e2fd4254e$var$RadioGroup.propTypes = {
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    /** Starting value */ value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    // eslint-disable-line react/forbid-prop-types
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    items: $dfd33cee3229493c$var$$568c3e0e2fd4254e$var$itemPropTypes.isRequired,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    orientation: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
        $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL,
        $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL
    ]),
    wrapLabel: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$568c3e0e2fd4254e$var$RadioGroup.defaultProps = {
    disabled: false,
    wrapLabel: false,
    orientation: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL
};
$dfd33cee3229493c$var$$568c3e0e2fd4254e$var$RadioGroup.displayName = "RadioGroup";
var $dfd33cee3229493c$var$$568c3e0e2fd4254e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$568c3e0e2fd4254e$var$RadioGroup;
// eslint-disable-next-line no-magic-numbers
const $dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$FETCH_RATES_MS = [
    1000,
    750,
    500,
    250
];
const $dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$DEFAULT_VALUES = "__DEFAULT_VALUES"; // need something that won't conflict with search terms
// Determines if the cachedValue should be updated with the options returned from a fetch. The
// cache should be updated if one of the following conditions holds:
// 1. The returned list of options is not a proper subset of the cached options and the two lists
//    are not equal
// 2. The cache is undefined.
const $dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$cacheNeedsUpdate = (retOptions, cachedValue)=>!$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isEmpty($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).differenceWith(retOptions, cachedValue, $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isEqual)) || $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isUndefined(cachedValue);
/**
 * React hook to handle parsing local options and remote options into a single source and provide
 * appropriate utils to handle remote search
 *
 * @param {Array} options - If provided, is a default set of options for the select, and can be
 *    supplemented by loadOptions results
 * @param {Function} loadOptions - If provided, is used to retrieve options based on the entered
 *    search to add to the existing option list.
 * @param {Function} loadOptionFromValue - given a value, fetch options to store. This is
 *    useful when an async select has values partially derived outside the context
 * @param {string|Function} uniqBy - The differentiator to determine which options are considered
 *    unique
 *
 * @returns {Array}
 * - parsed options
 * - parsed option groups
 * - fetch function
 * - cached values
 */ const $dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$useSelectAsync = ({ initialOptions: options, loadOptions: loadOptions, loadOptionFromValue: loadOptionFromValue, uniqBy: uniqBy = "value" })=>{
    // The base set of options / option groups and canonical set of options not mapped to internal
    // state. These are unordered and just a set of working options to simulate a set of initially
    // provided options
    const [storedOptions, setStoredOptions] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(options || []);
    const [fetchingCount, setFetchingCount] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(0);
    // The cache is used to determine if we have a result set for a given search. Otherwise not used
    const cache = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef({
        // Options defaults to an empty list if not provided. Prevents `null` from appearing in cache
        // results when we have no initial options for async selects
        [$dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$DEFAULT_VALUES]: options
    });
    // Helper method to update the options list to be additive
    const setOptions = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((newOptions)=>{
        // Always drop newest version first so if there are dupes, uniqBy doesn't use the cache
        const allOptions = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).uniqBy([
            ...newOptions,
            ...storedOptions
        ], uniqBy);
        if ($dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$cacheNeedsUpdate(allOptions, storedOptions)) setStoredOptions(allOptions);
    }, [
        uniqBy,
        storedOptions
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        if (options !== cache.current[$dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$DEFAULT_VALUES]) {
            // Different from setOptions above, use cached values first, so we don't update unnecessarily
            const allOptions = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).uniqBy([
                ...storedOptions,
                ...options
            ], uniqBy);
            if ($dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$cacheNeedsUpdate(allOptions, storedOptions)) setStoredOptions(allOptions);
            cache.current[$dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$DEFAULT_VALUES] = options;
        }
    }, [
        options,
        storedOptions,
        uniqBy
    ]);
    // A helper wrapper to conditionally fetch if the callback is provided and hook into state
    const handleFetchFromValue = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((value)=>{
        if (loadOptionFromValue && value) loadOptionFromValue(value).then((option)=>{
            if (option) setOptions([
                option
            ]);
        });
    }, [
        loadOptionFromValue,
        setOptions
    ]);
    // Helper function to trigger any applicable async call to fetch options based on search
    // Cache and debounce to retain reference so we can clear old debounced copies as you continue to
    // search.
    const rawHandleFetch = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((search)=>{
        // General structure
        // - Update cache to indicate options fetched
        // - Insert new options into option list
        if (loadOptions) {
            setFetchingCount((count)=>count + 1);
            loadOptions($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).trim(search)).then((retOptions)=>{
                setFetchingCount((count)=>count - 1);
                if (retOptions) cache.current[search] = retOptions;
                setOptions(cache.current[search]);
            });
        }
    }, [
        loadOptions,
        setOptions
    ]);
    // Maintain multiple debounce rate versions of the raw fetch to use in adaptive debouncing.
    // Adaptive debouncing increases the debounce duration for shorter-length search queries in
    // an attempt to reduce server load because users are more likely to type more characters.
    const debouncedFetches = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).map($dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$FETCH_RATES_MS, (rate)=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).debounce(rawHandleFetch, rate)), [
        rawHandleFetch
    ]);
    // Triggers API call on debounce, cancels any pending ones to prevent the network call
    // We debounce the fetch call since it is typically an API call and to minimize the work the
    // network needs to do.
    const handleFetch = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((search)=>{
        if (search.length) {
            // Don't perform unnecessary searches
            const applicableRate = Math.min(search.length, $dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$FETCH_RATES_MS.length) - 1;
            // Cancel all pending queries with an equal or greater rate to the applicable rate.
            for(let i = 0; i <= applicableRate; i++)debouncedFetches[i].cancel();
            debouncedFetches[applicableRate](search);
        }
    }, [
        debouncedFetches
    ]);
    return [
        // Convenience selectors to bypass local state work when unnecessary.
        storedOptions,
        // All in 1 fetch trigger regardless of using option or grouped options
        handleFetch,
        handleFetchFromValue,
        fetchingCount > 0
    ];
};
var $dfd33cee3229493c$var$$adfdd6bc334eb2dd$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$adfdd6bc334eb2dd$var$useSelectAsync;
/**
 * Simple hook to handle storing the current value of a select and enforcing the change handler is
 * called as appropriate.
 *
 * Some of the more complicated logic lives in useSearch because of tight coupling
 *
 * @param {any} initialValue
 * @param {Function} onChange
 * @param {Boolean} multiple
 *
 * @returns {Array}
 * - value
 * - setValue - function to update the value
 */ const $dfd33cee3229493c$var$$03c2fd226df43833$var$useSelectValue = (initialValue, onChange, multiple)=>{
    const useDefaultValue = initialValue === null || initialValue === undefined || initialValue === "";
    const defaultValue = multiple ? [] : null;
    const [value, setValue] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(useDefaultValue ? defaultValue : initialValue);
    const didMount = $dfd33cee3229493c$var$$8ea3e04a44a07747$export$2e2bcd8739ae039();
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        setValue(useDefaultValue ? defaultValue : initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialValue
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        if (didMount && onChange) onChange(value === undefined ? null : value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        value
    ]);
    const updateValue = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((updatedValue)=>{
        if (!multiple) {
            setValue(()=>updatedValue);
            return;
        } else if (updatedValue === null) {
            // Special case to clear multi selects
            setValue([]);
            return;
        }
        // Safe even if value is an object because the reference is stable
        if (value.find((val)=>val === updatedValue)) setValue($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).without(value, updatedValue));
        else setValue([
            ...value,
            updatedValue
        ]);
    }, [
        value,
        multiple,
        setValue
    ]);
    return [
        value,
        updateValue
    ];
};
var $dfd33cee3229493c$var$$03c2fd226df43833$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$03c2fd226df43833$var$useSelectValue;
/**
 * Parses the provided list of options into a standardized format with customizations applied
 *
 * @param {Object} config
 *
 * @returns {Array}
 * - the cleaned, flattened option list
 */ const $dfd33cee3229493c$var$$3ad0621ac43a8355$var$useMenuOptions = ({ options: initialOptions, labelKey: labelKey, valueKey: valueKey, iconKey: iconKey, thumbnailKey: thumbnailKey, sortAlphabetically: sortAlphabetically })=>{
    // We cache the base set of options to help reduce rerenders when lazily populated
    const [cachedInitialOptions, setCache] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(initialOptions);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        if (!$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isEqual(initialOptions, cachedInitialOptions)) setCache(initialOptions);
    }, [
        initialOptions,
        cachedInitialOptions
    ]);
    // Coerces the options from props into our standardized format to be used by the remainder of
    // the select logic and components.
    const parsedOptions = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>cachedInitialOptions.map((opt)=>({
                value: opt[valueKey],
                text: opt[labelKey],
                icon: opt[iconKey],
                thumbnail: opt[thumbnailKey],
                role: "option"
            })), [
        cachedInitialOptions,
        labelKey,
        valueKey,
        iconKey,
        thumbnailKey
    ]);
    // Cleaned options ready to pass to the menu config
    const options = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>{
        let cleanedOptions = parsedOptions;
        if (sortAlphabetically) cleanedOptions = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).sortedUniqBy($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).orderBy(cleanedOptions, [
            (option)=>$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).lowerCase(option.label)
        ]), "value");
        return cleanedOptions;
    }, [
        parsedOptions,
        sortAlphabetically
    ]);
    return options;
};
var $dfd33cee3229493c$var$$3ad0621ac43a8355$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3ad0621ac43a8355$var$useMenuOptions;
/**
 * This hook provides the interface to set the value of a select and manage that via options.
 * Specifically, it provides 2 values.
 * 1. A function that can be passed either an option object or a string value for non existent
 * options that will select/toggle that option in the value as appropriate based on if it is a multi
 * select.
 * 2. An array or single object representing the selected options reflected in the current value.
 * Always an array for a multi select, always an option object or undefined for a single select.
 *
 * @param {Function} addNewOption
 * @param {any} value - see ValuePropType for valid shape of this param
 * @param {Function} setValue
 * @param {boolean} multiple
 * @param {Array} allOptions
 *
 * @returns {Array} See [1, 2] for values in the array
 */ const $dfd33cee3229493c$var$$447ba32067a3f79b$var$useSelectValueDisplay = (allOptions, value, multiple = false, loadOptionFromValue = null)=>{
    // Collects options the match the selected value. This is necessary since the value is not what
    // is displayed to the user, but the label for the value
    const selectedOptions = (0, $70fFQ.useMemo)(()=>{
        if (multiple) return value.map((val)=>allOptions.find((option)=>option.value === val) || {
                text: val,
                value: val
            });
        const options = allOptions.find((option)=>option?.value === value);
        if (!options && loadOptionFromValue) loadOptionFromValue(value);
        return options;
    }, [
        value,
        multiple,
        allOptions
    ]);
    if (multiple) return [
        selectedOptions,
        null
    ];
    const valueDefault = value === null ? "" : value;
    return selectedOptions ? [
        selectedOptions.text,
        selectedOptions.icon
    ] : [
        valueDefault,
        null
    ];
};
var $dfd33cee3229493c$var$$447ba32067a3f79b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$447ba32067a3f79b$var$useSelectValueDisplay;
const $dfd33cee3229493c$var$$e2952b8096f84c91$export$11a238c5d7580a1e = "label";
const $dfd33cee3229493c$var$$e2952b8096f84c91$export$7b66e756e3d75af8 = "value";
const $dfd33cee3229493c$var$$e2952b8096f84c91$export$1a9600e2a1cca2c0 = "icon";
const $dfd33cee3229493c$var$$e2952b8096f84c91$export$c948a3c205193649 = "thumbnail";
const $dfd33cee3229493c$var$$39b379c99beb7181$export$b539292475965274 = $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
    $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    (propValue, key, componentName)=>{
        const curValue = propValue[key];
        if (!$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isArray(curValue) || curValue.length !== 2 || !(typeof curValue[1] === "string")) return new Error(`Invalid option prop '${curValue}' supplied to ${componentName}`);
        return null;
    }
]);
const $dfd33cee3229493c$var$$39b379c99beb7181$export$faa441423ff9d7d9 = $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$39b379c99beb7181$export$b539292475965274);
var $dfd33cee3229493c$var$$c02cb3eadc6332f4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
    $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).array,
    $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
]);
const $dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$StyledInput = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2)`
  width: 0;
  flex-grow: 1;
`;
const $dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$StyledMultiSelectInputWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b)`
  flex-wrap: wrap;
  height: fit-content;
  padding: 6px 11px;
  gap: 7px;
`;
const $dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$StyledClearButton = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).button`
  border: none;
  background: transparent;
  outline: none;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0;
  margin-left: 12px;
  line-height: 1;
  svg {
    pointer-events: bounding-box;
  }
  path:hover {
    fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80};
  }
`;
const $dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$ClearButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$StyledClearButton, {
        onClick: onClick,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$5186db77bb5db429$export$2e2bcd8739ae039, {
            size: 16,
            color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50
        })
    });
$dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$ClearButton.propTypes = {
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired
};
/**
 * A standard select component to get desired behavior on ZX.
 *
 * Common use case should leverage:
 * - options or loadOptions
 * - name
 * - placeholder
 * - value
 * - (within modals) popup
 * - some combination of create, disabled, multiple
 *
 * Other options are generally for advanced use cases. Use `Autocomplete` or `MultiAutocomplete`
 * when you want a text search of the dropdown options instead of `Select`
 *
 * When customizing this, try doing it in the following ways
 * 1. Use the boolean props available
 * 2. Use the component props available (for example, `inputComponent`)
 * 3. Add a new prop as necessary if no existing configuration works
 *   - Ensure all new props are well thought out, named generically and necessary.
 * 4. Create a thin wrapper around this that uses a ref and handlers to grab any stateful
 * information necessary.
 *   - Good option if you need different display logic that doesn't fit the existing structure
 *   - An example of this is `ChipSelect`
 * 5. If all else fails, build a new component/rework this one to be more extensible as needed
 *   - This is the nuclear option. Any such approach should minimize duplication and push for single
 *     source of truth as much as possible
 *
 * The first 2 methods should cover the vast majority of use cases
 */ const $dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$Select = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const inputRef = ref || internalRef;
    const [fetchedOptions, handleFetch, loadOptionFromValue] = $dfd33cee3229493c$var$$adfdd6bc334eb2dd$export$2e2bcd8739ae039({
        initialOptions: props.options,
        loadOptions: props.loadOptions,
        loadOptionFromValue: props.loadOptionFromValue,
        uniqBy: props.optionValueKey
    });
    const [value, setValue] = $dfd33cee3229493c$var$$03c2fd226df43833$export$2e2bcd8739ae039(props.value, props.onChange, props.multiple, loadOptionFromValue);
    const optionsAsMenuItems = $dfd33cee3229493c$var$$3ad0621ac43a8355$export$2e2bcd8739ae039({
        options: props.loadOptions ? fetchedOptions : props.options,
        sortAlphabetically: !props.noSort,
        labelKey: props.optionLabelKey,
        valueKey: props.optionValueKey,
        iconKey: props.optionIconKey,
        thumbnailKey: props.optionThumbnailKey
    });
    const [valueDisplay, valueIcon] = $dfd33cee3229493c$var$$447ba32067a3f79b$export$2e2bcd8739ae039(optionsAsMenuItems, value, props.multiple, loadOptionFromValue);
    const [dropdownContent, containerRef, toggleIsOpen] = $dfd33cee3229493c$var$$fdc23a95238ad2bd$export$2e2bcd8739ae039({
        searchable: props.searchable,
        menuItems: optionsAsMenuItems,
        role: "listbox",
        defaultAbove: false,
        onItemClick: (item)=>setValue(item.value),
        closeOnSelect: !props.multiple,
        onSearch: handleFetch,
        keyHandlerRef: inputRef
    });
    const size = props.small ? $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd : $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$29ce903923b9e67f;
    const iconSize = props.small ? 16 : 18;
    const leadingIconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30;
    const defaultChevronColor = dropdownContent ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50;
    let TrailingIcon = dropdownContent ? $dfd33cee3229493c$var$$082f0a59b33f843a$export$2e2bcd8739ae039 : $dfd33cee3229493c$var$$a91646f62d6b2784$export$2e2bcd8739ae039;
    // No clear button on multi selects
    if (value !== null && !props.disabled && !props.multiple) {
        const onClear = (e)=>{
            setValue(null);
            e.preventDefault();
            e.stopPropagation();
        };
        TrailingIcon = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$ClearButton, {
                onClick: onClear
            });
    }
    const trailingIconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : defaultChevronColor;
    const focusAndToggle = ()=>{
        inputRef.current?.focus();
        toggleIsOpen();
    };
    const LeadingIcon = props.leadingIcon || valueIcon;
    const Wrapper = props.multiple ? $dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$StyledMultiSelectInputWrapper : $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b;
    // Determine what to render based on the anchor type the user chose.
    let renderedComponent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)(Wrapper, {
        $disabled: props.disabled,
        $error: props.showError,
        $size: size,
        className: props.className,
        ref: containerRef,
        onClick: props.disabled ? null : focusAndToggle,
        children: [
            LeadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(LeadingIcon, {
                size: iconSize,
                color: leadingIconColor
            }),
            props.multiple ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
                children: [
                    valueDisplay.map((option)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$42b9a489fcea3072$export$209d5e35e7868ba1, {
                                leadingIcon: option.icon,
                                avatar: option.thumbnail,
                                onClose: ()=>setValue(option.value),
                                text: option.text
                            })
                        }, option.value)),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$StyledInput, {
                        ref: inputRef,
                        placeholder: value && value.length ? "" : props.placeholder,
                        name: props.name,
                        disabled: props.disabled,
                        role: "combobox",
                        readOnly: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$StyledInput, {
                ref: inputRef,
                placeholder: props.placeholder,
                name: props.name,
                disabled: props.disabled,
                value: valueDisplay,
                readOnly: true,
                role: "combobox"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(TrailingIcon, {
                size: iconSize,
                color: trailingIconColor
            })
        ]
    });
    // Explicitly do not support chip-style selects + multi-selection. We may add this down the line
    // but so far have not received any designs implementing this functionality. For multi-selects
    // of this type, we'd typically use a `CheckboxDropdown`.
    if (!props.multiple && props.anchorType === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef.CHIP) {
        // ActionChip will discard the `onClose` prop so we can just pass it into either.
        const ChipComponent = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isNull(value) ? $dfd33cee3229493c$var$$42b9a489fcea3072$export$340ef18e89d7d15d : $dfd33cee3229493c$var$$42b9a489fcea3072$export$209d5e35e7868ba1;
        renderedComponent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(ChipComponent, {
            ref: containerRef,
            onClick: props.disabled ? null : focusAndToggle,
            onClose: ()=>setValue(null),
            text: valueDisplay ? valueDisplay : props.placeholder,
            role: "listbox"
        });
    }
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            componentVersion: 2
        },
        children: [
            dropdownContent,
            renderedComponent
        ]
    });
});
$dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$Select.propTypes = {
    /** Does the select allow multiple options to be selected? */ multiple: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** Should the user be allowed to search through options? */ searchable: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** What type of anchor should this select be rendered as? */ anchorType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef)),
    // Common input props
    /** A class applied to the wrapper around the 'input' component of the select */ className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Whether the select is disabled or not */ disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** field name for this select */ name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    /** Event handler to be called whenever the value of the select changes */ onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** What to display if no option is selected for the input */ placeholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    // Value Props
    /** Function that returns a promise that evaluates to an array of options */ loadOptions: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** Function that accepts a value and returns a promise that evaluates to an option instance */ loadOptionFromValue: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** The list of options that can be selected from the input. Ungrouped */ options: $dfd33cee3229493c$var$$39b379c99beb7181$export$faa441423ff9d7d9,
    /**
   * The key in options provided that corresponds to what value should appear in the option display
   */ optionLabelKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to what icon should appear in the option display
   */ optionIconKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to what thumbnail should appear in the option display
   */ optionThumbnailKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to the internal value stored from selecting an
   * option
   */ optionValueKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Allows parent component to control the value stored on the select externally */ value: $dfd33cee3229493c$var$$c02cb3eadc6332f4$export$2e2bcd8739ae039,
    /** If set, leaves options in the order provided. Otherwise sorts alphabetically */ noSort: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$Select.defaultProps = {
    multiple: false,
    searchable: false,
    anchorType: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef.TEXT_BOX,
    className: "",
    disabled: false,
    placeholder: "",
    defaultOption: "",
    options: [],
    optionThumbnailKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$c948a3c205193649,
    optionValueKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$7b66e756e3d75af8,
    optionLabelKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$11a238c5d7580a1e,
    optionIconKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$1a9600e2a1cca2c0,
    noSort: false,
    showError: false
};
$dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$Select.displayName = "Select";
var $dfd33cee3229493c$var$$3c9b4e66358d3d2b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3c9b4e66358d3d2b$var$Select;
const $dfd33cee3229493c$var$$c36a08b03cc5dbf3$var$NO_SEARCH_MAX = 8;
/**
 * This is a standard select component that has been upgraded with a few usability tools, most
 * notably the ability to search the dropdown for a value you are looking for and allowing multiple
 * values to be selected and optionally removed in an easy to use manner.
 *
 */ const $dfd33cee3229493c$var$$c36a08b03cc5dbf3$var$SelectInput = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef(({ onChange: onChange, value: value, name: name, multiple: multiple, searchable: searchable, ...subprops }, ref)=>{
    const isSearchable = Boolean(searchable || (subprops.options || []).length > $dfd33cee3229493c$var$$c36a08b03cc5dbf3$var$NO_SEARCH_MAX || subprops.loadOptions);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$3c9b4e66358d3d2b$export$2e2bcd8739ae039, {
        ref: ref,
        name: name,
        value: value,
        onChange: onChange,
        multiple: multiple,
        searchable: isSearchable,
        ...subprops
    });
});
$dfd33cee3229493c$var$$c36a08b03cc5dbf3$var$SelectInput.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    // eslint-disable-line react/forbid-prop-types
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    multiple: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    searchable: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
var $dfd33cee3229493c$var$$c36a08b03cc5dbf3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c36a08b03cc5dbf3$var$SelectInput;
const $dfd33cee3229493c$var$$7195e09895656fea$var$StyledContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  position: relative;
  display: inline-block;
  width: 28px;
  height: 8px;
  margin: 4px 0;
`;
const $dfd33cee3229493c$var$$7195e09895656fea$var$StyledSlider = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  position: absolute;
  cursor: pointer;
  height: 100%;
  width: 100%;
  background-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.minWhite};
  transition: 0.25s;
  border-radius: 12px;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    top: -4px;
    background-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.fullWhite};
    transition: 0.25s;
    border-radius: 50%;
  }
`;
const $dfd33cee3229493c$var$$7195e09895656fea$var$StyledInput = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).input`
  display: none;

  &:checked + ${$dfd33cee3229493c$var$$7195e09895656fea$var$StyledSlider} {
    background-color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400};
    &:before {
      transform: translateX(12px);
    }
  }
`;
/**
 * A left-right toggle corresponding to a on-off switch. The value maps onto a checkbox input
 * and is frequently used for boolean values
 */ const $dfd33cee3229493c$var$$7195e09895656fea$var$SwitchInput = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$7195e09895656fea$var$StyledContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$7195e09895656fea$var$StyledInput, {
                ref: ref,
                ...props,
                type: "checkbox"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$7195e09895656fea$var$StyledSlider, {
                role: "switch"
            })
        ]
    }));
$dfd33cee3229493c$var$$7195e09895656fea$var$SwitchInput.propTypes = {
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    // eslint-disable-line react/forbid-prop-types
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$7195e09895656fea$var$SwitchInput.displayName = "SwitchInput";
var $dfd33cee3229493c$var$$7195e09895656fea$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7195e09895656fea$var$SwitchInput;
const $dfd33cee3229493c$var$$d0bc4a9b8df9b007$var$StyledWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b)`
  height: unset;
`;
/**
 * A styled textarea element
 */ const $dfd33cee3229493c$var$$d0bc4a9b8df9b007$var$TextArea = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const yukaTheme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    // Use a provided ref if there is one, otherwise create one here since we need it locally.
    const backupRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const _ref = ref || backupRef;
    $dfd33cee3229493c$var$$3e3c024a820593dc$export$2e2bcd8739ae039();
    const onChange = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((e)=>{
        props.onChange?.(e);
        if (props.autoResize && _ref.current) {
            // resets scrollHeight in case there is no longer text
            _ref.current.style.height = "0";
            // @ for 1px border not captured correctly
            _ref.current.style.height = `${_ref.current.scrollHeight + 2}px`;
        }
    }, [
        props.onChange,
        props.autoResize
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        // handleUpdateSize sets the css height of the textarea to 0, and then sets it
        // to the scroll height. For this to work, the textarea MUST have a min-height
        // and a max-height css attribute specified, as that sets the upper and lower
        // bounds of the size of the textarea
        if (props.autoResize && _ref.current) {
            // resets scrollHeight in case there is no longer text
            _ref.current.style.height = "0";
            // @ for 1px border not captured correctly
            _ref.current.style.height = `${_ref.current.scrollHeight + 2}px`;
        }
    });
    const focusChild = ()=>{
        _ref.current?.focus();
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$d0bc4a9b8df9b007$var$StyledWrapper, {
        $disabled: props.disabled,
        $error: Boolean(props.showError),
        onClick: focusChild,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$e93364aaaa97e46f, {
                ref: _ref,
                ...props,
                onChange: onChange,
                $height: props.height
            }),
            props.showError && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$21f83932bf995e14$export$2e2bcd8739ae039, {
                color: $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(yukaTheme, "red")
            })
        ]
    });
});
$dfd33cee3229493c$var$$d0bc4a9b8df9b007$var$TextArea.propTypes = {
    autoResize: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    // if the trailing text is used as a character counter, the implementation should change
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    height: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$d0bc4a9b8df9b007$var$TextArea.defaultProps = {
    disabled: false,
    autoResize: false,
    showError: false
};
$dfd33cee3229493c$var$$d0bc4a9b8df9b007$var$TextArea.displayName = "TextArea";
var $dfd33cee3229493c$var$$d0bc4a9b8df9b007$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$d0bc4a9b8df9b007$var$TextArea;
var $dfd33cee3229493c$var$$0cab4194af652e84$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "Select", ()=>$dfd33cee3229493c$var$$3c9b4e66358d3d2b$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "Autocomplete", ()=>$dfd33cee3229493c$var$$c72ae339b28b0434$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "MultiAutocomplete", ()=>$dfd33cee3229493c$var$$dad682ca2a56df25$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "OptionPropType", ()=>$dfd33cee3229493c$var$$39b379c99beb7181$export$b539292475965274);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "OptionPropTypeArray", ()=>$dfd33cee3229493c$var$$39b379c99beb7181$export$faa441423ff9d7d9);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "__internalUseSelectValue", ()=>$dfd33cee3229493c$var$$03c2fd226df43833$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "__internalUseSelectAsync", ()=>$dfd33cee3229493c$var$$adfdd6bc334eb2dd$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$0cab4194af652e84$exports, "__internalUseSearch", ()=>$dfd33cee3229493c$var$$b3da1e4d90228b29$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$6bbf2db1ba7d04d9$var$usePrevious = (value)=>{
    const ref = (0, $70fFQ.useRef)();
    // Store current value in ref
    (0, $70fFQ.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
};
var $dfd33cee3229493c$var$$6bbf2db1ba7d04d9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6bbf2db1ba7d04d9$var$usePrevious;
const $dfd33cee3229493c$var$$b3da1e4d90228b29$var$SEARCH_KEY = "text";
/**
 * This hook builds the search component to render for a select and provide critical information
 * related to what the current search is and if there is a matching option to update other display
 * aspects of the select.
 *
 * @param {Array} allOptions - a list of all options in the select
 *
 * @returns {Array} See return value for details
 */ const $dfd33cee3229493c$var$$b3da1e4d90228b29$var$useSearch = (allOptions)=>{
    const [search, setSearch] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState("");
    const matchingOptions = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useMemo(()=>{
        // Computes the new matching options. Note that we realign from the default sort so "better"
        // matches appear first. This puts prefix matches ahead of a generic token match
        const startsWithOptions = [];
        const includesOptions = [];
        allOptions.forEach((option)=>{
            if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).startsWith($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).toLower(option[$dfd33cee3229493c$var$$b3da1e4d90228b29$var$SEARCH_KEY]), $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).toLower(search))) startsWithOptions.push(option);
            else if ($dfd33cee3229493c$var$$d88ed55ea4ae4edc$export$2e2bcd8739ae039(search, option[$dfd33cee3229493c$var$$b3da1e4d90228b29$var$SEARCH_KEY])) includesOptions.push(option);
        });
        return startsWithOptions.concat(includesOptions);
    }, [
        allOptions,
        search
    ]);
    // Handle actual search updates to manage state and matches appropriately.
    const onSearch = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((searchValue)=>{
        setSearch(searchValue);
    }, [
        setSearch
    ]);
    return [
        onSearch,
        matchingOptions
    ];
};
var $dfd33cee3229493c$var$$b3da1e4d90228b29$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b3da1e4d90228b29$var$useSearch;
const $dfd33cee3229493c$var$$c72ae339b28b0434$var$inputProps = [
    "id",
    "name",
    "showError",
    "placeholder",
    "id",
    "leadingIcon",
    "trailingIcon",
    "disabled",
    "small",
    "onFocus",
    "onBlur"
];
/**
 * Presents a text input that suggests options as the user types. Also used as a "searchable" select
 * interface. Sibling to `MultiAutocomplete` which supports an interface for selecting multiple
 * values at once.
 *
 * See `Select` for more guidance on the configuration options, they use the same internals.
 *
 */ const $dfd33cee3229493c$var$$c72ae339b28b0434$var$Autocomplete = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const inputRef = ref || internalRef;
    const prevValue = $dfd33cee3229493c$var$$6bbf2db1ba7d04d9$export$2e2bcd8739ae039(props.value);
    const [fetchedOptions, handleFetch, loadOptionFromValue] = $dfd33cee3229493c$var$$adfdd6bc334eb2dd$export$2e2bcd8739ae039({
        initialOptions: props.options,
        loadOptions: props.loadOptions,
        loadOptionFromValue: props.loadOptionFromValue,
        uniqBy: props.optionValueKey
    });
    const optionsAsMenuItems = $dfd33cee3229493c$var$$3ad0621ac43a8355$export$2e2bcd8739ae039({
        options: props.loadOptions ? fetchedOptions : props.options,
        sortAlphabetically: !props.noSort,
        labelKey: props.optionLabelKey,
        valueKey: props.optionValueKey,
        iconKey: props.optionIconKey,
        thumbnailKey: props.optionThumbnailKey
    });
    // Find an option matching a provided value. Also match text on loaded options
    const optionMatchingValueOrText = optionsAsMenuItems.find((option)=>option.value === props.value || option.text.toLowerCase() === props.value?.toLowerCase?.());
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        // Load a missing option when value is programmatically updated
        if (props.value && loadOptionFromValue && !optionMatchingValueOrText) loadOptionFromValue(props.value);
    }, [
        props.value,
        loadOptionFromValue,
        optionMatchingValueOrText
    ]);
    const [inputValue, setInputValue] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(optionMatchingValueOrText?.text || props.value);
    const { onChange: onChange } = props;
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        // When value is loaded on a delay for async - update text to match
        if (optionMatchingValueOrText) {
            if (inputValue !== optionMatchingValueOrText.text) setInputValue(optionMatchingValueOrText.text);
            if (props.value !== optionMatchingValueOrText.value) onChange?.(optionMatchingValueOrText.value);
        } else if (!props.value && props.value !== prevValue) setInputValue("");
    }, [
        props.value,
        optionMatchingValueOrText,
        inputValue,
        setInputValue,
        onChange,
        prevValue
    ]);
    const inputOnChange = (e)=>{
        const search = e.target.value;
        // Use the value of a matching option if we have one, otherwise just use the entered text
        const updatedValue = optionsAsMenuItems.find((option)=>option.text.toLowerCase() === search.toLowerCase())?.value || search;
        props.onChange?.(updatedValue);
        setInputValue(search);
        onSearch(search);
        handleFetch(search);
        if (!dropdownContent) toggleIsOpen();
    };
    const selectOption = (option)=>inputOnChange({
            target: {
                value: option.text
            }
        });
    const [onSearch, filteredOptions] = $dfd33cee3229493c$var$$b3da1e4d90228b29$export$2e2bcd8739ae039(optionsAsMenuItems);
    const [dropdownContent, containerRef, toggleIsOpen] = $dfd33cee3229493c$var$$fdc23a95238ad2bd$export$2e2bcd8739ae039({
        menuItems: filteredOptions,
        defaultAbove: false,
        onItemClick: selectOption,
        closeOnSelect: true,
        keyHandlerRef: inputRef,
        role: "listbox"
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                ref: containerRef,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$a3428f5ff52af727$export$2e2bcd8739ae039, {
                    ref: inputRef,
                    onChange: inputOnChange,
                    value: inputValue,
                    role: "combobox",
                    ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, $dfd33cee3229493c$var$$c72ae339b28b0434$var$inputProps)
                })
            }),
            !props.disabled && Boolean(inputValue) && filteredOptions.length > 0 && dropdownContent
        ]
    });
});
$dfd33cee3229493c$var$$c72ae339b28b0434$var$Autocomplete.propTypes = {
    /** A class applied to the wrapper around the 'input' component of the select */ className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Whether the select is disabled or not */ disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** field name for this select */ name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    /** Event handler to be called whenever the value of the select changes */ onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** What to display if no option is selected for the input */ placeholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    // Value Props
    /** Function that returns a promise that evaluates to an array of options */ loadOptions: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** Function that accepts a value and returns a promise that evaluates to an option instance */ loadOptionFromValue: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** The list of options that can be selected from the input. Ungrouped */ options: $dfd33cee3229493c$var$$39b379c99beb7181$export$faa441423ff9d7d9,
    /**
   * The key in options provided that corresponds to what value should appear in the option display
   */ optionLabelKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to what icon should appear in the option display
   */ optionIconKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to what thumbnail should appear in the option display
   */ optionThumbnailKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to the internal value stored from selecting an
   * option
   */ optionValueKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Allows parent component to control the value stored on the select externally */ value: $dfd33cee3229493c$var$$c02cb3eadc6332f4$export$2e2bcd8739ae039,
    /** If set, leaves options in the order provided. Otherwise sorts alphabetically */ noSort: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$c72ae339b28b0434$var$Autocomplete.defaultProps = {
    className: "",
    disabled: false,
    placeholder: "",
    onChange: ()=>{},
    loadOptions: null,
    loadOptionFromValue: null,
    options: [],
    optionThumbnailKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$c948a3c205193649,
    optionValueKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$7b66e756e3d75af8,
    optionLabelKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$11a238c5d7580a1e,
    optionIconKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$1a9600e2a1cca2c0,
    noSort: false,
    showError: false
};
$dfd33cee3229493c$var$$c72ae339b28b0434$var$Autocomplete.displayName = "Autocomplete";
var $dfd33cee3229493c$var$$c72ae339b28b0434$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c72ae339b28b0434$var$Autocomplete;
const $dfd33cee3229493c$var$$dad682ca2a56df25$var$StyledInput = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2)`
  width: 50px;
  flex-grow: 1;
`;
const $dfd33cee3229493c$var$$dad682ca2a56df25$var$StyledInputWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b)`
  flex-wrap: wrap;
  height: fit-content;
  padding: 6px 11px;
  gap: 6px;
`;
/**
 * Yuka v1.0
 * A custom multi select component that renders the values in a chip list
 * This is a thin wrapper around or standard select component, only multiple is forced.
 *
 * @param {object} props
 * @returns {React.Element}
 */ const $dfd33cee3229493c$var$$dad682ca2a56df25$var$MultiAutocomplete = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const inputRef = ref || internalRef;
    const [fetchedOptions, handleFetch, loadOptionFromValue] = $dfd33cee3229493c$var$$adfdd6bc334eb2dd$export$2e2bcd8739ae039({
        initialOptions: props.options,
        loadOptions: props.loadOptions,
        loadOptionFromValue: props.loadOptionFromValue,
        uniqBy: props.optionValueKey
    });
    const optionsAsMenuItems = $dfd33cee3229493c$var$$3ad0621ac43a8355$export$2e2bcd8739ae039({
        options: props.loadOptions ? fetchedOptions : props.options,
        sortAlphabetically: !props.noSort,
        labelKey: props.optionLabelKey,
        valueKey: props.optionValueKey,
        iconKey: props.optionIconKey,
        thumbnailKey: props.optionThumbnailKey
    });
    const [value, setValue] = $dfd33cee3229493c$var$$03c2fd226df43833$export$2e2bcd8739ae039(props.value, props.onChange, true);
    const [valueDisplay] = $dfd33cee3229493c$var$$447ba32067a3f79b$export$2e2bcd8739ae039(optionsAsMenuItems, value, true, loadOptionFromValue);
    const [onSearch, filteredOptions] = $dfd33cee3229493c$var$$b3da1e4d90228b29$export$2e2bcd8739ae039(optionsAsMenuItems);
    const [dropdownContent, containerRef, toggleIsOpen] = $dfd33cee3229493c$var$$fdc23a95238ad2bd$export$2e2bcd8739ae039({
        menuItems: filteredOptions,
        defaultAbove: false,
        onItemClick: (item)=>{
            setValue(item.value);
            setInputValue("");
        },
        closeOnSelect: false
    });
    const [inputValue, setInputValue] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(props.value);
    const inputOnChange = (e)=>{
        setInputValue(e.target.value);
        onSearch(e.target.value);
        handleFetch(e.target.value);
        if (!dropdownContent) toggleIsOpen();
    };
    const size = props.small ? $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd : $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$29ce903923b9e67f;
    const iconSize = props.small ? 16 : 18;
    const iconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30;
    const focusAndToggle = ()=>{
        inputRef.current?.focus();
        toggleIsOpen();
    };
    // If popup is not open pass through to allow tabbing through form
    const onKeyPress = (event)=>{
        if (event.key === "Enter" || event.key === "Tab") {
            setValue(inputValue);
            setInputValue("");
            event.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$dad682ca2a56df25$var$StyledInputWrapper, {
                $disabled: props.disabled,
                $error: props.showError,
                $size: size,
                className: props.className,
                ref: containerRef,
                onClick: focusAndToggle,
                children: [
                    props.leadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                        size: iconSize,
                        color: iconColor
                    }),
                    valueDisplay.map((option)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$42b9a489fcea3072$export$209d5e35e7868ba1, {
                            leadingIcon: option.icon,
                            avatar: option.thumbnail,
                            onClose: ()=>setValue(option.value),
                            text: option.text
                        }, option.value)),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$dad682ca2a56df25$var$StyledInput, {
                        ref: inputRef,
                        onChange: inputOnChange,
                        value: inputValue,
                        placeholder: value.length ? "" : props.placeholder,
                        name: props.name,
                        disabled: props.disabled,
                        onKeyPress: onKeyPress,
                        role: "combobox"
                    }),
                    props.trailingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.trailingIcon, {
                        size: iconSize,
                        color: iconColor
                    })
                ]
            }),
            !props.disabled && Boolean(inputValue) && filteredOptions.length > 0 && dropdownContent
        ]
    });
});
$dfd33cee3229493c$var$$dad682ca2a56df25$var$MultiAutocomplete.propTypes = {
    /** A class applied to the wrapper around the 'input' component of the select */ className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Whether the select is disabled or not */ disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** field name for this select */ name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    /** Event handler to be called whenever the value of the select changes */ onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** What to display if no option is selected for the input */ placeholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    // Value Props
    /** Function that returns a promise that evaluates to an array of options */ loadOptions: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** Function that accepts a value and returns a promise that evaluates to an option instance */ loadOptionFromValue: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** The list of options that can be selected from the input. Ungrouped */ options: $dfd33cee3229493c$var$$39b379c99beb7181$export$faa441423ff9d7d9,
    /**
   * The key in options provided that corresponds to what value should appear in the option display
   */ optionLabelKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to what icon should appear in the option display
   */ optionIconKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to what thumbnail should appear in the option display
   */ optionThumbnailKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /**
   * The key in options provided that corresponds to the internal value stored from selecting an
   * option
   */ optionValueKey: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Allows parent component to control the value stored on the select externally */ value: $dfd33cee3229493c$var$$c02cb3eadc6332f4$export$2e2bcd8739ae039,
    /** If set, leaves options in the order provided. Otherwise sorts alphabetically */ noSort: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    trailingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$dad682ca2a56df25$var$MultiAutocomplete.defaultProps = {
    className: "",
    disabled: false,
    placeholder: "",
    onChange: ()=>{},
    loadOptions: null,
    loadOptionFromValue: null,
    options: [],
    optionThumbnailKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$c948a3c205193649,
    optionValueKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$7b66e756e3d75af8,
    optionLabelKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$11a238c5d7580a1e,
    optionIconKey: $dfd33cee3229493c$var$$e2952b8096f84c91$export$1a9600e2a1cca2c0,
    noSort: false,
    showError: false,
    small: false
};
$dfd33cee3229493c$var$$dad682ca2a56df25$var$MultiAutocomplete.displayName = "MultiAutocomplete";
var $dfd33cee3229493c$var$$dad682ca2a56df25$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$dad682ca2a56df25$var$MultiAutocomplete;
/**
 * This component is a standard text input enhanced to provide options from a list of
 * pre-existing values and remap the selected options (if matching) to appropriate internal values.
 * This can hold either a single value or be enhanced to select multiple values, and supports
 * user entered values as well.
 *
 * If you need the ability to select options from a list, but not add custom values, generally
 * prefer `Select` instead.
 */ const $dfd33cee3229493c$var$$b7593ba9508daed4$var$AutocompleteInput = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef(({ multiple: multiple, ...subprops }, ref)=>{
    const Component = multiple ? $dfd33cee3229493c$var$$dad682ca2a56df25$export$2e2bcd8739ae039 : $dfd33cee3229493c$var$$c72ae339b28b0434$export$2e2bcd8739ae039;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Component, {
        ref: ref,
        ...subprops
    });
});
$dfd33cee3229493c$var$$b7593ba9508daed4$var$AutocompleteInput.propTypes = {
    multiple: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
var $dfd33cee3229493c$var$$b7593ba9508daed4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$b7593ba9508daed4$var$AutocompleteInput;
const $dfd33cee3229493c$var$$2bacd19a477cacc4$var$StyledInput = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$a195049fd73b3fe2)`
  cursor: pointer;

  ${(props)=>props.$noSelection ? (0, $e42cae22e74e223a$exports.css)`
          ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
        ` : ""}
`;
const $dfd33cee3229493c$var$$2bacd19a477cacc4$var$StyledWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  // remove top margin from multiple checkboxes (used to create space under label normally)
  margin: -8px 16px 0;
  min-width: 208px;
`;
/**
 * An extension to `MultipleCheckbox` to store it within a Select-like container. Primarily for use
 * in filters
 */ const $dfd33cee3229493c$var$$2bacd19a477cacc4$var$CheckboxDropdown = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const inputRef = ref || internalRef;
    const renderCheckboxes = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$2bacd19a477cacc4$var$StyledWrapper, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$ad70e152d33af944, {
                    children: props.dropdownDescription
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$41830a11bf46c032$export$2e2bcd8739ae039, {
                    ...props,
                    value: props.value || []
                })
            ]
        });
    const [dropdownContent, containerRef, toggleIsOpen] = $dfd33cee3229493c$var$$218ded47fcfcecd4$export$2e2bcd8739ae039(renderCheckboxes);
    const size = props.small ? $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$aef427ddd11a03fd : $dfd33cee3229493c$var$$6afcf9414f3c5d37$export$29ce903923b9e67f;
    const iconSize = props.small ? 16 : 18;
    const leadingIconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white30;
    const defaultChevronColor = dropdownContent ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white80 : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50;
    const TrailingIcon = dropdownContent ? $dfd33cee3229493c$var$$082f0a59b33f843a$export$2e2bcd8739ae039 : $dfd33cee3229493c$var$$a91646f62d6b2784$export$2e2bcd8739ae039;
    const trailingIconColor = props.disabled ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15 : defaultChevronColor;
    const focusAndToggle = ()=>{
        inputRef.current?.focus();
        toggleIsOpen();
    };
    const valueDisplay = `${props.placeholder} (${props.value?.length ?? 0})`;
    let renderedComponent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$6afcf9414f3c5d37$export$479bffa770f4fc8b, {
        $disabled: props.disabled,
        $error: props.showError,
        $size: size,
        className: props.className,
        ref: containerRef,
        onClick: focusAndToggle,
        role: "listbox",
        children: [
            props.leadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("leadingIcon", {
                size: iconSize,
                color: leadingIconColor
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$2bacd19a477cacc4$var$StyledInput, {
                ref: inputRef,
                placeholder: props.placeholder,
                name: props.name,
                disabled: props.disabled,
                value: valueDisplay,
                $noSelection: (props.value?.length ?? 0) === 0,
                readOnly: true
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(TrailingIcon, {
                size: iconSize,
                color: trailingIconColor
            })
        ]
    });
    if (props.anchorType === $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef.CHIP) renderedComponent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$42b9a489fcea3072$export$340ef18e89d7d15d, {
        ref: containerRef,
        onClick: props.disabled ? null : focusAndToggle,
        text: valueDisplay,
        role: "listbox"
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            componentVersion: 2
        },
        children: [
            dropdownContent,
            renderedComponent
        ]
    });
});
$dfd33cee3229493c$var$$2bacd19a477cacc4$var$CheckboxDropdown.propTypes = {
    // Common input props
    /** A class applied to the wrapper around the 'input' component of the select */ className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Whether the select is disabled or not */ disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /** What type of anchor should this select be rendered as? */ anchorType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef)),
    /** field name for this select */ name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    /** Event handler to be called whenever the value of the select changes */ onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** What to display if no option is selected for the input */ placeholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    small: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** Allows parent component to control the value stored on the select externally */ value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    /** Short description of the dropdown options displayed above options. */ dropdownDescription: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    showError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
$dfd33cee3229493c$var$$2bacd19a477cacc4$var$CheckboxDropdown.defaultProps = {
    multiple: false,
    searchable: false,
    anchorType: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$ca5aaf747a1765ef.TEXT_BOX,
    className: "",
    disabled: false,
    placeholder: "",
    defaultOption: "",
    noSort: false,
    showError: false,
    dropdownDescription: ""
};
$dfd33cee3229493c$var$$2bacd19a477cacc4$var$CheckboxDropdown.displayName = "CheckboxDropdown";
var $dfd33cee3229493c$var$$2bacd19a477cacc4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2bacd19a477cacc4$var$CheckboxDropdown;
const $dfd33cee3229493c$var$$c728b085ea0b24a0$var$HiddenInput = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("input", {
        ...props,
        ref: ref
    }));
$dfd33cee3229493c$var$$c728b085ea0b24a0$var$HiddenInput.displayName = "HiddenInput";
var $dfd33cee3229493c$var$$c728b085ea0b24a0$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c728b085ea0b24a0$var$HiddenInput;
const $dfd33cee3229493c$var$$5d2375683ba5721b$var$Label = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).label`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$672392da99d9bca0}
  ${(props)=>props.$error ? $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.sell : $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
  line-height: 18px;
  display: inline-block;
  order: -1;
`;
// Class name to retain inherited styles while migrating
const $dfd33cee3229493c$var$$5d2375683ba5721b$var$Wrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div.attrs({
    className: "flex-input"
})`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${(props)=>props.$width ? (0, $e42cae22e74e223a$exports.css)`
          &&& {
            max-width: ${props.$width}px;
            width: ${props.$width}px;
          }
        ` : ""}
`;
const $dfd33cee3229493c$var$$5d2375683ba5721b$var$StyledFollowingText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$672392da99d9bca0}
  ${(props)=>props.$error ? $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.sell : $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
  line-height: 18px;
  display: flex;
  justify-content: space-between;
`;
const $dfd33cee3229493c$var$$5d2375683ba5721b$var$StyledTrailingNode = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  display: block;
  justify-self: flex-end;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
`;
/**
 * Base component used to wrap an underlying field with a label and error text
 *
 * @param {object} props
 * @param {object} ref
 *
 * @returns {Element}
 */ const $dfd33cee3229493c$var$$5d2375683ba5721b$var$BlockValidatedField = /*#__PURE__*/ (0, $70fFQ.forwardRef)((props, ref)=>{
    const subprops = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).omit(props, [
        "component",
        "className",
        "label",
        "input",
        "meta",
        "render"
    ]);
    const Input = props.component;
    const showError = props.meta.touched && props.meta.invalid && !props.meta.active;
    const errorMessage = showError ? props.meta.error || props.meta.submitError : "";
    const helpText = errorMessage || props.helpText;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$5d2375683ba5721b$var$Wrapper, {
        $width: props.width,
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Input, {
                ref: ref,
                showError: showError,
                ...subprops,
                ...props.input
            }),
            (helpText || props.trailingNode) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$5d2375683ba5721b$var$StyledFollowingText, {
                $error: Boolean(errorMessage),
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                        children: helpText
                    }),
                    props.trailingNode && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$5d2375683ba5721b$var$StyledTrailingNode, {
                        children: props.trailingNode
                    })
                ]
            }),
            props.label && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$5d2375683ba5721b$var$Label, {
                $error: Boolean(errorMessage),
                htmlFor: props.id || props.input.name,
                children: props.label
            })
        ]
    });
});
$dfd33cee3229493c$var$$5d2375683ba5721b$var$BlockValidatedField.propTypes = {
    component: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object
    ]).isRequired,
    label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    input: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
        type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    }),
    meta: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        touched: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        invalid: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        active: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        error: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        submitError: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    }).isRequired,
    helpText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    trailingNode: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    width: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
$dfd33cee3229493c$var$$5d2375683ba5721b$var$BlockValidatedField.defaultProps = {
    errorMessage: "",
    label: "",
    className: "",
    input: null,
    helpText: "",
    trailingNode: null
};
$dfd33cee3229493c$var$$5d2375683ba5721b$var$BlockValidatedField.displayName = "BlockValidatedField";
var $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5d2375683ba5721b$var$BlockValidatedField;
// Most of these are valid HTML input type attribute values. Some we remap under the covers
const $dfd33cee3229493c$var$$36cad0c88b1f5120$var$TYPE_MAPPING = {
    autocomplete: [
        $dfd33cee3229493c$var$$b7593ba9508daed4$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    checkbox: [
        $dfd33cee3229493c$var$$6cfe30fe9315c100$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039
    ],
    "custom-inline": [
        null,
        $dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039
    ],
    "custom-block": [
        null,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    date: [
        $dfd33cee3229493c$var$$4e2531e555f1f9b8$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039,
        {
            format: $dfd33cee3229493c$var$$4e2531e555f1f9b8$export$3ae94a2503e890a1
        }
    ],
    file: [
        $dfd33cee3229493c$var$$b616754bcddbd553$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    hidden: [
        $dfd33cee3229493c$var$$c728b085ea0b24a0$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    "multiple-checkbox": [
        $dfd33cee3229493c$var$$41830a11bf46c032$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    "checkbox-dropdown": [
        $dfd33cee3229493c$var$$2bacd19a477cacc4$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    number: [
        $dfd33cee3229493c$var$$b467eb62d85e0dc9$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039,
        {
            parse: $dfd33cee3229493c$var$$b467eb62d85e0dc9$export$a7737621d70c08a2,
            format: $dfd33cee3229493c$var$$b467eb62d85e0dc9$export$be206aa0a590ffb3
        }
    ],
    password: [
        $dfd33cee3229493c$var$$33dbf99396bbe51c$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    // We use a single input type="radio" in our interface for a group of radio inputs, we need to
    // override the type so other libraries don't apply the default behavior that mirrors browser
    // type radio more closely
    radio: [
        $dfd33cee3229493c$var$$568c3e0e2fd4254e$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039,
        {
            type: "hidden"
        }
    ],
    select: [
        $dfd33cee3229493c$var$$c36a08b03cc5dbf3$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    switch: [
        $dfd33cee3229493c$var$$7195e09895656fea$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$f29a25dd8cabf33b$export$2e2bcd8739ae039
    ],
    text: [
        $dfd33cee3229493c$var$$a3428f5ff52af727$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ],
    textarea: [
        $dfd33cee3229493c$var$$d0bc4a9b8df9b007$export$2e2bcd8739ae039,
        $dfd33cee3229493c$var$$5d2375683ba5721b$export$2e2bcd8739ae039
    ]
};
const $dfd33cee3229493c$var$$36cad0c88b1f5120$export$79dfbaf27b0062a4 = $dfd33cee3229493c$var$$36cad0c88b1f5120$var$TYPE_MAPPING.text;
// Includes unconventional input types that the browser may add some default validation on
const $dfd33cee3229493c$var$$36cad0c88b1f5120$var$WITH_ALIASES = {
    tel: $dfd33cee3229493c$var$$36cad0c88b1f5120$var$TYPE_MAPPING.text,
    email: $dfd33cee3229493c$var$$36cad0c88b1f5120$var$TYPE_MAPPING.text,
    url: $dfd33cee3229493c$var$$36cad0c88b1f5120$var$TYPE_MAPPING.text,
    ...$dfd33cee3229493c$var$$36cad0c88b1f5120$var$TYPE_MAPPING
};
var $dfd33cee3229493c$var$$36cad0c88b1f5120$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$36cad0c88b1f5120$var$WITH_ALIASES;
// A slimmed down meta status we can pass down to reuse the main interface leveraged by final-form
const $dfd33cee3229493c$var$$2c4674390d92bf46$var$DEFAULT_META = {
    active: false,
    touched: true
};
const $dfd33cee3229493c$var$$2c4674390d92bf46$var$INPUT_PROP_NAMES = [
    "type",
    "checked",
    "onFocus",
    "onBlur",
    "multiple",
    "defaultChecked",
    "disabled"
];
/**
 * An HTML input (or other form field) not connected to react final form
 */ const $dfd33cee3229493c$var$$2c4674390d92bf46$var$Field = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const prefix = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$783a6a60ccdbd93e);
    const name = `${prefix}${props.name}`;
    const idProp = props.id || name;
    const [Component, Wrapper, additionalProps] = $dfd33cee3229493c$var$$36cad0c88b1f5120$export$2e2bcd8739ae039[props.type] || $dfd33cee3229493c$var$$36cad0c88b1f5120$export$79dfbaf27b0062a4;
    const onChange = (e)=>{
        const handler = props.handleChange || props.onChange; // eslint-disable-line react/prop-types
        if (!handler) return;
        if (additionalProps?.parse) return handler({
            ...e,
            target: {
                ...e.target,
                value: additionalProps.parse(e.target.value)
            }
        });
        return handler(e);
    };
    const inputProps = {
        name: name,
        onChange: onChange,
        value: additionalProps?.format ? additionalProps.format(props.value) : props.value,
        ...$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).pick(props, $dfd33cee3229493c$var$$2c4674390d92bf46$var$INPUT_PROP_NAMES)
    };
    const subProps = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).omit(props, [
        "name",
        "onChange",
        "handleChange",
        "input",
        "component",
        ...$dfd33cee3229493c$var$$2c4674390d92bf46$var$INPUT_PROP_NAMES
    ]);
    const meta = {
        ...$dfd33cee3229493c$var$$2c4674390d92bf46$var$DEFAULT_META,
        invalid: Boolean(props.errorMessage),
        error: props.errorMessage
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Wrapper, {
        ref: ref,
        component: Component || props.component,
        input: inputProps,
        meta: meta,
        ...subProps,
        id: idProp
    });
});
$dfd33cee3229493c$var$$2c4674390d92bf46$var$Field.propTypes = {
    label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    errorMessage: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /* React component to render the underlying input if "type" is custom */ component: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object
    ])
};
$dfd33cee3229493c$var$$2c4674390d92bf46$var$Field.defaultProps = {
    // eslint-disable-next-line no-undefined
    id: undefined,
    label: null,
    disabled: false,
    type: "text",
    className: "",
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
    errorMessage: ""
};
$dfd33cee3229493c$var$$2c4674390d92bf46$var$Field.displayName = "Field";
var $dfd33cee3229493c$var$$2c4674390d92bf46$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2c4674390d92bf46$var$Field;
/**
 * Convenience hook to grab the value of a single field within the current form.
 *
 * This can only be used within a form context and will crash otherwise.
 *
 * @param {string} fieldName - the field you want to get the value of
 * @param {any} defaultValue - if value is null/undefined, this value will be returned as a fallback
 *
 * @returns {any}
 */ const $dfd33cee3229493c$var$$291c590e4543bbd3$var$useFormValue = (fieldName, defaultValue)=>{
    // Subscribe to updates to the field's value only, extract it from the returned shape
    const { input: { value: value } } = (0, $42456926338d44c1$export$294aa081a6c6f55d)(fieldName, {
        subscription: {
            value: true
        }
    });
    // A 0 or false should be passed through, but null/undefined should not
    if (($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isNil(value) || value === "") && !$dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isUndefined(defaultValue)) return defaultValue;
    return value;
};
var $dfd33cee3229493c$var$$291c590e4543bbd3$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$291c590e4543bbd3$var$useFormValue;
const $dfd33cee3229493c$var$$6714463298d23a2e$var$ChangeListener = ({ onChange: onChange, name: name })=>{
    const value = $dfd33cee3229493c$var$$291c590e4543bbd3$export$2e2bcd8739ae039(name);
    const didMount = $dfd33cee3229493c$var$$8ea3e04a44a07747$export$2e2bcd8739ae039();
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        if (didMount) onChange(value);
    }, [
        value
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};
var $dfd33cee3229493c$var$$6714463298d23a2e$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6714463298d23a2e$var$ChangeListener;
// When submitting forms that have cleared values, i.e. clearing the field 'assigned-rep', the
// 'assigned-rep' key does not appear by default in the submit data object because its value
// has become "undefined". We want `assigned-rep: undefined` to show up in our form submit data
// to indicate cleared values in update forms.
const $dfd33cee3229493c$var$$ae83ede378baf651$var$identity = (value)=>value;
// Historically redux-form passed a validate prop that was an array. react-final-form expects a
// function. This coerces the old structure to be valid while not breaking anything that doesn't
// require coercion.
const $dfd33cee3229493c$var$$ae83ede378baf651$var$composeValidators = (validators)=>{
    if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isFunction(validators)) return validators;
    return (value, form, meta)=>validators.reduce((error, validator)=>error || validator(value, form, meta), undefined); // eslint-disable-line no-undefined
};
/**
 * An HTML input (or other form field) connected to react final form
 */ const $dfd33cee3229493c$var$$ae83ede378baf651$var$FinalFormField = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const prefix = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$cd5da3c7f6c4a48b$export$783a6a60ccdbd93e);
    const name = `${prefix}${props.name}`;
    const idProp = props.id || name;
    const [Component, Wrapper, additionalProps] = $dfd33cee3229493c$var$$36cad0c88b1f5120$export$2e2bcd8739ae039[props.type] || $dfd33cee3229493c$var$$36cad0c88b1f5120$export$79dfbaf27b0062a4;
    const memoizedComponent = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback((memProps)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Wrapper, {
            ref: ref,
            ...memProps,
            component: Component || props.component
        }), [
        Wrapper,
        Component,
        props.component,
        ref
    ]);
    const field = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($42456926338d44c1$export$a455218a85c89869, {
        ...props,
        ...additionalProps,
        name: name,
        component: memoizedComponent,
        id: idProp,
        validate: $dfd33cee3229493c$var$$ae83ede378baf651$var$composeValidators(props.validate)
    });
    if (props.type === "hidden") return field;
    const onChange = props.handleChange || props.onChange; // eslint-disable-line react/prop-types
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            field,
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6714463298d23a2e$export$2e2bcd8739ae039, {
                name: name,
                onChange: onChange
            })
        ]
    });
});
$dfd33cee3229493c$var$$ae83ede378baf651$var$FinalFormField.propTypes = {
    label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    required: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    disabled: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    parse: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    validate: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func),
    component: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object
    ])
};
$dfd33cee3229493c$var$$ae83ede378baf651$var$FinalFormField.defaultProps = {
    // eslint-disable-next-line no-undefined
    id: undefined,
    label: null,
    required: false,
    disabled: false,
    type: "text",
    className: "",
    onChange: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
    parse: $dfd33cee3229493c$var$$ae83ede378baf651$var$identity,
    validate: []
};
$dfd33cee3229493c$var$$ae83ede378baf651$var$FinalFormField.displayName = "FinalFormField";
var $dfd33cee3229493c$var$$ae83ede378baf651$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ae83ede378baf651$var$FinalFormField;
/* eslint-disable react/no-array-index-key */ const $dfd33cee3229493c$var$$f0ac8474900a60e5$var$StyledIconButton = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039)`
  margin-left: 8px;
`;
const $dfd33cee3229493c$var$$f0ac8474900a60e5$var$FieldArrayComponent = ({ fields: fields, fieldComponent: FieldComponent, addText: addText, ...props })=>{
    const didMount = $dfd33cee3229493c$var$$8ea3e04a44a07747$export$2e2bcd8739ae039();
    (0, $70fFQ.useEffect)(()=>{
        if (didMount && !fields.length) fields.push();
    }, [
        fields,
        didMount
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            fields.map((field, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$de07a7337aac81e2$export$2e2bcd8739ae039, {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(FieldComponent, {
                            name: field,
                            ...props
                        }),
                        $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).size(fields) !== 1 && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f0ac8474900a60e5$var$StyledIconButton, {
                            onClick: ()=>fields.remove(index),
                            icon: $dfd33cee3229493c$var$$e70e94b576d9ab55$export$2e2bcd8739ae039
                        })
                    ]
                }, field)),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$de07a7337aac81e2$export$2e2bcd8739ae039, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$a2c12df47548b0d7, {
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039, {
                        onClick: ()=>fields.push(),
                        children: addText
                    })
                })
            })
        ]
    });
};
$dfd33cee3229493c$var$$f0ac8474900a60e5$var$FieldArrayComponent.propTypes = {
    fields: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    addText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    fieldComponent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    ]).isRequired
};
const $dfd33cee3229493c$var$$f0ac8474900a60e5$var$FieldArray = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bd7cd108646cef09$export$2683597413c8b91, {
        ...props,
        name: props.name,
        component: $dfd33cee3229493c$var$$f0ac8474900a60e5$var$FieldArrayComponent,
        validate: props.validate,
        addText: props.addText,
        fieldComponent: props.component
    });
$dfd33cee3229493c$var$$f0ac8474900a60e5$var$FieldArray.propTypes = {
    required: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    addText: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    component: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    ]).isRequired,
    name: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    validate: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
};
$dfd33cee3229493c$var$$f0ac8474900a60e5$var$FieldArray.defaultProps = {
    required: false,
    validate: null
};
var $dfd33cee3229493c$var$$f0ac8474900a60e5$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f0ac8474900a60e5$var$FieldArray;
var $dfd33cee3229493c$var$$158dfe5f733ca3db$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$158dfe5f733ca3db$exports, "Definition", ()=>$dfd33cee3229493c$var$$f176b85f5ec40d64$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$158dfe5f733ca3db$exports, "DefinitionListHeader", ()=>$dfd33cee3229493c$var$$aff2f337218a446c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$158dfe5f733ca3db$exports, "List", ()=>$dfd33cee3229493c$var$$751c2b0ed7ba4699$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$158dfe5f733ca3db$exports, "ListStyles", ()=>$dfd33cee3229493c$var$$fb72894a53085051$export$e38ab7727d17117c);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$158dfe5f733ca3db$exports, "ListItem", ()=>$dfd33cee3229493c$var$$fb72894a53085051$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$158dfe5f733ca3db$exports, "ListHeader", ()=>$dfd33cee3229493c$var$$2c77bda2fc7298a0$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$aff2f337218a446c$var$StyledWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$93db1c4064a2ca6)`
  align-items: center;
  line-height: 1;
  border-bottom: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
  margin-bottom: 8px;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
`;
/**
 * Yuka v2.0
 * This is a component used to display the standard heading for a list of definitions
 *
 * @param {object} props
 *
 * @returns {Element}
 */ const $dfd33cee3229493c$var$$aff2f337218a446c$export$712fb58b37184762 = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$aff2f337218a446c$var$StyledWrapper, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: props.title
            }),
            props.actionLink && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039, {
                ...props.linkProps,
                children: props.actionLink
            })
        ]
    });
$dfd33cee3229493c$var$$aff2f337218a446c$export$712fb58b37184762.propTypes = {
    title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /** Action link text */ actionLink: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    /** Any props to pass to the link, e.g. onClick, url, linkType */ linkProps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).object,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$aff2f337218a446c$export$712fb58b37184762.defaultProps = {
    className: ""
};
// Wrap with styled so this can be used inline for styles
const $dfd33cee3229493c$var$$aff2f337218a446c$var$StyledDefinitionListHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$aff2f337218a446c$export$712fb58b37184762)``;
$dfd33cee3229493c$var$$aff2f337218a446c$var$StyledDefinitionListHeader.displayName = "DefinitionListHeader";
var /* @component */ $dfd33cee3229493c$var$$aff2f337218a446c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$aff2f337218a446c$var$StyledDefinitionListHeader;
var $dfd33cee3229493c$var$$5a3231ddaa76d46d$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5a3231ddaa76d46d$exports, "Tooltip", ()=>$dfd33cee3229493c$var$$2716d1189824a9da$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$5a3231ddaa76d46d$exports, "useTooltip", ()=>$dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).dl`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 8px 0;
  margin: 0;

  & + ${$dfd33cee3229493c$var$$aff2f337218a446c$export$2e2bcd8739ae039} {
    // When multiple lists consecutively, give a bit extra space
    // Because it's vertical margins, they collapse, we want 12px total here
    margin-top: 12px;
  }
`;
const $dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledLabel = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Overlinetheme50).attrs({
    as: "dt"
})`
  line-height: 16px;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledValue = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Body1theme80).attrs({
    as: "dd"
})`
  line-height: 16px;
  margin-left: 24px;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
  white-space: nowrap;
`;
/**
 * A label value pair displayed in a standard arrangement. Typically found in multiples forming a
 * list. Provides reasonable null text if the value is false-y. The element exapnds to fill the
 * space available and will ellipsis out overflow. Provide a formatted value if multiline display
 * is necessary.
 *
 * Include a header in the definition list if there are multiple definition list in the same section
 * or if the least needs emphasis. A header includes a title and optionally an action link.
 */ const $dfd33cee3229493c$var$$f176b85f5ec40d64$export$109c7b9a380a003e = (props)=>{
    const widthMeasuringValueRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const widthMeasuringLabelRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const [valueWidth, setValueWidth] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState([
        0,
        0
    ]);
    const [labelWidth, setLabelWidth] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState([
        0,
        0
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        setValueWidth([
            widthMeasuringValueRef.current?.scrollWidth,
            widthMeasuringValueRef.current?.offsetWidth
        ]);
        setLabelWidth([
            widthMeasuringLabelRef.current?.scrollWidth,
            widthMeasuringLabelRef.current?.offsetWidth
        ]);
    }, [
        widthMeasuringValueRef.current?.scrollWidth,
        widthMeasuringValueRef.current?.offsetWidth
    ]);
    const valueTooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(widthMeasuringValueRef, props.value || "--");
    const labelTooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(widthMeasuringLabelRef, props.label || "--");
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledWrapper, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledLabel, {
                ref: widthMeasuringLabelRef,
                children: props.label
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledValue, {
                ref: widthMeasuringValueRef,
                children: props.value || "--"
            }),
            valueWidth[0] > valueWidth[1] && valueTooltip,
            labelWidth[0] > labelWidth[1] && labelTooltip
        ]
    });
};
$dfd33cee3229493c$var$$f176b85f5ec40d64$export$109c7b9a380a003e.propTypes = {
    label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /** If the display value is false-y, defaults to provide a reasonable null text */ value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /** Explicit usage discouraged, but can be used to wrap in a styled component */ className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$f176b85f5ec40d64$export$109c7b9a380a003e.defaultProps = {
    value: null,
    className: ""
};
const $dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledDefinition = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$f176b85f5ec40d64$export$109c7b9a380a003e)``;
$dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledDefinition.displayName = "Definition";
var $dfd33cee3229493c$var$$f176b85f5ec40d64$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f176b85f5ec40d64$var$StyledDefinition;
const $dfd33cee3229493c$var$$751c2b0ed7ba4699$var$List = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).ul.attrs({
    role: "list",
    className: "zx-list"
})`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  ${(props)=>props.divider ? `
    > ${$dfd33cee3229493c$var$$fb72894a53085051$export$2e2bcd8739ae039} {
      border-bottom: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
    }
    > ${$dfd33cee3229493c$var$$f176b85f5ec40d64$export$2e2bcd8739ae039} {
      border-bottom: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white15};
    }
  ` : ""}
`;
$dfd33cee3229493c$var$$751c2b0ed7ba4699$var$List.propTypes = {
    /** Should items be displayed with a divider between them */ divider: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$751c2b0ed7ba4699$var$List.defaultProps = {
    divider: false,
    className: ""
};
$dfd33cee3229493c$var$$751c2b0ed7ba4699$var$List.displayName = "List";
var /* @component */ $dfd33cee3229493c$var$$751c2b0ed7ba4699$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$751c2b0ed7ba4699$var$List;
const $dfd33cee3229493c$var$$2c77bda2fc7298a0$var$ListHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
  margin: 0 12px 12px;
`;
$dfd33cee3229493c$var$$2c77bda2fc7298a0$var$ListHeader.propTypes = {
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired
};
$dfd33cee3229493c$var$$2c77bda2fc7298a0$var$ListHeader.displayName = "ListHeader";
var /* @component */ $dfd33cee3229493c$var$$2c77bda2fc7298a0$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2c77bda2fc7298a0$var$ListHeader;
var $dfd33cee3229493c$var$$e6b58dd263c501b0$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$e6b58dd263c501b0$exports, "Table", ()=>$dfd33cee3229493c$var$$e86b805150f3483f$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$28610bd394c82dfd$var$getStyle = (key)=>(accessor, props)=>{
        const styles = props.theme?.tableStyles?.[key]?.[accessor];
        const currentSurface = (0, $70fFQ.useContext)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5);
        if (typeof styles === "function") return styles(props);
        return styles || styles === 0 ? styles : $dfd33cee3229493c$var$$58d0bb043433b77a$export$2e2bcd8739ae039(currentSurface - 1)[key]?.[accessor];
    };
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8 = $dfd33cee3229493c$var$$28610bd394c82dfd$var$getStyle("colors");
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1 = $dfd33cee3229493c$var$$28610bd394c82dfd$var$getStyle("header");
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e = $dfd33cee3229493c$var$$28610bd394c82dfd$var$getStyle("cells");
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$7a91a2f874220ab6 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  position: relative;
  flex-direction: column;
  max-height: 100%;
  ${(props)=>props.$usePercentageColumnWidths ? (0, $e42cae22e74e223a$exports.css)`
          width: 100%;
          overflow-x: hidden;
        ` : (0, $e42cae22e74e223a$exports.css)`
          width: 100%;
          overflow: auto;
        `}
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$9224ee7fa5eef0cc = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: inline-block;
  left: 0;
  position: sticky;
  top: 0;
  z-index: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c.zIndexVisible};
  ${(props)=>props.$width ? `width: ${props.$width}px;` : ""};
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$f99395d0d1e1a10e = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  background: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("header", props)};
  color: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("headerText", props)};
  ${(props)=>props.$column.width ? `width: ${props.$column.width}px;` : ""}
  top: 0;
  ${(props)=>props.$column.sticky ? (0, $e42cae22e74e223a$exports.css)`
          position: sticky;
          z-index: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c.zIndexVisible};
          left: ${props.$column.totalLeft}px;
        ` : ""};
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$cd928bb20d3ce93f = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${(props)=>props.$width ? `width: ${props.$width}px;` : ""};
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$81761b52b04ea573 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;

  ${(props)=>props.$onRowClick ? (0, $e42cae22e74e223a$exports.css)`
          &:hover > ${$dfd33cee3229493c$var$$28610bd394c82dfd$export$9253e4f716553796} {
            /* 
             * Determine the hover colour to use dynamically, based on the style configuration in 
             * the theme object. If \`theme.tableStyles.colors.row\` is a function, invoke it to 
             * determine the color. Inspired by Tangelo's rowClassName behaviour. Applies background 
             * to child TableCells, which will self-apply if they have an onCellClick handler 
             * anyway. This way, we get the functionality of highlighting whole rows if the whole 
             * row is clickable, or just individual cells if they have individual handlers.
             */
            background: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("rowHover", props)};
            cursor: pointer;
          }
          &:active > ${$dfd33cee3229493c$var$$28610bd394c82dfd$export$9253e4f716553796} {
            /* 
             * Similar to the hover interaction but with active coloring.
             */
            background: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("rowActive", props)};
          }
        ` : ""}
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$f892d76a9565988f = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
  display: flex;
  align-items: center;
  height: ${(props)=>props.$height}px;
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$9253e4f716553796 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
  flex-shrink: 0;
  flex-grow: 0;
  width: ${(props)=>props.$column.width}px;
  padding: 0;
  ${(props)=>props.$column.sticky ? (0, $e42cae22e74e223a$exports.css)`
          position: sticky;
          left: ${props.$column.totalLeft}px;
        ` : (0, $e42cae22e74e223a$exports.css)``}

  background: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("row", props)};
  /* 
  These hover/active styles are redundant if the whole row is clickable because of the identical 
  styling in the TableRow, however if only individual onCellClick handlers are defined, then this
  styling applies special colouring only to the hovered cell. 
  */
  ${(props)=>props.$column.onCellClick ? (0, $e42cae22e74e223a$exports.css)`
          &:hover {
            background: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("rowHover", props)};
            cursor: pointer;
          }
          &:active {
            background: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("rowActive", props)};
            cursor: pointer;
          }
        ` : (0, $e42cae22e74e223a$exports.css)``}
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$7fb51b284d7f1c81 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 48px;
  left: 0;
  margin-top: 16px;
  position: sticky;
  ${(props)=>props.$width ? `width: ${props.$width}px;` : ""};
`;
const $dfd33cee3229493c$var$$28610bd394c82dfd$export$a870e4e2493f0aa1 = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
`;
const $dfd33cee3229493c$var$$9657403c98743393$var$HEADER_COMPONENT_GAP = 4;
const $dfd33cee3229493c$var$$9657403c98743393$var$DEFAULT_HEADER_LEADING_ICON_SIZE = 16;
const $dfd33cee3229493c$var$$9657403c98743393$var$StyledHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7};
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  gap: ${$dfd33cee3229493c$var$$9657403c98743393$var$HEADER_COMPONENT_GAP}px;
  height: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("height", props)}px;
  align-items: center;

  // Alignment
  ${(props)=>{
    if (props.$column.align === "right") return (0, $e42cae22e74e223a$exports.css)`
        justify-content: flex-end;
      `;
    else if (props.$column.align === "center") return (0, $e42cae22e74e223a$exports.css)`
        justify-content: center;
      `;
    return (0, $e42cae22e74e223a$exports.css)`
      justify-content: flex-start;
    `;
}};

  // Padding
  ${(props)=>{
    if (props.$column.padding || props.$column.padding === 0) return (0, $e42cae22e74e223a$exports.css)`
        padding: ${props.$column.padding}px;
      `;
    return (0, $e42cae22e74e223a$exports.css)`
      padding: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("paddingTop", props)}px
        ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("paddingRight", props)}px
        ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("paddingBottom", props)}px
        ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("paddingLeft", props)}px;
    `;
}}

  // Borders
  border-top: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("borderTop", props)};
  border-bottom: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("borderBottom", props)};
  border-left: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1("borderLeft", props)};
  ${(props)=>{
    if (!props.$isFinalColumn && (props.$showBorders || props.$isFinalStickyColumn)) {
        const accessor = props.$isFinalStickyColumn ? "thickenedBorderRight" : "borderRight";
        return (0, $e42cae22e74e223a$exports.css)`
        border-right: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1(accessor, props)};
      `;
    }
}}

  // Background color + cursor based on sort-ability.
  ${(props)=>props.$column.sortable ? (0, $e42cae22e74e223a$exports.css)`
          &:hover {
            background-color: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("headerHover", props)};
            cursor: pointer;
          }
          &:active {
            background-color: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$a44245571c7d7aa8("headerActive", props)};
          }
        ` : (0, $e42cae22e74e223a$exports.css)`
          cursor: default;
        `}

  svg:not(:root) {
    flex-shrink: 0;
  }
`;
const $dfd33cee3229493c$var$$9657403c98743393$var$StyledHeaderText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $dfd33cee3229493c$var$$9657403c98743393$var$DefaultHeaderRenderer = ({ column: column, manualSortBy: manualSortBy = false, onSort: onSort = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop, sortState: sortState = [], numberOfStickyColumns: numberOfStickyColumns, ...props })=>{
    const theme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    const containerRef = (0, $70fFQ.useRef)(null);
    const headerRef = (0, $70fFQ.useRef)(null);
    let [sortingByThisColumnAsc, sortingByThisColumnDesc] = [
        false,
        false
    ];
    let nextSortingCriteria = {
        id: column.id
    };
    if (sortState.length) {
        const currentSort = sortState[0];
        // props.sortState looks like [{ id: "string", desc: false, [hideArrow]: true }]
        // If currentSort.hideArrow, both of these will be false, despite the data being sorted
        // in the table. This way we can have a default sort state that's not indicated visually.
        sortingByThisColumnAsc = !currentSort.hideArrow && currentSort.id === column.id && !currentSort.desc;
        sortingByThisColumnDesc = !currentSort.hideArrow && currentSort.id === column.id && currentSort.desc === true;
        // Sort order by clicking the headers goes in the cycle "unsorted, ascending, descending, unsorted".
        if (sortingByThisColumnAsc) nextSortingCriteria.desc = true;
        else if (sortingByThisColumnDesc) nextSortingCriteria = null;
        else nextSortingCriteria.desc = false;
    } else if (!manualSortBy) {
        sortingByThisColumnAsc = column.isSorted === true && !column.isSortedDesc;
        sortingByThisColumnDesc = column.isSorted === true && column.isSortedDesc === true;
    }
    const onClick = column.sortable ? ()=>onSort(nextSortingCriteria) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop;
    const headerContentFromHeaderRenderer = column.headerRenderer ? column.headerRenderer({
        header: column.header,
        ...column,
        ...props
    }) : column.header || "";
    // Attach a tooltip to headers with truncated content.
    // Allow column-specified padding.
    let paddingLeft = column.padding || column.padding === 0 ? column.padding : theme.tableStyles.header.paddingLeft;
    let paddingRight = column.padding || column.padding === 0 ? column.padding : theme.tableStyles.header.paddingRight;
    if (sortingByThisColumnAsc || sortingByThisColumnDesc) paddingRight += 16 + $dfd33cee3229493c$var$$9657403c98743393$var$HEADER_COMPONENT_GAP;
    if (column.headerLeadingIcon) paddingLeft += (column.headerLeadingIconSize || $dfd33cee3229493c$var$$9657403c98743393$var$DEFAULT_HEADER_LEADING_ICON_SIZE) + $dfd33cee3229493c$var$$9657403c98743393$var$HEADER_COMPONENT_GAP;
    let tooltipContent = null;
    if (typeof headerContentFromHeaderRenderer === "string") {
        if (headerRef.current?.scrollWidth && containerRef.current?.offsetWidth && headerRef.current?.scrollWidth > containerRef.current?.offsetWidth - paddingLeft - paddingRight) tooltipContent = headerContentFromHeaderRenderer;
    }
    const tooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(containerRef, tooltipContent, {
        orientation: column.headerTooltip && typeof column.headerTooltip === "function" ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$9657403c98743393$var$StyledHeader, {
                $column: column,
                $showBorders: props.showBorders,
                $isFinalColumn: props.columns.length === column.index + 1,
                $isFinalStickyColumn: column.sticky && numberOfStickyColumns === column.index + 1,
                onClick: onClick,
                ref: containerRef,
                children: [
                    column.headerLeadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(column.headerLeadingIcon, {
                        size: column.headerLeadingIconSize,
                        color: column.headerLeadingIconColor
                    }),
                    typeof headerContentFromHeaderRenderer === "string" ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$9657403c98743393$var$StyledHeaderText, {
                        ref: headerRef,
                        children: headerContentFromHeaderRenderer
                    }) : headerContentFromHeaderRenderer,
                    sortingByThisColumnAsc && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$502f458cee51ae7f$export$2e2bcd8739ae039, {
                        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white80
                    }),
                    sortingByThisColumnDesc && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$9b205aa1790e85a4$export$2e2bcd8739ae039, {
                        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white80
                    })
                ]
            }),
            tooltipContent ? tooltip : null
        ]
    });
};
$dfd33cee3229493c$var$$9657403c98743393$var$DefaultHeaderRenderer.propTypes = {
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        ]).isRequired,
        index: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        sticky: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        isSorted: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        isSortedDesc: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        sortable: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        padding: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        renderHeaderOverflow: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        headerRenderer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        header: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        headerTooltip: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        headerLeadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        headerLeadingIconSize: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        headerLeadingIconColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    }).isRequired,
    showBorders: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    numberOfStickyColumns: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    columns: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({})).isRequired,
    manualSortBy: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    onSort: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    sortState: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({}))
};
$dfd33cee3229493c$var$$9657403c98743393$var$DefaultHeaderRenderer.displayName = "DefaultHeaderRenderer";
var $dfd33cee3229493c$var$$9657403c98743393$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$9657403c98743393$var$DefaultHeaderRenderer;
// These are the column types this table allows for editable table data. If you need to use
// the standard editing controls, map your external columns to include a `column_type` parameter
// with one of these constants as the value so the table knows how to edit the cells.
const $dfd33cee3229493c$var$$b0b35d27495fc177$export$7ce43d0a8f00d826 = {
    PLAIN_TEXT: 1,
    DATE: 2,
    NUMBER: 3,
    PERCENT: 4,
    SINGLE_SELECT: 5,
    CURRENCY: 6
};
const $dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledContent = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  /* We need to render a flex box if rendering something other than text. */
  ${(props)=>props.$isText ? (0, $e42cae22e74e223a$exports.css)`
          display: inline-block;
          text-align: ${props.$align ? props.$align : "left"};
        ` : (0, $e42cae22e74e223a$exports.css)`
          display: flex;
          flex-direction: row;
          justify-content: ${(props)=>{
        if (props.$align === "right") return "flex-end";
        else if (props.$align === "center") return "center";
        return "flex-start";
    }};
        `}
  border-radius: 4px;
  ${(props)=>props.$renderOverflow ? "" : (0, $e42cae22e74e223a$exports.css)`
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `}
  ${(props)=>props.$width ? `width: ${props.$width - props.$paddingLeft - props.$paddingRight}px;` : ""}
`;
const $dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledCell = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  align-items: center;
  box-sizing: border-box;

  // Padding
  ${(props)=>{
    if (props.$column.padding || props.$column.padding === 0) return (0, $e42cae22e74e223a$exports.css)`
        padding: ${props.$column.padding}px;
      `;
    return (0, $e42cae22e74e223a$exports.css)`
      padding: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("paddingTop", props)}px
        ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("paddingRight", props)}px
        ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("paddingBottom", props)}px
        ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("paddingLeft", props)}px;
    `;
}}

  // Borders
  border-top: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("borderTop", props)};
  border-bottom: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("borderBottom", props)};
  border-left: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("borderLeft", props)};
  ${(props)=>{
    if (!props.$isFinalColumn && (props.$showBorders || props.$isFinalStickyColumn)) {
        const accessor = props.$isFinalStickyColumn ? "thickenedBorderRight" : "borderRight";
        return (0, $e42cae22e74e223a$exports.css)`
        border-right: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$4118f286336f6fe1(accessor, props)};
      `;
    }
}}

  ${(props)=>props.$column.width ? `width: ${props.$column.width}px;` : ""}
  ${(props)=>props.$inputError && props.$isEditingCell ? (0, $e42cae22e74e223a$exports.css)`
          position: absolute;
          left: ${props.$column.totalLeft}px;
          height: 75px;
        ` : (0, $e42cae22e74e223a$exports.css)`
          height: ${(props)=>$dfd33cee3229493c$var$$28610bd394c82dfd$export$25de7c25b9226e7e("height", props)}px;
        `}

  ${(props)=>props.$isSelected ? (0, $e42cae22e74e223a$exports.css)`
          z-index: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$10f1f7ea30e1592c.zIndexVisible};
          border-radius: 4px;
          outline: 2px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400};
          outline-offset: -2px;
        ` : ""}
`;
const $dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;
const $dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledError = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0};
  margin-top: 16px;
  color: rgba(255, 255, 255, 0.5);
`;
const $dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledInput = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).input`
  width: 100%;
  padding: 0;
  border: none;
  background-color: transparent;
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white100};

  &:focus {
    outline: none;
  }
`;
const $dfd33cee3229493c$var$$eee9b90cb319bb22$var$getEditComponentForColumn = (column, isEditingCell, inputProps)=>{
    switch(column.column_type){
        case $dfd33cee3229493c$var$$b0b35d27495fc177$export$7ce43d0a8f00d826.PLAIN_TEXT:
        case $dfd33cee3229493c$var$$b0b35d27495fc177$export$7ce43d0a8f00d826.NUMBER:
            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledContainer, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledInput, {
                        ref: (input)=>{
                            if (input && isEditingCell) input.focus();
                            return input;
                        },
                        ...inputProps
                    }),
                    inputProps.inputError && isEditingCell && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledError, {
                        children: inputProps.inputError
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: "edit not supported yet"
            });
    }
};
const $dfd33cee3229493c$var$$eee9b90cb319bb22$var$DefaultCellRenderer = (props)=>{
    const theme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    // Must be a function since `props.value` can be a React component in the case of
    // IconButton cells, etc.
    const [value, setValue] = (0, $70fFQ.useState)(()=>props.value);
    const [inputError, setInputError] = (0, $70fFQ.useState)(null);
    const containerRef = (0, $70fFQ.useRef)(null);
    const cellRef = (0, $70fFQ.useRef)(null);
    const { updateData: updateData, row: row, column: column, columns: columns, value: propsValue, numberOfStickyColumns: numberOfStickyColumns } = props;
    const confirmEdit = ()=>{
        if (column.column_type === $dfd33cee3229493c$var$$b0b35d27495fc177$export$7ce43d0a8f00d826.NUMBER) updateData?.(row, column, value !== "" ? Number(value) : null);
        else updateData?.(row, column, value);
    };
    const onChange = (e)=>{
        if (column.column_type !== $dfd33cee3229493c$var$$b0b35d27495fc177$export$7ce43d0a8f00d826.NUMBER || !isNaN(Number(e.currentTarget.value))) {
            setInputError(null);
            setValue(e.currentTarget.value);
        } else setInputError("Please enter a number");
    };
    // Cell selection requires rows to have IDs.
    const isCellSelected = props.selectedCell?.row === row.original.id && props.selectedCell.col === column.id;
    const isEditingCell = props.editingCell?.row === row.original.id && props.editingCell?.col === column.id;
    if (!isEditingCell && inputError) // acknowledgement of the error.
    setInputError(null);
    // props.column.cellRenderer is guaranteed to exist because it's injected if it is undefined.
    // Note: this used to call `column.cellRenderer({ ...props, value}) : value` which I believe
    // had something to do with supporting editable cells. Might need to consider this for when/if
    // editable cells makes a return. The old code caused bugs when filtering table rows, because
    // of the slight delay of `value` vs `propsValue`.
    const cellContentFromCellRenderer = column.cellRenderer && !isEditingCell ? column.cellRenderer(props) : propsValue;
    // Always a string value for the cell
    let cellContentFromStringRenderer;
    if (column.cellValueStringRenderer) cellContentFromStringRenderer = column.cellValueStringRenderer(props);
    else if (typeof cellContentFromCellRenderer === "string") cellContentFromStringRenderer = cellContentFromCellRenderer;
    // Allow column-specified padding.
    const paddingLeft = column.padding || column.padding === 0 ? column.padding : theme.tableStyles.cells.paddingLeft;
    const paddingRight = column.padding || column.padding === 0 ? column.padding : theme.tableStyles.cells.paddingRight;
    // Determine the cell content to actually render, if the cell isn't being edited it may
    // need to call updateData to propagate changes.
    let cellContent;
    if (isEditingCell) // them with ellipses, otherwise we should give users full control over rendering overflow.
    cellContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledContent, {
        $isText: typeof cellContentFromCellRenderer === "string",
        $renderOverflow: props.column.renderOverflow,
        $width: column.width,
        $paddingLeft: paddingLeft,
        $paddingRight: paddingRight,
        ref: cellRef,
        children: $dfd33cee3229493c$var$$eee9b90cb319bb22$var$getEditComponentForColumn(column, isEditingCell, {
            value: cellContentFromCellRenderer,
            inputError: inputError,
            onChange: onChange,
            onBlur: confirmEdit
        })
    });
    else {
        // Leverages type-coercion to compare, since "0001234" == 1234
        if (updateData && propsValue != value) confirmEdit();
        else if (propsValue !== value) setValue(propsValue);
        cellContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledContent, {
            $renderOverflow: column.renderOverflow,
            $isText: typeof cellContentFromCellRenderer === "string",
            $width: column.width,
            $align: column.align,
            $paddingLeft: paddingLeft,
            $paddingRight: paddingRight,
            ref: cellRef,
            children: typeof cellContentFromCellRenderer === "string" ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: cellContentFromCellRenderer
            }) : cellContentFromCellRenderer
        });
    }
    // Attach a tooltip to cells with truncated content.
    let tooltipContent = null;
    if (!isCellSelected && cellContentFromStringRenderer) {
        if (cellRef.current?.scrollWidth && containerRef.current?.offsetWidth && cellRef.current?.scrollWidth > containerRef.current?.offsetWidth - paddingLeft - paddingRight) tooltipContent = cellContentFromStringRenderer;
    }
    const tooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(cellRef, tooltipContent, {
        orientation: props.column.tooltip && typeof props.column.tooltip === "function" ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL : $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.VERTICAL
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$eee9b90cb319bb22$var$StyledCell, {
                ref: containerRef,
                $isEditingCell: isEditingCell,
                $inputError: inputError,
                $isFinalColumn: columns.length === column.index + 1,
                $isFinalStickyColumn: column.sticky && numberOfStickyColumns === column.index + 1,
                $showBorders: props.showBorders,
                $column: column,
                $isSelected: props.selectedCell.row && props.selectedCell.col && props.selectedCell?.row === props.row.original.id && props.selectedCell?.col === props.column.id,
                onClick: column.onCellClick ? (event)=>column.onCellClick?.({
                        event: event,
                        isCellSelected: isCellSelected,
                        ...props
                    }) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
                onContextMenu: column.onCellRightClick ? (event)=>column.onCellRightClick?.({
                        event: event,
                        isCellSelected: isCellSelected,
                        ...props
                    }) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
                children: cellContent
            }),
            tooltipContent ? tooltip : null
        ]
    });
};
$dfd33cee3229493c$var$$eee9b90cb319bb22$var$DefaultCellRenderer.propTypes = {
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        ]).isRequired,
        index: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        align: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
            "left",
            "right",
            "center"
        ]),
        sticky: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        column_type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        cellRenderer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        cellValueStringRenderer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        onCellClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        onCellRightClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        padding: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        renderOverflow: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        tooltip: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        width: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number.isRequired
    }).isRequired,
    showBorders: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    columns: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({})),
    numberOfStickyColumns: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any,
    updateData: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        original: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
            id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
                $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
                $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
            ])
        })
    }).isRequired,
    selectedCell: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        ]),
        col: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        ])
    }),
    editingCell: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        ]),
        col: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        ])
    })
};
$dfd33cee3229493c$var$$eee9b90cb319bb22$var$DefaultCellRenderer.displayName = "DefaultCellRenderer";
var $dfd33cee3229493c$var$$eee9b90cb319bb22$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$eee9b90cb319bb22$var$DefaultCellRenderer;
const $dfd33cee3229493c$var$$f191111e9833737a$var$StyledContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 16px 0;
  color: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$339ad1512bbbf7ac.rowText};
  left: 0;
  position: sticky;
  ${(props)=>props.$width ? `width: ${props.$width}px;` : ""};
`;
/**
 * To be used by Table. Rendered when a table has no data and is not loading.
 * @param content - content to be rendered in the table.
 * @param width - width of the container. Is typically computed dynamically by the parent Table.
 */ const $dfd33cee3229493c$var$$f191111e9833737a$var$EmptyTablePlaceholder = ({ content: content = "No data to display", width: width })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f191111e9833737a$var$StyledContainer, {
        $width: width,
        children: content
    });
};
$dfd33cee3229493c$var$$f191111e9833737a$var$EmptyTablePlaceholder.displayName = "EmptyTablePlaceholder";
$dfd33cee3229493c$var$$f191111e9833737a$var$EmptyTablePlaceholder.propTypes = {
    content: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    width: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
};
var $dfd33cee3229493c$var$$f191111e9833737a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f191111e9833737a$var$EmptyTablePlaceholder;
/**
 * A convenience helper to scroll an element to a point over a given time frame.
 *
 * @param {object} element - The actual DOM element being scrolled
 * @param {number} to - The scrollTop value after the animation
 * @param {number} duration - The time we want the scroll to take in milliseconds
 *                            If duration is 0, scroll without animation
 */ const $dfd33cee3229493c$var$$8975fdcc23d8041a$var$animateScrollTo = (element, to, duration)=>{
    const distance = to - element.scrollTop;
    const increment = 25;
    const adjustment = duration ? distance * increment / duration : distance;
    const animateScroll = ()=>{
        const prevTop = element.scrollTop;
        // eslint-disable-next-line no-param-reassign
        element.scrollTop += adjustment;
        if (element.scrollTop !== to && prevTop !== element.scrollTop) setTimeout(animateScroll, increment);
    };
    animateScroll();
};
/**
 * @param {object} element - HTMLElement
 * @returns {number} distance from top
 */ const $dfd33cee3229493c$var$$8975fdcc23d8041a$var$getDistanceFromTop = (element)=>element ? element.scrollTop : 0;
/**
 * @param {object} element - HTMLElement
 * @returns {number} distance from bottom
 */ const $dfd33cee3229493c$var$$8975fdcc23d8041a$var$getDistanceFromBottom = (element)=>element ? element.scrollHeight - element.clientHeight - element.scrollTop : 0;
/**
 * Hook for scrollable elements.
 * Allows callbacks to be called on scroll up/down and returns convenience methods
 * for scrolling to the top/bottom of the provided `scrollRef`.
 *
 * @param {object} args
 * @param {object} args.scrollRef - Ref to the scrollable element. Should not be used in conjunction
 *                                  with scrollCurrent, clients should use one or the other.
 * @param {object} args.scrollCurrent - Optional DOM element a functional ref is attached to, when
 *                                      clients don't have access to a ref, i.e. when using
 *                                      `useContentRect`. Should NOT be used in conjunction with
 *                                      scrollRef, clients should use one or the other.
 * @param {Function} args.onScrollUp - Function to invoke when the user scrolls to the top
 *                              Param is distance from top in pixels
 * @param {Function} args.onScrollDown - Function to invoke when the user scrolls to the bottom
 *                                Param is distance from bottom in pixels
 * @returns {Array<*>}
 *   0: {Function} scrollToBottom Function that scrolls the scrollRef to the bottom
 *   1: {Function} scrollToTop Function that scrolls the scrollRef to the top
 *   2: {Number} distanceFromBottom Distance in px from bottom of scrollRef
 *   3: {Number} distanceFromTop Distance in px from top of scrollRef
 */ const $dfd33cee3229493c$var$$8975fdcc23d8041a$var$useScrollable = ({ scrollRef: scrollRef, scrollCurrent: scrollCurrent, onScrollUp: onScrollUp, onScrollDown: onScrollDown })=>{
    const current = (0, $70fFQ.useMemo)(()=>{
        if (scrollCurrent) return scrollCurrent;
        return scrollRef?.current;
    }, [
        scrollCurrent,
        scrollRef
    ]);
    const [lastScrollPosition, setLastScrollPosition] = (0, $70fFQ.useState)(current ? current.scrollTop : 0);
    const _onScroll = ()=>{
        const newScrollPosition = current?.scrollTop || 0;
        const distanceFromTop = $dfd33cee3229493c$var$$8975fdcc23d8041a$var$getDistanceFromTop(current);
        const distanceFromBottom = $dfd33cee3229493c$var$$8975fdcc23d8041a$var$getDistanceFromBottom(current);
        // scrolling up
        if (newScrollPosition < lastScrollPosition) onScrollUp(distanceFromTop);
        // scrolling down
        if (newScrollPosition > lastScrollPosition) onScrollDown(distanceFromBottom);
        setLastScrollPosition(newScrollPosition);
    };
    const onScroll = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).throttle(_onScroll, $dfd33cee3229493c$var$$49b61417b640529d$export$34e77c57b0e8675a);
    // Mount: Add scroll event listeners to the ref
    // Unmount: Remove scroll event listeners from the ref
    (0, $70fFQ.useEffect)(()=>{
        if (!current) return undefined;
        const scrolledElement = current;
        scrolledElement.addEventListener("scroll", onScroll);
        return ()=>{
            scrolledElement.removeEventListener("scroll", onScroll);
        };
    });
    // Convenience methods for scrolling to top/bottom of the ref
    const scrollToBottom = (0, $70fFQ.useCallback)(({ animate: animate })=>{
        if (!current) return;
        $dfd33cee3229493c$var$$8975fdcc23d8041a$var$animateScrollTo(current, current.scrollHeight, animate ? $dfd33cee3229493c$var$$49b61417b640529d$export$a507d980baa6b21f : 0);
    }, [
        current
    ]);
    const scrollToTop = (0, $70fFQ.useCallback)(({ animate: animate })=>{
        if (!current) return;
        $dfd33cee3229493c$var$$8975fdcc23d8041a$var$animateScrollTo(current, 0, animate ? $dfd33cee3229493c$var$$49b61417b640529d$export$a507d980baa6b21f : 0);
    }, [
        current
    ]);
    const distanceFromTop = $dfd33cee3229493c$var$$8975fdcc23d8041a$var$getDistanceFromTop(current);
    const distanceFromBottom = $dfd33cee3229493c$var$$8975fdcc23d8041a$var$getDistanceFromBottom(current);
    return [
        scrollToBottom,
        scrollToTop,
        distanceFromBottom,
        distanceFromTop
    ];
};
var $dfd33cee3229493c$var$$8975fdcc23d8041a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$8975fdcc23d8041a$var$useScrollable;
const $dfd33cee3229493c$var$$cb31f4d02992530f$var$loadSpinner = (0, $e42cae22e74e223a$exports.keyframes)`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const $dfd33cee3229493c$var$$cb31f4d02992530f$var$StyledIcon = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  animation: ${$dfd33cee3229493c$var$$cb31f4d02992530f$var$loadSpinner} 0.5s infinite linear;

  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.fullWhite};
  background: linear-gradient(to right, ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.fullWhite}, transparent 38%);

  border-radius: 50%;
  height: 18px;
  left: calc(50% - 9px);
  position: relative;
  top: calc(50% - 9px);
  width: 18px;

  &:before {
    background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.fullWhite};
    border-radius: 100% 0 0 0;
    content: "";
    height: 50%;
    position: absolute;
    width: 50%;

    top: 0;
    left: 0;
  }

  &:after {
    background: rgba(22, 22, 22, 1);
    border-radius: 50%;
    bottom: 0;
    content: "";
    height: 70%;
    margin: auto;
    position: absolute;
    width: 70%;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
const $dfd33cee3229493c$var$$cb31f4d02992530f$var$StyledContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  background: rgba(22, 22, 22, 0.8);
  border-radius: 4px;
  height: 48px;
  margin: 0 auto;
  width: 48px;
`;
/**
 * Loading spinner to display when loading content.
 *
 * @param {object} props
 * @returns {JSX.Element}
 */ const $dfd33cee3229493c$var$$cb31f4d02992530f$var$LoadingSpinner = ({ showContainer: showContainer = true })=>{
    const icon = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb31f4d02992530f$var$StyledIcon, {});
    return showContainer ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb31f4d02992530f$var$StyledContainer, {
        children: icon
    }) : icon;
};
$dfd33cee3229493c$var$$cb31f4d02992530f$var$LoadingSpinner.propTypes = {
    showContainer: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool
};
var $dfd33cee3229493c$var$$cb31f4d02992530f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$cb31f4d02992530f$var$LoadingSpinner;
var /*
 * Specifically for creating event handlers within Table.
 */ $dfd33cee3229493c$var$$62ae77f47bb6235a$export$2e2bcd8739ae039 = (props, parameters = {})=>{
    const createEventHandler = (handler)=>({ event: event, ...args })=>{
            event.preventDefault();
            handler({
                event: event,
                ...args,
                ...parameters
            });
            event.stopPropagation();
        };
    const { onCellClick: onCellClick, onCellRightClick: onCellRightClick } = props;
    const eventHandlerProps = {};
    if (onCellClick && onCellClick !== $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop) eventHandlerProps.onCellClick = createEventHandler(onCellClick);
    if (onCellRightClick && onCellRightClick !== $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop) eventHandlerProps.onCellRightClick = createEventHandler(onCellRightClick);
    // No double click support for now; seemingly requires a new component in the tree to
    // prevent firing single clicks on every double click.
    // https://stackoverflow.com/questions/35491425/double-click-and-click-on-reactjs-component
    // if (onCellDoubleClick && onCellDoubleClick !== _.noop) {
    //   eventHandlerProps.onDoubleClick = createEventHandler(onCellDoubleClick);
    // }
    return eventHandlerProps;
};
/**
 * Helper to determine the full style configuration object for tables, given the current
 * Yuka theme context, and the defaults.
 */ const $dfd33cee3229493c$var$$81a362cff0c7d753$var$useTableStyles = ()=>{
    const styles = {};
    const { tableStyles: yukaThemeTableStyles } = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    const currentSurface = (0, $70fFQ.useContext)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5);
    // We always use current surface by default, while also allowing users to specify their own
    // colors.
    const allStyleKeys = Object.keys($dfd33cee3229493c$var$$58d0bb043433b77a$export$2e2bcd8739ae039(currentSurface - 1));
    // Merge the default styles with the yuka theme context-provided styles.
    // Assumes the keys that are present in DefaultStyleConfiguration are what
    // the Table accepts, so ignores all others.
    allStyleKeys.forEach((key)=>{
        styles[key] = {
            ...$dfd33cee3229493c$var$$58d0bb043433b77a$export$2e2bcd8739ae039(currentSurface - 1)[key],
            ...yukaThemeTableStyles?.[key]
        };
    });
    return styles;
};
var $dfd33cee3229493c$var$$81a362cff0c7d753$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$81a362cff0c7d753$var$useTableStyles;
/**
 * Helper to enable editing table data in real-time. Editing rows requires
 * that each row has an `id` field in it. This field hold any primitive value.
 *
 * Handles
 *  - distinguishing the currently selected and currently editing cell
 *  - debouncing the update data function to avoid propagating updates rapid-fire
 *
 */ const $dfd33cee3229493c$var$$f6b9af42a1e947b4$var$useEditableData = (data, columns, updateData)=>{
    // Defaults to the top-left corner of the table.
    const [selectedCell, setSelectedCell] = (0, $70fFQ.useState)(updateData ? {
        row: data[0]?.id,
        col: columns[0]?.id
    } : {
        row: undefined,
        col: undefined
    });
    // Defaults to nothing being edited.
    const [editingCell, setEditingCell] = (0, $70fFQ.useState)(null);
    const determineEditingStateOnCellClick = (0, $70fFQ.useCallback)((row, column, isCellSelected)=>{
        if (isCellSelected) setEditingCell({
            row: row.original.id,
            col: column.id
        });
        else {
            // Clicking a cell other than the selected cell.
            setSelectedCell({
                row: row.original.id,
                col: column.id
            });
            setEditingCell(null);
        }
    }, []);
    // Debounces the updateData function to prevent rapid-fire update propagation.
    const debouncedUpdate = (0, $70fFQ.useMemo)(()=>{
        if (updateData) return $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).debounce(updateData, 1000, {
            leading: false,
            trailing: true
        });
        return undefined;
    }, [
        updateData
    ]);
    return {
        selectedCell: selectedCell,
        setSelectedCell: setSelectedCell,
        editingCell: editingCell,
        setEditingCell: setEditingCell,
        determineEditingStateOnCellClick: determineEditingStateOnCellClick,
        debouncedUpdate: debouncedUpdate
    };
};
var $dfd33cee3229493c$var$$f6b9af42a1e947b4$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$f6b9af42a1e947b4$var$useEditableData;
/**
 * Helper to enable keyboard navigating an editable table. Uses a cell coordinate
 * system to know which row/column to navigate to on various key presses. Must only be used
 * with row objects that have been processed by the useTable hook, not raw row objects,
 * since unprocessed rows may not be sorted properly to allow the coordinate system
 * to function.
 *
 * Handles
 *  - keyboard navigation to give a spreadsheet-esque experience
 */ const $dfd33cee3229493c$var$$047b892b60325b08$var$useKeyboardNavigation = (rows, columns, selectedCell, setSelectedCell, editingCell, setEditingCell, debouncedUpdate)=>{
    const selectedCellCoordinates = (0, $70fFQ.useMemo)(()=>{
        if (!debouncedUpdate) return {
            row: undefined,
            col: undefined
        };
        const row = rows.findIndex((row)=>row.original.id === selectedCell.row);
        const col = columns.findIndex((col)=>col.id === selectedCell.col);
        return {
            row: row,
            col: col
        };
    }, [
        columns,
        rows,
        selectedCell,
        debouncedUpdate
    ]);
    const keyPressHandler = (0, $70fFQ.useCallback)((e)=>{
        // Given that the table can be sorted, we need to use the coordinates of the selected cell
        // to determine the cell row/col IDs the user intends to navigate to.
        if (e.code === "Enter" || e.code === "NumpadEnter") {
            e.preventDefault();
            if (!editingCell) setEditingCell(selectedCell);
            else {
                // If already editing, stop editing and move to the next row.
                setEditingCell(null);
                if (selectedCellCoordinates.row !== rows.length - 1) setSelectedCell({
                    row: rows[selectedCellCoordinates.row + 1].original.id,
                    col: selectedCell.col
                });
            }
        } else if (e.code === "Escape") {
            e.preventDefault();
            setEditingCell(null);
        } else if (e.code === "Tab") {
            e.preventDefault();
            setEditingCell(null);
            if (e.shiftKey && selectedCellCoordinates.col !== 0) setSelectedCell({
                row: selectedCell.row,
                col: columns[selectedCellCoordinates.col - 1].id
            });
            else if (!e.shiftKey && selectedCellCoordinates.col !== columns.length - 1) setSelectedCell({
                row: selectedCell.row,
                col: columns[selectedCellCoordinates.col + 1].id
            });
        } else if (e.code === "ArrowRight") {
            if (!editingCell) {
                e.preventDefault();
                if (selectedCellCoordinates.col !== columns.length - 1) setSelectedCell({
                    row: selectedCell.row,
                    col: columns[selectedCellCoordinates.col + 1].id
                });
            }
        } else if (e.code === "ArrowLeft") {
            if (!editingCell) {
                e.preventDefault();
                if (selectedCellCoordinates.col !== 0) setSelectedCell({
                    row: selectedCell.row,
                    col: columns[selectedCellCoordinates.col - 1].id
                });
            }
        } else if (e.code === "ArrowUp") {
            if (!editingCell) {
                e.preventDefault();
                if (selectedCellCoordinates.row !== 0) setSelectedCell({
                    row: rows[selectedCellCoordinates.row - 1].original.id,
                    col: selectedCell.col
                });
            }
        } else if (e.code === "ArrowDown") {
            if (!editingCell) {
                e.preventDefault();
                if (selectedCellCoordinates.row !== rows.length - 1) setSelectedCell({
                    row: rows[selectedCellCoordinates.row + 1].original.id,
                    col: selectedCell.col
                });
            }
        }
    // Do nothing with other keys.
    }, [
        selectedCellCoordinates,
        rows,
        columns,
        selectedCell,
        editingCell
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (debouncedUpdate) window.addEventListener("keydown", keyPressHandler);
        return ()=>{
            if (debouncedUpdate) window.removeEventListener("keydown", keyPressHandler);
        };
    }, [
        debouncedUpdate,
        keyPressHandler
    ]);
};
var $dfd33cee3229493c$var$$047b892b60325b08$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$047b892b60325b08$var$useKeyboardNavigation;
/**
 * Helper to compute several useful metadata fields for a table for given input parameters.
 * Essentially used to group table metadata calculations in one easy-to-follow place.
 *
 * Optimally used with a set of user-defined columns, prior to react-table processing.
 */ const $dfd33cee3229493c$var$$a77e0861af935b49$var$useTableMetadata = (columns)=>{
    // The specified table width is the sum of the column widths, to know precisely how wide
    // the table is. The specifiedTableWidth is used when computing the proportional
    // column widths, since their percentages need to be percentage of the table's total width.
    const specifiedTableWidth = (0, $70fFQ.useMemo)(()=>columns.reduce((prevSum, currElem)=>prevSum + (currElem.width || 0), 0), [
        columns
    ]);
    // The total width of columns that need to be rendered using fixed widths. Used to determine the
    // remaining size of the table to compute normalized percentage column widths.
    const fixedWidthColumnWidth = columns.filter((column)=>column.useFixedWidth).reduce((prevSum, currColumn)=>prevSum + (currColumn.width || 0), 0);
    const numberOfStickyColumns = (0, $70fFQ.useMemo)(()=>columns.reduce((prevSum, currColumn)=>prevSum + (currColumn.sticky ? 1 : 0), 0), [
        columns
    ]);
    return {
        specifiedTableWidth: specifiedTableWidth,
        fixedWidthColumnWidth: fixedWidthColumnWidth,
        numberOfStickyColumns: numberOfStickyColumns
    };
};
var $dfd33cee3229493c$var$$a77e0861af935b49$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$a77e0861af935b49$var$useTableMetadata;
/*
 * Exists as its own component so that we can have access to a ref for it to attach
 * tooltips conditionally. Does not handle actual value rendering/value truncation, that is handled
 * by the DefaultCellRenderer.
 */ const $dfd33cee3229493c$var$$77be48fd2fb128ca$var$RenderedTableCell = ({ cell: cell, row: row, selectedCell: selectedCell, onClick: onClick, tooltipContent: tooltipContent })=>{
    const cellRef = (0, $70fFQ.useRef)(null);
    const tooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(cellRef, tooltipContent);
    const cellProps = cell.getCellProps();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$9253e4f716553796, {
                ref: cellRef,
                $column: cell.column,
                $selected: row.original.id === selectedCell.row && cell.column.id === selectedCell.col,
                onClick: onClick,
                $row: row,
                ...cellProps,
                children: cell.render("Cell")
            }),
            tooltipContent ? tooltip : null
        ]
    });
};
$dfd33cee3229493c$var$$77be48fd2fb128ca$var$RenderedTableCell.propTypes = {
    cell: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        render: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        getCellProps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
            id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        })
    }).isRequired,
    row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        original: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
            id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
                $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
                $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
            ])
        })
    }).isRequired,
    selectedCell: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        col: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    }).isRequired,
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    tooltipContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element
    ])
};
var $dfd33cee3229493c$var$$77be48fd2fb128ca$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$77be48fd2fb128ca$var$RenderedTableCell;
/*
 * Exists as its own component so that we can have access to a ref for it to attach
 * tooltips conditionally. Does not handle actual value rendering/value truncation, that is handled
 * by the DefaultHeaderRenderer.
 */ const $dfd33cee3229493c$var$$84b437b96695db5f$var$RenderedTableHeader = ({ column: column, manualSortBy: manualSortBy, tooltipContent: tooltipContent })=>{
    const headerRef = (0, $70fFQ.useRef)(null);
    const tooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(headerRef, tooltipContent);
    const headerProps = column.getHeaderProps(manualSortBy ? {} : column.getSortByToggleProps());
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$f99395d0d1e1a10e, {
                ref: headerRef,
                $column: column,
                ...headerProps,
                children: column.render("Header")
            }, headerProps.key),
            tooltipContent ? tooltip : null
        ]
    });
};
$dfd33cee3229493c$var$$84b437b96695db5f$var$RenderedTableHeader.propTypes = {
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        render: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        getHeaderProps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        getSortByToggleProps: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    }).isRequired,
    manualSortBy: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    tooltipContent: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).element
    ])
};
$dfd33cee3229493c$var$$84b437b96695db5f$var$RenderedTableHeader.defaultProps = {
    manualSortBy: false
};
var $dfd33cee3229493c$var$$84b437b96695db5f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$84b437b96695db5f$var$RenderedTableHeader;
/*
 * Hook for tracking dimensions of an element. The other hook we use to perform this task,
 * useElementDimensions, has the drawback that the dimensions don't update when an element goes from
 * scrollable to not scrollable, which can cause underlying containers widths to change after the
 * padding is added for the sroll bar. This hook uses ResizeObserver to track dimensions of an
 * element, with the caveat that ResizeObserver isn't supported by opera mini or KaiOS, 0.19%
 * global usage.
 *
 * This function also doesn't accept a ref parameter, it returns a function ref, the ref.current
 * value, and the dimensions of the element, derived from `contentRect()`.
 * https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 *
 * When considering whether to use this function in lieu of `useElementDimensions`, follow this
 * simple flow chart:
 *
 * Am I working in Table.jsx? -> Yes -> use this function
 *                            -> No  -> probably use useElementDimensions
 *
 * Implementation is *mostly* stolen from
 * react-use https://github.com/streamich/react-use/blob/master/src/useMeasure.ts
 */ const $dfd33cee3229493c$var$$81f502e249b8644f$var$useElementContentRect = ()=>{
    const [element, ref] = (0, $70fFQ.useState)(null);
    const [rect, setRect] = (0, $70fFQ.useState)({
        width: 0
    });
    const observer = (0, $70fFQ.useMemo)(()=>new window.ResizeObserver((entries)=>{
            if (entries[0]) {
                const { x: x, y: y, width: width, height: height, top: top, left: left, bottom: bottom, right: right } = entries[0].contentRect;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        }), []);
    (0, $70fFQ.useLayoutEffect)(()=>{
        if (!element) return;
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element,
        observer
    ]);
    return [
        ref,
        element,
        rect
    ];
};
var $dfd33cee3229493c$var$$81f502e249b8644f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$81f502e249b8644f$var$useElementContentRect;
const $dfd33cee3229493c$var$$e86b805150f3483f$var$EMPTY_DATA = [];
const $dfd33cee3229493c$var$$e86b805150f3483f$var$EMPTY_COLUMNS = [];
/**
 * Table component that wraps react-table's implementation.
 *
 */ const $dfd33cee3229493c$var$$e86b805150f3483f$var$Table = ({ data: data = $dfd33cee3229493c$var$$e86b805150f3483f$var$EMPTY_DATA, columns: userColumns = $dfd33cee3229493c$var$$e86b805150f3483f$var$EMPTY_COLUMNS, updateData: updateData, isLoading: isLoading = false, paginationFunc: paginationFunc = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop, isPaginationLoading: isPaginationLoading = false, onRowClick: onRowClick, onRowRightClick: onRowRightClick, onRowMouseOut: onRowMouseOut, onRowMouseOver: onRowMouseOver, manualSortBy: manualSortBy = false, sortState: sortState = [], sortTypes: sortTypes = {}, usePercentageColumnWidths: usePercentageColumnWidths = false, showBorders: showBorders = false, onRowSelectStateChange: onRowSelectStateChange = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop, ...props })=>{
    const tableStyles = $dfd33cee3229493c$var$$81a362cff0c7d753$export$2e2bcd8739ae039();
    const theme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    // useEditableData will have no effect if `updateData` is not provided.
    const { selectedCell: selectedCell, setSelectedCell: setSelectedCell, editingCell: editingCell, setEditingCell: setEditingCell, determineEditingStateOnCellClick: determineEditingStateOnCellClick, debouncedUpdate: debouncedUpdate } = $dfd33cee3229493c$var$$f6b9af42a1e947b4$export$2e2bcd8739ae039(data, userColumns, updateData);
    // A browser scrollbar appearing on its own accord when content needs to be vertically scrollable
    // does NOT trigger the 'resize' event, so we need to take the minimum of the table's clientWidth,
    // and the width that gets tracked by window resizes.
    const [tableScrollableAreaRef, currentTableScrollableArea, { width: actualTableWidth }] = $dfd33cee3229493c$var$$81f502e249b8644f$export$2e2bcd8739ae039();
    // Obtain some metadata about how the table's actually going to render.
    const { specifiedTableWidth: specifiedTableWidth, fixedWidthColumnWidth: fixedWidthColumnWidth, numberOfStickyColumns: numberOfStickyColumns } = $dfd33cee3229493c$var$$a77e0861af935b49$export$2e2bcd8739ae039(userColumns);
    // Process the user columns to produce table-ingestible column objects.
    const columnsForTable = (0, $70fFQ.useMemo)(()=>userColumns.map((column, index)=>{
            const partialColumn = {
                ...$dfd33cee3229493c$var$$62ae77f47bb6235a$export$2e2bcd8739ae039({
                    onCellClick: onRowClick,
                    onCellRightClick: onRowRightClick,
                    ...column // Allows a column-defined handler to override Table-defined handlers.
                }),
                cellRenderer: (value)=>value.value,
                Header: $dfd33cee3229493c$var$$9657403c98743393$export$2e2bcd8739ae039,
                Cell: $dfd33cee3229493c$var$$eee9b90cb319bb22$export$2e2bcd8739ae039,
                ...column,
                // Possibly override column.sticky and width if `usePercentageColumnWidths` is true.
                sticky: !usePercentageColumnWidths && Boolean(column.sticky),
                // Enforce that every column has a width value in pixels.
                width: (usePercentageColumnWidths || actualTableWidth >= specifiedTableWidth) && !column.useFixedWidth ? (actualTableWidth - fixedWidthColumnWidth) * (column.width / (specifiedTableWidth - fixedWidthColumnWidth)) : column.width,
                disableSortBy: !column.sortable,
                index: index
            };
            // Handle selecting cells by clicking if and only if cells in this column are editable.
            if (debouncedUpdate) {
                const eventHandlerFunc = partialColumn.onCellClick;
                // Wrap the onCellClick to include the selected/editing cell logic.
                partialColumn.onCellClick = ({ row: row, isCellSelected: isCellSelected, ...args })=>{
                    // isCellSelected is determined by the individual cells instead of in this
                    // hook to save re-computations of the table column objects based on 'selectedCell'.
                    eventHandlerFunc?.({
                        row: row,
                        isCellSelected: isCellSelected,
                        ...args
                    });
                    determineEditingStateOnCellClick(row, column, isCellSelected);
                };
            }
            return partialColumn;
        }), [
        fixedWidthColumnWidth,
        specifiedTableWidth,
        usePercentageColumnWidths,
        userColumns,
        onRowClick,
        onRowRightClick,
        debouncedUpdate,
        actualTableWidth,
        determineEditingStateOnCellClick
    ]);
    const initialState = (0, $70fFQ.useMemo)(()=>{
        const sortBy = [];
        const state = {
            sortBy: sortBy
        };
        if (sortState && sortState.length) state.sortBy = sortState;
        return state;
    }, [
        sortState
    ]);
    const tableInstance = (0, $53461e26c6509d18$exports.useTable)({
        columns: columnsForTable,
        initialState: initialState,
        data: data,
        updateData: debouncedUpdate,
        numberOfStickyColumns: // to determine if they are selected and/or being edited.
        numberOfStickyColumns,
        selectedCell: selectedCell,
        editingCell: editingCell,
        sortTypes: {
            // Provides case-insensitive alphanumeric sorting.
            alphanumeric: (a, b, columnId)=>{
                const rowA = a.values[columnId];
                const rowB = b.values[columnId];
                if (typeof rowA === "string" && typeof rowB === "string") {
                    if (rowA.toLowerCase() === rowB.toLowerCase()) return 0;
                    return rowA.toLowerCase() > rowB.toLowerCase() ? 1 : -1;
                }
                if (Number(rowA) === Number(rowB)) return 0;
                return Number(rowA) > Number(rowB) ? 1 : -1;
            },
            ...sortTypes
        },
        // If updateData is provided, then we do not want to reset sorting when editing table values.
        autoResetSortBy: !debouncedUpdate,
        autoResetSelectedRows: false,
        sortState: sortState,
        manualSortBy: manualSortBy,
        showBorders: showBorders,
        ...props
    }, $53461e26c6509d18$exports.useSortBy, $53461e26c6509d18$exports.useRowSelect);
    const { getTableProps: getTableProps, getTableBodyProps: getTableBodyProps, headerGroups: headerGroups, rows: rows, prepareRow: prepareRow, columns: columns, state: { selectedRowIds: selectedRowIds } } = tableInstance;
    $dfd33cee3229493c$var$$047b892b60325b08$export$2e2bcd8739ae039(rows, columns, selectedCell, setSelectedCell, editingCell, setEditingCell, debouncedUpdate);
    // Exposes the internal row-selected state to clients.
    (0, $70fFQ.useEffect)(()=>onRowSelectStateChange?.(selectedRowIds), [
        onRowSelectStateChange,
        selectedRowIds
    ]);
    $dfd33cee3229493c$var$$8975fdcc23d8041a$export$2e2bcd8739ae039({
        scrollCurrent: currentTableScrollableArea,
        onScrollUp: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
        onScrollDown: (distanceFromBottom)=>{
            if (!isPaginationLoading && paginationFunc && paginationFunc !== $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop && distanceFromBottom < 100) paginationFunc();
        }
    });
    // Apply default here so we don't break legacy support
    const emptyTablePlaceholder = $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).isUndefined(props.emptyTablePlaceholder) ? "No data to display" : props.emptyTablePlaceholder;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            ...theme,
            tableStyles: tableStyles
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$28610bd394c82dfd$export$7a91a2f874220ab6, {
            $usePercentageColumnWidths: usePercentageColumnWidths,
            $width: specifiedTableWidth,
            ...getTableProps(),
            ref: tableScrollableAreaRef,
            children: [
                !props.disableHeader && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$9224ee7fa5eef0cc, {
                    $width: usePercentageColumnWidths ? actualTableWidth : Math.max(actualTableWidth, specifiedTableWidth),
                    children: headerGroups.map((headerGroup, i)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$81761b52b04ea573, {
                            ...headerGroup.getHeaderGroupProps(),
                            children: headerGroup.headers.map((column, j)=>{
                                const tooltipContent = column.headerTooltip && typeof column.headerTooltip === "function" ? column.headerTooltip(column) : null;
                                return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$84b437b96695db5f$export$2e2bcd8739ae039, {
                                    column: column,
                                    tooltipContent: tooltipContent
                                }, `rendered_table_header_${i}_${j}`);
                            })
                        }, `header_group_${i}`))
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$28610bd394c82dfd$export$cd928bb20d3ce93f, {
                    ...getTableBodyProps(),
                    $width: usePercentageColumnWidths ? actualTableWidth : Math.max(actualTableWidth, specifiedTableWidth),
                    children: [
                        !isLoading && // Loop over the table rows.
                        rows.map((row, index)=>{
                            // Prepare the row for display using react-table magic.
                            // https://github.com/TanStack/table/blob/v7/docs/src/pages/docs/api/useTable.md
                            // "Lazily" prepares a row for rendering, every row intended for rendering needs to be passed
                            // to this function prior. This logic allows us to only prepare and render rows
                            // that are visible in the scrollable parent container.
                            // Determine how many rows should be visible in the scrollable area.
                            const numberOfRowsVisible = Math.floor((currentTableScrollableArea?.getBoundingClientRect().height || 0) / (tableStyles.cells?.height || 1));
                            const parentScrollPosition = currentTableScrollableArea?.scrollTop || 0;
                            const firstVisibleRow = Math.floor(parentScrollPosition / (tableStyles.cells?.height || 1));
                            const lastVisibleRow = firstVisibleRow + numberOfRowsVisible;
                            // Since the table cannot know how large it is going to be before it renders any
                            // rows, we render the first 50 rows as a fallback. Once the table renders once,
                            // it will know in future how many rows are visible to the user at once. When the
                            // parentScrollPosition is 0 i.e. no scrolling has been done yet, then we render
                            // 50 rows as a fallback.
                            const rowShouldRender = firstVisibleRow - 10 <= index && index <= lastVisibleRow + 10 || parentScrollPosition === 0 && index <= 50;
                            if (rowShouldRender) {
                                // Is the row too high or too low down to be visible?
                                prepareRow(row);
                                const rowProps = row.getRowProps();
                                return /*#__PURE__*/ (0, $70fFQ.createElement)($dfd33cee3229493c$var$$28610bd394c82dfd$export$81761b52b04ea573, {
                                    ...rowProps,
                                    key: `row_${index}`,
                                    $row: row,
                                    $onRowClick: onRowClick,
                                    onMouseLeave: onRowMouseOut ? (event)=>onRowMouseOut({
                                            event: event,
                                            row: row
                                        }) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
                                    onMouseEnter: onRowMouseOver ? (event)=>onRowMouseOver({
                                            event: event,
                                            row: row
                                        }) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop
                                }, row.cells.map((cell)=>{
                                    // Apply the cell props and style.
                                    // Allow for a column-specified tooltip function to generate the
                                    // tooltip for this cell, if applicable. Tooltips are implemented one
                                    // layer above rendering "Cell", because users might want tooltip support
                                    // and also full visual control over the cell rendering.
                                    const tooltipContent = cell.column.tooltip && typeof cell.column.tooltip === "function" ? cell.column.tooltip({
                                        ...props,
                                        ...cell
                                    }) : null;
                                    // If the user elects to not use the DefaultCellRenderer, then the
                                    // onClick has to be set up on the container, so the users' function
                                    // will not have access to the full set of table props as the
                                    // DefaultCellRenderer does, because those are determined by the call
                                    // to cell.render("Cell") below.
                                    const cellOnClick = cell.column.onCellClick && cell.column.Cell !== $dfd33cee3229493c$var$$eee9b90cb319bb22$export$2e2bcd8739ae039 ? (event)=>{
                                        const { column: column, row: row, value: value } = cell;
                                        cell.column.onCellClick({
                                            event: event,
                                            column: column,
                                            row: row,
                                            value: value
                                        });
                                    } : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop;
                                    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$77be48fd2fb128ca$export$2e2bcd8739ae039, {
                                        cell: cell,
                                        row: row,
                                        selectedCell: selectedCell,
                                        onClick: cellOnClick,
                                        tooltipContent: tooltipContent
                                    }, cell.getCellProps().key);
                                }));
                            }
                            // Render an empty "Loading row" because this row is not visible.
                            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$81761b52b04ea573, {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$f892d76a9565988f, {
                                    $height: tableStyles.cells?.height || 1,
                                    children: "--"
                                })
                            }, `row_${index}`);
                        }),
                        !isLoading && rows.length === 0 && Boolean(emptyTablePlaceholder) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$f191111e9833737a$export$2e2bcd8739ae039, {
                            content: emptyTablePlaceholder,
                            width: actualTableWidth
                        })
                    ]
                }),
                isPaginationLoading || isLoading ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$7fb51b284d7f1c81, {
                    $width: actualTableWidth,
                    children: (isPaginationLoading || isLoading) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$cb31f4d02992530f$export$2e2bcd8739ae039, {})
                }) : null
            ]
        })
    });
};
$dfd33cee3229493c$var$$e86b805150f3483f$var$Table.propTypes = {
    /**
   * An array of objects where each key is a column ID, and each value is
   * the cell value for that column. Each item in the array specifies a full row.
   */ data: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).any
    })),
    /**
   * An array of objects where the object properties specify all the information necessary
   * to display a column in the table. Properties like 'sortable', 'sticky', that specify
   * how columns behave in the table live on these objects. Columns should appear in this list
   * in the order they should be presented in the table.
   */ columns: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
            $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
        ])
    })),
    /**
   * Optional text to render if there is no table data.
   */ emptyTablePlaceholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
    ]),
    /**
   * An optional function used to mutate the data in the table. If specified, for all
   * editable columns, this function is called when editing the cell. This function should consume
   * the full RTRowInterface object, the full RTColumnInterface object, and the updated cell value.
   */ updateData: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * A boolean parameter used to indicate from outside the table context if the input data
   * is loading. The table will render a loading spinner if this boolean is true.
   */ isLoading: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /**
   * An optional function used to query the next page of data for the table. Is
   * automatically triggered when the user scrolls to a certain distance from the bottom of the
   * rendered table. Useful for when table data is linked to paged queries.
   */ paginationFunc: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * Similarly to isLoading, a boolean parameter that's used to indicate to the
   * table that a new page of data is loading and the table should not attempt to fetch another
   * page. The table will automatically call a pagination function when near the bottom of the
   * scrollable region, and this flag equalling true prevents it from fetching another page while
   * loading.
   */ isPaginationLoading: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /**
   * An optional function to call when clicking a row. If `updateData` is provided, cells
   * are editable, and so clicking a cell (and therefore also its row) puts the cell in edit state.
   * Therefore, this handler probably should not redirect the user if `updateData` is provided.
   */ onRowClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * Optional row handler function to fire when the row is right-clicked. If provided, will
   * prevent default event.
   */ onRowRightClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * Optional row handler function to fire when the user moves their mouse out of a row.
   */ onRowMouseOut: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * Optional row handler function to fire when the user moves their mouse over a row.
   */ onRowMouseOver: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * Handler to expose the tables internal set of selected rows to implementors. Is called
   * with a map mapping row IDs to a boolean value, true for "is selected".
   */ onRowSelectStateChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /**
   * Boolean to indicate that sorting is handled external to the table implementation.
   * This table implementation ships with a primitive sorting facility, using the `accessor` field
   * on column objects. You may be interested in sorting the data server-side and served in pages,
   * in which case manualSortBy should be true. If primitive value sorting is acceptable, leave
   * this flag as false.
   */ manualSortBy: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /**
   * Boolean flag to toggle the header. Sometimes a table should be rendered without a header
   * row, so set this flag to true to display this way.
   */ disableHeader: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /**
   * Boolean to indicate that the widths specified on column objects should
   * be treated as percentages and not absolute pixel values. When this flag is set to true, the
   * table will fill its available space, and normalize the column widths so that they add up to
   * 100%, and then determine their actual width to render based on the available table space. Note
   * that you cannot simultaneously have `usePercentageColumnWidths == true` and have any columns
   * that are sticky, because side-scrolling doesn't make sense in this context. The table will
   * ignore column stickiness in this case.
   */ usePercentageColumnWidths: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /**
   * Boolean whether to include column-dividing borders. Leave unset to only render
   * borders to divide rows. Note that regardless of this value, the table will never have an
   * extreme left nor extreme right border.
   */ showBorders: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    /**
   * Array of { id: <column_id>, desc: <boolean> } objects, indicating which columns
   * to sort by (using ID), and whether they are descending (desc = true).
   * https://react-table-v7.tanstack.com/docs/api/useSortBy#table-options
   */ sortState: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({})),
    /**
   * Object mapping the names of custom sorting functions to their function definitions. Useful for
   * enabling sort on a column when the built-in case-insensitive alphanumeric sort will not
   * suffice.
   */ sortTypes: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        [$dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string]: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    })
};
$dfd33cee3229493c$var$$e86b805150f3483f$var$Table.displayName = "Table";
var $dfd33cee3229493c$var$$e86b805150f3483f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e86b805150f3483f$var$Table;
var $dfd33cee3229493c$var$$9edc545f672b7e20$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "AvatarCell", ()=>$dfd33cee3229493c$var$$5c4800a47f171310$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "BadgeCell", ()=>$dfd33cee3229493c$var$$6d9e2f234cebfd99$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "BookmarkCell", ()=>$dfd33cee3229493c$var$$ca5d26be9f0d6653$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "CheckboxCell", ()=>$dfd33cee3229493c$var$$37f63ef377063d6a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "CheckboxHeader", ()=>$dfd33cee3229493c$var$$62629da8bc60b7de$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "CurrencyCell", ()=>$dfd33cee3229493c$var$$022b1afec9546799$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "DateCell", ()=>$dfd33cee3229493c$var$$ee62f5b8e7740115$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "IconButtonCell", ()=>$dfd33cee3229493c$var$$7ba498b57aadd402$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "IconCell", ()=>$dfd33cee3229493c$var$$c9f707058059f083$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "NumberCell", ()=>$dfd33cee3229493c$var$$5ed5b45b5a1de80c$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "PercentageCell", ()=>$dfd33cee3229493c$var$$2af52c0ac0802fd1$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$9edc545f672b7e20$exports, "ToggleIconCell", ()=>$dfd33cee3229493c$var$$084319e59e55aa64$export$2e2bcd8739ae039);
// Standard cell renderer components.
const $dfd33cee3229493c$var$$5c4800a47f171310$var$AvatarCell = ({ value: value, ...props })=>{
    const { onClick: columnOnClick, ...columnProps } = props.column;
    const onClick = columnOnClick ? ()=>columnOnClick(props) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$907f6d30d9122715$export$2e2bcd8739ae039, {
        avatar: value,
        ...columnProps,
        onClick: onClick
    });
};
$dfd33cee3229493c$var$$5c4800a47f171310$var$AvatarCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    }).isRequired
};
$dfd33cee3229493c$var$$5c4800a47f171310$var$AvatarCell.defaultProps = {
    value: ""
};
$dfd33cee3229493c$var$$5c4800a47f171310$var$AvatarCell.displayName = "AvatarCell";
var $dfd33cee3229493c$var$$5c4800a47f171310$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5c4800a47f171310$var$AvatarCell;
const $dfd33cee3229493c$var$$6d9e2f234cebfd99$var$BadgeCell = ({ value: value, ...props })=>{
    let renderedValue;
    // Ensures that the column onClick handler is not also passed to the `Cell` component.
    const { onClick: columnOnClick, badgeMapping: badgeMapping, defaultBadgeStyle: defaultBadgeStyle, emptyPlaceholder: emptyPlaceholder } = props.column;
    const onClick = columnOnClick ? ()=>columnOnClick(props) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop;
    if (badgeMapping && badgeMapping[value]) renderedValue = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$0e049761bcecbff8$export$2e2bcd8739ae039, {
        badgeStyle: badgeMapping?.[value],
        onClick: onClick,
        children: value
    });
    else if (value) // or fall all the way back to the default on `Badge`.
    renderedValue = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$0e049761bcecbff8$export$2e2bcd8739ae039, {
        badgeStyle: defaultBadgeStyle || undefined,
        onClick: onClick,
        children: value
    });
    else renderedValue = emptyPlaceholder || "";
    return renderedValue;
};
$dfd33cee3229493c$var$$6d9e2f234cebfd99$var$BadgeCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    ]).isRequired,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        badgeMapping: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({}).isRequired,
        onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    }).isRequired
};
$dfd33cee3229493c$var$$6d9e2f234cebfd99$var$BadgeCell.displayName = "BadgeCell";
var $dfd33cee3229493c$var$$6d9e2f234cebfd99$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$6d9e2f234cebfd99$var$BadgeCell;
const $dfd33cee3229493c$var$$ca5d26be9f0d6653$var$CursorSpan = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  justify-content: center;
  cursor: pointer;
`;
/*
 * Has been superseded by ToggleIconCell, so avoid using this if possible. ToggleIconCell is just
 * a more customizable version of this cell.
 */ const $dfd33cee3229493c$var$$ca5d26be9f0d6653$var$BookmarkCell = ({ value: value, row: row, column: column })=>{
    const theme = $dfd33cee3229493c$var$$050d353b350c191b$export$ffe8919b10fb3ebd();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$ca5d26be9f0d6653$var$CursorSpan, {
        onClick: (event)=>column.onBookmark({
                row: row,
                column: column,
                value: !value,
                event: event
            }),
        children: value ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$9bee1ef65a69ab49$export$2e2bcd8739ae039, {
            color: $dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(theme, "branding400")
        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$7f249b4d1cf7dc29$export$2e2bcd8739ae039, {
            color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white50
        })
    });
};
$dfd33cee3229493c$var$$ca5d26be9f0d6653$var$BookmarkCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool.isRequired,
    row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({}),
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        onBookmark: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired
    }).isRequired
};
$dfd33cee3229493c$var$$ca5d26be9f0d6653$var$BookmarkCell.displayName = "BookmarkCell";
var $dfd33cee3229493c$var$$ca5d26be9f0d6653$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ca5d26be9f0d6653$var$BookmarkCell;
const $dfd33cee3229493c$var$$37f63ef377063d6a$var$CheckboxCell = ({ row: row, column: column })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("label", {
        htmlFor: `${column?.id}row_checkbox_${row.index}`,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cfe30fe9315c100$export$2e2bcd8739ae039, {
            checked: row.isSelected,
            name: `${column?.id}row_checkbox_${row.index}`,
            id: `${column?.id}row_checkbox_${row.index}`,
            onChange: row.toggleRowSelected
        })
    });
};
$dfd33cee3229493c$var$$37f63ef377063d6a$var$CheckboxCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        isSelected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        index: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        toggleRowSelected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    }).isRequired,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({}),
        onBookmark: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired
    }).isRequired
};
$dfd33cee3229493c$var$$37f63ef377063d6a$var$CheckboxCell.displayName = "CheckboxCell";
var $dfd33cee3229493c$var$$37f63ef377063d6a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$37f63ef377063d6a$var$CheckboxCell;
const $dfd33cee3229493c$var$$62629da8bc60b7de$var$CheckboxHeader = (props)=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("label", {
        htmlFor: `${props.header}header_checkbox`,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cfe30fe9315c100$export$2e2bcd8739ae039, {
            checked: props.isAllRowsSelected,
            name: `${props.header}header_checkbox`,
            id: `${props.header}header_checkbox`,
            onChange: props.toggleAllRowsSelected
        })
    });
};
$dfd33cee3229493c$var$$62629da8bc60b7de$var$CheckboxHeader.propTypes = {
    isAllRowsSelected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    toggleAllRowsSelected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({}),
        column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({}),
        onBookmark: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired
    }).isRequired
};
$dfd33cee3229493c$var$$62629da8bc60b7de$var$CheckboxHeader.displayName = "CheckboxHeader";
var $dfd33cee3229493c$var$$62629da8bc60b7de$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$62629da8bc60b7de$var$CheckboxHeader;
const $dfd33cee3229493c$var$$e4c45da8bf77be06$export$c19ece7ea27dcd9e = "$";
const $dfd33cee3229493c$var$$e4c45da8bf77be06$export$8ca4b3587c1b0b46 = "--";
const $dfd33cee3229493c$var$$e4c45da8bf77be06$export$a2c66b064d43ac23 = 2;
/**
 * Performs a multiplication by a power of 10 using string manipulation to
 * avoid floating point precision problems. Note that this does not work for
 * numbers of the form: 0.<6 or more zeroes><non-zero numbers> because their
 * toString() interpretation uses exponents. The alternative to toString is
 * toFixed, but that method seems unreliable when it comes to actually padding a
 * decimal value.
 *
 * Example: 0.000357871562323.toFixed(50) outputs
 * '0.00035787156232300001588650384398704318300588056445'
 * Which is pretty weird.
 *
 * The tradeoff for losing the precision beyond 6 decimal places (when the non-decimal
 * portion is zero), is that we avoid floating point precision problems like:
 * 5253959.56 * 10 == 52539595.599999994
 *
 */ const $dfd33cee3229493c$var$$47d0527ab391047c$var$multiplyByPowerOfTen = (number, powerOfTen)=>{
    let stringNumber = number.toString();
    // Pad enough zeroes to guarantee we do not get out-of-bounds errors.
    for(let i = 0; i < Math.abs(powerOfTen); i++)if (powerOfTen > 0) stringNumber += "0";
    else stringNumber = `0${stringNumber}`;
    let decimalIndex = stringNumber.indexOf(".");
    if (decimalIndex === -1) decimalIndex = powerOfTen > 0 ? stringNumber.length - powerOfTen : stringNumber.length;
    else stringNumber = `${stringNumber.slice(0, decimalIndex)}${stringNumber.slice(decimalIndex + 1)}`;
    const newDecimalIndex = decimalIndex + powerOfTen;
    stringNumber = `${stringNumber.slice(0, newDecimalIndex)}.${stringNumber.slice(newDecimalIndex)}`;
    return parseFloat(stringNumber);
};
var /**
 * Rounds the decimal to a fixed number of decimal places.
 *
 * .toFixed() has inconsistent rounding for cases that are close to being rounded or down due
 * to the way that floating point numbers are stored in JS so we need additional logic
 *
 * Logic: multiplying dec by the amount of decimals that we care about so that we can convert it to
 * be stored as an integer (taken care of by the Math.round/Math.floor), this solves the precision
 * issue with floating point. Next, we modulo by 10 to see if the last digit is 5 or greater,
 * in which case we want to round up (adding 1 to the number). We then want to display it as a
 * decimal again so we divide the number by the adjustment and use .toFixed to achieve the
 * correct padding of 0s.
 *
 * There is a limit to the precision that this works to. Tested up to decimalPlaces = 6.
 * Fails with: (params) -> result
 *             (0.000000015,8) -> 0.00000000
 */ $dfd33cee3229493c$var$$47d0527ab391047c$export$2e2bcd8739ae039 = (dec, decimalPlaces = 2)=>{
    if (dec === null || dec === undefined) return "";
    const neg = dec < 0;
    const absNum = neg ? -1 * dec : dec;
    const BASE = 10;
    const floorAdjustment = BASE ** decimalPlaces;
    let roundedNum = 0;
    if ($dfd33cee3229493c$var$$47d0527ab391047c$var$multiplyByPowerOfTen(absNum, decimalPlaces + 1) % BASE >= BASE / 2) roundedNum = (Math.floor($dfd33cee3229493c$var$$47d0527ab391047c$var$multiplyByPowerOfTen(absNum, decimalPlaces)) + 1) / floorAdjustment;
    else roundedNum = Math.round($dfd33cee3229493c$var$$47d0527ab391047c$var$multiplyByPowerOfTen(absNum, decimalPlaces)) / floorAdjustment;
    if (neg) roundedNum *= -1;
    return roundedNum.toFixed(decimalPlaces);
};
/**
 * Convert a number into a comma-delimited string. this has some similarities to
 * ``strip_decimal_trailing_zeros``
 *
 * @param {?number} num - the number to be converted
 * @param {number} minimumDecimalPlaces - optional argument
 * @returns {string|null} the comma-delimited string representation of num
 */ const $dfd33cee3229493c$var$$e080c300ad87ae24$var$addCommasToNum = (num, minimumDecimalPlaces = 0)=>{
    if (num === null) return num;
    const splitNumber = num.toString().split(".");
    splitNumber[0] = splitNumber[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (minimumDecimalPlaces !== 0) {
        if (splitNumber.length < 2) splitNumber.push($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).repeat("0", minimumDecimalPlaces));
        else splitNumber[1] += $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).repeat("0", minimumDecimalPlaces - splitNumber[1].length);
    }
    return splitNumber.join(".");
};
var $dfd33cee3229493c$var$$e080c300ad87ae24$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e080c300ad87ae24$var$addCommasToNum;
/**
 * Receives number and returns formatted string with commas and rounding
 * i.e (4000000) -> 4,000,000
 * i.e (4000000.5, 2, 0) -> 4,000,000.50
 * i.e (4000000.1234, 0, 2) -> 4,000,000.12
 *
 * @param {?number} number
 * @param {number} minPrecision
 * @param {number} maxPrecision
 * @returns {string}
 */ // eslint-disable-next-line no-magic-numbers
const $dfd33cee3229493c$var$$54672cb36d5a1f23$export$688d13a530c5dcbc = (number, minPrecision = 0, maxPrecision = 6)=>{
    const formatted = `${$dfd33cee3229493c$var$$e080c300ad87ae24$export$2e2bcd8739ae039(Number($dfd33cee3229493c$var$$47d0527ab391047c$export$2e2bcd8739ae039(number, maxPrecision)), minPrecision)}`;
    return number === null ? "--" : formatted;
};
/**
 * Receives number and number of decimal places and returns a string
 * representing the percentage value
 * i.e (0.5) -> 50.00%
 * i.e (0.5, 3) -> 50.000%
 * Similar to ``get_percent`` in numberformat.py
 *
 * @param {?number} number
 * @param {number} decimalPlaces
 * @returns {string}
 */ const $dfd33cee3229493c$var$$54672cb36d5a1f23$export$82fb8ba313c9dbb0 = (number, decimalPlaces = 2)=>number === null ? "--" : `${$dfd33cee3229493c$var$$47d0527ab391047c$export$2e2bcd8739ae039(number, decimalPlaces)}%`;
const $dfd33cee3229493c$var$$022b1afec9546799$var$CurrencyCell = ({ value: value, ...props })=>{
    let precision;
    const symbol = props.column.symbol || $dfd33cee3229493c$var$$e4c45da8bf77be06$export$c19ece7ea27dcd9e;
    // Need to allow for 0 precision.
    if (!props.column.precision && props.column.precision !== 0) precision = $dfd33cee3229493c$var$$e4c45da8bf77be06$export$a2c66b064d43ac23;
    else precision = props.column.precision;
    if (props.column.formatter) return props.column.formatter(value);
    return value ? `${symbol}${$dfd33cee3229493c$var$$54672cb36d5a1f23$export$688d13a530c5dcbc(value, precision, precision)}` : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$a870e4e2493f0aa1, {
        children: $dfd33cee3229493c$var$$e4c45da8bf77be06$export$8ca4b3587c1b0b46
    });
};
$dfd33cee3229493c$var$$022b1afec9546799$var$CurrencyCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    ]).isRequired,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        precision: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        symbol: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        align: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
            "left",
            "right",
            "center"
        ])
    }).isRequired
};
$dfd33cee3229493c$var$$022b1afec9546799$var$CurrencyCell.displayName = "CurrencyCell";
var $dfd33cee3229493c$var$$022b1afec9546799$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$022b1afec9546799$var$CurrencyCell;
/*
 * Date formats available by default to be used in cell renderers.
 * All formatters consume a date in string format.
 */ // 1/19/2022
const $dfd33cee3229493c$var$$46d86ecc2e8760c3$export$b1b37f2a40030964 = (date)=>{
    const dateObject = new Date(date);
    return `${dateObject.getMonth() + 1}/${dateObject.getDate()}/${dateObject.getFullYear()}`;
};
// 19/1/2022
const $dfd33cee3229493c$var$$46d86ecc2e8760c3$export$584c9e751ac93168 = (date)=>{
    const dateObject = new Date(date);
    return `${dateObject.getDate()}/${dateObject.getMonth() + 1}/${dateObject.getFullYear()}`;
};
// January 19, 2022
const $dfd33cee3229493c$var$$46d86ecc2e8760c3$export$2adb16ac204af30e = (date)=>{
    const dateObject = new Date(date);
    return dateObject.toLocaleString("en-us", {
        month: "long",
        year: "numeric",
        day: "numeric"
    });
};
// 2022-01-19
const $dfd33cee3229493c$var$$46d86ecc2e8760c3$export$1aba8f741a0eae06 = (date)=>{
    const dateObject = new Date(date);
    const dayString = `0${dateObject.getDate()}`.slice(-2);
    const monthString = `0${dateObject.getMonth() + 1}`.slice(-2);
    return `${dateObject.getFullYear()}-${monthString}-${dayString}`;
};
const $dfd33cee3229493c$var$$ee62f5b8e7740115$var$DateCell = ({ value: value, ...props })=>{
    const formatter = props.column.dateFormatter || $dfd33cee3229493c$var$$46d86ecc2e8760c3$export$b1b37f2a40030964;
    // Need to be able to render empty dates as "".
    return value ? formatter(value) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$a870e4e2493f0aa1, {
        children: props.column.emptyPlaceholder || $dfd33cee3229493c$var$$e4c45da8bf77be06$export$8ca4b3587c1b0b46
    });
};
$dfd33cee3229493c$var$$ee62f5b8e7740115$var$DateCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        dateFormatter: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        emptyPlaceholder: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        align: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
            "left",
            "right",
            "center"
        ])
    }).isRequired
};
$dfd33cee3229493c$var$$ee62f5b8e7740115$var$DateCell.displayName = "DateCell";
var $dfd33cee3229493c$var$$ee62f5b8e7740115$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$ee62f5b8e7740115$var$DateCell;
const $dfd33cee3229493c$var$$7ba498b57aadd402$var$IconButtonCell = ({ value: value, ...props })=>{
    // Ensures that the column onClick handler is not also passed to the `Cell` component.
    const { onClick: columnOnClick, ...columnProps } = props.column;
    const onClick = columnOnClick ? (event)=>columnOnClick({
            event: event,
            ...props
        }) : $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).identity;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039, {
        ...columnProps,
        icon: value || props.column.icon,
        onClick: onClick
    });
};
$dfd33cee3229493c$var$$7ba498b57aadd402$var$IconButtonCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        dateFormatter: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        icon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    }).isRequired
};
$dfd33cee3229493c$var$$7ba498b57aadd402$var$IconButtonCell.displayName = "IconButtonCell";
var $dfd33cee3229493c$var$$7ba498b57aadd402$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7ba498b57aadd402$var$IconButtonCell;
const $dfd33cee3229493c$var$$c9f707058059f083$var$IconCell = ({ value: value, ...props })=>{
    if (value) return value;
    return props.column.getIcon?.({
        value: value,
        ...props
    });
};
$dfd33cee3229493c$var$$c9f707058059f083$var$IconCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        getIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func
    }).isRequired
};
$dfd33cee3229493c$var$$c9f707058059f083$var$IconCell.displayName = "IconCell";
var $dfd33cee3229493c$var$$c9f707058059f083$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$c9f707058059f083$var$IconCell;
const $dfd33cee3229493c$var$$5ed5b45b5a1de80c$var$NumberCell = ({ value: value, ...props })=>{
    let precision;
    // Need to allow for 0 precision.
    if (!props.column.precision && props.column.precision !== 0) precision = $dfd33cee3229493c$var$$e4c45da8bf77be06$export$a2c66b064d43ac23;
    else precision = props.column.precision;
    const formatter = props.column.formatter || ((value)=>$dfd33cee3229493c$var$$54672cb36d5a1f23$export$688d13a530c5dcbc(value, precision, precision));
    // Calls formatter with value ONLY. Clients must specify other parameters using factory functions
    // similar to the usage of `numberFormat` in the line above.
    return formatter(value);
};
$dfd33cee3229493c$var$$5ed5b45b5a1de80c$var$NumberCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    ]).isRequired,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        precision: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        formatter: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        align: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
            "left",
            "right",
            "center"
        ])
    }).isRequired
};
$dfd33cee3229493c$var$$5ed5b45b5a1de80c$var$NumberCell.displayName = "NumberCell";
var $dfd33cee3229493c$var$$5ed5b45b5a1de80c$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5ed5b45b5a1de80c$var$NumberCell;
const $dfd33cee3229493c$var$$2af52c0ac0802fd1$var$PercentageCell = ({ value: value, ...props })=>{
    let precision;
    const isUnitInterval = Boolean(props.column.isUnitInterval);
    if (!value && value !== 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$28610bd394c82dfd$export$a870e4e2493f0aa1, {
        children: $dfd33cee3229493c$var$$e4c45da8bf77be06$export$8ca4b3587c1b0b46
    });
    // Need to allow for 0 precision.
    if (!props.column.precision && props.column.precision !== 0) precision = $dfd33cee3229493c$var$$e4c45da8bf77be06$export$a2c66b064d43ac23;
    else precision = props.column.precision;
    return $dfd33cee3229493c$var$$54672cb36d5a1f23$export$82fb8ba313c9dbb0(isUnitInterval ? value * 100 : value, precision);
};
$dfd33cee3229493c$var$$2af52c0ac0802fd1$var$PercentageCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOfType([
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
    ]).isRequired,
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        precision: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
        isUnitInterval: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
        align: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf([
            "left",
            "right",
            "center"
        ])
    }).isRequired
};
$dfd33cee3229493c$var$$2af52c0ac0802fd1$var$PercentageCell.displayName = "PercentageCell";
var $dfd33cee3229493c$var$$2af52c0ac0802fd1$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$2af52c0ac0802fd1$var$PercentageCell;
const $dfd33cee3229493c$var$$084319e59e55aa64$var$CursorSpan = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  justify-content: center;
  cursor: pointer;
`;
/*
 * A generic toggleable icon cell. Typically implemented using the bookmark icon, or the pin icon,
 * since those two icons are shipped with a "-filled" alternative. Supersedes the older
 * BookmarkCell.
 */ const $dfd33cee3229493c$var$$084319e59e55aa64$var$ToggleIconCell = ({ value: value, row: row, column: column })=>{
    const OffIcon = column.offIcon || $dfd33cee3229493c$var$$7f249b4d1cf7dc29$export$2e2bcd8739ae039;
    const OnIcon = column.onIcon || $dfd33cee3229493c$var$$9bee1ef65a69ab49$export$2e2bcd8739ae039;
    const offColor = column.offColor || $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white50;
    const onColor = column.onColor || $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.blue400;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$084319e59e55aa64$var$CursorSpan, {
        onClick: (event)=>column.toggle({
                row: row,
                column: column,
                value: !value,
                event: event
            }),
        children: value ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(OnIcon, {
            color: onColor
        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(OffIcon, {
            color: offColor
        })
    });
};
$dfd33cee3229493c$var$$084319e59e55aa64$var$ToggleIconCell.propTypes = {
    value: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool.isRequired,
    row: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({}),
    column: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        offColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        onColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
        offIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        onIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
        toggle: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired
    }).isRequired
};
$dfd33cee3229493c$var$$084319e59e55aa64$var$ToggleIconCell.displayName = "ToggleIconCell";
var $dfd33cee3229493c$var$$084319e59e55aa64$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$084319e59e55aa64$var$ToggleIconCell;
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$var$$e6b58dd263c501b0$exports, $dfd33cee3229493c$var$$9edc545f672b7e20$exports);
var $dfd33cee3229493c$var$$c011369d6675b5b6$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$c011369d6675b5b6$exports, "ToastMessage", ()=>$dfd33cee3229493c$var$$e9345c1a2767e361$export$2e2bcd8739ae039);
// eslint-disable-next-line import/prefer-default-export
const $dfd33cee3229493c$var$$e9345c1a2767e361$var$fadeIn = (0, $e42cae22e74e223a$exports.keyframes)`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const $dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledToast = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$2e2bcd8739ae039)`
  align-items: center;
  animation: ${$dfd33cee3229493c$var$$e9345c1a2767e361$var$fadeIn} 1s;
  border-radius: 12px;
  display: flex;
  padding: 16px 16px 16px 0;
  width: fit-content;

  ${(props)=>props.$removed ? `
    transition: visibility 0s 1s, opacity 1s linear;
    opacity: 0;
    visibility: hidden;
  ` : ""}
`;
const $dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledIndicator = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  width: 4px;
  align-self: stretch;
  display: flex;
  background: ${(props)=>props.$color};
`;
const $dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledContent = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  margin: 0 48px 0 16px;
  max-width: 480px;
`;
const $dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledTitle = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme100}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$79846c98ead4e525}
  line-height: 16px;
`;
const $dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledMessage = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).p`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
`;
const $dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastTypes = {
    info: {
        indicator: null
    },
    success: {
        indicator: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.buy
    },
    warning: {
        indicator: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.alert
    },
    error: {
        indicator: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.sell
    }
};
/**
 * The display content for an alert on the site
 */ const $dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastMessage = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const [removed, setRemoved] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState(false);
    const indicatorColor = $dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastTypes[props.type]?.indicator;
    const { onClose: propsOnClose } = props;
    const onClose = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useCallback(()=>{
        setRemoved(true);
        setTimeout(()=>{
            propsOnClose();
        }, $dfd33cee3229493c$var$$49b61417b640529d$export$32c0454ceff7f92d);
    }, [
        propsOnClose
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        let timeout;
        if (props.displayTime) timeout = setTimeout(()=>{
            onClose();
        }, props.displayTime);
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        onClose,
        props.displayTime
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$050d353b350c191b$export$e764f077ee0cf172, {
        theme: {
            componentVersion: 2
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6b2e3dbef50b8f4c$export$724ef4907eb829c5.Provider, {
            value: 3,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledToast, {
                ref: ref,
                elevated: true,
                $removed: removed,
                role: "alert",
                "aria-live": "polite",
                children: [
                    indicatorColor && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledIndicator, {
                        $color: indicatorColor
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledContent, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledTitle, {
                                children: props.title
                            }),
                            props.detail && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e9345c1a2767e361$var$StyledMessage, {
                                children: props.detail
                            })
                        ]
                    }),
                    props.actions?.map(({ text: text, onClick: onClick })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$07a4f6eac681e0c2$export$2e2bcd8739ae039, {
                            onClick: onClick,
                            children: text
                        }, text)),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$6cd24ed6cf0e8d6a$export$2e2bcd8739ae039, {
                        buttonStyle: $dfd33cee3229493c$var$$5145b76df3837708$export$1470a2808406d4e0.OUTLINE,
                        onClick: onClose,
                        icon: $dfd33cee3229493c$var$$e70e94b576d9ab55$export$2e2bcd8739ae039
                    })
                ]
            })
        })
    });
});
$dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastMessage.displayName = "ToastMessage";
$dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastMessage.propTypes = {
    /** The main contents to show within the toast */ title: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    /** The detailed contents to show within the toast */ detail: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    /** Triggers the toast close functionality */ onClose: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    /** "success", "info", "warning", or "error" */ type: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.keys($dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastTypes)),
    /** Milliseconds the toast should appear for. Set to 0 to never disappear */ displayTime: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number,
    actions: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        text: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
        onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired
    }))
};
$dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastMessage.defaultProps = {
    type: "info",
    displayTime: $dfd33cee3229493c$var$$49b61417b640529d$export$32c0454ceff7f92d * 5.5
};
$dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastMessage.displayName = "ToastMessage";
var $dfd33cee3229493c$var$$e9345c1a2767e361$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e9345c1a2767e361$var$ToastMessage;
var $dfd33cee3229493c$var$$908850549d08edc0$exports = {};
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$908850549d08edc0$exports, "NavigationItem", ()=>$dfd33cee3229493c$var$$7f41535bb2d4decb$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$908850549d08edc0$exports, "NavigationCategoryHeader", ()=>$dfd33cee3229493c$var$$d106efacb848288f$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$908850549d08edc0$exports, "TabList", ()=>$dfd33cee3229493c$var$$e812e8d83a428bbe$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$908850549d08edc0$exports, "useCurrentTab", ()=>$dfd33cee3229493c$var$$7e63860278105c8a$export$2e2bcd8739ae039);
$dfd33cee3229493c$var$$parcel$export($dfd33cee3229493c$var$$908850549d08edc0$exports, "useTabRoute", ()=>$dfd33cee3229493c$var$$5a1ba87b8ef930ce$export$2e2bcd8739ae039);
const $dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavItemContent = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$202691c4dadcc7a2$export$2e2bcd8739ae039).attrs({
    linkStyle: $dfd33cee3229493c$var$$202691c4dadcc7a2$export$10b6eba3c5b6ca23.UNSTYLED
})`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$cb052dd198116c3c}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
  border-radius: 8px;
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.hoverTransparent};
  }

  &:active${(props)=>props.$selected ? ", &" : ""} {
    background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$7a94ef87551d6a61.activeTransparent};
    ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme100}
    svg path {
      fill: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white100};
    }
  }
`;
const $dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavWrapper = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  border-right: 1px solid
    ${(props)=>props.$selected ? $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.blue500 : "transparent"};
  box-sizing: border-box;
  display: flex;
  padding-left: 12px;
  padding-right: 11px;
  width: 100%;

  & + & {
    margin-top: 4px;
  }
  &:first-child {
    margin-top: 16px;
  }
`;
const $dfd33cee3229493c$var$$7f41535bb2d4decb$var$StyledCounter = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$50f64a5048405b0}
  ${(props)=>props.$typography}
  background: ${(props)=>props.$background};
  border-radius: 8px;
  height: 16px;
  line-height: 16px;
  padding: 0 6px;
  margin-left: auto;
`;
// Do not allow navigation icons to shrink when `children` is wide.
const $dfd33cee3229493c$var$$7f41535bb2d4decb$var$FixedSizeIconContainer = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  display: flex;
  align-items: center;
  width: 18px;
`;
const $dfd33cee3229493c$var$$7f41535bb2d4decb$var$TruncatedChildren = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavigationItem = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).forwardRef((props, ref)=>{
    const isCollapsed = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$30b200ee48e6674c$export$2e2bcd8739ae039);
    const internalRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const widthMeasuringRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const [width, setWidth] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState([
        0,
        0
    ]);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        setWidth([
            widthMeasuringRef.current?.scrollWidth,
            widthMeasuringRef.current?.offsetWidth
        ]);
    }, []);
    let tooltipContent = props.tooltip;
    if (!isCollapsed && !props.tooltip && width[0] > width[1]) tooltipContent = props.children;
    const tooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(ref || internalRef, tooltipContent, {
        orientation: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$acc88a76d8488b7a.HORIZONTAL
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavWrapper, {
        role: "presentation",
        $selected: props.selected,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavItemContent, {
            role: "menuitem",
            tabIndex: "-1",
            id: props.id,
            ref: ref || internalRef,
            url: props.url,
            linkType: props.linkType,
            onClick: props.onClick,
            $selected: props.selected,
            children: [
                props.leadingIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$7f41535bb2d4decb$var$FixedSizeIconContainer, {
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.leadingIcon, {
                        color: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.white50,
                        size: 18
                    })
                }),
                !isCollapsed && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$7f41535bb2d4decb$var$TruncatedChildren, {
                            ref: widthMeasuringRef,
                            children: props.children
                        }),
                        Boolean(props.counter) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$7f41535bb2d4decb$var$StyledCounter, {
                            $background: props.counterColor,
                            $typography: props.counterTypography,
                            children: props.counter
                        })
                    ]
                }),
                tooltipContent && tooltip
            ]
        })
    });
});
$dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavigationItem.propTypes = {
    id: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    selected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    url: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    linkType: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$da5c189d3d5b3551$export$7c41e2bb5faad6c4)),
    onClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    leadingIcon: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired,
    counter: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    counterColor: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e)),
    counterTypography: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).oneOf(Object.values($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895)),
    tooltip: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node
};
$dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavigationItem.defaultProps = {
    url: "",
    selected: false,
    counter: 0,
    counterColor: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.sell,
    counterTypography: $dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$12cccd5ee568ce0e.theme100
};
$dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavigationItem.displayName = "NavigationItem";
var $dfd33cee3229493c$var$$7f41535bb2d4decb$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7f41535bb2d4decb$var$NavigationItem;
const $dfd33cee3229493c$var$$d106efacb848288f$var$StyledNavigationCategoryHeader = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin: 24px 24px 16px;
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$e473a436d0a5cdb7}
  ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme30}
`;
const $dfd33cee3229493c$var$$d106efacb848288f$var$NavigationCategoryHeader = (props)=>{
    const collapsed = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useContext($dfd33cee3229493c$var$$30b200ee48e6674c$export$2e2bcd8739ae039);
    if (collapsed) return null;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$d106efacb848288f$var$StyledNavigationCategoryHeader, {
        ...props
    });
};
var $dfd33cee3229493c$var$$d106efacb848288f$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$d106efacb848288f$var$NavigationCategoryHeader;
const $dfd33cee3229493c$var$$3861cf8e182b37d9$var$StyledTab = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Body1theme50)`
  line-height: 14px;
  ${(props)=>props.$active ? $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme100 : $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme50}
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  height: 42px;
  white-space: nowrap;

  ${(props)=>props.$active ? `
    border-bottom: 2px solid ${$dfd33cee3229493c$var$$88a35ca95b368dbb$export$e22c5d06d177c3fa(props.theme, "tabItem")};
    ` : (0, $e42cae22e74e223a$exports.css)`
          border-bottom: 2px solid transparent;
          &:hover {
            ${$dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$38e042d64c74d895.theme80}
          }
        `}

  & + & {
    margin-left: 32px;
  }
`;
const $dfd33cee3229493c$var$$3861cf8e182b37d9$var$CountIndicator = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports)($dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$export$20f257fc407da7a3.Caption2theme50)`
  background: ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.white15};
  border-radius: 8px;
  box-sizing: border-box;
  line-height: 12px;
  margin-left: 8px;
  height: 16px;
  padding: 2px 6px;
`;
/**
 * Yuka v2.0
 * This renders a clickable tab to switch between active tabs within a layout.
 * These styles are aligned with ``NavLink``
 *
 * @param {object} props
 *
 * @returns {React.Component}
 */ const $dfd33cee3229493c$var$$3861cf8e182b37d9$var$TabItem = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$3861cf8e182b37d9$var$StyledTab, {
        $active: props.selected,
        onClick: props.handleTabClick,
        role: "tab",
        children: [
            props.label,
            (props.count || props.count === 0) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$3861cf8e182b37d9$var$CountIndicator, {
                children: props.count
            })
        ]
    });
$dfd33cee3229493c$var$$3861cf8e182b37d9$var$TabItem.propTypes = {
    selected: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).bool,
    label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
    count: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    handleTabClick: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func.isRequired
};
$dfd33cee3229493c$var$$3861cf8e182b37d9$var$TabItem.defaultProps = {
    selected: false
};
$dfd33cee3229493c$var$$3861cf8e182b37d9$var$TabItem.displayName = "TabItem";
var $dfd33cee3229493c$var$$3861cf8e182b37d9$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$3861cf8e182b37d9$var$TabItem;
const $dfd33cee3229493c$var$$5a1ba87b8ef930ce$var$useTabRoute = (tabs, paramName = "tab", defaultTab)=>{
    const [searchParams, setSearchParams] = (0, $ff1ed43a67e50aba$export$f1a78c17382fe22a)?.() || [];
    const currentTab = searchParams.get(paramName);
    const onSelect = (0, $70fFQ.useCallback)((tabName)=>{
        if ($dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).includes(tabs, tabName) && Boolean(setSearchParams)) {
            const replace = !currentTab;
            // When loading the url for a page that uses query params, the initial page will load
            // with no query params specified. If we simply history.push the query params on top,
            // we can get into an infinite loop with the browser back button where a single click of
            // back will cause the history.push to be called again. So in the case where the page is
            // being loaded for the first time, we want to history.replace instead.
            const newParams = {};
            for (let [existingParam, value] of searchParams.entries())newParams[existingParam] = value;
            newParams[paramName] = tabName;
            setSearchParams(newParams, {
                replace: replace
            });
        }
    }, [
        currentTab,
        setSearchParams,
        tabs,
        paramName,
        searchParams
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (!currentTab) onSelect(defaultTab || $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).head(tabs));
    }, [
        currentTab,
        tabs,
        defaultTab,
        onSelect
    ]);
    return [
        currentTab,
        onSelect
    ];
};
var $dfd33cee3229493c$var$$5a1ba87b8ef930ce$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$5a1ba87b8ef930ce$var$useTabRoute;
const $dfd33cee3229493c$var$$e812e8d83a428bbe$var$StyledTabList = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  border-bottom: 1px solid ${$dfd33cee3229493c$var$$ab0cc988aeba6cd1$export$de3ce00f2432aaff.minWhite};
  display: flex;
`;
const $dfd33cee3229493c$var$$e812e8d83a428bbe$var$StyledChildren = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).div`
  margin-left: auto;
`;
/**
 * This component renders a list of card tabs and calls the provided change handler with the name
 * of the tab clicked when clicked.
 *
 * Use a TabList when you need secondary tab navigation on your page (such as sections of a profile)
 */ const $dfd33cee3229493c$var$$e812e8d83a428bbe$var$TabList = (props)=>{
    const [currentTab, handleChangeTab] = $dfd33cee3229493c$var$$5a1ba87b8ef930ce$export$2e2bcd8739ae039(props.tabs.map(({ label: label })=>label), props.paramName, props.defaultTab);
    const handleTabClick = (name)=>{
        props.onTabChange(name);
        handleChangeTab(name);
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($dfd33cee3229493c$var$$e812e8d83a428bbe$var$StyledTabList, {
        className: props.className,
        role: "tablist",
        children: [
            props.tabs.map(({ label: label, count: count })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$3861cf8e182b37d9$export$2e2bcd8739ae039, {
                    selected: currentTab === label,
                    handleTabClick: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).partial(handleTabClick, label),
                    count: count,
                    label: label
                }, label)),
            props.children && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e812e8d83a428bbe$var$StyledChildren, {
                children: props.children
            })
        ]
    });
};
$dfd33cee3229493c$var$$e812e8d83a428bbe$var$TabList.propTypes = {
    onTabChange: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).func,
    tabs: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).arrayOf($dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).shape({
        label: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string.isRequired,
        count: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).number
    })).isRequired,
    paramName: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    defaultTab: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string,
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node,
    className: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).string
};
$dfd33cee3229493c$var$$e812e8d83a428bbe$var$TabList.defaultProps = {
    onTabChange: $dfd33cee3229493c$var$$parcel$interopDefault($hI4Hx).noop,
    paramName: "tab",
    defaultTab: null
};
$dfd33cee3229493c$var$$e812e8d83a428bbe$var$TabList.displayName = "TabList";
var $dfd33cee3229493c$var$$e812e8d83a428bbe$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e812e8d83a428bbe$var$TabList;
const $dfd33cee3229493c$var$$7e63860278105c8a$var$useCurrentTab = (paramName = "tab")=>{
    const [searchParams] = (0, $ff1ed43a67e50aba$export$f1a78c17382fe22a)?.() || [];
    return searchParams.get(paramName);
};
var $dfd33cee3229493c$var$$7e63860278105c8a$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$7e63860278105c8a$var$useCurrentTab;
const $dfd33cee3229493c$var$$e31c7335eaf29ffe$var$EllipsisText = $dfd33cee3229493c$var$$parcel$interopDefault($e42cae22e74e223a$exports).span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
`;
const $dfd33cee3229493c$var$$e31c7335eaf29ffe$var$TruncatedText = (props)=>{
    const widthMeasuringRef = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useRef(null);
    const [width, setWidth] = $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useState([
        0,
        0
    ]);
    const tooltip = $dfd33cee3229493c$var$$2615b6627b5e18e8$export$2e2bcd8739ae039(widthMeasuringRef, props.children);
    $dfd33cee3229493c$var$$parcel$interopDefault($70fFQ).useEffect(()=>{
        setWidth([
            widthMeasuringRef.current?.scrollWidth,
            widthMeasuringRef.current?.offsetWidth
        ]);
    }, [
        widthMeasuringRef.current?.scrollWidth,
        widthMeasuringRef.current?.offsetWidth
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($34ccb6660205eec8$exports.Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dfd33cee3229493c$var$$e31c7335eaf29ffe$var$EllipsisText, {
                ref: widthMeasuringRef,
                ...props
            }),
            width[0] > width[1] && tooltip
        ]
    });
};
$dfd33cee3229493c$var$$e31c7335eaf29ffe$var$TruncatedText.propTypes = {
    children: $dfd33cee3229493c$var$$parcel$interopDefault($cd0Jr).node.isRequired
};
var $dfd33cee3229493c$var$$e31c7335eaf29ffe$export$2e2bcd8739ae039 = $dfd33cee3229493c$var$$e31c7335eaf29ffe$var$TruncatedText;
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$0d8b515cb6593639$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$fe1ba5810fdf797e$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$46d5e6430c21300b$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$764502df57988970$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$c010c076c78b1556$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$5e30a8781de33a30$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$158dfe5f733ca3db$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$0cab4194af652e84$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$e6b58dd263c501b0$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$c011369d6675b5b6$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$5a3231ddaa76d46d$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$bef1fe5a7f3fb2f4$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$ba530530b13dfca4$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$ab0cc988aeba6cd1$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$f0e8f6a9a93de2aa$exports);
$dfd33cee3229493c$var$$parcel$exportWildcard($dfd33cee3229493c$exports, $dfd33cee3229493c$var$$908850549d08edc0$exports);


var $6a047ae2b3ad6a79$exports = {};

$6a047ae2b3ad6a79$exports = (parcelRequire("7adkN"));


const $6bf0e7acb75bd54a$export$2d11c16491c4eeef = "zxdata.qa.zanbato.com";
const $6bf0e7acb75bd54a$export$ad760ad24ffdcd9f = "https://zxdata.qa.zanbato.com";
const $6bf0e7acb75bd54a$export$2530df85a6e0f19b = "zxdata.qa.zanbato.com";
const $6bf0e7acb75bd54a$export$fde0d8a45aec75e1 = "https://zxdata.qa.zanbato.com";
const $6bf0e7acb75bd54a$export$9a91fcb7b72ad6a0 = "/assets/";


const $fd9e8486e0b9b483$var$getBaseUrl = ()=>{
    // Local dev defaults to localhost:8001; production builds set this to the
    // ZX backend URL (e.g., https://zxdata.zanbato.com/).
    return 0, $6bf0e7acb75bd54a$export$ad760ad24ffdcd9f;
};
const $fd9e8486e0b9b483$var$AxiosInstance = (0, (/*@__PURE__*/$parcel$interopDefault($6a047ae2b3ad6a79$exports))).create({
    baseURL: $fd9e8486e0b9b483$var$getBaseUrl(),
    responseType: "json",
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json"
    }
});
var $fd9e8486e0b9b483$export$2e2bcd8739ae039 = $fd9e8486e0b9b483$var$AxiosInstance;


// HD API endpoints remapped for ZX monolith.
//
// All endpoints share the /api/zxdata/ prefix:
//   api/zxdata/hd-*   — ZX HDAPI (HDUser JWT auth), previously at /hdapi/
//   api/zxdata/*      — HD-specific endpoints (accounts, analytics, access, etc.)
//
// NOTE: COMPANY, GENERIC_COMPANY, CONTRARY_REPORTS, and SACRA_DOCUMENTS
// reference endpoints that do not yet exist in ZX. They are mapped to their intended paths
// and will 404 until the backend endpoints are implemented.
const $beb11aa5e2886f26$export$30dba1e0a1cb02c9 = {
    // ── ZX HDAPI endpoints (api/zxdata/) ──────────────────────────────────────────
    // Previously proxied through HD backend via *-zx/ paths; now called directly.
    // HD's ZXViewSetMixin rewrote pagination URLs and filtered attributes; ZX returns
    // correct pagination links and full attribute sets — no frontend adaptation needed.
    COMPANY_SECTORS: ()=>"api/zxdata/hd-sectors/",
    COI_FILINGS: ()=>"api/zxdata/hd-coi-filings/",
    STOCK_SPLITS: ()=>"api/zxdata/hd-stock-splits/",
    FUNDING_ROUNDS: ()=>"api/zxdata/hd-funding-rounds/",
    ENTITY_PROFILES: ()=>"api/zxdata/hd-entity-profiles/",
    INSIGHT_ARTICLE: ()=>"api/zxdata/hd-insight-articles/",
    TRANSACTION_RECORDS: ()=>"api/zxdata/hd-transaction-records/",
    TRANSACTION_RECORD_AGGREGATES: ()=>"api/zxdata/hd-transaction-record-aggregates/",
    COMPANY_LATEST_ORDER_FLOW: ()=>"api/zxdata/hd-company-latest-order-flow/",
    COMPANY_LATEST_ORDER_FLOW_REPORTS: ()=>"api/zxdata/hd-company-latest-order-flow-reports/",
    COMPANY_REPORTED_MARKS_VALUATION: (id)=>`api/zxdata/hd-company-reported-marks-valuation/${id}/`,
    COMPANY_PRICE_VOLUME_ORDER_FLOW: ()=>"api/zxdata/hd-prices/",
    ZX_MARKET_INDEX_VALUES: ()=>"api/zxdata/hd-private-market-index-values/",
    COMPANY_AND_SECURITY_SEARCH: ()=>"api/zxdata/hd-all-symbols-search/",
    // Order flow reports — previously had company_id in URL path; now a query param.
    // HD backend also filtered JSON:API attributes; ZX returns full attribute set.
    COMPANY_VOLUME_TRADING_DATA: (companyId)=>`api/zxdata/hd-order-flow-reports/?company=${companyId}`,
    COMPANY_BID_OFFER_RATIO_DATA: (companyId)=>`api/zxdata/hd-order-flow-reports/?company=${companyId}`,
    HEADER_STATS: (companyId)=>`api/zxdata/hd-order-flow-reports/?company=${companyId}`,
    COMPANY: (id = "")=>id ? `api/zxdata/hd-companies/${id}/` : "api/zxdata/hd-companies/",
    GENERIC_COMPANY: ()=>"api/zxdata/company/search/",
    COMPANY_ARTICLES: (id)=>`api/zxdata/hd-company-articles/?company=${id}`,
    CONTRARY_REPORTS: (id = "")=>`api/zxdata/hd-contrary-reports/?company=${id}`,
    // TODO: no ZX endpoint yet — needs sacraservice ported (SACRA_URL/SACRA_API_KEY absent in ZX)
    SACRA_DOCUMENTS: (id = "")=>`api/zxdata/hd-sacra-documents/?company=${id}`,
    // TODO: no ZX endpoint yet — needs KusanagiService ported to ZX
    DOWNLOAD_ZXDATA: (companyId)=>`api/zxdata/orderflow/download-zxdata-report/${companyId}/`,
    // ── HD-specific endpoints (zxdata/) ─────────────────────────────────────
    // These are HD's own data endpoints, now served by ZX under /api/zxdata/.
    // accounts
    AGREEMENT: (id = "")=>id ? `api/zxdata/accounts/agreement/${id}/` : "api/zxdata/accounts/agreement/",
    SIGN_AGREEMENT: ()=>"api/zxdata/accounts/agreement/sign_agreement/",
    LOGIN: ()=>"api/zxdata/accounts/login/",
    LOGOUT: ()=>"api/zxdata/accounts/logout/",
    REFRESH: ()=>"api/zxdata/accounts/refresh/",
    TOKEN: ()=>"api/zxdata/accounts/token/",
    TOKEN_LOGIN: ()=>"api/zxdata/accounts/login/token/",
    USER: ()=>"api/zxdata/accounts/user/",
    WALKTHROUGH_PROGRESS: (id)=>`api/zxdata/accounts/walkthrough_progress/${id}/`,
    CHANGE_PASSWORD: (id)=>`api/zxdata/accounts/change_password/${id}/`,
    RESET_PASSWORD_SEND_EMAIL: ()=>"api/zxdata/accounts/password_reset/",
    RESET_PASSWORD_SET_PASSWORD: ()=>"api/zxdata/accounts/password_reset/confirm/",
    RESET_PASSWORD_NEW_USER: ()=>"api/zxdata/accounts/password_reset/new_user/",
    RESET_PASSWORD_VALIDATE_TOKEN: ()=>"api/zxdata/accounts/password_reset/validate_token/",
    CHANGE_ACCOUNT_SETTINGS: ()=>"api/zxdata/accounts/update_account_settings/",
    EMAIL_CHANGE_REQUEST: ()=>"api/zxdata/accounts/change_email/",
    UPDATED_AGREEMENT_FILES: ()=>"api/zxdata/accounts/updated_agreement_files/",
    // access
    HAS_FEATURE_ACCESS: ()=>"api/zxdata/access/has-feature-access/",
    HAS_PRO_DATA_ACCESS: (companyId)=>`api/zxdata/access/has-pro-data-access/${companyId}/`,
    CAN_DOWNLOAD_ZX_DATA_REPORT: (company_id)=>`api/zxdata/access/can-download-zx-data-report/${company_id}/`,
    // analytics
    REPORT_ERROR: ()=>"api/zxdata/analytics/report-error/",
    MIXPANEL_TRACK: ()=>"api/zxdata/analytics/mixpanel/track/",
    MIXPANEL_SET_PEOPLE: ()=>"api/zxdata/analytics/mixpanel/set-people/",
    // portfolios
    PORTFOLIOS: ()=>"api/zxdata/portfolios/",
    PORTFOLIO_DETAIL: (id)=>`api/zxdata/portfolios/${id}/`,
    DOWNLOAD_PORTFOLIO: (id)=>`api/zxdata/portfolios/${id}/download/`,
    PORTFOLIO_COMPANIES: ()=>"api/zxdata/portfolios/companies/",
    SHARE_LOTS: ()=>"api/zxdata/portfolios/share-lots/",
    SHARE_LOT_DETAIL: (id)=>`api/zxdata/portfolios/share-lots/${id}/`,
    // valuations
    CUSTOM_VALUATIONS: ()=>"api/zxdata/valuations/",
    // userprefs
    WATCHLIST_COMPANIES: ()=>"api/zxdata/userprefs/watchlist/"
};
// KN pagination query param
const $beb11aa5e2886f26$export$eca05871efc9bc5d = "page[number]";
// pagination refetch buffer
const $beb11aa5e2886f26$export$17369480c3d9326f = 20;
// feature names
const $beb11aa5e2886f26$export$6eae34c76cd5f0ad = "Sacra Documents";
const $beb11aa5e2886f26$export$5b6ad604c0c2bd71 = "ZX Private Market Indices";
const $beb11aa5e2886f26$export$41b1c5543b082fe7 = "EV Calculator";
const $beb11aa5e2886f26$export$aa1abf4728849f35 = "Company Transferability";
const $beb11aa5e2886f26$export$92c41cb6f16f58a = "Custom Valuation Calculator";
const $beb11aa5e2886f26$export$6d4c76a833ca8f22 = "Portfolios";
const $beb11aa5e2886f26$export$4a882f87980a4d7a = "Home Page";
const $beb11aa5e2886f26$export$8fd6bef7337a1255 = "Closed transactions";




var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");


const $447d80c2705a4d0e$export$a3b943834c35c8a3 = {
    // market activity routes
    MARKET_ACTIVITY: ()=>"/market-activity",
    // company routes
    COMPANIES: ()=>"/company/",
    COMPANY: (id)=>`/company/${id}/`,
    // user routes
    ACCOUNT: ()=>"/account",
    ACCOUNT_EMAIL: ()=>"/account/email",
    ACCOUNT_PASSWORD: ()=>"/account/password",
    // agreements routes
    AGREEMENTS: ()=>"/agreement/",
    AGREEMENT: (id)=>`/agreement/${id}/`,
    // insights routes
    INSIGHTS: ()=>"/insights",
    // login routes
    LOGIN: ()=>"/login",
    RESET_PASSWORD: ()=>"/resetpassword",
    RESET_PASSWORD_CONFIRM: ()=>"/resetpassword/confirm",
    SET_PASSWORD_BASE: ()=>"/setpassword/",
    SET_PASSWORD_NEW_USER: ()=>"/setpassword/new/",
    HOME: ()=>"/home",
    PORTFOLIOS: ()=>"/portfolios/",
    PORTFOLIO: (id)=>`/portfolios/${id}`,
    DISCOVER: ()=>"/discover"
};
const $447d80c2705a4d0e$var$UNAUTHENTICATED_ROUTES = [
    $447d80c2705a4d0e$export$a3b943834c35c8a3.LOGIN(),
    $447d80c2705a4d0e$export$a3b943834c35c8a3.RESET_PASSWORD(),
    $447d80c2705a4d0e$export$a3b943834c35c8a3.RESET_PASSWORD_CONFIRM()
];
// IMPORTANT NOTE THAT YOU SHOULD READ WHILE YOU'RE IN THIS FILE:
// If a route that is unauthenticated has variable subcomponents i.e. an ID like:
// /setpassword/new/3bb892c58233437f74b99b?email=0380a201-ee70-4c42-b5be-6272acefb285
// Then you MUST include this route somehow in the "startsWith" logic below.
const $447d80c2705a4d0e$export$983ff5a0e082b1c5 = (route)=>route.startsWith("/agreement") || route.startsWith("/setpassword") || $447d80c2705a4d0e$var$UNAUTHENTICATED_ROUTES.includes(route);






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");


const $7cf104288a3d5c08$var$loadSpinner = (0, $e42cae22e74e223a$export$d25ddfdf17c3ad3e)`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;
const $7cf104288a3d5c08$var$StyledLoadingText = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.body1)};
`;
const $7cf104288a3d5c08$var$StyledIcon = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  animation: ${$7cf104288a3d5c08$var$loadSpinner} 0.5s infinite linear;
  background: ${(0, $dfd33cee3229493c$exports.ColorPalette).fullWhite};
  background: -moz-linear-gradient(left, ${(0, $dfd33cee3229493c$exports.ColorPalette).fullWhite}, transparent 38%);
  background: -webkit-linear-gradient(left, ${(0, $dfd33cee3229493c$exports.ColorPalette).fullWhite}, transparent 38%);
  background: -o-linear-gradient(left, ${(0, $dfd33cee3229493c$exports.ColorPalette).fullWhite}, transparent 38%);
  background: -ms-linear-gradient(left, ${(0, $dfd33cee3229493c$exports.ColorPalette).fullWhite}, transparent 38%);
  background: linear-gradient(to right, ${(0, $dfd33cee3229493c$exports.ColorPalette).fullWhite}, transparent 38%);
  border-radius: 50%;
  height: 18px;
  left: calc(50% - 9px);
  position: relative;
  top: calc(50% - 9px);
  width: 18px;
  &:before {
    background: ${(0, $dfd33cee3229493c$exports.ColorPalette).fullWhite};
    border-radius: 100% 0 0 0;
    content: "";
    height: 50%;
    position: absolute;
    width: 50%;
    top: 0;
    left: 0;
  }
  &:after {
    background: rgba(22, 22, 22, 1);
    border-radius: 50%;
    bottom: 0;
    content: "";
    height: 70%;
    margin: auto;
    position: absolute;
    width: 70%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
const $7cf104288a3d5c08$var$StyledContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  background: rgba(22, 22, 22, 0.8);
  border-radius: 4px;
  height: 48px;
  margin: 0 auto;
  width: 48px;
`;
const $7cf104288a3d5c08$var$StyledContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  left: 50%;
  position: ${(props)=>props.absolute ? "absolute" : "relative"};
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`;
/**
 * Loading spinner to display when loading content.
 *
 * @param {object} props
 * @returns {React.Element}
 */ const $7cf104288a3d5c08$var$LoadingSpinner = (props)=>{
    const icon = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7cf104288a3d5c08$var$StyledIcon, {});
    const spinner = props.showContainer ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7cf104288a3d5c08$var$StyledContainer, {
        children: icon
    }) : icon;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($7cf104288a3d5c08$var$StyledContent, {
        absolute: props.absolute,
        className: props.className,
        children: [
            spinner,
            props.loadingText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7cf104288a3d5c08$var$StyledLoadingText, {
                children: props.loadingText
            })
        ]
    });
};
$7cf104288a3d5c08$var$LoadingSpinner.propTypes = {
    absolute: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    loadingText: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    showContainer: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
$7cf104288a3d5c08$var$LoadingSpinner.defaultProps = {
    absolute: true,
    className: "",
    loadingText: "",
    showContainer: true
};
var $7cf104288a3d5c08$export$2e2bcd8739ae039 = $7cf104288a3d5c08$var$LoadingSpinner;


const $0a76e47e1183ea12$export$c0ffa675b87aff = {
    privacy: "Privacy Policy",
    tou: "Terms of Use",
    nda: "Non-Disclosure Agreement"
};
const $0a76e47e1183ea12$export$b0ea155c8d9ba8b9 = {
    10: "privacy",
    20: "tou",
    40: "nda"
};


/**
 * Map a 403 from the agreements gate to the agreement route param it names.
 *
 * `HasAcceptedAgreements` / `HDAPIPermission` put the outstanding
 * `agreement_type` code in the 403 "detail" (e.g. "40" for the NDA). Where that
 * code sits depends on the view's renderer:
 *
 *   - plain DRF views (accounts, access, portfolios, ...):
 *       {"detail": "40"}
 *   - HDAPI views on HDJSONAPIMixin (rest_framework_json_api renderer):
 *       {"errors": {"detail": "40"}}
 *   - JSON:API spec shape, should the exception handler ever be swapped in:
 *       {"errors": [{"detail": "40", ...}]}
 *
 * Standalone HD only ever produced the first shape, so the interceptor used to
 * read `data.detail` alone and silently skipped the redirect on the monolith's
 * JSON:API views (ZX-15289). Returns the route param ("privacy" | "tou" |
 * "nda") or null when the error is not an unsigned-agreement 403.
 */ const $58e5b1eb16cac8d2$export$f904f69919d42934 = (error)=>{
    const data = error?.response?.data;
    if (!data || typeof data !== "object") return null;
    const errors = data.errors;
    let detail = data.detail;
    if (detail === undefined) detail = Array.isArray(errors) ? errors[0]?.detail : errors?.detail;
    if (detail === undefined || detail === null) return null;
    return (0, $0a76e47e1183ea12$export$b0ea155c8d9ba8b9)[String(detail)] ?? null;
};


// Copied from zanbato/orderflow/constants.py
// Normally passed through JSContext which is not available here
const $753b8dcbe6be17f9$export$1fe7b54cedb89d9c = 1000;
const $753b8dcbe6be17f9$export$c1c27e297fdb3d7e = 2000;
const $753b8dcbe6be17f9$export$77baccb4c6bd5852 = 1000;
const $753b8dcbe6be17f9$export$ae1f9aa6ba0be5df = 10000;
const $753b8dcbe6be17f9$export$7d08ee921734ee28 = 1000000;
const $753b8dcbe6be17f9$var$FIVE_MILLION = 5000000;
const $753b8dcbe6be17f9$var$TEN_MILLION = 10000000;
const $753b8dcbe6be17f9$var$TWENTY_FIVE_MILLION = 25000000;
const $753b8dcbe6be17f9$var$HUNDRED_MILLION = 100000000;
const $753b8dcbe6be17f9$export$58a5337423702f7c = 1000000000;
const $753b8dcbe6be17f9$export$69abf931d0e964ac = 1000000000000;
const $753b8dcbe6be17f9$export$e15589d55377682c = "weekly";
const $753b8dcbe6be17f9$export$34e77c57b0e8675a = 100; // 100ms
const $753b8dcbe6be17f9$export$3b574867feb0ac0a = 500; // 500ms
const $753b8dcbe6be17f9$export$32c0454ceff7f92d = 1000; // 1000 ms
const $753b8dcbe6be17f9$export$35acaebf644db34e = $753b8dcbe6be17f9$export$32c0454ceff7f92d * 60;
const $753b8dcbe6be17f9$export$64a5dce8d64aaa2a = 2;
const $753b8dcbe6be17f9$export$af244bfc5e04ba23 = 4;
const $753b8dcbe6be17f9$export$89ba74fd97633d5b = "company profile";
const $753b8dcbe6be17f9$export$a08762b44f24cd2 = "company profile - floating header";
const $753b8dcbe6be17f9$export$142f942119c744e0 = "Superchart";
const $753b8dcbe6be17f9$export$16dc43bcee2b5f71 = "company screener";
const $753b8dcbe6be17f9$export$a1a0d48d479bd8d4 = [
    $753b8dcbe6be17f9$export$7d08ee921734ee28,
    $753b8dcbe6be17f9$var$FIVE_MILLION,
    $753b8dcbe6be17f9$var$TEN_MILLION,
    $753b8dcbe6be17f9$var$TWENTY_FIVE_MILLION,
    $753b8dcbe6be17f9$var$HUNDRED_MILLION
];




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");
const $46a097389bbbbe65$export$7feebea0001a7c34 = /*#__PURE__*/ (0, $70fFQ.createContext)(null);
const [$46a097389bbbbe65$var$addToast, $46a097389bbbbe65$var$removeToast, $46a097389bbbbe65$var$addBanner, $46a097389bbbbe65$var$removeBanner, $46a097389bbbbe65$var$registerDropdown, $46a097389bbbbe65$var$unregisterDropdown, $46a097389bbbbe65$var$toggleDropdown, $46a097389bbbbe65$var$disableHotkeys, $46a097389bbbbe65$var$enableHotkeys, $46a097389bbbbe65$var$updateMixpanelEventSource] = [
    "ADD_TOAST",
    "REMOVE_TOAST",
    "ADD_BANNER",
    "REMOVE_BANNER",
    "REGISTER_DROPDOWN",
    "UNREGISTER_DROPDOWN",
    "TOGGLE_DROPDOWN",
    "DISABLE_HOTKEYS",
    "ENABLE_HOTKEYS",
    "UPDATE_MIXPANEL_EVENT_SOURCE"
];
const $46a097389bbbbe65$export$92a1a3b7554e9387 = {
    addToast: $46a097389bbbbe65$var$addToast,
    removeToast: $46a097389bbbbe65$var$removeToast,
    addBanner: $46a097389bbbbe65$var$addBanner,
    removeBanner: $46a097389bbbbe65$var$removeBanner,
    registerDropdown: $46a097389bbbbe65$var$registerDropdown,
    unregisterDropdown: $46a097389bbbbe65$var$unregisterDropdown,
    toggleDropdown: $46a097389bbbbe65$var$toggleDropdown,
    enableHotkeys: $46a097389bbbbe65$var$enableHotkeys,
    disableHotkeys: $46a097389bbbbe65$var$disableHotkeys,
    updateMixpanelEventSource: $46a097389bbbbe65$var$updateMixpanelEventSource
};
const $46a097389bbbbe65$var$reducer = (state, action)=>{
    switch(action.type){
        case $46a097389bbbbe65$var$addToast:
            return {
                ...state,
                toasts: [
                    ...state.toasts,
                    {
                        id: Math.random(),
                        message: action.message
                    }
                ]
            };
        case $46a097389bbbbe65$var$removeToast:
            return {
                ...state,
                toasts: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).reject(state.toasts, {
                    id: action.id
                })
            };
        case $46a097389bbbbe65$var$addBanner:
            return {
                ...state,
                banners: [
                    ...state.banners,
                    action.banner
                ]
            };
        case $46a097389bbbbe65$var$removeBanner:
            state.banners.shift();
            return {
                ...state,
                banners: [
                    ...state.banners
                ]
            };
        case $46a097389bbbbe65$var$registerDropdown:
            if (action.id in state.registeredDropdowns) // eslint-disable-next-line no-console
            console.warn(`Dropdown is already registered with id "${action.id}"! Dropdown IDs must be globally unique.`);
            return {
                ...state,
                registeredDropdowns: {
                    ...state.registeredDropdowns,
                    [action.id]: [
                        action.toggleDropdown,
                        false
                    ]
                }
            };
        case $46a097389bbbbe65$var$unregisterDropdown:
            return {
                ...state,
                registeredDropdowns: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).omit(state.registeredDropdowns, action.id)
            };
        case $46a097389bbbbe65$var$toggleDropdown:
            return {
                ...state,
                registeredDropdowns: {
                    ...state.registeredDropdowns,
                    [action.id]: [
                        state.registeredDropdowns[action.id][0],
                        !state.registeredDropdowns[action.id][1]
                    ]
                }
            };
        case $46a097389bbbbe65$var$disableHotkeys:
            return {
                ...state,
                hotkeysEnabled: false
            };
        case $46a097389bbbbe65$var$enableHotkeys:
            return {
                ...state,
                hotkeysEnabled: true
            };
        // Falls through to default case and returns state;
        case $46a097389bbbbe65$var$updateMixpanelEventSource:
            return {
                ...state,
                mixpanelEventSources: {
                    ...state.mixpanelEventSources,
                    [action.target]: action.source
                }
            };
        default:
            return state;
    }
};
const $46a097389bbbbe65$var$BASE_SOURCE = "ZXData";
const $46a097389bbbbe65$export$796b285b8ee8898e = "company profile";
const $46a097389bbbbe65$var$StateProvider = (props)=>{
    const stateInitializer = ()=>({
            toasts: [],
            banners: [],
            registeredDropdowns: {},
            hotkeysEnabled: true,
            mixpanelEventSources: {
                [$46a097389bbbbe65$export$796b285b8ee8898e]: $46a097389bbbbe65$var$BASE_SOURCE
            }
        });
    // A global data store to be shared by all children.
    const [state, dispatch] = (0, $70fFQ.useReducer)($46a097389bbbbe65$var$reducer, {}, stateInitializer);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($46a097389bbbbe65$export$7feebea0001a7c34.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: props.children
    });
};
$46a097389bbbbe65$var$StateProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired
};
const $46a097389bbbbe65$export$2105062e25df4afe = (fn)=>{
    const { state: state } = (0, $70fFQ.useContext)($46a097389bbbbe65$export$7feebea0001a7c34);
    // Don't include fn in dependencies so an arrow function can be provided
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const val = (0, $70fFQ.useMemo)(()=>fn(state), [
        state
    ]);
    return val;
};
const $46a097389bbbbe65$export$8ad76b76a4c905f8 = ()=>{
    const { dispatch: dispatch } = (0, $70fFQ.useContext)($46a097389bbbbe65$export$7feebea0001a7c34);
    return dispatch;
};
const $46a097389bbbbe65$export$646567740a5dfaed = (target)=>{
    const { state: state } = (0, $70fFQ.useContext)($46a097389bbbbe65$export$7feebea0001a7c34);
    return state.mixpanelEventSources[target];
};
var $46a097389bbbbe65$export$2e2bcd8739ae039 = $46a097389bbbbe65$var$StateProvider;


const $53b8b7db1779de07$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $70fFQ.createContext)(null);
const $53b8b7db1779de07$var$ACCESS_TOKEN = "access_token";
const $53b8b7db1779de07$var$REFRESH_TOKEN = "refresh_token";
const $53b8b7db1779de07$var$REFRESH_TIMEOUT = (0, $753b8dcbe6be17f9$export$35acaebf644db34e) * 59; // access token expires in 60 minutes
/**
 * Wrapper around all the routes in HD to provide the basic authentication mechanisms.
 *
 * Checks if user is authenticated by hitting a basic /user endpoint,
 * redirects to login page if necessary.
 *
 * Provides an authentication function through React context for the login form to use. Sets Axios
 * authentication header from token acquired through login form or local storage.
 *
 * Refreshes JWT access token on a fixed cadence in line with the token lifetime defined
 * in the backend.
 *
 * @param {React.Component} children - the child components to render
 * @returns {React.Element}
 */ const $53b8b7db1779de07$export$87091915187a1a85 = ({ children: children })=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const [user, setUser] = (0, $70fFQ.useState)(null);
    const [loadingAuth, setLoadingAuth] = (0, $70fFQ.useState)(true);
    const [nextLocation, setNextLocation] = (0, $70fFQ.useState)(null);
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    const queryClient = (0, $7e71e0df4024a5cb$export$22e77b9572c4fded)();
    let refreshTimeout = null;
    const setToken = (newToken)=>{
        if (newToken.access) {
            localStorage.setItem($53b8b7db1779de07$var$ACCESS_TOKEN, newToken.access);
            (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).defaults.headers.Authorization = `Bearer ${newToken.access}`;
        }
        if (newToken.refresh) localStorage.setItem($53b8b7db1779de07$var$REFRESH_TOKEN, newToken.refresh);
        if (refreshTimeout) clearTimeout(refreshTimeout);
        refreshTimeout = window.setTimeout(refreshAccessToken, $53b8b7db1779de07$var$REFRESH_TIMEOUT);
    };
    const setUserData = ()=>{
        (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).get((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).USER()).then((response)=>{
            setUser(response.data);
        }).catch(()=>{
            if (!(0, $447d80c2705a4d0e$export$983ff5a0e082b1c5)(location.pathname)) navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN());
            setUser(null);
        }).finally(()=>{
            setLoadingAuth(false);
        });
    };
    const authenticate = (newToken, redirect = false)=>{
        setToken(newToken);
        setUserData();
        if (redirect) {
            navigate(nextLocation || (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES());
            setNextLocation(null);
        }
    };
    const logout = async ()=>{
        // Call the backend so the refresh token is blacklisted server-side. We
        // run this best-effort: even if the network call fails (offline, server
        // error, expired token) we must still clear client state and route the
        // user to the login page. See ZX-15031.
        const refresh = localStorage.getItem($53b8b7db1779de07$var$REFRESH_TOKEN);
        try {
            if (refresh) await (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).LOGOUT(), {
                refresh: refresh
            });
        } catch (err) {
        // Swallow — client cleanup still has to run.
        } finally{
            if (refreshTimeout) {
                clearTimeout(refreshTimeout);
                refreshTimeout = null;
            }
            setUser(null);
            localStorage.removeItem($53b8b7db1779de07$var$ACCESS_TOKEN);
            localStorage.removeItem($53b8b7db1779de07$var$REFRESH_TOKEN);
            delete (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).defaults.headers.Authorization;
            // Standalone HD's Log Out was a plain <a href="/login"> — a full page load
            // that wiped React state and the react-query cache. ZX-15031 made it an
            // SPA navigation, so cached server state (feature access, portfolios, ...)
            // now outlives the session unless we drop it here; otherwise the next
            // sign-in on this tab starts from the previous user's cache (ZX-15283).
            queryClient.clear();
            navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN());
        }
    };
    (0, $70fFQ.useEffect)(()=>{
        // On first load, attempt to set access token from local storage
        // in case user is already logged in from before
        authenticate({
            access: localStorage.getItem($53b8b7db1779de07$var$ACCESS_TOKEN),
            refresh: localStorage.getItem($53b8b7db1779de07$var$REFRESH_TOKEN)
        });
        if (!localStorage.getItem($53b8b7db1779de07$var$ACCESS_TOKEN)) {
            const nextLocation = !(0, $447d80c2705a4d0e$export$983ff5a0e082b1c5)(location.pathname) ? location.pathname : null;
            setNextLocation(nextLocation);
        }
        (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).interceptors.response.use((response)=>{
            return response; // propagate success response
        }, (error)=>{
            // Network errors (no server response, CORS, cancelled requests) leave
            // `error.response` undefined — guard so this interceptor itself does
            // not throw a TypeError that masks the original failure (ZX-15035).
            const status = error?.response?.status;
            const requestUrl = error?.response?.config?.url ?? "";
            // 401 means auth check failed on the server side, redirect to login
            // This will probably only be activated when a users token expires
            // mid-session.
            if (status === 401) {
                setUser(null);
                // Do not prompt the toast or redirect if the user is trying to log in.
                if (!requestUrl.startsWith((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).LOGIN()) && !requestUrl.startsWith((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).HAS_FEATURE_ACCESS()) && !requestUrl.startsWith((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).MIXPANEL_TRACK()) && // report-error requires a JWT again (ZX-15290); a JS error on the
                // login page must not turn into an "inactivity" toast + redirect.
                !requestUrl.startsWith((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).REPORT_ERROR())) {
                    dispatch({
                        type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                        message: "You have been logged out of your session due to inactivity. Redirecting to login page in 5 seconds..."
                    });
                    setTimeout(()=>navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN()), (0, $753b8dcbe6be17f9$export$32c0454ceff7f92d) * 5);
                }
            } else if (status === 403) {
                // The agreements gate names the outstanding agreement in the 403
                // body. The body shape differs between plain DRF views and the
                // HDAPI JSON:API views, so let the helper find it (ZX-15289).
                const agreement = (0, $58e5b1eb16cac8d2$export$f904f69919d42934)(error);
                if (agreement) navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT(agreement));
            // Be careful of redirecting to a page that could lead to repeated
            // 403 errors resulting in continuous redirects
            }
            return Promise.reject(error);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const refreshAccessToken = ()=>{
        const refresh = localStorage.getItem($53b8b7db1779de07$var$REFRESH_TOKEN);
        if (refresh) (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).REFRESH(), {
            refresh: refresh
        }).then((response)=>{
            authenticate(response.data);
        }).catch(()=>{
            if (refreshTimeout) {
                clearTimeout(refreshTimeout);
                refreshTimeout = null;
            }
        });
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($53b8b7db1779de07$export$a0fd8390cfe8ae69.Provider, {
        value: {
            authenticate: authenticate,
            user: user,
            logout: logout,
            setUserData: setUserData
        },
        children: loadingAuth ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}) : children
    });
};
$53b8b7db1779de07$export$87091915187a1a85.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired
};


// React Documentation: https://react.dev/reference/react/Component#componentdidcatch-caveats
// If we want additional functionality, react-error-boundary can be a good place to start


var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");



var $cd0Jr = parcelRequire("cd0Jr");
/*
 * The primary ZX Logo in grayscale
 *
 * @param {Object} props
 * @returns {React.Element}
 */ const $146a4380c9eee20d$var$ZXLogo = ({ size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    fill: "#FFF",
                    fillOpacity: ".3",
                    d: "M8 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0M24 20a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
                    fill: "#FEFEFE",
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                            d: "M24 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                            d: "M20.36 9.297c-.121.008-.237.036-.36.036A5.339 5.339 0 0 1 14.667 4c0-.123.028-.24.036-.36L3.64 14.704c.121-.01.237-.038.36-.038A5.34 5.34 0 0 1 9.333 20c0 .124-.028.24-.036.36L20.36 9.297z",
                            opacity: ".5"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                            d: "M8 20a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
                        })
                    ]
                })
            ]
        })
    });
$146a4380c9eee20d$var$ZXLogo.displayName = "ZXLogo";
$146a4380c9eee20d$var$ZXLogo.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$146a4380c9eee20d$var$ZXLogo.defaultProps = {
    size: 24
};
var $146a4380c9eee20d$export$2e2bcd8739ae039 = $146a4380c9eee20d$var$ZXLogo;




const $12833d8bb7591755$var$StyledError = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin: 50px auto 0;
  width: 50%;
`;
class $12833d8bb7591755$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI
        return {
            hasError: true
        };
    }
    componentDidCatch(error, info) {
        const errorPostDetails = {
            error: error.message,
            stack: info.componentStack,
            route: window.location.href
        };
        (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).REPORT_ERROR(), errorPostDetails);
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($12833d8bb7591755$var$StyledError, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $146a4380c9eee20d$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("p", {
                    children: "Oops, something went wrong... our supported platforms are:"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                            children: "Chrome"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                            children: "Firefox"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                            children: "IE 11"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                            children: "Edge"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                            children: "Safari 11"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("p", {
                    children: "The development team has been notified of your issue and will work to resolve it as soon as possible. If you do not see your browser listed above, please use one of those to view this site."
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("p", {
                    children: "We apologize for any inconvenience."
                })
            ]
        });
        return this.props.children;
    }
}
$12833d8bb7591755$var$ErrorBoundary.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired
};
var $12833d8bb7591755$export$2e2bcd8739ae039 = $12833d8bb7591755$var$ErrorBoundary;



const $78cf78541be2071b$var$BLUE900 = "#B1E2E7";
const $78cf78541be2071b$var$BLUE800 = "#A2DCE2";
const $78cf78541be2071b$var$BLUE700 = "#92D7DD";
const $78cf78541be2071b$var$BLUE600 = "#83D1D8";
const $78cf78541be2071b$var$BLUE500 = "#74CBD3";
const $78cf78541be2071b$var$BLUE400 = "#64C5CE";
const $78cf78541be2071b$var$BLUE300 = "#54BFC9";
const $78cf78541be2071b$var$BLUE200 = "#45BAC4";
const $78cf78541be2071b$var$BLUE100 = "#3BAFBA";
// The commented out colors are left in place to remind us which colors we still need to
// standardize in our theme.
const $78cf78541be2071b$export$29792b0afe15a7ce = {
    branding900: $78cf78541be2071b$var$BLUE900,
    branding800: $78cf78541be2071b$var$BLUE800,
    branding700: $78cf78541be2071b$var$BLUE700,
    branding600: $78cf78541be2071b$var$BLUE600,
    branding500: $78cf78541be2071b$var$BLUE500,
    branding400: $78cf78541be2071b$var$BLUE400,
    branding300: $78cf78541be2071b$var$BLUE300,
    branding200: $78cf78541be2071b$var$BLUE200,
    branding100: $78cf78541be2071b$var$BLUE100,
    d300: "#2B393A",
    d200: "#344546",
    d100: "#3D5152",
    red: "#FFBC96",
    // redHover: "#ff7272",
    // redActive: "#ff7a7a",
    green: "#92CAB7",
    // greenHover: "#33f8a2",
    // greenActive: "#66fab9",
    yellow: "#DFCD6F",
    magenta: "#D593DB",
    indigo: "#557EE7",
    /* Component-specific coloring */ link: $78cf78541be2071b$var$BLUE500,
    checkbox: $78cf78541be2071b$var$BLUE500,
    tabItem: $78cf78541be2071b$var$BLUE500,
    focussedInputBorder: $78cf78541be2071b$var$BLUE500
};


/*
 * styled-components css definitions that will be passed into the yuka theme provider at various
 * levels to customize the look and feel of our components.
 */ 


const $2bea9d664998feb5$export$b9f4a6445d7ff477 = (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
  border-radius: 12px;
  padding: 0 12px;
  height: 40px;
`;
const $2bea9d664998feb5$export$b4cda9855716fb0f = (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
  border-radius: 12px;
  padding: 11px;
  width: 40px;
  height: 40px;
`;
const $2bea9d664998feb5$export$fbffadb75457213a = (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
  background: ${(0, $78cf78541be2071b$export$29792b0afe15a7ce).d300};
  color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white80};
  border: none;
  svg path {
    fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white50};
  }
`;
const $2bea9d664998feb5$export$2d2fb02a1fffc814 = (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
  background: ${(0, $78cf78541be2071b$export$29792b0afe15a7ce).d200};
  color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white80};
  svg path {
    fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white50};
  }
`;
const $2bea9d664998feb5$export$4bb1592bbd434475 = (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
  background: ${(0, $78cf78541be2071b$export$29792b0afe15a7ce).d100};
  color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white80};
  svg path {
    fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white50};
  }
`;


var /*
 * ZXData overrides some yuka defaults.
 */ $235b758820ece497$export$2e2bcd8739ae039 = {
    button: {
        [(0, $dfd33cee3229493c$exports.ButtonStyles).RAISED]: {
            container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477),
            selectedDefault: (0, $2bea9d664998feb5$export$fbffadb75457213a),
            selectedHover: (0, $2bea9d664998feb5$export$2d2fb02a1fffc814),
            selectedActive: (0, $2bea9d664998feb5$export$4bb1592bbd434475)
        },
        [(0, $dfd33cee3229493c$exports.ButtonStyles).CTA]: {
            container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
        }
    },
    iconButton: {
        [(0, $dfd33cee3229493c$exports.IconButtonStyles).RAISED]: {
            container: (0, $2bea9d664998feb5$export$b4cda9855716fb0f)
        }
    },
    colors: (0, $78cf78541be2071b$export$29792b0afe15a7ce)
};




var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");

var $hI4Hx = parcelRequire("hI4Hx");
var $e4e2ed8cc86ce03b$exports = {};

$parcel$export($e4e2ed8cc86ce03b$exports, "extract", function () { return $e4e2ed8cc86ce03b$export$f9380c9a627682d3; }, function (v) { return $e4e2ed8cc86ce03b$export$f9380c9a627682d3 = v; });
$parcel$export($e4e2ed8cc86ce03b$exports, "parse", function () { return $e4e2ed8cc86ce03b$export$98e6a39c04603d36; }, function (v) { return $e4e2ed8cc86ce03b$export$98e6a39c04603d36 = v; });
$parcel$export($e4e2ed8cc86ce03b$exports, "stringify", function () { return $e4e2ed8cc86ce03b$export$fac44ee5b035f737; }, function (v) { return $e4e2ed8cc86ce03b$export$fac44ee5b035f737 = v; });
$parcel$export($e4e2ed8cc86ce03b$exports, "parseUrl", function () { return $e4e2ed8cc86ce03b$export$7a5253c0f62e0150; }, function (v) { return $e4e2ed8cc86ce03b$export$7a5253c0f62e0150 = v; });
$parcel$export($e4e2ed8cc86ce03b$exports, "stringifyUrl", function () { return $e4e2ed8cc86ce03b$export$a8c1621ea79325d3; }, function (v) { return $e4e2ed8cc86ce03b$export$a8c1621ea79325d3 = v; });
$parcel$export($e4e2ed8cc86ce03b$exports, "pick", function () { return $e4e2ed8cc86ce03b$export$357523c63a2253b9; }, function (v) { return $e4e2ed8cc86ce03b$export$357523c63a2253b9 = v; });
$parcel$export($e4e2ed8cc86ce03b$exports, "exclude", function () { return $e4e2ed8cc86ce03b$export$44c361b8ec72ef7f; }, function (v) { return $e4e2ed8cc86ce03b$export$44c361b8ec72ef7f = v; });
var $e4e2ed8cc86ce03b$export$f9380c9a627682d3;
var $e4e2ed8cc86ce03b$export$98e6a39c04603d36;
var $e4e2ed8cc86ce03b$export$fac44ee5b035f737;
var $e4e2ed8cc86ce03b$export$7a5253c0f62e0150;
var $e4e2ed8cc86ce03b$export$a8c1621ea79325d3;
var $e4e2ed8cc86ce03b$export$357523c63a2253b9;
var $e4e2ed8cc86ce03b$export$44c361b8ec72ef7f;
'use strict';
var $c0efee4f766de3d3$exports = {};
'use strict';
$c0efee4f766de3d3$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $d64e412da1ccae29$exports = {};
'use strict';
var $d64e412da1ccae29$var$token = '%[a-f0-9]{2}';
var $d64e412da1ccae29$var$singleMatcher = new RegExp('(' + $d64e412da1ccae29$var$token + ')|([^%]+?)', 'gi');
var $d64e412da1ccae29$var$multiMatcher = new RegExp('(' + $d64e412da1ccae29$var$token + ')+', 'gi');
function $d64e412da1ccae29$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $d64e412da1ccae29$var$decodeComponents(left), $d64e412da1ccae29$var$decodeComponents(right));
}
function $d64e412da1ccae29$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($d64e412da1ccae29$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $d64e412da1ccae29$var$decodeComponents(tokens, i).join('');
            tokens = input.match($d64e412da1ccae29$var$singleMatcher) || [];
        }
        return input;
    }
}
function $d64e412da1ccae29$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $d64e412da1ccae29$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $d64e412da1ccae29$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $d64e412da1ccae29$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
$d64e412da1ccae29$exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $d64e412da1ccae29$var$customDecodeURIComponent(encodedURI);
    }
};


var $b643dce4e3c76d44$exports = {};
'use strict';
$b643dce4e3c76d44$exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $15a7ce80463f6165$exports = {};
'use strict';
$15a7ce80463f6165$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $e4e2ed8cc86ce03b$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $e4e2ed8cc86ce03b$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $e4e2ed8cc86ce03b$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $e4e2ed8cc86ce03b$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $e4e2ed8cc86ce03b$var$encode(key, options),
                            '[',
                            $e4e2ed8cc86ce03b$var$encode(index, options),
                            ']=',
                            $e4e2ed8cc86ce03b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $e4e2ed8cc86ce03b$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $e4e2ed8cc86ce03b$var$encode(key, options),
                            '[]=',
                            $e4e2ed8cc86ce03b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $e4e2ed8cc86ce03b$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $e4e2ed8cc86ce03b$var$encode(key, options),
                            ':list=',
                            $e4e2ed8cc86ce03b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $e4e2ed8cc86ce03b$var$encode(key, options),
                                keyValueSep,
                                $e4e2ed8cc86ce03b$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $e4e2ed8cc86ce03b$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $e4e2ed8cc86ce03b$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $e4e2ed8cc86ce03b$var$encode(key, options),
                            '=',
                            $e4e2ed8cc86ce03b$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $e4e2ed8cc86ce03b$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $e4e2ed8cc86ce03b$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $e4e2ed8cc86ce03b$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$e4e2ed8cc86ce03b$var$decode(item, options)) : value === null ? value : $e4e2ed8cc86ce03b$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $e4e2ed8cc86ce03b$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$e4e2ed8cc86ce03b$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $e4e2ed8cc86ce03b$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $e4e2ed8cc86ce03b$var$encode(value, options) {
    if (options.encode) return options.strict ? $c0efee4f766de3d3$exports(value) : encodeURIComponent(value);
    return value;
}
function $e4e2ed8cc86ce03b$var$decode(value, options) {
    if (options.decode) return $d64e412da1ccae29$exports(value);
    return value;
}
function $e4e2ed8cc86ce03b$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $e4e2ed8cc86ce03b$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $e4e2ed8cc86ce03b$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $e4e2ed8cc86ce03b$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $e4e2ed8cc86ce03b$var$extract(input) {
    input = $e4e2ed8cc86ce03b$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $e4e2ed8cc86ce03b$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $e4e2ed8cc86ce03b$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $e4e2ed8cc86ce03b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $e4e2ed8cc86ce03b$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $b643dce4e3c76d44$exports(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $e4e2ed8cc86ce03b$var$decode(value, options);
        formatter($e4e2ed8cc86ce03b$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $e4e2ed8cc86ce03b$var$parseValue(value[k], options);
        else ret[key] = $e4e2ed8cc86ce03b$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $e4e2ed8cc86ce03b$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$e4e2ed8cc86ce03b$export$f9380c9a627682d3 = $e4e2ed8cc86ce03b$var$extract;
$e4e2ed8cc86ce03b$export$98e6a39c04603d36 = $e4e2ed8cc86ce03b$var$parse;
$e4e2ed8cc86ce03b$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $e4e2ed8cc86ce03b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $e4e2ed8cc86ce03b$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $e4e2ed8cc86ce03b$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $e4e2ed8cc86ce03b$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $e4e2ed8cc86ce03b$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $e4e2ed8cc86ce03b$var$encode(key, options) + '=' + $e4e2ed8cc86ce03b$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$e4e2ed8cc86ce03b$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $b643dce4e3c76d44$exports(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $e4e2ed8cc86ce03b$var$parse($e4e2ed8cc86ce03b$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $e4e2ed8cc86ce03b$var$decode(hash, options)
    } : {});
};
$e4e2ed8cc86ce03b$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$e4e2ed8cc86ce03b$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $e4e2ed8cc86ce03b$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $e4e2ed8cc86ce03b$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $e4e2ed8cc86ce03b$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $e4e2ed8cc86ce03b$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $e4e2ed8cc86ce03b$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$e4e2ed8cc86ce03b$var$encodeFragmentIdentifier] ? $e4e2ed8cc86ce03b$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$e4e2ed8cc86ce03b$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$e4e2ed8cc86ce03b$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $e4e2ed8cc86ce03b$export$7a5253c0f62e0150(input, options);
    return $e4e2ed8cc86ce03b$export$a8c1621ea79325d3({
        url: url,
        query: $15a7ce80463f6165$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$e4e2ed8cc86ce03b$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $e4e2ed8cc86ce03b$export$357523c63a2253b9(input, exclusionFilter, options);
};



var $70fFQ = parcelRequire("70fFQ");



var $hI4Hx = parcelRequire("hI4Hx");
// Copied from onikiri
const $397b4344a6629882$var$_parseJsonApiObj = (obj)=>{
    const attributes = obj.attributes;
    const relationships = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).mapValues(obj.relationships, (rel)=>{
        // Check if rel.data is an array of objects.
        if (rel.data) {
            if (Array.isArray(rel.data)) return rel.data.map((datum)=>[
                    datum.type,
                    datum.id
                ]);
            // Not an array.
            return [
                rel.data.type,
                rel.data.id
            ];
        }
        return null;
    });
    return {
        apiId: obj.id,
        apiType: obj.type,
        ...attributes,
        ...relationships
    };
};
// Copied from onikiri
const $397b4344a6629882$export$4d4d4fb2de83c9b8 = (data)=>{
    if (data) {
        // Handle the primary objects being passed down. Flatten structure
        let mainData;
        if (Array.isArray(data.data)) mainData = data.data.map((inst)=>$397b4344a6629882$var$_parseJsonApiObj(inst));
        else mainData = $397b4344a6629882$var$_parseJsonApiObj(data.data);
        // Handle the included objects. Returns an object shaped like
        // { [TYPE]: { [ID]: obj1, [ID2]: obj2 }, [TYPE2]: { [ID]: obj } }
        // Relationships get parsed from the api in a way you can use a get helper to access this
        // without any additional work
        const parsedIncluded = data.included ? (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).groupBy((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).keyBy(data.included.map((inst)=>$397b4344a6629882$var$_parseJsonApiObj(inst)), "apiId"), "apiType") : {};
        const parsedPaginationInfo = {
            ...data.links,
            ...data.meta?.pagination
        };
        return {
            data: mainData,
            relationships: parsedIncluded,
            page: parsedPaginationInfo
        };
    }
    return null;
};
// KN pagination data format
const $397b4344a6629882$export$262205ea6b009fb3 = (page)=>{
    if (!page?.meta?.pagination) return undefined;
    if (page.meta.pagination.page < page.meta.pagination.pages) return page.meta.pagination.page + 1;
};
const $397b4344a6629882$export$3518a77cc76c909 = {
    refetchOnWindowFocus: false,
    retry: 0
};
/**
 * Determines whether or not the provided data is for a file upload.
 * Checks if data is an instance of ``FormData`` or if it contains any ``File`` objects.
 *
 * @param {object} data - The data we are sending to the server
 * @returns {boolean} True if the data is for a file upload, False otherwise
 */ const $397b4344a6629882$export$47203b4e8b42864c = (data)=>{
    if (data instanceof FormData) return true;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).some((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).values(data), (v)=>{
        if (v instanceof File) return true;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isArray(v) || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isObject(v)) return $397b4344a6629882$export$47203b4e8b42864c(v);
        return false;
    });
};
/**
 * Creates a FormData object for file uploads.
 *
 * @param {object} data
 * @returns {FormData}
 */ const $397b4344a6629882$export$9e33b233a1fdb104 = (data)=>{
    const formData = new FormData();
    (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).forIn(data, (v, k)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isArray(v)) (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).forEach(v, (arrayV)=>formData.append(k, arrayV));
        else formData.append(k, v);
    });
    return formData;
};


/**
 * Wrapper around `useQuery`
 * https://tanstack.com/query/v4/docs/reference/useQuery?from=reactQueryV3&original=https://react-query-v3.tanstack.com/reference/useQuery
 *
 * @param {string} url
 * @param {object} queryParams
 * @param {object} options
 * @returns {Array} see useQuery documentation for return values. Also adds `cleanedData` to the returnInfo.
 */ const $3b38c5c0bd1105aa$var$useFetch = (url, queryParams = {}, options = {})=>{
    // Some API_ENDPOINTS entries pre-embed `?company=…` into the URL, so the
    // separator must adapt instead of always being `?`.
    const separator = url.includes("?") ? "&" : "?";
    const qs = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(queryParams) ? "" : `${separator}${(0, (/*@__PURE__*/$parcel$interopDefault($e4e2ed8cc86ce03b$exports))).stringify(queryParams)}`;
    const apiUrl = `${url}${qs}`;
    const queryFn = (0, $70fFQ.useCallback)(()=>(0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).get(apiUrl).then((response)=>response.data)// Preserve the original error (typically an AxiosError) when there is
        // no `response` (network error, CORS failure, request cancellation).
        // Rejecting with `undefined` here turns into a non-Error rejection that
        // surfaces as the cryptic "Uncaught (in promise) <minified-token>"
        // console error (ZX-15035).
        .catch((error)=>Promise.reject(error?.response ?? error)), [
        apiUrl
    ]);
    const queryOptions = {
        ...options,
        ...(0, $397b4344a6629882$export$3518a77cc76c909)
    };
    const queryInfo = (0, $44ac4c87cce0b07f$export$dd0a697e1782aedd)([
        url,
        queryParams
    ], queryFn, queryOptions);
    const cleanedData = (0, $70fFQ.useMemo)(()=>{
        // JSON API data
        if (queryInfo.data?.data) return (0, $397b4344a6629882$export$4d4d4fb2de83c9b8)(queryInfo.data);
        // HD API data
        return queryInfo.data;
    }, [
        queryInfo.data
    ]);
    return (0, $70fFQ.useMemo)(()=>({
            ...queryInfo,
            cleanedData: cleanedData
        }), [
        queryInfo,
        cleanedData
    ]);
};
var $3b38c5c0bd1105aa$export$2e2bcd8739ae039 = $3b38c5c0bd1105aa$var$useFetch;






var $70fFQ = parcelRequire("70fFQ");




/**
 * Wrapper around `useMutation` for POST request
 * https://tanstack.com/query/v4/docs/reference/useMutation
 *
 * @param {string} url
 * @returns {Array} see useMutation documentation for return values.
 */ const $6928fa22999a8502$var$useWrite = (url, usePut = false, config = {})=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const apiUrl = `${url}`;
    const queryClient = (0, $7e71e0df4024a5cb$export$22e77b9572c4fded)();
    const axiosFn = usePut ? (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).put : (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post;
    const mutationFn = (0, $70fFQ.useCallback)((data)=>{
        if ((0, $397b4344a6629882$export$47203b4e8b42864c)(data)) {
            const formData = (0, $397b4344a6629882$export$9e33b233a1fdb104)(data);
            // cannot stringify a FormData object as it will return empty object
            return axiosFn(apiUrl, formData);
        } else return axiosFn(apiUrl, JSON.stringify(data));
    }, [
        apiUrl,
        axiosFn
    ]);
    const mutation = (0, $4590a457b11e610e$export$609860bf8b0084c)({
        mutationFn: mutationFn,
        onSuccess: ()=>{
            // Invalidate and refetch
            queryClient.invalidateQueries({
                queryKey: [
                    url
                ]
            });
            if (config?.invalidateUrls) // Useful for invalidating LIST endpoint calls when a PUT request is made to a related
            // DETAIL route.
            config.invalidateUrls.forEach(({ url: otherUrl, queryParams: queryParams })=>queryClient.invalidateQueries({
                    queryKey: [
                        otherUrl,
                        queryParams
                    ]
                }));
            if (!config?.silent) {
                if (config?.message) dispatch({
                    type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                    message: config.message
                });
                else dispatch({
                    type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                    message: `Successfully ${usePut ? "updated" : "created"}`
                });
            }
        },
        onError: ()=>{
            if (!config?.silent) dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                message: "Update failed, please check your information and try again"
            });
        }
    });
    return mutation;
};
var $6928fa22999a8502$export$2e2bcd8739ae039 = $6928fa22999a8502$var$useWrite;


const $824379ba34d9601c$export$a0f1f42f3a69f6b = {
    INFORMATIONAL: "INFORMATIONAL",
    PROBLEM: "PROBLEM",
    WARNING: "WARNING",
    REWARD: "REWARD"
};


const $79e8bb15bdb007b5$var$AgreementContext = /*#__PURE__*/ (0, $70fFQ.createContext)(null);
/**
 * This AgreementProvider component wraps all routes in HD to provide agreement-related operations.
 *
 * Checks for updated agreement files, and dispatches actions to show banners notifying
 * the user about the updates in the agreements. Users can interact with
 * these banners, specifically closing the banners will sign the agreement file
 *
 * @param {React.Component} children - the child components to render
 * @returns {React.Element}
 */ const $79e8bb15bdb007b5$var$AgreementProvider = ({ children: children })=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const { user: user } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const signAgreement = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SIGN_AGREEMENT(), false, {
        silent: true
    });
    const agreementQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).UPDATED_AGREEMENT_FILES(), {}, {
        enabled: !!user
    });
    const agreements = agreementQuery.cleanedData;
    const onClose = (agreement)=>{
        signAgreement.mutate({
            agreement_type: agreement.agreement_type
        });
    };
    (0, $70fFQ.useEffect)(()=>{
        if (!Array.isArray(agreements)) return;
        agreements.forEach((agreement)=>{
            dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addBanner,
                banner: {
                    id: agreement.id,
                    color: (0, $824379ba34d9601c$export$a0f1f42f3a69f6b).INFORMATIONAL,
                    message: `We have updated our ${agreement.agreement_type}, which governs your use of ZXData. By using this website and ZXData, you are agreeing to our updated ${agreement.agreement_type}.`,
                    onClose: ()=>onClose(agreement)
                }
            });
        });
    }, [
        agreements
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($79e8bb15bdb007b5$var$AgreementContext.Provider, {
        value: {
            agreements: agreements
        },
        children: children
    });
};
$79e8bb15bdb007b5$var$AgreementProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired
};
var $79e8bb15bdb007b5$export$2e2bcd8739ae039 = $79e8bb15bdb007b5$var$AgreementProvider;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");







var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");



var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





const $2579cfa538529ea8$export$81761b52b04ea573 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
const $2579cfa538529ea8$export$c1cdecccab05cfc8 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).form`
  padding: 0px 16px;
`;
const $2579cfa538529ea8$export$635d1b58476adfbe = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;






var $70fFQ = parcelRequire("70fFQ");

/**
 * Hook helper to implement logic shared between useAnchoredMenu and useDropdown
 */ const $c44912cad4a16fe0$var$useDropdownContext = (element, ref, toggle, config)=>{
    const [id] = (0, $70fFQ.useState)(config.id || String(Math.random()));
    const [previousElement, setPreviousElement] = (0, $70fFQ.useState)(element);
    const { state: { registeredDropdowns: registeredDropdowns }, dispatch: dispatch } = (0, $70fFQ.useContext)((0, $46a097389bbbbe65$export$7feebea0001a7c34));
    (0, $70fFQ.useEffect)(()=>{
        if (element && !previousElement) {
            setPreviousElement(()=>element);
            dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).toggleDropdown,
                id: id
            });
            Object.keys(registeredDropdowns).forEach((dropdown)=>{
                // Toggles off the other registered dropdowns.
                if (dropdown !== id && registeredDropdowns[dropdown][1]) registeredDropdowns[dropdown][0]();
            });
        } else if (!element && previousElement) {
            setPreviousElement(()=>element);
            dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).toggleDropdown,
                id: id
            });
        }
    }, [
        dispatch,
        element,
        previousElement,
        id,
        registeredDropdowns
    ]);
    (0, $70fFQ.useEffect)(()=>{
        // Register the anchoredMenu on mount. Note that these are included in the same global
        // context as dropdowns.
        dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).registerDropdown,
            id: id,
            toggleDropdown: toggle
        });
        return ()=>{
            dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).unregisterDropdown,
                id: id
            });
        };
    }, [
        dispatch,
        toggle,
        id
    ]);
    return [
        element,
        ref,
        toggle
    ];
};
var $c44912cad4a16fe0$export$2e2bcd8739ae039 = $c44912cad4a16fe0$var$useDropdownContext;


/**
 * Utility that mimics the interface for Yuka's useDropdown hook, but behind the scenes registers
 * the dropdown function with the global state manager so that it can be toggled on and off
 * when hotkeys are used throughout the site.
 *
 * @param renderContents - a render prop for the contents of the dropdown
 * @param userConfig - Config object for dropdown options.
 *   - defaultAbove - prefer above
 *   - orientation - position vertically overlapping an element or horizontally
 *   if enough space is available
 */ const $ecfedd356bff7c39$var$useDropdown = (renderContents, userConfig = {})=>{
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(renderContents, userConfig);
    return (0, $c44912cad4a16fe0$export$2e2bcd8739ae039)(dropdownElement, dropdownRef, toggleDropdown, userConfig);
};
var $ecfedd356bff7c39$export$2e2bcd8739ae039 = $ecfedd356bff7c39$var$useDropdown;




/**
 * Utility that mimics the interface for Yuka's useAnchoredMenu hook, but behind the scenes
 * registers the toggle function with the global state manager so that it can be toggled on and off
 * when hotkeys are used throughout the site.
 *
 * @param menuConfig - Config object for menu options that will be forwarded to
 *    Yuka's useAnchoredMenu.
 */ const $199c364f599190d4$var$useAnchoredMenu = (menuConfig)=>{
    const [menuElement, menuRef, toggleMenu] = (0, $dfd33cee3229493c$exports.useAnchoredMenu)(menuConfig);
    return (0, $c44912cad4a16fe0$export$2e2bcd8739ae039)(menuElement, menuRef, toggleMenu, menuConfig);
};
var $199c364f599190d4$export$2e2bcd8739ae039 = $199c364f599190d4$var$useAnchoredMenu;




var $70fFQ = parcelRequire("70fFQ");



var $cd0Jr = parcelRequire("cd0Jr");
/**
 * Component to mimic the interface with Yuka's Input component, but with the added knowledge
 * of our hotkey system.
 */ const $a3cb2c0ab9bbfa1d$var$Input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ autoFocus: autoFocus, ...props }, ref)=>{
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const actualRef = (0, $70fFQ.useMemo)(()=>ref || internalRef, [
        ref,
        internalRef
    ]);
    const { dispatch: dispatch } = (0, $70fFQ.useContext)((0, $46a097389bbbbe65$export$7feebea0001a7c34));
    const handleFocus = (0, $70fFQ.useCallback)(()=>dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).disableHotkeys
        }), [
        dispatch
    ]);
    const handleBlur = (0, $70fFQ.useCallback)(()=>dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).enableHotkeys
        }), [
        dispatch
    ]);
    // Prevents propagation of hotkey keydown events.
    (0, $70fFQ.useEffect)(()=>{
        const current = actualRef.current;
        if (current) {
            current.addEventListener("focus", handleFocus);
            current.addEventListener("blur", handleBlur);
        }
        return ()=>{
            if (current) {
                current.removeEventListener("focus", handleFocus);
                current.removeEventListener("blur", handleBlur);
            }
        };
    }, [
        handleFocus,
        handleBlur,
        actualRef
    ]);
    // ORDER OF THESE useEffects IS IMPORTANT; this one must follow the event listener one so that
    // the focus element handler is set before the .focus() call is triggered.
    (0, $70fFQ.useEffect)(()=>{
        if (autoFocus && actualRef.current) actualRef.current.focus();
    }, [
        actualRef,
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Input), {
        ...props,
        ref: actualRef
    });
});
$a3cb2c0ab9bbfa1d$var$Input.propTypes = {
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
$a3cb2c0ab9bbfa1d$var$Input.defaultProps = {
    autoFocus: false
};
$a3cb2c0ab9bbfa1d$var$Input.displayName = "Input";
var $a3cb2c0ab9bbfa1d$export$2e2bcd8739ae039 = $a3cb2c0ab9bbfa1d$var$Input;




var $70fFQ = parcelRequire("70fFQ");


var $cd0Jr = parcelRequire("cd0Jr");

/**
 * Component to mimic the interface with Yuka's Field component, but with the added
 * knowledge of our hotkey system.
 */ const $5dd9c98298e24b6e$var$Field = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ autoFocus: autoFocus, ...props }, ref)=>{
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const actualRef = (0, $70fFQ.useMemo)(()=>ref || internalRef, [
        ref,
        internalRef
    ]);
    const { dispatch: dispatch } = (0, $70fFQ.useContext)((0, $46a097389bbbbe65$export$7feebea0001a7c34));
    const handleFocus = (0, $70fFQ.useCallback)(()=>dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).disableHotkeys
        }), [
        dispatch
    ]);
    const handleBlur = (0, $70fFQ.useCallback)(()=>dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).enableHotkeys
        }), [
        dispatch
    ]);
    // Prevents propagation of hotkey keydown events.
    (0, $70fFQ.useEffect)(()=>{
        // Need to check .current.ref.current first in the case of type="number" fields.
        const current = actualRef.current?.ref?.current || actualRef.current;
        if (current) {
            current.addEventListener("focus", handleFocus);
            current.addEventListener("blur", handleBlur);
        }
        return ()=>{
            if (current) {
                current.removeEventListener("focus", handleFocus);
                current.removeEventListener("blur", handleBlur);
            }
        };
    }, [
        handleFocus,
        handleBlur,
        actualRef
    ]);
    // ORDER OF THESE useEffects IS IMPORTANT; this one must follow the event listener one so that
    // the focus element handler is set before the .focus() call is triggered.
    (0, $70fFQ.useEffect)(()=>{
        if (autoFocus && actualRef.current) actualRef.current.focus();
    }, [
        actualRef,
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Field), {
        ...props,
        ref: actualRef
    });
});
$5dd9c98298e24b6e$var$Field.propTypes = {
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
$5dd9c98298e24b6e$var$Field.defaultProps = {
    autoFocus: false
};
$5dd9c98298e24b6e$var$Field.displayName = "Field";
var $5dd9c98298e24b6e$export$2e2bcd8739ae039 = $5dd9c98298e24b6e$var$Field;




var $70fFQ = parcelRequire("70fFQ");



var $cd0Jr = parcelRequire("cd0Jr");
/**
 * Component to mimic the interface with Yuka's FinalFormField component, but with the added
 * knowledge of our hotkey system.
 */ const $ce413dbcef8c4e6e$var$FinalFormField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ autoFocus: autoFocus, ...props }, ref)=>{
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const actualRef = (0, $70fFQ.useMemo)(()=>ref || internalRef, [
        ref,
        internalRef
    ]);
    const { dispatch: dispatch } = (0, $70fFQ.useContext)((0, $46a097389bbbbe65$export$7feebea0001a7c34));
    const handleFocus = (0, $70fFQ.useCallback)(()=>dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).disableHotkeys
        }), [
        dispatch
    ]);
    const handleBlur = (0, $70fFQ.useCallback)(()=>dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).enableHotkeys
        }), [
        dispatch
    ]);
    // Prevents propagation of hotkey keydown events.
    (0, $70fFQ.useEffect)(()=>{
        const current = actualRef.current;
        if (current) {
            current.addEventListener("focus", handleFocus);
            current.addEventListener("blur", handleBlur);
        }
        return ()=>{
            if (current) {
                current.removeEventListener("focus", handleFocus);
                current.removeEventListener("blur", handleBlur);
            }
        };
    }, [
        handleFocus,
        handleBlur,
        actualRef
    ]);
    // ORDER OF THESE useEffects IS IMPORTANT; this one must follow the event listener one so that
    // the focus element handler is set before the .focus() call is triggered.
    (0, $70fFQ.useEffect)(()=>{
        if (autoFocus && actualRef.current) actualRef.current.focus();
    }, [
        actualRef,
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
        ...props,
        ref: actualRef
    });
});
$ce413dbcef8c4e6e$var$FinalFormField.propTypes = {
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
$ce413dbcef8c4e6e$var$FinalFormField.defaultProps = {
    autoFocus: false
};
$ce413dbcef8c4e6e$var$FinalFormField.displayName = "FinalFormField";
var $ce413dbcef8c4e6e$export$2e2bcd8739ae039 = $ce413dbcef8c4e6e$var$FinalFormField;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");


const $f82caaae0faa7ac9$var$StyledThumbnailPlaceholderContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: ${(props)=>props.$width}px;
  height: ${(props)=>props.$height}px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props)=>props.$background && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      background: ${props.$background};
    `}
  border-radius: 6px;
`;
/**
 * A simple component that wraps a Yuka icon in a grey box. Typically used as a placeholder for a
 * company/security logo, or just as a more visible icon.
 *
 * @param icon
 * @return {JSX.Element}
 */ const $f82caaae0faa7ac9$var$RoundedSquareIcon = ({ icon: Icon, color: color, containerSize: containerSize, iconSize: iconSize, backgroundColor: backgroundColor, className: className })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f82caaae0faa7ac9$var$StyledThumbnailPlaceholderContainer, {
        className: className,
        $width: containerSize,
        $height: containerSize,
        $background: backgroundColor,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Icon, {
            size: iconSize,
            color: color
        })
    });
$f82caaae0faa7ac9$var$RoundedSquareIcon.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    containerSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    iconSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).elementType,
    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
$f82caaae0faa7ac9$var$RoundedSquareIcon.defaultProps = {
    className: "",
    containerSize: 24,
    iconSize: 18,
    icon: (0, $dfd33cee3229493c$exports.BuildingIcon),
    backgroundColor: (0, $dfd33cee3229493c$exports.ColorPalette).white50,
    color: (0, $dfd33cee3229493c$exports.ColorPalette).black50
};
var $f82caaae0faa7ac9$export$2e2bcd8739ae039 = $f82caaae0faa7ac9$var$RoundedSquareIcon;


const $00de0ec5a3f2db13$var$StyledActionButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50).attrs({
    as: "div"
})`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 8px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 24px;

  ${({ $disabled: $disabled })=>{
    if ($disabled) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        ${(0, $dfd33cee3229493c$exports.FontColors).theme30}
        cursor: unset;

        > :first-child {
          background: ${(0, $dfd33cee3229493c$exports.ColorPalette).white10};
        }

        svg path {
          fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
        }
      `;
    return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      > :first-child {
        background: ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
      }

      svg path {
        fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white50};
      }

      &&:hover {
        ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
        > :first-child {
          background: ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
        }
        svg path {
          fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white80};
        }
      }

      &&:active {
        ${(0, $dfd33cee3229493c$exports.FontColors).theme100}
        > :first-child {
          background: rgba(255, 255, 255, 0.2);
        }
        svg path {
          fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white100};
        }
      }

      // Allow users to programmatically force the active state.
      ${(props)=>props.$active && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          ${(0, $dfd33cee3229493c$exports.FontColors).theme100}
          > :first-child {
            background: rgba(255, 255, 255, 0.2);
          }
          svg path {
            fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white100};
          }
        `}
    `;
}}
`;
const $00de0ec5a3f2db13$var$ActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ icon: icon, onClick: onClick, children: children, active: active, disabled: disabled, className: className, id: id }, ref)=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($00de0ec5a3f2db13$var$StyledActionButton, {
        id: id,
        $disabled: disabled,
        $active: active,
        role: "button",
        onClick: disabled ? null : onClick,
        className: className,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f82caaae0faa7ac9$export$2e2bcd8739ae039), {
                containerSize: 20,
                iconSize: 14,
                icon: icon
            }),
            children
        ]
    });
});
$00de0ec5a3f2db13$var$ActionButton.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).elementType.isRequired
};
var $00de0ec5a3f2db13$export$2e2bcd8739ae039 = $00de0ec5a3f2db13$var$ActionButton;




var $cd0Jr = parcelRequire("cd0Jr");


const $c4c73d5d1e08d057$var$StyledCard = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Card))`
  border: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white30};

  &:hover {
    ${(props)=>props.onClick && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
      `}
  }

  &:active {
    ${(props)=>props.onClick && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        border: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white50};
        background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
      `}
  }
`;
const $c4c73d5d1e08d057$var$SurfaceZeroCard = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            surfaceLevel: -1
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($c4c73d5d1e08d057$var$StyledCard, {
            ...props,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
                theme: {
                    surfaceLevel: 1
                },
                children: children
            })
        })
    });
};
$c4c73d5d1e08d057$var$SurfaceZeroCard.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node
};
var $c4c73d5d1e08d057$export$2e2bcd8739ae039 = $c4c73d5d1e08d057$var$SurfaceZeroCard;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");


/* eslint-disable react/prop-types */ 
/**
 * Our custom ListItem component needs both functions but they are meant to be for internal
 * use in yuka, so they aren't exported. We need to copy them here to use them.
 */ const $5340a4df2779fa80$export$7c41e2bb5faad6c4 = {
    // add missing type="button" to button links
    // to prevent form submission in case they are used inside a form
    // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#notes
    BUTTON: ()=>({
            type: "button"
        }),
    DOWNLOAD: (url)=>({
            href: url,
            download: true,
            rel: "noreferrer noopener",
            target: "_blank"
        }),
    LOCAL_LINK: (url)=>({
            to: url
        }),
    EXTERNAL_LINK: (url)=>({
            href: url,
            rel: "noreferrer noopener",
            target: "_blank"
        }),
    LINK: (url)=>({
            href: url
        })
};
/**
 *
 * A text link element with helpers to ensure attributes and navigation behaves as desired.
 *
 * Provides a backwards compatible interface with the legacy element with warnings. This can be
 * expected to be removed in a future release
 *
 * url - This prop is a string that is a valid href or a string/object that react-router can parse.
 *   This results in either an `<a>` tag or a `<Link>` being rendered.
 *
 * Either url, to, or href must be specified for `target`, `rel`, or `download` attributes to be applied
 *
 * LinkTypes guideline:
 * - `BUTTON` - when no navigation is performed but need a text link visually
 * - `DOWNLOAD` - when the link is directly to a document to be downloaded
 * - `LOCAL_LINK` - the link navigates within a SPA
 * - `EXTERNAL_LINK` - the link navigates away from the environment, opens in a new tab
 * - `LINK` - a traditional `<a>` tag without any special behaviors
 *
 * @param {string} url - The URL we are linking to if applicable
 * @param {function} linkType - One of LinkTypes
 *
 * @returns {Array}
 *   - computedLinkProps {object} - set of props to pass into the rendered link component
 *   - renderAs {string|function} - the component to render the link as
 *     either an "a", "button", or Link
 */ const $5340a4df2779fa80$var$getLinkProps = (url, _linkType)=>{
    const linkType = _linkType ?? (url ? $5340a4df2779fa80$export$7c41e2bb5faad6c4.LINK : $5340a4df2779fa80$export$7c41e2bb5faad6c4.BUTTON);
    let computedLinkProps = linkType?.(url);
    let renderAs = "a";
    if (!computedLinkProps) {
        if (url) computedLinkProps = $5340a4df2779fa80$export$7c41e2bb5faad6c4.LINK(url);
        else computedLinkProps = $5340a4df2779fa80$export$7c41e2bb5faad6c4.BUTTON();
    }
    // Compute which base element to use to render
    if (linkType == $5340a4df2779fa80$export$7c41e2bb5faad6c4.LOCAL_LINK) renderAs = (0, $ff1ed43a67e50aba$export$a6c7ac8248d6e38a);
    else if (linkType == $5340a4df2779fa80$export$7c41e2bb5faad6c4.BUTTON) renderAs = "button";
    return [
        computedLinkProps,
        renderAs
    ];
};
var $5340a4df2779fa80$export$2e2bcd8739ae039 = $5340a4df2779fa80$var$getLinkProps;


const $bc98d6e7d0ab4f53$var$StyledText = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.body1)}
  flex-grow: 1;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $bc98d6e7d0ab4f53$var$StyledSubtext = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.caption2)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  margin-top: 4px;
  flex-grow: 1;
  ${(props)=>props.$wrap ? `
      white-space: wrap;
    ` : `
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;
const $bc98d6e7d0ab4f53$var$StyledAfterText = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin-left: 24px;
  line-height: 1;
`;
const $bc98d6e7d0ab4f53$var$StyledTextWrapper = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  ${(props)=>props.$wrap ? `
    margin: 12px 0;
  ` : `
    margin: 14px 0;
  `}
  flex-grow: 1;
  min-width: 0;
`;
const $bc98d6e7d0ab4f53$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).li`
  // normalizing buttons
  background: transparent;
  outline: none;
  border: none;
  color: inherit;
  text-align: left;
  letter-spacing: inherit;
  list-style: none;
  font-size: inherit;
  font-family: inherit;
  margin: 0;
  line-height: inherit;
  width: 100%;

  flex-shrink: 0;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  min-width: 200px;
  min-height: 48px;
  padding: 0 16px;
  ${(props)=>props.onClick || props.href ? `
    cursor: pointer;
    &:hover {
      background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).hoverTransparent};
    }
    &:active {
      background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).activeTransparent};
    }
  ` : ""}
`;
const $bc98d6e7d0ab4f53$var$SingleLineListItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bc98d6e7d0ab4f53$var$StyledListItem, {
        as: props.as,
        ...props.linkProps,
        ref: ref,
        className: props.className,
        onClick: props.onClick,
        role: props.role,
        children: [
            props.leadingContent,
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledText, {
                children: props.text
            }),
            props.trailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledAfterText, {
                children: props.trailingContent
            })
        ]
    }));
const $bc98d6e7d0ab4f53$var$TwoLineListItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bc98d6e7d0ab4f53$var$StyledListItem, {
        as: props.as,
        ...props.linkProps,
        ref: ref,
        className: props.className,
        onClick: props.onClick,
        role: props.role,
        children: [
            props.leadingContent,
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bc98d6e7d0ab4f53$var$StyledTextWrapper, {
                $wrap: false,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledText, {
                        children: props.text
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledSubtext, {
                        $wrap: false,
                        children: props.subtext
                    })
                ]
            }),
            props.trailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledAfterText, {
                children: props.trailingContent
            })
        ]
    }));
const $bc98d6e7d0ab4f53$var$ThreeLineListItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bc98d6e7d0ab4f53$var$StyledListItem, {
        as: props.as,
        ...props.linkProps,
        ref: ref,
        className: props.className,
        onClick: props.onClick,
        role: props.role,
        children: [
            props.leadingContent,
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bc98d6e7d0ab4f53$var$StyledTextWrapper, {
                $wrap: true,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledText, {
                        children: props.text
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledSubtext, {
                        $wrap: true,
                        children: props.subtext
                    })
                ]
            }),
            props.trailingContent && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc98d6e7d0ab4f53$var$StyledAfterText, {
                children: props.trailingContent
            })
        ]
    }));
const $bc98d6e7d0ab4f53$export$e38ab7727d17117c = {
    SINGLE_LINE: "SINGLE_LINE",
    TWO_LINE: "TWO_LINE",
    THREE_LINE: "THREE_LINE"
};
/**
 * Copy pasted from yuka/ListItem
 *
 * The only difference is that the leading icon now accepts any styled component,
 * where in yuka it only supports either an Icon or an Avatar.
 *
 * The assumption is that the leading content will have it's own styling rather than have
 * margin and size styling hard coded into the component.
 */ const $bc98d6e7d0ab4f53$export$7b497e9b71607d44 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, ref)=>{
    let StyledElement;
    switch(props.listStyle){
        case $bc98d6e7d0ab4f53$export$e38ab7727d17117c.SINGLE_LINE:
            StyledElement = $bc98d6e7d0ab4f53$var$SingleLineListItem;
            break;
        case $bc98d6e7d0ab4f53$export$e38ab7727d17117c.TWO_LINE:
            StyledElement = $bc98d6e7d0ab4f53$var$TwoLineListItem;
            break;
        case $bc98d6e7d0ab4f53$export$e38ab7727d17117c.THREE_LINE:
            StyledElement = $bc98d6e7d0ab4f53$var$ThreeLineListItem;
            break;
    }
    let [linkProps, linkAs] = (0, $5340a4df2779fa80$export$2e2bcd8739ae039)(props.url, props.linkType);
    if (!props.url && !props.onClick) {
        linkAs = "li";
        // clear out link props as unneeded on a <li>
        linkProps = {};
    }
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(StyledElement, {
        ref: ref,
        as: linkAs,
        ...props,
        linkProps: linkProps
    });
});
$bc98d6e7d0ab4f53$export$7b497e9b71607d44.propTypes = {
    listStyle: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf(Object.values($bc98d6e7d0ab4f53$export$e38ab7727d17117c)),
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired,
    subtext: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node,
    leadingContent: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).element,
    avatar: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).element,
    trailingContent: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).element,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    linkType: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf(Object.values((0, $5340a4df2779fa80$export$7c41e2bb5faad6c4))),
    url: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
$bc98d6e7d0ab4f53$export$7b497e9b71607d44.defaultProps = {
    listStyle: $bc98d6e7d0ab4f53$export$e38ab7727d17117c.SINGLE_LINE,
    role: "listitem"
};
$bc98d6e7d0ab4f53$export$7b497e9b71607d44.displayName = "ListItem";
$bc98d6e7d0ab4f53$var$SingleLineListItem.propTypes = $bc98d6e7d0ab4f53$export$7b497e9b71607d44.propTypes;
$bc98d6e7d0ab4f53$var$TwoLineListItem.propTypes = $bc98d6e7d0ab4f53$export$7b497e9b71607d44.propTypes;
$bc98d6e7d0ab4f53$var$ThreeLineListItem.propTypes = $bc98d6e7d0ab4f53$export$7b497e9b71607d44.propTypes;
const $bc98d6e7d0ab4f53$var$WrappedListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)($bc98d6e7d0ab4f53$export$7b497e9b71607d44)``;
$bc98d6e7d0ab4f53$var$WrappedListItem.displayName = "StyledListItem";
var $bc98d6e7d0ab4f53$export$2e2bcd8739ae039 = $bc98d6e7d0ab4f53$var$WrappedListItem;




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");


const $cc46139b4b8262d4$var$StyledOption = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)}
  line-height: 14px;
  ${(props)=>props.$active ? (0, $dfd33cee3229493c$exports.FontColors).theme100 : (0, $dfd33cee3229493c$exports.FontColors).theme50}
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  height: 22px;
  padding-left: 4px;
  padding-right: 4px;
  white-space: nowrap;

  ${(props)=>props.$active ? `
    border-bottom: 2px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).blue400};
    ` : (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          &:hover {
            ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
          }
        `}

  ${(props)=>props.$disabled ? (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          color: ${(0, $dfd33cee3229493c$exports.PrimaryColorPalette).white30};
          border-bottom: none;
          cursor: unset;
          &:hover {
            ${(0, $dfd33cee3229493c$exports.FontColors).theme30}
          }
        ` : ""}
`;
const $cc46139b4b8262d4$var$OptionItem = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($cc46139b4b8262d4$var$StyledOption, {
        $active: props.selected,
        $disabled: props.disabled,
        onClick: !props.disabled ? props.handleOptionClick : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
        children: props.label
    });
$cc46139b4b8262d4$var$OptionItem.propTypes = {
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    handleOptionClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
$cc46139b4b8262d4$var$OptionItem.defaultProps = {
    selected: false,
    disabled: false
};
const $cc46139b4b8262d4$var$StyledOptionSelectList = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 24px;
`;
const $cc46139b4b8262d4$var$StyledTitle = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme80}

  ${(props)=>props.$disabled ? `
      color: ${(0, $dfd33cee3229493c$exports.PrimaryColorPalette).white30};
  ` : ""}
`;
/**
 * This component renders a list of selectable UI options with an optional default.
 */ const $cc46139b4b8262d4$var$OptionSelectList = (props)=>{
    const { options: options, onOptionChange: onOptionChange } = props;
    const [currentSelection, setCurrentSelection] = (0, $70fFQ.useState)(props.defaultOption);
    const handleOptionClick = (0, $70fFQ.useCallback)((name)=>{
        onOptionChange(name);
        setCurrentSelection(name);
    }, [
        onOptionChange
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($cc46139b4b8262d4$var$StyledOptionSelectList, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($cc46139b4b8262d4$var$StyledTitle, {
                $disabled: props.disabled,
                children: props.title
            }),
            options.map(({ label: label })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($cc46139b4b8262d4$var$OptionItem, {
                    selected: currentSelection === label,
                    handleOptionClick: ()=>handleOptionClick(label),
                    label: label,
                    disabled: props.disabled
                }, label))
        ]
    });
};
$cc46139b4b8262d4$var$OptionSelectList.propTypes = {
    onOptionChange: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    })),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    defaultOption: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
$cc46139b4b8262d4$var$OptionSelectList.defaultProps = {
    onOptionChange: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
    title: "",
    defaultOption: null,
    disabled: false
};
var $cc46139b4b8262d4$export$2e2bcd8739ae039 = $cc46139b4b8262d4$var$OptionSelectList;




var $70fFQ = parcelRequire("70fFQ");
// packages/react/context/src/createContext.tsx

var $70fFQ = parcelRequire("70fFQ");

function $dc4102e012c69f71$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $70fFQ.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $70fFQ.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $70fFQ.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $dc4102e012c69f71$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $70fFQ.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $70fFQ.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $70fFQ.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $70fFQ.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $70fFQ.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $dc4102e012c69f71$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $dc4102e012c69f71$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $70fFQ.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $70fFQ = parcelRequire("70fFQ");

// packages/react/compose-refs/src/composeRefs.tsx

var $70fFQ = parcelRequire("70fFQ");
function $340a4fddbb62b87d$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $340a4fddbb62b87d$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$340a4fddbb62b87d$var$setRef(ref, node));
}
function $340a4fddbb62b87d$export$c7b2cbe3552a0d05(...refs) {
    return $70fFQ.useCallback($340a4fddbb62b87d$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/slot/src/Slot.tsx

var $70fFQ = parcelRequire("70fFQ");


var $599afc0a2f7a8e8b$export$8c6ed5c666ac1360 = $70fFQ.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $70fFQ.Children.toArray(children);
    const slottable = childrenArray.find($599afc0a2f7a8e8b$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($70fFQ.Children.count(newElement) > 1) return $70fFQ.Children.only(null);
                return $70fFQ.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($599afc0a2f7a8e8b$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $70fFQ.isValidElement(newElement) ? $70fFQ.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($599afc0a2f7a8e8b$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$599afc0a2f7a8e8b$export$8c6ed5c666ac1360.displayName = "Slot";
var $599afc0a2f7a8e8b$var$SlotClone = $70fFQ.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($70fFQ.isValidElement(children)) {
        const childrenRef = $599afc0a2f7a8e8b$var$getElementRef(children);
        return $70fFQ.cloneElement(children, {
            ...$599afc0a2f7a8e8b$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $340a4fddbb62b87d$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $70fFQ.Children.count(children) > 1 ? $70fFQ.Children.only(null) : null;
});
$599afc0a2f7a8e8b$var$SlotClone.displayName = "SlotClone";
var $599afc0a2f7a8e8b$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $34ccb6660205eec8$exports.Fragment), {
        children: children
    });
};
function $599afc0a2f7a8e8b$var$isSlottable(child) {
    return $70fFQ.isValidElement(child) && child.type === $599afc0a2f7a8e8b$export$d9f1ccf0bdb05d45;
}
function $599afc0a2f7a8e8b$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $599afc0a2f7a8e8b$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $599afc0a2f7a8e8b$export$be92b6f5f03c0fe9 = $599afc0a2f7a8e8b$export$8c6ed5c666ac1360;



"use client";
function $b81b75be38786b8d$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $dc4102e012c69f71$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $340a4fddbb62b87d$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $599afc0a2f7a8e8b$export$8c6ed5c666ac1360), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
        const composedRefs = (0, $340a4fddbb62b87d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $599afc0a2f7a8e8b$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}



// packages/core/primitive/src/primitive.tsx
function $2b1d1568c3aa77ff$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $70fFQ = parcelRequire("70fFQ");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $70fFQ = parcelRequire("70fFQ");
function $a9c72f1ec6f2b1fb$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $70fFQ.useRef(callback);
    $70fFQ.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $70fFQ.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $225008a49d12b126$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $225008a49d12b126$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $a9c72f1ec6f2b1fb$export$25bec8c6f54ee79a)(onChange);
    const setValue = $70fFQ.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $225008a49d12b126$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $70fFQ.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $70fFQ.useRef(value);
    const handleChange = (0, $a9c72f1ec6f2b1fb$export$25bec8c6f54ee79a)(onChange);
    $70fFQ.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/primitive/src/Primitive.tsx

var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");


var $3e19f80aa8b65600$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $3e19f80aa8b65600$export$250ffa63cdc0d034 = $3e19f80aa8b65600$var$NODES.reduce((primitive, node)=>{
    const Node = $70fFQ.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $599afc0a2f7a8e8b$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $3e19f80aa8b65600$export$6d1a0317bde7de7f(target, event) {
    if (target) $3glZ1.flushSync(()=>target.dispatchEvent(event));
}
var $3e19f80aa8b65600$export$be92b6f5f03c0fe9 = $3e19f80aa8b65600$export$250ffa63cdc0d034;



var $70fFQ = parcelRequire("70fFQ");



// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $70fFQ = parcelRequire("70fFQ");
var $d247b1e73e8ac4cf$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $70fFQ.useLayoutEffect : ()=>{};





var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");


"use client";
function $6091e2707bc1c69b$var$useStateMachine(initialState, machine) {
    return $70fFQ.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $6091e2707bc1c69b$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $6091e2707bc1c69b$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $70fFQ.Children.only(children);
    const ref = (0, $340a4fddbb62b87d$export$c7b2cbe3552a0d05)(presence.ref, $6091e2707bc1c69b$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $70fFQ.cloneElement(child, {
        ref: ref
    }) : null;
};
$6091e2707bc1c69b$export$99c2b779aa4e8b8b.displayName = "Presence";
function $6091e2707bc1c69b$var$usePresence(present) {
    const [node, setNode] = $70fFQ.useState();
    const stylesRef = $70fFQ.useRef({});
    const prevPresentRef = $70fFQ.useRef(present);
    const prevAnimationNameRef = $70fFQ.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $6091e2707bc1c69b$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $70fFQ.useEffect(()=>{
        const currentAnimationName = $6091e2707bc1c69b$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $d247b1e73e8ac4cf$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $6091e2707bc1c69b$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $d247b1e73e8ac4cf$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $6091e2707bc1c69b$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) $3glZ1.flushSync(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $6091e2707bc1c69b$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $70fFQ.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $6091e2707bc1c69b$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $6091e2707bc1c69b$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}


// packages/react/id/src/id.tsx

var $70fFQ = parcelRequire("70fFQ");

var $0bbfe31e6436b889$var$useReactId = $70fFQ["useId".toString()] || (()=>void 0);
var $0bbfe31e6436b889$var$count = 0;
function $0bbfe31e6436b889$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $70fFQ.useState($0bbfe31e6436b889$var$useReactId());
    (0, $d247b1e73e8ac4cf$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($0bbfe31e6436b889$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



"use client";
var $7ae692a808bf9638$var$COLLAPSIBLE_NAME = "Collapsible";
var [$7ae692a808bf9638$var$createCollapsibleContext, $7ae692a808bf9638$export$952b32dcbe73087a] = (0, $dc4102e012c69f71$export$50c7b4e9d9f19c1)($7ae692a808bf9638$var$COLLAPSIBLE_NAME);
var [$7ae692a808bf9638$var$CollapsibleProvider, $7ae692a808bf9638$var$useCollapsibleContext] = $7ae692a808bf9638$var$createCollapsibleContext($7ae692a808bf9638$var$COLLAPSIBLE_NAME);
var $7ae692a808bf9638$export$6eb0f7ddcda6131f = $70fFQ.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, open: openProp, defaultOpen: defaultOpen, disabled: disabled, onOpenChange: onOpenChange, ...collapsibleProps } = props;
    const [open = false, setOpen] = (0, $225008a49d12b126$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($7ae692a808bf9638$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: (0, $0bbfe31e6436b889$export$f680877a34711e37)(),
        open: open,
        onOpenToggle: $70fFQ.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $3e19f80aa8b65600$export$250ffa63cdc0d034).div, {
            "data-state": $7ae692a808bf9638$var$getState(open),
            "data-disabled": disabled ? "" : void 0,
            ...collapsibleProps,
            ref: forwardedRef
        })
    });
});
$7ae692a808bf9638$export$6eb0f7ddcda6131f.displayName = $7ae692a808bf9638$var$COLLAPSIBLE_NAME;
var $7ae692a808bf9638$var$TRIGGER_NAME = "CollapsibleTrigger";
var $7ae692a808bf9638$export$c135dce7b15bbbdc = $70fFQ.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, ...triggerProps } = props;
    const context = $7ae692a808bf9638$var$useCollapsibleContext($7ae692a808bf9638$var$TRIGGER_NAME, __scopeCollapsible);
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $3e19f80aa8b65600$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $7ae692a808bf9638$var$getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled,
        ...triggerProps,
        ref: forwardedRef,
        onClick: (0, $2b1d1568c3aa77ff$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$7ae692a808bf9638$export$c135dce7b15bbbdc.displayName = $7ae692a808bf9638$var$TRIGGER_NAME;
var $7ae692a808bf9638$var$CONTENT_NAME = "CollapsibleContent";
var $7ae692a808bf9638$export$aadde00976f34151 = $70fFQ.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...contentProps } = props;
    const context = $7ae692a808bf9638$var$useCollapsibleContext($7ae692a808bf9638$var$CONTENT_NAME, props.__scopeCollapsible);
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $6091e2707bc1c69b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: ({ present: present })=>/* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($7ae692a808bf9638$var$CollapsibleContentImpl, {
                ...contentProps,
                ref: forwardedRef,
                present: present
            })
    });
});
$7ae692a808bf9638$export$aadde00976f34151.displayName = $7ae692a808bf9638$var$CONTENT_NAME;
var $7ae692a808bf9638$var$CollapsibleContentImpl = $70fFQ.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, present: present, children: children, ...contentProps } = props;
    const context = $7ae692a808bf9638$var$useCollapsibleContext($7ae692a808bf9638$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = $70fFQ.useState(present);
    const ref = $70fFQ.useRef(null);
    const composedRefs = (0, $340a4fddbb62b87d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const heightRef = $70fFQ.useRef(0);
    const height = heightRef.current;
    const widthRef = $70fFQ.useRef(0);
    const width = widthRef.current;
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = $70fFQ.useRef(isOpen);
    const originalStylesRef = $70fFQ.useRef();
    $70fFQ.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, $d247b1e73e8ac4cf$export$e5c5a5f917a5871c)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            };
            node.style.transitionDuration = "0s";
            node.style.animationName = "none";
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width;
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    }, [
        context.open,
        present
    ]);
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $3e19f80aa8b65600$export$250ffa63cdc0d034).div, {
        "data-state": $7ae692a808bf9638$var$getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        id: context.contentId,
        hidden: !isOpen,
        ...contentProps,
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
            ...props.style
        },
        children: isOpen && children
    });
});
function $7ae692a808bf9638$var$getState(open) {
    return open ? "open" : "closed";
}
var $7ae692a808bf9638$export$be92b6f5f03c0fe9 = $7ae692a808bf9638$export$6eb0f7ddcda6131f;
var $7ae692a808bf9638$export$41fb9f06171c75f4 = $7ae692a808bf9638$export$c135dce7b15bbbdc;
var $7ae692a808bf9638$export$7c6e2c02157bb7d2 = $7ae692a808bf9638$export$aadde00976f34151;



// packages/react/direction/src/Direction.tsx

var $70fFQ = parcelRequire("70fFQ");

var $f6d2792e625c1ee3$var$DirectionContext = $70fFQ.createContext(void 0);
var $f6d2792e625c1ee3$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($f6d2792e625c1ee3$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $f6d2792e625c1ee3$export$b39126d51d94e6f3(localDir) {
    const globalDir = $70fFQ.useContext($f6d2792e625c1ee3$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $f6d2792e625c1ee3$export$2881499e37b75b9a = $f6d2792e625c1ee3$export$c760c09fdd558351;



"use client";
var $9380d202ffb94ee4$var$ACCORDION_NAME = "Accordion";
var $9380d202ffb94ee4$var$ACCORDION_KEYS = [
    "Home",
    "End",
    "ArrowDown",
    "ArrowUp",
    "ArrowLeft",
    "ArrowRight"
];
var [$9380d202ffb94ee4$var$Collection, $9380d202ffb94ee4$var$useCollection, $9380d202ffb94ee4$var$createCollectionScope] = (0, $b81b75be38786b8d$export$c74125a8e3af6bb2)($9380d202ffb94ee4$var$ACCORDION_NAME);
var [$9380d202ffb94ee4$var$createAccordionContext, $9380d202ffb94ee4$export$9748edc328a73be1] = (0, $dc4102e012c69f71$export$50c7b4e9d9f19c1)($9380d202ffb94ee4$var$ACCORDION_NAME, [
    $9380d202ffb94ee4$var$createCollectionScope,
    (0, $7ae692a808bf9638$export$952b32dcbe73087a)
]);
var $9380d202ffb94ee4$var$useCollapsibleScope = (0, $7ae692a808bf9638$export$952b32dcbe73087a)();
var $9380d202ffb94ee4$export$a766cd26d0d69044 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { type: type, ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$Collection.Provider, {
        scope: props.__scopeAccordion,
        children: type === "multiple" ? /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionImplMultiple, {
            ...multipleProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionImplSingle, {
            ...singleProps,
            ref: forwardedRef
        })
    });
});
$9380d202ffb94ee4$export$a766cd26d0d69044.displayName = $9380d202ffb94ee4$var$ACCORDION_NAME;
var [$9380d202ffb94ee4$var$AccordionValueProvider, $9380d202ffb94ee4$var$useAccordionValueContext] = $9380d202ffb94ee4$var$createAccordionContext($9380d202ffb94ee4$var$ACCORDION_NAME);
var [$9380d202ffb94ee4$var$AccordionCollapsibleProvider, $9380d202ffb94ee4$var$useAccordionCollapsibleContext] = $9380d202ffb94ee4$var$createAccordionContext($9380d202ffb94ee4$var$ACCORDION_NAME, {
    collapsible: false
});
var $9380d202ffb94ee4$var$AccordionImplSingle = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, collapsible: collapsible = false, ...accordionSingleProps } = props;
    const [value, setValue] = (0, $225008a49d12b126$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value ? [
            value
        ] : [],
        onItemOpen: setValue,
        onItemClose: (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback(()=>collapsible && setValue(""), [
            collapsible,
            setValue
        ]),
        children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionCollapsibleProvider, {
            scope: props.__scopeAccordion,
            collapsible: collapsible,
            children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionImpl, {
                ...accordionSingleProps,
                ref: forwardedRef
            })
        })
    });
});
var $9380d202ffb94ee4$var$AccordionImplMultiple = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...accordionMultipleProps } = props;
    const [value = [], setValue] = (0, $225008a49d12b126$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleItemOpen = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleItemClose = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value,
        onItemOpen: handleItemOpen,
        onItemClose: handleItemClose,
        children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionCollapsibleProvider, {
            scope: props.__scopeAccordion,
            collapsible: true,
            children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionImpl, {
                ...accordionMultipleProps,
                ref: forwardedRef
            })
        })
    });
});
var [$9380d202ffb94ee4$var$AccordionImplProvider, $9380d202ffb94ee4$var$useAccordionContext] = $9380d202ffb94ee4$var$createAccordionContext($9380d202ffb94ee4$var$ACCORDION_NAME);
var $9380d202ffb94ee4$var$AccordionImpl = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, disabled: disabled, dir: dir, orientation: orientation = "vertical", ...accordionProps } = props;
    const accordionRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const composedRefs = (0, $340a4fddbb62b87d$export$c7b2cbe3552a0d05)(accordionRef, forwardedRef);
    const getItems = $9380d202ffb94ee4$var$useCollection(__scopeAccordion);
    const direction = (0, $f6d2792e625c1ee3$export$b39126d51d94e6f3)(dir);
    const isDirectionLTR = direction === "ltr";
    const handleKeyDown = (0, $2b1d1568c3aa77ff$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
        if (!$9380d202ffb94ee4$var$ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target;
        const triggerCollection = getItems().filter((item)=>!item.ref.current?.disabled);
        const triggerIndex = triggerCollection.findIndex((item)=>item.ref.current === target);
        const triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return;
        event.preventDefault();
        let nextIndex = triggerIndex;
        const homeIndex = 0;
        const endIndex = triggerCount - 1;
        const moveNext = ()=>{
            nextIndex = triggerIndex + 1;
            if (nextIndex > endIndex) nextIndex = homeIndex;
        };
        const movePrev = ()=>{
            nextIndex = triggerIndex - 1;
            if (nextIndex < homeIndex) nextIndex = endIndex;
        };
        switch(event.key){
            case "Home":
                nextIndex = homeIndex;
                break;
            case "End":
                nextIndex = endIndex;
                break;
            case "ArrowRight":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) moveNext();
                    else movePrev();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") moveNext();
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) movePrev();
                    else moveNext();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") movePrev();
                break;
        }
        const clampedIndex = nextIndex % triggerCount;
        triggerCollection[clampedIndex].ref.current?.focus();
    });
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionImplProvider, {
        scope: __scopeAccordion,
        disabled: disabled,
        direction: dir,
        orientation: orientation,
        children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$Collection.Slot, {
            scope: __scopeAccordion,
            children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $3e19f80aa8b65600$export$250ffa63cdc0d034).div, {
                ...accordionProps,
                "data-orientation": orientation,
                ref: composedRefs,
                onKeyDown: disabled ? void 0 : handleKeyDown
            })
        })
    });
});
var $9380d202ffb94ee4$var$ITEM_NAME = "AccordionItem";
var [$9380d202ffb94ee4$var$AccordionItemProvider, $9380d202ffb94ee4$var$useAccordionItemContext] = $9380d202ffb94ee4$var$createAccordionContext($9380d202ffb94ee4$var$ITEM_NAME);
var $9380d202ffb94ee4$export$d99097c13d4dac9f = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, value: value, ...accordionItemProps } = props;
    const accordionContext = $9380d202ffb94ee4$var$useAccordionContext($9380d202ffb94ee4$var$ITEM_NAME, __scopeAccordion);
    const valueContext = $9380d202ffb94ee4$var$useAccordionValueContext($9380d202ffb94ee4$var$ITEM_NAME, __scopeAccordion);
    const collapsibleScope = $9380d202ffb94ee4$var$useCollapsibleScope(__scopeAccordion);
    const triggerId = (0, $0bbfe31e6436b889$export$f680877a34711e37)();
    const open = value && valueContext.value.includes(value) || false;
    const disabled = accordionContext.disabled || props.disabled;
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$AccordionItemProvider, {
        scope: __scopeAccordion,
        open: open,
        disabled: disabled,
        triggerId: triggerId,
        children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($7ae692a808bf9638$export$be92b6f5f03c0fe9, {
            "data-orientation": accordionContext.orientation,
            "data-state": $9380d202ffb94ee4$var$getState(open),
            ...collapsibleScope,
            ...accordionItemProps,
            ref: forwardedRef,
            disabled: disabled,
            open: open,
            onOpenChange: (open2)=>{
                if (open2) valueContext.onItemOpen(value);
                else valueContext.onItemClose(value);
            }
        })
    });
});
$9380d202ffb94ee4$export$d99097c13d4dac9f.displayName = $9380d202ffb94ee4$var$ITEM_NAME;
var $9380d202ffb94ee4$var$HEADER_NAME = "AccordionHeader";
var $9380d202ffb94ee4$export$5e3e5deaaf81ee41 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, ...headerProps } = props;
    const accordionContext = $9380d202ffb94ee4$var$useAccordionContext($9380d202ffb94ee4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $9380d202ffb94ee4$var$useAccordionItemContext($9380d202ffb94ee4$var$HEADER_NAME, __scopeAccordion);
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)((0, $3e19f80aa8b65600$export$250ffa63cdc0d034).h3, {
        "data-orientation": accordionContext.orientation,
        "data-state": $9380d202ffb94ee4$var$getState(itemContext.open),
        "data-disabled": itemContext.disabled ? "" : void 0,
        ...headerProps,
        ref: forwardedRef
    });
});
$9380d202ffb94ee4$export$5e3e5deaaf81ee41.displayName = $9380d202ffb94ee4$var$HEADER_NAME;
var $9380d202ffb94ee4$var$TRIGGER_NAME = "AccordionTrigger";
var $9380d202ffb94ee4$export$94e939b1f85bdd73 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, ...triggerProps } = props;
    const accordionContext = $9380d202ffb94ee4$var$useAccordionContext($9380d202ffb94ee4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $9380d202ffb94ee4$var$useAccordionItemContext($9380d202ffb94ee4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleContext = $9380d202ffb94ee4$var$useAccordionCollapsibleContext($9380d202ffb94ee4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleScope = $9380d202ffb94ee4$var$useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$var$Collection.ItemSlot, {
        scope: __scopeAccordion,
        children: /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($7ae692a808bf9638$export$41fb9f06171c75f4, {
            "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
            "data-orientation": accordionContext.orientation,
            id: itemContext.triggerId,
            ...collapsibleScope,
            ...triggerProps,
            ref: forwardedRef
        })
    });
});
$9380d202ffb94ee4$export$94e939b1f85bdd73.displayName = $9380d202ffb94ee4$var$TRIGGER_NAME;
var $9380d202ffb94ee4$var$CONTENT_NAME = "AccordionContent";
var $9380d202ffb94ee4$export$985b9a77379b54a0 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, ...contentProps } = props;
    const accordionContext = $9380d202ffb94ee4$var$useAccordionContext($9380d202ffb94ee4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $9380d202ffb94ee4$var$useAccordionItemContext($9380d202ffb94ee4$var$CONTENT_NAME, __scopeAccordion);
    const collapsibleScope = $9380d202ffb94ee4$var$useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ (0, $34ccb6660205eec8$exports.jsx)($7ae692a808bf9638$export$7c6e2c02157bb7d2, {
        role: "region",
        "aria-labelledby": itemContext.triggerId,
        "data-orientation": accordionContext.orientation,
        ...collapsibleScope,
        ...contentProps,
        ref: forwardedRef,
        style: {
            ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
            ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
            ...props.style
        }
    });
});
$9380d202ffb94ee4$export$985b9a77379b54a0.displayName = $9380d202ffb94ee4$var$CONTENT_NAME;
function $9380d202ffb94ee4$var$getState(open) {
    return open ? "open" : "closed";
}
var $9380d202ffb94ee4$export$be92b6f5f03c0fe9 = $9380d202ffb94ee4$export$a766cd26d0d69044;
var $9380d202ffb94ee4$export$6d08773d2e66f8f2 = $9380d202ffb94ee4$export$d99097c13d4dac9f;
var $9380d202ffb94ee4$export$8b251419efc915eb = $9380d202ffb94ee4$export$5e3e5deaaf81ee41;
var $9380d202ffb94ee4$export$41fb9f06171c75f4 = $9380d202ffb94ee4$export$94e939b1f85bdd73;
var $9380d202ffb94ee4$export$7c6e2c02157bb7d2 = $9380d202ffb94ee4$export$985b9a77379b54a0;



var $70fFQ = parcelRequire("70fFQ");


var $axMmP = parcelRequire("axMmP");
var $f5f2c02b8572acf2$exports = {};
'use strict';
Object.defineProperty($f5f2c02b8572acf2$exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f5f2c02b8572acf2$var$CLASS_PART_SEPARATOR = '-';
function $f5f2c02b8572acf2$var$createClassGroupUtils(config) {
    const classMap = $f5f2c02b8572acf2$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    function getClassGroupId(className) {
        const classParts = className.split($f5f2c02b8572acf2$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === '' && classParts.length !== 1) classParts.shift();
        return $f5f2c02b8572acf2$var$getGroupRecursive(classParts, classMap) || $f5f2c02b8572acf2$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $f5f2c02b8572acf2$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $f5f2c02b8572acf2$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($f5f2c02b8572acf2$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
}
const $f5f2c02b8572acf2$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $f5f2c02b8572acf2$var$getGroupIdForArbitraryProperty(className) {
    if ($f5f2c02b8572acf2$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $f5f2c02b8572acf2$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(':'));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return 'arbitrary..' + property;
    }
}
/**
 * Exported for testing only
 */ function $f5f2c02b8572acf2$var$createClassMap(config) {
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $f5f2c02b8572acf2$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $f5f2c02b8572acf2$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $f5f2c02b8572acf2$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === 'string') {
            const classPartObjectToEdit = classDefinition === '' ? classPartObject : $f5f2c02b8572acf2$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === 'function') {
            if ($f5f2c02b8572acf2$var$isThemeGetter(classDefinition)) {
                $f5f2c02b8572acf2$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $f5f2c02b8572acf2$var$processClassesRecursively(classGroup, $f5f2c02b8572acf2$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $f5f2c02b8572acf2$var$getPart(classPartObject, path) {
    let currentClassPartObject = classPartObject;
    path.split($f5f2c02b8572acf2$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $f5f2c02b8572acf2$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $f5f2c02b8572acf2$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === 'string') return prefix + classDefinition;
            if (typeof classDefinition === 'object') return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $f5f2c02b8572acf2$var$createLruCache(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}
const $f5f2c02b8572acf2$var$IMPORTANT_MODIFIER = '!';
function $f5f2c02b8572acf2$var$createParseClassName(config) {
    const { separator: separator, experimentalParseClassName: experimentalParseClassName } = config;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    function parseClassName(className) {
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($f5f2c02b8572acf2$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    }
    if (experimentalParseClassName) return function parseClassNameExperimental(className) {
        return experimentalParseClassName({
            className: className,
            parseClassName: parseClassName
        });
    };
    return parseClassName;
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $f5f2c02b8572acf2$var$sortModifiers(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === '[';
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
}
function $f5f2c02b8572acf2$var$createConfigUtils(config) {
    return {
        cache: $f5f2c02b8572acf2$var$createLruCache(config.cacheSize),
        parseClassName: $f5f2c02b8572acf2$var$createParseClassName(config),
        ...$f5f2c02b8572acf2$var$createClassGroupUtils(config)
    };
}
const $f5f2c02b8572acf2$var$SPLIT_CLASSES_REGEX = /\s+/;
function $f5f2c02b8572acf2$var$mergeClassList(classList, configUtils) {
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = new Set();
    return classList.trim().split($f5f2c02b8572acf2$var$SPLIT_CLASSES_REGEX).map((originalClassName)=>{
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        const variantModifier = $f5f2c02b8572acf2$var$sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $f5f2c02b8572acf2$var$IMPORTANT_MODIFIER : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter((parsed)=>{
        if (!parsed.isTailwindClass) return true;
        const { modifierId: modifierId, classGroupId: classGroupId, hasPostfixModifier: hasPostfixModifier } = parsed;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group)=>classGroupsInConflict.add(modifierId + group));
        return true;
    }).reverse().map((parsed)=>parsed.originalClassName).join(' ');
}
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $f5f2c02b8572acf2$var$twJoin() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $f5f2c02b8572acf2$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $f5f2c02b8572acf2$var$toValue(mix) {
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $f5f2c02b8572acf2$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $f5f2c02b8572acf2$var$createTailwindMerge(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $f5f2c02b8572acf2$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $f5f2c02b8572acf2$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($f5f2c02b8572acf2$var$twJoin.apply(null, arguments));
    };
}
function $f5f2c02b8572acf2$var$fromTheme(key) {
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
}
const $f5f2c02b8572acf2$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $f5f2c02b8572acf2$var$fractionRegex = /^\d+\/\d+$/;
const $f5f2c02b8572acf2$var$stringLengths = /*#__PURE__*/ new Set([
    'px',
    'full',
    'screen'
]);
const $f5f2c02b8572acf2$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $f5f2c02b8572acf2$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $f5f2c02b8572acf2$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $f5f2c02b8572acf2$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $f5f2c02b8572acf2$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function $f5f2c02b8572acf2$var$isLength(value) {
    return $f5f2c02b8572acf2$var$isNumber(value) || $f5f2c02b8572acf2$var$stringLengths.has(value) || $f5f2c02b8572acf2$var$fractionRegex.test(value);
}
function $f5f2c02b8572acf2$var$isArbitraryLength(value) {
    return $f5f2c02b8572acf2$var$getIsArbitraryValue(value, 'length', $f5f2c02b8572acf2$var$isLengthOnly);
}
function $f5f2c02b8572acf2$var$isNumber(value) {
    return Boolean(value) && !Number.isNaN(Number(value));
}
function $f5f2c02b8572acf2$var$isArbitraryNumber(value) {
    return $f5f2c02b8572acf2$var$getIsArbitraryValue(value, 'number', $f5f2c02b8572acf2$var$isNumber);
}
function $f5f2c02b8572acf2$var$isInteger(value) {
    return Boolean(value) && Number.isInteger(Number(value));
}
function $f5f2c02b8572acf2$var$isPercent(value) {
    return value.endsWith('%') && $f5f2c02b8572acf2$var$isNumber(value.slice(0, -1));
}
function $f5f2c02b8572acf2$var$isArbitraryValue(value) {
    return $f5f2c02b8572acf2$var$arbitraryValueRegex.test(value);
}
function $f5f2c02b8572acf2$var$isTshirtSize(value) {
    return $f5f2c02b8572acf2$var$tshirtUnitRegex.test(value);
}
const $f5f2c02b8572acf2$var$sizeLabels = /*#__PURE__*/ new Set([
    'length',
    'size',
    'percentage'
]);
function $f5f2c02b8572acf2$var$isArbitrarySize(value) {
    return $f5f2c02b8572acf2$var$getIsArbitraryValue(value, $f5f2c02b8572acf2$var$sizeLabels, $f5f2c02b8572acf2$var$isNever);
}
function $f5f2c02b8572acf2$var$isArbitraryPosition(value) {
    return $f5f2c02b8572acf2$var$getIsArbitraryValue(value, 'position', $f5f2c02b8572acf2$var$isNever);
}
const $f5f2c02b8572acf2$var$imageLabels = /*#__PURE__*/ new Set([
    'image',
    'url'
]);
function $f5f2c02b8572acf2$var$isArbitraryImage(value) {
    return $f5f2c02b8572acf2$var$getIsArbitraryValue(value, $f5f2c02b8572acf2$var$imageLabels, $f5f2c02b8572acf2$var$isImage);
}
function $f5f2c02b8572acf2$var$isArbitraryShadow(value) {
    return $f5f2c02b8572acf2$var$getIsArbitraryValue(value, '', $f5f2c02b8572acf2$var$isShadow);
}
function $f5f2c02b8572acf2$var$isAny() {
    return true;
}
function $f5f2c02b8572acf2$var$getIsArbitraryValue(value, label, testValue) {
    const result = $f5f2c02b8572acf2$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === 'string' ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
}
function $f5f2c02b8572acf2$var$isLengthOnly(value) {
    // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    return $f5f2c02b8572acf2$var$lengthUnitRegex.test(value) && !$f5f2c02b8572acf2$var$colorFunctionRegex.test(value);
}
function $f5f2c02b8572acf2$var$isNever() {
    return false;
}
function $f5f2c02b8572acf2$var$isShadow(value) {
    return $f5f2c02b8572acf2$var$shadowRegex.test(value);
}
function $f5f2c02b8572acf2$var$isImage(value) {
    return $f5f2c02b8572acf2$var$imageRegex.test(value);
}
const $f5f2c02b8572acf2$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $f5f2c02b8572acf2$var$isAny,
    isArbitraryImage: $f5f2c02b8572acf2$var$isArbitraryImage,
    isArbitraryLength: $f5f2c02b8572acf2$var$isArbitraryLength,
    isArbitraryNumber: $f5f2c02b8572acf2$var$isArbitraryNumber,
    isArbitraryPosition: $f5f2c02b8572acf2$var$isArbitraryPosition,
    isArbitraryShadow: $f5f2c02b8572acf2$var$isArbitraryShadow,
    isArbitrarySize: $f5f2c02b8572acf2$var$isArbitrarySize,
    isArbitraryValue: $f5f2c02b8572acf2$var$isArbitraryValue,
    isInteger: $f5f2c02b8572acf2$var$isInteger,
    isLength: $f5f2c02b8572acf2$var$isLength,
    isNumber: $f5f2c02b8572acf2$var$isNumber,
    isPercent: $f5f2c02b8572acf2$var$isPercent,
    isTshirtSize: $f5f2c02b8572acf2$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
function $f5f2c02b8572acf2$var$getDefaultConfig() {
    const colors = $f5f2c02b8572acf2$var$fromTheme('colors');
    const spacing = $f5f2c02b8572acf2$var$fromTheme('spacing');
    const blur = $f5f2c02b8572acf2$var$fromTheme('blur');
    const brightness = $f5f2c02b8572acf2$var$fromTheme('brightness');
    const borderColor = $f5f2c02b8572acf2$var$fromTheme('borderColor');
    const borderRadius = $f5f2c02b8572acf2$var$fromTheme('borderRadius');
    const borderSpacing = $f5f2c02b8572acf2$var$fromTheme('borderSpacing');
    const borderWidth = $f5f2c02b8572acf2$var$fromTheme('borderWidth');
    const contrast = $f5f2c02b8572acf2$var$fromTheme('contrast');
    const grayscale = $f5f2c02b8572acf2$var$fromTheme('grayscale');
    const hueRotate = $f5f2c02b8572acf2$var$fromTheme('hueRotate');
    const invert = $f5f2c02b8572acf2$var$fromTheme('invert');
    const gap = $f5f2c02b8572acf2$var$fromTheme('gap');
    const gradientColorStops = $f5f2c02b8572acf2$var$fromTheme('gradientColorStops');
    const gradientColorStopPositions = $f5f2c02b8572acf2$var$fromTheme('gradientColorStopPositions');
    const inset = $f5f2c02b8572acf2$var$fromTheme('inset');
    const margin = $f5f2c02b8572acf2$var$fromTheme('margin');
    const opacity = $f5f2c02b8572acf2$var$fromTheme('opacity');
    const padding = $f5f2c02b8572acf2$var$fromTheme('padding');
    const saturate = $f5f2c02b8572acf2$var$fromTheme('saturate');
    const scale = $f5f2c02b8572acf2$var$fromTheme('scale');
    const sepia = $f5f2c02b8572acf2$var$fromTheme('sepia');
    const skew = $f5f2c02b8572acf2$var$fromTheme('skew');
    const space = $f5f2c02b8572acf2$var$fromTheme('space');
    const translate = $f5f2c02b8572acf2$var$fromTheme('translate');
    const getOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const getOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            'auto',
            $f5f2c02b8572acf2$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $f5f2c02b8572acf2$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            '',
            $f5f2c02b8572acf2$var$isLength,
            $f5f2c02b8572acf2$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            'auto',
            $f5f2c02b8572acf2$var$isNumber,
            $f5f2c02b8572acf2$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            'bottom',
            'center',
            'left',
            'left-bottom',
            'left-top',
            'right',
            'right-bottom',
            'right-top',
            'top'
        ];
    const getLineStyles = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double',
            'none'
        ];
    const getBlendModes = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const getAlign = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch'
        ];
    const getZeroAndEmpty = ()=>[
            '',
            '0',
            $f5f2c02b8572acf2$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const getNumber = ()=>[
            $f5f2c02b8572acf2$var$isNumber,
            $f5f2c02b8572acf2$var$isArbitraryNumber
        ];
    const getNumberAndArbitrary = ()=>[
            $f5f2c02b8572acf2$var$isNumber,
            $f5f2c02b8572acf2$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ':',
        theme: {
            colors: [
                $f5f2c02b8572acf2$var$isAny
            ],
            spacing: [
                $f5f2c02b8572acf2$var$isLength,
                $f5f2c02b8572acf2$var$isArbitraryLength
            ],
            blur: [
                'none',
                '',
                $f5f2c02b8572acf2$var$isTshirtSize,
                $f5f2c02b8572acf2$var$isArbitraryValue
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                'none',
                '',
                'full',
                $f5f2c02b8572acf2$var$isTshirtSize,
                $f5f2c02b8572acf2$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $f5f2c02b8572acf2$var$isPercent,
                $f5f2c02b8572acf2$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        'video',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                'container'
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $f5f2c02b8572acf2$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: [
                        ...getPositions(),
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        'auto',
                        $f5f2c02b8572acf2$var$isInteger,
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'wrap',
                        'wrap-reverse',
                        'nowrap'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        '1',
                        'auto',
                        'initial',
                        'none',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        'first',
                        'last',
                        'none',
                        $f5f2c02b8572acf2$var$isInteger,
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': [
                        $f5f2c02b8572acf2$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: [
                        'auto',
                        {
                            span: [
                                'full',
                                $f5f2c02b8572acf2$var$isInteger,
                                $f5f2c02b8572acf2$var$isArbitraryValue
                            ]
                        },
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': [
                        $f5f2c02b8572acf2$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: [
                        'auto',
                        {
                            span: [
                                $f5f2c02b8572acf2$var$isInteger,
                                $f5f2c02b8572acf2$var$isArbitraryValue
                            ]
                        },
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': [
                        'auto',
                        'min',
                        'max',
                        'fr',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': [
                        'auto',
                        'min',
                        'max',
                        'fr',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        'normal',
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...getAlign(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        'start',
                        'end',
                        'center',
                        'baseline',
                        'stretch'
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch',
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': [
                        ...getAlign(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        'start',
                        'end',
                        'center',
                        'baseline',
                        'stretch'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ 'space-x': [
                {
                    'space-x': [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ 'space-y': [
                {
                    'space-y': [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        'auto',
                        'min',
                        'max',
                        'fit',
                        'svw',
                        'lvw',
                        'dvw',
                        $f5f2c02b8572acf2$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        $f5f2c02b8572acf2$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit'
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        $f5f2c02b8572acf2$var$isArbitraryValue,
                        spacing,
                        'none',
                        'full',
                        'min',
                        'max',
                        'fit',
                        'prose',
                        {
                            screen: [
                                $f5f2c02b8572acf2$var$isTshirtSize
                            ]
                        },
                        $f5f2c02b8572acf2$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $f5f2c02b8572acf2$var$isArbitraryValue,
                        spacing,
                        'auto',
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        $f5f2c02b8572acf2$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        $f5f2c02b8572acf2$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $f5f2c02b8572acf2$var$isArbitraryValue,
                        spacing,
                        'auto',
                        'min',
                        'max',
                        'fit'
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        $f5f2c02b8572acf2$var$isTshirtSize,
                        $f5f2c02b8572acf2$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        'thin',
                        'extralight',
                        'light',
                        'normal',
                        'medium',
                        'semibold',
                        'bold',
                        'extrabold',
                        'black',
                        $f5f2c02b8572acf2$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $f5f2c02b8572acf2$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractons'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        'tighter',
                        'tight',
                        'normal',
                        'wide',
                        'wider',
                        'widest',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        'none',
                        $f5f2c02b8572acf2$var$isNumber,
                        $f5f2c02b8572acf2$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        'tight',
                        'snug',
                        'normal',
                        'relaxed',
                        'loose',
                        $f5f2c02b8572acf2$var$isLength,
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'none',
                        'disc',
                        'decimal',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ 'placeholder-opacity': [
                {
                    'placeholder-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ 'text-opacity': [
                {
                    'text-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...getLineStyles(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        'auto',
                        'from-font',
                        $f5f2c02b8572acf2$var$isLength,
                        $f5f2c02b8572acf2$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        'auto',
                        $f5f2c02b8572acf2$var$isLength,
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ 'bg-opacity': [
                {
                    'bg-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: [
                        ...getPositions(),
                        $f5f2c02b8572acf2$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: [
                        'no-repeat',
                        {
                            repeat: [
                                '',
                                'x',
                                'y',
                                'round',
                                'space'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: [
                        'auto',
                        'cover',
                        'contain',
                        $f5f2c02b8572acf2$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            'gradient-to': [
                                't',
                                'tr',
                                'r',
                                'br',
                                'b',
                                'bl',
                                'l',
                                'tl'
                            ]
                        },
                        $f5f2c02b8572acf2$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ 'border-opacity': [
                {
                    'border-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...getLineStyles(),
                        'hidden'
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-x': [
                {
                    'divide-x': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-y': [
                {
                    'divide-y': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ 'divide-opacity': [
                {
                    'divide-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ 'divide-style': [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        '',
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $f5f2c02b8572acf2$var$isLength,
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        $f5f2c02b8572acf2$var$isLength,
                        $f5f2c02b8572acf2$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ 'ring-w': [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ 'ring-color': [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ 'ring-opacity': [
                {
                    'ring-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $f5f2c02b8572acf2$var$isLength,
                        $f5f2c02b8572acf2$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ 'ring-offset-color': [
                {
                    'ring-offset': [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        '',
                        'inner',
                        'none',
                        $f5f2c02b8572acf2$var$isTshirtSize,
                        $f5f2c02b8572acf2$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ 'shadow-color': [
                {
                    shadow: [
                        $f5f2c02b8572acf2$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...getBlendModes(),
                        'plus-lighter',
                        'plus-darker'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        '',
                        'none'
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        '',
                        'none',
                        $f5f2c02b8572acf2$var$isTshirtSize,
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        '',
                        'none'
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        'none',
                        'all',
                        '',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'in',
                        'out',
                        'in-out',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        'spin',
                        'ping',
                        'pulse',
                        'bounce',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        '',
                        'gpu',
                        'none'
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $f5f2c02b8572acf2$var$isInteger,
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: [
                        'center',
                        'top',
                        'top-right',
                        'right',
                        'bottom-right',
                        'bottom',
                        'bottom-left',
                        'left',
                        'top-left',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        'auto',
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        'y',
                        'x',
                        ''
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $f5f2c02b8572acf2$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        'none'
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $f5f2c02b8572acf2$var$isLength,
                        $f5f2c02b8572acf2$var$isArbitraryLength,
                        $f5f2c02b8572acf2$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        'none'
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-s',
                'border-w-e',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        }
    };
}
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $f5f2c02b8572acf2$var$mergeConfigs(baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} }) {
    $f5f2c02b8572acf2$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $f5f2c02b8572acf2$var$overrideProperty(baseConfig, 'prefix', prefix);
    $f5f2c02b8572acf2$var$overrideProperty(baseConfig, 'separator', separator);
    $f5f2c02b8572acf2$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    for(const configKey in override)$f5f2c02b8572acf2$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$f5f2c02b8572acf2$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
}
function $f5f2c02b8572acf2$var$overrideProperty(baseObject, overrideKey, overrideValue) {
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
}
function $f5f2c02b8572acf2$var$overrideConfigProperties(baseObject, overrideObject) {
    if (overrideObject) for(const key in overrideObject)$f5f2c02b8572acf2$var$overrideProperty(baseObject, key, overrideObject[key]);
}
function $f5f2c02b8572acf2$var$mergeConfigProperties(baseObject, mergeObject) {
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
}
function $f5f2c02b8572acf2$var$extendTailwindMerge(configExtension, ...createConfig) {
    return typeof configExtension === 'function' ? $f5f2c02b8572acf2$var$createTailwindMerge($f5f2c02b8572acf2$var$getDefaultConfig, configExtension, ...createConfig) : $f5f2c02b8572acf2$var$createTailwindMerge(()=>$f5f2c02b8572acf2$var$mergeConfigs($f5f2c02b8572acf2$var$getDefaultConfig(), configExtension), ...createConfig);
}
const $f5f2c02b8572acf2$var$twMerge = /*#__PURE__*/ $f5f2c02b8572acf2$var$createTailwindMerge($f5f2c02b8572acf2$var$getDefaultConfig);
$f5f2c02b8572acf2$exports.createTailwindMerge = $f5f2c02b8572acf2$var$createTailwindMerge;
$f5f2c02b8572acf2$exports.extendTailwindMerge = $f5f2c02b8572acf2$var$extendTailwindMerge;
$f5f2c02b8572acf2$exports.fromTheme = $f5f2c02b8572acf2$var$fromTheme;
$f5f2c02b8572acf2$exports.getDefaultConfig = $f5f2c02b8572acf2$var$getDefaultConfig;
$f5f2c02b8572acf2$exports.mergeConfigs = $f5f2c02b8572acf2$var$mergeConfigs;
$f5f2c02b8572acf2$exports.twJoin = $f5f2c02b8572acf2$var$twJoin;
$f5f2c02b8572acf2$exports.twMerge = $f5f2c02b8572acf2$var$twMerge;
$f5f2c02b8572acf2$exports.validators = $f5f2c02b8572acf2$var$validators;


var // Classic tailwind helper to make it easier to conditionally add tailwind css classes.
// https://tigerabrodi.blog/the-story-behind-tailwinds-cn-function
$2008c04e61e79f08$export$2e2bcd8739ae039 = (...inputs)=>(0, $f5f2c02b8572acf2$exports.twMerge)((0, $axMmP.clsx)(inputs));


const $c4723ffe9ea446ab$export$a766cd26d0d69044 = $9380d202ffb94ee4$export$be92b6f5f03c0fe9;
const $c4723ffe9ea446ab$export$d99097c13d4dac9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $2008c04e61e79f08$export$2e2bcd8739ae039)("border-0 [&[data-state=open]]:my-4 [&[data-state=open]]:border [&[data-state=open]]:border-white30 [&[data-state=open]]:rounded-xl overflow-hidden", className),
        ...props
    }));
$c4723ffe9ea446ab$export$d99097c13d4dac9f.displayName = "AccordionItem";
const $c4723ffe9ea446ab$export$94e939b1f85bdd73 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ className: className, children: children, chevronId: chevronId, ...props }, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$export$8b251419efc915eb, {
        className: "flex",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($9380d202ffb94ee4$export$41fb9f06171c75f4, {
            ref: ref,
            className: (0, $2008c04e61e79f08$export$2e2bcd8739ae039)(`flex flex-1 items-center gap-4 justify-between py-6 px-4 transition-all hover:bg-surface1 [&[data-state=open]]:bg-surface1 [&>div>svg]:transition-all [&[data-state=open]>div>svg]:rotate-180`, className),
            ...props,
            children: [
                children,
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                    id: chevronId,
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ChevronDownIcon), {
                        size: 16,
                        color: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                    })
                })
            ]
        })
    }));
$c4723ffe9ea446ab$export$94e939b1f85bdd73.displayName = $9380d202ffb94ee4$export$41fb9f06171c75f4.displayName;
const $c4723ffe9ea446ab$export$985b9a77379b54a0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9380d202ffb94ee4$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: "px-4 overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        ...props,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
            className: (0, $2008c04e61e79f08$export$2e2bcd8739ae039)("pb-4 pt-0", className),
            children: children
        })
    }));
$c4723ffe9ea446ab$export$985b9a77379b54a0.displayName = $9380d202ffb94ee4$export$7c6e2c02157bb7d2.displayName;






var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");


const $fe4b5db038b9a49b$export$e96af9b58a485423 = "default";
const $fe4b5db038b9a49b$export$9e74f599b5cec2df = "buttonGroup";
const $fe4b5db038b9a49b$export$c8fc308cb76d7ae7 = [
    $fe4b5db038b9a49b$export$e96af9b58a485423,
    $fe4b5db038b9a49b$export$9e74f599b5cec2df
];


const $e68215c90b0d6c33$export$16c00e832ee4fba4 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  flex: 0 0 1px;
  height: 24px;
  background-color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
const $e68215c90b0d6c33$export$3f801fc7e5c696a8 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 24px;
  margin: 0;
  overflow: hidden;
`;
/**
 * A component to organize a set of tab groups. Can either be used with a route portion, or
 * a query param, and offers 2 visual variants.
 *
 * @param {React.Element} children
 * @param {string} routeId - Optional routeId to use for tab selection, should be from a <Route />
 *    component that has a :routeId parameter involved. Should be included if not using queryParam.
 * @param {string} queryParam - Optional query param to use for tab selection, should be provided
 *    if not using routeId.
 * @param {string} variant - Optional variant to use for tab selection.
 * @return {JSX.Element}
 */ const $e68215c90b0d6c33$var$TabList = ({ children: children, routeId: routeId, queryParam: queryParam, variant: variant })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e68215c90b0d6c33$export$3f801fc7e5c696a8, {
        role: "tablist",
        children: (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.map(children, (child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(child, {
                index: index,
                variant: variant,
                routeId: routeId,
                queryParam: queryParam,
                resizeable: index === children.length - 1,
                key: `tab-group-${index}`
            }))
    });
};
$e68215c90b0d6c33$var$TabList.propTypes = {
    routeId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    queryParam: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array
    ])),
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf((0, $fe4b5db038b9a49b$export$c8fc308cb76d7ae7))
};
$e68215c90b0d6c33$var$TabList.defaultProps = {
    routeId: null,
    queryParam: null,
    variant: (0, $fe4b5db038b9a49b$export$e96af9b58a485423)
};
var $e68215c90b0d6c33$export$2e2bcd8739ae039 = $e68215c90b0d6c33$var$TabList;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");






var $70fFQ = parcelRequire("70fFQ");
/**
 * Stolen from react-use https://github.com/streamich/react-use/blob/master/src/useMeasure.ts
 */ const $4e12efec6f3d63a0$var$useElementDimensions = ()=>{
    const [element, ref] = (0, $70fFQ.useState)(null);
    const [rect, setRect] = (0, $70fFQ.useState)({
        width: 0
    });
    const observer = (0, $70fFQ.useMemo)(()=>// Doesn't work on opera mini and KaiOS 2.5; 0.19% global usage ¯\_(ツ)_/¯
        // eslint-disable-next-line compat/compat
        new ResizeObserver((entries)=>{
            if (entries[0]) {
                const { x: x, y: y, width: width, height: height, top: top, left: left, bottom: bottom, right: right } = entries[0].contentRect;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        }), []);
    (0, $70fFQ.useLayoutEffect)(()=>{
        if (!element) return;
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element,
        observer
    ]);
    return [
        ref,
        element,
        rect
    ];
};
var $4e12efec6f3d63a0$export$2e2bcd8739ae039 = $4e12efec6f3d63a0$var$useElementDimensions;


const $f52afbcf820a94e0$var$StyledMoreArrowGradient = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  height: 24px;
  width: 64px;

  ${(props)=>props.$right ? (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          justify-content: flex-end;

          background: linear-gradient(
            0.25turn,
            transparent,
            ${(props)=>(0, $dfd33cee3229493c$exports.YukaColorPalette)[`surface${props.theme.surfaceLevel || 1}`]} 62.5%
          );
        ` : (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          justify-content: flex-start;

          background: linear-gradient(
            0.75turn,
            transparent,
            ${(props)=>(0, $dfd33cee3229493c$exports.YukaColorPalette)[`surface${props.theme.surfaceLevel || 1}`]} 62.5%
          );
        `}
`;
const $f52afbcf820a94e0$var$StyledMoreArrowButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
  overflow: auto;

  &:hover {
    svg path {
      fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white80};
    }
  }

  &:active {
    svg path {
      fill: ${(0, $dfd33cee3229493c$exports.ColorPalette).white100};
    }
  }
`;
const $f52afbcf820a94e0$var$StyledTabGroup = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $e68215c90b0d6c33$export$3f801fc7e5c696a8))`
  position: relative;
  margin: 0;
  flex-shrink: ${({ $resizeable: $resizeable })=>$resizeable ? 1 : 0};
  ${(props)=>{
    if (props.$variant === (0, $fe4b5db038b9a49b$export$9e74f599b5cec2df)) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        border-radius: 12px;
        padding: 5px;
        background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
      `;
}}
`;
const $f52afbcf820a94e0$var$StyledTabs = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: ${(props)=>props.$variant === (0, $fe4b5db038b9a49b$export$9e74f599b5cec2df) ? "8px" : "24px"};
  flex-grow: 1;
  overflow-x: auto;

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;
const $f52afbcf820a94e0$var$StyledOverlay = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
`;
const $f52afbcf820a94e0$var$TabGroup = ({ index: groupIndex, variant: variant, resizeable: resizeable, routeId: routeId, queryParam: queryParam, defaultTabId: defaultTabId, onSelectTab: onSelectTab, children: children, scrollIntoView: scrollIntoView })=>{
    const [tabsRef, current] = (0, $4e12efec6f3d63a0$export$2e2bcd8739ae039)();
    // We allow users of the tab list to use either route IDs or query params to select tabs.
    const { [routeId]: id } = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const currentTab = (0, $dfd33cee3229493c$exports.useCurrentTab)(queryParam);
    const location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const tabs = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.toArray(children), [
        children
    ]);
    const [scrollPosition, setScrollPosition] = (0, $70fFQ.useState)(0);
    const scroll = (0, $70fFQ.useCallback)((right)=>{
        if (current) {
            if (right) current.scrollTo({
                left: scrollPosition + 400,
                behavior: "smooth"
            });
            else current.scrollTo({
                left: scrollPosition - 400,
                behavior: "smooth"
            });
        }
    }, [
        scrollPosition,
        current
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (tabs.length > 0 && !id && routeId && defaultTabId && tabs.find((tab)=>tab.props.id === defaultTabId)) navigate(`${location.pathname}${defaultTabId}`, {
            replace: true
        });
        else if (tabs.length > 0 && (!currentTab || !tabs.find((tab)=>tab.props.id === currentTab)) && !currentTab && queryParam && defaultTabId && tabs.find((tab)=>tab.props.id === defaultTabId)) navigate({
            search: `?${queryParam}=${defaultTabId}`
        }, {
            replace: true
        });
    }, [
        routeId,
        queryParam,
        currentTab,
        tabs,
        tabs.length,
        id,
        defaultTabId,
        location.pathname,
        navigate
    ]);
    const onScroll = (0, $70fFQ.useCallback)(()=>{
        setScrollPosition(current?.scrollLeft);
    }, [
        current?.scrollLeft
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (!current) return null;
        const scrolledElement = current;
        scrolledElement.addEventListener("scroll", onScroll);
        return ()=>{
            scrolledElement.removeEventListener("scroll", onScroll);
        };
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f52afbcf820a94e0$var$StyledTabGroup, {
        $variant: variant,
        $resizeable: resizeable,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f52afbcf820a94e0$var$StyledTabs, {
                $variant: variant,
                ref: tabsRef,
                children: (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.map(children, (child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(child, {
                        index: index,
                        variant: variant,
                        scrollIntoView: scrollIntoView,
                        parentWidth: current?.clientWidth,
                        scrollPosition: scrollPosition,
                        key: `tab-${groupIndex}_${index}`,
                        currentTab: id || currentTab,
                        isSelected: child.props.id === currentTab || String(child.props.id) === currentTab,
                        onSelectTab: ()=>{
                            if (onSelectTab) onSelectTab(child.props.id);
                            if (child.props.onSelectTab) child.props.onSelectTab();
                            if (routeId) navigate(location.pathname.replace(`/${id}`, `/${child.props.id}`));
                            else navigate({
                                search: `?${queryParam}=${child.props.id}`
                            });
                        }
                    }))
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f52afbcf820a94e0$var$StyledOverlay, {
                children: [
                    resizeable && scrollPosition > 0 ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f52afbcf820a94e0$var$StyledMoreArrowGradient, {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f52afbcf820a94e0$var$StyledMoreArrowButton, {
                            onClick: ()=>scroll(false),
                            role: "button",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ChevronLeftIcon), {
                                size: 18,
                                color: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                            })
                        })
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {}),
                    resizeable && Math.ceil(scrollPosition) < Math.ceil(current?.scrollWidth - current?.clientWidth) ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f52afbcf820a94e0$var$StyledMoreArrowGradient, {
                        $right: true,
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f52afbcf820a94e0$var$StyledMoreArrowButton, {
                            onClick: ()=>scroll(true),
                            role: "button",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ChevronRightIcon), {
                                size: 18,
                                color: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                            })
                        })
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {})
                ]
            })
        ]
    });
};
$f52afbcf820a94e0$var$TabGroup.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf((0, $fe4b5db038b9a49b$export$c8fc308cb76d7ae7)),
    defaultTabId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    routeId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    queryParam: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    onSelectTab: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired,
    resizeable: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    scrollIntoView: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
$f52afbcf820a94e0$var$TabGroup.defaultProps = {
    onSelectTab: null,
    variant: (0, $fe4b5db038b9a49b$export$e96af9b58a485423)
};
var $f52afbcf820a94e0$export$2e2bcd8739ae039 = $f52afbcf820a94e0$var$TabGroup;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



const $e754b611d0d28d4e$var$SCROLL_MARGINS = 64;
const $e754b611d0d28d4e$var$StyledTab = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  scroll-margin: ${$e754b611d0d28d4e$var$SCROLL_MARGINS}px;
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  ${(0, $dfd33cee3229493c$exports.body1)}
  position: relative;
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
  line-height: 24px;

  height: 40px;
  box-sizing: border-box;

  ${(props)=>{
    if (props.$variant === (0, $fe4b5db038b9a49b$export$9e74f599b5cec2df)) {
        const sharedStyles = (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        height: 30px;
        padding: 8px;
        border-radius: 8px;
        align-items: center;
      `;
        if (props.$selected) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          ${sharedStyles}
          ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
          background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface2};
        `;
        return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        ${sharedStyles}
      `;
    }
    // Default variant.
    if (props.$selected) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
        border-bottom: 2px solid white;
      `;
    return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      border-bottom: 2px solid ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
    `;
}}

  &:hover {
    ${(props)=>props.onClick && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        cursor: pointer;
        ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
      `}
  }
`;
const $e754b611d0d28d4e$var$StyledFlexRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
`;
const $e754b611d0d28d4e$var$Tab = ({ id: id, variant: variant, className: className, children: children, currentTab: currentTab, onSelectTab: onSelectTab, scrollPosition: scrollPosition, parentWidth: parentWidth, scrollIntoView: scrollIntoView })=>{
    const ref = (0, $70fFQ.useRef)(null);
    const isSelected = id === currentTab || String(id) === currentTab;
    (0, $70fFQ.useEffect)(()=>{
        if (isSelected && parentWidth && scrollIntoView) {
            /*
       * Determines the tab extends beyond the left boundary of its parent. Checks to see if
       * all the space to the left of the tab is less than the parent's
       * scroll position + minus the scroll margin. The scroll margin is
       * used to ensure this function returns `true` even if there's a SCROLL_MARGIN worth of
       * buffer between the left side of the tab and the left side of the parent's container, since
       * that buffer is hidden below the parent's scroll-left arrow.
       */ const isOverflowingToLeft = ref.current?.offsetLeft < scrollPosition + $e754b611d0d28d4e$var$SCROLL_MARGINS;
            /*
       * Determines the tab extends beyond the right boundary of its parent. Checks to see if
       * all the space to the left of the tab + the width of the tab is greater than the parent's
       * scroll position + the parent's visible width, minus the scroll margin. The scroll margin is
       * used to ensure this function returns `true` even if there's a SCROLL_MARGIN worth of
       * buffer between the right side of the tab and the right side of the parent's container, since
       * that buffer is hidden below the parent's scroll-right arrow.
       */ const isOverflowingToRight = ref.current?.offsetLeft + ref.current?.clientWidth > parentWidth + scrollPosition - $e754b611d0d28d4e$var$SCROLL_MARGINS;
            if (isOverflowingToRight) // If we need to scroll to the left to view the tab, line up the right-side of the tab
            // at the right-side of the parent.
            ref.current?.scrollIntoView({
                inline: "end",
                behavior: "smooth"
            });
            else if (isOverflowingToLeft) // If we need to scroll to the right to view the tab, line up the left-side of the tab
            // at the left-side of the parent.
            ref.current?.scrollIntoView({
                inline: "start",
                behavior: "smooth"
            });
        }
    // We need to exclude scrollPosition otherwise the scroll slows down b/c it runs this effect
    // every frame.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scrollIntoView,
        isSelected,
        parentWidth
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e754b611d0d28d4e$var$StyledTab, {
        id: id,
        className: className,
        ref: ref,
        role: "tab",
        onClick: onSelectTab,
        $variant: variant,
        $selected: id === currentTab || String(id) === currentTab,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e754b611d0d28d4e$var$StyledFlexRow, {
            children: children
        })
    });
};
$e754b611d0d28d4e$var$Tab.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf((0, $fe4b5db038b9a49b$export$c8fc308cb76d7ae7)),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired,
    currentTab: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    onSelectTab: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    scrollPosition: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    parentWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    scrollIntoView: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
$e754b611d0d28d4e$var$Tab.defaultProps = {
    variant: (0, $fe4b5db038b9a49b$export$e96af9b58a485423),
    onSelectTab: null
};
var $e754b611d0d28d4e$export$2e2bcd8739ae039 = $e754b611d0d28d4e$var$Tab;









parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");

/**
 * Returns the user's thumbnail in a circular container with the given
 * dimensions.
 *
 * @returns {React.Element}
 *
 */ const $7759a50ff4d048a0$var$UserAvatar = (props)=>{
    const profilePicture = props.user?.thumbnail;
    const defaultPicture = `${props.user?.first_name?.charAt(0) ?? ""}${props.user?.last_name?.charAt(0) ?? ""}`;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Avatar), {
        avatar: profilePicture,
        avatarAlt: defaultPicture,
        colorId: props.user?.id ? props.user.id : 0,
        size: props.size
    });
};
$7759a50ff4d048a0$var$UserAvatar.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        first_name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        last_name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
$7759a50ff4d048a0$var$UserAvatar.defaultProps = {
    size: "32px"
};
var $7759a50ff4d048a0$export$2e2bcd8739ae039 = $7759a50ff4d048a0$var$UserAvatar;


const $f12c13297c011f88$var$CenteredRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $2579cfa538529ea8$export$81761b52b04ea573))`
  padding: 0px 16px;
  align-items: center;
`;
const $f12c13297c011f88$var$StyledMessage = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).p`
  ${(0, $dfd33cee3229493c$exports.caption2)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
`;
const $f12c13297c011f88$var$StyledAccountInformationActions = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const $f12c13297c011f88$var$StyledHiddenInput = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: none;
`;
const $f12c13297c011f88$var$StyledButtonRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;
const $f12c13297c011f88$var$AccountInformation = (props)=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const fileInputRef = (0, $70fFQ.useRef)(null);
    const [file, setFile] = (0, $70fFQ.useState)(null);
    const changeAccountNameQuery = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CHANGE_ACCOUNT_SETTINGS(), true, {
        silent: false
    });
    const onSubmit = (values)=>{
        changeAccountNameQuery.mutate(values, {
            onSuccess: ()=>{
                navigate(0);
            }
        });
    };
    const handleDeletePicture = ()=>{
        const data = {
            main_picture: null
        };
        changeAccountNameQuery.mutate(data, {
            onSuccess: ()=>{
                navigate(0);
            }
        });
    };
    const triggerUpdatePicture = (0, $70fFQ.useCallback)(()=>{
        fileInputRef.current.click();
    }, []);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Card), {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        title: "Account Information",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f12c13297c011f88$var$CenteredRow, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7759a50ff4d048a0$export$2e2bcd8739ae039), {
                        user: props.user,
                        size: "96px"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f12c13297c011f88$var$StyledAccountInformationActions, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f12c13297c011f88$var$StyledButtonRow, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                        leadingIcon: (0, $dfd33cee3229493c$exports.UploadIcon),
                                        onClick: triggerUpdatePicture,
                                        children: "Upload New Picture"
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                        leadingIcon: (0, $dfd33cee3229493c$exports.TrashIcon),
                                        onClick: handleDeletePicture,
                                        children: "Delete Picture"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.StyledBody1), {
                                children: file
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
                onSubmit: onSubmit,
                children: ({ handleSubmit: handleSubmit, submitting: submitting, dirty: dirty })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $2579cfa538529ea8$export$c1cdecccab05cfc8), {
                        onSubmit: handleSubmit,
                        children: [
                            submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f12c13297c011f88$var$StyledHiddenInput, {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                    id: "file",
                                    type: "file",
                                    name: "main_picture",
                                    ref: fileInputRef,
                                    onChange: (file)=>{
                                        setFile(file.name);
                                    },
                                    parse: (fileList)=>fileList[0],
                                    format: (file)=>[
                                            file
                                        ]
                                })
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                    id: "first_name",
                                    name: "first_name",
                                    placeholder: props.user.first_name,
                                    type: "text",
                                    label: "First Name"
                                })
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                    id: "last_name",
                                    name: "last_name",
                                    placeholder: props.user.last_name,
                                    type: "text",
                                    label: "Last Name"
                                })
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f12c13297c011f88$var$StyledMessage, {
                                children: [
                                    "Updating your name will change how it is displayed throughout the platform. Your time zone is only used to display times on the site in your local time. For more details, visit our\xa0",
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                        url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("privacy"),
                                        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                                        children: "Privacy Policy."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2579cfa538529ea8$export$635d1b58476adfbe), {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                    disabled: submitting || !dirty,
                                    type: "submit",
                                    children: "Save Changes"
                                })
                            })
                        ]
                    })
            })
        ]
    });
};
$f12c13297c011f88$var$AccountInformation.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        first_name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        last_name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired
};
var $f12c13297c011f88$export$2e2bcd8739ae039 = $f12c13297c011f88$var$AccountInformation;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");









parcelRequire("70fFQ");


const $56dc12cc1901e599$var$TipList = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  margin-bottom: 24px;

  > ul {
    margin: 0;
    padding: 0;
    list-style-position: inside;

    li {
      padding-left: 14px;
    }
  }
`;
/**
 * Used in the password reset + set forms.
 *
 * @returns {React.Element}
 */ const $56dc12cc1901e599$var$PasswordSecurityTips = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($56dc12cc1901e599$var$TipList, {
        children: [
            "Password security tips:",
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                        children: "Make sure your password is at least 8 characters long"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                        children: "Note that passwords are case-sensitive"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                        children: "Use a combination of letters, numbers and special characters to make your password harder to guess"
                    })
                ]
            })
        ]
    });
var $56dc12cc1901e599$export$2e2bcd8739ae039 = $56dc12cc1901e599$var$PasswordSecurityTips;


const $ba93553e8cd5f72b$var$StyledButtonContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $ba93553e8cd5f72b$var$StyledInputContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin: 24px 0px;
`;
const $ba93553e8cd5f72b$var$StyledSecurityTips = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)};
  ${(0, $dfd33cee3229493c$exports.FontColors).theme80};
`;
const $ba93553e8cd5f72b$var$StyledStatusMessage = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)};
  padding-left: 18px;
  padding-bottom: 16px;
  color: ${(props)=>props.$error ? (0, $dfd33cee3229493c$exports.ColorPalette).sell : (0, $dfd33cee3229493c$exports.ColorPalette).buy};
`;
const $ba93553e8cd5f72b$var$EditPasswordForm = (props)=>{
    const changePasswordQuery = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CHANGE_PASSWORD(props.userId), true, {
        silent: false,
        message: "Your password has been updated"
    });
    const validate = (value)=>value ? undefined : "Required";
    const onSubmit = (values)=>{
        changePasswordQuery.mutate(values);
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        title: "Password",
        tagline: "For your protection, if you want to change your password, we will ask you to confirm your existing password.",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
            onSubmit: onSubmit,
            children: ({ handleSubmit: handleSubmit, submitting: submitting, valid: valid, dirty: dirty })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
                    children: [
                        submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $2579cfa538529ea8$export$c1cdecccab05cfc8), {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ba93553e8cd5f72b$var$StyledSecurityTips, {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $56dc12cc1901e599$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($ba93553e8cd5f72b$var$StyledInputContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                                displayIndicator: false,
                                                id: "old_password",
                                                type: "password",
                                                placeholder: "Old password",
                                                name: "old_password",
                                                label: "Old Password",
                                                validate: validate
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                                id: "password",
                                                type: "password",
                                                name: "password",
                                                placeholder: "New password",
                                                label: "New Password",
                                                validate: validate,
                                                displayIndicator: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                                id: "confirm-password",
                                                type: "password",
                                                name: "confirm_password",
                                                placeholder: "Confirm new password",
                                                label: "New Password Confirmation",
                                                validate: validate,
                                                displayIndicator: false
                                            })
                                        }),
                                        changePasswordQuery.isSuccess && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ba93553e8cd5f72b$var$StyledStatusMessage, {
                                            children: "Password changed!"
                                        }),
                                        changePasswordQuery.isError && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($ba93553e8cd5f72b$var$StyledStatusMessage, {
                                            $error: true,
                                            children: [
                                                "Error:",
                                                " ",
                                                changePasswordQuery.error.response.data.Error || changePasswordQuery.error.response.data.non_field_errors
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ba93553e8cd5f72b$var$StyledButtonContainer, {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                        disabled: submitting || !dirty || !valid,
                                        type: "submit",
                                        children: "Change Password"
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
$ba93553e8cd5f72b$var$EditPasswordForm.propTypes = {
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
};
var $ba93553e8cd5f72b$export$2e2bcd8739ae039 = $ba93553e8cd5f72b$var$EditPasswordForm;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");









const $3f8b69bff344b58f$var$StyledButtonContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $3f8b69bff344b58f$var$StyledInputContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin: 24px 0px;
`;
const $3f8b69bff344b58f$var$CurrentEmailSpan = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.overline)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  margin-right: 120px;
`;
const $3f8b69bff344b58f$var$UserEmailSpan = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.body1)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
`;
const $3f8b69bff344b58f$var$EditEmailForm = (props)=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const newEmailRef = (0, $70fFQ.useRef)();
    const commentsRef = (0, $70fFQ.useRef)();
    const validateEmail = (value)=>value ? undefined : "Required";
    const onSubmit = (values, form)=>{
        return (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).EMAIL_CHANGE_REQUEST(), JSON.stringify(values)).then(()=>{
            dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                message: "Email change request submitted. Our team will review it and follow up by email."
            });
            newEmailRef.current?.blur();
            commentsRef.current?.blur();
            form.restart();
        }).catch((error)=>{
            const data = error?.response?.data;
            let errorMsg = "Unknown error occurred";
            newEmailRef.current?.blur();
            commentsRef.current?.blur();
            if (data?.new_email) errorMsg = Array.isArray(data.new_email) ? data.new_email[0] : data.new_email;
            return {
                new_email: errorMsg
            };
        });
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        title: "Email",
        tagline: "Request an email address change. Our team will review your request and follow up by email once it's processed.",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
            onSubmit: onSubmit,
            children: ({ handleSubmit: handleSubmit, submitting: submitting, dirty: dirty })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
                    children: [
                        submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $2579cfa538529ea8$export$c1cdecccab05cfc8), {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($3f8b69bff344b58f$var$CurrentEmailSpan, {
                                            children: "Your current email"
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($3f8b69bff344b58f$var$UserEmailSpan, {
                                            children: props.user?.email ?? "Email not found!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($3f8b69bff344b58f$var$StyledInputContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                                id: "new_email",
                                                type: "email",
                                                name: "new_email",
                                                placeholder: "Email",
                                                label: "New Email Address",
                                                validate: validateEmail,
                                                displayIndicator: false,
                                                ref: newEmailRef
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                                id: "comments",
                                                type: "text",
                                                name: "comments",
                                                placeholder: "Optional context for our support team",
                                                label: "Comments (optional)",
                                                displayIndicator: false,
                                                ref: commentsRef
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($3f8b69bff344b58f$var$StyledButtonContainer, {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                        disabled: submitting || !dirty,
                                        type: "submit",
                                        children: "Submit Request"
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
$3f8b69bff344b58f$var$EditEmailForm.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired
};
var $3f8b69bff344b58f$export$2e2bcd8739ae039 = $3f8b69bff344b58f$var$EditEmailForm;




var $70fFQ = parcelRequire("70fFQ");

parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");


const $aacdb8c81c3d4f14$var$InitialStep = (props)=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
            children: [
                "Two-Factor Authentication:",
                " ",
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme100, {
                    children: props.is2FaEnabled ? "ON" : "OFF"
                })
            ]
        }),
        tagline: props.is2FaEnabled ? `While we strongly discourage it, you can disable two-factor authentication for your account.` : `Two-factor authentication is not enabled for your account.
                  Enable two-factor authentication for enhanced account security.`,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2579cfa538529ea8$export$635d1b58476adfbe), {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Button), {
                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                onClick: props.goToNext,
                type: "submit",
                children: [
                    props.is2FaEnabled ? "Disable" : "Enable",
                    " Two-Factor Authentication"
                ]
            })
        })
    });
};
$aacdb8c81c3d4f14$var$InitialStep.propTypes = {
    is2FaEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    goToNext: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $aacdb8c81c3d4f14$export$2e2bcd8739ae039 = $aacdb8c81c3d4f14$var$InitialStep;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");
var $0065ac31823e5d68$var$__defProp = Object.defineProperty;
var $0065ac31823e5d68$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0065ac31823e5d68$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0065ac31823e5d68$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0065ac31823e5d68$var$__defNormalProp = (obj, key, value)=>key in obj ? $0065ac31823e5d68$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0065ac31823e5d68$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0065ac31823e5d68$var$__hasOwnProp.call(b, prop)) $0065ac31823e5d68$var$__defNormalProp(a, prop, b[prop]);
    if ($0065ac31823e5d68$var$__getOwnPropSymbols) {
        for (var prop of $0065ac31823e5d68$var$__getOwnPropSymbols(b))if ($0065ac31823e5d68$var$__propIsEnum.call(b, prop)) $0065ac31823e5d68$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0065ac31823e5d68$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0065ac31823e5d68$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0065ac31823e5d68$var$__getOwnPropSymbols) {
        for (var prop of $0065ac31823e5d68$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0065ac31823e5d68$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $0065ac31823e5d68$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class {
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.modules = [];
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        getModules() {
            return this.modules;
        }
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    let QrCode = _QrCode;
    QrCode.MIN_VERSION = 1;
    QrCode.MAX_VERSION = 40;
    QrCode.PENALTY_N1 = 3;
    QrCode.PENALTY_N2 = 3;
    QrCode.PENALTY_N3 = 40;
    QrCode.PENALTY_N4 = 10;
    QrCode.ECC_CODEWORDS_PER_BLOCK = [
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    qrcodegen2.QrCode = QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class {
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        getData() {
            return this.bitData.slice();
        }
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substr(i + 1, 2), 16));
                i += 2;
            }
            return result;
        }
    };
    let QrSegment = _QrSegment;
    QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    qrcodegen2.QrSegment = QrSegment;
})($0065ac31823e5d68$var$qrcodegen || ($0065ac31823e5d68$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class {
            constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        let Ecc = _Ecc;
        Ecc.LOW = new _Ecc(0, 1);
        Ecc.MEDIUM = new _Ecc(1, 0);
        Ecc.QUARTILE = new _Ecc(2, 3);
        Ecc.HIGH = new _Ecc(3, 2);
        QrCode2.Ecc = Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($0065ac31823e5d68$var$qrcodegen || ($0065ac31823e5d68$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class {
            constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        let Mode = _Mode;
        Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        QrSegment2.Mode = Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($0065ac31823e5d68$var$qrcodegen || ($0065ac31823e5d68$var$qrcodegen = {}));
var $0065ac31823e5d68$var$qrcodegen_default = $0065ac31823e5d68$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $0065ac31823e5d68$var$ERROR_LEVEL_MAP = {
    L: $0065ac31823e5d68$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $0065ac31823e5d68$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $0065ac31823e5d68$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $0065ac31823e5d68$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $0065ac31823e5d68$var$DEFAULT_SIZE = 128;
var $0065ac31823e5d68$var$DEFAULT_LEVEL = "L";
var $0065ac31823e5d68$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $0065ac31823e5d68$var$DEFAULT_FGCOLOR = "#000000";
var $0065ac31823e5d68$var$DEFAULT_INCLUDEMARGIN = false;
var $0065ac31823e5d68$var$MARGIN_SIZE = 4;
var $0065ac31823e5d68$var$DEFAULT_IMG_SCALE = 0.1;
function $0065ac31823e5d68$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $0065ac31823e5d68$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $0065ac31823e5d68$var$getImageSettings(cells, size, includeMargin, imageSettings) {
    if (imageSettings == null) return null;
    const margin = includeMargin ? $0065ac31823e5d68$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $0065ac31823e5d68$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation
    };
}
var $0065ac31823e5d68$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
function $0065ac31823e5d68$export$7e3713cf0c0fe9d0(props) {
    const _a = props, { value: value, size: size = $0065ac31823e5d68$var$DEFAULT_SIZE, level: level = $0065ac31823e5d68$var$DEFAULT_LEVEL, bgColor: bgColor = $0065ac31823e5d68$var$DEFAULT_BGCOLOR, fgColor: fgColor = $0065ac31823e5d68$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $0065ac31823e5d68$var$DEFAULT_INCLUDEMARGIN, style: style, imageSettings: imageSettings } = _a, otherProps = $0065ac31823e5d68$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "style",
        "imageSettings"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, $70fFQ.useRef)(null);
    const _image = (0, $70fFQ.useRef)(null);
    const [isImgLoaded, setIsImageLoaded] = (0, $70fFQ.useState)(false);
    (0, $70fFQ.useEffect)(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cells = $0065ac31823e5d68$var$qrcodegen_default.QrCode.encodeText(value, $0065ac31823e5d68$var$ERROR_LEVEL_MAP[level]).getModules();
            const margin = includeMargin ? $0065ac31823e5d68$var$MARGIN_SIZE : 0;
            const numCells = cells.length + margin * 2;
            const calculatedImageSettings = $0065ac31823e5d68$var$getImageSettings(cells, size, includeMargin, imageSettings);
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cells = $0065ac31823e5d68$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($0065ac31823e5d68$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($0065ac31823e5d68$var$generatePath(cells, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, $70fFQ.useEffect)(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $0065ac31823e5d68$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("canvas", $0065ac31823e5d68$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: _canvas
    }, otherProps)), img);
}
function $0065ac31823e5d68$export$10307208e61210e9(props) {
    const _a = props, { value: value, size: size = $0065ac31823e5d68$var$DEFAULT_SIZE, level: level = $0065ac31823e5d68$var$DEFAULT_LEVEL, bgColor: bgColor = $0065ac31823e5d68$var$DEFAULT_BGCOLOR, fgColor: fgColor = $0065ac31823e5d68$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $0065ac31823e5d68$var$DEFAULT_INCLUDEMARGIN, imageSettings: imageSettings } = _a, otherProps = $0065ac31823e5d68$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "imageSettings"
    ]);
    let cells = $0065ac31823e5d68$var$qrcodegen_default.QrCode.encodeText(value, $0065ac31823e5d68$var$ERROR_LEVEL_MAP[level]).getModules();
    const margin = includeMargin ? $0065ac31823e5d68$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const calculatedImageSettings = $0065ac31823e5d68$var$getImageSettings(cells, size, includeMargin, imageSettings);
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cells = $0065ac31823e5d68$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("image", {
            xlinkHref: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none"
        });
    }
    const fgPath = $0065ac31823e5d68$var$generatePath(cells, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("svg", $0065ac31823e5d68$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`
    }, otherProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
}
var $0065ac31823e5d68$export$2e2bcd8739ae039 = (props)=>{
    const _a = props, { renderAs: renderAs } = _a, otherProps = $0065ac31823e5d68$var$__objRest(_a, [
        "renderAs"
    ]);
    if (renderAs === "svg") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($0065ac31823e5d68$export$10307208e61210e9, $0065ac31823e5d68$var$__spreadValues({}, otherProps));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($0065ac31823e5d68$export$7e3713cf0c0fe9d0, $0065ac31823e5d68$var$__spreadValues({}, otherProps));
};



var $70fFQ = parcelRequire("70fFQ");











const $8d4d30ddc633c090$var$StyledQRCode = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
`;
const $8d4d30ddc633c090$var$StyledQRCodeSVG = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $0065ac31823e5d68$export$10307208e61210e9))`
  border: 8px solid white;
  border-radius: 8px;
`;
const $8d4d30ddc633c090$var$TokenRegistrationStep = ({ goToPrevious: goToPrevious })=>{
    const { setUserData: setUserData } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const otpFormRef = (0, $70fFQ.useRef)();
    const validate = (value)=>value ? undefined : "Required";
    const tokenQueryInfo = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).TOKEN());
    const enable2faQuery = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).TOKEN(), false, {
        message: "Congratulations, you've successfully enabled two-factor authentication."
    });
    if (tokenQueryInfo.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    const token = tokenQueryInfo.cleanedData;
    const onSubmit = (values)=>{
        enable2faQuery.mutate(values, {
            onSuccess: ()=>{
                setUserData();
                navigate(0);
            }
        });
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Card), {
        title: "Enable Two-Factor Authentication",
        tagline: "To start using a token generator, please use your smartphone to scan the QR code below. For example, use Google Authenticator.",
        children: [
            token && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($8d4d30ddc633c090$var$StyledQRCode, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($8d4d30ddc633c090$var$StyledQRCodeSVG, {
                    value: token.provision_url,
                    bgColor: "#ffffff",
                    fgColor: "#1b1b1b",
                    size: "160"
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
                onSubmit: onSubmit,
                children: ({ handleSubmit: handleSubmit, submitting: submitting, dirty: dirty, valid: valid })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                    label: "Please enter the tokens generated by your token generator",
                                    name: "otp_token",
                                    placeholder: "Token",
                                    type: "text",
                                    validate: [
                                        validate
                                    ],
                                    ref: otpFormRef
                                })
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $2579cfa538529ea8$export$635d1b58476adfbe), {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                        onClick: goToPrevious,
                                        children: "Back"
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                        disabled: submitting || !dirty || !valid,
                                        type: "submit",
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
$8d4d30ddc633c090$var$TokenRegistrationStep.propTypes = {
    goToPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $8d4d30ddc633c090$export$2e2bcd8739ae039 = $8d4d30ddc633c090$var$TokenRegistrationStep;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");









var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");
const $65bd6cc08769cb23$var$getWithExpiry = (key)=>{
    const itemStr = window.localStorage.getItem(key);
    if (!itemStr) return null;
    // Delete if expired
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (item.expiry && now.getTime() > item.expiry) {
        window.localStorage.removeItem(key);
        return null;
    }
    return item.value;
};
const $65bd6cc08769cb23$var$setWithExpiry = (key, value, ttl = null)=>{
    const now = new Date();
    const item = {
        value: value,
        expiry: !(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(ttl) ? now.getTime() + ttl : null
    };
    window.localStorage.setItem(key, JSON.stringify(item));
};
const $65bd6cc08769cb23$var$removeItem = (key)=>{
    window.localStorage.removeItem(key);
};
const $65bd6cc08769cb23$var$useLocalStorage = ()=>{
    const getItem = (0, $70fFQ.useCallback)((key)=>$65bd6cc08769cb23$var$getWithExpiry(key), []);
    const setItem = (0, $70fFQ.useCallback)((key, value, ttl)=>$65bd6cc08769cb23$var$setWithExpiry(key, value, ttl), []);
    const deleteItem = (0, $70fFQ.useCallback)((key)=>$65bd6cc08769cb23$var$removeItem(key), []);
    return {
        getItem: getItem,
        setItem: setItem,
        deleteItem: deleteItem
    };
};
var $65bd6cc08769cb23$export$2e2bcd8739ae039 = $65bd6cc08769cb23$var$useLocalStorage;



const $d638277b5cdfa245$var$REMEMBER_2FA_KEY = "remember_2fa_token";
const $d638277b5cdfa245$var$DisableConfirmStep = ({ goToPrevious: goToPrevious })=>{
    const { setUserData: setUserData } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const { deleteItem: deleteItem } = (0, $65bd6cc08769cb23$export$2e2bcd8739ae039)();
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const validate = (value)=>value ? undefined : "Required";
    const disableTokenQuery = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CHANGE_ACCOUNT_SETTINGS(), true, {
        message: "Two-factor authentication successfully disabled."
    });
    const onSubmit = ()=>{
        disableTokenQuery.mutate({
            token_auth_enabled: false
        }, {
            onSuccess: ()=>{
                deleteItem($d638277b5cdfa245$var$REMEMBER_2FA_KEY);
                setUserData();
                navigate(0);
            }
        });
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: "Disable Two-Factor Authentication",
        tagline: "You are about to disable two-factor authentication. This weakens your account security, are you sure?",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
            onSubmit: onSubmit,
            children: ({ handleSubmit: handleSubmit, submitting: submitting, dirty: dirty, valid: valid })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.InputRow), {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                id: "confirm_disable",
                                name: "confirm_disable",
                                type: "checkbox",
                                label: "Yes, I am sure",
                                validate: [
                                    validate
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $2579cfa538529ea8$export$635d1b58476adfbe), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                    onClick: goToPrevious,
                                    children: "Back"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                    disabled: submitting || !dirty || !valid,
                                    type: "submit",
                                    children: "Disable"
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
$d638277b5cdfa245$var$DisableConfirmStep.propTypes = {
    goToPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $d638277b5cdfa245$export$2e2bcd8739ae039 = $d638277b5cdfa245$var$DisableConfirmStep;



var $cd0Jr = parcelRequire("cd0Jr");
// Main component to handle the 2fa wizard logic
const $0873baed80268b68$var$TwoFactorAuthentication = (props)=>{
    const [currentStep, setCurrentStep] = (0, $70fFQ.useState)(0);
    // Go to the next step
    const goToNext = ()=>{
        setCurrentStep(currentStep + 1);
    };
    // Go back to the previous step
    const goToPrevious = ()=>{
        setCurrentStep(currentStep - 1);
    };
    const enableSteps = [
        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $aacdb8c81c3d4f14$export$2e2bcd8739ae039), {
            goToNext: goToNext,
            is2FaEnabled: props.user?.token_auth_enabled
        }, "initial-step"),
        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $8d4d30ddc633c090$export$2e2bcd8739ae039), {
            goToPrevious: goToPrevious
        }, "token-registration")
    ];
    const disableSteps = [
        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $aacdb8c81c3d4f14$export$2e2bcd8739ae039), {
            goToNext: goToNext,
            is2FaEnabled: props.user?.token_auth_enabled
        }, "initial-step"),
        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d638277b5cdfa245$export$2e2bcd8739ae039), {
            goToPrevious: goToPrevious
        }, "disable-confirm")
    ];
    return props.user?.token_auth_enabled ? disableSteps[currentStep] : enableSteps[currentStep];
};
$0873baed80268b68$var$TwoFactorAuthentication.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        token_auth_enabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
    })
};
var $0873baed80268b68$export$2e2bcd8739ae039 = $0873baed80268b68$var$TwoFactorAuthentication;


var $02c68cc883f400db$export$2e2bcd8739ae039 = (0, $0873baed80268b68$export$2e2bcd8739ae039);





const $a7ce25f64c8a45a1$export$1a50cbca5efbfbf9 = (user)=>`${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();




var $70fFQ = parcelRequire("70fFQ");
/**
 * Add this to the top of any component to set the page title.
 * The title will reset to "ZXData" afterwards as a safe default,
 * but assuming some other component is mounted subsequently, we should
 * have smooth transitions between titles
 *
 * See https://dev.to/luispa/how-to-add-a-dynamic-title-on-your-react-app-1l7k
 * for the inspiration
 *
 * @param {string} title - the title for the page
 */ function $90c290bf538e7f9d$var$useDocumentTitle(title) {
    (0, $70fFQ.useEffect)(()=>{
        document.title = title;
        return ()=>{
            document.title = "ZXData";
        };
    }, [
        title
    ]);
}
var $90c290bf538e7f9d$export$2e2bcd8739ae039 = $90c290bf538e7f9d$var$useDocumentTitle;




const $27107782d824bd56$export$5e3a8d80984ffe28 = (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
  width: min(100%, 1320px);
`;


const $e9eb03c4b2170285$var$StyledAccountContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  padding-top: 48px;
  gap: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
`;
const $e9eb03c4b2170285$var$CardContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  flex-grow: 1;
`;
const $e9eb03c4b2170285$var$PAGES = {
    ACCOUNT: "account",
    PASSWORD: "password",
    EMAIL: "email",
    TWO_FACTOR_AUTH: "2fa"
};
/**
 * Returns the Account information component
 *
 * @returns {React.Element}
 */ const $e9eb03c4b2170285$var$AccountSettings = ()=>{
    (0, $90c290bf538e7f9d$export$2e2bcd8739ae039)("ZXData: Account");
    const [page, setPage] = (0, $70fFQ.useState)($e9eb03c4b2170285$var$PAGES.ACCOUNT);
    const userQueryInfo = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).USER(), {}, {
        keepPreviousData: true
    });
    if (userQueryInfo.isError) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
        children: "An error occurred"
    });
    if (userQueryInfo.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    const user = userQueryInfo.cleanedData;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($e9eb03c4b2170285$var$StyledAccountContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListItem), {
                listStyle: (0, $dfd33cee3229493c$exports.ListStyles).TWO_LINE,
                text: `${(0, $a7ce25f64c8a45a1$export$1a50cbca5efbfbf9)(user)} / Account`,
                subtext: "Manage your account info and security",
                avatar: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7759a50ff4d048a0$export$2e2bcd8739ae039), {
                    user: user
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $2579cfa538529ea8$export$81761b52b04ea573), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.FloatingNavigation), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.NavigationItem), {
                                selected: page === $e9eb03c4b2170285$var$PAGES.ACCOUNT,
                                onClick: ()=>page !== $e9eb03c4b2170285$var$PAGES.ACCOUNT ? setPage($e9eb03c4b2170285$var$PAGES.ACCOUNT) : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
                                children: "Account Information"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.NavigationItem), {
                                selected: page === $e9eb03c4b2170285$var$PAGES.EMAIL,
                                onClick: ()=>page !== $e9eb03c4b2170285$var$PAGES.EMAIL ? setPage($e9eb03c4b2170285$var$PAGES.EMAIL) : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.NavigationItem), {
                                selected: page === $e9eb03c4b2170285$var$PAGES.PASSWORD,
                                onClick: ()=>page !== $e9eb03c4b2170285$var$PAGES.PASSWORD ? setPage($e9eb03c4b2170285$var$PAGES.PASSWORD) : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.NavigationItem), {
                                selected: page === $e9eb03c4b2170285$var$PAGES.TWO_FACTOR_AUTH,
                                onClick: ()=>page !== $e9eb03c4b2170285$var$PAGES.TWO_FACTOR_AUTH ? setPage($e9eb03c4b2170285$var$PAGES.TWO_FACTOR_AUTH) : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
                                children: "Two-Factor Authentication"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($e9eb03c4b2170285$var$CardContainer, {
                        children: [
                            page === $e9eb03c4b2170285$var$PAGES.ACCOUNT && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f12c13297c011f88$export$2e2bcd8739ae039), {
                                user: user
                            }),
                            page === $e9eb03c4b2170285$var$PAGES.EMAIL && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3f8b69bff344b58f$export$2e2bcd8739ae039), {
                                user: user
                            }),
                            page === $e9eb03c4b2170285$var$PAGES.PASSWORD && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ba93553e8cd5f72b$export$2e2bcd8739ae039), {
                                userId: user.id
                            }),
                            page === $e9eb03c4b2170285$var$PAGES.TWO_FACTOR_AUTH && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $02c68cc883f400db$export$2e2bcd8739ae039), {
                                user: user
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e9eb03c4b2170285$export$2e2bcd8739ae039 = $e9eb03c4b2170285$var$AccountSettings;


var $1264b55b25318845$export$2e2bcd8739ae039 = (0, $e9eb03c4b2170285$export$2e2bcd8739ae039);










const $5caae8b793832a8d$var$SideNavigationBar = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-sizing: border-box;
  height: 100vh;
  padding: 0px 12px;
  overflow-y: auto;
  width: 240px;
`;
const $5caae8b793832a8d$var$StyledNavigationHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 24px 12px 64px;
`;
const $5caae8b793832a8d$var$StyledNavigationSection = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  margin-bottom: 32px;
`;
const $5caae8b793832a8d$var$AgreementsSideNav = ()=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5caae8b793832a8d$var$SideNavigationBar, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5caae8b793832a8d$var$StyledNavigationHeader, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $146a4380c9eee20d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5caae8b793832a8d$var$StyledNavigationSection, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.List), {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListHeader), {
                            children: "Terms and Agreements"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListItem), {
                            onClick: ()=>navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("privacy")),
                            text: "Privacy Policy"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListItem), {
                            onClick: ()=>navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("tou")),
                            text: "Terms of Use"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListItem), {
                            onClick: ()=>navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("nda")),
                            text: "Non-Disclosure Agreement"
                        })
                    ]
                })
            })
        ]
    });
};
var $5caae8b793832a8d$export$2e2bcd8739ae039 = $5caae8b793832a8d$var$AgreementsSideNav;




var $cd0Jr = parcelRequire("cd0Jr");



var $hI4Hx = parcelRequire("hI4Hx");







const $27ad40e6a36f9ef2$var$StyledAgreementsPanel = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 24px 24px 0;
  width: 100%;
  > :first-child {
    margin-bottom: 12px;
  }
  ${(0, $dfd33cee3229493c$exports.body1)};
  ${(0, $dfd33cee3229493c$exports.FontColors).theme500}
`;
const $27ad40e6a36f9ef2$var$StyledIFrame = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).iframe`
  border: 0;
  height: 100%;
  width: 100%;
`;
const $27ad40e6a36f9ef2$var$StyledAgreementButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Button))`
  margin: 20px;
  width: 300px;
`;
const $27ad40e6a36f9ef2$var$StyledContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin: 10px 20px;
  display: flex;
  flex-direction: column;
`;
const $27ad40e6a36f9ef2$var$StyledCard = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Card))`
  margin: 10px 0 20px 0;
  overflow: hidden;
  min-height: 150px;
`;
const $27ad40e6a36f9ef2$var$StyledButtonWrapper = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
`;
/**
 * Component used to render the content of an agreement.
 * requires the title and html content of the agreement to render
 *
 * @param {object} props
 * @returns {Element}
 */ const $27ad40e6a36f9ef2$var$AgreementContentView = ()=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const params = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const agreement = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).AGREEMENT(""), {
        agreement_type: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).get((0, $0a76e47e1183ea12$export$c0ffa675b87aff), params.type)
    });
    const signAgreement = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SIGN_AGREEMENT(), false, {
        silent: true
    });
    if (agreement.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    const agreement_data = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).head(agreement.cleanedData);
    const agreement_files = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).head(agreement_data?.agreement_files);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(agreement_files)) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
        children: "File not found!"
    });
    const agreement_url = agreement_files.agreement_doc;
    const handleAcceptAgreement = ()=>{
        signAgreement.mutate({
            agreement_type: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).get((0, $0a76e47e1183ea12$export$c0ffa675b87aff), params.type)
        }, {
            onSuccess: ()=>{
                navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN());
            }
        });
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($27ad40e6a36f9ef2$var$StyledAgreementsPanel, {
        className: "elevation1",
        children: [
            !agreement_data.accepted && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($27ad40e6a36f9ef2$var$StyledCard, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($27ad40e6a36f9ef2$var$StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                            children: [
                                "To proceed, please review the ZXData agreement and click\xa0",
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("b", {
                                    children: "Accept Agreement"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($27ad40e6a36f9ef2$var$StyledButtonWrapper, {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($27ad40e6a36f9ef2$var$StyledAgreementButton, {
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                onClick: handleAcceptAgreement,
                                children: "Accept Agreement"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.StyledHeadline1), {
                    children: agreement_data.title
                })
            }),
            agreement_files.agreement_doc && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($27ad40e6a36f9ef2$var$StyledIFrame, {
                src: agreement_url,
                title: agreement_data.title
            })
        ]
    });
};
$27ad40e6a36f9ef2$var$AgreementContentView.propTypes = {
    content: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
$27ad40e6a36f9ef2$var$AgreementContentView.defaultProps = {
    url: ""
};
var $27ad40e6a36f9ef2$export$2e2bcd8739ae039 = $27ad40e6a36f9ef2$var$AgreementContentView;


const $d0d028f6372c04f9$var$StyledDocView = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $d0d028f6372c04f9$var$DocView = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($d0d028f6372c04f9$var$StyledDocView, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5caae8b793832a8d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $27ad40e6a36f9ef2$export$2e2bcd8739ae039), {})
        ]
    });
var $d0d028f6372c04f9$export$2e2bcd8739ae039 = $d0d028f6372c04f9$var$DocView;






const $f5a68a16bc4b55a2$var$BannerWrapper = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: ${({ color: color })=>{
    if (color === "PROBLEM") return "#e53e3e";
    if (color === "WARNING") return "#dd6b20";
    if (color === "REWARD") return "#38a169";
    return "#3182ce";
}};
  color: white;
  font-size: 14px;
`;
const $f5a68a16bc4b55a2$var$CloseButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 0 4px;
`;
const $f5a68a16bc4b55a2$var$BannerCard = ({ text: text, color: color, onClose: onClose })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f5a68a16bc4b55a2$var$BannerWrapper, {
        color: color,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: text
            }),
            onClose && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f5a68a16bc4b55a2$var$CloseButton, {
                onClick: onClose,
                children: "\xd7"
            })
        ]
    });
const $f5a68a16bc4b55a2$var$BannerList = ()=>{
    const currentBanner = (0, $46a097389bbbbe65$export$2105062e25df4afe)((state)=>state.banners[0]);
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const handleClose = ()=>{
        if (currentBanner && currentBanner.onClose) currentBanner.onClose();
        dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).removeBanner
        });
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
        children: currentBanner && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f5a68a16bc4b55a2$var$BannerCard, {
            id: currentBanner.id,
            text: currentBanner.message,
            color: currentBanner.color,
            onClose: handleClose
        })
    });
};
var $f5a68a16bc4b55a2$export$2e2bcd8739ae039 = $f5a68a16bc4b55a2$var$BannerList;




var $70fFQ = parcelRequire("70fFQ");






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");



const $6fe5203b57b507ea$var$StyledCompanyNameContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
`;
const $6fe5203b57b507ea$var$StyledAvatarPlaceholder = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $f82caaae0faa7ac9$export$2e2bcd8739ae039))`
  border-radius: 50%;
`;
const $6fe5203b57b507ea$var$CompanyCellRenderer = ({ value: { name: name, avatar: avatar } })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6fe5203b57b507ea$var$StyledCompanyNameContainer, {
        children: [
            avatar ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Avatar), {
                avatar: avatar,
                avatarAlt: name.slice(0, 2).toUpperCase(),
                size: "24px"
            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6fe5203b57b507ea$var$StyledAvatarPlaceholder, {
                iconSize: 24
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                children: name
            })
        ]
    });
};
$6fe5203b57b507ea$var$CompanyCellRenderer.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    })
};
var $6fe5203b57b507ea$export$2e2bcd8739ae039 = $6fe5203b57b507ea$var$CompanyCellRenderer;




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");


const $2551481dcc2e9273$export$267f7ff9a66227a8 = "Loading...";
const $2551481dcc2e9273$export$4c84ac3c8d18afa6 = "watchlist";
const $2551481dcc2e9273$export$273d5e0c912ace6e = "robustness";
const $2551481dcc2e9273$export$2d53b25b9cc4bff4 = "zx_index_value_change";
const $2551481dcc2e9273$export$3107559fca62635f = "last_round_price_diff";
const $2551481dcc2e9273$export$d9a40271e7b2217c = "Watching";
const $2551481dcc2e9273$export$a009aff2df671150 = "Not watching";
const $2551481dcc2e9273$export$eb3d1c509817ff28 = {
    [$2551481dcc2e9273$export$d9a40271e7b2217c]: true,
    [$2551481dcc2e9273$export$a009aff2df671150]: false
};
const $2551481dcc2e9273$var$THIRTY_PERCENT_AND_ABOVE = "30% and above";
const $2551481dcc2e9273$var$TWENTY_PERCENT_AND_ABOVE = "20% and above";
const $2551481dcc2e9273$var$TEN_PERCENT_AND_ABOVE = "10% and above";
const $2551481dcc2e9273$var$ZERO_TO_FIVE_PERCENT = "0% to 5%";
const $2551481dcc2e9273$var$ZERO_PERCENT_AND_BELOW = "0% and below";
const $2551481dcc2e9273$var$ZERO_TO_NEGATIVE_FIVE_PERCENT = "0% to -5%";
const $2551481dcc2e9273$var$NEGATIVE_FIVE_PERCENT_AND_BELOW = "-5% and below";
const $2551481dcc2e9273$var$NEGATIVE_TEN_PERCENT_AND_BELOW = "-10% and below";
const $2551481dcc2e9273$var$NEGATIVE_TWENTY_PERCENT_AND_BELOW = "-20% and below";
const $2551481dcc2e9273$var$NEGATIVE_THIRTY_PERCENT_AND_BELOW = "-30% and below";
const $2551481dcc2e9273$var$NINE_AND_ABOVE = "9 and above";
const $2551481dcc2e9273$var$EIGHT_AND_ABOVE = "8 and above";
const $2551481dcc2e9273$var$SEVEN_AND_ABOVE = "7 and above";
const $2551481dcc2e9273$var$FOUR_TO_SIX = "4 to 6";
const $2551481dcc2e9273$var$THREE_AND_BELOW = "3 and below";
const $2551481dcc2e9273$export$b4756409cd4ced1a = {
    [$2551481dcc2e9273$var$THIRTY_PERCENT_AND_ABOVE]: {
        min: 30,
        max: null
    },
    [$2551481dcc2e9273$var$TWENTY_PERCENT_AND_ABOVE]: {
        min: 20,
        max: null
    },
    [$2551481dcc2e9273$var$TEN_PERCENT_AND_ABOVE]: {
        min: 10,
        max: null
    },
    [$2551481dcc2e9273$var$ZERO_TO_FIVE_PERCENT]: {
        min: 0,
        max: 5
    },
    [$2551481dcc2e9273$var$ZERO_PERCENT_AND_BELOW]: {
        min: null,
        max: 0
    },
    [$2551481dcc2e9273$var$ZERO_TO_NEGATIVE_FIVE_PERCENT]: {
        min: -5,
        max: 0
    },
    [$2551481dcc2e9273$var$NEGATIVE_FIVE_PERCENT_AND_BELOW]: {
        min: null,
        max: -5
    },
    [$2551481dcc2e9273$var$NEGATIVE_TEN_PERCENT_AND_BELOW]: {
        min: null,
        max: -10
    },
    [$2551481dcc2e9273$var$NEGATIVE_TWENTY_PERCENT_AND_BELOW]: {
        min: null,
        max: -20
    },
    [$2551481dcc2e9273$var$NEGATIVE_THIRTY_PERCENT_AND_BELOW]: {
        min: null,
        max: -30
    },
    [$2551481dcc2e9273$var$NINE_AND_ABOVE]: {
        min: 9,
        max: null
    },
    [$2551481dcc2e9273$var$EIGHT_AND_ABOVE]: {
        min: 8,
        max: null
    },
    [$2551481dcc2e9273$var$SEVEN_AND_ABOVE]: {
        min: 7,
        max: null
    },
    [$2551481dcc2e9273$var$FOUR_TO_SIX]: {
        min: 4,
        max: 6
    },
    [$2551481dcc2e9273$var$THREE_AND_BELOW]: {
        min: null,
        max: 3
    }
};
const $2551481dcc2e9273$export$d705ab93b2e7e1c8 = [
    $2551481dcc2e9273$export$d9a40271e7b2217c,
    $2551481dcc2e9273$export$a009aff2df671150
];
const $2551481dcc2e9273$export$355404e82408ab2a = [
    $2551481dcc2e9273$var$THIRTY_PERCENT_AND_ABOVE,
    $2551481dcc2e9273$var$TWENTY_PERCENT_AND_ABOVE,
    $2551481dcc2e9273$var$TEN_PERCENT_AND_ABOVE,
    $2551481dcc2e9273$var$ZERO_TO_FIVE_PERCENT,
    $2551481dcc2e9273$var$ZERO_PERCENT_AND_BELOW,
    $2551481dcc2e9273$var$ZERO_TO_NEGATIVE_FIVE_PERCENT,
    $2551481dcc2e9273$var$NEGATIVE_FIVE_PERCENT_AND_BELOW,
    $2551481dcc2e9273$var$NEGATIVE_TEN_PERCENT_AND_BELOW,
    $2551481dcc2e9273$var$NEGATIVE_TWENTY_PERCENT_AND_BELOW,
    $2551481dcc2e9273$var$NEGATIVE_THIRTY_PERCENT_AND_BELOW
];
const $2551481dcc2e9273$export$20b663052f862f52 = [
    $2551481dcc2e9273$var$NINE_AND_ABOVE,
    $2551481dcc2e9273$var$EIGHT_AND_ABOVE,
    $2551481dcc2e9273$var$SEVEN_AND_ABOVE,
    $2551481dcc2e9273$var$FOUR_TO_SIX,
    $2551481dcc2e9273$var$THREE_AND_BELOW
];
const $2551481dcc2e9273$export$a0ffc7e106c34dd3 = [
    ...$2551481dcc2e9273$export$355404e82408ab2a
];




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");



var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



const $c45be5d48c4611e5$export$3385e4952449b877 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
`;


const $f0895775776f2044$var$HighlightedValue = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80)`
  color: ${(props)=>props.theme.colors.branding400};
`;
/**
 * Button presentational component to render the normal button children, with the addition of a
 * highlighted value. All values are contained in a flexbox with the children on the left
 * and the highlighted value on the right (still to the left of the trailing icon).
 */ const $f0895775776f2044$var$HighlightedValueButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ children: children, highlightedValue: highlightedValue, ...props }, ref)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $c45be5d48c4611e5$export$3385e4952449b877), {
            children: [
                children,
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f0895775776f2044$var$HighlightedValue, {
                    children: highlightedValue
                })
            ]
        })
    }));
$f0895775776f2044$var$HighlightedValueButton.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired,
    highlightedValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node
};
var $f0895775776f2044$export$2e2bcd8739ae039 = $f0895775776f2044$var$HighlightedValueButton;


/**
 * Wrapper for HighlightedValueButton that includes a dropdown to select a value to highlight.
 * Does not manage its own value, value must be provided in props.
 *
 * @param name
 * @param value
 * @param onChange
 * @param RenderDropdown
 * @param children
 * @param props
 * @return {JSX.Element}
 */ const $b3e62bbe3bd62a1f$var$FilterButton = ({ dropdownComponent: RenderDropdown, children: children, value: value, onChange: onChange, ...props })=>{
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)((dropdownProps)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(RenderDropdown, {
            ...dropdownProps,
            value: value,
            onChange: (newValue)=>onChange(newValue)
        }));
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f0895775776f2044$export$2e2bcd8739ae039), {
                selected: Boolean(value),
                ref: dropdownRef,
                onClick: toggleDropdown,
                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                trailingIcon: dropdownElement ? (0, $dfd33cee3229493c$exports.ChevronUpIcon) : (0, $dfd33cee3229493c$exports.ChevronDownIcon),
                highlightedValue: value,
                ...props,
                children: children
            }),
            dropdownElement
        ]
    });
};
$b3e62bbe3bd62a1f$var$FilterButton.propTypes = {
    dropdownComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    ]),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $b3e62bbe3bd62a1f$export$2e2bcd8739ae039 = $b3e62bbe3bd62a1f$var$FilterButton;




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");




/* eslint-disable no-console, no-undef */ 
var $70fFQ = parcelRequire("70fFQ");


/* eslint-disable */ /* global navigator */ /**
 * Ported from mixpanel-browser library.
 * Adapted to only port the necessary values
 *
 * Content in this file is directly copied from zanbato/zanbato/frontend/utils/mixpanelHelpers.js
 */ 
var $hI4Hx = parcelRequire("hI4Hx");
const $c336d099c8d4b65a$var$userAgent = navigator.userAgent;
const $c336d099c8d4b65a$var$stripEmptyProperties = (p)=>{
    const ret = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).forEach(p, (v, k)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/**
 * This function detects which browser is running this script.
 * The order of the checks are important since many user agents
 * include key words used in later checks.
 */ function $c336d099c8d4b65a$var$_browser(user_agent, vendor, opera) {
    vendor = vendor || ""; // vendor is undefined for at least IE9
    if (opera || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, " OPR/")) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Mini")) return "Opera Mini";
        return "Opera";
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "IEMobile") || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "WPDesktop")) return "Internet Explorer Mobile";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "SamsungBrowser/")) // https://developer.samsung.com/internet/user-agent-string-format
    return "Samsung Internet";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Edge") || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Edg/")) return "Microsoft Edge";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "FBIOS")) return "Facebook Mobile";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Chrome")) return "Chrome";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "CriOS")) return "Chrome iOS";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "UCWEB") || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "UCBrowser")) return "UC Browser";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "FxiOS")) return "Firefox iOS";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(vendor, "Apple")) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Mobile")) return "Mobile Safari";
        return "Safari";
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Android")) return "Android Mobile";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Konqueror")) return "Konqueror";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Firefox")) return "Firefox";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "MSIE") || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Trident/")) return "Internet Explorer";
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(user_agent, "Gecko")) return "Mozilla";
    else return "";
}
/**
 * This function detects which browser version is running this script,
 * parsing major and minor version (e.g., 42.1). User agent strings from:
 * http://www.useragentstring.com/pages/useragentstring.php
 */ function $c336d099c8d4b65a$var$_browserVersion(userAgent, vendor, opera) {
    const browser = $c336d099c8d4b65a$var$_browser(userAgent, vendor, opera);
    const versionRegexs = {
        "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
        "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
        Chrome: /Chrome\/(\d+(\.\d+)?)/,
        "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
        "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
        Safari: /Version\/(\d+(\.\d+)?)/,
        "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
        Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
        Firefox: /Firefox\/(\d+(\.\d+)?)/,
        "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
        Konqueror: /Konqueror:(\d+(\.\d+)?)/,
        BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
        "Android Mobile": /android\s(\d+(\.\d+)?)/,
        "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
        "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
        Mozilla: /rv:(\d+(\.\d+)?)/
    };
    var regex = versionRegexs[browser];
    if (regex === undefined) return null;
    var matches = userAgent.match(regex);
    if (!matches) return null;
    return parseFloat(matches[matches.length - 2]);
}
function $c336d099c8d4b65a$var$_os() {
    var a = $c336d099c8d4b65a$var$userAgent;
    if (/Windows/i.test(a)) {
        if (/Phone/.test(a) || /WPDesktop/.test(a)) return "Windows Phone";
        return "Windows";
    } else if (/(iPhone|iPad|iPod)/.test(a)) return "iOS";
    else if (/Android/.test(a)) return "Android";
    else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return "BlackBerry";
    else if (/Mac/i.test(a)) return "Mac OS X";
    else if (/Linux/.test(a)) return "Linux";
    else if (/CrOS/.test(a)) return "Chrome OS";
    else return "";
}
function $c336d099c8d4b65a$var$_device(user_agent) {
    if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return "Windows Phone";
    else if (/iPad/.test(user_agent)) return "iPad";
    else if (/iPod/.test(user_agent)) return "iPod Touch";
    else if (/iPhone/.test(user_agent)) return "iPhone";
    else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
    else if (/Android/.test(user_agent)) return "Android";
    else return "";
}
const $c336d099c8d4b65a$export$3cb21709c4058847 = ()=>({
        ...$c336d099c8d4b65a$var$stripEmptyProperties({
            $os: $c336d099c8d4b65a$var$_os(),
            $browser: $c336d099c8d4b65a$var$_browser($c336d099c8d4b65a$var$userAgent, navigator.vendor, window.opera),
            $referrer: document.referrer,
            $device: $c336d099c8d4b65a$var$_device($c336d099c8d4b65a$var$userAgent)
        }),
        $current_url: window.location.href,
        $browser_version: $c336d099c8d4b65a$var$_browserVersion($c336d099c8d4b65a$var$userAgent, navigator.vendor, window.opera),
        $screen_height: window.screen.height,
        $screen_width: window.screen.width,
        time: Date.now() / 1000
    });
const $c336d099c8d4b65a$export$d085728b49dd60c4 = ()=>({
        ...$c336d099c8d4b65a$var$stripEmptyProperties({
            $os: $c336d099c8d4b65a$var$_os(),
            $browser: $c336d099c8d4b65a$var$_browser($c336d099c8d4b65a$var$userAgent, navigator.vendor, window.opera)
        }),
        $browser_version: $c336d099c8d4b65a$var$_browserVersion($c336d099c8d4b65a$var$userAgent, navigator.vendor, window.opera)
    });



const $8e8dba6047d43ae4$var$MixpanelAPI = {
    setPeople: (browserProperties)=>(0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).MIXPANEL_SET_PEOPLE(), {
            properties: browserProperties
        }),
    track: (event, data)=>(0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).MIXPANEL_TRACK(), {
            event_name: event,
            ...data
        })
};
const $8e8dba6047d43ae4$export$66cf78a45ab85b85 = (eventName, data)=>{
    const trackData = data || {};
    $8e8dba6047d43ae4$var$MixpanelAPI.track(eventName, {
        ...(0, $c336d099c8d4b65a$export$3cb21709c4058847)(),
        ...trackData
    }).catch(()=>{});
};
const $8e8dba6047d43ae4$export$3d5853f50227afa0 = ({ children: children })=>{
    const [mixpanelLoaded, setMixpanelLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(false);
    const { user: user } = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useContext((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    if (user && !mixpanelLoaded) {
        $8e8dba6047d43ae4$var$MixpanelAPI.setPeople((0, $c336d099c8d4b65a$export$d085728b49dd60c4)()).catch(()=>{});
        setMixpanelLoaded(true);
    }
    return children;
};


const $9f7f80bd8f655910$export$bbe54dd70c4c891d = "companySearch";
const $9f7f80bd8f655910$export$c95120c046e3a0ee = "companySearchMatch";
const $9f7f80bd8f655910$export$499338e8263ebdba = "hasResults";
const $9f7f80bd8f655910$export$20b894bc7afa3bd9 = "noMatches";
const $9f7f80bd8f655910$export$d436565424d2e13d = "alreadyInPortfolio";
const $9f7f80bd8f655910$export$c96ddd097772fcd0 = "selectedCompany";
const $9f7f80bd8f655910$export$c13286d94aaa5103 = "Added date";
const $9f7f80bd8f655910$export$6cf98e810f90594d = "Company";
const $9f7f80bd8f655910$export$6c4ab75a3515ea8b = "ZX Index Value";
const $9f7f80bd8f655910$export$e7c1e6cedf6dc420 = "Custom valuation";
const $9f7f80bd8f655910$export$dad3cfc9bdd61ce9 = "Quantity";
const $9f7f80bd8f655910$export$de49b66bcf2dd882 = "Total value";
const $9f7f80bd8f655910$export$44a2577ec4dcfcb9 = "Unrealized gain";
const $9f7f80bd8f655910$export$f11b9f8160aec5e8 = [
    $9f7f80bd8f655910$export$c13286d94aaa5103,
    $9f7f80bd8f655910$export$6cf98e810f90594d,
    $9f7f80bd8f655910$export$6c4ab75a3515ea8b,
    $9f7f80bd8f655910$export$e7c1e6cedf6dc420,
    $9f7f80bd8f655910$export$dad3cfc9bdd61ce9,
    $9f7f80bd8f655910$export$de49b66bcf2dd882,
    $9f7f80bd8f655910$export$44a2577ec4dcfcb9
];
const $9f7f80bd8f655910$export$4f3e3139f0bd00ce = {
    [$9f7f80bd8f655910$export$c13286d94aaa5103]: "added date",
    [$9f7f80bd8f655910$export$6cf98e810f90594d]: "company",
    [$9f7f80bd8f655910$export$6c4ab75a3515ea8b]: "ZX Index Value",
    [$9f7f80bd8f655910$export$e7c1e6cedf6dc420]: "custom valuation",
    [$9f7f80bd8f655910$export$dad3cfc9bdd61ce9]: "quantity",
    [$9f7f80bd8f655910$export$de49b66bcf2dd882]: "total value",
    [$9f7f80bd8f655910$export$44a2577ec4dcfcb9]: "unrealized gain"
};
const $9f7f80bd8f655910$export$8a1c64667c571941 = "Ascending";
const $9f7f80bd8f655910$export$3c419d7277cff7a7 = "Descending";
const $9f7f80bd8f655910$export$d4c8db9df56aeb7b = [
    $9f7f80bd8f655910$export$8a1c64667c571941,
    $9f7f80bd8f655910$export$3c419d7277cff7a7
];
const $9f7f80bd8f655910$var$REMOVED_REASON_IPO = 1;
const $9f7f80bd8f655910$var$REMOVED_REASON_ACQUIRED = 2;
const $9f7f80bd8f655910$var$REMOVED_REASON_OUT_OF_BUSINESS = 3;
const $9f7f80bd8f655910$var$REMOVED_REASON_SANCTIONED = 4;
const $9f7f80bd8f655910$var$REMOVED_REASON_FEDERAL_LAW = 5;
const $9f7f80bd8f655910$var$REMOVED_REASON_STATE_LAW = 6;
const $9f7f80bd8f655910$var$REMOVED_REASON_BANKRUPT = 7;
const $9f7f80bd8f655910$var$REMOVED_REASON_SPAC = 8;
const $9f7f80bd8f655910$var$REMOVED_REASON_DIRECT_LISTING = 9;
/*
 * Maps the removed reasons to how they're displayed for the portfolio table.
 */ const $9f7f80bd8f655910$export$7f9ed126330db964 = {
    [$9f7f80bd8f655910$var$REMOVED_REASON_IPO]: "IPO",
    [$9f7f80bd8f655910$var$REMOVED_REASON_ACQUIRED]: "Acquired",
    [$9f7f80bd8f655910$var$REMOVED_REASON_OUT_OF_BUSINESS]: "Out of Business",
    [$9f7f80bd8f655910$var$REMOVED_REASON_SANCTIONED]: "Sanctioned",
    [$9f7f80bd8f655910$var$REMOVED_REASON_FEDERAL_LAW]: "Federal Law",
    [$9f7f80bd8f655910$var$REMOVED_REASON_STATE_LAW]: "State Law",
    [$9f7f80bd8f655910$var$REMOVED_REASON_BANKRUPT]: "Bankrupt",
    [$9f7f80bd8f655910$var$REMOVED_REASON_SPAC]: "SPAC",
    [$9f7f80bd8f655910$var$REMOVED_REASON_DIRECT_LISTING]: "Direct Listing"
};
/*
 * Portfolio viewing modes.
 */ const $9f7f80bd8f655910$export$55eb0e54fb69f7d9 = "zx-index-value";
const $9f7f80bd8f655910$export$9ca75af4009e4fa2 = "custom-valuation";
// We need this map b/c IDs can't have whitespace and the above 2 constants will be IDs.
const $9f7f80bd8f655910$export$1fe3b47417c4ee2d = {
    [$9f7f80bd8f655910$export$55eb0e54fb69f7d9]: "zx index value",
    [$9f7f80bd8f655910$export$9ca75af4009e4fa2]: "custom valuation"
};



var $70fFQ = parcelRequire("70fFQ");


const $b432f056c3259fac$export$b34c7ae3fd8138d2 = "ArrowUp";
const $b432f056c3259fac$export$1734a06b2397c2a8 = "ArrowDown";
const $b432f056c3259fac$export$8152f929a25a0ff4 = "Enter";
const $b432f056c3259fac$export$391dcf4886d760e9 = "NumpadEnter";
const $b432f056c3259fac$export$929c2026f4dd54a2 = "Escape";
const $b432f056c3259fac$export$4893289f1f957ad8 = "Slash";
// Global registry of hotkeys we use to toggle things across the page regardless of current
// context.
const $b432f056c3259fac$var$FOCUS_CHANGING_HOTKEYS = {
    [$b432f056c3259fac$export$4893289f1f957ad8]: true
};
// Focus-holding element types that prevent hotkey triggering while focussed.
const $b432f056c3259fac$var$FOCUS_HOLDING_ELEMENTS = {
    input: true,
    textarea: true
};
/**
 * Custom hook to handle hotkeys. Taps into the global hotkey registry to ensure that focus-taking
 * hotkeys are not available when focusable elements are in focus. Example: if we're typing in a
 * text input, we don't want "/" in our text to trigger the global company search.
 *
 * @param hotkeys {object} - Object of hotkeys to register for the component.
 *  Maps key codes to callback functions, in addition to a boolean indicating whether the shift key
 *  being pressed should cancel the callback trigger.
 *  Example:
 *  {
 *    "Enter": {
 *      callback: () => console.log("Enter pressed"),
 *      shiftDisabled: true, // Indicates that if the Shift key is pressed, the callback is not
 *                           // triggered.
 *    },
 *  }
 */ const $b432f056c3259fac$var$useHotkeys = (hotkeys)=>{
    const { state: { hotkeysEnabled: stateHotkeysEnabled } } = (0, $70fFQ.useContext)((0, $46a097389bbbbe65$export$7feebea0001a7c34));
    const handleKeyDown = (0, $70fFQ.useCallback)((event)=>{
        // hotkeysEnabled only applies to focus-taking hotkeys, so that arrow keys and Enter still work
        // for navigating dropdown lists created by focusable elements.
        if (!(event.code in hotkeys)) return; // Unused key.
        const hotkeysEnabled = !$b432f056c3259fac$var$FOCUS_HOLDING_ELEMENTS[document.activeElement.localName] && stateHotkeysEnabled;
        if (!hotkeysEnabled && event.code in $b432f056c3259fac$var$FOCUS_CHANGING_HOTKEYS) return; // Do nothing.
        if (event.shiftKey && hotkeys[event.code].shiftDisabled) return;
        const success = hotkeys[event.code].callback(event);
        if (success) // eslint thinks this MixpanelEvents.useHotkey is a react hook because of its name
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).useHotkey(event.code);
    }, [
        hotkeys,
        stateHotkeysEnabled
    ]);
    (0, $70fFQ.useEffect)(()=>{
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleKeyDown
    ]);
};
var $b432f056c3259fac$export$2e2bcd8739ae039 = $b432f056c3259fac$var$useHotkeys;


const $fcb46ed2ee17f59f$var$MixpanelEvents = {
    /* Main Navigation */ viewCompanyList: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("view company list", {
            "event version": 1
        });
    },
    viewMarketActivity: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("view market activity", {
            "event version": 1
        });
    },
    viewInsights: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("view insights", {
            "event version": 1
        });
    },
    viewAccountSettings: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("view account settings", {
            "event version": 1
        });
    },
    /* Company List */ clickCompanyListItem: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click company list item", {
            "event version": 1,
            company: companyName
        });
    },
    filterCompanyList: (filters)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("filter company list", {
            ...filters,
            "event version": 2
        });
    },
    resetCompanyListFilter: (filter, value)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("reset company list filter", {
            filter: filter,
            "filter value": value,
            "event version": 1
        });
    },
    clickResetAllCompanyListFilters: (filters)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click reset all company list filters", {
            ...filters,
            "event version": 1
        });
    },
    /* Company Profile */ viewCompanyProfile: (source, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("view company profile", {
            "event version": 2,
            source: source,
            company: companyName
        });
    },
    downloadXlsSpreadsheet: (source)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("download xls spreadsheet", {
            source: source,
            "event version": 2
        });
    },
    addCompanyToWatchlist: (source, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("add company to watchlist", {
            "event version": 1,
            source: source,
            company: companyName
        });
    },
    removeCompanyFromWatchlist: (source, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("remove company from watchlist", {
            "event version": 1,
            source: source,
            company: companyName
        });
    },
    navigateToCompanyWebsite: (companyName, url)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("navigate to company website", {
            "event version": 1,
            url: url,
            company: companyName
        });
    },
    changeCompanyProfileLineChartTimeFrame: (companyName, oldTimeFrame, newTimeFrame)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("change company profile line chart time frame", {
            "event version": 1,
            company: companyName,
            "old time frame": oldTimeFrame,
            "new time frame": newTimeFrame
        });
    },
    addComparisonToCompanyProfileLineChart: (companyName, symbol, exchange)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("super chart add comparison", {
            "event version": 2,
            symbol: symbol,
            exchange: exchange,
            company: companyName
        });
    },
    removeComparisonFromCompanyProfileLineChart: (companyName, symbol, exchange)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("remove comparison from company profile line chart", {
            "event version": 1,
            symbol: symbol,
            exchange: exchange,
            company: companyName
        });
    },
    addIndicatorToCompanyProfileLineChart: (companyName, indicator)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("super chart add indicator", {
            "event version": 2,
            indicator: indicator,
            company: companyName
        });
    },
    removeIndicatorFromCompanyProfileLineChart: (source, companyName, indicator)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("remove indicator from company profile line chart", {
            "event version": 1,
            source: source,
            indicator: indicator,
            company: companyName
        });
    },
    hoverCompanyProfileLineChartLegendItem: (companyName, legendItemName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("hover company profile line chart legend item", {
            "event version": 1,
            company: companyName,
            "legend item": legendItemName
        });
    },
    hoverCompanyProfileLineChart: (companyName, hoveredDate, numberOfComparisons, numberOfIndicators)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("hover company profile line chart", {
            "event version": 1,
            company: companyName,
            date: hoveredDate,
            "number of comparisons": numberOfComparisons,
            "number of indicators": numberOfIndicators
        });
    },
    openCompanyReport: (documentSource, articleType, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open company report", {
            "event version": 1,
            "article type": articleType,
            documentSource: documentSource,
            company: companyName
        });
    },
    scrollCompanyReportsCarousel: (direction, articleType, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("scroll company reports carousel", {
            "event version": 1,
            "article type": articleType,
            direction: direction,
            company: companyName
        });
    },
    openReportsAndInterviewsDisclaimer: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open reports and interviews disclaimer", {
            "event version": 1,
            company: companyName
        });
    },
    scrollCompanyNewsCarousel: (direction, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("scroll company news carousel", {
            "event version": 1,
            direction: direction,
            company: companyName
        });
    },
    openCompanyNewsArticle: (companyName, articleUrl)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open company news article", {
            "event version": 1,
            url: articleUrl,
            company: companyName
        });
    },
    navigateToMentionDotCom: (source, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("navigate to mention.com", {
            "event version": 1,
            source: source,
            company: companyName
        });
    },
    scrollSimilarCompaniesCarousel: (direction, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("scroll similar companies carousel", {
            "event version": 1,
            direction: direction,
            company: companyName
        });
    },
    navigateToSimilarCompany: (companyName, similarCompanyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("navigate to similar company", {
            "event version": 1,
            "source company": companyName,
            "similar company": similarCompanyName
        });
    },
    scrollMostActiveCompaniesCarousel: (direction, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("scroll most active companies carousel", {
            "event version": 1,
            direction: direction,
            company: companyName
        });
    },
    navigateToMostActiveCompany: (companyName, activeCompanyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("navigate to most active company", {
            "event version": 1,
            "source company": companyName,
            "most active company": activeCompanyName
        });
    },
    viewCompanyCertificatesOfIncorporationList: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("view company certificates of incorporation list", {
            "event version": 1,
            company: companyName
        });
    },
    viewCompanyCertificateOfIncorporation: (companyName, coiDate)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("view company certificate of incorporation", {
            "event version": 1,
            company: companyName,
            date: coiDate
        });
    },
    hoverCompanyReportedMarksCard: (companyName, reportPeriod)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("hover company reported marks card", {
            "event version": 1,
            company: companyName,
            "report period": reportPeriod
        });
    },
    openCompanyReportedMarksModal: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open company reported marks modal", {
            "event version": 1,
            company: companyName
        });
    },
    hoverCompanyReportedMarksModal: (companyName, reportPeriod)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("hover company reported marks modal", {
            "event version": 1,
            company: companyName,
            "report period": reportPeriod
        });
    },
    selectCompanyReportedMarksModal: (companyName, reportPeriod)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("select company reported marks modal", {
            "event version": 1,
            company: companyName,
            "report period": reportPeriod
        });
    },
    selectCompanyBidOfferRatioType: (companyName, type)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("select company bid offer ratio type", {
            "event version": 1,
            company: companyName,
            type: type
        });
    },
    hoverCompanyBidOfferRatioCard: (companyName, reportPeriod)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("hover company bid offer ratio card", {
            "event version": 1,
            company: companyName,
            "report period": reportPeriod
        });
    },
    openRobustnessScoreModal: (source)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open robustness score modal", {
            source: source,
            "event version": 1
        });
    },
    openZXIndexValueModal: (source)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open zx index value modal", {
            source: source,
            "event version": 1
        });
    },
    openCompanyProfileTooltip: (source, tooltip)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open company profile tooltip", {
            source: source,
            tooltip: tooltip,
            "event version": 1
        });
    },
    /* Postmoney valuation calculator */ toggleCustomEnterpriseValuationCalculator: (companyName, isOpen)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("toggle postmoney valuation calculator", {
            "event version": 1,
            company: companyName,
            open: isOpen
        });
    },
    modifyCustomPricePerShareField: (companyName, oldValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify custom price per share field", {
            "event version": 1,
            company: companyName,
            "old value": oldValue === undefined ? "" : oldValue,
            "new value": newValue
        });
    },
    modifyCustomValuationField: (companyName, oldValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify custom valuation field", {
            "event version": 1,
            company: companyName,
            "old value": oldValue === undefined ? "" : oldValue,
            "new value": newValue
        });
    },
    clickHoldingsListItem: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click holdings list item", {
            "event version": 1,
            company: companyName
        });
    },
    clickValuationCardViewPastValuautions: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click valuation card view past valuations", {
            "event version": 1,
            company: companyName
        });
    },
    clickValuationCardNewValuation: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click valuation card new valuation", {
            "event version": 1,
            company: companyName
        });
    },
    clickFundingsTab: (companyName, tabName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click fundings tab", {
            "event version": 1,
            company: companyName,
            tab: tabName
        });
    },
    clickFundingsShowMore: (companyName, tabName, expand)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click fundings show more", {
            "event version": 1,
            company: companyName,
            tab: tabName,
            expand: expand
        });
    },
    /* Valuation Calculator */ openCustomValuationModal: (companyName, isCreate)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open custom valuation modal", {
            "event version": 1,
            create: isCreate,
            company: companyName
        });
    },
    closeValuationModal: (companyName, isCreate)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("close custom valuation modal", {
            "event version": 1,
            create: isCreate,
            company: companyName
        });
    },
    clickValuationDate: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click valuation date", {
            "event version": 1,
            company: companyName
        });
    },
    modifyValuationDate: (companyName, oldValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify custom valuation date", {
            "event version": 1,
            company: companyName,
            "old value": oldValue === undefined ? "" : oldValue,
            "new value": newValue
        });
    },
    modifyPreviousValuation: (companyName, oldValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify custom valuation previous valuation value", {
            "event version": 1,
            company: companyName,
            "old value": oldValue === undefined ? "" : oldValue,
            "new value": newValue
        });
    },
    modifyPreviousValuationDate: (companyName, oldValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify custom valuation previous valuation date", {
            "event version": 1,
            company: companyName,
            "old value": oldValue === undefined ? "" : oldValue,
            "new value": newValue
        });
    },
    modifyValuationWeightField: (companyName, fieldName, fieldType, oldValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify valuation weight field", {
            "event version": 1,
            company: companyName,
            field: fieldName,
            fieldType: fieldType,
            "old value": oldValue,
            "new value": newValue
        });
    },
    selectValuationComparison: (companyName, comparison, comparisonType)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("select valuation comparison", {
            "event version": 1,
            company: companyName,
            comparison: comparison,
            comparisonType: comparisonType
        });
    },
    clearValuationComparison: (companyName, comparisonType)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("clear valuation comparison", {
            "event version": 1,
            company: companyName,
            comparisonType: comparisonType
        });
    },
    createCustomValuation: (companyName, valuationDate)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("create custom valuation", {
            "event version": 1,
            company: companyName,
            date: valuationDate
        });
    },
    deleteCustomValuation: (companyName, valuationDate)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("delete custom valuation", {
            "event version": 1,
            company: companyName,
            date: valuationDate
        });
    },
    modifyDefaultComponentValue: (companyName, fieldName, fieldType, defaultValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify default component value", {
            "event version": 1,
            company: companyName,
            field: fieldName,
            fieldType: fieldType,
            defaultValue: defaultValue,
            newValue: newValue
        });
    },
    restoreDefaultComponentValue: (companyName, fieldName, fieldType)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("restore default component value", {
            "event version": 1,
            company: companyName,
            field: fieldName,
            fieldType: fieldType
        });
    },
    addCustomCriterion: (companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("add custom criterion", {
            "event version": 1,
            company: companyName
        });
    },
    removeCustomCriterion: (companyName, criterionName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("remove custom criterion", {
            "event version": 1,
            company: companyName,
            field: criterionName
        });
    },
    modifyCustomCriterionName: (companyName, oldName, newName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify custom criterion name", {
            "event version": 1,
            company: companyName,
            "old name": oldName === undefined ? "" : oldName,
            "new name": newName
        });
    },
    modifyCustomCriterionValue: (companyName, criterionName, oldValue, newValue)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("modify custom criterion value", {
            "event version": 1,
            company: companyName,
            field: criterionName,
            "old value": oldValue === undefined ? "" : oldValue,
            "new value": newValue
        });
    },
    /* Market Activity */ heatMapFilterSector: (sector)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("heat map filter sector", {
            "event version": 1,
            sector: sector
        });
    },
    /* Global search */ toggleGlobalSearch: (hotkeyUsed, isOpen)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("toggle global search", {
            "event version": 1,
            hotkey: hotkeyUsed,
            open: isOpen
        });
    },
    navigateGlobalSearchDropdown: (direction)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("navigate global search dropdown", {
            "event version": 1,
            direction: direction === (0, $b432f056c3259fac$export$b34c7ae3fd8138d2) ? "up" : "down"
        });
    },
    globalSearchSelectCompany: (hotkeyUsed, searchQuery, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("global search select company", {
            "event version": 1,
            hotkey: hotkeyUsed,
            search: searchQuery,
            company: companyName
        });
    },
    globalSearchQueryCompany: (searchQuery)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("global search query company", {
            "event version": 1,
            search: searchQuery
        });
    },
    /* Portfolios */ navigateToPortfolioProfile: (source, portfolioId, name)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("navigate to portfolio", {
            "event version": 1,
            source: source,
            portfolio: portfolioId,
            "portfolio name": name
        });
    },
    openAddNewPortfolioModal: (source)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open add new portfolio modal", {
            "event version": 1,
            source: source
        });
    },
    addNewPortfolio: (source)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("add new portfolio", {
            "event version": 1,
            source: source
        });
    },
    openRenamePortfolioModal: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open rename portfolio modal", {
            "event version": 1
        });
    },
    renamePortfolio: (source, id, oldName, name)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("rename portfolio", {
            "event version": 1,
            source: source,
            id: id,
            "new name": name,
            "old name": oldName
        });
    },
    openDeletePortfolioModal: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open delete portfolio modal", {
            "event version": 1
        });
    },
    deletePortfolio: (source, portfolioId, portfolioName, numberOfCompanies, hasShareLots)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("delete portfolio", {
            "event version": 1,
            source: source,
            portfolio: portfolioId,
            "portfolio name": portfolioName,
            "number of companies in portfolio": numberOfCompanies,
            "has share lots": hasShareLots
        });
    },
    openAddCompanyToPortfolioModal: (source)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open add company to portfolio modal", {
            "event version": 1,
            source: source
        });
    },
    addCompanyToPortfolio: (source, portfolioId, portfolioName, companyName, isZXDataCompany)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("add company to portfolio", {
            "event version": 1,
            source: source,
            portfolio: portfolioId,
            "portfolio name": portfolioName,
            company: companyName,
            "ZXData company": isZXDataCompany
        });
    },
    openRemoveCompanyFromPortfolioModal: (source, mode, portfolioId, portfolioName, companyName, isZXDataCompany)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open remove company from portfolio modal", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode],
            portfolio: portfolioId,
            "portfolio name": portfolioName,
            company: companyName,
            "ZXData company": isZXDataCompany
        });
    },
    removeCompanyFromPortfolio: (source, portfolioId, portfolioName, companyName, isZXDataCompany)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("remove company from portfolio", {
            "event version": 1,
            portfolio: portfolioId,
            "portfolio name": portfolioName,
            company: companyName,
            "ZXData company": isZXDataCompany
        });
    },
    openAddShareLotModal: (source, mode)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open add share lot modal", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode]
        });
    },
    openEditShareLotModal: (source, mode)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open edit share lot modal", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode]
        });
    },
    addShareLotsToPortfolio: (source, mode, quantity)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("add share lots", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode],
            "number created": quantity
        });
    },
    editShareLot: (source, mode, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("edit share lot", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode],
            company: companyName
        });
    },
    openRemoveShareLotModal: (source, mode, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open remove share lot modal", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode],
            company: companyName
        });
    },
    removeShareLot: (source, mode, companyName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("remove share lot", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode],
            company: companyName
        });
    },
    exportPortfolio: (source, mode, portfolioId, portfolioName, numberOfCompanies)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("export portfolio", {
            "event version": 1,
            source: source,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode],
            portfolio: portfolioId,
            "portfolio name": portfolioName,
            "number of companies in portfolio": numberOfCompanies
        });
    },
    expandPortfolioCompany: (mode)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("expand portfolio company", {
            "event version": 1,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode]
        });
    },
    collapsePortfolioCompany: (mode)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("collapse company", {
            "event version": 1,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode]
        });
    },
    expandAllCompanies: (mode)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click expand all", {
            "event version": 1,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode]
        });
    },
    collapseAllCompanies: (mode)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click collapse all", {
            "event version": 1,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode]
        });
    },
    sortPortfolioCompanies: (mode, sortBy, sortDirection)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("sort portfolio", {
            "event version": 1,
            mode: (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[mode],
            "sort by": sortBy,
            "sort direction": sortDirection
        });
    },
    togglePortfolioMode: (oldMode, newMode)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("toggle portfolio mode", {
            "event version": 1,
            "old mode": (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[oldMode],
            "new mode": (0, $9f7f80bd8f655910$export$1fe3b47417c4ee2d)[newMode]
        });
    },
    /* Insights */ openMonthlyMoversArticle: (articleTitle)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open monthly movers article", {
            "event version": 1,
            article: articleTitle
        });
    },
    openReportOrPressRelease: (articleTitle)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open report or press release", {
            "event version": 1,
            article: articleTitle
        });
    },
    /* Miscellaneous */ clickGlobalNavigationPage: (option)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("click global navigation page", {
            "event version": 1,
            option: option
        });
    },
    useHotkey: (hotkey)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("use hotkey", {
            "event version": 1,
            hotkey: hotkey
        });
    },
    openTooltip: (tooltipName)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open helper tooltip", {
            "event version": 1,
            tooltip: tooltipName
        });
    },
    openReportABug: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open report a bug", {
            "event version": 1
        });
    },
    openTermsOfUse: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open terms of use", {
            "event version": 1
        });
    },
    openPrivacyPolicy: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open privacy policy", {
            "event version": 1
        });
    },
    openNDA: ()=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("open NDA", {
            "event version": 1
        });
    },
    /* Walkthroughs */ completeWalkthrough: (name, stepsCompleted)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("complete walkthrough", {
            "event version": 1,
            walkthrough: name,
            "steps completed": stepsCompleted
        });
    },
    skipWalkthrough: (name, stepSkippedOn, stepsRemaining)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("skip walkthrough", {
            "event version": 1,
            walkthrough: name,
            "skipped on step": stepSkippedOn,
            "steps remaining": stepsRemaining
        });
    },
    completeWalkthroughStep: (name, step)=>{
        (0, $8e8dba6047d43ae4$export$66cf78a45ab85b85)("complete walkthrough step", {
            "event version": 1,
            walkthrough: name,
            step: step
        });
    }
};
var $fcb46ed2ee17f59f$export$2e2bcd8739ae039 = $fcb46ed2ee17f59f$var$MixpanelEvents;


const $d2ba43cd4f142ed6$var$StyledDropdownContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.PageSection))`
  padding: 12px 0;
  margin: -16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $d2ba43cd4f142ed6$var$StyledSection = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50).attrs({
    as: "div"
})`
  padding: 8px 12px;
`;
const $d2ba43cd4f142ed6$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  padding: 0 12px;
  height: 32px;
  min-height: 32px;
`;
const $d2ba43cd4f142ed6$var$IconPlaceholderDiv = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 18px;
  height: 18px;
`;
const $d2ba43cd4f142ed6$var$StyledHorizontalRule = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).hr`
  border: none;
  border-bottom: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  margin-top: 12px;
`;
const $d2ba43cd4f142ed6$var$StyledCheckboxList = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding: 0 12px;
  min-width: 200px;
  box-sizing: border-box;

  > * {
    height: 32px;
    display: flex;
    align-items: center;
  }
`;
const $d2ba43cd4f142ed6$var$SingleSelect = ({ label: label, options: options, value: value, onChange: onChange, toggleIsOpen: toggleIsOpen })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($d2ba43cd4f142ed6$var$StyledDropdownContainer, {
        children: [
            value && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledListItem, {
                        leadingIcon: (0, $dfd33cee3229493c$exports.XCloseIcon),
                        onClick: ()=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).resetCompanyListFilter(label, value);
                            toggleIsOpen();
                            onChange(null);
                        },
                        text: "Reset"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledHorizontalRule, {})
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledSection, {
                children: label
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                children: options.map((option)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledListItem, {
                        leadingIconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500,
                        leadingIcon: value === option.value ? (0, $dfd33cee3229493c$exports.CheckIcon) : $d2ba43cd4f142ed6$var$IconPlaceholderDiv,
                        text: option.label,
                        onClick: ()=>{
                            onChange(option.value);
                            toggleIsOpen();
                        }
                    }, option.key || option.value))
            })
        ]
    });
$d2ba43cd4f142ed6$var$SingleSelect.propTypes = {
    toggleIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).any,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    })),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    ]),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
$d2ba43cd4f142ed6$var$SingleSelect.defaultProps = {
    value: null
};
const $d2ba43cd4f142ed6$var$StyledCheckbox = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Field))`
  height: 32px;

  > div {
    > span {
      color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white80} !important;
    }
  }
`;
const $d2ba43cd4f142ed6$export$1e7dfd31545b5809 = ({ name: name, label: label, options: options })=>{
    const { values: { [name]: value } } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($d2ba43cd4f142ed6$var$StyledDropdownContainer, {
        children: [
            value?.length > 0 && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledListItem, {
                        leadingIcon: (0, $dfd33cee3229493c$exports.XCloseIcon),
                        onClick: ()=>change(name, []),
                        text: "Reset"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledHorizontalRule, {})
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledSection, {
                children: label
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledCheckboxList, {
                children: options.map((option)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($d2ba43cd4f142ed6$var$StyledCheckbox, {
                        type: "checkbox",
                        label: option.label,
                        checked: value.includes(option.value),
                        onClick: ()=>{
                            const newValue = value.includes(option.value) ? value.filter((v)=>v !== option.value) : [
                                ...value,
                                option.value
                            ];
                            change(name, newValue);
                        }
                    }, option.key || option.value))
            })
        ]
    });
};
$d2ba43cd4f142ed6$export$1e7dfd31545b5809.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).any,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }))
};
var $d2ba43cd4f142ed6$export$2e2bcd8739ae039 = $d2ba43cd4f142ed6$var$SingleSelect;




const $f04c7d74952e4f04$var$FilterActionsDivider = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  flex: 0 0 1px;
  height: 40px;
  background-color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
const $f04c7d74952e4f04$var$StyledFilterContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;
const $f04c7d74952e4f04$var$makeSelectOptions = (options)=>options.map((option)=>({
            value: option,
            label: option
        }));
const $f04c7d74952e4f04$var$WatchlistFilterDropdown = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d2ba43cd4f142ed6$export$2e2bcd8739ae039), {
        ...props,
        label: "Watchlist",
        options: $f04c7d74952e4f04$var$makeSelectOptions((0, $2551481dcc2e9273$export$d705ab93b2e7e1c8))
    });
const $f04c7d74952e4f04$var$ZXIndexValueChangeFilterDropdown = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d2ba43cd4f142ed6$export$2e2bcd8739ae039), {
        ...props,
        label: "ZX Index Value Week Change %",
        options: $f04c7d74952e4f04$var$makeSelectOptions((0, $2551481dcc2e9273$export$355404e82408ab2a))
    });
const $f04c7d74952e4f04$var$RobustnessFilterDropdown = (props)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d2ba43cd4f142ed6$export$2e2bcd8739ae039), {
        ...props,
        label: "Robustness Score (RS)",
        options: $f04c7d74952e4f04$var$makeSelectOptions((0, $2551481dcc2e9273$export$20b663052f862f52))
    });
// const PremiumToLastRoundDropdown = (props) => (
//   <SingleSelect
//     {...props}
//     label="ZX Index Value Premium to LR Price"
//     options={makeSelectOptions(PREMIUM_TO_LAST_ROUND_OPTIONS)}
//   />
// );
const $f04c7d74952e4f04$var$CompanyFilters = ({ makeOnChangeFunction: makeOnChangeFunction, filters: filters, resetFilters: resetFilters })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f04c7d74952e4f04$var$StyledFilterContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $b3e62bbe3bd62a1f$export$2e2bcd8739ae039), {
                onChange: makeOnChangeFunction((0, $2551481dcc2e9273$export$4c84ac3c8d18afa6)),
                value: filters.watchlist,
                dropdownComponent: $f04c7d74952e4f04$var$WatchlistFilterDropdown,
                children: "Watchlist"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $b3e62bbe3bd62a1f$export$2e2bcd8739ae039), {
                value: filters[0, $2551481dcc2e9273$export$273d5e0c912ace6e],
                onChange: makeOnChangeFunction((0, $2551481dcc2e9273$export$273d5e0c912ace6e)),
                dropdownComponent: $f04c7d74952e4f04$var$RobustnessFilterDropdown,
                children: "Robustness Score"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $b3e62bbe3bd62a1f$export$2e2bcd8739ae039), {
                value: filters[0, $2551481dcc2e9273$export$2d53b25b9cc4bff4],
                onChange: makeOnChangeFunction((0, $2551481dcc2e9273$export$2d53b25b9cc4bff4)),
                dropdownComponent: $f04c7d74952e4f04$var$ZXIndexValueChangeFilterDropdown,
                children: "Week change %"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f04c7d74952e4f04$var$FilterActionsDivider, {}),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                disabled: !Object.values(filters).some((value)=>value),
                onClick: ()=>{
                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickResetAllCompanyListFilters(filters);
                    resetFilters();
                },
                icon: (0, $dfd33cee3229493c$exports.XCloseIcon),
                children: "Reset all"
            })
        ]
    });
};
$f04c7d74952e4f04$var$CompanyFilters.propTypes = {
    resetFilters: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        watchlist: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        robustness: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        zx_index_value_change: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        last_round_price_diff: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired,
    makeOnChangeFunction: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $f04c7d74952e4f04$export$2e2bcd8739ae039 = $f04c7d74952e4f04$var$CompanyFilters;





var $70fFQ = parcelRequire("70fFQ");



/**
 * Wrapper around `useMutation` for DELETE request
 * https://tanstack.com/query/v4/docs/reference/useMutation
 *
 * @param {string} url
 * @returns {Array} see useMutation documentation for return values.
 */ const $fd1e6894b991baa0$var$useDelete = (url, config = {})=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const apiUrl = `${url}`;
    const queryClient = (0, $7e71e0df4024a5cb$export$22e77b9572c4fded)();
    // Delete request is a detail request
    // To make the useDelete hook more generic on initialization, id is passed to the mutationFn instead of the hook
    // Whether that's the best practice is questionable
    const mutationFn = (0, $70fFQ.useCallback)(({ id: id })=>(0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).delete(`${apiUrl}${id}/`), [
        apiUrl
    ]);
    const mutation = (0, $4590a457b11e610e$export$609860bf8b0084c)({
        mutationFn: mutationFn,
        onSuccess: ()=>{
            // Invalidate and refetch
            queryClient.invalidateQueries({
                queryKey: [
                    url
                ]
            });
            if (config?.invalidateUrls) // Useful for invalidating related DETAIL endpoints calls when a DELETE request is made to
            // a related LIST endpoint.
            config.invalidateUrls.forEach(({ url: otherUrl, queryParams: queryParams })=>queryClient.invalidateQueries({
                    queryKey: [
                        otherUrl,
                        queryParams
                    ]
                }));
            if (!config?.silent) {
                if (config?.message) dispatch({
                    type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                    message: config.message
                });
                else dispatch({
                    type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                    message: "Successfully deleted"
                });
            }
        },
        onError: ()=>{
            if (!config?.silent) dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                message: "Update failed, please check your information and try again"
            });
        }
    });
    return mutation;
};
var $fd1e6894b991baa0$export$2e2bcd8739ae039 = $fd1e6894b991baa0$var$useDelete;




var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");




/**
 * Wrapper around `useQueries` to execute multiple queries in parallel. Basically is used like
 * a `useFetch` that takes an array of the params. The key difference is the returned object will
 * contain `cleanedData`, which will be an array of the cleaned results, and `queryInfo`, which will
 * be an array of query information objects. The object will also contain information about the
 * full set of queries, such as `isLoading` and `isError`, which are logically true based on all
 * of the underlying queries.
 *
 * @param {Array} queries - Array of query objects. Each query object should have the following
 *  properties: `url`, `queryParams`, `options`. See `useFetch` for more details about how each
 *  will be applied.
 * @param {object} globalOptions - Metadata options for using this hook. These options are NOT
 *  forwarded on to the individual queries.
 */ const $1007cdd3bb68930d$var$useFetches = (queries = [], globalOptions = {
    flattenResults: false
})=>{
    const queryStrings = queries.map((query)=>{
        if (query === null) return null;
        const { queryParams: queryParams } = query;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(queryParams) ? "" : `?${(0, (/*@__PURE__*/$parcel$interopDefault($e4e2ed8cc86ce03b$exports))).stringify(queryParams)}`;
    });
    const apiURLs = queries.map((query, index)=>{
        if (query === null) return null;
        return `${query.url}${queryStrings[index]}`;
    });
    const queryOptions = queries.map((query)=>{
        if (query === null) return null;
        return {
            ...query.options,
            ...(0, $397b4344a6629882$export$3518a77cc76c909)
        };
    });
    const queryFns = (0, $70fFQ.useMemo)(()=>apiURLs.map((apiUrl)=>apiUrl ? ()=>(0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).get(apiUrl).then((response)=>response.data) : null), [
        apiURLs
    ]);
    const queryInfo = (0, $c3bf82321f15cb6e$export$408667c6c87da1e5)(queries.map((query, index)=>{
        if (query === null) // A null query always resolves to null data.
        return {
            queryKey: [
                null
            ],
            queryFn: ()=>Promise.resolve({
                    data: null
                })
        };
        return {
            queryKey: [
                query.url,
                query.queryParams
            ],
            queryFn: queryFns[index],
            ...queryOptions[index]
        };
    }));
    const cleanedData = (0, $70fFQ.useMemo)(()=>{
        const mappedCleanData = queryInfo.map((queryResult)=>{
            // JSON API data
            if (queryResult.data?.data) return (0, $397b4344a6629882$export$4d4d4fb2de83c9b8)(queryResult.data);
            // HD API data
            return queryResult.data;
        });
        if (!globalOptions.flattenResults) return mappedCleanData;
        return {
            data: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).flatten(mappedCleanData.map((data)=>data?.data || [])),
            relationships: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).merge({}, ...mappedCleanData.map((data)=>data?.relationships || {}))
        };
    }, [
        queryInfo,
        globalOptions.flattenResults
    ]);
    return (0, $70fFQ.useMemo)(()=>({
            queryInfo: queryInfo,
            cleanedData: cleanedData,
            isLoading: queryInfo.some((query)=>query.isLoading),
            isFetching: queryInfo.some((query)=>query.isFetching),
            isError: queryInfo.some((query)=>query.isError),
            isIdle: queryInfo.every((query)=>query.isIdle),
            isAnySuccess: queryInfo.some((query)=>query.isSuccess),
            isSuccess: queryInfo.every((query)=>query.isSuccess)
        }), [
        queryInfo,
        cleanedData
    ]);
};
var $1007cdd3bb68930d$export$2e2bcd8739ae039 = $1007cdd3bb68930d$var$useFetches;



var $70fFQ = parcelRequire("70fFQ");



var $hI4Hx = parcelRequire("hI4Hx");



/**
 * Wrapper around `useInfiniteQuery`
 * https://tanstack.com/query/v4/docs/reference/useQuery?from=reactQueryV3&original=https://react-query-v3.tanstack.com/reference/useInfiniteQuery
 *
 * @param {string} url
 * @param {string} pageQueryParam
 * @param {function} getNextPageParam
 * @param {object} queryParams
 * @param {object} options
 * @returns {Array} see useInfiniteQuery documentation for return values. Also adds `cleanedData` to the returnInfo.
 */ const $f869aac89d4eda76$var$useInfiniteFetch = (url, queryParams = {}, options = {}, pageQueryParam = (0, $beb11aa5e2886f26$export$eca05871efc9bc5d), getNextPageParam = (0, $397b4344a6629882$export$262205ea6b009fb3))=>{
    const queryFn = (0, $70fFQ.useCallback)(({ pageParam: pageParam = 1 })=>{
        queryParams[pageQueryParam] = pageParam;
        const qs = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(queryParams) ? "" : `?${(0, (/*@__PURE__*/$parcel$interopDefault($e4e2ed8cc86ce03b$exports))).stringify(queryParams)}`;
        const apiUrl = `${url}${qs}`;
        return (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).get(apiUrl).then((response)=>response.data);
    }, [
        queryParams,
        pageQueryParam,
        url
    ]);
    const queryOptions = {
        ...options,
        ...(0, $397b4344a6629882$export$3518a77cc76c909)
    };
    const queryInfo = (0, $924889e2158d19ef$export$bdc59d3c1a6569aa)(// to differentiate paginated query and regular query
    [
        url,
        queryParams,
        "paginated"
    ], queryFn, {
        ...queryOptions,
        getNextPageParam: getNextPageParam
    });
    const cleanedData = (0, $70fFQ.useMemo)(()=>{
        if (!queryInfo.isLoading && queryInfo.data) {
            // Create an object composed of the links and meta from the last page, plus the data and includes from all pages.
            const currentPageNumber = queryInfo.data.pages.length;
            const currentPage = queryInfo.data.pages[currentPageNumber - 1];
            const fullData = {
                links: currentPage.links,
                meta: currentPage.meta,
                data: queryInfo.data.pages.map((page)=>page.data).flat(),
                included: queryInfo.data.pages.map((page)=>page.included || []).flat()
            };
            if (fullData.data.length) return (0, $397b4344a6629882$export$4d4d4fb2de83c9b8)(fullData);
            return fullData;
        }
        return [];
    }, [
        queryInfo.isLoading,
        queryInfo.data
    ]);
    const returnInfo = (0, $70fFQ.useMemo)(()=>({
            ...queryInfo,
            cleanedData: cleanedData
        }), [
        queryInfo,
        cleanedData
    ]);
    return returnInfo;
};
var $f869aac89d4eda76$export$2e2bcd8739ae039 = $f869aac89d4eda76$var$useInfiniteFetch;









var $70fFQ = parcelRequire("70fFQ");





const $fa6f9dce0653fce6$export$6b7545a126c3c6c5 = [
    "sam.macpherson@zanbato.com",
    "kchang@zanbato.com",
    "jessica.yang@zanbato.com",
    "lazar.vukoje@zanbato.com",
    "scott.kwang@zanbato.com",
    "kevin.leung@zanbato.com",
    "andrew.yoon@zanbato.com",
    "maurice.royce@zanbato.com",
    "shawn.zhao@zanbato.com"
];






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");
/**
 * Clickable logo in the header that goes back to the company page.
 * Using a SVG instead of a png due to issues with the Parcel URL reference
 * leading to a `Cannot use 'import.meta' outside a module` error
 *
 * @returns {React.Element}
 */ const $037584e3e4e73fb7$var$SiteLogo = ({ size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("svg", {
        width: "153",
        height: size,
        viewBox: "0 0 153 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M47.2786 21.5879H59.2697V25.6199H42.0006V21.5879L53.6277 6.13186H42.9736V2.09985H58.8707V6.13186L47.2786 21.5879Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M70.8757 17.8358L76.1257 25.6198H81.4877L73.5497 13.8597L70.8757 17.8358Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M69.1815 7.38475L65.6185 2.09973H60.2565L66.5005 11.3538L69.1815 7.38475Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M65.6185 25.6198H60.2565L76.1255 2.09973H81.4875L65.6185 25.6198Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M82.8877 25.6198L87.4518 2.09973H94.4378C97.4898 2.09973 99.9258 2.98873 101.753 4.77374C103.58 6.55174 104.49 9.01575 104.49 12.1518C104.49 16.2258 103.132 19.4948 100.409 21.9448C97.6858 24.3948 94.2558 25.6268 90.1118 25.6268H82.8877V25.6198ZM85.1068 23.8698H90.2798C93.7098 23.8698 96.6008 22.8198 98.9668 20.7128C101.333 18.6058 102.509 15.7848 102.509 12.2428C102.509 9.57575 101.753 7.51075 100.241 6.04074C98.7288 4.57074 96.7058 3.84274 94.1788 3.84274H89.0408L85.1068 23.8698Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M112.953 26.1239C110.846 26.1239 109.159 25.4519 107.878 24.1079C106.604 22.7639 105.96 20.9859 105.96 18.7669C105.96 16.1699 106.793 13.9929 108.466 12.2289C110.132 10.4718 112.211 9.58984 114.696 9.58984C116.285 9.58984 117.657 9.96084 118.812 10.6958C119.967 11.4308 120.765 12.4669 121.213 13.7899H121.283L121.99 10.0938H123.74L120.716 25.6199H118.966L119.54 22.7989H119.47C117.811 25.0179 115.641 26.1239 112.953 26.1239ZM113.527 24.4439C115.585 24.4439 117.307 23.7299 118.686 22.2949C120.065 20.8599 120.751 19.0819 120.751 16.9539C120.751 15.2319 120.219 13.8529 119.155 12.8239C118.091 11.7948 116.649 11.2768 114.836 11.2768C112.862 11.2768 111.203 11.9978 109.845 13.4469C108.487 14.8889 107.815 16.6809 107.815 18.8089C107.815 20.5309 108.333 21.9029 109.362 22.9249C110.391 23.9469 111.784 24.4509 113.527 24.4509V24.4439Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M131.237 11.578L129.319 21.392C129.249 21.77 129.221 22.12 129.221 22.435C129.221 22.904 129.375 23.289 129.676 23.576C129.977 23.87 130.411 24.01 130.971 24.01H131.944L131.643 25.69H130.565C129.599 25.69 128.843 25.424 128.283 24.885C127.723 24.346 127.443 23.618 127.443 22.701C127.443 22.344 127.485 21.917 127.576 21.427L129.494 11.585H126.232L126.533 10.108H129.76L130.971 3.89197H132.721L131.51 10.108H135.206L134.905 11.585H131.244L131.237 11.578Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                d: "M141.856 26.1239C139.749 26.1239 138.062 25.4519 136.781 24.1079C135.507 22.7639 134.863 20.9859 134.863 18.7669C134.863 16.1699 135.696 13.9929 137.369 12.2289C139.035 10.4718 141.114 9.58984 143.599 9.58984C145.188 9.58984 146.56 9.96084 147.715 10.6958C148.87 11.4308 149.668 12.4669 150.116 13.7899H150.186L150.893 10.0938H152.643L149.619 25.6199H147.869L148.443 22.7989H148.373C146.714 25.0179 144.544 26.1239 141.856 26.1239ZM142.43 24.4439C144.488 24.4439 146.21 23.7299 147.589 22.2949C148.968 20.8599 149.654 19.0819 149.654 16.9539C149.654 15.2319 149.122 13.8529 148.058 12.8239C146.994 11.7948 145.552 11.2768 143.739 11.2768C141.765 11.2768 140.106 11.9978 138.748 13.4469C137.39 14.8889 136.718 16.6809 136.718 18.8089C136.718 20.5309 137.236 21.9029 138.265 22.9249C139.294 23.9469 140.687 24.4509 142.43 24.4509V24.4439Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                cx: "4.66717",
                cy: "4.66717",
                r: "4.66668",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                cx: "23.334",
                cy: "23.3333",
                r: "4.66668",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("rect", {
                x: "19.94",
                y: "1.46045",
                width: "9.33336",
                height: "27.0667",
                transform: "rotate(45 19.94 1.46045)",
                fill: "url(#paint0_linear_6206_25103)"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                cx: "4.66668",
                cy: "23.3333",
                r: "4.66668",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                cx: "23.3336",
                cy: "4.66668",
                r: "4.66668",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("linearGradient", {
                    id: "paint0_linear_6206_25103",
                    x1: "24.9172",
                    y1: "1.22346",
                    x2: "24.3015",
                    y2: "27.2097",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("stop", {
                            stopColor: "#74CBD3"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#6C7594"
                        })
                    ]
                })
            })
        ]
    });
$037584e3e4e73fb7$var$SiteLogo.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$037584e3e4e73fb7$var$SiteLogo.defaultProps = {
    size: 28
};
const $037584e3e4e73fb7$export$8cb747ba8c0ee4c = ({ size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: "135",
        height: size,
        viewBox: "0 0 135 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
            id: "Dataverse logo",
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector",
                    d: "M123.875 19.1447V2.74585H135V5.67749H127.06V9.15881H134.263V12.0904H127.06V16.2131H135V19.1447H123.875Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_2",
                    d: "M114.488 19.5112C112.618 19.5112 111.112 19.076 109.971 18.2057C108.846 17.3354 108.109 16.068 107.76 14.4037L110.97 13.7166C111.144 14.587 111.524 15.2817 112.111 15.8008C112.713 16.32 113.513 16.5795 114.512 16.5795C115.399 16.5795 116.112 16.404 116.651 16.0528C117.19 15.6863 117.459 15.1901 117.459 14.564C117.459 14.106 117.348 13.7319 117.127 13.4418C116.921 13.1517 116.564 12.8921 116.057 12.6631C115.55 12.4188 114.852 12.1668 113.965 11.9073L112.729 11.5408C112.317 11.4186 111.865 11.2583 111.374 11.0598C110.882 10.8461 110.415 10.5636 109.971 10.2124C109.527 9.86121 109.163 9.42605 108.878 8.9069C108.608 8.38776 108.473 7.76173 108.473 7.02882C108.473 6.15849 108.695 5.37214 109.139 4.66977C109.583 3.9674 110.233 3.41008 111.088 2.99782C111.944 2.58556 112.99 2.37943 114.226 2.37943C116.033 2.37943 117.444 2.78405 118.458 3.59331C119.472 4.40256 120.082 5.50956 120.288 6.9143L117.245 7.34947C117.087 6.70817 116.762 6.19666 116.271 5.81494C115.779 5.41795 115.114 5.21945 114.274 5.21945C113.466 5.21945 112.816 5.37214 112.325 5.67752C111.833 5.9829 111.588 6.38753 111.588 6.8914C111.588 7.41054 111.825 7.84571 112.301 8.1969C112.792 8.53281 113.553 8.85346 114.583 9.15884L115.772 9.50239C116.738 9.77723 117.586 10.1208 118.315 10.533C119.044 10.93 119.615 11.4492 120.027 12.0905C120.439 12.7165 120.645 13.5181 120.645 14.4953C120.645 15.61 120.352 16.5414 119.765 17.2896C119.195 18.0225 118.442 18.5798 117.507 18.9615C116.572 19.328 115.566 19.5112 114.488 19.5112Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_3",
                    d: "M92.1172 19.1447V2.74585H99.2489C100.945 2.74585 102.3 3.20392 103.314 4.12006C104.344 5.02092 104.859 6.28825 104.859 7.92202C104.859 9.05193 104.518 10.0215 103.837 10.8308C103.171 11.6247 102.323 12.1821 101.293 12.5027L101.27 12.663L105.216 18.9615V19.1447H101.674L97.8463 12.9837H95.3027V19.1447H92.1172ZM95.3027 10.1437H99.2252C99.9542 10.1437 100.541 9.9528 100.984 9.57107C101.428 9.17408 101.65 8.60913 101.65 7.87622C101.65 7.14331 101.444 6.58599 101.032 6.20427C100.62 5.80727 100.025 5.60878 99.2489 5.60878H95.3027V10.1437Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_4",
                    d: "M77.4219 19.1447V2.74585H88.5474V5.67749H80.6074V9.15881H87.8104V12.0904H80.6074V16.2131H88.5474V19.1447H77.4219Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_5",
                    d: "M63.6603 19.1447L57.8599 2.74585H61.3069L64.6826 12.6401L65.2769 14.7243H65.467L66.0851 12.6401L70.6841 0H74.1549L67.0598 19.1447H63.6603Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_6",
                    d: "M54.2269 2.8553L60.0273 19.2541H56.5803L53.2047 9.35987L52.6103 7.27565H52.4202L51.8021 9.35987L47.2031 22H43.7323L50.8274 2.8553H54.2269Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_7",
                    d: "M35.8405 19.1447V5.67749H30.6106V2.74585H44.256V5.67749H39.026V19.1447H35.8405Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_8",
                    d: "M0 19.1446V2.74579H5.65784C8.4313 2.74579 10.5391 3.45579 11.9813 4.87581C13.4394 6.29582 14.1684 8.31896 14.1684 10.9452C14.1684 13.5715 13.4394 15.5946 11.9813 17.0146C10.5391 18.4346 8.4313 19.1446 5.65784 19.1446H0ZM3.18551 16.213H5.51521C7.27437 16.213 8.62148 15.7931 9.55652 14.9533C10.4916 14.1135 10.9591 12.7775 10.9591 10.9452C10.9591 9.11294 10.4916 7.77691 9.55652 6.93712C8.62148 6.09732 7.27437 5.67743 5.51521 5.67743H3.18551V16.213Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Union",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.8662 2.83029H25.1937L30.8979 19.0604H28.0458L23.1021 6.07619L18.5386 19.0604H15.2112L21.3908 2.83031H21.8662L21.8662 2.83029Z",
                    fill: "white"
                })
            ]
        })
    });
$037584e3e4e73fb7$export$8cb747ba8c0ee4c.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$037584e3e4e73fb7$export$8cb747ba8c0ee4c.defaultProps = {
    size: 22
};
const $037584e3e4e73fb7$export$8e5f7bf6856988e9 = ({ size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        width: "135",
        height: size,
        viewBox: "0 0 135 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
            id: "Dataverse logo",
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector",
                    d: "M123.875 19.1447V2.74585H135V5.67749H127.06V9.15881H134.263V12.0904H127.06V16.2131H135V19.1447H123.875Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_2",
                    d: "M114.488 19.5112C112.618 19.5112 111.112 19.076 109.971 18.2057C108.846 17.3353 108.109 16.068 107.76 14.4037L110.97 13.7166C111.144 14.5869 111.524 15.2817 112.111 15.8008C112.713 16.3199 113.513 16.5795 114.512 16.5795C115.399 16.5795 116.112 16.4039 116.651 16.0527C117.19 15.6863 117.459 15.19 117.459 14.564C117.459 14.1059 117.348 13.7319 117.127 13.4417C116.921 13.1516 116.564 12.8921 116.057 12.663C115.55 12.4187 114.852 12.1668 113.965 11.9072L112.729 11.5408C112.317 11.4186 111.865 11.2583 111.374 11.0598C110.882 10.846 110.415 10.5636 109.971 10.2124C109.527 9.86118 109.163 9.42602 108.878 8.90687C108.608 8.38773 108.473 7.7617 108.473 7.02879C108.473 6.15846 108.695 5.37211 109.139 4.66974C109.583 3.96737 110.233 3.41005 111.088 2.99779C111.944 2.58553 112.99 2.37939 114.226 2.37939C116.033 2.37939 117.444 2.78402 118.458 3.59328C119.472 4.40253 120.082 5.50953 120.288 6.91427L117.245 7.34944C117.087 6.70814 116.762 6.19663 116.271 5.81491C115.779 5.41792 115.114 5.21942 114.274 5.21942C113.466 5.21942 112.816 5.37211 112.325 5.67749C111.833 5.98287 111.588 6.38749 111.588 6.89137C111.588 7.41051 111.825 7.84568 112.301 8.19687C112.792 8.53278 113.553 8.85343 114.583 9.15881L115.772 9.50236C116.738 9.7772 117.586 10.1208 118.315 10.533C119.044 10.93 119.615 11.4492 120.027 12.0904C120.439 12.7165 120.645 13.5181 120.645 14.4953C120.645 15.6099 120.352 16.5413 119.765 17.2895C119.195 18.0224 118.442 18.5798 117.507 18.9615C116.572 19.3279 115.566 19.5112 114.488 19.5112Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_3",
                    d: "M92.1172 19.1447V2.74585H99.2489C100.945 2.74585 102.3 3.20392 103.314 4.12006C104.344 5.02092 104.859 6.28825 104.859 7.92202C104.859 9.05193 104.518 10.0215 103.837 10.8308C103.171 11.6247 102.323 12.1821 101.293 12.5027L101.27 12.663L105.216 18.9615V19.1447H101.674L97.8463 12.9837H95.3027V19.1447H92.1172ZM95.3027 10.1437H99.2252C99.9542 10.1437 100.541 9.9528 100.984 9.57107C101.428 9.17408 101.65 8.60913 101.65 7.87622C101.65 7.14331 101.444 6.58599 101.032 6.20427C100.62 5.80727 100.025 5.60878 99.2489 5.60878H95.3027V10.1437Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_4",
                    d: "M77.4219 19.1447V2.74585H88.5474V5.67749H80.6074V9.15881H87.8104V12.0904H80.6074V16.2131H88.5474V19.1447H77.4219Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_5",
                    d: "M63.6603 19.1447L57.8599 2.74585H61.3069L64.6826 12.6401L65.2769 14.7243H65.467L66.0851 12.6401L70.6841 0H74.1549L67.0598 19.1447H63.6603Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_6",
                    d: "M54.2269 2.8553L60.0273 19.2541H56.5803L53.2047 9.35987L52.6103 7.27565H52.4202L51.8021 9.35987L47.2031 22H43.7323L50.8274 2.8553H54.2269Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_7",
                    d: "M35.8405 19.1447V5.67749H30.6106V2.74585H44.256V5.67749H39.026V19.1447H35.8405Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Vector_8",
                    d: "M0 19.1447V2.74585H5.65784C8.4313 2.74585 10.5391 3.45586 11.9813 4.87587C13.4394 6.29588 14.1684 8.31902 14.1684 10.9453C14.1684 13.5715 13.4394 15.5947 11.9813 17.0147C10.5391 18.4347 8.4313 19.1447 5.65784 19.1447H0ZM3.18551 16.2131H5.51521C7.27437 16.2131 8.62148 15.7932 9.55652 14.9534C10.4916 14.1136 10.9591 12.7776 10.9591 10.9453C10.9591 9.113 10.4916 7.77697 9.55652 6.93718C8.62148 6.09738 7.27437 5.67749 5.51521 5.67749H3.18551V16.2131Z",
                    fill: "white",
                    fillOpacity: "0.3"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    id: "Union",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.8662 2.83032H25.1937L30.8979 19.0604H28.0458L23.1021 6.07622L18.5386 19.0604H15.2112L21.3908 2.83034H21.8662L21.8662 2.83032Z",
                    fill: "white",
                    fillOpacity: "0.3"
                })
            ]
        })
    });
$037584e3e4e73fb7$export$8e5f7bf6856988e9.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$037584e3e4e73fb7$export$8e5f7bf6856988e9.defaultProps = {
    size: 22
};
const $037584e3e4e73fb7$export$3a9add76aac2435a = ({ size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
                id: "mark",
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                        id: "Ellipse 52",
                        cx: "4.33383",
                        cy: "4.33383",
                        r: "4.33334",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                        id: "Ellipse 60",
                        cx: "21.6673",
                        cy: "21.6668",
                        r: "4.33334",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("rect", {
                        id: "Rectangle 21",
                        x: "18.5158",
                        y: "1.3562",
                        width: "8.66669",
                        height: "25.1334",
                        transform: "rotate(45 18.5158 1.3562)",
                        fill: "url(#paint0_linear_6443_25979)"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                        id: "Ellipse 58",
                        cx: "4.33334",
                        cy: "21.6668",
                        r: "4.33334",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                        id: "Ellipse 54",
                        cx: "21.6669",
                        cy: "4.33334",
                        r: "4.33334",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("linearGradient", {
                    id: "paint0_linear_6443_25979",
                    x1: "23.1374",
                    y1: "1.13614",
                    x2: "22.5657",
                    y2: "25.2662",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("stop", {
                            stopColor: "#74CBD3"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#6C7594"
                        })
                    ]
                })
            })
        ]
    });
$037584e3e4e73fb7$export$3a9add76aac2435a.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$037584e3e4e73fb7$export$3a9add76aac2435a.defaultProps = {
    size: 26
};
const $037584e3e4e73fb7$export$8720f41dbb9273e6 = ({ size: size })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
        height: size,
        width: "120",
        viewBox: "0 0 120 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("g", {
            opacity: "0.3",
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M37.1475 16.9619H46.569V20.1299H33.0005V16.9619L42.136 4.81791H33.765V1.6499H46.2555V4.81791L37.1475 16.9619Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M55.688 14.0139L59.8131 20.1299H64.0261L57.7891 10.8899L55.688 14.0139Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M54.3569 5.80241L51.5574 1.6499H47.3444L52.2504 8.92092L54.3569 5.80241Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M51.5574 20.1299H47.3444L59.8129 1.6499H64.0259L51.5574 20.1299Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M65.1261 20.1299L68.7121 1.6499H74.2011C76.5991 1.6499 78.5131 2.3484 79.9486 3.75091C81.3841 5.14791 82.0991 7.08392 82.0991 9.54792C82.0991 12.7489 81.0321 15.3174 78.8926 17.2424C76.7531 19.1674 74.0581 20.1354 70.8021 20.1354H65.1261V20.1299ZM66.8696 18.7549H70.9341C73.6291 18.7549 75.9006 17.9299 77.7596 16.2744C79.6186 14.6189 80.5426 12.4024 80.5426 9.61942C80.5426 7.52392 79.9486 5.90141 78.7606 4.74641C77.5726 3.59141 75.9831 3.01941 73.9976 3.01941H69.9606L66.8696 18.7549Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M88.7487 20.5259C87.0932 20.5259 85.7677 19.9979 84.7612 18.9419C83.7602 17.8859 83.2542 16.4889 83.2542 14.7454C83.2542 12.7049 83.9086 10.9944 85.2232 9.60842C86.5322 8.22791 88.1657 7.53491 90.1182 7.53491C91.3667 7.53491 92.4447 7.82641 93.3522 8.40391C94.2597 8.98142 94.8867 9.79542 95.2387 10.8349H95.2937L95.8492 7.93091H97.2242L94.8482 20.1299H93.4732L93.9242 17.9134H93.8692C92.5657 19.6569 90.8607 20.5259 88.7487 20.5259ZM89.1997 19.2059C90.8167 19.2059 92.1697 18.6449 93.2532 17.5174C94.3367 16.3899 94.8757 14.9929 94.8757 13.3209C94.8757 11.9679 94.4577 10.8844 93.6217 10.0759C92.7857 9.26742 91.6527 8.86042 90.2282 8.86042C88.6772 8.86042 87.3737 9.42692 86.3067 10.5654C85.2397 11.6984 84.7117 13.1064 84.7117 14.7784C84.7117 16.1314 85.1187 17.2094 85.9272 18.0124C86.7357 18.8154 87.8302 19.2114 89.1997 19.2114V19.2059Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M103.115 9.09712L101.608 16.8081C101.553 17.1051 101.531 17.3801 101.531 17.6276C101.531 17.9961 101.652 18.2986 101.888 18.5241C102.125 18.7551 102.466 18.8651 102.906 18.8651H103.67L103.434 20.1852H102.587C101.828 20.1852 101.234 19.9761 100.794 19.5526C100.354 19.1291 100.134 18.5571 100.134 17.8366C100.134 17.5561 100.167 17.2206 100.238 16.8356L101.745 9.10262H99.1822L99.4187 7.94212H101.954L102.906 3.05811H104.281L103.329 7.94212H106.233L105.997 9.10262H103.12L103.115 9.09712Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
                    d: "M111.458 20.5259C109.803 20.5259 108.477 19.9979 107.471 18.9419C106.47 17.8859 105.964 16.4889 105.964 14.7454C105.964 12.7049 106.618 10.9944 107.933 9.60842C109.242 8.22791 110.875 7.53491 112.828 7.53491C114.076 7.53491 115.154 7.82641 116.062 8.40391C116.969 8.98142 117.596 9.79542 117.948 10.8349H118.003L118.559 7.93091H119.934L117.558 20.1299H116.183L116.634 17.9134H116.579C115.275 19.6569 113.57 20.5259 111.458 20.5259ZM111.909 19.2059C113.526 19.2059 114.879 18.6449 115.963 17.5174C117.046 16.3899 117.585 14.9929 117.585 13.3209C117.585 11.9679 117.167 10.8844 116.331 10.0759C115.495 9.26742 114.362 8.86042 112.938 8.86042C111.387 8.86042 110.083 9.42692 109.016 10.5654C107.949 11.6984 107.421 13.1064 107.421 14.7784C107.421 16.1314 107.828 17.2094 108.637 18.0124C109.445 18.8154 110.54 19.2114 111.909 19.2114V19.2059Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                    cx: "3.66716",
                    cy: "3.66716",
                    r: "3.66668",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                    cx: "18.3339",
                    cy: "18.3334",
                    r: "3.66668",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("rect", {
                    x: "15.6672",
                    y: "1.14746",
                    width: "7.33335",
                    height: "21.2667",
                    transform: "rotate(45 15.6672 1.14746)",
                    fill: "white",
                    fillOpacity: "0.5"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                    cx: "3.66668",
                    cy: "18.3334",
                    r: "3.66668",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
                    cx: "18.3335",
                    cy: "3.66668",
                    r: "3.66668",
                    fill: "white"
                })
            ]
        })
    });
$037584e3e4e73fb7$export$8720f41dbb9273e6.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$037584e3e4e73fb7$var$SiteLogo.defaultProps = {
    size: 22
};
var $037584e3e4e73fb7$export$2e2bcd8739ae039 = $037584e3e4e73fb7$var$SiteLogo;



var $70fFQ = parcelRequire("70fFQ");



const $2245bf051ccf70ab$var$useHasFeatureAccess = (featureName)=>{
    const { user: user } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const hasFeatureAccessQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).HAS_FEATURE_ACCESS(), {}, {
        enabled: Boolean(user)
    });
    const hasFeatureAccessQueryInfo = hasFeatureAccessQuery?.cleanedData;
    const featureAccessLoading = hasFeatureAccessQuery?.isLoading;
    return [
        hasFeatureAccessQueryInfo && hasFeatureAccessQueryInfo[featureName],
        featureAccessLoading
    ];
};
var $2245bf051ccf70ab$export$2e2bcd8739ae039 = $2245bf051ccf70ab$var$useHasFeatureAccess;


const $253eff529b7bdd6f$var$SiteFooterContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  display: flex;
  flex-shrink: 0;
  align-self: center;
  align-items: center;
  gap: 32px;
  padding-top: 48px;
  padding-bottom: 48px;
  border-top: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
/**
 * Renders a footer containing the site logo, and links to relevant legal documentation. Also
 * lets users report bugs. Should be inserted at the bottom of every page, within the scrollable
 * container for that page so that it becomes visible after scrolling to the bottom.
 */ const $253eff529b7bdd6f$var$SiteFooter = ()=>{
    const [portfoliosFeatureAccess] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$6d4c76a833ca8f22));
    const { user: user } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const siteLogo = (0, $fa6f9dce0653fce6$export$6b7545a126c3c6c5).includes(user?.email) ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $037584e3e4e73fb7$export$8e5f7bf6856988e9), {}) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $037584e3e4e73fb7$export$8720f41dbb9273e6), {});
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($253eff529b7bdd6f$var$SiteFooterContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).UNSTYLED,
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).HOME(),
                children: siteLogo
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openReportABug(),
                url: "mailto:support@zanbato.com",
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                    children: "Report a Bug"
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openTermsOfUse(),
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("tou"),
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                    children: "Terms of Use"
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openPrivacyPolicy(),
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("privacy"),
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                    children: "Privacy Policy"
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openNDA(),
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("nda"),
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                    children: "NDA"
                })
            }),
            portfoliosFeatureAccess && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).INSIGHTS(),
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                    children: "Insights"
                })
            })
        ]
    });
};
var $253eff529b7bdd6f$export$2e2bcd8739ae039 = $253eff529b7bdd6f$var$SiteFooter;




var $hI4Hx = parcelRequire("hI4Hx");

var $hI4Hx = parcelRequire("hI4Hx");

var $hI4Hx = parcelRequire("hI4Hx");
/**
 * Performs a multiplication by a power of 10 using string manipulation to
 * avoid floating point precision problems. Note that this does not work for
 * numbers of the form: 0.<6 or more zeroes><non-zero numbers> because their
 * toString() interpretation uses exponents. The alternative to toString is
 * toFixed, but that method seems unreliable when it comes to actually padding a
 * decimal value.
 *
 * Example: 0.000357871562323.toFixed(50) outputs
 * '0.00035787156232300001588650384398704318300588056445'
 * Which is pretty weird.
 *
 * The tradeoff for losing the precision beyond 6 decimal places (when the non-decimal
 * portion is zero), is that we avoid floating point precision problems like:
 * 5253959.56 * 10 == 52539595.599999994
 *
 * @param {number} number
 * @param {number} powerOfTen
 * @returns {number}
 */ const $9cd630fd213df404$var$multiplyByPowerOfTen = (number, powerOfTen)=>{
    let stringNumber = number.toString();
    // Pad enough zeroes to guarantee we do not get out-of-bounds errors.
    for(let i = 0; i < Math.abs(powerOfTen); i++)if (powerOfTen > 0) stringNumber += "0";
    else stringNumber = `0${stringNumber}`;
    let decimalIndex = stringNumber.indexOf(".");
    if (decimalIndex === -1) decimalIndex = powerOfTen > 0 ? stringNumber.length - powerOfTen : stringNumber.length;
    else stringNumber = `${stringNumber.slice(0, decimalIndex)}${stringNumber.slice(decimalIndex + 1)}`;
    const newDecimalIndex = decimalIndex + powerOfTen;
    stringNumber = `${stringNumber.slice(0, newDecimalIndex)}.${stringNumber.slice(newDecimalIndex)}`;
    return parseFloat(stringNumber);
};
var /**
 * Rounds the decimal to a fixed number of decimal places.
 *
 * .toFixed() has inconsistent rounding for cases that are close to being rounded or down due
 * to the way that floating point numbers are stored in JS so we need additional logic
 *
 * Logic: multiplying dec by the amount of decimals that we care about so that we can convert it to
 * be stored as an integer (taken care of by the Math.round/Math.floor), this solves the precision
 * issue with floating point. Next, we modulo by 10 to see if the last digit is 5 or greater,
 * in which case we want to round up (adding 1 to the number). We then want to display it as a
 * decimal again so we divide the number by the adjustment and use .toFixed to achieve the
 * correct padding of 0s.
 *
 * There is a limit to the precision that this works to. Tested up to decimalPlaces = 6.
 * Fails with: (params) -> result
 *             (0.000000015,8) -> 0.00000000
 *
 * @param {number} dec
 * @param {number} decimalPlaces
 * @returns {string}
 */ $9cd630fd213df404$export$2e2bcd8739ae039 = (dec, decimalPlaces = 2)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(dec) || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isUndefined(dec)) return "";
    const neg = dec < 0;
    const absNum = neg ? -1 * dec : dec;
    const BASE = 10;
    const floorAdjustment = BASE ** decimalPlaces;
    let roundedNum = 0;
    if ($9cd630fd213df404$var$multiplyByPowerOfTen(absNum, decimalPlaces + 1) % BASE >= BASE / 2) roundedNum = (Math.floor($9cd630fd213df404$var$multiplyByPowerOfTen(absNum, decimalPlaces)) + 1) / floorAdjustment;
    else roundedNum = Math.round($9cd630fd213df404$var$multiplyByPowerOfTen(absNum, decimalPlaces)) / floorAdjustment;
    if (neg) roundedNum *= -1;
    return roundedNum.toFixed(decimalPlaces);
};



/**
 * Convert a number into a readable string. this has some similarities to
 * ``convert_num_to_readable``
 *
 * @param {number} numRaw - the number to be converted
 * @param {number} decimalPlaces - optional argument
 * @param {boolean} preferExpanded - optional boolean to specify if you want to prefer to display
 *  decimals and a fully expanded number for numbers in the range [1000, 9999.99]. In example,
 *  instead of rendering $1340.50 as $1.34K, render it instead as $1341.50. Useful when the
 *  tradeoff of on-page width is worth it for the precision of the number.
 * @returns {string} a readable string representation of num
 */ const $ae4651a71cdb6522$var$convertNumToReadable = (numRaw, decimalPlaces = 2, preferExpanded = false)=>{
    const num = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isString(numRaw) ? Number.parseFloat(numRaw) : numRaw;
    if (num === 0) return "0";
    if (!num || num === Number.POSITIVE_INFINITY || num === Number.NEGATIVE_INFINITY) return "";
    const abs = Math.abs(num);
    if (abs < (0, $753b8dcbe6be17f9$export$77baccb4c6bd5852)) return (0, $9cd630fd213df404$export$2e2bcd8739ae039)(num, decimalPlaces);
    // Offers a way to render numbers < 10,000 without decimals, i.e. 1341.50 => 1342
    if (abs < (0, $753b8dcbe6be17f9$export$ae1f9aa6ba0be5df)) {
        const rounded = (0, $9cd630fd213df404$export$2e2bcd8739ae039)(num, 2);
        if (parseFloat(rounded) < (0, $753b8dcbe6be17f9$export$ae1f9aa6ba0be5df) && preferExpanded) return rounded;
    }
    if (abs < (0, $753b8dcbe6be17f9$export$7d08ee921734ee28)) {
        // Edge case handling where numbers like 999997.4 are less than $1.00M, but large enough
        // that they round to $1000.00K, should be displayed as $1.00M.
        const rounded = (0, $9cd630fd213df404$export$2e2bcd8739ae039)(num / (0, $753b8dcbe6be17f9$export$77baccb4c6bd5852), decimalPlaces);
        if (parseFloat(rounded) < (0, $753b8dcbe6be17f9$export$77baccb4c6bd5852)) return `${rounded}K`;
    }
    if (abs < (0, $753b8dcbe6be17f9$export$58a5337423702f7c)) {
        const rounded = (0, $9cd630fd213df404$export$2e2bcd8739ae039)(num / (0, $753b8dcbe6be17f9$export$7d08ee921734ee28), decimalPlaces);
        if (parseFloat(rounded) < (0, $753b8dcbe6be17f9$export$77baccb4c6bd5852)) return `${rounded}M`;
    }
    if (abs < (0, $753b8dcbe6be17f9$export$69abf931d0e964ac)) {
        const rounded = (0, $9cd630fd213df404$export$2e2bcd8739ae039)(num / (0, $753b8dcbe6be17f9$export$58a5337423702f7c), decimalPlaces);
        if (parseFloat(rounded) < (0, $753b8dcbe6be17f9$export$77baccb4c6bd5852)) return `${rounded}B`;
    }
    return `${(0, $9cd630fd213df404$export$2e2bcd8739ae039)(num / (0, $753b8dcbe6be17f9$export$69abf931d0e964ac), decimalPlaces)}T`;
};
var $ae4651a71cdb6522$export$2e2bcd8739ae039 = $ae4651a71cdb6522$var$convertNumToReadable;



var $hI4Hx = parcelRequire("hI4Hx");
/**
 * Convert a number into a comma-delimited string. this has some similarities to
 * ``strip_decimal_trailing_zeros``
 *
 * @param {number} num - the number to be converted
 * @param {number} minimumDecimalPlaces - optional argument
 * @returns {string} the comma-delimited string representation of num
 */ const $67b5297c2a83ffd3$var$addCommasToNum = (num, minimumDecimalPlaces = 0)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(num)) return num;
    const splitNumber = ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isString(num) ? Number(num) : num).toString().split(".");
    splitNumber[0] = splitNumber[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (minimumDecimalPlaces !== 0) {
        if (splitNumber.length < 2) splitNumber.push((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).repeat("0", minimumDecimalPlaces));
        else splitNumber[1] += (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).repeat("0", minimumDecimalPlaces - splitNumber[1].length);
    }
    return splitNumber.join(".");
};
var $67b5297c2a83ffd3$export$2e2bcd8739ae039 = $67b5297c2a83ffd3$var$addCommasToNum;



/**
 * Receives number and returns formatted string with dollar sign, commas and rounding
 * i.e (4000000) -> $4,000,000
 * i.e (4000000.5, 2, 0) -> $4,000,000.50
 * i.e (4000000.1234, 0, 2) -> $4,000,000.12
 *
 * @param {number} number
 * @param {number} minPrecision
 * @param {number} maxPrecision
 * @returns {string}
 */ // eslint-disable-next-line no-magic-numbers
const $66339e7a022e68c9$export$365988f95ba9ba73 = (number, minPrecision = 0, maxPrecision = 6)=>{
    const moneyFormat = number < 0 ? `-$${(0, $67b5297c2a83ffd3$export$2e2bcd8739ae039)((0, $9cd630fd213df404$export$2e2bcd8739ae039)(-number, maxPrecision), minPrecision)}` : `$${(0, $67b5297c2a83ffd3$export$2e2bcd8739ae039)((0, $9cd630fd213df404$export$2e2bcd8739ae039)(number, maxPrecision), minPrecision)}`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(number) ? "--" : moneyFormat;
};
/**
 * Receives number and returns formatted shorthand string, with suffix to represent size
 * i.e. (4000000) -> $4M
 * i.e. (4123450) -> $4.12M
 * i.e. (4123450, 3) -> $4.123M
 * Similar to ``convert_num_to_readable`` in numberformat.py
 *
 * @param {number} number
 * @param {number} precision
 * @param {boolean} preferExpanded - Do not abbreviate nor slice off cents for values in
 *  the range [1000, 9999.99].
 * @returns {string}
 */ const $66339e7a022e68c9$export$736d072c44caa715 = (number, precision = 2, preferExpanded = false)=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(number) || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isUndefined(number) ? "--" : `$${(0, $ae4651a71cdb6522$export$2e2bcd8739ae039)(number, precision, preferExpanded)}`;
/**
 * Receives number and number of decimal places and returns a string
 * representing the percentage value
 * i.e (50) -> 50.00%
 * i.e (50, 3) -> 50.000%
 * Similar to ``get_percent`` in numberformat.py
 *
 * @param {number} number
 * @param {number} decimalPlaces
 * @returns {string}
 */ const $66339e7a022e68c9$export$82fb8ba313c9dbb0 = (number, decimalPlaces = 2)=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(number) ? "--" : `${(0, $9cd630fd213df404$export$2e2bcd8739ae039)(number, decimalPlaces)}%`;






const $a72cb095399be523$export$2640e91038f768a9 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)}
  padding: 0 16px;
  width: 300px;
`;
const $a72cb095399be523$export$602bc615500fb959 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.headline1)}
  ${(0, $dfd33cee3229493c$exports.FontWeights).bold}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme100}
  margin-bottom: 12px;
`;
const $a72cb095399be523$export$9e01a360a7b6c6aa = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  margin: 24px 0 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $a72cb095399be523$export$4ea0ff3663964b59 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme30}
`;
const $a72cb095399be523$export$7fb51b284d7f1c81 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  height: 48px;
  margin: 16px 0;
`;





var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");





var $70fFQ = parcelRequire("70fFQ");

var $hI4Hx = parcelRequire("hI4Hx");

/**
 * Hook for tracking window dimensions.
 *
 * @returns {object} dimensions { width, height }
 */ const $9158ec1ce76b3577$var$useWindowDimensions = ()=>{
    const [dimensions, setDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback(()=>{
        setDimensions({
            height: window.innerHeight,
            width: window.innerWidth
        });
    }, []);
    const onWindowResizeDebounce = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useMemo(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce(onWindowResize, (0, $753b8dcbe6be17f9$export$34e77c57b0e8675a)), [
        onWindowResize
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(()=>{
        window.addEventListener("resize", onWindowResizeDebounce);
        return ()=>{
            window.removeEventListener("resize", onWindowResizeDebounce);
        };
    }, [
        onWindowResizeDebounce
    ]);
    return dimensions;
};
var $9158ec1ce76b3577$export$2e2bcd8739ae039 = $9158ec1ce76b3577$var$useWindowDimensions;



const $94e97caba62a953c$var$IndicatorArrow = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("svg", {
    width: "16",
    height: "10",
    viewBox: "0 0 16 10",
    fill: "none",
    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
        d: "M8 0L16 10H0L8 0Z",
        fill: "#5A686A"
    })
});
const $94e97caba62a953c$var$StyledIndicator = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  height: 10px;
  width: 16px;
  position: absolute;
  z-index: ${(0, $dfd33cee3229493c$exports.Z_INDEXES).zIndexModal};
`;
const $94e97caba62a953c$var$StyledWalkthroughContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: absolute;
  box-sizing: border-box;
  z-index: ${(0, $dfd33cee3229493c$exports.Z_INDEXES).zIndexModal};
  border-radius: 12px;
  background: #5a686a;
  padding: 24px;
  display: flex;
  gap: 24px;
  width: ${(props)=>props.$width}px;
  flex-direction: column;

  ${(props)=>props.$center && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      left: 50%;
      top: 50%;
      margin-left: -${props.$width / 2}px;
      margin-top: -${props.$height / 2}px;
    `}
`;
const $94e97caba62a953c$var$StyledHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const $94e97caba62a953c$var$StyledFooter = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;
const $94e97caba62a953c$var$DEFAULT_WIDTH = 400;
const $94e97caba62a953c$var$StyledBody2 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80)`
  line-height: 1.5; // Dataverse update for walkthroughs.
`;
/**
 * Presentational component to render a step of a tutorial.
 *
 * @param {object} props
 *
 * @returns {React.Element}
 */ const $94e97caba62a953c$var$Walkthrough = ({ name: name, steps: steps, initialStep: initialStep, onFinish: onFinish })=>{
    const { width: windowWidth, height: windowHeight } = (0, $9158ec1ce76b3577$export$2e2bcd8739ae039)();
    const [contentRef, , { height: height }] = (0, $4e12efec6f3d63a0$export$2e2bcd8739ae039)();
    const [currentStepIndex, setCurrentStepIndex] = (0, $70fFQ.useState)(initialStep);
    // Use query selector to position the indicator and dropdown correctly.
    const relativeElements = steps.map((step)=>step.positionSelector ? document.querySelector(step.positionSelector) : null);
    const currentStep = (0, $70fFQ.useMemo)(()=>steps[currentStepIndex], [
        steps,
        currentStepIndex
    ]);
    // Leave this here for posterity from copy-over job from ZX, we may need to bring it back at
    // some point.
    //
    // React.useLayoutEffect(() => {
    //   if (props.scroll) {
    //     const scrollAnchor = document.querySelector(props.scroll);
    //     if (scrollAnchor) {
    //       scrollAnchor.scrollIntoView();
    //       relativeElement.scrollIntoView();
    //     }
    //   }
    // }, [relativeElement, props.scroll]);
    const { top: parentTop, left: parentLeft, width: parentWidth, height: parentHeight } = relativeElements[currentStepIndex]?.getBoundingClientRect?.() || {};
    const nextStep = (0, $70fFQ.useCallback)(()=>{
        if (currentStepIndex === steps.length - 1) {
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).completeWalkthrough(name, currentStepIndex + 1);
            onFinish({
                stepsCompleted: currentStepIndex + 1
            });
            return;
        }
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).completeWalkthroughStep(name, currentStepIndex + 1);
        setCurrentStepIndex(currentStepIndex + 1);
    }, [
        name,
        currentStepIndex,
        steps,
        onFinish
    ]);
    const skipRemaining = (0, $70fFQ.useCallback)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).skipWalkthrough(name, currentStepIndex + 1, steps.length - currentStepIndex - 1);
        onFinish({
            stepsCompleted: currentStepIndex + 1
        });
    }, [
        name,
        onFinish,
        currentStepIndex,
        steps.length
    ]);
    const { top: top, left: left } = (0, $70fFQ.useMemo)(()=>{
        if (currentStep.positionSelector === null) return {
            top: null,
            left: null
        };
        let top = Math.max(0, parentTop + parentHeight + 8);
        let left = Math.max(0, parentLeft + parentWidth / 2 - (currentStep.width || $94e97caba62a953c$var$DEFAULT_WIDTH) / 2);
        // With a flick of the wrist, ensure the dropdown is within the window bounds.
        const right = left + (currentStep.width || $94e97caba62a953c$var$DEFAULT_WIDTH);
        // Height doesn't include padding so we need to add 48.
        // We also add 10 because the indicator takes up 10px above the "top" of the element.
        const bottom = top + height + 48 + 10;
        if (right > windowWidth) left -= right - windowWidth;
        if (bottom > windowHeight) top -= bottom - windowHeight;
        return {
            top: top,
            left: left
        };
    }, [
        currentStep,
        height,
        windowWidth,
        windowHeight,
        parentTop,
        parentHeight,
        parentLeft,
        parentWidth
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            button: {
                [(0, $dfd33cee3229493c$exports.ButtonStyles).CTA]: {
                    container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
                },
                [(0, $dfd33cee3229493c$exports.ButtonStyles).RAISED]: {
                    container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
                }
            }
        },
        children: [
            currentStep.positionSelector && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($94e97caba62a953c$var$StyledIndicator, {
                style: {
                    top: top,
                    left: parentLeft + parentWidth / 2 - 8
                },
                children: $94e97caba62a953c$var$IndicatorArrow
            }),
            currentStep.positionSelector ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($94e97caba62a953c$var$StyledWalkthroughContainer, {
                ref: contentRef,
                $width: currentStep.width || $94e97caba62a953c$var$DEFAULT_WIDTH,
                style: {
                    top: top + 10,
                    left: left
                },
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($94e97caba62a953c$var$StyledHeader, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme100, {
                                children: currentStep.title
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
                                children: [
                                    currentStepIndex + 1,
                                    " of ",
                                    steps.length
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($94e97caba62a953c$var$StyledBody2, {
                        children: currentStep.text
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($94e97caba62a953c$var$StyledFooter, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                onClick: skipRemaining,
                                children: "Skip"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                onClick: nextStep,
                                children: currentStepIndex === steps.length - 1 ? "Finish" : "Next"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).createPortal(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($94e97caba62a953c$var$StyledWalkthroughContainer, {
                ref: contentRef,
                $height: height,
                $width: currentStep.width || $94e97caba62a953c$var$DEFAULT_WIDTH,
                $center: true,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($94e97caba62a953c$var$StyledHeader, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme100, {
                                children: currentStep.title
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
                                children: [
                                    currentStepIndex + 1,
                                    " of ",
                                    steps.length
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($94e97caba62a953c$var$StyledBody2, {
                        children: currentStep.text
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($94e97caba62a953c$var$StyledFooter, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                onClick: skipRemaining,
                                children: "Skip"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                onClick: nextStep,
                                children: currentStepIndex === steps.length - 1 ? "Finish" : "Next"
                            })
                        ]
                    })
                ]
            }), document.body)
        ]
    });
};
$94e97caba62a953c$var$Walkthrough.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        positionSelector: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    })).isRequired,
    initialStep: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    onFinish: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
};
$94e97caba62a953c$var$Walkthrough.defaultProps = {
    initialStep: 0,
    width: 400,
    onFinish: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
};
var $94e97caba62a953c$export$2e2bcd8739ae039 = $94e97caba62a953c$var$Walkthrough;



var $70fFQ = parcelRequire("70fFQ");



const $f7a9c013198e3a53$var$LS_PREFIX = "walkthrough_dismissed_";
/**
 * Hook to manage the presentation boolean for a walkthrough, based on the field from the user's
 * completed walkthrough progress.
 *
 * @param walkthroughFieldName - name of the relevant walkthrough in user.walkthrough_progress.
 * @return {{walkthroughShowing: boolean, completeWalkthrough: function}}
 */ const $f7a9c013198e3a53$var$useWalkthrough = (walkthroughFieldName)=>{
    const { user: user, setUserData: setUserData } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const lsKey = `${$f7a9c013198e3a53$var$LS_PREFIX}${walkthroughFieldName}`;
    const isDismissed = ()=>!!user?.walkthrough_progress?.[walkthroughFieldName] || !!localStorage.getItem(lsKey);
    const [walkthroughShowing, setWalkthroughShowing] = (0, $70fFQ.useState)(!isDismissed());
    const walkthroughUpdate = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WALKTHROUGH_PROGRESS(user?.id), true, {
        silent: true
    });
    const completeWalkthrough = (0, $70fFQ.useCallback)(()=>{
        setWalkthroughShowing(false);
        localStorage.setItem(lsKey, "true");
        walkthroughUpdate.mutate({
            [walkthroughFieldName]: true
        }, {
            onSuccess: ()=>{
                setUserData();
            }
        });
    }, [
        walkthroughFieldName,
        setUserData,
        walkthroughUpdate,
        lsKey
    ]);
    return {
        walkthroughShowing: walkthroughShowing && !isDismissed(),
        completeWalkthrough: completeWalkthrough
    };
};
var $f7a9c013198e3a53$export$2e2bcd8739ae039 = $f7a9c013198e3a53$var$useWalkthrough;




const $02c8e5c0904a25fc$var$StyledCompanyListContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  padding-top: 48px;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  gap: 24px;
  flex-direction: column;
  align-self: center;
`;
const $02c8e5c0904a25fc$var$EmptyInfoContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding: 0 24px;
`;
const $02c8e5c0904a25fc$var$RANGE_QUERY_PARAM_KEYS = [
    (0, $2551481dcc2e9273$export$273d5e0c912ace6e),
    (0, $2551481dcc2e9273$export$2d53b25b9cc4bff4)
];
const $02c8e5c0904a25fc$var$CompanyListHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80)`
  width: fit-content;
`;
const $02c8e5c0904a25fc$var$WALKTHROUGH_STEPS = [
    {
        title: "New company screener",
        text: "With an updated view and more filters, you can now sift through hundreds of private companies and discover the right fit for your investment strategy.",
        positionSelector: "#company-list-header"
    },
    {
        title: "Powerful global search",
        text: "You can quickly and easily find any ZXData private company using the global search.",
        positionSelector: "#global-search-bar"
    },
    {
        title: "Brand new portfolio feature",
        text: "You can now manage your private market investments within ZXData.",
        positionSelector: "#portfolios-global-nav-link"
    }
];
const $02c8e5c0904a25fc$var$DEFAULT_FILTERS = {
    watchlist: null,
    [(0, $2551481dcc2e9273$export$273d5e0c912ace6e)]: null,
    [(0, $2551481dcc2e9273$export$2d53b25b9cc4bff4)]: null
};
const $02c8e5c0904a25fc$var$EmptyTablePlaceholderContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding: 224px 0;
`;
const $02c8e5c0904a25fc$var$CompanyList = ()=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const queryClient = (0, $7e71e0df4024a5cb$export$22e77b9572c4fded)();
    (0, $90c290bf538e7f9d$export$2e2bcd8739ae039)("ZXData: Company List");
    const { walkthroughShowing: walkthroughShowing, completeWalkthrough: completeWalkthrough } = (0, $f7a9c013198e3a53$export$2e2bcd8739ae039)("walkthrough_company_list");
    const [filters, setFilters] = (0, $70fFQ.useState)($02c8e5c0904a25fc$var$DEFAULT_FILTERS);
    (0, $70fFQ.useEffect)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).viewCompanyList();
    }, []);
    const queryParams = {
        ordering: "-robustness,-volume",
        time_frame: (0, $753b8dcbe6be17f9$export$e15589d55377682c),
        "page[size]": 30,
        // Intentionally can be undefined to include both watchlisted and non-watchlisted.
        watchlist: (0, $2551481dcc2e9273$export$eb3d1c509817ff28)[filters.watchlist],
        ...$02c8e5c0904a25fc$var$RANGE_QUERY_PARAM_KEYS.reduce((acc, key)=>filters[key] ? {
                ...acc,
                ...(0, $2551481dcc2e9273$export$b4756409cd4ced1a)[filters[key]].min !== null && {
                    [`${key}_min`]: (0, $2551481dcc2e9273$export$b4756409cd4ced1a)[filters[key]].min
                },
                ...(0, $2551481dcc2e9273$export$b4756409cd4ced1a)[filters[key]].max !== null && {
                    [`${key}_max`]: (0, $2551481dcc2e9273$export$b4756409cd4ced1a)[filters[key]].max
                }
            } : acc, {})
    };
    const queryInvalidator = [
        (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_LATEST_ORDER_FLOW(),
        queryParams,
        "paginated"
    ];
    const companyQueryInfo = (0, $f869aac89d4eda76$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_LATEST_ORDER_FLOW(), queryParams);
    const watchlistQueryInfo = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES());
    const watchlistDelete = (0, $fd1e6894b991baa0$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES(), {
        silent: true
    });
    const watchlistUpdate = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES(), false, {
        silent: true
    });
    // map for quick lookup on watchlisted companies
    const watchlistMap = (0, $70fFQ.useMemo)(()=>{
        if (watchlistQueryInfo.isSuccess) return watchlistQueryInfo.cleanedData.data.reduce((obj, watchlistItem)=>{
            obj[watchlistItem.company] = watchlistItem;
            return obj;
        }, {});
        return {};
    }, [
        watchlistQueryInfo.isSuccess,
        watchlistQueryInfo.cleanedData
    ]);
    const companies = (0, $70fFQ.useMemo)(()=>{
        if (companyQueryInfo.isSuccess) return companyQueryInfo.cleanedData.data;
        return [];
    }, [
        companyQueryInfo.isSuccess,
        companyQueryInfo.cleanedData
    ]);
    const fundingRoundsQuery = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)(companies?.map((company)=>({
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).FUNDING_ROUNDS(),
            queryParams: {
                company: company.apiId,
                "page[size]": 1
            }
        })));
    // We'll determine the funding round related to each company based on ordering.
    const fundingRounds = (0, $70fFQ.useMemo)(()=>{
        if (fundingRoundsQuery.isAnySuccess) return fundingRoundsQuery.cleanedData.map((queryResult)=>queryResult?.data?.[0]);
        return [];
    }, [
        fundingRoundsQuery.isAnySuccess,
        fundingRoundsQuery.cleanedData
    ]);
    const fundingRoundsMap = (0, $70fFQ.useMemo)(()=>{
        let result = {};
        for(let i = 0; i < companies.length; i++)if (!fundingRounds[i] && fundingRoundsQuery.queryInfo[i].isLoading) // Check to see if it's loading
        result[companies[i].apiId] = (0, $2551481dcc2e9273$export$267f7ff9a66227a8);
        else result[companies[i].apiId] = fundingRounds[i];
        return result;
    }, [
        companies,
        fundingRounds,
        fundingRoundsQuery.queryInfo
    ]);
    const transactionRecordsQuery = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)(companies?.map((company)=>({
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).TRANSACTION_RECORDS(),
            queryParams: {
                company: company.apiId
            }
        })));
    const transactionRecordSort = (a, b)=>{
        const dateA = a.closing_date || a.noticed_date;
        const dateB = b.closing_date || b.noticed_date;
        if (!dateA || dateA < dateB) return 1;
        if (!dateB || dateA > dateB) return -1;
        return 0;
    };
    // We'll determine the transaction records related to each company based on ordering.
    const transactionRecords = (0, $70fFQ.useMemo)(()=>{
        if (transactionRecordsQuery.isAnySuccess) return transactionRecordsQuery.cleanedData.map((queryResult)=>{
            const sortedQueryResult = queryResult?.data?.sort(transactionRecordSort);
            return sortedQueryResult?.[0];
        });
        return [];
    }, [
        transactionRecordsQuery.isAnySuccess,
        transactionRecordsQuery.cleanedData
    ]);
    const transactionRecordsMap = (0, $70fFQ.useMemo)(()=>{
        let result = {};
        for(let i = 0; i < companies.length; i++)if (!transactionRecords[i] && transactionRecordsQuery.queryInfo[i].isLoading) // Check to see if it's loading
        result[companies[i].apiId] = (0, $2551481dcc2e9273$export$267f7ff9a66227a8);
        else result[companies[i].apiId] = transactionRecords[i];
        return result;
    }, [
        companies,
        transactionRecords,
        transactionRecordsQuery.queryInfo
    ]);
    /*
   * Used to wrap the `setFilters` function to use the child filter buttons onChange interface.
   */ const makeOnChangeFunction = (0, $70fFQ.useCallback)((fieldName)=>{
        return (newValue)=>{
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).filterCompanyList({
                ...filters,
                [fieldName]: newValue
            });
            setFilters({
                ...filters,
                [fieldName]: newValue
            });
        };
    }, [
        filters
    ]);
    const watchlistCompany = (companyId, companyName)=>{
        watchlistUpdate.mutate({
            company: companyId
        }, {
            onSuccess: ()=>{
                queryClient.invalidateQueries({
                    queryKey: queryInvalidator
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES()
                    ]
                });
            }
        });
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addCompanyToWatchlist((0, $753b8dcbe6be17f9$export$16dc43bcee2b5f71), companyName);
    };
    const removeWatchlistedCompany = (companyId, companyName)=>{
        watchlistDelete.mutate({
            id: watchlistMap[companyId]?.apiId
        }, {
            onSuccess: ()=>{
                queryClient.invalidateQueries({
                    queryKey: queryInvalidator
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES()
                    ]
                });
            }
        });
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).removeCompanyFromWatchlist((0, $753b8dcbe6be17f9$export$16dc43bcee2b5f71), companyName);
    };
    const tableColumns = (0, $70fFQ.useMemo)(()=>[
            {
                id: "watchlist",
                accessor: (company)=>company,
                cellRenderer: ({ value: { apiId: apiId, name: name }, watchlistMap: watchlistMap, watchlistDeleteLoading: watchlistDeleteLoading, watchlistDeleteCompanyId: watchlistDeleteCompanyId, watchlistUpdateLoading: watchlistUpdateLoading, watchlistUpdateCompanyId: watchlistUpdateCompanyId, removeWatchlistedCompany: removeWatchlistedCompany, watchlistCompany: watchlistCompany })=>{
                    const watchlisted = apiId in watchlistMap;
                    if (watchlisted) {
                        if (watchlistDeleteLoading && watchlistDeleteCompanyId === apiId) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
                                showContainer: false,
                                absolute: false
                            })
                        });
                        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                            icon: (0, $dfd33cee3229493c$exports.BookmarkFilledIcon),
                            iconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500,
                            onClick: (e)=>{
                                removeWatchlistedCompany(apiId, name);
                                e.stopPropagation();
                            }
                        });
                    }
                    if (watchlistUpdateLoading && watchlistUpdateCompanyId === apiId) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
                            showContainer: false,
                            absolute: false
                        })
                    });
                    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                        icon: (0, $dfd33cee3229493c$exports.BookmarkIcon),
                        onClick: (e)=>{
                            watchlistCompany(apiId, name);
                            e.stopPropagation();
                        }
                    });
                },
                renderOverflow: true,
                align: "center",
                width: 50,
                useFixedWidth: true,
                header: "",
                sticky: true
            },
            {
                id: "name",
                accessor: (company)=>({
                        name: company.name,
                        avatar: company.main_picture
                    }),
                header: "Company",
                width: 250,
                sticky: true,
                cellRenderer: (0, $6fe5203b57b507ea$export$2e2bcd8739ae039)
            },
            {
                id: "zx_index_value",
                accessor: "zx_index_value",
                header: "ZX Index Value",
                width: 130,
                cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
                formatter: (value)=>value ? (0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, (0, $753b8dcbe6be17f9$export$64a5dce8d64aaa2a), (0, $753b8dcbe6be17f9$export$af244bfc5e04ba23)) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                        children: "--"
                    })
            },
            {
                id: "weekChange",
                accessor: "zx_index_value_percent_change",
                header: "Week Change",
                width: 120,
                cellRenderer: (0, $dfd33cee3229493c$exports.PercentageCell),
                isUnitInterval: true
            },
            {
                id: "lastTrade",
                header: "Last Trade",
                accessor: (company)=>({
                        company: company,
                        transactionRecordsMap: transactionRecordsMap
                    }),
                width: 100,
                cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
                formatter: ({ company: company, transactionRecordsMap: transactionRecordsMap })=>{
                    const transactionRecord = transactionRecordsMap[company.apiId];
                    if (transactionRecord === (0, $2551481dcc2e9273$export$267f7ff9a66227a8)) return 0, $2551481dcc2e9273$export$267f7ff9a66227a8;
                    if (!transactionRecord || !transactionRecord.price_per_share) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                        children: "--"
                    });
                    return (0, $66339e7a022e68c9$export$365988f95ba9ba73)(transactionRecord.price_per_share, (0, $753b8dcbe6be17f9$export$64a5dce8d64aaa2a), (0, $753b8dcbe6be17f9$export$af244bfc5e04ba23));
                }
            },
            {
                id: "lastRoundPrice",
                accessor: (company)=>({
                        company: company,
                        fundingRoundsMap: fundingRoundsMap
                    }),
                header: "LR Price",
                width: 100,
                cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
                formatter: ({ company: company, fundingRoundsMap: fundingRoundsMap })=>{
                    const fundingRound = fundingRoundsMap[company.apiId];
                    if (fundingRound === (0, $2551481dcc2e9273$export$267f7ff9a66227a8)) return 0, $2551481dcc2e9273$export$267f7ff9a66227a8;
                    if (!fundingRound || !fundingRound.price_per_share) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                        children: "--"
                    });
                    return (0, $66339e7a022e68c9$export$365988f95ba9ba73)(fundingRound.price_per_share, (0, $753b8dcbe6be17f9$export$64a5dce8d64aaa2a), (0, $753b8dcbe6be17f9$export$af244bfc5e04ba23));
                }
            },
            {
                id: "volume",
                accessor: "total_volume",
                header: "$ Volume (M)",
                width: 120,
                cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
                formatter: (value)=>(0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, 0, 0)
            },
            {
                id: "robustnessScore",
                accessor: "robustness",
                header: "Robustness Score",
                width: 160,
                cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
                formatter: (value)=>value != null ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                        children: [
                            value,
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "/10"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                        children: "--"
                    })
            },
            {
                id: "bid_ask_ratio",
                accessor: "bid_ask_ratio",
                header: "Bid/Ask Ratio",
                width: 120,
                cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
                formatter: (value)=>(0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(value * 100, 0)
            }
        ], [
        fundingRoundsMap,
        transactionRecordsMap
    ]);
    if (companyQueryInfo.isError) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($02c8e5c0904a25fc$var$StyledCompanyListContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                children: "Company List"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f04c7d74952e4f04$export$2e2bcd8739ae039), {
                resetFilters: ()=>setFilters($02c8e5c0904a25fc$var$DEFAULT_FILTERS),
                filters: filters,
                makeOnChangeFunction: makeOnChangeFunction
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($02c8e5c0904a25fc$var$EmptyInfoContainer, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a72cb095399be523$export$4ea0ff3663964b59), {
                    children: "An error has occurred."
                })
            })
        ]
    });
    const onRowClick = ({ row: { index: index } })=>{
        const companyId = companies[index].apiId;
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickCompanyListItem(companies[index].name);
        dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).updateMixpanelEventSource,
            source: "company screener",
            target: (0, $46a097389bbbbe65$export$796b285b8ee8898e)
        });
        navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANY(companyId));
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            tableStyles: {
                colors: {
                    header: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0,
                    row: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0,
                    rowHover: (0, $dfd33cee3229493c$exports.ColorPalette).surface1
                },
                header: {
                    height: 42,
                    borderTop: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`,
                    borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
                },
                cells: {
                    height: 56,
                    borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($02c8e5c0904a25fc$var$StyledCompanyListContainer, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($02c8e5c0904a25fc$var$CompanyListHeader, {
                        id: "company-list-header",
                        children: "Company Screener"
                    }),
                    walkthroughShowing && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $94e97caba62a953c$export$2e2bcd8739ae039), {
                        name: "company screener",
                        steps: $02c8e5c0904a25fc$var$WALKTHROUGH_STEPS,
                        onFinish: completeWalkthrough
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f04c7d74952e4f04$export$2e2bcd8739ae039), {
                        resetFilters: ()=>setFilters($02c8e5c0904a25fc$var$DEFAULT_FILTERS),
                        filters: filters,
                        makeOnChangeFunction: makeOnChangeFunction
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                        watchlistMap: watchlistMap,
                        watchlistDeleteLoading: watchlistDelete.isLoading,
                        watchlistDeleteCompanyId: watchlistDelete.variables?.id,
                        watchlistUpdateLoading: watchlistUpdate.isLoading,
                        watchlistUpdateCompanyId: watchlistUpdate.variables?.company,
                        removeWatchlistedCompany: removeWatchlistedCompany,
                        watchlistCompany: watchlistCompany,
                        data: companies,
                        fundingRoundsMap: fundingRoundsMap,
                        onRowClick: onRowClick,
                        paginationFunc: companyQueryInfo.hasNextPage && !companyQueryInfo.isFetchingNextPage ? companyQueryInfo.fetchNextPage : null,
                        isLoading: companyQueryInfo.isLoading,
                        isPaginationLoading: companyQueryInfo.isFetchingNextPage,
                        columns: tableColumns,
                        emptyTablePlaceholder: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($02c8e5c0904a25fc$var$EmptyTablePlaceholderContainer, {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme30, {
                                children: "No companies match your screen. Please update or remove filters and try again."
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $253eff529b7bdd6f$export$2e2bcd8739ae039), {})
        ]
    });
};
var $02c8e5c0904a25fc$export$2e2bcd8739ae039 = $02c8e5c0904a25fc$var$CompanyList;


var $75b6a3dd02a2fc8f$export$2e2bcd8739ae039 = (0, $02c8e5c0904a25fc$export$2e2bcd8739ae039);




var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");




var $70fFQ = parcelRequire("70fFQ");




var $hI4Hx = parcelRequire("hI4Hx");
var $86d2f3987cc9d604$exports = {};
'use strict';
Object.defineProperty($86d2f3987cc9d604$exports, '__esModule', {
    value: true
});
function $86d2f3987cc9d604$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $86d2f3987cc9d604$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $86d2f3987cc9d604$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $86d2f3987cc9d604$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $86d2f3987cc9d604$var$_extends() {
    $86d2f3987cc9d604$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $86d2f3987cc9d604$var$_extends.apply(this, arguments);
}
function $86d2f3987cc9d604$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $86d2f3987cc9d604$var$_setPrototypeOf(subClass, superClass);
}
function $86d2f3987cc9d604$var$_getPrototypeOf(o) {
    $86d2f3987cc9d604$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $86d2f3987cc9d604$var$_getPrototypeOf(o);
}
function $86d2f3987cc9d604$var$_setPrototypeOf(o, p) {
    $86d2f3987cc9d604$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $86d2f3987cc9d604$var$_setPrototypeOf(o, p);
}
function $86d2f3987cc9d604$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $86d2f3987cc9d604$var$_construct(Parent, args, Class) {
    if ($86d2f3987cc9d604$var$_isNativeReflectConstruct()) $86d2f3987cc9d604$var$_construct = Reflect.construct.bind();
    else $86d2f3987cc9d604$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $86d2f3987cc9d604$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $86d2f3987cc9d604$var$_construct.apply(null, arguments);
}
function $86d2f3987cc9d604$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $86d2f3987cc9d604$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $86d2f3987cc9d604$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$86d2f3987cc9d604$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $86d2f3987cc9d604$var$_construct(Class, arguments, $86d2f3987cc9d604$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $86d2f3987cc9d604$var$_setPrototypeOf(Wrapper, Class);
    };
    return $86d2f3987cc9d604$var$_wrapNativeSuper(Class);
}
function $86d2f3987cc9d604$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $86d2f3987cc9d604$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $86d2f3987cc9d604$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $86d2f3987cc9d604$var$_arrayLikeToArray(o, minLen);
}
function $86d2f3987cc9d604$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $86d2f3987cc9d604$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $86d2f3987cc9d604$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $86d2f3987cc9d604$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $86d2f3987cc9d604$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $86d2f3987cc9d604$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $86d2f3987cc9d604$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($86d2f3987cc9d604$var$LuxonError);
/**
 * @private
 */ var $86d2f3987cc9d604$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $86d2f3987cc9d604$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($86d2f3987cc9d604$var$LuxonError);
/**
 * @private
 */ var $86d2f3987cc9d604$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $86d2f3987cc9d604$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($86d2f3987cc9d604$var$LuxonError);
/**
 * @private
 */ var $86d2f3987cc9d604$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $86d2f3987cc9d604$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($86d2f3987cc9d604$var$LuxonError);
/**
 * @private
 */ var $86d2f3987cc9d604$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $86d2f3987cc9d604$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($86d2f3987cc9d604$var$LuxonError);
/**
 * @private
 */ var $86d2f3987cc9d604$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $86d2f3987cc9d604$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($86d2f3987cc9d604$var$LuxonError);
/**
 * @private
 */ var $86d2f3987cc9d604$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $86d2f3987cc9d604$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($86d2f3987cc9d604$var$LuxonError);
/**
 * @private
 */ var $86d2f3987cc9d604$var$n = "numeric", $86d2f3987cc9d604$var$s = "short", $86d2f3987cc9d604$var$l = "long";
var $86d2f3987cc9d604$var$DATE_SHORT = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$n,
    day: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATE_MED = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$s,
    day: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATE_MED_WITH_WEEKDAY = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$s,
    day: $86d2f3987cc9d604$var$n,
    weekday: $86d2f3987cc9d604$var$s
};
var $86d2f3987cc9d604$var$DATE_FULL = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$l,
    day: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATE_HUGE = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$l,
    day: $86d2f3987cc9d604$var$n,
    weekday: $86d2f3987cc9d604$var$l
};
var $86d2f3987cc9d604$var$TIME_SIMPLE = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$TIME_WITH_SECONDS = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$TIME_WITH_SHORT_OFFSET = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n,
    timeZoneName: $86d2f3987cc9d604$var$s
};
var $86d2f3987cc9d604$var$TIME_WITH_LONG_OFFSET = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n,
    timeZoneName: $86d2f3987cc9d604$var$l
};
var $86d2f3987cc9d604$var$TIME_24_SIMPLE = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    hourCycle: "h23"
};
var $86d2f3987cc9d604$var$TIME_24_WITH_SECONDS = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n,
    hourCycle: "h23"
};
var $86d2f3987cc9d604$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n,
    hourCycle: "h23",
    timeZoneName: $86d2f3987cc9d604$var$s
};
var $86d2f3987cc9d604$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n,
    hourCycle: "h23",
    timeZoneName: $86d2f3987cc9d604$var$l
};
var $86d2f3987cc9d604$var$DATETIME_SHORT = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$n,
    day: $86d2f3987cc9d604$var$n,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$n,
    day: $86d2f3987cc9d604$var$n,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATETIME_MED = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$s,
    day: $86d2f3987cc9d604$var$n,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATETIME_MED_WITH_SECONDS = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$s,
    day: $86d2f3987cc9d604$var$n,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$s,
    day: $86d2f3987cc9d604$var$n,
    weekday: $86d2f3987cc9d604$var$s,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n
};
var $86d2f3987cc9d604$var$DATETIME_FULL = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$l,
    day: $86d2f3987cc9d604$var$n,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    timeZoneName: $86d2f3987cc9d604$var$s
};
var $86d2f3987cc9d604$var$DATETIME_FULL_WITH_SECONDS = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$l,
    day: $86d2f3987cc9d604$var$n,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n,
    timeZoneName: $86d2f3987cc9d604$var$s
};
var $86d2f3987cc9d604$var$DATETIME_HUGE = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$l,
    day: $86d2f3987cc9d604$var$n,
    weekday: $86d2f3987cc9d604$var$l,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    timeZoneName: $86d2f3987cc9d604$var$l
};
var $86d2f3987cc9d604$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $86d2f3987cc9d604$var$n,
    month: $86d2f3987cc9d604$var$l,
    day: $86d2f3987cc9d604$var$n,
    weekday: $86d2f3987cc9d604$var$l,
    hour: $86d2f3987cc9d604$var$n,
    minute: $86d2f3987cc9d604$var$n,
    second: $86d2f3987cc9d604$var$n,
    timeZoneName: $86d2f3987cc9d604$var$l
};
/**
 * @private
 */ // TYPES
function $86d2f3987cc9d604$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $86d2f3987cc9d604$var$isNumber(o) {
    return typeof o === "number";
}
function $86d2f3987cc9d604$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $86d2f3987cc9d604$var$isString(o) {
    return typeof o === "string";
}
function $86d2f3987cc9d604$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES
function $86d2f3987cc9d604$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
} // OBJECTS AND ARRAYS
function $86d2f3987cc9d604$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $86d2f3987cc9d604$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $86d2f3987cc9d604$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $86d2f3987cc9d604$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS
function $86d2f3987cc9d604$var$integerBetween(thing, bottom, top) {
    return $86d2f3987cc9d604$var$isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x
function $86d2f3987cc9d604$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $86d2f3987cc9d604$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $86d2f3987cc9d604$var$parseInteger(string) {
    if ($86d2f3987cc9d604$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $86d2f3987cc9d604$var$parseFloating(string) {
    if ($86d2f3987cc9d604$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $86d2f3987cc9d604$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($86d2f3987cc9d604$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $86d2f3987cc9d604$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
} // DATE BASICS
function $86d2f3987cc9d604$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $86d2f3987cc9d604$var$daysInYear(year) {
    return $86d2f3987cc9d604$var$isLeapYear(year) ? 366 : 365;
}
function $86d2f3987cc9d604$var$daysInMonth(year, month) {
    var modMonth = $86d2f3987cc9d604$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $86d2f3987cc9d604$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $86d2f3987cc9d604$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        d.setUTCFullYear(d.getUTCFullYear() - 1900);
    }
    return +d;
}
function $86d2f3987cc9d604$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $86d2f3987cc9d604$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING
function $86d2f3987cc9d604$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $86d2f3987cc9d604$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
} // signedOffset('-5', '30') -> -330
function $86d2f3987cc9d604$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
} // COERCION
function $86d2f3987cc9d604$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $86d2f3987cc9d604$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $86d2f3987cc9d604$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($86d2f3987cc9d604$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $86d2f3987cc9d604$var$asNumber(v);
    }
    return normalized;
}
function $86d2f3987cc9d604$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $86d2f3987cc9d604$var$padStart(hours, 2) + ":" + $86d2f3987cc9d604$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $86d2f3987cc9d604$var$padStart(hours, 2) + $86d2f3987cc9d604$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $86d2f3987cc9d604$var$timeObject(obj) {
    return $86d2f3987cc9d604$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
var $86d2f3987cc9d604$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
/**
 * @private
 */ var $86d2f3987cc9d604$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $86d2f3987cc9d604$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $86d2f3987cc9d604$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $86d2f3987cc9d604$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($86d2f3987cc9d604$var$monthsNarrow);
        case "short":
            return [].concat($86d2f3987cc9d604$var$monthsShort);
        case "long":
            return [].concat($86d2f3987cc9d604$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $86d2f3987cc9d604$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $86d2f3987cc9d604$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $86d2f3987cc9d604$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $86d2f3987cc9d604$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($86d2f3987cc9d604$var$weekdaysNarrow);
        case "short":
            return [].concat($86d2f3987cc9d604$var$weekdaysShort);
        case "long":
            return [].concat($86d2f3987cc9d604$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $86d2f3987cc9d604$var$meridiems = [
    "AM",
    "PM"
];
var $86d2f3987cc9d604$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $86d2f3987cc9d604$var$erasShort = [
    "BC",
    "AD"
];
var $86d2f3987cc9d604$var$erasNarrow = [
    "B",
    "A"
];
function $86d2f3987cc9d604$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($86d2f3987cc9d604$var$erasNarrow);
        case "short":
            return [].concat($86d2f3987cc9d604$var$erasShort);
        case "long":
            return [].concat($86d2f3987cc9d604$var$erasLong);
        default:
            return null;
    }
}
function $86d2f3987cc9d604$var$meridiemForDateTime(dt) {
    return $86d2f3987cc9d604$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $86d2f3987cc9d604$var$weekdayForDateTime(dt, length) {
    return $86d2f3987cc9d604$var$weekdays(length)[dt.weekday - 1];
}
function $86d2f3987cc9d604$var$monthForDateTime(dt, length) {
    return $86d2f3987cc9d604$var$months(length)[dt.month - 1];
}
function $86d2f3987cc9d604$var$eraForDateTime(dt, length) {
    return $86d2f3987cc9d604$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $86d2f3987cc9d604$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $86d2f3987cc9d604$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $86d2f3987cc9d604$var$_macroTokenToFormatOpts = {
    D: $86d2f3987cc9d604$var$DATE_SHORT,
    DD: $86d2f3987cc9d604$var$DATE_MED,
    DDD: $86d2f3987cc9d604$var$DATE_FULL,
    DDDD: $86d2f3987cc9d604$var$DATE_HUGE,
    t: $86d2f3987cc9d604$var$TIME_SIMPLE,
    tt: $86d2f3987cc9d604$var$TIME_WITH_SECONDS,
    ttt: $86d2f3987cc9d604$var$TIME_WITH_SHORT_OFFSET,
    tttt: $86d2f3987cc9d604$var$TIME_WITH_LONG_OFFSET,
    T: $86d2f3987cc9d604$var$TIME_24_SIMPLE,
    TT: $86d2f3987cc9d604$var$TIME_24_WITH_SECONDS,
    TTT: $86d2f3987cc9d604$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $86d2f3987cc9d604$var$TIME_24_WITH_LONG_OFFSET,
    f: $86d2f3987cc9d604$var$DATETIME_SHORT,
    ff: $86d2f3987cc9d604$var$DATETIME_MED,
    fff: $86d2f3987cc9d604$var$DATETIME_FULL,
    ffff: $86d2f3987cc9d604$var$DATETIME_HUGE,
    F: $86d2f3987cc9d604$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $86d2f3987cc9d604$var$DATETIME_MED_WITH_SECONDS,
    FFF: $86d2f3987cc9d604$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $86d2f3987cc9d604$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $86d2f3987cc9d604$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed,
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: false,
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed,
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $86d2f3987cc9d604$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $86d2f3987cc9d604$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $86d2f3987cc9d604$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $86d2f3987cc9d604$var$_extends({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $86d2f3987cc9d604$var$_extends({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $86d2f3987cc9d604$var$padStart(n, p);
        var opts = $86d2f3987cc9d604$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $86d2f3987cc9d604$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $86d2f3987cc9d604$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $86d2f3987cc9d604$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $86d2f3987cc9d604$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $86d2f3987cc9d604$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $86d2f3987cc9d604$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $86d2f3987cc9d604$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/**
 * @interface
 */ var $86d2f3987cc9d604$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
    };
    $86d2f3987cc9d604$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $86d2f3987cc9d604$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $86d2f3987cc9d604$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $86d2f3987cc9d604$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $86d2f3987cc9d604$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $86d2f3987cc9d604$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $86d2f3987cc9d604$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $86d2f3987cc9d604$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($86d2f3987cc9d604$var$singleton$1 === null) $86d2f3987cc9d604$var$singleton$1 = new SystemZone();
                return $86d2f3987cc9d604$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($86d2f3987cc9d604$var$Zone);
var $86d2f3987cc9d604$var$dtfCache = {};
function $86d2f3987cc9d604$var$makeDTF(zone) {
    if (!$86d2f3987cc9d604$var$dtfCache[zone]) $86d2f3987cc9d604$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $86d2f3987cc9d604$var$dtfCache[zone];
}
var $86d2f3987cc9d604$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $86d2f3987cc9d604$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $86d2f3987cc9d604$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $86d2f3987cc9d604$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$86d2f3987cc9d604$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $86d2f3987cc9d604$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $86d2f3987cc9d604$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $86d2f3987cc9d604$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$86d2f3987cc9d604$var$ianaZoneCache[name]) $86d2f3987cc9d604$var$ianaZoneCache[name] = new IANAZone(name);
        return $86d2f3987cc9d604$var$ianaZoneCache[name];
    };
    IANAZone.resetCache = function resetCache() {
        $86d2f3987cc9d604$var$ianaZoneCache = {};
        $86d2f3987cc9d604$var$dtfCache = {};
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $86d2f3987cc9d604$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $86d2f3987cc9d604$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $86d2f3987cc9d604$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $86d2f3987cc9d604$var$partsOffset(dtf, date) : $86d2f3987cc9d604$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
         // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $86d2f3987cc9d604$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $86d2f3987cc9d604$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($86d2f3987cc9d604$var$Zone);
var $86d2f3987cc9d604$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $86d2f3987cc9d604$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $86d2f3987cc9d604$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($86d2f3987cc9d604$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $86d2f3987cc9d604$var$formatOffset(this.fixed, format);
    };
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $86d2f3987cc9d604$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $86d2f3987cc9d604$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $86d2f3987cc9d604$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($86d2f3987cc9d604$var$singleton === null) $86d2f3987cc9d604$var$singleton = new FixedOffsetZone(0);
                return $86d2f3987cc9d604$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($86d2f3987cc9d604$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $86d2f3987cc9d604$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $86d2f3987cc9d604$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $86d2f3987cc9d604$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($86d2f3987cc9d604$var$Zone);
/**
 * @private
 */ function $86d2f3987cc9d604$var$normalizeZone(input, defaultZone) {
    if ($86d2f3987cc9d604$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $86d2f3987cc9d604$var$Zone) return input;
    else if ($86d2f3987cc9d604$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "local" || lowered === "system") return defaultZone;
        else if (lowered === "utc" || lowered === "gmt") return $86d2f3987cc9d604$var$FixedOffsetZone.utcInstance;
        else return $86d2f3987cc9d604$var$FixedOffsetZone.parseSpecifier(lowered) || $86d2f3987cc9d604$var$IANAZone.create(input);
    } else if ($86d2f3987cc9d604$var$isNumber(input)) return $86d2f3987cc9d604$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $86d2f3987cc9d604$var$InvalidZone(input);
}
var $86d2f3987cc9d604$var$now = function now() {
    return Date.now();
}, $86d2f3987cc9d604$var$defaultZone = "system", $86d2f3987cc9d604$var$defaultLocale = null, $86d2f3987cc9d604$var$defaultNumberingSystem = null, $86d2f3987cc9d604$var$defaultOutputCalendar = null, $86d2f3987cc9d604$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $86d2f3987cc9d604$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $86d2f3987cc9d604$var$Locale.resetCache();
        $86d2f3987cc9d604$var$IANAZone.resetCache();
    };
    $86d2f3987cc9d604$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $86d2f3987cc9d604$var$now;
            },
            set: function set(n) {
                $86d2f3987cc9d604$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $86d2f3987cc9d604$var$normalizeZone($86d2f3987cc9d604$var$defaultZone, $86d2f3987cc9d604$var$SystemZone.instance);
            },
            set: function set(zone) {
                $86d2f3987cc9d604$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $86d2f3987cc9d604$var$defaultLocale;
            },
            set: function set(locale) {
                $86d2f3987cc9d604$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $86d2f3987cc9d604$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $86d2f3987cc9d604$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $86d2f3987cc9d604$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $86d2f3987cc9d604$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $86d2f3987cc9d604$var$throwOnInvalid;
            },
            set: function set(t) {
                $86d2f3987cc9d604$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $86d2f3987cc9d604$var$_excluded = [
    "base"
], $86d2f3987cc9d604$var$_excluded2 = [
    "padTo",
    "floor"
];
var $86d2f3987cc9d604$var$intlLFCache = {};
function $86d2f3987cc9d604$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $86d2f3987cc9d604$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $86d2f3987cc9d604$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $86d2f3987cc9d604$var$intlDTCache = {};
function $86d2f3987cc9d604$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $86d2f3987cc9d604$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $86d2f3987cc9d604$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $86d2f3987cc9d604$var$intlNumCache = {};
function $86d2f3987cc9d604$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $86d2f3987cc9d604$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $86d2f3987cc9d604$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $86d2f3987cc9d604$var$intlRelCache = {};
function $86d2f3987cc9d604$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $86d2f3987cc9d604$var$_objectWithoutPropertiesLoose(_opts, $86d2f3987cc9d604$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $86d2f3987cc9d604$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $86d2f3987cc9d604$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $86d2f3987cc9d604$var$sysLocaleCache = null;
function $86d2f3987cc9d604$var$systemLocale() {
    if ($86d2f3987cc9d604$var$sysLocaleCache) return $86d2f3987cc9d604$var$sysLocaleCache;
    else {
        $86d2f3987cc9d604$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $86d2f3987cc9d604$var$sysLocaleCache;
    }
}
function $86d2f3987cc9d604$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var smaller = localeStr.substring(0, uIndex);
        try {
            options = $86d2f3987cc9d604$var$getCachedDTF(localeStr).resolvedOptions();
        } catch (e) {
            options = $86d2f3987cc9d604$var$getCachedDTF(smaller).resolvedOptions();
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
        return [
            smaller,
            numberingSystem,
            calendar
        ];
    }
}
function $86d2f3987cc9d604$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $86d2f3987cc9d604$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $86d2f3987cc9d604$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $86d2f3987cc9d604$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $86d2f3987cc9d604$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $86d2f3987cc9d604$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $86d2f3987cc9d604$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $86d2f3987cc9d604$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $86d2f3987cc9d604$var$_objectWithoutPropertiesLoose(opts, $86d2f3987cc9d604$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $86d2f3987cc9d604$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $86d2f3987cc9d604$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $86d2f3987cc9d604$var$roundTo(i, 3);
            return $86d2f3987cc9d604$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $86d2f3987cc9d604$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        var z;
        if (dt.zone.isUniversal) {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $86d2f3987cc9d604$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
                // So we have to make do. Two cases:
                // 1. The format options tell us to show the zone. We can't do that, so the best
                // we can do is format the date in UTC.
                // 2. The format options don't tell us to show the zone. Then we can adjust them
                // the time and tell the formatter to show it to us in UTC, so that the time is right
                // and the bad zone doesn't show up.
                z = "UTC";
                if (opts.timeZoneName) this.dt = dt;
                else this.dt = dt.offset === 0 ? dt : $86d2f3987cc9d604$var$DateTime.fromMillis(dt.ts + dt.offset * 60000);
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else {
            this.dt = dt;
            z = dt.zone.name;
        }
        var intlOpts = $86d2f3987cc9d604$var$_extends({}, this.opts);
        if (z) intlOpts.timeZone = z;
        this.dtf = $86d2f3987cc9d604$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        return this.dtf.formatToParts(this.dt.toJSDate());
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $86d2f3987cc9d604$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $86d2f3987cc9d604$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $86d2f3987cc9d604$var$hasRelative()) this.rtf = $86d2f3987cc9d604$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $86d2f3987cc9d604$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $86d2f3987cc9d604$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $86d2f3987cc9d604$var$Settings.defaultLocale; // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $86d2f3987cc9d604$var$systemLocale());
        var numberingSystemR = numberingSystem || $86d2f3987cc9d604$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $86d2f3987cc9d604$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $86d2f3987cc9d604$var$sysLocaleCache = null;
        $86d2f3987cc9d604$var$intlDTCache = {};
        $86d2f3987cc9d604$var$intlNumCache = {};
        $86d2f3987cc9d604$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, outputCalendar = _ref.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $86d2f3987cc9d604$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $86d2f3987cc9d604$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($86d2f3987cc9d604$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($86d2f3987cc9d604$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $86d2f3987cc9d604$var$listStuff(this, length, defaultOK, $86d2f3987cc9d604$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this.monthsCache[formatStr][length]) _this.monthsCache[formatStr][length] = $86d2f3987cc9d604$var$mapMonths(function(dt) {
                return _this.extract(dt, intl, "month");
            });
            return _this.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $86d2f3987cc9d604$var$listStuff(this, length, defaultOK, $86d2f3987cc9d604$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.weekdaysCache[formatStr][length]) _this2.weekdaysCache[formatStr][length] = $86d2f3987cc9d604$var$mapWeekdays(function(dt) {
                return _this2.extract(dt, intl, "weekday");
            });
            return _this2.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this3 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $86d2f3987cc9d604$var$listStuff(this, undefined, defaultOK, function() {
            return $86d2f3987cc9d604$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this3.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this3.meridiemCache = [
                    $86d2f3987cc9d604$var$DateTime.utc(2016, 11, 13, 9),
                    $86d2f3987cc9d604$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this3.extract(dt, intl, "dayperiod");
                });
            }
            return _this3.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $86d2f3987cc9d604$var$listStuff(this, length, defaultOK, $86d2f3987cc9d604$var$eras, function() {
            var intl = {
                era: length
            }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this4.eraCache[length]) _this4.eraCache[length] = [
                $86d2f3987cc9d604$var$DateTime.utc(-40, 1, 1),
                $86d2f3987cc9d604$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this4.extract(dt, intl, "era");
            });
            return _this4.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $86d2f3987cc9d604$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $86d2f3987cc9d604$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $86d2f3987cc9d604$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $86d2f3987cc9d604$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $86d2f3987cc9d604$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $86d2f3987cc9d604$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ function $86d2f3987cc9d604$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $86d2f3987cc9d604$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $86d2f3987cc9d604$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $86d2f3987cc9d604$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $86d2f3987cc9d604$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $86d2f3987cc9d604$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
} // ISO and SQL parsing
var $86d2f3987cc9d604$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $86d2f3987cc9d604$var$isoExtendedZone = "(?:" + $86d2f3987cc9d604$var$offsetRegex.source + "?(?:\\[(" + $86d2f3987cc9d604$var$ianaRegex.source + ")\\])?)?";
var $86d2f3987cc9d604$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $86d2f3987cc9d604$var$isoTimeRegex = RegExp("" + $86d2f3987cc9d604$var$isoTimeBaseRegex.source + $86d2f3987cc9d604$var$isoExtendedZone);
var $86d2f3987cc9d604$var$isoTimeExtensionRegex = RegExp("(?:T" + $86d2f3987cc9d604$var$isoTimeRegex.source + ")?");
var $86d2f3987cc9d604$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $86d2f3987cc9d604$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $86d2f3987cc9d604$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $86d2f3987cc9d604$var$extractISOWeekData = $86d2f3987cc9d604$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $86d2f3987cc9d604$var$extractISOOrdinalData = $86d2f3987cc9d604$var$simpleParse("year", "ordinal");
var $86d2f3987cc9d604$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $86d2f3987cc9d604$var$sqlTimeRegex = RegExp($86d2f3987cc9d604$var$isoTimeBaseRegex.source + " ?(?:" + $86d2f3987cc9d604$var$offsetRegex.source + "|(" + $86d2f3987cc9d604$var$ianaRegex.source + "))?");
var $86d2f3987cc9d604$var$sqlTimeExtensionRegex = RegExp("(?: " + $86d2f3987cc9d604$var$sqlTimeRegex.source + ")?");
function $86d2f3987cc9d604$var$int(match, pos, fallback) {
    var m = match[pos];
    return $86d2f3987cc9d604$var$isUndefined(m) ? fallback : $86d2f3987cc9d604$var$parseInteger(m);
}
function $86d2f3987cc9d604$var$extractISOYmd(match, cursor) {
    var item = {
        year: $86d2f3987cc9d604$var$int(match, cursor),
        month: $86d2f3987cc9d604$var$int(match, cursor + 1, 1),
        day: $86d2f3987cc9d604$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $86d2f3987cc9d604$var$extractISOTime(match, cursor) {
    var item = {
        hours: $86d2f3987cc9d604$var$int(match, cursor, 0),
        minutes: $86d2f3987cc9d604$var$int(match, cursor + 1, 0),
        seconds: $86d2f3987cc9d604$var$int(match, cursor + 2, 0),
        milliseconds: $86d2f3987cc9d604$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $86d2f3987cc9d604$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $86d2f3987cc9d604$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $86d2f3987cc9d604$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $86d2f3987cc9d604$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $86d2f3987cc9d604$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
} // ISO time parsing
var $86d2f3987cc9d604$var$isoTimeOnly = RegExp("^T?" + $86d2f3987cc9d604$var$isoTimeBaseRegex.source + "$"); // ISO duration parsing
var $86d2f3987cc9d604$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $86d2f3987cc9d604$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($86d2f3987cc9d604$var$parseFloating(yearStr)),
            months: maybeNegate($86d2f3987cc9d604$var$parseFloating(monthStr)),
            weeks: maybeNegate($86d2f3987cc9d604$var$parseFloating(weekStr)),
            days: maybeNegate($86d2f3987cc9d604$var$parseFloating(dayStr)),
            hours: maybeNegate($86d2f3987cc9d604$var$parseFloating(hourStr)),
            minutes: maybeNegate($86d2f3987cc9d604$var$parseFloating(minuteStr)),
            seconds: maybeNegate($86d2f3987cc9d604$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($86d2f3987cc9d604$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $86d2f3987cc9d604$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $86d2f3987cc9d604$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $86d2f3987cc9d604$var$untruncateYear($86d2f3987cc9d604$var$parseInteger(yearStr)) : $86d2f3987cc9d604$var$parseInteger(yearStr),
        month: $86d2f3987cc9d604$var$monthsShort.indexOf(monthStr) + 1,
        day: $86d2f3987cc9d604$var$parseInteger(dayStr),
        hour: $86d2f3987cc9d604$var$parseInteger(hourStr),
        minute: $86d2f3987cc9d604$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $86d2f3987cc9d604$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $86d2f3987cc9d604$var$weekdaysLong.indexOf(weekdayStr) + 1 : $86d2f3987cc9d604$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
} // RFC 2822/5322
var $86d2f3987cc9d604$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $86d2f3987cc9d604$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $86d2f3987cc9d604$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $86d2f3987cc9d604$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $86d2f3987cc9d604$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $86d2f3987cc9d604$var$FixedOffsetZone(offset)
    ];
}
function $86d2f3987cc9d604$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date
var $86d2f3987cc9d604$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $86d2f3987cc9d604$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $86d2f3987cc9d604$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $86d2f3987cc9d604$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $86d2f3987cc9d604$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $86d2f3987cc9d604$var$FixedOffsetZone.utcInstance
    ];
}
function $86d2f3987cc9d604$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $86d2f3987cc9d604$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $86d2f3987cc9d604$var$FixedOffsetZone.utcInstance
    ];
}
var $86d2f3987cc9d604$var$isoYmdWithTimeExtensionRegex = $86d2f3987cc9d604$var$combineRegexes($86d2f3987cc9d604$var$isoYmdRegex, $86d2f3987cc9d604$var$isoTimeExtensionRegex);
var $86d2f3987cc9d604$var$isoWeekWithTimeExtensionRegex = $86d2f3987cc9d604$var$combineRegexes($86d2f3987cc9d604$var$isoWeekRegex, $86d2f3987cc9d604$var$isoTimeExtensionRegex);
var $86d2f3987cc9d604$var$isoOrdinalWithTimeExtensionRegex = $86d2f3987cc9d604$var$combineRegexes($86d2f3987cc9d604$var$isoOrdinalRegex, $86d2f3987cc9d604$var$isoTimeExtensionRegex);
var $86d2f3987cc9d604$var$isoTimeCombinedRegex = $86d2f3987cc9d604$var$combineRegexes($86d2f3987cc9d604$var$isoTimeRegex);
var $86d2f3987cc9d604$var$extractISOYmdTimeAndOffset = $86d2f3987cc9d604$var$combineExtractors($86d2f3987cc9d604$var$extractISOYmd, $86d2f3987cc9d604$var$extractISOTime, $86d2f3987cc9d604$var$extractISOOffset, $86d2f3987cc9d604$var$extractIANAZone);
var $86d2f3987cc9d604$var$extractISOWeekTimeAndOffset = $86d2f3987cc9d604$var$combineExtractors($86d2f3987cc9d604$var$extractISOWeekData, $86d2f3987cc9d604$var$extractISOTime, $86d2f3987cc9d604$var$extractISOOffset, $86d2f3987cc9d604$var$extractIANAZone);
var $86d2f3987cc9d604$var$extractISOOrdinalDateAndTime = $86d2f3987cc9d604$var$combineExtractors($86d2f3987cc9d604$var$extractISOOrdinalData, $86d2f3987cc9d604$var$extractISOTime, $86d2f3987cc9d604$var$extractISOOffset, $86d2f3987cc9d604$var$extractIANAZone);
var $86d2f3987cc9d604$var$extractISOTimeAndOffset = $86d2f3987cc9d604$var$combineExtractors($86d2f3987cc9d604$var$extractISOTime, $86d2f3987cc9d604$var$extractISOOffset, $86d2f3987cc9d604$var$extractIANAZone);
/*
 * @private
 */ function $86d2f3987cc9d604$var$parseISODate(s) {
    return $86d2f3987cc9d604$var$parse(s, [
        $86d2f3987cc9d604$var$isoYmdWithTimeExtensionRegex,
        $86d2f3987cc9d604$var$extractISOYmdTimeAndOffset
    ], [
        $86d2f3987cc9d604$var$isoWeekWithTimeExtensionRegex,
        $86d2f3987cc9d604$var$extractISOWeekTimeAndOffset
    ], [
        $86d2f3987cc9d604$var$isoOrdinalWithTimeExtensionRegex,
        $86d2f3987cc9d604$var$extractISOOrdinalDateAndTime
    ], [
        $86d2f3987cc9d604$var$isoTimeCombinedRegex,
        $86d2f3987cc9d604$var$extractISOTimeAndOffset
    ]);
}
function $86d2f3987cc9d604$var$parseRFC2822Date(s) {
    return $86d2f3987cc9d604$var$parse($86d2f3987cc9d604$var$preprocessRFC2822(s), [
        $86d2f3987cc9d604$var$rfc2822,
        $86d2f3987cc9d604$var$extractRFC2822
    ]);
}
function $86d2f3987cc9d604$var$parseHTTPDate(s) {
    return $86d2f3987cc9d604$var$parse(s, [
        $86d2f3987cc9d604$var$rfc1123,
        $86d2f3987cc9d604$var$extractRFC1123Or850
    ], [
        $86d2f3987cc9d604$var$rfc850,
        $86d2f3987cc9d604$var$extractRFC1123Or850
    ], [
        $86d2f3987cc9d604$var$ascii,
        $86d2f3987cc9d604$var$extractASCII
    ]);
}
function $86d2f3987cc9d604$var$parseISODuration(s) {
    return $86d2f3987cc9d604$var$parse(s, [
        $86d2f3987cc9d604$var$isoDuration,
        $86d2f3987cc9d604$var$extractISODuration
    ]);
}
var $86d2f3987cc9d604$var$extractISOTimeOnly = $86d2f3987cc9d604$var$combineExtractors($86d2f3987cc9d604$var$extractISOTime);
function $86d2f3987cc9d604$var$parseISOTimeOnly(s) {
    return $86d2f3987cc9d604$var$parse(s, [
        $86d2f3987cc9d604$var$isoTimeOnly,
        $86d2f3987cc9d604$var$extractISOTimeOnly
    ]);
}
var $86d2f3987cc9d604$var$sqlYmdWithTimeExtensionRegex = $86d2f3987cc9d604$var$combineRegexes($86d2f3987cc9d604$var$sqlYmdRegex, $86d2f3987cc9d604$var$sqlTimeExtensionRegex);
var $86d2f3987cc9d604$var$sqlTimeCombinedRegex = $86d2f3987cc9d604$var$combineRegexes($86d2f3987cc9d604$var$sqlTimeRegex);
var $86d2f3987cc9d604$var$extractISOTimeOffsetAndIANAZone = $86d2f3987cc9d604$var$combineExtractors($86d2f3987cc9d604$var$extractISOTime, $86d2f3987cc9d604$var$extractISOOffset, $86d2f3987cc9d604$var$extractIANAZone);
function $86d2f3987cc9d604$var$parseSQL(s) {
    return $86d2f3987cc9d604$var$parse(s, [
        $86d2f3987cc9d604$var$sqlYmdWithTimeExtensionRegex,
        $86d2f3987cc9d604$var$extractISOYmdTimeAndOffset
    ], [
        $86d2f3987cc9d604$var$sqlTimeCombinedRegex,
        $86d2f3987cc9d604$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $86d2f3987cc9d604$var$INVALID$2 = "Invalid Duration"; // unit conversion constants
var $86d2f3987cc9d604$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $86d2f3987cc9d604$var$casualMatrix = $86d2f3987cc9d604$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $86d2f3987cc9d604$var$lowOrderMatrix), $86d2f3987cc9d604$var$daysInYearAccurate = 365.2425, $86d2f3987cc9d604$var$daysInMonthAccurate = 30.436875, $86d2f3987cc9d604$var$accurateMatrix = $86d2f3987cc9d604$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $86d2f3987cc9d604$var$daysInYearAccurate / 7,
        days: $86d2f3987cc9d604$var$daysInYearAccurate,
        hours: $86d2f3987cc9d604$var$daysInYearAccurate * 24,
        minutes: $86d2f3987cc9d604$var$daysInYearAccurate * 1440,
        seconds: $86d2f3987cc9d604$var$daysInYearAccurate * 86400,
        milliseconds: $86d2f3987cc9d604$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $86d2f3987cc9d604$var$daysInYearAccurate / 28,
        days: $86d2f3987cc9d604$var$daysInYearAccurate / 4,
        hours: $86d2f3987cc9d604$var$daysInYearAccurate * 24 / 4,
        minutes: $86d2f3987cc9d604$var$daysInYearAccurate * 1440 / 4,
        seconds: $86d2f3987cc9d604$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $86d2f3987cc9d604$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $86d2f3987cc9d604$var$daysInMonthAccurate / 7,
        days: $86d2f3987cc9d604$var$daysInMonthAccurate,
        hours: $86d2f3987cc9d604$var$daysInMonthAccurate * 24,
        minutes: $86d2f3987cc9d604$var$daysInMonthAccurate * 1440,
        seconds: $86d2f3987cc9d604$var$daysInMonthAccurate * 86400,
        milliseconds: $86d2f3987cc9d604$var$daysInMonthAccurate * 86400000
    }
}, $86d2f3987cc9d604$var$lowOrderMatrix); // units ordered by size
var $86d2f3987cc9d604$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $86d2f3987cc9d604$var$reverseUnits = $86d2f3987cc9d604$var$orderedUnits$1.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
function $86d2f3987cc9d604$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $86d2f3987cc9d604$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
    };
    return new $86d2f3987cc9d604$var$Duration(conf);
}
function $86d2f3987cc9d604$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters
function $86d2f3987cc9d604$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $86d2f3987cc9d604$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters
function $86d2f3987cc9d604$var$normalizeValues(matrix, vals) {
    $86d2f3987cc9d604$var$reverseUnits.reduce(function(previous, current) {
        if (!$86d2f3987cc9d604$var$isUndefined(vals[current])) {
            if (previous) $86d2f3987cc9d604$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration#fromMillis}, {@link Duration#fromObject}, or {@link Duration#fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $86d2f3987cc9d604$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $86d2f3987cc9d604$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = accurate ? $86d2f3987cc9d604$var$accurateMatrix : $86d2f3987cc9d604$var$casualMatrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $86d2f3987cc9d604$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $86d2f3987cc9d604$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $86d2f3987cc9d604$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($86d2f3987cc9d604$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $86d2f3987cc9d604$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $86d2f3987cc9d604$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $86d2f3987cc9d604$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $86d2f3987cc9d604$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $86d2f3987cc9d604$var$Invalid ? reason : new $86d2f3987cc9d604$var$Invalid(reason, explanation);
        if ($86d2f3987cc9d604$var$Settings.throwOnInvalid) throw new $86d2f3987cc9d604$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $86d2f3987cc9d604$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $86d2f3987cc9d604$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $86d2f3987cc9d604$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $86d2f3987cc9d604$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        var l = $86d2f3987cc9d604$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($86d2f3987cc9d604$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($86d2f3987cc9d604$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($86d2f3987cc9d604$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $86d2f3987cc9d604$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $86d2f3987cc9d604$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $86d2f3987cc9d604$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _iterator = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose($86d2f3987cc9d604$var$orderedUnits$1), _step; !(_step = _iterator()).done;){
            var k = _step.value;
            if ($86d2f3987cc9d604$var$hasOwnProperty(dur.values, k) || $86d2f3987cc9d604$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $86d2f3987cc9d604$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++){
            var k = _Object$keys[_i];
            result[k] = $86d2f3987cc9d604$var$asNumber(fn(this.values[k], k));
        }
        return $86d2f3987cc9d604$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $86d2f3987cc9d604$var$_extends({}, this.values, $86d2f3987cc9d604$var$normalizeObject(values, Duration.normalizeUnit));
        return $86d2f3987cc9d604$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        }), opts = {
            loc: loc
        };
        if (conversionAccuracy) opts.conversionAccuracy = conversionAccuracy;
        return $86d2f3987cc9d604$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $86d2f3987cc9d604$var$normalizeValues(this.matrix, vals);
        return $86d2f3987cc9d604$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _iterator2 = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose($86d2f3987cc9d604$var$orderedUnits$1), _step2; !(_step2 = _iterator2()).done;){
            var k = _step2.value;
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0; // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                } // plus anything that's already in this unit
                if ($86d2f3987cc9d604$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000; // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($86d2f3987cc9d604$var$orderedUnits$1.indexOf(down) > $86d2f3987cc9d604$var$orderedUnits$1.indexOf(k)) $86d2f3987cc9d604$var$convert(this.matrix, vals, down, built, k);
                 // otherwise, keep it in the wings to boil it later
            } else if ($86d2f3987cc9d604$var$isNumber(vals[k])) accumulated[k] = vals[k];
        } // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $86d2f3987cc9d604$var$clone$1(this, {
            values: built
        }, true).normalize();
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++){
            var k = _Object$keys2[_i2];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $86d2f3987cc9d604$var$clone$1(this, {
            values: negated
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _iterator3 = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose($86d2f3987cc9d604$var$orderedUnits$1), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $86d2f3987cc9d604$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $86d2f3987cc9d604$var$INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
function $86d2f3987cc9d604$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $86d2f3987cc9d604$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $86d2f3987cc9d604$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $86d2f3987cc9d604$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval#fromDateTimes}, {@link Interval#after}, {@link Interval#before}, or {@link Interval#fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval#merge}, {@link Interval#xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $86d2f3987cc9d604$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $86d2f3987cc9d604$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $86d2f3987cc9d604$var$Invalid ? reason : new $86d2f3987cc9d604$var$Invalid(reason, explanation);
        if ($86d2f3987cc9d604$var$Settings.throwOnInvalid) throw new $86d2f3987cc9d604$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $86d2f3987cc9d604$var$friendlyDateTime(start), builtEnd = $86d2f3987cc9d604$var$friendlyDateTime(end);
        var validateError = $86d2f3987cc9d604$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $86d2f3987cc9d604$var$Duration.fromDurationLike(duration), dt = $86d2f3987cc9d604$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $86d2f3987cc9d604$var$Duration.fromDurationLike(duration), dt = $86d2f3987cc9d604$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $86d2f3987cc9d604$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $86d2f3987cc9d604$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $86d2f3987cc9d604$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $86d2f3987cc9d604$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + 1;
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($86d2f3987cc9d604$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $86d2f3987cc9d604$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $86d2f3987cc9d604$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $86d2f3987cc9d604$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $86d2f3987cc9d604$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $86d2f3987cc9d604$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $86d2f3987cc9d604$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $86d2f3987cc9d604$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $86d2f3987cc9d604$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $86d2f3987cc9d604$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $86d2f3987cc9d604$var$Settings.defaultZone;
        var proto = $86d2f3987cc9d604$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $86d2f3987cc9d604$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $86d2f3987cc9d604$var$normalizeZone(input, $86d2f3987cc9d604$var$Settings.defaultZone);
    };
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $86d2f3987cc9d604$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $86d2f3987cc9d604$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $86d2f3987cc9d604$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $86d2f3987cc9d604$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $86d2f3987cc9d604$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $86d2f3987cc9d604$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $86d2f3987cc9d604$var$hasRelative()
        };
    };
    return Info;
}();
function $86d2f3987cc9d604$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($86d2f3987cc9d604$var$Duration.fromMillis(ms).as("days"));
}
function $86d2f3987cc9d604$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $86d2f3987cc9d604$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $86d2f3987cc9d604$var$dayDiff
        ]
    ];
    var results = {};
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            var _cursor$plus;
            lowestOrder = unit;
            var delta = differ(cursor, later);
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
            if (highWater > later) {
                var _cursor$plus2;
                cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
                delta -= 1;
            } else cursor = highWater;
            results[unit] = delta;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $86d2f3987cc9d604$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $86d2f3987cc9d604$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus3;
            highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $86d2f3987cc9d604$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $86d2f3987cc9d604$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $86d2f3987cc9d604$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $86d2f3987cc9d604$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $86d2f3987cc9d604$var$hanidecChars = $86d2f3987cc9d604$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $86d2f3987cc9d604$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($86d2f3987cc9d604$var$numberingSystems.hanidec) !== -1) value += $86d2f3987cc9d604$var$hanidecChars.indexOf(str[i]);
            else for(var key in $86d2f3987cc9d604$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $86d2f3987cc9d604$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $86d2f3987cc9d604$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $86d2f3987cc9d604$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $86d2f3987cc9d604$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $86d2f3987cc9d604$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($86d2f3987cc9d604$var$parseDigits(s));
        }
    };
}
var $86d2f3987cc9d604$var$NBSP = String.fromCharCode(160);
var $86d2f3987cc9d604$var$spaceOrNBSP = "[ " + $86d2f3987cc9d604$var$NBSP + "]";
var $86d2f3987cc9d604$var$spaceOrNBSPRegExp = new RegExp($86d2f3987cc9d604$var$spaceOrNBSP, "g");
function $86d2f3987cc9d604$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($86d2f3987cc9d604$var$spaceOrNBSPRegExp, $86d2f3987cc9d604$var$spaceOrNBSP);
}
function $86d2f3987cc9d604$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($86d2f3987cc9d604$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $86d2f3987cc9d604$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($86d2f3987cc9d604$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $86d2f3987cc9d604$var$stripInsensitivities(s) === $86d2f3987cc9d604$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $86d2f3987cc9d604$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $86d2f3987cc9d604$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $86d2f3987cc9d604$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $86d2f3987cc9d604$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $86d2f3987cc9d604$var$unitForToken(token, loc) {
    var one = $86d2f3987cc9d604$var$digitRegex(loc), two = $86d2f3987cc9d604$var$digitRegex(loc, "{2}"), three = $86d2f3987cc9d604$var$digitRegex(loc, "{3}"), four = $86d2f3987cc9d604$var$digitRegex(loc, "{4}"), six = $86d2f3987cc9d604$var$digitRegex(loc, "{6}"), oneOrTwo = $86d2f3987cc9d604$var$digitRegex(loc, "{1,2}"), oneToThree = $86d2f3987cc9d604$var$digitRegex(loc, "{1,3}"), oneToSix = $86d2f3987cc9d604$var$digitRegex(loc, "{1,6}"), oneToNine = $86d2f3987cc9d604$var$digitRegex(loc, "{1,9}"), twoToFour = $86d2f3987cc9d604$var$digitRegex(loc, "{2,4}"), fourToSix = $86d2f3987cc9d604$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($86d2f3987cc9d604$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $86d2f3987cc9d604$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $86d2f3987cc9d604$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $86d2f3987cc9d604$var$intUnit(oneToSix);
            case "yy":
                return $86d2f3987cc9d604$var$intUnit(twoToFour, $86d2f3987cc9d604$var$untruncateYear);
            case "yyyy":
                return $86d2f3987cc9d604$var$intUnit(four);
            case "yyyyy":
                return $86d2f3987cc9d604$var$intUnit(fourToSix);
            case "yyyyyy":
                return $86d2f3987cc9d604$var$intUnit(six);
            // months
            case "M":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "MM":
                return $86d2f3987cc9d604$var$intUnit(two);
            case "MMM":
                return $86d2f3987cc9d604$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $86d2f3987cc9d604$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "LL":
                return $86d2f3987cc9d604$var$intUnit(two);
            case "LLL":
                return $86d2f3987cc9d604$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $86d2f3987cc9d604$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "dd":
                return $86d2f3987cc9d604$var$intUnit(two);
            // ordinals
            case "o":
                return $86d2f3987cc9d604$var$intUnit(oneToThree);
            case "ooo":
                return $86d2f3987cc9d604$var$intUnit(three);
            // time
            case "HH":
                return $86d2f3987cc9d604$var$intUnit(two);
            case "H":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "hh":
                return $86d2f3987cc9d604$var$intUnit(two);
            case "h":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "mm":
                return $86d2f3987cc9d604$var$intUnit(two);
            case "m":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "q":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "qq":
                return $86d2f3987cc9d604$var$intUnit(two);
            case "s":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "ss":
                return $86d2f3987cc9d604$var$intUnit(two);
            case "S":
                return $86d2f3987cc9d604$var$intUnit(oneToThree);
            case "SSS":
                return $86d2f3987cc9d604$var$intUnit(three);
            case "u":
                return $86d2f3987cc9d604$var$simple(oneToNine);
            case "uu":
                return $86d2f3987cc9d604$var$simple(oneOrTwo);
            case "uuu":
                return $86d2f3987cc9d604$var$intUnit(one);
            // meridiem
            case "a":
                return $86d2f3987cc9d604$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $86d2f3987cc9d604$var$intUnit(four);
            case "kk":
                return $86d2f3987cc9d604$var$intUnit(twoToFour, $86d2f3987cc9d604$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $86d2f3987cc9d604$var$intUnit(oneOrTwo);
            case "WW":
                return $86d2f3987cc9d604$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $86d2f3987cc9d604$var$intUnit(one);
            case "EEE":
                return $86d2f3987cc9d604$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $86d2f3987cc9d604$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $86d2f3987cc9d604$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $86d2f3987cc9d604$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $86d2f3987cc9d604$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $86d2f3987cc9d604$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $86d2f3987cc9d604$var$simple(/[a-z_+-/]{1,256}?/i);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $86d2f3987cc9d604$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $86d2f3987cc9d604$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    }
};
function $86d2f3987cc9d604$var$tokenForPart(part, locale, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") return {
        literal: true,
        val: value
    };
    var style = formatOpts[type];
    var val = $86d2f3987cc9d604$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $86d2f3987cc9d604$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $86d2f3987cc9d604$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($86d2f3987cc9d604$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $86d2f3987cc9d604$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$86d2f3987cc9d604$var$isUndefined(matches.z)) zone = $86d2f3987cc9d604$var$IANAZone.create(matches.z);
    if (!$86d2f3987cc9d604$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $86d2f3987cc9d604$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$86d2f3987cc9d604$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$86d2f3987cc9d604$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$86d2f3987cc9d604$var$isUndefined(matches.u)) matches.S = $86d2f3987cc9d604$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $86d2f3987cc9d604$var$dummyDateTimeCache = null;
function $86d2f3987cc9d604$var$getDummyDateTime() {
    if (!$86d2f3987cc9d604$var$dummyDateTimeCache) $86d2f3987cc9d604$var$dummyDateTimeCache = $86d2f3987cc9d604$var$DateTime.fromMillis(1555555555555);
    return $86d2f3987cc9d604$var$dummyDateTimeCache;
}
function $86d2f3987cc9d604$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $86d2f3987cc9d604$var$Formatter.macroTokenToFormatOpts(token.val);
    if (!formatOpts) return token;
    var formatter = $86d2f3987cc9d604$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($86d2f3987cc9d604$var$getDummyDateTime());
    var tokens = parts.map(function(p) {
        return $86d2f3987cc9d604$var$tokenForPart(p, locale, formatOpts);
    });
    if (tokens.includes(undefined)) return token;
    return tokens;
}
function $86d2f3987cc9d604$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $86d2f3987cc9d604$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $86d2f3987cc9d604$var$explainFromTokens(locale, input, format) {
    var tokens = $86d2f3987cc9d604$var$expandMacroTokens($86d2f3987cc9d604$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $86d2f3987cc9d604$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $86d2f3987cc9d604$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $86d2f3987cc9d604$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $86d2f3987cc9d604$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($86d2f3987cc9d604$var$hasOwnProperty(matches, "a") && $86d2f3987cc9d604$var$hasOwnProperty(matches, "H")) throw new $86d2f3987cc9d604$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $86d2f3987cc9d604$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $86d2f3987cc9d604$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
var $86d2f3987cc9d604$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $86d2f3987cc9d604$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $86d2f3987cc9d604$var$unitOutOfRange(unit, value) {
    return new $86d2f3987cc9d604$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $86d2f3987cc9d604$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $86d2f3987cc9d604$var$computeOrdinal(year, month, day) {
    return day + ($86d2f3987cc9d604$var$isLeapYear(year) ? $86d2f3987cc9d604$var$leapLadder : $86d2f3987cc9d604$var$nonLeapLadder)[month - 1];
}
function $86d2f3987cc9d604$var$uncomputeOrdinal(year, ordinal) {
    var table = $86d2f3987cc9d604$var$isLeapYear(year) ? $86d2f3987cc9d604$var$leapLadder : $86d2f3987cc9d604$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $86d2f3987cc9d604$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $86d2f3987cc9d604$var$computeOrdinal(year, month, day), weekday = $86d2f3987cc9d604$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $86d2f3987cc9d604$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $86d2f3987cc9d604$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $86d2f3987cc9d604$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $86d2f3987cc9d604$var$timeObject(gregObj));
}
function $86d2f3987cc9d604$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $86d2f3987cc9d604$var$dayOfWeek(weekYear, 1, 4), yearInDays = $86d2f3987cc9d604$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $86d2f3987cc9d604$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $86d2f3987cc9d604$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $86d2f3987cc9d604$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $86d2f3987cc9d604$var$_extends({
        year: year,
        month: month,
        day: day
    }, $86d2f3987cc9d604$var$timeObject(weekData));
}
function $86d2f3987cc9d604$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $86d2f3987cc9d604$var$computeOrdinal(year, month, day);
    return $86d2f3987cc9d604$var$_extends({
        year: year,
        ordinal: ordinal
    }, $86d2f3987cc9d604$var$timeObject(gregData));
}
function $86d2f3987cc9d604$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $86d2f3987cc9d604$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $86d2f3987cc9d604$var$_extends({
        year: year,
        month: month,
        day: day
    }, $86d2f3987cc9d604$var$timeObject(ordinalData));
}
function $86d2f3987cc9d604$var$hasInvalidWeekData(obj) {
    var validYear = $86d2f3987cc9d604$var$isInteger(obj.weekYear), validWeek = $86d2f3987cc9d604$var$integerBetween(obj.weekNumber, 1, $86d2f3987cc9d604$var$weeksInWeekYear(obj.weekYear)), validWeekday = $86d2f3987cc9d604$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $86d2f3987cc9d604$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $86d2f3987cc9d604$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $86d2f3987cc9d604$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $86d2f3987cc9d604$var$hasInvalidOrdinalData(obj) {
    var validYear = $86d2f3987cc9d604$var$isInteger(obj.year), validOrdinal = $86d2f3987cc9d604$var$integerBetween(obj.ordinal, 1, $86d2f3987cc9d604$var$daysInYear(obj.year));
    if (!validYear) return $86d2f3987cc9d604$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $86d2f3987cc9d604$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $86d2f3987cc9d604$var$hasInvalidGregorianData(obj) {
    var validYear = $86d2f3987cc9d604$var$isInteger(obj.year), validMonth = $86d2f3987cc9d604$var$integerBetween(obj.month, 1, 12), validDay = $86d2f3987cc9d604$var$integerBetween(obj.day, 1, $86d2f3987cc9d604$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $86d2f3987cc9d604$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $86d2f3987cc9d604$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $86d2f3987cc9d604$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $86d2f3987cc9d604$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $86d2f3987cc9d604$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $86d2f3987cc9d604$var$integerBetween(minute, 0, 59), validSecond = $86d2f3987cc9d604$var$integerBetween(second, 0, 59), validMillisecond = $86d2f3987cc9d604$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $86d2f3987cc9d604$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $86d2f3987cc9d604$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $86d2f3987cc9d604$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $86d2f3987cc9d604$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $86d2f3987cc9d604$var$INVALID = "Invalid DateTime";
var $86d2f3987cc9d604$var$MAX_DATE = 8.64e15;
function $86d2f3987cc9d604$var$unsupportedZone(zone) {
    return new $86d2f3987cc9d604$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
} // we cache week data on the DT object and this intermediates the cache
function $86d2f3987cc9d604$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $86d2f3987cc9d604$var$gregorianToWeek(dt.c);
    return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $86d2f3987cc9d604$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $86d2f3987cc9d604$var$DateTime($86d2f3987cc9d604$var$_extends({}, current, alts, {
        old: current
    }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $86d2f3987cc9d604$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000; // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
     // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000; // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
     // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
} // convert an epoch timestamp into a calendar object with the given offset
function $86d2f3987cc9d604$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
} // convert a calendar object to a epoch timestamp
function $86d2f3987cc9d604$var$objToTS(obj, offset, zone) {
    return $86d2f3987cc9d604$var$fixOffset($86d2f3987cc9d604$var$objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs
function $86d2f3987cc9d604$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $86d2f3987cc9d604$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $86d2f3987cc9d604$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $86d2f3987cc9d604$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $86d2f3987cc9d604$var$objToLocalTS(c);
    var _fixOffset = $86d2f3987cc9d604$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options
function $86d2f3987cc9d604$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0) {
        var interpretationZone = parsedZone || zone, inst = $86d2f3987cc9d604$var$DateTime.fromObject(parsed, $86d2f3987cc9d604$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $86d2f3987cc9d604$var$DateTime.invalid(new $86d2f3987cc9d604$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $86d2f3987cc9d604$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $86d2f3987cc9d604$var$Formatter.create($86d2f3987cc9d604$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $86d2f3987cc9d604$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $86d2f3987cc9d604$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $86d2f3987cc9d604$var$padStart(o.c.month);
        c += "-";
        c += $86d2f3987cc9d604$var$padStart(o.c.day);
    } else {
        c += $86d2f3987cc9d604$var$padStart(o.c.month);
        c += $86d2f3987cc9d604$var$padStart(o.c.day);
    }
    return c;
}
function $86d2f3987cc9d604$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $86d2f3987cc9d604$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $86d2f3987cc9d604$var$padStart(o.c.minute);
        if (o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $86d2f3987cc9d604$var$padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
        c += $86d2f3987cc9d604$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $86d2f3987cc9d604$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $86d2f3987cc9d604$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $86d2f3987cc9d604$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $86d2f3987cc9d604$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $86d2f3987cc9d604$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
} // defaults for unspecified units in the supported calendars
var $86d2f3987cc9d604$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $86d2f3987cc9d604$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $86d2f3987cc9d604$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}; // Units in the supported calendars, sorted by bigness
var $86d2f3987cc9d604$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $86d2f3987cc9d604$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $86d2f3987cc9d604$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
]; // standardize case and plurality in units
function $86d2f3987cc9d604$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $86d2f3987cc9d604$var$InvalidUnitError(unit);
    return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $86d2f3987cc9d604$var$quickDT(obj, opts) {
    var zone = $86d2f3987cc9d604$var$normalizeZone(opts.zone, $86d2f3987cc9d604$var$Settings.defaultZone), loc = $86d2f3987cc9d604$var$Locale.fromObject(opts), tsNow = $86d2f3987cc9d604$var$Settings.now();
    var ts, o; // assume we have the higher-order units
    if (!$86d2f3987cc9d604$var$isUndefined(obj.year)) {
        for(var _iterator = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose($86d2f3987cc9d604$var$orderedUnits), _step; !(_step = _iterator()).done;){
            var u = _step.value;
            if ($86d2f3987cc9d604$var$isUndefined(obj[u])) obj[u] = $86d2f3987cc9d604$var$defaultUnitValues[u];
        }
        var invalid = $86d2f3987cc9d604$var$hasInvalidGregorianData(obj) || $86d2f3987cc9d604$var$hasInvalidTimeData(obj);
        if (invalid) return $86d2f3987cc9d604$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $86d2f3987cc9d604$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $86d2f3987cc9d604$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $86d2f3987cc9d604$var$diffRelative(start, end, opts) {
    var round = $86d2f3987cc9d604$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $86d2f3987cc9d604$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator2 = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;){
        var unit = _step2.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $86d2f3987cc9d604$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime#local}, {@link DateTime#utc}, and (most flexibly) {@link DateTime#fromObject}. To create one from a standard string format, use {@link DateTime#fromISO}, {@link DateTime#fromHTTP}, and {@link DateTime#fromRFC2822}. To create one from a custom string format, use {@link DateTime#fromFormat}. To create one from a native JS date, use {@link DateTime#fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $86d2f3987cc9d604$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $86d2f3987cc9d604$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $86d2f3987cc9d604$var$Invalid("invalid input") : null) || (!zone.isValid ? $86d2f3987cc9d604$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $86d2f3987cc9d604$var$isUndefined(config.ts) ? $86d2f3987cc9d604$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $86d2f3987cc9d604$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $86d2f3987cc9d604$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $86d2f3987cc9d604$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    } // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $86d2f3987cc9d604$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $86d2f3987cc9d604$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $86d2f3987cc9d604$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $86d2f3987cc9d604$var$FixedOffsetZone.utcInstance;
        return $86d2f3987cc9d604$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $86d2f3987cc9d604$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $86d2f3987cc9d604$var$normalizeZone(options.zone, $86d2f3987cc9d604$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($86d2f3987cc9d604$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $86d2f3987cc9d604$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$86d2f3987cc9d604$var$isNumber(milliseconds)) throw new $86d2f3987cc9d604$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$86d2f3987cc9d604$var$MAX_DATE || milliseconds > $86d2f3987cc9d604$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $86d2f3987cc9d604$var$normalizeZone(options.zone, $86d2f3987cc9d604$var$Settings.defaultZone),
            loc: $86d2f3987cc9d604$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$86d2f3987cc9d604$var$isNumber(seconds)) throw new $86d2f3987cc9d604$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $86d2f3987cc9d604$var$normalizeZone(options.zone, $86d2f3987cc9d604$var$Settings.defaultZone),
            loc: $86d2f3987cc9d604$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $86d2f3987cc9d604$var$normalizeZone(opts.zone, $86d2f3987cc9d604$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($86d2f3987cc9d604$var$unsupportedZone(zoneToUse));
        var tsNow = $86d2f3987cc9d604$var$Settings.now(), offsetProvis = !$86d2f3987cc9d604$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $86d2f3987cc9d604$var$normalizeObject(obj, $86d2f3987cc9d604$var$normalizeUnit), containsOrdinal = !$86d2f3987cc9d604$var$isUndefined(normalized.ordinal), containsGregorYear = !$86d2f3987cc9d604$var$isUndefined(normalized.year), containsGregorMD = !$86d2f3987cc9d604$var$isUndefined(normalized.month) || !$86d2f3987cc9d604$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $86d2f3987cc9d604$var$Locale.fromObject(opts); // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $86d2f3987cc9d604$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $86d2f3987cc9d604$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $86d2f3987cc9d604$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $86d2f3987cc9d604$var$orderedWeekUnits;
            defaultValues = $86d2f3987cc9d604$var$defaultWeekUnitValues;
            objNow = $86d2f3987cc9d604$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $86d2f3987cc9d604$var$orderedOrdinalUnits;
            defaultValues = $86d2f3987cc9d604$var$defaultOrdinalUnitValues;
            objNow = $86d2f3987cc9d604$var$gregorianToOrdinal(objNow);
        } else {
            units = $86d2f3987cc9d604$var$orderedUnits;
            defaultValues = $86d2f3987cc9d604$var$defaultUnitValues;
        } // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator3 = $86d2f3987cc9d604$var$_createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            var v = normalized[u];
            if (!$86d2f3987cc9d604$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        } // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $86d2f3987cc9d604$var$hasInvalidWeekData(normalized) : containsOrdinal ? $86d2f3987cc9d604$var$hasInvalidOrdinalData(normalized) : $86d2f3987cc9d604$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $86d2f3987cc9d604$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
         // compute the actual time
        var gregorian = useWeekData ? $86d2f3987cc9d604$var$weekToGregorian(normalized) : containsOrdinal ? $86d2f3987cc9d604$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $86d2f3987cc9d604$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        }); // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $86d2f3987cc9d604$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $86d2f3987cc9d604$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $86d2f3987cc9d604$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $86d2f3987cc9d604$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $86d2f3987cc9d604$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $86d2f3987cc9d604$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($86d2f3987cc9d604$var$isUndefined(text) || $86d2f3987cc9d604$var$isUndefined(fmt)) throw new $86d2f3987cc9d604$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $86d2f3987cc9d604$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $86d2f3987cc9d604$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $86d2f3987cc9d604$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $86d2f3987cc9d604$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $86d2f3987cc9d604$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $86d2f3987cc9d604$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $86d2f3987cc9d604$var$Invalid ? reason : new $86d2f3987cc9d604$var$Invalid(reason, explanation);
        if ($86d2f3987cc9d604$var$Settings.throwOnInvalid) throw new $86d2f3987cc9d604$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } // INFO
    ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $86d2f3987cc9d604$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } // TRANSFORM
    ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($86d2f3987cc9d604$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($86d2f3987cc9d604$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $86d2f3987cc9d604$var$normalizeZone(zone, $86d2f3987cc9d604$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($86d2f3987cc9d604$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $86d2f3987cc9d604$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $86d2f3987cc9d604$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $86d2f3987cc9d604$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $86d2f3987cc9d604$var$normalizeObject(values, $86d2f3987cc9d604$var$normalizeUnit), settingWeekStuff = !$86d2f3987cc9d604$var$isUndefined(normalized.weekYear) || !$86d2f3987cc9d604$var$isUndefined(normalized.weekNumber) || !$86d2f3987cc9d604$var$isUndefined(normalized.weekday), containsOrdinal = !$86d2f3987cc9d604$var$isUndefined(normalized.ordinal), containsGregorYear = !$86d2f3987cc9d604$var$isUndefined(normalized.year), containsGregorMD = !$86d2f3987cc9d604$var$isUndefined(normalized.month) || !$86d2f3987cc9d604$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $86d2f3987cc9d604$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $86d2f3987cc9d604$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $86d2f3987cc9d604$var$weekToGregorian($86d2f3987cc9d604$var$_extends({}, $86d2f3987cc9d604$var$gregorianToWeek(this.c), normalized));
        else if (!$86d2f3987cc9d604$var$isUndefined(normalized.ordinal)) mixed = $86d2f3987cc9d604$var$ordinalToGregorian($86d2f3987cc9d604$var$_extends({}, $86d2f3987cc9d604$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $86d2f3987cc9d604$var$_extends({}, this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($86d2f3987cc9d604$var$isUndefined(normalized.day)) mixed.day = Math.min($86d2f3987cc9d604$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $86d2f3987cc9d604$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $86d2f3987cc9d604$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $86d2f3987cc9d604$var$Duration.fromDurationLike(duration);
        return $86d2f3987cc9d604$var$clone(this, $86d2f3987cc9d604$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $86d2f3987cc9d604$var$Duration.fromDurationLike(duration).negate();
        return $86d2f3987cc9d604$var$clone(this, $86d2f3987cc9d604$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $86d2f3987cc9d604$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } // OUTPUT
    ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $86d2f3987cc9d604$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $86d2f3987cc9d604$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $86d2f3987cc9d604$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $86d2f3987cc9d604$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $86d2f3987cc9d604$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $86d2f3987cc9d604$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset, _ref4$extendedZone = _ref4.extendedZone, extendedZone = _ref4$extendedZone === void 0 ? false : _ref4$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $86d2f3987cc9d604$var$_toISODate(this, ext);
        c += "T";
        c += $86d2f3987cc9d604$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    };
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $86d2f3987cc9d604$var$_toISODate(this, format === "extended");
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $86d2f3987cc9d604$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$extendedZone = _ref6.extendedZone, extendedZone = _ref6$extendedZone === void 0 ? false : _ref6$extendedZone, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $86d2f3987cc9d604$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $86d2f3987cc9d604$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $86d2f3987cc9d604$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $86d2f3987cc9d604$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $86d2f3987cc9d604$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $86d2f3987cc9d604$var$INVALID;
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $86d2f3987cc9d604$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } // COMPARE
    ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $86d2f3987cc9d604$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $86d2f3987cc9d604$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $86d2f3987cc9d604$var$maybeArray(unit).map($86d2f3987cc9d604$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $86d2f3987cc9d604$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $86d2f3987cc9d604$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $86d2f3987cc9d604$var$diffRelative(base, this.plus(padding), $86d2f3987cc9d604$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $86d2f3987cc9d604$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $86d2f3987cc9d604$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $86d2f3987cc9d604$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $86d2f3987cc9d604$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $86d2f3987cc9d604$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $86d2f3987cc9d604$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } // MISC
    ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $86d2f3987cc9d604$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $86d2f3987cc9d604$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } // FORMAT PRESETS
    ;
    $86d2f3987cc9d604$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $86d2f3987cc9d604$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $86d2f3987cc9d604$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $86d2f3987cc9d604$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $86d2f3987cc9d604$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $86d2f3987cc9d604$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $86d2f3987cc9d604$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $86d2f3987cc9d604$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $86d2f3987cc9d604$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $86d2f3987cc9d604$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $86d2f3987cc9d604$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $86d2f3987cc9d604$var$friendlyDateTime(dateTimeish) {
    if ($86d2f3987cc9d604$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $86d2f3987cc9d604$var$isNumber(dateTimeish.valueOf())) return $86d2f3987cc9d604$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $86d2f3987cc9d604$var$DateTime.fromObject(dateTimeish);
    else throw new $86d2f3987cc9d604$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $86d2f3987cc9d604$var$VERSION = "2.5.2";
$86d2f3987cc9d604$exports.DateTime = $86d2f3987cc9d604$var$DateTime;
$86d2f3987cc9d604$exports.Duration = $86d2f3987cc9d604$var$Duration;
$86d2f3987cc9d604$exports.FixedOffsetZone = $86d2f3987cc9d604$var$FixedOffsetZone;
$86d2f3987cc9d604$exports.IANAZone = $86d2f3987cc9d604$var$IANAZone;
$86d2f3987cc9d604$exports.Info = $86d2f3987cc9d604$var$Info;
$86d2f3987cc9d604$exports.Interval = $86d2f3987cc9d604$var$Interval;
$86d2f3987cc9d604$exports.InvalidZone = $86d2f3987cc9d604$var$InvalidZone;
$86d2f3987cc9d604$exports.Settings = $86d2f3987cc9d604$var$Settings;
$86d2f3987cc9d604$exports.SystemZone = $86d2f3987cc9d604$var$SystemZone;
$86d2f3987cc9d604$exports.VERSION = $86d2f3987cc9d604$var$VERSION;
$86d2f3987cc9d604$exports.Zone = $86d2f3987cc9d604$var$Zone;



var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





const $f5879f76b7a709cc$export$4d0a7f76ad443516 = `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`;
const $f5879f76b7a709cc$export$81d8b526340b2d71 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme30).attrs({
    as: "div"
})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props)=>props.$margin && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      margin: ${props.$margin}px 0;
    `}
`;
/**
 * Typically used to wrap StyledCenteredEmptyState for cards that contain graphs.
 */ const $f5879f76b7a709cc$export$757b1a5dfccb9b1d = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 60px;
`;
const $f5879f76b7a709cc$export$68f1b3e785b3c668 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  margin-top: 16px;
  justify-content: flex-end;
  width: 100%;
`;
const $f5879f76b7a709cc$export$d407bf5e3affaa77 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $f5879f76b7a709cc$export$fefc80bbaaa2e887 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  margin-top: 16px;
  justify-content: flex-end;
  width: 100%;
`;
const $f5879f76b7a709cc$export$63d0ed8ace03c0a7 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  height: 168px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.03);
`;
const $f5879f76b7a709cc$export$54c2e3dc7acea9f5 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  &:not(:last-child) {
    margin-right: 16px;
  }
`;
const $f5879f76b7a709cc$export$a7b06bfba60a8a78 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  display: flex;
  justify-content: space-between;
  width: 100%;

  &:not(:first-child) {
    padding-top: 16px;
  }

  &:not(:last-child) {
    border-bottom: ${$f5879f76b7a709cc$export$4d0a7f76ad443516};
    padding-bottom: 16px;
  }
`;
const $f5879f76b7a709cc$export$f734cfedcd7bed10 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${({ color: color })=>color};
`;
const $f5879f76b7a709cc$export$fece441740db2f20 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  overflow: hidden;
  text-overflow: ellipsis;
  // 97% global support
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
const $f5879f76b7a709cc$export$e3829a99457e34ea = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  overflow: hidden;
  text-overflow: ellipsis;
  // 97% global support
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;


const $5a2e8494737d1c0e$var$TWO_LINE_CONTENT_HEIGHT = 108;
const $5a2e8494737d1c0e$var$THREE_LINE_CONTENT_HEIGHT = 148;
const $5a2e8494737d1c0e$var$TWO_LINE_HEIGHT = 42;
const $5a2e8494737d1c0e$var$THREE_LINE_HEIGHT = 63;
const $5a2e8494737d1c0e$var$StyledDocumentCardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(props)=>{
    if (props.$titleTextLines === 3) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        height: ${$5a2e8494737d1c0e$var$THREE_LINE_CONTENT_HEIGHT}px;
      `;
    else if (props.$titleTextLines === 2) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        height: ${$5a2e8494737d1c0e$var$TWO_LINE_CONTENT_HEIGHT}px;
      `;
}}
  padding: 0 16px;

  > :first-child {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  > :last-child {
    flex-shrink: 0;
    justify-self: flex-end;
  }
`;
const $5a2e8494737d1c0e$var$DocumentCard = ({ document: document, titleTextLines: titleTextLines, onClick: onClick })=>{
    const cardRef = (0, $70fFQ.useRef)(null);
    const [textRef, current] = (0, $4e12efec6f3d63a0$export$2e2bcd8739ae039)();
    const TextComponent = titleTextLines === 2 ? (0, $f5879f76b7a709cc$export$fece441740db2f20) : (0, $f5879f76b7a709cc$export$e3829a99457e34ea);
    const tooltipContent = (0, $70fFQ.useMemo)(()=>{
        if (titleTextLines === 2 && current?.scrollHeight > $5a2e8494737d1c0e$var$TWO_LINE_HEIGHT || titleTextLines === 3 && current?.scrollHeight > $5a2e8494737d1c0e$var$THREE_LINE_HEIGHT) return document.title;
        return null;
    }, [
        document.title,
        titleTextLines,
        current
    ]);
    const tooltip = (0, $dfd33cee3229493c$exports.useTooltip)(cardRef, tooltipContent);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.HyperLink), {
        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).UNSTYLED,
        url: document.link,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
                ref: cardRef,
                onClick: onClick,
                cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).MINIMAL,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5a2e8494737d1c0e$var$StyledDocumentCardContent, {
                    $titleTextLines: titleTextLines,
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme50, {
                                    children: document.source
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(TextComponent, {
                                    ref: textRef,
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                        children: document.title
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme50, {
                            children: [
                                "Published on ",
                                (0, $86d2f3987cc9d604$exports.DateTime).fromISO(document.date).toLocaleString()
                            ]
                        })
                    ]
                })
            }),
            tooltip
        ]
    });
};
$5a2e8494737d1c0e$var$DocumentCard.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    document: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired,
    titleTextLines: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$5a2e8494737d1c0e$var$DocumentCard.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
    titleTextLines: 3
};
var $5a2e8494737d1c0e$export$2e2bcd8739ae039 = $5a2e8494737d1c0e$var$DocumentCard;





/* eslint-disable */ 

var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");
function $4c566ec7d0dec1f0$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $4c566ec7d0dec1f0$var$isRecord(subject) {
    return $4c566ec7d0dec1f0$var$isObject(subject) || Array.isArray(subject);
}
function $4c566ec7d0dec1f0$export$71594e8a50f746f4() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function $4c566ec7d0dec1f0$export$1ace03bbcd701468(optionsA, optionsB) {
    const optionsAKeys = Object.keys(optionsA);
    const optionsBKeys = Object.keys(optionsB);
    if (optionsAKeys.length !== optionsBKeys.length) return false;
    const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
    const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
    if (breakpointsA !== breakpointsB) return false;
    return optionsAKeys.every((key)=>{
        const valueA = optionsA[key];
        const valueB = optionsB[key];
        if (typeof valueA === 'function') return `${valueA}` === `${valueB}`;
        if (!$4c566ec7d0dec1f0$var$isRecord(valueA) || !$4c566ec7d0dec1f0$var$isRecord(valueB)) return valueA === valueB;
        return $4c566ec7d0dec1f0$export$1ace03bbcd701468(valueA, valueB);
    });
}
function $4c566ec7d0dec1f0$export$919604828c9466f3(plugins) {
    return plugins.concat().sort((a, b)=>a.name > b.name ? 1 : -1).map((plugin)=>plugin.options);
}
function $4c566ec7d0dec1f0$export$8a8daedc629f7568(pluginsA, pluginsB) {
    if (pluginsA.length !== pluginsB.length) return false;
    const optionsA = $4c566ec7d0dec1f0$export$919604828c9466f3(pluginsA);
    const optionsB = $4c566ec7d0dec1f0$export$919604828c9466f3(pluginsB);
    return optionsA.every((optionA, index)=>{
        const optionB = optionsB[index];
        return $4c566ec7d0dec1f0$export$1ace03bbcd701468(optionA, optionB);
    });
}


function $06310d3d46be49d7$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $06310d3d46be49d7$var$isString(subject) {
    return typeof subject === 'string';
}
function $06310d3d46be49d7$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $06310d3d46be49d7$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $06310d3d46be49d7$var$mathAbs(n) {
    return Math.abs(n);
}
function $06310d3d46be49d7$var$mathSign(n) {
    return Math.sign(n);
}
function $06310d3d46be49d7$var$deltaAbs(valueB, valueA) {
    return $06310d3d46be49d7$var$mathAbs(valueB - valueA);
}
function $06310d3d46be49d7$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($06310d3d46be49d7$var$mathAbs(valueB) <= $06310d3d46be49d7$var$mathAbs(valueA)) return 0;
    const diff = $06310d3d46be49d7$var$deltaAbs($06310d3d46be49d7$var$mathAbs(valueB), $06310d3d46be49d7$var$mathAbs(valueA));
    return $06310d3d46be49d7$var$mathAbs(diff / valueB);
}
function $06310d3d46be49d7$var$arrayKeys(array) {
    return $06310d3d46be49d7$var$objectKeys(array).map(Number);
}
function $06310d3d46be49d7$var$arrayLast(array) {
    return array[$06310d3d46be49d7$var$arrayLastIndex(array)];
}
function $06310d3d46be49d7$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $06310d3d46be49d7$var$arrayIsLastIndex(array, index) {
    return index === $06310d3d46be49d7$var$arrayLastIndex(array);
}
function $06310d3d46be49d7$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $06310d3d46be49d7$var$objectKeys(object) {
    return Object.keys(object);
}
function $06310d3d46be49d7$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $06310d3d46be49d7$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $06310d3d46be49d7$var$isObject(valueA) && $06310d3d46be49d7$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $06310d3d46be49d7$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $06310d3d46be49d7$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $06310d3d46be49d7$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($06310d3d46be49d7$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $06310d3d46be49d7$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $06310d3d46be49d7$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $06310d3d46be49d7$var$EventStore();
    const timeStep = 1000 / 60;
    let lastTimeStamp = null;
    let lag = 0;
    let animationFrame = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationFrame) return;
        if (!lastTimeStamp) lastTimeStamp = timeStamp;
        const elapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        lag += elapsed;
        while(lag >= timeStep){
            update(timeStep);
            lag -= timeStep;
        }
        const lagOffset = lag / timeStep;
        render(lagOffset);
        if (animationFrame) ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationFrame) return;
        animationFrame = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationFrame);
        lastTimeStamp = null;
        lag = 0;
        animationFrame = 0;
    }
    function reset() {
        lastTimeStamp = null;
        lag = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: ()=>update(timeStep),
        render: render
    };
    return self;
}
function $06310d3d46be49d7$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $06310d3d46be49d7$var$Limit(min = 0, max = 0) {
    const length = $06310d3d46be49d7$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $06310d3d46be49d7$var$Counter(max, start, loop) {
    const { constrain: constrain } = $06310d3d46be49d7$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $06310d3d46be49d7$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $06310d3d46be49d7$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $06310d3d46be49d7$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $06310d3d46be49d7$var$EventStore();
    const dragEvents = $06310d3d46be49d7$var$EventStore();
    const goToNextThreshold = $06310d3d46be49d7$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($06310d3d46be49d7$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($06310d3d46be49d7$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $06310d3d46be49d7$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $06310d3d46be49d7$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $06310d3d46be49d7$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$06310d3d46be49d7$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $06310d3d46be49d7$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $06310d3d46be49d7$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $06310d3d46be49d7$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $06310d3d46be49d7$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($06310d3d46be49d7$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $06310d3d46be49d7$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $06310d3d46be49d7$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $06310d3d46be49d7$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $06310d3d46be49d7$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $06310d3d46be49d7$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit('resize');
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($06310d3d46be49d7$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek(timeStep) {
        const fixedDeltaTimeSeconds = timeStep / 1000;
        const duration = scrollDuration * fixedDeltaTimeSeconds;
        const diff = target.get() - location.get();
        const isInstant = !scrollDuration;
        let directionDiff = 0;
        if (isInstant) {
            bodyVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            directionDiff = diff;
        } else {
            previousLocation.set(location);
            bodyVelocity += diff / duration;
            bodyVelocity *= scrollFriction;
            rawLocation += bodyVelocity;
            location.add(bodyVelocity * fixedDeltaTimeSeconds);
            directionDiff = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $06310d3d46be49d7$var$mathSign(directionDiff);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $06310d3d46be49d7$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return bodyVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $06310d3d46be49d7$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
        const diffToEdge = $06310d3d46be49d7$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $06310d3d46be49d7$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $06310d3d46be49d7$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $06310d3d46be49d7$var$deltaAbs(bound, snap) < 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $06310d3d46be49d7$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $06310d3d46be49d7$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $06310d3d46be49d7$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $06310d3d46be49d7$var$arrayLast(scrollSnaps);
    const limit = $06310d3d46be49d7$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $06310d3d46be49d7$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$06310d3d46be49d7$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($06310d3d46be49d7$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$06310d3d46be49d7$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $06310d3d46be49d7$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $06310d3d46be49d7$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $06310d3d46be49d7$var$arrayLast(groups[0]) + 1;
                return $06310d3d46be49d7$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $06310d3d46be49d7$var$arrayLastIndex(slideIndexes) - $06310d3d46be49d7$var$arrayLast(groups)[0] + 1;
                return $06310d3d46be49d7$var$arrayFromNumber(range, $06310d3d46be49d7$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$06310d3d46be49d7$var$mathAbs(a) - $06310d3d46be49d7$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$06310d3d46be49d7$var$mathAbs(d1.diff) - $06310d3d46be49d7$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$06310d3d46be49d7$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $06310d3d46be49d7$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $06310d3d46be49d7$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $06310d3d46be49d7$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler) {
    let lastTabPressTime = 0;
    function init() {
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach(addSlideFocusEvent);
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    function addSlideFocusEvent(slide) {
        const focus = ()=>{
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            root.scrollLeft = 0;
            const index = slides.indexOf(slide);
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$06310d3d46be49d7$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit('slideFocus');
        };
        eventStore.add(slide, 'focus', focus, {
            passive: true,
            capture: true
        });
    }
    const self = {
        init: init
    };
    return self;
}
function $06310d3d46be49d7$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $06310d3d46be49d7$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $06310d3d46be49d7$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        containerStyle.transform = translate(axis.direction(target));
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $06310d3d46be49d7$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $06310d3d46be49d7$var$arrayKeys(slideSizesWithGaps);
    const descItems = $06310d3d46be49d7$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $06310d3d46be49d7$var$Vector1D(-1),
                translate: $06310d3d46be49d7$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $06310d3d46be49d7$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($06310d3d46be49d7$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $06310d3d46be49d7$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $06310d3d46be49d7$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $06310d3d46be49d7$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $06310d3d46be49d7$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($06310d3d46be49d7$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $06310d3d46be49d7$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($06310d3d46be49d7$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $06310d3d46be49d7$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $06310d3d46be49d7$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $06310d3d46be49d7$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $06310d3d46be49d7$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $06310d3d46be49d7$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $06310d3d46be49d7$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $06310d3d46be49d7$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $06310d3d46be49d7$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $06310d3d46be49d7$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $06310d3d46be49d7$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $06310d3d46be49d7$var$PercentOfView(viewSize);
    const alignment = $06310d3d46be49d7$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $06310d3d46be49d7$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $06310d3d46be49d7$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $06310d3d46be49d7$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$06310d3d46be49d7$var$arrayLast(snaps) + $06310d3d46be49d7$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $06310d3d46be49d7$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $06310d3d46be49d7$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $06310d3d46be49d7$var$Counter($06310d3d46be49d7$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $06310d3d46be49d7$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } }, timeStep)=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek(timeStep);
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, lagOffset)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        if (hasSettled && !dragHandler.pointerDown()) {
            animation.stop();
            eventHandler.emit('settle');
        }
        if (!hasSettled) eventHandler.emit('scroll');
        const interpolatedLocation = location.get() * lagOffset + previousLocation.get() * (1 - lagOffset);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
    };
    const animation = $06310d3d46be49d7$var$Animations(ownerDocument, ownerWindow, (timeStep)=>update(engine, timeStep), (lagOffset)=>render(engine, lagOffset));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $06310d3d46be49d7$var$Vector1D(startLocation);
    const previousLocation = $06310d3d46be49d7$var$Vector1D(startLocation);
    const offsetLocation = $06310d3d46be49d7$var$Vector1D(startLocation);
    const target = $06310d3d46be49d7$var$Vector1D(startLocation);
    const scrollBody = $06310d3d46be49d7$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $06310d3d46be49d7$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $06310d3d46be49d7$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $06310d3d46be49d7$var$ScrollProgress(limit);
    const eventStore = $06310d3d46be49d7$var$EventStore();
    const slidesInView = $06310d3d46be49d7$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $06310d3d46be49d7$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $06310d3d46be49d7$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $06310d3d46be49d7$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $06310d3d46be49d7$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $06310d3d46be49d7$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $06310d3d46be49d7$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $06310d3d46be49d7$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $06310d3d46be49d7$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $06310d3d46be49d7$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $06310d3d46be49d7$var$Translate(axis, container)
    };
    return engine;
}
function $06310d3d46be49d7$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $06310d3d46be49d7$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true
};
function $06310d3d46be49d7$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $06310d3d46be49d7$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $06310d3d46be49d7$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$06310d3d46be49d7$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $06310d3d46be49d7$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $06310d3d46be49d7$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $06310d3d46be49d7$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $06310d3d46be49d7$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $06310d3d46be49d7$var$EventStore();
    const eventHandler = $06310d3d46be49d7$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($06310d3d46be49d7$var$defaultOptions, $06310d3d46be49d7$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $06310d3d46be49d7$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $06310d3d46be49d7$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $06310d3d46be49d7$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init();
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$06310d3d46be49d7$export$2e2bcd8739ae039.globalOptions = undefined;


function $1d6426753367e1e9$export$2e2bcd8739ae039(options = {}, plugins = []) {
    const storedOptions = (0, $70fFQ.useRef)(options);
    const storedPlugins = (0, $70fFQ.useRef)(plugins);
    const [emblaApi, setEmblaApi] = (0, $70fFQ.useState)();
    const [viewport, setViewport] = (0, $70fFQ.useState)();
    const reInit = (0, $70fFQ.useCallback)(()=>{
        if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
    }, [
        emblaApi
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if ((0, $4c566ec7d0dec1f0$export$71594e8a50f746f4)() && viewport) {
            (0, $06310d3d46be49d7$export$2e2bcd8739ae039).globalOptions = $1d6426753367e1e9$export$2e2bcd8739ae039.globalOptions;
            const newEmblaApi = (0, $06310d3d46be49d7$export$2e2bcd8739ae039)(viewport, storedOptions.current, storedPlugins.current);
            setEmblaApi(newEmblaApi);
            return ()=>newEmblaApi.destroy();
        } else setEmblaApi(undefined);
    }, [
        viewport,
        setEmblaApi
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if ((0, $4c566ec7d0dec1f0$export$1ace03bbcd701468)(storedOptions.current, options)) return;
        storedOptions.current = options;
        reInit();
    }, [
        options,
        reInit
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if ((0, $4c566ec7d0dec1f0$export$8a8daedc629f7568)(storedPlugins.current, plugins)) return;
        storedPlugins.current = plugins;
        reInit();
    }, [
        plugins,
        reInit
    ]);
    return [
        setViewport,
        emblaApi
    ];
}
$1d6426753367e1e9$export$2e2bcd8739ae039.globalOptions = undefined;





const $003dc761c92dedde$var$CarouselContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(null);
const $003dc761c92dedde$var$useCarousel = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useContext($003dc761c92dedde$var$CarouselContext);
    if (!context) throw new Error("useCarousel must be used within a <Carousel />");
    return context;
};
const $003dc761c92dedde$var$StyledEmptyOverlay = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme15).attrs({
    as: "div"
})`
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(
    0.25turn,
    transparent,
    ${(props)=>(0, $dfd33cee3229493c$exports.YukaColorPalette)[`surface${Math.max(props.theme.surfaceLevel - 1 || 0, 0)}`]}
  );
`;
const $003dc761c92dedde$export$144901db2ea8e967 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ opts: // We currently do not support EmblaCarousel's vertical orientation.
// orientation = "horizontal"
opts, setApi: setApi, plugins: plugins, className: className, children: children, slidesToScroll: slidesToScroll = 3, empty: empty, onScrollNext: onScrollNext, onScrollPrev: onScrollPrev, ...props }, ref)=>{
    const [carouselRef, api] = (0, $1d6426753367e1e9$export$2e2bcd8739ae039)({
        ...opts,
        slidesToScroll: slidesToScroll,
        duration: 20,
        axis: "x"
    }, plugins);
    const [canScrollPrev, setCanScrollPrev] = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(false);
    const [canScrollNext, setCanScrollNext] = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(false);
    const onSelect = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback((api)=>{
        if (!api) return;
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
    }, []);
    const scrollPrev = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback(()=>{
        api?.scrollPrev();
        if (onScrollPrev) onScrollPrev();
    }, [
        api
    ]);
    const scrollNext = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback(()=>{
        api?.scrollNext();
        if (onScrollNext) onScrollNext();
    }, [
        api
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useCallback((event)=>{
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            scrollPrev();
        } else if (event.key === "ArrowRight") {
            event.preventDefault();
            scrollNext();
        }
    }, [
        scrollPrev,
        scrollNext
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(()=>{
        if (!api || !setApi) return;
        setApi(api);
    }, [
        api,
        setApi
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(()=>{
        if (!api) return;
        onSelect(api);
        api.on("reInit", onSelect);
        api.on("select", onSelect);
        return ()=>{
            api?.off("select", onSelect);
        };
    }, [
        api,
        onSelect
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($003dc761c92dedde$var$CarouselContext.Provider, {
        value: {
            carouselRef: carouselRef,
            api: api,
            opts: opts,
            orientation: "horizontal",
            scrollPrev: // orientation: orientation || (opts?.axis === "y" ? "vertical" : "horizontal"),
            scrollPrev,
            scrollNext: scrollNext,
            canScrollPrev: canScrollPrev,
            canScrollNext: canScrollNext,
            slidesToScroll: slidesToScroll
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
            ref: ref,
            onKeyDownCapture: handleKeyDown,
            className: (0, $2008c04e61e79f08$export$2e2bcd8739ae039)("relative", className),
            role: "region",
            "aria-roledescription": "carousel",
            ...props,
            children: [
                children,
                empty && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($003dc761c92dedde$var$StyledEmptyOverlay, {
                    children: "Data not available"
                })
            ]
        })
    });
});
$003dc761c92dedde$export$144901db2ea8e967.displayName = "Carousel";
const $003dc761c92dedde$var$StyledContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  > :not(:last-child) {
    margin-right: 16px;
  }
`;
const $003dc761c92dedde$var$StyledStart = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 0;
  height: 100%;
  width: 32px;
  background: linear-gradient(
    0.75turn,
    transparent,
    ${(props)=>(0, $dfd33cee3229493c$exports.YukaColorPalette)[`surface${Math.max(props.theme.surfaceLevel - 1 || 0, 0)}`]} 62.5%
  );
`;
const $003dc761c92dedde$var$StyledEnd = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: absolute;
  right: 0;
  height: 100%;
  width: 32px;
  background: linear-gradient(
    0.25turn,
    transparent,
    ${(props)=>(0, $dfd33cee3229493c$exports.YukaColorPalette)[`surface${Math.max(props.theme.surfaceLevel - 1 || 0, 0)}`]} 62.5%
  );
`;
const $003dc761c92dedde$export$c1bff280f3570f68 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ className: className, ...props }, ref)=>{
    const { carouselRef: carouselRef, canScrollPrev: // orientation,
    canScrollPrev, canScrollNext: canScrollNext, slidesToScroll: slidesToScroll } = $003dc761c92dedde$var$useCarousel();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
        ref: carouselRef,
        className: "relative overflow-hidden flex w-full",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($003dc761c92dedde$var$StyledContent, {
                // $orientation={orientation}
                ref: ref,
                className: (0, $2008c04e61e79f08$export$2e2bcd8739ae039)("flex w-full", className),
                ...props
            }),
            canScrollPrev && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($003dc761c92dedde$var$StyledStart, {
                $slidesToScroll: slidesToScroll
            }),
            canScrollNext && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($003dc761c92dedde$var$StyledEnd, {
                $slidesToScroll: slidesToScroll
            })
        ]
    });
});
$003dc761c92dedde$export$c1bff280f3570f68.displayName = "CarouselContent";
const $003dc761c92dedde$var$StyledItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  // The carousel will show $slidesToScroll items, plus half an extra item
  // to indicate scroll ability.
  flex-basis: calc(
    calc(100% - calc(16px * ${(props)=>props.$slidesToScroll})) /
      ${(props)=>props.$slidesToScroll + 0.4}
  );
`;
const $003dc761c92dedde$export$42c20acb2971398c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ className: className, ...props }, ref)=>{
    const { slidesToScroll: slidesToScroll } = $003dc761c92dedde$var$useCarousel();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($003dc761c92dedde$var$StyledItem, {
        $slidesToScroll: slidesToScroll,
        ref: ref,
        role: "group",
        "aria-roledescription": "slide",
        className: (0, $2008c04e61e79f08$export$2e2bcd8739ae039)("min-w-0 shrink-0 grow-0", className),
        ...props
    });
});
$003dc761c92dedde$export$42c20acb2971398c.displayName = "CarouselItem";
const $003dc761c92dedde$export$434129336ddede1b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ className: className, variant: variant = "outline", size: size = "icon", ...props }, ref)=>{
    const { scrollPrev: scrollPrev, canScrollPrev: canScrollPrev } = $003dc761c92dedde$var$useCarousel();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
        buttonStyle: (0, $dfd33cee3229493c$exports.IconButtonStyles).OUTLINE,
        icon: (0, $dfd33cee3229493c$exports.ChevronLeftIcon),
        ref: ref,
        variant: variant,
        size: size,
        disabled: !canScrollPrev,
        onClick: scrollPrev,
        ...props
    });
});
$003dc761c92dedde$export$434129336ddede1b.displayName = "CarouselPrevious";
const $003dc761c92dedde$export$75fd771fe00f2b45 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ className: className, variant: variant = "outline", size: size = "icon", ...props }, ref)=>{
    const { scrollNext: scrollNext, canScrollNext: canScrollNext } = $003dc761c92dedde$var$useCarousel();
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
        className: "self-end",
        buttonStyle: (0, $dfd33cee3229493c$exports.IconButtonStyles).OUTLINE,
        icon: (0, $dfd33cee3229493c$exports.ChevronRightIcon),
        ref: ref,
        variant: variant,
        size: size,
        disabled: !canScrollNext,
        onClick: scrollNext,
        ...props
    });
});
$003dc761c92dedde$export$75fd771fe00f2b45.displayName = "CarouselNext";










var $hI4Hx = parcelRequire("hI4Hx");
const $3d0a219733fde2aa$var$STORAGE_KEY = "mostRecentlyVisitedCompanies";
const $3d0a219733fde2aa$var$QUEUE_SIZE = 5;
const $3d0a219733fde2aa$export$aaa33b06eebfe9e4 = ()=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(window.localStorage.getItem($3d0a219733fde2aa$var$STORAGE_KEY))) return [];
    const stored = JSON.parse(window.localStorage.getItem($3d0a219733fde2aa$var$STORAGE_KEY));
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter(stored, (c)=>c[0] && c[0] !== "undefined");
};
const $3d0a219733fde2aa$export$d604d20474eedda8 = (company)=>{
    const oldQueue = $3d0a219733fde2aa$export$aaa33b06eebfe9e4();
    const newCompany = [
        company.zb_id ?? company.apiId,
        company.name,
        company.main_picture,
        company.legal_name
    ];
    if (oldQueue.length && newCompany[0] === oldQueue[0][0]) return;
    // Push company into queue, pull it out of existing queue if it exists, trim to max size
    const newQueue = [
        newCompany,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter(oldQueue, (c)=>c[0] !== newCompany[0]).slice(0, $3d0a219733fde2aa$var$QUEUE_SIZE - 1)
    ];
    window.localStorage.setItem($3d0a219733fde2aa$var$STORAGE_KEY, JSON.stringify(newQueue));
};
const $3d0a219733fde2aa$export$571c6d653a7837db = (companyId)=>{
    const oldQueue = $3d0a219733fde2aa$export$aaa33b06eebfe9e4();
    const newQueue = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter(oldQueue, (c)=>c[0] !== companyId);
    window.localStorage.setItem($3d0a219733fde2aa$var$STORAGE_KEY, JSON.stringify(newQueue));
};



/**
 * Simple hook that fetches a company by ID, and in the event of a 404 navigates the user back to
 * the company list page. The 404 also triggers a purge in the local storage "recent companies"
 * list.
 *
 * @param companyId
 * @param queryParams
 * @param config
 * @return {Array}
 */ const $c0097679c2d88aee$var$useCompanyFetch = (companyId, queryParams = {}, config = {
    redirectOnFail: true
})=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    return (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY(companyId), queryParams, {
        onError: (error)=>{
            if (error.status === 404) {
                // Purge from local storage.
                (0, $3d0a219733fde2aa$export$571c6d653a7837db)(companyId);
                // Navigate to company list.
                if (config.redirectOnFail) navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES());
            }
        }
    });
};
var $c0097679c2d88aee$export$2e2bcd8739ae039 = $c0097679c2d88aee$var$useCompanyFetch;


/*
 * Pulls the company ID out of the URL and fetches the company data. Useful for determining
 * if the URL provided ID actually matches a company.
 */ const $5e1940079019bdf2$var$useCompany = ()=>{
    const { id: companyId } = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const companyQuery = (0, $c0097679c2d88aee$export$2e2bcd8739ae039)(companyId);
    if (companyQuery.isLoading) return [
        null,
        true
    ];
    if (!companyQuery.isSuccess) return [
        null,
        false
    ];
    return [
        companyQuery.cleanedData.data,
        false
    ];
};
var $5e1940079019bdf2$export$2e2bcd8739ae039 = $5e1940079019bdf2$var$useCompany;




var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");


const $f61d99c2f2cef056$var$INVESTOR_PAGE_SIZE = 10;
/**
 * Fetches any number of entity profiles and simulates paging, based on a list of
 * Funding Round objects. The investors will be pulled from Kusanagi, so only use this hook with
 * funding rounds also obtained from kusanagi, so the entity primary keys match up.
 *
 * @param fundingRounds
 * @return {Array}
 */ const $f61d99c2f2cef056$var$useEntityProfileFetches = (fundingRounds)=>{
    const investors = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).flatten(fundingRounds.map((fundingRound)=>fundingRound.investors || [])).map((investor)=>investor[1])), [
        fundingRounds
    ]);
    const entityProfileQueries = [];
    for(let i = 0; i < investors.length; i += $f61d99c2f2cef056$var$INVESTOR_PAGE_SIZE)entityProfileQueries.push({
        url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).ENTITY_PROFILES(),
        queryParams: {
            zb_id: investors.slice(i, i + $f61d99c2f2cef056$var$INVESTOR_PAGE_SIZE)
        },
        options: {
            enabled: fundingRounds.length > 0
        }
    });
    return (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)(entityProfileQueries, {
        flattenResults: true
    });
};
var $f61d99c2f2cef056$export$2e2bcd8739ae039 = $f61d99c2f2cef056$var$useEntityProfileFetches;





/**
 * Similar to useLatestOrderflowForPortfolio, except operates on a single company. Queries for 1
 * year of data but only returns the 2 latest order flow reports. Querying for 1 year of data is so
 * we can make use of the cache.
 *
 * @param companyId
 */ const $f54bc4a73753e281$var$useLatestOrderflowForCompany = (companyId)=>{
    const query = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_PRICE_VOLUME_ORDER_FLOW(), {
        company: companyId,
        end_date: (0, $86d2f3987cc9d604$exports.DateTime).now().toISODate(),
        start_date: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
            years: 1
        }).toISODate()
    }, {
        enabled: Boolean(companyId)
    });
    if (query.isLoading) return [
        null,
        true
    ];
    if (!query.isSuccess) return [
        null,
        false
    ];
    return [
        [
            query.cleanedData.data?.[0],
            query.cleanedData.data?.[1]
        ],
        false
    ];
};
var $f54bc4a73753e281$export$2e2bcd8739ae039 = $f54bc4a73753e281$var$useLatestOrderflowForCompany;




/**
 * Hook that queries /api/valuations/ using a given companyId
 *
 * @param {string} companyId
 * @return {[object|null, boolean, object]} - The valuation object and a boolean that indicates
 *    whether or not the query is still loading or has failed. Also returns the query object
 *    in case we need to access the query itself.
 */ const $5c04b71cc3b9ae40$var$useCompanyCustomValuations = (companyId)=>{
    const valuationsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CUSTOM_VALUATIONS(), {
        company: companyId
    }, {
        enabled: Boolean(companyId)
    });
    if (valuationsQuery.isLoading) return [
        null,
        true
    ];
    if (!valuationsQuery.isSuccess) return [
        null,
        false
    ];
    return [
        valuationsQuery.cleanedData.results,
        false
    ];
};
var $5c04b71cc3b9ae40$export$2e2bcd8739ae039 = $5c04b71cc3b9ae40$var$useCompanyCustomValuations;






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");




const $39796339e90eaa03$export$a2d4d3aa503347c = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  > :first-child {
    gap: 16px;
  }

  > * {
    display: flex;
    align-items: center;
  }
`;
const $39796339e90eaa03$export$470b861649e7e2bd = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 64px;
  align-items: flex-end;
`;
const $39796339e90eaa03$export$391f39a3139b457a = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  align-self: center;
`;
const $39796339e90eaa03$export$82a28123aed8f0f3 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  display: grid;
  align-items: center;
  ${(props)=>props.$showData ? (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          grid-template-columns: 5fr 4fr 2fr 3fr 5fr 4fr 32px;
        ` : (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          grid-template-columns: 5fr 18fr 32px;
        `}}
`;
const $39796339e90eaa03$export$79590076e00e839c = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)($39796339e90eaa03$export$82a28123aed8f0f3)`
  height: 42px;
  padding: 0 16px;
  box-sizing: border-box;
  grid-template-columns: 5fr 4fr 2fr 3fr 5fr 4fr 64px;
  border-top: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  border-bottom: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
const $39796339e90eaa03$export$81645ce662b26656 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
  display: flex;

  flex-direction: column;
  gap: 24px;
  padding: 24px 24px 0 24px;
  overflow-y: auto;
  box-sizing: border-box;
  ${(props)=>props.$maxHeight ? `max-height: ${props.$maxHeight}px;` : ""}
  ${(props)=>props.$minHeight ? `min-height: ${props.$minHeight}px;` : ""}
  ${(props)=>props.$width ? `width: ${props.$width}px;` : ""}
`;
const $39796339e90eaa03$export$abe9a70c21d758c5 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
  box-sizing: border-box;
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: flex-end;
`;
const $39796339e90eaa03$export$ce16246c7502d1c8 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
`;


/**
 * Disclaimer for where we source our articles.
 * @param onClose
 * @return {JSX.Element}
 * @constructor
 */ const $8ce7ecd6e63f4c49$var$ReportsAndInterviewsDisclaimerModal = ({ onClose: onClose })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                $width: 624,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
                        children: "Disclaimer for reports and interviews"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                        children: "ZXData is providing a link to independent third-party research reports, such as the Sacra reports, solely as a courtesy to ZXData subscribers. ZXData is not recommending the use of, or reliance on, such reports and has not prepared or contributed to any such independent third-party research reports, nor is Zanbato affiliated with the entities producing such reports. Zanbato compensates the third party research providers for access to these reports. ZXData makes no warranties or representations of any kind, and takes no responsibility for the accuracy, completeness, timeliness, authenticity, or continued availability and/or updating of the independent third-party research reports. Any recommendation, opinion or advice regarding securities or markets contained in such independent third-party research reports does not necessarily reflect the views of ZXData. To the fullest extent provided by law, in no event shall Zanbato or its affiliates be liable for damages of any kind arising out of or in connection with the independent third-party research reports."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    onClick: onClose,
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    children: "Close"
                })
            })
        ]
    });
$8ce7ecd6e63f4c49$var$ReportsAndInterviewsDisclaimerModal.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $8ce7ecd6e63f4c49$export$2e2bcd8739ae039 = $8ce7ecd6e63f4c49$var$ReportsAndInterviewsDisclaimerModal;




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");


/**
 * Disclaimer for where we source our articles.
 * @param onClose
 * @return {JSX.Element}
 */ const $b503a24c9cb99895$var$ReportsAndInterviewsDisclaimerModal = ({ onClose: onClose })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                $width: 624,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
                        children: "Disclaimer for post-money valuation"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                        children: "Share count as stated or implied in Company press release or news article. Price per share as per company filings. Although care has been taken to ensure the accuracy, completeness, and reliability of the information, Zanbato makes no warranty, express or implied, or assumes any legal liability or responsibility for the accuracy, completeness, reliability or usefulness of any information."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    onClick: onClose,
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    children: "Close"
                })
            })
        ]
    });
$b503a24c9cb99895$var$ReportsAndInterviewsDisclaimerModal.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $b503a24c9cb99895$export$2e2bcd8739ae039 = $b503a24c9cb99895$var$ReportsAndInterviewsDisclaimerModal;





const $9d636a90fdf6e0e6$var$RELATION_CONNECTED = "connected";
const $9d636a90fdf6e0e6$var$RELATION_SUBJECT = "subject";
const $9d636a90fdf6e0e6$var$TYPE_COMPANY = "company";
const $9d636a90fdf6e0e6$var$CardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $9d636a90fdf6e0e6$var$StyledDisclaimer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.HyperLink))`
  align-self: flex-end;
`;
const $9d636a90fdf6e0e6$var$AlsoMentionedIn = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80).attrs({
    as: "div"
})``;
const $9d636a90fdf6e0e6$var$CompanyDocumentsCard = ()=>{
    const [disclaimerModalShowing, setDisclaimerModalShowing] = (0, $70fFQ.useState)(false);
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const documentsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SACRA_DOCUMENTS(company?.zb_id), {}, {
        enabled: Boolean(!companyIsLoading && company?.zb_id)
    });
    const reportsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CONTRARY_REPORTS(company?.zb_id), {}, {
        enabled: Boolean(!companyIsLoading && company?.zb_id)
    });
    const contraryReportMapper = (doc)=>({
            id: doc.title,
            link: doc.url,
            relation: $9d636a90fdf6e0e6$var$RELATION_SUBJECT,
            date: doc.article_updated_on,
            title: doc.title,
            type: $9d636a90fdf6e0e6$var$TYPE_COMPANY,
            source: "Contrary"
        });
    const sacraDocumentMapper = (doc)=>({
            ...doc,
            id: `SacraReport-${doc.id}`,
            source: "Sacra"
        });
    const contraryReports = reportsQuery?.cleanedData?.data?.map(contraryReportMapper) || [];
    const sacraDocuments = documentsQuery?.cleanedData?.documents?.map(sacraDocumentMapper) || [];
    const documentSorter = (a, b)=>{
        // Sort the documents by date, newest (largest date) first.
        if (a.date < b.date) return 1;
        if (a.date > b.date) return -1;
        return 0;
    };
    const documents = contraryReports.concat(sacraDocuments).sort(documentSorter);
    const subjectDocuments = documents?.filter((document)=>document.relation === $9d636a90fdf6e0e6$var$RELATION_SUBJECT);
    const connectedDocuments = documents?.filter((document)=>document.relation === $9d636a90fdf6e0e6$var$RELATION_CONNECTED);
    if (companyIsLoading || documentsQuery.isLoading || reportsQuery.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Reports and Interviews",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 48,
            children: "Loading reports and interviews..."
        })
    });
    if (!company) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Reports and Interviews",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 48,
            children: "An error has occurred."
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Reports and Interviews",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($9d636a90fdf6e0e6$var$CardContent, {
            children: [
                subjectDocuments.length ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $003dc761c92dedde$export$144901db2ea8e967), {
                    slidesToScroll: 3,
                    onScrollNext: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollCompanyReportsCarousel("next", "subject", company.name),
                    onScrollPrev: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollCompanyReportsCarousel("prev", "subject", company.name),
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$c1bff280f3570f68), {
                            children: subjectDocuments.map((document, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$42c20acb2971398c), {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5a2e8494737d1c0e$export$2e2bcd8739ae039), {
                                        document: document,
                                        titleTextLines: 3,
                                        onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openCompanyReport(document.source, "subject", company.name)
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$68f1b3e785b3c668), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$434129336ddede1b), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$75fd771fe00f2b45), {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                    $margin: 48,
                    children: "Reports and interviews not available"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($9d636a90fdf6e0e6$var$AlsoMentionedIn, {
                    children: [
                        company.name,
                        " is also mentioned in..."
                    ]
                }),
                connectedDocuments.length ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $003dc761c92dedde$export$144901db2ea8e967), {
                    slidesToScroll: 4,
                    onScrollNext: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollCompanyReportsCarousel("next", "related", company.name),
                    onScrollPrev: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollCompanyReportsCarousel("prev", "related", company.name),
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$c1bff280f3570f68), {
                            children: connectedDocuments.map((document, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$42c20acb2971398c), {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5a2e8494737d1c0e$export$2e2bcd8739ae039), {
                                        document: document,
                                        titleTextLines: 2,
                                        onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openCompanyReport(document.source, "related", company.name)
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$68f1b3e785b3c668), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$434129336ddede1b), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$75fd771fe00f2b45), {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                    $margin: 48,
                    children: "Articles not available"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9d636a90fdf6e0e6$var$StyledDisclaimer, {
                    linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                    onClick: ()=>{
                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openReportsAndInterviewsDisclaimer(company.name);
                        setDisclaimerModalShowing(true);
                    },
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme50, {
                        children: "View disclaimer"
                    })
                }),
                disclaimerModalShowing && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $8ce7ecd6e63f4c49$export$2e2bcd8739ae039), {
                    onClose: ()=>setDisclaimerModalShowing(false)
                })
            ]
        })
    });
};
var $9d636a90fdf6e0e6$export$2e2bcd8739ae039 = $9d636a90fdf6e0e6$var$CompanyDocumentsCard;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");
/**
 * @fileOverview Cross
 */ var $6ebe10030e701f4c$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$6ebe10030e701f4c$export$f6f0c3fe4ec306ea.displayName = 'Cell';


var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");
var $2fa78e63e2ad1ba9$exports = {};
(function(global, factory) {
    factory($2fa78e63e2ad1ba9$exports);
})($2fa78e63e2ad1ba9$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $cf819d0e0024b710$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $cf819d0e0024b710$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $cf819d0e0024b710$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $958cc3122c1c8c95$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $958cc3122c1c8c95$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $958cc3122c1c8c95$var$_typeof(o);
}
function $958cc3122c1c8c95$var$_toArray(arr) {
    return $958cc3122c1c8c95$var$_arrayWithHoles(arr) || $958cc3122c1c8c95$var$_iterableToArray(arr) || $958cc3122c1c8c95$var$_unsupportedIterableToArray(arr) || $958cc3122c1c8c95$var$_nonIterableRest();
}
function $958cc3122c1c8c95$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $958cc3122c1c8c95$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $958cc3122c1c8c95$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $958cc3122c1c8c95$var$_arrayLikeToArray(o, minLen);
}
function $958cc3122c1c8c95$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $958cc3122c1c8c95$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $958cc3122c1c8c95$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $958cc3122c1c8c95$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $958cc3122c1c8c95$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $cf819d0e0024b710$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $cf819d0e0024b710$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($958cc3122c1c8c95$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $a127c5ef64a83249$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a127c5ef64a83249$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a127c5ef64a83249$var$_typeof(o);
}
function $a127c5ef64a83249$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a127c5ef64a83249$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a127c5ef64a83249$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a127c5ef64a83249$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a127c5ef64a83249$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a127c5ef64a83249$var$_defineProperty(obj, key, value) {
    key = $a127c5ef64a83249$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a127c5ef64a83249$var$_toPropertyKey(arg) {
    var key = $a127c5ef64a83249$var$_toPrimitive(arg, "string");
    return $a127c5ef64a83249$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a127c5ef64a83249$var$_toPrimitive(input, hint) {
    if ($a127c5ef64a83249$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a127c5ef64a83249$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a127c5ef64a83249$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $a127c5ef64a83249$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $a127c5ef64a83249$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $a127c5ef64a83249$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $a127c5ef64a83249$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $a127c5ef64a83249$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $a127c5ef64a83249$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $a127c5ef64a83249$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $a127c5ef64a83249$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $a127c5ef64a83249$var$_objectSpread($a127c5ef64a83249$var$_objectSpread({}, res), {}, $a127c5ef64a83249$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $a127c5ef64a83249$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($a127c5ef64a83249$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $a127c5ef64a83249$var$isDev = false;
var $a127c5ef64a83249$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($a127c5ef64a83249$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $18edc1162dd5904e$var$_slicedToArray(arr, i) {
    return $18edc1162dd5904e$var$_arrayWithHoles(arr) || $18edc1162dd5904e$var$_iterableToArrayLimit(arr, i) || $18edc1162dd5904e$var$_unsupportedIterableToArray(arr, i) || $18edc1162dd5904e$var$_nonIterableRest();
}
function $18edc1162dd5904e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $18edc1162dd5904e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $18edc1162dd5904e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $18edc1162dd5904e$var$_toConsumableArray(arr) {
    return $18edc1162dd5904e$var$_arrayWithoutHoles(arr) || $18edc1162dd5904e$var$_iterableToArray(arr) || $18edc1162dd5904e$var$_unsupportedIterableToArray(arr) || $18edc1162dd5904e$var$_nonIterableSpread();
}
function $18edc1162dd5904e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $18edc1162dd5904e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $18edc1162dd5904e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $18edc1162dd5904e$var$_arrayLikeToArray(o, minLen);
}
function $18edc1162dd5904e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $18edc1162dd5904e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $18edc1162dd5904e$var$_arrayLikeToArray(arr);
}
function $18edc1162dd5904e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $18edc1162dd5904e$var$ACCURACY = 1e-4;
var $18edc1162dd5904e$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $18edc1162dd5904e$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $18edc1162dd5904e$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $18edc1162dd5904e$var$cubicBezierFactor(c1, c2);
        return $18edc1162dd5904e$var$multyTime(params, t);
    };
};
var $18edc1162dd5904e$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $18edc1162dd5904e$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($18edc1162dd5904e$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $18edc1162dd5904e$var$multyTime(newParams, t);
    };
};
var $18edc1162dd5904e$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $18edc1162dd5904e$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $a127c5ef64a83249$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $a127c5ef64a83249$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $18edc1162dd5904e$var$cubicBezier(x1, x2);
    var curveY = $18edc1162dd5904e$var$cubicBezier(y1, y2);
    var derCurveX = $18edc1162dd5904e$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $18edc1162dd5904e$var$ACCURACY || derVal < $18edc1162dd5904e$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $18edc1162dd5904e$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $18edc1162dd5904e$var$ACCURACY && Math.abs(newV) < $18edc1162dd5904e$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $18edc1162dd5904e$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $18edc1162dd5904e$export$56c51296f72f0592(easing);
        case 'spring':
            return $18edc1162dd5904e$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $18edc1162dd5904e$export$56c51296f72f0592(easing);
            (0, $a127c5ef64a83249$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $a127c5ef64a83249$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $525fb8859e3d7d25$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $525fb8859e3d7d25$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $525fb8859e3d7d25$var$_typeof(o);
}
function $525fb8859e3d7d25$var$_toConsumableArray(arr) {
    return $525fb8859e3d7d25$var$_arrayWithoutHoles(arr) || $525fb8859e3d7d25$var$_iterableToArray(arr) || $525fb8859e3d7d25$var$_unsupportedIterableToArray(arr) || $525fb8859e3d7d25$var$_nonIterableSpread();
}
function $525fb8859e3d7d25$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $525fb8859e3d7d25$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $525fb8859e3d7d25$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $525fb8859e3d7d25$var$_arrayLikeToArray(arr);
}
function $525fb8859e3d7d25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $525fb8859e3d7d25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $525fb8859e3d7d25$var$ownKeys(Object(t), !0).forEach(function(r) {
            $525fb8859e3d7d25$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $525fb8859e3d7d25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $525fb8859e3d7d25$var$_defineProperty(obj, key, value) {
    key = $525fb8859e3d7d25$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $525fb8859e3d7d25$var$_toPropertyKey(arg) {
    var key = $525fb8859e3d7d25$var$_toPrimitive(arg, "string");
    return $525fb8859e3d7d25$var$_typeof(key) === "symbol" ? key : String(key);
}
function $525fb8859e3d7d25$var$_toPrimitive(input, hint) {
    if ($525fb8859e3d7d25$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($525fb8859e3d7d25$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $525fb8859e3d7d25$var$_slicedToArray(arr, i) {
    return $525fb8859e3d7d25$var$_arrayWithHoles(arr) || $525fb8859e3d7d25$var$_iterableToArrayLimit(arr, i) || $525fb8859e3d7d25$var$_unsupportedIterableToArray(arr, i) || $525fb8859e3d7d25$var$_nonIterableRest();
}
function $525fb8859e3d7d25$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $525fb8859e3d7d25$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $525fb8859e3d7d25$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $525fb8859e3d7d25$var$_arrayLikeToArray(o, minLen);
}
function $525fb8859e3d7d25$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $525fb8859e3d7d25$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $525fb8859e3d7d25$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $525fb8859e3d7d25$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $525fb8859e3d7d25$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $525fb8859e3d7d25$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $a127c5ef64a83249$export$d6051a0f7a227332)(function(key, val) {
        if ($525fb8859e3d7d25$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $525fb8859e3d7d25$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $a127c5ef64a83249$export$d6051a0f7a227332)(function(key, val) {
        if ($525fb8859e3d7d25$var$needContinue(val)) return $525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread({}, val), {}, {
            velocity: $525fb8859e3d7d25$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $525fb8859e3d7d25$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$525fb8859e3d7d25$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $a127c5ef64a83249$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread({}, res), {}, $525fb8859e3d7d25$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread({}, res), {}, $525fb8859e3d7d25$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $a127c5ef64a83249$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($525fb8859e3d7d25$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $525fb8859e3d7d25$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $a127c5ef64a83249$export$d6051a0f7a227332)(function(key, val) {
            return $525fb8859e3d7d25$var$alpha.apply(void 0, $525fb8859e3d7d25$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $a127c5ef64a83249$export$d6051a0f7a227332)(function(key, val) {
                return $525fb8859e3d7d25$var$alpha.apply(void 0, $525fb8859e3d7d25$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread($525fb8859e3d7d25$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $24173923f0f12ff6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24173923f0f12ff6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24173923f0f12ff6$var$_typeof(o);
}
var $24173923f0f12ff6$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $24173923f0f12ff6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $24173923f0f12ff6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $24173923f0f12ff6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $24173923f0f12ff6$var$_toConsumableArray(arr) {
    return $24173923f0f12ff6$var$_arrayWithoutHoles(arr) || $24173923f0f12ff6$var$_iterableToArray(arr) || $24173923f0f12ff6$var$_unsupportedIterableToArray(arr) || $24173923f0f12ff6$var$_nonIterableSpread();
}
function $24173923f0f12ff6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $24173923f0f12ff6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $24173923f0f12ff6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $24173923f0f12ff6$var$_arrayLikeToArray(o, minLen);
}
function $24173923f0f12ff6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $24173923f0f12ff6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $24173923f0f12ff6$var$_arrayLikeToArray(arr);
}
function $24173923f0f12ff6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $24173923f0f12ff6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24173923f0f12ff6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24173923f0f12ff6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $24173923f0f12ff6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24173923f0f12ff6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $24173923f0f12ff6$var$_defineProperty(obj, key, value) {
    key = $24173923f0f12ff6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24173923f0f12ff6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $24173923f0f12ff6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $24173923f0f12ff6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $24173923f0f12ff6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $24173923f0f12ff6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $24173923f0f12ff6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $24173923f0f12ff6$var$_toPropertyKey(arg) {
    var key = $24173923f0f12ff6$var$_toPrimitive(arg, "string");
    return $24173923f0f12ff6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $24173923f0f12ff6$var$_toPrimitive(input, hint) {
    if ($24173923f0f12ff6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($24173923f0f12ff6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $24173923f0f12ff6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $24173923f0f12ff6$var$_setPrototypeOf(subClass, superClass);
}
function $24173923f0f12ff6$var$_setPrototypeOf(o, p) {
    $24173923f0f12ff6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $24173923f0f12ff6$var$_setPrototypeOf(o, p);
}
function $24173923f0f12ff6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $24173923f0f12ff6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $24173923f0f12ff6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $24173923f0f12ff6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $24173923f0f12ff6$var$_possibleConstructorReturn(this, result);
    };
}
function $24173923f0f12ff6$var$_possibleConstructorReturn(self, call) {
    if (call && ($24173923f0f12ff6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $24173923f0f12ff6$var$_assertThisInitialized(self);
}
function $24173923f0f12ff6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $24173923f0f12ff6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $24173923f0f12ff6$var$_getPrototypeOf(o) {
    $24173923f0f12ff6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $24173923f0f12ff6$var$_getPrototypeOf(o);
}
var $24173923f0f12ff6$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $24173923f0f12ff6$var$_inherits(Animate, _PureComponent);
    var _super = $24173923f0f12ff6$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $24173923f0f12ff6$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($24173923f0f12ff6$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($24173923f0f12ff6$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $24173923f0f12ff6$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $24173923f0f12ff6$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $24173923f0f12ff6$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $24173923f0f12ff6$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $24173923f0f12ff6$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $2fa78e63e2ad1ba9$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $24173923f0f12ff6$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($24173923f0f12ff6$var$_objectSpread($24173923f0f12ff6$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $525fb8859e3d7d25$export$2e2bcd8739ae039)(from, to, (0, $18edc1162dd5904e$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($24173923f0f12ff6$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $a127c5ef64a83249$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $24173923f0f12ff6$var$_objectSpread($24173923f0f12ff6$var$_objectSpread($24173923f0f12ff6$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($24173923f0f12ff6$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $a127c5ef64a83249$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($24173923f0f12ff6$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $958cc3122c1c8c95$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $24173923f0f12ff6$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $a127c5ef64a83249$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $24173923f0f12ff6$var$_objectSpread($24173923f0f12ff6$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $24173923f0f12ff6$var$_objectWithoutProperties(_this$props4, $24173923f0f12ff6$var$_excluded);
                var count = (0, $70fFQ.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $70fFQ.cloneElement)(container, $24173923f0f12ff6$var$_objectSpread($24173923f0f12ff6$var$_objectSpread({}, others), {}, {
                        style: $24173923f0f12ff6$var$_objectSpread($24173923f0f12ff6$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $70fFQ.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("div", null, (0, $70fFQ.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $70fFQ.PureComponent));
$24173923f0f12ff6$var$Animate.displayName = 'Animate';
$24173923f0f12ff6$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$24173923f0f12ff6$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
};
var $24173923f0f12ff6$export$2e2bcd8739ae039 = $24173923f0f12ff6$var$Animate;




var $70fFQ = parcelRequire("70fFQ");


function $0262b859e0d0c401$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");
var $33a66605070563c4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(null);



var $70fFQ = parcelRequire("70fFQ");
function $18c2f95c83e72740$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $70fFQ.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $70fFQ.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $18c2f95c83e72740$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $18c2f95c83e72740$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $18c2f95c83e72740$export$fa71e2345c31d7a2(props, onExited) {
    return $18c2f95c83e72740$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $18c2f95c83e72740$var$getProp(child, 'appear', props),
            enter: $18c2f95c83e72740$var$getProp(child, 'enter', props),
            exit: $18c2f95c83e72740$var$getProp(child, 'exit', props)
        });
    });
}
function $18c2f95c83e72740$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $18c2f95c83e72740$export$bbc8a025727ea824(nextProps.children);
    var children = $18c2f95c83e72740$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $70fFQ.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $70fFQ.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $18c2f95c83e72740$var$getProp(child, 'exit', nextProps),
            enter: $18c2f95c83e72740$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $70fFQ.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $18c2f95c83e72740$var$getProp(child, 'exit', nextProps),
            enter: $18c2f95c83e72740$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $6ac5cba62b059f30$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $6ac5cba62b059f30$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $6ac5cba62b059f30$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $0262b859e0d0c401$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $18c2f95c83e72740$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $18c2f95c83e72740$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $18c2f95c83e72740$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $1771723e14e11c61$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $53548097e910e6ba$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $6ac5cba62b059f30$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $33a66605070563c4$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $33a66605070563c4$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
$6ac5cba62b059f30$var$TransitionGroup.propTypes = {};
$6ac5cba62b059f30$var$TransitionGroup.defaultProps = $6ac5cba62b059f30$var$defaultProps;
var $6ac5cba62b059f30$export$2e2bcd8739ae039 = $6ac5cba62b059f30$var$TransitionGroup;



var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");
var $c7a34531073c5216$export$2e2bcd8739ae039 = {
    disabled: false
};




var $e444c257cd7374f8$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $eab1069f2d35a284$export$bb38bb9a1161268 = 'unmounted';
var $eab1069f2d35a284$export$84cbff306f539230 = 'exited';
var $eab1069f2d35a284$export$df38205c966be359 = 'entering';
var $eab1069f2d35a284$export$78e9e6e3e014d60a = 'entered';
var $eab1069f2d35a284$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $eab1069f2d35a284$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $803c8d214cd5af94$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $eab1069f2d35a284$export$84cbff306f539230;
                _this.appearStatus = $eab1069f2d35a284$export$df38205c966be359;
            } else initialStatus = $eab1069f2d35a284$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $eab1069f2d35a284$export$bb38bb9a1161268;
        else initialStatus = $eab1069f2d35a284$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $eab1069f2d35a284$export$bb38bb9a1161268) return {
            status: $eab1069f2d35a284$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $eab1069f2d35a284$export$df38205c966be359 && status !== $eab1069f2d35a284$export$78e9e6e3e014d60a) nextStatus = $eab1069f2d35a284$export$df38205c966be359;
            } else if (status === $eab1069f2d35a284$export$df38205c966be359 || status === $eab1069f2d35a284$export$78e9e6e3e014d60a) nextStatus = $eab1069f2d35a284$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $eab1069f2d35a284$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $e444c257cd7374f8$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $eab1069f2d35a284$export$84cbff306f539230) this.setState({
            status: $eab1069f2d35a284$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c7a34531073c5216$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $eab1069f2d35a284$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $eab1069f2d35a284$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $eab1069f2d35a284$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c7a34531073c5216$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $eab1069f2d35a284$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $eab1069f2d35a284$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $eab1069f2d35a284$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $eab1069f2d35a284$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $53548097e910e6ba$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $33a66605070563c4$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
$eab1069f2d35a284$var$Transition.contextType = (0, $33a66605070563c4$export$2e2bcd8739ae039);
$eab1069f2d35a284$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $eab1069f2d35a284$var$noop() {}
$eab1069f2d35a284$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $eab1069f2d35a284$var$noop,
    onEntering: $eab1069f2d35a284$var$noop,
    onEntered: $eab1069f2d35a284$var$noop,
    onExit: $eab1069f2d35a284$var$noop,
    onExiting: $eab1069f2d35a284$var$noop,
    onExited: $eab1069f2d35a284$var$noop
};
$eab1069f2d35a284$var$Transition.UNMOUNTED = $eab1069f2d35a284$export$bb38bb9a1161268;
$eab1069f2d35a284$var$Transition.EXITED = $eab1069f2d35a284$export$84cbff306f539230;
$eab1069f2d35a284$var$Transition.ENTERING = $eab1069f2d35a284$export$df38205c966be359;
$eab1069f2d35a284$var$Transition.ENTERED = $eab1069f2d35a284$export$78e9e6e3e014d60a;
$eab1069f2d35a284$var$Transition.EXITING = $eab1069f2d35a284$export$4aacc83d4d59139f;
var $eab1069f2d35a284$export$2e2bcd8739ae039 = $eab1069f2d35a284$var$Transition;



var $cd0Jr = parcelRequire("cd0Jr");

var $efaa1f699e6351dc$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $efaa1f699e6351dc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $efaa1f699e6351dc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $efaa1f699e6351dc$var$_typeof(o);
}
function $efaa1f699e6351dc$var$_extends() {
    $efaa1f699e6351dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efaa1f699e6351dc$var$_extends.apply(this, arguments);
}
function $efaa1f699e6351dc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $efaa1f699e6351dc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $efaa1f699e6351dc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $efaa1f699e6351dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efaa1f699e6351dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efaa1f699e6351dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $efaa1f699e6351dc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efaa1f699e6351dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $efaa1f699e6351dc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $efaa1f699e6351dc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $efaa1f699e6351dc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $efaa1f699e6351dc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $efaa1f699e6351dc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $efaa1f699e6351dc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $efaa1f699e6351dc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $efaa1f699e6351dc$var$_setPrototypeOf(subClass, superClass);
}
function $efaa1f699e6351dc$var$_setPrototypeOf(o, p) {
    $efaa1f699e6351dc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $efaa1f699e6351dc$var$_setPrototypeOf(o, p);
}
function $efaa1f699e6351dc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $efaa1f699e6351dc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $efaa1f699e6351dc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $efaa1f699e6351dc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $efaa1f699e6351dc$var$_possibleConstructorReturn(this, result);
    };
}
function $efaa1f699e6351dc$var$_possibleConstructorReturn(self, call) {
    if (call && ($efaa1f699e6351dc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $efaa1f699e6351dc$var$_assertThisInitialized(self);
}
function $efaa1f699e6351dc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $efaa1f699e6351dc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $efaa1f699e6351dc$var$_getPrototypeOf(o) {
    $efaa1f699e6351dc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $efaa1f699e6351dc$var$_getPrototypeOf(o);
}
function $efaa1f699e6351dc$var$_defineProperty(obj, key, value) {
    key = $efaa1f699e6351dc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $efaa1f699e6351dc$var$_toPropertyKey(arg) {
    var key = $efaa1f699e6351dc$var$_toPrimitive(arg, "string");
    return $efaa1f699e6351dc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $efaa1f699e6351dc$var$_toPrimitive(input, hint) {
    if ($efaa1f699e6351dc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($efaa1f699e6351dc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $efaa1f699e6351dc$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $efaa1f699e6351dc$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $efaa1f699e6351dc$var$_inherits(AnimateGroupChild, _Component);
    var _super = $efaa1f699e6351dc$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $efaa1f699e6351dc$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $efaa1f699e6351dc$var$_defineProperty($efaa1f699e6351dc$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $efaa1f699e6351dc$var$_defineProperty($efaa1f699e6351dc$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $efaa1f699e6351dc$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($efaa1f699e6351dc$var$_objectSpread($efaa1f699e6351dc$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $efaa1f699e6351dc$var$parseDurationOfSingleTransition(appearOptions) + $efaa1f699e6351dc$var$parseDurationOfSingleTransition(enterOptions) + $efaa1f699e6351dc$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $efaa1f699e6351dc$var$_objectWithoutProperties(_this$props3, $efaa1f699e6351dc$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $eab1069f2d35a284$export$2e2bcd8739ae039), $efaa1f699e6351dc$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $24173923f0f12ff6$export$2e2bcd8739ae039), _this2.state, (0, $70fFQ.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $70fFQ.Component));
$efaa1f699e6351dc$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).element
};
var $efaa1f699e6351dc$export$2e2bcd8739ae039 = $efaa1f699e6351dc$var$AnimateGroupChild;


function $5b5cd0d1f5f8a3f6$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $6ac5cba62b059f30$export$2e2bcd8739ae039), {
        component: component
    }, (0, $70fFQ.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $efaa1f699e6351dc$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$5b5cd0d1f5f8a3f6$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).any
};
$5b5cd0d1f5f8a3f6$var$AnimateGroup.defaultProps = {
    component: 'span'
};
var $5b5cd0d1f5f8a3f6$export$2e2bcd8739ae039 = $5b5cd0d1f5f8a3f6$var$AnimateGroup;


var $bc9b14c565af883b$export$2e2bcd8739ae039 = (0, $24173923f0f12ff6$export$2e2bcd8739ae039);


var $fc063f47c858524d$exports = {};
var $4efc1e893078bbf0$exports = {};
var $1001bcd844d108ba$exports = {};
var $df41e7dc5257abcb$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $df41e7dc5257abcb$var$isArray = Array.isArray;
$df41e7dc5257abcb$exports = $df41e7dc5257abcb$var$isArray;


var $32563463197471a3$exports = {};

var $383d33c6e13780df$exports = {};
var $4caad4bc3a782200$exports = {};
var $07e8d33a12bd76c2$exports = {};

var $3KrFG = parcelRequire("3KrFG");
/** Built-in value references. */ var $07e8d33a12bd76c2$var$Symbol = $3KrFG.Symbol;
$07e8d33a12bd76c2$exports = $07e8d33a12bd76c2$var$Symbol;


var $f4576ef9c4654eb1$exports = {};

/** Used for built-in method references. */ var $f4576ef9c4654eb1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f4576ef9c4654eb1$var$hasOwnProperty = $f4576ef9c4654eb1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f4576ef9c4654eb1$var$nativeObjectToString = $f4576ef9c4654eb1$var$objectProto.toString;
/** Built-in value references. */ var $f4576ef9c4654eb1$var$symToStringTag = $07e8d33a12bd76c2$exports ? $07e8d33a12bd76c2$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f4576ef9c4654eb1$var$getRawTag(value) {
    var isOwn = $f4576ef9c4654eb1$var$hasOwnProperty.call(value, $f4576ef9c4654eb1$var$symToStringTag), tag = value[$f4576ef9c4654eb1$var$symToStringTag];
    try {
        value[$f4576ef9c4654eb1$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f4576ef9c4654eb1$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f4576ef9c4654eb1$var$symToStringTag] = tag;
        else delete value[$f4576ef9c4654eb1$var$symToStringTag];
    }
    return result;
}
$f4576ef9c4654eb1$exports = $f4576ef9c4654eb1$var$getRawTag;


var $1a94e5a7b74de9b4$exports = {};
/** Used for built-in method references. */ var $1a94e5a7b74de9b4$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1a94e5a7b74de9b4$var$nativeObjectToString = $1a94e5a7b74de9b4$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1a94e5a7b74de9b4$var$objectToString(value) {
    return $1a94e5a7b74de9b4$var$nativeObjectToString.call(value);
}
$1a94e5a7b74de9b4$exports = $1a94e5a7b74de9b4$var$objectToString;


/** `Object#toString` result references. */ var $4caad4bc3a782200$var$nullTag = '[object Null]', $4caad4bc3a782200$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $4caad4bc3a782200$var$symToStringTag = $07e8d33a12bd76c2$exports ? $07e8d33a12bd76c2$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $4caad4bc3a782200$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $4caad4bc3a782200$var$undefinedTag : $4caad4bc3a782200$var$nullTag;
    return $4caad4bc3a782200$var$symToStringTag && $4caad4bc3a782200$var$symToStringTag in Object(value) ? $f4576ef9c4654eb1$exports(value) : $1a94e5a7b74de9b4$exports(value);
}
$4caad4bc3a782200$exports = $4caad4bc3a782200$var$baseGetTag;


var $862d5c9ce5bfb845$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $862d5c9ce5bfb845$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$862d5c9ce5bfb845$exports = $862d5c9ce5bfb845$var$isObjectLike;


/** `Object#toString` result references. */ var $383d33c6e13780df$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $383d33c6e13780df$var$isSymbol(value) {
    return typeof value == 'symbol' || $862d5c9ce5bfb845$exports(value) && $4caad4bc3a782200$exports(value) == $383d33c6e13780df$var$symbolTag;
}
$383d33c6e13780df$exports = $383d33c6e13780df$var$isSymbol;


/** Used to match property names within property paths. */ var $32563463197471a3$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $32563463197471a3$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $32563463197471a3$var$isKey(value, object) {
    if ($df41e7dc5257abcb$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $383d33c6e13780df$exports(value)) return true;
    return $32563463197471a3$var$reIsPlainProp.test(value) || !$32563463197471a3$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$32563463197471a3$exports = $32563463197471a3$var$isKey;


var $f8d5f7671a330e00$exports = {};
var $7d7065aec0022095$exports = {};
var $5eb956ceb92f8e8e$exports = {};
var $07a532a2010e8bdc$exports = {};
var $8adb0db073d82ab7$exports = {};
var $1875be661cfde554$exports = {};
var $4c7b7b362854f137$exports = {};
var $ef1b5ce0958b3036$exports = {};
var $36fef8c2a5f648c9$exports = {};
var $efba48e3a615f206$exports = {};
var $27042e501e0294f8$exports = {};

var $b3d1e6aa1c534f86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b3d1e6aa1c534f86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$b3d1e6aa1c534f86$exports = $b3d1e6aa1c534f86$var$isObject;


/** `Object#toString` result references. */ var $27042e501e0294f8$var$asyncTag = '[object AsyncFunction]', $27042e501e0294f8$var$funcTag = '[object Function]', $27042e501e0294f8$var$genTag = '[object GeneratorFunction]', $27042e501e0294f8$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $27042e501e0294f8$var$isFunction(value) {
    if (!$b3d1e6aa1c534f86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $4caad4bc3a782200$exports(value);
    return tag == $27042e501e0294f8$var$funcTag || tag == $27042e501e0294f8$var$genTag || tag == $27042e501e0294f8$var$asyncTag || tag == $27042e501e0294f8$var$proxyTag;
}
$27042e501e0294f8$exports = $27042e501e0294f8$var$isFunction;


var $d6f0a2f8e213008a$exports = {};
var $175ccfce93e6573c$exports = {};

var $3KrFG = parcelRequire("3KrFG");
/** Used to detect overreaching core-js shims. */ var $175ccfce93e6573c$var$coreJsData = $3KrFG["__core-js_shared__"];
$175ccfce93e6573c$exports = $175ccfce93e6573c$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $d6f0a2f8e213008a$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($175ccfce93e6573c$exports && $175ccfce93e6573c$exports.keys && $175ccfce93e6573c$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $d6f0a2f8e213008a$var$isMasked(func) {
    return !!$d6f0a2f8e213008a$var$maskSrcKey && $d6f0a2f8e213008a$var$maskSrcKey in func;
}
$d6f0a2f8e213008a$exports = $d6f0a2f8e213008a$var$isMasked;



var $9d7ef3a5c0cb7b1d$exports = {};
/** Used for built-in method references. */ var $9d7ef3a5c0cb7b1d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9d7ef3a5c0cb7b1d$var$funcToString = $9d7ef3a5c0cb7b1d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9d7ef3a5c0cb7b1d$var$toSource(func) {
    if (func != null) {
        try {
            return $9d7ef3a5c0cb7b1d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$9d7ef3a5c0cb7b1d$exports = $9d7ef3a5c0cb7b1d$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $efba48e3a615f206$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $efba48e3a615f206$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $efba48e3a615f206$var$funcProto = Function.prototype, $efba48e3a615f206$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $efba48e3a615f206$var$funcToString = $efba48e3a615f206$var$funcProto.toString;
/** Used to check objects for own properties. */ var $efba48e3a615f206$var$hasOwnProperty = $efba48e3a615f206$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $efba48e3a615f206$var$reIsNative = RegExp('^' + $efba48e3a615f206$var$funcToString.call($efba48e3a615f206$var$hasOwnProperty).replace($efba48e3a615f206$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $efba48e3a615f206$var$baseIsNative(value) {
    if (!$b3d1e6aa1c534f86$exports(value) || $d6f0a2f8e213008a$exports(value)) return false;
    var pattern = $27042e501e0294f8$exports(value) ? $efba48e3a615f206$var$reIsNative : $efba48e3a615f206$var$reIsHostCtor;
    return pattern.test($9d7ef3a5c0cb7b1d$exports(value));
}
$efba48e3a615f206$exports = $efba48e3a615f206$var$baseIsNative;


var $08e60050045d63cb$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $08e60050045d63cb$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$08e60050045d63cb$exports = $08e60050045d63cb$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $36fef8c2a5f648c9$var$getNative(object, key) {
    var value = $08e60050045d63cb$exports(object, key);
    return $efba48e3a615f206$exports(value) ? value : undefined;
}
$36fef8c2a5f648c9$exports = $36fef8c2a5f648c9$var$getNative;


/* Built-in method references that are verified to be native. */ var $ef1b5ce0958b3036$var$nativeCreate = $36fef8c2a5f648c9$exports(Object, 'create');
$ef1b5ce0958b3036$exports = $ef1b5ce0958b3036$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $4c7b7b362854f137$var$hashClear() {
    this.__data__ = $ef1b5ce0958b3036$exports ? $ef1b5ce0958b3036$exports(null) : {};
    this.size = 0;
}
$4c7b7b362854f137$exports = $4c7b7b362854f137$var$hashClear;


var $65bc96cca30758a4$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $65bc96cca30758a4$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$65bc96cca30758a4$exports = $65bc96cca30758a4$var$hashDelete;


var $c7cac474fedfc5a2$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $c7cac474fedfc5a2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $c7cac474fedfc5a2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c7cac474fedfc5a2$var$hasOwnProperty = $c7cac474fedfc5a2$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c7cac474fedfc5a2$var$hashGet(key) {
    var data = this.__data__;
    if ($ef1b5ce0958b3036$exports) {
        var result = data[key];
        return result === $c7cac474fedfc5a2$var$HASH_UNDEFINED ? undefined : result;
    }
    return $c7cac474fedfc5a2$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$c7cac474fedfc5a2$exports = $c7cac474fedfc5a2$var$hashGet;


var $5f00d62f34781231$exports = {};

/** Used for built-in method references. */ var $5f00d62f34781231$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5f00d62f34781231$var$hasOwnProperty = $5f00d62f34781231$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5f00d62f34781231$var$hashHas(key) {
    var data = this.__data__;
    return $ef1b5ce0958b3036$exports ? data[key] !== undefined : $5f00d62f34781231$var$hasOwnProperty.call(data, key);
}
$5f00d62f34781231$exports = $5f00d62f34781231$var$hashHas;


var $2427966849788ef0$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $2427966849788ef0$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $2427966849788ef0$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $ef1b5ce0958b3036$exports && value === undefined ? $2427966849788ef0$var$HASH_UNDEFINED : value;
    return this;
}
$2427966849788ef0$exports = $2427966849788ef0$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1875be661cfde554$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1875be661cfde554$var$Hash.prototype.clear = $4c7b7b362854f137$exports;
$1875be661cfde554$var$Hash.prototype['delete'] = $65bc96cca30758a4$exports;
$1875be661cfde554$var$Hash.prototype.get = $c7cac474fedfc5a2$exports;
$1875be661cfde554$var$Hash.prototype.has = $5f00d62f34781231$exports;
$1875be661cfde554$var$Hash.prototype.set = $2427966849788ef0$exports;
$1875be661cfde554$exports = $1875be661cfde554$var$Hash;


var $bad02d14e79a5617$exports = {};
var $f124be0dcc68b6ca$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f124be0dcc68b6ca$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$f124be0dcc68b6ca$exports = $f124be0dcc68b6ca$var$listCacheClear;


var $43f08e2bf62994ea$exports = {};
var $708089c78b4f3a3f$exports = {};
var $c48233b0642b0c67$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c48233b0642b0c67$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$c48233b0642b0c67$exports = $c48233b0642b0c67$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $708089c78b4f3a3f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($c48233b0642b0c67$exports(array[length][0], key)) return length;
    }
    return -1;
}
$708089c78b4f3a3f$exports = $708089c78b4f3a3f$var$assocIndexOf;


/** Used for built-in method references. */ var $43f08e2bf62994ea$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $43f08e2bf62994ea$var$splice = $43f08e2bf62994ea$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $43f08e2bf62994ea$var$listCacheDelete(key) {
    var data = this.__data__, index = $708089c78b4f3a3f$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $43f08e2bf62994ea$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$43f08e2bf62994ea$exports = $43f08e2bf62994ea$var$listCacheDelete;


var $be6a72cd4edc3196$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $be6a72cd4edc3196$var$listCacheGet(key) {
    var data = this.__data__, index = $708089c78b4f3a3f$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$be6a72cd4edc3196$exports = $be6a72cd4edc3196$var$listCacheGet;


var $f27e09ffc8bc7ac7$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f27e09ffc8bc7ac7$var$listCacheHas(key) {
    return $708089c78b4f3a3f$exports(this.__data__, key) > -1;
}
$f27e09ffc8bc7ac7$exports = $f27e09ffc8bc7ac7$var$listCacheHas;


var $8a4a06923b51e014$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8a4a06923b51e014$var$listCacheSet(key, value) {
    var data = this.__data__, index = $708089c78b4f3a3f$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$8a4a06923b51e014$exports = $8a4a06923b51e014$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bad02d14e79a5617$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$bad02d14e79a5617$var$ListCache.prototype.clear = $f124be0dcc68b6ca$exports;
$bad02d14e79a5617$var$ListCache.prototype['delete'] = $43f08e2bf62994ea$exports;
$bad02d14e79a5617$var$ListCache.prototype.get = $be6a72cd4edc3196$exports;
$bad02d14e79a5617$var$ListCache.prototype.has = $f27e09ffc8bc7ac7$exports;
$bad02d14e79a5617$var$ListCache.prototype.set = $8a4a06923b51e014$exports;
$bad02d14e79a5617$exports = $bad02d14e79a5617$var$ListCache;


var $d67870a6ce92d1a2$exports = {};


var $3KrFG = parcelRequire("3KrFG");
/* Built-in method references that are verified to be native. */ var $d67870a6ce92d1a2$var$Map = $36fef8c2a5f648c9$exports($3KrFG, 'Map');
$d67870a6ce92d1a2$exports = $d67870a6ce92d1a2$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8adb0db073d82ab7$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $1875be661cfde554$exports,
        'map': new ($d67870a6ce92d1a2$exports || $bad02d14e79a5617$exports),
        'string': new $1875be661cfde554$exports
    };
}
$8adb0db073d82ab7$exports = $8adb0db073d82ab7$var$mapCacheClear;


var $9fc9ed94c2a3fa54$exports = {};
var $f114472181272600$exports = {};
var $a8bb0b8cf8289668$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $a8bb0b8cf8289668$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$a8bb0b8cf8289668$exports = $a8bb0b8cf8289668$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $f114472181272600$var$getMapData(map, key) {
    var data = map.__data__;
    return $a8bb0b8cf8289668$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$f114472181272600$exports = $f114472181272600$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9fc9ed94c2a3fa54$var$mapCacheDelete(key) {
    var result = $f114472181272600$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$9fc9ed94c2a3fa54$exports = $9fc9ed94c2a3fa54$var$mapCacheDelete;


var $a9d278c1fcfa4764$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a9d278c1fcfa4764$var$mapCacheGet(key) {
    return $f114472181272600$exports(this, key).get(key);
}
$a9d278c1fcfa4764$exports = $a9d278c1fcfa4764$var$mapCacheGet;


var $fd7b3c164e5fbf87$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fd7b3c164e5fbf87$var$mapCacheHas(key) {
    return $f114472181272600$exports(this, key).has(key);
}
$fd7b3c164e5fbf87$exports = $fd7b3c164e5fbf87$var$mapCacheHas;


var $3ccd3186be3be6e6$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3ccd3186be3be6e6$var$mapCacheSet(key, value) {
    var data = $f114472181272600$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$3ccd3186be3be6e6$exports = $3ccd3186be3be6e6$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $07a532a2010e8bdc$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$07a532a2010e8bdc$var$MapCache.prototype.clear = $8adb0db073d82ab7$exports;
$07a532a2010e8bdc$var$MapCache.prototype['delete'] = $9fc9ed94c2a3fa54$exports;
$07a532a2010e8bdc$var$MapCache.prototype.get = $a9d278c1fcfa4764$exports;
$07a532a2010e8bdc$var$MapCache.prototype.has = $fd7b3c164e5fbf87$exports;
$07a532a2010e8bdc$var$MapCache.prototype.set = $3ccd3186be3be6e6$exports;
$07a532a2010e8bdc$exports = $07a532a2010e8bdc$var$MapCache;


/** Error message constants. */ var $5eb956ceb92f8e8e$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5eb956ceb92f8e8e$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5eb956ceb92f8e8e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5eb956ceb92f8e8e$var$memoize.Cache || $07a532a2010e8bdc$exports);
    return memoized;
}
// Expose `MapCache`.
$5eb956ceb92f8e8e$var$memoize.Cache = $07a532a2010e8bdc$exports;
$5eb956ceb92f8e8e$exports = $5eb956ceb92f8e8e$var$memoize;


/** Used as the maximum memoize cache size. */ var $7d7065aec0022095$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $7d7065aec0022095$var$memoizeCapped(func) {
    var result = $5eb956ceb92f8e8e$exports(func, function(key) {
        if (cache.size === $7d7065aec0022095$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$7d7065aec0022095$exports = $7d7065aec0022095$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f8d5f7671a330e00$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f8d5f7671a330e00$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f8d5f7671a330e00$var$stringToPath = $7d7065aec0022095$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f8d5f7671a330e00$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f8d5f7671a330e00$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$f8d5f7671a330e00$exports = $f8d5f7671a330e00$var$stringToPath;


var $023873f58349031a$exports = {};
var $4746b559608fa6dd$exports = {};

var $30dd2768a5448b60$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $30dd2768a5448b60$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$30dd2768a5448b60$exports = $30dd2768a5448b60$var$arrayMap;




/** Used as references for various `Number` constants. */ var $4746b559608fa6dd$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $4746b559608fa6dd$var$symbolProto = $07e8d33a12bd76c2$exports ? $07e8d33a12bd76c2$exports.prototype : undefined, $4746b559608fa6dd$var$symbolToString = $4746b559608fa6dd$var$symbolProto ? $4746b559608fa6dd$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $4746b559608fa6dd$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($df41e7dc5257abcb$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $30dd2768a5448b60$exports(value, $4746b559608fa6dd$var$baseToString) + '';
    if ($383d33c6e13780df$exports(value)) return $4746b559608fa6dd$var$symbolToString ? $4746b559608fa6dd$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$4746b559608fa6dd$var$INFINITY ? '-0' : result;
}
$4746b559608fa6dd$exports = $4746b559608fa6dd$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $023873f58349031a$var$toString(value) {
    return value == null ? '' : $4746b559608fa6dd$exports(value);
}
$023873f58349031a$exports = $023873f58349031a$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $1001bcd844d108ba$var$castPath(value, object) {
    if ($df41e7dc5257abcb$exports(value)) return value;
    return $32563463197471a3$exports(value, object) ? [
        value
    ] : $f8d5f7671a330e00$exports($023873f58349031a$exports(value));
}
$1001bcd844d108ba$exports = $1001bcd844d108ba$var$castPath;


var $e299d21966deff9d$exports = {};

/** Used as references for various `Number` constants. */ var $e299d21966deff9d$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e299d21966deff9d$var$toKey(value) {
    if (typeof value == 'string' || $383d33c6e13780df$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$e299d21966deff9d$var$INFINITY ? '-0' : result;
}
$e299d21966deff9d$exports = $e299d21966deff9d$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $4efc1e893078bbf0$var$baseGet(object, path) {
    path = $1001bcd844d108ba$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$e299d21966deff9d$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$4efc1e893078bbf0$exports = $4efc1e893078bbf0$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $fc063f47c858524d$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $4efc1e893078bbf0$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$fc063f47c858524d$exports = $fc063f47c858524d$var$get;


var $6b42dee265745d0f$exports = {};
var $eabb0f547dafe061$exports = {};
var $437808f12f09907e$exports = {};
var $7ae838d2ea346065$exports = {};

var $39ac605b56810d67$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $39ac605b56810d67$var$stackClear() {
    this.__data__ = new $bad02d14e79a5617$exports;
    this.size = 0;
}
$39ac605b56810d67$exports = $39ac605b56810d67$var$stackClear;


var $fd7de41d17397c06$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fd7de41d17397c06$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$fd7de41d17397c06$exports = $fd7de41d17397c06$var$stackDelete;


var $b1340adbc0eac8b3$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b1340adbc0eac8b3$var$stackGet(key) {
    return this.__data__.get(key);
}
$b1340adbc0eac8b3$exports = $b1340adbc0eac8b3$var$stackGet;


var $8cb442140abf8bfa$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8cb442140abf8bfa$var$stackHas(key) {
    return this.__data__.has(key);
}
$8cb442140abf8bfa$exports = $8cb442140abf8bfa$var$stackHas;


var $eafb454c0961382a$exports = {};



/** Used as the size to enable large array optimizations. */ var $eafb454c0961382a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $eafb454c0961382a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $bad02d14e79a5617$exports) {
        var pairs = data.__data__;
        if (!$d67870a6ce92d1a2$exports || pairs.length < $eafb454c0961382a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $07a532a2010e8bdc$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$eafb454c0961382a$exports = $eafb454c0961382a$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7ae838d2ea346065$var$Stack(entries) {
    var data = this.__data__ = new $bad02d14e79a5617$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$7ae838d2ea346065$var$Stack.prototype.clear = $39ac605b56810d67$exports;
$7ae838d2ea346065$var$Stack.prototype['delete'] = $fd7de41d17397c06$exports;
$7ae838d2ea346065$var$Stack.prototype.get = $b1340adbc0eac8b3$exports;
$7ae838d2ea346065$var$Stack.prototype.has = $8cb442140abf8bfa$exports;
$7ae838d2ea346065$var$Stack.prototype.set = $eafb454c0961382a$exports;
$7ae838d2ea346065$exports = $7ae838d2ea346065$var$Stack;


var $a71a7b3d0d59172a$exports = {};
var $580ef9deb5abbaef$exports = {};

var $b5da74069ae559b5$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $b5da74069ae559b5$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $b5da74069ae559b5$var$setCacheAdd(value) {
    this.__data__.set(value, $b5da74069ae559b5$var$HASH_UNDEFINED);
    return this;
}
$b5da74069ae559b5$exports = $b5da74069ae559b5$var$setCacheAdd;


var $cc0dd54c1db0d559$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $cc0dd54c1db0d559$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$cc0dd54c1db0d559$exports = $cc0dd54c1db0d559$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $580ef9deb5abbaef$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $07a532a2010e8bdc$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$580ef9deb5abbaef$var$SetCache.prototype.add = $580ef9deb5abbaef$var$SetCache.prototype.push = $b5da74069ae559b5$exports;
$580ef9deb5abbaef$var$SetCache.prototype.has = $cc0dd54c1db0d559$exports;
$580ef9deb5abbaef$exports = $580ef9deb5abbaef$var$SetCache;


var $d7fc50af2b7aa63a$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $d7fc50af2b7aa63a$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$d7fc50af2b7aa63a$exports = $d7fc50af2b7aa63a$var$arraySome;


var $b23cd2e7fb810464$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b23cd2e7fb810464$var$cacheHas(cache, key) {
    return cache.has(key);
}
$b23cd2e7fb810464$exports = $b23cd2e7fb810464$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $a71a7b3d0d59172a$var$COMPARE_PARTIAL_FLAG = 1, $a71a7b3d0d59172a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $a71a7b3d0d59172a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a71a7b3d0d59172a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $a71a7b3d0d59172a$var$COMPARE_UNORDERED_FLAG ? new $580ef9deb5abbaef$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$d7fc50af2b7aa63a$exports(other, function(othValue, othIndex) {
                if (!$b23cd2e7fb810464$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$a71a7b3d0d59172a$exports = $a71a7b3d0d59172a$var$equalArrays;


var $3af9371c33bdef73$exports = {};

var $cbc6492f599ae7aa$exports = {};

var $3KrFG = parcelRequire("3KrFG");
/** Built-in value references. */ var $cbc6492f599ae7aa$var$Uint8Array = $3KrFG.Uint8Array;
$cbc6492f599ae7aa$exports = $cbc6492f599ae7aa$var$Uint8Array;




var $88090a7a8fbde31a$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $88090a7a8fbde31a$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$88090a7a8fbde31a$exports = $88090a7a8fbde31a$var$mapToArray;


var $9536752770575bdf$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $9536752770575bdf$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$9536752770575bdf$exports = $9536752770575bdf$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $3af9371c33bdef73$var$COMPARE_PARTIAL_FLAG = 1, $3af9371c33bdef73$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $3af9371c33bdef73$var$boolTag = '[object Boolean]', $3af9371c33bdef73$var$dateTag = '[object Date]', $3af9371c33bdef73$var$errorTag = '[object Error]', $3af9371c33bdef73$var$mapTag = '[object Map]', $3af9371c33bdef73$var$numberTag = '[object Number]', $3af9371c33bdef73$var$regexpTag = '[object RegExp]', $3af9371c33bdef73$var$setTag = '[object Set]', $3af9371c33bdef73$var$stringTag = '[object String]', $3af9371c33bdef73$var$symbolTag = '[object Symbol]';
var $3af9371c33bdef73$var$arrayBufferTag = '[object ArrayBuffer]', $3af9371c33bdef73$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $3af9371c33bdef73$var$symbolProto = $07e8d33a12bd76c2$exports ? $07e8d33a12bd76c2$exports.prototype : undefined, $3af9371c33bdef73$var$symbolValueOf = $3af9371c33bdef73$var$symbolProto ? $3af9371c33bdef73$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3af9371c33bdef73$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $3af9371c33bdef73$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $3af9371c33bdef73$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $cbc6492f599ae7aa$exports(object), new $cbc6492f599ae7aa$exports(other))) return false;
            return true;
        case $3af9371c33bdef73$var$boolTag:
        case $3af9371c33bdef73$var$dateTag:
        case $3af9371c33bdef73$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $c48233b0642b0c67$exports(+object, +other);
        case $3af9371c33bdef73$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $3af9371c33bdef73$var$regexpTag:
        case $3af9371c33bdef73$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $3af9371c33bdef73$var$mapTag:
            var convert = $88090a7a8fbde31a$exports;
        case $3af9371c33bdef73$var$setTag:
            var isPartial = bitmask & $3af9371c33bdef73$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $9536752770575bdf$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $3af9371c33bdef73$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $a71a7b3d0d59172a$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $3af9371c33bdef73$var$symbolTag:
            if ($3af9371c33bdef73$var$symbolValueOf) return $3af9371c33bdef73$var$symbolValueOf.call(object) == $3af9371c33bdef73$var$symbolValueOf.call(other);
    }
    return false;
}
$3af9371c33bdef73$exports = $3af9371c33bdef73$var$equalByTag;


var $b76663b5e56a7121$exports = {};
var $96167778e03ba634$exports = {};
var $f7966e9168aa2161$exports = {};
var $422598f9fec7430c$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $422598f9fec7430c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$422598f9fec7430c$exports = $422598f9fec7430c$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f7966e9168aa2161$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $df41e7dc5257abcb$exports(object) ? result : $422598f9fec7430c$exports(result, symbolsFunc(object));
}
$f7966e9168aa2161$exports = $f7966e9168aa2161$var$baseGetAllKeys;


var $6615cd71800a25c6$exports = {};
var $7f1bf505fb4739a8$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7f1bf505fb4739a8$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$7f1bf505fb4739a8$exports = $7f1bf505fb4739a8$var$arrayFilter;


var $c85a9c4e66ed522f$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $c85a9c4e66ed522f$var$stubArray() {
    return [];
}
$c85a9c4e66ed522f$exports = $c85a9c4e66ed522f$var$stubArray;


/** Used for built-in method references. */ var $6615cd71800a25c6$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6615cd71800a25c6$var$propertyIsEnumerable = $6615cd71800a25c6$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6615cd71800a25c6$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6615cd71800a25c6$var$getSymbols = !$6615cd71800a25c6$var$nativeGetSymbols ? $c85a9c4e66ed522f$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $7f1bf505fb4739a8$exports($6615cd71800a25c6$var$nativeGetSymbols(object), function(symbol) {
        return $6615cd71800a25c6$var$propertyIsEnumerable.call(object, symbol);
    });
};
$6615cd71800a25c6$exports = $6615cd71800a25c6$var$getSymbols;


var $8b0ac38f8259c849$exports = {};
var $600e185d53161fe9$exports = {};
var $d29b4c69a20d83af$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d29b4c69a20d83af$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$d29b4c69a20d83af$exports = $d29b4c69a20d83af$var$baseTimes;


var $70cbfc6695bf6c02$exports = {};
var $0bd729cd477f588e$exports = {};


/** `Object#toString` result references. */ var $0bd729cd477f588e$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $0bd729cd477f588e$var$baseIsArguments(value) {
    return $862d5c9ce5bfb845$exports(value) && $4caad4bc3a782200$exports(value) == $0bd729cd477f588e$var$argsTag;
}
$0bd729cd477f588e$exports = $0bd729cd477f588e$var$baseIsArguments;



/** Used for built-in method references. */ var $70cbfc6695bf6c02$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $70cbfc6695bf6c02$var$hasOwnProperty = $70cbfc6695bf6c02$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $70cbfc6695bf6c02$var$propertyIsEnumerable = $70cbfc6695bf6c02$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $70cbfc6695bf6c02$var$isArguments = $0bd729cd477f588e$exports(function() {
    return arguments;
}()) ? $0bd729cd477f588e$exports : function(value) {
    return $862d5c9ce5bfb845$exports(value) && $70cbfc6695bf6c02$var$hasOwnProperty.call(value, 'callee') && !$70cbfc6695bf6c02$var$propertyIsEnumerable.call(value, 'callee');
};
$70cbfc6695bf6c02$exports = $70cbfc6695bf6c02$var$isArguments;




var $dDAvp = parcelRequire("dDAvp");
var $ef51c2ce0f9192d4$exports = {};
/** Used as references for various `Number` constants. */ var $ef51c2ce0f9192d4$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ef51c2ce0f9192d4$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ef51c2ce0f9192d4$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ef51c2ce0f9192d4$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ef51c2ce0f9192d4$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ef51c2ce0f9192d4$exports = $ef51c2ce0f9192d4$var$isIndex;


var $257777d773b0b95b$exports = {};
var $dfd264e1e1b2e9bd$exports = {};

var $5420202956375f24$exports = {};
/** Used as references for various `Number` constants. */ var $5420202956375f24$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $5420202956375f24$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $5420202956375f24$var$MAX_SAFE_INTEGER;
}
$5420202956375f24$exports = $5420202956375f24$var$isLength;



/** `Object#toString` result references. */ var $dfd264e1e1b2e9bd$var$argsTag = '[object Arguments]', $dfd264e1e1b2e9bd$var$arrayTag = '[object Array]', $dfd264e1e1b2e9bd$var$boolTag = '[object Boolean]', $dfd264e1e1b2e9bd$var$dateTag = '[object Date]', $dfd264e1e1b2e9bd$var$errorTag = '[object Error]', $dfd264e1e1b2e9bd$var$funcTag = '[object Function]', $dfd264e1e1b2e9bd$var$mapTag = '[object Map]', $dfd264e1e1b2e9bd$var$numberTag = '[object Number]', $dfd264e1e1b2e9bd$var$objectTag = '[object Object]', $dfd264e1e1b2e9bd$var$regexpTag = '[object RegExp]', $dfd264e1e1b2e9bd$var$setTag = '[object Set]', $dfd264e1e1b2e9bd$var$stringTag = '[object String]', $dfd264e1e1b2e9bd$var$weakMapTag = '[object WeakMap]';
var $dfd264e1e1b2e9bd$var$arrayBufferTag = '[object ArrayBuffer]', $dfd264e1e1b2e9bd$var$dataViewTag = '[object DataView]', $dfd264e1e1b2e9bd$var$float32Tag = '[object Float32Array]', $dfd264e1e1b2e9bd$var$float64Tag = '[object Float64Array]', $dfd264e1e1b2e9bd$var$int8Tag = '[object Int8Array]', $dfd264e1e1b2e9bd$var$int16Tag = '[object Int16Array]', $dfd264e1e1b2e9bd$var$int32Tag = '[object Int32Array]', $dfd264e1e1b2e9bd$var$uint8Tag = '[object Uint8Array]', $dfd264e1e1b2e9bd$var$uint8ClampedTag = '[object Uint8ClampedArray]', $dfd264e1e1b2e9bd$var$uint16Tag = '[object Uint16Array]', $dfd264e1e1b2e9bd$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $dfd264e1e1b2e9bd$var$typedArrayTags = {};
$dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$float32Tag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$float64Tag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$int8Tag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$int16Tag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$int32Tag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$uint8Tag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$uint8ClampedTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$uint16Tag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$uint32Tag] = true;
$dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$argsTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$arrayTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$arrayBufferTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$boolTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$dataViewTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$dateTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$errorTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$funcTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$mapTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$numberTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$objectTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$regexpTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$setTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$stringTag] = $dfd264e1e1b2e9bd$var$typedArrayTags[$dfd264e1e1b2e9bd$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $dfd264e1e1b2e9bd$var$baseIsTypedArray(value) {
    return $862d5c9ce5bfb845$exports(value) && $5420202956375f24$exports(value.length) && !!$dfd264e1e1b2e9bd$var$typedArrayTags[$4caad4bc3a782200$exports(value)];
}
$dfd264e1e1b2e9bd$exports = $dfd264e1e1b2e9bd$var$baseIsTypedArray;


var $0a4f31274eaa1170$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $0a4f31274eaa1170$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$0a4f31274eaa1170$exports = $0a4f31274eaa1170$var$baseUnary;



var $6wVNP = parcelRequire("6wVNP");
/* Node.js helper references. */ var $257777d773b0b95b$var$nodeIsTypedArray = $6wVNP && $6wVNP.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $257777d773b0b95b$var$isTypedArray = $257777d773b0b95b$var$nodeIsTypedArray ? $0a4f31274eaa1170$exports($257777d773b0b95b$var$nodeIsTypedArray) : $dfd264e1e1b2e9bd$exports;
$257777d773b0b95b$exports = $257777d773b0b95b$var$isTypedArray;


/** Used for built-in method references. */ var $600e185d53161fe9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $600e185d53161fe9$var$hasOwnProperty = $600e185d53161fe9$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $600e185d53161fe9$var$arrayLikeKeys(value, inherited) {
    var isArr = $df41e7dc5257abcb$exports(value), isArg = !isArr && $70cbfc6695bf6c02$exports(value), isBuff = !isArr && !isArg && $dDAvp(value), isType = !isArr && !isArg && !isBuff && $257777d773b0b95b$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $d29b4c69a20d83af$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $600e185d53161fe9$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ef51c2ce0f9192d4$exports(key, length)))) result.push(key);
    return result;
}
$600e185d53161fe9$exports = $600e185d53161fe9$var$arrayLikeKeys;


var $732f819b93a587f3$exports = {};
var $01a2aced29058b27$exports = {};
/** Used for built-in method references. */ var $01a2aced29058b27$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $01a2aced29058b27$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $01a2aced29058b27$var$objectProto;
    return value === proto;
}
$01a2aced29058b27$exports = $01a2aced29058b27$var$isPrototype;


var $cce18cd6f211394b$exports = {};
var $d285731b63f15206$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $d285731b63f15206$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$d285731b63f15206$exports = $d285731b63f15206$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $cce18cd6f211394b$var$nativeKeys = $d285731b63f15206$exports(Object.keys, Object);
$cce18cd6f211394b$exports = $cce18cd6f211394b$var$nativeKeys;


/** Used for built-in method references. */ var $732f819b93a587f3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $732f819b93a587f3$var$hasOwnProperty = $732f819b93a587f3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $732f819b93a587f3$var$baseKeys(object) {
    if (!$01a2aced29058b27$exports(object)) return $cce18cd6f211394b$exports(object);
    var result = [];
    for(var key in Object(object))if ($732f819b93a587f3$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$732f819b93a587f3$exports = $732f819b93a587f3$var$baseKeys;


var $a3e116769f9c8886$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $a3e116769f9c8886$var$isArrayLike(value) {
    return value != null && $5420202956375f24$exports(value.length) && !$27042e501e0294f8$exports(value);
}
$a3e116769f9c8886$exports = $a3e116769f9c8886$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $8b0ac38f8259c849$var$keys(object) {
    return $a3e116769f9c8886$exports(object) ? $600e185d53161fe9$exports(object) : $732f819b93a587f3$exports(object);
}
$8b0ac38f8259c849$exports = $8b0ac38f8259c849$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $96167778e03ba634$var$getAllKeys(object) {
    return $f7966e9168aa2161$exports(object, $8b0ac38f8259c849$exports, $6615cd71800a25c6$exports);
}
$96167778e03ba634$exports = $96167778e03ba634$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $b76663b5e56a7121$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $b76663b5e56a7121$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b76663b5e56a7121$var$hasOwnProperty = $b76663b5e56a7121$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b76663b5e56a7121$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b76663b5e56a7121$var$COMPARE_PARTIAL_FLAG, objProps = $96167778e03ba634$exports(object), objLength = objProps.length, othProps = $96167778e03ba634$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $b76663b5e56a7121$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$b76663b5e56a7121$exports = $b76663b5e56a7121$var$equalObjects;


var $827a088e1bbeebd5$exports = {};
var $0a700d5fc1371773$exports = {};


var $3KrFG = parcelRequire("3KrFG");
/* Built-in method references that are verified to be native. */ var $0a700d5fc1371773$var$DataView = $36fef8c2a5f648c9$exports($3KrFG, 'DataView');
$0a700d5fc1371773$exports = $0a700d5fc1371773$var$DataView;



var $b1b48dab69263b7f$exports = {};


var $3KrFG = parcelRequire("3KrFG");
/* Built-in method references that are verified to be native. */ var $b1b48dab69263b7f$var$Promise = $36fef8c2a5f648c9$exports($3KrFG, 'Promise');
$b1b48dab69263b7f$exports = $b1b48dab69263b7f$var$Promise;


var $b354218c0a1726db$exports = {};


var $3KrFG = parcelRequire("3KrFG");
/* Built-in method references that are verified to be native. */ var $b354218c0a1726db$var$Set = $36fef8c2a5f648c9$exports($3KrFG, 'Set');
$b354218c0a1726db$exports = $b354218c0a1726db$var$Set;


var $93924a1589b2ac11$exports = {};


var $3KrFG = parcelRequire("3KrFG");
/* Built-in method references that are verified to be native. */ var $93924a1589b2ac11$var$WeakMap = $36fef8c2a5f648c9$exports($3KrFG, 'WeakMap');
$93924a1589b2ac11$exports = $93924a1589b2ac11$var$WeakMap;




/** `Object#toString` result references. */ var $827a088e1bbeebd5$var$mapTag = '[object Map]', $827a088e1bbeebd5$var$objectTag = '[object Object]', $827a088e1bbeebd5$var$promiseTag = '[object Promise]', $827a088e1bbeebd5$var$setTag = '[object Set]', $827a088e1bbeebd5$var$weakMapTag = '[object WeakMap]';
var $827a088e1bbeebd5$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $827a088e1bbeebd5$var$dataViewCtorString = $9d7ef3a5c0cb7b1d$exports($0a700d5fc1371773$exports), $827a088e1bbeebd5$var$mapCtorString = $9d7ef3a5c0cb7b1d$exports($d67870a6ce92d1a2$exports), $827a088e1bbeebd5$var$promiseCtorString = $9d7ef3a5c0cb7b1d$exports($b1b48dab69263b7f$exports), $827a088e1bbeebd5$var$setCtorString = $9d7ef3a5c0cb7b1d$exports($b354218c0a1726db$exports), $827a088e1bbeebd5$var$weakMapCtorString = $9d7ef3a5c0cb7b1d$exports($93924a1589b2ac11$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $827a088e1bbeebd5$var$getTag = $4caad4bc3a782200$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($0a700d5fc1371773$exports && $827a088e1bbeebd5$var$getTag(new $0a700d5fc1371773$exports(new ArrayBuffer(1))) != $827a088e1bbeebd5$var$dataViewTag || $d67870a6ce92d1a2$exports && $827a088e1bbeebd5$var$getTag(new $d67870a6ce92d1a2$exports) != $827a088e1bbeebd5$var$mapTag || $b1b48dab69263b7f$exports && $827a088e1bbeebd5$var$getTag($b1b48dab69263b7f$exports.resolve()) != $827a088e1bbeebd5$var$promiseTag || $b354218c0a1726db$exports && $827a088e1bbeebd5$var$getTag(new $b354218c0a1726db$exports) != $827a088e1bbeebd5$var$setTag || $93924a1589b2ac11$exports && $827a088e1bbeebd5$var$getTag(new $93924a1589b2ac11$exports) != $827a088e1bbeebd5$var$weakMapTag) $827a088e1bbeebd5$var$getTag = function(value) {
    var result = $4caad4bc3a782200$exports(value), Ctor = result == $827a088e1bbeebd5$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9d7ef3a5c0cb7b1d$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $827a088e1bbeebd5$var$dataViewCtorString:
            return $827a088e1bbeebd5$var$dataViewTag;
        case $827a088e1bbeebd5$var$mapCtorString:
            return $827a088e1bbeebd5$var$mapTag;
        case $827a088e1bbeebd5$var$promiseCtorString:
            return $827a088e1bbeebd5$var$promiseTag;
        case $827a088e1bbeebd5$var$setCtorString:
            return $827a088e1bbeebd5$var$setTag;
        case $827a088e1bbeebd5$var$weakMapCtorString:
            return $827a088e1bbeebd5$var$weakMapTag;
    }
    return result;
};
$827a088e1bbeebd5$exports = $827a088e1bbeebd5$var$getTag;




var $dDAvp = parcelRequire("dDAvp");

/** Used to compose bitmasks for value comparisons. */ var $437808f12f09907e$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $437808f12f09907e$var$argsTag = '[object Arguments]', $437808f12f09907e$var$arrayTag = '[object Array]', $437808f12f09907e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $437808f12f09907e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $437808f12f09907e$var$hasOwnProperty = $437808f12f09907e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $437808f12f09907e$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $df41e7dc5257abcb$exports(object), othIsArr = $df41e7dc5257abcb$exports(other), objTag = objIsArr ? $437808f12f09907e$var$arrayTag : $827a088e1bbeebd5$exports(object), othTag = othIsArr ? $437808f12f09907e$var$arrayTag : $827a088e1bbeebd5$exports(other);
    objTag = objTag == $437808f12f09907e$var$argsTag ? $437808f12f09907e$var$objectTag : objTag;
    othTag = othTag == $437808f12f09907e$var$argsTag ? $437808f12f09907e$var$objectTag : othTag;
    var objIsObj = objTag == $437808f12f09907e$var$objectTag, othIsObj = othTag == $437808f12f09907e$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $dDAvp(object)) {
        if (!$dDAvp(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $7ae838d2ea346065$exports);
        return objIsArr || $257777d773b0b95b$exports(object) ? $a71a7b3d0d59172a$exports(object, other, bitmask, customizer, equalFunc, stack) : $3af9371c33bdef73$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $437808f12f09907e$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $437808f12f09907e$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $437808f12f09907e$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $7ae838d2ea346065$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $7ae838d2ea346065$exports);
    return $b76663b5e56a7121$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$437808f12f09907e$exports = $437808f12f09907e$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $eabb0f547dafe061$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$862d5c9ce5bfb845$exports(value) && !$862d5c9ce5bfb845$exports(other)) return value !== value && other !== other;
    return $437808f12f09907e$exports(value, other, bitmask, customizer, $eabb0f547dafe061$var$baseIsEqual, stack);
}
$eabb0f547dafe061$exports = $eabb0f547dafe061$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $6b42dee265745d0f$var$isEqual(value, other) {
    return $eabb0f547dafe061$exports(value, other);
}
$6b42dee265745d0f$exports = $6b42dee265745d0f$var$isEqual;


var $ad1dfe9d76fb957d$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $ad1dfe9d76fb957d$var$isNil(value) {
    return value == null;
}
$ad1dfe9d76fb957d$exports = $ad1dfe9d76fb957d$var$isNil;




var $axMmP = parcelRequire("axMmP");

var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");


var $e1a838f354cb0c85$exports = {};



/** `Object#toString` result references. */ var $e1a838f354cb0c85$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $e1a838f354cb0c85$var$isString(value) {
    return typeof value == 'string' || !$df41e7dc5257abcb$exports(value) && $862d5c9ce5bfb845$exports(value) && $4caad4bc3a782200$exports(value) == $e1a838f354cb0c85$var$stringTag;
}
$e1a838f354cb0c85$exports = $e1a838f354cb0c85$var$isString;





var $70fFQ = parcelRequire("70fFQ");
var $3bb4b056bcc3c4d9$exports = {};
'use strict';

$3bb4b056bcc3c4d9$exports = (parcelRequire("cXAH8"));



var $b26a90b73a77c867$exports = {};
var $65ad8e0b91275ff6$exports = {};


/** `Object#toString` result references. */ var $65ad8e0b91275ff6$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $65ad8e0b91275ff6$var$isNumber(value) {
    return typeof value == 'number' || $862d5c9ce5bfb845$exports(value) && $4caad4bc3a782200$exports(value) == $65ad8e0b91275ff6$var$numberTag;
}
$65ad8e0b91275ff6$exports = $65ad8e0b91275ff6$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $b26a90b73a77c867$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $65ad8e0b91275ff6$exports(value) && value != +value;
}
$b26a90b73a77c867$exports = $b26a90b73a77c867$var$isNaN;




var $453b3059df48aedd$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $453b3059df48aedd$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($e1a838f354cb0c85$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $453b3059df48aedd$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($65ad8e0b91275ff6$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($b26a90b73a77c867$exports)))(value);
};
var $453b3059df48aedd$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $453b3059df48aedd$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($e1a838f354cb0c85$exports)))(value);
};
var $453b3059df48aedd$var$idCounter = 0;
var $453b3059df48aedd$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$453b3059df48aedd$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $453b3059df48aedd$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$453b3059df48aedd$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($e1a838f354cb0c85$exports)))(percent)) return defaultValue;
    var value;
    if ($453b3059df48aedd$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b26a90b73a77c867$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $453b3059df48aedd$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $453b3059df48aedd$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $453b3059df48aedd$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($453b3059df48aedd$export$7e4aa119212bc614(numberA) && $453b3059df48aedd$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $453b3059df48aedd$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $453b3059df48aedd$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $924d4aaaa598a456$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $70fFQ = parcelRequire("70fFQ");

function $e11a437526851c08$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e11a437526851c08$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e11a437526851c08$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $e11a437526851c08$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $e11a437526851c08$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $e11a437526851c08$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $e11a437526851c08$export$2b22758266a6fa48 = {
    svg: $e11a437526851c08$var$SVGContainerPropKeys,
    polygon: $e11a437526851c08$var$PolyElementKeys,
    polyline: $e11a437526851c08$var$PolyElementKeys
};
var $e11a437526851c08$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $e11a437526851c08$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($b3d1e6aa1c534f86$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($e11a437526851c08$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $e11a437526851c08$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $e11a437526851c08$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($b3d1e6aa1c534f86$exports)))(props) || $e11a437526851c08$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($e11a437526851c08$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $e11a437526851c08$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $a56fb3d503224b01$var$_excluded = [
    "children"
], $a56fb3d503224b01$var$_excluded2 = [
    "children"
];
function $a56fb3d503224b01$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a56fb3d503224b01$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a56fb3d503224b01$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a56fb3d503224b01$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a56fb3d503224b01$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a56fb3d503224b01$var$_typeof(o);
}
var $a56fb3d503224b01$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart'
};
var $a56fb3d503224b01$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $a56fb3d503224b01$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $a56fb3d503224b01$export$59a4d7d024cf1025 = [
    'none'
];
var $a56fb3d503224b01$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $a56fb3d503224b01$var$lastChildren = null;
var $a56fb3d503224b01$var$lastResult = null;
var $a56fb3d503224b01$export$45b10814cc054894 = function toArray(children) {
    if (children === $a56fb3d503224b01$var$lastChildren && Array.isArray($a56fb3d503224b01$var$lastResult)) return $a56fb3d503224b01$var$lastResult;
    var result = [];
    (0, $70fFQ.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(child)) return;
        if ((0, $3bb4b056bcc3c4d9$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $a56fb3d503224b01$var$lastResult = result;
    $a56fb3d503224b01$var$lastChildren = children;
    return result;
};
function $a56fb3d503224b01$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $a56fb3d503224b01$export$be63e0664592e141(t);
    });
    else types = [
        $a56fb3d503224b01$export$be63e0664592e141(type)
    ];
    $a56fb3d503224b01$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $a56fb3d503224b01$export$64c61536a2b72e0f(children, type) {
    var result = $a56fb3d503224b01$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $a56fb3d503224b01$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $a56fb3d503224b01$export$be63e0664592e141(t);
    });
    else types = [
        $a56fb3d503224b01$export$be63e0664592e141(type)
    ];
    $a56fb3d503224b01$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $a56fb3d503224b01$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $453b3059df48aedd$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $a56fb3d503224b01$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $a56fb3d503224b01$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($e1a838f354cb0c85$exports)))(child.type) && $a56fb3d503224b01$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $a56fb3d503224b01$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $a56fb3d503224b01$var$_typeof(dot) === 'object' && 'cx' in dot && 'cy' in dot && 'r' in dot;
};
var $a56fb3d503224b01$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $e11a437526851c08$export$2b22758266a6fa48) === null || (0, $e11a437526851c08$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $e11a437526851c08$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $e11a437526851c08$export$190f430946f96110).includes(key)) || includeEvents && (0, $e11a437526851c08$export$f30789245f2c4d11).includes(key);
};
var $a56fb3d503224b01$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $a56fb3d503224b01$export$45b10814cc054894(children).forEach(function(entry) {
        if ($a56fb3d503224b01$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $a56fb3d503224b01$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($b3d1e6aa1c534f86$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($a56fb3d503224b01$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $a56fb3d503224b01$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $70fFQ.Children).count(nextChildren);
    if (count !== (0, $70fFQ.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $a56fb3d503224b01$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$a56fb3d503224b01$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $a56fb3d503224b01$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $a56fb3d503224b01$var$_objectWithoutProperties(_ref, $a56fb3d503224b01$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $a56fb3d503224b01$var$_objectWithoutProperties(_ref2, $a56fb3d503224b01$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $924d4aaaa598a456$export$d36bdfa510afb180)(nextProps, prevProps) && $a56fb3d503224b01$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $924d4aaaa598a456$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $a56fb3d503224b01$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $a56fb3d503224b01$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($a56fb3d503224b01$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $a56fb3d503224b01$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $a56fb3d503224b01$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $a56fb3d503224b01$var$REACT_BROWSER_EVENT_MAP[type]) return $a56fb3d503224b01$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $a56fb3d503224b01$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $a56fb3d503224b01$export$45b10814cc054894(children).indexOf(child);
};


var $5ac932a8929d0d57$var$_excluded = [
    "children",
    "className"
];
function $5ac932a8929d0d57$var$_extends() {
    $5ac932a8929d0d57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ac932a8929d0d57$var$_extends.apply(this, arguments);
}
function $5ac932a8929d0d57$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5ac932a8929d0d57$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5ac932a8929d0d57$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5ac932a8929d0d57$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $5ac932a8929d0d57$var$_objectWithoutProperties(props, $5ac932a8929d0d57$var$_excluded);
    var layerClass = (0, $axMmP.default)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", $5ac932a8929d0d57$var$_extends({
        className: layerClass
    }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $70fFQ = parcelRequire("70fFQ");
var $6893b2114d74c3a2$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$6893b2114d74c3a2$exports = (parcelRequire("lmnjA"));


var $274dcdc4ff8cf388$exports = {};
var $5db26964f57d3e69$exports = {};
var $cd3a3b6bd35ad104$exports = {};
var $2a5ae2efb5f49a17$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $2a5ae2efb5f49a17$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$2a5ae2efb5f49a17$exports = $2a5ae2efb5f49a17$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cd3a3b6bd35ad104$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $2a5ae2efb5f49a17$exports(array, start, end);
}
$cd3a3b6bd35ad104$exports = $cd3a3b6bd35ad104$var$castSlice;


var $e78ccf7d13d4c75f$exports = {};
/** Used to compose unicode character classes. */ var $e78ccf7d13d4c75f$var$rsAstralRange = '\\ud800-\\udfff', $e78ccf7d13d4c75f$var$rsComboMarksRange = '\\u0300-\\u036f', $e78ccf7d13d4c75f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $e78ccf7d13d4c75f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $e78ccf7d13d4c75f$var$rsComboRange = $e78ccf7d13d4c75f$var$rsComboMarksRange + $e78ccf7d13d4c75f$var$reComboHalfMarksRange + $e78ccf7d13d4c75f$var$rsComboSymbolsRange, $e78ccf7d13d4c75f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $e78ccf7d13d4c75f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $e78ccf7d13d4c75f$var$reHasUnicode = RegExp('[' + $e78ccf7d13d4c75f$var$rsZWJ + $e78ccf7d13d4c75f$var$rsAstralRange + $e78ccf7d13d4c75f$var$rsComboRange + $e78ccf7d13d4c75f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $e78ccf7d13d4c75f$var$hasUnicode(string) {
    return $e78ccf7d13d4c75f$var$reHasUnicode.test(string);
}
$e78ccf7d13d4c75f$exports = $e78ccf7d13d4c75f$var$hasUnicode;


var $9c4e5334a9b9b89d$exports = {};
var $2899b282900de4c2$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2899b282900de4c2$var$asciiToArray(string) {
    return string.split('');
}
$2899b282900de4c2$exports = $2899b282900de4c2$var$asciiToArray;



var $337485990290f9c1$exports = {};
/** Used to compose unicode character classes. */ var $337485990290f9c1$var$rsAstralRange = '\\ud800-\\udfff', $337485990290f9c1$var$rsComboMarksRange = '\\u0300-\\u036f', $337485990290f9c1$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $337485990290f9c1$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $337485990290f9c1$var$rsComboRange = $337485990290f9c1$var$rsComboMarksRange + $337485990290f9c1$var$reComboHalfMarksRange + $337485990290f9c1$var$rsComboSymbolsRange, $337485990290f9c1$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $337485990290f9c1$var$rsAstral = '[' + $337485990290f9c1$var$rsAstralRange + ']', $337485990290f9c1$var$rsCombo = '[' + $337485990290f9c1$var$rsComboRange + ']', $337485990290f9c1$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $337485990290f9c1$var$rsModifier = '(?:' + $337485990290f9c1$var$rsCombo + '|' + $337485990290f9c1$var$rsFitz + ')', $337485990290f9c1$var$rsNonAstral = '[^' + $337485990290f9c1$var$rsAstralRange + ']', $337485990290f9c1$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $337485990290f9c1$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $337485990290f9c1$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $337485990290f9c1$var$reOptMod = $337485990290f9c1$var$rsModifier + '?', $337485990290f9c1$var$rsOptVar = '[' + $337485990290f9c1$var$rsVarRange + ']?', $337485990290f9c1$var$rsOptJoin = '(?:' + $337485990290f9c1$var$rsZWJ + '(?:' + [
    $337485990290f9c1$var$rsNonAstral,
    $337485990290f9c1$var$rsRegional,
    $337485990290f9c1$var$rsSurrPair
].join('|') + ')' + $337485990290f9c1$var$rsOptVar + $337485990290f9c1$var$reOptMod + ')*', $337485990290f9c1$var$rsSeq = $337485990290f9c1$var$rsOptVar + $337485990290f9c1$var$reOptMod + $337485990290f9c1$var$rsOptJoin, $337485990290f9c1$var$rsSymbol = '(?:' + [
    $337485990290f9c1$var$rsNonAstral + $337485990290f9c1$var$rsCombo + '?',
    $337485990290f9c1$var$rsCombo,
    $337485990290f9c1$var$rsRegional,
    $337485990290f9c1$var$rsSurrPair,
    $337485990290f9c1$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $337485990290f9c1$var$reUnicode = RegExp($337485990290f9c1$var$rsFitz + '(?=' + $337485990290f9c1$var$rsFitz + ')|' + $337485990290f9c1$var$rsSymbol + $337485990290f9c1$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $337485990290f9c1$var$unicodeToArray(string) {
    return string.match($337485990290f9c1$var$reUnicode) || [];
}
$337485990290f9c1$exports = $337485990290f9c1$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9c4e5334a9b9b89d$var$stringToArray(string) {
    return $e78ccf7d13d4c75f$exports(string) ? $337485990290f9c1$exports(string) : $2899b282900de4c2$exports(string);
}
$9c4e5334a9b9b89d$exports = $9c4e5334a9b9b89d$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $5db26964f57d3e69$var$createCaseFirst(methodName) {
    return function(string) {
        string = $023873f58349031a$exports(string);
        var strSymbols = $e78ccf7d13d4c75f$exports(string) ? $9c4e5334a9b9b89d$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cd3a3b6bd35ad104$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$5db26964f57d3e69$exports = $5db26964f57d3e69$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $274dcdc4ff8cf388$var$upperFirst = $5db26964f57d3e69$exports('toUpperCase');
$274dcdc4ff8cf388$exports = $274dcdc4ff8cf388$var$upperFirst;




var $axMmP = parcelRequire("axMmP");



function $eb73f5e7cf78fb38$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eb73f5e7cf78fb38$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eb73f5e7cf78fb38$var$_typeof(o);
}
function $eb73f5e7cf78fb38$var$_extends() {
    $eb73f5e7cf78fb38$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eb73f5e7cf78fb38$var$_extends.apply(this, arguments);
}
function $eb73f5e7cf78fb38$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb73f5e7cf78fb38$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb73f5e7cf78fb38$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eb73f5e7cf78fb38$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb73f5e7cf78fb38$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eb73f5e7cf78fb38$var$_defineProperty(obj, key, value) {
    key = $eb73f5e7cf78fb38$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eb73f5e7cf78fb38$var$_toPropertyKey(t) {
    var i = $eb73f5e7cf78fb38$var$_toPrimitive(t, "string");
    return "symbol" == $eb73f5e7cf78fb38$var$_typeof(i) ? i : String(i);
}
function $eb73f5e7cf78fb38$var$_toPrimitive(t, r) {
    if ("object" != $eb73f5e7cf78fb38$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $eb73f5e7cf78fb38$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $eb73f5e7cf78fb38$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $6893b2114d74c3a2$exports.curveBasisClosed),
    curveBasisOpen: (0, $6893b2114d74c3a2$exports.curveBasisOpen),
    curveBasis: (0, $6893b2114d74c3a2$exports.curveBasis),
    curveBumpX: (0, $6893b2114d74c3a2$exports.curveBumpX),
    curveBumpY: (0, $6893b2114d74c3a2$exports.curveBumpY),
    curveLinearClosed: (0, $6893b2114d74c3a2$exports.curveLinearClosed),
    curveLinear: (0, $6893b2114d74c3a2$exports.curveLinear),
    curveMonotoneX: (0, $6893b2114d74c3a2$exports.curveMonotoneX),
    curveMonotoneY: (0, $6893b2114d74c3a2$exports.curveMonotoneY),
    curveNatural: (0, $6893b2114d74c3a2$exports.curveNatural),
    curveStep: (0, $6893b2114d74c3a2$exports.curveStep),
    curveStepAfter: (0, $6893b2114d74c3a2$exports.curveStepAfter),
    curveStepBefore: (0, $6893b2114d74c3a2$exports.curveStepBefore)
};
var $eb73f5e7cf78fb38$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $eb73f5e7cf78fb38$var$getX = function getX(p) {
    return p.x;
};
var $eb73f5e7cf78fb38$var$getY = function getY(p) {
    return p.y;
};
var $eb73f5e7cf78fb38$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($274dcdc4ff8cf388$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $eb73f5e7cf78fb38$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $eb73f5e7cf78fb38$var$CURVE_FACTORIES[name] || (0, $6893b2114d74c3a2$exports.curveLinear);
};
var $eb73f5e7cf78fb38$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $eb73f5e7cf78fb38$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $eb73f5e7cf78fb38$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $eb73f5e7cf78fb38$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $eb73f5e7cf78fb38$var$_objectSpread($eb73f5e7cf78fb38$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $6893b2114d74c3a2$exports.area)().y($eb73f5e7cf78fb38$var$getY).x1($eb73f5e7cf78fb38$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $6893b2114d74c3a2$exports.area)().x($eb73f5e7cf78fb38$var$getX).y1($eb73f5e7cf78fb38$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($eb73f5e7cf78fb38$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $453b3059df48aedd$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $6893b2114d74c3a2$exports.area)().y($eb73f5e7cf78fb38$var$getY).x1($eb73f5e7cf78fb38$var$getX).x0(baseLine);
    else if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $6893b2114d74c3a2$exports.area)().x($eb73f5e7cf78fb38$var$getX).y1($eb73f5e7cf78fb38$var$getY).y0(baseLine);
    else lineFunction = (0, $6893b2114d74c3a2$exports.line)().x($eb73f5e7cf78fb38$var$getX).y($eb73f5e7cf78fb38$var$getY);
    lineFunction.defined($eb73f5e7cf78fb38$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $eb73f5e7cf78fb38$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $eb73f5e7cf78fb38$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, false), (0, $e11a437526851c08$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $axMmP.default)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $70fFQ = parcelRequire("70fFQ");


var $axMmP = parcelRequire("axMmP");

var $9d05d8035ca0d2c9$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $9d05d8035ca0d2c9$export$98f03c5d19621d70 = {
    isSsr: $9d05d8035ca0d2c9$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $9d05d8035ca0d2c9$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $9d05d8035ca0d2c9$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $9d05d8035ca0d2c9$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $14ab4f4cd331f2e9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $14ab4f4cd331f2e9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $14ab4f4cd331f2e9$var$_typeof(o);
}
function $14ab4f4cd331f2e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14ab4f4cd331f2e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14ab4f4cd331f2e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $14ab4f4cd331f2e9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14ab4f4cd331f2e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14ab4f4cd331f2e9$var$_defineProperty(obj, key, value) {
    key = $14ab4f4cd331f2e9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $14ab4f4cd331f2e9$var$_toPropertyKey(t) {
    var i = $14ab4f4cd331f2e9$var$_toPrimitive(t, "string");
    return "symbol" == $14ab4f4cd331f2e9$var$_typeof(i) ? i : String(i);
}
function $14ab4f4cd331f2e9$var$_toPrimitive(t, r) {
    if ("object" != $14ab4f4cd331f2e9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $14ab4f4cd331f2e9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $14ab4f4cd331f2e9$var$_toConsumableArray(arr) {
    return $14ab4f4cd331f2e9$var$_arrayWithoutHoles(arr) || $14ab4f4cd331f2e9$var$_iterableToArray(arr) || $14ab4f4cd331f2e9$var$_unsupportedIterableToArray(arr) || $14ab4f4cd331f2e9$var$_nonIterableSpread();
}
function $14ab4f4cd331f2e9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $14ab4f4cd331f2e9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $14ab4f4cd331f2e9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $14ab4f4cd331f2e9$var$_arrayLikeToArray(o, minLen);
}
function $14ab4f4cd331f2e9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $14ab4f4cd331f2e9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $14ab4f4cd331f2e9$var$_arrayLikeToArray(arr);
}
function $14ab4f4cd331f2e9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $14ab4f4cd331f2e9$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $14ab4f4cd331f2e9$var$MAX_CACHE_NUM = 2000;
var $14ab4f4cd331f2e9$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $14ab4f4cd331f2e9$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $14ab4f4cd331f2e9$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $14ab4f4cd331f2e9$var$autoCompleteStyle(name, value) {
    if ($14ab4f4cd331f2e9$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $14ab4f4cd331f2e9$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($14ab4f4cd331f2e9$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($14ab4f4cd331f2e9$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $14ab4f4cd331f2e9$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($14ab4f4cd331f2e9$var$camelToMiddleLine(s), ":").concat($14ab4f4cd331f2e9$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $14ab4f4cd331f2e9$var$removeInvalidKeys(obj) {
    var copyObj = $14ab4f4cd331f2e9$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $14ab4f4cd331f2e9$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $14ab4f4cd331f2e9$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($14ab4f4cd331f2e9$var$stringCache.widthCache[cacheKey]) return $14ab4f4cd331f2e9$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($14ab4f4cd331f2e9$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $14ab4f4cd331f2e9$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $14ab4f4cd331f2e9$var$_objectSpread($14ab4f4cd331f2e9$var$_objectSpread({}, $14ab4f4cd331f2e9$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $14ab4f4cd331f2e9$var$stringCache.widthCache[cacheKey] = result;
        if (++$14ab4f4cd331f2e9$var$stringCache.cacheCount > $14ab4f4cd331f2e9$var$MAX_CACHE_NUM) {
            $14ab4f4cd331f2e9$var$stringCache.cacheCount = 0;
            $14ab4f4cd331f2e9$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $14ab4f4cd331f2e9$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $4a9a9909e7cf1f6b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4a9a9909e7cf1f6b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4a9a9909e7cf1f6b$var$_typeof(o);
}
function $4a9a9909e7cf1f6b$var$_slicedToArray(arr, i) {
    return $4a9a9909e7cf1f6b$var$_arrayWithHoles(arr) || $4a9a9909e7cf1f6b$var$_iterableToArrayLimit(arr, i) || $4a9a9909e7cf1f6b$var$_unsupportedIterableToArray(arr, i) || $4a9a9909e7cf1f6b$var$_nonIterableRest();
}
function $4a9a9909e7cf1f6b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4a9a9909e7cf1f6b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4a9a9909e7cf1f6b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4a9a9909e7cf1f6b$var$_arrayLikeToArray(o, minLen);
}
function $4a9a9909e7cf1f6b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4a9a9909e7cf1f6b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4a9a9909e7cf1f6b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4a9a9909e7cf1f6b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4a9a9909e7cf1f6b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4a9a9909e7cf1f6b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4a9a9909e7cf1f6b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4a9a9909e7cf1f6b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4a9a9909e7cf1f6b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4a9a9909e7cf1f6b$var$_toPropertyKey(t) {
    var i = $4a9a9909e7cf1f6b$var$_toPrimitive(t, "string");
    return "symbol" == $4a9a9909e7cf1f6b$var$_typeof(i) ? i : String(i);
}
function $4a9a9909e7cf1f6b$var$_toPrimitive(t, r) {
    if ("object" != $4a9a9909e7cf1f6b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4a9a9909e7cf1f6b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4a9a9909e7cf1f6b$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $4a9a9909e7cf1f6b$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $4a9a9909e7cf1f6b$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $4a9a9909e7cf1f6b$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $4a9a9909e7cf1f6b$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $4a9a9909e7cf1f6b$var$FIXED_CSS_LENGTH_UNITS = Object.keys($4a9a9909e7cf1f6b$var$CONVERSION_RATES);
var $4a9a9909e7cf1f6b$var$STR_NAN = 'NaN';
function $4a9a9909e7cf1f6b$var$convertToPx(value, unit) {
    return value * $4a9a9909e7cf1f6b$var$CONVERSION_RATES[unit];
}
var $4a9a9909e7cf1f6b$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $4a9a9909e7cf1f6b$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$4a9a9909e7cf1f6b$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($4a9a9909e7cf1f6b$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $4a9a9909e7cf1f6b$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    $4a9a9909e7cf1f6b$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $4a9a9909e7cf1f6b$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $4a9a9909e7cf1f6b$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
    return DecimalCSS;
}();
function $4a9a9909e7cf1f6b$var$calculateArithmetic(expr) {
    if (expr.includes($4a9a9909e7cf1f6b$var$STR_NAN)) return $4a9a9909e7cf1f6b$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $4a9a9909e7cf1f6b$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $4a9a9909e7cf1f6b$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $4a9a9909e7cf1f6b$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $4a9a9909e7cf1f6b$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $4a9a9909e7cf1f6b$var$STR_NAN;
        newExpr = newExpr.replace($4a9a9909e7cf1f6b$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $4a9a9909e7cf1f6b$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $4a9a9909e7cf1f6b$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $4a9a9909e7cf1f6b$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $4a9a9909e7cf1f6b$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $4a9a9909e7cf1f6b$var$STR_NAN;
        newExpr = newExpr.replace($4a9a9909e7cf1f6b$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $4a9a9909e7cf1f6b$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $4a9a9909e7cf1f6b$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $4a9a9909e7cf1f6b$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $4a9a9909e7cf1f6b$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($4a9a9909e7cf1f6b$var$PARENTHESES_REGEX, $4a9a9909e7cf1f6b$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $4a9a9909e7cf1f6b$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $4a9a9909e7cf1f6b$var$calculateParentheses(newExpr);
    newExpr = $4a9a9909e7cf1f6b$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $4a9a9909e7cf1f6b$export$c891f73c9c6d00c9(expression) {
    try {
        return $4a9a9909e7cf1f6b$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $4a9a9909e7cf1f6b$var$STR_NAN;
    }
}
function $4a9a9909e7cf1f6b$export$254eac204f89fd7d(expression) {
    var result = $4a9a9909e7cf1f6b$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $4a9a9909e7cf1f6b$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $f01a70744931f940$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $f01a70744931f940$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $f01a70744931f940$var$_extends() {
    $f01a70744931f940$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f01a70744931f940$var$_extends.apply(this, arguments);
}
function $f01a70744931f940$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f01a70744931f940$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f01a70744931f940$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f01a70744931f940$var$_slicedToArray(arr, i) {
    return $f01a70744931f940$var$_arrayWithHoles(arr) || $f01a70744931f940$var$_iterableToArrayLimit(arr, i) || $f01a70744931f940$var$_unsupportedIterableToArray(arr, i) || $f01a70744931f940$var$_nonIterableRest();
}
function $f01a70744931f940$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f01a70744931f940$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f01a70744931f940$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f01a70744931f940$var$_arrayLikeToArray(o, minLen);
}
function $f01a70744931f940$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f01a70744931f940$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f01a70744931f940$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f01a70744931f940$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $f01a70744931f940$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($f01a70744931f940$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $14ab4f4cd331f2e9$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $14ab4f4cd331f2e9$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $f01a70744931f940$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $453b3059df48aedd$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $f01a70744931f940$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $f01a70744931f940$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $f01a70744931f940$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $f01a70744931f940$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(children) ? children.toString().split($f01a70744931f940$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $f01a70744931f940$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $f01a70744931f940$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $f01a70744931f940$var$getWordsWithoutCalculate(children);
        return $f01a70744931f940$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $f01a70744931f940$var$getWordsWithoutCalculate(children);
};
var $f01a70744931f940$var$DEFAULT_FILL = '#808080';
var $f01a70744931f940$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $f01a70744931f940$var$DEFAULT_FILL : _ref5$fill, props = $f01a70744931f940$var$_objectWithoutProperties(_ref5, $f01a70744931f940$var$_excluded);
    var wordsByLines = (0, $70fFQ.useMemo)(function() {
        return $f01a70744931f940$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $f01a70744931f940$var$_objectWithoutProperties(props, $f01a70744931f940$var$_excluded2);
    if (!(0, $453b3059df48aedd$export$402a499e1ea44294)(propsX) || !(0, $453b3059df48aedd$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $453b3059df48aedd$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $453b3059df48aedd$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $4a9a9909e7cf1f6b$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $4a9a9909e7cf1f6b$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $4a9a9909e7cf1f6b$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $453b3059df48aedd$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("text", $f01a70744931f940$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $axMmP.default)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $f01a70744931f940$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: words
        }, words);
    }));
};



var $70fFQ = parcelRequire("70fFQ");




var $axMmP = parcelRequire("axMmP");





var $70fFQ = parcelRequire("70fFQ");


var $0976c92ed4d25575$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$0976c92ed4d25575$exports = (parcelRequire("3hNZR"));



var $cf55e66df9391434$exports = {};
var $3b150f889b608e27$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $3b150f889b608e27$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$383d33c6e13780df$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$3b150f889b608e27$exports = $3b150f889b608e27$var$baseExtremum;


var $0ef548784951ddf1$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $0ef548784951ddf1$var$baseGt(value, other) {
    return value > other;
}
$0ef548784951ddf1$exports = $0ef548784951ddf1$var$baseGt;


var $d0de2540b01c794a$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d0de2540b01c794a$var$identity(value) {
    return value;
}
$d0de2540b01c794a$exports = $d0de2540b01c794a$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $cf55e66df9391434$var$max(array) {
    return array && array.length ? $3b150f889b608e27$exports(array, $d0de2540b01c794a$exports, $0ef548784951ddf1$exports) : undefined;
}
$cf55e66df9391434$exports = $cf55e66df9391434$var$max;


var $5faa772a70839d2c$exports = {};

var $c1afed27cfddf2ec$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $c1afed27cfddf2ec$var$baseLt(value, other) {
    return value < other;
}
$c1afed27cfddf2ec$exports = $c1afed27cfddf2ec$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $5faa772a70839d2c$var$min(array) {
    return array && array.length ? $3b150f889b608e27$exports(array, $d0de2540b01c794a$exports, $c1afed27cfddf2ec$exports) : undefined;
}
$5faa772a70839d2c$exports = $5faa772a70839d2c$var$min;






var $5bace4c68bf572de$exports = {};
var $1cd241fd53d76830$exports = {};

var $5bcb62b83ada49db$exports = {};



/** Built-in value references. */ var $5bcb62b83ada49db$var$spreadableSymbol = $07e8d33a12bd76c2$exports ? $07e8d33a12bd76c2$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $5bcb62b83ada49db$var$isFlattenable(value) {
    return $df41e7dc5257abcb$exports(value) || $70cbfc6695bf6c02$exports(value) || !!($5bcb62b83ada49db$var$spreadableSymbol && value && value[$5bcb62b83ada49db$var$spreadableSymbol]);
}
$5bcb62b83ada49db$exports = $5bcb62b83ada49db$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $1cd241fd53d76830$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $5bcb62b83ada49db$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $1cd241fd53d76830$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $422598f9fec7430c$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$1cd241fd53d76830$exports = $1cd241fd53d76830$var$baseFlatten;


var $20d1d6078369c63f$exports = {};

var $1316a39af77ac4e6$exports = {};
var $3458801529aa0efd$exports = {};
var $c3fcb49d6ad36de0$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $c3fcb49d6ad36de0$var$COMPARE_PARTIAL_FLAG = 1, $c3fcb49d6ad36de0$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $c3fcb49d6ad36de0$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $7ae838d2ea346065$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $eabb0f547dafe061$exports(srcValue, objValue, $c3fcb49d6ad36de0$var$COMPARE_PARTIAL_FLAG | $c3fcb49d6ad36de0$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$c3fcb49d6ad36de0$exports = $c3fcb49d6ad36de0$var$baseIsMatch;


var $bd850d60c24f4c5e$exports = {};
var $40a496f54928a62b$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $40a496f54928a62b$var$isStrictComparable(value) {
    return value === value && !$b3d1e6aa1c534f86$exports(value);
}
$40a496f54928a62b$exports = $40a496f54928a62b$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $bd850d60c24f4c5e$var$getMatchData(object) {
    var result = $8b0ac38f8259c849$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $40a496f54928a62b$exports(value)
        ];
    }
    return result;
}
$bd850d60c24f4c5e$exports = $bd850d60c24f4c5e$var$getMatchData;


var $b2126f84f4b42bc9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b2126f84f4b42bc9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$b2126f84f4b42bc9$exports = $b2126f84f4b42bc9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $3458801529aa0efd$var$baseMatches(source) {
    var matchData = $bd850d60c24f4c5e$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $b2126f84f4b42bc9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $c3fcb49d6ad36de0$exports(object, source, matchData);
    };
}
$3458801529aa0efd$exports = $3458801529aa0efd$var$baseMatches;


var $4e60662b6d7fa78d$exports = {};


var $2fe5ed617142fb73$exports = {};
var $9c6d7a956528abe6$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $9c6d7a956528abe6$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$9c6d7a956528abe6$exports = $9c6d7a956528abe6$var$baseHasIn;


var $29adc89dc8674ef0$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $29adc89dc8674ef0$var$hasPath(object, path, hasFunc) {
    path = $1001bcd844d108ba$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $e299d21966deff9d$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5420202956375f24$exports(length) && $ef51c2ce0f9192d4$exports(key, length) && ($df41e7dc5257abcb$exports(object) || $70cbfc6695bf6c02$exports(object));
}
$29adc89dc8674ef0$exports = $29adc89dc8674ef0$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $2fe5ed617142fb73$var$hasIn(object, path) {
    return object != null && $29adc89dc8674ef0$exports(object, path, $9c6d7a956528abe6$exports);
}
$2fe5ed617142fb73$exports = $2fe5ed617142fb73$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $4e60662b6d7fa78d$var$COMPARE_PARTIAL_FLAG = 1, $4e60662b6d7fa78d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $4e60662b6d7fa78d$var$baseMatchesProperty(path, srcValue) {
    if ($32563463197471a3$exports(path) && $40a496f54928a62b$exports(srcValue)) return $b2126f84f4b42bc9$exports($e299d21966deff9d$exports(path), srcValue);
    return function(object) {
        var objValue = $fc063f47c858524d$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $2fe5ed617142fb73$exports(object, path) : $eabb0f547dafe061$exports(srcValue, objValue, $4e60662b6d7fa78d$var$COMPARE_PARTIAL_FLAG | $4e60662b6d7fa78d$var$COMPARE_UNORDERED_FLAG);
    };
}
$4e60662b6d7fa78d$exports = $4e60662b6d7fa78d$var$baseMatchesProperty;




var $c7602ddbfa9af164$exports = {};
var $1e2628a010f5fae3$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $1e2628a010f5fae3$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$1e2628a010f5fae3$exports = $1e2628a010f5fae3$var$baseProperty;


var $a6d9b3f9a7654b08$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a6d9b3f9a7654b08$var$basePropertyDeep(path) {
    return function(object) {
        return $4efc1e893078bbf0$exports(object, path);
    };
}
$a6d9b3f9a7654b08$exports = $a6d9b3f9a7654b08$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $c7602ddbfa9af164$var$property(path) {
    return $32563463197471a3$exports(path) ? $1e2628a010f5fae3$exports($e299d21966deff9d$exports(path)) : $a6d9b3f9a7654b08$exports(path);
}
$c7602ddbfa9af164$exports = $c7602ddbfa9af164$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $1316a39af77ac4e6$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $d0de2540b01c794a$exports;
    if (typeof value == 'object') return $df41e7dc5257abcb$exports(value) ? $4e60662b6d7fa78d$exports(value[0], value[1]) : $3458801529aa0efd$exports(value);
    return $c7602ddbfa9af164$exports(value);
}
$1316a39af77ac4e6$exports = $1316a39af77ac4e6$var$baseIteratee;


var $ae1ebea36a8b53b3$exports = {};
var $7a7a9c233f315af2$exports = {};
var $6e0b37a4a8b8a230$exports = {};
var $fb5dd6a7a6a3ff88$exports = {};
var $8f0e20a46ae5a655$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $8f0e20a46ae5a655$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$8f0e20a46ae5a655$exports = $8f0e20a46ae5a655$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $fb5dd6a7a6a3ff88$var$baseFor = $8f0e20a46ae5a655$exports();
$fb5dd6a7a6a3ff88$exports = $fb5dd6a7a6a3ff88$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $6e0b37a4a8b8a230$var$baseForOwn(object, iteratee) {
    return object && $fb5dd6a7a6a3ff88$exports(object, iteratee, $8b0ac38f8259c849$exports);
}
$6e0b37a4a8b8a230$exports = $6e0b37a4a8b8a230$var$baseForOwn;


var $39e9df9799024c4d$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $39e9df9799024c4d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$a3e116769f9c8886$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$39e9df9799024c4d$exports = $39e9df9799024c4d$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $7a7a9c233f315af2$var$baseEach = $39e9df9799024c4d$exports($6e0b37a4a8b8a230$exports);
$7a7a9c233f315af2$exports = $7a7a9c233f315af2$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $ae1ebea36a8b53b3$var$baseMap(collection, iteratee) {
    var index = -1, result = $a3e116769f9c8886$exports(collection) ? Array(collection.length) : [];
    $7a7a9c233f315af2$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$ae1ebea36a8b53b3$exports = $ae1ebea36a8b53b3$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $20d1d6078369c63f$var$map(collection, iteratee) {
    var func = $df41e7dc5257abcb$exports(collection) ? $30dd2768a5448b60$exports : $ae1ebea36a8b53b3$exports;
    return func(collection, $1316a39af77ac4e6$exports(iteratee, 3));
}
$20d1d6078369c63f$exports = $20d1d6078369c63f$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $5bace4c68bf572de$var$flatMap(collection, iteratee) {
    return $1cd241fd53d76830$exports($20d1d6078369c63f$exports(collection, iteratee), 1);
}
$5bace4c68bf572de$exports = $5bace4c68bf572de$var$flatMap;





var $f30c977dfc6b9355$exports = {};

var $af07f7df76897339$exports = {};




var $bfcadedd18dffff3$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $bfcadedd18dffff3$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$bfcadedd18dffff3$exports = $bfcadedd18dffff3$var$baseSortBy;



var $a425c1168e6a9781$exports = {};
var $d7af14f2c98ce236$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $d7af14f2c98ce236$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $383d33c6e13780df$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $383d33c6e13780df$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$d7af14f2c98ce236$exports = $d7af14f2c98ce236$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $a425c1168e6a9781$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $d7af14f2c98ce236$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$a425c1168e6a9781$exports = $a425c1168e6a9781$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $af07f7df76897339$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $30dd2768a5448b60$exports(iteratees, function(iteratee) {
        if ($df41e7dc5257abcb$exports(iteratee)) return function(value) {
            return $4efc1e893078bbf0$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d0de2540b01c794a$exports
    ];
    var index = -1;
    iteratees = $30dd2768a5448b60$exports(iteratees, $0a4f31274eaa1170$exports($1316a39af77ac4e6$exports));
    var result = $ae1ebea36a8b53b3$exports(collection, function(value, key, collection) {
        var criteria = $30dd2768a5448b60$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $bfcadedd18dffff3$exports(result, function(object, other) {
        return $a425c1168e6a9781$exports(object, other, orders);
    });
}
$af07f7df76897339$exports = $af07f7df76897339$var$baseOrderBy;


var $dff7f960f44ec62d$exports = {};

var $052a1d21cec8b607$exports = {};
var $31dbf998eac724db$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $31dbf998eac724db$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$31dbf998eac724db$exports = $31dbf998eac724db$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $052a1d21cec8b607$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $052a1d21cec8b607$var$overRest(func, start, transform) {
    start = $052a1d21cec8b607$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $052a1d21cec8b607$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $31dbf998eac724db$exports(func, this, otherArgs);
    };
}
$052a1d21cec8b607$exports = $052a1d21cec8b607$var$overRest;


var $c3b4f37afb1dc922$exports = {};
var $2bbad04eb3df3ca8$exports = {};
var $67f249a34161ff7c$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $67f249a34161ff7c$var$constant(value) {
    return function() {
        return value;
    };
}
$67f249a34161ff7c$exports = $67f249a34161ff7c$var$constant;


var $9fe91ffd91812deb$exports = {};

var $9fe91ffd91812deb$var$defineProperty = function() {
    try {
        var func = $36fef8c2a5f648c9$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$9fe91ffd91812deb$exports = $9fe91ffd91812deb$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $2bbad04eb3df3ca8$var$baseSetToString = !$9fe91ffd91812deb$exports ? $d0de2540b01c794a$exports : function(func, string) {
    return $9fe91ffd91812deb$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $67f249a34161ff7c$exports(string),
        'writable': true
    });
};
$2bbad04eb3df3ca8$exports = $2bbad04eb3df3ca8$var$baseSetToString;


var $ab175197080f4e5a$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ab175197080f4e5a$var$HOT_COUNT = 800, $ab175197080f4e5a$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ab175197080f4e5a$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ab175197080f4e5a$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ab175197080f4e5a$var$nativeNow(), remaining = $ab175197080f4e5a$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ab175197080f4e5a$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$ab175197080f4e5a$exports = $ab175197080f4e5a$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $c3b4f37afb1dc922$var$setToString = $ab175197080f4e5a$exports($2bbad04eb3df3ca8$exports);
$c3b4f37afb1dc922$exports = $c3b4f37afb1dc922$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $dff7f960f44ec62d$var$baseRest(func, start) {
    return $c3b4f37afb1dc922$exports($052a1d21cec8b607$exports(func, start, $d0de2540b01c794a$exports), func + '');
}
$dff7f960f44ec62d$exports = $dff7f960f44ec62d$var$baseRest;


var $8d786ecf76c18222$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $8d786ecf76c18222$var$isIterateeCall(value, index, object) {
    if (!$b3d1e6aa1c534f86$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $a3e116769f9c8886$exports(object) && $ef51c2ce0f9192d4$exports(index, object.length) : type == 'string' && index in object) return $c48233b0642b0c67$exports(object[index], value);
    return false;
}
$8d786ecf76c18222$exports = $8d786ecf76c18222$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $f30c977dfc6b9355$var$sortBy = $dff7f960f44ec62d$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $8d786ecf76c18222$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $8d786ecf76c18222$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $af07f7df76897339$exports(collection, $1cd241fd53d76830$exports(iteratees, 1), []);
});
$f30c977dfc6b9355$exports = $f30c977dfc6b9355$var$sortBy;


var $c9ea4366e124976a$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($c9ea4366e124976a$exports) $c9ea4366e124976a$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($c9ea4366e124976a$exports);


function $ffe938d875ae7f8d$var$_toConsumableArray(arr) {
    return $ffe938d875ae7f8d$var$_arrayWithoutHoles(arr) || $ffe938d875ae7f8d$var$_iterableToArray(arr) || $ffe938d875ae7f8d$var$_unsupportedIterableToArray(arr) || $ffe938d875ae7f8d$var$_nonIterableSpread();
}
function $ffe938d875ae7f8d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ffe938d875ae7f8d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ffe938d875ae7f8d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ffe938d875ae7f8d$var$_arrayLikeToArray(o, minLen);
}
function $ffe938d875ae7f8d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $ffe938d875ae7f8d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ffe938d875ae7f8d$var$_arrayLikeToArray(arr);
}
function $ffe938d875ae7f8d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ffe938d875ae7f8d$var$identity = function identity(i) {
    return i;
};
var $ffe938d875ae7f8d$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $ffe938d875ae7f8d$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $ffe938d875ae7f8d$export$ca73b6d700d0505;
};
var $ffe938d875ae7f8d$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $ffe938d875ae7f8d$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $ffe938d875ae7f8d$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $ffe938d875ae7f8d$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $ffe938d875ae7f8d$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $ffe938d875ae7f8d$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $ffe938d875ae7f8d$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $ffe938d875ae7f8d$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $ffe938d875ae7f8d$export$c3095a23b368d1f2 = function curry(fn) {
    return $ffe938d875ae7f8d$var$curryN(fn.length, fn);
};
var $ffe938d875ae7f8d$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $ffe938d875ae7f8d$export$871de8747c9eaa88 = $ffe938d875ae7f8d$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $ffe938d875ae7f8d$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $ffe938d875ae7f8d$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $ffe938d875ae7f8d$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $ffe938d875ae7f8d$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $50c3e7540b2002ce$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $50c3e7540b2002ce$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $50c3e7540b2002ce$var$interpolateNumber = (0, $ffe938d875ae7f8d$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $50c3e7540b2002ce$var$uninterpolateNumber = (0, $ffe938d875ae7f8d$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $50c3e7540b2002ce$var$uninterpolateTruncation = (0, $ffe938d875ae7f8d$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $50c3e7540b2002ce$export$2e2bcd8739ae039 = {
    rangeStep: $50c3e7540b2002ce$var$rangeStep,
    getDigitCount: $50c3e7540b2002ce$var$getDigitCount,
    interpolateNumber: $50c3e7540b2002ce$var$interpolateNumber,
    uninterpolateNumber: $50c3e7540b2002ce$var$uninterpolateNumber,
    uninterpolateTruncation: $50c3e7540b2002ce$var$uninterpolateTruncation
};


function $b526c1eb02d5f4bf$var$_toConsumableArray(arr) {
    return $b526c1eb02d5f4bf$var$_arrayWithoutHoles(arr) || $b526c1eb02d5f4bf$var$_iterableToArray(arr) || $b526c1eb02d5f4bf$var$_unsupportedIterableToArray(arr) || $b526c1eb02d5f4bf$var$_nonIterableSpread();
}
function $b526c1eb02d5f4bf$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b526c1eb02d5f4bf$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $b526c1eb02d5f4bf$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b526c1eb02d5f4bf$var$_arrayLikeToArray(arr);
}
function $b526c1eb02d5f4bf$var$_slicedToArray(arr, i) {
    return $b526c1eb02d5f4bf$var$_arrayWithHoles(arr) || $b526c1eb02d5f4bf$var$_iterableToArrayLimit(arr, i) || $b526c1eb02d5f4bf$var$_unsupportedIterableToArray(arr, i) || $b526c1eb02d5f4bf$var$_nonIterableRest();
}
function $b526c1eb02d5f4bf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b526c1eb02d5f4bf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b526c1eb02d5f4bf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b526c1eb02d5f4bf$var$_arrayLikeToArray(o, minLen);
}
function $b526c1eb02d5f4bf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b526c1eb02d5f4bf$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b526c1eb02d5f4bf$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $b526c1eb02d5f4bf$var$getValidInterval(_ref) {
    var _ref2 = $b526c1eb02d5f4bf$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $b526c1eb02d5f4bf$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(0);
    var digitCount = (0, $50c3e7540b2002ce$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $b526c1eb02d5f4bf$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(10).pow((0, $50c3e7540b2002ce$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $ffe938d875ae7f8d$export$f672e0b6f7222cd7)((0, $ffe938d875ae7f8d$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $ffe938d875ae7f8d$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $b526c1eb02d5f4bf$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $b526c1eb02d5f4bf$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $b526c1eb02d5f4bf$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $b526c1eb02d5f4bf$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $b526c1eb02d5f4bf$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $b526c1eb02d5f4bf$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $b526c1eb02d5f4bf$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($b526c1eb02d5f4bf$var$_toConsumableArray((0, $ffe938d875ae7f8d$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($b526c1eb02d5f4bf$var$_toConsumableArray((0, $ffe938d875ae7f8d$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $ffe938d875ae7f8d$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $b526c1eb02d5f4bf$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $b526c1eb02d5f4bf$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $50c3e7540b2002ce$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $ffe938d875ae7f8d$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $b526c1eb02d5f4bf$var$getTickValuesFn(_ref5) {
    var _ref6 = $b526c1eb02d5f4bf$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $b526c1eb02d5f4bf$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $b526c1eb02d5f4bf$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $b526c1eb02d5f4bf$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $b526c1eb02d5f4bf$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $ffe938d875ae7f8d$export$f672e0b6f7222cd7)((0, $ffe938d875ae7f8d$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(n).mul(step)).toNumber();
    }), (0, $ffe938d875ae7f8d$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $ffe938d875ae7f8d$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $b526c1eb02d5f4bf$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $b526c1eb02d5f4bf$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $b526c1eb02d5f4bf$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $b526c1eb02d5f4bf$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $b526c1eb02d5f4bf$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($b526c1eb02d5f4bf$var$_toConsumableArray((0, $50c3e7540b2002ce$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($c9ea4366e124976a$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $ffe938d875ae7f8d$export$66c1ae025e96b4bc)(values) : values;
}
var $b526c1eb02d5f4bf$export$b84e75ccbfe6a612 = (0, $ffe938d875ae7f8d$export$fc10aeed3a532e2a)($b526c1eb02d5f4bf$var$getNiceTickValuesFn);
var $b526c1eb02d5f4bf$export$4cc7a216492b1f53 = (0, $ffe938d875ae7f8d$export$fc10aeed3a532e2a)($b526c1eb02d5f4bf$var$getTickValuesFn);
var $b526c1eb02d5f4bf$export$e9d28da780436e98 = (0, $ffe938d875ae7f8d$export$fc10aeed3a532e2a)($b526c1eb02d5f4bf$var$getTickValuesFixedDomainFn);





var $70fFQ = parcelRequire("70fFQ");
var $0da1c288545eac50$var$isProduction = true;
var $0da1c288545eac50$var$prefix = 'Invariant failed';
function $0da1c288545eac50$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($0da1c288545eac50$var$isProduction) throw new Error($0da1c288545eac50$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($0da1c288545eac50$var$prefix, ": ").concat(provided) : $0da1c288545eac50$var$prefix;
    throw new Error(value);
}




var $fc2e0abee97a8d1b$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $fc2e0abee97a8d1b$var$_extends() {
    $fc2e0abee97a8d1b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc2e0abee97a8d1b$var$_extends.apply(this, arguments);
}
function $fc2e0abee97a8d1b$var$_slicedToArray(arr, i) {
    return $fc2e0abee97a8d1b$var$_arrayWithHoles(arr) || $fc2e0abee97a8d1b$var$_iterableToArrayLimit(arr, i) || $fc2e0abee97a8d1b$var$_unsupportedIterableToArray(arr, i) || $fc2e0abee97a8d1b$var$_nonIterableRest();
}
function $fc2e0abee97a8d1b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fc2e0abee97a8d1b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fc2e0abee97a8d1b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fc2e0abee97a8d1b$var$_arrayLikeToArray(o, minLen);
}
function $fc2e0abee97a8d1b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fc2e0abee97a8d1b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $fc2e0abee97a8d1b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fc2e0abee97a8d1b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fc2e0abee97a8d1b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fc2e0abee97a8d1b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fc2e0abee97a8d1b$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $fc2e0abee97a8d1b$var$_objectWithoutProperties(props, $fc2e0abee97a8d1b$var$_excluded);
    var svgProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, false);
    !!(props.direction === 'x' && xAxis.type !== 'number') && (0, $0da1c288545eac50$export$2e2bcd8739ae039)(false);
    var errorBars = data.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $fc2e0abee97a8d1b$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === 'vertical') {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === 'horizontal') {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $fc2e0abee97a8d1b$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(lineCoordinates.map(function(c) {
                return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
            }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", $fc2e0abee97a8d1b$var$_extends({}, coordinates, {
                key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
            }));
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$fc2e0abee97a8d1b$export$4f4d7676bdf949e5.defaultProps = {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
};
$fc2e0abee97a8d1b$export$4f4d7676bdf949e5.displayName = 'ErrorBar';





var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");


var $axMmP = parcelRequire("axMmP");
/* eslint no-console: 0 */ var $425eb72df2965775$var$isDev = false;
var $425eb72df2965775$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($425eb72df2965775$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");

var $abed49cce9ec42fc$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $abed49cce9ec42fc$var$_extends() {
    $abed49cce9ec42fc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $abed49cce9ec42fc$var$_extends.apply(this, arguments);
}
function $abed49cce9ec42fc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $abed49cce9ec42fc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $abed49cce9ec42fc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $abed49cce9ec42fc$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $abed49cce9ec42fc$var$_objectWithoutProperties(props, $abed49cce9ec42fc$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $axMmP.default)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("svg", $abed49cce9ec42fc$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("desc", null, desc), children);
}



var $70fFQ = parcelRequire("70fFQ");



var $axMmP = parcelRequire("axMmP");

function $b03b683f83f72751$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b03b683f83f72751$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b03b683f83f72751$var$_typeof(o);
}
var $b03b683f83f72751$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $b03b683f83f72751$var$_extends() {
    $b03b683f83f72751$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b03b683f83f72751$var$_extends.apply(this, arguments);
}
function $b03b683f83f72751$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b03b683f83f72751$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b03b683f83f72751$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b03b683f83f72751$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b03b683f83f72751$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b03b683f83f72751$var$_defineProperty(obj, key, value) {
    key = $b03b683f83f72751$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b03b683f83f72751$var$_toPropertyKey(t) {
    var i = $b03b683f83f72751$var$_toPrimitive(t, "string");
    return "symbol" == $b03b683f83f72751$var$_typeof(i) ? i : String(i);
}
function $b03b683f83f72751$var$_toPrimitive(t, r) {
    if ("object" != $b03b683f83f72751$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b03b683f83f72751$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b03b683f83f72751$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b03b683f83f72751$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b03b683f83f72751$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b03b683f83f72751$var$symbolFactories = {
    symbolCircle: (0, $6893b2114d74c3a2$exports.symbolCircle),
    symbolCross: (0, $6893b2114d74c3a2$exports.symbolCross),
    symbolDiamond: (0, $6893b2114d74c3a2$exports.symbolDiamond),
    symbolSquare: (0, $6893b2114d74c3a2$exports.symbolSquare),
    symbolStar: (0, $6893b2114d74c3a2$exports.symbolStar),
    symbolTriangle: (0, $6893b2114d74c3a2$exports.symbolTriangle),
    symbolWye: (0, $6893b2114d74c3a2$exports.symbolWye)
};
var $b03b683f83f72751$var$RADIAN = Math.PI / 180;
var $b03b683f83f72751$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($274dcdc4ff8cf388$exports)))(type));
    return $b03b683f83f72751$var$symbolFactories[name] || (0, $6893b2114d74c3a2$exports.symbolCircle);
};
var $b03b683f83f72751$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $b03b683f83f72751$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $b03b683f83f72751$var$registerSymbol = function registerSymbol(key, factory) {
    $b03b683f83f72751$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($274dcdc4ff8cf388$exports)))(key))] = factory;
};
var $b03b683f83f72751$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $b03b683f83f72751$var$_objectWithoutProperties(_ref, $b03b683f83f72751$var$_excluded);
    var props = $b03b683f83f72751$var$_objectSpread($b03b683f83f72751$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $b03b683f83f72751$var$getSymbolFactory(type);
        var symbol = (0, $6893b2114d74c3a2$exports.symbol)().type(symbolFactory).size($b03b683f83f72751$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $b03b683f83f72751$var$_extends({}, filteredProps, {
        className: (0, $axMmP.default)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$b03b683f83f72751$export$fa456266707bf4e4.registerSymbol = $b03b683f83f72751$var$registerSymbol;



function $72ba004730b0a753$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $72ba004730b0a753$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $72ba004730b0a753$var$_typeof(o);
}
function $72ba004730b0a753$var$_extends() {
    $72ba004730b0a753$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $72ba004730b0a753$var$_extends.apply(this, arguments);
}
function $72ba004730b0a753$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $72ba004730b0a753$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $72ba004730b0a753$var$ownKeys(Object(t), !0).forEach(function(r) {
            $72ba004730b0a753$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $72ba004730b0a753$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $72ba004730b0a753$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $72ba004730b0a753$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $72ba004730b0a753$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $72ba004730b0a753$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $72ba004730b0a753$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $72ba004730b0a753$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $72ba004730b0a753$var$_callSuper(t, o, e) {
    return o = $72ba004730b0a753$var$_getPrototypeOf(o), $72ba004730b0a753$var$_possibleConstructorReturn(t, $72ba004730b0a753$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $72ba004730b0a753$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $72ba004730b0a753$var$_possibleConstructorReturn(self, call) {
    if (call && ($72ba004730b0a753$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $72ba004730b0a753$var$_assertThisInitialized(self);
}
function $72ba004730b0a753$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $72ba004730b0a753$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($72ba004730b0a753$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $72ba004730b0a753$var$_getPrototypeOf(o) {
    $72ba004730b0a753$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $72ba004730b0a753$var$_getPrototypeOf(o);
}
function $72ba004730b0a753$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $72ba004730b0a753$var$_setPrototypeOf(subClass, superClass);
}
function $72ba004730b0a753$var$_setPrototypeOf(o, p) {
    $72ba004730b0a753$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $72ba004730b0a753$var$_setPrototypeOf(o, p);
}
function $72ba004730b0a753$var$_defineProperty(obj, key, value) {
    key = $72ba004730b0a753$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $72ba004730b0a753$var$_toPropertyKey(t) {
    var i = $72ba004730b0a753$var$_toPrimitive(t, "string");
    return "symbol" == $72ba004730b0a753$var$_typeof(i) ? i : String(i);
}
function $72ba004730b0a753$var$_toPrimitive(t, r) {
    if ("object" != $72ba004730b0a753$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $72ba004730b0a753$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $72ba004730b0a753$var$SIZE = 32;
var $72ba004730b0a753$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $72ba004730b0a753$var$_inherits(DefaultLegendContent, _PureComponent);
    function DefaultLegendContent() {
        $72ba004730b0a753$var$_classCallCheck(this, DefaultLegendContent);
        return $72ba004730b0a753$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $72ba004730b0a753$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $72ba004730b0a753$var$SIZE / 2;
                var sixthSize = $72ba004730b0a753$var$SIZE / 6;
                var thirdSize = $72ba004730b0a753$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $72ba004730b0a753$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($72ba004730b0a753$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($72ba004730b0a753$var$SIZE / 8, "h").concat($72ba004730b0a753$var$SIZE, "v").concat($72ba004730b0a753$var$SIZE * 3 / 4, "h").concat(-$72ba004730b0a753$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(data.legendIcon)) {
                    var iconProps = $72ba004730b0a753$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $b03b683f83f72751$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $72ba004730b0a753$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $72ba004730b0a753$var$SIZE,
                    height: $72ba004730b0a753$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $axMmP.default)($72ba004730b0a753$var$_defineProperty($72ba004730b0a753$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(entry.value) ? entry.value : null;
                    (0, $425eb72df2965775$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("li", $72ba004730b0a753$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $abed49cce9ec42fc$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $70fFQ.PureComponent));
$72ba004730b0a753$var$_defineProperty($72ba004730b0a753$export$99f8d96ed0cededa, "displayName", 'Legend');
$72ba004730b0a753$var$_defineProperty($72ba004730b0a753$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $408330307bfc034c$exports = {};

var $3ced2c80d3060a6c$exports = {};

var $74599e81060611a9$exports = {};
var $b47a9bc8f4824047$exports = {};
var $776b070841b67cc0$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $776b070841b67cc0$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$776b070841b67cc0$exports = $776b070841b67cc0$var$baseFindIndex;


var $e8e7d54227a98bfe$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $e8e7d54227a98bfe$var$baseIsNaN(value) {
    return value !== value;
}
$e8e7d54227a98bfe$exports = $e8e7d54227a98bfe$var$baseIsNaN;


var $09f175bdd2fef616$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $09f175bdd2fef616$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$09f175bdd2fef616$exports = $09f175bdd2fef616$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b47a9bc8f4824047$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $09f175bdd2fef616$exports(array, value, fromIndex) : $776b070841b67cc0$exports(array, $e8e7d54227a98bfe$exports, fromIndex);
}
$b47a9bc8f4824047$exports = $b47a9bc8f4824047$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $74599e81060611a9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $b47a9bc8f4824047$exports(array, value, 0) > -1;
}
$74599e81060611a9$exports = $74599e81060611a9$var$arrayIncludes;


var $061a1f1f348d7efd$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $061a1f1f348d7efd$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$061a1f1f348d7efd$exports = $061a1f1f348d7efd$var$arrayIncludesWith;



var $3c9210990ca38404$exports = {};

var $7494ca3b5822d283$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $7494ca3b5822d283$var$noop() {
// No operation performed.
}
$7494ca3b5822d283$exports = $7494ca3b5822d283$var$noop;



/** Used as references for various `Number` constants. */ var $3c9210990ca38404$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3c9210990ca38404$var$createSet = !($b354218c0a1726db$exports && 1 / $9536752770575bdf$exports(new $b354218c0a1726db$exports([
    ,
    -0
]))[1] == $3c9210990ca38404$var$INFINITY) ? $7494ca3b5822d283$exports : function(values) {
    return new $b354218c0a1726db$exports(values);
};
$3c9210990ca38404$exports = $3c9210990ca38404$var$createSet;



/** Used as the size to enable large array optimizations. */ var $3ced2c80d3060a6c$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $3ced2c80d3060a6c$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $74599e81060611a9$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $061a1f1f348d7efd$exports;
    } else if (length >= $3ced2c80d3060a6c$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $3c9210990ca38404$exports(array);
        if (set) return $9536752770575bdf$exports(set);
        isCommon = false;
        includes = $b23cd2e7fb810464$exports;
        seen = new $580ef9deb5abbaef$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$3ced2c80d3060a6c$exports = $3ced2c80d3060a6c$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $408330307bfc034c$var$uniqBy(array, iteratee) {
    return array && array.length ? $3ced2c80d3060a6c$exports(array, $1316a39af77ac4e6$exports(iteratee, 2)) : [];
}
$408330307bfc034c$exports = $408330307bfc034c$var$uniqBy;



function $ddc8730ee9c3cd89$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($408330307bfc034c$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($408330307bfc034c$exports)))(payload, option);
    return payload;
}


function $1bb7597bd9097c42$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1bb7597bd9097c42$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1bb7597bd9097c42$var$_typeof(o);
}
var $1bb7597bd9097c42$var$_excluded = [
    "ref"
];
function $1bb7597bd9097c42$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1bb7597bd9097c42$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1bb7597bd9097c42$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1bb7597bd9097c42$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1bb7597bd9097c42$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1bb7597bd9097c42$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1bb7597bd9097c42$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1bb7597bd9097c42$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1bb7597bd9097c42$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1bb7597bd9097c42$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1bb7597bd9097c42$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1bb7597bd9097c42$var$_callSuper(t, o, e) {
    return o = $1bb7597bd9097c42$var$_getPrototypeOf(o), $1bb7597bd9097c42$var$_possibleConstructorReturn(t, $1bb7597bd9097c42$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1bb7597bd9097c42$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1bb7597bd9097c42$var$_possibleConstructorReturn(self, call) {
    if (call && ($1bb7597bd9097c42$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1bb7597bd9097c42$var$_assertThisInitialized(self);
}
function $1bb7597bd9097c42$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1bb7597bd9097c42$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1bb7597bd9097c42$var$_getPrototypeOf(o) {
    $1bb7597bd9097c42$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1bb7597bd9097c42$var$_getPrototypeOf(o);
}
function $1bb7597bd9097c42$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1bb7597bd9097c42$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1bb7597bd9097c42$var$_setPrototypeOf(subClass, superClass);
}
function $1bb7597bd9097c42$var$_setPrototypeOf(o, p) {
    $1bb7597bd9097c42$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1bb7597bd9097c42$var$_setPrototypeOf(o, p);
}
function $1bb7597bd9097c42$var$_defineProperty(obj, key, value) {
    key = $1bb7597bd9097c42$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1bb7597bd9097c42$var$_toPropertyKey(t) {
    var i = $1bb7597bd9097c42$var$_toPrimitive(t, "string");
    return "symbol" == $1bb7597bd9097c42$var$_typeof(i) ? i : String(i);
}
function $1bb7597bd9097c42$var$_toPrimitive(t, r) {
    if ("object" != $1bb7597bd9097c42$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1bb7597bd9097c42$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1bb7597bd9097c42$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1bb7597bd9097c42$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1bb7597bd9097c42$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1bb7597bd9097c42$var$defaultUniqBy(entry) {
    return entry.value;
}
function $1bb7597bd9097c42$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(content, props);
    var ref = props.ref, otherProps = $1bb7597bd9097c42$var$_objectWithoutProperties(props, $1bb7597bd9097c42$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $72ba004730b0a753$export$99f8d96ed0cededa), otherProps);
}
var $1bb7597bd9097c42$var$EPS = 1;
var $1bb7597bd9097c42$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $1bb7597bd9097c42$var$_inherits(Legend, _PureComponent);
    function Legend() {
        var _this;
        $1bb7597bd9097c42$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $1bb7597bd9097c42$var$_callSuper(this, Legend, [].concat(args));
        $1bb7597bd9097c42$var$_defineProperty($1bb7597bd9097c42$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $1bb7597bd9097c42$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    _box.height = this.wrapperNode.offsetHeight;
                    _box.width = this.wrapperNode.offsetWidth;
                    return _box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $1bb7597bd9097c42$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $1bb7597bd9097c42$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $1bb7597bd9097c42$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $1bb7597bd9097c42$var$_objectSpread($1bb7597bd9097c42$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $1bb7597bd9097c42$var$_objectSpread($1bb7597bd9097c42$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $1bb7597bd9097c42$var$renderContent(content, $1bb7597bd9097c42$var$_objectSpread($1bb7597bd9097c42$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $ddc8730ee9c3cd89$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $1bb7597bd9097c42$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === 'vertical' && (0, $453b3059df48aedd$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $70fFQ.PureComponent));
$1bb7597bd9097c42$var$_defineProperty($1bb7597bd9097c42$export$ed247974535929c7, "displayName", 'Legend');
$1bb7597bd9097c42$var$_defineProperty($1bb7597bd9097c42$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $b5b278592fecce6c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b5b278592fecce6c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b5b278592fecce6c$var$_typeof(o);
}
function $b5b278592fecce6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5b278592fecce6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5b278592fecce6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b5b278592fecce6c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5b278592fecce6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b5b278592fecce6c$var$_defineProperty(obj, key, value) {
    key = $b5b278592fecce6c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5b278592fecce6c$var$_toPropertyKey(t) {
    var i = $b5b278592fecce6c$var$_toPrimitive(t, "string");
    return "symbol" == $b5b278592fecce6c$var$_typeof(i) ? i : String(i);
}
function $b5b278592fecce6c$var$_toPrimitive(t, r) {
    if ("object" != $b5b278592fecce6c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b5b278592fecce6c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b5b278592fecce6c$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $1bb7597bd9097c42$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || 'square',
            color: (0, $cdef3b11746f8934$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return $b5b278592fecce6c$var$_objectSpread($b5b278592fecce6c$var$_objectSpread($b5b278592fecce6c$var$_objectSpread({}, legendItem.props), (0, $1bb7597bd9097c42$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $cdef3b11746f8934$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cdef3b11746f8934$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cdef3b11746f8934$var$_typeof(o);
}
function $cdef3b11746f8934$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cdef3b11746f8934$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cdef3b11746f8934$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cdef3b11746f8934$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cdef3b11746f8934$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cdef3b11746f8934$var$_defineProperty(obj, key, value) {
    key = $cdef3b11746f8934$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cdef3b11746f8934$var$_toPropertyKey(t) {
    var i = $cdef3b11746f8934$var$_toPrimitive(t, "string");
    return "symbol" == $cdef3b11746f8934$var$_typeof(i) ? i : String(i);
}
function $cdef3b11746f8934$var$_toPrimitive(t, r) {
    if ("object" != $cdef3b11746f8934$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cdef3b11746f8934$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cdef3b11746f8934$var$_toConsumableArray(arr) {
    return $cdef3b11746f8934$var$_arrayWithoutHoles(arr) || $cdef3b11746f8934$var$_iterableToArray(arr) || $cdef3b11746f8934$var$_unsupportedIterableToArray(arr) || $cdef3b11746f8934$var$_nonIterableSpread();
}
function $cdef3b11746f8934$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cdef3b11746f8934$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cdef3b11746f8934$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cdef3b11746f8934$var$_arrayLikeToArray(o, minLen);
}
function $cdef3b11746f8934$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cdef3b11746f8934$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cdef3b11746f8934$var$_arrayLikeToArray(arr);
}
function $cdef3b11746f8934$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cdef3b11746f8934$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(dataKey)) return defaultValue;
    if ((0, $453b3059df48aedd$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $cdef3b11746f8934$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($5bace4c68bf572de$exports)))(data, function(entry) {
        return $cdef3b11746f8934$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $453b3059df48aedd$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($5faa772a70839d2c$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $453b3059df48aedd$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $cdef3b11746f8934$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $453b3059df48aedd$export$9d334328eb75e624)(cur - before) !== (0, $453b3059df48aedd$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $453b3059df48aedd$export$9d334328eb75e624)(after - cur) === (0, $453b3059df48aedd$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $cdef3b11746f8934$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $cdef3b11746f8934$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $a56fb3d503224b01$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(barSize) ? undefined : (0, $453b3059df48aedd$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $cdef3b11746f8934$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $453b3059df48aedd$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($cdef3b11746f8934$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $453b3059df48aedd$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($cdef3b11746f8934$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $cdef3b11746f8934$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $b5b278592fecce6c$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $453b3059df48aedd$export$7e4aa119212bc614)(offset[align])) return $cdef3b11746f8934$var$_objectSpread($cdef3b11746f8934$var$_objectSpread({}, offset), {}, $cdef3b11746f8934$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $453b3059df48aedd$export$7e4aa119212bc614)(offset[verticalAlign])) return $cdef3b11746f8934$var$_objectSpread($cdef3b11746f8934$var$_objectSpread({}, offset), {}, $cdef3b11746f8934$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $cdef3b11746f8934$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $cdef3b11746f8934$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $fc2e0abee97a8d1b$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $cdef3b11746f8934$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $cdef3b11746f8934$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($5faa772a70839d2c$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $cdef3b11746f8934$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $cdef3b11746f8934$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $cdef3b11746f8934$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $cdef3b11746f8934$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $cdef3b11746f8934$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $cdef3b11746f8934$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $cdef3b11746f8934$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $cdef3b11746f8934$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $cdef3b11746f8934$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $cdef3b11746f8934$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $453b3059df48aedd$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($b26a90b73a77c867$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $cdef3b11746f8934$var$handlerWeakMap = new WeakMap();
var $cdef3b11746f8934$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$cdef3b11746f8934$var$handlerWeakMap.has(defaultHandler)) $cdef3b11746f8934$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $cdef3b11746f8934$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $cdef3b11746f8934$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $0976c92ed4d25575$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $0976c92ed4d25575$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $0976c92ed4d25575$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $0976c92ed4d25575$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $0976c92ed4d25575$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e1a838f354cb0c85$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($274dcdc4ff8cf388$exports)))(scale));
        return {
            scale: ($0976c92ed4d25575$exports[name] || $0976c92ed4d25575$exports.scalePoint)(),
            realScaleType: $0976c92ed4d25575$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $0976c92ed4d25575$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $cdef3b11746f8934$var$EPS = 1e-4;
var $cdef3b11746f8934$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $cdef3b11746f8934$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $cdef3b11746f8934$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $cdef3b11746f8934$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $cdef3b11746f8934$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(domain[0]) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $453b3059df48aedd$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $453b3059df48aedd$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $cdef3b11746f8934$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($b26a90b73a77c867$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $cdef3b11746f8934$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($b26a90b73a77c867$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $cdef3b11746f8934$var$STACK_OFFSET_MAP = {
    sign: $cdef3b11746f8934$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $6893b2114d74c3a2$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $6893b2114d74c3a2$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $6893b2114d74c3a2$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $6893b2114d74c3a2$exports.stackOffsetWiggle),
    positive: $cdef3b11746f8934$export$9f2c6ead70935022
};
var $cdef3b11746f8934$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $cdef3b11746f8934$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $6893b2114d74c3a2$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$cdef3b11746f8934$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $6893b2114d74c3a2$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $cdef3b11746f8934$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $453b3059df48aedd$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $453b3059df48aedd$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $cdef3b11746f8934$var$_objectSpread($cdef3b11746f8934$var$_objectSpread({}, result), {}, $cdef3b11746f8934$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $cdef3b11746f8934$var$_objectSpread($cdef3b11746f8934$var$_objectSpread({}, res), {}, $cdef3b11746f8934$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $cdef3b11746f8934$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $cdef3b11746f8934$var$_objectSpread($cdef3b11746f8934$var$_objectSpread({}, result), {}, $cdef3b11746f8934$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $cdef3b11746f8934$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $b526c1eb02d5f4bf$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($5faa772a70839d2c$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $b526c1eb02d5f4bf$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $cdef3b11746f8934$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $453b3059df48aedd$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $cdef3b11746f8934$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(value) ? axis.scale(value) : null;
}
var $cdef3b11746f8934$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $cdef3b11746f8934$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $cdef3b11746f8934$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $cdef3b11746f8934$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $453b3059df48aedd$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $cdef3b11746f8934$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($5faa772a70839d2c$exports)))(entry.concat([
                result[0]
            ]).filter((0, $453b3059df48aedd$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(entry.concat([
                result[1]
            ]).filter((0, $453b3059df48aedd$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $cdef3b11746f8934$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $cdef3b11746f8934$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $cdef3b11746f8934$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cdef3b11746f8934$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cdef3b11746f8934$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($cdef3b11746f8934$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$cdef3b11746f8934$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($cdef3b11746f8934$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$cdef3b11746f8934$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $cdef3b11746f8934$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($f30c977dfc6b9355$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $cdef3b11746f8934$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $cdef3b11746f8934$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType, hide = _graphicalItem$props.hide;
    return $cdef3b11746f8934$var$_objectSpread($cdef3b11746f8934$var$_objectSpread({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $cdef3b11746f8934$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $cdef3b11746f8934$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $a9c74f58ba1355cc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a9c74f58ba1355cc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a9c74f58ba1355cc$var$_typeof(o);
}
function $a9c74f58ba1355cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9c74f58ba1355cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9c74f58ba1355cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a9c74f58ba1355cc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9c74f58ba1355cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a9c74f58ba1355cc$var$_defineProperty(obj, key, value) {
    key = $a9c74f58ba1355cc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a9c74f58ba1355cc$var$_toPropertyKey(t) {
    var i = $a9c74f58ba1355cc$var$_toPrimitive(t, "string");
    return "symbol" == $a9c74f58ba1355cc$var$_typeof(i) ? i : String(i);
}
function $a9c74f58ba1355cc$var$_toPrimitive(t, r) {
    if ("object" != $a9c74f58ba1355cc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a9c74f58ba1355cc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a9c74f58ba1355cc$var$_slicedToArray(arr, i) {
    return $a9c74f58ba1355cc$var$_arrayWithHoles(arr) || $a9c74f58ba1355cc$var$_iterableToArrayLimit(arr, i) || $a9c74f58ba1355cc$var$_unsupportedIterableToArray(arr, i) || $a9c74f58ba1355cc$var$_nonIterableRest();
}
function $a9c74f58ba1355cc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a9c74f58ba1355cc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a9c74f58ba1355cc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a9c74f58ba1355cc$var$_arrayLikeToArray(o, minLen);
}
function $a9c74f58ba1355cc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a9c74f58ba1355cc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a9c74f58ba1355cc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a9c74f58ba1355cc$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $a9c74f58ba1355cc$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $a9c74f58ba1355cc$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $a9c74f58ba1355cc$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$a9c74f58ba1355cc$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$a9c74f58ba1355cc$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $a9c74f58ba1355cc$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $a9c74f58ba1355cc$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $453b3059df48aedd$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $453b3059df48aedd$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $a9c74f58ba1355cc$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $453b3059df48aedd$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $453b3059df48aedd$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $a9c74f58ba1355cc$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $cdef3b11746f8934$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $cdef3b11746f8934$export$9d80152e23bae434)(scale);
        var ticks = (0, $cdef3b11746f8934$export$ac086aaa4358d590)(scale, $a9c74f58ba1355cc$var$_objectSpread($a9c74f58ba1355cc$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $a9c74f58ba1355cc$var$_objectSpread($a9c74f58ba1355cc$var$_objectSpread($a9c74f58ba1355cc$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $a9c74f58ba1355cc$var$_objectSpread($a9c74f58ba1355cc$var$_objectSpread({}, result), {}, $a9c74f58ba1355cc$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $a9c74f58ba1355cc$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $a9c74f58ba1355cc$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $a9c74f58ba1355cc$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $a9c74f58ba1355cc$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $a9c74f58ba1355cc$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $a9c74f58ba1355cc$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $a9c74f58ba1355cc$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $a9c74f58ba1355cc$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $a9c74f58ba1355cc$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $a9c74f58ba1355cc$var$_objectSpread($a9c74f58ba1355cc$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $a9c74f58ba1355cc$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $a9c74f58ba1355cc$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $70fFQ.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $e8d2d091029884ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e8d2d091029884ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e8d2d091029884ea$var$_typeof(o);
}
var $e8d2d091029884ea$var$_excluded = [
    "offset"
];
function $e8d2d091029884ea$var$_toConsumableArray(arr) {
    return $e8d2d091029884ea$var$_arrayWithoutHoles(arr) || $e8d2d091029884ea$var$_iterableToArray(arr) || $e8d2d091029884ea$var$_unsupportedIterableToArray(arr) || $e8d2d091029884ea$var$_nonIterableSpread();
}
function $e8d2d091029884ea$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e8d2d091029884ea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e8d2d091029884ea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e8d2d091029884ea$var$_arrayLikeToArray(o, minLen);
}
function $e8d2d091029884ea$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e8d2d091029884ea$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e8d2d091029884ea$var$_arrayLikeToArray(arr);
}
function $e8d2d091029884ea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e8d2d091029884ea$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e8d2d091029884ea$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e8d2d091029884ea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e8d2d091029884ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e8d2d091029884ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e8d2d091029884ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e8d2d091029884ea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e8d2d091029884ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e8d2d091029884ea$var$_defineProperty(obj, key, value) {
    key = $e8d2d091029884ea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e8d2d091029884ea$var$_toPropertyKey(t) {
    var i = $e8d2d091029884ea$var$_toPrimitive(t, "string");
    return "symbol" == $e8d2d091029884ea$var$_typeof(i) ? i : String(i);
}
function $e8d2d091029884ea$var$_toPrimitive(t, r) {
    if ("object" != $e8d2d091029884ea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e8d2d091029884ea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e8d2d091029884ea$var$_extends() {
    $e8d2d091029884ea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8d2d091029884ea$var$_extends.apply(this, arguments);
}
var $e8d2d091029884ea$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(formatter)) return formatter(label);
    return label;
};
var $e8d2d091029884ea$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $453b3059df48aedd$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $e8d2d091029884ea$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $e8d2d091029884ea$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(labelProps.id) ? (0, $453b3059df48aedd$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("text", $e8d2d091029884ea$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $axMmP.default)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $e8d2d091029884ea$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $e8d2d091029884ea$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $e8d2d091029884ea$var$_objectSpread($e8d2d091029884ea$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $e8d2d091029884ea$var$_objectSpread($e8d2d091029884ea$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $e8d2d091029884ea$var$_objectSpread($e8d2d091029884ea$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $e8d2d091029884ea$var$_objectSpread($e8d2d091029884ea$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $e8d2d091029884ea$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $e8d2d091029884ea$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $e8d2d091029884ea$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $e8d2d091029884ea$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $e8d2d091029884ea$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $e8d2d091029884ea$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $e8d2d091029884ea$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $e8d2d091029884ea$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b3d1e6aa1c534f86$exports)))(position) && ((0, $453b3059df48aedd$export$7e4aa119212bc614)(position.x) || (0, $453b3059df48aedd$export$e50269385c77c348)(position.x)) && ((0, $453b3059df48aedd$export$7e4aa119212bc614)(position.y) || (0, $453b3059df48aedd$export$e50269385c77c348)(position.y))) return $e8d2d091029884ea$var$_objectSpread({
        x: x + (0, $453b3059df48aedd$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $453b3059df48aedd$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $e8d2d091029884ea$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $e8d2d091029884ea$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $453b3059df48aedd$export$7e4aa119212bc614)(viewBox.cx);
};
function $e8d2d091029884ea$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $e8d2d091029884ea$var$_objectWithoutProperties(_ref4, $e8d2d091029884ea$var$_excluded);
    var props = $e8d2d091029884ea$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(children) && !/*#__PURE__*/ (0, $70fFQ.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(content)) return /*#__PURE__*/ (0, $70fFQ.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(content)) {
        label = /*#__PURE__*/ (0, $70fFQ.createElement)(content, props);
        if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(label)) return label;
    } else label = $e8d2d091029884ea$var$getLabel(props);
    var isPolarLabel = $e8d2d091029884ea$var$isPolar(viewBox);
    var attrs = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $e8d2d091029884ea$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $e8d2d091029884ea$var$getAttrsOfPolarLabel(props) : $e8d2d091029884ea$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f01a70744931f940$export$5f1af8db9871e1d6), $e8d2d091029884ea$var$_extends({
        className: (0, $axMmP.default)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$e8d2d091029884ea$export$b04be29aa201d4f5.displayName = 'Label';
var $e8d2d091029884ea$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(width) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(height)) {
        if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(x) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(top) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(x) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(cx) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $e8d2d091029884ea$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e8d2d091029884ea$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $453b3059df48aedd$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e8d2d091029884ea$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(label)) {
        if (label.type === $e8d2d091029884ea$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $70fFQ.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e8d2d091029884ea$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e8d2d091029884ea$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b3d1e6aa1c534f86$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($e8d2d091029884ea$export$b04be29aa201d4f5, $e8d2d091029884ea$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $e8d2d091029884ea$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $e8d2d091029884ea$var$parseViewBox(parentProps);
    var explicitChildren = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, $e8d2d091029884ea$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $70fFQ.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $e8d2d091029884ea$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($e8d2d091029884ea$var$_toConsumableArray(explicitChildren));
};
$e8d2d091029884ea$export$b04be29aa201d4f5.parseViewBox = $e8d2d091029884ea$var$parseViewBox;
$e8d2d091029884ea$export$b04be29aa201d4f5.renderCallByParent = $e8d2d091029884ea$var$renderCallByParent;



var $70fFQ = parcelRequire("70fFQ");



var $6a686ac99b5f433f$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $6a686ac99b5f433f$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$6a686ac99b5f433f$exports = $6a686ac99b5f433f$var$last;






function $f77ba05e9211fcd7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f77ba05e9211fcd7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f77ba05e9211fcd7$var$_typeof(o);
}
var $f77ba05e9211fcd7$var$_excluded = [
    "valueAccessor"
], $f77ba05e9211fcd7$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $f77ba05e9211fcd7$var$_toConsumableArray(arr) {
    return $f77ba05e9211fcd7$var$_arrayWithoutHoles(arr) || $f77ba05e9211fcd7$var$_iterableToArray(arr) || $f77ba05e9211fcd7$var$_unsupportedIterableToArray(arr) || $f77ba05e9211fcd7$var$_nonIterableSpread();
}
function $f77ba05e9211fcd7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f77ba05e9211fcd7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f77ba05e9211fcd7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f77ba05e9211fcd7$var$_arrayLikeToArray(o, minLen);
}
function $f77ba05e9211fcd7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f77ba05e9211fcd7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f77ba05e9211fcd7$var$_arrayLikeToArray(arr);
}
function $f77ba05e9211fcd7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f77ba05e9211fcd7$var$_extends() {
    $f77ba05e9211fcd7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f77ba05e9211fcd7$var$_extends.apply(this, arguments);
}
function $f77ba05e9211fcd7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f77ba05e9211fcd7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f77ba05e9211fcd7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f77ba05e9211fcd7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f77ba05e9211fcd7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f77ba05e9211fcd7$var$_defineProperty(obj, key, value) {
    key = $f77ba05e9211fcd7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f77ba05e9211fcd7$var$_toPropertyKey(t) {
    var i = $f77ba05e9211fcd7$var$_toPrimitive(t, "string");
    return "symbol" == $f77ba05e9211fcd7$var$_typeof(i) ? i : String(i);
}
function $f77ba05e9211fcd7$var$_toPrimitive(t, r) {
    if ("object" != $f77ba05e9211fcd7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f77ba05e9211fcd7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f77ba05e9211fcd7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f77ba05e9211fcd7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f77ba05e9211fcd7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f77ba05e9211fcd7$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($6a686ac99b5f433f$exports)))(entry.value) : entry.value;
};
function $f77ba05e9211fcd7$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $f77ba05e9211fcd7$var$defaultAccessor : _ref$valueAccessor, restProps = $f77ba05e9211fcd7$var$_objectWithoutProperties(_ref, $f77ba05e9211fcd7$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $f77ba05e9211fcd7$var$_objectWithoutProperties(restProps, $f77ba05e9211fcd7$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $e8d2d091029884ea$export$b04be29aa201d4f5), $f77ba05e9211fcd7$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $e8d2d091029884ea$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(clockWise) ? entry : $f77ba05e9211fcd7$var$_objectSpread($f77ba05e9211fcd7$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$f77ba05e9211fcd7$export$835fcf23ab7bf88.displayName = 'LabelList';
function $f77ba05e9211fcd7$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f77ba05e9211fcd7$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f77ba05e9211fcd7$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b3d1e6aa1c534f86$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f77ba05e9211fcd7$export$835fcf23ab7bf88, $f77ba05e9211fcd7$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $f77ba05e9211fcd7$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, $f77ba05e9211fcd7$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $70fFQ.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $f77ba05e9211fcd7$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($f77ba05e9211fcd7$var$_toConsumableArray(explicitChildren));
}
$f77ba05e9211fcd7$export$835fcf23ab7bf88.renderCallByParent = $f77ba05e9211fcd7$var$renderCallByParent;











var $70fFQ = parcelRequire("70fFQ");

var $aba82bbc3cf689dd$exports = {};

var $20a250c32200039c$exports = {};

/** Built-in value references. */ var $20a250c32200039c$var$getPrototype = $d285731b63f15206$exports(Object.getPrototypeOf, Object);
$20a250c32200039c$exports = $20a250c32200039c$var$getPrototype;



/** `Object#toString` result references. */ var $aba82bbc3cf689dd$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $aba82bbc3cf689dd$var$funcProto = Function.prototype, $aba82bbc3cf689dd$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $aba82bbc3cf689dd$var$funcToString = $aba82bbc3cf689dd$var$funcProto.toString;
/** Used to check objects for own properties. */ var $aba82bbc3cf689dd$var$hasOwnProperty = $aba82bbc3cf689dd$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $aba82bbc3cf689dd$var$objectCtorString = $aba82bbc3cf689dd$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $aba82bbc3cf689dd$var$isPlainObject(value) {
    if (!$862d5c9ce5bfb845$exports(value) || $4caad4bc3a782200$exports(value) != $aba82bbc3cf689dd$var$objectTag) return false;
    var proto = $20a250c32200039c$exports(value);
    if (proto === null) return true;
    var Ctor = $aba82bbc3cf689dd$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $aba82bbc3cf689dd$var$funcToString.call(Ctor) == $aba82bbc3cf689dd$var$objectCtorString;
}
$aba82bbc3cf689dd$exports = $aba82bbc3cf689dd$var$isPlainObject;


var $5056b63f10015155$exports = {};


/** `Object#toString` result references. */ var $5056b63f10015155$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $5056b63f10015155$var$isBoolean(value) {
    return value === true || value === false || $862d5c9ce5bfb845$exports(value) && $4caad4bc3a782200$exports(value) == $5056b63f10015155$var$boolTag;
}
$5056b63f10015155$exports = $5056b63f10015155$var$isBoolean;




var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");


function $c0f721a3b6bafaa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c0f721a3b6bafaa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c0f721a3b6bafaa4$var$_typeof(o);
}
function $c0f721a3b6bafaa4$var$_extends() {
    $c0f721a3b6bafaa4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0f721a3b6bafaa4$var$_extends.apply(this, arguments);
}
function $c0f721a3b6bafaa4$var$_slicedToArray(arr, i) {
    return $c0f721a3b6bafaa4$var$_arrayWithHoles(arr) || $c0f721a3b6bafaa4$var$_iterableToArrayLimit(arr, i) || $c0f721a3b6bafaa4$var$_unsupportedIterableToArray(arr, i) || $c0f721a3b6bafaa4$var$_nonIterableRest();
}
function $c0f721a3b6bafaa4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0f721a3b6bafaa4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0f721a3b6bafaa4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0f721a3b6bafaa4$var$_arrayLikeToArray(o, minLen);
}
function $c0f721a3b6bafaa4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0f721a3b6bafaa4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c0f721a3b6bafaa4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c0f721a3b6bafaa4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0f721a3b6bafaa4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0f721a3b6bafaa4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0f721a3b6bafaa4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0f721a3b6bafaa4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0f721a3b6bafaa4$var$_defineProperty(obj, key, value) {
    key = $c0f721a3b6bafaa4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0f721a3b6bafaa4$var$_toPropertyKey(t) {
    var i = $c0f721a3b6bafaa4$var$_toPrimitive(t, "string");
    return "symbol" == $c0f721a3b6bafaa4$var$_typeof(i) ? i : String(i);
}
function $c0f721a3b6bafaa4$var$_toPrimitive(t, r) {
    if ("object" != $c0f721a3b6bafaa4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c0f721a3b6bafaa4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c0f721a3b6bafaa4$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $c0f721a3b6bafaa4$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $c0f721a3b6bafaa4$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $c0f721a3b6bafaa4$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $c0f721a3b6bafaa4$var$_objectSpread($c0f721a3b6bafaa4$var$_objectSpread({}, $c0f721a3b6bafaa4$var$defaultProps), rectangleProps);
    var pathRef = (0, $70fFQ.useRef)();
    var _useState = (0, $70fFQ.useState)(-1), _useState2 = $c0f721a3b6bafaa4$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $70fFQ.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $axMmP.default)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $c0f721a3b6bafaa4$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $c0f721a3b6bafaa4$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $c0f721a3b6bafaa4$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $c0f721a3b6bafaa4$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");


function $04f0670ba82b8c97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $04f0670ba82b8c97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $04f0670ba82b8c97$var$_typeof(o);
}
function $04f0670ba82b8c97$var$_extends() {
    $04f0670ba82b8c97$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04f0670ba82b8c97$var$_extends.apply(this, arguments);
}
function $04f0670ba82b8c97$var$_slicedToArray(arr, i) {
    return $04f0670ba82b8c97$var$_arrayWithHoles(arr) || $04f0670ba82b8c97$var$_iterableToArrayLimit(arr, i) || $04f0670ba82b8c97$var$_unsupportedIterableToArray(arr, i) || $04f0670ba82b8c97$var$_nonIterableRest();
}
function $04f0670ba82b8c97$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $04f0670ba82b8c97$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $04f0670ba82b8c97$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $04f0670ba82b8c97$var$_arrayLikeToArray(o, minLen);
}
function $04f0670ba82b8c97$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $04f0670ba82b8c97$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $04f0670ba82b8c97$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $04f0670ba82b8c97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04f0670ba82b8c97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04f0670ba82b8c97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $04f0670ba82b8c97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04f0670ba82b8c97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $04f0670ba82b8c97$var$_defineProperty(obj, key, value) {
    key = $04f0670ba82b8c97$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $04f0670ba82b8c97$var$_toPropertyKey(t) {
    var i = $04f0670ba82b8c97$var$_toPrimitive(t, "string");
    return "symbol" == $04f0670ba82b8c97$var$_typeof(i) ? i : String(i);
}
function $04f0670ba82b8c97$var$_toPrimitive(t, r) {
    if ("object" != $04f0670ba82b8c97$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $04f0670ba82b8c97$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $04f0670ba82b8c97$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $04f0670ba82b8c97$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $04f0670ba82b8c97$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $04f0670ba82b8c97$var$_objectSpread($04f0670ba82b8c97$var$_objectSpread({}, $04f0670ba82b8c97$var$defaultProps), props);
    var pathRef = (0, $70fFQ.useRef)();
    var _useState = (0, $70fFQ.useState)(-1), _useState2 = $04f0670ba82b8c97$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $70fFQ.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $axMmP.default)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $04f0670ba82b8c97$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $04f0670ba82b8c97$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $04f0670ba82b8c97$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $04f0670ba82b8c97$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");



function $6d3f0bfe46cac913$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6d3f0bfe46cac913$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6d3f0bfe46cac913$var$_typeof(o);
}
function $6d3f0bfe46cac913$var$_extends() {
    $6d3f0bfe46cac913$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6d3f0bfe46cac913$var$_extends.apply(this, arguments);
}
function $6d3f0bfe46cac913$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d3f0bfe46cac913$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d3f0bfe46cac913$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6d3f0bfe46cac913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d3f0bfe46cac913$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d3f0bfe46cac913$var$_defineProperty(obj, key, value) {
    key = $6d3f0bfe46cac913$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6d3f0bfe46cac913$var$_toPropertyKey(t) {
    var i = $6d3f0bfe46cac913$var$_toPrimitive(t, "string");
    return "symbol" == $6d3f0bfe46cac913$var$_typeof(i) ? i : String(i);
}
function $6d3f0bfe46cac913$var$_toPrimitive(t, r) {
    if ("object" != $6d3f0bfe46cac913$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6d3f0bfe46cac913$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6d3f0bfe46cac913$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $453b3059df48aedd$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $6d3f0bfe46cac913$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $a9c74f58ba1355cc$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $a9c74f58ba1355cc$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $6d3f0bfe46cac913$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $6d3f0bfe46cac913$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $6d3f0bfe46cac913$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $453b3059df48aedd$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $6d3f0bfe46cac913$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $6d3f0bfe46cac913$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $6d3f0bfe46cac913$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $6d3f0bfe46cac913$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $6d3f0bfe46cac913$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $6d3f0bfe46cac913$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $6d3f0bfe46cac913$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $6d3f0bfe46cac913$var$_objectSpread($6d3f0bfe46cac913$var$_objectSpread({}, $6d3f0bfe46cac913$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $axMmP.default)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $453b3059df48aedd$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $6d3f0bfe46cac913$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $6d3f0bfe46cac913$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $6d3f0bfe46cac913$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $f2d64a0eb3db0ded$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $f2d64a0eb3db0ded$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f2d64a0eb3db0ded$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f2d64a0eb3db0ded$var$_typeof(o);
}
function $f2d64a0eb3db0ded$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f2d64a0eb3db0ded$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f2d64a0eb3db0ded$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f2d64a0eb3db0ded$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2d64a0eb3db0ded$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2d64a0eb3db0ded$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f2d64a0eb3db0ded$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2d64a0eb3db0ded$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f2d64a0eb3db0ded$var$_defineProperty(obj, key, value) {
    key = $f2d64a0eb3db0ded$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f2d64a0eb3db0ded$var$_toPropertyKey(t) {
    var i = $f2d64a0eb3db0ded$var$_toPrimitive(t, "string");
    return "symbol" == $f2d64a0eb3db0ded$var$_typeof(i) ? i : String(i);
}
function $f2d64a0eb3db0ded$var$_toPrimitive(t, r) {
    if ("object" != $f2d64a0eb3db0ded$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f2d64a0eb3db0ded$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $f2d64a0eb3db0ded$var$defaultPropTransformer(option, props) {
    return $f2d64a0eb3db0ded$var$_objectSpread($f2d64a0eb3db0ded$var$_objectSpread({}, props), option);
}
function $f2d64a0eb3db0ded$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $f2d64a0eb3db0ded$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $c0f721a3b6bafaa4$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $04f0670ba82b8c97$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $6d3f0bfe46cac913$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($f2d64a0eb3db0ded$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $b03b683f83f72751$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $f2d64a0eb3db0ded$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(option)) return option.props;
    return option;
}
function $f2d64a0eb3db0ded$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $f2d64a0eb3db0ded$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $f2d64a0eb3db0ded$var$_objectWithoutProperties(_ref2, $f2d64a0eb3db0ded$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(option)) shape = /*#__PURE__*/ (0, $70fFQ.cloneElement)(option, $f2d64a0eb3db0ded$var$_objectSpread($f2d64a0eb3db0ded$var$_objectSpread({}, props), $f2d64a0eb3db0ded$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($aba82bbc3cf689dd$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($5056b63f10015155$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f2d64a0eb3db0ded$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($f2d64a0eb3db0ded$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $f2d64a0eb3db0ded$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $f2d64a0eb3db0ded$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $f2d64a0eb3db0ded$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $f2d64a0eb3db0ded$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $f2d64a0eb3db0ded$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $f2d64a0eb3db0ded$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $f2d64a0eb3db0ded$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($f2d64a0eb3db0ded$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $f2d64a0eb3db0ded$export$7c9a98b3f068686f;
    else if ($f2d64a0eb3db0ded$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $f2d64a0eb3db0ded$export$b356b51e8337a02f;
    else if ($f2d64a0eb3db0ded$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $f2d64a0eb3db0ded$export$559c3a78b4889350;
    return comparison;
}
function $f2d64a0eb3db0ded$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($f2d64a0eb3db0ded$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($f2d64a0eb3db0ded$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($f2d64a0eb3db0ded$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $f2d64a0eb3db0ded$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($f2d64a0eb3db0ded$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($f2d64a0eb3db0ded$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($f2d64a0eb3db0ded$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $f2d64a0eb3db0ded$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $f2d64a0eb3db0ded$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $f2d64a0eb3db0ded$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $f2d64a0eb3db0ded$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


var $a476105a50608ff4$var$_Pie;
function $a476105a50608ff4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a476105a50608ff4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a476105a50608ff4$var$_typeof(o);
}
function $a476105a50608ff4$var$_extends() {
    $a476105a50608ff4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a476105a50608ff4$var$_extends.apply(this, arguments);
}
function $a476105a50608ff4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a476105a50608ff4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a476105a50608ff4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a476105a50608ff4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a476105a50608ff4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a476105a50608ff4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a476105a50608ff4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a476105a50608ff4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a476105a50608ff4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a476105a50608ff4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a476105a50608ff4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a476105a50608ff4$var$_callSuper(t, o, e) {
    return o = $a476105a50608ff4$var$_getPrototypeOf(o), $a476105a50608ff4$var$_possibleConstructorReturn(t, $a476105a50608ff4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a476105a50608ff4$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a476105a50608ff4$var$_possibleConstructorReturn(self, call) {
    if (call && ($a476105a50608ff4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a476105a50608ff4$var$_assertThisInitialized(self);
}
function $a476105a50608ff4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a476105a50608ff4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a476105a50608ff4$var$_getPrototypeOf(o) {
    $a476105a50608ff4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a476105a50608ff4$var$_getPrototypeOf(o);
}
function $a476105a50608ff4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a476105a50608ff4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a476105a50608ff4$var$_setPrototypeOf(subClass, superClass);
}
function $a476105a50608ff4$var$_setPrototypeOf(o, p) {
    $a476105a50608ff4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a476105a50608ff4$var$_setPrototypeOf(o, p);
}
function $a476105a50608ff4$var$_defineProperty(obj, key, value) {
    key = $a476105a50608ff4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a476105a50608ff4$var$_toPropertyKey(t) {
    var i = $a476105a50608ff4$var$_toPrimitive(t, "string");
    return "symbol" == $a476105a50608ff4$var$_typeof(i) ? i : String(i);
}
function $a476105a50608ff4$var$_toPrimitive(t, r) {
    if ("object" != $a476105a50608ff4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a476105a50608ff4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a476105a50608ff4$export$2ae8800cf67c848c = /*#__PURE__*/ function(_PureComponent) {
    $a476105a50608ff4$var$_inherits(Pie, _PureComponent);
    function Pie(props) {
        var _this;
        $a476105a50608ff4$var$_classCallCheck(this, Pie);
        _this = $a476105a50608ff4$var$_callSuper(this, Pie, [
            props
        ]);
        $a476105a50608ff4$var$_defineProperty($a476105a50608ff4$var$_assertThisInitialized(_this), "pieRef", null);
        $a476105a50608ff4$var$_defineProperty($a476105a50608ff4$var$_assertThisInitialized(_this), "sectorRefs", []);
        $a476105a50608ff4$var$_defineProperty($a476105a50608ff4$var$_assertThisInitialized(_this), "id", (0, $453b3059df48aedd$export$8b15d37bc3f197d4)('recharts-pie-'));
        $a476105a50608ff4$var$_defineProperty($a476105a50608ff4$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $a476105a50608ff4$var$_defineProperty($a476105a50608ff4$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    $a476105a50608ff4$var$_createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                var customLabelProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(label, false);
                var customLabelLineProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(labelLine, false);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({}, pieProps), entry), {}, {
                        stroke: 'none'
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({}, pieProps), entry), {}, {
                        fill: 'none',
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ],
                        key: 'line'
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(valueKey)) realDataKey = 'value';
                    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(dataKey)) realDataKey = valueKey;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                        key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps), Pie.renderLabelItem(label, labelProps, (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, realDataKey))));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
                    var isActive = _this2.isActiveIndex(i);
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = isActive ? activeShape : inactiveShape;
                    var sectorProps = $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke,
                        tabIndex: -1
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $a476105a50608ff4$var$_extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f2d64a0eb3db0ded$export$6428a7f2611ef1fa), $a476105a50608ff4$var$_extends({
                        option: sectorOptions,
                        isActive: isActive,
                        shapeType: "sector"
                    }, sectorProps)));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(entry, 'paddingAngle', 0) : 0;
                        if (prev) {
                            var angleIp = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case 'ArrowLeft':
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case 'ArrowRight':
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case 'Escape':
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(cx) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(cy) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(innerRadius) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(outerRadius)) return null;
                var layerClass = (0, $axMmP.default)('recharts-pie', className);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    tabIndex: this.props.rootTabIndex,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, $e8d2d091029884ea$export$b04be29aa201d4f5).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, $f77ba05e9211fcd7$export$835fcf23ab7bf88).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return 'start';
                if (x < cx) return 'end';
                return 'middle';
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) return option(props);
                var className = (0, $axMmP.default)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1), $a476105a50608ff4$var$_extends({}, props, {
                    type: "linear",
                    className: className
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                var label = value;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(label)) return label;
                }
                var className = (0, $axMmP.default)('recharts-pie-label-text', typeof option !== 'boolean' && !(0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option) ? option.className : '');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f01a70744931f940$export$5f1af8db9871e1d6), $a476105a50608ff4$var$_extends({}, props, {
                    alignmentBaseline: "middle",
                    className: className
                }), label);
            }
        }
    ]);
    return Pie;
}((0, $70fFQ.PureComponent));
$a476105a50608ff4$var$_Pie = $a476105a50608ff4$export$2ae8800cf67c848c;
$a476105a50608ff4$var$_defineProperty($a476105a50608ff4$export$2ae8800cf67c848c, "displayName", 'Pie');
$a476105a50608ff4$var$_defineProperty($a476105a50608ff4$export$2ae8800cf67c848c, "defaultProps", {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    cx: '50%',
    cy: '50%',
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: '80%',
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    blendStroke: false,
    rootTabIndex: 0
});
$a476105a50608ff4$var$_defineProperty($a476105a50608ff4$export$2ae8800cf67c848c, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, $453b3059df48aedd$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
$a476105a50608ff4$var$_defineProperty($a476105a50608ff4$export$2ae8800cf67c848c, "getRealPieData", function(item) {
    var _item$props = item.props, data = _item$props.data, children = _item$props.children;
    var presentationProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(item.props, false);
    var cells = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $6ebe10030e701f4c$export$f6f0c3fe4ec306ea));
    if (data && data.length) return data.map(function(entry, index) {
        return $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
$a476105a50608ff4$var$_defineProperty($a476105a50608ff4$export$2ae8800cf67c848c, "parseCoordinateOfPie", function(item, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, $a9c74f58ba1355cc$export$ad5c48602371adfa)(width, height);
    var cx = left + (0, $453b3059df48aedd$export$476354dbf49bdff6)(item.props.cx, width, width / 2);
    var cy = top + (0, $453b3059df48aedd$export$476354dbf49bdff6)(item.props.cy, height, height / 2);
    var innerRadius = (0, $453b3059df48aedd$export$476354dbf49bdff6)(item.props.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, $453b3059df48aedd$export$476354dbf49bdff6)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
$a476105a50608ff4$var$_defineProperty($a476105a50608ff4$export$2ae8800cf67c848c, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var pieData = $a476105a50608ff4$var$_Pie.getRealPieData(item);
    if (!pieData || !pieData.length) return null;
    var _item$props2 = item.props, cornerRadius = _item$props2.cornerRadius, startAngle = _item$props2.startAngle, endAngle = _item$props2.endAngle, paddingAngle = _item$props2.paddingAngle, dataKey = _item$props2.dataKey, nameKey = _item$props2.nameKey, valueKey = _item$props2.valueKey, tooltipType = _item$props2.tooltipType;
    var minAngle = Math.abs(item.props.minAngle);
    var coordinate = $a476105a50608ff4$var$_Pie.parseCoordinateOfPie(item, offset);
    var deltaAngle = $a476105a50608ff4$var$_Pie.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(valueKey)) {
        (0, $425eb72df2965775$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = 'value';
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(dataKey)) {
        (0, $425eb72df2965775$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, realDataKey, 0);
        return result + ((0, $453b3059df48aedd$export$7e4aa119212bc614)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, realDataKey, 0);
            var name = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, nameKey, i);
            var percent = ((0, $453b3059df48aedd$export$7e4aa119212bc614)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, $453b3059df48aedd$export$9d334328eb75e624)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $453b3059df48aedd$export$9d334328eb75e624)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, $453b3059df48aedd$export$9d334328eb75e624)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return $a476105a50608ff4$var$_objectSpread($a476105a50608ff4$var$_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

/**
 * @fileOverview Pie Chart
 */ 
var $70fFQ = parcelRequire("70fFQ");


var $4f8af09a991e04d2$exports = {};
var $6affd458340daa81$exports = {};
var $12ba6c1325afd59f$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $12ba6c1325afd59f$var$nativeCeil = Math.ceil, $12ba6c1325afd59f$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $12ba6c1325afd59f$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $12ba6c1325afd59f$var$nativeMax($12ba6c1325afd59f$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$12ba6c1325afd59f$exports = $12ba6c1325afd59f$var$baseRange;



var $eeca356013e254c3$exports = {};
var $6435bf026c76031a$exports = {};
var $00e1b360e3809213$exports = {};
var $34b16b8a90d55c24$exports = {};
/** Used to match a single whitespace character. */ var $34b16b8a90d55c24$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $34b16b8a90d55c24$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $34b16b8a90d55c24$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$34b16b8a90d55c24$exports = $34b16b8a90d55c24$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $00e1b360e3809213$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $00e1b360e3809213$var$baseTrim(string) {
    return string ? string.slice(0, $34b16b8a90d55c24$exports(string) + 1).replace($00e1b360e3809213$var$reTrimStart, '') : string;
}
$00e1b360e3809213$exports = $00e1b360e3809213$var$baseTrim;




/** Used as references for various `Number` constants. */ var $6435bf026c76031a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $6435bf026c76031a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6435bf026c76031a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6435bf026c76031a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6435bf026c76031a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6435bf026c76031a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($383d33c6e13780df$exports(value)) return $6435bf026c76031a$var$NAN;
    if ($b3d1e6aa1c534f86$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $b3d1e6aa1c534f86$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $00e1b360e3809213$exports(value);
    var isBinary = $6435bf026c76031a$var$reIsBinary.test(value);
    return isBinary || $6435bf026c76031a$var$reIsOctal.test(value) ? $6435bf026c76031a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6435bf026c76031a$var$reIsBadHex.test(value) ? $6435bf026c76031a$var$NAN : +value;
}
$6435bf026c76031a$exports = $6435bf026c76031a$var$toNumber;


/** Used as references for various `Number` constants. */ var $eeca356013e254c3$var$INFINITY = 1 / 0, $eeca356013e254c3$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $eeca356013e254c3$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $6435bf026c76031a$exports(value);
    if (value === $eeca356013e254c3$var$INFINITY || value === -$eeca356013e254c3$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $eeca356013e254c3$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$eeca356013e254c3$exports = $eeca356013e254c3$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $6affd458340daa81$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $8d786ecf76c18222$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $eeca356013e254c3$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $eeca356013e254c3$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $eeca356013e254c3$exports(step);
        return $12ba6c1325afd59f$exports(start, end, step, fromRight);
    };
}
$6affd458340daa81$exports = $6affd458340daa81$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $4f8af09a991e04d2$var$range = $6affd458340daa81$exports();
$4f8af09a991e04d2$exports = $4f8af09a991e04d2$var$range;




var $2003fcc117392f52$exports = {};
var $617e2a1ed64a0c98$exports = {};

var $0493e1ee5f3c7877$exports = {};

var $3KrFG = parcelRequire("3KrFG");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $0493e1ee5f3c7877$var$now = function() {
    return $3KrFG.Date.now();
};
$0493e1ee5f3c7877$exports = $0493e1ee5f3c7877$var$now;



/** Error message constants. */ var $617e2a1ed64a0c98$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $617e2a1ed64a0c98$var$nativeMax = Math.max, $617e2a1ed64a0c98$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $617e2a1ed64a0c98$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($617e2a1ed64a0c98$var$FUNC_ERROR_TEXT);
    wait = $6435bf026c76031a$exports(wait) || 0;
    if ($b3d1e6aa1c534f86$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $617e2a1ed64a0c98$var$nativeMax($6435bf026c76031a$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $617e2a1ed64a0c98$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $0493e1ee5f3c7877$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($0493e1ee5f3c7877$exports());
    }
    function debounced() {
        var time = $0493e1ee5f3c7877$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$617e2a1ed64a0c98$exports = $617e2a1ed64a0c98$var$debounce;



/** Error message constants. */ var $2003fcc117392f52$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $2003fcc117392f52$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($2003fcc117392f52$var$FUNC_ERROR_TEXT);
    if ($b3d1e6aa1c534f86$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $617e2a1ed64a0c98$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$2003fcc117392f52$exports = $2003fcc117392f52$var$throttle;



var $axMmP = parcelRequire("axMmP");




var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");



var $axMmP = parcelRequire("axMmP");

function $1407ce9ad96ea31f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1407ce9ad96ea31f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1407ce9ad96ea31f$var$_typeof(o);
}
function $1407ce9ad96ea31f$var$_extends() {
    $1407ce9ad96ea31f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1407ce9ad96ea31f$var$_extends.apply(this, arguments);
}
function $1407ce9ad96ea31f$var$_slicedToArray(arr, i) {
    return $1407ce9ad96ea31f$var$_arrayWithHoles(arr) || $1407ce9ad96ea31f$var$_iterableToArrayLimit(arr, i) || $1407ce9ad96ea31f$var$_unsupportedIterableToArray(arr, i) || $1407ce9ad96ea31f$var$_nonIterableRest();
}
function $1407ce9ad96ea31f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1407ce9ad96ea31f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1407ce9ad96ea31f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1407ce9ad96ea31f$var$_arrayLikeToArray(o, minLen);
}
function $1407ce9ad96ea31f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1407ce9ad96ea31f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1407ce9ad96ea31f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1407ce9ad96ea31f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1407ce9ad96ea31f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1407ce9ad96ea31f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1407ce9ad96ea31f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1407ce9ad96ea31f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1407ce9ad96ea31f$var$_defineProperty(obj, key, value) {
    key = $1407ce9ad96ea31f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1407ce9ad96ea31f$var$_toPropertyKey(t) {
    var i = $1407ce9ad96ea31f$var$_toPrimitive(t, "string");
    return "symbol" == $1407ce9ad96ea31f$var$_typeof(i) ? i : String(i);
}
function $1407ce9ad96ea31f$var$_toPrimitive(t, r) {
    if ("object" != $1407ce9ad96ea31f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1407ce9ad96ea31f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1407ce9ad96ea31f$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $453b3059df48aedd$export$402a499e1ea44294)(value[0]) && (0, $453b3059df48aedd$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $1407ce9ad96ea31f$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($f30c977dfc6b9355$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $1407ce9ad96ea31f$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $1407ce9ad96ea31f$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $1407ce9ad96ea31f$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $453b3059df48aedd$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $453b3059df48aedd$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $1407ce9ad96ea31f$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $1407ce9ad96ea31f$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $axMmP.default)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $axMmP.default)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("div", $1407ce9ad96ea31f$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");

function $1ea91f2e921d2eb5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1ea91f2e921d2eb5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1ea91f2e921d2eb5$var$_typeof(o);
}
function $1ea91f2e921d2eb5$var$_defineProperty(obj, key, value) {
    key = $1ea91f2e921d2eb5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ea91f2e921d2eb5$var$_toPropertyKey(t) {
    var i = $1ea91f2e921d2eb5$var$_toPrimitive(t, "string");
    return "symbol" == $1ea91f2e921d2eb5$var$_typeof(i) ? i : String(i);
}
function $1ea91f2e921d2eb5$var$_toPrimitive(t, r) {
    if ("object" != $1ea91f2e921d2eb5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1ea91f2e921d2eb5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1ea91f2e921d2eb5$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $1ea91f2e921d2eb5$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $1ea91f2e921d2eb5$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $axMmP.default)($1ea91f2e921d2eb5$var$CSS_CLASS_PREFIX, $1ea91f2e921d2eb5$var$_defineProperty($1ea91f2e921d2eb5$var$_defineProperty($1ea91f2e921d2eb5$var$_defineProperty($1ea91f2e921d2eb5$var$_defineProperty({}, "".concat($1ea91f2e921d2eb5$var$CSS_CLASS_PREFIX, "-right"), (0, $453b3059df48aedd$export$7e4aa119212bc614)(translateX) && coordinate && (0, $453b3059df48aedd$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($1ea91f2e921d2eb5$var$CSS_CLASS_PREFIX, "-left"), (0, $453b3059df48aedd$export$7e4aa119212bc614)(translateX) && coordinate && (0, $453b3059df48aedd$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($1ea91f2e921d2eb5$var$CSS_CLASS_PREFIX, "-bottom"), (0, $453b3059df48aedd$export$7e4aa119212bc614)(translateY) && coordinate && (0, $453b3059df48aedd$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($1ea91f2e921d2eb5$var$CSS_CLASS_PREFIX, "-top"), (0, $453b3059df48aedd$export$7e4aa119212bc614)(translateY) && coordinate && (0, $453b3059df48aedd$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $1ea91f2e921d2eb5$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $453b3059df48aedd$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $1ea91f2e921d2eb5$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $1ea91f2e921d2eb5$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $1ea91f2e921d2eb5$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $1ea91f2e921d2eb5$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $1ea91f2e921d2eb5$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $1ea91f2e921d2eb5$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $1ea91f2e921d2eb5$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $27e2970ad41f72ab$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $27e2970ad41f72ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $27e2970ad41f72ab$var$_typeof(o);
}
function $27e2970ad41f72ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27e2970ad41f72ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27e2970ad41f72ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            $27e2970ad41f72ab$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27e2970ad41f72ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $27e2970ad41f72ab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $27e2970ad41f72ab$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $27e2970ad41f72ab$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $27e2970ad41f72ab$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $27e2970ad41f72ab$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $27e2970ad41f72ab$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $27e2970ad41f72ab$var$_callSuper(t, o, e) {
    return o = $27e2970ad41f72ab$var$_getPrototypeOf(o), $27e2970ad41f72ab$var$_possibleConstructorReturn(t, $27e2970ad41f72ab$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $27e2970ad41f72ab$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $27e2970ad41f72ab$var$_possibleConstructorReturn(self, call) {
    if (call && ($27e2970ad41f72ab$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $27e2970ad41f72ab$var$_assertThisInitialized(self);
}
function $27e2970ad41f72ab$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($27e2970ad41f72ab$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $27e2970ad41f72ab$var$_getPrototypeOf(o) {
    $27e2970ad41f72ab$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $27e2970ad41f72ab$var$_getPrototypeOf(o);
}
function $27e2970ad41f72ab$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $27e2970ad41f72ab$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $27e2970ad41f72ab$var$_setPrototypeOf(subClass, superClass);
}
function $27e2970ad41f72ab$var$_setPrototypeOf(o, p) {
    $27e2970ad41f72ab$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $27e2970ad41f72ab$var$_setPrototypeOf(o, p);
}
function $27e2970ad41f72ab$var$_defineProperty(obj, key, value) {
    key = $27e2970ad41f72ab$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27e2970ad41f72ab$var$_toPropertyKey(t) {
    var i = $27e2970ad41f72ab$var$_toPrimitive(t, "string");
    return "symbol" == $27e2970ad41f72ab$var$_typeof(i) ? i : String(i);
}
function $27e2970ad41f72ab$var$_toPrimitive(t, r) {
    if ("object" != $27e2970ad41f72ab$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $27e2970ad41f72ab$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $27e2970ad41f72ab$var$EPSILON = 1;
var $27e2970ad41f72ab$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    $27e2970ad41f72ab$var$_inherits(TooltipBoundingBox, _PureComponent);
    function TooltipBoundingBox() {
        var _this;
        $27e2970ad41f72ab$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $27e2970ad41f72ab$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $27e2970ad41f72ab$var$_defineProperty($27e2970ad41f72ab$var$_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $27e2970ad41f72ab$var$_defineProperty($27e2970ad41f72ab$var$_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $27e2970ad41f72ab$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $27e2970ad41f72ab$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $27e2970ad41f72ab$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $1ea91f2e921d2eb5$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $27e2970ad41f72ab$var$_objectSpread($27e2970ad41f72ab$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, $70fFQ.PureComponent));




function $9c6bfe96f56d0a02$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9c6bfe96f56d0a02$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9c6bfe96f56d0a02$var$_typeof(o);
}
function $9c6bfe96f56d0a02$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c6bfe96f56d0a02$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c6bfe96f56d0a02$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9c6bfe96f56d0a02$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c6bfe96f56d0a02$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9c6bfe96f56d0a02$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9c6bfe96f56d0a02$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9c6bfe96f56d0a02$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9c6bfe96f56d0a02$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9c6bfe96f56d0a02$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9c6bfe96f56d0a02$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9c6bfe96f56d0a02$var$_callSuper(t, o, e) {
    return o = $9c6bfe96f56d0a02$var$_getPrototypeOf(o), $9c6bfe96f56d0a02$var$_possibleConstructorReturn(t, $9c6bfe96f56d0a02$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $9c6bfe96f56d0a02$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $9c6bfe96f56d0a02$var$_possibleConstructorReturn(self, call) {
    if (call && ($9c6bfe96f56d0a02$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9c6bfe96f56d0a02$var$_assertThisInitialized(self);
}
function $9c6bfe96f56d0a02$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9c6bfe96f56d0a02$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9c6bfe96f56d0a02$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9c6bfe96f56d0a02$var$_getPrototypeOf(o) {
    $9c6bfe96f56d0a02$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9c6bfe96f56d0a02$var$_getPrototypeOf(o);
}
function $9c6bfe96f56d0a02$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9c6bfe96f56d0a02$var$_setPrototypeOf(subClass, superClass);
}
function $9c6bfe96f56d0a02$var$_setPrototypeOf(o, p) {
    $9c6bfe96f56d0a02$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9c6bfe96f56d0a02$var$_setPrototypeOf(o, p);
}
function $9c6bfe96f56d0a02$var$_defineProperty(obj, key, value) {
    key = $9c6bfe96f56d0a02$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9c6bfe96f56d0a02$var$_toPropertyKey(t) {
    var i = $9c6bfe96f56d0a02$var$_toPrimitive(t, "string");
    return "symbol" == $9c6bfe96f56d0a02$var$_typeof(i) ? i : String(i);
}
function $9c6bfe96f56d0a02$var$_toPrimitive(t, r) {
    if ("object" != $9c6bfe96f56d0a02$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9c6bfe96f56d0a02$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9c6bfe96f56d0a02$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $9c6bfe96f56d0a02$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $1407ce9ad96ea31f$export$6fe33945eebf9ac8), props);
}
var $9c6bfe96f56d0a02$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $9c6bfe96f56d0a02$var$_inherits(Tooltip, _PureComponent);
    function Tooltip() {
        $9c6bfe96f56d0a02$var$_classCallCheck(this, Tooltip);
        return $9c6bfe96f56d0a02$var$_callSuper(this, Tooltip, arguments);
    }
    $9c6bfe96f56d0a02$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $ddc8730ee9c3cd89$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $9c6bfe96f56d0a02$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $27e2970ad41f72ab$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $9c6bfe96f56d0a02$var$renderContent(content, $9c6bfe96f56d0a02$var$_objectSpread($9c6bfe96f56d0a02$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $70fFQ.PureComponent));
$9c6bfe96f56d0a02$var$_defineProperty($9c6bfe96f56d0a02$export$28c660c63b792dea, "displayName", 'Tooltip');
$9c6bfe96f56d0a02$var$_defineProperty($9c6bfe96f56d0a02$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");


function $d509b7e1d2bfee51$var$_extends() {
    $d509b7e1d2bfee51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d509b7e1d2bfee51$var$_extends.apply(this, arguments);
}
var $d509b7e1d2bfee51$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $axMmP.default)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("circle", $d509b7e1d2bfee51$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, false), (0, $e11a437526851c08$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");







function $cbabe1eb27de938a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cbabe1eb27de938a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cbabe1eb27de938a$var$_typeof(o);
}
function $cbabe1eb27de938a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbabe1eb27de938a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbabe1eb27de938a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cbabe1eb27de938a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbabe1eb27de938a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cbabe1eb27de938a$var$_defineProperty(obj, key, value) {
    key = $cbabe1eb27de938a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cbabe1eb27de938a$var$_toPropertyKey(t) {
    var i = $cbabe1eb27de938a$var$_toPrimitive(t, "string");
    return "symbol" == $cbabe1eb27de938a$var$_typeof(i) ? i : String(i);
}
function $cbabe1eb27de938a$var$_toPrimitive(t, r) {
    if ("object" != $cbabe1eb27de938a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cbabe1eb27de938a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $cbabe1eb27de938a$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $cbabe1eb27de938a$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $cbabe1eb27de938a$var$PREFIX_LIST.reduce(function(res, entry) {
        return $cbabe1eb27de938a$var$_objectSpread($cbabe1eb27de938a$var$_objectSpread({}, res), {}, $cbabe1eb27de938a$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $052b95d1dd0554f6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $052b95d1dd0554f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $052b95d1dd0554f6$var$_typeof(o);
}
function $052b95d1dd0554f6$var$_extends() {
    $052b95d1dd0554f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $052b95d1dd0554f6$var$_extends.apply(this, arguments);
}
function $052b95d1dd0554f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $052b95d1dd0554f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $052b95d1dd0554f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $052b95d1dd0554f6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $052b95d1dd0554f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $052b95d1dd0554f6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $052b95d1dd0554f6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $052b95d1dd0554f6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $052b95d1dd0554f6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $052b95d1dd0554f6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $052b95d1dd0554f6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $052b95d1dd0554f6$var$_callSuper(t, o, e) {
    return o = $052b95d1dd0554f6$var$_getPrototypeOf(o), $052b95d1dd0554f6$var$_possibleConstructorReturn(t, $052b95d1dd0554f6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $052b95d1dd0554f6$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $052b95d1dd0554f6$var$_possibleConstructorReturn(self, call) {
    if (call && ($052b95d1dd0554f6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $052b95d1dd0554f6$var$_assertThisInitialized(self);
}
function $052b95d1dd0554f6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($052b95d1dd0554f6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $052b95d1dd0554f6$var$_getPrototypeOf(o) {
    $052b95d1dd0554f6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $052b95d1dd0554f6$var$_getPrototypeOf(o);
}
function $052b95d1dd0554f6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $052b95d1dd0554f6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $052b95d1dd0554f6$var$_setPrototypeOf(subClass, superClass);
}
function $052b95d1dd0554f6$var$_setPrototypeOf(o, p) {
    $052b95d1dd0554f6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $052b95d1dd0554f6$var$_setPrototypeOf(o, p);
}
function $052b95d1dd0554f6$var$_defineProperty(obj, key, value) {
    key = $052b95d1dd0554f6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $052b95d1dd0554f6$var$_toPropertyKey(t) {
    var i = $052b95d1dd0554f6$var$_toPrimitive(t, "string");
    return "symbol" == $052b95d1dd0554f6$var$_typeof(i) ? i : String(i);
}
function $052b95d1dd0554f6$var$_toPrimitive(t, r) {
    if ("object" != $052b95d1dd0554f6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $052b95d1dd0554f6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $052b95d1dd0554f6$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $0976c92ed4d25575$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($4f8af09a991e04d2$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $052b95d1dd0554f6$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $052b95d1dd0554f6$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $052b95d1dd0554f6$var$_inherits(Brush, _PureComponent);
    function Brush(props) {
        var _this;
        $052b95d1dd0554f6$var$_classCallCheck(this, Brush);
        _this = $052b95d1dd0554f6$var$_callSuper(this, Brush, [
            props
        ]);
        $052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $052b95d1dd0554f6$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($052b95d1dd0554f6$var$_assertThisInitialized(_this), 'startX'),
            endX: _this.handleTravellerDragStart.bind($052b95d1dd0554f6$var$_assertThisInitialized(_this), 'endX')
        };
        _this.state = {};
        return _this;
    }
    $052b95d1dd0554f6$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $052b95d1dd0554f6$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($052b95d1dd0554f6$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $70fFQ.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $052b95d1dd0554f6$var$_objectSpread($052b95d1dd0554f6$var$_objectSpread({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f01a70744931f940$export$5f1af8db9871e1d6), $052b95d1dd0554f6$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f01a70744931f940$export$5f1af8db9871e1d6), $052b95d1dd0554f6$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(x) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(y) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(width) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $axMmP.default)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.count(children) === 1;
                var style = (0, $cbabe1eb27de938a$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $052b95d1dd0554f6$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $052b95d1dd0554f6$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $70fFQ.PureComponent));
$052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$export$59bc2e3533b384a0, "displayName", 'Brush');
$052b95d1dd0554f6$var$_defineProperty($052b95d1dd0554f6$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $70fFQ = parcelRequire("70fFQ");


var $axMmP = parcelRequire("axMmP");




var $ab8bbca642734c75$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};


var $58f05ffd402549d8$exports = {};
var $7ded4698ef435a4c$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7ded4698ef435a4c$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $9fe91ffd91812deb$exports) $9fe91ffd91812deb$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$7ded4698ef435a4c$exports = $7ded4698ef435a4c$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $58f05ffd402549d8$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1316a39af77ac4e6$exports(iteratee, 3);
    $6e0b37a4a8b8a230$exports(object, function(value, key, object) {
        $7ded4698ef435a4c$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$58f05ffd402549d8$exports = $58f05ffd402549d8$var$mapValues;


var $45fc7190daf2cd22$exports = {};
var $3244f51cc9da4401$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $3244f51cc9da4401$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$3244f51cc9da4401$exports = $3244f51cc9da4401$var$arrayEvery;


var $171821d4c7acb19e$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $171821d4c7acb19e$var$baseEvery(collection, predicate) {
    var result = true;
    $7a7a9c233f315af2$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$171821d4c7acb19e$exports = $171821d4c7acb19e$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $45fc7190daf2cd22$var$every(collection, predicate, guard) {
    var func = $df41e7dc5257abcb$exports(collection) ? $3244f51cc9da4401$exports : $171821d4c7acb19e$exports;
    if (guard && $8d786ecf76c18222$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $1316a39af77ac4e6$exports(predicate, 3));
}
$45fc7190daf2cd22$exports = $45fc7190daf2cd22$var$every;






var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");













var $70fFQ = parcelRequire("70fFQ");


var $b85e47d0cc68ff54$var$_excluded = [
    "x",
    "y"
];
function $b85e47d0cc68ff54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b85e47d0cc68ff54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b85e47d0cc68ff54$var$_typeof(o);
}
function $b85e47d0cc68ff54$var$_extends() {
    $b85e47d0cc68ff54$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b85e47d0cc68ff54$var$_extends.apply(this, arguments);
}
function $b85e47d0cc68ff54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b85e47d0cc68ff54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b85e47d0cc68ff54$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b85e47d0cc68ff54$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b85e47d0cc68ff54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b85e47d0cc68ff54$var$_defineProperty(obj, key, value) {
    key = $b85e47d0cc68ff54$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b85e47d0cc68ff54$var$_toPropertyKey(t) {
    var i = $b85e47d0cc68ff54$var$_toPrimitive(t, "string");
    return "symbol" == $b85e47d0cc68ff54$var$_typeof(i) ? i : String(i);
}
function $b85e47d0cc68ff54$var$_toPrimitive(t, r) {
    if ("object" != $b85e47d0cc68ff54$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b85e47d0cc68ff54$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b85e47d0cc68ff54$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b85e47d0cc68ff54$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b85e47d0cc68ff54$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $b85e47d0cc68ff54$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $b85e47d0cc68ff54$var$_objectWithoutProperties(_ref, $b85e47d0cc68ff54$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $b85e47d0cc68ff54$var$_objectSpread($b85e47d0cc68ff54$var$_objectSpread($b85e47d0cc68ff54$var$_objectSpread($b85e47d0cc68ff54$var$_objectSpread($b85e47d0cc68ff54$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $b85e47d0cc68ff54$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f2d64a0eb3db0ded$export$6428a7f2611ef1fa), $b85e47d0cc68ff54$var$_extends({
        shapeType: "rectangle",
        propTransformer: $b85e47d0cc68ff54$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $b85e47d0cc68ff54$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumber = typeof value === 'number';
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, $0da1c288545eac50$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $7c0a47df8064ce07$var$_excluded = [
    "value",
    "background"
];
var $7c0a47df8064ce07$var$_Bar;
function $7c0a47df8064ce07$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7c0a47df8064ce07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7c0a47df8064ce07$var$_typeof(o);
}
function $7c0a47df8064ce07$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7c0a47df8064ce07$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7c0a47df8064ce07$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7c0a47df8064ce07$var$_extends() {
    $7c0a47df8064ce07$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c0a47df8064ce07$var$_extends.apply(this, arguments);
}
function $7c0a47df8064ce07$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c0a47df8064ce07$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c0a47df8064ce07$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7c0a47df8064ce07$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c0a47df8064ce07$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7c0a47df8064ce07$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7c0a47df8064ce07$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7c0a47df8064ce07$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7c0a47df8064ce07$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7c0a47df8064ce07$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7c0a47df8064ce07$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7c0a47df8064ce07$var$_callSuper(t, o, e) {
    return o = $7c0a47df8064ce07$var$_getPrototypeOf(o), $7c0a47df8064ce07$var$_possibleConstructorReturn(t, $7c0a47df8064ce07$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7c0a47df8064ce07$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7c0a47df8064ce07$var$_possibleConstructorReturn(self, call) {
    if (call && ($7c0a47df8064ce07$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7c0a47df8064ce07$var$_assertThisInitialized(self);
}
function $7c0a47df8064ce07$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7c0a47df8064ce07$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7c0a47df8064ce07$var$_getPrototypeOf(o) {
    $7c0a47df8064ce07$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7c0a47df8064ce07$var$_getPrototypeOf(o);
}
function $7c0a47df8064ce07$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7c0a47df8064ce07$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7c0a47df8064ce07$var$_setPrototypeOf(subClass, superClass);
}
function $7c0a47df8064ce07$var$_setPrototypeOf(o, p) {
    $7c0a47df8064ce07$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7c0a47df8064ce07$var$_setPrototypeOf(o, p);
}
function $7c0a47df8064ce07$var$_defineProperty(obj, key, value) {
    key = $7c0a47df8064ce07$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7c0a47df8064ce07$var$_toPropertyKey(t) {
    var i = $7c0a47df8064ce07$var$_toPrimitive(t, "string");
    return "symbol" == $7c0a47df8064ce07$var$_typeof(i) ? i : String(i);
}
function $7c0a47df8064ce07$var$_toPrimitive(t, r) {
    if ("object" != $7c0a47df8064ce07$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7c0a47df8064ce07$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7c0a47df8064ce07$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $7c0a47df8064ce07$var$_inherits(Bar, _PureComponent);
    function Bar() {
        var _this;
        $7c0a47df8064ce07$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7c0a47df8064ce07$var$_callSuper(this, Bar, [].concat(args));
        $7c0a47df8064ce07$var$_defineProperty($7c0a47df8064ce07$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $7c0a47df8064ce07$var$_defineProperty($7c0a47df8064ce07$var$_assertThisInitialized(_this), "id", (0, $453b3059df48aedd$export$8b15d37bc3f197d4)('recharts-bar-'));
        $7c0a47df8064ce07$var$_defineProperty($7c0a47df8064ce07$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $7c0a47df8064ce07$var$_defineProperty($7c0a47df8064ce07$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $7c0a47df8064ce07$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $7c0a47df8064ce07$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $b85e47d0cc68ff54$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $7c0a47df8064ce07$var$_objectWithoutProperties(entry, $7c0a47df8064ce07$var$_excluded);
                    if (!background) return null;
                    var props = $7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $b85e47d0cc68ff54$export$f19074a6842f9217), $7c0a47df8064ce07$var$_extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $fc2e0abee97a8d1b$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $cdef3b11746f8934$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $axMmP.default)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $f77ba05e9211fcd7$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, $70fFQ.PureComponent));
$7c0a47df8064ce07$var$_Bar = $7c0a47df8064ce07$export$bbc6c6369b38e3d1;
$7c0a47df8064ce07$var$_defineProperty($7c0a47df8064ce07$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$7c0a47df8064ce07$var$_defineProperty($7c0a47df8064ce07$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $7c0a47df8064ce07$var$_defineProperty($7c0a47df8064ce07$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $cdef3b11746f8934$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSizeProp = _item$props.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $cdef3b11746f8934$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $6ebe10030e701f4c$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $cdef3b11746f8934$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $b85e47d0cc68ff54$export$c20d73790de171f0)(minPointSizeProp, $7c0a47df8064ce07$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $cdef3b11746f8934$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $453b3059df48aedd$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $cdef3b11746f8934$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $453b3059df48aedd$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread($7c0a47df8064ce07$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $cdef3b11746f8934$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $7c0a47df8064ce07$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $2b3288d276a160b8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2b3288d276a160b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2b3288d276a160b8$var$_typeof(o);
}
function $2b3288d276a160b8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2b3288d276a160b8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2b3288d276a160b8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2b3288d276a160b8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2b3288d276a160b8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2b3288d276a160b8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2b3288d276a160b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b3288d276a160b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b3288d276a160b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2b3288d276a160b8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b3288d276a160b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2b3288d276a160b8$var$_defineProperty(obj, key, value) {
    key = $2b3288d276a160b8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2b3288d276a160b8$var$_toPropertyKey(t) {
    var i = $2b3288d276a160b8$var$_toPrimitive(t, "string");
    return "symbol" == $2b3288d276a160b8$var$_typeof(i) ? i : String(i);
}
function $2b3288d276a160b8$var$_toPrimitive(t, r) {
    if ("object" != $2b3288d276a160b8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2b3288d276a160b8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2b3288d276a160b8$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $453b3059df48aedd$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $cdef3b11746f8934$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $cdef3b11746f8934$export$9d80152e23bae434)(scale);
        var ticks = (0, $cdef3b11746f8934$export$ac086aaa4358d590)(scale, $2b3288d276a160b8$var$_objectSpread($2b3288d276a160b8$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $2b3288d276a160b8$var$_objectSpread($2b3288d276a160b8$var$_objectSpread($2b3288d276a160b8$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $cdef3b11746f8934$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $2b3288d276a160b8$var$_objectSpread($2b3288d276a160b8$var$_objectSpread({}, result), {}, $2b3288d276a160b8$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $2b3288d276a160b8$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $2b3288d276a160b8$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $2b3288d276a160b8$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $2b3288d276a160b8$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $2b3288d276a160b8$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $2b3288d276a160b8$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$2b3288d276a160b8$var$_defineProperty($2b3288d276a160b8$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $2b3288d276a160b8$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $2b3288d276a160b8$var$_objectSpread($2b3288d276a160b8$var$_objectSpread({}, res), {}, $2b3288d276a160b8$var$_defineProperty({}, key, $2b3288d276a160b8$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $2b3288d276a160b8$var$_objectSpread($2b3288d276a160b8$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($58f05ffd402549d8$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fc7190daf2cd22$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $2b3288d276a160b8$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $2b3288d276a160b8$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $2b3288d276a160b8$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $dde223bfe082dea6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dde223bfe082dea6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dde223bfe082dea6$var$_typeof(o);
}
function $dde223bfe082dea6$var$_extends() {
    $dde223bfe082dea6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dde223bfe082dea6$var$_extends.apply(this, arguments);
}
function $dde223bfe082dea6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dde223bfe082dea6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dde223bfe082dea6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dde223bfe082dea6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dde223bfe082dea6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dde223bfe082dea6$var$_defineProperty(obj, key, value) {
    key = $dde223bfe082dea6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dde223bfe082dea6$var$_toPropertyKey(t) {
    var i = $dde223bfe082dea6$var$_toPrimitive(t, "string");
    return "symbol" == $dde223bfe082dea6$var$_typeof(i) ? i : String(i);
}
function $dde223bfe082dea6$var$_toPrimitive(t, r) {
    if ("object" != $dde223bfe082dea6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dde223bfe082dea6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dde223bfe082dea6$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $2b3288d276a160b8$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
function $dde223bfe082dea6$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $453b3059df48aedd$export$402a499e1ea44294)(x);
    var isY = (0, $453b3059df48aedd$export$402a499e1ea44294)(y);
    (0, $425eb72df2965775$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $dde223bfe082dea6$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $dde223bfe082dea6$var$_objectSpread($dde223bfe082dea6$var$_objectSpread({
        clipPath: clipPath
    }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        className: (0, $axMmP.default)('recharts-reference-dot', className)
    }, $dde223bfe082dea6$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $e8d2d091029884ea$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$dde223bfe082dea6$export$aa7f0b0106bff39.displayName = 'ReferenceDot';
$dde223bfe082dea6$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
};
$dde223bfe082dea6$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $d509b7e1d2bfee51$export$d046b3c4a416f60d), $dde223bfe082dea6$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};



var $70fFQ = parcelRequire("70fFQ");

var $9d2b230ef89c92d0$exports = {};


var $5735d9144816a0b5$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $5735d9144816a0b5$var$baseSome(collection, predicate) {
    var result;
    $7a7a9c233f315af2$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$5735d9144816a0b5$exports = $5735d9144816a0b5$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $9d2b230ef89c92d0$var$some(collection, predicate, guard) {
    var func = $df41e7dc5257abcb$exports(collection) ? $d7fc50af2b7aa63a$exports : $5735d9144816a0b5$exports;
    if (guard && $8d786ecf76c18222$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $1316a39af77ac4e6$exports(predicate, 3));
}
$9d2b230ef89c92d0$exports = $9d2b230ef89c92d0$var$some;



var $axMmP = parcelRequire("axMmP");








var $70fFQ = parcelRequire("70fFQ");

var $abbcfa99589bb5f8$exports = {};
var $02c8b29271107c11$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $02c8b29271107c11$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$a3e116769f9c8886$exports(collection)) {
            var iteratee = $1316a39af77ac4e6$exports(predicate, 3);
            collection = $8b0ac38f8259c849$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$02c8b29271107c11$exports = $02c8b29271107c11$var$createFind;


var $74a8007a5f101e3c$exports = {};


var $29d7ba785de3f2f1$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $29d7ba785de3f2f1$var$toInteger(value) {
    var result = $eeca356013e254c3$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$29d7ba785de3f2f1$exports = $29d7ba785de3f2f1$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $74a8007a5f101e3c$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $74a8007a5f101e3c$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $29d7ba785de3f2f1$exports(fromIndex);
    if (index < 0) index = $74a8007a5f101e3c$var$nativeMax(length + index, 0);
    return $776b070841b67cc0$exports(array, $1316a39af77ac4e6$exports(predicate, 3), index);
}
$74a8007a5f101e3c$exports = $74a8007a5f101e3c$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $abbcfa99589bb5f8$var$find = $02c8b29271107c11$exports($74a8007a5f101e3c$exports);
$abbcfa99589bb5f8$exports = $abbcfa99589bb5f8$var$find;




var $c2f1d41348d979c8$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($5eb956ceb92f8e8e$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $7ac7b265aa8e371b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7ac7b265aa8e371b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7ac7b265aa8e371b$var$_typeof(o);
}
var $7ac7b265aa8e371b$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $70fFQ.createContext)(undefined);
var $7ac7b265aa8e371b$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $70fFQ.createContext)(undefined);
var $7ac7b265aa8e371b$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $70fFQ.createContext)(undefined);
var $7ac7b265aa8e371b$export$482c85f2026f212e = /*#__PURE__*/ (0, $70fFQ.createContext)({});
var $7ac7b265aa8e371b$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $70fFQ.createContext)(undefined);
var $7ac7b265aa8e371b$export$b18854f928720bc8 = /*#__PURE__*/ (0, $70fFQ.createContext)(0);
var $7ac7b265aa8e371b$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $70fFQ.createContext)(0);
var $7ac7b265aa8e371b$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $c2f1d41348d979c8$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7ac7b265aa8e371b$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7ac7b265aa8e371b$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7ac7b265aa8e371b$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7ac7b265aa8e371b$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7ac7b265aa8e371b$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7ac7b265aa8e371b$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($7ac7b265aa8e371b$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $7ac7b265aa8e371b$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$e42cfe3f3988c70f);
};
function $7ac7b265aa8e371b$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $7ac7b265aa8e371b$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $0da1c288545eac50$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $0da1c288545eac50$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $7ac7b265aa8e371b$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$92c2a2c8239475bf);
    return (0, $453b3059df48aedd$export$b88993f0aa0bf776)(xAxisMap);
};
var $7ac7b265aa8e371b$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$40ceabe61e17c4dc);
    return (0, $453b3059df48aedd$export$b88993f0aa0bf776)(yAxisMap);
};
var $7ac7b265aa8e371b$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($abbcfa99589bb5f8$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fc7190daf2cd22$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $453b3059df48aedd$export$b88993f0aa0bf776)(yAxisMap);
};
var $7ac7b265aa8e371b$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $0da1c288545eac50$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $0da1c288545eac50$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $7ac7b265aa8e371b$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$29b7735f8b5653b2);
    return viewBox;
};
var $7ac7b265aa8e371b$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$482c85f2026f212e);
};
var $7ac7b265aa8e371b$export$8854f7ece606854b = function useChartWidth() {
    return (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$3c3f0c9338cf7530);
};
var $7ac7b265aa8e371b$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $70fFQ.useContext)($7ac7b265aa8e371b$export$b18854f928720bc8);
};


function $5cd0beeb16898d0b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5cd0beeb16898d0b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5cd0beeb16898d0b$var$_typeof(o);
}
function $5cd0beeb16898d0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5cd0beeb16898d0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5cd0beeb16898d0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5cd0beeb16898d0b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5cd0beeb16898d0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5cd0beeb16898d0b$var$_defineProperty(obj, key, value) {
    key = $5cd0beeb16898d0b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5cd0beeb16898d0b$var$_toPropertyKey(t) {
    var i = $5cd0beeb16898d0b$var$_toPrimitive(t, "string");
    return "symbol" == $5cd0beeb16898d0b$var$_typeof(i) ? i : String(i);
}
function $5cd0beeb16898d0b$var$_toPrimitive(t, r) {
    if ("object" != $5cd0beeb16898d0b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5cd0beeb16898d0b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5cd0beeb16898d0b$var$_slicedToArray(arr, i) {
    return $5cd0beeb16898d0b$var$_arrayWithHoles(arr) || $5cd0beeb16898d0b$var$_iterableToArrayLimit(arr, i) || $5cd0beeb16898d0b$var$_unsupportedIterableToArray(arr, i) || $5cd0beeb16898d0b$var$_nonIterableRest();
}
function $5cd0beeb16898d0b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5cd0beeb16898d0b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5cd0beeb16898d0b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5cd0beeb16898d0b$var$_arrayLikeToArray(o, minLen);
}
function $5cd0beeb16898d0b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5cd0beeb16898d0b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5cd0beeb16898d0b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5cd0beeb16898d0b$var$_extends() {
    $5cd0beeb16898d0b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5cd0beeb16898d0b$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $5cd0beeb16898d0b$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", $5cd0beeb16898d0b$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $5cd0beeb16898d0b$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($9d2b230ef89c92d0$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $5cd0beeb16898d0b$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $7ac7b265aa8e371b$export$71e825c43eae6ca6)();
    var xAxis = (0, $7ac7b265aa8e371b$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $7ac7b265aa8e371b$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $7ac7b265aa8e371b$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $425eb72df2965775$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $2b3288d276a160b8$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $453b3059df48aedd$export$402a499e1ea44294)(fixedX);
    var isY = (0, $453b3059df48aedd$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $5cd0beeb16898d0b$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $5cd0beeb16898d0b$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $5cd0beeb16898d0b$var$_objectSpread($5cd0beeb16898d0b$var$_objectSpread({
        clipPath: clipPath
    }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        className: (0, $axMmP.default)('recharts-reference-line', className)
    }, $5cd0beeb16898d0b$var$renderLine(shape, lineProps), (0, $e8d2d091029884ea$export$b04be29aa201d4f5).renderCallByParent(props, (0, $2b3288d276a160b8$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$5cd0beeb16898d0b$export$b2f28e248e7838eb.displayName = 'ReferenceLine';
$5cd0beeb16898d0b$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
};



var $70fFQ = parcelRequire("70fFQ");


var $axMmP = parcelRequire("axMmP");








function $e38128122fee402d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e38128122fee402d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e38128122fee402d$var$_typeof(o);
}
function $e38128122fee402d$var$_extends() {
    $e38128122fee402d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e38128122fee402d$var$_extends.apply(this, arguments);
}
function $e38128122fee402d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e38128122fee402d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e38128122fee402d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e38128122fee402d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e38128122fee402d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e38128122fee402d$var$_defineProperty(obj, key, value) {
    key = $e38128122fee402d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e38128122fee402d$var$_toPropertyKey(t) {
    var i = $e38128122fee402d$var$_toPrimitive(t, "string");
    return "symbol" == $e38128122fee402d$var$_typeof(i) ? i : String(i);
}
function $e38128122fee402d$var$_toPrimitive(t, r) {
    if ("object" != $e38128122fee402d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e38128122fee402d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e38128122fee402d$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $2b3288d276a160b8$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $2b3288d276a160b8$export$c7964a5b9439ae62)(p1, p2);
};
function $e38128122fee402d$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $425eb72df2965775$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $453b3059df48aedd$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $453b3059df48aedd$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $453b3059df48aedd$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $453b3059df48aedd$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $e38128122fee402d$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $ab8bbca642734c75$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        className: (0, $axMmP.default)('recharts-reference-area', className)
    }, $e38128122fee402d$export$b4ec4f050ce240b9.renderRect(shape, $e38128122fee402d$var$_objectSpread($e38128122fee402d$var$_objectSpread({
        clipPath: clipPath
    }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true)), rect)), (0, $e8d2d091029884ea$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$e38128122fee402d$export$b4ec4f050ce240b9.displayName = 'ReferenceArea';
$e38128122fee402d$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
};
$e38128122fee402d$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $c0f721a3b6bafaa4$export$4617fb02663045ef), $e38128122fee402d$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $974b1312a1d737b0$var$_toConsumableArray(arr) {
    return $974b1312a1d737b0$var$_arrayWithoutHoles(arr) || $974b1312a1d737b0$var$_iterableToArray(arr) || $974b1312a1d737b0$var$_unsupportedIterableToArray(arr) || $974b1312a1d737b0$var$_nonIterableSpread();
}
function $974b1312a1d737b0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $974b1312a1d737b0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $974b1312a1d737b0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $974b1312a1d737b0$var$_arrayLikeToArray(o, minLen);
}
function $974b1312a1d737b0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $974b1312a1d737b0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $974b1312a1d737b0$var$_arrayLikeToArray(arr);
}
function $974b1312a1d737b0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $974b1312a1d737b0$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $5cd0beeb16898d0b$export$b2f28e248e7838eb));
    var dots = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $dde223bfe082dea6$export$aa7f0b0106bff39));
    var elements = [].concat($974b1312a1d737b0$var$_toConsumableArray(lines), $974b1312a1d737b0$var$_toConsumableArray(dots));
    var areas = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $e38128122fee402d$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $ab8bbca642734c75$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $453b3059df48aedd$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $ab8bbca642734c75$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $453b3059df48aedd$export$7e4aa119212bc614)(el.props[key1]) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $39fa5e9cf5221548$exports = {};
'use strict';
var $39fa5e9cf5221548$var$has = Object.prototype.hasOwnProperty, $39fa5e9cf5221548$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $39fa5e9cf5221548$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $39fa5e9cf5221548$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $39fa5e9cf5221548$var$Events().__proto__) $39fa5e9cf5221548$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $39fa5e9cf5221548$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $39fa5e9cf5221548$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $39fa5e9cf5221548$var$EE(fn, context || emitter, once), evt = $39fa5e9cf5221548$var$prefix ? $39fa5e9cf5221548$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $39fa5e9cf5221548$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $39fa5e9cf5221548$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $39fa5e9cf5221548$var$EventEmitter() {
    this._events = new $39fa5e9cf5221548$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($39fa5e9cf5221548$var$has.call(events, name)) names.push($39fa5e9cf5221548$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $39fa5e9cf5221548$var$prefix ? $39fa5e9cf5221548$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $39fa5e9cf5221548$var$prefix ? $39fa5e9cf5221548$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $39fa5e9cf5221548$var$prefix ? $39fa5e9cf5221548$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $39fa5e9cf5221548$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $39fa5e9cf5221548$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $39fa5e9cf5221548$var$prefix ? $39fa5e9cf5221548$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $39fa5e9cf5221548$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $39fa5e9cf5221548$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $39fa5e9cf5221548$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $39fa5e9cf5221548$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $39fa5e9cf5221548$var$prefix ? $39fa5e9cf5221548$var$prefix + event : event;
        if (this._events[evt]) $39fa5e9cf5221548$var$clearEvent(this, evt);
    } else {
        this._events = new $39fa5e9cf5221548$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$39fa5e9cf5221548$var$EventEmitter.prototype.off = $39fa5e9cf5221548$var$EventEmitter.prototype.removeListener;
$39fa5e9cf5221548$var$EventEmitter.prototype.addListener = $39fa5e9cf5221548$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$39fa5e9cf5221548$var$EventEmitter.prefixed = $39fa5e9cf5221548$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$39fa5e9cf5221548$var$EventEmitter.EventEmitter = $39fa5e9cf5221548$var$EventEmitter;
$39fa5e9cf5221548$exports = $39fa5e9cf5221548$var$EventEmitter;


var $a879b92cafd6b877$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($39fa5e9cf5221548$exports)))();
var $a879b92cafd6b877$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $c2607a00f5df64fc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c2607a00f5df64fc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c2607a00f5df64fc$var$_typeof(o);
}
function $c2607a00f5df64fc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c2607a00f5df64fc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c2607a00f5df64fc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c2607a00f5df64fc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c2607a00f5df64fc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c2607a00f5df64fc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c2607a00f5df64fc$var$_defineProperty(obj, key, value) {
    key = $c2607a00f5df64fc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2607a00f5df64fc$var$_toPropertyKey(t) {
    var i = $c2607a00f5df64fc$var$_toPrimitive(t, "string");
    return "symbol" == $c2607a00f5df64fc$var$_typeof(i) ? i : String(i);
}
function $c2607a00f5df64fc$var$_toPrimitive(t, r) {
    if ("object" != $c2607a00f5df64fc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c2607a00f5df64fc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c2607a00f5df64fc$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $c2607a00f5df64fc$var$_classCallCheck(this, AccessibilityManager);
        $c2607a00f5df64fc$var$_defineProperty(this, "activeIndex", 0);
        $c2607a00f5df64fc$var$_defineProperty(this, "coordinateList", []);
        $c2607a00f5df64fc$var$_defineProperty(this, "layout", 'horizontal');
    }
    $c2607a00f5df64fc$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();



function $ff87c169edbe1d4d$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $453b3059df48aedd$export$7e4aa119212bc614)(domainStart) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");


var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");


function $a39521517a4a20f5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a39521517a4a20f5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a39521517a4a20f5$var$_typeof(o);
}
var $a39521517a4a20f5$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $a39521517a4a20f5$var$_extends() {
    $a39521517a4a20f5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a39521517a4a20f5$var$_extends.apply(this, arguments);
}
function $a39521517a4a20f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a39521517a4a20f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a39521517a4a20f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a39521517a4a20f5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a39521517a4a20f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a39521517a4a20f5$var$_defineProperty(obj, key, value) {
    key = $a39521517a4a20f5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a39521517a4a20f5$var$_toPropertyKey(t) {
    var i = $a39521517a4a20f5$var$_toPrimitive(t, "string");
    return "symbol" == $a39521517a4a20f5$var$_typeof(i) ? i : String(i);
}
function $a39521517a4a20f5$var$_toPrimitive(t, r) {
    if ("object" != $a39521517a4a20f5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a39521517a4a20f5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a39521517a4a20f5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a39521517a4a20f5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a39521517a4a20f5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a39521517a4a20f5$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $a39521517a4a20f5$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $a39521517a4a20f5$var$_objectWithoutProperties(_ref, $a39521517a4a20f5$var$_excluded);
    var props = $a39521517a4a20f5$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $453b3059df48aedd$export$7e4aa119212bc614)(x) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(y) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(width) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(height) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(top) || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $a39521517a4a20f5$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, true), {
        className: (0, $axMmP.default)('recharts-cross', className),
        d: $a39521517a4a20f5$var$getPath(x, y, width, height, top, left)
    }));
};


function $3256118fc220f16f$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $a900f0086d9d43c9$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $ccde052ebf1049cd$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $a900f0086d9d43c9$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $124fd20fba3a41f4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $124fd20fba3a41f4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $124fd20fba3a41f4$var$_typeof(o);
}
function $124fd20fba3a41f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $124fd20fba3a41f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $124fd20fba3a41f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $124fd20fba3a41f4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $124fd20fba3a41f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $124fd20fba3a41f4$var$_defineProperty(obj, key, value) {
    key = $124fd20fba3a41f4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $124fd20fba3a41f4$var$_toPropertyKey(t) {
    var i = $124fd20fba3a41f4$var$_toPrimitive(t, "string");
    return "symbol" == $124fd20fba3a41f4$var$_typeof(i) ? i : String(i);
}
function $124fd20fba3a41f4$var$_toPrimitive(t, r) {
    if ("object" != $124fd20fba3a41f4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $124fd20fba3a41f4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $124fd20fba3a41f4$export$b6a79797ad180576(props) {
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $a39521517a4a20f5$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $3256118fc220f16f$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $c0f721a3b6bafaa4$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $a900f0086d9d43c9$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $6d3f0bfe46cac913$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $ccde052ebf1049cd$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $124fd20fba3a41f4$var$_objectSpread($124fd20fba3a41f4$var$_objectSpread($124fd20fba3a41f4$var$_objectSpread($124fd20fba3a41f4$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $a56fb3d503224b01$export$d697c39a2985a4c)(element.props.cursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $axMmP.default)('recharts-tooltip-cursor', element.props.cursor.className)
    });
    return /*#__PURE__*/ (0, $70fFQ.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $70fFQ.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $70fFQ.createElement)(cursorComp, cursorProps);
}



var $0b69b3fe5a85f3bb$var$_excluded = [
    "item"
], $0b69b3fe5a85f3bb$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $0b69b3fe5a85f3bb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0b69b3fe5a85f3bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0b69b3fe5a85f3bb$var$_typeof(o);
}
function $0b69b3fe5a85f3bb$var$_extends() {
    $0b69b3fe5a85f3bb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0b69b3fe5a85f3bb$var$_extends.apply(this, arguments);
}
function $0b69b3fe5a85f3bb$var$_slicedToArray(arr, i) {
    return $0b69b3fe5a85f3bb$var$_arrayWithHoles(arr) || $0b69b3fe5a85f3bb$var$_iterableToArrayLimit(arr, i) || $0b69b3fe5a85f3bb$var$_unsupportedIterableToArray(arr, i) || $0b69b3fe5a85f3bb$var$_nonIterableRest();
}
function $0b69b3fe5a85f3bb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0b69b3fe5a85f3bb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0b69b3fe5a85f3bb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0b69b3fe5a85f3bb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0b69b3fe5a85f3bb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0b69b3fe5a85f3bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0b69b3fe5a85f3bb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0b69b3fe5a85f3bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0b69b3fe5a85f3bb$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0b69b3fe5a85f3bb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0b69b3fe5a85f3bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0b69b3fe5a85f3bb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0b69b3fe5a85f3bb$var$_callSuper(t, o, e) {
    return o = $0b69b3fe5a85f3bb$var$_getPrototypeOf(o), $0b69b3fe5a85f3bb$var$_possibleConstructorReturn(t, $0b69b3fe5a85f3bb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $0b69b3fe5a85f3bb$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $0b69b3fe5a85f3bb$var$_possibleConstructorReturn(self, call) {
    if (call && ($0b69b3fe5a85f3bb$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0b69b3fe5a85f3bb$var$_assertThisInitialized(self);
}
function $0b69b3fe5a85f3bb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0b69b3fe5a85f3bb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0b69b3fe5a85f3bb$var$_getPrototypeOf(o) {
    $0b69b3fe5a85f3bb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0b69b3fe5a85f3bb$var$_getPrototypeOf(o);
}
function $0b69b3fe5a85f3bb$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0b69b3fe5a85f3bb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0b69b3fe5a85f3bb$var$_setPrototypeOf(subClass, superClass);
}
function $0b69b3fe5a85f3bb$var$_setPrototypeOf(o, p) {
    $0b69b3fe5a85f3bb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0b69b3fe5a85f3bb$var$_setPrototypeOf(o, p);
}
function $0b69b3fe5a85f3bb$var$_toConsumableArray(arr) {
    return $0b69b3fe5a85f3bb$var$_arrayWithoutHoles(arr) || $0b69b3fe5a85f3bb$var$_iterableToArray(arr) || $0b69b3fe5a85f3bb$var$_unsupportedIterableToArray(arr) || $0b69b3fe5a85f3bb$var$_nonIterableSpread();
}
function $0b69b3fe5a85f3bb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0b69b3fe5a85f3bb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0b69b3fe5a85f3bb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0b69b3fe5a85f3bb$var$_arrayLikeToArray(o, minLen);
}
function $0b69b3fe5a85f3bb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0b69b3fe5a85f3bb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0b69b3fe5a85f3bb$var$_arrayLikeToArray(arr);
}
function $0b69b3fe5a85f3bb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0b69b3fe5a85f3bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b69b3fe5a85f3bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b69b3fe5a85f3bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0b69b3fe5a85f3bb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b69b3fe5a85f3bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0b69b3fe5a85f3bb$var$_defineProperty(obj, key, value) {
    key = $0b69b3fe5a85f3bb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0b69b3fe5a85f3bb$var$_toPropertyKey(t) {
    var i = $0b69b3fe5a85f3bb$var$_toPrimitive(t, "string");
    return "symbol" == $0b69b3fe5a85f3bb$var$_typeof(i) ? i : String(i);
}
function $0b69b3fe5a85f3bb$var$_toPrimitive(t, r) {
    if ("object" != $0b69b3fe5a85f3bb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0b69b3fe5a85f3bb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0b69b3fe5a85f3bb$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $0b69b3fe5a85f3bb$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $0b69b3fe5a85f3bb$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $0b69b3fe5a85f3bb$var$renderAsIs(element) {
    return element;
}
var $0b69b3fe5a85f3bb$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $0b69b3fe5a85f3bb$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, rangeObj), (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, rangeObj), (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $0b69b3fe5a85f3bb$var$originCoordinate;
};
var $0b69b3fe5a85f3bb$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($0b69b3fe5a85f3bb$var$_toConsumableArray(result), $0b69b3fe5a85f3bb$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $453b3059df48aedd$export$7e4aa119212bc614)(dataStartIndex) && (0, $453b3059df48aedd$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $0b69b3fe5a85f3bb$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $0b69b3fe5a85f3bb$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $0b69b3fe5a85f3bb$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $453b3059df48aedd$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($0b69b3fe5a85f3bb$var$_toConsumableArray(result), [
            (0, $cdef3b11746f8934$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $0b69b3fe5a85f3bb$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $0b69b3fe5a85f3bb$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $cdef3b11746f8934$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $0b69b3fe5a85f3bb$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $0b69b3fe5a85f3bb$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $0b69b3fe5a85f3bb$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $cdef3b11746f8934$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $0b69b3fe5a85f3bb$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $ff87c169edbe1d4d$export$33279f645a5831b7)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $cdef3b11746f8934$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cdef3b11746f8934$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $0b69b3fe5a85f3bb$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $cdef3b11746f8934$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $453b3059df48aedd$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($4f8af09a991e04d2$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $cdef3b11746f8934$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($0b69b3fe5a85f3bb$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $cdef3b11746f8934$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(entry) ? finalDomain : [].concat($0b69b3fe5a85f3bb$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $cdef3b11746f8934$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cdef3b11746f8934$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($4f8af09a991e04d2$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $cdef3b11746f8934$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $cdef3b11746f8934$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $974b1312a1d737b0$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $cdef3b11746f8934$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, result), {}, $0b69b3fe5a85f3bb$var$_defineProperty({}, axisId, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $0b69b3fe5a85f3bb$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $0b69b3fe5a85f3bb$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $cdef3b11746f8934$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $0b69b3fe5a85f3bb$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($4f8af09a991e04d2$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $cdef3b11746f8934$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $974b1312a1d737b0$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $cdef3b11746f8934$export$a0bc8660980558a0)(originalDomain, (0, $cdef3b11746f8934$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $974b1312a1d737b0$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, result), {}, $0b69b3fe5a85f3bb$var$_defineProperty({}, axisId, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))($0b69b3fe5a85f3bb$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $0b69b3fe5a85f3bb$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $0b69b3fe5a85f3bb$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $0b69b3fe5a85f3bb$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $0b69b3fe5a85f3bb$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $453b3059df48aedd$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($f30c977dfc6b9355$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $cdef3b11746f8934$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $0b69b3fe5a85f3bb$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $052b95d1dd0554f6$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $0b69b3fe5a85f3bb$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $a56fb3d503224b01$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $0b69b3fe5a85f3bb$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $0b69b3fe5a85f3bb$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $052b95d1dd0554f6$export$59bc2e3533b384a0));
    var legendItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $1bb7597bd9097c42$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, result), {}, $0b69b3fe5a85f3bb$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, result), {}, $0b69b3fe5a85f3bb$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $052b95d1dd0554f6$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $cdef3b11746f8934$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $0b69b3fe5a85f3bb$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $0b69b3fe5a85f3bb$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _CategoricalChartWrapper;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $0b69b3fe5a85f3bb$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $0b69b3fe5a85f3bb$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $0b69b3fe5a85f3bb$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $0da1c288545eac50$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, result), {}, $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $cdef3b11746f8934$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $a56fb3d503224b01$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $cdef3b11746f8934$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $cdef3b11746f8934$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $0b69b3fe5a85f3bb$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $cdef3b11746f8934$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $cdef3b11746f8934$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, pos), {}, {
                        position: $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, composedFn($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $a56fb3d503224b01$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $a56fb3d503224b01$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $0b69b3fe5a85f3bb$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $cdef3b11746f8934$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, result), {}, $0b69b3fe5a85f3bb$var$_defineProperty({}, name, $0b69b3fe5a85f3bb$var$getAxisMap(props, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $0b69b3fe5a85f3bb$var$calculateOffset($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $0b69b3fe5a85f3bb$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        $0b69b3fe5a85f3bb$var$_inherits(CategoricalChartWrapper, _Component);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $0b69b3fe5a85f3bb$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $0b69b3fe5a85f3bb$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $c2607a00f5df64fc$export$a2c2de1efa8671eb)());
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($0b69b3fe5a85f3bb$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $0b69b3fe5a85f3bb$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $a56fb3d503224b01$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $a879b92cafd6b877$export$9bcdfe5f29bb33).emit((0, $a879b92cafd6b877$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($0b69b3fe5a85f3bb$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $0b69b3fe5a85f3bb$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $0b69b3fe5a85f3bb$var$originCoordinate;
                    _this.setState($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $124fd20fba3a41f4$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $70fFQ.cloneElement)(element, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $axMmP.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $453b3059df48aedd$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $453b3059df48aedd$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $70fFQ.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $b5b278592fecce6c$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $0b69b3fe5a85f3bb$var$_objectWithoutProperties(props, $0b69b3fe5a85f3bb$var$_excluded);
                return /*#__PURE__*/ (0, $70fFQ.cloneElement)(item, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $70fFQ.cloneElement)(tooltipItem, {
                    viewBox: $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $70fFQ.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $cdef3b11746f8934$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $453b3059df48aedd$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $453b3059df48aedd$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $453b3059df48aedd$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $70fFQ.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $cdef3b11746f8934$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(activeDot, false)), (0, $e11a437526851c08$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $cdef3b11746f8934$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $cdef3b11746f8934$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $cdef3b11746f8934$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $70fFQ.cloneElement)(element, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $453b3059df48aedd$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $453b3059df48aedd$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $70fFQ.cloneElement)(element, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($0b69b3fe5a85f3bb$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $70fFQ.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $70fFQ.cloneElement)(element, $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $0b69b3fe5a85f3bb$var$_defineProperty($0b69b3fe5a85f3bb$var$_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: $0b69b3fe5a85f3bb$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $0b69b3fe5a85f3bb$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $0b69b3fe5a85f3bb$var$renderAsIs
                },
                YAxis: {
                    handler: $0b69b3fe5a85f3bb$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $453b3059df48aedd$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($2003fcc117392f52$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $0b69b3fe5a85f3bb$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $0b69b3fe5a85f3bb$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $a56fb3d503224b01$export$acdc716e08572f94)([
                        (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(prevProps.children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea))
                    ], [
                        (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(this.props.children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(this.props.children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $14ab4f4cd331f2e9$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $453b3059df48aedd$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $453b3059df48aedd$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $0b69b3fe5a85f3bb$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $453b3059df48aedd$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $a9c74f58ba1355cc$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $e11a437526851c08$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $a879b92cafd6b877$export$9bcdfe5f29bb33).on((0, $a879b92cafd6b877$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $a879b92cafd6b877$export$9bcdfe5f29bb33).removeListener((0, $a879b92cafd6b877$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $a56fb3d503224b01$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $0b69b3fe5a85f3bb$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, res), {}, $0b69b3fe5a85f3bb$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $0b69b3fe5a85f3bb$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, res), {}, $0b69b3fe5a85f3bb$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $a56fb3d503224b01$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $c0f721a3b6bafaa4$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $a9c74f58ba1355cc$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $f2d64a0eb3db0ded$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $f2d64a0eb3db0ded$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $f2d64a0eb3db0ded$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $f2d64a0eb3db0ded$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $f2d64a0eb3db0ded$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $a56fb3d503224b01$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $0b69b3fe5a85f3bb$var$_objectWithoutProperties(_this$props6, $0b69b3fe5a85f3bb$var$_excluded2);
                    var attrs = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $7ac7b265aa8e371b$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $abed49cce9ec42fc$export$7b92b459e668cb21), $0b69b3fe5a85f3bb$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $a56fb3d503224b01$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $7ac7b265aa8e371b$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("div", $0b69b3fe5a85f3bb$var$_extends({
                        className: (0, $axMmP.default)('recharts-wrapper', className),
                        style: $0b69b3fe5a85f3bb$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $abed49cce9ec42fc$export$7b92b459e668cb21), $0b69b3fe5a85f3bb$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $0b69b3fe5a85f3bb$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $a56fb3d503224b01$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $70fFQ.Component)), $0b69b3fe5a85f3bb$var$_defineProperty(_CategoricalChartWrapper, "displayName", chartName), $0b69b3fe5a85f3bb$var$_defineProperty(_CategoricalChartWrapper, "defaultProps", $0b69b3fe5a85f3bb$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps)), $0b69b3fe5a85f3bb$var$_defineProperty(_CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $0b69b3fe5a85f3bb$export$e5182fb58612e577(nextProps);
            return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $924d4aaaa598a456$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $0b69b3fe5a85f3bb$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, $0b69b3fe5a85f3bb$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($0b69b3fe5a85f3bb$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $a56fb3d503224b01$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $052b95d1dd0554f6$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($0b69b3fe5a85f3bb$var$_objectSpread($0b69b3fe5a85f3bb$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    }), $0b69b3fe5a85f3bb$var$_defineProperty(_CategoricalChartWrapper, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $70fFQ.isValidElement)(option)) dot = /*#__PURE__*/ (0, $70fFQ.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $d509b7e1d2bfee51$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _CategoricalChartWrapper;
};



var $70fFQ = parcelRequire("70fFQ");


var $axMmP = parcelRequire("axMmP");



var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");

var $ac792741c8a1679d$var$_excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function $ac792741c8a1679d$var$_extends() {
    $ac792741c8a1679d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac792741c8a1679d$var$_extends.apply(this, arguments);
}
function $ac792741c8a1679d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ac792741c8a1679d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ac792741c8a1679d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ac792741c8a1679d$var$_toConsumableArray(arr) {
    return $ac792741c8a1679d$var$_arrayWithoutHoles(arr) || $ac792741c8a1679d$var$_iterableToArray(arr) || $ac792741c8a1679d$var$_unsupportedIterableToArray(arr) || $ac792741c8a1679d$var$_nonIterableSpread();
}
function $ac792741c8a1679d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ac792741c8a1679d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ac792741c8a1679d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ac792741c8a1679d$var$_arrayLikeToArray(o, minLen);
}
function $ac792741c8a1679d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ac792741c8a1679d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ac792741c8a1679d$var$_arrayLikeToArray(arr);
}
function $ac792741c8a1679d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ac792741c8a1679d$var$isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var $ac792741c8a1679d$var$getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if ($ac792741c8a1679d$var$isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if ($ac792741c8a1679d$var$isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var $ac792741c8a1679d$var$getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = $ac792741c8a1679d$var$getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat($ac792741c8a1679d$var$_toConsumableArray(res), $ac792741c8a1679d$var$_toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? 'M' : 'L').concat(point.x, ",").concat(point.y);
        }, '');
    }).join('');
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var $ac792741c8a1679d$var$getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = $ac792741c8a1679d$var$getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, "L").concat($ac792741c8a1679d$var$getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var $ac792741c8a1679d$export$7d31b617c820d435 = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = $ac792741c8a1679d$var$_objectWithoutProperties(props, $ac792741c8a1679d$var$_excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, $axMmP.default)('recharts-polygon', className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== 'none';
        var rangePath = $ac792741c8a1679d$var$getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $ac792741c8a1679d$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true), {
            fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $ac792741c8a1679d$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $ac792741c8a1679d$var$getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $ac792741c8a1679d$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $ac792741c8a1679d$var$getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = $ac792741c8a1679d$var$getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $ac792741c8a1679d$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true), {
        fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
        className: layerClass,
        d: singlePath
    }));
};






function $c588585679983d00$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c588585679983d00$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c588585679983d00$var$_typeof(o);
}
function $c588585679983d00$var$_extends() {
    $c588585679983d00$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c588585679983d00$var$_extends.apply(this, arguments);
}
function $c588585679983d00$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c588585679983d00$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c588585679983d00$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c588585679983d00$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c588585679983d00$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c588585679983d00$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c588585679983d00$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c588585679983d00$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c588585679983d00$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c588585679983d00$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c588585679983d00$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c588585679983d00$var$_callSuper(t, o, e) {
    return o = $c588585679983d00$var$_getPrototypeOf(o), $c588585679983d00$var$_possibleConstructorReturn(t, $c588585679983d00$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c588585679983d00$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c588585679983d00$var$_possibleConstructorReturn(self, call) {
    if (call && ($c588585679983d00$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c588585679983d00$var$_assertThisInitialized(self);
}
function $c588585679983d00$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c588585679983d00$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c588585679983d00$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c588585679983d00$var$_getPrototypeOf(o) {
    $c588585679983d00$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c588585679983d00$var$_getPrototypeOf(o);
}
function $c588585679983d00$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c588585679983d00$var$_setPrototypeOf(subClass, superClass);
}
function $c588585679983d00$var$_setPrototypeOf(o, p) {
    $c588585679983d00$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c588585679983d00$var$_setPrototypeOf(o, p);
}
function $c588585679983d00$var$_defineProperty(obj, key, value) {
    key = $c588585679983d00$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c588585679983d00$var$_toPropertyKey(t) {
    var i = $c588585679983d00$var$_toPrimitive(t, "string");
    return "symbol" == $c588585679983d00$var$_typeof(i) ? i : String(i);
}
function $c588585679983d00$var$_toPrimitive(t, r) {
    if ("object" != $c588585679983d00$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c588585679983d00$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c588585679983d00$var$RADIAN = Math.PI / 180;
var $c588585679983d00$var$eps = 1e-5;
var $c588585679983d00$export$67d930e793705898 = /*#__PURE__*/ function(_PureComponent) {
    $c588585679983d00$var$_inherits(PolarAngleAxis, _PureComponent);
    function PolarAngleAxis() {
        $c588585679983d00$var$_classCallCheck(this, PolarAngleAxis);
        return $c588585679983d00$var$_callSuper(this, PolarAngleAxis, arguments);
    }
    $c588585679983d00$var$_createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius, data.coordinate);
                var p2 = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * $c588585679983d00$var$RADIAN);
                var textAnchor;
                if (cos > $c588585679983d00$var$eps) textAnchor = orientation === 'outer' ? 'start' : 'end';
                else if (cos < -$c588585679983d00$var$eps) textAnchor = orientation === 'outer' ? 'end' : 'start';
                else textAnchor = 'middle';
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = $c588585679983d00$var$_objectSpread($c588585679983d00$var$_objectSpread({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false)), {}, {
                    fill: 'none'
                }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(axisLine, false));
                if (axisLineType === 'circle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $d509b7e1d2bfee51$export$d046b3c4a416f60d), $c588585679983d00$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $ac792741c8a1679d$export$7d31b617c820d435), $c588585679983d00$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $c588585679983d00$var$_objectSpread($c588585679983d00$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(tickLine, false));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = $c588585679983d00$var$_objectSpread($c588585679983d00$var$_objectSpread($c588585679983d00$var$_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $c588585679983d00$var$_extends({
                        className: (0, $axMmP.default)('recharts-polar-angle-axis-tick', (0, $a9c74f58ba1355cc$export$88d525dabc04abcd)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", $c588585679983d00$var$_extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: (0, $axMmP.default)('recharts-polar-angle-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f01a70744931f940$export$5f1af8db9871e1d6), $c588585679983d00$var$_extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarAngleAxis;
}((0, $70fFQ.PureComponent));
$c588585679983d00$var$_defineProperty($c588585679983d00$export$67d930e793705898, "displayName", 'PolarAngleAxis');
$c588585679983d00$var$_defineProperty($c588585679983d00$export$67d930e793705898, "axisType", 'angleAxis');
$c588585679983d00$var$_defineProperty($c588585679983d00$export$67d930e793705898, "defaultProps", {
    type: 'category',
    angleAxisId: 0,
    scale: 'auto',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});



var $70fFQ = parcelRequire("70fFQ");
var $19af5f1d1bb3415a$exports = {};



/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $19af5f1d1bb3415a$var$maxBy(array, iteratee) {
    return array && array.length ? $3b150f889b608e27$exports(array, $1316a39af77ac4e6$exports(iteratee, 2), $0ef548784951ddf1$exports) : undefined;
}
$19af5f1d1bb3415a$exports = $19af5f1d1bb3415a$var$maxBy;


var $6b05af1650a10f96$exports = {};



/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $6b05af1650a10f96$var$minBy(array, iteratee) {
    return array && array.length ? $3b150f889b608e27$exports(array, $1316a39af77ac4e6$exports(iteratee, 2), $c1afed27cfddf2ec$exports) : undefined;
}
$6b05af1650a10f96$exports = $6b05af1650a10f96$var$minBy;




var $axMmP = parcelRequire("axMmP");






var $7cc336700f36af4d$var$_excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], $7cc336700f36af4d$var$_excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function $7cc336700f36af4d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7cc336700f36af4d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7cc336700f36af4d$var$_typeof(o);
}
function $7cc336700f36af4d$var$_extends() {
    $7cc336700f36af4d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7cc336700f36af4d$var$_extends.apply(this, arguments);
}
function $7cc336700f36af4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7cc336700f36af4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7cc336700f36af4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7cc336700f36af4d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7cc336700f36af4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7cc336700f36af4d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7cc336700f36af4d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7cc336700f36af4d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7cc336700f36af4d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7cc336700f36af4d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7cc336700f36af4d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7cc336700f36af4d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7cc336700f36af4d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7cc336700f36af4d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7cc336700f36af4d$var$_callSuper(t, o, e) {
    return o = $7cc336700f36af4d$var$_getPrototypeOf(o), $7cc336700f36af4d$var$_possibleConstructorReturn(t, $7cc336700f36af4d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7cc336700f36af4d$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7cc336700f36af4d$var$_possibleConstructorReturn(self, call) {
    if (call && ($7cc336700f36af4d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7cc336700f36af4d$var$_assertThisInitialized(self);
}
function $7cc336700f36af4d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7cc336700f36af4d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7cc336700f36af4d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7cc336700f36af4d$var$_getPrototypeOf(o) {
    $7cc336700f36af4d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7cc336700f36af4d$var$_getPrototypeOf(o);
}
function $7cc336700f36af4d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7cc336700f36af4d$var$_setPrototypeOf(subClass, superClass);
}
function $7cc336700f36af4d$var$_setPrototypeOf(o, p) {
    $7cc336700f36af4d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7cc336700f36af4d$var$_setPrototypeOf(o, p);
}
function $7cc336700f36af4d$var$_defineProperty(obj, key, value) {
    key = $7cc336700f36af4d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7cc336700f36af4d$var$_toPropertyKey(t) {
    var i = $7cc336700f36af4d$var$_toPrimitive(t, "string");
    return "symbol" == $7cc336700f36af4d$var$_typeof(i) ? i : String(i);
}
function $7cc336700f36af4d$var$_toPrimitive(t, r) {
    if ("object" != $7cc336700f36af4d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7cc336700f36af4d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7cc336700f36af4d$export$d2607afddf4df58d = /*#__PURE__*/ function(_PureComponent) {
    $7cc336700f36af4d$var$_inherits(PolarRadiusAxis, _PureComponent);
    function PolarRadiusAxis() {
        $7cc336700f36af4d$var$_classCallCheck(this, PolarRadiusAxis);
        return $7cc336700f36af4d$var$_callSuper(this, PolarRadiusAxis, arguments);
    }
    $7cc336700f36af4d$var$_createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = 'end';
                        break;
                    case 'right':
                        textAnchor = 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($19af5f1d1bb3415a$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($6b05af1650a10f96$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = $7cc336700f36af4d$var$_objectWithoutProperties(_this$props3, $7cc336700f36af4d$var$_excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, extent[0], angle);
                var point1 = (0, $a9c74f58ba1355cc$export$5c9a959bb3fc7749)(cx, cy, extent[1], angle);
                var props = $7cc336700f36af4d$var$_objectSpread($7cc336700f36af4d$var$_objectSpread($7cc336700f36af4d$var$_objectSpread({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, false)), {}, {
                    fill: 'none'
                }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", $7cc336700f36af4d$var$_extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = $7cc336700f36af4d$var$_objectWithoutProperties(_this$props4, $7cc336700f36af4d$var$_excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, false);
                var customTickProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(tick, false);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = $7cc336700f36af4d$var$_objectSpread($7cc336700f36af4d$var$_objectSpread($7cc336700f36af4d$var$_objectSpread($7cc336700f36af4d$var$_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $7cc336700f36af4d$var$_extends({
                        className: (0, $axMmP.default)('recharts-polar-radius-axis-tick', (0, $a9c74f58ba1355cc$export$88d525dabc04abcd)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: (0, $axMmP.default)('recharts-polar-radius-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, $e8d2d091029884ea$export$b04be29aa201d4f5).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f01a70744931f940$export$5f1af8db9871e1d6), $7cc336700f36af4d$var$_extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarRadiusAxis;
}((0, $70fFQ.PureComponent));
$7cc336700f36af4d$var$_defineProperty($7cc336700f36af4d$export$d2607afddf4df58d, "displayName", 'PolarRadiusAxis');
$7cc336700f36af4d$var$_defineProperty($7cc336700f36af4d$export$d2607afddf4df58d, "axisType", 'radiusAxis');
$7cc336700f36af4d$var$_defineProperty($7cc336700f36af4d$export$d2607afddf4df58d, "defaultProps", {
    type: 'number',
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: 'right',
    stroke: '#ccc',
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: 'auto',
    allowDuplicatedCategory: true
});




var $135ac290ed466b55$export$b99d3348f709c998 = (0, $0b69b3fe5a85f3bb$export$77871aede60e6838)({
    chartName: 'PieChart',
    GraphicalChild: (0, $a476105a50608ff4$export$2ae8800cf67c848c),
    validateTooltipEventTypes: [
        'item'
    ],
    defaultTooltipEventType: 'item',
    legendContent: 'children',
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, $c588585679983d00$export$67d930e793705898)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, $7cc336700f36af4d$export$d2607afddf4df58d)
        }
    ],
    formatAxisMap: (0, $a9c74f58ba1355cc$export$ece7de1383db5ac),
    defaultProps: {
        layout: 'centric',
        startAngle: 0,
        endAngle: 360,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});








/**
 * Pulls the portfolio ID out of the URL and fetches the portfolio data. Useful for determining
 * if the URL provided ID actually matches a portfolio for the user.
 *
 * @param {string} id - The portfolio ID to fetch. If not provided, the hook will attempt to
 *    pull the ID from the URL.
 * @return {[object|null, boolean]} - The portfolio object and a boolean indicating whether the
 *    fetch is still in progress. Returns null as the portfolio if the query is loading or if the
 *    query failed.
 */ const $41057fa49be8f4de$var$usePortfolio = (id)=>{
    const { id: urlId } = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const portfolioId = id || urlId;
    const portfolioQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_DETAIL(portfolioId), {}, {
        enabled: Boolean(portfolioId)
    });
    if (portfolioQuery.isLoading) return [
        null,
        true
    ];
    if (!portfolioQuery.isSuccess) return [
        null,
        false
    ];
    return [
        portfolioQuery.cleanedData?.data,
        false
    ];
};
var $41057fa49be8f4de$export$2e2bcd8739ae039 = $41057fa49be8f4de$var$usePortfolio;




/**
 * Fetches the companies in a portfolio. The order of the returned array is guaranteed to match
 * the order of the companies in the portfolio. Returns the list of companies and a boolean
 * indicating the loading state of the query. If the query is still loading or encountered an error,
 * the returned company list is `null`.
 *
 * @param {string} portfolioId
 * @return {[Array<object>|null, boolean]}
 */ const $b48a78ee18a41ad4$var$usePortfolioCompanies = (portfolioId)=>{
    const companiesQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_COMPANIES(), {
        portfolio: portfolioId
    }, {
        enabled: Boolean(portfolioId)
    });
    if (companiesQuery.isLoading) return [
        null,
        true
    ];
    if (!companiesQuery.isSuccess) return [
        null,
        false
    ];
    return [
        companiesQuery.cleanedData.data,
        false
    ];
};
var $b48a78ee18a41ad4$export$2e2bcd8739ae039 = $b48a78ee18a41ad4$var$usePortfolioCompanies;



var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");


var $70fFQ = parcelRequire("70fFQ");



const $072c01e4bbbdc0f1$export$3ae68de48cfab197 = (shareLot)=>!shareLot.shareQuantity && shareLot.shareQuantity !== 0 && !shareLot.purchaseDate && !shareLot.pricePerShare && shareLot.pricePerShare !== 0 && shareLot.pricePerShare !== "0." && !shareLot.security;
/*
 * Use in forms that need to use the <ShareLotFieldSet /> component.
 */ const $072c01e4bbbdc0f1$export$f72a262d0c5666a0 = (shareLots)=>{
    if (shareLots.some((shareLot)=>{
        if ($072c01e4bbbdc0f1$export$3ae68de48cfab197(shareLot)) // If all the relevant values are falsey, there are no errors, we just won't submit
        // this empty share lot to the backend.
        return false;
        return !(shareLot.shareQuantity && shareLot.shareQuantity !== 0 && shareLot.purchaseDate && shareLot.pricePerShare && shareLot.pricePerShare !== 0 && shareLot.pricePerShare !== "0." && shareLot.security);
    })) return "Do not leave any share lots partially filled in";
    return undefined;
};


/*
 * Returns true if the portfolioCompany has a company object. Portfolio companies always have either
 * a company or a requested_company, so the presence of the company field is sufficient for
 * identifying portfolio companies as verified.
 */ var $a397e2ca8ff89f69$export$2e2bcd8739ae039 = (portfolioCompany)=>Boolean(portfolioCompany?.company);


var /*
 * Returns true if the portfolio company is not verified and has a requested company.
 */ $2c8cfe157c823722$export$2e2bcd8739ae039 = (portfolioCompany)=>!(0, $a397e2ca8ff89f69$export$2e2bcd8739ae039)(portfolioCompany) && Boolean(portfolioCompany?.requested_company);



/*
 * Returns the name of a portfolio company, via the related Company instance, or the related
 * RequestedCompany instance, for components that don't care about the difference.
 */ 
const $1c46b8197a693bea$var$getPortfolioCompanyName = (portfolioCompany)=>{
    if ((0, $a397e2ca8ff89f69$export$2e2bcd8739ae039)(portfolioCompany)) return portfolioCompany.company.name;
    if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(portfolioCompany)) return portfolioCompany.requested_company.name;
    return null; // Should not hit this theoretically.
};
var $1c46b8197a693bea$export$2e2bcd8739ae039 = $1c46b8197a693bea$var$getPortfolioCompanyName;




/*
 * Returns true if the company is removed from the portfolio. Should only be used with objects
 * that are returned from the `usePortfolioCompanyAggregates` hook.
 */ var $d570420533f8fda2$export$2e2bcd8739ae039 = (company)=>company?.removed;


/**
 * This hook is used to fetch the latest order flow report for each of the companies in a portfolio,
 * based on portfolio ID. It returns an array of pairs of order flow reports, one pair for each
 * company in the portfolio. The ordering of the returned pairs of OFRs is the same as the ordering
 * of the companies in the portfolio. The ordering within a pair is the first item is the more
 * recent report_period.
 *
 * For any companies that do not have a latest order flow report, their index in the returned array
 * will be the sentinel value `undefined`.
 *
 * @param {string} portfolioId
 * @return {Array<object|undefined>}
 */ const $361bea2ba5ead2bb$var$useLatestOrderflowForPortfolio = (portfolioId)=>{
    const [portfolioCompanies, companiesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    // We do not fetch for requested companies because there is no company ID to query orderflow with.
    const latestOrderFlowReportQueries = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)((portfolioCompanies || []).map((company)=>(0, $a397e2ca8ff89f69$export$2e2bcd8739ae039)(company) && !(0, $d570420533f8fda2$export$2e2bcd8739ae039)(company.company) ? {
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_PRICE_VOLUME_ORDER_FLOW(),
            queryParams: {
                company: company.company?.zb_id,
                end_date: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
                    days: 1
                }).toISODate(),
                start_date: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
                    years: 1
                }).toISODate()
            }
        } : null));
    const orderFlowReports = (0, $70fFQ.useMemo)(()=>{
        return latestOrderFlowReportQueries.isAnySuccess ? latestOrderFlowReportQueries.cleanedData.map((orderFlowReport)=>{
            if (!orderFlowReport) return [
                null,
                null
            ];
            return [
                orderFlowReport?.data?.[0],
                orderFlowReport?.data?.[1]
            ];
        }) : null;
    }, [
        latestOrderFlowReportQueries.isAnySuccess,
        latestOrderFlowReportQueries.cleanedData
    ]);
    if (companiesLoading) return [
        null,
        true
    ];
    return [
        orderFlowReports,
        latestOrderFlowReportQueries.isLoading
    ];
};
var $361bea2ba5ead2bb$export$2e2bcd8739ae039 = $361bea2ba5ead2bb$var$useLatestOrderflowForPortfolio;



var $70fFQ = parcelRequire("70fFQ");




/**
 * Returns all the share lots for a portfolio, grouped by portfolio company, ordered in the same
 * order as the portfolio companies. Useful in determining overall cost basis of a portfolio.
 *
 * @param {string} portfolioId
 * @return {[Array<Array<object>>|null, boolean]} - Returns a pair of values, the first an array of
 *    share lot arrays, grouped in the same order as the companies for the portfolio. Returns null
 *    for the array instead if any of the queries are loading or encountered errors. The second
 *    is a boolean indicating the loading state of the queries.
 */ const $175f183e6334c39c$var$useShareLotsForPortfolio = (portfolioId)=>{
    const [portfolioCompanies, companiesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    const shareLotsQueries = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)((portfolioCompanies || []).map((company)=>// `removed` lives on the embedded company record, not the
        // PortfolioCompany row — same shape as usePortfolioCompanyAggregates.
        (0, $d570420533f8fda2$export$2e2bcd8739ae039)(company.company) ? null : {
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SHARE_LOTS(),
            queryParams: {
                portfolio_company: company.apiId
            }
        }));
    const shareLots = (0, $70fFQ.useMemo)(()=>{
        // ZX-15149/ZX-15151: cleanedData elements can be null/empty even on success
        // (removed-company null queries, empty/no-content responses) — normalize
        // them to [] so consumers can treat every group as an array.
        return shareLotsQueries.isSuccess ? shareLotsQueries.cleanedData.map((shareLotsList)=>shareLotsList?.data ?? []) : null;
    }, [
        shareLotsQueries.isSuccess,
        shareLotsQueries.cleanedData
    ]);
    if (companiesLoading || shareLotsQueries.isLoading) return [
        null,
        true
    ];
    return [
        shareLots,
        false
    ];
};
var $175f183e6334c39c$export$2e2bcd8739ae039 = $175f183e6334c39c$var$useShareLotsForPortfolio;



/**
 * Computes the current total value of a portfolio given its ID. For each of the companies in the
 * portfolio, multiplies the total # of shares across the share lots for that company by the
 * current ZX Index Value, and sums them to obtain the total value.
 *
 * @param {string} portfolioId
 * @return {number|null} - Returns the computed value on success, or null if any of the queries are
 *    still loading or encountered errors.
 */ const $c0753d95e24a3305$var$usePortfolioValue = (portfolioId)=>{
    const [portfolioCompanies, companiesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    // Get all the share lots and latest orderflow report for all the companies. useFetches guarantees
    // the order of the results matches the order of the queries, and we will make use of that fact
    // below.
    const [shareLots, shareLotsLoading] = (0, $175f183e6334c39c$export$2e2bcd8739ae039)(portfolioId);
    const [orderFlowReports, orderFlowLoading] = (0, $361bea2ba5ead2bb$export$2e2bcd8739ae039)(portfolioId);
    const currentValue = (0, $70fFQ.useMemo)(()=>{
        if (!shareLots || !orderFlowReports) return null;
        return (portfolioCompanies || []).map((company, index)=>{
            // Make use of the useFetches ordering guarantee to use `index`.
            const companyShareLots = shareLots[index];
            const latestOrderFlowReport = orderFlowReports[index][0];
            if (!latestOrderFlowReport || !companyShareLots) // We only include companies with verified data in the portfolio value calculation.
            return 0;
            // Determine the current value based on the current ZX Index Value multiplied by the total
            // number of shares.
            const totalShareQuantity = companyShareLots.reduce((acc, shareLot)=>acc + shareLot.share_quantity, 0);
            return totalShareQuantity * Number(latestOrderFlowReport.zx_index_price);
        }).reduce((acc, value)=>acc + value, 0);
    }, [
        shareLots,
        orderFlowReports,
        portfolioCompanies
    ]);
    if (companiesLoading || orderFlowLoading || shareLotsLoading || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(portfolioCompanies)) return null;
    return currentValue;
};
var $c0753d95e24a3305$export$2e2bcd8739ae039 = $c0753d95e24a3305$var$usePortfolioValue;




var $70fFQ = parcelRequire("70fFQ");




/**
 * Fetches a portfolio company's relevant data and produces an easy to read object holding all
 * the high level stats. Useful for performing sorts across values related to the comapny but not
 * actually present on the PortfolioCompany model, and for displaying in the
 * PortfolioCompanyAccordionTrigger.
 */ const $a840f37efa0f043f$var$usePortfolioCompanyAggregates = (portfolioCompanies)=>{
    const companyNames = (portfolioCompanies || []).map((0, $1c46b8197a693bea$export$2e2bcd8739ae039));
    const orderFlowReportsQueries = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)((portfolioCompanies || []).map((company)=>{
        if ((0, $d570420533f8fda2$export$2e2bcd8739ae039)(company.company) || (0, $2c8cfe157c823722$export$2e2bcd8739ae039)(company)) return null;
        return {
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_PRICE_VOLUME_ORDER_FLOW(),
            queryParams: {
                company: company.company?.zb_id,
                end_date: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
                    days: 1
                }).toISODate(),
                start_date: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
                    years: 1
                }).toISODate()
            }
        };
    }));
    const shareLotsQueries = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)((portfolioCompanies || []).map((company)=>({
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SHARE_LOTS(),
            queryParams: {
                portfolio_company: company.apiId
            }
        })));
    const customValuationsQueries = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)((portfolioCompanies || []).map((company)=>({
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CUSTOM_VALUATIONS(),
            queryParams: {
                "page[size]": 1,
                company: company.company?.zb_id,
                // We support custom valuations for unverified companies.
                requested_company: company.requested_company?.id
            }
        })));
    // We'll keep share lots ordered with newest share lots at the top.
    const shareLots = (0, $70fFQ.useMemo)(()=>{
        return shareLotsQueries.queryInfo.map((queryInfo, index)=>{
            // ZX-15149: cleanedData[index]?.data can be null/undefined even when
            // isSuccess is true (empty/no-content response, null query element).
            const data = shareLotsQueries.cleanedData[index]?.data;
            if (!queryInfo.isSuccess || !data) return null;
            return data.sort((a, b)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(b.purchase_date) - (0, $86d2f3987cc9d604$exports.DateTime).fromISO(a.purchase_date));
        });
    }, [
        shareLotsQueries.queryInfo,
        shareLotsQueries.cleanedData
    ]);
    const latestCustomValuations = (0, $70fFQ.useMemo)(()=>{
        return customValuationsQueries.queryInfo.map((queryInfo, index)=>{
            const data = customValuationsQueries.cleanedData[index]?.data;
            if (!queryInfo.isSuccess || !data) return null;
            return data[0] || null;
        });
    }, [
        customValuationsQueries.queryInfo,
        customValuationsQueries.cleanedData
    ]);
    const orderFlowStats = (0, $70fFQ.useMemo)(()=>{
        return orderFlowReportsQueries.queryInfo.map((queryInfo, index)=>{
            const data = orderFlowReportsQueries.cleanedData[index]?.data;
            if (!queryInfo.isSuccess || data === null || data.length === 0) return {
                low52weeks: null,
                high52weeks: null,
                currentZXIndexValue: null,
                currentZXIndexValuePercentChange: null,
                currentRobustnessScore: null
            };
            const zxIndexValues = data.map((report)=>report.zx_index_price);
            const latestReport = data[0];
            return {
                low52weeks: Math.min(...zxIndexValues),
                high52weeks: Math.max(...zxIndexValues),
                currentZXIndexValue: latestReport.zx_index_price,
                currentZXIndexValuePercentChange: latestReport.zx_index_value_percent_change,
                currentRobustnessScore: latestReport.robustness
            };
        });
    }, [
        orderFlowReportsQueries.queryInfo,
        orderFlowReportsQueries.cleanedData
    ]);
    /*
   * The sum of share_quantity of the share lots.
   */ const shareQuantities = (0, $70fFQ.useMemo)(()=>{
        return (shareLots || []).map((companyShareLots)=>{
            if (!companyShareLots || companyShareLots.length === 0) return null;
            return companyShareLots.reduce((acc, shareLot)=>acc + shareLot.share_quantity, 0);
        });
    }, [
        shareLots
    ]);
    /*
   * The cost of all the shares to the user. Will be used to compute total unrealized gain.
   */ const costBases = (0, $70fFQ.useMemo)(()=>{
        return (shareLots || []).map((companyShareLots)=>{
            if (!companyShareLots || companyShareLots.length === 0) return null;
            return companyShareLots.reduce((acc, shareLot)=>acc + Number(shareLot.price_per_share) * shareLot.share_quantity, 0);
        });
    }, [
        shareLots
    ]);
    /*
   * The total value of all the shares to the user, based on the current ZX Index Value.
   */ const totalValuesFromZXIndexValue = (0, $70fFQ.useMemo)(()=>{
        return shareQuantities.map((shareQuantity, index)=>{
            const currentZXIndexValue = orderFlowStats[index].currentZXIndexValue;
            if (shareQuantity === null || currentZXIndexValue === null) return null;
            return shareQuantity * currentZXIndexValue;
        });
    }, [
        shareQuantities,
        orderFlowStats
    ]);
    /*
   * The total value of all the shares to the user, based on their latest custom valuation for
   * each company.
   */ const totalValuesFromCustomValuation = (0, $70fFQ.useMemo)(()=>{
        return shareQuantities.map((shareQuantity, index)=>{
            const customValuation = latestCustomValuations[index];
            if (shareQuantity === null || customValuation === null) return null;
            return shareQuantity * customValuation.computed_value;
        });
    }, [
        shareQuantities,
        latestCustomValuations
    ]);
    /*
   * The difference between the current total value, and the cost basis for the share lots.
   */ const unrealizedGainsFromZXIndexValue = (0, $70fFQ.useMemo)(()=>{
        return totalValuesFromZXIndexValue.map((totalValue, index)=>{
            const costBasis = costBases[index];
            if (costBasis === null || totalValue === null) return null;
            return totalValue - costBasis;
        });
    }, [
        totalValuesFromZXIndexValue,
        costBases
    ]);
    /*
   * The difference between the current total value, and the cost basis for the share lots, based on
   * the latest custom valuation for each company.
   */ const unrealizedGainFromCustomValuation = (0, $70fFQ.useMemo)(()=>{
        return totalValuesFromCustomValuation.map((totalValue, index)=>{
            const costBasis = costBases[index];
            if (costBasis === null || totalValue === null) return null;
            return totalValue - costBasis;
        });
    }, [
        totalValuesFromCustomValuation,
        costBases
    ]);
    return (portfolioCompanies || []).map((company, index)=>({
            company: company,
            isLoading: orderFlowReportsQueries.queryInfo[index].isLoading || shareLotsQueries.queryInfo[index].isLoading,
            isError: orderFlowReportsQueries.queryInfo[index].isError || shareLotsQueries.queryInfo[index].isError,
            createdOn: company.created_on,
            removed: Boolean(company.company?.removed),
            removedOn: company.company?.removed_on,
            removedReason: company.company?.removed_reason,
            name: companyNames[index],
            ...orderFlowStats[index],
            customValuation: latestCustomValuations[index],
            shareLots: shareLots[index],
            shareQuantity: shareQuantities[index],
            costBasis: costBases[index],
            totalValueFromZXIndexValue: totalValuesFromZXIndexValue[index],
            totalValueFromCustomValuation: totalValuesFromCustomValuation[index],
            unrealizedGainFromZXIndexValue: unrealizedGainsFromZXIndexValue[index],
            unrealizedGainFromCustomValuation: unrealizedGainFromCustomValuation[index]
        }));
};
var $a840f37efa0f043f$export$2e2bcd8739ae039 = $a840f37efa0f043f$var$usePortfolioCompanyAggregates;



var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");



/**
 * Computes "last week's" portfolio total value. Similar to the usePortfolioValue hook, but
 * rather than multiplying the current ZX Index Value by the share quantities for each company, it
 * computes the previous week's ZX Index Value based on the current value and the percentage change
 * from the previous week, and uses that.
 *
 * @param {string} portfolioId
 * @return {number|null} - Returns the computed value on success, or null if any of the queries are
 *    still loading or encountered errors.
 */ const $59d8e8d545f6ae7a$var$useLastWeekPortfolioValue = (portfolioId)=>{
    const [portfolioCompanies, companiesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    // Get all the share lots and latest orderflow report for all the companies. useFetches guarantees
    // the order of the results matches the order of the queries, and we will make use of that fact
    // below.
    const [shareLots, shareLotsLoading] = (0, $175f183e6334c39c$export$2e2bcd8739ae039)(portfolioId);
    const [orderFlowReports, orderflowLoading] = (0, $361bea2ba5ead2bb$export$2e2bcd8739ae039)(portfolioId);
    const lastWeekValue = (0, $70fFQ.useMemo)(()=>{
        if (!orderFlowReports || !shareLots) return null;
        return (portfolioCompanies || []).map((company, index)=>{
            // Make use of the useFetches ordering guarantee.
            const companyShareLots = shareLots[index];
            const previousZXIndexValue = orderFlowReports[index][1]?.zx_index_price;
            if (!previousZXIndexValue) // We only include companies with verified data in the portfolio value calculation.
            return 0;
            const totalShareQuantity = companyShareLots.reduce((acc, shareLot)=>acc + shareLot.share_quantity, 0);
            return totalShareQuantity * previousZXIndexValue;
        }).reduce((acc, value)=>acc + value, 0);
    }, [
        orderFlowReports,
        shareLots,
        portfolioCompanies
    ]);
    if (companiesLoading || orderflowLoading || shareLotsLoading || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(portfolioCompanies)) return null;
    return lastWeekValue;
};
var $59d8e8d545f6ae7a$export$2e2bcd8739ae039 = $59d8e8d545f6ae7a$var$useLastWeekPortfolioValue;



var $70fFQ = parcelRequire("70fFQ");



/**
 * Using the current value of the portfolio and the cost basis of the portfolio, computes the
 * unrealized gain of the portfolio.
 *
 * @param {string} portfolioId
 * @return {number|null} - Returns the computed on success, or null if any of the queries are still
 *    loading or encountered errors.
 */ const $e14bfaf84535560c$var$usePortfolioUnrealizedGain = (portfolioId)=>{
    const currentValue = (0, $c0753d95e24a3305$export$2e2bcd8739ae039)(portfolioId);
    const [shareLots, shareLotsLoading] = (0, $175f183e6334c39c$export$2e2bcd8739ae039)(portfolioId);
    const [orderFlowReports, orderFlowLoading] = (0, $361bea2ba5ead2bb$export$2e2bcd8739ae039)(portfolioId);
    // Compute the cost basis across all share lots for portfolioID
    const costBasis = (0, $70fFQ.useMemo)(()=>{
        if (!shareLots || !orderFlowReports) return null;
        return shareLots.reduce((acc, companyShareLots, index)=>{
            // We do not include company share lots for companies whose current ZX Index Value is null,
            // because then the share lot would be -100%.
            if (!companyShareLots || !orderFlowReports[index][0]?.zx_index_price) return acc;
            return acc + companyShareLots.reduce((acc, shareLot)=>acc + Number(shareLot.price_per_share) * shareLot.share_quantity, 0);
        }, 0);
    }, [
        shareLots,
        orderFlowReports
    ]);
    const totalUnrealizedGain = (0, $70fFQ.useMemo)(()=>{
        if (costBasis === null || currentValue === null) return null;
        return currentValue - costBasis;
    }, [
        currentValue,
        costBasis
    ]);
    if (shareLotsLoading || orderFlowLoading) return null;
    return totalUnrealizedGain;
};
var $e14bfaf84535560c$export$2e2bcd8739ae039 = $e14bfaf84535560c$var$usePortfolioUnrealizedGain;




/**
 * Fetches portfolios containing a company.
 * Mostly copied from `usePortfolioCompanies`, but is a separate hook since the intent is
 * very different, as this hook is used to fetch portfolios containing a given company
 * while `usePortfolioCompanies` is used to fetch companies in a given portfolio.
 *
 * Note that this hook is intended to be used with zb_ids and currently does not support
 * requested companies
 *
 * @param {string} companyId
 * @return {[Array<object>|null, boolean]}
 */ const $ba149842d65eafb2$var$usePortfoliosContainingCompany = (companyId)=>{
    const companiesQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_COMPANIES(), {
        company__zb_id: companyId
    }, {
        enabled: Boolean(companyId)
    });
    if (companiesQuery.isLoading) return [
        null,
        true
    ];
    if (!companiesQuery.isSuccess) return [
        null,
        false
    ];
    return [
        companiesQuery.cleanedData.data,
        false
    ];
};
var $ba149842d65eafb2$export$2e2bcd8739ae039 = $ba149842d65eafb2$var$usePortfoliosContainingCompany;









const $ddb71d6eb587cb49$var$StyledDonutChartContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding-right: 16px;
`;
const $ddb71d6eb587cb49$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $bc98d6e7d0ab4f53$export$2e2bcd8739ae039))`
  padding: 0 16px;

  ${(props)=>props.$hide && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      display: none;
    `}
`;
// for recharts, 0 degrees is at 3 o'clock so we need to adjust the start and end angles
// by 90 degrees to get the correct orientation.
// we go from 450 to 90 degrees to make the chart go clockwise.
const $ddb71d6eb587cb49$var$DONUT_START_ANGLE = 450;
const $ddb71d6eb587cb49$var$DONUT_END_ANGLE = 90;
const $ddb71d6eb587cb49$var$DonutChart = ({ percentage: percentage })=>{
    const theme = (0, $e42cae22e74e223a$export$93d4e7f90805808f)();
    const data = [
        {
            value: percentage,
            color: theme.colors.branding500
        },
        {
            value: 100 - percentage,
            color: (0, $dfd33cee3229493c$exports.PrimaryColorPalette).white15
        }
    ];
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ddb71d6eb587cb49$var$StyledDonutChartContainer, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $135ac290ed466b55$export$b99d3348f709c998), {
            width: 40,
            height: 40,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a476105a50608ff4$export$2ae8800cf67c848c), {
                data: data,
                outerRadius: 20,
                innerRadius: 14,
                dataKey: "value",
                startAngle: $ddb71d6eb587cb49$var$DONUT_START_ANGLE,
                endAngle: $ddb71d6eb587cb49$var$DONUT_END_ANGLE,
                children: data.map((entry, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6ebe10030e701f4c$export$f6f0c3fe4ec306ea), {
                        stroke: null,
                        fill: entry.color
                    }, `cell-${index}`))
            })
        })
    });
};
$ddb71d6eb587cb49$var$DonutChart.propTypes = {
    percentage: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
};
const $ddb71d6eb587cb49$var$StyledPortfolioName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.TruncatedText))`
  max-width: 300px;
`;
const $ddb71d6eb587cb49$var$HoldingsListItem = ({ portfolioCompany: portfolioCompany, onComputePercentage: onComputePercentage, hide: hide })=>{
    const portfolioId = portfolioCompany?.portfolio[1];
    const [portfolio, portfolioIsLoading] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)(portfolioId);
    const totalValue = (0, $c0753d95e24a3305$export$2e2bcd8739ae039)(portfolioId);
    const aggregates = (0, $a840f37efa0f043f$export$2e2bcd8739ae039)([
        portfolioCompany
    ]);
    const [percentage, setPercentage] = (0, $70fFQ.useState)(null);
    (0, $70fFQ.useEffect)(()=>{
        if (totalValue === null || aggregates[0].isLoading) return;
        const newPercentage = totalValue ? aggregates[0]?.totalValueFromZXIndexValue / totalValue * 100 : 0;
        if (newPercentage !== percentage) onComputePercentage(newPercentage);
        setPercentage(newPercentage);
    }, [
        aggregates,
        onComputePercentage,
        percentage,
        totalValue
    ]);
    if (portfolioIsLoading || aggregates[0].isLoading) return null;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ddb71d6eb587cb49$var$StyledListItem, {
        $hide: hide,
        listStyle: (0, $dfd33cee3229493c$exports.ListStyles).TWO_LINE,
        leadingContent: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ddb71d6eb587cb49$var$DonutChart, {
            percentage: percentage
        }),
        text: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ddb71d6eb587cb49$var$StyledPortfolioName, {
                children: portfolio?.name
            })
        }),
        subtext: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                    children: (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentage)
                }),
                " ",
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                    children: "of this portfolio"
                })
            ]
        }),
        trailingContent: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ChevronRightIcon), {
            color: (0, $dfd33cee3229493c$exports.PrimaryColorPalette).white50
        }),
        url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIO(portfolioId),
        onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickHoldingsListItem(portfolioCompany.company.name)
    });
};
$ddb71d6eb587cb49$var$HoldingsListItem.propTypes = {
    hide: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    onComputePercentage: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    portfolioCompany: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        portfolio: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string),
        company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
        }).isRequired
    }).isRequired
};
const $ddb71d6eb587cb49$var$HoldingsCard = ()=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const cardTitle = `Your holdings of ${company?.name}`;
    const [portfolioPercentages, setPortfolioPercentages] = (0, $70fFQ.useState)({});
    const [portfolioCompanies, portfolioCompaniesLoading] = (0, $ba149842d65eafb2$export$2e2bcd8739ae039)(company.zb_id);
    const onComputePercentage = (0, $70fFQ.useCallback)((portfolioId, percentage)=>setPortfolioPercentages((prev)=>({
                ...prev,
                [portfolioId]: percentage
            })), []);
    /*
   * We'll sort the portfolio companies by the percentage of the portfolio they represent.
   */ const sortedPortfolioCompanies = (0, $70fFQ.useMemo)(()=>{
        if (!(portfolioCompanies && Object.keys(portfolioPercentages).length === portfolioCompanies.length)) return portfolioCompanies;
        return portfolioCompanies?.sort((a, b)=>portfolioPercentages[b.portfolio[1]] - portfolioPercentages[a.portfolio[1]]).slice(0, 5);
    }, [
        portfolioCompanies,
        portfolioPercentages
    ]);
    const allPercentagesLoaded = (0, $70fFQ.useMemo)(()=>{
        if (!portfolioCompanies || !company) return false;
        return sortedPortfolioCompanies && sortedPortfolioCompanies.length === Math.min(5, portfolioCompanies.length);
    }, [
        company,
        portfolioCompanies,
        sortedPortfolioCompanies
    ]);
    if (companyIsLoading || portfolioCompaniesLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: cardTitle,
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 32,
            children: "Holdings are loading..."
        })
    });
    if (!company || !portfolioCompanies) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: cardTitle,
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 32,
            children: "An error has occurred."
        })
    });
    if (portfolioCompanies.length === 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: cardTitle,
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 32,
            children: "No holdings of this company"
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: cardTitle,
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.List), {
            children: [
                sortedPortfolioCompanies.map((portfolioCompany)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ddb71d6eb587cb49$var$HoldingsListItem, {
                        hide: !allPercentagesLoaded,
                        portfolioCompany: portfolioCompany,
                        onComputePercentage: (percentage)=>onComputePercentage(portfolioCompany.portfolio[1], percentage)
                    }, `holding_item_${portfolioCompany.apiId}`)),
                !allPercentagesLoaded && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                    $margin: 32,
                    children: "Holdings are loading..."
                })
            ]
        })
    });
};
var $ddb71d6eb587cb49$export$2e2bcd8739ae039 = $ddb71d6eb587cb49$var$HoldingsCard;





var $70fFQ = parcelRequire("70fFQ");








var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");







var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");



const $cae95c5f30fb26c6$export$2aef760adc50e4c2 = "--";
const $cae95c5f30fb26c6$export$ec5d4f9e49a406e9 = "name_";
const $cae95c5f30fb26c6$export$95c82b6edd1812c7 = "weight_";
const $cae95c5f30fb26c6$export$60d9dd7388251618 = "component_type_";
const $cae95c5f30fb26c6$export$ad6c51b0649b796a = "current_value_";
const $cae95c5f30fb26c6$export$7d06ad40f02bc47b = "initial_value_";
const $cae95c5f30fb26c6$export$2a619d37ecce8d48 = "ZX Market Indices";
const $cae95c5f30fb26c6$export$1a6e795411c0c81 = 0;
const $cae95c5f30fb26c6$export$f6e9db416b98a143 = 10;
const $cae95c5f30fb26c6$export$178116d1e4b93949 = 20;
const $cae95c5f30fb26c6$export$899fc22946bfeab4 = 30;
const $cae95c5f30fb26c6$export$48cf7c587fa2ed9d = 40;
const $cae95c5f30fb26c6$export$38fe8b1d68fdbad1 = 50;
const $cae95c5f30fb26c6$export$f84e92b1dbaa05f9 = 60;
const $cae95c5f30fb26c6$export$401b02bb6f0a7e18 = {
    [$cae95c5f30fb26c6$export$1a6e795411c0c81]: "Other",
    [$cae95c5f30fb26c6$export$f6e9db416b98a143]: "ZX Index Value",
    [$cae95c5f30fb26c6$export$178116d1e4b93949]: "ZX Index Value Trailing",
    [$cae95c5f30fb26c6$export$899fc22946bfeab4]: "Reported Marks",
    [$cae95c5f30fb26c6$export$48cf7c587fa2ed9d]: "Funding Round",
    [$cae95c5f30fb26c6$export$38fe8b1d68fdbad1]: "Private Market Index Comparison",
    [$cae95c5f30fb26c6$export$f84e92b1dbaa05f9]: "Company Comparison"
};
const $cae95c5f30fb26c6$export$69f76b5d34a5636 = "ZXEQ";




var $cd0Jr = parcelRequire("cd0Jr");



var $hI4Hx = parcelRequire("hI4Hx");


/*
 * Helper to debounce the modification mixpanel event for the field each of the editable components
 * uses.
 */ const $20dd6074bf336e59$export$564c1b5f0a9675fe = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((companyName, fieldName, fieldType, defaultValue, newValue)=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyDefaultComponentValue(companyName, fieldName, fieldType, defaultValue, newValue), (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a), {
    leading: false,
    trailing: true
});
const $20dd6074bf336e59$export$582c124cf407ed2c = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((companyName, oldName, newName)=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyCustomCriterionName(companyName, oldName, newName), (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a), {
    leading: false,
    trailing: true
});
const $20dd6074bf336e59$export$3b0acee6bf49a1ab = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((companyName, componentName, oldValue, newValue)=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyCustomCriterionValue(companyName, componentName, oldValue, newValue), (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a), {
    leading: false,
    trailing: true
});



var $70fFQ = parcelRequire("70fFQ");


/**
 * Returns the weighted value for a given component type.
 * Most component types are simple multiplication by the weight; however, some require additional
 * calculations.
 *
 * @param {number|string} currentValue - The current value of the component
 * @param {number} weight - The weight of the component
 * @param {number} componentType - The type of the component
 * @param formValues - Supplementary form values required in some calculations.
 * @return {number|null}
 */ const $04acc63186b2e971$var$getWeightedValueForComponent = (currentValue, weight, componentType, formValues)=>{
    if (weight === 0) // Short circuit so we don't see null values for 0-weighted components, since we don't care
    // about those in the final sum/validity of the form.
    return 0;
    switch(componentType){
        case 0, $cae95c5f30fb26c6$export$f6e9db416b98a143:
        case 0, $cae95c5f30fb26c6$export$178116d1e4b93949:
        case 0, $cae95c5f30fb26c6$export$899fc22946bfeab4:
        case 0, $cae95c5f30fb26c6$export$48cf7c587fa2ed9d:
        case 0, $cae95c5f30fb26c6$export$1a6e795411c0c81:
            return (Number(currentValue) || 0) * weight / 100;
        case 0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1:
            // This type involves the previous valuation multiplied by a percentage change.
            if (!formValues || !formValues.previous_pps && formValues.previous_pps !== 0) return null;
            return (1 + Number(currentValue) || 0) * (formValues.previous_pps || 0) * weight / 100;
        default:
            return null;
    }
};
var $04acc63186b2e971$export$2e2bcd8739ae039 = $04acc63186b2e971$var$getWeightedValueForComponent;



// Removes periods (.) and replaces them with underscores (_), since `.` denotes a
// nested field in our forms.
const $c4d995d57bf57d07$export$863b699e61e72272 = (id)=>String(id).split(".").join("_");
const $c4d995d57bf57d07$export$81de1b1dfa4df31e = (id)=>`${0, $cae95c5f30fb26c6$export$ec5d4f9e49a406e9}${$c4d995d57bf57d07$export$863b699e61e72272(id)}`;
const $c4d995d57bf57d07$export$d26ed11629a407db = (id)=>`${0, $cae95c5f30fb26c6$export$95c82b6edd1812c7}${$c4d995d57bf57d07$export$863b699e61e72272(id)}`;
const $c4d995d57bf57d07$export$a7bb5fe944834813 = (id)=>`${0, $cae95c5f30fb26c6$export$60d9dd7388251618}${$c4d995d57bf57d07$export$863b699e61e72272(id)}`;
const $c4d995d57bf57d07$export$ee5be55cf0249756 = (id)=>`${0, $cae95c5f30fb26c6$export$ad6c51b0649b796a}${$c4d995d57bf57d07$export$863b699e61e72272(id)}`;
const $c4d995d57bf57d07$export$724d03e87e3deb01 = (id)=>`${0, $cae95c5f30fb26c6$export$7d06ad40f02bc47b}${$c4d995d57bf57d07$export$863b699e61e72272(id)}`;


/**
 * Calculate the percentage gain of the private market index. Assumes values are sorted in
 * descending order by time, so the last item in the list should be the oldest value, and the first
 * item should be the most recent.
 *
 * @param privateMarketIndexValues - a list of private market index values, where the `value` key
 *    of each object represents the price per share of the index.
 * @return {number} - Positive for gain, negative for loss.
 *    i.e. 0.1 -> a 10% gain, -0.05 -> a 5% loss.
 */ const $89ee4b1bb625134e$var$computePrivateMarketGain = (privateMarketIndexValues)=>{
    if (!privateMarketIndexValues || privateMarketIndexValues.length === 0) return null;
    // Get the first and last items in the list, and calculate the percentage change.
    const firstValue = privateMarketIndexValues[privateMarketIndexValues.length - 1].value;
    const lastValue = privateMarketIndexValues[0].value;
    // If either value is missing or falsey (other than 0), return null.
    if (!firstValue && firstValue !== 0 || !lastValue && lastValue !== 0) return null;
    return (lastValue - firstValue) / firstValue;
};
var $89ee4b1bb625134e$export$2e2bcd8739ae039 = $89ee4b1bb625134e$var$computePrivateMarketGain;




/**
 * A helper that extracts the relevant form field values from form state and combines them
 * into an array of objects where each object represents 1 of the weighted components in the form.
 * Useful for keeping weights + values in 1 place while not constantly doing name-based lookups.

 *
 * @return {Array}
 */ const $393fe82cf00b6f5f$var$useComponents = (values)=>{
    const componentIds = (0, $70fFQ.useMemo)(()=>Object.keys(values).filter((key)=>key.startsWith((0, $cae95c5f30fb26c6$export$ec5d4f9e49a406e9))).map((key)=>key.replace((0, $cae95c5f30fb26c6$export$ec5d4f9e49a406e9), "")), [
        values
    ]);
    return (0, $70fFQ.useMemo)(()=>componentIds.map((componentId)=>({
                id: componentId,
                name: values[(0, $c4d995d57bf57d07$export$81de1b1dfa4df31e)(componentId)],
                weight: values[(0, $c4d995d57bf57d07$export$d26ed11629a407db)(componentId)],
                componentType: values[(0, $c4d995d57bf57d07$export$a7bb5fe944834813)(componentId)],
                initialValue: values[(0, $c4d995d57bf57d07$export$724d03e87e3deb01)(componentId)],
                currentValue: values[(0, $c4d995d57bf57d07$export$ee5be55cf0249756)(componentId)]
            })), [
        values,
        componentIds
    ]);
};
/*
 * Gets a single component based on ID.
 */ const $393fe82cf00b6f5f$export$20304da8a9e0268b = (values, id)=>{
    const components = $393fe82cf00b6f5f$var$useComponents(values);
    const foundComponent = components.find((component)=>component.id === (0, $c4d995d57bf57d07$export$863b699e61e72272)(id));
    if (!foundComponent) return {};
    return foundComponent;
};
var $393fe82cf00b6f5f$export$2e2bcd8739ae039 = $393fe82cf00b6f5f$var$useComponents;



var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");


/*
 * Retrieves HDFundingRound objects for the company that do not occur in the future to the
 * provided valuation date. Possibly returns undefined if there are no such objects.
 */ const $563ccae8320ce392$var$useLatestFundingRound = (companyId, valuationDate, queryEnabled = false)=>{
    const fundingRoundsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).FUNDING_ROUNDS(), {
        company: companyId,
        "page[size]": 10000
    }, {
        enabled: queryEnabled
    });
    return (0, $70fFQ.useMemo)(()=>{
        // Finds the HDFundingRound whose date is most recent prior to the valuation date.
        const hdFundingRounds = fundingRoundsQuery.cleanedData?.data || [];
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).maxBy(hdFundingRounds, (round)=>round.date && new Date(round.date) <= new Date(valuationDate) ? new Date(round.date).getTime() : -1),
            fundingRoundsQuery.isLoading
        ];
    }, [
        fundingRoundsQuery.isLoading,
        valuationDate,
        fundingRoundsQuery.cleanedData?.data
    ]);
};
var $563ccae8320ce392$export$2e2bcd8739ae039 = $563ccae8320ce392$var$useLatestFundingRound;




var $70fFQ = parcelRequire("70fFQ");


/*
 * Retrieves OrderFlowReport objects for the company that do not occur in the future to the
 * provided valuation date. Possibly returns undefined if there are no such objects.
 */ const $cc0d9f1785481f03$var$useLatestOrderFlowReport = (companyId, endDate, queryEnabled = false)=>{
    const startDate = (0, $70fFQ.useMemo)(()=>{
        // We'll store a query start date to limit the number of results we get back.
        if (!endDate) return null;
        return (0, $86d2f3987cc9d604$exports.DateTime).fromISO(endDate).minus({
            weeks: 4
        }).toISODate();
    }, [
        endDate
    ]);
    // We offset the end_date by 1 day so that on Fridays we never get different values depending on
    // when in the day the user runs the valuation (we generate OrderFlowReports on Fridays).
    const orderFlowQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_PRICE_VOLUME_ORDER_FLOW(), {
        company: companyId,
        end_date: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(endDate).minus({
            days: 1
        }).toISODate(),
        ...startDate ? {
            start_date: startDate
        } : {}
    }, {
        enabled: queryEnabled
    });
    return (0, $70fFQ.useMemo)(()=>[
            orderFlowQuery.cleanedData?.data?.[0],
            orderFlowQuery.isLoading
        ], [
        orderFlowQuery.cleanedData?.data,
        orderFlowQuery.isLoading
    ]);
};
var $cc0d9f1785481f03$export$2e2bcd8739ae039 = $cc0d9f1785481f03$var$useLatestOrderFlowReport;




var $70fFQ = parcelRequire("70fFQ");


const $970e297198e83701$var$useLatestReportedMarks = (companyId, valuationDate, queryEnabled)=>{
    // The reported marks endpoint deals in "months ago" as its date range querying format, so we'll
    // determine the values here, based on valuationDate.
    const valuationDateObj = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(valuationDate);
    let monthsAgo = Math.ceil(Math.max((0, $86d2f3987cc9d604$exports.DateTime).fromObject({
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: 1
    }).diff(valuationDateObj, "months").months, 0));
    const companyReportedMarksValuationQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_REPORTED_MARKS_VALUATION(companyId), {
        months_ago_start: monthsAgo + 12,
        months_ago_end: monthsAgo - 3
    }, {
        enabled: queryEnabled
    });
    return (0, $70fFQ.useMemo)(()=>{
        if (!companyReportedMarksValuationQuery.isSuccess) return [
            null,
            null,
            companyReportedMarksValuationQuery.isLoading
        ];
        // Find the most recent date with data for reported marks.
        const mostRecentDateWithData = Object.keys(companyReportedMarksValuationQuery.data.data).sort((a, b)=>new Date(b) - new Date(a)).filter((dateKey)=>Boolean(companyReportedMarksValuationQuery.data.data[dateKey].weighted_avg))?.[0];
        return [
            companyReportedMarksValuationQuery.data?.data?.[mostRecentDateWithData],
            mostRecentDateWithData,
            companyReportedMarksValuationQuery.isLoading
        ];
    }, [
        companyReportedMarksValuationQuery.isSuccess,
        companyReportedMarksValuationQuery.isLoading,
        companyReportedMarksValuationQuery.data?.data
    ]);
};
var $970e297198e83701$export$2e2bcd8739ae039 = $970e297198e83701$var$useLatestReportedMarks;



var $70fFQ = parcelRequire("70fFQ");
const $2bc09423f50031f8$var$useNoDataErrorState = (nullConditions, computedValue)=>{
    return (0, $70fFQ.useMemo)(()=>{
        if (nullConditions) return null;
        if (!computedValue && computedValue !== 0) return "No data for the selected date range";
        return null;
    }, [
        nullConditions,
        computedValue
    ]);
};
var $2bc09423f50031f8$export$2e2bcd8739ae039 = $2bc09423f50031f8$var$useNoDataErrorState;





const $fa530cf65d1d2850$var$usePrivateMarketIndices = ()=>{
    const privateMarketIndicesQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_AND_SECURITY_SEARCH(), {
        "page[size]": 10000,
        security_type: (0, $cae95c5f30fb26c6$export$2a619d37ecce8d48),
        removed: false
    });
    return privateMarketIndicesQuery.cleanedData?.data;
};
var $fa530cf65d1d2850$export$2e2bcd8739ae039 = $fa530cf65d1d2850$var$usePrivateMarketIndices;






const $a5c42c9fc76ddc77$export$81761b52b04ea573 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: relative;
  display: grid;
  // Simulate a table's columns.
  grid-template-columns: 50% 20% 30%;
  row-gap: 16px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  border-bottom: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};

  background: ${({ $isSelected: $isSelected })=>$isSelected ? (0, $dfd33cee3229493c$exports.YukaColorPalette).activeTransparent : "transparent"};

  ${(props)=>props.$noInteraction ? (0, $e42cae22e74e223a$export$dbf350e5966cf602)`` : (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          cursor: pointer;

          &:hover {
            background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).hoverTransparent};
          }
          &:active {
            background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).activeTransparent};
          }
        `}
`;
const $a5c42c9fc76ddc77$export$709757f95208cf6c = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $a5c42c9fc76ddc77$export$7926177aa829ea06 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;




var $70fFQ = parcelRequire("70fFQ");

var $hI4Hx = parcelRequire("hI4Hx");

/**
 * A simple wrapper for useState that debounces the state update using lodash's debounce function,
 * and the specified delay. This function should be used when dealing with state changes that
 * occur frequently, and trigger long-running tasks.
 *
 * The main usage is a search box that triggers an API fetch. If we do not debounce the component's
 * state updates, we will trigger an API fetch for every keystroke. This is not ideal, as we will
 * be making many unnecessary API calls. Instead, we can debounce the state update, and only trigger
 * the API fetch after the user has stopped typing for a specified amount of time. Note that the
 * setter will be equipped with the `.cancel()` method as with any _.debounced function.
 *
 * @param initialValue
 * @param delay - A number of milliseconds to wait before sending a request.
 * @returns {Array} - the state value, a setter function that will debounce the
 *  state update, should be used as if it were a regular call to useState, and the regular
 *  setter in case the client sometimes wants to skip the debounced logic.
 */ const $814b4b84818795e9$var$useDebouncedState = (initialValue, delay = (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a))=>{
    const [state, setState] = (0, $70fFQ.useState)(initialValue);
    const debouncedSetter = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce(setState, delay, {
            leading: false,
            trailing: true
        }), [
        setState,
        delay
    ]);
    // Sneaks in the raw setter as well if you're interested in sometimes skipping the debouncing.
    return [
        state,
        debouncedSetter,
        setState
    ];
};
var $814b4b84818795e9$export$2e2bcd8739ae039 = $814b4b84818795e9$var$useDebouncedState;


const $d0c1f22839eed905$var$CustomComponentField = ({ companyName: companyName, editable: editable, componentId: componentId })=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    // These will be used for mixpanel tracking.
    const { name: name, currentValue: currentValue } = (0, $393fe82cf00b6f5f$export$20304da8a9e0268b)(values, componentId);
    const [previousName, setPreviousName] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(name);
    const [previousValue, setPreviousValue] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(currentValue);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$709757f95208cf6c), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: "You can customize your own criterion to include in the valuation calculation."
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$7926177aa829ea06), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        disabled: !editable,
                        name: (0, $c4d995d57bf57d07$export$81de1b1dfa4df31e)(componentId),
                        label: "Criterion name",
                        placeholder: "Untitled",
                        onChange: (value)=>{
                            (0, $20dd6074bf336e59$export$582c124cf407ed2c)(companyName, previousName, value);
                            setPreviousName(value);
                        }
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        disabled: !editable,
                        name: (0, $c4d995d57bf57d07$export$ee5be55cf0249756)(componentId),
                        type: "number",
                        label: "Value",
                        placeholder: "Enter a price",
                        onChange: (value)=>{
                            (0, $20dd6074bf336e59$export$3b0acee6bf49a1ab)(companyName, name, previousValue, value);
                            setPreviousValue(value);
                        }
                    })
                ]
            })
        ]
    });
};
$d0c1f22839eed905$var$CustomComponentField.propTypes = {
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    componentId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
var $d0c1f22839eed905$export$2e2bcd8739ae039 = $d0c1f22839eed905$var$CustomComponentField;





var $cd0Jr = parcelRequire("cd0Jr");




const $a01502d75a137031$var$FundMarksField = ({ companyId: companyId })=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const [, reportedMarksDate] = (0, $970e297198e83701$export$2e2bcd8739ae039)(companyId, values.valuation_date, Boolean(companyId));
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$709757f95208cf6c), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: "If available we use the dollar-weighted average price at which funds are marking their positions as our default value."
            }),
            reportedMarksDate && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: [
                    "Our most recent reported marks are from",
                    " ",
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(reportedMarksDate).toFormat("LLLL, yyyy")
                    }),
                    "."
                ]
            })
        ]
    });
};
$a01502d75a137031$var$FundMarksField.propTypes = {
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
var $a01502d75a137031$export$2e2bcd8739ae039 = $a01502d75a137031$var$FundMarksField;




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");










const $c15a3969d2572adc$var$debouncedModifyPreviousValuationValue = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((companyName, previousValue, newValue)=>{
    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyPreviousValuation(companyName, previousValue, newValue);
}, (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a), {
    leading: false,
    trailing: true
});
const $c15a3969d2572adc$var$IndexPerformanceField = ({ companyName: companyName, companyId: companyId, editable: editable, visible: visible })=>{
    const [loadedDefault, setLoadedDefault] = (0, $70fFQ.useState)(false);
    const { change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { selected_sector_index: selectedSectorIndexFromForm, previous_pps: previousValuation, previous_date: previousValuationDate } = values;
    const [oldPreviousValuationValue, setOldPreviousValuationValue] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(previousValuation);
    const [oldPreviousValuationDate, setOldPreviousValuationDate] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(previousValuationDate);
    const sectorQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_SECTORS(), {
        company: companyId
    }, {
        enabled: Boolean(companyId)
    });
    const companySector = sectorQuery.cleanedData?.data?.[0];
    const privateMarketIndices = (0, $fa530cf65d1d2850$export$2e2bcd8739ae039)();
    const defaultPrivateMarketIndex = (0, $70fFQ.useMemo)(()=>{
        if (privateMarketIndices && companySector) {
            // Try to find matching sector index.
            const sectorIndex = privateMarketIndices.find((index)=>index.name === companySector?.name);
            if (sectorIndex) return sectorIndex;
            // Fall back to the ZXEQ if there's no matching sector index.
            return privateMarketIndices.find((index)=>index.symbol === (0, $cae95c5f30fb26c6$export$69f76b5d34a5636));
        }
        return null;
    }, [
        privateMarketIndices,
        companySector
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (defaultPrivateMarketIndex && !loadedDefault && !selectedSectorIndexFromForm) {
            setLoadedDefault(true);
            change("selected_sector_index", defaultPrivateMarketIndex.private_market_index?.[1]);
        }
    }, [
        change,
        loadedDefault,
        selectedSectorIndexFromForm,
        defaultPrivateMarketIndex
    ]);
    // This component must be rendered despite not matching the "currently selected component"
    // because we need to perform the logic above, where we prepopulate the `selected_sector_index`
    // form value. That form value is used downstream by the `IndexComparisonComponentRow` to
    // render the percentage gain/loss of the index, and we need to be able to render that gain
    // prior to the user actually selecting this row. Therefore, we allow all the above logic to
    // execute and render nothing in the DOM.
    if (!visible) return null;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$709757f95208cf6c), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: "Index performance tracks the performance of a group of companies that represent a portion of the market or a sector."
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: [
                    "Please fill in",
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: " ALL "
                    }),
                    "the following fields in order to include index performance in the calculation."
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$7926177aa829ea06), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        disabled: !editable,
                        onChange: (indexId)=>{
                            if (!indexId) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clearValuationComparison(companyName, (0, $cae95c5f30fb26c6$export$401b02bb6f0a7e18)[0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1]);
                            else {
                                const selectedIndex = privateMarketIndices?.find((index)=>index?.private_market_index[1] === indexId);
                                (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).selectValuationComparison(companyName, `${selectedIndex?.name} (${selectedIndex?.symbol})`, (0, $cae95c5f30fb26c6$export$401b02bb6f0a7e18)[0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1]);
                            }
                        },
                        type: "select",
                        label: "Private market index",
                        name: "selected_sector_index",
                        options: privateMarketIndices?.map((index)=>({
                                label: `${index.name} (${index.symbol})`,
                                value: index.private_market_index[1]
                            })),
                        placeholder: "Select an index",
                        noSort: true
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        disabled: !editable,
                        onChange: (value)=>{
                            $c15a3969d2572adc$var$debouncedModifyPreviousValuationValue(companyName, Number(oldPreviousValuationValue), value);
                            setOldPreviousValuationValue(value);
                        },
                        id: "previous_pps",
                        name: "previous_pps",
                        type: "number",
                        label: "Previous valuation",
                        leadingIcon: (0, $dfd33cee3229493c$exports.DollarIcon)
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        onChange: (value)=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyPreviousValuationDate(companyName, oldPreviousValuationDate, value);
                            setOldPreviousValuationDate(value);
                        },
                        disabled: !editable,
                        id: "previous_date",
                        name: "previous_date",
                        type: "date",
                        placeholder: "",
                        label: "Previous valuation date",
                        parse: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromJSDate(value).toISODate()
                    })
                ]
            })
        ]
    });
};
$c15a3969d2572adc$var$IndexPerformanceField.propTypes = {
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    visible: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
var $c15a3969d2572adc$export$2e2bcd8739ae039 = $c15a3969d2572adc$var$IndexPerformanceField;




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");







const $e5bf163b1b4a3564$var$LastFundingRoundField = ({ companyName: companyName, companyId: companyId, editable: editable, resetValue: resetValue, componentId: componentId })=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { name: name, initialValue: initialValue } = (0, $393fe82cf00b6f5f$export$20304da8a9e0268b)(values, componentId);
    const [fundingRound] = (0, $563ccae8320ce392$export$2e2bcd8739ae039)(companyId, values.valuation_date, Boolean(companyId));
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$709757f95208cf6c), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: [
                    "If available, we use the cost of a single share during the most recent investment round as our default value.",
                    fundingRound && fundingRound.price_per_share && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                        children: [
                            "Our sources indicate that the most recent primary financing round was",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                children: [
                                    " ",
                                    fundingRound.event,
                                    " "
                                ]
                            }),
                            "in",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                children: [
                                    " ",
                                    (0, $86d2f3987cc9d604$exports.DateTime).fromISO(fundingRound.date).toFormat("LLLL, yyyy")
                                ]
                            })
                        ]
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: "You can override the default value by entering your own number below:"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$7926177aa829ea06), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        disabled: !editable,
                        initialValue: values[(0, $c4d995d57bf57d07$export$724d03e87e3deb01)(componentId)],
                        name: (0, $c4d995d57bf57d07$export$ee5be55cf0249756)(componentId),
                        type: "number",
                        label: "Financing round",
                        placeholder: "Enter a price",
                        onChange: (value)=>{
                            if (value !== initialValue && (value || initialValue)) (0, $20dd6074bf336e59$export$564c1b5f0a9675fe)(companyName, name, (0, $cae95c5f30fb26c6$export$401b02bb6f0a7e18)[0, $cae95c5f30fb26c6$export$48cf7c587fa2ed9d], initialValue, value);
                        }
                    }),
                    editable && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ActionChip), {
                        text: "Restore default",
                        onClick: resetValue
                    })
                ]
            })
        ]
    });
};
$e5bf163b1b4a3564$var$LastFundingRoundField.propTypes = {
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    resetValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    componentId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$e5bf163b1b4a3564$var$LastFundingRoundField.defaultProps = {
    resetValue: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
};
var $e5bf163b1b4a3564$export$2e2bcd8739ae039 = $e5bf163b1b4a3564$var$LastFundingRoundField;




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");









var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");


const $bb0ef5dcd8e37d29$var$StyledCounterContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme80).attrs({
    as: "div"
})`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  height: 16px;
  padding: 0 8px;
  ${(props)=>(0, $e42cae22e74e223a$export$dbf350e5966cf602)`
    background: ${props.$background};
    color: ${props.$color};
  `}
`;
const $bb0ef5dcd8e37d29$var$StyledCounter = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.FontWeights).bold}
  padding: 0;
`;
/*
 * Handy label to include as the trailing text in the zx index price fields to indicate
 * the robustness score of the provided default value.
 */ const $bb0ef5dcd8e37d29$var$RobustnessScoreLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef(({ score: score }, ref)=>{
    const colorOptions = {
        low: {
            background: "#484846",
            color: "#918F8C"
        },
        medium: {
            background: "#555342",
            color: "#C4BC71"
        },
        high: {
            background: "#263322",
            color: "#83B59C"
        }
    };
    let color = colorOptions.low;
    if (score >= 3) color = colorOptions.medium;
    if (score >= 7) color = colorOptions.high;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bb0ef5dcd8e37d29$var$StyledCounterContainer, {
        ref: ref,
        $background: color.background,
        $color: color.color,
        children: [
            "RS",
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bb0ef5dcd8e37d29$var$StyledCounter, {
                children: score
            })
        ]
    });
});
$bb0ef5dcd8e37d29$var$RobustnessScoreLabel.propTypes = {
    score: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
};
var $bb0ef5dcd8e37d29$export$2e2bcd8739ae039 = $bb0ef5dcd8e37d29$var$RobustnessScoreLabel;




const $4b591179c6517494$var$LastSecondaryPriceField = ({ companyName: companyName, companyId: companyId, editable: editable, resetValue: resetValue, componentId: componentId })=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { name: name, initialValue: initialValue, currentValue: currentValue } = (0, $393fe82cf00b6f5f$export$20304da8a9e0268b)(values, componentId);
    const [orderFlowReport] = (0, $cc0d9f1785481f03$export$2e2bcd8739ae039)(companyId, values.valuation_date, !initialValue && Boolean(values.valuation_date) && Boolean(companyId));
    const robustnessLabel = orderFlowReport && orderFlowReport.zx_index_value_trailing ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bb0ef5dcd8e37d29$export$2e2bcd8739ae039), {
        score: orderFlowReport.robustness
    }) : null;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$709757f95208cf6c), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: "If available, we use the most recent ZX Index Value (trailing) as our default value. ZX Index Value (trailing) is designed to provide a view on where the most recent transaction has closed."
            }),
            editable && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: "You can override the default value by entering your own number below:"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$7926177aa829ea06), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        initialValue: values[(0, $c4d995d57bf57d07$export$724d03e87e3deb01)(componentId)],
                        disabled: !editable,
                        name: (0, $c4d995d57bf57d07$export$ee5be55cf0249756)(componentId),
                        type: "number",
                        label: "Secondary price",
                        placeholder: "Enter a price",
                        trailingIcon: initialValue === currentValue ? ()=>robustnessLabel : null,
                        onChange: (value)=>{
                            if (value !== initialValue && (value || initialValue)) (0, $20dd6074bf336e59$export$564c1b5f0a9675fe)(companyName, name, (0, $cae95c5f30fb26c6$export$401b02bb6f0a7e18)[0, $cae95c5f30fb26c6$export$178116d1e4b93949], initialValue, value);
                        }
                    }),
                    editable && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ActionChip), {
                        text: "Restore default",
                        onClick: resetValue
                    })
                ]
            })
        ]
    });
};
$4b591179c6517494$var$LastSecondaryPriceField.propTypes = {
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    resetValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    componentId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
$4b591179c6517494$var$LastSecondaryPriceField.defaultProps = {
    resetValue: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
};
var $4b591179c6517494$export$2e2bcd8739ae039 = $4b591179c6517494$var$LastSecondaryPriceField;





const $0a2377cde2662088$var$StyledInformationPanel = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 24px;
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface2};
  border-left: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white05};
`;
const $0a2377cde2662088$var$StyledHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const $0a2377cde2662088$var$ComponentRowDetailPanel = ({ companyName: companyName, companyId: companyId, editable: editable, removeComponent: removeComponent })=>{
    const { change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const componentId = values.selected_row;
    const { name: name, componentType: componentType, initialValue: initialValue, currentValue: currentValue } = (0, $393fe82cf00b6f5f$export$20304da8a9e0268b)(values, componentId);
    if (!componentId) return null;
    const resetValue = ()=>{
        // Shared helper function that some of the children will use.
        if (currentValue !== initialValue) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).restoreDefaultComponentValue(companyName, name, (0, $cae95c5f30fb26c6$export$401b02bb6f0a7e18)[componentType]);
        change((0, $c4d995d57bf57d07$export$ee5be55cf0249756)(componentId), initialValue);
    };
    const label = componentType === (0, $cae95c5f30fb26c6$export$1a6e795411c0c81) ? "Custom criterion" : name;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($0a2377cde2662088$var$StyledInformationPanel, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($0a2377cde2662088$var$StyledHeader, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
                        children: label
                    }),
                    editable && componentType === (0, $cae95c5f30fb26c6$export$1a6e795411c0c81) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ActionChip), {
                        onClick: ()=>removeComponent(componentId),
                        text: "Remove"
                    })
                ]
            }),
            componentType === (0, $cae95c5f30fb26c6$export$178116d1e4b93949) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $4b591179c6517494$export$2e2bcd8739ae039), {
                companyName: companyName,
                companyId: companyId,
                editable: editable,
                resetValue: resetValue,
                componentId: componentId
            }),
            componentType === (0, $cae95c5f30fb26c6$export$48cf7c587fa2ed9d) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e5bf163b1b4a3564$export$2e2bcd8739ae039), {
                companyName: companyName,
                companyId: companyId,
                editable: editable,
                resetValue: resetValue,
                componentId: componentId
            }),
            componentType === (0, $cae95c5f30fb26c6$export$899fc22946bfeab4) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a01502d75a137031$export$2e2bcd8739ae039), {
                companyId: companyId,
                editable: editable,
                resetValue: resetValue,
                componentId: componentId
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c15a3969d2572adc$export$2e2bcd8739ae039), {
                visible: componentType === (0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1),
                companyName: companyName,
                companyId: companyId,
                editable: editable,
                componentId: componentId
            }),
            componentType === (0, $cae95c5f30fb26c6$export$1a6e795411c0c81) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d0c1f22839eed905$export$2e2bcd8739ae039), {
                companyName: companyName,
                componentId: componentId,
                editable: editable
            })
        ]
    });
};
$0a2377cde2662088$var$ComponentRowDetailPanel.propTypes = {
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    removeComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
var $0a2377cde2662088$export$2e2bcd8739ae039 = $0a2377cde2662088$var$ComponentRowDetailPanel;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");






const $1f388ee7c3189762$var$StyledFooterRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  border-top: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  padding: 16px;

  > :first-child {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;
const $1f388ee7c3189762$var$StyledOverlineUnit = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50)`
  margin-left: 8px;
`;
/**
 * Computes the valuation based on the available form values, by adding them up.
 * Also renders the previous valuation + current date ƒorm fields.
 */ const $1f388ee7c3189762$var$ComputedValuationFooterRow = ({ valuation: valuation, onClose: onClose, onDelete: onDelete })=>{
    const { values: values, valid: valid, submitting: submitting } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    const components = (0, $393fe82cf00b6f5f$export$2e2bcd8739ae039)(values);
    const sumOfWeights = (0, $70fFQ.useMemo)(()=>Object.keys(components).reduce((acc, key)=>acc + (components[key].weight || 0), 0), [
        components
    ]);
    const computedValuation = (0, $70fFQ.useMemo)(()=>{
        if (valuation) return valuation.computed_value;
        if (sumOfWeights !== 100) return null;
        if (Object.keys(components).some((key)=>Boolean(components[key].weight) && !components[key].currentValue && components[key].currentValue !== 0)) // Null value acts as a sentinel to indicate that there is an un-computed value with non-zero
        // weighting; therefore the valuation cannot be computed.
        return null;
        const fieldContributingValues = components.map((component)=>(0, $04acc63186b2e971$export$2e2bcd8739ae039)(component.currentValue, component.weight || 0, component.componentType, values));
        if (fieldContributingValues.some((value)=>value === null)) // Null value acts as a sentinel to indicate that there is an un-computed value with non-zero
        // weighting; therefore the valuation cannot be computed.
        return null;
        return fieldContributingValues.reduce((acc, value)=>acc + value, 0);
    }, [
        components,
        valuation,
        values,
        sumOfWeights
    ]);
    (0, $70fFQ.useEffect)(()=>{
        change("computed_valuation", computedValuation);
    }, [
        computedValuation,
        change
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            surfaceLevel: 2
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($1f388ee7c3189762$var$StyledFooterRow, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                            type: "hidden",
                            name: "computed_valuation",
                            validate: ()=>{
                                if (valuation || computedValuation !== null) return undefined;
                                return "Valuation cannot be computed with unpopulated fields.";
                            }
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                            children: "Calculated valuation"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                                    children: computedValuation || computedValuation === 0 ? (0, $66339e7a022e68c9$export$365988f95ba9ba73)(computedValuation, 2) : "--"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($1f388ee7c3189762$var$StyledOverlineUnit, {
                                    children: "USD / Share"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                            buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                            onClick: onClose,
                            children: valuation ? "Close" : "Cancel"
                        }),
                        valuation ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                            buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                            onClick: onDelete,
                            children: "Delete"
                        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                            type: "submit",
                            buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                            disabled: valuation || !valid || submitting,
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
};
$1f388ee7c3189762$var$ComputedValuationFooterRow.propTypes = {
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    valuation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        computed_value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    })
};
var $1f388ee7c3189762$export$2e2bcd8739ae039 = $1f388ee7c3189762$var$ComputedValuationFooterRow;





var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");













const $72f81949cfe57742$var$StyledComponentLabel = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
const $72f81949cfe57742$var$StyledLabel = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $72f81949cfe57742$var$StyledWeightWithArrow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;
const $72f81949cfe57742$var$StyledArrowContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  height: 32px;
  flex: 0 0 32px;
  background: ${({ $isSelected: $isSelected })=>$isSelected ? (0, $dfd33cee3229493c$exports.ColorPalette).white15 : "transparent"};
`;
const $72f81949cfe57742$var$debouncedModifyWeight = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((companyName, fieldName, fieldType, previousValue, newValue)=>{
    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyValuationWeightField(companyName, fieldName, fieldType, previousValue, newValue);
}, (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a), {
    leading: false,
    trailing: true
});
/**
 * Renders a row describing an individual component in a weighted valuation sum. Supports the basic
 * component structure, with a label, a value and a weight field. Renders the `children` prop
 * directly in-line with the label. Typically, this prop will be used for a form value, such as a
 * Select.
 */ const $72f81949cfe57742$var$ValuationPriceComponentRow = ({ id: id, name: name, weight: weight, companyName: companyName, initialValue: initialValue, children: children, helpText: helpText, errorText: propsErrorText, componentType: componentType, editable: editable })=>{
    const { change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const isSelected = values.selected_row === id;
    const selectRow = (0, $70fFQ.useCallback)(()=>{
        if (!isSelected) change("selected_row", id);
    }, [
        id,
        isSelected,
        change
    ]);
    const { name: nameFromForm, weight: weightFromForm, currentValue: currentValue, initialValue: initialValueFromForm } = (0, $393fe82cf00b6f5f$export$20304da8a9e0268b)(values, id);
    // Used for debouncing mixpanel events.
    const [previousWeight, setPreviousWeight] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(weightFromForm);
    (0, $70fFQ.useEffect)(()=>{
        // Default weight to props, or 0 if props.weight is falsey.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(weightFromForm)) change((0, $c4d995d57bf57d07$export$d26ed11629a407db)(id), weight);
        // Default form values that won't change.
        if (!nameFromForm) change((0, $c4d995d57bf57d07$export$81de1b1dfa4df31e)(id), name);
        change((0, $c4d995d57bf57d07$export$a7bb5fe944834813)(id), componentType);
        // Propagate the initial value to the form values so the "Reset to defaults" button downstream
        // can properly work.
        if (initialValueFromForm !== initialValue) {
            change((0, $c4d995d57bf57d07$export$724d03e87e3deb01)(id), initialValue);
            // Propagates the current value to the form values so the calculator header can compute the
            // overall weighted sum.
            change((0, $c4d995d57bf57d07$export$ee5be55cf0249756)(id), initialValue === null ? null : Number((0, $9cd630fd213df404$export$2e2bcd8739ae039)(initialValue, 6)));
        }
    }, [
        change,
        id,
        initialValue,
        initialValueFromForm,
        name,
        nameFromForm,
        weight,
        weightFromForm,
        componentType
    ]);
    const renderedValue = (0, $70fFQ.useMemo)(()=>{
        if (!currentValue && currentValue !== 0) return 0, $cae95c5f30fb26c6$export$2aef760adc50e4c2;
        switch(componentType){
            case 0, $cae95c5f30fb26c6$export$f6e9db416b98a143:
            case 0, $cae95c5f30fb26c6$export$178116d1e4b93949:
            case 0, $cae95c5f30fb26c6$export$899fc22946bfeab4:
            case 0, $cae95c5f30fb26c6$export$48cf7c587fa2ed9d:
            case 0, $cae95c5f30fb26c6$export$1a6e795411c0c81:
                return (0, $66339e7a022e68c9$export$736d072c44caa715)(currentValue, 2, true);
            case 0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1:
                return (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(currentValue * 100, 2);
            default:
                return 0, $cae95c5f30fb26c6$export$2aef760adc50e4c2;
        }
    }, [
        currentValue,
        componentType
    ]);
    const errorText = (0, $70fFQ.useMemo)(()=>{
        if (!weightFromForm) return null;
        if (propsErrorText) return propsErrorText;
        if (!currentValue && currentValue !== 0 || !nameFromForm) return "Missing required information";
        return null;
    }, [
        propsErrorText,
        currentValue,
        nameFromForm,
        weightFromForm
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$81761b52b04ea573), {
        $isSelected: isSelected,
        onClick: selectRow,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($72f81949cfe57742$var$StyledComponentLabel, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f82caaae0faa7ac9$export$2e2bcd8739ae039), {
                        icon: (0, $dfd33cee3229493c$exports.FunctionIcon),
                        backgroundColor: (0, $dfd33cee3229493c$exports.ColorPalette).white80,
                        color: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface2
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($72f81949cfe57742$var$StyledLabel, {
                        children: [
                            !nameFromForm ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "Untitled"
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                children: nameFromForm
                            }),
                            errorText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2sell, {
                                children: errorText
                            }),
                            helpText && !errorText && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme50, {
                                children: helpText
                            })
                        ]
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                children: renderedValue
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($72f81949cfe57742$var$StyledWeightWithArrow, {
                children: [
                    editable ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        width: 100,
                        onChange: (value)=>{
                            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(previousWeight)) // Don't trigger unless the weight is not being initialized from null/undefined.
                            $72f81949cfe57742$var$debouncedModifyWeight(companyName, name, (0, $cae95c5f30fb26c6$export$401b02bb6f0a7e18)[componentType], previousWeight, value);
                            setPreviousWeight(value);
                        },
                        name: (0, $c4d995d57bf57d07$export$d26ed11629a407db)(id),
                        type: "number",
                        placeholder: "0",
                        trailingIcon: (0, $dfd33cee3229493c$exports.PercentIcon)
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(Number(weightFromForm), 2)
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($72f81949cfe57742$var$StyledArrowContainer, {
                        $isSelected: isSelected,
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ChevronRightIcon), {
                            color: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                        })
                    })
                ]
            })
        ]
    });
};
$72f81949cfe57742$var$ValuationPriceComponentRow.propTypes = {
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    pricePerShare: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    percentageChange: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    weight: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    initialValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node,
    errorText: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    helpText: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    componentType: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
};
$72f81949cfe57742$var$ValuationPriceComponentRow.defaultProps = {
    helpText: null,
    editable: true,
    isSelected: false
};
var $72f81949cfe57742$export$2e2bcd8739ae039 = $72f81949cfe57742$var$ValuationPriceComponentRow;


const $8a6c9937668d9a35$var$FundingRoundPriceComponentRow = (props)=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { currentValue: currentValue } = (0, $393fe82cf00b6f5f$export$20304da8a9e0268b)(values, props.id);
    const [fundingRound, fundingRoundIsLoading] = (0, $563ccae8320ce392$export$2e2bcd8739ae039)(props.companyId, values.valuation_date, !props.initialValue && Boolean(props.companyId));
    const computedValue = (0, $70fFQ.useMemo)(()=>props.initialValue ? props.initialValue : Number(fundingRound?.price_per_share) || null, [
        props.initialValue,
        fundingRound?.price_per_share
    ]);
    const error = (0, $2bc09423f50031f8$export$2e2bcd8739ae039)(props.initialValue || !values.valuation_date || fundingRoundIsLoading, computedValue || currentValue);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $72f81949cfe57742$export$2e2bcd8739ae039), {
        ...props,
        errorText: error,
        editable: !props.initialValue,
        initialValue: computedValue
    });
};
$8a6c9937668d9a35$var$FundingRoundPriceComponentRow.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    initialValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
var $8a6c9937668d9a35$export$2e2bcd8739ae039 = $8a6c9937668d9a35$var$FundingRoundPriceComponentRow;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



const $1a554ca1a4162fa8$var$FundMarksPriceComponentRow = (props)=>{
    const { values: { valuation_date: valuationDate } } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const [reportedMarksData, , reportedMarksDataIsLoading] = (0, $970e297198e83701$export$2e2bcd8739ae039)(props.companyId, valuationDate, !props.initialValue && Boolean(props.companyId));
    const computedValue = (0, $70fFQ.useMemo)(()=>props.initialValue ? props.initialValue : Number(reportedMarksData?.weighted_avg) || null, [
        props.initialValue,
        reportedMarksData?.weighted_avg
    ]);
    const error = (0, $2bc09423f50031f8$export$2e2bcd8739ae039)(props.initialValue || !valuationDate || reportedMarksDataIsLoading, computedValue);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $72f81949cfe57742$export$2e2bcd8739ae039), {
        ...props,
        errorText: error,
        editable: !props.initialValue,
        initialValue: computedValue
    });
};
$1a554ca1a4162fa8$var$FundMarksPriceComponentRow.propTypes = {
    initialValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
var $1a554ca1a4162fa8$export$2e2bcd8739ae039 = $1a554ca1a4162fa8$var$FundMarksPriceComponentRow;





var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");






/**
 * A wrapper for the value-computing valuation component, which handles fetching the relevant
 * index values and computing the percentage change. Propagates the percentage to the form values
 * to be used downstream in the computed value computation.
 * @param props
 *
 */ const $4cb4eeb7ed2d57c2$var$IndexComparisonComponentRow = (props)=>{
    const { values: { selected_sector_index: selectedSectorIndexId, valuation_date: endDate, previous_pps: previousPPS, previous_date: startDate } } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const previousFriday = (0, $70fFQ.useMemo)(()=>{
        if (!startDate) return null;
        // Get the previous friday to startDate unless startDate is a friday.
        const date = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(startDate);
        const dayOfWeek = date.weekday;
        const friday = 5;
        let daysToSubtract = 0;
        if (dayOfWeek !== friday) {
            if (dayOfWeek > friday) daysToSubtract = dayOfWeek - friday;
            else daysToSubtract = 7 - (friday - dayOfWeek);
        }
        return date.minus({
            days: daysToSubtract
        }).toISODate();
    }, [
        startDate
    ]);
    const privateMarketIndices = (0, $fa530cf65d1d2850$export$2e2bcd8739ae039)();
    const privateMarketIndex = privateMarketIndices?.find((index)=>index.private_market_index?.[1] === selectedSectorIndexId);
    const privateMarketIndexValuesQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).ZX_MARKET_INDEX_VALUES(), {
        market_index: selectedSectorIndexId,
        start_date: previousFriday,
        ...endDate && {
            end_date: endDate
        }
    }, {
        enabled: Boolean(selectedSectorIndexId && !props.initialValue && startDate)
    });
    const privateMarketIndexValues = (0, $70fFQ.useMemo)(()=>privateMarketIndexValuesQuery.cleanedData?.data || [], [
        privateMarketIndexValuesQuery.cleanedData?.data
    ]);
    const computedValue = (0, $70fFQ.useMemo)(()=>{
        if (props.initialValue) return props.initialValue;
        if (!startDate || privateMarketIndexValuesQuery.isLoading) return null;
        if (!previousPPS) return null;
        return (0, $89ee4b1bb625134e$export$2e2bcd8739ae039)(privateMarketIndexValues);
    }, [
        previousPPS,
        startDate,
        props.initialValue,
        privateMarketIndexValuesQuery.isLoading,
        privateMarketIndexValues
    ]);
    const error = (0, $2bc09423f50031f8$export$2e2bcd8739ae039)(props.initialValue || !startDate || !previousPPS || privateMarketIndexValuesQuery.isLoading, computedValue);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $72f81949cfe57742$export$2e2bcd8739ae039), {
        ...props,
        helpText: privateMarketIndex && `${privateMarketIndex?.name} (${privateMarketIndex?.symbol})`,
        errorText: error,
        editable: !props.initialValue,
        initialValue: computedValue
    });
};
$4cb4eeb7ed2d57c2$var$IndexComparisonComponentRow.propTypes = {
    initialValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
var $4cb4eeb7ed2d57c2$export$2e2bcd8739ae039 = $4cb4eeb7ed2d57c2$var$IndexComparisonComponentRow;






var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




const $d168c494d6e56371$var$StyledModalHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
`;
const $d168c494d6e56371$var$StyledModalTitle = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
const $d168c494d6e56371$var$ValuationCalculatorModalHeader = ({ companyName: companyName, valuation: valuation, previousValuations: previousValuations })=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    // These will be used for mixpanel tracking.
    const [oldValuationDate, setOldValuationDate] = (0, $70fFQ.useState)(values.valuation_date);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($d168c494d6e56371$var$StyledModalHeader, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($d168c494d6e56371$var$StyledModalTitle, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                                children: "Valuation calculator"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme50, {
                                children: "for"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                                children: companyName
                            }),
                            " ",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme50, {
                                children: "on"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                        onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickValuationDate(companyName),
                        onChange: (value)=>{
                            // find the valuation in previousValuation that was created most recently prior to the new date value
                            const previousValuation = previousValuations.filter((v)=>v.valuation_date <= value).sort((a, b)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(b.valuation_date) - (0, $86d2f3987cc9d604$exports.DateTime).fromISO(a.valuation_date))[0];
                            if (previousValuation) {
                                change("previous_date", previousValuation.valuation_date);
                                change("previous_pps", previousValuation.computed_value);
                            } else if (values.valuation_date && values.previous_date && values.valuation_date < values.previous_date) {
                                change("previous_date", undefined);
                                change("previous_pps", undefined);
                            }
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyValuationDate(companyName, oldValuationDate, value);
                            setOldValuationDate(value);
                        },
                        disabled: valuation,
                        id: "valuation_date",
                        name: "valuation_date",
                        type: "date",
                        placeholder: "MM/DD/YYYY",
                        parse: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromJSDate(value).toISODate(),
                        width: 138
                    })
                ]
            }),
            !valuation && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme50, {
                children: "Changing the date might affect the value for certain criteria"
            })
        ]
    });
};
$d168c494d6e56371$var$ValuationCalculatorModalHeader.propTypes = {
    valuation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({}),
    previousValuations: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        valuation_date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    })),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
$d168c494d6e56371$var$ValuationCalculatorModalHeader.defaultProps = {
    valuation: {},
    previousValuations: []
};
var $d168c494d6e56371$export$2e2bcd8739ae039 = $d168c494d6e56371$var$ValuationCalculatorModalHeader;




var $70fFQ = parcelRequire("70fFQ");





// Simulate a table's header.
const $9cafe7c256d6ce2a$var$StyledStickyHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: sticky;
  top: 0;
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
  border-top: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  z-index: 1;
`;
const $9cafe7c256d6ce2a$var$ValuationComponentsHeader = ()=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const components = (0, $393fe82cf00b6f5f$export$2e2bcd8739ae039)(values);
    const sumOfWeights = (0, $70fFQ.useMemo)(()=>Object.keys(components).reduce((acc, key)=>acc + (components[key].weight || 0), 0), [
        components
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9cafe7c256d6ce2a$var$StyledStickyHeader, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a5c42c9fc76ddc77$export$81761b52b04ea573), {
            $noInteraction: true,
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                    children: "Included criterion"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                    children: "Value"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                    children: [
                        "Weighting (",
                        sumOfWeights !== 100 ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Overlinesell, {
                            children: [
                                sumOfWeights,
                                "%"
                            ]
                        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                            children: "100%"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme80, {
                            children: "/100%"
                        }),
                        ")"
                    ]
                })
            ]
        })
    });
};
var $9cafe7c256d6ce2a$export$2e2bcd8739ae039 = $9cafe7c256d6ce2a$var$ValuationComponentsHeader;





var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



const $aeb73813eb1992be$var$ZXIndexPriceComponentRow = (props)=>{
    const { values: values } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { currentValue: currentValue } = (0, $393fe82cf00b6f5f$export$20304da8a9e0268b)(values, props.id);
    const [orderFlowReport, orderFlowReportIsLoading] = (0, $cc0d9f1785481f03$export$2e2bcd8739ae039)(props.companyId, values.valuation_date, !props.initialValue && Boolean(values.valuation_date) && Boolean(props.companyId));
    const computedValue = (0, $70fFQ.useMemo)(()=>props.initialValue ? props.initialValue : Number(orderFlowReport?.zx_index_value_trailing) || null, [
        orderFlowReport,
        props.initialValue
    ]);
    const error = (0, $2bc09423f50031f8$export$2e2bcd8739ae039)(props.initialValue || !values.valuation_date || orderFlowReportIsLoading, computedValue || currentValue);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $72f81949cfe57742$export$2e2bcd8739ae039), {
        ...props,
        errorText: error,
        initialValue: computedValue,
        editable: !props.initialValue
    });
};
$aeb73813eb1992be$var$ZXIndexPriceComponentRow.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    initialValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
var $aeb73813eb1992be$export$2e2bcd8739ae039 = $aeb73813eb1992be$var$ZXIndexPriceComponentRow;








const $6242c343450c3bf5$var$StyledModal = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Modal))`
  width: 1000px;
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
`;
const $6242c343450c3bf5$var$StyledModalContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  border-top: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  width: 100%;
`;
const $6242c343450c3bf5$var$StyledTwoColumns = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 2fr 1fr;
`;
const $6242c343450c3bf5$var$StyledCriteriaList = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  height: 528px;
  overflow: auto;
  margin: 24px 0 0 24px;
  padding-right: 24px;
`;
const $6242c343450c3bf5$var$StyledAddCriterionButtonContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding: 16px;
`;
const $6242c343450c3bf5$var$getRenderedComponentRow = (componentType)=>{
    switch(componentType){
        case 0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1:
            return 0, $4cb4eeb7ed2d57c2$export$2e2bcd8739ae039;
        case 0, $cae95c5f30fb26c6$export$178116d1e4b93949:
        case 0, $cae95c5f30fb26c6$export$f6e9db416b98a143:
            return 0, $aeb73813eb1992be$export$2e2bcd8739ae039;
        case 0, $cae95c5f30fb26c6$export$48cf7c587fa2ed9d:
            return 0, $8a6c9937668d9a35$export$2e2bcd8739ae039;
        case 0, $cae95c5f30fb26c6$export$899fc22946bfeab4:
            return 0, $1a554ca1a4162fa8$export$2e2bcd8739ae039;
        default:
            return 0, $72f81949cfe57742$export$2e2bcd8739ae039;
    }
};
const $6242c343450c3bf5$var$ValuationCalculatorModal = ({ onClose: onClose, companyId: companyId, requestedCompanyId: requestedCompanyId, companyName: companyName, previousValuations: previousValuations, valuation: valuation })=>{
    const scrollAreaRef = (0, $70fFQ.useRef)(null);
    const todayDate = (0, $86d2f3987cc9d604$exports.DateTime).now().toISODate();
    const valuationDate = valuation ? valuation.valuation_date : todayDate;
    const latestValuation = (0, $70fFQ.useMemo)(()=>{
        if (previousValuations && previousValuations.length) return previousValuations[0];
        return {};
    }, [
        previousValuations
    ]);
    const defaultComponents = (0, $70fFQ.useMemo)(()=>{
        // When users are creating new valuations, we should default to include
        // The latest ZX index price, latest funding round, latest fund marks, and sector growth.
        // We'll need to configure the default weights in the future based on our formulas.
        return [
            {
                id: Math.random(),
                name: "Secondary price",
                valuation_component_type: (0, $cae95c5f30fb26c6$export$178116d1e4b93949),
                effective_as_of: todayDate
            },
            {
                id: Math.random(),
                name: "Primary financing",
                valuation_component_type: (0, $cae95c5f30fb26c6$export$48cf7c587fa2ed9d)
            },
            {
                id: Math.random(),
                name: "Reported marks",
                valuation_component_type: (0, $cae95c5f30fb26c6$export$899fc22946bfeab4),
                effective_as_of: todayDate
            },
            {
                id: Math.random(),
                name: "Index performance",
                valuation_component_type: (0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1),
                effective_as_of: todayDate
            }
        ];
    }, [
        todayDate
    ]);
    const [customComponents, setCustomComponents] = (0, $70fFQ.useState)([]);
    const activeWeightedComponents = (0, $70fFQ.useMemo)(()=>{
        if (valuation) return valuation.components.map((component)=>({
                ...component,
                weight: component.weight * 100
            }));
        return defaultComponents.concat(customComponents);
    }, [
        valuation,
        defaultComponents,
        customComponents
    ]);
    const selectedComponent = (0, $70fFQ.useMemo)(()=>activeWeightedComponents?.[0], [
        activeWeightedComponents
    ]);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = (0, $70fFQ.useState)(false);
    const createValuation = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CUSTOM_VALUATIONS(), false, {
        message: "Valuation created"
    });
    const deleteValuation = (0, $fd1e6894b991baa0$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CUSTOM_VALUATIONS(), {
        message: "Valuation deleted"
    });
    const deleteModal = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: ()=>setShowDeleteConfirmation(false),
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                        children: "Confirm Delete"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: "Are you sure you want to delete this valuation?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                        onClick: ()=>setShowDeleteConfirmation(false),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                        onClick: (event)=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).deleteCustomValuation(companyName, valuation.valuation_date);
                            deleteValuation.mutate({
                                id: valuation.id
                            });
                            setShowDeleteConfirmation(false);
                            onClose(event, true);
                        },
                        children: "Delete"
                    })
                ]
            })
        ]
    });
    const onClickAlt = ()=>{
        if (valuation) return setShowDeleteConfirmation(true);
    };
    (0, $70fFQ.useEffect)(()=>{
        // Auto scroll to the end if you're adding a new criterion.
        if (scrollAreaRef?.current) scrollAreaRef.current.scrollTop = scrollAreaRef.current?.scrollHeight;
    }, [
        activeWeightedComponents,
        scrollAreaRef
    ]);
    const onSubmit = (values)=>{
        const components = activeWeightedComponents.map((weightedComponent)=>{
            const private_market_index_id = weightedComponent.valuation_component_type === (0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1) ? values.selected_sector_index : null;
            const [name, weight, valuationComponentType] = [
                values[(0, $c4d995d57bf57d07$export$81de1b1dfa4df31e)(weightedComponent.id)],
                (values[(0, $c4d995d57bf57d07$export$d26ed11629a407db)(weightedComponent.id)] || 0) / 100,
                values[(0, $c4d995d57bf57d07$export$a7bb5fe944834813)(weightedComponent.id)]
            ];
            const componentData = {
                name: name,
                weight: weight,
                valuation_component_type: valuationComponentType,
                effective_as_of: values.valuation_date,
                comparison_private_market_index_id: private_market_index_id,
                comparison_company_id: null
            };
            if (valuationComponentType === (0, $cae95c5f30fb26c6$export$38fe8b1d68fdbad1)) componentData.percentage_change = values[(0, $c4d995d57bf57d07$export$ee5be55cf0249756)(weightedComponent.id)];
            else componentData.price_per_share = values[(0, $c4d995d57bf57d07$export$ee5be55cf0249756)(weightedComponent.id)];
            return componentData;
        });
        const postData = {
            ...companyId ? {
                company: companyId
            } : {},
            ...requestedCompanyId ? {
                requested_company: requestedCompanyId
            } : {},
            valuation_date: values.valuation_date,
            computed_value: null,
            previous_valuation_value: values.previous_pps,
            previous_valuation_date: values.previous_date,
            components: components
        };
        if (latestValuation) postData.previous_valuation = latestValuation.id;
        createValuation.mutate(postData);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).createCustomValuation(companyName, values.valuation_date);
        onClose(null, true);
    };
    const defaultSectorIndex = (0, $70fFQ.useMemo)(()=>{
        if (valuation) {
            // See if there are any components in the valuation with the sector index.
            const sectorIndexComponent = valuation.components.find((component)=>Boolean(component.comparison_private_market_index_id));
            if (sectorIndexComponent) return sectorIndexComponent.comparison_private_market_index_id;
        }
        // Will be handled downstream.
        return undefined;
    }, [
        valuation
    ]);
    const initialValues = (0, $70fFQ.useMemo)(()=>({
            selected_row: selectedComponent?.id,
            valuation_date: valuationDate,
            previous_pps: valuation ? valuation.previous_valuation_value : latestValuation.computed_value,
            previous_date: valuation ? valuation.previous_valuation_date : latestValuation.valuation_date,
            // Attempt to set the default sector index to match the company's sector.
            selected_sector_index: defaultSectorIndex
        }), [
        selectedComponent?.id,
        valuationDate,
        valuation,
        latestValuation,
        defaultSectorIndex
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
        initialValues: initialValues,
        onSubmit: onSubmit,
        children: ({ values: values, handleSubmit: handleSubmit, form: { change: change } })=>{
            const addNewComponent = ()=>{
                (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addCustomCriterion(companyName);
                const newId = Math.random();
                setCustomComponents([
                    ...customComponents,
                    {
                        id: newId,
                        name: null,
                        valuation_component_type: (0, $cae95c5f30fb26c6$export$1a6e795411c0c81),
                        weight: 0,
                        effective_as_of: todayDate
                    }
                ]);
                change("selected_row", newId);
            };
            const removeComponent = (componentId)=>{
                (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).removeCustomCriterion(companyName, values[(0, $c4d995d57bf57d07$export$81de1b1dfa4df31e)(componentId)]);
                // Find the component in the list.
                setCustomComponents(customComponents.filter((component)=>component.id !== componentId));
                // Change all corresponding field values to undefined.
                change((0, $c4d995d57bf57d07$export$81de1b1dfa4df31e)(componentId), undefined);
                change((0, $c4d995d57bf57d07$export$d26ed11629a407db)(componentId), undefined);
                change((0, $c4d995d57bf57d07$export$ee5be55cf0249756)(componentId), undefined);
                change((0, $c4d995d57bf57d07$export$a7bb5fe944834813)(componentId), undefined);
                change((0, $c4d995d57bf57d07$export$724d03e87e3deb01)(componentId), undefined);
                // Reset selected component to the top.
                change("selected_row", selectedComponent?.id);
            };
            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6242c343450c3bf5$var$StyledModal, {
                modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
                onClose: onClose,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d168c494d6e56371$export$2e2bcd8739ae039), {
                        companyName: companyName,
                        valuation: valuation,
                        previousValuations: previousValuations
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6242c343450c3bf5$var$StyledModalContent, {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6242c343450c3bf5$var$StyledTwoColumns, {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6242c343450c3bf5$var$StyledCriteriaList, {
                                            ref: scrollAreaRef,
                                            children: [
                                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9cafe7c256d6ce2a$export$2e2bcd8739ae039), {}),
                                                activeWeightedComponents.map((weightedComponent, index)=>{
                                                    const Component = $6242c343450c3bf5$var$getRenderedComponentRow(weightedComponent.valuation_component_type);
                                                    const initialValue = weightedComponent.price_per_share || weightedComponent.percentage_change || null;
                                                    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Component, {
                                                        id: weightedComponent.id,
                                                        companyId: companyId,
                                                        requestedCompanyId: requestedCompanyId,
                                                        companyName: companyName,
                                                        componentType: weightedComponent.valuation_component_type,
                                                        name: weightedComponent.name,
                                                        weight: weightedComponent.weight,
                                                        helpText: weightedComponent.help_text,
                                                        editable: !initialValue,
                                                        initialValue: initialValue
                                                    }, `weighted_component_${index}`);
                                                }),
                                                !valuation && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6242c343450c3bf5$var$StyledAddCriterionButtonContainer, {
                                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                                                        icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                                        onClick: addNewComponent,
                                                        children: "Add criterion"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $0a2377cde2662088$export$2e2bcd8739ae039), {
                                            companyName: companyName,
                                            companyId: companyId,
                                            editable: !valuation,
                                            removeComponent: removeComponent
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $1f388ee7c3189762$export$2e2bcd8739ae039), {
                                    onDelete: onClickAlt,
                                    onClose: onClose,
                                    companyName: companyName,
                                    valuation: valuation
                                })
                            ]
                        })
                    }),
                    showDeleteConfirmation && deleteModal
                ]
            });
        }
    });
};
$6242c343450c3bf5$var$ValuationCalculatorModal.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    requestedCompanyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    previousValuations: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        computed_value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        valuation_date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    })),
    valuation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        computed_value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        valuation_date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        previous_valuation_date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        previous_valuation_value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        components: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            weight: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            price_per_share: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            percentage_change: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            valuation_component_type: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
        }))
    })
};
$6242c343450c3bf5$var$ValuationCalculatorModal.defaultProps = {
    companyName: "",
    previousValuations: [],
    valuation: null
};
var $6242c343450c3bf5$export$2e2bcd8739ae039 = $6242c343450c3bf5$var$ValuationCalculatorModal;




const $791eddcdabae9c2e$var$PastValuationsModal = ({ onClose: onClose, valuations: valuations })=>{
    const [company, companyLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [viewingValuation, setViewingValuation] = (0, $70fFQ.useState)(null);
    const columns = (0, $70fFQ.useMemo)(()=>[
            {
                id: "date",
                accessor: "valuation_date",
                header: "Valuation date",
                cellRenderer: (0, $dfd33cee3229493c$exports.DateCell),
                width: 4
            },
            {
                id: "valuation",
                accessor: "computed_value",
                header: "Valuation",
                cellRenderer: (0, $dfd33cee3229493c$exports.CurrencyCell),
                width: 3
            },
            {
                id: "viewDetails",
                align: "right",
                accessor: (valuation)=>valuation,
                header: "",
                width: 2,
                cellRenderer: ({ value: valuation })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).DEFAULT,
                        onClick: (event)=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openCustomValuationModal(company?.name, false);
                            setViewingValuation(valuation);
                            event.stopPropagation();
                        },
                        children: "View details"
                    })
            }
        ], [
        company?.name
    ]);
    if (companyLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Modal), {
        title: "Loading past valuations"
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                $maxHeight: 500,
                $width: 552,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                        children: [
                            "Past valuations\xa0",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme50, {
                                children: "for\xa0"
                            }),
                            company.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
                        theme: {
                            tableStyles: {
                                colors: {
                                    header: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface1,
                                    row: "transparent",
                                    rowHover: "rgba(255, 255, 255, 0.05)",
                                    rowActive: "rgba(255, 255, 255, 0.07)"
                                },
                                header: {
                                    borderTop: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`,
                                    borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
                                },
                                cells: {
                                    borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                            usePercentageColumnWidths: true,
                            columns: columns,
                            data: valuations
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    onClick: onClose,
                    children: "Close"
                })
            }),
            viewingValuation && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6242c343450c3bf5$export$2e2bcd8739ae039), {
                onClose: (event, skipMixpanel = false)=>{
                    if (!skipMixpanel) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).closeValuationModal(company.name, !viewingValuation);
                    setViewingValuation(null);
                },
                companyName: company.name,
                companyId: company.zb_id,
                valuation: viewingValuation,
                previousValuations: valuations
            })
        ]
    });
};
$791eddcdabae9c2e$var$PastValuationsModal.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    valuations: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        valuation_date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        computed_value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    })).isRequired
};
var $791eddcdabae9c2e$export$2e2bcd8739ae039 = $791eddcdabae9c2e$var$PastValuationsModal;




const $6c2bed80dab78dd2$var$StyledValuationActions = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
const $6c2bed80dab78dd2$var$StyledCustomValuations = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
`;
const $6c2bed80dab78dd2$var$StyledDataContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  flex-direction: column;
  row-gap: 8px;
`;
const $6c2bed80dab78dd2$var$MODAL_CREATE_VALUATION = "CREATE_VALUATION";
const $6c2bed80dab78dd2$var$MODAL_VIEW_VALUATIONS = "VIEW_VALUATIONS";
const $6c2bed80dab78dd2$var$CARD_TITLE = "Recent custom valuations";
const $6c2bed80dab78dd2$var$RecentCustomValuationsCard = ()=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [modalShowing, setModalShowing] = (0, $70fFQ.useState)(null);
    const [valuations, valuationsIsLoading] = (0, $5c04b71cc3b9ae40$export$2e2bcd8739ae039)(company?.zb_id);
    const latestValuation = (0, $70fFQ.useMemo)(()=>{
        if (valuations && valuations.length) return valuations[0];
        return {};
    }, [
        valuations
    ]);
    if (companyIsLoading || valuationsIsLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: $6c2bed80dab78dd2$var$CARD_TITLE,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 32,
            children: "Recent valuations are loading..."
        })
    });
    const mostRecentDate = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(latestValuation.valuation_date);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Card), {
        title: $6c2bed80dab78dd2$var$CARD_TITLE,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6c2bed80dab78dd2$var$StyledCustomValuations, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6c2bed80dab78dd2$var$StyledDataContainer, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                                children: "Custom valuation"
                            }),
                            latestValuation.computed_value ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(latestValuation.computed_value, 2, 2)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme30, {
                                children: "--"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6c2bed80dab78dd2$var$StyledDataContainer, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                                children: "Date"
                            }),
                            mostRecentDate.isValid ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                                children: mostRecentDate.toFormat("MM/dd/yyyy")
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme30, {
                                children: "--"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6c2bed80dab78dd2$var$StyledValuationActions, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                        icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                        onClick: ()=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickValuationCardNewValuation(company.name);
                            setModalShowing($6c2bed80dab78dd2$var$MODAL_CREATE_VALUATION);
                        },
                        children: "New valuation"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                        icon: (0, $dfd33cee3229493c$exports.ClockIcon),
                        onClick: ()=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickValuationCardViewPastValuautions(company.name);
                            setModalShowing($6c2bed80dab78dd2$var$MODAL_VIEW_VALUATIONS);
                        },
                        children: "View past valuations"
                    })
                ]
            }),
            modalShowing === $6c2bed80dab78dd2$var$MODAL_CREATE_VALUATION && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6242c343450c3bf5$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    setModalShowing(null);
                },
                companyId: company.zb_id,
                companyName: company.name,
                previousValuations: valuations
            }),
            modalShowing === $6c2bed80dab78dd2$var$MODAL_VIEW_VALUATIONS && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $791eddcdabae9c2e$export$2e2bcd8739ae039), {
                onClose: ()=>setModalShowing(null),
                valuations: valuations
            })
        ]
    });
};
var $6c2bed80dab78dd2$export$2e2bcd8739ae039 = $6c2bed80dab78dd2$var$RecentCustomValuationsCard;




var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");





var $70fFQ = parcelRequire("70fFQ");



const $88e99f4c2bd06374$export$2aef760adc50e4c2 = "--";
const $88e99f4c2bd06374$export$563247ce2062b766 = "StockSplit";
const $88e99f4c2bd06374$export$95acb1cff781603c = "event";
const $88e99f4c2bd06374$export$80ac8f7dc189db5f = {
    colors: {
        header: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0,
        row: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0
    },
    header: {
        borderTop: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`,
        borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
    },
    cells: {
        borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
    }
};
const $88e99f4c2bd06374$export$c4690fd83b4516d = 5;
const $88e99f4c2bd06374$export$f6750a376240142c = 84;
const $88e99f4c2bd06374$export$e0f98a65ace826d = {
    FUNDING_ROUNDS: "Funding rounds",
    INVESTORS: "Investors",
    COIS: "COIs"
};



const $29a741c51bfaa3eb$export$52c5708a6fcb91e8 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 16px;
`;







const $5a0e06fdaa979949$var$StyledLink = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.HyperLink))`
  ${(0, $dfd33cee3229493c$exports.body1)}
`;
const $5a0e06fdaa979949$var$StyledLoadingState = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
`;
const $5a0e06fdaa979949$var$COIList = ()=>{
    const [company] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [isShowingMore, setIsShowingMore] = (0, $70fFQ.useState)(false);
    (0, $70fFQ.useEffect)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).viewCompanyCertificatesOfIncorporationList(company?.name);
    }, [
        company
    ]);
    const coiFilings = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COI_FILINGS(), {
        company: company.zb_id
    }, {
        enabled: Boolean(company?.zb_id)
    });
    const companyCOIs = coiFilings?.cleanedData?.data || [];
    if (coiFilings.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5a0e06fdaa979949$var$StyledLoadingState, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "Loading..."
        })
    });
    if (coiFilings.isError) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
        children: "An error has occurred."
    });
    if (coiFilings.isSuccess && companyCOIs.length === 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
        $margin: (0, $88e99f4c2bd06374$export$f6750a376240142c),
        children: "COIs not available"
    });
    const numberOfRows = isShowingMore ? companyCOIs.length : (0, $88e99f4c2bd06374$export$c4690fd83b4516d);
    const columns = [
        {
            accessor: "filing_date",
            header: "Date",
            width: 4,
            cellRenderer: ({ value: filingDate })=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(filingDate).toLocaleString((0, $86d2f3987cc9d604$exports.DateTime).DATE_FULL)
        },
        {
            id: "viewLink",
            accessor: (coiFiling)=>coiFiling,
            header: "",
            width: 1,
            align: "right",
            cellRenderer: ({ value: coiFiling })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5a0e06fdaa979949$var$StyledLink, {
                    url: coiFiling.file_url,
                    linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                    children: "View"
                })
        }
    ];
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            tableStyles: (0, $88e99f4c2bd06374$export$80ac8f7dc189db5f)
        },
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                data: companyCOIs.slice(0, numberOfRows),
                columns: columns,
                usePercentageColumnWidths: true
            }),
            companyCOIs.length > (0, $88e99f4c2bd06374$export$c4690fd83b4516d) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $29a741c51bfaa3eb$export$52c5708a6fcb91e8), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    onClick: ()=>{
                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickFundingsShowMore(company?.name, (0, $88e99f4c2bd06374$export$e0f98a65ace826d).COIS);
                        setIsShowingMore(!isShowingMore);
                    },
                    children: isShowingMore ? "Show fewer" : "Show more"
                })
            })
        ]
    });
};
var $5a0e06fdaa979949$export$2e2bcd8739ae039 = $5a0e06fdaa979949$var$COIList;





var $cd0Jr = parcelRequire("cd0Jr");


const $85efa06bc75c673b$var$StyledContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;
const $85efa06bc75c673b$var$StyledSize30Text = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80)`
  font-size: 30px;
  line-height: 40px;
`;
const $85efa06bc75c673b$var$FundingRoundsStat = ({ mainStatistic: mainStatistic, supportingText: supportingText })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($85efa06bc75c673b$var$StyledContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                children: supportingText
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($85efa06bc75c673b$var$StyledSize30Text, {
                children: mainStatistic
            })
        ]
    });
$85efa06bc75c673b$var$FundingRoundsStat.propTypes = {
    mainStatistic: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).elementType.isRequired,
    supportingText: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).elementType
};
$85efa06bc75c673b$var$FundingRoundsStat.defaultProps = {
    supportingText: null
};
var $85efa06bc75c673b$export$2e2bcd8739ae039 = $85efa06bc75c673b$var$FundingRoundsStat;





var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



var $cd0Jr = parcelRequire("cd0Jr");

const $567bc9cc27a3b5c2$var$EMPTY_VALUE_PLACEHOLDER = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
    children: "--"
});
const $567bc9cc27a3b5c2$var$FundingRoundEventCellRenderer = ({ value: fundingRound })=>{
    return fundingRound.event || $567bc9cc27a3b5c2$var$EMPTY_VALUE_PLACEHOLDER;
};
$567bc9cc27a3b5c2$var$FundingRoundEventCellRenderer.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        event: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        parent_funding_round: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({})
    }).isRequired
};
var $567bc9cc27a3b5c2$export$2e2bcd8739ae039 = $567bc9cc27a3b5c2$var$FundingRoundEventCellRenderer;




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");


/**
 * Renders a cell used in the Funding Rounds table. Since cell stock splits are rendered as a
 * simple badge in the first column followed by a row of empty cells, this component handles
 * rendering both stock splits and funding rounds by allowing funding round cells to specify their
 * own default values (typically a white30 --), but also automatically using a blank cell for
 * stock split rows.
 */ const $a8ed2fbb4aba28e0$var$FundingRoundOrStockSplitCellRenderer = ({ value: value, column: { fundingRoundCellRenderer: CellRenderer, ...column }, ...props })=>{
    if (value?.apiType === (0, $88e99f4c2bd06374$export$563247ce2062b766)) {
        const multiplier = parseFloat(value.multiplier).toString();
        const description = `${multiplier}:1 Stock Split`;
        // Renders a blank cell for all cells beyond the first column.
        return column?.id === (0, $88e99f4c2bd06374$export$95acb1cff781603c) ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.BadgeCell), {
            value: description,
            column: column,
            ...props
        }) : null;
    }
    if (CellRenderer) // We raw-call this renderer so we can actually get the underlying rendered value so automatic
    // tooltipping kicks in on the Table side.
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(CellRenderer, {
        value: value,
        column: column,
        ...props
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
        children: value
    });
};
$a8ed2fbb4aba28e0$var$FundingRoundOrStockSplitCellRenderer.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        apiType: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        parent_funding_round: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({}),
        multiplier: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired,
    column: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        fundingRoundCellRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    }).isRequired
};
var $a8ed2fbb4aba28e0$export$2e2bcd8739ae039 = $a8ed2fbb4aba28e0$var$FundingRoundOrStockSplitCellRenderer;






var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




/*
 * This function is used to sort the investor names in the modal that pops up from the
 * Funding Round table and in the Financings card.
 */ const $dcc04126e8d4465e$export$6e5018d043496eab = (a, b)=>{
    // Case-insensitive sort on entity profile name
    const nameA = a.investor.toLowerCase();
    const nameB = b.investor.toLowerCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
};


const $512fb3f69d16c13a$var$ENTITY_LOADING = "Loading...";
const $512fb3f69d16c13a$var$StyledList = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.List))`
  height: unset;
  max-height: 400px;
  margin: -16px 0; // dropdown component has padding that can't be overwritten
  padding: 0 16px;
  width: 228px;
`;
const $512fb3f69d16c13a$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  border-bottom: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  padding: 0;
`;
const $512fb3f69d16c13a$var$EntityName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${({ $loading: $loading })=>$loading ? (0, $dfd33cee3229493c$exports.FontColors).theme50 : (0, $dfd33cee3229493c$exports.FontColors).theme80};
`;
const $512fb3f69d16c13a$var$InvestorListHyperlinkCell = ({ value: fundingRound, entityProfiles: entityProfiles })=>{
    const investorList = (0, $70fFQ.useMemo)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(fundingRound)) return fundingRound.investors.map((investor)=>({
                investor: entityProfiles[investor[1]]?.name || $512fb3f69d16c13a$var$ENTITY_LOADING
            })).sort((0, $dcc04126e8d4465e$export$6e5018d043496eab));
        return [];
    }, [
        entityProfiles,
        fundingRound
    ]);
    const [dropdownElement, triggerRef, toggleDisplay] = (0, $ecfedd356bff7c39$export$2e2bcd8739ae039)(()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($512fb3f69d16c13a$var$StyledList, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($512fb3f69d16c13a$var$StyledListItem, {
                    text: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                        children: [
                            fundingRound.event,
                            " Investors"
                        ]
                    })
                }, "header"),
                investorList.map((investor, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($512fb3f69d16c13a$var$StyledListItem, {
                        text: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($512fb3f69d16c13a$var$EntityName, {
                            $loading: investor.investor === $512fb3f69d16c13a$var$ENTITY_LOADING,
                            children: investor.investor
                        })
                    }, `investor_${index}`))
            ]
        }));
    // Determine if we've loaded all the investor profiles.
    const allInvestorsLoaded = fundingRound.investors?.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).some(fundingRound.investors, (investor)=>investor[1] in entityProfiles);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            allInvestorsLoaded ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.HyperLink), {
                ref: triggerRef,
                onClick: ()=>toggleDisplay(fundingRound),
                children: [
                    fundingRound.investors.length,
                    " Investor",
                    fundingRound.investors.length > 1 ? "s" : ""
                ]
            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: (0, $88e99f4c2bd06374$export$2aef760adc50e4c2)
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.PageSection), {
                children: dropdownElement
            })
        ]
    });
};
$512fb3f69d16c13a$var$InvestorListHyperlinkCell.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        investors: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array,
        parent_funding_round: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        event: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }),
    entityProfiles: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    })
};
var $512fb3f69d16c13a$export$2e2bcd8739ae039 = $512fb3f69d16c13a$var$InvestorListHyperlinkCell;









const $0ac481a983581bcc$var$FUNDING_ROUND_MIN_DECIMAL_PLACES = 2;
const $0ac481a983581bcc$var$FUNDING_ROUND_MAX_DECIMAL_PLACES = 4;
const $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
    children: "--"
});
const $0ac481a983581bcc$var$fundingRoundTableColumns = (hasWaterfallDistribution)=>{
    const columns = [
        {
            id: (0, $88e99f4c2bd06374$export$95acb1cff781603c),
            width: 200,
            sticky: true,
            header: "Event",
            accessor: (fundingRound)=>fundingRound,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            badgeMapping: {},
            defaultBadgeStyle: (0, $dfd33cee3229493c$exports.BadgeStyles).MEDIUM_GRAY,
            fundingRoundCellRenderer: (0, $567bc9cc27a3b5c2$export$2e2bcd8739ae039)
        },
        {
            id: "date",
            width: 100,
            header: "Date",
            accessor: (fundingRound)=>fundingRound,
            emptyPlaceholder: $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: ({ value: fundingRound, ...props })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.DateCell), {
                    value: fundingRound.date,
                    ...props
                }),
            dateFormatter: (value)=>{
                const formattedDate = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(value).toLocaleString({
                    month: "short",
                    year: "2-digit"
                });
                const [month, year] = formattedDate.split(" ");
                // Inject the apostrophe to the year.
                return `${month} '${year}`;
            }
        },
        {
            id: "pricePerShare",
            width: 140,
            header: "Price/Share",
            accessor: (fundingRound)=>fundingRound,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
            formatter: (fundingRound)=>fundingRound.price_per_share ? (0, $66339e7a022e68c9$export$365988f95ba9ba73)(fundingRound.price_per_share, $0ac481a983581bcc$var$FUNDING_ROUND_MIN_DECIMAL_PLACES, $0ac481a983581bcc$var$FUNDING_ROUND_MAX_DECIMAL_PLACES) : $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER
        },
        {
            id: "amountRaised",
            width: 160,
            header: "Amount Raised",
            accessor: (fundingRound)=>fundingRound,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
            formatter: (fundingRound)=>fundingRound.amount_raised ? (0, $66339e7a022e68c9$export$736d072c44caa715)(fundingRound.amount_raised, $0ac481a983581bcc$var$FUNDING_ROUND_MIN_DECIMAL_PLACES) : $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER
        },
        {
            id: "postmoneyValuation",
            width: 124,
            header: "Post-val",
            accessor: (fundingRound)=>fundingRound,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
            formatter: (fundingRound)=>fundingRound.postmoney_valuation ? (0, $66339e7a022e68c9$export$736d072c44caa715)(fundingRound.postmoney_valuation, $0ac481a983581bcc$var$FUNDING_ROUND_MIN_DECIMAL_PLACES) : $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER
        },
        {
            id: "investorList",
            width: 124,
            accessor: (fundingRound)=>fundingRound,
            header: "Investor List",
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: (0, $512fb3f69d16c13a$export$2e2bcd8739ae039)
        },
        {
            id: "authorizedShares",
            width: 156,
            header: "Shares Authorized",
            accessor: (fundingRound)=>fundingRound,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
            formatter: (fundingRound)=>fundingRound.authorized_shares ? (0, $67b5297c2a83ffd3$export$2e2bcd8739ae039)(fundingRound.authorized_shares) : $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER
        },
        {
            id: "security",
            width: 188,
            header: "Security",
            accessor: (fundingRound)=>fundingRound,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: ({ value: fundingRound })=>fundingRound.security || $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER
        },
        {
            id: "liquidationMultiple",
            width: 124,
            header: "Multiple",
            accessor: (fundingRound)=>fundingRound,
            cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
            fundingRoundCellRenderer: ({ value: fundingRound })=>fundingRound?.liquidation_display || $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER
        }
    ];
    if (hasWaterfallDistribution) columns.push({
        id: "distributionOrder",
        width: 200,
        header: "Waterfall Distribution",
        accessor: (fundingRound)=>fundingRound,
        cellRenderer: (0, $a8ed2fbb4aba28e0$export$2e2bcd8739ae039),
        fundingRoundCellRenderer: ({ value: fundingRound })=>fundingRound?.liquidation_order_display || $0ac481a983581bcc$var$EMPTY_VALUE_PLACEHOLDER
    });
    return columns;
};
/**
 * A table listing all funding rounds for the given company.
 *
 * @param {object} props
 * @returns {React.Component}
 */ const $0ac481a983581bcc$var$FundingRoundTable = (props)=>{
    const [isShowingMore, setIsShowingMore] = (0, $70fFQ.useState)(false);
    const [company] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const numberOfRows = isShowingMore ? props.fundingRounds.length : (0, $88e99f4c2bd06374$export$c4690fd83b4516d);
    const hasWaterfallDistribution = (0, $70fFQ.useMemo)(()=>{
        const hasValues = (fundingRound)=>fundingRound.liquidation_order_display;
        return props.fundingRounds.some(hasValues);
    }, [
        props.fundingRounds
    ]);
    if (props.fundingRounds.length === 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
        $margin: (0, $88e99f4c2bd06374$export$f6750a376240142c),
        children: "Funding round data not available"
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            tableStyles: (0, $88e99f4c2bd06374$export$80ac8f7dc189db5f)
        },
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                columns: $0ac481a983581bcc$var$fundingRoundTableColumns(hasWaterfallDistribution),
                data: props.fundingRounds.slice(0, numberOfRows),
                entityProfiles: props.entityProfiles
            }),
            props.fundingRounds.length > (0, $88e99f4c2bd06374$export$c4690fd83b4516d) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $29a741c51bfaa3eb$export$52c5708a6fcb91e8), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    onClick: ()=>{
                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickFundingsShowMore(company?.name, (0, $88e99f4c2bd06374$export$e0f98a65ace826d).FUNDING_ROUNDS, !isShowingMore);
                        setIsShowingMore(!isShowingMore);
                    },
                    children: isShowingMore ? "Show fewer" : "Show more"
                })
            })
        ]
    });
};
$0ac481a983581bcc$var$FundingRoundTable.propTypes = {
    entityProfiles: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        [(0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string]: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        })
    }),
    fundingRounds: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object).isRequired
};
$0ac481a983581bcc$var$FundingRoundTable.defaultProps = {
    entityProfiles: {}
};
var $0ac481a983581bcc$export$2e2bcd8739ae039 = $0ac481a983581bcc$var$FundingRoundTable;




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");







const $c4d94f8d3afb1bb9$var$InvestorsTable = ({ entityProfiles: entityProfiles, fundingRounds: fundingRounds })=>{
    const [isShowingMore, setIsShowingMore] = (0, $70fFQ.useState)(false);
    const [company] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const entityProfileTableData = (0, $70fFQ.useMemo)(()=>{
        // For each entity profile, map them to the funding rounds they participated in
        return Object.values((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).mapValues(entityProfiles, (entityProfile)=>({
                investor: entityProfile.name,
                fundingRounds: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter(fundingRounds, (fundingRound)=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).some(fundingRound.investors, (investor)=>investor[1] === entityProfile.apiId)), (fundingRound)=>fundingRound.event))
            }))).sort((0, $dcc04126e8d4465e$export$6e5018d043496eab)).slice(0, isShowingMore ? undefined : (0, $88e99f4c2bd06374$export$c4690fd83b4516d));
    }, [
        entityProfiles,
        fundingRounds,
        isShowingMore
    ]);
    if (entityProfileTableData.length === 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
        $margin: (0, $88e99f4c2bd06374$export$f6750a376240142c),
        children: "Investor data not available"
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            tableStyles: (0, $88e99f4c2bd06374$export$80ac8f7dc189db5f)
        },
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                usePercentageColumnWidths: true,
                columns: [
                    {
                        id: "investorName",
                        header: "Investor",
                        accessor: "investor",
                        width: 50,
                        sortable: true
                    },
                    {
                        id: "fundingRounds",
                        header: "Funding Rounds",
                        accessor: (entity)=>entity,
                        width: 50,
                        sortable: true,
                        cellRenderer: ({ value: entity })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                                children: entity.fundingRounds.map((fundingRound, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                                        children: [
                                            index > 0 && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                                children: " | "
                                            }),
                                            fundingRound
                                        ]
                                    }, index))
                            })
                    }
                ],
                data: entityProfileTableData,
                emptyTablePlaceholder: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme15, {
                    children: "Investor data not available"
                })
            }),
            Object.keys(entityProfiles).length > (0, $88e99f4c2bd06374$export$c4690fd83b4516d) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $29a741c51bfaa3eb$export$52c5708a6fcb91e8), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    onClick: ()=>{
                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickFundingsShowMore(company?.name, (0, $88e99f4c2bd06374$export$e0f98a65ace826d).INVESTORS, !isShowingMore);
                        setIsShowingMore(!isShowingMore);
                    },
                    children: isShowingMore ? "Show fewer" : "Show more"
                })
            })
        ]
    });
};
$c4d94f8d3afb1bb9$var$InvestorsTable.propTypes = {
    entityProfiles: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        apiId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired,
    fundingRounds: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        investors: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array)
    })).isRequired
};
var $c4d94f8d3afb1bb9$export$2e2bcd8739ae039 = $c4d94f8d3afb1bb9$var$InvestorsTable;










const $fb67d70fcb8e8e4f$var$StyledSurfaceZeroCard = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039))`
  min-height: 434px;
`;
const $fb67d70fcb8e8e4f$var$EmptyInfoContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding: 0 16px;
`;
const $fb67d70fcb8e8e4f$var$StyledFundingRoundsHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
`;
const $fb67d70fcb8e8e4f$var$StyledStatsRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 48px;
`;
const $fb67d70fcb8e8e4f$var$StyledTabListContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding-bottom: 24px;
`;
const $fb67d70fcb8e8e4f$var$FundingCard = ()=>{
    const currentTab = (0, $dfd33cee3229493c$exports.useCurrentTab)();
    const [company] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    // Using a hack page size here that a query to the funding rounds/stock split table for a given
    // company will not exceed in practice. There is great difficulty with combining multiple models
    // into 1 resultant queryset + using pagination. This is a hack to get around that.
    const fundingRoundsReq = (0, $f869aac89d4eda76$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).FUNDING_ROUNDS(), {
        company: company?.zb_id,
        "page[size]": 100000
    });
    const stockSplitsReq = (0, $f869aac89d4eda76$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).STOCK_SPLITS(), {
        company: company?.zb_id,
        "page[size]": 100000
    });
    const fundingRounds = (0, $70fFQ.useMemo)(()=>{
        return fundingRoundsReq.isSuccess ? fundingRoundsReq.cleanedData.data : [];
    }, [
        fundingRoundsReq.isSuccess,
        fundingRoundsReq.cleanedData.data
    ]);
    const totalPreferredRounds = (0, $70fFQ.useMemo)(()=>{
        return fundingRounds.filter((round)=>round.security?.toLowerCase().includes("preferred")).length;
    }, [
        fundingRounds
    ]);
    const totalFundingAmount = (0, $70fFQ.useMemo)(()=>fundingRounds.reduce((acc, round)=>acc + Number(round.amount_raised) || 0, 0), [
        fundingRounds
    ]);
    const stockSplits = (0, $70fFQ.useMemo)(()=>stockSplitsReq.isSuccess ? stockSplitsReq.cleanedData.data : [], [
        stockSplitsReq.isSuccess,
        stockSplitsReq.cleanedData.data
    ]);
    const entityProfilesQuery = (0, $f61d99c2f2cef056$export$2e2bcd8739ae039)(fundingRounds);
    const entityProfiles = (0, $70fFQ.useMemo)(()=>entityProfilesQuery.isAnySuccess ? (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).keyBy(entityProfilesQuery?.cleanedData.data || [], "apiId") : {}, [
        entityProfilesQuery.isAnySuccess,
        entityProfilesQuery.cleanedData
    ]);
    const numFundingRounds = fundingRounds ? fundingRounds.length : 0;
    const loading = fundingRoundsReq.isLoading || stockSplitsReq.isLoading;
    let tableContent = null;
    if (loading) tableContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
        absolute: false
    });
    else if (fundingRoundsReq.isError || stockSplitsReq.isError) tableContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($fb67d70fcb8e8e4f$var$EmptyInfoContainer, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a72cb095399be523$export$4ea0ff3663964b59), {
            children: "An error has occurred."
        })
    });
    else {
        const grouped = [];
        let currGroupedFundingRounds = [];
        let currNumFundingRounds = 0;
        let currRoundIndex = 0;
        let currSplitIndex = 0;
        while(currNumFundingRounds < numFundingRounds && currSplitIndex < stockSplits.length){
            const currRound = fundingRounds[currRoundIndex];
            const currSplit = stockSplits[currSplitIndex];
            if (currRound.order > currSplit.order) {
                // part of the funding round table
                currGroupedFundingRounds.push(currRound);
                currRoundIndex += 1;
                currNumFundingRounds += 1;
            } else {
                // break up the funding round table and insert a row for the stock split
                grouped.push(currGroupedFundingRounds);
                grouped.push(currSplit);
                currGroupedFundingRounds = [];
                currSplitIndex += 1;
            }
        }
        if (currNumFundingRounds === numFundingRounds) // at the end, attach the last batch of included funding rounds
        {
            if (currGroupedFundingRounds.length > 0) grouped.push(currGroupedFundingRounds);
        } else if (currNumFundingRounds < numFundingRounds) {
            const numNeeded = numFundingRounds - currNumFundingRounds;
            grouped.push(fundingRounds.slice(currRoundIndex, currRoundIndex + numNeeded));
        }
        const nextSplit = stockSplits[currSplitIndex];
        if (nextSplit) grouped.push(nextSplit);
        tableContent = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $0ac481a983581bcc$export$2e2bcd8739ae039), {
            entityProfiles: entityProfiles,
            fundingRounds: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).flatten(grouped)
        });
    }
    const tabContent = (0, $70fFQ.useMemo)(()=>{
        switch(currentTab){
            case (0, $88e99f4c2bd06374$export$e0f98a65ace826d).FUNDING_ROUNDS:
                return tableContent;
            case (0, $88e99f4c2bd06374$export$e0f98a65ace826d).INVESTORS:
                return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4d94f8d3afb1bb9$export$2e2bcd8739ae039), {
                    entityProfiles: entityProfiles,
                    fundingRounds: fundingRounds
                });
            case (0, $88e99f4c2bd06374$export$e0f98a65ace826d).COIS:
                return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5a0e06fdaa979949$export$2e2bcd8739ae039), {});
            default:
                return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                    children: "An error has occurred."
                });
        }
    }, [
        currentTab,
        tableContent,
        entityProfiles,
        fundingRounds
    ]);
    const onClickTab = (name)=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickFundingsTab(company?.name, name);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($fb67d70fcb8e8e4f$var$StyledSurfaceZeroCard, {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).PADDED,
        title: "Funding",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($fb67d70fcb8e8e4f$var$StyledFundingRoundsHeader, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($fb67d70fcb8e8e4f$var$StyledStatsRow, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $85efa06bc75c673b$export$2e2bcd8739ae039), {
                                mainStatistic: (0, $66339e7a022e68c9$export$736d072c44caa715)(totalFundingAmount),
                                supportingText: "Total funding amount"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $85efa06bc75c673b$export$2e2bcd8739ae039), {
                                mainStatistic: totalPreferredRounds,
                                supportingText: "Funding rounds"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $85efa06bc75c673b$export$2e2bcd8739ae039), {
                                mainStatistic: entityProfilesQuery.isLoading ? "Loading" : Object.keys(entityProfiles).length,
                                supportingText: "Investors"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30, {
                        children: "Data is collected from state filings and publicly available sources, and may be incomplete."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($fb67d70fcb8e8e4f$var$StyledTabListContainer, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.TabList), {
                    tabs: [
                        {
                            label: (0, $88e99f4c2bd06374$export$e0f98a65ace826d).FUNDING_ROUNDS
                        },
                        {
                            label: (0, $88e99f4c2bd06374$export$e0f98a65ace826d).INVESTORS
                        },
                        {
                            label: (0, $88e99f4c2bd06374$export$e0f98a65ace826d).COIS
                        }
                    ],
                    defaultTab: (0, $88e99f4c2bd06374$export$e0f98a65ace826d).FUNDING_ROUNDS,
                    onTabChange: onClickTab
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                children: tabContent
            })
        ]
    });
};
var $fb67d70fcb8e8e4f$export$2e2bcd8739ae039 = $fb67d70fcb8e8e4f$var$FundingCard;


var $d0963f91212dde52$export$2e2bcd8739ae039 = (0, $fb67d70fcb8e8e4f$export$2e2bcd8739ae039);




var $70fFQ = parcelRequire("70fFQ");




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");





var $70fFQ = parcelRequire("70fFQ");
const $385bab7661b44b18$var$StyledArticleImage = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(props)=>props.$background ? (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          background-image: url(${(props)=>props.$background});
          background-size: cover;
          background-position: center;
        ` : (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface2};
        `}
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -16px;
  width: 100%;
  height: 100px;
`;
const $385bab7661b44b18$var$StyledCardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`;
const $385bab7661b44b18$var$StyledCard = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Card))`
  height: 100%;
`;
const $385bab7661b44b18$var$StyledMissingThumbnail = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
const $385bab7661b44b18$var$MissingThumbnailIconContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white10};
  border-radius: 50%;
  width: 40px;
  height: 40px;
`;
const $385bab7661b44b18$var$MentionArticleTitle = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80).attrs({
    as: "p"
})``;
const $385bab7661b44b18$var$THREE_LINE_HEIGHT = 72;
const $385bab7661b44b18$var$MentionArticleCard = ({ article: article, onClick: onClick })=>{
    const cardRef = (0, $70fFQ.useRef)(null);
    const [textRef, current] = (0, $4e12efec6f3d63a0$export$2e2bcd8739ae039)();
    const tooltipContent = (0, $70fFQ.useMemo)(()=>{
        if (current?.scrollHeight > $385bab7661b44b18$var$THREE_LINE_HEIGHT) return article.title;
        return null;
    }, [
        article.title,
        current
    ]);
    const tooltip = (0, $dfd33cee3229493c$exports.useTooltip)(cardRef, tooltipContent);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.HyperLink), {
        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).UNSTYLED,
        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
        url: article.original_url,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($385bab7661b44b18$var$StyledCard, {
                ref: cardRef,
                cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).MINIMAL,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($385bab7661b44b18$var$StyledArticleImage, {
                        $background: article.mention_image || article.mention_image_original_url,
                        children: article.mention_image || article.mention_image_original_url ? null : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($385bab7661b44b18$var$StyledMissingThumbnail, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($385bab7661b44b18$var$MissingThumbnailIconContainer, {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ImageIcon), {
                                        color: (0, $dfd33cee3229493c$exports.ColorPalette).white30,
                                        size: 16
                                    })
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                    children: "Thumbnail not available"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($385bab7661b44b18$var$StyledCardContent, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: [
                                    article.mention_source_name,
                                    " | ",
                                    (0, $86d2f3987cc9d604$exports.DateTime).fromISO(article.published_at).toRelative()
                                ]
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$e3829a99457e34ea), {
                                ref: textRef,
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($385bab7661b44b18$var$MentionArticleTitle, {
                                    children: article.title
                                })
                            })
                        ]
                    })
                ]
            }),
            tooltip
        ]
    });
};
$385bab7661b44b18$var$MentionArticleCard.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    article: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        published_at: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        original_url: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        mention_source_name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        mention_image: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        mention_image_original_url: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired
};
$385bab7661b44b18$var$MentionArticleCard.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
};
var $385bab7661b44b18$export$2e2bcd8739ae039 = $385bab7661b44b18$var$MentionArticleCard;









const $a322506e0b6f743d$var$CardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $a322506e0b6f743d$var$StyledDisclaimer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30)`
  align-self: flex-end;
  > :first-child {
    ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  }
`;
const $a322506e0b6f743d$var$CompanyNewsCard = ()=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const companyArticleQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_ARTICLES(company?.zb_id), {}, {
        enabled: Boolean(company.zb_id)
    });
    const companyArticles = (0, $70fFQ.useMemo)(()=>{
        if (!companyArticleQuery.isSuccess) return null;
        return companyArticleQuery?.cleanedData?.data ?? null;
    }, [
        companyArticleQuery
    ]);
    if (companyIsLoading || companyArticleQuery.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: `News about ${company?.name}`,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 48,
            children: "Loading news..."
        })
    });
    if (companyArticles === null || companyArticles.length === 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: `News about ${company?.name}`,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
            $margin: 48,
            children: "News not available"
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: `News about ${company?.name}`,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a322506e0b6f743d$var$CardContent, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $003dc761c92dedde$export$144901db2ea8e967), {
                    slidesToScroll: 2,
                    onScrollNext: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollCompanyNewsCarousel("next", company?.name),
                    onScrollPrev: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollCompanyNewsCarousel("prev", company?.name),
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$c1bff280f3570f68), {
                            children: companyArticles.map((article, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$42c20acb2971398c), {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $385bab7661b44b18$export$2e2bcd8739ae039), {
                                        onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openCompanyNewsArticle(company?.name, article.original_url),
                                        article: article
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$68f1b3e785b3c668), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$434129336ddede1b), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$75fd771fe00f2b45), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a322506e0b6f743d$var$StyledDisclaimer, {
                    children: [
                        "Convenience links for news & press releases are powered by",
                        " ",
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                            linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                            linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).INVISIBLE,
                            url: "https://mention.com/en/",
                            onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateToMentionDotCom("company news", company?.name),
                            children: "Mention"
                        })
                    ]
                })
            ]
        })
    });
};
var $a322506e0b6f743d$export$2e2bcd8739ae039 = $a322506e0b6f743d$var$CompanyNewsCard;




var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");

var $70fFQ = parcelRequire("70fFQ");





function $2e5a4ca8ae099b29$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2e5a4ca8ae099b29$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2e5a4ca8ae099b29$var$_typeof(o);
}
function $2e5a4ca8ae099b29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e5a4ca8ae099b29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e5a4ca8ae099b29$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2e5a4ca8ae099b29$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e5a4ca8ae099b29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e5a4ca8ae099b29$var$_defineProperty(obj, key, value) {
    key = $2e5a4ca8ae099b29$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2e5a4ca8ae099b29$var$_toPropertyKey(t) {
    var i = $2e5a4ca8ae099b29$var$_toPrimitive(t, "string");
    return "symbol" == $2e5a4ca8ae099b29$var$_typeof(i) ? i : String(i);
}
function $2e5a4ca8ae099b29$var$_toPrimitive(t, r) {
    if ("object" != $2e5a4ca8ae099b29$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2e5a4ca8ae099b29$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2e5a4ca8ae099b29$var$_slicedToArray(arr, i) {
    return $2e5a4ca8ae099b29$var$_arrayWithHoles(arr) || $2e5a4ca8ae099b29$var$_iterableToArrayLimit(arr, i) || $2e5a4ca8ae099b29$var$_unsupportedIterableToArray(arr, i) || $2e5a4ca8ae099b29$var$_nonIterableRest();
}
function $2e5a4ca8ae099b29$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2e5a4ca8ae099b29$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2e5a4ca8ae099b29$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2e5a4ca8ae099b29$var$_arrayLikeToArray(o, minLen);
}
function $2e5a4ca8ae099b29$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2e5a4ca8ae099b29$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2e5a4ca8ae099b29$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2e5a4ca8ae099b29$export$e60a4704009a0009 = /*#__PURE__*/ (0, $70fFQ.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $70fFQ.useRef)(null);
    var onResizeRef = (0, $70fFQ.useRef)();
    onResizeRef.current = onResize;
    (0, $70fFQ.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $70fFQ.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $2e5a4ca8ae099b29$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $70fFQ.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $70fFQ.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($2003fcc117392f52$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $70fFQ.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $425eb72df2965775$export$c106dd0671a0fc2d)((0, $453b3059df48aedd$export$e50269385c77c348)(width) || (0, $453b3059df48aedd$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $425eb72df2965775$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $453b3059df48aedd$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $453b3059df48aedd$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $425eb72df2965775$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $3bb4b056bcc3c4d9$exports.isElement)(children) && (0, $a56fb3d503224b01$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.map(children, function(child) {
            if ((0, $3bb4b056bcc3c4d9$exports.isElement)(child)) return /*#__PURE__*/ (0, $70fFQ.cloneElement)(child, $2e5a4ca8ae099b29$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $2e5a4ca8ae099b29$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $axMmP.default)('recharts-responsive-container', className),
        style: $2e5a4ca8ae099b29$var$_objectSpread($2e5a4ca8ae099b29$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});


var $70fFQ = parcelRequire("70fFQ");



var $8fab083a396980e2$exports = {};

var $6941b8119d78cbba$exports = {};
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $6941b8119d78cbba$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
$6941b8119d78cbba$exports = $6941b8119d78cbba$var$baseSum;


/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $8fab083a396980e2$var$sumBy(array, iteratee) {
    return array && array.length ? $6941b8119d78cbba$exports(array, $1316a39af77ac4e6$exports(iteratee, 2)) : 0;
}
$8fab083a396980e2$exports = $8fab083a396980e2$var$sumBy;




var $axMmP = parcelRequire("axMmP");







var $04b7bfe8c4fdc12f$var$_excluded = [
    "width",
    "height",
    "className",
    "style",
    "children"
], $04b7bfe8c4fdc12f$var$_excluded2 = [
    "sourceX",
    "sourceY",
    "sourceControlX",
    "targetX",
    "targetY",
    "targetControlX",
    "linkWidth"
];
function $04b7bfe8c4fdc12f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $04b7bfe8c4fdc12f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $04b7bfe8c4fdc12f$var$_typeof(o);
}
function $04b7bfe8c4fdc12f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $04b7bfe8c4fdc12f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $04b7bfe8c4fdc12f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $04b7bfe8c4fdc12f$var$_extends() {
    $04b7bfe8c4fdc12f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04b7bfe8c4fdc12f$var$_extends.apply(this, arguments);
}
function $04b7bfe8c4fdc12f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $04b7bfe8c4fdc12f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $04b7bfe8c4fdc12f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $04b7bfe8c4fdc12f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $04b7bfe8c4fdc12f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $04b7bfe8c4fdc12f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $04b7bfe8c4fdc12f$var$_callSuper(t, o, e) {
    return o = $04b7bfe8c4fdc12f$var$_getPrototypeOf(o), $04b7bfe8c4fdc12f$var$_possibleConstructorReturn(t, $04b7bfe8c4fdc12f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $04b7bfe8c4fdc12f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $04b7bfe8c4fdc12f$var$_possibleConstructorReturn(self, call) {
    if (call && ($04b7bfe8c4fdc12f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $04b7bfe8c4fdc12f$var$_assertThisInitialized(self);
}
function $04b7bfe8c4fdc12f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($04b7bfe8c4fdc12f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $04b7bfe8c4fdc12f$var$_getPrototypeOf(o) {
    $04b7bfe8c4fdc12f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $04b7bfe8c4fdc12f$var$_getPrototypeOf(o);
}
function $04b7bfe8c4fdc12f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $04b7bfe8c4fdc12f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $04b7bfe8c4fdc12f$var$_setPrototypeOf(subClass, superClass);
}
function $04b7bfe8c4fdc12f$var$_setPrototypeOf(o, p) {
    $04b7bfe8c4fdc12f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $04b7bfe8c4fdc12f$var$_setPrototypeOf(o, p);
}
function $04b7bfe8c4fdc12f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04b7bfe8c4fdc12f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04b7bfe8c4fdc12f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $04b7bfe8c4fdc12f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04b7bfe8c4fdc12f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $04b7bfe8c4fdc12f$var$_defineProperty(obj, key, value) {
    key = $04b7bfe8c4fdc12f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $04b7bfe8c4fdc12f$var$_toPropertyKey(t) {
    var i = $04b7bfe8c4fdc12f$var$_toPrimitive(t, "string");
    return "symbol" == $04b7bfe8c4fdc12f$var$_typeof(i) ? i : String(i);
}
function $04b7bfe8c4fdc12f$var$_toPrimitive(t, r) {
    if ("object" != $04b7bfe8c4fdc12f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $04b7bfe8c4fdc12f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $04b7bfe8c4fdc12f$var$defaultCoordinateOfTooltip = {
    x: 0,
    y: 0
};
var $04b7bfe8c4fdc12f$var$interpolationGenerator = function interpolationGenerator(a, b) {
    var ka = +a;
    var kb = b - ka;
    return function(t) {
        return ka + kb * t;
    };
};
var $04b7bfe8c4fdc12f$var$centerY = function centerY(node) {
    return node.y + node.dy / 2;
};
var $04b7bfe8c4fdc12f$var$getValue = function getValue(entry) {
    return entry && entry.value || 0;
};
var $04b7bfe8c4fdc12f$var$getSumOfIds = function getSumOfIds(links, ids) {
    return ids.reduce(function(result, id) {
        return result + $04b7bfe8c4fdc12f$var$getValue(links[id]);
    }, 0);
};
var $04b7bfe8c4fdc12f$var$getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
    return ids.reduce(function(result, id) {
        var link = links[id];
        var sourceNode = tree[link.source];
        return result + $04b7bfe8c4fdc12f$var$centerY(sourceNode) * $04b7bfe8c4fdc12f$var$getValue(links[id]);
    }, 0);
};
var $04b7bfe8c4fdc12f$var$getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
    return ids.reduce(function(result, id) {
        var link = links[id];
        var targetNode = tree[link.target];
        return result + $04b7bfe8c4fdc12f$var$centerY(targetNode) * $04b7bfe8c4fdc12f$var$getValue(links[id]);
    }, 0);
};
var $04b7bfe8c4fdc12f$var$ascendingY = function ascendingY(a, b) {
    return a.y - b.y;
};
var $04b7bfe8c4fdc12f$var$searchTargetsAndSources = function searchTargetsAndSources(links, id) {
    var sourceNodes = [];
    var sourceLinks = [];
    var targetNodes = [];
    var targetLinks = [];
    for(var i = 0, len = links.length; i < len; i++){
        var link = links[i];
        if (link.source === id) {
            targetNodes.push(link.target);
            targetLinks.push(i);
        }
        if (link.target === id) {
            sourceNodes.push(link.source);
            sourceLinks.push(i);
        }
    }
    return {
        sourceNodes: sourceNodes,
        sourceLinks: sourceLinks,
        targetLinks: targetLinks,
        targetNodes: targetNodes
    };
};
var $04b7bfe8c4fdc12f$var$updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
    var targetNodes = curNode.targetNodes;
    for(var i = 0, len = targetNodes.length; i < len; i++){
        var target = tree[targetNodes[i]];
        if (target) {
            target.depth = Math.max(curNode.depth + 1, target.depth);
            updateDepthOfTargets(tree, target);
        }
    }
};
var $04b7bfe8c4fdc12f$var$getNodesTree = function getNodesTree(_ref, width, nodeWidth, allowFloatingTerminalNodes) {
    var nodes = _ref.nodes, links = _ref.links;
    var tree = nodes.map(function(entry, index) {
        var result = $04b7bfe8c4fdc12f$var$searchTargetsAndSources(links, index);
        return $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, entry), result), {}, {
            value: Math.max($04b7bfe8c4fdc12f$var$getSumOfIds(links, result.sourceLinks), $04b7bfe8c4fdc12f$var$getSumOfIds(links, result.targetLinks)),
            depth: 0
        });
    });
    for(var i = 0, len = tree.length; i < len; i++){
        var node = tree[i];
        if (!node.sourceNodes.length) $04b7bfe8c4fdc12f$var$updateDepthOfTargets(tree, node);
    }
    var maxDepth = (0, (/*@__PURE__*/$parcel$interopDefault($19af5f1d1bb3415a$exports)))(tree, function(entry) {
        return entry.depth;
    }).depth;
    if (maxDepth >= 1) {
        var childWidth = (width - nodeWidth) / maxDepth;
        for(var _i = 0, _len = tree.length; _i < _len; _i++){
            var _node = tree[_i];
            if (!_node.targetNodes.length && !allowFloatingTerminalNodes) _node.depth = maxDepth;
            _node.x = _node.depth * childWidth;
            _node.dx = nodeWidth;
        }
    }
    return {
        tree: tree,
        maxDepth: maxDepth
    };
};
var $04b7bfe8c4fdc12f$var$getDepthTree = function getDepthTree(tree) {
    var result = [];
    for(var i = 0, len = tree.length; i < len; i++){
        var node = tree[i];
        if (!result[node.depth]) result[node.depth] = [];
        result[node.depth].push(node);
    }
    return result;
};
var $04b7bfe8c4fdc12f$var$updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
    var yRatio = (0, (/*@__PURE__*/$parcel$interopDefault($5faa772a70839d2c$exports)))(depthTree.map(function(nodes) {
        return (height - (nodes.length - 1) * nodePadding) / (0, (/*@__PURE__*/$parcel$interopDefault($8fab083a396980e2$exports)))(nodes, $04b7bfe8c4fdc12f$var$getValue);
    }));
    for(var d = 0, maxDepth = depthTree.length; d < maxDepth; d++)for(var i = 0, len = depthTree[d].length; i < len; i++){
        var node = depthTree[d][i];
        node.y = i;
        node.dy = node.value * yRatio;
    }
    return links.map(function(link) {
        return $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, link), {}, {
            dy: $04b7bfe8c4fdc12f$var$getValue(link) * yRatio
        });
    });
};
var $04b7bfe8c4fdc12f$var$resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    for(var i = 0, len = depthTree.length; i < len; i++){
        var nodes = depthTree[i];
        var n = nodes.length;
        // Sort by the value of y
        if (sort) nodes.sort($04b7bfe8c4fdc12f$var$ascendingY);
        var y0 = 0;
        for(var j = 0; j < n; j++){
            var node = nodes[j];
            var dy = y0 - node.y;
            if (dy > 0) node.y += dy;
            y0 = node.y + node.dy + nodePadding;
        }
        y0 = height + nodePadding;
        for(var _j = n - 1; _j >= 0; _j--){
            var _node2 = nodes[_j];
            var _dy = _node2.y + _node2.dy + nodePadding - y0;
            if (_dy > 0) {
                _node2.y -= _dy;
                y0 = _node2.y;
            } else break;
        }
    }
};
var $04b7bfe8c4fdc12f$var$relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
    for(var i = 0, maxDepth = depthTree.length; i < maxDepth; i++){
        var nodes = depthTree[i];
        for(var j = 0, len = nodes.length; j < len; j++){
            var node = nodes[j];
            if (node.sourceLinks.length) {
                var sourceSum = $04b7bfe8c4fdc12f$var$getSumOfIds(links, node.sourceLinks);
                var weightedSum = $04b7bfe8c4fdc12f$var$getSumWithWeightedSource(tree, links, node.sourceLinks);
                var y = weightedSum / sourceSum;
                node.y += (y - $04b7bfe8c4fdc12f$var$centerY(node)) * alpha;
            }
        }
    }
};
var $04b7bfe8c4fdc12f$var$relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
    for(var i = depthTree.length - 1; i >= 0; i--){
        var nodes = depthTree[i];
        for(var j = 0, len = nodes.length; j < len; j++){
            var node = nodes[j];
            if (node.targetLinks.length) {
                var targetSum = $04b7bfe8c4fdc12f$var$getSumOfIds(links, node.targetLinks);
                var weightedSum = $04b7bfe8c4fdc12f$var$getSumWithWeightedTarget(tree, links, node.targetLinks);
                var y = weightedSum / targetSum;
                node.y += (y - $04b7bfe8c4fdc12f$var$centerY(node)) * alpha;
            }
        }
    }
};
var $04b7bfe8c4fdc12f$var$updateYOfLinks = function updateYOfLinks(tree, links) {
    for(var i = 0, len = tree.length; i < len; i++){
        var node = tree[i];
        var sy = 0;
        var ty = 0;
        node.targetLinks.sort(function(a, b) {
            return tree[links[a].target].y - tree[links[b].target].y;
        });
        node.sourceLinks.sort(function(a, b) {
            return tree[links[a].source].y - tree[links[b].source].y;
        });
        for(var j = 0, tLen = node.targetLinks.length; j < tLen; j++){
            var link = links[node.targetLinks[j]];
            if (link) {
                link.sy = sy;
                sy += link.dy;
            }
        }
        for(var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++){
            var _link = links[node.sourceLinks[_j2]];
            if (_link) {
                _link.ty = ty;
                ty += _link.dy;
            }
        }
    }
};
var $04b7bfe8c4fdc12f$var$computeData = function computeData(_ref2) {
    var data = _ref2.data, width = _ref2.width, height = _ref2.height, iterations = _ref2.iterations, nodeWidth = _ref2.nodeWidth, nodePadding = _ref2.nodePadding, sort = _ref2.sort, allowFloatingTerminalNodes = _ref2.allowFloatingTerminalNodes;
    var links = data.links;
    var _getNodesTree = $04b7bfe8c4fdc12f$var$getNodesTree(data, width, nodeWidth, allowFloatingTerminalNodes), tree = _getNodesTree.tree;
    var depthTree = $04b7bfe8c4fdc12f$var$getDepthTree(tree);
    var newLinks = $04b7bfe8c4fdc12f$var$updateYOfTree(depthTree, height, nodePadding, links);
    $04b7bfe8c4fdc12f$var$resolveCollisions(depthTree, height, nodePadding, sort);
    var alpha = 1;
    for(var i = 1; i <= iterations; i++){
        $04b7bfe8c4fdc12f$var$relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
        $04b7bfe8c4fdc12f$var$resolveCollisions(depthTree, height, nodePadding, sort);
        $04b7bfe8c4fdc12f$var$relaxLeftToRight(tree, depthTree, newLinks, alpha);
        $04b7bfe8c4fdc12f$var$resolveCollisions(depthTree, height, nodePadding, sort);
    }
    $04b7bfe8c4fdc12f$var$updateYOfLinks(tree, newLinks);
    return {
        nodes: tree,
        links: newLinks
    };
};
var $04b7bfe8c4fdc12f$var$getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
    if (type === 'node') return {
        x: el.x + el.width / 2,
        y: el.y + el.height / 2
    };
    return {
        x: (el.sourceX + el.targetX) / 2,
        y: (el.sourceY + el.targetY) / 2
    };
};
var $04b7bfe8c4fdc12f$var$getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
    var payload = el.payload;
    if (type === 'node') return [
        {
            payload: el,
            name: (0, $cdef3b11746f8934$export$f97fc4a450f29a)(payload, nameKey, ''),
            value: (0, $cdef3b11746f8934$export$f97fc4a450f29a)(payload, 'value')
        }
    ];
    if (payload.source && payload.target) {
        var sourceName = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(payload.source, nameKey, '');
        var targetName = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(payload.target, nameKey, '');
        return [
            {
                payload: el,
                name: "".concat(sourceName, " - ").concat(targetName),
                value: (0, $cdef3b11746f8934$export$f97fc4a450f29a)(payload, 'value')
            }
        ];
    }
    return [];
};
var $04b7bfe8c4fdc12f$export$c6543aa9da37a94e = /*#__PURE__*/ function(_PureComponent) {
    $04b7bfe8c4fdc12f$var$_inherits(Sankey, _PureComponent);
    function Sankey() {
        var _this;
        $04b7bfe8c4fdc12f$var$_classCallCheck(this, Sankey);
        for(var _len2 = arguments.length, args = new Array(_len2), _key = 0; _key < _len2; _key++)args[_key] = arguments[_key];
        _this = $04b7bfe8c4fdc12f$var$_callSuper(this, Sankey, [].concat(args));
        $04b7bfe8c4fdc12f$var$_defineProperty($04b7bfe8c4fdc12f$var$_assertThisInitialized(_this), "state", {
            activeElement: null,
            activeElementType: null,
            isTooltipActive: false,
            nodes: [],
            links: []
        });
        return _this;
    }
    $04b7bfe8c4fdc12f$var$_createClass(Sankey, [
        {
            key: "handleMouseEnter",
            value: function handleMouseEnter(el, type, e) {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, children = _this$props.children;
                var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                if (tooltipItem) this.setState(function(prev) {
                    if (tooltipItem.props.trigger === 'hover') return $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, prev), {}, {
                        activeElement: el,
                        activeElementType: type,
                        isTooltipActive: true
                    });
                    return prev;
                }, function() {
                    if (onMouseEnter) onMouseEnter(el, type, e);
                });
                else if (onMouseEnter) onMouseEnter(el, type, e);
            }
        },
        {
            key: "handleMouseLeave",
            value: function handleMouseLeave(el, type, e) {
                var _this$props2 = this.props, onMouseLeave = _this$props2.onMouseLeave, children = _this$props2.children;
                var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                if (tooltipItem) this.setState(function(prev) {
                    if (tooltipItem.props.trigger === 'hover') return $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, prev), {}, {
                        activeElement: undefined,
                        activeElementType: undefined,
                        isTooltipActive: false
                    });
                    return prev;
                }, function() {
                    if (onMouseLeave) onMouseLeave(el, type, e);
                });
                else if (onMouseLeave) onMouseLeave(el, type, e);
            }
        },
        {
            key: "handleClick",
            value: function handleClick(el, type, e) {
                var _this$props3 = this.props, onClick = _this$props3.onClick, children = _this$props3.children;
                var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                if (tooltipItem && tooltipItem.props.trigger === 'click') {
                    if (this.state.isTooltipActive) this.setState(function(prev) {
                        return $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, prev), {}, {
                            activeElement: undefined,
                            activeElementType: undefined,
                            isTooltipActive: false
                        });
                    });
                    else this.setState(function(prev) {
                        return $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, prev), {}, {
                            activeElement: el,
                            activeElementType: type,
                            isTooltipActive: true
                        });
                    });
                }
                if (onClick) onClick(el, type, e);
            }
        },
        {
            key: "renderLinks",
            value: function renderLinks(links, nodes) {
                var _this2 = this;
                var _this$props4 = this.props, linkCurvature = _this$props4.linkCurvature, linkContent = _this$props4.link, margin = _this$props4.margin;
                var top = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(margin, 'top') || 0;
                var left = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(margin, 'left') || 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-sankey-links",
                    key: "recharts-sankey-links"
                }, links.map(function(link, i) {
                    var sourceRelativeY = link.sy, targetRelativeY = link.ty, linkWidth = link.dy;
                    var source = nodes[link.source];
                    var target = nodes[link.target];
                    var sourceX = source.x + source.dx + left;
                    var targetX = target.x + left;
                    var interpolationFunc = $04b7bfe8c4fdc12f$var$interpolationGenerator(sourceX, targetX);
                    var sourceControlX = interpolationFunc(linkCurvature);
                    var targetControlX = interpolationFunc(1 - linkCurvature);
                    var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
                    var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
                    var linkProps = $04b7bfe8c4fdc12f$var$_objectSpread({
                        sourceX: sourceX,
                        targetX: targetX,
                        sourceY: sourceY,
                        targetY: targetY,
                        sourceControlX: sourceControlX,
                        targetControlX: targetControlX,
                        sourceRelativeY: sourceRelativeY,
                        targetRelativeY: targetRelativeY,
                        linkWidth: linkWidth,
                        index: i,
                        payload: $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, link), {}, {
                            source: source,
                            target: target
                        })
                    }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(linkContent, false));
                    var events = {
                        onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
                        onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
                        onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $04b7bfe8c4fdc12f$var$_extends({
                        key: "link-".concat(link.source, "-").concat(link.target, "-").concat(link.value)
                    }, events), _this2.constructor.renderLinkItem(linkContent, linkProps));
                }));
            }
        },
        {
            key: "renderNodes",
            value: function renderNodes(nodes) {
                var _this3 = this;
                var _this$props5 = this.props, nodeContent = _this$props5.node, margin = _this$props5.margin;
                var top = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(margin, 'top') || 0;
                var left = (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(margin, 'left') || 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-sankey-nodes",
                    key: "recharts-sankey-nodes"
                }, nodes.map(function(node, i) {
                    var x = node.x, y = node.y, dx = node.dx, dy = node.dy;
                    var nodeProps = $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(nodeContent, false)), {}, {
                        x: x + left,
                        y: y + top,
                        width: dx,
                        height: dy,
                        index: i,
                        payload: node
                    });
                    var events = {
                        onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
                        onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
                        onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $04b7bfe8c4fdc12f$var$_extends({
                        key: "node-".concat(node.x, "-").concat(node.y, "-").concat(node.value)
                    }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps));
                }));
            }
        },
        {
            key: "renderTooltip",
            value: function renderTooltip() {
                var _this$props6 = this.props, children = _this$props6.children, width = _this$props6.width, height = _this$props6.height, nameKey = _this$props6.nameKey;
                var tooltipItem = (0, $a56fb3d503224b01$export$64c61536a2b72e0f)(children, (0, $9c6bfe96f56d0a02$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state = this.state, isTooltipActive = _this$state.isTooltipActive, activeElement = _this$state.activeElement, activeElementType = _this$state.activeElementType;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                };
                var coordinate = activeElement ? $04b7bfe8c4fdc12f$var$getCoordinateOfTooltip(activeElement, activeElementType) : $04b7bfe8c4fdc12f$var$defaultCoordinateOfTooltip;
                var payload = activeElement ? $04b7bfe8c4fdc12f$var$getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(tooltipItem, {
                    viewBox: viewBox,
                    active: isTooltipActive,
                    coordinate: coordinate,
                    label: '',
                    payload: payload
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (!(0, $a56fb3d503224b01$export$5301de6bfd3cfa2a)(this)) return null;
                var _this$props7 = this.props, width = _this$props7.width, height = _this$props7.height, className = _this$props7.className, style = _this$props7.style, children = _this$props7.children, others = $04b7bfe8c4fdc12f$var$_objectWithoutProperties(_this$props7, $04b7bfe8c4fdc12f$var$_excluded);
                var _this$state2 = this.state, links = _this$state2.links, nodes = _this$state2.nodes;
                var attrs = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, false);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("div", {
                    className: (0, $axMmP.default)('recharts-wrapper', className),
                    style: $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, style), {}, {
                        position: 'relative',
                        cursor: 'default',
                        width: width,
                        height: height
                    }),
                    role: "region"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $abed49cce9ec42fc$export$7b92b459e668cb21), $04b7bfe8c4fdc12f$var$_extends({}, attrs, {
                    width: width,
                    height: height
                }), (0, $a56fb3d503224b01$export$ef6f3b46dcb37b3f)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, height = nextProps.height, margin = nextProps.margin, iterations = nextProps.iterations, nodeWidth = nextProps.nodeWidth, nodePadding = nextProps.nodePadding, sort = nextProps.sort, allowFloatingTerminalNodes = nextProps.allowFloatingTerminalNodes;
                if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || !(0, $924d4aaaa598a456$export$d36bdfa510afb180)(margin, prevState.prevMargin) || iterations !== prevState.prevIterations || nodeWidth !== prevState.prevNodeWidth || nodePadding !== prevState.prevNodePadding || sort !== prevState.sort) {
                    var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
                    var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
                    var _computeData = $04b7bfe8c4fdc12f$var$computeData({
                        data: data,
                        width: contentWidth,
                        height: contentHeight,
                        iterations: iterations,
                        nodeWidth: nodeWidth,
                        nodePadding: nodePadding,
                        sort: sort,
                        allowFloatingTerminalNodes: allowFloatingTerminalNodes
                    }), links = _computeData.links, nodes = _computeData.nodes;
                    return $04b7bfe8c4fdc12f$var$_objectSpread($04b7bfe8c4fdc12f$var$_objectSpread({}, prevState), {}, {
                        nodes: nodes,
                        links: links,
                        prevData: data,
                        prevWidth: iterations,
                        prevHeight: height,
                        prevMargin: margin,
                        prevNodePadding: nodePadding,
                        prevNodeWidth: nodeWidth,
                        prevIterations: iterations,
                        prevSort: sort
                    });
                }
                return null;
            }
        },
        {
            key: "renderLinkItem",
            value: function renderLinkItem(option, props) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) return option(props);
                var sourceX = props.sourceX, sourceY = props.sourceY, sourceControlX = props.sourceControlX, targetX = props.targetX, targetY = props.targetY, targetControlX = props.targetControlX, linkWidth = props.linkWidth, others = $04b7bfe8c4fdc12f$var$_objectWithoutProperties(props, $04b7bfe8c4fdc12f$var$_excluded2);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("path", $04b7bfe8c4fdc12f$var$_extends({
                    className: "recharts-sankey-link",
                    d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
                    fill: "none",
                    stroke: "#333",
                    strokeWidth: linkWidth,
                    strokeOpacity: "0.2"
                }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, false)));
            }
        },
        {
            key: "renderNodeItem",
            value: function renderNodeItem(option, props) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) return option(props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $c0f721a3b6bafaa4$export$4617fb02663045ef), $04b7bfe8c4fdc12f$var$_extends({
                    className: "recharts-sankey-node",
                    fill: "#0088fe",
                    fillOpacity: "0.8"
                }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(props, false), {
                    role: "img"
                }));
            }
        }
    ]);
    return Sankey;
}((0, $70fFQ.PureComponent));
$04b7bfe8c4fdc12f$var$_defineProperty($04b7bfe8c4fdc12f$export$c6543aa9da37a94e, "displayName", 'Sankey');
$04b7bfe8c4fdc12f$var$_defineProperty($04b7bfe8c4fdc12f$export$c6543aa9da37a94e, "defaultProps", {
    nameKey: 'name',
    dataKey: 'value',
    nodePadding: 10,
    nodeWidth: 10,
    linkCurvature: 0.5,
    iterations: 32,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    sort: true
});









var $cd0Jr = parcelRequire("cd0Jr");

const $29c714bbf94e67c5$export$49cb64643f8069b3 = "Direct (Approved)";
const $29c714bbf94e67c5$export$6ae3be16c5e9de4b = "Direct (ROFR'd)";
const $29c714bbf94e67c5$export$c6aa9d861bfe48b5 = "SPV";
const $29c714bbf94e67c5$export$cce8a4f293cf0ee2 = "Forward";
const $29c714bbf94e67c5$export$f367739dcc25743f = "Unknown Security";
const $29c714bbf94e67c5$export$9c91b96c9255b14 = "Preferred";
const $29c714bbf94e67c5$export$b582d54815d3c1bd = "Common";


const $7182a89bcd572dc1$var$CompanyTransferabilitySankeyLink = (props)=>{
    // All props are passed in by recharts.
    const { sourceX: sourceX, sourceY: sourceY, sourceControlX: sourceControlX, targetX: targetX, targetY: targetY, targetControlX: targetControlX, linkWidth: linkWidth } = props;
    const strokeTargetMap = {
        [(0, $29c714bbf94e67c5$export$49cb64643f8069b3)]: "rgba(116, 154, 211, 0.8)",
        [(0, $29c714bbf94e67c5$export$6ae3be16c5e9de4b)]: "rgba(116, 154, 211, 0.8)",
        [(0, $29c714bbf94e67c5$export$c6aa9d861bfe48b5)]: "rgba(116, 154, 211, 0.8)",
        [(0, $29c714bbf94e67c5$export$cce8a4f293cf0ee2)]: "rgba(116, 154, 211, 0.8)",
        [(0, $29c714bbf94e67c5$export$f367739dcc25743f)]: "rgba(212, 185, 114, 0.80)",
        [(0, $29c714bbf94e67c5$export$9c91b96c9255b14)]: "rgba(152, 116, 211, 0.80)",
        [(0, $29c714bbf94e67c5$export$b582d54815d3c1bd)]: "rgba(152, 116, 211, 0.80)"
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("path", {
            className: "recharts-sankey-link",
            d: `
          M${sourceX},${sourceY}
          C${sourceControlX},${sourceY} ${targetControlX},${targetY} ${targetX},${targetY}
        `,
            fill: "none",
            stroke: strokeTargetMap[props.payload.target.name],
            strokeWidth: Math.max(linkWidth || 0, 1),
            strokeOpacity: "0.2"
        })
    });
};
$7182a89bcd572dc1$var$CompanyTransferabilitySankeyLink.propTypes = {
    sourceX: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    sourceY: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    sourceControlX: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    targetX: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    targetY: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    targetControlX: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    linkWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    payload: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        target: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        })
    })
};
var $7182a89bcd572dc1$export$2e2bcd8739ae039 = $7182a89bcd572dc1$var$CompanyTransferabilitySankeyLink;




var $cd0Jr = parcelRequire("cd0Jr");





const $0a79174dc9443828$var$CompanyTransferabilitySankeyNode = (props)=>{
    const { x: x, y: y, width: width, height: height, index: index, payload: payload } = props;
    const depthColorMap = {
        0: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500,
        1: "#749AD3",
        2: "#9874D3"
    };
    // The unknown security is a special case, but other than that we color the nodes based on
    // depth in the chart.
    const color = payload.name === (0, $29c714bbf94e67c5$export$f367739dcc25743f) ? (0, $78cf78541be2071b$export$29792b0afe15a7ce).yellow : depthColorMap[payload.depth];
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c0f721a3b6bafaa4$export$4617fb02663045ef), {
                x: x,
                y: y,
                width: width,
                height: Math.max(height, 1),
                fill: color,
                fillOpacity: "1"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("text", {
                x: x,
                y: y - 24,
                fontSize: "12",
                fill: (0, $dfd33cee3229493c$exports.ColorPalette).white50,
                children: payload.name
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("text", {
                x: x,
                y: y - 8,
                fontSize: "12",
                fill: (0, $dfd33cee3229493c$exports.ColorPalette).white80,
                children: payload.value >= 0.05 ? (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(payload.value, 1) : "less than 0.1%"
            })
        ]
    }, `CustomNode${index}`);
};
$0a79174dc9443828$var$CompanyTransferabilitySankeyNode.propTypes = {
    x: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    payload: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        depth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    })
};
var $0a79174dc9443828$export$2e2bcd8739ae039 = $0a79174dc9443828$var$CompanyTransferabilitySankeyNode;





const $bbcf64687823cf5e$var$StyledContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  height: 380px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
`;
const $bbcf64687823cf5e$var$StyledFooter = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30).attrs({
    as: "div"
})`
  padding-right: 16px;
  text-align: right;
`;
const $bbcf64687823cf5e$var$CompanyTransferabilityCard = ()=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const transactionRecordAggregateQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).TRANSACTION_RECORD_AGGREGATES(), {
        company: company?.zb_id
    }, {
        enabled: !companyIsLoading && Boolean(company?.zb_id)
    });
    const transactionRecordData = (0, $70fFQ.useMemo)(()=>transactionRecordAggregateQuery.isSuccess ? transactionRecordAggregateQuery.cleanedData?.data?.[0] : null, [
        transactionRecordAggregateQuery.isSuccess,
        transactionRecordAggregateQuery.cleanedData?.data
    ]);
    const transferabilityData = (0, $70fFQ.useMemo)(()=>{
        if (!transactionRecordData) return {
            nodes: [],
            links: []
        };
        // Add in the unknown percentages for convenience.
        const actualData = {
            ...transactionRecordData,
            approved_volume_unknown: Number(transactionRecordData.approved_volume_percentage) - Number(transactionRecordData.approved_volume_common_percentage) - Number(transactionRecordData.approved_volume_preferred_percentage),
            rofr_volume_unknown: Number(transactionRecordData.rofr_volume_total_percentage) - Number(transactionRecordData.rofr_volume_common_percentage) - Number(transactionRecordData.rofr_volume_preferred_percentage)
        };
        const pushNode = (nodeName, depth)=>{
            nodes.push({
                name: nodeName,
                depth: depth
            });
        };
        const pushLink = (source, target, value)=>{
            links.push({
                source: source,
                target: target,
                value: value
            });
        };
        const ALL_TRADES_NODE = 0;
        const FIRST_LAYER = 0;
        const SECOND_LAYER = 1;
        const THIRD_LAYER = 2;
        // We'll store the node index that the direct approved and direct rofr nodes end up at
        // so we can refer to them for creating the links to the security types.
        let directApprovedNodeIndex = 0;
        let directRofrNodeIndex = 0;
        let curNode = 1;
        const nodes = [
            {
                name: "All trades",
                depth: FIRST_LAYER
            }
        ];
        const links = [];
        // We have to build the nodes and links in a specific order, and dependent on what data
        // is present. Specific nodes always have the same depth, but the links are dynamic because
        // we don't include a node if its % is 0.
        if (actualData.approved_volume_percentage) {
            directApprovedNodeIndex = curNode;
            pushNode((0, $29c714bbf94e67c5$export$49cb64643f8069b3), SECOND_LAYER);
            pushLink(ALL_TRADES_NODE, curNode++, actualData.approved_volume_percentage * 100);
        }
        if (actualData.rofr_volume_total_percentage) {
            directRofrNodeIndex = curNode;
            pushNode((0, $29c714bbf94e67c5$export$6ae3be16c5e9de4b), SECOND_LAYER);
            pushLink(ALL_TRADES_NODE, curNode++, actualData.rofr_volume_total_percentage * 100);
        }
        if (actualData.spv_volume_percentage) {
            pushNode((0, $29c714bbf94e67c5$export$c6aa9d861bfe48b5), SECOND_LAYER);
            pushLink(ALL_TRADES_NODE, curNode++, actualData.spv_volume_percentage * 100);
        }
        if (actualData.derivative_volume_percentage) {
            pushNode((0, $29c714bbf94e67c5$export$cce8a4f293cf0ee2), SECOND_LAYER);
            pushLink(ALL_TRADES_NODE, curNode++, actualData.derivative_volume_percentage * 100);
        }
        if (directApprovedNodeIndex && actualData.approved_volume_unknown !== 0) {
            pushNode((0, $29c714bbf94e67c5$export$f367739dcc25743f), THIRD_LAYER);
            pushLink(directApprovedNodeIndex, curNode++, actualData.approved_volume_unknown * 100);
        }
        if (directApprovedNodeIndex && actualData.approved_volume_preferred_percentage) {
            pushNode((0, $29c714bbf94e67c5$export$9c91b96c9255b14), THIRD_LAYER);
            pushLink(directApprovedNodeIndex, curNode++, actualData.approved_volume_preferred_percentage * 100);
        }
        if (directApprovedNodeIndex && actualData.approved_volume_common_percentage) {
            pushNode((0, $29c714bbf94e67c5$export$b582d54815d3c1bd), THIRD_LAYER);
            pushLink(directApprovedNodeIndex, curNode++, actualData.approved_volume_common_percentage * 100);
        }
        if (directRofrNodeIndex && actualData.rofr_volume_unknown !== 0) {
            pushNode((0, $29c714bbf94e67c5$export$f367739dcc25743f), THIRD_LAYER);
            pushLink(directRofrNodeIndex, curNode++, actualData.rofr_volume_unknown * 100);
        }
        if (directRofrNodeIndex && actualData.rofr_volume_preferred_percentage) {
            pushNode((0, $29c714bbf94e67c5$export$9c91b96c9255b14), THIRD_LAYER);
            pushLink(directRofrNodeIndex, curNode++, actualData.rofr_volume_preferred_percentage * 100);
        }
        if (directRofrNodeIndex && actualData.rofr_volume_common_percentage) {
            pushNode((0, $29c714bbf94e67c5$export$b582d54815d3c1bd), THIRD_LAYER);
            pushLink(directRofrNodeIndex, curNode++, actualData.rofr_volume_common_percentage * 100);
        }
        return {
            nodes: nodes,
            links: links
        };
    }, [
        transactionRecordData
    ]);
    if (transactionRecordAggregateQuery.isLoading || !transactionRecordData) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Company Transferability",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$757b1a5dfccb9b1d), {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                $margin: 48,
                children: "Data not available"
            })
        })
    });
    /**
   * We need to add some margin to the right of the sankey graph because the labels for each node
   * extend beyond the right edge of the node. The longest 3rd-layer label is "Unknown Security",
   * which with our typeface takes about 98px. Subtract the width of the node (24), and we get 74px.
   * @type {number}
   */ const SANKEY_MARGIN_RIGHT = 74;
    /**
   * Similarly to the right margin, we need to Add enough margin to cover the labels which appear
   * above the nodes. 34 is 10 pixels larger than the y offset for the text, so we get some
   * narrow padding between the two rows of text, and the bar.
   * @type {number}
   */ const SANKEY_MARGIN_TOP = 34;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Company Transferability",
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bbcf64687823cf5e$var$StyledContainer, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2e5a4ca8ae099b29$export$e60a4704009a0009), {
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $04b7bfe8c4fdc12f$export$c6543aa9da37a94e), {
                        allowFloatingTerminalNodes: true,
                        // iterations={0} Forces nodes to align at the top of the container, and not reorder.
                        iterations: 0,
                        data: transferabilityData,
                        linkCurvature: 0.5,
                        node: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $0a79174dc9443828$export$2e2bcd8739ae039), {}),
                        link: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7182a89bcd572dc1$export$2e2bcd8739ae039), {}),
                        nodePadding: 60,
                        nodeWidth: 24,
                        margin: {
                            left: 0,
                            right: SANKEY_MARGIN_RIGHT,
                            top: SANKEY_MARGIN_TOP,
                            bottom: 0
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bbcf64687823cf5e$var$StyledFooter, {
                children: "Percentage of transfers by volume, rounded to one decimal place"
            })
        ]
    });
};
var $bbcf64687823cf5e$export$2e2bcd8739ae039 = $bbcf64687823cf5e$var$CompanyTransferabilityCard;




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");
/**
 * @fileOverview Bar Chart
 */ 


var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");


var $70fFQ = parcelRequire("70fFQ");



var $axMmP = parcelRequire("axMmP");












/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $8af0c55e8c73e8b9$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $8b11cea5ebf6d7cd$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $2b3288d276a160b8$export$3ee78d51cffc2b68)(size, angle);
}
function $8b11cea5ebf6d7cd$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $8b11cea5ebf6d7cd$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $8b11cea5ebf6d7cd$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $8af0c55e8c73e8b9$export$41514b9f058a6886)(ticks, interval + 1);
}




function $e46a22a71b87b26a$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $8af0c55e8c73e8b9$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $8b11cea5ebf6d7cd$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $3679be4ba9e352cd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3679be4ba9e352cd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3679be4ba9e352cd$var$_typeof(o);
}
function $3679be4ba9e352cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3679be4ba9e352cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3679be4ba9e352cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3679be4ba9e352cd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3679be4ba9e352cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3679be4ba9e352cd$var$_defineProperty(obj, key, value) {
    key = $3679be4ba9e352cd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3679be4ba9e352cd$var$_toPropertyKey(t) {
    var i = $3679be4ba9e352cd$var$_toPrimitive(t, "string");
    return "symbol" == $3679be4ba9e352cd$var$_typeof(i) ? i : String(i);
}
function $3679be4ba9e352cd$var$_toPrimitive(t, r) {
    if ("object" != $3679be4ba9e352cd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3679be4ba9e352cd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3679be4ba9e352cd$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $8b11cea5ebf6d7cd$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $3679be4ba9e352cd$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $8b11cea5ebf6d7cd$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $8b11cea5ebf6d7cd$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $3679be4ba9e352cd$var$_objectSpread($3679be4ba9e352cd$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $3679be4ba9e352cd$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(interval) || (0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr) return (0, $8b11cea5ebf6d7cd$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $453b3059df48aedd$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $14ab4f4cd331f2e9$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $8b11cea5ebf6d7cd$export$a1966f4ad955c82b)((0, $14ab4f4cd331f2e9$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $14ab4f4cd331f2e9$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $453b3059df48aedd$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $8b11cea5ebf6d7cd$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $e46a22a71b87b26a$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $3679be4ba9e352cd$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $3679be4ba9e352cd$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $a32f1c0af82fc7b0$var$_excluded = [
    "viewBox"
], $a32f1c0af82fc7b0$var$_excluded2 = [
    "viewBox"
], $a32f1c0af82fc7b0$var$_excluded3 = [
    "ticks"
];
function $a32f1c0af82fc7b0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a32f1c0af82fc7b0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a32f1c0af82fc7b0$var$_typeof(o);
}
function $a32f1c0af82fc7b0$var$_extends() {
    $a32f1c0af82fc7b0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a32f1c0af82fc7b0$var$_extends.apply(this, arguments);
}
function $a32f1c0af82fc7b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a32f1c0af82fc7b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a32f1c0af82fc7b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a32f1c0af82fc7b0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a32f1c0af82fc7b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a32f1c0af82fc7b0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a32f1c0af82fc7b0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a32f1c0af82fc7b0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a32f1c0af82fc7b0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a32f1c0af82fc7b0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a32f1c0af82fc7b0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a32f1c0af82fc7b0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a32f1c0af82fc7b0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a32f1c0af82fc7b0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a32f1c0af82fc7b0$var$_callSuper(t, o, e) {
    return o = $a32f1c0af82fc7b0$var$_getPrototypeOf(o), $a32f1c0af82fc7b0$var$_possibleConstructorReturn(t, $a32f1c0af82fc7b0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a32f1c0af82fc7b0$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a32f1c0af82fc7b0$var$_possibleConstructorReturn(self, call) {
    if (call && ($a32f1c0af82fc7b0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a32f1c0af82fc7b0$var$_assertThisInitialized(self);
}
function $a32f1c0af82fc7b0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a32f1c0af82fc7b0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a32f1c0af82fc7b0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a32f1c0af82fc7b0$var$_getPrototypeOf(o) {
    $a32f1c0af82fc7b0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a32f1c0af82fc7b0$var$_getPrototypeOf(o);
}
function $a32f1c0af82fc7b0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a32f1c0af82fc7b0$var$_setPrototypeOf(subClass, superClass);
}
function $a32f1c0af82fc7b0$var$_setPrototypeOf(o, p) {
    $a32f1c0af82fc7b0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a32f1c0af82fc7b0$var$_setPrototypeOf(o, p);
}
function $a32f1c0af82fc7b0$var$_defineProperty(obj, key, value) {
    key = $a32f1c0af82fc7b0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a32f1c0af82fc7b0$var$_toPropertyKey(t) {
    var i = $a32f1c0af82fc7b0$var$_toPrimitive(t, "string");
    return "symbol" == $a32f1c0af82fc7b0$var$_typeof(i) ? i : String(i);
}
function $a32f1c0af82fc7b0$var$_toPrimitive(t, r) {
    if ("object" != $a32f1c0af82fc7b0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a32f1c0af82fc7b0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a32f1c0af82fc7b0$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $a32f1c0af82fc7b0$var$_inherits(CartesianAxis, _Component);
    function CartesianAxis(props) {
        var _this;
        $a32f1c0af82fc7b0$var$_classCallCheck(this, CartesianAxis);
        _this = $a32f1c0af82fc7b0$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $a32f1c0af82fc7b0$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $a32f1c0af82fc7b0$var$_objectWithoutProperties(_ref, $a32f1c0af82fc7b0$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $a32f1c0af82fc7b0$var$_objectWithoutProperties(_this$props, $a32f1c0af82fc7b0$var$_excluded2);
                return !(0, $924d4aaaa598a456$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $924d4aaaa598a456$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $924d4aaaa598a456$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $453b3059df48aedd$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false)), (0, $a56fb3d503224b01$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", $a32f1c0af82fc7b0$var$_extends({}, props, {
                    className: (0, $axMmP.default)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $3679be4ba9e352cd$export$3d27d42b1034de5c)($a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread($a32f1c0af82fc7b0$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $a32f1c0af82fc7b0$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", $a32f1c0af82fc7b0$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $axMmP.default)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($fc063f47c858524d$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $a32f1c0af82fc7b0$var$_objectWithoutProperties(_this$props8, $a32f1c0af82fc7b0$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: (0, $axMmP.default)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $e8d2d091029884ea$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f01a70744931f940$export$5f1af8db9871e1d6), $a32f1c0af82fc7b0$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $70fFQ.Component));
$a32f1c0af82fc7b0$var$_defineProperty($a32f1c0af82fc7b0$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$a32f1c0af82fc7b0$var$_defineProperty($a32f1c0af82fc7b0$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



function $ee3eb083333526ae$var$_extends() {
    $ee3eb083333526ae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ee3eb083333526ae$var$_extends.apply(this, arguments);
}
var $ee3eb083333526ae$export$ea77231de273b52d = function XAxis(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $7ac7b265aa8e371b$export$8854f7ece606854b)();
    var height = (0, $7ac7b265aa8e371b$export$369ae257969c6f9f)();
    var axisOptions = (0, $7ac7b265aa8e371b$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $a32f1c0af82fc7b0$export$bdd99f2cdf352bae), $ee3eb083333526ae$var$_extends({}, axisOptions, {
        className: (0, $axMmP.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
$ee3eb083333526ae$export$ea77231de273b52d.displayName = 'XAxis';
$ee3eb083333526ae$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
};



var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");



function $fcdeec4b2ff3583d$var$_extends() {
    $fcdeec4b2ff3583d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fcdeec4b2ff3583d$var$_extends.apply(this, arguments);
}
var $fcdeec4b2ff3583d$export$f96c4024c52de8f4 = function YAxis(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $7ac7b265aa8e371b$export$8854f7ece606854b)();
    var height = (0, $7ac7b265aa8e371b$export$369ae257969c6f9f)();
    var axisOptions = (0, $7ac7b265aa8e371b$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $a32f1c0af82fc7b0$export$bdd99f2cdf352bae), $fcdeec4b2ff3583d$var$_extends({}, axisOptions, {
        className: (0, $axMmP.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
$fcdeec4b2ff3583d$export$f96c4024c52de8f4.displayName = 'YAxis';
$fcdeec4b2ff3583d$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
};



var $585615f2309c503c$export$94aefc399ef206a9 = (0, $0b69b3fe5a85f3bb$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $ee3eb083333526ae$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $2b3288d276a160b8$export$ece7de1383db5ac)
});






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");

/**
 * This is a factory specifically to use as the `activeBar` prop passed into a recharts `Bar`
 * component. The factory returns a component to render a highlighted bar when the user hovers over
 * it in the company profile line graph, when displaying a volume indicator.
 *
 * `dataKey` will be used to fish the correct chart data value out of the hover state, to know if
 *    the user is hovering specifically the bar or just somewhere in the graph.
 * `barIndex` will be used to determine necessary y-offset to add to the y-value. We space our
 *    bars with 2 pixels of vertical padding between them, so the more bars we stack, the more
 *    additional spacing we need.
 */ const $46a3eecb23840b20$var$ActiveVolumeBar = (dataKey, color, barIndex)=>{
    const Bar = ({ x: x, y: y, width: width, height: height, ...props })=>{
        return props[dataKey] ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c0f721a3b6bafaa4$export$4617fb02663045ef), {
            fill: color,
            x: x,
            y: y - 2 * barIndex,
            width: width,
            height: height
        }) : null;
    };
    Bar.propTypes = {
        x: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
    };
    return Bar;
};
var $46a3eecb23840b20$export$2e2bcd8739ae039 = $46a3eecb23840b20$var$ActiveVolumeBar;


const $93f86887bbb59afd$export$eb7173689595799a = "volume";
const $93f86887bbb59afd$export$cbd83ed2d87d2b86 = "tickets";




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");





const $c7868140520f25ad$var$StyledDropdownContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.PageSection))`
  padding: 12px 0;
  margin: -16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $c7868140520f25ad$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  padding: 0 12px;
  height: 32px;
  min-height: 32px;
`;
const $c7868140520f25ad$var$IconPlaceholderDiv = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 18px;
  height: 18px;
`;
const $c7868140520f25ad$var$SelectTypeDropdown = (props)=>{
    const isVolumeSelected = props.selectedRatioType === (0, $93f86887bbb59afd$export$eb7173689595799a);
    // eslint-disable-next-line react/prop-types
    const TypeDropdown = ({ toggleIsOpen: toggleIsOpen })=>{
        const selectVolume = ()=>{
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).selectCompanyBidOfferRatioType(props.companyName, (0, $93f86887bbb59afd$export$eb7173689595799a));
            props.setSelectedRatioType((0, $93f86887bbb59afd$export$eb7173689595799a));
            toggleIsOpen();
        };
        const selectNumTickets = ()=>{
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).selectCompanyBidOfferRatioType(props.companyName, (0, $93f86887bbb59afd$export$cbd83ed2d87d2b86));
            props.setSelectedRatioType((0, $93f86887bbb59afd$export$cbd83ed2d87d2b86));
            toggleIsOpen();
        };
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($c7868140520f25ad$var$StyledDropdownContainer, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.List), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($c7868140520f25ad$var$StyledListItem, {
                        text: "by volume",
                        onClick: selectVolume,
                        leadingIconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400,
                        leadingIcon: isVolumeSelected ? (0, $dfd33cee3229493c$exports.CheckIcon) : $c7868140520f25ad$var$IconPlaceholderDiv
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($c7868140520f25ad$var$StyledListItem, {
                        text: "by tickets",
                        onClick: selectNumTickets,
                        leadingIconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400,
                        leadingIcon: !isVolumeSelected ? (0, $dfd33cee3229493c$exports.CheckIcon) : $c7868140520f25ad$var$IconPlaceholderDiv
                    })
                ]
            })
        });
    };
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(TypeDropdown);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ActionChip), {
                onClick: toggleDropdown,
                text: props.selectedRatioType === (0, $93f86887bbb59afd$export$eb7173689595799a) ? "by volume" : "by tickets",
                trailingIcon: (0, $dfd33cee3229493c$exports.ChevronDownIcon),
                ref: dropdownRef
            }),
            dropdownElement
        ]
    });
};
$c7868140520f25ad$var$SelectTypeDropdown.propTypes = {
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    selectedRatioType: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        (0, $93f86887bbb59afd$export$eb7173689595799a),
        (0, $93f86887bbb59afd$export$cbd83ed2d87d2b86)
    ]).isRequired,
    setSelectedRatioType: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $c7868140520f25ad$export$2e2bcd8739ae039 = $c7868140520f25ad$var$SelectTypeDropdown;






/**
 * Apply opacity to a 6-character hex code.
 *
 * @param {string} hex - A color hex code of the form "#FFFFF"
 * @param {number} opacity - A number in the interval [0, 1]
 * @return {string}
 */ const $a58ecc6057b2b381$var$applyOpacityToHex = (hex, opacity)=>{
    // Convert opacity to 2-character hex suffix
    const opacityHex = Math.round(opacity * 255).toString(16);
    return `${hex}${opacityHex}`;
};
var $a58ecc6057b2b381$export$2e2bcd8739ae039 = $a58ecc6057b2b381$var$applyOpacityToHex;








const $a834045649dba913$var$GraphXAxisYearContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
`;
const $a834045649dba913$var$StyledContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  > :last-child {
    margin-top: 24px;
  }
`;
const $a834045649dba913$var$LegendItemContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50).attrs({
    as: "div"
})`
  display: flex;
  gap: 12px;
  align-items: center;
`;
// Debounce hover tracker by 1 second
const $a834045649dba913$var$HOVER_INTERACTION_DEBOUNCE_DELAY = 1000;
const $a834045649dba913$var$hoverCompanyBidOfferRatioCard = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).hoverCompanyBidOfferRatioCard, $a834045649dba913$var$HOVER_INTERACTION_DEBOUNCE_DELAY);
const $a834045649dba913$var$BidAskRatioStatsList = ({ bidPercentage: bidPercentage, askPercentage: askPercentage, reportPeriod: reportPeriod })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$54c2e3dc7acea9f5), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a834045649dba913$var$LegendItemContainer, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$f734cfedcd7bed10), {
                                color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).green
                            }),
                            "Bid %"
                        ]
                    }),
                    bidPercentage !== undefined ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                        children: (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(bidPercentage * 100, 0)
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                        children: "--"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a834045649dba913$var$LegendItemContainer, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$f734cfedcd7bed10), {
                                color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).red
                            }),
                            "Ask %"
                        ]
                    }),
                    askPercentage !== undefined ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                        children: (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(askPercentage * 100, 0)
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                        children: "--"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($a834045649dba913$var$LegendItemContainer, {
                        children: "Report Period"
                    }),
                    reportPeriod !== undefined ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                        children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(reportPeriod).toLocaleString({
                            month: "short",
                            year: "numeric"
                        })
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                        children: "--"
                    })
                ]
            })
        ]
    });
$a834045649dba913$var$BidAskRatioStatsList.propTypes = {
    bidPercentage: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    askPercentage: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    reportPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
const $a834045649dba913$var$BidAskRatioCard = ()=>{
    const [hoverStats, setHoverStats] = (0, $70fFQ.useState)();
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [selectedRatioType, _setSelectedRatioType] = (0, $70fFQ.useState)((0, $93f86887bbb59afd$export$eb7173689595799a));
    const setSelectedRatioType = (0, $70fFQ.useCallback)((type)=>{
        _setSelectedRatioType(type);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).selectBidOfferRatioType(company?.name, type);
    }, [
        _setSelectedRatioType,
        company
    ]);
    const selectedBidType = (0, $70fFQ.useMemo)(()=>selectedRatioType === (0, $93f86887bbb59afd$export$eb7173689595799a) ? "percent_bid_by_volume" : "percent_bid_by_tickets", [
        selectedRatioType
    ]);
    const selectedAskType = (0, $70fFQ.useMemo)(()=>selectedRatioType === (0, $93f86887bbb59afd$export$eb7173689595799a) ? "percent_ask_by_volume" : "percent_ask_by_tickets", [
        selectedRatioType
    ]);
    // Standalone HD's proxy added the trailing-year window, newest-first ordering
    // and a 100-row page to this request; the SPA now talks to the endpoint
    // directly, so it has to ask for them itself (ZX-15277).
    const bidOfferRatioQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_BID_OFFER_RATIO_DATA(company.zb_id), {
        time_frame: (0, $753b8dcbe6be17f9$export$c1c27e297fdb3d7e),
        years: 1,
        ordering: "-report_period",
        "page[size]": 100
    });
    const bidOfferRatioData = bidOfferRatioQuery?.data?.data;
    const graphData = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(bidOfferRatioData, (d)=>({
                date: d.attributes.report_period,
                percent_bid_by_tickets: Number(d.attributes.percent_bid_by_tickets),
                percent_ask_by_tickets: 1 - d.attributes.percent_bid_by_tickets,
                percent_bid_by_volume: Number(d.attributes.percent_bid_by_volume),
                percent_ask_by_volume: 1 - d.attributes.percent_bid_by_volume
            })).reverse(), [
        bidOfferRatioData
    ]);
    const xAxisTicks = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(graphData, "date"), [
        graphData
    ]);
    const startDate = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).first(xAxisTicks), [
        xAxisTicks
    ]);
    const endDate = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).last(xAxisTicks), [
        xAxisTicks
    ]);
    // Set hover point data
    const onMouseMove = (0, $70fFQ.useCallback)((d)=>{
        if (!graphData) return;
        $a834045649dba913$var$hoverCompanyBidOfferRatioCard(company?.name, d.activeLabel);
        const hoveredBarData = graphData[d.activeTooltipIndex];
        setHoverStats({
            ...hoveredBarData,
            report_period: d.activeLabel,
            index: d.activeTooltipIndex
        });
    }, [
        graphData,
        company?.name
    ]);
    // Remove hover stats on mouse leave
    const onMouseLeave = (0, $70fFQ.useCallback)(()=>setHoverStats(null), []);
    // Identical shape to hoverStats, used to display default legend value if no bar is being hovered
    const lastPeriodStats = (0, $70fFQ.useMemo)(()=>{
        const lastPeriodData = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).last(graphData);
        return {
            ...lastPeriodData,
            report_period: lastPeriodData?.date,
            index: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(graphData) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).size(graphData) - 1
        };
    }, [
        graphData
    ]);
    const displayStats = (0, $70fFQ.useMemo)(()=>hoverStats || lastPeriodStats || null, [
        hoverStats,
        lastPeriodStats
    ]);
    // The active dot on the <Line /> component requires a tooltip to be enabled
    // So we pass in a null tooltip function as a hack
    const renderNullTooltip = (0, $70fFQ.useCallback)(()=>null, []);
    if (companyIsLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    if (!bidOfferRatioData) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Bid-Ask Ratio",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a834045649dba913$var$StyledContent, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$757b1a5dfccb9b1d), {
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                        $margin: 48,
                        children: "Data not available"
                    })
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($a834045649dba913$var$BidAskRatioStatsList, {})
            ]
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Bid-Ask Ratio",
        headerTrailingContent: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c7868140520f25ad$export$2e2bcd8739ae039), {
            companyName: company?.name,
            selectedRatioType: selectedRatioType,
            setSelectedRatioType: setSelectedRatioType
        }),
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a834045649dba913$var$StyledContent, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2e5a4ca8ae099b29$export$e60a4704009a0009), {
                    width: "100%",
                    minHeight: 108,
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $585615f2309c503c$export$94aefc399ef206a9), {
                        data: graphData,
                        barCategoryGap: 8,
                        onMouseMove: onMouseMove,
                        onMouseLeave: onMouseLeave,
                        margin: {
                            top: 0,
                            right: -7,
                            left: -7,
                            bottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ee3eb083333526ae$export$ea77231de273b52d), {
                                axisLine: false,
                                tickLine: false,
                                interval: 0,
                                fontSize: 11,
                                tickFormatter: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(value).toFormat("MMM"),
                                ticks: xAxisTicks,
                                dataKey: "date",
                                stroke: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9c6bfe96f56d0a02$export$28c660c63b792dea), {
                                content: renderNullTooltip,
                                cursor: {
                                    fill: "transparent"
                                }
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1), {
                                dataKey: selectedBidType,
                                fill: (0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).green, 0.5),
                                stackId: "bidAskRatioStack",
                                activeBar: (0, $46a3eecb23840b20$export$2e2bcd8739ae039)(selectedBidType, (0, $78cf78541be2071b$export$29792b0afe15a7ce).green, 0),
                                barSize: 12,
                                activeIndex: displayStats.index
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1), {
                                dataKey: selectedAskType,
                                fill: (0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).red, 0.5),
                                stackId: "bidAskRatioStack",
                                style: {
                                    transform: "translateY(-2px)"
                                },
                                activeBar: (0, $46a3eecb23840b20$export$2e2bcd8739ae039)(selectedAskType, (0, $78cf78541be2071b$export$29792b0afe15a7ce).red, 1),
                                activeIndex: displayStats.index,
                                barSize: 12
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a834045649dba913$var$GraphXAxisYearContainer, {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption1theme50, {
                            children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(startDate).year
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption1theme50, {
                            children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(endDate).year
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($a834045649dba913$var$BidAskRatioStatsList, {
                    bidPercentage: displayStats?.[selectedBidType],
                    askPercentage: displayStats?.[selectedAskType],
                    reportPeriod: displayStats?.report_period
                })
            ]
        })
    });
};
var $a834045649dba913$export$2e2bcd8739ae039 = $a834045649dba913$var$BidAskRatioCard;




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");

var $axMmP = parcelRequire("axMmP");














var $54b055b34209fc18$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
];
var $54b055b34209fc18$var$_Area;
function $54b055b34209fc18$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $54b055b34209fc18$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $54b055b34209fc18$var$_typeof(o);
}
function $54b055b34209fc18$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $54b055b34209fc18$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $54b055b34209fc18$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $54b055b34209fc18$var$_extends() {
    $54b055b34209fc18$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $54b055b34209fc18$var$_extends.apply(this, arguments);
}
function $54b055b34209fc18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54b055b34209fc18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54b055b34209fc18$var$ownKeys(Object(t), !0).forEach(function(r) {
            $54b055b34209fc18$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54b055b34209fc18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $54b055b34209fc18$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $54b055b34209fc18$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $54b055b34209fc18$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $54b055b34209fc18$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $54b055b34209fc18$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $54b055b34209fc18$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $54b055b34209fc18$var$_callSuper(t, o, e) {
    return o = $54b055b34209fc18$var$_getPrototypeOf(o), $54b055b34209fc18$var$_possibleConstructorReturn(t, $54b055b34209fc18$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $54b055b34209fc18$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $54b055b34209fc18$var$_possibleConstructorReturn(self, call) {
    if (call && ($54b055b34209fc18$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $54b055b34209fc18$var$_assertThisInitialized(self);
}
function $54b055b34209fc18$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($54b055b34209fc18$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $54b055b34209fc18$var$_getPrototypeOf(o) {
    $54b055b34209fc18$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $54b055b34209fc18$var$_getPrototypeOf(o);
}
function $54b055b34209fc18$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $54b055b34209fc18$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $54b055b34209fc18$var$_setPrototypeOf(subClass, superClass);
}
function $54b055b34209fc18$var$_setPrototypeOf(o, p) {
    $54b055b34209fc18$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $54b055b34209fc18$var$_setPrototypeOf(o, p);
}
function $54b055b34209fc18$var$_defineProperty(obj, key, value) {
    key = $54b055b34209fc18$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $54b055b34209fc18$var$_toPropertyKey(t) {
    var i = $54b055b34209fc18$var$_toPrimitive(t, "string");
    return "symbol" == $54b055b34209fc18$var$_typeof(i) ? i : String(i);
}
function $54b055b34209fc18$var$_toPrimitive(t, r) {
    if ("object" != $54b055b34209fc18$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $54b055b34209fc18$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $54b055b34209fc18$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $54b055b34209fc18$var$_inherits(Area, _PureComponent);
    function Area() {
        var _this;
        $54b055b34209fc18$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $54b055b34209fc18$var$_callSuper(this, Area, [].concat(args));
        $54b055b34209fc18$var$_defineProperty($54b055b34209fc18$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true
        });
        $54b055b34209fc18$var$_defineProperty($54b055b34209fc18$var$_assertThisInitialized(_this), "id", (0, $453b3059df48aedd$export$8b15d37bc3f197d4)('recharts-area-'));
        $54b055b34209fc18$var$_defineProperty($54b055b34209fc18$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $54b055b34209fc18$var$_defineProperty($54b055b34209fc18$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $54b055b34209fc18$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $54b055b34209fc18$var$_objectSpread($54b055b34209fc18$var$_objectSpread($54b055b34209fc18$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $54b055b34209fc18$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($cf55e66df9391434$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $54b055b34209fc18$var$_objectWithoutProperties(_this$props4, $54b055b34209fc18$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1), $54b055b34209fc18$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1), $54b055b34209fc18$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1), $54b055b34209fc18$var$_extends({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $54b055b34209fc18$var$_objectSpread($54b055b34209fc18$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($b26a90b73a77c867$exports)))(baseLine)) {
                            var _interpolator = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $54b055b34209fc18$var$_objectSpread($54b055b34209fc18$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $axMmP.default)('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $a56fb3d503224b01$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $f77ba05e9211fcd7$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $70fFQ.PureComponent));
$54b055b34209fc18$var$_Area = $54b055b34209fc18$export$ea1a111407f37557;
$54b055b34209fc18$var$_defineProperty($54b055b34209fc18$export$ea1a111407f37557, "displayName", 'Area');
$54b055b34209fc18$var$_defineProperty($54b055b34209fc18$export$ea1a111407f37557, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
$54b055b34209fc18$var$_defineProperty($54b055b34209fc18$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $453b3059df48aedd$export$7e4aa119212bc614)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
$54b055b34209fc18$var$_defineProperty($54b055b34209fc18$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $54b055b34209fc18$var$_Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, $cdef3b11746f8934$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $cdef3b11746f8934$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return $54b055b34209fc18$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$54b055b34209fc18$var$_defineProperty($54b055b34209fc18$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) dotItem = option(props);
    else {
        var className = (0, $axMmP.default)('recharts-area-dot', typeof option !== 'boolean' ? option.className : '');
        dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $d509b7e1d2bfee51$export$d046b3c4a416f60d), $54b055b34209fc18$var$_extends({}, props, {
            className: className
        }));
    }
    return dotItem;
});

/**
 * @fileOverview Composed Chart
 */ 



var $70fFQ = parcelRequire("70fFQ");





var $axMmP = parcelRequire("axMmP");









var $32207b201d0eab60$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function $32207b201d0eab60$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $32207b201d0eab60$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $32207b201d0eab60$var$_typeof(o);
}
function $32207b201d0eab60$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $32207b201d0eab60$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $32207b201d0eab60$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $32207b201d0eab60$var$_extends() {
    $32207b201d0eab60$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $32207b201d0eab60$var$_extends.apply(this, arguments);
}
function $32207b201d0eab60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32207b201d0eab60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32207b201d0eab60$var$ownKeys(Object(t), !0).forEach(function(r) {
            $32207b201d0eab60$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32207b201d0eab60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $32207b201d0eab60$var$_toConsumableArray(arr) {
    return $32207b201d0eab60$var$_arrayWithoutHoles(arr) || $32207b201d0eab60$var$_iterableToArray(arr) || $32207b201d0eab60$var$_unsupportedIterableToArray(arr) || $32207b201d0eab60$var$_nonIterableSpread();
}
function $32207b201d0eab60$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $32207b201d0eab60$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $32207b201d0eab60$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $32207b201d0eab60$var$_arrayLikeToArray(o, minLen);
}
function $32207b201d0eab60$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $32207b201d0eab60$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $32207b201d0eab60$var$_arrayLikeToArray(arr);
}
function $32207b201d0eab60$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $32207b201d0eab60$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $32207b201d0eab60$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $32207b201d0eab60$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $32207b201d0eab60$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $32207b201d0eab60$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $32207b201d0eab60$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $32207b201d0eab60$var$_callSuper(t, o, e) {
    return o = $32207b201d0eab60$var$_getPrototypeOf(o), $32207b201d0eab60$var$_possibleConstructorReturn(t, $32207b201d0eab60$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $32207b201d0eab60$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $32207b201d0eab60$var$_possibleConstructorReturn(self, call) {
    if (call && ($32207b201d0eab60$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $32207b201d0eab60$var$_assertThisInitialized(self);
}
function $32207b201d0eab60$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($32207b201d0eab60$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $32207b201d0eab60$var$_getPrototypeOf(o) {
    $32207b201d0eab60$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $32207b201d0eab60$var$_getPrototypeOf(o);
}
function $32207b201d0eab60$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $32207b201d0eab60$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $32207b201d0eab60$var$_setPrototypeOf(subClass, superClass);
}
function $32207b201d0eab60$var$_setPrototypeOf(o, p) {
    $32207b201d0eab60$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $32207b201d0eab60$var$_setPrototypeOf(o, p);
}
function $32207b201d0eab60$var$_defineProperty(obj, key, value) {
    key = $32207b201d0eab60$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $32207b201d0eab60$var$_toPropertyKey(t) {
    var i = $32207b201d0eab60$var$_toPrimitive(t, "string");
    return "symbol" == $32207b201d0eab60$var$_typeof(i) ? i : String(i);
}
function $32207b201d0eab60$var$_toPrimitive(t, r) {
    if ("object" != $32207b201d0eab60$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $32207b201d0eab60$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $32207b201d0eab60$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    $32207b201d0eab60$var$_inherits(Line, _PureComponent);
    function Line() {
        var _this;
        $32207b201d0eab60$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $32207b201d0eab60$var$_callSuper(this, Line, [].concat(args));
        $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$var$_assertThisInitialized(_this), "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$var$_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($32207b201d0eab60$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($32207b201d0eab60$var$_toConsumableArray(Line.repeat(lines, count)), $32207b201d0eab60$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$var$_assertThisInitialized(_this), "id", (0, $453b3059df48aedd$export$8b15d37bc3f197d4)('recharts-line-'));
        $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$var$_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $32207b201d0eab60$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $fc2e0abee97a8d1b$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $cdef3b11746f8934$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $32207b201d0eab60$var$_objectSpread($32207b201d0eab60$var$_objectSpread($32207b201d0eab60$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $32207b201d0eab60$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $32207b201d0eab60$var$_objectWithoutProperties(_this$props3, $32207b201d0eab60$var$_excluded);
                var curveProps = $32207b201d0eab60$var$_objectSpread($32207b201d0eab60$var$_objectSpread($32207b201d0eab60$var$_objectSpread({}, (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1), $32207b201d0eab60$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $32207b201d0eab60$var$_objectSpread($32207b201d0eab60$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $32207b201d0eab60$var$_objectSpread($32207b201d0eab60$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $32207b201d0eab60$var$_objectSpread($32207b201d0eab60$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $axMmP.default)('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $a56fb3d503224b01$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $f77ba05e9211fcd7$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($32207b201d0eab60$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($32207b201d0eab60$var$_toConsumableArray(result), $32207b201d0eab60$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) dotItem = option(props);
                else {
                    var className = (0, $axMmP.default)('recharts-line-dot', typeof option !== 'boolean' ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $d509b7e1d2bfee51$export$d046b3c4a416f60d), $32207b201d0eab60$var$_extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, $70fFQ.PureComponent));
$32207b201d0eab60$var$_defineProperty($32207b201d0eab60$export$17d680238e50603e, "displayName", 'Line');
$32207b201d0eab60$var$_defineProperty($32207b201d0eab60$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $32207b201d0eab60$var$_defineProperty($32207b201d0eab60$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, $cdef3b11746f8934$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $cdef3b11746f8934$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $32207b201d0eab60$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});



var $70fFQ = parcelRequire("70fFQ");





var $axMmP = parcelRequire("axMmP");




/**
 * @fileOverview Z Axis
 */ var $d181a59c3a75db7a$export$2363a7fa7edfe988 = function ZAxis() {
    return null;
};
$d181a59c3a75db7a$export$2363a7fa7edfe988.displayName = 'ZAxis';
$d181a59c3a75db7a$export$2363a7fa7edfe988.defaultProps = {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number'
};









var $70fFQ = parcelRequire("70fFQ");


var $b7577bf8dae0054d$var$_excluded = [
    "option",
    "isActive"
];
function $b7577bf8dae0054d$var$_extends() {
    $b7577bf8dae0054d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b7577bf8dae0054d$var$_extends.apply(this, arguments);
}
function $b7577bf8dae0054d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b7577bf8dae0054d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b7577bf8dae0054d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b7577bf8dae0054d$export$569fa72fa47640a8(_ref) {
    var option = _ref.option, isActive = _ref.isActive, props = $b7577bf8dae0054d$var$_objectWithoutProperties(_ref, $b7577bf8dae0054d$var$_excluded);
    if (typeof option === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f2d64a0eb3db0ded$export$6428a7f2611ef1fa), $b7577bf8dae0054d$var$_extends({
        option: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $b03b683f83f72751$export$fa456266707bf4e4), $b7577bf8dae0054d$var$_extends({
            type: option
        }, props)),
        isActive: isActive,
        shapeType: "symbols"
    }, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $f2d64a0eb3db0ded$export$6428a7f2611ef1fa), $b7577bf8dae0054d$var$_extends({
        option: option,
        isActive: isActive,
        shapeType: "symbols"
    }, props));
}


var $da1a64f3d803bb82$var$_Scatter;
function $da1a64f3d803bb82$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $da1a64f3d803bb82$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $da1a64f3d803bb82$var$_typeof(o);
}
function $da1a64f3d803bb82$var$_extends() {
    $da1a64f3d803bb82$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $da1a64f3d803bb82$var$_extends.apply(this, arguments);
}
function $da1a64f3d803bb82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da1a64f3d803bb82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da1a64f3d803bb82$var$ownKeys(Object(t), !0).forEach(function(r) {
            $da1a64f3d803bb82$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da1a64f3d803bb82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $da1a64f3d803bb82$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $da1a64f3d803bb82$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $da1a64f3d803bb82$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $da1a64f3d803bb82$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $da1a64f3d803bb82$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $da1a64f3d803bb82$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $da1a64f3d803bb82$var$_callSuper(t, o, e) {
    return o = $da1a64f3d803bb82$var$_getPrototypeOf(o), $da1a64f3d803bb82$var$_possibleConstructorReturn(t, $da1a64f3d803bb82$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $da1a64f3d803bb82$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $da1a64f3d803bb82$var$_possibleConstructorReturn(self, call) {
    if (call && ($da1a64f3d803bb82$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $da1a64f3d803bb82$var$_assertThisInitialized(self);
}
function $da1a64f3d803bb82$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($da1a64f3d803bb82$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $da1a64f3d803bb82$var$_getPrototypeOf(o) {
    $da1a64f3d803bb82$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $da1a64f3d803bb82$var$_getPrototypeOf(o);
}
function $da1a64f3d803bb82$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $da1a64f3d803bb82$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $da1a64f3d803bb82$var$_setPrototypeOf(subClass, superClass);
}
function $da1a64f3d803bb82$var$_setPrototypeOf(o, p) {
    $da1a64f3d803bb82$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da1a64f3d803bb82$var$_setPrototypeOf(o, p);
}
function $da1a64f3d803bb82$var$_defineProperty(obj, key, value) {
    key = $da1a64f3d803bb82$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da1a64f3d803bb82$var$_toPropertyKey(t) {
    var i = $da1a64f3d803bb82$var$_toPrimitive(t, "string");
    return "symbol" == $da1a64f3d803bb82$var$_typeof(i) ? i : String(i);
}
function $da1a64f3d803bb82$var$_toPrimitive(t, r) {
    if ("object" != $da1a64f3d803bb82$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $da1a64f3d803bb82$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $da1a64f3d803bb82$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    $da1a64f3d803bb82$var$_inherits(Scatter, _PureComponent);
    function Scatter() {
        var _this;
        $da1a64f3d803bb82$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $da1a64f3d803bb82$var$_callSuper(this, Scatter, [].concat(args));
        $da1a64f3d803bb82$var$_defineProperty($da1a64f3d803bb82$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $da1a64f3d803bb82$var$_defineProperty($da1a64f3d803bb82$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $da1a64f3d803bb82$var$_defineProperty($da1a64f3d803bb82$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $da1a64f3d803bb82$var$_defineProperty($da1a64f3d803bb82$var$_assertThisInitialized(_this), "id", (0, $453b3059df48aedd$export$8b15d37bc3f197d4)('recharts-scatter-'));
        return _this;
    }
    $da1a64f3d803bb82$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                return points.map(function(entry, i) {
                    var isActive = activeIndex === i;
                    var option = isActive ? activeShape : shape;
                    var props = $da1a64f3d803bb82$var$_objectSpread($da1a64f3d803bb82$var$_objectSpread({
                        key: "symbol-".concat(i)
                    }, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), $da1a64f3d803bb82$var$_extends({
                        className: "recharts-scatter-symbol"
                    }, (0, $e11a437526851c08$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "symbol-".concat(entry === null || entry === void 0 ? void 0 : entry.cx, "-").concat(entry === null || entry === void 0 ? void 0 : entry.cy, "-").concat(entry === null || entry === void 0 ? void 0 : entry.size, "-").concat(i),
                        role: "img"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $b7577bf8dae0054d$export$569fa72fa47640a8), $da1a64f3d803bb82$var$_extends({
                        option: option,
                        isActive: isActive
                    }, props)));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $bc9b14c565af883b$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $da1a64f3d803bb82$var$_objectSpread($da1a64f3d803bb82$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $453b3059df48aedd$export$d871d53bd7eeb390)(0, entry.size);
                        return $da1a64f3d803bb82$var$_objectSpread($da1a64f3d803bb82$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($6b42dee265745d0f$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(children, (0, $fc2e0abee97a8d1b$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var _item$props = item.props, direction = _item$props.direction, errorDataKey = _item$props.dataKey;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(item, {
                        key: "".concat(direction, "-").concat(errorDataKey, "-").concat(points[i]),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === 'x' ? 'vertical' : 'horizontal',
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $cdef3b11746f8934$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(this.props, false);
                var customLineProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(line, false);
                var linePoints, lineItem;
                if (lineType === 'joint') linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === 'fitting') {
                    var _getLinearRegression = (0, $453b3059df48aedd$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $da1a64f3d803bb82$var$_objectSpread($da1a64f3d803bb82$var$_objectSpread($da1a64f3d803bb82$var$_objectSpread({}, scatterProps), {}, {
                    fill: 'none',
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $eb73f5e7cf78fb38$export$b0e83c3ef8d2db1), $da1a64f3d803bb82$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $axMmP.default)('recharts-scatter', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $5ac932a8929d0d57$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $f77ba05e9211fcd7$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        }
    ]);
    return Scatter;
}((0, $70fFQ.PureComponent));
$da1a64f3d803bb82$var$_Scatter = $da1a64f3d803bb82$export$1c460fb4285edadc;
$da1a64f3d803bb82$var$_defineProperty($da1a64f3d803bb82$export$1c460fb4285edadc, "displayName", 'Scatter');
$da1a64f3d803bb82$var$_defineProperty($da1a64f3d803bb82$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: 'circle',
    lineType: 'joint',
    lineJointType: 'linear',
    data: [],
    shape: 'circle',
    hide: false,
    isAnimationActive: !(0, $9d05d8035ca0d2c9$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $da1a64f3d803bb82$var$_defineProperty($da1a64f3d803bb82$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $a56fb3d503224b01$export$fdd5e64c0e8495bb)(item.props.children, (0, $6ebe10030e701f4c$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $d181a59c3a75db7a$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(zAxisDataKey) && (0, $cdef3b11746f8934$export$f97fc4a450f29a)(entry, zAxisDataKey) || '-';
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || '',
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($ad1dfe9d76fb957d$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || '',
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== '-') tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || '',
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $cdef3b11746f8934$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $cdef3b11746f8934$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== '-' ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $da1a64f3d803bb82$var$_objectSpread($da1a64f3d803bb82$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $da1a64f3d803bb82$var$_objectSpread({
        points: points
    }, offset);
});






var $fb5252d4c65f633c$export$f881f4f9e4007a57 = (0, $0b69b3fe5a85f3bb$export$77871aede60e6838)({
    chartName: 'ComposedChart',
    GraphicalChild: [
        (0, $32207b201d0eab60$export$17d680238e50603e),
        (0, $54b055b34209fc18$export$ea1a111407f37557),
        (0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1),
        (0, $da1a64f3d803bb82$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $ee3eb083333526ae$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, $d181a59c3a75db7a$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $2b3288d276a160b8$export$ece7de1383db5ac)
});






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");


/**
 * This is a factory specifically to use as the `dot` prop passed into a recharts `Line`
 * component. The factory returns a component to render a dot when the user hovers over it.
 *
 * `dataKey` will be used to fish the correct chart data value out of the hover state, to know if
 *    the user is hovering specifically the bar or just somewhere in the graph.
 * `activeIndex` will be used to determine if the dot should be displayed
 */ const $3ae1a3cadebbaa5e$var$ActiveDot = (color, activeIndex)=>{
    const DotComponent = ({ cx: cx, cy: cy, ...props })=>{
        return activeIndex === props.index || activeIndex === props.payload?.time ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d509b7e1d2bfee51$export$d046b3c4a416f60d), {
            fill: color,
            stroke: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0,
            strokeWidth: 2,
            r: 6,
            cx: cx,
            cy: cy
        }) : null;
    };
    DotComponent.propTypes = {
        cx: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        cy: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        index: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        payload: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            time: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        })
    };
    return DotComponent;
};
var $3ae1a3cadebbaa5e$export$2e2bcd8739ae039 = $3ae1a3cadebbaa5e$var$ActiveDot;




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");








var $3ece4213e6b51d98$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $3ece4213e6b51d98$var$_excluded2 = [
    "offset"
];
function $3ece4213e6b51d98$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3ece4213e6b51d98$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3ece4213e6b51d98$var$_typeof(o);
}
function $3ece4213e6b51d98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ece4213e6b51d98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ece4213e6b51d98$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3ece4213e6b51d98$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ece4213e6b51d98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3ece4213e6b51d98$var$_defineProperty(obj, key, value) {
    key = $3ece4213e6b51d98$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3ece4213e6b51d98$var$_toPropertyKey(t) {
    var i = $3ece4213e6b51d98$var$_toPrimitive(t, "string");
    return "symbol" == $3ece4213e6b51d98$var$_typeof(i) ? i : String(i);
}
function $3ece4213e6b51d98$var$_toPrimitive(t, r) {
    if ("object" != $3ece4213e6b51d98$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3ece4213e6b51d98$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3ece4213e6b51d98$var$_extends() {
    $3ece4213e6b51d98$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ece4213e6b51d98$var$_extends.apply(this, arguments);
}
function $3ece4213e6b51d98$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3ece4213e6b51d98$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3ece4213e6b51d98$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $3ece4213e6b51d98$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $3ece4213e6b51d98$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $3ece4213e6b51d98$var$_objectWithoutProperties(props, $3ece4213e6b51d98$var$_excluded);
        var _filterProps = (0, $a56fb3d503224b01$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $3ece4213e6b51d98$var$_objectWithoutProperties(_filterProps, $3ece4213e6b51d98$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("line", $3ece4213e6b51d98$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $3ece4213e6b51d98$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $3ece4213e6b51d98$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $3ece4213e6b51d98$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $3ece4213e6b51d98$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $3ece4213e6b51d98$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $3ece4213e6b51d98$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $3ece4213e6b51d98$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $cdef3b11746f8934$export$846dc5ac5fecff74)((0, $3679be4ba9e352cd$export$3d27d42b1034de5c)($3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread({}, (0, $a32f1c0af82fc7b0$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $3ece4213e6b51d98$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $cdef3b11746f8934$export$846dc5ac5fecff74)((0, $3679be4ba9e352cd$export$3d27d42b1034de5c)($3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread({}, (0, $a32f1c0af82fc7b0$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $cdef3b11746f8934$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $3ece4213e6b51d98$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $3ece4213e6b51d98$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $7ac7b265aa8e371b$export$8854f7ece606854b)();
    var chartHeight = (0, $7ac7b265aa8e371b$export$369ae257969c6f9f)();
    var offset = (0, $7ac7b265aa8e371b$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $3ece4213e6b51d98$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $3ece4213e6b51d98$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $3ece4213e6b51d98$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $3ece4213e6b51d98$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $3ece4213e6b51d98$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $3ece4213e6b51d98$var$defaultProps.verticalFill,
        x: (0, $453b3059df48aedd$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $453b3059df48aedd$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $453b3059df48aedd$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $453b3059df48aedd$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $7ac7b265aa8e371b$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $7ac7b265aa8e371b$export$631ee617f1052e16)();
    if (!(0, $453b3059df48aedd$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(x) || x !== +x || !(0, $453b3059df48aedd$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $3ece4213e6b51d98$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $3ece4213e6b51d98$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $425eb72df2965775$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($3ece4213e6b51d98$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($27042e501e0294f8$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $3ece4213e6b51d98$var$_objectSpread($3ece4213e6b51d98$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $425eb72df2965775$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($3ece4213e6b51d98$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($3ece4213e6b51d98$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($3ece4213e6b51d98$var$HorizontalGridLines, $3ece4213e6b51d98$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($3ece4213e6b51d98$var$VerticalGridLines, $3ece4213e6b51d98$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($3ece4213e6b51d98$var$HorizontalStripes, $3ece4213e6b51d98$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($3ece4213e6b51d98$var$VerticalStripes, $3ece4213e6b51d98$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$3ece4213e6b51d98$export$6440e27b9f186856.displayName = 'CartesianGrid';






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");

/*
 * Custom dot prop for <Line /> to highlight selected period
 */ const $9acc68d81edcc52f$var$SelectedPeriodDot = (props)=>{
    if (props.payload?.date === props.selectedPeriod) {
        const { stroke: stroke, value: value } = props;
        if (!value) return null;
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("circle", {
            ...props,
            fill: stroke,
            r: 6,
            stroke: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0,
            strokeWidth: 2
        });
    }
    return null;
};
$9acc68d81edcc52f$var$SelectedPeriodDot.propTypes = {
    payload: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }),
    r: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    stroke: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).any.isRequired,
    selectedPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
$9acc68d81edcc52f$var$SelectedPeriodDot.defaultProps = {
    payload: null,
    selectedPeriod: null
};
var $9acc68d81edcc52f$export$2e2bcd8739ae039 = $9acc68d81edcc52f$var$SelectedPeriodDot;











const $3483e96430a6f406$export$a815c023683bd5fd = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80).attrs({
    as: "div"
})`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 12px;
  height: 32px;
  box-sizing: border-box;
  border-radius: 8px;
  background: ${(props)=>props.$isHovered ? (0, $dfd33cee3229493c$exports.YukaColorPalette).surface2 : (0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
`;
const $3483e96430a6f406$export$f734cfedcd7bed10 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${({ color: color })=>color};
`;




const $f0acc19cad702cdf$var$LegendContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const $f0acc19cad702cdf$var$ColoredText = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80)`
  color: ${({ color: color })=>color};
`;
const $f0acc19cad702cdf$var$ReportedMarksLegendItemContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $3483e96430a6f406$export$a815c023683bd5fd))`
  background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface2};
`;
const $f0acc19cad702cdf$var$UnderlyingFundsTableStyles = {
    colors: {
        header: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface1,
        row: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface1
    },
    header: {
        borderTop: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`,
        borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
    },
    cells: {
        borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
    }
};
const $f0acc19cad702cdf$var$UNDERLYING_FUNDS_TABLE_COLUMNS = [
    {
        id: "underlying_fund",
        header: "Underlying Fund",
        accessor: "name",
        width: 150
    },
    {
        id: "price_per_share",
        header: "Price / Share",
        accessor: "price_per_share",
        width: 100,
        cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
        formatter: (value)=>(0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, 2, 2)
    },
    {
        id: "security",
        header: "Security",
        accessor: "security",
        width: 100
    },
    {
        id: "notional_value",
        header: "Notional Value",
        accessor: "total_value",
        width: 100,
        cellRenderer: (0, $dfd33cee3229493c$exports.NumberCell),
        formatter: (0, $66339e7a022e68c9$export$736d072c44caa715)
    },
    {
        id: "date",
        header: "Date",
        accessor: "date",
        width: 75,
        cellRenderer: (0, $dfd33cee3229493c$exports.DateCell),
        dateFormatter: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(value).toFormat("MMM yy")
    }
];
// Debounce hover tracker by 1 second
const $f0acc19cad702cdf$var$HOVER_INTERACTION_DEBOUNCE_DELAY = 1000;
const $f0acc19cad702cdf$var$hoverCompanyReportedMarksModal = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).hoverCompanyReportedMarksModal, $f0acc19cad702cdf$var$HOVER_INTERACTION_DEBOUNCE_DELAY);
const $f0acc19cad702cdf$var$ReportedMarksModal = (props)=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    // These hovered/selected period values correspond to the X-axis label values
    // e.g. '2023-07-01'
    const [hoveredPeriod, setHoveredPeriod] = (0, $70fFQ.useState)(null);
    const [selectedPeriod, setSelectedPeriod] = (0, $70fFQ.useState)(null);
    const reportedMarksQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_REPORTED_MARKS_VALUATION(company.zb_id));
    const reportedMarksData = reportedMarksQuery?.data?.data;
    const graphData = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).reverse((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(reportedMarksData, (d, date)=>({
                date: date,
                area: [
                    d.min,
                    d.max
                ],
                weighted_avg: d.weighted_avg,
                simple_avg: d.simple_avg,
                median: d.median
            }))), [
        reportedMarksData
    ]);
    const xAxisTicks = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(graphData, "date"), [
        graphData
    ]);
    const hoveredReportedMarksData = (0, $70fFQ.useMemo)(()=>hoveredPeriod ? reportedMarksData[hoveredPeriod] : null, [
        reportedMarksData,
        hoveredPeriod
    ]);
    const selectedReportedMarksData = (0, $70fFQ.useMemo)(()=>selectedPeriod ? reportedMarksData[selectedPeriod] : null, [
        reportedMarksData,
        selectedPeriod
    ]);
    const displayedReportedMarksData = (0, $70fFQ.useMemo)(()=>selectedReportedMarksData || hoveredReportedMarksData, [
        selectedReportedMarksData,
        hoveredReportedMarksData
    ]);
    // Set hover point data
    const onMouseMove = (0, $70fFQ.useCallback)((d)=>{
        if (!reportedMarksData) return;
        $f0acc19cad702cdf$var$hoverCompanyReportedMarksModal(company?.name, d.activeLabel);
        if (d.activeLabel) setHoveredPeriod(d.activeLabel);
        else setHoveredPeriod(null);
    }, [
        reportedMarksData,
        setHoveredPeriod,
        company?.name
    ]);
    // Set selected point data
    const onClick = (0, $70fFQ.useCallback)((d)=>{
        if (!reportedMarksData) return;
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).selectCompanyReportedMarksModal(company?.name, d.activeLabel);
        if (d.activeLabel) setSelectedPeriod(d.activeLabel);
        else setSelectedPeriod(null);
    }, [
        reportedMarksData,
        setSelectedPeriod,
        company?.name
    ]);
    // The active dot on the <Line /> component requires a tooltip to be enabled
    // So we pass in a null tooltip function as a hack
    const renderNullTooltip = (0, $70fFQ.useCallback)(()=>null, []);
    if (companyIsLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: props.closeModal,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
            theme: {
                tableStyles: $f0acc19cad702cdf$var$UnderlyingFundsTableStyles
            },
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                    $width: 900,
                    $maxHeight: 800,
                    $minHeight: 800,
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                            children: [
                                "Reported Marks for ",
                                company.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f0acc19cad702cdf$var$LegendContainer, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f0acc19cad702cdf$var$ReportedMarksLegendItemContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$f734cfedcd7bed10), {
                                            color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                            children: "Dollar-Weighted AVG."
                                        }),
                                        displayedReportedMarksData?.weighted_avg ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f0acc19cad702cdf$var$ColoredText, {
                                            color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400,
                                            children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(displayedReportedMarksData.weighted_avg, 2, 2)
                                        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                            children: "--"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f0acc19cad702cdf$var$ReportedMarksLegendItemContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$f734cfedcd7bed10), {
                                            color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).indigo
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                            children: "Simple AVG."
                                        }),
                                        displayedReportedMarksData?.simple_avg ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f0acc19cad702cdf$var$ColoredText, {
                                            color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).indigo,
                                            children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(displayedReportedMarksData.simple_avg, 2, 2)
                                        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                            children: "--"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f0acc19cad702cdf$var$ReportedMarksLegendItemContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$f734cfedcd7bed10), {
                                            color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).magenta
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                            children: "Median"
                                        }),
                                        displayedReportedMarksData?.median ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f0acc19cad702cdf$var$ColoredText, {
                                            color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).magenta,
                                            children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(displayedReportedMarksData.median, 2, 2)
                                        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                            children: "--"
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                                    children: "Max"
                                                }),
                                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                                    children: " | "
                                                }),
                                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                                    children: "Min"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                                            children: [
                                                displayedReportedMarksData?.max ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                                    children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(displayedReportedMarksData.max, 2, 2)
                                                }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                                    children: "--"
                                                }),
                                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                                    children: " | "
                                                }),
                                                displayedReportedMarksData?.min ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                                    children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(displayedReportedMarksData.min, 2, 2)
                                                }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                                                    children: "--"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2e5a4ca8ae099b29$export$e60a4704009a0009), {
                            width: "100%",
                            height: 250,
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $fb5252d4c65f633c$export$f881f4f9e4007a57), {
                                data: graphData,
                                onMouseMove: onMouseMove,
                                onClick: onClick,
                                margin: {
                                    top: 0,
                                    right: 0,
                                    left: 12,
                                    bottom: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4), {
                                        axisLine: false,
                                        tickLine: false,
                                        fontSize: 14,
                                        domain: [
                                            (dataMin)=>dataMin * 0.98,
                                            (dataMax)=>dataMax * 1.02
                                        ],
                                        orientation: "right",
                                        tickFormatter: (value)=>(0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, 2, 2),
                                        stroke: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ee3eb083333526ae$export$ea77231de273b52d), {
                                        axisLine: false,
                                        tickLine: false,
                                        interval: 0,
                                        fontSize: 14,
                                        tickFormatter: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(value).toFormat("MMM"),
                                        ticks: xAxisTicks,
                                        dataKey: "date",
                                        stroke: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3ece4213e6b51d98$export$6440e27b9f186856), {
                                        vertical: false,
                                        stroke: "rgba(255, 255, 255, 0.05)"
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $54b055b34209fc18$export$ea1a111407f37557), {
                                        type: "monotone",
                                        dataKey: "area",
                                        stroke: "none",
                                        fill: (0, $dfd33cee3229493c$exports.ColorPalette).white15,
                                        connectNulls: true,
                                        activeDot: false
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9c6bfe96f56d0a02$export$28c660c63b792dea), {
                                        content: renderNullTooltip
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $32207b201d0eab60$export$17d680238e50603e), {
                                        type: "monotone",
                                        dataKey: "weighted_avg",
                                        stroke: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400,
                                        strokeWidth: 2,
                                        dot: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9acc68d81edcc52f$export$2e2bcd8739ae039), {
                                            selectedPeriod: selectedPeriod
                                        }),
                                        connectNulls: true,
                                        activeDot: {
                                            r: 6,
                                            strokeWidth: 2,
                                            stroke: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $32207b201d0eab60$export$17d680238e50603e), {
                                        type: "monotone",
                                        dataKey: "simple_avg",
                                        stroke: (0, $78cf78541be2071b$export$29792b0afe15a7ce).indigo,
                                        strokeWidth: 2,
                                        dot: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9acc68d81edcc52f$export$2e2bcd8739ae039), {
                                            selectedPeriod: selectedPeriod
                                        }),
                                        connectNulls: true,
                                        activeDot: {
                                            r: 6,
                                            strokeWidth: 2,
                                            stroke: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $32207b201d0eab60$export$17d680238e50603e), {
                                        type: "monotone",
                                        dataKey: "median",
                                        stroke: (0, $78cf78541be2071b$export$29792b0afe15a7ce).magenta,
                                        strokeWidth: 2,
                                        dot: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9acc68d81edcc52f$export$2e2bcd8739ae039), {
                                            selectedPeriod: selectedPeriod
                                        }),
                                        connectNulls: true,
                                        activeDot: {
                                            r: 6,
                                            strokeWidth: 2,
                                            stroke: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                            columns: $f0acc19cad702cdf$var$UNDERLYING_FUNDS_TABLE_COLUMNS,
                            data: selectedReportedMarksData?.funds || [],
                            emptyTablePlaceholder: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                                $margin: 120,
                                children: "Please select a specific month to see the underlying funds"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                        onClick: props.closeModal,
                        children: "Close"
                    })
                })
            ]
        })
    });
};
$f0acc19cad702cdf$var$ReportedMarksModal.propTypes = {
    closeModal: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $f0acc19cad702cdf$export$2e2bcd8739ae039 = $f0acc19cad702cdf$var$ReportedMarksModal;











const $5b84349b0f4754fa$var$GraphXAxisYearContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
`;
const $5b84349b0f4754fa$var$LegendItemContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50).attrs({
    as: "div"
})`
  display: flex;
  gap: 12px;
  align-items: center;
`;
// Debounce hover tracker by 1 second
const $5b84349b0f4754fa$var$HOVER_INTERACTION_DEBOUNCE_DELAY = 1000;
const $5b84349b0f4754fa$var$hoverCompanyReportedMarksCard = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).hoverCompanyReportedMarksCard, $5b84349b0f4754fa$var$HOVER_INTERACTION_DEBOUNCE_DELAY);
const $5b84349b0f4754fa$var$StyledContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  > :last-child {
    margin-top: 24px;
  }
`;
const $5b84349b0f4754fa$var$ReportedMarksStatsList = ({ min: min, max: max, weightedAvg: weightedAvg, reportPeriod: reportPeriod })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$54c2e3dc7acea9f5), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5b84349b0f4754fa$var$LegendItemContainer, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$f734cfedcd7bed10), {
                                color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400
                            }),
                            "Dollar-Weighted AVG."
                        ]
                    }),
                    weightedAvg ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                        children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(weightedAvg, 2, 2)
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                        children: "--"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5b84349b0f4754fa$var$LegendItemContainer, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$f734cfedcd7bed10), {
                                color: (0, $dfd33cee3229493c$exports.ColorPalette).white15
                            }),
                            "Max | Min"
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                        children: [
                            max ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(max, 2, 2)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: " | "
                            }),
                            min ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(min, 2, 2)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5b84349b0f4754fa$var$LegendItemContainer, {
                        children: "Report period"
                    }),
                    reportPeriod ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                        children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(reportPeriod).toLocaleString({
                            month: "short",
                            year: "numeric"
                        })
                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                        children: "--"
                    })
                ]
            })
        ]
    });
$5b84349b0f4754fa$var$ReportedMarksStatsList.propTypes = {
    min: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    max: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    weightedAvg: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    reportPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
const $5b84349b0f4754fa$var$ReportedMarksCard = ()=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [isModalOpen, setIsModalOpen] = (0, $70fFQ.useState)(false);
    const closeModal = (0, $70fFQ.useCallback)(()=>setIsModalOpen(false), [
        setIsModalOpen
    ]);
    const openModal = (0, $70fFQ.useCallback)(()=>{
        setIsModalOpen(true);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openCompanyReportedMarksModal(company?.name);
    }, [
        company,
        setIsModalOpen
    ]);
    const [hoverStats, setHoverStats] = (0, $70fFQ.useState)(null);
    const reportedMarksQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_REPORTED_MARKS_VALUATION(company.zb_id));
    const reportedMarksData = reportedMarksQuery?.data?.data;
    const graphData = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(reportedMarksData, (d, date)=>({
                ...d,
                date: date,
                area: [
                    d.min,
                    d.max
                ]
            })).reverse(), [
        reportedMarksData
    ]);
    const xAxisTicks = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(graphData, "date"), [
        graphData
    ]);
    const startDate = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).first(xAxisTicks), [
        xAxisTicks
    ]);
    const endDate = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).last(xAxisTicks), [
        xAxisTicks
    ]);
    // Set hover point data
    const onMouseMove = (0, $70fFQ.useCallback)((d)=>{
        if (!graphData) return;
        $5b84349b0f4754fa$var$hoverCompanyReportedMarksCard(company?.name, d.activeLabel);
        const hoveredMark = graphData[d.activeTooltipIndex];
        setHoverStats({
            ...hoveredMark,
            report_period: d.activeLabel,
            index: d.activeTooltipIndex
        });
    }, [
        graphData,
        company?.name
    ]);
    // Remove hover stats on mouse leave
    const onMouseLeave = (0, $70fFQ.useCallback)(()=>setHoverStats(null), []);
    // Identical shape to hoverStats, used to display default legend value if no bar is being hovered
    const lastPeriodStats = (0, $70fFQ.useMemo)(()=>{
        const validData = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter(graphData, (d)=>d.weighted_avg);
        const lastPeriodData = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).last(validData);
        return {
            ...lastPeriodData,
            report_period: lastPeriodData?.date,
            index: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(validData) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).size(validData) - 1
        };
    }, [
        graphData
    ]);
    const displayStats = (0, $70fFQ.useMemo)(()=>hoverStats || lastPeriodStats || null, [
        hoverStats,
        lastPeriodStats
    ]);
    // The active dot on the <Line /> component requires a tooltip to be enabled
    // So we pass in a null tooltip function as a hack
    const renderNullTooltip = (0, $70fFQ.useCallback)(()=>null, []);
    if (companyIsLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(reportedMarksData)) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Reported Marks",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5b84349b0f4754fa$var$StyledContent, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$757b1a5dfccb9b1d), {
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                        $margin: 48,
                        children: "Data not available"
                    })
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5b84349b0f4754fa$var$ReportedMarksStatsList, {})
            ]
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Reported Marks",
        headerTrailingContent: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ActionChip), {
            text: "Full data",
            leadingIcon: (0, $dfd33cee3229493c$exports.GridIcon),
            onClick: openModal
        }),
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5b84349b0f4754fa$var$StyledContent, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2e5a4ca8ae099b29$export$e60a4704009a0009), {
                        width: "100%",
                        minHeight: 108,
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $fb5252d4c65f633c$export$f881f4f9e4007a57), {
                            data: graphData,
                            onMouseMove: onMouseMove,
                            onMouseLeave: onMouseLeave,
                            margin: {
                                top: 0,
                                right: 10,
                                left: 10,
                                bottom: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4), {
                                    domain: [
                                        (dataMin)=>dataMin * 0.98,
                                        (dataMax)=>dataMax * 1.02
                                    ],
                                    hide: true
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ee3eb083333526ae$export$ea77231de273b52d), {
                                    axisLine: false,
                                    tickLine: false,
                                    interval: 0,
                                    fontSize: 11,
                                    tickFormatter: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(value).toFormat("MMM"),
                                    ticks: xAxisTicks,
                                    dataKey: "date",
                                    stroke: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $54b055b34209fc18$export$ea1a111407f37557), {
                                    type: "monotone",
                                    dataKey: "area",
                                    stroke: "none",
                                    fill: (0, $dfd33cee3229493c$exports.ColorPalette).white15,
                                    connectNulls: true,
                                    activeDot: false
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9c6bfe96f56d0a02$export$28c660c63b792dea), {
                                    content: renderNullTooltip
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $32207b201d0eab60$export$17d680238e50603e), {
                                    type: "monotone",
                                    dataKey: "weighted_avg",
                                    stroke: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500,
                                    strokeWidth: 2,
                                    dot: (0, $3ae1a3cadebbaa5e$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500, displayStats.index),
                                    connectNulls: true,
                                    activeDot: {
                                        r: 6,
                                        strokeWidth: 2,
                                        stroke: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5b84349b0f4754fa$var$GraphXAxisYearContainer, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption1theme50, {
                                children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(startDate).year
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption1theme50, {
                                children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(endDate).year
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5b84349b0f4754fa$var$ReportedMarksStatsList, {
                        min: displayStats?.min,
                        max: displayStats?.max,
                        weightedAvg: displayStats?.weighted_avg,
                        reportPeriod: displayStats?.report_period
                    })
                ]
            }),
            isModalOpen && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f0acc19cad702cdf$export$2e2bcd8739ae039), {
                closeModal: closeModal
            })
        ]
    });
};
var $5b84349b0f4754fa$export$2e2bcd8739ae039 = $5b84349b0f4754fa$var$ReportedMarksCard;


var $6d0b58065a03cb25$export$2e2bcd8739ae039 = (0, $5b84349b0f4754fa$export$2e2bcd8739ae039);





var $70fFQ = parcelRequire("70fFQ");








var $hI4Hx = parcelRequire("hI4Hx");


/**
 * Convert a number into a bucketed number (e.g: 11mn => 10mn - 25mn).
 * This has some similarities to ``convert_total_value_bucketed``
 *
 * @param {number} numRaw - the number to be converted
 * @param {number} precision - optional argument to specify number of decimal places
 * @returns {string} bucket value representation of num
 */ const $93597109349c7d49$var$convertTotalValueBucketed = (numRaw, precision)=>{
    const num = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isString(numRaw) ? Number.parseFloat(numRaw) : numRaw;
    let bucketString = `>$${(0, $ae4651a71cdb6522$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).last((0, $753b8dcbe6be17f9$export$a1a0d48d479bd8d4)), precision)}`;
    // eslint-disable-next-line consistent-return
    (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).forEach((0, $753b8dcbe6be17f9$export$a1a0d48d479bd8d4), (bucketValue, index)=>{
        if (num < bucketValue) {
            bucketString = index ? `$${(0, $ae4651a71cdb6522$export$2e2bcd8739ae039)((0, $753b8dcbe6be17f9$export$a1a0d48d479bd8d4)[index - 1], precision)} - ` + `$${(0, $ae4651a71cdb6522$export$2e2bcd8739ae039)(bucketValue, precision)}` : `<$${(0, $ae4651a71cdb6522$export$2e2bcd8739ae039)(bucketValue, precision)}`;
            return false;
        }
    });
    return bucketString;
};
var $93597109349c7d49$export$2e2bcd8739ae039 = $93597109349c7d49$var$convertTotalValueBucketed;


const $6637df40dcad5da3$var$StyledSubtitle = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding-bottom: 16px;
`;
const $6637df40dcad5da3$var$StyledButtonContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 16px;
`;
const $6637df40dcad5da3$var$SECURITY_TYPE_CHOICES = {
    11: "Common",
    12: "Preferred"
};
const $6637df40dcad5da3$var$STRUCTURE_CHOICES = {
    1: "Derivative",
    2: "Direct",
    3: "SPV"
};
const $6637df40dcad5da3$var$SOURCE_TYPE_RUMORED = 200;
const $6637df40dcad5da3$var$INITIAL_TABLE_SIZE = 5;
const $6637df40dcad5da3$var$EMPTY_VALUE_PLACEHOLDER = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
    children: "--"
});
const $6637df40dcad5da3$var$columns = [
    {
        id: "structure",
        header: "Structure",
        accessor: (transactionRecord)=>({
                structure: transactionRecord.structure,
                source_type: transactionRecord.source_type
            }),
        width: 170,
        cellRenderer: ({ value: value })=>{
            if (!value.structure) return $6637df40dcad5da3$var$EMPTY_VALUE_PLACEHOLDER;
            // We're using "Uncomfirmed" copy since "Rumored" is non-compliant
            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                children: [
                    $6637df40dcad5da3$var$STRUCTURE_CHOICES[value.structure],
                    value.source_type == $6637df40dcad5da3$var$SOURCE_TYPE_RUMORED && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                        children: "\xa0Unconfirmed"
                    })
                ]
            });
        }
    },
    {
        id: "date",
        header: "Close Date",
        accessor: (transactionRecord)=>transactionRecord.closing_date || transactionRecord.noticed_date,
        width: 140,
        cellRenderer: (0, $dfd33cee3229493c$exports.DateCell),
        // using default DateCell dateFormatter causes off-by-one-day error
        dateFormatter: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(value).toFormat("M/dd/yyyy")
    },
    {
        id: "price",
        header: "Price",
        accessor: "price_per_share",
        width: 120,
        cellRenderer: (0, $dfd33cee3229493c$exports.CurrencyCell)
    },
    {
        id: "size",
        header: "Size",
        accessor: "total_value",
        width: 140,
        cellRenderer: ({ value: value })=>(0, $93597109349c7d49$export$2e2bcd8739ae039)(value, 0)
    },
    {
        id: "security",
        header: "Security",
        accessor: "security_type",
        width: 140,
        cellRenderer: ({ value: value })=>value ? $6637df40dcad5da3$var$SECURITY_TYPE_CHOICES[value] : $6637df40dcad5da3$var$EMPTY_VALUE_PLACEHOLDER
    },
    {
        id: "rofr_percent",
        header: "ROFR%",
        accessor: (transactionRecord)=>{
            if (transactionRecord.rofr_value && transactionRecord.total_value) return 100 * (transactionRecord.rofr_value / transactionRecord.total_value);
        },
        width: 90,
        cellRenderer: (0, $dfd33cee3229493c$exports.PercentageCell),
        precision: 0
    }
];
const $6637df40dcad5da3$var$ClosedTransactionsCard = ()=>{
    const [isShowingMore, setIsShowingMore] = (0, $70fFQ.useState)(false);
    const { id: companyId } = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const transactionRecordSort = (a, b)=>{
        const dateA = a.closing_date || a.noticed_date;
        const dateB = b.closing_date || b.noticed_date;
        if (!dateA || dateA < dateB) return 1;
        if (!dateB || dateA > dateB) return -1;
        return 0;
    };
    // large page size so that we can get everything in one page
    const transactionRecords = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).TRANSACTION_RECORDS(), {
        company: companyId,
        "page[size]": 100000
    });
    const transactionRecordsData = transactionRecords?.cleanedData?.data;
    const sortedTransactionRecordsData = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useMemo(()=>transactionRecordsData?.sort(transactionRecordSort), [
        transactionRecordsData
    ]);
    // ZX-15151: transactionRecordsData is undefined while loading — this line
    // runs before the loading/error early-returns below.
    const numberOfRows = isShowingMore ? (transactionRecordsData || []).length : $6637df40dcad5da3$var$INITIAL_TABLE_SIZE;
    if (transactionRecords.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Closed transactions",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6637df40dcad5da3$var$StyledSubtitle, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30, {
                    children: "Data is collected from the ZXData Partners network"
                })
            }),
            "Loading..."
        ]
    });
    if (!transactionRecordsData || transactionRecords.isError) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Closed transactions",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "An error has occurred."
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        title: "Closed transactions",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6637df40dcad5da3$var$StyledSubtitle, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30, {
                    children: "Data is collected from the ZXData Partners network"
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
                theme: {
                    tableStyles: (0, $88e99f4c2bd06374$export$80ac8f7dc189db5f)
                },
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                        data: sortedTransactionRecordsData.slice(0, numberOfRows),
                        columns: $6637df40dcad5da3$var$columns
                    }),
                    sortedTransactionRecordsData.length > $6637df40dcad5da3$var$INITIAL_TABLE_SIZE && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6637df40dcad5da3$var$StyledButtonContainer, {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                            buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                            onClick: ()=>{
                                setIsShowingMore(!isShowingMore);
                            },
                            children: isShowingMore ? "Show fewer" : "Show more"
                        })
                    })
                ]
            })
        ]
    });
};
var $6637df40dcad5da3$export$2e2bcd8739ae039 = $6637df40dcad5da3$var$ClosedTransactionsCard;





parcelRequire("70fFQ");







const $6d36351144df98c3$var$StyledCardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 16px;
`;
const $6d36351144df98c3$var$formatWebsiteUrl = (rawUrl)=>rawUrl ? rawUrl.replace("http://", "").replace("www.", "") : "";
const $6d36351144df98c3$var$AboutCard = ()=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const sectorQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_SECTORS(), {
        company: company?.zb_id
    }, {
        enabled: Boolean(company?.zb_id)
    });
    if (companyIsLoading || sectorQuery.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: "About",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "Loading..."
        })
    });
    if (!company || sectorQuery.isError) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).TITLE,
        title: "About",
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "An error has occurred."
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Card), {
        title: "About",
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).PADDED,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6d36351144df98c3$var$StyledCardContent, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                    children: company.description
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$54c2e3dc7acea9f5), {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                    children: "Legal Name"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                    children: company.legal_name || company.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                    children: "Headquarters"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                    children: company.headquarters
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                    children: "Sectors"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                    children: (sectorQuery.cleanedData?.data || []).map((sector)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                                            children: sector.name
                                        }, `sector_${sector.name}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                    children: "Website"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                        onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateToCompanyWebsite(company.name, company.url),
                                        url: company.url,
                                        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                                        children: $6d36351144df98c3$var$formatWebsiteUrl(company.url)
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $6d36351144df98c3$export$2e2bcd8739ae039 = $6d36351144df98c3$var$AboutCard;




var $hI4Hx = parcelRequire("hI4Hx");


var $70fFQ = parcelRequire("70fFQ");





var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");









const $6d21304585ee404b$var$StyledCardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  width: 368px;
  box-sizing: border-box;
  text-align: left;
  gap: 16px;

  > :last-child {
    text-align: right;
  }
`;
const $6d21304585ee404b$var$StyledInputPrompt = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30)`
  white-space: nowrap;
`;
const $6d21304585ee404b$var$debouncedModifyPricePerShare = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((companyName, previousValue, newValue)=>{
    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyCustomPricePerShareField(companyName, previousValue, newValue);
}, (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a), {
    leading: false,
    trailing: true
});
const $6d21304585ee404b$var$debouncedModifyImpliedValue = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((companyName, previousValue, newValue)=>{
    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).modifyCustomValuationField(companyName, previousValue, newValue);
}, (0, $753b8dcbe6be17f9$export$3b574867feb0ac0a), {
    leading: false,
    trailing: true
});
const $6d21304585ee404b$var$numberFormatter = (value)=>Number((0, $9cd630fd213df404$export$2e2bcd8739ae039)(value, 6));
const $6d21304585ee404b$var$PostMoneyCalculatorDropdown = ({ latestFundingRound: latestFundingRound, latestOrderFlow: latestOrderFlow })=>{
    const [disclaimerModalShowing, setDisclaimerModalShowing] = (0, $70fFQ.useState)(false);
    const [isInitialLoad, setIsInitialLoad] = (0, $70fFQ.useState)(true);
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [pricePerShare, setPricePerShare] = (0, $70fFQ.useState)(null);
    const [impliedValue, setImpliedValue] = (0, $70fFQ.useState)(null);
    // Two fields used for accurate mixpanel reporting.
    const [previousPricePerShare, setPreviousPricePerShare, _setPreviousPricePerShare] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(null);
    const [previousImpliedValue, setPreviousImpliedValue, _setPreviousImpliedValue] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(null);
    const outstandingShares = (0, $70fFQ.useMemo)(()=>latestFundingRound ? latestFundingRound.postmoney_valuation / latestFundingRound.price_per_share : null, [
        latestFundingRound
    ]);
    const valuationFromZXIndexValue = (0, $70fFQ.useMemo)(()=>{
        if (!outstandingShares || !latestOrderFlow?.zx_index_value) return null;
        return outstandingShares * latestOrderFlow.zx_index_value;
    }, [
        latestOrderFlow,
        outstandingShares
    ]);
    (0, $70fFQ.useEffect)(()=>{
        // We must handle this logic in a useEffect to pre-load the latest funding round's values
        // because the API fetches are async and we need to set the initial values of the fields, but we
        // do not want the fields to be reset whenever they become null, so we can't just set them
        // conditionally if they're null, we need an extra variable.
        // Note that we're skipping the debounce logic for the 'previous' values since we want this
        // initial load to be snappy.
        if (isInitialLoad && latestOrderFlow && valuationFromZXIndexValue) {
            setIsInitialLoad(false);
            setPricePerShare($6d21304585ee404b$var$numberFormatter(latestOrderFlow.zx_index_value));
            _setPreviousPricePerShare($6d21304585ee404b$var$numberFormatter(latestOrderFlow.zx_index_value));
            setImpliedValue($6d21304585ee404b$var$numberFormatter(valuationFromZXIndexValue) / (0, $753b8dcbe6be17f9$export$58a5337423702f7c));
            _setPreviousImpliedValue($6d21304585ee404b$var$numberFormatter(valuationFromZXIndexValue) / (0, $753b8dcbe6be17f9$export$58a5337423702f7c));
        }
    }, [
        _setPreviousImpliedValue,
        _setPreviousPricePerShare,
        latestOrderFlow,
        valuationFromZXIndexValue,
        isInitialLoad
    ]);
    if (companyIsLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6d21304585ee404b$var$StyledCardContent, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "Loading..."
        })
    });
    if (!company) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6d21304585ee404b$var$StyledCardContent, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "An error has occurred."
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6d21304585ee404b$var$StyledCardContent, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                children: [
                    "Calculate a custom post-money valuation or price per share based on",
                    " ",
                    latestFundingRound?.event,
                    " at ",
                    (0, $66339e7a022e68c9$export$736d072c44caa715)(latestFundingRound?.price_per_share),
                    "/share."
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Field), {
                type: "number",
                name: "price_per_share",
                placeholder: "Price / share",
                trailingIcon: ()=>pricePerShare !== null ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6d21304585ee404b$var$StyledInputPrompt, {
                        children: "Price / share"
                    }) : null,
                leadingIcon: (0, $dfd33cee3229493c$exports.DollarIcon),
                onChange: (e)=>{
                    if (e.target.value === "") {
                        $6d21304585ee404b$var$debouncedModifyPricePerShare(company.name, previousPricePerShare, null);
                        setPreviousPricePerShare(null);
                        setPricePerShare(null);
                        setImpliedValue(null); // Cast an empty conversion to empty input.
                    } else {
                        $6d21304585ee404b$var$debouncedModifyPricePerShare(company.name, previousPricePerShare, e.target.value);
                        setPreviousPricePerShare(e.target.value);
                        setPricePerShare(e.target.value);
                        const impliedValuation = outstandingShares ? outstandingShares * e.target.value : null;
                        setImpliedValue($6d21304585ee404b$var$numberFormatter(impliedValuation / (0, $753b8dcbe6be17f9$export$58a5337423702f7c)));
                    }
                },
                value: pricePerShare
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Field), {
                type: "number",
                name: "valuation",
                placeholder: "Valuation (billions)",
                trailingIcon: ()=>impliedValue !== null ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6d21304585ee404b$var$StyledInputPrompt, {
                        children: "Valuation (billions)"
                    }) : null,
                leadingIcon: (0, $dfd33cee3229493c$exports.DollarIcon),
                onChange: (e)=>{
                    if (e.target.value === "") {
                        $6d21304585ee404b$var$debouncedModifyImpliedValue(company.name, previousImpliedValue, null);
                        setPreviousImpliedValue(null);
                        setImpliedValue(null);
                        setPricePerShare(null); // Cast an empty conversion to empty input.
                    } else {
                        $6d21304585ee404b$var$debouncedModifyImpliedValue(company.name, previousImpliedValue, e.target.value);
                        setPreviousImpliedValue(e.target.value);
                        setImpliedValue(e.target.value);
                        const impliedPPS = outstandingShares ? e.target.value * (0, $753b8dcbe6be17f9$export$58a5337423702f7c) / outstandingShares : null;
                        setPricePerShare($6d21304585ee404b$var$numberFormatter(impliedPPS));
                    }
                },
                value: impliedValue
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                onClick: ()=>{
                    setDisclaimerModalShowing(true);
                },
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30, {
                    children: "View disclaimer"
                })
            }),
            disclaimerModalShowing && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $b503a24c9cb99895$export$2e2bcd8739ae039), {
                onClose: ()=>setDisclaimerModalShowing(false)
            })
        ]
    });
};
$6d21304585ee404b$var$PostMoneyCalculatorDropdown.propTypes = {
    latestFundingRound: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        event: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        postmoney_valuation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        price_per_share: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired,
    latestOrderFlow: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        zx_index_value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        total_volume: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    }).isRequired
};
var $6d21304585ee404b$export$2e2bcd8739ae039 = $6d21304585ee404b$var$PostMoneyCalculatorDropdown;



const $9501f6de946a3a51$var$convertRelativeRankingToString = (value)=>{
    switch(value){
        case 24:
            return "Bottom 25%";
        case 49:
            return "Bottom 50%";
        case 54:
            return "Top 50%";
        case 59:
            return "Top 45%";
        case 64:
            return "Top 40%";
        case 69:
            return "Top 35%";
        case 74:
            return "Top 30%";
        case 79:
            return "Top 25%";
        case 84:
            return "Top 20%";
        case 89:
            return "Top 15%";
        case 94:
            return "Top 10%";
        case 97:
            return "Top 5%";
        case 98:
            return "Top 2%";
        case 99:
            return "Top 1%";
        default:
            return "N/A";
    }
};
var $9501f6de946a3a51$export$2e2bcd8739ae039 = $9501f6de946a3a51$var$convertRelativeRankingToString;








const $7dab3f73260568e2$var$Container = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 16px 0;
  border-top: ${(0, $f5879f76b7a709cc$export$4d0a7f76ad443516)};
  border-bottom: ${(0, $f5879f76b7a709cc$export$4d0a7f76ad443516)};
`;
const $7dab3f73260568e2$var$ONE_MILLION = 1000000;
const $7dab3f73260568e2$var$FundingRoundContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80).attrs({
    as: "div"
})`
  max-width: 65%;
  display: flex;
  align-items: center;
`;
const $7dab3f73260568e2$var$CompanyHighLevelStats = ()=>{
    const [company, isLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    // Latest Order Flow
    const latestOrderFlowReportQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_LATEST_ORDER_FLOW(), {
        time_frame: (0, $753b8dcbe6be17f9$export$e15589d55377682c),
        id: company?.zb_id
    }, {
        enabled: Boolean(company.zb_id)
    });
    const latestOrderFlowReport = (0, $70fFQ.useMemo)(()=>latestOrderFlowReportQuery?.cleanedData?.data?.[0], [
        latestOrderFlowReportQuery
    ]);
    // Latest Funding Round
    const latestFundingRoundQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).FUNDING_ROUNDS(), {
        company: company.zb_id,
        "page[size]": 1
    });
    const latestFundingRound = (0, $70fFQ.useMemo)(()=>latestFundingRoundQuery?.cleanedData?.data?.[0], [
        latestFundingRoundQuery
    ]);
    // Latest Valid Reported Mark
    const reportedMarksQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_REPORTED_MARKS_VALUATION(company.zb_id));
    const reportedMarksData = (0, $70fFQ.useMemo)(()=>reportedMarksQuery?.data?.data, [
        reportedMarksQuery
    ]);
    const reportedMarksWithDate = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(reportedMarksData, (data, date)=>({
                date: date,
                ...data
            })), [
        reportedMarksData
    ]);
    const validReportedMarks = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter(reportedMarksWithDate, (d)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(d.weighted_avg)), [
        reportedMarksWithDate
    ]);
    const latestReportedMark = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).first(validReportedMarks), [
        validReportedMarks
    ]);
    // Used only for the Relative Rankings stat
    const headerStatsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).HEADER_STATS(company.zb_id), {
        time_frame: (0, $753b8dcbe6be17f9$export$c1c27e297fdb3d7e),
        ordering: "-report_period",
        "page[size]": 1
    });
    // ZX-15173: standalone HD served a processed header-stats shape
    // ({relative_ranking: {current}}); the monolith endpoint returns a plain
    // JSON:API report list, so read ranking_total_interest off the latest
    // monthly report instead.
    const ranking = (0, $70fFQ.useMemo)(()=>headerStatsQuery?.data?.data?.[0]?.attributes?.ranking_total_interest, [
        headerStatsQuery
    ]);
    const [customPostmoneyValuationDropdown, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6d21304585ee404b$export$2e2bcd8739ae039), {
            latestFundingRound: latestFundingRound,
            latestOrderFlow: latestOrderFlowReport
        }));
    /**
   * Handle the cases for funding round display individually for maximum specificity + the flattest
   * possible DOM rendering.
   */ const latestFundingRoundDisplay = (0, $70fFQ.useMemo)(()=>{
        const roundName = latestFundingRound?.security || latestFundingRound?.event;
        if (!latestFundingRound || !roundName && !latestFundingRound.date) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
            children: "--"
        });
        if (!roundName && latestFundingRound.date) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
            children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(latestFundingRound.date).toLocaleString()
        });
        if (roundName && !latestFundingRound.date) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7dab3f73260568e2$var$FundingRoundContainer, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.TruncatedText), {
                children: roundName
            })
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($7dab3f73260568e2$var$FundingRoundContainer, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.TruncatedText), {
                    children: roundName
                }),
                "\xa0(",
                (0, $86d2f3987cc9d604$exports.DateTime).fromISO(latestFundingRound.date).toLocaleString(),
                ")"
            ]
        });
    }, [
        latestFundingRound
    ]);
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($7dab3f73260568e2$var$Container, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$54c2e3dc7acea9f5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "ZX Index Value (Current)"
                            }),
                            latestOrderFlowReport?.zx_index_value ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(latestOrderFlowReport.zx_index_value, 2, 2)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "ZX Index Value (Trailing)"
                            }),
                            latestOrderFlowReport?.zx_index_value_trailing ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(latestOrderFlowReport.zx_index_value_trailing, 2, 2)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: [
                                    "Reported marks (",
                                    latestReportedMark ? (0, $86d2f3987cc9d604$exports.DateTime).fromISO(latestReportedMark.date).toLocaleString({
                                        month: "short",
                                        year: "numeric"
                                    }) : "--",
                                    ")"
                                ]
                            }),
                            latestReportedMark?.weighted_avg ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(latestReportedMark.weighted_avg, 2, 2)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$54c2e3dc7acea9f5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "Last funding round price"
                            }),
                            latestFundingRound?.price_per_share ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(latestFundingRound.price_per_share, 2, 2)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "Last funding round"
                            }),
                            latestFundingRoundDisplay
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: [
                                    "Post money valuation",
                                    latestFundingRound && latestFundingRound.postmoney_valuation && latestFundingRound.price_per_share && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                                        children: [
                                            "\xa0(",
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                                ref: dropdownRef,
                                                onClick: ()=>{
                                                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).toggleCustomEnterpriseValuationCalculator(company.name, !customPostmoneyValuationDropdown);
                                                    toggleDropdown();
                                                },
                                                children: "Custom"
                                            }),
                                            ")",
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.PageSection), {
                                                children: customPostmoneyValuationDropdown
                                            })
                                        ]
                                    })
                                ]
                            }),
                            latestFundingRound?.postmoney_valuation ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: [
                                    "$",
                                    (0, $ae4651a71cdb6522$export$2e2bcd8739ae039)(latestFundingRound.postmoney_valuation, 2)
                                ]
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$54c2e3dc7acea9f5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "Volume"
                            }),
                            latestOrderFlowReport?.total_volume ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: [
                                    "$",
                                    (0, $ae4651a71cdb6522$export$2e2bcd8739ae039)(latestOrderFlowReport.total_volume * $7dab3f73260568e2$var$ONE_MILLION, 0)
                                ]
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "Bid / Offer ratio"
                            }),
                            latestOrderFlowReport?.bid_ask_ratio ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(latestOrderFlowReport.bid_ask_ratio * 100, 0)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$a7b06bfba60a8a78), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                children: "Ranking"
                            }),
                            ranking ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                children: (0, $9501f6de946a3a51$export$2e2bcd8739ae039)(ranking)
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "--"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7dab3f73260568e2$export$2e2bcd8739ae039 = $7dab3f73260568e2$var$CompanyHighLevelStats;




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");











const $b53dd0b8a7e7857d$var$StyledDropdownContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin: -16px 0;
  min-width: 360px;

  > :first-child {
    overflow-y: auto;
    max-height: 400px;
    margin-top: 12px;
  }
`;
const $b53dd0b8a7e7857d$var$StyledHorizontalRule = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).hr`
  border: none;
  border-bottom: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  margin-top: 12px;
`;
const $b53dd0b8a7e7857d$var$StyledPortfolioListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  padding: 8px 12px;
  box-sizing: border-box;
`;
const $b53dd0b8a7e7857d$var$TruncatedPortfolioName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.TruncatedText))`
  max-width: 200px;
  ${(0, $dfd33cee3229493c$exports.body1)}
  ${({ $deEmphasize: $deEmphasize })=>$deEmphasize ? (0, $dfd33cee3229493c$exports.FontColors).theme30 : (0, $dfd33cee3229493c$exports.FontColors).theme80}
  // Unfortunately we have to rewrite some of the yuka hyperlink styling here because we've
  // used truncated text within a hyperlink.
  &:hover {
    text-decoration: underline;
  }
`;
const $b53dd0b8a7e7857d$var$StyledCreatePortfolioButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039))`
  margin: 12px;
`;
const $b53dd0b8a7e7857d$var$AddToPortfolioDropdown = ({ source: source, openCreatePortfolioModal: openCreatePortfolioModal })=>{
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const addCompanyToPortfolio = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_COMPANIES(), false, {
        message: `${company?.name} added to portfolio`
    });
    const portfolioQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIOS());
    const portfolios = (0, $70fFQ.useMemo)(()=>{
        return portfolioQuery.isSuccess && !portfolioQuery.isRefetching ? portfolioQuery.cleanedData.data : [];
    }, [
        portfolioQuery.isSuccess,
        portfolioQuery.isRefetching,
        portfolioQuery.cleanedData
    ]);
    const [portfoliosWithThisCompany, portfolioContainingCompanyIsLoading] = (0, $ba149842d65eafb2$export$2e2bcd8739ae039)(company?.zb_id);
    if (companyIsLoading || portfolioQuery.isLoading || portfolioContainingCompanyIsLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($b53dd0b8a7e7857d$var$StyledDropdownContainer, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($b53dd0b8a7e7857d$var$StyledPortfolioListItem, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                children: "Loading..."
            })
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($b53dd0b8a7e7857d$var$StyledDropdownContainer, {
        children: [
            portfolios.length > 0 && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                        children: portfolios.map((portfolio)=>{
                            const alreadyInPortfolio = Boolean(portfoliosWithThisCompany.find((portfolioCompany)=>portfolioCompany.portfolio[1] === portfolio.apiId));
                            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($b53dd0b8a7e7857d$var$StyledPortfolioListItem, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).INVISIBLE,
                                        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                                        onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateToPortfolioProfile("company profile - add to portfolio", portfolio.apiId, portfolio.name),
                                        url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIO(portfolio.apiId),
                                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($b53dd0b8a7e7857d$var$TruncatedPortfolioName, {
                                            $deEmphasize: alreadyInPortfolio,
                                            children: portfolio.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ActionChip), {
                                        disabled: alreadyInPortfolio,
                                        leadingIconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500,
                                        leadingIcon: alreadyInPortfolio ? (0, $dfd33cee3229493c$exports.CheckIcon) : (0, $dfd33cee3229493c$exports.PlusIcon),
                                        onClick: ()=>{
                                            addCompanyToPortfolio.mutate({
                                                portfolio: portfolio.apiId,
                                                company: company.zb_id
                                            });
                                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addCompanyToPortfolio(source, portfolio.apiId, company.name);
                                        },
                                        text: alreadyInPortfolio ? "Added" : "Add"
                                    })
                                ]
                            }, portfolio.apiId);
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($b53dd0b8a7e7857d$var$StyledHorizontalRule, {})
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($b53dd0b8a7e7857d$var$StyledCreatePortfolioButton, {
                onClick: openCreatePortfolioModal,
                icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                children: "New portfolio"
            })
        ]
    });
};
$b53dd0b8a7e7857d$var$AddToPortfolioDropdown.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    openCreatePortfolioModal: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $b53dd0b8a7e7857d$export$2e2bcd8739ae039 = $b53dd0b8a7e7857d$var$AddToPortfolioDropdown;




var $70fFQ = parcelRequire("70fFQ");


/*
 * Using a company, provide a useful object of booleans that indicate the level of access
 * the user has to the company's data.
 *
 * `hasAnyAccess` is true when the user has any per-user `can_*` permission OR when the
 * company itself exposes data via its `show_order_flow_data` / `show_reported_marks_data`
 * flags. The per-company flags act as a baseline gate so that publicly-available data
 * (e.g. order flow on companies marked show_order_flow_data=true) renders the profile
 * even when the user has no explicit access records.
 */ const $063f7f1279c82c38$var$useCompanyAccess = (company)=>{
    const companyId = company?.zb_id;
    const hasProDataAccessQueryInfo = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).HAS_PRO_DATA_ACCESS(companyId), {}, {
        retryOnMount: false,
        enabled: Boolean(companyId)
    });
    const showOrderFlowData = Boolean(company?.show_order_flow_data);
    const showReportedMarksData = Boolean(company?.show_reported_marks_data);
    return (0, $70fFQ.useMemo)(()=>{
        const companyHasVisibleData = showOrderFlowData || showReportedMarksData;
        if (hasProDataAccessQueryInfo.isLoading || hasProDataAccessQueryInfo.isError || !hasProDataAccessQueryInfo.cleanedData) return {
            canDownloadPDFReport: false,
            canDownloadZXData: false,
            canViewBidAskPriceGraph: false,
            canViewBidAskRatioGraph: false,
            canViewPriceAndVolumeGraph: false,
            canViewRelativeActivityGraph: false,
            canViewReportedMarksGraph: false,
            canViewSacraDocuments: false,
            canViewClosedTransactions: false,
            isLoading: hasProDataAccessQueryInfo.isLoading,
            isError: hasProDataAccessQueryInfo.isError,
            // Honor the per-company baseline gate even when the access query is
            // unavailable — otherwise public data (show_order_flow_data=true) is
            // hidden during loading/error/empty states.
            hasAnyAccess: companyHasVisibleData,
            timeFrame: null
        };
        const hasAnyCanFlag = Object.keys(hasProDataAccessQueryInfo.cleanedData).filter((key)=>key.startsWith("can_")).some((key)=>hasProDataAccessQueryInfo.cleanedData[key]);
        return {
            canDownloadPDFReport: hasProDataAccessQueryInfo.cleanedData.can_download_pdf_report,
            canDownloadZXData: hasProDataAccessQueryInfo.cleanedData.can_download_zx_data,
            canViewBidAskPriceGraph: hasProDataAccessQueryInfo.cleanedData.can_view_bid_ask_price_graph,
            canViewBidAskRatioGraph: hasProDataAccessQueryInfo.cleanedData.can_view_bid_ask_ratio_graph,
            canViewPriceAndVolumeGraph: hasProDataAccessQueryInfo.cleanedData.can_view_price_and_volume_graph,
            canViewRelativeActivityGraph: hasProDataAccessQueryInfo.cleanedData.can_view_relative_activity_graph,
            canViewReportedMarksGraph: hasProDataAccessQueryInfo.cleanedData.can_view_reported_marks_graph,
            canViewSacraDocuments: hasProDataAccessQueryInfo.cleanedData.can_view_sacra_documents,
            canViewClosedTransactions: hasProDataAccessQueryInfo.cleanedData.can_view_closed_transactions,
            isLoading: hasProDataAccessQueryInfo.isLoading,
            isError: hasProDataAccessQueryInfo.isError,
            hasAnyAccess: hasAnyCanFlag || companyHasVisibleData,
            timeFrame: hasProDataAccessQueryInfo.cleanedData.time_frame
        };
    }, [
        hasProDataAccessQueryInfo,
        showOrderFlowData,
        showReportedMarksData
    ]);
};
var $063f7f1279c82c38$export$2e2bcd8739ae039 = $063f7f1279c82c38$var$useCompanyAccess;












var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");








/**
 * Modal to create a new portfolio or rename an existing one.
 *
 * @param source - Mixpanel source.
 * @param {function} onClose - Function to close the modal
 * @param {object} portfolio - Portfolio object to rename, if null, a new portfolio will be created
 * @param {boolean} navigateOnSuccess - If true, navigate to the new portfolio's profile on success
 * @param {object} company - Optional company object to add to the new portfolio upon successful
 *    creation, so the portfolio doesn't start out empty. Should not be provided if renaming a
 *    portfolio, and will not be added in this case.
 * @return {JSX.Element}
 */ const $53819f53b665196a$var$CreatePortfolioModal = ({ source: source, onClose: onClose, portfolio: portfolio, navigateOnSuccess: navigateOnSuccess, company: company })=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const createPortfolioQuery = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIOS(), false, {
        message: "Portfolio created"
    });
    const addCompanyToPortfolio = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_COMPANIES(), false, {
        message: `${company?.name} added to portfolio`
    });
    const editPortfolioQuery = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_DETAIL(portfolio?.apiId), true, {
        invalidateUrls: [
            {
                url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIOS(),
                queryParams: {}
            }
        ]
    });
    const initialValues = (0, $70fFQ.useMemo)(()=>portfolio ? {
            name: portfolio.name
        } : {}, [
        portfolio
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (!portfolio) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openAddNewPortfolioModal(source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
        initialValues: initialValues,
        onSubmit: (values)=>{
            if (portfolio) editPortfolioQuery.mutate(values, {
                onSuccess: ()=>{
                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).renamePortfolio(source, portfolio.apiId, portfolio.name, values.name);
                    onClose();
                }
            });
            else createPortfolioQuery.mutate(values, {
                onSuccess: (response)=>{
                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addNewPortfolio(source, response.data.data.id, response.data.data.attributes.name);
                    if (company && company.zb_id) {
                        addCompanyToPortfolio.mutate({
                            portfolio: response.data.data.id,
                            company: company.zb_id
                        });
                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addCompanyToPortfolio(source, response.data.data.id, response.data.data.attributes.name, company.name, true);
                    }
                    if (navigateOnSuccess) navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIO(response.data.data.id));
                    onClose();
                }
            });
        },
        children: ({ handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Modal), {
                modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
                onClose: onClose,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                                    children: portfolio ? "Rename your portfolio" : "Set up your new portfolio"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                                    ref: (element)=>{
                                        if (element) element.focus();
                                    },
                                    name: "name",
                                    label: "Portfolio name",
                                    placeholder: "Name your portfolio"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                    onClick: onClose,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    type: "submit",
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                    children: portfolio ? "Save" : "Create"
                                })
                            ]
                        })
                    ]
                })
            })
    });
};
$53819f53b665196a$var$CreatePortfolioModal.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    navigateOnSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    portfolio: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        apiId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }),
    company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        zb_id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
$53819f53b665196a$var$CreatePortfolioModal.defaultProps = {
    source: null,
    navigateOnSuccess: true,
    company: null,
    portfolio: null
};
var $53819f53b665196a$export$2e2bcd8739ae039 = $53819f53b665196a$var$CreatePortfolioModal;










var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




const $df89a5c3c3d7019c$var$StyledHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80).attrs({
    as: "div"
})`
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
  padding: 24px;
`;
const $df89a5c3c3d7019c$var$StyledModalContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $39796339e90eaa03$export$81645ce662b26656))`
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface2};
  gap: 8px;
`;
const $df89a5c3c3d7019c$var$StyledModal = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Modal))`
  width: 800px;
  ${(0, $dfd33cee3229493c$exports.body1)};
  line-height: 1.5;

  ol {
    list-style: decimal inside;
  }

  ul {
    list-style: disc inside;
  }

  ol,
  ul {
    margin: 16px 0;
    padding: 0;

    li {
      padding-left: 16px;
    }
  }
`;
const $df89a5c3c3d7019c$var$StyledParagraph = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80)`
  line-height: 1.5;
`;
const $df89a5c3c3d7019c$var$RobustnessScoreModal = ({ onClose: onClose, source: source })=>{
    (0, $70fFQ.useEffect)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openRobustnessScoreModal(source);
    }, [
        source
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($df89a5c3c3d7019c$var$StyledModal, {
        onClose: onClose,
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($df89a5c3c3d7019c$var$StyledHeader, {
                children: "Robustness Score"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($df89a5c3c3d7019c$var$StyledModalContent, {
                $maxHeight: 400,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($df89a5c3c3d7019c$var$StyledParagraph, {
                    children: [
                        "The ZXData Robustness Score is a proprietary algorithm developed by Zanbato to objectively assess the confidence levels in the ZX Index Value for different private companies. This score is calculated on a scale of 1 to 10 and is based on several key metrics, which provide an indication of the reliability of the price signals for a given company. These metrics include:",
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("ol", {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Number of executed trades and buy and sell orders: Companies with a higher number of executed trades and submitted orders tend to receive a higher Robustness Score. This suggests that more trading activity and order flow contribute to a greater level of confidence in the company's secondary trading price data."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Age of the closed transactions and buy and sell orders: The age of the transactions and orders is also taken into account. More recent transactions and orders may contribute to a higher score, as they reflect more up-to-date market activity."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Total volume of closed transactions and buy and sell orders: Greater volume of trading activity typically leads to a higher Robustness Score, as it indicates greater market participation and liquidity."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "The spread between bid and offer price: A narrower spread between the bid and offer price may contribute to a higher score, as it suggests a more efficient and liquid market."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Symmetry of the orderbook: Companies with more balanced and two-sided order books are generally awarded higher Robustness Scores. Conversely, companies with order books that are skewed toward one side (either bids or offers) are considered less reliable in providing price signals."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                            children: "Here's how the scores are typically interpreted:"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Score of 2 and below: Companies with fewer than 3 orders on either side of the market."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Score of 3-4: Companies with 3-5 orders on each side of the market or a more asymmetric orderbook with 5+ orders. Most companies with scores of 3 or 4 do not have recently executed trades in the data set."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Score of 5: Typically indicates at least one executed trade or a more balanced orderbook, but with no recently executed trades."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Score of 6 or greater: Usually includes at least one executed trade in the data set, with some edge cases reflecting a deep orderbook of 10+ orders on both sides of the market."
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("li", {
                                    children: "Score of 7 and above: Reflect deeper order books as well as multiple executed trades, indicating a higher level of confidence in the price data."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    onClick: onClose,
                    children: "Close"
                })
            })
        ]
    });
};
$df89a5c3c3d7019c$var$RobustnessScoreModal.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $df89a5c3c3d7019c$export$2e2bcd8739ae039 = $df89a5c3c3d7019c$var$RobustnessScoreModal;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



const $84254fef690e4dc9$var$ZXIndexValueModal = ({ onClose: onClose, source: source })=>{
    (0, $70fFQ.useEffect)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openZXIndexValueModal(source);
    }, [
        source
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        title: "ZX Index Value",
        onClose: onClose,
        cancelText: "Close",
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                $width: 800,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                        children: "ZX Index Value"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("p", {
                        children: "ZX Index Value is an internally developed metric that reflects secondary trading prices for private companies using an algorithmic approach based on the prices sourced from ZX and ZXData partners. The algorithm used to calculate ZX Index Values incorporates both executed transaction prices and current bid and ask pricing. As such, ZX Index Value provides a better representation of current market conditions versus closed prices given there is usually a 30\u201345-day lag between the time that a transaction gets matched and the time when it is fully executed."
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("p", {
                        children: "The algorithm is developed by incorporating metrics such as executed prices, inside market prices, and size of transactions. Executed transactions are consistently given the highest weighting in the ZX Index Value, followed by non-executed prices. Inside market prices see higher weightings than bids and offers further down the orderbook, as they consider current market conditions. Institutionally sized transactions are weighted above smaller transactions in the ZX Index Value. In addition, half-lives are calculated for all ZX Index Value inputs. Empirically, time decays typically see a substantial drop-off after two weeks."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                    onClick: onClose,
                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                    children: "Close"
                })
            })
        ]
    });
};
$84254fef690e4dc9$var$ZXIndexValueModal.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $84254fef690e4dc9$export$2e2bcd8739ae039 = $84254fef690e4dc9$var$ZXIndexValueModal;


const $4bbc60df02440f0f$var$FloatingHeaderContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: center;
  background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface1};
  z-index: ${(0, $dfd33cee3229493c$exports.Z_INDEXES).zIndexExtraVisible};
  width: 100%;
  transition: transform 0.3s ease-in-out;
  border-top: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  border-bottom: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  ${(props)=>props.$open ? (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          transform: translateY(16px);
        ` : (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          transform: translateY(-100%);
        `}
`;
const $4bbc60df02440f0f$var$FloatingDropdownAttachmentDiv = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  transform: translateY(-52px);
`;
const $4bbc60df02440f0f$var$StyledIconButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.IconButton))`
  margin-left: 12px;
`;
const $4bbc60df02440f0f$var$FloatingHeaderContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  height: 64px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;

  > :first-child {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
  }

  > :last-child {
    display: flex;
    align-items: center;
  }
`;
const $4bbc60df02440f0f$var$StyledCompanyHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $4bbc60df02440f0f$var$StyledHorizontalRule = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).hr`
  border: none;
  border-bottom: ${(0, $f5879f76b7a709cc$export$4d0a7f76ad443516)};
`;
const $4bbc60df02440f0f$var$StyledName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  height: 46px;
  justify-content: space-between;

  > :first-child {
    display: flex;
    gap: 16px;
  }

  > :last-child {
    display: flex;
    align-items: center;
  }
`;
const $4bbc60df02440f0f$var$StyledPricingInformation = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > :first-child {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
const $4bbc60df02440f0f$var$StyledFont40 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  font-size: 40px;
`;
const $4bbc60df02440f0f$var$StyledFont30 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  font-size: 30px;
`;
const $4bbc60df02440f0f$var$StyledIndexValueCaption = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const $4bbc60df02440f0f$var$StyledThumbnail = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Thumbnail))`
  border-radius: 12px;
`;
const $4bbc60df02440f0f$var$MIXPANEL_SOURCE = "company profile";
const $4bbc60df02440f0f$var$StyledCompanyName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80).attrs({
    as: "div"
})``;
const $4bbc60df02440f0f$var$StyledLegalName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30).attrs({
    as: "div"
})``;
const $4bbc60df02440f0f$var$ZX_INDEX_VALUE_MODAL = "ZX_INDEX_VALUE_MODAL";
const $4bbc60df02440f0f$var$ROBUSTNESS_MODAL = "ROBUSTNESS_MODAL";
const $4bbc60df02440f0f$var$CREATE_PORTFOLIO_MODAL = "CREATE_PORTFOLIO_MODAL";
const $4bbc60df02440f0f$var$ZX_INDEX_VALUE_TOOLTIP_TEXT = "A custom metric derived from our proprietary algorithm blending transacted prices with open bids and offers.";
const $4bbc60df02440f0f$var$ROBUSTNESS_SCORE_TOOLTIP_TEXT = "A score ranging from 1-10 to objectively assess the confidence levels in the ZX Index Value for different companies. Key metrics that make up the Robustness Score include recency of orders and total volume.";
/**
 * Company profile header has 2 modes, floating and not floating. The floating version has
 * less information and spans the full page. It should only appear after the user has scrolled
 * beyond the point in the page that the non-floating header is no longer visible.
 *
 * @param floating
 * @param hidden
 * @return {JSX.Element}
 * @constructor
 */ const $4bbc60df02440f0f$var$CompanyProfileHeader = ({ floating: floating, hidden: hidden })=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const mixpanelSource = floating && !hidden ? (0, $753b8dcbe6be17f9$export$a08762b44f24cd2) : (0, $753b8dcbe6be17f9$export$89ba74fd97633d5b);
    const [isDownloading, setIsDownloading] = (0, $70fFQ.useState)(false);
    const [modalShowing, setModalShowing] = (0, $70fFQ.useState)(null);
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [latestOrderFlow, latestOrderFlowLoading] = (0, $f54bc4a73753e281$export$2e2bcd8739ae039)(company?.zb_id);
    const zxIndexValueRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const zxIndexValueTooltip = (0, $dfd33cee3229493c$exports.useTooltip)(zxIndexValueRef, /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("b", {
                children: "ZX Index Value"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("p", {
                children: [
                    $4bbc60df02440f0f$var$ZX_INDEX_VALUE_TOOLTIP_TEXT,
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.HyperLink), {
                        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).INVISIBLE,
                        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).BUTTON,
                        onClick: ()=>setModalShowing($4bbc60df02440f0f$var$ZX_INDEX_VALUE_MODAL),
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("u", {
                                children: "Click to learn more."
                            })
                        ]
                    })
                ]
            })
        ]
    }));
    const robustnessScoreRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const robustnessScoreTooltip = (0, $dfd33cee3229493c$exports.useTooltip)(robustnessScoreRef, /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("b", {
                children: "Robustness Score"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("p", {
                children: [
                    $4bbc60df02440f0f$var$ROBUSTNESS_SCORE_TOOLTIP_TEXT,
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.HyperLink), {
                        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).INVISIBLE,
                        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).BUTTON,
                        onClick: ()=>setModalShowing($4bbc60df02440f0f$var$ROBUSTNESS_MODAL),
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("u", {
                                children: "Click to learn more."
                            })
                        ]
                    })
                ]
            })
        ]
    }));
    const showingZXIndexValueTooltip = Boolean(zxIndexValueTooltip);
    (0, $70fFQ.useEffect)(()=>{
        if (showingZXIndexValueTooltip) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openCompanyProfileTooltip(mixpanelSource, "zx index value");
    }, [
        mixpanelSource,
        showingZXIndexValueTooltip
    ]);
    const showingRobustness = Boolean(robustnessScoreTooltip);
    (0, $70fFQ.useEffect)(()=>{
        if (showingRobustness) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openCompanyProfileTooltip(mixpanelSource, "robustness score");
    }, [
        mixpanelSource,
        showingRobustness
    ]);
    const { hasAnyAccess: hasAnyAccess, canDownloadZXData: canDownloadZXData, timeFrame: timeFrame } = (0, $063f7f1279c82c38$export$2e2bcd8739ae039)(company);
    const watchlistQueryInfo = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES());
    const watchlistDelete = (0, $fd1e6894b991baa0$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES(), {
        silent: true
    });
    const watchlistUpdate = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).WATCHLIST_COMPANIES(), false, {
        silent: true
    });
    const isWatchlisted = (0, $70fFQ.useMemo)(()=>watchlistQueryInfo.isSuccess && !companyIsLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).filter(watchlistQueryInfo.cleanedData, {
            company: company?.zb_id
        }).length : false, [
        watchlistQueryInfo,
        company,
        companyIsLoading
    ]);
    const zxIndexValueDisplay = (0, $70fFQ.useMemo)(()=>{
        let FontComponent = floating ? (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment : $4bbc60df02440f0f$var$StyledFont30;
        if (latestOrderFlowLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme50, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(FontComponent, {
                children: "Loading..."
            })
        });
        if (!latestOrderFlow || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(latestOrderFlow[0]?.zx_index_price)) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme50, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(FontComponent, {
                children: "This week's ZX Index Value not available"
            })
        });
        FontComponent = floating ? (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment : $4bbc60df02440f0f$var$StyledFont40;
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
            ref: zxIndexValueRef,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(FontComponent, {
                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(latestOrderFlow[0]?.zx_index_price, 2, 2)
            })
        });
    }, [
        latestOrderFlowLoading,
        latestOrderFlow,
        floating
    ]);
    const previousValueDisplay = (0, $70fFQ.useMemo)(()=>{
        if (latestOrderFlowLoading || !latestOrderFlow) return null;
        const [currentOrderFlow, previousOrderFlow] = latestOrderFlow;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(currentOrderFlow?.zx_index_price) || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(previousOrderFlow?.zx_index_price) || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(currentOrderFlow.zx_index_value_percent_change)) return null;
        const percentageChange = Number(currentOrderFlow.zx_index_value_percent_change);
        const difference = Number(currentOrderFlow.zx_index_price) - Number(previousOrderFlow.zx_index_price);
        const FontComponent = floating ? (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment : $4bbc60df02440f0f$var$StyledFont30;
        if (percentageChange > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1buy, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)(FontComponent, {
                children: [
                    "+",
                    (0, $66339e7a022e68c9$export$365988f95ba9ba73)(difference, 2, 2),
                    "(+",
                    (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange * 100),
                    ")"
                ]
            })
        });
        if (percentageChange < 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1sell, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)(FontComponent, {
                children: [
                    "-",
                    (0, $66339e7a022e68c9$export$365988f95ba9ba73)(Math.abs(difference), 2, 2),
                    "(",
                    (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange * 100),
                    ")"
                ]
            })
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)(FontComponent, {
                children: [
                    "+",
                    (0, $66339e7a022e68c9$export$365988f95ba9ba73)(difference, 2, 2),
                    "(+",
                    (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange * 100),
                    ")"
                ]
            })
        });
    }, [
        latestOrderFlow,
        latestOrderFlowLoading,
        floating
    ]);
    const reportPeriodDisplay = (0, $70fFQ.useMemo)(()=>{
        if (latestOrderFlowLoading || !latestOrderFlow || !latestOrderFlow[0]?.report_period || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(latestOrderFlow[0]?.zx_index_price)) return null;
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
            children: [
                "ZX Index Value as of ",
                (0, $86d2f3987cc9d604$exports.DateTime).fromISO(latestOrderFlow[0].report_period).toLocaleString()
            ]
        });
    }, [
        latestOrderFlowLoading,
        latestOrderFlow
    ]);
    const robustnessDisplay = (0, $70fFQ.useMemo)(()=>{
        if (latestOrderFlowLoading || !latestOrderFlow || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(latestOrderFlow[0]?.robustness) || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(latestOrderFlow[0]?.zx_index_price)) return null;
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bb0ef5dcd8e37d29$export$2e2bcd8739ae039), {
            ref: robustnessScoreRef,
            score: latestOrderFlow[0]?.robustness
        });
    }, [
        latestOrderFlowLoading,
        latestOrderFlow
    ]);
    const [addToPortfolioDropdown, dropdownRef, toggleAddToPortfolioDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $b53dd0b8a7e7857d$export$2e2bcd8739ae039), {
            source: mixpanelSource,
            openCreatePortfolioModal: ()=>setModalShowing($4bbc60df02440f0f$var$CREATE_PORTFOLIO_MODAL)
        }));
    const [actionsMenu, menuRef, toggleAdditionalActionsMenu] = (0, $dfd33cee3229493c$exports.useAnchoredMenu)({
        menuItems: [
            {
                key: "watchlist",
                text: isWatchlisted ? "Remove from Watchlist" : "Add to Watchlist",
                iconColor: isWatchlisted ? (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500 : (0, $dfd33cee3229493c$exports.ColorPalette).white50,
                icon: isWatchlisted ? (0, $dfd33cee3229493c$exports.BookmarkFilledIcon) : (0, $dfd33cee3229493c$exports.BookmarkIcon),
                onClick: ()=>{
                    if (isWatchlisted) {
                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).removeCompanyFromWatchlist(mixpanelSource, company?.name);
                        watchlistDelete.mutate({
                            id: company?.zb_id
                        });
                    } else {
                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addCompanyToWatchlist(mixpanelSource, company?.name);
                        watchlistUpdate.mutate({
                            company: company?.zb_id
                        });
                    }
                }
            },
            canDownloadZXData ? {
                key: "download",
                text: "Download ZXData (XLS)",
                icon: (0, $dfd33cee3229493c$exports.DownloadIcon),
                onClick: ()=>{
                    setIsDownloading(true);
                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).downloadXlsSpreadsheet(mixpanelSource);
                    (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).get((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).DOWNLOAD_ZXDATA(company?.zb_id), {
                        params: {
                            time_frame: timeFrame
                        },
                        responseType: "blob"
                    }).then(()=>{
                        dispatch({
                            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                            message: "Your ZXData Report is being generated, please check your email in a couple of minutes for receipt of the report."
                        });
                    }).catch(()=>{
                        dispatch({
                            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                            message: "Failed to download ZXData Report. Please try again or contact support."
                        });
                    }).finally(()=>{
                        setIsDownloading(false);
                    });
                }
            } : null
        ].filter(Boolean)
    });
    (0, $70fFQ.useEffect)(()=>{
        // Just a bit of cleanup to automatically close the dropdown if the user scrolls into a region
        // of the screen where a floating header is no longer showing.
        if (floating && hidden && addToPortfolioDropdown) toggleAddToPortfolioDropdown();
        if (floating && hidden && actionsMenu) toggleAdditionalActionsMenu();
    }, [
        floating,
        hidden,
        addToPortfolioDropdown,
        toggleAddToPortfolioDropdown,
        actionsMenu,
        toggleAdditionalActionsMenu
    ]);
    if (floating) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($4bbc60df02440f0f$var$FloatingHeaderContainer, {
        $open: !hidden,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($4bbc60df02440f0f$var$FloatingHeaderContent, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$StyledThumbnail, {
                                src: company.main_picture,
                                size: "40px"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                                children: company?.name
                            }),
                            zxIndexValueDisplay,
                            previousValueDisplay,
                            robustnessDisplay,
                            zxIndexValueTooltip,
                            robustnessScoreTooltip
                        ]
                    }),
                    hasAnyAccess && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                onClick: toggleAddToPortfolioDropdown,
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                leadingIcon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                children: "Add to portfolio"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$FloatingDropdownAttachmentDiv, {
                                ref: dropdownRef
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$StyledIconButton, {
                                onClick: toggleAdditionalActionsMenu,
                                buttonStyle: (0, $dfd33cee3229493c$exports.IconButtonStyles).RAISED,
                                icon: (0, $dfd33cee3229493c$exports.DotsVerticalIcon)
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$FloatingDropdownAttachmentDiv, {
                                ref: menuRef
                            })
                        ]
                    })
                ]
            }),
            hasAnyAccess && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
                theme: {
                    surfaceLevel: 2
                },
                children: [
                    addToPortfolioDropdown,
                    actionsMenu
                ]
            }),
            modalShowing === $4bbc60df02440f0f$var$CREATE_PORTFOLIO_MODAL && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $53819f53b665196a$export$2e2bcd8739ae039), {
                source: $4bbc60df02440f0f$var$MIXPANEL_SOURCE,
                navigateOnSuccess: false,
                onClose: ()=>setModalShowing(null)
            }),
            modalShowing === $4bbc60df02440f0f$var$ROBUSTNESS_MODAL && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $df89a5c3c3d7019c$export$2e2bcd8739ae039), {
                source: $4bbc60df02440f0f$var$MIXPANEL_SOURCE,
                onClose: ()=>setModalShowing(null)
            }),
            modalShowing === $4bbc60df02440f0f$var$ZX_INDEX_VALUE_MODAL && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $84254fef690e4dc9$export$2e2bcd8739ae039), {
                source: $4bbc60df02440f0f$var$MIXPANEL_SOURCE,
                onClose: ()=>setModalShowing(null)
            }),
            isDownloading && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {})
        ]
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($4bbc60df02440f0f$var$StyledCompanyHeader, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($4bbc60df02440f0f$var$StyledName, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$StyledThumbnail, {
                                src: company.main_picture,
                                size: "46px"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$StyledCompanyName, {
                                        children: company.name
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$StyledLegalName, {
                                        children: company.legal_name
                                    })
                                ]
                            })
                        ]
                    }),
                    hasAnyAccess && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                id: "add-company-to-portfolio-button",
                                ref: dropdownRef,
                                onClick: toggleAddToPortfolioDropdown,
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                leadingIcon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                children: "Add to portfolio"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                                ref: menuRef,
                                onClick: toggleAdditionalActionsMenu,
                                buttonStyle: (0, $dfd33cee3229493c$exports.IconButtonStyles).RAISED,
                                icon: (0, $dfd33cee3229493c$exports.DotsVerticalIcon)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($4bbc60df02440f0f$var$StyledPricingInformation, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            zxIndexValueDisplay,
                            previousValueDisplay
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($4bbc60df02440f0f$var$StyledIndexValueCaption, {
                        children: [
                            reportPeriodDisplay,
                            Boolean(reportPeriodDisplay) && Boolean(robustnessDisplay) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme30, {
                                children: "|"
                            }),
                            robustnessDisplay,
                            zxIndexValueTooltip,
                            robustnessScoreTooltip
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4bbc60df02440f0f$var$StyledHorizontalRule, {}),
            hasAnyAccess && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
                theme: {
                    surfaceLevel: 2
                },
                children: [
                    addToPortfolioDropdown,
                    actionsMenu
                ]
            }),
            modalShowing === $4bbc60df02440f0f$var$CREATE_PORTFOLIO_MODAL && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $53819f53b665196a$export$2e2bcd8739ae039), {
                source: $4bbc60df02440f0f$var$MIXPANEL_SOURCE,
                navigateOnSuccess: false,
                company: company,
                onClose: ()=>setModalShowing(null)
            }),
            modalShowing === $4bbc60df02440f0f$var$ROBUSTNESS_MODAL && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $df89a5c3c3d7019c$export$2e2bcd8739ae039), {
                source: $4bbc60df02440f0f$var$MIXPANEL_SOURCE,
                onClose: ()=>setModalShowing(null)
            }),
            modalShowing === $4bbc60df02440f0f$var$ZX_INDEX_VALUE_MODAL && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $84254fef690e4dc9$export$2e2bcd8739ae039), {
                source: $4bbc60df02440f0f$var$MIXPANEL_SOURCE,
                onClose: ()=>setModalShowing(null)
            }),
            isDownloading && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {})
        ]
    });
};
$4bbc60df02440f0f$var$CompanyProfileHeader.propTypes = {
    floating: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
var $4bbc60df02440f0f$export$2e2bcd8739ae039 = $4bbc60df02440f0f$var$CompanyProfileHeader;




var $70fFQ = parcelRequire("70fFQ");

var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");
/**
 * @fileOverview Line Chart
 */ 




var $d86fd0d5243d41f1$export$54d0e8420ac838ac = (0, $0b69b3fe5a85f3bb$export$77871aede60e6838)({
    chartName: 'LineChart',
    GraphicalChild: (0, $32207b201d0eab60$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $ee3eb083333526ae$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $2b3288d276a160b8$export$ece7de1383db5ac)
});






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");

/**
 * This is a factory specifically to use as the `activeBar` prop passed into a recharts `Bar`
 * component. The factory returns a component to render a highlighted bar when the user hovers over
 * it in the company profile line graph, when displaying a volume indicator.
 *
 * `dataKey` will be used to fish the correct chart data value out of the hover state, to know if
 *    the user is hovering specifically the bar or just somewhere in the graph.
 * `barIndex` will be used to determine necessary y-offset to add to the y-value. We space our
 *    bars with 2 pixels of vertical padding between them, so the more bars we stack, the more
 *    additional spacing we need.
 */ const $09f8ecdf3f34b551$var$ActiveVolumeBar = (dataKey, color, barIndex)=>{
    const Bar = ({ x: x, y: y, width: width, height: height, ...props })=>{
        return props[dataKey] ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c0f721a3b6bafaa4$export$4617fb02663045ef), {
            fill: color,
            x: x,
            y: y - 2 * barIndex,
            width: width,
            height: height
        }) : null;
    };
    Bar.propTypes = {
        x: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
    };
    return Bar;
};
var $09f8ecdf3f34b551$export$2e2bcd8739ae039 = $09f8ecdf3f34b551$var$ActiveVolumeBar;




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");






var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");


const $7ded616a721e70ef$var$StyledToggleableIcon = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).button`
  position: relative;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 0 solid transparent;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex-grow: 0;
  flex-shrink: 0;
  outline: none;
  margin: 0;
  padding: 0;
`;
/**
 * Displays an icon from props as a clickable element; similar to but visually different than
 * Yuka IconButton.
 *
 * @param {object} props
 *
 * @returns {React.Element}
 */ const $7ded616a721e70ef$var$ToggleableIcon = (props)=>{
    const [iconColor, setIconColor] = (0, $70fFQ.useState)((0, $dfd33cee3229493c$exports.ColorPalette).white30);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7ded616a721e70ef$var$StyledToggleableIcon, {
        onClick: props.onClick,
        disabled: props.disabled,
        onMouseOver: ()=>setIconColor((0, $dfd33cee3229493c$exports.ColorPalette).white80),
        onMouseLeave: ()=>setIconColor((0, $dfd33cee3229493c$exports.ColorPalette).white30),
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(props.icon, {
            size: props.size,
            color: iconColor
        })
    });
};
$7ded616a721e70ef$var$ToggleableIcon.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
};
$7ded616a721e70ef$var$ToggleableIcon.defaultProps = {
    size: 16,
    disabled: false,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
};
var $7ded616a721e70ef$export$2e2bcd8739ae039 = $7ded616a721e70ef$var$ToggleableIcon;



/**
 * Helper to get the dot indicating the hover position of a line on the company profile line chart.
 *
 * @param chartElement - An object with a `color` property that is a string.
 * @return {object}
 */ const $4b44dbac5b3e4d6a$var$getActiveDot = (chartElement)=>({
        stroke: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface0,
        fill: chartElement.color,
        strokeWidth: 2,
        r: 6
    });
var $4b44dbac5b3e4d6a$export$2e2bcd8739ae039 = $4b44dbac5b3e4d6a$var$getActiveDot;



var $hI4Hx = parcelRequire("hI4Hx");

/**
 * Combines the public security quotes and pre-IPO orderflow data into a single data set.
 *
 * @param {Array} postIPOData
 * @param {Array} preIPOData
 * @returns {object}
 */ const $49bdb570b3c546c8$var$combinePublicAndPreIPOData = (postIPOData, preIPOData)=>{
    // Masquerade private company orderflow data as public security quotes.
    const mappedPreIPOData = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(preIPOData, ({ zx_index_price: closePrice, report_period: date })=>({
            close_price: closePrice,
            date: date,
            is_market_closed_day: false
        }));
    let finalPreIPODataWithWhitespace = [];
    // Populate the data with "whitespace" data points to fill in the gaps between the pre-IPO
    // data points. We take orderflow reports on a weekly basis, but public security quotes are
    // collected daily. We want lightweight charts to keep our x-axis scale consistent, so we
    // make recently IPO'd companies' data look like it's always been public.
    (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).forEach(mappedPreIPOData, (dataPoint, index)=>{
        const nextDataPoint = mappedPreIPOData[index + 1];
        finalPreIPODataWithWhitespace.push(dataPoint);
        let nextDate = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(dataPoint.date).minus({
            days: 1
        });
        while(nextDataPoint && nextDate > (0, $86d2f3987cc9d604$exports.DateTime).fromISO(nextDataPoint.date)){
            finalPreIPODataWithWhitespace.push({
                date: nextDate.toISODate()
            });
            nextDate = nextDate.minus({
                days: 1
            });
        }
    });
    const combined = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).sortedUniqBy((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).orderBy([
        ...postIPOData,
        ...finalPreIPODataWithWhitespace
    ], [
        "date"
    ], [
        "desc"
    ]), "date");
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(combined) ? {} : combined;
};
var $49bdb570b3c546c8$export$2e2bcd8739ae039 = $49bdb570b3c546c8$var$combinePublicAndPreIPOData;



var $hI4Hx = parcelRequire("hI4Hx");

var $hI4Hx = parcelRequire("hI4Hx");


/**
 * Creates slices of the provided timeseries data corresponding to the length of data needed
 * for each selectable date range on the superchart (3 months, 6 months, 1 year, YTD, 2 years).
 *
 * `data` is 2 years of price data in descending order such that the 0th element is from today,
 * that way the function will return an object of this form:
 *
 * {
 *   3M: data[0:i]
 *   6M: data[0:j]
 *   1Y: data[0:k]
 *   YTD: data[0:l]
 *   2Y: data
 * } where `i` is the index that takes us to the data point from 3 months ago, j is 6mo, etc.
 *
 * @param {Array<object>} data - an array of raw price data
 * @param {string} dateKey - the name of the date field in the data elements
 * @returns {object} dateDividedData - splices of `data` as described above
 */ const $81fd4db69ef7496a$var$getDateDividedData = (data, dateKey)=>{
    // find indices of the rawPriceData array that correspond to the first data points in
    // the chartable data for last 3 months, 6 months, 1 year, and YTD.
    const cutOffIndices = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).mapValues((0, $cd95af98ccabe80c$export$a9864fdcc39cd433), (startDate)=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).findIndex(data, (datum)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(datum[dateKey]) < startDate);
        // findIndex returns -1 when the item isn't found; in these cases we want all the data
        return index === -1 ? data.length : index;
    });
    return {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).mapValues(cutOffIndices, (index)=>data.slice(0, index)),
        [(0, $cd95af98ccabe80c$export$6f4aa2efcb73a5b2)]: data
    };
};
var $81fd4db69ef7496a$export$2e2bcd8739ae039 = $81fd4db69ef7496a$var$getDateDividedData;



var $hI4Hx = parcelRequire("hI4Hx");

const $c0f2959292915645$var$nullOrFloat = (value)=>value === null ? null : parseFloat(value);
/**
 * Makes a timeseries array that is used to draw a line on the superchart.
 *
 * This function accepts API price data and makes an array of `dataPoint` objects:
 * { time, absolute, percent }; `time` is an ISO datestring, `absolute` is the $ value at `time`,
 * and `percent` is the % change of absolute from the first/earliest `absolute` in the array.
 *
 * @param {Array<object>} data - an array of raw price data
 * @param {string} dateKey - the name of the date field in the data elements
 * @param {string} valueKey - the name of the price value field in the data elements
 * @param {Array<string>} additionalDataKeys - names of fields that we also want in the timeseries
 * @param {object} config - optional config object
 * @returns {Array<object>} [dataPoint] - a dataPoint is a { time, absolute, percent } object
 */ const $c0f2959292915645$var$makePriceDataTimeSeries = (data, dateKey, valueKey, additionalDataKeys = [], { castDateTimeToDate: castDateTimeToDate, isVolume: isVolume } = {
    castDateTimeToDate: false,
    isVolume: false
})=>{
    // the last data point is the earliest in time; drop empty data until we have a real start point
    const cleanData = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).dropRightWhile(data, (datum)=>!datum?.[valueKey]);
    const startValue = parseFloat((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).last(cleanData)?.[valueKey]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).reverse((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(cleanData, (datum, i)=>{
        // We preserve whitespace points.
        const isWhiteSpace = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEqual(Object.keys(datum), [
            dateKey
        ]);
        // Will conveniently only apply to public market data. We'll use this flag to ignore
        // values that would be computed as NaN.
        const isMarketClosedDay = datum?.is_market_closed_day;
        const time = castDateTimeToDate ? (0, $86d2f3987cc9d604$exports.DateTime).fromISO(datum[dateKey]).toISODate() : datum[dateKey];
        if (isWhiteSpace || isMarketClosedDay) return {
            time: time
        };
        if (isVolume) return {
            time: time,
            total: $c0f2959292915645$var$nullOrFloat(datum.total_volume),
            bid: $c0f2959292915645$var$nullOrFloat(datum.bid_volume),
            offer: $c0f2959292915645$var$nullOrFloat(datum.ask_volume),
            // for each additional data key, add a { key: datum[key] } property to the timeseries
            ...(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).zipObject(additionalDataKeys, (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(additionalDataKeys, (key)=>datum[key]))
        };
        if (datum[valueKey] === null) return {
            time: time,
            absolute: null,
            percent: null,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).zipObject(additionalDataKeys, (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(additionalDataKeys, (key)=>datum[key]))
        };
        return {
            time: time,
            absolute: parseFloat(datum[valueKey]),
            percent: i === cleanData.length - 1 ? 0 : (parseFloat(datum[valueKey]) - startValue) / startValue * 100,
            // for each additional data key, add a { key: datum[key] } property to the timeseries
            ...(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).zipObject(additionalDataKeys, (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(additionalDataKeys, (key)=>datum[key]))
        };
    }));
};
var $c0f2959292915645$export$2e2bcd8739ae039 = $c0f2959292915645$var$makePriceDataTimeSeries;



const $b4bc42725e344a04$var$makeSuperchartData = (rawPriceData, seriesType)=>{
    const { TIME_FIELD: TIME_FIELD, PRICE_DATA_FIELD: PRICE_DATA_FIELD, ADDITIONAL_DATA_FIELDS: ADDITIONAL_DATA_FIELDS, config: config } = (0, $cd95af98ccabe80c$export$f94889ddc23788b0)[seriesType];
    const dateDividedData = (0, $81fd4db69ef7496a$export$2e2bcd8739ae039)(rawPriceData, TIME_FIELD);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).mapValues(dateDividedData, (dataSeries)=>(0, $c0f2959292915645$export$2e2bcd8739ae039)(dataSeries, TIME_FIELD, PRICE_DATA_FIELD, ADDITIONAL_DATA_FIELDS, config));
};
var $b4bc42725e344a04$export$2e2bcd8739ae039 = $b4bc42725e344a04$var$makeSuperchartData;



var $hI4Hx = parcelRequire("hI4Hx");



/**
 * This function creates all the indicator timeseries data for the key company in the form:
 *
 * {
 *   [indicator1]: {
 *     3M: [dataPoint],
 *     6M: ...,
 *     ...
 *   },
 *   [indicator2]: {
 *     ...
 *   },
 *   ...
 * }
 *
 * @param {Array<object>} rawPriceData - an array of raw price data
 * @param {Array<object>} monthlyVolumeAggregateData - an array of monthly volume data
 * @returns {Array<object>} superchartData - maps superchart date ranges to price data timeseries
 */ const $09a2297481aa74e0$var$makeAllIndicatorData = (rawPriceData, monthlyVolumeAggregateData)=>{
    const { TIME_FIELD: TIME_FIELD } = (0, $cd95af98ccabe80c$export$f94889ddc23788b0)[0, $cd95af98ccabe80c$export$affb72ae61a3e7b4];
    const dateDividedData = (0, $81fd4db69ef7496a$export$2e2bcd8739ae039)(rawPriceData, TIME_FIELD);
    const dateDividedVolumeData = (0, $81fd4db69ef7496a$export$2e2bcd8739ae039)(monthlyVolumeAggregateData, TIME_FIELD);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).mapValues((0, $cd95af98ccabe80c$export$f8502645f74d42f8), ({ apiDataKey: apiDataKey, isVolume: isVolume })=>{
        // Special case where we need to pull from `monthlyVolumeAggregateData` instead.
        // return _.mapValues()
        return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).mapValues(isVolume ? dateDividedVolumeData : dateDividedData, (dataSeries)=>(0, $c0f2959292915645$export$2e2bcd8739ae039)(dataSeries, TIME_FIELD, apiDataKey, [], {
                isVolume: isVolume
            }));
    });
};
var $09a2297481aa74e0$export$2e2bcd8739ae039 = $09a2297481aa74e0$var$makeAllIndicatorData;



var $hI4Hx = parcelRequire("hI4Hx");
const $0c153f15ec244d80$var$COMPARISON_COLORS = [
    // Set 1
    "#A60683",
    "#D63CB4",
    "#FF82E3",
    "#EAB6DE",
    "#E4CFE0",
    // Set 2
    "#1D4CC3",
    "#346DFF",
    "#6B8BDE",
    "#8290B4",
    // Set 3
    "#964800",
    "#C86912",
    "#FF993C",
    "#615D00",
    "#A6A80B",
    "#FFFA79",
    "#E5E4BE"
];
const $0c153f15ec244d80$var$makeRandomColorPicker = (colorSet)=>{
    let remainingColors = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).cloneDeep(colorSet);
    return ()=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).random(0, remainingColors.length - 1);
        const ret = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).pullAt(remainingColors, [
            index
        ])[0];
        if (remainingColors.length === 0) remainingColors = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).cloneDeep(colorSet);
        return ret;
    };
};
var $0c153f15ec244d80$export$2e2bcd8739ae039 = $0c153f15ec244d80$var$makeRandomColorPicker($0c153f15ec244d80$var$COMPARISON_COLORS);


const $dbdfce0a002f831e$var$getAbsoluteIndicatorValue = (id, indicatorDataPoint)=>({
        [id]: indicatorDataPoint.absolute
    });
var $dbdfce0a002f831e$export$2e2bcd8739ae039 = $dbdfce0a002f831e$var$getAbsoluteIndicatorValue;



var $hI4Hx = parcelRequire("hI4Hx");


var $70fFQ = parcelRequire("70fFQ");
/**
 * Helper to find the non-whitespace data point whose `time` field matches the given `date`.
 * Returns undefined if there is no non-whitespace element at `time`. Whitespace objects are
 * objects with only 1 key: `time`, or objects where `obj[dataKey]` is `null`.
 *
 * @param data - Array of chart data.
 * @param date - ISO date, 2023-10-23
 * @param dataKey - The key in the data to check for nullishness in determining if the data point
 *  is whitespace.
 * @returns {object|undefined}
 */ const $8ebb0cd4807e72b7$var$findNonWhiteSpacePoint = (data, date, dataKey)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).find(data, (datum)=>datum.time === date && !(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEqual(Object.keys(datum), [
            "time"
        ]) && (!dataKey || datum[dataKey] !== null));
};
/**
 * Returns the point in the provided chart line data that should be used in the legend item for
 * that line; if the user is hovering the graph it returns the nearest point <= where the mouse is,
 * otherwise return the last (most recent) non-whitespace value in the data. Whitespace values are
 * objects with no properties other than `time`.
 *
 * @param {string} hoverDate - current x value being hovered, if one exists
 * @param {Array<object>} data - the { time, absolute, percent } timeseries data of the graph
 * @param {string} dataKey - the key in the data to verify truthiness in determining if the
 *  data point is whitespace.
 * @param {boolean} strict - if true, only return the point if it matches the hoverDate exactly
 *
 * @returns {object} - a { time, absolute, percent } dataPoint
 */ const $8ebb0cd4807e72b7$var$useChartReferencePoint = (hoverDate, data, dataKey, strict = false)=>{
    return (0, $70fFQ.useMemo)(()=>{
        if (!data?.length) return null;
        let hoverPoint = $8ebb0cd4807e72b7$var$findNonWhiteSpacePoint(data, hoverDate, dataKey);
        if (strict) return hoverPoint;
        if (hoverDate && !hoverPoint) {
            // find last non-whitespace date in the data, if one exists
            let currentDate = hoverDate;
            while(!hoverPoint && (0, $86d2f3987cc9d604$exports.DateTime).fromISO(currentDate) >= (0, $86d2f3987cc9d604$exports.DateTime).fromISO(data[0].time)){
                currentDate = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(currentDate).minus({
                    days: 1
                }).toISODate();
                hoverPoint = $8ebb0cd4807e72b7$var$findNonWhiteSpacePoint(data, currentDate, dataKey);
            }
        }
        return hoverPoint || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).findLast(data, (datum)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEqual(Object.keys(datum), [
                "time"
            ]) && (!dataKey || datum[dataKey] !== null));
    }, [
        dataKey,
        data,
        hoverDate,
        strict
    ]);
};
var $8ebb0cd4807e72b7$export$2e2bcd8739ae039 = $8ebb0cd4807e72b7$var$useChartReferencePoint;



const $d37602e0c5798917$var$_mapGenericSecurityToRelatedObject = (security)=>security.public_security || security.private_company || security.private_market_index;
const $d37602e0c5798917$export$e39f4ded596157ee = (security)=>(0, $cd95af98ccabe80c$export$67f4009dfb8f6c86)[$d37602e0c5798917$var$_mapGenericSecurityToRelatedObject(security)[0]];
const $d37602e0c5798917$export$362d5c04bc4f464a = (security)=>$d37602e0c5798917$var$_mapGenericSecurityToRelatedObject(security)[1];






const $ced6f69c885580a1$var$StyledPriceDisplay = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
`;
const $ced6f69c885580a1$var$ColoredText = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80)`
  color: ${({ color: color })=>color};
`;
const $ced6f69c885580a1$var$LegendItem = ({ onRemove: onRemove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isHovered: isHovered, chartElement: chartElement, hoveredDate: hoveredDate })=>{
    const { name: name, color: color, data: data, exchange: exchange } = chartElement;
    /*
   * For the sake of determining hover points, we'll trim off any data points that have a `null`
   * absolute or percent.
   */ const trimmedData = (0, $70fFQ.useMemo)(()=>{
        return data.filter((point)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(point.absolute) && !(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNil(point.percent));
    }, [
        data
    ]);
    const strict = (0, $70fFQ.useMemo)(()=>{
        if (!hoveredDate || trimmedData?.length === 0) return true;
        return hoveredDate < trimmedData[0].time || hoveredDate > trimmedData[trimmedData.length - 1].time;
    }, [
        hoveredDate,
        trimmedData
    ]);
    const referencePoint = (0, $8ebb0cd4807e72b7$export$2e2bcd8739ae039)(hoveredDate, data, "absolute", strict);
    const formattedValue = (0, $70fFQ.useMemo)(()=>{
        if (!data.length) return "";
        if (!referencePoint) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ced6f69c885580a1$var$StyledPriceDisplay, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: "--"
            })
        });
        const changeAbsolute = (referencePoint.absolute - data[0].absolute).toFixed(2);
        const changePercent = referencePoint.percent.toFixed(2);
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($ced6f69c885580a1$var$StyledPriceDisplay, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                    children: (0, $66339e7a022e68c9$export$736d072c44caa715)(referencePoint.absolute)
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                    children: [
                        changeAbsolute >= 0 ? "+" : "-",
                        (0, $66339e7a022e68c9$export$736d072c44caa715)(Math.abs(changeAbsolute))
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                    children: [
                        "(",
                        changePercent > 0 ? "+" : "",
                        (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(changePercent),
                        ")"
                    ]
                })
            ]
        });
    }, [
        referencePoint,
        data
    ]);
    const formattedRobustnessScore = (0, $70fFQ.useMemo)(()=>{
        if (referencePoint?.robustness) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bb0ef5dcd8e37d29$export$2e2bcd8739ae039), {
            score: referencePoint.robustness
        });
        return null;
    }, [
        referencePoint
    ]);
    const formattedName = (0, $70fFQ.useMemo)(()=>{
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
            children: [
                name,
                exchange && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                            children: " | "
                        }),
                        exchange
                    ]
                })
            ]
        });
    }, [
        name,
        exchange
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $3483e96430a6f406$export$a815c023683bd5fd), {
        $isHovered: isHovered,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3483e96430a6f406$export$f734cfedcd7bed10), {
                color: color
            }),
            formattedName,
            formattedRobustnessScore,
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ced6f69c885580a1$var$ColoredText, {
                color: color,
                children: formattedValue
            }),
            onRemove ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7ded616a721e70ef$export$2e2bcd8739ae039), {
                icon: (0, $dfd33cee3229493c$exports.XCloseIcon),
                onClick: onRemove
            }) : null
        ]
    });
};
$ced6f69c885580a1$var$LegendItem.propTypes = {
    isHovered: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    chartElement: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        exchange: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            time: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            absolute: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
        }))
    }).isRequired,
    hoveredDate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
$ced6f69c885580a1$var$LegendItem.defaultProps = {
    onMouseEnter: null,
    onMouseLeave: null,
    onRemove: null
};
var $ced6f69c885580a1$export$2e2bcd8739ae039 = $ced6f69c885580a1$var$LegendItem;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");






const $f6ae50faf14a0998$var$EmptyVolume = (label)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
        children: [
            label,
            " - $",
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                children: "--"
            })
        ]
    });
const $f6ae50faf14a0998$var$VolumeAggregateLegendItem = ({ isHovered: isHovered, chartElement: chartElement, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hoveredDate: hoveredDate, onRemove: onRemove })=>{
    const { data: data } = chartElement;
    const referencePoint = (0, $8ebb0cd4807e72b7$export$2e2bcd8739ae039)(hoveredDate, data, "total", true);
    /*
   * The values from the data point is stored in "millions", so we'll reformat it appropriately.
   * Typically we'd just append an "M" to it but when it's larger than 1000M, we really want to
   * show a "B".
   */ const values = (0, $70fFQ.useMemo)(()=>{
        if (!referencePoint) return {
            total: null,
            bid: null,
            offer: null
        };
        return {
            total: referencePoint.total ? (0, $66339e7a022e68c9$export$736d072c44caa715)(referencePoint.total * 1000000) : null,
            bid: referencePoint.bid ? (0, $66339e7a022e68c9$export$736d072c44caa715)(referencePoint.bid * 1000000) : null,
            offer: referencePoint.offer ? (0, $66339e7a022e68c9$export$736d072c44caa715)(referencePoint.offer * 1000000) : null
        };
    }, [
        referencePoint
    ]);
    const formattedTotalValue = (0, $70fFQ.useMemo)(()=>{
        if (!values.total) return $f6ae50faf14a0998$var$EmptyVolume("Total");
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
            children: [
                "Total - ",
                values.total
            ]
        });
    }, [
        values.total
    ]);
    const formattedBidValue = (0, $70fFQ.useMemo)(()=>{
        if (!values.bid) return $f6ae50faf14a0998$var$EmptyVolume("Bid");
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
            children: [
                "Bid - ",
                values.bid
            ]
        });
    }, [
        values.bid
    ]);
    const formattedOfferValue = (0, $70fFQ.useMemo)(()=>{
        if (!values.offer) return $f6ae50faf14a0998$var$EmptyVolume("Offer");
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
            children: [
                "Offer - ",
                values.offer
            ]
        });
    }, [
        values.offer
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $3483e96430a6f406$export$a815c023683bd5fd), {
        $isHovered: isHovered,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                children: "Volume - 3M AGG."
            }),
            formattedTotalValue,
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3483e96430a6f406$export$f734cfedcd7bed10), {
                color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).green
            }),
            formattedBidValue,
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3483e96430a6f406$export$f734cfedcd7bed10), {
                color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).red
            }),
            formattedOfferValue,
            onRemove ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7ded616a721e70ef$export$2e2bcd8739ae039), {
                icon: (0, $dfd33cee3229493c$exports.XCloseIcon),
                onClick: onRemove
            }) : null
        ]
    });
};
$f6ae50faf14a0998$var$VolumeAggregateLegendItem.propTypes = {
    isHovered: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    chartElement: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({})
    }).isRequired,
    hoveredDate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
var $f6ae50faf14a0998$export$2e2bcd8739ae039 = $f6ae50faf14a0998$var$VolumeAggregateLegendItem;


const $cd95af98ccabe80c$var$WEEKS_IN_3_MONTHS = 13;
const $cd95af98ccabe80c$var$WEEKS_IN_6_MONTHS = 26;
const $cd95af98ccabe80c$var$WEEKS_IN_1_YEAR = 52;
const $cd95af98ccabe80c$export$99d24ef84589a5ba = "3M";
const $cd95af98ccabe80c$export$ee25c2a2e8e534bf = "6M";
const $cd95af98ccabe80c$export$8f1924ffed232894 = "1Y";
const $cd95af98ccabe80c$export$6f4aa2efcb73a5b2 = "2Y";
const $cd95af98ccabe80c$export$e19a6d70f5805ce3 = "YTD";
/*
 * Some hardcoded values to implement the hover state for the graph, which has a fixed size and
 * offset.
 */ const $cd95af98ccabe80c$export$2dd871b9b6883c28 = {
    fontSize: 12,
    padding: "4px 8px",
    maxWidth: 165,
    background: (0, $dfd33cee3229493c$exports.YukaColorPalette).surface3,
    borderRadius: 4,
    color: (0, $dfd33cee3229493c$exports.ColorPalette).white50,
    display: "flex",
    flexDirection: "column",
    gap: "8px"
};
const $cd95af98ccabe80c$export$affb72ae61a3e7b4 = "KEY_COMPANY";
const $cd95af98ccabe80c$export$aa91631980c62dad = "ZX_COMPARISON";
const $cd95af98ccabe80c$export$d629e9c374a4750 = "ZX_MARKET_INDEX_COMPARISON";
const $cd95af98ccabe80c$var$API_TYPE_PRIVATE_COMPANY = "Company";
const $cd95af98ccabe80c$var$API_TYPE_PRIVATE_MARKET_INDEX = "PrivateMarketIndex";
const $cd95af98ccabe80c$export$67f4009dfb8f6c86 = {
    [$cd95af98ccabe80c$var$API_TYPE_PRIVATE_COMPANY]: $cd95af98ccabe80c$export$aa91631980c62dad,
    [$cd95af98ccabe80c$var$API_TYPE_PRIVATE_MARKET_INDEX]: $cd95af98ccabe80c$export$d629e9c374a4750
};
const $cd95af98ccabe80c$export$9b32a7d6857d01a = "ZX";
const $cd95af98ccabe80c$export$165f4543bc6a6b54 = "ZXI";
const $cd95af98ccabe80c$export$f94889ddc23788b0 = {
    [$cd95af98ccabe80c$export$affb72ae61a3e7b4]: {
        TIME_FIELD: "report_period",
        PRICE_DATA_FIELD: "zx_index_price",
        ADDITIONAL_DATA_FIELDS: [
            "robustness",
            "volume"
        ]
    },
    [$cd95af98ccabe80c$export$aa91631980c62dad]: {
        TIME_FIELD: "report_period",
        PRICE_DATA_FIELD: "zx_index_price",
        ADDITIONAL_DATA_FIELDS: [
            "robustness"
        ]
    },
    [$cd95af98ccabe80c$export$d629e9c374a4750]: {
        TIME_FIELD: "created_on",
        PRICE_DATA_FIELD: "value",
        ADDITIONAL_DATA_FIELDS: [],
        config: {
            castDateTimeToDate: true
        }
    }
};
const $cd95af98ccabe80c$export$a9864fdcc39cd433 = {
    [$cd95af98ccabe80c$export$99d24ef84589a5ba]: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
        weeks: $cd95af98ccabe80c$var$WEEKS_IN_3_MONTHS
    }),
    [$cd95af98ccabe80c$export$ee25c2a2e8e534bf]: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
        weeks: $cd95af98ccabe80c$var$WEEKS_IN_6_MONTHS
    }),
    [$cd95af98ccabe80c$export$8f1924ffed232894]: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
        weeks: $cd95af98ccabe80c$var$WEEKS_IN_1_YEAR
    }),
    [$cd95af98ccabe80c$export$e19a6d70f5805ce3]: (0, $86d2f3987cc9d604$exports.DateTime).now().startOf("year")
};
const $cd95af98ccabe80c$var$getBidOfferValue = (id, indicatorDataPoint)=>{
    return {
        [`${id}_bid`]: indicatorDataPoint.bid !== null ? Number(indicatorDataPoint.bid) : null,
        [`${id}_offer`]: indicatorDataPoint.offer !== null ? Number(indicatorDataPoint.offer) : null
    };
};
const $cd95af98ccabe80c$export$f404cd8f0234575e = "Bid & Ask";
const $cd95af98ccabe80c$export$bc2cd93286e1f57d = "Overall";
const $cd95af98ccabe80c$export$f8502645f74d42f8 = {
    ZIVT: {
        name: "ZX Index Value - Trailing",
        apiDataKey: "zx_index_value_trailing",
        category: $cd95af98ccabe80c$export$bc2cd93286e1f57d,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    DWA: {
        name: "Dollar-Weighted AVG.",
        apiDataKey: "overall_dwa",
        category: $cd95af98ccabe80c$export$bc2cd93286e1f57d,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    SA: {
        name: "Simple AVG.",
        apiDataKey: "overall_simple_average",
        category: $cd95af98ccabe80c$export$bc2cd93286e1f57d,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    V3MA: {
        name: "Volume - 3M AGG.",
        apiDataKey: "total_volume",
        isVolume: true,
        category: $cd95af98ccabe80c$export$bc2cd93286e1f57d,
        getIndicatorValueObject: $cd95af98ccabe80c$var$getBidOfferValue,
        LegendItem: (0, $f6ae50faf14a0998$export$2e2bcd8739ae039)
    },
    BZX: {
        name: "Bid ZX Index Value",
        apiDataKey: "zx_index_value_bid_side",
        category: $cd95af98ccabe80c$export$f404cd8f0234575e,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    BDWA: {
        name: "Bid Dollar-Weighted AVG.",
        apiDataKey: "bid_dwa",
        category: $cd95af98ccabe80c$export$f404cd8f0234575e,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    BSA: {
        name: "Bid Simple AVG.",
        apiDataKey: "bid_simple_average",
        category: $cd95af98ccabe80c$export$f404cd8f0234575e,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    OZX: {
        name: "Offer ZX Index Value",
        apiDataKey: "zx_index_value_ask_side",
        category: $cd95af98ccabe80c$export$f404cd8f0234575e,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    ODWA: {
        name: "Offer Dollar-Weighted AVG.",
        apiDataKey: "ask_dwa",
        category: $cd95af98ccabe80c$export$f404cd8f0234575e,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    },
    OSA: {
        name: "Offer Simple AVG.",
        apiDataKey: "ask_simple_average",
        category: $cd95af98ccabe80c$export$f404cd8f0234575e,
        LegendItem: (0, $ced6f69c885580a1$export$2e2bcd8739ae039)
    }
};
const $cd95af98ccabe80c$export$1a36fc7a09bd0584 = 14;











var $70fFQ = parcelRequire("70fFQ");

var $hI4Hx = parcelRequire("hI4Hx");
const $cf715cdf7b4bb119$var$QUARTER_SECOND = 250;
/**
 * A convenience helper to scroll an element to a point over a given time frame.
 *
 * @param {object} element - The actual DOM element being scrolled
 * @param {number} to - The scrollTop value after the animation
 * @param {number} duration - The time we want the scroll to take in milliseconds
 *                            If duration is 0, scroll without animation
 */ const $cf715cdf7b4bb119$var$animateScrollTo = (element, to, duration)=>{
    const distance = to - element.scrollTop;
    const increment = 25;
    const adjustment = duration ? distance * increment / duration : distance;
    const animateScroll = ()=>{
        const prevTop = element.scrollTop;
        // eslint-disable-next-line no-param-reassign
        element.scrollTop += adjustment;
        if (element.scrollTop !== to && prevTop !== element.scrollTop) setTimeout(animateScroll, increment);
    };
    animateScroll();
};
/**
 * @param {object} element - HTMLElement
 * @returns {number} distance from top
 */ const $cf715cdf7b4bb119$var$getDistanceFromTop = (element)=>element ? element.scrollTop : 0;
/**
 * @param {object} element - HTMLElement
 * @returns {number} distance from bottom
 */ const $cf715cdf7b4bb119$var$getDistanceFromBottom = (element)=>element ? element.scrollHeight - element.clientHeight - element.scrollTop : 0;
/**
 * Hook for scrollable elements.
 * Allows callbacks to be called on scroll up/down and returns convenience methods
 * for scrolling to the top/bottom of the provided `scrollRef`.
 *
 * @param {object} args
 * @param {object} args.scrollRef - Ref to the scrollable element
 * @param {Function} args.onScrollUp - Function to invoke when the user scrolls to the top
 *                              Param is distance from top in pixels
 * @param {Function} args.onScrollDown - Function to invoke when the user scrolls to the bottom
 *                                Param is distance from bottom in pixels
 * @returns {Array<*>}
 *   0: {Function} scrollToBottom Function that scrolls the scrollRef to the bottom
 *   1: {Function} scrollToTop Function that scrolls the scrollRef to the top
 *   2: {Number} distanceFromBottom Distance in px from bottom of scrollRef
 *   3: {Number} distanceFromTop Distance in px from top of scrollRef
 */ const $cf715cdf7b4bb119$var$useScrollable = ({ scrollRef: scrollRef, onScrollUp: onScrollUp, onScrollDown: onScrollDown })=>{
    const [lastScrollPosition, setLastScrollPosition] = (0, $70fFQ.useState)(scrollRef.current ? scrollRef.current.scrollTop : 0);
    const _onScroll = ()=>{
        const newScrollPosition = scrollRef.current.scrollTop;
        const distanceFromTop = $cf715cdf7b4bb119$var$getDistanceFromTop(scrollRef.current);
        const distanceFromBottom = $cf715cdf7b4bb119$var$getDistanceFromBottom(scrollRef.current);
        // scrolling up
        if (newScrollPosition < lastScrollPosition) onScrollUp(distanceFromTop);
        // scrolling down
        if (newScrollPosition > lastScrollPosition) onScrollDown(distanceFromBottom);
        setLastScrollPosition(newScrollPosition);
    };
    const onScroll = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).throttle(_onScroll, $cf715cdf7b4bb119$var$QUARTER_SECOND);
    // Mount: Add scroll event listeners to scrollRef
    // Unmount: Remove scrol levent listeners from scrollRef
    (0, $70fFQ.useEffect)(()=>{
        if (!scrollRef.current) return null;
        const scrolledElement = scrollRef.current;
        scrolledElement.addEventListener("scroll", onScroll);
        return ()=>{
            scrolledElement.removeEventListener("scroll", onScroll);
        };
    });
    // Convenience methods for scrolling to top/bottom of scrollRef
    const scrollToBottom = (0, $70fFQ.useCallback)(({ animate: animate })=>{
        if (!scrollRef.current) return;
        $cf715cdf7b4bb119$var$animateScrollTo(scrollRef.current, scrollRef.current.scrollHeight, animate ? $cf715cdf7b4bb119$var$QUARTER_SECOND : 0);
    }, [
        scrollRef
    ]);
    const scrollToTop = (0, $70fFQ.useCallback)(({ animate: animate })=>{
        if (!scrollRef.current) return;
        $cf715cdf7b4bb119$var$animateScrollTo(scrollRef.current, 0, animate ? $cf715cdf7b4bb119$var$QUARTER_SECOND : 0);
    }, [
        scrollRef
    ]);
    const distanceFromTop = $cf715cdf7b4bb119$var$getDistanceFromTop(scrollRef.current);
    const distanceFromBottom = $cf715cdf7b4bb119$var$getDistanceFromBottom(scrollRef.current);
    return [
        scrollToBottom,
        scrollToTop,
        distanceFromBottom,
        distanceFromTop
    ];
};
var $cf715cdf7b4bb119$export$2e2bcd8739ae039 = $cf715cdf7b4bb119$var$useScrollable;


const $567ba063e88c5e09$var$StyledCardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 600px;
  height: 360px;
  padding: 0 16px;
  margin-bottom: -16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const $567ba063e88c5e09$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  // I am very important. Overriding Yuka-injected styles.
  border-bottom: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15} !important;
`;
const $567ba063e88c5e09$var$StyledSearchContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  overflow: auto;
  margin: 0 -16px;
`;
const $567ba063e88c5e09$var$StyledPlaceholderText = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  text-align: center;
  margin-top: 80px;
`;
const $567ba063e88c5e09$var$ThumbnailContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $567ba063e88c5e09$var$StyledCompanyThumbnail = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).img`
  max-width: 24px;
  max-height: 24px;
  width: auto;
  height: auto;
`;
// We sometimes manually override the exchange value to display it in the UI.
const $567ba063e88c5e09$var$EXCHANGE_DISPLAY_NAMES = {
    ZXI: "ZX"
};
const $567ba063e88c5e09$var$FETCH_NEXT_COMPANIES_PAGE_THRESHOLD = 94; // Height of two search results
const $567ba063e88c5e09$var$AddComparisonDropdown = ({ onSelectComparison: onSelectComparison })=>{
    const [searchQuery, setSearchQuery] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)(null);
    const [selectedComparisonType, setSelectedComparisonType] = (0, $70fFQ.useState)(null);
    const searchResultsRef = (0, $70fFQ.useRef)(null);
    const [zxMarketIndexAccess] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$5b6ad604c0c2bd71));
    const COMPARISON_TYPES = {
        PRIVATE_COMPANIES: "Private Companies",
        // PUBLIC_SYMBOLS: "Public Symbols", // Removing until we resubscribe to Xignite.
        ...zxMarketIndexAccess ? {
            ZX_MARKET_INDICES: "ZX Market Indices"
        } : {}
    };
    // search all companies and symbols
    const allSecuritySearchQuery = (0, $f869aac89d4eda76$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_AND_SECURITY_SEARCH(), {
        "filter[search]": searchQuery || undefined,
        security_type: selectedComparisonType || undefined,
        removed: false
    }, {
        keepPreviousData: true
    });
    const onScrollDownFetchNext = (0, $70fFQ.useCallback)((distanceFromBottom)=>{
        if (distanceFromBottom < $567ba063e88c5e09$var$FETCH_NEXT_COMPANIES_PAGE_THRESHOLD && allSecuritySearchQuery.hasNextPage && !allSecuritySearchQuery.isFetchingNextPage) allSecuritySearchQuery.fetchNextPage().then((response)=>response.data);
    }, [
        allSecuritySearchQuery
    ]);
    // We need to debounce the scroll handler so we don't send duplicate API requests.
    const debouncedOnScrollDownFetchNext = (0, $70fFQ.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce(onScrollDownFetchNext, (0, $753b8dcbe6be17f9$export$32c0454ceff7f92d), {
            leading: true,
            trailing: false
        }), [
        onScrollDownFetchNext
    ]);
    (0, $cf715cdf7b4bb119$export$2e2bcd8739ae039)({
        scrollRef: searchResultsRef,
        onScrollUp: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
        onScrollDown: debouncedOnScrollDownFetchNext
    });
    const changeHandler = (0, $70fFQ.useCallback)((event)=>{
        setSearchQuery.cancel();
        setSearchQuery(event.target.value);
    }, [
        setSearchQuery
    ]);
    const securities = allSecuritySearchQuery.isSuccess ? allSecuritySearchQuery.cleanedData.data : [];
    const getAvatar = (0, $70fFQ.useCallback)((security)=>{
        if (security.main_picture) {
            if (security.exchange === (0, $cd95af98ccabe80c$export$9b32a7d6857d01a)) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Thumbnail), {
                src: security.main_picture,
                size: "24px"
            });
            // We need a special 24x24 container since some logos are taller than they are wide.
            // In those cases, we want to center the logo within the 24x24 box. We're shipping a 1-off
            // for this use case.
            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($567ba063e88c5e09$var$ThumbnailContainer, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($567ba063e88c5e09$var$StyledCompanyThumbnail, {
                    src: security.main_picture
                })
            });
        }
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f82caaae0faa7ac9$export$2e2bcd8739ae039), {
            icon: security.exchange === (0, $cd95af98ccabe80c$export$165f4543bc6a6b54) ? (0, $dfd33cee3229493c$exports.LineChartUpIcon) : (0, $dfd33cee3229493c$exports.BuildingIcon)
        });
    }, []);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($567ba063e88c5e09$var$StyledCardContent, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a3cb2c0ab9bbfa1d$export$2e2bcd8739ae039), {
                placeholder: "Search private companies and indices",
                leadingIcon: (0, $dfd33cee3229493c$exports.SearchIcon),
                onChange: changeHandler,
                autoFocus: true
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $34ccb6660205eec8$exports.Fragment), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FilterChip), {
                            text: "All",
                            selected: selectedComparisonType === null,
                            onClick: ()=>setSelectedComparisonType(null)
                        }),
                        Object.values(COMPARISON_TYPES).map((label)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FilterChip), {
                                text: label,
                                selected: selectedComparisonType === label,
                                onClick: ()=>setSelectedComparisonType(label)
                            }, label))
                    ]
                })
            }),
            securities.length > 0 ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($567ba063e88c5e09$var$StyledSearchContent, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.List), {
                    ref: searchResultsRef,
                    divider: true,
                    children: [
                        securities.map((security)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($567ba063e88c5e09$var$StyledListItem, {
                                avatar: getAvatar(security),
                                onClick: ()=>onSelectComparison(security),
                                text: security.symbol,
                                trailingContent: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.StyledCaption2), {
                                    children: `${security.name} | ${$567ba063e88c5e09$var$EXCHANGE_DISPLAY_NAMES[security.exchange] || security.exchange}`
                                })
                            }, security.apiId)),
                        allSecuritySearchQuery.isFetchingNextPage && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
                            absolute: false
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($567ba063e88c5e09$var$StyledPlaceholderText, {
                children: [
                    allSecuritySearchQuery.isLoading && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
                        absolute: false
                    }),
                    allSecuritySearchQuery.isSuccess ? "No securities found. Try adjusting your search." : "Start your search with private companies, public symbols, or ETFs"
                ]
            })
        ]
    });
};
$567ba063e88c5e09$var$AddComparisonDropdown.propTypes = {
    onSelectComparison: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $567ba063e88c5e09$export$2e2bcd8739ae039 = $567ba063e88c5e09$var$AddComparisonDropdown;




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





const $76a49a5fc1820df9$var$StyledDropdownContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.PageSection))`
  padding: 12px 0;
  margin: -16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $76a49a5fc1820df9$var$StyledSection = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50).attrs({
    as: "div"
})`
  padding: 8px 12px;
`;
const $76a49a5fc1820df9$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  padding: 0 12px;
  height: 32px;
  min-height: 32px;
`;
const $76a49a5fc1820df9$var$IconPlaceholderDiv = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 18px;
  height: 18px;
`;
const $76a49a5fc1820df9$var$AddIndicatorDropdown = ({ disabled: disabled, availableIndicators: availableIndicators, addIndicator: addIndicator, removeIndicator: removeIndicator, selectedIndicators: selectedIndicators })=>{
    const overallIndicators = (0, $70fFQ.useMemo)(()=>availableIndicators.filter((indicator)=>indicator.category === (0, $cd95af98ccabe80c$export$bc2cd93286e1f57d)), [
        availableIndicators
    ]);
    const sideRelatedIndicators = (0, $70fFQ.useMemo)(()=>availableIndicators.filter((indicator)=>indicator.category === (0, $cd95af98ccabe80c$export$f404cd8f0234575e)), [
        availableIndicators
    ]);
    const sections = (0, $70fFQ.useMemo)(()=>[
            {
                title: "Overall",
                indicators: overallIndicators
            },
            {
                title: "Bid & Ask",
                indicators: sideRelatedIndicators
            }
        ], [
        overallIndicators,
        sideRelatedIndicators
    ]);
    const IndicatorsDropdown = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($76a49a5fc1820df9$var$StyledDropdownContainer, {
            children: sections.map((section)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($76a49a5fc1820df9$var$StyledSection, {
                            children: section.title
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                            children: section.indicators.map((indicator)=>{
                                const indicatorSelected = selectedIndicators.find((i)=>i.name === indicator.id);
                                return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($76a49a5fc1820df9$var$StyledListItem, {
                                    leadingIconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400,
                                    leadingIcon: indicatorSelected ? (0, $dfd33cee3229493c$exports.CheckIcon) : $76a49a5fc1820df9$var$IconPlaceholderDiv,
                                    text: indicator.name,
                                    onClick: ()=>indicatorSelected ? removeIndicator(indicator.id) : addIndicator(indicator.id)
                                }, indicator.id);
                            })
                        })
                    ]
                }, section.title))
        });
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(IndicatorsDropdown);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                id: "add-indicator-button",
                disabled: disabled,
                active: dropdownElement !== null,
                ref: dropdownRef,
                onClick: toggleDropdown,
                icon: (0, $dfd33cee3229493c$exports.LineChartIcon),
                children: "Indicators"
            }),
            dropdownElement
        ]
    });
};
$76a49a5fc1820df9$var$AddIndicatorDropdown.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    addIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    removeIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    availableIndicators: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array,
    selectedIndicators: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array
};
$76a49a5fc1820df9$var$AddIndicatorDropdown.defaultProps = {
    disabled: false,
    availableIndicators: [],
    selectedIndicators: [],
    addIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
    removeIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
};
var $76a49a5fc1820df9$export$2e2bcd8739ae039 = $76a49a5fc1820df9$var$AddIndicatorDropdown;




var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




const $b943d1910a3fe883$var$debouncedMixpanel = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).debounce((0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).hoverCompanyProfileLineChart, 500, {
    leading: false,
    trailing: true
});
const $b943d1910a3fe883$var$CompanyLineGraphTooltip = ({ setHoveredDate: setHoveredDate, payload: payload, companyName: companyName, comparisonCount: comparisonCount, indicatorCount: indicatorCount })=>{
    // Props are injected by recharts.
    (0, $70fFQ.useEffect)(()=>{
        if (payload[0]?.payload?.time) $b943d1910a3fe883$var$debouncedMixpanel(companyName, payload[0]?.payload?.time, comparisonCount, indicatorCount);
        setHoveredDate(payload[0]?.payload?.time);
    }, [
        companyName,
        comparisonCount,
        indicatorCount,
        setHoveredDate,
        payload
    ]);
    if (!payload[0]?.payload?.time) return null;
    const formattedDate = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(payload[0]?.payload?.time).toFormat("dd MMM yy");
    const [day, month, year] = formattedDate.split(" ");
    // Inject the apostrophe to the year.
    const { transactionRecords: transactionRecords } = payload[0]?.payload;
    if (!transactionRecords) return `${day} ${month} '${year}`;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("span", {
                children: [
                    day,
                    " ",
                    month,
                    " '",
                    year
                ]
            }),
            transactionRecords.map((record)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                                children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(record.price_per_share, 2, 2)
                            })
                        }),
                        "Trade closed on",
                        " ",
                        (0, $86d2f3987cc9d604$exports.DateTime).fromISO(record.closing_date || record.noticed_date).toFormat("M/d/y"),
                        " at",
                        " ",
                        (0, $93597109349c7d49$export$2e2bcd8739ae039)(record.total_value, 0)
                    ]
                }, record.id))
        ]
    });
};
$b943d1910a3fe883$var$CompanyLineGraphTooltip.propTypes = {
    setHoveredDate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    payload: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array,
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    comparisonCount: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    indicatorCount: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
};
var $b943d1910a3fe883$export$2e2bcd8739ae039 = $b943d1910a3fe883$var$CompanyLineGraphTooltip;





var $70fFQ = parcelRequire("70fFQ");
/**
 * Custom hook to generate the x-axis ticks for the company profile line graph. We prefer to show
 * close to 12 ticks if the date range spans > 12 months of data. We take an even distribution of
 * the dates so that the spaces between the dates are equal. If the date range spans < 12 months
 * of data, we show all the dates.
 *
 * We will derive our x-axis ticks from the main company data and also dates for the relevant
 * comparisons that are applied, since a company's data might not stretch far enough back into
 * the past/the future to provide the ticks for the selected range.
 *
 * @param companyData
 * @param comparisonData
 * @return {Array<string>} - List of dates to show on the x-axis.
 */ const $a253dd47fdc13799$var$useXAxisTicks = (companyData, comparisonData)=>(0, $70fFQ.useMemo)(()=>{
        // Get the first report_period in each month for the companyData
        // let curComparisonDate = comparisonDates?.[0];
        // let curCompanyDate = companyData?.data?.[0].time;
        let allDates = new Set();
        if (companyData?.data) for(let i = 0; i < companyData.data.length; i++)allDates.add(companyData.data[i].time);
        comparisonData?.forEach((comparison)=>{
            for(let i = 0; i < comparison?.data?.length; i++)allDates.add(comparison?.data[i].time);
        });
        let sortedDates = Array.from(allDates).sort();
        const dates = [];
        let lastDate = null;
        for(let i = 0; i < sortedDates.length; i++){
            const date = (0, $86d2f3987cc9d604$exports.DateTime).fromISO(sortedDates[i]);
            if (lastDate === null || date.month !== lastDate.month) {
                dates.push(date.toISODate());
                lastDate = date;
            }
        }
        // If dates is larger than 12, ensure we get exactly 12 evenly distributed dates.
        if (dates.length > 12) {
            const sampleSize = Math.floor(dates.length / 12);
            return dates.filter((_, i)=>i % sampleSize === 0);
        }
        return dates;
    }, [
        companyData,
        comparisonData
    ]);
var $a253dd47fdc13799$export$2e2bcd8739ae039 = $a253dd47fdc13799$var$useXAxisTicks;


















const $81a940f400b753fe$var$StyledLineGraphLayout = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $81a940f400b753fe$var$StyledGraphControlRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > :first-child {
    display: flex;
    gap: 16px;
  }
`;
const $81a940f400b753fe$var$StyledLegendContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;
const $81a940f400b753fe$var$StyledAbsoluteEmptyPill = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $f5879f76b7a709cc$export$757b1a5dfccb9b1d))`
  position: absolute;
  height: 120px;
  width: 400px;
  top: calc(50% - 60px);
  left: calc(50% - 200px);

  > :first-child {
    height: 100%;
  }
`;
const $81a940f400b753fe$var$DEFAULT_DATE_RANGE = (0, $cd95af98ccabe80c$export$8f1924ffed232894);
const $81a940f400b753fe$var$getLineProps = (chartElement, activeIndex)=>({
        connectNulls: true,
        isAnimationActive: false,
        dot: (0, $3ae1a3cadebbaa5e$export$2e2bcd8739ae039)(chartElement.color, activeIndex),
        type: "monotone",
        dataKey: chartElement.id,
        activeDot: (0, $4b44dbac5b3e4d6a$export$2e2bcd8739ae039)(chartElement),
        strokeWidth: 2,
        stroke: chartElement.color
    });
const $81a940f400b753fe$var$SHARED_BAR_PROPS = {
    yAxisId: "volumeYAxis",
    stackId: "volumeStack",
    isAnimationActive: false,
    barSize: 12
};
const $81a940f400b753fe$var$COMPARISON_MODE = "comparisonMode";
const $81a940f400b753fe$var$INDICATOR_MODE = "indicatorMode";
const $81a940f400b753fe$var$CompanyProfileLineGraph = ({ onClickClosedTransaction: onClickClosedTransaction })=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const [zxMarketIndexAccess] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$5b6ad604c0c2bd71));
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const [mode, setMode] = (0, $70fFQ.useState)($81a940f400b753fe$var$INDICATOR_MODE);
    // Store all comparisons in a single state object.
    // List of { id: "21312412", type: "PUBLIC_COMPARISON", symbol: "AAPL", data: [] }
    const [comparisons, setComparisons] = (0, $70fFQ.useState)([]);
    const [selectedIndicators, setSelectedIndicators] = (0, $70fFQ.useState)([
        {
            name: "ZIVT",
            color: (0, $0c153f15ec244d80$export$2e2bcd8739ae039)()
        }
    ]);
    const [selectedRange, setSelectedRange] = (0, $70fFQ.useState)($81a940f400b753fe$var$DEFAULT_DATE_RANGE);
    // We'll leverage uuid4 collision rate to identify the hovered legend item.
    const [hoveredDate, setHoveredDate] = (0, $70fFQ.useState)(null);
    // Will be used for mixpanel tracking.
    const [prevHoveredLegendItem, setPrevHoveredLegendItem] = (0, $70fFQ.useState)(null);
    const [hoveredLegendItem, setHoveredLegendItem] = (0, $70fFQ.useState)(null);
    const updateHoveredLegendItem = (0, $70fFQ.useCallback)((newHoveredLegendItem)=>{
        setPrevHoveredLegendItem(hoveredLegendItem);
        setHoveredLegendItem(newHoveredLegendItem);
    }, [
        hoveredLegendItem
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (hoveredLegendItem && hoveredLegendItem !== prevHoveredLegendItem) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).hoverCompanyProfileLineChartLegendItem(company?.name, hoveredLegendItem.name);
    }, [
        company?.name,
        hoveredLegendItem,
        prevHoveredLegendItem
    ]);
    const companyOrderFlowQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_PRICE_VOLUME_ORDER_FLOW(), {
        company: company?.zb_id
    }, {
        enabled: Boolean(company?.zb_id)
    });
    const monthlyOrderFlowQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_VOLUME_TRADING_DATA(company?.zb_id), {
        years: 2,
        time_frame: (0, $753b8dcbe6be17f9$export$c1c27e297fdb3d7e),
        // Supplied by standalone HD's proxy before the SPA called this endpoint
        // directly (ZX-15277).
        ordering: "-report_period",
        "page[size]": 100
    }, {
        enabled: Boolean(company?.zb_id)
    });
    const comparisonQueryObjects = (0, $70fFQ.useMemo)(()=>comparisons.map(({ type: type, id: id })=>{
            if (type === (0, $cd95af98ccabe80c$export$aa91631980c62dad)) return {
                url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_PRICE_VOLUME_ORDER_FLOW(),
                queryParams: {
                    company: id
                }
            };
            else if (type === (0, $cd95af98ccabe80c$export$d629e9c374a4750) && zxMarketIndexAccess) return {
                url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).ZX_MARKET_INDEX_VALUES(),
                queryParams: {
                    market_index: id
                }
            };
        }).flat(), [
        zxMarketIndexAccess,
        comparisons
    ]);
    const comparisonsQueries = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)(comparisonQueryObjects, {});
    // large page size so that we can get everything in one page
    const transactionRecords = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).TRANSACTION_RECORDS(), {
        company: company?.zb_id,
        "page[size]": 100000
    }, {
        enabled: Boolean(company?.zb_id)
    });
    const transactionRecordsData = transactionRecords?.cleanedData?.data;
    const companyData = (0, $70fFQ.useMemo)(()=>{
        if (companyOrderFlowQuery.isSuccess) return {
            id: company?.zb_id,
            name: company?.name,
            exchange: (0, $cd95af98ccabe80c$export$9b32a7d6857d01a),
            color: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding400,
            data: (0, $b4bc42725e344a04$export$2e2bcd8739ae039)(companyOrderFlowQuery.cleanedData.data, (0, $cd95af98ccabe80c$export$affb72ae61a3e7b4))[selectedRange]
        };
        return null;
    }, [
        selectedRange,
        company?.zb_id,
        company?.name,
        companyOrderFlowQuery.isSuccess,
        companyOrderFlowQuery.cleanedData
    ]);
    const companyDataKey = (0, $70fFQ.useMemo)(()=>{
        if (mode === $81a940f400b753fe$var$COMPARISON_MODE && comparisons.length > 0) return "percent";
        return "absolute";
    }, [
        comparisons.length,
        mode
    ]);
    const companyIndicatorData = (0, $70fFQ.useMemo)(()=>{
        if (companyOrderFlowQuery.isSuccess && monthlyOrderFlowQuery.isSuccess) return (0, $09a2297481aa74e0$export$2e2bcd8739ae039)(companyOrderFlowQuery.cleanedData.data, monthlyOrderFlowQuery.cleanedData.data);
        return null;
    }, [
        companyOrderFlowQuery,
        monthlyOrderFlowQuery
    ]);
    const availableIndicators = (0, $70fFQ.useMemo)(()=>{
        // The full set of available indicators. Will be used in combination with `selectedIndicators`
        // to determine the chart data to render.
        if (!companyIndicatorData) return [];
        return Object.keys(companyIndicatorData).map((indicatorName)=>{
            if (!companyIndicatorData?.[indicatorName]?.[selectedRange]?.length > 0) return null;
            return {
                id: indicatorName,
                name: indicatorName,
                ...(0, $cd95af98ccabe80c$export$f8502645f74d42f8)[indicatorName],
                data: companyIndicatorData[indicatorName][selectedRange]
            };
        }).filter((indicator)=>indicator !== null);
    }, [
        selectedRange,
        companyIndicatorData
    ]);
    const superchartComparisonData = (0, $70fFQ.useMemo)(()=>{
        if (comparisonsQueries.isAnySuccess) {
            const actualCleanedData = comparisonsQueries.cleanedData.map((comparisonData, index)=>{
                if (!comparisonData && !comparisonQueryObjects[index].supplementary) return comparisonData;
                if (comparisonQueryObjects[index + 1]?.supplementary) // combine the next query's results with this one.
                // As of Feb. 4, 2026, we no longer support public data + pre-IPO data combinations
                // but we'll keep it around in case we re-introduce this functionality in the future
                return {
                    ...comparisonData,
                    data: (0, $49bdb570b3c546c8$export$2e2bcd8739ae039)(// ZX-15151: comparisonData can be null when the primary query
                    // resolved without data but the next query is supplementary.
                    comparisonData?.data || [], comparisonsQueries.cleanedData[index + 1]?.data || [])
                };
                else if (comparisonQueryObjects[index].supplementary) return null;
                return comparisonData;
            }).filter((data)=>data !== null); // Remove supplementary data points.
            return actualCleanedData.map((comparisonData, index)=>{
                const data = comparisonData?.data.length ? (0, $b4bc42725e344a04$export$2e2bcd8739ae039)(comparisonData.data, comparisons[index].type)[selectedRange] : [];
                return {
                    ...comparisons[index],
                    isLoading: !comparisonData?.data,
                    data: data
                };
            });
        }
        return [];
    }, [
        selectedRange,
        comparisons,
        comparisonQueryObjects,
        comparisonsQueries
    ]);
    (0, $70fFQ.useEffect)(()=>{
        // Purge comparisons who have successfully been queried but have been found to have no data.
        // Report using a toast on the list of comparisons that had no data.
        const difference = [];
        const newComparisons = comparisons.filter((comp)=>{
            const comparisonData = superchartComparisonData.find((data)=>data.id === comp.id);
            if (comparisonData && !comparisonData.isLoading && !comparisonData.data?.length) {
                difference.push(comparisonData);
                return false;
            }
            // Allow comparisons that have not been loaded yet + comparisons with data through the filter.
            return true;
        });
        if (newComparisons.length !== comparisons.length) {
            // Typically because of network latency we'll see 1 of these toasts per failing company, but
            // we might as well handle the list case if there's a weird race between network responses
            // coming back and the rendering cycle.
            dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                message: `No available data for ${difference.map((comparison)=>comparison.name).join(", ")}.`
            });
            setComparisons(newComparisons);
        }
    }, [
        comparisons,
        superchartComparisonData,
        dispatch
    ]);
    const xAxisTicks = (0, $a253dd47fdc13799$export$2e2bcd8739ae039)(companyData, superchartComparisonData);
    const superchartIndicatorData = (0, $70fFQ.useMemo)(()=>{
        // The actual chart data to render for the indicators.
        if (!companyIndicatorData) return [];
        return availableIndicators.filter((indicator)=>Boolean(selectedIndicators.find((i)=>i.name === indicator.id))).map((indicator)=>({
                ...indicator,
                color: selectedIndicators.find((i)=>i.name === indicator.id).color
            }));
    }, [
        availableIndicators,
        companyIndicatorData,
        selectedIndicators
    ]);
    const onSelectComparison = (0, $70fFQ.useCallback)((security)=>{
        setMode($81a940f400b753fe$var$COMPARISON_MODE);
        if (comparisons.find((comp)=>comp.id === (0, $d37602e0c5798917$export$362d5c04bc4f464a)(security))) {
            dispatch({
                type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                message: `You've already added ${security.symbol} to the chart.`
            });
            return;
        }
        setComparisons([
            ...comparisons,
            {
                id: (0, $d37602e0c5798917$export$362d5c04bc4f464a)(security),
                type: (0, $d37602e0c5798917$export$e39f4ded596157ee)(security),
                name: security.symbol,
                color: (0, $0c153f15ec244d80$export$2e2bcd8739ae039)(),
                exchange: security.exchange,
                enabled: true
            }
        ]);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addComparisonToCompanyProfileLineChart(company?.name, security.symbol, security.exchange);
    }, [
        dispatch,
        comparisons,
        company?.name
    ]);
    const onRemoveComparison = (0, $70fFQ.useCallback)((comparisonId)=>{
        const removedComparison = comparisons.find((comp)=>comp.id === comparisonId);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).removeComparisonFromCompanyProfileLineChart(company?.name, removedComparison.name, removedComparison.exchange);
        const newComparisons = comparisons.filter((comp)=>comp.id !== comparisonId);
        if (newComparisons.length === 0) setMode($81a940f400b753fe$var$INDICATOR_MODE);
        setComparisons(newComparisons);
        updateHoveredLegendItem(null);
    }, [
        updateHoveredLegendItem,
        company?.name,
        comparisons
    ]);
    const onSelectIndicator = (0, $70fFQ.useCallback)((indicatorName)=>{
        if (companyData) {
            setMode($81a940f400b753fe$var$INDICATOR_MODE);
            setSelectedIndicators([
                ...new Set([
                    ...selectedIndicators,
                    {
                        name: indicatorName,
                        color: (0, $0c153f15ec244d80$export$2e2bcd8739ae039)()
                    }
                ])
            ]);
        }
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addIndicatorToCompanyProfileLineChart(company?.name, (0, $cd95af98ccabe80c$export$f8502645f74d42f8)[indicatorName].name);
    }, [
        company?.name,
        companyData,
        selectedIndicators
    ]);
    const onRemoveIndicator = (0, $70fFQ.useCallback)((source, indicatorName)=>{
        const newIndicators = selectedIndicators.filter((indicator)=>indicator.name !== indicatorName);
        if (newIndicators.length === 0) setMode($81a940f400b753fe$var$COMPARISON_MODE);
        setSelectedIndicators(newIndicators);
        updateHoveredLegendItem(null);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).removeIndicatorFromCompanyProfileLineChart(source, company?.name, (0, $cd95af98ccabe80c$export$f8502645f74d42f8)[indicatorName].name);
    }, [
        company?.name,
        updateHoveredLegendItem,
        selectedIndicators
    ]);
    const onRangeOptionChange = (0, $70fFQ.useCallback)((option)=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).changeCompanyProfileLineChartTimeFrame(company?.name, selectedRange, option);
        setSelectedRange(option);
    }, [
        company?.name,
        selectedRange
    ]);
    const [addComparisonDropdown, addComparisonRef, toggleAddComparisonDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(({ toggleIsOpen: toggleIsOpen })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $567ba063e88c5e09$export$2e2bcd8739ae039), {
            onSelectComparison: (security)=>{
                onSelectComparison(security);
                toggleIsOpen();
            }
        }));
    const chartData = (0, $70fFQ.useMemo)(()=>{
        if (!companyData) return null;
        // Get full list of dates from the `time` field of the comparisons and companyData. We
        // get the list based on the current mode, so we don't use comparison dates when we're
        // in indicator mode and vice versa.
        const filteredCompanyData = companyData.data.filter((datum)=>{
            if (mode === $81a940f400b753fe$var$COMPARISON_MODE) return datum.percent !== null;
            return datum.absolute !== null;
        });
        const allDates = [
            ...new Set([
                ...filteredCompanyData.map((data)=>data.time),
                ...mode === $81a940f400b753fe$var$COMPARISON_MODE ? superchartComparisonData.map((data)=>data.data.filter((datum)=>Object.keys(datum).length > 1).map((d)=>d.time)).flat() : [],
                ...mode === $81a940f400b753fe$var$INDICATOR_MODE || superchartComparisonData === 0 ? superchartIndicatorData.map((data)=>data.data.map((d)=>d.time)).flat() : []
            ].sort())
        ];
        // Construct these 3 specialized data structures to provide O(1) lookups in the allDates.map
        // step next.
        const companyDataPointsByDate = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).keyBy(companyData.data, "time");
        const comparisonDataByDate = mode === $81a940f400b753fe$var$COMPARISON_MODE ? superchartComparisonData.map((comparison)=>({
                id: comparison.id,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).keyBy(comparison.data, "time")
            })) : [];
        const indicatorDataByDate = mode === $81a940f400b753fe$var$INDICATOR_MODE || superchartComparisonData.length === 0 ? superchartIndicatorData.map((indicator)=>({
                id: indicator.id,
                name: indicator.name,
                getIndicatorValueObject: indicator.getIndicatorValueObject || (0, $dbdfce0a002f831e$export$2e2bcd8739ae039),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).keyBy(indicator.data, "time")
            })) : [];
        const transactionRecordDataByDate = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).groupBy(transactionRecordsData, (transactionRecord)=>{
            const transactionDate = transactionRecord.closing_date || transactionRecord.noticed_date;
            return (0, $86d2f3987cc9d604$exports.DateTime).fromISO(transactionDate).set({
                weekday: 5
            }).toISODate();
        });
        // Create a new list of data points, where each point contains the date, the percent and
        // absolute values from the companyData, the percent or absolute values from the indicator
        // data, and the percent values from the comparisonData, to be fed into the recharts LineGraph.
        return allDates.map((date)=>{
            const companyDataPoint = companyDataPointsByDate[date];
            const comparisonDataPoints = comparisonDataByDate.map(({ id: id, data: data })=>{
                const comparisonDataPoint = data[date];
                return comparisonDataPoint ? {
                    [id]: comparisonDataPoint.percent
                } : {};
            });
            const indicatorDataPoints = indicatorDataByDate.map(({ id: id, data: data, getIndicatorValueObject: getIndicatorValueObject })=>{
                const indicatorDataPoint = data[date];
                return indicatorDataPoint ? getIndicatorValueObject(id, indicatorDataPoint) : {};
            });
            const transactionRecordDataPoint = transactionRecordDataByDate[date] ? {
                transactionRecords: transactionRecordDataByDate[date],
                transactionRecordAverage: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).meanBy(transactionRecordDataByDate[date], (transactionRecord)=>Number(transactionRecord.price_per_share))
            } : {};
            return {
                time: date,
                percent: companyDataPoint?.percent,
                absolute: companyDataPoint?.absolute,
                ...Object.assign({}, ...comparisonDataPoints),
                ...Object.assign({}, ...indicatorDataPoints),
                ...transactionRecordDataPoint
            };
        });
    }, [
        companyData,
        mode,
        superchartComparisonData,
        superchartIndicatorData,
        transactionRecordsData
    ]);
    const lastPeriodDate = (0, $70fFQ.useMemo)(()=>{
        if (!chartData || chartData.length === 0) return null;
        return chartData[chartData.length - 1].time;
    }, [
        chartData
    ]);
    const displayedHoverDate = (0, $70fFQ.useMemo)(()=>{
        if (hoveredDate) return hoveredDate;
        return lastPeriodDate;
    }, [
        hoveredDate,
        lastPeriodDate
    ]);
    const hoveredChartElement = (0, $70fFQ.useMemo)(()=>{
        // Craftily, we'll store the actual rendering of the hovered line in memory so we can render
        // it last in the DOM, and make it appear above the greyed-out lines. We'll use the uniqueness
        // of the legend item IDs, and the fact that all data charted conforms to the same shape to
        // achieve this.
        if (hoveredLegendItem === null) return null;
        if (hoveredLegendItem.isVolume) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $70fFQ.createElement)((0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1), {
                    ...$81a940f400b753fe$var$SHARED_BAR_PROPS,
                    key: `${hoveredLegendItem.id}_bid`,
                    dataKey: `${hoveredLegendItem.id}_bid`,
                    fill: (0, $78cf78541be2071b$export$29792b0afe15a7ce).green
                }),
                /*#__PURE__*/ (0, $70fFQ.createElement)((0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1), {
                    ...$81a940f400b753fe$var$SHARED_BAR_PROPS,
                    style: {
                        transform: "translateY(-2px)"
                    },
                    key: `${hoveredLegendItem.id}_offer`,
                    dataKey: `${hoveredLegendItem.id}_offer`,
                    fill: (0, $78cf78541be2071b$export$29792b0afe15a7ce).red
                })
            ]
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $32207b201d0eab60$export$17d680238e50603e), {
            ...$81a940f400b753fe$var$getLineProps(hoveredLegendItem, displayedHoverDate),
            dataKey: hoveredLegendItem.dataKey || hoveredLegendItem.id
        });
    }, [
        hoveredLegendItem,
        displayedHoverDate
    ]);
    if (!company || !companyData || !companyData.data?.length > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($81a940f400b753fe$var$StyledLineGraphLayout, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($81a940f400b753fe$var$StyledGraphControlRow, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                                id: "add-comparison-button",
                                disabled: true,
                                onClick: toggleAddComparisonDropdown,
                                ref: addComparisonRef,
                                icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                children: "Comparisons"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $76a49a5fc1820df9$export$2e2bcd8739ae039), {
                                disabled: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $cc46139b4b8262d4$export$2e2bcd8739ae039), {
                        title: null,
                        defaultOption: selectedRange,
                        onOptionChange: onRangeOptionChange,
                        options: [
                            {
                                label: (0, $cd95af98ccabe80c$export$99d24ef84589a5ba)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$ee25c2a2e8e534bf)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$8f1924ffed232894)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$6f4aa2efcb73a5b2)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$e19a6d70f5805ce3)
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $2e5a4ca8ae099b29$export$e60a4704009a0009), {
                width: "100%",
                height: 300,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d86fd0d5243d41f1$export$54d0e8420ac838ac), {
                        width: 500,
                        height: 300,
                        data: [],
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3ece4213e6b51d98$export$6440e27b9f186856), {
                            horizontalPoints: [
                                0,
                                75,
                                150,
                                225,
                                300
                            ],
                            vertical: false,
                            stroke: (0, $dfd33cee3229493c$exports.ColorPalette).white05
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($81a940f400b753fe$var$StyledAbsoluteEmptyPill, {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$81d8b526340b2d71), {
                            $margin: 0,
                            children: companyIsLoading ? "Loading..." : "No data available"
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($81a940f400b753fe$var$StyledLineGraphLayout, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($81a940f400b753fe$var$StyledGraphControlRow, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                                id: "add-comparison-button",
                                active: addComparisonDropdown,
                                onClick: toggleAddComparisonDropdown,
                                ref: addComparisonRef,
                                icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                children: "Comparisons"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $76a49a5fc1820df9$export$2e2bcd8739ae039), {
                                availableIndicators: availableIndicators,
                                addIndicator: onSelectIndicator,
                                removeIndicator: (indicatorName)=>onRemoveIndicator("dropdown", indicatorName),
                                selectedIndicators: selectedIndicators
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $cc46139b4b8262d4$export$2e2bcd8739ae039), {
                        title: null,
                        defaultOption: selectedRange,
                        onOptionChange: onRangeOptionChange,
                        disabled: !company,
                        options: [
                            {
                                label: (0, $cd95af98ccabe80c$export$99d24ef84589a5ba)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$ee25c2a2e8e534bf)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$8f1924ffed232894)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$6f4aa2efcb73a5b2)
                            },
                            {
                                label: (0, $cd95af98ccabe80c$export$e19a6d70f5805ce3)
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($81a940f400b753fe$var$StyledLegendContainer, {
                children: [
                    companyData && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ced6f69c885580a1$export$2e2bcd8739ae039), {
                        isHovered: hoveredLegendItem?.id === companyData.id,
                        onMouseEnter: ()=>updateHoveredLegendItem({
                                ...companyData,
                                dataKey: companyDataKey
                            }),
                        onMouseLeave: ()=>updateHoveredLegendItem(null),
                        chartElement: {
                            ...companyData,
                            name: mode === $81a940f400b753fe$var$COMPARISON_MODE || selectedIndicators.length === 0 ? companyData.name : "ZX Index Value - Current",
                            exchange: mode === $81a940f400b753fe$var$COMPARISON_MODE ? companyData.exchange : null
                        },
                        onRemove: null,
                        hoveredDate: displayedHoverDate
                    }),
                    (mode === $81a940f400b753fe$var$INDICATOR_MODE || comparisons.length === 0) && superchartIndicatorData.map((indicator)=>{
                        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(indicator.LegendItem, {
                            isHovered: hoveredLegendItem?.id === indicator.id,
                            onMouseEnter: ()=>updateHoveredLegendItem(indicator),
                            onMouseLeave: ()=>updateHoveredLegendItem(null),
                            onRemove: ()=>onRemoveIndicator("legend", indicator.id),
                            hoveredDate: displayedHoverDate,
                            chartElement: indicator
                        }, `legend_${indicator.id}`);
                    }),
                    mode === $81a940f400b753fe$var$COMPARISON_MODE && superchartComparisonData.map((comparison)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ced6f69c885580a1$export$2e2bcd8739ae039), {
                            isHovered: hoveredLegendItem?.id === comparison.id,
                            onMouseEnter: ()=>updateHoveredLegendItem(comparison),
                            onMouseLeave: ()=>updateHoveredLegendItem(null),
                            onRemove: ()=>onRemoveComparison(comparison.id),
                            chartElement: comparison,
                            hoveredDate: displayedHoverDate
                        }, `legend_${comparison.id}`))
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2e5a4ca8ae099b29$export$e60a4704009a0009), {
                width: "100%",
                height: 300,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $fb5252d4c65f633c$export$f881f4f9e4007a57), {
                    width: 500,
                    height: 300,
                    data: chartData,
                    margin: {
                        left: 20,
                        right: 8,
                        top: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3ece4213e6b51d98$export$6440e27b9f186856), {
                            vertical: false,
                            stroke: "rgba(255, 255, 255, 0.05)"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ee3eb083333526ae$export$ea77231de273b52d), {
                            interval: 0,
                            fontSize: (0, $cd95af98ccabe80c$export$1a36fc7a09bd0584),
                            dy: 8,
                            tickFormatter: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromISO(value).toFormat("MMM"),
                            ticks: xAxisTicks,
                            dataKey: "time"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4), {
                            width: 0,
                            yAxisId: "volumeYAxis",
                            domain: [
                                0,
                                (dataMax)=>dataMax * 3
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4), {
                            domain: [
                                "dataMin",
                                "dataMax"
                            ],
                            orientation: "right",
                            fontSize: (0, $cd95af98ccabe80c$export$1a36fc7a09bd0584),
                            tickFormatter: (value)=>mode === $81a940f400b753fe$var$INDICATOR_MODE || comparisons.length === 0 ? (0, $66339e7a022e68c9$export$736d072c44caa715)(value) : (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(value)
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9c6bfe96f56d0a02$export$28c660c63b792dea), {
                            allowEscapeViewBox: {
                                x: true
                            },
                            wrapperStyle: (0, $cd95af98ccabe80c$export$2dd871b9b6883c28),
                            cursor: {
                                stroke: (0, $dfd33cee3229493c$exports.ColorPalette).white50,
                                strokeWidth: 1
                            },
                            content: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $b943d1910a3fe883$export$2e2bcd8739ae039), {
                                setHoveredDate: setHoveredDate,
                                companyName: company?.name,
                                comparisonCount: comparisons.length,
                                indicatorCount: superchartIndicatorData.length
                            })
                        }),
                        mode === $81a940f400b753fe$var$COMPARISON_MODE && superchartComparisonData.map((comparison)=>hoveredLegendItem?.id === comparison.id ? null : /*#__PURE__*/ (0, $70fFQ.createElement)((0, $32207b201d0eab60$export$17d680238e50603e), {
                                ...$81a940f400b753fe$var$getLineProps(comparison, displayedHoverDate),
                                key: comparison.id,
                                stroke: hoveredLegendItem === null ? comparison.color : (0, $dfd33cee3229493c$exports.YukaColorPalette).surface3
                            })),
                        (mode === $81a940f400b753fe$var$INDICATOR_MODE || comparisons.length === 0) && superchartIndicatorData.map((indicator)=>{
                            if (hoveredLegendItem?.id === indicator.id) // We can return null for this indicator b/c it'll be rendered
                            // by `hoveredChartElement`.
                            return null;
                            if (indicator.isVolume) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $70fFQ.createElement)((0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1), {
                                        ...$81a940f400b753fe$var$SHARED_BAR_PROPS,
                                        activeBar: (0, $09f8ecdf3f34b551$export$2e2bcd8739ae039)(`${indicator.id}_bid`, (0, $78cf78541be2071b$export$29792b0afe15a7ce).green, 0),
                                        key: `${indicator.id}_bid`,
                                        dataKey: `${indicator.id}_bid`,
                                        fill: (0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).green, 0.5)
                                    }),
                                    /*#__PURE__*/ (0, $70fFQ.createElement)((0, $7c0a47df8064ce07$export$bbc6c6369b38e3d1), {
                                        ...$81a940f400b753fe$var$SHARED_BAR_PROPS,
                                        activeBar: (0, $09f8ecdf3f34b551$export$2e2bcd8739ae039)(`${indicator.id}_offer`, (0, $78cf78541be2071b$export$29792b0afe15a7ce).red, 1),
                                        style: {
                                            transform: "translateY(-2px)"
                                        },
                                        key: `${indicator.id}_offer`,
                                        dataKey: `${indicator.id}_offer`,
                                        fill: (0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).red, 0.5)
                                    })
                                ]
                            });
                            return /*#__PURE__*/ (0, $70fFQ.createElement)((0, $32207b201d0eab60$export$17d680238e50603e), {
                                ...$81a940f400b753fe$var$getLineProps(indicator, displayedHoverDate),
                                key: indicator.id,
                                stroke: hoveredLegendItem === null ? indicator.color : (0, $dfd33cee3229493c$exports.YukaColorPalette).surface3
                            });
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $32207b201d0eab60$export$17d680238e50603e), {
                            ...$81a940f400b753fe$var$getLineProps(companyData, displayedHoverDate),
                            dataKey: companyDataKey,
                            stroke: hoveredLegendItem === null ? companyData.color : (0, $dfd33cee3229493c$exports.YukaColorPalette).surface3
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $da1a64f3d803bb82$export$1c460fb4285edadc), {
                            stroke: "yellow",
                            fill: (0, $78cf78541be2071b$export$29792b0afe15a7ce).yellow,
                            valueKey: "time",
                            dataKey: "transactionRecordAverage",
                            shape: "triangle",
                            isAnimationActive: false,
                            onClick: ()=>{
                                onClickClosedTransaction({
                                    animate: false
                                });
                            },
                            style: {
                                cursor: "pointer"
                            },
                            activeShape: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $b03b683f83f72751$export$fa456266707bf4e4), {
                                type: "triangle",
                                opacity: 1
                            }),
                            opacity: 0.8
                        }),
                        hoveredChartElement
                    ]
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.PageSection), {
                children: addComparisonDropdown
            })
        ]
    });
};
$81a940f400b753fe$var$CompanyProfileLineGraph.propTypes = {
    onClickClosedTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $81a940f400b753fe$export$2e2bcd8739ae039 = $81a940f400b753fe$var$CompanyProfileLineGraph;











const $267cddf137cb984e$var$StyledContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)};
  flex-grow: 1;
  border: none;
  margin-top: -24px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  background-image: linear-gradient(
      to right,
      ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface0},
      ${(0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.YukaColorPalette).surface0, 0.4)},
      ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface0}
    ),
    url(${(0, {})});

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
const $267cddf137cb984e$var$CompanyProfileNoAccess = ()=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($267cddf137cb984e$var$StyledContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme50, {
                children: "You don't have access to this company profile"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES(),
                children: "Back to company screener"
            })
        ]
    });
};
var $267cddf137cb984e$export$2e2bcd8739ae039 = $267cddf137cb984e$var$CompanyProfileNoAccess;






var $70fFQ = parcelRequire("70fFQ");



var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");












const $646aac5d606715dc$var$StyledCompanyName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $646aac5d606715dc$var$StyledCardContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 0 16px;
  height: 136px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $646aac5d606715dc$var$StyledChartContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $2e5a4ca8ae099b29$export$e60a4704009a0009))`
  position: absolute;
  left: 0;
  bottom: 0;
`;
const $646aac5d606715dc$var$CompanyQuickPriceCard = ({ companyId: companyId, onClick: onClick })=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const companyQuery = (0, $c0097679c2d88aee$export$2e2bcd8739ae039)(companyId, {}, {
        redirectOnFail: false
    });
    const orderFlowQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_PRICE_VOLUME_ORDER_FLOW(), {
        company: companyId,
        end_date: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
            days: 1
        }).toISODate(),
        start_date: (0, $86d2f3987cc9d604$exports.DateTime).now().minus({
            years: 1
        }).toISODate()
    }, {
        enabled: Boolean(companyId && companyQuery.isSuccess)
    });
    const company = (0, $70fFQ.useMemo)(()=>{
        if (companyQuery.isSuccess) return companyQuery.cleanedData.data;
        return null;
    }, [
        companyQuery.isSuccess,
        companyQuery.cleanedData
    ]);
    const [currentZXIndexPrice, currentPercentageChange] = (0, $70fFQ.useMemo)(()=>{
        if (!orderFlowQuery.isSuccess) return [
            null,
            null
        ];
        return [
            orderFlowQuery.cleanedData.data[0]?.zx_index_price,
            orderFlowQuery.cleanedData.data[0]?.zx_index_value_percent_change
        ];
    }, [
        orderFlowQuery.isSuccess,
        orderFlowQuery.cleanedData
    ]);
    const tinyChartData = (0, $70fFQ.useMemo)(()=>{
        if (!orderFlowQuery.isSuccess) return [];
        return orderFlowQuery.cleanedData.data.map((report)=>({
                price: Number(report.zx_index_price),
                time: report.report_period
            })).reverse();
    }, [
        orderFlowQuery.isSuccess,
        orderFlowQuery.cleanedData
    ]);
    const priceDisplay = (0, $70fFQ.useMemo)(()=>{
        if (currentZXIndexPrice === null) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme50, {
            children: "--"
        });
        if (currentPercentageChange > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline2buy, {
            children: [
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(currentZXIndexPrice, 2, 2),
                " (+",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(currentPercentageChange * 100),
                ")"
            ]
        });
        if (currentPercentageChange < 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline2sell, {
            children: [
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(currentZXIndexPrice, 2, 2),
                " (",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(currentPercentageChange * 100),
                ")"
            ]
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
            children: [
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(currentZXIndexPrice),
                " (+",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(currentPercentageChange * 100),
                ")"
            ]
        });
    }, [
        currentZXIndexPrice,
        currentPercentageChange
    ]);
    const graphColor = (0, $70fFQ.useMemo)(()=>{
        if (!Number(currentPercentageChange)) return (0, $dfd33cee3229493c$exports.ColorPalette).white50;
        if (currentPercentageChange > 0) return (0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).green, 0.5);
        return (0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).red, 0.5);
    }, [
        currentPercentageChange
    ]);
    if (companyQuery.isLoading || orderFlowQuery.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).MINIMAL,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($646aac5d606715dc$var$StyledCardContent, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                children: "Loading..."
            })
        })
    });
    if (!company) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).MINIMAL,
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($646aac5d606715dc$var$StyledCardContent, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                children: "An error has occurred."
            })
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4c73d5d1e08d057$export$2e2bcd8739ae039), {
        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).MINIMAL,
        onClick: ()=>{
            onClick(company.name);
            navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANY(companyId));
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($646aac5d606715dc$var$StyledCardContent, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($646aac5d606715dc$var$StyledCompanyName, {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                            children: company.name
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                            children: company.legal_name
                        })
                    ]
                }),
                priceDisplay,
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($646aac5d606715dc$var$StyledChartContainer, {
                    width: "100%",
                    height: 48,
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $d86fd0d5243d41f1$export$54d0e8420ac838ac), {
                        data: tinyChartData,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $fcdeec4b2ff3583d$export$f96c4024c52de8f4), {
                                hide: true,
                                type: "number",
                                domain: [
                                    "dataMin",
                                    "dataMax"
                                ]
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $32207b201d0eab60$export$17d680238e50603e), {
                                type: "monotone",
                                dataKey: "price",
                                stroke: graphColor,
                                strokeWidth: 1,
                                dot: false
                            })
                        ]
                    })
                })
            ]
        })
    });
};
$646aac5d606715dc$var$CompanyQuickPriceCard.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
$646aac5d606715dc$var$CompanyQuickPriceCard.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
};
var $646aac5d606715dc$export$2e2bcd8739ae039 = $646aac5d606715dc$var$CompanyQuickPriceCard;




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");



/**
 * To be used by the Most active companies and similar companies carousels. Used to indicate
 * there is no data to display.
 */ const $06d4c3a7ca127814$var$EmptyCompanyCarousel = ({ title: title })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$d407bf5e3affaa77), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
                children: title
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$144901db2ea8e967), {
                slidesToScroll: 6,
                empty: true,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$c1bff280f3570f68), {
                    children: [
                        ...Array(7)
                    ].map((_, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$42c20acb2971398c), {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5879f76b7a709cc$export$63d0ed8ace03c0a7), {}, index)
                        }, `empty_card_${index}`))
                })
            })
        ]
    });
$06d4c3a7ca127814$var$EmptyCompanyCarousel.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
var $06d4c3a7ca127814$export$2e2bcd8739ae039 = $06d4c3a7ca127814$var$EmptyCompanyCarousel;










const $8164fead0f867c61$var$MostActiveCompanies = ()=>{
    const { dispatch: dispatch } = (0, $70fFQ.useContext)((0, $46a097389bbbbe65$export$7feebea0001a7c34));
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const mostActiveCompaniesQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_LATEST_ORDER_FLOW(), {
        time_frame: (0, $753b8dcbe6be17f9$export$e15589d55377682c),
        most_active: true,
        "page[size]": 12
    });
    const mostActiveCompanies = (0, $70fFQ.useMemo)(()=>{
        if (!mostActiveCompaniesQuery.isSuccess) return null;
        return mostActiveCompaniesQuery.cleanedData.data.map((company)=>company.apiId);
    }, [
        mostActiveCompaniesQuery.isSuccess,
        mostActiveCompaniesQuery.cleanedData
    ]);
    if (companyIsLoading || !mostActiveCompanies || mostActiveCompanies.length === 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $06d4c3a7ca127814$export$2e2bcd8739ae039), {
        title: "Most active companies"
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$d407bf5e3affaa77), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
                children: "Most active companies"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $003dc761c92dedde$export$144901db2ea8e967), {
                slidesToScroll: 6,
                onScrollNext: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollMostActiveCompaniesCarousel("next", company?.name),
                onScrollPrev: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollMostActiveCompaniesCarousel("prev", company?.name),
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$c1bff280f3570f68), {
                        children: mostActiveCompanies.map((companyId, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $646aac5d606715dc$export$2e2bcd8739ae039), {
                                    companyId: companyId,
                                    onClick: (companyName)=>{
                                        dispatch({
                                            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).updateMixpanelEventSource,
                                            source: "most active companies carousel",
                                            target: (0, $46a097389bbbbe65$export$796b285b8ee8898e)
                                        });
                                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateToMostActiveCompany(company?.name, companyName);
                                    }
                                })
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$fefc80bbaaa2e887), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$434129336ddede1b), {}),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$75fd771fe00f2b45), {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $8164fead0f867c61$export$2e2bcd8739ae039 = $8164fead0f867c61$var$MostActiveCompanies;




var $70fFQ = parcelRequire("70fFQ");












const $9857c31224d8aa0a$var$SimilarCompanies = ()=>{
    const { dispatch: dispatch } = (0, $70fFQ.useContext)((0, $46a097389bbbbe65$export$7feebea0001a7c34));
    const { id: companyId } = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const [company, companyIsLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    const sectorsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_SECTORS(), {
        company: companyId
    }, {
        enabled: Boolean(companyId)
    });
    const sectorIds = (0, $70fFQ.useMemo)(()=>{
        if (sectorsQuery.isLoading || sectorsQuery.isError) return [];
        return (sectorsQuery.cleanedData.data || []).map((sector)=>sector.apiId);
    }, [
        sectorsQuery
    ]);
    const similarCompaniesQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_LATEST_ORDER_FLOW(), {
        time_frame: (0, $753b8dcbe6be17f9$export$e15589d55377682c),
        sectors: sectorIds,
        most_active: true,
        "page[size]": 12
    });
    const similarCompanies = (0, $70fFQ.useMemo)(()=>{
        if (!similarCompaniesQuery.isSuccess) return null;
        return similarCompaniesQuery.cleanedData.data.map((company)=>company.apiId).filter((id)=>id !== companyId);
    }, [
        companyId,
        similarCompaniesQuery.isSuccess,
        similarCompaniesQuery.cleanedData
    ]);
    if (companyIsLoading || !similarCompanies || similarCompanies.length === 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $06d4c3a7ca127814$export$2e2bcd8739ae039), {
        title: "Similar companies"
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$d407bf5e3affaa77), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
                children: "Similar companies"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $003dc761c92dedde$export$144901db2ea8e967), {
                slidesToScroll: 6,
                onScrollNext: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollSimilarCompaniesCarousel("next", company?.name),
                onScrollPrev: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).scrollSimilarCompaniesCarousel("prev", company?.name),
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$c1bff280f3570f68), {
                        children: similarCompanies.map((companyId, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $646aac5d606715dc$export$2e2bcd8739ae039), {
                                    companyId: companyId,
                                    onClick: (similarCompanyName)=>{
                                        dispatch({
                                            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).updateMixpanelEventSource,
                                            source: "similar companies carousel",
                                            target: (0, $46a097389bbbbe65$export$796b285b8ee8898e)
                                        });
                                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateToSimilarCompany(company?.name, similarCompanyName);
                                    }
                                })
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f5879f76b7a709cc$export$fefc80bbaaa2e887), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$434129336ddede1b), {}),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $003dc761c92dedde$export$75fd771fe00f2b45), {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $9857c31224d8aa0a$export$2e2bcd8739ae039 = $9857c31224d8aa0a$var$SimilarCompanies;














// Using a container div because the ref isn't working on ClosedTransactionsCard for some reason
// Need 80px otherwise the card will be hidden behind the floating header
const $c59749d2fd779010$var$ClosedTransactionsCardContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  scroll-margin-top: 80px;
`;
const $c59749d2fd779010$var$CompanyProfileContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: relative;
  height: 100%;
  width: 100%;
  margin-top: -16px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $c59749d2fd779010$var$CompanyProfileLayout = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)};

  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;

  > * {
    flex-shrink: 0;
  }
`;
const $c59749d2fd779010$var$StyledColumnSection = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 24px;
  grid-template-columns: 2fr 1fr;
  grid-template-areas:
    "general user"
    "mostactive mostactive"
    "sitefooter sitefooter";

  > :first-child {
    grid-area: general;
  }
  > :nth-child(2) {
    grid-area: user;
  }
  > :nth-child(3) {
    grid-area: mostactive;
  }
  > :nth-child(4) {
    grid-area: sitefooter;
  }
`;
const $c59749d2fd779010$var$StyledGeneralCompanyInformation = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr;

  > :first-child {
    grid-column: span 1;
  }
  > :nth-child(2) {
    grid-column: span 1;
  }
  > :not(:first-child):not(:nth-child(2)) {
    grid-column: span 2;
  }
`;
const $c59749d2fd779010$var$StyledNoAccess = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
const $c59749d2fd779010$var$StyledUserCompanyInformation = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $c59749d2fd779010$var$COMPANY_PROFILE_HEADER_BREAKPOINT = 232;
const $c59749d2fd779010$var$WALKTHROUGH_STEPS = [
    {
        title: "Welcome to the new company profile",
        text: "Our redesigned company profile offers a more intuitive and informative experience, providing a deeper range of data points and insights. Discover new opportunities and make more informed investment decisions with our revamped company profiles.",
        positionSelector: null,
        width: 600
    },
    {
        title: "Compare and contrast",
        text: "Benchmark this company against other private companies, public symbols, and our ZX private market indices to gain a better understanding of its performance over time.",
        positionSelector: "#add-comparison-button"
    },
    {
        title: "Dive deeper with indicators",
        text: "Add indicators to enhance your analysis.",
        positionSelector: "#add-indicator-button"
    },
    {
        title: "Stay informed",
        text: "Easily monitor your holdings or stay informed about this company by adding it to one of your portfolios.",
        positionSelector: "#add-company-to-portfolio-button"
    }
];
const $c59749d2fd779010$var$CompanyProfile = ()=>{
    const source = (0, $46a097389bbbbe65$export$646567740a5dfaed)((0, $46a097389bbbbe65$export$796b285b8ee8898e));
    const containerRef = (0, $70fFQ.useRef)(null);
    const closedTransactionsRef = (0, $70fFQ.useRef)(null);
    const { walkthroughShowing: walkthroughShowing, completeWalkthrough: completeWalkthrough } = (0, $f7a9c013198e3a53$export$2e2bcd8739ae039)("walkthrough_company_profile");
    const [, scrollToTop, , distanceFromTop] = (0, $cf715cdf7b4bb119$export$2e2bcd8739ae039)({
        scrollRef: containerRef,
        onScrollUp: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
        onScrollDown: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop
    });
    const [company, companyLoading] = (0, $5e1940079019bdf2$export$2e2bcd8739ae039)();
    (0, $90c290bf538e7f9d$export$2e2bcd8739ae039)(company?.name ? `ZXData: ${company.name}` : "ZXData");
    (0, $70fFQ.useEffect)(()=>{
        // Scroll to top when the company name changes, since we can navigate to other companies
        // within this profile using LOCAL_LINK hyperlinks, which won't trigger a rerender all the time.
        if (company?.name) scrollToTop({
            animate: false
        });
    }, [
        company?.name,
        scrollToTop
    ]);
    const [sacraDocumentsFeatureEnabled] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$6eae34c76cd5f0ad));
    const [portfolioFeatureEnabled] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$6d4c76a833ca8f22));
    const [closedTransactionsEnabled] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$8fd6bef7337a1255));
    const { hasAnyAccess: hasAnyAccess, canViewSacraDocuments: canViewSacraDocuments, canViewClosedTransactions: canViewClosedTransactions, isLoading: isLoadingAccess } = (0, $063f7f1279c82c38$export$2e2bcd8739ae039)(company);
    (0, $70fFQ.useEffect)(()=>{
        if (!companyLoading && company !== null) {
            (0, $3d0a219733fde2aa$export$d604d20474eedda8)(company);
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).viewCompanyProfile(source, company.name);
        }
    }, [
        source,
        companyLoading,
        company
    ]);
    if (companyLoading || isLoadingAccess) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    if (!company) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($c59749d2fd779010$var$CompanyProfileContainer, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "An error has occurred."
        })
    });
    const scrollToClosedTransactions = ()=>{
        closedTransactionsRef.current?.scrollIntoView();
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            button: {
                [(0, $dfd33cee3229493c$exports.ButtonStyles).CTA]: {
                    container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
                },
                [(0, $dfd33cee3229493c$exports.ButtonStyles).RAISED]: {
                    container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
                }
            }
        },
        children: [
            hasAnyAccess && walkthroughShowing && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $94e97caba62a953c$export$2e2bcd8739ae039), {
                name: "company profile",
                steps: $c59749d2fd779010$var$WALKTHROUGH_STEPS,
                onFinish: completeWalkthrough
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c59749d2fd779010$var$CompanyProfileContainer, {
                $floatingHeader: distanceFromTop >= $c59749d2fd779010$var$COMPANY_PROFILE_HEADER_BREAKPOINT,
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $4bbc60df02440f0f$export$2e2bcd8739ae039), {
                        floating: true,
                        hidden: distanceFromTop < $c59749d2fd779010$var$COMPANY_PROFILE_HEADER_BREAKPOINT
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c59749d2fd779010$var$CompanyProfileLayout, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $4bbc60df02440f0f$export$2e2bcd8739ae039), {
                                floating: false,
                                hidden: false
                            }),
                            hasAnyAccess ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $81a940f400b753fe$export$2e2bcd8739ae039), {
                                        onClickClosedTransaction: scrollToClosedTransactions
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7dab3f73260568e2$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c59749d2fd779010$var$StyledColumnSection, {
                                        children: [
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c59749d2fd779010$var$StyledGeneralCompanyInformation, {
                                                children: [
                                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a834045649dba913$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6d0b58065a03cb25$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d0963f91212dde52$export$2e2bcd8739ae039), {}),
                                                    closedTransactionsEnabled && canViewClosedTransactions && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($c59749d2fd779010$var$ClosedTransactionsCardContainer, {
                                                        ref: closedTransactionsRef,
                                                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6637df40dcad5da3$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bbcf64687823cf5e$export$2e2bcd8739ae039), {}),
                                                    sacraDocumentsFeatureEnabled && company.show_sacra_documents && canViewSacraDocuments && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9d636a90fdf6e0e6$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a322506e0b6f743d$export$2e2bcd8739ae039), {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c59749d2fd779010$var$StyledUserCompanyInformation, {
                                                children: [
                                                    portfolioFeatureEnabled && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ddb71d6eb587cb49$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6c2bed80dab78dd2$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6d36351144df98c3$export$2e2bcd8739ae039), {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9857c31224d8aa0a$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $8164fead0f867c61$export$2e2bcd8739ae039), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $253eff529b7bdd6f$export$2e2bcd8739ae039), {})
                                ]
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c59749d2fd779010$var$StyledNoAccess, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $267cddf137cb984e$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $253eff529b7bdd6f$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $c59749d2fd779010$export$2e2bcd8739ae039 = $c59749d2fd779010$var$CompanyProfile;






var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");






var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");








const $7c3793a1dcab3cf8$var$StyledProfileButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Button)).attrs({
    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED
})`
  padding: 8px 12px;
  height: 40px;
`;
const $7c3793a1dcab3cf8$var$AvatarContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 24px;
  height: 24px;
  margin-right: 12px;
`;
const $7c3793a1dcab3cf8$var$UserNameContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin-right: 8px;
`;
/**
 * Renders a card with the users profile information that has an anchored menu.
 *
 * @returns {React.Element}
 */ const $7c3793a1dcab3cf8$var$ProfileInfo = ()=>{
    const { user: user, logout: logout } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const menuItems = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).compact([
        {
            url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).ACCOUNT(),
            icon: (0, $dfd33cee3229493c$exports.UserCircleIcon),
            linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
            onClick: ()=>{
                toggleDisplay();
                (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).viewAccountSettings();
            },
            text: "Account"
        },
        {
            // No `url` here on purpose: rendering Log Out as an anchor pointing at
            // /login lets the browser navigate before the logout request completes
            // (and historically left the refresh token live on the server). The
            // button form fires onClick only; logout() handles routing after the
            // backend call resolves. See ZX-15031.
            text: "Log Out",
            icon: (0, $dfd33cee3229493c$exports.LogOutIcon),
            linkType: (0, $dfd33cee3229493c$exports.LinkTypes).BUTTON,
            onClick: logout
        }
    ]);
    const [dropdownElement, targetRef, toggleDisplay] = (0, $199c364f599190d4$export$2e2bcd8739ae039)({
        id: "UserProfileMenu",
        sectioned: true,
        orientation: (0, $dfd33cee3229493c$exports.Orientations).VERTICAL,
        menuItems: [
            {
                menuItems: menuItems
            }
        ]
    });
    const profileInfoTarget = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7c3793a1dcab3cf8$var$StyledProfileButton, {
        ref: targetRef,
        onClick: toggleDisplay,
        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
        leadingIcon: ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7c3793a1dcab3cf8$var$AvatarContainer, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7759a50ff4d048a0$export$2e2bcd8739ae039), {
                    user: user,
                    size: "24px"
                })
            }),
        trailingIcon: (0, $dfd33cee3229493c$exports.ChevronDownIcon),
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($7c3793a1dcab3cf8$var$UserNameContainer, {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: (0, $a7ce25f64c8a45a1$export$1a50cbca5efbfbf9)(user)
            })
        })
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
        children: [
            profileInfoTarget,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).createPortal(dropdownElement, document.body)
        ]
    });
};
var $7c3793a1dcab3cf8$export$2e2bcd8739ae039 = $7c3793a1dcab3cf8$var$ProfileInfo;






var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



const $8ad59d289eb882fd$export$8b12118a302a8fe8 = 64;




var $cd0Jr = parcelRequire("cd0Jr");


const $1fd7e8665c70ce17$var$StyledKeyContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white30};
  border-radius: 4px;
  width: 16px;
  height: 16px;
`;
const $1fd7e8665c70ce17$var$StyledHotkeyPrompt = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30).attrs({
    as: "div"
})`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 10px;
`;
const $1fd7e8665c70ce17$var$HotkeyPrompt = ({ action: action, hotkey: Hotkey })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($1fd7e8665c70ce17$var$StyledHotkeyPrompt, {
        children: [
            "Type",
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($1fd7e8665c70ce17$var$StyledKeyContainer, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(Hotkey, {
                    size: 12,
                    color: (0, $dfd33cee3229493c$exports.ColorPalette).white30
                })
            }),
            "to ",
            action
        ]
    });
};
$1fd7e8665c70ce17$var$HotkeyPrompt.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    hotkey: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $1fd7e8665c70ce17$export$2e2bcd8739ae039 = $1fd7e8665c70ce17$var$HotkeyPrompt;













var $70fFQ = parcelRequire("70fFQ");

const $dd2c7087b54d88e8$var$UnhighlightedText = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.FontColors).theme30}
`;
/**
 * Based on a search, highlight the matching sections of text.
 *
 * Note that the current styles have the "highlighted" text color match the default;
 * we are actually just dimming the rest of the text
 *
 * @param {string} text
 * @param {string} search
 * @param {React.Element?} HighlightElement - Optional element to use to render the text portion
 *  that matches the search term. Defaults to a regular <span> that will inherit styling.
 * @param {React.Element?} NoMatchElement - Optional element to render in place of the text
 *  when the search term is not present. Defaults to a regular <span> that will inherit styling.
 *
 * @returns {React.Fragment}
 */ const $dd2c7087b54d88e8$var$highlightText = (text, search, HighlightElement = null, NoMatchElement = null)=>{
    const lowerText = text.toLowerCase();
    // Return unchanged text if search term is not present
    if (!search.trim() || !lowerText.includes(search.toLowerCase().trim())) return NoMatchElement ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(NoMatchElement, {
        children: text
    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
        children: text
    });
    const tokens = search.split(" ");
    const indexes = tokens.map((token)=>({
            index: lowerText.indexOf(token.toLowerCase()),
            token: token
        })).sort((a, b)=>a.index - b.index);
    const resultSegments = [];
    let prevEnd = 0;
    indexes.forEach(({ index: index, token: token })=>{
        if (index > prevEnd) {
            resultSegments.push(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dd2c7087b54d88e8$var$UnhighlightedText, {
                children: text.slice(prevEnd, index)
            }));
            prevEnd = index;
        }
        if (index + token.length > prevEnd) {
            const textSlice = text.slice(prevEnd, index + token.length);
            resultSegments.push(HighlightElement ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(HighlightElement, {
                children: textSlice
            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                children: textSlice
            }));
            prevEnd = index + token.length;
        }
    });
    if (prevEnd < text.length) resultSegments.push(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($dd2c7087b54d88e8$var$UnhighlightedText, {
        children: text.slice(prevEnd)
    }));
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
        children: resultSegments
    });
};
var $dd2c7087b54d88e8$export$2e2bcd8739ae039 = $dd2c7087b54d88e8$var$highlightText;








const $1a448af5be72ffe3$var$StyledResultHeader = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.FontColors).theme30}
  ${(0, $dfd33cee3229493c$exports.overline)}
  align-items: center;
  display: flex;
  margin: 0 16px 0;
`;
const $1a448af5be72ffe3$var$StyledNoResults = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.body1)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  text-align: center;
  margin-top: 27px;
  margin-bottom: 27px;
`;
const $1a448af5be72ffe3$var$StyledSearchBarContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: auto;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;
  min-width: 300px;
  max-width: 800px;
  border-radius: 12px;
`;
const $1a448af5be72ffe3$var$StyledSearchBar = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $a3cb2c0ab9bbfa1d$export$2e2bcd8739ae039))`
  overflow-y: auto;
  width: 100%;
  border: none;
  background: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface2};
`;
const $1a448af5be72ffe3$var$StyledDropdownContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  // show 6.5 items, indicating scrollability.
  max-height: ${(0, $8ad59d289eb882fd$export$8b12118a302a8fe8) * 7 - (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) / 2};
  margin-bottom: -16px; // Remove padding from bottom of scrollable region
  overflow-y: auto;
  width: 800px;
`;
const $1a448af5be72ffe3$var$HoverableListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  ${(props)=>props.$hovered ? (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          background: rgba(255, 255, 255, 0.05);
        ` : ``}

  > :first-child {
    flex-shrink: 0;
  }
`;
const $1a448af5be72ffe3$var$StyledTheme80 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
`;
const $1a448af5be72ffe3$var$StyledTheme30 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.FontColors).theme30}
`;
const $1a448af5be72ffe3$var$FETCH_NEXT_COMPANIES_PAGE_THRESHOLD = 104; // Height of two search results
const $1a448af5be72ffe3$var$MIN_SEARCH_QUERY_LENGTH = 1;
const $1a448af5be72ffe3$var$CompanySearch = ()=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const searchBarRef = (0, $70fFQ.useRef)(null);
    // Used for keyboard navigation.
    const scrollableListRef = (0, $70fFQ.useRef)(null);
    const hoveredElementRef = (0, $70fFQ.useRef)(null);
    const [scrollState, setScrollState] = (0, $70fFQ.useState)({
        hoveredIndex: 0,
        arrowDirection: (0, $b432f056c3259fac$export$1734a06b2397c2a8)
    });
    const [focussed, setFocussed] = (0, $70fFQ.useState)(false);
    const [searchQuery, setSearchQuery] = (0, $814b4b84818795e9$export$2e2bcd8739ae039)("");
    // This query does a quick fetch to each of the companies stored in the local storage object, to
    // verify that they're still accessible in our API. If any of the requests return a 404, the
    // offending company will be removed from the local storage. This will prevent us from displaying
    // a link to an extremely recently IPO'd company in the recent list.
    (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)((0, $3d0a219733fde2aa$export$aaa33b06eebfe9e4)().map((company)=>({
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY(company[0]),
            options: {
                onError: (error)=>{
                    if (error.status === 404) (0, $3d0a219733fde2aa$export$571c6d653a7837db)(company[0]);
                }
            }
        })));
    // search companies from ZX
    const companyQuery = (0, $f869aac89d4eda76$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY(), {
        search: searchQuery
    }, {
        enabled: searchQuery.length >= $1a448af5be72ffe3$var$MIN_SEARCH_QUERY_LENGTH,
        cacheTime: 0
    });
    (0, $70fFQ.useEffect)(()=>{
        if (searchQuery) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).globalSearchQueryCompany(searchQuery);
    }, [
        searchQuery
    ]);
    const onScrollDownFetchNext = (0, $70fFQ.useCallback)((distanceFromBottom)=>{
        if (distanceFromBottom < $1a448af5be72ffe3$var$FETCH_NEXT_COMPANIES_PAGE_THRESHOLD && companyQuery.hasNextPage && !companyQuery.isFetchingNextPage) companyQuery.fetchNextPage().then((response)=>response.data);
    }, [
        companyQuery
    ]);
    (0, $cf715cdf7b4bb119$export$2e2bcd8739ae039)({
        scrollRef: scrollableListRef,
        onScrollUp: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
        onScrollDown: onScrollDownFetchNext
    });
    const showSearchResults = (0, $70fFQ.useMemo)(()=>searchQuery.length >= $1a448af5be72ffe3$var$MIN_SEARCH_QUERY_LENGTH, [
        searchQuery
    ]);
    const companies = (0, $70fFQ.useMemo)(()=>{
        // Returns either the results from the API fetch, or the local storage companies that were
        // recently visited.
        if (showSearchResults) return companyQuery.isSuccess ? companyQuery.cleanedData.data : [];
        return (0, $3d0a219733fde2aa$export$aaa33b06eebfe9e4)().map((company)=>({
                zb_id: company[0],
                name: company[1],
                main_picture: company[2],
                legal_name: company[3] || company[1]
            }));
    }, [
        companyQuery,
        showSearchResults
    ]);
    const onSelectSearchResult = (0, $70fFQ.useCallback)((company, hotkeyUsed = false)=>{
        setSearchQuery("");
        if (searchBarRef.current) searchBarRef.current.value = "";
        setFocussed(!focussed);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).globalSearchSelectCompany(hotkeyUsed, searchQuery, company?.name);
        dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).updateMixpanelEventSource,
            source: "global search",
            target: (0, $46a097389bbbbe65$export$796b285b8ee8898e)
        });
        navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANY(company.zb_id ?? company.apiId));
    }, [
        dispatch,
        setSearchQuery,
        focussed,
        searchBarRef,
        navigate,
        searchQuery
    ]);
    (0, $70fFQ.useEffect)(()=>{
        // A bit of sorcery here. Essentially we want to scroll the currently hovered element into view,
        // but maintain a buffer of 1 element on the top and bottom of the scroll so you get a preview
        // of what's next to come.
        if (scrollableListRef.current) {
            const { hoveredIndex: hoveredIndex, arrowDirection: arrowDirection } = scrollState;
            // We determine where in the list the currently hovered element is so that we can scroll
            // to a position that gives the buffer on either side, if necessary.
            const hoveredElementPositionOnScreen = hoveredIndex * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) - scrollableListRef.current.scrollTop;
            // Note that arrowDirection is relevant here because we don't want to scroll down when the
            // hoveredElement is at the top of the list, but that could happen without checking to see
            // if the user is attempting to scroll down.
            if (arrowDirection === (0, $b432f056c3259fac$export$1734a06b2397c2a8) && hoveredElementPositionOnScreen + 2 * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) > scrollableListRef.current.clientHeight) // The hovered element is at the bottom of the list, and we are scrolling down.
            scrollableListRef.current.scrollTop = (hoveredIndex + 2) * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) - scrollableListRef.current.clientHeight;
            else if (arrowDirection === (0, $b432f056c3259fac$export$b34c7ae3fd8138d2) && hoveredElementPositionOnScreen - (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) < 0) // The hovered element is at the top of the list, and we are scrolling up.
            scrollableListRef.current.scrollTop = (hoveredIndex - 1) * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8);
            else if (arrowDirection === (0, $b432f056c3259fac$export$1734a06b2397c2a8) && hoveredElementPositionOnScreen + 2 * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) < 0) // The hovered element is offscreen at the top of the list, and we are scrolling down.
            scrollableListRef.current.scrollTop = (hoveredIndex - 1) * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8);
            else if (arrowDirection === (0, $b432f056c3259fac$export$b34c7ae3fd8138d2) && hoveredElementPositionOnScreen + (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) > scrollableListRef.current.clientHeight) // The hovered element is offscreen at the bottom of the list, and we are scrolling up
            scrollableListRef.current.scrollTop = hoveredIndex * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8) - (scrollableListRef.current.clientHeight - 2 * (0, $8ad59d289eb882fd$export$8b12118a302a8fe8));
        }
    }, [
        scrollState,
        scrollableListRef,
        hoveredElementRef
    ]);
    const SearchDropdown = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($1a448af5be72ffe3$var$StyledResultHeader, {
                    children: showSearchResults ? "Company Results" : "Recently Visited Companies"
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($1a448af5be72ffe3$var$StyledDropdownContainer, {
                    ref: scrollableListRef,
                    children: [
                        companies.length === 0 && !companyQuery.isLoading ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($1a448af5be72ffe3$var$StyledNoResults, {
                            children: showSearchResults ? "No private companies found. Try adjusting your search." : "No recently visited companies. Start your search above."
                        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                            children: companies.map((company, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($1a448af5be72ffe3$var$HoverableListItem, {
                                    listStyle: (0, $dfd33cee3229493c$exports.ListStyles).TWO_LINE,
                                    ref: index === scrollState.hoveredIndex ? hoveredElementRef : null,
                                    $hovered: index === scrollState.hoveredIndex,
                                    avatar: company.main_picture ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Thumbnail), {
                                        src: company.main_picture,
                                        size: "24px"
                                    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f82caaae0faa7ac9$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>onSelectSearchResult(company),
                                    trailingContent: index === scrollState.hoveredIndex ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $1fd7e8665c70ce17$export$2e2bcd8739ae039), {
                                        hotkey: (0, $dfd33cee3229493c$exports.CornerDownLeftIcon),
                                        action: "select"
                                    }) : null,
                                    text: (0, $dd2c7087b54d88e8$export$2e2bcd8739ae039)(company.name, searchQuery, null, showSearchResults ? $1a448af5be72ffe3$var$StyledTheme30 : null),
                                    subtext: (0, $dd2c7087b54d88e8$export$2e2bcd8739ae039)(company.legal_name, searchQuery, showSearchResults ? $1a448af5be72ffe3$var$StyledTheme80 : null, showSearchResults ? $1a448af5be72ffe3$var$StyledTheme30 : null)
                                }, company.zb_id ?? company.apiId))
                        }),
                        (!companyQuery.isSuccess || companyQuery.isFetching) && showSearchResults && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a72cb095399be523$export$7fb51b284d7f1c81), {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
                                absolute: false
                            })
                        })
                    ]
                })
            ]
        });
    SearchDropdown.propTypes = {
        toggleIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
    };
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $ecfedd356bff7c39$export$2e2bcd8739ae039)(SearchDropdown, {
        id: "GlobalSearchDropdown"
    });
    const handleSlashKeyPress = (0, $70fFQ.useCallback)((event)=>{
        if (!focussed) {
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).toggleGlobalSearch(true, true);
            searchBarRef.current?.focus();
            toggleDropdown();
            event.preventDefault();
            return true;
        }
        return false;
    }, [
        searchBarRef,
        focussed,
        toggleDropdown
    ]);
    const handleEscapeKeyPress = (0, $70fFQ.useCallback)(()=>{
        if (focussed) {
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).toggleGlobalSearch(true, false);
            setFocussed(false);
            toggleDropdown();
            searchBarRef.current?.blur();
            return true;
        }
        return false;
    }, [
        focussed,
        searchBarRef,
        toggleDropdown
    ]);
    const handleEnterKeyPress = (0, $70fFQ.useCallback)(()=>{
        if (focussed) {
            setFocussed(false);
            toggleDropdown();
            searchBarRef.current?.blur();
            const company = companies[scrollState.hoveredIndex];
            onSelectSearchResult(company, true);
            return true;
        }
        return false;
    }, [
        onSelectSearchResult,
        focussed,
        companies,
        scrollState,
        toggleDropdown
    ]);
    const handleArrowDownKeyPress = (0, $70fFQ.useCallback)((event)=>{
        if (focussed) {
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateGlobalSearchDropdown((0, $b432f056c3259fac$export$1734a06b2397c2a8));
            setScrollState({
                hoveredIndex: Math.max(Math.min(scrollState.hoveredIndex + 1, companies.length - 1), 0),
                arrowDirection: (0, $b432f056c3259fac$export$1734a06b2397c2a8)
            });
            event.preventDefault();
            return true;
        }
        return false;
    }, [
        scrollState,
        focussed,
        companies
    ]);
    const handleArrowKeyUpPress = (0, $70fFQ.useCallback)((event)=>{
        if (focussed) {
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateGlobalSearchDropdown((0, $b432f056c3259fac$export$b34c7ae3fd8138d2));
            setScrollState({
                hoveredIndex: Math.max(Math.min(scrollState.hoveredIndex - 1, companies.length - 1), 0),
                arrowDirection: (0, $b432f056c3259fac$export$b34c7ae3fd8138d2)
            });
            event.preventDefault();
            return true;
        }
        return false;
    }, [
        scrollState,
        focussed,
        companies
    ]);
    const hotkeyConfigs = (0, $70fFQ.useMemo)(()=>({
            [(0, $b432f056c3259fac$export$4893289f1f957ad8)]: {
                callback: handleSlashKeyPress,
                shiftDisabled: true
            },
            [(0, $b432f056c3259fac$export$8152f929a25a0ff4)]: {
                callback: handleEnterKeyPress
            },
            [(0, $b432f056c3259fac$export$391dcf4886d760e9)]: {
                callback: handleEnterKeyPress
            },
            [(0, $b432f056c3259fac$export$929c2026f4dd54a2)]: {
                callback: handleEscapeKeyPress
            },
            [(0, $b432f056c3259fac$export$1734a06b2397c2a8)]: {
                callback: handleArrowDownKeyPress
            },
            [(0, $b432f056c3259fac$export$b34c7ae3fd8138d2)]: {
                callback: handleArrowKeyUpPress
            }
        }), [
        handleSlashKeyPress,
        handleEnterKeyPress,
        handleEscapeKeyPress,
        handleArrowDownKeyPress,
        handleArrowKeyUpPress
    ]);
    (0, $b432f056c3259fac$export$2e2bcd8739ae039)(hotkeyConfigs);
    const handleFocus = (0, $70fFQ.useCallback)(()=>{
        setFocussed(true);
    }, []);
    const handleBlur = (0, $70fFQ.useCallback)((event)=>{
        if (dropdownRef.current && !dropdownRef.current.contains(event.relatedTarget)) {
            setFocussed(false);
            setScrollState({
                ...scrollState,
                hoveredIndex: 0
            });
        }
    }, [
        dropdownRef,
        scrollState
    ]);
    (0, $70fFQ.useEffect)(()=>{
        const current = dropdownRef.current;
        if (current) {
            current.addEventListener("focusin", handleFocus);
            current.addEventListener("focusout", handleBlur);
        }
        return ()=>{
            if (current) {
                current.removeEventListener("focusin", handleFocus);
                current.removeEventListener("focusout", handleBlur);
            }
        };
    }, [
        dropdownRef,
        handleFocus,
        handleBlur
    ]);
    const trailingContent = focussed ? null : ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $1fd7e8665c70ce17$export$2e2bcd8739ae039), {
            hotkey: (0, $dfd33cee3229493c$exports.SlashIcon),
            action: "search"
        });
    const handleClick = (0, $70fFQ.useCallback)((event)=>{
        if (!dropdownElement) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).toggleGlobalSearch(false, true);
        else {
            searchBarRef.current?.blur();
            event.stopPropagation();
        }
        toggleDropdown();
    }, [
        dropdownElement,
        searchBarRef,
        toggleDropdown
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($1a448af5be72ffe3$var$StyledSearchBarContainer, {
        id: "global-search-bar",
        ref: dropdownRef,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($1a448af5be72ffe3$var$StyledSearchBar, {
                ref: searchBarRef,
                id: "company-search",
                leadingIcon: (0, $dfd33cee3229493c$exports.SearchIcon),
                name: "CompanySearch",
                onChange: (event)=>setSearchQuery(event.target.value),
                trailingIcon: trailingContent,
                placeholder: "Search company",
                type: "text"
            }),
            dropdownElement
        ]
    });
};
var $1a448af5be72ffe3$export$2e2bcd8739ae039 = $1a448af5be72ffe3$var$CompanySearch;






const $65d5ae292da56411$var$StyledGlobalNavigationContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.PageSection))`
  width: 100%;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  box-sizing: border-box;
  padding: 16px 24px;
  overflow: hidden;
  z-index: 4;

  // Support the right-aligned profile dropdown
  justify-content: space-between;
`;
const $65d5ae292da56411$var$GlobalNavigation = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  gap: 24px;
  margin-right: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;

  > :first-child {
    flex-shrink: 0;
  }
`;
const $65d5ae292da56411$var$NavigationLinks = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50).attrs({
    as: "div"
})`
  margin-left: 24px;
  display: flex;
  flex-shrink: 0;
  gap: 32px;
`;
const $65d5ae292da56411$var$StyledNavigationLink = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.HyperLink))`
  &:hover {
    ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
  }

  ${(props)=>props.$selected && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
    `}
`;
const $65d5ae292da56411$var$removeTrailingSlashes = (path)=>path.replace(/\/+$/, "");
/**
 * Global navigation bar
 *
 * @returns {React.Element}
 */ const $65d5ae292da56411$var$GlobalNav = ()=>{
    const { user: user } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const location = (0, $9a6b443e2c413186$export$45d76561a5302f2b)();
    const [homePageFeatureAccess, homePageAcessLoading] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$4a882f87980a4d7a));
    const [portfoliosFeatureAccess, portfolioAccessLoading] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$6d4c76a833ca8f22));
    const navLinks = (0, $70fFQ.useMemo)(()=>{
        // Determine the available navigation links based on feature permissions.
        const navLinks = [];
        if (homePageAcessLoading || portfolioAccessLoading) return navLinks;
        if (homePageFeatureAccess) navLinks.push({
            url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).HOME(),
            name: "Home"
        });
        navLinks.push({
            url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES(),
            id: "companies-global-nav-link",
            strictMatch: true,
            name: "Companies"
        });
        if (portfoliosFeatureAccess) navLinks.push({
            url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIOS(),
            id: "portfolios-global-nav-link",
            name: "Portfolios"
        });
        if (!portfoliosFeatureAccess) {
            // These two feature flags constitute the dataverse updates. Not passing 1 of them
            // leaves the old navigation items in place.
            navLinks.push({
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).MARKET_ACTIVITY(),
                name: "Market Activity"
            });
            navLinks.push({
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).INSIGHTS(),
                name: "Insights"
            });
        }
        return navLinks;
    }, [
        homePageAcessLoading,
        portfolioAccessLoading,
        homePageFeatureAccess,
        portfoliosFeatureAccess
    ]);
    const siteLogo = (0, $fa6f9dce0653fce6$export$6b7545a126c3c6c5).includes(user?.email) ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $037584e3e4e73fb7$export$8cb747ba8c0ee4c), {}) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $037584e3e4e73fb7$export$3a9add76aac2435a), {});
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($65d5ae292da56411$var$StyledGlobalNavigationContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($65d5ae292da56411$var$GlobalNavigation, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).UNSTYLED,
                        url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).HOME(),
                        children: siteLogo
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $1a448af5be72ffe3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($65d5ae292da56411$var$NavigationLinks, {
                        children: navLinks.map((link)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($65d5ae292da56411$var$StyledNavigationLink, {
                                id: link.id,
                                $selected: link.strictMatch ? $65d5ae292da56411$var$removeTrailingSlashes(location.pathname) === $65d5ae292da56411$var$removeTrailingSlashes(link.url) : (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).includes(location.pathname, link.url),
                                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).UNSTYLED,
                                url: link.url,
                                onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).clickGlobalNavigationPage(link.name),
                                children: link.name
                            }, `nav-link-${link.url}`))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7c3793a1dcab3cf8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $65d5ae292da56411$export$2e2bcd8739ae039 = $65d5ae292da56411$var$GlobalNav;




var $70fFQ = parcelRequire("70fFQ");





var $hI4Hx = parcelRequire("hI4Hx");





const $02c5ec2c30ece073$var$InsightsContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  padding-top: 48px;
  gap: 24px;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
  padding-bottom: 16px;
`;
const $02c5ec2c30ece073$var$StyledCard = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Card))`
  height: fit-content;
`;
const $02c5ec2c30ece073$var$StyledDate = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.caption2)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme50}
  white-space: nowrap;
`;
const $02c5ec2c30ece073$var$StyledPageLayout = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  overflow: auto;
  gap: 16px;
  height: 100%;

  > * {
    flex-grow: 1;
  }
`;
const $02c5ec2c30ece073$var$SECONDARY_MARKET_MONTHLY_MOVERS = 10;
const $02c5ec2c30ece073$var$INSTITUTIONAL_MARKS_MONTHLY_MOVERS = 20;
const $02c5ec2c30ece073$var$Insights = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).viewInsights();
    }, []);
    const insightArticleQueryInfo = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).INSIGHT_ARTICLE());
    const insightArticles = insightArticleQueryInfo?.cleanedData?.data;
    const [monthlyMoverArticles, pressReportArticles] = (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).partition(insightArticles, (article)=>{
        return article.article_type === $02c5ec2c30ece073$var$SECONDARY_MARKET_MONTHLY_MOVERS || article.article_type === $02c5ec2c30ece073$var$INSTITUTIONAL_MARKS_MONTHLY_MOVERS;
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($02c5ec2c30ece073$var$InsightsContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                children: "Insights"
            }),
            insightArticleQueryInfo.isLoading ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
                absolute: false
            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($02c5ec2c30ece073$var$StyledPageLayout, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($02c5ec2c30ece073$var$StyledCard, {
                        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
                        tagline: "ZX Monthly Movers summarizes notable movements in the holding values of venture-backed private companies",
                        title: "ZX Monthly Movers",
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                            divider: true,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(monthlyMoverArticles, (article)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListItem), {
                                    leadingIcon: (0, $dfd33cee3229493c$exports.BarLineChartIcon),
                                    linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                                    listStyle: (0, $dfd33cee3229493c$exports.ListStyles).TWO_LINE,
                                    onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openMonthlyMoversArticle(article.title),
                                    subtext: article.subtitle,
                                    text: article.title,
                                    trailingContent: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($02c5ec2c30ece073$var$StyledDate, {
                                        children: `Published on ${(0, $86d2f3987cc9d604$exports.DateTime).fromISO(article.posted_on).toLocaleString((0, $86d2f3987cc9d604$exports.DateTime).DATE_SHORT)}`
                                    }),
                                    url: article.url
                                }))
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($02c5ec2c30ece073$var$StyledCard, {
                        cardStyle: (0, $dfd33cee3229493c$exports.CardStyles).SECTIONED,
                        title: "Reports & Press Releases",
                        children: pressReportArticles?.length ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                            divider: true,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(pressReportArticles, (article)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListItem), {
                                    avatar: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Thumbnail), {
                                        src: article.thumbnail_kn_url,
                                        alt: article.title,
                                        size: "32px"
                                    }),
                                    linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                                    listStyle: (0, $dfd33cee3229493c$exports.ListStyles).TWO_LINE,
                                    onClick: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openReportOrPressRelease(article.title),
                                    subtext: `Posted on ${(0, $86d2f3987cc9d604$exports.DateTime).fromISO(article.posted_on).toLocaleString((0, $86d2f3987cc9d604$exports.DateTime).DATE_SHORT)}`,
                                    text: article.title,
                                    trailingContent: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.LinkExternalIcon), {}),
                                    url: article.url
                                }))
                        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                            children: "No reports or press releases available."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $253eff529b7bdd6f$export$2e2bcd8739ae039), {})
        ]
    });
};
var $02c5ec2c30ece073$export$2e2bcd8739ae039 = $02c5ec2c30ece073$var$Insights;


var $4a429256ba12bfbb$export$2e2bcd8739ae039 = (0, $02c5ec2c30ece073$export$2e2bcd8739ae039);




var $70fFQ = parcelRequire("70fFQ");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");



const $44e2f7a231c5b728$export$f10b32dfda12e96e = "An unknown error has occurred. Please try again later.";







const $a4ddd3bc744aef18$export$f5914fa2ff99e738 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body1sell)`
  margin-left: -32px;
  white-space: nowrap;
  text-align: center;
  background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface0};
  height: 62px;
  line-height: 62px;
  border-radius: 12px;
  margin-right: 1px;
  padding-right: 20px;
  box-sizing: border-box;
  border: none;
`;
/*
 * Some seriously aggressive Yuka styling overriding for the login form.
 */ const $a4ddd3bc744aef18$export$c43bfb5198aa7b21 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Button))`
  border-radius: 12px;
  height: 64px;
  width: 100%;

  > span {
    font-size: 18px;
  }
`;
const $a4ddd3bc744aef18$export$e090f7fe8c15a037 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039))`
  > :nth-child(1) {
    height: 64px;
    /* full design width where it fits, shrink with the viewport on small
       screens (48px = LoginBase wrapper horizontal padding) */
    width: min(600px, calc(100vw - 48px));
    border-radius: 13px;
    padding: 0;

    border: none;
    background-image: linear-gradient(to top right, #6e7dca99 0%, #74cbd399 100%);

    ${(props)=>props.$error && (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
        background-image: none;
        background-color: ${(0, $78cf78541be2071b$export$29792b0afe15a7ce).red};
      `}

    &:focus-within {
      background-image: linear-gradient(to top right, #6e7dca99 0%, #74cbd399 100%);
      background-color: transparent;

      > ${$a4ddd3bc744aef18$export$f5914fa2ff99e738} {
        display: none;
      }
    }

    > input {
      box-sizing: border-box;
      border: none;
      height: 62px;
      margin: 1px;
      font-size: 20px !important;
      padding: 16px 20px;
      border-radius: 12px;

      background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface0};

      &:hover {
        background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface0};
      }

      &:focus {
        padding: 16px 19px;
        height: 60px;
        margin: 2px;
        background-color: ${(0, $dfd33cee3229493c$exports.YukaColorPalette).surface0};
        box-shadow: 0 0 15px 5px ${(0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500, 0.3)};
      }
    }
  }
`;
const $a4ddd3bc744aef18$export$84f00ea3aac2fb4e = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  > ${(0, $dfd33cee3229493c$exports.Fonts).Body2sell} {
    align-self: flex-start;
  }
`;
const $a4ddd3bc744aef18$export$63ab9f56defa0d6a = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: flex-start;
`;
const $a4ddd3bc744aef18$export$93f9c7a07af14032 = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50).attrs({
    as: "p"
})`
  margin-bottom: 24px;
`;









var $70fFQ = parcelRequire("70fFQ");
/**
 * Helper hook to automatically focus the submit button in a form after submitting. This hook
 * should be used when we want to render input validation errors on form submit failing, and need
 * to unfocus the inputs in the form to do so.
 * Users of this hook should call the returned wrapped on submit function, and should attach
 * the ref to a non-input element (e.g. a button) in the form.
 *
 * @param onSubmit {Function} - The onSubmit function to wrap with the ref focus().
 * @returns {[Function, React.MutableRefObject<null>]}
 */ const $e512ba898a21188f$var$useUnfocusOnSubmit = (onSubmit)=>{
    const submitButtonRef = (0, $70fFQ.useRef)(null);
    const wrappedOnSubmit = (0, $70fFQ.useCallback)((...args)=>{
        submitButtonRef.current?.focus();
        return onSubmit(...args);
    }, [
        onSubmit
    ]);
    return [
        wrappedOnSubmit,
        submitButtonRef
    ];
};
var $e512ba898a21188f$export$2e2bcd8739ae039 = $e512ba898a21188f$var$useUnfocusOnSubmit;


const $6ee7af79541ee735$var$REMEMBER_2FA_KEY = "remember_2fa_token";
const $6ee7af79541ee735$var$LoginForm = ({ setCredentials: setCredentials })=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const [errors, setErrors] = (0, $70fFQ.useState)({});
    const { authenticate: authenticate, user: user } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const { getItem: getItem } = (0, $65bd6cc08769cb23$export$2e2bcd8739ae039)();
    const onSubmit = (0, $70fFQ.useCallback)((values)=>{
        const remember2faToken = getItem($6ee7af79541ee735$var$REMEMBER_2FA_KEY);
        const combinedValues = {
            ...values,
            remember_2fa_token: remember2faToken
        };
        if (!values.email || !values.password) {
            setErrors({
                submission: undefined,
                ...values.email ? {} : {
                    email: "Email is required"
                },
                ...values.password ? {} : {
                    password: "Password is required"
                }
            });
            return;
        }
        return (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).LOGIN(), JSON.stringify(combinedValues)).then(({ data: data })=>{
            if (data.require_2fa) // If 2FA is required, stash the credentials and switch to TokenForm
            setCredentials(values);
            else authenticate(data, true);
        }).catch((err)=>{
            const data = err?.response?.data;
            let errorMsg = (0, $44e2f7a231c5b728$export$f10b32dfda12e96e);
            if (data) {
                if (typeof data === "string") errorMsg = data;
                else if (data.detail) errorMsg = data.detail;
                else if (Array.isArray(data.non_field_errors) && data.non_field_errors.length) errorMsg = data.non_field_errors[0];
                else {
                    const firstFieldError = Object.values(data).find((v)=>Array.isArray(v) && v.length && typeof v[0] === "string");
                    if (firstFieldError) errorMsg = firstFieldError[0];
                }
            }
            setErrors({
                submission: errorMsg
            });
        });
    }, [
        authenticate,
        getItem,
        setCredentials
    ]);
    const [wrappedOnSubmit, submitRef] = (0, $e512ba898a21188f$export$2e2bcd8739ae039)(onSubmit);
    (0, $70fFQ.useEffect)(()=>{
        if (user) navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
        onSubmit: wrappedOnSubmit,
        children: ({ handleSubmit: handleSubmit, submitting: submitting })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a4ddd3bc744aef18$export$84f00ea3aac2fb4e), {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$e090f7fe8c15a037), {
                                id: "email",
                                name: "email",
                                placeholder: "Email",
                                type: "text",
                                $error: errors.email,
                                onChange: ()=>setErrors({
                                        ...errors,
                                        email: undefined
                                    }),
                                trailingIcon: ()=>errors.email ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$f5914fa2ff99e738), {
                                        children: errors.email
                                    }) : null
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$e090f7fe8c15a037), {
                                displayIndicator: false,
                                id: "password",
                                $error: errors.password,
                                name: "password",
                                placeholder: "Password",
                                type: "password",
                                onChange: ()=>setErrors({
                                        ...errors,
                                        password: undefined
                                    }),
                                trailingIcon: ()=>errors.password ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$f5914fa2ff99e738), {
                                        children: errors.password
                                    }) : null
                            }),
                            errors.submission && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2sell, {
                                children: errors.submission
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$c43bfb5198aa7b21), {
                                ref: submitRef,
                                disabled: submitting,
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                type: "submit",
                                children: "Log in"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).RESET_PASSWORD(),
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
                                    children: "Forgot your password?"
                                })
                            })
                        ]
                    })
                ]
            })
    });
};
$6ee7af79541ee735$var$LoginForm.propTypes = {
    setCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $6ee7af79541ee735$export$2e2bcd8739ae039 = $6ee7af79541ee735$var$LoginForm;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");












const $1292a4b3ad94cf20$var$REMEMBER_2FA_KEY = "remember_2fa_token";
const $1292a4b3ad94cf20$var$REMEMBER_2FA_TTL = 43200 * (0, $753b8dcbe6be17f9$export$35acaebf644db34e);
const $1292a4b3ad94cf20$var$TokenForm = ({ credentials: credentials, setCredentials: setCredentials })=>{
    const otpTokenRef = (0, $70fFQ.useRef)();
    const [errors, setErrors] = (0, $70fFQ.useState)({});
    const { authenticate: authenticate } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const { setItem: setItem } = (0, $65bd6cc08769cb23$export$2e2bcd8739ae039)();
    const onSubmit = (values)=>{
        const combinedValues = {
            ...credentials,
            ...values
        };
        if (!combinedValues.otp_token) {
            setErrors({
                otp_token: "Token is required"
            });
            return;
        }
        return (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).TOKEN_LOGIN(), JSON.stringify(combinedValues)).then(({ data: data })=>{
            // useLocalStorage to store a 30 day signed token to remember device
            if (data.remember_2fa_token) setItem($1292a4b3ad94cf20$var$REMEMBER_2FA_KEY, data.remember_2fa_token, $1292a4b3ad94cf20$var$REMEMBER_2FA_TTL);
            setCredentials(null);
            authenticate(data, true);
        }).catch((error)=>{
            const data = error?.response?.data;
            let errorMsg = (0, $44e2f7a231c5b728$export$f10b32dfda12e96e);
            if (data?.error) errorMsg = data.error[0] || errorMsg;
            setErrors({
                submission: errorMsg
            });
        });
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$93f9c7a07af14032), {
                children: "Please enter the token from your token generator"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
                onSubmit: onSubmit,
                children: ({ handleSubmit: handleSubmit, submitting: submitting })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a4ddd3bc744aef18$export$84f00ea3aac2fb4e), {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$e090f7fe8c15a037), {
                                        name: "otp_token",
                                        placeholder: "Token",
                                        type: "text",
                                        ref: otpTokenRef,
                                        $error: errors.otp_token,
                                        onChange: ()=>setErrors({
                                                ...errors,
                                                otp_token: undefined
                                            }),
                                        trailingIcon: ()=>errors.otp_token ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$f5914fa2ff99e738), {
                                                children: errors.otp_token
                                            }) : null
                                    }),
                                    errors.submission && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2sell, {
                                        children: errors.submission
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$63ab9f56defa0d6a), {
                                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                                            id: "remember_2fa",
                                            name: "remember_2fa",
                                            type: "checkbox",
                                            label: "Remember this device for 30 days"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$c43bfb5198aa7b21), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                        disabled: submitting,
                                        type: "submit",
                                        children: "Log in"
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                                        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                                        url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN(),
                                        onClick: ()=>setCredentials(null),
                                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
                                            children: "Back to Login"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
$1292a4b3ad94cf20$var$TokenForm.propTypes = {
    credentials: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object.isRequired,
    setCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $1292a4b3ad94cf20$export$2e2bcd8739ae039 = $1292a4b3ad94cf20$var$TokenForm;


const $4a305f9fa19dd7a5$var$Login = ()=>{
    const [credentials, setCredentials] = (0, $70fFQ.useState)(null);
    return credentials ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $1292a4b3ad94cf20$export$2e2bcd8739ae039), {
        credentials: credentials,
        setCredentials: setCredentials
    }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6ee7af79541ee735$export$2e2bcd8739ae039), {
        setCredentials: setCredentials
    });
};
var $4a305f9fa19dd7a5$export$2e2bcd8739ae039 = $4a305f9fa19dd7a5$var$Login;




var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");






const $ccea159ae1764da7$var$StyledByline = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  margin-bottom: 48px;
`;
const $ccea159ae1764da7$var$StyledWrapper = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* fill the 100vh app shell (StyledHDContainer clips overflow) and scroll
     internally, so tall content (e.g. the onboarding form) scrolls on small
     screens rather than clipping the header */
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  background-image: linear-gradient(
      180deg,
      transparent,
      ${(0, $a58ecc6057b2b381$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.YukaColorPalette).surface0, 0.5)} 100%
    ),
    url(${(0, {})});
  background-size: cover;
  background-position: center;
`;
const $ccea159ae1764da7$var$StyledMain = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;

  > * {
    max-width: 600px;
  }
`;
const $ccea159ae1764da7$var$StyledFooter = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 600px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 32px;
  padding: 24px 0 26px;

  > :last-child {
    display: flex;
    gap: 32px;
    align-items: center;
  }
`;
const $ccea159ae1764da7$var$LoginBase = ({ children: children, bylineText: bylineText })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($ccea159ae1764da7$var$StyledWrapper, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($ccea159ae1764da7$var$StyledMain, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $037584e3e4e73fb7$export$2e2bcd8739ae039), {
                        size: 28
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($ccea159ae1764da7$var$StyledByline, {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme50, {
                            children: bylineText
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($ccea159ae1764da7$var$StyledFooter, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                        children: [
                            "\xa9 Zanbato, Inc. ",
                            new Date().getFullYear()
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                        children: [
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("tou"),
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                    children: "Terms of Use"
                                })
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("privacy"),
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                    children: "Privacy Policy"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
$ccea159ae1764da7$var$LoginBase.propTypes = {
    bylineText: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node
};
$ccea159ae1764da7$var$LoginBase.defaultProps = {
    bylineText: "",
    children: null
};
var $ccea159ae1764da7$export$2e2bcd8739ae039 = $ccea159ae1764da7$var$LoginBase;




var $70fFQ = parcelRequire("70fFQ");



var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





var $70fFQ = parcelRequire("70fFQ");




/**
 * Fields for accepting agreements to use the platform
 *
 * @returns {React.Element} AcceptAgreementsFields
 */ const $d01c4e34ba84741d$var$AcceptAgreementsFields = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a4ddd3bc744aef18$export$63ab9f56defa0d6a), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                id: "accept_tou",
                name: "accept_tou",
                type: "checkbox",
                label: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
                    children: [
                        "I agree to the\xa0",
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                            url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("tou"),
                            linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                            children: "Terms of Use"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                id: "accept_privacy",
                name: "accept_privacy",
                type: "checkbox",
                label: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
                    children: [
                        "I agree to the\xa0",
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                            url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("privacy"),
                            linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                            children: "Privacy Policy"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ce413dbcef8c4e6e$export$2e2bcd8739ae039), {
                id: "accept_nda",
                name: "accept_nda",
                type: "checkbox",
                label: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
                    children: [
                        "I agree to the\xa0",
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                            url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT("nda"),
                            linkType: (0, $dfd33cee3229493c$exports.LinkTypes).EXTERNAL_LINK,
                            children: "Non-Disclosure Agreement"
                        })
                    ]
                })
            })
        ]
    });
var $d01c4e34ba84741d$export$2e2bcd8739ae039 = $d01c4e34ba84741d$var$AcceptAgreementsFields;








const $196fb1ae8b489cbe$var$SetNewPassword = (props)=>{
    const [onSubmit, submitRef] = (0, $e512ba898a21188f$export$2e2bcd8739ae039)(props.onSubmit);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $56dc12cc1901e599$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
                onSubmit: onSubmit,
                children: ({ handleSubmit: handleSubmit, submitting: submitting })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a4ddd3bc744aef18$export$84f00ea3aac2fb4e), {
                            children: [
                                submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$e090f7fe8c15a037), {
                                    id: "password",
                                    type: "password",
                                    name: "password",
                                    placeholder: "New password",
                                    $error: props.errors.password,
                                    onChange: ()=>props.setErrors({
                                            ...props.errors,
                                            password: undefined
                                        }),
                                    trailingIcon: ()=>props.errors.password ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$f5914fa2ff99e738), {
                                            children: props.errors.password
                                        }) : null
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$e090f7fe8c15a037), {
                                    id: "confirm-password",
                                    type: "password",
                                    name: "confirm_password",
                                    placeholder: "Confirm your new password",
                                    displayIndicator: false,
                                    $error: props.errors.confirm_password,
                                    onChange: ()=>props.setErrors({
                                            ...props.errors,
                                            confirm_password: undefined
                                        }),
                                    trailingIcon: ()=>props.errors.confirm_password ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$f5914fa2ff99e738), {
                                            children: props.errors.confirm_password
                                        }) : null
                                }),
                                props.includeAgreements && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d01c4e34ba84741d$export$2e2bcd8739ae039), {}),
                                props.errors.submission && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2sell, {
                                    children: props.errors.submission
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$c43bfb5198aa7b21), {
                                    ref: submitRef,
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                    disabled: submitting,
                                    type: "submit",
                                    children: "Set password"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                    linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                                    linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                                    url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN(),
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
                                        children: "Back to Login"
                                    })
                                })
                            ]
                        })
                    })
            })
        ]
    });
};
$196fb1ae8b489cbe$var$SetNewPassword.propTypes = {
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        password: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        confirm_password: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        submission: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired,
    setErrors: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    includeAgreements: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired
};
var $196fb1ae8b489cbe$export$2e2bcd8739ae039 = $196fb1ae8b489cbe$var$SetNewPassword;





const $7a738fb69523d82f$var$NewUserSetPasswordForm = ()=>{
    const [errors, setErrors] = (0, $70fFQ.useState)({});
    const params = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const token = params.token;
    const { authenticate: authenticate } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const onSubmit = (0, $70fFQ.useCallback)((values)=>{
        if (!values.password || !values.confirm_password) {
            setErrors({
                submission: undefined,
                ...values.password ? {} : {
                    password: "Password is required"
                },
                ...values.confirm_password ? {} : {
                    confirm_password: "Password is required"
                }
            });
            return;
        }
        if (values.password !== values.confirm_password) {
            // The view for resetting password uses a library that doesn't have support for
            // password confirmation, so we do it in the frontend.
            setErrors({
                submission: "Passwords do not match"
            });
            return;
        }
        return (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).RESET_PASSWORD_NEW_USER(), JSON.stringify({
            accept_tou: values.accept_tou,
            accept_privacy: values.accept_privacy,
            accept_nda: values.accept_nda,
            password: values.password,
            token: token
        })).then(({ data: data })=>{
            authenticate(data, true);
        }).catch((error)=>{
            const data = error?.response?.data ?? {};
            let errorMsg = data.error || "Unknown error occurred";
            if (data.password) errorMsg = data.password.join(" ");
            else if (data.detail) errorMsg = "Expired or invalid URL.";
            setErrors({
                submission: errorMsg
            });
        });
    }, [
        authenticate,
        token
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $196fb1ae8b489cbe$export$2e2bcd8739ae039), {
        onSubmit: onSubmit,
        includeAgreements: true,
        errors: errors,
        setErrors: setErrors
    });
};
var $7a738fb69523d82f$export$2e2bcd8739ae039 = $7a738fb69523d82f$var$NewUserSetPasswordForm;



parcelRequire("70fFQ");



const $f95eb8f5335e9c74$var$ResetPasswordConfirm = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$93f9c7a07af14032), {
                children: "We\u2019ve emailed you instructions for setting your password. If an account exists with the email you entered, You should receive them shortly. If you don\u2019t receive an email, please make sure you\u2019ve entered the address you registered with, and check your spam folder."
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$c43bfb5198aa7b21), {
                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN(),
                children: "Back to Login"
            })
        ]
    });
var $f95eb8f5335e9c74$export$2e2bcd8739ae039 = $f95eb8f5335e9c74$var$ResetPasswordConfirm;




var $70fFQ = parcelRequire("70fFQ");






const $5657343c83e756b2$var$ResetPasswordForm = ()=>{
    const [errors, setErrors] = (0, $70fFQ.useState)({});
    const params = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const token = params.token;
    const { authenticate: authenticate } = (0, $70fFQ.useContext)((0, $53b8b7db1779de07$export$a0fd8390cfe8ae69));
    const onSubmit = (0, $70fFQ.useCallback)((values)=>{
        if (!values.password || !values.confirm_password) {
            setErrors({
                submission: undefined,
                ...values.password ? {} : {
                    password: "Password is required"
                },
                ...values.confirm_password ? {} : {
                    confirm_password: "Password is required"
                }
            });
            return;
        }
        if (values.password !== values.confirm_password) {
            // The view for resetting password uses a library that doesn't have support for
            // password confirmation, so we do it in the frontend.
            setErrors({
                submission: "Passwords do not match"
            });
            return;
        }
        return (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).RESET_PASSWORD_SET_PASSWORD(), JSON.stringify({
            password: values.password,
            token: token
        })).then(({ data: data })=>{
            authenticate(data, true);
        }).catch((error)=>{
            const data = error?.response?.data ?? {};
            let errorMsg = (0, $44e2f7a231c5b728$export$f10b32dfda12e96e);
            if (data.password) errorMsg = data.password.join(" ");
            else if (data.error || data.detail) // The backend returns 400 {"error": "Invalid token."} for
            // expired/unknown tokens (ZX-15172).
            errorMsg = "Expired or invalid URL.";
            setErrors({
                submission: errorMsg
            });
        });
    }, [
        authenticate,
        token
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $196fb1ae8b489cbe$export$2e2bcd8739ae039), {
        onSubmit: onSubmit,
        includeAgreements: false,
        errors: errors,
        setErrors: setErrors
    });
};
var $5657343c83e756b2$export$2e2bcd8739ae039 = $5657343c83e756b2$var$ResetPasswordForm;




var $70fFQ = parcelRequire("70fFQ");









const $e57de322dec43041$var$ResetPasswordRequest = ()=>{
    const [errors, setErrors] = (0, $70fFQ.useState)({});
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const onSubmit = (0, $70fFQ.useCallback)((values)=>{
        if (!values.email) {
            setErrors({
                submission: undefined,
                ...values.email ? {} : {
                    email: "Email is required"
                }
            });
            return;
        }
        return (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).post((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).RESET_PASSWORD_SEND_EMAIL(), JSON.stringify(values)).then(()=>{
            navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).RESET_PASSWORD_CONFIRM());
        }).catch((error)=>{
            const data = error?.response?.data ?? {};
            let errorMsg = (0, $44e2f7a231c5b728$export$f10b32dfda12e96e);
            if (data.email) errorMsg = data.email;
            setErrors({
                submission: errorMsg
            });
        });
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$93f9c7a07af14032), {
                children: "Please enter your email address, and we will send instructions on how to reset your password."
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
                onSubmit: onSubmit,
                children: ({ handleSubmit: handleSubmit, submitting: submitting })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            submitting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $a4ddd3bc744aef18$export$84f00ea3aac2fb4e), {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$e090f7fe8c15a037), {
                                        id: "email",
                                        $error: errors.email,
                                        name: "email",
                                        placeholder: "Email",
                                        type: "text",
                                        onChange: ()=>setErrors({
                                                ...errors,
                                                email: undefined
                                            }),
                                        trailingIcon: ()=>errors.email ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$f5914fa2ff99e738), {
                                                children: errors.email
                                            }) : null
                                    }),
                                    errors.submission && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2sell, {
                                        children: errors.submission
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a4ddd3bc744aef18$export$c43bfb5198aa7b21), {
                                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                        disabled: submitting,
                                        type: "submit",
                                        children: "Reset password"
                                    }),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                                        linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                                        linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).SUPPORT,
                                        url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN(),
                                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
                                            children: "Back to Login"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
var $e57de322dec43041$export$2e2bcd8739ae039 = $e57de322dec43041$var$ResetPasswordRequest;




var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");



// Current ranges are:
// 0-5%
// 5-50%
// 50%+
const $1c65c0ea97763ca5$export$d9cd0b3ac04149b9 = 0;
const $1c65c0ea97763ca5$export$f62485b3efb1c466 = 0.05;
const $1c65c0ea97763ca5$export$13bc0199dfde7167 = 0.5;
// All rgb values are based off ColorPalette.buy/ColorPalette.sell
// Have to use rgba to set background opacity that doesn't affect text opacity
const $1c65c0ea97763ca5$export$520c135c36b4ad28 = (0, $dfd33cee3229493c$exports.ColorPalette).buy;
const $1c65c0ea97763ca5$export$d5706c2da84f5fb4 = "rgba(0, 246, 139, 0.8)";
const $1c65c0ea97763ca5$export$8325733cdc75dab2 = "rgba(0, 246, 139, 0.6)";
const $1c65c0ea97763ca5$export$5f8ed3a93d1c658c = (0, $dfd33cee3229493c$exports.ColorPalette).darkBlack;
const $1c65c0ea97763ca5$export$e8db43107eeb70d5 = (0, $dfd33cee3229493c$exports.ColorPalette).black15;
const $1c65c0ea97763ca5$export$4a08e21f9d34d856 = (0, $dfd33cee3229493c$exports.ColorPalette).sell;
const $1c65c0ea97763ca5$export$3eca592c52d9c8bc = "rgba(255, 98, 98, 0.8)";
const $1c65c0ea97763ca5$export$893c6c5ebbc518f = "rgba(255, 98, 98, 0.6)";
const $1c65c0ea97763ca5$export$f5cec11a603bb51f = (0, $dfd33cee3229493c$exports.ColorPalette).darkWhite;
const $1c65c0ea97763ca5$export$cacfd74c2bfb6bd5 = (0, $dfd33cee3229493c$exports.ColorPalette).white15;
const $1c65c0ea97763ca5$export$8baaded32f414239 = (0, $dfd33cee3229493c$exports.ColorPalette).minWhite;
const $1c65c0ea97763ca5$export$83507ffb82f63b8e = (0, $dfd33cee3229493c$exports.ColorPalette).darkWhite;
const $1c65c0ea97763ca5$export$42a35608c37ba052 = "-zx_index_value_percent_change";
const $1c65c0ea97763ca5$export$609bbe1c6781a75b = "ordering";
const $1c65c0ea97763ca5$export$9ceb2610726b0459 = "sector";




var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");


var $hI4Hx = parcelRequire("hI4Hx");


var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");







const $214771db7c959115$var$StyledBlock = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  flex-direction: column;
  cursor: pointer;
  background-color: ${(props)=>props.$backgroundColor};
  padding: 12px;
  min-width: 156px; // 180 - 24px;
  max-width: 216px; // 240 - 24px;
  box-sizing: content-box;
  height: 64px;
  // override width if $width is manually set
  flex-basis: ${(props)=>props.$width ? `${props.$width - 24}px` : null};
  flex-grow: ${(props)=>props.$width ? 0 : 1};
  flex-shrink: ${(props)=>props.$width ? 0 : 1};
`;
const $214771db7c959115$var$StyledMainTextContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  color: ${(props)=>props.$color};
  flex-grow: 1;
  flex-direction: column;
`;
const $214771db7c959115$var$StyledCompanyNameContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.body1)}
  flex: 1;
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide any overflowing text */
  text-overflow: ellipsis; /* Display ellipsis (...) for overflowed text */
`;
const $214771db7c959115$var$StyledSectorsContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).span`
  ${(0, $dfd33cee3229493c$exports.caption2)}
  flex: 1;
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide any overflowing text */
  text-overflow: ellipsis; /* Display ellipsis (...) for overflowed text */
`;
const $214771db7c959115$var$StyledPercentChangeContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  ${(0, $dfd33cee3229493c$exports.body1)}
  color: ${(props)=>props.$color};
  justify-content: flex-end;
  align-self: flex-end;
`;
const $214771db7c959115$var$HeatMapBlock = (props)=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const absChange = Math.abs(props.change);
    let backgroundColor;
    let textColor;
    let chevronTopColor;
    let chevronMiddleColor;
    let icon;
    // Positive Change
    if (props.change > 0) {
        textColor = (0, $1c65c0ea97763ca5$export$5f8ed3a93d1c658c);
        // > 50%
        if (absChange >= (0, $1c65c0ea97763ca5$export$13bc0199dfde7167)) backgroundColor = (0, $1c65c0ea97763ca5$export$520c135c36b4ad28);
        else if (absChange >= (0, $1c65c0ea97763ca5$export$f62485b3efb1c466) && absChange < (0, $1c65c0ea97763ca5$export$13bc0199dfde7167)) {
            backgroundColor = (0, $1c65c0ea97763ca5$export$d5706c2da84f5fb4);
            chevronTopColor = (0, $1c65c0ea97763ca5$export$e8db43107eeb70d5);
        // < 5%
        } else if (absChange >= (0, $1c65c0ea97763ca5$export$d9cd0b3ac04149b9)) {
            backgroundColor = (0, $1c65c0ea97763ca5$export$8325733cdc75dab2);
            chevronTopColor = (0, $1c65c0ea97763ca5$export$e8db43107eeb70d5);
            chevronMiddleColor = (0, $1c65c0ea97763ca5$export$e8db43107eeb70d5);
        }
        icon = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.TripleChevronUpIcon), {
            color: (0, $1c65c0ea97763ca5$export$5f8ed3a93d1c658c),
            middleColor: chevronMiddleColor,
            topColor: chevronTopColor
        });
    // Negative Change
    } else if (props.change < 0) {
        textColor = (0, $1c65c0ea97763ca5$export$f5cec11a603bb51f);
        // > 50%
        if (absChange >= (0, $1c65c0ea97763ca5$export$13bc0199dfde7167)) backgroundColor = (0, $1c65c0ea97763ca5$export$4a08e21f9d34d856);
        else if (absChange >= (0, $1c65c0ea97763ca5$export$f62485b3efb1c466) && absChange < (0, $1c65c0ea97763ca5$export$13bc0199dfde7167)) {
            backgroundColor = (0, $1c65c0ea97763ca5$export$3eca592c52d9c8bc);
            chevronTopColor = (0, $1c65c0ea97763ca5$export$cacfd74c2bfb6bd5);
        // < 5%
        } else if (absChange >= (0, $1c65c0ea97763ca5$export$d9cd0b3ac04149b9)) {
            backgroundColor = (0, $1c65c0ea97763ca5$export$893c6c5ebbc518f);
            chevronTopColor = (0, $1c65c0ea97763ca5$export$cacfd74c2bfb6bd5);
            chevronMiddleColor = (0, $1c65c0ea97763ca5$export$cacfd74c2bfb6bd5);
        }
        icon = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.TripleChevronDownIcon), {
            color: (0, $1c65c0ea97763ca5$export$f5cec11a603bb51f),
            middleColor: chevronMiddleColor,
            topColor: chevronTopColor
        });
    // No Change
    } else {
        // there shouldn't be any blocks with no change
        textColor = (0, $1c65c0ea97763ca5$export$83507ffb82f63b8e);
        backgroundColor = (0, $1c65c0ea97763ca5$export$8baaded32f414239);
        icon = "--";
    }
    const onClick = ()=>{
        dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).updateMixpanelEventSource,
            source: "heat map",
            target: (0, $46a097389bbbbe65$export$796b285b8ee8898e)
        });
        navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANY(props.companyId));
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($214771db7c959115$var$StyledBlock, {
        $backgroundColor: backgroundColor,
        $width: props.width,
        onClick: onClick,
        ref: props.firstBlockRef,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($214771db7c959115$var$StyledMainTextContainer, {
                $color: textColor,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($214771db7c959115$var$StyledCompanyNameContainer, {
                        children: props.companyName
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($214771db7c959115$var$StyledSectorsContainer, {
                        children: props.sectorNames
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($214771db7c959115$var$StyledPercentChangeContainer, {
                $color: textColor,
                children: [
                    icon,
                    "\xa0",
                    props.change ? (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(props.change * 100) : "0%"
                ]
            })
        ]
    });
};
$214771db7c959115$var$HeatMapBlock.propTypes = {
    change: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    firstBlockRef: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Element)
        })
    ]),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    sectorNames: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
$214771db7c959115$var$HeatMapBlock.defaultProps = {
    firstBlockRef: null,
    width: null
};
var $214771db7c959115$export$2e2bcd8739ae039 = $214771db7c959115$var$HeatMapBlock;


const $9002556fb230765c$var$HeatMapContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  overflow: auto;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding-bottom: 16px;
  gap: 1px;
`;
const $9002556fb230765c$var$HeatMap = (props)=>{
    const [firstBlockRef, setFirstBlockRef] = (0, $70fFQ.useState)(null);
    const containerRef = (0, $70fFQ.useRef)(null);
    const [firstBlockWidth, setFirstBlockWidth] = (0, $70fFQ.useState)(null);
    const isLastRow = (0, $70fFQ.useCallback)((index)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(containerRef.current) || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isNull(firstBlockRef)) return false;
        const containerRect = containerRef.current.getBoundingClientRect();
        const blockRect = firstBlockRef.getBoundingClientRect();
        // Calculate the number of blocks in a row
        const blocksPerRow = Math.floor(containerRect.width / blockRect.width);
        // Calculate the number of rows
        const numRows = Math.ceil((0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).size(props.reports) / blocksPerRow);
        // Calculate the row index of the item
        const rowIndex = Math.floor(index / blocksPerRow) + 1;
        return rowIndex === numRows;
    }, [
        containerRef,
        firstBlockRef,
        props.reports
    ]);
    (0, $70fFQ.useLayoutEffect)(()=>{
        if (!firstBlockRef) return;
        const measure = ()=>{
            const rect = firstBlockRef.getBoundingClientRect();
            setFirstBlockWidth(rect.width);
        };
        measure();
        window.addEventListener("resize", measure);
        return ()=>{
            window.removeEventListener("resize", measure);
        };
    }, [
        firstBlockRef,
        setFirstBlockWidth
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9002556fb230765c$var$HeatMapContainer, {
        ref: containerRef,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(props.reports, (r, i)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $214771db7c959115$export$2e2bcd8739ae039), {
                firstBlockRef: i === 0 ? setFirstBlockRef : null,
                width: isLastRow(i) ? firstBlockWidth : null,
                change: r.zx_index_value_percent_change,
                companyId: r.company_id,
                companyName: r.company_name,
                sectorNames: r.sector_names
            }, r.company_name))
    });
};
$9002556fb230765c$var$HeatMap.propTypes = {
    reports: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        company_id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        company_name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        sector_names: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        zx_index_value_percent_change: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    })).isRequired
};
var $9002556fb230765c$export$2e2bcd8739ae039 = $9002556fb230765c$var$HeatMap;




var $hI4Hx = parcelRequire("hI4Hx");

var $cd0Jr = parcelRequire("cd0Jr");



const $05bfc28dd5c5d81a$var$StyledFilterContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;

  > div {
    flex: 1;
    max-width: 280px;
  }
`;
const $05bfc28dd5c5d81a$var$HeatMapFilter = (props)=>{
    const resetFilters = ()=>{
        props.setSelectedOrdering((0, $1c65c0ea97763ca5$export$42a35608c37ba052));
        props.setSelectedSector(null);
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($05bfc28dd5c5d81a$var$StyledFilterContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Select), {
                multiple: true,
                name: (0, $1c65c0ea97763ca5$export$9ceb2610726b0459),
                options: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(props.sectorNames, (s)=>({
                        label: s,
                        value: s
                    })),
                placeholder: "All Sectors",
                onChange: (val)=>props.setSelectedSector(val),
                value: props.selectedSector || null,
                noSort: true
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Select), {
                name: (0, $1c65c0ea97763ca5$export$609bbe1c6781a75b),
                placeholder: "Positive to negative",
                options: [
                    {
                        label: "Positive to negative",
                        value: "-zx_index_value_percent_change"
                    },
                    {
                        label: "Negative to positive",
                        value: "zx_index_value_percent_change"
                    }
                ],
                onChange: (val)=>props.setSelectedOrdering(val),
                value: props.selectedOrdering || (0, $1c65c0ea97763ca5$export$42a35608c37ba052),
                noSort: true
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                onClick: resetFilters,
                disabled: (props.selectedSector === null || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(props.selectedSector)) && props.selectedOrdering === (0, $1c65c0ea97763ca5$export$42a35608c37ba052),
                children: "Reset Filters"
            })
        ]
    });
};
$05bfc28dd5c5d81a$var$HeatMapFilter.propTypes = {
    sectorNames: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string),
    selectedOrdering: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    selectedSector: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    setSelectedOrdering: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    setSelectedSector: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
$05bfc28dd5c5d81a$var$HeatMapFilter.defaultProps = {
    sectorNames: [],
    selectedOrdering: (0, $1c65c0ea97763ca5$export$42a35608c37ba052),
    selectedSector: null
};
var $05bfc28dd5c5d81a$export$2e2bcd8739ae039 = $05bfc28dd5c5d81a$var$HeatMapFilter;









const $f4ff3d5445d5bd9e$var$StyledMarketActivityContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  padding-top: 48px;
  gap: 24px;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  align-self: center;
  flex-direction: column;
`;
const $f4ff3d5445d5bd9e$var$MarketActivityView = ()=>{
    (0, $90c290bf538e7f9d$export$2e2bcd8739ae039)("ZXData: Market Activity");
    const [selectedOrdering, setSelectedOrdering] = (0, $70fFQ.useState)((0, $1c65c0ea97763ca5$export$42a35608c37ba052));
    const [selectedSector, setSelectedSector] = (0, $70fFQ.useState)(null);
    (0, $70fFQ.useEffect)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).viewMarketActivity();
    }, []);
    (0, $70fFQ.useEffect)(()=>{
        if (selectedSector) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).heatMapFilterSector(selectedSector);
    }, [
        selectedSector
    ]);
    const sectorsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_SECTORS(), {
        "page[size]": 100
    });
    const latestReportsQuery = (0, $f869aac89d4eda76$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_LATEST_ORDER_FLOW_REPORTS(), {
        "page[size]": 500,
        ordering: selectedOrdering,
        ...selectedSector ? {
            sector_name: selectedSector
        } : {}
    }, {
        keepPreviousData: true
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f4ff3d5445d5bd9e$var$StyledMarketActivityContainer, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                children: [
                    "Market Activity /",
                    " ",
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme50, {
                        children: "Heat Map of ZX Index Value MoM Change"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $05bfc28dd5c5d81a$export$2e2bcd8739ae039), {
                selectedOrdering: selectedOrdering,
                selectedSector: selectedSector,
                setSelectedOrdering: setSelectedOrdering,
                setSelectedSector: setSelectedSector,
                sectorNames: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).map(sectorsQuery.cleanedData?.data, "name")
            }),
            latestReportsQuery.isLoading || /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9002556fb230765c$export$2e2bcd8739ae039), {
                reports: latestReportsQuery.cleanedData.data
            }),
            latestReportsQuery.isFetchingNextPage && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {
                absolute: false
            })
        ]
    });
};
var $f4ff3d5445d5bd9e$export$2e2bcd8739ae039 = $f4ff3d5445d5bd9e$var$MarketActivityView;


var $23d87aa47128109b$export$2e2bcd8739ae039 = (0, $f4ff3d5445d5bd9e$export$2e2bcd8739ae039);



parcelRequire("70fFQ");




const $bf1a00356fb3dc32$var$Container = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  gap: 16px;
  padding: 48px;
  text-align: center;
`;
/**
 * 404 page rendered when the user navigates to an unknown route.
 *
 * @returns {React.Element}
 */ const $bf1a00356fb3dc32$var$NotFound = ()=>{
    (0, $90c290bf538e7f9d$export$2e2bcd8739ae039)("ZXData: Page Not Found");
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bf1a00356fb3dc32$var$Container, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline1theme80, {
                children: "404"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                children: "Page not found"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                children: "The page you are looking for does not exist or has been moved."
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES(),
                children: "Go to Companies"
            })
        ]
    });
};
var $bf1a00356fb3dc32$export$2e2bcd8739ae039 = $bf1a00356fb3dc32$var$NotFound;




var $70fFQ = parcelRequire("70fFQ");







var $70fFQ = parcelRequire("70fFQ");




function $50e198d53a681a4d$var$_extends() {
    $50e198d53a681a4d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $50e198d53a681a4d$var$_extends.apply(this, arguments);
}
//      
function $50e198d53a681a4d$var$copyField(oldFields, oldKey, newFields, newKey) {
    newFields[newKey] = $50e198d53a681a4d$var$_extends({}, oldFields[oldKey], {
        name: newKey,
        // prevent functions from being overwritten
        // if the newFields[newKey] does not exist, it will be created
        // when that field gets registered, with its own change/blur/focus callbacks
        change: oldFields[newKey] && oldFields[newKey].change,
        blur: oldFields[newKey] && oldFields[newKey].blur,
        focus: oldFields[newKey] && oldFields[newKey].focus,
        lastFieldState: undefined // clearing lastFieldState forces renotification
    });
    if (!newFields[newKey].change) delete newFields[newKey].change;
    if (!newFields[newKey].blur) delete newFields[newKey].blur;
    if (!newFields[newKey].focus) delete newFields[newKey].focus;
}
//      
// From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
var $50e198d53a681a4d$var$escapeRegexTokens = function escapeRegexTokens(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string
//      
var $50e198d53a681a4d$var$insert = function insert(_ref, state, _ref2) {
    var name = _ref[0], index = _ref[1], value = _ref[2];
    var changeValue = _ref2.changeValue;
    changeValue(state, name, function(array) {
        var copy = [].concat(array || []);
        copy.splice(index, 0, value);
        return copy;
    }); // now we have increment any higher indexes
    var pattern = new RegExp("^" + $50e198d53a681a4d$var$escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
    var newFields = {};
    Object.keys(state.fields).forEach(function(key) {
        var tokens = pattern.exec(key);
        if (tokens) {
            var fieldIndex = Number(tokens[1]);
            if (fieldIndex >= index) {
                // Shift all higher indices up
                var incrementedKey = name + "[" + (fieldIndex + 1) + "]" + tokens[2];
                $50e198d53a681a4d$var$copyField(state.fields, key, newFields, incrementedKey);
                return;
            }
        } // Keep this field that does not match the name,
        // or has index smaller than what is being inserted
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
};
//      
var $50e198d53a681a4d$var$concat = function concat(_ref, state, _ref2) {
    var name = _ref[0], value = _ref[1];
    var changeValue = _ref2.changeValue;
    changeValue(state, name, function(array) {
        return array ? [].concat(array, value) : value;
    });
};
//      
var $50e198d53a681a4d$var$move = function move(_ref, state, _ref2) {
    var name = _ref[0], from = _ref[1], to = _ref[2];
    var changeValue = _ref2.changeValue;
    if (from === to) return;
    changeValue(state, name, function(array) {
        var copy = [].concat(array || []);
        var value = copy[from];
        copy.splice(from, 1);
        copy.splice(to, 0, value);
        return copy;
    });
    var newFields = {};
    var pattern = new RegExp("^" + $50e198d53a681a4d$var$escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
    var lowest;
    var highest;
    var increment;
    if (from > to) {
        lowest = to;
        highest = from;
        increment = 1;
    } else {
        lowest = from;
        highest = to;
        increment = -1;
    }
    Object.keys(state.fields).forEach(function(key) {
        var tokens = pattern.exec(key);
        if (tokens) {
            var fieldIndex = Number(tokens[1]);
            if (fieldIndex === from) {
                var newKey = name + "[" + to + "]" + tokens[2];
                $50e198d53a681a4d$var$copyField(state.fields, key, newFields, newKey);
                return;
            }
            if (lowest <= fieldIndex && fieldIndex <= highest) {
                // Shift all indices
                var _newKey = name + "[" + (fieldIndex + increment) + "]" + tokens[2];
                $50e198d53a681a4d$var$copyField(state.fields, key, newFields, _newKey);
                return;
            }
        } // Keep this field that does not match the name,
        // or has index smaller or larger than affected range
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
};
//      
var $50e198d53a681a4d$var$remove = function remove(_ref, state, _ref2) {
    var name = _ref[0], index = _ref[1];
    var changeValue = _ref2.changeValue, getIn = _ref2.getIn, setIn = _ref2.setIn;
    var returnValue;
    changeValue(state, name, function(array) {
        if (!array) return array;
        var copy = [].concat(array);
        returnValue = copy[index];
        copy.splice(index, 1);
        return copy.length > 0 ? copy : undefined;
    }); // now we have to remove any subfields for our index,
    // and decrement all higher indexes.
    var pattern = new RegExp("^" + $50e198d53a681a4d$var$escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
    var newFields = {};
    Object.keys(state.fields).forEach(function(key) {
        var tokens = pattern.exec(key);
        if (tokens) {
            var fieldIndex = Number(tokens[1]);
            if (fieldIndex === index) {
                // delete any submitErrors for this array item
                // if the root key of the delete index
                if (key === name + "[" + index + "]") {
                    var path = "formState.submitErrors." + name;
                    var submitErrors = getIn(state, path); // if has submitErrors for array
                    if (Array.isArray(submitErrors)) {
                        submitErrors.splice(index, 1);
                        state = setIn(state, path, submitErrors);
                    }
                }
                return;
            }
            if (fieldIndex > index) {
                // Shift all higher indices down
                var decrementedKey = name + "[" + (fieldIndex - 1) + "]" + tokens[2];
                $50e198d53a681a4d$var$copyField(state.fields, key, newFields, decrementedKey);
                return;
            }
        } // Keep this field that does not match the name,
        // or has index smaller than what is being removed
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
    return returnValue;
};
//      
var $50e198d53a681a4d$var$pop = function pop(_ref, state, tools) {
    var name = _ref[0];
    var getIn = tools.getIn;
    var array = getIn(state.formState.values, name);
    return array && array.length > 0 ? $50e198d53a681a4d$var$remove([
        name,
        array.length - 1
    ], state, tools) : undefined;
};
//      
var $50e198d53a681a4d$var$push = function push(_ref, state, _ref2) {
    var name = _ref[0], value = _ref[1];
    var changeValue = _ref2.changeValue;
    changeValue(state, name, function(array) {
        return array ? [].concat(array, [
            value
        ]) : [
            value
        ];
    });
};
//      
var $50e198d53a681a4d$var$binarySearch = function binarySearch(list, value) {
    // This algorithm assumes the items in list is unique
    var first = 0;
    var last = list.length - 1;
    var middle = 0;
    while(first <= last){
        middle = Math.floor((first + last) / 2);
        if (list[middle] === value) return middle;
        if (list[middle] > value) last = middle - 1;
        else first = middle + 1;
    }
    return ~first;
};
var $50e198d53a681a4d$var$removeBatch = function removeBatch(_ref, state, _ref2) {
    var name = _ref[0], indexes = _ref[1];
    var changeValue = _ref2.changeValue;
    if (indexes.length === 0) return [];
    var sortedIndexes = [].concat(indexes);
    sortedIndexes.sort(); // Remove duplicates
    for(var i = sortedIndexes.length - 1; i > 0; i -= 1)if (sortedIndexes[i] === sortedIndexes[i - 1]) sortedIndexes.splice(i, 1);
    var returnValue = [];
    changeValue(state, name, function(array) {
        // use original order of indexes for return value
        returnValue = indexes.map(function(index) {
            return array && array[index];
        });
        if (!array) return array;
        var copy = [].concat(array);
        for(var _i = sortedIndexes.length - 1; _i >= 0; _i -= 1){
            var index = sortedIndexes[_i];
            copy.splice(index, 1);
        }
        return copy.length > 0 ? copy : undefined;
    }); // now we have to remove any subfields for our indexes,
    // and decrement all higher indexes.
    var pattern = new RegExp("^" + $50e198d53a681a4d$var$escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
    var newFields = {};
    Object.keys(state.fields).forEach(function(key) {
        var tokens = pattern.exec(key);
        if (tokens) {
            var fieldIndex = Number(tokens[1]);
            var indexOfFieldIndex = $50e198d53a681a4d$var$binarySearch(sortedIndexes, fieldIndex);
            if (indexOfFieldIndex >= 0) // One of the removed indices
            return;
            if (fieldIndex > sortedIndexes[0]) {
                // Shift all higher indices down
                var decrementedKey = name + "[" + (fieldIndex - ~indexOfFieldIndex) + "]" + tokens[2];
                $50e198d53a681a4d$var$copyField(state.fields, key, newFields, decrementedKey);
                return;
            }
        } // Keep this field that does not match the name,
        // or has index smaller than what is being removed
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
    return returnValue;
};
//      
var $50e198d53a681a4d$var$shift = function shift(_ref, state, tools) {
    var name = _ref[0];
    return $50e198d53a681a4d$var$remove([
        name,
        0
    ], state, tools);
};
//      
var $50e198d53a681a4d$var$swap = function swap(_ref, state, _ref2) {
    var name = _ref[0], indexA = _ref[1], indexB = _ref[2];
    var changeValue = _ref2.changeValue;
    if (indexA === indexB) return;
    changeValue(state, name, function(array) {
        var copy = [].concat(array || []);
        var a = copy[indexA];
        copy[indexA] = copy[indexB];
        copy[indexB] = a;
        return copy;
    }); // swap all field state that begin with "name[indexA]" with that under "name[indexB]"
    var aPrefix = name + "[" + indexA + "]";
    var bPrefix = name + "[" + indexB + "]";
    var newFields = {};
    Object.keys(state.fields).forEach(function(key) {
        if (key.substring(0, aPrefix.length) === aPrefix) {
            var suffix = key.substring(aPrefix.length);
            var newKey = bPrefix + suffix;
            $50e198d53a681a4d$var$copyField(state.fields, key, newFields, newKey);
        } else if (key.substring(0, bPrefix.length) === bPrefix) {
            var _suffix = key.substring(bPrefix.length);
            var _newKey = aPrefix + _suffix;
            $50e198d53a681a4d$var$copyField(state.fields, key, newFields, _newKey);
        } else // Keep this field that does not match the name
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
};
//      
var $50e198d53a681a4d$var$unshift = function unshift(_ref, state, tools) {
    var name = _ref[0], value = _ref[1];
    return $50e198d53a681a4d$var$insert([
        name,
        0,
        value
    ], state, tools);
};
//      
var $50e198d53a681a4d$var$update = function update(_ref, state, _ref2) {
    var name = _ref[0], index = _ref[1], value = _ref[2];
    var changeValue = _ref2.changeValue;
    changeValue(state, name, function(array) {
        var copy = [].concat(array || []);
        copy.splice(index, 1, value);
        return copy;
    });
};
//      
var $50e198d53a681a4d$var$mutators = {
    insert: $50e198d53a681a4d$var$insert,
    concat: $50e198d53a681a4d$var$concat,
    move: $50e198d53a681a4d$var$move,
    pop: $50e198d53a681a4d$var$pop,
    push: $50e198d53a681a4d$var$push,
    remove: $50e198d53a681a4d$var$remove,
    removeBatch: $50e198d53a681a4d$var$removeBatch,
    shift: $50e198d53a681a4d$var$shift,
    swap: $50e198d53a681a4d$var$swap,
    unshift: $50e198d53a681a4d$var$unshift,
    update: $50e198d53a681a4d$var$update
};
var $50e198d53a681a4d$export$2e2bcd8739ae039 = $50e198d53a681a4d$var$mutators;



var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");








var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");





var $cd0Jr = parcelRequire("cd0Jr");


const $9138e8ab42793af5$var$AbandonShareLotsModal = ({ onClose: onClose, abandonShareLots: abandonShareLots })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        title: "Search for a new company?",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                $width: 400,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                        children: "Search for a new company?"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: "You will lose all entered share lots if you search for a new company without saving. Are you sure you want to proceed?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                        onClick: abandonShareLots,
                        children: "Proceed"
                    })
                ]
            })
        ]
    });
$9138e8ab42793af5$var$AbandonShareLotsModal.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    abandonShareLots: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
};
var $9138e8ab42793af5$export$2e2bcd8739ae039 = $9138e8ab42793af5$var$AbandonShareLotsModal;











const $6b85991d91315b01$var$StyledFlex = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
`;
const $6b85991d91315b01$var$StyledSearchBarContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`;
const $6b85991d91315b01$var$StyledSearchBar = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.FinalFormField))`
  width: 100%;
`;
const $6b85991d91315b01$var$StyledSelectedCompanyContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  height: 40px;
  padding: 0 12px;
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const $6b85991d91315b01$var$StyledDropdownContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  overflow-y: auto;
  max-height: 240px;
  margin: -16px 0;
  width: 752px;
`;
const $6b85991d91315b01$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  // I am very important. Overriding Yuka-injected styles.
  border-bottom: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15} !important;
`;
const $6b85991d91315b01$var$FETCH_NEXT_COMPANIES_PAGE_THRESHOLD = 80;
const $6b85991d91315b01$var$getGenericCompanyId = (genericCompany)=>genericCompany.company || genericCompany.requested_company;
const $6b85991d91315b01$var$getPortfolioCompanyId = (portfolioCompany)=>portfolioCompany.company?.zb_id || portfolioCompany.requested_company?.id;
const $6b85991d91315b01$var$PortfolioCompanySearch = ()=>{
    const [abandonShareLotsModalShowing, setAbandonShareLotsModalShowing] = (0, $70fFQ.useState)(false);
    const [portfolio] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const [portfolioCompanies, portfolioCompaniesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolio?.apiId);
    const { values: { [(0, $9f7f80bd8f655910$export$bbe54dd70c4c891d)]: searchQuery, [(0, $9f7f80bd8f655910$export$c96ddd097772fcd0)]: selectedCompanyId, shareLots: shareLots } } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const { change: change, batch: batch } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    const searchBarRef = (0, $70fFQ.useRef)(null);
    const scrollableListRef = (0, $70fFQ.useRef)(null);
    const showSearchResults = (0, $70fFQ.useMemo)(()=>searchQuery?.length >= 1, [
        searchQuery
    ]);
    const mostActiveCompaniesQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).COMPANY_LATEST_ORDER_FLOW(), {
        time_frame: (0, $753b8dcbe6be17f9$export$e15589d55377682c),
        most_active: true,
        "page[size]": 5
    });
    const mostActiveCompanies = (0, $70fFQ.useMemo)(()=>{
        if (mostActiveCompaniesQuery.isSuccess) return mostActiveCompaniesQuery.cleanedData.data;
        return [];
    }, [
        mostActiveCompaniesQuery.isSuccess,
        mostActiveCompaniesQuery.cleanedData
    ]);
    const genericCompanyQuery = (0, $f869aac89d4eda76$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).GENERIC_COMPANY(), {
        search: searchQuery
    }, {
        enabled: showSearchResults
    });
    const onScrollDownFetchNext = (0, $70fFQ.useCallback)((distanceFromBottom)=>{
        if (distanceFromBottom < $6b85991d91315b01$var$FETCH_NEXT_COMPANIES_PAGE_THRESHOLD && genericCompanyQuery.hasNextPage && !genericCompanyQuery.isFetchingNextPage) genericCompanyQuery.fetchNextPage().then((response)=>response.data);
    }, [
        genericCompanyQuery
    ]);
    (0, $cf715cdf7b4bb119$export$2e2bcd8739ae039)({
        scrollRef: scrollableListRef,
        onScrollUp: (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).noop,
        onScrollDown: onScrollDownFetchNext
    });
    const companies = (0, $70fFQ.useMemo)(()=>{
        // Returns either the results from the API fetch, or the local storage companies that were
        // recently visited.
        if (showSearchResults) return genericCompanyQuery.isSuccess ? genericCompanyQuery.cleanedData.data : [];
        return mostActiveCompanies.map((company)=>({
                company: company.apiId,
                name: company.name,
                main_picture: company.main_picture,
                legal_name: company.legal_name
            }));
    }, [
        genericCompanyQuery,
        showSearchResults,
        mostActiveCompanies
    ]);
    const selectedCompany = (0, $70fFQ.useMemo)(()=>{
        if (!genericCompanyQuery.isSuccess || !selectedCompanyId) return null;
        return companies.find((company)=>$6b85991d91315b01$var$getGenericCompanyId(company) === selectedCompanyId);
    }, [
        genericCompanyQuery.isSuccess,
        selectedCompanyId,
        companies
    ]);
    const SearchDropdown = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6b85991d91315b01$var$StyledDropdownContainer, {
            ref: scrollableListRef,
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.List), {
                    children: [
                        mostActiveCompaniesQuery.isLoading && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ListItem), {
                            text: "Loading most active companies..."
                        }),
                        companies.map((company)=>{
                            const alreadyAdded = !portfolioCompaniesLoading && portfolioCompanies.find(// Making use of UUID collision likelihood
                            (portfolioCompany)=>$6b85991d91315b01$var$getPortfolioCompanyId(portfolioCompany) === $6b85991d91315b01$var$getGenericCompanyId(company));
                            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6b85991d91315b01$var$StyledListItem, {
                                avatar: company.main_picture ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Avatar), {
                                    avatar: company.main_picture,
                                    avatarAlt: company.name,
                                    size: "24px"
                                }) : null,
                                trailingContent: alreadyAdded ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                    children: "Already in portfolio"
                                }) : null,
                                leadingIcon: (0, $dfd33cee3229493c$exports.BuildingIcon),
                                text: company.name,
                                onClick: alreadyAdded ? ()=>{} : ()=>{
                                    batch(()=>{
                                        change((0, $9f7f80bd8f655910$export$bbe54dd70c4c891d), company.name);
                                        change((0, $9f7f80bd8f655910$export$c96ddd097772fcd0), $6b85991d91315b01$var$getGenericCompanyId(company));
                                    });
                                }
                            }, `${$6b85991d91315b01$var$getGenericCompanyId(company)}`);
                        })
                    ]
                }),
                genericCompanyQuery.isFetching && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {})
            ]
        });
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(SearchDropdown);
    /*
   * We will auto set the company ID to the first company in the query results if the user's
   * query perfectly matches the company's name, this way we won't require the user to select
   * the company if they typed the name all the way out. Anything other than a perfect match
   * needs to be selected in the dropdown. We also don't auto-select the option if the user already
   * has that company in their portfolio.
   */ (0, $70fFQ.useEffect)(()=>{
        if (selectedCompanyId === null && searchQuery && genericCompanyQuery.isSuccess && companies[0]?.name.toLowerCase().trim() === searchQuery.toLowerCase().trim() && !dropdownElement && !portfolioCompanies.find((company)=>(0, $1c46b8197a693bea$export$2e2bcd8739ae039)(company).toLowerCase().trim() === searchQuery.toLowerCase().trim())) change((0, $9f7f80bd8f655910$export$c96ddd097772fcd0), $6b85991d91315b01$var$getGenericCompanyId(companies[0]));
    }, [
        selectedCompanyId,
        portfolioCompanies,
        dropdownElement,
        searchQuery,
        genericCompanyQuery.isSuccess,
        companies,
        change
    ]);
    /*
   * We'll indicate to the user that the company they're searching for doesn't exist in 2 cases:
   * 1. The user has a search query, the query has executed and there are 0 results
   * 2. The user has a query, is not focussed on the search box, and did not select one of the
   *    available companies.
   *
   * We'll also indicate if the user has manually typed in a company name that's already in their
   * portfolio.
   */ (0, $70fFQ.useEffect)(()=>{
        if (searchQuery && genericCompanyQuery.isSuccess && companies.length === 0) change((0, $9f7f80bd8f655910$export$c95120c046e3a0ee), (0, $9f7f80bd8f655910$export$20b894bc7afa3bd9));
        else if (searchQuery && !dropdownElement && selectedCompanyId === null) {
            if (portfolioCompanies.find((company)=>(0, $1c46b8197a693bea$export$2e2bcd8739ae039)(company).toLowerCase().trim() === searchQuery.toLowerCase().trim())) change((0, $9f7f80bd8f655910$export$c95120c046e3a0ee), (0, $9f7f80bd8f655910$export$d436565424d2e13d));
            else change((0, $9f7f80bd8f655910$export$c95120c046e3a0ee), (0, $9f7f80bd8f655910$export$20b894bc7afa3bd9));
        } else change((0, $9f7f80bd8f655910$export$c95120c046e3a0ee), (0, $9f7f80bd8f655910$export$499338e8263ebdba));
    }, [
        searchQuery,
        genericCompanyQuery.isSuccess,
        companies.length,
        portfolioCompanies,
        change,
        selectedCompanyId,
        dropdownElement
    ]);
    const handleFocus = (0, $70fFQ.useCallback)(()=>{
        if (!dropdownElement) toggleDropdown();
    }, [
        dropdownElement,
        toggleDropdown
    ]);
    const handleBlur = (0, $70fFQ.useCallback)((event)=>{
        if (dropdownRef.current && !dropdownRef.current.contains(event.relatedTarget) && dropdownElement) toggleDropdown();
    }, [
        dropdownRef,
        toggleDropdown,
        dropdownElement
    ]);
    (0, $70fFQ.useEffect)(()=>{
        const current = dropdownRef.current;
        if (current) {
            current.addEventListener("focusin", handleFocus);
            current.addEventListener("focusout", handleBlur);
        }
        return ()=>{
            if (current) {
                current.removeEventListener("focusin", handleFocus);
                current.removeEventListener("focusout", handleBlur);
            }
        };
    }, [
        dropdownRef,
        handleFocus,
        handleBlur
    ]);
    (0, $70fFQ.useEffect)(()=>{
        // When the dropdown element is showing, focus the search bar so typing works.
        if (dropdownElement) searchBarRef.current?.focus();
    }, [
        dropdownElement,
        searchBarRef
    ]);
    (0, $70fFQ.useEffect)(()=>{
        // Defaults to displaying search results when the component first loads.
        if (!selectedCompanyId) searchBarRef.current?.focus();
    }, [
        selectedCompanyId,
        searchBarRef
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            selectedCompany && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6b85991d91315b01$var$StyledSelectedCompanyContainer, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6b85991d91315b01$var$StyledFlex, {
                        children: [
                            selectedCompany.main_picture ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Avatar), {
                                avatar: selectedCompany.main_picture,
                                avatarAlt: selectedCompany.name.slice(0, 2).toUpperCase(),
                                size: "24px"
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.BuildingIcon), {
                                size: 24,
                                color: (0, $dfd33cee3229493c$exports.ColorPalette).white50
                            }),
                            selectedCompany.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                        icon: (0, $dfd33cee3229493c$exports.XCloseIcon),
                        onClick: ()=>{
                            if (shareLots.every((0, $072c01e4bbbdc0f1$export$3ae68de48cfab197))) {
                                // When no modal confirmation is needed.
                                batch(()=>{
                                    change((0, $9f7f80bd8f655910$export$bbe54dd70c4c891d), "");
                                    change((0, $9f7f80bd8f655910$export$c96ddd097772fcd0), null);
                                    change("shareLots", [
                                        {
                                            tempId: Math.random()
                                        }
                                    ]);
                                });
                                toggleDropdown();
                            } else setAbandonShareLotsModalShowing(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($6b85991d91315b01$var$StyledSearchBarContainer, {
                ref: dropdownRef,
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($6b85991d91315b01$var$StyledSearchBar, {
                        type: selectedCompany ? "hidden" : "text",
                        ref: searchBarRef,
                        options: companies,
                        id: "company-search",
                        leadingIcon: (0, $dfd33cee3229493c$exports.SearchIcon),
                        name: (0, $9f7f80bd8f655910$export$bbe54dd70c4c891d),
                        placeholder: "Add company"
                    }),
                    (genericCompanyQuery.isSuccess && companies.length !== 0 || genericCompanyQuery.isIdle) && dropdownElement
                ]
            }),
            abandonShareLotsModalShowing && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9138e8ab42793af5$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    setAbandonShareLotsModalShowing(false);
                },
                abandonShareLots: ()=>{
                    if (!dropdownElement) toggleDropdown();
                    batch(()=>{
                        change((0, $9f7f80bd8f655910$export$bbe54dd70c4c891d), "");
                        change((0, $9f7f80bd8f655910$export$c96ddd097772fcd0), null);
                        change("shareLots", [
                            {
                                tempId: Math.random()
                            }
                        ]);
                    });
                    setAbandonShareLotsModalShowing(false);
                }
            })
        ]
    });
};
var $6b85991d91315b01$export$2e2bcd8739ae039 = $6b85991d91315b01$var$PortfolioCompanySearch;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");







var $cd0Jr = parcelRequire("cd0Jr");




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





const $f3448fa0bec92d5c$var$StyledDropdownContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 300px;
  margin-top: -4px;
  max-height: 184px;
`;
const $f3448fa0bec92d5c$var$StyledHr = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).hr`
  border: none;
  margin-top: 8px;
  border-bottom: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
const $f3448fa0bec92d5c$var$StyledCustomSecurityFooter = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  padding: 16px 12px;
  white-space: wrap;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $f3448fa0bec92d5c$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  padding: 0 12px;
  height: 32px;
  min-height: 32px;
`;
const $f3448fa0bec92d5c$var$StyledField = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  > * {
    line-height: 18px;
  }
`;
const $f3448fa0bec92d5c$var$Component = (props)=>{
    const inputRef = (0, $70fFQ.useRef)(null);
    const { onChange: onChange, value: value, disabled: disabled } = props;
    const SecuritySelectDropdown = (0, $70fFQ.useCallback)(({ toggleIsOpen: toggleIsOpen })=>{
        const handleKeyPress = (event)=>{
            if (event.key === (0, $b432f056c3259fac$export$8152f929a25a0ff4)) {
                onChange(event.target.value);
                toggleIsOpen();
            }
        };
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f3448fa0bec92d5c$var$StyledDropdownContent, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                    children: props.options.map((option)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f3448fa0bec92d5c$var$StyledListItem, {
                            onClick: ()=>{
                                onChange(option.label);
                                toggleIsOpen();
                            },
                            text: option.label
                        }, option.value))
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($f3448fa0bec92d5c$var$StyledHr, {}),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f3448fa0bec92d5c$var$StyledCustomSecurityFooter, {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                            children: "If you can't find a specific security in the list above, please enter it below"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Input), {
                            onKeyDown: handleKeyPress,
                            disabled: disabled,
                            small: true,
                            onChange: (e)=>onChange(e.target.value)
                        })
                    ]
                })
            ]
        });
    }, [
        disabled,
        onChange,
        props.options
    ]);
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)((dropdownProps)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(SecuritySelectDropdown, {
            ...dropdownProps
        }));
    (0, $70fFQ.useEffect)(()=>{
        if (dropdownElement) inputRef?.current.blur();
    }, [
        dropdownElement
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($f3448fa0bec92d5c$var$StyledField, {
        ref: dropdownRef,
        onClick: disabled ? null : ()=>{
            dropdownRef.current?.blur();
            if (!dropdownElement) toggleDropdown();
        },
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Input), {
                placeholder: "Select security",
                disabled: disabled,
                ref: inputRef,
                value: value
            }),
            dropdownElement
        ]
    });
};
$f3448fa0bec92d5c$var$Component.propTypes = {
    options: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    })).isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
/**
 * A field that allows the user to select a security from a list of securities, or enter their
 * own if they don't find the one they're looking for.
 *
 * @param includeLabel
 * @param disabled
 * @param companyId
 * @param props
 * @return {JSX.Element}
 */ const $f3448fa0bec92d5c$var$SecuritySelectField = ({ includeLabel: includeLabel, disabled: disabled, companyId: companyId, ...props })=>{
    const fundingRoundsQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).FUNDING_ROUNDS(), {
        company: companyId,
        "page[size]": 10000
    }, {
        enabled: Boolean(companyId)
    });
    const securityOptions = (0, $70fFQ.useMemo)(()=>{
        if (fundingRoundsQuery.isSuccess) return fundingRoundsQuery.cleanedData.data.filter((fundingRound)=>Boolean(fundingRound.security)).map((fundingRound)=>({
                label: fundingRound.security,
                value: fundingRound.apiId
            }));
        return [];
    }, [
        fundingRoundsQuery.isSuccess,
        fundingRoundsQuery.cleanedData?.data
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
        type: "custom-block",
        label: includeLabel ? "Security" : undefined,
        name: "security",
        disabled: disabled,
        options: securityOptions,
        component: $f3448fa0bec92d5c$var$Component,
        parse: (value)=>fundingRoundsQuery.cleanedData?.data?.find((fundingRound)=>fundingRound.apiId === value)?.security || value,
        ...props
    });
};
$f3448fa0bec92d5c$var$SecuritySelectField.propTypes = {
    includeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
var $f3448fa0bec92d5c$export$2e2bcd8739ae039 = $f3448fa0bec92d5c$var$SecuritySelectField;


const $3777fc984a2fd2f2$var$StyledShareLotRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.FormSection))`
  display: inline-grid;
  justify-content: flex-end;
  gap: 16px;
  grid-template-columns: ${(props)=>props.$clearable ? "1fr 1fr 1fr 1fr 40px" : "1fr 1fr 1fr 1fr"};
`;
const $3777fc984a2fd2f2$var$StyledQuantityField = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.FinalFormField))`
  input {
    text-align: right;
  }
`;
const $3777fc984a2fd2f2$var$StyledIconButtonContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  align-self: flex-end;
`;
const $3777fc984a2fd2f2$var$ShareLotFieldSet = ({ name: name, disabled: disabled, includeLabels: includeLabels, onClear: onClear, companyId: companyId })=>{
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($3777fc984a2fd2f2$var$StyledShareLotRow, {
        $clearable: Boolean(onClear),
        name: name,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($3777fc984a2fd2f2$var$StyledQuantityField, {
                label: includeLabels ? "Quantity" : undefined,
                placeholder: 0,
                disabled: disabled,
                name: "shareQuantity",
                type: "number"
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                label: includeLabels ? "Purchase date" : undefined,
                placeholder: "Select date",
                name: "purchaseDate",
                disabled: disabled,
                type: "date",
                parse: (value)=>(0, $86d2f3987cc9d604$exports.DateTime).fromJSDate(value).toISODate()
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.FinalFormField), {
                label: includeLabels ? "Purchase price" : undefined,
                placeholder: "10.50",
                name: "pricePerShare",
                disabled: disabled,
                type: "number",
                leadingIcon: (0, $dfd33cee3229493c$exports.DollarIcon)
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f3448fa0bec92d5c$export$2e2bcd8739ae039), {
                companyId: companyId,
                includeLabel: includeLabels,
                disabled: disabled
            }),
            onClear && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($3777fc984a2fd2f2$var$StyledIconButtonContainer, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                    disabled: disabled,
                    buttonStyle: (0, $dfd33cee3229493c$exports.IconButtonStyles).RAISED,
                    onClick: onClear,
                    icon: (0, $dfd33cee3229493c$exports.TrashIcon)
                })
            })
        ]
    });
};
$3777fc984a2fd2f2$var$ShareLotFieldSet.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    includeLabels: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    onClear: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    companyId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
var $3777fc984a2fd2f2$export$2e2bcd8739ae039 = $3777fc984a2fd2f2$var$ShareLotFieldSet;



const $b9276da65cea1349$var$ShareLotsGridContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const $b9276da65cea1349$var$ShareLotsFieldArray = (props)=>{
    const { change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    // Used to automatically scroll down when adding rows.
    const addShareLotButtonRef = (0, $70fFQ.useRef)(null);
    const { values: { [(0, $9f7f80bd8f655910$export$c96ddd097772fcd0)]: selectedCompanyId, [(0, $9f7f80bd8f655910$export$bbe54dd70c4c891d)]: searchQuery } } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const disabled = (0, $70fFQ.useMemo)(()=>!searchQuery && !selectedCompanyId || props.disabled, [
        searchQuery,
        selectedCompanyId,
        props.disabled
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($b9276da65cea1349$var$ShareLotsGridContainer, {
        children: [
            props.fields.map((field, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3777fc984a2fd2f2$export$2e2bcd8739ae039), {
                    companyId: selectedCompanyId,
                    disabled: disabled,
                    name: field,
                    includeLabels: index === 0,
                    onClear: ()=>{
                        if (props.fields.length === 1) // If we only have 1 share lot, just reset the field.
                        change("shareLots", [
                            {
                                tempId: Math.random()
                            }
                        ]);
                        else // Otherwise, just remove the row.
                        return props.fields.remove(index);
                    }
                }, `share_lot_${props.fields.value[index].tempId}`)),
            !disabled && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                ref: addShareLotButtonRef,
                icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                onClick: ()=>{
                    setTimeout(()=>addShareLotButtonRef.current.scrollIntoView({
                            behavior: "smooth"
                        }), 1);
                    return props.fields.push({
                        tempId: Math.random()
                    });
                },
                children: "Add share lot"
            })
        ]
    });
};
$b9276da65cea1349$var$ShareLotsFieldArray.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    fields: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        map: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            tempId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
        })),
        length: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        push: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    })
};
var $b9276da65cea1349$export$2e2bcd8739ae039 = $b9276da65cea1349$var$ShareLotsFieldArray;







const $e5d43197de112ed4$var$StyledScrollableModalContent = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $39796339e90eaa03$export$81645ce662b26656))`
  width: 800px;
  min-height: 400px;
  max-height: 600px;
`;
const $e5d43197de112ed4$var$StyledPortfolioName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.TruncatedText))`
  ${(0, $dfd33cee3229493c$exports.headline2)}
  ${(0, $dfd33cee3229493c$exports.FontColors).theme80}
  max-width: 800px;
`;
const $e5d43197de112ed4$var$StyledWarning = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2yellow).attrs({
    as: "p"
})``;
const $e5d43197de112ed4$var$StyledDescription = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50).attrs({
    as: "p"
})``;
const $e5d43197de112ed4$var$CLOSE_ON_SUBMIT = "closeOnSubmit";
const $e5d43197de112ed4$var$AddPortfolioCompanyForm = ({ onClose: onClose })=>{
    const { submit: submit, reset: reset, change: change } = (0, $42456926338d44c1$export$87c0cf8eb5a167e0)();
    const { dirty: dirty, valid: valid, submitting: submitting, values: { [(0, $9f7f80bd8f655910$export$c95120c046e3a0ee)]: companyMatch } } = (0, $42456926338d44c1$export$606f11b2eb45ecc6)();
    const [portfolio] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const submitDisabled = (0, $70fFQ.useMemo)(()=>!dirty || !valid || submitting || companyMatch === (0, $9f7f80bd8f655910$export$d436565424d2e13d), [
        dirty,
        valid,
        submitting,
        companyMatch
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($e5d43197de112ed4$var$StyledScrollableModalContent, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($e5d43197de112ed4$var$StyledPortfolioName, {
                        children: [
                            "Add a company to ",
                            portfolio?.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6b85991d91315b01$export$2e2bcd8739ae039), {})
                    }),
                    companyMatch === (0, $9f7f80bd8f655910$export$20b894bc7afa3bd9) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e5d43197de112ed4$var$StyledWarning, {
                        children: "No matches found. You can add this company and share lots now, and we'll update the data once the company is available on our platform."
                    }),
                    companyMatch === (0, $9f7f80bd8f655910$export$d436565424d2e13d) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e5d43197de112ed4$var$StyledWarning, {
                        children: "This company is already in your portfolio."
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e5d43197de112ed4$var$StyledDescription, {
                        children: "Adding share lots enables us to provide ZX Index Value data for the companies in your portfolio, helping you better track metrics and performance."
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bd7cd108646cef09$export$2683597413c8b91), {
                        name: "shareLots",
                        component: (0, $b9276da65cea1349$export$2e2bcd8739ae039),
                        disabled: companyMatch === (0, $9f7f80bd8f655910$export$d436565424d2e13d)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        disabled: submitDisabled,
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                        onClick: ()=>{
                            change($e5d43197de112ed4$var$CLOSE_ON_SUBMIT, false);
                            submit();
                            reset();
                        },
                        children: "Save & add another"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        disabled: submitDisabled,
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                        onClick: ()=>{
                            change($e5d43197de112ed4$var$CLOSE_ON_SUBMIT, true);
                            return submit();
                        },
                        children: "Save"
                    })
                ]
            })
        ]
    });
};
$e5d43197de112ed4$var$AddPortfolioCompanyForm.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
const $e5d43197de112ed4$var$AddPortfolioCompanyModal = ({ mode: mode, onClose: onClose })=>{
    const addCompany = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_COMPANIES(), false, {
        message: "Company added to portfolio"
    });
    const [portfolio] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const initialValues = (0, $70fFQ.useMemo)(()=>{
        return {
            shareLots: [
                {
                    tempId: Math.random()
                }
            ],
            closeOnSubmit: true,
            [(0, $9f7f80bd8f655910$export$c96ddd097772fcd0)]: null,
            [(0, $9f7f80bd8f655910$export$bbe54dd70c4c891d)]: ""
        };
    }, []);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
        mutators: {
            ...(0, $50e198d53a681a4d$export$2e2bcd8739ae039)
        },
        initialValues: initialValues,
        validate: (values)=>{
            // Ensures companySearch or selectedCompany is filled in and we have no partially filled
            // in share lots.
            const { [(0, $9f7f80bd8f655910$export$c96ddd097772fcd0)]: selectedCompanyId, [(0, $9f7f80bd8f655910$export$bbe54dd70c4c891d)]: companySearch, shareLots: shareLots } = values;
            if (!selectedCompanyId && !companySearch) return "Select a company";
            return (0, $072c01e4bbbdc0f1$export$f72a262d0c5666a0)(shareLots);
        },
        onSubmit: ({ closeOnSubmit: closeOnSubmit, ...values })=>{
            const submitData = {
                portfolio: portfolio.apiId
            };
            if (values.selectedCompany) submitData.company = values.selectedCompany;
            else if (values.companySearch) // Backend will handle creating a new company.
            submitData.requested_company = values.companySearch;
            if (!values.shareLots.every((0, $072c01e4bbbdc0f1$export$3ae68de48cfab197))) submitData.share_lots = values.shareLots.filter((shareLot)=>!(0, $072c01e4bbbdc0f1$export$3ae68de48cfab197)(shareLot)).map((shareLot)=>({
                    purchase_date: shareLot.purchaseDate,
                    price_per_share: shareLot.pricePerShare,
                    share_quantity: shareLot.shareQuantity,
                    security: shareLot.security
                }));
            addCompany.mutate(submitData);
            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addCompanyToPortfolio("portfolio", portfolio.apiId, portfolio.name, values.companySearch, Boolean(values[0, $9f7f80bd8f655910$export$c96ddd097772fcd0]));
            if (submitData.share_lots?.length > 0) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addShareLotsToPortfolio("add company modal", mode, submitData.share_lots.length);
            if (closeOnSubmit) onClose();
        },
        children: ({ handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e5d43197de112ed4$var$AddPortfolioCompanyForm, {
                    onClose: onClose
                })
            })
    });
};
$e5d43197de112ed4$var$AddPortfolioCompanyModal.propTypes = {
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $e5d43197de112ed4$export$2e2bcd8739ae039 = $e5d43197de112ed4$var$AddPortfolioCompanyModal;






var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");







const $4aaa603296879e74$var$DeletePortfolioModal = ({ source: source, onClose: onClose })=>{
    const [portfolio] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const [portfolioCompanies, portfolioCompaniesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolio?.apiId);
    const [shareLots, shareLotsLoading] = (0, $175f183e6334c39c$export$2e2bcd8739ae039)(portfolio?.apiId);
    const deletePortfolioQuery = (0, $fd1e6894b991baa0$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIOS(), {
        invalidateUrls: [
            {
                url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_DETAIL(portfolio.apiId),
                queryParams: {}
            }
        ]
    });
    const onSubmit = ()=>{
        const hasShareLots = !shareLotsLoading && shareLots.some((shareLotList)=>shareLotList.length > 0);
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).deletePortfolio(source, portfolio.apiId, portfolio.name, portfolioCompanies.length, hasShareLots);
        deletePortfolioQuery.mutate({
            id: portfolio.apiId
        });
        onClose();
    };
    if (!portfolio.apiId || portfolioCompaniesLoading) return null;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                        children: "Delete this portfolio?"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: [
                            "This portfolio with",
                            " ",
                            `${portfolioCompanies.length} ${portfolioCompanies.length === 1 ? " company" : " companies"}`,
                            " ",
                            "will be deleted."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                        onClick: onSubmit,
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};
$4aaa603296879e74$var$DeletePortfolioModal.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
};
var $4aaa603296879e74$export$2e2bcd8739ae039 = $4aaa603296879e74$var$DeletePortfolioModal;




var $70fFQ = parcelRequire("70fFQ");

var $70fFQ = parcelRequire("70fFQ");




/**
 * Returns the latest custom valuations for all the companies in a portfolio.
 *
 * @param portfolioId
 */ const $75b76cd15226089d$var$useCustomValuationsForPortfolio = (portfolioId)=>{
    const [portfolioCompanies, companiesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    const customValuationsQueries = (0, $1007cdd3bb68930d$export$2e2bcd8739ae039)((portfolioCompanies || []).map((company)=>({
            url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).CUSTOM_VALUATIONS(),
            queryParams: {
                "page[size]": 1,
                ...(0, $2c8cfe157c823722$export$2e2bcd8739ae039)(company) ? {
                    requested_company: company.requested_company?.id
                } : {
                    company: company.company?.zb_id
                }
            }
        })));
    const latestCustomValuations = (0, $70fFQ.useMemo)(()=>{
        return customValuationsQueries.queryInfo.map((queryInfo, index)=>{
            if (queryInfo.isSuccess) return customValuationsQueries.cleanedData[index]?.data?.[0] || null;
            return null;
        });
    }, [
        customValuationsQueries.queryInfo,
        customValuationsQueries.cleanedData
    ]);
    if (companiesLoading || customValuationsQueries.isLoading) return [
        null,
        true
    ];
    return [
        latestCustomValuations,
        false
    ];
};
var $75b76cd15226089d$export$2e2bcd8739ae039 = $75b76cd15226089d$var$useCustomValuationsForPortfolio;



var $hI4Hx = parcelRequire("hI4Hx");

var $70fFQ = parcelRequire("70fFQ");



/**
 * Same as `usePortfolioValue` except uses the custom valuation for the portfolio companies instead
 * of the current ZX Index Value.
 *
 * @param portfolioId
 */ const $73d05bd17d75f25f$var$usePortfolioValueFromCustomValuation = (portfolioId)=>{
    const [portfolioCompanies, companiesLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    // Get all the share lots and latest custom valuations for all the companies. useFetches guarantees
    // the order of the results matches the order of the queries, and we will make use of that fact
    // below.
    const [shareLots, shareLotsLoading] = (0, $175f183e6334c39c$export$2e2bcd8739ae039)(portfolioId);
    const [customValuations, customValuationsLoading] = (0, $75b76cd15226089d$export$2e2bcd8739ae039)(portfolioId);
    const currentValue = (0, $70fFQ.useMemo)(()=>{
        if (!shareLots || !customValuations) return null;
        return (portfolioCompanies || []).map((company, index)=>{
            // Make use of the useFetches ordering guarantee to use `index`.
            const companyShareLots = shareLots[index];
            const valuation = customValuations[index];
            if (!valuation || !companyShareLots) // We only include companies with verified data in the portfolio value calculation.
            return 0;
            // Determine the current value based on the current ZX Index Value multiplied by the total
            // number of shares.
            const totalShareQuantity = companyShareLots.reduce((acc, shareLot)=>acc + shareLot.share_quantity, 0);
            return totalShareQuantity * Number(valuation.computed_value);
        }).reduce((acc, value)=>acc + value, 0);
    }, [
        customValuations,
        shareLots,
        portfolioCompanies
    ]);
    if (companiesLoading || customValuationsLoading || shareLotsLoading || (0, (/*@__PURE__*/$parcel$interopDefault($hI4Hx))).isEmpty(portfolioCompanies)) return null;
    return currentValue;
};
var $73d05bd17d75f25f$export$2e2bcd8739ae039 = $73d05bd17d75f25f$var$usePortfolioValueFromCustomValuation;



/**
 * Essentially the same as `usePortfolioUnrealizedGain`, but uses the latest custom valuation
 * for each company instead of the current ZX Index Value.
 *
 * @param {string} portfolioId
 * @return {number|null} - Returns the computed on success, or null if any of the queries are still
 *    loading or encountered errors.
 */ const $dd7819a1e8d8e68f$var$usePortfolioUnrealizedGainFromCustomValuation = (portfolioId)=>{
    const currentValue = (0, $73d05bd17d75f25f$export$2e2bcd8739ae039)(portfolioId);
    const [shareLots, shareLotsLoading] = (0, $175f183e6334c39c$export$2e2bcd8739ae039)(portfolioId);
    const [customValuations, customValuationsLoading] = (0, $75b76cd15226089d$export$2e2bcd8739ae039)(portfolioId);
    // Compute the cost basis across all share lots for portfolioID
    const costBasis = (0, $70fFQ.useMemo)(()=>{
        if (!shareLots || !customValuations) return null;
        return shareLots.reduce((acc, companyShareLots, index)=>{
            // We do not include company share lots for companies whose current ZX Index Value is null,
            // because then the share lot would be -100%.
            if (!companyShareLots || !customValuations[index]?.computed_value) return acc;
            return acc + companyShareLots.reduce((acc, shareLot)=>acc + Number(shareLot.price_per_share) * shareLot.share_quantity, 0);
        }, 0);
    }, [
        shareLots,
        customValuations
    ]);
    const totalUnrealizedGain = (0, $70fFQ.useMemo)(()=>{
        if (costBasis === null || currentValue === null) return null;
        return currentValue - costBasis;
    }, [
        currentValue,
        costBasis
    ]);
    if (shareLotsLoading || customValuationsLoading) return null;
    return totalUnrealizedGain;
};
var $dd7819a1e8d8e68f$export$2e2bcd8739ae039 = $dd7819a1e8d8e68f$var$usePortfolioUnrealizedGainFromCustomValuation;





var $70fFQ = parcelRequire("70fFQ");









var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");







const $36630747ef98d95a$var$DeletePortfolioCompanyModal = ({ onClose: onClose, portfolioCompanyAggregate: portfolioCompanyAggregate })=>{
    const [portfolio] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const deleteCompanyQuery = (0, $fd1e6894b991baa0$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_COMPANIES(), {
        invalidateUrls: [
            {
                url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIO_COMPANIES(),
                queryParams: {
                    portfolio_id: portfolio?.apiId
                }
            }
        ]
    });
    const onSubmit = ()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).removeCompanyFromPortfolio("portfolio", portfolio.apiId, portfolio.name, portfolioCompanyAggregate.name, (0, $a397e2ca8ff89f69$export$2e2bcd8739ae039)(portfolioCompanyAggregate.company));
        deleteCompanyQuery.mutate({
            id: portfolioCompanyAggregate.company.apiId
        });
        onClose();
    };
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                        children: [
                            "Remove ",
                            portfolioCompanyAggregate.name,
                            "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: [
                            "This company with",
                            " ",
                            `${portfolioCompanyAggregate.shareLots.length} ${portfolioCompanyAggregate.shareLots.length === 1 ? " share lot" : " share lots"}`,
                            " ",
                            "will be removed."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                        onClick: onSubmit,
                        children: "Remove"
                    })
                ]
            })
        ]
    });
};
$36630747ef98d95a$var$DeletePortfolioCompanyModal.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    portfolioCompanyAggregate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            apiId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        }),
        shareLots: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array
    }).isRequired
};
var $36630747ef98d95a$export$2e2bcd8739ae039 = $36630747ef98d95a$var$DeletePortfolioCompanyModal;









var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");
const $fd6365ae465acb7b$var$StyledFullWidth = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  max-width: 120px;
`;
const $fd6365ae465acb7b$var$LabelContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30).attrs({
    as: "div"
})`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
const $fd6365ae465acb7b$var$StyledIndicatorBar = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
const $fd6365ae465acb7b$var$StyledIndicatorDot = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  position: absolute;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${(0, $dfd33cee3229493c$exports.ColorPalette).white50};
  ${(props)=>props.$left && `left: ${props.$left}%;`}
`;
/*
 * Assumes low, high, and current are properly sorted.
 */ const $fd6365ae465acb7b$var$PriceRangeIndicator = ({ low: low, high: high, current: current })=>{
    const percentageOfCurrent = (0, $70fFQ.useMemo)(()=>{
        // Determine what percentage of the way between low and high current is
        if (low < high && current >= low && current <= high) return (current - low) / (high - low) * 100;
        // Special case for not a lot of change over time. Note that we don't check current here
        // since if low === high current must equal low and high.
        if (low === high) return 50;
    }, [
        low,
        high,
        current
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($fd6365ae465acb7b$var$StyledFullWidth, {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($fd6365ae465acb7b$var$LabelContainer, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                        children: (0, $66339e7a022e68c9$export$736d072c44caa715)(low)
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                        children: (0, $66339e7a022e68c9$export$736d072c44caa715)(high)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($fd6365ae465acb7b$var$StyledIndicatorBar, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($fd6365ae465acb7b$var$StyledIndicatorDot, {
                    $left: percentageOfCurrent
                })
            })
        ]
    });
};
$fd6365ae465acb7b$var$PriceRangeIndicator.propTypes = {
    low: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    high: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    current: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
};
var $fd6365ae465acb7b$export$2e2bcd8739ae039 = $fd6365ae465acb7b$var$PriceRangeIndicator;





var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");





var $cd0Jr = parcelRequire("cd0Jr");






const $aa238dbd5e3fe3c8$var$DeleteShareLotConfirmationModal = ({ source: source, mode: mode, shareLot: shareLot, company: company, onClose: onClose })=>{
    const deleteShareLot = (0, $fd1e6894b991baa0$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SHARE_LOTS());
    const companyName = (0, $1c46b8197a693bea$export$2e2bcd8739ae039)(company);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Modal), {
        modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                        children: "Delete this share lot?"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: [
                            "This share lot will be deleted from ",
                            companyName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        onClick: onClose,
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                        onClick: ()=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).removeShareLot(source, mode, companyName);
                            deleteShareLot.mutate({
                                id: shareLot.apiId
                            });
                            onClose();
                        },
                        buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};
$aa238dbd5e3fe3c8$var$DeleteShareLotConfirmationModal.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    shareLot: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        apiId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }).isRequired,
    company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
        }),
        requested_company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
        })
    }).isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
var $aa238dbd5e3fe3c8$export$2e2bcd8739ae039 = $aa238dbd5e3fe3c8$var$DeleteShareLotConfirmationModal;





var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");








/**
 * A modal that allows a user to create or view/edit a single share lot. Does not allow users
 * to view/create/edit multiple share lots at once.
 *
 * @param {object|null} shareLot - When null, modal will be treated as a "create" modal. When
 *    non-null, shareLot will be used as the default values for the field.
 * @param {function} onClose - Function to call when the modal is closed.
 * @param {string} companyName - Name of the company that this share lot is for.
 */ const $3bae848a7765bc98$var$SingleShareLotModal = ({ source: source, mode: mode, shareLot: shareLot, onClose: onClose, company: company })=>{
    const initialValues = (0, $70fFQ.useMemo)(()=>shareLot ? {
            shareLot: {
                shareQuantity: shareLot.share_quantity,
                pricePerShare: shareLot.price_per_share,
                purchaseDate: shareLot.purchase_date,
                security: shareLot.security
            }
        } : {}, [
        shareLot
    ]);
    const createShareLot = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SHARE_LOTS());
    // We'll need to invalidate the LIST endpoint related to this share lot's portfolio company
    // in the case of an edit so that the change is reflected in the table.
    const editShareLot = (0, $6928fa22999a8502$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SHARE_LOT_DETAIL(shareLot?.apiId), true, {
        invalidateUrls: [
            {
                url: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).SHARE_LOTS(),
                queryParams: {
                    portfolio_company: shareLot?.portfolio_company?.[1]
                }
            }
        ]
    });
    const companyName = (0, $1c46b8197a693bea$export$2e2bcd8739ae039)(company);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $42456926338d44c1$export$a7fed597f4b8afd8), {
        initialValues: initialValues,
        onSubmit: (values)=>{
            const { shareLot: formValues } = values;
            const baseSubmitData = {
                purchase_date: formValues.purchaseDate,
                price_per_share: formValues.pricePerShare,
                share_quantity: formValues.shareQuantity,
                security: formValues.security
            };
            if (shareLot) {
                editShareLot.mutate(baseSubmitData);
                (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).editShareLot(source, mode, companyName);
            } else {
                const submitData = {
                    portfolio_company: company.apiId,
                    ...baseSubmitData
                };
                createShareLot.mutate(submitData);
                (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).addShareLotsToPortfolio(source, mode, 1);
            }
            onClose();
        },
        validate: (values)=>{
            if (!values.shareLot) return undefined;
            return (0, $072c01e4bbbdc0f1$export$f72a262d0c5666a0)([
                values.shareLot
            ]);
        },
        children: ({ handleSubmit: handleSubmit, dirty: dirty, valid: valid, submitting: submitting })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Modal), {
                onClose: onClose,
                modalStyle: (0, $dfd33cee3229493c$exports.ModalStyles).MINIMAL,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$81645ce662b26656), {
                            $width: 756,
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                                    children: [
                                        shareLot ? "Edit " : "Record ",
                                        "a share lot for ",
                                        companyName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3777fc984a2fd2f2$export$2e2bcd8739ae039), {
                                    companyId: company?.company?.zb_id,
                                    includeLabels: true,
                                    name: "shareLot"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$abe9a70c21d758c5), {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                    onClick: onClose,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    type: "submit",
                                    disabled: !dirty || !valid || submitting,
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                    children: "Save"
                                })
                            ]
                        })
                    ]
                })
            })
    });
};
$3bae848a7765bc98$var$SingleShareLotModal.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        apiId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            zb_id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
        }),
        requested_company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
        })
    }),
    shareLot: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        apiId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        purchase_date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        price_per_share: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        share_quantity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        security: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        portfolio_company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string)
    }),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired
};
$3bae848a7765bc98$var$SingleShareLotModal.defaultProps = {
    source: null,
    shareLot: null
};
var $3bae848a7765bc98$export$2e2bcd8739ae039 = $3bae848a7765bc98$var$SingleShareLotModal;





const $a6543bb2491571e9$var$StyledButtonRow = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 100%;
  justify-content: flex-end;
  display: flex;
`;
const $a6543bb2491571e9$var$ShareLotTableStyles = {
    colors: {
        header: "transparent",
        row: "transparent",
        rowHover: (0, $dfd33cee3229493c$exports.ColorPalette).white05,
        rowActive: (0, $dfd33cee3229493c$exports.ColorPalette).white05
    },
    header: {
        paddingLeft: 0,
        paddingRight: 0,
        borderTop: "none",
        borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
    },
    cells: {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: `1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15}`
    }
};
const $a6543bb2491571e9$var$COLUMNS = [
    {
        id: "security",
        accessor: (shareLot)=>shareLot,
        header: "Share lot",
        width: 5,
        cellRenderer: ({ value: shareLot })=>{
            return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                        children: shareLot.security
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                        children: [
                            "\xa0(",
                            (0, $86d2f3987cc9d604$exports.DateTime).fromISO(shareLot.purchase_date).toFormat("MM/dd/yyyy"),
                            ")"
                        ]
                    })
                ]
            });
        }
    },
    {
        id: "pricePerShare",
        accessor: "price_per_share",
        header: "Purchase price",
        width: 4,
        cellRenderer: (0, $dfd33cee3229493c$exports.CurrencyCell)
    },
    {
        id: "shareQuantity",
        accessor: "share_quantity",
        header: "Quantity",
        width: 2,
        cellRenderer: ({ value: value })=>(0, $67b5297c2a83ffd3$export$2e2bcd8739ae039)(value)
    },
    {
        id: "totalValue",
        accessor: (shareLot)=>shareLot,
        header: "Value",
        width: 3,
        cellRenderer: ({ value: shareLot, companyAggregate: companyAggregate, mode: mode })=>{
            const value = mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? companyAggregate.currentZXIndexValue : companyAggregate.customValuation?.computed_value || null;
            if (value === null) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                children: "--"
            });
            return (0, $66339e7a022e68c9$export$365988f95ba9ba73)(value * shareLot.share_quantity, 2, 2);
        }
    },
    {
        id: "unrealizedGain",
        accessor: (shareLot)=>shareLot,
        header: "Unrealized gain",
        width: 5,
        cellRenderer: ({ value: shareLot, companyAggregate: companyAggregate, mode: mode })=>{
            const value = mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? companyAggregate.currentZXIndexValue : companyAggregate.customValuation?.computed_value || null;
            if (value === null) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                children: "--"
            });
            const costBasis = shareLot.price_per_share * shareLot.share_quantity;
            const currentTotalValue = value * shareLot.share_quantity;
            const unrealizedGain = currentTotalValue - costBasis;
            const percentageChange = costBasis ? (currentTotalValue - costBasis) / costBasis * 100 : null;
            if (unrealizedGain > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1buy, {
                children: [
                    "+",
                    (0, $66339e7a022e68c9$export$365988f95ba9ba73)(unrealizedGain, 2, 2),
                    " (+",
                    (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange),
                    ")"
                ]
            });
            if (unrealizedGain < 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1sell, {
                children: [
                    (0, $66339e7a022e68c9$export$365988f95ba9ba73)(unrealizedGain, 2, 2),
                    " (",
                    (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange),
                    ")"
                ]
            });
            return `${(0, $66339e7a022e68c9$export$365988f95ba9ba73)(unrealizedGain)} (${(0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange)})`;
        }
    },
    {
        id: "blank",
        width: 64,
        useFixedWidth: true,
        header: ""
    },
    {
        id: "actions",
        align: "right",
        accessor: (shareLot)=>shareLot,
        width: 4,
        cellRenderer: ({ value: shareLot, row: row, mode: mode, companyName: companyName, editShareLot: editShareLot, deleteShareLot: deleteShareLot, hoveredRowId: hoveredRowId })=>{
            // Conditionally render the action buttons if the rows hovered.
            if (hoveredRowId === row.id) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($a6543bb2491571e9$var$StyledButtonRow, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                        icon: (0, $dfd33cee3229493c$exports.PencilIcon),
                        onClick: ()=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openEditShareLotModal("share lots table", mode);
                            editShareLot(shareLot);
                        }
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                        icon: (0, $dfd33cee3229493c$exports.TrashIcon),
                        onClick: ()=>{
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openRemoveShareLotModal("share lots table", mode, companyName);
                            deleteShareLot(shareLot);
                        }
                    })
                ]
            });
            return "";
        }
    }
];
const $a6543bb2491571e9$var$ShareLotTable = ({ companyAggregate: companyAggregate })=>{
    const [editingShareLot, setEditingShareLot] = (0, $70fFQ.useState)(null);
    const [deletingShareLot, setDeletingShareLot] = (0, $70fFQ.useState)(null);
    const [hoveredRowId, setHoveredRowId] = (0, $70fFQ.useState)(null);
    const { mode: mode } = (0, $70fFQ.useContext)((0, $2f0f11d3c5ba2a18$export$f0ae825879cf78d7));
    const { shareLots: shareLots, company: company, name: name } = companyAggregate;
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            tableStyles: $a6543bb2491571e9$var$ShareLotTableStyles
        },
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Table), {
                companyName: name,
                mode: mode,
                companyAggregate: companyAggregate,
                editShareLot: setEditingShareLot,
                deleteShareLot: setDeletingShareLot,
                usePercentageColumnWidths: true,
                columns: $a6543bb2491571e9$var$COLUMNS,
                data: shareLots,
                hoveredRowId: hoveredRowId,
                onRowClick: ()=>{},
                onRowMouseOver: ({ row: row })=>setHoveredRowId(row.id),
                onRowMouseOut: ()=>setHoveredRowId(null)
            }),
            editingShareLot && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3bae848a7765bc98$export$2e2bcd8739ae039), {
                mode: mode,
                source: "share lots table",
                onClose: ()=>setEditingShareLot(null),
                shareLot: editingShareLot,
                company: company
            }),
            deletingShareLot && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $aa238dbd5e3fe3c8$export$2e2bcd8739ae039), {
                source: "share lots table",
                mode: mode,
                shareLot: deletingShareLot,
                company: company,
                onClose: ()=>setDeletingShareLot(null)
            })
        ]
    });
};
$a6543bb2491571e9$var$ShareLotTable.propTypes = {
    companyAggregate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({}),
        shareLots: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            security: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            price_per_share: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            share_quantity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
        })),
        currentZXIndexValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    })
};
var $a6543bb2491571e9$export$2e2bcd8739ae039 = $a6543bb2491571e9$var$ShareLotTable;














const $c56f205bc6405734$var$EMPTY_VALUE_PLACEHOLDER = /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme50, {
    children: "--"
});
const $c56f205bc6405734$var$StyledActionButton = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039))`
  margin-top: 16px;
`;
const $c56f205bc6405734$var$StyledCurrentPriceCell = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80).attrs({
    as: "div"
})`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const $c56f205bc6405734$var$MODAL_DELETING_COMPANY = "deletingCompany";
const $c56f205bc6405734$var$MODAL_CREATING_SHARE_LOT = "creatingShareLot";
const $c56f205bc6405734$var$MODAL_CREATING_CUSTOM_VALUATION = "creatingCustomValuation";
/**
 *
 * @param company - MUST be the output of the `usePortfolioCompanyAggregates` hook.
 * @return {JSX.Element}
 */ const $c56f205bc6405734$var$PortfolioCompanyAccordionTrigger = ({ companyAggregate: companyAggregate, id: id, isOpen: isOpen })=>{
    const [portfolio] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const [isHovered, setIsHovered] = (0, $70fFQ.useState)(false);
    const [modal, setModal] = (0, $70fFQ.useState)(null);
    const { mode: mode } = (0, $70fFQ.useContext)((0, $2f0f11d3c5ba2a18$export$f0ae825879cf78d7));
    // Sam's log: isError is currently not in use because we technically allow users to add
    // companies to portfolios that do not have order flow data showing. This component renders
    // such companies as a bunch of --'s for every field except quantity. The network returns a 404
    // for these companies when fetching orderflow, so isError is true.
    const { company: company, isLoading: isLoading, name: // isError,
    name, customValuation: customValuation, shareQuantity: shareQuantity, totalValueFromZXIndexValue: totalValueFromZXIndexValue, totalValueFromCustomValuation: totalValueFromCustomValuation, unrealizedGainFromZXIndexValue: unrealizedGainFromZXIndexValue, unrealizedGainFromCustomValuation: unrealizedGainFromCustomValuation, costBasis: costBasis, shareLots: shareLots, low52weeks: low52weeks, high52weeks: high52weeks, currentZXIndexValue: currentZXIndexValue, currentZXIndexValuePercentChange: currentZXIndexValuePercentChange, currentRobustnessScore: currentRobustnessScore } = companyAggregate;
    const zxIndexValueChangeDisplay = (0, $70fFQ.useMemo)(()=>{
        if (currentZXIndexValuePercentChange === null) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
            children: "(+0.00%)"
        });
        const percentDisplay = currentZXIndexValuePercentChange * 100;
        if (percentDisplay > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1buy, {
            children: [
                "(+",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentDisplay),
                ")"
            ]
        });
        if (percentDisplay < 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1sell, {
            children: [
                "(",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentDisplay),
                ")"
            ]
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
            children: [
                "(",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentDisplay),
                ")"
            ]
        });
    }, [
        currentZXIndexValuePercentChange
    ]);
    const totalValueDisplay = (0, $70fFQ.useMemo)(()=>{
        const totalValue = mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? totalValueFromZXIndexValue : totalValueFromCustomValuation;
        return totalValue ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
            children: (0, $66339e7a022e68c9$export$365988f95ba9ba73)(totalValue, 2, 2)
        }) : $c56f205bc6405734$var$EMPTY_VALUE_PLACEHOLDER;
    }, [
        mode,
        totalValueFromZXIndexValue,
        totalValueFromCustomValuation
    ]);
    /*
   * Display the unrealized gain in the correct color and with the percentage change.
   */ const unrealizedGainDisplay = (0, $70fFQ.useMemo)(()=>{
        const totalValue = mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? totalValueFromZXIndexValue : totalValueFromCustomValuation;
        const unrealizedGain = mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? unrealizedGainFromZXIndexValue : unrealizedGainFromCustomValuation;
        if (unrealizedGain === null) return $c56f205bc6405734$var$EMPTY_VALUE_PLACEHOLDER;
        const percentageChange = costBasis ? (totalValue - costBasis) / costBasis * 100 : null;
        if (unrealizedGain > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2buy, {
            children: [
                "+",
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(unrealizedGain, 2, 2),
                " (+",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange),
                ")"
            ]
        });
        if (unrealizedGain < 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2sell, {
            children: [
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(unrealizedGain, 2, 2),
                " (",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange),
                ")"
            ]
        });
        // Vanishingly uncommon case.
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
            children: [
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(unrealizedGain, 2, 2),
                " (",
                (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(percentageChange),
                ")"
            ]
        });
    }, [
        mode,
        totalValueFromZXIndexValue,
        totalValueFromCustomValuation,
        unrealizedGainFromZXIndexValue,
        unrealizedGainFromCustomValuation,
        costBasis
    ]);
    const companyNameDisplay = (0, $70fFQ.useMemo)(()=>{
        if (company?.company) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.HyperLink), {
                url: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANY(company.company.zb_id),
                onClick: (e)=>{
                    dispatch({
                        type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).updateMixpanelEventSource,
                        source: "portfolio",
                        target: (0, $46a097389bbbbe65$export$796b285b8ee8898e)
                    });
                    e.stopPropagation();
                },
                linkType: (0, $dfd33cee3229493c$exports.LinkTypes).LOCAL_LINK,
                linkStyle: (0, $dfd33cee3229493c$exports.LinkStyles).INVISIBLE,
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                    children: name
                })
            })
        });
        else if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(company)) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
            children: name
        });
        return $c56f205bc6405734$var$EMPTY_VALUE_PLACEHOLDER;
    }, [
        company,
        dispatch,
        name
    ]);
    const zxIndexValueDisplay = (0, $70fFQ.useMemo)(()=>currentZXIndexValue ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c56f205bc6405734$var$StyledCurrentPriceCell, {
            children: [
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(currentZXIndexValue, 2, 2),
                " ",
                zxIndexValueChangeDisplay,
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bb0ef5dcd8e37d29$export$2e2bcd8739ae039), {
                    score: currentRobustnessScore
                })
            ]
        }) : $c56f205bc6405734$var$EMPTY_VALUE_PLACEHOLDER, [
        currentZXIndexValue,
        zxIndexValueChangeDisplay,
        currentRobustnessScore
    ]);
    const currentValueDisplay = (0, $70fFQ.useMemo)(()=>{
        // Will show the current ZX Index Value (+ robustness) or the latest custom valuation
        // for the company depending on what mode we're in.
        if (mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9)) return zxIndexValueDisplay;
        // Return custom valuation, with the option to create a new one.
        return customValuation ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c56f205bc6405734$var$StyledCurrentPriceCell, {
            children: [
                (0, $66339e7a022e68c9$export$365988f95ba9ba73)(customValuation.computed_value, 2, 2),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
                    children: (0, $86d2f3987cc9d604$exports.DateTime).fromISO(customValuation.valuation_date).toLocaleString()
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                    icon: isHovered ? (0, $dfd33cee3229493c$exports.PencilIcon) : ()=>null,
                    onClick: (e)=>{
                        setModal($c56f205bc6405734$var$MODAL_CREATING_CUSTOM_VALUATION);
                        // Prevents click from expanding accordion.
                        e.stopPropagation();
                    }
                })
            ]
        }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
            icon: (0, $dfd33cee3229493c$exports.PlusIcon),
            onClick: (e)=>{
                setModal($c56f205bc6405734$var$MODAL_CREATING_CUSTOM_VALUATION);
                // Prevents click from expanding accordion.
                e.stopPropagation();
            },
            children: "New valuation"
        });
    }, [
        mode,
        zxIndexValueDisplay,
        customValuation,
        isHovered
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4723ffe9ea446ab$export$94e939b1f85bdd73), {
                onClick: ()=>{
                    if (!isOpen) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).expandPortfolioCompany(mode);
                    else (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).collapsePortfolioCompany(mode);
                },
                chevronId: id,
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                className: "text-left",
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$82a28123aed8f0f3), {
                    $showData: !(0, $d570420533f8fda2$export$2e2bcd8739ae039)(companyAggregate) && !(mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) && (0, $2c8cfe157c823722$export$2e2bcd8739ae039)(company)),
                    children: [
                        companyNameDisplay,
                        (0, $d570420533f8fda2$export$2e2bcd8739ae039)(companyAggregate) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                            children: [
                                "This company was removed",
                                companyAggregate.removedReason && ` (${(0, $9f7f80bd8f655910$export$7f9ed126330db964)[companyAggregate.removedReason]})`,
                                " ",
                                "on",
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Body1theme80, {
                                    children: [
                                        " ",
                                        (0, $86d2f3987cc9d604$exports.DateTime).fromISO(companyAggregate.removedOn).toFormat("MM/dd/yyyy"),
                                        " "
                                    ]
                                }),
                                "and we won't be displaying data going forward."
                            ]
                        }),
                        mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) && (0, $2c8cfe157c823722$export$2e2bcd8739ae039)(company) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                            children: "This company is not yet verified in ZXData and does not contribute to portfolio value."
                        }),
                        !(0, $d570420533f8fda2$export$2e2bcd8739ae039)(companyAggregate) && !(mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) && (0, $2c8cfe157c823722$export$2e2bcd8739ae039)(company)) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
                            children: [
                                currentValueDisplay,
                                shareQuantity ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body2theme80, {
                                    children: (0, $67b5297c2a83ffd3$export$2e2bcd8739ae039)(shareQuantity)
                                }) : $c56f205bc6405734$var$EMPTY_VALUE_PLACEHOLDER,
                                totalValueDisplay,
                                unrealizedGainDisplay,
                                !isLoading && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $fd6365ae465acb7b$export$2e2bcd8739ae039), {
                                    low: low52weeks,
                                    high: high52weeks,
                                    current: Number(currentZXIndexValue)
                                }),
                                mode === (0, $9f7f80bd8f655910$export$9ca75af4009e4fa2) && zxIndexValueDisplay
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                            icon: isHovered ? (0, $dfd33cee3229493c$exports.TrashIcon) : ()=>null,
                            onClick: (e)=>{
                                setModal($c56f205bc6405734$var$MODAL_DELETING_COMPANY);
                                (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openRemoveCompanyFromPortfolioModal("portfolio", mode, portfolio?.apiId, portfolio?.name, name, (0, $a397e2ca8ff89f69$export$2e2bcd8739ae039)(company));
                                // Prevents click from expanding accordion.
                                e.stopPropagation();
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $c4723ffe9ea446ab$export$985b9a77379b54a0), {
                children: [
                    shareLots?.length > 0 && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $a6543bb2491571e9$export$2e2bcd8739ae039), {
                        companyAggregate: companyAggregate
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($c56f205bc6405734$var$StyledActionButton, {
                        onClick: ()=>{
                            setModal($c56f205bc6405734$var$MODAL_CREATING_SHARE_LOT);
                            (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openAddShareLotModal("share lots table", mode);
                        },
                        icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                        children: [
                            "Record a",
                            shareLots?.length > 0 ? "nother" : "",
                            " share lot"
                        ]
                    })
                ]
            }),
            modal === $c56f205bc6405734$var$MODAL_CREATING_SHARE_LOT ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $3bae848a7765bc98$export$2e2bcd8739ae039), {
                mode: mode,
                source: "share lots table",
                company: company,
                onClose: ()=>setModal(null),
                shareLot: null
            }) : null,
            modal === $c56f205bc6405734$var$MODAL_DELETING_COMPANY && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $36630747ef98d95a$export$2e2bcd8739ae039), {
                portfolioCompanyAggregate: companyAggregate,
                onClose: ()=>setModal(null)
            }),
            modal === $c56f205bc6405734$var$MODAL_CREATING_CUSTOM_VALUATION && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $6242c343450c3bf5$export$2e2bcd8739ae039), {
                companyName: name,
                onClose: ()=>setModal(null),
                requestedCompanyId: companyAggregate.company?.requested_company?.id,
                companyId: companyAggregate.company?.company?.zb_id
            })
        ]
    });
};
$c56f205bc6405734$var$PortfolioCompanyAccordionTrigger.propTypes = {
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    companyAggregate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
                zb_id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
            }),
            requested_company: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
                id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
            })
        }),
        removed: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
        removedOn: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        removedReason: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        shareQuantity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        totalValueFromZXIndexValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        totalValueFromCustomValuation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        unrealizedGainFromZXIndexValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        unrealizedGainFromCustomValuation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        costBasis: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        shareLots: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array,
        low52weeks: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        high52weeks: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        currentZXIndexValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        currentZXIndexValuePercentChange: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        currentRobustnessScore: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        customValuation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            computed_value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            valuation_date: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        })
    })
};
var $c56f205bc6405734$export$2e2bcd8739ae039 = $c56f205bc6405734$var$PortfolioCompanyAccordionTrigger;





var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("70fFQ");






const $9923428b409f8a9a$var$StyledDropdownContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.PageSection))`
  padding: 12px 0;
  margin: -16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $9923428b409f8a9a$var$StyledSection = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50).attrs({
    as: "div"
})`
  padding: 8px 12px;
`;
const $9923428b409f8a9a$var$StyledListItem = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.ListItem))`
  padding: 0 12px;
  height: 32px;
  min-height: 32px;
`;
const $9923428b409f8a9a$var$IconPlaceholderDiv = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 18px;
  height: 18px;
`;
const $9923428b409f8a9a$var$SortByDropdown = ({ updateSort: updateSort, currentSort: currentSort, mode: mode })=>{
    const SearchDropdown = ()=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($9923428b409f8a9a$var$StyledDropdownContainer, {
            children: [
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9923428b409f8a9a$var$StyledSection, {
                            children: "Sort by"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                            children: (0, $9f7f80bd8f655910$export$f11b9f8160aec5e8).map((sortCriteria)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9923428b409f8a9a$var$StyledListItem, {
                                    leadingIconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500,
                                    leadingIcon: sortCriteria === currentSort.criteria ? (0, $dfd33cee3229493c$exports.CheckIcon) : $9923428b409f8a9a$var$IconPlaceholderDiv,
                                    text: sortCriteria,
                                    onClick: ()=>{
                                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).sortPortfolioCompanies(mode, sortCriteria, currentSort.direction);
                                        updateSort({
                                            ...currentSort,
                                            criteria: sortCriteria
                                        });
                                    }
                                }, `sort_criteria_${sortCriteria}`))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9923428b409f8a9a$var$StyledSection, {
                            children: "Sort direction"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.List), {
                            children: (0, $9f7f80bd8f655910$export$d4c8db9df56aeb7b).map((sortDirection)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($9923428b409f8a9a$var$StyledListItem, {
                                    leadingIconColor: (0, $78cf78541be2071b$export$29792b0afe15a7ce).branding500,
                                    leadingIcon: sortDirection === currentSort.direction ? (0, $dfd33cee3229493c$exports.CheckIcon) : $9923428b409f8a9a$var$IconPlaceholderDiv,
                                    text: sortDirection,
                                    onClick: ()=>{
                                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).sortPortfolioCompanies(mode, currentSort.criteria, sortDirection);
                                        updateSort({
                                            ...currentSort,
                                            direction: sortDirection
                                        });
                                    }
                                }, `sort_direction_${sortDirection.key}`))
                        })
                    ]
                })
            ]
        });
    const [dropdownElement, dropdownRef, toggleDropdown] = (0, $dfd33cee3229493c$exports.useDropdown)(SearchDropdown);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                active: dropdownElement !== null,
                ref: dropdownRef,
                onClick: toggleDropdown,
                icon: currentSort.direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941) ? (0, $dfd33cee3229493c$exports.ArrowUpIcon) : (0, $dfd33cee3229493c$exports.ArrowDownIcon),
                children: [
                    "Sort by ",
                    (0, $9f7f80bd8f655910$export$4f3e3139f0bd00ce)[currentSort.criteria]
                ]
            }),
            dropdownElement
        ]
    });
};
$9923428b409f8a9a$var$SortByDropdown.propTypes = {
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    updateSort: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func.isRequired,
    currentSort: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf((0, $9f7f80bd8f655910$export$d4c8db9df56aeb7b)),
        criteria: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf((0, $9f7f80bd8f655910$export$f11b9f8160aec5e8))
    }).isRequired
};
var $9923428b409f8a9a$export$2e2bcd8739ae039 = $9923428b409f8a9a$var$SortByDropdown;







/*
 * All the below sort functions should only be used on objects that come out of the
 * usePortfolioCompanyAggregate hook. This is because the functions rely on the data being
 * in a specific format.
 *
 * Each sort function will be called with a `direction` and a `mode` to construct the sorting
 * comparator function. The direction is either SORT_DIRECTION_ASC or SORT_DIRECTION_DESC, and the
 * mode is either MODE_ZX_INDEX_VALUE or MODE_CUSTOM_VALUATION (used to determine which fields to
 * use when determining "quantity" or "total value").
 *
 * Note that not all the sort functions actually make use of the `mode` parameter, when mode is
 * irrelevant to determining sort.
 */ const $a157ffaaf28917a2$var$sortByAddedDate = (direction)=>(a, b)=>{
        if (direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941)) return (0, $86d2f3987cc9d604$exports.DateTime).fromISO(a.createdOn) - (0, $86d2f3987cc9d604$exports.DateTime).fromISO(b.createdOn);
        return (0, $86d2f3987cc9d604$exports.DateTime).fromISO(b.createdOn) - (0, $86d2f3987cc9d604$exports.DateTime).fromISO(a.createdOn);
    };
const $a157ffaaf28917a2$var$sortByCompany = (direction)=>(a, b)=>{
        if (direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941)) return `${a.name}`.localeCompare(b.name);
        return `${b.name}`.localeCompare(a.name);
    };
const $a157ffaaf28917a2$var$sortByZXIndexValue = (direction)=>(a, b)=>{
        // For requested/removed companies we force them to the bottom of sorted lists, except
        // by company name and date added.
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(a.company) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(a.company)) return 1;
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(b.company) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(b.company)) return -1;
        if (direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941)) return a.currentZXIndexValue - b.currentZXIndexValue;
        return b.currentZXIndexValue - a.currentZXIndexValue;
    };
const $a157ffaaf28917a2$var$sortByCustomValuation = (direction, mode)=>(a, b)=>{
        // For requested/removed companies we force them to the bottom of sorted lists, except
        // by company name and date added.
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(a.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(a.company)) return 1;
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(b.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(b.company)) return -1;
        // Special || usage here to avoid NaN's from using `undefined`.
        const aValuation = a.customValuation?.computed_value || 0;
        const bValuation = b.customValuation?.computed_value || 0;
        if (direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941)) return aValuation - bValuation;
        return bValuation - aValuation;
    };
const $a157ffaaf28917a2$var$sortByQuantity = (direction, mode)=>(a, b)=>{
        // For requested/removed companies we force them to the bottom of sorted lists, except
        // by company name and date added.
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(a.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(a.company)) return 1;
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(b.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(b.company)) return -1;
        if (direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941)) return a.shareQuantity - b.shareQuantity;
        return b.shareQuantity - a.shareQuantity;
    };
const $a157ffaaf28917a2$var$sortByValue = (direction, mode)=>(a, b)=>{
        // For requested/removed companies we force them to the bottom of sorted lists, except
        // by company name and date added.
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(a.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(a.company)) return 1;
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(b.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(b.company)) return -1;
        if (direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941)) return mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? a.totalValueFromZXIndexValue - b.totalValueFromZXIndexValue : a.totalValueFromCustomValuation - b.totalValueFromCustomValuation;
        return mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? b.totalValueFromZXIndexValue - a.totalValueFromZXIndexValue : b.totalValueFromCustomValuation - a.totalValueFromCustomValuation;
    };
const $a157ffaaf28917a2$var$sortByUnrealizedGain = (direction, mode)=>(a, b)=>{
        // For requested/removed companies we force them to the bottom of sorted lists, except
        // by company name and date added.
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(a.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(a.company)) return 1;
        if ((0, $2c8cfe157c823722$export$2e2bcd8739ae039)(b.company) && mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) || (0, $d570420533f8fda2$export$2e2bcd8739ae039)(b.company)) return -1;
        if (direction === (0, $9f7f80bd8f655910$export$8a1c64667c571941)) return mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? a.unrealizedGainFromZXIndexValue - b.unrealizedGainFromZXIndexValue : a.unrealizedGainFromCustomValuation - b.unrealizedGainFromCustomValuation;
        return mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? b.unrealizedGainFromZXIndexValue - a.unrealizedGainFromZXIndexValue : b.unrealizedGainFromCustomValuation - a.unrealizedGainFromCustomValuation;
    };
const $a157ffaaf28917a2$export$a9fc493f2b56ad43 = {
    [(0, $9f7f80bd8f655910$export$c13286d94aaa5103)]: $a157ffaaf28917a2$var$sortByAddedDate,
    [(0, $9f7f80bd8f655910$export$6cf98e810f90594d)]: $a157ffaaf28917a2$var$sortByCompany,
    [(0, $9f7f80bd8f655910$export$6c4ab75a3515ea8b)]: $a157ffaaf28917a2$var$sortByZXIndexValue,
    [(0, $9f7f80bd8f655910$export$e7c1e6cedf6dc420)]: $a157ffaaf28917a2$var$sortByCustomValuation,
    [(0, $9f7f80bd8f655910$export$dad3cfc9bdd61ce9)]: $a157ffaaf28917a2$var$sortByQuantity,
    [(0, $9f7f80bd8f655910$export$de49b66bcf2dd882)]: $a157ffaaf28917a2$var$sortByValue,
    [(0, $9f7f80bd8f655910$export$44a2577ec4dcfcb9)]: $a157ffaaf28917a2$var$sortByUnrealizedGain
};






const $4f857026f9a12273$var$StyledHorizontalRule = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).hr`
  border: none;
  border-bottom: 1px dashed ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
const $4f857026f9a12273$var$PortfolioActionButtons = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-bottom: 24px;
`;
const $4f857026f9a12273$var$PortfolioSummaryTable = ()=>{
    const [accordionValue, setAccordionValue] = (0, $70fFQ.useState)([]);
    const { id: portfolioId } = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const { mode: mode } = (0, $70fFQ.useContext)((0, $2f0f11d3c5ba2a18$export$f0ae825879cf78d7));
    const [portfolioCompanies, portfolioCompaniesAreLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    const [sortState, setSortState] = (0, $70fFQ.useState)({
        criteria: (0, $9f7f80bd8f655910$export$c13286d94aaa5103),
        direction: (0, $9f7f80bd8f655910$export$3c419d7277cff7a7)
    });
    const portfolioCompanyAggregates = (0, $a840f37efa0f043f$export$2e2bcd8739ae039)(portfolioCompanies);
    const sortedPortfolioCompanies = (0, $70fFQ.useMemo)(()=>{
        if (portfolioCompaniesAreLoading) return null;
        return portfolioCompanyAggregates.sort((0, $a157ffaaf28917a2$export$a9fc493f2b56ad43)[sortState.criteria](sortState.direction, mode));
    }, [
        mode,
        portfolioCompaniesAreLoading,
        portfolioCompanyAggregates,
        sortState.direction,
        sortState.criteria
    ]);
    const [addCompanyModalOpen, setAddCompanyModalOpen] = (0, $70fFQ.useState)(false);
    const expandAll = (0, $70fFQ.useCallback)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).expandAllCompanies(mode);
        setAccordionValue(portfolioCompanies.map((company)=>company.apiId));
    }, [
        portfolioCompanies,
        mode
    ]);
    const collapseAll = (0, $70fFQ.useCallback)(()=>{
        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).collapseAllCompanies(mode);
        setAccordionValue([]);
    }, [
        mode
    ]);
    const headers = (0, $70fFQ.useMemo)(()=>mode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? [
            "Company",
            "ZX Index Value",
            "Quantity",
            "Total value",
            "Total unrealized gain",
            "52W range"
        ] : [
            "Company",
            "Custom valuation",
            "Quantity",
            "Total value",
            "Total unrealized gain",
            "ZX Index Value"
        ], [
        mode
    ]);
    if (portfolioCompaniesAreLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    if (portfolioCompanies === null) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
        children: "An error has occurred."
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            portfolioCompanies.length === 0 ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$ce16246c7502d1c8), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$391f39a3139b457a), {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                            children: "Your portfolio is empty"
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                            children: "Add companies to see market insights, performance, and more."
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
                            theme: {
                                button: {
                                    [(0, $dfd33cee3229493c$exports.ButtonStyles).CTA]: {
                                        container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).CTA,
                                leadingIcon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                onClick: ()=>{
                                    setAddCompanyModalOpen(true);
                                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openAddCompanyToPortfolioModal("portfolio - first company");
                                },
                                children: "Add a company"
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($4f857026f9a12273$var$PortfolioActionButtons, {
                        children: [
                            portfolioCompanies.length === accordionValue.length ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                                icon: (0, $dfd33cee3229493c$exports.MinimizeIcon),
                                onClick: collapseAll,
                                children: "Collapse all"
                            }) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                                icon: (0, $dfd33cee3229493c$exports.MaximizeIcon),
                                onClick: expandAll,
                                children: "Expand all"
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9923428b409f8a9a$export$2e2bcd8739ae039), {
                                mode: mode,
                                currentSort: sortState,
                                updateSort: setSortState
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$79590076e00e839c), {
                        children: [
                            headers.map((header)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                                    children: header
                                }, `header_${header}`)),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("div", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4723ffe9ea446ab$export$a766cd26d0d69044), {
                        type: "multiple",
                        collapsible: true,
                        value: accordionValue,
                        onValueChange: setAccordionValue,
                        children: sortedPortfolioCompanies.map((aggregate, index)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c4723ffe9ea446ab$export$d99097c13d4dac9f), {
                                        value: aggregate.company.apiId,
                                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c56f205bc6405734$export$2e2bcd8739ae039), {
                                            id: index === 0 ? "expand-table-row" : undefined,
                                            isOpen: accordionValue.includes(aggregate.company.apiId),
                                            companyAggregate: aggregate
                                        })
                                    }, `row_${aggregate.company.apiId}`),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($4f857026f9a12273$var$StyledHorizontalRule, {})
                                ]
                            }, `row_${aggregate.company.apiId}_fragment`))
                    })
                ]
            }),
            addCompanyModalOpen && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e5d43197de112ed4$export$2e2bcd8739ae039), {
                mode: mode,
                onClose: ()=>setAddCompanyModalOpen(false)
            })
        ]
    });
};
var $4f857026f9a12273$export$2e2bcd8739ae039 = $4f857026f9a12273$var$PortfolioSummaryTable;












const $2f0f11d3c5ba2a18$var$StyledPortfolioLayout = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-grow: 1;
`;
const $2f0f11d3c5ba2a18$var$StyledPortfolioStat = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:not(:first-child) {
    margin-bottom: 6px;
  }
`;
const $2f0f11d3c5ba2a18$var$TruncatedPortfolioName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.TruncatedText))`
  max-width: 750px;
`;
const $2f0f11d3c5ba2a18$var$valueWithChangeDisplay = (value, change)=>{
    if (value === null || change === null) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline4theme30, {
        children: "-- (--%)"
    });
    if (value > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline4buy, {
        children: [
            "+",
            (0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, 2, 2),
            " (+",
            (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(change),
            ")"
        ]
    });
    if (value < 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline4sell, {
        children: [
            (0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, 2, 2),
            " (",
            (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(change),
            ")"
        ]
    });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.Fonts).Headline4theme80, {
        children: [
            (0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, 2, 2),
            " (+",
            (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(change),
            ")"
        ]
    });
};
const $2f0f11d3c5ba2a18$export$f0ae825879cf78d7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext((0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9));
const $2f0f11d3c5ba2a18$var$MODAL_DELETE_PORTFOLIO = "deletePortfolio";
const $2f0f11d3c5ba2a18$var$MODAL_RENAME_PORTFOLIO = "renamePortfolio";
const $2f0f11d3c5ba2a18$var$MODAL_ADD_COMPANY = "addCompany";
const $2f0f11d3c5ba2a18$var$WALKTHROUGH_STEPS = [
    {
        title: "Add more companies",
        text: "You can add more companies to your portfolio and easily monitor the performance of your holdings, all in one place.",
        positionSelector: "#add-company-to-portfolio-button"
    },
    {
        title: "Track your holdings",
        text: "Expand each row to add or edit individual share lots for your portfolio companies.",
        positionSelector: "#expand-table-row"
    },
    {
        title: "Custom valuations",
        text: "Switch to custom valuation mode to get a more personalized view of your portfolio companies based on your valuations.",
        positionSelector: `#${(0, $9f7f80bd8f655910$export$9ca75af4009e4fa2)}`
    },
    {
        title: "Create multiple portfolios",
        text: "Organize your investments by creating multiple portfolios for different strategies or clients.",
        positionSelector: "#create-portfolio-button"
    }
];
const $2f0f11d3c5ba2a18$var$PortfolioProfile = ()=>{
    const { id: portfolioId } = (0, $9a6b443e2c413186$export$99eaa27ddbbb95ef)();
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const currentMode = (0, $dfd33cee3229493c$exports.useCurrentTab)("mode");
    const [portfolio, portfolioIsLoading] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const [portfolioCompanies, portfolioCompaniesAreLoading] = (0, $b48a78ee18a41ad4$export$2e2bcd8739ae039)(portfolioId);
    const { walkthroughShowing: walkthroughShowing, completeWalkthrough: completeWalkthrough } = (0, $f7a9c013198e3a53$export$2e2bcd8739ae039)("walkthrough_portfolios");
    const [exporting, setExporting] = (0, $70fFQ.useState)(false);
    const [modal, setModal] = (0, $70fFQ.useState)(null);
    const [actionsMenu, triggerRef, toggleDisplay] = (0, $dfd33cee3229493c$exports.useAnchoredMenu)({
        menuItems: [
            {
                onClick: ()=>{
                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openRenamePortfolioModal();
                    setModal($2f0f11d3c5ba2a18$var$MODAL_RENAME_PORTFOLIO);
                },
                key: "rename",
                text: "Rename",
                icon: (0, $dfd33cee3229493c$exports.PencilIcon)
            },
            {
                onClick: ()=>{
                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openDeletePortfolioModal();
                    setModal($2f0f11d3c5ba2a18$var$MODAL_DELETE_PORTFOLIO);
                },
                key: "delete",
                text: "Delete",
                icon: (0, $dfd33cee3229493c$exports.TrashIcon)
            },
            {
                onClick: ()=>{
                    setExporting(true);
                    (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).exportPortfolio("portfolio", currentMode, portfolio?.apiId, portfolio?.name, portfolioCompanies?.length);
                    (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039).get((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).DOWNLOAD_PORTFOLIO(portfolio?.apiId)).then(()=>{
                        dispatch({
                            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                            message: "Your portfolio export is being generated, please check your email in a couple of minutes for receipt of the export."
                        });
                    }).catch(()=>{
                        dispatch({
                            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).addToast,
                            message: "Failed to download portfolio. Please try again or contact support."
                        });
                    }).finally(()=>{
                        setExporting(false);
                        toggleDisplay();
                    });
                },
                key: "export",
                text: "Export",
                icon: (0, $dfd33cee3229493c$exports.LinkExternalIcon)
            }
        ]
    });
    const portfolioValueFromZXIndexValue = (0, $c0753d95e24a3305$export$2e2bcd8739ae039)(portfolio?.apiId);
    const portfolioValueFromCustomValuation = (0, $73d05bd17d75f25f$export$2e2bcd8739ae039)(portfolio?.apiId);
    const lastWeekPortfolioValue = (0, $59d8e8d545f6ae7a$export$2e2bcd8739ae039)(portfolio?.apiId);
    const totalUnrealizedGain = (0, $e14bfaf84535560c$export$2e2bcd8739ae039)(portfolio?.apiId);
    const totalUnrealizedGainFromCustomValuation = (0, $dd7819a1e8d8e68f$export$2e2bcd8739ae039)(portfolio?.apiId);
    const unrealizedGainPercentChange = (0, $70fFQ.useMemo)(()=>{
        const portfolioValue = currentMode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? portfolioValueFromZXIndexValue : portfolioValueFromCustomValuation;
        const unrealizedGainValue = currentMode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? totalUnrealizedGain : totalUnrealizedGainFromCustomValuation;
        // Reverse engineer cost basis and determine overall percentage change.
        if (portfolioValue === null || unrealizedGainValue === null) return null;
        const costBasis = portfolioValue - unrealizedGainValue;
        if (costBasis === 0) return null; // Infinity percent change
        return (portfolioValue - costBasis) / costBasis;
    }, [
        currentMode,
        portfolioValueFromCustomValuation,
        portfolioValueFromZXIndexValue,
        totalUnrealizedGain,
        totalUnrealizedGainFromCustomValuation
    ]);
    const [weekChange, percentChange] = (0, $70fFQ.useMemo)(()=>{
        if (portfolioValueFromZXIndexValue === null || lastWeekPortfolioValue === null) return [
            null,
            null
        ];
        if (lastWeekPortfolioValue === 0) return [
            portfolioValueFromZXIndexValue,
            null
        ]; // Infinity percent change.
        return [
            portfolioValueFromZXIndexValue - lastWeekPortfolioValue,
            (portfolioValueFromZXIndexValue - lastWeekPortfolioValue) / lastWeekPortfolioValue
        ];
    }, [
        portfolioValueFromZXIndexValue,
        lastWeekPortfolioValue
    ]);
    const portfolioValueDisplay = (0, $70fFQ.useMemo)(()=>{
        const value = currentMode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? portfolioValueFromZXIndexValue : portfolioValueFromCustomValuation;
        return value ? (0, $66339e7a022e68c9$export$365988f95ba9ba73)(value, 2, 2) : "$0.00";
    }, [
        currentMode,
        portfolioValueFromZXIndexValue,
        portfolioValueFromCustomValuation
    ]);
    const unrealizedGainDisplay = (0, $70fFQ.useMemo)(()=>{
        const unrealizedGainValue = currentMode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) ? totalUnrealizedGain : totalUnrealizedGainFromCustomValuation;
        return $2f0f11d3c5ba2a18$var$valueWithChangeDisplay(unrealizedGainValue, unrealizedGainPercentChange * 100);
    }, [
        currentMode,
        totalUnrealizedGain,
        totalUnrealizedGainFromCustomValuation,
        unrealizedGainPercentChange
    ]);
    if (portfolioIsLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    if (portfolio === null && portfolioId !== null) {
        if (portfolioId) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme30, {
            children: "An error has occurred."
        });
        return null;
    }
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($2f0f11d3c5ba2a18$export$f0ae825879cf78d7.Provider, {
        value: {
            mode: currentMode || (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9)
        },
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($2f0f11d3c5ba2a18$var$StyledPortfolioLayout, {
            children: [
                portfolioCompanies?.length > 0 && walkthroughShowing && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $94e97caba62a953c$export$2e2bcd8739ae039), {
                    name: "portfolios",
                    steps: $2f0f11d3c5ba2a18$var$WALKTHROUGH_STEPS,
                    onFinish: completeWalkthrough
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$a2d4d3aa503347c), {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline3theme80, {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($2f0f11d3c5ba2a18$var$TruncatedPortfolioName, {
                                        children: portfolio.name
                                    })
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e68215c90b0d6c33$export$2e2bcd8739ae039), {
                                    variant: "buttonGroup",
                                    queryParam: "mode",
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $f52afbcf820a94e0$export$2e2bcd8739ae039), {
                                        defaultTabId: (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9),
                                        resizeable: false,
                                        children: [
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e754b611d0d28d4e$export$2e2bcd8739ae039), {
                                                id: (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9),
                                                onSelectTab: ()=>{
                                                    if (currentMode !== (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9)) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).togglePortfolioMode(currentMode, (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9));
                                                },
                                                children: "ZX Index Value"
                                            }),
                                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e754b611d0d28d4e$export$2e2bcd8739ae039), {
                                                id: (0, $9f7f80bd8f655910$export$9ca75af4009e4fa2),
                                                onSelectTab: ()=>{
                                                    if (currentMode !== (0, $9f7f80bd8f655910$export$9ca75af4009e4fa2)) (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).togglePortfolioMode(currentMode, (0, $9f7f80bd8f655910$export$9ca75af4009e4fa2));
                                                },
                                                children: "Custom valuation"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)("div", {
                            children: [
                                !portfolioCompaniesAreLoading && portfolioCompanies?.length !== 0 && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                    id: "add-company-to-portfolio-button",
                                    buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                    leadingIcon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                    onClick: ()=>{
                                        setModal($2f0f11d3c5ba2a18$var$MODAL_ADD_COMPANY);
                                        (0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).openAddCompanyToPortfolioModal("portfolio");
                                    },
                                    children: "Add a company"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.IconButton), {
                                    ref: triggerRef,
                                    buttonStyle: (0, $dfd33cee3229493c$exports.IconButtonStyles).RAISED,
                                    icon: (0, $dfd33cee3229493c$exports.DotsVerticalIcon),
                                    onClick: toggleDisplay
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$470b861649e7e2bd), {
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($2f0f11d3c5ba2a18$var$StyledPortfolioStat, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                                    children: "Portfolio value"
                                }),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline5theme80, {
                                    children: portfolioValueDisplay
                                })
                            ]
                        }),
                        currentMode === (0, $9f7f80bd8f655910$export$55eb0e54fb69f7d9) && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($2f0f11d3c5ba2a18$var$StyledPortfolioStat, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                                    children: "Week change"
                                }),
                                $2f0f11d3c5ba2a18$var$valueWithChangeDisplay(weekChange, percentChange * 100)
                            ]
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($2f0f11d3c5ba2a18$var$StyledPortfolioStat, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Overlinetheme50, {
                                    children: "Unrealized gain/loss"
                                }),
                                unrealizedGainDisplay
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $4f857026f9a12273$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.PageSection), {
                    children: actionsMenu
                }),
                modal === $2f0f11d3c5ba2a18$var$MODAL_DELETE_PORTFOLIO && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $4aaa603296879e74$export$2e2bcd8739ae039), {
                    source: "portfolio",
                    onClose: ()=>setModal(null)
                }),
                modal === $2f0f11d3c5ba2a18$var$MODAL_RENAME_PORTFOLIO && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $53819f53b665196a$export$2e2bcd8739ae039), {
                    source: "portfolio",
                    portfolio: portfolio,
                    onClose: ()=>setModal(null)
                }),
                modal === $2f0f11d3c5ba2a18$var$MODAL_ADD_COMPANY && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e5d43197de112ed4$export$2e2bcd8739ae039), {
                    mode: currentMode,
                    onClose: ()=>setModal(null)
                }),
                exporting && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $2f0f11d3c5ba2a18$export$2e2bcd8739ae039 = $2f0f11d3c5ba2a18$var$PortfolioProfile;




var $cd0Jr = parcelRequire("cd0Jr");

var $70fFQ = parcelRequire("70fFQ");




const $bc449d3ed83a9d1f$var$TruncatedPortfolioName = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.TruncatedText))`
  max-width: 400px;
`;
const $bc449d3ed83a9d1f$var$StyledCounter = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $dfd33cee3229493c$exports.FontColors).theme80}

  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 16px;
  border-radius: 8px;
  padding: 0 8px;
  height: 16px;
  ${(props)=>{
    if (props.$percentChange) {
        if (props.$percentChange > 0) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          background: ${props.theme.colors.green};
        `;
        if (props.$percentChange < 0) return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
          background: ${props.theme.colors.red};
        `;
    }
    return (0, $e42cae22e74e223a$export$dbf350e5966cf602)`
      background: ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
    `;
}}
`;
const $bc449d3ed83a9d1f$var$PortfolioTabContent = ({ portfolioId: portfolioId, name: name })=>{
    const portfolioValue = (0, $c0753d95e24a3305$export$2e2bcd8739ae039)(portfolioId);
    const lastWeekPortfolioValue = (0, $59d8e8d545f6ae7a$export$2e2bcd8739ae039)(portfolioId);
    const percentChange = (0, $70fFQ.useMemo)(()=>{
        if (portfolioValue === null || lastWeekPortfolioValue === null) return null;
        if (lastWeekPortfolioValue === 0) return null; // Infinity percent
        return (portfolioValue - lastWeekPortfolioValue) / lastWeekPortfolioValue;
    }, [
        portfolioValue,
        lastWeekPortfolioValue
    ]);
    const ArrowIcon = (0, $70fFQ.useMemo)(()=>{
        if (percentChange === null) return null;
        return percentChange >= 0 ? (0, $dfd33cee3229493c$exports.ArrowUpIcon) : (0, $dfd33cee3229493c$exports.ArrowDownIcon);
    }, [
        percentChange
    ]);
    const percentDisplay = (0, $70fFQ.useMemo)(()=>{
        if (percentChange !== null) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
            theme: {
                mode: percentChange === 0 ? "dark" : "light"
            },
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme80, {
                children: (0, $66339e7a022e68c9$export$82fb8ba313c9dbb0)(Math.abs(percentChange) * 100, 2)
            })
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
            theme: {
                mode: "dark"
            },
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Caption2theme30, {
                children: "--"
            })
        });
    }, [
        percentChange
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($bc449d3ed83a9d1f$var$TruncatedPortfolioName, {
                children: name
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($bc449d3ed83a9d1f$var$StyledCounter, {
                $percentChange: percentChange,
                children: [
                    ArrowIcon && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)(ArrowIcon, {
                        color: percentChange === 0 ? (0, $dfd33cee3229493c$exports.ColorPalette).white50 : (0, $dfd33cee3229493c$exports.ColorPalette).black50
                    }),
                    percentDisplay
                ]
            })
        ]
    });
};
$bc449d3ed83a9d1f$var$PortfolioTabContent.propTypes = {
    portfolioId: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
var $bc449d3ed83a9d1f$export$2e2bcd8739ae039 = $bc449d3ed83a9d1f$var$PortfolioTabContent;











const $5ea263d6d8caa115$var$StyledTabListPageSection = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.PageSection))`
  flex-shrink: 0;
  padding: 0 24px;
`;
const $5ea263d6d8caa115$var$StyledLayout = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  ${(0, $27107782d824bd56$export$5e3a8d80984ffe28)}
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;
const $5ea263d6d8caa115$var$PortfolioProfileContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  width: 100%;
  padding-top: 48px;
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-top: 1px solid ${(0, $dfd33cee3229493c$exports.ColorPalette).white15};
`;
const $5ea263d6d8caa115$var$StyledNoPortfoliosTab = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $e754b611d0d28d4e$export$2e2bcd8739ae039))`
  ${(0, $dfd33cee3229493c$exports.FontColors).theme30}
`;
const $5ea263d6d8caa115$var$Portfolios = ()=>{
    const navigate = (0, $9a6b443e2c413186$export$9770f232ac06a008)();
    const [portfolio, portfolioIsLoading] = (0, $41057fa49be8f4de$export$2e2bcd8739ae039)();
    const [createPortfolioModalOpen, setCreatePortfolioModalOpen] = (0, $70fFQ.useState)(false);
    const portfolioQuery = (0, $3b38c5c0bd1105aa$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).PORTFOLIOS());
    const portfolios = (0, $70fFQ.useMemo)(()=>{
        return portfolioQuery.isSuccess && !portfolioQuery.isRefetching ? portfolioQuery.cleanedData.data : [];
    }, [
        portfolioQuery.isSuccess,
        portfolioQuery.isRefetching,
        portfolioQuery.cleanedData
    ]);
    const firstPortfolioId = portfolios?.[0]?.apiId;
    (0, $70fFQ.useEffect)(()=>{
        // When a portfolio is deleted, we navigate away. Either to the first portfolio in their list,
        // or to the base page if there are no portfolios.
        if (!portfolioIsLoading && !portfolio) {
            if (firstPortfolioId) navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIO(firstPortfolioId), {
                replace: true
            });
            else navigate((0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIOS(), {
                replace: true
            });
        }
    }, [
        firstPortfolioId,
        portfolioIsLoading,
        portfolio,
        navigate
    ]);
    const portfoliosTabContent = (0, $70fFQ.useMemo)(()=>{
        if (portfolioQuery.isLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5ea263d6d8caa115$var$StyledNoPortfoliosTab, {
            id: "loading-portfolios",
            children: "Loading portfolios"
        });
        if (portfolios.length > 0) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f52afbcf820a94e0$export$2e2bcd8739ae039), {
            scrollIntoView: true,
            defaultTabId: firstPortfolioId,
            children: portfolios.map(({ apiId: apiId, name: name })=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e754b611d0d28d4e$export$2e2bcd8739ae039), {
                    id: apiId,
                    onSelectTab: ()=>(0, $fcb46ed2ee17f59f$export$2e2bcd8739ae039).navigateToPortfolioProfile("portfolios tab", apiId, name),
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bc449d3ed83a9d1f$export$2e2bcd8739ae039), {
                        portfolioId: apiId,
                        name: name
                    })
                }, `tab_${apiId}`))
        });
        return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5ea263d6d8caa115$var$StyledNoPortfoliosTab, {
            id: "no-portfolios",
            children: "You don't have any portfolios yet"
        });
    }, [
        portfolioQuery?.isLoading,
        portfolios,
        firstPortfolioId
    ]);
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
        theme: {
            button: {
                [(0, $dfd33cee3229493c$exports.ButtonStyles).CTA]: {
                    container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
                },
                [(0, $dfd33cee3229493c$exports.ButtonStyles).RAISED]: {
                    container: (0, $2bea9d664998feb5$export$b9f4a6445d7ff477)
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($5ea263d6d8caa115$var$StyledTabListPageSection, {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $e68215c90b0d6c33$export$2e2bcd8739ae039), {
                    routeId: "id",
                    children: [
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e754b611d0d28d4e$export$2e2bcd8739ae039), {
                            id: "create-portfolio-button",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $00de0ec5a3f2db13$export$2e2bcd8739ae039), {
                                icon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                onClick: ()=>setCreatePortfolioModalOpen(true),
                                children: "New portfolio"
                            })
                        }),
                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e68215c90b0d6c33$export$16c00e832ee4fba4), {}),
                        portfoliosTabContent
                    ]
                })
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5ea263d6d8caa115$var$PortfolioProfileContainer, {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($5ea263d6d8caa115$var$StyledLayout, {
                        children: [
                            portfolios.length === 0 && !portfolioQuery.isLoading && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $39796339e90eaa03$export$ce16246c7502d1c8), {
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $39796339e90eaa03$export$391f39a3139b457a), {
                                    children: [
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Headline2theme80, {
                                            children: "No portfolios yet"
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Fonts).Body1theme50, {
                                            children: "Create your first portfolio to track and manage your private companies and/or holdings with advanced insights."
                                        }),
                                        /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.Button), {
                                            buttonStyle: (0, $dfd33cee3229493c$exports.ButtonStyles).RAISED,
                                            leadingIcon: (0, $dfd33cee3229493c$exports.PlusIcon),
                                            onClick: ()=>setCreatePortfolioModalOpen(true),
                                            children: "Create a portfolio"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $2f0f11d3c5ba2a18$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $253eff529b7bdd6f$export$2e2bcd8739ae039), {})
                ]
            }),
            createPortfolioModalOpen && /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $53819f53b665196a$export$2e2bcd8739ae039), {
                source: portfolios.length === 0 ? "first portfolio" : "portfolio",
                onClose: ()=>setCreatePortfolioModalOpen(false)
            })
        ]
    });
};
var $5ea263d6d8caa115$export$2e2bcd8739ae039 = $5ea263d6d8caa115$var$Portfolios;








const $c01b1af6673b4a25$var$StyledToastContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  z-index: ${(0, $dfd33cee3229493c$exports.Z_INDEXES).zIndexAriaModalSelect};
  position: fixed;
  bottom: 16px;
  left: 16px;
  max-width: 480px;
`;
const $c01b1af6673b4a25$var$ToastList = ()=>{
    const dispatch = (0, $46a097389bbbbe65$export$8ad76b76a4c905f8)();
    const toasts = (0, $46a097389bbbbe65$export$2105062e25df4afe)((state)=>state.toasts);
    const deque = (id)=>dispatch({
            type: (0, $46a097389bbbbe65$export$92a1a3b7554e9387).removeToast,
            id: id
        });
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($c01b1af6673b4a25$var$StyledToastContainer, {
        children: toasts.map((toast)=>/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.ToastMessage), {
                title: toast.message,
                onClose: ()=>deque(toast.id)
            }, toast.id))
    });
};
var $c01b1af6673b4a25$export$2e2bcd8739ae039 = $c01b1af6673b4a25$var$ToastList;




const $de876a1da5740a6c$var$StyledPageSection = (0, $e42cae22e74e223a$export$2e2bcd8739ae039)((0, $dfd33cee3229493c$exports.PageSection))`
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
  width: 100%;
`;
const $de876a1da5740a6c$var$FeatureProtectedRoute = (props)=>{
    const [hasFeatureAccess, featureAccessLoading] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)(props.featureName);
    if (featureAccessLoading) return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7cf104288a3d5c08$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Fragment, {
        children: hasFeatureAccess ? /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$910ae8079b2c2852), {}) : /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$444b3ab0cb9aec40), {
            to: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN()
        })
    });
};
$de876a1da5740a6c$var$FeatureProtectedRoute.propTypes = {
    featureName: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
const $de876a1da5740a6c$var$MainRoutes = ()=>{
    const [portfoliosFeatureAccess] = (0, $2245bf051ccf70ab$export$2e2bcd8739ae039)((0, $beb11aa5e2886f26$export$6d4c76a833ca8f22));
    return /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $34ccb6660205eec8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f5a68a16bc4b55a2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)((0, $9a6b443e2c413186$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).LOGIN(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ccea159ae1764da7$export$2e2bcd8739ae039), {
                            bylineText: "Please enter your credentials to log in",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $4a305f9fa19dd7a5$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).RESET_PASSWORD(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ccea159ae1764da7$export$2e2bcd8739ae039), {
                            bylineText: "Forgot your password?",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $e57de322dec43041$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).RESET_PASSWORD_CONFIRM(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ccea159ae1764da7$export$2e2bcd8739ae039), {
                            bylineText: "Email sent!",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $f95eb8f5335e9c74$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: `${(0, $447d80c2705a4d0e$export$a3b943834c35c8a3).SET_PASSWORD_BASE()}:token`,
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ccea159ae1764da7$export$2e2bcd8739ae039), {
                            bylineText: "Set your new password",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5657343c83e756b2$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: `${(0, $447d80c2705a4d0e$export$a3b943834c35c8a3).SET_PASSWORD_NEW_USER()}:token`,
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ccea159ae1764da7$export$2e2bcd8739ae039), {
                            bylineText: "Choose a password",
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7a738fb69523d82f$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).ACCOUNT(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $1264b55b25318845$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: `${(0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENT()}`,
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d0d028f6372c04f9$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: `${(0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENTS()}`,
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d0d028f6372c04f9$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: `${(0, $447d80c2705a4d0e$export$a3b943834c35c8a3).AGREEMENTS()}:type`,
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $d0d028f6372c04f9$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).HOME(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($de876a1da5740a6c$var$FeatureProtectedRoute, {
                            featureName: (0, $beb11aa5e2886f26$export$4a882f87980a4d7a)
                        }),
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)("span", {
                                        children: "Home"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: "/company/:id",
                        exact: true,
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c59749d2fd779010$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIOS(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($de876a1da5740a6c$var$FeatureProtectedRoute, {
                            featureName: (0, $beb11aa5e2886f26$export$6d4c76a833ca8f22)
                        }),
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5ea263d6d8caa115$export$2e2bcd8739ae039), {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: `${(0, $447d80c2705a4d0e$export$a3b943834c35c8a3).PORTFOLIOS()}:id`,
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($de876a1da5740a6c$var$FeatureProtectedRoute, {
                            featureName: (0, $beb11aa5e2886f26$export$6d4c76a833ca8f22)
                        }),
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                                children: [
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $5ea263d6d8caa115$export$2e2bcd8739ae039), {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $75b6a3dd02a2fc8f$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    portfoliosFeatureAccess || /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).MARKET_ACTIVITY(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $23d87aa47128109b$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).INSIGHTS(),
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $4a429256ba12bfbb$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$444b3ab0cb9aec40), {
                            to: (0, $447d80c2705a4d0e$export$a3b943834c35c8a3).COMPANIES()
                        })
                    }),
                    /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $9a6b443e2c413186$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsxs)($de876a1da5740a6c$var$StyledPageSection, {
                            children: [
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $65d5ae292da56411$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $bf1a00356fb3dc32$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $c01b1af6673b4a25$export$2e2bcd8739ae039), {})
        ]
    });
};
var $de876a1da5740a6c$export$2e2bcd8739ae039 = $de876a1da5740a6c$var$MainRoutes;



/**
 * Install a global `unhandledrejection` listener that captures non-Error
 * promise rejections (e.g. the cryptic "Uncaught (in promise) <minified-token>")
 * and reports them to the server so they can be diagnosed.
 *
 * The listener:
 *   - logs the rejection's `typeof`, `message`, `stack`, and a JSON repr to the
 *     console (with circular-safe replacer);
 *   - POSTs the same payload to the existing `report-error` endpoint;
 *   - never throws, never preventDefault()s — the original console error stays
 *     visible so existing alerting still fires.
 *
 * Exported as a function (not auto-installed) so it is easy to unit test and so
 * tests don't accidentally double-install it.
 *
 * @param {object} deps
 * @param {{ post: Function }} deps.axios - axios instance used to POST.
 * @param {string} deps.reportUrl - endpoint to POST diagnostics to.
 * @returns {Function} an uninstall function (mostly for tests).
 */ const $c495d3ab822def3e$var$circularReplacer = ()=>{
    const seen = new WeakSet();
    return (key, value)=>{
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) return "[Circular]";
            seen.add(value);
        }
        if (value instanceof Error) return {
            name: value.name,
            message: value.message,
            stack: value.stack
        };
        return value;
    };
};
const $c495d3ab822def3e$export$56831a8b9cb27763 = (value)=>{
    try {
        const out = JSON.stringify(value, $c495d3ab822def3e$var$circularReplacer());
        // JSON.stringify(undefined) returns undefined; fall back to String() so
        // callers always get a string back.
        if (out === undefined) return String(value);
        return out;
    } catch (_e) {
        try {
            return String(value);
        } catch (_e2) {
            return "<unstringifiable>";
        }
    }
};
const $c495d3ab822def3e$export$200c619e846540a2 = (reason)=>{
    const payload = {
        error: "Unhandled promise rejection",
        reasonType: typeof reason,
        reasonString: (()=>{
            try {
                return String(reason);
            } catch (_e) {
                return "<unstringifiable>";
            }
        })(),
        reasonJson: $c495d3ab822def3e$export$56831a8b9cb27763(reason),
        route: typeof window !== "undefined" ? window.location.href : ""
    };
    if (reason instanceof Error) {
        payload.message = reason.message;
        payload.stack = reason.stack;
        payload.name = reason.name;
    } else if (reason && typeof reason === "object") {
        payload.message = reason.message;
        payload.stack = reason.stack;
    }
    return payload;
};
const $c495d3ab822def3e$export$e4d42f9163c50938 = ({ axios: axios, reportUrl: reportUrl } = {})=>{
    if (typeof window === "undefined") return ()=>{};
    const handler = (event)=>{
        try {
            const reason = event?.reason;
            const payload = $c495d3ab822def3e$export$200c619e846540a2(reason);
            // eslint-disable-next-line no-console
            console.error("unhandledrejection", payload);
            if (axios && reportUrl) // Fire-and-forget. Swallow any error so we don't loop.
            Promise.resolve().then(()=>axios.post(reportUrl, payload)).catch(()=>{});
        } catch (_e) {
        // Never let the diagnostic logger itself throw.
        }
    };
    window.addEventListener("unhandledrejection", handler);
    return ()=>window.removeEventListener("unhandledrejection", handler);
};
var $c495d3ab822def3e$export$2e2bcd8739ae039 = $c495d3ab822def3e$export$e4d42f9163c50938;



const $e7d439f130169221$var$StyledHDContainer = (0, $e42cae22e74e223a$export$2e2bcd8739ae039).div`
  color: rgba(255, 255, 255, 0.8);
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`;
const $e7d439f130169221$var$MINUTE = 60000;
const $e7d439f130169221$var$queryClient = new (0, $1f0fe77b5c426c98$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            cacheTime: 60 * $e7d439f130169221$var$MINUTE,
            staleTime: 60 * $e7d439f130169221$var$MINUTE
        }
    }
});
// Install a global handler for unhandled promise rejections so that the cryptic
// "Uncaught (in promise) <minified-token>" errors observed in production
// (ZX-15035) leave a usable diagnostic trail in the console and on the server.
(0, $c495d3ab822def3e$export$e4d42f9163c50938)({
    axios: (0, $fd9e8486e0b9b483$export$2e2bcd8739ae039),
    reportUrl: (0, $beb11aa5e2886f26$export$30dba1e0a1cb02c9).REPORT_ERROR()
});
document.addEventListener("DOMContentLoaded", ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).render(/*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).StrictMode, {
        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $7e71e0df4024a5cb$export$45604f0cc8ae667b), {
            client: $e7d439f130169221$var$queryClient,
            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $ff1ed43a67e50aba$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $46a097389bbbbe65$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $53b8b7db1779de07$export$87091915187a1a85), {
                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $8e8dba6047d43ae4$export$3d5853f50227afa0), {
                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $dfd33cee3229493c$exports.YukaThemeProvider), {
                                theme: (0, $235b758820ece497$export$2e2bcd8739ae039),
                                children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $79e8bb15bdb007b5$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)($e7d439f130169221$var$StyledHDContainer, {
                                        children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $12833d8bb7591755$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $34ccb6660205eec8$exports.jsx)((0, $de876a1da5740a6c$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    }), document.getElementById("application"));
});


//# sourceMappingURL=frontend.35a28277.js.map
